/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 785);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(1025)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.moment = factory();
})(undefined, function () {
    'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function some(fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) {
                isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [],
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (_typeof(arguments[i]) === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function keys(obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function func() {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
                return tok.slice(1);
            }
            return tok;
        }).join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/,
        //       0 - 9
    match2 = /\d\d/,
        //      00 - 99
    match3 = /\d{3}/,
        //     000 - 999
    match4 = /\d{4}/,
        //    0000 - 9999
    match6 = /[+-]?\d{6}/,
        // -999999 - 999999
    match1to2 = /\d\d?/,
        //       0 - 99
    match3to4 = /\d\d\d\d?/,
        //     999 - 9999
    match5to6 = /\d\d\d\d\d\d?/,
        //   99999 - 999999
    match1to3 = /\d{1,3}/,
        //       0 - 999
    match1to4 = /\d{1,4}/,
        //       0 - 9999
    match1to6 = /[+-]?\d{1,6}/,
        // -999999 - 999999
    matchUnsigned = /\d+/,
        //       0 - inf
    matchSigned = /[+-]?\d+/,
        //    -inf - inf
    matchOffset = /Z|[+-]\d\d:?\d\d/gi,
        // +00:00 -00:00 +0000 -0000 or Z
    matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
        // +00 -00 +00:00 -00:00 +0000 -0000 or Z
    matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
        // 123456789 123456789.123
    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/,
        //         1-99
    match1to2HasZero = /^([1-9]\d|\d)/,
        //           0-99
    regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function func(input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if ((typeof units === 'undefined' ? 'undefined' : _typeof(units)) === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return (n % x + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function indexOf(o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months) ? this._months : this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,

        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && typeof module !== 'undefined' && module && module.exports && isLocaleNameSane(name)) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__(1084)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key + ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],

    // iso time formats and regexes
    isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || format === undefined && input === '') {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }),
        prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    });

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function now() {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,

        // matching against regexp is expensive, do it on demand
        match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if ((typeof duration === 'undefined' ? 'undefined' : _typeof(duration)) === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest = input.filter(function (item) {
                return !isNumber(item) && isString(input);
            }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),

        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
            return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
            return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    });

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (_typeof(eras[i].since)) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (_typeof(eras[i].until)) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
                return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [{
            since: '0001-01-01',
            until: +Infinity,
            offset: 1,
            name: 'Anno Domini',
            narrow: 'AD',
            abbr: 'AD'
        }, {
            since: '0000-12-31',
            until: -Infinity,
            offset: 1,
            name: 'Before Christ',
            narrow: 'BC',
            abbr: 'BC'
        }],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
        ss: 44, // a few seconds to seconds
        s: 45, // seconds to minute
        m: 45, // minutes to hour
        h: 22, // hours to day
        d: 26, // days to month/week
        w: null, // weeks to month
        M: 11 // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];

        if (thresholds.w != null) {
            a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
        }
        a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if ((typeof argWithSuffix === 'undefined' ? 'undefined' : _typeof(argWithSuffix)) === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if ((typeof argThresholds === 'undefined' ? 'undefined' : _typeof(argThresholds)) === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM' // <input type="month" />
    };

    return hooks;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SysVars = undefined;

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(221);

var _vuex2 = _interopRequireDefault(_vuex);

var _vueResource = __webpack_require__(990);

var _vueResource2 = _interopRequireDefault(_vueResource);

var _axios = __webpack_require__(9);

var _axios2 = _interopRequireDefault(_axios);

var _vueAxios = __webpack_require__(1008);

var _vueAxios2 = _interopRequireDefault(_vueAxios);

var _vueRouter = __webpack_require__(1009);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueBootstrapTypeahead = __webpack_require__(1010);

var _vueBootstrapTypeahead2 = _interopRequireDefault(_vueBootstrapTypeahead);

var _vMask = __webpack_require__(1021);

var _vMask2 = _interopRequireDefault(_vMask);

var _legacy = __webpack_require__(85);

var _legacy2 = _interopRequireDefault(_legacy);

var _App = __webpack_require__(1022);

var _App2 = _interopRequireDefault(_App);

var _vueSnotify = __webpack_require__(1081);

var _vueSnotify2 = _interopRequireDefault(_vueSnotify);

__webpack_require__(56);

__webpack_require__(1082);

__webpack_require__(255);

__webpack_require__(1083);

var _vueBootstrapDatetimepicker = __webpack_require__(257);

var _vueBootstrapDatetimepicker2 = _interopRequireDefault(_vueBootstrapDatetimepicker);

__webpack_require__(1085);

var _vueFocusLock = __webpack_require__(26);

var _vueFocusLock2 = _interopRequireDefault(_vueFocusLock);

var _vueColor = __webpack_require__(396);

var _vueOffline = __webpack_require__(116);

var _vueOffline2 = _interopRequireDefault(_vueOffline);

var _globalFunctions = __webpack_require__(1087);

var _globalFunctions2 = _interopRequireDefault(_globalFunctions);

var _store = __webpack_require__(1088);

var _mdMessage = __webpack_require__(397);

var _mdMessage2 = _interopRequireDefault(_mdMessage);

var _alert = __webpack_require__(1095);

var _alert2 = _interopRequireDefault(_alert);

var _validation = __webpack_require__(1099);

var _validation2 = _interopRequireDefault(_validation);

var _warnings = __webpack_require__(1103);

var _warnings2 = _interopRequireDefault(_warnings);

var _barList = __webpack_require__(8);

var _barList2 = _interopRequireDefault(_barList);

var _barFilter = __webpack_require__(404);

var _barFilter2 = _interopRequireDefault(_barFilter);

var _barGrid = __webpack_require__(13);

var _barGrid2 = _interopRequireDefault(_barGrid);

var _barManut = __webpack_require__(1117);

var _barManut2 = _interopRequireDefault(_barManut);

var _label = __webpack_require__(1119);

var _label2 = _interopRequireDefault(_label);

var _labelTitle = __webpack_require__(410);

var _labelTitle2 = _interopRequireDefault(_labelTitle);

var _button = __webpack_require__(164);

var _button2 = _interopRequireDefault(_button);

var _formField = __webpack_require__(117);

var _formField2 = _interopRequireDefault(_formField);

var _inputCep = __webpack_require__(1127);

var _inputCep2 = _interopRequireDefault(_inputCep);

var _inputFone = __webpack_require__(1131);

var _inputFone2 = _interopRequireDefault(_inputFone);

var _inputHora = __webpack_require__(1135);

var _inputHora2 = _interopRequireDefault(_inputHora);

var _inputEmail = __webpack_require__(1139);

var _inputEmail2 = _interopRequireDefault(_inputEmail);

var _inputEmailList = __webpack_require__(1143);

var _inputEmailList2 = _interopRequireDefault(_inputEmailList);

var _inputValue = __webpack_require__(1147);

var _inputValue2 = _interopRequireDefault(_inputValue);

var _inputCheckbox = __webpack_require__(1151);

var _inputCheckbox2 = _interopRequireDefault(_inputCheckbox);

var _inputSwitch = __webpack_require__(1153);

var _inputSwitch2 = _interopRequireDefault(_inputSwitch);

var _inputMonth = __webpack_require__(1157);

var _inputMonth2 = _interopRequireDefault(_inputMonth);

var _inputMonth3 = __webpack_require__(422);

var _inputMonth4 = _interopRequireDefault(_inputMonth3);

var _inputNumber = __webpack_require__(1164);

var _inputNumber2 = _interopRequireDefault(_inputNumber);

var _inputPart = __webpack_require__(1168);

var _inputPart2 = _interopRequireDefault(_inputPart);

var _inputItem = __webpack_require__(1193);

var _inputItem2 = _interopRequireDefault(_inputItem);

var _inputSearch = __webpack_require__(439);

var _inputSearch2 = _interopRequireDefault(_inputSearch);

var _inputDate = __webpack_require__(1200);

var _inputDate2 = _interopRequireDefault(_inputDate);

var _inputColorPicker = __webpack_require__(1204);

var _inputColorPicker2 = _interopRequireDefault(_inputColorPicker);

var _tabs = __webpack_require__(1208);

var _tabs2 = _interopRequireDefault(_tabs);

var _select = __webpack_require__(1212);

var _select2 = _interopRequireDefault(_select);

var _select2static = __webpack_require__(1218);

var _select2static2 = _interopRequireDefault(_select2static);

var _inputTypeahead = __webpack_require__(88);

var _inputTypeahead2 = _interopRequireDefault(_inputTypeahead);

var _emailForm = __webpack_require__(1225);

var _emailForm2 = _interopRequireDefault(_emailForm);

var _fonesPartShare = __webpack_require__(1229);

var _fonesPartShare2 = _interopRequireDefault(_fonesPartShare);

var _confirmAdminpass = __webpack_require__(1233);

var _confirmAdminpass2 = _interopRequireDefault(_confirmAdminpass);

var _appRecuperarForm = __webpack_require__(1237);

var _appRecuperarForm2 = _interopRequireDefault(_appRecuperarForm);

var _appRegistroForm = __webpack_require__(1241);

var _appRegistroForm2 = _interopRequireDefault(_appRegistroForm);

var _appAtivacaoForm = __webpack_require__(1246);

var _appAtivacaoForm2 = _interopRequireDefault(_appAtivacaoForm);

var _appSenhaUsuarioForm = __webpack_require__(1250);

var _appSenhaUsuarioForm2 = _interopRequireDefault(_appSenhaUsuarioForm);

var _appAssinaturaForm = __webpack_require__(1254);

var _appAssinaturaForm2 = _interopRequireDefault(_appAssinaturaForm);

var _appMinhaContaForm = __webpack_require__(456);

var _appMinhaContaForm2 = _interopRequireDefault(_appMinhaContaForm);

var _appPlanosNfe = __webpack_require__(1263);

var _appPlanosNfe2 = _interopRequireDefault(_appPlanosNfe);

var _appPlanosErp = __webpack_require__(1267);

var _appPlanosErp2 = _interopRequireDefault(_appPlanosErp);

var _appPlanoIncrementAddons = __webpack_require__(1275);

var _appPlanoIncrementAddons2 = _interopRequireDefault(_appPlanoIncrementAddons);

var _appLoginForm = __webpack_require__(1279);

var _appLoginForm2 = _interopRequireDefault(_appLoginForm);

var _dashboardForm = __webpack_require__(1283);

var _dashboardForm2 = _interopRequireDefault(_dashboardForm);

var _appCertificado = __webpack_require__(162);

var _appCertificado2 = _interopRequireDefault(_appCertificado);

var _consultaVendas = __webpack_require__(1305);

var _consultaVendas2 = _interopRequireDefault(_consultaVendas);

var _consultaCurvaCliente = __webpack_require__(1312);

var _consultaCurvaCliente2 = _interopRequireDefault(_consultaCurvaCliente);

var _consultaCarteiraClientes = __webpack_require__(1316);

var _consultaCarteiraClientes2 = _interopRequireDefault(_consultaCarteiraClientes);

var _consultaVendasPorProduto = __webpack_require__(1320);

var _consultaVendasPorProduto2 = _interopRequireDefault(_consultaVendasPorProduto);

var _consultaVendasPerformanceCarteira = __webpack_require__(1324);

var _consultaVendasPerformanceCarteira2 = _interopRequireDefault(_consultaVendasPerformanceCarteira);

var _consultaVendasPorCliente = __webpack_require__(1328);

var _consultaVendasPorCliente2 = _interopRequireDefault(_consultaVendasPorCliente);

var _consultaVendasVendedor = __webpack_require__(1332);

var _consultaVendasVendedor2 = _interopRequireDefault(_consultaVendasVendedor);

var _consultaVendasPedidosProduto = __webpack_require__(1336);

var _consultaVendasPedidosProduto2 = _interopRequireDefault(_consultaVendasPedidosProduto);

var _listagemClientes = __webpack_require__(1340);

var _listagemClientes2 = _interopRequireDefault(_listagemClientes);

var _consultaVendasPedidosFaturados = __webpack_require__(1344);

var _consultaVendasPedidosFaturados2 = _interopRequireDefault(_consultaVendasPedidosFaturados);

var _consultaVendasComissaoPorPedido = __webpack_require__(1348);

var _consultaVendasComissaoPorPedido2 = _interopRequireDefault(_consultaVendasComissaoPorPedido);

var _consultaVarejoMovimentoCaixa = __webpack_require__(1352);

var _consultaVarejoMovimentoCaixa2 = _interopRequireDefault(_consultaVarejoMovimentoCaixa);

var _consultaVarejoPendcli = __webpack_require__(484);

var _consultaVarejoPendcli2 = _interopRequireDefault(_consultaVarejoPendcli);

var _metavendasForm = __webpack_require__(1363);

var _metavendasForm2 = _interopRequireDefault(_metavendasForm);

var _consultaRecebimentosPedido = __webpack_require__(1367);

var _consultaRecebimentosPedido2 = _interopRequireDefault(_consultaRecebimentosPedido);

var _consultaEstoqueProduto = __webpack_require__(1371);

var _consultaEstoqueProduto2 = _interopRequireDefault(_consultaEstoqueProduto);

var _consultaItemsEstoque = __webpack_require__(494);

var _consultaItemsEstoque2 = _interopRequireDefault(_consultaItemsEstoque);

var _consultaNfse = __webpack_require__(1387);

var _consultaNfse2 = _interopRequireDefault(_consultaNfse);

var _consultaDistribuicaoCfop = __webpack_require__(1391);

var _consultaDistribuicaoCfop2 = _interopRequireDefault(_consultaDistribuicaoCfop);

var _customerImportaForm = __webpack_require__(1395);

var _customerImportaForm2 = _interopRequireDefault(_customerImportaForm);

var _customerList = __webpack_require__(1399);

var _customerList2 = _interopRequireDefault(_customerList);

var _customerForm = __webpack_require__(27);

var _customerForm2 = _interopRequireDefault(_customerForm);

var _itemList = __webpack_require__(504);

var _itemList2 = _interopRequireDefault(_itemList);

var _itemForm = __webpack_require__(89);

var _itemForm2 = _interopRequireDefault(_itemForm);

var _itemImportaForm = __webpack_require__(1433);

var _itemImportaForm2 = _interopRequireDefault(_itemImportaForm);

var _itemImportaEstoqueForm = __webpack_require__(1437);

var _itemImportaEstoqueForm2 = _interopRequireDefault(_itemImportaEstoqueForm);

var _natesList = __webpack_require__(516);

var _natesList2 = _interopRequireDefault(_natesList);

var _estadoList = __webpack_require__(167);

var _estadoList2 = _interopRequireDefault(_estadoList);

var _ivaclassList = __webpack_require__(1454);

var _ivaclassList2 = _interopRequireDefault(_ivaclassList);

var _ivancmList = __webpack_require__(1458);

var _ivancmList2 = _interopRequireDefault(_ivancmList);

var _unimedList = __webpack_require__(168);

var _unimedList2 = _interopRequireDefault(_unimedList);

var _ncmList = __webpack_require__(1469);

var _ncmList2 = _interopRequireDefault(_ncmList);

var _gradeList = __webpack_require__(527);

var _gradeList2 = _interopRequireDefault(_gradeList);

var _gruestList = __webpack_require__(530);

var _gruestList2 = _interopRequireDefault(_gruestList);

var _grucliList = __webpack_require__(165);

var _grucliList2 = _interopRequireDefault(_grucliList);

var _gruforList = __webpack_require__(502);

var _gruforList2 = _interopRequireDefault(_gruforList);

var _depoList = __webpack_require__(532);

var _depoList2 = _interopRequireDefault(_depoList);

var _mennfList = __webpack_require__(1490);

var _mennfList2 = _interopRequireDefault(_mennfList);

var _vendList = __webpack_require__(536);

var _vendList2 = _interopRequireDefault(_vendList);

var _filialList = __webpack_require__(169);

var _filialList2 = _interopRequireDefault(_filialList);

var _filialForm = __webpack_require__(87);

var _filialForm2 = _interopRequireDefault(_filialForm);

var _configGuia = __webpack_require__(244);

var _configGuia2 = _interopRequireDefault(_configGuia);

var _pedidoList = __webpack_require__(1504);

var _pedidoList2 = _interopRequireDefault(_pedidoList);

var _pedidoForm = __webpack_require__(541);

var _pedidoForm2 = _interopRequireDefault(_pedidoForm);

var _compraList = __webpack_require__(1548);

var _compraList2 = _interopRequireDefault(_compraList);

var _compraForm = __webpack_require__(558);

var _compraForm2 = _interopRequireDefault(_compraForm);

var _regrafcpList = __webpack_require__(172);

var _regrafcpList2 = _interopRequireDefault(_regrafcpList);

var _regrastList = __webpack_require__(1572);

var _regrastList2 = _interopRequireDefault(_regrastList);

var _regraimpList = __webpack_require__(173);

var _regraimpList2 = _interopRequireDefault(_regraimpList);

var _usuarioList = __webpack_require__(174);

var _usuarioList2 = _interopRequireDefault(_usuarioList);

var _nfList = __webpack_require__(1598);

var _nfList2 = _interopRequireDefault(_nfList);

var _nfsaidaForm = __webpack_require__(94);

var _nfsaidaForm2 = _interopRequireDefault(_nfsaidaForm);

var _nfentradaForm = __webpack_require__(590);

var _nfentradaForm2 = _interopRequireDefault(_nfentradaForm);

var _serienfList = __webpack_require__(1643);

var _serienfList2 = _interopRequireDefault(_serienfList);

var _contadorList = __webpack_require__(1650);

var _contadorList2 = _interopRequireDefault(_contadorList);

var _ramoatList = __webpack_require__(597);

var _ramoatList2 = _interopRequireDefault(_ramoatList);

var _natfinList = __webpack_require__(1661);

var _natfinList2 = _interopRequireDefault(_natfinList);

var _inutList = __webpack_require__(1665);

var _inutList2 = _interopRequireDefault(_inutList);

var _importaIbpt = __webpack_require__(1673);

var _importaIbpt2 = _interopRequireDefault(_importaIbpt);

var _importaXml = __webpack_require__(1677);

var _importaXml2 = _interopRequireDefault(_importaXml);

var _importaXmlhist = __webpack_require__(1681);

var _importaXmlhist2 = _interopRequireDefault(_importaXmlhist);

var _nfimportList = __webpack_require__(1685);

var _nfimportList2 = _interopRequireDefault(_nfimportList);

var _duimpList = __webpack_require__(1693);

var _duimpList2 = _interopRequireDefault(_duimpList);

var _duimpForm = __webpack_require__(612);

var _duimpForm2 = _interopRequireDefault(_duimpForm);

var _receberList = __webpack_require__(1698);

var _receberList2 = _interopRequireDefault(_receberList);

var _financeiroList = __webpack_require__(1718);

var _financeiroList2 = _interopRequireDefault(_financeiroList);

var _conciliacaoForm = __webpack_require__(1746);

var _conciliacaoForm2 = _interopRequireDefault(_conciliacaoForm);

var _pedidoImpressao = __webpack_require__(92);

var _pedidoImpressao2 = _interopRequireDefault(_pedidoImpressao);

var _pedidoCompraImpressao = __webpack_require__(171);

var _pedidoCompraImpressao2 = _interopRequireDefault(_pedidoCompraImpressao);

var _financeirologList = __webpack_require__(1750);

var _financeirologList2 = _interopRequireDefault(_financeirologList);

var _ctaList = __webpack_require__(1754);

var _ctaList2 = _interopRequireDefault(_ctaList);

var _fpagList = __webpack_require__(632);

var _fpagList2 = _interopRequireDefault(_fpagList);

var _vcaixaList = __webpack_require__(1769);

var _vcaixaList2 = _interopRequireDefault(_vcaixaList);

var _printForm = __webpack_require__(1777);

var _printForm2 = _interopRequireDefault(_printForm);

var _tabpreList = __webpack_require__(639);

var _tabpreList2 = _interopRequireDefault(_tabpreList);

var _destaqList = __webpack_require__(644);

var _destaqList2 = _interopRequireDefault(_destaqList);

var _tabdesList = __webpack_require__(647);

var _tabdesList2 = _interopRequireDefault(_tabdesList);

var _configMenu = __webpack_require__(1814);

var _configMenu2 = _interopRequireDefault(_configMenu);

var _nfseForm = __webpack_require__(587);

var _nfseForm2 = _interopRequireDefault(_nfseForm);

var _cobranca = __webpack_require__(1852);

var _cobranca2 = _interopRequireDefault(_cobranca);

var _cobrancaConfig = __webpack_require__(1856);

var _cobrancaConfig2 = _interopRequireDefault(_cobrancaConfig);

var _agendaList = __webpack_require__(1860);

var _agendaList2 = _interopRequireDefault(_agendaList);

var _fvClienteList = __webpack_require__(1867);

var _fvClienteList2 = _interopRequireDefault(_fvClienteList);

var _customerPainelForm = __webpack_require__(436);

var _customerPainelForm2 = _interopRequireDefault(_customerPainelForm);

var _fvPedidoList = __webpack_require__(1871);

var _fvPedidoList2 = _interopRequireDefault(_fvPedidoList);

var _fvPedidoForm = __webpack_require__(123);

var _fvPedidoForm2 = _interopRequireDefault(_fvPedidoForm);

var _fvProdutosMenu = __webpack_require__(1883);

var _fvProdutosMenu2 = _interopRequireDefault(_fvProdutosMenu);

var _fvConfigMenu = __webpack_require__(1893);

var _fvConfigMenu2 = _interopRequireDefault(_fvConfigMenu);

var _fvPedidoFormPag = __webpack_require__(1956);

var _fvPedidoFormPag2 = _interopRequireDefault(_fvPedidoFormPag);

var _configListLoja = __webpack_require__(680);

var _configListLoja2 = _interopRequireDefault(_configListLoja);

var _guiaLoja = __webpack_require__(1960);

var _guiaLoja2 = _interopRequireDefault(_guiaLoja);

var _crmPainelForm = __webpack_require__(1964);

var _crmPainelForm2 = _interopRequireDefault(_crmPainelForm);

var _crmNegocioForm = __webpack_require__(722);

var _crmNegocioForm2 = _interopRequireDefault(_crmNegocioForm);

var _crmLeadList = __webpack_require__(2052);

var _crmLeadList2 = _interopRequireDefault(_crmLeadList);

var _crmPessoaList = __webpack_require__(2063);

var _crmPessoaList2 = _interopRequireDefault(_crmPessoaList);

var _crmPessoaForm = __webpack_require__(178);

var _crmPessoaForm2 = _interopRequireDefault(_crmPessoaForm);

var _crmOrgForm = __webpack_require__(182);

var _crmOrgForm2 = _interopRequireDefault(_crmOrgForm);

var _crmOrgList = __webpack_require__(2070);

var _crmOrgList2 = _interopRequireDefault(_crmOrgList);

var _crmEmailList = __webpack_require__(2074);

var _crmEmailList2 = _interopRequireDefault(_crmEmailList);

var _crmConfig = __webpack_require__(2078);

var _crmConfig2 = _interopRequireDefault(_crmConfig);

var _appMercadolivreCode = __webpack_require__(2106);

var _appMercadolivreCode2 = _interopRequireDefault(_appMercadolivreCode);

var _catmktList = __webpack_require__(663);

var _catmktList2 = _interopRequireDefault(_catmktList);

var _catmktForm = __webpack_require__(176);

var _catmktForm2 = _interopRequireDefault(_catmktForm);

var _manifestoList = __webpack_require__(2110);

var _manifestoList2 = _interopRequireDefault(_manifestoList);

var _estoqueAjusteTransferenciaForm = __webpack_require__(490);

var _estoqueAjusteTransferenciaForm2 = _interopRequireDefault(_estoqueAjusteTransferenciaForm);

var _itemAjusteEstoque = __webpack_require__(675);

var _itemAjusteEstoque2 = _interopRequireDefault(_itemAjusteEstoque);

var _itemPrecosList = __webpack_require__(677);

var _itemPrecosList2 = _interopRequireDefault(_itemPrecosList);

var _consultaMovimentoEstoque = __webpack_require__(2122);

var _consultaMovimentoEstoque2 = _interopRequireDefault(_consultaMovimentoEstoque);

var _consultaResumoMovimentoEstoque = __webpack_require__(2126);

var _consultaResumoMovimentoEstoque2 = _interopRequireDefault(_consultaResumoMovimentoEstoque);

var _consultaSaldoEstoque = __webpack_require__(2130);

var _consultaSaldoEstoque2 = _interopRequireDefault(_consultaSaldoEstoque);

var _itemEntradasSaidas = __webpack_require__(2134);

var _itemEntradasSaidas2 = _interopRequireDefault(_itemEntradasSaidas);

var _varejoList = __webpack_require__(2138);

var _varejoList2 = _interopRequireDefault(_varejoList);

var _varejoForm = __webpack_require__(2148);

var _varejoForm2 = _interopRequireDefault(_varejoForm);

var _varejoControlecaixaList = __webpack_require__(2224);

var _varejoControlecaixaList2 = _interopRequireDefault(_varejoControlecaixaList);

var _varejoRecebiveisList = __webpack_require__(2232);

var _varejoRecebiveisList2 = _interopRequireDefault(_varejoRecebiveisList);

var _varejoDevolucaoList = __webpack_require__(2236);

var _varejoDevolucaoList2 = _interopRequireDefault(_varejoDevolucaoList);

var _consultaFluxoCaixa = __webpack_require__(2240);

var _consultaFluxoCaixa2 = _interopRequireDefault(_consultaFluxoCaixa);

var _consultaDre = __webpack_require__(2244);

var _consultaDre2 = _interopRequireDefault(_consultaDre);

var _consultaPosicaoFinanceiro = __webpack_require__(2248);

var _consultaPosicaoFinanceiro2 = _interopRequireDefault(_consultaPosicaoFinanceiro);

var _consultaFinanceiroBaixas = __webpack_require__(2252);

var _consultaFinanceiroBaixas2 = _interopRequireDefault(_consultaFinanceiroBaixas);

var _contadorEmpresas = __webpack_require__(2256);

var _contadorEmpresas2 = _interopRequireDefault(_contadorEmpresas);

var _vueWysiwyg = __webpack_require__(2262);

var _vueWysiwyg2 = _interopRequireDefault(_vueWysiwyg);

__webpack_require__(2263);

__webpack_require__(2265);

__webpack_require__(2267);

__webpack_require__(2269);

var _veeValidate = __webpack_require__(2271);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _cpfValidator = __webpack_require__(2272);

var _cpfValidator2 = _interopRequireDefault(_cpfValidator);

var _cnpjValidator = __webpack_require__(2273);

var _cnpjValidator2 = _interopRequireDefault(_cnpjValidator);

var _zeroValidator = __webpack_require__(2275);

var _zeroValidator2 = _interopRequireDefault(_zeroValidator);

var _dictionaryPT = __webpack_require__(2276);

var _dictionaryPT2 = _interopRequireDefault(_dictionaryPT);

var _utils = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//VAREJO


//CRM


//LOJA


//APP FORCA VENDAS
window.jQuery = __webpack_require__(56); // << import jquery global


//FINANCEIRO


//ESTOQUE

// import CrmOrganizacaoForm from './forms-crm/crm-organizacao-form'
// import CrmOrganizacaoList from './forms-crm/crm-organizacao-list'

// import FvClientesMenu from './forms-fv/fv-clientes-menu'

//import notificationOnOffline from './components/notification-online-offline'

__webpack_require__(255); // << import js bootstrap

//Vue.use(VueResource)
_vue2.default.use(_vueAxios2.default, _axios2.default);

_vue2.default.use(_vueBootstrapDatetimepicker2.default);

//BLOQUEIO DO FOCUS EM FORM MODAL
_vue2.default.use(_vueFocusLock2.default);

_vue2.default.use(_vueColor.Chrome);
_vue2.default.use(_vMask2.default);

_vue2.default.use(_vueOffline2.default, { storage: true, mixin: false });

// Charts Google
_vue2.default.use(_legacy2.default);

//EXCEL
// import JsonExcel from 'vue-json-excel'
// Vue.component('downloadExcel', JsonExcel)

//EDITOR

_vue2.default.use(_vueWysiwyg2.default, {});
__webpack_require__(2277);

//TOAST NOTIFY
var options = {
  toast: {
    position: _vueSnotify.SnotifyPosition.rightTop,
    timeout: 5000,
    showProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    oneAtTime: true,
    preventDuplicates: true
  }
};
_vue2.default.use(_vueSnotify2.default, options);
// import 'vue-snotify/styles/simple.css'
//import 'vue-snotify/styles/dark.css'

//CSS

//https://github.com/select2/select2-bootstrap-theme


//LIBS
//import '../node_modules/bootstrap/dist/css/bootstrap.css';
//import '../node_modules/select2/dist/css/select2.min.css';

//require('bootstrap'); // << import js bootstrap
//import 'bootstrap/dist/css/bootstrap.css' // << import CSS
//require('!style-loader!css-loader!font-awesome/css/font-awesome.css');

//VALIDATOR


//FILTERS


_vue2.default.filter("formatValue", function (value, decimals, zeros) {
  if (!value) {
    if (zeros) return (0, _utils.formatValue)(0, decimals);else return "--";
  } else return (0, _utils.formatValue)(value, decimals);
});

_vue2.default.filter("formatData", function (value) {
  return (0, _utils.formatDate)(value);
});

_vue2.default.filter("formatDataHora", function (value) {
  return (0, _utils.formatDataHora)(value);
});

_vue2.default.filter("formatFone", function (value) {
  return (0, _utils.formatFone)(value);
});

_vue2.default.filter("getTextOption", function (value, options) {
  return (0, _utils.getText)(value, options);
});

_vue2.default.filter("formatCNPJCPF", function (value) {
  return (0, _utils.formatCNPJCPF)(value);
});

_vue2.default.filter("formatDataExtenso", function (value) {
  return (0, _utils.formatDataExtenso)(value);
});

_vue2.default.filter("formatMesExtenso", function (value) {
  return (0, _utils.formatMesExtenso)(value);
});

_vue2.default.filter("formatDataHoraExtenso", function (value) {
  return (0, _utils.formatDataHoraExtenso)(value);
});

//ROUTER
_vue2.default.use(_vueRouter2.default);
var routes = [
//rotas publicas
{
  path: "/imprimir-pedido",
  component: _pedidoImpressao2.default,
  name: "imprimir-pedido"
}, {
  path: "/imprimir-compra",
  component: _pedidoCompraImpressao2.default,
  name: "imprimir-compra"
}, { path: "/planos/nfe", component: _appPlanosNfe2.default, name: "planosnfe" }, { path: "/planos/erp", component: _appPlanosErp2.default, name: "planoserp" }, {
  path: "/planos/complementos",
  component: _appPlanoIncrementAddons2.default,
  name: "planosincremento"
}, { path: "/recuperar", component: _appRecuperarForm2.default, name: "recuperar" },
// { path: '/registro', component: RegistroForm, name: 'registro' },
{
  path: "/registropedidos",
  component: _appRegistroForm2.default,
  name: "registropedidos"
}, { path: "/registroloja", component: _appRegistroForm2.default, name: "registroloja" }, { path: "/registronfe", component: _appRegistroForm2.default, name: "registronfe" }, { path: "/ativar", component: _appAtivacaoForm2.default, name: "ativar" }, { path: "/senha", component: _appSenhaUsuarioForm2.default, name: "senha" }, { path: "/login", component: _appLoginForm2.default, name: "login" }, { path: "/assinar", component: _appAssinaturaForm2.default, name: "assinar" }, { path: "/minhaconta", component: _appMinhaContaForm2.default, name: "minhaconta" }, { path: "/cadastro", component: _appAssinaturaForm2.default, name: "cadastro" },

//rotas privadas

{ path: '/contador/empresas', component: _contadorEmpresas2.default, name: 'contador_empresas' }, { path: '/', component: _dashboardForm2.default, name: 'home' }, { path: '/guiapedidos', component: _dashboardForm2.default, name: 'guiapedidos' }, { path: '/painelpedidos', component: _dashboardForm2.default, name: 'painelpedidos' }, { path: '/guianfe', component: _dashboardForm2.default, name: 'guianfe' }, { path: '/painelnfe', component: _dashboardForm2.default, name: 'painelnfe' }, { path: '/painelservico', component: _dashboardForm2.default, name: 'painelservico' }, { path: '/painelvarejo', component: _dashboardForm2.default, name: 'painelvarejo' }, { path: '/app-certificado', redirect: '/filiallist/certificado' }, { path: '/certificado', redirect: '/filiallist/certificado' }, { path: '/certificado/:param', component: _appCertificado2.default, name: 'certificado' }, { path: '/vendlist', component: _vendList2.default, name: 'vendlist' }, { path: '/part/:id', component: _customerForm2.default, name: 'part' }, { path: '/partlist', component: _customerList2.default, name: 'partlist' }, { path: '/mennflist', component: _mennfList2.default, name: 'mennflist' }, { path: '/gruclilist', component: _grucliList2.default, name: 'gruclilist' }, { path: '/gruforlist', component: _gruforList2.default, name: 'gruforlist' }, { path: '/ramoatlist', component: _ramoatList2.default, name: 'ramoatlist' }, { path: '/natfinlist', component: _natfinList2.default, name: 'natfinlist' }, { path: '/importa/produtos', component: _itemImportaForm2.default, name: 'importaprodutos' }, { path: '/importa/clientes', component: _customerImportaForm2.default, name: 'importaclientes' }, { path: '/importa/estoque', component: _itemImportaEstoqueForm2.default, name: 'importaestoqueprodutos' }, { path: '/estoque/saldo', component: _itemAjusteEstoque2.default, name: 'estoqueajuste' }, { path: '/estoque/saldoentradasaida', component: _itemEntradasSaidas2.default, name: 'estoquesaldo' }, { path: '/itemlist', component: _itemList2.default, name: 'itemlist' }, { path: '/item/:id', component: _itemForm2.default, name: 'item' }, { path: '/gradelist', component: _gradeList2.default, name: 'gradelist' }, { path: '/gruestlist', component: _gruestList2.default, name: 'gruestlist' }, { path: '/depolist', component: _depoList2.default, name: 'depolist' }, { path: '/destaqlist', component: _destaqList2.default, name: 'destaqlist' }, { path: '/tabdeslist', component: _tabdesList2.default, name: 'tabdeslist' }, { path: '/configuracoes', component: _configMenu2.default, name: 'configmenu' }, { path: '/empresa', component: _filialForm2.default, name: 'empresa' }, { path: '/guiaempresa', component: _configGuia2.default, name: 'guiaempresa' }, { path: '/guiaempresa/:param', component: _configGuia2.default, name: 'guiaempresa' }, { path: '/filiallist', component: _filialList2.default, name: 'filiallist' }, { path: '/filiallist/:operacao', component: _filialList2.default, name: 'filiallist' }, { path: '/estadolist', component: _estadoList2.default, name: 'estadolist' }, { path: '/ivaclasslist', component: _ivaclassList2.default, name: 'ivaclasslist' }, { path: '/ivancmlist', component: _ivancmList2.default, name: 'ivancmlist' }, { path: '/contadorlist', component: _contadorList2.default, name: 'contadorlist' }, { path: '/usuariolist', component: _usuarioList2.default, name: 'usuariolist' }, { path: '/unimedlist', component: _unimedList2.default, name: 'unimedlist' }, { path: '/ncmlist', component: _ncmList2.default, name: 'ncmlist' }, { path: '/nateslist', component: _natesList2.default, name: 'nateslist' }, { path: '/serienflist', component: _serienfList2.default, name: 'serienflist' }, { path: '/importaxml', component: _importaXml2.default, name: 'importaxml' }, { path: '/importaibpt', component: _importaIbpt2.default, name: 'importaibpt' }, { path: '/importaxmlhist', component: _importaXmlhist2.default, name: 'importaxmlhist' }, { path: '/nfimportlist', component: _nfimportList2.default, name: 'nfimportlist' }, { path: '/duimplist', component: _duimpList2.default, name: 'duimplist' }, { path: '/regraimplist', component: _regraimpList2.default, name: 'regraimplist' }, { path: '/regrastlist', component: _regrastList2.default, name: 'regrastlist' }, { path: '/regrafcplist', component: _regrafcpList2.default, name: 'regrafcplist' }, { path: '/nflist/:operacao', component: _nfList2.default, name: 'nflist' }, { path: '/inutlist', component: _inutList2.default, name: 'inutlist' }, { path: '/nf/:id', component: _nfsaidaForm2.default, name: 'nfsaida' }, { path: '/nfentrada/:id', component: _nfentradaForm2.default, name: 'nfentrada' }, { path: '/pedidolist', component: _pedidoList2.default, name: 'pedidolist' }, { path: '/pedido/:novo', component: _pedidoForm2.default, name: 'pedido' }, { path: '/compralist', component: _compraList2.default, name: 'compralist' }, { path: '/compra/:novo', component: _compraForm2.default, name: 'compra' }, { path: '/varejo', component: _varejoForm2.default, name: 'varejoform' }, { path: '/varejolist', component: _varejoList2.default, name: 'varejolist' }, { path: '/varejolist/:tipo', component: _varejoList2.default, name: 'varejolist' }, { path: '/printform', component: _printForm2.default, name: 'PrintForm' }, { path: '/tabpre', component: _tabpreList2.default, name: 'tabprelist' }, { path: '/nfse/:id', component: _nfseForm2.default, name: 'nfseform' }, { path: '/cta', component: _ctaList2.default, name: 'ctalist' }, { path: '/fpag', component: _fpagList2.default, name: 'fpaglist' }, { path: '/caixas', component: _vcaixaList2.default, name: 'vcaixalist' }, { path: '/financeiro', component: _financeiroList2.default, name: 'financeirolist' }, { path: '/conciliacao', component: _conciliacaoForm2.default, name: 'conciliacao-form' },
// { path: '/financeirolog', component: FinanceirologList, name: 'financeirologlist' },
{ path: '/cnab', component: _receberList2.default, name: 'receberlist' }, { path: '/banking', component: _cobranca2.default, name: 'cobbanking' }, { path: '/cobranca-config', component: _cobrancaConfig2.default, name: 'cobrancaconfig' }, { path: "/catmkt", component: _catmktList2.default, name: "catmktlist" }, { path: "/manifesto", component: _manifestoList2.default, name: "manifestolist" },

// APP FORCA DE VENDAS
{ path: "/fv/clientes", component: _fvClienteList2.default, name: "fvclientelist" }, {
  path: "/fv/clientes/painel/:id",
  component: _customerPainelForm2.default,
  name: "clientepainel"
}, { path: "/fv/pedidos", component: _fvPedidoList2.default, name: "fvpedidolist" }, {
  path: "/fv/pedidos/:id/:codpart",
  component: _fvPedidoForm2.default,
  name: "fvpedidoform"
}, { path: "/fv/agenda", component: _agendaList2.default, name: "fvagendalist" }, { path: "/fv/produtos", component: _fvProdutosMenu2.default, name: "fvprodutosmenu" }, { path: "/configuracoes", component: _fvConfigMenu2.default, name: "fvconfigmenu" },
//{ path: '/fv/clientes', component: FvClientesMenu, name: 'fvclientesmenu' },
{
  path: "/fv/pedidocheckout/:id/:idempresa",
  component: _fvPedidoFormPag2.default,
  name: "fvpedidopagform"
},

// LOJA
{ path: "/loja", component: _configListLoja2.default, name: "loja" }, { path: "/guialoja", component: _guiaLoja2.default, name: "guialoja" },

// CRM
{ path: "/crm/painel", component: _crmPainelForm2.default, name: "crmpainelform" }, { path: "/crm/lead/list", component: _crmLeadList2.default, name: "crmleadlist" }, { path: "/crm/pessoa/list", component: _crmPessoaList2.default, name: "crmpessoalist" }, { path: "/crm/pessoa/:id", component: _crmPessoaForm2.default, name: "crmpessoaform" }, {
  path: "/crm/negocio/:codnegocio",
  component: _crmNegocioForm2.default,
  name: "crmnegocioform"
}, {
  path: "/crm/negocio/:codnegocio/orcamento/:id",
  component: _fvPedidoForm2.default,
  name: "fvpedidoform"
}, { path: "/crm/organizacao/list", component: _crmOrgList2.default, name: "crmorglist" }, { path: "/crm/organizacao/:id", component: _crmOrgForm2.default, name: "crmorgform" }, { path: "/crm/email/list", component: _crmEmailList2.default, name: "crmemaillist" }, { path: "/crm/config", component: _crmConfig2.default, name: "crmconfig" },
// { path: '/crm/organizacao/list', component: CrmOrganizacaoList, name: 'crmorganizacaolist' },
// { path: '/crm/organizacao/:id', component: CrmOrganizacaoForm, name: 'crmorganizacaoform' },

//mercado livre
{
  path: "/mercadolivre/code",
  component: _appMercadolivreCode2.default,
  name: "mercadolivreCode"
},

//somente aplicativo pedidos
{
  path: "/estoque/saldo",
  component: _itemAjusteEstoque2.default,
  name: "estoqueajuste"
},

//somente aplicativo NFE
{
  path: "/estoque/saldoentradasaida",
  component: _itemPrecosList2.default,
  name: "estoquesaldo"
},

//estoque
{
  path: "/estoque/ajuste/novo/:item",
  component: _estoqueAjusteTransferenciaForm2.default,
  name: "estoqueajusteform"
}, {
  path: "/consultas/entrada-e-saida",
  component: _consultaMovimentoEstoque2.default,
  name: "movimentoestoque"
}, {
  path: "/consultas/resumo-entrada-e-saida",
  component: _consultaResumoMovimentoEstoque2.default,
  name: "resumomovimentoestoque"
}, {
  path: "/consultas/estoque-saldo",
  component: _consultaSaldoEstoque2.default,
  name: "saldoestoque"
},
//consultas estoque
{
  path: "/consultas/estoque-produto",
  component: _consultaEstoqueProduto2.default,
  name: "consultaestoqueproduto"
}, {
  path: "/consultas/items-estoque",
  component: _consultaItemsEstoque2.default,
  name: "consultaitemsestoque"
},

//consultas vendas
{
  path: "/consultas/vendas",
  component: _consultaVendas2.default,
  name: "consultavendas"
}, {
  path: "/consultas/curvacliente",
  component: _consultaCurvaCliente2.default,
  name: "consultacurvacliente"
}, {
  path: "/consultas/carteiraclientes",
  component: _consultaCarteiraClientes2.default,
  name: "consultacarteiraclientes"
}, {
  path: "/consultas/vendas-produtos",
  component: _consultaVendasPorProduto2.default,
  name: "consultavendasprodutos"
}, {
  path: "/consultas/vendas-performance-carteira",
  component: _consultaVendasPerformanceCarteira2.default,
  name: "consultavendasperformance"
}, {
  path: "/consultas/vendas-por-cliente",
  component: _consultaVendasPorCliente2.default,
  name: "consultavendasclientes"
}, {
  path: "/consultas/vendas-vendedor",
  component: _consultaVendasVendedor2.default,
  name: "consultavendasvendedor"
}, {
  path: "/consultas/vendas-pedidos-produto",
  component: _consultaVendasPedidosProduto2.default,
  name: "consultapedidosproduto"
}, {
  path: "/consultas/lista-clientes",
  component: _listagemClientes2.default,
  name: "consultalistaclientes"
}, { path: "/metas", component: _metavendasForm2.default, name: "metavendasform" }, {
  path: "/consultas/vendas-pedidos-faturados",
  component: _consultaVendasPedidosFaturados2.default,
  name: "consultapedidosfaturados"
}, {
  path: "/consultas/vendas-pedidos-comissao-por-pedido",
  component: _consultaVendasComissaoPorPedido2.default,
  name: "consultapedidoscomissao"
}, {
  path: "/consultas/varejo-movimento-caixa",
  component: _consultaVarejoMovimentoCaixa2.default,
  name: "ConsultaVarejoMovimentoCaixa"
}, {
  path: "/consultas/vendas-pedido-recebimentos",
  component: _consultaRecebimentosPedido2.default,
  name: "consultarecebimentospedido"
}, {
  path: "/consultas/varejo-pendencia-cliente",
  component: _consultaVarejoPendcli2.default,
  name: "consultavarejopendenciacliente"
}, { path: "/consultas/nfse", component: _consultaNfse2.default, name: "consultanfse" }, { path: "/consultas/distribuicaocfop", component: _consultaDistribuicaoCfop2.default, name: "consultadistribuicaocfop" }, { path: "/consultas/faturamento-cfop", component: _consultaDistribuicaoCfop2.default, name: "consultafaturamentocfop" },

//varejo
{
  path: "/varejo/controlecaixa",
  component: _varejoControlecaixaList2.default,
  name: "controlecaixa"
}, {
  path: "/varejo/controlecaixa/:id",
  component: _varejoControlecaixaList2.default,
  name: "controlecaixa"
}, {
  path: "/varejo/recebiveis",
  component: _varejoRecebiveisList2.default,
  name: "VarejoRecebiveisList"
}, {
  path: "/varejo/devolucaolist",
  component: _varejoDevolucaoList2.default,
  name: "VarejoDevolucaoList"
}, { path: "/varejo/:novo", component: _varejoForm2.default, name: "varejoform" },

//financeiro
{
  path: "/financeiro/fluxodecaixa",
  component: _consultaFluxoCaixa2.default,
  name: "ConsultaFluxoCaixa"
}, { path: "/financeiro/dre", component: _consultaDre2.default, name: "ConsultaDre" }, {
  path: "/financeiro/posicaofinanceiro",
  component: _consultaPosicaoFinanceiro2.default,
  name: "ConsultaPosicaoFinanceiro"
}, {
  path: "/financeiro/financeirobaixas",
  component: _consultaFinanceiroBaixas2.default,
  name: "ConsultaFinanceiroBaixas"
}];

var SysVars = exports.SysVars = new _vue2.default({
  //https://forum.vuejs.org/t/how-set-global-state-available-to-all-components/5947/2
  data: {
    crudI: "ins",
    crudU: "upd",
    crudD: "del",
    crudC: "can",
    crudInsert: "ins",
    crudUpdate: "upd",
    crudDelete: "del",
    crudCancel: "can",
    crudView: "view",
    // appPlanoContratado: '',
    appCrm: false,
    appForcaVendas: false,
    appLoja: false,
    appNFe: false,
    appVarejo: false,
    appERP: false,
    ambienteHomologacaoNFe: false,
    usuarioComum: false,
    usuarioAdministrador: false,
    usuarioForcaVendas: false, //tipo definido no cadastro de usuario
    usuarioVarejoPDV: false, //tipo definido no cadastro de usuario
    endereco: {},
    usaIntegracao: false,

    //CONTADOR DE EMAILS E AGENDA
    countEmail: null,
    countAgenda: null,

    //focus control - variavel utilizada para controle do enter nos formularios
    //sFocusControl: 'input:text, .select2-selection, select',
    //EXEMPLO QUERYSELECTOR: jQuery(this.$el).index('input:text:not([disabled],*[tabindex=-1]), .select2-selection:not([disabled],*[tabindex=-1]), select:not([disabled],*[tabindex=-1])')
    sFocusControl: "input:text:not([disabled]), input:password:not([disabled]), input:checkbox:not([disabled]), :radio:not([disabled]), .select2-selection:not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], area[href], button:not([disabled])",

    //quando usuario estiver logado
    appLogged: false,

    //quando expirou acesso trial
    appEndTrial: false,
    appTrial: false,
    appDataExpiracao: null,
    appAvisoRenovacao: null,
    appBlocked: false,
    urlBlocked: "",
    forceUrl: "",
    appFree: false,

    //loading
    appLoading: false,

    //controle modal para erros (this.$appError)
    appError: false,

    //controle para erros de conexao com servidor (this.$serverError)
    serverError: false,
    serverErrorStatus: "",
    serverErrorText: "",

    //controle de mensagens toast
    toastSuccess: "",
    toastError: "",
    toastWarning: "",

    //controle modal de mensagens e perguntas
    kindMessage: "", //danger, success, error, warning
    appCodeMessage: "",
    appMessage: "",
    appTitleMessage: "",
    appHelpeMessage: "",
    appShowMessage: false,

    //limite de plano
    limiteUsuariosAlcancado: false,
    limitePlanoMensagem: null,
    showLimitePlano: false,

    plano: null,

    guia: false,
    help: false,

    primeiroAcesso: true
  }
});

//VALIDATOR
_veeValidate2.default.Validator.extend("cpf", _cpfValidator2.default);
_veeValidate2.default.Validator.extend("cnpj", _cnpjValidator2.default);
_veeValidate2.default.Validator.extend("valida-zero", _zeroValidator2.default);
_vue2.default.use(_veeValidate2.default, { locale: "pt", dictionary: _dictionaryPT2.default });
// Vue.use(VeeValidate, { locale: 'pt', dictionary: Dictionary, events: 'blur' })
// Vue.use(VeeValidate, { locale: 'pt', dictionary: Dictionary, delay: 20 })
// VeeValidate.setMode('lazy')

//LIBS INTERNAS
_vue2.default.use(_globalFunctions2.default);

//COMPONENTES
_vue2.default.component("alert", _alert2.default);
_vue2.default.component("validation", _validation2.default);
_vue2.default.component("warnings", _warnings2.default);
_vue2.default.component("md-message", _mdMessage2.default);
_vue2.default.component("bar-manut", _barManut2.default);
_vue2.default.component("bar-list", _barList2.default);
_vue2.default.component("bar-grid", _barGrid2.default);
_vue2.default.component("v-label", _label2.default);
_vue2.default.component("label-title", _labelTitle2.default);
_vue2.default.component("v-button", _button2.default);
_vue2.default.component("form-field", _formField2.default);
_vue2.default.component("input-cep", _inputCep2.default);
_vue2.default.component("input-fone", _inputFone2.default);
_vue2.default.component("input-hora", _inputHora2.default);
_vue2.default.component("input-email", _inputEmail2.default);
_vue2.default.component("input-email-list", _inputEmailList2.default);
_vue2.default.component("input-value", _inputValue2.default);
_vue2.default.component("input-checkbox", _inputCheckbox2.default);
_vue2.default.component("input-switch", _inputSwitch2.default);
_vue2.default.component("input-month", _inputMonth2.default);
_vue2.default.component("input-month2", _inputMonth4.default);
_vue2.default.component("input-date", _inputDate2.default);
_vue2.default.component("input-number", _inputNumber2.default);
_vue2.default.component("input-part", _inputPart2.default);
_vue2.default.component("input-item", _inputItem2.default);
_vue2.default.component("input-search", _inputSearch2.default);
_vue2.default.component("input-color-picker", _inputColorPicker2.default);
_vue2.default.component("tabs", _tabs2.default);
_vue2.default.component("select2", _select2.default);
_vue2.default.component("select2static", _select2static2.default);
_vue2.default.component("input-typeahead", _inputTypeahead2.default);
_vue2.default.component("email-form", _emailForm2.default);
_vue2.default.component("fones-part-share", _fonesPartShare2.default);
_vue2.default.component("confirm-adminpass", _confirmAdminpass2.default);
//Vue.component('notification-online-offline', notificationOnOffline)
//
//Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

var handleOutsideClick = void 0;

_vue2.default.directive("closable", {
  bind: function bind(el, binding, vnode) {
    // Here's the click/touchstart handler
    // (it is registered below)
    handleOutsideClick = function handleOutsideClick(e) {
      e.stopPropagation();
      // Get the handler method name and the exclude array
      // from the object used in v-closable
      var _binding$value = binding.value,
          handler = _binding$value.handler,
          exclude = _binding$value.exclude;

      // This variable indicates if the clicked element is excluded

      var clickedOnExcludedEl = false;
      exclude.forEach(function (refName) {
        // We only run this code if we haven't detected
        // any excluded element yet
        if (!clickedOnExcludedEl) {
          // Get the element using the reference name
          var excludedEl = vnode.context.$refs[refName];
          // See if this excluded element
          // is the same element the user just clicked on
          // console.log(refName)
          // console.log(excludedEl)
          if (excludedEl) if (excludedEl.length) clickedOnExcludedEl = excludedEl[0].contains(e.target);else clickedOnExcludedEl = excludedEl.contains(e.target);
        }
      });

      // We check to see if the clicked element is not
      // the dialog element and not excluded
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        // If the clicked element is outside the dialog
        // and not the button, then call the outside-click handler
        // from the same component this directive is used in
        vnode.context[handler]();
      }
    };
    // Register click/touchstart event listeners on the whole page
    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
  },
  unbind: function unbind() {
    // If the element that has v-closable is removed, then
    // unbind click/touchstart listeners from the whole page
    document.removeEventListener("click", handleOutsideClick);
    document.removeEventListener("touchstart", handleOutsideClick);
  }
});

var router = new _vueRouter2.default({
  //hashbang: false,
  //mode: 'history',
  base: "/app/",
  routes: routes
});

new _vue2.default({
  el: "#app",
  store: _store.store,
  created: function created() {
    //carrega o metadata do servidor backend
    this.$restRegisterInterceptor();
    // this.loadMetadata()
  },

  data: {
    //para acessar o dada: this.$root._data
    //this.$root.data_example()
  },
  methods: {
    //this.$root.method_example()
    // async loadMetadata () {
    // await this.$store.dispatch('loadMetadata')
    // }
  },
  render: function render(h) {
    return h(_App2.default);
  },
  router: router
});

router.beforeEach(function (to, from, next) {
  if (to.name == "login" || to.name == "assinar" || to.name == "cadastro" || to.name == "ativar" || to.name == "senha" || to.name == "registro" || to.name == "registronfe" || to.name == "registroloja" || to.name == "registropedidos" || to.name == "recuperar" || to.name == "fvpedidopagform" || to.name == "imprimir-pedido" || to.name == "imprimir-compra") {
    next();
  } else if (SysVars.appLogged) {
    var isContador = _store.store.getters.getEnv && _store.store.getters.getEnv.tpempresa === 'E';
    if (isContador) {
      if (to.name !== 'contador_empresas') {
        next({ name: 'contador_empresas' });
      } else {
        next();
      }
    } else {
      if (to.name == "minhaconta" || to.name == "planosnfe" || to.name == "planoserp") {
        next();
      } else if (SysVars.forceUrl) {
        next({ path: SysVars.forceUrl });
      } else {
        next();
      }
    }
  } else {
    next({ name: "login" });
  }

  Tawk_API.showWidget();
});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiMenuLiberado = exports.apiRecursoLiberado = exports.apiValidaLimitePlano = exports.apiORDSmidia = exports.apiORDSdelete2 = exports.apiORDSdelete = exports.apiORDSauth = exports.apiORDSapp = exports.lojaORDSpost = exports.apiORDSpost = exports.apiORDSpostlongtimeout = exports.apiORDSgetViaPost = exports.apiORDS = undefined;
exports.apiMetadata = apiMetadata;
exports.urlORDS = urlORDS;
exports.urlAPP = urlAPP;
exports.urlLoja = urlLoja;
exports.apiDateORDS = apiDateORDS;
exports.apiEmailPDF = apiEmailPDF;
exports.apiDownloadPDF = apiDownloadPDF;
exports.apiDownload2 = apiDownload2;
exports.apiOpenPDF = apiOpenPDF;
exports.apiSavePDF = apiSavePDF;
exports.apiSavePDFBlob = apiSavePDFBlob;
exports.apiDownload = apiDownload;
exports.str2bytes = str2bytes;
exports.apiDownloadFile = apiDownloadFile;
exports.apiAutNFe = apiAutNFe;
exports.apiAutNFSe = apiAutNFSe;
exports.apiSyncNFSe = apiSyncNFSe;
exports.apiConsultaCadastro = apiConsultaCadastro;

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(9);

var _axios2 = _interopRequireDefault(_axios);

var _main = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                           export para funcao de chamadas API REST
                                                                                                                                                                                                                                                                                                                                                                                                                                                                           - estas funções estão sendo utilizadas na STORE.JS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                           apiOrds: efetua a requisicao no servidor ORDS e retorna o resultado
                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                           TRATAMENTO DE EXCECAO:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                           global-functions.js -> Vue.prototype.$restRegisterInterceptor
                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

var apiORDS = exports.apiORDS = function apiORDS(url, params, noSpin) {
  var path = url;
  if (params && params.id) {
    path = path + params.id;
  }
  if (params && params.filter) {
    path = path + '?q=' + params.filter;
  }
  if (params && params.query) {
    path = path + '?' + params.query;
  }
  if (params && params.page) {
    if (params.filter || params.query) {
      path = path + '&offset=' + params.page;
    } else {
      path = path + '?offset=' + params.page;
    }
  }
  if (params && params.offset) {
    if (params.filter || params.query) {
      path = path + '&offset=' + params.offset;
    } else {
      path = path + '?offset=' + params.offset;
    }
  }
  if (params && params.limit) {
    if (params.filter || params.query) {
      path = path + '&limit=' + params.limit;
    } else {
      path = path + '?limit=' + params.limit;
    }
  }
  if (params && params.body) {
    if (params.filter || params.query) {
      path = path + '&filtros=' + params.body;
    } else {
      path = path + '?filtros=' + params.body;
    }
  }

  if (!noSpin) _vue2.default.prototype.$appLoading(true);
  return _axios2.default.get(path).then(function (data) {
    _vue2.default.prototype.$serverError(false);
    if (!noSpin) _vue2.default.prototype.$appLoading(false);
    return data.data;
  });
};

var apiORDSgetViaPost = exports.apiORDSgetViaPost = function apiORDSgetViaPost(url, params, noSpin) {
  var path = url;
  if (params && params.id) {
    path = path + params.id;
  }
  if (params && params.filter) {
    path = path + '?q=' + params.filter;
  }
  if (params && params.query) {
    path = path + '?' + params.query;
  }
  if (params && params.page) {
    if (params.filter || params.query) {
      path = path + '&offset=' + params.page;
    } else {
      path = path + '?offset=' + params.page;
    }
  }
  if (params && params.offset) {
    if (params.filter || params.query) {
      path = path + '&offset=' + params.offset;
    } else {
      path = path + '?offset=' + params.offset;
    }
  }
  if (params && params.limit) {
    if (params.filter || params.query) {
      path = path + '&limit=' + params.limit;
    } else {
      path = path + '?limit=' + params.limit;
    }
  }

  var data = params.body;

  if (!noSpin) _vue2.default.prototype.$appLoading(true);
  return _axios2.default.post(path, data).then(function (data) {
    _vue2.default.prototype.$serverError(false);
    if (!noSpin) _vue2.default.prototype.$appLoading(false);
    return data.data;
  });
};

var apiORDSpostlongtimeout = exports.apiORDSpostlongtimeout = function apiORDSpostlongtimeout(store, modulo, data, metodo, params, token) {
  //CHAMADA API ORDS METODO POST OU PUT
  var path = urlORDS(store, modulo, params);
  _vue2.default.prototype.$appLoading(true);
  if (metodo == 'post') {
    return _axios2.default.post(path, data, { timeout: 1200000 }).then(function (data) {
      _vue2.default.prototype.$serverError(false);
      _vue2.default.prototype.$appLoading(false);
      return data.data;
    });
  } else if (metodo == 'put') {
    return _axios2.default.put(path, data, { timeout: 1200000 }).then(function (data) {
      _vue2.default.prototype.$serverError(false);
      _vue2.default.prototype.$appLoading(false);
      return data.data;
    });
  }
  _vue2.default.prototype.$appLoading(false);
};

var apiORDSpost = exports.apiORDSpost = function apiORDSpost(store, modulo, data, metodo, params, token) {
  //CHAMADA API ORDS METODO POST OU PUT
  var path = urlORDS(store, modulo, params);
  _vue2.default.prototype.$appLoading(true);
  if (metodo == 'post') {
    return _axios2.default.post(path, data).then(function (data) {
      _vue2.default.prototype.$serverError(false);
      _vue2.default.prototype.$appLoading(false);
      return data.data;
    });
  } else if (metodo == 'put') {
    return _axios2.default.put(path, data).then(function (data) {
      _vue2.default.prototype.$serverError(false);
      _vue2.default.prototype.$appLoading(false);
      return data.data;
    });
  }
  _vue2.default.prototype.$appLoading(false);
};

var lojaORDSpost = exports.lojaORDSpost = function lojaORDSpost(store, modulo, data, metodo, params, token) {
  //CHAMADA API ORDS METODO POST OU PUT
  var path = urlLoja(store, modulo, params);
  _vue2.default.prototype.$appLoading(true);
  if (metodo == 'post') {
    return _axios2.default.post(path, data).then(function (data) {
      _vue2.default.prototype.$serverError(false);
      _vue2.default.prototype.$appLoading(false);
      return data.data;
    });
  } else if (metodo == 'put') {
    return _axios2.default.put(path, data).then(function (data) {
      _vue2.default.prototype.$serverError(false);
      _vue2.default.prototype.$appLoading(false);
      return data.data;
    });
  }
  _vue2.default.prototype.$appLoading(false);
};

var apiORDSapp = exports.apiORDSapp = function apiORDSapp(vm, url, metodo, data, params) {
  //CHAMADA API ORDS /nbapp/
  var path = vm.$store.getters.urlApp + url;
  if (params && params.id) {
    path = path + params.id;
  }
  _vue2.default.prototype.$appLoading(true);
  if (metodo == 'get') {
    return _axios2.default.get(path).then(function (data) {
      _vue2.default.prototype.$serverError(false);
      _vue2.default.prototype.$appLoading(false);
      return data.data;
    });
  }
  if (metodo == 'post') {
    return _axios2.default.post(path, data).then(function (data) {
      _vue2.default.prototype.$serverError(false);
      _vue2.default.prototype.$appLoading(false);
      return data.data;
    });
  } else if (metodo == 'put') {
    return _axios2.default.put(path, data).then(function (data) {
      _vue2.default.prototype.$serverError(false);
      _vue2.default.prototype.$appLoading(false);
      return data.data;
    });
  } else if (metodo == 'delete') {
    return _axios2.default.delete(path, data).then(function (data) {
      _vue2.default.prototype.$serverError(false);
      _vue2.default.prototype.$appLoading(false);
      return data.data;
    });
  }
  _vue2.default.prototype.$appLoading(false);
};

var apiORDSauth = exports.apiORDSauth = function apiORDSauth(data) {
  //CHAMADA API ORDS METODO AUTH/TOKEN PARA OBTER O TOKEN
  var url = data.urlapi + '/oauth/token';
  var config = {
    headers: {
      'Authorization': 'Basic ' + data.token,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  };
  var body = 'grant_type=client_credentials';

  _vue2.default.prototype.$appLoading(true);
  return _axios2.default.post(url, body, config).then(function (data) {
    _vue2.default.prototype.$serverError(false);
    _vue2.default.prototype.$appLoading(false);
    return data.data;
  });

  _vue2.default.prototype.$appLoading(false);
  return false;
};

var apiORDSdelete = exports.apiORDSdelete = function apiORDSdelete(state, modulo, token) {
  //CHAMADA API ORDS METODO DELETE
  var path = urlORDS(state, modulo);
  _vue2.default.prototype.$appLoading(true);
  return _axios2.default.delete(path).then(function () {
    _vue2.default.prototype.$serverError(false);
    _vue2.default.prototype.$appLoading(false);
    return;
  });
  _vue2.default.prototype.$appLoading(false);
};

var apiORDSdelete2 = exports.apiORDSdelete2 = function apiORDSdelete2(url) {
  //CHAMADA API ORDS METODO DELETE
  _vue2.default.prototype.$appLoading(true);
  return _axios2.default.delete(url).then(function () {
    _vue2.default.prototype.$serverError(false);
    _vue2.default.prototype.$appLoading(false);
    return;
  });
  _vue2.default.prototype.$appLoading(false);
};

var apiORDSmidia = exports.apiORDSmidia = function apiORDSmidia(url, params) {
  //CHAMADA NA API ORDS PARA DOWNLOAD DE MIDIA (IMAGENS)
  var path = url;
  if (params && params.id) {
    path = path + params.id;
  }
  if (params && params.filter) {
    path = path + '?q=' + params.filter;
  }
  if (params && params.page) {
    if (params.filter) {
      path = path + '&offset=' + params.page;
    } else {
      path = path + '?offset=' + params.page;
    }
  }
  _vue2.default.prototype.$appLoading(true);
  return _axios2.default.get(path, { responseType: "blob" }).then(function (data) {
    _vue2.default.prototype.$serverError(false);
    _vue2.default.prototype.$appLoading(false);
    return data.data;
  });
  _vue2.default.prototype.$appLoading(false);
};

function apiMetadata(url) {
  //CHAMADA APP SERVER PARA RETORNAR O OBJETO METADATA
  return _axios2.default.get(url).then(function (response) {
    _vue2.default.prototype.$serverError(false);
    return response.data.entities;
  });
}

function urlORDS(store, modulo, params) {
  //FUNCAO QUE MONTA A URL PARA ACESSO À API ORDS
  var url = store.getters.urlOrds + modulo;
  if (params && params.id) {
    url = url + params.id;
  }
  return url;
}

function urlAPP(state, modulo, params) {
  //FUNCAO QUE MONTA A URL PARA ACESSO À API PRINCIPAL ords/nbapp/
  var url = state.urlApp + modulo;
  if (params && params.id) {
    url = url + params.id;
  }
  return url;
}

function urlLoja(store, modulo, params) {
  //FUNCAO QUE MONTA A URL PARA ACESSO À API ORDS
  var url = store.getters.urlLoja + modulo;
  if (params && params.id) {
    url = url + params.id;
  }
  return url;
}

function apiDateORDS(pDate, ulthora) {
  //retorna o campo data formatado para a query string do ORDS
  //{"$date":"2018-09-12T00:00:00Z"}
  if (!pDate || pDate == '') {
    return '';
  }
  if (ulthora) {
    return pDate + 'T23:59:59Z';
  } else {
    return pDate + 'T00:00:00Z';
  }
}

function apiEmailPDF(self, module, data) {
  /* chamada API para envio de emails ORDS/NBAPP/EMAIL/ (pedido de venda, cotacao, pedido de compra, danfe, etc)
  data:
    sendto: '',
    subject: '',
    text: '',
    codnf: uuid
  */

  var path = self.$store.getters.urlApp + 'email/' + module;
  _vue2.default.prototype.$appLoading(true);
  _vue2.default.prototype.$serverError(false);
  return _axios2.default.post(path, data).then(function (data) {
    _vue2.default.prototype.$serverError(false);
    _vue2.default.prototype.$appLoading(false);
    if (data.data && data.data.errmessages) {
      _vue2.default.prototype.$erpToastError(data.data.errmessages[0]);
    } else {
      _vue2.default.prototype.$erpToastSuccess('O Email foi enviado');
      return data.data;
    }
  });
  _vue2.default.prototype.$appLoading(false);
}

function apiDownloadPDF(self, module, data, metodo, open, filename, print) {
  //efetua download de arquivos pdf da api ORDS/NBAPP (pedido de venda, cotacao, pedido de compra, danfe, etc)
  //o servidor está enviando o arquivo em BASE64 pelo fato da rotina apiDownloadFile estar mudando o character-set do arquivo

  var url = self.$store.getters.urlApp + module;

  if (module.includes('boleto') || module.includes('cnab') || module.includes('xmlhist') || module.includes('etiqueta') || module.includes('nfse')) {
    url = self.$store.getters.urlOrds + module;
  }

  if (module.includes('htmlpdf')) {
    url = 'https://teste.notabrasil.com.br/htmlpdf';
    // url = '/htmlpdf'
  }

  url = url.replace('empresa.uuid', self.$store.getters.getEnv.uuid);

  _vue2.default.prototype.$appLoading(true);
  _vue2.default.prototype.$serverError(false);
  if (!metodo || metodo === 'get') {
    self.$http.get(url).then(function (response) {
      _vue2.default.prototype.$appLoading(false);
      if (response.data && response.data.errmessages) {
        _vue2.default.prototype.$erpToastError(response.data.errmessages[0]);
      } else {
        if (!open) apiSavePDF(response, filename); //para o CRM deve salvar o arquivo
        else apiOpenPDF(response, print);
      }
    }, function (response) {
      _vue2.default.prototype.$appLoading(false);
    });
  } else if (metodo && metodo === 'post') {
    //postConfig acrescentado para solucionar problema no serviço htmlpdf
    var postConfig = {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      responseType: 'blob'
    };
    self.$http.post(url, data, postConfig).then(function (response) {
      _vue2.default.prototype.$appLoading(false);
      if (response.data && response.data.errmessages) {
        _vue2.default.prototype.$erpToastError(response.data.errmessages[0]);
      } else {
        if (!open) apiSavePDF(response, filename); //para o CRM deve salvar o arquivo
        else apiOpenPDF(response, print);
      }
    }, function (response) {
      _vue2.default.prototype.$appLoading(false);
    });
  }
}

function apiDownload2(self, module, data, metodo, notProcessDownload) {
  var url = self.$store.getters.urlOrds + module;

  _vue2.default.prototype.$appLoading(true);
  if (metodo == 'get') {
    return _axios2.default.get(url, { responseType: 'blob' }).then(function (response) {
      _vue2.default.prototype.$serverError(false);
      _vue2.default.prototype.$appLoading(false);
      if (!notProcessDownload) apiDownloadFile(response);else return response;
    });
  }

  if (metodo == 'post') {
    return _axios2.default.post(url, data, { responseType: 'blob' }).then(function (response) {
      _vue2.default.prototype.$serverError(false);
      _vue2.default.prototype.$appLoading(false);
      if (!notProcessDownload) apiDownloadFile(response);else return response;
    });
  }
}

function apiOpenPDF(pdf, print) {
  //abre o arquivo PDF em outra janela
  var features = "width=800,height=600,left=100,top=100,toolbar=no,menubar=no,scrollbars=yes,resizable=yes";
  var pdfWindow = window.open("", "_blank", features);

  if (!pdfWindow || pdfWindow.closed || typeof pdfWindow.closed == 'undefined') {
    _vue2.default.prototype.$erpToastError('Desabilitar bloqueador de Pop-up para visualizar impressão da NF');
    return;
  }

  // pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdf.data) + "'></iframe>")
  var iframe = pdfWindow.document.createElement('iframe');
  iframe.style.width = '100%';
  iframe.style.height = '100%';
  iframe.style.border = 'none';
  iframe.src = 'data:application/pdf;base64,' + encodeURI(pdf.data);

  // Espera o iframe carregar
  iframe.onload = function () {
    if (print) {
      pdfWindow.focus(); // foca na nova janela
      pdfWindow.print();
    }
  };

  pdfWindow.document.body.style.margin = 0;
  pdfWindow.document.body.appendChild(iframe);
}

function apiSavePDF(pdf, filename) {
  //salva o arquivo PDF
  if (pdf.data instanceof Blob) {
    apiSavePDFBlob(pdf, filename);
    return;
  }

  //RECEBE ARQUIVO PDF EM BASE 64
  var name = 'unknown.pdf';
  var contentDisposition = pdf.headers['content-disposition'];
  if (contentDisposition) {
    var fileNameMatch = contentDisposition.match(/filename="(.+)"/);
    if (fileNameMatch.length === 2) name = fileNameMatch[1];
  }

  var linkSource = 'data:application/pdf;base64,' + pdf.data;
  var downloadLink = document.createElement("a");

  downloadLink.href = linkSource;
  downloadLink.download = name;
  downloadLink.click();
}

function apiSavePDFBlob(response, filename) {
  var newBlob = new Blob([response.data], { type: 'application/pdf' });

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }

  var name = 'unknown';
  if (!filename) {
    var contentDisposition = response.headers['content-disposition'];
    if (contentDisposition) {
      var fileNameMatch = contentDisposition.match(/filename="(.+)"/);
      if (fileNameMatch.length === 2) name = fileNameMatch[1];
    }
  } else {
    name = filename;
  }

  var data = window.URL.createObjectURL(newBlob);
  var link = document.createElement('a');
  link.href = data;
  link.download = name;
  link.click();
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
}

function apiDownload(self, module, data, metodo, notProcessDownload) {
  /* DOWNLOAD DE ARQUIVOS DO SERVIDOR ORDS/NBAPP */

  var url = self.$store.getters.urlApp + module;
  if (module.includes('cnab')) {
    url = self.$store.getters.urlOrds + module;
  }

  /* download teste de arquivo ZIP
  url = 'http://localhost:1049/nfexmlfiles?mes=10&ano=2019&codempresa=6&codfil=1&base=NBDATA000006'
  */

  _vue2.default.prototype.$appLoading(true);
  if (metodo == 'get') {
    return _axios2.default.get(url, { responseType: 'blob' }).then(function (response) {
      _vue2.default.prototype.$serverError(false);
      _vue2.default.prototype.$appLoading(false);
      if (!notProcessDownload) apiDownloadFile(response);else return response;
    });
  }
  if (metodo == 'post') {
    return _axios2.default.post(url, data, { responseType: 'blob' }).then(function (response) {
      _vue2.default.prototype.$serverError(false);
      _vue2.default.prototype.$appLoading(false);
      if (!notProcessDownload) apiDownloadFile(response);else return response;
    });
  }
}

function str2bytes(str) {
  var bytes = new Uint8Array(str.length);
  for (var i = 0; i < str.length; i++) {
    bytes[i] = str.charCodeAt(i);
  }
  return bytes;
}

function apiDownloadFile(response, filename) {
  //ATENCAO: rotina nao utilizada para download de PDF pelo fato de alterar o character-set do arquivo e causar problema de acentuação

  //trata o download do arquivo recebido da api

  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  //    var newBlob = new Blob([response.data], {type: response.headers['content-type']})
  var newBlob = new Blob([response.data], { type: 'text/json' });
  //var newBlob = new Blob([response.data], {type: 'application/zip'})
  //var url = window.URL.createObjectURL(newBlob)
  //window.open(url);
  //return

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  var name = 'unknown';

  if (!filename) {
    var contentDisposition = response.headers['content-disposition'];

    if (contentDisposition) {
      var fileNameMatch = contentDisposition.match(/filename="(.+)"/);
      if (fileNameMatch.length === 2) name = fileNameMatch[1];
    }
  } else {
    name = filename;
  }

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  var data = window.URL.createObjectURL(newBlob);
  var link = document.createElement('a');
  link.href = data;
  link.download = name;
  link.click();
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
}

function apiAutNFe(self, pFilial, pCodNF) {
  /* efetua o envio da nota fiscal para SEFAZ  */

  var url = self.$store.getters.urlApp + 'apinfe/autnfe/filial/' + pFilial + '/nfs/' + pCodNF;

  _vue2.default.prototype.$appLoading(true);
  return _axios2.default.get(url).then(function (response) {
    _vue2.default.prototype.$appLoading(false);
    return response;
  });
}

function apiAutNFSe(self, pCodNF) {

  var url = urlORDS(self.$store, 'nfse/autoriza/' + pCodNF);
  return apiORDS(url, null, true).then(function (response) {
    return response;
  });
}

function apiSyncNFSe(self, pCodNF) {

  var url = urlORDS(self.$store, 'nfse/sincroniza/' + pCodNF);
  return apiORDS(url, null, true).then(function (response) {
    return response;
  });
}

function apiConsultaCadastro(self, pCNPJ, pUF, callBack) {
  var url = 'consultacadastro/' + pCNPJ;
  if (pUF) url = url + '?uf=' + pUF;

  apiORDSapp(self, url, 'get').then(function (data) {
    if (data.errmessages) {} else {
      var dados = data;
      dados.endereco = self.$removerAcentos((dados.endereco || '').toUpperCase());
      dados.nr = self.$removerAcentos((dados.nr || '').toUpperCase());
      dados.bairro = self.$removerAcentos((dados.bairro || '').toUpperCase());
      dados.mun = self.$removerAcentos((dados.mun || '').toUpperCase());
      if (callBack) callBack(dados);
    }
  });
}

var apiValidaLimitePlano = exports.apiValidaLimitePlano = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(vm, recurso) {
    var path, data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            path = vm.$store.getters.urlApp + 'planos/validarecurso/' + recurso;

            // return axios.get(path).then((data) => {
            //   if (data.data.limitePlano) {
            //     if (recurso == 'usuarios')
            //       SysVars.limiteUsuariosAlcancado = true
            //     SysVars.showLimitePlano = true
            //     SysVars.limitePlanoMensagem = data.data.message
            //     return false
            //   }
            //   else
            //     return true
            // })

            _context.next = 3;
            return _axios2.default.get(path);

          case 3:
            data = _context.sent;

            if (!(data && data.data.limitePlano)) {
              _context.next = 11;
              break;
            }

            if (recurso == 'usuarios') _main.SysVars.limiteUsuariosAlcancado = true;
            _main.SysVars.showLimitePlano = true;
            _main.SysVars.limitePlanoMensagem = data.data.message;
            return _context.abrupt('return', false);

          case 11:
            return _context.abrupt('return', true);

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function apiValidaLimitePlano(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var apiRecursoLiberado = exports.apiRecursoLiberado = function apiRecursoLiberado(vm, recurso) {
  var recList = vm.$store.getters.getSessao.recursos_plano;
  recList = JSON.parse(recList);

  if (!recList) return true;

  var recId = null;

  var recursoLiberado = false;

  if (recurso == 'nfe') recId = 'E22157F5AD8E7BF2E0530100007F163B';else if (recurso == 'nfce') recId = 'E22157F5AD937BF2E0530100007F163B';else if (recurso == 'sat') recId = 'E22157F5AD927BF2E0530100007F163B';else if (recurso == 'financeiro') recId = 'EF2CF5AF0C2A644AE0530100007F58DF';else if (recurso == 'estoque') recId = 'EF2CF5AF0C2B644AE0530100007F58DF';else if (recurso == 'nfimportacao') recId = '016415DCCF0006DAE0630100007FA0CB';else if (recurso == 'nfimportacao_xmldi') recId = 'EF2CF5AF0C2F644AE0530100007F58DF';else if (recurso == 'varejo') recId = 'E22157F5AD947BF2E0530100007F163B';else if (recurso == 'regaimp') recId = 'E28170AE07D00331E0530100007F2060';else if (recurso == 'nfentrada') recId = 'E22157F5AD977BF2E0530100007F163B';else if (recurso == 'pedido') recId = 'E22157F5AD967BF2E0530100007F163B';else if (recurso == 'lojaonline') recId = 'E28170AE07CF0331E0530100007F2060';
  if (recurso == 'consultascomercial') recId = 'FFD312868DB76ED4E0530100007FA634';
  if (recurso == 'consultasestoque') recId = 'FFD312868DB86ED4E0530100007FA634';
  if (recurso == 'consultasfinanceiro') recId = 'FFD312868DB96ED4E0530100007FA634';

  if (_main.SysVars.plano && _main.SysVars.plano.app && _main.SysVars.plano.app.length > 0 && _main.SysVars.plano.app[0].app == 'ERP') {
    return true;
  }

  if (recId) {
    var recFound = recList.filter(function (obj) {
      return obj.uuid == recId;
    });
    if (recFound.length > 0 && recFound[0].ativo) {
      recursoLiberado = true;
    }
    return recursoLiberado;
  } else return true;
};

var apiMenuLiberado = exports.apiMenuLiberado = function apiMenuLiberado(vm, recurso) {
  if (recurso == 'varejo' && _main.SysVars.appVarejo) return true;else if (recurso == 'lojaonline' && _main.SysVars.appLoja) return true;else return apiRecursoLiberado(vm, recurso);
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(12);
var core = __webpack_require__(40);
var hide = __webpack_require__(29);
var redefine = __webpack_require__(30);
var ctx = __webpack_require__(41);
var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getText = getText;
exports.formatDate = formatDate;
exports.formatDateTraco = formatDateTraco;
exports.checkDate = checkDate;
exports.stringToInteger = stringToInteger;
exports.formatValue = formatValue;
exports.formatCNPJCPF = formatCNPJCPF;
exports.formatFone = formatFone;
exports.formatMesExtenso = formatMesExtenso;
exports.formatDataExtenso = formatDataExtenso;
exports.formatDataHoraExtenso = formatDataHoraExtenso;
exports.formatDataHora = formatDataHora;
exports.arrayMoveIndex = arrayMoveIndex;
exports.isValidURLSubdomain = isValidURLSubdomain;
exports.zeroPad = zeroPad;
exports.isMobile = isMobile;
exports.printForm = printForm;
exports.hasHiddenParent = hasHiddenParent;
exports.isValidHashColor = isValidHashColor;
exports.isValidPostalCode = isValidPostalCode;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// função que efetua validação do CPF
function getText(value, object) {
  // RETORNA O DESCRITIVO DO CAMPO
  if (!object.options) {
    console.log('Metadata "options" não foi encontrado:');
    console.log(object);
    return '';
  }
  var item = object.options.filter(function (x) {
    return x.id === value;
  });
  if (item.length) {
    return item[0].text;
  }
}

function formatDate(dateField) {
  //RECEBE A DATA NO FORMATO JSON "2018-09-21T03:00:00Z" E RETORNA NO FORMATO BR 21/09/2018

  if (checkDate(dateField)) {
    var _dateField$split = dateField.split("-"),
        _dateField$split2 = _slicedToArray(_dateField$split, 3),
        year_ = _dateField$split2[0],
        month_ = _dateField$split2[1],
        day_ = _dateField$split2[2];

    var day = day_.substr(0, 2);

    return [day, month_, year_].join('-');
  } else {
    return dateField;
  }
}

function formatDateTraco(dateField) {
  //RECEBE A DATA NO FORMATO JSON "2018-09-21T03:00:00Z" E RETORNA NO FORMATO BR 21/09/2018
  if (checkDate(dateField)) {
    var _dateField$split3 = dateField.split("-"),
        _dateField$split4 = _slicedToArray(_dateField$split3, 3),
        year_ = _dateField$split4[0],
        month_ = _dateField$split4[1],
        day_ = _dateField$split4[2];

    var day = day_.substr(0, 2);

    return [day, month_, year_].join('-');
  } else {
    return dateField;
  }
}

function checkDate(field) {
  if (field != '') {
    //https://stackoverflow.com/questions/29826284/my-regex-does-not-match-yyyy-mm-ddthhmmss


    // if ((/^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])T(0[0-9]|1[0-9]|2[0-3]):(0[0-9]|[0-5][0-9]):(0[0-9]|[0-5][0-9])Z$/.test(field))
    if (/^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])T(0[0-9]|1[0-9]|2[0-3]):(0[0-9]|[0-5][0-9]):(0[0-9]|[0-5][0-9])$/.test(field) || /^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])T(0[0-9]|1[0-9]|2[0-3]):(0[0-9]|[0-5][0-9]):(0[0-9]|[0-5][0-9])Z$/.test(field) || /^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])(00|[0-9]|1[0-9]|2[0-3]):([0-9]|[0-5][0-9]):([0-9]|[0-5][0-9])$/.test(field) || /^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])$/.test(field)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function stringToInteger(str) {
  // Attempt to parse the string to an integer
  var parsedInt = parseInt(str, 10);

  // Check if the result is NaN (Not a Number)
  if (isNaN(parsedInt)) {
    return 0; // Return 0 if parsing fails
  }

  return parsedInt; // Return the parsed integer
}

function formatValue(value, precision) {
  var numero = 0;
  if (value) {
    numero = value;
  }

  numero = parseFloat(numero).toFixed(precision).split('.');
  if (numero) {
    numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.');

    //RETIRA O PONTO A FRENTE DE VALORES NEGATIVOS
    if (numero[0].substr(0, 1) === '-') {
      var fracao = numero[0].split('');
      if (fracao[1] === '.') {
        fracao.splice(1, 1);
        fracao = fracao.join('');
        numero[0] = fracao;
      }
    }
    return numero.join(',');
  } else {
    return 0;
  }
  // let numero = 0
  // if (value)
  //   numero = value
  // numero = numero.toLocaleString('pt-br', {minimumFractionDigits: 2})
  // return numero
}

function formatCNPJCPF(value) {
  if (!value) {
    return value;
  }
  if (value.length == 14) {
    return String(value).toUpperCase().replace(/^([A-Z0-9]{2})([A-Z0-9]{3})?([A-Z0-9]{3})?([A-Z0-9]{4})?([A-Z0-9]{2})?/, "$1.$2.$3/$4-$5");
  }
  if (value.length == 11) {
    return value.replace(/^(\d{3})?(\d{3})?(\d{3})?(\d{2})?/, "$1.$2.$3-$4");
  } else {
    return value;
  }
}

function formatFone(value) {
  if (!value) {
    return value;
  }
  var t = value.length;
  if (t == 8) return value.replace(/\D/g, '').replace(/^(\d{4})(\d{4})??/, "$1-$2");else if (t == 9) return value.replace(/\D/g, '').replace(/^(\d{1})(\d{4})(\d{4})??/, "$1 $2-$3");else if (t == 11) return value.replace(/\D/g, '').replace(/^(\d{2})(\d{1})(\d{4})(\d{4})??/, "($1) $2 $3-$4");else if (t == 10) return value.replace(/\D/g, '').replace(/^(\d{2})(\d{4})(\d{4})??/, "($1) $2-$3");else return value;
}

function formatMesExtenso(value, min) {
  if (!value) return '';

  var listMonth = [];
  if (min) listMonth = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];else listMonth = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

  var _value$split = value.split("-"),
      _value$split2 = _slicedToArray(_value$split, 3),
      year_ = _value$split2[0],
      month_ = _value$split2[1],
      day_ = _value$split2[2];

  var now = new Date();
  if (now.getFullYear() == year_) return listMonth[month_ - 1];else return listMonth[month_ - 1] + ' ' + year_;
}

function formatDataExtenso(value, min) {
  if (!value) return '';

  var _value$split3 = value.split("-"),
      _value$split4 = _slicedToArray(_value$split3, 3),
      year_ = _value$split4[0],
      month_ = _value$split4[1],
      day_ = _value$split4[2];

  var day = day_.substr(0, 2);

  if (min) return day + ' ' + formatMesExtenso(value, min);else {
    var teste = new Date(value);
    var dia = teste.getDay();
    var semana = new Array(6);
    semana[0] = 'Dom';
    semana[1] = 'Seg';
    semana[2] = 'Ter';
    semana[3] = 'Qua';
    semana[4] = 'Qui';
    semana[5] = 'Sex';
    semana[6] = 'Sáb';
    return semana[dia] + ', ' + day + ' ' + formatMesExtenso(value, min);
  }
}

function formatDataHoraExtenso(value, min) {
  if (!value) return '';

  var data = new Date(value);
  var hora = data.toLocaleTimeString();

  return formatDataExtenso(value, min) + ', ' + hora.substr(0, 5);
}

function formatDataHora(value, min) {
  if (!value) return '';

  // var data = new Date(value);

  // var hora = data.toTimeString();

  // return formatDate(value) + ' ' + hora.substr(0, 5

  // Rotina estava convertendo 3 horas a menos do horario do servidor. Pelo horario do browser GTM-0300

  var data = new Date(value);
  var hora = data.getUTCHours();
  var minute = data.getUTCMinutes();

  return formatDate(value) + ' ' + hora + ':' + (minute < 10 ? '0' + minute : minute);
}

function arrayMoveIndex(arr, old_index, positions) {
  var new_index = old_index + positions;

  // console.log(positions)
  // console.log(old_index)
  // console.log(new_index)
  // console.log(arr)

  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  // return arr;
}

function isValidURLSubdomain(str) {
  var pattern = new RegExp('^((?!-)[A-Za-z0-9-]+[A-Za-z0-9-]+[A-Za-z0-9-](?<!-))$');
  return !!pattern.test(str);
}

function zeroPad(num, places) {
  return String(num).padStart(places, '0');
}

function isMobile() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
}

function printForm(prtHtml, mobileDevice) {
  var stylesHtml = '';

  var _arr = [].concat(_toConsumableArray(document.querySelectorAll('link[rel="stylesheet"], style')));

  for (var _i = 0; _i < _arr.length; _i++) {
    var node = _arr[_i];
    stylesHtml += node.outerHTML;
  }

  var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

  WinPrint.document.write('\n    <!DOCTYPE html>\n    <html>\n      <head>\n        ' + stylesHtml + '\n      </head>\n      <body>\n        <div>\n          <div class="w-100 p-3">\n              ' + prtHtml + '\n          </div>\n        </div>\n      </body>\n    </html>\n  ');

  WinPrint.document.close();
  WinPrint.focus();
  if (!isMobile()) {
    WinPrint.print();
    // WinPrint.close();
  }
}

/*
export {
   getText,
   formatDate,
   checkDate,
   formatValue,
   formatFone,
   formatCNPJCPF,
   formatMesExtenso,
   formatDataExtenso
}

*/

function hasHiddenParent(element) {
  while (element && element.parentElement) {
    if (window.getComputedStyle(element.parentElement).display === 'none' || jQuery(element.parentElement).prop("tabindex") === 1) {
      return true;
    }
    element = element.parentElement;
  }
  return false;
}

function isValidHashColor(color) {
  // Regular expression to match the hex color format
  var hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

  // Test if the string matches the regex
  return hexRegex.test(color);
}

function isValidPostalCode(cep) {
  // Expressão regular para validar o formato do CEP
  var regex = /^[0-9]{5}-?[0-9]{3}$/;
  return regex.test(cep);
}

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_bar_list_vue__ = __webpack_require__(403);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_66ab8e44_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_bar_list_vue__ = __webpack_require__(1115);
function injectStyle (ssrContext) {
  __webpack_require__(1107)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66ab8e44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_bar_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_66ab8e44_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_bar_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(992);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(15);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Vue.js v2.7.16
 * (c) 2014-2023 Evan You
 * Released under the MIT License.
 */
var emptyObject = Object.freeze({});
var isArray = Array.isArray;
// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef(v) {
    return v === undefined || v === null;
}
function isDef(v) {
    return v !== undefined && v !== null;
}
function isTrue(v) {
    return v === true;
}
function isFalse(v) {
    return v === false;
}
/**
 * Check if value is primitive.
 */
function isPrimitive(value) {
    return typeof value === 'string' || typeof value === 'number' ||
    // $flow-disable-line
    (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol' || typeof value === 'boolean';
}
function isFunction(value) {
    return typeof value === 'function';
}
/**
 * Quick object check - this is primarily used to tell
 * objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject(obj) {
    return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}
/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;
function toRawType(value) {
    return _toString.call(value).slice(8, -1);
}
/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject(obj) {
    return _toString.call(obj) === '[object Object]';
}
function isRegExp(v) {
    return _toString.call(v) === '[object RegExp]';
}
/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val);
}
function isPromise(val) {
    return isDef(val) && typeof val.then === 'function' && typeof val.catch === 'function';
}
/**
 * Convert a value to a string that is actually rendered.
 */
function toString(val) {
    return val == null ? '' : Array.isArray(val) || isPlainObject(val) && val.toString === _toString ? JSON.stringify(val, replacer, 2) : String(val);
}
function replacer(_key, val) {
    // avoid circular deps from v3
    if (val && val.__v_isRef) {
        return val.value;
    }
    return val;
}
/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
}
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap(str, expectsLowerCase) {
    var map = Object.create(null);
    var list = str.split(',');
    for (var i = 0; i < list.length; i++) {
        map[list[i]] = true;
    }
    return expectsLowerCase ? function (val) {
        return map[val.toLowerCase()];
    } : function (val) {
        return map[val];
    };
}
/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);
/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
/**
 * Remove an item from an array.
 */
function remove$2(arr, item) {
    var len = arr.length;
    if (len) {
        // fast path for the only / last item
        if (item === arr[len - 1]) {
            arr.length = len - 1;
            return;
        }
        var index = arr.indexOf(item);
        if (index > -1) {
            return arr.splice(index, 1);
        }
    }
}
/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
    return hasOwnProperty.call(obj, key);
}
/**
 * Create a cached version of a pure function.
 */
function cached(fn) {
    var cache = Object.create(null);
    return function cachedFn(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
    return str.replace(camelizeRE, function (_, c) {
        return c ? c.toUpperCase() : '';
    });
});
/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
    return str.replace(hyphenateRE, '-$1').toLowerCase();
});
/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */
/* istanbul ignore next */
function polyfillBind(fn, ctx) {
    function boundFn(a) {
        var l = arguments.length;
        return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
    }
    boundFn._length = fn.length;
    return boundFn;
}
function nativeBind(fn, ctx) {
    return fn.bind(ctx);
}
// @ts-expect-error bind cannot be `undefined`
var bind$1 = Function.prototype.bind ? nativeBind : polyfillBind;
/**
 * Convert an Array-like object to a real Array.
 */
function toArray(list, start) {
    start = start || 0;
    var i = list.length - start;
    var ret = new Array(i);
    while (i--) {
        ret[i] = list[i + start];
    }
    return ret;
}
/**
 * Mix properties into target object.
 */
function extend(to, _from) {
    for (var key in _from) {
        to[key] = _from[key];
    }
    return to;
}
/**
 * Merge an Array of Objects into a single Object.
 */
function toObject(arr) {
    var res = {};
    for (var i = 0; i < arr.length; i++) {
        if (arr[i]) {
            extend(res, arr[i]);
        }
    }
    return res;
}
/* eslint-disable no-unused-vars */
/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop(a, b, c) {}
/**
 * Always return false.
 */
var no = function no(a, b, c) {
    return false;
};
/* eslint-enable no-unused-vars */
/**
 * Return the same value.
 */
var identity = function identity(_) {
    return _;
};
/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys$1(modules) {
    return modules.reduce(function (keys, m) {
        return keys.concat(m.staticKeys || []);
    }, []).join(',');
}
/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual(a, b) {
    if (a === b) return true;
    var isObjectA = isObject(a);
    var isObjectB = isObject(b);
    if (isObjectA && isObjectB) {
        try {
            var isArrayA = Array.isArray(a);
            var isArrayB = Array.isArray(b);
            if (isArrayA && isArrayB) {
                return a.length === b.length && a.every(function (e, i) {
                    return looseEqual(e, b[i]);
                });
            } else if (a instanceof Date && b instanceof Date) {
                return a.getTime() === b.getTime();
            } else if (!isArrayA && !isArrayB) {
                var keysA = Object.keys(a);
                var keysB = Object.keys(b);
                return keysA.length === keysB.length && keysA.every(function (key) {
                    return looseEqual(a[key], b[key]);
                });
            } else {
                /* istanbul ignore next */
                return false;
            }
        } catch (e) {
            /* istanbul ignore next */
            return false;
        }
    } else if (!isObjectA && !isObjectB) {
        return String(a) === String(b);
    } else {
        return false;
    }
}
/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf(arr, val) {
    for (var i = 0; i < arr.length; i++) {
        if (looseEqual(arr[i], val)) return i;
    }
    return -1;
}
/**
 * Ensure a function is called only once.
 */
function once(fn) {
    var called = false;
    return function () {
        if (!called) {
            called = true;
            fn.apply(this, arguments);
        }
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#polyfill
function hasChanged(x, y) {
    if (x === y) {
        return x === 0 && 1 / x !== 1 / y;
    } else {
        return x === x || y === y;
    }
}

var SSR_ATTR = 'data-server-rendered';
var ASSET_TYPES = ['component', 'directive', 'filter'];
var LIFECYCLE_HOOKS = ['beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeUpdate', 'updated', 'beforeDestroy', 'destroyed', 'activated', 'deactivated', 'errorCaptured', 'serverPrefetch', 'renderTracked', 'renderTriggered'];

var config = {
    /**
     * Option merge strategies (used in core/util/options)
     */
    // $flow-disable-line
    optionMergeStrategies: Object.create(null),
    /**
     * Whether to suppress warnings.
     */
    silent: false,
    /**
     * Show production mode tip message on boot?
     */
    productionTip: "production" !== 'production',
    /**
     * Whether to enable devtools
     */
    devtools: "production" !== 'production',
    /**
     * Whether to record perf
     */
    performance: false,
    /**
     * Error handler for watcher errors
     */
    errorHandler: null,
    /**
     * Warn handler for watcher warns
     */
    warnHandler: null,
    /**
     * Ignore certain custom elements
     */
    ignoredElements: [],
    /**
     * Custom user key aliases for v-on
     */
    // $flow-disable-line
    keyCodes: Object.create(null),
    /**
     * Check if a tag is reserved so that it cannot be registered as a
     * component. This is platform-dependent and may be overwritten.
     */
    isReservedTag: no,
    /**
     * Check if an attribute is reserved so that it cannot be used as a component
     * prop. This is platform-dependent and may be overwritten.
     */
    isReservedAttr: no,
    /**
     * Check if a tag is an unknown element.
     * Platform-dependent.
     */
    isUnknownElement: no,
    /**
     * Get the namespace of an element
     */
    getTagNamespace: noop,
    /**
     * Parse the real tag name for the specific platform.
     */
    parsePlatformTagName: identity,
    /**
     * Check if an attribute must be bound using property, e.g. value
     * Platform-dependent.
     */
    mustUseProp: no,
    /**
     * Perform updates asynchronously. Intended to be used by Vue Test Utils
     * This will significantly reduce performance if set to false.
     */
    async: true,
    /**
     * Exposed for legacy reasons
     */
    _lifecycleHooks: LIFECYCLE_HOOKS
};

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
/**
 * Check if a string starts with $ or _
 */
function isReserved(str) {
    var c = (str + '').charCodeAt(0);
    return c === 0x24 || c === 0x5f;
}
/**
 * Define a property.
 */
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true
    });
}
/**
 * Parse simple path.
 */
var bailRE = new RegExp("[^".concat(unicodeRegExp.source, ".$_\\d]"));
function parsePath(path) {
    if (bailRE.test(path)) {
        return;
    }
    var segments = path.split('.');
    return function (obj) {
        for (var i = 0; i < segments.length; i++) {
            if (!obj) return;
            obj = obj[segments[i]];
        }
        return obj;
    };
}

// can we use __proto__?
var hasProto = '__proto__' in {};
// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
UA && /chrome\/\d+/.test(UA) && !isEdge;
UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);
// Firefox has a "watch" function on Object.prototype...
// @ts-expect-error firebox support
var nativeWatch = {}.watch;
var supportsPassive = false;
if (inBrowser) {
    try {
        var opts = {};
        Object.defineProperty(opts, 'passive', {
            get: function get() {
                /* istanbul ignore next */
                supportsPassive = true;
            }
        }); // https://github.com/facebook/flow/issues/285
        window.addEventListener('test-passive', null, opts);
    } catch (e) {}
}
// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function isServerRendering() {
    if (_isServer === undefined) {
        /* istanbul ignore if */
        if (!inBrowser && typeof global !== 'undefined') {
            // detect presence of vue-server-renderer and avoid
            // Webpack shimming the process
            _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
        } else {
            _isServer = false;
        }
    }
    return _isServer;
};
// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
/* istanbul ignore next */
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' && isNative(Symbol) && typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);
var _Set; // $flow-disable-line
/* istanbul ignore if */if (typeof Set !== 'undefined' && isNative(Set)) {
    // use native Set when available.
    _Set = Set;
} else {
    // a non-standard Set polyfill that only works with primitive keys.
    _Set = /** @class */function () {
        function Set() {
            this.set = Object.create(null);
        }
        Set.prototype.has = function (key) {
            return this.set[key] === true;
        };
        Set.prototype.add = function (key) {
            this.set[key] = true;
        };
        Set.prototype.clear = function () {
            this.set = Object.create(null);
        };
        return Set;
    }();
}

var currentInstance = null;
/**
 * This is exposed for compatibility with v3 (e.g. some functions in VueUse
 * relies on it). Do not use this internally, just use `currentInstance`.
 *
 * @internal this function needs manual type declaration because it relies
 * on previously manually authored types from Vue 2
 */
function getCurrentInstance() {
    return currentInstance && { proxy: currentInstance };
}
/**
 * @internal
 */
function setCurrentInstance(vm) {
    if (vm === void 0) {
        vm = null;
    }
    if (!vm) currentInstance && currentInstance._scope.off();
    currentInstance = vm;
    vm && vm._scope.on();
}

/**
 * @internal
 */
var VNode = /** @class */function () {
    function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
        this.tag = tag;
        this.data = data;
        this.children = children;
        this.text = text;
        this.elm = elm;
        this.ns = undefined;
        this.context = context;
        this.fnContext = undefined;
        this.fnOptions = undefined;
        this.fnScopeId = undefined;
        this.key = data && data.key;
        this.componentOptions = componentOptions;
        this.componentInstance = undefined;
        this.parent = undefined;
        this.raw = false;
        this.isStatic = false;
        this.isRootInsert = true;
        this.isComment = false;
        this.isCloned = false;
        this.isOnce = false;
        this.asyncFactory = asyncFactory;
        this.asyncMeta = undefined;
        this.isAsyncPlaceholder = false;
    }
    Object.defineProperty(VNode.prototype, "child", {
        // DEPRECATED: alias for componentInstance for backwards compat.
        /* istanbul ignore next */
        get: function get() {
            return this.componentInstance;
        },
        enumerable: false,
        configurable: true
    });
    return VNode;
}();
var createEmptyVNode = function createEmptyVNode(text) {
    if (text === void 0) {
        text = '';
    }
    var node = new VNode();
    node.text = text;
    node.isComment = true;
    return node;
};
function createTextVNode(val) {
    return new VNode(undefined, undefined, undefined, String(val));
}
// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode(vnode) {
    var cloned = new VNode(vnode.tag, vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(), vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    cloned.isComment = vnode.isComment;
    cloned.fnContext = vnode.fnContext;
    cloned.fnOptions = vnode.fnOptions;
    cloned.fnScopeId = vnode.fnScopeId;
    cloned.asyncMeta = vnode.asyncMeta;
    cloned.isCloned = true;
    return cloned;
}

/* not type checking this file because flow doesn't play well with Proxy */
var initProxy;
if (false) {
    var allowedGlobals_1 = makeMap('Infinity,undefined,NaN,isFinite,isNaN,' + 'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' + 'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' + 'require' // for Webpack/Browserify
    );
    var warnNonPresent_1 = function warnNonPresent_1(target, key) {
        warn$2("Property or method \"".concat(key, "\" is not defined on the instance but ") + 'referenced during render. Make sure that this property is reactive, ' + 'either in the data option, or for class-based components, by ' + 'initializing the property. ' + 'See: https://v2.vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.', target);
    };
    var warnReservedPrefix_1 = function warnReservedPrefix_1(target, key) {
        warn$2("Property \"".concat(key, "\" must be accessed with \"$data.").concat(key, "\" because ") + 'properties starting with "$" or "_" are not proxied in the Vue instance to ' + 'prevent conflicts with Vue internals. ' + 'See: https://v2.vuejs.org/v2/api/#data', target);
    };
    var hasProxy_1 = typeof Proxy !== 'undefined' && isNative(Proxy);
    if (hasProxy_1) {
        var isBuiltInModifier_1 = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
        config.keyCodes = new Proxy(config.keyCodes, {
            set: function set(target, key, value) {
                if (isBuiltInModifier_1(key)) {
                    warn$2("Avoid overwriting built-in modifier in config.keyCodes: .".concat(key));
                    return false;
                } else {
                    target[key] = value;
                    return true;
                }
            }
        });
    }
    var hasHandler_1 = {
        has: function has(target, key) {
            var has = key in target;
            var isAllowed = allowedGlobals_1(key) || typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data);
            if (!has && !isAllowed) {
                if (key in target.$data) warnReservedPrefix_1(target, key);else warnNonPresent_1(target, key);
            }
            return has || !isAllowed;
        }
    };
    var getHandler_1 = {
        get: function get(target, key) {
            if (typeof key === 'string' && !(key in target)) {
                if (key in target.$data) warnReservedPrefix_1(target, key);else warnNonPresent_1(target, key);
            }
            return target[key];
        }
    };
    initProxy = function initProxy(vm) {
        if (hasProxy_1) {
            // determine which proxy handler to use
            var options = vm.$options;
            var handlers = options.render && options.render._withStripped ? getHandler_1 : hasHandler_1;
            vm._renderProxy = new Proxy(vm, handlers);
        } else {
            vm._renderProxy = vm;
        }
    };
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
    _assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };
    return _assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var uid$2 = 0;
var pendingCleanupDeps = [];
var cleanupDeps = function cleanupDeps() {
    for (var i = 0; i < pendingCleanupDeps.length; i++) {
        var dep = pendingCleanupDeps[i];
        dep.subs = dep.subs.filter(function (s) {
            return s;
        });
        dep._pending = false;
    }
    pendingCleanupDeps.length = 0;
};
/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 * @internal
 */
var Dep = /** @class */function () {
    function Dep() {
        // pending subs cleanup
        this._pending = false;
        this.id = uid$2++;
        this.subs = [];
    }
    Dep.prototype.addSub = function (sub) {
        this.subs.push(sub);
    };
    Dep.prototype.removeSub = function (sub) {
        // #12696 deps with massive amount of subscribers are extremely slow to
        // clean up in Chromium
        // to workaround this, we unset the sub for now, and clear them on
        // next scheduler flush.
        this.subs[this.subs.indexOf(sub)] = null;
        if (!this._pending) {
            this._pending = true;
            pendingCleanupDeps.push(this);
        }
    };
    Dep.prototype.depend = function (info) {
        if (Dep.target) {
            Dep.target.addDep(this);
            if (false) {
                Dep.target.onTrack(_assign({ effect: Dep.target }, info));
            }
        }
    };
    Dep.prototype.notify = function (info) {
        // stabilize the subscriber list first
        var subs = this.subs.filter(function (s) {
            return s;
        });
        if (false) {
            // subs aren't sorted in scheduler if not running async
            // we need to sort them now to make sure they fire in correct
            // order
            subs.sort(function (a, b) {
                return a.id - b.id;
            });
        }
        for (var i = 0, l = subs.length; i < l; i++) {
            var sub = subs[i];
            if (false) {
                sub.onTrigger && sub.onTrigger(_assign({ effect: subs[i] }, info));
            }
            sub.update();
        }
    };
    return Dep;
}();
// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];
function pushTarget(target) {
    targetStack.push(target);
    Dep.target = target;
}
function popTarget() {
    targetStack.pop();
    Dep.target = targetStack[targetStack.length - 1];
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */
var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);
var methodsToPatch = ['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse'];
/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
    // cache original method
    var original = arrayProto[method];
    def(arrayMethods, method, function mutator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = original.apply(this, args);
        var ob = this.__ob__;
        var inserted;
        switch (method) {
            case 'push':
            case 'unshift':
                inserted = args;
                break;
            case 'splice':
                inserted = args.slice(2);
                break;
        }
        if (inserted) ob.observeArray(inserted);
        // notify change
        if (false) {
            ob.dep.notify({
                type: "array mutation" /* TriggerOpTypes.ARRAY_MUTATION */
                , target: this,
                key: method
            });
        } else {
            ob.dep.notify();
        }
        return result;
    });
});

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
var NO_INITIAL_VALUE = {};
/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;
function toggleObserving(value) {
    shouldObserve = value;
}
// ssr mock dep
var mockDep = {
    notify: noop,
    depend: noop,
    addSub: noop,
    removeSub: noop
};
/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = /** @class */function () {
    function Observer(value, shallow, mock) {
        if (shallow === void 0) {
            shallow = false;
        }
        if (mock === void 0) {
            mock = false;
        }
        this.value = value;
        this.shallow = shallow;
        this.mock = mock;
        // this.value = value
        this.dep = mock ? mockDep : new Dep();
        this.vmCount = 0;
        def(value, '__ob__', this);
        if (isArray(value)) {
            if (!mock) {
                if (hasProto) {
                    value.__proto__ = arrayMethods;
                    /* eslint-enable no-proto */
                } else {
                    for (var i = 0, l = arrayKeys.length; i < l; i++) {
                        var key = arrayKeys[i];
                        def(value, key, arrayMethods[key]);
                    }
                }
            }
            if (!shallow) {
                this.observeArray(value);
            }
        } else {
            /**
             * Walk through all properties and convert them into
             * getter/setters. This method should only be called when
             * value type is Object.
             */
            var keys = Object.keys(value);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                defineReactive(value, key, NO_INITIAL_VALUE, undefined, shallow, mock);
            }
        }
    }
    /**
     * Observe a list of Array items.
     */
    Observer.prototype.observeArray = function (value) {
        for (var i = 0, l = value.length; i < l; i++) {
            observe(value[i], false, this.mock);
        }
    };
    return Observer;
}();
// helpers
/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe(value, shallow, ssrMockReactivity) {
    if (value && hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
        return value.__ob__;
    }
    if (shouldObserve && (ssrMockReactivity || !isServerRendering()) && (isArray(value) || isPlainObject(value)) && Object.isExtensible(value) && !value.__v_skip /* ReactiveFlags.SKIP */ && !isRef(value) && !(value instanceof VNode)) {
        return new Observer(value, shallow, ssrMockReactivity);
    }
}
/**
 * Define a reactive property on an Object.
 */
function defineReactive(obj, key, val, customSetter, shallow, mock, observeEvenIfShallow) {
    if (observeEvenIfShallow === void 0) {
        observeEvenIfShallow = false;
    }
    var dep = new Dep();
    var property = Object.getOwnPropertyDescriptor(obj, key);
    if (property && property.configurable === false) {
        return;
    }
    // cater for pre-defined getter/setters
    var getter = property && property.get;
    var setter = property && property.set;
    if ((!getter || setter) && (val === NO_INITIAL_VALUE || arguments.length === 2)) {
        val = obj[key];
    }
    var childOb = shallow ? val && val.__ob__ : observe(val, false, mock);
    Object.defineProperty(obj, key, {
        enumerable: true,
        configurable: true,
        get: function reactiveGetter() {
            var value = getter ? getter.call(obj) : val;
            if (Dep.target) {
                if (false) {
                    dep.depend({
                        target: obj,
                        type: "get" /* TrackOpTypes.GET */
                        , key: key
                    });
                } else {
                    dep.depend();
                }
                if (childOb) {
                    childOb.dep.depend();
                    if (isArray(value)) {
                        dependArray(value);
                    }
                }
            }
            return isRef(value) && !shallow ? value.value : value;
        },
        set: function reactiveSetter(newVal) {
            var value = getter ? getter.call(obj) : val;
            if (!hasChanged(value, newVal)) {
                return;
            }
            if (false) {
                customSetter();
            }
            if (setter) {
                setter.call(obj, newVal);
            } else if (getter) {
                // #7981: for accessor properties without setter
                return;
            } else if (!shallow && isRef(value) && !isRef(newVal)) {
                value.value = newVal;
                return;
            } else {
                val = newVal;
            }
            childOb = shallow ? newVal && newVal.__ob__ : observe(newVal, false, mock);
            if (false) {
                dep.notify({
                    type: "set" /* TriggerOpTypes.SET */
                    , target: obj,
                    key: key,
                    newValue: newVal,
                    oldValue: value
                });
            } else {
                dep.notify();
            }
        }
    });
    return dep;
}
function set(target, key, val) {
    if (false) {
        warn$2("Cannot set reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isReadonly(target)) {
        "production" !== 'production' && warn$2("Set operation on key \"".concat(key, "\" failed: target is readonly."));
        return;
    }
    var ob = target.__ob__;
    if (isArray(target) && isValidArrayIndex(key)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        // when mocking for SSR, array methods are not hijacked
        if (ob && !ob.shallow && ob.mock) {
            observe(val, false, true);
        }
        return val;
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        return val;
    }
    if (target._isVue || ob && ob.vmCount) {
        "production" !== 'production' && warn$2('Avoid adding reactive properties to a Vue instance or its root $data ' + 'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val, undefined, ob.shallow, ob.mock);
    if (false) {
        ob.dep.notify({
            type: "add" /* TriggerOpTypes.ADD */
            , target: target,
            key: key,
            newValue: val,
            oldValue: undefined
        });
    } else {
        ob.dep.notify();
    }
    return val;
}
function del(target, key) {
    if (false) {
        warn$2("Cannot delete reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || ob && ob.vmCount) {
        "production" !== 'production' && warn$2('Avoid deleting properties on a Vue instance or its root $data ' + '- just set it to null.');
        return;
    }
    if (isReadonly(target)) {
        "production" !== 'production' && warn$2("Delete operation on key \"".concat(key, "\" failed: target is readonly."));
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    if (false) {
        ob.dep.notify({
            type: "delete" /* TriggerOpTypes.DELETE */
            , target: target,
            key: key
        });
    } else {
        ob.dep.notify();
    }
}
/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray(value) {
    for (var e = void 0, i = 0, l = value.length; i < l; i++) {
        e = value[i];
        if (e && e.__ob__) {
            e.__ob__.dep.depend();
        }
        if (isArray(e)) {
            dependArray(e);
        }
    }
}

function reactive(target) {
    makeReactive(target, false);
    return target;
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */
function shallowReactive(target) {
    makeReactive(target, true);
    def(target, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
    return target;
}
function makeReactive(target, shallow) {
    // if trying to observe a readonly proxy, return the readonly version.
    if (!isReadonly(target)) {
        if (false) {
            if (isArray(target)) {
                warn$2("Avoid using Array as root value for ".concat(shallow ? "shallowReactive()" : "reactive()", " as it cannot be tracked in watch() or watchEffect(). Use ").concat(shallow ? "shallowRef()" : "ref()", " instead. This is a Vue-2-only limitation."));
            }
            var existingOb = target && target.__ob__;
            if (existingOb && existingOb.shallow !== shallow) {
                warn$2("Target is already a ".concat(existingOb.shallow ? "" : "non-", "shallow reactive object, and cannot be converted to ").concat(shallow ? "" : "non-", "shallow."));
            }
        }
        var ob = observe(target, shallow, isServerRendering() /* ssr mock reactivity */);
        if (false) {
            if (target == null || isPrimitive(target)) {
                warn$2("value cannot be made reactive: ".concat(String(target)));
            }
            if (isCollectionType(target)) {
                warn$2("Vue 2 does not support reactive collection types such as Map or Set.");
            }
        }
    }
}
function isReactive(value) {
    if (isReadonly(value)) {
        return isReactive(value["__v_raw" /* ReactiveFlags.RAW */]);
    }
    return !!(value && value.__ob__);
}
function isShallow(value) {
    return !!(value && value.__v_isShallow);
}
function isReadonly(value) {
    return !!(value && value.__v_isReadonly);
}
function isProxy(value) {
    return isReactive(value) || isReadonly(value);
}
function toRaw(observed) {
    var raw = observed && observed["__v_raw" /* ReactiveFlags.RAW */];
    return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
    // non-extensible objects won't be observed anyway
    if (Object.isExtensible(value)) {
        def(value, "__v_skip" /* ReactiveFlags.SKIP */, true);
    }
    return value;
}
/**
 * @internal
 */
function isCollectionType(value) {
    var type = toRawType(value);
    return type === 'Map' || type === 'WeakMap' || type === 'Set' || type === 'WeakSet';
}

/**
 * @internal
 */
var RefFlag = "__v_isRef";
function isRef(r) {
    return !!(r && r.__v_isRef === true);
}
function ref$1(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) {
        return rawValue;
    }
    var ref = {};
    def(ref, RefFlag, true);
    def(ref, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, shallow);
    def(ref, 'dep', defineReactive(ref, 'value', rawValue, null, shallow, isServerRendering()));
    return ref;
}
function triggerRef(ref) {
    if (false) {
        warn$2("received object is not a triggerable ref.");
    }
    if (false) {
        ref.dep && ref.dep.notify({
            type: "set" /* TriggerOpTypes.SET */
            , target: ref,
            key: 'value'
        });
    } else {
        ref.dep && ref.dep.notify();
    }
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
function proxyRefs(objectWithRefs) {
    if (isReactive(objectWithRefs)) {
        return objectWithRefs;
    }
    var proxy = {};
    var keys = Object.keys(objectWithRefs);
    for (var i = 0; i < keys.length; i++) {
        proxyWithRefUnwrap(proxy, objectWithRefs, keys[i]);
    }
    return proxy;
}
function proxyWithRefUnwrap(target, source, key) {
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: function get() {
            var val = source[key];
            if (isRef(val)) {
                return val.value;
            } else {
                var ob = val && val.__ob__;
                if (ob) ob.dep.depend();
                return val;
            }
        },
        set: function set(value) {
            var oldValue = source[key];
            if (isRef(oldValue) && !isRef(value)) {
                oldValue.value = value;
            } else {
                source[key] = value;
            }
        }
    });
}
function customRef(factory) {
    var dep = new Dep();
    var _a = factory(function () {
        if (false) {
            dep.depend({
                target: ref,
                type: "get" /* TrackOpTypes.GET */
                , key: 'value'
            });
        } else {
            dep.depend();
        }
    }, function () {
        if (false) {
            dep.notify({
                target: ref,
                type: "set" /* TriggerOpTypes.SET */
                , key: 'value'
            });
        } else {
            dep.notify();
        }
    }),
        get = _a.get,
        set = _a.set;
    var ref = {
        get value() {
            return get();
        },
        set value(newVal) {
            set(newVal);
        }
    };
    def(ref, RefFlag, true);
    return ref;
}
function toRefs(object) {
    if (false) {
        warn$2("toRefs() expects a reactive object but received a plain one.");
    }
    var ret = isArray(object) ? new Array(object.length) : {};
    for (var key in object) {
        ret[key] = toRef(object, key);
    }
    return ret;
}
function toRef(object, key, defaultValue) {
    var val = object[key];
    if (isRef(val)) {
        return val;
    }
    var ref = {
        get value() {
            var val = object[key];
            return val === undefined ? defaultValue : val;
        },
        set value(newVal) {
            object[key] = newVal;
        }
    };
    def(ref, RefFlag, true);
    return ref;
}

var rawToReadonlyFlag = "__v_rawToReadonly";
var rawToShallowReadonlyFlag = "__v_rawToShallowReadonly";
function readonly(target) {
    return createReadonly(target, false);
}
function createReadonly(target, shallow) {
    if (!isPlainObject(target)) {
        if (false) {
            if (isArray(target)) {
                warn$2("Vue 2 does not support readonly arrays.");
            } else if (isCollectionType(target)) {
                warn$2("Vue 2 does not support readonly collection types such as Map or Set.");
            } else {
                warn$2("value cannot be made readonly: ".concat(typeof target === 'undefined' ? 'undefined' : _typeof(target)));
            }
        }
        return target;
    }
    if (false) {
        warn$2("Vue 2 does not support creating readonly proxy for non-extensible object.");
    }
    // already a readonly object
    if (isReadonly(target)) {
        return target;
    }
    // already has a readonly proxy
    var existingFlag = shallow ? rawToShallowReadonlyFlag : rawToReadonlyFlag;
    var existingProxy = target[existingFlag];
    if (existingProxy) {
        return existingProxy;
    }
    var proxy = Object.create(Object.getPrototypeOf(target));
    def(target, existingFlag, proxy);
    def(proxy, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, true);
    def(proxy, "__v_raw" /* ReactiveFlags.RAW */, target);
    if (isRef(target)) {
        def(proxy, RefFlag, true);
    }
    if (shallow || isShallow(target)) {
        def(proxy, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
    }
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineReadonlyProperty(proxy, target, keys[i], shallow);
    }
    return proxy;
}
function defineReadonlyProperty(proxy, target, key, shallow) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function get() {
            var val = target[key];
            return shallow || !isPlainObject(val) ? val : readonly(val);
        },
        set: function set() {
            "production" !== 'production' && warn$2("Set operation on key \"".concat(key, "\" failed: target is readonly."));
        }
    });
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */
function shallowReadonly(target) {
    return createReadonly(target, true);
}

function computed(getterOrOptions, debugOptions) {
    var getter;
    var setter;
    var onlyGetter = isFunction(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter =  false ? function () {
            warn$2('Write operation failed: computed value is readonly');
        } : noop;
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var watcher = isServerRendering() ? null : new Watcher(currentInstance, getter, noop, { lazy: true });
    if (false) {
        watcher.onTrack = debugOptions.onTrack;
        watcher.onTrigger = debugOptions.onTrigger;
    }
    var ref = {
        // some libs rely on the presence effect for checking computed refs
        // from normal refs, but the implementation doesn't matter
        effect: watcher,
        get value() {
            if (watcher) {
                if (watcher.dirty) {
                    watcher.evaluate();
                }
                if (Dep.target) {
                    if (false) {
                        Dep.target.onTrack({
                            effect: Dep.target,
                            target: ref,
                            type: "get" /* TrackOpTypes.GET */
                            , key: 'value'
                        });
                    }
                    watcher.depend();
                }
                return watcher.value;
            } else {
                return getter();
            }
        },
        set value(newVal) {
            setter(newVal);
        }
    };
    def(ref, RefFlag, true);
    def(ref, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, onlyGetter);
    return ref;
}

var mark;
var measure;
if (false) {
    var perf_1 = inBrowser && window.performance;
    /* istanbul ignore if */
    if (perf_1 &&
    // @ts-ignore
    perf_1.mark &&
    // @ts-ignore
    perf_1.measure &&
    // @ts-ignore
    perf_1.clearMarks &&
    // @ts-ignore
    perf_1.clearMeasures) {
        mark = function mark(tag) {
            return perf_1.mark(tag);
        };
        measure = function measure(name, startTag, endTag) {
            perf_1.measure(name, startTag, endTag);
            perf_1.clearMarks(startTag);
            perf_1.clearMarks(endTag);
            // perf.clearMeasures(name)
        };
    }
}

var normalizeEvent = cached(function (name) {
    var passive = name.charAt(0) === '&';
    name = passive ? name.slice(1) : name;
    var once = name.charAt(0) === '~'; // Prefixed last, checked first
    name = once ? name.slice(1) : name;
    var capture = name.charAt(0) === '!';
    name = capture ? name.slice(1) : name;
    return {
        name: name,
        once: once,
        capture: capture,
        passive: passive
    };
});
function createFnInvoker(fns, vm) {
    function invoker() {
        var fns = invoker.fns;
        if (isArray(fns)) {
            var cloned = fns.slice();
            for (var i = 0; i < cloned.length; i++) {
                invokeWithErrorHandling(cloned[i], null, arguments, vm, "v-on handler");
            }
        } else {
            // return handler return value for single handlers
            return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler");
        }
    }
    invoker.fns = fns;
    return invoker;
}
function updateListeners(on, oldOn, add, remove, createOnceHandler, vm) {
    var name, cur, old, event;
    for (name in on) {
        cur = on[name];
        old = oldOn[name];
        event = normalizeEvent(name);
        if (isUndef(cur)) {
            "production" !== 'production' && warn$2("Invalid handler for event \"".concat(event.name, "\": got ") + String(cur), vm);
        } else if (isUndef(old)) {
            if (isUndef(cur.fns)) {
                cur = on[name] = createFnInvoker(cur, vm);
            }
            if (isTrue(event.once)) {
                cur = on[name] = createOnceHandler(event.name, cur, event.capture);
            }
            add(event.name, cur, event.capture, event.passive, event.params);
        } else if (cur !== old) {
            old.fns = cur;
            on[name] = old;
        }
    }
    for (name in oldOn) {
        if (isUndef(on[name])) {
            event = normalizeEvent(name);
            remove(event.name, oldOn[name], event.capture);
        }
    }
}

function mergeVNodeHook(def, hookKey, hook) {
    if (def instanceof VNode) {
        def = def.data.hook || (def.data.hook = {});
    }
    var invoker;
    var oldHook = def[hookKey];
    function wrappedHook() {
        hook.apply(this, arguments);
        // important: remove merged hook to ensure it's called only once
        // and prevent memory leak
        remove$2(invoker.fns, wrappedHook);
    }
    if (isUndef(oldHook)) {
        // no existing hook
        invoker = createFnInvoker([wrappedHook]);
    } else {
        /* istanbul ignore if */
        if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
            // already a merged invoker
            invoker = oldHook;
            invoker.fns.push(wrappedHook);
        } else {
            // existing plain hook
            invoker = createFnInvoker([oldHook, wrappedHook]);
        }
    }
    invoker.merged = true;
    def[hookKey] = invoker;
}

function extractPropsFromVNodeData(data, Ctor, tag) {
    // we are only extracting raw values here.
    // validation and default values are handled in the child
    // component itself.
    var propOptions = Ctor.options.props;
    if (isUndef(propOptions)) {
        return;
    }
    var res = {};
    var attrs = data.attrs,
        props = data.props;
    if (isDef(attrs) || isDef(props)) {
        for (var key in propOptions) {
            var altKey = hyphenate(key);
            if (false) {
                var keyInLowerCase = key.toLowerCase();
                if (key !== keyInLowerCase && attrs && hasOwn(attrs, keyInLowerCase)) {
                    tip("Prop \"".concat(keyInLowerCase, "\" is passed to component ") + "".concat(formatComponentName(
                    // @ts-expect-error tag is string
                    tag || Ctor), ", but the declared prop name is") + " \"".concat(key, "\". ") + "Note that HTML attributes are case-insensitive and camelCased " + "props need to use their kebab-case equivalents when using in-DOM " + "templates. You should probably use \"".concat(altKey, "\" instead of \"").concat(key, "\"."));
                }
            }
            checkProp(res, props, key, altKey, true) || checkProp(res, attrs, key, altKey, false);
        }
    }
    return res;
}
function checkProp(res, hash, key, altKey, preserve) {
    if (isDef(hash)) {
        if (hasOwn(hash, key)) {
            res[key] = hash[key];
            if (!preserve) {
                delete hash[key];
            }
            return true;
        } else if (hasOwn(hash, altKey)) {
            res[key] = hash[altKey];
            if (!preserve) {
                delete hash[altKey];
            }
            return true;
        }
    }
    return false;
}

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:
// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren(children) {
    for (var i = 0; i < children.length; i++) {
        if (isArray(children[i])) {
            return Array.prototype.concat.apply([], children);
        }
    }
    return children;
}
// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren(children) {
    return isPrimitive(children) ? [createTextVNode(children)] : isArray(children) ? normalizeArrayChildren(children) : undefined;
}
function isTextNode(node) {
    return isDef(node) && isDef(node.text) && isFalse(node.isComment);
}
function normalizeArrayChildren(children, nestedIndex) {
    var res = [];
    var i, c, lastIndex, last;
    for (i = 0; i < children.length; i++) {
        c = children[i];
        if (isUndef(c) || typeof c === 'boolean') continue;
        lastIndex = res.length - 1;
        last = res[lastIndex];
        //  nested
        if (isArray(c)) {
            if (c.length > 0) {
                c = normalizeArrayChildren(c, "".concat(nestedIndex || '', "_").concat(i));
                // merge adjacent text nodes
                if (isTextNode(c[0]) && isTextNode(last)) {
                    res[lastIndex] = createTextVNode(last.text + c[0].text);
                    c.shift();
                }
                res.push.apply(res, c);
            }
        } else if (isPrimitive(c)) {
            if (isTextNode(last)) {
                // merge adjacent text nodes
                // this is necessary for SSR hydration because text nodes are
                // essentially merged when rendered to HTML strings
                res[lastIndex] = createTextVNode(last.text + c);
            } else if (c !== '') {
                // convert primitive to vnode
                res.push(createTextVNode(c));
            }
        } else {
            if (isTextNode(c) && isTextNode(last)) {
                // merge adjacent text nodes
                res[lastIndex] = createTextVNode(last.text + c.text);
            } else {
                // default key for nested array children (likely generated by v-for)
                if (isTrue(children._isVList) && isDef(c.tag) && isUndef(c.key) && isDef(nestedIndex)) {
                    c.key = "__vlist".concat(nestedIndex, "_").concat(i, "__");
                }
                res.push(c);
            }
        }
    }
    return res;
}

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;
// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement$1(context, tag, data, children, normalizationType, alwaysNormalize) {
    if (isArray(data) || isPrimitive(data)) {
        normalizationType = children;
        children = data;
        data = undefined;
    }
    if (isTrue(alwaysNormalize)) {
        normalizationType = ALWAYS_NORMALIZE;
    }
    return _createElement(context, tag, data, children, normalizationType);
}
function _createElement(context, tag, data, children, normalizationType) {
    if (isDef(data) && isDef(data.__ob__)) {
        "production" !== 'production' && warn$2("Avoid using observed data object as vnode data: ".concat(JSON.stringify(data), "\n") + 'Always create fresh vnode data objects in each render!', context);
        return createEmptyVNode();
    }
    // object syntax in v-bind
    if (isDef(data) && isDef(data.is)) {
        tag = data.is;
    }
    if (!tag) {
        // in case of component :is set to falsy value
        return createEmptyVNode();
    }
    // warn against non-primitive key
    if (false) {
        warn$2('Avoid using non-primitive value as key, ' + 'use string/number value instead.', context);
    }
    // support single function children as default scoped slot
    if (isArray(children) && isFunction(children[0])) {
        data = data || {};
        data.scopedSlots = { default: children[0] };
        children.length = 0;
    }
    if (normalizationType === ALWAYS_NORMALIZE) {
        children = normalizeChildren(children);
    } else if (normalizationType === SIMPLE_NORMALIZE) {
        children = simpleNormalizeChildren(children);
    }
    var vnode, ns;
    if (typeof tag === 'string') {
        var Ctor = void 0;
        ns = context.$vnode && context.$vnode.ns || config.getTagNamespace(tag);
        if (config.isReservedTag(tag)) {
            // platform built-in elements
            if (false) {
                warn$2("The .native modifier for v-on is only valid on components but it was used on <".concat(tag, ">."), context);
            }
            vnode = new VNode(config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
        } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
            // component
            vnode = createComponent(Ctor, data, context, children, tag);
        } else {
            // unknown or unlisted namespaced elements
            // check at runtime because it may get assigned a namespace when its
            // parent normalizes children
            vnode = new VNode(tag, data, children, undefined, undefined, context);
        }
    } else {
        // direct component options / constructor
        vnode = createComponent(tag, data, context, children);
    }
    if (isArray(vnode)) {
        return vnode;
    } else if (isDef(vnode)) {
        if (isDef(ns)) applyNS(vnode, ns);
        if (isDef(data)) registerDeepBindings(data);
        return vnode;
    } else {
        return createEmptyVNode();
    }
}
function applyNS(vnode, ns, force) {
    vnode.ns = ns;
    if (vnode.tag === 'foreignObject') {
        // use default namespace inside foreignObject
        ns = undefined;
        force = true;
    }
    if (isDef(vnode.children)) {
        for (var i = 0, l = vnode.children.length; i < l; i++) {
            var child = vnode.children[i];
            if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force) && child.tag !== 'svg')) {
                applyNS(child, ns, force);
            }
        }
    }
}
// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings(data) {
    if (isObject(data.style)) {
        traverse(data.style);
    }
    if (isObject(data.class)) {
        traverse(data.class);
    }
}

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList(val, render) {
    var ret = null,
        i,
        l,
        keys,
        key;
    if (isArray(val) || typeof val === 'string') {
        ret = new Array(val.length);
        for (i = 0, l = val.length; i < l; i++) {
            ret[i] = render(val[i], i);
        }
    } else if (typeof val === 'number') {
        ret = new Array(val);
        for (i = 0; i < val; i++) {
            ret[i] = render(i + 1, i);
        }
    } else if (isObject(val)) {
        if (hasSymbol && val[Symbol.iterator]) {
            ret = [];
            var iterator = val[Symbol.iterator]();
            var result = iterator.next();
            while (!result.done) {
                ret.push(render(result.value, ret.length));
                result = iterator.next();
            }
        } else {
            keys = Object.keys(val);
            ret = new Array(keys.length);
            for (i = 0, l = keys.length; i < l; i++) {
                key = keys[i];
                ret[i] = render(val[key], key, i);
            }
        }
    }
    if (!isDef(ret)) {
        ret = [];
    }
    ret._isVList = true;
    return ret;
}

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot(name, fallbackRender, props, bindObject) {
    var scopedSlotFn = this.$scopedSlots[name];
    var nodes;
    if (scopedSlotFn) {
        // scoped slot
        props = props || {};
        if (bindObject) {
            if (false) {
                warn$2('slot v-bind without argument expects an Object', this);
            }
            props = extend(extend({}, bindObject), props);
        }
        nodes = scopedSlotFn(props) || (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    } else {
        nodes = this.$slots[name] || (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    }
    var target = props && props.slot;
    if (target) {
        return this.$createElement('template', { slot: target }, nodes);
    } else {
        return nodes;
    }
}

/**
 * Runtime helper for resolving filters
 */
function resolveFilter(id) {
    return resolveAsset(this.$options, 'filters', id, true) || identity;
}

function isKeyNotMatch(expect, actual) {
    if (isArray(expect)) {
        return expect.indexOf(actual) === -1;
    } else {
        return expect !== actual;
    }
}
/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
    var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
    if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
        return isKeyNotMatch(builtInKeyName, eventKeyName);
    } else if (mappedKeyCode) {
        return isKeyNotMatch(mappedKeyCode, eventKeyCode);
    } else if (eventKeyName) {
        return hyphenate(eventKeyName) !== key;
    }
    return eventKeyCode === undefined;
}

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps(data, tag, value, asProp, isSync) {
    if (value) {
        if (!isObject(value)) {
            "production" !== 'production' && warn$2('v-bind without argument expects an Object or Array value', this);
        } else {
            if (isArray(value)) {
                value = toObject(value);
            }
            var hash = void 0;
            var _loop_1 = function _loop_1(key) {
                if (key === 'class' || key === 'style' || isReservedAttribute(key)) {
                    hash = data;
                } else {
                    var type = data.attrs && data.attrs.type;
                    hash = asProp || config.mustUseProp(tag, type, key) ? data.domProps || (data.domProps = {}) : data.attrs || (data.attrs = {});
                }
                var camelizedKey = camelize(key);
                var hyphenatedKey = hyphenate(key);
                if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
                    hash[key] = value[key];
                    if (isSync) {
                        var on = data.on || (data.on = {});
                        on["update:".concat(key)] = function ($event) {
                            value[key] = $event;
                        };
                    }
                }
            };
            for (var key in value) {
                _loop_1(key);
            }
        }
    }
    return data;
}

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic(index, isInFor) {
    var cached = this._staticTrees || (this._staticTrees = []);
    var tree = cached[index];
    // if has already-rendered static tree and not inside v-for,
    // we can reuse the same tree.
    if (tree && !isInFor) {
        return tree;
    }
    // otherwise, render a fresh tree.
    tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, this._c, this // for render fns generated for functional component templates
    );
    markStatic$1(tree, "__static__".concat(index), false);
    return tree;
}
/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce(tree, index, key) {
    markStatic$1(tree, "__once__".concat(index).concat(key ? "_".concat(key) : ""), true);
    return tree;
}
function markStatic$1(tree, key, isOnce) {
    if (isArray(tree)) {
        for (var i = 0; i < tree.length; i++) {
            if (tree[i] && typeof tree[i] !== 'string') {
                markStaticNode(tree[i], "".concat(key, "_").concat(i), isOnce);
            }
        }
    } else {
        markStaticNode(tree, key, isOnce);
    }
}
function markStaticNode(node, key, isOnce) {
    node.isStatic = true;
    node.key = key;
    node.isOnce = isOnce;
}

function bindObjectListeners(data, value) {
    if (value) {
        if (!isPlainObject(value)) {
            "production" !== 'production' && warn$2('v-on without argument expects an Object value', this);
        } else {
            var on = data.on = data.on ? extend({}, data.on) : {};
            for (var key in value) {
                var existing = on[key];
                var ours = value[key];
                on[key] = existing ? [].concat(existing, ours) : ours;
            }
        }
    }
    return data;
}

function resolveScopedSlots(fns, res,
// the following are added in 2.6
hasDynamicKeys, contentHashKey) {
    res = res || { $stable: !hasDynamicKeys };
    for (var i = 0; i < fns.length; i++) {
        var slot = fns[i];
        if (isArray(slot)) {
            resolveScopedSlots(slot, res, hasDynamicKeys);
        } else if (slot) {
            // marker for reverse proxying v-slot without scope on this.$slots
            // @ts-expect-error
            if (slot.proxy) {
                // @ts-expect-error
                slot.fn.proxy = true;
            }
            res[slot.key] = slot.fn;
        }
    }
    if (contentHashKey) {
        res.$key = contentHashKey;
    }
    return res;
}

// helper to process dynamic keys for dynamic arguments in v-bind and v-on.
function bindDynamicKeys(baseObj, values) {
    for (var i = 0; i < values.length; i += 2) {
        var key = values[i];
        if (typeof key === 'string' && key) {
            baseObj[values[i]] = values[i + 1];
        } else if (false) {
            // null is a special value for explicitly removing a binding
            warn$2("Invalid value for dynamic directive argument (expected string or null): ".concat(key), this);
        }
    }
    return baseObj;
}
// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier(value, symbol) {
    return typeof value === 'string' ? symbol + value : value;
}

function installRenderHelpers(target) {
    target._o = markOnce;
    target._n = toNumber;
    target._s = toString;
    target._l = renderList;
    target._t = renderSlot;
    target._q = looseEqual;
    target._i = looseIndexOf;
    target._m = renderStatic;
    target._f = resolveFilter;
    target._k = checkKeyCodes;
    target._b = bindObjectProps;
    target._v = createTextVNode;
    target._e = createEmptyVNode;
    target._u = resolveScopedSlots;
    target._g = bindObjectListeners;
    target._d = bindDynamicKeys;
    target._p = prependModifier;
}

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots(children, context) {
    if (!children || !children.length) {
        return {};
    }
    var slots = {};
    for (var i = 0, l = children.length; i < l; i++) {
        var child = children[i];
        var data = child.data;
        // remove slot attribute if the node is resolved as a Vue slot node
        if (data && data.attrs && data.attrs.slot) {
            delete data.attrs.slot;
        }
        // named slots should only be respected if the vnode was rendered in the
        // same context.
        if ((child.context === context || child.fnContext === context) && data && data.slot != null) {
            var name_1 = data.slot;
            var slot = slots[name_1] || (slots[name_1] = []);
            if (child.tag === 'template') {
                slot.push.apply(slot, child.children || []);
            } else {
                slot.push(child);
            }
        } else {
            (slots.default || (slots.default = [])).push(child);
        }
    }
    // ignore slots that contains only whitespace
    for (var name_2 in slots) {
        if (slots[name_2].every(isWhitespace)) {
            delete slots[name_2];
        }
    }
    return slots;
}
function isWhitespace(node) {
    return node.isComment && !node.asyncFactory || node.text === ' ';
}

function isAsyncPlaceholder(node) {
    // @ts-expect-error not really boolean type
    return node.isComment && node.asyncFactory;
}

function normalizeScopedSlots(ownerVm, scopedSlots, normalSlots, prevScopedSlots) {
    var res;
    var hasNormalSlots = Object.keys(normalSlots).length > 0;
    var isStable = scopedSlots ? !!scopedSlots.$stable : !hasNormalSlots;
    var key = scopedSlots && scopedSlots.$key;
    if (!scopedSlots) {
        res = {};
    } else if (scopedSlots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return scopedSlots._normalized;
    } else if (isStable && prevScopedSlots && prevScopedSlots !== emptyObject && key === prevScopedSlots.$key && !hasNormalSlots && !prevScopedSlots.$hasNormal) {
        // fast path 2: stable scoped slots w/ no normal slots to proxy,
        // only need to normalize once
        return prevScopedSlots;
    } else {
        res = {};
        for (var key_1 in scopedSlots) {
            if (scopedSlots[key_1] && key_1[0] !== '$') {
                res[key_1] = normalizeScopedSlot(ownerVm, normalSlots, key_1, scopedSlots[key_1]);
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key_2 in normalSlots) {
        if (!(key_2 in res)) {
            res[key_2] = proxyNormalSlot(normalSlots, key_2);
        }
    }
    // avoriaz seems to mock a non-extensible $scopedSlots object
    // and when that is passed down this would cause an error
    if (scopedSlots && Object.isExtensible(scopedSlots)) {
        scopedSlots._normalized = res;
    }
    def(res, '$stable', isStable);
    def(res, '$key', key);
    def(res, '$hasNormal', hasNormalSlots);
    return res;
}
function normalizeScopedSlot(vm, normalSlots, key, fn) {
    var normalized = function normalized() {
        var cur = currentInstance;
        setCurrentInstance(vm);
        var res = arguments.length ? fn.apply(null, arguments) : fn({});
        res = res && (typeof res === 'undefined' ? 'undefined' : _typeof(res)) === 'object' && !isArray(res) ? [res] // single vnode
        : normalizeChildren(res);
        var vnode = res && res[0];
        setCurrentInstance(cur);
        return res && (!vnode || res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode)) // #9658, #10391
        ? undefined : res;
    };
    // this is a slot using the new v-slot syntax without scope. although it is
    // compiled as a scoped slot, render fn users would expect it to be present
    // on this.$slots because the usage is semantically a normal slot.
    if (fn.proxy) {
        Object.defineProperty(normalSlots, key, {
            get: normalized,
            enumerable: true,
            configurable: true
        });
    }
    return normalized;
}
function proxyNormalSlot(slots, key) {
    return function () {
        return slots[key];
    };
}

function initSetup(vm) {
    var options = vm.$options;
    var setup = options.setup;
    if (setup) {
        var ctx = vm._setupContext = createSetupContext(vm);
        setCurrentInstance(vm);
        pushTarget();
        var setupResult = invokeWithErrorHandling(setup, null, [vm._props || shallowReactive({}), ctx], vm, "setup");
        popTarget();
        setCurrentInstance();
        if (isFunction(setupResult)) {
            // render function
            // @ts-ignore
            options.render = setupResult;
        } else if (isObject(setupResult)) {
            // bindings
            if (false) {
                warn$2("setup() should not return VNodes directly - " + "return a render function instead.");
            }
            vm._setupState = setupResult;
            // __sfc indicates compiled bindings from <script setup>
            if (!setupResult.__sfc) {
                for (var key in setupResult) {
                    if (!isReserved(key)) {
                        proxyWithRefUnwrap(vm, setupResult, key);
                    } else if (false) {
                        warn$2("Avoid using variables that start with _ or $ in setup().");
                    }
                }
            } else {
                // exposed for compiled render fn
                var proxy = vm._setupProxy = {};
                for (var key in setupResult) {
                    if (key !== '__sfc') {
                        proxyWithRefUnwrap(proxy, setupResult, key);
                    }
                }
            }
        } else if (false) {
            warn$2("setup() should return an object. Received: ".concat(setupResult === null ? 'null' : typeof setupResult === 'undefined' ? 'undefined' : _typeof(setupResult)));
        }
    }
}
function createSetupContext(vm) {
    var exposeCalled = false;
    return {
        get attrs() {
            if (!vm._attrsProxy) {
                var proxy = vm._attrsProxy = {};
                def(proxy, '_v_attr_proxy', true);
                syncSetupProxy(proxy, vm.$attrs, emptyObject, vm, '$attrs');
            }
            return vm._attrsProxy;
        },
        get listeners() {
            if (!vm._listenersProxy) {
                var proxy = vm._listenersProxy = {};
                syncSetupProxy(proxy, vm.$listeners, emptyObject, vm, '$listeners');
            }
            return vm._listenersProxy;
        },
        get slots() {
            return initSlotsProxy(vm);
        },
        emit: bind$1(vm.$emit, vm),
        expose: function expose(exposed) {
            if (false) {
                if (exposeCalled) {
                    warn$2("expose() should be called only once per setup().", vm);
                }
                exposeCalled = true;
            }
            if (exposed) {
                Object.keys(exposed).forEach(function (key) {
                    return proxyWithRefUnwrap(vm, exposed, key);
                });
            }
        }
    };
}
function syncSetupProxy(to, from, prev, instance, type) {
    var changed = false;
    for (var key in from) {
        if (!(key in to)) {
            changed = true;
            defineProxyAttr(to, key, instance, type);
        } else if (from[key] !== prev[key]) {
            changed = true;
        }
    }
    for (var key in to) {
        if (!(key in from)) {
            changed = true;
            delete to[key];
        }
    }
    return changed;
}
function defineProxyAttr(proxy, key, instance, type) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function get() {
            return instance[type][key];
        }
    });
}
function initSlotsProxy(vm) {
    if (!vm._slotsProxy) {
        syncSetupSlots(vm._slotsProxy = {}, vm.$scopedSlots);
    }
    return vm._slotsProxy;
}
function syncSetupSlots(to, from) {
    for (var key in from) {
        to[key] = from[key];
    }
    for (var key in to) {
        if (!(key in from)) {
            delete to[key];
        }
    }
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useSlots() {
    return getContext().slots;
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useAttrs() {
    return getContext().attrs;
}
/**
 * Vue 2 only
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useListeners() {
    return getContext().listeners;
}
function getContext() {
    if (false) {
        warn$2("useContext() called without active instance.");
    }
    var vm = currentInstance;
    return vm._setupContext || (vm._setupContext = createSetupContext(vm));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */
function mergeDefaults(raw, defaults) {
    var props = isArray(raw) ? raw.reduce(function (normalized, p) {
        return normalized[p] = {}, normalized;
    }, {}) : raw;
    for (var key in defaults) {
        var opt = props[key];
        if (opt) {
            if (isArray(opt) || isFunction(opt)) {
                props[key] = { type: opt, default: defaults[key] };
            } else {
                opt.default = defaults[key];
            }
        } else if (opt === null) {
            props[key] = { default: defaults[key] };
        } else if (false) {
            warn$2("props default key \"".concat(key, "\" has no corresponding declaration."));
        }
    }
    return props;
}

function initRender(vm) {
    vm._vnode = null; // the root of the child tree
    vm._staticTrees = null; // v-once cached trees
    var options = vm.$options;
    var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
    var renderContext = parentVnode && parentVnode.context;
    vm.$slots = resolveSlots(options._renderChildren, renderContext);
    vm.$scopedSlots = parentVnode ? normalizeScopedSlots(vm.$parent, parentVnode.data.scopedSlots, vm.$slots) : emptyObject;
    // bind the createElement fn to this instance
    // so that we get proper render context inside it.
    // args order: tag, data, children, normalizationType, alwaysNormalize
    // internal version is used by render functions compiled from templates
    // @ts-expect-error
    vm._c = function (a, b, c, d) {
        return createElement$1(vm, a, b, c, d, false);
    };
    // normalization is always applied for the public version, used in
    // user-written render functions.
    // @ts-expect-error
    vm.$createElement = function (a, b, c, d) {
        return createElement$1(vm, a, b, c, d, true);
    };
    // $attrs & $listeners are exposed for easier HOC creation.
    // they need to be reactive so that HOCs using them are always updated
    var parentData = parentVnode && parentVnode.data;
    /* istanbul ignore else */
    if (false) {
        defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
            !isUpdatingChildComponent && warn$2("$attrs is readonly.", vm);
        }, true);
        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
            !isUpdatingChildComponent && warn$2("$listeners is readonly.", vm);
        }, true);
    } else {
        defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
    }
}
var currentRenderingInstance = null;
function renderMixin(Vue) {
    // install runtime convenience helpers
    installRenderHelpers(Vue.prototype);
    Vue.prototype.$nextTick = function (fn) {
        return nextTick(fn, this);
    };
    Vue.prototype._render = function () {
        var vm = this;
        var _a = vm.$options,
            render = _a.render,
            _parentVnode = _a._parentVnode;
        if (_parentVnode && vm._isMounted) {
            vm.$scopedSlots = normalizeScopedSlots(vm.$parent, _parentVnode.data.scopedSlots, vm.$slots, vm.$scopedSlots);
            if (vm._slotsProxy) {
                syncSetupSlots(vm._slotsProxy, vm.$scopedSlots);
            }
        }
        // set parent vnode. this allows render functions to have access
        // to the data on the placeholder node.
        vm.$vnode = _parentVnode;
        // render self
        var prevInst = currentInstance;
        var prevRenderInst = currentRenderingInstance;
        var vnode;
        try {
            setCurrentInstance(vm);
            currentRenderingInstance = vm;
            vnode = render.call(vm._renderProxy, vm.$createElement);
        } catch (e) {
            handleError(e, vm, "render");
            // return error render result,
            // or previous vnode to prevent render error causing blank component
            /* istanbul ignore else */
            if (false) {
                try {
                    vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
                } catch (e) {
                    handleError(e, vm, "renderError");
                    vnode = vm._vnode;
                }
            } else {
                vnode = vm._vnode;
            }
        } finally {
            currentRenderingInstance = prevRenderInst;
            setCurrentInstance(prevInst);
        }
        // if the returned array contains only a single node, allow it
        if (isArray(vnode) && vnode.length === 1) {
            vnode = vnode[0];
        }
        // return empty vnode in case the render function errored out
        if (!(vnode instanceof VNode)) {
            if (false) {
                warn$2('Multiple root nodes returned from render function. Render function ' + 'should return a single root node.', vm);
            }
            vnode = createEmptyVNode();
        }
        // set parent
        vnode.parent = _parentVnode;
        return vnode;
    };
}

function ensureCtor(comp, base) {
    if (comp.__esModule || hasSymbol && comp[Symbol.toStringTag] === 'Module') {
        comp = comp.default;
    }
    return isObject(comp) ? base.extend(comp) : comp;
}
function createAsyncPlaceholder(factory, data, context, children, tag) {
    var node = createEmptyVNode();
    node.asyncFactory = factory;
    node.asyncMeta = { data: data, context: context, children: children, tag: tag };
    return node;
}
function resolveAsyncComponent(factory, baseCtor) {
    if (isTrue(factory.error) && isDef(factory.errorComp)) {
        return factory.errorComp;
    }
    if (isDef(factory.resolved)) {
        return factory.resolved;
    }
    var owner = currentRenderingInstance;
    if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
        // already pending
        factory.owners.push(owner);
    }
    if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
        return factory.loadingComp;
    }
    if (owner && !isDef(factory.owners)) {
        var owners_1 = factory.owners = [owner];
        var sync_1 = true;
        var timerLoading_1 = null;
        var timerTimeout_1 = null;
        owner.$on('hook:destroyed', function () {
            return remove$2(owners_1, owner);
        });
        var forceRender_1 = function forceRender_1(renderCompleted) {
            for (var i = 0, l = owners_1.length; i < l; i++) {
                owners_1[i].$forceUpdate();
            }
            if (renderCompleted) {
                owners_1.length = 0;
                if (timerLoading_1 !== null) {
                    clearTimeout(timerLoading_1);
                    timerLoading_1 = null;
                }
                if (timerTimeout_1 !== null) {
                    clearTimeout(timerTimeout_1);
                    timerTimeout_1 = null;
                }
            }
        };
        var resolve = once(function (res) {
            // cache resolved
            factory.resolved = ensureCtor(res, baseCtor);
            // invoke callbacks only if this is not a synchronous resolve
            // (async resolves are shimmed as synchronous during SSR)
            if (!sync_1) {
                forceRender_1(true);
            } else {
                owners_1.length = 0;
            }
        });
        var reject_1 = once(function (reason) {
            "production" !== 'production' && warn$2("Failed to resolve async component: ".concat(String(factory)) + (reason ? "\nReason: ".concat(reason) : ''));
            if (isDef(factory.errorComp)) {
                factory.error = true;
                forceRender_1(true);
            }
        });
        var res_1 = factory(resolve, reject_1);
        if (isObject(res_1)) {
            if (isPromise(res_1)) {
                // () => Promise
                if (isUndef(factory.resolved)) {
                    res_1.then(resolve, reject_1);
                }
            } else if (isPromise(res_1.component)) {
                res_1.component.then(resolve, reject_1);
                if (isDef(res_1.error)) {
                    factory.errorComp = ensureCtor(res_1.error, baseCtor);
                }
                if (isDef(res_1.loading)) {
                    factory.loadingComp = ensureCtor(res_1.loading, baseCtor);
                    if (res_1.delay === 0) {
                        factory.loading = true;
                    } else {
                        // @ts-expect-error NodeJS timeout type
                        timerLoading_1 = setTimeout(function () {
                            timerLoading_1 = null;
                            if (isUndef(factory.resolved) && isUndef(factory.error)) {
                                factory.loading = true;
                                forceRender_1(false);
                            }
                        }, res_1.delay || 200);
                    }
                }
                if (isDef(res_1.timeout)) {
                    // @ts-expect-error NodeJS timeout type
                    timerTimeout_1 = setTimeout(function () {
                        timerTimeout_1 = null;
                        if (isUndef(factory.resolved)) {
                            reject_1( false ? "timeout (".concat(res_1.timeout, "ms)") : null);
                        }
                    }, res_1.timeout);
                }
            }
        }
        sync_1 = false;
        // return in case resolved synchronously
        return factory.loading ? factory.loadingComp : factory.resolved;
    }
}

function getFirstComponentChild(children) {
    if (isArray(children)) {
        for (var i = 0; i < children.length; i++) {
            var c = children[i];
            if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
                return c;
            }
        }
    }
}

function initEvents(vm) {
    vm._events = Object.create(null);
    vm._hasHookEvent = false;
    // init parent attached events
    var listeners = vm.$options._parentListeners;
    if (listeners) {
        updateComponentListeners(vm, listeners);
    }
}
var target$1;
function add$1(event, fn) {
    target$1.$on(event, fn);
}
function remove$1(event, fn) {
    target$1.$off(event, fn);
}
function createOnceHandler$1(event, fn) {
    var _target = target$1;
    return function onceHandler() {
        var res = fn.apply(null, arguments);
        if (res !== null) {
            _target.$off(event, onceHandler);
        }
    };
}
function updateComponentListeners(vm, listeners, oldListeners) {
    target$1 = vm;
    updateListeners(listeners, oldListeners || {}, add$1, remove$1, createOnceHandler$1, vm);
    target$1 = undefined;
}
function eventsMixin(Vue) {
    var hookRE = /^hook:/;
    Vue.prototype.$on = function (event, fn) {
        var vm = this;
        if (isArray(event)) {
            for (var i = 0, l = event.length; i < l; i++) {
                vm.$on(event[i], fn);
            }
        } else {
            (vm._events[event] || (vm._events[event] = [])).push(fn);
            // optimize hook:event cost by using a boolean flag marked at registration
            // instead of a hash lookup
            if (hookRE.test(event)) {
                vm._hasHookEvent = true;
            }
        }
        return vm;
    };
    Vue.prototype.$once = function (event, fn) {
        var vm = this;
        function on() {
            vm.$off(event, on);
            fn.apply(vm, arguments);
        }
        on.fn = fn;
        vm.$on(event, on);
        return vm;
    };
    Vue.prototype.$off = function (event, fn) {
        var vm = this;
        // all
        if (!arguments.length) {
            vm._events = Object.create(null);
            return vm;
        }
        // array of events
        if (isArray(event)) {
            for (var i_1 = 0, l = event.length; i_1 < l; i_1++) {
                vm.$off(event[i_1], fn);
            }
            return vm;
        }
        // specific event
        var cbs = vm._events[event];
        if (!cbs) {
            return vm;
        }
        if (!fn) {
            vm._events[event] = null;
            return vm;
        }
        // specific handler
        var cb;
        var i = cbs.length;
        while (i--) {
            cb = cbs[i];
            if (cb === fn || cb.fn === fn) {
                cbs.splice(i, 1);
                break;
            }
        }
        return vm;
    };
    Vue.prototype.$emit = function (event) {
        var vm = this;
        if (false) {
            var lowerCaseEvent = event.toLowerCase();
            if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
                tip("Event \"".concat(lowerCaseEvent, "\" is emitted in component ") + "".concat(formatComponentName(vm), " but the handler is registered for \"").concat(event, "\". ") + "Note that HTML attributes are case-insensitive and you cannot use " + "v-on to listen to camelCase events when using in-DOM templates. " + "You should probably use \"".concat(hyphenate(event), "\" instead of \"").concat(event, "\"."));
            }
        }
        var cbs = vm._events[event];
        if (cbs) {
            cbs = cbs.length > 1 ? toArray(cbs) : cbs;
            var args = toArray(arguments, 1);
            var info = "event handler for \"".concat(event, "\"");
            for (var i = 0, l = cbs.length; i < l; i++) {
                invokeWithErrorHandling(cbs[i], vm, args, vm, info);
            }
        }
        return vm;
    };
}

var activeEffectScope;
var EffectScope = /** @class */function () {
    function EffectScope(detached) {
        if (detached === void 0) {
            detached = false;
        }
        this.detached = detached;
        /**
         * @internal
         */
        this.active = true;
        /**
         * @internal
         */
        this.effects = [];
        /**
         * @internal
         */
        this.cleanups = [];
        this.parent = activeEffectScope;
        if (!detached && activeEffectScope) {
            this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
        }
    }
    EffectScope.prototype.run = function (fn) {
        if (this.active) {
            var currentEffectScope = activeEffectScope;
            try {
                activeEffectScope = this;
                return fn();
            } finally {
                activeEffectScope = currentEffectScope;
            }
        } else if (false) {
            warn$2("cannot run an inactive effect scope.");
        }
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.on = function () {
        activeEffectScope = this;
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.off = function () {
        activeEffectScope = this.parent;
    };
    EffectScope.prototype.stop = function (fromParent) {
        if (this.active) {
            var i = void 0,
                l = void 0;
            for (i = 0, l = this.effects.length; i < l; i++) {
                this.effects[i].teardown();
            }
            for (i = 0, l = this.cleanups.length; i < l; i++) {
                this.cleanups[i]();
            }
            if (this.scopes) {
                for (i = 0, l = this.scopes.length; i < l; i++) {
                    this.scopes[i].stop(true);
                }
            }
            // nested scope, dereference from parent to avoid memory leaks
            if (!this.detached && this.parent && !fromParent) {
                // optimized O(1) removal
                var last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = undefined;
            this.active = false;
        }
    };
    return EffectScope;
}();
function effectScope(detached) {
    return new EffectScope(detached);
}
/**
 * @internal
 */
function recordEffectScope(effect, scope) {
    if (scope === void 0) {
        scope = activeEffectScope;
    }
    if (scope && scope.active) {
        scope.effects.push(effect);
    }
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    } else if (false) {
        warn$2("onScopeDispose() is called when there is no active effect scope" + " to be associated with.");
    }
}

var activeInstance = null;
var isUpdatingChildComponent = false;
function setActiveInstance(vm) {
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    return function () {
        activeInstance = prevActiveInstance;
    };
}
function initLifecycle(vm) {
    var options = vm.$options;
    // locate first non-abstract parent
    var parent = options.parent;
    if (parent && !options.abstract) {
        while (parent.$options.abstract && parent.$parent) {
            parent = parent.$parent;
        }
        parent.$children.push(vm);
    }
    vm.$parent = parent;
    vm.$root = parent ? parent.$root : vm;
    vm.$children = [];
    vm.$refs = {};
    vm._provided = parent ? parent._provided : Object.create(null);
    vm._watcher = null;
    vm._inactive = null;
    vm._directInactive = false;
    vm._isMounted = false;
    vm._isDestroyed = false;
    vm._isBeingDestroyed = false;
}
function lifecycleMixin(Vue) {
    Vue.prototype._update = function (vnode, hydrating) {
        var vm = this;
        var prevEl = vm.$el;
        var prevVnode = vm._vnode;
        var restoreActiveInstance = setActiveInstance(vm);
        vm._vnode = vnode;
        // Vue.prototype.__patch__ is injected in entry points
        // based on the rendering backend used.
        if (!prevVnode) {
            // initial render
            vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
        } else {
            // updates
            vm.$el = vm.__patch__(prevVnode, vnode);
        }
        restoreActiveInstance();
        // update __vue__ reference
        if (prevEl) {
            prevEl.__vue__ = null;
        }
        if (vm.$el) {
            vm.$el.__vue__ = vm;
        }
        // if parent is an HOC, update its $el as well
        var wrapper = vm;
        while (wrapper && wrapper.$vnode && wrapper.$parent && wrapper.$vnode === wrapper.$parent._vnode) {
            wrapper.$parent.$el = wrapper.$el;
            wrapper = wrapper.$parent;
        }
        // updated hook is called by the scheduler to ensure that children are
        // updated in a parent's updated hook.
    };
    Vue.prototype.$forceUpdate = function () {
        var vm = this;
        if (vm._watcher) {
            vm._watcher.update();
        }
    };
    Vue.prototype.$destroy = function () {
        var vm = this;
        if (vm._isBeingDestroyed) {
            return;
        }
        callHook$1(vm, 'beforeDestroy');
        vm._isBeingDestroyed = true;
        // remove self from parent
        var parent = vm.$parent;
        if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
            remove$2(parent.$children, vm);
        }
        // teardown scope. this includes both the render watcher and other
        // watchers created
        vm._scope.stop();
        // remove reference from data ob
        // frozen object may not have observer.
        if (vm._data.__ob__) {
            vm._data.__ob__.vmCount--;
        }
        // call the last hook...
        vm._isDestroyed = true;
        // invoke destroy hooks on current rendered tree
        vm.__patch__(vm._vnode, null);
        // fire destroyed hook
        callHook$1(vm, 'destroyed');
        // turn off all instance listeners.
        vm.$off();
        // remove __vue__ reference
        if (vm.$el) {
            vm.$el.__vue__ = null;
        }
        // release circular reference (#6759)
        if (vm.$vnode) {
            vm.$vnode.parent = null;
        }
    };
}
function mountComponent(vm, el, hydrating) {
    vm.$el = el;
    if (!vm.$options.render) {
        // @ts-expect-error invalid type
        vm.$options.render = createEmptyVNode;
        if (false) {
            /* istanbul ignore if */
            if (vm.$options.template && vm.$options.template.charAt(0) !== '#' || vm.$options.el || el) {
                warn$2('You are using the runtime-only build of Vue where the template ' + 'compiler is not available. Either pre-compile the templates into ' + 'render functions, or use the compiler-included build.', vm);
            } else {
                warn$2('Failed to mount component: template or render function not defined.', vm);
            }
        }
    }
    callHook$1(vm, 'beforeMount');
    var updateComponent;
    /* istanbul ignore if */
    if (false) {
        updateComponent = function updateComponent() {
            var name = vm._name;
            var id = vm._uid;
            var startTag = "vue-perf-start:".concat(id);
            var endTag = "vue-perf-end:".concat(id);
            mark(startTag);
            var vnode = vm._render();
            mark(endTag);
            measure("vue ".concat(name, " render"), startTag, endTag);
            mark(startTag);
            vm._update(vnode, hydrating);
            mark(endTag);
            measure("vue ".concat(name, " patch"), startTag, endTag);
        };
    } else {
        updateComponent = function updateComponent() {
            vm._update(vm._render(), hydrating);
        };
    }
    var watcherOptions = {
        before: function before() {
            if (vm._isMounted && !vm._isDestroyed) {
                callHook$1(vm, 'beforeUpdate');
            }
        }
    };
    if (false) {
        watcherOptions.onTrack = function (e) {
            return callHook$1(vm, 'renderTracked', [e]);
        };
        watcherOptions.onTrigger = function (e) {
            return callHook$1(vm, 'renderTriggered', [e]);
        };
    }
    // we set this to vm._watcher inside the watcher's constructor
    // since the watcher's initial patch may call $forceUpdate (e.g. inside child
    // component's mounted hook), which relies on vm._watcher being already defined
    new Watcher(vm, updateComponent, noop, watcherOptions, true /* isRenderWatcher */);
    hydrating = false;
    // flush buffer for flush: "pre" watchers queued in setup()
    var preWatchers = vm._preWatchers;
    if (preWatchers) {
        for (var i = 0; i < preWatchers.length; i++) {
            preWatchers[i].run();
        }
    }
    // manually mounted instance, call mounted on self
    // mounted is called for render-created child components in its inserted hook
    if (vm.$vnode == null) {
        vm._isMounted = true;
        callHook$1(vm, 'mounted');
    }
    return vm;
}
function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
    if (false) {
        isUpdatingChildComponent = true;
    }
    // determine whether component has slot children
    // we need to do this before overwriting $options._renderChildren.
    // check if there are dynamic scopedSlots (hand-written or compiled but with
    // dynamic slot names). Static scoped slots compiled from template has the
    // "$stable" marker.
    var newScopedSlots = parentVnode.data.scopedSlots;
    var oldScopedSlots = vm.$scopedSlots;
    var hasDynamicScopedSlot = !!(newScopedSlots && !newScopedSlots.$stable || oldScopedSlots !== emptyObject && !oldScopedSlots.$stable || newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key || !newScopedSlots && vm.$scopedSlots.$key);
    // Any static slot children from the parent may have changed during parent's
    // update. Dynamic scoped slots may also have changed. In such cases, a forced
    // update is necessary to ensure correctness.
    var needsForceUpdate = !!(renderChildren || // has new static slots
    vm.$options._renderChildren || // has old static slots
    hasDynamicScopedSlot);
    var prevVNode = vm.$vnode;
    vm.$options._parentVnode = parentVnode;
    vm.$vnode = parentVnode; // update vm's placeholder node without re-render
    if (vm._vnode) {
        // update child tree's parent
        vm._vnode.parent = parentVnode;
    }
    vm.$options._renderChildren = renderChildren;
    // update $attrs and $listeners hash
    // these are also reactive so they may trigger child update if the child
    // used them during render
    var attrs = parentVnode.data.attrs || emptyObject;
    if (vm._attrsProxy) {
        // force update if attrs are accessed and has changed since it may be
        // passed to a child component.
        if (syncSetupProxy(vm._attrsProxy, attrs, prevVNode.data && prevVNode.data.attrs || emptyObject, vm, '$attrs')) {
            needsForceUpdate = true;
        }
    }
    vm.$attrs = attrs;
    // update listeners
    listeners = listeners || emptyObject;
    var prevListeners = vm.$options._parentListeners;
    if (vm._listenersProxy) {
        syncSetupProxy(vm._listenersProxy, listeners, prevListeners || emptyObject, vm, '$listeners');
    }
    vm.$listeners = vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, prevListeners);
    // update props
    if (propsData && vm.$options.props) {
        toggleObserving(false);
        var props = vm._props;
        var propKeys = vm.$options._propKeys || [];
        for (var i = 0; i < propKeys.length; i++) {
            var key = propKeys[i];
            var propOptions = vm.$options.props; // wtf flow?
            props[key] = validateProp(key, propOptions, propsData, vm);
        }
        toggleObserving(true);
        // keep a copy of raw propsData
        vm.$options.propsData = propsData;
    }
    // resolve slots + force update if has children
    if (needsForceUpdate) {
        vm.$slots = resolveSlots(renderChildren, parentVnode.context);
        vm.$forceUpdate();
    }
    if (false) {
        isUpdatingChildComponent = false;
    }
}
function isInInactiveTree(vm) {
    while (vm && (vm = vm.$parent)) {
        if (vm._inactive) return true;
    }
    return false;
}
function activateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = false;
        if (isInInactiveTree(vm)) {
            return;
        }
    } else if (vm._directInactive) {
        return;
    }
    if (vm._inactive || vm._inactive === null) {
        vm._inactive = false;
        for (var i = 0; i < vm.$children.length; i++) {
            activateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'activated');
    }
}
function deactivateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = true;
        if (isInInactiveTree(vm)) {
            return;
        }
    }
    if (!vm._inactive) {
        vm._inactive = true;
        for (var i = 0; i < vm.$children.length; i++) {
            deactivateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'deactivated');
    }
}
function callHook$1(vm, hook, args, setContext) {
    if (setContext === void 0) {
        setContext = true;
    }
    // #7573 disable dep collection when invoking lifecycle hooks
    pushTarget();
    var prevInst = currentInstance;
    var prevScope = getCurrentScope();
    setContext && setCurrentInstance(vm);
    var handlers = vm.$options[hook];
    var info = "".concat(hook, " hook");
    if (handlers) {
        for (var i = 0, j = handlers.length; i < j; i++) {
            invokeWithErrorHandling(handlers[i], vm, args || null, vm, info);
        }
    }
    if (vm._hasHookEvent) {
        vm.$emit('hook:' + hook);
    }
    if (setContext) {
        setCurrentInstance(prevInst);
        prevScope && prevScope.on();
    }
    popTarget();
}

var MAX_UPDATE_COUNT = 100;
var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index$1 = 0;
/**
 * Reset the scheduler's state.
 */
function resetSchedulerState() {
    index$1 = queue.length = activatedChildren.length = 0;
    has = {};
    if (false) {
        circular = {};
    }
    waiting = flushing = false;
}
// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;
// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;
// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
    var performance_1 = window.performance;
    if (performance_1 && typeof performance_1.now === 'function' && getNow() > document.createEvent('Event').timeStamp) {
        // if the event timestamp, although evaluated AFTER the Date.now(), is
        // smaller than it, it means the event is using a hi-res timestamp,
        // and we need to use the hi-res version for event listener timestamps as
        // well.
        getNow = function getNow() {
            return performance_1.now();
        };
    }
}
var sortCompareFn = function sortCompareFn(a, b) {
    if (a.post) {
        if (!b.post) return 1;
    } else if (b.post) {
        return -1;
    }
    return a.id - b.id;
};
/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue() {
    currentFlushTimestamp = getNow();
    flushing = true;
    var watcher, id;
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child)
    // 2. A component's user watchers are run before its render watcher (because
    //    user watchers are created before the render watcher)
    // 3. If a component is destroyed during a parent component's watcher run,
    //    its watchers can be skipped.
    queue.sort(sortCompareFn);
    // do not cache length because more watchers might be pushed
    // as we run existing watchers
    for (index$1 = 0; index$1 < queue.length; index$1++) {
        watcher = queue[index$1];
        if (watcher.before) {
            watcher.before();
        }
        id = watcher.id;
        has[id] = null;
        watcher.run();
        // in dev build, check and stop circular updates.
        if (false) {
            circular[id] = (circular[id] || 0) + 1;
            if (circular[id] > MAX_UPDATE_COUNT) {
                warn$2('You may have an infinite update loop ' + (watcher.user ? "in watcher with expression \"".concat(watcher.expression, "\"") : "in a component render function."), watcher.vm);
                break;
            }
        }
    }
    // keep copies of post queues before resetting state
    var activatedQueue = activatedChildren.slice();
    var updatedQueue = queue.slice();
    resetSchedulerState();
    // call component updated and activated hooks
    callActivatedHooks(activatedQueue);
    callUpdatedHooks(updatedQueue);
    cleanupDeps();
    // devtool hook
    /* istanbul ignore if */
    if (devtools && config.devtools) {
        devtools.emit('flush');
    }
}
function callUpdatedHooks(queue) {
    var i = queue.length;
    while (i--) {
        var watcher = queue[i];
        var vm = watcher.vm;
        if (vm && vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
            callHook$1(vm, 'updated');
        }
    }
}
/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent(vm) {
    // setting _inactive to false here so that a render function can
    // rely on checking whether it's in an inactive tree (e.g. router-view)
    vm._inactive = false;
    activatedChildren.push(vm);
}
function callActivatedHooks(queue) {
    for (var i = 0; i < queue.length; i++) {
        queue[i]._inactive = true;
        activateChildComponent(queue[i], true /* true */);
    }
}
/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher(watcher) {
    var id = watcher.id;
    if (has[id] != null) {
        return;
    }
    if (watcher === Dep.target && watcher.noRecurse) {
        return;
    }
    has[id] = true;
    if (!flushing) {
        queue.push(watcher);
    } else {
        // if already flushing, splice the watcher based on its id
        // if already past its id, it will be run next immediately.
        var i = queue.length - 1;
        while (i > index$1 && queue[i].id > watcher.id) {
            i--;
        }
        queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
        waiting = true;
        if (false) {
            flushSchedulerQueue();
            return;
        }
        nextTick(flushSchedulerQueue);
    }
}

var WATCHER = "watcher";
var WATCHER_CB = "".concat(WATCHER, " callback");
var WATCHER_GETTER = "".concat(WATCHER, " getter");
var WATCHER_CLEANUP = "".concat(WATCHER, " cleanup");
// Simple effect.
function watchEffect(effect, options) {
    return doWatch(effect, null, options);
}
function watchPostEffect(effect, options) {
    return doWatch(effect, null,  false ? _assign(_assign({}, options), { flush: 'post' }) : { flush: 'post' });
}
function watchSyncEffect(effect, options) {
    return doWatch(effect, null,  false ? _assign(_assign({}, options), { flush: 'sync' }) : { flush: 'sync' });
}
// initial value for watchers to trigger on undefined initial values
var INITIAL_WATCHER_VALUE = {};
// implementation
function watch(source, cb, options) {
    if (false) {
        warn$2("`watch(fn, options?)` signature has been moved to a separate API. " + "Use `watchEffect(fn, options?)` instead. `watch` now only " + "supports `watch(source, cb, options?) signature.");
    }
    return doWatch(source, cb, options);
}
function doWatch(source, cb, _a) {
    var _b = _a === void 0 ? emptyObject : _a,
        immediate = _b.immediate,
        deep = _b.deep,
        _c = _b.flush,
        flush = _c === void 0 ? 'pre' : _c,
        onTrack = _b.onTrack,
        onTrigger = _b.onTrigger;
    if (false) {
        if (immediate !== undefined) {
            warn$2("watch() \"immediate\" option is only respected when using the " + "watch(source, callback, options?) signature.");
        }
        if (deep !== undefined) {
            warn$2("watch() \"deep\" option is only respected when using the " + "watch(source, callback, options?) signature.");
        }
    }
    var warnInvalidSource = function warnInvalidSource(s) {
        warn$2("Invalid watch source: ".concat(s, ". A watch source can only be a getter/effect ") + "function, a ref, a reactive object, or an array of these types.");
    };
    var instance = currentInstance;
    var call = function call(fn, type, args) {
        if (args === void 0) {
            args = null;
        }
        var res = invokeWithErrorHandling(fn, null, args, instance, type);
        if (deep && res && res.__ob__) res.__ob__.dep.depend();
        return res;
    };
    var getter;
    var forceTrigger = false;
    var isMultiSource = false;
    if (isRef(source)) {
        getter = function getter() {
            return source.value;
        };
        forceTrigger = isShallow(source);
    } else if (isReactive(source)) {
        getter = function getter() {
            source.__ob__.dep.depend();
            return source;
        };
        deep = true;
    } else if (isArray(source)) {
        isMultiSource = true;
        forceTrigger = source.some(function (s) {
            return isReactive(s) || isShallow(s);
        });
        getter = function getter() {
            return source.map(function (s) {
                if (isRef(s)) {
                    return s.value;
                } else if (isReactive(s)) {
                    s.__ob__.dep.depend();
                    return traverse(s);
                } else if (isFunction(s)) {
                    return call(s, WATCHER_GETTER);
                } else {
                    "production" !== 'production' && warnInvalidSource(s);
                }
            });
        };
    } else if (isFunction(source)) {
        if (cb) {
            // getter with cb
            getter = function getter() {
                return call(source, WATCHER_GETTER);
            };
        } else {
            // no cb -> simple effect
            getter = function getter() {
                if (instance && instance._isDestroyed) {
                    return;
                }
                if (cleanup) {
                    cleanup();
                }
                return call(source, WATCHER, [onCleanup]);
            };
        }
    } else {
        getter = noop;
        "production" !== 'production' && warnInvalidSource(source);
    }
    if (cb && deep) {
        var baseGetter_1 = getter;
        getter = function getter() {
            return traverse(baseGetter_1());
        };
    }
    var cleanup;
    var onCleanup = function onCleanup(fn) {
        cleanup = watcher.onStop = function () {
            call(fn, WATCHER_CLEANUP);
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if (isServerRendering()) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onCleanup = noop;
        if (!cb) {
            getter();
        } else if (immediate) {
            call(cb, WATCHER_CB, [getter(), isMultiSource ? [] : undefined, onCleanup]);
        }
        return noop;
    }
    var watcher = new Watcher(currentInstance, getter, noop, {
        lazy: true
    });
    watcher.noRecurse = !cb;
    var oldValue = isMultiSource ? [] : INITIAL_WATCHER_VALUE;
    // overwrite default run
    watcher.run = function () {
        if (!watcher.active) {
            return;
        }
        if (cb) {
            // watch(source, cb)
            var newValue = watcher.get();
            if (deep || forceTrigger || (isMultiSource ? newValue.some(function (v, i) {
                return hasChanged(v, oldValue[i]);
            }) : hasChanged(newValue, oldValue))) {
                // cleanup before running cb again
                if (cleanup) {
                    cleanup();
                }
                call(cb, WATCHER_CB, [newValue,
                // pass undefined as the old value when it's changed for the first time
                oldValue === INITIAL_WATCHER_VALUE ? undefined : oldValue, onCleanup]);
                oldValue = newValue;
            }
        } else {
            // watchEffect
            watcher.get();
        }
    };
    if (flush === 'sync') {
        watcher.update = watcher.run;
    } else if (flush === 'post') {
        watcher.post = true;
        watcher.update = function () {
            return queueWatcher(watcher);
        };
    } else {
        // pre
        watcher.update = function () {
            if (instance && instance === currentInstance && !instance._isMounted) {
                // pre-watcher triggered before
                var buffer = instance._preWatchers || (instance._preWatchers = []);
                if (buffer.indexOf(watcher) < 0) buffer.push(watcher);
            } else {
                queueWatcher(watcher);
            }
        };
    }
    if (false) {
        watcher.onTrack = onTrack;
        watcher.onTrigger = onTrigger;
    }
    // initial run
    if (cb) {
        if (immediate) {
            watcher.run();
        } else {
            oldValue = watcher.get();
        }
    } else if (flush === 'post' && instance) {
        instance.$once('hook:mounted', function () {
            return watcher.get();
        });
    } else {
        watcher.get();
    }
    return function () {
        watcher.teardown();
    };
}

function provide(key, value) {
    if (!currentInstance) {
        if (false) {
            warn$2("provide() can only be used inside setup().");
        }
    } else {
        // TS doesn't allow symbol as index type
        resolveProvided(currentInstance)[key] = value;
    }
}
function resolveProvided(vm) {
    // by default an instance inherits its parent's provides object
    // but when it needs to provide values of its own, it creates its
    // own provides object using parent provides object as prototype.
    // this way in `inject` we can simply look up injections from direct
    // parent and let the prototype chain do the work.
    var existing = vm._provided;
    var parentProvides = vm.$parent && vm.$parent._provided;
    if (parentProvides === existing) {
        return vm._provided = Object.create(parentProvides);
    } else {
        return existing;
    }
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    if (treatDefaultAsFactory === void 0) {
        treatDefaultAsFactory = false;
    }
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    var instance = currentInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the instance is at root
        var provides = instance.$parent && instance.$parent._provided;
        if (provides && key in provides) {
            // TS doesn't allow symbol as index type
            return provides[key];
        } else if (arguments.length > 1) {
            return treatDefaultAsFactory && isFunction(defaultValue) ? defaultValue.call(instance) : defaultValue;
        } else if (false) {
            warn$2("injection \"".concat(String(key), "\" not found."));
        }
    } else if (false) {
        warn$2("inject() can only be used inside setup() or functional components.");
    }
}

/**
 * @internal this function needs manual public type declaration because it relies
 * on previously manually authored types from Vue 2
 */
function h(type, props, children) {
    if (!currentInstance) {
        "production" !== 'production' && warn$2("globally imported h() can only be invoked when there is an active " + "component instance, e.g. synchronously in a component's render or setup function.");
    }
    return createElement$1(currentInstance, type, props, children, 2, true);
}

function handleError(err, vm, info) {
    // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
    // See: https://github.com/vuejs/vuex/issues/1505
    pushTarget();
    try {
        if (vm) {
            var cur = vm;
            while (cur = cur.$parent) {
                var hooks = cur.$options.errorCaptured;
                if (hooks) {
                    for (var i = 0; i < hooks.length; i++) {
                        try {
                            var capture = hooks[i].call(cur, err, vm, info) === false;
                            if (capture) return;
                        } catch (e) {
                            globalHandleError(e, cur, 'errorCaptured hook');
                        }
                    }
                }
            }
        }
        globalHandleError(err, vm, info);
    } finally {
        popTarget();
    }
}
function invokeWithErrorHandling(handler, context, args, vm, info) {
    var res;
    try {
        res = args ? handler.apply(context, args) : handler.call(context);
        if (res && !res._isVue && isPromise(res) && !res._handled) {
            res.catch(function (e) {
                return handleError(e, vm, info + " (Promise/async)");
            });
            res._handled = true;
        }
    } catch (e) {
        handleError(e, vm, info);
    }
    return res;
}
function globalHandleError(err, vm, info) {
    if (config.errorHandler) {
        try {
            return config.errorHandler.call(null, err, vm, info);
        } catch (e) {
            // if the user intentionally throws the original error in the handler,
            // do not log it twice
            if (e !== err) {
                logError(e, null, 'config.errorHandler');
            }
        }
    }
    logError(err, vm, info);
}
function logError(err, vm, info) {
    if (false) {
        warn$2("Error in ".concat(info, ": \"").concat(err.toString(), "\""), vm);
    }
    /* istanbul ignore else */
    if (inBrowser && typeof console !== 'undefined') {
        console.error(err);
    } else {
        throw err;
    }
}

/* globals MutationObserver */
var isUsingMicroTask = false;
var callbacks = [];
var pending = false;
function flushCallbacks() {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
        copies[i]();
    }
}
// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;
// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p_1 = Promise.resolve();
    timerFunc = function timerFunc() {
        p_1.then(flushCallbacks);
        // In problematic UIWebViews, Promise.then doesn't completely break, but
        // it can get stuck in a weird state where callbacks are pushed into the
        // microtask queue but the queue isn't being flushed, until the browser
        // needs to do some other work, e.g. handle a timer. Therefore we can
        // "force" the microtask queue to be flushed by adding an empty timer.
        if (isIOS) setTimeout(noop);
    };
    isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (isNative(MutationObserver) ||
// PhantomJS and iOS 7.x
MutationObserver.toString() === '[object MutationObserverConstructor]')) {
    // Use MutationObserver where native Promise is not available,
    // e.g. PhantomJS, iOS7, Android 4.4
    // (#6466 MutationObserver is unreliable in IE11)
    var counter_1 = 1;
    var observer = new MutationObserver(flushCallbacks);
    var textNode_1 = document.createTextNode(String(counter_1));
    observer.observe(textNode_1, {
        characterData: true
    });
    timerFunc = function timerFunc() {
        counter_1 = (counter_1 + 1) % 2;
        textNode_1.data = String(counter_1);
    };
    isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
    // Fallback to setImmediate.
    // Technically it leverages the (macro) task queue,
    // but it is still a better choice than setTimeout.
    timerFunc = function timerFunc() {
        setImmediate(flushCallbacks);
    };
} else {
    // Fallback to setTimeout.
    timerFunc = function timerFunc() {
        setTimeout(flushCallbacks, 0);
    };
}
/**
 * @internal
 */
function nextTick(cb, ctx) {
    var _resolve;
    callbacks.push(function () {
        if (cb) {
            try {
                cb.call(ctx);
            } catch (e) {
                handleError(e, ctx, 'nextTick');
            }
        } else if (_resolve) {
            _resolve(ctx);
        }
    });
    if (!pending) {
        pending = true;
        timerFunc();
    }
    // $flow-disable-line
    if (!cb && typeof Promise !== 'undefined') {
        return new Promise(function (resolve) {
            _resolve = resolve;
        });
    }
}

function useCssModule(name) {
    if (name === void 0) {
        name = '$style';
    }
    /* istanbul ignore else */
    {
        if (!currentInstance) {
            "production" !== 'production' && warn$2("useCssModule must be called inside setup()");
            return emptyObject;
        }
        var mod = currentInstance[name];
        if (!mod) {
            "production" !== 'production' && warn$2("Current instance does not have CSS module named \"".concat(name, "\"."));
            return emptyObject;
        }
        return mod;
    }
}

/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */
function useCssVars(getter) {
    if (!inBrowser && !false) return;
    var instance = currentInstance;
    if (!instance) {
        "production" !== 'production' && warn$2("useCssVars is called without current active component instance.");
        return;
    }
    watchPostEffect(function () {
        var el = instance.$el;
        var vars = getter(instance, instance._setupProxy);
        if (el && el.nodeType === 1) {
            var style = el.style;
            for (var key in vars) {
                style.setProperty("--".concat(key), vars[key]);
            }
        }
    });
}

/**
 * v3-compatible async component API.
 * @internal the type is manually declared in <root>/types/v3-define-async-component.d.ts
 * because it relies on existing manual types
 */
function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader,
        loadingComponent = source.loadingComponent,
        errorComponent = source.errorComponent,
        _a = source.delay,
        delay = _a === void 0 ? 200 : _a,
        timeout = source.timeout,
        // undefined = never times out
    _b = source.suspensible,
        // undefined = never times out
    suspensible = _b === void 0 ? false : _b,
        // in Vue 3 default is true
    userOnError = source.onError;
    if (false) {
        warn$2("The suspensible option for async components is not supported in Vue2. It is ignored.");
    }
    var pendingRequest = null;
    var retries = 0;
    var retry = function retry() {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function load() {
        var thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch(function (err) {
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) {
                return new Promise(function (resolve, reject) {
                    var userRetry = function userRetry() {
                        return resolve(retry());
                    };
                    var userFail = function userFail() {
                        return reject(err);
                    };
                    userOnError(err, userRetry, userFail, retries + 1);
                });
            } else {
                throw err;
            }
        }).then(function (comp) {
            if (thisRequest !== pendingRequest && pendingRequest) {
                return pendingRequest;
            }
            if (false) {
                warn$2("Async component loader resolved to undefined. " + "If you are using retry(), make sure to return its return value.");
            }
            // interop module default
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                comp = comp.default;
            }
            if (false) {
                throw new Error("Invalid async component load result: ".concat(comp));
            }
            return comp;
        }));
    };
    return function () {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent
        };
    };
}

function createLifeCycle(hookName) {
    return function (fn, target) {
        if (target === void 0) {
            target = currentInstance;
        }
        if (!target) {
            "production" !== 'production' && warn$2("".concat(formatName(hookName), " is called when there is no active component instance to be ") + "associated with. " + "Lifecycle injection APIs can only be used during execution of setup().");
            return;
        }
        return injectHook(target, hookName, fn);
    };
}
function formatName(name) {
    if (name === 'beforeDestroy') {
        name = 'beforeUnmount';
    } else if (name === 'destroyed') {
        name = 'unmounted';
    }
    return "on".concat(name[0].toUpperCase() + name.slice(1));
}
function injectHook(instance, hookName, fn) {
    var options = instance.$options;
    options[hookName] = mergeLifecycleHook(options[hookName], fn);
}
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');
var onRenderTracked = createLifeCycle('renderTracked');
var onRenderTriggered = createLifeCycle('renderTriggered');
var injectErrorCapturedHook = createLifeCycle('errorCaptured');
function onErrorCaptured(hook, target) {
    if (target === void 0) {
        target = currentInstance;
    }
    injectErrorCapturedHook(hook, target);
}

/**
 * Note: also update dist/vue.runtime.mjs when adding new exports to this file.
 */
var version = '2.7.16';
/**
 * @internal type is manually declared in <root>/types/v3-define-component.d.ts
 */
function defineComponent(options) {
    return options;
}

var seenObjects = new _Set();
/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse(val) {
    _traverse(val, seenObjects);
    seenObjects.clear();
    return val;
}
function _traverse(val, seen) {
    var i, keys;
    var isA = isArray(val);
    if (!isA && !isObject(val) || val.__v_skip /* ReactiveFlags.SKIP */ || Object.isFrozen(val) || val instanceof VNode) {
        return;
    }
    if (val.__ob__) {
        var depId = val.__ob__.dep.id;
        if (seen.has(depId)) {
            return;
        }
        seen.add(depId);
    }
    if (isA) {
        i = val.length;
        while (i--) {
            _traverse(val[i], seen);
        }
    } else if (isRef(val)) {
        _traverse(val.value, seen);
    } else {
        keys = Object.keys(val);
        i = keys.length;
        while (i--) {
            _traverse(val[keys[i]], seen);
        }
    }
}

var uid$1 = 0;
/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 * @internal
 */
var Watcher = /** @class */function () {
    function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
        recordEffectScope(this,
        // if the active effect scope is manually created (not a component scope),
        // prioritize it
        activeEffectScope && !activeEffectScope._vm ? activeEffectScope : vm ? vm._scope : undefined);
        if ((this.vm = vm) && isRenderWatcher) {
            vm._watcher = this;
        }
        // options
        if (options) {
            this.deep = !!options.deep;
            this.user = !!options.user;
            this.lazy = !!options.lazy;
            this.sync = !!options.sync;
            this.before = options.before;
            if (false) {
                this.onTrack = options.onTrack;
                this.onTrigger = options.onTrigger;
            }
        } else {
            this.deep = this.user = this.lazy = this.sync = false;
        }
        this.cb = cb;
        this.id = ++uid$1; // uid for batching
        this.active = true;
        this.post = false;
        this.dirty = this.lazy; // for lazy watchers
        this.deps = [];
        this.newDeps = [];
        this.depIds = new _Set();
        this.newDepIds = new _Set();
        this.expression =  false ? expOrFn.toString() : '';
        // parse expression for getter
        if (isFunction(expOrFn)) {
            this.getter = expOrFn;
        } else {
            this.getter = parsePath(expOrFn);
            if (!this.getter) {
                this.getter = noop;
                "production" !== 'production' && warn$2("Failed watching path: \"".concat(expOrFn, "\" ") + 'Watcher only accepts simple dot-delimited paths. ' + 'For full control, use a function instead.', vm);
            }
        }
        this.value = this.lazy ? undefined : this.get();
    }
    /**
     * Evaluate the getter, and re-collect dependencies.
     */
    Watcher.prototype.get = function () {
        pushTarget(this);
        var value;
        var vm = this.vm;
        try {
            value = this.getter.call(vm, vm);
        } catch (e) {
            if (this.user) {
                handleError(e, vm, "getter for watcher \"".concat(this.expression, "\""));
            } else {
                throw e;
            }
        } finally {
            // "touch" every property so they are all tracked as
            // dependencies for deep watching
            if (this.deep) {
                traverse(value);
            }
            popTarget();
            this.cleanupDeps();
        }
        return value;
    };
    /**
     * Add a dependency to this directive.
     */
    Watcher.prototype.addDep = function (dep) {
        var id = dep.id;
        if (!this.newDepIds.has(id)) {
            this.newDepIds.add(id);
            this.newDeps.push(dep);
            if (!this.depIds.has(id)) {
                dep.addSub(this);
            }
        }
    };
    /**
     * Clean up for dependency collection.
     */
    Watcher.prototype.cleanupDeps = function () {
        var i = this.deps.length;
        while (i--) {
            var dep = this.deps[i];
            if (!this.newDepIds.has(dep.id)) {
                dep.removeSub(this);
            }
        }
        var tmp = this.depIds;
        this.depIds = this.newDepIds;
        this.newDepIds = tmp;
        this.newDepIds.clear();
        tmp = this.deps;
        this.deps = this.newDeps;
        this.newDeps = tmp;
        this.newDeps.length = 0;
    };
    /**
     * Subscriber interface.
     * Will be called when a dependency changes.
     */
    Watcher.prototype.update = function () {
        /* istanbul ignore else */
        if (this.lazy) {
            this.dirty = true;
        } else if (this.sync) {
            this.run();
        } else {
            queueWatcher(this);
        }
    };
    /**
     * Scheduler job interface.
     * Will be called by the scheduler.
     */
    Watcher.prototype.run = function () {
        if (this.active) {
            var value = this.get();
            if (value !== this.value ||
            // Deep watchers and watchers on Object/Arrays should fire even
            // when the value is the same, because the value may
            // have mutated.
            isObject(value) || this.deep) {
                // set new value
                var oldValue = this.value;
                this.value = value;
                if (this.user) {
                    var info = "callback for watcher \"".concat(this.expression, "\"");
                    invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
                } else {
                    this.cb.call(this.vm, value, oldValue);
                }
            }
        }
    };
    /**
     * Evaluate the value of the watcher.
     * This only gets called for lazy watchers.
     */
    Watcher.prototype.evaluate = function () {
        this.value = this.get();
        this.dirty = false;
    };
    /**
     * Depend on all deps collected by this watcher.
     */
    Watcher.prototype.depend = function () {
        var i = this.deps.length;
        while (i--) {
            this.deps[i].depend();
        }
    };
    /**
     * Remove self from all dependencies' subscriber list.
     */
    Watcher.prototype.teardown = function () {
        if (this.vm && !this.vm._isBeingDestroyed) {
            remove$2(this.vm._scope.effects, this);
        }
        if (this.active) {
            var i = this.deps.length;
            while (i--) {
                this.deps[i].removeSub(this);
            }
            this.active = false;
            if (this.onStop) {
                this.onStop();
            }
        }
    };
    return Watcher;
}();

var sharedPropertyDefinition = {
    enumerable: true,
    configurable: true,
    get: noop,
    set: noop
};
function proxy(target, sourceKey, key) {
    sharedPropertyDefinition.get = function proxyGetter() {
        return this[sourceKey][key];
    };
    sharedPropertyDefinition.set = function proxySetter(val) {
        this[sourceKey][key] = val;
    };
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function initState(vm) {
    var opts = vm.$options;
    if (opts.props) initProps$1(vm, opts.props);
    // Composition API
    initSetup(vm);
    if (opts.methods) initMethods(vm, opts.methods);
    if (opts.data) {
        initData(vm);
    } else {
        var ob = observe(vm._data = {});
        ob && ob.vmCount++;
    }
    if (opts.computed) initComputed$1(vm, opts.computed);
    if (opts.watch && opts.watch !== nativeWatch) {
        initWatch(vm, opts.watch);
    }
}
function initProps$1(vm, propsOptions) {
    var propsData = vm.$options.propsData || {};
    var props = vm._props = shallowReactive({});
    // cache prop keys so that future props updates can iterate using Array
    // instead of dynamic object key enumeration.
    var keys = vm.$options._propKeys = [];
    var isRoot = !vm.$parent;
    // root instance props should be converted
    if (!isRoot) {
        toggleObserving(false);
    }
    var _loop_1 = function _loop_1(key) {
        keys.push(key);
        var value = validateProp(key, propsOptions, propsData, vm);
        /* istanbul ignore else */
        if (false) {
            var hyphenatedKey = hyphenate(key);
            if (isReservedAttribute(hyphenatedKey) || config.isReservedAttr(hyphenatedKey)) {
                warn$2("\"".concat(hyphenatedKey, "\" is a reserved attribute and cannot be used as component prop."), vm);
            }
            defineReactive(props, key, value, function () {
                if (!isRoot && !isUpdatingChildComponent) {
                    warn$2("Avoid mutating a prop directly since the value will be " + "overwritten whenever the parent component re-renders. " + "Instead, use a data or computed property based on the prop's " + "value. Prop being mutated: \"".concat(key, "\""), vm);
                }
            }, true /* shallow */);
        } else {
            defineReactive(props, key, value, undefined, true /* shallow */);
        }
        // static props are already proxied on the component's prototype
        // during Vue.extend(). We only need to proxy props defined at
        // instantiation here.
        if (!(key in vm)) {
            proxy(vm, "_props", key);
        }
    };
    for (var key in propsOptions) {
        _loop_1(key);
    }
    toggleObserving(true);
}
function initData(vm) {
    var data = vm.$options.data;
    data = vm._data = isFunction(data) ? getData(data, vm) : data || {};
    if (!isPlainObject(data)) {
        data = {};
        "production" !== 'production' && warn$2('data functions should return an object:\n' + 'https://v2.vuejs.org/v2/guide/components.html#data-Must-Be-a-Function', vm);
    }
    // proxy data on instance
    var keys = Object.keys(data);
    var props = vm.$options.props;
    var methods = vm.$options.methods;
    var i = keys.length;
    while (i--) {
        var key = keys[i];
        if (false) {
            if (methods && hasOwn(methods, key)) {
                warn$2("Method \"".concat(key, "\" has already been defined as a data property."), vm);
            }
        }
        if (props && hasOwn(props, key)) {
            "production" !== 'production' && warn$2("The data property \"".concat(key, "\" is already declared as a prop. ") + "Use prop default value instead.", vm);
        } else if (!isReserved(key)) {
            proxy(vm, "_data", key);
        }
    }
    // observe data
    var ob = observe(data);
    ob && ob.vmCount++;
}
function getData(data, vm) {
    // #7573 disable dep collection when invoking data getters
    pushTarget();
    try {
        return data.call(vm, vm);
    } catch (e) {
        handleError(e, vm, "data()");
        return {};
    } finally {
        popTarget();
    }
}
var computedWatcherOptions = { lazy: true };
function initComputed$1(vm, computed) {
    // $flow-disable-line
    var watchers = vm._computedWatchers = Object.create(null);
    // computed properties are just getters during SSR
    var isSSR = isServerRendering();
    for (var key in computed) {
        var userDef = computed[key];
        var getter = isFunction(userDef) ? userDef : userDef.get;
        if (false) {
            warn$2("Getter is missing for computed property \"".concat(key, "\"."), vm);
        }
        if (!isSSR) {
            // create internal watcher for the computed property.
            watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
        }
        // component-defined computed properties are already defined on the
        // component prototype. We only need to define computed properties defined
        // at instantiation here.
        if (!(key in vm)) {
            defineComputed(vm, key, userDef);
        } else if (false) {
            if (key in vm.$data) {
                warn$2("The computed property \"".concat(key, "\" is already defined in data."), vm);
            } else if (vm.$options.props && key in vm.$options.props) {
                warn$2("The computed property \"".concat(key, "\" is already defined as a prop."), vm);
            } else if (vm.$options.methods && key in vm.$options.methods) {
                warn$2("The computed property \"".concat(key, "\" is already defined as a method."), vm);
            }
        }
    }
}
function defineComputed(target, key, userDef) {
    var shouldCache = !isServerRendering();
    if (isFunction(userDef)) {
        sharedPropertyDefinition.get = shouldCache ? createComputedGetter(key) : createGetterInvoker(userDef);
        sharedPropertyDefinition.set = noop;
    } else {
        sharedPropertyDefinition.get = userDef.get ? shouldCache && userDef.cache !== false ? createComputedGetter(key) : createGetterInvoker(userDef.get) : noop;
        sharedPropertyDefinition.set = userDef.set || noop;
    }
    if (false) {
        sharedPropertyDefinition.set = function () {
            warn$2("Computed property \"".concat(key, "\" was assigned to but it has no setter."), this);
        };
    }
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function createComputedGetter(key) {
    return function computedGetter() {
        var watcher = this._computedWatchers && this._computedWatchers[key];
        if (watcher) {
            if (watcher.dirty) {
                watcher.evaluate();
            }
            if (Dep.target) {
                if (false) {
                    Dep.target.onTrack({
                        effect: Dep.target,
                        target: this,
                        type: "get" /* TrackOpTypes.GET */
                        , key: key
                    });
                }
                watcher.depend();
            }
            return watcher.value;
        }
    };
}
function createGetterInvoker(fn) {
    return function computedGetter() {
        return fn.call(this, this);
    };
}
function initMethods(vm, methods) {
    var props = vm.$options.props;
    for (var key in methods) {
        if (false) {
            if (typeof methods[key] !== 'function') {
                warn$2("Method \"".concat(key, "\" has type \"").concat(_typeof(methods[key]), "\" in the component definition. ") + "Did you reference the function correctly?", vm);
            }
            if (props && hasOwn(props, key)) {
                warn$2("Method \"".concat(key, "\" has already been defined as a prop."), vm);
            }
            if (key in vm && isReserved(key)) {
                warn$2("Method \"".concat(key, "\" conflicts with an existing Vue instance method. ") + "Avoid defining component methods that start with _ or $.");
            }
        }
        vm[key] = typeof methods[key] !== 'function' ? noop : bind$1(methods[key], vm);
    }
}
function initWatch(vm, watch) {
    for (var key in watch) {
        var handler = watch[key];
        if (isArray(handler)) {
            for (var i = 0; i < handler.length; i++) {
                createWatcher(vm, key, handler[i]);
            }
        } else {
            createWatcher(vm, key, handler);
        }
    }
}
function createWatcher(vm, expOrFn, handler, options) {
    if (isPlainObject(handler)) {
        options = handler;
        handler = handler.handler;
    }
    if (typeof handler === 'string') {
        handler = vm[handler];
    }
    return vm.$watch(expOrFn, handler, options);
}
function stateMixin(Vue) {
    // flow somehow has problems with directly declared definition object
    // when using Object.defineProperty, so we have to procedurally build up
    // the object here.
    var dataDef = {};
    dataDef.get = function () {
        return this._data;
    };
    var propsDef = {};
    propsDef.get = function () {
        return this._props;
    };
    if (false) {
        dataDef.set = function () {
            warn$2('Avoid replacing instance root $data. ' + 'Use nested data properties instead.', this);
        };
        propsDef.set = function () {
            warn$2("$props is readonly.", this);
        };
    }
    Object.defineProperty(Vue.prototype, '$data', dataDef);
    Object.defineProperty(Vue.prototype, '$props', propsDef);
    Vue.prototype.$set = set;
    Vue.prototype.$delete = del;
    Vue.prototype.$watch = function (expOrFn, cb, options) {
        var vm = this;
        if (isPlainObject(cb)) {
            return createWatcher(vm, expOrFn, cb, options);
        }
        options = options || {};
        options.user = true;
        var watcher = new Watcher(vm, expOrFn, cb, options);
        if (options.immediate) {
            var info = "callback for immediate watcher \"".concat(watcher.expression, "\"");
            pushTarget();
            invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
            popTarget();
        }
        return function unwatchFn() {
            watcher.teardown();
        };
    };
}

function initProvide(vm) {
    var provideOption = vm.$options.provide;
    if (provideOption) {
        var provided = isFunction(provideOption) ? provideOption.call(vm) : provideOption;
        if (!isObject(provided)) {
            return;
        }
        var source = resolveProvided(vm);
        // IE9 doesn't support Object.getOwnPropertyDescriptors so we have to
        // iterate the keys ourselves.
        var keys = hasSymbol ? Reflect.ownKeys(provided) : Object.keys(provided);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            Object.defineProperty(source, key, Object.getOwnPropertyDescriptor(provided, key));
        }
    }
}
function initInjections(vm) {
    var result = resolveInject(vm.$options.inject, vm);
    if (result) {
        toggleObserving(false);
        Object.keys(result).forEach(function (key) {
            /* istanbul ignore else */
            if (false) {
                defineReactive(vm, key, result[key], function () {
                    warn$2("Avoid mutating an injected value directly since the changes will be " + "overwritten whenever the provided component re-renders. " + "injection being mutated: \"".concat(key, "\""), vm);
                });
            } else {
                defineReactive(vm, key, result[key]);
            }
        });
        toggleObserving(true);
    }
}
function resolveInject(inject, vm) {
    if (inject) {
        // inject is :any because flow is not smart enough to figure out cached
        var result = Object.create(null);
        var keys = hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            // #6574 in case the inject object is observed...
            if (key === '__ob__') continue;
            var provideKey = inject[key].from;
            if (provideKey in vm._provided) {
                result[key] = vm._provided[provideKey];
            } else if ('default' in inject[key]) {
                var provideDefault = inject[key].default;
                result[key] = isFunction(provideDefault) ? provideDefault.call(vm) : provideDefault;
            } else if (false) {
                warn$2("Injection \"".concat(key, "\" not found"), vm);
            }
        }
        return result;
    }
}

var uid = 0;
function initMixin$1(Vue) {
    Vue.prototype._init = function (options) {
        var vm = this;
        // a uid
        vm._uid = uid++;
        var startTag, endTag;
        /* istanbul ignore if */
        if (false) {
            startTag = "vue-perf-start:".concat(vm._uid);
            endTag = "vue-perf-end:".concat(vm._uid);
            mark(startTag);
        }
        // a flag to mark this as a Vue instance without having to do instanceof
        // check
        vm._isVue = true;
        // avoid instances from being observed
        vm.__v_skip = true;
        // effect scope
        vm._scope = new EffectScope(true /* detached */);
        // #13134 edge case where a child component is manually created during the
        // render of a parent component
        vm._scope.parent = undefined;
        vm._scope._vm = true;
        // merge options
        if (options && options._isComponent) {
            // optimize internal component instantiation
            // since dynamic options merging is pretty slow, and none of the
            // internal component options needs special treatment.
            initInternalComponent(vm, options);
        } else {
            vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
        }
        /* istanbul ignore else */
        if (false) {
            initProxy(vm);
        } else {
            vm._renderProxy = vm;
        }
        // expose real self
        vm._self = vm;
        initLifecycle(vm);
        initEvents(vm);
        initRender(vm);
        callHook$1(vm, 'beforeCreate', undefined, false /* setContext */);
        initInjections(vm); // resolve injections before data/props
        initState(vm);
        initProvide(vm); // resolve provide after data/props
        callHook$1(vm, 'created');
        /* istanbul ignore if */
        if (false) {
            vm._name = formatComponentName(vm, false);
            mark(endTag);
            measure("vue ".concat(vm._name, " init"), startTag, endTag);
        }
        if (vm.$options.el) {
            vm.$mount(vm.$options.el);
        }
    };
}
function initInternalComponent(vm, options) {
    var opts = vm.$options = Object.create(vm.constructor.options);
    // doing this because it's faster than dynamic enumeration.
    var parentVnode = options._parentVnode;
    opts.parent = options.parent;
    opts._parentVnode = parentVnode;
    var vnodeComponentOptions = parentVnode.componentOptions;
    opts.propsData = vnodeComponentOptions.propsData;
    opts._parentListeners = vnodeComponentOptions.listeners;
    opts._renderChildren = vnodeComponentOptions.children;
    opts._componentTag = vnodeComponentOptions.tag;
    if (options.render) {
        opts.render = options.render;
        opts.staticRenderFns = options.staticRenderFns;
    }
}
function resolveConstructorOptions(Ctor) {
    var options = Ctor.options;
    if (Ctor.super) {
        var superOptions = resolveConstructorOptions(Ctor.super);
        var cachedSuperOptions = Ctor.superOptions;
        if (superOptions !== cachedSuperOptions) {
            // super option changed,
            // need to resolve new options.
            Ctor.superOptions = superOptions;
            // check if there are any late-modified/attached options (#4976)
            var modifiedOptions = resolveModifiedOptions(Ctor);
            // update base extend options
            if (modifiedOptions) {
                extend(Ctor.extendOptions, modifiedOptions);
            }
            options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
            if (options.name) {
                options.components[options.name] = Ctor;
            }
        }
    }
    return options;
}
function resolveModifiedOptions(Ctor) {
    var modified;
    var latest = Ctor.options;
    var sealed = Ctor.sealedOptions;
    for (var key in latest) {
        if (latest[key] !== sealed[key]) {
            if (!modified) modified = {};
            modified[key] = latest[key];
        }
    }
    return modified;
}

function FunctionalRenderContext(data, props, children, parent, Ctor) {
    var _this = this;
    var options = Ctor.options;
    // ensure the createElement function in functional components
    // gets a unique context - this is necessary for correct named slot check
    var contextVm;
    if (hasOwn(parent, '_uid')) {
        contextVm = Object.create(parent);
        contextVm._original = parent;
    } else {
        // the context vm passed in is a functional context as well.
        // in this case we want to make sure we are able to get a hold to the
        // real context instance.
        contextVm = parent;
        // @ts-ignore
        parent = parent._original;
    }
    var isCompiled = isTrue(options._compiled);
    var needNormalization = !isCompiled;
    this.data = data;
    this.props = props;
    this.children = children;
    this.parent = parent;
    this.listeners = data.on || emptyObject;
    this.injections = resolveInject(options.inject, parent);
    this.slots = function () {
        if (!_this.$slots) {
            normalizeScopedSlots(parent, data.scopedSlots, _this.$slots = resolveSlots(children, parent));
        }
        return _this.$slots;
    };
    Object.defineProperty(this, 'scopedSlots', {
        enumerable: true,
        get: function get() {
            return normalizeScopedSlots(parent, data.scopedSlots, this.slots());
        }
    });
    // support for compiled functional template
    if (isCompiled) {
        // exposing $options for renderStatic()
        this.$options = options;
        // pre-resolve slots for renderSlot()
        this.$slots = this.slots();
        this.$scopedSlots = normalizeScopedSlots(parent, data.scopedSlots, this.$slots);
    }
    if (options._scopeId) {
        this._c = function (a, b, c, d) {
            var vnode = createElement$1(contextVm, a, b, c, d, needNormalization);
            if (vnode && !isArray(vnode)) {
                vnode.fnScopeId = options._scopeId;
                vnode.fnContext = parent;
            }
            return vnode;
        };
    } else {
        this._c = function (a, b, c, d) {
            return createElement$1(contextVm, a, b, c, d, needNormalization);
        };
    }
}
installRenderHelpers(FunctionalRenderContext.prototype);
function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
    var options = Ctor.options;
    var props = {};
    var propOptions = options.props;
    if (isDef(propOptions)) {
        for (var key in propOptions) {
            props[key] = validateProp(key, propOptions, propsData || emptyObject);
        }
    } else {
        if (isDef(data.attrs)) mergeProps(props, data.attrs);
        if (isDef(data.props)) mergeProps(props, data.props);
    }
    var renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);
    var vnode = options.render.call(null, renderContext._c, renderContext);
    if (vnode instanceof VNode) {
        return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext);
    } else if (isArray(vnode)) {
        var vnodes = normalizeChildren(vnode) || [];
        var res = new Array(vnodes.length);
        for (var i = 0; i < vnodes.length; i++) {
            res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
        }
        return res;
    }
}
function cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
    // #7817 clone node before setting fnContext, otherwise if the node is reused
    // (e.g. it was from a cached normal slot) the fnContext causes named slots
    // that should not be matched to match.
    var clone = cloneVNode(vnode);
    clone.fnContext = contextVm;
    clone.fnOptions = options;
    if (false) {
        (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
    }
    if (data.slot) {
        (clone.data || (clone.data = {})).slot = data.slot;
    }
    return clone;
}
function mergeProps(to, from) {
    for (var key in from) {
        to[camelize(key)] = from[key];
    }
}

function getComponentName(options) {
    return options.name || options.__name || options._componentTag;
}
// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
    init: function init(vnode, hydrating) {
        if (vnode.componentInstance && !vnode.componentInstance._isDestroyed && vnode.data.keepAlive) {
            // kept-alive components, treat as a patch
            var mountedNode = vnode; // work around flow
            componentVNodeHooks.prepatch(mountedNode, mountedNode);
        } else {
            var child = vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance);
            child.$mount(hydrating ? vnode.elm : undefined, hydrating);
        }
    },
    prepatch: function prepatch(oldVnode, vnode) {
        var options = vnode.componentOptions;
        var child = vnode.componentInstance = oldVnode.componentInstance;
        updateChildComponent(child, options.propsData, // updated props
        options.listeners, // updated listeners
        vnode, // new parent vnode
        options.children // new children
        );
    },
    insert: function insert(vnode) {
        var context = vnode.context,
            componentInstance = vnode.componentInstance;
        if (!componentInstance._isMounted) {
            componentInstance._isMounted = true;
            callHook$1(componentInstance, 'mounted');
        }
        if (vnode.data.keepAlive) {
            if (context._isMounted) {
                // vue-router#1212
                // During updates, a kept-alive component's child components may
                // change, so directly walking the tree here may call activated hooks
                // on incorrect children. Instead we push them into a queue which will
                // be processed after the whole patch process ended.
                queueActivatedComponent(componentInstance);
            } else {
                activateChildComponent(componentInstance, true /* direct */);
            }
        }
    },
    destroy: function destroy(vnode) {
        var componentInstance = vnode.componentInstance;
        if (!componentInstance._isDestroyed) {
            if (!vnode.data.keepAlive) {
                componentInstance.$destroy();
            } else {
                deactivateChildComponent(componentInstance, true /* direct */);
            }
        }
    }
};
var hooksToMerge = Object.keys(componentVNodeHooks);
function createComponent(Ctor, data, context, children, tag) {
    if (isUndef(Ctor)) {
        return;
    }
    var baseCtor = context.$options._base;
    // plain options object: turn it into a constructor
    if (isObject(Ctor)) {
        Ctor = baseCtor.extend(Ctor);
    }
    // if at this stage it's not a constructor or an async component factory,
    // reject.
    if (typeof Ctor !== 'function') {
        if (false) {
            warn$2("Invalid Component definition: ".concat(String(Ctor)), context);
        }
        return;
    }
    // async component
    var asyncFactory;
    // @ts-expect-error
    if (isUndef(Ctor.cid)) {
        asyncFactory = Ctor;
        Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
        if (Ctor === undefined) {
            // return a placeholder node for async component, which is rendered
            // as a comment node but preserves all the raw information for the node.
            // the information will be used for async server-rendering and hydration.
            return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
        }
    }
    data = data || {};
    // resolve constructor options in case global mixins are applied after
    // component constructor creation
    resolveConstructorOptions(Ctor);
    // transform component v-model data into props & events
    if (isDef(data.model)) {
        // @ts-expect-error
        transformModel(Ctor.options, data);
    }
    // extract props
    // @ts-expect-error
    var propsData = extractPropsFromVNodeData(data, Ctor, tag);
    // functional component
    // @ts-expect-error
    if (isTrue(Ctor.options.functional)) {
        return createFunctionalComponent(Ctor, propsData, data, context, children);
    }
    // extract listeners, since these needs to be treated as
    // child component listeners instead of DOM listeners
    var listeners = data.on;
    // replace with listeners with .native modifier
    // so it gets processed during parent component patch.
    data.on = data.nativeOn;
    // @ts-expect-error
    if (isTrue(Ctor.options.abstract)) {
        // abstract components do not keep anything
        // other than props & listeners & slot
        // work around flow
        var slot = data.slot;
        data = {};
        if (slot) {
            data.slot = slot;
        }
    }
    // install component management hooks onto the placeholder node
    installComponentHooks(data);
    // return a placeholder vnode
    // @ts-expect-error
    var name = getComponentName(Ctor.options) || tag;
    var vnode = new VNode(
    // @ts-expect-error
    "vue-component-".concat(Ctor.cid).concat(name ? "-".concat(name) : ''), data, undefined, undefined, undefined, context,
    // @ts-expect-error
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }, asyncFactory);
    return vnode;
}
function createComponentInstanceForVnode(
// we know it's MountedComponentVNode but flow doesn't
vnode,
// activeInstance in lifecycle state
parent) {
    var options = {
        _isComponent: true,
        _parentVnode: vnode,
        parent: parent
    };
    // check inline-template render functions
    var inlineTemplate = vnode.data.inlineTemplate;
    if (isDef(inlineTemplate)) {
        options.render = inlineTemplate.render;
        options.staticRenderFns = inlineTemplate.staticRenderFns;
    }
    return new vnode.componentOptions.Ctor(options);
}
function installComponentHooks(data) {
    var hooks = data.hook || (data.hook = {});
    for (var i = 0; i < hooksToMerge.length; i++) {
        var key = hooksToMerge[i];
        var existing = hooks[key];
        var toMerge = componentVNodeHooks[key];
        // @ts-expect-error
        if (existing !== toMerge && !(existing && existing._merged)) {
            hooks[key] = existing ? mergeHook(toMerge, existing) : toMerge;
        }
    }
}
function mergeHook(f1, f2) {
    var merged = function merged(a, b) {
        // flow complains about extra args which is why we use any
        f1(a, b);
        f2(a, b);
    };
    merged._merged = true;
    return merged;
}
// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel(options, data) {
    var prop = options.model && options.model.prop || 'value';
    var event = options.model && options.model.event || 'input';
    (data.attrs || (data.attrs = {}))[prop] = data.model.value;
    var on = data.on || (data.on = {});
    var existing = on[event];
    var callback = data.model.callback;
    if (isDef(existing)) {
        if (isArray(existing) ? existing.indexOf(callback) === -1 : existing !== callback) {
            on[event] = [callback].concat(existing);
        }
    } else {
        on[event] = callback;
    }
}

var warn$2 = noop;
var tip = noop;
var generateComponentTrace; // work around flow check
var formatComponentName;
if (false) {
    var hasConsole_1 = typeof console !== 'undefined';
    var classifyRE_1 = /(?:^|[-_])(\w)/g;
    var classify_1 = function classify_1(str) {
        return str.replace(classifyRE_1, function (c) {
            return c.toUpperCase();
        }).replace(/[-_]/g, '');
    };
    warn$2 = function warn$2(msg, vm) {
        if (vm === void 0) {
            vm = currentInstance;
        }
        var trace = vm ? generateComponentTrace(vm) : '';
        if (config.warnHandler) {
            config.warnHandler.call(null, msg, vm, trace);
        } else if (hasConsole_1 && !config.silent) {
            console.error("[Vue warn]: ".concat(msg).concat(trace));
        }
    };
    tip = function tip(msg, vm) {
        if (hasConsole_1 && !config.silent) {
            console.warn("[Vue tip]: ".concat(msg) + (vm ? generateComponentTrace(vm) : ''));
        }
    };
    formatComponentName = function formatComponentName(vm, includeFile) {
        if (vm.$root === vm) {
            return '<Root>';
        }
        var options = isFunction(vm) && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm;
        var name = getComponentName(options);
        var file = options.__file;
        if (!name && file) {
            var match = file.match(/([^/\\]+)\.vue$/);
            name = match && match[1];
        }
        return (name ? "<".concat(classify_1(name), ">") : "<Anonymous>") + (file && includeFile !== false ? " at ".concat(file) : '');
    };
    var repeat_1 = function repeat_1(str, n) {
        var res = '';
        while (n) {
            if (n % 2 === 1) res += str;
            if (n > 1) str += str;
            n >>= 1;
        }
        return res;
    };
    generateComponentTrace = function generateComponentTrace(vm) {
        if (vm._isVue && vm.$parent) {
            var tree = [];
            var currentRecursiveSequence = 0;
            while (vm) {
                if (tree.length > 0) {
                    var last = tree[tree.length - 1];
                    if (last.constructor === vm.constructor) {
                        currentRecursiveSequence++;
                        vm = vm.$parent;
                        continue;
                    } else if (currentRecursiveSequence > 0) {
                        tree[tree.length - 1] = [last, currentRecursiveSequence];
                        currentRecursiveSequence = 0;
                    }
                }
                tree.push(vm);
                vm = vm.$parent;
            }
            return '\n\nfound in\n\n' + tree.map(function (vm, i) {
                return "".concat(i === 0 ? '---> ' : repeat_1(' ', 5 + i * 2)).concat(isArray(vm) ? "".concat(formatComponentName(vm[0]), "... (").concat(vm[1], " recursive calls)") : formatComponentName(vm));
            }).join('\n');
        } else {
            return "\n\n(found in ".concat(formatComponentName(vm), ")");
        }
    };
}

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;
/**
 * Options with restrictions
 */
if (false) {
    strats.el = strats.propsData = function (parent, child, vm, key) {
        if (!vm) {
            warn$2("option \"".concat(key, "\" can only be used during instance ") + 'creation with the `new` keyword.');
        }
        return defaultStrat(parent, child);
    };
}
/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(to, from, recursive) {
    if (recursive === void 0) {
        recursive = true;
    }
    if (!from) return to;
    var key, toVal, fromVal;
    var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__') continue;
        toVal = to[key];
        fromVal = from[key];
        if (!recursive || !hasOwn(to, key)) {
            set(to, key, fromVal);
        } else if (toVal !== fromVal && isPlainObject(toVal) && isPlainObject(fromVal)) {
            mergeData(toVal, fromVal);
        }
    }
    return to;
}
/**
 * Data
 */
function mergeDataOrFn(parentVal, childVal, vm) {
    if (!vm) {
        // in a Vue.extend merge, both should be functions
        if (!childVal) {
            return parentVal;
        }
        if (!parentVal) {
            return childVal;
        }
        // when parentVal & childVal are both present,
        // we need to return a function that returns the
        // merged result of both functions... no need to
        // check if parentVal is a function here because
        // it has to be a function to pass previous merges.
        return function mergedDataFn() {
            return mergeData(isFunction(childVal) ? childVal.call(this, this) : childVal, isFunction(parentVal) ? parentVal.call(this, this) : parentVal);
        };
    } else {
        return function mergedInstanceDataFn() {
            // instance merge
            var instanceData = isFunction(childVal) ? childVal.call(vm, vm) : childVal;
            var defaultData = isFunction(parentVal) ? parentVal.call(vm, vm) : parentVal;
            if (instanceData) {
                return mergeData(instanceData, defaultData);
            } else {
                return defaultData;
            }
        };
    }
}
strats.data = function (parentVal, childVal, vm) {
    if (!vm) {
        if (childVal && typeof childVal !== 'function') {
            "production" !== 'production' && warn$2('The "data" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
            return parentVal;
        }
        return mergeDataOrFn(parentVal, childVal);
    }
    return mergeDataOrFn(parentVal, childVal, vm);
};
/**
 * Hooks and props are merged as arrays.
 */
function mergeLifecycleHook(parentVal, childVal) {
    var res = childVal ? parentVal ? parentVal.concat(childVal) : isArray(childVal) ? childVal : [childVal] : parentVal;
    return res ? dedupeHooks(res) : res;
}
function dedupeHooks(hooks) {
    var res = [];
    for (var i = 0; i < hooks.length; i++) {
        if (res.indexOf(hooks[i]) === -1) {
            res.push(hooks[i]);
        }
    }
    return res;
}
LIFECYCLE_HOOKS.forEach(function (hook) {
    strats[hook] = mergeLifecycleHook;
});
/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets(parentVal, childVal, vm, key) {
    var res = Object.create(parentVal || null);
    if (childVal) {
        "production" !== 'production' && assertObjectType(key, childVal, vm);
        return extend(res, childVal);
    } else {
        return res;
    }
}
ASSET_TYPES.forEach(function (type) {
    strats[type + 's'] = mergeAssets;
});
/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (parentVal, childVal, vm, key) {
    // work around Firefox's Object.prototype.watch...
    //@ts-expect-error work around
    if (parentVal === nativeWatch) parentVal = undefined;
    //@ts-expect-error work around
    if (childVal === nativeWatch) childVal = undefined;
    /* istanbul ignore if */
    if (!childVal) return Object.create(parentVal || null);
    if (false) {
        assertObjectType(key, childVal, vm);
    }
    if (!parentVal) return childVal;
    var ret = {};
    extend(ret, parentVal);
    for (var key_1 in childVal) {
        var parent_1 = ret[key_1];
        var child = childVal[key_1];
        if (parent_1 && !isArray(parent_1)) {
            parent_1 = [parent_1];
        }
        ret[key_1] = parent_1 ? parent_1.concat(child) : isArray(child) ? child : [child];
    }
    return ret;
};
/**
 * Other object hashes.
 */
strats.props = strats.methods = strats.inject = strats.computed = function (parentVal, childVal, vm, key) {
    if (childVal && "production" !== 'production') {
        assertObjectType(key, childVal, vm);
    }
    if (!parentVal) return childVal;
    var ret = Object.create(null);
    extend(ret, parentVal);
    if (childVal) extend(ret, childVal);
    return ret;
};
strats.provide = function (parentVal, childVal) {
    if (!parentVal) return childVal;
    return function () {
        var ret = Object.create(null);
        mergeData(ret, isFunction(parentVal) ? parentVal.call(this) : parentVal);
        if (childVal) {
            mergeData(ret, isFunction(childVal) ? childVal.call(this) : childVal, false // non-recursive
            );
        }
        return ret;
    };
};
/**
 * Default strategy.
 */
var defaultStrat = function defaultStrat(parentVal, childVal) {
    return childVal === undefined ? parentVal : childVal;
};
/**
 * Validate component names
 */
function checkComponents(options) {
    for (var key in options.components) {
        validateComponentName(key);
    }
}
function validateComponentName(name) {
    if (!new RegExp("^[a-zA-Z][\\-\\.0-9_".concat(unicodeRegExp.source, "]*$")).test(name)) {
        warn$2('Invalid component name: "' + name + '". Component names ' + 'should conform to valid custom element name in html5 specification.');
    }
    if (isBuiltInTag(name) || config.isReservedTag(name)) {
        warn$2('Do not use built-in or reserved HTML elements as component ' + 'id: ' + name);
    }
}
/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps(options, vm) {
    var props = options.props;
    if (!props) return;
    var res = {};
    var i, val, name;
    if (isArray(props)) {
        i = props.length;
        while (i--) {
            val = props[i];
            if (typeof val === 'string') {
                name = camelize(val);
                res[name] = { type: null };
            } else if (false) {
                warn$2('props must be strings when using array syntax.');
            }
        }
    } else if (isPlainObject(props)) {
        for (var key in props) {
            val = props[key];
            name = camelize(key);
            res[name] = isPlainObject(val) ? val : { type: val };
        }
    } else if (false) {
        warn$2("Invalid value for option \"props\": expected an Array or an Object, " + "but got ".concat(toRawType(props), "."), vm);
    }
    options.props = res;
}
/**
 * Normalize all injections into Object-based format
 */
function normalizeInject(options, vm) {
    var inject = options.inject;
    if (!inject) return;
    var normalized = options.inject = {};
    if (isArray(inject)) {
        for (var i = 0; i < inject.length; i++) {
            normalized[inject[i]] = { from: inject[i] };
        }
    } else if (isPlainObject(inject)) {
        for (var key in inject) {
            var val = inject[key];
            normalized[key] = isPlainObject(val) ? extend({ from: key }, val) : { from: val };
        }
    } else if (false) {
        warn$2("Invalid value for option \"inject\": expected an Array or an Object, " + "but got ".concat(toRawType(inject), "."), vm);
    }
}
/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives$1(options) {
    var dirs = options.directives;
    if (dirs) {
        for (var key in dirs) {
            var def = dirs[key];
            if (isFunction(def)) {
                dirs[key] = { bind: def, update: def };
            }
        }
    }
}
function assertObjectType(name, value, vm) {
    if (!isPlainObject(value)) {
        warn$2("Invalid value for option \"".concat(name, "\": expected an Object, ") + "but got ".concat(toRawType(value), "."), vm);
    }
}
/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions(parent, child, vm) {
    if (false) {
        checkComponents(child);
    }
    if (isFunction(child)) {
        // @ts-expect-error
        child = child.options;
    }
    normalizeProps(child, vm);
    normalizeInject(child, vm);
    normalizeDirectives$1(child);
    // Apply extends and mixins on the child options,
    // but only if it is a raw options object that isn't
    // the result of another mergeOptions call.
    // Only merged options has the _base property.
    if (!child._base) {
        if (child.extends) {
            parent = mergeOptions(parent, child.extends, vm);
        }
        if (child.mixins) {
            for (var i = 0, l = child.mixins.length; i < l; i++) {
                parent = mergeOptions(parent, child.mixins[i], vm);
            }
        }
    }
    var options = {};
    var key;
    for (key in parent) {
        mergeField(key);
    }
    for (key in child) {
        if (!hasOwn(parent, key)) {
            mergeField(key);
        }
    }
    function mergeField(key) {
        var strat = strats[key] || defaultStrat;
        options[key] = strat(parent[key], child[key], vm, key);
    }
    return options;
}
/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset(options, type, id, warnMissing) {
    /* istanbul ignore if */
    if (typeof id !== 'string') {
        return;
    }
    var assets = options[type];
    // check local registration variations first
    if (hasOwn(assets, id)) return assets[id];
    var camelizedId = camelize(id);
    if (hasOwn(assets, camelizedId)) return assets[camelizedId];
    var PascalCaseId = capitalize(camelizedId);
    if (hasOwn(assets, PascalCaseId)) return assets[PascalCaseId];
    // fallback to prototype chain
    var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
    if (false) {
        warn$2('Failed to resolve ' + type.slice(0, -1) + ': ' + id);
    }
    return res;
}

function validateProp(key, propOptions, propsData, vm) {
    var prop = propOptions[key];
    var absent = !hasOwn(propsData, key);
    var value = propsData[key];
    // boolean casting
    var booleanIndex = getTypeIndex(Boolean, prop.type);
    if (booleanIndex > -1) {
        if (absent && !hasOwn(prop, 'default')) {
            value = false;
        } else if (value === '' || value === hyphenate(key)) {
            // only cast empty string / same name to boolean if
            // boolean has higher priority
            var stringIndex = getTypeIndex(String, prop.type);
            if (stringIndex < 0 || booleanIndex < stringIndex) {
                value = true;
            }
        }
    }
    // check default value
    if (value === undefined) {
        value = getPropDefaultValue(vm, prop, key);
        // since the default value is a fresh copy,
        // make sure to observe it.
        var prevShouldObserve = shouldObserve;
        toggleObserving(true);
        observe(value);
        toggleObserving(prevShouldObserve);
    }
    if (false) {
        assertProp(prop, key, value, vm, absent);
    }
    return value;
}
/**
 * Get the default value of a prop.
 */
function getPropDefaultValue(vm, prop, key) {
    // no default, return undefined
    if (!hasOwn(prop, 'default')) {
        return undefined;
    }
    var def = prop.default;
    // warn against non-factory defaults for Object & Array
    if (false) {
        warn$2('Invalid default value for prop "' + key + '": ' + 'Props with type Object/Array must use a factory function ' + 'to return the default value.', vm);
    }
    // the raw prop value was also undefined from previous render,
    // return previous default value to avoid unnecessary watcher trigger
    if (vm && vm.$options.propsData && vm.$options.propsData[key] === undefined && vm._props[key] !== undefined) {
        return vm._props[key];
    }
    // call factory function for non-Function types
    // a value is Function if its prototype is function even across different execution context
    return isFunction(def) && getType(prop.type) !== 'Function' ? def.call(vm) : def;
}
/**
 * Assert whether a prop is valid.
 */
function assertProp(prop, name, value, vm, absent) {
    if (prop.required && absent) {
        warn$2('Missing required prop: "' + name + '"', vm);
        return;
    }
    if (value == null && !prop.required) {
        return;
    }
    var type = prop.type;
    var valid = !type || type === true;
    var expectedTypes = [];
    if (type) {
        if (!isArray(type)) {
            type = [type];
        }
        for (var i = 0; i < type.length && !valid; i++) {
            var assertedType = assertType(value, type[i], vm);
            expectedTypes.push(assertedType.expectedType || '');
            valid = assertedType.valid;
        }
    }
    var haveExpectedTypes = expectedTypes.some(function (t) {
        return t;
    });
    if (!valid && haveExpectedTypes) {
        warn$2(getInvalidTypeMessage(name, value, expectedTypes), vm);
        return;
    }
    var validator = prop.validator;
    if (validator) {
        if (!validator(value)) {
            warn$2('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
        }
    }
}
var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;
function assertType(value, type, vm) {
    var valid;
    var expectedType = getType(type);
    if (simpleCheckRE.test(expectedType)) {
        var t = typeof value === 'undefined' ? 'undefined' : _typeof(value);
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === 'object') {
            valid = value instanceof type;
        }
    } else if (expectedType === 'Object') {
        valid = isPlainObject(value);
    } else if (expectedType === 'Array') {
        valid = isArray(value);
    } else {
        try {
            valid = value instanceof type;
        } catch (e) {
            warn$2('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
            valid = false;
        }
    }
    return {
        valid: valid,
        expectedType: expectedType
    };
}
var functionTypeCheckRE = /^\s*function (\w+)/;
/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType(fn) {
    var match = fn && fn.toString().match(functionTypeCheckRE);
    return match ? match[1] : '';
}
function isSameType(a, b) {
    return getType(a) === getType(b);
}
function getTypeIndex(type, expectedTypes) {
    if (!isArray(expectedTypes)) {
        return isSameType(expectedTypes, type) ? 0 : -1;
    }
    for (var i = 0, len = expectedTypes.length; i < len; i++) {
        if (isSameType(expectedTypes[i], type)) {
            return i;
        }
    }
    return -1;
}
function getInvalidTypeMessage(name, value, expectedTypes) {
    var message = "Invalid prop: type check failed for prop \"".concat(name, "\".") + " Expected ".concat(expectedTypes.map(capitalize).join(', '));
    var expectedType = expectedTypes[0];
    var receivedType = toRawType(value);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 && isExplicable(expectedType) && isExplicable(typeof value === 'undefined' ? 'undefined' : _typeof(value)) && !isBoolean(expectedType, receivedType)) {
        message += " with value ".concat(styleValue(value, expectedType));
    }
    message += ", got ".concat(receivedType, " ");
    // check if we need to specify received value
    if (isExplicable(receivedType)) {
        message += "with value ".concat(styleValue(value, receivedType), ".");
    }
    return message;
}
function styleValue(value, type) {
    if (type === 'String') {
        return "\"".concat(value, "\"");
    } else if (type === 'Number') {
        return "".concat(Number(value));
    } else {
        return "".concat(value);
    }
}
var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
function isExplicable(value) {
    return EXPLICABLE_TYPES.some(function (elem) {
        return value.toLowerCase() === elem;
    });
}
function isBoolean() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.some(function (elem) {
        return elem.toLowerCase() === 'boolean';
    });
}

function Vue(options) {
    if (false) {
        warn$2('Vue is a constructor and should be called with the `new` keyword');
    }
    this._init(options);
}
//@ts-expect-error Vue has function type
initMixin$1(Vue);
//@ts-expect-error Vue has function type
stateMixin(Vue);
//@ts-expect-error Vue has function type
eventsMixin(Vue);
//@ts-expect-error Vue has function type
lifecycleMixin(Vue);
//@ts-expect-error Vue has function type
renderMixin(Vue);

function initUse(Vue) {
    Vue.use = function (plugin) {
        var installedPlugins = this._installedPlugins || (this._installedPlugins = []);
        if (installedPlugins.indexOf(plugin) > -1) {
            return this;
        }
        // additional parameters
        var args = toArray(arguments, 1);
        args.unshift(this);
        if (isFunction(plugin.install)) {
            plugin.install.apply(plugin, args);
        } else if (isFunction(plugin)) {
            plugin.apply(null, args);
        }
        installedPlugins.push(plugin);
        return this;
    };
}

function initMixin(Vue) {
    Vue.mixin = function (mixin) {
        this.options = mergeOptions(this.options, mixin);
        return this;
    };
}

function initExtend(Vue) {
    /**
     * Each instance constructor, including Vue, has a unique
     * cid. This enables us to create wrapped "child
     * constructors" for prototypal inheritance and cache them.
     */
    Vue.cid = 0;
    var cid = 1;
    /**
     * Class inheritance
     */
    Vue.extend = function (extendOptions) {
        extendOptions = extendOptions || {};
        var Super = this;
        var SuperId = Super.cid;
        var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
        if (cachedCtors[SuperId]) {
            return cachedCtors[SuperId];
        }
        var name = getComponentName(extendOptions) || getComponentName(Super.options);
        if (false) {
            validateComponentName(name);
        }
        var Sub = function VueComponent(options) {
            this._init(options);
        };
        Sub.prototype = Object.create(Super.prototype);
        Sub.prototype.constructor = Sub;
        Sub.cid = cid++;
        Sub.options = mergeOptions(Super.options, extendOptions);
        Sub['super'] = Super;
        // For props and computed properties, we define the proxy getters on
        // the Vue instances at extension time, on the extended prototype. This
        // avoids Object.defineProperty calls for each instance created.
        if (Sub.options.props) {
            initProps(Sub);
        }
        if (Sub.options.computed) {
            initComputed(Sub);
        }
        // allow further extension/mixin/plugin usage
        Sub.extend = Super.extend;
        Sub.mixin = Super.mixin;
        Sub.use = Super.use;
        // create asset registers, so extended classes
        // can have their private assets too.
        ASSET_TYPES.forEach(function (type) {
            Sub[type] = Super[type];
        });
        // enable recursive self-lookup
        if (name) {
            Sub.options.components[name] = Sub;
        }
        // keep a reference to the super options at extension time.
        // later at instantiation we can check if Super's options have
        // been updated.
        Sub.superOptions = Super.options;
        Sub.extendOptions = extendOptions;
        Sub.sealedOptions = extend({}, Sub.options);
        // cache constructor
        cachedCtors[SuperId] = Sub;
        return Sub;
    };
}
function initProps(Comp) {
    var props = Comp.options.props;
    for (var key in props) {
        proxy(Comp.prototype, "_props", key);
    }
}
function initComputed(Comp) {
    var computed = Comp.options.computed;
    for (var key in computed) {
        defineComputed(Comp.prototype, key, computed[key]);
    }
}

function initAssetRegisters(Vue) {
    /**
     * Create asset registration methods.
     */
    ASSET_TYPES.forEach(function (type) {
        // @ts-expect-error function is not exact same type
        Vue[type] = function (id, definition) {
            if (!definition) {
                return this.options[type + 's'][id];
            } else {
                /* istanbul ignore if */
                if (false) {
                    validateComponentName(id);
                }
                if (type === 'component' && isPlainObject(definition)) {
                    // @ts-expect-error
                    definition.name = definition.name || id;
                    definition = this.options._base.extend(definition);
                }
                if (type === 'directive' && isFunction(definition)) {
                    definition = { bind: definition, update: definition };
                }
                this.options[type + 's'][id] = definition;
                return definition;
            }
        };
    });
}

function _getComponentName(opts) {
    return opts && (getComponentName(opts.Ctor.options) || opts.tag);
}
function matches(pattern, name) {
    if (isArray(pattern)) {
        return pattern.indexOf(name) > -1;
    } else if (typeof pattern === 'string') {
        return pattern.split(',').indexOf(name) > -1;
    } else if (isRegExp(pattern)) {
        return pattern.test(name);
    }
    /* istanbul ignore next */
    return false;
}
function pruneCache(keepAliveInstance, filter) {
    var cache = keepAliveInstance.cache,
        keys = keepAliveInstance.keys,
        _vnode = keepAliveInstance._vnode,
        $vnode = keepAliveInstance.$vnode;
    for (var key in cache) {
        var entry = cache[key];
        if (entry) {
            var name_1 = entry.name;
            if (name_1 && !filter(name_1)) {
                pruneCacheEntry(cache, key, keys, _vnode);
            }
        }
    }
    $vnode.componentOptions.children = undefined;
}
function pruneCacheEntry(cache, key, keys, current) {
    var entry = cache[key];
    if (entry && (!current || entry.tag !== current.tag)) {
        // @ts-expect-error can be undefined
        entry.componentInstance.$destroy();
    }
    cache[key] = null;
    remove$2(keys, key);
}
var patternTypes = [String, RegExp, Array];
// TODO defineComponent
var KeepAlive = {
    name: 'keep-alive',
    abstract: true,
    props: {
        include: patternTypes,
        exclude: patternTypes,
        max: [String, Number]
    },
    methods: {
        cacheVNode: function cacheVNode() {
            var _a = this,
                cache = _a.cache,
                keys = _a.keys,
                vnodeToCache = _a.vnodeToCache,
                keyToCache = _a.keyToCache;
            if (vnodeToCache) {
                var tag = vnodeToCache.tag,
                    componentInstance = vnodeToCache.componentInstance,
                    componentOptions = vnodeToCache.componentOptions;
                cache[keyToCache] = {
                    name: _getComponentName(componentOptions),
                    tag: tag,
                    componentInstance: componentInstance
                };
                keys.push(keyToCache);
                // prune oldest entry
                if (this.max && keys.length > parseInt(this.max)) {
                    pruneCacheEntry(cache, keys[0], keys, this._vnode);
                }
                this.vnodeToCache = null;
            }
        }
    },
    created: function created() {
        this.cache = Object.create(null);
        this.keys = [];
    },
    destroyed: function destroyed() {
        for (var key in this.cache) {
            pruneCacheEntry(this.cache, key, this.keys);
        }
    },
    mounted: function mounted() {
        var _this = this;
        this.cacheVNode();
        this.$watch('include', function (val) {
            pruneCache(_this, function (name) {
                return matches(val, name);
            });
        });
        this.$watch('exclude', function (val) {
            pruneCache(_this, function (name) {
                return !matches(val, name);
            });
        });
    },
    updated: function updated() {
        this.cacheVNode();
    },
    render: function render() {
        var slot = this.$slots.default;
        var vnode = getFirstComponentChild(slot);
        var componentOptions = vnode && vnode.componentOptions;
        if (componentOptions) {
            // check pattern
            var name_2 = _getComponentName(componentOptions);
            var _a = this,
                include = _a.include,
                exclude = _a.exclude;
            if (
            // not included
            include && (!name_2 || !matches(include, name_2)) ||
            // excluded
            exclude && name_2 && matches(exclude, name_2)) {
                return vnode;
            }
            var _b = this,
                cache = _b.cache,
                keys = _b.keys;
            var key = vnode.key == null ? // same constructor may get registered as different local components
            // so cid alone is not enough (#3269)
            componentOptions.Ctor.cid + (componentOptions.tag ? "::".concat(componentOptions.tag) : '') : vnode.key;
            if (cache[key]) {
                vnode.componentInstance = cache[key].componentInstance;
                // make current key freshest
                remove$2(keys, key);
                keys.push(key);
            } else {
                // delay setting the cache until update
                this.vnodeToCache = vnode;
                this.keyToCache = key;
            }
            // @ts-expect-error can vnode.data can be undefined
            vnode.data.keepAlive = true;
        }
        return vnode || slot && slot[0];
    }
};

var builtInComponents = {
    KeepAlive: KeepAlive
};

function initGlobalAPI(Vue) {
    // config
    var configDef = {};
    configDef.get = function () {
        return config;
    };
    if (false) {
        configDef.set = function () {
            warn$2('Do not replace the Vue.config object, set individual fields instead.');
        };
    }
    Object.defineProperty(Vue, 'config', configDef);
    // exposed util methods.
    // NOTE: these are not considered part of the public API - avoid relying on
    // them unless you are aware of the risk.
    Vue.util = {
        warn: warn$2,
        extend: extend,
        mergeOptions: mergeOptions,
        defineReactive: defineReactive
    };
    Vue.set = set;
    Vue.delete = del;
    Vue.nextTick = nextTick;
    // 2.6 explicit observable API
    Vue.observable = function (obj) {
        observe(obj);
        return obj;
    };
    Vue.options = Object.create(null);
    ASSET_TYPES.forEach(function (type) {
        Vue.options[type + 's'] = Object.create(null);
    });
    // this is used to identify the "base" constructor to extend all plain-object
    // components with in Weex's multi-instance scenarios.
    Vue.options._base = Vue;
    extend(Vue.options.components, builtInComponents);
    initUse(Vue);
    initMixin(Vue);
    initExtend(Vue);
    initAssetRegisters(Vue);
}

initGlobalAPI(Vue);
Object.defineProperty(Vue.prototype, '$isServer', {
    get: isServerRendering
});
Object.defineProperty(Vue.prototype, '$ssrContext', {
    get: function get() {
        /* istanbul ignore next */
        return this.$vnode && this.$vnode.ssrContext;
    }
});
// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
    value: FunctionalRenderContext
});
Vue.version = version;

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');
// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function mustUseProp(tag, type, attr) {
    return attr === 'value' && acceptValue(tag) && type !== 'button' || attr === 'selected' && tag === 'option' || attr === 'checked' && tag === 'input' || attr === 'muted' && tag === 'video';
};
var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');
var convertEnumeratedValue = function convertEnumeratedValue(key, value) {
    return isFalsyAttrValue(value) || value === 'false' ? 'false' : // allow arbitrary string value for contenteditable
    key === 'contenteditable' && isValidContentEditableValue(value) ? value : 'true';
};
var isBooleanAttr = makeMap('allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' + 'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' + 'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' + 'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' + 'required,reversed,scoped,seamless,selected,sortable,' + 'truespeed,typemustmatch,visible');
var xlinkNS = 'http://www.w3.org/1999/xlink';
var isXlink = function isXlink(name) {
    return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
};
var getXlinkProp = function getXlinkProp(name) {
    return isXlink(name) ? name.slice(6, name.length) : '';
};
var isFalsyAttrValue = function isFalsyAttrValue(val) {
    return val == null || val === false;
};

function genClassForVnode(vnode) {
    var data = vnode.data;
    var parentNode = vnode;
    var childNode = vnode;
    while (isDef(childNode.componentInstance)) {
        childNode = childNode.componentInstance._vnode;
        if (childNode && childNode.data) {
            data = mergeClassData(childNode.data, data);
        }
    }
    // @ts-expect-error parentNode.parent not VNodeWithData
    while (isDef(parentNode = parentNode.parent)) {
        if (parentNode && parentNode.data) {
            data = mergeClassData(data, parentNode.data);
        }
    }
    return renderClass(data.staticClass, data.class);
}
function mergeClassData(child, parent) {
    return {
        staticClass: concat(child.staticClass, parent.staticClass),
        class: isDef(child.class) ? [child.class, parent.class] : parent.class
    };
}
function renderClass(staticClass, dynamicClass) {
    if (isDef(staticClass) || isDef(dynamicClass)) {
        return concat(staticClass, stringifyClass(dynamicClass));
    }
    /* istanbul ignore next */
    return '';
}
function concat(a, b) {
    return a ? b ? a + ' ' + b : a : b || '';
}
function stringifyClass(value) {
    if (Array.isArray(value)) {
        return stringifyArray(value);
    }
    if (isObject(value)) {
        return stringifyObject(value);
    }
    if (typeof value === 'string') {
        return value;
    }
    /* istanbul ignore next */
    return '';
}
function stringifyArray(value) {
    var res = '';
    var stringified;
    for (var i = 0, l = value.length; i < l; i++) {
        if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
            if (res) res += ' ';
            res += stringified;
        }
    }
    return res;
}
function stringifyObject(value) {
    var res = '';
    for (var key in value) {
        if (value[key]) {
            if (res) res += ' ';
            res += key;
        }
    }
    return res;
}

var namespaceMap = {
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
var isHTMLTag = makeMap('html,body,base,head,link,meta,style,title,' + 'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' + 'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' + 'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' + 's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' + 'embed,object,param,source,canvas,script,noscript,del,ins,' + 'caption,col,colgroup,table,thead,tbody,td,th,tr,' + 'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' + 'output,progress,select,textarea,' + 'details,dialog,menu,menuitem,summary,' + 'content,element,shadow,template,blockquote,iframe,tfoot');
// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap('svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' + 'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' + 'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view', true);
var isPreTag = function isPreTag(tag) {
    return tag === 'pre';
};
var isReservedTag = function isReservedTag(tag) {
    return isHTMLTag(tag) || isSVG(tag);
};
function getTagNamespace(tag) {
    if (isSVG(tag)) {
        return 'svg';
    }
    // basic support for MathML
    // note it doesn't support other MathML elements being component roots
    if (tag === 'math') {
        return 'math';
    }
}
var unknownElementCache = Object.create(null);
function isUnknownElement(tag) {
    /* istanbul ignore if */
    if (!inBrowser) {
        return true;
    }
    if (isReservedTag(tag)) {
        return false;
    }
    tag = tag.toLowerCase();
    /* istanbul ignore if */
    if (unknownElementCache[tag] != null) {
        return unknownElementCache[tag];
    }
    var el = document.createElement(tag);
    if (tag.indexOf('-') > -1) {
        // https://stackoverflow.com/a/28210364/1070244
        return unknownElementCache[tag] = el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
    } else {
        return unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString());
    }
}
var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/**
 * Query an element selector if it's not an element already.
 */
function query(el) {
    if (typeof el === 'string') {
        var selected = document.querySelector(el);
        if (!selected) {
            "production" !== 'production' && warn$2('Cannot find element: ' + el);
            return document.createElement('div');
        }
        return selected;
    } else {
        return el;
    }
}

function createElement(tagName, vnode) {
    var elm = document.createElement(tagName);
    if (tagName !== 'select') {
        return elm;
    }
    // false or null will remove the attribute but undefined will not
    if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
        elm.setAttribute('multiple', 'multiple');
    }
    return elm;
}
function createElementNS(namespace, tagName) {
    return document.createElementNS(namespaceMap[namespace], tagName);
}
function createTextNode(text) {
    return document.createTextNode(text);
}
function createComment(text) {
    return document.createComment(text);
}
function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function removeChild(node, child) {
    node.removeChild(child);
}
function appendChild(node, child) {
    node.appendChild(child);
}
function parentNode(node) {
    return node.parentNode;
}
function nextSibling(node) {
    return node.nextSibling;
}
function tagName(node) {
    return node.tagName;
}
function setTextContent(node, text) {
    node.textContent = text;
}
function setStyleScope(node, scopeId) {
    node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
    __proto__: null,
    createElement: createElement,
    createElementNS: createElementNS,
    createTextNode: createTextNode,
    createComment: createComment,
    insertBefore: insertBefore,
    removeChild: removeChild,
    appendChild: appendChild,
    parentNode: parentNode,
    nextSibling: nextSibling,
    tagName: tagName,
    setTextContent: setTextContent,
    setStyleScope: setStyleScope
});

var ref = {
    create: function create(_, vnode) {
        registerRef(vnode);
    },
    update: function update(oldVnode, vnode) {
        if (oldVnode.data.ref !== vnode.data.ref) {
            registerRef(oldVnode, true);
            registerRef(vnode);
        }
    },
    destroy: function destroy(vnode) {
        registerRef(vnode, true);
    }
};
function registerRef(vnode, isRemoval) {
    var ref = vnode.data.ref;
    if (!isDef(ref)) return;
    var vm = vnode.context;
    var refValue = vnode.componentInstance || vnode.elm;
    var value = isRemoval ? null : refValue;
    var $refsValue = isRemoval ? undefined : refValue;
    if (isFunction(ref)) {
        invokeWithErrorHandling(ref, vm, [value], vm, "template ref function");
        return;
    }
    var isFor = vnode.data.refInFor;
    var _isString = typeof ref === 'string' || typeof ref === 'number';
    var _isRef = isRef(ref);
    var refs = vm.$refs;
    if (_isString || _isRef) {
        if (isFor) {
            var existing = _isString ? refs[ref] : ref.value;
            if (isRemoval) {
                isArray(existing) && remove$2(existing, refValue);
            } else {
                if (!isArray(existing)) {
                    if (_isString) {
                        refs[ref] = [refValue];
                        setSetupRef(vm, ref, refs[ref]);
                    } else {
                        ref.value = [refValue];
                    }
                } else if (!existing.includes(refValue)) {
                    existing.push(refValue);
                }
            }
        } else if (_isString) {
            if (isRemoval && refs[ref] !== refValue) {
                return;
            }
            refs[ref] = $refsValue;
            setSetupRef(vm, ref, value);
        } else if (_isRef) {
            if (isRemoval && ref.value !== refValue) {
                return;
            }
            ref.value = value;
        } else if (false) {
            warn$2("Invalid template ref type: ".concat(typeof ref === 'undefined' ? 'undefined' : _typeof(ref)));
        }
    }
}
function setSetupRef(_a, key, val) {
    var _setupState = _a._setupState;
    if (_setupState && hasOwn(_setupState, key)) {
        if (isRef(_setupState[key])) {
            _setupState[key].value = val;
        } else {
            _setupState[key] = val;
        }
    }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */
var emptyNode = new VNode('', {}, []);
var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];
function sameVnode(a, b) {
    return a.key === b.key && a.asyncFactory === b.asyncFactory && (a.tag === b.tag && a.isComment === b.isComment && isDef(a.data) === isDef(b.data) && sameInputType(a, b) || isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error));
}
function sameInputType(a, b) {
    if (a.tag !== 'input') return true;
    var i;
    var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
    var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
    return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB);
}
function createKeyToOldIdx(children, beginIdx, endIdx) {
    var i, key;
    var map = {};
    for (i = beginIdx; i <= endIdx; ++i) {
        key = children[i].key;
        if (isDef(key)) map[key] = i;
    }
    return map;
}
function createPatchFunction(backend) {
    var i, j;
    var cbs = {};
    var modules = backend.modules,
        nodeOps = backend.nodeOps;
    for (i = 0; i < hooks.length; ++i) {
        cbs[hooks[i]] = [];
        for (j = 0; j < modules.length; ++j) {
            if (isDef(modules[j][hooks[i]])) {
                cbs[hooks[i]].push(modules[j][hooks[i]]);
            }
        }
    }
    function emptyNodeAt(elm) {
        return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
    }
    function createRmCb(childElm, listeners) {
        function remove() {
            if (--remove.listeners === 0) {
                removeNode(childElm);
            }
        }
        remove.listeners = listeners;
        return remove;
    }
    function removeNode(el) {
        var parent = nodeOps.parentNode(el);
        // element may have already been removed due to v-html / v-text
        if (isDef(parent)) {
            nodeOps.removeChild(parent, el);
        }
    }
    function isUnknownElement(vnode, inVPre) {
        return !inVPre && !vnode.ns && !(config.ignoredElements.length && config.ignoredElements.some(function (ignore) {
            return isRegExp(ignore) ? ignore.test(vnode.tag) : ignore === vnode.tag;
        })) && config.isUnknownElement(vnode.tag);
    }
    var creatingElmInVPre = 0;
    function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // This vnode was used in a previous render!
            // now it's used as a new node, overwriting its elm would cause
            // potential patch errors down the road when it's used as an insertion
            // reference node. Instead, we clone the node on-demand before creating
            // associated DOM element for it.
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        vnode.isRootInsert = !nested; // for transition enter check
        if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
            return;
        }
        var data = vnode.data;
        var children = vnode.children;
        var tag = vnode.tag;
        if (isDef(tag)) {
            if (false) {
                if (data && data.pre) {
                    creatingElmInVPre++;
                }
                if (isUnknownElement(vnode, creatingElmInVPre)) {
                    warn$2('Unknown custom element: <' + tag + '> - did you ' + 'register the component correctly? For recursive components, ' + 'make sure to provide the "name" option.', vnode.context);
                }
            }
            vnode.elm = vnode.ns ? nodeOps.createElementNS(vnode.ns, tag) : nodeOps.createElement(tag, vnode);
            setScope(vnode);
            createChildren(vnode, children, insertedVnodeQueue);
            if (isDef(data)) {
                invokeCreateHooks(vnode, insertedVnodeQueue);
            }
            insert(parentElm, vnode.elm, refElm);
            if (false) {
                creatingElmInVPre--;
            }
        } else if (isTrue(vnode.isComment)) {
            vnode.elm = nodeOps.createComment(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        } else {
            vnode.elm = nodeOps.createTextNode(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
    }
    function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i = vnode.data;
        if (isDef(i)) {
            var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
            if (isDef(i = i.hook) && isDef(i = i.init)) {
                i(vnode, false /* hydrating */);
            }
            // after calling the init hook, if the vnode is a child component
            // it should've created a child instance and mounted it. the child
            // component also has set the placeholder vnode's elm.
            // in that case we can just return the element and be done.
            if (isDef(vnode.componentInstance)) {
                initComponent(vnode, insertedVnodeQueue);
                insert(parentElm, vnode.elm, refElm);
                if (isTrue(isReactivated)) {
                    reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
                }
                return true;
            }
        }
    }
    function initComponent(vnode, insertedVnodeQueue) {
        if (isDef(vnode.data.pendingInsert)) {
            insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
            vnode.data.pendingInsert = null;
        }
        vnode.elm = vnode.componentInstance.$el;
        if (isPatchable(vnode)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            setScope(vnode);
        } else {
            // empty component root.
            // skip all element-related modules except for ref (#3455)
            registerRef(vnode);
            // make sure to invoke the insert hook
            insertedVnodeQueue.push(vnode);
        }
    }
    function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i;
        // hack for #4339: a reactivated component with inner transition
        // does not trigger because the inner node's created hooks are not called
        // again. It's not ideal to involve module-specific logic in here but
        // there doesn't seem to be a better way to do it.
        var innerNode = vnode;
        while (innerNode.componentInstance) {
            innerNode = innerNode.componentInstance._vnode;
            if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
                for (i = 0; i < cbs.activate.length; ++i) {
                    cbs.activate[i](emptyNode, innerNode);
                }
                insertedVnodeQueue.push(innerNode);
                break;
            }
        }
        // unlike a newly created component,
        // a reactivated keep-alive component doesn't insert itself
        insert(parentElm, vnode.elm, refElm);
    }
    function insert(parent, elm, ref) {
        if (isDef(parent)) {
            if (isDef(ref)) {
                if (nodeOps.parentNode(ref) === parent) {
                    nodeOps.insertBefore(parent, elm, ref);
                }
            } else {
                nodeOps.appendChild(parent, elm);
            }
        }
    }
    function createChildren(vnode, children, insertedVnodeQueue) {
        if (isArray(children)) {
            if (false) {
                checkDuplicateKeys(children);
            }
            for (var i_1 = 0; i_1 < children.length; ++i_1) {
                createElm(children[i_1], insertedVnodeQueue, vnode.elm, null, true, children, i_1);
            }
        } else if (isPrimitive(vnode.text)) {
            nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
        }
    }
    function isPatchable(vnode) {
        while (vnode.componentInstance) {
            vnode = vnode.componentInstance._vnode;
        }
        return isDef(vnode.tag);
    }
    function invokeCreateHooks(vnode, insertedVnodeQueue) {
        for (var i_2 = 0; i_2 < cbs.create.length; ++i_2) {
            cbs.create[i_2](emptyNode, vnode);
        }
        i = vnode.data.hook; // Reuse variable
        if (isDef(i)) {
            if (isDef(i.create)) i.create(emptyNode, vnode);
            if (isDef(i.insert)) insertedVnodeQueue.push(vnode);
        }
    }
    // set scope id attribute for scoped CSS.
    // this is implemented as a special case to avoid the overhead
    // of going through the normal attribute patching process.
    function setScope(vnode) {
        var i;
        if (isDef(i = vnode.fnScopeId)) {
            nodeOps.setStyleScope(vnode.elm, i);
        } else {
            var ancestor = vnode;
            while (ancestor) {
                if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
                    nodeOps.setStyleScope(vnode.elm, i);
                }
                ancestor = ancestor.parent;
            }
        }
        // for slot content they should also get the scopeId from the host instance.
        if (isDef(i = activeInstance) && i !== vnode.context && i !== vnode.fnContext && isDef(i = i.$options._scopeId)) {
            nodeOps.setStyleScope(vnode.elm, i);
        }
    }
    function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for (; startIdx <= endIdx; ++startIdx) {
            createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
        }
    }
    function invokeDestroyHook(vnode) {
        var i, j;
        var data = vnode.data;
        if (isDef(data)) {
            if (isDef(i = data.hook) && isDef(i = i.destroy)) i(vnode);
            for (i = 0; i < cbs.destroy.length; ++i) {
                cbs.destroy[i](vnode);
            }
        }
        if (isDef(i = vnode.children)) {
            for (j = 0; j < vnode.children.length; ++j) {
                invokeDestroyHook(vnode.children[j]);
            }
        }
    }
    function removeVnodes(vnodes, startIdx, endIdx) {
        for (; startIdx <= endIdx; ++startIdx) {
            var ch = vnodes[startIdx];
            if (isDef(ch)) {
                if (isDef(ch.tag)) {
                    removeAndInvokeRemoveHook(ch);
                    invokeDestroyHook(ch);
                } else {
                    // Text node
                    removeNode(ch.elm);
                }
            }
        }
    }
    function removeAndInvokeRemoveHook(vnode, rm) {
        if (isDef(rm) || isDef(vnode.data)) {
            var i_3;
            var listeners = cbs.remove.length + 1;
            if (isDef(rm)) {
                // we have a recursively passed down rm callback
                // increase the listeners count
                rm.listeners += listeners;
            } else {
                // directly removing
                rm = createRmCb(vnode.elm, listeners);
            }
            // recursively invoke hooks on child component root node
            if (isDef(i_3 = vnode.componentInstance) && isDef(i_3 = i_3._vnode) && isDef(i_3.data)) {
                removeAndInvokeRemoveHook(i_3, rm);
            }
            for (i_3 = 0; i_3 < cbs.remove.length; ++i_3) {
                cbs.remove[i_3](vnode, rm);
            }
            if (isDef(i_3 = vnode.data.hook) && isDef(i_3 = i_3.remove)) {
                i_3(vnode, rm);
            } else {
                rm();
            }
        } else {
            removeNode(vnode.elm);
        }
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
        var oldStartIdx = 0;
        var newStartIdx = 0;
        var oldEndIdx = oldCh.length - 1;
        var oldStartVnode = oldCh[0];
        var oldEndVnode = oldCh[oldEndIdx];
        var newEndIdx = newCh.length - 1;
        var newStartVnode = newCh[0];
        var newEndVnode = newCh[newEndIdx];
        var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
        // removeOnly is a special flag used only by <transition-group>
        // to ensure removed elements stay in correct relative positions
        // during leaving transitions
        var canMove = !removeOnly;
        if (false) {
            checkDuplicateKeys(newCh);
        }
        while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
            if (isUndef(oldStartVnode)) {
                oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
            } else if (isUndef(oldEndVnode)) {
                oldEndVnode = oldCh[--oldEndIdx];
            } else if (sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            } else if (sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if (sameVnode(oldStartVnode, newEndVnode)) {
                // Vnode moved right
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if (sameVnode(oldEndVnode, newStartVnode)) {
                // Vnode moved left
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            } else {
                if (isUndef(oldKeyToIdx)) oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
                if (isUndef(idxInOld)) {
                    // New element
                    createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                } else {
                    vnodeToMove = oldCh[idxInOld];
                    if (sameVnode(vnodeToMove, newStartVnode)) {
                        patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                        oldCh[idxInOld] = undefined;
                        canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
                    } else {
                        // same key but different element. treat as new element
                        createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                    }
                }
                newStartVnode = newCh[++newStartIdx];
            }
        }
        if (oldStartIdx > oldEndIdx) {
            refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
        } else if (newStartIdx > newEndIdx) {
            removeVnodes(oldCh, oldStartIdx, oldEndIdx);
        }
    }
    function checkDuplicateKeys(children) {
        var seenKeys = {};
        for (var i_4 = 0; i_4 < children.length; i_4++) {
            var vnode = children[i_4];
            var key = vnode.key;
            if (isDef(key)) {
                if (seenKeys[key]) {
                    warn$2("Duplicate keys detected: '".concat(key, "'. This may cause an update error."), vnode.context);
                } else {
                    seenKeys[key] = true;
                }
            }
        }
    }
    function findIdxInOld(node, oldCh, start, end) {
        for (var i_5 = start; i_5 < end; i_5++) {
            var c = oldCh[i_5];
            if (isDef(c) && sameVnode(node, c)) return i_5;
        }
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index, removeOnly) {
        if (oldVnode === vnode) {
            return;
        }
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // clone reused vnode
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        var elm = vnode.elm = oldVnode.elm;
        if (isTrue(oldVnode.isAsyncPlaceholder)) {
            if (isDef(vnode.asyncFactory.resolved)) {
                hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
            } else {
                vnode.isAsyncPlaceholder = true;
            }
            return;
        }
        // reuse element for static trees.
        // note we only do this if the vnode is cloned -
        // if the new node is not cloned it means the render functions have been
        // reset by the hot-reload-api and we need to do a proper re-render.
        if (isTrue(vnode.isStatic) && isTrue(oldVnode.isStatic) && vnode.key === oldVnode.key && (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
            vnode.componentInstance = oldVnode.componentInstance;
            return;
        }
        var i;
        var data = vnode.data;
        if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
            i(oldVnode, vnode);
        }
        var oldCh = oldVnode.children;
        var ch = vnode.children;
        if (isDef(data) && isPatchable(vnode)) {
            for (i = 0; i < cbs.update.length; ++i) {
                cbs.update[i](oldVnode, vnode);
            }if (isDef(i = data.hook) && isDef(i = i.update)) i(oldVnode, vnode);
        }
        if (isUndef(vnode.text)) {
            if (isDef(oldCh) && isDef(ch)) {
                if (oldCh !== ch) updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
            } else if (isDef(ch)) {
                if (false) {
                    checkDuplicateKeys(ch);
                }
                if (isDef(oldVnode.text)) nodeOps.setTextContent(elm, '');
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            } else if (isDef(oldCh)) {
                removeVnodes(oldCh, 0, oldCh.length - 1);
            } else if (isDef(oldVnode.text)) {
                nodeOps.setTextContent(elm, '');
            }
        } else if (oldVnode.text !== vnode.text) {
            nodeOps.setTextContent(elm, vnode.text);
        }
        if (isDef(data)) {
            if (isDef(i = data.hook) && isDef(i = i.postpatch)) i(oldVnode, vnode);
        }
    }
    function invokeInsertHook(vnode, queue, initial) {
        // delay insert hooks for component root nodes, invoke them after the
        // element is really inserted
        if (isTrue(initial) && isDef(vnode.parent)) {
            vnode.parent.data.pendingInsert = queue;
        } else {
            for (var i_6 = 0; i_6 < queue.length; ++i_6) {
                queue[i_6].data.hook.insert(queue[i_6]);
            }
        }
    }
    var hydrationBailed = false;
    // list of modules that can skip create hook during hydration because they
    // are already rendered on the client or has no need for initialization
    // Note: style is excluded because it relies on initial clone for future
    // deep updates (#7063).
    var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');
    // Note: this is a browser-only function so we can assume elms are DOM nodes.
    function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
        var i;
        var tag = vnode.tag,
            data = vnode.data,
            children = vnode.children;
        inVPre = inVPre || data && data.pre;
        vnode.elm = elm;
        if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
            vnode.isAsyncPlaceholder = true;
            return true;
        }
        // assert node match
        if (false) {
            if (!assertNodeMatch(elm, vnode, inVPre)) {
                return false;
            }
        }
        if (isDef(data)) {
            if (isDef(i = data.hook) && isDef(i = i.init)) i(vnode, true /* hydrating */);
            if (isDef(i = vnode.componentInstance)) {
                // child component. it should have hydrated its own tree.
                initComponent(vnode, insertedVnodeQueue);
                return true;
            }
        }
        if (isDef(tag)) {
            if (isDef(children)) {
                // empty element, allow client to pick up and populate children
                if (!elm.hasChildNodes()) {
                    createChildren(vnode, children, insertedVnodeQueue);
                } else {
                    // v-html and domProps: innerHTML
                    if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
                        if (i !== elm.innerHTML) {
                            /* istanbul ignore if */
                            if (false) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('server innerHTML: ', i);
                                console.warn('client innerHTML: ', elm.innerHTML);
                            }
                            return false;
                        }
                    } else {
                        // iterate and compare children lists
                        var childrenMatch = true;
                        var childNode = elm.firstChild;
                        for (var i_7 = 0; i_7 < children.length; i_7++) {
                            if (!childNode || !hydrate(childNode, children[i_7], insertedVnodeQueue, inVPre)) {
                                childrenMatch = false;
                                break;
                            }
                            childNode = childNode.nextSibling;
                        }
                        // if childNode is not null, it means the actual childNodes list is
                        // longer than the virtual children list.
                        if (!childrenMatch || childNode) {
                            /* istanbul ignore if */
                            if (false) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
                            }
                            return false;
                        }
                    }
                }
            }
            if (isDef(data)) {
                var fullInvoke = false;
                for (var key in data) {
                    if (!isRenderedModule(key)) {
                        fullInvoke = true;
                        invokeCreateHooks(vnode, insertedVnodeQueue);
                        break;
                    }
                }
                if (!fullInvoke && data['class']) {
                    // ensure collecting deps for deep class bindings for future updates
                    traverse(data['class']);
                }
            }
        } else if (elm.data !== vnode.text) {
            elm.data = vnode.text;
        }
        return true;
    }
    function assertNodeMatch(node, vnode, inVPre) {
        if (isDef(vnode.tag)) {
            return vnode.tag.indexOf('vue-component') === 0 || !isUnknownElement(vnode, inVPre) && vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase());
        } else {
            return node.nodeType === (vnode.isComment ? 8 : 3);
        }
    }
    return function patch(oldVnode, vnode, hydrating, removeOnly) {
        if (isUndef(vnode)) {
            if (isDef(oldVnode)) invokeDestroyHook(oldVnode);
            return;
        }
        var isInitialPatch = false;
        var insertedVnodeQueue = [];
        if (isUndef(oldVnode)) {
            // empty mount (likely as component), create new root element
            isInitialPatch = true;
            createElm(vnode, insertedVnodeQueue);
        } else {
            var isRealElement = isDef(oldVnode.nodeType);
            if (!isRealElement && sameVnode(oldVnode, vnode)) {
                // patch existing root node
                patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
            } else {
                if (isRealElement) {
                    // mounting to a real element
                    // check if this is server-rendered content and if we can perform
                    // a successful hydration.
                    if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
                        oldVnode.removeAttribute(SSR_ATTR);
                        hydrating = true;
                    }
                    if (isTrue(hydrating)) {
                        if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                            invokeInsertHook(vnode, insertedVnodeQueue, true);
                            return oldVnode;
                        } else if (false) {
                            warn$2('The client-side rendered virtual DOM tree is not matching ' + 'server-rendered content. This is likely caused by incorrect ' + 'HTML markup, for example nesting block-level elements inside ' + '<p>, or missing <tbody>. Bailing hydration and performing ' + 'full client-side render.');
                        }
                    }
                    // either not server-rendered, or hydration failed.
                    // create an empty node and replace it
                    oldVnode = emptyNodeAt(oldVnode);
                }
                // replacing existing element
                var oldElm = oldVnode.elm;
                var parentElm = nodeOps.parentNode(oldElm);
                // create new node
                createElm(vnode, insertedVnodeQueue,
                // extremely rare edge case: do not insert if old element is in a
                // leaving transition. Only happens when combining transition +
                // keep-alive + HOCs. (#4590)
                oldElm._leaveCb ? null : parentElm, nodeOps.nextSibling(oldElm));
                // update parent placeholder node element, recursively
                if (isDef(vnode.parent)) {
                    var ancestor = vnode.parent;
                    var patchable = isPatchable(vnode);
                    while (ancestor) {
                        for (var i_8 = 0; i_8 < cbs.destroy.length; ++i_8) {
                            cbs.destroy[i_8](ancestor);
                        }
                        ancestor.elm = vnode.elm;
                        if (patchable) {
                            for (var i_9 = 0; i_9 < cbs.create.length; ++i_9) {
                                cbs.create[i_9](emptyNode, ancestor);
                            }
                            // #6513
                            // invoke insert hooks that may have been merged by create hooks.
                            // e.g. for directives that uses the "inserted" hook.
                            var insert_1 = ancestor.data.hook.insert;
                            if (insert_1.merged) {
                                // start at index 1 to avoid re-invoking component mounted hook
                                // clone insert hooks to avoid being mutated during iteration.
                                // e.g. for customed directives under transition group.
                                var cloned = insert_1.fns.slice(1);
                                for (var i_10 = 0; i_10 < cloned.length; i_10++) {
                                    cloned[i_10]();
                                }
                            }
                        } else {
                            registerRef(ancestor);
                        }
                        ancestor = ancestor.parent;
                    }
                }
                // destroy old node
                if (isDef(parentElm)) {
                    removeVnodes([oldVnode], 0, 0);
                } else if (isDef(oldVnode.tag)) {
                    invokeDestroyHook(oldVnode);
                }
            }
        }
        invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
        return vnode.elm;
    };
}

var directives$1 = {
    create: updateDirectives,
    update: updateDirectives,
    destroy: function unbindDirectives(vnode) {
        // @ts-expect-error emptyNode is not VNodeWithData
        updateDirectives(vnode, emptyNode);
    }
};
function updateDirectives(oldVnode, vnode) {
    if (oldVnode.data.directives || vnode.data.directives) {
        _update(oldVnode, vnode);
    }
}
function _update(oldVnode, vnode) {
    var isCreate = oldVnode === emptyNode;
    var isDestroy = vnode === emptyNode;
    var oldDirs = normalizeDirectives(oldVnode.data.directives, oldVnode.context);
    var newDirs = normalizeDirectives(vnode.data.directives, vnode.context);
    var dirsWithInsert = [];
    var dirsWithPostpatch = [];
    var key, oldDir, dir;
    for (key in newDirs) {
        oldDir = oldDirs[key];
        dir = newDirs[key];
        if (!oldDir) {
            // new directive, bind
            callHook(dir, 'bind', vnode, oldVnode);
            if (dir.def && dir.def.inserted) {
                dirsWithInsert.push(dir);
            }
        } else {
            // existing directive, update
            dir.oldValue = oldDir.value;
            dir.oldArg = oldDir.arg;
            callHook(dir, 'update', vnode, oldVnode);
            if (dir.def && dir.def.componentUpdated) {
                dirsWithPostpatch.push(dir);
            }
        }
    }
    if (dirsWithInsert.length) {
        var callInsert = function callInsert() {
            for (var i = 0; i < dirsWithInsert.length; i++) {
                callHook(dirsWithInsert[i], 'inserted', vnode, oldVnode);
            }
        };
        if (isCreate) {
            mergeVNodeHook(vnode, 'insert', callInsert);
        } else {
            callInsert();
        }
    }
    if (dirsWithPostpatch.length) {
        mergeVNodeHook(vnode, 'postpatch', function () {
            for (var i = 0; i < dirsWithPostpatch.length; i++) {
                callHook(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
            }
        });
    }
    if (!isCreate) {
        for (key in oldDirs) {
            if (!newDirs[key]) {
                // no longer present, unbind
                callHook(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
            }
        }
    }
}
var emptyModifiers = Object.create(null);
function normalizeDirectives(dirs, vm) {
    var res = Object.create(null);
    if (!dirs) {
        // $flow-disable-line
        return res;
    }
    var i, dir;
    for (i = 0; i < dirs.length; i++) {
        dir = dirs[i];
        if (!dir.modifiers) {
            // $flow-disable-line
            dir.modifiers = emptyModifiers;
        }
        res[getRawDirName(dir)] = dir;
        if (vm._setupState && vm._setupState.__sfc) {
            var setupDef = dir.def || resolveAsset(vm, '_setupState', 'v-' + dir.name);
            if (typeof setupDef === 'function') {
                dir.def = {
                    bind: setupDef,
                    update: setupDef
                };
            } else {
                dir.def = setupDef;
            }
        }
        dir.def = dir.def || resolveAsset(vm.$options, 'directives', dir.name, true);
    }
    // $flow-disable-line
    return res;
}
function getRawDirName(dir) {
    return dir.rawName || "".concat(dir.name, ".").concat(Object.keys(dir.modifiers || {}).join('.'));
}
function callHook(dir, hook, vnode, oldVnode, isDestroy) {
    var fn = dir.def && dir.def[hook];
    if (fn) {
        try {
            fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
        } catch (e) {
            handleError(e, vnode.context, "directive ".concat(dir.name, " ").concat(hook, " hook"));
        }
    }
}

var baseModules = [ref, directives$1];

function updateAttrs(oldVnode, vnode) {
    var opts = vnode.componentOptions;
    if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
        return;
    }
    if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
        return;
    }
    var key, cur, old;
    var elm = vnode.elm;
    var oldAttrs = oldVnode.data.attrs || {};
    var attrs = vnode.data.attrs || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(attrs.__ob__) || isTrue(attrs._v_attr_proxy)) {
        attrs = vnode.data.attrs = extend({}, attrs);
    }
    for (key in attrs) {
        cur = attrs[key];
        old = oldAttrs[key];
        if (old !== cur) {
            setAttr(elm, key, cur, vnode.data.pre);
        }
    }
    // #4391: in IE9, setting type can reset value for input[type=radio]
    // #6666: IE/Edge forces progress value down to 1 before setting a max
    /* istanbul ignore if */
    if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
        setAttr(elm, 'value', attrs.value);
    }
    for (key in oldAttrs) {
        if (isUndef(attrs[key])) {
            if (isXlink(key)) {
                elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
            } else if (!isEnumeratedAttr(key)) {
                elm.removeAttribute(key);
            }
        }
    }
}
function setAttr(el, key, value, isInPre) {
    if (isInPre || el.tagName.indexOf('-') > -1) {
        baseSetAttr(el, key, value);
    } else if (isBooleanAttr(key)) {
        // set attribute for blank value
        // e.g. <option disabled>Select one</option>
        if (isFalsyAttrValue(value)) {
            el.removeAttribute(key);
        } else {
            // technically allowfullscreen is a boolean attribute for <iframe>,
            // but Flash expects a value of "true" when used on <embed> tag
            value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
            el.setAttribute(key, value);
        }
    } else if (isEnumeratedAttr(key)) {
        el.setAttribute(key, convertEnumeratedValue(key, value));
    } else if (isXlink(key)) {
        if (isFalsyAttrValue(value)) {
            el.removeAttributeNS(xlinkNS, getXlinkProp(key));
        } else {
            el.setAttributeNS(xlinkNS, key, value);
        }
    } else {
        baseSetAttr(el, key, value);
    }
}
function baseSetAttr(el, key, value) {
    if (isFalsyAttrValue(value)) {
        el.removeAttribute(key);
    } else {
        // #7138: IE10 & 11 fires input event when setting placeholder on
        // <textarea>... block the first input event and remove the blocker
        // immediately.
        /* istanbul ignore if */
        if (isIE && !isIE9 && el.tagName === 'TEXTAREA' && key === 'placeholder' && value !== '' && !el.__ieph) {
            var blocker_1 = function blocker_1(e) {
                e.stopImmediatePropagation();
                el.removeEventListener('input', blocker_1);
            };
            el.addEventListener('input', blocker_1);
            // $flow-disable-line
            el.__ieph = true; /* IE placeholder patched */
        }
        el.setAttribute(key, value);
    }
}
var attrs = {
    create: updateAttrs,
    update: updateAttrs
};

function updateClass(oldVnode, vnode) {
    var el = vnode.elm;
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticClass) && isUndef(data.class) && (isUndef(oldData) || isUndef(oldData.staticClass) && isUndef(oldData.class))) {
        return;
    }
    var cls = genClassForVnode(vnode);
    // handle transition classes
    var transitionClass = el._transitionClasses;
    if (isDef(transitionClass)) {
        cls = concat(cls, stringifyClass(transitionClass));
    }
    // set the class
    if (cls !== el._prevClass) {
        el.setAttribute('class', cls);
        el._prevClass = cls;
    }
}
var klass$1 = {
    create: updateClass,
    update: updateClass
};

var validDivisionCharRE = /[\w).+\-_$\]]/;
function parseFilters(exp) {
    var inSingle = false;
    var inDouble = false;
    var inTemplateString = false;
    var inRegex = false;
    var curly = 0;
    var square = 0;
    var paren = 0;
    var lastFilterIndex = 0;
    var c, prev, i, expression, filters;
    for (i = 0; i < exp.length; i++) {
        prev = c;
        c = exp.charCodeAt(i);
        if (inSingle) {
            if (c === 0x27 && prev !== 0x5c) inSingle = false;
        } else if (inDouble) {
            if (c === 0x22 && prev !== 0x5c) inDouble = false;
        } else if (inTemplateString) {
            if (c === 0x60 && prev !== 0x5c) inTemplateString = false;
        } else if (inRegex) {
            if (c === 0x2f && prev !== 0x5c) inRegex = false;
        } else if (c === 0x7c && // pipe
        exp.charCodeAt(i + 1) !== 0x7c && exp.charCodeAt(i - 1) !== 0x7c && !curly && !square && !paren) {
            if (expression === undefined) {
                // first filter, end of expression
                lastFilterIndex = i + 1;
                expression = exp.slice(0, i).trim();
            } else {
                pushFilter();
            }
        } else {
            switch (c) {
                case 0x22:
                    inDouble = true;
                    break; // "
                case 0x27:
                    inSingle = true;
                    break; // '
                case 0x60:
                    inTemplateString = true;
                    break; // `
                case 0x28:
                    paren++;
                    break; // (
                case 0x29:
                    paren--;
                    break; // )
                case 0x5b:
                    square++;
                    break; // [
                case 0x5d:
                    square--;
                    break; // ]
                case 0x7b:
                    curly++;
                    break; // {
                case 0x7d:
                    curly--;
                    break; // }
            }
            if (c === 0x2f) {
                // /
                var j = i - 1;
                var p
                // find first non-whitespace prev char
                = void 0;
                // find first non-whitespace prev char
                for (; j >= 0; j--) {
                    p = exp.charAt(j);
                    if (p !== ' ') break;
                }
                if (!p || !validDivisionCharRE.test(p)) {
                    inRegex = true;
                }
            }
        }
    }
    if (expression === undefined) {
        expression = exp.slice(0, i).trim();
    } else if (lastFilterIndex !== 0) {
        pushFilter();
    }
    function pushFilter() {
        (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
        lastFilterIndex = i + 1;
    }
    if (filters) {
        for (i = 0; i < filters.length; i++) {
            expression = wrapFilter(expression, filters[i]);
        }
    }
    return expression;
}
function wrapFilter(exp, filter) {
    var i = filter.indexOf('(');
    if (i < 0) {
        // _f: resolveFilter
        return "_f(\"".concat(filter, "\")(").concat(exp, ")");
    } else {
        var name_1 = filter.slice(0, i);
        var args = filter.slice(i + 1);
        return "_f(\"".concat(name_1, "\")(").concat(exp).concat(args !== ')' ? ',' + args : args);
    }
}

/* eslint-disable no-unused-vars */
function baseWarn(msg, range) {
    console.error("[Vue compiler]: ".concat(msg));
}
/* eslint-enable no-unused-vars */
function pluckModuleFunction(modules, key) {
    return modules ? modules.map(function (m) {
        return m[key];
    }).filter(function (_) {
        return _;
    }) : [];
}
function addProp(el, name, value, range, dynamic) {
    (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
    el.plain = false;
}
function addAttr(el, name, value, range, dynamic) {
    var attrs = dynamic ? el.dynamicAttrs || (el.dynamicAttrs = []) : el.attrs || (el.attrs = []);
    attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
    el.plain = false;
}
// add a raw attr (use this in preTransforms)
function addRawAttr(el, name, value, range) {
    el.attrsMap[name] = value;
    el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}
function addDirective(el, name, rawName, value, arg, isDynamicArg, modifiers, range) {
    (el.directives || (el.directives = [])).push(rangeSetItem({
        name: name,
        rawName: rawName,
        value: value,
        arg: arg,
        isDynamicArg: isDynamicArg,
        modifiers: modifiers
    }, range));
    el.plain = false;
}
function prependModifierMarker(symbol, name, dynamic) {
    return dynamic ? "_p(".concat(name, ",\"").concat(symbol, "\")") : symbol + name; // mark the event as captured
}
function addHandler(el, name, value, modifiers, important, warn, range, dynamic) {
    modifiers = modifiers || emptyObject;
    // warn prevent and passive modifier
    /* istanbul ignore if */
    if (false) {
        warn("passive and prevent can't be used together. " + "Passive handler can't prevent default event.", range);
    }
    // normalize click.right and click.middle since they don't actually fire
    // this is technically browser-specific, but at least for now browsers are
    // the only target envs that have right/middle clicks.
    if (modifiers.right) {
        if (dynamic) {
            name = "(".concat(name, ")==='click'?'contextmenu':(").concat(name, ")");
        } else if (name === 'click') {
            name = 'contextmenu';
            delete modifiers.right;
        }
    } else if (modifiers.middle) {
        if (dynamic) {
            name = "(".concat(name, ")==='click'?'mouseup':(").concat(name, ")");
        } else if (name === 'click') {
            name = 'mouseup';
        }
    }
    // check capture modifier
    if (modifiers.capture) {
        delete modifiers.capture;
        name = prependModifierMarker('!', name, dynamic);
    }
    if (modifiers.once) {
        delete modifiers.once;
        name = prependModifierMarker('~', name, dynamic);
    }
    /* istanbul ignore if */
    if (modifiers.passive) {
        delete modifiers.passive;
        name = prependModifierMarker('&', name, dynamic);
    }
    var events;
    if (modifiers.native) {
        delete modifiers.native;
        events = el.nativeEvents || (el.nativeEvents = {});
    } else {
        events = el.events || (el.events = {});
    }
    var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
    if (modifiers !== emptyObject) {
        newHandler.modifiers = modifiers;
    }
    var handlers = events[name];
    /* istanbul ignore if */
    if (Array.isArray(handlers)) {
        important ? handlers.unshift(newHandler) : handlers.push(newHandler);
    } else if (handlers) {
        events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
    } else {
        events[name] = newHandler;
    }
    el.plain = false;
}
function getRawBindingAttr(el, name) {
    return el.rawAttrsMap[':' + name] || el.rawAttrsMap['v-bind:' + name] || el.rawAttrsMap[name];
}
function getBindingAttr(el, name, getStatic) {
    var dynamicValue = getAndRemoveAttr(el, ':' + name) || getAndRemoveAttr(el, 'v-bind:' + name);
    if (dynamicValue != null) {
        return parseFilters(dynamicValue);
    } else if (getStatic !== false) {
        var staticValue = getAndRemoveAttr(el, name);
        if (staticValue != null) {
            return JSON.stringify(staticValue);
        }
    }
}
// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr(el, name, removeFromMap) {
    var val;
    if ((val = el.attrsMap[name]) != null) {
        var list = el.attrsList;
        for (var i = 0, l = list.length; i < l; i++) {
            if (list[i].name === name) {
                list.splice(i, 1);
                break;
            }
        }
    }
    if (removeFromMap) {
        delete el.attrsMap[name];
    }
    return val;
}
function getAndRemoveAttrByRegex(el, name) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
        var attr = list[i];
        if (name.test(attr.name)) {
            list.splice(i, 1);
            return attr;
        }
    }
}
function rangeSetItem(item, range) {
    if (range) {
        if (range.start != null) {
            item.start = range.start;
        }
        if (range.end != null) {
            item.end = range.end;
        }
    }
    return item;
}

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel(el, value, modifiers) {
    var _a = modifiers || {},
        number = _a.number,
        trim = _a.trim;
    var baseValueExpression = '$$v';
    var valueExpression = baseValueExpression;
    if (trim) {
        valueExpression = "(typeof ".concat(baseValueExpression, " === 'string'") + "? ".concat(baseValueExpression, ".trim()") + ": ".concat(baseValueExpression, ")");
    }
    if (number) {
        valueExpression = "_n(".concat(valueExpression, ")");
    }
    var assignment = genAssignmentCode(value, valueExpression);
    el.model = {
        value: "(".concat(value, ")"),
        expression: JSON.stringify(value),
        callback: "function (".concat(baseValueExpression, ") {").concat(assignment, "}")
    };
}
/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode(value, assignment) {
    var res = parseModel(value);
    if (res.key === null) {
        return "".concat(value, "=").concat(assignment);
    } else {
        return "$set(".concat(res.exp, ", ").concat(res.key, ", ").concat(assignment, ")");
    }
}
/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */
var len, str, chr, index, expressionPos, expressionEndPos;
function parseModel(val) {
    // Fix https://github.com/vuejs/vue/pull/7730
    // allow v-model="obj.val " (trailing whitespace)
    val = val.trim();
    len = val.length;
    if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
        index = val.lastIndexOf('.');
        if (index > -1) {
            return {
                exp: val.slice(0, index),
                key: '"' + val.slice(index + 1) + '"'
            };
        } else {
            return {
                exp: val,
                key: null
            };
        }
    }
    str = val;
    index = expressionPos = expressionEndPos = 0;
    while (!eof()) {
        chr = next();
        /* istanbul ignore if */
        if (isStringStart(chr)) {
            parseString(chr);
        } else if (chr === 0x5b) {
            parseBracket(chr);
        }
    }
    return {
        exp: val.slice(0, expressionPos),
        key: val.slice(expressionPos + 1, expressionEndPos)
    };
}
function next() {
    return str.charCodeAt(++index);
}
function eof() {
    return index >= len;
}
function isStringStart(chr) {
    return chr === 0x22 || chr === 0x27;
}
function parseBracket(chr) {
    var inBracket = 1;
    expressionPos = index;
    while (!eof()) {
        chr = next();
        if (isStringStart(chr)) {
            parseString(chr);
            continue;
        }
        if (chr === 0x5b) inBracket++;
        if (chr === 0x5d) inBracket--;
        if (inBracket === 0) {
            expressionEndPos = index;
            break;
        }
    }
}
function parseString(chr) {
    var stringQuote = chr;
    while (!eof()) {
        chr = next();
        if (chr === stringQuote) {
            break;
        }
    }
}

var warn$1;
// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';
function model$1(el, dir, _warn) {
    warn$1 = _warn;
    var value = dir.value;
    var modifiers = dir.modifiers;
    var tag = el.tag;
    var type = el.attrsMap.type;
    if (false) {
        // inputs with type="file" are read only and setting the input's
        // value will throw an error.
        if (tag === 'input' && type === 'file') {
            warn$1("<".concat(el.tag, " v-model=\"").concat(value, "\" type=\"file\">:\n") + "File inputs are read only. Use a v-on:change listener instead.", el.rawAttrsMap['v-model']);
        }
    }
    if (el.component) {
        genComponentModel(el, value, modifiers);
        // component v-model doesn't need extra runtime
        return false;
    } else if (tag === 'select') {
        genSelect(el, value, modifiers);
    } else if (tag === 'input' && type === 'checkbox') {
        genCheckboxModel(el, value, modifiers);
    } else if (tag === 'input' && type === 'radio') {
        genRadioModel(el, value, modifiers);
    } else if (tag === 'input' || tag === 'textarea') {
        genDefaultModel(el, value, modifiers);
    } else if (!config.isReservedTag(tag)) {
        genComponentModel(el, value, modifiers);
        // component v-model doesn't need extra runtime
        return false;
    } else if (false) {
        warn$1("<".concat(el.tag, " v-model=\"").concat(value, "\">: ") + "v-model is not supported on this element type. " + "If you are working with contenteditable, it's recommended to " + 'wrap a library dedicated for that purpose inside a custom component.', el.rawAttrsMap['v-model']);
    }
    // ensure runtime directive metadata
    return true;
}
function genCheckboxModel(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
    var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
    addProp(el, 'checked', "Array.isArray(".concat(value, ")") + "?_i(".concat(value, ",").concat(valueBinding, ")>-1") + (trueValueBinding === 'true' ? ":(".concat(value, ")") : ":_q(".concat(value, ",").concat(trueValueBinding, ")")));
    addHandler(el, 'change', "var $$a=".concat(value, ",") + '$$el=$event.target,' + "$$c=$$el.checked?(".concat(trueValueBinding, "):(").concat(falseValueBinding, ");") + 'if(Array.isArray($$a)){' + "var $$v=".concat(number ? '_n(' + valueBinding + ')' : valueBinding, ",") + '$$i=_i($$a,$$v);' + "if($$el.checked){$$i<0&&(".concat(genAssignmentCode(value, '$$a.concat([$$v])'), ")}") + "else{$$i>-1&&(".concat(genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))'), ")}") + "}else{".concat(genAssignmentCode(value, '$$c'), "}"), null, true);
}
function genRadioModel(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    valueBinding = number ? "_n(".concat(valueBinding, ")") : valueBinding;
    addProp(el, 'checked', "_q(".concat(value, ",").concat(valueBinding, ")"));
    addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}
function genSelect(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var selectedVal = "Array.prototype.filter" + ".call($event.target.options,function(o){return o.selected})" + ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" + "return ".concat(number ? '_n(val)' : 'val', "})");
    var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
    var code = "var $$selectedVal = ".concat(selectedVal, ";");
    code = "".concat(code, " ").concat(genAssignmentCode(value, assignment));
    addHandler(el, 'change', code, null, true);
}
function genDefaultModel(el, value, modifiers) {
    var type = el.attrsMap.type;
    // warn if v-bind:value conflicts with v-model
    // except for inputs with v-bind:type
    if (false) {
        var value_1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
        var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
        if (value_1 && !typeBinding) {
            var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
            warn$1("".concat(binding, "=\"").concat(value_1, "\" conflicts with v-model on the same element ") + 'because the latter already expands to a value binding internally', el.rawAttrsMap[binding]);
        }
    }
    var _a = modifiers || {},
        lazy = _a.lazy,
        number = _a.number,
        trim = _a.trim;
    var needCompositionGuard = !lazy && type !== 'range';
    var event = lazy ? 'change' : type === 'range' ? RANGE_TOKEN : 'input';
    var valueExpression = '$event.target.value';
    if (trim) {
        valueExpression = "$event.target.value.trim()";
    }
    if (number) {
        valueExpression = "_n(".concat(valueExpression, ")");
    }
    var code = genAssignmentCode(value, valueExpression);
    if (needCompositionGuard) {
        code = "if($event.target.composing)return;".concat(code);
    }
    addProp(el, 'value', "(".concat(value, ")"));
    addHandler(el, event, code, null, true);
    if (trim || number) {
        addHandler(el, 'blur', '$forceUpdate()');
    }
}

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents(on) {
    /* istanbul ignore if */
    if (isDef(on[RANGE_TOKEN])) {
        // IE input[type=range] only supports `change` event
        var event_1 = isIE ? 'change' : 'input';
        on[event_1] = [].concat(on[RANGE_TOKEN], on[event_1] || []);
        delete on[RANGE_TOKEN];
    }
    // This was originally intended to fix #4521 but no longer necessary
    // after 2.5. Keeping it for backwards compat with generated code from < 2.4
    /* istanbul ignore if */
    if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
        on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
        delete on[CHECKBOX_RADIO_TOKEN];
    }
}
var target;
function createOnceHandler(event, handler, capture) {
    var _target = target; // save current target element in closure
    return function onceHandler() {
        var res = handler.apply(null, arguments);
        if (res !== null) {
            remove(event, onceHandler, capture, _target);
        }
    };
}
// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);
function add(name, handler, capture, passive) {
    // async edge case #6566: inner click event triggers patch, event handler
    // attached to outer element during patch, and triggered again. This
    // happens because browsers fire microtask ticks between event propagation.
    // the solution is simple: we save the timestamp when a handler is attached,
    // and the handler would only fire if the event passed to it was fired
    // AFTER it was attached.
    if (useMicrotaskFix) {
        var attachedTimestamp_1 = currentFlushTimestamp;
        var original_1 = handler;
        //@ts-expect-error
        handler = original_1._wrapper = function (e) {
            if (
            // no bubbling, should always fire.
            // this is just a safety net in case event.timeStamp is unreliable in
            // certain weird environments...
            e.target === e.currentTarget ||
            // event is fired after handler attachment
            e.timeStamp >= attachedTimestamp_1 ||
            // bail for environments that have buggy event.timeStamp implementations
            // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
            // #9681 QtWebEngine event.timeStamp is negative value
            e.timeStamp <= 0 ||
            // #9448 bail if event is fired in another document in a multi-page
            // electron/nw.js app, since event.timeStamp will be using a different
            // starting reference
            e.target.ownerDocument !== document) {
                return original_1.apply(this, arguments);
            }
        };
    }
    target.addEventListener(name, handler, supportsPassive ? { capture: capture, passive: passive } : capture);
}
function remove(name, handler, capture, _target) {
    (_target || target).removeEventListener(name,
    //@ts-expect-error
    handler._wrapper || handler, capture);
}
function updateDOMListeners(oldVnode, vnode) {
    if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
        return;
    }
    var on = vnode.data.on || {};
    var oldOn = oldVnode.data.on || {};
    // vnode is empty when removing all listeners,
    // and use old vnode dom element
    target = vnode.elm || oldVnode.elm;
    normalizeEvents(on);
    updateListeners(on, oldOn, add, remove, createOnceHandler, vnode.context);
    target = undefined;
}
var events = {
    create: updateDOMListeners,
    update: updateDOMListeners,
    // @ts-expect-error emptyNode has actually data
    destroy: function destroy(vnode) {
        return updateDOMListeners(vnode, emptyNode);
    }
};

var svgContainer;
function updateDOMProps(oldVnode, vnode) {
    if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
        return;
    }
    var key, cur;
    var elm = vnode.elm;
    var oldProps = oldVnode.data.domProps || {};
    var props = vnode.data.domProps || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(props.__ob__) || isTrue(props._v_attr_proxy)) {
        props = vnode.data.domProps = extend({}, props);
    }
    for (key in oldProps) {
        if (!(key in props)) {
            elm[key] = '';
        }
    }
    for (key in props) {
        cur = props[key];
        // ignore children if the node has textContent or innerHTML,
        // as these will throw away existing DOM nodes and cause removal errors
        // on subsequent patches (#3360)
        if (key === 'textContent' || key === 'innerHTML') {
            if (vnode.children) vnode.children.length = 0;
            if (cur === oldProps[key]) continue;
            // #6601 work around Chrome version <= 55 bug where single textNode
            // replaced by innerHTML/textContent retains its parentNode property
            if (elm.childNodes.length === 1) {
                elm.removeChild(elm.childNodes[0]);
            }
        }
        if (key === 'value' && elm.tagName !== 'PROGRESS') {
            // store value as _value as well since
            // non-string values will be stringified
            elm._value = cur;
            // avoid resetting cursor position when value is the same
            var strCur = isUndef(cur) ? '' : String(cur);
            if (shouldUpdateValue(elm, strCur)) {
                elm.value = strCur;
            }
        } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
            // IE doesn't support innerHTML for SVG elements
            svgContainer = svgContainer || document.createElement('div');
            svgContainer.innerHTML = "<svg>".concat(cur, "</svg>");
            var svg = svgContainer.firstChild;
            while (elm.firstChild) {
                elm.removeChild(elm.firstChild);
            }
            while (svg.firstChild) {
                elm.appendChild(svg.firstChild);
            }
        } else if (
        // skip the update if old and new VDOM state is the same.
        // `value` is handled separately because the DOM value may be temporarily
        // out of sync with VDOM state due to focus, composition and modifiers.
        // This  #4521 by skipping the unnecessary `checked` update.
        cur !== oldProps[key]) {
            // some property updates can throw
            // e.g. `value` on <progress> w/ non-finite value
            try {
                elm[key] = cur;
            } catch (e) {}
        }
    }
}
function shouldUpdateValue(elm, checkVal) {
    return (
        //@ts-expect-error
        !elm.composing && (elm.tagName === 'OPTION' || isNotInFocusAndDirty(elm, checkVal) || isDirtyWithModifiers(elm, checkVal))
    );
}
function isNotInFocusAndDirty(elm, checkVal) {
    // return true when textbox (.number and .trim) loses focus and its value is
    // not equal to the updated value
    var notInFocus = true;
    // #6157
    // work around IE bug when accessing document.activeElement in an iframe
    try {
        notInFocus = document.activeElement !== elm;
    } catch (e) {}
    return notInFocus && elm.value !== checkVal;
}
function isDirtyWithModifiers(elm, newVal) {
    var value = elm.value;
    var modifiers = elm._vModifiers; // injected by v-model runtime
    if (isDef(modifiers)) {
        if (modifiers.number) {
            return toNumber(value) !== toNumber(newVal);
        }
        if (modifiers.trim) {
            return value.trim() !== newVal.trim();
        }
    }
    return value !== newVal;
}
var domProps = {
    create: updateDOMProps,
    update: updateDOMProps
};

var parseStyleText = cached(function (cssText) {
    var res = {};
    var listDelimiter = /;(?![^(]*\))/g;
    var propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function (item) {
        if (item) {
            var tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return res;
});
// merge static and dynamic style data on the same vnode
function normalizeStyleData(data) {
    var style = normalizeStyleBinding(data.style);
    // static style is pre-processed into an object during compilation
    // and is always a fresh object, so it's safe to merge into it
    return data.staticStyle ? extend(data.staticStyle, style) : style;
}
// normalize possible array / string values into Object
function normalizeStyleBinding(bindingStyle) {
    if (Array.isArray(bindingStyle)) {
        return toObject(bindingStyle);
    }
    if (typeof bindingStyle === 'string') {
        return parseStyleText(bindingStyle);
    }
    return bindingStyle;
}
/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle(vnode, checkChild) {
    var res = {};
    var styleData;
    if (checkChild) {
        var childNode = vnode;
        while (childNode.componentInstance) {
            childNode = childNode.componentInstance._vnode;
            if (childNode && childNode.data && (styleData = normalizeStyleData(childNode.data))) {
                extend(res, styleData);
            }
        }
    }
    if (styleData = normalizeStyleData(vnode.data)) {
        extend(res, styleData);
    }
    var parentNode = vnode;
    // @ts-expect-error parentNode.parent not VNodeWithData
    while (parentNode = parentNode.parent) {
        if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
            extend(res, styleData);
        }
    }
    return res;
}

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function setProp(el, name, val) {
    /* istanbul ignore if */
    if (cssVarRE.test(name)) {
        el.style.setProperty(name, val);
    } else if (importantRE.test(val)) {
        el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
    } else {
        var normalizedName = normalize(name);
        if (Array.isArray(val)) {
            // Support values array created by autoprefixer, e.g.
            // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
            // Set them one by one, and the browser will only set those it can recognize
            for (var i = 0, len = val.length; i < len; i++) {
                el.style[normalizedName] = val[i];
            }
        } else {
            el.style[normalizedName] = val;
        }
    }
};
var vendorNames = ['Webkit', 'Moz', 'ms'];
var emptyStyle;
var normalize = cached(function (prop) {
    emptyStyle = emptyStyle || document.createElement('div').style;
    prop = camelize(prop);
    if (prop !== 'filter' && prop in emptyStyle) {
        return prop;
    }
    var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
    for (var i = 0; i < vendorNames.length; i++) {
        var name_1 = vendorNames[i] + capName;
        if (name_1 in emptyStyle) {
            return name_1;
        }
    }
});
function updateStyle(oldVnode, vnode) {
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticStyle) && isUndef(data.style) && isUndef(oldData.staticStyle) && isUndef(oldData.style)) {
        return;
    }
    var cur, name;
    var el = vnode.elm;
    var oldStaticStyle = oldData.staticStyle;
    var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
    // if static style exists, stylebinding already merged into it when doing normalizeStyleData
    var oldStyle = oldStaticStyle || oldStyleBinding;
    var style = normalizeStyleBinding(vnode.data.style) || {};
    // store normalized style under a different key for next diff
    // make sure to clone it if it's reactive, since the user likely wants
    // to mutate it.
    vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;
    var newStyle = getStyle(vnode, true);
    for (name in oldStyle) {
        if (isUndef(newStyle[name])) {
            setProp(el, name, '');
        }
    }
    for (name in newStyle) {
        cur = newStyle[name];
        // ie9 setting to null has no effect, must use empty string
        setProp(el, name, cur == null ? '' : cur);
    }
}
var style$1 = {
    create: updateStyle,
    update: updateStyle
};

var whitespaceRE$1 = /\s+/;
/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE$1).forEach(function (c) {
                return el.classList.add(c);
            });
        } else {
            el.classList.add(cls);
        }
    } else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        if (cur.indexOf(' ' + cls + ' ') < 0) {
            el.setAttribute('class', (cur + cls).trim());
        }
    }
}
/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE$1).forEach(function (c) {
                return el.classList.remove(c);
            });
        } else {
            el.classList.remove(cls);
        }
        if (!el.classList.length) {
            el.removeAttribute('class');
        }
    } else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        var tar = ' ' + cls + ' ';
        while (cur.indexOf(tar) >= 0) {
            cur = cur.replace(tar, ' ');
        }
        cur = cur.trim();
        if (cur) {
            el.setAttribute('class', cur);
        } else {
            el.removeAttribute('class');
        }
    }
}

function resolveTransition(def) {
    if (!def) {
        return;
    }
    /* istanbul ignore else */
    if ((typeof def === 'undefined' ? 'undefined' : _typeof(def)) === 'object') {
        var res = {};
        if (def.css !== false) {
            extend(res, autoCssTransition(def.name || 'v'));
        }
        extend(res, def);
        return res;
    } else if (typeof def === 'string') {
        return autoCssTransition(def);
    }
}
var autoCssTransition = cached(function (name) {
    return {
        enterClass: "".concat(name, "-enter"),
        enterToClass: "".concat(name, "-enter-to"),
        enterActiveClass: "".concat(name, "-enter-active"),
        leaveClass: "".concat(name, "-leave"),
        leaveToClass: "".concat(name, "-leave-to"),
        leaveActiveClass: "".concat(name, "-leave-active")
    };
});
var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';
// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
    /* istanbul ignore if */
    if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) {
        transitionProp = 'WebkitTransition';
        transitionEndEvent = 'webkitTransitionEnd';
    }
    if (window.onanimationend === undefined && window.onwebkitanimationend !== undefined) {
        animationProp = 'WebkitAnimation';
        animationEndEvent = 'webkitAnimationEnd';
    }
}
// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser ? window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout : /* istanbul ignore next */function ( /* istanbul ignore next */fn) {
    return fn();
};
function nextFrame(fn) {
    raf(function () {
        // @ts-expect-error
        raf(fn);
    });
}
function addTransitionClass(el, cls) {
    var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
    if (transitionClasses.indexOf(cls) < 0) {
        transitionClasses.push(cls);
        addClass(el, cls);
    }
}
function removeTransitionClass(el, cls) {
    if (el._transitionClasses) {
        remove$2(el._transitionClasses, cls);
    }
    removeClass(el, cls);
}
function whenTransitionEnds(el, expectedType, cb) {
    var _a = getTransitionInfo(el, expectedType),
        type = _a.type,
        timeout = _a.timeout,
        propCount = _a.propCount;
    if (!type) return cb();
    var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
    var ended = 0;
    var end = function end() {
        el.removeEventListener(event, onEnd);
        cb();
    };
    var onEnd = function onEnd(e) {
        if (e.target === el) {
            if (++ended >= propCount) {
                end();
            }
        }
    };
    setTimeout(function () {
        if (ended < propCount) {
            end();
        }
    }, timeout + 1);
    el.addEventListener(event, onEnd);
}
var transformRE = /\b(transform|all)(,|$)/;
function getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
    var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
    var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
    var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
    var animationTimeout = getTimeout(animationDelays, animationDurations);
    var type;
    var timeout = 0;
    var propCount = 0;
    /* istanbul ignore if */
    if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
        propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + 'Property']);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function getTimeout(delays, durations) {
    /* istanbul ignore next */
    while (delays.length < durations.length) {
        delays = delays.concat(delays);
    }
    return Math.max.apply(null, durations.map(function (d, i) {
        return toMs(d) + toMs(delays[i]);
    }));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs(s) {
    return Number(s.slice(0, -1).replace(',', '.')) * 1000;
}

function enter(vnode, toggleDisplay) {
    var el = vnode.elm;
    // call leave callback now
    if (isDef(el._leaveCb)) {
        el._leaveCb.cancelled = true;
        el._leaveCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data)) {
        return;
    }
    /* istanbul ignore if */
    if (isDef(el._enterCb) || el.nodeType !== 1) {
        return;
    }
    var css = data.css,
        type = data.type,
        enterClass = data.enterClass,
        enterToClass = data.enterToClass,
        enterActiveClass = data.enterActiveClass,
        appearClass = data.appearClass,
        appearToClass = data.appearToClass,
        appearActiveClass = data.appearActiveClass,
        beforeEnter = data.beforeEnter,
        enter = data.enter,
        afterEnter = data.afterEnter,
        enterCancelled = data.enterCancelled,
        beforeAppear = data.beforeAppear,
        appear = data.appear,
        afterAppear = data.afterAppear,
        appearCancelled = data.appearCancelled,
        duration = data.duration;
    // activeInstance will always be the <transition> component managing this
    // transition. One edge case to check is when the <transition> is placed
    // as the root node of a child component. In that case we need to check
    // <transition>'s parent for appear check.
    var context = activeInstance;
    var transitionNode = activeInstance.$vnode;
    while (transitionNode && transitionNode.parent) {
        context = transitionNode.context;
        transitionNode = transitionNode.parent;
    }
    var isAppear = !context._isMounted || !vnode.isRootInsert;
    if (isAppear && !appear && appear !== '') {
        return;
    }
    var startClass = isAppear && appearClass ? appearClass : enterClass;
    var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
    var toClass = isAppear && appearToClass ? appearToClass : enterToClass;
    var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
    var enterHook = isAppear ? isFunction(appear) ? appear : enter : enter;
    var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
    var enterCancelledHook = isAppear ? appearCancelled || enterCancelled : enterCancelled;
    var explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);
    if (false) {
        checkDuration(explicitEnterDuration, 'enter', vnode);
    }
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(enterHook);
    var cb = el._enterCb = once(function () {
        if (expectsCSS) {
            removeTransitionClass(el, toClass);
            removeTransitionClass(el, activeClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, startClass);
            }
            enterCancelledHook && enterCancelledHook(el);
        } else {
            afterEnterHook && afterEnterHook(el);
        }
        el._enterCb = null;
    });
    if (!vnode.data.show) {
        // remove pending leave element on enter by injecting an insert hook
        mergeVNodeHook(vnode, 'insert', function () {
            var parent = el.parentNode;
            var pendingNode = parent && parent._pending && parent._pending[vnode.key];
            if (pendingNode && pendingNode.tag === vnode.tag && pendingNode.elm._leaveCb) {
                pendingNode.elm._leaveCb();
            }
            enterHook && enterHook(el, cb);
        });
    }
    // start enter transition
    beforeEnterHook && beforeEnterHook(el);
    if (expectsCSS) {
        addTransitionClass(el, startClass);
        addTransitionClass(el, activeClass);
        nextFrame(function () {
            removeTransitionClass(el, startClass);
            // @ts-expect-error
            if (!cb.cancelled) {
                addTransitionClass(el, toClass);
                if (!userWantsControl) {
                    if (isValidDuration(explicitEnterDuration)) {
                        setTimeout(cb, explicitEnterDuration);
                    } else {
                        whenTransitionEnds(el, type, cb);
                    }
                }
            }
        });
    }
    if (vnode.data.show) {
        toggleDisplay && toggleDisplay();
        enterHook && enterHook(el, cb);
    }
    if (!expectsCSS && !userWantsControl) {
        cb();
    }
}
function leave(vnode, rm) {
    var el = vnode.elm;
    // call enter callback now
    if (isDef(el._enterCb)) {
        el._enterCb.cancelled = true;
        el._enterCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data) || el.nodeType !== 1) {
        return rm();
    }
    /* istanbul ignore if */
    if (isDef(el._leaveCb)) {
        return;
    }
    var css = data.css,
        type = data.type,
        leaveClass = data.leaveClass,
        leaveToClass = data.leaveToClass,
        leaveActiveClass = data.leaveActiveClass,
        beforeLeave = data.beforeLeave,
        leave = data.leave,
        afterLeave = data.afterLeave,
        leaveCancelled = data.leaveCancelled,
        delayLeave = data.delayLeave,
        duration = data.duration;
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(leave);
    var explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);
    if (false) {
        checkDuration(explicitLeaveDuration, 'leave', vnode);
    }
    var cb = el._leaveCb = once(function () {
        if (el.parentNode && el.parentNode._pending) {
            el.parentNode._pending[vnode.key] = null;
        }
        if (expectsCSS) {
            removeTransitionClass(el, leaveToClass);
            removeTransitionClass(el, leaveActiveClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, leaveClass);
            }
            leaveCancelled && leaveCancelled(el);
        } else {
            rm();
            afterLeave && afterLeave(el);
        }
        el._leaveCb = null;
    });
    if (delayLeave) {
        delayLeave(performLeave);
    } else {
        performLeave();
    }
    function performLeave() {
        // the delayed leave may have already been cancelled
        // @ts-expect-error
        if (cb.cancelled) {
            return;
        }
        // record leaving element
        if (!vnode.data.show && el.parentNode) {
            (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] = vnode;
        }
        beforeLeave && beforeLeave(el);
        if (expectsCSS) {
            addTransitionClass(el, leaveClass);
            addTransitionClass(el, leaveActiveClass);
            nextFrame(function () {
                removeTransitionClass(el, leaveClass);
                // @ts-expect-error
                if (!cb.cancelled) {
                    addTransitionClass(el, leaveToClass);
                    if (!userWantsControl) {
                        if (isValidDuration(explicitLeaveDuration)) {
                            setTimeout(cb, explicitLeaveDuration);
                        } else {
                            whenTransitionEnds(el, type, cb);
                        }
                    }
                }
            });
        }
        leave && leave(el, cb);
        if (!expectsCSS && !userWantsControl) {
            cb();
        }
    }
}
// only used in dev mode
function checkDuration(val, name, vnode) {
    if (typeof val !== 'number') {
        warn$2("<transition> explicit ".concat(name, " duration is not a valid number - ") + "got ".concat(JSON.stringify(val), "."), vnode.context);
    } else if (isNaN(val)) {
        warn$2("<transition> explicit ".concat(name, " duration is NaN - ") + 'the duration expression might be incorrect.', vnode.context);
    }
}
function isValidDuration(val) {
    return typeof val === 'number' && !isNaN(val);
}
/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength(fn) {
    if (isUndef(fn)) {
        return false;
    }
    // @ts-expect-error
    var invokerFns = fn.fns;
    if (isDef(invokerFns)) {
        // invoker
        return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
    } else {
        // @ts-expect-error
        return (fn._length || fn.length) > 1;
    }
}
function _enter(_, vnode) {
    if (vnode.data.show !== true) {
        enter(vnode);
    }
}
var transition = inBrowser ? {
    create: _enter,
    activate: _enter,
    remove: function remove(vnode, rm) {
        /* istanbul ignore else */
        if (vnode.data.show !== true) {
            // @ts-expect-error
            leave(vnode, rm);
        } else {
            rm();
        }
    }
} : {};

var platformModules = [attrs, klass$1, events, domProps, style$1, transition];

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules$1 = platformModules.concat(baseModules);
var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules$1 });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */
/* istanbul ignore if */
if (isIE9) {
    // http://www.matts411.com/post/internet-explorer-9-oninput/
    document.addEventListener('selectionchange', function () {
        var el = document.activeElement;
        // @ts-expect-error
        if (el && el.vmodel) {
            trigger(el, 'input');
        }
    });
}
var directive = {
    inserted: function inserted(el, binding, vnode, oldVnode) {
        if (vnode.tag === 'select') {
            // #6903
            if (oldVnode.elm && !oldVnode.elm._vOptions) {
                mergeVNodeHook(vnode, 'postpatch', function () {
                    directive.componentUpdated(el, binding, vnode);
                });
            } else {
                setSelected(el, binding, vnode.context);
            }
            el._vOptions = [].map.call(el.options, getValue);
        } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
            el._vModifiers = binding.modifiers;
            if (!binding.modifiers.lazy) {
                el.addEventListener('compositionstart', onCompositionStart);
                el.addEventListener('compositionend', onCompositionEnd);
                // Safari < 10.2 & UIWebView doesn't fire compositionend when
                // switching focus before confirming composition choice
                // this also fixes the issue where some browsers e.g. iOS Chrome
                // fires "change" instead of "input" on autocomplete.
                el.addEventListener('change', onCompositionEnd);
                /* istanbul ignore if */
                if (isIE9) {
                    el.vmodel = true;
                }
            }
        }
    },
    componentUpdated: function componentUpdated(el, binding, vnode) {
        if (vnode.tag === 'select') {
            setSelected(el, binding, vnode.context);
            // in case the options rendered by v-for have changed,
            // it's possible that the value is out-of-sync with the rendered options.
            // detect such cases and filter out values that no longer has a matching
            // option in the DOM.
            var prevOptions_1 = el._vOptions;
            var curOptions_1 = el._vOptions = [].map.call(el.options, getValue);
            if (curOptions_1.some(function (o, i) {
                return !looseEqual(o, prevOptions_1[i]);
            })) {
                // trigger change event if
                // no matching option found for at least one value
                var needReset = el.multiple ? binding.value.some(function (v) {
                    return hasNoMatchingOption(v, curOptions_1);
                }) : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions_1);
                if (needReset) {
                    trigger(el, 'change');
                }
            }
        }
    }
};
function setSelected(el, binding, vm) {
    actuallySetSelected(el, binding, vm);
    /* istanbul ignore if */
    if (isIE || isEdge) {
        setTimeout(function () {
            actuallySetSelected(el, binding, vm);
        }, 0);
    }
}
function actuallySetSelected(el, binding, vm) {
    var value = binding.value;
    var isMultiple = el.multiple;
    if (isMultiple && !Array.isArray(value)) {
        "production" !== 'production' && warn$2("<select multiple v-model=\"".concat(binding.expression, "\"> ") + "expects an Array value for its binding, but got ".concat(Object.prototype.toString.call(value).slice(8, -1)), vm);
        return;
    }
    var selected, option;
    for (var i = 0, l = el.options.length; i < l; i++) {
        option = el.options[i];
        if (isMultiple) {
            selected = looseIndexOf(value, getValue(option)) > -1;
            if (option.selected !== selected) {
                option.selected = selected;
            }
        } else {
            if (looseEqual(getValue(option), value)) {
                if (el.selectedIndex !== i) {
                    el.selectedIndex = i;
                }
                return;
            }
        }
    }
    if (!isMultiple) {
        el.selectedIndex = -1;
    }
}
function hasNoMatchingOption(value, options) {
    return options.every(function (o) {
        return !looseEqual(o, value);
    });
}
function getValue(option) {
    return '_value' in option ? option._value : option.value;
}
function onCompositionStart(e) {
    e.target.composing = true;
}
function onCompositionEnd(e) {
    // prevent triggering an input event for no reason
    if (!e.target.composing) return;
    e.target.composing = false;
    trigger(e.target, 'input');
}
function trigger(el, type) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
}

// recursively search for possible transition defined inside the component root
function locateNode(vnode) {
    // @ts-expect-error
    return vnode.componentInstance && (!vnode.data || !vnode.data.transition) ? locateNode(vnode.componentInstance._vnode) : vnode;
}
var show = {
    bind: function bind(el, _a, vnode) {
        var value = _a.value;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        var originalDisplay = el.__vOriginalDisplay = el.style.display === 'none' ? '' : el.style.display;
        if (value && transition) {
            vnode.data.show = true;
            enter(vnode, function () {
                el.style.display = originalDisplay;
            });
        } else {
            el.style.display = value ? originalDisplay : 'none';
        }
    },
    update: function update(el, _a, vnode) {
        var value = _a.value,
            oldValue = _a.oldValue;
        /* istanbul ignore if */
        if (!value === !oldValue) return;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        if (transition) {
            vnode.data.show = true;
            if (value) {
                enter(vnode, function () {
                    el.style.display = el.__vOriginalDisplay;
                });
            } else {
                leave(vnode, function () {
                    el.style.display = 'none';
                });
            }
        } else {
            el.style.display = value ? el.__vOriginalDisplay : 'none';
        }
    },
    unbind: function unbind(el, binding, vnode, oldVnode, isDestroy) {
        if (!isDestroy) {
            el.style.display = el.__vOriginalDisplay;
        }
    }
};

var platformDirectives = {
    model: directive,
    show: show
};

// Provides transition support for a single element/component.
var transitionProps = {
    name: String,
    appear: Boolean,
    css: Boolean,
    mode: String,
    type: String,
    enterClass: String,
    leaveClass: String,
    enterToClass: String,
    leaveToClass: String,
    enterActiveClass: String,
    leaveActiveClass: String,
    appearClass: String,
    appearActiveClass: String,
    appearToClass: String,
    duration: [Number, String, Object]
};
// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild(vnode) {
    var compOptions = vnode && vnode.componentOptions;
    if (compOptions && compOptions.Ctor.options.abstract) {
        return getRealChild(getFirstComponentChild(compOptions.children));
    } else {
        return vnode;
    }
}
function extractTransitionData(comp) {
    var data = {};
    var options = comp.$options;
    // props
    for (var key in options.propsData) {
        data[key] = comp[key];
    }
    // events.
    // extract listeners and pass them directly to the transition methods
    var listeners = options._parentListeners;
    for (var key in listeners) {
        data[camelize(key)] = listeners[key];
    }
    return data;
}
function placeholder(h, rawChild) {
    // @ts-expect-error
    if (/\d-keep-alive$/.test(rawChild.tag)) {
        return h('keep-alive', {
            props: rawChild.componentOptions.propsData
        });
    }
}
function hasParentTransition(vnode) {
    while (vnode = vnode.parent) {
        if (vnode.data.transition) {
            return true;
        }
    }
}
function isSameChild(child, oldChild) {
    return oldChild.key === child.key && oldChild.tag === child.tag;
}
var isNotTextNode = function isNotTextNode(c) {
    return c.tag || isAsyncPlaceholder(c);
};
var isVShowDirective = function isVShowDirective(d) {
    return d.name === 'show';
};
var Transition = {
    name: 'transition',
    props: transitionProps,
    abstract: true,
    render: function render(h) {
        var _this = this;
        var children = this.$slots.default;
        if (!children) {
            return;
        }
        // filter out text nodes (possible whitespaces)
        children = children.filter(isNotTextNode);
        /* istanbul ignore if */
        if (!children.length) {
            return;
        }
        // warn multiple elements
        if (false) {
            warn$2('<transition> can only be used on a single element. Use ' + '<transition-group> for lists.', this.$parent);
        }
        var mode = this.mode;
        // warn invalid mode
        if (false) {
            warn$2('invalid <transition> mode: ' + mode, this.$parent);
        }
        var rawChild = children[0];
        // if this is a component root node and the component's
        // parent container node also has transition, skip.
        if (hasParentTransition(this.$vnode)) {
            return rawChild;
        }
        // apply transition data to child
        // use getRealChild() to ignore abstract components e.g. keep-alive
        var child = getRealChild(rawChild);
        /* istanbul ignore if */
        if (!child) {
            return rawChild;
        }
        if (this._leaving) {
            return placeholder(h, rawChild);
        }
        // ensure a key that is unique to the vnode type and to this transition
        // component instance. This key will be used to remove pending leaving nodes
        // during entering.
        var id = "__transition-".concat(this._uid, "-");
        child.key = child.key == null ? child.isComment ? id + 'comment' : id + child.tag : isPrimitive(child.key) ? String(child.key).indexOf(id) === 0 ? child.key : id + child.key : child.key;
        var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
        var oldRawChild = this._vnode;
        var oldChild = getRealChild(oldRawChild);
        // mark v-show
        // so that the transition module can hand over the control to the directive
        if (child.data.directives && child.data.directives.some(isVShowDirective)) {
            child.data.show = true;
        }
        if (oldChild && oldChild.data && !isSameChild(child, oldChild) && !isAsyncPlaceholder(oldChild) &&
        // #6687 component root is a comment node
        !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)) {
            // replace old child transition data with fresh one
            // important for dynamic transitions!
            var oldData = oldChild.data.transition = extend({}, data);
            // handle transition mode
            if (mode === 'out-in') {
                // return placeholder node and queue update when leave finishes
                this._leaving = true;
                mergeVNodeHook(oldData, 'afterLeave', function () {
                    _this._leaving = false;
                    _this.$forceUpdate();
                });
                return placeholder(h, rawChild);
            } else if (mode === 'in-out') {
                if (isAsyncPlaceholder(child)) {
                    return oldRawChild;
                }
                var delayedLeave_1;
                var performLeave = function performLeave() {
                    delayedLeave_1();
                };
                mergeVNodeHook(data, 'afterEnter', performLeave);
                mergeVNodeHook(data, 'enterCancelled', performLeave);
                mergeVNodeHook(oldData, 'delayLeave', function (leave) {
                    delayedLeave_1 = leave;
                });
            }
        }
        return rawChild;
    }
};

// Provides transition support for list items.
var props = extend({
    tag: String,
    moveClass: String
}, transitionProps);
delete props.mode;
var TransitionGroup = {
    props: props,
    beforeMount: function beforeMount() {
        var _this = this;
        var update = this._update;
        this._update = function (vnode, hydrating) {
            var restoreActiveInstance = setActiveInstance(_this);
            // force removing pass
            _this.__patch__(_this._vnode, _this.kept, false, // hydrating
            true // removeOnly (!important, avoids unnecessary moves)
            );
            _this._vnode = _this.kept;
            restoreActiveInstance();
            update.call(_this, vnode, hydrating);
        };
    },
    render: function render(h) {
        var tag = this.tag || this.$vnode.data.tag || 'span';
        var map = Object.create(null);
        var prevChildren = this.prevChildren = this.children;
        var rawChildren = this.$slots.default || [];
        var children = this.children = [];
        var transitionData = extractTransitionData(this);
        for (var i = 0; i < rawChildren.length; i++) {
            var c = rawChildren[i];
            if (c.tag) {
                if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
                    children.push(c);
                    map[c.key] = c;
                    (c.data || (c.data = {})).transition = transitionData;
                } else if (false) {
                    var opts = c.componentOptions;
                    var name_1 = opts ? getComponentName(opts.Ctor.options) || opts.tag || '' : c.tag;
                    warn$2("<transition-group> children must be keyed: <".concat(name_1, ">"));
                }
            }
        }
        if (prevChildren) {
            var kept = [];
            var removed = [];
            for (var i = 0; i < prevChildren.length; i++) {
                var c = prevChildren[i];
                c.data.transition = transitionData;
                // @ts-expect-error .getBoundingClientRect is not typed in Node
                c.data.pos = c.elm.getBoundingClientRect();
                if (map[c.key]) {
                    kept.push(c);
                } else {
                    removed.push(c);
                }
            }
            this.kept = h(tag, null, kept);
            this.removed = removed;
        }
        return h(tag, null, children);
    },
    updated: function updated() {
        var children = this.prevChildren;
        var moveClass = this.moveClass || (this.name || 'v') + '-move';
        if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
            return;
        }
        // we divide the work into three loops to avoid mixing DOM reads and writes
        // in each iteration - which helps prevent layout thrashing.
        children.forEach(callPendingCbs);
        children.forEach(recordPosition);
        children.forEach(applyTranslation);
        // force reflow to put everything in position
        // assign to this to avoid being removed in tree-shaking
        // $flow-disable-line
        this._reflow = document.body.offsetHeight;
        children.forEach(function (c) {
            if (c.data.moved) {
                var el_1 = c.elm;
                var s = el_1.style;
                addTransitionClass(el_1, moveClass);
                s.transform = s.WebkitTransform = s.transitionDuration = '';
                el_1.addEventListener(transitionEndEvent, el_1._moveCb = function cb(e) {
                    if (e && e.target !== el_1) {
                        return;
                    }
                    if (!e || /transform$/.test(e.propertyName)) {
                        el_1.removeEventListener(transitionEndEvent, cb);
                        el_1._moveCb = null;
                        removeTransitionClass(el_1, moveClass);
                    }
                });
            }
        });
    },
    methods: {
        hasMove: function hasMove(el, moveClass) {
            /* istanbul ignore if */
            if (!hasTransition) {
                return false;
            }
            /* istanbul ignore if */
            if (this._hasMove) {
                return this._hasMove;
            }
            // Detect whether an element with the move class applied has
            // CSS transitions. Since the element may be inside an entering
            // transition at this very moment, we make a clone of it and remove
            // all other transition classes applied to ensure only the move class
            // is applied.
            var clone = el.cloneNode();
            if (el._transitionClasses) {
                el._transitionClasses.forEach(function (cls) {
                    removeClass(clone, cls);
                });
            }
            addClass(clone, moveClass);
            clone.style.display = 'none';
            this.$el.appendChild(clone);
            var info = getTransitionInfo(clone);
            this.$el.removeChild(clone);
            return this._hasMove = info.hasTransform;
        }
    }
};
function callPendingCbs(c) {
    /* istanbul ignore if */
    if (c.elm._moveCb) {
        c.elm._moveCb();
    }
    /* istanbul ignore if */
    if (c.elm._enterCb) {
        c.elm._enterCb();
    }
}
function recordPosition(c) {
    c.data.newPos = c.elm.getBoundingClientRect();
}
function applyTranslation(c) {
    var oldPos = c.data.pos;
    var newPos = c.data.newPos;
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        c.data.moved = true;
        var s = c.elm.style;
        s.transform = s.WebkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
        s.transitionDuration = '0s';
    }
}

var platformComponents = {
    Transition: Transition,
    TransitionGroup: TransitionGroup
};

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;
// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);
// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;
// public mount method
Vue.prototype.$mount = function (el, hydrating) {
    el = el && inBrowser ? query(el) : undefined;
    return mountComponent(this, el, hydrating);
};
// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
    setTimeout(function () {
        if (config.devtools) {
            if (devtools) {
                devtools.emit('init', Vue);
            } else if (false) {
                // @ts-expect-error
                console[console.info ? 'info' : 'log']('Download the Vue Devtools extension for a better development experience:\n' + 'https://github.com/vuejs/vue-devtools');
            }
        }
        if (false) {
            // @ts-expect-error
            console[console.info ? 'info' : 'log']("You are running Vue in development mode.\n" + "Make sure to turn on production mode when deploying for production.\n" + "See more tips at https://vuejs.org/guide/deployment.html");
        }
    }, 0);
}

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
var buildRegex = cached(function (delimiters) {
    var open = delimiters[0].replace(regexEscapeRE, '\\$&');
    var close = delimiters[1].replace(regexEscapeRE, '\\$&');
    return new RegExp(open + '((?:.|\\n)+?)' + close, 'g');
});
function parseText(text, delimiters) {
    //@ts-expect-error
    var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
    if (!tagRE.test(text)) {
        return;
    }
    var tokens = [];
    var rawTokens = [];
    var lastIndex = tagRE.lastIndex = 0;
    var match, index, tokenValue;
    while (match = tagRE.exec(text)) {
        index = match.index;
        // push text token
        if (index > lastIndex) {
            rawTokens.push(tokenValue = text.slice(lastIndex, index));
            tokens.push(JSON.stringify(tokenValue));
        }
        // tag token
        var exp = parseFilters(match[1].trim());
        tokens.push("_s(".concat(exp, ")"));
        rawTokens.push({ '@binding': exp });
        lastIndex = index + match[0].length;
    }
    if (lastIndex < text.length) {
        rawTokens.push(tokenValue = text.slice(lastIndex));
        tokens.push(JSON.stringify(tokenValue));
    }
    return {
        expression: tokens.join('+'),
        tokens: rawTokens
    };
}

function transformNode$1(el, options) {
    var warn = options.warn || baseWarn;
    var staticClass = getAndRemoveAttr(el, 'class');
    if (false) {
        var res = parseText(staticClass, options.delimiters);
        if (res) {
            warn("class=\"".concat(staticClass, "\": ") + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div class="{{ val }}">, use <div :class="val">.', el.rawAttrsMap['class']);
        }
    }
    if (staticClass) {
        el.staticClass = JSON.stringify(staticClass.replace(/\s+/g, ' ').trim());
    }
    var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
    if (classBinding) {
        el.classBinding = classBinding;
    }
}
function genData$2(el) {
    var data = '';
    if (el.staticClass) {
        data += "staticClass:".concat(el.staticClass, ",");
    }
    if (el.classBinding) {
        data += "class:".concat(el.classBinding, ",");
    }
    return data;
}
var klass = {
    staticKeys: ['staticClass'],
    transformNode: transformNode$1,
    genData: genData$2
};

function transformNode(el, options) {
    var warn = options.warn || baseWarn;
    var staticStyle = getAndRemoveAttr(el, 'style');
    if (staticStyle) {
        /* istanbul ignore if */
        if (false) {
            var res = parseText(staticStyle, options.delimiters);
            if (res) {
                warn("style=\"".concat(staticStyle, "\": ") + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div style="{{ val }}">, use <div :style="val">.', el.rawAttrsMap['style']);
            }
        }
        el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
    }
    var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
    if (styleBinding) {
        el.styleBinding = styleBinding;
    }
}
function genData$1(el) {
    var data = '';
    if (el.staticStyle) {
        data += "staticStyle:".concat(el.staticStyle, ",");
    }
    if (el.styleBinding) {
        data += "style:(".concat(el.styleBinding, "),");
    }
    return data;
}
var style = {
    staticKeys: ['staticStyle'],
    transformNode: transformNode,
    genData: genData$1
};

var decoder;
var he = {
    decode: function decode(html) {
        decoder = decoder || document.createElement('div');
        decoder.innerHTML = html;
        return decoder.textContent;
    }
};

var isUnaryTag = makeMap('area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' + 'link,meta,param,source,track,wbr');
// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap('colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source');
// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap('address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' + 'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' + 'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' + 'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' + 'title,tr,track');

/**
 * Not type-checking this file because it's mostly vendor code.
 */
// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z".concat(unicodeRegExp.source, "]*");
var qnameCapture = "((?:".concat(ncname, "\\:)?").concat(ncname, ")");
var startTagOpen = new RegExp("^<".concat(qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp("^<\\/".concat(qnameCapture, "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;
// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};
var decodingMap = {
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&amp;': '&',
    '&#10;': '\n',
    '&#9;': '\t',
    '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;
// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function shouldIgnoreFirstNewline(tag, html) {
    return tag && isIgnoreNewlineTag(tag) && html[0] === '\n';
};
function decodeAttr(value, shouldDecodeNewlines) {
    var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
    return value.replace(re, function (match) {
        return decodingMap[match];
    });
}
function parseHTML(html, options) {
    var stack = [];
    var expectHTML = options.expectHTML;
    var isUnaryTag = options.isUnaryTag || no;
    var canBeLeftOpenTag = options.canBeLeftOpenTag || no;
    var index = 0;
    var last, lastTag;
    var _loop_1 = function _loop_1() {
        last = html;
        // Make sure we're not in a plaintext content element like script/style
        if (!lastTag || !isPlainTextElement(lastTag)) {
            var textEnd = html.indexOf('<');
            if (textEnd === 0) {
                // Comment:
                if (comment.test(html)) {
                    var commentEnd = html.indexOf('-->');
                    if (commentEnd >= 0) {
                        if (options.shouldKeepComment && options.comment) {
                            options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
                        }
                        advance(commentEnd + 3);
                        return "continue";
                    }
                }
                // https://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
                if (conditionalComment.test(html)) {
                    var conditionalEnd = html.indexOf(']>');
                    if (conditionalEnd >= 0) {
                        advance(conditionalEnd + 2);
                        return "continue";
                    }
                }
                // Doctype:
                var doctypeMatch = html.match(doctype);
                if (doctypeMatch) {
                    advance(doctypeMatch[0].length);
                    return "continue";
                }
                // End tag:
                var endTagMatch = html.match(endTag);
                if (endTagMatch) {
                    var curIndex = index;
                    advance(endTagMatch[0].length);
                    parseEndTag(endTagMatch[1], curIndex, index);
                    return "continue";
                }
                // Start tag:
                var startTagMatch = parseStartTag();
                if (startTagMatch) {
                    handleStartTag(startTagMatch);
                    if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
                        advance(1);
                    }
                    return "continue";
                }
            }
            var text = void 0,
                rest = void 0,
                next = void 0;
            if (textEnd >= 0) {
                rest = html.slice(textEnd);
                while (!endTag.test(rest) && !startTagOpen.test(rest) && !comment.test(rest) && !conditionalComment.test(rest)) {
                    // < in plain text, be forgiving and treat it as text
                    next = rest.indexOf('<', 1);
                    if (next < 0) break;
                    textEnd += next;
                    rest = html.slice(textEnd);
                }
                text = html.substring(0, textEnd);
            }
            if (textEnd < 0) {
                text = html;
            }
            if (text) {
                advance(text.length);
            }
            if (options.chars && text) {
                options.chars(text, index - text.length, index);
            }
        } else {
            var endTagLength_1 = 0;
            var stackedTag_1 = lastTag.toLowerCase();
            var reStackedTag = reCache[stackedTag_1] || (reCache[stackedTag_1] = new RegExp('([\\s\\S]*?)(</' + stackedTag_1 + '[^>]*>)', 'i'));
            var rest = html.replace(reStackedTag, function (all, text, endTag) {
                endTagLength_1 = endTag.length;
                if (!isPlainTextElement(stackedTag_1) && stackedTag_1 !== 'noscript') {
                    text = text.replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
                    .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
                }
                if (shouldIgnoreFirstNewline(stackedTag_1, text)) {
                    text = text.slice(1);
                }
                if (options.chars) {
                    options.chars(text);
                }
                return '';
            });
            index += html.length - rest.length;
            html = rest;
            parseEndTag(stackedTag_1, index - endTagLength_1, index);
        }
        if (html === last) {
            options.chars && options.chars(html);
            if (false) {
                options.warn("Mal-formatted tag at end of template: \"".concat(html, "\""), {
                    start: index + html.length
                });
            }
            return "break";
        }
    };
    while (html) {
        var state_1 = _loop_1();
        if (state_1 === "break") break;
    }
    // Clean up any remaining tags
    parseEndTag();
    function advance(n) {
        index += n;
        html = html.substring(n);
    }
    function parseStartTag() {
        var start = html.match(startTagOpen);
        if (start) {
            var match = {
                tagName: start[1],
                attrs: [],
                start: index
            };
            advance(start[0].length);
            var end = void 0,
                attr = void 0;
            while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
                attr.start = index;
                advance(attr[0].length);
                attr.end = index;
                match.attrs.push(attr);
            }
            if (end) {
                match.unarySlash = end[1];
                advance(end[0].length);
                match.end = index;
                return match;
            }
        }
    }
    function handleStartTag(match) {
        var tagName = match.tagName;
        var unarySlash = match.unarySlash;
        if (expectHTML) {
            if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
                parseEndTag(lastTag);
            }
            if (canBeLeftOpenTag(tagName) && lastTag === tagName) {
                parseEndTag(tagName);
            }
        }
        var unary = isUnaryTag(tagName) || !!unarySlash;
        var l = match.attrs.length;
        var attrs = new Array(l);
        for (var i = 0; i < l; i++) {
            var args = match.attrs[i];
            var value = args[3] || args[4] || args[5] || '';
            var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href' ? options.shouldDecodeNewlinesForHref : options.shouldDecodeNewlines;
            attrs[i] = {
                name: args[1],
                value: decodeAttr(value, shouldDecodeNewlines)
            };
            if (false) {
                attrs[i].start = args.start + args[0].match(/^\s*/).length;
                attrs[i].end = args.end;
            }
        }
        if (!unary) {
            stack.push({
                tag: tagName,
                lowerCasedTag: tagName.toLowerCase(),
                attrs: attrs,
                start: match.start,
                end: match.end
            });
            lastTag = tagName;
        }
        if (options.start) {
            options.start(tagName, attrs, unary, match.start, match.end);
        }
    }
    function parseEndTag(tagName, start, end) {
        var pos, lowerCasedTagName;
        if (start == null) start = index;
        if (end == null) end = index;
        // Find the closest opened tag of the same type
        if (tagName) {
            lowerCasedTagName = tagName.toLowerCase();
            for (pos = stack.length - 1; pos >= 0; pos--) {
                if (stack[pos].lowerCasedTag === lowerCasedTagName) {
                    break;
                }
            }
        } else {
            // If no tag name is provided, clean shop
            pos = 0;
        }
        if (pos >= 0) {
            // Close all the open elements, up the stack
            for (var i = stack.length - 1; i >= pos; i--) {
                if (false) {
                    options.warn("tag <".concat(stack[i].tag, "> has no matching end tag."), {
                        start: stack[i].start,
                        end: stack[i].end
                    });
                }
                if (options.end) {
                    options.end(stack[i].tag, start, end);
                }
            }
            // Remove the open elements from the stack
            stack.length = pos;
            lastTag = pos && stack[pos - 1].tag;
        } else if (lowerCasedTagName === 'br') {
            if (options.start) {
                options.start(tagName, [], true, start, end);
            }
        } else if (lowerCasedTagName === 'p') {
            if (options.start) {
                options.start(tagName, [], false, start, end);
            }
            if (options.end) {
                options.end(tagName, start, end);
            }
        }
    }
}

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;
var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;
var slotRE = /^v-slot(:|$)|^#/;
var lineBreakRE = /[\r\n]/;
var whitespaceRE = /[ \f\t\r\n]+/g;
var invalidAttributeRE = /[\s"'<>\/=]/;
var decodeHTMLCached = cached(he.decode);
var emptySlotScopeToken = "_empty_";
// configurable state
var warn;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;
function createASTElement(tag, attrs, parent) {
    return {
        type: 1,
        tag: tag,
        attrsList: attrs,
        attrsMap: makeAttrsMap(attrs),
        rawAttrsMap: {},
        parent: parent,
        children: []
    };
}
/**
 * Convert HTML string to AST.
 */
function parse(template, options) {
    warn = options.warn || baseWarn;
    platformIsPreTag = options.isPreTag || no;
    platformMustUseProp = options.mustUseProp || no;
    platformGetTagNamespace = options.getTagNamespace || no;
    var isReservedTag = options.isReservedTag || no;
    maybeComponent = function maybeComponent(el) {
        return !!(el.component || el.attrsMap[':is'] || el.attrsMap['v-bind:is'] || !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag)));
    };
    transforms = pluckModuleFunction(options.modules, 'transformNode');
    preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
    postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
    delimiters = options.delimiters;
    var stack = [];
    var preserveWhitespace = options.preserveWhitespace !== false;
    var whitespaceOption = options.whitespace;
    var root;
    var currentParent;
    var inVPre = false;
    var inPre = false;
    var warned = false;
    function warnOnce(msg, range) {
        if (!warned) {
            warned = true;
            warn(msg, range);
        }
    }
    function closeElement(element) {
        trimEndingWhitespace(element);
        if (!inVPre && !element.processed) {
            element = processElement(element, options);
        }
        // tree management
        if (!stack.length && element !== root) {
            // allow root elements with v-if, v-else-if and v-else
            if (root.if && (element.elseif || element.else)) {
                if (false) {
                    checkRootConstraints(element);
                }
                addIfCondition(root, {
                    exp: element.elseif,
                    block: element
                });
            } else if (false) {
                warnOnce("Component template should contain exactly one root element. " + "If you are using v-if on multiple elements, " + "use v-else-if to chain them instead.", { start: element.start });
            }
        }
        if (currentParent && !element.forbidden) {
            if (element.elseif || element.else) {
                processIfConditions(element, currentParent);
            } else {
                if (element.slotScope) {
                    // scoped slot
                    // keep it in the children list so that v-else(-if) conditions can
                    // find it as the prev node.
                    var name_1 = element.slotTarget || '"default"';
                    (currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name_1] = element;
                }
                currentParent.children.push(element);
                element.parent = currentParent;
            }
        }
        // final children cleanup
        // filter out scoped slots
        element.children = element.children.filter(function (c) {
            return !c.slotScope;
        });
        // remove trailing whitespace node again
        trimEndingWhitespace(element);
        // check pre state
        if (element.pre) {
            inVPre = false;
        }
        if (platformIsPreTag(element.tag)) {
            inPre = false;
        }
        // apply post-transforms
        for (var i = 0; i < postTransforms.length; i++) {
            postTransforms[i](element, options);
        }
    }
    function trimEndingWhitespace(el) {
        // remove trailing whitespace node
        if (!inPre) {
            var lastNode = void 0;
            while ((lastNode = el.children[el.children.length - 1]) && lastNode.type === 3 && lastNode.text === ' ') {
                el.children.pop();
            }
        }
    }
    function checkRootConstraints(el) {
        if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce("Cannot use <".concat(el.tag, "> as component root element because it may ") + 'contain multiple nodes.', { start: el.start });
        }
        if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce('Cannot use v-for on stateful component root element because ' + 'it renders multiple elements.', el.rawAttrsMap['v-for']);
        }
    }
    parseHTML(template, {
        warn: warn,
        expectHTML: options.expectHTML,
        isUnaryTag: options.isUnaryTag,
        canBeLeftOpenTag: options.canBeLeftOpenTag,
        shouldDecodeNewlines: options.shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
        shouldKeepComment: options.comments,
        outputSourceRange: options.outputSourceRange,
        start: function start(tag, attrs, unary, _start, end) {
            // check namespace.
            // inherit parent ns if there is one
            var ns = currentParent && currentParent.ns || platformGetTagNamespace(tag);
            // handle IE svg bug
            /* istanbul ignore if */
            if (isIE && ns === 'svg') {
                attrs = guardIESVGBug(attrs);
            }
            var element = createASTElement(tag, attrs, currentParent);
            if (ns) {
                element.ns = ns;
            }
            if (false) {
                if (options.outputSourceRange) {
                    element.start = _start;
                    element.end = end;
                    element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
                        cumulated[attr.name] = attr;
                        return cumulated;
                    }, {});
                }
                attrs.forEach(function (attr) {
                    if (invalidAttributeRE.test(attr.name)) {
                        warn("Invalid dynamic argument expression: attribute names cannot contain " + "spaces, quotes, <, >, / or =.", options.outputSourceRange ? {
                            start: attr.start + attr.name.indexOf("["),
                            end: attr.start + attr.name.length
                        } : undefined);
                    }
                });
            }
            if (isForbiddenTag(element) && !isServerRendering()) {
                element.forbidden = true;
                "production" !== 'production' && warn('Templates should only be responsible for mapping the state to the ' + 'UI. Avoid placing tags with side-effects in your templates, such as ' + "<".concat(tag, ">") + ', as they will not be parsed.', { start: element.start });
            }
            // apply pre-transforms
            for (var i = 0; i < preTransforms.length; i++) {
                element = preTransforms[i](element, options) || element;
            }
            if (!inVPre) {
                processPre(element);
                if (element.pre) {
                    inVPre = true;
                }
            }
            if (platformIsPreTag(element.tag)) {
                inPre = true;
            }
            if (inVPre) {
                processRawAttrs(element);
            } else if (!element.processed) {
                // structural directives
                processFor(element);
                processIf(element);
                processOnce(element);
            }
            if (!root) {
                root = element;
                if (false) {
                    checkRootConstraints(root);
                }
            }
            if (!unary) {
                currentParent = element;
                stack.push(element);
            } else {
                closeElement(element);
            }
        },
        end: function end(tag, start, _end) {
            var element = stack[stack.length - 1];
            // pop stack
            stack.length -= 1;
            currentParent = stack[stack.length - 1];
            if (false) {
                element.end = _end;
            }
            closeElement(element);
        },
        chars: function chars(text, start, end) {
            if (!currentParent) {
                if (false) {
                    if (text === template) {
                        warnOnce('Component template requires a root element, rather than just text.', { start: start });
                    } else if (text = text.trim()) {
                        warnOnce("text \"".concat(text, "\" outside root element will be ignored."), {
                            start: start
                        });
                    }
                }
                return;
            }
            // IE textarea placeholder bug
            /* istanbul ignore if */
            if (isIE && currentParent.tag === 'textarea' && currentParent.attrsMap.placeholder === text) {
                return;
            }
            var children = currentParent.children;
            if (inPre || text.trim()) {
                text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
            } else if (!children.length) {
                // remove the whitespace-only node right after an opening tag
                text = '';
            } else if (whitespaceOption) {
                if (whitespaceOption === 'condense') {
                    // in condense mode, remove the whitespace node if it contains
                    // line break, otherwise condense to a single space
                    text = lineBreakRE.test(text) ? '' : ' ';
                } else {
                    text = ' ';
                }
            } else {
                text = preserveWhitespace ? ' ' : '';
            }
            if (text) {
                if (!inPre && whitespaceOption === 'condense') {
                    // condense consecutive whitespaces into single space
                    text = text.replace(whitespaceRE, ' ');
                }
                var res = void 0;
                var child = void 0;
                if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
                    child = {
                        type: 2,
                        expression: res.expression,
                        tokens: res.tokens,
                        text: text
                    };
                } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
                    child = {
                        type: 3,
                        text: text
                    };
                }
                if (child) {
                    if (false) {
                        child.start = start;
                        child.end = end;
                    }
                    children.push(child);
                }
            }
        },
        comment: function comment(text, start, end) {
            // adding anything as a sibling to the root node is forbidden
            // comments should still be allowed, but ignored
            if (currentParent) {
                var child = {
                    type: 3,
                    text: text,
                    isComment: true
                };
                if (false) {
                    child.start = start;
                    child.end = end;
                }
                currentParent.children.push(child);
            }
        }
    });
    return root;
}
function processPre(el) {
    if (getAndRemoveAttr(el, 'v-pre') != null) {
        el.pre = true;
    }
}
function processRawAttrs(el) {
    var list = el.attrsList;
    var len = list.length;
    if (len) {
        var attrs = el.attrs = new Array(len);
        for (var i = 0; i < len; i++) {
            attrs[i] = {
                name: list[i].name,
                value: JSON.stringify(list[i].value)
            };
            if (list[i].start != null) {
                attrs[i].start = list[i].start;
                attrs[i].end = list[i].end;
            }
        }
    } else if (!el.pre) {
        // non root node in pre blocks with no attributes
        el.plain = true;
    }
}
function processElement(element, options) {
    processKey(element);
    // determine whether this is a plain element after
    // removing structural attributes
    element.plain = !element.key && !element.scopedSlots && !element.attrsList.length;
    processRef(element);
    processSlotContent(element);
    processSlotOutlet(element);
    processComponent(element);
    for (var i = 0; i < transforms.length; i++) {
        element = transforms[i](element, options) || element;
    }
    processAttrs(element);
    return element;
}
function processKey(el) {
    var exp = getBindingAttr(el, 'key');
    if (exp) {
        if (false) {
            if (el.tag === 'template') {
                warn("<template> cannot be keyed. Place the key on real elements instead.", getRawBindingAttr(el, 'key'));
            }
            if (el.for) {
                var iterator = el.iterator2 || el.iterator1;
                var parent_1 = el.parent;
                if (iterator && iterator === exp && parent_1 && parent_1.tag === 'transition-group') {
                    warn("Do not use v-for index as key on <transition-group> children, " + "this is the same as not using keys.", getRawBindingAttr(el, 'key'), true /* tip */);
                }
            }
        }
        el.key = exp;
    }
}
function processRef(el) {
    var ref = getBindingAttr(el, 'ref');
    if (ref) {
        el.ref = ref;
        el.refInFor = checkInFor(el);
    }
}
function processFor(el) {
    var exp;
    if (exp = getAndRemoveAttr(el, 'v-for')) {
        var res = parseFor(exp);
        if (res) {
            extend(el, res);
        } else if (false) {
            warn("Invalid v-for expression: ".concat(exp), el.rawAttrsMap['v-for']);
        }
    }
}
function parseFor(exp) {
    var inMatch = exp.match(forAliasRE);
    if (!inMatch) return;
    var res = {};
    res.for = inMatch[2].trim();
    var alias = inMatch[1].trim().replace(stripParensRE, '');
    var iteratorMatch = alias.match(forIteratorRE);
    if (iteratorMatch) {
        res.alias = alias.replace(forIteratorRE, '').trim();
        res.iterator1 = iteratorMatch[1].trim();
        if (iteratorMatch[2]) {
            res.iterator2 = iteratorMatch[2].trim();
        }
    } else {
        res.alias = alias;
    }
    return res;
}
function processIf(el) {
    var exp = getAndRemoveAttr(el, 'v-if');
    if (exp) {
        el.if = exp;
        addIfCondition(el, {
            exp: exp,
            block: el
        });
    } else {
        if (getAndRemoveAttr(el, 'v-else') != null) {
            el.else = true;
        }
        var elseif = getAndRemoveAttr(el, 'v-else-if');
        if (elseif) {
            el.elseif = elseif;
        }
    }
}
function processIfConditions(el, parent) {
    var prev = findPrevElement(parent.children);
    if (prev && prev.if) {
        addIfCondition(prev, {
            exp: el.elseif,
            block: el
        });
    } else if (false) {
        warn("v-".concat(el.elseif ? 'else-if="' + el.elseif + '"' : 'else', " ") + "used on element <".concat(el.tag, "> without corresponding v-if."), el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']);
    }
}
function findPrevElement(children) {
    var i = children.length;
    while (i--) {
        if (children[i].type === 1) {
            return children[i];
        } else {
            if (false) {
                warn("text \"".concat(children[i].text.trim(), "\" between v-if and v-else(-if) ") + "will be ignored.", children[i]);
            }
            children.pop();
        }
    }
}
function addIfCondition(el, condition) {
    if (!el.ifConditions) {
        el.ifConditions = [];
    }
    el.ifConditions.push(condition);
}
function processOnce(el) {
    var once = getAndRemoveAttr(el, 'v-once');
    if (once != null) {
        el.once = true;
    }
}
// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent(el) {
    var slotScope;
    if (el.tag === 'template') {
        slotScope = getAndRemoveAttr(el, 'scope');
        /* istanbul ignore if */
        if (false) {
            warn("the \"scope\" attribute for scoped slots have been deprecated and " + "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " + "can also be used on plain elements in addition to <template> to " + "denote scoped slots.", el.rawAttrsMap['scope'], true);
        }
        el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if (slotScope = getAndRemoveAttr(el, 'slot-scope')) {
        /* istanbul ignore if */
        if (false) {
            warn("Ambiguous combined usage of slot-scope and v-for on <".concat(el.tag, "> ") + "(v-for takes higher priority). Use a wrapper <template> for the " + "scoped slot to make it clearer.", el.rawAttrsMap['slot-scope'], true);
        }
        el.slotScope = slotScope;
    }
    // slot="xxx"
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
        el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
        el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
        // preserve slot as an attribute for native shadow DOM compat
        // only for non-scoped slots.
        if (el.tag !== 'template' && !el.slotScope) {
            addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
        }
    }
    // 2.6 v-slot syntax
    {
        if (el.tag === 'template') {
            // v-slot on <template>
            var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
            if (slotBinding) {
                if (false) {
                    if (el.slotTarget || el.slotScope) {
                        warn("Unexpected mixed usage of different slot syntaxes.", el);
                    }
                    if (el.parent && !maybeComponent(el.parent)) {
                        warn("<template v-slot> can only appear at the root level inside " + "the receiving component", el);
                    }
                }
                var _a = getSlotName(slotBinding),
                    name_2 = _a.name,
                    dynamic = _a.dynamic;
                el.slotTarget = name_2;
                el.slotTargetDynamic = dynamic;
                el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
            }
        } else {
            // v-slot on component, denotes default slot
            var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
            if (slotBinding) {
                if (false) {
                    if (!maybeComponent(el)) {
                        warn("v-slot can only be used on components or <template>.", slotBinding);
                    }
                    if (el.slotScope || el.slotTarget) {
                        warn("Unexpected mixed usage of different slot syntaxes.", el);
                    }
                    if (el.scopedSlots) {
                        warn("To avoid scope ambiguity, the default slot should also use " + "<template> syntax when there are other named slots.", slotBinding);
                    }
                }
                // add the component's children to its default slot
                var slots = el.scopedSlots || (el.scopedSlots = {});
                var _b = getSlotName(slotBinding),
                    name_3 = _b.name,
                    dynamic = _b.dynamic;
                var slotContainer_1 = slots[name_3] = createASTElement('template', [], el);
                slotContainer_1.slotTarget = name_3;
                slotContainer_1.slotTargetDynamic = dynamic;
                slotContainer_1.children = el.children.filter(function (c) {
                    if (!c.slotScope) {
                        c.parent = slotContainer_1;
                        return true;
                    }
                });
                slotContainer_1.slotScope = slotBinding.value || emptySlotScopeToken;
                // remove children as they are returned from scopedSlots now
                el.children = [];
                // mark el non-plain so data gets generated
                el.plain = false;
            }
        }
    }
}
function getSlotName(binding) {
    var name = binding.name.replace(slotRE, '');
    if (!name) {
        if (binding.name[0] !== '#') {
            name = 'default';
        } else if (false) {
            warn("v-slot shorthand syntax requires a slot name.", binding);
        }
    }
    return dynamicArgRE.test(name) ? // dynamic [name]
    { name: name.slice(1, -1), dynamic: true } : // static name
    { name: "\"".concat(name, "\""), dynamic: false };
}
// handle <slot/> outlets
function processSlotOutlet(el) {
    if (el.tag === 'slot') {
        el.slotName = getBindingAttr(el, 'name');
        if (false) {
            warn("`key` does not work on <slot> because slots are abstract outlets " + "and can possibly expand into multiple elements. " + "Use the key on a wrapping element instead.", getRawBindingAttr(el, 'key'));
        }
    }
}
function processComponent(el) {
    var binding;
    if (binding = getBindingAttr(el, 'is')) {
        el.component = binding;
    }
    if (getAndRemoveAttr(el, 'inline-template') != null) {
        el.inlineTemplate = true;
    }
}
function processAttrs(el) {
    var list = el.attrsList;
    var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
    for (i = 0, l = list.length; i < l; i++) {
        name = rawName = list[i].name;
        value = list[i].value;
        if (dirRE.test(name)) {
            // mark element as dynamic
            el.hasBindings = true;
            // modifiers
            modifiers = parseModifiers(name.replace(dirRE, ''));
            // support .foo shorthand syntax for the .prop modifier
            if (modifiers) {
                name = name.replace(modifierRE, '');
            }
            if (bindRE.test(name)) {
                // v-bind
                name = name.replace(bindRE, '');
                value = parseFilters(value);
                isDynamic = dynamicArgRE.test(name);
                if (isDynamic) {
                    name = name.slice(1, -1);
                }
                if (false) {
                    warn("The value for a v-bind expression cannot be empty. Found in \"v-bind:".concat(name, "\""));
                }
                if (modifiers) {
                    if (modifiers.prop && !isDynamic) {
                        name = camelize(name);
                        if (name === 'innerHtml') name = 'innerHTML';
                    }
                    if (modifiers.camel && !isDynamic) {
                        name = camelize(name);
                    }
                    if (modifiers.sync) {
                        syncGen = genAssignmentCode(value, "$event");
                        if (!isDynamic) {
                            addHandler(el, "update:".concat(camelize(name)), syncGen, null, false, warn, list[i]);
                            if (hyphenate(name) !== camelize(name)) {
                                addHandler(el, "update:".concat(hyphenate(name)), syncGen, null, false, warn, list[i]);
                            }
                        } else {
                            // handler w/ dynamic event name
                            addHandler(el, "\"update:\"+(".concat(name, ")"), syncGen, null, false, warn, list[i], true // dynamic
                            );
                        }
                    }
                }
                if (modifiers && modifiers.prop || !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)) {
                    addProp(el, name, value, list[i], isDynamic);
                } else {
                    addAttr(el, name, value, list[i], isDynamic);
                }
            } else if (onRE.test(name)) {
                // v-on
                name = name.replace(onRE, '');
                isDynamic = dynamicArgRE.test(name);
                if (isDynamic) {
                    name = name.slice(1, -1);
                }
                addHandler(el, name, value, modifiers, false, warn, list[i], isDynamic);
            } else {
                // normal directives
                name = name.replace(dirRE, '');
                // parse arg
                var argMatch = name.match(argRE);
                var arg = argMatch && argMatch[1];
                isDynamic = false;
                if (arg) {
                    name = name.slice(0, -(arg.length + 1));
                    if (dynamicArgRE.test(arg)) {
                        arg = arg.slice(1, -1);
                        isDynamic = true;
                    }
                }
                addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
                if (false) {
                    checkForAliasModel(el, value);
                }
            }
        } else {
            // literal attribute
            if (false) {
                var res = parseText(value, delimiters);
                if (res) {
                    warn("".concat(name, "=\"").concat(value, "\": ") + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div id="{{ val }}">, use <div :id="val">.', list[i]);
                }
            }
            addAttr(el, name, JSON.stringify(value), list[i]);
            // #6887 firefox doesn't update muted state if set via attribute
            // even immediately after element creation
            if (!el.component && name === 'muted' && platformMustUseProp(el.tag, el.attrsMap.type, name)) {
                addProp(el, name, 'true', list[i]);
            }
        }
    }
}
function checkInFor(el) {
    var parent = el;
    while (parent) {
        if (parent.for !== undefined) {
            return true;
        }
        parent = parent.parent;
    }
    return false;
}
function parseModifiers(name) {
    var match = name.match(modifierRE);
    if (match) {
        var ret_1 = {};
        match.forEach(function (m) {
            ret_1[m.slice(1)] = true;
        });
        return ret_1;
    }
}
function makeAttrsMap(attrs) {
    var map = {};
    for (var i = 0, l = attrs.length; i < l; i++) {
        if (false) {
            warn('duplicate attribute: ' + attrs[i].name, attrs[i]);
        }
        map[attrs[i].name] = attrs[i].value;
    }
    return map;
}
// for script (e.g. type="x/template") or style, do not decode content
function isTextTag(el) {
    return el.tag === 'script' || el.tag === 'style';
}
function isForbiddenTag(el) {
    return el.tag === 'style' || el.tag === 'script' && (!el.attrsMap.type || el.attrsMap.type === 'text/javascript');
}
var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;
/* istanbul ignore next */
function guardIESVGBug(attrs) {
    var res = [];
    for (var i = 0; i < attrs.length; i++) {
        var attr = attrs[i];
        if (!ieNSBug.test(attr.name)) {
            attr.name = attr.name.replace(ieNSPrefix, '');
            res.push(attr);
        }
    }
    return res;
}
function checkForAliasModel(el, value) {
    var _el = el;
    while (_el) {
        if (_el.for && _el.alias === value) {
            warn("<".concat(el.tag, " v-model=\"").concat(value, "\">: ") + "You are binding v-model directly to a v-for iteration alias. " + "This will not be able to modify the v-for source array because " + "writing to the alias is like modifying a function local variable. " + "Consider using an array of objects and use v-model on an object property instead.", el.rawAttrsMap['v-model']);
        }
        _el = _el.parent;
    }
}

/**
 * Expand input[v-model] with dynamic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */
function preTransformNode(el, options) {
    if (el.tag === 'input') {
        var map = el.attrsMap;
        if (!map['v-model']) {
            return;
        }
        var typeBinding = void 0;
        if (map[':type'] || map['v-bind:type']) {
            typeBinding = getBindingAttr(el, 'type');
        }
        if (!map.type && !typeBinding && map['v-bind']) {
            typeBinding = "(".concat(map['v-bind'], ").type");
        }
        if (typeBinding) {
            var ifCondition = getAndRemoveAttr(el, 'v-if', true);
            var ifConditionExtra = ifCondition ? "&&(".concat(ifCondition, ")") : "";
            var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
            var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
            // 1. checkbox
            var branch0 = cloneASTElement(el);
            // process for on the main node
            processFor(branch0);
            addRawAttr(branch0, 'type', 'checkbox');
            processElement(branch0, options);
            branch0.processed = true; // prevent it from double-processed
            branch0.if = "(".concat(typeBinding, ")==='checkbox'") + ifConditionExtra;
            addIfCondition(branch0, {
                exp: branch0.if,
                block: branch0
            });
            // 2. add radio else-if condition
            var branch1 = cloneASTElement(el);
            getAndRemoveAttr(branch1, 'v-for', true);
            addRawAttr(branch1, 'type', 'radio');
            processElement(branch1, options);
            addIfCondition(branch0, {
                exp: "(".concat(typeBinding, ")==='radio'") + ifConditionExtra,
                block: branch1
            });
            // 3. other
            var branch2 = cloneASTElement(el);
            getAndRemoveAttr(branch2, 'v-for', true);
            addRawAttr(branch2, ':type', typeBinding);
            processElement(branch2, options);
            addIfCondition(branch0, {
                exp: ifCondition,
                block: branch2
            });
            if (hasElse) {
                branch0.else = true;
            } else if (elseIfCondition) {
                branch0.elseif = elseIfCondition;
            }
            return branch0;
        }
    }
}
function cloneASTElement(el) {
    return createASTElement(el.tag, el.attrsList.slice(), el.parent);
}
var model = {
    preTransformNode: preTransformNode
};

var modules = [klass, style, model];

function text(el, dir) {
    if (dir.value) {
        addProp(el, 'textContent', "_s(".concat(dir.value, ")"), dir);
    }
}

function html(el, dir) {
    if (dir.value) {
        addProp(el, 'innerHTML', "_s(".concat(dir.value, ")"), dir);
    }
}

var directives = {
    model: model$1,
    text: text,
    html: html
};

var baseOptions = {
    expectHTML: true,
    modules: modules,
    directives: directives,
    isPreTag: isPreTag,
    isUnaryTag: isUnaryTag,
    mustUseProp: mustUseProp,
    canBeLeftOpenTag: canBeLeftOpenTag,
    isReservedTag: isReservedTag,
    getTagNamespace: getTagNamespace,
    staticKeys: genStaticKeys$1(modules)
};

var isStaticKey;
var isPlatformReservedTag;
var genStaticKeysCached = cached(genStaticKeys);
/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize(root, options) {
    if (!root) return;
    isStaticKey = genStaticKeysCached(options.staticKeys || '');
    isPlatformReservedTag = options.isReservedTag || no;
    // first pass: mark all non-static nodes.
    markStatic(root);
    // second pass: mark static roots.
    markStaticRoots(root, false);
}
function genStaticKeys(keys) {
    return makeMap('type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' + (keys ? ',' + keys : ''));
}
function markStatic(node) {
    node.static = isStatic(node);
    if (node.type === 1) {
        // do not make component slot content static. this avoids
        // 1. components not able to mutate slot nodes
        // 2. static slot content fails for hot-reloading
        if (!isPlatformReservedTag(node.tag) && node.tag !== 'slot' && node.attrsMap['inline-template'] == null) {
            return;
        }
        for (var i = 0, l = node.children.length; i < l; i++) {
            var child = node.children[i];
            markStatic(child);
            if (!child.static) {
                node.static = false;
            }
        }
        if (node.ifConditions) {
            for (var i = 1, l = node.ifConditions.length; i < l; i++) {
                var block = node.ifConditions[i].block;
                markStatic(block);
                if (!block.static) {
                    node.static = false;
                }
            }
        }
    }
}
function markStaticRoots(node, isInFor) {
    if (node.type === 1) {
        if (node.static || node.once) {
            node.staticInFor = isInFor;
        }
        // For a node to qualify as a static root, it should have children that
        // are not just static text. Otherwise the cost of hoisting out will
        // outweigh the benefits and it's better off to just always render it fresh.
        if (node.static && node.children.length && !(node.children.length === 1 && node.children[0].type === 3)) {
            node.staticRoot = true;
            return;
        } else {
            node.staticRoot = false;
        }
        if (node.children) {
            for (var i = 0, l = node.children.length; i < l; i++) {
                markStaticRoots(node.children[i], isInFor || !!node.for);
            }
        }
        if (node.ifConditions) {
            for (var i = 1, l = node.ifConditions.length; i < l; i++) {
                markStaticRoots(node.ifConditions[i].block, isInFor);
            }
        }
    }
}
function isStatic(node) {
    if (node.type === 2) {
        // expression
        return false;
    }
    if (node.type === 3) {
        // text
        return true;
    }
    return !!(node.pre || !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) && Object.keys(node).every(isStaticKey));
}
function isDirectChildOfTemplateFor(node) {
    while (node.parent) {
        node = node.parent;
        if (node.tag !== 'template') {
            return false;
        }
        if (node.for) {
            return true;
        }
    }
    return false;
}

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;
// KeyboardEvent.keyCode aliases
var keyCodes = {
    esc: 27,
    tab: 9,
    enter: 13,
    space: 32,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    delete: [8, 46]
};
// KeyboardEvent.key aliases
var keyNames = {
    // #7880: IE11 and Edge use `Esc` for Escape key name.
    esc: ['Esc', 'Escape'],
    tab: 'Tab',
    enter: 'Enter',
    // #9112: IE11 uses `Spacebar` for Space key name.
    space: [' ', 'Spacebar'],
    // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
    up: ['Up', 'ArrowUp'],
    left: ['Left', 'ArrowLeft'],
    right: ['Right', 'ArrowRight'],
    down: ['Down', 'ArrowDown'],
    // #9112: IE11 uses `Del` for Delete key name.
    delete: ['Backspace', 'Delete', 'Del']
};
// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function genGuard(condition) {
    return "if(".concat(condition, ")return null;");
};
var modifierCode = {
    stop: '$event.stopPropagation();',
    prevent: '$event.preventDefault();',
    self: genGuard("$event.target !== $event.currentTarget"),
    ctrl: genGuard("!$event.ctrlKey"),
    shift: genGuard("!$event.shiftKey"),
    alt: genGuard("!$event.altKey"),
    meta: genGuard("!$event.metaKey"),
    left: genGuard("'button' in $event && $event.button !== 0"),
    middle: genGuard("'button' in $event && $event.button !== 1"),
    right: genGuard("'button' in $event && $event.button !== 2")
};
function genHandlers(events, isNative) {
    var prefix = isNative ? 'nativeOn:' : 'on:';
    var staticHandlers = "";
    var dynamicHandlers = "";
    for (var name_1 in events) {
        var handlerCode = genHandler(events[name_1]);
        //@ts-expect-error
        if (events[name_1] && events[name_1].dynamic) {
            dynamicHandlers += "".concat(name_1, ",").concat(handlerCode, ",");
        } else {
            staticHandlers += "\"".concat(name_1, "\":").concat(handlerCode, ",");
        }
    }
    staticHandlers = "{".concat(staticHandlers.slice(0, -1), "}");
    if (dynamicHandlers) {
        return prefix + "_d(".concat(staticHandlers, ",[").concat(dynamicHandlers.slice(0, -1), "])");
    } else {
        return prefix + staticHandlers;
    }
}
function genHandler(handler) {
    if (!handler) {
        return 'function(){}';
    }
    if (Array.isArray(handler)) {
        return "[".concat(handler.map(function (handler) {
            return genHandler(handler);
        }).join(','), "]");
    }
    var isMethodPath = simplePathRE.test(handler.value);
    var isFunctionExpression = fnExpRE.test(handler.value);
    var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));
    if (!handler.modifiers) {
        if (isMethodPath || isFunctionExpression) {
            return handler.value;
        }
        return "function($event){".concat(isFunctionInvocation ? "return ".concat(handler.value) : handler.value, "}"); // inline statement
    } else {
        var code = '';
        var genModifierCode = '';
        var keys = [];
        var _loop_1 = function _loop_1(key) {
            if (modifierCode[key]) {
                genModifierCode += modifierCode[key];
                // left/right
                if (keyCodes[key]) {
                    keys.push(key);
                }
            } else if (key === 'exact') {
                var modifiers_1 = handler.modifiers;
                genModifierCode += genGuard(['ctrl', 'shift', 'alt', 'meta'].filter(function (keyModifier) {
                    return !modifiers_1[keyModifier];
                }).map(function (keyModifier) {
                    return "$event.".concat(keyModifier, "Key");
                }).join('||'));
            } else {
                keys.push(key);
            }
        };
        for (var key in handler.modifiers) {
            _loop_1(key);
        }
        if (keys.length) {
            code += genKeyFilter(keys);
        }
        // Make sure modifiers like prevent and stop get executed after key filtering
        if (genModifierCode) {
            code += genModifierCode;
        }
        var handlerCode = isMethodPath ? "return ".concat(handler.value, ".apply(null, arguments)") : isFunctionExpression ? "return (".concat(handler.value, ").apply(null, arguments)") : isFunctionInvocation ? "return ".concat(handler.value) : handler.value;
        return "function($event){".concat(code).concat(handlerCode, "}");
    }
}
function genKeyFilter(keys) {
    return (
        // make sure the key filters only apply to KeyboardEvents
        // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
        // key events that do not have keyCode property...
        "if(!$event.type.indexOf('key')&&" + "".concat(keys.map(genFilterCode).join('&&'), ")return null;")
    );
}
function genFilterCode(key) {
    var keyVal = parseInt(key, 10);
    if (keyVal) {
        return "$event.keyCode!==".concat(keyVal);
    }
    var keyCode = keyCodes[key];
    var keyName = keyNames[key];
    return "_k($event.keyCode," + "".concat(JSON.stringify(key), ",") + "".concat(JSON.stringify(keyCode), ",") + "$event.key," + "".concat(JSON.stringify(keyName)) + ")";
}

function on(el, dir) {
    if (false) {
        warn$2("v-on without argument does not support modifiers.");
    }
    el.wrapListeners = function (code) {
        return "_g(".concat(code, ",").concat(dir.value, ")");
    };
}

function bind(el, dir) {
    el.wrapData = function (code) {
        return "_b(".concat(code, ",'").concat(el.tag, "',").concat(dir.value, ",").concat(dir.modifiers && dir.modifiers.prop ? 'true' : 'false').concat(dir.modifiers && dir.modifiers.sync ? ',true' : '', ")");
    };
}

var baseDirectives = {
    on: on,
    bind: bind,
    cloak: noop
};

var CodegenState = /** @class */function () {
    function CodegenState(options) {
        this.options = options;
        this.warn = options.warn || baseWarn;
        this.transforms = pluckModuleFunction(options.modules, 'transformCode');
        this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
        this.directives = extend(extend({}, baseDirectives), options.directives);
        var isReservedTag = options.isReservedTag || no;
        this.maybeComponent = function (el) {
            return !!el.component || !isReservedTag(el.tag);
        };
        this.onceId = 0;
        this.staticRenderFns = [];
        this.pre = false;
    }
    return CodegenState;
}();
function generate(ast, options) {
    var state = new CodegenState(options);
    // fix #11483, Root level <script> tags should not be rendered.
    var code = ast ? ast.tag === 'script' ? 'null' : genElement(ast, state) : '_c("div")';
    return {
        render: "with(this){return ".concat(code, "}"),
        staticRenderFns: state.staticRenderFns
    };
}
function genElement(el, state) {
    if (el.parent) {
        el.pre = el.pre || el.parent.pre;
    }
    if (el.staticRoot && !el.staticProcessed) {
        return genStatic(el, state);
    } else if (el.once && !el.onceProcessed) {
        return genOnce(el, state);
    } else if (el.for && !el.forProcessed) {
        return genFor(el, state);
    } else if (el.if && !el.ifProcessed) {
        return genIf(el, state);
    } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
        return genChildren(el, state) || 'void 0';
    } else if (el.tag === 'slot') {
        return genSlot(el, state);
    } else {
        // component or element
        var code = void 0;
        if (el.component) {
            code = genComponent(el.component, el, state);
        } else {
            var data = void 0;
            var maybeComponent = state.maybeComponent(el);
            if (!el.plain || el.pre && maybeComponent) {
                data = genData(el, state);
            }
            var tag
            // check if this is a component in <script setup>
            = void 0;
            // check if this is a component in <script setup>
            var bindings = state.options.bindings;
            if (maybeComponent && bindings && bindings.__isScriptSetup !== false) {
                tag = checkBindingType(bindings, el.tag);
            }
            if (!tag) tag = "'".concat(el.tag, "'");
            var children = el.inlineTemplate ? null : genChildren(el, state, true);
            code = "_c(".concat(tag).concat(data ? ",".concat(data) : '' // data
            ).concat(children ? ",".concat(children) : '' // children
            , ")");
        }
        // module transforms
        for (var i = 0; i < state.transforms.length; i++) {
            code = state.transforms[i](el, code);
        }
        return code;
    }
}
function checkBindingType(bindings, key) {
    var camelName = camelize(key);
    var PascalName = capitalize(camelName);
    var checkType = function checkType(type) {
        if (bindings[key] === type) {
            return key;
        }
        if (bindings[camelName] === type) {
            return camelName;
        }
        if (bindings[PascalName] === type) {
            return PascalName;
        }
    };
    var fromConst = checkType("setup-const" /* BindingTypes.SETUP_CONST */) || checkType("setup-reactive-const" /* BindingTypes.SETUP_REACTIVE_CONST */);
    if (fromConst) {
        return fromConst;
    }
    var fromMaybeRef = checkType("setup-let" /* BindingTypes.SETUP_LET */) || checkType("setup-ref" /* BindingTypes.SETUP_REF */) || checkType("setup-maybe-ref" /* BindingTypes.SETUP_MAYBE_REF */);
    if (fromMaybeRef) {
        return fromMaybeRef;
    }
}
// hoist static sub-trees out
function genStatic(el, state) {
    el.staticProcessed = true;
    // Some elements (templates) need to behave differently inside of a v-pre
    // node.  All pre nodes are static roots, so we can use this as a location to
    // wrap a state change and reset it upon exiting the pre node.
    var originalPreState = state.pre;
    if (el.pre) {
        state.pre = el.pre;
    }
    state.staticRenderFns.push("with(this){return ".concat(genElement(el, state), "}"));
    state.pre = originalPreState;
    return "_m(".concat(state.staticRenderFns.length - 1).concat(el.staticInFor ? ',true' : '', ")");
}
// v-once
function genOnce(el, state) {
    el.onceProcessed = true;
    if (el.if && !el.ifProcessed) {
        return genIf(el, state);
    } else if (el.staticInFor) {
        var key = '';
        var parent_1 = el.parent;
        while (parent_1) {
            if (parent_1.for) {
                key = parent_1.key;
                break;
            }
            parent_1 = parent_1.parent;
        }
        if (!key) {
            "production" !== 'production' && state.warn("v-once can only be used inside v-for that is keyed. ", el.rawAttrsMap['v-once']);
            return genElement(el, state);
        }
        return "_o(".concat(genElement(el, state), ",").concat(state.onceId++, ",").concat(key, ")");
    } else {
        return genStatic(el, state);
    }
}
function genIf(el, state, altGen, altEmpty) {
    el.ifProcessed = true; // avoid recursion
    return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty);
}
function genIfConditions(conditions, state, altGen, altEmpty) {
    if (!conditions.length) {
        return altEmpty || '_e()';
    }
    var condition = conditions.shift();
    if (condition.exp) {
        return "(".concat(condition.exp, ")?").concat(genTernaryExp(condition.block), ":").concat(genIfConditions(conditions, state, altGen, altEmpty));
    } else {
        return "".concat(genTernaryExp(condition.block));
    }
    // v-if with v-once should generate code like (a)?_m(0):_m(1)
    function genTernaryExp(el) {
        return altGen ? altGen(el, state) : el.once ? genOnce(el, state) : genElement(el, state);
    }
}
function genFor(el, state, altGen, altHelper) {
    var exp = el.for;
    var alias = el.alias;
    var iterator1 = el.iterator1 ? ",".concat(el.iterator1) : '';
    var iterator2 = el.iterator2 ? ",".concat(el.iterator2) : '';
    if (false) {
        state.warn("<".concat(el.tag, " v-for=\"").concat(alias, " in ").concat(exp, "\">: component lists rendered with ") + "v-for should have explicit keys. " + "See https://v2.vuejs.org/v2/guide/list.html#key for more info.", el.rawAttrsMap['v-for'], true /* tip */);
    }
    el.forProcessed = true; // avoid recursion
    return "".concat(altHelper || '_l', "((").concat(exp, "),") + "function(".concat(alias).concat(iterator1).concat(iterator2, "){") + "return ".concat((altGen || genElement)(el, state)) + '})';
}
function genData(el, state) {
    var data = '{';
    // directives first.
    // directives may mutate the el's other properties before they are generated.
    var dirs = genDirectives(el, state);
    if (dirs) data += dirs + ',';
    // key
    if (el.key) {
        data += "key:".concat(el.key, ",");
    }
    // ref
    if (el.ref) {
        data += "ref:".concat(el.ref, ",");
    }
    if (el.refInFor) {
        data += "refInFor:true,";
    }
    // pre
    if (el.pre) {
        data += "pre:true,";
    }
    // record original tag name for components using "is" attribute
    if (el.component) {
        data += "tag:\"".concat(el.tag, "\",");
    }
    // module data generation functions
    for (var i = 0; i < state.dataGenFns.length; i++) {
        data += state.dataGenFns[i](el);
    }
    // attributes
    if (el.attrs) {
        data += "attrs:".concat(genProps(el.attrs), ",");
    }
    // DOM props
    if (el.props) {
        data += "domProps:".concat(genProps(el.props), ",");
    }
    // event handlers
    if (el.events) {
        data += "".concat(genHandlers(el.events, false), ",");
    }
    if (el.nativeEvents) {
        data += "".concat(genHandlers(el.nativeEvents, true), ",");
    }
    // slot target
    // only for non-scoped slots
    if (el.slotTarget && !el.slotScope) {
        data += "slot:".concat(el.slotTarget, ",");
    }
    // scoped slots
    if (el.scopedSlots) {
        data += "".concat(genScopedSlots(el, el.scopedSlots, state), ",");
    }
    // component v-model
    if (el.model) {
        data += "model:{value:".concat(el.model.value, ",callback:").concat(el.model.callback, ",expression:").concat(el.model.expression, "},");
    }
    // inline-template
    if (el.inlineTemplate) {
        var inlineTemplate = genInlineTemplate(el, state);
        if (inlineTemplate) {
            data += "".concat(inlineTemplate, ",");
        }
    }
    data = data.replace(/,$/, '') + '}';
    // v-bind dynamic argument wrap
    // v-bind with dynamic arguments must be applied using the same v-bind object
    // merge helper so that class/style/mustUseProp attrs are handled correctly.
    if (el.dynamicAttrs) {
        data = "_b(".concat(data, ",\"").concat(el.tag, "\",").concat(genProps(el.dynamicAttrs), ")");
    }
    // v-bind data wrap
    if (el.wrapData) {
        data = el.wrapData(data);
    }
    // v-on data wrap
    if (el.wrapListeners) {
        data = el.wrapListeners(data);
    }
    return data;
}
function genDirectives(el, state) {
    var dirs = el.directives;
    if (!dirs) return;
    var res = 'directives:[';
    var hasRuntime = false;
    var i, l, dir, needRuntime;
    for (i = 0, l = dirs.length; i < l; i++) {
        dir = dirs[i];
        needRuntime = true;
        var gen = state.directives[dir.name];
        if (gen) {
            // compile-time directive that manipulates AST.
            // returns true if it also needs a runtime counterpart.
            needRuntime = !!gen(el, dir, state.warn);
        }
        if (needRuntime) {
            hasRuntime = true;
            res += "{name:\"".concat(dir.name, "\",rawName:\"").concat(dir.rawName, "\"").concat(dir.value ? ",value:(".concat(dir.value, "),expression:").concat(JSON.stringify(dir.value)) : '').concat(dir.arg ? ",arg:".concat(dir.isDynamicArg ? dir.arg : "\"".concat(dir.arg, "\"")) : '').concat(dir.modifiers ? ",modifiers:".concat(JSON.stringify(dir.modifiers)) : '', "},");
        }
    }
    if (hasRuntime) {
        return res.slice(0, -1) + ']';
    }
}
function genInlineTemplate(el, state) {
    var ast = el.children[0];
    if (false) {
        state.warn('Inline-template components must have exactly one child element.', { start: el.start });
    }
    if (ast && ast.type === 1) {
        var inlineRenderFns = generate(ast, state.options);
        return "inlineTemplate:{render:function(){".concat(inlineRenderFns.render, "},staticRenderFns:[").concat(inlineRenderFns.staticRenderFns.map(function (code) {
            return "function(){".concat(code, "}");
        }).join(','), "]}");
    }
}
function genScopedSlots(el, slots, state) {
    // by default scoped slots are considered "stable", this allows child
    // components with only scoped slots to skip forced updates from parent.
    // but in some cases we have to bail-out of this optimization
    // for example if the slot contains dynamic names, has v-if or v-for on them...
    var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
        var slot = slots[key];
        return slot.slotTargetDynamic || slot.if || slot.for || containsSlotChild(slot) // is passing down slot from parent which may be dynamic
        ;
    });
    // #9534: if a component with scoped slots is inside a conditional branch,
    // it's possible for the same component to be reused but with different
    // compiled slot content. To avoid that, we generate a unique key based on
    // the generated code of all the slot contents.
    var needsKey = !!el.if;
    // OR when it is inside another scoped slot or v-for (the reactivity may be
    // disconnected due to the intermediate scope variable)
    // #9438, #9506
    // TODO: this can be further optimized by properly analyzing in-scope bindings
    // and skip force updating ones that do not actually use scope variables.
    if (!needsForceUpdate) {
        var parent_2 = el.parent;
        while (parent_2) {
            if (parent_2.slotScope && parent_2.slotScope !== emptySlotScopeToken || parent_2.for) {
                needsForceUpdate = true;
                break;
            }
            if (parent_2.if) {
                needsKey = true;
            }
            parent_2 = parent_2.parent;
        }
    }
    var generatedSlots = Object.keys(slots).map(function (key) {
        return genScopedSlot(slots[key], state);
    }).join(',');
    return "scopedSlots:_u([".concat(generatedSlots, "]").concat(needsForceUpdate ? ",null,true" : "").concat(!needsForceUpdate && needsKey ? ",null,false,".concat(hash(generatedSlots)) : "", ")");
}
function hash(str) {
    var hash = 5381;
    var i = str.length;
    while (i) {
        hash = hash * 33 ^ str.charCodeAt(--i);
    }
    return hash >>> 0;
}
function containsSlotChild(el) {
    if (el.type === 1) {
        if (el.tag === 'slot') {
            return true;
        }
        return el.children.some(containsSlotChild);
    }
    return false;
}
function genScopedSlot(el, state) {
    var isLegacySyntax = el.attrsMap['slot-scope'];
    if (el.if && !el.ifProcessed && !isLegacySyntax) {
        return genIf(el, state, genScopedSlot, "null");
    }
    if (el.for && !el.forProcessed) {
        return genFor(el, state, genScopedSlot);
    }
    var slotScope = el.slotScope === emptySlotScopeToken ? "" : String(el.slotScope);
    var fn = "function(".concat(slotScope, "){") + "return ".concat(el.tag === 'template' ? el.if && isLegacySyntax ? "(".concat(el.if, ")?").concat(genChildren(el, state) || 'undefined', ":undefined") : genChildren(el, state) || 'undefined' : genElement(el, state), "}");
    // reverse proxy v-slot without scope on this.$slots
    var reverseProxy = slotScope ? "" : ",proxy:true";
    return "{key:".concat(el.slotTarget || "\"default\"", ",fn:").concat(fn).concat(reverseProxy, "}");
}
function genChildren(el, state, checkSkip, altGenElement, altGenNode) {
    var children = el.children;
    if (children.length) {
        var el_1 = children[0];
        // optimize single v-for
        if (children.length === 1 && el_1.for && el_1.tag !== 'template' && el_1.tag !== 'slot') {
            var normalizationType_1 = checkSkip ? state.maybeComponent(el_1) ? ",1" : ",0" : "";
            return "".concat((altGenElement || genElement)(el_1, state)).concat(normalizationType_1);
        }
        var normalizationType = checkSkip ? getNormalizationType(children, state.maybeComponent) : 0;
        var gen_1 = altGenNode || genNode;
        return "[".concat(children.map(function (c) {
            return gen_1(c, state);
        }).join(','), "]").concat(normalizationType ? ",".concat(normalizationType) : '');
    }
}
// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType(children, maybeComponent) {
    var res = 0;
    for (var i = 0; i < children.length; i++) {
        var el = children[i];
        if (el.type !== 1) {
            continue;
        }
        if (needsNormalization(el) || el.ifConditions && el.ifConditions.some(function (c) {
            return needsNormalization(c.block);
        })) {
            res = 2;
            break;
        }
        if (maybeComponent(el) || el.ifConditions && el.ifConditions.some(function (c) {
            return maybeComponent(c.block);
        })) {
            res = 1;
        }
    }
    return res;
}
function needsNormalization(el) {
    return el.for !== undefined || el.tag === 'template' || el.tag === 'slot';
}
function genNode(node, state) {
    if (node.type === 1) {
        return genElement(node, state);
    } else if (node.type === 3 && node.isComment) {
        return genComment(node);
    } else {
        return genText(node);
    }
}
function genText(text) {
    return "_v(".concat(text.type === 2 ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text)), ")");
}
function genComment(comment) {
    return "_e(".concat(JSON.stringify(comment.text), ")");
}
function genSlot(el, state) {
    var slotName = el.slotName || '"default"';
    var children = genChildren(el, state);
    var res = "_t(".concat(slotName).concat(children ? ",function(){return ".concat(children, "}") : '');
    var attrs = el.attrs || el.dynamicAttrs ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) {
        return {
            // slot props are camelized
            name: camelize(attr.name),
            value: attr.value,
            dynamic: attr.dynamic
        };
    })) : null;
    var bind = el.attrsMap['v-bind'];
    if ((attrs || bind) && !children) {
        res += ",null";
    }
    if (attrs) {
        res += ",".concat(attrs);
    }
    if (bind) {
        res += "".concat(attrs ? '' : ',null', ",").concat(bind);
    }
    return res + ')';
}
// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent(componentName, el, state) {
    var children = el.inlineTemplate ? null : genChildren(el, state, true);
    return "_c(".concat(componentName, ",").concat(genData(el, state)).concat(children ? ",".concat(children) : '', ")");
}
function genProps(props) {
    var staticProps = "";
    var dynamicProps = "";
    for (var i = 0; i < props.length; i++) {
        var prop = props[i];
        var value = transformSpecialNewlines(prop.value);
        if (prop.dynamic) {
            dynamicProps += "".concat(prop.name, ",").concat(value, ",");
        } else {
            staticProps += "\"".concat(prop.name, "\":").concat(value, ",");
        }
    }
    staticProps = "{".concat(staticProps.slice(0, -1), "}");
    if (dynamicProps) {
        return "_d(".concat(staticProps, ",[").concat(dynamicProps.slice(0, -1), "])");
    } else {
        return staticProps;
    }
}
// #3895, #4268
function transformSpecialNewlines(text) {
    return text.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + ('do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' + 'super,throw,while,yield,delete,export,import,return,switch,default,' + 'extends,finally,continue,debugger,function,arguments').split(',').join('\\b|\\b') + '\\b');
// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + 'delete,typeof,void'.split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');
// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
// detect problematic expressions in a template
function detectErrors(ast, warn) {
    if (ast) {
        checkNode(ast, warn);
    }
}
function checkNode(node, warn) {
    if (node.type === 1) {
        for (var name_1 in node.attrsMap) {
            if (dirRE.test(name_1)) {
                var value = node.attrsMap[name_1];
                if (value) {
                    var range = node.rawAttrsMap[name_1];
                    if (name_1 === 'v-for') {
                        checkFor(node, "v-for=\"".concat(value, "\""), warn, range);
                    } else if (name_1 === 'v-slot' || name_1[0] === '#') {
                        checkFunctionParameterExpression(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                    } else if (onRE.test(name_1)) {
                        checkEvent(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                    } else {
                        checkExpression(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                    }
                }
            }
        }
        if (node.children) {
            for (var i = 0; i < node.children.length; i++) {
                checkNode(node.children[i], warn);
            }
        }
    } else if (node.type === 2) {
        checkExpression(node.expression, node.text, warn, node);
    }
}
function checkEvent(exp, text, warn, range) {
    var stripped = exp.replace(stripStringRE, '');
    var keywordMatch = stripped.match(unaryOperatorsRE);
    if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
        warn("avoid using JavaScript unary operator as property name: " + "\"".concat(keywordMatch[0], "\" in expression ").concat(text.trim()), range);
    }
    checkExpression(exp, text, warn, range);
}
function checkFor(node, text, warn, range) {
    checkExpression(node.for || '', text, warn, range);
    checkIdentifier(node.alias, 'v-for alias', text, warn, range);
    checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
    checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}
function checkIdentifier(ident, type, text, warn, range) {
    if (typeof ident === 'string') {
        try {
            new Function("var ".concat(ident, "=_"));
        } catch (e) {
            warn("invalid ".concat(type, " \"").concat(ident, "\" in expression: ").concat(text.trim()), range);
        }
    }
}
function checkExpression(exp, text, warn, range) {
    try {
        new Function("return ".concat(exp));
    } catch (e) {
        var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
        if (keywordMatch) {
            warn("avoid using JavaScript keyword as property name: " + "\"".concat(keywordMatch[0], "\"\n  Raw expression: ").concat(text.trim()), range);
        } else {
            warn("invalid expression: ".concat(e.message, " in\n\n") + "    ".concat(exp, "\n\n") + "  Raw expression: ".concat(text.trim(), "\n"), range);
        }
    }
}
function checkFunctionParameterExpression(exp, text, warn, range) {
    try {
        new Function(exp, '');
    } catch (e) {
        warn("invalid function parameter expression: ".concat(e.message, " in\n\n") + "    ".concat(exp, "\n\n") + "  Raw expression: ".concat(text.trim(), "\n"), range);
    }
}

var range = 2;
function generateCodeFrame(source, start, end) {
    if (start === void 0) {
        start = 0;
    }
    if (end === void 0) {
        end = source.length;
    }
    var lines = source.split(/\r?\n/);
    var count = 0;
    var res = [];
    for (var i = 0; i < lines.length; i++) {
        count += lines[i].length + 1;
        if (count >= start) {
            for (var j = i - range; j <= i + range || end > count; j++) {
                if (j < 0 || j >= lines.length) continue;
                res.push("".concat(j + 1).concat(repeat(" ", 3 - String(j + 1).length), "|  ").concat(lines[j]));
                var lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    var pad = start - (count - lineLength) + 1;
                    var length_1 = end > count ? lineLength - pad : end - start;
                    res.push("   |  " + repeat(" ", pad) + repeat("^", length_1));
                } else if (j > i) {
                    if (end > count) {
                        var length_2 = Math.min(end - count, lineLength);
                        res.push("   |  " + repeat("^", length_2));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join('\n');
}
function repeat(str, n) {
    var result = '';
    if (n > 0) {
        // eslint-disable-next-line no-constant-condition
        while (true) {
            // eslint-disable-line
            if (n & 1) result += str;
            n >>>= 1;
            if (n <= 0) break;
            str += str;
        }
    }
    return result;
}

function createFunction(code, errors) {
    try {
        return new Function(code);
    } catch (err) {
        errors.push({ err: err, code: code });
        return noop;
    }
}
function createCompileToFunctionFn(compile) {
    var cache = Object.create(null);
    return function compileToFunctions(template, options, vm) {
        options = extend({}, options);
        var warn = options.warn || warn$2;
        delete options.warn;
        /* istanbul ignore if */
        if (false) {
            // detect possible CSP restriction
            try {
                new Function('return 1');
            } catch (e) {
                if (e.toString().match(/unsafe-eval|CSP/)) {
                    warn('It seems you are using the standalone build of Vue.js in an ' + 'environment with Content Security Policy that prohibits unsafe-eval. ' + 'The template compiler cannot work in this environment. Consider ' + 'relaxing the policy to allow unsafe-eval or pre-compiling your ' + 'templates into render functions.');
                }
            }
        }
        // check cache
        var key = options.delimiters ? String(options.delimiters) + template : template;
        if (cache[key]) {
            return cache[key];
        }
        // compile
        var compiled = compile(template, options);
        // check compilation errors/tips
        if (false) {
            if (compiled.errors && compiled.errors.length) {
                if (options.outputSourceRange) {
                    compiled.errors.forEach(function (e) {
                        warn("Error compiling template:\n\n".concat(e.msg, "\n\n") + generateCodeFrame(template, e.start, e.end), vm);
                    });
                } else {
                    warn("Error compiling template:\n\n".concat(template, "\n\n") + compiled.errors.map(function (e) {
                        return "- ".concat(e);
                    }).join('\n') + '\n', vm);
                }
            }
            if (compiled.tips && compiled.tips.length) {
                if (options.outputSourceRange) {
                    compiled.tips.forEach(function (e) {
                        return tip(e.msg, vm);
                    });
                } else {
                    compiled.tips.forEach(function (msg) {
                        return tip(msg, vm);
                    });
                }
            }
        }
        // turn code into functions
        var res = {};
        var fnGenErrors = [];
        res.render = createFunction(compiled.render, fnGenErrors);
        res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
            return createFunction(code, fnGenErrors);
        });
        // check function generation errors.
        // this should only happen if there is a bug in the compiler itself.
        // mostly for codegen development use
        /* istanbul ignore if */
        if (false) {
            if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
                warn("Failed to generate render function:\n\n" + fnGenErrors.map(function (_a) {
                    var err = _a.err,
                        code = _a.code;
                    return "".concat(err.toString(), " in\n\n").concat(code, "\n");
                }).join('\n'), vm);
            }
        }
        return cache[key] = res;
    };
}

function createCompilerCreator(baseCompile) {
    return function createCompiler(baseOptions) {
        function compile(template, options) {
            var finalOptions = Object.create(baseOptions);
            var errors = [];
            var tips = [];
            var warn = function warn(msg, range, tip) {
                (tip ? tips : errors).push(msg);
            };
            if (options) {
                if (false) {
                    // $flow-disable-line
                    var leadingSpaceLength_1 = template.match(/^\s*/)[0].length;
                    warn = function warn(msg, range, tip) {
                        var data = typeof msg === 'string' ? { msg: msg } : msg;
                        if (range) {
                            if (range.start != null) {
                                data.start = range.start + leadingSpaceLength_1;
                            }
                            if (range.end != null) {
                                data.end = range.end + leadingSpaceLength_1;
                            }
                        }
                        (tip ? tips : errors).push(data);
                    };
                }
                // merge custom modules
                if (options.modules) {
                    finalOptions.modules = (baseOptions.modules || []).concat(options.modules);
                }
                // merge custom directives
                if (options.directives) {
                    finalOptions.directives = extend(Object.create(baseOptions.directives || null), options.directives);
                }
                // copy other options
                for (var key in options) {
                    if (key !== 'modules' && key !== 'directives') {
                        finalOptions[key] = options[key];
                    }
                }
            }
            finalOptions.warn = warn;
            var compiled = baseCompile(template.trim(), finalOptions);
            if (false) {
                detectErrors(compiled.ast, warn);
            }
            compiled.errors = errors;
            compiled.tips = tips;
            return compiled;
        }
        return {
            compile: compile,
            compileToFunctions: createCompileToFunctionFn(compile)
        };
    };
}

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile(template, options) {
    var ast = parse(template.trim(), options);
    if (options.optimize !== false) {
        optimize(ast, options);
    }
    var code = generate(ast, options);
    return {
        ast: ast,
        render: code.render,
        staticRenderFns: code.staticRenderFns
    };
});

var _a = createCompiler(baseOptions),
    compileToFunctions = _a.compileToFunctions;

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode(href) {
    div = div || document.createElement('div');
    div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
    return div.innerHTML.indexOf('&#10;') > 0;
}
// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

var idToTemplate = cached(function (id) {
    var el = query(id);
    return el && el.innerHTML;
});
var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (el, hydrating) {
    el = el && query(el);
    /* istanbul ignore if */
    if (el === document.body || el === document.documentElement) {
        "production" !== 'production' && warn$2("Do not mount Vue to <html> or <body> - mount to normal elements instead.");
        return this;
    }
    var options = this.$options;
    // resolve template/el and convert to render function
    if (!options.render) {
        var template = options.template;
        if (template) {
            if (typeof template === 'string') {
                if (template.charAt(0) === '#') {
                    template = idToTemplate(template);
                    /* istanbul ignore if */
                    if (false) {
                        warn$2("Template element not found or is empty: ".concat(options.template), this);
                    }
                }
            } else if (template.nodeType) {
                template = template.innerHTML;
            } else {
                if (false) {
                    warn$2('invalid template option:' + template, this);
                }
                return this;
            }
        } else if (el) {
            // @ts-expect-error
            template = getOuterHTML(el);
        }
        if (template) {
            /* istanbul ignore if */
            if (false) {
                mark('compile');
            }
            var _a = compileToFunctions(template, {
                outputSourceRange: "production" !== 'production',
                shouldDecodeNewlines: shouldDecodeNewlines,
                shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
                delimiters: options.delimiters,
                comments: options.comments
            }, this),
                render = _a.render,
                staticRenderFns = _a.staticRenderFns;
            options.render = render;
            options.staticRenderFns = staticRenderFns;
            /* istanbul ignore if */
            if (false) {
                mark('compile end');
                measure("vue ".concat(this._name, " compile"), 'compile', 'compile end');
            }
        }
    }
    return mount.call(this, el, hydrating);
};
/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML(el) {
    if (el.outerHTML) {
        return el.outerHTML;
    } else {
        var container = document.createElement('div');
        container.appendChild(el.cloneNode(true));
        return container.innerHTML;
    }
}
Vue.compile = compileToFunctions;

exports.EffectScope = EffectScope;
exports.computed = computed;
exports.customRef = customRef;
exports.default = Vue;
exports.defineAsyncComponent = defineAsyncComponent;
exports.defineComponent = defineComponent;
exports.del = del;
exports.effectScope = effectScope;
exports.getCurrentInstance = getCurrentInstance;
exports.getCurrentScope = getCurrentScope;
exports.h = h;
exports.inject = inject;
exports.isProxy = isProxy;
exports.isReactive = isReactive;
exports.isReadonly = isReadonly;
exports.isRef = isRef;
exports.isShallow = isShallow;
exports.markRaw = markRaw;
exports.mergeDefaults = mergeDefaults;
exports.nextTick = nextTick;
exports.onActivated = onActivated;
exports.onBeforeMount = onBeforeMount;
exports.onBeforeUnmount = onBeforeUnmount;
exports.onBeforeUpdate = onBeforeUpdate;
exports.onDeactivated = onDeactivated;
exports.onErrorCaptured = onErrorCaptured;
exports.onMounted = onMounted;
exports.onRenderTracked = onRenderTracked;
exports.onRenderTriggered = onRenderTriggered;
exports.onScopeDispose = onScopeDispose;
exports.onServerPrefetch = onServerPrefetch;
exports.onUnmounted = onUnmounted;
exports.onUpdated = onUpdated;
exports.provide = provide;
exports.proxyRefs = proxyRefs;
exports.reactive = reactive;
exports.readonly = readonly;
exports.ref = ref$1;
exports.set = set;
exports.shallowReactive = shallowReactive;
exports.shallowReadonly = shallowReadonly;
exports.shallowRef = shallowRef;
exports.toRaw = toRaw;
exports.toRef = toRef;
exports.toRefs = toRefs;
exports.triggerRef = triggerRef;
exports.unref = unref;
exports.useAttrs = useAttrs;
exports.useCssModule = useCssModule;
exports.useCssVars = useCssVars;
exports.useListeners = useListeners;
exports.useSlots = useSlots;
exports.version = version;
exports.watch = watch;
exports.watchEffect = watchEffect;
exports.watchPostEffect = watchPostEffect;
exports.watchSyncEffect = watchSyncEffect;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39), __webpack_require__(988).setImmediate))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_bar_grid_vue__ = __webpack_require__(407);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_14ec3a27_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_bar_grid_vue__ = __webpack_require__(1116);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_bar_grid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_14ec3a27_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_bar_grid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_filtro_vue__ = __webpack_require__(406);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec56e20_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_filtro_vue__ = __webpack_require__(1114);
function injectStyle (ssrContext) {
  __webpack_require__(1112)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_filtro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec56e20_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_filtro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(9);

var _axios2 = _interopRequireDefault(_axios);

var _apiFunctions = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var NOTEURL = 'crm/note/';
var NEGOCIOURL = 'crm/negocio/';
var PESSOAURL = 'crm/pessoa/';
var ORGURL = 'crm/organizacao/';
var FUNILURL = 'crm/funil/';
var MOTIVOURL = 'crm/motivo/';
var ORIGEMURL = 'crm/origem/';
var TAGURL = 'crm/tag/';
var EMAILURL = 'crm/email/draft/';
var LEADURL = 'crm/lead/';
var TEMPLATEURL = 'crm/template/';

exports.default = {
    data: function data() {
        return {
            listDuplicates: [],
            searching: false
        };
    },


    methods: {
        ///////////////// FUNIL

        apiFunil: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(obj, id, responseCallback) {
                var url, metodo, sendData, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                url = FUNILURL;
                                metodo = 'post';

                                if (id) {
                                    url = url + id;
                                    metodo = 'put';
                                }

                                sendData = { funil: obj };
                                _context.next = 6;
                                return (0, _apiFunctions.apiORDSpost)(this.$store, url, sendData, metodo);

                            case 6:
                                data = _context.sent;

                                if (data.items) {
                                    _context.next = 9;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 9:

                                if (responseCallback) {
                                    responseCallback(data.items[0]);
                                }

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function apiFunil(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return apiFunil;
        }(),


        ///////////////// OBSERVACOES

        apiNotes: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(obj, id, responseCallback) {
                var url, metodo, sendData, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                url = NOTEURL;
                                metodo = 'post';

                                if (id) {
                                    url = url + id;
                                    metodo = 'put';
                                }

                                sendData = { note: obj };
                                _context2.next = 6;
                                return (0, _apiFunctions.apiORDSpost)(this.$store, url, sendData, metodo);

                            case 6:
                                data = _context2.sent;

                                if (data.items) {
                                    _context2.next = 9;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 9:

                                if (responseCallback) {
                                    responseCallback(data.items[0]);
                                }

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function apiNotes(_x4, _x5, _x6) {
                return _ref2.apply(this, arguments);
            }

            return apiNotes;
        }(),
        apiNotesDelete: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id, responseCallback) {
                var url, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                url = NOTEURL + id;
                                _context3.next = 3;
                                return (0, _apiFunctions.apiORDSdelete)(this.$store, url);

                            case 3:
                                data = _context3.sent;


                                if (responseCallback) {
                                    responseCallback();
                                }

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function apiNotesDelete(_x7, _x8) {
                return _ref3.apply(this, arguments);
            }

            return apiNotesDelete;
        }(),


        ///////////////// TAG

        apiTag: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(obj, id, responseCallback) {
                var url, metodo, sendData, data;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                url = TAGURL;
                                metodo = 'post';

                                if (id) {
                                    url = url + id;
                                    metodo = 'put';
                                }

                                sendData = { tag: obj };
                                _context4.next = 6;
                                return (0, _apiFunctions.apiORDSpost)(this.$store, url, sendData, metodo);

                            case 6:
                                data = _context4.sent;

                                if (data.items) {
                                    _context4.next = 9;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 9:

                                if (responseCallback) {
                                    responseCallback(data.items[0]);
                                }

                            case 10:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function apiTag(_x9, _x10, _x11) {
                return _ref4.apply(this, arguments);
            }

            return apiTag;
        }(),
        apiTagDelete: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id, responseCallback) {
                var url, data;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                url = TAGURL + id;
                                _context5.next = 3;
                                return (0, _apiFunctions.apiORDSdelete)(this.$store, url);

                            case 3:
                                data = _context5.sent;


                                if (responseCallback) {
                                    responseCallback();
                                }

                            case 5:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function apiTagDelete(_x12, _x13) {
                return _ref5.apply(this, arguments);
            }

            return apiTagDelete;
        }(),


        ///////////////// ORIGEM

        apiOrigem: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(obj, id, responseCallback) {
                var url, metodo, sendData, data;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                url = ORIGEMURL;
                                metodo = 'post';

                                if (id) {
                                    url = url + id;
                                    metodo = 'put';
                                }

                                sendData = { origem: obj };
                                _context6.next = 6;
                                return (0, _apiFunctions.apiORDSpost)(this.$store, url, sendData, metodo);

                            case 6:
                                data = _context6.sent;

                                if (data.items) {
                                    _context6.next = 9;
                                    break;
                                }

                                return _context6.abrupt('return');

                            case 9:

                                if (responseCallback) {
                                    responseCallback(data.items[0]);
                                }

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function apiOrigem(_x14, _x15, _x16) {
                return _ref6.apply(this, arguments);
            }

            return apiOrigem;
        }(),
        apiOrigemDelete: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id, responseCallback) {
                var url, data;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                url = ORIGEMURL + id;
                                _context7.next = 3;
                                return (0, _apiFunctions.apiORDSdelete)(this.$store, url);

                            case 3:
                                data = _context7.sent;


                                if (responseCallback) {
                                    responseCallback();
                                }

                            case 5:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function apiOrigemDelete(_x17, _x18) {
                return _ref7.apply(this, arguments);
            }

            return apiOrigemDelete;
        }(),


        ///////////////// MOTIVOS

        apiMotivo: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(obj, id, responseCallback) {
                var url, metodo, sendData, data;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                url = MOTIVOURL;
                                metodo = 'post';

                                if (id) {
                                    url = url + id;
                                    metodo = 'put';
                                }

                                sendData = { motivo: obj };
                                _context8.next = 6;
                                return (0, _apiFunctions.apiORDSpost)(this.$store, url, sendData, metodo);

                            case 6:
                                data = _context8.sent;

                                if (!data.errmessages) {
                                    _context8.next = 12;
                                    break;
                                }

                                this.errmessages = data.errmessages;
                                this.$erpToastError('Alguns erros precisam ser corrigidos.');
                                _context8.next = 14;
                                break;

                            case 12:
                                if (data.items) {
                                    _context8.next = 14;
                                    break;
                                }

                                return _context8.abrupt('return');

                            case 14:

                                if (responseCallback) {
                                    responseCallback(data.items[0]);
                                }

                            case 15:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function apiMotivo(_x19, _x20, _x21) {
                return _ref8.apply(this, arguments);
            }

            return apiMotivo;
        }(),
        apiMotivoDelete: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id, responseCallback) {
                var url, data;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                url = MOTIVOURL + id;
                                _context9.next = 3;
                                return (0, _apiFunctions.apiORDSdelete)(this.$store, url);

                            case 3:
                                data = _context9.sent;


                                if (responseCallback) {
                                    responseCallback();
                                }

                            case 5:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function apiMotivoDelete(_x22, _x23) {
                return _ref9.apply(this, arguments);
            }

            return apiMotivoDelete;
        }(),


        ///////////////// NEGOCIO

        apiNegocio: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(obj, id, responseCallback) {
                var url, metodo, sendData, data;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                url = NEGOCIOURL;
                                metodo = 'post';

                                if (id) {
                                    url = url + id;
                                    metodo = 'put';
                                }

                                sendData = { negociocrm: obj };
                                _context10.next = 6;
                                return (0, _apiFunctions.apiORDSpost)(this.$store, url, sendData, metodo);

                            case 6:
                                data = _context10.sent;

                                if (data.items) {
                                    _context10.next = 9;
                                    break;
                                }

                                return _context10.abrupt('return');

                            case 9:

                                if (responseCallback) {
                                    responseCallback(data.items[0]);
                                }

                            case 10:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function apiNegocio(_x24, _x25, _x26) {
                return _ref10.apply(this, arguments);
            }

            return apiNegocio;
        }(),


        //////////////// PESSOAS

        apiPessoas: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(obj, id, responseCallback) {
                var url, metodo, sendData, data;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                url = PESSOAURL;
                                metodo = 'post';

                                if (id) {
                                    url = url + id;
                                    metodo = 'put';
                                }

                                sendData = {};

                                //inclui a organizacao se necessario
                                // if (obj.organizacao && obj.organizacao.novo) {
                                //   sendData = { orgranizacao: obj.organizacao }
                                //   await this.apiOrganizacao(sendData, null, null)
                                // }

                                sendData = { pessoa: obj };
                                _context11.next = 7;
                                return (0, _apiFunctions.apiORDSpost)(this.$store, url, sendData, metodo);

                            case 7:
                                data = _context11.sent;

                                if (data.items) {
                                    _context11.next = 10;
                                    break;
                                }

                                return _context11.abrupt('return');

                            case 10:

                                if (responseCallback) {
                                    responseCallback(data.items[0]);
                                }

                            case 11:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function apiPessoas(_x27, _x28, _x29) {
                return _ref11.apply(this, arguments);
            }

            return apiPessoas;
        }(),
        apiPessoasDelete: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(id, responseCallback) {
                var url, data;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                url = PESSOAURL + '/' + id;
                                _context12.next = 3;
                                return (0, _apiFunctions.apiORDSdelete)(this.$store, url);

                            case 3:
                                data = _context12.sent;


                                if (responseCallback) {
                                    responseCallback();
                                }

                            case 5:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function apiPessoasDelete(_x30, _x31) {
                return _ref12.apply(this, arguments);
            }

            return apiPessoasDelete;
        }(),


        //////////////// ORGANIZACOES

        apiOrg: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(obj, id, responseCallback) {
                var url, metodo, sendData, data;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                url = ORGURL;
                                metodo = 'post';

                                if (id) {
                                    url = url + '/' + id;
                                    metodo = 'put';
                                }

                                sendData = {};


                                sendData = { org: obj };
                                _context13.next = 7;
                                return (0, _apiFunctions.apiORDSpost)(this.$store, url, sendData, metodo);

                            case 7:
                                data = _context13.sent;

                                if (data.items) {
                                    _context13.next = 10;
                                    break;
                                }

                                return _context13.abrupt('return');

                            case 10:

                                if (responseCallback) {
                                    responseCallback(data.items[0]);
                                }

                            case 11:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function apiOrg(_x32, _x33, _x34) {
                return _ref13.apply(this, arguments);
            }

            return apiOrg;
        }(),
        apiOrgDelete: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(id, responseCallback) {
                var url, data;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                url = ORGURL + '/' + id;
                                _context14.next = 3;
                                return (0, _apiFunctions.apiORDSdelete)(this.$store, url);

                            case 3:
                                data = _context14.sent;


                                if (responseCallback) {
                                    responseCallback();
                                }

                            case 5:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function apiOrgDelete(_x35, _x36) {
                return _ref14.apply(this, arguments);
            }

            return apiOrgDelete;
        }(),
        apiAgendaDelete: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(codagenda, responseCallback) {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                modulo = 'cg/agenda/' + codagenda;
                                _context15.next = 3;
                                return (0, _apiFunctions.apiORDSdelete)(this.$store, modulo);

                            case 3:
                                data = _context15.sent;

                                if (responseCallback) {
                                    responseCallback();
                                }

                            case 5:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function apiAgendaDelete(_x37, _x38) {
                return _ref15.apply(this, arguments);
            }

            return apiAgendaDelete;
        }(),


        //////////////// LEADS

        apiLead: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(obj, id, responseCallback) {
                var url, metodo, sendData, data;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                url = LEADURL;
                                metodo = 'post';

                                if (id) {
                                    url = url + id;
                                    metodo = 'put';
                                }

                                sendData = {};


                                sendData = { lead: obj };
                                _context16.next = 7;
                                return (0, _apiFunctions.apiORDSpost)(this.$store, url, sendData, metodo);

                            case 7:
                                data = _context16.sent;

                                if (data.items) {
                                    _context16.next = 10;
                                    break;
                                }

                                return _context16.abrupt('return');

                            case 10:

                                if (responseCallback) {
                                    responseCallback(data.items[0]);
                                }

                            case 11:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function apiLead(_x39, _x40, _x41) {
                return _ref16.apply(this, arguments);
            }

            return apiLead;
        }(),
        apiLeadDelete: function () {
            var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(id, responseCallback) {
                var url, data;
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                url = LEADURL + id;
                                _context17.next = 3;
                                return (0, _apiFunctions.apiORDSdelete)(this.$store, url);

                            case 3:
                                data = _context17.sent;


                                if (responseCallback) {
                                    responseCallback();
                                }

                            case 5:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, this);
            }));

            function apiLeadDelete(_x42, _x43) {
                return _ref17.apply(this, arguments);
            }

            return apiLeadDelete;
        }(),


        //////////////// TEMPLATES DE EMAILS

        apiTemplate: function () {
            var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(obj, id, responseCallback) {
                var url, metodo, sendData, data;
                return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                url = TEMPLATEURL;
                                metodo = 'post';

                                if (id) {
                                    url = url + id;
                                    metodo = 'put';
                                }

                                sendData = {};


                                sendData = { template: obj };
                                _context18.next = 7;
                                return (0, _apiFunctions.apiORDSpost)(this.$store, url, sendData, metodo);

                            case 7:
                                data = _context18.sent;

                                if (data.items) {
                                    _context18.next = 10;
                                    break;
                                }

                                return _context18.abrupt('return');

                            case 10:

                                if (responseCallback) {
                                    responseCallback(data.items[0]);
                                }

                            case 11:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, this);
            }));

            function apiTemplate(_x44, _x45, _x46) {
                return _ref18.apply(this, arguments);
            }

            return apiTemplate;
        }(),
        apiTemplateDelete: function () {
            var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(id, responseCallback) {
                var url, data;
                return regeneratorRuntime.wrap(function _callee19$(_context19) {
                    while (1) {
                        switch (_context19.prev = _context19.next) {
                            case 0:
                                url = TEMPLATEURL + id;
                                _context19.next = 3;
                                return (0, _apiFunctions.apiORDSdelete)(this.$store, url);

                            case 3:
                                data = _context19.sent;


                                if (responseCallback) {
                                    responseCallback();
                                }

                            case 5:
                            case 'end':
                                return _context19.stop();
                        }
                    }
                }, _callee19, this);
            }));

            function apiTemplateDelete(_x47, _x48) {
                return _ref19.apply(this, arguments);
            }

            return apiTemplateDelete;
        }(),


        //////////////// ENVIO DE EMAILS

        emailPost: function () {
            var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(obj, id, responseCallback) {
                var url, metodo, sendData, data;
                return regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                        switch (_context20.prev = _context20.next) {
                            case 0:
                                url = EMAILURL;
                                metodo = 'post';

                                if (id) {
                                    url = url + id;
                                    metodo = 'put';
                                }

                                sendData = {};


                                sendData = { email: obj };
                                _context20.next = 7;
                                return (0, _apiFunctions.apiORDSpost)(this.$store, url, sendData, metodo);

                            case 7:
                                data = _context20.sent;

                                if (data.items) {
                                    _context20.next = 10;
                                    break;
                                }

                                return _context20.abrupt('return');

                            case 10:

                                if (responseCallback) {
                                    responseCallback(data.items[0]);
                                }

                            case 11:
                            case 'end':
                                return _context20.stop();
                        }
                    }
                }, _callee20, this);
            }));

            function emailPost(_x49, _x50, _x51) {
                return _ref20.apply(this, arguments);
            }

            return emailPost;
        }(),
        apiEmailDelete: function () {
            var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(id, responseCallback) {
                var url, data;
                return regeneratorRuntime.wrap(function _callee21$(_context21) {
                    while (1) {
                        switch (_context21.prev = _context21.next) {
                            case 0:
                                url = EMAILURL + id;
                                _context21.next = 3;
                                return (0, _apiFunctions.apiORDSdelete)(this.$store, url);

                            case 3:
                                data = _context21.sent;


                                if (responseCallback) {
                                    responseCallback();
                                }

                            case 5:
                            case 'end':
                                return _context21.stop();
                        }
                    }
                }, _callee21, this);
            }));

            function apiEmailDelete(_x52, _x53) {
                return _ref21.apply(this, arguments);
            }

            return apiEmailDelete;
        }(),
        apiEmailLido: function () {
            var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(id, responseCallback) {
                var url, data;
                return regeneratorRuntime.wrap(function _callee22$(_context22) {
                    while (1) {
                        switch (_context22.prev = _context22.next) {
                            case 0:
                                url = '/crm/email/' + id + '/lido';
                                _context22.next = 3;
                                return (0, _apiFunctions.apiORDSpost)(this.$store, url, null, 'post');

                            case 3:
                                data = _context22.sent;


                                if (responseCallback) {
                                    responseCallback();
                                }

                            case 5:
                            case 'end':
                                return _context22.stop();
                        }
                    }
                }, _callee22, this);
            }));

            function apiEmailLido(_x54, _x55) {
                return _ref22.apply(this, arguments);
            }

            return apiEmailLido;
        }(),
        apiUploadAnexo: function apiUploadAnexo(objAnexo, responseCallback) {
            var formData = new FormData();
            formData.append('file', objAnexo.selectedFile);

            var url = this.$store.getters.urlOrds + 'docs/';

            _axios2.default.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'ref': 'EMAILCRM',
                    'chaveref': objAnexo.codemail,
                    'filename': objAnexo.selectedFile.name
                }
            }).then(function (response) {
                if (response.data.items) {
                    if (responseCallback) {
                        var data = response.data.items[0];
                        responseCallback(data);
                    }
                }
            });
        },
        apiDeleteAnexo: function apiDeleteAnexo(coddoc) {
            var url = this.$store.getters.urlOrds + 'docs/' + coddoc;

            var self = this;
            _axios2.default.delete(url).then(function (data) {
                self.$erpToastSuccess('Anexo removido');
            });
        }
    }
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var store = __webpack_require__(80)('wks');
var uid = __webpack_require__(58);
var _Symbol = __webpack_require__(12).Symbol;
var USE_SYMBOL = typeof _Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.1.15 ToLength
var toInteger = __webpack_require__(43);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_chart_vue__ = __webpack_require__(472);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b74419_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_chart_vue__ = __webpack_require__(1310);
function injectStyle (ssrContext) {
  __webpack_require__(1308)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59b74419"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b74419_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(14)(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(10);
var IE8_DOM_DEFINE = __webpack_require__(184);
var toPrimitive = __webpack_require__(46);
var dP = Object.defineProperty;

exports.f = __webpack_require__(21) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_dash_card_vue__ = __webpack_require__(465);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cd05c86_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_dash_card_vue__ = __webpack_require__(1288);
function injectStyle (ssrContext) {
  __webpack_require__(1286)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1cd05c86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_dash_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cd05c86_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_dash_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.1.13 ToObject(argument)
var defined = __webpack_require__(47);
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function webpackUniversalModuleDefinition(root, factory) {
  if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["vue-focus-lock"] = factory();else root["vue-focus-lock"] = factory();
})(undefined, function () {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/var installedModules = {};
      /******/
      /******/ // The require function
      /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/__webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/__webpack_require__.c = installedModules;
      /******/
      /******/ // identity function for calling harmony imports with the correct context
      /******/__webpack_require__.i = function (value) {
        return value;
      };
      /******/
      /******/ // define getter function for harmony exports
      /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, {
            /******/configurable: false,
            /******/enumerable: true,
            /******/get: getter
            /******/ });
          /******/
        }
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
          return module['default'];
        } :
        /******/function getModuleExports() {
          return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/__webpack_require__.p = "";
      /******/
      /******/ // Load entry module and return exports
      /******/return __webpack_require__(__webpack_require__.s = 6);
      /******/
    }(
    /************************************************************************/
    /******/[
    /* 0 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "a", function () {
        return toArray;
      });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
        return arrayFind;
      });
      var toArray = function toArray(a) {
        var ret = Array(a.length);
        for (var i = 0; i < a.length; ++i) {
          ret[i] = a[i];
        }
        return ret;
      };

      var arrayFind = function arrayFind(array, search) {
        return array.filter(function (a) {
          return a === search;
        })[0];
      };

      /***/
    },
    /* 1 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";

      Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "FOCUS_GROUP", function () {
        return FOCUS_GROUP;
      });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "FOCUS_DISABLED", function () {
        return FOCUS_DISABLED;
      });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "FOCUS_ALLOW", function () {
        return FOCUS_ALLOW;
      });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "FOCUS_AUTO", function () {
        return FOCUS_AUTO;
      });
      var FOCUS_GROUP = 'data-focus-lock';
      var FOCUS_DISABLED = 'data-focus-lock-disabled';
      var FOCUS_ALLOW = 'data-no-focus-lock';
      var FOCUS_AUTO = 'data-autofocus-inside';

      /***/
    },
    /* 2 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(1);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(0);

      var filterNested = function filterNested(nodes) {
        var l = nodes.length;
        var i = void 0;
        var j = void 0;
        for (i = 0; i < l; i += 1) {
          for (j = 0; j < l; j += 1) {
            if (i !== j) {
              if (nodes[i].contains(nodes[j])) {
                return filterNested(nodes.filter(function (x) {
                  return x !== nodes[j];
                }));
              }
            }
          }
        }
        return nodes;
      };

      var getTopParent = function getTopParent(node) {
        return node.parentNode ? getTopParent(node.parentNode) : node;
      };

      var getAllAffectedNodes = function getAllAffectedNodes(node) {
        var group = node.getAttribute(__WEBPACK_IMPORTED_MODULE_0__constants__["FOCUS_GROUP"]);
        if (group) {
          return filterNested(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__array__["a" /* toArray */])(getTopParent(node).querySelectorAll('[' + __WEBPACK_IMPORTED_MODULE_0__constants__["FOCUS_GROUP"] + '="' + group + '"]:not([' + __WEBPACK_IMPORTED_MODULE_0__constants__["FOCUS_DISABLED"] + '="disabled"])')));
        }
        return [node];
      };

      /* harmony default export */__webpack_exports__["a"] = getAllAffectedNodes;

      /***/
    },
    /* 3 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";
      /* unused harmony export newFocus */
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__ = __webpack_require__(12);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__ = __webpack_require__(13);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__utils_all_affected__ = __webpack_require__(2);

      var findAutoFocused = function findAutoFocused(autoFocusables) {
        return function (node) {
          return !!node.autofocus || node.dataset && !!node.dataset.autofocus || autoFocusables.indexOf(node) >= 0;
        };
      };

      var newFocus = function newFocus(innerNodes, outerNodes, activeElement, lastNode, autoFocused) {
        var cnt = innerNodes.length;
        var firstFocus = innerNodes[0];
        var lastFocus = innerNodes[cnt - 1];

        // focus is inside
        if (innerNodes.indexOf(activeElement) >= 0) {
          return undefined;
        }

        var activeIndex = outerNodes.indexOf(activeElement);
        var lastIndex = outerNodes.indexOf(lastNode || activeIndex);
        var lastNodeInside = innerNodes.indexOf(lastNode);
        var indexDiff = activeIndex - lastIndex;
        var firstNodeIndex = outerNodes.indexOf(firstFocus);
        var lastNodeIndex = outerNodes.indexOf(lastFocus);

        // new focus
        if (activeIndex === -1 || lastNodeInside === -1) {
          return innerNodes.indexOf(autoFocused.length ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__["a" /* default */])(autoFocused) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__["a" /* default */])(innerNodes));
        }
        // old focus
        if (!indexDiff && lastNodeInside >= 0) {
          return lastNodeInside;
        }
        // jump out
        if (indexDiff && Math.abs(indexDiff) > 1) {
          return lastNodeInside;
        }
        // focus above lock
        if (activeIndex <= firstNodeIndex) {
          return cnt - 1;
        }
        // focus below lock
        if (activeIndex > lastNodeIndex) {
          return 0;
        }
        // index is inside tab order, but outside Lock
        if (indexDiff) {
          if (Math.abs(indexDiff) > 1) {
            return lastNodeInside;
          }
          return (cnt + lastNodeInside + indexDiff) % cnt;
        }
        // do nothing
        return undefined;
      };

      var getTopCommonParent = function getTopCommonParent(activeElement, entry, entries) {
        var topCommon = entry;
        entries.forEach(function (subEntry) {
          var common = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["a" /* getCommonParent */])(activeElement, subEntry);
          if (common) {
            if (common.contains(topCommon)) {
              topCommon = common;
            } else {
              topCommon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["a" /* getCommonParent */])(common, topCommon);
            }
          }
        });
        return topCommon;
      };

      var allParentAutofocusables = function allParentAutofocusables(entries) {
        return entries.reduce(function (acc, node) {
          return acc.concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["b" /* parentAutofocusables */])(node));
        }, []);
      };

      var notAGuard = function notAGuard(node) {
        return !(node.dataset && node.dataset.focusGuard);
      };

      var getFocusMerge = function getFocusMerge(topNode, lastNode) {
        var activeElement = document && document.activeElement;
        var entries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_all_affected__["a" /* default */])(topNode).filter(notAGuard);

        var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);

        var innerElements = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["c" /* getTabbableNodes */])(entries).filter(function (_ref) {
          var node = _ref.node;
          return notAGuard(node);
        });

        if (!innerElements[0]) {
          innerElements = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["d" /* getAllTabbableNodes */])(entries).filter(function (_ref2) {
            var node = _ref2.node;
            return notAGuard(node);
          });
          if (!innerElements[0]) {
            return undefined;
          }
        }

        var innerNodes = innerElements.map(function (_ref3) {
          var node = _ref3.node;
          return node;
        });

        var outerNodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["c" /* getTabbableNodes */])([commonParent]).map(function (_ref4) {
          var node = _ref4.node;
          return node;
        });

        var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode, innerNodes.filter(findAutoFocused(allParentAutofocusables(entries))));

        if (newId === undefined) {
          return newId;
        }
        return innerElements[newId];
      };

      /* harmony default export */__webpack_exports__["a"] = getFocusMerge;

      /***/
    },
    /* 4 */
    /***/function (module, exports, __webpack_require__) {

      var Component = __webpack_require__(17)(
      /* script */
      __webpack_require__(5),
      /* template */
      __webpack_require__(18),
      /* scopeId */
      null,
      /* cssModules */
      null);
      Component.options.__file = "/Users/akorzunov/dev/Z/mellis/github/focus/vue-focus-lock/src/Lock.vue";
      if (Component.esModule && Object.keys(Component.esModule).some(function (key) {
        return key !== "default" && key !== "__esModule";
      })) {
        console.error("named exports are not supported in *.vue files.");
      }
      if (Component.options.functional) {
        console.error("[vue-loader] Lock.vue: functional components are not supported with templates, they should use render functions.");
      }

      /* hot reload */
      if (false) {
        (function () {
          var hotAPI = require("vue-hot-reload-api");
          hotAPI.install(require("vue"), false);
          if (!hotAPI.compatible) return;
          module.hot.accept();
          if (!module.hot.data) {
            hotAPI.createRecord("data-v-0d4029e0", Component.options);
          } else {
            hotAPI.reload("data-v-0d4029e0", Component.options);
          }
        })();
      }

      module.exports = Component.exports;

      /***/
    },
    /* 5 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _focusLock = __webpack_require__(9);

      var _focusLock2 = _interopRequireDefault(_focusLock);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
        } else {
          obj[key] = value;
        }return obj;
      } //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //

      function deferAction(action) {
        var setImmediate = window.setImmediate;
        if (typeof setImmediate !== 'undefined') {
          setImmediate(action);
        } else {
          setTimeout(action, 1);
        }
      }

      var lastActiveTrap = 0;
      var lastActiveFocus = null;

      var focusWasOutsideWindow = false;

      var focusOnBody = function focusOnBody() {
        return document && document.activeElement === document.body;
      };

      var isFreeFocus = function isFreeFocus() {
        return focusOnBody() || (0, _focusLock.focusIsHidden)();
      };

      var activateTrap = function activateTrap() {
        var result = false;
        if (lastActiveTrap) {
          var _lastActiveTrap = lastActiveTrap,
              observed = _lastActiveTrap.observed,
              onActivation = _lastActiveTrap.onActivation;

          if (focusWasOutsideWindow || !isFreeFocus() || !lastActiveFocus) {
            if (observed && !(0, _focusLock.focusInside)(observed)) {
              onActivation();
              result = (0, _focusLock2.default)(observed, lastActiveFocus);
            }
            focusWasOutsideWindow = false;
            lastActiveFocus = document && document.activeElement;
          }
        }
        return result;
      };

      var reducePropsToState = function reducePropsToState(propsList) {
        return propsList.filter(function (_ref) {
          var disabled = _ref.disabled;
          return !disabled;
        }).slice(-1)[0];
      };

      var handleStateChangeOnClient = function handleStateChangeOnClient(trap) {
        if (lastActiveTrap !== trap) {
          lastActiveTrap = null;
        }
        lastActiveTrap = trap;
        if (trap) {
          activateTrap();
          deferAction(activateTrap);
        }
      };

      var instances = [];

      var emitChange = function emitChange() {
        handleStateChangeOnClient(reducePropsToState(instances));
      };

      var onTrap = function onTrap(event) {
        if (activateTrap() && event) {
          // prevent scroll jump
          event.stopPropagation();
          event.preventDefault();
        }
      };

      var onBlur = function onBlur() {
        deferAction(activateTrap);
      };

      var onWindowBlur = function onWindowBlur() {
        focusWasOutsideWindow = true;
      };

      var attachHandler = function attachHandler() {
        document.addEventListener('focusin', onTrap, true);
        document.addEventListener('focusout', onBlur);
        window.addEventListener('blur', onWindowBlur);
      };

      var detachHandler = function detachHandler() {
        document.removeEventListener('focusin', onTrap, true);
        document.removeEventListener('focusout', onBlur);
        window.removeEventListener('blur', onWindowBlur);
      };

      exports.default = {
        name: 'Lock',
        props: {
          returnFocus: {
            type: Boolean
          },
          disabled: {
            type: Boolean
          },
          noFocusGuards: {
            type: [Boolean, String],
            default: false
          },
          group: {
            type: String
          }
        },
        data: function data() {
          return {
            data: {},
            hidden: "" //    "width: 1px;height: 0px;padding: 0;overflow: hidden;position: fixed;top: 0;left: 0;"
          };
        },

        computed: {
          groupAttr: function groupAttr() {
            return _defineProperty({}, _focusLock.constants.FOCUS_GROUP, this.group);
          },
          hasLeadingGuards: function hasLeadingGuards() {
            return this.noFocusGuards !== true;
          },
          hasTailingGuards: function hasTailingGuards() {
            return this.hasLeadingGuards && this.noFocusGuards !== 'tail';
          }
        },
        watch: {
          disabled: function disabled() {
            this.data.disabled = this.disabled;
            emitChange();
          }
        },

        methods: {
          onBlur: function onBlur() {
            deferAction(emitChange);
          }
        },

        mounted: function mounted() {
          var _this = this;

          this.data.vue = this;
          this.data.observed = this.$el.querySelector("[data-lock]");

          this.data.disabled = this.disabled;
          this.data.onActivation = function () {
            _this.originalFocusedElement = _this.originalFocusedElement || document && document.activeElement;
          };

          if (!instances.length) {
            attachHandler();
          }
          instances.push(this.data);
          emitChange();
        },
        destroyed: function destroyed() {
          var _this2 = this;

          instances = instances.filter(function (_ref3) {
            var vue = _ref3.vue;
            return vue !== _this2;
          });
          if (!instances.length) {
            detachHandler();
          }
          if (this.returnFocus && this.originalFocusedElement && this.originalFocusedElement.focus) {
            this.originalFocusedElement.focus();
          }
          emitChange();
        }
      };

      /***/
    },
    /* 6 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _Lock = __webpack_require__(4);

      var _Lock2 = _interopRequireDefault(_Lock);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      exports.default = _Lock2.default;

      /***/
    },
    /* 7 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0__utils_all_affected__ = __webpack_require__(2);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(0);

      var focusInFrame = function focusInFrame(frame) {
        return frame === document.activeElement;
      };

      var focusInsideIframe = function focusInsideIframe(topNode) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_all_affected__["a" /* default */])(topNode).reduce(function (result, node) {
          return result || !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["b" /* arrayFind */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* toArray */])(node.querySelectorAll('iframe')), focusInFrame);
        }, false);
      };

      var focusInside = function focusInside(topNode) {
        var activeElement = document && document.activeElement;

        if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
          return false;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_all_affected__["a" /* default */])(topNode).reduce(function (result, node) {
          return result || node.contains(activeElement) || focusInsideIframe(topNode);
        }, false);
      };

      /* harmony default export */__webpack_exports__["a"] = focusInside;

      /***/
    },
    /* 8 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0__utils_array__ = __webpack_require__(0);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(1);

      var focusIsHidden = function focusIsHidden() {
        return document && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_array__["a" /* toArray */])(document.querySelectorAll('[' + __WEBPACK_IMPORTED_MODULE_1__constants__["FOCUS_ALLOW"] + ']')).some(function (node) {
          return node.contains(document.activeElement);
        });
      };

      /* harmony default export */__webpack_exports__["a"] = focusIsHidden;

      /***/
    },
    /* 9 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";

      Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__tabHook__ = __webpack_require__(11);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__focusMerge__ = __webpack_require__(3);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__focusInside__ = __webpack_require__(7);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__focusIsHidden__ = __webpack_require__(8);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__setFocus__ = __webpack_require__(10);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(1);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__utils_all_affected__ = __webpack_require__(2);
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "tabHook", function () {
        return __WEBPACK_IMPORTED_MODULE_0__tabHook__["a"];
      });
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "focusInside", function () {
        return __WEBPACK_IMPORTED_MODULE_2__focusInside__["a"];
      });
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "focusIsHidden", function () {
        return __WEBPACK_IMPORTED_MODULE_3__focusIsHidden__["a"];
      });
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "focusMerge", function () {
        return __WEBPACK_IMPORTED_MODULE_1__focusMerge__["a"];
      });
      /* harmony reexport (module object) */__webpack_require__.d(__webpack_exports__, "constants", function () {
        return __WEBPACK_IMPORTED_MODULE_5__constants__;
      });
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "getAllAffectedNodes", function () {
        return __WEBPACK_IMPORTED_MODULE_6__utils_all_affected__["a"];
      });

      /* harmony default export */__webpack_exports__["default"] = __WEBPACK_IMPORTED_MODULE_4__setFocus__["a" /* default */];

      /***/
    },
    /* 10 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";
      /* unused harmony export focusOn */
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0__focusMerge__ = __webpack_require__(3);

      var focusOn = function focusOn(target) {
        target.focus();
        if (target.contentWindow) {
          target.contentWindow.focus();
        }
      };

      var guardCount = 0;
      var lockDisabled = false;

      /* harmony default export */__webpack_exports__["a"] = function (topNode, lastNode) {
        var focusable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__focusMerge__["a" /* default */])(topNode, lastNode);

        if (lockDisabled) {
          return;
        }

        if (focusable) {
          if (guardCount > 2) {
            if (false) {
              // eslint-disable-next-line no-console
              console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' + 'See https://github.com/theKashey/focus-lock/#focus-fighting');
              lockDisabled = true;
              setTimeout(function () {
                lockDisabled = false;
              }, 1);
            }
            return;
          }
          guardCount++;
          focusOn(focusable.node);
          guardCount--;
        }
      };

      /***/
    },
    /* 11 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";
      /* harmony default export */
      __webpack_exports__["a"] = {
        attach: function attach(node, enabled) {},
        detach: function detach() {}
      };

      /***/
    },
    /* 12 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";
      /* unused harmony export isVisible */
      /* unused harmony export notHiddenInput */
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "a", function () {
        return getCommonParent;
      });
      /* unused harmony export filterFocusable */
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "c", function () {
        return getTabbableNodes;
      });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "d", function () {
        return getAllTabbableNodes;
      });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
        return parentAutofocusables;
      });
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__tabOrder__ = __webpack_require__(14);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__tabUtils__ = __webpack_require__(15);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(0);

      var isElementHidden = function isElementHidden(computedStyle) {
        if (!computedStyle || !computedStyle.getPropertyValue) {
          return false;
        }
        return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
      };

      var isVisible = function isVisible(node) {
        return !node || node === document || !isElementHidden(window.getComputedStyle(node, null)) && isVisible(node.parentNode);
      };

      var notHiddenInput = function notHiddenInput(node) {
        return !((node.tagName === 'INPUT' || node.tagName === 'BUTTON') && (node.type === 'hidden' || node.disabled));
      };

      var getParents = function getParents(node) {
        var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        parents.push(node);
        if (node.parentNode) {
          getParents(node.parentNode, parents);
        }
        return parents;
      };

      var getCommonParent = function getCommonParent(nodea, nodeb) {
        var parentsA = getParents(nodea);
        var parentsB = getParents(nodeb);

        for (var i = 0; i < parentsA.length; i += 1) {
          var currentParent = parentsA[i];
          if (parentsB.indexOf(currentParent) >= 0) {
            return currentParent;
          }
        }
        return false;
      };

      var filterFocusable = function filterFocusable(nodes) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__array__["a" /* toArray */])(nodes).filter(function (node) {
          return isVisible(node);
        }).filter(function (node) {
          return notHiddenInput(node);
        });
      };

      var getTabbableNodes = function getTabbableNodes(topNodes) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tabOrder__["a" /* orderByTabIndex */])(filterFocusable(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tabUtils__["a" /* getFocusables */])(topNodes)), true);
      };

      var getAllTabbableNodes = function getAllTabbableNodes(topNodes) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tabOrder__["a" /* orderByTabIndex */])(filterFocusable(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tabUtils__["a" /* getFocusables */])(topNodes)), false);
      };

      var parentAutofocusables = function parentAutofocusables(topNode) {
        return filterFocusable(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tabUtils__["b" /* getParentAutofocusables */])(topNode));
      };

      /***/
    },
    /* 13 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";

      var isRadio = function isRadio(node) {
        return node.tagName === 'INPUT' && node.type === 'radio';
      };

      var findSelectedRadio = function findSelectedRadio(node, nodes) {
        return nodes.filter(isRadio).filter(function (el) {
          return el.name === node.name;
        }).filter(function (el) {
          return el.checked;
        })[0] || node;
      };

      var pickFirstFocus = function pickFirstFocus(nodes) {
        if (nodes[0] && nodes.length > 1) {
          if (isRadio(nodes[0]) && nodes[0].name) {
            return findSelectedRadio(nodes[0], nodes);
          }
        }
        return nodes[0];
      };

      /* harmony default export */__webpack_exports__["a"] = pickFirstFocus;

      /***/
    },
    /* 14 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";
      /* unused harmony export tabSort */
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "a", function () {
        return orderByTabIndex;
      });
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(0);

      var tabSort = function tabSort(a, b) {
        var tabDiff = a.tabIndex - b.tabIndex;
        var indexDiff = a.index - b.index;

        if (tabDiff) {
          if (!a.tabIndex) return 1;
          if (!b.tabIndex) return -1;
        }

        return tabDiff || indexDiff;
      };

      var orderByTabIndex = function orderByTabIndex(nodes, filterNegative) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* toArray */])(nodes).map(function (node, index) {
          return {
            node: node,
            index: index,
            tabIndex: node.tabIndex
          };
        }).filter(function (data) {
          return !filterNegative || data.tabIndex >= 0;
        }).sort(tabSort);
      };

      /***/
    },
    /* 15 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "a", function () {
        return getFocusables;
      });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
        return getParentAutofocusables;
      });
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__tabbables__ = __webpack_require__(16);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(0);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1);

      var getFocusables = function getFocusables(parents) {
        return parents.reduce(function (acc, parent) {
          return acc.concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__array__["a" /* toArray */])(parent.querySelectorAll(__WEBPACK_IMPORTED_MODULE_0__tabbables__["a" /* default */].join(','))));
        }, []);
      };

      var getParentAutofocusables = function getParentAutofocusables(parent) {
        var parentFocus = parent.querySelectorAll('[' + __WEBPACK_IMPORTED_MODULE_2__constants__["FOCUS_AUTO"] + ']');
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__array__["a" /* toArray */])(parentFocus).map(function (node) {
          return getFocusables([node]);
        }).reduce(function (acc, nodes) {
          return acc.concat(nodes);
        }, []);
      };

      /***/
    },
    /* 16 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";
      /* harmony default export */
      __webpack_exports__["a"] = ['button:enabled:not([readonly])', 'select:enabled:not([readonly])', 'textarea:enabled:not([readonly])', 'input:enabled:not([readonly])', 'a[href]', 'area[href]', 'iframe', 'object', 'embed', '[tabindex]', '[contenteditable]', '[autofocus]'];

      /***/
    },
    /* 17 */
    /***/function (module, exports) {

      // this module is a runtime utility for cleaner component module output and will
      // be included in the final webpack user bundle

      module.exports = function normalizeComponent(rawScriptExports, compiledTemplate, scopeId, cssModules) {
        var esModule;
        var scriptExports = rawScriptExports = rawScriptExports || {};

        // ES6 modules interop
        var type = _typeof(rawScriptExports.default);
        if (type === 'object' || type === 'function') {
          esModule = rawScriptExports;
          scriptExports = rawScriptExports.default;
        }

        // Vue.extend constructor export interop
        var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

        // render functions
        if (compiledTemplate) {
          options.render = compiledTemplate.render;
          options.staticRenderFns = compiledTemplate.staticRenderFns;
        }

        // scopedId
        if (scopeId) {
          options._scopeId = scopeId;
        }

        // inject cssModules
        if (cssModules) {
          var computed = Object.create(options.computed || null);
          Object.keys(cssModules).forEach(function (key) {
            var module = cssModules[key];
            computed[key] = function () {
              return module;
            };
          });
          options.computed = computed;
        }

        return {
          esModule: esModule,
          exports: scriptExports,
          options: options
        };
      };

      /***/
    },
    /* 18 */
    /***/function (module, exports, __webpack_require__) {

      module.exports = { render: function render() {
          var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
          return _c('div', [_vm.hasLeadingGuards ? _c('div', {
            style: _vm.hidden,
            attrs: {
              "tabIndex": _vm.disabled ? -1 : 0,
              "aria-hidden": "true"
            }
          }) : _vm._e(), _vm._v(" "), _vm.hasLeadingGuards ? _c('div', {
            style: _vm.hidden,
            attrs: {
              "tabIndex": _vm.disabled ? -1 : 1,
              "aria-hidden": "true"
            }
          }) : _vm._e(), _vm._v(" "), _c('div', _vm._b({
            attrs: {
              "data-lock": ""
            },
            on: {
              "focusout": _vm.onBlur
            }
          }, 'div', _vm.groupAttr, false), [_vm._t("default")], 2), _vm._v(" "), _vm.hasTailingGuards ? _c('div', {
            style: _vm.hidden,
            attrs: {
              "tabIndex": _vm.disabled ? -1 : 0,
              "aria-hidden": "true"
            }
          }) : _vm._e()]);
        }, staticRenderFns: [] };
      module.exports.render._withStripped = true;
      if (false) {
        module.hot.accept();
        if (module.hot.data) {
          require("vue-hot-reload-api").rerender("data-v-0d4029e0", module.exports);
        }
      }

      /***/
    }]
    /******/)
  );
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module)))

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_customer_form_vue__ = __webpack_require__(426);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e32b627_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_customer_form_vue__ = __webpack_require__(1188);
function injectStyle (ssrContext) {
  __webpack_require__(1171)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_customer_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e32b627_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_customer_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.objectToCsv = objectToCsv;
exports.downloadCsvReport = downloadCsvReport;
function objectToCsv(data) {
    var csvRows = [];

    var headers = Object.keys(data[0]);
    csvRows.push(headers.join(';'));

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop = function _loop() {
            var row = _step.value;

            var values = headers.map(function (header) {
                var escaped = ('' + row[header]).replace(/"/g, '\\"');
                return '"' + escaped + '"';
            });
            csvRows.push(values.join(';'));
        };

        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return csvRows.join('\n');
}

function downloadCsvReport(data) {
    var blob = new Blob([data], { type: 'text/csv' });
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', 'download.csv');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dP = __webpack_require__(22);
var createDesc = __webpack_require__(57);
module.exports = __webpack_require__(21) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(12);
var hide = __webpack_require__(29);
var has = __webpack_require__(35);
var SRC = __webpack_require__(58)('src');
var $toString = __webpack_require__(789);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(40).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var fails = __webpack_require__(14);
var defined = __webpack_require__(47);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function createHTML(string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var bind = __webpack_require__(222);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (_typeof(result[key]) === 'object' && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (_typeof(result[key]) === 'object' && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calcDesconto = calcDesconto;
exports.arr = arr;
// função que efetua validação do CPF
function calcDesconto(v1, p1, p2, p3, p4) {
  var tot = 0;
  tot = v1;

  if (p1.length) {
    for (var x = 0; x < p1.length; x++) {
      if (p1[x] > 0) {
        tot = tot * (100 - p1[x]) / 100;
      }
    }
  } else {
    if (p1 > 0) {
      tot = tot * (100 - p1) / 100;
    }
    if (p2 > 0) {
      tot = tot * (100 - p2) / 100;
    }
    if (p3 > 0) {
      tot = tot * (100 - p3) / 100;
    }
    if (p4 > 0) {
      tot = tot * (100 - p4) / 100;
    }
  }
  return arr(tot, 2);
}

function arr(vlr, decimals, round) {
  var rounded = 0;

  if (round) {
    rounded = vlr.toFixed(decimals);
  } else {
    rounded = vlr.toFixed(decimals);
  }

  return parseFloat(rounded);
}

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_filter_list_vue__ = __webpack_require__(540);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a209a0_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_filter_list_vue__ = __webpack_require__(1509);
function injectStyle (ssrContext) {
  __webpack_require__(1507)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01a209a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_filter_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a209a0_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_filter_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(81);
var defined = __webpack_require__(47);
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pIE = __webpack_require__(82);
var createDesc = __webpack_require__(57);
var toIObject = __webpack_require__(36);
var toPrimitive = __webpack_require__(46);
var has = __webpack_require__(35);
var IE8_DOM_DEFINE = __webpack_require__(184);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(21) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) {/* empty */}
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(35);
var toObject = __webpack_require__(24);
var IE_PROTO = __webpack_require__(132)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// optional / simple context binding
var aFunction = __webpack_require__(25);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__(14);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () {/* empty */}, 1) : method.call(null);
  });
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(15);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(6);
var core = __webpack_require__(40);
var fails = __webpack_require__(14);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () {
    fn(1);
  }), 'Object', exp);
};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(41);
var IObject = __webpack_require__(81);
var toObject = __webpack_require__(24);
var toLength = __webpack_require__(19);
var asc = __webpack_require__(148);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (; length > index; index++) {
      if (NO_HOLES || index in self) {
        val = self[index];
        res = f(val, index, O);
        if (TYPE) {
          if (IS_MAP) result[index] = res; // map
          else if (res) switch (TYPE) {
              case 3:
                return true; // some
              case 5:
                return val; // find
              case 6:
                return index; // findIndex
              case 2:
                result.push(val); // filter
            } else if (IS_EVERY) return false; // every
        }
      }
    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_anexos_form_vue__ = __webpack_require__(496);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a031b22_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_anexos_form_vue__ = __webpack_require__(1385);
function injectStyle (ssrContext) {
  __webpack_require__(1383)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_anexos_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a031b22_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_anexos_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

if (__webpack_require__(21)) {
  var LIBRARY = __webpack_require__(53);
  var global = __webpack_require__(12);
  var fails = __webpack_require__(14);
  var $export = __webpack_require__(6);
  var $typed = __webpack_require__(111);
  var $buffer = __webpack_require__(156);
  var ctx = __webpack_require__(41);
  var anInstance = __webpack_require__(64);
  var propertyDesc = __webpack_require__(57);
  var hide = __webpack_require__(29);
  var redefineAll = __webpack_require__(66);
  var toInteger = __webpack_require__(43);
  var toLength = __webpack_require__(19);
  var toIndex = __webpack_require__(212);
  var toAbsoluteIndex = __webpack_require__(60);
  var toPrimitive = __webpack_require__(46);
  var has = __webpack_require__(35);
  var classof = __webpack_require__(71);
  var isObject = __webpack_require__(15);
  var toObject = __webpack_require__(24);
  var isArrayIter = __webpack_require__(145);
  var create = __webpack_require__(61);
  var getPrototypeOf = __webpack_require__(38);
  var gOPN = __webpack_require__(62).f;
  var getIterFn = __webpack_require__(147);
  var uid = __webpack_require__(58);
  var wks = __webpack_require__(18);
  var createArrayMethod = __webpack_require__(49);
  var createArrayIncludes = __webpack_require__(101);
  var speciesConstructor = __webpack_require__(84);
  var ArrayIterators = __webpack_require__(150);
  var Iterators = __webpack_require__(73);
  var $iterDetect = __webpack_require__(106);
  var setSpecies = __webpack_require__(63);
  var arrayFill = __webpack_require__(149);
  var arrayCopyWithin = __webpack_require__(201);
  var $DP = __webpack_require__(22);
  var $GOPD = __webpack_require__(37);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function toOffset(it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function validate(it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function allocate(C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    }return new C(length);
  };

  var speciesFromList = function speciesFromList(O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function fromList(C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) {
      result[index] = list[index++];
    }return result;
  };

  var addGetter = function addGetter(it, key, internal) {
    dP(it, key, { get: function get() {
        return this._d[internal];
      } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      }O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of() /* ...items */{
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) {
      result[index] = arguments[index++];
    }return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
    arrayToLocaleString.call(new Uint8Array(1));
  });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) {
      // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) {
      // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) {
      // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) {
      // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) {
      // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      }return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin));
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) {
      this[offset + index] = src[index++];
    }
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function isTAIndex(target, key) {
    return isObject(target) && target[TYPED_ARRAY] && (typeof key === 'undefined' ? 'undefined' : _typeof(key)) != 'symbol' && key in target && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, 'value') && !has(desc, 'get') && !has(desc, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !desc.configurable && (!has(desc, 'writable') || desc.writable) && (!has(desc, 'enumerable') || desc.enumerable)) {
      target[key] = desc.value;
      return target;
    }return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () {
    arrayToString.call({});
  })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function constructor() {/* noop */},
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function get() {
      return this[TYPED_ARRAY];
    }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function getter(that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function setter(that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function addElement(that, index) {
      dP(that, index, {
        get: function get() {
          return getter(this, index);
        },
        set: function set(value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) {
          addElement(that, index++);
        }
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function get() {
          return NAME;
        }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () {
      Base.of.call(TypedArray, 1);
    }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () {/* empty */};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Map = __webpack_require__(207);
var $export = __webpack_require__(6);
var shared = __webpack_require__(80)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(210))());

var getOrCreateMetadataMap = function getOrCreateMetadataMap(target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  }return keyMetadata;
};
var ordinaryHasOwnMetadata = function ordinaryHasOwnMetadata(MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function ordinaryGetOwnMetadata(MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function ordinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function ordinaryOwnMetadataKeys(target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) {
    keys.push(key);
  });
  return keys;
};
var toMetaKey = function toMetaKey(it) {
  return it === undefined || (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : String(it);
};
var exp = function exp(O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = false;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var META = __webpack_require__(58)('meta');
var isObject = __webpack_require__(15);
var has = __webpack_require__(35);
var setDesc = __webpack_require__(22).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(14)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function setMeta(it) {
  setDesc(it, META, { value: {
      i: 'O' + ++id, // object ID
      w: {} // weak collections IDs
    } });
};
var fastKey = function fastKey(it, create) {
  // return primitive with prefix
  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
    // return object ID
  }return it[META].i;
};
var getWeak = function getWeak(it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
    // return hash weak collections IDs
  }return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function onFreeze(it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(18)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(29)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
(function (global, factory) {

	"use strict";

	if (( false ? "undefined" : _typeof(module)) === "object" && _typeof(module.exports) === "object") {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ? factory(global, true) : function (w) {
			if (!w.document) {
				throw new Error("jQuery requires a window with a document");
			}
			return factory(w);
		};
	} else {
		factory(global);
	}

	// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : undefined, function (window, noGlobal) {

	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";

	var arr = [];

	var getProto = Object.getPrototypeOf;

	var _slice = arr.slice;

	var flat = arr.flat ? function (array) {
		return arr.flat.call(array);
	} : function (array) {
		return arr.concat.apply([], array);
	};

	var push = arr.push;

	var indexOf = arr.indexOf;

	var class2type = {};

	var toString = class2type.toString;

	var hasOwn = class2type.hasOwnProperty;

	var fnToString = hasOwn.toString;

	var ObjectFunctionString = fnToString.call(Object);

	var support = {};

	var isFunction = function isFunction(obj) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
	};

	var isWindow = function isWindow(obj) {
		return obj != null && obj === obj.window;
	};

	var document = window.document;

	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval(code, node, doc) {
		doc = doc || document;

		var i,
		    val,
		    script = doc.createElement("script");

		script.text = code;
		if (node) {
			for (i in preservedScriptAttributes) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[i] || node.getAttribute && node.getAttribute(i);
				if (val) {
					script.setAttribute(i, val);
				}
			}
		}
		doc.head.appendChild(script).parentNode.removeChild(script);
	}

	function toType(obj) {
		if (obj == null) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module


	var version = "3.7.1",
	    rhtmlSuffix = /HTML$/i,


	// Define a local copy of jQuery
	jQuery = function jQuery(selector, context) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init(selector, context);
	};

	jQuery.fn = jQuery.prototype = {

		// The current version of jQuery being used
		jquery: version,

		constructor: jQuery,

		// The default length of a jQuery object is 0
		length: 0,

		toArray: function toArray() {
			return _slice.call(this);
		},

		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function get(num) {

			// Return all the elements in a clean array
			if (num == null) {
				return _slice.call(this);
			}

			// Return just the one element from the set
			return num < 0 ? this[num + this.length] : this[num];
		},

		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function pushStack(elems) {

			// Build a new jQuery matched element set
			var ret = jQuery.merge(this.constructor(), elems);

			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;

			// Return the newly-formed element set
			return ret;
		},

		// Execute a callback for every element in the matched set.
		each: function each(callback) {
			return jQuery.each(this, callback);
		},

		map: function map(callback) {
			return this.pushStack(jQuery.map(this, function (elem, i) {
				return callback.call(elem, i, elem);
			}));
		},

		slice: function slice() {
			return this.pushStack(_slice.apply(this, arguments));
		},

		first: function first() {
			return this.eq(0);
		},

		last: function last() {
			return this.eq(-1);
		},

		even: function even() {
			return this.pushStack(jQuery.grep(this, function (_elem, i) {
				return (i + 1) % 2;
			}));
		},

		odd: function odd() {
			return this.pushStack(jQuery.grep(this, function (_elem, i) {
				return i % 2;
			}));
		},

		eq: function eq(i) {
			var len = this.length,
			    j = +i + (i < 0 ? len : 0);
			return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
		},

		end: function end() {
			return this.prevObject || this.constructor();
		},

		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};

	jQuery.extend = jQuery.fn.extend = function () {
		var options,
		    name,
		    src,
		    copy,
		    copyIsArray,
		    clone,
		    target = arguments[0] || {},
		    i = 1,
		    length = arguments.length,
		    deep = false;

		// Handle a deep copy situation
		if (typeof target === "boolean") {
			deep = target;

			// Skip the boolean and the target
			target = arguments[i] || {};
			i++;
		}

		// Handle case when target is a string or something (possible in deep copy)
		if ((typeof target === "undefined" ? "undefined" : _typeof(target)) !== "object" && !isFunction(target)) {
			target = {};
		}

		// Extend jQuery itself if only one argument is passed
		if (i === length) {
			target = this;
			i--;
		}

		for (; i < length; i++) {

			// Only deal with non-null/undefined values
			if ((options = arguments[i]) != null) {

				// Extend the base object
				for (name in options) {
					copy = options[name];

					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if (name === "__proto__" || target === copy) {
						continue;
					}

					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
						src = target[name];

						// Ensure proper type for the source value
						if (copyIsArray && !Array.isArray(src)) {
							clone = [];
						} else if (!copyIsArray && !jQuery.isPlainObject(src)) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;

						// Never move original objects, clone them
						target[name] = jQuery.extend(deep, clone, copy);

						// Don't bring in undefined values
					} else if (copy !== undefined) {
						target[name] = copy;
					}
				}
			}
		}

		// Return the modified object
		return target;
	};

	jQuery.extend({

		// Unique for each copy of jQuery on the page
		expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),

		// Assume jQuery is ready without the ready module
		isReady: true,

		error: function error(msg) {
			throw new Error(msg);
		},

		noop: function noop() {},

		isPlainObject: function isPlainObject(obj) {
			var proto, Ctor;

			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if (!obj || toString.call(obj) !== "[object Object]") {
				return false;
			}

			proto = getProto(obj);

			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if (!proto) {
				return true;
			}

			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
			return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
		},

		isEmptyObject: function isEmptyObject(obj) {
			var name;

			for (name in obj) {
				return false;
			}
			return true;
		},

		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function globalEval(code, options, doc) {
			DOMEval(code, { nonce: options && options.nonce }, doc);
		},

		each: function each(obj, callback) {
			var length,
			    i = 0;

			if (isArrayLike(obj)) {
				length = obj.length;
				for (; i < length; i++) {
					if (callback.call(obj[i], i, obj[i]) === false) {
						break;
					}
				}
			} else {
				for (i in obj) {
					if (callback.call(obj[i], i, obj[i]) === false) {
						break;
					}
				}
			}

			return obj;
		},

		// Retrieve the text value of an array of DOM nodes
		text: function text(elem) {
			var node,
			    ret = "",
			    i = 0,
			    nodeType = elem.nodeType;

			if (!nodeType) {

				// If no nodeType, this is expected to be an array
				while (node = elem[i++]) {

					// Do not traverse comment nodes
					ret += jQuery.text(node);
				}
			}
			if (nodeType === 1 || nodeType === 11) {
				return elem.textContent;
			}
			if (nodeType === 9) {
				return elem.documentElement.textContent;
			}
			if (nodeType === 3 || nodeType === 4) {
				return elem.nodeValue;
			}

			// Do not include comment or processing instruction nodes

			return ret;
		},

		// results is for internal usage only
		makeArray: function makeArray(arr, results) {
			var ret = results || [];

			if (arr != null) {
				if (isArrayLike(Object(arr))) {
					jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
				} else {
					push.call(ret, arr);
				}
			}

			return ret;
		},

		inArray: function inArray(elem, arr, i) {
			return arr == null ? -1 : indexOf.call(arr, elem, i);
		},

		isXMLDoc: function isXMLDoc(elem) {
			var namespace = elem && elem.namespaceURI,
			    docElem = elem && (elem.ownerDocument || elem).documentElement;

			// Assume HTML when documentElement doesn't yet exist, such as inside
			// document fragments.
			return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
		},

		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function merge(first, second) {
			var len = +second.length,
			    j = 0,
			    i = first.length;

			for (; j < len; j++) {
				first[i++] = second[j];
			}

			first.length = i;

			return first;
		},

		grep: function grep(elems, callback, invert) {
			var callbackInverse,
			    matches = [],
			    i = 0,
			    length = elems.length,
			    callbackExpect = !invert;

			// Go through the array, only saving the items
			// that pass the validator function
			for (; i < length; i++) {
				callbackInverse = !callback(elems[i], i);
				if (callbackInverse !== callbackExpect) {
					matches.push(elems[i]);
				}
			}

			return matches;
		},

		// arg is for internal usage only
		map: function map(elems, callback, arg) {
			var length,
			    value,
			    i = 0,
			    ret = [];

			// Go through the array, translating each of the items to their new values
			if (isArrayLike(elems)) {
				length = elems.length;
				for (; i < length; i++) {
					value = callback(elems[i], i, arg);

					if (value != null) {
						ret.push(value);
					}
				}

				// Go through every key on the object,
			} else {
				for (i in elems) {
					value = callback(elems[i], i, arg);

					if (value != null) {
						ret.push(value);
					}
				}
			}

			// Flatten any nested arrays
			return flat(ret);
		},

		// A global GUID counter for objects
		guid: 1,

		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	});

	if (typeof Symbol === "function") {
		jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
	}

	// Populate the class2type map
	jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (_i, name) {
		class2type["[object " + name + "]"] = name.toLowerCase();
	});

	function isArrayLike(obj) {

		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
		    type = toType(obj);

		if (isFunction(obj) || isWindow(obj)) {
			return false;
		}

		return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
	}

	function nodeName(elem, name) {

		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	}
	var pop = arr.pop;

	var sort = arr.sort;

	var splice = arr.splice;

	var whitespace = "[\\x20\\t\\r\\n\\f]";

	var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");

	// Note: an element does not contain itself
	jQuery.contains = function (a, b) {
		var bup = b && b.parentNode;

		return a === bup || !!(bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
	};

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

	function fcssescape(ch, asCodePoint) {
		if (asCodePoint) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if (ch === "\0") {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	}

	jQuery.escapeSelector = function (sel) {
		return (sel + "").replace(rcssescape, fcssescape);
	};

	var preferredDoc = document,
	    pushNative = push;

	(function () {

		var i,
		    Expr,
		    outermostContext,
		    sortInput,
		    hasDuplicate,
		    push = pushNative,


		// Local document vars
		document,
		    documentElement,
		    documentIsHTML,
		    rbuggyQSA,
		    matches,


		// Instance-specific data
		expando = jQuery.expando,
		    dirruns = 0,
		    done = 0,
		    classCache = createCache(),
		    tokenCache = createCache(),
		    compilerCache = createCache(),
		    nonnativeSelectorCache = createCache(),
		    sortOrder = function sortOrder(a, b) {
			if (a === b) {
				hasDuplicate = true;
			}
			return 0;
		},
		    booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" + "loop|multiple|open|readonly|required|scoped",


		// Regular expressions

		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",


		// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
		    pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" + ")\\)|)",


		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp(whitespace + "+", "g"),
		    rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
		    rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
		    rdescend = new RegExp(whitespace + "|>"),
		    rpseudo = new RegExp(pseudos),
		    ridentifier = new RegExp("^" + identifier + "$"),
		    matchExpr = {
			ID: new RegExp("^#(" + identifier + ")"),
			CLASS: new RegExp("^\\.(" + identifier + ")"),
			TAG: new RegExp("^(" + identifier + "|[*])"),
			ATTR: new RegExp("^" + attributes),
			PSEUDO: new RegExp("^" + pseudos),
			CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
			bool: new RegExp("^(?:" + booleans + ")$", "i"),

			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
		},
		    rinputs = /^(?:input|select|textarea|button)$/i,
		    rheader = /^h\d$/i,


		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
		    rsibling = /[+~]/,


		// CSS escapes
		// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"),
		    funescape = function funescape(escape, nonHex) {
			var high = "0x" + escape.slice(1) - 0x10000;

			if (nonHex) {

				// Strip the backslash prefix from a non-hex escape sequence
				return nonHex;
			}

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
		},


		// Used for iframes; see `setDocument`.
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE/Edge.
		unloadHandler = function unloadHandler() {
			setDocument();
		},
		    inDisabledFieldset = addCombinator(function (elem) {
			return elem.disabled === true && nodeName(elem, "fieldset");
		}, { dir: "parentNode", next: "legend" });

		// Support: IE <=9 only
		// Accessing document.activeElement can throw unexpectedly
		// https://bugs.jquery.com/ticket/13393
		function safeActiveElement() {
			try {
				return document.activeElement;
			} catch (err) {}
		}

		// Optimize for push.apply( _, NodeList )
		try {
			push.apply(arr = _slice.call(preferredDoc.childNodes), preferredDoc.childNodes);

			// Support: Android <=4.0
			// Detect silently failing push.apply
			// eslint-disable-next-line no-unused-expressions
			arr[preferredDoc.childNodes.length].nodeType;
		} catch (e) {
			push = {
				apply: function apply(target, els) {
					pushNative.apply(target, _slice.call(els));
				},
				call: function call(target) {
					pushNative.apply(target, _slice.call(arguments, 1));
				}
			};
		}

		function find(selector, context, results, seed) {
			var m,
			    i,
			    elem,
			    nid,
			    match,
			    groups,
			    newSelector,
			    newContext = context && context.ownerDocument,


			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;

			results = results || [];

			// Return early from calls with invalid selector or context
			if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {

				return results;
			}

			// Try to shortcut find operations (as opposed to filters) in HTML documents
			if (!seed) {
				setDocument(context);
				context = context || document;

				if (documentIsHTML) {

					// If the selector is sufficiently simple, try using a "get*By*" DOM method
					// (excepting DocumentFragment context, where the methods don't exist)
					if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {

						// ID selector
						if (m = match[1]) {

							// Document context
							if (nodeType === 9) {
								if (elem = context.getElementById(m)) {

									// Support: IE 9 only
									// getElementById can match elements by name instead of ID
									if (elem.id === m) {
										push.call(results, elem);
										return results;
									}
								} else {
									return results;
								}

								// Element context
							} else {

								// Support: IE 9 only
								// getElementById can match elements by name instead of ID
								if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {

									push.call(results, elem);
									return results;
								}
							}

							// Type selector
						} else if (match[2]) {
							push.apply(results, context.getElementsByTagName(selector));
							return results;

							// Class selector
						} else if ((m = match[3]) && context.getElementsByClassName) {
							push.apply(results, context.getElementsByClassName(m));
							return results;
						}
					}

					// Take advantage of querySelectorAll
					if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {

						newSelector = selector;
						newContext = context;

						// qSA considers elements outside a scoping root when evaluating child or
						// descendant combinators, which is not what we want.
						// In such cases, we work around the behavior by prefixing every selector in the
						// list with an ID selector referencing the scope context.
						// The technique has to be used as well when a leading combinator is used
						// as such selectors are not recognized by querySelectorAll.
						// Thanks to Andrew Dupont for this technique.
						if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {

							// Expand context for sibling selectors
							newContext = rsibling.test(selector) && testContext(context.parentNode) || context;

							// We can use :scope instead of the ID hack if the browser
							// supports it & if we're not changing the context.
							// Support: IE 11+, Edge 17 - 18+
							// IE/Edge sometimes throw a "Permission denied" error when
							// strict-comparing two documents; shallow comparisons work.
							// eslint-disable-next-line eqeqeq
							if (newContext != context || !support.scope) {

								// Capture the context ID, setting it first if necessary
								if (nid = context.getAttribute("id")) {
									nid = jQuery.escapeSelector(nid);
								} else {
									context.setAttribute("id", nid = expando);
								}
							}

							// Prefix every selector in the list
							groups = tokenize(selector);
							i = groups.length;
							while (i--) {
								groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
							}
							newSelector = groups.join(",");
						}

						try {
							push.apply(results, newContext.querySelectorAll(newSelector));
							return results;
						} catch (qsaError) {
							nonnativeSelectorCache(selector, true);
						} finally {
							if (nid === expando) {
								context.removeAttribute("id");
							}
						}
					}
				}
			}

			// All others
			return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
		}

		/**
   * Create key-value caches of limited size
   * @returns {function(string, object)} Returns the Object data after storing it on itself with
   *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
   *	deleting the oldest entry
   */
		function createCache() {
			var keys = [];

			function cache(key, value) {

				// Use (key + " ") to avoid collision with native prototype properties
				// (see https://github.com/jquery/sizzle/issues/157)
				if (keys.push(key + " ") > Expr.cacheLength) {

					// Only keep the most recent entries
					delete cache[keys.shift()];
				}
				return cache[key + " "] = value;
			}
			return cache;
		}

		/**
   * Mark a function for special use by jQuery selector module
   * @param {Function} fn The function to mark
   */
		function markFunction(fn) {
			fn[expando] = true;
			return fn;
		}

		/**
   * Support testing using an element
   * @param {Function} fn Passed the created element and returns a boolean result
   */
		function assert(fn) {
			var el = document.createElement("fieldset");

			try {
				return !!fn(el);
			} catch (e) {
				return false;
			} finally {

				// Remove from its parent by default
				if (el.parentNode) {
					el.parentNode.removeChild(el);
				}

				// release memory in IE
				el = null;
			}
		}

		/**
   * Returns a function to use in pseudos for input types
   * @param {String} type
   */
		function createInputPseudo(type) {
			return function (elem) {
				return nodeName(elem, "input") && elem.type === type;
			};
		}

		/**
   * Returns a function to use in pseudos for buttons
   * @param {String} type
   */
		function createButtonPseudo(type) {
			return function (elem) {
				return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
			};
		}

		/**
   * Returns a function to use in pseudos for :enabled/:disabled
   * @param {Boolean} disabled true for :disabled; false for :enabled
   */
		function createDisabledPseudo(disabled) {

			// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
			return function (elem) {

				// Only certain elements can match :enabled or :disabled
				// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
				// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
				if ("form" in elem) {

					// Check for inherited disabledness on relevant non-disabled elements:
					// * listed form-associated elements in a disabled fieldset
					//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
					//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
					// * option elements in a disabled optgroup
					//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
					// All such elements have a "form" property.
					if (elem.parentNode && elem.disabled === false) {

						// Option elements defer to a parent optgroup if present
						if ("label" in elem) {
							if ("label" in elem.parentNode) {
								return elem.parentNode.disabled === disabled;
							} else {
								return elem.disabled === disabled;
							}
						}

						// Support: IE 6 - 11+
						// Use the isDisabled shortcut property to check for disabled fieldset ancestors
						return elem.isDisabled === disabled ||

						// Where there is no isDisabled, check manually
						elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
					}

					return elem.disabled === disabled;

					// Try to winnow out elements that can't be disabled before trusting the disabled property.
					// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
					// even exist on them, let alone have a boolean value.
				} else if ("label" in elem) {
					return elem.disabled === disabled;
				}

				// Remaining elements are neither :enabled nor :disabled
				return false;
			};
		}

		/**
   * Returns a function to use in pseudos for positionals
   * @param {Function} fn
   */
		function createPositionalPseudo(fn) {
			return markFunction(function (argument) {
				argument = +argument;
				return markFunction(function (seed, matches) {
					var j,
					    matchIndexes = fn([], seed.length, argument),
					    i = matchIndexes.length;

					// Match elements found at the specified indexes
					while (i--) {
						if (seed[j = matchIndexes[i]]) {
							seed[j] = !(matches[j] = seed[j]);
						}
					}
				});
			});
		}

		/**
   * Checks a node for validity as a jQuery selector context
   * @param {Element|Object=} context
   * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
   */
		function testContext(context) {
			return context && typeof context.getElementsByTagName !== "undefined" && context;
		}

		/**
   * Sets document-related variables once based on the current document
   * @param {Element|Object} [node] An element or document object to use to set the document
   * @returns {Object} Returns the current document
   */
		function setDocument(node) {
			var subWindow,
			    doc = node ? node.ownerDocument || node : preferredDoc;

			// Return early if doc is invalid or already selected
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if (doc == document || doc.nodeType !== 9 || !doc.documentElement) {
				return document;
			}

			// Update global variables
			document = doc;
			documentElement = document.documentElement;
			documentIsHTML = !jQuery.isXMLDoc(document);

			// Support: iOS 7 only, IE 9 - 11+
			// Older browsers didn't support unprefixed `matches`.
			matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;

			// Support: IE 9 - 11+, Edge 12 - 18+
			// Accessing iframe documents after unload throws "permission denied" errors
			// (see trac-13936).
			// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
			// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
			if (documentElement.msMatchesSelector &&

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {

				// Support: IE 9 - 11+, Edge 12 - 18+
				subWindow.addEventListener("unload", unloadHandler);
			}

			// Support: IE <10
			// Check if getElementById returns elements by name
			// The broken getElementById methods don't pick up programmatically-set names,
			// so use a roundabout getElementsByName test
			support.getById = assert(function (el) {
				documentElement.appendChild(el).id = jQuery.expando;
				return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
			});

			// Support: IE 9 only
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node.
			support.disconnectedMatch = assert(function (el) {
				return matches.call(el, "*");
			});

			// Support: IE 9 - 11+, Edge 12 - 18+
			// IE/Edge don't support the :scope pseudo-class.
			support.scope = assert(function () {
				return document.querySelectorAll(":scope");
			});

			// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
			// Make sure the `:has()` argument is parsed unforgivingly.
			// We include `*` in the test to detect buggy implementations that are
			// _selectively_ forgiving (specifically when the list includes at least
			// one valid selector).
			// Note that we treat complete lack of support for `:has()` as if it were
			// spec-compliant support, which is fine because use of `:has()` in such
			// environments will fail in the qSA path and fall back to jQuery traversal
			// anyway.
			support.cssHas = assert(function () {
				try {
					document.querySelector(":has(*,:jqfake)");
					return false;
				} catch (e) {
					return true;
				}
			});

			// ID filter and find
			if (support.getById) {
				Expr.filter.ID = function (id) {
					var attrId = id.replace(runescape, funescape);
					return function (elem) {
						return elem.getAttribute("id") === attrId;
					};
				};
				Expr.find.ID = function (id, context) {
					if (typeof context.getElementById !== "undefined" && documentIsHTML) {
						var elem = context.getElementById(id);
						return elem ? [elem] : [];
					}
				};
			} else {
				Expr.filter.ID = function (id) {
					var attrId = id.replace(runescape, funescape);
					return function (elem) {
						var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
						return node && node.value === attrId;
					};
				};

				// Support: IE 6 - 7 only
				// getElementById is not reliable as a find shortcut
				Expr.find.ID = function (id, context) {
					if (typeof context.getElementById !== "undefined" && documentIsHTML) {
						var node,
						    i,
						    elems,
						    elem = context.getElementById(id);

						if (elem) {

							// Verify the id attribute
							node = elem.getAttributeNode("id");
							if (node && node.value === id) {
								return [elem];
							}

							// Fall back on getElementsByName
							elems = context.getElementsByName(id);
							i = 0;
							while (elem = elems[i++]) {
								node = elem.getAttributeNode("id");
								if (node && node.value === id) {
									return [elem];
								}
							}
						}

						return [];
					}
				};
			}

			// Tag
			Expr.find.TAG = function (tag, context) {
				if (typeof context.getElementsByTagName !== "undefined") {
					return context.getElementsByTagName(tag);

					// DocumentFragment nodes don't have gEBTN
				} else {
					return context.querySelectorAll(tag);
				}
			};

			// Class
			Expr.find.CLASS = function (className, context) {
				if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
					return context.getElementsByClassName(className);
				}
			};

			/* QSA/matchesSelector
   ---------------------------------------------------------------------- */

			// QSA and matchesSelector support

			rbuggyQSA = [];

			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function (el) {

				var input;

				documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";

				// Support: iOS <=7 - 8 only
				// Boolean attributes and "value" are not treated correctly in some XML documents
				if (!el.querySelectorAll("[selected]").length) {
					rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
				}

				// Support: iOS <=7 - 8 only
				if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
					rbuggyQSA.push("~=");
				}

				// Support: iOS 8 only
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if (!el.querySelectorAll("a#" + expando + "+*").length) {
					rbuggyQSA.push(".#.+[+~]");
				}

				// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
				// In some of the document kinds, these selectors wouldn't work natively.
				// This is probably OK but for backwards compatibility we want to maintain
				// handling them through jQuery traversal in jQuery 3.x.
				if (!el.querySelectorAll(":checked").length) {
					rbuggyQSA.push(":checked");
				}

				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				input = document.createElement("input");
				input.setAttribute("type", "hidden");
				el.appendChild(input).setAttribute("name", "D");

				// Support: IE 9 - 11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
				// In some of the document kinds, these selectors wouldn't work natively.
				// This is probably OK but for backwards compatibility we want to maintain
				// handling them through jQuery traversal in jQuery 3.x.
				documentElement.appendChild(el).disabled = true;
				if (el.querySelectorAll(":disabled").length !== 2) {
					rbuggyQSA.push(":enabled", ":disabled");
				}

				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement("input");
				input.setAttribute("name", "");
				el.appendChild(input);
				if (!el.querySelectorAll("[name='']").length) {
					rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
				}
			});

			if (!support.cssHas) {

				// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
				// Our regular `try-catch` mechanism fails to detect natively-unsupported
				// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
				// in browsers that parse the `:has()` argument as a forgiving selector list.
				// https://drafts.csswg.org/selectors/#relational now requires the argument
				// to be parsed unforgivingly, but browsers have not yet fully adjusted.
				rbuggyQSA.push(":has");
			}

			rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));

			/* Sorting
   ---------------------------------------------------------------------- */

			// Document order sorting
			sortOrder = function sortOrder(a, b) {

				// Flag for duplicate removal
				if (a === b) {
					hasDuplicate = true;
					return 0;
				}

				// Sort on method existence if only one input has compareDocumentPosition
				var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
				if (compare) {
					return compare;
				}

				// Calculate position if both inputs belong to the same document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) :

				// Otherwise we know they are disconnected
				1;

				// Disconnected nodes
				if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {

					// Choose the first element that is related to our preferred document
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) {
						return -1;
					}

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) {
						return 1;
					}

					// Maintain original order
					return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
				}

				return compare & 4 ? -1 : 1;
			};

			return document;
		}

		find.matches = function (expr, elements) {
			return find(expr, null, null, elements);
		};

		find.matchesSelector = function (elem, expr) {
			setDocument(elem);

			if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) {

				try {
					var ret = matches.call(elem, expr);

					// IE 9's matchesSelector returns false on disconnected nodes
					if (ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11) {
						return ret;
					}
				} catch (e) {
					nonnativeSelectorCache(expr, true);
				}
			}

			return find(expr, document, null, [elem]).length > 0;
		};

		find.contains = function (context, elem) {

			// Set document vars if needed
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ((context.ownerDocument || context) != document) {
				setDocument(context);
			}
			return jQuery.contains(context, elem);
		};

		find.attr = function (elem, name) {

			// Set document vars if needed
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ((elem.ownerDocument || elem) != document) {
				setDocument(elem);
			}

			var fn = Expr.attrHandle[name.toLowerCase()],


			// Don't get fooled by Object.prototype properties (see trac-13807)
			val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;

			if (val !== undefined) {
				return val;
			}

			return elem.getAttribute(name);
		};

		find.error = function (msg) {
			throw new Error("Syntax error, unrecognized expression: " + msg);
		};

		/**
   * Document sorting and removing duplicates
   * @param {ArrayLike} results
   */
		jQuery.uniqueSort = function (results) {
			var elem,
			    duplicates = [],
			    j = 0,
			    i = 0;

			// Unless we *know* we can detect duplicates, assume their presence
			//
			// Support: Android <=4.0+
			// Testing for detecting duplicates is unpredictable so instead assume we can't
			// depend on duplicate detection in all browsers without a stable sort.
			hasDuplicate = !support.sortStable;
			sortInput = !support.sortStable && _slice.call(results, 0);
			sort.call(results, sortOrder);

			if (hasDuplicate) {
				while (elem = results[i++]) {
					if (elem === results[i]) {
						j = duplicates.push(i);
					}
				}
				while (j--) {
					splice.call(results, duplicates[j], 1);
				}
			}

			// Clear input after sorting to release objects
			// See https://github.com/jquery/sizzle/pull/225
			sortInput = null;

			return results;
		};

		jQuery.fn.uniqueSort = function () {
			return this.pushStack(jQuery.uniqueSort(_slice.apply(this)));
		};

		Expr = jQuery.expr = {

			// Can be adjusted by the user
			cacheLength: 50,

			createPseudo: markFunction,

			match: matchExpr,

			attrHandle: {},

			find: {},

			relative: {
				">": { dir: "parentNode", first: true },
				" ": { dir: "parentNode" },
				"+": { dir: "previousSibling", first: true },
				"~": { dir: "previousSibling" }
			},

			preFilter: {
				ATTR: function ATTR(match) {
					match[1] = match[1].replace(runescape, funescape);

					// Move the given value to match[3] whether quoted or unquoted
					match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);

					if (match[2] === "~=") {
						match[3] = " " + match[3] + " ";
					}

					return match.slice(0, 4);
				},

				CHILD: function CHILD(match) {

					/* matches from matchExpr["CHILD"]
     	1 type (only|nth|...)
     	2 what (child|of-type)
     	3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
     	4 xn-component of xn+y argument ([+-]?\d*n|)
     	5 sign of xn-component
     	6 x of xn-component
     	7 sign of y-component
     	8 y of y-component
     */
					match[1] = match[1].toLowerCase();

					if (match[1].slice(0, 3) === "nth") {

						// nth-* requires argument
						if (!match[3]) {
							find.error(match[0]);
						}

						// numeric x and y parameters for Expr.filter.CHILD
						// remember that false/true cast respectively to 0/1
						match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
						match[5] = +(match[7] + match[8] || match[3] === "odd");

						// other types prohibit arguments
					} else if (match[3]) {
						find.error(match[0]);
					}

					return match;
				},

				PSEUDO: function PSEUDO(match) {
					var excess,
					    unquoted = !match[6] && match[2];

					if (matchExpr.CHILD.test(match[0])) {
						return null;
					}

					// Accept quoted arguments as-is
					if (match[3]) {
						match[2] = match[4] || match[5] || "";

						// Strip excess characters from unquoted arguments
					} else if (unquoted && rpseudo.test(unquoted) && (

					// Get excess from tokenize (recursively)
					excess = tokenize(unquoted, true)) && (

					// advance to the next closing parenthesis
					excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {

						// excess is a negative index
						match[0] = match[0].slice(0, excess);
						match[2] = unquoted.slice(0, excess);
					}

					// Return only captures needed by the pseudo filter method (type and argument)
					return match.slice(0, 3);
				}
			},

			filter: {

				TAG: function TAG(nodeNameSelector) {
					var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
					return nodeNameSelector === "*" ? function () {
						return true;
					} : function (elem) {
						return nodeName(elem, expectedNodeName);
					};
				},

				CLASS: function CLASS(className) {
					var pattern = classCache[className + " "];

					return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function (elem) {
						return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
					});
				},

				ATTR: function ATTR(name, operator, check) {
					return function (elem) {
						var result = find.attr(elem, name);

						if (result == null) {
							return operator === "!=";
						}
						if (!operator) {
							return true;
						}

						result += "";

						if (operator === "=") {
							return result === check;
						}
						if (operator === "!=") {
							return result !== check;
						}
						if (operator === "^=") {
							return check && result.indexOf(check) === 0;
						}
						if (operator === "*=") {
							return check && result.indexOf(check) > -1;
						}
						if (operator === "$=") {
							return check && result.slice(-check.length) === check;
						}
						if (operator === "~=") {
							return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
						}
						if (operator === "|=") {
							return result === check || result.slice(0, check.length + 1) === check + "-";
						}

						return false;
					};
				},

				CHILD: function CHILD(type, what, _argument, first, last) {
					var simple = type.slice(0, 3) !== "nth",
					    forward = type.slice(-4) !== "last",
					    ofType = what === "of-type";

					return first === 1 && last === 0 ?

					// Shortcut for :nth-*(n)
					function (elem) {
						return !!elem.parentNode;
					} : function (elem, _context, xml) {
						var cache,
						    outerCache,
						    node,
						    nodeIndex,
						    start,
						    dir = simple !== forward ? "nextSibling" : "previousSibling",
						    parent = elem.parentNode,
						    name = ofType && elem.nodeName.toLowerCase(),
						    useCache = !xml && !ofType,
						    diff = false;

						if (parent) {

							// :(first|last|only)-(child|of-type)
							if (simple) {
								while (dir) {
									node = elem;
									while (node = node[dir]) {
										if (ofType ? nodeName(node, name) : node.nodeType === 1) {

											return false;
										}
									}

									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}

							start = [forward ? parent.firstChild : parent.lastChild];

							// non-xml :nth-child(...) stores cache data on `parent`
							if (forward && useCache) {

								// Seek `elem` from a previously-cached index
								outerCache = parent[expando] || (parent[expando] = {});
								cache = outerCache[type] || [];
								nodeIndex = cache[0] === dirruns && cache[1];
								diff = nodeIndex && cache[2];
								node = nodeIndex && parent.childNodes[nodeIndex];

								while (node = ++nodeIndex && node && node[dir] || (

								// Fallback to seeking `elem` from the start
								diff = nodeIndex = 0) || start.pop()) {

									// When found, cache indexes on `parent` and break
									if (node.nodeType === 1 && ++diff && node === elem) {
										outerCache[type] = [dirruns, nodeIndex, diff];
										break;
									}
								}
							} else {

								// Use previously-cached element index if available
								if (useCache) {
									outerCache = elem[expando] || (elem[expando] = {});
									cache = outerCache[type] || [];
									nodeIndex = cache[0] === dirruns && cache[1];
									diff = nodeIndex;
								}

								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if (diff === false) {

									// Use the same loop as above to seek `elem` from the start
									while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {

										if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {

											// Cache the index of each encountered element
											if (useCache) {
												outerCache = node[expando] || (node[expando] = {});
												outerCache[type] = [dirruns, diff];
											}

											if (node === elem) {
												break;
											}
										}
									}
								}
							}

							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || diff % first === 0 && diff / first >= 0;
						}
					};
				},

				PSEUDO: function PSEUDO(pseudo, argument) {

					// pseudo-class names are case-insensitive
					// https://www.w3.org/TR/selectors/#pseudo-classes
					// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
					// Remember that setFilters inherits from pseudos
					var args,
					    fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);

					// The user may use createPseudo to indicate that
					// arguments are needed to create the filter function
					// just as jQuery does
					if (fn[expando]) {
						return fn(argument);
					}

					// But maintain support for old signatures
					if (fn.length > 1) {
						args = [pseudo, pseudo, "", argument];
						return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
							var idx,
							    matched = fn(seed, argument),
							    i = matched.length;
							while (i--) {
								idx = indexOf.call(seed, matched[i]);
								seed[idx] = !(matches[idx] = matched[i]);
							}
						}) : function (elem) {
							return fn(elem, 0, args);
						};
					}

					return fn;
				}
			},

			pseudos: {

				// Potentially complex pseudos
				not: markFunction(function (selector) {

					// Trim the selector passed to compile
					// to avoid treating leading and trailing
					// spaces as combinators
					var input = [],
					    results = [],
					    matcher = compile(selector.replace(rtrimCSS, "$1"));

					return matcher[expando] ? markFunction(function (seed, matches, _context, xml) {
						var elem,
						    unmatched = matcher(seed, null, xml, []),
						    i = seed.length;

						// Match elements unmatched by `matcher`
						while (i--) {
							if (elem = unmatched[i]) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) : function (elem, _context, xml) {
						input[0] = elem;
						matcher(input, null, xml, results);

						// Don't keep the element
						// (see https://github.com/jquery/sizzle/issues/299)
						input[0] = null;
						return !results.pop();
					};
				}),

				has: markFunction(function (selector) {
					return function (elem) {
						return find(selector, elem).length > 0;
					};
				}),

				contains: markFunction(function (text) {
					text = text.replace(runescape, funescape);
					return function (elem) {
						return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
					};
				}),

				// "Whether an element is represented by a :lang() selector
				// is based solely on the element's language value
				// being equal to the identifier C,
				// or beginning with the identifier C immediately followed by "-".
				// The matching of C against the element's language value is performed case-insensitively.
				// The identifier C does not have to be a valid language name."
				// https://www.w3.org/TR/selectors/#lang-pseudo
				lang: markFunction(function (lang) {

					// lang value must be a valid identifier
					if (!ridentifier.test(lang || "")) {
						find.error("unsupported lang: " + lang);
					}
					lang = lang.replace(runescape, funescape).toLowerCase();
					return function (elem) {
						var elemLang;
						do {
							if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {

								elemLang = elemLang.toLowerCase();
								return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
							}
						} while ((elem = elem.parentNode) && elem.nodeType === 1);
						return false;
					};
				}),

				// Miscellaneous
				target: function target(elem) {
					var hash = window.location && window.location.hash;
					return hash && hash.slice(1) === elem.id;
				},

				root: function root(elem) {
					return elem === documentElement;
				},

				focus: function focus(elem) {
					return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
				},

				// Boolean properties
				enabled: createDisabledPseudo(false),
				disabled: createDisabledPseudo(true),

				checked: function checked(elem) {

					// In CSS3, :checked should return both checked and selected elements
					// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
					return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
				},

				selected: function selected(elem) {

					// Support: IE <=11+
					// Accessing the selectedIndex property
					// forces the browser to treat the default option as
					// selected when in an optgroup.
					if (elem.parentNode) {
						// eslint-disable-next-line no-unused-expressions
						elem.parentNode.selectedIndex;
					}

					return elem.selected === true;
				},

				// Contents
				empty: function empty(elem) {

					// https://www.w3.org/TR/selectors/#empty-pseudo
					// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
					//   but not by others (comment: 8; processing instruction: 7; etc.)
					// nodeType < 6 works because attributes (2) do not appear as children
					for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
						if (elem.nodeType < 6) {
							return false;
						}
					}
					return true;
				},

				parent: function parent(elem) {
					return !Expr.pseudos.empty(elem);
				},

				// Element/input types
				header: function header(elem) {
					return rheader.test(elem.nodeName);
				},

				input: function input(elem) {
					return rinputs.test(elem.nodeName);
				},

				button: function button(elem) {
					return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
				},

				text: function text(elem) {
					var attr;
					return nodeName(elem, "input") && elem.type === "text" && (

					// Support: IE <10 only
					// New HTML5 attribute values (e.g., "search") appear
					// with elem.type === "text"
					(attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
				},

				// Position-in-collection
				first: createPositionalPseudo(function () {
					return [0];
				}),

				last: createPositionalPseudo(function (_matchIndexes, length) {
					return [length - 1];
				}),

				eq: createPositionalPseudo(function (_matchIndexes, length, argument) {
					return [argument < 0 ? argument + length : argument];
				}),

				even: createPositionalPseudo(function (matchIndexes, length) {
					var i = 0;
					for (; i < length; i += 2) {
						matchIndexes.push(i);
					}
					return matchIndexes;
				}),

				odd: createPositionalPseudo(function (matchIndexes, length) {
					var i = 1;
					for (; i < length; i += 2) {
						matchIndexes.push(i);
					}
					return matchIndexes;
				}),

				lt: createPositionalPseudo(function (matchIndexes, length, argument) {
					var i;

					if (argument < 0) {
						i = argument + length;
					} else if (argument > length) {
						i = length;
					} else {
						i = argument;
					}

					for (; --i >= 0;) {
						matchIndexes.push(i);
					}
					return matchIndexes;
				}),

				gt: createPositionalPseudo(function (matchIndexes, length, argument) {
					var i = argument < 0 ? argument + length : argument;
					for (; ++i < length;) {
						matchIndexes.push(i);
					}
					return matchIndexes;
				})
			}
		};

		Expr.pseudos.nth = Expr.pseudos.eq;

		// Add button/input type pseudos
		for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
			Expr.pseudos[i] = createInputPseudo(i);
		}
		for (i in { submit: true, reset: true }) {
			Expr.pseudos[i] = createButtonPseudo(i);
		}

		// Easy API for creating new setFilters
		function setFilters() {}
		setFilters.prototype = Expr.filters = Expr.pseudos;
		Expr.setFilters = new setFilters();

		function tokenize(selector, parseOnly) {
			var matched,
			    match,
			    tokens,
			    type,
			    soFar,
			    groups,
			    preFilters,
			    cached = tokenCache[selector + " "];

			if (cached) {
				return parseOnly ? 0 : cached.slice(0);
			}

			soFar = selector;
			groups = [];
			preFilters = Expr.preFilter;

			while (soFar) {

				// Comma and first run
				if (!matched || (match = rcomma.exec(soFar))) {
					if (match) {

						// Don't consume trailing commas as valid
						soFar = soFar.slice(match[0].length) || soFar;
					}
					groups.push(tokens = []);
				}

				matched = false;

				// Combinators
				if (match = rleadingCombinator.exec(soFar)) {
					matched = match.shift();
					tokens.push({
						value: matched,

						// Cast descendant combinators to space
						type: match[0].replace(rtrimCSS, " ")
					});
					soFar = soFar.slice(matched.length);
				}

				// Filters
				for (type in Expr.filter) {
					if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
						matched = match.shift();
						tokens.push({
							value: matched,
							type: type,
							matches: match
						});
						soFar = soFar.slice(matched.length);
					}
				}

				if (!matched) {
					break;
				}
			}

			// Return the length of the invalid excess
			// if we're just parsing
			// Otherwise, throw an error or return tokens
			if (parseOnly) {
				return soFar.length;
			}

			return soFar ? find.error(selector) :

			// Cache the tokens
			tokenCache(selector, groups).slice(0);
		}

		function toSelector(tokens) {
			var i = 0,
			    len = tokens.length,
			    selector = "";
			for (; i < len; i++) {
				selector += tokens[i].value;
			}
			return selector;
		}

		function addCombinator(matcher, combinator, base) {
			var dir = combinator.dir,
			    skip = combinator.next,
			    key = skip || dir,
			    checkNonElements = base && key === "parentNode",
			    doneName = done++;

			return combinator.first ?

			// Check against closest ancestor/preceding element
			function (elem, context, xml) {
				while (elem = elem[dir]) {
					if (elem.nodeType === 1 || checkNonElements) {
						return matcher(elem, context, xml);
					}
				}
				return false;
			} :

			// Check against all ancestor/preceding elements
			function (elem, context, xml) {
				var oldCache,
				    outerCache,
				    newCache = [dirruns, doneName];

				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if (xml) {
					while (elem = elem[dir]) {
						if (elem.nodeType === 1 || checkNonElements) {
							if (matcher(elem, context, xml)) {
								return true;
							}
						}
					}
				} else {
					while (elem = elem[dir]) {
						if (elem.nodeType === 1 || checkNonElements) {
							outerCache = elem[expando] || (elem[expando] = {});

							if (skip && nodeName(elem, skip)) {
								elem = elem[dir] || elem;
							} else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {

								// Assign to newCache so results back-propagate to previous elements
								return newCache[2] = oldCache[2];
							} else {

								// Reuse newcache so results back-propagate to previous elements
								outerCache[key] = newCache;

								// A match means we're done; a fail means we have to keep checking
								if (newCache[2] = matcher(elem, context, xml)) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
		}

		function elementMatcher(matchers) {
			return matchers.length > 1 ? function (elem, context, xml) {
				var i = matchers.length;
				while (i--) {
					if (!matchers[i](elem, context, xml)) {
						return false;
					}
				}
				return true;
			} : matchers[0];
		}

		function multipleContexts(selector, contexts, results) {
			var i = 0,
			    len = contexts.length;
			for (; i < len; i++) {
				find(selector, contexts[i], results);
			}
			return results;
		}

		function condense(unmatched, map, filter, context, xml) {
			var elem,
			    newUnmatched = [],
			    i = 0,
			    len = unmatched.length,
			    mapped = map != null;

			for (; i < len; i++) {
				if (elem = unmatched[i]) {
					if (!filter || filter(elem, context, xml)) {
						newUnmatched.push(elem);
						if (mapped) {
							map.push(i);
						}
					}
				}
			}

			return newUnmatched;
		}

		function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
			if (postFilter && !postFilter[expando]) {
				postFilter = setMatcher(postFilter);
			}
			if (postFinder && !postFinder[expando]) {
				postFinder = setMatcher(postFinder, postSelector);
			}
			return markFunction(function (seed, results, context, xml) {
				var temp,
				    i,
				    elem,
				    matcherOut,
				    preMap = [],
				    postMap = [],
				    preexisting = results.length,


				// Get initial elements from seed or context
				elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),


				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;

				if (matcher) {

					// If we have a postFinder, or filtered seed, or non-seed postFilter
					// or preexisting results,
					matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results;

					// Find primary matches
					matcher(matcherIn, matcherOut, context, xml);
				} else {
					matcherOut = matcherIn;
				}

				// Apply postFilter
				if (postFilter) {
					temp = condense(matcherOut, postMap);
					postFilter(temp, [], context, xml);

					// Un-match failing elements by moving them back to matcherIn
					i = temp.length;
					while (i--) {
						if (elem = temp[i]) {
							matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
						}
					}
				}

				if (seed) {
					if (postFinder || preFilter) {
						if (postFinder) {

							// Get the final matcherOut by condensing this intermediate into postFinder contexts
							temp = [];
							i = matcherOut.length;
							while (i--) {
								if (elem = matcherOut[i]) {

									// Restore matcherIn since elem is not yet a final match
									temp.push(matcherIn[i] = elem);
								}
							}
							postFinder(null, matcherOut = [], temp, xml);
						}

						// Move matched elements from seed to results to keep them synchronized
						i = matcherOut.length;
						while (i--) {
							if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) {

								seed[temp] = !(results[temp] = elem);
							}
						}
					}

					// Add elements to results, through postFinder if defined
				} else {
					matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
					if (postFinder) {
						postFinder(null, results, matcherOut, xml);
					} else {
						push.apply(results, matcherOut);
					}
				}
			});
		}

		function matcherFromTokens(tokens) {
			var checkContext,
			    matcher,
			    j,
			    len = tokens.length,
			    leadingRelative = Expr.relative[tokens[0].type],
			    implicitRelative = leadingRelative || Expr.relative[" "],
			    i = leadingRelative ? 1 : 0,


			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator(function (elem) {
				return elem === checkContext;
			}, implicitRelative, true),
			    matchAnyContext = addCombinator(function (elem) {
				return indexOf.call(checkContext, elem) > -1;
			}, implicitRelative, true),
			    matchers = [function (elem, context, xml) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));

				// Avoid hanging onto element
				// (see https://github.com/jquery/sizzle/issues/299)
				checkContext = null;
				return ret;
			}];

			for (; i < len; i++) {
				if (matcher = Expr.relative[tokens[i].type]) {
					matchers = [addCombinator(elementMatcher(matchers), matcher)];
				} else {
					matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);

					// Return special upon seeing a positional matcher
					if (matcher[expando]) {

						// Find the next relative operator (if any) for proper handling
						j = ++i;
						for (; j < len; j++) {
							if (Expr.relative[tokens[j].type]) {
								break;
							}
						}
						return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === " " ? "*" : "" })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
					}
					matchers.push(matcher);
				}
			}

			return elementMatcher(matchers);
		}

		function matcherFromGroupMatchers(elementMatchers, setMatchers) {
			var bySet = setMatchers.length > 0,
			    byElement = elementMatchers.length > 0,
			    superMatcher = function superMatcher(seed, context, xml, results, outermost) {
				var elem,
				    j,
				    matcher,
				    matchedCount = 0,
				    i = "0",
				    unmatched = seed && [],
				    setMatched = [],
				    contextBackup = outermostContext,


				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG("*", outermost),


				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1,
				    len = elems.length;

				if (outermost) {

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}

				// Add elements passing elementMatchers directly to results
				// Support: iOS <=7 - 9 only
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
				// elements by id. (see trac-14142)
				for (; i !== len && (elem = elems[i]) != null; i++) {
					if (byElement && elem) {
						j = 0;

						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if (!context && elem.ownerDocument != document) {
							setDocument(elem);
							xml = !documentIsHTML;
						}
						while (matcher = elementMatchers[j++]) {
							if (matcher(elem, context || document, xml)) {
								push.call(results, elem);
								break;
							}
						}
						if (outermost) {
							dirruns = dirrunsUnique;
						}
					}

					// Track unmatched elements for set filters
					if (bySet) {

						// They will have gone through all possible matchers
						if (elem = !matcher && elem) {
							matchedCount--;
						}

						// Lengthen the array for every element, matched or not
						if (seed) {
							unmatched.push(elem);
						}
					}
				}

				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;

				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if (bySet && i !== matchedCount) {
					j = 0;
					while (matcher = setMatchers[j++]) {
						matcher(unmatched, setMatched, context, xml);
					}

					if (seed) {

						// Reintegrate element matches to eliminate the need for sorting
						if (matchedCount > 0) {
							while (i--) {
								if (!(unmatched[i] || setMatched[i])) {
									setMatched[i] = pop.call(results);
								}
							}
						}

						// Discard index placeholder values to get only actual matches
						setMatched = condense(setMatched);
					}

					// Add matches to results
					push.apply(results, setMatched);

					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {

						jQuery.uniqueSort(results);
					}
				}

				// Override manipulation of globals by nested matchers
				if (outermost) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}

				return unmatched;
			};

			return bySet ? markFunction(superMatcher) : superMatcher;
		}

		function compile(selector, match /* Internal Use Only */) {
			var i,
			    setMatchers = [],
			    elementMatchers = [],
			    cached = compilerCache[selector + " "];

			if (!cached) {

				// Generate a function of recursive functions that can be used to check each element
				if (!match) {
					match = tokenize(selector);
				}
				i = match.length;
				while (i--) {
					cached = matcherFromTokens(match[i]);
					if (cached[expando]) {
						setMatchers.push(cached);
					} else {
						elementMatchers.push(cached);
					}
				}

				// Cache the compiled function
				cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));

				// Save selector and tokenization
				cached.selector = selector;
			}
			return cached;
		}

		/**
   * A low-level selection function that works with jQuery's compiled
   *  selector functions
   * @param {String|Function} selector A selector or a pre-compiled
   *  selector function built with jQuery selector compile
   * @param {Element} context
   * @param {Array} [results]
   * @param {Array} [seed] A set of elements to match against
   */
		function select(selector, context, results, seed) {
			var i,
			    tokens,
			    token,
			    type,
			    find,
			    compiled = typeof selector === "function" && selector,
			    match = !seed && tokenize(selector = compiled.selector || selector);

			results = results || [];

			// Try to minimize operations if there is only one selector in the list and no seed
			// (the latter of which guarantees us context)
			if (match.length === 1) {

				// Reduce context if the leading compound selector is an ID
				tokens = match[0] = match[0].slice(0);
				if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {

					context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
					if (!context) {
						return results;

						// Precompiled matchers will still verify ancestry, so step up a level
					} else if (compiled) {
						context = context.parentNode;
					}

					selector = selector.slice(tokens.shift().value.length);
				}

				// Fetch a seed set for right-to-left matching
				i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
				while (i--) {
					token = tokens[i];

					// Abort if we hit a combinator
					if (Expr.relative[type = token.type]) {
						break;
					}
					if (find = Expr.find[type]) {

						// Search, expanding context for leading sibling combinators
						if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {

							// If seed is empty or no tokens remain, we can return early
							tokens.splice(i, 1);
							selector = seed.length && toSelector(tokens);
							if (!selector) {
								push.apply(results, seed);
								return results;
							}

							break;
						}
					}
				}
			}

			// Compile and execute a filtering function if one is not provided
			// Provide `match` to avoid retokenization if we modified the selector above
			(compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
			return results;
		}

		// One-time assignments

		// Support: Android <=4.0 - 4.1+
		// Sort stability
		support.sortStable = expando.split("").sort(sortOrder).join("") === expando;

		// Initialize against the default document
		setDocument();

		// Support: Android <=4.0 - 4.1+
		// Detached nodes confoundingly follow *each other*
		support.sortDetached = assert(function (el) {

			// Should return 1, but returns 4 (following)
			return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
		});

		jQuery.find = find;

		// Deprecated
		jQuery.expr[":"] = jQuery.expr.pseudos;
		jQuery.unique = jQuery.uniqueSort;

		// These have always been private, but they used to be documented as part of
		// Sizzle so let's maintain them for now for backwards compatibility purposes.
		find.compile = compile;
		find.select = select;
		find.setDocument = setDocument;
		find.tokenize = tokenize;

		find.escape = jQuery.escapeSelector;
		find.getText = jQuery.text;
		find.isXML = jQuery.isXMLDoc;
		find.selectors = jQuery.expr;
		find.support = jQuery.support;
		find.uniqueSort = jQuery.uniqueSort;

		/* eslint-enable */
	})();

	var dir = function dir(elem, _dir, until) {
		var matched = [],
		    truncate = until !== undefined;

		while ((elem = elem[_dir]) && elem.nodeType !== 9) {
			if (elem.nodeType === 1) {
				if (truncate && jQuery(elem).is(until)) {
					break;
				}
				matched.push(elem);
			}
		}
		return matched;
	};

	var _siblings = function _siblings(n, elem) {
		var matched = [];

		for (; n; n = n.nextSibling) {
			if (n.nodeType === 1 && n !== elem) {
				matched.push(n);
			}
		}

		return matched;
	};

	var rneedsContext = jQuery.expr.match.needsContext;

	var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

	// Implement the identical functionality for filter and not
	function winnow(elements, qualifier, not) {
		if (isFunction(qualifier)) {
			return jQuery.grep(elements, function (elem, i) {
				return !!qualifier.call(elem, i, elem) !== not;
			});
		}

		// Single element
		if (qualifier.nodeType) {
			return jQuery.grep(elements, function (elem) {
				return elem === qualifier !== not;
			});
		}

		// Arraylike of elements (jQuery, arguments, Array)
		if (typeof qualifier !== "string") {
			return jQuery.grep(elements, function (elem) {
				return indexOf.call(qualifier, elem) > -1 !== not;
			});
		}

		// Filtered directly for both simple and complex selectors
		return jQuery.filter(qualifier, elements, not);
	}

	jQuery.filter = function (expr, elems, not) {
		var elem = elems[0];

		if (not) {
			expr = ":not(" + expr + ")";
		}

		if (elems.length === 1 && elem.nodeType === 1) {
			return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
		}

		return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
			return elem.nodeType === 1;
		}));
	};

	jQuery.fn.extend({
		find: function find(selector) {
			var i,
			    ret,
			    len = this.length,
			    self = this;

			if (typeof selector !== "string") {
				return this.pushStack(jQuery(selector).filter(function () {
					for (i = 0; i < len; i++) {
						if (jQuery.contains(self[i], this)) {
							return true;
						}
					}
				}));
			}

			ret = this.pushStack([]);

			for (i = 0; i < len; i++) {
				jQuery.find(selector, self[i], ret);
			}

			return len > 1 ? jQuery.uniqueSort(ret) : ret;
		},
		filter: function filter(selector) {
			return this.pushStack(winnow(this, selector || [], false));
		},
		not: function not(selector) {
			return this.pushStack(winnow(this, selector || [], true));
		},
		is: function is(selector) {
			return !!winnow(this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
		}
	});

	// Initialize a jQuery object


	// A central reference to the root jQuery(document)
	var rootjQuery,


	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	    init = jQuery.fn.init = function (selector, context, root) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if (!selector) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if (typeof selector === "string") {
			if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [null, selector, null];
			} else {
				match = rquickExpr.exec(selector);
			}

			// Match html or make sure no context is specified for #id
			if (match && (match[1] || !context)) {

				// HANDLE: $(html) -> $(array)
				if (match[1]) {
					context = context instanceof jQuery ? context[0] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));

					// HANDLE: $(html, props)
					if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
						for (match in context) {

							// Properties of context are called as methods if possible
							if (isFunction(this[match])) {
								this[match](context[match]);

								// ...and otherwise set as attributes
							} else {
								this.attr(match, context[match]);
							}
						}
					}

					return this;

					// HANDLE: $(#id)
				} else {
					elem = document.getElementById(match[2]);

					if (elem) {

						// Inject the element directly into the jQuery object
						this[0] = elem;
						this.length = 1;
					}
					return this;
				}

				// HANDLE: $(expr, $(...))
			} else if (!context || context.jquery) {
				return (context || root).find(selector);

				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor(context).find(selector);
			}

			// HANDLE: $(DOMElement)
		} else if (selector.nodeType) {
			this[0] = selector;
			this.length = 1;
			return this;

			// HANDLE: $(function)
			// Shortcut for document ready
		} else if (isFunction(selector)) {
			return root.ready !== undefined ? root.ready(selector) :

			// Execute immediately if ready is not present
			selector(jQuery);
		}

		return jQuery.makeArray(selector, this);
	};

	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;

	// Initialize central reference
	rootjQuery = jQuery(document);

	var rparentsprev = /^(?:parents|prev(?:Until|All))/,


	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

	jQuery.fn.extend({
		has: function has(target) {
			var targets = jQuery(target, this),
			    l = targets.length;

			return this.filter(function () {
				var i = 0;
				for (; i < l; i++) {
					if (jQuery.contains(this, targets[i])) {
						return true;
					}
				}
			});
		},

		closest: function closest(selectors, context) {
			var cur,
			    i = 0,
			    l = this.length,
			    matched = [],
			    targets = typeof selectors !== "string" && jQuery(selectors);

			// Positional selectors never match, since there's no _selection_ context
			if (!rneedsContext.test(selectors)) {
				for (; i < l; i++) {
					for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {

						// Always skip document fragments
						if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {

							matched.push(cur);
							break;
						}
					}
				}
			}

			return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
		},

		// Determine the position of an element within the set
		index: function index(elem) {

			// No argument, return index in parent
			if (!elem) {
				return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
			}

			// Index in selector
			if (typeof elem === "string") {
				return indexOf.call(jQuery(elem), this[0]);
			}

			// Locate the position of the desired element
			return indexOf.call(this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[0] : elem);
		},

		add: function add(selector, context) {
			return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
		},

		addBack: function addBack(selector) {
			return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
		}
	});

	function sibling(cur, dir) {
		while ((cur = cur[dir]) && cur.nodeType !== 1) {}
		return cur;
	}

	jQuery.each({
		parent: function parent(elem) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function parents(elem) {
			return dir(elem, "parentNode");
		},
		parentsUntil: function parentsUntil(elem, _i, until) {
			return dir(elem, "parentNode", until);
		},
		next: function next(elem) {
			return sibling(elem, "nextSibling");
		},
		prev: function prev(elem) {
			return sibling(elem, "previousSibling");
		},
		nextAll: function nextAll(elem) {
			return dir(elem, "nextSibling");
		},
		prevAll: function prevAll(elem) {
			return dir(elem, "previousSibling");
		},
		nextUntil: function nextUntil(elem, _i, until) {
			return dir(elem, "nextSibling", until);
		},
		prevUntil: function prevUntil(elem, _i, until) {
			return dir(elem, "previousSibling", until);
		},
		siblings: function siblings(elem) {
			return _siblings((elem.parentNode || {}).firstChild, elem);
		},
		children: function children(elem) {
			return _siblings(elem.firstChild);
		},
		contents: function contents(elem) {
			if (elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto(elem.contentDocument)) {

				return elem.contentDocument;
			}

			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if (nodeName(elem, "template")) {
				elem = elem.content || elem;
			}

			return jQuery.merge([], elem.childNodes);
		}
	}, function (name, fn) {
		jQuery.fn[name] = function (until, selector) {
			var matched = jQuery.map(this, fn, until);

			if (name.slice(-5) !== "Until") {
				selector = until;
			}

			if (selector && typeof selector === "string") {
				matched = jQuery.filter(selector, matched);
			}

			if (this.length > 1) {

				// Remove duplicates
				if (!guaranteedUnique[name]) {
					jQuery.uniqueSort(matched);
				}

				// Reverse order for parents* and prev-derivatives
				if (rparentsprev.test(name)) {
					matched.reverse();
				}
			}

			return this.pushStack(matched);
		};
	});
	var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;

	// Convert String-formatted options into Object-formatted ones
	function createOptions(options) {
		var object = {};
		jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
			object[flag] = true;
		});
		return object;
	}

	/*
  * Create a callback list using the following parameters:
  *
  *	options: an optional list of space-separated options that will change how
  *			the callback list behaves or a more traditional option object
  *
  * By default a callback list will act like an event callback list and can be
  * "fired" multiple times.
  *
  * Possible options:
  *
  *	once:			will ensure the callback list can only be fired once (like a Deferred)
  *
  *	memory:			will keep track of previous values and will call any callback added
  *					after the list has been fired right away with the latest "memorized"
  *					values (like a Deferred)
  *
  *	unique:			will ensure a callback can only be added once (no duplicate in the list)
  *
  *	stopOnFalse:	interrupt callings when a callback returns false
  *
  */
	jQuery.Callbacks = function (options) {

		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);

		var // Flag to know if list is currently firing
		firing,


		// Last fire value for non-forgettable lists
		memory,


		// Flag to know if list was already fired
		_fired,


		// Flag to prevent firing
		_locked,


		// Actual callback list
		list = [],


		// Queue of execution data for repeatable lists
		queue = [],


		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,


		// Fire callbacks
		fire = function fire() {

			// Enforce single-firing
			_locked = _locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			_fired = firing = true;
			for (; queue.length; firingIndex = -1) {
				memory = queue.shift();
				while (++firingIndex < list.length) {

					// Run callback and check for early termination
					if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if (!options.memory) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if (_locked) {

				// Keep an empty list if we have data for future add calls
				if (memory) {
					list = [];

					// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},


		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function add() {
				if (list) {

					// If we have memory from a past run, we should fire after adding
					if (memory && !firing) {
						firingIndex = list.length - 1;
						queue.push(memory);
					}

					(function add(args) {
						jQuery.each(args, function (_, arg) {
							if (isFunction(arg)) {
								if (!options.unique || !self.has(arg)) {
									list.push(arg);
								}
							} else if (arg && arg.length && toType(arg) !== "string") {

								// Inspect recursively
								add(arg);
							}
						});
					})(arguments);

					if (memory && !firing) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function remove() {
				jQuery.each(arguments, function (_, arg) {
					var index;
					while ((index = jQuery.inArray(arg, list, index)) > -1) {
						list.splice(index, 1);

						// Handle firing indexes
						if (index <= firingIndex) {
							firingIndex--;
						}
					}
				});
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function has(fn) {
				return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function empty() {
				if (list) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function disable() {
				_locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function disabled() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function lock() {
				_locked = queue = [];
				if (!memory && !firing) {
					list = memory = "";
				}
				return this;
			},
			locked: function locked() {
				return !!_locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function fireWith(context, args) {
				if (!_locked) {
					args = args || [];
					args = [context, args.slice ? args.slice() : args];
					queue.push(args);
					if (!firing) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function fire() {
				self.fireWith(this, arguments);
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function fired() {
				return !!_fired;
			}
		};

		return self;
	};

	function Identity(v) {
		return v;
	}
	function Thrower(ex) {
		throw ex;
	}

	function adoptValue(value, resolve, reject, noValue) {
		var method;

		try {

			// Check for promise aspect first to privilege synchronous behavior
			if (value && isFunction(method = value.promise)) {
				method.call(value).done(resolve).fail(reject);

				// Other thenables
			} else if (value && isFunction(method = value.then)) {
				method.call(value, resolve, reject);

				// Other non-thenables
			} else {

				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply(undefined, [value].slice(noValue));
			}

			// For Promises/A+, convert exceptions into rejections
			// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
			// Deferred#then to conditionally suppress rejection.
		} catch (value) {

			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply(undefined, [value]);
		}
	}

	jQuery.extend({

		Deferred: function Deferred(func) {
			var tuples = [

			// action, add listener, callbacks,
			// ... .then handlers, argument index, [final state]
			["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory"), 2], ["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 1, "rejected"]],
			    _state = "pending",
			    _promise = {
				state: function state() {
					return _state;
				},
				always: function always() {
					deferred.done(arguments).fail(arguments);
					return this;
				},
				"catch": function _catch(fn) {
					return _promise.then(null, fn);
				},

				// Keep pipe for back-compat
				pipe: function pipe() /* fnDone, fnFail, fnProgress */{
					var fns = arguments;

					return jQuery.Deferred(function (newDefer) {
						jQuery.each(tuples, function (_i, tuple) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[tuple[1]](function () {
								var returned = fn && fn.apply(this, arguments);
								if (returned && isFunction(returned.promise)) {
									returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
								} else {
									newDefer[tuple[0] + "With"](this, fn ? [returned] : arguments);
								}
							});
						});
						fns = null;
					}).promise();
				},
				then: function then(onFulfilled, onRejected, onProgress) {
					var maxDepth = 0;
					function resolve(depth, deferred, handler, special) {
						return function () {
							var that = this,
							    args = arguments,
							    mightThrow = function mightThrow() {
								var returned, then;

								// Support: Promises/A+ section 2.3.3.3.3
								// https://promisesaplus.com/#point-59
								// Ignore double-resolution attempts
								if (depth < maxDepth) {
									return;
								}

								returned = handler.apply(that, args);

								// Support: Promises/A+ section 2.3.1
								// https://promisesaplus.com/#point-48
								if (returned === deferred.promise()) {
									throw new TypeError("Thenable self-resolution");
								}

								// Support: Promises/A+ sections 2.3.3.1, 3.5
								// https://promisesaplus.com/#point-54
								// https://promisesaplus.com/#point-75
								// Retrieve `then` only once
								then = returned && (

								// Support: Promises/A+ section 2.3.4
								// https://promisesaplus.com/#point-64
								// Only check objects and functions for thenability
								(typeof returned === "undefined" ? "undefined" : _typeof(returned)) === "object" || typeof returned === "function") && returned.then;

								// Handle a returned thenable
								if (isFunction(then)) {

									// Special processors (notify) just wait for resolution
									if (special) {
										then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));

										// Normal processors (resolve) also hook into progress
									} else {

										// ...and disregard older resolution values
										maxDepth++;

										then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
									}

									// Handle all other returned values
								} else {

									// Only substitute handlers pass on context
									// and multiple values (non-spec behavior)
									if (handler !== Identity) {
										that = undefined;
										args = [returned];
									}

									// Process the value(s)
									// Default process is resolve
									(special || deferred.resolveWith)(that, args);
								}
							},


							// Only normal processors (resolve) catch and reject exceptions
							process = special ? mightThrow : function () {
								try {
									mightThrow();
								} catch (e) {

									if (jQuery.Deferred.exceptionHook) {
										jQuery.Deferred.exceptionHook(e, process.error);
									}

									// Support: Promises/A+ section 2.3.3.3.4.1
									// https://promisesaplus.com/#point-61
									// Ignore post-resolution exceptions
									if (depth + 1 >= maxDepth) {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if (handler !== Thrower) {
											that = undefined;
											args = [e];
										}

										deferred.rejectWith(that, args);
									}
								}
							};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if (depth) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if (jQuery.Deferred.getErrorHook) {
									process.error = jQuery.Deferred.getErrorHook();

									// The deprecated alias of the above. While the name suggests
									// returning the stack, not an error instance, jQuery just passes
									// it directly to `console.warn` so both will work; an instance
									// just better cooperates with source maps.
								} else if (jQuery.Deferred.getStackHook) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout(process);
							}
						};
					}

					return jQuery.Deferred(function (newDefer) {

						// progress_handlers.add( ... )
						tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));

						// fulfilled_handlers.add( ... )
						tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));

						// rejected_handlers.add( ... )
						tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
					}).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function promise(obj) {
					return obj != null ? jQuery.extend(obj, _promise) : _promise;
				}
			},
			    deferred = {};

			// Add list-specific methods
			jQuery.each(tuples, function (i, tuple) {
				var list = tuple[2],
				    stateString = tuple[5];

				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				_promise[tuple[1]] = list.add;

				// Handle state
				if (stateString) {
					list.add(function () {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						_state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[3 - i][2].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[3 - i][3].disable,

					// progress_callbacks.lock
					tuples[0][2].lock,

					// progress_handlers.lock
					tuples[0][3].lock);
				}

				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add(tuple[3].fire);

				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[tuple[0]] = function () {
					deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
					return this;
				};

				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[tuple[0] + "With"] = list.fireWith;
			});

			// Make the deferred a promise
			_promise.promise(deferred);

			// Call given func if any
			if (func) {
				func.call(deferred, deferred);
			}

			// All done!
			return deferred;
		},

		// Deferred helper
		when: function when(singleValue) {
			var

			// count of uncompleted subordinates
			remaining = arguments.length,


			// count of unprocessed arguments
			i = remaining,


			// subordinate fulfillment data
			resolveContexts = Array(i),
			    resolveValues = _slice.call(arguments),


			// the primary Deferred
			primary = jQuery.Deferred(),


			// subordinate callback factory
			updateFunc = function updateFunc(i) {
				return function (value) {
					resolveContexts[i] = this;
					resolveValues[i] = arguments.length > 1 ? _slice.call(arguments) : value;
					if (! --remaining) {
						primary.resolveWith(resolveContexts, resolveValues);
					}
				};
			};

			// Single- and empty arguments are adopted like Promise.resolve
			if (remaining <= 1) {
				adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);

				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {

					return primary.then();
				}
			}

			// Multiple arguments are aggregated like Promise.all array elements
			while (i--) {
				adoptValue(resolveValues[i], updateFunc(i), primary.reject);
			}

			return primary.promise();
		}
	});

	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

	// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
	// captured before the async barrier to get the original error cause
	// which may otherwise be hidden.
	jQuery.Deferred.exceptionHook = function (error, asyncError) {

		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
			window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
		}
	};

	jQuery.readyException = function (error) {
		window.setTimeout(function () {
			throw error;
		});
	};

	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();

	jQuery.fn.ready = function (fn) {

		readyList.then(fn)

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch(function (error) {
			jQuery.readyException(error);
		});

		return this;
	};

	jQuery.extend({

		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,

		// A counter to track how many items to wait for before
		// the ready event fires. See trac-6781
		readyWait: 1,

		// Handle when the DOM is ready
		ready: function ready(wait) {

			// Abort if there are pending holds or we're already ready
			if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
				return;
			}

			// Remember that the DOM is ready
			jQuery.isReady = true;

			// If a normal DOM Ready event fired, decrement, and wait if need be
			if (wait !== true && --jQuery.readyWait > 0) {
				return;
			}

			// If there are functions bound, to execute
			readyList.resolveWith(document, [jQuery]);
		}
	});

	jQuery.ready.then = readyList.then;

	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener("DOMContentLoaded", completed);
		window.removeEventListener("load", completed);
		jQuery.ready();
	}

	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) {

		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout(jQuery.ready);
	} else {

		// Use the handy event callback
		document.addEventListener("DOMContentLoaded", completed);

		// A fallback to window.onload, that will always work
		window.addEventListener("load", completed);
	}

	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function access(elems, fn, key, value, chainable, emptyGet, raw) {
		var i = 0,
		    len = elems.length,
		    bulk = key == null;

		// Sets many values
		if (toType(key) === "object") {
			chainable = true;
			for (i in key) {
				access(elems, fn, i, key[i], true, emptyGet, raw);
			}

			// Sets one value
		} else if (value !== undefined) {
			chainable = true;

			if (!isFunction(value)) {
				raw = true;
			}

			if (bulk) {

				// Bulk operations run against the entire set
				if (raw) {
					fn.call(elems, value);
					fn = null;

					// ...except when executing function values
				} else {
					bulk = fn;
					fn = function fn(elem, _key, value) {
						return bulk.call(jQuery(elem), value);
					};
				}
			}

			if (fn) {
				for (; i < len; i++) {
					fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
				}
			}
		}

		if (chainable) {
			return elems;
		}

		// Gets
		if (bulk) {
			return fn.call(elems);
		}

		return len ? fn(elems[0], key) : emptyGet;
	};

	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
	    rdashAlpha = /-([a-z])/g;

	// Used by camelCase as callback to replace()
	function fcamelCase(_all, letter) {
		return letter.toUpperCase();
	}

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (trac-9572)
	function camelCase(string) {
		return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
	}
	var acceptData = function acceptData(owner) {

		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
	};

	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}

	Data.uid = 1;

	Data.prototype = {

		cache: function cache(owner) {

			// Check if the owner object already has a cache
			var value = owner[this.expando];

			// If not, create one
			if (!value) {
				value = {};

				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see trac-8335.
				// Always return an empty object.
				if (acceptData(owner)) {

					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if (owner.nodeType) {
						owner[this.expando] = value;

						// Otherwise secure it in a non-enumerable property
						// configurable must be true to allow the property to be
						// deleted when data is removed
					} else {
						Object.defineProperty(owner, this.expando, {
							value: value,
							configurable: true
						});
					}
				}
			}

			return value;
		},
		set: function set(owner, data, value) {
			var prop,
			    cache = this.cache(owner);

			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if (typeof data === "string") {
				cache[camelCase(data)] = value;

				// Handle: [ owner, { properties } ] args
			} else {

				// Copy the properties one-by-one to the cache object
				for (prop in data) {
					cache[camelCase(prop)] = data[prop];
				}
			}
			return cache;
		},
		get: function get(owner, key) {
			return key === undefined ? this.cache(owner) :

			// Always use camelCase key (gh-2257)
			owner[this.expando] && owner[this.expando][camelCase(key)];
		},
		access: function access(owner, key, value) {

			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if (key === undefined || key && typeof key === "string" && value === undefined) {

				return this.get(owner, key);
			}

			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set(owner, key, value);

			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function remove(owner, key) {
			var i,
			    cache = owner[this.expando];

			if (cache === undefined) {
				return;
			}

			if (key !== undefined) {

				// Support array or space separated string of keys
				if (Array.isArray(key)) {

					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map(camelCase);
				} else {
					key = camelCase(key);

					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
				}

				i = key.length;

				while (i--) {
					delete cache[key[i]];
				}
			}

			// Remove the expando if there's no more data
			if (key === undefined || jQuery.isEmptyObject(cache)) {

				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if (owner.nodeType) {
					owner[this.expando] = undefined;
				} else {
					delete owner[this.expando];
				}
			}
		},
		hasData: function hasData(owner) {
			var cache = owner[this.expando];
			return cache !== undefined && !jQuery.isEmptyObject(cache);
		}
	};
	var dataPriv = new Data();

	var dataUser = new Data();

	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	    rmultiDash = /[A-Z]/g;

	function getData(data) {
		if (data === "true") {
			return true;
		}

		if (data === "false") {
			return false;
		}

		if (data === "null") {
			return null;
		}

		// Only convert to a number if it doesn't change the string
		if (data === +data + "") {
			return +data;
		}

		if (rbrace.test(data)) {
			return JSON.parse(data);
		}

		return data;
	}

	function dataAttr(elem, key, data) {
		var name;

		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if (data === undefined && elem.nodeType === 1) {
			name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
			data = elem.getAttribute(name);

			if (typeof data === "string") {
				try {
					data = getData(data);
				} catch (e) {}

				// Make sure we set the data so it isn't changed later
				dataUser.set(elem, key, data);
			} else {
				data = undefined;
			}
		}
		return data;
	}

	jQuery.extend({
		hasData: function hasData(elem) {
			return dataUser.hasData(elem) || dataPriv.hasData(elem);
		},

		data: function data(elem, name, _data) {
			return dataUser.access(elem, name, _data);
		},

		removeData: function removeData(elem, name) {
			dataUser.remove(elem, name);
		},

		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function _data(elem, name, data) {
			return dataPriv.access(elem, name, data);
		},

		_removeData: function _removeData(elem, name) {
			dataPriv.remove(elem, name);
		}
	});

	jQuery.fn.extend({
		data: function data(key, value) {
			var i,
			    name,
			    data,
			    elem = this[0],
			    attrs = elem && elem.attributes;

			// Gets all values
			if (key === undefined) {
				if (this.length) {
					data = dataUser.get(elem);

					if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
						i = attrs.length;
						while (i--) {

							// Support: IE 11 only
							// The attrs elements can be null (trac-14894)
							if (attrs[i]) {
								name = attrs[i].name;
								if (name.indexOf("data-") === 0) {
									name = camelCase(name.slice(5));
									dataAttr(elem, name, data[name]);
								}
							}
						}
						dataPriv.set(elem, "hasDataAttrs", true);
					}
				}

				return data;
			}

			// Sets multiple values
			if ((typeof key === "undefined" ? "undefined" : _typeof(key)) === "object") {
				return this.each(function () {
					dataUser.set(this, key);
				});
			}

			return access(this, function (value) {
				var data;

				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if (elem && value === undefined) {

					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get(elem, key);
					if (data !== undefined) {
						return data;
					}

					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr(elem, key);
					if (data !== undefined) {
						return data;
					}

					// We tried really hard, but the data doesn't exist.
					return;
				}

				// Set the data...
				this.each(function () {

					// We always store the camelCased key
					dataUser.set(this, key, value);
				});
			}, null, value, arguments.length > 1, null, true);
		},

		removeData: function removeData(key) {
			return this.each(function () {
				dataUser.remove(this, key);
			});
		}
	});

	jQuery.extend({
		queue: function queue(elem, type, data) {
			var queue;

			if (elem) {
				type = (type || "fx") + "queue";
				queue = dataPriv.get(elem, type);

				// Speed up dequeue by getting out quickly if this is just a lookup
				if (data) {
					if (!queue || Array.isArray(data)) {
						queue = dataPriv.access(elem, type, jQuery.makeArray(data));
					} else {
						queue.push(data);
					}
				}
				return queue || [];
			}
		},

		dequeue: function dequeue(elem, type) {
			type = type || "fx";

			var queue = jQuery.queue(elem, type),
			    startLength = queue.length,
			    fn = queue.shift(),
			    hooks = jQuery._queueHooks(elem, type),
			    next = function next() {
				jQuery.dequeue(elem, type);
			};

			// If the fx queue is dequeued, always remove the progress sentinel
			if (fn === "inprogress") {
				fn = queue.shift();
				startLength--;
			}

			if (fn) {

				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if (type === "fx") {
					queue.unshift("inprogress");
				}

				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call(elem, next, hooks);
			}

			if (!startLength && hooks) {
				hooks.empty.fire();
			}
		},

		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function _queueHooks(elem, type) {
			var key = type + "queueHooks";
			return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
				empty: jQuery.Callbacks("once memory").add(function () {
					dataPriv.remove(elem, [type + "queue", key]);
				})
			});
		}
	});

	jQuery.fn.extend({
		queue: function queue(type, data) {
			var setter = 2;

			if (typeof type !== "string") {
				data = type;
				type = "fx";
				setter--;
			}

			if (arguments.length < setter) {
				return jQuery.queue(this[0], type);
			}

			return data === undefined ? this : this.each(function () {
				var queue = jQuery.queue(this, type, data);

				// Ensure a hooks for this queue
				jQuery._queueHooks(this, type);

				if (type === "fx" && queue[0] !== "inprogress") {
					jQuery.dequeue(this, type);
				}
			});
		},
		dequeue: function dequeue(type) {
			return this.each(function () {
				jQuery.dequeue(this, type);
			});
		},
		clearQueue: function clearQueue(type) {
			return this.queue(type || "fx", []);
		},

		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function promise(type, obj) {
			var tmp,
			    count = 1,
			    defer = jQuery.Deferred(),
			    elements = this,
			    i = this.length,
			    resolve = function resolve() {
				if (! --count) {
					defer.resolveWith(elements, [elements]);
				}
			};

			if (typeof type !== "string") {
				obj = type;
				type = undefined;
			}
			type = type || "fx";

			while (i--) {
				tmp = dataPriv.get(elements[i], type + "queueHooks");
				if (tmp && tmp.empty) {
					count++;
					tmp.empty.add(resolve);
				}
			}
			resolve();
			return defer.promise(obj);
		}
	});
	var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;

	var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");

	var cssExpand = ["Top", "Right", "Bottom", "Left"];

	var documentElement = document.documentElement;

	var isAttached = function isAttached(elem) {
		return jQuery.contains(elem.ownerDocument, elem);
	},
	    composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if (documentElement.getRootNode) {
		isAttached = function isAttached(elem) {
			return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
		};
	}
	var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" || elem.style.display === "" &&

		// Otherwise, check computed style
		// Support: Firefox <=43 - 45
		// Disconnected elements can have computed display: none, so first confirm that elem is
		// in the document.
		isAttached(elem) && jQuery.css(elem, "display") === "none";
	};

	function adjustCSS(elem, prop, valueParts, tween) {
		var adjusted,
		    scale,
		    maxIterations = 20,
		    currentValue = tween ? function () {
			return tween.cur();
		} : function () {
			return jQuery.css(elem, prop, "");
		},
		    initial = currentValue(),
		    unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),


		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));

		if (initialInUnit && initialInUnit[3] !== unit) {

			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;

			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[3];

			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;

			while (maxIterations--) {

				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style(elem, prop, initialInUnit + unit);
				if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
			}

			initialInUnit = initialInUnit * 2;
			jQuery.style(elem, prop, initialInUnit + unit);

			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}

		if (valueParts) {
			initialInUnit = +initialInUnit || +initial || 0;

			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
			if (tween) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}

	var defaultDisplayMap = {};

	function getDefaultDisplay(elem) {
		var temp,
		    doc = elem.ownerDocument,
		    nodeName = elem.nodeName,
		    display = defaultDisplayMap[nodeName];

		if (display) {
			return display;
		}

		temp = doc.body.appendChild(doc.createElement(nodeName));
		display = jQuery.css(temp, "display");

		temp.parentNode.removeChild(temp);

		if (display === "none") {
			display = "block";
		}
		defaultDisplayMap[nodeName] = display;

		return display;
	}

	function showHide(elements, show) {
		var display,
		    elem,
		    values = [],
		    index = 0,
		    length = elements.length;

		// Determine new display value for elements that need to change
		for (; index < length; index++) {
			elem = elements[index];
			if (!elem.style) {
				continue;
			}

			display = elem.style.display;
			if (show) {

				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if (display === "none") {
					values[index] = dataPriv.get(elem, "display") || null;
					if (!values[index]) {
						elem.style.display = "";
					}
				}
				if (elem.style.display === "" && isHiddenWithinTree(elem)) {
					values[index] = getDefaultDisplay(elem);
				}
			} else {
				if (display !== "none") {
					values[index] = "none";

					// Remember what we're overwriting
					dataPriv.set(elem, "display", display);
				}
			}
		}

		// Set the display of the elements in a second loop to avoid constant reflow
		for (index = 0; index < length; index++) {
			if (values[index] != null) {
				elements[index].style.display = values[index];
			}
		}

		return elements;
	}

	jQuery.fn.extend({
		show: function show() {
			return showHide(this, true);
		},
		hide: function hide() {
			return showHide(this);
		},
		toggle: function toggle(state) {
			if (typeof state === "boolean") {
				return state ? this.show() : this.hide();
			}

			return this.each(function () {
				if (isHiddenWithinTree(this)) {
					jQuery(this).show();
				} else {
					jQuery(this).hide();
				}
			});
		}
	});
	var rcheckableType = /^(?:checkbox|radio)$/i;

	var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;

	var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;

	(function () {
		var fragment = document.createDocumentFragment(),
		    div = fragment.appendChild(document.createElement("div")),
		    input = document.createElement("input");

		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (trac-11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (trac-14901)
		input.setAttribute("type", "radio");
		input.setAttribute("checked", "checked");
		input.setAttribute("name", "t");

		div.appendChild(input);

		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;

		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;

		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	})();

	// We have to close these tags to support XHTML (trac-13200)
	var wrapMap = {

		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [1, "<table>", "</table>"],
		col: [2, "<table><colgroup>", "</colgroup></table>"],
		tr: [2, "<table><tbody>", "</tbody></table>"],
		td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],

		_default: [0, "", ""]
	};

	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;

	// Support: IE <=9 only
	if (!support.option) {
		wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", "</select>"];
	}

	function getAll(context, tag) {

		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
		var ret;

		if (typeof context.getElementsByTagName !== "undefined") {
			ret = context.getElementsByTagName(tag || "*");
		} else if (typeof context.querySelectorAll !== "undefined") {
			ret = context.querySelectorAll(tag || "*");
		} else {
			ret = [];
		}

		if (tag === undefined || tag && nodeName(context, tag)) {
			return jQuery.merge([context], ret);
		}

		return ret;
	}

	// Mark scripts as having already been evaluated
	function setGlobalEval(elems, refElements) {
		var i = 0,
		    l = elems.length;

		for (; i < l; i++) {
			dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
		}
	}

	var rhtml = /<|&#?\w+;/;

	function buildFragment(elems, context, scripts, selection, ignored) {
		var elem,
		    tmp,
		    tag,
		    wrap,
		    attached,
		    j,
		    fragment = context.createDocumentFragment(),
		    nodes = [],
		    i = 0,
		    l = elems.length;

		for (; i < l; i++) {
			elem = elems[i];

			if (elem || elem === 0) {

				// Add nodes directly
				if (toType(elem) === "object") {

					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

					// Convert non-html into a text node
				} else if (!rhtml.test(elem)) {
					nodes.push(context.createTextNode(elem));

					// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild(context.createElement("div"));

					// Deserialize a standard representation
					tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
					wrap = wrapMap[tag] || wrapMap._default;
					tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

					// Descend through wrappers to the right content
					j = wrap[0];
					while (j--) {
						tmp = tmp.lastChild;
					}

					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge(nodes, tmp.childNodes);

					// Remember the top-level container
					tmp = fragment.firstChild;

					// Ensure the created nodes are orphaned (trac-12392)
					tmp.textContent = "";
				}
			}
		}

		// Remove wrapper from fragment
		fragment.textContent = "";

		i = 0;
		while (elem = nodes[i++]) {

			// Skip elements already in the context collection (trac-4087)
			if (selection && jQuery.inArray(elem, selection) > -1) {
				if (ignored) {
					ignored.push(elem);
				}
				continue;
			}

			attached = isAttached(elem);

			// Append to fragment
			tmp = getAll(fragment.appendChild(elem), "script");

			// Preserve script evaluation history
			if (attached) {
				setGlobalEval(tmp);
			}

			// Capture executables
			if (scripts) {
				j = 0;
				while (elem = tmp[j++]) {
					if (rscriptType.test(elem.type || "")) {
						scripts.push(elem);
					}
				}
			}
		}

		return fragment;
	}

	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

	function returnTrue() {
		return true;
	}

	function returnFalse() {
		return false;
	}

	function _on(elem, types, selector, data, fn, one) {
		var origFn, type;

		// Types can be a map of types/handlers
		if ((typeof types === "undefined" ? "undefined" : _typeof(types)) === "object") {

			// ( types-Object, selector, data )
			if (typeof selector !== "string") {

				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for (type in types) {
				_on(elem, type, selector, data, types[type], one);
			}
			return elem;
		}

		if (data == null && fn == null) {

			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if (fn == null) {
			if (typeof selector === "string") {

				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {

				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if (fn === false) {
			fn = returnFalse;
		} else if (!fn) {
			return elem;
		}

		if (one === 1) {
			origFn = fn;
			fn = function fn(event) {

				// Can use an empty set, since event contains the info
				jQuery().off(event);
				return origFn.apply(this, arguments);
			};

			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
		}
		return elem.each(function () {
			jQuery.event.add(this, types, fn, data, selector);
		});
	}

	/*
  * Helper functions for managing events -- not part of the public interface.
  * Props to Dean Edwards' addEvent library for many of the ideas.
  */
	jQuery.event = {

		global: {},

		add: function add(elem, types, handler, data, selector) {

			var handleObjIn,
			    eventHandle,
			    tmp,
			    events,
			    t,
			    handleObj,
			    special,
			    handlers,
			    type,
			    namespaces,
			    origType,
			    elemData = dataPriv.get(elem);

			// Only attach events to objects that accept data
			if (!acceptData(elem)) {
				return;
			}

			// Caller can pass in an object of custom data in lieu of the handler
			if (handler.handler) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}

			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if (selector) {
				jQuery.find.matchesSelector(documentElement, selector);
			}

			// Make sure that the handler has a unique ID, used to find/remove it later
			if (!handler.guid) {
				handler.guid = jQuery.guid++;
			}

			// Init the element's event structure and main handler, if this is the first
			if (!(events = elemData.events)) {
				events = elemData.events = Object.create(null);
			}
			if (!(eventHandle = elemData.handle)) {
				eventHandle = elemData.handle = function (e) {

					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
				};
			}

			// Handle multiple events separated by a space
			types = (types || "").match(rnothtmlwhite) || [""];
			t = types.length;
			while (t--) {
				tmp = rtypenamespace.exec(types[t]) || [];
				type = origType = tmp[1];
				namespaces = (tmp[2] || "").split(".").sort();

				// There *must* be a type, no attaching namespace-only handlers
				if (!type) {
					continue;
				}

				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[type] || {};

				// If selector defined, determine special event api type, otherwise given type
				type = (selector ? special.delegateType : special.bindType) || type;

				// Update special based on newly reset type
				special = jQuery.event.special[type] || {};

				// handleObj is passed to all event handlers
				handleObj = jQuery.extend({
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test(selector),
					namespace: namespaces.join(".")
				}, handleObjIn);

				// Init the event handler queue if we're the first
				if (!(handlers = events[type])) {
					handlers = events[type] = [];
					handlers.delegateCount = 0;

					// Only use addEventListener if the special events handler returns false
					if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {

						if (elem.addEventListener) {
							elem.addEventListener(type, eventHandle);
						}
					}
				}

				if (special.add) {
					special.add.call(elem, handleObj);

					if (!handleObj.handler.guid) {
						handleObj.handler.guid = handler.guid;
					}
				}

				// Add to the element's handler list, delegates in front
				if (selector) {
					handlers.splice(handlers.delegateCount++, 0, handleObj);
				} else {
					handlers.push(handleObj);
				}

				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[type] = true;
			}
		},

		// Detach an event or set of events from an element
		remove: function remove(elem, types, handler, selector, mappedTypes) {

			var j,
			    origCount,
			    tmp,
			    events,
			    t,
			    handleObj,
			    special,
			    handlers,
			    type,
			    namespaces,
			    origType,
			    elemData = dataPriv.hasData(elem) && dataPriv.get(elem);

			if (!elemData || !(events = elemData.events)) {
				return;
			}

			// Once for each type.namespace in types; type may be omitted
			types = (types || "").match(rnothtmlwhite) || [""];
			t = types.length;
			while (t--) {
				tmp = rtypenamespace.exec(types[t]) || [];
				type = origType = tmp[1];
				namespaces = (tmp[2] || "").split(".").sort();

				// Unbind all events (on this namespace, if provided) for the element
				if (!type) {
					for (type in events) {
						jQuery.event.remove(elem, type + types[t], handler, selector, true);
					}
					continue;
				}

				special = jQuery.event.special[type] || {};
				type = (selector ? special.delegateType : special.bindType) || type;
				handlers = events[type] || [];
				tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");

				// Remove matching events
				origCount = j = handlers.length;
				while (j--) {
					handleObj = handlers[j];

					if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
						handlers.splice(j, 1);

						if (handleObj.selector) {
							handlers.delegateCount--;
						}
						if (special.remove) {
							special.remove.call(elem, handleObj);
						}
					}
				}

				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if (origCount && !handlers.length) {
					if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {

						jQuery.removeEvent(elem, type, elemData.handle);
					}

					delete events[type];
				}
			}

			// Remove data and the expando if it's no longer used
			if (jQuery.isEmptyObject(events)) {
				dataPriv.remove(elem, "handle events");
			}
		},

		dispatch: function dispatch(nativeEvent) {

			var i,
			    j,
			    ret,
			    matched,
			    handleObj,
			    handlerQueue,
			    args = new Array(arguments.length),


			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix(nativeEvent),
			    handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [],
			    special = jQuery.event.special[event.type] || {};

			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[0] = event;

			for (i = 1; i < arguments.length; i++) {
				args[i] = arguments[i];
			}

			event.delegateTarget = this;

			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if (special.preDispatch && special.preDispatch.call(this, event) === false) {
				return;
			}

			// Determine handlers
			handlerQueue = jQuery.event.handlers.call(this, event, handlers);

			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
				event.currentTarget = matched.elem;

				j = 0;
				while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {

					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {

						event.handleObj = handleObj;
						event.data = handleObj.data;

						ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);

						if (ret !== undefined) {
							if ((event.result = ret) === false) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}

			// Call the postDispatch hook for the mapped type
			if (special.postDispatch) {
				special.postDispatch.call(this, event);
			}

			return event.result;
		},

		handlers: function handlers(event, _handlers) {
			var i,
			    handleObj,
			    sel,
			    matchedHandlers,
			    matchedSelectors,
			    handlerQueue = [],
			    delegateCount = _handlers.delegateCount,
			    cur = event.target;

			// Find delegate handlers
			if (delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!(event.type === "click" && event.button >= 1)) {

				for (; cur !== this; cur = cur.parentNode || this) {

					// Don't check non-elements (trac-13208)
					// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
					if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
						matchedHandlers = [];
						matchedSelectors = {};
						for (i = 0; i < delegateCount; i++) {
							handleObj = _handlers[i];

							// Don't conflict with Object.prototype properties (trac-13203)
							sel = handleObj.selector + " ";

							if (matchedSelectors[sel] === undefined) {
								matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
							}
							if (matchedSelectors[sel]) {
								matchedHandlers.push(handleObj);
							}
						}
						if (matchedHandlers.length) {
							handlerQueue.push({ elem: cur, handlers: matchedHandlers });
						}
					}
				}
			}

			// Add the remaining (directly-bound) handlers
			cur = this;
			if (delegateCount < _handlers.length) {
				handlerQueue.push({ elem: cur, handlers: _handlers.slice(delegateCount) });
			}

			return handlerQueue;
		},

		addProp: function addProp(name, hook) {
			Object.defineProperty(jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,

				get: isFunction(hook) ? function () {
					if (this.originalEvent) {
						return hook(this.originalEvent);
					}
				} : function () {
					if (this.originalEvent) {
						return this.originalEvent[name];
					}
				},

				set: function set(value) {
					Object.defineProperty(this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					});
				}
			});
		},

		fix: function fix(originalEvent) {
			return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
		},

		special: {
			load: {

				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {

				// Utilize native event to ensure correct state for checkable inputs
				setup: function setup(data) {

					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;

					// Claim the first handler
					if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {

						// dataPriv.set( el, "click", ... )
						leverageNative(el, "click", true);
					}

					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function trigger(data) {

					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;

					// Force setup before triggering a click
					if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {

						leverageNative(el, "click");
					}

					// Return non-false to allow normal event-path propagation
					return true;
				},

				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function _default(event) {
					var target = event.target;
					return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
				}
			},

			beforeunload: {
				postDispatch: function postDispatch(event) {

					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if (event.result !== undefined && event.originalEvent) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};

	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative(el, type, isSetup) {

		// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
		if (!isSetup) {
			if (dataPriv.get(el, type) === undefined) {
				jQuery.event.add(el, type, returnTrue);
			}
			return;
		}

		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set(el, type, false);
		jQuery.event.add(el, type, {
			namespace: false,
			handler: function handler(event) {
				var result,
				    saved = dataPriv.get(this, type);

				if (event.isTrigger & 1 && this[type]) {

					// Interrupt processing of the outer synthetic .trigger()ed event
					if (!saved) {

						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = _slice.call(arguments);
						dataPriv.set(this, type, saved);

						// Trigger the native event and capture its result
						this[type]();
						result = dataPriv.get(this, type);
						dataPriv.set(this, type, false);

						if (saved !== result) {

							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();

							return result;
						}

						// If this is an inner synthetic event for an event with a bubbling surrogate
						// (focus or blur), assume that the surrogate already propagated from triggering
						// the native event and prevent that from happening again here.
						// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
						// bubbling surrogate propagates *after* the non-bubbling base), but that seems
						// less bad than duplication.
					} else if ((jQuery.event.special[type] || {}).delegateType) {
						event.stopPropagation();
					}

					// If this is a native event triggered above, everything is now in order
					// Fire an inner synthetic event with the original arguments
				} else if (saved) {

					// ...and capture the result
					dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));

					// Abort handling of the native event by all jQuery handlers while allowing
					// native handlers on the same element to run. On target, this is achieved
					// by stopping immediate propagation just on the jQuery event. However,
					// the native event is re-wrapped by a jQuery one on each level of the
					// propagation so the only way to stop it for jQuery is to stop it for
					// everyone via native `stopPropagation()`. This is not a problem for
					// focus/blur which don't bubble, but it does also stop click on checkboxes
					// and radios. We accept this limitation.
					event.stopPropagation();
					event.isImmediatePropagationStopped = returnTrue;
				}
			}
		});
	}

	jQuery.removeEvent = function (elem, type, handle) {

		// This "if" is needed for plain objects
		if (elem.removeEventListener) {
			elem.removeEventListener(type, handle);
		}
	};

	jQuery.Event = function (src, props) {

		// Allow instantiation without the 'new' keyword
		if (!(this instanceof jQuery.Event)) {
			return new jQuery.Event(src, props);
		}

		// Event object
		if (src && src.type) {
			this.originalEvent = src;
			this.type = src.type;

			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined &&

			// Support: Android <=2.3 only
			src.returnValue === false ? returnTrue : returnFalse;

			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (trac-504, trac-13143)
			this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;

			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;

			// Event type
		} else {
			this.type = src;
		}

		// Put explicitly provided properties onto the event object
		if (props) {
			jQuery.extend(this, props);
		}

		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();

		// Mark it as fixed
		this[jQuery.expando] = true;
	};

	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,

		preventDefault: function preventDefault() {
			var e = this.originalEvent;

			this.isDefaultPrevented = returnTrue;

			if (e && !this.isSimulated) {
				e.preventDefault();
			}
		},
		stopPropagation: function stopPropagation() {
			var e = this.originalEvent;

			this.isPropagationStopped = returnTrue;

			if (e && !this.isSimulated) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function stopImmediatePropagation() {
			var e = this.originalEvent;

			this.isImmediatePropagationStopped = returnTrue;

			if (e && !this.isSimulated) {
				e.stopImmediatePropagation();
			}

			this.stopPropagation();
		}
	};

	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each({
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp);

	jQuery.each({ focus: "focusin", blur: "focusout" }, function (type, delegateType) {

		function focusMappedHandler(nativeEvent) {
			if (document.documentMode) {

				// Support: IE 11+
				// Attach a single focusin/focusout handler on the document while someone wants
				// focus/blur. This is because the former are synchronous in IE while the latter
				// are async. In other browsers, all those handlers are invoked synchronously.

				// `handle` from private data would already wrap the event, but we need
				// to change the `type` here.
				var handle = dataPriv.get(this, "handle"),
				    event = jQuery.event.fix(nativeEvent);
				event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
				event.isSimulated = true;

				// First, handle focusin/focusout
				handle(nativeEvent);

				// ...then, handle focus/blur
				//
				// focus/blur don't bubble while focusin/focusout do; simulate the former by only
				// invoking the handler at the lower level.
				if (event.target === event.currentTarget) {

					// The setup part calls `leverageNative`, which, in turn, calls
					// `jQuery.event.add`, so event handle will already have been set
					// by this point.
					handle(event);
				}
			} else {

				// For non-IE browsers, attach a single capturing handler on the document
				// while someone wants focusin/focusout.
				jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
			}
		}

		jQuery.event.special[type] = {

			// Utilize native event if possible so blur/focus sequence is correct
			setup: function setup() {

				var attaches;

				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative(this, type, true);

				if (document.documentMode) {

					// Support: IE 9 - 11+
					// We use the same native handler for focusin & focus (and focusout & blur)
					// so we need to coordinate setup & teardown parts between those events.
					// Use `delegateType` as the key as `type` is already used by `leverageNative`.
					attaches = dataPriv.get(this, delegateType);
					if (!attaches) {
						this.addEventListener(delegateType, focusMappedHandler);
					}
					dataPriv.set(this, delegateType, (attaches || 0) + 1);
				} else {

					// Return false to allow normal processing in the caller
					return false;
				}
			},
			trigger: function trigger() {

				// Force setup before trigger
				leverageNative(this, type);

				// Return non-false to allow normal event-path propagation
				return true;
			},

			teardown: function teardown() {
				var attaches;

				if (document.documentMode) {
					attaches = dataPriv.get(this, delegateType) - 1;
					if (!attaches) {
						this.removeEventListener(delegateType, focusMappedHandler);
						dataPriv.remove(this, delegateType);
					} else {
						dataPriv.set(this, delegateType, attaches);
					}
				} else {

					// Return false to indicate standard teardown should be applied
					return false;
				}
			},

			// Suppress native focus or blur if we're currently inside
			// a leveraged native-event stack
			_default: function _default(event) {
				return dataPriv.get(event.target, type);
			},

			delegateType: delegateType
		};

		// Support: Firefox <=44
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
		//
		// Support: IE 9 - 11+
		// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
		// attach a single handler for both events in IE.
		jQuery.event.special[delegateType] = {
			setup: function setup() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
				    dataHolder = document.documentMode ? this : doc,
				    attaches = dataPriv.get(dataHolder, delegateType);

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				if (!attaches) {
					if (document.documentMode) {
						this.addEventListener(delegateType, focusMappedHandler);
					} else {
						doc.addEventListener(type, focusMappedHandler, true);
					}
				}
				dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
			},
			teardown: function teardown() {
				var doc = this.ownerDocument || this.document || this,
				    dataHolder = document.documentMode ? this : doc,
				    attaches = dataPriv.get(dataHolder, delegateType) - 1;

				if (!attaches) {
					if (document.documentMode) {
						this.removeEventListener(delegateType, focusMappedHandler);
					} else {
						doc.removeEventListener(type, focusMappedHandler, true);
					}
					dataPriv.remove(dataHolder, delegateType);
				} else {
					dataPriv.set(dataHolder, delegateType, attaches);
				}
			}
		};
	});

	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each({
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function (orig, fix) {
		jQuery.event.special[orig] = {
			delegateType: fix,
			bindType: fix,

			handle: function handle(event) {
				var ret,
				    target = this,
				    related = event.relatedTarget,
				    handleObj = event.handleObj;

				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if (!related || related !== target && !jQuery.contains(target, related)) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply(this, arguments);
					event.type = fix;
				}
				return ret;
			}
		};
	});

	jQuery.fn.extend({

		on: function on(types, selector, data, fn) {
			return _on(this, types, selector, data, fn);
		},
		one: function one(types, selector, data, fn) {
			return _on(this, types, selector, data, fn, 1);
		},
		off: function off(types, selector, fn) {
			var handleObj, type;
			if (types && types.preventDefault && types.handleObj) {

				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
				return this;
			}
			if ((typeof types === "undefined" ? "undefined" : _typeof(types)) === "object") {

				// ( types-object [, selector] )
				for (type in types) {
					this.off(type, selector, types[type]);
				}
				return this;
			}
			if (selector === false || typeof selector === "function") {

				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if (fn === false) {
				fn = returnFalse;
			}
			return this.each(function () {
				jQuery.event.remove(this, types, fn, selector);
			});
		}
	});

	var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,


	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	    rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget(elem, content) {
		if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {

			return jQuery(elem).children("tbody")[0] || elem;
		}

		return elem;
	}

	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript(elem) {
		elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
		return elem;
	}
	function restoreScript(elem) {
		if ((elem.type || "").slice(0, 5) === "true/") {
			elem.type = elem.type.slice(5);
		} else {
			elem.removeAttribute("type");
		}

		return elem;
	}

	function cloneCopyEvent(src, dest) {
		var i, l, type, pdataOld, udataOld, udataCur, events;

		if (dest.nodeType !== 1) {
			return;
		}

		// 1. Copy private data: events, handlers, etc.
		if (dataPriv.hasData(src)) {
			pdataOld = dataPriv.get(src);
			events = pdataOld.events;

			if (events) {
				dataPriv.remove(dest, "handle events");

				for (type in events) {
					for (i = 0, l = events[type].length; i < l; i++) {
						jQuery.event.add(dest, type, events[type][i]);
					}
				}
			}
		}

		// 2. Copy user data
		if (dataUser.hasData(src)) {
			udataOld = dataUser.access(src);
			udataCur = jQuery.extend({}, udataOld);

			dataUser.set(dest, udataCur);
		}
	}

	// Fix IE bugs, see support tests
	function fixInput(src, dest) {
		var nodeName = dest.nodeName.toLowerCase();

		// Fails to persist the checked state of a cloned checkbox or radio button.
		if (nodeName === "input" && rcheckableType.test(src.type)) {
			dest.checked = src.checked;

			// Fails to return the selected option to the default selected state when cloning options
		} else if (nodeName === "input" || nodeName === "textarea") {
			dest.defaultValue = src.defaultValue;
		}
	}

	function domManip(collection, args, callback, ignored) {

		// Flatten any nested arrays
		args = flat(args);

		var fragment,
		    first,
		    scripts,
		    hasScripts,
		    node,
		    doc,
		    i = 0,
		    l = collection.length,
		    iNoClone = l - 1,
		    value = args[0],
		    valueIsFunction = isFunction(value);

		// We can't cloneNode fragments that contain checked, in WebKit
		if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
			return collection.each(function (index) {
				var self = collection.eq(index);
				if (valueIsFunction) {
					args[0] = value.call(this, index, self.html());
				}
				domManip(self, args, callback, ignored);
			});
		}

		if (l) {
			fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
			first = fragment.firstChild;

			if (fragment.childNodes.length === 1) {
				fragment = first;
			}

			// Require either new content or an interest in ignored elements to invoke the callback
			if (first || ignored) {
				scripts = jQuery.map(getAll(fragment, "script"), disableScript);
				hasScripts = scripts.length;

				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (trac-8070).
				for (; i < l; i++) {
					node = fragment;

					if (i !== iNoClone) {
						node = jQuery.clone(node, true, true);

						// Keep references to cloned scripts for later restoration
						if (hasScripts) {

							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge(scripts, getAll(node, "script"));
						}
					}

					callback.call(collection[i], node, i);
				}

				if (hasScripts) {
					doc = scripts[scripts.length - 1].ownerDocument;

					// Re-enable scripts
					jQuery.map(scripts, restoreScript);

					// Evaluate executable scripts on first document insertion
					for (i = 0; i < hasScripts; i++) {
						node = scripts[i];
						if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {

							if (node.src && (node.type || "").toLowerCase() !== "module") {

								// Optional AJAX dependency, but won't run scripts if not present
								if (jQuery._evalUrl && !node.noModule) {
									jQuery._evalUrl(node.src, {
										nonce: node.nonce || node.getAttribute("nonce")
									}, doc);
								}
							} else {

								// Unwrap a CDATA section containing script contents. This shouldn't be
								// needed as in XML documents they're already not visible when
								// inspecting element contents and in HTML documents they have no
								// meaning but we're preserving that logic for backwards compatibility.
								// This will be removed completely in 4.0. See gh-4904.
								DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
							}
						}
					}
				}
			}
		}

		return collection;
	}

	function _remove(elem, selector, keepData) {
		var node,
		    nodes = selector ? jQuery.filter(selector, elem) : elem,
		    i = 0;

		for (; (node = nodes[i]) != null; i++) {
			if (!keepData && node.nodeType === 1) {
				jQuery.cleanData(getAll(node));
			}

			if (node.parentNode) {
				if (keepData && isAttached(node)) {
					setGlobalEval(getAll(node, "script"));
				}
				node.parentNode.removeChild(node);
			}
		}

		return elem;
	}

	jQuery.extend({
		htmlPrefilter: function htmlPrefilter(html) {
			return html;
		},

		clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
			var i,
			    l,
			    srcElements,
			    destElements,
			    clone = elem.cloneNode(true),
			    inPage = isAttached(elem);

			// Fix IE cloning issues
			if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {

				// We eschew jQuery#find here for performance reasons:
				// https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll(clone);
				srcElements = getAll(elem);

				for (i = 0, l = srcElements.length; i < l; i++) {
					fixInput(srcElements[i], destElements[i]);
				}
			}

			// Copy the events from the original to the clone
			if (dataAndEvents) {
				if (deepDataAndEvents) {
					srcElements = srcElements || getAll(elem);
					destElements = destElements || getAll(clone);

					for (i = 0, l = srcElements.length; i < l; i++) {
						cloneCopyEvent(srcElements[i], destElements[i]);
					}
				} else {
					cloneCopyEvent(elem, clone);
				}
			}

			// Preserve script evaluation history
			destElements = getAll(clone, "script");
			if (destElements.length > 0) {
				setGlobalEval(destElements, !inPage && getAll(elem, "script"));
			}

			// Return the cloned set
			return clone;
		},

		cleanData: function cleanData(elems) {
			var data,
			    elem,
			    type,
			    special = jQuery.event.special,
			    i = 0;

			for (; (elem = elems[i]) !== undefined; i++) {
				if (acceptData(elem)) {
					if (data = elem[dataPriv.expando]) {
						if (data.events) {
							for (type in data.events) {
								if (special[type]) {
									jQuery.event.remove(elem, type);

									// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent(elem, type, data.handle);
								}
							}
						}

						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[dataPriv.expando] = undefined;
					}
					if (elem[dataUser.expando]) {

						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[dataUser.expando] = undefined;
					}
				}
			}
		}
	});

	jQuery.fn.extend({
		detach: function detach(selector) {
			return _remove(this, selector, true);
		},

		remove: function remove(selector) {
			return _remove(this, selector);
		},

		text: function text(value) {
			return access(this, function (value) {
				return value === undefined ? jQuery.text(this) : this.empty().each(function () {
					if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
						this.textContent = value;
					}
				});
			}, null, value, arguments.length);
		},

		append: function append() {
			return domManip(this, arguments, function (elem) {
				if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
					var target = manipulationTarget(this, elem);
					target.appendChild(elem);
				}
			});
		},

		prepend: function prepend() {
			return domManip(this, arguments, function (elem) {
				if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
					var target = manipulationTarget(this, elem);
					target.insertBefore(elem, target.firstChild);
				}
			});
		},

		before: function before() {
			return domManip(this, arguments, function (elem) {
				if (this.parentNode) {
					this.parentNode.insertBefore(elem, this);
				}
			});
		},

		after: function after() {
			return domManip(this, arguments, function (elem) {
				if (this.parentNode) {
					this.parentNode.insertBefore(elem, this.nextSibling);
				}
			});
		},

		empty: function empty() {
			var elem,
			    i = 0;

			for (; (elem = this[i]) != null; i++) {
				if (elem.nodeType === 1) {

					// Prevent memory leaks
					jQuery.cleanData(getAll(elem, false));

					// Remove any remaining nodes
					elem.textContent = "";
				}
			}

			return this;
		},

		clone: function clone(dataAndEvents, deepDataAndEvents) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

			return this.map(function () {
				return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
			});
		},

		html: function html(value) {
			return access(this, function (value) {
				var elem = this[0] || {},
				    i = 0,
				    l = this.length;

				if (value === undefined && elem.nodeType === 1) {
					return elem.innerHTML;
				}

				// See if we can take a shortcut and just use innerHTML
				if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {

					value = jQuery.htmlPrefilter(value);

					try {
						for (; i < l; i++) {
							elem = this[i] || {};

							// Remove element nodes and prevent memory leaks
							if (elem.nodeType === 1) {
								jQuery.cleanData(getAll(elem, false));
								elem.innerHTML = value;
							}
						}

						elem = 0;

						// If using innerHTML throws an exception, use the fallback method
					} catch (e) {}
				}

				if (elem) {
					this.empty().append(value);
				}
			}, null, value, arguments.length);
		},

		replaceWith: function replaceWith() {
			var ignored = [];

			// Make the changes, replacing each non-ignored context element with the new content
			return domManip(this, arguments, function (elem) {
				var parent = this.parentNode;

				if (jQuery.inArray(this, ignored) < 0) {
					jQuery.cleanData(getAll(this));
					if (parent) {
						parent.replaceChild(elem, this);
					}
				}

				// Force callback invocation
			}, ignored);
		}
	});

	jQuery.each({
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function (name, original) {
		jQuery.fn[name] = function (selector) {
			var elems,
			    ret = [],
			    insert = jQuery(selector),
			    last = insert.length - 1,
			    i = 0;

			for (; i <= last; i++) {
				elems = i === last ? this : this.clone(true);
				jQuery(insert[i])[original](elems);

				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply(ret, elems.get());
			}

			return this.pushStack(ret);
		};
	});
	var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");

	var rcustomProp = /^--/;

	var getStyles = function getStyles(elem) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if (!view || !view.opener) {
			view = window;
		}

		return view.getComputedStyle(elem);
	};

	var swap = function swap(elem, options, callback) {
		var ret,
		    name,
		    old = {};

		// Remember the old values, and insert the new ones
		for (name in options) {
			old[name] = elem.style[name];
			elem.style[name] = options[name];
		}

		ret = callback.call(elem);

		// Revert the old values
		for (name in options) {
			elem.style[name] = old[name];
		}

		return ret;
	};

	var rboxStyle = new RegExp(cssExpand.join("|"), "i");

	(function () {

		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {

			// This is a singleton, we need to execute it only once
			if (!div) {
				return;
			}

			container.style.cssText = "position:absolute;left:-11111px;width:60px;" + "margin-top:1px;padding:0;border:0";
			div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;" + "margin:auto;border:1px;padding:1px;" + "width:60%;top:1%";
			documentElement.appendChild(container).appendChild(div);

			var divStyle = window.getComputedStyle(div);
			pixelPositionVal = divStyle.top !== "1%";

			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;

			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;

			documentElement.removeChild(container);

			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}

		function roundPixelMeasures(measure) {
			return Math.round(parseFloat(measure));
		}

		var pixelPositionVal,
		    boxSizingReliableVal,
		    scrollboxSizeVal,
		    pixelBoxStylesVal,
		    reliableTrDimensionsVal,
		    reliableMarginLeftVal,
		    container = document.createElement("div"),
		    div = document.createElement("div");

		// Finish early in limited (non-browser) environments
		if (!div.style) {
			return;
		}

		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (trac-8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode(true).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";

		jQuery.extend(support, {
			boxSizingReliable: function boxSizingReliable() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function pixelBoxStyles() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function pixelPosition() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function reliableMarginLeft() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function scrollboxSize() {
				computeStyleTests();
				return scrollboxSizeVal;
			},

			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function reliableTrDimensions() {
				var table, tr, trChild, trStyle;
				if (reliableTrDimensionsVal == null) {
					table = document.createElement("table");
					tr = document.createElement("tr");
					trChild = document.createElement("div");

					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "box-sizing:content-box;border:1px solid";

					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";

					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is `display: block`
					// gets around this issue.
					trChild.style.display = "block";

					documentElement.appendChild(table).appendChild(tr).appendChild(trChild);

					trStyle = window.getComputedStyle(tr);
					reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;

					documentElement.removeChild(table);
				}
				return reliableTrDimensionsVal;
			}
		});
	})();

	function curCSS(elem, name, computed) {
		var width,
		    minWidth,
		    maxWidth,
		    ret,
		    isCustomProp = rcustomProp.test(name),


		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

		computed = computed || getStyles(elem);

		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, trac-12537)
		//   .css('--customProperty) (gh-3144)
		if (computed) {

			// Support: IE <=9 - 11+
			// IE only supports `"float"` in `getPropertyValue`; in computed styles
			// it's only available as `"cssFloat"`. We no longer modify properties
			// sent to `.css()` apart from camelCasing, so we need to check both.
			// Normally, this would create difference in behavior: if
			// `getPropertyValue` returns an empty string, the value returned
			// by `.css()` would be `undefined`. This is usually the case for
			// disconnected elements. However, in IE even disconnected elements
			// with no styles return `"none"` for `getPropertyValue( "float" )`
			ret = computed.getPropertyValue(name) || computed[name];

			if (isCustomProp && ret) {

				// Support: Firefox 105+, Chrome <=105+
				// Spec requires trimming whitespace for custom properties (gh-4926).
				// Firefox only trims leading whitespace. Chrome just collapses
				// both leading & trailing whitespace to a single space.
				//
				// Fall back to `undefined` if empty string returned.
				// This collapses a missing definition with property defined
				// and set to an empty string but there's no standard API
				// allowing us to differentiate them without a performance penalty
				// and returning `undefined` aligns with older jQuery.
				//
				// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
				// as whitespace while CSS does not, but this is not a problem
				// because CSS preprocessing replaces them with U+000A LINE FEED
				// (which *is* CSS whitespace)
				// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
				ret = ret.replace(rtrimCSS, "$1") || undefined;
			}

			if (ret === "" && !isAttached(elem)) {
				ret = jQuery.style(elem, name);
			}

			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {

				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;

				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;

				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}

		return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" : ret;
	}

	function addGetHookIf(conditionFn, hookFn) {

		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function get() {
				if (conditionFn()) {

					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}

				// Hook needed; redefine it so that the support test is not executed again.
				return (this.get = hookFn).apply(this, arguments);
			}
		};
	}

	var cssPrefixes = ["Webkit", "Moz", "ms"],
	    emptyStyle = document.createElement("div").style,
	    vendorProps = {};

	// Return a vendor-prefixed property or undefined
	function vendorPropName(name) {

		// Check for vendor prefixed names
		var capName = name[0].toUpperCase() + name.slice(1),
		    i = cssPrefixes.length;

		while (i--) {
			name = cssPrefixes[i] + capName;
			if (name in emptyStyle) {
				return name;
			}
		}
	}

	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName(name) {
		var final = jQuery.cssProps[name] || vendorProps[name];

		if (final) {
			return final;
		}
		if (name in emptyStyle) {
			return name;
		}
		return vendorProps[name] = vendorPropName(name) || name;
	}

	var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	    cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	    cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

	function setPositiveNumber(_elem, value, subtract) {

		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec(value);
		return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
	}

	function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
		var i = dimension === "width" ? 1 : 0,
		    extra = 0,
		    delta = 0,
		    marginDelta = 0;

		// Adjustment may not be necessary
		if (box === (isBorderBox ? "border" : "content")) {
			return 0;
		}

		for (; i < 4; i += 2) {

			// Both box models exclude margin
			// Count margin delta separately to only add it after scroll gutter adjustment.
			// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
			if (box === "margin") {
				marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
			}

			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if (!isBorderBox) {

				// Add padding
				delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);

				// For "border" or "margin", add border
				if (box !== "padding") {
					delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);

					// But still keep track of it otherwise
				} else {
					extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
				}

				// If we get here with a border-box (content + padding + border), we're seeking "content" or
				// "padding" or "margin"
			} else {

				// For "content", subtract padding
				if (box === "content") {
					delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
				}

				// For "content" or "padding", subtract border
				if (box !== "margin") {
					delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
				}
			}
		}

		// Account for positive content-box scroll gutter when requested by providing computedVal
		if (!isBorderBox && computedVal >= 0) {

			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5

			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			)) || 0;
		}

		return delta + marginDelta;
	}

	function getWidthOrHeight(elem, dimension, extra) {

		// Start with computed style
		var styles = getStyles(elem),


		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		    isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
		    valueIsBorderBox = isBorderBox,
		    val = curCSS(elem, dimension, styles),
		    offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);

		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if (rnumnonpx.test(val)) {
			if (!extra) {
				return val;
			}
			val = "auto";
		}

		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ((!support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName(elem, "tr") ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") &&

		// Make sure the element is visible & connected
		elem.getClientRects().length) {

			isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";

			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if (valueIsBorderBox) {
				val = elem[offsetProp];
			}
		}

		// Normalize "" and auto
		val = parseFloat(val) || 0;

		// Adjust for the element's box model
		return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles,

		// Provide the current computed size to request scroll gutter calculation (gh-3589)
		val) + "px";
	}

	jQuery.extend({

		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function get(elem, computed) {
					if (computed) {

						// We should always get a number back from opacity
						var ret = curCSS(elem, "opacity");
						return ret === "" ? "1" : ret;
					}
				}
			}
		},

		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			animationIterationCount: true,
			aspectRatio: true,
			borderImageSlice: true,
			columnCount: true,
			flexGrow: true,
			flexShrink: true,
			fontWeight: true,
			gridArea: true,
			gridColumn: true,
			gridColumnEnd: true,
			gridColumnStart: true,
			gridRow: true,
			gridRowEnd: true,
			gridRowStart: true,
			lineHeight: true,
			opacity: true,
			order: true,
			orphans: true,
			scale: true,
			widows: true,
			zIndex: true,
			zoom: true,

			// SVG-related
			fillOpacity: true,
			floodOpacity: true,
			stopOpacity: true,
			strokeMiterlimit: true,
			strokeOpacity: true
		},

		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},

		// Get and set the style property on a DOM Node
		style: function style(elem, name, value, extra) {

			// Don't set styles on text and comment nodes
			if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
				return;
			}

			// Make sure that we're working with the right name
			var ret,
			    type,
			    hooks,
			    origName = camelCase(name),
			    isCustomProp = rcustomProp.test(name),
			    style = elem.style;

			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if (!isCustomProp) {
				name = finalPropName(origName);
			}

			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

			// Check if we're setting a value
			if (value !== undefined) {
				type = typeof value === "undefined" ? "undefined" : _typeof(value);

				// Convert "+=" or "-=" to relative numbers (trac-7345)
				if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
					value = adjustCSS(elem, name, ret);

					// Fixes bug trac-9237
					type = "number";
				}

				// Make sure that null and NaN values aren't set (trac-7116)
				if (value == null || value !== value) {
					return;
				}

				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if (type === "number" && !isCustomProp) {
					value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
				}

				// background-* props affect original clone's values
				if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
					style[name] = "inherit";
				}

				// If a hook was provided, use that value, otherwise just set the specified value
				if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {

					if (isCustomProp) {
						style.setProperty(name, value);
					} else {
						style[name] = value;
					}
				}
			} else {

				// If a hook was provided get the non-computed value from there
				if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {

					return ret;
				}

				// Otherwise just get the value from the style object
				return style[name];
			}
		},

		css: function css(elem, name, extra, styles) {
			var val,
			    num,
			    hooks,
			    origName = camelCase(name),
			    isCustomProp = rcustomProp.test(name);

			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if (!isCustomProp) {
				name = finalPropName(origName);
			}

			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

			// If a hook was provided get the computed value from there
			if (hooks && "get" in hooks) {
				val = hooks.get(elem, true, extra);
			}

			// Otherwise, if a way to get the computed value exists, use that
			if (val === undefined) {
				val = curCSS(elem, name, styles);
			}

			// Convert "normal" to computed value
			if (val === "normal" && name in cssNormalTransform) {
				val = cssNormalTransform[name];
			}

			// Make numeric if forced or a qualifier was provided and val looks numeric
			if (extra === "" || extra) {
				num = parseFloat(val);
				return extra === true || isFinite(num) ? num || 0 : val;
			}

			return val;
		}
	});

	jQuery.each(["height", "width"], function (_i, dimension) {
		jQuery.cssHooks[dimension] = {
			get: function get(elem, computed, extra) {
				if (computed) {

					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test(jQuery.css(elem, "display")) && (

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function () {
						return getWidthOrHeight(elem, dimension, extra);
					}) : getWidthOrHeight(elem, dimension, extra);
				}
			},

			set: function set(elem, value, extra) {
				var matches,
				    styles = getStyles(elem),


				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute",


				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				    isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
				    subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;

				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if (isBorderBox && scrollboxSizeBuggy) {
					subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
				}

				// Convert to pixels if value adjustment is needed
				if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {

					elem.style[dimension] = value;
					value = jQuery.css(elem, dimension);
				}

				return setPositiveNumber(elem, value, subtract);
			}
		};
	});

	jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function (elem, computed) {
		if (computed) {
			return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, { marginLeft: 0 }, function () {
				return elem.getBoundingClientRect().left;
			})) + "px";
		}
	});

	// These hooks are used by animate to expand properties
	jQuery.each({
		margin: "",
		padding: "",
		border: "Width"
	}, function (prefix, suffix) {
		jQuery.cssHooks[prefix + suffix] = {
			expand: function expand(value) {
				var i = 0,
				    expanded = {},


				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split(" ") : [value];

				for (; i < 4; i++) {
					expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
				}

				return expanded;
			}
		};

		if (prefix !== "margin") {
			jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
		}
	});

	jQuery.fn.extend({
		css: function css(name, value) {
			return access(this, function (elem, name, value) {
				var styles,
				    len,
				    map = {},
				    i = 0;

				if (Array.isArray(name)) {
					styles = getStyles(elem);
					len = name.length;

					for (; i < len; i++) {
						map[name[i]] = jQuery.css(elem, name[i], false, styles);
					}

					return map;
				}

				return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
			}, name, value, arguments.length > 1);
		}
	});

	function Tween(elem, options, prop, end, easing) {
		return new Tween.prototype.init(elem, options, prop, end, easing);
	}
	jQuery.Tween = Tween;

	Tween.prototype = {
		constructor: Tween,
		init: function init(elem, options, prop, end, easing, unit) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
		},
		cur: function cur() {
			var hooks = Tween.propHooks[this.prop];

			return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
		},
		run: function run(percent) {
			var eased,
			    hooks = Tween.propHooks[this.prop];

			if (this.options.duration) {
				this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
			} else {
				this.pos = eased = percent;
			}
			this.now = (this.end - this.start) * eased + this.start;

			if (this.options.step) {
				this.options.step.call(this.elem, this.now, this);
			}

			if (hooks && hooks.set) {
				hooks.set(this);
			} else {
				Tween.propHooks._default.set(this);
			}
			return this;
		}
	};

	Tween.prototype.init.prototype = Tween.prototype;

	Tween.propHooks = {
		_default: {
			get: function get(tween) {
				var result;

				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
					return tween.elem[tween.prop];
				}

				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css(tween.elem, tween.prop, "");

				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function set(tween) {

				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if (jQuery.fx.step[tween.prop]) {
					jQuery.fx.step[tween.prop](tween);
				} else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) {
					jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
				} else {
					tween.elem[tween.prop] = tween.now;
				}
			}
		}
	};

	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function set(tween) {
			if (tween.elem.nodeType && tween.elem.parentNode) {
				tween.elem[tween.prop] = tween.now;
			}
		}
	};

	jQuery.easing = {
		linear: function linear(p) {
			return p;
		},
		swing: function swing(p) {
			return 0.5 - Math.cos(p * Math.PI) / 2;
		},
		_default: "swing"
	};

	jQuery.fx = Tween.prototype.init;

	// Back compat <1.8 extension point
	jQuery.fx.step = {};

	var fxNow,
	    inProgress,
	    rfxtypes = /^(?:toggle|show|hide)$/,
	    rrun = /queueHooks$/;

	function schedule() {
		if (inProgress) {
			if (document.hidden === false && window.requestAnimationFrame) {
				window.requestAnimationFrame(schedule);
			} else {
				window.setTimeout(schedule, jQuery.fx.interval);
			}

			jQuery.fx.tick();
		}
	}

	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout(function () {
			fxNow = undefined;
		});
		return fxNow = Date.now();
	}

	// Generate parameters to create a standard animation
	function genFx(type, includeWidth) {
		var which,
		    i = 0,
		    attrs = { height: type };

		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for (; i < 4; i += 2 - includeWidth) {
			which = cssExpand[i];
			attrs["margin" + which] = attrs["padding" + which] = type;
		}

		if (includeWidth) {
			attrs.opacity = attrs.width = type;
		}

		return attrs;
	}

	function createTween(value, prop, animation) {
		var tween,
		    collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
		    index = 0,
		    length = collection.length;
		for (; index < length; index++) {
			if (tween = collection[index].call(animation, prop, value)) {

				// We're done with this property
				return tween;
			}
		}
	}

	function defaultPrefilter(elem, props, opts) {
		var prop,
		    value,
		    toggle,
		    hooks,
		    oldfire,
		    propTween,
		    restoreDisplay,
		    display,
		    isBox = "width" in props || "height" in props,
		    anim = this,
		    orig = {},
		    style = elem.style,
		    hidden = elem.nodeType && isHiddenWithinTree(elem),
		    dataShow = dataPriv.get(elem, "fxshow");

		// Queue-skipping animations hijack the fx hooks
		if (!opts.queue) {
			hooks = jQuery._queueHooks(elem, "fx");
			if (hooks.unqueued == null) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function () {
					if (!hooks.unqueued) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;

			anim.always(function () {

				// Ensure the complete handler is called before this completes
				anim.always(function () {
					hooks.unqueued--;
					if (!jQuery.queue(elem, "fx").length) {
						hooks.empty.fire();
					}
				});
			});
		}

		// Detect show/hide animations
		for (prop in props) {
			value = props[prop];
			if (rfxtypes.test(value)) {
				delete props[prop];
				toggle = toggle || value === "toggle";
				if (value === (hidden ? "hide" : "show")) {

					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if (value === "show" && dataShow && dataShow[prop] !== undefined) {
						hidden = true;

						// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
			}
		}

		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject(props);
		if (!propTween && jQuery.isEmptyObject(orig)) {
			return;
		}

		// Restrict "overflow" and "display" styles during box animations
		if (isBox && elem.nodeType === 1) {

			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [style.overflow, style.overflowX, style.overflowY];

			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if (restoreDisplay == null) {
				restoreDisplay = dataPriv.get(elem, "display");
			}
			display = jQuery.css(elem, "display");
			if (display === "none") {
				if (restoreDisplay) {
					display = restoreDisplay;
				} else {

					// Get nonempty value(s) by temporarily forcing visibility
					showHide([elem], true);
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css(elem, "display");
					showHide([elem]);
				}
			}

			// Animate inline elements as inline-block
			if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
				if (jQuery.css(elem, "float") === "none") {

					// Restore the original display value at the end of pure show/hide animations
					if (!propTween) {
						anim.done(function () {
							style.display = restoreDisplay;
						});
						if (restoreDisplay == null) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}

		if (opts.overflow) {
			style.overflow = "hidden";
			anim.always(function () {
				style.overflow = opts.overflow[0];
				style.overflowX = opts.overflow[1];
				style.overflowY = opts.overflow[2];
			});
		}

		// Implement show/hide animations
		propTween = false;
		for (prop in orig) {

			// General show/hide setup for this element animation
			if (!propTween) {
				if (dataShow) {
					if ("hidden" in dataShow) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay });
				}

				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if (toggle) {
					dataShow.hidden = !hidden;
				}

				// Show elements before animating them
				if (hidden) {
					showHide([elem], true);
				}

				/* eslint-disable no-loop-func */

				anim.done(function () {

					/* eslint-enable no-loop-func */

					// The final step of a "hide" animation is actually hiding the element
					if (!hidden) {
						showHide([elem]);
					}
					dataPriv.remove(elem, "fxshow");
					for (prop in orig) {
						jQuery.style(elem, prop, orig[prop]);
					}
				});
			}

			// Per-property setup
			propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
			if (!(prop in dataShow)) {
				dataShow[prop] = propTween.start;
				if (hidden) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}

	function propFilter(props, specialEasing) {
		var index, name, easing, value, hooks;

		// camelCase, specialEasing and expand cssHook pass
		for (index in props) {
			name = camelCase(index);
			easing = specialEasing[name];
			value = props[index];
			if (Array.isArray(value)) {
				easing = value[1];
				value = props[index] = value[0];
			}

			if (index !== name) {
				props[name] = value;
				delete props[index];
			}

			hooks = jQuery.cssHooks[name];
			if (hooks && "expand" in hooks) {
				value = hooks.expand(value);
				delete props[name];

				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for (index in value) {
					if (!(index in props)) {
						props[index] = value[index];
						specialEasing[index] = easing;
					}
				}
			} else {
				specialEasing[name] = easing;
			}
		}
	}

	function Animation(elem, properties, options) {
		var result,
		    stopped,
		    index = 0,
		    length = Animation.prefilters.length,
		    deferred = jQuery.Deferred().always(function () {

			// Don't match elem in the :animated selector
			delete tick.elem;
		}),
		    tick = function tick() {
			if (stopped) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
			    remaining = Math.max(0, animation.startTime + animation.duration - currentTime),


			// Support: Android 2.3 only
			// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
			temp = remaining / animation.duration || 0,
			    percent = 1 - temp,
			    index = 0,
			    length = animation.tweens.length;

			for (; index < length; index++) {
				animation.tweens[index].run(percent);
			}

			deferred.notifyWith(elem, [animation, percent, remaining]);

			// If there's more to do, yield
			if (percent < 1 && length) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if (!length) {
				deferred.notifyWith(elem, [animation, 1, 0]);
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith(elem, [animation]);
			return false;
		},
		    animation = deferred.promise({
			elem: elem,
			props: jQuery.extend({}, properties),
			opts: jQuery.extend(true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function createTween(prop, end) {
				var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
				animation.tweens.push(tween);
				return tween;
			},
			stop: function stop(gotoEnd) {
				var index = 0,


				// If we are going to the end, we want to run all the tweens
				// otherwise we skip this part
				length = gotoEnd ? animation.tweens.length : 0;
				if (stopped) {
					return this;
				}
				stopped = true;
				for (; index < length; index++) {
					animation.tweens[index].run(1);
				}

				// Resolve when we played the last frame; otherwise, reject
				if (gotoEnd) {
					deferred.notifyWith(elem, [animation, 1, 0]);
					deferred.resolveWith(elem, [animation, gotoEnd]);
				} else {
					deferred.rejectWith(elem, [animation, gotoEnd]);
				}
				return this;
			}
		}),
		    props = animation.props;

		propFilter(props, animation.opts.specialEasing);

		for (; index < length; index++) {
			result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
			if (result) {
				if (isFunction(result.stop)) {
					jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
				}
				return result;
			}
		}

		jQuery.map(props, createTween, animation);

		if (isFunction(animation.opts.start)) {
			animation.opts.start.call(elem, animation);
		}

		// Attach callbacks from options
		animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);

		jQuery.fx.timer(jQuery.extend(tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		}));

		return animation;
	}

	jQuery.Animation = jQuery.extend(Animation, {

		tweeners: {
			"*": [function (prop, value) {
				var tween = this.createTween(prop, value);
				adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
				return tween;
			}]
		},

		tweener: function tweener(props, callback) {
			if (isFunction(props)) {
				callback = props;
				props = ["*"];
			} else {
				props = props.match(rnothtmlwhite);
			}

			var prop,
			    index = 0,
			    length = props.length;

			for (; index < length; index++) {
				prop = props[index];
				Animation.tweeners[prop] = Animation.tweeners[prop] || [];
				Animation.tweeners[prop].unshift(callback);
			}
		},

		prefilters: [defaultPrefilter],

		prefilter: function prefilter(callback, prepend) {
			if (prepend) {
				Animation.prefilters.unshift(callback);
			} else {
				Animation.prefilters.push(callback);
			}
		}
	});

	jQuery.speed = function (speed, easing, fn) {
		var opt = speed && (typeof speed === "undefined" ? "undefined" : _typeof(speed)) === "object" ? jQuery.extend({}, speed) : {
			complete: fn || !fn && easing || isFunction(speed) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction(easing) && easing
		};

		// Go to the end state if fx are off
		if (jQuery.fx.off) {
			opt.duration = 0;
		} else {
			if (typeof opt.duration !== "number") {
				if (opt.duration in jQuery.fx.speeds) {
					opt.duration = jQuery.fx.speeds[opt.duration];
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}

		// Normalize opt.queue - true/undefined/null -> "fx"
		if (opt.queue == null || opt.queue === true) {
			opt.queue = "fx";
		}

		// Queueing
		opt.old = opt.complete;

		opt.complete = function () {
			if (isFunction(opt.old)) {
				opt.old.call(this);
			}

			if (opt.queue) {
				jQuery.dequeue(this, opt.queue);
			}
		};

		return opt;
	};

	jQuery.fn.extend({
		fadeTo: function fadeTo(speed, to, easing, callback) {

			// Show any hidden elements after setting opacity to 0
			return this.filter(isHiddenWithinTree).css("opacity", 0).show()

			// Animate to the value specified
			.end().animate({ opacity: to }, speed, easing, callback);
		},
		animate: function animate(prop, speed, easing, callback) {
			var empty = jQuery.isEmptyObject(prop),
			    optall = jQuery.speed(speed, easing, callback),
			    doAnimation = function doAnimation() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation(this, jQuery.extend({}, prop), optall);

				// Empty animations, or finishing resolves immediately
				if (empty || dataPriv.get(this, "finish")) {
					anim.stop(true);
				}
			};

			doAnimation.finish = doAnimation;

			return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
		},
		stop: function stop(type, clearQueue, gotoEnd) {
			var stopQueue = function stopQueue(hooks) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop(gotoEnd);
			};

			if (typeof type !== "string") {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if (clearQueue) {
				this.queue(type || "fx", []);
			}

			return this.each(function () {
				var dequeue = true,
				    index = type != null && type + "queueHooks",
				    timers = jQuery.timers,
				    data = dataPriv.get(this);

				if (index) {
					if (data[index] && data[index].stop) {
						stopQueue(data[index]);
					}
				} else {
					for (index in data) {
						if (data[index] && data[index].stop && rrun.test(index)) {
							stopQueue(data[index]);
						}
					}
				}

				for (index = timers.length; index--;) {
					if (timers[index].elem === this && (type == null || timers[index].queue === type)) {

						timers[index].anim.stop(gotoEnd);
						dequeue = false;
						timers.splice(index, 1);
					}
				}

				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if (dequeue || !gotoEnd) {
					jQuery.dequeue(this, type);
				}
			});
		},
		finish: function finish(type) {
			if (type !== false) {
				type = type || "fx";
			}
			return this.each(function () {
				var index,
				    data = dataPriv.get(this),
				    queue = data[type + "queue"],
				    hooks = data[type + "queueHooks"],
				    timers = jQuery.timers,
				    length = queue ? queue.length : 0;

				// Enable finishing flag on private data
				data.finish = true;

				// Empty the queue first
				jQuery.queue(this, type, []);

				if (hooks && hooks.stop) {
					hooks.stop.call(this, true);
				}

				// Look for any active animations, and finish them
				for (index = timers.length; index--;) {
					if (timers[index].elem === this && timers[index].queue === type) {
						timers[index].anim.stop(true);
						timers.splice(index, 1);
					}
				}

				// Look for any animations in the old queue and finish them
				for (index = 0; index < length; index++) {
					if (queue[index] && queue[index].finish) {
						queue[index].finish.call(this);
					}
				}

				// Turn off finishing flag
				delete data.finish;
			});
		}
	});

	jQuery.each(["toggle", "show", "hide"], function (_i, name) {
		var cssFn = jQuery.fn[name];
		jQuery.fn[name] = function (speed, easing, callback) {
			return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
		};
	});

	// Generate shortcuts for custom animations
	jQuery.each({
		slideDown: genFx("show"),
		slideUp: genFx("hide"),
		slideToggle: genFx("toggle"),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function (name, props) {
		jQuery.fn[name] = function (speed, easing, callback) {
			return this.animate(props, speed, easing, callback);
		};
	});

	jQuery.timers = [];
	jQuery.fx.tick = function () {
		var timer,
		    i = 0,
		    timers = jQuery.timers;

		fxNow = Date.now();

		for (; i < timers.length; i++) {
			timer = timers[i];

			// Run the timer and safely remove it when done (allowing for external removal)
			if (!timer() && timers[i] === timer) {
				timers.splice(i--, 1);
			}
		}

		if (!timers.length) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};

	jQuery.fx.timer = function (timer) {
		jQuery.timers.push(timer);
		jQuery.fx.start();
	};

	jQuery.fx.interval = 13;
	jQuery.fx.start = function () {
		if (inProgress) {
			return;
		}

		inProgress = true;
		schedule();
	};

	jQuery.fx.stop = function () {
		inProgress = null;
	};

	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,

		// Default speed
		_default: 400
	};

	// Based off of the plugin by Clint Helfers, with permission.
	jQuery.fn.delay = function (time, type) {
		time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
		type = type || "fx";

		return this.queue(type, function (next, hooks) {
			var timeout = window.setTimeout(next, time);
			hooks.stop = function () {
				window.clearTimeout(timeout);
			};
		});
	};

	(function () {
		var input = document.createElement("input"),
		    select = document.createElement("select"),
		    opt = select.appendChild(document.createElement("option"));

		input.type = "checkbox";

		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";

		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;

		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement("input");
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	})();

	var boolHook,
	    attrHandle = jQuery.expr.attrHandle;

	jQuery.fn.extend({
		attr: function attr(name, value) {
			return access(this, jQuery.attr, name, value, arguments.length > 1);
		},

		removeAttr: function removeAttr(name) {
			return this.each(function () {
				jQuery.removeAttr(this, name);
			});
		}
	});

	jQuery.extend({
		attr: function attr(elem, name, value) {
			var ret,
			    hooks,
			    nType = elem.nodeType;

			// Don't get/set attributes on text, comment and attribute nodes
			if (nType === 3 || nType === 8 || nType === 2) {
				return;
			}

			// Fallback to prop when attributes are not supported
			if (typeof elem.getAttribute === "undefined") {
				return jQuery.prop(elem, name, value);
			}

			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
				hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
			}

			if (value !== undefined) {
				if (value === null) {
					jQuery.removeAttr(elem, name);
					return;
				}

				if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
					return ret;
				}

				elem.setAttribute(name, value + "");
				return value;
			}

			if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
				return ret;
			}

			ret = jQuery.find.attr(elem, name);

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},

		attrHooks: {
			type: {
				set: function set(elem, value) {
					if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
						var val = elem.value;
						elem.setAttribute("type", value);
						if (val) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},

		removeAttr: function removeAttr(elem, value) {
			var name,
			    i = 0,


			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match(rnothtmlwhite);

			if (attrNames && elem.nodeType === 1) {
				while (name = attrNames[i++]) {
					elem.removeAttribute(name);
				}
			}
		}
	});

	// Hooks for boolean attributes
	boolHook = {
		set: function set(elem, value, name) {
			if (value === false) {

				// Remove boolean attributes when set to false
				jQuery.removeAttr(elem, name);
			} else {
				elem.setAttribute(name, name);
			}
			return name;
		}
	};

	jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (_i, name) {
		var getter = attrHandle[name] || jQuery.find.attr;

		attrHandle[name] = function (elem, name, isXML) {
			var ret,
			    handle,
			    lowercaseName = name.toLowerCase();

			if (!isXML) {

				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[lowercaseName];
				attrHandle[lowercaseName] = ret;
				ret = getter(elem, name, isXML) != null ? lowercaseName : null;
				attrHandle[lowercaseName] = handle;
			}
			return ret;
		};
	});

	var rfocusable = /^(?:input|select|textarea|button)$/i,
	    rclickable = /^(?:a|area)$/i;

	jQuery.fn.extend({
		prop: function prop(name, value) {
			return access(this, jQuery.prop, name, value, arguments.length > 1);
		},

		removeProp: function removeProp(name) {
			return this.each(function () {
				delete this[jQuery.propFix[name] || name];
			});
		}
	});

	jQuery.extend({
		prop: function prop(elem, name, value) {
			var ret,
			    hooks,
			    nType = elem.nodeType;

			// Don't get/set properties on text, comment and attribute nodes
			if (nType === 3 || nType === 8 || nType === 2) {
				return;
			}

			if (nType !== 1 || !jQuery.isXMLDoc(elem)) {

				// Fix name and attach hooks
				name = jQuery.propFix[name] || name;
				hooks = jQuery.propHooks[name];
			}

			if (value !== undefined) {
				if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
					return ret;
				}

				return elem[name] = value;
			}

			if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
				return ret;
			}

			return elem[name];
		},

		propHooks: {
			tabIndex: {
				get: function get(elem) {

					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// Use proper attribute retrieval (trac-12072)
					var tabindex = jQuery.find.attr(elem, "tabindex");

					if (tabindex) {
						return parseInt(tabindex, 10);
					}

					if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
						return 0;
					}

					return -1;
				}
			}
		},

		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	});

	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if (!support.optSelected) {
		jQuery.propHooks.selected = {
			get: function get(elem) {

				/* eslint no-unused-expressions: "off" */

				var parent = elem.parentNode;
				if (parent && parent.parentNode) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function set(elem) {

				/* eslint no-unused-expressions: "off" */

				var parent = elem.parentNode;
				if (parent) {
					parent.selectedIndex;

					if (parent.parentNode) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}

	jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
		jQuery.propFix[this.toLowerCase()] = this;
	});

	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse(value) {
		var tokens = value.match(rnothtmlwhite) || [];
		return tokens.join(" ");
	}

	function getClass(elem) {
		return elem.getAttribute && elem.getAttribute("class") || "";
	}

	function classesToArray(value) {
		if (Array.isArray(value)) {
			return value;
		}
		if (typeof value === "string") {
			return value.match(rnothtmlwhite) || [];
		}
		return [];
	}

	jQuery.fn.extend({
		addClass: function addClass(value) {
			var classNames, cur, curValue, className, i, finalValue;

			if (isFunction(value)) {
				return this.each(function (j) {
					jQuery(this).addClass(value.call(this, j, getClass(this)));
				});
			}

			classNames = classesToArray(value);

			if (classNames.length) {
				return this.each(function () {
					curValue = getClass(this);
					cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";

					if (cur) {
						for (i = 0; i < classNames.length; i++) {
							className = classNames[i];
							if (cur.indexOf(" " + className + " ") < 0) {
								cur += className + " ";
							}
						}

						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse(cur);
						if (curValue !== finalValue) {
							this.setAttribute("class", finalValue);
						}
					}
				});
			}

			return this;
		},

		removeClass: function removeClass(value) {
			var classNames, cur, curValue, className, i, finalValue;

			if (isFunction(value)) {
				return this.each(function (j) {
					jQuery(this).removeClass(value.call(this, j, getClass(this)));
				});
			}

			if (!arguments.length) {
				return this.attr("class", "");
			}

			classNames = classesToArray(value);

			if (classNames.length) {
				return this.each(function () {
					curValue = getClass(this);

					// This expression is here for better compressibility (see addClass)
					cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";

					if (cur) {
						for (i = 0; i < classNames.length; i++) {
							className = classNames[i];

							// Remove *all* instances
							while (cur.indexOf(" " + className + " ") > -1) {
								cur = cur.replace(" " + className + " ", " ");
							}
						}

						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse(cur);
						if (curValue !== finalValue) {
							this.setAttribute("class", finalValue);
						}
					}
				});
			}

			return this;
		},

		toggleClass: function toggleClass(value, stateVal) {
			var classNames,
			    className,
			    i,
			    self,
			    type = typeof value === "undefined" ? "undefined" : _typeof(value),
			    isValidValue = type === "string" || Array.isArray(value);

			if (isFunction(value)) {
				return this.each(function (i) {
					jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
				});
			}

			if (typeof stateVal === "boolean" && isValidValue) {
				return stateVal ? this.addClass(value) : this.removeClass(value);
			}

			classNames = classesToArray(value);

			return this.each(function () {
				if (isValidValue) {

					// Toggle individual class names
					self = jQuery(this);

					for (i = 0; i < classNames.length; i++) {
						className = classNames[i];

						// Check each className given, space separated list
						if (self.hasClass(className)) {
							self.removeClass(className);
						} else {
							self.addClass(className);
						}
					}

					// Toggle whole class name
				} else if (value === undefined || type === "boolean") {
					className = getClass(this);
					if (className) {

						// Store className if set
						dataPriv.set(this, "__className__", className);
					}

					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if (this.setAttribute) {
						this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
					}
				}
			});
		},

		hasClass: function hasClass(selector) {
			var className,
			    elem,
			    i = 0;

			className = " " + selector + " ";
			while (elem = this[i++]) {
				if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
					return true;
				}
			}

			return false;
		}
	});

	var rreturn = /\r/g;

	jQuery.fn.extend({
		val: function val(value) {
			var hooks,
			    ret,
			    valueIsFunction,
			    elem = this[0];

			if (!arguments.length) {
				if (elem) {
					hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];

					if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
						return ret;
					}

					ret = elem.value;

					// Handle most common string cases
					if (typeof ret === "string") {
						return ret.replace(rreturn, "");
					}

					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}

				return;
			}

			valueIsFunction = isFunction(value);

			return this.each(function (i) {
				var val;

				if (this.nodeType !== 1) {
					return;
				}

				if (valueIsFunction) {
					val = value.call(this, i, jQuery(this).val());
				} else {
					val = value;
				}

				// Treat null/undefined as ""; convert numbers to string
				if (val == null) {
					val = "";
				} else if (typeof val === "number") {
					val += "";
				} else if (Array.isArray(val)) {
					val = jQuery.map(val, function (value) {
						return value == null ? "" : value + "";
					});
				}

				hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];

				// If set returns undefined, fall back to normal setting
				if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
					this.value = val;
				}
			});
		}
	});

	jQuery.extend({
		valHooks: {
			option: {
				get: function get(elem) {

					var val = jQuery.find.attr(elem, "value");
					return val != null ? val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse(jQuery.text(elem));
				}
			},
			select: {
				get: function get(elem) {
					var value,
					    option,
					    i,
					    options = elem.options,
					    index = elem.selectedIndex,
					    one = elem.type === "select-one",
					    values = one ? null : [],
					    max = one ? index + 1 : options.length;

					if (index < 0) {
						i = max;
					} else {
						i = one ? index : 0;
					}

					// Loop through all the selected options
					for (; i < max; i++) {
						option = options[i];

						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (trac-2551)
						if ((option.selected || i === index) &&

						// Don't return options that are disabled or in a disabled optgroup
						!option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {

							// Get the specific value for the option
							value = jQuery(option).val();

							// We don't need an array for one selects
							if (one) {
								return value;
							}

							// Multi-Selects return an array
							values.push(value);
						}
					}

					return values;
				},

				set: function set(elem, value) {
					var optionSet,
					    option,
					    options = elem.options,
					    values = jQuery.makeArray(value),
					    i = options.length;

					while (i--) {
						option = options[i];

						/* eslint-disable no-cond-assign */

						if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
							optionSet = true;
						}

						/* eslint-enable no-cond-assign */
					}

					// Force browsers to behave consistently when non-matching value is set
					if (!optionSet) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	});

	// Radios and checkboxes getter/setter
	jQuery.each(["radio", "checkbox"], function () {
		jQuery.valHooks[this] = {
			set: function set(elem, value) {
				if (Array.isArray(value)) {
					return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
				}
			}
		};
		if (!support.checkOn) {
			jQuery.valHooks[this].get = function (elem) {
				return elem.getAttribute("value") === null ? "on" : elem.value;
			};
		}
	});

	// Return jQuery for attributes-only inclusion
	var location = window.location;

	var nonce = { guid: Date.now() };

	var rquery = /\?/;

	// Cross-browser xml parsing
	jQuery.parseXML = function (data) {
		var xml, parserErrorElem;
		if (!data || typeof data !== "string") {
			return null;
		}

		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = new window.DOMParser().parseFromString(data, "text/xml");
		} catch (e) {}

		parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
		if (!xml || parserErrorElem) {
			jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function (el) {
				return el.textContent;
			}).join("\n") : data));
		}
		return xml;
	};

	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	    stopPropagationCallback = function stopPropagationCallback(e) {
		e.stopPropagation();
	};

	jQuery.extend(jQuery.event, {

		trigger: function trigger(event, data, elem, onlyHandlers) {

			var i,
			    cur,
			    tmp,
			    bubbleType,
			    ontype,
			    handle,
			    special,
			    lastElement,
			    eventPath = [elem || document],
			    type = hasOwn.call(event, "type") ? event.type : event,
			    namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];

			cur = lastElement = tmp = elem = elem || document;

			// Don't do events on text and comment nodes
			if (elem.nodeType === 3 || elem.nodeType === 8) {
				return;
			}

			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if (rfocusMorph.test(type + jQuery.event.triggered)) {
				return;
			}

			if (type.indexOf(".") > -1) {

				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split(".");
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf(":") < 0 && "on" + type;

			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[jQuery.expando] ? event : new jQuery.Event(type, (typeof event === "undefined" ? "undefined" : _typeof(event)) === "object" && event);

			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join(".");
			event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;

			// Clean up the event in case it is being reused
			event.result = undefined;
			if (!event.target) {
				event.target = elem;
			}

			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ? [event] : jQuery.makeArray(data, [event]);

			// Allow special events to draw outside the lines
			special = jQuery.event.special[type] || {};
			if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
				return;
			}

			// Determine event propagation path in advance, per W3C events spec (trac-9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
			if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {

				bubbleType = special.delegateType || type;
				if (!rfocusMorph.test(bubbleType + type)) {
					cur = cur.parentNode;
				}
				for (; cur; cur = cur.parentNode) {
					eventPath.push(cur);
					tmp = cur;
				}

				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if (tmp === (elem.ownerDocument || document)) {
					eventPath.push(tmp.defaultView || tmp.parentWindow || window);
				}
			}

			// Fire handlers on the event path
			i = 0;
			while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
				lastElement = cur;
				event.type = i > 1 ? bubbleType : special.bindType || type;

				// jQuery handler
				handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
				if (handle) {
					handle.apply(cur, data);
				}

				// Native handler
				handle = ontype && cur[ontype];
				if (handle && handle.apply && acceptData(cur)) {
					event.result = handle.apply(cur, data);
					if (event.result === false) {
						event.preventDefault();
					}
				}
			}
			event.type = type;

			// If nobody prevented the default action, do it now
			if (!onlyHandlers && !event.isDefaultPrevented()) {

				if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {

					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (trac-6170)
					if (ontype && isFunction(elem[type]) && !isWindow(elem)) {

						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ontype];

						if (tmp) {
							elem[ontype] = null;
						}

						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;

						if (event.isPropagationStopped()) {
							lastElement.addEventListener(type, stopPropagationCallback);
						}

						elem[type]();

						if (event.isPropagationStopped()) {
							lastElement.removeEventListener(type, stopPropagationCallback);
						}

						jQuery.event.triggered = undefined;

						if (tmp) {
							elem[ontype] = tmp;
						}
					}
				}
			}

			return event.result;
		},

		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function simulate(type, elem, event) {
			var e = jQuery.extend(new jQuery.Event(), event, {
				type: type,
				isSimulated: true
			});

			jQuery.event.trigger(e, null, elem);
		}

	});

	jQuery.fn.extend({

		trigger: function trigger(type, data) {
			return this.each(function () {
				jQuery.event.trigger(type, data, this);
			});
		},
		triggerHandler: function triggerHandler(type, data) {
			var elem = this[0];
			if (elem) {
				return jQuery.event.trigger(type, data, elem, true);
			}
		}
	});

	var rbracket = /\[\]$/,
	    rCRLF = /\r?\n/g,
	    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	    rsubmittable = /^(?:input|select|textarea|keygen)/i;

	function buildParams(prefix, obj, traditional, add) {
		var name;

		if (Array.isArray(obj)) {

			// Serialize array item.
			jQuery.each(obj, function (i, v) {
				if (traditional || rbracket.test(prefix)) {

					// Treat each array item as a scalar.
					add(prefix, v);
				} else {

					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(prefix + "[" + ((typeof v === "undefined" ? "undefined" : _typeof(v)) === "object" && v != null ? i : "") + "]", v, traditional, add);
				}
			});
		} else if (!traditional && toType(obj) === "object") {

			// Serialize object item.
			for (name in obj) {
				buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
			}
		} else {

			// Serialize scalar item.
			add(prefix, obj);
		}
	}

	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function (a, traditional) {
		var prefix,
		    s = [],
		    add = function add(key, valueOrFunction) {

			// If value is a function, invoke it and use its return value
			var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;

			s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
		};

		if (a == null) {
			return "";
		}

		// If an array was passed in, assume that it is an array of form elements.
		if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {

			// Serialize the form elements
			jQuery.each(a, function () {
				add(this.name, this.value);
			});
		} else {

			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for (prefix in a) {
				buildParams(prefix, a[prefix], traditional, add);
			}
		}

		// Return the resulting serialization
		return s.join("&");
	};

	jQuery.fn.extend({
		serialize: function serialize() {
			return jQuery.param(this.serializeArray());
		},
		serializeArray: function serializeArray() {
			return this.map(function () {

				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop(this, "elements");
				return elements ? jQuery.makeArray(elements) : this;
			}).filter(function () {
				var type = this.type;

				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
			}).map(function (_i, elem) {
				var val = jQuery(this).val();

				if (val == null) {
					return null;
				}

				if (Array.isArray(val)) {
					return jQuery.map(val, function (val) {
						return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
					});
				}

				return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
			}).get();
		}
	});

	var r20 = /%20/g,
	    rhash = /#.*$/,
	    rantiCache = /([?&])_=[^&]*/,
	    rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,


	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	    rnoContent = /^(?:GET|HEAD)$/,
	    rprotocol = /^\/\//,


	/* Prefilters
  * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
  * 2) These are called:
  *    - BEFORE asking for a transport
  *    - AFTER param serialization (s.data is a string if s.processData is true)
  * 3) key is the dataType
  * 4) the catchall symbol "*" can be used
  * 5) execution will start with transport dataType and THEN continue down to "*" if needed
  */
	prefilters = {},


	/* Transports bindings
  * 1) key is the dataType
  * 2) the catchall symbol "*" can be used
  * 3) selection will start with transport dataType and THEN go to "*" if needed
  */
	transports = {},


	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat("*"),


	// Anchor tag for parsing the document origin
	originAnchor = document.createElement("a");

	originAnchor.href = location.href;

	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports(structure) {

		// dataTypeExpression is optional and defaults to "*"
		return function (dataTypeExpression, func) {

			if (typeof dataTypeExpression !== "string") {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}

			var dataType,
			    i = 0,
			    dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];

			if (isFunction(func)) {

				// For each dataType in the dataTypeExpression
				while (dataType = dataTypes[i++]) {

					// Prepend if requested
					if (dataType[0] === "+") {
						dataType = dataType.slice(1) || "*";
						(structure[dataType] = structure[dataType] || []).unshift(func);

						// Otherwise append
					} else {
						(structure[dataType] = structure[dataType] || []).push(func);
					}
				}
			}
		};
	}

	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {

		var inspected = {},
		    seekingTransport = structure === transports;

		function inspect(dataType) {
			var selected;
			inspected[dataType] = true;
			jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
				var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
				if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {

					options.dataTypes.unshift(dataTypeOrTransport);
					inspect(dataTypeOrTransport);
					return false;
				} else if (seekingTransport) {
					return !(selected = dataTypeOrTransport);
				}
			});
			return selected;
		}

		return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
	}

	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes trac-9887
	function ajaxExtend(target, src) {
		var key,
		    deep,
		    flatOptions = jQuery.ajaxSettings.flatOptions || {};

		for (key in src) {
			if (src[key] !== undefined) {
				(flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
			}
		}
		if (deep) {
			jQuery.extend(true, target, deep);
		}

		return target;
	}

	/* Handles responses to an ajax request:
  * - finds the right dataType (mediates between content-type and expected dataType)
  * - returns the corresponding response
  */
	function ajaxHandleResponses(s, jqXHR, responses) {

		var ct,
		    type,
		    finalDataType,
		    firstDataType,
		    contents = s.contents,
		    dataTypes = s.dataTypes;

		// Remove auto dataType and get content-type in the process
		while (dataTypes[0] === "*") {
			dataTypes.shift();
			if (ct === undefined) {
				ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
			}
		}

		// Check if we're dealing with a known content-type
		if (ct) {
			for (type in contents) {
				if (contents[type] && contents[type].test(ct)) {
					dataTypes.unshift(type);
					break;
				}
			}
		}

		// Check to see if we have a response for the expected dataType
		if (dataTypes[0] in responses) {
			finalDataType = dataTypes[0];
		} else {

			// Try convertible dataTypes
			for (type in responses) {
				if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
					finalDataType = type;
					break;
				}
				if (!firstDataType) {
					firstDataType = type;
				}
			}

			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}

		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if (finalDataType) {
			if (finalDataType !== dataTypes[0]) {
				dataTypes.unshift(finalDataType);
			}
			return responses[finalDataType];
		}
	}

	/* Chain conversions given the request and the original response
  * Also sets the responseXXX fields on the jqXHR instance
  */
	function ajaxConvert(s, response, jqXHR, isSuccess) {
		var conv2,
		    current,
		    conv,
		    tmp,
		    prev,
		    converters = {},


		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

		// Create converters map with lowercased keys
		if (dataTypes[1]) {
			for (conv in s.converters) {
				converters[conv.toLowerCase()] = s.converters[conv];
			}
		}

		current = dataTypes.shift();

		// Convert to each sequential dataType
		while (current) {

			if (s.responseFields[current]) {
				jqXHR[s.responseFields[current]] = response;
			}

			// Apply the dataFilter if provided
			if (!prev && isSuccess && s.dataFilter) {
				response = s.dataFilter(response, s.dataType);
			}

			prev = current;
			current = dataTypes.shift();

			if (current) {

				// There's only work to do if current dataType is non-auto
				if (current === "*") {

					current = prev;

					// Convert response if prev dataType is non-auto and differs from current
				} else if (prev !== "*" && prev !== current) {

					// Seek a direct converter
					conv = converters[prev + " " + current] || converters["* " + current];

					// If none found, seek a pair
					if (!conv) {
						for (conv2 in converters) {

							// If conv2 outputs current
							tmp = conv2.split(" ");
							if (tmp[1] === current) {

								// If prev can be converted to accepted input
								conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
								if (conv) {

									// Condense equivalence converters
									if (conv === true) {
										conv = converters[conv2];

										// Otherwise, insert the intermediate dataType
									} else if (converters[conv2] !== true) {
										current = tmp[0];
										dataTypes.unshift(tmp[1]);
									}
									break;
								}
							}
						}
					}

					// Apply converter (if not an equivalence)
					if (conv !== true) {

						// Unless errors are allowed to bubble, catch and return them
						if (conv && s.throws) {
							response = conv(response);
						} else {
							try {
								response = conv(response);
							} catch (e) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}

		return { state: "success", data: response };
	}

	jQuery.extend({

		// Counter for holding the number of active queries
		active: 0,

		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},

		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test(location.protocol),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",

			/*
   timeout: 0,
   data: null,
   dataType: null,
   username: null,
   password: null,
   cache: null,
   throws: false,
   traditional: false,
   headers: {},
   */

			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},

			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},

			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},

			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {

				// Convert anything to text
				"* text": String,

				// Text to html (true = no transformation)
				"text html": true,

				// Evaluate text as a json expression
				"text json": JSON.parse,

				// Parse text as xml
				"text xml": jQuery.parseXML
			},

			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},

		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function ajaxSetup(target, settings) {
			return settings ?

			// Building a settings object
			ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) :

			// Extending ajaxSettings
			ajaxExtend(jQuery.ajaxSettings, target);
		},

		ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
		ajaxTransport: addToPrefiltersOrTransports(transports),

		// Main method
		ajax: function ajax(url, options) {

			// If url is an object, simulate pre-1.5 signature
			if ((typeof url === "undefined" ? "undefined" : _typeof(url)) === "object") {
				options = url;
				url = undefined;
			}

			// Force options to be an object
			options = options || {};

			var transport,


			// URL without anti-cache param
			cacheURL,


			// Response headers
			responseHeadersString,
			    responseHeaders,


			// timeout handle
			timeoutTimer,


			// Url cleanup var
			urlAnchor,


			// Request state (becomes false upon send and true upon completion)
			completed,


			// To know if global events are to be dispatched
			fireGlobals,


			// Loop variable
			i,


			// uncached part of the url
			uncached,


			// Create the final options object
			s = jQuery.ajaxSetup({}, options),


			// Callbacks context
			callbackContext = s.context || s,


			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,


			// Deferreds
			deferred = jQuery.Deferred(),
			    completeDeferred = jQuery.Callbacks("once memory"),


			// Status-dependent callbacks
			_statusCode = s.statusCode || {},


			// Headers (they are sent all at once)
			requestHeaders = {},
			    requestHeadersNames = {},


			// Default abort message
			strAbort = "canceled",


			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function getResponseHeader(key) {
					var match;
					if (completed) {
						if (!responseHeaders) {
							responseHeaders = {};
							while (match = rheaders.exec(responseHeadersString)) {
								responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
							}
						}
						match = responseHeaders[key.toLowerCase() + " "];
					}
					return match == null ? null : match.join(", ");
				},

				// Raw string
				getAllResponseHeaders: function getAllResponseHeaders() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function setRequestHeader(name, value) {
					if (completed == null) {
						name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
						requestHeaders[name] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function overrideMimeType(type) {
					if (completed == null) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function statusCode(map) {
					var code;
					if (map) {
						if (completed) {

							// Execute the appropriate callbacks
							jqXHR.always(map[jqXHR.status]);
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for (code in map) {
								_statusCode[code] = [_statusCode[code], map[code]];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function abort(statusText) {
					var finalText = statusText || strAbort;
					if (transport) {
						transport.abort(finalText);
					}
					done(0, finalText);
					return this;
				}
			};

			// Attach deferreds
			deferred.promise(jqXHR);

			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (trac-10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");

			// Alias method option to type as per ticket trac-12004
			s.type = options.method || options.type || s.method || s.type;

			// Extract dataTypes list
			s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];

			// A cross-domain request is in order when the origin doesn't match the current origin.
			if (s.crossDomain == null) {
				urlAnchor = document.createElement("a");

				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;

					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
				} catch (e) {

					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}

			// Convert data if not already a string
			if (s.data && s.processData && typeof s.data !== "string") {
				s.data = jQuery.param(s.data, s.traditional);
			}

			// Apply prefilters
			inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

			// If request was aborted inside a prefilter, stop there
			if (completed) {
				return jqXHR;
			}

			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
			fireGlobals = jQuery.event && s.global;

			// Watch for a new set of requests
			if (fireGlobals && jQuery.active++ === 0) {
				jQuery.event.trigger("ajaxStart");
			}

			// Uppercase the type
			s.type = s.type.toUpperCase();

			// Determine if request has content
			s.hasContent = !rnoContent.test(s.type);

			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace(rhash, "");

			// More options handling for requests with no content
			if (!s.hasContent) {

				// Remember the hash so we can put it back
				uncached = s.url.slice(cacheURL.length);

				// If data is available and should be processed, append data to url
				if (s.data && (s.processData || typeof s.data === "string")) {
					cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;

					// trac-9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}

				// Add or update anti-cache param if needed
				if (s.cache === false) {
					cacheURL = cacheURL.replace(rantiCache, "$1");
					uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
				}

				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;

				// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
				s.data = s.data.replace(r20, "+");
			}

			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if (s.ifModified) {
				if (jQuery.lastModified[cacheURL]) {
					jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
				}
				if (jQuery.etag[cacheURL]) {
					jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
				}
			}

			// Set the correct header, if data is being sent
			if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
				jqXHR.setRequestHeader("Content-Type", s.contentType);
			}

			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);

			// Check for headers option
			for (i in s.headers) {
				jqXHR.setRequestHeader(i, s.headers[i]);
			}

			// Allow custom headers/mimetypes and early abort
			if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {

				// Abort if not done already and return
				return jqXHR.abort();
			}

			// Aborting is no longer a cancellation
			strAbort = "abort";

			// Install callbacks on deferreds
			completeDeferred.add(s.complete);
			jqXHR.done(s.success);
			jqXHR.fail(s.error);

			// Get transport
			transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);

			// If no transport, we auto-abort
			if (!transport) {
				done(-1, "No Transport");
			} else {
				jqXHR.readyState = 1;

				// Send global event
				if (fireGlobals) {
					globalEventContext.trigger("ajaxSend", [jqXHR, s]);
				}

				// If request was aborted inside ajaxSend, stop there
				if (completed) {
					return jqXHR;
				}

				// Timeout
				if (s.async && s.timeout > 0) {
					timeoutTimer = window.setTimeout(function () {
						jqXHR.abort("timeout");
					}, s.timeout);
				}

				try {
					completed = false;
					transport.send(requestHeaders, done);
				} catch (e) {

					// Rethrow post-completion exceptions
					if (completed) {
						throw e;
					}

					// Propagate others as results
					done(-1, e);
				}
			}

			// Callback for when everything is done
			function done(status, nativeStatusText, responses, headers) {
				var isSuccess,
				    success,
				    error,
				    response,
				    modified,
				    statusText = nativeStatusText;

				// Ignore repeat invocations
				if (completed) {
					return;
				}

				completed = true;

				// Clear timeout if it exists
				if (timeoutTimer) {
					window.clearTimeout(timeoutTimer);
				}

				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;

				// Cache response headers
				responseHeadersString = headers || "";

				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;

				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;

				// Get response data
				if (responses) {
					response = ajaxHandleResponses(s, jqXHR, responses);
				}

				// Use a noop converter for missing script but not if jsonp
				if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) {
					s.converters["text script"] = function () {};
				}

				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert(s, response, jqXHR, isSuccess);

				// If successful, handle type chaining
				if (isSuccess) {

					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if (s.ifModified) {
						modified = jqXHR.getResponseHeader("Last-Modified");
						if (modified) {
							jQuery.lastModified[cacheURL] = modified;
						}
						modified = jqXHR.getResponseHeader("etag");
						if (modified) {
							jQuery.etag[cacheURL] = modified;
						}
					}

					// if no content
					if (status === 204 || s.type === "HEAD") {
						statusText = "nocontent";

						// if not modified
					} else if (status === 304) {
						statusText = "notmodified";

						// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {

					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if (status || !statusText) {
						statusText = "error";
						if (status < 0) {
							status = 0;
						}
					}
				}

				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = (nativeStatusText || statusText) + "";

				// Success/Error
				if (isSuccess) {
					deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
				} else {
					deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
				}

				// Status-dependent callbacks
				jqXHR.statusCode(_statusCode);
				_statusCode = undefined;

				if (fireGlobals) {
					globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
				}

				// Complete
				completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);

				if (fireGlobals) {
					globalEventContext.trigger("ajaxComplete", [jqXHR, s]);

					// Handle the global AJAX counter
					if (! --jQuery.active) {
						jQuery.event.trigger("ajaxStop");
					}
				}
			}

			return jqXHR;
		},

		getJSON: function getJSON(url, data, callback) {
			return jQuery.get(url, data, callback, "json");
		},

		getScript: function getScript(url, callback) {
			return jQuery.get(url, undefined, callback, "script");
		}
	});

	jQuery.each(["get", "post"], function (_i, method) {
		jQuery[method] = function (url, data, callback, type) {

			// Shift arguments if data argument was omitted
			if (isFunction(data)) {
				type = type || callback;
				callback = data;
				data = undefined;
			}

			// The url can be an options object (which then must have .url)
			return jQuery.ajax(jQuery.extend({
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject(url) && url));
		};
	});

	jQuery.ajaxPrefilter(function (s) {
		var i;
		for (i in s.headers) {
			if (i.toLowerCase() === "content-type") {
				s.contentType = s.headers[i] || "";
			}
		}
	});

	jQuery._evalUrl = function (url, options, doc) {
		return jQuery.ajax({
			url: url,

			// Make this explicit, since user can override this through ajaxSetup (trac-11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,

			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function textScript() {}
			},
			dataFilter: function dataFilter(response) {
				jQuery.globalEval(response, options, doc);
			}
		});
	};

	jQuery.fn.extend({
		wrapAll: function wrapAll(html) {
			var wrap;

			if (this[0]) {
				if (isFunction(html)) {
					html = html.call(this[0]);
				}

				// The elements to wrap the target around
				wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

				if (this[0].parentNode) {
					wrap.insertBefore(this[0]);
				}

				wrap.map(function () {
					var elem = this;

					while (elem.firstElementChild) {
						elem = elem.firstElementChild;
					}

					return elem;
				}).append(this);
			}

			return this;
		},

		wrapInner: function wrapInner(html) {
			if (isFunction(html)) {
				return this.each(function (i) {
					jQuery(this).wrapInner(html.call(this, i));
				});
			}

			return this.each(function () {
				var self = jQuery(this),
				    contents = self.contents();

				if (contents.length) {
					contents.wrapAll(html);
				} else {
					self.append(html);
				}
			});
		},

		wrap: function wrap(html) {
			var htmlIsFunction = isFunction(html);

			return this.each(function (i) {
				jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
			});
		},

		unwrap: function unwrap(selector) {
			this.parent(selector).not("body").each(function () {
				jQuery(this).replaceWith(this.childNodes);
			});
			return this;
		}
	});

	jQuery.expr.pseudos.hidden = function (elem) {
		return !jQuery.expr.pseudos.visible(elem);
	};
	jQuery.expr.pseudos.visible = function (elem) {
		return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
	};

	jQuery.ajaxSettings.xhr = function () {
		try {
			return new window.XMLHttpRequest();
		} catch (e) {}
	};

	var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	    xhrSupported = jQuery.ajaxSettings.xhr();

	support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
	support.ajax = xhrSupported = !!xhrSupported;

	jQuery.ajaxTransport(function (options) {
		var _callback, errorCallback;

		// Cross domain only allowed if supported through XMLHttpRequest
		if (support.cors || xhrSupported && !options.crossDomain) {
			return {
				send: function send(headers, complete) {
					var i,
					    xhr = options.xhr();

					xhr.open(options.type, options.url, options.async, options.username, options.password);

					// Apply custom fields if provided
					if (options.xhrFields) {
						for (i in options.xhrFields) {
							xhr[i] = options.xhrFields[i];
						}
					}

					// Override mime type if needed
					if (options.mimeType && xhr.overrideMimeType) {
						xhr.overrideMimeType(options.mimeType);
					}

					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if (!options.crossDomain && !headers["X-Requested-With"]) {
						headers["X-Requested-With"] = "XMLHttpRequest";
					}

					// Set headers
					for (i in headers) {
						xhr.setRequestHeader(i, headers[i]);
					}

					// Callback
					_callback = function callback(type) {
						return function () {
							if (_callback) {
								_callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;

								if (type === "abort") {
									xhr.abort();
								} else if (type === "error") {

									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if (typeof xhr.status !== "number") {
										complete(0, "error");
									} else {
										complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status, xhr.statusText);
									}
								} else {
									complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									(xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? { binary: xhr.response } : { text: xhr.responseText }, xhr.getAllResponseHeaders());
								}
							}
						};
					};

					// Listen to events
					xhr.onload = _callback();
					errorCallback = xhr.onerror = xhr.ontimeout = _callback("error");

					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if (xhr.onabort !== undefined) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function () {

							// Check readyState before timeout as it changes
							if (xhr.readyState === 4) {

								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout(function () {
									if (_callback) {
										errorCallback();
									}
								});
							}
						};
					}

					// Create the abort callback
					_callback = _callback("abort");

					try {

						// Do send the request (this may raise an exception)
						xhr.send(options.hasContent && options.data || null);
					} catch (e) {

						// trac-14683: Only rethrow if this hasn't been notified as an error yet
						if (_callback) {
							throw e;
						}
					}
				},

				abort: function abort() {
					if (_callback) {
						_callback();
					}
				}
			};
		}
	});

	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter(function (s) {
		if (s.crossDomain) {
			s.contents.script = false;
		}
	});

	// Install script dataType
	jQuery.ajaxSetup({
		accepts: {
			script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function textScript(text) {
				jQuery.globalEval(text);
				return text;
			}
		}
	});

	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter("script", function (s) {
		if (s.cache === undefined) {
			s.cache = false;
		}
		if (s.crossDomain) {
			s.type = "GET";
		}
	});

	// Bind script tag hack transport
	jQuery.ajaxTransport("script", function (s) {

		// This transport only deals with cross domain or forced-by-attrs requests
		if (s.crossDomain || s.scriptAttrs) {
			var script, _callback2;
			return {
				send: function send(_, complete) {
					script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({ charset: s.scriptCharset, src: s.url }).on("load error", _callback2 = function callback(evt) {
						script.remove();
						_callback2 = null;
						if (evt) {
							complete(evt.type === "error" ? 404 : 200, evt.type);
						}
					});

					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild(script[0]);
				},
				abort: function abort() {
					if (_callback2) {
						_callback2();
					}
				}
			};
		}
	});

	var oldCallbacks = [],
	    rjsonp = /(=)\?(?=&|$)|\?\?/;

	// Default jsonp settings
	jQuery.ajaxSetup({
		jsonp: "callback",
		jsonpCallback: function jsonpCallback() {
			var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
			this[callback] = true;
			return callback;
		}
	});

	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {

		var callbackName,
		    overwritten,
		    responseContainer,
		    jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");

		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if (jsonProp || s.dataTypes[0] === "jsonp") {

			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;

			// Insert callback into url or form data
			if (jsonProp) {
				s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
			} else if (s.jsonp !== false) {
				s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
			}

			// Use data converter to retrieve json after script execution
			s.converters["script json"] = function () {
				if (!responseContainer) {
					jQuery.error(callbackName + " was not called");
				}
				return responseContainer[0];
			};

			// Force json dataType
			s.dataTypes[0] = "json";

			// Install callback
			overwritten = window[callbackName];
			window[callbackName] = function () {
				responseContainer = arguments;
			};

			// Clean-up function (fires after converters)
			jqXHR.always(function () {

				// If previous value didn't exist - remove it
				if (overwritten === undefined) {
					jQuery(window).removeProp(callbackName);

					// Otherwise restore preexisting value
				} else {
					window[callbackName] = overwritten;
				}

				// Save back as free
				if (s[callbackName]) {

					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;

					// Save the callback name for future use
					oldCallbacks.push(callbackName);
				}

				// Call if it was a function and we have a response
				if (responseContainer && isFunction(overwritten)) {
					overwritten(responseContainer[0]);
				}

				responseContainer = overwritten = undefined;
			});

			// Delegate to script
			return "script";
		}
	});

	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = function () {
		var body = document.implementation.createHTMLDocument("").body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	}();

	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function (data, context, keepScripts) {
		if (typeof data !== "string") {
			return [];
		}
		if (typeof context === "boolean") {
			keepScripts = context;
			context = false;
		}

		var base, parsed, scripts;

		if (!context) {

			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if (support.createHTMLDocument) {
				context = document.implementation.createHTMLDocument("");

				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement("base");
				base.href = document.location.href;
				context.head.appendChild(base);
			} else {
				context = document;
			}
		}

		parsed = rsingleTag.exec(data);
		scripts = !keepScripts && [];

		// Single tag
		if (parsed) {
			return [context.createElement(parsed[1])];
		}

		parsed = buildFragment([data], context, scripts);

		if (scripts && scripts.length) {
			jQuery(scripts).remove();
		}

		return jQuery.merge([], parsed.childNodes);
	};

	/**
  * Load a url into a page
  */
	jQuery.fn.load = function (url, params, callback) {
		var selector,
		    type,
		    response,
		    self = this,
		    off = url.indexOf(" ");

		if (off > -1) {
			selector = stripAndCollapse(url.slice(off));
			url = url.slice(0, off);
		}

		// If it's a function
		if (isFunction(params)) {

			// We assume that it's the callback
			callback = params;
			params = undefined;

			// Otherwise, build a param string
		} else if (params && (typeof params === "undefined" ? "undefined" : _typeof(params)) === "object") {
			type = "POST";
		}

		// If we have elements to modify, make the request
		if (self.length > 0) {
			jQuery.ajax({
				url: url,

				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			}).done(function (responseText) {

				// Save response for use in complete callback
				response = arguments;

				self.html(selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) :

				// Otherwise use the full result
				responseText);

				// If the request succeeds, this function gets "data", "status", "jqXHR"
				// but they are ignored because response was set above.
				// If it fails, this function gets "jqXHR", "status", "error"
			}).always(callback && function (jqXHR, status) {
				self.each(function () {
					callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
				});
			});
		}

		return this;
	};

	jQuery.expr.pseudos.animated = function (elem) {
		return jQuery.grep(jQuery.timers, function (fn) {
			return elem === fn.elem;
		}).length;
	};

	jQuery.offset = {
		setOffset: function setOffset(elem, options, i) {
			var curPosition,
			    curLeft,
			    curCSSTop,
			    curTop,
			    curOffset,
			    curCSSLeft,
			    calculatePosition,
			    position = jQuery.css(elem, "position"),
			    curElem = jQuery(elem),
			    props = {};

			// Set position first, in-case top/left are set even on static elem
			if (position === "static") {
				elem.style.position = "relative";
			}

			curOffset = curElem.offset();
			curCSSTop = jQuery.css(elem, "top");
			curCSSLeft = jQuery.css(elem, "left");
			calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;

			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if (calculatePosition) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
			} else {
				curTop = parseFloat(curCSSTop) || 0;
				curLeft = parseFloat(curCSSLeft) || 0;
			}

			if (isFunction(options)) {

				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call(elem, i, jQuery.extend({}, curOffset));
			}

			if (options.top != null) {
				props.top = options.top - curOffset.top + curTop;
			}
			if (options.left != null) {
				props.left = options.left - curOffset.left + curLeft;
			}

			if ("using" in options) {
				options.using.call(elem, props);
			} else {
				curElem.css(props);
			}
		}
	};

	jQuery.fn.extend({

		// offset() relates an element's border box to the document origin
		offset: function offset(options) {

			// Preserve chaining for setter
			if (arguments.length) {
				return options === undefined ? this : this.each(function (i) {
					jQuery.offset.setOffset(this, options, i);
				});
			}

			var rect,
			    win,
			    elem = this[0];

			if (!elem) {
				return;
			}

			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if (!elem.getClientRects().length) {
				return { top: 0, left: 0 };
			}

			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},

		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function position() {
			if (!this[0]) {
				return;
			}

			var offsetParent,
			    offset,
			    doc,
			    elem = this[0],
			    parentOffset = { top: 0, left: 0 };

			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if (jQuery.css(elem, "position") === "fixed") {

				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
			} else {
				offset = this.offset();

				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {

					offsetParent = offsetParent.parentNode;
				}
				if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {

					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery(offsetParent).offset();
					parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
					parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
				}
			}

			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
				left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
			};
		},

		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function offsetParent() {
			return this.map(function () {
				var offsetParent = this.offsetParent;

				while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
					offsetParent = offsetParent.offsetParent;
				}

				return offsetParent || documentElement;
			});
		}
	});

	// Create scrollLeft and scrollTop methods
	jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (method, prop) {
		var top = "pageYOffset" === prop;

		jQuery.fn[method] = function (val) {
			return access(this, function (elem, method, val) {

				// Coalesce documents and windows
				var win;
				if (isWindow(elem)) {
					win = elem;
				} else if (elem.nodeType === 9) {
					win = elem.defaultView;
				}

				if (val === undefined) {
					return win ? win[prop] : elem[method];
				}

				if (win) {
					win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
				} else {
					elem[method] = val;
				}
			}, method, val, arguments.length);
		};
	});

	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each(["top", "left"], function (_i, prop) {
		jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
			if (computed) {
				computed = curCSS(elem, prop);

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
			}
		});
	});

	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each({ Height: "height", Width: "width" }, function (name, type) {
		jQuery.each({
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function (defaultExtra, funcName) {

			// Margin is only for outerHeight, outerWidth
			jQuery.fn[funcName] = function (margin, value) {
				var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
				    extra = defaultExtra || (margin === true || value === true ? "margin" : "border");

				return access(this, function (elem, type, value) {
					var doc;

					if (isWindow(elem)) {

						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
					}

					// Get document width or height
					if (elem.nodeType === 9) {
						doc = elem.documentElement;

						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
					}

					return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css(elem, type, extra) :

					// Set width or height on the element
					jQuery.style(elem, type, value, extra);
				}, type, chainable ? margin : undefined, chainable);
			};
		});
	});

	jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (_i, type) {
		jQuery.fn[type] = function (fn) {
			return this.on(type, fn);
		};
	});

	jQuery.fn.extend({

		bind: function bind(types, data, fn) {
			return this.on(types, null, data, fn);
		},
		unbind: function unbind(types, fn) {
			return this.off(types, null, fn);
		},

		delegate: function delegate(selector, types, data, fn) {
			return this.on(types, selector, data, fn);
		},
		undelegate: function undelegate(selector, types, fn) {

			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
		},

		hover: function hover(fnOver, fnOut) {
			return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
		}
	});

	jQuery.each(("blur focus focusin focusout resize scroll click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup contextmenu").split(" "), function (_i, name) {

		// Handle event binding
		jQuery.fn[name] = function (data, fn) {
			return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
		};
	});

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	// Require that the "whitespace run" starts from a non-whitespace
	// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
	var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function (fn, context) {
		var tmp, args, proxy;

		if (typeof context === "string") {
			tmp = fn[context];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if (!isFunction(fn)) {
			return undefined;
		}

		// Simulated bind
		args = _slice.call(arguments, 2);
		proxy = function proxy() {
			return fn.apply(context || this, args.concat(_slice.call(arguments)));
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	};

	jQuery.holdReady = function (hold) {
		if (hold) {
			jQuery.readyWait++;
		} else {
			jQuery.ready(true);
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;

	jQuery.now = Date.now;

	jQuery.isNumeric = function (obj) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type(obj);
		return (type === "number" || type === "string") &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN(obj - parseFloat(obj));
	};

	jQuery.trim = function (text) {
		return text == null ? "" : (text + "").replace(rtrim, "$1");
	};

	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.

	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return jQuery;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}

	var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,


	// Map over the $ in case of overwrite
	_$ = window.$;

	jQuery.noConflict = function (deep) {
		if (window.$ === jQuery) {
			window.$ = _$;
		}

		if (deep && window.jQuery === jQuery) {
			window.jQuery = _jQuery;
		}

		return jQuery;
	};

	// Expose jQuery and $ identifiers, even in AMD
	// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (trac-13566)
	if (typeof noGlobal === "undefined") {
		window.jQuery = window.$ = jQuery;
	}

	return jQuery;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module)))

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(186);
var enumBugKeys = __webpack_require__(133);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toInteger = __webpack_require__(43);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(10);
var dPs = __webpack_require__(187);
var enumBugKeys = __webpack_require__(133);
var IE_PROTO = __webpack_require__(132)('IE_PROTO');
var Empty = function Empty() {/* empty */};
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(130)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(134).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;
  while (i--) {
    delete _createDict[PROTOTYPE][enumBugKeys[i]];
  }return _createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = _createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(186);
var hiddenKeys = __webpack_require__(133).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(12);
var dP = __webpack_require__(22);
var DESCRIPTORS = __webpack_require__(21);
var SPECIES = __webpack_require__(18)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function get() {
      return this;
    }
  });
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
    throw TypeError(name + ': incorrect invocation!');
  }return it;
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ctx = __webpack_require__(41);
var call = __webpack_require__(199);
var isArrayIter = __webpack_require__(145);
var anObject = __webpack_require__(10);
var toLength = __webpack_require__(19);
var getIterFn = __webpack_require__(147);
var BREAK = {};
var RETURN = {};
var _exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () {
    return iterable;
  } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
_exports.BREAK = BREAK;
_exports.RETURN = RETURN;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var redefine = __webpack_require__(30);
module.exports = function (target, src, safe) {
  for (var key in src) {
    redefine(target, key, src[key], safe);
  }return target;
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(15);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiFunctions = __webpack_require__(5);

var _main = __webpack_require__(4);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  methods: {
    autorizaNFSe: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(nf, responseCallback) {
        var isValid, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(nf.tpnf != 'S')) {
                  _context.next = 3;
                  break;
                }

                this.$erpToastError('A nota fiscal deve ser do tipo serviço.');
                return _context.abrupt('return');

              case 3:
                if (!(nf.tpnf == 'S' && !_main.SysVars.ambienteHomologacaoNFe)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return (0, _apiFunctions.apiValidaLimitePlano)(this, 'nfservico');

              case 6:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return');

              case 9:

                this.$appLoading(true);
                _context.next = 12;
                return (0, _apiFunctions.apiAutNFSe)(this, nf.codnf);

              case 12:
                response = _context.sent;

                console.log(response);
                if (response) {
                  if (response.errmessages) {
                    this.$erpToastError(response.errmessages[0]);
                    this.errmessages = {};
                    this.errmessages.errmessages = response.errmessages;
                  } else {
                    if (response.items.length > 0) {
                      if (response.items[0].stnf === '10') {
                        //EXIBE A MENSAGEM DE NF AUTORIZADA E ATUALIZA O STATUS E CHAVE DA NF NA TELA
                        this.$erpToastSuccess('Nota fiscal autorizada');
                      } else {
                        nf.xmotivo = response.items[0].xmotivo;
                        this.$erpToastWarning(response.items[0].xmotivo);
                      }
                    } else {
                      //LOTE REJEITADO OU AINDA NAO PROCESSADO
                      nf.stnf = '50'; //NF REJEITADA
                      nf.xmotivo = response.message;
                      this.$erpToastError(response.message);
                    }
                  }
                }
                if (responseCallback) {
                  responseCallback(response);
                }

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function autorizaNFSe(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return autorizaNFSe;
    }(),
    sincronizaNFSe: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(nf, responseCallback) {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(nf.tpnf != 'S')) {
                  _context2.next = 3;
                  break;
                }

                this.$erpToastError('A nota fiscal deve ser do tipo serviço.');
                return _context2.abrupt('return');

              case 3:

                this.$appLoading(true);
                _context2.next = 6;
                return (0, _apiFunctions.apiSyncNFSe)(this, nf.codnf);

              case 6:
                response = _context2.sent;

                console.log(response);
                if (response) {
                  if (response.errmessages) {
                    this.$erpToastError(response.errmessages[0]);
                    this.errmessages = {};
                    this.errmessages.errmessages = response.errmessages;
                  } else {
                    if (response.items.length > 0) {
                      if (response.items[0].stnf === '10') {
                        //EXIBE A MENSAGEM DE NF AUTORIZADA E ATUALIZA O STATUS E CHAVE DA NF NA TELA
                        this.$erpToastSuccess('Nota fiscal autorizada');
                      } else {
                        nf.xmotivo = response.items[0].xmotivo;
                        this.$erpToastWarning(response.items[0].xmotivo);
                      }
                    } else {
                      //LOTE REJEITADO OU AINDA NAO PROCESSADO
                      nf.stnf = '50'; //NF REJEITADA
                      nf.xmotivo = response.message;
                      this.$erpToastError(response.message);
                    }
                  }
                }
                if (responseCallback) {
                  responseCallback(response);
                }

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sincronizaNFSe(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return sincronizaNFSe;
    }(),
    autorizaNFeSAT: function autorizaNFeSAT(nf, responseCallback) {
      this.$executaExtensaoChromeSAT(nf.codnf, 'sat', responseCallback);
    },
    autorizaNFeA3: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(nf, responseCallback) {
        var isValid, _isValid;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(nf.operacaonf == 'S' && nf.movest == 'S' && nf.flagestoquebaixado != 'S')) {
                  _context3.next = 3;
                  break;
                }

                this.$erpToastError('Efetue a baixa do estoque para prosseguir');
                return _context3.abrupt('return');

              case 3:
                if (_main.SysVars.ambienteHomologacaoNFe) {
                  _context3.next = 17;
                  break;
                }

                if (!nf.coddi) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 7;
                return (0, _apiFunctions.apiValidaLimitePlano)(this, 'nfimportacao');

              case 7:
                isValid = _context3.sent;

                if (isValid) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt('return');

              case 10:
                _context3.next = 17;
                break;

              case 12:
                _context3.next = 14;
                return (0, _apiFunctions.apiValidaLimitePlano)(this, 'nfe');

              case 14:
                _isValid = _context3.sent;

                if (_isValid) {
                  _context3.next = 17;
                  break;
                }

                return _context3.abrupt('return');

              case 17:

                this.$appLoading(true);
                // const baixa = await this.baixaEstoqueNF(nf)
                // if (!baixa)
                //   return
                this.$executaExtensaoChromeA3(nf.codnf, 'nfe', responseCallback);

              case 19:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function autorizaNFeA3(_x5, _x6) {
        return _ref3.apply(this, arguments);
      }

      return autorizaNFeA3;
    }(),


    // async baixaEstoqueNF (nf) {
    //   let url = '/estoque/nfsaida/baixarestoque/' + nf.codnf
    //   const response = await apiORDSpost(this.$store, url, null, 'put')
    //   //erro 400 é retornado se o estoque não for baixado
    //   return true
    // },

    autorizaNFeA1: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(nf, responseCallback) {
        var isValid, _isValid2, _isValid3, response, motivo;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(nf.operacaonf == 'S' && nf.movest == 'S' && nf.flagestoquebaixado != 'S')) {
                  _context4.next = 3;
                  break;
                }

                this.$erpToastError('Efetue a baixa do estoque para prosseguir');
                return _context4.abrupt('return');

              case 3:
                if (_main.SysVars.ambienteHomologacaoNFe) {
                  _context4.next = 23;
                  break;
                }

                if (!nf.coddi) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 7;
                return (0, _apiFunctions.apiValidaLimitePlano)(this, 'nfimportacao');

              case 7:
                isValid = _context4.sent;

                if (isValid) {
                  _context4.next = 10;
                  break;
                }

                return _context4.abrupt('return');

              case 10:
                if (!(nf.esp == '65')) {
                  _context4.next = 18;
                  break;
                }

                _context4.next = 13;
                return (0, _apiFunctions.apiValidaLimitePlano)(this, 'nfce');

              case 13:
                _isValid2 = _context4.sent;

                if (_isValid2) {
                  _context4.next = 16;
                  break;
                }

                return _context4.abrupt('return');

              case 16:
                _context4.next = 23;
                break;

              case 18:
                _context4.next = 20;
                return (0, _apiFunctions.apiValidaLimitePlano)(this, 'nfe');

              case 20:
                _isValid3 = _context4.sent;

                if (_isValid3) {
                  _context4.next = 23;
                  break;
                }

                return _context4.abrupt('return');

              case 23:

                this.$appLoading(true);
                _context4.next = 26;
                return (0, _apiFunctions.apiAutNFe)(this, nf.codfil, nf.codnf);

              case 26:
                response = _context4.sent;

                if (response.data) {
                  if (response.data.errmessages) {
                    this.$erpToastError(response.data.errmessages[0]);
                    this.errmessages = {};
                    this.errmessages.errmessages = response.data.errmessages;
                  } else {
                    if (response.data.nf.length > 0) {
                      if (response.data.nf[0].cstat === '100') {
                        //EXIBE A MENSAGEM DE NF AUTORIZADA E ATUALIZA O STATUS E CHAVE DA NF NA TELA
                        this.$erpToastSuccess('Nota fiscal autorizada');
                        nf.stnf = '10';
                        nf.chave = response.data.nf[0].chave;
                        nf.xmotivo = '';
                      } else {
                        if (response.data.nf[0].cstat === '302' || response.data.cstat === '302') nf.stnf = '92';else nf.stnf = '50';
                        motivo = response.data.nf[0].xmotivo || response.data.xmotivo;

                        nf.xmotivo = motivo;
                        this.$erpToastError(motivo);
                      }
                    } else {
                      //LOTE REJEITADO OU AINDA NAO PROCESSADO
                      nf.stnf = '50'; //NF REJEITADA
                      nf.xmotivo = response.data.xmotivo;
                      this.$erpToastError(response.data.xmotivo);
                    }
                  }
                }
                if (responseCallback) {
                  responseCallback(response);
                }

              case 29:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function autorizaNFeA1(_x7, _x8) {
        return _ref4.apply(this, arguments);
      }

      return autorizaNFeA1;
    }(),
    ambienteHomologacaoNFe: function ambienteHomologacaoNFe() {
      (0, _apiFunctions.apiORDS)(this.$store.getters.urlOrds + 'cg/ambientenfe', null, true).then(function (result) {
        if (result) _main.SysVars.ambienteHomologacaoNFe = result.homologacao;else _main.SysVars.ambienteHomologacaoNFe = null;
      });
    }
  }
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _apiFunctions = __webpack_require__(5);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var MODULO = 'sales/pedv/';
var MODULODUPLICA = 'sales/pedv/duplica';
var MODULOIT = 'sales/pedvit/';
var MODULOCANCELIT = 'sales/pedvit/cancel/';
var MODULODELETEIT = 'sales/pedvit/delete/';
var MODULOVAREJO = 'sales/pedv/varejo';
var MODULOVAREJOVMOVCAIXA = 'varejo/vmovcaixa/';

exports.default = {

  methods: {
    apiPedido: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(operacao, pedv, pedvit, pedvpar, responseCallback) {
        var pedido, sendData, metodo, update, data, validation;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pedido = pedv;

                pedido.pedvit = pedvit;
                pedido.pedvpar = pedvpar;
                sendData = { pedv: pedido };
                metodo = 'post';
                update = false;

                if (this.pedv.codpedv != null) {
                  metodo = 'put';
                  update = true;
                }

                _context.next = 9;
                return (0, _apiFunctions.apiORDSpost)(this.$store, MODULO, sendData, metodo);

              case 9:
                data = _context.sent;

                if (data.items) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt('return');

              case 12:
                validation = null;

                if (data.items[0].validation) {
                  validation = JSON.parse(data.items[0].validation);
                } else if (data.items[0].stpedv == 'C') {
                  this.$erpToastWarning('O pedido foi cancelado');
                  this.closeForm();
                }

                if (operacao == 'gerarpedido') if (data.items[0].tppedv == 'P') this.$erpToastSuccess('O orçamento foi transformado em pedido');

                if (operacao == 'perdido') this.$erpToastError('Orçamento perdido');

                if (responseCallback) {
                  responseCallback(operacao, data.items[0], validation);
                }

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function apiPedido(_x, _x2, _x3, _x4, _x5) {
        return _ref.apply(this, arguments);
      }

      return apiPedido;
    }(),
    apiVarejoPedido: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(pedv, pedvit, pagamentos, cancel, responseCallback) {
        var pedido, sendData, metodo, data, erros;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (cancel) pedv.stpedv = 'C';

                pedido = pedv;

                pedido.pedvit = pedvit;
                //pedido.pedvpar = pedvpar
                //pedido.pagamentos = pagamentos
                sendData = { pedv: pedido };
                metodo = 'post';
                _context2.next = 7;
                return (0, _apiFunctions.apiORDSpost)(this.$store, MODULOVAREJO, sendData, metodo);

              case 7:
                data = _context2.sent;

                if (data.items) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt('return');

              case 10:
                erros = [];

                if (data.items[0].validation) {
                  erros = JSON.parse(data.items[0].validation);
                  this.$scrollTo(0);
                  if (erros.errmessages) this.$erpToastError('Por favor corrija os erros de validação');
                } else if (data.items[0].stpedv == 'C') {
                  this.$erpToastWarning('O pedido foi cancelado');
                  this.closeForm();
                }

                if (responseCallback) {
                  responseCallback(data.items[0], erros);
                }

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function apiVarejoPedido(_x6, _x7, _x8, _x9, _x10) {
        return _ref2.apply(this, arguments);
      }

      return apiVarejoPedido;
    }(),
    apiDuplicaPedido: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(codpedv, responseCallback) {
        var sendData, data, errmessages;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                //efetua a copia do pedido
                sendData = { pedv: codpedv };
                _context3.next = 3;
                return (0, _apiFunctions.apiORDSpost)(this.$store, MODULODUPLICA, sendData, 'post');

              case 3:
                data = _context3.sent;

                if (data.items) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt('return');

              case 6:
                if (data.items[0].tppedv === 'P') {
                  this.$erpToastSuccess('Pedido copiado. O novo pedido criado é: ' + data.items[0].npedido);
                } else {
                  this.$erpToastSuccess('Orçamento copiado. O novo orçamento criado é: ' + data.items[0].ncotacao);
                }
                errmessages = [];

                if (data.items[0].validation) {
                  errmessages = JSON.parse(data.items[0].validation);
                }
                if (responseCallback) {
                  responseCallback(data.items[0], errmessages);
                }

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function apiDuplicaPedido(_x11, _x12) {
        return _ref3.apply(this, arguments);
      }

      return apiDuplicaPedido;
    }(),
    apiItemPedido: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(senddata, updateItem, cancelItem, deleteItem, responseCallback) {
        var modulo, metodo, data, validation;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                modulo = MODULOIT;
                metodo = 'post';

                if (!senddata.pedv.codpedv) {
                  modulo = MODULO;
                } else if (updateItem) {
                  metodo = 'put';
                } else if (cancelItem) {
                  modulo = MODULOCANCELIT;
                } else if (deleteItem) {
                  modulo = MODULODELETEIT;
                }

                _context4.next = 5;
                return (0, _apiFunctions.apiORDSpost)(this.$store, modulo, senddata, metodo);

              case 5:
                data = _context4.sent;
                validation = null;

                if (data.items) {
                  if (cancelItem) this.$erpToastSuccess('O produto foi cancelado com sucesso.');else if (updateItem) this.$erpToastSuccess('Item alterado com sucesso.');else if (senddata.pedv.pedvit.length && senddata.pedv.pedvit.length > 1) this.$erpToastSuccess('Os produtos selecionados foram adicionados.');else if (senddata.pedv.pedvit.length) this.$erpToastSuccess('O produto selecionado foi adicionado.');

                  if (data.items[0].validation) {
                    validation = JSON.parse(data.items[0].validation);
                  }
                }

                if (responseCallback) {
                  if (deleteItem) {
                    this.$erpToastSuccess('O produto foi excluído do pedido.');
                    responseCallback('deleteItem', null, validation);
                  } else responseCallback(null, data.items[0], validation);
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function apiItemPedido(_x13, _x14, _x15, _x16, _x17) {
        return _ref4.apply(this, arguments);
      }

      return apiItemPedido;
    }(),
    apiRentab: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(pedv, liberada, desfazerLiberacao, obs, responseCallback) {
        var dados, url, data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                dados = {
                  codpedv: pedv.codpedv,
                  obs: obs,
                  liberada: liberada,
                  desfazer: desfazerLiberacao

                };
                url = MODULO + '/' + pedv.codpedv + '/rentabilidade';
                _context5.next = 4;
                return (0, _apiFunctions.apiORDSpost)(this.$store, url, dados, 'post');

              case 4:
                data = _context5.sent;


                if (desfazerLiberacao) this.$erpToastSuccess('Liberação desfeita.');else if (liberada) this.$erpToastSuccess('Liberação efetuada.');else this.$erpToastSuccess('Reprovação efetuada.');

                if (responseCallback) {
                  responseCallback('rentab');
                }

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function apiRentab(_x18, _x19, _x20, _x21, _x22) {
        return _ref5.apply(this, arguments);
      }

      return apiRentab;
    }(),
    apiVarejoVMovCaixa: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(paramvmovcaixa, cancel, responseCallback) {
        var vmcaixa, sendData, metodo, modulo, data, errmessages;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                //if (cancel) pedv.stpedv = 'C'

                vmcaixa = paramvmovcaixa;
                sendData = { vmovcaixa: vmcaixa };
                metodo = 'post';
                modulo = MODULOVAREJOVMOVCAIXA;


                modulo = modulo + (vmcaixa.codvmovcaixa != undefined ? vmcaixa.codvmovcaixa : '0');

                _context6.next = 7;
                return (0, _apiFunctions.apiORDSpost)(this.$store, modulo, sendData, metodo);

              case 7:
                data = _context6.sent;

                if (!data.validation) {
                  _context6.next = 12;
                  break;
                }

                this.$erpToastError(data.validation);
                if (responseCallback) {
                  responseCallback(null, null, data.validation);
                }
                return _context6.abrupt('return');

              case 12:
                if (data.items) {
                  _context6.next = 14;
                  break;
                }

                return _context6.abrupt('return');

              case 14:
                errmessages = [];

                if (data.items[0].validation) {
                  errmessages = JSON.parse(data.items[0].validation);
                  this.$scrollTo(0);
                  this.$erpToastError('Por favor corrija os erros de validação');
                }

                if (responseCallback) {
                  responseCallback(data.items[0], errmessages);
                }

              case 17:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function apiVarejoVMovCaixa(_x23, _x24, _x25) {
        return _ref6.apply(this, arguments);
      }

      return apiVarejoVMovCaixa;
    }(),
    apiEnviaPedidoWhats: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(pedv, numero) {
        var pedido, msg, link, isHomolog, sufixo, data;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.$store.dispatch('loadPedv', { id: pedv.codpedv });

              case 2:
                pedido = null;

                if (this.$store.getters.getPedv[0]) pedido = this.$store.getters.getPedv[0];

                msg = "";
                link = null;

                if (!(pedido.ecommerce == 'S')) {
                  _context7.next = 11;
                  break;
                }

                if (this.$store.getters.getSessao.dominio) {
                  isHomolog = typeof window !== 'undefined' && window.location && (window.location.host.indexOf('teste') >= 0 || window.location.host.indexOf('localhost') >= 0);
                  sufixo = isHomolog ? '.teste.notabrasil.com.br' : '.notabrasil.com.br';

                  link = 'https://' + this.$store.getters.getSessao.dominio + sufixo + '/loja/#/pedido-concluido?uuid=' + pedido.uuid;
                }
                msg = 'Um novo status foi vinculado ao seu pedido em nossa loja virtual acesse: ' + link;
                _context7.next = 18;
                break;

              case 11:
                _context7.next = 13;
                return (0, _apiFunctions.apiORDS)(this.$store.getters.urlOrds + 'sales/linkpdf/' + pedido.codpedv, null);

              case 13:
                data = _context7.sent;

                if (data.link) link = data.link;
                if (pedido.part[0].fantasia) msg = msg + "Olá *" + pedido.part[0].fantasia + "*,\n";
                if (pedido.filial[0].fantasia) msg = msg + "Seu pedido emitido por *" + pedido.filial[0].fantasia + "* está disponível.\n\n";
                msg = msg + "• Link para a impressão do pedido em pdf, *acesse*: \n" + data.link;

              case 18:

                msg = window.encodeURIComponent(msg);

                if (link) window.open("https://wa.me/?phone=55" + numero + '&text="' + msg, "_blank");

              case 20:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function apiEnviaPedidoWhats(_x26, _x27) {
        return _ref7.apply(this, arguments);
      }

      return apiEnviaPedidoWhats;
    }(),
    apiGerarNF: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(tipo) {
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                modulo = "invoice/order/" + this.pedv.codpedv;

                if (tipo) modulo += '?especie=' + tipo;
                _context8.next = 4;
                return (0, _apiFunctions.apiORDSpost)(this.$store, modulo, {}, "post");

              case 4:
                data = _context8.sent;

                if (!data.codnf) {
                  _context8.next = 10;
                  break;
                }

                this.pedv.nf = data.codnf;
                _context8.next = 9;
                return this.$store.dispatch("loadNf", { id: data.codnf });

              case 9:
                if (this.$store.getters.getNf) {
                  this.pedv.nf = _extends({}, this.$store.getters.getNf[0]);
                }

              case 10:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function apiGerarNF(_x28) {
        return _ref8.apply(this, arguments);
      }

      return apiGerarNF;
    }()
  }
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var def = __webpack_require__(22).f;
var has = __webpack_require__(35);
var TAG = __webpack_require__(18)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(42);
var TAG = __webpack_require__(18)('toStringTag');
// ES3 wrong here
var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {/* empty */}
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
  // builtinTag case
  : ARG ? cof(O)
  // ES3 arguments fallback
  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var defined = __webpack_require__(47);
var fails = __webpack_require__(14);
var spaces = __webpack_require__(136);
var space = '[' + spaces + ']';
var non = '\u200B\x85';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function exporter(KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Emitter = Emitter;
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on = Emitter.prototype.addEventListener = function (event, fn) {
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function (event, fn) {
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function (event, fn) {
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function (event) {
  this._callbacks = this._callbacks || {};

  var args = new Array(arguments.length - 1),
      callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

// alias used for reserved events (protected method)
Emitter.prototype.emitReserved = Emitter.prototype.emit;

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function (event) {
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function (event) {
  return !!this.listeners(event).length;
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pick = pick;
exports.installTimerFunctions = installTimerFunctions;
exports.byteLength = byteLength;
exports.randomString = randomString;

var _globalsNode = __webpack_require__(76);

function pick(obj) {
    for (var _len = arguments.length, attr = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        attr[_key - 1] = arguments[_key];
    }

    return attr.reduce(function (acc, k) {
        if (obj.hasOwnProperty(k)) {
            acc[k] = obj[k];
        }
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
var NATIVE_SET_TIMEOUT = _globalsNode.globalThisShim.setTimeout;
var NATIVE_CLEAR_TIMEOUT = _globalsNode.globalThisShim.clearTimeout;
function installTimerFunctions(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = NATIVE_SET_TIMEOUT.bind(_globalsNode.globalThisShim);
        obj.clearTimeoutFn = NATIVE_CLEAR_TIMEOUT.bind(_globalsNode.globalThisShim);
    } else {
        obj.setTimeoutFn = _globalsNode.globalThisShim.setTimeout.bind(_globalsNode.globalThisShim);
        obj.clearTimeoutFn = _globalsNode.globalThisShim.clearTimeout.bind(_globalsNode.globalThisShim);
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
var BASE64_OVERHEAD = 1.33;
// we could also have used `new Blob([obj]).size`, but it isn't supported in IE9
function byteLength(obj) {
    if (typeof obj === "string") {
        return utf8Length(obj);
    }
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * BASE64_OVERHEAD);
}
function utf8Length(str) {
    var c = 0,
        length = 0;
    for (var i = 0, l = str.length; i < l; i++) {
        c = str.charCodeAt(i);
        if (c < 0x80) {
            length += 1;
        } else if (c < 0x800) {
            length += 2;
        } else if (c < 0xd800 || c >= 0xe000) {
            length += 3;
        } else {
            i++;
            length += 4;
        }
    }
    return length;
}
/**
 * Generates a random 8-characters string.
 */
function randomString() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createCookieJar = createCookieJar;
var nextTick = exports.nextTick = function () {
    var isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) {
        return function (cb) {
            return Promise.resolve().then(cb);
        };
    } else {
        return function (cb, setTimeoutFn) {
            return setTimeoutFn(cb, 0);
        };
    }
}();
var globalThisShim = exports.globalThisShim = function () {
    if (typeof self !== "undefined") {
        return self;
    } else if (typeof window !== "undefined") {
        return window;
    } else {
        return Function("return this")();
    }
}();
var defaultBinaryType = exports.defaultBinaryType = "arraybuffer";
function createCookieJar() {}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var s$1 = function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(t, e) {
    var n, i, r, o, s, c, f, _e2, _e2$boundary, u, _e2$rootBoundary, m, _e2$elementContext, g, _e2$altBoundary, d, _e2$padding, p, h, y, x, w, v, b, R;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            void 0 === e && (e = {});i = t.x;
            r = t.y;
            o = t.platform;
            s = t.rects;
            c = t.elements;
            f = t.strategy;
            _e2 = e;
            _e2$boundary = _e2.boundary;
            u = _e2$boundary === undefined ? "clippingAncestors" : _e2$boundary;
            _e2$rootBoundary = _e2.rootBoundary;
            m = _e2$rootBoundary === undefined ? "viewport" : _e2$rootBoundary;
            _e2$elementContext = _e2.elementContext;
            g = _e2$elementContext === undefined ? "floating" : _e2$elementContext;
            _e2$altBoundary = _e2.altBoundary;
            d = _e2$altBoundary === undefined ? !1 : _e2$altBoundary;
            _e2$padding = _e2.padding;
            p = _e2$padding === undefined ? 0 : _e2$padding;
            h = a$1(p);
            y = c[d ? "floating" === g ? "reference" : "floating" : g];
            _context2.t0 = l$1;
            _context2.t1 = o;
            _context2.next = 24;
            return null == o.isElement ? void 0 : o.isElement(y);

          case 24:
            _context2.t3 = n = _context2.sent;
            _context2.t2 = null == _context2.t3;

            if (_context2.t2) {
              _context2.next = 28;
              break;
            }

            _context2.t2 = n;

          case 28:
            if (!_context2.t2) {
              _context2.next = 32;
              break;
            }

            _context2.t4 = y;
            _context2.next = 38;
            break;

          case 32:
            _context2.t5 = y.contextElement;

            if (_context2.t5) {
              _context2.next = 37;
              break;
            }

            _context2.next = 36;
            return null == o.getDocumentElement ? void 0 : o.getDocumentElement(c.floating);

          case 36:
            _context2.t5 = _context2.sent;

          case 37:
            _context2.t4 = _context2.t5;

          case 38:
            _context2.t6 = _context2.t4;
            _context2.t7 = u;
            _context2.t8 = m;
            _context2.t9 = f;
            _context2.t10 = {
              element: _context2.t6,
              boundary: _context2.t7,
              rootBoundary: _context2.t8,
              strategy: _context2.t9
            };
            _context2.next = 45;
            return _context2.t1.getClippingRect.call(_context2.t1, _context2.t10);

          case 45:
            _context2.t11 = _context2.sent;
            x = (0, _context2.t0)(_context2.t11);
            w = "floating" === g ? _extends({}, s.floating, { x: i, y: r }) : s.reference;
            _context2.next = 50;
            return null == o.getOffsetParent ? void 0 : o.getOffsetParent(c.floating);

          case 50:
            v = _context2.sent;
            _context2.next = 53;
            return null == o.isElement ? void 0 : o.isElement(v);

          case 53:
            _context2.t13 = _context2.sent;

            if (!_context2.t13) {
              _context2.next = 58;
              break;
            }

            _context2.next = 57;
            return null == o.getScale ? void 0 : o.getScale(v);

          case 57:
            _context2.t13 = _context2.sent;

          case 58:
            _context2.t12 = _context2.t13;

            if (_context2.t12) {
              _context2.next = 61;
              break;
            }

            _context2.t12 = { x: 1, y: 1 };

          case 61:
            b = _context2.t12;
            _context2.t14 = l$1;

            if (!o.convertOffsetParentRelativeRectToViewportRelativeRect) {
              _context2.next = 69;
              break;
            }

            _context2.next = 66;
            return o.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: w, offsetParent: v, strategy: f });

          case 66:
            _context2.t15 = _context2.sent;
            _context2.next = 70;
            break;

          case 69:
            _context2.t15 = w;

          case 70:
            _context2.t16 = _context2.t15;
            R = (0, _context2.t14)(_context2.t16);
            return _context2.abrupt("return", { top: (x.top - R.top + h.top) / b.y, bottom: (R.bottom - x.bottom + h.bottom) / b.y, left: (x.left - R.left + h.left) / b.x, right: (R.right - x.right + h.right) / b.x });

          case 73:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function s$1(_x6, _x7) {
    return _ref6.apply(this, arguments);
  };
}();

function _toConsumableArray2(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {}
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if ((typeof input === "undefined" ? "undefined" : _typeof2(input)) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if ((typeof res === "undefined" ? "undefined" : _typeof2(res)) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return (typeof key === "undefined" ? "undefined" : _typeof2(key)) === "symbol" ? key : String(key);
}

var umbrella_min = { exports: {} };

/* Umbrella JS 3.3.0 umbrellajs.com */

(function (module) {
  var u = function u(t, e) {
    return this instanceof u ? t instanceof u ? t : ((t = "string" == typeof t ? this.select(t, e) : t) && t.nodeName && (t = [t]), void (this.nodes = this.slice(t))) : new u(t, e);
  };u.prototype = { get length() {
      return this.nodes.length;
    } }, u.prototype.nodes = [], u.prototype.addClass = function () {
    return this.eacharg(arguments, function (t, e) {
      t.classList.add(e);
    });
  }, u.prototype.adjacent = function (o, t, i) {
    return "number" == typeof t && (t = 0 === t ? [] : new Array(t).join().split(",").map(Number.call, Number)), this.each(function (n, r) {
      var e = document.createDocumentFragment();u(t || {}).map(function (t, e) {
        e = "function" == typeof o ? o.call(this, t, e, n, r) : o;return "string" == typeof e ? this.generate(e) : u(e);
      }).each(function (t) {
        this.isInPage(t) ? e.appendChild(u(t).clone().first()) : e.appendChild(t);
      }), i.call(this, n, e);
    });
  }, u.prototype.after = function (t, e) {
    return this.adjacent(t, e, function (t, e) {
      t.parentNode.insertBefore(e, t.nextSibling);
    });
  }, u.prototype.append = function (t, e) {
    return this.adjacent(t, e, function (t, e) {
      t.appendChild(e);
    });
  }, u.prototype.args = function (t, e, n) {
    return (t = "string" != typeof (t = "function" == typeof t ? t(e, n) : t) ? this.slice(t).map(this.str(e, n)) : t).toString().split(/[\s,]+/).filter(function (t) {
      return t.length;
    });
  }, u.prototype.array = function (o) {
    var i = this;return this.nodes.reduce(function (t, e, n) {
      var r;return o ? (r = "string" == typeof (r = (r = o.call(i, e, n)) || !1) ? u(r) : r) instanceof u && (r = r.nodes) : r = e.innerHTML, t.concat(!1 !== r ? r : []);
    }, []);
  }, u.prototype.attr = function (t, e, r) {
    return r = r ? "data-" : "", this.pairs(t, e, function (t, e) {
      return t.getAttribute(r + e);
    }, function (t, e, n) {
      n ? t.setAttribute(r + e, n) : t.removeAttribute(r + e);
    });
  }, u.prototype.before = function (t, e) {
    return this.adjacent(t, e, function (t, e) {
      t.parentNode.insertBefore(e, t);
    });
  }, u.prototype.children = function (t) {
    return this.map(function (t) {
      return this.slice(t.children);
    }).filter(t);
  }, u.prototype.clone = function () {
    return this.map(function (t, e) {
      var n = t.cloneNode(!0),
          r = this.getAll(n);return this.getAll(t).each(function (t, e) {
        for (var n in this.mirror) {
          this.mirror[n] && this.mirror[n](t, r.nodes[e]);
        }
      }), n;
    });
  }, u.prototype.getAll = function (t) {
    return u([t].concat(u("*", t).nodes));
  }, u.prototype.mirror = {}, u.prototype.mirror.events = function (t, e) {
    if (t._e) for (var n in t._e) {
      t._e[n].forEach(function (t) {
        u(e).on(n, t.callback);
      });
    }
  }, u.prototype.mirror.select = function (t, e) {
    u(t).is("select") && (e.value = t.value);
  }, u.prototype.mirror.textarea = function (t, e) {
    u(t).is("textarea") && (e.value = t.value);
  }, u.prototype.closest = function (e) {
    return this.map(function (t) {
      do {
        if (u(t).is(e)) return t;
      } while ((t = t.parentNode) && t !== document);
    });
  }, u.prototype.data = function (t, e) {
    return this.attr(t, e, !0);
  }, u.prototype.each = function (t) {
    return this.nodes.forEach(t.bind(this)), this;
  }, u.prototype.eacharg = function (n, r) {
    return this.each(function (e, t) {
      this.args(n, e, t).forEach(function (t) {
        r.call(this, e, t);
      }, this);
    });
  }, u.prototype.empty = function () {
    return this.each(function (t) {
      for (; t.firstChild;) {
        t.removeChild(t.firstChild);
      }
    });
  }, u.prototype.filter = function (e) {
    var t = e instanceof u ? function (t) {
      return -1 !== e.nodes.indexOf(t);
    } : "function" == typeof e ? e : function (t) {
      return t.matches = t.matches || t.msMatchesSelector || t.webkitMatchesSelector, t.matches(e || "*");
    };return u(this.nodes.filter(t));
  }, u.prototype.find = function (e) {
    return this.map(function (t) {
      return u(e || "*", t);
    });
  }, u.prototype.first = function () {
    return this.nodes[0] || !1;
  }, u.prototype.generate = function (t) {
    return (/^\s*<tr[> ]/.test(t) ? u(document.createElement("table")).html(t).children().children().nodes : /^\s*<t(h|d)[> ]/.test(t) ? u(document.createElement("table")).html(t).children().children().children().nodes : /^\s*</.test(t) ? u(document.createElement("div")).html(t).children().nodes : document.createTextNode(t)
    );
  }, u.prototype.handle = function () {
    var t = this.slice(arguments).map(function (e) {
      return "function" == typeof e ? function (t) {
        t.preventDefault(), e.apply(this, arguments);
      } : e;
    }, this);return this.on.apply(this, t);
  }, u.prototype.hasClass = function () {
    return this.is("." + this.args(arguments).join("."));
  }, u.prototype.html = function (e) {
    return void 0 === e ? this.first().innerHTML || "" : this.each(function (t) {
      t.innerHTML = e;
    });
  }, u.prototype.is = function (t) {
    return 0 < this.filter(t).length;
  }, u.prototype.isInPage = function (t) {
    return t !== document.body && document.body.contains(t);
  }, u.prototype.last = function () {
    return this.nodes[this.length - 1] || !1;
  }, u.prototype.map = function (t) {
    return t ? u(this.array(t)).unique() : this;
  }, u.prototype.not = function (e) {
    return this.filter(function (t) {
      return !u(t).is(e || !0);
    });
  }, u.prototype.off = function (t, e, n) {
    var r = null == e && null == n,
        o = null,
        i = e;return "string" == typeof e && (o = e, i = n), this.eacharg(t, function (e, n) {
      u(e._e ? e._e[n] : []).each(function (t) {
        (r || t.orig_callback === i && t.selector === o) && e.removeEventListener(n, t.callback);
      });
    });
  }, u.prototype.on = function (t, e, o) {
    function i(t, e) {
      try {
        Object.defineProperty(t, "currentTarget", { value: e, configurable: !0 });
      } catch (t) {}
    }var c = null,
        n = e;"string" == typeof e && (c = e, n = o, e = function e(n) {
      var r = arguments;u(n.currentTarget).find(c).each(function (t) {
        var e;t.contains(n.target) && (e = n.currentTarget, i(n, t), o.apply(t, r), i(n, e));
      });
    });function r(t) {
      return e.apply(this, [t].concat(t.detail || []));
    }return this.eacharg(t, function (t, e) {
      t.addEventListener(e, r), t._e = t._e || {}, t._e[e] = t._e[e] || [], t._e[e].push({ callback: r, orig_callback: n, selector: c });
    });
  }, u.prototype.pairs = function (r, t, e, o) {
    var n;return void 0 !== t && (n = r, (r = {})[n] = t), "object" == (typeof r === "undefined" ? "undefined" : _typeof2(r)) ? this.each(function (t, e) {
      for (var n in r) {
        "function" == typeof r[n] ? o(t, n, r[n](t, e)) : o(t, n, r[n]);
      }
    }) : this.length ? e(this.first(), r) : "";
  }, u.prototype.param = function (e) {
    return Object.keys(e).map(function (t) {
      return this.uri(t) + "=" + this.uri(e[t]);
    }.bind(this)).join("&");
  }, u.prototype.parent = function (t) {
    return this.map(function (t) {
      return t.parentNode;
    }).filter(t);
  }, u.prototype.prepend = function (t, e) {
    return this.adjacent(t, e, function (t, e) {
      t.insertBefore(e, t.firstChild);
    });
  }, u.prototype.remove = function () {
    return this.each(function (t) {
      t.parentNode && t.parentNode.removeChild(t);
    });
  }, u.prototype.removeClass = function () {
    return this.eacharg(arguments, function (t, e) {
      t.classList.remove(e);
    });
  }, u.prototype.replace = function (t, e) {
    var n = [];return this.adjacent(t, e, function (t, e) {
      n = n.concat(this.slice(e.children)), t.parentNode.replaceChild(e, t);
    }), u(n);
  }, u.prototype.scroll = function () {
    return this.first().scrollIntoView({ behavior: "smooth" }), this;
  }, u.prototype.select = function (t, e) {
    return t = t.replace(/^\s*/, "").replace(/\s*$/, ""), /^</.test(t) ? u().generate(t) : (e || document).querySelectorAll(t);
  }, u.prototype.serialize = function () {
    var r = this;return this.slice(this.first().elements).reduce(function (e, n) {
      return !n.name || n.disabled || "file" === n.type || /(checkbox|radio)/.test(n.type) && !n.checked ? e : "select-multiple" === n.type ? (u(n.options).each(function (t) {
        t.selected && (e += "&" + r.uri(n.name) + "=" + r.uri(t.value));
      }), e) : e + "&" + r.uri(n.name) + "=" + r.uri(n.value);
    }, "").slice(1);
  }, u.prototype.siblings = function (t) {
    return this.parent().children(t).not(this);
  }, u.prototype.size = function () {
    return this.first().getBoundingClientRect();
  }, u.prototype.slice = function (t) {
    return t && 0 !== t.length && "string" != typeof t && "[object Function]" !== t.toString() ? t.length ? [].slice.call(t.nodes || t) : [t] : [];
  }, u.prototype.str = function (e, n) {
    return function (t) {
      return "function" == typeof t ? t.call(this, e, n) : t.toString();
    };
  }, u.prototype.text = function (e) {
    return void 0 === e ? this.first().textContent || "" : this.each(function (t) {
      t.textContent = e;
    });
  }, u.prototype.toggleClass = function (t, e) {
    return !!e === e ? this[e ? "addClass" : "removeClass"](t) : this.eacharg(t, function (t, e) {
      t.classList.toggle(e);
    });
  }, u.prototype.trigger = function (t) {
    var o = this.slice(arguments).slice(1);return this.eacharg(t, function (t, e) {
      var n,
          r = { bubbles: !0, cancelable: !0, detail: o };try {
        n = new window.CustomEvent(e, r);
      } catch (t) {
        (n = document.createEvent("CustomEvent")).initCustomEvent(e, !0, !0, o);
      }t.dispatchEvent(n);
    });
  }, u.prototype.unique = function () {
    return u(this.nodes.reduce(function (t, e) {
      return null != e && !1 !== e && -1 === t.indexOf(e) ? t.concat(e) : t;
    }, []));
  }, u.prototype.uri = function (t) {
    return encodeURIComponent(t).replace(/!/g, "%21").replace(/'/g, "%27").replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/\*/g, "%2A").replace(/%20/g, "+");
  }, u.prototype.wrap = function (t) {
    return this.map(function (e) {
      return u(t).each(function (t) {
        !function (t) {
          for (; t.firstElementChild;) {
            t = t.firstElementChild;
          }return u(t);
        }(t).append(e.cloneNode(!0)), e.parentNode.replaceChild(t, e);
      });
    });
  }, module.exports && (module.exports = u, module.exports.u = u);
})(umbrella_min);

var u$2 = umbrella_min.exports;

var Icons = "<svg id=\"GuidedTourIconSet\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" style=\"display: none;\">\n<symbol id=\"tour-icon-close\" viewBox=\"0 0 20 20\"><g fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\"><path d=\"M16,16 L4,4\"></path><path d=\"M16,4 L4,16\"></path></g></symbol>\n<symbol id=\"tour-icon-next\" viewBox=\"0 0 20 20\"><polyline points=\"7 4 13 10 7 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1\"></polyline></symbol>\n<symbol id=\"tour-icon-prev\" viewBox=\"0 0 20 20\"><polyline points=\"12 4 6 10 12 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1\"></polyline></symbol>\n<symbol id=\"tour-icon-complete\" viewBox=\"0 0 20 20\"><polyline points=\"4,10 8,15 17,4\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1\"></polyline></symbol>\n</svg>";

var COMPLETE = 'complete',
    CANCELED = 'canceled';

function raf(task) {
  if ('requestAnimationFrame' in window) {
    return window.requestAnimationFrame(task);
  }

  setTimeout(task, 16);
}

function setElementScroll$1(element, x, y) {

  if (element.self === element) {
    element.scrollTo(x, y);
  } else {
    element.scrollLeft = x;
    element.scrollTop = y;
  }
}

function getTargetScrollLocation(scrollSettings, parent) {
  var align = scrollSettings.align,
      target = scrollSettings.target,
      targetPosition = target.getBoundingClientRect(),
      parentPosition,
      x,
      y,
      differenceX,
      differenceY,
      targetWidth,
      targetHeight,
      leftAlign = align && align.left != null ? align.left : 0.5,
      topAlign = align && align.top != null ? align.top : 0.5,
      leftOffset = align && align.leftOffset != null ? align.leftOffset : 0,
      topOffset = align && align.topOffset != null ? align.topOffset : 0,
      leftScalar = leftAlign,
      topScalar = topAlign;

  if (scrollSettings.isWindow(parent)) {
    targetWidth = Math.min(targetPosition.width, parent.innerWidth);
    targetHeight = Math.min(targetPosition.height, parent.innerHeight);
    x = targetPosition.left + parent.pageXOffset - parent.innerWidth * leftScalar + targetWidth * leftScalar;
    y = targetPosition.top + parent.pageYOffset - parent.innerHeight * topScalar + targetHeight * topScalar;
    x -= leftOffset;
    y -= topOffset;
    x = scrollSettings.align.lockX ? parent.pageXOffset : x;
    y = scrollSettings.align.lockY ? parent.pageYOffset : y;
    differenceX = x - parent.pageXOffset;
    differenceY = y - parent.pageYOffset;
  } else {
    targetWidth = targetPosition.width;
    targetHeight = targetPosition.height;
    parentPosition = parent.getBoundingClientRect();
    var offsetLeft = targetPosition.left - (parentPosition.left - parent.scrollLeft);
    var offsetTop = targetPosition.top - (parentPosition.top - parent.scrollTop);
    x = offsetLeft + targetWidth * leftScalar - parent.clientWidth * leftScalar;
    y = offsetTop + targetHeight * topScalar - parent.clientHeight * topScalar;
    x -= leftOffset;
    y -= topOffset;
    x = Math.max(Math.min(x, parent.scrollWidth - parent.clientWidth), 0);
    y = Math.max(Math.min(y, parent.scrollHeight - parent.clientHeight), 0);
    x = scrollSettings.align.lockX ? parent.scrollLeft : x;
    y = scrollSettings.align.lockY ? parent.scrollTop : y;
    differenceX = x - parent.scrollLeft;
    differenceY = y - parent.scrollTop;
  }

  return {
    x: x,
    y: y,
    differenceX: differenceX,
    differenceY: differenceY
  };
}

function animate(parent) {
  var scrollSettings = parent._scrollSettings;

  if (!scrollSettings) {
    return;
  }

  var maxSynchronousAlignments = scrollSettings.maxSynchronousAlignments;

  var location = getTargetScrollLocation(scrollSettings, parent),
      time = Date.now() - scrollSettings.startTime,
      timeValue = Math.min(1 / scrollSettings.time * time, 1);

  if (scrollSettings.endIterations >= maxSynchronousAlignments) {
    setElementScroll$1(parent, location.x, location.y);
    parent._scrollSettings = null;
    return scrollSettings.end(COMPLETE);
  }

  var easeValue = 1 - scrollSettings.ease(timeValue);

  setElementScroll$1(parent, location.x - location.differenceX * easeValue, location.y - location.differenceY * easeValue);

  if (time >= scrollSettings.time) {
    scrollSettings.endIterations++;
    // Align ancestor synchronously
    scrollSettings.scrollAncestor && animate(scrollSettings.scrollAncestor);
    animate(parent);
    return;
  }

  raf(animate.bind(null, parent));
}

function defaultIsWindow(target) {
  return target.self === target;
}

function transitionScrollTo(target, parent, settings, scrollAncestor, callback) {
  var idle = !parent._scrollSettings,
      lastSettings = parent._scrollSettings,
      now = Date.now(),
      cancelHandler,
      passiveOptions = { passive: true };

  if (lastSettings) {
    lastSettings.end(CANCELED);
  }

  function end(endType) {
    parent._scrollSettings = null;

    if (parent.parentElement && parent.parentElement._scrollSettings) {
      parent.parentElement._scrollSettings.end(endType);
    }

    if (settings.debug) {
      console.log('Scrolling ended with type', endType, 'for', parent);
    }

    callback(endType);
    if (cancelHandler) {
      parent.removeEventListener('touchstart', cancelHandler, passiveOptions);
      parent.removeEventListener('wheel', cancelHandler, passiveOptions);
    }
  }

  var maxSynchronousAlignments = settings.maxSynchronousAlignments;

  if (maxSynchronousAlignments == null) {
    maxSynchronousAlignments = 3;
  }

  parent._scrollSettings = {
    startTime: now,
    endIterations: 0,
    target: target,
    time: settings.time,
    ease: settings.ease,
    align: settings.align,
    isWindow: settings.isWindow || defaultIsWindow,
    maxSynchronousAlignments: maxSynchronousAlignments,
    end: end,
    scrollAncestor: scrollAncestor
  };

  if (!('cancellable' in settings) || settings.cancellable) {
    cancelHandler = end.bind(null, CANCELED);
    parent.addEventListener('touchstart', cancelHandler, passiveOptions);
    parent.addEventListener('wheel', cancelHandler, passiveOptions);
  }

  if (idle) {
    animate(parent);
  }

  return cancelHandler;
}

function defaultIsScrollable(element) {
  return 'pageXOffset' in element || (element.scrollHeight !== element.clientHeight || element.scrollWidth !== element.clientWidth) && getComputedStyle(element).overflow !== 'hidden';
}

function defaultValidTarget() {
  return true;
}

function findParentElement(el) {
  if (el.assignedSlot) {
    return findParentElement(el.assignedSlot);
  }

  if (el.parentElement) {
    if (el.parentElement.tagName === 'BODY') {
      return el.parentElement.ownerDocument.defaultView || el.parentElement.ownerDocument.ownerWindow;
    }
    return el.parentElement;
  }

  if (el.getRootNode) {
    var parent = el.getRootNode();
    if (parent.nodeType === 11) {
      return parent.host;
    }
  }
}

var scrollIntoView = function scrollIntoView(target, settings, callback) {
  if (!target) {
    return;
  }

  if (typeof settings === 'function') {
    callback = settings;
    settings = null;
  }

  if (!settings) {
    settings = {};
  }

  settings.time = isNaN(settings.time) ? 1000 : settings.time;
  settings.ease = settings.ease || function (v) {
    return 1 - Math.pow(1 - v, v / 2);
  };
  settings.align = settings.align || {};

  var parent = findParentElement(target),
      parents = 1;

  function done(endType) {
    parents--;
    if (!parents) {
      callback && callback(endType);
    }
  }

  var validTarget = settings.validTarget || defaultValidTarget;
  var isScrollable = settings.isScrollable;

  if (settings.debug) {
    console.log('About to scroll to', target);

    if (!parent) {
      console.error('Target did not have a parent, is it mounted in the DOM?');
    }
  }

  var scrollingElements = [];

  while (parent) {
    if (settings.debug) {
      console.log('Scrolling parent node', parent);
    }

    if (validTarget(parent, parents) && (isScrollable ? isScrollable(parent, defaultIsScrollable) : defaultIsScrollable(parent))) {
      parents++;
      scrollingElements.push(parent);
    }

    parent = findParentElement(parent);

    if (!parent) {
      done(COMPLETE);
      break;
    }
  }

  return scrollingElements.reduce(function (cancel, parent, index) {
    return transitionScrollTo(target, parent, settings, scrollingElements[index + 1], done);
  }, null);
};

function assert(assertion, message) {
  if (!assertion) throw "TourguideJS: ".concat(message);
  return true;
}

function clamp(number, min, max) {
  min = isNaN(min) ? number : min;
  max = isNaN(max) ? number : max;
  return Math.max(min, Math.min(number, max));
}
function getDataContents() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parts = data.split(";");
  var result = _objectSpread2({}, defaults);
  parts.forEach(function (part) {
    var entries = (part || "").split(":");
    result[(entries[0] || "").trim()] = (entries[1] || "").trim();
  });
  return result;
}
function isTargetValid(target) {
  return target && target.offsetParent !== null;
}

/**
 * getting bounding client rect and additional properties
 * @param {Element | string} element target element or selector
 * @param {Element} root root element
 * @returns {{ width: number, height: number, top: number, bottom: number, left: number, right: number, viewTop: number, viewBottom: number, viewLeft: number, viewRight: number }} object
 */
function getBoundingClientRect(element, root) {
  var rect = u$2(element).size();
  var view = getViewportRect(root);
  return {
    width: rect.width,
    height: rect.height,
    top: rect.top + view.scrollY,
    bottom: rect.bottom + view.scrollY,
    left: rect.left + view.scrollX,
    right: rect.right + view.scrollX,
    viewTop: rect.top,
    viewBottom: rect.bottom,
    viewLeft: rect.left,
    viewRight: rect.right
  };
}

/**
 * getting viewport rect and additional properties
 * @param {Element | string} element target element or selector
 * @returns {{ width: number, height: number, scrollX: number, scrollY: number, rootWidth: number, rootHeight: number, rootTop: number, rootLeft: number }} object
 */
function getViewportRect(element) {
  try {
    var rect = u$2(element).size();
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      scrollX: window.scrollX,
      scrollY: window.scrollY,
      rootWidth: rect.width,
      rootHeight: rect.height,
      rootTop: rect.top,
      rootLeft: rect.left
    };
  } catch (error) {
    console.error(error);
    throw Error("element is invalid: ".concat(element));
  }
}
function setStyle(element, styleObj) {
  Object.keys(styleObj).forEach(function (key) {
    if (typeof styleObj[key] === "number") {
      styleObj[key] = Math.floor(styleObj[key]) + "px";
    }
  });
  Object.assign(u$2(element).first().style, styleObj);
}

/**
 * convert the color object to the sets of css variables
 * @param {Object<string, string | number>} colors color object
 * @param {string} [prefix] prefix of css variable name. default: "--tourguide"
 * @param {string} [selector] target css selector. default: ":root"
 * @returns {string} converted string
 * @example
 *  input: { overlay: "gray", background: "white", bulletCurrent: "red" }
 *  output: ":root { --tourguide-overlay: gray; --tourguide-background: white; --tourguide-bullet-current: red; }"
 */
function colorObjToStyleVarString(colors) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "--tourguide";
  var selector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ":host";
  var styleArray = [];
  Object.entries(colors).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
    var splitNameArray = [prefix];
    var prevIndex = 0;
    for (var i = 0; i < key.length; i += 1) {
      if ("A" <= key[i] && key[i] <= "Z") {
        splitNameArray.push(key.substring(prevIndex, i).toLowerCase());
        prevIndex = i;
      }
    }
    splitNameArray.push(key.substring(prevIndex, key.length).toLowerCase());
    styleArray.push("".concat(splitNameArray.join("-"), ": ").concat(value));
  });
  return "".concat(selector, " {\n").concat(styleArray.join(";\n"), ";\n}");
}

/**
 * scroll element by coordinates (cross browser support)
 * @param {Element} element target element
 * @param {number} x scroll offset from left
 * @param {number} y scroll offset from top
 */
function setElementScroll(element, x, y) {
  if (element.self === element) {
    element.scrollTo(x, y);
  } else {
    element.scrollLeft = x;
    element.scrollTop = y;
  }
}

/**
 * Smooth scroll element by coordinates (cross browser support)
 * @param {{ element: Element, x: number, y: number }[]} scrollItems
 * @param {number} time duration time
 */
function animateScroll(scrollItems, time) {
  var startTime = Date.now();
  function raf(task) {
    if ("requestAnimationFrame" in window) {
      return window.requestAnimationFrame(task);
    }
    setTimeout(task, 16);
  }
  function ease(v) {
    return 1 - Math.pow(1 - v, v / 2);
  }
  function animate(el, x, y) {
    if (!el) {
      console.warn("target element ".concat(el, " not found, skip"));
      return;
    }
    var diffTime = Date.now() - startTime;
    var timeValue = Math.min(1 / time * diffTime, 1);
    var easeValue = 1 - ease(timeValue);
    var differenceX = x - el.scrollLeft;
    var differenceY = y - el.scrollTop;
    setElementScroll(el, x - differenceX * easeValue, y - differenceY * easeValue);
    if (diffTime >= time) {
      setElementScroll(el, x, y);
      return;
    }
    raf(animate.bind(null, el, x, y));
  }
  scrollItems.forEach(function (item) {
    animate(item.element, item.x, item.y);
  });
}

/**
 * Getting scroll coordinates (cross browser support)
 * @param {Element | string} target target element
 * @returns {{ element: Element, x: number, y: number }[]} scrollItems
 */
function getScrollCoordinates(target) {
  var scrollItems = [];
  var targetUEl = u$2(target);
  do {
    if (!targetUEl) targetUEl = false;
    if (!targetUEl.first()) targetUEl = false;
    try {
      var element = targetUEl.first();
      if (element.scrollHeight !== element.height || element.scrollWidth !== element.width) {
        scrollItems.push({
          element: targetUEl.first(),
          x: targetUEl.first().scrollLeft,
          y: targetUEl.first().scrollTop
        });
      }
      targetUEl = targetUEl.parent();
    } catch (error) {
      targetUEl = false;
    }
  } while (targetUEl);
  return scrollItems;
}
function getMaxZIndex() {
  return Math.max.apply(Math, _toConsumableArray(Array.from(document.querySelectorAll('body *'), function (el) {
    return parseFloat(window.getComputedStyle(el).zIndex);
  }).filter(function (zIndex) {
    return !Number.isNaN(zIndex);
  })).concat([0]));
}

function t$1(t) {
  return t.split("-")[0];
}function e$1(t) {
  return t.split("-")[1];
}function n$2(e) {
  return ["top", "bottom"].includes(t$1(e)) ? "x" : "y";
}function i$1(t) {
  return "y" === t ? "height" : "width";
}function r$2(r, o, a) {
  var l = r.reference,
      s = r.floating;
  var c = l.x + l.width / 2 - s.width / 2,
      f = l.y + l.height / 2 - s.height / 2,
      u = n$2(o),
      m = i$1(u),
      g = l[m] / 2 - s[m] / 2,
      d = "x" === u;var p = void 0;switch (t$1(o)) {case "top":
      p = { x: c, y: l.y - s.height };break;case "bottom":
      p = { x: c, y: l.y + l.height };break;case "right":
      p = { x: l.x + l.width, y: f };break;case "left":
      p = { x: l.x - s.width, y: f };break;default:
      p = { x: l.x, y: l.y };}switch (e$1(o)) {case "start":
      p[u] -= g * (a && d ? -1 : 1);break;case "end":
      p[u] += g * (a && d ? -1 : 1);}return p;
}var o$1 = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(t, e, n) {
    var _n$placement, i, _n$strategy, o, _n$middleware, a, l, s, c, f, _r$, u, m, g, d, p, _n2, _r$2, _s$_n, _a, _h, _ref5, _y2, _x5, _w, _v;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _n$placement = n.placement;
            i = _n$placement === undefined ? "bottom" : _n$placement;
            _n$strategy = n.strategy;
            o = _n$strategy === undefined ? "absolute" : _n$strategy;
            _n$middleware = n.middleware;
            a = _n$middleware === undefined ? [] : _n$middleware;
            l = n.platform;
            s = a.filter(Boolean);
            _context.next = 10;
            return null == l.isRTL ? void 0 : l.isRTL(e);

          case 10:
            c = _context.sent;
            _context.next = 13;
            return l.getElementRects({ reference: t, floating: e, strategy: o });

          case 13:
            f = _context.sent;
            _r$ = r$2(f, i, c);
            u = _r$.x;
            m = _r$.y;
            g = i;
            d = {};
            p = 0;
            _n2 = 0;

          case 21:
            if (!(_n2 < s.length)) {
              _context.next = 56;
              break;
            }

            _s$_n = s[_n2];
            _a = _s$_n.name;
            _h = _s$_n.fn;
            _context.next = 27;
            return _h({ x: u, y: m, initialPlacement: i, placement: g, strategy: o, middlewareData: d, rects: f, platform: l, elements: { reference: t, floating: e } });

          case 27:
            _ref5 = _context.sent;
            _y2 = _ref5.x;
            _x5 = _ref5.y;
            _w = _ref5.data;
            _v = _ref5.reset;
            u = null != _y2 ? _y2 : u;
            m = null != _x5 ? _x5 : m;
            d = _extends({}, d, _defineProperty2({}, _a, _extends({}, d[_a], _w)));
            _context.t0 = _v && p <= 50;

            if (!_context.t0) {
              _context.next = 53;
              break;
            }

            p++;
            _context.t1 = "object" == (typeof _v === "undefined" ? "undefined" : _typeof2(_v));

            if (!_context.t1) {
              _context.next = 52;
              break;
            }

            _v.placement && (g = _v.placement);
            _context.t2 = _v.rects;

            if (!_context.t2) {
              _context.next = 51;
              break;
            }

            if (!(!0 === _v.rects)) {
              _context.next = 49;
              break;
            }

            _context.next = 46;
            return l.getElementRects({ reference: t, floating: e, strategy: o });

          case 46:
            _context.t3 = _context.sent;
            _context.next = 50;
            break;

          case 49:
            _context.t3 = _v.rects;

          case 50:
            f = _context.t3;

          case 51:
            _r$2 = r$2(f, g, c), u = _r$2.x, m = _r$2.y, _r$2;

          case 52:
            _n2 = -1;

          case 53:
            _n2++;
            _context.next = 21;
            break;

          case 56:
            return _context.abrupt("return", { x: u, y: m, placement: g, strategy: o, middlewareData: d });

          case 57:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function o$1(_x2, _x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}();function a$1(t) {
  return "number" != typeof t ? function (t) {
    return _extends({ top: 0, right: 0, bottom: 0, left: 0 }, t);
  }(t) : { top: t, right: t, bottom: t, left: t };
}function l$1(t) {
  return _extends({}, t, { top: t.y, left: t.x, right: t.x + t.width, bottom: t.y + t.height });
}var c$1 = Math.min,
    f$1 = Math.max;function u$1(t, e, n) {
  return f$1(t, c$1(e, n));
}var m$1 = function m$1(t) {
  return { name: "arrow", options: t, fn: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(r) {
        var _data, _ref9;

        var _ref8, o, _ref8$padding, l, s, c, f, m, g, d, p, h, y, x, w, v, b, R, A, P, T, O, E, L, D, k, B;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _ref8 = null != t ? t : {}, o = _ref8.element, _ref8$padding = _ref8.padding, l = _ref8$padding === undefined ? 0 : _ref8$padding, s = r.x, c = r.y, f = r.placement, m = r.rects, g = r.platform;

                if (!(null == o)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", {});

              case 3:
                d = a$1(l);
                p = { x: s, y: c };
                h = n$2(f);
                y = e$1(f);
                x = i$1(h);
                _context3.next = 10;
                return g.getDimensions(o);

              case 10:
                w = _context3.sent;
                v = "y" === h ? "top" : "left";
                b = "y" === h ? "bottom" : "right";
                R = m.reference[x] + m.reference[h] - p[h] - m.floating[x];
                A = p[h] - m.reference[h];
                _context3.next = 17;
                return null == g.getOffsetParent ? void 0 : g.getOffsetParent(o);

              case 17:
                P = _context3.sent;
                T = P ? "y" === h ? P.clientHeight || 0 : P.clientWidth || 0 : 0;
                0 === T && (T = m.floating[x]);O = R / 2 - A / 2, E = d[v], L = T - w[x] - d[b], D = T / 2 - w[x] / 2 + O, k = u$1(E, D, L), B = ("start" === y ? d[v] : d[b]) > 0 && D !== k && m.reference[x] <= m.floating[x];
                return _context3.abrupt("return", (_ref9 = {}, _defineProperty2(_ref9, h, p[h] - (B ? D < E ? E - D : L - D : 0)), _defineProperty2(_ref9, "data", (_data = {}, _defineProperty2(_data, h, k), _defineProperty2(_data, "centerOffset", D - k), _data)), _ref9));

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fn(_x8) {
        return _ref7.apply(this, arguments);
      }

      return fn;
    }()
  };
},
    g$1 = { left: "right", right: "left", bottom: "top", top: "bottom" };function d$1(t) {
  return t.replace(/left|right|bottom|top/g, function (t) {
    return g$1[t];
  });
}function p$1(t, r, o) {
  void 0 === o && (o = !1);var a = e$1(t),
      l = n$2(t),
      s = i$1(l);var c = "x" === l ? a === (o ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";return r.reference[s] > r.floating[s] && (c = d$1(c)), { main: c, cross: d$1(c) };
}var h$1 = { start: "end", end: "start" };function y$1(t) {
  return t.replace(/start|end/g, function (t) {
    return h$1[t];
  });
}var x$1 = ["top", "right", "bottom", "left"],
    w$1 = x$1.reduce(function (t, e) {
  return t.concat(e, e + "-start", e + "-end");
}, []);var v$1 = function v$1(n) {
  return void 0 === n && (n = {}), { name: "autoPlacement", options: n, fn: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(i) {
        var r, o, a, l, c, f, u, m, g, d, h, x, _n3, _n3$alignment, v, _n3$allowedPlacements, b, _n3$autoAlignment, R, A, P, T, O, E, _p$, L, D, k, B, C, H, V, S;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                f = i.x;
                u = i.y;
                m = i.rects;
                g = i.middlewareData;
                d = i.placement;
                h = i.platform;
                x = i.elements;
                _n3 = n;
                _n3$alignment = _n3.alignment;
                v = _n3$alignment === undefined ? null : _n3$alignment;
                _n3$allowedPlacements = _n3.allowedPlacements;
                b = _n3$allowedPlacements === undefined ? w$1 : _n3$allowedPlacements;
                _n3$autoAlignment = _n3.autoAlignment;
                R = _n3$autoAlignment === undefined ? !0 : _n3$autoAlignment;
                A = _objectWithoutProperties(_n3, ["alignment", "allowedPlacements", "autoAlignment"]);

                P = function (n, i, r) {
                  return (n ? [].concat(_toConsumableArray2(r.filter(function (t) {
                    return e$1(t) === n;
                  })), _toConsumableArray2(r.filter(function (t) {
                    return e$1(t) !== n;
                  }))) : r.filter(function (e) {
                    return t$1(e) === e;
                  })).filter(function (t) {
                    return !n || e$1(t) === n || !!i && y$1(t) !== t;
                  });
                }(v, R, b);

                _context4.next = 18;
                return s$1(i, A);

              case 18:
                T = _context4.sent;
                O = null != (r = null == (o = g.autoPlacement) ? void 0 : o.index) ? r : 0;
                E = P[O];

                if (!(null == E)) {
                  _context4.next = 23;
                  break;
                }

                return _context4.abrupt("return", {});

              case 23:
                _context4.t0 = p$1;
                _context4.t1 = E;
                _context4.t2 = m;
                _context4.next = 28;
                return null == h.isRTL ? void 0 : h.isRTL(x.floating);

              case 28:
                _context4.t3 = _context4.sent;
                _p$ = (0, _context4.t0)(_context4.t1, _context4.t2, _context4.t3);
                L = _p$.main;
                D = _p$.cross;

                if (!(d !== E)) {
                  _context4.next = 34;
                  break;
                }

                return _context4.abrupt("return", { x: f, y: u, reset: { placement: P[0] } });

              case 34:
                k = [T[t$1(E)], T[L], T[D]], B = [].concat(_toConsumableArray2(null != (a = null == (l = g.autoPlacement) ? void 0 : l.overflows) ? a : []), [{ placement: E, overflows: k }]), C = P[O + 1];

                if (!C) {
                  _context4.next = 37;
                  break;
                }

                return _context4.abrupt("return", { data: { index: O + 1, overflows: B }, reset: { placement: C } });

              case 37:
                H = B.slice().sort(function (t, e) {
                  return t.overflows[0] - e.overflows[0];
                }), V = null == (c = H.find(function (t) {
                  var e = t.overflows;
                  return e.every(function (t) {
                    return t <= 0;
                  });
                })) ? void 0 : c.placement, S = null != V ? V : H[0].placement;
                return _context4.abrupt("return", S !== d ? { data: { index: O + 1, overflows: B }, reset: { placement: S } } : {});

              case 39:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fn(_x9) {
        return _ref10.apply(this, arguments);
      }

      return fn;
    }()
  };
};var T$1 = function T$1(i) {
  return void 0 === i && (i = 0), { name: "offset", options: i, fn: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(r) {
        var o, a, l;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                o = r.x;
                a = r.y;
                _context6.next = 4;
                return function () {
                  var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(i, r) {
                    var o, a, l, s, c, f, u, m, g, d, _ref13, p, h, y;

                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            o = i.placement;
                            a = i.platform;
                            l = i.elements;
                            _context5.next = 5;
                            return null == a.isRTL ? void 0 : a.isRTL(l.floating);

                          case 5:
                            s = _context5.sent;
                            c = t$1(o);
                            f = e$1(o);
                            u = "x" === n$2(o);
                            m = ["left", "top"].includes(c) ? -1 : 1;
                            g = s && u ? -1 : 1;
                            d = "function" == typeof r ? r(i) : r;
                            _ref13 = "number" == typeof d ? { mainAxis: d, crossAxis: 0, alignmentAxis: null } : _extends({ mainAxis: 0, crossAxis: 0, alignmentAxis: null }, d), p = _ref13.mainAxis, h = _ref13.crossAxis, y = _ref13.alignmentAxis;
                            return _context5.abrupt("return", (f && "number" == typeof y && (h = "end" === f ? -1 * y : y), u ? { x: h * g, y: p * m } : { x: p * m, y: h * g }));

                          case 14:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, this);
                  }));

                  return function (_x11, _x12) {
                    return _ref12.apply(this, arguments);
                  };
                }()(r, i);

              case 4:
                l = _context6.sent;
                return _context6.abrupt("return", { x: o + l.x, y: a + l.y, data: l });

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function fn(_x10) {
        return _ref11.apply(this, arguments);
      }

      return fn;
    }()
  };
};

function n$1(t) {
  var e;return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}function o(t) {
  return n$1(t).getComputedStyle(t);
}function i(t) {
  return f(t) ? (t.nodeName || "").toLowerCase() : "";
}var r$1 = void 0;function l() {
  if (r$1) return r$1;var t = navigator.userAgentData;return t && Array.isArray(t.brands) ? (r$1 = t.brands.map(function (t) {
    return t.brand + "/" + t.version;
  }).join(" "), r$1) : navigator.userAgent;
}function c(t) {
  return t instanceof n$1(t).HTMLElement;
}function s(t) {
  return t instanceof n$1(t).Element;
}function f(t) {
  return t instanceof n$1(t).Node;
}function u(t) {
  if ("undefined" == typeof ShadowRoot) return !1;return t instanceof n$1(t).ShadowRoot || t instanceof ShadowRoot;
}function a(t) {
  var _o = o(t),
      e = _o.overflow,
      n = _o.overflowX,
      i = _o.overflowY,
      r = _o.display;

  return (/auto|scroll|overlay|hidden/.test(e + i + n) && !["inline", "contents"].includes(r)
  );
}function d(t) {
  return ["table", "td", "th"].includes(i(t));
}function h(t) {
  var e = /firefox/i.test(l()),
      n = o(t),
      i = n.backdropFilter || n.WebkitBackdropFilter;return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || ["transform", "perspective"].some(function (t) {
    return n.willChange.includes(t);
  }) || ["paint", "layout", "strict", "content"].some(function (t) {
    var e = n.contain;return null != e && e.includes(t);
  });
}function g() {
  return !/^((?!chrome|android).)*safari/i.test(l());
}function m(t) {
  return ["html", "body", "#document"].includes(i(t));
}var p = { x: 1, y: 1 };function y(t) {
  var e = !s(t) && t.contextElement ? t.contextElement : s(t) ? t : null;if (!e) return p;var n = e.getBoundingClientRect(),
      i = o(e);var r = n.width / parseFloat(i.width),
      l = n.height / parseFloat(i.height);return r && Number.isFinite(r) || (r = 1), l && Number.isFinite(l) || (l = 1), { x: r, y: l };
}function w(t, e, o, i) {
  var r, l, c, f;void 0 === e && (e = !1), void 0 === o && (o = !1);var u = t.getBoundingClientRect();var a = p;e && (i ? s(i) && (a = y(i)) : a = y(t));var d = s(t) ? n$1(t) : window,
      h = !g() && o,
      m = (u.left + (h && null != (r = null == (l = d.visualViewport) ? void 0 : l.offsetLeft) ? r : 0)) / a.x,
      w = (u.top + (h && null != (c = null == (f = d.visualViewport) ? void 0 : f.offsetTop) ? c : 0)) / a.y,
      x = u.width / a.x,
      v = u.height / a.y;return { width: x, height: v, top: w, right: m + x, bottom: w + v, left: m, x: m, y: w };
}function x(t) {
  return ((f(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}function v(t) {
  return s(t) ? { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop } : { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
}function b(t) {
  return w(x(t)).left + v(t).scrollLeft;
}function L(t, e, n) {
  var o = c(e),
      r = x(e),
      l = w(t, !0, "fixed" === n, e);var s = { scrollLeft: 0, scrollTop: 0 };var f = { x: 0, y: 0 };if (o || !o && "fixed" !== n) if (("body" !== i(e) || a(r)) && (s = v(e)), c(e)) {
    var _t = w(e, !0);f.x = _t.x + e.clientLeft, f.y = _t.y + e.clientTop;
  } else r && (f.x = b(r));return { x: l.left + s.scrollLeft - f.x, y: l.top + s.scrollTop - f.y, width: l.width, height: l.height };
}function E(t) {
  if ("html" === i(t)) return t;var e = t.assignedSlot || t.parentNode || (u(t) ? t.host : null) || x(t);return u(e) ? e.host : e;
}function R(t) {
  return c(t) && "fixed" !== o(t).position ? t.offsetParent : null;
}function T(t) {
  var e = n$1(t);var r = R(t);for (; r && d(r) && "static" === o(r).position;) {
    r = R(r);
  }return r && ("html" === i(r) || "body" === i(r) && "static" === o(r).position && !h(r)) ? e : r || function (t) {
    var e = E(t);for (; c(e) && !m(e);) {
      if (h(e)) return e;e = E(e);
    }return null;
  }(t) || e;
}var W = Math.min,
    C = Math.max;function D(t) {
  var e = E(t);return m(e) ? t.ownerDocument.body : c(e) && a(e) ? e : D(e);
}function F(t, e) {
  var o;void 0 === e && (e = []);var i = D(t),
      r = i === (null == (o = t.ownerDocument) ? void 0 : o.body),
      l = n$1(i);return r ? e.concat(l, l.visualViewport || [], a(i) ? i : []) : e.concat(i, F(i));
}function A(e, i, r) {
  return "viewport" === i ? l$1(function (t, e) {
    var o = n$1(t),
        i = x(t),
        r = o.visualViewport;var l = i.clientWidth,
        c = i.clientHeight,
        s = 0,
        f = 0;if (r) {
      l = r.width, c = r.height;var _t2 = g();(_t2 || !_t2 && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
    }return { width: l, height: c, x: s, y: f };
  }(e, r)) : s(i) ? function (t, e) {
    var n = w(t, !0, "fixed" === e),
        o = n.top + t.clientTop,
        i = n.left + t.clientLeft,
        r = c(t) ? y(t) : { x: 1, y: 1 },
        l = t.clientWidth * r.x,
        s = t.clientHeight * r.y,
        f = i * r.x,
        u = o * r.y;return { top: u, left: f, right: f + l, bottom: u + s, x: f, y: u, width: l, height: s };
  }(i, r) : l$1(function (t) {
    var e;var n = x(t),
        i = v(t),
        r = null == (e = t.ownerDocument) ? void 0 : e.body,
        l = C(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0),
        c = C(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0);var s = -i.scrollLeft + b(t);var f = -i.scrollTop;return "rtl" === o(r || n).direction && (s += C(n.clientWidth, r ? r.clientWidth : 0) - l), { width: l, height: c, x: s, y: f };
  }(x(e)));
}var H = { getClippingRect: function getClippingRect(t) {
    var e = t.element,
        n = t.boundary,
        r = t.rootBoundary,
        l = t.strategy;
    var c = "clippingAncestors" === n ? function (t, e) {
      var n = e.get(t);if (n) return n;var r = F(t).filter(function (t) {
        return s(t) && "body" !== i(t);
      }),
          l = null;var c = "fixed" === o(t).position;var f = c ? E(t) : t;for (; s(f) && !m(f);) {
        var _t3 = o(f),
            _e3 = h(f);(c ? _e3 || l : _e3 || "static" !== _t3.position || !l || !["absolute", "fixed"].includes(l.position)) ? l = _t3 : r = r.filter(function (t) {
          return t !== f;
        }), f = E(f);
      }return e.set(t, r), r;
    }(e, this._c) : [].concat(n),
        f = [].concat(_toConsumableArray2(c), [r]),
        u = f[0],
        a = f.reduce(function (t, n) {
      var o = A(e, n, l);return t.top = C(o.top, t.top), t.right = W(o.right, t.right), t.bottom = W(o.bottom, t.bottom), t.left = C(o.left, t.left), t;
    }, A(e, u, l));return { width: a.right - a.left, height: a.bottom - a.top, x: a.left, y: a.top };
  }, convertOffsetParentRelativeRectToViewportRelativeRect: function convertOffsetParentRelativeRectToViewportRelativeRect(t) {
    var e = t.rect,
        n = t.offsetParent,
        o = t.strategy;
    var r = c(n),
        l = x(n);if (n === l) return e;var s = { scrollLeft: 0, scrollTop: 0 },
        f = { x: 1, y: 1 };var u = { x: 0, y: 0 };if ((r || !r && "fixed" !== o) && (("body" !== i(n) || a(l)) && (s = v(n)), c(n))) {
      var _t4 = w(n);f = y(n), u.x = _t4.x + n.clientLeft, u.y = _t4.y + n.clientTop;
    }return { width: e.width * f.x, height: e.height * f.y, x: e.x * f.x - s.scrollLeft * f.x + u.x, y: e.y * f.y - s.scrollTop * f.y + u.y };
  }, isElement: s, getDimensions: function getDimensions(t) {
    if (c(t)) return { width: t.offsetWidth, height: t.offsetHeight };var e = w(t);return { width: e.width, height: e.height };
  }, getOffsetParent: T, getDocumentElement: x, getScale: y, getElementRects: function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(t) {
      var e, n, o, i, r;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              e = t.reference, n = t.floating, o = t.strategy;
              i = this.getOffsetParent || T, r = this.getDimensions;
              _context7.t0 = L;
              _context7.t1 = e;
              _context7.next = 6;
              return i(n);

            case 6:
              _context7.t2 = _context7.sent;
              _context7.t3 = o;
              _context7.t4 = (0, _context7.t0)(_context7.t1, _context7.t2, _context7.t3);
              _context7.t5 = _extends;
              _context7.t6 = { x: 0, y: 0 };
              _context7.next = 13;
              return r(n);

            case 13:
              _context7.t7 = _context7.sent;
              _context7.t8 = (0, _context7.t5)(_context7.t6, _context7.t7);
              return _context7.abrupt("return", {
                reference: _context7.t4,
                floating: _context7.t8
              });

            case 16:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function getElementRects(_x13) {
      return _ref14.apply(this, arguments);
    }

    return getElementRects;
  }(),
  getClientRects: function getClientRects(t) {
    return Array.from(t.getClientRects());
  }, isRTL: function isRTL(t) {
    return "rtl" === o(t).direction;
  } };var O = function O(t, n, o) {
  var i = new Map(),
      r = _extends({ platform: H }, o),
      l = _extends({}, r.platform, { _c: i });return o$1(t, n, _extends({}, r, { platform: l }));
};

var e = { "": ["<em>", "</em>"], _: ["<strong>", "</strong>"], "*": ["<strong>", "</strong>"], "~": ["<s>", "</s>"], "\n": ["<br />"], " ": ["<br />"], "-": ["<hr />"] };function n(e) {
  return e.replace(RegExp("^" + (e.match(/^(\t| )+/) || "")[0], "gm"), "");
}function r(e) {
  return (e + "").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}function t(a, c) {
  var o,
      l,
      g,
      s,
      p,
      u = /((?:^|\n+)(?:\n---+|\* \*(?: \*)+)\n)|(?:^``` *(\w*)\n([\s\S]*?)\n```$)|((?:(?:^|\n+)(?:\t|  {2,}).+)+\n*)|((?:(?:^|\n)([>*+-]|\d+\.)\s+.*)+)|(?:!\[([^\]]*?)\]\(([^)]+?)\))|(\[)|(\](?:\(([^)]+?)\))?)|(?:(?:^|\n+)([^\s].*)\n(-{3,}|={3,})(?:\n+|$))|(?:(?:^|\n+)(#{1,6})\s*(.+)(?:\n+|$))|(?:`([^`].*?)`)|(  \n\n*|\n{2,}|__|\*\*|[_*]|~~)/gm,
      m = [],
      h = "",
      i = c || {},
      d = 0;function f(n) {
    var r = e[n[1] || ""],
        t = m[m.length - 1] == n;return r ? r[1] ? (t ? m.pop() : m.push(n), r[0 | t]) : r[0] : n;
  }function $() {
    for (var e = ""; m.length;) {
      e += f(m[m.length - 1]);
    }return e;
  }for (a = a.replace(/^\[(.+?)\]:\s*(.+)$/gm, function (e, n, r) {
    return i[n.toLowerCase()] = r, "";
  }).replace(/^\n+|\n+$/g, ""); g = u.exec(a);) {
    l = a.substring(d, g.index), d = u.lastIndex, o = g[0], l.match(/[^\\](\\\\)*\\$/) || ((p = g[3] || g[4]) ? o = '<pre class="code ' + (g[4] ? "poetry" : g[2].toLowerCase()) + '"><code' + (g[2] ? ' class="language-' + g[2].toLowerCase() + '"' : "") + ">" + n(r(p).replace(/^\n+|\n+$/g, "")) + "</code></pre>" : (p = g[6]) ? (p.match(/\./) && (g[5] = g[5].replace(/^\d+/gm, "")), s = t(n(g[5].replace(/^\s*[>*+.-]/gm, ""))), ">" == p ? p = "blockquote" : (p = p.match(/\./) ? "ol" : "ul", s = s.replace(/^(.*)(\n|$)/gm, "<li>$1</li>")), o = "<" + p + ">" + s + "</" + p + ">") : g[8] ? o = '<img src="' + r(g[8]) + '" alt="' + r(g[7]) + '">' : g[10] ? (h = h.replace("<a>", '<a href="' + r(g[11] || i[l.toLowerCase()]) + '">'), o = $() + "</a>") : g[9] ? o = "<a>" : g[12] || g[14] ? o = "<" + (p = "h" + (g[14] ? g[14].length : g[13] > "=" ? 1 : 2)) + ">" + t(g[12] || g[15], i) + "</" + p + ">" : g[16] ? o = "<code>" + r(g[16]) + "</code>" : (g[17] || g[1]) && (o = f(g[17] || "--"))), h += l, h += o;
  }return (h + a.substring(d) + $()).replace(/^\n+|\n+$/g, "");
}

var keepinview = function keepinview(_ref) {
  var _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 0 : _ref$padding;
  return {
    name: "keepinview",
    fn: function fn(_ref2) {
      var x = _ref2.x,
          y = _ref2.y,
          rects = _ref2.rects,
          middlewareData = _ref2.middlewareData,
          platform = _ref2.platform;
      var documentDimentions = platform.getDimensions(document.body);
      var _x = clamp(x, padding, documentDimentions.width - rects.floating.width - padding);
      var _y = clamp(y, padding, documentDimentions.height - rects.floating.height - padding);
      var dx = x - _x;
      var dy = y - _y;
      var arrow = middlewareData.arrow;
      if (arrow) {
        if (arrow.x && dx) arrow.x += dx;
        if (arrow.y && dy) arrow.y += dy;
      }
      return {
        x: _x,
        y: _y
      };
    }
  };
};
function positionTooltip(target, tooltipEl, arrowEl, context) {
  //context._options.root
  O(target, tooltipEl, {
    // placement: 'bottom-start',
    middleware: [
    // flip(),
    v$1({
      alignment: 'bottom-start'
    }), T$1(function (props) {
      var side = props.placement.split("-")[0];
      switch (side) {
        case "top":
          return 32;
        case "left":
        case "right":
          return 24;
        default:
          return 6;
      }
    }), m$1({
      element: arrowEl,
      padding: 8
    }), keepinview({
      padding: 24
    })]
  }).then(function (_ref3) {
    var x = _ref3.x,
        y = _ref3.y,
        middlewareData = _ref3.middlewareData,
        placement = _ref3.placement;
    setStyle(tooltipEl, {
      left: "".concat(x, "px"),
      top: "".concat(y, "px")
    });
    if (middlewareData.arrow) {
      var side = placement.split("-")[0];
      var staticSide = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[side];
      setStyle(arrowEl, _defineProperty({
        left: middlewareData.arrow.x != null ? "".concat(middlewareData.arrow.x, "px") : '',
        top: middlewareData.arrow.y != null ? "".concat(middlewareData.arrow.y, "px") : '',
        right: "",
        bottom: ""
      }, staticSide, "".concat(-arrowEl.offsetWidth / 2, "px")));
    }
  });
}
var Step = /*#__PURE__*/function () {
  function Step(step, context) {
    var _this = this;
    _classCallCheck(this, Step);
    this.active = false;
    this.first = false;
    this.last = false;
    this.container = null;
    this.highlight = null;
    this.tooltip = null;
    this.arrow = null;
    this.context = context;
    this._target = null;
    this._timerHandler = null;
    this._scrollCancel = null;
    var data;
    if (!(step instanceof HTMLElement)) {
      data = step;
      this._selector = step.selector;
    } else {
      this.target = step;
      data = getDataContents(u$2(step).data("tour"));
    }
    assert(data.hasOwnProperty("title"), "missing required step parameter: title\n" + JSON.stringify(data, null, 2) + "\n" + "see this doc for more detail: https://github.com/LikaloLLC/tourguide.js#json-based-approach");
    assert(data.hasOwnProperty("content"), "missing required step parameter: content\n" + JSON.stringify(data, null, 2) + "\n" + "see this doc for more detail: https://github.com/LikaloLLC/tourguide.js#json-based-approach");
    this.index = parseInt(data.step);
    this.title = data.title;
    this.content = t(data.content);
    this.image = data.image;
    this.width = data.width;
    this.height = data.height;
    this.layout = data.layout || "vertical";
    this.placement = data.placement || "bottom";
    this.overlay = data.overlay !== false;
    this.navigation = data.navigation !== false;
    if (data.image && context.options.preloadimages && !/^data:/i.test(data.image)) {
      var preload = new Image();
      // preload.onload = (e) => {
      // };
      preload.onerror = function () {
        console.error(new Error("Invalid image URL: ".concat(data.image)));
        _this.image = null;
      };
      preload.src = this.image;
    }
    this.actions = [];
    if (data.actions) {
      if (!Array.isArray(data.actions)) {
        console.error(new Error("actions must be array but got ".concat(_typeof(data.actions))));
      } else {
        this.actions = data.actions;
      }
    }
    // this.adjust = this.adjust.bind(this);
  }
  _createClass(Step, [{
    key: "el",
    get: function get() {
      var _this2 = this;
      if (!this.container) {
        var image = u$2("<div role=\"figure\" class=\"guided-tour-step-image\">".concat(this.image ? "<img src=\"".concat(this.image, "\" />") : "", "</div>"));
        var content = u$2("<div class=\"guided-tour-step-content-wrapper\">\n        <div id=\"tooltip-title-".concat(this.index, "\" role=\"heading\" class=\"guided-tour-step-title\">").concat(this.context._decorateText(this.title, this), "</div>\n        <div class=\"guided-tour-step-content\">").concat(this.context._decorateText(this.content, this), "</div>\n      </div>"));
        content.find('a').on('click', function (e) {
          _this2.context.action(e, {
            action: "link"
          });
        });
        if (Array.isArray(this.actions) && this.actions.length > 0) {
          var actions = u$2("<div class=\"guided-tour-step-actions\">\n          ".concat(this.actions.map(function (action, index) {
            return "<".concat(action.href ? "a" : "button", " id=\"").concat(action.id, "\" ").concat(action.href ? "href=\"".concat(action.href, "\"") : "", " ").concat(action.target ? "target=\"".concat(action.target, "\"") : "", " class=\"button").concat(action.primary ? " primary" : "", "\" data-index=\"").concat(index, "\">").concat(action.label, "</").concat(action.href ? "a" : "button", ">");
          }).join(""), "\n        </div>"));
          actions.find('a, button').on('click', function (e) {
            var action = _this2.actions[parseInt(e.target.dataset.index)];
            if (action.action) e.preventDefault();
            _this2.context.action(e, action);
          });
          content.append(actions);
        }
        var tooltip = this.tooltip = u$2("<div role=\"document\" class=\"guided-tour-step-tooltip\"></div>");
        if (this.width) setStyle(tooltip, {
          width: this.width + "px",
          maxWidth: this.width + "px"
        });
        if (this.height) setStyle(tooltip, {
          height: this.height + "px",
          maxHeight: this.height + "px"
        });
        var tooltipinner = u$2("<div class=\"guided-tour-step-tooltip-inner".concat(this.layout === "horizontal" ? " step-layout-horizontal" : "", "\"></div>"));
        var container = u$2("<div class=\"guided-tour-step-content-container\"></div>");
        container.append(image).append(content);
        var _arrow = this.arrow = u$2("<div class=\"guided-tour-arrow\"></div>");
        if (this.navigation) {
          var footer = u$2("<div class=\"guided-tour-step-footer\">\n                  <button class=\"guided-tour-step-button guided-tour-step-button-close\" title=\"End tour\">\n                      <svg class=\"guided-tour-icon\" viewBox=\"0 0 20 20\" width=\"16\" height=\"16\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#tour-icon-close\"></use></svg>\n                  </button>\n                  ".concat(!this.first ? "<button class=\"guided-tour-step-button guided-tour-step-button-prev\" title=\"Prev step\">\n                    <svg class=\"guided-tour-icon\" viewBox=\"0 0 20 20\" width=\"32\" height=\"32\">\n                      <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#tour-icon-prev\"></use>\n                    </svg>\n                  </button>" : "", "\n                  ").concat(this.last ? "<button class=\"guided-tour-step-button guided-tour-step-button-complete\" title=\"Complete tour\">\n                    <svg class=\"guided-tour-icon\" viewBox=\"0 0 20 20\" width=\"32\" height=\"32\">\n                      <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#tour-icon-complete\"></use>\n                    </svg>\n                  </button>" : "<button class=\"guided-tour-step-button guided-tour-step-button-next\" title=\"Next step\">\n                    <svg class=\"guided-tour-icon\" viewBox=\"0 0 20 20\" width=\"32\" height=\"32\">\n                      <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#tour-icon-next\"></use>\n                    </svg>\n                  </button>", "\n                  ").concat(this.context._steps.length > 1 ? "<div class=\"guided-tour-step-bullets\">\n                      <ul>".concat(this.context._steps.map(function (step, i) {
            return "<li><button title=\"Go to step ".concat(i + 1, "\" data-index=\"").concat(i, "\" class=\"").concat(step.index < _this2.index ? "complete" : step.index == _this2.index ? "current" : "", "\"></button></li>");
          }).join(""), "</ul>\n                  </div>") : "", "\n              </div>"));
          footer.find(".guided-tour-step-button-prev").on("click", this.context.previous);
          footer.find(".guided-tour-step-button-next").on("click", this.context.next);
          footer.find(".guided-tour-step-button-close").on("click", this.context.stop);
          footer.find(".guided-tour-step-button-complete").on("click", this.context.complete);
          footer.find(".guided-tour-step-bullets button").on("click", function (e) {
            return _this2.context.go(parseInt(u$2(e.target).data("index")));
          });
          tooltipinner.append(_arrow).append(container).append(footer);
        } else tooltipinner.append(_arrow).append(container);
        tooltip.append(tooltipinner);
        this.container = u$2("<div role=\"dialog\" aria-labelleby=\"tooltip-title-".concat(this.index, "\" class=\"guided-tour-step").concat(this.first ? " guided-tour-step-first" : "").concat(this.last ? " guided-tour-step-last" : "", "\"></div>"));
        if (this.overlay && isTargetValid(this.target)) {
          var highlight = this.highlight = u$2("<div class=\"guided-tour-step-highlight\"></div>");
          this.container.append(highlight).append(tooltip);
        } else this.container.append(tooltip);
      }
      return this.container;
    }
  }, {
    key: "target",
    get: function get() {
      return this._target || this._selector && u$2(this._selector).first();
    },
    set: function set(target) {
      this._target = target;
    }
  }, {
    key: "attach",
    value: function attach(root) {
      u$2(root).append(this.el);
    }
  }, {
    key: "remove",
    value: function remove() {
      this.hide();
      this.el.remove();
    }
  }, {
    key: "position",
    value: function position() {
      var view = getViewportRect(this.context._options.root);
      var tooltip = this.tooltip;
      var highlight = this.highlight;
      var highlightStyle = {
        top: 0,
        left: 0,
        width: 0,
        height: 0
      };
      if (isTargetValid(this.target)) {
        if (this.overlay && this.highlight) {
          var targetRect = getBoundingClientRect(this.target, this.context._options.root);
          highlightStyle.top = "".concat(targetRect.top - this.context.options.padding, "px");
          highlightStyle.left = "".concat(targetRect.left - this.context.options.padding, "px");
          highlightStyle.width = "".concat(targetRect.width + this.context.options.padding * 2, "px");
          highlightStyle.height = "".concat(targetRect.height + this.context.options.padding * 2, "px");
          setStyle(highlight, highlightStyle);
        }
        positionTooltip(this.target, tooltip.first(), this.arrow.first(), this.context);
      } else {
        if (this.overlay && this.highlight) setStyle(highlight, highlightStyle);
        var tootipStyle = {};
        var tooltipRect = getBoundingClientRect(tooltip, this.context._options.root);
        tootipStyle.top = view.height / 2 + view.scrollY - view.rootTop - tooltipRect.height / 2;
        tootipStyle.left = view.width / 2 + view.scrollX - view.rootLeft - tooltipRect.width / 2;
        tootipStyle.bottom = "unset";
        tootipStyle.right = "unset";
        tooltip.addClass("guided-tour-arrow-none");
        setStyle(tooltip, tootipStyle);
        if (this.overlay) this.context._overlay.show();
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (this._timerHandler) clearTimeout(this._timerHandler);
      if (this._scrollCancel) this._scrollCancel();
    }
  }, {
    key: "show",
    value: function show() {
      var _this3 = this;
      this.cancel();
      if (!this.active) {
        var show = function show() {
          _this3.el.addClass("active"); // Add 'active' first to calculate the tooltip real size on the DOM.
          _this3.context._overlay.hide();
          _this3.position();
          _this3.active = true;
          _this3.container.find(".guided-tour-step-tooltip, button.primary, .guided-tour-step-button-complete, .guided-tour-step-button-next").last().focus({
            preventScroll: true
          });
        };
        var animationspeed = clamp(this.context.options.animationspeed, 120, 1000);
        if (isTargetValid(this.target)) {
          this._scrollCancel = scrollIntoView(this.target, {
            time: animationspeed,
            cancellable: false,
            align: {
              top: 0.5,
              left: 0.5
            }
          });
        }
        this._timerHandler = setTimeout(show, animationspeed * 3);
        return true;
      }
      return false;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.cancel();
      if (this.active) {
        this.el.removeClass("active");
        this.tooltip.removeClass("guided-tour-arrow-top");
        this.tooltip.removeClass("guided-tour-arrow-bottom");
        if (this.overlay) this.context._overlay.show();
        this.active = false;
        return true;
      }
      return false;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var index = this.index,
          title = this.title,
          content = this.content,
          image = this.image,
          active = this.active;
      return {
        index: index,
        title: title,
        content: content,
        image: image,
        active: active
      };
    }
  }]);
  return Step;
}();

var Overlay = /*#__PURE__*/function () {
  function Overlay(context) {
    _classCallCheck(this, Overlay);
    this.context = context;
    this.container = null;
    this.active = false;
  }
  _createClass(Overlay, [{
    key: "el",
    get: function get() {
      if (!this.container) {
        this.container = u$2("<div role=\"dialog\" class=\"guided-tour-overlay\"></div>");
      }
      return this.container;
    }
  }, {
    key: "attach",
    value: function attach(root) {
      u$2(root).append(this.el);
    }
  }, {
    key: "remove",
    value: function remove() {
      this.hide();
      this.el.remove();
    }
  }, {
    key: "show",
    value: function show() {
      if (!this.active) {
        this.el.addClass("active");
        this.active = true;
        return true;
      }
      return false;
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.active) {
        this.el.removeClass("active");
        this.active = false;
        return true;
      }
      return false;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var active = this.active;
      return {
        active: active
      };
    }
  }]);
  return Overlay;
}();

function hexToRGB(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : null;
}
function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}
function rgbToHex(r, g, b) {
  return "#" + componentToHex(Math.floor(r)) + componentToHex(Math.floor(g)) + componentToHex(Math.floor(b));
}
function RGBToHSL(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;
  var l = Math.max(r, g, b);
  var s = l - Math.min(r, g, b);
  var h = s ? l === r ? (g - b) / s : l === g ? 2 + (b - r) / s : 4 + (r - g) / s : 0;
  return [60 * h < 0 ? 60 * h + 360 : 60 * h, 100 * (s ? l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s)) : 0), 100 * (2 * l - s) / 2];
}
function HSLToRGB(h, s, l) {
  s /= 100;
  l /= 100;
  var k = function k(n) {
    return (n + h / 30) % 12;
  };
  var a = s * Math.min(l, 1 - l);
  var f = function f(n) {
    return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  };
  return [255 * f(0), 255 * f(8), 255 * f(4)];
}
function hexToHSL(hex) {
  return RGBToHSL.apply(null, hexToRGB(hex));
}
function HSLToHex(h, s, l) {
  return rgbToHex.apply(null, HSLToRGB(h, s, l));
}
function adjust(hex, h, s, l) {
  var hsl = hexToHSL(hex);
  hsl[0] = clamp(hsl[0] * h, 0, 255);
  hsl[1] = clamp(hsl[1] * s, 0, 255);
  hsl[2] = clamp(hsl[2] * l, 0, 255);
  return HSLToHex.apply(null, hsl);
}
function setAutoColors(defaultStyle, optionsStyle) {
  var style = Object.assign(defaultStyle, optionsStyle || {});
  var filter = /Color$/;
  var accentColor = style.accentColor;
  Object.keys(style).filter(function (key) {
    return filter.test(key) && style[key] === "auto";
  }).forEach(function (key) {
    switch (key) {
      case "focusColor":
      case "stepButtonNextColor":
      case "stepButtonCompleteColor":
      case "bulletCurrentColor":
        style[key] = accentColor;
        break;
      case "bulletColor":
        style[key] = adjust(accentColor, 1, 0.8, 1.4);
        break;
      case "bulletVisitedColor":
        style[key] = adjust(accentColor, 1, 0.3, 1.2);
        break;
      case "stepButtonPrevColor":
      case "stepButtonCloseColor":
        style[key] = adjust(accentColor, 1, 0.2, 0.8);
        break;
    }
  });
  return style;
}

var ActionHandler = /*#__PURE__*/_createClass(function ActionHandler(name, handlerFn) {
  _classCallCheck(this, ActionHandler);
  this.name = name;
  this.onAction = handlerFn;
});

function parseProperties(props) {
  return (props || "").split(",").map(function (p) {
    return p.trim();
  }).filter(Boolean);
}
function getMatches(str, regex) {
  var matches = [],
      m;
  regex.lastIndex = 0;
  while ((m = regex.exec(str)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }

    // The result can be accessed through the `m`-variable.
    // m.forEach((match, groupIndex) => {
    matches.push({
      match: m[0],
      start: m.index,
      length: m[0].length,
      properties: parseProperties(m[1])
    });
    // });
  }

  return matches;
}
var ContentDecorator = /*#__PURE__*/function () {
  function ContentDecorator(match, decoratorFn) {
    _classCallCheck(this, ContentDecorator);
    if (typeof match === 'string') this.match = new RegExp("{s*".concat(match.trim(), "s*(,.+?)?s*?}"), 'gmi');else this.match = match;
    this.decoratorFn = decoratorFn;
  }
  _createClass(ContentDecorator, [{
    key: "test",
    value: function test(text) {
      return this.match.test(text);
    }
  }, {
    key: "render",
    value: function render(text, step, context) {
      try {
        var matches = getMatches(text, this.match).reverse();
        return this.decoratorFn(text, matches, step, context);
      } catch (e) {
        console.warn(e);
        return text;
      }
    }
  }]);
  return ContentDecorator;
}();

var Style = ":host {\n  position: absolute;\n  overflow: visible;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 0;\n  box-sizing: border-box;\n  line-height: 1.4;\n  text-align: left;\n  text-rendering: optimizespeed;\n  font-family: var(--tourguide-font-family);\n  font-size: var(--tourguide-font-size);\n  color: var(--tourguide-text-color);\n  /* 1 */\n  -webkit-text-size-adjust: 100%;\n  /* 2 */\n  -moz-tab-size: 4;\n  /* 3 */\n  tab-size: 4;\n  /* 3 */\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  background: none;\n  border: none;\n  border-width: 0;\n  border-style: none;\n  border-color: currentColor;\n  box-shadow: none;\n  color: inherit;\n  appearance: none;\n  font-size: inherit;\n  font-weight: inherit;\n  text-decoration: none;\n}\n\na,\nbutton {\n  cursor: pointer;\n}\na:hover, a:focus,\nbutton:hover,\nbutton:focus {\n  outline: 5px auto var(--tourguide-focus-color);\n}\n\n.guided-tour-overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  background-color: var(--tourguide-overlay-color);\n}\n.guided-tour-overlay.active {\n  display: block;\n}\n\n.guided-tour-step {\n  display: none;\n}\n.guided-tour-step.active {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: all;\n}\n.guided-tour-step.active .guided-tour-step-highlight {\n  position: absolute;\n  box-sizing: border-box;\n  border-radius: 4px;\n  box-shadow: 0 0 0 999em var(--tourguide-overlay-color);\n  z-index: 1;\n}\n.guided-tour-step.active .guided-tour-step-tooltip {\n  position: absolute;\n  margin: 16px 0;\n  z-index: 2;\n  background-color: var(--tourguide-background-color);\n  width: var(--tourguide-tooltip-width);\n  max-width: max-content;\n  border-radius: 5px;\n  box-sizing: border-box;\n  box-shadow: 0 0 3em -0.8em #000;\n  transition: opacity 150ms;\n}\n@media screen and (max-width: 760px) {\n  .guided-tour-step.active .guided-tour-step-tooltip {\n    max-width: 85vw;\n    width: max-content !important;\n  }\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-arrow {\n  position: absolute;\n  width: 1em;\n  height: 1em;\n  background: var(--tourguide-background-color);\n  z-index: -1;\n  transform: rotate(45deg);\n  pointer-events: none;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content-container {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  height: calc(100% - 2.6em);\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-image {\n  flex-grow: 1;\n  flex-shrink: 1;\n  overflow: hidden;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-image img {\n  width: 100%;\n  height: 100%;\n  border-radius: 4px 4px 0 0;\n  object-fit: cover;\n  object-position: center;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content-wrapper {\n  margin: 1.5em 2.5em;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-title {\n  font-size: 1.4em;\n  margin-bottom: 0.8em;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content {\n  flex-shrink: 0;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content b,\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content strong {\n  font-weight: bold;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content i,\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content em {\n  font-style: italic;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content a {\n  cursor: pointer;\n  text-decoration: underline;\n  color: var(--tourguide-accent-color);\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content mark {\n  background: inherit;\n  text-shadow: 0px 2px 4px #ff0;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content code,\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content dfn {\n  padding: 1px 6px 1px 4px;\n  border-radius: 4px;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content code {\n  background-color: #f0f0f0;\n  color: #e83e8c;\n  font-family: monospace;\n  font-size: 87.5%;\n  word-break: break-word;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content dfn {\n  font-style: italic;\n  background-color: #ffc6e5;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content p,\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content ul,\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content ol,\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content blockquote {\n  margin: 1em 0;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content p:last-child,\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content ul:last-child,\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content ol:last-child,\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content blockquote:last-child {\n  margin-bottom: 0;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content blockquote {\n  padding-left: 1em;\n  border-left: 4px solid silver;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content ul,\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content ol {\n  padding-left: 1.5em;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content ul li,\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-content ol li {\n  margin: 0.3em 0;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-actions {\n  display: flex;\n  column-gap: 0.5em;\n  margin-top: 1.5em;\n  justify-content: end;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-actions .button {\n  color: var(--tourguide-accent-color);\n  padding: 0.5em 1em;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-actions .button.primary {\n  background: var(--tourguide-accent-color);\n  padding: 0.5em 1.5em;\n  color: #fff;\n  border-radius: 4px;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-actions .button.primary:hover, .guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-actions .button.primary:focus {\n  filter: brightness(120%);\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-icon {\n  display: inline-block;\n  overflow: hidden;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-button {\n  flex-direction: column;\n  justify-content: center;\n  /* <-- actual veertical align */\n  display: inline-flex;\n  text-align: center;\n  cursor: pointer;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-button .guided-tour-icon {\n  align-self: center;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-button-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 2em;\n  height: 2em;\n  color: var(--tourguide-step-button-close-color);\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-button-prev,\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-button-next,\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-button-complete {\n  width: 3em;\n  height: 3em;\n  background: var(--tourguide-background-color);\n  border-radius: 50%;\n  margin-top: -1.5em;\n  position: absolute;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-button-prev {\n  color: var(--tourguide-step-button-prev-color);\n  left: 0;\n  transform: translateX(-50%);\n  top: 50%;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-button-next {\n  color: var(--tourguide-step-button-next-color);\n  right: 0;\n  transform: translateX(50%);\n  top: 50%;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-button-complete {\n  color: var(--tourguide-step-button-complete-color);\n  right: 0;\n  transform: translateX(50%);\n  top: 50%;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-footer {\n  flex-shrink: 0;\n  flex-grow: 0;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-bullets {\n  text-align: center;\n  line-height: 16px;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-bullets ul {\n  list-style: none;\n  margin: 0 1em 1em;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-bullets ul li {\n  display: inline-block;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-bullets ul li button {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n  background-color: var(--tourguide-bullet-color);\n  border: 8px solid var(--tourguide-background-color);\n  box-sizing: content-box;\n  cursor: pointer;\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-bullets ul li button.complete {\n  background-color: var(--tourguide-bullet-visited-color);\n}\n.guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner .guided-tour-step-bullets ul li button.current {\n  background-color: var(--tourguide-bullet-current-color);\n}\n@media screen and (min-width: 760px) {\n  .guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner.step-layout-horizontal .guided-tour-step-content-container {\n    flex-direction: row;\n    height: 100%;\n  }\n  .guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner.step-layout-horizontal .guided-tour-step-content-container .guided-tour-step-content-wrapper {\n    flex: 1 1 auto;\n  }\n  .guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner.step-layout-horizontal .guided-tour-step-content-container .guided-tour-step-image {\n    width: 50%;\n    margin-bottom: calc((1em + 24px) * -1);\n    flex: 0 0 auto;\n  }\n  .guided-tour-step.active .guided-tour-step-tooltip .guided-tour-step-tooltip-inner.step-layout-horizontal .guided-tour-step-content-container .guided-tour-step-image img {\n    border-radius: 4px 0 0 4px;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n}\n.guided-tour-step.active .guided-tour-step-tooltip.guided-tour-arrow-none .guided-tour-step-tooltip-inner .guided-tour-arrow {\n  display: none;\n}";

var StepsSource = {
  DOM: 0,
  JSON: 1,
  REMOTE: 2
};
var defaultKeyNavOptions = {
  next: "ArrowRight",
  prev: "ArrowLeft",
  first: "Home",
  last: "End",
  complete: null,
  stop: "Escape"
};
var defaultStyle = {
  fontFamily: 'sans-serif',
  fontSize: "14px",
  tooltipWidth: "40vw",
  overlayColor: "rgba(0, 0, 0, 0.5)",
  textColor: "#333",
  accentColor: "#0d6efd",
  focusColor: "auto",
  bulletColor: "auto",
  bulletVisitedColor: "auto",
  bulletCurrentColor: "auto",
  stepButtonCloseColor: "auto",
  stepButtonPrevColor: "auto",
  stepButtonNextColor: "auto",
  stepButtonCompleteColor: "auto",
  backgroundColor: "#fff"
};
function isEventAttrbutesMatched(event, keyOption) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "keyup";
  if (_typeof(event) === "object") {
    var eventAttrsMap = {
      type: type
    };
    if (typeof keyOption === "number") {
      eventAttrsMap.keyCode = keyOption;
    } else if (typeof keyOption === "string") {
      eventAttrsMap.key = keyOption;
    } else if (_typeof(keyOption) === "object") {
      eventAttrsMap = _objectSpread2(_objectSpread2({}, keyOption), {}, {
        type: type
      });
    } else {
      throw new Error("keyboardNavigation option invalid. should be predefined object or false. Check documentation.");
    }
    var eventAttrs = Object.entries(eventAttrsMap).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
      return {
        key: key,
        value: value
      };
    });
    return !eventAttrs.filter(function (attr) {
      return event[attr.key] !== attr.value;
    }).length;
  }
  return false;
}
var Tour = /*#__PURE__*/function () {
  function Tour() {
    var _this = this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Tour);
    this._options = Object.assign({
      root: "body",
      selector: "[data-tour]",
      animationspeed: 120,
      padding: 5,
      steps: null,
      src: null,
      restoreinitialposition: true,
      preloadimages: false,
      request: {
        options: {
          mode: "cors",
          cache: "no-cache"
        },
        headers: {
          "Content-Type": "application/json"
        }
      },
      keyboardNavigation: defaultKeyNavOptions,
      actionHandlers: [],
      contentDecorators: [],
      onStart: function onStart() {},
      onStop: function onStop() {},
      onComplete: function onComplete() {},
      onStep: function onStep() {},
      onAction: function onAction() {}
    }, options, {
      style: setAutoColors(defaultStyle, options.colors || options.style)
    });
    this._overlay = null;
    this._steps = [];
    this._current = 0;
    this._active = false;
    this._stepsSrc = StepsSource.DOM;
    this._ready = false;
    this._initialposition = null;
    if (_typeof(this._options.steps) === "object" && Array.isArray(this._options.steps)) {
      this._stepsSrc = StepsSource.JSON;
      this._steps = this._options.steps.map(function (o, index) {
        return new Step(_objectSpread2(_objectSpread2({}, o), {}, {
          step: o.step || index
        }), _this);
      });
      this._ready = true;
    } else if (typeof this._options.src === "string") {
      this._stepsSrc = StepsSource.REMOTE;
      fetch(new Request(this._options.src, this._options.request)).then(function (response) {
        return response.json().then(function (data) {
          _this._steps = data.map(function (o, index) {
            return new Step(_objectSpread2(_objectSpread2({}, o), {}, {
              step: o.step || index
            }), _this);
          });
          _this._ready = true;
        });
      });
    } else if (u$2(this._options.selector).length > 0) {
      this._stepsSrc = StepsSource.DOM;
      this._ready = true;
    } else {
      throw new Error("Tour is not configured properly. Check documentation.");
    }
    this._containerElement = document.createElement("aside");
    this._containerElement.classList.add("__guided-tour-container");
    u$2(this._options.root).append(this._containerElement);
    this._shadowRoot = this._containerElement.attachShadow({
      mode: "closed"
    });
    this._injectIcons();
    this._injectStyles();
    this.start = this.start.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.go = this.go.bind(this);
    this.stop = this.stop.bind(this);
    this.complete = this.complete.bind(this);
    // this.action = this.action.bind(this);
    this._keyboardHandler = this._keyboardHandler.bind(this);
  }
  _createClass(Tour, [{
    key: "currentstep",
    get: function get() {
      return this._steps[this._current];
    }
  }, {
    key: "length",
    get: function get() {
      return this._steps.length;
    }
  }, {
    key: "steps",
    get: function get() {
      return this._steps.map(function (step) {
        return step.toJSON();
      });
    }
  }, {
    key: "hasnext",
    get: function get() {
      return this.nextstep !== this._current;
    }
  }, {
    key: "nextstep",
    get: function get() {
      return clamp(this._current + 1, 0, this.length - 1);
    }
  }, {
    key: "previousstep",
    get: function get() {
      return clamp(this._current - 1, 0);
    }
  }, {
    key: "options",
    get: function get() {
      return this._options;
    }
  }, {
    key: "_injectIcons",
    value: function _injectIcons() {
      if (u$2("#GuidedTourIconSet", this._shadowRoot).length === 0) {
        u$2(this._shadowRoot).append(u$2(Icons));
      }
    }
  }, {
    key: "_injectStyles",
    value: function _injectStyles() {
      // const global = u("<style>.__guided-tour-active{position:relative!important}</style>");
      // u(":root > head").append(global);
      var style = u$2("<style>".concat(Style, "</style>"));
      u$2(this._shadowRoot).append(style);
      var colors = u$2("<style>".concat(colorObjToStyleVarString(this._options.style, "--tourguide"), "</style>"));
      u$2(this._shadowRoot).append(colors);
    }
  }, {
    key: "_keyboardHandler",
    value: function _keyboardHandler(event) {
      if (this._options.keyboardNavigation.next && isEventAttrbutesMatched(event, this._options.keyboardNavigation.next)) {
        this.next();
      } else if (this._options.keyboardNavigation.prev && isEventAttrbutesMatched(event, this._options.keyboardNavigation.prev)) {
        this.previous();
      } else if (this._options.keyboardNavigation.first && isEventAttrbutesMatched(event, this._options.keyboardNavigation.first)) {
        this.go(0);
      } else if (this._options.keyboardNavigation.last && isEventAttrbutesMatched(event, this._options.keyboardNavigation.last)) {
        this.go(this._steps.length - 1);
      } else if (this._options.keyboardNavigation.stop && isEventAttrbutesMatched(event, this._options.keyboardNavigation.stop)) {
        this.stop();
      } else if (this._options.keyboardNavigation.complete && isEventAttrbutesMatched(event, this._options.keyboardNavigation.complete)) {
        this.complete();
      }
    }
  }, {
    key: "_decorateText",
    value: function _decorateText(text, step) {
      var _this2 = this;
      var _text = text;
      this._options.contentDecorators.forEach(function (decorator) {
        if (decorator.test(_text)) _text = decorator.render(_text, step, _this2);
      });
      return _text;
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;
      this.reset();
      // u(this._options.root).addClass("guided-tour");
      this._overlay = new Overlay(this);
      if (this._stepsSrc === StepsSource.DOM) {
        var steps = u$2(this._options.selector).nodes;
        this._steps = steps.map(function (el) {
          return new Step(el, _this3);
        });
      }
      this._steps = this._steps.sort(function (a, b) {
        return a.index - b.index;
      });
      this._steps[0].first = true;
      this._steps[this.length - 1].last = true;
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this._active) this.stop();
      if (this._stepsSrc === StepsSource.DOM) {
        this._steps = [];
      }
      this._current = 0;
    }
  }, {
    key: "start",
    value: function start() {
      var _this4 = this;
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (this._ready) {
        this._containerElement.style.zIndex = getMaxZIndex() + 1;
        if (this._options.restoreinitialposition) {
          this._initialposition = getScrollCoordinates(this._options.root);
        }
        if (!this._active) {
          u$2(this._options.root).addClass("__guided-tour-active");
          this.init();
          this._overlay.attach(this._shadowRoot);
          this._steps.forEach(function (step) {
            return step.attach(_this4._shadowRoot);
          });
          this._current = step;
          this.currentstep.show();
          this._active = true;
          this._options.onStart(this._options);
          if (this._options.keyboardNavigation) {
            if (Object.prototype.toString.call(this._options.keyboardNavigation) !== "[object Object]") throw new Error("keyboardNavigation option invalid. should be predefined object or false. Check documentation.");
            u$2(":root").on("keyup", this._keyboardHandler);
          }
        } else {
          this.go(step, "start");
        }
      } else {
        setTimeout(function () {
          _this4.start(step);
        }, 50);
      }
    }
  }, {
    key: "action",
    value: function action(event, _action) {
      if (this._active) {
        switch (_action.action) {
          case "next":
            this.next();
            break;
          case "previous":
            this.previous();
            break;
          case "stop":
            this.stop();
            break;
          case "complete":
            this.complete();
            break;
          default:
            {
              var handler = this._options.actionHandlers.find(function (handler) {
                return handler.name === _action.action;
              });
              if (handler) handler.onAction(event, _action, this);
            }
        }
        if (typeof this._options.onAction === "function") {
          this._options.onAction(event, _action, this);
        }
      }
    }
  }, {
    key: "next",
    value: function next() {
      if (this._active) {
        this.go(this.nextstep, "next");
      }
    }
  }, {
    key: "previous",
    value: function previous() {
      if (this._active) {
        this.go(this.previousstep, "previous");
      }
    }
  }, {
    key: "go",
    value: function go(step, type) {
      if (this._active && this._current !== step) {
        this.currentstep.hide();
        this._current = clamp(step, 0, this.length - 1);
        this.currentstep.show();
        this._options.onStep(this.currentstep, type);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this._active) {
        this.currentstep.hide();
        this._active = false;
        this._overlay.remove();
        this._steps.forEach(function (step) {
          return step.remove();
        });
        u$2(this._options.root).removeClass("__guided-tour-active");
        if (this._options.keyboardNavigation) {
          u$2(":root").off("keyup", this._keyboardHandler);
        }
        if (this._options.restoreinitialposition && this._initialposition) {
          animateScroll(this._initialposition, this._options.animationspeed);
        }
        this._options.onStop(this._options);
      }
    }
  }, {
    key: "complete",
    value: function complete() {
      if (this._active) {
        this.stop();
        this._options.onComplete();
      }
    }
  }, {
    key: "deinit",
    value: function deinit() {
      if (this._ready) {
        this._containerElement.remove();
        this._containerElement = null;
        this._active = false;
        this._ready = false;
      }
    }
  }]);
  return Tour;
}();
Tour.ActionHandler = ActionHandler;
Tour.ContentDecorator = ContentDecorator;

exports.default = Tour;

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_vend_form_vue__ = __webpack_require__(433);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7553e62f_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_vend_form_vue__ = __webpack_require__(1184);
function injectStyle (ssrContext) {
  __webpack_require__(1182)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_vend_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7553e62f_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_vend_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_agenda_form_vue__ = __webpack_require__(669);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5794c569_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_agenda_form_vue__ = __webpack_require__(1865);
function injectStyle (ssrContext) {
  __webpack_require__(1863)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_agenda_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5794c569_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_agenda_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var core = __webpack_require__(40);
var global = __webpack_require__(12);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(53) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(42);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags

var anObject = __webpack_require__(10);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(10);
var aFunction = __webpack_require__(25);
var SPECIES = __webpack_require__(18)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Function to load Google Charts JS API.
 * @param version - Chart version to load.
 * @param packages - Packages to load.
 * @param language - Languages to load.
 * @param mapsApiKey - Google Maps api key.
 * @returns
 */var loadGoogleCharts = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var version,
            _ref2,
            _ref2$packages,
            packages,
            _ref2$language,
            language,
            mapsApiKey,
            loader,
            settingsKey,
            loaderPromise,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        version = _args.length > 0 && _args[0] !== void 0 ? _args[0] : 'current', _ref2 = _args.length > 1 ? _args[1] : void 0, _ref2$packages = _ref2.packages, packages = _ref2$packages === undefined ? ['corechart', 'controls'] : _ref2$packages, _ref2$language = _ref2.language, language = _ref2$language === undefined ? 'en' : _ref2$language, mapsApiKey = _ref2.mapsApiKey;
                        _context.next = 3;
                        return getChartsLoader();

                    case 3:
                        loader = _context.sent;
                        settingsKey = "".concat(version, "_").concat(packages.join('_'), "_").concat(language);

                        if (!loadedPackages.has(settingsKey)) {
                            _context.next = 7;
                            break;
                        }

                        return _context.abrupt("return", loadedPackages.get(settingsKey));

                    case 7:
                        loaderPromise = new Promise(function (resolve) {
                            loader.load(version, {
                                packages: packages,
                                language: language,
                                mapsApiKey: mapsApiKey
                            });
                            loader.setOnLoadCallback(function () {
                                return resolve(window.google);
                            });
                        });

                        loadedPackages.set(settingsKey, loaderPromise);
                        return _context.abrupt("return", loaderPromise);

                    case 10:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function loadGoogleCharts() {
        return _ref.apply(this, arguments);
    };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var chartsScriptUrl = 'https://www.gstatic.com/charts/loader.js';
var chartsLoaderPromise = null;
var loadedPackages = new Map();
function getChartsLoader() {
    // If already included in the page:
    if (window.google !== undefined) {
        return Promise.resolve(window.google.charts);
    }
    if (chartsLoaderPromise === null) {
        chartsLoaderPromise = new Promise(function (resolve) {
            // Find script tag with same src in DOM.
            var foundScript = document.querySelector("script[src=\"".concat(chartsScriptUrl, "\"]"));
            // Create or get existed tag.
            var script = foundScript || document.createElement('script');
            // Set src if no script was found.
            if (!foundScript) {
                script.src = chartsScriptUrl;
                script.type = 'text/javascript';
                document.head.append(script);
            }
            script.onload = function () {
                if (window.google !== undefined) {
                    resolve(window.google.charts);
                }
            };
        });
    }
    return chartsLoaderPromise;
}

function debounce(func) {
    var waitMilliseconds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 50;
    var timeoutId = void 0;
    function nextInvokeTimeout() {
        return waitMilliseconds;
    }
    var debouncedFunction = function debouncedFunction() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        var context = this;
        var invokeFunction = function invokeFunction() {
            timeoutId = undefined;
            func.apply(context, args);
        };
        if (timeoutId !== undefined) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(invokeFunction, nextInvokeTimeout());
    };
    return debouncedFunction;
}

function getValidChartData(chartsLib, data, isFirstRowLabels) {
    if (chartsLib !== null && data instanceof chartsLib.visualization.DataTable) {
        return data;
    }
    if (chartsLib !== null && data instanceof chartsLib.visualization.DataView) {
        return data;
    }
    if (chartsLib !== null && Array.isArray(data)) {
        return chartsLib.visualization.arrayToDataTable(data, isFirstRowLabels);
    }
    if (chartsLib !== null && data !== null && (typeof data === "undefined" ? "undefined" : _typeof(data)) === 'object') {
        return new chartsLib.visualization.DataTable(data);
    }
    return null;
}
function createChartObject(chartsLib, chartObject, chartEl, chartType, chartEvents, createChartFunction) {
    var createChart = function createChart(el, google, type) {
        if (type === undefined) {
            throw new Error('please, provide chart type property');
        }
        return new google.visualization[type](el);
    };
    if (chartsLib === null) {
        throw new Error('please, provide charts lib property');
    }
    if (chartEl === null) {
        throw new Error('please, provide chart element property');
    }
    var fn = createChartFunction || createChart;
    chartObject = fn(chartEl, chartsLib, chartType);
    attachListeners(chartsLib, chartObject, chartEvents);
    return chartObject;
}
function attachListeners(chartsLib, chartObject, chartEvents) {
    if (chartEvents === null) {
        return;
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.entries(chartEvents)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = _slicedToArray(_step.value, 2),
                event = _step$value[0],
                listener = _step$value[1];

            if (chartsLib !== null && chartObject !== null) {
                chartsLib.visualization.events.addListener(chartObject, event, listener);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

var chartsLib = null;
var GChart = {
    render: function render() {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c('div', {
            ref: "chart"
        });
    },
    staticRenderFns: [],
    name: 'GChart',
    props: {
        type: {
            type: String,
            required: true
        },
        data: {
            type: [Array, Object],
            default: function _default() {
                return [];
            }
        },
        isFirstRowLabels: {
            type: Boolean,
            default: false
        },
        options: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        version: {
            type: String,
            default: 'current'
        },
        settings: {
            type: Object,
            default: function _default() {
                return {
                    packages: ['corechart', 'table']
                };
            }
        },
        events: {
            type: Object,
            default: null
        },
        createChart: {
            type: Function,
            default: null
        },
        resizeDebounce: {
            type: Number,
            default: 200
        }
    },
    data: function data() {
        return {
            chartObject: null
        };
    },

    watch: {
        data: {
            deep: true,
            handler: function handler() {
                this.drawChart();
            }
        },
        options: {
            deep: true,
            handler: function handler() {
                this.drawChart();
            }
        },
        type: function type() {
            this.chartObject = createChartObject(chartsLib, this.chartObject, this.$refs.chart, this.type, this.events, this.createChart);
            this.drawChart();
        }
    },
    mounted: function mounted() {
        var _this = this;

        loadGoogleCharts(this.version, this.settings).then(function (api) {
            chartsLib = api;
            _this.chartObject = createChartObject(chartsLib, _this.chartObject, _this.$refs.chart, _this.type, _this.events, _this.createChart);
            _this.$emit('ready', _this.chartObject, api);
            _this.drawChart();
        });
        if (this.resizeDebounce > 0) window.addEventListener('resize', debounce(this.drawChart, this.resizeDebounce));
    },
    beforeDestroy: function beforeDestroy() {
        if (this.chartObject !== null && typeof this.chartObject.clearChart === 'function') {
            this.chartObject.clearChart();
        }
    },

    methods: {
        drawChart: function drawChart() {
            if (!chartsLib || !this.chartObject) return;
            var data = getValidChartData(chartsLib, this.data, this.isFirstRowLabels);
            if (data) this.chartObject.draw(data, this.options);
        }
    }
};

// Install the components
function install(vue) {
    vue.component('GChart', GChart);
}
/* -- Plugin definition & Auto-install -- */ /* You shouldn't have to modify the code below */ // Plugin
var plugin = {
    version: "1.1.0",
    install: install
};
// Auto-install
var GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

exports.GChart = GChart;
exports.default = plugin;
exports.install = install;
exports.loadGoogleCharts = loadGoogleCharts;
//# sourceMappingURL=index.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.decodePayload = exports.decodePacket = exports.encodePayload = exports.encodePacket = exports.protocol = undefined;
exports.createPacketEncoderStream = createPacketEncoderStream;
exports.createPacketDecoderStream = createPacketDecoderStream;

var _encodePacket = __webpack_require__(1032);

var _decodePacket = __webpack_require__(1033);

var _commons = __webpack_require__(160);

var SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
var encodePayload = function encodePayload(packets, callback) {
    // some packets may be added to the array while encoding, so the initial length must be saved
    var length = packets.length;
    var encodedPackets = new Array(length);
    var count = 0;
    packets.forEach(function (packet, i) {
        // force base64 encoding for binary packets
        (0, _encodePacket.encodePacket)(packet, false, function (encodedPacket) {
            encodedPackets[i] = encodedPacket;
            if (++count === length) {
                callback(encodedPackets.join(SEPARATOR));
            }
        });
    });
};
var decodePayload = function decodePayload(encodedPayload, binaryType) {
    var encodedPackets = encodedPayload.split(SEPARATOR);
    var packets = [];
    for (var i = 0; i < encodedPackets.length; i++) {
        var decodedPacket = (0, _decodePacket.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") {
            break;
        }
    }
    return packets;
};
function createPacketEncoderStream() {
    return new TransformStream({
        transform: function transform(packet, controller) {
            (0, _encodePacket.encodePacketToBinary)(packet, function (encodedPacket) {
                var payloadLength = encodedPacket.length;
                var header = void 0;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    var view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    var _view = new DataView(header.buffer);
                    _view.setUint8(0, 127);
                    _view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") {
                    header[0] |= 0x80;
                }
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
var TEXT_DECODER = void 0;
function totalLength(chunks) {
    return chunks.reduce(function (acc, chunk) {
        return acc + chunk.length;
    }, 0);
}
function concatChunks(chunks, size) {
    if (chunks[0].length === size) {
        return chunks.shift();
    }
    var buffer = new Uint8Array(size);
    var j = 0;
    for (var i = 0; i < size; i++) {
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) {
        chunks[0] = chunks[0].slice(j);
    }
    return buffer;
}
function createPacketDecoderStream(maxPayload, binaryType) {
    if (!TEXT_DECODER) {
        TEXT_DECODER = new TextDecoder();
    }
    var chunks = [];
    var state = 0 /* State.READ_HEADER */;
    var expectedLength = -1;
    var isBinary = false;
    return new TransformStream({
        transform: function transform(chunk, controller) {
            chunks.push(chunk);
            while (true) {
                if (state === 0 /* State.READ_HEADER */) {
                        if (totalLength(chunks) < 1) {
                            break;
                        }
                        var header = concatChunks(chunks, 1);
                        isBinary = (header[0] & 0x80) === 0x80;
                        expectedLength = header[0] & 0x7f;
                        if (expectedLength < 126) {
                            state = 3 /* State.READ_PAYLOAD */;
                        } else if (expectedLength === 126) {
                            state = 1 /* State.READ_EXTENDED_LENGTH_16 */;
                        } else {
                            state = 2 /* State.READ_EXTENDED_LENGTH_64 */;
                        }
                    } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */) {
                        if (totalLength(chunks) < 2) {
                            break;
                        }
                        var headerArray = concatChunks(chunks, 2);
                        expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                        state = 3 /* State.READ_PAYLOAD */;
                    } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */) {
                        if (totalLength(chunks) < 8) {
                            break;
                        }
                        var _headerArray = concatChunks(chunks, 8);
                        var view = new DataView(_headerArray.buffer, _headerArray.byteOffset, _headerArray.length);
                        var n = view.getUint32(0);
                        if (n > Math.pow(2, 53 - 32) - 1) {
                            // the maximum safe integer in JavaScript is 2^53 - 1
                            controller.enqueue(_commons.ERROR_PACKET);
                            break;
                        }
                        expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                        state = 3 /* State.READ_PAYLOAD */;
                    } else {
                    if (totalLength(chunks) < expectedLength) {
                        break;
                    }
                    var data = concatChunks(chunks, expectedLength);
                    controller.enqueue((0, _decodePacket.decodePacket)(isBinary ? data : TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue(_commons.ERROR_PACKET);
                    break;
                }
            }
        }
    });
}
var protocol = exports.protocol = 4;
exports.encodePacket = _encodePacket.encodePacket;
exports.encodePayload = encodePayload;
exports.decodePacket = _decodePacket.decodePacket;
exports.decodePayload = decodePayload;

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_filial_form_vue__ = __webpack_require__(246);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_362be20a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_filial_form_vue__ = __webpack_require__(1069);
function injectStyle (ssrContext) {
  __webpack_require__(1046)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_filial_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_362be20a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_filial_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_typeahead_vue__ = __webpack_require__(446);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfb955ec_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_typeahead_vue__ = __webpack_require__(1224);
function injectStyle (ssrContext) {
  __webpack_require__(1222)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cfb955ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_typeahead_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfb955ec_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_typeahead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_item_form_vue__ = __webpack_require__(506);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ae7502e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_item_form_vue__ = __webpack_require__(1431);
function injectStyle (ssrContext) {
  __webpack_require__(1411)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_item_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ae7502e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_item_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grade_vue__ = __webpack_require__(512);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_39db60c6_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grade_vue__ = __webpack_require__(1424);
function injectStyle (ssrContext) {
  __webpack_require__(1422)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grade_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_39db60c6_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grade_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nates_form_vue__ = __webpack_require__(518);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_51330e2c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nates_form_vue__ = __webpack_require__(1445);
function injectStyle (ssrContext) {
  __webpack_require__(1443)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nates_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_51330e2c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nates_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_impressao_vue__ = __webpack_require__(550);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_48615cd8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_impressao_vue__ = __webpack_require__(1536);
function injectStyle (ssrContext) {
  __webpack_require__(1530)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_impressao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_48615cd8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_impressao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_filtro_vue__ = __webpack_require__(556);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_61eb9a72_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_filtro_vue__ = __webpack_require__(1546);
function injectStyle (ssrContext) {
  __webpack_require__(1544)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_filtro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_61eb9a72_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_filtro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfsaida_form_vue__ = __webpack_require__(575);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac8af540_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfsaida_form_vue__ = __webpack_require__(1631);
function injectStyle (ssrContext) {
  __webpack_require__(1601)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ac8af540"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfsaida_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac8af540_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfsaida_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_filtros_negocio_vue__ = __webpack_require__(700);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa3740d2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_filtros_negocio_vue__ = __webpack_require__(1973);
function injectStyle (ssrContext) {
  __webpack_require__(1971)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_filtros_negocio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa3740d2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_filtros_negocio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_card_vue__ = __webpack_require__(703);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_06043a54_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_card_vue__ = __webpack_require__(1983);
function injectStyle (ssrContext) {
  __webpack_require__(1977)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_06043a54_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_negocio_novo_form_vue__ = __webpack_require__(710);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_95d4df80_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_negocio_novo_form_vue__ = __webpack_require__(2013);
function injectStyle (ssrContext) {
  __webpack_require__(2002)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_negocio_novo_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_95d4df80_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_negocio_novo_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_color_vue__ = __webpack_require__(711);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef3d78dc_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_color_vue__ = __webpack_require__(2006);
function injectStyle (ssrContext) {
  __webpack_require__(2004)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_color_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef3d78dc_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_color_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_org_novo_form_vue__ = __webpack_require__(714);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f83db298_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_org_novo_form_vue__ = __webpack_require__(2016);
function injectStyle (ssrContext) {
  __webpack_require__(2014)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_org_novo_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f83db298_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_org_novo_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_pessoa_novo_form_vue__ = __webpack_require__(715);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1995f63a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_pessoa_novo_form_vue__ = __webpack_require__(2019);
function injectStyle (ssrContext) {
  __webpack_require__(2017)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_pessoa_novo_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1995f63a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_pessoa_novo_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(36);
var toLength = __webpack_require__(19);
var toAbsoluteIndex = __webpack_require__(60);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.2.2 IsArray(argument)
var cof = __webpack_require__(42);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toInteger = __webpack_require__(43);
var defined = __webpack_require__(47);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(15);
var cof = __webpack_require__(42);
var MATCH = __webpack_require__(18)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ITERATOR = __webpack_require__(18)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () {
    SAFE_CLOSING = true;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () {
    throw 2;
  });
} catch (e) {/* empty */}

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () {
      return { done: safe = true };
    };
    arr[ITERATOR] = function () {
      return iter;
    };
    exec(arr);
  } catch (e) {/* empty */}
  return safe;
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var classof = __webpack_require__(71);
var builtinExec = RegExp.prototype.exec;

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(203);
var redefine = __webpack_require__(30);
var hide = __webpack_require__(29);
var fails = __webpack_require__(14);
var defined = __webpack_require__(47);
var wks = __webpack_require__(18);
var regexpExec = __webpack_require__(151);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () {
    return originalExec.apply(this, arguments);
  };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
}();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () {
      return 7;
    };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () {
      execCalled = true;return null;
    };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () {
        return re;
      };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(defined, SYMBOL, ''[KEY], function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
    // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
    // 21.2.5.11 RegExp.prototype[@@split](string, limit)
    ? function (string, arg) {
      return rxfn.call(string, this, arg);
    }
    // 21.2.5.6 RegExp.prototype[@@match](string)
    // 21.2.5.9 RegExp.prototype[@@search](string)
    : function (string) {
      return rxfn.call(string, this);
    });
  }
};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(12);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(12);
var $export = __webpack_require__(6);
var redefine = __webpack_require__(30);
var redefineAll = __webpack_require__(66);
var meta = __webpack_require__(54);
var forOf = __webpack_require__(65);
var anInstance = __webpack_require__(64);
var isObject = __webpack_require__(15);
var fails = __webpack_require__(14);
var $iterDetect = __webpack_require__(106);
var setToStringTag = __webpack_require__(70);
var inheritIfRequired = __webpack_require__(137);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function fixMethod(KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY, KEY == 'delete' ? function (a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'has' ? function has(a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'get' ? function get(a) {
      return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'add' ? function add(a) {
      fn.call(this, a === 0 ? 0 : a);return this;
    } : function set(a, b) {
      fn.call(this, a === 0 ? 0 : a, b);return this;
    });
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () {
      instance.has(1);
    });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) {
      new C(iter);
    }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) {
        $instance[ADDER](index, index);
      }return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(12);
var hide = __webpack_require__(29);
var uid = __webpack_require__(58);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods

module.exports = __webpack_require__(53) || !__webpack_require__(14)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () {/* empty */});
  delete __webpack_require__(12)[K];
});

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/

var $export = __webpack_require__(6);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
      var length = arguments.length;
      var A = new Array(length);
      while (length--) {
        A[length] = arguments[length];
      }return new this(A);
    } });
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/

var $export = __webpack_require__(6);
var aFunction = __webpack_require__(25);
var ctx = __webpack_require__(41);
var forOf = __webpack_require__(65);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
      var mapFn = arguments[1];
      var mapping, A, n, cb;
      aFunction(this);
      mapping = mapFn !== undefined;
      if (mapping) aFunction(mapFn);
      if (source == undefined) return new this();
      A = [];
      if (mapping) {
        n = 0;
        cb = ctx(mapFn, arguments[2], 2);
        forOf(source, false, function (nextItem) {
          A.push(cb(nextItem, n++));
        });
      } else {
        forOf(source, false, A.push, A);
      }
      return new this(A);
    } });
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Transport = exports.TransportError = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _engine = __webpack_require__(86);

var _componentEmitter = __webpack_require__(74);

var _util = __webpack_require__(75);

var _parseqs = __webpack_require__(238);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TransportError = exports.TransportError = function (_Error) {
    _inherits(TransportError, _Error);

    function TransportError(reason, description, context) {
        _classCallCheck(this, TransportError);

        var _this = _possibleConstructorReturn(this, (TransportError.__proto__ || Object.getPrototypeOf(TransportError)).call(this, reason));

        _this.description = description;
        _this.context = context;
        _this.type = "TransportError";
        return _this;
    }

    return TransportError;
}(Error);

var Transport = exports.Transport = function (_Emitter) {
    _inherits(Transport, _Emitter);

    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */
    function Transport(opts) {
        _classCallCheck(this, Transport);

        var _this2 = _possibleConstructorReturn(this, (Transport.__proto__ || Object.getPrototypeOf(Transport)).call(this));

        _this2.writable = false;
        (0, _util.installTimerFunctions)(_this2, opts);
        _this2.opts = opts;
        _this2.query = opts.query;
        _this2.socket = opts.socket;
        _this2.supportsBinary = !opts.forceBase64;
        return _this2;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */


    _createClass(Transport, [{
        key: "onError",
        value: function onError(reason, description, context) {
            _get(Transport.prototype.__proto__ || Object.getPrototypeOf(Transport.prototype), "emitReserved", this).call(this, "error", new TransportError(reason, description, context));
            return this;
        }
        /**
         * Opens the transport.
         */

    }, {
        key: "open",
        value: function open() {
            this.readyState = "opening";
            this.doOpen();
            return this;
        }
        /**
         * Closes the transport.
         */

    }, {
        key: "close",
        value: function close() {
            if (this.readyState === "opening" || this.readyState === "open") {
                this.doClose();
                this.onClose();
            }
            return this;
        }
        /**
         * Sends multiple packets.
         *
         * @param {Array} packets
         */

    }, {
        key: "send",
        value: function send(packets) {
            if (this.readyState === "open") {
                this.write(packets);
            } else {
                // this might happen if the transport was silently closed in the beforeunload event handler
            }
        }
        /**
         * Called upon open
         *
         * @protected
         */

    }, {
        key: "onOpen",
        value: function onOpen() {
            this.readyState = "open";
            this.writable = true;
            _get(Transport.prototype.__proto__ || Object.getPrototypeOf(Transport.prototype), "emitReserved", this).call(this, "open");
        }
        /**
         * Called with data.
         *
         * @param {String} data
         * @protected
         */

    }, {
        key: "onData",
        value: function onData(data) {
            var packet = (0, _engine.decodePacket)(data, this.socket.binaryType);
            this.onPacket(packet);
        }
        /**
         * Called with a decoded packet.
         *
         * @protected
         */

    }, {
        key: "onPacket",
        value: function onPacket(packet) {
            _get(Transport.prototype.__proto__ || Object.getPrototypeOf(Transport.prototype), "emitReserved", this).call(this, "packet", packet);
        }
        /**
         * Called upon close.
         *
         * @protected
         */

    }, {
        key: "onClose",
        value: function onClose(details) {
            this.readyState = "closed";
            _get(Transport.prototype.__proto__ || Object.getPrototypeOf(Transport.prototype), "emitReserved", this).call(this, "close", details);
        }
        /**
         * Pauses the transport, in order not to lose packets during an upgrade.
         *
         * @param onPause
         */

    }, {
        key: "pause",
        value: function pause(onPause) {}
    }, {
        key: "createUri",
        value: function createUri(schema) {
            var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
        }
    }, {
        key: "_hostname",
        value: function _hostname() {
            var hostname = this.opts.hostname;
            return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
        }
    }, {
        key: "_port",
        value: function _port() {
            if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) {
                return ":" + this.opts.port;
            } else {
                return "";
            }
        }
    }, {
        key: "_query",
        value: function _query(query) {
            var encodedQuery = (0, _parseqs.encode)(query);
            return encodedQuery.length ? "?" + encodedQuery : "";
        }
    }]);

    return Transport;
}(_componentEmitter.Emitter);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function webpackUniversalModuleDefinition(root, factory) {
  if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["vue-offline"] = factory();else root["vue-offline"] = factory();
})(window, function () {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/var installedModules = {};
      /******/
      /******/ // The require function
      /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/__webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/__webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
          /******/
        }
        /******/
      };
      /******/
      /******/ // define __esModule on exports
      /******/__webpack_require__.r = function (exports) {
        /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
          /******/
        }
        /******/Object.defineProperty(exports, '__esModule', { value: true });
        /******/
      };
      /******/
      /******/ // create a fake namespace object
      /******/ // mode & 1: value is a module id, require it
      /******/ // mode & 2: merge all properties of value into the ns
      /******/ // mode & 4: return value when already ns object
      /******/ // mode & 8|1: behave like require
      /******/__webpack_require__.t = function (value, mode) {
        /******/if (mode & 1) value = __webpack_require__(value);
        /******/if (mode & 8) return value;
        /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
        /******/var ns = Object.create(null);
        /******/__webpack_require__.r(ns);
        /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
        /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        } /******/return ns;
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
          return module['default'];
        } :
        /******/function getModuleExports() {
          return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/__webpack_require__.p = "";
      /******/
      /******/
      /******/ // Load entry module and return exports
      /******/return __webpack_require__(__webpack_require__.s = "./src/index.js");
      /******/
    }(
    /************************************************************************/
    /******/{

      /***/"./src/index.js":
      /*!**********************!*\
        !*** ./src/index.js ***!
        \**********************/
      /*! exports provided: VueOfflineMixin, VueOfflineStorage, VueOfflinePlugin, default */
      /***/function srcIndexJs(module, __webpack_exports__, __webpack_require__) {

        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "VueOfflineMixin", function () {
          return VueOfflineMixin;
        });
        /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "VueOfflineStorage", function () {
          return VueOfflineStorage;
        });
        /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "VueOfflinePlugin", function () {
          return VueOfflinePlugin;
        });
        /* ----------------------- Mixin ------------------------ */

        /** This mixin adds:
         * - `isOnline`, `isOffline` data properties
         * - `online`, `offline` in-component events 
         * */
        var VueOfflineMixin = {
          data: function data() {
            return {
              isOnline: false,
              isOffline: false
            };
          },
          mounted: function mounted() {
            var _this = this;

            if (typeof window !== 'undefined') {
              navigator.onLine ? this.isOnline = true : this.isOffline = true;

              var onlineHandler = function onlineHandler() {
                _this.$emit('online');

                _this.isOnline = true;
                _this.isOffline = false;
              };

              var offlineHandler = function offlineHandler() {
                _this.$emit('offline');

                _this.isOffline = true;
                _this.isOnline = false;
              };

              window.addEventListener('online', onlineHandler);
              window.addEventListener('offline', offlineHandler);
              this.$once('hook:beforeDestroy', function () {
                window.removeEventListener('online', onlineHandler);
                window.removeEventListener('offline', offlineHandler);
              });
            }
          }
        };
        /* ----------------------- Storage ------------------------ */

        function _addKey(newKey) {
          var keys = JSON.parse(localStorage.getItem('VueOfflineStorageKeys')) || [];
          if (!keys.includes(newKey)) keys.push(newKey);
          localStorage.setItem('VueOfflineStorageKeys', JSON.stringify(keys));
        }
        /** Offline storage based on localStorage. You can import it and use standalone or register a plugin */

        var VueOfflineStorage = {
          keys: typeof window !== 'undefined' ? localStorage.getItem('VueOfflineStorageKeys') : null,
          set: function set(key, value) {
            if (typeof window !== 'undefined') {
              localStorage.setItem(key, JSON.stringify(value));

              _addKey(key);
            }
          },
          get: function get(key) {
            return typeof window !== 'undefined' ? JSON.parse(localStorage.getItem(key)) : null;
          }
        };
        /* ----------------------- Plugin ------------------------ */

        /** Registers VueOfflineMixin in whole application giving you access to:
         * - isOnline, isOffline data properties
         * - online, offline in-component events
         */

        var VueOfflinePlugin = {
          install: function install(Vue) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
              mixin: true,
              storage: true
            };
            var pluginOptions = {
              mixin: options.mixin,
              storage: options.storage
            };
            if (pluginOptions.storage) Vue.prototype.$offlineStorage = VueOfflineStorage;
            if (pluginOptions.mixin) Vue.mixin(VueOfflineMixin);
          }
        };
        /* harmony default export */__webpack_exports__["default"] = VueOfflinePlugin;

        /***/
      }

      /******/ })
  );
});
//# sourceMappingURL=vue-offline.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module)))

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_form_field_vue__ = __webpack_require__(399);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d0c4dc_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_form_field_vue__ = __webpack_require__(1093);
function injectStyle (ssrContext) {
  __webpack_require__(1091)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78d0c4dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_form_field_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d0c4dc_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_form_field_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// função que efetua validação do CPF
function calcChecker1(firstNineDigits) {
  var sum = null;

  for (var j = 0; j < 9; ++j) {
    sum += firstNineDigits.toString().charAt(j) * (10 - j);
  }

  var lastSumChecker1 = sum % 11;
  var checker1 = lastSumChecker1 < 2 ? 0 : 11 - lastSumChecker1;

  return checker1;
}

function calcChecker2(cpfWithChecker1) {
  var sum = null;

  for (var k = 0; k < 10; ++k) {
    sum += cpfWithChecker1.toString().charAt(k) * (11 - k);
  }
  var lastSumChecker2 = sum % 11;
  var checker2 = lastSumChecker2 < 2 ? 0 : 11 - lastSumChecker2;

  return checker2;
}

function cleaner(value) {
  var digits = value.replace(/[^\d]/g, '');
  return digits;
}

function validate(value) {
  var cleanCPF = cleaner(value);
  var firstNineDigits = cleanCPF.substring(0, 9);
  var checker = cleanCPF.substring(9, 11);
  var result = false;

  for (var i = 0; i < 10; i++) {
    if (firstNineDigits + checker === Array(12).join(i)) {
      return false;
    }
  }

  var checker1 = calcChecker1(firstNineDigits);
  var checker2 = calcChecker2('' + firstNineDigits + checker1);

  if (checker.toString() === checker1.toString() + checker2.toString()) {
    result = true;
  } else {
    result = false;
  }
  return result;
}

exports.default = validate;

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_add_item_vue__ = __webpack_require__(546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb74473_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_add_item_vue__ = __webpack_require__(1519);
function injectStyle (ssrContext) {
  __webpack_require__(1517)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bb74473"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_add_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb74473_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_add_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_customer_contato_form_vue__ = __webpack_require__(549);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_18fe9124_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_customer_contato_form_vue__ = __webpack_require__(1528);
function injectStyle (ssrContext) {
  __webpack_require__(1526)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_customer_contato_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_18fe9124_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_customer_contato_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiFunctions = __webpack_require__(5);

var _main = __webpack_require__(4);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  methods: {

    // apiCarregaProduto (nfit) {
    //   // ROTINA EXECUTADA AO SELECIONAR UM ITEM PARA A NOTA
    //   let self = this

    //   this.$store.dispatch('loadItem', { id: nfit.coditem }).then(function () {
    //     self.apiCarregaDadosProduto(nfit, self.$store.getters.getItem, null)
    //   })

    //   this.$store.dispatch('loadItemTaxes', { codnf: nfit.codnf, coditem: nfit.coditem, finalidade: nfit.finalidade }).then(function () {
    //     self.apiCarregaDadosProduto(nfit, null, self.$store.getters.getItemTaxes)
    //   })

    // },

    apiCarregaProduto: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(nfit) {
        var self;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // ROTINA EXECUTADA AO SELECIONAR UM ITEM PARA A NOTA
                self = this;
                _context.next = 3;
                return this.$store.dispatch('loadItem', { id: nfit.coditem });

              case 3:
                _context.next = 5;
                return this.$store.dispatch('loadItemTaxes', { codnf: nfit.codnf, coditem: nfit.coditem, finalidade: nfit.finalidade });

              case 5:
                this.apiCarregaDadosProduto(nfit, this.$store.getters.getItem, this.$store.getters.getItemTaxes);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function apiCarregaProduto(_x) {
        return _ref.apply(this, arguments);
      }

      return apiCarregaProduto;
    }(),
    apiCarregaIvaclass: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(nfit) {
        var self;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // ROTINA EXECUTADA AO SELECIONAR UM ITEM PARA A NOTA
                self = this;
                _context2.next = 3;
                return this.$store.dispatch('loadItem', { id: nfit.coditem });

              case 3:
                _context2.next = 5;
                return this.$store.dispatch('loadItemTaxes', { codnf: nfit.codnf, coditem: nfit.coditem, finalidade: nfit.finalidade, ibscbscclass: nfit.ibscbscclass });

              case 5:
                this.apiCarregaDadosIvaclass(nfit, this.$store.getters.getItem, this.$store.getters.getItemTaxes);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function apiCarregaIvaclass(_x2) {
        return _ref2.apply(this, arguments);
      }

      return apiCarregaIvaclass;
    }(),
    apiCarregaDadosProduto: function apiCarregaDadosProduto(nfit, item, itemTaxes) {
      if (item) {
        nfit.uni = item[0].uni;
        nfit.ncm = item[0].ncm;
        nfit.orimerc = item[0].orimerc;
        nfit.indtot = 'S';
        nfit.inddup = 'S';
        //agrega o objeto retornado pela API ao objeto NFIT
        nfit.item = item;

        nfit.vlr = 0;
        if (item[0].precovenda) nfit.vlr = item[0].precovenda;

        try {
          if (nfit.operacaonf == 'E') {
            nfit.vlr = 0;
          }
        } catch (e) {}
      }
      if (itemTaxes) {
        nfit.nfci = itemTaxes.nfci;
        nfit.csosn = itemTaxes.csosn;
        nfit.sticm = itemTaxes.sticm;
        nfit.stpis = itemTaxes.stpis;
        nfit.stcofins = itemTaxes.stcofins;
        nfit.stipi = itemTaxes.stipi;
        nfit.cfop = itemTaxes.cfop;
        nfit.motdesicm = itemTaxes.motdesicm;
        nfit.cest = itemTaxes.cest;
        nfit.aicm = itemTaxes.aicm;
        nfit.ricm = itemTaxes.ricm;
        nfit.afcp = itemTaxes.afcp;
        nfit.aicmst = itemTaxes.aicmst;
        nfit.mva = itemTaxes.mva;
        nfit.pautaicm = itemTaxes.pautaicm;
        nfit.pautaicmst = itemTaxes.pautaicmst;
        nfit.ricmst = itemTaxes.ricmst;
        nfit.afcpst = itemTaxes.afcpst;
        nfit.picmdif = itemTaxes.picmdif;

        nfit.pdesicm = itemTaxes.pdesicm;
        nfit.pdespc = itemTaxes.pdespc;

        nfit.particmdest = itemTaxes.particmdest;
        nfit.aicmdest = itemTaxes.aicmdest;
        nfit.afcpdest = itemTaxes.afcpdest;

        nfit.bcipi = 0;
        nfit.vipi = 0;
        nfit.aipi = itemTaxes.aipi;
        nfit.ripi = itemTaxes.ripi;
        nfit.pautaipi = itemTaxes.pautaipi;
        nfit.cenqipi = itemTaxes.cenqipi;

        nfit.bcpis = 0;
        nfit.vpis = 0;
        nfit.apis = itemTaxes.apis;
        nfit.apisst = itemTaxes.apisst;
        nfit.rpis = itemTaxes.rpis;
        nfit.pautapis = itemTaxes.pautapis;
        nfit.pautapisst = itemTaxes.pautapisst;

        // nfit.atribest = itemTaxes.atribest
        // nfit.atribfed = itemTaxes.atribfed
        // nfit.atribimp = itemTaxes.atribimp
        // nfit.atribmun = itemTaxes.atribmun

        nfit.bccofins = 0;
        nfit.vcofins = 0;
        nfit.acofins = itemTaxes.acofins;
        nfit.acofinsst = itemTaxes.acofinsst;
        nfit.rcofins = itemTaxes.rcofins;
        nfit.pautacofins = itemTaxes.pautacofins;
        nfit.pautacofinsst = itemTaxes.pautacofinsst;

        nfit.stiss = itemTaxes.stiss;
        nfit.aiss = itemTaxes.aiss;

        nfit.ibscbscclass = itemTaxes.ibscbscclass;

        nfit.ibsufaliq = itemTaxes.ibsufaliq;
        nfit.ibsufred = itemTaxes.ibsufred;

        nfit.ibsmunaliq = itemTaxes.ibsmunaliq;
        nfit.ibsmunred = itemTaxes.ibsmunred;

        nfit.cbsaliq = itemTaxes.cbsaliq;
        nfit.cbsred = itemTaxes.cbsred;

        nfit.ccredpres = itemTaxes.ibsccredpres;
        nfit.ibspcredpres = itemTaxes.ibspcredpres;
        nfit.ibsvcredprescondsus = itemTaxes.ibsvcredprescondsus;

        nfit.cbspcredpres = itemTaxes.cbspcredpres;
        nfit.cbsvcredprescondsus = itemTaxes.cbsvcredprescondsus;

        // nfit.bcicmsret
      }
    },
    apiCarregaDadosIvaclass: function apiCarregaDadosIvaclass(nfit, item, itemTaxes) {
      if (itemTaxes) {
        nfit.ibscbscclass = itemTaxes.ibscbscclass;

        nfit.ibsufaliq = itemTaxes.ibsufaliq;
        nfit.ibsufred = itemTaxes.ibsufred;

        nfit.ibsmunaliq = itemTaxes.ibsmunaliq;
        nfit.ibsmunred = itemTaxes.ibsmunred;

        nfit.cbsaliq = itemTaxes.cbsaliq;
        nfit.cbsred = itemTaxes.cbsred;

        nfit.ccredpres = itemTaxes.ibsccredpres;
        nfit.ibspcredpres = itemTaxes.ibspcredpres;
        nfit.ibsvcredprescondsus = itemTaxes.ibsvcredprescondsus;

        nfit.cbspcredpres = itemTaxes.cbspcredpres;
        nfit.cbsvcredprescondsus = itemTaxes.cbsvcredprescondsus;

        // nfit.bcicmsret
      }
    }
  }
};

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_form_vue__ = __webpack_require__(616);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5ca476e_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_form_vue__ = __webpack_require__(1716);
function injectStyle (ssrContext) {
  __webpack_require__(1705)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e5ca476e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5ca476e_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fv_pedido_form_vue__ = __webpack_require__(617);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df88638_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fv_pedido_form_vue__ = __webpack_require__(1715);
function injectStyle (ssrContext) {
  __webpack_require__(1707)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7df88638"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fv_pedido_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df88638_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fv_pedido_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_pipeline_vue__ = __webpack_require__(709);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ebdff1a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_pipeline_vue__ = __webpack_require__(2001);
function injectStyle (ssrContext) {
  __webpack_require__(1999)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_pipeline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ebdff1a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_pipeline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_tag_form_vue__ = __webpack_require__(712);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_671da41f_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_tag_form_vue__ = __webpack_require__(2009);
function injectStyle (ssrContext) {
  __webpack_require__(2007)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_tag_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_671da41f_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_tag_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_negocio_agenda_vue__ = __webpack_require__(718);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_134652a0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_negocio_agenda_vue__ = __webpack_require__(2028);
function injectStyle (ssrContext) {
  __webpack_require__(2026)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_negocio_agenda_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_134652a0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_negocio_agenda_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_email_vue__ = __webpack_require__(719);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_761d25a2_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_email_vue__ = __webpack_require__(2035);
function injectStyle (ssrContext) {
  __webpack_require__(2029)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-761d25a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_email_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_761d25a2_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_email_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_notes_vue__ = __webpack_require__(721);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_04e6b454_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_notes_vue__ = __webpack_require__(2038);
function injectStyle (ssrContext) {
  __webpack_require__(2036)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_notes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_04e6b454_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_notes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_emissao_cupom_vue__ = __webpack_require__(751);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_333ac4c8_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_emissao_cupom_vue__ = __webpack_require__(2143);
function injectStyle (ssrContext) {
  __webpack_require__(2141)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-333ac4c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_emissao_cupom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_333ac4c8_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_emissao_cupom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(15);
var document = __webpack_require__(12).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(12);
var core = __webpack_require__(40);
var LIBRARY = __webpack_require__(53);
var wksExt = __webpack_require__(185);
var defineProperty = __webpack_require__(22).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var shared = __webpack_require__(80)('keys');
var uid = __webpack_require__(58);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var document = __webpack_require__(12).document;
module.exports = document && document.documentElement;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(15);
var anObject = __webpack_require__(10);
var check = function check(O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
  function (test, buggy, set) {
    try {
      set = __webpack_require__(41)(Function.call, __webpack_require__(37).f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }
    return function setPrototypeOf(O, proto) {
      check(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = '\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003' + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(15);
var setPrototypeOf = __webpack_require__(135).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  }return that;
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toInteger = __webpack_require__(43);
var defined = __webpack_require__(47);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (; n > 0; (n >>>= 1) && (str += str)) {
    if (n & 1) res += str;
  }return res;
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = !$expm1
// Old FF bug
|| $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
// Tor Browser bug
|| $expm1(-2e-17) != -2e-17 ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__(53);
var $export = __webpack_require__(6);
var redefine = __webpack_require__(30);
var hide = __webpack_require__(29);
var Iterators = __webpack_require__(73);
var $iterCreate = __webpack_require__(142);
var setToStringTag = __webpack_require__(70);
var getPrototypeOf = __webpack_require__(38);
var ITERATOR = __webpack_require__(18)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function returnThis() {
  return this;
};

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__(61);
var descriptor = __webpack_require__(57);
var setToStringTag = __webpack_require__(70);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(29)(IteratorPrototype, __webpack_require__(18)('iterator'), function () {
  return this;
});

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(105);
var defined = __webpack_require__(47);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MATCH = __webpack_require__(18)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) {/* empty */}
  }return true;
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// check on default Array iterator
var Iterators = __webpack_require__(73);
var ITERATOR = __webpack_require__(18)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(22);
var createDesc = __webpack_require__(57);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(71);
var ITERATOR = __webpack_require__(18)('iterator');
var Iterators = __webpack_require__(73);
module.exports = __webpack_require__(40).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(878);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)


var toObject = __webpack_require__(24);
var toAbsoluteIndex = __webpack_require__(60);
var toLength = __webpack_require__(19);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) {
    O[index++] = value;
  }return O;
};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addToUnscopables = __webpack_require__(55);
var step = __webpack_require__(202);
var Iterators = __webpack_require__(73);
var toIObject = __webpack_require__(36);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(141)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0; // next index
  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(83);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
}();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var at = __webpack_require__(104)(true);

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ctx = __webpack_require__(41);
var invoke = __webpack_require__(192);
var html = __webpack_require__(134);
var cel = __webpack_require__(130);
var global = __webpack_require__(12);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function run() {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function listener(event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(42)(process) == 'process') {
    defer = function defer(id) {
      process.nextTick(ctx(run, id, 1));
    };
    // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function defer(id) {
      Dispatch.now(ctx(run, id, 1));
    };
    // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function defer(id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
    // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function defer(id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
    // Rest old browsers
  } else {
    defer = function defer(id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(12);
var macrotask = __webpack_require__(153).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(42)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function flush() {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();else last = undefined;
        throw e;
      }
    }last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function notify() {
      process.nextTick(flush);
    };
    // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function notify() {
      node.data = toggle = !toggle;
    };
    // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function notify() {
      promise.then(flush);
    };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
  } else {
    notify = function notify() {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    }last = task;
  };
};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)

var aFunction = __webpack_require__(25);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(12);
var DESCRIPTORS = __webpack_require__(21);
var LIBRARY = __webpack_require__(53);
var $typed = __webpack_require__(111);
var hide = __webpack_require__(29);
var redefineAll = __webpack_require__(66);
var fails = __webpack_require__(14);
var anInstance = __webpack_require__(64);
var toInteger = __webpack_require__(43);
var toLength = __webpack_require__(19);
var toIndex = __webpack_require__(212);
var gOPN = __webpack_require__(62).f;
var dP = __webpack_require__(22).f;
var arrayFill = __webpack_require__(149);
var setToStringTag = __webpack_require__(70);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) {}
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) {}
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) {}
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) {}
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  }return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function get() {
      return this[internal];
    } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) {
    store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
  }
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Decoder = exports.Encoder = exports.PacketType = exports.protocol = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _componentEmitter = __webpack_require__(74);

var _binary = __webpack_require__(1030);

var _isBinary = __webpack_require__(235);

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * These strings must not be used as event names, as they have a special meaning.
 */
var RESERVED_EVENTS = ["connect", "connect_error", "disconnect", "disconnecting", "newListener", "removeListener"];
/**
 * Protocol version.
 *
 * @public
 */
var protocol = exports.protocol = 5;
var PacketType = exports.PacketType = undefined;
(function (PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})(PacketType || (exports.PacketType = PacketType = {}));
/**
 * A socket.io Encoder instance
 */

var Encoder = exports.Encoder = function () {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */
    function Encoder(replacer) {
        _classCallCheck(this, Encoder);

        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */


    _createClass(Encoder, [{
        key: "encode",
        value: function encode(obj) {
            if (obj.type === PacketType.EVENT || obj.type === PacketType.ACK) {
                if ((0, _isBinary.hasBinary)(obj)) {
                    return this.encodeAsBinary({
                        type: obj.type === PacketType.EVENT ? PacketType.BINARY_EVENT : PacketType.BINARY_ACK,
                        nsp: obj.nsp,
                        data: obj.data,
                        id: obj.id
                    });
                }
            }
            return [this.encodeAsString(obj)];
        }
        /**
         * Encode packet as string.
         */

    }, {
        key: "encodeAsString",
        value: function encodeAsString(obj) {
            // first is type
            var str = "" + obj.type;
            // attachments if we have them
            if (obj.type === PacketType.BINARY_EVENT || obj.type === PacketType.BINARY_ACK) {
                str += obj.attachments + "-";
            }
            // if we have a namespace other than `/`
            // we append it followed by a comma `,`
            if (obj.nsp && "/" !== obj.nsp) {
                str += obj.nsp + ",";
            }
            // immediately followed by the id
            if (null != obj.id) {
                str += obj.id;
            }
            // json data
            if (null != obj.data) {
                str += JSON.stringify(obj.data, this.replacer);
            }
            return str;
        }
        /**
         * Encode packet as 'buffer sequence' by removing blobs, and
         * deconstructing packet into object with placeholders and
         * a list of buffers.
         */

    }, {
        key: "encodeAsBinary",
        value: function encodeAsBinary(obj) {
            var deconstruction = (0, _binary.deconstructPacket)(obj);
            var pack = this.encodeAsString(deconstruction.packet);
            var buffers = deconstruction.buffers;
            buffers.unshift(pack); // add packet info to beginning of data list
            return buffers; // write all the buffers
        }
    }]);

    return Encoder;
}();
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript


function isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 */

var Decoder = exports.Decoder = function (_Emitter) {
    _inherits(Decoder, _Emitter);

    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */
    function Decoder(reviver) {
        _classCallCheck(this, Decoder);

        var _this = _possibleConstructorReturn(this, (Decoder.__proto__ || Object.getPrototypeOf(Decoder)).call(this));

        _this.reviver = reviver;
        return _this;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */


    _createClass(Decoder, [{
        key: "add",
        value: function add(obj) {
            var packet = void 0;
            if (typeof obj === "string") {
                if (this.reconstructor) {
                    throw new Error("got plaintext data when reconstructing a packet");
                }
                packet = this.decodeString(obj);
                var isBinaryEvent = packet.type === PacketType.BINARY_EVENT;
                if (isBinaryEvent || packet.type === PacketType.BINARY_ACK) {
                    packet.type = isBinaryEvent ? PacketType.EVENT : PacketType.ACK;
                    // binary packet's json
                    this.reconstructor = new BinaryReconstructor(packet);
                    // no attachments, labeled binary but no binary data to follow
                    if (packet.attachments === 0) {
                        _get(Decoder.prototype.__proto__ || Object.getPrototypeOf(Decoder.prototype), "emitReserved", this).call(this, "decoded", packet);
                    }
                } else {
                    // non-binary full packet
                    _get(Decoder.prototype.__proto__ || Object.getPrototypeOf(Decoder.prototype), "emitReserved", this).call(this, "decoded", packet);
                }
            } else if ((0, _isBinary.isBinary)(obj) || obj.base64) {
                // raw binary data
                if (!this.reconstructor) {
                    throw new Error("got binary data when not reconstructing a packet");
                } else {
                    packet = this.reconstructor.takeBinaryData(obj);
                    if (packet) {
                        // received final buffer
                        this.reconstructor = null;
                        _get(Decoder.prototype.__proto__ || Object.getPrototypeOf(Decoder.prototype), "emitReserved", this).call(this, "decoded", packet);
                    }
                }
            } else {
                throw new Error("Unknown type: " + obj);
            }
        }
        /**
         * Decode a packet String (JSON data)
         *
         * @param {String} str
         * @return {Object} packet
         */

    }, {
        key: "decodeString",
        value: function decodeString(str) {
            var i = 0;
            // look up type
            var p = {
                type: Number(str.charAt(0))
            };
            if (PacketType[p.type] === undefined) {
                throw new Error("unknown packet type " + p.type);
            }
            // look up attachments if type binary
            if (p.type === PacketType.BINARY_EVENT || p.type === PacketType.BINARY_ACK) {
                var start = i + 1;
                while (str.charAt(++i) !== "-" && i != str.length) {}
                var buf = str.substring(start, i);
                if (buf != Number(buf) || str.charAt(i) !== "-") {
                    throw new Error("Illegal attachments");
                }
                p.attachments = Number(buf);
            }
            // look up namespace (if any)
            if ("/" === str.charAt(i + 1)) {
                var _start = i + 1;
                while (++i) {
                    var c = str.charAt(i);
                    if ("," === c) break;
                    if (i === str.length) break;
                }
                p.nsp = str.substring(_start, i);
            } else {
                p.nsp = "/";
            }
            // look up id
            var next = str.charAt(i + 1);
            if ("" !== next && Number(next) == next) {
                var _start2 = i + 1;
                while (++i) {
                    var _c = str.charAt(i);
                    if (null == _c || Number(_c) != _c) {
                        --i;
                        break;
                    }
                    if (i === str.length) break;
                }
                p.id = Number(str.substring(_start2, i + 1));
            }
            // look up json data
            if (str.charAt(++i)) {
                var payload = this.tryParse(str.substr(i));
                if (Decoder.isPayloadValid(p.type, payload)) {
                    p.data = payload;
                } else {
                    throw new Error("invalid payload");
                }
            }
            return p;
        }
    }, {
        key: "tryParse",
        value: function tryParse(str) {
            try {
                return JSON.parse(str, this.reviver);
            } catch (e) {
                return false;
            }
        }
    }, {
        key: "destroy",

        /**
         * Deallocates a parser's resources
         */
        value: function destroy() {
            if (this.reconstructor) {
                this.reconstructor.finishedReconstruction();
                this.reconstructor = null;
            }
        }
    }], [{
        key: "isPayloadValid",
        value: function isPayloadValid(type, payload) {
            switch (type) {
                case PacketType.CONNECT:
                    return isObject(payload);
                case PacketType.DISCONNECT:
                    return payload === undefined;
                case PacketType.CONNECT_ERROR:
                    return typeof payload === "string" || isObject(payload);
                case PacketType.EVENT:
                case PacketType.BINARY_EVENT:
                    return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && RESERVED_EVENTS.indexOf(payload[0]) === -1);
                case PacketType.ACK:
                case PacketType.BINARY_ACK:
                    return Array.isArray(payload);
            }
        }
    }]);

    return Decoder;
}(_componentEmitter.Emitter);
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */


var BinaryReconstructor = function () {
    function BinaryReconstructor(packet) {
        _classCallCheck(this, BinaryReconstructor);

        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */


    _createClass(BinaryReconstructor, [{
        key: "takeBinaryData",
        value: function takeBinaryData(binData) {
            this.buffers.push(binData);
            if (this.buffers.length === this.reconPack.attachments) {
                // done with buffer list
                var packet = (0, _binary.reconstructPacket)(this.reconPack, this.buffers);
                this.finishedReconstruction();
                return packet;
            }
            return null;
        }
        /**
         * Cleans up binary packet reconstruction variables.
         */

    }, {
        key: "finishedReconstruction",
        value: function finishedReconstruction() {
            this.reconPack = null;
            this.buffers = [];
        }
    }]);

    return BinaryReconstructor;
}();

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebTransport = exports.WebSocket = exports.NodeWebSocket = exports.XHR = exports.NodeXHR = exports.Fetch = exports.nextTick = exports.parse = exports.installTimerFunctions = exports.transports = exports.TransportError = exports.Transport = exports.protocol = exports.SocketWithUpgrade = exports.SocketWithoutUpgrade = exports.Socket = undefined;

var _socket = __webpack_require__(1031);

Object.defineProperty(exports, "SocketWithoutUpgrade", {
  enumerable: true,
  get: function get() {
    return _socket.SocketWithoutUpgrade;
  }
});
Object.defineProperty(exports, "SocketWithUpgrade", {
  enumerable: true,
  get: function get() {
    return _socket.SocketWithUpgrade;
  }
});

var _transport = __webpack_require__(115);

Object.defineProperty(exports, "Transport", {
  enumerable: true,
  get: function get() {
    return _transport.Transport;
  }
});
Object.defineProperty(exports, "TransportError", {
  enumerable: true,
  get: function get() {
    return _transport.TransportError;
  }
});

var _index = __webpack_require__(236);

Object.defineProperty(exports, "transports", {
  enumerable: true,
  get: function get() {
    return _index.transports;
  }
});

var _util = __webpack_require__(75);

Object.defineProperty(exports, "installTimerFunctions", {
  enumerable: true,
  get: function get() {
    return _util.installTimerFunctions;
  }
});

var _parseuri = __webpack_require__(240);

Object.defineProperty(exports, "parse", {
  enumerable: true,
  get: function get() {
    return _parseuri.parse;
  }
});

var _globalsNode = __webpack_require__(76);

Object.defineProperty(exports, "nextTick", {
  enumerable: true,
  get: function get() {
    return _globalsNode.nextTick;
  }
});

var _pollingFetch = __webpack_require__(1036);

Object.defineProperty(exports, "Fetch", {
  enumerable: true,
  get: function get() {
    return _pollingFetch.Fetch;
  }
});

var _pollingXhrNode = __webpack_require__(159);

Object.defineProperty(exports, "NodeXHR", {
  enumerable: true,
  get: function get() {
    return _pollingXhrNode.XHR;
  }
});

var _pollingXhr = __webpack_require__(159);

Object.defineProperty(exports, "XHR", {
  enumerable: true,
  get: function get() {
    return _pollingXhr.XHR;
  }
});

var _websocketNode = __webpack_require__(161);

Object.defineProperty(exports, "NodeWebSocket", {
  enumerable: true,
  get: function get() {
    return _websocketNode.WS;
  }
});

var _websocket = __webpack_require__(161);

Object.defineProperty(exports, "WebSocket", {
  enumerable: true,
  get: function get() {
    return _websocket.WS;
  }
});

var _webtransport = __webpack_require__(239);

Object.defineProperty(exports, "WebTransport", {
  enumerable: true,
  get: function get() {
    return _webtransport.WT;
  }
});
exports.Socket = _socket.Socket;
var protocol = exports.protocol = _socket.Socket.protocol;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.XHR = exports.Request = exports.BaseXHR = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _polling = __webpack_require__(237);

var _componentEmitter = __webpack_require__(74);

var _util = __webpack_require__(75);

var _globalsNode = __webpack_require__(76);

var _hasCors = __webpack_require__(1035);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function empty() {}

var BaseXHR = exports.BaseXHR = function (_Polling) {
    _inherits(BaseXHR, _Polling);

    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */
    function BaseXHR(opts) {
        _classCallCheck(this, BaseXHR);

        var _this = _possibleConstructorReturn(this, (BaseXHR.__proto__ || Object.getPrototypeOf(BaseXHR)).call(this, opts));

        if (typeof location !== "undefined") {
            var isSSL = "https:" === location.protocol;
            var port = location.port;
            // some user agents have empty `location.port`
            if (!port) {
                port = isSSL ? "443" : "80";
            }
            _this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
        return _this;
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */


    _createClass(BaseXHR, [{
        key: "doWrite",
        value: function doWrite(data, fn) {
            var _this2 = this;

            var req = this.request({
                method: "POST",
                data: data
            });
            req.on("success", fn);
            req.on("error", function (xhrStatus, context) {
                _this2.onError("xhr post error", xhrStatus, context);
            });
        }
        /**
         * Starts a poll cycle.
         *
         * @private
         */

    }, {
        key: "doPoll",
        value: function doPoll() {
            var _this3 = this;

            var req = this.request();
            req.on("data", this.onData.bind(this));
            req.on("error", function (xhrStatus, context) {
                _this3.onError("xhr poll error", xhrStatus, context);
            });
            this.pollXhr = req;
        }
    }]);

    return BaseXHR;
}(_polling.Polling);

var Request = exports.Request = function (_Emitter) {
    _inherits(Request, _Emitter);

    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */
    function Request(createRequest, uri, opts) {
        _classCallCheck(this, Request);

        var _this4 = _possibleConstructorReturn(this, (Request.__proto__ || Object.getPrototypeOf(Request)).call(this));

        _this4.createRequest = createRequest;
        (0, _util.installTimerFunctions)(_this4, opts);
        _this4._opts = opts;
        _this4._method = opts.method || "GET";
        _this4._uri = uri;
        _this4._data = undefined !== opts.data ? opts.data : null;
        _this4._create();
        return _this4;
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */


    _createClass(Request, [{
        key: "_create",
        value: function _create() {
            var _this5 = this;

            var _a;
            var opts = (0, _util.pick)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
            opts.xdomain = !!this._opts.xd;
            var xhr = this._xhr = this.createRequest(opts);
            try {
                xhr.open(this._method, this._uri, true);
                try {
                    if (this._opts.extraHeaders) {
                        // @ts-ignore
                        xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                        for (var i in this._opts.extraHeaders) {
                            if (this._opts.extraHeaders.hasOwnProperty(i)) {
                                xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                            }
                        }
                    }
                } catch (e) {}
                if ("POST" === this._method) {
                    try {
                        xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
                    } catch (e) {}
                }
                try {
                    xhr.setRequestHeader("Accept", "*/*");
                } catch (e) {}
                (_a = this._opts.cookieJar) === null || _a === void 0 ? void 0 : _a.addCookies(xhr);
                // ie6 check
                if ("withCredentials" in xhr) {
                    xhr.withCredentials = this._opts.withCredentials;
                }
                if (this._opts.requestTimeout) {
                    xhr.timeout = this._opts.requestTimeout;
                }
                xhr.onreadystatechange = function () {
                    var _a;
                    if (xhr.readyState === 3) {
                        (_a = _this5._opts.cookieJar) === null || _a === void 0 ? void 0 : _a.parseCookies(
                        // @ts-ignore
                        xhr.getResponseHeader("set-cookie"));
                    }
                    if (4 !== xhr.readyState) return;
                    if (200 === xhr.status || 1223 === xhr.status) {
                        _this5._onLoad();
                    } else {
                        // make sure the `error` event handler that's user-set
                        // does not throw in the same tick and gets caught here
                        _this5.setTimeoutFn(function () {
                            _this5._onError(typeof xhr.status === "number" ? xhr.status : 0);
                        }, 0);
                    }
                };
                xhr.send(this._data);
            } catch (e) {
                // Need to defer since .create() is called directly from the constructor
                // and thus the 'error' event can only be only bound *after* this exception
                // occurs.  Therefore, also, we cannot throw here at all.
                this.setTimeoutFn(function () {
                    _this5._onError(e);
                }, 0);
                return;
            }
            if (typeof document !== "undefined") {
                this._index = Request.requestsCount++;
                Request.requests[this._index] = this;
            }
        }
        /**
         * Called upon error.
         *
         * @private
         */

    }, {
        key: "_onError",
        value: function _onError(err) {
            this.emitReserved("error", err, this._xhr);
            this._cleanup(true);
        }
        /**
         * Cleans up house.
         *
         * @private
         */

    }, {
        key: "_cleanup",
        value: function _cleanup(fromError) {
            if ("undefined" === typeof this._xhr || null === this._xhr) {
                return;
            }
            this._xhr.onreadystatechange = empty;
            if (fromError) {
                try {
                    this._xhr.abort();
                } catch (e) {}
            }
            if (typeof document !== "undefined") {
                delete Request.requests[this._index];
            }
            this._xhr = null;
        }
        /**
         * Called upon load.
         *
         * @private
         */

    }, {
        key: "_onLoad",
        value: function _onLoad() {
            var data = this._xhr.responseText;
            if (data !== null) {
                this.emitReserved("data", data);
                this.emitReserved("success");
                this._cleanup();
            }
        }
        /**
         * Aborts the request.
         *
         * @package
         */

    }, {
        key: "abort",
        value: function abort() {
            this._cleanup();
        }
    }]);

    return Request;
}(_componentEmitter.Emitter);

Request.requestsCount = 0;
Request.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */
if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") {
        // @ts-ignore
        attachEvent("onunload", unloadHandler);
    } else if (typeof addEventListener === "function") {
        var terminationEvent = "onpagehide" in _globalsNode.globalThisShim ? "pagehide" : "unload";
        addEventListener(terminationEvent, unloadHandler, false);
    }
}
function unloadHandler() {
    for (var i in Request.requests) {
        if (Request.requests.hasOwnProperty(i)) {
            Request.requests[i].abort();
        }
    }
}
var hasXHR2 = function () {
    var xhr = newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
/**
 * HTTP long-polling based on the built-in `XMLHttpRequest` object.
 *
 * Usage: browser
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest
 */

var XHR = exports.XHR = function (_BaseXHR) {
    _inherits(XHR, _BaseXHR);

    function XHR(opts) {
        _classCallCheck(this, XHR);

        var _this6 = _possibleConstructorReturn(this, (XHR.__proto__ || Object.getPrototypeOf(XHR)).call(this, opts));

        var forceBase64 = opts && opts.forceBase64;
        _this6.supportsBinary = hasXHR2 && !forceBase64;
        return _this6;
    }

    _createClass(XHR, [{
        key: "request",
        value: function request() {
            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            Object.assign(opts, { xd: this.xd }, this.opts);
            return new Request(newRequest, this.uri(), opts);
        }
    }]);

    return XHR;
}(BaseXHR);

function newRequest(opts) {
    var xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || _hasCors.hasCORS)) {
            return new XMLHttpRequest();
        }
    } catch (e) {}
    if (!xdomain) {
        try {
            return new _globalsNode.globalThisShim[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
        } catch (e) {}
    }
}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var PACKET_TYPES = Object.create(null); // no Map = no polyfill
PACKET_TYPES["open"] = "0";
PACKET_TYPES["close"] = "1";
PACKET_TYPES["ping"] = "2";
PACKET_TYPES["pong"] = "3";
PACKET_TYPES["message"] = "4";
PACKET_TYPES["upgrade"] = "5";
PACKET_TYPES["noop"] = "6";
var PACKET_TYPES_REVERSE = Object.create(null);
Object.keys(PACKET_TYPES).forEach(function (key) {
    PACKET_TYPES_REVERSE[PACKET_TYPES[key]] = key;
});
var ERROR_PACKET = { type: "error", data: "parser error" };
exports.PACKET_TYPES = PACKET_TYPES;
exports.PACKET_TYPES_REVERSE = PACKET_TYPES_REVERSE;
exports.ERROR_PACKET = ERROR_PACKET;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WS = exports.BaseWS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _transport = __webpack_require__(115);

var _util = __webpack_require__(75);

var _engine = __webpack_require__(86);

var _globalsNode = __webpack_require__(76);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// detect ReactNative environment
var isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";

var BaseWS = exports.BaseWS = function (_Transport) {
    _inherits(BaseWS, _Transport);

    function BaseWS() {
        _classCallCheck(this, BaseWS);

        return _possibleConstructorReturn(this, (BaseWS.__proto__ || Object.getPrototypeOf(BaseWS)).apply(this, arguments));
    }

    _createClass(BaseWS, [{
        key: "doOpen",
        value: function doOpen() {
            var uri = this.uri();
            var protocols = this.opts.protocols;
            // React Native only supports the 'headers' option, and will print a warning if anything else is passed
            var opts = isReactNative ? {} : (0, _util.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
            if (this.opts.extraHeaders) {
                opts.headers = this.opts.extraHeaders;
            }
            try {
                this.ws = this.createSocket(uri, protocols, opts);
            } catch (err) {
                return this.emitReserved("error", err);
            }
            this.ws.binaryType = this.socket.binaryType;
            this.addEventListeners();
        }
        /**
         * Adds event listeners to the socket
         *
         * @private
         */

    }, {
        key: "addEventListeners",
        value: function addEventListeners() {
            var _this2 = this;

            this.ws.onopen = function () {
                if (_this2.opts.autoUnref) {
                    _this2.ws._socket.unref();
                }
                _this2.onOpen();
            };
            this.ws.onclose = function (closeEvent) {
                return _this2.onClose({
                    description: "websocket connection closed",
                    context: closeEvent
                });
            };
            this.ws.onmessage = function (ev) {
                return _this2.onData(ev.data);
            };
            this.ws.onerror = function (e) {
                return _this2.onError("websocket error", e);
            };
        }
    }, {
        key: "write",
        value: function write(packets) {
            var _this3 = this;

            this.writable = false;
            // encodePacket efficient as it uses WS framing
            // no need for encodePayload

            var _loop = function _loop(i) {
                var packet = packets[i];
                var lastPacket = i === packets.length - 1;
                (0, _engine.encodePacket)(packet, _this3.supportsBinary, function (data) {
                    // Sometimes the websocket has already been closed but the browser didn't
                    // have a chance of informing us about it yet, in that case send will
                    // throw an error
                    try {
                        _this3.doWrite(packet, data);
                    } catch (e) {}
                    if (lastPacket) {
                        // fake drain
                        // defer to next tick to allow Socket to clear writeBuffer
                        (0, _globalsNode.nextTick)(function () {
                            _this3.writable = true;
                            _this3.emitReserved("drain");
                        }, _this3.setTimeoutFn);
                    }
                });
            };

            for (var i = 0; i < packets.length; i++) {
                _loop(i);
            }
        }
    }, {
        key: "doClose",
        value: function doClose() {
            if (typeof this.ws !== "undefined") {
                this.ws.onerror = function () {};
                this.ws.close();
                this.ws = null;
            }
        }
        /**
         * Generates uri for connection.
         *
         * @private
         */

    }, {
        key: "uri",
        value: function uri() {
            var schema = this.opts.secure ? "wss" : "ws";
            var query = this.query || {};
            // append timestamp to URI
            if (this.opts.timestampRequests) {
                query[this.opts.timestampParam] = (0, _util.randomString)();
            }
            // communicate binary support capabilities
            if (!this.supportsBinary) {
                query.b64 = 1;
            }
            return this.createUri(schema, query);
        }
    }, {
        key: "name",
        get: function get() {
            return "websocket";
        }
    }]);

    return BaseWS;
}(_transport.Transport);

var WebSocketCtor = _globalsNode.globalThisShim.WebSocket || _globalsNode.globalThisShim.MozWebSocket;
/**
 * WebSocket transport based on the built-in `WebSocket` object.
 *
 * Usage: browser, Node.js (since v21), Deno, Bun
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket
 * @see https://caniuse.com/mdn-api_websocket
 * @see https://nodejs.org/api/globals.html#websocket
 */

var WS = exports.WS = function (_BaseWS) {
    _inherits(WS, _BaseWS);

    function WS() {
        _classCallCheck(this, WS);

        return _possibleConstructorReturn(this, (WS.__proto__ || Object.getPrototypeOf(WS)).apply(this, arguments));
    }

    _createClass(WS, [{
        key: "createSocket",
        value: function createSocket(uri, protocols, opts) {
            return !isReactNative ? protocols ? new WebSocketCtor(uri, protocols) : new WebSocketCtor(uri) : new WebSocketCtor(uri, protocols, opts);
        }
    }, {
        key: "doWrite",
        value: function doWrite(_packet, data) {
            this.ws.send(data);
        }
    }]);

    return WS;
}(BaseWS);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_certificado_vue__ = __webpack_require__(248);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ecfa522_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_certificado_vue__ = __webpack_require__(1068);
function injectStyle (ssrContext) {
  __webpack_require__(1056)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_certificado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ecfa522_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_certificado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_guia_step_svg_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc63062_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_guia_step_svg_vue__ = __webpack_require__(1066);
function injectStyle (ssrContext) {
  __webpack_require__(1064)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fc63062"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_guia_step_svg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc63062_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_guia_step_svg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue__ = __webpack_require__(412);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b4d2cab_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__ = __webpack_require__(1126);
function injectStyle (ssrContext) {
  __webpack_require__(1124)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b4d2cab_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grucli_list_vue__ = __webpack_require__(501);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_390fcce6_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grucli_list_vue__ = __webpack_require__(1404);
function injectStyle (ssrContext) {
  __webpack_require__(1402)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-390fcce6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grucli_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_390fcce6_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grucli_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_unimed_form_vue__ = __webpack_require__(511);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e6fe14f_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_unimed_form_vue__ = __webpack_require__(1421);
function injectStyle (ssrContext) {
  __webpack_require__(1419)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_unimed_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e6fe14f_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_unimed_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_estado_list_vue__ = __webpack_require__(519);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aa3d8de_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_estado_list_vue__ = __webpack_require__(1453);
function injectStyle (ssrContext) {
  __webpack_require__(1447)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5aa3d8de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_estado_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aa3d8de_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_estado_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_unimed_list_vue__ = __webpack_require__(524);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_931c335c_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_unimed_list_vue__ = __webpack_require__(1468);
function injectStyle (ssrContext) {
  __webpack_require__(1466)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-931c335c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_unimed_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_931c335c_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_unimed_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_filial_list_vue__ = __webpack_require__(538);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_617edab7_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_filial_list_vue__ = __webpack_require__(1503);
function injectStyle (ssrContext) {
  __webpack_require__(1501)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_filial_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_617edab7_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_filial_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_addlist_vue__ = __webpack_require__(543);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ee92e64_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_addlist_vue__ = __webpack_require__(1514);
function injectStyle (ssrContext) {
  __webpack_require__(1512)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_addlist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ee92e64_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_addlist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_compra_impressao_vue__ = __webpack_require__(560);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cc4b9c2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_compra_impressao_vue__ = __webpack_require__(1556);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_compra_impressao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cc4b9c2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_compra_impressao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_regrafcp_list_vue__ = __webpack_require__(565);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf46f8ba_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_regrafcp_list_vue__ = __webpack_require__(1571);
function injectStyle (ssrContext) {
  __webpack_require__(1565)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cf46f8ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_regrafcp_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf46f8ba_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_regrafcp_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_regraimp_list_vue__ = __webpack_require__(569);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b4810c_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_regraimp_list_vue__ = __webpack_require__(1590);
function injectStyle (ssrContext) {
  __webpack_require__(1580)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48b4810c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_regraimp_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b4810c_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_regraimp_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_usuario_list_vue__ = __webpack_require__(572);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf492c8_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_usuario_list_vue__ = __webpack_require__(1597);
function injectStyle (ssrContext) {
  __webpack_require__(1591)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cf492c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_usuario_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf492c8_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_usuario_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nf_form_ref_vue__ = __webpack_require__(577);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb1dfb4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nf_form_ref_vue__ = __webpack_require__(1613);
function injectStyle (ssrContext) {
  __webpack_require__(1607)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nf_form_ref_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb1dfb4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nf_form_ref_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_catmkt_form_vue__ = __webpack_require__(665);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_289d7de3_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_catmkt_form_vue__ = __webpack_require__(1849);
function injectStyle (ssrContext) {
  __webpack_require__(1847)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_catmkt_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_289d7de3_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_catmkt_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function webpackUniversalModuleDefinition(root, factory) {
  if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory(__webpack_require__(702));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(702)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["vuedraggable"] = factory(require("sortablejs"));else root["vuedraggable"] = factory(root["Sortable"]);
})(typeof self !== 'undefined' ? self : undefined, function (__WEBPACK_EXTERNAL_MODULE_a352__) {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/var installedModules = {};
      /******/
      /******/ // The require function
      /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/__webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/__webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
          /******/
        }
        /******/
      };
      /******/
      /******/ // define __esModule on exports
      /******/__webpack_require__.r = function (exports) {
        /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
          /******/
        }
        /******/Object.defineProperty(exports, '__esModule', { value: true });
        /******/
      };
      /******/
      /******/ // create a fake namespace object
      /******/ // mode & 1: value is a module id, require it
      /******/ // mode & 2: merge all properties of value into the ns
      /******/ // mode & 4: return value when already ns object
      /******/ // mode & 8|1: behave like require
      /******/__webpack_require__.t = function (value, mode) {
        /******/if (mode & 1) value = __webpack_require__(value);
        /******/if (mode & 8) return value;
        /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
        /******/var ns = Object.create(null);
        /******/__webpack_require__.r(ns);
        /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
        /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        } /******/return ns;
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
          return module['default'];
        } :
        /******/function getModuleExports() {
          return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/__webpack_require__.p = "";
      /******/
      /******/
      /******/ // Load entry module and return exports
      /******/return __webpack_require__(__webpack_require__.s = "fb15");
      /******/
    }(
    /************************************************************************/
    /******/{

      /***/"01f9":
      /***/function f9(module, exports, __webpack_require__) {

        "use strict";

        var LIBRARY = __webpack_require__("2d00");
        var $export = __webpack_require__("5ca1");
        var redefine = __webpack_require__("2aba");
        var hide = __webpack_require__("32e9");
        var Iterators = __webpack_require__("84f2");
        var $iterCreate = __webpack_require__("41a0");
        var setToStringTag = __webpack_require__("7f20");
        var getPrototypeOf = __webpack_require__("38fd");
        var ITERATOR = __webpack_require__("2b4c")('iterator');
        var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
        var FF_ITERATOR = '@@iterator';
        var KEYS = 'keys';
        var VALUES = 'values';

        var returnThis = function returnThis() {
          return this;
        };

        module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
          $iterCreate(Constructor, NAME, next);
          var getMethod = function getMethod(kind) {
            if (!BUGGY && kind in proto) return proto[kind];
            switch (kind) {
              case KEYS:
                return function keys() {
                  return new Constructor(this, kind);
                };
              case VALUES:
                return function values() {
                  return new Constructor(this, kind);
                };
            }return function entries() {
              return new Constructor(this, kind);
            };
          };
          var TAG = NAME + ' Iterator';
          var DEF_VALUES = DEFAULT == VALUES;
          var VALUES_BUG = false;
          var proto = Base.prototype;
          var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
          var $default = $native || getMethod(DEFAULT);
          var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
          var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
          var methods, key, IteratorPrototype;
          // Fix native
          if ($anyNative) {
            IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
            if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
              // Set @@toStringTag to native iterators
              setToStringTag(IteratorPrototype, TAG, true);
              // fix for some old engines
              if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
            }
          }
          // fix Array#{values, @@iterator}.name in V8 / FF
          if (DEF_VALUES && $native && $native.name !== VALUES) {
            VALUES_BUG = true;
            $default = function values() {
              return $native.call(this);
            };
          }
          // Define iterator
          if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
            hide(proto, ITERATOR, $default);
          }
          // Plug for library
          Iterators[NAME] = $default;
          Iterators[TAG] = returnThis;
          if (DEFAULT) {
            methods = {
              values: DEF_VALUES ? $default : getMethod(VALUES),
              keys: IS_SET ? $default : getMethod(KEYS),
              entries: $entries
            };
            if (FORCED) for (key in methods) {
              if (!(key in proto)) redefine(proto, key, methods[key]);
            } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
          }
          return methods;
        };

        /***/
      },

      /***/"02f4":
      /***/function f4(module, exports, __webpack_require__) {

        var toInteger = __webpack_require__("4588");
        var defined = __webpack_require__("be13");
        // true  -> String#at
        // false -> String#codePointAt
        module.exports = function (TO_STRING) {
          return function (that, pos) {
            var s = String(defined(that));
            var i = toInteger(pos);
            var l = s.length;
            var a, b;
            if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
            a = s.charCodeAt(i);
            return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
          };
        };

        /***/
      },

      /***/"0390":
      /***/function _(module, exports, __webpack_require__) {

        "use strict";

        var at = __webpack_require__("02f4")(true);

        // `AdvanceStringIndex` abstract operation
        // https://tc39.github.io/ecma262/#sec-advancestringindex
        module.exports = function (S, index, unicode) {
          return index + (unicode ? at(S, index).length : 1);
        };

        /***/
      },

      /***/"0bfb":
      /***/function bfb(module, exports, __webpack_require__) {

        "use strict";

        // 21.2.5.3 get RegExp.prototype.flags

        var anObject = __webpack_require__("cb7c");
        module.exports = function () {
          var that = anObject(this);
          var result = '';
          if (that.global) result += 'g';
          if (that.ignoreCase) result += 'i';
          if (that.multiline) result += 'm';
          if (that.unicode) result += 'u';
          if (that.sticky) result += 'y';
          return result;
        };

        /***/
      },

      /***/"0d58":
      /***/function d58(module, exports, __webpack_require__) {

        // 19.1.2.14 / 15.2.3.14 Object.keys(O)
        var $keys = __webpack_require__("ce10");
        var enumBugKeys = __webpack_require__("e11e");

        module.exports = Object.keys || function keys(O) {
          return $keys(O, enumBugKeys);
        };

        /***/
      },

      /***/"1495":
      /***/function _(module, exports, __webpack_require__) {

        var dP = __webpack_require__("86cc");
        var anObject = __webpack_require__("cb7c");
        var getKeys = __webpack_require__("0d58");

        module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
          anObject(O);
          var keys = getKeys(Properties);
          var length = keys.length;
          var i = 0;
          var P;
          while (length > i) {
            dP.f(O, P = keys[i++], Properties[P]);
          }return O;
        };

        /***/
      },

      /***/"214f":
      /***/function f(module, exports, __webpack_require__) {

        "use strict";

        __webpack_require__("b0c5");
        var redefine = __webpack_require__("2aba");
        var hide = __webpack_require__("32e9");
        var fails = __webpack_require__("79e5");
        var defined = __webpack_require__("be13");
        var wks = __webpack_require__("2b4c");
        var regexpExec = __webpack_require__("520a");

        var SPECIES = wks('species');

        var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
          // #replace needs built-in support for named groups.
          // #match works fine because it just return the exec results, even if it has
          // a "grops" property.
          var re = /./;
          re.exec = function () {
            var result = [];
            result.groups = { a: '7' };
            return result;
          };
          return ''.replace(re, '$<a>') !== '7';
        });

        var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function () {
          // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
          var re = /(?:)/;
          var originalExec = re.exec;
          re.exec = function () {
            return originalExec.apply(this, arguments);
          };
          var result = 'ab'.split(re);
          return result.length === 2 && result[0] === 'a' && result[1] === 'b';
        }();

        module.exports = function (KEY, length, exec) {
          var SYMBOL = wks(KEY);

          var DELEGATES_TO_SYMBOL = !fails(function () {
            // String methods call symbol-named RegEp methods
            var O = {};
            O[SYMBOL] = function () {
              return 7;
            };
            return ''[KEY](O) != 7;
          });

          var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
            // Symbol-named RegExp methods call .exec
            var execCalled = false;
            var re = /a/;
            re.exec = function () {
              execCalled = true;return null;
            };
            if (KEY === 'split') {
              // RegExp[@@split] doesn't call the regex's exec method, but first creates
              // a new one. We need to return the patched regex when creating the new one.
              re.constructor = {};
              re.constructor[SPECIES] = function () {
                return re;
              };
            }
            re[SYMBOL]('');
            return !execCalled;
          }) : undefined;

          if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
            var nativeRegExpMethod = /./[SYMBOL];
            var fns = exec(defined, SYMBOL, ''[KEY], function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
              if (regexp.exec === regexpExec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
                  // The native String method already delegates to @@method (this
                  // polyfilled function), leasing to infinite recursion.
                  // We avoid it by directly calling the native @@method method.
                  return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
                }
                return { done: true, value: nativeMethod.call(str, regexp, arg2) };
              }
              return { done: false };
            });
            var strfn = fns[0];
            var rxfn = fns[1];

            redefine(String.prototype, KEY, strfn);
            hide(RegExp.prototype, SYMBOL, length == 2
            // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
            // 21.2.5.11 RegExp.prototype[@@split](string, limit)
            ? function (string, arg) {
              return rxfn.call(string, this, arg);
            }
            // 21.2.5.6 RegExp.prototype[@@match](string)
            // 21.2.5.9 RegExp.prototype[@@search](string)
            : function (string) {
              return rxfn.call(string, this);
            });
          }
        };

        /***/
      },

      /***/"230e":
      /***/function e(module, exports, __webpack_require__) {

        var isObject = __webpack_require__("d3f4");
        var document = __webpack_require__("7726").document;
        // typeof document.createElement is 'object' in old IE
        var is = isObject(document) && isObject(document.createElement);
        module.exports = function (it) {
          return is ? document.createElement(it) : {};
        };

        /***/
      },

      /***/"23c6":
      /***/function c6(module, exports, __webpack_require__) {

        // getting tag from 19.1.3.6 Object.prototype.toString()
        var cof = __webpack_require__("2d95");
        var TAG = __webpack_require__("2b4c")('toStringTag');
        // ES3 wrong here
        var ARG = cof(function () {
          return arguments;
        }()) == 'Arguments';

        // fallback for IE11 Script Access Denied error
        var tryGet = function tryGet(it, key) {
          try {
            return it[key];
          } catch (e) {/* empty */}
        };

        module.exports = function (it) {
          var O, T, B;
          return it === undefined ? 'Undefined' : it === null ? 'Null'
          // @@toStringTag case
          : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
          // builtinTag case
          : ARG ? cof(O)
          // ES3 arguments fallback
          : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
        };

        /***/
      },

      /***/"2621":
      /***/function _(module, exports) {

        exports.f = Object.getOwnPropertySymbols;

        /***/
      },

      /***/"2aba":
      /***/function aba(module, exports, __webpack_require__) {

        var global = __webpack_require__("7726");
        var hide = __webpack_require__("32e9");
        var has = __webpack_require__("69a8");
        var SRC = __webpack_require__("ca5a")('src');
        var $toString = __webpack_require__("fa5b");
        var TO_STRING = 'toString';
        var TPL = ('' + $toString).split(TO_STRING);

        __webpack_require__("8378").inspectSource = function (it) {
          return $toString.call(it);
        };

        (module.exports = function (O, key, val, safe) {
          var isFunction = typeof val == 'function';
          if (isFunction) has(val, 'name') || hide(val, 'name', key);
          if (O[key] === val) return;
          if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
          if (O === global) {
            O[key] = val;
          } else if (!safe) {
            delete O[key];
            hide(O, key, val);
          } else if (O[key]) {
            O[key] = val;
          } else {
            hide(O, key, val);
          }
          // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
        })(Function.prototype, TO_STRING, function toString() {
          return typeof this == 'function' && this[SRC] || $toString.call(this);
        });

        /***/
      },

      /***/"2aeb":
      /***/function aeb(module, exports, __webpack_require__) {

        // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
        var anObject = __webpack_require__("cb7c");
        var dPs = __webpack_require__("1495");
        var enumBugKeys = __webpack_require__("e11e");
        var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
        var Empty = function Empty() {/* empty */};
        var PROTOTYPE = 'prototype';

        // Create object with fake `null` prototype: use iframe Object with cleared prototype
        var _createDict = function createDict() {
          // Thrash, waste and sodomy: IE GC bug
          var iframe = __webpack_require__("230e")('iframe');
          var i = enumBugKeys.length;
          var lt = '<';
          var gt = '>';
          var iframeDocument;
          iframe.style.display = 'none';
          __webpack_require__("fab2").appendChild(iframe);
          iframe.src = 'javascript:'; // eslint-disable-line no-script-url
          // createDict = iframe.contentWindow.Object;
          // html.removeChild(iframe);
          iframeDocument = iframe.contentWindow.document;
          iframeDocument.open();
          iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
          iframeDocument.close();
          _createDict = iframeDocument.F;
          while (i--) {
            delete _createDict[PROTOTYPE][enumBugKeys[i]];
          }return _createDict();
        };

        module.exports = Object.create || function create(O, Properties) {
          var result;
          if (O !== null) {
            Empty[PROTOTYPE] = anObject(O);
            result = new Empty();
            Empty[PROTOTYPE] = null;
            // add "__proto__" for Object.getPrototypeOf polyfill
            result[IE_PROTO] = O;
          } else result = _createDict();
          return Properties === undefined ? result : dPs(result, Properties);
        };

        /***/
      },

      /***/"2b4c":
      /***/function b4c(module, exports, __webpack_require__) {

        var store = __webpack_require__("5537")('wks');
        var uid = __webpack_require__("ca5a");
        var _Symbol = __webpack_require__("7726").Symbol;
        var USE_SYMBOL = typeof _Symbol == 'function';

        var $exports = module.exports = function (name) {
          return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
        };

        $exports.store = store;

        /***/
      },

      /***/"2d00":
      /***/function d00(module, exports) {

        module.exports = false;

        /***/
      },

      /***/"2d95":
      /***/function d95(module, exports) {

        var toString = {}.toString;

        module.exports = function (it) {
          return toString.call(it).slice(8, -1);
        };

        /***/
      },

      /***/"2fdb":
      /***/function fdb(module, exports, __webpack_require__) {

        "use strict";
        // 21.1.3.7 String.prototype.includes(searchString, position = 0)

        var $export = __webpack_require__("5ca1");
        var context = __webpack_require__("d2c8");
        var INCLUDES = 'includes';

        $export($export.P + $export.F * __webpack_require__("5147")(INCLUDES), 'String', {
          includes: function includes(searchString /* , position = 0 */) {
            return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
          }
        });

        /***/
      },

      /***/"32e9":
      /***/function e9(module, exports, __webpack_require__) {

        var dP = __webpack_require__("86cc");
        var createDesc = __webpack_require__("4630");
        module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
          return dP.f(object, key, createDesc(1, value));
        } : function (object, key, value) {
          object[key] = value;
          return object;
        };

        /***/
      },

      /***/"38fd":
      /***/function fd(module, exports, __webpack_require__) {

        // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
        var has = __webpack_require__("69a8");
        var toObject = __webpack_require__("4bf8");
        var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
        var ObjectProto = Object.prototype;

        module.exports = Object.getPrototypeOf || function (O) {
          O = toObject(O);
          if (has(O, IE_PROTO)) return O[IE_PROTO];
          if (typeof O.constructor == 'function' && O instanceof O.constructor) {
            return O.constructor.prototype;
          }return O instanceof Object ? ObjectProto : null;
        };

        /***/
      },

      /***/"41a0":
      /***/function a0(module, exports, __webpack_require__) {

        "use strict";

        var create = __webpack_require__("2aeb");
        var descriptor = __webpack_require__("4630");
        var setToStringTag = __webpack_require__("7f20");
        var IteratorPrototype = {};

        // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
        __webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () {
          return this;
        });

        module.exports = function (Constructor, NAME, next) {
          Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
          setToStringTag(Constructor, NAME + ' Iterator');
        };

        /***/
      },

      /***/"456d":
      /***/function d(module, exports, __webpack_require__) {

        // 19.1.2.14 Object.keys(O)
        var toObject = __webpack_require__("4bf8");
        var $keys = __webpack_require__("0d58");

        __webpack_require__("5eda")('keys', function () {
          return function keys(it) {
            return $keys(toObject(it));
          };
        });

        /***/
      },

      /***/"4588":
      /***/function _(module, exports) {

        // 7.1.4 ToInteger
        var ceil = Math.ceil;
        var floor = Math.floor;
        module.exports = function (it) {
          return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
        };

        /***/
      },

      /***/"4630":
      /***/function _(module, exports) {

        module.exports = function (bitmap, value) {
          return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
          };
        };

        /***/
      },

      /***/"4bf8":
      /***/function bf8(module, exports, __webpack_require__) {

        // 7.1.13 ToObject(argument)
        var defined = __webpack_require__("be13");
        module.exports = function (it) {
          return Object(defined(it));
        };

        /***/
      },

      /***/"5147":
      /***/function _(module, exports, __webpack_require__) {

        var MATCH = __webpack_require__("2b4c")('match');
        module.exports = function (KEY) {
          var re = /./;
          try {
            '/./'[KEY](re);
          } catch (e) {
            try {
              re[MATCH] = false;
              return !'/./'[KEY](re);
            } catch (f) {/* empty */}
          }return true;
        };

        /***/
      },

      /***/"520a":
      /***/function a(module, exports, __webpack_require__) {

        "use strict";

        var regexpFlags = __webpack_require__("0bfb");

        var nativeExec = RegExp.prototype.exec;
        // This always refers to the native implementation, because the
        // String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
        // which loads this file before patching the method.
        var nativeReplace = String.prototype.replace;

        var patchedExec = nativeExec;

        var LAST_INDEX = 'lastIndex';

        var UPDATES_LAST_INDEX_WRONG = function () {
          var re1 = /a/,
              re2 = /b*/g;
          nativeExec.call(re1, 'a');
          nativeExec.call(re2, 'a');
          return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
        }();

        // nonparticipating capturing group, copied from es5-shim's String#split patch.
        var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

        var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

        if (PATCH) {
          patchedExec = function exec(str) {
            var re = this;
            var lastIndex, reCopy, match, i;

            if (NPCG_INCLUDED) {
              reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
            }
            if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

            match = nativeExec.call(re, str);

            if (UPDATES_LAST_INDEX_WRONG && match) {
              re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
            }
            if (NPCG_INCLUDED && match && match.length > 1) {
              // Fix browsers whose `exec` methods don't consistently return `undefined`
              // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
              // eslint-disable-next-line no-loop-func
              nativeReplace.call(match[0], reCopy, function () {
                for (i = 1; i < arguments.length - 2; i++) {
                  if (arguments[i] === undefined) match[i] = undefined;
                }
              });
            }

            return match;
          };
        }

        module.exports = patchedExec;

        /***/
      },

      /***/"52a7":
      /***/function a7(module, exports) {

        exports.f = {}.propertyIsEnumerable;

        /***/
      },

      /***/"5537":
      /***/function _(module, exports, __webpack_require__) {

        var core = __webpack_require__("8378");
        var global = __webpack_require__("7726");
        var SHARED = '__core-js_shared__';
        var store = global[SHARED] || (global[SHARED] = {});

        (module.exports = function (key, value) {
          return store[key] || (store[key] = value !== undefined ? value : {});
        })('versions', []).push({
          version: core.version,
          mode: __webpack_require__("2d00") ? 'pure' : 'global',
          copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
        });

        /***/
      },

      /***/"5ca1":
      /***/function ca1(module, exports, __webpack_require__) {

        var global = __webpack_require__("7726");
        var core = __webpack_require__("8378");
        var hide = __webpack_require__("32e9");
        var redefine = __webpack_require__("2aba");
        var ctx = __webpack_require__("9b43");
        var PROTOTYPE = 'prototype';

        var $export = function $export(type, name, source) {
          var IS_FORCED = type & $export.F;
          var IS_GLOBAL = type & $export.G;
          var IS_STATIC = type & $export.S;
          var IS_PROTO = type & $export.P;
          var IS_BIND = type & $export.B;
          var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
          var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
          var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
          var key, own, out, exp;
          if (IS_GLOBAL) source = name;
          for (key in source) {
            // contains in native
            own = !IS_FORCED && target && target[key] !== undefined;
            // export native or passed
            out = (own ? target : source)[key];
            // bind timers to global for call from export context
            exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
            // extend global
            if (target) redefine(target, key, out, type & $export.U);
            // export
            if (exports[key] != out) hide(exports, key, exp);
            if (IS_PROTO && expProto[key] != out) expProto[key] = out;
          }
        };
        global.core = core;
        // type bitmap
        $export.F = 1; // forced
        $export.G = 2; // global
        $export.S = 4; // static
        $export.P = 8; // proto
        $export.B = 16; // bind
        $export.W = 32; // wrap
        $export.U = 64; // safe
        $export.R = 128; // real proto method for `library`
        module.exports = $export;

        /***/
      },

      /***/"5eda":
      /***/function eda(module, exports, __webpack_require__) {

        // most Object methods by ES6 should accept primitives
        var $export = __webpack_require__("5ca1");
        var core = __webpack_require__("8378");
        var fails = __webpack_require__("79e5");
        module.exports = function (KEY, exec) {
          var fn = (core.Object || {})[KEY] || Object[KEY];
          var exp = {};
          exp[KEY] = exec(fn);
          $export($export.S + $export.F * fails(function () {
            fn(1);
          }), 'Object', exp);
        };

        /***/
      },

      /***/"5f1b":
      /***/function f1b(module, exports, __webpack_require__) {

        "use strict";

        var classof = __webpack_require__("23c6");
        var builtinExec = RegExp.prototype.exec;

        // `RegExpExec` abstract operation
        // https://tc39.github.io/ecma262/#sec-regexpexec
        module.exports = function (R, S) {
          var exec = R.exec;
          if (typeof exec === 'function') {
            var result = exec.call(R, S);
            if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) !== 'object') {
              throw new TypeError('RegExp exec method returned something other than an Object or null');
            }
            return result;
          }
          if (classof(R) !== 'RegExp') {
            throw new TypeError('RegExp#exec called on incompatible receiver');
          }
          return builtinExec.call(R, S);
        };

        /***/
      },

      /***/"613b":
      /***/function b(module, exports, __webpack_require__) {

        var shared = __webpack_require__("5537")('keys');
        var uid = __webpack_require__("ca5a");
        module.exports = function (key) {
          return shared[key] || (shared[key] = uid(key));
        };

        /***/
      },

      /***/"626a":
      /***/function a(module, exports, __webpack_require__) {

        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        var cof = __webpack_require__("2d95");
        // eslint-disable-next-line no-prototype-builtins
        module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
          return cof(it) == 'String' ? it.split('') : Object(it);
        };

        /***/
      },

      /***/"6762":
      /***/function _(module, exports, __webpack_require__) {

        "use strict";

        // https://github.com/tc39/Array.prototype.includes

        var $export = __webpack_require__("5ca1");
        var $includes = __webpack_require__("c366")(true);

        $export($export.P, 'Array', {
          includes: function includes(el /* , fromIndex = 0 */) {
            return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
          }
        });

        __webpack_require__("9c6c")('includes');

        /***/
      },

      /***/"6821":
      /***/function _(module, exports, __webpack_require__) {

        // to indexed object, toObject with fallback for non-array-like ES3 strings
        var IObject = __webpack_require__("626a");
        var defined = __webpack_require__("be13");
        module.exports = function (it) {
          return IObject(defined(it));
        };

        /***/
      },

      /***/"69a8":
      /***/function a8(module, exports) {

        var hasOwnProperty = {}.hasOwnProperty;
        module.exports = function (it, key) {
          return hasOwnProperty.call(it, key);
        };

        /***/
      },

      /***/"6a99":
      /***/function a99(module, exports, __webpack_require__) {

        // 7.1.1 ToPrimitive(input [, PreferredType])
        var isObject = __webpack_require__("d3f4");
        // instead of the ES6 spec version, we didn't implement @@toPrimitive case
        // and the second argument - flag - preferred type is a string
        module.exports = function (it, S) {
          if (!isObject(it)) return it;
          var fn, val;
          if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
          if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          throw TypeError("Can't convert object to primitive value");
        };

        /***/
      },

      /***/"7333":
      /***/function _(module, exports, __webpack_require__) {

        "use strict";

        // 19.1.2.1 Object.assign(target, source, ...)

        var getKeys = __webpack_require__("0d58");
        var gOPS = __webpack_require__("2621");
        var pIE = __webpack_require__("52a7");
        var toObject = __webpack_require__("4bf8");
        var IObject = __webpack_require__("626a");
        var $assign = Object.assign;

        // should work with symbols and should have deterministic property order (V8 bug)
        module.exports = !$assign || __webpack_require__("79e5")(function () {
          var A = {};
          var B = {};
          // eslint-disable-next-line no-undef
          var S = Symbol();
          var K = 'abcdefghijklmnopqrst';
          A[S] = 7;
          K.split('').forEach(function (k) {
            B[k] = k;
          });
          return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
        }) ? function assign(target, source) {
          // eslint-disable-line no-unused-vars
          var T = toObject(target);
          var aLen = arguments.length;
          var index = 1;
          var getSymbols = gOPS.f;
          var isEnum = pIE.f;
          while (aLen > index) {
            var S = IObject(arguments[index++]);
            var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
            var length = keys.length;
            var j = 0;
            var key;
            while (length > j) {
              if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
            }
          }return T;
        } : $assign;

        /***/
      },

      /***/"7726":
      /***/function _(module, exports) {

        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
        // eslint-disable-next-line no-new-func
        : Function('return this')();
        if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


        /***/
      },

      /***/"77f1":
      /***/function f1(module, exports, __webpack_require__) {

        var toInteger = __webpack_require__("4588");
        var max = Math.max;
        var min = Math.min;
        module.exports = function (index, length) {
          index = toInteger(index);
          return index < 0 ? max(index + length, 0) : min(index, length);
        };

        /***/
      },

      /***/"79e5":
      /***/function e5(module, exports) {

        module.exports = function (exec) {
          try {
            return !!exec();
          } catch (e) {
            return true;
          }
        };

        /***/
      },

      /***/"7f20":
      /***/function f20(module, exports, __webpack_require__) {

        var def = __webpack_require__("86cc").f;
        var has = __webpack_require__("69a8");
        var TAG = __webpack_require__("2b4c")('toStringTag');

        module.exports = function (it, tag, stat) {
          if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
        };

        /***/
      },

      /***/"8378":
      /***/function _(module, exports) {

        var core = module.exports = { version: '2.6.5' };
        if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


        /***/
      },

      /***/"84f2":
      /***/function f2(module, exports) {

        module.exports = {};

        /***/
      },

      /***/"86cc":
      /***/function cc(module, exports, __webpack_require__) {

        var anObject = __webpack_require__("cb7c");
        var IE8_DOM_DEFINE = __webpack_require__("c69a");
        var toPrimitive = __webpack_require__("6a99");
        var dP = Object.defineProperty;

        exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
          anObject(O);
          P = toPrimitive(P, true);
          anObject(Attributes);
          if (IE8_DOM_DEFINE) try {
            return dP(O, P, Attributes);
          } catch (e) {/* empty */}
          if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
          if ('value' in Attributes) O[P] = Attributes.value;
          return O;
        };

        /***/
      },

      /***/"9b43":
      /***/function b43(module, exports, __webpack_require__) {

        // optional / simple context binding
        var aFunction = __webpack_require__("d8e8");
        module.exports = function (fn, that, length) {
          aFunction(fn);
          if (that === undefined) return fn;
          switch (length) {
            case 1:
              return function (a) {
                return fn.call(that, a);
              };
            case 2:
              return function (a, b) {
                return fn.call(that, a, b);
              };
            case 3:
              return function (a, b, c) {
                return fn.call(that, a, b, c);
              };
          }
          return function () /* ...args */{
            return fn.apply(that, arguments);
          };
        };

        /***/
      },

      /***/"9c6c":
      /***/function c6c(module, exports, __webpack_require__) {

        // 22.1.3.31 Array.prototype[@@unscopables]
        var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
        var ArrayProto = Array.prototype;
        if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
        module.exports = function (key) {
          ArrayProto[UNSCOPABLES][key] = true;
        };

        /***/
      },

      /***/"9def":
      /***/function def(module, exports, __webpack_require__) {

        // 7.1.15 ToLength
        var toInteger = __webpack_require__("4588");
        var min = Math.min;
        module.exports = function (it) {
          return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
        };

        /***/
      },

      /***/"9e1e":
      /***/function e1e(module, exports, __webpack_require__) {

        // Thank's IE8 for his funny defineProperty
        module.exports = !__webpack_require__("79e5")(function () {
          return Object.defineProperty({}, 'a', { get: function get() {
              return 7;
            } }).a != 7;
        });

        /***/
      },

      /***/"a352":
      /***/function a352(module, exports) {

        module.exports = __WEBPACK_EXTERNAL_MODULE_a352__;

        /***/
      },

      /***/"a481":
      /***/function a481(module, exports, __webpack_require__) {

        "use strict";

        var anObject = __webpack_require__("cb7c");
        var toObject = __webpack_require__("4bf8");
        var toLength = __webpack_require__("9def");
        var toInteger = __webpack_require__("4588");
        var advanceStringIndex = __webpack_require__("0390");
        var regExpExec = __webpack_require__("5f1b");
        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
        var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

        var maybeToString = function maybeToString(it) {
          return it === undefined ? it : String(it);
        };

        // @@replace logic
        __webpack_require__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
          return [
          // `String.prototype.replace` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.replace
          function replace(searchValue, replaceValue) {
            var O = defined(this);
            var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
            return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
          },
          // `RegExp.prototype[@@replace]` method
          // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
          function (regexp, replaceValue) {
            var res = maybeCallNative($replace, regexp, this, replaceValue);
            if (res.done) return res.value;

            var rx = anObject(regexp);
            var S = String(this);
            var functionalReplace = typeof replaceValue === 'function';
            if (!functionalReplace) replaceValue = String(replaceValue);
            var global = rx.global;
            if (global) {
              var fullUnicode = rx.unicode;
              rx.lastIndex = 0;
            }
            var results = [];
            while (true) {
              var result = regExpExec(rx, S);
              if (result === null) break;
              results.push(result);
              if (!global) break;
              var matchStr = String(result[0]);
              if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = '';
            var nextSourcePosition = 0;
            for (var i = 0; i < results.length; i++) {
              result = results[i];
              var matched = String(result[0]);
              var position = max(min(toInteger(result.index), S.length), 0);
              var captures = [];
              // NOTE: This is equivalent to
              //   captures = result.slice(1).map(maybeToString)
              // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
              // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
              // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
              for (var j = 1; j < result.length; j++) {
                captures.push(maybeToString(result[j]));
              }var namedCaptures = result.groups;
              if (functionalReplace) {
                var replacerArgs = [matched].concat(captures, position, S);
                if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
                var replacement = String(replaceValue.apply(undefined, replacerArgs));
              } else {
                replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
              }
              if (position >= nextSourcePosition) {
                accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
                nextSourcePosition = position + matched.length;
              }
            }
            return accumulatedResult + S.slice(nextSourcePosition);
          }];

          // https://tc39.github.io/ecma262/#sec-getsubstitution
          function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
            var tailPos = position + matched.length;
            var m = captures.length;
            var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
            if (namedCaptures !== undefined) {
              namedCaptures = toObject(namedCaptures);
              symbols = SUBSTITUTION_SYMBOLS;
            }
            return $replace.call(replacement, symbols, function (match, ch) {
              var capture;
              switch (ch.charAt(0)) {
                case '$':
                  return '$';
                case '&':
                  return matched;
                case '`':
                  return str.slice(0, position);
                case "'":
                  return str.slice(tailPos);
                case '<':
                  capture = namedCaptures[ch.slice(1, -1)];
                  break;
                default:
                  // \d\d?
                  var n = +ch;
                  if (n === 0) return match;
                  if (n > m) {
                    var f = floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                    return match;
                  }
                  capture = captures[n - 1];
              }
              return capture === undefined ? '' : capture;
            });
          }
        });

        /***/
      },

      /***/"aae3":
      /***/function aae3(module, exports, __webpack_require__) {

        // 7.2.8 IsRegExp(argument)
        var isObject = __webpack_require__("d3f4");
        var cof = __webpack_require__("2d95");
        var MATCH = __webpack_require__("2b4c")('match');
        module.exports = function (it) {
          var isRegExp;
          return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
        };

        /***/
      },

      /***/"ac6a":
      /***/function ac6a(module, exports, __webpack_require__) {

        var $iterators = __webpack_require__("cadf");
        var getKeys = __webpack_require__("0d58");
        var redefine = __webpack_require__("2aba");
        var global = __webpack_require__("7726");
        var hide = __webpack_require__("32e9");
        var Iterators = __webpack_require__("84f2");
        var wks = __webpack_require__("2b4c");
        var ITERATOR = wks('iterator');
        var TO_STRING_TAG = wks('toStringTag');
        var ArrayValues = Iterators.Array;

        var DOMIterables = {
          CSSRuleList: true, // TODO: Not spec compliant, should be false.
          CSSStyleDeclaration: false,
          CSSValueList: false,
          ClientRectList: false,
          DOMRectList: false,
          DOMStringList: false,
          DOMTokenList: true,
          DataTransferItemList: false,
          FileList: false,
          HTMLAllCollection: false,
          HTMLCollection: false,
          HTMLFormElement: false,
          HTMLSelectElement: false,
          MediaList: true, // TODO: Not spec compliant, should be false.
          MimeTypeArray: false,
          NamedNodeMap: false,
          NodeList: true,
          PaintRequestList: false,
          Plugin: false,
          PluginArray: false,
          SVGLengthList: false,
          SVGNumberList: false,
          SVGPathSegList: false,
          SVGPointList: false,
          SVGStringList: false,
          SVGTransformList: false,
          SourceBufferList: false,
          StyleSheetList: true, // TODO: Not spec compliant, should be false.
          TextTrackCueList: false,
          TextTrackList: false,
          TouchList: false
        };

        for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
          var NAME = collections[i];
          var explicit = DOMIterables[NAME];
          var Collection = global[NAME];
          var proto = Collection && Collection.prototype;
          var key;
          if (proto) {
            if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
            if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
            Iterators[NAME] = ArrayValues;
            if (explicit) for (key in $iterators) {
              if (!proto[key]) redefine(proto, key, $iterators[key], true);
            }
          }
        }

        /***/
      },

      /***/"b0c5":
      /***/function b0c5(module, exports, __webpack_require__) {

        "use strict";

        var regexpExec = __webpack_require__("520a");
        __webpack_require__("5ca1")({
          target: 'RegExp',
          proto: true,
          forced: regexpExec !== /./.exec
        }, {
          exec: regexpExec
        });

        /***/
      },

      /***/"be13":
      /***/function be13(module, exports) {

        // 7.2.1 RequireObjectCoercible(argument)
        module.exports = function (it) {
          if (it == undefined) throw TypeError("Can't call method on  " + it);
          return it;
        };

        /***/
      },

      /***/"c366":
      /***/function c366(module, exports, __webpack_require__) {

        // false -> Array#indexOf
        // true  -> Array#includes
        var toIObject = __webpack_require__("6821");
        var toLength = __webpack_require__("9def");
        var toAbsoluteIndex = __webpack_require__("77f1");
        module.exports = function (IS_INCLUDES) {
          return function ($this, el, fromIndex) {
            var O = toIObject($this);
            var length = toLength(O.length);
            var index = toAbsoluteIndex(fromIndex, length);
            var value;
            // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare
            if (IS_INCLUDES && el != el) while (length > index) {
              value = O[index++];
              // eslint-disable-next-line no-self-compare
              if (value != value) return true;
              // Array#indexOf ignores holes, Array#includes - not
            } else for (; length > index; index++) {
              if (IS_INCLUDES || index in O) {
                if (O[index] === el) return IS_INCLUDES || index || 0;
              }
            }return !IS_INCLUDES && -1;
          };
        };

        /***/
      },

      /***/"c649":
      /***/function c649(module, __webpack_exports__, __webpack_require__) {

        "use strict";
        /* WEBPACK VAR INJECTION */
        (function (global) {
          /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "c", function () {
            return insertNodeAt;
          });
          /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
            return camelize;
          });
          /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
            return console;
          });
          /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "d", function () {
            return removeNode;
          });
          /* harmony import */var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a481");
          /* harmony import */var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__);

          function getConsole() {
            if (typeof window !== "undefined") {
              return window.console;
            }

            return global.console;
          }

          var console = getConsole();

          function cached(fn) {
            var cache = Object.create(null);
            return function cachedFn(str) {
              var hit = cache[str];
              return hit || (cache[str] = fn(str));
            };
          }

          var regex = /-(\w)/g;
          var camelize = cached(function (str) {
            return str.replace(regex, function (_, c) {
              return c ? c.toUpperCase() : "";
            });
          });

          function removeNode(node) {
            if (node.parentElement !== null) {
              node.parentElement.removeChild(node);
            }
          }

          function insertNodeAt(fatherNode, node, position) {
            var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
            fatherNode.insertBefore(node, refNode);
          }

          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__("c8ba"));

        /***/
      },

      /***/"c69a":
      /***/function c69a(module, exports, __webpack_require__) {

        module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
          return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function get() {
              return 7;
            } }).a != 7;
        });

        /***/
      },

      /***/"c8ba":
      /***/function c8ba(module, exports) {

        var g;

        // This works in non-strict mode
        g = function () {
          return this;
        }();

        try {
          // This works if eval is allowed (see CSP)
          g = g || new Function("return this")();
        } catch (e) {
          // This works if the window reference is available
          if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === "object") g = window;
        }

        // g can still be undefined, but nothing to do about it...
        // We return undefined, instead of nothing here, so it's
        // easier to handle this case. if(!global) { ...}

        module.exports = g;

        /***/
      },

      /***/"ca5a":
      /***/function ca5a(module, exports) {

        var id = 0;
        var px = Math.random();
        module.exports = function (key) {
          return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
        };

        /***/
      },

      /***/"cadf":
      /***/function cadf(module, exports, __webpack_require__) {

        "use strict";

        var addToUnscopables = __webpack_require__("9c6c");
        var step = __webpack_require__("d53b");
        var Iterators = __webpack_require__("84f2");
        var toIObject = __webpack_require__("6821");

        // 22.1.3.4 Array.prototype.entries()
        // 22.1.3.13 Array.prototype.keys()
        // 22.1.3.29 Array.prototype.values()
        // 22.1.3.30 Array.prototype[@@iterator]()
        module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
          this._t = toIObject(iterated); // target
          this._i = 0; // next index
          this._k = kind; // kind
          // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
        }, function () {
          var O = this._t;
          var kind = this._k;
          var index = this._i++;
          if (!O || index >= O.length) {
            this._t = undefined;
            return step(1);
          }
          if (kind == 'keys') return step(0, index);
          if (kind == 'values') return step(0, O[index]);
          return step(0, [index, O[index]]);
        }, 'values');

        // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
        Iterators.Arguments = Iterators.Array;

        addToUnscopables('keys');
        addToUnscopables('values');
        addToUnscopables('entries');

        /***/
      },

      /***/"cb7c":
      /***/function cb7c(module, exports, __webpack_require__) {

        var isObject = __webpack_require__("d3f4");
        module.exports = function (it) {
          if (!isObject(it)) throw TypeError(it + ' is not an object!');
          return it;
        };

        /***/
      },

      /***/"ce10":
      /***/function ce10(module, exports, __webpack_require__) {

        var has = __webpack_require__("69a8");
        var toIObject = __webpack_require__("6821");
        var arrayIndexOf = __webpack_require__("c366")(false);
        var IE_PROTO = __webpack_require__("613b")('IE_PROTO');

        module.exports = function (object, names) {
          var O = toIObject(object);
          var i = 0;
          var result = [];
          var key;
          for (key in O) {
            if (key != IE_PROTO) has(O, key) && result.push(key);
          } // Don't enum bug & hidden keys
          while (names.length > i) {
            if (has(O, key = names[i++])) {
              ~arrayIndexOf(result, key) || result.push(key);
            }
          }return result;
        };

        /***/
      },

      /***/"d2c8":
      /***/function d2c8(module, exports, __webpack_require__) {

        // helper for String#{startsWith, endsWith, includes}
        var isRegExp = __webpack_require__("aae3");
        var defined = __webpack_require__("be13");

        module.exports = function (that, searchString, NAME) {
          if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
          return String(defined(that));
        };

        /***/
      },

      /***/"d3f4":
      /***/function d3f4(module, exports) {

        module.exports = function (it) {
          return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
        };

        /***/
      },

      /***/"d53b":
      /***/function d53b(module, exports) {

        module.exports = function (done, value) {
          return { value: value, done: !!done };
        };

        /***/
      },

      /***/"d8e8":
      /***/function d8e8(module, exports) {

        module.exports = function (it) {
          if (typeof it != 'function') throw TypeError(it + ' is not a function!');
          return it;
        };

        /***/
      },

      /***/"e11e":
      /***/function e11e(module, exports) {

        // IE 8- don't enum bug keys
        module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

        /***/
      },

      /***/"f559":
      /***/function f559(module, exports, __webpack_require__) {

        "use strict";
        // 21.1.3.18 String.prototype.startsWith(searchString [, position ])

        var $export = __webpack_require__("5ca1");
        var toLength = __webpack_require__("9def");
        var context = __webpack_require__("d2c8");
        var STARTS_WITH = 'startsWith';
        var $startsWith = ''[STARTS_WITH];

        $export($export.P + $export.F * __webpack_require__("5147")(STARTS_WITH), 'String', {
          startsWith: function startsWith(searchString /* , position = 0 */) {
            var that = context(this, searchString, STARTS_WITH);
            var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
            var search = String(searchString);
            return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
          }
        });

        /***/
      },

      /***/"f6fd":
      /***/function f6fd(module, exports) {

        // document.currentScript polyfill by Adam Miller

        // MIT license

        (function (document) {
          var currentScript = "currentScript",
              scripts = document.getElementsByTagName('script'); // Live NodeList collection

          // If browser needs currentScript polyfill, add get currentScript() to the document object
          if (!(currentScript in document)) {
            Object.defineProperty(document, currentScript, {
              get: function get() {

                // IE 6-10 supports script readyState
                // IE 10+ support stack trace
                try {
                  throw new Error();
                } catch (err) {

                  // Find the second match for the "at" string to get file src url from stack.
                  // Specifically works with the format of stack traces in IE.
                  var i,
                      res = (/.*at [^\(]*\((.*):.+:.+\)$/ig.exec(err.stack) || [false])[1];

                  // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
                  for (i in scripts) {
                    if (scripts[i].src == res || scripts[i].readyState == "interactive") {
                      return scripts[i];
                    }
                  }

                  // If no match, return null
                  return null;
                }
              }
            });
          }
        })(document);

        /***/
      },

      /***/"f751":
      /***/function f751(module, exports, __webpack_require__) {

        // 19.1.3.1 Object.assign(target, source)
        var $export = __webpack_require__("5ca1");

        $export($export.S + $export.F, 'Object', { assign: __webpack_require__("7333") });

        /***/
      },

      /***/"fa5b":
      /***/function fa5b(module, exports, __webpack_require__) {

        module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);

        /***/
      },

      /***/"fab2":
      /***/function fab2(module, exports, __webpack_require__) {

        var document = __webpack_require__("7726").document;
        module.exports = document && document.documentElement;

        /***/
      },

      /***/"fb15":
      /***/function fb15(module, __webpack_exports__, __webpack_require__) {

        "use strict";
        // ESM COMPAT FLAG

        __webpack_require__.r(__webpack_exports__);

        // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
        // This file is imported into lib/wc client bundles.

        if (typeof window !== 'undefined') {
          if (true) {
            __webpack_require__("f6fd");
          }

          var setPublicPath_i;
          if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
            __webpack_require__.p = setPublicPath_i[1]; // eslint-disable-line
          }
        }

        // Indicate to webpack that this file can be concatenated
        /* harmony default export */var setPublicPath = null;

        // EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
        var es6_object_assign = __webpack_require__("f751");

        // EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
        var es6_string_starts_with = __webpack_require__("f559");

        // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
        var web_dom_iterable = __webpack_require__("ac6a");

        // EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
        var es6_array_iterator = __webpack_require__("cadf");

        // EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
        var es6_object_keys = __webpack_require__("456d");

        // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
        function _arrayWithHoles(arr) {
          if (Array.isArray(arr)) return arr;
        }
        // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
        function _iterableToArrayLimit(arr, i) {
          if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
          var _arr = [];
          var _n = true;
          var _d = false;
          var _e = undefined;

          try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e = err;
          } finally {
            try {
              if (!_n && _i["return"] != null) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }

          return _arr;
        }
        // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;

          for (var i = 0, arr2 = new Array(len); i < len; i++) {
            arr2[i] = arr[i];
          }

          return arr2;
        }
        // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
        }
        // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
        function _nonIterableRest() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js


        function _slicedToArray(arr, i) {
          return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
        }
        // EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
        var es7_array_includes = __webpack_require__("6762");

        // EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
        var es6_string_includes = __webpack_require__("2fdb");

        // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) return _arrayLikeToArray(arr);
        }
        // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
        function _iterableToArray(iter) {
          if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
        }
        // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
        function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js


        function _toConsumableArray(arr) {
          return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
        }
        // EXTERNAL MODULE: external {"commonjs":"sortablejs","commonjs2":"sortablejs","amd":"sortablejs","root":"Sortable"}
        var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_ = __webpack_require__("a352");
        var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_);

        // EXTERNAL MODULE: ./src/util/helper.js
        var helper = __webpack_require__("c649");

        // CONCATENATED MODULE: ./src/vuedraggable.js


        function buildAttribute(object, propName, value) {
          if (value === undefined) {
            return object;
          }

          object = object || {};
          object[propName] = value;
          return object;
        }

        function computeVmIndex(vnodes, element) {
          return vnodes.map(function (elt) {
            return elt.elm;
          }).indexOf(element);
        }

        function _computeIndexes(slots, children, isTransition, footerOffset) {
          if (!slots) {
            return [];
          }

          var elmFromNodes = slots.map(function (elt) {
            return elt.elm;
          });
          var footerIndex = children.length - footerOffset;

          var rawIndexes = _toConsumableArray(children).map(function (elt, idx) {
            return idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt);
          });

          return isTransition ? rawIndexes.filter(function (ind) {
            return ind !== -1;
          }) : rawIndexes;
        }

        function emit(evtName, evtData) {
          var _this = this;

          this.$nextTick(function () {
            return _this.$emit(evtName.toLowerCase(), evtData);
          });
        }

        function delegateAndEmit(evtName) {
          var _this2 = this;

          return function (evtData) {
            if (_this2.realList !== null) {
              _this2["onDrag" + evtName](evtData);
            }

            emit.call(_this2, evtName, evtData);
          };
        }

        function isTransitionName(name) {
          return ["transition-group", "TransitionGroup"].includes(name);
        }

        function vuedraggable_isTransition(slots) {
          if (!slots || slots.length !== 1) {
            return false;
          }

          var _slots = _slicedToArray(slots, 1),
              componentOptions = _slots[0].componentOptions;

          if (!componentOptions) {
            return false;
          }

          return isTransitionName(componentOptions.tag);
        }

        function getSlot(slot, scopedSlot, key) {
          return slot[key] || (scopedSlot[key] ? scopedSlot[key]() : undefined);
        }

        function computeChildrenAndOffsets(children, slot, scopedSlot) {
          var headerOffset = 0;
          var footerOffset = 0;
          var header = getSlot(slot, scopedSlot, "header");

          if (header) {
            headerOffset = header.length;
            children = children ? [].concat(_toConsumableArray(header), _toConsumableArray(children)) : _toConsumableArray(header);
          }

          var footer = getSlot(slot, scopedSlot, "footer");

          if (footer) {
            footerOffset = footer.length;
            children = children ? [].concat(_toConsumableArray(children), _toConsumableArray(footer)) : _toConsumableArray(footer);
          }

          return {
            children: children,
            headerOffset: headerOffset,
            footerOffset: footerOffset
          };
        }

        function getComponentAttributes($attrs, componentData) {
          var attributes = null;

          var update = function update(name, value) {
            attributes = buildAttribute(attributes, name, value);
          };

          var attrs = Object.keys($attrs).filter(function (key) {
            return key === "id" || key.startsWith("data-");
          }).reduce(function (res, key) {
            res[key] = $attrs[key];
            return res;
          }, {});
          update("attrs", attrs);

          if (!componentData) {
            return attributes;
          }

          var on = componentData.on,
              props = componentData.props,
              componentDataAttrs = componentData.attrs;
          update("on", on);
          update("props", props);
          Object.assign(attributes.attrs, componentDataAttrs);
          return attributes;
        }

        var eventsListened = ["Start", "Add", "Remove", "Update", "End"];
        var eventsToEmit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
        var readonlyProperties = ["Move"].concat(eventsListened, eventsToEmit).map(function (evt) {
          return "on" + evt;
        });
        var draggingElement = null;
        var props = {
          options: Object,
          list: {
            type: Array,
            required: false,
            default: null
          },
          value: {
            type: Array,
            required: false,
            default: null
          },
          noTransitionOnDrag: {
            type: Boolean,
            default: false
          },
          clone: {
            type: Function,
            default: function _default(original) {
              return original;
            }
          },
          element: {
            type: String,
            default: "div"
          },
          tag: {
            type: String,
            default: null
          },
          move: {
            type: Function,
            default: null
          },
          componentData: {
            type: Object,
            required: false,
            default: null
          }
        };
        var draggableComponent = {
          name: "draggable",
          inheritAttrs: false,
          props: props,
          data: function data() {
            return {
              transitionMode: false,
              noneFunctionalComponentMode: false
            };
          },
          render: function render(h) {
            var slots = this.$slots.default;
            this.transitionMode = vuedraggable_isTransition(slots);

            var _computeChildrenAndOf = computeChildrenAndOffsets(slots, this.$slots, this.$scopedSlots),
                children = _computeChildrenAndOf.children,
                headerOffset = _computeChildrenAndOf.headerOffset,
                footerOffset = _computeChildrenAndOf.footerOffset;

            this.headerOffset = headerOffset;
            this.footerOffset = footerOffset;
            var attributes = getComponentAttributes(this.$attrs, this.componentData);
            return h(this.getTag(), attributes, children);
          },
          created: function created() {
            if (this.list !== null && this.value !== null) {
              helper["b" /* console */].error("Value and list props are mutually exclusive! Please set one or another.");
            }

            if (this.element !== "div") {
              helper["b" /* console */].warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props");
            }

            if (this.options !== undefined) {
              helper["b" /* console */].warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
            }
          },
          mounted: function mounted() {
            var _this3 = this;

            this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional();

            if (this.noneFunctionalComponentMode && this.transitionMode) {
              throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));
            }

            var optionsAdded = {};
            eventsListened.forEach(function (elt) {
              optionsAdded["on" + elt] = delegateAndEmit.call(_this3, elt);
            });
            eventsToEmit.forEach(function (elt) {
              optionsAdded["on" + elt] = emit.bind(_this3, elt);
            });
            var attributes = Object.keys(this.$attrs).reduce(function (res, key) {
              res[Object(helper["a" /* camelize */])(key)] = _this3.$attrs[key];
              return res;
            }, {});
            var options = Object.assign({}, this.options, attributes, optionsAdded, {
              onMove: function onMove(evt, originalEvent) {
                return _this3.onDragMove(evt, originalEvent);
              }
            });
            !("draggable" in options) && (options.draggable = ">*");
            this._sortable = new external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default.a(this.rootContainer, options);
            this.computeIndexes();
          },
          beforeDestroy: function beforeDestroy() {
            if (this._sortable !== undefined) this._sortable.destroy();
          },
          computed: {
            rootContainer: function rootContainer() {
              return this.transitionMode ? this.$el.children[0] : this.$el;
            },
            realList: function realList() {
              return this.list ? this.list : this.value;
            }
          },
          watch: {
            options: {
              handler: function handler(newOptionValue) {
                this.updateOptions(newOptionValue);
              },
              deep: true
            },
            $attrs: {
              handler: function handler(newOptionValue) {
                this.updateOptions(newOptionValue);
              },
              deep: true
            },
            realList: function realList() {
              this.computeIndexes();
            }
          },
          methods: {
            getIsFunctional: function getIsFunctional() {
              var fnOptions = this._vnode.fnOptions;
              return fnOptions && fnOptions.functional;
            },
            getTag: function getTag() {
              return this.tag || this.element;
            },
            updateOptions: function updateOptions(newOptionValue) {
              for (var property in newOptionValue) {
                var value = Object(helper["a" /* camelize */])(property);

                if (readonlyProperties.indexOf(value) === -1) {
                  this._sortable.option(value, newOptionValue[property]);
                }
              }
            },
            getChildrenNodes: function getChildrenNodes() {
              if (this.noneFunctionalComponentMode) {
                return this.$children[0].$slots.default;
              }

              var rawNodes = this.$slots.default;
              return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
            },
            computeIndexes: function computeIndexes() {
              var _this4 = this;

              this.$nextTick(function () {
                _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode, _this4.footerOffset);
              });
            },
            getUnderlyingVm: function getUnderlyingVm(htmlElt) {
              var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);

              if (index === -1) {
                //Edge case during move callback: related element might be
                //an element different from collection
                return null;
              }

              var element = this.realList[index];
              return {
                index: index,
                element: element
              };
            },
            getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
              var vue = _ref.__vue__;

              if (!vue || !vue.$options || !isTransitionName(vue.$options._componentTag)) {
                if (!("realList" in vue) && vue.$children.length === 1 && "realList" in vue.$children[0]) return vue.$children[0];
                return vue;
              }

              return vue.$parent;
            },
            emitChanges: function emitChanges(evt) {
              var _this5 = this;

              this.$nextTick(function () {
                _this5.$emit("change", evt);
              });
            },
            alterList: function alterList(onList) {
              if (this.list) {
                onList(this.list);
                return;
              }

              var newList = _toConsumableArray(this.value);

              onList(newList);
              this.$emit("input", newList);
            },
            spliceList: function spliceList() {
              var _arguments = arguments;

              var spliceList = function spliceList(list) {
                return list.splice.apply(list, _toConsumableArray(_arguments));
              };

              this.alterList(spliceList);
            },
            updatePosition: function updatePosition(oldIndex, newIndex) {
              var updatePosition = function updatePosition(list) {
                return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
              };

              this.alterList(updatePosition);
            },
            getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
              var to = _ref2.to,
                  related = _ref2.related;
              var component = this.getUnderlyingPotencialDraggableComponent(to);

              if (!component) {
                return {
                  component: component
                };
              }

              var list = component.realList;
              var context = {
                list: list,
                component: component
              };

              if (to !== related && list && component.getUnderlyingVm) {
                var destination = component.getUnderlyingVm(related);

                if (destination) {
                  return Object.assign(destination, context);
                }
              }

              return context;
            },
            getVmIndex: function getVmIndex(domIndex) {
              var indexes = this.visibleIndexes;
              var numberIndexes = indexes.length;
              return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
            },
            getComponent: function getComponent() {
              return this.$slots.default[0].componentInstance;
            },
            resetTransitionData: function resetTransitionData(index) {
              if (!this.noTransitionOnDrag || !this.transitionMode) {
                return;
              }

              var nodes = this.getChildrenNodes();
              nodes[index].data = null;
              var transitionContainer = this.getComponent();
              transitionContainer.children = [];
              transitionContainer.kept = undefined;
            },
            onDragStart: function onDragStart(evt) {
              this.context = this.getUnderlyingVm(evt.item);
              evt.item._underlying_vm_ = this.clone(this.context.element);
              draggingElement = evt.item;
            },
            onDragAdd: function onDragAdd(evt) {
              var element = evt.item._underlying_vm_;

              if (element === undefined) {
                return;
              }

              Object(helper["d" /* removeNode */])(evt.item);
              var newIndex = this.getVmIndex(evt.newIndex);
              this.spliceList(newIndex, 0, element);
              this.computeIndexes();
              var added = {
                element: element,
                newIndex: newIndex
              };
              this.emitChanges({
                added: added
              });
            },
            onDragRemove: function onDragRemove(evt) {
              Object(helper["c" /* insertNodeAt */])(this.rootContainer, evt.item, evt.oldIndex);

              if (evt.pullMode === "clone") {
                Object(helper["d" /* removeNode */])(evt.clone);
                return;
              }

              var oldIndex = this.context.index;
              this.spliceList(oldIndex, 1);
              var removed = {
                element: this.context.element,
                oldIndex: oldIndex
              };
              this.resetTransitionData(oldIndex);
              this.emitChanges({
                removed: removed
              });
            },
            onDragUpdate: function onDragUpdate(evt) {
              Object(helper["d" /* removeNode */])(evt.item);
              Object(helper["c" /* insertNodeAt */])(evt.from, evt.item, evt.oldIndex);
              var oldIndex = this.context.index;
              var newIndex = this.getVmIndex(evt.newIndex);
              this.updatePosition(oldIndex, newIndex);
              var moved = {
                element: this.context.element,
                oldIndex: oldIndex,
                newIndex: newIndex
              };
              this.emitChanges({
                moved: moved
              });
            },
            updateProperty: function updateProperty(evt, propertyName) {
              evt.hasOwnProperty(propertyName) && (evt[propertyName] += this.headerOffset);
            },
            computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
              if (!relatedContext.element) {
                return 0;
              }

              var domChildren = _toConsumableArray(evt.to.children).filter(function (el) {
                return el.style["display"] !== "none";
              });

              var currentDOMIndex = domChildren.indexOf(evt.related);
              var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
              var draggedInList = domChildren.indexOf(draggingElement) !== -1;
              return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
            },
            onDragMove: function onDragMove(evt, originalEvent) {
              var onMove = this.move;

              if (!onMove || !this.realList) {
                return true;
              }

              var relatedContext = this.getRelatedContextFromMoveEvent(evt);
              var draggedContext = this.context;
              var futureIndex = this.computeFutureIndex(relatedContext, evt);
              Object.assign(draggedContext, {
                futureIndex: futureIndex
              });
              var sendEvt = Object.assign({}, evt, {
                relatedContext: relatedContext,
                draggedContext: draggedContext
              });
              return onMove(sendEvt, originalEvent);
            },
            onDragEnd: function onDragEnd() {
              this.computeIndexes();
              draggingElement = null;
            }
          }
        };

        if (typeof window !== "undefined" && "Vue" in window) {
          window.Vue.component("draggable", draggableComponent);
        }

        /* harmony default export */var vuedraggable = draggableComponent;
        // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


        /* harmony default export */var entry_lib = __webpack_exports__["default"] = vuedraggable;

        /***/
      }

      /******/ })["default"]
  );
});
//# sourceMappingURL=vuedraggable.umd.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module)))

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_pessoa_form_vue__ = __webpack_require__(708);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1271572_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_pessoa_form_vue__ = __webpack_require__(2039);
function injectStyle (ssrContext) {
  __webpack_require__(1997)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c1271572"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_pessoa_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1271572_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_pessoa_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_negocio_motivo_form_vue__ = __webpack_require__(713);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_60466be3_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_negocio_motivo_form_vue__ = __webpack_require__(2012);
function injectStyle (ssrContext) {
  __webpack_require__(2010)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_negocio_motivo_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_60466be3_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_negocio_motivo_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_negocio_participantes_vue__ = __webpack_require__(716);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_36489ac5_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_negocio_participantes_vue__ = __webpack_require__(2022);
function injectStyle (ssrContext) {
  __webpack_require__(2020)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_negocio_participantes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_36489ac5_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_negocio_participantes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_negocio_seguidores_vue__ = __webpack_require__(717);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba3a60c4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_negocio_seguidores_vue__ = __webpack_require__(2025);
function injectStyle (ssrContext) {
  __webpack_require__(2023)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_negocio_seguidores_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba3a60c4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_negocio_seguidores_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_org_form_vue__ = __webpack_require__(731);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee417686_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_org_form_vue__ = __webpack_require__(2069);
function injectStyle (ssrContext) {
  __webpack_require__(2067)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ee417686"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_org_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee417686_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_org_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_fecharcaixa_form_vue__ = __webpack_require__(764);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e60f1d44_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_fecharcaixa_form_vue__ = __webpack_require__(2181);
function injectStyle (ssrContext) {
  __webpack_require__(2179)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_fecharcaixa_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e60f1d44_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_fecharcaixa_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = !__webpack_require__(21) && !__webpack_require__(14)(function () {
  return Object.defineProperty(__webpack_require__(130)('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.f = __webpack_require__(18);

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(35);
var toIObject = __webpack_require__(36);
var arrayIndexOf = __webpack_require__(101)(false);
var IE_PROTO = __webpack_require__(132)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dP = __webpack_require__(22);
var anObject = __webpack_require__(10);
var getKeys = __webpack_require__(59);

module.exports = __webpack_require__(21) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) {
    dP.f(O, P = keys[i++], Properties[P]);
  }return O;
};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(36);
var gOPN = __webpack_require__(62).f;
var toString = {}.toString;

var windowNames = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)

var DESCRIPTORS = __webpack_require__(21);
var getKeys = __webpack_require__(59);
var gOPS = __webpack_require__(102);
var pIE = __webpack_require__(82);
var toObject = __webpack_require__(24);
var IObject = __webpack_require__(81);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(14)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  }return T;
} : $assign;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var aFunction = __webpack_require__(25);
var isObject = __webpack_require__(15);
var invoke = __webpack_require__(192);
var arraySlice = [].slice;
var factories = {};

var construct = function construct(F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) {
      n[i] = 'a[' + i + ']';
    } // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  }return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function bound() /* args... */{
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
                  var un = that === undefined;
                  switch (args.length) {
                                    case 0:
                                                      return un ? fn() : fn.call(that);
                                    case 1:
                                                      return un ? fn(args[0]) : fn.call(that, args[0]);
                                    case 2:
                                                      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
                                    case 3:
                                                      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
                                    case 4:
                                                      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
                  }return fn.apply(that, args);
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $parseInt = __webpack_require__(12).parseInt;
var $trim = __webpack_require__(72).trim;
var ws = __webpack_require__(136);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, radix >>> 0 || (hex.test(string) ? 16 : 10));
} : $parseInt;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $parseFloat = __webpack_require__(12).parseFloat;
var $trim = __webpack_require__(72).trim;

module.exports = 1 / $parseFloat(__webpack_require__(136) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cof = __webpack_require__(42);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(15);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(139);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function roundTiesToEven(n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// call something on iterator step with safe closing on error
var anObject = __webpack_require__(10);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var aFunction = __webpack_require__(25);
var toObject = __webpack_require__(24);
var IObject = __webpack_require__(81);
var toLength = __webpack_require__(19);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (; isRight ? index >= 0 : length > index; index += i) {
    if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
  }return memo;
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)


var toObject = __webpack_require__(24);
var toAbsoluteIndex = __webpack_require__(60);
var toLength = __webpack_require__(19);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];else delete O[to];
    to += inc;
    from += inc;
  }return O;
};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (done, value) {
  return { value: value, done: !!done };
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpExec = __webpack_require__(151);
__webpack_require__(6)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(21) && /./g.flags != 'g') __webpack_require__(22).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(83)
});

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(10);
var isObject = __webpack_require__(15);
var newPromiseCapability = __webpack_require__(155);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strong = __webpack_require__(208);
var validate = __webpack_require__(67);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(110)(MAP, function (get) {
  return function Map() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dP = __webpack_require__(22).f;
var create = __webpack_require__(61);
var redefineAll = __webpack_require__(66);
var ctx = __webpack_require__(41);
var anInstance = __webpack_require__(64);
var forOf = __webpack_require__(65);
var $iterDefine = __webpack_require__(141);
var step = __webpack_require__(202);
var setSpecies = __webpack_require__(63);
var DESCRIPTORS = __webpack_require__(21);
var fastKey = __webpack_require__(54).fastKey;
var validate = __webpack_require__(67);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function getEntry(that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME; // collection type
      that._i = create(null); // index
      that._f = undefined; // first entry
      that._l = undefined; // last entry
      that[SIZE] = 0; // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function _delete(key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        }return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) {
            entry = entry.p;
          }
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function get() {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function def(that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
      // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key, // <- key
        v: value, // <- value
        p: prev = that._l, // <- previous entry
        n: undefined, // <- next entry
        r: false // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    }return that;
  },
  getEntry: getEntry,
  setStrong: function setStrong(C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind; // kind
      this._l = undefined; // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) {
        entry = entry.p;
      } // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strong = __webpack_require__(208);
var validate = __webpack_require__(67);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(110)(SET, function (get) {
  return function Set() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(12);
var each = __webpack_require__(49)(0);
var redefine = __webpack_require__(30);
var meta = __webpack_require__(54);
var assign = __webpack_require__(189);
var weak = __webpack_require__(211);
var isObject = __webpack_require__(15);
var validate = __webpack_require__(67);
var NATIVE_WEAK_MAP = __webpack_require__(67);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function wrapper(get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(110)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
        // store all the rest on native weakmap
      }return method.call(this, a, b);
    });
  });
}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var redefineAll = __webpack_require__(66);
var getWeak = __webpack_require__(54).getWeak;
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(15);
var anInstance = __webpack_require__(64);
var forOf = __webpack_require__(65);
var createArrayMethod = __webpack_require__(49);
var $has = __webpack_require__(35);
var validate = __webpack_require__(67);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function UncaughtFrozenStore() {
  this.a = [];
};
var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function get(key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function has(key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function set(key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;else this.a.push([key, value]);
  },
  'delete': function _delete(key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME; // collection type
      that._i = id++; // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function _delete(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function def(that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(43);
var toLength = __webpack_require__(19);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(62);
var gOPS = __webpack_require__(102);
var anObject = __webpack_require__(10);
var Reflect = __webpack_require__(12).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray

var isArray = __webpack_require__(103);
var isObject = __webpack_require__(15);
var toLength = __webpack_require__(19);
var ctx = __webpack_require__(41);
var IS_CONCAT_SPREADABLE = __webpack_require__(18)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(19);
var repeat = __webpack_require__(138);
var defined = __webpack_require__(47);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DESCRIPTORS = __webpack_require__(21);
var getKeys = __webpack_require__(59);
var toIObject = __webpack_require__(36);
var isEnum = __webpack_require__(82).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(71);
var from = __webpack_require__(218);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var forOf = __webpack_require__(65);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (arguments.length === 0
  // eslint-disable-next-line no-self-compare
  || x != x
  // eslint-disable-next-line no-self-compare
  || inLow != inLow
  // eslint-disable-next-line no-self-compare
  || inHigh != inHigh
  // eslint-disable-next-line no-self-compare
  || outLow != outLow
  // eslint-disable-next-line no-self-compare
  || outHigh != outHigh) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * vuex v3.6.2
 * (c) 2021 Evan You
 * @license MIT
 */
function applyMixin(Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if (options === void 0) options = {};

      options.init = options.init ? [vuexInit].concat(options.init) : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit() {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function' ? options.store() : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin(store) {
  if (!devtoolHook) {
    return;
  }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find(list, f) {
  return list.filter(f)[0];
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy(obj, cache) {
  if (cache === void 0) cache = [];

  // just return if obj is immutable value
  if (obj === null || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    return obj;
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) {
    return c.original === obj;
  });
  if (hit) {
    return hit.copy;
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy;
}

/**
 * forEach for object
 */
function forEachValue(obj, fn) {
  Object.keys(obj).forEach(function (key) {
    return fn(obj[key], key);
  });
}

function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}

function isPromise(val) {
  return val && typeof val.then === 'function';
}

function assert(condition, msg) {
  if (!condition) {
    throw new Error("[vuex] " + msg);
  }
}

function partial(fn, arg) {
  return function () {
    return fn(arg);
  };
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module(rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced;
};

Module.prototype.addChild = function addChild(key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild(key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild(key) {
  return this._children[key];
};

Module.prototype.hasChild = function hasChild(key) {
  return key in this._children;
};

Module.prototype.update = function update(rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild(fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter(fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction(fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation(fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties(Module.prototype, prototypeAccessors);

var ModuleCollection = function ModuleCollection(rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get(path) {
  return path.reduce(function (module, key) {
    return module.getChild(key);
  }, this.root);
};

ModuleCollection.prototype.getNamespace = function getNamespace(path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '');
  }, '');
};

ModuleCollection.prototype.update = function update$1(rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register(path, rawModule, runtime) {
  var this$1 = this;
  if (runtime === void 0) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister(path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    if (false) {
      console.warn("[vuex] trying to unregister module '" + key + "', which is " + "not registered");
    }
    return;
  }

  if (!child.runtime) {
    return;
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered(path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  if (parent) {
    return parent.hasChild(key);
  }

  return false;
};

function update(path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn("[vuex] trying to add a new module '" + key + "' on hot reloading, " + 'manual reload is needed');
        }
        return;
      }
      update(path.concat(key), targetModule.getChild(key), newModule.modules[key]);
    }
  }
}

var functionAssert = {
  assert: function assert(value) {
    return typeof value === 'function';
  },
  expected: 'function'
};

var objectAssert = {
  assert: function assert(value) {
    return typeof value === 'function' || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.handler === 'function';
  },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule(path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) {
      return;
    }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(assertOptions.assert(value), makeAssertionMessage(path, key, type, value, assertOptions.expected));
    });
  });
}

function makeAssertionMessage(path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + path.join('.') + "\"";
  }
  buf += " is " + JSON.stringify(value) + ".";
  return buf;
}

var Vue; // bind on install

var Store = function Store(options) {
  var this$1 = this;
  if (options === void 0) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins;if (plugins === void 0) plugins = [];
  var strict = options.strict;if (strict === void 0) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch(type, payload) {
    return dispatch.call(store, type, payload);
  };
  this.commit = function boundCommit(type, payload, options) {
    return commit.call(store, type, payload, options);
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) {
    return plugin(this$1);
  });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state;
};

prototypeAccessors$1.state.set = function (v) {
  if (false) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit(_type, _payload, _options) {
  var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
  var type = ref.type;
  var payload = ref.payload;
  var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error("[vuex] unknown mutation type: " + type);
    }
    return;
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator(handler) {
      handler(payload);
    });
  });

  this._subscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
  .forEach(function (sub) {
    return sub(mutation, this$1.state);
  });

  if (false) {
    console.warn("[vuex] mutation type: " + type + ". Silent option has been removed. " + 'Use the filter functionality in the vue-devtools');
  }
};

Store.prototype.dispatch = function dispatch(_type, _payload) {
  var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
  var type = ref.type;
  var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error("[vuex] unknown action type: " + type);
    }
    return;
  }

  try {
    this._actionSubscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .filter(function (sub) {
      return sub.before;
    }).forEach(function (sub) {
      return sub.before(action, this$1.state);
    });
  } catch (e) {
    if (false) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1 ? Promise.all(entry.map(function (handler) {
    return handler(payload);
  })) : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers.filter(function (sub) {
          return sub.after;
        }).forEach(function (sub) {
          return sub.after(action, this$1.state);
        });
      } catch (e) {
        if (false) {
          console.warn("[vuex] error in after action subscribers: ");
          console.error(e);
        }
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers.filter(function (sub) {
          return sub.error;
        }).forEach(function (sub) {
          return sub.error(action, this$1.state, error);
        });
      } catch (e) {
        if (false) {
          console.warn("[vuex] error in error action subscribers: ");
          console.error(e);
        }
      }
      reject(error);
    });
  });
};

Store.prototype.subscribe = function subscribe(fn, options) {
  return genericSubscribe(fn, this._subscribers, options);
};

Store.prototype.subscribeAction = function subscribeAction(fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options);
};

Store.prototype.watch = function watch(getter, cb, options) {
  var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () {
    return getter(this$1.state, this$1.getters);
  }, cb, options);
};

Store.prototype.replaceState = function replaceState(state) {
  var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule(path, rawModule, options) {
  if (options === void 0) options = {};

  if (typeof path === 'string') {
    path = [path];
  }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule(path) {
  var this$1 = this;

  if (typeof path === 'string') {
    path = [path];
  }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule(path) {
  if (typeof path === 'string') {
    path = [path];
  }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  return this._modules.isRegistered(path);
};

Store.prototype.hotUpdate = function hotUpdate(newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit(fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties(Store.prototype, prototypeAccessors$1);

function genericSubscribe(fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend ? subs.unshift(fn) : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  };
}

function resetStore(store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM(store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function get() {
        return store._vm[key];
      },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () {
      return oldVm.$destroy();
    });
  }
}

function installModule(store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && "production" !== 'production') {
      console.error("[vuex] duplicate namespace " + namespace + " for the namespaced module " + path.join('/'));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if (false) {
        if (moduleName in parentState) {
          console.warn("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + path.join('.') + "\"");
        }
      }
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext(store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error("[vuex] unknown local action type: " + args.type + ", global type: " + type);
          return;
        }
      }

      return store.dispatch(type, payload);
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error("[vuex] unknown local mutation type: " + args.type + ", global type: " + type);
          return;
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace ? function () {
        return store.getters;
      } : function () {
        return makeLocalGetters(store, namespace);
      }
    },
    state: {
      get: function get() {
        return getNestedState(store.state, path);
      }
    }
  });

  return local;
}

function makeLocalGetters(store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) {
        return;
      }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function get() {
          return store.getters[type];
        },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace];
}

function registerMutation(store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler(payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction(store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler(payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err;
      });
    } else {
      return res;
    }
  });
}

function registerGetter(store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error("[vuex] duplicate getter key: " + type);
    }
    return;
  }
  store._wrappedGetters[type] = function wrappedGetter(store) {
    return rawGetter(local.state, // local state
    local.getters, // local getters
    store.state, // root state
    store.getters // root getters
    );
  };
}

function enableStrictMode(store) {
  store._vm.$watch(function () {
    return this._data.$$state;
  }, function () {
    if (false) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState(state, path) {
  return path.reduce(function (state, key) {
    return state[key];
  }, state);
}

function unifyObjectStyle(type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', "expects string as the type, but found " + (typeof type === 'undefined' ? 'undefined' : _typeof(type)) + ".");
  }

  return { type: type, payload: payload, options: options };
}

function install(_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error('[vuex] already installed. Vue.use(Vuex) should be called only once.');
    }
    return;
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (false) {
    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState() {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return;
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function' ? val.call(this, state, getters) : state[val];
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res;
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (false) {
    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation() {
      var args = [],
          len = arguments.length;
      while (len--) {
        args[len] = arguments[len];
      } // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return;
        }
        commit = module.context.commit;
      }
      return typeof val === 'function' ? val.apply(this, [commit].concat(args)) : commit.apply(this.$store, [val].concat(args));
    };
  });
  return res;
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (false) {
    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter() {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return;
      }
      if (false) {
        console.error("[vuex] unknown getter: " + val);
        return;
      }
      return this.$store.getters[val];
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res;
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (false) {
    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction() {
      var args = [],
          len = arguments.length;
      while (len--) {
        args[len] = arguments[len];
      } // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return;
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function' ? val.apply(this, [dispatch].concat(args)) : dispatch.apply(this.$store, [val].concat(args));
    };
  });
  return res;
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function createNamespacedHelpers(namespace) {
  return {
    mapState: mapState.bind(null, namespace),
    mapGetters: mapGetters.bind(null, namespace),
    mapMutations: mapMutations.bind(null, namespace),
    mapActions: mapActions.bind(null, namespace)
  };
};

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap(map) {
  if (!isValidMap(map)) {
    return [];
  }
  return Array.isArray(map) ? map.map(function (key) {
    return { key: key, val: key };
  }) : Object.keys(map).map(function (key) {
    return { key: key, val: map[key] };
  });
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap(map) {
  return Array.isArray(map) || isObject(map);
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace(fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map);
  };
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace(store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error("[vuex] module namespace not found in " + helper + "(): " + namespace);
  }
  return module;
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger(ref) {
  if (ref === void 0) ref = {};
  var collapsed = ref.collapsed;if (collapsed === void 0) collapsed = true;
  var filter = ref.filter;if (filter === void 0) filter = function filter(mutation, stateBefore, stateAfter) {
    return true;
  };
  var transformer = ref.transformer;if (transformer === void 0) transformer = function transformer(state) {
    return state;
  };
  var mutationTransformer = ref.mutationTransformer;if (mutationTransformer === void 0) mutationTransformer = function mutationTransformer(mut) {
    return mut;
  };
  var actionFilter = ref.actionFilter;if (actionFilter === void 0) actionFilter = function actionFilter(action, state) {
    return true;
  };
  var actionTransformer = ref.actionTransformer;if (actionTransformer === void 0) actionTransformer = function actionTransformer(act) {
    return act;
  };
  var logMutations = ref.logMutations;if (logMutations === void 0) logMutations = true;
  var logActions = ref.logActions;if (logActions === void 0) logActions = true;
  var logger = ref.logger;if (logger === void 0) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return;
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + mutation.type + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + action.type + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  };
}

function startMessage(logger, message, collapsed) {
  var startMessage = collapsed ? logger.groupCollapsed : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage(logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime() {
  var time = new Date();
  return " @ " + pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
}

function repeat(str, times) {
  return new Array(times + 1).join(str);
}

function pad(num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num;
}

var index = {
  Store: Store,
  install: install,
  version: '3.6.2',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

exports.default = index;
exports.Store = Store;
exports.createLogger = createLogger;
exports.createNamespacedHelpers = createNamespacedHelpers;
exports.install = install;
exports.mapActions = mapActions;
exports.mapGetters = mapGetters;
exports.mapMutations = mapMutations;
exports.mapState = mapState;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(32);

function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(32);
var normalizeHeaderName = __webpack_require__(997);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(226);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(226);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(220)))

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(32);
var settle = __webpack_require__(998);
var buildURL = __webpack_require__(223);
var buildFullPath = __webpack_require__(1000);
var parseHeaders = __webpack_require__(1003);
var isURLSameOrigin = __webpack_require__(1004);
var createError = __webpack_require__(227);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(1005);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(999);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(32);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = ['baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath'];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys);

  var otherKeys = Object.keys(config2).filter(function filterAxiosKeys(key) {
    return axiosKeys.indexOf(key) === -1;
  });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadList_vue__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueBootstrapTypehead',

  components: {
    VueBootstrapTypeaheadList: __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadList_vue__["a" /* default */]
  },

  props: {
    size: {
      type: String,
      default: null,
      validator: function validator(size) {
        return ['lg', 'sm'].indexOf(size) > -1;
      }
    },
    value: {
      type: String
    },
    data: {
      type: Array,
      required: true,
      validator: function validator(d) {
        return d instanceof Array;
      }
    },
    serializer: {
      type: Function,
      default: function _default(d) {
        return d;
      },
      validator: function validator(d) {
        return d instanceof Function;
      }
    },
    backgroundVariant: String,
    textVariant: String,
    inputClass: {
      type: String,
      default: ''
    },
    maxMatches: {
      type: Number,
      default: 10
    },
    minMatchingChars: {
      type: Number,
      default: 2
    },
    placeholder: String,
    prepend: String,
    append: String
  },

  computed: {
    sizeClasses: function sizeClasses() {
      return this.size ? 'input-group input-group-' + this.size : 'input-group';
    },
    formattedData: function formattedData() {
      var _this = this;

      if (!(this.data instanceof Array)) {
        return [];
      }
      return this.data.map(function (d, i) {
        return {
          id: i,
          data: d,
          text: _this.serializer(d)
        };
      });
    }
  },

  methods: {
    resizeList: function resizeList(el) {
      var rect = el.getBoundingClientRect();
      var listStyle = this.$refs.list.$el.style;

      // Set the width of the list on resize
      listStyle.width = rect.width + 'px';

      // Set the margin when the prepend prop or slot is populated
      // (setting the "left" CSS property doesn't work)
      if (this.$refs.prependDiv) {
        var prependRect = this.$refs.prependDiv.getBoundingClientRect();
        listStyle.marginLeft = prependRect.width + 'px';
      }
    },
    handleHit: function handleHit(evt) {
      if (typeof this.value !== 'undefined') {
        this.$emit('input', evt.text);
      }

      this.inputValue = evt.text;
      this.$emit('hit', evt.data);
      this.$refs.input.blur();
      this.isFocused = false;
    },
    handleBlur: function handleBlur(evt) {
      var tgt = evt.relatedTarget;
      if (tgt && tgt.classList.contains('vbst-item')) {
        return;
      }
      this.isFocused = false;
    },
    handleInput: function handleInput(newValue) {
      this.inputValue = newValue;

      // If v-model is being used, emit an input event
      if (typeof this.value !== 'undefined') {
        this.$emit('input', newValue);
      }
    }
  },

  data: function data() {
    return {
      isFocused: false,
      inputValue: ''
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$_ro = new __WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill___default.a(function (e) {
      _this2.resizeList(_this2.$refs.input);
    });
    this.$_ro.observe(this.$refs.input);
    this.$_ro.observe(this.$refs.list.$el);
  },
  beforeDestroy: function beforeDestroy() {
    this.$_ro.disconnect();
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadListItem_vue__ = __webpack_require__(1016);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function sanitize(text) {
  return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueBootstrapTypeaheadList',

  components: {
    VueBootstrapTypeaheadListItem: __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadListItem_vue__["a" /* default */]
  },

  props: {
    data: {
      type: Array,
      required: true,
      validator: function validator(d) {
        return d instanceof Array;
      }
    },
    query: {
      type: String,
      default: ''
    },
    backgroundVariant: {
      type: String
    },
    textVariant: {
      type: String
    },
    maxMatches: {
      type: Number,
      default: 10
    },
    minMatchingChars: {
      type: Number,
      default: 2
    }
  },

  computed: {
    highlight: function highlight() {
      var _this = this;

      return function (text) {
        text = sanitize(text);
        if (_this.query.length === 0) {
          return text;
        }
        var re = new RegExp(_this.escapedQuery, 'gi');

        return text.replace(re, '<strong>$&</strong>');
      };
    },
    escapedQuery: function escapedQuery() {
      return escapeRegExp(sanitize(this.query));
    },
    matchedItems: function matchedItems() {
      if (this.query.length === 0 || this.query.length < this.minMatchingChars) {
        return [];
      }

      var re = new RegExp(this.escapedQuery, 'gi');

      // Filter, sort, and concat
      return this.data.filter(function (i) {
        return i.text.match(re) !== null;
      }).sort(function (a, b) {
        var aIndex = a.text.indexOf(a.text.match(re)[0]);
        var bIndex = b.text.indexOf(b.text.match(re)[0]);

        if (aIndex < bIndex) {
          return -1;
        }
        if (aIndex > bIndex) {
          return 1;
        }
        return 0;
      }).slice(0, this.maxMatches);
    }
  },

  methods: {
    handleHit: function handleHit(item, evt) {
      this.$emit('hit', item);
      evt.preventDefault();
    }
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueBootstrapTypeaheadListItem',

  props: {
    data: {},
    htmlText: {
      type: String
    },
    backgroundVariant: {
      type: String
    },
    textVariant: {
      type: String
    }
  },

  data: function data() {
    return {
      active: false
    };
  },


  computed: {
    textClasses: function textClasses() {
      var classes = '';
      classes += this.active ? 'active' : '';
      classes += this.backgroundVariant ? ' bg-' + this.backgroundVariant : '';
      classes += this.textVariant ? ' text-' + this.textVariant : '';
      return 'vbst-item list-group-item list-group-item-action ' + classes;
    }
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_top__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forms_app_guia__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_md_limite_plano_vue__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_alert_cert_vue__ = __webpack_require__(250);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",

  components: {
    BarTop: __WEBPACK_IMPORTED_MODULE_0__components_bar_top__["a" /* default */],
    AppGuia: __WEBPACK_IMPORTED_MODULE_1__forms_app_guia__["a" /* default */],
    mdLimitePlano: __WEBPACK_IMPORTED_MODULE_4__components_md_limite_plano_vue__["a" /* default */],
    AlertCert: __WEBPACK_IMPORTED_MODULE_5__components_alert_cert_vue__["a" /* default */]
  },

  data: function data() {
    var _ref;

    return _ref = {
      action: "",
      titleMessage: "",
      message: "",
      kindMessage: "error",
      auth: {},
      showApp: false
    }, _defineProperty(_ref, "auth", null), _defineProperty(_ref, "login", false), _ref;
  },


  computed: {
    showAlertCert: function showAlertCert() {
      if (this.$route.name != 'home' && this.$route.name != 'guianfe' && this.$route.name != 'painelvarejo' && this.$route.name != 'guiapedidos') return false;

      if (!this.appForcaVendas && this.certificado) return true;else return false;
    },
    certificado: function certificado() {
      return [].concat(_toConsumableArray(this.$store.getters.getSessao.certificado));
    },
    appShowMessage: function appShowMessage() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appShowMessage;
    },
    appTitleMessage: function appTitleMessage() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appTitleMessage;
    },
    appKindMessage: function appKindMessage() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].kindMessage;
    },
    appMessage: function appMessage() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appMessage;
    },
    appLoading: function appLoading() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appLoading;
    },
    serverError: function serverError() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].serverError;
    },
    toastWarning: function toastWarning() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].toastWarning;
    },
    toastSuccess: function toastSuccess() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].toastSuccess;
    },
    toastError: function toastError() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].toastError;
    },
    appLogged: function appLogged() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appLogged;
    },
    appForcaVendas: function appForcaVendas() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appForcaVendas;
    },
    appVarejo: function appVarejo() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appVarejo;
    },
    appNFe: function appNFe() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appNFe;
    },
    appERP: function appERP() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appERP;
    },
    appEndTrial: function appEndTrial() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appEndTrial;
    },
    appBlocked: function appBlocked() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appBlocked;
    },
    appAvisoRenovacao: function appAvisoRenovacao() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appAvisoRenovacao;
    },
    appTrial: function appTrial() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appTrial;
    },
    appFree: function appFree() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appFree;
    },
    showAmbienteHomologacao: function showAmbienteHomologacao() {
      return (this.appNFe || this.appERP) && __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].ambienteHomologacaoNFe && (this.$route.name == "nflist" || this.$route.name == "nfsaida");
    },
    showLimitePlano: function showLimitePlano() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].showLimitePlano;
    },
    appDataExpiracao: function appDataExpiracao() {
      return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appDataExpiracao;
    },
    metadata: function metadata() {
      return this.$store.getters.getEntities;
    },


    perfilUsuarioPadrao: function perfilUsuarioPadrao() {
      return this.$store.getters.getSessao.perfil == "3";
    },

    appLogin: function appLogin() {
      if (this.$route.name == "login" || this.login) return true;else return false;
    },

    classContainer: function classContainer() {
      if (__WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appForcaVendas) {
        return "";
      } else {
        // return "container-min-width"
        return "";
      }
    }
  },

  methods: {
    crmCounters: function crmCounters() {
      return;

      if (!this.appLogged) return;

      Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDS"])(this.$store.getters.urlOrds + "crm/email/count", null, true).then(function (result) {
        if (result.items.length > 0) __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].countEmail = result.items[0].email;else __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].countEmail = null;
      });

      Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDS"])(this.$store.getters.urlOrds + "crm/agenda/count", null, true).then(function (result) {
        if (result.items.length > 0) __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].countAgenda = result.items[0].agenda;else __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].countAgenda = null;
      });

      var vm = this;
      setTimeout(function () {
        vm.crmCounters();
      }, 60000);
    },
    getAction: function getAction(action) {
      //executa a acao dos botoes do menu
      this.action = action;
      if (action == "register") {
        this.showRegisterForm();
      }
    },
    handleCloseMessage: function handleCloseMessage() {
      __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appShowMessage = false;
      __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appTitleMessage = null;
      __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appMessage = null;
    },
    handleCloseError: function handleCloseError() {
      //fecha tela de erro ao clicar em OK
      __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appError = false;
      __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].serverError = false;
    },
    handleLogout: function handleLogout() {
      //efetua o logout, zerando os dados de autenticacao e direciona para a pagina de login
      this.$store.dispatch("logout");
      __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appLogged = false;
      __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].primeiroAcesso = true;
      this.login = true;
      this.$router.push({ path: "/login", query: this.$route.query });
    },
    handleRenovar: function handleRenovar() {
      this.$router.push("/minhaconta");
    },
    closeForm: function closeForm() {
      this.action = "";
    },
    showRegisterForm: function showRegisterForm() {
      this.showRegister = true;
    },
    loadEnvironment: function loadEnvironment() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var urlParams, redirectTo, _urlParams, _redirectTo, cleanUrl;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // ENTRA AQUI PELO WATCH DAS VARIAVEIS SYSVARS.APPBLOCKED, SYSVARS.APPENDTRIAL, SYSVARS.APPLOGGED
                setTimeout(function () {
                  if (Tawk_API) {
                    if (typeof Tawk_API.showWidget === "function") {
                      Tawk_API.showWidget();
                    }
                  }
                }, 1000);

                if (!_this.loadingEnvironment) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:

                _this.loadingEnvironment = true;

                if (!_this.auth) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return _this.$store.dispatch("loadEnv", _this.auth);

              case 7:
                _context.next = 10;
                break;

              case 9:
                _this.auth = JSON.parse(window.sessionStorage.getItem("authObj"));

              case 10:
                _context.next = 12;
                return _this.$store.dispatch("loadSessao", _this);

              case 12:
                _context.next = 14;
                return _this.$store.dispatch("loadMetadata");

              case 14:
                _context.next = 16;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSapp"])(_this, "sessao/meuplano/", "get", null).then(function (result) {
                  if (result) __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].plano = result;else __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].plano = { plano_atual: {}, historico: [] };
                });

              case 16:

                __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].usuarioComum = _this.$store.getters.getSessao.perfil > 1;
                __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].usuarioForcaVendas = _this.$store.getters.getSessao.perfil == 3; //neste caso exibe o menu força de vendas
                __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].usuarioVarejoPDV = _this.$store.getters.getSessao.perfil == 5; //neste caso exibe o menu força de vendas
                __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].usuarioAdministrador = _this.$store.getters.getSessao.perfil == 0 || _this.$store.getters.getSessao.perfil == 1;
                __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].hasRepresentation = _this.$store.getters.getSessao.possui_usu_representante == "S";
                __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].loja_b2b = _this.$store.getters.getSessao.loja_b2b == "S";
                __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].guia = _this.$store.getters.getSessao.showguia == "S";
                __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].usaIntegracao = _this.$store.getters.getSessao.integracao == "S";

                __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appTrial = _this.auth.login.istrial;
                __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appDataExpiracao = _this.auth.login.dataexpiracao;
                __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appAvisoRenovacao = _this.auth.login.avisorenovacao;
                // SysVars.appPlanoContratado = this.auth.login.planocontratado
                if (_this.auth.login.apps.length) {
                  __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appVarejo = _this.auth.login.apps.indexOf("VAREJO") >= 0;
                  __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appLoja = _this.auth.login.apps.indexOf("LOJA") >= 0;
                  __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appForcaVendas = _this.auth.login.apps.indexOf("FV") >= 0 || _this.auth.login.apps.indexOf("LOJA") >= 0;
                  __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appNFe = _this.auth.login.apps.indexOf("NFE") >= 0;
                  __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appERP = _this.auth.login.apps.toString().includes("ERP");
                }
                __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appFree = _this.auth.login.isfree;

                if (_this.auth.login.isblocked) __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appBlocked = true;else if (_this.auth.login.isendtrial) __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appEndTrial = true;

                __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].forceUrl = null;
                __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].urlBlocked = null;

                if (__WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appNFe || __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appERP) {
                  __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appLogged = true;
                  _this.login = false;
                  if (__WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appEndTrial || __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appBlocked) {

                    if (__WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].plano && __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].plano.plano_atual && (__WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].plano.plano_atual.controle_app == 'ERP2' || __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].plano.plano_atual.controle_app == 'ERP3' || __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].plano.plano_atual.controle_app == 'ERP4')) {
                      __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].forceUrl = '/minhaconta';
                      __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].urlBlocked = '/minhaconta';
                      _this.$router.push('/planos/erp');
                    } else {
                      __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].forceUrl = '/minhaconta';
                      __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].urlBlocked = '/minhaconta';
                      _this.$router.push('/minhaconta');
                    }
                  } else {
                    if (_this.$route.path == "/login" || _this.$route.path == "/registronfe" || _this.$route.path == "/registroloja") {
                      //AO DAR F5 NA PAGINA, DEVE CONTINUAR NA MESMA
                      urlParams = new URLSearchParams(window.location.search);
                      redirectTo = urlParams.get('redirect_to') || _this.$route.query.redirect_to;

                      if (redirectTo) {
                        _this.$router.push(redirectTo);
                      } else {
                        _this.$router.push("/");
                      }
                    }
                  }
                }

                if (!__WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appNFe && !__WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appERP) {
                  if (__WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appEndTrial || __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appBlocked) {
                    __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].urlBlocked = "/assinar";
                    __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].forceUrl = "/assinar";
                    _this.$router.push("/assinar");
                  } else {
                    _this.login = false;
                    __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appLogged = true;
                    if (__WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appLoja && __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].guia) _this.$router.push("/guialoja");else {
                      if (_this.$route.path == "/login") {
                        //AO DAR F5 NA PAGINA, DEVE CONTINUAR NA MESMA
                        _urlParams = new URLSearchParams(window.location.search);
                        _redirectTo = _urlParams.get('redirect_to') || _this.$route.query.redirect_to;

                        if (_redirectTo) {
                          _this.$router.push(_redirectTo);
                        } else {
                          _this.$router.push("/");
                        }
                      }
                    }
                  }
                }

                //exibe a aplicação quando terminar de carregar o ambiente e o METADATA
                if (_this.metadata) {
                  _this.showApp = true;
                } else {
                  _this.showApp = false;
                }
                //

                if (window.location.search.includes("redirect_to")) {
                  cleanUrl = new URL(window.location.href);

                  cleanUrl.searchParams.delete("redirect_to");
                  window.history.replaceState({}, "", cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
                }

                _this.loadingEnvironment = false;

                _this.auth = null;

                _this.$scrollTo(0);

                _this.crmCounters();

                Tawk_API.visitor = {
                  name: _this.$store.getters.getSessao.nome,
                  email: _this.$store.getters.getSessao.email
                };
                Tawk_API.onLoad = function () {
                  Tawk_API.setAttributes({
                    name: this.$store.getters.getSessao.nome,
                    email: this.$store.getters.getSessao.email
                  }, function (error) {});
                };

              case 42:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  watch: {
    metadata: function metadata(value) {},

    $route: function $route() {
      this.$nextTick(function () {
        jQuery(".tooltip").remove();
      });
    },


    serverError: function serverError(value) {
      if (__WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].serverErrorStatus == 0) {
        this.message = "Erro: " + __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].serverErrorText;
      } else {
        this.message = "Erro na requisição ao servidor: (" + __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].serverErrorStatus + ") " + __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].serverErrorText;
      }
    },

    //watch para controle de notificações
    toastWarning: function toastWarning(value) {
      if (this.toastWarning != "") {
        this.$snotify.warning(this.toastWarning);
        __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].toastWarning = "";
      }
    },

    toastSuccess: function toastSuccess(value) {
      if (this.toastSuccess != "") {
        this.$snotify.success(this.toastSuccess);
        __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].toastSuccess = "";
      }
    },

    toastError: function toastError(value) {
      if (this.toastError != "") {
        this.$snotify.error(this.toastError);
        __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].toastError = "";
      }
    },

    appLogged: function appLogged(value) {
      //exibe a pagina principal ao efetuar login
      if (value) {
        if (this.$route.path == "/registronfe" || this.$route.path == "/registroloja" || this.$route.path == "/contador/empresas") {
          this.loadEnvironment();
        } else if (this.$route.path != "/login") {
          this.$router.push({
            path: this.$route.path,
            query: this.$route.query
          });
        } else {
          this.loadEnvironment();
        }
      } else {
        this.$router.push({ path: "/login", query: this.$route.query });
      }
    },

    appEndTrial: function appEndTrial(value) {
      if (value) {
        this.loadEnvironment();
      }
    },

    appBlocked: function appBlocked(value) {
      if (value) {
        this.loadEnvironment();
      }
    }
  },

  created: function created() {
    this.showApp = false;

    __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].appForcaVendas = true;

    if (this.$route.name == "registro") {
      this.showApp = true;
      this.$router.push({ path: "/registro", query: this.$route.query });
      return;
    }
    if (this.$route.name == "registropedidos") {
      this.showApp = true;
      this.$router.push("/registropedidos");
      return;
    }
    if (this.$route.name == "registronfe") {
      this.showApp = true;
      this.$router.push({ path: "/registronfe", query: this.$route.query });
      return;
    }
    if (this.$route.name == "registroloja") {
      this.showApp = true;
      this.$router.push("/registroloja");
      return;
    }
    if (this.$route.name == "recuperar") {
      this.showApp = true;
      this.$router.push("/recuperar");
      return;
    }

    if (this.$route.name == "ativar") {
      this.showApp = true;
      this.$router.push({ path: "ativar", query: this.$route.query });
      return;
    }

    if (this.$route.name == "senha") {
      this.showApp = true;
      this.$router.push({ path: "senha", query: this.$route.query });
      return;
    }

    if (this.$route.name == "imprimir-pedido") {
      this.showApp = true;
      this.$router.push({ path: "imprimir-pedido", query: this.$route.query });
      return;
    }

    if (this.$route.name == "login") {
      this.$router.push({ path: "/login", query: this.$route.query });
      return;
    }

    //verifica se já está autenticado ao carregar a pagina (em case de F5)
    var urlParams = new URLSearchParams(window.location.search);
    var queryObj = {};
    urlParams.forEach(function (value, key) {
      queryObj[key] = value;
    });

    var hasAutologin = urlParams.has('token_autologin');
    if (hasAutologin) {
      window.sessionStorage.removeItem("authObj");
      this.auth = null;
    } else {
      this.auth = JSON.parse(window.sessionStorage.getItem("authObj"));
    }

    if (!this.auth || !this.auth.auth) {
      this.login = true;
      this.$router.push({ path: "/login", query: queryObj });
    } else {
      this.loadEnvironment();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // app.js

    window.addEventListener("desativar-guia", _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.$apiGuiaUsuarioDesativar();

            case 2:
              _this2.$erpToastSuccess("Guia desativado com sucesso.");

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    })));

    jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
      icons: {
        time: "fa fa-clock",
        date: "fa fa-calendar",
        up: "fa fa-arrow-up",
        down: "fa fa-arrow-down",
        previous: "fa fa-chevron-left",
        next: "fa fa-chevron-right",
        today: "fa fa-calendar-check",
        clear: "fa fa-trash",
        close: "fa fa-times-circle"
      }
    });
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_socket_io_client__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notification_history_vue__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_config_guia_vue__ = __webpack_require__(244);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    NotificationHistory: __WEBPACK_IMPORTED_MODULE_4__notification_history_vue__["a" /* default */],
    ConfigGuia: __WEBPACK_IMPORTED_MODULE_5__forms_config_guia_vue__["default"]
  },
  data: function data() {
    return {
      currVideo: null,
      unreadNotification: 0,
      notification: null,
      offset: false,
      viewMobileMenu: false,
      showNotificationHistory: false,
      backToNotificationHistoryModal: false,
      configGuide: false,
      isGuide: false
    };
  },


  computed: {
    showConsultasAntigas: function showConsultasAntigas() {
      if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].plano && __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].plano.plano_atual && __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].plano.plano_atual.controle_app) {
        var appStr = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].plano.plano_atual.controle_app;
        if (appStr.startsWith('ERP')) {
          var num = parseInt(appStr.replace('ERP', ''), 10);
          if (!isNaN(num) && num >= 4) {
            return false;
          }
        }
      }
      return true;
    },
    nextPage: function nextPage() {
      return this.$store.getters.getNextPage;
    },

    notificationsList: function notificationsList() {
      var notifications = [];
      if (!this.$store.getters.getNotificationsList || !this.$store.getters.getNotificationsList.length) return notifications;

      var notifications_status_0 = this.$store.getters.getNotificationsList.filter(function (e) {
        return e.status_usuario == "0";
      });

      notifications_status_0.forEach(function (e) {
        notifications.push(e);
      });
      return notifications;
    },
    notificationMsg: function notificationMsg() {
      var strLineBreak = this.notification.mensagem.replace(/\\n/g, "\n");
      return strLineBreak;
    },
    administrador: function administrador() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador;
    },
    usuarioForcavendas: function usuarioForcavendas() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioForcaVendas;
    },
    company: function company() {
      return this.$store.getters.getEnv.empresacod;
    },
    uuid: function uuid() {
      return this.$store.getters.getEnv.uuid;
    },
    usuarionome: function usuarionome() {
      return this.$store.getters.getEnv.usuarionome;
    },
    empresanome: function empresanome() {
      return this.$store.getters.getEnv.empresanome;
    },
    empresacod: function empresacod() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["zeroPad"])(this.$store.getters.getEnv.empresacod, 6);
    },
    email: function email() {
      return this.$store.getters.getEnv.email;
    },
    istrial: function istrial() {
      return this.$store.getters.getSessao.istrial == "S";
    },
    appNFe: function appNFe() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appNFe;
    },
    appERP: function appERP() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appERP;
    },
    appForcaVendas: function appForcaVendas() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appForcaVendas;
    },
    isAdmin: function isAdmin() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador;
    },
    hasRep: function hasRep() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].hasRepresentation;
    },
    isRep: function isRep() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioForcaVendas;
    },
    isUserVarejoPDV: function isUserVarejoPDV() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioVarejoPDV;
    },

    menu: function menu() {
      if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioForcaVendas) return "menuforcavendas";else if (this.isUserVarejoPDV) return "menuvarejopdv";else if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appNFe) return "menucompleto";else if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appVarejo) return "menucompleto";else if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appERP && __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioForcaVendas || __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appForcaVendas) return "menuforcavendas";else if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appERP) return "menucompleto";
    },
    appLoja: function appLoja() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appLoja;
    },
    app: function app() {
      if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appNFe) return "nfe";else if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appForcaVendas) return "forcaVendas";else if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appVarejo) return "varejo";else if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appERP) return "erp";
    },
    url_router: function url_router() {
      return this.$route.name;
    },

    helpList: function helpList() {
      var _this = this;

      var list = this.$store.getters.getHelpList;
      return list.filter(function (obj) {
        return !obj.app || obj.app.indexOf(_this.app) > -1 && obj.route == _this.url_router;
      });
    },
    agendaCounter: function agendaCounter() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].countAgenda;
    },
    emailCounter: function emailCounter() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].countEmail;
    },
    classDesktopMobile: function classDesktopMobile() {
      return "navbar-desktop";
      if (this.appForcaVendas) {
        return "navbar-desktop";
      } else {
        return "navbar-desktop navbar-mobile";
      }
    },
    planoConsultasComercial: function planoConsultasComercial() {
      var isValid = Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiRecursoLiberado"])(this, "consultascomercial");
      return isValid;
    },
    planoConsultasEstoque: function planoConsultasEstoque() {
      var isValid = Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiRecursoLiberado"])(this, "consultasestoque");
      return isValid;
    },
    planoConsultasFinanceiro: function planoConsultasFinanceiro() {
      var isValid = Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiRecursoLiberado"])(this, "consultasfinanceiro");
      return isValid;
    }
  },

  methods: {
    handleCancelNotification: function handleCancelNotification(not) {
      this.notification = not;
      this.handleConfirmNotification();
    },
    handleShowNotificationHistory: function handleShowNotificationHistory() {
      this.showNotificationHistory = true;
    },
    handleCloseNotification: function handleCloseNotification() {
      this.notification = null;

      if (this.backToNotificationHistoryModal) {
        this.showNotificationHistory = true;
        this.backToNotificationHistoryModal = false;
      }
    },
    handleShowViewNotification: function handleShowViewNotification(value) {
      this.notification = value;
      this.showNotificationHistory = false;
      this.backToNotificationHistoryModal = true;
    },
    handleCloseNotificationHistory: function handleCloseNotificationHistory() {
      this.showNotificationHistory = false;
    },
    loadNotifications: function loadNotifications(next) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (next) {
                  _this2.offset = next;
                }

                params = {};

                if (_this2.offset) {
                  params.offset = _this2.nextPage;
                }

                _context.next = 5;
                return _this2.$store.dispatch("loadNotificationsList", params);

              case 5:
                _this2.offset = false;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    clickAction: function clickAction(action) {
      this.$emit("action", action);
    },
    menuLiberado: function menuLiberado(recurso) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiMenuLiberado"])(this, recurso);
    },
    handleManual: function handleManual() {
      window.open("https://s3.amazonaws.com/htdti/Gestor/NBManual.pdf", "_blank");
    },
    handleCentral: function handleCentral() {
      window.open("http://notabrasil.com.br/suporte/", "_blank");
    },
    handleLogout: function handleLogout() {
      this.$emit("logout");
    },
    handleAssinar: function handleAssinar() {
      this.$router.push("/assinar");
    },
    handleGuia: function handleGuia() {
      if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appLoja) this.$router.push("/guialoja");else if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appNFe) this.$router.push("/guianfe");else if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appForcaVendas) this.$router.push("/guiapedidos");else this.$router.push("/");
    },
    handleShowVideo: function handleShowVideo(index) {
      this.currVideo = this.helpList[index].url;
    },
    iconNotifications: function iconNotifications(notification) {
      if (notification.status_usuario == "0") return "fa-envelope";
      if (notification.status_usuario == "1") return "fa-envelope-open";
    },
    handleNotifications: function handleNotifications(notification) {
      this.notification = notification;
    },
    handleConfirmNotification: function handleConfirmNotification() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.notification.status_usuario = "1";
                modulo = "cg/notifications/";
                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this3.$store, modulo, _this3.notification, "post");

              case 4:
                data = _context2.sent;

                if (!data.resultado) {
                  _context2.next = 8;
                  break;
                }

                _this3.$erpToastError("Falha ao confirmar Mensagem!");
                return _context2.abrupt("return");

              case 8:

                _this3.notification = null;

                _context2.next = 11;
                return _this3.loadNotifications();

              case 11:
                _this3.unreadNotification--;

                if (_this3.unreadNotification < 0) {
                  _this3.unreadNotification = 0;
                }

                if (_this3.backToNotificationHistoryModal) {
                  _this3.showNotificationHistory = true;
                  _this3.backToNotificationHistoryModal = false;
                }

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    toggleMenu: function toggleMenu() {
      this.viewMobileMenu = !this.viewMobileMenu;
    },
    handleAccordion: function handleAccordion() {
      var _this4 = this;

      var acc = document.getElementsByClassName("accordion");

      var _loop = function _loop(i) {
        acc[i].addEventListener("click", function (event) {
          _this4.closeAccordions(i);

          acc[i].classList.toggle("active");

          var panel = acc[i].nextElementSibling;

          if (panel.style.maxHeight === "0px") {
            panel.style.maxHeight = "500px";
          } else {
            panel.style.maxHeight = "0px";
          }

          var icon = acc[i].getElementsByClassName("fa");

          if (icon[0].classList.contains("fa-plus")) {
            icon[0].classList.remove("fa-plus");
            icon[0].classList.add("fa-minus");
            return;
          }

          if (icon[0].classList.contains("fa-minus")) {
            icon[0].classList.remove("fa-minus");
            icon[0].classList.add("fa-plus");
            return;
          }
        });
      };

      for (var i = 0; i < acc.length; i++) {
        _loop(i);
      }
    },
    closeAccordions: function closeAccordions(index) {
      var acc = document.getElementsByClassName("accordion");

      for (var i = 0; i < acc.length; i++) {
        if (i != index) {
          var panel = acc[i].nextElementSibling;

          if (panel && panel.style.maxHeight === "500px") {
            panel.style.maxHeight = "0px";
          }

          var icon = acc[i].getElementsByClassName("fa");

          if (icon[0].classList.contains("fa-minus")) {
            icon[0].classList.remove("fa-minus");
            icon[0].classList.add("fa-plus");
          }
        }
      }
    },
    handleMenuLink: function handleMenuLink() {
      var _this5 = this;

      var link = document.getElementsByClassName("menu-link");

      for (var i = 0; i < link.length; i++) {
        link[i].addEventListener("click", function (event) {
          _this5.viewMobileMenu = false;
          _this5.closeAccordions();
        });
      }
    },
    loadFilial: function loadFilial() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDS"])(_this6.$store.getters.urlOrds + "cg/filial/varejo", null, true).then(function (result) {
                  if (result.items.length > 0) {
                    _this6.filial = result.items[0];
                    // this.loadLogoTipo();
                  }
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    handleConfigModal: function handleConfigModal() {
      this.configGuide = !this.configGuide;
    }
  },

  created: function created() {
    var self = this;

    // console.log(this.$store.getters.urlNotifications)
    // //const socket = io("http://ec2-52-202-145-226.compute-1.amazonaws.com:3232", {
    // const socket = io(this.$store.getters.urlNotifications, {
    //     extraHeaders: {
    //         "company": self.company,
    //         "uuid": self.uuid
    //       }
    //   });

    // socket.on("connect", () => {
    //   console.log(socket.id); // x8WIv7-mJelg7on_ALbx

    // });

    // socket.on('notifications', (data) => {
    //   self.unreadNotification = data.qtd
    //   self.loadNotifications();
    // });

    // socket.on("disconnect", () => {
    //   console.log(socket.id); // undefined
    // });
  },
  mounted: function mounted() {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var self;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              self = _this7;


              self.loadNotifications().then(function () {
                var notification = self.notificationsList.find(function (notification) {
                  return notification.status === "1" && notification.status_usuario === "0";
                });
                if (notification) self.notification = notification;
              });

              _context4.next = 4;
              return _this7.loadFilial();

            case 4:

              _this7.handleAccordion();
              _this7.handleMenuLink();

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this7);
    }))();
  }
});

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isBinary = isBinary;
exports.hasBinary = hasBinary;
var withNativeArrayBuffer = typeof ArrayBuffer === "function";
var isView = function isView(obj) {
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
var toString = Object.prototype.toString;
var withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && toString.call(Blob) === "[object BlobConstructor]";
var withNativeFile = typeof File === "function" || typeof File !== "undefined" && toString.call(File) === "[object FileConstructor]";
/**
 * Returns true if obj is a Buffer, an ArrayBuffer, a Blob or a File.
 *
 * @private
 */
function isBinary(obj) {
    return withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)) || withNativeBlob && obj instanceof Blob || withNativeFile && obj instanceof File;
}
function hasBinary(obj, toJSON) {
    if (!obj || (typeof obj === "undefined" ? "undefined" : _typeof(obj)) !== "object") {
        return false;
    }
    if (Array.isArray(obj)) {
        for (var i = 0, l = obj.length; i < l; i++) {
            if (hasBinary(obj[i])) {
                return true;
            }
        }
        return false;
    }
    if (isBinary(obj)) {
        return true;
    }
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) {
        return hasBinary(obj.toJSON(), true);
    }
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
            return true;
        }
    }
    return false;
}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.transports = undefined;

var _pollingXhrNode = __webpack_require__(159);

var _websocketNode = __webpack_require__(161);

var _webtransport = __webpack_require__(239);

var transports = exports.transports = {
    websocket: _websocketNode.WS,
    webtransport: _webtransport.WT,
    polling: _pollingXhrNode.XHR
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Polling = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _transport = __webpack_require__(115);

var _util = __webpack_require__(75);

var _engine = __webpack_require__(86);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Polling = exports.Polling = function (_Transport) {
    _inherits(Polling, _Transport);

    function Polling() {
        _classCallCheck(this, Polling);

        var _this = _possibleConstructorReturn(this, (Polling.__proto__ || Object.getPrototypeOf(Polling)).apply(this, arguments));

        _this._polling = false;
        return _this;
    }

    _createClass(Polling, [{
        key: "doOpen",

        /**
         * Opens the socket (triggers polling). We write a PING message to determine
         * when the transport is open.
         *
         * @protected
         */
        value: function doOpen() {
            this._poll();
        }
        /**
         * Pauses polling.
         *
         * @param {Function} onPause - callback upon buffers are flushed and transport is paused
         * @package
         */

    }, {
        key: "pause",
        value: function pause(onPause) {
            var _this2 = this;

            this.readyState = "pausing";
            var pause = function pause() {
                _this2.readyState = "paused";
                onPause();
            };
            if (this._polling || !this.writable) {
                var total = 0;
                if (this._polling) {
                    total++;
                    this.once("pollComplete", function () {
                        --total || pause();
                    });
                }
                if (!this.writable) {
                    total++;
                    this.once("drain", function () {
                        --total || pause();
                    });
                }
            } else {
                pause();
            }
        }
        /**
         * Starts polling cycle.
         *
         * @private
         */

    }, {
        key: "_poll",
        value: function _poll() {
            this._polling = true;
            this.doPoll();
            this.emitReserved("poll");
        }
        /**
         * Overloads onData to detect payloads.
         *
         * @protected
         */

    }, {
        key: "onData",
        value: function onData(data) {
            var _this3 = this;

            var callback = function callback(packet) {
                // if its the first message we consider the transport open
                if ("opening" === _this3.readyState && packet.type === "open") {
                    _this3.onOpen();
                }
                // if its a close packet, we close the ongoing requests
                if ("close" === packet.type) {
                    _this3.onClose({ description: "transport closed by the server" });
                    return false;
                }
                // otherwise bypass onData and handle the message
                _this3.onPacket(packet);
            };
            // decode payload
            (0, _engine.decodePayload)(data, this.socket.binaryType).forEach(callback);
            // if an event did not trigger closing
            if ("closed" !== this.readyState) {
                // if we got data we're not polling
                this._polling = false;
                this.emitReserved("pollComplete");
                if ("open" === this.readyState) {
                    this._poll();
                } else {}
            }
        }
        /**
         * For polling, send a close packet.
         *
         * @protected
         */

    }, {
        key: "doClose",
        value: function doClose() {
            var _this4 = this;

            var close = function close() {
                _this4.write([{ type: "close" }]);
            };
            if ("open" === this.readyState) {
                close();
            } else {
                // in case we're trying to close while
                // handshaking is in progress (GH-164)
                this.once("open", close);
            }
        }
        /**
         * Writes a packets payload.
         *
         * @param {Array} packets - data packets
         * @protected
         */

    }, {
        key: "write",
        value: function write(packets) {
            var _this5 = this;

            this.writable = false;
            (0, _engine.encodePayload)(packets, function (data) {
                _this5.doWrite(data, function () {
                    _this5.writable = true;
                    _this5.emitReserved("drain");
                });
            });
        }
        /**
         * Generates uri for connection.
         *
         * @private
         */

    }, {
        key: "uri",
        value: function uri() {
            var schema = this.opts.secure ? "https" : "http";
            var query = this.query || {};
            // cache busting is forced
            if (false !== this.opts.timestampRequests) {
                query[this.opts.timestampParam] = (0, _util.randomString)();
            }
            if (!this.supportsBinary && !query.sid) {
                query.b64 = 1;
            }
            return this.createUri(schema, query);
        }
    }, {
        key: "name",
        get: function get() {
            return "polling";
        }
    }]);

    return Polling;
}(_transport.Transport);

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.encode = encode;
exports.decode = decode;
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */
function encode(obj) {
    var str = '';
    for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
            if (str.length) str += '&';
            str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
        }
    }
    return str;
}
/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */
function decode(qs) {
    var qry = {};
    var pairs = qs.split('&');
    for (var i = 0, l = pairs.length; i < l; i++) {
        var pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WT = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _transport = __webpack_require__(115);

var _globalsNode = __webpack_require__(76);

var _engine = __webpack_require__(86);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * WebTransport transport based on the built-in `WebTransport` object.
 *
 * Usage: browser, Node.js (with the `@fails-components/webtransport` package)
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/WebTransport
 * @see https://caniuse.com/webtransport
 */
var WT = exports.WT = function (_Transport) {
    _inherits(WT, _Transport);

    function WT() {
        _classCallCheck(this, WT);

        return _possibleConstructorReturn(this, (WT.__proto__ || Object.getPrototypeOf(WT)).apply(this, arguments));
    }

    _createClass(WT, [{
        key: "doOpen",
        value: function doOpen() {
            var _this2 = this;

            try {
                // @ts-ignore
                this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
            } catch (err) {
                return this.emitReserved("error", err);
            }
            this._transport.closed.then(function () {
                _this2.onClose();
            }).catch(function (err) {
                _this2.onError("webtransport error", err);
            });
            // note: we could have used async/await, but that would require some additional polyfills
            this._transport.ready.then(function () {
                _this2._transport.createBidirectionalStream().then(function (stream) {
                    var decoderStream = (0, _engine.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, _this2.socket.binaryType);
                    var reader = stream.readable.pipeThrough(decoderStream).getReader();
                    var encoderStream = (0, _engine.createPacketEncoderStream)();
                    encoderStream.readable.pipeTo(stream.writable);
                    _this2._writer = encoderStream.writable.getWriter();
                    var read = function read() {
                        reader.read().then(function (_ref) {
                            var done = _ref.done,
                                value = _ref.value;

                            if (done) {
                                return;
                            }
                            _this2.onPacket(value);
                            read();
                        }).catch(function (err) {});
                    };
                    read();
                    var packet = { type: "open" };
                    if (_this2.query.sid) {
                        packet.data = "{\"sid\":\"" + _this2.query.sid + "\"}";
                    }
                    _this2._writer.write(packet).then(function () {
                        return _this2.onOpen();
                    });
                });
            });
        }
    }, {
        key: "write",
        value: function write(packets) {
            var _this3 = this;

            this.writable = false;

            var _loop = function _loop(i) {
                var packet = packets[i];
                var lastPacket = i === packets.length - 1;
                _this3._writer.write(packet).then(function () {
                    if (lastPacket) {
                        (0, _globalsNode.nextTick)(function () {
                            _this3.writable = true;
                            _this3.emitReserved("drain");
                        }, _this3.setTimeoutFn);
                    }
                });
            };

            for (var i = 0; i < packets.length; i++) {
                _loop(i);
            }
        }
    }, {
        key: "doClose",
        value: function doClose() {
            var _a;
            (_a = this._transport) === null || _a === void 0 ? void 0 : _a.close();
        }
    }, {
        key: "name",
        get: function get() {
            return "webtransport";
        }
    }]);

    return WT;
}(_transport.Transport);

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parse = parse;
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */
var re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
var parts = ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'];
function parse(str) {
    if (str.length > 8000) {
        throw "URI too long";
    }
    var src = str,
        b = str.indexOf('['),
        e = str.indexOf(']');
    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }
    var m = re.exec(str || ''),
        uri = {},
        i = 14;
    while (i--) {
        uri[parts[i]] = m[i] || '';
    }
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = pathNames(uri, uri['path']);
    uri.queryKey = queryKey(uri, uri['query']);
    return uri;
}
function pathNames(obj, path) {
    var regx = /\/{2,9}/g,
        names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) {
        names.splice(0, 1);
    }
    if (path.slice(-1) == '/') {
        names.splice(names.length - 1, 1);
    }
    return names;
}
function queryKey(uri, query) {
    var data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function ($0, $1, $2) {
        if ($1) {
            data[$1] = $2;
        }
    });
    return data;
}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Socket = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _socket = __webpack_require__(157);

var _on = __webpack_require__(242);

var _componentEmitter = __webpack_require__(74);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Internal events.
 * These events can't be emitted by the user.
 */
var RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
/**
 * A Socket is the fundamental class for interacting with the server.
 *
 * A Socket belongs to a certain Namespace (by default /) and uses an underlying {@link Manager} to communicate.
 *
 * @example
 * const socket = io();
 *
 * socket.on("connect", () => {
 *   console.log("connected");
 * });
 *
 * // send an event to the server
 * socket.emit("foo", "bar");
 *
 * socket.on("foobar", () => {
 *   // an event was received from the server
 * });
 *
 * // upon disconnection
 * socket.on("disconnect", (reason) => {
 *   console.log(`disconnected due to ${reason}`);
 * });
 */

var Socket = function (_Emitter) {
    _inherits(Socket, _Emitter);

    /**
     * `Socket` constructor.
     */
    function Socket(io, nsp, opts) {
        _classCallCheck(this, Socket);

        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */
        var _this = _possibleConstructorReturn(this, (Socket.__proto__ || Object.getPrototypeOf(Socket)).call(this));

        _this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */
        _this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */
        _this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */
        _this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */
        _this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */
        _this._queueSeq = 0;
        _this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */
        _this.acks = {};
        _this.flags = {};
        _this.io = io;
        _this.nsp = nsp;
        if (opts && opts.auth) {
            _this.auth = opts.auth;
        }
        _this._opts = Object.assign({}, opts);
        if (_this.io._autoConnect) _this.open();
        return _this;
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */


    _createClass(Socket, [{
        key: "subEvents",

        /**
         * Subscribe to open, close and packet events
         *
         * @private
         */
        value: function subEvents() {
            if (this.subs) return;
            var io = this.io;
            this.subs = [(0, _on.on)(io, "open", this.onopen.bind(this)), (0, _on.on)(io, "packet", this.onpacket.bind(this)), (0, _on.on)(io, "error", this.onerror.bind(this)), (0, _on.on)(io, "close", this.onclose.bind(this))];
        }
        /**
         * Whether the Socket will try to reconnect when its Manager connects or reconnects.
         *
         * @example
         * const socket = io();
         *
         * console.log(socket.active); // true
         *
         * socket.on("disconnect", (reason) => {
         *   if (reason === "io server disconnect") {
         *     // the disconnection was initiated by the server, you need to manually reconnect
         *     console.log(socket.active); // false
         *   }
         *   // else the socket will automatically try to reconnect
         *   console.log(socket.active); // true
         * });
         */

    }, {
        key: "connect",

        /**
         * "Opens" the socket.
         *
         * @example
         * const socket = io({
         *   autoConnect: false
         * });
         *
         * socket.connect();
         */
        value: function connect() {
            if (this.connected) return this;
            this.subEvents();
            if (!this.io["_reconnecting"]) this.io.open(); // ensure open
            if ("open" === this.io._readyState) this.onopen();
            return this;
        }
        /**
         * Alias for {@link connect()}.
         */

    }, {
        key: "open",
        value: function open() {
            return this.connect();
        }
        /**
         * Sends a `message` event.
         *
         * This method mimics the WebSocket.send() method.
         *
         * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
         *
         * @example
         * socket.send("hello");
         *
         * // this is equivalent to
         * socket.emit("message", "hello");
         *
         * @return self
         */

    }, {
        key: "send",
        value: function send() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            args.unshift("message");
            this.emit.apply(this, args);
            return this;
        }
        /**
         * Override `emit`.
         * If the event is in `events`, it's emitted normally.
         *
         * @example
         * socket.emit("hello", "world");
         *
         * // all serializable datastructures are supported (no need to call JSON.stringify)
         * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
         *
         * // with an acknowledgement from the server
         * socket.emit("hello", "world", (val) => {
         *   // ...
         * });
         *
         * @return self
         */

    }, {
        key: "emit",
        value: function emit(ev) {
            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                args[_key2 - 1] = arguments[_key2];
            }

            var _a, _b, _c;
            if (RESERVED_EVENTS.hasOwnProperty(ev)) {
                throw new Error('"' + ev.toString() + '" is a reserved event name');
            }
            args.unshift(ev);
            if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
                this._addToQueue(args);
                return this;
            }
            var packet = {
                type: _socket.PacketType.EVENT,
                data: args
            };
            packet.options = {};
            packet.options.compress = this.flags.compress !== false;
            // event ack callback
            if ("function" === typeof args[args.length - 1]) {
                var id = this.ids++;
                var ack = args.pop();
                this._registerAckCallback(id, ack);
                packet.id = id;
            }
            var isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
            var isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
            var discardPacket = this.flags.volatile && !isTransportWritable;
            if (discardPacket) {} else if (isConnected) {
                this.notifyOutgoingListeners(packet);
                this.packet(packet);
            } else {
                this.sendBuffer.push(packet);
            }
            this.flags = {};
            return this;
        }
        /**
         * @private
         */

    }, {
        key: "_registerAckCallback",
        value: function _registerAckCallback(id, ack) {
            var _this2 = this;

            var _a;
            var timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
            if (timeout === undefined) {
                this.acks[id] = ack;
                return;
            }
            // @ts-ignore
            var timer = this.io.setTimeoutFn(function () {
                delete _this2.acks[id];
                for (var i = 0; i < _this2.sendBuffer.length; i++) {
                    if (_this2.sendBuffer[i].id === id) {
                        _this2.sendBuffer.splice(i, 1);
                    }
                }
                ack.call(_this2, new Error("operation has timed out"));
            }, timeout);
            var fn = function fn() {
                for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    args[_key3] = arguments[_key3];
                }

                // @ts-ignore
                _this2.io.clearTimeoutFn(timer);
                ack.apply(_this2, args);
            };
            fn.withError = true;
            this.acks[id] = fn;
        }
        /**
         * Emits an event and waits for an acknowledgement
         *
         * @example
         * // without timeout
         * const response = await socket.emitWithAck("hello", "world");
         *
         * // with a specific timeout
         * try {
         *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
         * } catch (err) {
         *   // the server did not acknowledge the event in the given delay
         * }
         *
         * @return a Promise that will be fulfilled when the server acknowledges the event
         */

    }, {
        key: "emitWithAck",
        value: function emitWithAck(ev) {
            var _this3 = this;

            for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                args[_key4 - 1] = arguments[_key4];
            }

            return new Promise(function (resolve, reject) {
                var fn = function fn(arg1, arg2) {
                    return arg1 ? reject(arg1) : resolve(arg2);
                };
                fn.withError = true;
                args.push(fn);
                _this3.emit.apply(_this3, [ev].concat(args));
            });
        }
        /**
         * Add the packet to the queue.
         * @param args
         * @private
         */

    }, {
        key: "_addToQueue",
        value: function _addToQueue(args) {
            var _this4 = this;

            var ack = void 0;
            if (typeof args[args.length - 1] === "function") {
                ack = args.pop();
            }
            var packet = {
                id: this._queueSeq++,
                tryCount: 0,
                pending: false,
                args: args,
                flags: Object.assign({ fromQueue: true }, this.flags)
            };
            args.push(function (err) {
                for (var _len5 = arguments.length, responseArgs = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
                    responseArgs[_key5 - 1] = arguments[_key5];
                }

                if (packet !== _this4._queue[0]) {
                    // the packet has already been acknowledged
                    return;
                }
                var hasError = err !== null;
                if (hasError) {
                    if (packet.tryCount > _this4._opts.retries) {
                        _this4._queue.shift();
                        if (ack) {
                            ack(err);
                        }
                    }
                } else {
                    _this4._queue.shift();
                    if (ack) {
                        ack.apply(undefined, [null].concat(responseArgs));
                    }
                }
                packet.pending = false;
                return _this4._drainQueue();
            });
            this._queue.push(packet);
            this._drainQueue();
        }
        /**
         * Send the first packet of the queue, and wait for an acknowledgement from the server.
         * @param force - whether to resend a packet that has not been acknowledged yet
         *
         * @private
         */

    }, {
        key: "_drainQueue",
        value: function _drainQueue() {
            var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!this.connected || this._queue.length === 0) {
                return;
            }
            var packet = this._queue[0];
            if (packet.pending && !force) {
                return;
            }
            packet.pending = true;
            packet.tryCount++;
            this.flags = packet.flags;
            this.emit.apply(this, packet.args);
        }
        /**
         * Sends a packet.
         *
         * @param packet
         * @private
         */

    }, {
        key: "packet",
        value: function packet(_packet) {
            _packet.nsp = this.nsp;
            this.io._packet(_packet);
        }
        /**
         * Called upon engine `open`.
         *
         * @private
         */

    }, {
        key: "onopen",
        value: function onopen() {
            var _this5 = this;

            if (typeof this.auth == "function") {
                this.auth(function (data) {
                    _this5._sendConnectPacket(data);
                });
            } else {
                this._sendConnectPacket(this.auth);
            }
        }
        /**
         * Sends a CONNECT packet to initiate the Socket.IO session.
         *
         * @param data
         * @private
         */

    }, {
        key: "_sendConnectPacket",
        value: function _sendConnectPacket(data) {
            this.packet({
                type: _socket.PacketType.CONNECT,
                data: this._pid ? Object.assign({ pid: this._pid, offset: this._lastOffset }, data) : data
            });
        }
        /**
         * Called upon engine or manager `error`.
         *
         * @param err
         * @private
         */

    }, {
        key: "onerror",
        value: function onerror(err) {
            if (!this.connected) {
                this.emitReserved("connect_error", err);
            }
        }
        /**
         * Called upon engine `close`.
         *
         * @param reason
         * @param description
         * @private
         */

    }, {
        key: "onclose",
        value: function onclose(reason, description) {
            this.connected = false;
            delete this.id;
            this.emitReserved("disconnect", reason, description);
            this._clearAcks();
        }
        /**
         * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
         * the server.
         *
         * @private
         */

    }, {
        key: "_clearAcks",
        value: function _clearAcks() {
            var _this6 = this;

            Object.keys(this.acks).forEach(function (id) {
                var isBuffered = _this6.sendBuffer.some(function (packet) {
                    return String(packet.id) === id;
                });
                if (!isBuffered) {
                    // note: handlers that do not accept an error as first argument are ignored here
                    var ack = _this6.acks[id];
                    delete _this6.acks[id];
                    if (ack.withError) {
                        ack.call(_this6, new Error("socket has been disconnected"));
                    }
                }
            });
        }
        /**
         * Called with socket packet.
         *
         * @param packet
         * @private
         */

    }, {
        key: "onpacket",
        value: function onpacket(packet) {
            var sameNamespace = packet.nsp === this.nsp;
            if (!sameNamespace) return;
            switch (packet.type) {
                case _socket.PacketType.CONNECT:
                    if (packet.data && packet.data.sid) {
                        this.onconnect(packet.data.sid, packet.data.pid);
                    } else {
                        this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                    }
                    break;
                case _socket.PacketType.EVENT:
                case _socket.PacketType.BINARY_EVENT:
                    this.onevent(packet);
                    break;
                case _socket.PacketType.ACK:
                case _socket.PacketType.BINARY_ACK:
                    this.onack(packet);
                    break;
                case _socket.PacketType.DISCONNECT:
                    this.ondisconnect();
                    break;
                case _socket.PacketType.CONNECT_ERROR:
                    this.destroy();
                    var err = new Error(packet.data.message);
                    // @ts-ignore
                    err.data = packet.data.data;
                    this.emitReserved("connect_error", err);
                    break;
            }
        }
        /**
         * Called upon a server event.
         *
         * @param packet
         * @private
         */

    }, {
        key: "onevent",
        value: function onevent(packet) {
            var args = packet.data || [];
            if (null != packet.id) {
                args.push(this.ack(packet.id));
            }
            if (this.connected) {
                this.emitEvent(args);
            } else {
                this.receiveBuffer.push(Object.freeze(args));
            }
        }
    }, {
        key: "emitEvent",
        value: function emitEvent(args) {
            if (this._anyListeners && this._anyListeners.length) {
                var listeners = this._anyListeners.slice();
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var listener = _step.value;

                        listener.apply(this, args);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            _get(Socket.prototype.__proto__ || Object.getPrototypeOf(Socket.prototype), "emit", this).apply(this, args);
            if (this._pid && args.length && typeof args[args.length - 1] === "string") {
                this._lastOffset = args[args.length - 1];
            }
        }
        /**
         * Produces an ack callback to emit with an event.
         *
         * @private
         */

    }, {
        key: "ack",
        value: function ack(id) {
            var self = this;
            var sent = false;
            return function () {
                for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                    args[_key6] = arguments[_key6];
                }

                // prevent double callbacks
                if (sent) return;
                sent = true;
                self.packet({
                    type: _socket.PacketType.ACK,
                    id: id,
                    data: args
                });
            };
        }
        /**
         * Called upon a server acknowledgement.
         *
         * @param packet
         * @private
         */

    }, {
        key: "onack",
        value: function onack(packet) {
            var ack = this.acks[packet.id];
            if (typeof ack !== "function") {
                return;
            }
            delete this.acks[packet.id];
            // @ts-ignore FIXME ack is incorrectly inferred as 'never'
            if (ack.withError) {
                packet.data.unshift(null);
            }
            // @ts-ignore
            ack.apply(this, packet.data);
        }
        /**
         * Called upon server connect.
         *
         * @private
         */

    }, {
        key: "onconnect",
        value: function onconnect(id, pid) {
            this.id = id;
            this.recovered = pid && this._pid === pid;
            this._pid = pid; // defined only if connection state recovery is enabled
            this.connected = true;
            this.emitBuffered();
            this.emitReserved("connect");
            this._drainQueue(true);
        }
        /**
         * Emit buffered events (received and emitted).
         *
         * @private
         */

    }, {
        key: "emitBuffered",
        value: function emitBuffered() {
            var _this7 = this;

            this.receiveBuffer.forEach(function (args) {
                return _this7.emitEvent(args);
            });
            this.receiveBuffer = [];
            this.sendBuffer.forEach(function (packet) {
                _this7.notifyOutgoingListeners(packet);
                _this7.packet(packet);
            });
            this.sendBuffer = [];
        }
        /**
         * Called upon server disconnect.
         *
         * @private
         */

    }, {
        key: "ondisconnect",
        value: function ondisconnect() {
            this.destroy();
            this.onclose("io server disconnect");
        }
        /**
         * Called upon forced client/server side disconnections,
         * this method ensures the manager stops tracking us and
         * that reconnections don't get triggered for this.
         *
         * @private
         */

    }, {
        key: "destroy",
        value: function destroy() {
            if (this.subs) {
                // clean subscriptions to avoid reconnections
                this.subs.forEach(function (subDestroy) {
                    return subDestroy();
                });
                this.subs = undefined;
            }
            this.io["_destroy"](this);
        }
        /**
         * Disconnects the socket manually. In that case, the socket will not try to reconnect.
         *
         * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
         *
         * @example
         * const socket = io();
         *
         * socket.on("disconnect", (reason) => {
         *   // console.log(reason); prints "io client disconnect"
         * });
         *
         * socket.disconnect();
         *
         * @return self
         */

    }, {
        key: "disconnect",
        value: function disconnect() {
            if (this.connected) {
                this.packet({ type: _socket.PacketType.DISCONNECT });
            }
            // remove socket from pool
            this.destroy();
            if (this.connected) {
                // fire events
                this.onclose("io client disconnect");
            }
            return this;
        }
        /**
         * Alias for {@link disconnect()}.
         *
         * @return self
         */

    }, {
        key: "close",
        value: function close() {
            return this.disconnect();
        }
        /**
         * Sets the compress flag.
         *
         * @example
         * socket.compress(false).emit("hello");
         *
         * @param compress - if `true`, compresses the sending data
         * @return self
         */

    }, {
        key: "compress",
        value: function compress(_compress) {
            this.flags.compress = _compress;
            return this;
        }
        /**
         * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
         * ready to send messages.
         *
         * @example
         * socket.volatile.emit("hello"); // the server may or may not receive it
         *
         * @returns self
         */

    }, {
        key: "timeout",

        /**
         * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
         * given number of milliseconds have elapsed without an acknowledgement from the server:
         *
         * @example
         * socket.timeout(5000).emit("my-event", (err) => {
         *   if (err) {
         *     // the server did not acknowledge the event in the given delay
         *   }
         * });
         *
         * @returns self
         */
        value: function timeout(_timeout) {
            this.flags.timeout = _timeout;
            return this;
        }
        /**
         * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
         * callback.
         *
         * @example
         * socket.onAny((event, ...args) => {
         *   console.log(`got ${event}`);
         * });
         *
         * @param listener
         */

    }, {
        key: "onAny",
        value: function onAny(listener) {
            this._anyListeners = this._anyListeners || [];
            this._anyListeners.push(listener);
            return this;
        }
        /**
         * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
         * callback. The listener is added to the beginning of the listeners array.
         *
         * @example
         * socket.prependAny((event, ...args) => {
         *   console.log(`got event ${event}`);
         * });
         *
         * @param listener
         */

    }, {
        key: "prependAny",
        value: function prependAny(listener) {
            this._anyListeners = this._anyListeners || [];
            this._anyListeners.unshift(listener);
            return this;
        }
        /**
         * Removes the listener that will be fired when any event is emitted.
         *
         * @example
         * const catchAllListener = (event, ...args) => {
         *   console.log(`got event ${event}`);
         * }
         *
         * socket.onAny(catchAllListener);
         *
         * // remove a specific listener
         * socket.offAny(catchAllListener);
         *
         * // or remove all listeners
         * socket.offAny();
         *
         * @param listener
         */

    }, {
        key: "offAny",
        value: function offAny(listener) {
            if (!this._anyListeners) {
                return this;
            }
            if (listener) {
                var listeners = this._anyListeners;
                for (var i = 0; i < listeners.length; i++) {
                    if (listener === listeners[i]) {
                        listeners.splice(i, 1);
                        return this;
                    }
                }
            } else {
                this._anyListeners = [];
            }
            return this;
        }
        /**
         * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
         * e.g. to remove listeners.
         */

    }, {
        key: "listenersAny",
        value: function listenersAny() {
            return this._anyListeners || [];
        }
        /**
         * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
         * callback.
         *
         * Note: acknowledgements sent to the server are not included.
         *
         * @example
         * socket.onAnyOutgoing((event, ...args) => {
         *   console.log(`sent event ${event}`);
         * });
         *
         * @param listener
         */

    }, {
        key: "onAnyOutgoing",
        value: function onAnyOutgoing(listener) {
            this._anyOutgoingListeners = this._anyOutgoingListeners || [];
            this._anyOutgoingListeners.push(listener);
            return this;
        }
        /**
         * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
         * callback. The listener is added to the beginning of the listeners array.
         *
         * Note: acknowledgements sent to the server are not included.
         *
         * @example
         * socket.prependAnyOutgoing((event, ...args) => {
         *   console.log(`sent event ${event}`);
         * });
         *
         * @param listener
         */

    }, {
        key: "prependAnyOutgoing",
        value: function prependAnyOutgoing(listener) {
            this._anyOutgoingListeners = this._anyOutgoingListeners || [];
            this._anyOutgoingListeners.unshift(listener);
            return this;
        }
        /**
         * Removes the listener that will be fired when any event is emitted.
         *
         * @example
         * const catchAllListener = (event, ...args) => {
         *   console.log(`sent event ${event}`);
         * }
         *
         * socket.onAnyOutgoing(catchAllListener);
         *
         * // remove a specific listener
         * socket.offAnyOutgoing(catchAllListener);
         *
         * // or remove all listeners
         * socket.offAnyOutgoing();
         *
         * @param [listener] - the catch-all listener (optional)
         */

    }, {
        key: "offAnyOutgoing",
        value: function offAnyOutgoing(listener) {
            if (!this._anyOutgoingListeners) {
                return this;
            }
            if (listener) {
                var listeners = this._anyOutgoingListeners;
                for (var i = 0; i < listeners.length; i++) {
                    if (listener === listeners[i]) {
                        listeners.splice(i, 1);
                        return this;
                    }
                }
            } else {
                this._anyOutgoingListeners = [];
            }
            return this;
        }
        /**
         * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
         * e.g. to remove listeners.
         */

    }, {
        key: "listenersAnyOutgoing",
        value: function listenersAnyOutgoing() {
            return this._anyOutgoingListeners || [];
        }
        /**
         * Notify the listeners for each packet sent
         *
         * @param packet
         *
         * @private
         */

    }, {
        key: "notifyOutgoingListeners",
        value: function notifyOutgoingListeners(packet) {
            if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
                var listeners = this._anyOutgoingListeners.slice();
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = listeners[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var listener = _step2.value;

                        listener.apply(this, packet.data);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        }
    }, {
        key: "disconnected",
        get: function get() {
            return !this.connected;
        }
    }, {
        key: "active",
        get: function get() {
            return !!this.subs;
        }
    }, {
        key: "volatile",
        get: function get() {
            this.flags.volatile = true;
            return this;
        }
    }]);

    return Socket;
}(_componentEmitter.Emitter);

exports.Socket = Socket;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.on = on;
function on(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        notificationList: function notificationList() {
            var notifications = [];

            if (!this.$store.getters.getNotificationsList || !this.$store.getters.getNotificationsList.length) return notifications;

            var notifications_status_1 = this.$store.getters.getNotificationsList.filter(function (e) {
                return e.status_usuario == '1';
            });

            notifications_status_1.forEach(function (e) {
                notifications.push(e);
            });

            return notifications;
        }
    },
    methods: {
        handleDeleteNotification: function handleDeleteNotification(not) {
            not.status = 0;
            this.$emit('cancel', not);
        },
        handleViewNotification: function handleViewNotification(not) {
            this.$emit('view', not);
        },
        loadNotifications: function loadNotifications(next) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (next) {
                                    _this.offset = next;
                                }

                                params = {};

                                if (_this.offset) {
                                    params.offset = _this.nextPage;
                                }

                                _context.next = 5;
                                return _this.$store.dispatch('loadNotificationsList', params);

                            case 5:
                                _this.offset = false;

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    created: function created() {
        this.loadNotifications();
    }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_guia_vue__ = __webpack_require__(245);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_717f7bb3_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_guia_vue__ = __webpack_require__(1070);
function injectStyle (ssrContext) {
  __webpack_require__(1044)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_guia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_717f7bb3_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_guia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forms_filial_form__ = __webpack_require__(87);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilialForm: __WEBPACK_IMPORTED_MODULE_0__forms_filial_form__["default"]
  },
  props: {},
  data: function data() {
    return {
      guide: true,
      localStep: 0,
      lastStep: false,
      guideType: "NFE",
      steps: ["1", "2", "3", "4"]
    };
  },

  methods: {
    changeToNextEl: function changeToNextEl() {
      this.$nextTick(function () {
        this.$refs.qtdConfirmButton.focus();
      });
    },
    closeModal: function closeModal() {
      this.$router.go(-1);
    },
    tryNextStep: function tryNextStep() {
      if (this.$refs.filialFormRef.tabCertificado) this.nextStep();else if (this.$refs.filialFormRef.tabDados) this.$refs.filialFormRef.handleSave();else this.$refs.filialFormRef.handleSave(true);
    },
    nextStep: function nextStep() {
      if (this.$refs.filialFormRef.activeTab === this.$refs.filialFormRef.tabLength - 1) return;
      this.$refs.filialFormRef.activeTab += 1;
      this.localStep = this.$refs.filialFormRef.activeTab;
      if (this.$refs.filialFormRef.activeTab === this.$refs.filialFormRef.tabLength - 1) {
        this.lastStep = true;
      }
      // console.log(this.$refs.filialFormRef.filteredTabs);
    },
    backStep: function backStep() {
      this.lastStep = false;
      this.$refs.filialFormRef.activeTab -= 1;
      this.localStep = this.$refs.filialFormRef.activeTab;
    },
    handleSave: function handleSave() {
      this.$refs.filialFormRef.handleSave();
      this.closeModal();
    }
  },
  computed: {
    canGoBack: function canGoBack() {
      return this.localStep >= 1;
    }
  },

  created: function created() {
    if (this.$route.params.param == "pdv") {
      this.guideType = "PDV";
      this.steps = ["1", "2", "3"];
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_nfse__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_nfse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_nfse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_etiqueta_vue__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_certificado__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tourguidejs__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tourguidejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_tourguidejs__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: "",
    crud: "",
    list: "",
    guide: Boolean,
    type: ""
  },

  data: function data() {
    return {
      tabs: [
      // {title: 'Dados Gerais', icon:'fa-building'},
      // {title: 'Pedido', icon:'fa-shopping-basket'},
      // {title: 'NF-e e NFC-e', icon:'fa-file-invoice-dollar'},
      // {title: 'Frente de Caixa', icon:'fa-cash-register'},
      // {title: 'Integração Ecommerce', icon:'fa-at'}
      { title: "Dados Gerais", icon: "" }, { title: "NF-e e NFC-e", icon: "" }, { title: "Certificado Digital", icon: "" }, { title: "Pedidos de Venda", icon: "" }, { title: "Frente de Caixa", icon: "" }, { title: "Financeiro", icon: "" }, { title: "Ecommerce", icon: "" }, { title: "Siscomex / Duimp", icon: "" }, { title: "Etiquetas", icon: "" }],
      crudText: "",
      codfil: null,
      filial: _extends({}, this.$store.getters.getEntities.filial),
      listSubstitutos: [],
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
      estadoList: [],
      tipo_ie: "COM_IE",
      tipo_ie_options: [{ id: "COM_IE", text: "Possui Inscrição Estadual" }, { id: "ISENTO", text: "Empresa Isenta de Inscrição Estadual" }, { id: "SEM_IE", text: "Contribuinte Exclusivo IBS/CBS (Sem Inscrição Estadual)" }],
      activeTab: 0,

      disableRetorno: false,
      showMarketplaces: false,
      showPagOnline: false,
      showIntFF: false,
      showSAT: false,
      showPDV: false,
      showModalEtiqueta: false,
      showFormCert: false, //exibe a tela de manutencao do certificado

      nfse_login: false,
      nfse_senha: false,
      nfse_token: false,
      nfse_certificado: false,

      ML_APP_ID: "1536197050949661",
      ML_SECRET_KEY: "THWeVgitHbvAH0iIZqMJkpZA10gPbyaS",

      parametros: {
        controlaestoque: false,
        venda_sem_estoque: false,
        venda_sem_credito: true,
        agrupar_itens_pedido: false,
        rentabilidade_minima: null,
        exibir_estoque_integracao: false,
        marketplaces: {
          b2w: {
            userlogin: null,
            apikey: null,
            accountmanagerkey: null
          },
          mercadolivre: {
            code: null,
            accesstoken: null,
            refreshtoken: null,
            userid: null
          }
        },
        pagonline: _defineProperty({
          cielo: {
            clientid: null,
            clientsecret: null
          }
        }, "cielo", {
          token: null,
          pv: null
        }),
        sat: {
          signAC: null,
          codigoDeAtivacao: null,
          nomeDLL: null,
          arqLOG: null,
          visualizarImp: null,
          emulador: null
        },
        parcelas: {
          formapag: null
        },
        etiquetas: [],
        pedido: {
          observacao_garantia: null
        },
        nfse: {
          login: null,
          senha: null,
          token: null,
          nfseNacional: null
        }
      },

      image: null,
      selectedFile: "",
      etiqueta: null,
      listEtiquetas: [],
      etiquetaTipoOptions: [{ id: "P", text: "Produto" }],
      bodyContent: null,

      steps: [{
        selector: "",
        step: 1,
        title: "Vamos come\xE7ar!",
        content: "Vamos te guiar passo a passo por todo o processo de cadastro da empresa.</br></br><a href='javascript:void(0)' class='btn btn-sm btn-danger text-white' onclick='window.dispatchEvent(new CustomEvent(\"desativar-guia\"))'>Não mostrar este guia</a>"
        // "image": "https://somehost.com/image.jpeg"
      }, {
        selector: "#cnpj",
        step: 2,
        title: "Cnpj",
        content: "Informe o CNPJ da empresa."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        selector: "#nome",
        step: 3,
        title: "Nome",
        content: "Informe o Nome/Razão Social da empresa."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        selector: "#fantasia",
        step: 4,
        title: "Fantasia",
        content: "Informe o Nome Fantasia da empresa."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        selector: "#isento",
        step: 5,
        title: "Isento de Inscri\xE7\xE3o Estadual?",
        content: "Informe se a empresa é isenta de inscrição estadual."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        selector: "#crt",
        step: 6,
        title: "Regime Tribut\xE1rio",
        content: "Informe o Regime Tributário da empresa."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        selector: "#cep",
        step: 7,
        title: "CEP do Endere\xE7o",
        content: "Informe o CEP do endereço da empresa."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        selector: "#endenr",
        step: 8,
        title: "Numero do Endere\xE7o",
        content: "Informe o Nr. do endereço da empresa."
        // "image": "https://somehost.com/image.jpeg"
      }]
    };
  },


  computed: {
    showPreencherCadastro: function showPreencherCadastro() {
      return this.filial.cnpj && this.filial.cnpj.length == 14;
    },
    typeNfe: function typeNfe() {
      return type === "NFE" && guide === true;
    },
    typePDV: function typePDV() {
      return type === "PDV" && guide === true;
    },
    typePedido: function typePedido() {
      return type === "PEDIDO";
    },
    filteredTabs: function filteredTabs() {
      if (!this.guide) {
        return this.tabs;
      }

      if (this.type === "NFE") {
        return [{ title: "Dados Gerais", icon: "" }, { title: "NF-e e NFC-e", icon: "" }, { title: "Certificado Digital", icon: "" }];
      }

      if (this.type === "PDV") {
        return [
        // { title: "Dados Gerais", icon: "" },
        { title: "Frente de Caixa", icon: "" }, { title: "NF-e e NFC-e", icon: "" }, { title: "Certificado Digital", icon: "" }];
      }

      if (this.type === "PEDIDO") {
        return [{ title: "Dados Gerais", icon: "" }, { title: "Pedidos de Venda", icon: "" }];
      }

      return this.tabs;
    },
    tabLength: function tabLength() {
      return this.filteredTabs.length;
    },
    tabCertificado: function tabCertificado() {
      return this.getTabIndex("Certificado Digital") === this.activeTab;
    },
    tabDados: function tabDados() {
      return this.getTabIndex("Dados Gerais") === this.activeTab;
    },
    tabPed: function tabPed() {
      return this.getTabIndex("Pedidos de Venda") === this.activeTab;
    },
    tabNf: function tabNf() {
      return this.getTabIndex("NF-e e NFC-e") === this.activeTab;
    },
    tabFrente: function tabFrente() {
      return this.getTabIndex("Frente de Caixa") === this.activeTab;
    },
    tabEcommerce: function tabEcommerce() {
      return this.getTabIndex("Ecommerce") === this.activeTab;
    },
    tabDuimp: function tabDuimp() {
      return this.getTabIndex("Siscomex / Duimp") === this.activeTab;
    },
    tabEtiqueta: function tabEtiqueta() {
      return this.getTabIndex("Etiquetas") === this.activeTab;
    },
    tabFinanceiro: function tabFinanceiro() {
      return this.getTabIndex("Financeiro") === this.activeTab;
    },

    tokenEmpresa: function tokenEmpresa() {
      return this.$store.getters.getSessao.empresa;
    },
    appForcaVendas: function appForcaVendas() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appForcaVendas;
    },
    appNFe: function appNFe() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appNFe;
    },
    titleForm: function titleForm() {
      return "Dados da Empresa";
    },
    activeTabTitle: function activeTabTitle() {
      return this.filteredTabs && this.filteredTabs.length > this.activeTab ? this.filteredTabs[this.activeTab].title : "";
    },


    tipo_controle_cm_ms_options: function tipo_controle_cm_ms_options() {
      var options = [];

      options.push({ id: "CM", text: "Comanda" });
      options.push({ id: "MS", text: "Mesa" });
      options.push({ id: "MC", text: "Mesa e Comanda" });

      return options;
    },
    focus_btn_pag_options: function focus_btn_pag_options() {
      var options = [];

      options.push({ id: "CP", text: "Imprimir Cupom" });
      options.push({ id: "ES", text: "Emitir SAT" });
      options.push({ id: "NC", text: "Emitir NFC-e" });
      options.push({ id: "NF", text: "Emitir NF" });
      options.push({ id: "FV", text: "Finalizar Venda" });

      return options;
    },
    pdv_ir_para_emissao_nf_options: function pdv_ir_para_emissao_nf_options() {
      var options = [];

      options.push({ id: "NF", text: "Ir Para Tela de Emissão de Notas" });
      options.push({ id: "NV", text: "Ir Para Nova Venda" });

      return options;
    },
    nao_sim_options: function nao_sim_options() {
      //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
      var options = [];

      options.push({ id: "N", text: "Não" });
      options.push({ id: "S", text: "Sim" });

      return options;
    },

    pdv_tipo_desc_acre_options: function pdv_tipo_desc_acre_options() {
      //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
      var options = [];

      options.push({ id: "V", text: "Valor" });
      options.push({ id: "P", text: "Porcentagem" });
      options.push({ id: "A", text: "Ambos" });

      return options;
    },

    tabelas_preco_options: function tabelas_preco_options() {
      //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
      var options = [];

      var liberado = [];
      var currTabpre = {};

      for (var x = 0; x < this.$store.getters.getTabpreList.length; x++) {
        currTabpre = this.$store.getters.getTabpreList[x];

        //se existir parametros do usuario, libera somente as tabelas permitidas
        if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) {
          liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter(function (obj) {
            return obj == currTabpre.codtabpre;
          });
          if (liberado.length > 0) {
            options.push({
              id: currTabpre.codtabpre,
              text: currTabpre.descricao
            });
          }
        } else {
          options.push({
            id: currTabpre.codtabpre,
            text: currTabpre.descricao
          });
        }
      }
      return options;
    },

    pdv_balanca_peso_valor_options: function pdv_balanca_peso_valor_options() {
      //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
      var options = [];

      options.push({ id: "P", text: "Peso" });
      options.push({ id: "V", text: "Valor" });

      return options;
    },

    pdv_qtd_casas_valor_options: function pdv_qtd_casas_valor_options() {
      //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
      var options = [];

      options.push({ id: 2, text: "2" });
      options.push({ id: 3, text: "3" });
      options.push({ id: 4, text: "4" });

      return options;
    },

    siscomex_env_options: function siscomex_env_options() {
      var options = [];
      options.push({ id: "H", text: "Homologação" });
      options.push({ id: "P", text: "Produção" });
      return options;
    },

    showGuia: function showGuia() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].guia;
    }
  },

  methods: {
    handlePreencherCadastro: function handlePreencherCadastro() {
      if (!this.filial.cnpj) {
        this.$erpToastError("Preencha o CNPJ");
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiConsultaCadastro"])(this, this.filial.cnpj, this.filial.uf, this.updateDadosCadastrais);
    },
    updateDadosCadastrais: function updateDadosCadastrais(dados) {
      this.filial.nome = (dados.nome || '').substr(0, 100);
      this.filial.fantasia = (dados.fantasia || dados.nome || '').substr(0, 100);
      this.filial.cnae = dados.cnae;
      this.filial.iest = dados.ie;
      this.filial.cep = dados.cep;
      this.filial.ende = (dados.endereco || '').substr(0, 100);
      this.filial.endenr = dados.nr;
      this.filial.endecomp = dados.complemento;
      this.filial.uf = dados.uf;
      this.filial.mun = dados.mun;
      this.filial.codmun = dados.cMun;
      this.filial.bairro = dados.bairro;
    },
    getTabIndex: function getTabIndex(title) {
      return this.filteredTabs.findIndex(function (tab) {
        return tab.title === title;
      });
    },
    closeFormCertificado: function closeFormCertificado() {
      this.showFormCert = false;
      this.$scrollTo(0);
      this.loadData();
    },
    handleGuiaInstalacaoCertificado: function handleGuiaInstalacaoCertificado() {
      //EXIBE O GUIA DE INSTALACAO DO CERTIFICADO DIGITAL
      this.showFormCert = true;
    },
    handleAdicionarMesa: function handleAdicionarMesa() {
      //adiciona nova linha na lista de mesa
      this.parametros.pdv.listMesas.push({});
    },
    handleDeleteMesa: function handleDeleteMesa(index) {
      this.parametros.pdv.listMesas.splice(index, 1);
    },
    handleCloseModal: function handleCloseModal() {
      var _this = this;

      //Cancela alterações do modal
      this.$refs.etiqueta.items_backup.map(function (e, i) {
        _this.$refs.etiqueta.items[i] = _extends({}, _this.$refs.etiqueta.items_backup[i]);
      });
      this.showModalEtiqueta = false;
    },
    changeTab: function changeTab(idx) {
      this.activeTab = idx;
    },
    responseTokenMercadoLivre: function responseTokenMercadoLivre(data) {
      this.parametros.marketplaces.mercadolivre.accesstoken = data.access_token;
      this.mlaccesstoken = this.parametros.marketplaces.mercadolivre.accesstoken;
      this.parametros.marketplaces.mercadolivre.refreshtoken = data.refresh_token;
      this.mlrefreshtoken = this.parametros.marketplaces.mercadolivre.refreshtoken;
      this.parametros.marketplaces.mercadolivre.userid = data.user_id;
      this.mluserid = this.parametros.marketplaces.mercadolivre.userid;
    },
    requestTokenMercadoLivre: function requestTokenMercadoLivre(data) {
      var url = "https://api.mercadolibre.com/oauth/token?grant_type=authorization_code&client_id=" + this.ML_APP_ID + "&client_secret=" + this.ML_SECRET_KEY + "&code=" + this.parametros.marketplaces.mercadolivre.code;
      if (window.location.href.includes("notabrasil.com.br/teste/")) {
        url += "&redirect_uri=" + window.location.origin + "/teste/mercadolivre_code.html";
      } else {
        url += "&redirect_uri=" + window.location.origin + "/mercadolivre_code.html";
      }

      jQuery.post(url, this.responseTokenMercadoLivre);
    },
    getCodeFormPermissaoMercadoLivre: function getCodeFormPermissaoMercadoLivre() {
      var queryString = this.popup.location.search;

      var urlParams = new URLSearchParams(queryString);

      this.parametros.marketplaces.mercadolivre.code = urlParams.get("code");
      this.mlcode = this.parametros.marketplaces.mercadolivre.code;
      if (this.parametros.marketplaces.mercadolivre.code) {
        this.popup.close();
        this.requestTokenMercadoLivre();
      } else {
        this.onLoadFormPermissaoMercadoLivre();
      }
    },
    onLoadFormPermissaoMercadoLivre: function onLoadFormPermissaoMercadoLivre() {
      setTimeout(this.getCodeFormPermissaoMercadoLivre, 2000);
    },
    handlePermissaoMercadoLivre: function handlePermissaoMercadoLivre() {
      var url = "http://auth.mercadolivre.com.br/authorization?response_type=code&client_id=" + this.ML_APP_ID;
      //if (window.location.href.includes('notabrasil.com.br/teste/')){
      //    url += "&redirect_uri="+ window.location.origin +"/teste/#/mercadolivre/code";
      //}else{
      //    url += "&redirect_uri="+ window.location.origin +"/#/mercadolivre/code";
      //}

      this.popup = window.open(url, "myWindow", "width=800,height=600");

      this.popup.onload = this.onLoadFormPermissaoMercadoLivre;
    },
    closeForm: function closeForm() {
      if (this.$route.name == "empresa") {
        this.$router.go(-1);
      } else if (!this.disableRetorno) this.$emit("closeform");
    },
    updateCep: function updateCep() {
      //CARREGA INFORMACOES DO CEP
      this.filial.ende = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.logradouro;
      this.filial.bairro = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.bairro;
      this.filial.codmun = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.ibge;
      this.filial.uf = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.uf;
    },
    handleSave: function handleSave(guideDisableValidation) {
      var _this2 = this;

      //BOTAO SALVAR
      this.errmessages = [];

      console.log(guideDisableValidation);

      if (guideDisableValidation) {
        this.apiPost();
        return;
      }

      //novo plano permite habilitar ambiente produção para emissão de 5 notas
      // if (SysVars.appTrial && this.filial.tpambnfe == '1')
      //     this.errmessages.push('Não é permitido emitir notas fiscais em "ambiente de produção" para contas em período de testes!')

      if ((this.filial.crt == "1" || this.filial.crt == "4") && (this.filial.pcredsn || 0) <= 0) this.errmessages.push("% Aproveitamento Crédito deve ser preenchido.");

      if (this.errmessages.length > 0) {
        this.$validator.validateAll();
        this.$erpToastError("Por favor, corrija os campos em destaque para continuar");
        return;
      }

      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this2.$erpToastError("Por favor, corrija os campos em destaque para continuar");
        } else {
          // if ((this.filial.crt=='1') && ((this.filial.pcredsn||0)<=0)){
          //     this.$erpToastError('% Aproveitamento Crédito deve ser preenchido.')
          // }else{
          // this.apiPost()
          // }
          _this2.apiPost();
        }
      });
    },
    handleDelete: function handleDelete() {
      //BOTAO Excluir
      this.apiDelete();
    },
    handleAdicionaUF: function handleAdicionaUF() {
      //adiciona nova linha na lista de inscricoes de substituto tributario
      var iest = _extends({}, this.$store.getters.getEntities.listSubstitutos);
      this.listSubstitutos.push(iest);
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },
    handleDeleteUF: function handleDeleteUF(index) {
      //exclui uma inscricao de substituto tributario
      this.listSubstitutos.splice(index, 1);
    },
    handleAdicionaEtiqueta: function handleAdicionaEtiqueta() {
      //adiciona novo campo para inserção de uma nova etiqueta
      var etiqueta = { descricao: null, conteudo: null, tipo: null };
      this.listEtiquetas.push(etiqueta);
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },
    handleSetEtiqueta: function handleSetEtiqueta(etiqueta) {
      this.showModalEtiqueta = true;
      this.etiqueta = etiqueta;
    },
    handleSaveEtiqueta: function handleSaveEtiqueta() {
      var conteudoEtiqueta = this.$refs.etiqueta.saveLayout();
      this.etiqueta.conteudo = conteudoEtiqueta;
      this.showModalEtiqueta = false;
    },
    handleDeleteEtiqueta: function handleDeleteEtiqueta(index) {
      //exclui uma inscricao de substituto tributario
      this.etiqueta = null;
      this.listEtiquetas.splice(index, 1);
    },
    loadListaEtiquetas: function loadListaEtiquetas() {
      return this.listEtiquetas;
    },
    loadData: function loadData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var filialList, x, tourguide;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$store.dispatch("loadTabpre", {});

              case 2:
                _context.next = 4;
                return _this3.$store.dispatch("loadEstadoRegras");

              case 4:
                if (_this3.$store.getters.getEstadoList) {
                  _this3.estadoList = _this3.$store.getters.getEstadoList.map(function (obj) {
                    return { id: obj.uf, text: obj.uf };
                  });
                }

                //carrega o registro para alteracao ou visualizacao

                if (!(_this3.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI)) {
                  _context.next = 24;
                  break;
                }

                if (!(_this3.$store.getters.getFilialList.length == 0)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 9;
                return _this3.$store.dispatch("loadSessao", _this3);

              case 9:
                _this3.filial.nome = _this3.$store.getters.getSessao.empresa_nome;
                _this3.filial.cnpj = _this3.$store.getters.getSessao.cnpj;

              case 11:
                _this3.$set(_this3.filial, "cnpjcontador", "");
                _this3.filial.stfilial = "A";
                _this3.filial.uf = "SP";
                _this3.filial.crt = "1";
                _this3.filial.contingencia = "D";
                _this3.filial.tpambnfe = "2";
                _this3.filial.tpimpnfe = "1";
                _this3.filial.regimepiscofins = "1";
                _this3.isento = "N";
                _this3.disableRetorno = _this3.appForcaVendas;
                return _context.abrupt("return");

              case 24:
                if (_this3.index) _this3.codfil = _this3.index;else {
                  filialList = _this3.$store.getters.getFilialList;

                  if (filialList.length > 0) {
                    _this3.codfil = filialList[0].codfil;
                  }
                }

              case 25:
                _context.next = 27;
                return _this3.$store.dispatch("loadFilial", { id: _this3.codfil });

              case 27:
                if (_this3.$store.getters.getFilial) {
                  _this3.filial = _extends({}, _this3.$store.getters.getFilial);
                  _this3.$set(_this3.filial, "cnpjcontador", _this3.filial.cnpjcontador || "");

                  _this3.listSubstitutos = _this3.filial.list_iest; //lista de inscricoes ST

                  if (_this3.filial.list_iest.length) {
                    for (x = 0; x < _this3.filial.list_iest; x++) {
                      _this3.listSubstitutos.push(_this3.filial.list_iest[x]);
                    }
                  }

                  if (_this3.filial.iest === "ISENTO") {
                    _this3.tipo_ie = "ISENTO";
                  } else if (!_this3.filial.iest || String(_this3.filial.iest).trim() === "") {
                    _this3.tipo_ie = "SEM_IE";
                    _this3.filial.iest = null;
                  } else {
                    _this3.tipo_ie = "COM_IE";
                  }
                  if (_this3.filial.parametros) {
                    _this3.parametros = JSON.parse(_this3.filial.parametros);
                  } else {
                    _this3.parametros = {
                      controlaestoque: false,
                      venda_sem_estoque: false,
                      venda_sem_credito: true,
                      agrupar_itens_pedido: false,
                      rentabilidade_minima: null
                    };
                  }

                  if (_this3.parametros.hasOwnProperty("agrupar_itens_pedido") == false) {
                    _this3.parametros.agrupar_itens_pedido = false;
                  }

                  if (_this3.parametros.hasOwnProperty("marketplaces") == false) {
                    _this3.parametros.marketplaces = {
                      b2w: {
                        userlogin: null,
                        apikey: null,
                        accountmanagerkey: null
                      },
                      mercadolivre: {
                        code: null,
                        accesstoken: null,
                        refreshtoken: null,
                        userid: null
                      }
                    };
                  }
                  if (_this3.parametros.hasOwnProperty("pagonline") == false) {
                    _this3.parametros.pagonline = {
                      cielo: {
                        clientid: null,
                        clientsecret: null
                      },
                      rede: {
                        token: null,
                        pv: null
                      }
                    };
                  }
                  if (_this3.parametros.pagonline.hasOwnProperty("cielo") == false) {
                    _this3.parametros.pagonline.cielo = {
                      clientid: null,
                      clientsecret: null
                    };
                  }
                  if (_this3.parametros.pagonline.hasOwnProperty("rede") == false) {
                    _this3.parametros.pagonline.rede = {
                      token: null,
                      pv: null
                    };
                  }

                  if (_this3.parametros.hasOwnProperty("sat") == false) {
                    _this3.parametros.sat = {
                      signAC: null,
                      codigoDeAtivacao: null,
                      nomeDLL: null,
                      arqLOG: null,
                      visualizarImp: null,
                      emulador: null
                    };
                  }

                  if (_this3.parametros.hasOwnProperty("pdv") == false) {
                    _this3.parametros.pdv = _extends({}, _this3.$store.getters.getParamPDV);
                  }

                  if (_this3.parametros.hasOwnProperty("exibir_estoque_integracao") == false) {
                    _this3.parametros.exibir_estoque_integracao = false;
                  }

                  if (_this3.parametros.hasOwnProperty("parcelas") == false) {
                    _this3.parametros.parcelas = {
                      formapag: null
                    };
                  }

                  if (_this3.parametros.pdv.hasOwnProperty("default_focus_btn_pag") == false) {
                    _this3.parametros.pdv.default_focus_btn_pag = null;
                  }
                  if (_this3.parametros.pdv.hasOwnProperty("ir_para_emissao_nf") == false) {
                    _this3.parametros.pdv.ir_para_emissao_nf = null;
                  }
                  if (_this3.parametros.pdv.hasOwnProperty("tipo_controle_cm_ms") == false) {
                    _this3.parametros.pdv.tipo_controle_cm_ms = null;
                  }
                  if (_this3.parametros.pdv.hasOwnProperty("colors") == false) {
                    _this3.parametros.pdv.colors = {
                      bg_top_bottom: null,
                      fc_top_bottom: null,
                      bg_buttom: null,
                      fc_buttom: null
                    };
                  }
                  if (_this3.parametros.pdv.hasOwnProperty("listMesas") == false) {
                    _this3.parametros.pdv.listMesas = [];
                  }

                  if (_this3.parametros.hasOwnProperty("etiquetas")) {
                    _this3.listEtiquetas = _this3.parametros.etiquetas;
                  }

                  if (_this3.parametros.hasOwnProperty("pedido") == false) {
                    _this3.parametros.pedido = {
                      observacao_garantia: null
                    };
                  }

                  if (_this3.parametros.pdv.hasOwnProperty("default_header_title") == false) {
                    _this3.parametros.pdv.default_header_title = null;
                  }

                  if (_this3.parametros.hasOwnProperty("cartaCobranca") == false) {
                    _this3.parametros.cartaCobranca = {
                      assunto: null,
                      emailResposta: null,
                      textoEmail: "<p>Caro {{nome_cliente}},</p><p>Verificamos que você possui o(s) valor(es) vencido(s) conforme relacionado abaixo.</p><div>{{titulos}}</div><br><p>Por gentileza desconsidere esta mensagem caso já tenha sido efetuado o pagamento.</p><p>{{nome_empresa}}</p>"
                    };
                  }

                  if (_this3.parametros.hasOwnProperty("nfse") == false) {
                    _this3.parametros.nfse = {
                      login: null,
                      senha: null,
                      token: null,
                      nfseNacional: null
                    };

                    if (_this3.parametros.nfse.hasOwnProperty("login") == false) {
                      _this3.parametros.nfse.login = null;
                    }
                    if (_this3.parametros.nfse.hasOwnProperty("senha") == false) {
                      _this3.parametros.nfse.senha = null;
                    }
                    if (_this3.parametros.nfse.hasOwnProperty("token") == false) {
                      _this3.parametros.nfse.token = null;
                    }
                    if (_this3.parametros.nfse.hasOwnProperty("nfseNacional") == false) {
                      _this3.parametros.nfse.nfseNacional = null;
                    }
                  }

                  if (_this3.showGuia && _this3.steps.length > 0 && _this3.filial.cnpj == "50117039000161") {
                    tourguide = new __WEBPACK_IMPORTED_MODULE_6_tourguidejs___default.a({
                      steps: _this3.steps
                    });


                    tourguide.start();
                  }
                }

                _this3.loadParametrosNfse();

                _this3.loadLogotipo();

                _this3.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    loadParametrosNfse: function loadParametrosNfse() {
      if (!this.filial.codempresa) return;
      var self = this;
      Object(__WEBPACK_IMPORTED_MODULE_3__shared_nfse__["cidades"])(this.$store, this.filial.codmun, function (data) {
        if (data) {
          self.nfse_login = data.login;
          self.nfse_senha = data.senha;
          self.nfse_token = data.token;
          self.nfse_certificado = data.certificado;
        }
      });
    },
    loadLogotipo: function loadLogotipo() {
      var _this4 = this;

      if (!this.filial.codempresa) return;
      Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSmidia"])(this.$store.getters.urlApp + "logo/download/" + this.filial.codempresa + "/" + this.filial.codfil).then(function (data) {
        if (data && data.size > 0) {
          var self = _this4;
          var reader = new window.FileReader();
          reader.readAsDataURL(data);
          reader.onload = function () {
            self.image = reader.result;
          };
        }
      });
    },
    apiDelete: function apiDelete() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                //efetua a exclusao
                modulo = "cg/filial/" + _this5.filial.codfil;
                _context2.next = 3;
                return apiORDSdelete(_this5.$store, modulo);

              case 3:
                data = _context2.sent;

                _this5.$erpToastDeleted();
                _this5.closeForm();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    apiPost: function apiPost() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var modulo, sendData, metodo, update, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                //efetua a gravacao

                modulo = "cg/filial/";

                _this6.filial.list_iest = _this6.listSubstitutos;
                _this6.parametros.etiquetas = _this6.listEtiquetas;
                _this6.filial.parametros = _this6.parametros;
                if (_this6.filial.parametrosloja) {
                  _this6.filial.parametrosloja = JSON.parse(_this6.filial.parametrosloja);
                } else {
                  _this6.filial.parametrosloja = null;
                }
                if (_this6.tipo_ie === "SEM_IE") {
                  _this6.filial.iest = null;
                } else if (_this6.tipo_ie === "ISENTO") {
                  _this6.filial.iest = "ISENTO";
                }
                sendData = { filial: _this6.filial };
                metodo = "post";
                update = false;

                if (_this6.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                  metodo = "put";
                  update = true;
                }

                _context3.next = 12;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this6.$store, modulo, sendData, metodo);

              case 12:
                data = _context3.sent;

                if (data.errmessages) {
                  _this6.errmessages = data.errmessages;
                  _this6.$erpToastError("Alguns erros precisam ser corrigidos.");
                } else {
                  if (!_this6.guide) if (update) {
                    _this6.$erpToastUpdated();
                  } else {
                    _this6.$erpToastInserted();
                  }
                  _this6.errmessages = {};
                  if (!_this6.guide) _this6.closeForm();else {
                    _this6.$emit("gonextstep");
                  }
                }

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    handleClickLogotipo: function handleClickLogotipo(cod) {
      document.getElementById("anexo").click();
    },
    handleUpload: function handleUpload(event) {
      this.selectedFile = event.target.files[0];
      this.urlImage = URL.createObjectURL(this.selectedFile);
      this.uploadImage();
    },
    uploadImage: function uploadImage() {
      //EFETUA O UPLOAD DO CERTIFICADO

      var formData = new FormData();
      formData.append("file", this.selectedFile);

      var url = this.$store.getters.urlApp + "logo/";

      var self = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          codfilial: this.filial.codfil,
          filename: this.selectedFile.name
        }
      }).then(function (data) {
        self.$erpToastSuccess("O logotipo foi atualizado com sucesso.");
        self.loadLogotipo();
      });
    },
    apiDeleteImage: function apiDeleteImage() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this7.filial.logotipo.length == 0)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                modulo = "logo/" + _this7.filial.logotipo[0].codlogotipo;
                _context4.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSapp"])(_this7, modulo, "delete");

              case 5:
                data = _context4.sent;

                _this7.image = null;
                _this7.$erpToastSuccess("O certificado foi removido com sucesso.");

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    }
  },

  components: {
    "layout-etiqueta": __WEBPACK_IMPORTED_MODULE_4__components_layout_etiqueta_vue__["a" /* default */],
    AppCertificado: __WEBPACK_IMPORTED_MODULE_5__app_certificado__["default"],
    Tourguide: __WEBPACK_IMPORTED_MODULE_6_tourguidejs___default.a
  },

  watch: {
    tipo_ie: function tipo_ie() {
      if (this.tipo_ie === "ISENTO") {
        this.filial.iest = "ISENTO";
      } else if (this.tipo_ie === "SEM_IE") {
        this.filial.iest = null;
      } else if (this.tipo_ie === "COM_IE") {
        if (this.filial.iest === "ISENTO") {
          this.filial.iest = null;
        }
      }
    },
    "filial.nome": function filialNome() {},
    "filial.codmun": function filialCodmun() {
      this.loadParametrosNfse();
    }
  },

  beforeCreate: function beforeCreate() {},
  created: function created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
      if (this.$refs.cnpj) this.$refs.cnpj.focus();
    });

    if (!this.crud) this.crud = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;

    this.crudText = this.$crudText(this.crud);

    this.loadData();
  },
  mounted: function mounted() {}
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_draggable_resizable__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_draggable_resizable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_draggable_resizable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_draggable_resizable_dist_VueDraggableResizable_css__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_draggable_resizable_dist_VueDraggableResizable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_draggable_resizable_dist_VueDraggableResizable_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _computed;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = (_defineProperty({
    name: 'layout-etiqueta',
    props: {
        dadosEtiqueta: { type: Object },
        isView: { type: Boolean, default: false }
    },

    components: { VueDraggableResizable: __WEBPACK_IMPORTED_MODULE_0_vue_draggable_resizable___default.a },

    data: function data() {
        return {
            fields: [],
            multiplicador_etiqueta: 1,
            multiplicador_pagina: 1,
            items: [],
            items_backup: [],
            optionsCurrency: [{ id: 'RL', text: 'BRL(R$)' }, { id: 'US', text: 'USD($)' }, { id: 'EU', text: 'EUR(€)' }, { id: 'GB', text: 'EUR(€)' }],
            optionsFont: [{ id: 'Courier', text: 'Courier' }, { id: 'Courier-Bold', text: 'Courier-Bold' }, { id: 'Courier-Oblique', text: 'Courier-Oblique' }, { id: 'Courier-BoldOblique', text: 'Courier-BoldOblique' }, { id: 'Helvetica', text: 'Helvetica' }, { id: 'Helvetica-Bold', text: 'Helvetica-Bold' }, { id: 'Helvetica-Oblique', text: 'Helvetica-Oblique' }, { id: 'Helvetica-BoldOblique', text: 'Helvetica-BoldOblique' }, { id: 'Symbol', text: 'Symbol' }, { id: 'Times-Roman', text: 'Times-Roman' }, { id: 'Times-Bold', text: 'Times-Bold' }, { id: 'Times-Italic', text: 'Times-BoldItalic' }, { id: 'ZapfDingbats', text: 'ZapfDingbats' }],
            optionsTypeGTIN: [{ id: 'CB', text: 'Código de Barras' }, { id: 'TX', text: 'Texto' }],
            optionsFormatGTIN: [{ id: 'EAN13', text: 'EAN13' }, { id: 'EAN8', text: 'EAN8' }, { id: 'EAN5', text: 'EAN5' }, { id: 'EAN2', text: 'EAN2' }, { id: 'MSI', text: 'MSI' }, { id: 'MSI10', text: 'MSI10' }, { id: 'MSI11', text: 'MSI11' }, { id: 'MSI1010', text: 'MSI1010' }, { id: 'MSI1110', text: 'MSI1110' }, { id: 'UPC', text: 'UPC' }, { id: 'ITF14', text: 'ITF14' }, { id: 'pharmacode', text: 'PHARMACODE' }, { id: 'CODE39', text: 'CODE39' }, { id: 'CODE128', text: 'CODE128' }, { id: 'codabar', text: 'CODABAR' }],
            typeOfField: 'produto',
            pagina: {
                format: '4',
                largura: 210,
                altura: 297,
                margin: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                }
            },
            etiqueta: {
                largura: 80,
                altura: 30,
                espacamento_horizontal: 5,
                espacamento_vertical: 5
            },
            item: null,
            tabs: [{ title: 'Etiqueta', icon: '' }, { title: 'Pagina', icon: '' }],
            activeTab: 0,
            focusVertical: false,
            focusHorizontal: false,
            focusSuperior: false,
            focusInferior: false,
            focusDireita: false,
            focusEsquerda: false,
            formatOptions: [{ id: 1, text: "Personalizado" }, { id: 2, text: "A2" }, { id: 3, text: "A3" }, { id: 4, text: "A4" }, { id: 5, text: "A5" }]
        };
    },


    methods: {
        handleCancelItem: function handleCancelItem(item) {
            var _this = this;

            this.items.map(function (e, i) {
                if (e.index == item.index) {
                    _this.items.splice(i, 1);
                }
            });

            this.items.map(function (e, i) {
                e.index = i;
            });
            this.item = null;
        },

        // handleBold(){
        //     this.$set(this.item, 'selectedBold', !this.item.selectedBold)
        // },
        // handleItalic(){
        //     this.$set(this.item, 'selectedItalic', !this.item.selectedItalic)
        // },
        handleTextStyle: function handleTextStyle(item) {
            var fontSize = '';
            var textFont = '';
            var selectedBold = false;
            var selectedItalic = false;
            if (item.fontSize) {
                fontSize = 'font-size: ' + item.fontSize + 'px';
            }
            if (item.textFont) {
                textFont = 'font-family: ' + item.textFont;
            }
            // if(item.selectedBold){
            if ((item.textFont + "").toUpperCase().includes("bold".toUpperCase())) {
                selectedBold = 'font-weight: bold';
            }
            // if(item.selectedItalic){
            if ((item.textFont + "").toUpperCase().includes("italic".toUpperCase())) {
                selectedItalic = 'font-style: italic';
            }

            return fontSize + '; ' + textFont + '; ' + selectedBold + '; ' + selectedItalic + ';';
        },
        focus: function focus() {},
        onFocusVertical: function onFocusVertical() {
            this.focusVertical = true;
            this.preview_pagina_nexttick();
        },
        onBlurVertical: function onBlurVertical() {
            this.focusVertical = false;
            this.preview_pagina_nexttick();
        },
        onFocusHorizontal: function onFocusHorizontal() {
            this.focusHorizontal = true;
            this.preview_pagina_nexttick();
        },
        onBlurHorizontal: function onBlurHorizontal() {
            this.focusHorizontal = false;
            this.preview_pagina_nexttick();
        },
        onFocusSuperior: function onFocusSuperior() {
            this.focusSuperior = true;
            this.preview_pagina_nexttick();
        },
        onBlurSuperior: function onBlurSuperior() {
            this.focusSuperior = false;
            this.preview_pagina_nexttick();
        },
        onFocusInferior: function onFocusInferior() {
            this.focusInferior = true;
            this.preview_pagina_nexttick();
        },
        onBlurInferior: function onBlurInferior() {
            this.focusInferior = false;
            this.preview_pagina_nexttick();
        },
        onFocusDireita: function onFocusDireita() {
            this.focusDireita = true;
            this.preview_pagina_nexttick();
        },
        onBlurDireita: function onBlurDireita() {
            this.focusDireita = false;
            this.preview_pagina_nexttick();
        },
        onFocusEsquerda: function onFocusEsquerda() {
            this.focusEsquerda = true;
            this.preview_pagina_nexttick();
        },
        onBlurEsquerda: function onBlurEsquerda() {
            this.focusEsquerda = false;
            this.preview_pagina_nexttick();
        },
        setFormat: function setFormat() {
            if (this.pagina.format == 1) {
                this.pagina.largura = 210;
                this.pagina.altura = 297;
                this.preview_pagina_nexttick();
                return;
            }

            if (this.pagina.format == 2) {
                this.pagina.largura = 420;
                this.pagina.altura = 594;
                this.preview_pagina_nexttick();
                return;
            }

            if (this.pagina.format == 3) {
                this.pagina.largura = 297;
                this.pagina.altura = 420;
                this.preview_pagina_nexttick();
                return;
            }

            if (this.pagina.format == 4) {
                this.pagina.largura = 210;
                this.pagina.altura = 297;
                this.preview_pagina_nexttick();
                return;
            }

            if (this.pagina.format == 5) {
                this.pagina.largura = 148;
                this.pagina.altura = 210;
                this.preview_pagina_nexttick();
                return;
            }
        },
        preview_pagina_nexttick: function preview_pagina_nexttick() {
            this.$nextTick(function () {
                this.preview_pagina();
            });
        },
        saveLayout: function saveLayout() {
            var layoutConfig = {};
            layoutConfig.items = this.items;
            layoutConfig.pagina = this.pagina;
            layoutConfig.etiqueta = this.etiqueta;

            return layoutConfig;
        },
        getFields: function getFields() {
            var aux = [];
            if (this.dadosEtiqueta.tipo == 'P') {
                aux.push({ name: 'item.descricao', family: 'produto', label: 'Nome' });
                aux.push({ name: 'item.codigo', family: 'produto', label: 'Codigo' });
                aux.push({ name: 'item.canp', family: 'produto', label: 'Codigo ANP' });
                aux.push({ name: 'item.vlr', family: 'produto', label: 'Preço de Venda' });
                aux.push({ name: 'item.cuspadrao', family: 'produto', label: 'Custo' });
                aux.push({ name: 'item.pliq', family: 'produto', label: 'Peso Líquido' });
                aux.push({ name: 'item.pbru', family: 'produto', label: 'Peso Bruto' });
                aux.push({ name: 'item.comprimento', family: 'produto', label: 'Comprimento (cm)' });
                aux.push({ name: 'item.largura', family: 'produto', label: 'Largurai (cm)' });
                aux.push({ name: 'item.espessura', family: 'produto', label: 'Espessura (cm)' });
                aux.push({ name: 'item.codbarras', family: 'produto', label: 'GTIN' });

                aux.push({ name: 'filial.nome', family: 'empresa', label: 'Nome' });
                aux.push({ name: 'filial.fantasia', family: 'empresa', label: 'Fantasia' });
                aux.push({ name: 'filial.cnpj', family: 'empresa', label: 'CNPJ' });
                aux.push({ name: 'filial.cep', family: 'empresa', label: 'CEP' });
                aux.push({ name: 'filial.ende', family: 'empresa', label: 'Endereço' });
                aux.push({ name: 'filial.endenr', family: 'empresa', label: 'Endereço Nr.' });
                aux.push({ name: 'filial.endecomp', family: 'empresa', label: 'Complemento' });
                aux.push({ name: 'filial.bairro', family: 'empresa', label: 'Bairro' });
                aux.push({ name: 'filial.uf', family: 'empresa', label: 'UF' });
                aux.push({ name: 'filial.nomemun', family: 'empresa', label: 'Município' });
                aux.push({ name: 'filial.fone1', family: 'empresa', label: 'Telefone 1' });
                aux.push({ name: 'filial.fone2', family: 'empresa', label: 'Telefone 2' });
                aux.push({ name: 'filial.fone3', family: 'empresa', label: 'Telefone 3' });
                aux.push({ name: 'filial.email', family: 'empresa', label: 'E-mail' });
                aux.push({ name: 'filial.site', family: 'empresa', label: 'Site' });
                aux.push({ name: 'filial.iest', family: 'empresa', label: 'iest' });

                aux.push({ name: 'outros.texto', family: 'outros', label: 'Texto' });
                aux.push({ name: 'outros.date', family: 'outros', label: 'Data Atual' });
            }
            return aux;
        },
        changeTab: function changeTab(idx) {
            this.activeTab = idx;
            if (this.activeTab == 1) this.preview_pagina_nexttick();
        },
        startDragFields: function startDragFields(evt, item) {
            evt.dataTransfer.dropEffect = 'move';
            evt.dataTransfer.effectAllowed = 'move';
            evt.dataTransfer.setData('fieldID', item.name);
        },
        onDropFields: function onDropFields(evt) {
            console.log(evt);
            var fieldID = evt.dataTransfer.getData('fieldID');
            if (!fieldID) {
                return;
            }
            var field = this.fields.find(function (item) {
                return item.name == fieldID;
            });

            var clonefield = JSON.parse(JSON.stringify(field));
            clonefield.index = this.items.length;
            clonefield.x = 0;
            clonefield.y = 0;
            clonefield.width = 20;
            clonefield.height = 7;
            clonefield.textFont = "Times-Roman";
            clonefield.fontSize = 12;
            // clonefield.selectedBold = false
            // clonefield.selectedItalic = false
            clonefield.rotudo = null;
            clonefield.typeGTIN = null;
            clonefield.formatGTIN = null;
            clonefield.codemtexto = false;
            if (clonefield.name == 'item.codbarras') {
                clonefield.typeGTIN = 'CB';
                clonefield.formatGTIN = 'EAN13';
            }
            clonefield.obs = null;
            this.items.push(clonefield);
            evt.dataTransfer.setData('fieldID', null);
        },


        onResizeItem: function onResizeItem(index, x, y, width, height) {
            var field = this.items.find(function (item) {
                return item.index == index;
            });
            field.x = this.pxTomm(Number(x));
            field.y = this.pxTomm(Number(y));
            field.width = this.pxTomm(Number(width));
            field.height = this.pxTomm(Number(height));
        },

        onDragingItem: function onDragingItem(index, x, y) {
            var field = this.items.find(function (item) {
                return item.index == index;
            });
            this.item = field;
            field.x = this.pxTomm(Number(x));
            field.y = this.pxTomm(Number(y));
            field.fontSize = 12;
        },

        onActivated: function onActivated(index) {
            var field = this.items.find(function (item) {
                return item.index == index;
            });
            this.item = field;
        },
        onDeactivated: function onDeactivated() {
            // this.item = null
        },
        calcula_etiqueta_largura: function calcula_etiqueta_largura(modoPagina) {
            return this.etiqueta.largura / 0.264583333 * (modoPagina ? this.multiplicador_pagina : this.multiplicador_etiqueta);
        },
        calcula_etiqueta_altura: function calcula_etiqueta_altura(modoPagina) {
            return this.etiqueta.altura / 0.264583333 * (modoPagina ? this.multiplicador_pagina : this.multiplicador_etiqueta);
        },
        pxTomm: function pxTomm(value_px) {
            var dpi = 96;
            if (document.getElementById("dpi") && document.getElementById("dpi").offsetHeight) dpi = document.getElementById("dpi").offsetHeight;
            var mmDPI = 25.4 / Number(dpi);
            return Number(value_px) * mmDPI;
        },
        mmTopx: function mmTopx(value_mm) {
            var dpi = 96;
            if (document.getElementById("dpi") && document.getElementById("dpi").offsetHeight) dpi = document.getElementById("dpi").offsetHeight;
            var mmDPI = 25.4 / Number(dpi);
            return Number(value_mm) / mmDPI;
        },
        preview_pagina: function preview_pagina() {
            var canvas = document.getElementById('canvas');

            if (!canvas) return;

            var ctx = canvas.getContext('2d');

            ctx.clearRect(0, 0, this.mmTopx(this.pagina.largura), this.mmTopx(this.pagina.altura));

            ctx.lineWidth = 1;

            ctx.font = "20px Arial";
            ctx.fillStyle = "red";
            ctx.fillText(this.pagina.largura + "x" + this.pagina.altura, 5, 15);

            ctx.strokeStyle = 'black';
            ctx.setLineDash([]);
            ctx.strokeRect(0, 0, this.mmTopx(this.pagina.largura), this.mmTopx(this.pagina.altura));

            // Define o Grid
            // for (let i = 0; i < (this.pagina.largura / 5); i++) {
            //     for (let j = 0; j < (this.pagina.altura / 5); j++) {
            //         ctx.strokeStyle = 'black';
            //         ctx.lineWidth = 1;
            //         ctx.strokeRect(5 * i, 5 * j , 5, 5);
            //     }
            // }

            for (var i = Number(this.pagina.margin.left); i + Number(this.etiqueta.largura) <= Number(this.pagina.largura) - Number(this.pagina.margin.right); i = i + Number(this.etiqueta.largura) + Number(this.etiqueta.espacamento_horizontal)) {
                for (var j = Number(this.pagina.margin.top); j + Number(this.etiqueta.altura) <= Number(this.pagina.altura) - Number(this.pagina.margin.bottom); j = j + Number(this.etiqueta.altura) + Number(this.etiqueta.espacamento_vertical)) {
                    var x = this.mmTopx(i);
                    var y = this.mmTopx(j);
                    ctx.font = "15px Arial";
                    ctx.fillStyle = "red";
                    ctx.fillText(this.etiqueta.largura + "x" + this.etiqueta.altura, x, y + 10);

                    // Define a etiqueta
                    ctx.fillStyle = 'rgba(55, 55, 55, 0.1)';
                    ctx.fillRect(x, y, this.mmTopx(this.etiqueta.largura), this.mmTopx(this.etiqueta.altura));

                    // Define a borda tracejada da etiqueta
                    ctx.setLineDash([5, 5, 5]);
                    ctx.strokeRect(x, y, this.mmTopx(this.etiqueta.largura), this.mmTopx(this.etiqueta.altura));

                    // Espacamento Horizontal
                    if (this.focusHorizontal) if (i > Number(this.pagina.margin.left)) {
                        ctx.fillStyle = 'rgba(0, 255, 0, 0.6)';
                        ctx.fillRect(x - this.mmTopx(Number(this.etiqueta.espacamento_horizontal)), y, this.mmTopx(this.etiqueta.espacamento_horizontal), this.mmTopx(this.etiqueta.altura));
                    }

                    // Espacamento Vertical
                    if (this.focusVertical) if (j > Number(this.pagina.margin.top)) {
                        ctx.fillStyle = 'rgba(0, 0, 255, 0.6)';
                        ctx.fillRect(x, y - this.mmTopx(Number(this.etiqueta.espacamento_vertical)), this.mmTopx(this.etiqueta.largura), this.mmTopx(this.etiqueta.espacamento_vertical));
                    }
                }
            }

            // Define as 4 bordas
            if (this.focusSuperior) {
                ctx.fillStyle = 'rgba(245, 121, 49, 0.6)';
                ctx.fillRect(0, 0, this.mmTopx(this.pagina.largura), this.mmTopx(this.pagina.margin.top));
                return;
            }

            if (this.focusEsquerda) {
                ctx.fillStyle = 'rgba(245, 121, 49, 0.6)';
                ctx.fillRect(0, 0, this.mmTopx(this.pagina.margin.left), this.mmTopx(this.pagina.altura));
                return;
            }

            if (this.focusDireita) {
                ctx.fillStyle = 'rgba(245, 121, 49, 0.6)';
                ctx.fillRect(this.mmTopx(this.pagina.largura - this.pagina.margin.right), 0, this.mmTopx(this.pagina.margin.right), this.mmTopx(this.pagina.altura));
                return;
            }

            if (this.focusInferior) {
                ctx.fillStyle = 'rgba(245, 121, 49, 0.6)';
                ctx.fillRect(0, this.mmTopx(this.pagina.altura - this.pagina.margin.bottom), this.mmTopx(this.pagina.largura), this.mmTopx(this.pagina.margin.bottom));
                return;
            }
        }
    },
    mounted: function mounted() {},


    computed: (_computed = {
        fieldWidth: function fieldWidth() {
            // if((this.item.family == 'produto' && this.item.name !== 'item.gtin') || this.item.family == 'outros' || this.item.family == 'empresa'){
            return true;
            // }
        },
        fieldHeight: function fieldHeight() {
            // if((this.item.family == 'produto' && this.item.name !== 'item.gtin') || this.item.family == 'outros' || this.item.family == 'empresa'){
            return true;
            // }
        },
        fieldTextFont: function fieldTextFont() {
            if (this.item.family == 'produto' && this.item.name !== 'item.codbarras' || this.item.family == 'outros' || this.item.family == 'empresa') {
                return true;
            }
        },
        fieldFontSize: function fieldFontSize() {
            if (this.item.family == 'produto' && this.item.name !== 'item.codbarras' || this.item.family == 'outros' || this.item.family == 'empresa') {
                return true;
            }
        },
        fieldRotulo: function fieldRotulo() {
            if (this.item.family == 'produto' && this.item.name !== 'item.codbarras' || this.item.family == 'outros' || this.item.family == 'empresa') {
                return true;
            }
        },
        fieldObs: function fieldObs() {
            if (this.item.name == 'item.texto') {
                return true;
            }
        },
        fieldTypeGTIN: function fieldTypeGTIN() {
            if (this.item.name == 'item.codbarras') {
                return true;
            }
        },
        fieldFormatGTIN: function fieldFormatGTIN() {
            if (this.item.name == 'item.codbarras') {
                return true;
            }
        }
    }, _defineProperty(_computed, 'fieldFormatGTIN', function fieldFormatGTIN() {
        if (this.item.name == 'item.codbarras') {
            return true;
        }
    }), _defineProperty(_computed, 'paginalargura', function paginalargura() {
        return this.pagina.largura * this.multiplicador_pagina;
    }), _defineProperty(_computed, 'paginaaltura', function paginaaltura() {
        return this.pagina.altura * this.multiplicador_pagina;
    }), _defineProperty(_computed, 'etiquetalargura', function etiquetalargura() {
        return this.calcula_etiqueta_largura(false);
    }), _defineProperty(_computed, 'etiquetaaltura', function etiquetaaltura() {
        return this.calcula_etiqueta_altura(false);
    }), _defineProperty(_computed, 'etiquetalargura_modoPagina', function etiquetalargura_modoPagina() {
        return this.calcula_etiqueta_largura(true);
    }), _defineProperty(_computed, 'etiquetaaltura_modoPagina', function etiquetaaltura_modoPagina() {
        return this.calcula_etiqueta_altura(true);
    }), _defineProperty(_computed, 'pagina_margin_top', function pagina_margin_top(tp) {
        return this.pagina.margin.top * this.multiplicador_pagina;
    }), _defineProperty(_computed, 'pagina_margin_bottom', function pagina_margin_bottom() {
        return this.pagina.margin.bottom * this.multiplicador_pagina;
    }), _defineProperty(_computed, 'pagina_margin_left', function pagina_margin_left() {
        return this.pagina.margin.left * this.multiplicador_pagina;
    }), _defineProperty(_computed, 'pagina_margin_right', function pagina_margin_right() {
        return this.pagina.margin.right * this.multiplicador_pagina;
    }), _defineProperty(_computed, 'tabEtiqueta', function tabEtiqueta() {
        return this.activeTab == 0;
    }), _defineProperty(_computed, 'tabPagina', function tabPagina() {
        return this.activeTab == 1;
    }), _computed),

    watch: {},

    beforeDestroy: function beforeDestroy() {},
    created: function created() {
        var _this2 = this;

        this.setFormat();

        if (this.dadosEtiqueta) {
            var conteudo = this.dadosEtiqueta.conteudo;
            this.pagina = conteudo.pagina;
            this.items = conteudo.items;
            this.etiqueta = conteudo.etiqueta;
        }

        //Salvando dados antigos do array
        this.items.map(function (item, i) {
            _this2.items_backup[i] = _extends({}, _this2.items[i]);
        });
        this.items_backup[0] = _extends({}, this.items[0]);
    }
}, 'mounted', function mounted() {
    this.fields = this.getFields();
}));

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_certificado_form__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tourguidejs__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tourguidejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_tourguidejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_alert_cert_vue__ = __webpack_require__(250);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AppCertificadoForm: __WEBPACK_IMPORTED_MODULE_0__app_certificado_form__["a" /* default */], Tourguide: __WEBPACK_IMPORTED_MODULE_3_tourguidejs___default.a, AlertCert: __WEBPACK_IMPORTED_MODULE_5__components_alert_cert_vue__["a" /* default */]
  },

  props: {
    codfil: [String, Number],
    disableBtnVoltar: [Boolean]
  },

  data: function data() {
    return {
      errmessages: null,
      passo: 'inicio',
      tipoCertificado: '',
      port: null,
      url: Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["urlORDS"])(this.$store, 'certificado/'),
      configurandoA3: false,
      testandoA3: false,
      filial: null,
      lCodfil: null,
      procurandoCertificado: '',
      procurandoCertificado2: '',
      titleValidacaoCertificado: '',
      guiaConfiguracao: false,

      steps: [{
        "selector": "",
        "step": 1,
        "title": 'Vamos come\xE7ar!',
        "content": "Vamos te guiar passo a passo por todo o processo de Vinculação de Certificado Digital.</br></br><a href='javascript:void(0)' class='btn btn-sm btn-danger text-white' onclick='window.dispatchEvent(new CustomEvent(\"desativar-guia\"))'>Não mostrar este guia</a>"
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#tipocertificado",
        "step": 2,
        "title": 'Tipo de Certificado',
        "content": "Informe o tipo do seu certificado."
        // "image": "https://somehost.com/image.jpeg"
      }]

    };
  },


  computed: {
    showForm: function showForm() {
      if (this.filial) return true;else return false;
    },

    diasvalidade: function diasvalidade() {
      if (this.filial && this.filial.certificado && this.filial.certificado.length > 0 && this.filial.certificado[0].dtval) return this.$daysBetween(this.$getDate(), this.filial.certificado[0].dtval);else return 0;
    },

    certificadoVinculado: function certificadoVinculado() {
      return Boolean(this.filial && Array.isArray(this.filial.certificado) && this.filial.certificado.length > 0);
    },
    validadeDisponivel: function validadeDisponivel() {
      return Boolean(this.certificadoVinculado && this.filial.certificado[0].dtval);
    },
    certificadosVenda: function certificadosVenda() {
      if (!this.validadeDisponivel) return [];
      var validade = this.diasvalidade === 0 ? 1 : this.diasvalidade;
      return [{ validade: validade, dtval: this.filial.certificado[0].dtval }];
    },
    statusCertificado: function statusCertificado() {
      if (!this.certificadoVinculado) return 'pendente';
      if (!this.validadeDisponivel) return 'indisponivel';
      if (this.diasvalidade < 0) return 'vencido';
      if (this.diasvalidade === 0) return 'vence-hoje';
      if (this.diasvalidade <= 30) return 'proximo';
      return 'valido';
    },
    statusCertificadoTitulo: function statusCertificadoTitulo() {
      var titulos = {
        pendente: 'Certificado não configurado',
        valido: 'Certificado válido',
        proximo: 'Certificado próximo do vencimento',
        'vence-hoje': 'Certificado vence hoje',
        vencido: 'Certificado vencido',
        indisponivel: 'Validade não disponível'
      };
      return titulos[this.statusCertificado];
    },
    statusCertificadoLabel: function statusCertificadoLabel() {
      var labels = {
        pendente: 'Pendente',
        valido: 'Ativo',
        proximo: 'Atenção',
        'vence-hoje': 'Vence hoje',
        vencido: 'Vencido',
        indisponivel: 'Verifique os dados'
      };
      return labels[this.statusCertificado];
    },
    statusCertificadoIcone: function statusCertificadoIcone() {
      var icones = {
        pendente: 'fa-exclamation-circle',
        valido: 'fa-check-circle',
        proximo: 'fa-clock-o',
        'vence-hoje': 'fa-exclamation-triangle',
        vencido: 'fa-times-circle',
        indisponivel: 'fa-question-circle'
      };
      return icones[this.statusCertificado];
    },
    validadeCertificadoTexto: function validadeCertificadoTexto() {
      if (!this.validadeDisponivel) return '';
      if (this.diasvalidade < 0) {
        var dias = Math.ceil(Math.abs(this.diasvalidade));
        return 'Vencido há ' + dias + (dias === 1 ? ' dia' : ' dias');
      }
      if (this.diasvalidade === 0) return 'Vence hoje';
      return 'Vence em ' + Math.ceil(this.diasvalidade) + ' dias';
    },
    progressoValidade: function progressoValidade() {
      if (!this.validadeDisponivel || this.diasvalidade <= 0) return 0;
      return Math.min(100, Math.max(1, Math.round(this.diasvalidade / 365 * 100)));
    },


    showGuia: function showGuia() {
      return __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].guia;
    }

  },

  watch: {
    codfil: function codfil() {
      // AO SELECIONA A FILIAL
    }
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.tipoCertificado = '';
      this.$scrollTo(0);
      this.loadFilial();
    },
    handleEmpresaRedirect: function handleEmpresaRedirect() {
      this.$router.push('/filiallist');
    },
    handleAtivarExtensao: function handleAtivarExtensao() {
      window.open('https://chrome.google.com/webstore/detail/nota-brasil-a3/epmndncpbbgiclhagbgoienhimkjhdck', "_blank");
      if (!this.param == 'extension') this.passo = 'downloadA3';
    },
    handleDownloadA3: function handleDownloadA3() {
      window.open('https://novo.notabrasil.com.br/com.notabrasil.a3.exe', "_blank");
      if (this.passo != 'extension') this.passo = 'concluido';
    },
    handleVoltarListaNF: function handleVoltarListaNF() {
      this.$router.go(-1);
    },
    handleConcluiA3: function handleConcluiA3() {
      this.loadFilial();
    },
    handleCheckExtensionA3: function handleCheckExtensionA3() {
      //CHECA SE A EXTENSAO ESTÁ INSTALADA
      this.$checkExtensaoChromeA3(this.callBackExtensionA3);
    },
    handleTestarA3: function handleTestarA3() {
      //CHECA SE A EXTENSAO ESTÁ INSTALADA
      this.$certificadoTesteA3(this.callBackTesteA3);
    },
    handleVoltar: function handleVoltar(voltar) {
      if (voltar == 'closeform') {
        this.$emit('closeform');
      }
    },
    callBackExtensionA3: function callBackExtensionA3(response) {
      console.log('callBackExtensionA3');
      console.log(response);
      //CALLBACK COM RESPOSTA SE A EXTENSAO ESTÁ INSTALADA
      if (response && response.status == 'success') {
        this.titleValidacaoCertificado = 'Validando o Certificado A3...';
        this.procurandoCertificado = 'Tentando localizar um certificado digital neste computador...';
        this.procurandoCertificado2 = 'Caso a tela para seleção do certificados não abra, certifique-se de que o módulo tenha sido corretamente instalado.';
        this.testandoA3 = true;
        this.handleTestarA3();
      } else {
        this.configurandoA3 = true;
      }
    },
    callBackTesteA3: function callBackTesteA3(response) {
      //EFETUA TESTE NO CERTIFICADO A3
      //O TESTE RETORNA response.data COM A DATA DE VALIDADE DO CERTIFICADO
      console.log('callBackExtensionA3');
      console.log(response);

      if (!response) {
        return; //FALTA EXIBIR PAGINA DE ERRO OU TENTAR NOVAMENTE
      }
      if (response.status == 'success') {
        this.titleValidacaoCertificado = 'Configuração Finalizada';
        this.procurandoCertificado2 = '';
        this.apiPostCertificado(response);
      }
      if (response.status == 'error') {
        this.titleValidacaoCertificado = 'Erro...';
        this.procurandoCertificado = response.message;
        this.procurandoCertificado2 = 'O certificado não foi configurado.';
      }
    },
    apiPostCertificado: function apiPostCertificado(response) {
      //EFETUA O UPLOAD DO CERTIFICADO COMO TIPO A3 APOS TER EFETUADO A VALIDACAO ATRAVÉS DA EXTENSAO

      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.url, null, {
        headers: {
          // 'Content-Type': 'multipart/form-data',
          'filial': this.filial.codfil,
          'tpcertificado': 'A3',
          'data': response.response.validade, //data de validade
          'nome': response.response.nome //nome
        }
      }).then(function (data) {
        if (data.items) {}
        self.$store.dispatch('loadSessao', self); //ATUALIZA A SESSAO COM O CERTIFICADO INSTALADO
        self.loadFilial();
      }).catch(function (data) {
        self.testandoA3 = false;
        self.$erpToastError('Erro ao carregar o certificado: ' + data.message);
      });
    },
    loadFilial: function loadFilial() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //CARREGA AS INFORMAÇÕES PARA CONFIGURACAO DO CERTIFICADO
                _this.testandoA3 = false;
                _this.configurandoA3 = false;
                _this.passo = 'inicio';
                _context.next = 5;
                return _this.$store.dispatch('loadFilial', { id: _this.lCodfil });

              case 5:
                if (_this.$store.getters.getFilial) {
                  _this.filial = _extends({}, _this.$store.getters.getFilial);
                  if (Array.isArray(_this.filial.certificado) && _this.filial.certificado.length > 0) {
                    _this.tipoCertificado = _this.filial.certificado[0].tipocertificado;
                    if (_this.filial.certificado[0].filename) {
                      _this.tipoCertificado = 'A1';
                    } else {
                      _this.tipoCertificado = 'A3';
                    }
                  }
                }

                if (!_this.filial) {
                  //exibe mensagem para cadastrar uma filial quando nao encontrar a filial
                  _this.passo = 'empresa';
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var param, tourguide;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:

              //CHECA OS PARAMETROS RECEBIDOS DA ROTA
              param = null;

              if (_this2.codfil) param = _this2.codfil;

              if (!param && _this2.$route.params && _this2.$route.params.param) {
                param = _this2.$route.params.param;
              }

              if (!(param == 'extension')) {
                _context2.next = 9;
                break;
              }

              //EXIGE A INSTALACAO OU A ATUALIZACAO DA EXTENSAO
              _this2.passo = 'extension';
              _this2.$scrollTo(0);
              return _context2.abrupt('return');

            case 9:
              if (param != null) {
                _this2.lCodfil = param;
              } else {
                _this2.lCodfil = _this2.codfil;
              }

            case 10:
              _context2.next = 12;
              return _this2.loadFilial();

            case 12:
              if (!_this2.filial) {
                _context2.next = 17;
                break;
              }

              _this2.passo = 'inicio';
              if (_this2.showGuia && _this2.steps.length > 0 && !_this2.certificadoVinculado) {
                tourguide = new __WEBPACK_IMPORTED_MODULE_3_tourguidejs___default.a({
                  steps: _this2.steps
                });


                tourguide.start();
              }

              _context2.next = 19;
              break;

            case 17:
              _this2.passo = 'empresa';
              return _context2.abrupt('return');

            case 19:
              _this2.$scrollTo(0);

            case 20:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  created: function created() {}
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        filial: {}
    },

    data: function data() {
        return {
            certificado: [],
            metadata: this.$store.getters.getEntities.metadata,
            message: null, //armazena as mensagens de validacao do servidor para mostrar em tela
            selectedFile: {},
            urlFile: '',
            url: Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["urlORDS"])(this.$store, 'certificado/'),
            imageStatus: 'empty',
            senha1: '',
            tipoCertificado: 'A1',
            configurarNovoCertificado: true
        };
    },


    computed: {
        status: function status() {
            return '';
        }
    },

    methods: {
        data: function data(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatDate"])(value);
        },
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        uploadCert: function uploadCert() {
            //EFETUA O UPLOAD DO CERTIFICADO

            var formData = new FormData();
            formData.append('file', this.selectedFile);

            var self = this;
            this.message = null;

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'filial': this.filial.codfil,
                    'password': this.senha1,
                    'filename': this.selectedFile.name,
                    'tpcertificado': 'A1'
                }
            }).then(function (data) {
                if (data.data.result == 'error') {
                    self.message = data.data.message;
                    //self.$erpToastError(data.data.message)
                    return;
                }
                self.imageStatus = 'ok';
                // if (data.items) {
                //     self.certificado = data.items
                // }
                self.$store.dispatch('loadSessao', self); //ATUALIZA A SESSAO COM O CERTIFICADO INSTALADO
                self.$erpToastSuccess('O certificado foi atualizado com sucesso.');
                self.$emit('refresh');
            }).catch(function (data) {
                self.imageStatus = 'error';
            });
        },
        handleFileSelectBtn: function handleFileSelectBtn() {
            //BOTAO SELECIONAR ARQUIVO
            this.$refs.file.click();
        },
        handleSend: function handleSend() {
            if (this.senha1 == '') {
                alert('Informe a senha');
                return;
            }
            if (!this.selectedFile.name) {
                this.$erpToastError('Selecione um arquivo para continuar');
                return;
            }
            this.uploadCert();
        },
        handleDeleteFile: function handleDeleteFile() {
            //REMOVE O CERTIFICADO
            this.selectedFile = {};
            if (this.certificado.length > 0) {
                this.apiDelete();
            }
        },
        handleFileUpload: function handleFileUpload() {
            //EVENTO AO SELECIONAR ARQUIVO
            this.selectedFile = this.$refs.file.files[0];
            this.$nextTick(function () {
                this.$refs.senha.focus();
            });
        },
        handleDownloadA3: function handleDownloadA3() {
            window.open('https://novo.notabrasil.com.br/com.notabrasil.a3.exe', "_blank");
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //CARREGA OS DADOS DO CERTIFICADO DA FILIAL
                                _this.certificado = [];
                                _this.configurarNovoCertificado = _this.filial.certificado.length == 0;

                                if (!(_this.filial.certificado.length > 0)) {
                                    _context.next = 7;
                                    break;
                                }

                                _context.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDS"])(_this.url + _this.filial.certificado[0].codcertificado, {});

                            case 5:
                                data = _context.sent;

                                if (data.items) {
                                    _this.certificado = data.items;
                                }

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //EFETUA A EXCLUSAO DO CERTIFICADO
                                modulo = 'certificado/' + _this2.certificado[0].codcertificado;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSdelete"])(_this2.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this2.$erpToastSuccess('O certificado foi removido com sucesso.');
                                _this2.certificado = [];
                                _this2.$emit('refresh');

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    },

    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.loadData();
        this.selectedFile = '';
    }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_alert_cert_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0373086a_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_alert_cert_vue__ = __webpack_require__(1067);
function injectStyle (ssrContext) {
  __webpack_require__(1062)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0373086a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_alert_cert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0373086a_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_alert_cert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_guia_step_svg_vue__ = __webpack_require__(163);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    GuiaStepSvg: __WEBPACK_IMPORTED_MODULE_0__dashboards_guia_step_svg_vue__["a" /* default */]
  },

  props: {
    certificados: Array
  },

  data: function data() {
    return {};
  },


  methods: {
    handleQueroCertificadoDigital: function handleQueroCertificadoDigital() {
      window.open('https://www.notabrasil.com.br/certificado-digital/#plans', '_blank');
    }
  },

  computed: {
    mensagem: function mensagem() {
      if (!this.certificados || this.certificados.length == 0) {
        return 1;
      } else if (this.certificados[0].validade <= 0) {
        return 2; //vencido
      } else if (this.certificados[0].validade <= 15) {
        return 3; //vencimento proximo
      } else return 0;
    }
  },

  created: function created() {},
  mounted: function mounted() {}
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "guia-step-svg",
  props: {
    step: {
      type: String,
      required: true
    },
    completed: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},

  data: function data() {
    return {
      errmessages: null, //armazena as mensagens de validacao do servidor para mostrar em tela

      minimizado: true,

      currVideo: null,

      listVideos: [
      // { app: 'nfe', title: 'Visão geral do nota brasil NF-e *****', url: '//www.youtube.com/embed/z0G5S0hxV4k'},
      { app: 'nfe', title: 'Configurar a empresa', url: '//www.youtube.com/embed/9aM1WjYSGjg' }, { app: 'nfe', title: 'Configurar o certificado digital A1', url: '//www.youtube.com/embed/SWB17DsnAVM' }, { app: 'nfe', title: 'Configurar o certificado digital A3', url: '//www.youtube.com/embed/Cnd3KgC9VsQ' }, { app: 'nfe', title: 'Cadastrar um produto', url: '//www.youtube.com/embed/p7ifHw3lvx4' }, { app: 'nfe', title: 'Importar cadastro de produtos', url: '//www.youtube.com/embed/jp75E6ezdpI' }, { app: 'nfe', title: 'Produtos e configuração de impostos', url: '//www.youtube.com/embed/gjwdNe3q8AM' }, { app: 'nfe', title: 'Cadastrar um cliente', url: '//www.youtube.com/embed/63sscsQRLgY' }, { app: 'nfe', title: 'Importar cadastro de clientes e fornecedores', url: '//www.youtube.com/embed/eGD9DaZWoBc' }, { app: 'nfe', title: 'Configurar regras de ICMS', url: '//www.youtube.com/embed/d4AgTK11q_s' }, { app: 'nfe', title: 'Lançar uma venda', url: '//www.youtube.com/embed/QJC0ZLvBavc' }, { app: 'nfe', title: 'Emitir uma nota fiscal', url: '//www.youtube.com/embed/sLgbQ0ZW2AQ' }, { app: 'forcaVendas', title: 'Configurar os usuários', url: '//www.youtube.com/embed/kbZ9kTtajIA' }]
    };
  },


  computed: {
    guiaList: function guiaList() {
      var _this = this;

      return this.listVideos.filter(function (obj) {
        return obj.app == _this.app;
      });
    },

    app: function app() {
      if (__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appNFe) return 'nfe';else if (__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appForcaVendas) return 'forcaVendas';
    },

    guia: function guia() {
      return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].guia;
    }
  },

  methods: {
    apiPost: function apiPost() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, ativacao;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // var params = '?uuid=' + SysVars.uuid
                data = null;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSapp"])(_this2, 'usuario/guia/', 'post', data);

              case 3:
                ativacao = _context.sent;

                _this2.$appLoading(false);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleCloseVideo: function handleCloseVideo(index) {
      this.currVideo = null;
    },
    handleShowVideo: function handleShowVideo(index) {
      this.currVideo = this.guiaList[index].url;
    },
    handleMinimizar: function handleMinimizar() {
      this.minimizado = !this.minimizado;
      if (__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].guia) {
        this.apiPost();
        __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].guia = false;
      }
    },
    handleFecharGuia: function handleFecharGuia() {
      this.apiPost();
      __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].guia = false;
    }
  },

  watch: {
    guia: function guia(value) {
      if (value) this.minimizado = false;
    }
  },

  components: {},

  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
  },
  created: function created() {}
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: {
    mensagemAdicioneUsuarios: function mensagemAdicioneUsuarios() {
      if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].limiteUsuariosAlcancado && __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appForcaVendas) return true;else return false;
    },
    mensagem: function mensagem() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].limitePlanoMensagem;
    }
  },
  created: function created() {
    this.$router.push('/minhaconta');
  },
  mounted: function mounted() {},

  methods: {
    handleCloseButton: function handleCloseButton() {
      __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].showLimitePlano = false;
      __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].limiteUsuariosAlcancado = false;
    },
    handleMinhaConta: function handleMinhaConta() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].showLimitePlano = false;
                __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].limiteUsuariosAlcancado = false;

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  * Bootstrap v4.6.2 (https://getbootstrap.com/)
  * Copyright 2011-2022 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
(function (global, factory) {
  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports, __webpack_require__(56), __webpack_require__(256)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(56), __webpack_require__(256)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.bootstrap = {}, global.jQuery, global.Popper));
})(undefined, function (exports, $, Popper) {
  'use strict';

  function _interopDefaultLegacy(e) {
    return e && (typeof e === 'undefined' ? 'undefined' : _typeof(e)) === 'object' && 'default' in e ? e : { 'default': e };
  }

  var $__default = /*#__PURE__*/_interopDefaultLegacy($);
  var Popper__default = /*#__PURE__*/_interopDefaultLegacy(Popper);

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };
    return _extends.apply(this, arguments);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;

    _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.2): util.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  /**
   * Private TransitionEnd Helpers
   */

  var TRANSITION_END = 'transitionend';
  var MAX_UID = 1000000;
  var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)

  function toType(obj) {
    if (obj === null || typeof obj === 'undefined') {
      return "" + obj;
    }

    return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
  }

  function getSpecialTransitionEndEvent() {
    return {
      bindType: TRANSITION_END,
      delegateType: TRANSITION_END,
      handle: function handle(event) {
        if ($__default["default"](event.target).is(this)) {
          return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
        }

        return undefined;
      }
    };
  }

  function transitionEndEmulator(duration) {
    var _this = this;

    var called = false;
    $__default["default"](this).one(Util.TRANSITION_END, function () {
      called = true;
    });
    setTimeout(function () {
      if (!called) {
        Util.triggerTransitionEnd(_this);
      }
    }, duration);
    return this;
  }

  function setTransitionEndSupport() {
    $__default["default"].fn.emulateTransitionEnd = transitionEndEmulator;
    $__default["default"].event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
  }
  /**
   * Public Util API
   */

  var Util = {
    TRANSITION_END: 'bsTransitionEnd',
    getUID: function getUID(prefix) {
      do {
        // eslint-disable-next-line no-bitwise
        prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
      } while (document.getElementById(prefix));

      return prefix;
    },
    getSelectorFromElement: function getSelectorFromElement(element) {
      var selector = element.getAttribute('data-target');

      if (!selector || selector === '#') {
        var hrefAttr = element.getAttribute('href');
        selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : '';
      }

      try {
        return document.querySelector(selector) ? selector : null;
      } catch (_) {
        return null;
      }
    },
    getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
      if (!element) {
        return 0;
      } // Get transition-duration of the element


      var transitionDuration = $__default["default"](element).css('transition-duration');
      var transitionDelay = $__default["default"](element).css('transition-delay');
      var floatTransitionDuration = parseFloat(transitionDuration);
      var floatTransitionDelay = parseFloat(transitionDelay); // Return 0 if element or transition duration is not found

      if (!floatTransitionDuration && !floatTransitionDelay) {
        return 0;
      } // If multiple durations are defined, take the first


      transitionDuration = transitionDuration.split(',')[0];
      transitionDelay = transitionDelay.split(',')[0];
      return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    },
    reflow: function reflow(element) {
      return element.offsetHeight;
    },
    triggerTransitionEnd: function triggerTransitionEnd(element) {
      $__default["default"](element).trigger(TRANSITION_END);
    },
    supportsTransitionEnd: function supportsTransitionEnd() {
      return Boolean(TRANSITION_END);
    },
    isElement: function isElement(obj) {
      return (obj[0] || obj).nodeType;
    },
    typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
      for (var property in configTypes) {
        if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
          var expectedTypes = configTypes[property];
          var value = config[property];
          var valueType = value && Util.isElement(value) ? 'element' : toType(value);

          if (!new RegExp(expectedTypes).test(valueType)) {
            throw new Error(componentName.toUpperCase() + ": " + ("Option \"" + property + "\" provided type \"" + valueType + "\" ") + ("but expected type \"" + expectedTypes + "\"."));
          }
        }
      }
    },
    findShadowRoot: function findShadowRoot(element) {
      if (!document.documentElement.attachShadow) {
        return null;
      } // Can find the shadow root otherwise it'll return the document


      if (typeof element.getRootNode === 'function') {
        var root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
      }

      if (element instanceof ShadowRoot) {
        return element;
      } // when we don't find a shadow root


      if (!element.parentNode) {
        return null;
      }

      return Util.findShadowRoot(element.parentNode);
    },
    jQueryDetection: function jQueryDetection() {
      if (typeof $__default["default"] === 'undefined') {
        throw new TypeError('Bootstrap\'s JavaScript requires jQuery. jQuery must be included before Bootstrap\'s JavaScript.');
      }

      var version = $__default["default"].fn.jquery.split(' ')[0].split('.');
      var minMajor = 1;
      var ltMajor = 2;
      var minMinor = 9;
      var minPatch = 1;
      var maxMajor = 4;

      if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) {
        throw new Error('Bootstrap\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0');
      }
    }
  };
  Util.jQueryDetection();
  setTransitionEndSupport();

  /**
   * Constants
   */

  var NAME$a = 'alert';
  var VERSION$a = '4.6.2';
  var DATA_KEY$a = 'bs.alert';
  var EVENT_KEY$a = "." + DATA_KEY$a;
  var DATA_API_KEY$7 = '.data-api';
  var JQUERY_NO_CONFLICT$a = $__default["default"].fn[NAME$a];
  var CLASS_NAME_ALERT = 'alert';
  var CLASS_NAME_FADE$5 = 'fade';
  var CLASS_NAME_SHOW$7 = 'show';
  var EVENT_CLOSE = "close" + EVENT_KEY$a;
  var EVENT_CLOSED = "closed" + EVENT_KEY$a;
  var EVENT_CLICK_DATA_API$6 = "click" + EVENT_KEY$a + DATA_API_KEY$7;
  var SELECTOR_DISMISS = '[data-dismiss="alert"]';
  /**
   * Class definition
   */

  var Alert = /*#__PURE__*/function () {
    function Alert(element) {
      this._element = element;
    } // Getters


    var _proto = Alert.prototype;

    // Public
    _proto.close = function close(element) {
      var rootElement = this._element;

      if (element) {
        rootElement = this._getRootElement(element);
      }

      var customEvent = this._triggerCloseEvent(rootElement);

      if (customEvent.isDefaultPrevented()) {
        return;
      }

      this._removeElement(rootElement);
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$a);
      this._element = null;
    } // Private
    ;

    _proto._getRootElement = function _getRootElement(element) {
      var selector = Util.getSelectorFromElement(element);
      var parent = false;

      if (selector) {
        parent = document.querySelector(selector);
      }

      if (!parent) {
        parent = $__default["default"](element).closest("." + CLASS_NAME_ALERT)[0];
      }

      return parent;
    };

    _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
      var closeEvent = $__default["default"].Event(EVENT_CLOSE);
      $__default["default"](element).trigger(closeEvent);
      return closeEvent;
    };

    _proto._removeElement = function _removeElement(element) {
      var _this = this;

      $__default["default"](element).removeClass(CLASS_NAME_SHOW$7);

      if (!$__default["default"](element).hasClass(CLASS_NAME_FADE$5)) {
        this._destroyElement(element);

        return;
      }

      var transitionDuration = Util.getTransitionDurationFromElement(element);
      $__default["default"](element).one(Util.TRANSITION_END, function (event) {
        return _this._destroyElement(element, event);
      }).emulateTransitionEnd(transitionDuration);
    };

    _proto._destroyElement = function _destroyElement(element) {
      $__default["default"](element).detach().trigger(EVENT_CLOSED).remove();
    } // Static
    ;

    Alert._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $__default["default"](this);
        var data = $element.data(DATA_KEY$a);

        if (!data) {
          data = new Alert(this);
          $element.data(DATA_KEY$a, data);
        }

        if (config === 'close') {
          data[config](this);
        }
      });
    };

    Alert._handleDismiss = function _handleDismiss(alertInstance) {
      return function (event) {
        if (event) {
          event.preventDefault();
        }

        alertInstance.close(this);
      };
    };

    _createClass(Alert, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$a;
      }
    }]);

    return Alert;
  }();
  /**
   * Data API implementation
   */

  $__default["default"](document).on(EVENT_CLICK_DATA_API$6, SELECTOR_DISMISS, Alert._handleDismiss(new Alert()));
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$a] = Alert._jQueryInterface;
  $__default["default"].fn[NAME$a].Constructor = Alert;

  $__default["default"].fn[NAME$a].noConflict = function () {
    $__default["default"].fn[NAME$a] = JQUERY_NO_CONFLICT$a;
    return Alert._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$9 = 'button';
  var VERSION$9 = '4.6.2';
  var DATA_KEY$9 = 'bs.button';
  var EVENT_KEY$9 = "." + DATA_KEY$9;
  var DATA_API_KEY$6 = '.data-api';
  var JQUERY_NO_CONFLICT$9 = $__default["default"].fn[NAME$9];
  var CLASS_NAME_ACTIVE$3 = 'active';
  var CLASS_NAME_BUTTON = 'btn';
  var CLASS_NAME_FOCUS = 'focus';
  var EVENT_CLICK_DATA_API$5 = "click" + EVENT_KEY$9 + DATA_API_KEY$6;
  var EVENT_FOCUS_BLUR_DATA_API = "focus" + EVENT_KEY$9 + DATA_API_KEY$6 + " " + ("blur" + EVENT_KEY$9 + DATA_API_KEY$6);
  var EVENT_LOAD_DATA_API$2 = "load" + EVENT_KEY$9 + DATA_API_KEY$6;
  var SELECTOR_DATA_TOGGLE_CARROT = '[data-toggle^="button"]';
  var SELECTOR_DATA_TOGGLES = '[data-toggle="buttons"]';
  var SELECTOR_DATA_TOGGLE$4 = '[data-toggle="button"]';
  var SELECTOR_DATA_TOGGLES_BUTTONS = '[data-toggle="buttons"] .btn';
  var SELECTOR_INPUT = 'input:not([type="hidden"])';
  var SELECTOR_ACTIVE$2 = '.active';
  var SELECTOR_BUTTON = '.btn';
  /**
   * Class definition
   */

  var Button = /*#__PURE__*/function () {
    function Button(element) {
      this._element = element;
      this.shouldAvoidTriggerChange = false;
    } // Getters


    var _proto = Button.prototype;

    // Public
    _proto.toggle = function toggle() {
      var triggerChangeEvent = true;
      var addAriaPressed = true;
      var rootElement = $__default["default"](this._element).closest(SELECTOR_DATA_TOGGLES)[0];

      if (rootElement) {
        var input = this._element.querySelector(SELECTOR_INPUT);

        if (input) {
          if (input.type === 'radio') {
            if (input.checked && this._element.classList.contains(CLASS_NAME_ACTIVE$3)) {
              triggerChangeEvent = false;
            } else {
              var activeElement = rootElement.querySelector(SELECTOR_ACTIVE$2);

              if (activeElement) {
                $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$3);
              }
            }
          }

          if (triggerChangeEvent) {
            // if it's not a radio button or checkbox don't add a pointless/invalid checked property to the input
            if (input.type === 'checkbox' || input.type === 'radio') {
              input.checked = !this._element.classList.contains(CLASS_NAME_ACTIVE$3);
            }

            if (!this.shouldAvoidTriggerChange) {
              $__default["default"](input).trigger('change');
            }
          }

          input.focus();
          addAriaPressed = false;
        }
      }

      if (!(this._element.hasAttribute('disabled') || this._element.classList.contains('disabled'))) {
        if (addAriaPressed) {
          this._element.setAttribute('aria-pressed', !this._element.classList.contains(CLASS_NAME_ACTIVE$3));
        }

        if (triggerChangeEvent) {
          $__default["default"](this._element).toggleClass(CLASS_NAME_ACTIVE$3);
        }
      }
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$9);
      this._element = null;
    } // Static
    ;

    Button._jQueryInterface = function _jQueryInterface(config, avoidTriggerChange) {
      return this.each(function () {
        var $element = $__default["default"](this);
        var data = $element.data(DATA_KEY$9);

        if (!data) {
          data = new Button(this);
          $element.data(DATA_KEY$9, data);
        }

        data.shouldAvoidTriggerChange = avoidTriggerChange;

        if (config === 'toggle') {
          data[config]();
        }
      });
    };

    _createClass(Button, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$9;
      }
    }]);

    return Button;
  }();
  /**
   * Data API implementation
   */

  $__default["default"](document).on(EVENT_CLICK_DATA_API$5, SELECTOR_DATA_TOGGLE_CARROT, function (event) {
    var button = event.target;
    var initialButton = button;

    if (!$__default["default"](button).hasClass(CLASS_NAME_BUTTON)) {
      button = $__default["default"](button).closest(SELECTOR_BUTTON)[0];
    }

    if (!button || button.hasAttribute('disabled') || button.classList.contains('disabled')) {
      event.preventDefault(); // work around Firefox bug #1540995
    } else {
      var inputBtn = button.querySelector(SELECTOR_INPUT);

      if (inputBtn && (inputBtn.hasAttribute('disabled') || inputBtn.classList.contains('disabled'))) {
        event.preventDefault(); // work around Firefox bug #1540995

        return;
      }

      if (initialButton.tagName === 'INPUT' || button.tagName !== 'LABEL') {
        Button._jQueryInterface.call($__default["default"](button), 'toggle', initialButton.tagName === 'INPUT');
      }
    }
  }).on(EVENT_FOCUS_BLUR_DATA_API, SELECTOR_DATA_TOGGLE_CARROT, function (event) {
    var button = $__default["default"](event.target).closest(SELECTOR_BUTTON)[0];
    $__default["default"](button).toggleClass(CLASS_NAME_FOCUS, /^focus(in)?$/.test(event.type));
  });
  $__default["default"](window).on(EVENT_LOAD_DATA_API$2, function () {
    // ensure correct active class is set to match the controls' actual values/states
    // find all checkboxes/readio buttons inside data-toggle groups
    var buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLES_BUTTONS));

    for (var i = 0, len = buttons.length; i < len; i++) {
      var button = buttons[i];
      var input = button.querySelector(SELECTOR_INPUT);

      if (input.checked || input.hasAttribute('checked')) {
        button.classList.add(CLASS_NAME_ACTIVE$3);
      } else {
        button.classList.remove(CLASS_NAME_ACTIVE$3);
      }
    } // find all button toggles


    buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$4));

    for (var _i = 0, _len = buttons.length; _i < _len; _i++) {
      var _button = buttons[_i];

      if (_button.getAttribute('aria-pressed') === 'true') {
        _button.classList.add(CLASS_NAME_ACTIVE$3);
      } else {
        _button.classList.remove(CLASS_NAME_ACTIVE$3);
      }
    }
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$9] = Button._jQueryInterface;
  $__default["default"].fn[NAME$9].Constructor = Button;

  $__default["default"].fn[NAME$9].noConflict = function () {
    $__default["default"].fn[NAME$9] = JQUERY_NO_CONFLICT$9;
    return Button._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$8 = 'carousel';
  var VERSION$8 = '4.6.2';
  var DATA_KEY$8 = 'bs.carousel';
  var EVENT_KEY$8 = "." + DATA_KEY$8;
  var DATA_API_KEY$5 = '.data-api';
  var JQUERY_NO_CONFLICT$8 = $__default["default"].fn[NAME$8];
  var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key

  var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key

  var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch

  var SWIPE_THRESHOLD = 40;
  var CLASS_NAME_CAROUSEL = 'carousel';
  var CLASS_NAME_ACTIVE$2 = 'active';
  var CLASS_NAME_SLIDE = 'slide';
  var CLASS_NAME_RIGHT = 'carousel-item-right';
  var CLASS_NAME_LEFT = 'carousel-item-left';
  var CLASS_NAME_NEXT = 'carousel-item-next';
  var CLASS_NAME_PREV = 'carousel-item-prev';
  var CLASS_NAME_POINTER_EVENT = 'pointer-event';
  var DIRECTION_NEXT = 'next';
  var DIRECTION_PREV = 'prev';
  var DIRECTION_LEFT = 'left';
  var DIRECTION_RIGHT = 'right';
  var EVENT_SLIDE = "slide" + EVENT_KEY$8;
  var EVENT_SLID = "slid" + EVENT_KEY$8;
  var EVENT_KEYDOWN = "keydown" + EVENT_KEY$8;
  var EVENT_MOUSEENTER = "mouseenter" + EVENT_KEY$8;
  var EVENT_MOUSELEAVE = "mouseleave" + EVENT_KEY$8;
  var EVENT_TOUCHSTART = "touchstart" + EVENT_KEY$8;
  var EVENT_TOUCHMOVE = "touchmove" + EVENT_KEY$8;
  var EVENT_TOUCHEND = "touchend" + EVENT_KEY$8;
  var EVENT_POINTERDOWN = "pointerdown" + EVENT_KEY$8;
  var EVENT_POINTERUP = "pointerup" + EVENT_KEY$8;
  var EVENT_DRAG_START = "dragstart" + EVENT_KEY$8;
  var EVENT_LOAD_DATA_API$1 = "load" + EVENT_KEY$8 + DATA_API_KEY$5;
  var EVENT_CLICK_DATA_API$4 = "click" + EVENT_KEY$8 + DATA_API_KEY$5;
  var SELECTOR_ACTIVE$1 = '.active';
  var SELECTOR_ACTIVE_ITEM = '.active.carousel-item';
  var SELECTOR_ITEM = '.carousel-item';
  var SELECTOR_ITEM_IMG = '.carousel-item img';
  var SELECTOR_NEXT_PREV = '.carousel-item-next, .carousel-item-prev';
  var SELECTOR_INDICATORS = '.carousel-indicators';
  var SELECTOR_DATA_SLIDE = '[data-slide], [data-slide-to]';
  var SELECTOR_DATA_RIDE = '[data-ride="carousel"]';
  var Default$7 = {
    interval: 5000,
    keyboard: true,
    slide: false,
    pause: 'hover',
    wrap: true,
    touch: true
  };
  var DefaultType$7 = {
    interval: '(number|boolean)',
    keyboard: 'boolean',
    slide: '(boolean|string)',
    pause: '(string|boolean)',
    wrap: 'boolean',
    touch: 'boolean'
  };
  var PointerType = {
    TOUCH: 'touch',
    PEN: 'pen'
  };
  /**
   * Class definition
   */

  var Carousel = /*#__PURE__*/function () {
    function Carousel(element, config) {
      this._items = null;
      this._interval = null;
      this._activeElement = null;
      this._isPaused = false;
      this._isSliding = false;
      this.touchTimeout = null;
      this.touchStartX = 0;
      this.touchDeltaX = 0;
      this._config = this._getConfig(config);
      this._element = element;
      this._indicatorsElement = this._element.querySelector(SELECTOR_INDICATORS);
      this._touchSupported = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
      this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent);

      this._addEventListeners();
    } // Getters


    var _proto = Carousel.prototype;

    // Public
    _proto.next = function next() {
      if (!this._isSliding) {
        this._slide(DIRECTION_NEXT);
      }
    };

    _proto.nextWhenVisible = function nextWhenVisible() {
      var $element = $__default["default"](this._element); // Don't call next when the page isn't visible
      // or the carousel or its parent isn't visible

      if (!document.hidden && $element.is(':visible') && $element.css('visibility') !== 'hidden') {
        this.next();
      }
    };

    _proto.prev = function prev() {
      if (!this._isSliding) {
        this._slide(DIRECTION_PREV);
      }
    };

    _proto.pause = function pause(event) {
      if (!event) {
        this._isPaused = true;
      }

      if (this._element.querySelector(SELECTOR_NEXT_PREV)) {
        Util.triggerTransitionEnd(this._element);
        this.cycle(true);
      }

      clearInterval(this._interval);
      this._interval = null;
    };

    _proto.cycle = function cycle(event) {
      if (!event) {
        this._isPaused = false;
      }

      if (this._interval) {
        clearInterval(this._interval);
        this._interval = null;
      }

      if (this._config.interval && !this._isPaused) {
        this._updateInterval();

        this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
      }
    };

    _proto.to = function to(index) {
      var _this = this;

      this._activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);

      var activeIndex = this._getItemIndex(this._activeElement);

      if (index > this._items.length - 1 || index < 0) {
        return;
      }

      if (this._isSliding) {
        $__default["default"](this._element).one(EVENT_SLID, function () {
          return _this.to(index);
        });
        return;
      }

      if (activeIndex === index) {
        this.pause();
        this.cycle();
        return;
      }

      var direction = index > activeIndex ? DIRECTION_NEXT : DIRECTION_PREV;

      this._slide(direction, this._items[index]);
    };

    _proto.dispose = function dispose() {
      $__default["default"](this._element).off(EVENT_KEY$8);
      $__default["default"].removeData(this._element, DATA_KEY$8);
      this._items = null;
      this._config = null;
      this._element = null;
      this._interval = null;
      this._isPaused = null;
      this._isSliding = null;
      this._activeElement = null;
      this._indicatorsElement = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default$7, config);
      Util.typeCheckConfig(NAME$8, config, DefaultType$7);
      return config;
    };

    _proto._handleSwipe = function _handleSwipe() {
      var absDeltax = Math.abs(this.touchDeltaX);

      if (absDeltax <= SWIPE_THRESHOLD) {
        return;
      }

      var direction = absDeltax / this.touchDeltaX;
      this.touchDeltaX = 0; // swipe left

      if (direction > 0) {
        this.prev();
      } // swipe right


      if (direction < 0) {
        this.next();
      }
    };

    _proto._addEventListeners = function _addEventListeners() {
      var _this2 = this;

      if (this._config.keyboard) {
        $__default["default"](this._element).on(EVENT_KEYDOWN, function (event) {
          return _this2._keydown(event);
        });
      }

      if (this._config.pause === 'hover') {
        $__default["default"](this._element).on(EVENT_MOUSEENTER, function (event) {
          return _this2.pause(event);
        }).on(EVENT_MOUSELEAVE, function (event) {
          return _this2.cycle(event);
        });
      }

      if (this._config.touch) {
        this._addTouchEventListeners();
      }
    };

    _proto._addTouchEventListeners = function _addTouchEventListeners() {
      var _this3 = this;

      if (!this._touchSupported) {
        return;
      }

      var start = function start(event) {
        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
          _this3.touchStartX = event.originalEvent.clientX;
        } else if (!_this3._pointerEvent) {
          _this3.touchStartX = event.originalEvent.touches[0].clientX;
        }
      };

      var move = function move(event) {
        // ensure swiping with one touch and not pinching
        _this3.touchDeltaX = event.originalEvent.touches && event.originalEvent.touches.length > 1 ? 0 : event.originalEvent.touches[0].clientX - _this3.touchStartX;
      };

      var end = function end(event) {
        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
          _this3.touchDeltaX = event.originalEvent.clientX - _this3.touchStartX;
        }

        _this3._handleSwipe();

        if (_this3._config.pause === 'hover') {
          // If it's a touch-enabled device, mouseenter/leave are fired as
          // part of the mouse compatibility events on first tap - the carousel
          // would stop cycling until user tapped out of it;
          // here, we listen for touchend, explicitly pause the carousel
          // (as if it's the second time we tap on it, mouseenter compat event
          // is NOT fired) and after a timeout (to allow for mouse compatibility
          // events to fire) we explicitly restart cycling
          _this3.pause();

          if (_this3.touchTimeout) {
            clearTimeout(_this3.touchTimeout);
          }

          _this3.touchTimeout = setTimeout(function (event) {
            return _this3.cycle(event);
          }, TOUCHEVENT_COMPAT_WAIT + _this3._config.interval);
        }
      };

      $__default["default"](this._element.querySelectorAll(SELECTOR_ITEM_IMG)).on(EVENT_DRAG_START, function (e) {
        return e.preventDefault();
      });

      if (this._pointerEvent) {
        $__default["default"](this._element).on(EVENT_POINTERDOWN, function (event) {
          return start(event);
        });
        $__default["default"](this._element).on(EVENT_POINTERUP, function (event) {
          return end(event);
        });

        this._element.classList.add(CLASS_NAME_POINTER_EVENT);
      } else {
        $__default["default"](this._element).on(EVENT_TOUCHSTART, function (event) {
          return start(event);
        });
        $__default["default"](this._element).on(EVENT_TOUCHMOVE, function (event) {
          return move(event);
        });
        $__default["default"](this._element).on(EVENT_TOUCHEND, function (event) {
          return end(event);
        });
      }
    };

    _proto._keydown = function _keydown(event) {
      if (/input|textarea/i.test(event.target.tagName)) {
        return;
      }

      switch (event.which) {
        case ARROW_LEFT_KEYCODE:
          event.preventDefault();
          this.prev();
          break;

        case ARROW_RIGHT_KEYCODE:
          event.preventDefault();
          this.next();
          break;
      }
    };

    _proto._getItemIndex = function _getItemIndex(element) {
      this._items = element && element.parentNode ? [].slice.call(element.parentNode.querySelectorAll(SELECTOR_ITEM)) : [];
      return this._items.indexOf(element);
    };

    _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
      var isNextDirection = direction === DIRECTION_NEXT;
      var isPrevDirection = direction === DIRECTION_PREV;

      var activeIndex = this._getItemIndex(activeElement);

      var lastItemIndex = this._items.length - 1;
      var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;

      if (isGoingToWrap && !this._config.wrap) {
        return activeElement;
      }

      var delta = direction === DIRECTION_PREV ? -1 : 1;
      var itemIndex = (activeIndex + delta) % this._items.length;
      return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
    };

    _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
      var targetIndex = this._getItemIndex(relatedTarget);

      var fromIndex = this._getItemIndex(this._element.querySelector(SELECTOR_ACTIVE_ITEM));

      var slideEvent = $__default["default"].Event(EVENT_SLIDE, {
        relatedTarget: relatedTarget,
        direction: eventDirectionName,
        from: fromIndex,
        to: targetIndex
      });
      $__default["default"](this._element).trigger(slideEvent);
      return slideEvent;
    };

    _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
      if (this._indicatorsElement) {
        var indicators = [].slice.call(this._indicatorsElement.querySelectorAll(SELECTOR_ACTIVE$1));
        $__default["default"](indicators).removeClass(CLASS_NAME_ACTIVE$2);

        var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];

        if (nextIndicator) {
          $__default["default"](nextIndicator).addClass(CLASS_NAME_ACTIVE$2);
        }
      }
    };

    _proto._updateInterval = function _updateInterval() {
      var element = this._activeElement || this._element.querySelector(SELECTOR_ACTIVE_ITEM);

      if (!element) {
        return;
      }

      var elementInterval = parseInt(element.getAttribute('data-interval'), 10);

      if (elementInterval) {
        this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
        this._config.interval = elementInterval;
      } else {
        this._config.interval = this._config.defaultInterval || this._config.interval;
      }
    };

    _proto._slide = function _slide(direction, element) {
      var _this4 = this;

      var activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);

      var activeElementIndex = this._getItemIndex(activeElement);

      var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);

      var nextElementIndex = this._getItemIndex(nextElement);

      var isCycling = Boolean(this._interval);
      var directionalClassName;
      var orderClassName;
      var eventDirectionName;

      if (direction === DIRECTION_NEXT) {
        directionalClassName = CLASS_NAME_LEFT;
        orderClassName = CLASS_NAME_NEXT;
        eventDirectionName = DIRECTION_LEFT;
      } else {
        directionalClassName = CLASS_NAME_RIGHT;
        orderClassName = CLASS_NAME_PREV;
        eventDirectionName = DIRECTION_RIGHT;
      }

      if (nextElement && $__default["default"](nextElement).hasClass(CLASS_NAME_ACTIVE$2)) {
        this._isSliding = false;
        return;
      }

      var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);

      if (slideEvent.isDefaultPrevented()) {
        return;
      }

      if (!activeElement || !nextElement) {
        // Some weirdness is happening, so we bail
        return;
      }

      this._isSliding = true;

      if (isCycling) {
        this.pause();
      }

      this._setActiveIndicatorElement(nextElement);

      this._activeElement = nextElement;
      var slidEvent = $__default["default"].Event(EVENT_SLID, {
        relatedTarget: nextElement,
        direction: eventDirectionName,
        from: activeElementIndex,
        to: nextElementIndex
      });

      if ($__default["default"](this._element).hasClass(CLASS_NAME_SLIDE)) {
        $__default["default"](nextElement).addClass(orderClassName);
        Util.reflow(nextElement);
        $__default["default"](activeElement).addClass(directionalClassName);
        $__default["default"](nextElement).addClass(directionalClassName);
        var transitionDuration = Util.getTransitionDurationFromElement(activeElement);
        $__default["default"](activeElement).one(Util.TRANSITION_END, function () {
          $__default["default"](nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(CLASS_NAME_ACTIVE$2);
          $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$2 + " " + orderClassName + " " + directionalClassName);
          _this4._isSliding = false;
          setTimeout(function () {
            return $__default["default"](_this4._element).trigger(slidEvent);
          }, 0);
        }).emulateTransitionEnd(transitionDuration);
      } else {
        $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$2);
        $__default["default"](nextElement).addClass(CLASS_NAME_ACTIVE$2);
        this._isSliding = false;
        $__default["default"](this._element).trigger(slidEvent);
      }

      if (isCycling) {
        this.cycle();
      }
    } // Static
    ;

    Carousel._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $__default["default"](this).data(DATA_KEY$8);

        var _config = _extends({}, Default$7, $__default["default"](this).data());

        if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
          _config = _extends({}, _config, config);
        }

        var action = typeof config === 'string' ? config : _config.slide;

        if (!data) {
          data = new Carousel(this, _config);
          $__default["default"](this).data(DATA_KEY$8, data);
        }

        if (typeof config === 'number') {
          data.to(config);
        } else if (typeof action === 'string') {
          if (typeof data[action] === 'undefined') {
            throw new TypeError("No method named \"" + action + "\"");
          }

          data[action]();
        } else if (_config.interval && _config.ride) {
          data.pause();
          data.cycle();
        }
      });
    };

    Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
      var selector = Util.getSelectorFromElement(this);

      if (!selector) {
        return;
      }

      var target = $__default["default"](selector)[0];

      if (!target || !$__default["default"](target).hasClass(CLASS_NAME_CAROUSEL)) {
        return;
      }

      var config = _extends({}, $__default["default"](target).data(), $__default["default"](this).data());

      var slideIndex = this.getAttribute('data-slide-to');

      if (slideIndex) {
        config.interval = false;
      }

      Carousel._jQueryInterface.call($__default["default"](target), config);

      if (slideIndex) {
        $__default["default"](target).data(DATA_KEY$8).to(slideIndex);
      }

      event.preventDefault();
    };

    _createClass(Carousel, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$8;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$7;
      }
    }]);

    return Carousel;
  }();
  /**
   * Data API implementation
   */

  $__default["default"](document).on(EVENT_CLICK_DATA_API$4, SELECTOR_DATA_SLIDE, Carousel._dataApiClickHandler);
  $__default["default"](window).on(EVENT_LOAD_DATA_API$1, function () {
    var carousels = [].slice.call(document.querySelectorAll(SELECTOR_DATA_RIDE));

    for (var i = 0, len = carousels.length; i < len; i++) {
      var $carousel = $__default["default"](carousels[i]);

      Carousel._jQueryInterface.call($carousel, $carousel.data());
    }
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$8] = Carousel._jQueryInterface;
  $__default["default"].fn[NAME$8].Constructor = Carousel;

  $__default["default"].fn[NAME$8].noConflict = function () {
    $__default["default"].fn[NAME$8] = JQUERY_NO_CONFLICT$8;
    return Carousel._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$7 = 'collapse';
  var VERSION$7 = '4.6.2';
  var DATA_KEY$7 = 'bs.collapse';
  var EVENT_KEY$7 = "." + DATA_KEY$7;
  var DATA_API_KEY$4 = '.data-api';
  var JQUERY_NO_CONFLICT$7 = $__default["default"].fn[NAME$7];
  var CLASS_NAME_SHOW$6 = 'show';
  var CLASS_NAME_COLLAPSE = 'collapse';
  var CLASS_NAME_COLLAPSING = 'collapsing';
  var CLASS_NAME_COLLAPSED = 'collapsed';
  var DIMENSION_WIDTH = 'width';
  var DIMENSION_HEIGHT = 'height';
  var EVENT_SHOW$4 = "show" + EVENT_KEY$7;
  var EVENT_SHOWN$4 = "shown" + EVENT_KEY$7;
  var EVENT_HIDE$4 = "hide" + EVENT_KEY$7;
  var EVENT_HIDDEN$4 = "hidden" + EVENT_KEY$7;
  var EVENT_CLICK_DATA_API$3 = "click" + EVENT_KEY$7 + DATA_API_KEY$4;
  var SELECTOR_ACTIVES = '.show, .collapsing';
  var SELECTOR_DATA_TOGGLE$3 = '[data-toggle="collapse"]';
  var Default$6 = {
    toggle: true,
    parent: ''
  };
  var DefaultType$6 = {
    toggle: 'boolean',
    parent: '(string|element)'
  };
  /**
   * Class definition
   */

  var Collapse = /*#__PURE__*/function () {
    function Collapse(element, config) {
      this._isTransitioning = false;
      this._element = element;
      this._config = this._getConfig(config);
      this._triggerArray = [].slice.call(document.querySelectorAll("[data-toggle=\"collapse\"][href=\"#" + element.id + "\"]," + ("[data-toggle=\"collapse\"][data-target=\"#" + element.id + "\"]")));
      var toggleList = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$3));

      for (var i = 0, len = toggleList.length; i < len; i++) {
        var elem = toggleList[i];
        var selector = Util.getSelectorFromElement(elem);
        var filterElement = [].slice.call(document.querySelectorAll(selector)).filter(function (foundElem) {
          return foundElem === element;
        });

        if (selector !== null && filterElement.length > 0) {
          this._selector = selector;

          this._triggerArray.push(elem);
        }
      }

      this._parent = this._config.parent ? this._getParent() : null;

      if (!this._config.parent) {
        this._addAriaAndCollapsedClass(this._element, this._triggerArray);
      }

      if (this._config.toggle) {
        this.toggle();
      }
    } // Getters


    var _proto = Collapse.prototype;

    // Public
    _proto.toggle = function toggle() {
      if ($__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) {
        this.hide();
      } else {
        this.show();
      }
    };

    _proto.show = function show() {
      var _this = this;

      if (this._isTransitioning || $__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) {
        return;
      }

      var actives;
      var activesData;

      if (this._parent) {
        actives = [].slice.call(this._parent.querySelectorAll(SELECTOR_ACTIVES)).filter(function (elem) {
          if (typeof _this._config.parent === 'string') {
            return elem.getAttribute('data-parent') === _this._config.parent;
          }

          return elem.classList.contains(CLASS_NAME_COLLAPSE);
        });

        if (actives.length === 0) {
          actives = null;
        }
      }

      if (actives) {
        activesData = $__default["default"](actives).not(this._selector).data(DATA_KEY$7);

        if (activesData && activesData._isTransitioning) {
          return;
        }
      }

      var startEvent = $__default["default"].Event(EVENT_SHOW$4);
      $__default["default"](this._element).trigger(startEvent);

      if (startEvent.isDefaultPrevented()) {
        return;
      }

      if (actives) {
        Collapse._jQueryInterface.call($__default["default"](actives).not(this._selector), 'hide');

        if (!activesData) {
          $__default["default"](actives).data(DATA_KEY$7, null);
        }
      }

      var dimension = this._getDimension();

      $__default["default"](this._element).removeClass(CLASS_NAME_COLLAPSE).addClass(CLASS_NAME_COLLAPSING);
      this._element.style[dimension] = 0;

      if (this._triggerArray.length) {
        $__default["default"](this._triggerArray).removeClass(CLASS_NAME_COLLAPSED).attr('aria-expanded', true);
      }

      this.setTransitioning(true);

      var complete = function complete() {
        $__default["default"](_this._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$6);
        _this._element.style[dimension] = '';

        _this.setTransitioning(false);

        $__default["default"](_this._element).trigger(EVENT_SHOWN$4);
      };

      var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
      var scrollSize = "scroll" + capitalizedDimension;
      var transitionDuration = Util.getTransitionDurationFromElement(this._element);
      $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      this._element.style[dimension] = this._element[scrollSize] + "px";
    };

    _proto.hide = function hide() {
      var _this2 = this;

      if (this._isTransitioning || !$__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) {
        return;
      }

      var startEvent = $__default["default"].Event(EVENT_HIDE$4);
      $__default["default"](this._element).trigger(startEvent);

      if (startEvent.isDefaultPrevented()) {
        return;
      }

      var dimension = this._getDimension();

      this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
      Util.reflow(this._element);
      $__default["default"](this._element).addClass(CLASS_NAME_COLLAPSING).removeClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$6);
      var triggerArrayLength = this._triggerArray.length;

      if (triggerArrayLength > 0) {
        for (var i = 0; i < triggerArrayLength; i++) {
          var trigger = this._triggerArray[i];
          var selector = Util.getSelectorFromElement(trigger);

          if (selector !== null) {
            var $elem = $__default["default"]([].slice.call(document.querySelectorAll(selector)));

            if (!$elem.hasClass(CLASS_NAME_SHOW$6)) {
              $__default["default"](trigger).addClass(CLASS_NAME_COLLAPSED).attr('aria-expanded', false);
            }
          }
        }
      }

      this.setTransitioning(true);

      var complete = function complete() {
        _this2.setTransitioning(false);

        $__default["default"](_this2._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE).trigger(EVENT_HIDDEN$4);
      };

      this._element.style[dimension] = '';
      var transitionDuration = Util.getTransitionDurationFromElement(this._element);
      $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
    };

    _proto.setTransitioning = function setTransitioning(isTransitioning) {
      this._isTransitioning = isTransitioning;
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$7);
      this._config = null;
      this._parent = null;
      this._element = null;
      this._triggerArray = null;
      this._isTransitioning = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default$6, config);
      config.toggle = Boolean(config.toggle); // Coerce string values

      Util.typeCheckConfig(NAME$7, config, DefaultType$6);
      return config;
    };

    _proto._getDimension = function _getDimension() {
      var hasWidth = $__default["default"](this._element).hasClass(DIMENSION_WIDTH);
      return hasWidth ? DIMENSION_WIDTH : DIMENSION_HEIGHT;
    };

    _proto._getParent = function _getParent() {
      var _this3 = this;

      var parent;

      if (Util.isElement(this._config.parent)) {
        parent = this._config.parent; // It's a jQuery object

        if (typeof this._config.parent.jquery !== 'undefined') {
          parent = this._config.parent[0];
        }
      } else {
        parent = document.querySelector(this._config.parent);
      }

      var selector = "[data-toggle=\"collapse\"][data-parent=\"" + this._config.parent + "\"]";
      var children = [].slice.call(parent.querySelectorAll(selector));
      $__default["default"](children).each(function (i, element) {
        _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
      });
      return parent;
    };

    _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
      var isOpen = $__default["default"](element).hasClass(CLASS_NAME_SHOW$6);

      if (triggerArray.length) {
        $__default["default"](triggerArray).toggleClass(CLASS_NAME_COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
      }
    } // Static
    ;

    Collapse._getTargetFromElement = function _getTargetFromElement(element) {
      var selector = Util.getSelectorFromElement(element);
      return selector ? document.querySelector(selector) : null;
    };

    Collapse._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $__default["default"](this);
        var data = $element.data(DATA_KEY$7);

        var _config = _extends({}, Default$6, $element.data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});

        if (!data && _config.toggle && typeof config === 'string' && /show|hide/.test(config)) {
          _config.toggle = false;
        }

        if (!data) {
          data = new Collapse(this, _config);
          $element.data(DATA_KEY$7, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Collapse, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$7;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$6;
      }
    }]);

    return Collapse;
  }();
  /**
   * Data API implementation
   */

  $__default["default"](document).on(EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function (event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.currentTarget.tagName === 'A') {
      event.preventDefault();
    }

    var $trigger = $__default["default"](this);
    var selector = Util.getSelectorFromElement(this);
    var selectors = [].slice.call(document.querySelectorAll(selector));
    $__default["default"](selectors).each(function () {
      var $target = $__default["default"](this);
      var data = $target.data(DATA_KEY$7);
      var config = data ? 'toggle' : $trigger.data();

      Collapse._jQueryInterface.call($target, config);
    });
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$7] = Collapse._jQueryInterface;
  $__default["default"].fn[NAME$7].Constructor = Collapse;

  $__default["default"].fn[NAME$7].noConflict = function () {
    $__default["default"].fn[NAME$7] = JQUERY_NO_CONFLICT$7;
    return Collapse._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$6 = 'dropdown';
  var VERSION$6 = '4.6.2';
  var DATA_KEY$6 = 'bs.dropdown';
  var EVENT_KEY$6 = "." + DATA_KEY$6;
  var DATA_API_KEY$3 = '.data-api';
  var JQUERY_NO_CONFLICT$6 = $__default["default"].fn[NAME$6];
  var ESCAPE_KEYCODE$1 = 27; // KeyboardEvent.which value for Escape (Esc) key

  var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key

  var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key

  var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key

  var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key

  var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)

  var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE$1);
  var CLASS_NAME_DISABLED$1 = 'disabled';
  var CLASS_NAME_SHOW$5 = 'show';
  var CLASS_NAME_DROPUP = 'dropup';
  var CLASS_NAME_DROPRIGHT = 'dropright';
  var CLASS_NAME_DROPLEFT = 'dropleft';
  var CLASS_NAME_MENURIGHT = 'dropdown-menu-right';
  var CLASS_NAME_POSITION_STATIC = 'position-static';
  var EVENT_HIDE$3 = "hide" + EVENT_KEY$6;
  var EVENT_HIDDEN$3 = "hidden" + EVENT_KEY$6;
  var EVENT_SHOW$3 = "show" + EVENT_KEY$6;
  var EVENT_SHOWN$3 = "shown" + EVENT_KEY$6;
  var EVENT_CLICK = "click" + EVENT_KEY$6;
  var EVENT_CLICK_DATA_API$2 = "click" + EVENT_KEY$6 + DATA_API_KEY$3;
  var EVENT_KEYDOWN_DATA_API = "keydown" + EVENT_KEY$6 + DATA_API_KEY$3;
  var EVENT_KEYUP_DATA_API = "keyup" + EVENT_KEY$6 + DATA_API_KEY$3;
  var SELECTOR_DATA_TOGGLE$2 = '[data-toggle="dropdown"]';
  var SELECTOR_FORM_CHILD = '.dropdown form';
  var SELECTOR_MENU = '.dropdown-menu';
  var SELECTOR_NAVBAR_NAV = '.navbar-nav';
  var SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
  var PLACEMENT_TOP = 'top-start';
  var PLACEMENT_TOPEND = 'top-end';
  var PLACEMENT_BOTTOM = 'bottom-start';
  var PLACEMENT_BOTTOMEND = 'bottom-end';
  var PLACEMENT_RIGHT = 'right-start';
  var PLACEMENT_LEFT = 'left-start';
  var Default$5 = {
    offset: 0,
    flip: true,
    boundary: 'scrollParent',
    reference: 'toggle',
    display: 'dynamic',
    popperConfig: null
  };
  var DefaultType$5 = {
    offset: '(number|string|function)',
    flip: 'boolean',
    boundary: '(string|element)',
    reference: '(string|element)',
    display: 'string',
    popperConfig: '(null|object)'
  };
  /**
   * Class definition
   */

  var Dropdown = /*#__PURE__*/function () {
    function Dropdown(element, config) {
      this._element = element;
      this._popper = null;
      this._config = this._getConfig(config);
      this._menu = this._getMenuElement();
      this._inNavbar = this._detectNavbar();

      this._addEventListeners();
    } // Getters


    var _proto = Dropdown.prototype;

    // Public
    _proto.toggle = function toggle() {
      if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1)) {
        return;
      }

      var isActive = $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5);

      Dropdown._clearMenus();

      if (isActive) {
        return;
      }

      this.show(true);
    };

    _proto.show = function show(usePopper) {
      if (usePopper === void 0) {
        usePopper = false;
      }

      if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1) || $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5)) {
        return;
      }

      var relatedTarget = {
        relatedTarget: this._element
      };
      var showEvent = $__default["default"].Event(EVENT_SHOW$3, relatedTarget);

      var parent = Dropdown._getParentFromElement(this._element);

      $__default["default"](parent).trigger(showEvent);

      if (showEvent.isDefaultPrevented()) {
        return;
      } // Totally disable Popper for Dropdowns in Navbar


      if (!this._inNavbar && usePopper) {
        // Check for Popper dependency
        if (typeof Popper__default["default"] === 'undefined') {
          throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
        }

        var referenceElement = this._element;

        if (this._config.reference === 'parent') {
          referenceElement = parent;
        } else if (Util.isElement(this._config.reference)) {
          referenceElement = this._config.reference; // Check if it's jQuery element

          if (typeof this._config.reference.jquery !== 'undefined') {
            referenceElement = this._config.reference[0];
          }
        } // If boundary is not `scrollParent`, then set position to `static`
        // to allow the menu to "escape" the scroll parent's boundaries
        // https://github.com/twbs/bootstrap/issues/24251


        if (this._config.boundary !== 'scrollParent') {
          $__default["default"](parent).addClass(CLASS_NAME_POSITION_STATIC);
        }

        this._popper = new Popper__default["default"](referenceElement, this._menu, this._getPopperConfig());
      } // If this is a touch-enabled device we add extra
      // empty mouseover listeners to the body's immediate children;
      // only needed because of broken event delegation on iOS
      // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html


      if ('ontouchstart' in document.documentElement && $__default["default"](parent).closest(SELECTOR_NAVBAR_NAV).length === 0) {
        $__default["default"](document.body).children().on('mouseover', null, $__default["default"].noop);
      }

      this._element.focus();

      this._element.setAttribute('aria-expanded', true);

      $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$5);
      $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_SHOWN$3, relatedTarget));
    };

    _proto.hide = function hide() {
      if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1) || !$__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5)) {
        return;
      }

      var relatedTarget = {
        relatedTarget: this._element
      };
      var hideEvent = $__default["default"].Event(EVENT_HIDE$3, relatedTarget);

      var parent = Dropdown._getParentFromElement(this._element);

      $__default["default"](parent).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      if (this._popper) {
        this._popper.destroy();
      }

      $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$5);
      $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_HIDDEN$3, relatedTarget));
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$6);
      $__default["default"](this._element).off(EVENT_KEY$6);
      this._element = null;
      this._menu = null;

      if (this._popper !== null) {
        this._popper.destroy();

        this._popper = null;
      }
    };

    _proto.update = function update() {
      this._inNavbar = this._detectNavbar();

      if (this._popper !== null) {
        this._popper.scheduleUpdate();
      }
    } // Private
    ;

    _proto._addEventListeners = function _addEventListeners() {
      var _this = this;

      $__default["default"](this._element).on(EVENT_CLICK, function (event) {
        event.preventDefault();
        event.stopPropagation();

        _this.toggle();
      });
    };

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, this.constructor.Default, $__default["default"](this._element).data(), config);
      Util.typeCheckConfig(NAME$6, config, this.constructor.DefaultType);
      return config;
    };

    _proto._getMenuElement = function _getMenuElement() {
      if (!this._menu) {
        var parent = Dropdown._getParentFromElement(this._element);

        if (parent) {
          this._menu = parent.querySelector(SELECTOR_MENU);
        }
      }

      return this._menu;
    };

    _proto._getPlacement = function _getPlacement() {
      var $parentDropdown = $__default["default"](this._element.parentNode);
      var placement = PLACEMENT_BOTTOM; // Handle dropup

      if ($parentDropdown.hasClass(CLASS_NAME_DROPUP)) {
        placement = $__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT) ? PLACEMENT_TOPEND : PLACEMENT_TOP;
      } else if ($parentDropdown.hasClass(CLASS_NAME_DROPRIGHT)) {
        placement = PLACEMENT_RIGHT;
      } else if ($parentDropdown.hasClass(CLASS_NAME_DROPLEFT)) {
        placement = PLACEMENT_LEFT;
      } else if ($__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT)) {
        placement = PLACEMENT_BOTTOMEND;
      }

      return placement;
    };

    _proto._detectNavbar = function _detectNavbar() {
      return $__default["default"](this._element).closest('.navbar').length > 0;
    };

    _proto._getOffset = function _getOffset() {
      var _this2 = this;

      var offset = {};

      if (typeof this._config.offset === 'function') {
        offset.fn = function (data) {
          data.offsets = _extends({}, data.offsets, _this2._config.offset(data.offsets, _this2._element));
          return data;
        };
      } else {
        offset.offset = this._config.offset;
      }

      return offset;
    };

    _proto._getPopperConfig = function _getPopperConfig() {
      var popperConfig = {
        placement: this._getPlacement(),
        modifiers: {
          offset: this._getOffset(),
          flip: {
            enabled: this._config.flip
          },
          preventOverflow: {
            boundariesElement: this._config.boundary
          }
        }
      }; // Disable Popper if we have a static display

      if (this._config.display === 'static') {
        popperConfig.modifiers.applyStyle = {
          enabled: false
        };
      }

      return _extends({}, popperConfig, this._config.popperConfig);
    } // Static
    ;

    Dropdown._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $__default["default"](this).data(DATA_KEY$6);

        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' ? config : null;

        if (!data) {
          data = new Dropdown(this, _config);
          $__default["default"](this).data(DATA_KEY$6, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    Dropdown._clearMenus = function _clearMenus(event) {
      if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) {
        return;
      }

      var toggles = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$2));

      for (var i = 0, len = toggles.length; i < len; i++) {
        var parent = Dropdown._getParentFromElement(toggles[i]);

        var context = $__default["default"](toggles[i]).data(DATA_KEY$6);
        var relatedTarget = {
          relatedTarget: toggles[i]
        };

        if (event && event.type === 'click') {
          relatedTarget.clickEvent = event;
        }

        if (!context) {
          continue;
        }

        var dropdownMenu = context._menu;

        if (!$__default["default"](parent).hasClass(CLASS_NAME_SHOW$5)) {
          continue;
        }

        if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.which === TAB_KEYCODE) && $__default["default"].contains(parent, event.target)) {
          continue;
        }

        var hideEvent = $__default["default"].Event(EVENT_HIDE$3, relatedTarget);
        $__default["default"](parent).trigger(hideEvent);

        if (hideEvent.isDefaultPrevented()) {
          continue;
        } // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support


        if ('ontouchstart' in document.documentElement) {
          $__default["default"](document.body).children().off('mouseover', null, $__default["default"].noop);
        }

        toggles[i].setAttribute('aria-expanded', 'false');

        if (context._popper) {
          context._popper.destroy();
        }

        $__default["default"](dropdownMenu).removeClass(CLASS_NAME_SHOW$5);
        $__default["default"](parent).removeClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_HIDDEN$3, relatedTarget));
      }
    };

    Dropdown._getParentFromElement = function _getParentFromElement(element) {
      var parent;
      var selector = Util.getSelectorFromElement(element);

      if (selector) {
        parent = document.querySelector(selector);
      }

      return parent || element.parentNode;
    } // eslint-disable-next-line complexity
    ;

    Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
      // If not input/textarea:
      //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
      // If input/textarea:
      //  - If space key => not a dropdown command
      //  - If key is other than escape
      //    - If key is not up or down => not a dropdown command
      //    - If trigger inside the menu => not a dropdown command
      if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE$1 && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $__default["default"](event.target).closest(SELECTOR_MENU).length) : !REGEXP_KEYDOWN.test(event.which)) {
        return;
      }

      if (this.disabled || $__default["default"](this).hasClass(CLASS_NAME_DISABLED$1)) {
        return;
      }

      var parent = Dropdown._getParentFromElement(this);

      var isActive = $__default["default"](parent).hasClass(CLASS_NAME_SHOW$5);

      if (!isActive && event.which === ESCAPE_KEYCODE$1) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (!isActive || event.which === ESCAPE_KEYCODE$1 || event.which === SPACE_KEYCODE) {
        if (event.which === ESCAPE_KEYCODE$1) {
          $__default["default"](parent.querySelector(SELECTOR_DATA_TOGGLE$2)).trigger('focus');
        }

        $__default["default"](this).trigger('click');
        return;
      }

      var items = [].slice.call(parent.querySelectorAll(SELECTOR_VISIBLE_ITEMS)).filter(function (item) {
        return $__default["default"](item).is(':visible');
      });

      if (items.length === 0) {
        return;
      }

      var index = items.indexOf(event.target);

      if (event.which === ARROW_UP_KEYCODE && index > 0) {
        // Up
        index--;
      }

      if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
        // Down
        index++;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    };

    _createClass(Dropdown, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$6;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$5;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType$5;
      }
    }]);

    return Dropdown;
  }();
  /**
   * Data API implementation
   */

  $__default["default"](document).on(EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$2, Dropdown._dataApiKeydownHandler).on(EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown._dataApiKeydownHandler).on(EVENT_CLICK_DATA_API$2 + " " + EVENT_KEYUP_DATA_API, Dropdown._clearMenus).on(EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function (event) {
    event.preventDefault();
    event.stopPropagation();

    Dropdown._jQueryInterface.call($__default["default"](this), 'toggle');
  }).on(EVENT_CLICK_DATA_API$2, SELECTOR_FORM_CHILD, function (e) {
    e.stopPropagation();
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$6] = Dropdown._jQueryInterface;
  $__default["default"].fn[NAME$6].Constructor = Dropdown;

  $__default["default"].fn[NAME$6].noConflict = function () {
    $__default["default"].fn[NAME$6] = JQUERY_NO_CONFLICT$6;
    return Dropdown._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$5 = 'modal';
  var VERSION$5 = '4.6.2';
  var DATA_KEY$5 = 'bs.modal';
  var EVENT_KEY$5 = "." + DATA_KEY$5;
  var DATA_API_KEY$2 = '.data-api';
  var JQUERY_NO_CONFLICT$5 = $__default["default"].fn[NAME$5];
  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

  var CLASS_NAME_SCROLLABLE = 'modal-dialog-scrollable';
  var CLASS_NAME_SCROLLBAR_MEASURER = 'modal-scrollbar-measure';
  var CLASS_NAME_BACKDROP = 'modal-backdrop';
  var CLASS_NAME_OPEN = 'modal-open';
  var CLASS_NAME_FADE$4 = 'fade';
  var CLASS_NAME_SHOW$4 = 'show';
  var CLASS_NAME_STATIC = 'modal-static';
  var EVENT_HIDE$2 = "hide" + EVENT_KEY$5;
  var EVENT_HIDE_PREVENTED = "hidePrevented" + EVENT_KEY$5;
  var EVENT_HIDDEN$2 = "hidden" + EVENT_KEY$5;
  var EVENT_SHOW$2 = "show" + EVENT_KEY$5;
  var EVENT_SHOWN$2 = "shown" + EVENT_KEY$5;
  var EVENT_FOCUSIN = "focusin" + EVENT_KEY$5;
  var EVENT_RESIZE = "resize" + EVENT_KEY$5;
  var EVENT_CLICK_DISMISS$1 = "click.dismiss" + EVENT_KEY$5;
  var EVENT_KEYDOWN_DISMISS = "keydown.dismiss" + EVENT_KEY$5;
  var EVENT_MOUSEUP_DISMISS = "mouseup.dismiss" + EVENT_KEY$5;
  var EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss" + EVENT_KEY$5;
  var EVENT_CLICK_DATA_API$1 = "click" + EVENT_KEY$5 + DATA_API_KEY$2;
  var SELECTOR_DIALOG = '.modal-dialog';
  var SELECTOR_MODAL_BODY = '.modal-body';
  var SELECTOR_DATA_TOGGLE$1 = '[data-toggle="modal"]';
  var SELECTOR_DATA_DISMISS$1 = '[data-dismiss="modal"]';
  var SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
  var SELECTOR_STICKY_CONTENT = '.sticky-top';
  var Default$4 = {
    backdrop: true,
    keyboard: true,
    focus: true,
    show: true
  };
  var DefaultType$4 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    focus: 'boolean',
    show: 'boolean'
  };
  /**
   * Class definition
   */

  var Modal = /*#__PURE__*/function () {
    function Modal(element, config) {
      this._config = this._getConfig(config);
      this._element = element;
      this._dialog = element.querySelector(SELECTOR_DIALOG);
      this._backdrop = null;
      this._isShown = false;
      this._isBodyOverflowing = false;
      this._ignoreBackdropClick = false;
      this._isTransitioning = false;
      this._scrollbarWidth = 0;
    } // Getters


    var _proto = Modal.prototype;

    // Public
    _proto.toggle = function toggle(relatedTarget) {
      return this._isShown ? this.hide() : this.show(relatedTarget);
    };

    _proto.show = function show(relatedTarget) {
      var _this = this;

      if (this._isShown || this._isTransitioning) {
        return;
      }

      var showEvent = $__default["default"].Event(EVENT_SHOW$2, {
        relatedTarget: relatedTarget
      });
      $__default["default"](this._element).trigger(showEvent);

      if (showEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = true;

      if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$4)) {
        this._isTransitioning = true;
      }

      this._checkScrollbar();

      this._setScrollbar();

      this._adjustDialog();

      this._setEscapeEvent();

      this._setResizeEvent();

      $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, SELECTOR_DATA_DISMISS$1, function (event) {
        return _this.hide(event);
      });
      $__default["default"](this._dialog).on(EVENT_MOUSEDOWN_DISMISS, function () {
        $__default["default"](_this._element).one(EVENT_MOUSEUP_DISMISS, function (event) {
          if ($__default["default"](event.target).is(_this._element)) {
            _this._ignoreBackdropClick = true;
          }
        });
      });

      this._showBackdrop(function () {
        return _this._showElement(relatedTarget);
      });
    };

    _proto.hide = function hide(event) {
      var _this2 = this;

      if (event) {
        event.preventDefault();
      }

      if (!this._isShown || this._isTransitioning) {
        return;
      }

      var hideEvent = $__default["default"].Event(EVENT_HIDE$2);
      $__default["default"](this._element).trigger(hideEvent);

      if (!this._isShown || hideEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = false;
      var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4);

      if (transition) {
        this._isTransitioning = true;
      }

      this._setEscapeEvent();

      this._setResizeEvent();

      $__default["default"](document).off(EVENT_FOCUSIN);
      $__default["default"](this._element).removeClass(CLASS_NAME_SHOW$4);
      $__default["default"](this._element).off(EVENT_CLICK_DISMISS$1);
      $__default["default"](this._dialog).off(EVENT_MOUSEDOWN_DISMISS);

      if (transition) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $__default["default"](this._element).one(Util.TRANSITION_END, function (event) {
          return _this2._hideModal(event);
        }).emulateTransitionEnd(transitionDuration);
      } else {
        this._hideModal();
      }
    };

    _proto.dispose = function dispose() {
      [window, this._element, this._dialog].forEach(function (htmlElement) {
        return $__default["default"](htmlElement).off(EVENT_KEY$5);
      });
      /**
       * `document` has 2 events `EVENT_FOCUSIN` and `EVENT_CLICK_DATA_API`
       * Do not move `document` in `htmlElements` array
       * It will remove `EVENT_CLICK_DATA_API` event that should remain
       */

      $__default["default"](document).off(EVENT_FOCUSIN);
      $__default["default"].removeData(this._element, DATA_KEY$5);
      this._config = null;
      this._element = null;
      this._dialog = null;
      this._backdrop = null;
      this._isShown = null;
      this._isBodyOverflowing = null;
      this._ignoreBackdropClick = null;
      this._isTransitioning = null;
      this._scrollbarWidth = null;
    };

    _proto.handleUpdate = function handleUpdate() {
      this._adjustDialog();
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default$4, config);
      Util.typeCheckConfig(NAME$5, config, DefaultType$4);
      return config;
    };

    _proto._triggerBackdropTransition = function _triggerBackdropTransition() {
      var _this3 = this;

      var hideEventPrevented = $__default["default"].Event(EVENT_HIDE_PREVENTED);
      $__default["default"](this._element).trigger(hideEventPrevented);

      if (hideEventPrevented.isDefaultPrevented()) {
        return;
      }

      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

      if (!isModalOverflowing) {
        this._element.style.overflowY = 'hidden';
      }

      this._element.classList.add(CLASS_NAME_STATIC);

      var modalTransitionDuration = Util.getTransitionDurationFromElement(this._dialog);
      $__default["default"](this._element).off(Util.TRANSITION_END);
      $__default["default"](this._element).one(Util.TRANSITION_END, function () {
        _this3._element.classList.remove(CLASS_NAME_STATIC);

        if (!isModalOverflowing) {
          $__default["default"](_this3._element).one(Util.TRANSITION_END, function () {
            _this3._element.style.overflowY = '';
          }).emulateTransitionEnd(_this3._element, modalTransitionDuration);
        }
      }).emulateTransitionEnd(modalTransitionDuration);

      this._element.focus();
    };

    _proto._showElement = function _showElement(relatedTarget) {
      var _this4 = this;

      var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4);
      var modalBody = this._dialog ? this._dialog.querySelector(SELECTOR_MODAL_BODY) : null;

      if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
        // Don't move modal's DOM position
        document.body.appendChild(this._element);
      }

      this._element.style.display = 'block';

      this._element.removeAttribute('aria-hidden');

      this._element.setAttribute('aria-modal', true);

      this._element.setAttribute('role', 'dialog');

      if ($__default["default"](this._dialog).hasClass(CLASS_NAME_SCROLLABLE) && modalBody) {
        modalBody.scrollTop = 0;
      } else {
        this._element.scrollTop = 0;
      }

      if (transition) {
        Util.reflow(this._element);
      }

      $__default["default"](this._element).addClass(CLASS_NAME_SHOW$4);

      if (this._config.focus) {
        this._enforceFocus();
      }

      var shownEvent = $__default["default"].Event(EVENT_SHOWN$2, {
        relatedTarget: relatedTarget
      });

      var transitionComplete = function transitionComplete() {
        if (_this4._config.focus) {
          _this4._element.focus();
        }

        _this4._isTransitioning = false;
        $__default["default"](_this4._element).trigger(shownEvent);
      };

      if (transition) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._dialog);
        $__default["default"](this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(transitionDuration);
      } else {
        transitionComplete();
      }
    };

    _proto._enforceFocus = function _enforceFocus() {
      var _this5 = this;

      $__default["default"](document).off(EVENT_FOCUSIN) // Guard against infinite focus loop
      .on(EVENT_FOCUSIN, function (event) {
        if (document !== event.target && _this5._element !== event.target && $__default["default"](_this5._element).has(event.target).length === 0) {
          _this5._element.focus();
        }
      });
    };

    _proto._setEscapeEvent = function _setEscapeEvent() {
      var _this6 = this;

      if (this._isShown) {
        $__default["default"](this._element).on(EVENT_KEYDOWN_DISMISS, function (event) {
          if (_this6._config.keyboard && event.which === ESCAPE_KEYCODE) {
            event.preventDefault();

            _this6.hide();
          } else if (!_this6._config.keyboard && event.which === ESCAPE_KEYCODE) {
            _this6._triggerBackdropTransition();
          }
        });
      } else if (!this._isShown) {
        $__default["default"](this._element).off(EVENT_KEYDOWN_DISMISS);
      }
    };

    _proto._setResizeEvent = function _setResizeEvent() {
      var _this7 = this;

      if (this._isShown) {
        $__default["default"](window).on(EVENT_RESIZE, function (event) {
          return _this7.handleUpdate(event);
        });
      } else {
        $__default["default"](window).off(EVENT_RESIZE);
      }
    };

    _proto._hideModal = function _hideModal() {
      var _this8 = this;

      this._element.style.display = 'none';

      this._element.setAttribute('aria-hidden', true);

      this._element.removeAttribute('aria-modal');

      this._element.removeAttribute('role');

      this._isTransitioning = false;

      this._showBackdrop(function () {
        $__default["default"](document.body).removeClass(CLASS_NAME_OPEN);

        _this8._resetAdjustments();

        _this8._resetScrollbar();

        $__default["default"](_this8._element).trigger(EVENT_HIDDEN$2);
      });
    };

    _proto._removeBackdrop = function _removeBackdrop() {
      if (this._backdrop) {
        $__default["default"](this._backdrop).remove();
        this._backdrop = null;
      }
    };

    _proto._showBackdrop = function _showBackdrop(callback) {
      var _this9 = this;

      var animate = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4) ? CLASS_NAME_FADE$4 : '';

      if (this._isShown && this._config.backdrop) {
        this._backdrop = document.createElement('div');
        this._backdrop.className = CLASS_NAME_BACKDROP;

        if (animate) {
          this._backdrop.classList.add(animate);
        }

        $__default["default"](this._backdrop).appendTo(document.body);
        $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, function (event) {
          if (_this9._ignoreBackdropClick) {
            _this9._ignoreBackdropClick = false;
            return;
          }

          if (event.target !== event.currentTarget) {
            return;
          }

          if (_this9._config.backdrop === 'static') {
            _this9._triggerBackdropTransition();
          } else {
            _this9.hide();
          }
        });

        if (animate) {
          Util.reflow(this._backdrop);
        }

        $__default["default"](this._backdrop).addClass(CLASS_NAME_SHOW$4);

        if (!callback) {
          return;
        }

        if (!animate) {
          callback();
          return;
        }

        var backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
        $__default["default"](this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(backdropTransitionDuration);
      } else if (!this._isShown && this._backdrop) {
        $__default["default"](this._backdrop).removeClass(CLASS_NAME_SHOW$4);

        var callbackRemove = function callbackRemove() {
          _this9._removeBackdrop();

          if (callback) {
            callback();
          }
        };

        if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$4)) {
          var _backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);

          $__default["default"](this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(_backdropTransitionDuration);
        } else {
          callbackRemove();
        }
      } else if (callback) {
        callback();
      }
    } // ----------------------------------------------------------------------
    // the following methods are used to handle overflowing modals
    // todo (fat): these should probably be refactored out of modal.js
    // ----------------------------------------------------------------------
    ;

    _proto._adjustDialog = function _adjustDialog() {
      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

      if (!this._isBodyOverflowing && isModalOverflowing) {
        this._element.style.paddingLeft = this._scrollbarWidth + "px";
      }

      if (this._isBodyOverflowing && !isModalOverflowing) {
        this._element.style.paddingRight = this._scrollbarWidth + "px";
      }
    };

    _proto._resetAdjustments = function _resetAdjustments() {
      this._element.style.paddingLeft = '';
      this._element.style.paddingRight = '';
    };

    _proto._checkScrollbar = function _checkScrollbar() {
      var rect = document.body.getBoundingClientRect();
      this._isBodyOverflowing = Math.round(rect.left + rect.right) < window.innerWidth;
      this._scrollbarWidth = this._getScrollbarWidth();
    };

    _proto._setScrollbar = function _setScrollbar() {
      var _this10 = this;

      if (this._isBodyOverflowing) {
        // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
        //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
        var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
        var stickyContent = [].slice.call(document.querySelectorAll(SELECTOR_STICKY_CONTENT)); // Adjust fixed content padding

        $__default["default"](fixedContent).each(function (index, element) {
          var actualPadding = element.style.paddingRight;
          var calculatedPadding = $__default["default"](element).css('padding-right');
          $__default["default"](element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + _this10._scrollbarWidth + "px");
        }); // Adjust sticky content margin

        $__default["default"](stickyContent).each(function (index, element) {
          var actualMargin = element.style.marginRight;
          var calculatedMargin = $__default["default"](element).css('margin-right');
          $__default["default"](element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this10._scrollbarWidth + "px");
        }); // Adjust body padding

        var actualPadding = document.body.style.paddingRight;
        var calculatedPadding = $__default["default"](document.body).css('padding-right');
        $__default["default"](document.body).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
      }

      $__default["default"](document.body).addClass(CLASS_NAME_OPEN);
    };

    _proto._resetScrollbar = function _resetScrollbar() {
      // Restore fixed content padding
      var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
      $__default["default"](fixedContent).each(function (index, element) {
        var padding = $__default["default"](element).data('padding-right');
        $__default["default"](element).removeData('padding-right');
        element.style.paddingRight = padding ? padding : '';
      }); // Restore sticky content

      var elements = [].slice.call(document.querySelectorAll("" + SELECTOR_STICKY_CONTENT));
      $__default["default"](elements).each(function (index, element) {
        var margin = $__default["default"](element).data('margin-right');

        if (typeof margin !== 'undefined') {
          $__default["default"](element).css('margin-right', margin).removeData('margin-right');
        }
      }); // Restore body padding

      var padding = $__default["default"](document.body).data('padding-right');
      $__default["default"](document.body).removeData('padding-right');
      document.body.style.paddingRight = padding ? padding : '';
    };

    _proto._getScrollbarWidth = function _getScrollbarWidth() {
      // thx d.walsh
      var scrollDiv = document.createElement('div');
      scrollDiv.className = CLASS_NAME_SCROLLBAR_MEASURER;
      document.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWidth;
    } // Static
    ;

    Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
      return this.each(function () {
        var data = $__default["default"](this).data(DATA_KEY$5);

        var _config = _extends({}, Default$4, $__default["default"](this).data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});

        if (!data) {
          data = new Modal(this, _config);
          $__default["default"](this).data(DATA_KEY$5, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config](relatedTarget);
        } else if (_config.show) {
          data.show(relatedTarget);
        }
      });
    };

    _createClass(Modal, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$5;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$4;
      }
    }]);

    return Modal;
  }();
  /**
   * Data API implementation
   */

  $__default["default"](document).on(EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function (event) {
    var _this11 = this;

    var target;
    var selector = Util.getSelectorFromElement(this);

    if (selector) {
      target = document.querySelector(selector);
    }

    var config = $__default["default"](target).data(DATA_KEY$5) ? 'toggle' : _extends({}, $__default["default"](target).data(), $__default["default"](this).data());

    if (this.tagName === 'A' || this.tagName === 'AREA') {
      event.preventDefault();
    }

    var $target = $__default["default"](target).one(EVENT_SHOW$2, function (showEvent) {
      if (showEvent.isDefaultPrevented()) {
        // Only register focus restorer if modal will actually get shown
        return;
      }

      $target.one(EVENT_HIDDEN$2, function () {
        if ($__default["default"](_this11).is(':visible')) {
          _this11.focus();
        }
      });
    });

    Modal._jQueryInterface.call($__default["default"](target), config, this);
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$5] = Modal._jQueryInterface;
  $__default["default"].fn[NAME$5].Constructor = Modal;

  $__default["default"].fn[NAME$5].noConflict = function () {
    $__default["default"].fn[NAME$5] = JQUERY_NO_CONFLICT$5;
    return Modal._jQueryInterface;
  };

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.2): tools/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  var uriAttrs = ['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href'];
  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
  var DefaultWhitelist = {
    // Global attributes allowed on any supplied element below.
    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
    a: ['target', 'href', 'title', 'rel'],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
  };
  /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
   */

  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i;
  /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
   */

  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;

  function allowedAttribute(attr, allowedAttributeList) {
    var attrName = attr.nodeName.toLowerCase();

    if (allowedAttributeList.indexOf(attrName) !== -1) {
      if (uriAttrs.indexOf(attrName) !== -1) {
        return Boolean(SAFE_URL_PATTERN.test(attr.nodeValue) || DATA_URL_PATTERN.test(attr.nodeValue));
      }

      return true;
    }

    var regExp = allowedAttributeList.filter(function (attrRegex) {
      return attrRegex instanceof RegExp;
    }); // Check if a regular expression validates the attribute.

    for (var i = 0, len = regExp.length; i < len; i++) {
      if (regExp[i].test(attrName)) {
        return true;
      }
    }

    return false;
  }

  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
    if (unsafeHtml.length === 0) {
      return unsafeHtml;
    }

    if (sanitizeFn && typeof sanitizeFn === 'function') {
      return sanitizeFn(unsafeHtml);
    }

    var domParser = new window.DOMParser();
    var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    var whitelistKeys = Object.keys(whiteList);
    var elements = [].slice.call(createdDocument.body.querySelectorAll('*'));

    var _loop = function _loop(i, len) {
      var el = elements[i];
      var elName = el.nodeName.toLowerCase();

      if (whitelistKeys.indexOf(el.nodeName.toLowerCase()) === -1) {
        el.parentNode.removeChild(el);
        return "continue";
      }

      var attributeList = [].slice.call(el.attributes); // eslint-disable-next-line unicorn/prefer-spread

      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);
      attributeList.forEach(function (attr) {
        if (!allowedAttribute(attr, whitelistedAttributes)) {
          el.removeAttribute(attr.nodeName);
        }
      });
    };

    for (var i = 0, len = elements.length; i < len; i++) {
      var _ret = _loop(i);

      if (_ret === "continue") continue;
    }

    return createdDocument.body.innerHTML;
  }

  /**
   * Constants
   */

  var NAME$4 = 'tooltip';
  var VERSION$4 = '4.6.2';
  var DATA_KEY$4 = 'bs.tooltip';
  var EVENT_KEY$4 = "." + DATA_KEY$4;
  var JQUERY_NO_CONFLICT$4 = $__default["default"].fn[NAME$4];
  var CLASS_PREFIX$1 = 'bs-tooltip';
  var BSCLS_PREFIX_REGEX$1 = new RegExp("(^|\\s)" + CLASS_PREFIX$1 + "\\S+", 'g');
  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];
  var CLASS_NAME_FADE$3 = 'fade';
  var CLASS_NAME_SHOW$3 = 'show';
  var HOVER_STATE_SHOW = 'show';
  var HOVER_STATE_OUT = 'out';
  var SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
  var SELECTOR_ARROW = '.arrow';
  var TRIGGER_HOVER = 'hover';
  var TRIGGER_FOCUS = 'focus';
  var TRIGGER_CLICK = 'click';
  var TRIGGER_MANUAL = 'manual';
  var AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left'
  };
  var Default$3 = {
    animation: true,
    template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    selector: false,
    placement: 'top',
    offset: 0,
    container: false,
    fallbackPlacement: 'flip',
    boundary: 'scrollParent',
    customClass: '',
    sanitize: true,
    sanitizeFn: null,
    whiteList: DefaultWhitelist,
    popperConfig: null
  };
  var DefaultType$3 = {
    animation: 'boolean',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string',
    delay: '(number|object)',
    html: 'boolean',
    selector: '(string|boolean)',
    placement: '(string|function)',
    offset: '(number|string|function)',
    container: '(string|element|boolean)',
    fallbackPlacement: '(string|array)',
    boundary: '(string|element)',
    customClass: '(string|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    whiteList: 'object',
    popperConfig: '(null|object)'
  };
  var Event$1 = {
    HIDE: "hide" + EVENT_KEY$4,
    HIDDEN: "hidden" + EVENT_KEY$4,
    SHOW: "show" + EVENT_KEY$4,
    SHOWN: "shown" + EVENT_KEY$4,
    INSERTED: "inserted" + EVENT_KEY$4,
    CLICK: "click" + EVENT_KEY$4,
    FOCUSIN: "focusin" + EVENT_KEY$4,
    FOCUSOUT: "focusout" + EVENT_KEY$4,
    MOUSEENTER: "mouseenter" + EVENT_KEY$4,
    MOUSELEAVE: "mouseleave" + EVENT_KEY$4
  };
  /**
   * Class definition
   */

  var Tooltip = /*#__PURE__*/function () {
    function Tooltip(element, config) {
      if (typeof Popper__default["default"] === 'undefined') {
        throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
      } // Private


      this._isEnabled = true;
      this._timeout = 0;
      this._hoverState = '';
      this._activeTrigger = {};
      this._popper = null; // Protected

      this.element = element;
      this.config = this._getConfig(config);
      this.tip = null;

      this._setListeners();
    } // Getters


    var _proto = Tooltip.prototype;

    // Public
    _proto.enable = function enable() {
      this._isEnabled = true;
    };

    _proto.disable = function disable() {
      this._isEnabled = false;
    };

    _proto.toggleEnabled = function toggleEnabled() {
      this._isEnabled = !this._isEnabled;
    };

    _proto.toggle = function toggle(event) {
      if (!this._isEnabled) {
        return;
      }

      if (event) {
        var dataKey = this.constructor.DATA_KEY;
        var context = $__default["default"](event.currentTarget).data(dataKey);

        if (!context) {
          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
          $__default["default"](event.currentTarget).data(dataKey, context);
        }

        context._activeTrigger.click = !context._activeTrigger.click;

        if (context._isWithActiveTrigger()) {
          context._enter(null, context);
        } else {
          context._leave(null, context);
        }
      } else {
        if ($__default["default"](this.getTipElement()).hasClass(CLASS_NAME_SHOW$3)) {
          this._leave(null, this);

          return;
        }

        this._enter(null, this);
      }
    };

    _proto.dispose = function dispose() {
      clearTimeout(this._timeout);
      $__default["default"].removeData(this.element, this.constructor.DATA_KEY);
      $__default["default"](this.element).off(this.constructor.EVENT_KEY);
      $__default["default"](this.element).closest('.modal').off('hide.bs.modal', this._hideModalHandler);

      if (this.tip) {
        $__default["default"](this.tip).remove();
      }

      this._isEnabled = null;
      this._timeout = null;
      this._hoverState = null;
      this._activeTrigger = null;

      if (this._popper) {
        this._popper.destroy();
      }

      this._popper = null;
      this.element = null;
      this.config = null;
      this.tip = null;
    };

    _proto.show = function show() {
      var _this = this;

      if ($__default["default"](this.element).css('display') === 'none') {
        throw new Error('Please use show on visible elements');
      }

      var showEvent = $__default["default"].Event(this.constructor.Event.SHOW);

      if (this.isWithContent() && this._isEnabled) {
        $__default["default"](this.element).trigger(showEvent);
        var shadowRoot = Util.findShadowRoot(this.element);
        var isInTheDom = $__default["default"].contains(shadowRoot !== null ? shadowRoot : this.element.ownerDocument.documentElement, this.element);

        if (showEvent.isDefaultPrevented() || !isInTheDom) {
          return;
        }

        var tip = this.getTipElement();
        var tipId = Util.getUID(this.constructor.NAME);
        tip.setAttribute('id', tipId);
        this.element.setAttribute('aria-describedby', tipId);
        this.setContent();

        if (this.config.animation) {
          $__default["default"](tip).addClass(CLASS_NAME_FADE$3);
        }

        var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

        var attachment = this._getAttachment(placement);

        this.addAttachmentClass(attachment);

        var container = this._getContainer();

        $__default["default"](tip).data(this.constructor.DATA_KEY, this);

        if (!$__default["default"].contains(this.element.ownerDocument.documentElement, this.tip)) {
          $__default["default"](tip).appendTo(container);
        }

        $__default["default"](this.element).trigger(this.constructor.Event.INSERTED);
        this._popper = new Popper__default["default"](this.element, tip, this._getPopperConfig(attachment));
        $__default["default"](tip).addClass(CLASS_NAME_SHOW$3);
        $__default["default"](tip).addClass(this.config.customClass); // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html

        if ('ontouchstart' in document.documentElement) {
          $__default["default"](document.body).children().on('mouseover', null, $__default["default"].noop);
        }

        var complete = function complete() {
          if (_this.config.animation) {
            _this._fixTransition();
          }

          var prevHoverState = _this._hoverState;
          _this._hoverState = null;
          $__default["default"](_this.element).trigger(_this.constructor.Event.SHOWN);

          if (prevHoverState === HOVER_STATE_OUT) {
            _this._leave(null, _this);
          }
        };

        if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$3)) {
          var transitionDuration = Util.getTransitionDurationFromElement(this.tip);
          $__default["default"](this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
        } else {
          complete();
        }
      }
    };

    _proto.hide = function hide(callback) {
      var _this2 = this;

      var tip = this.getTipElement();
      var hideEvent = $__default["default"].Event(this.constructor.Event.HIDE);

      var complete = function complete() {
        if (_this2._hoverState !== HOVER_STATE_SHOW && tip.parentNode) {
          tip.parentNode.removeChild(tip);
        }

        _this2._cleanTipClass();

        _this2.element.removeAttribute('aria-describedby');

        $__default["default"](_this2.element).trigger(_this2.constructor.Event.HIDDEN);

        if (_this2._popper !== null) {
          _this2._popper.destroy();
        }

        if (callback) {
          callback();
        }
      };

      $__default["default"](this.element).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      $__default["default"](tip).removeClass(CLASS_NAME_SHOW$3); // If this is a touch-enabled device we remove the extra
      // empty mouseover listeners we added for iOS support

      if ('ontouchstart' in document.documentElement) {
        $__default["default"](document.body).children().off('mouseover', null, $__default["default"].noop);
      }

      this._activeTrigger[TRIGGER_CLICK] = false;
      this._activeTrigger[TRIGGER_FOCUS] = false;
      this._activeTrigger[TRIGGER_HOVER] = false;

      if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$3)) {
        var transitionDuration = Util.getTransitionDurationFromElement(tip);
        $__default["default"](tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }

      this._hoverState = '';
    };

    _proto.update = function update() {
      if (this._popper !== null) {
        this._popper.scheduleUpdate();
      }
    } // Protected
    ;

    _proto.isWithContent = function isWithContent() {
      return Boolean(this.getTitle());
    };

    _proto.addAttachmentClass = function addAttachmentClass(attachment) {
      $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX$1 + "-" + attachment);
    };

    _proto.getTipElement = function getTipElement() {
      this.tip = this.tip || $__default["default"](this.config.template)[0];
      return this.tip;
    };

    _proto.setContent = function setContent() {
      var tip = this.getTipElement();
      this.setElementContent($__default["default"](tip.querySelectorAll(SELECTOR_TOOLTIP_INNER)), this.getTitle());
      $__default["default"](tip).removeClass(CLASS_NAME_FADE$3 + " " + CLASS_NAME_SHOW$3);
    };

    _proto.setElementContent = function setElementContent($element, content) {
      if ((typeof content === 'undefined' ? 'undefined' : _typeof(content)) === 'object' && (content.nodeType || content.jquery)) {
        // Content is a DOM node or a jQuery
        if (this.config.html) {
          if (!$__default["default"](content).parent().is($element)) {
            $element.empty().append(content);
          }
        } else {
          $element.text($__default["default"](content).text());
        }

        return;
      }

      if (this.config.html) {
        if (this.config.sanitize) {
          content = sanitizeHtml(content, this.config.whiteList, this.config.sanitizeFn);
        }

        $element.html(content);
      } else {
        $element.text(content);
      }
    };

    _proto.getTitle = function getTitle() {
      var title = this.element.getAttribute('data-original-title');

      if (!title) {
        title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
      }

      return title;
    } // Private
    ;

    _proto._getPopperConfig = function _getPopperConfig(attachment) {
      var _this3 = this;

      var defaultBsConfig = {
        placement: attachment,
        modifiers: {
          offset: this._getOffset(),
          flip: {
            behavior: this.config.fallbackPlacement
          },
          arrow: {
            element: SELECTOR_ARROW
          },
          preventOverflow: {
            boundariesElement: this.config.boundary
          }
        },
        onCreate: function onCreate(data) {
          if (data.originalPlacement !== data.placement) {
            _this3._handlePopperPlacementChange(data);
          }
        },
        onUpdate: function onUpdate(data) {
          return _this3._handlePopperPlacementChange(data);
        }
      };
      return _extends({}, defaultBsConfig, this.config.popperConfig);
    };

    _proto._getOffset = function _getOffset() {
      var _this4 = this;

      var offset = {};

      if (typeof this.config.offset === 'function') {
        offset.fn = function (data) {
          data.offsets = _extends({}, data.offsets, _this4.config.offset(data.offsets, _this4.element));
          return data;
        };
      } else {
        offset.offset = this.config.offset;
      }

      return offset;
    };

    _proto._getContainer = function _getContainer() {
      if (this.config.container === false) {
        return document.body;
      }

      if (Util.isElement(this.config.container)) {
        return $__default["default"](this.config.container);
      }

      return $__default["default"](document).find(this.config.container);
    };

    _proto._getAttachment = function _getAttachment(placement) {
      return AttachmentMap[placement.toUpperCase()];
    };

    _proto._setListeners = function _setListeners() {
      var _this5 = this;

      var triggers = this.config.trigger.split(' ');
      triggers.forEach(function (trigger) {
        if (trigger === 'click') {
          $__default["default"](_this5.element).on(_this5.constructor.Event.CLICK, _this5.config.selector, function (event) {
            return _this5.toggle(event);
          });
        } else if (trigger !== TRIGGER_MANUAL) {
          var eventIn = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSEENTER : _this5.constructor.Event.FOCUSIN;
          var eventOut = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSELEAVE : _this5.constructor.Event.FOCUSOUT;
          $__default["default"](_this5.element).on(eventIn, _this5.config.selector, function (event) {
            return _this5._enter(event);
          }).on(eventOut, _this5.config.selector, function (event) {
            return _this5._leave(event);
          });
        }
      });

      this._hideModalHandler = function () {
        if (_this5.element) {
          _this5.hide();
        }
      };

      $__default["default"](this.element).closest('.modal').on('hide.bs.modal', this._hideModalHandler);

      if (this.config.selector) {
        this.config = _extends({}, this.config, {
          trigger: 'manual',
          selector: ''
        });
      } else {
        this._fixTitle();
      }
    };

    _proto._fixTitle = function _fixTitle() {
      var titleType = _typeof(this.element.getAttribute('data-original-title'));

      if (this.element.getAttribute('title') || titleType !== 'string') {
        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
        this.element.setAttribute('title', '');
      }
    };

    _proto._enter = function _enter(event, context) {
      var dataKey = this.constructor.DATA_KEY;
      context = context || $__default["default"](event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $__default["default"](event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusin' ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
      }

      if ($__default["default"](context.getTipElement()).hasClass(CLASS_NAME_SHOW$3) || context._hoverState === HOVER_STATE_SHOW) {
        context._hoverState = HOVER_STATE_SHOW;
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HOVER_STATE_SHOW;

      if (!context.config.delay || !context.config.delay.show) {
        context.show();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HOVER_STATE_SHOW) {
          context.show();
        }
      }, context.config.delay.show);
    };

    _proto._leave = function _leave(event, context) {
      var dataKey = this.constructor.DATA_KEY;
      context = context || $__default["default"](event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $__default["default"](event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusout' ? TRIGGER_FOCUS : TRIGGER_HOVER] = false;
      }

      if (context._isWithActiveTrigger()) {
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HOVER_STATE_OUT;

      if (!context.config.delay || !context.config.delay.hide) {
        context.hide();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HOVER_STATE_OUT) {
          context.hide();
        }
      }, context.config.delay.hide);
    };

    _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
      for (var trigger in this._activeTrigger) {
        if (this._activeTrigger[trigger]) {
          return true;
        }
      }

      return false;
    };

    _proto._getConfig = function _getConfig(config) {
      var dataAttributes = $__default["default"](this.element).data();
      Object.keys(dataAttributes).forEach(function (dataAttr) {
        if (DISALLOWED_ATTRIBUTES.indexOf(dataAttr) !== -1) {
          delete dataAttributes[dataAttr];
        }
      });
      config = _extends({}, this.constructor.Default, dataAttributes, (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});

      if (typeof config.delay === 'number') {
        config.delay = {
          show: config.delay,
          hide: config.delay
        };
      }

      if (typeof config.title === 'number') {
        config.title = config.title.toString();
      }

      if (typeof config.content === 'number') {
        config.content = config.content.toString();
      }

      Util.typeCheckConfig(NAME$4, config, this.constructor.DefaultType);

      if (config.sanitize) {
        config.template = sanitizeHtml(config.template, config.whiteList, config.sanitizeFn);
      }

      return config;
    };

    _proto._getDelegateConfig = function _getDelegateConfig() {
      var config = {};

      if (this.config) {
        for (var key in this.config) {
          if (this.constructor.Default[key] !== this.config[key]) {
            config[key] = this.config[key];
          }
        }
      }

      return config;
    };

    _proto._cleanTipClass = function _cleanTipClass() {
      var $tip = $__default["default"](this.getTipElement());
      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX$1);

      if (tabClass !== null && tabClass.length) {
        $tip.removeClass(tabClass.join(''));
      }
    };

    _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(popperData) {
      this.tip = popperData.instance.popper;

      this._cleanTipClass();

      this.addAttachmentClass(this._getAttachment(popperData.placement));
    };

    _proto._fixTransition = function _fixTransition() {
      var tip = this.getTipElement();
      var initConfigAnimation = this.config.animation;

      if (tip.getAttribute('x-placement') !== null) {
        return;
      }

      $__default["default"](tip).removeClass(CLASS_NAME_FADE$3);
      this.config.animation = false;
      this.hide();
      this.show();
      this.config.animation = initConfigAnimation;
    } // Static
    ;

    Tooltip._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $__default["default"](this);
        var data = $element.data(DATA_KEY$4);

        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config;

        if (!data && /dispose|hide/.test(config)) {
          return;
        }

        if (!data) {
          data = new Tooltip(this, _config);
          $element.data(DATA_KEY$4, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Tooltip, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$4;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$3;
      }
    }, {
      key: "NAME",
      get: function get() {
        return NAME$4;
      }
    }, {
      key: "DATA_KEY",
      get: function get() {
        return DATA_KEY$4;
      }
    }, {
      key: "Event",
      get: function get() {
        return Event$1;
      }
    }, {
      key: "EVENT_KEY",
      get: function get() {
        return EVENT_KEY$4;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType$3;
      }
    }]);

    return Tooltip;
  }();
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$4] = Tooltip._jQueryInterface;
  $__default["default"].fn[NAME$4].Constructor = Tooltip;

  $__default["default"].fn[NAME$4].noConflict = function () {
    $__default["default"].fn[NAME$4] = JQUERY_NO_CONFLICT$4;
    return Tooltip._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$3 = 'popover';
  var VERSION$3 = '4.6.2';
  var DATA_KEY$3 = 'bs.popover';
  var EVENT_KEY$3 = "." + DATA_KEY$3;
  var JQUERY_NO_CONFLICT$3 = $__default["default"].fn[NAME$3];
  var CLASS_PREFIX = 'bs-popover';
  var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
  var CLASS_NAME_FADE$2 = 'fade';
  var CLASS_NAME_SHOW$2 = 'show';
  var SELECTOR_TITLE = '.popover-header';
  var SELECTOR_CONTENT = '.popover-body';

  var Default$2 = _extends({}, Tooltip.Default, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip">' + '<div class="arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
  });

  var DefaultType$2 = _extends({}, Tooltip.DefaultType, {
    content: '(string|element|function)'
  });

  var Event = {
    HIDE: "hide" + EVENT_KEY$3,
    HIDDEN: "hidden" + EVENT_KEY$3,
    SHOW: "show" + EVENT_KEY$3,
    SHOWN: "shown" + EVENT_KEY$3,
    INSERTED: "inserted" + EVENT_KEY$3,
    CLICK: "click" + EVENT_KEY$3,
    FOCUSIN: "focusin" + EVENT_KEY$3,
    FOCUSOUT: "focusout" + EVENT_KEY$3,
    MOUSEENTER: "mouseenter" + EVENT_KEY$3,
    MOUSELEAVE: "mouseleave" + EVENT_KEY$3
  };
  /**
   * Class definition
   */

  var Popover = /*#__PURE__*/function (_Tooltip) {
    _inheritsLoose(Popover, _Tooltip);

    function Popover() {
      return _Tooltip.apply(this, arguments) || this;
    }

    var _proto = Popover.prototype;

    // Overrides
    _proto.isWithContent = function isWithContent() {
      return this.getTitle() || this._getContent();
    };

    _proto.addAttachmentClass = function addAttachmentClass(attachment) {
      $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
    };

    _proto.getTipElement = function getTipElement() {
      this.tip = this.tip || $__default["default"](this.config.template)[0];
      return this.tip;
    };

    _proto.setContent = function setContent() {
      var $tip = $__default["default"](this.getTipElement()); // We use append for html objects to maintain js events

      this.setElementContent($tip.find(SELECTOR_TITLE), this.getTitle());

      var content = this._getContent();

      if (typeof content === 'function') {
        content = content.call(this.element);
      }

      this.setElementContent($tip.find(SELECTOR_CONTENT), content);
      $tip.removeClass(CLASS_NAME_FADE$2 + " " + CLASS_NAME_SHOW$2);
    } // Private
    ;

    _proto._getContent = function _getContent() {
      return this.element.getAttribute('data-content') || this.config.content;
    };

    _proto._cleanTipClass = function _cleanTipClass() {
      var $tip = $__default["default"](this.getTipElement());
      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

      if (tabClass !== null && tabClass.length > 0) {
        $tip.removeClass(tabClass.join(''));
      }
    } // Static
    ;

    Popover._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $__default["default"](this).data(DATA_KEY$3);

        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' ? config : null;

        if (!data && /dispose|hide/.test(config)) {
          return;
        }

        if (!data) {
          data = new Popover(this, _config);
          $__default["default"](this).data(DATA_KEY$3, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Popover, null, [{
      key: "VERSION",
      get: // Getters
      function get() {
        return VERSION$3;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$2;
      }
    }, {
      key: "NAME",
      get: function get() {
        return NAME$3;
      }
    }, {
      key: "DATA_KEY",
      get: function get() {
        return DATA_KEY$3;
      }
    }, {
      key: "Event",
      get: function get() {
        return Event;
      }
    }, {
      key: "EVENT_KEY",
      get: function get() {
        return EVENT_KEY$3;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType$2;
      }
    }]);

    return Popover;
  }(Tooltip);
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$3] = Popover._jQueryInterface;
  $__default["default"].fn[NAME$3].Constructor = Popover;

  $__default["default"].fn[NAME$3].noConflict = function () {
    $__default["default"].fn[NAME$3] = JQUERY_NO_CONFLICT$3;
    return Popover._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$2 = 'scrollspy';
  var VERSION$2 = '4.6.2';
  var DATA_KEY$2 = 'bs.scrollspy';
  var EVENT_KEY$2 = "." + DATA_KEY$2;
  var DATA_API_KEY$1 = '.data-api';
  var JQUERY_NO_CONFLICT$2 = $__default["default"].fn[NAME$2];
  var CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
  var CLASS_NAME_ACTIVE$1 = 'active';
  var EVENT_ACTIVATE = "activate" + EVENT_KEY$2;
  var EVENT_SCROLL = "scroll" + EVENT_KEY$2;
  var EVENT_LOAD_DATA_API = "load" + EVENT_KEY$2 + DATA_API_KEY$1;
  var METHOD_OFFSET = 'offset';
  var METHOD_POSITION = 'position';
  var SELECTOR_DATA_SPY = '[data-spy="scroll"]';
  var SELECTOR_NAV_LIST_GROUP$1 = '.nav, .list-group';
  var SELECTOR_NAV_LINKS = '.nav-link';
  var SELECTOR_NAV_ITEMS = '.nav-item';
  var SELECTOR_LIST_ITEMS = '.list-group-item';
  var SELECTOR_DROPDOWN$1 = '.dropdown';
  var SELECTOR_DROPDOWN_ITEMS = '.dropdown-item';
  var SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
  var Default$1 = {
    offset: 10,
    method: 'auto',
    target: ''
  };
  var DefaultType$1 = {
    offset: 'number',
    method: 'string',
    target: '(string|element)'
  };
  /**
   * Class definition
   */

  var ScrollSpy = /*#__PURE__*/function () {
    function ScrollSpy(element, config) {
      var _this = this;

      this._element = element;
      this._scrollElement = element.tagName === 'BODY' ? window : element;
      this._config = this._getConfig(config);
      this._selector = this._config.target + " " + SELECTOR_NAV_LINKS + "," + (this._config.target + " " + SELECTOR_LIST_ITEMS + ",") + (this._config.target + " " + SELECTOR_DROPDOWN_ITEMS);
      this._offsets = [];
      this._targets = [];
      this._activeTarget = null;
      this._scrollHeight = 0;
      $__default["default"](this._scrollElement).on(EVENT_SCROLL, function (event) {
        return _this._process(event);
      });
      this.refresh();

      this._process();
    } // Getters


    var _proto = ScrollSpy.prototype;

    // Public
    _proto.refresh = function refresh() {
      var _this2 = this;

      var autoMethod = this._scrollElement === this._scrollElement.window ? METHOD_OFFSET : METHOD_POSITION;
      var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
      var offsetBase = offsetMethod === METHOD_POSITION ? this._getScrollTop() : 0;
      this._offsets = [];
      this._targets = [];
      this._scrollHeight = this._getScrollHeight();
      var targets = [].slice.call(document.querySelectorAll(this._selector));
      targets.map(function (element) {
        var target;
        var targetSelector = Util.getSelectorFromElement(element);

        if (targetSelector) {
          target = document.querySelector(targetSelector);
        }

        if (target) {
          var targetBCR = target.getBoundingClientRect();

          if (targetBCR.width || targetBCR.height) {
            // TODO (fat): remove sketch reliance on jQuery position/offset
            return [$__default["default"](target)[offsetMethod]().top + offsetBase, targetSelector];
          }
        }

        return null;
      }).filter(Boolean).sort(function (a, b) {
        return a[0] - b[0];
      }).forEach(function (item) {
        _this2._offsets.push(item[0]);

        _this2._targets.push(item[1]);
      });
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$2);
      $__default["default"](this._scrollElement).off(EVENT_KEY$2);
      this._element = null;
      this._scrollElement = null;
      this._config = null;
      this._selector = null;
      this._offsets = null;
      this._targets = null;
      this._activeTarget = null;
      this._scrollHeight = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default$1, (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});

      if (typeof config.target !== 'string' && Util.isElement(config.target)) {
        var id = $__default["default"](config.target).attr('id');

        if (!id) {
          id = Util.getUID(NAME$2);
          $__default["default"](config.target).attr('id', id);
        }

        config.target = "#" + id;
      }

      Util.typeCheckConfig(NAME$2, config, DefaultType$1);
      return config;
    };

    _proto._getScrollTop = function _getScrollTop() {
      return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
    };

    _proto._getScrollHeight = function _getScrollHeight() {
      return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    };

    _proto._getOffsetHeight = function _getOffsetHeight() {
      return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
    };

    _proto._process = function _process() {
      var scrollTop = this._getScrollTop() + this._config.offset;

      var scrollHeight = this._getScrollHeight();

      var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

      if (this._scrollHeight !== scrollHeight) {
        this.refresh();
      }

      if (scrollTop >= maxScroll) {
        var target = this._targets[this._targets.length - 1];

        if (this._activeTarget !== target) {
          this._activate(target);
        }

        return;
      }

      if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
        this._activeTarget = null;

        this._clear();

        return;
      }

      for (var i = this._offsets.length; i--;) {
        var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);

        if (isActiveTarget) {
          this._activate(this._targets[i]);
        }
      }
    };

    _proto._activate = function _activate(target) {
      this._activeTarget = target;

      this._clear();

      var queries = this._selector.split(',').map(function (selector) {
        return selector + "[data-target=\"" + target + "\"]," + selector + "[href=\"" + target + "\"]";
      });

      var $link = $__default["default"]([].slice.call(document.querySelectorAll(queries.join(','))));

      if ($link.hasClass(CLASS_NAME_DROPDOWN_ITEM)) {
        $link.closest(SELECTOR_DROPDOWN$1).find(SELECTOR_DROPDOWN_TOGGLE$1).addClass(CLASS_NAME_ACTIVE$1);
        $link.addClass(CLASS_NAME_ACTIVE$1);
      } else {
        // Set triggered link as active
        $link.addClass(CLASS_NAME_ACTIVE$1); // Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor

        $link.parents(SELECTOR_NAV_LIST_GROUP$1).prev(SELECTOR_NAV_LINKS + ", " + SELECTOR_LIST_ITEMS).addClass(CLASS_NAME_ACTIVE$1); // Handle special case when .nav-link is inside .nav-item

        $link.parents(SELECTOR_NAV_LIST_GROUP$1).prev(SELECTOR_NAV_ITEMS).children(SELECTOR_NAV_LINKS).addClass(CLASS_NAME_ACTIVE$1);
      }

      $__default["default"](this._scrollElement).trigger(EVENT_ACTIVATE, {
        relatedTarget: target
      });
    };

    _proto._clear = function _clear() {
      [].slice.call(document.querySelectorAll(this._selector)).filter(function (node) {
        return node.classList.contains(CLASS_NAME_ACTIVE$1);
      }).forEach(function (node) {
        return node.classList.remove(CLASS_NAME_ACTIVE$1);
      });
    } // Static
    ;

    ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $__default["default"](this).data(DATA_KEY$2);

        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config;

        if (!data) {
          data = new ScrollSpy(this, _config);
          $__default["default"](this).data(DATA_KEY$2, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(ScrollSpy, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$2;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$1;
      }
    }]);

    return ScrollSpy;
  }();
  /**
   * Data API implementation
   */

  $__default["default"](window).on(EVENT_LOAD_DATA_API, function () {
    var scrollSpys = [].slice.call(document.querySelectorAll(SELECTOR_DATA_SPY));
    var scrollSpysLength = scrollSpys.length;

    for (var i = scrollSpysLength; i--;) {
      var $spy = $__default["default"](scrollSpys[i]);

      ScrollSpy._jQueryInterface.call($spy, $spy.data());
    }
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$2] = ScrollSpy._jQueryInterface;
  $__default["default"].fn[NAME$2].Constructor = ScrollSpy;

  $__default["default"].fn[NAME$2].noConflict = function () {
    $__default["default"].fn[NAME$2] = JQUERY_NO_CONFLICT$2;
    return ScrollSpy._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$1 = 'tab';
  var VERSION$1 = '4.6.2';
  var DATA_KEY$1 = 'bs.tab';
  var EVENT_KEY$1 = "." + DATA_KEY$1;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT$1 = $__default["default"].fn[NAME$1];
  var CLASS_NAME_DROPDOWN_MENU = 'dropdown-menu';
  var CLASS_NAME_ACTIVE = 'active';
  var CLASS_NAME_DISABLED = 'disabled';
  var CLASS_NAME_FADE$1 = 'fade';
  var CLASS_NAME_SHOW$1 = 'show';
  var EVENT_HIDE$1 = "hide" + EVENT_KEY$1;
  var EVENT_HIDDEN$1 = "hidden" + EVENT_KEY$1;
  var EVENT_SHOW$1 = "show" + EVENT_KEY$1;
  var EVENT_SHOWN$1 = "shown" + EVENT_KEY$1;
  var EVENT_CLICK_DATA_API = "click" + EVENT_KEY$1 + DATA_API_KEY;
  var SELECTOR_DROPDOWN = '.dropdown';
  var SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
  var SELECTOR_ACTIVE = '.active';
  var SELECTOR_ACTIVE_UL = '> li > .active';
  var SELECTOR_DATA_TOGGLE = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]';
  var SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
  var SELECTOR_DROPDOWN_ACTIVE_CHILD = '> .dropdown-menu .active';
  /**
   * Class definition
   */

  var Tab = /*#__PURE__*/function () {
    function Tab(element) {
      this._element = element;
    } // Getters


    var _proto = Tab.prototype;

    // Public
    _proto.show = function show() {
      var _this = this;

      if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $__default["default"](this._element).hasClass(CLASS_NAME_ACTIVE) || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED) || this._element.hasAttribute('disabled')) {
        return;
      }

      var target;
      var previous;
      var listElement = $__default["default"](this._element).closest(SELECTOR_NAV_LIST_GROUP)[0];
      var selector = Util.getSelectorFromElement(this._element);

      if (listElement) {
        var itemSelector = listElement.nodeName === 'UL' || listElement.nodeName === 'OL' ? SELECTOR_ACTIVE_UL : SELECTOR_ACTIVE;
        previous = $__default["default"].makeArray($__default["default"](listElement).find(itemSelector));
        previous = previous[previous.length - 1];
      }

      var hideEvent = $__default["default"].Event(EVENT_HIDE$1, {
        relatedTarget: this._element
      });
      var showEvent = $__default["default"].Event(EVENT_SHOW$1, {
        relatedTarget: previous
      });

      if (previous) {
        $__default["default"](previous).trigger(hideEvent);
      }

      $__default["default"](this._element).trigger(showEvent);

      if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
        return;
      }

      if (selector) {
        target = document.querySelector(selector);
      }

      this._activate(this._element, listElement);

      var complete = function complete() {
        var hiddenEvent = $__default["default"].Event(EVENT_HIDDEN$1, {
          relatedTarget: _this._element
        });
        var shownEvent = $__default["default"].Event(EVENT_SHOWN$1, {
          relatedTarget: previous
        });
        $__default["default"](previous).trigger(hiddenEvent);
        $__default["default"](_this._element).trigger(shownEvent);
      };

      if (target) {
        this._activate(target, target.parentNode, complete);
      } else {
        complete();
      }
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$1);
      this._element = null;
    } // Private
    ;

    _proto._activate = function _activate(element, container, callback) {
      var _this2 = this;

      var activeElements = container && (container.nodeName === 'UL' || container.nodeName === 'OL') ? $__default["default"](container).find(SELECTOR_ACTIVE_UL) : $__default["default"](container).children(SELECTOR_ACTIVE);
      var active = activeElements[0];
      var isTransitioning = callback && active && $__default["default"](active).hasClass(CLASS_NAME_FADE$1);

      var complete = function complete() {
        return _this2._transitionComplete(element, active, callback);
      };

      if (active && isTransitioning) {
        var transitionDuration = Util.getTransitionDurationFromElement(active);
        $__default["default"](active).removeClass(CLASS_NAME_SHOW$1).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }
    };

    _proto._transitionComplete = function _transitionComplete(element, active, callback) {
      if (active) {
        $__default["default"](active).removeClass(CLASS_NAME_ACTIVE);
        var dropdownChild = $__default["default"](active.parentNode).find(SELECTOR_DROPDOWN_ACTIVE_CHILD)[0];

        if (dropdownChild) {
          $__default["default"](dropdownChild).removeClass(CLASS_NAME_ACTIVE);
        }

        if (active.getAttribute('role') === 'tab') {
          active.setAttribute('aria-selected', false);
        }
      }

      $__default["default"](element).addClass(CLASS_NAME_ACTIVE);

      if (element.getAttribute('role') === 'tab') {
        element.setAttribute('aria-selected', true);
      }

      Util.reflow(element);

      if (element.classList.contains(CLASS_NAME_FADE$1)) {
        element.classList.add(CLASS_NAME_SHOW$1);
      }

      var parent = element.parentNode;

      if (parent && parent.nodeName === 'LI') {
        parent = parent.parentNode;
      }

      if (parent && $__default["default"](parent).hasClass(CLASS_NAME_DROPDOWN_MENU)) {
        var dropdownElement = $__default["default"](element).closest(SELECTOR_DROPDOWN)[0];

        if (dropdownElement) {
          var dropdownToggleList = [].slice.call(dropdownElement.querySelectorAll(SELECTOR_DROPDOWN_TOGGLE));
          $__default["default"](dropdownToggleList).addClass(CLASS_NAME_ACTIVE);
        }

        element.setAttribute('aria-expanded', true);
      }

      if (callback) {
        callback();
      }
    } // Static
    ;

    Tab._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $this = $__default["default"](this);
        var data = $this.data(DATA_KEY$1);

        if (!data) {
          data = new Tab(this);
          $this.data(DATA_KEY$1, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Tab, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$1;
      }
    }]);

    return Tab;
  }();
  /**
   * Data API implementation
   */

  $__default["default"](document).on(EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function (event) {
    event.preventDefault();

    Tab._jQueryInterface.call($__default["default"](this), 'show');
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$1] = Tab._jQueryInterface;
  $__default["default"].fn[NAME$1].Constructor = Tab;

  $__default["default"].fn[NAME$1].noConflict = function () {
    $__default["default"].fn[NAME$1] = JQUERY_NO_CONFLICT$1;
    return Tab._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME = 'toast';
  var VERSION = '4.6.2';
  var DATA_KEY = 'bs.toast';
  var EVENT_KEY = "." + DATA_KEY;
  var JQUERY_NO_CONFLICT = $__default["default"].fn[NAME];
  var CLASS_NAME_FADE = 'fade';
  var CLASS_NAME_HIDE = 'hide';
  var CLASS_NAME_SHOW = 'show';
  var CLASS_NAME_SHOWING = 'showing';
  var EVENT_CLICK_DISMISS = "click.dismiss" + EVENT_KEY;
  var EVENT_HIDE = "hide" + EVENT_KEY;
  var EVENT_HIDDEN = "hidden" + EVENT_KEY;
  var EVENT_SHOW = "show" + EVENT_KEY;
  var EVENT_SHOWN = "shown" + EVENT_KEY;
  var SELECTOR_DATA_DISMISS = '[data-dismiss="toast"]';
  var Default = {
    animation: true,
    autohide: true,
    delay: 500
  };
  var DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
  };
  /**
   * Class definition
   */

  var Toast = /*#__PURE__*/function () {
    function Toast(element, config) {
      this._element = element;
      this._config = this._getConfig(config);
      this._timeout = null;

      this._setListeners();
    } // Getters


    var _proto = Toast.prototype;

    // Public
    _proto.show = function show() {
      var _this = this;

      var showEvent = $__default["default"].Event(EVENT_SHOW);
      $__default["default"](this._element).trigger(showEvent);

      if (showEvent.isDefaultPrevented()) {
        return;
      }

      this._clearTimeout();

      if (this._config.animation) {
        this._element.classList.add(CLASS_NAME_FADE);
      }

      var complete = function complete() {
        _this._element.classList.remove(CLASS_NAME_SHOWING);

        _this._element.classList.add(CLASS_NAME_SHOW);

        $__default["default"](_this._element).trigger(EVENT_SHOWN);

        if (_this._config.autohide) {
          _this._timeout = setTimeout(function () {
            _this.hide();
          }, _this._config.delay);
        }
      };

      this._element.classList.remove(CLASS_NAME_HIDE);

      Util.reflow(this._element);

      this._element.classList.add(CLASS_NAME_SHOWING);

      if (this._config.animation) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }
    };

    _proto.hide = function hide() {
      if (!this._element.classList.contains(CLASS_NAME_SHOW)) {
        return;
      }

      var hideEvent = $__default["default"].Event(EVENT_HIDE);
      $__default["default"](this._element).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      this._close();
    };

    _proto.dispose = function dispose() {
      this._clearTimeout();

      if (this._element.classList.contains(CLASS_NAME_SHOW)) {
        this._element.classList.remove(CLASS_NAME_SHOW);
      }

      $__default["default"](this._element).off(EVENT_CLICK_DISMISS);
      $__default["default"].removeData(this._element, DATA_KEY);
      this._element = null;
      this._config = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default, $__default["default"](this._element).data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});
      Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
      return config;
    };

    _proto._setListeners = function _setListeners() {
      var _this2 = this;

      $__default["default"](this._element).on(EVENT_CLICK_DISMISS, SELECTOR_DATA_DISMISS, function () {
        return _this2.hide();
      });
    };

    _proto._close = function _close() {
      var _this3 = this;

      var complete = function complete() {
        _this3._element.classList.add(CLASS_NAME_HIDE);

        $__default["default"](_this3._element).trigger(EVENT_HIDDEN);
      };

      this._element.classList.remove(CLASS_NAME_SHOW);

      if (this._config.animation) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }
    };

    _proto._clearTimeout = function _clearTimeout() {
      clearTimeout(this._timeout);
      this._timeout = null;
    } // Static
    ;

    Toast._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $__default["default"](this);
        var data = $element.data(DATA_KEY);

        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config;

        if (!data) {
          data = new Toast(this, _config);
          $element.data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config](this);
        }
      });
    };

    _createClass(Toast, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default;
      }
    }]);

    return Toast;
  }();
  /**
   * jQuery
   */

  $__default["default"].fn[NAME] = Toast._jQueryInterface;
  $__default["default"].fn[NAME].Constructor = Toast;

  $__default["default"].fn[NAME].noConflict = function () {
    $__default["default"].fn[NAME] = JQUERY_NO_CONFLICT;
    return Toast._jQueryInterface;
  };

  exports.Alert = Alert;
  exports.Button = Button;
  exports.Carousel = Carousel;
  exports.Collapse = Collapse;
  exports.Dropdown = Dropdown;
  exports.Modal = Modal;
  exports.Popover = Popover;
  exports.Scrollspy = ScrollSpy;
  exports.Tab = Tab;
  exports.Toast = Toast;
  exports.Tooltip = Tooltip;
  exports.Util = Util;

  Object.defineProperty(exports, '__esModule', { value: true });
});
//# sourceMappingURL=bootstrap.js.map

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */

    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */

Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

exports.default = Popper;
//# sourceMappingURL=popper.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function webpackUniversalModuleDefinition(root, factory) {
  if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory(__webpack_require__(56), __webpack_require__(3), __webpack_require__(395));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(56), __webpack_require__(3), __webpack_require__(395)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["VueBootstrapDatetimePicker"] = factory(require("jquery"), require("moment"), require("pc-bootstrap4-datetimepicker"));else root["VueBootstrapDatetimePicker"] = factory(root["jQuery"], root["moment"], root["pc-bootstrap4-datetimepicker"]);
})(window, function (__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/var installedModules = {};
      /******/
      /******/ // The require function
      /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/__webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/__webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
          /******/
        }
        /******/
      };
      /******/
      /******/ // define __esModule on exports
      /******/__webpack_require__.r = function (exports) {
        /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
          /******/
        }
        /******/Object.defineProperty(exports, '__esModule', { value: true });
        /******/
      };
      /******/
      /******/ // create a fake namespace object
      /******/ // mode & 1: value is a module id, require it
      /******/ // mode & 2: merge all properties of value into the ns
      /******/ // mode & 4: return value when already ns object
      /******/ // mode & 8|1: behave like require
      /******/__webpack_require__.t = function (value, mode) {
        /******/if (mode & 1) value = __webpack_require__(value);
        /******/if (mode & 8) return value;
        /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
        /******/var ns = Object.create(null);
        /******/__webpack_require__.r(ns);
        /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
        /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        } /******/return ns;
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
          return module['default'];
        } :
        /******/function getModuleExports() {
          return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/__webpack_require__.p = "";
      /******/
      /******/
      /******/ // Load entry module and return exports
      /******/return __webpack_require__(__webpack_require__.s = 3);
      /******/
    }(
    /************************************************************************/
    /******/[
    /* 0 */
    /***/function (module, exports) {

      module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

      /***/
    },
    /* 1 */
    /***/function (module, exports) {

      module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

      /***/
    },
    /* 2 */
    /***/function (module, exports) {

      module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

      /***/
    },
    /* 3 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";

      __webpack_require__.r(__webpack_exports__);

      // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/component.vue?vue&type=template&id=cb93df46&
      var render = function render() {
        var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _vm.config.inline ? _c('div', { staticClass: "datetimepicker-inline" }) : _c('input', { staticClass: "form-control", attrs: { "type": "text" } });
      };
      var staticRenderFns = [];

      // CONCATENATED MODULE: ./src/component.vue?vue&type=template&id=cb93df46&

      // EXTERNAL MODULE: external {"commonjs":"jquery","commonjs2":"jquery","amd":"jquery","root":"jQuery"}
      var external_commonjs_jquery_commonjs2_jquery_amd_jquery_root_jQuery_ = __webpack_require__(0);
      var external_commonjs_jquery_commonjs2_jquery_amd_jquery_root_jQuery_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_jquery_commonjs2_jquery_amd_jquery_root_jQuery_);

      // EXTERNAL MODULE: external "moment"
      var external_moment_ = __webpack_require__(1);
      var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);

      // EXTERNAL MODULE: external "pc-bootstrap4-datetimepicker"
      var external_pc_bootstrap4_datetimepicker_ = __webpack_require__(2);

      // CONCATENATED MODULE: ./src/events.js
      // Events list without prefix
      // http://eonasdan.github.io/bootstrap-datetimepicker/Events/
      /* harmony default export */var events = ['hide', 'show', 'change', 'error', 'update'];
      // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/component.vue?vue&type=script&lang=js&
      //
      //
      //
      //
      //


      // You have to import css yourself


      /* harmony default export */var componentvue_type_script_lang_js_ = {
        name: 'date-picker',
        props: {
          value: {
            default: null,
            required: true,
            validator: function validator(value) {
              return value === null || value instanceof Date || typeof value === 'string' || value instanceof String || value instanceof external_moment_default.a;
            }
          },
          // http://eonasdan.github.io/bootstrap-datetimepicker/Options/
          config: {
            type: Object,
            default: function _default() {
              return {};
            }
          },
          /**
           * You can set this to true when component is wrapped in input-group
           * Note: inline and wrap mode wont work together
           */
          wrap: {
            type: Boolean,
            default: false
          }
        },
        data: function data() {
          return {
            dp: null,
            // jQuery DOM
            elem: null
          };
        },
        mounted: function mounted() {
          // Return early if date-picker is already loaded
          /* istanbul ignore if */
          if (this.dp) return;
          // Handle wrapped input
          this.elem = external_commonjs_jquery_commonjs2_jquery_amd_jquery_root_jQuery_default()(this.wrap ? this.$el.parentNode : this.$el);
          // Init date-picker
          this.elem.datetimepicker(this.config);
          // Store data control
          this.dp = this.elem.data('DateTimePicker');
          // Set initial value
          this.dp.date(this.value);
          // Watch for changes
          this.elem.on('dp.change', this.onChange);
          // Register remaining events
          this.registerEvents();
        },

        watch: {
          /**
           * Listen to change from outside of component and update DOM
           *
           * @param newValue
           */
          value: function value(newValue) {
            this.dp && this.dp.date(newValue || null);
          },

          /**
           * Watch for any change in options and set them
           *
           * @param newConfig Object
           */
          config: {
            deep: true,
            handler: function handler(newConfig) {
              this.dp && this.dp.options(newConfig);
            }
          }
        },
        methods: {
          /**
           * Update v-model upon change triggered by date-picker itself
           *
           * @param event
           */
          onChange: function onChange(event) {
            var formattedDate = event.date ? event.date.format(this.dp.format()) : null;
            this.$emit('input', formattedDate);
          },

          /**
           * Emit all available events
           */
          registerEvents: function registerEvents() {
            var _this = this;

            events.forEach(function (name) {
              _this.elem.on('dp.' + name, function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key];
                }

                _this.$emit.apply(_this, ['dp-' + name].concat(args));
              });
            });
          }
        },
        /**
         * Free up memory
         */
        beforeDestroy: function beforeDestroy() {
          /* istanbul ignore else */
          if (this.dp) {
            this.dp.destroy();
            this.dp = null;
            this.elem = null;
          }
        }
      };
      // CONCATENATED MODULE: ./src/component.vue?vue&type=script&lang=js&
      /* harmony default export */var src_componentvue_type_script_lang_js_ = componentvue_type_script_lang_js_;
      // CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
      /* globals __VUE_SSR_CONTEXT__ */

      // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
      // This module is a runtime utility for cleaner component module output and will
      // be included in the final webpack user bundle.

      function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
      shadowMode /* vue-cli only */
      ) {
        // Vue.extend constructor export interop
        var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

        // render functions
        if (render) {
          options.render = render;
          options.staticRenderFns = staticRenderFns;
          options._compiled = true;
        }

        // functional template
        if (functionalTemplate) {
          options.functional = true;
        }

        // scopedId
        if (scopeId) {
          options._scopeId = 'data-v-' + scopeId;
        }

        var hook;
        if (moduleIdentifier) {
          // server build
          hook = function hook(context) {
            // 2.3 injection
            context = context || // cached call
            this.$vnode && this.$vnode.ssrContext || // stateful
            this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
              context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyles) {
              injectStyles.call(this, context);
            }
            // register component module identifier for async chunk inferrence
            if (context && context._registeredComponents) {
              context._registeredComponents.add(moduleIdentifier);
            }
          };
          // used by ssr in case component is cached and beforeCreate
          // never gets called
          options._ssrRegister = hook;
        } else if (injectStyles) {
          hook = shadowMode ? function () {
            injectStyles.call(this, this.$root.$options.shadowRoot);
          } : injectStyles;
        }

        if (hook) {
          if (options.functional) {
            // for template-only hot-reload because in that case the render fn doesn't
            // go through the normalizer
            options._injectStyles = hook;
            // register for functioal component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
              hook.call(context);
              return originalRender(h, context);
            };
          } else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
          }
        }

        return {
          exports: scriptExports,
          options: options
        };
      }

      // CONCATENATED MODULE: ./src/component.vue


      /* normalize component */

      var component = normalizeComponent(src_componentvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

      component.options.__file = "component.vue";
      /* harmony default export */var src_component = component.exports;
      // CONCATENATED MODULE: ./src/index.js
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "Plugin", function () {
        return src_Plugin;
      });
      /* concated harmony reexport Component */__webpack_require__.d(__webpack_exports__, "Component", function () {
        return src_component;
      });

      var src_Plugin = function Plugin(Vue, params) {
        var name = 'date-picker';
        /* istanbul ignore else */
        if (typeof params === 'string') name = params;

        Vue.component(name, src_component);
      };

      src_component.install = src_Plugin;

      /* harmony default export */var src = __webpack_exports__["default"] = src_component;

      /***/
    }]
    /******/)["default"]
  );
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module)))

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function isPM(input) {
            return (/^nm$/i.test(input)
            );
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4 // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;
});

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '١',
        2: '٢',
        3: '٣',
        4: '٤',
        5: '٥',
        6: '٦',
        7: '٧',
        8: '٨',
        9: '٩',
        0: '٠'
    },
        numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    },
        pluralForm = function pluralForm(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    },
        plurals = {
        s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    },
        pluralize = function pluralize(u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    },
        months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(input) {
            return 'م' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y')
        },
        preparse: function preparse(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ar;
});

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var pluralForm = function pluralForm(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    },
        plurals = {
        s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    },
        pluralize = function pluralize(u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    },
        months = ['جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان', 'جويلية', 'أوت', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(input) {
            return 'م' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y')
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arDz;
});

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arKw;
});

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7',
        8: '8',
        9: '9',
        0: '0'
    },
        pluralForm = function pluralForm(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    },
        plurals = {
        s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    },
        pluralize = function pluralize(u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    },
        months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(input) {
            return 'م' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y')
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arLy;
});

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arMa;
});

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Palestine) [ar-ps]
//! author : Majd Al-Shihabi : https://github.com/majdal

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '١',
        2: '٢',
        3: '٣',
        4: '٤',
        5: '٥',
        6: '٦',
        7: '٧',
        8: '٨',
        9: '٩',
        0: '٠'
    },
        numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arPs = moment.defineLocale('ar-ps', {
        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split('_'),
        monthsShort: 'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(input) {
            return 'م' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        preparse: function preparse(string) {
            return string.replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).split('') // reversed since negative lookbehind not supported everywhere
            .reverse().join('').replace(/[١٢](?![\u062a\u0643])/g, function (match) {
                return numberMap[match];
            }).split('').reverse().join('').replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return arPs;
});

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '١',
        2: '٢',
        3: '٣',
        4: '٤',
        5: '٥',
        6: '٦',
        7: '٧',
        8: '٨',
        9: '٩',
        0: '٠'
    },
        numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(input) {
            return 'م' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        preparse: function preparse(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return arSa;
});

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arTn;
});

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function isPM(input) {
            return (/^(gündüz|axşam)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function ordinal(number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return az;
});

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function nextWeek() {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function isPM(input) {
            return (/^(дня|вечара)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return be;
});

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function ordinal(number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bg;
});

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return bm;
});

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '১',
        2: '২',
        3: '৩',
        4: '৪',
        5: '৫',
        6: '৬',
        7: '৭',
        8: '৮',
        9: '৯',
        0: '০'
    },
        numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর'
        },
        preparse: function preparse(string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত' && hour >= 4 || meridiem === 'দুপুর' && hour < 5 || meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bn;
});

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '১',
        2: '২',
        3: '৩',
        4: '৪',
        5: '৫',
        6: '৬',
        7: '৭',
        8: '৮',
        9: '৯',
        0: '০'
    },
        numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর'
        },
        preparse: function preparse(string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bnBd;
});

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '༡',
        2: '༢',
        3: '༣',
        4: '༤',
        5: '༥',
        6: '༦',
        7: '༧',
        8: '༨',
        9: '༩',
        0: '༠'
    },
        numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split('_'),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ'
        },
        preparse: function preparse(string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'མཚན་མོ' && hour >= 4 || meridiem === 'ཉིན་གུང' && hour < 5 || meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bo;
});

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [/^gen/i, /^c[ʼ\']hwe/i, /^meu/i, /^ebr/i, /^mae/i, /^(mez|eve)/i, /^gou/i, /^eos/i, /^gwe/i, /^her/i, /^du/i, /^ker/i],
        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [/^sul/i, /^lun/i, /^meurzh/i, /^merc[ʼ\']her/i, /^yaou/i, /^gwener/i, /^sadorn/i],
        shortWeekdaysParse = [/^Sul/i, /^Lun/i, /^Meu/i, /^Mer/i, /^Yao/i, /^Gwe/i, /^Sad/i],
        minWeekdaysParse = [/^Su/i, /^Lu/i, /^Me([^r]|$)/i, /^Mer/i, /^Ya/i, /^Gw/i, /^Sa/i];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function ordinal(number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function isPM(token) {
            return token === 'g.m.';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        }
    });

    return br;
});

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! author : Rasid Redzic : https://github.com/rasidre
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 'm':
                return withoutSuffix ? 'jedna minuta' : isFuture ? 'jednu minutu' : 'jedne minute';
        }
    }

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jedan sat';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: processRelativeTime,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bs;
});

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function nextDay() {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [passat a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function ordinal(number, period) {
            var output = number === 1 ? 'r' : number === 2 ? 'n' : number === 3 ? 'r' : number === 4 ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;
});

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var months = {
        standalone: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split('_'),
        isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/
    },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i],

    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
    monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss':
                // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm':
                // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm':
                // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h':
                // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh':
                // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd':
                // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd':
                // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M':
                // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM':
                // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y':
                // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy':
                // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY'
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;
});

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return cv;
});

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function ordinal(number) {
            var b = number,
                output = '',
                lookup = ['', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
            'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed'];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cy;
});

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;
});

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;
});

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deAt;
});

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deCh;
});

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var months = ['ޖެނުއަރީ', 'ފެބްރުއަރީ', 'މާރިޗު', 'އޭޕްރީލު', 'މޭ', 'ޖޫން', 'ޖުލައި', 'އޯގަސްޓު', 'ސެޕްޓެމްބަރު', 'އޮކްޓޯބަރު', 'ނޮވެމްބަރު', 'ޑިސެމްބަރު'],
        weekdays = ['އާދިއްތަ', 'ހޯމަ', 'އަންގާރަ', 'ބުދަ', 'ބުރާސްފަތި', 'ހުކުރު', 'ހޮނިހިރު'];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM: function isPM(input) {
            return 'މފ' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d'
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return dv;
});

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months: function months(momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function isPM(input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L'
        },
        calendar: function calendar(key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4st is the first week of the year.
        }
    });

    return el;
});

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;
});

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;
});

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;
});

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;
});

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });

    return enIl;
});

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return enIn;
});

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;
});

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enSg;
});

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function isPM(input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eo;
});

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return _monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida'
    });

    return es;
});

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return _monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;
});

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return _monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida'
    });

    return esMx;
});

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return _monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return esUs;
});

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return et;
});

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact: true,
        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eu;
});

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '۱',
        2: '۲',
        3: '۳',
        4: '۴',
        5: '۵',
        6: '۶',
        7: '۷',
        8: '۸',
        9: '۹',
        0: '۰'
    },
        numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays: '\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647'.split('_'),
        weekdaysShort: '\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function isPM(input) {
            return (/بعد از ظهر/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال'
        },
        preparse: function preparse(string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return fa;
});

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = ['nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden', numbersPast[7], numbersPast[8], numbersPast[9]];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? isFuture ? numbersFuture[number] : numbersPast[number] : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;
});

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function ordinal(number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fil;
});

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fo;
});

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [/^janv/i, /^févr/i, /^mars/i, /^avr/i, /^mai/i, /^juin/i, /^juil/i, /^août/i, /^sept/i, /^oct/i, /^nov/i, /^déc/i];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;
});

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;
});

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return frCh;
});

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fy;
});

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var months = ['Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Meitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deireadh Fómhair', 'Samhain', 'Nollaig'],
        monthsShort = ['Ean', 'Feabh', 'Márt', 'Aib', 'Beal', 'Meith', 'Iúil', 'Lún', 'M.F.', 'D.F.', 'Samh', 'Noll'],
        weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Sathairn'],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function ordinal(number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ga;
});

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var months = ['Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'],
        monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'],
        weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function ordinal(number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gd;
});

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function lastDay() {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gl;
});

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां']
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split('_'),
            isFormat: /MMMM(\s)+D[oD]?/
        },
        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]'
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3 // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        }
    });

    return gomDeva;
});

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam']
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split('_'),
            isFormat: /MMMM(\s)+D[oD]?/
        },
        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3 // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    return gomLatn;
});

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '૧',
        2: '૨',
        3: '૩',
        4: '૪',
        5: '૫',
        6: '૬',
        7: '૭',
        8: '૮',
        9: '૯',
        0: '૦'
    },
        numberMap = {
        '૧': '1',
        '૨': '2',
        '૩': '3',
        '૪': '4',
        '૫': '5',
        '૬': '6',
        '૭': '7',
        '૮': '8',
        '૯': '9',
        '૦': '0'
    };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ'
        },
        preparse: function preparse(string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return gu;
});

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function hh(number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function dd(number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function MM(number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function yy(number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function isPM(input) {
            return (/^(אחה"צ|אחרי הצהריים|בערב)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;
});

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '१',
        2: '२',
        3: '३',
        4: '४',
        5: '५',
        6: '६',
        7: '७',
        8: '८',
        9: '९',
        0: '०'
    },
        numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    },
        monthsParse = [/^जन/i, /^फ़र|फर/i, /^मार्च/i, /^अप्रै/i, /^मई/i, /^जून/i, /^जुल/i, /^अग/i, /^सितं|सित/i, /^अक्टू/i, /^नव|नवं/i, /^दिसं|दिस/i],
        shortMonthsParse = [/^जन/i, /^फ़र/i, /^मार्च/i, /^अप्रै/i, /^मई/i, /^जून/i, /^जुल/i, /^अग/i, /^सित/i, /^अक्टू/i, /^नव/i, /^दिस/i];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split('_')
        },
        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे'
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष'
        },
        preparse: function preparse(string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return hi;
});

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hr;
});

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix ? 'néhány másodperc' : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function isPM(input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function nextWeek() {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function lastWeek() {
                return week.call(this, false);
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return hu;
});

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function nextWeek() {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function lastWeek() {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function isPM(input) {
            return (/^(ցերեկվա|երեկոյան)$/.test(input)
            );
        },
        meridiem: function meridiem(hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hyAm;
});

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return id;
});

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return is;
});

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[Oggi a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
            },
            nextDay: function nextDay() {
                return '[Domani a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
            },
            lastDay: function lastDay() {
                return '[Ieri a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
            },
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[La scorsa] dddd [a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
                    default:
                        return '[Lo scorso] dddd [a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;
});

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return itCh;
});

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [{
            since: '2019-05-01',
            offset: 1,
            name: '令和',
            narrow: '㋿',
            abbr: 'R'
        }, {
            since: '1989-01-08',
            until: '2019-04-30',
            offset: 1,
            name: '平成',
            narrow: '㍻',
            abbr: 'H'
        }, {
            since: '1926-12-25',
            until: '1989-01-07',
            offset: 1,
            name: '昭和',
            narrow: '㍼',
            abbr: 'S'
        }, {
            since: '1912-07-30',
            until: '1926-12-24',
            offset: 1,
            name: '大正',
            narrow: '㍽',
            abbr: 'T'
        }, {
            since: '1873-01-01',
            until: '1912-07-29',
            offset: 6,
            name: '明治',
            narrow: '㍾',
            abbr: 'M'
        }, {
            since: '0001-01-01',
            until: '1873-12-31',
            offset: 1,
            name: '西暦',
            narrow: 'AD',
            abbr: 'AD'
        }, {
            since: '0000-12-31',
            until: -Infinity,
            offset: 1,
            name: '紀元前',
            narrow: 'BC',
            abbr: 'BC'
        }],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function eraYearOrdinalParse(input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM: function isPM(input) {
            return input === '午後';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function nextWeek(now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function lastWeek(now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年'
        }
    });

    return ja;
});

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return jv;
});

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(s) {
                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function ($0, $1, $2) {
                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                });
            },
            past: function past(s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function ordinal(number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (number < 20 || number <= 100 && number % 20 === 0 || number % 100 === 0) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7
        }
    });

    return ka;
});

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function ordinal(number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return kk;
});

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '១',
        2: '២',
        3: '៣',
        4: '៤',
        5: '៥',
        6: '៦',
        7: '៧',
        8: '៨',
        9: '៩',
        0: '០'
    },
        numberMap = {
        '១': '1',
        '២': '2',
        '៣': '3',
        '៤': '4',
        '៥': '5',
        '៦': '6',
        '៧': '7',
        '៨': '8',
        '៩': '9',
        '០': '0'
    };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function isPM(input) {
            return input === 'ល្ងាច';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function preparse(string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return km;
});

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '೧',
        2: '೨',
        3: '೩',
        4: '೪',
        5: '೫',
        6: '೬',
        7: '೭',
        8: '೮',
        9: '೯',
        0: '೦'
    },
        numberMap = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ'
        },
        preparse: function preparse(string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function ordinal(number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return kn;
});

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function isPM(token) {
            return token === '오후';
        },
        meridiem: function meridiem(hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;
});

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '١',
        2: '٢',
        3: '٣',
        4: '٤',
        5: '٥',
        6: '٦',
        7: '٧',
        8: '٨',
        9: '٩',
        0: '٠'
    },
        numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    },
        months = ['کانونی دووەم', 'شوبات', 'ئازار', 'نیسان', 'ئایار', 'حوزەیران', 'تەمموز', 'ئاب', 'ئەیلوول', 'تشرینی یەكەم', 'تشرینی دووەم', 'كانونی یەکەم'];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function isPM(input) {
            return (/ئێواره‌/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ'
        },
        preparse: function preparse(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ku;
});

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Northern Kurdish [ku-kmr]
//! authors : Mazlum Özdogan : https://github.com/mergehez

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(num, withoutSuffix, key, isFuture) {
        var format = {
            s: ['çend sanîye', 'çend sanîyeyan'],
            ss: [num + ' sanîye', num + ' sanîyeyan'],
            m: ['deqîqeyek', 'deqîqeyekê'],
            mm: [num + ' deqîqe', num + ' deqîqeyan'],
            h: ['saetek', 'saetekê'],
            hh: [num + ' saet', num + ' saetan'],
            d: ['rojek', 'rojekê'],
            dd: [num + ' roj', num + ' rojan'],
            w: ['hefteyek', 'hefteyekê'],
            ww: [num + ' hefte', num + ' hefteyan'],
            M: ['mehek', 'mehekê'],
            MM: [num + ' meh', num + ' mehan'],
            y: ['salek', 'salekê'],
            yy: [num + ' sal', num + ' salan']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    // function obliqueNumSuffix(num) {
    //     if(num.includes(':'))
    //         num = parseInt(num.split(':')[0]);
    //     else
    //         num = parseInt(num);
    //     return num == 0 || num % 10 == 1 ? 'ê'
    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
    // }
    function ezafeNumSuffix(num) {
        num = '' + num;
        var l = num.substring(num.length - 1),
            ll = num.length > 1 ? num.substring(num.length - 2) : '';
        if (!(ll == 12 || ll == 13) && (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')) return 'yê';
        return 'ê';
    }

    var kuKmr = moment.defineLocale('ku-kmr', {
        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
        // But the names below are more well known and handy
        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split('_'),
        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
        monthsParseExact: true,
        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'bn' : 'BN';
            } else {
                return isLower ? 'pn' : 'PN';
            }
        },
        meridiemParse: /bn|BN|pn|PN/,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[a] YYYY[an]',
            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
            ll: 'Do MMM[.] YYYY[an]',
            lll: 'Do MMM[.] YYYY[an] HH:mm',
            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm'
        },
        calendar: {
            sameDay: '[Îro di saet] LT [de]',
            nextDay: '[Sibê di saet] LT [de]',
            nextWeek: 'dddd [di saet] LT [de]',
            lastDay: '[Duh di saet] LT [de]',
            lastWeek: 'dddd[a borî di saet] LT [de]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'di %s de',
            past: 'berî %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
        ordinal: function ordinal(num, period) {
            var p = period.toLowerCase();
            if (p.includes('w') || p.includes('m')) return num + '.';

            return num + ezafeNumSuffix(num);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return kuKmr;
});

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function ordinal(number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ky;
});

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function lastWeek() {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lb;
});

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function isPM(input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function ordinal(number) {
            return 'ທີ່' + number;
        }
    });

    return lo;
});

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || number > 10 && number < 20;
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function ordinal(number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lt;
});

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lv;
});

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
        },
        translate: function translate(number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function lastWeek() {
                var lastWeekDays = ['[prošle] [nedjelje] [u] LT', '[prošlog] [ponedjeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srijede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return me;
});

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mi;
});

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function ordinal(number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return mk;
});

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact: true,
        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'രാത്രി' && hour >= 4 || meridiem === 'ഉച്ച കഴിഞ്ഞ്' || meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;
});

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm'
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function isPM(input) {
            return input === 'ҮХ';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        }
    });

    return mn;
});

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '१',
        2: '२',
        3: '३',
        4: '४',
        5: '५',
        6: '६',
        7: '७',
        8: '८',
        9: '९',
        0: '०'
    },
        numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function preparse(string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी' || meridiem === 'सायंकाळी' || meridiem === 'रात्री') {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return mr;
});

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ms;
});

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return msMy;
});

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mt;
});

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '၁',
        2: '၂',
        3: '၃',
        4: '၄',
        5: '၅',
        6: '၆',
        7: '၇',
        8: '၈',
        9: '၉',
        0: '၀'
    },
        numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function preparse(string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return my;
});

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'én time',
            hh: '%d timer',
            d: 'én dag',
            dd: '%d dager',
            w: 'én uke',
            ww: '%d uker',
            M: 'én måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nb;
});

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '१',
        2: '२',
        3: '३',
        4: '४',
        5: '५',
        6: '६',
        7: '७',
        8: '८',
        9: '९',
        0: '०'
    },
        numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function preparse(string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष'
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ne;
});

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [/^jan/i, /^feb/i, /^(maart|mrt\.?)$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;
});

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [/^jan/i, /^feb/i, /^(maart|mrt\.?)$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nlBe;
});

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nn;
});

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split('_'),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split('_'),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm'
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function ordinal(number, period) {
            var output = number === 1 ? 'r' : number === 2 ? 'n' : number === 3 ? 'r' : number === 4 ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4
        }
    });

    return ocLnc;
});

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '੧',
        2: '੨',
        3: '੩',
        4: '੪',
        5: '੫',
        6: '੬',
        7: '੭',
        8: '੮',
        9: '੯',
        0: '੦'
    },
        numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ'
        },
        preparse: function preparse(string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return paIn;
});

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_'),
        monthsParse = [/^sty/i, /^lut/i, /^mar/i, /^kwi/i, /^maj/i, /^cze/i, /^lip/i, /^sie/i, /^wrz/i, /^paź/i, /^lis/i, /^gru/i];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function months(momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;
});

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function lastWeek() {
                return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' // Saturday + Sunday
                : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;
});

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split('_'),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function lastWeek() {
                return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' // Saturday + Sunday
                : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida'
    });

    return ptBr;
});

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: 'secunde',
            mm: 'minute',
            hh: 'ore',
            dd: 'zile',
            ww: 'săptămâni',
            MM: 'luni',
            yy: 'ani'
        },
            separator = ' ';
        if (number % 100 >= 20 || number >= 100 && number % 100 === 0) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ro;
});

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays: {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm'
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function nextWeek(now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function lastWeek(now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function isPM(input) {
            return (/^(дня|вечера)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ru;
});

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var months = ['جنوري', 'فيبروري', 'مارچ', 'اپريل', 'مئي', 'جون', 'جولاءِ', 'آگسٽ', 'سيپٽمبر', 'آڪٽوبر', 'نومبر', 'ڊسمبر'],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM: function isPM(input) {
            return 'شام' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال'
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sd;
});

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return se;
});

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/

    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function ordinal(number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function isPM(input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;
});

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss':
                // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm':
                // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm':
                // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h':
                // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh':
                // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd':
                // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd':
                // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M':
                // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM':
                // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y':
                // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy':
                // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sk;
});

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sl;
});

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function isPM(input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sq;
});

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina']
        },
        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
            if (number % 10 >= 1 && number % 10 <= 4 && (number % 100 < 10 || number % 100 >= 20)) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function translate(number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function lastWeek() {
                var lastWeekDays = ['[prošle] [nedelje] [u] LT', '[prošlog] [ponedeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sr;
});

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година']
        },
        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
            if (number % 10 >= 1 && number % 10 <= 4 && (number % 100 < 10 || number % 100 >= 20)) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function translate(number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        }
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function lastWeek() {
                var lastWeekDays = ['[прошле] [недеље] [у] LT', '[прошлог] [понедељка] [у] LT', '[прошлог] [уторка] [у] LT', '[прошле] [среде] [у] LT', '[прошлог] [четвртка] [у] LT', '[прошлог] [петка] [у] LT', '[прошле] [суботе] [у] LT'];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return srCyrl;
});

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ss;
});

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? ':e' : b === 1 ? ':a' : b === 2 ? ':a' : b === 3 ? ':e' : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;
});

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sw;
});

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '௧',
        2: '௨',
        3: '௩',
        4: '௪',
        5: '௫',
        6: '௬',
        7: '௭',
        8: '௮',
        9: '௯',
        0: '௦'
    },
        numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function ordinal(number) {
            return number + 'வது';
        },
        preparse: function preparse(string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ta;
});

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact: true,
        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return te;
});

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tet;
});

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум'
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split('_'),
            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_')
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол'
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function ordinal(number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1th is the first week of the year.
        }
    });

    return tg;
});

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function isPM(input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี'
        }
    });

    return th;
});

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy"
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split('_'),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split('_'),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl'
        },
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return tk;
});

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function ordinal(number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlPh;
});

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + 'leS' : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'waQ' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'nem' : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + 'Hu’' : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'wen' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'ben' : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor(number % 1000 / 100),
            ten = Math.floor(number % 100 / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlh;
});

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı"
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function isPM(input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl'
        },
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return tr;
});

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.

    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function isPM(input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : withoutSuffix ? format[key][0] : format[key][1];
    }

    return tzl;
});

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzm;
});

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn'
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzmLatn;
});

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split('_'),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split('_'),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split('_'),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'يېرىم كېچە' || meridiem === 'سەھەر' || meridiem === 'چۈشتىن بۇرۇن') {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل'
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ugCn;
});

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        },
            nounCase;

        if (m === true) {
            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format) ? 'accusative' : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format) ? 'genitive' : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function isPM(input) {
            return (/^(дня|вечора)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uk;
});

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var months = ['جنوری', 'فروری', 'مارچ', 'اپریل', 'مئی', 'جون', 'جولائی', 'اگست', 'ستمبر', 'اکتوبر', 'نومبر', 'دسمبر'],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM: function isPM(input) {
            return 'شام' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال'
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ur;
});

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm'
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return uz;
});

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm'
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L'
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uzLatn;
});

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split('_'),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function isPM(input) {
            return (/^ch$/i.test(input)
            );
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function ordinal(number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;
});

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact: true,
        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return xPseudo;
});

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d'
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return yo;
});

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function nextWeek(now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function lastWeek(now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年'
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;
});

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年'
        }
    });

    return zhHk;
});

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年'
        }
    });

    return zhMo;
});

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年'
        }
    });

    return zhTw;
});

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! version : 4.17.47
 =========================================================
 bootstrap-datetimejs
 https://github.com/Eonasdan/bootstrap-datetimepicker
 Copyright (c) 2015 Jonathan Peterson
 =========================================================
 */
/*
 The MIT License (MIT)

 Copyright (c) 2015 Jonathan Peterson

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 */
/*global define:false */
/*global exports:false */
/*global require:false */
/*global jQuery:false */
/*global moment:false */
(function (factory) {
    'use strict';

    if (true) {
        // AMD is used - Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(56), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
        module.exports = factory(require('jquery'), require('moment'));
    } else {
        // Neither AMD nor CommonJS used. Use global variables.
        if (typeof jQuery === 'undefined') {
            throw 'bootstrap-datetimepicker requires jQuery to be loaded first';
        }
        if (typeof moment === 'undefined') {
            throw 'bootstrap-datetimepicker requires Moment.js to be loaded first';
        }
        factory(jQuery, moment);
    }
})(function ($, moment) {
    'use strict';

    if (!moment) {
        throw new Error('bootstrap-datetimepicker requires Moment.js to be loaded first');
    }

    var dateTimePicker = function dateTimePicker(element, options) {
        var picker = {},
            date,
            viewDate,
            unset = true,
            input,
            component = false,
            widget = false,
            use24Hours,
            minViewModeNumber = 0,
            actualFormat,
            parseFormats,
            currentViewMode,
            datePickerModes = [{
            clsName: 'days',
            navFnc: 'M',
            navStep: 1
        }, {
            clsName: 'months',
            navFnc: 'y',
            navStep: 1
        }, {
            clsName: 'years',
            navFnc: 'y',
            navStep: 10
        }, {
            clsName: 'decades',
            navFnc: 'y',
            navStep: 100
        }],
            viewModes = ['days', 'months', 'years', 'decades'],
            verticalModes = ['top', 'bottom', 'auto'],
            horizontalModes = ['left', 'right', 'auto'],
            toolbarPlacements = ['default', 'top', 'bottom'],
            keyMap = {
            'up': 38,
            38: 'up',
            'down': 40,
            40: 'down',
            'left': 37,
            37: 'left',
            'right': 39,
            39: 'right',
            'tab': 9,
            9: 'tab',
            'escape': 27,
            27: 'escape',
            'enter': 13,
            13: 'enter',
            'pageUp': 33,
            33: 'pageUp',
            'pageDown': 34,
            34: 'pageDown',
            'shift': 16,
            16: 'shift',
            'control': 17,
            17: 'control',
            'space': 32,
            32: 'space',
            't': 84,
            84: 't',
            'delete': 46,
            46: 'delete'
        },
            keyState = {},


        /********************************************************************************
         *
         * Private functions
         *
         ********************************************************************************/

        hasTimeZone = function hasTimeZone() {
            return moment.tz !== undefined && options.timeZone !== undefined && options.timeZone !== null && options.timeZone !== '';
        },
            getMoment = function getMoment(d) {
            var returnMoment;

            if (d === undefined || d === null) {
                returnMoment = moment(); //TODO should this use format? and locale?
            } else if (moment.isDate(d) || moment.isMoment(d)) {
                // If the date that is passed in is already a Date() or moment() object,
                // pass it directly to moment.
                returnMoment = moment(d);
            } else if (hasTimeZone()) {
                // There is a string to parse and a default time zone
                // parse with the tz function which takes a default time zone if it is not in the format string
                returnMoment = moment.tz(d, parseFormats, options.useStrict, options.timeZone);
            } else {
                returnMoment = moment(d, parseFormats, options.useStrict);
            }

            if (hasTimeZone()) {
                returnMoment.tz(options.timeZone);
            }

            return returnMoment;
        },
            isEnabled = function isEnabled(granularity) {
            if (typeof granularity !== 'string' || granularity.length > 1) {
                throw new TypeError('isEnabled expects a single character string parameter');
            }
            switch (granularity) {
                case 'y':
                    return actualFormat.indexOf('Y') !== -1;
                case 'M':
                    return actualFormat.indexOf('M') !== -1;
                case 'd':
                    return actualFormat.toLowerCase().indexOf('d') !== -1;
                case 'h':
                case 'H':
                    return actualFormat.toLowerCase().indexOf('h') !== -1;
                case 'm':
                    return actualFormat.indexOf('m') !== -1;
                case 's':
                    return actualFormat.indexOf('s') !== -1;
                default:
                    return false;
            }
        },
            hasTime = function hasTime() {
            return isEnabled('h') || isEnabled('m') || isEnabled('s');
        },
            hasDate = function hasDate() {
            return isEnabled('y') || isEnabled('M') || isEnabled('d');
        },
            getDatePickerTemplate = function getDatePickerTemplate() {
            var headTemplate = $('<thead>').append($('<tr>').append($('<th>').addClass('prev').attr('data-action', 'previous').append($('<i>').addClass(options.icons.previous))).append($('<th>').addClass('picker-switch').attr('data-action', 'pickerSwitch').attr('colspan', options.calendarWeeks ? '6' : '5')).append($('<th>').addClass('next').attr('data-action', 'next').append($('<i>').addClass(options.icons.next)))),
                contTemplate = $('<tbody>').append($('<tr>').append($('<td>').attr('colspan', options.calendarWeeks ? '8' : '7')));

            return [$('<div>').addClass('datepicker-days').append($('<table>').addClass('table-condensed').append(headTemplate).append($('<tbody>'))), $('<div>').addClass('datepicker-months').append($('<table>').addClass('table-condensed').append(headTemplate.clone()).append(contTemplate.clone())), $('<div>').addClass('datepicker-years').append($('<table>').addClass('table-condensed').append(headTemplate.clone()).append(contTemplate.clone())), $('<div>').addClass('datepicker-decades').append($('<table>').addClass('table-condensed').append(headTemplate.clone()).append(contTemplate.clone()))];
        },
            getTimePickerMainTemplate = function getTimePickerMainTemplate() {
            var topRow = $('<tr>'),
                middleRow = $('<tr>'),
                bottomRow = $('<tr>');

            if (isEnabled('h')) {
                topRow.append($('<td>').append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementHour }).addClass('btn').attr('data-action', 'incrementHours').append($('<i>').addClass(options.icons.up))));
                middleRow.append($('<td>').append($('<span>').addClass('timepicker-hour').attr({ 'data-time-component': 'hours', 'title': options.tooltips.pickHour }).attr('data-action', 'showHours')));
                bottomRow.append($('<td>').append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementHour }).addClass('btn').attr('data-action', 'decrementHours').append($('<i>').addClass(options.icons.down))));
            }
            if (isEnabled('m')) {
                if (isEnabled('h')) {
                    topRow.append($('<td>').addClass('separator'));
                    middleRow.append($('<td>').addClass('separator').html(':'));
                    bottomRow.append($('<td>').addClass('separator'));
                }
                topRow.append($('<td>').append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementMinute }).addClass('btn').attr('data-action', 'incrementMinutes').append($('<i>').addClass(options.icons.up))));
                middleRow.append($('<td>').append($('<span>').addClass('timepicker-minute').attr({ 'data-time-component': 'minutes', 'title': options.tooltips.pickMinute }).attr('data-action', 'showMinutes')));
                bottomRow.append($('<td>').append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementMinute }).addClass('btn').attr('data-action', 'decrementMinutes').append($('<i>').addClass(options.icons.down))));
            }
            if (isEnabled('s')) {
                if (isEnabled('m')) {
                    topRow.append($('<td>').addClass('separator'));
                    middleRow.append($('<td>').addClass('separator').html(':'));
                    bottomRow.append($('<td>').addClass('separator'));
                }
                topRow.append($('<td>').append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementSecond }).addClass('btn').attr('data-action', 'incrementSeconds').append($('<i>').addClass(options.icons.up))));
                middleRow.append($('<td>').append($('<span>').addClass('timepicker-second').attr({ 'data-time-component': 'seconds', 'title': options.tooltips.pickSecond }).attr('data-action', 'showSeconds')));
                bottomRow.append($('<td>').append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementSecond }).addClass('btn').attr('data-action', 'decrementSeconds').append($('<i>').addClass(options.icons.down))));
            }

            if (!use24Hours) {
                topRow.append($('<td>').addClass('separator'));
                middleRow.append($('<td>').append($('<button>').addClass('btn btn-primary').attr({ 'data-action': 'togglePeriod', tabindex: '-1', 'title': options.tooltips.togglePeriod })));
                bottomRow.append($('<td>').addClass('separator'));
            }

            return $('<div>').addClass('timepicker-picker').append($('<table>').addClass('table-condensed').append([topRow, middleRow, bottomRow]));
        },
            getTimePickerTemplate = function getTimePickerTemplate() {
            var hoursView = $('<div>').addClass('timepicker-hours').append($('<table>').addClass('table-condensed')),
                minutesView = $('<div>').addClass('timepicker-minutes').append($('<table>').addClass('table-condensed')),
                secondsView = $('<div>').addClass('timepicker-seconds').append($('<table>').addClass('table-condensed')),
                ret = [getTimePickerMainTemplate()];

            if (isEnabled('h')) {
                ret.push(hoursView);
            }
            if (isEnabled('m')) {
                ret.push(minutesView);
            }
            if (isEnabled('s')) {
                ret.push(secondsView);
            }

            return ret;
        },
            getToolbar = function getToolbar() {
            var row = [];
            if (options.showTodayButton) {
                row.push($('<td>').append($('<a>').attr({ 'data-action': 'today', 'title': options.tooltips.today }).append($('<i>').addClass(options.icons.today))));
            }
            if (!options.sideBySide && hasDate() && hasTime()) {
                row.push($('<td>').append($('<a>').attr({ 'data-action': 'togglePicker', 'title': options.tooltips.selectTime }).append($('<i>').addClass(options.icons.time))));
            }
            if (options.showClear) {
                row.push($('<td>').append($('<a>').attr({ 'data-action': 'clear', 'title': options.tooltips.clear }).append($('<i>').addClass(options.icons.clear))));
            }
            if (options.showClose) {
                row.push($('<td>').append($('<a>').attr({ 'data-action': 'close', 'title': options.tooltips.close }).append($('<i>').addClass(options.icons.close))));
            }
            return $('<table>').addClass('table-condensed').append($('<tbody>').append($('<tr>').append(row)));
        },
            getTemplate = function getTemplate() {
            var template = $('<div>').addClass('bootstrap-datetimepicker-widget dropdown-menu'),
                dateView = $('<div>').addClass('datepicker').append(getDatePickerTemplate()),
                timeView = $('<div>').addClass('timepicker').append(getTimePickerTemplate()),
                content = $('<ul>').addClass('list-unstyled'),
                toolbar = $('<li>').addClass('picker-switch' + (options.collapse ? ' accordion-toggle' : '')).append(getToolbar());

            if (options.inline) {
                template.removeClass('dropdown-menu');
            }

            if (use24Hours) {
                template.addClass('usetwentyfour');
            }

            if (isEnabled('s') && !use24Hours) {
                template.addClass('wider');
            }

            if (options.sideBySide && hasDate() && hasTime()) {
                template.addClass('timepicker-sbs');
                if (options.toolbarPlacement === 'top') {
                    template.append(toolbar);
                }
                template.append($('<div>').addClass('row').append(dateView.addClass('col-md-6')).append(timeView.addClass('col-md-6')));
                if (options.toolbarPlacement === 'bottom') {
                    template.append(toolbar);
                }
                return template;
            }

            if (options.toolbarPlacement === 'top') {
                content.append(toolbar);
            }
            if (hasDate()) {
                content.append($('<li>').addClass(options.collapse && hasTime() ? 'collapse show' : '').append(dateView));
            }
            if (options.toolbarPlacement === 'default') {
                content.append(toolbar);
            }
            if (hasTime()) {
                content.append($('<li>').addClass(options.collapse && hasDate() ? 'collapse' : '').append(timeView));
            }
            if (options.toolbarPlacement === 'bottom') {
                content.append(toolbar);
            }
            return template.append(content);
        },
            dataToOptions = function dataToOptions() {
            var eData,
                dataOptions = {};

            if (element.is('input') || options.inline) {
                eData = element.data();
            } else {
                eData = element.find('input').data();
            }

            if (eData.dateOptions && eData.dateOptions instanceof Object) {
                dataOptions = $.extend(true, dataOptions, eData.dateOptions);
            }

            $.each(options, function (key) {
                var attributeName = 'date' + key.charAt(0).toUpperCase() + key.slice(1);
                if (eData[attributeName] !== undefined) {
                    dataOptions[key] = eData[attributeName];
                }
            });
            return dataOptions;
        },
            place = function place() {
            var position = (component || element).position(),
                offset = (component || element).offset(),
                vertical = options.widgetPositioning.vertical,
                horizontal = options.widgetPositioning.horizontal,
                parent;

            if (options.widgetParent) {
                parent = options.widgetParent.append(widget);
            } else if (element.is('input')) {
                parent = element.after(widget).parent();
            } else if (options.inline) {
                parent = element.append(widget);
                return;
            } else {
                parent = element;
                element.children().first().after(widget);
            }

            // Top and bottom logic
            if (vertical === 'auto') {
                if (offset.top + widget.height() * 1.5 >= $(window).height() + $(window).scrollTop() && widget.height() + element.outerHeight() < offset.top) {
                    vertical = 'top';
                } else {
                    vertical = 'bottom';
                }
            }

            // Left and right logic
            if (horizontal === 'auto') {
                if (parent.width() < offset.left + widget.outerWidth() / 2 && offset.left + widget.outerWidth() > $(window).width()) {
                    horizontal = 'right';
                } else {
                    horizontal = 'left';
                }
            }

            if (vertical === 'top') {
                widget.addClass('top').removeClass('bottom');
            } else {
                widget.addClass('bottom').removeClass('top');
            }

            if (horizontal === 'right') {
                widget.addClass('pull-right');
            } else {
                widget.removeClass('pull-right');
            }

            // find the first parent element that has a non-static css positioning
            if (parent.css('position') === 'static') {
                parent = parent.parents().filter(function () {
                    return $(this).css('position') !== 'static';
                }).first();
            }

            if (parent.length === 0) {
                throw new Error('datetimepicker component should be placed within a non-static positioned container');
            }

            widget.css({
                top: vertical === 'top' ? 'auto' : position.top + element.outerHeight(),
                bottom: vertical === 'top' ? parent.outerHeight() - (parent === element ? 0 : position.top) : 'auto',
                left: horizontal === 'left' ? parent === element ? 0 : position.left : 'auto',
                right: horizontal === 'left' ? 'auto' : parent.outerWidth() - element.outerWidth() - (parent === element ? 0 : position.left)
            });
        },
            notifyEvent = function notifyEvent(e) {
            if (e.type === 'dp.change' && (e.date && e.date.isSame(e.oldDate) || !e.date && !e.oldDate)) {
                return;
            }
            element.trigger(e);
        },
            viewUpdate = function viewUpdate(e) {
            if (e === 'y') {
                e = 'YYYY';
            }
            notifyEvent({
                type: 'dp.update',
                change: e,
                viewDate: viewDate.clone()
            });
        },
            showMode = function showMode(dir) {
            if (!widget) {
                return;
            }
            if (dir) {
                currentViewMode = Math.max(minViewModeNumber, Math.min(3, currentViewMode + dir));
            }
            widget.find('.datepicker > div').hide().filter('.datepicker-' + datePickerModes[currentViewMode].clsName).show();
        },
            fillDow = function fillDow() {
            var row = $('<tr>'),
                currentDate = viewDate.clone().startOf('w').startOf('d');

            if (options.calendarWeeks === true) {
                row.append($('<th>').addClass('cw').text('#'));
            }

            while (currentDate.isBefore(viewDate.clone().endOf('w'))) {
                row.append($('<th>').addClass('dow').text(currentDate.format('dd')));
                currentDate.add(1, 'd');
            }
            widget.find('.datepicker-days thead').append(row);
        },
            isInDisabledDates = function isInDisabledDates(testDate) {
            return options.disabledDates[testDate.format('YYYY-MM-DD')] === true;
        },
            isInEnabledDates = function isInEnabledDates(testDate) {
            return options.enabledDates[testDate.format('YYYY-MM-DD')] === true;
        },
            isInDisabledHours = function isInDisabledHours(testDate) {
            return options.disabledHours[testDate.format('H')] === true;
        },
            isInEnabledHours = function isInEnabledHours(testDate) {
            return options.enabledHours[testDate.format('H')] === true;
        },
            isValid = function isValid(targetMoment, granularity) {
            if (!targetMoment.isValid()) {
                return false;
            }
            if (options.disabledDates && granularity === 'd' && isInDisabledDates(targetMoment)) {
                return false;
            }
            if (options.enabledDates && granularity === 'd' && !isInEnabledDates(targetMoment)) {
                return false;
            }
            if (options.minDate && targetMoment.isBefore(options.minDate, granularity)) {
                return false;
            }
            if (options.maxDate && targetMoment.isAfter(options.maxDate, granularity)) {
                return false;
            }
            if (options.daysOfWeekDisabled && granularity === 'd' && options.daysOfWeekDisabled.indexOf(targetMoment.day()) !== -1) {
                return false;
            }
            if (options.disabledHours && (granularity === 'h' || granularity === 'm' || granularity === 's') && isInDisabledHours(targetMoment)) {
                return false;
            }
            if (options.enabledHours && (granularity === 'h' || granularity === 'm' || granularity === 's') && !isInEnabledHours(targetMoment)) {
                return false;
            }
            if (options.disabledTimeIntervals && (granularity === 'h' || granularity === 'm' || granularity === 's')) {
                var found = false;
                $.each(options.disabledTimeIntervals, function () {
                    if (targetMoment.isBetween(this[0], this[1])) {
                        found = true;
                        return false;
                    }
                });
                if (found) {
                    return false;
                }
            }
            return true;
        },
            fillMonths = function fillMonths() {
            var spans = [],
                monthsShort = viewDate.clone().startOf('y').startOf('d');
            while (monthsShort.isSame(viewDate, 'y')) {
                spans.push($('<span>').attr('data-action', 'selectMonth').addClass('month').text(monthsShort.format('MMM')));
                monthsShort.add(1, 'M');
            }
            widget.find('.datepicker-months td').empty().append(spans);
        },
            updateMonths = function updateMonths() {
            var monthsView = widget.find('.datepicker-months'),
                monthsViewHeader = monthsView.find('th'),
                months = monthsView.find('tbody').find('span');

            monthsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevYear);
            monthsViewHeader.eq(1).attr('title', options.tooltips.selectYear);
            monthsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextYear);

            monthsView.find('.disabled').removeClass('disabled');

            if (!isValid(viewDate.clone().subtract(1, 'y'), 'y')) {
                monthsViewHeader.eq(0).addClass('disabled');
            }

            monthsViewHeader.eq(1).text(viewDate.year());

            if (!isValid(viewDate.clone().add(1, 'y'), 'y')) {
                monthsViewHeader.eq(2).addClass('disabled');
            }

            months.removeClass('active');
            if (date.isSame(viewDate, 'y') && !unset) {
                months.eq(date.month()).addClass('active');
            }

            months.each(function (index) {
                if (!isValid(viewDate.clone().month(index), 'M')) {
                    $(this).addClass('disabled');
                }
            });
        },
            updateYears = function updateYears() {
            var yearsView = widget.find('.datepicker-years'),
                yearsViewHeader = yearsView.find('th'),
                startYear = viewDate.clone().subtract(5, 'y'),
                endYear = viewDate.clone().add(6, 'y'),
                html = '';

            yearsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevDecade);
            yearsViewHeader.eq(1).attr('title', options.tooltips.selectDecade);
            yearsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextDecade);

            yearsView.find('.disabled').removeClass('disabled');

            if (options.minDate && options.minDate.isAfter(startYear, 'y')) {
                yearsViewHeader.eq(0).addClass('disabled');
            }

            yearsViewHeader.eq(1).text(startYear.year() + '-' + endYear.year());

            if (options.maxDate && options.maxDate.isBefore(endYear, 'y')) {
                yearsViewHeader.eq(2).addClass('disabled');
            }

            while (!startYear.isAfter(endYear, 'y')) {
                html += '<span data-action="selectYear" class="year' + (startYear.isSame(date, 'y') && !unset ? ' active' : '') + (!isValid(startYear, 'y') ? ' disabled' : '') + '">' + startYear.year() + '</span>';
                startYear.add(1, 'y');
            }

            yearsView.find('td').html(html);
        },
            updateDecades = function updateDecades() {
            var decadesView = widget.find('.datepicker-decades'),
                decadesViewHeader = decadesView.find('th'),
                startDecade = moment({ y: viewDate.year() - viewDate.year() % 100 - 1 }),
                endDecade = startDecade.clone().add(100, 'y'),
                startedAt = startDecade.clone(),
                minDateDecade = false,
                maxDateDecade = false,
                endDecadeYear,
                html = '';

            decadesViewHeader.eq(0).find('span').attr('title', options.tooltips.prevCentury);
            decadesViewHeader.eq(2).find('span').attr('title', options.tooltips.nextCentury);

            decadesView.find('.disabled').removeClass('disabled');

            if (startDecade.isSame(moment({ y: 1900 })) || options.minDate && options.minDate.isAfter(startDecade, 'y')) {
                decadesViewHeader.eq(0).addClass('disabled');
            }

            decadesViewHeader.eq(1).text(startDecade.year() + '-' + endDecade.year());

            if (startDecade.isSame(moment({ y: 2000 })) || options.maxDate && options.maxDate.isBefore(endDecade, 'y')) {
                decadesViewHeader.eq(2).addClass('disabled');
            }

            while (!startDecade.isAfter(endDecade, 'y')) {
                endDecadeYear = startDecade.year() + 12;
                minDateDecade = options.minDate && options.minDate.isAfter(startDecade, 'y') && options.minDate.year() <= endDecadeYear;
                maxDateDecade = options.maxDate && options.maxDate.isAfter(startDecade, 'y') && options.maxDate.year() <= endDecadeYear;
                html += '<span data-action="selectDecade" class="decade' + (date.isAfter(startDecade) && date.year() <= endDecadeYear ? ' active' : '') + (!isValid(startDecade, 'y') && !minDateDecade && !maxDateDecade ? ' disabled' : '') + '" data-selection="' + (startDecade.year() + 6) + '">' + (startDecade.year() + 1) + ' - ' + (startDecade.year() + 12) + '</span>';
                startDecade.add(12, 'y');
            }
            html += '<span></span><span></span><span></span>'; //push the dangling block over, at least this way it's even

            decadesView.find('td').html(html);
            decadesViewHeader.eq(1).text(startedAt.year() + 1 + '-' + startDecade.year());
        },
            fillDate = function fillDate() {
            var daysView = widget.find('.datepicker-days'),
                daysViewHeader = daysView.find('th'),
                currentDate,
                html = [],
                row,
                clsNames = [],
                i;

            if (!hasDate()) {
                return;
            }

            daysViewHeader.eq(0).find('span').attr('title', options.tooltips.prevMonth);
            daysViewHeader.eq(1).attr('title', options.tooltips.selectMonth);
            daysViewHeader.eq(2).find('span').attr('title', options.tooltips.nextMonth);

            daysView.find('.disabled').removeClass('disabled');
            daysViewHeader.eq(1).text(viewDate.format(options.dayViewHeaderFormat));

            if (!isValid(viewDate.clone().subtract(1, 'M'), 'M')) {
                daysViewHeader.eq(0).addClass('disabled');
            }
            if (!isValid(viewDate.clone().add(1, 'M'), 'M')) {
                daysViewHeader.eq(2).addClass('disabled');
            }

            currentDate = viewDate.clone().startOf('M').startOf('w').startOf('d');

            for (i = 0; i < 42; i++) {
                //always display 42 days (should show 6 weeks)
                if (currentDate.weekday() === 0) {
                    row = $('<tr>');
                    if (options.calendarWeeks) {
                        row.append('<td class="cw">' + currentDate.week() + '</td>');
                    }
                    html.push(row);
                }
                clsNames = ['day'];
                if (currentDate.isBefore(viewDate, 'M')) {
                    clsNames.push('old');
                }
                if (currentDate.isAfter(viewDate, 'M')) {
                    clsNames.push('new');
                }
                if (currentDate.isSame(date, 'd') && !unset) {
                    clsNames.push('active');
                }
                if (!isValid(currentDate, 'd')) {
                    clsNames.push('disabled');
                }
                if (currentDate.isSame(getMoment(), 'd')) {
                    clsNames.push('today');
                }
                if (currentDate.day() === 0 || currentDate.day() === 6) {
                    clsNames.push('weekend');
                }
                notifyEvent({
                    type: 'dp.classify',
                    date: currentDate,
                    classNames: clsNames
                });
                row.append('<td data-action="selectDay" data-day="' + currentDate.format('L') + '" class="' + clsNames.join(' ') + '">' + currentDate.date() + '</td>');
                currentDate.add(1, 'd');
            }

            daysView.find('tbody').empty().append(html);

            updateMonths();

            updateYears();

            updateDecades();
        },
            fillHours = function fillHours() {
            var table = widget.find('.timepicker-hours table'),
                currentHour = viewDate.clone().startOf('d'),
                html = [],
                row = $('<tr>');

            if (viewDate.hour() > 11 && !use24Hours) {
                currentHour.hour(12);
            }
            while (currentHour.isSame(viewDate, 'd') && (use24Hours || viewDate.hour() < 12 && currentHour.hour() < 12 || viewDate.hour() > 11)) {
                if (currentHour.hour() % 4 === 0) {
                    row = $('<tr>');
                    html.push(row);
                }
                row.append('<td data-action="selectHour" class="hour' + (!isValid(currentHour, 'h') ? ' disabled' : '') + '">' + currentHour.format(use24Hours ? 'HH' : 'hh') + '</td>');
                currentHour.add(1, 'h');
            }
            table.empty().append(html);
        },
            fillMinutes = function fillMinutes() {
            var table = widget.find('.timepicker-minutes table'),
                currentMinute = viewDate.clone().startOf('h'),
                html = [],
                row = $('<tr>'),
                step = options.stepping === 1 ? 5 : options.stepping;

            while (viewDate.isSame(currentMinute, 'h')) {
                if (currentMinute.minute() % (step * 4) === 0) {
                    row = $('<tr>');
                    html.push(row);
                }
                row.append('<td data-action="selectMinute" class="minute' + (!isValid(currentMinute, 'm') ? ' disabled' : '') + '">' + currentMinute.format('mm') + '</td>');
                currentMinute.add(step, 'm');
            }
            table.empty().append(html);
        },
            fillSeconds = function fillSeconds() {
            var table = widget.find('.timepicker-seconds table'),
                currentSecond = viewDate.clone().startOf('m'),
                html = [],
                row = $('<tr>');

            while (viewDate.isSame(currentSecond, 'm')) {
                if (currentSecond.second() % 20 === 0) {
                    row = $('<tr>');
                    html.push(row);
                }
                row.append('<td data-action="selectSecond" class="second' + (!isValid(currentSecond, 's') ? ' disabled' : '') + '">' + currentSecond.format('ss') + '</td>');
                currentSecond.add(5, 's');
            }

            table.empty().append(html);
        },
            fillTime = function fillTime() {
            var toggle,
                newDate,
                timeComponents = widget.find('.timepicker span[data-time-component]');

            if (!use24Hours) {
                toggle = widget.find('.timepicker [data-action=togglePeriod]');
                newDate = date.clone().add(date.hours() >= 12 ? -12 : 12, 'h');

                toggle.text(date.format('A'));

                if (isValid(newDate, 'h')) {
                    toggle.removeClass('disabled');
                } else {
                    toggle.addClass('disabled');
                }
            }
            timeComponents.filter('[data-time-component=hours]').text(date.format(use24Hours ? 'HH' : 'hh'));
            timeComponents.filter('[data-time-component=minutes]').text(date.format('mm'));
            timeComponents.filter('[data-time-component=seconds]').text(date.format('ss'));

            fillHours();
            fillMinutes();
            fillSeconds();
        },
            update = function update() {
            if (!widget) {
                return;
            }
            fillDate();
            fillTime();
        },
            setValue = function setValue(targetMoment) {
            var oldDate = unset ? null : date;

            // case of calling setValue(null or false)
            if (!targetMoment) {
                unset = true;
                input.val('');
                element.data('date', '');
                notifyEvent({
                    type: 'dp.change',
                    date: false,
                    oldDate: oldDate
                });
                update();
                return;
            }

            targetMoment = targetMoment.clone().locale(options.locale);

            if (hasTimeZone()) {
                targetMoment.tz(options.timeZone);
            }

            if (options.stepping !== 1) {
                targetMoment.minutes(Math.round(targetMoment.minutes() / options.stepping) * options.stepping).seconds(0);

                while (options.minDate && targetMoment.isBefore(options.minDate)) {
                    targetMoment.add(options.stepping, 'minutes');
                }
            }

            if (isValid(targetMoment)) {
                date = targetMoment;
                viewDate = date.clone();
                input.val(date.format(actualFormat));
                element.data('date', date.format(actualFormat));
                unset = false;
                update();
                notifyEvent({
                    type: 'dp.change',
                    date: date.clone(),
                    oldDate: oldDate
                });
            } else {
                if (!options.keepInvalid) {
                    input.val(unset ? '' : date.format(actualFormat));
                } else {
                    notifyEvent({
                        type: 'dp.change',
                        date: targetMoment,
                        oldDate: oldDate
                    });
                }
                notifyEvent({
                    type: 'dp.error',
                    date: targetMoment,
                    oldDate: oldDate
                });
            }
        },


        /**
         * Hides the widget. Possibly will emit dp.hide
         */
        hide = function hide() {
            var transitioning = false;
            if (!widget) {
                return picker;
            }
            // Ignore event if in the middle of a picker transition
            widget.find('.collapse').each(function () {
                var collapseData = $(this).data('collapse');
                if (collapseData && collapseData.transitioning) {
                    transitioning = true;
                    return false;
                }
                return true;
            });
            if (transitioning) {
                return picker;
            }
            if (component && component.hasClass('btn')) {
                component.toggleClass('active');
            }
            widget.hide();

            $(window).off('resize', place);
            widget.off('click', '[data-action]');
            widget.off('mousedown', false);

            widget.remove();
            widget = false;

            notifyEvent({
                type: 'dp.hide',
                date: date.clone()
            });

            input.blur();

            viewDate = date.clone();

            return picker;
        },
            clear = function clear() {
            setValue(null);
        },
            parseInputDate = function parseInputDate(inputDate) {
            if (options.parseInputDate === undefined) {
                if (!moment.isMoment(inputDate) || inputDate instanceof Date) {
                    inputDate = getMoment(inputDate);
                }
            } else {
                inputDate = options.parseInputDate(inputDate);
            }
            //inputDate.locale(options.locale);
            return inputDate;
        },


        /********************************************************************************
         *
         * Widget UI interaction functions
         *
         ********************************************************************************/
        actions = {
            next: function next() {
                var navFnc = datePickerModes[currentViewMode].navFnc;
                viewDate.add(datePickerModes[currentViewMode].navStep, navFnc);
                fillDate();
                viewUpdate(navFnc);
            },

            previous: function previous() {
                var navFnc = datePickerModes[currentViewMode].navFnc;
                viewDate.subtract(datePickerModes[currentViewMode].navStep, navFnc);
                fillDate();
                viewUpdate(navFnc);
            },

            pickerSwitch: function pickerSwitch() {
                showMode(1);
            },

            selectMonth: function selectMonth(e) {
                var month = $(e.target).closest('tbody').find('span').index($(e.target));
                viewDate.month(month);
                if (currentViewMode === minViewModeNumber) {
                    setValue(date.clone().year(viewDate.year()).month(viewDate.month()));
                    if (!options.inline) {
                        hide();
                    }
                } else {
                    showMode(-1);
                    fillDate();
                }
                viewUpdate('M');
            },

            selectYear: function selectYear(e) {
                var year = parseInt($(e.target).text(), 10) || 0;
                viewDate.year(year);
                if (currentViewMode === minViewModeNumber) {
                    setValue(date.clone().year(viewDate.year()));
                    if (!options.inline) {
                        hide();
                    }
                } else {
                    showMode(-1);
                    fillDate();
                }
                viewUpdate('YYYY');
            },

            selectDecade: function selectDecade(e) {
                var year = parseInt($(e.target).data('selection'), 10) || 0;
                viewDate.year(year);
                if (currentViewMode === minViewModeNumber) {
                    setValue(date.clone().year(viewDate.year()));
                    if (!options.inline) {
                        hide();
                    }
                } else {
                    showMode(-1);
                    fillDate();
                }
                viewUpdate('YYYY');
            },

            selectDay: function selectDay(e) {
                var day = viewDate.clone();
                if ($(e.target).is('.old')) {
                    day.subtract(1, 'M');
                }
                if ($(e.target).is('.new')) {
                    day.add(1, 'M');
                }
                setValue(day.date(parseInt($(e.target).text(), 10)));
                if (!hasTime() && !options.keepOpen && !options.inline) {
                    hide();
                }
            },

            incrementHours: function incrementHours() {
                var newDate = date.clone().add(1, 'h');
                if (isValid(newDate, 'h')) {
                    setValue(newDate);
                }
            },

            incrementMinutes: function incrementMinutes() {
                var newDate = date.clone().add(options.stepping, 'm');
                if (isValid(newDate, 'm')) {
                    setValue(newDate);
                }
            },

            incrementSeconds: function incrementSeconds() {
                var newDate = date.clone().add(1, 's');
                if (isValid(newDate, 's')) {
                    setValue(newDate);
                }
            },

            decrementHours: function decrementHours() {
                var newDate = date.clone().subtract(1, 'h');
                if (isValid(newDate, 'h')) {
                    setValue(newDate);
                }
            },

            decrementMinutes: function decrementMinutes() {
                var newDate = date.clone().subtract(options.stepping, 'm');
                if (isValid(newDate, 'm')) {
                    setValue(newDate);
                }
            },

            decrementSeconds: function decrementSeconds() {
                var newDate = date.clone().subtract(1, 's');
                if (isValid(newDate, 's')) {
                    setValue(newDate);
                }
            },

            togglePeriod: function togglePeriod() {
                setValue(date.clone().add(date.hours() >= 12 ? -12 : 12, 'h'));
            },

            togglePicker: function togglePicker(e) {
                var $this = $(e.target),
                    $link = $this.closest('a'),
                    $parent = $this.closest('ul'),
                    expanded = $parent.find('.show'),
                    closed = $parent.find('.collapse:not(.show)'),
                    collapseData;

                if (expanded && expanded.length) {
                    collapseData = expanded.data('collapse');
                    if (collapseData && collapseData.transitioning) {
                        return;
                    }
                    if (expanded.collapse) {
                        // if collapse plugin is available through bootstrap.js then use it
                        expanded.collapse('hide');
                        closed.collapse('show');
                    } else {
                        // otherwise just toggle in class on the two views
                        expanded.removeClass('show');
                        closed.addClass('show');
                    }
                    if ($this.is('i')) {
                        $this.toggleClass(options.icons.time + ' ' + options.icons.date);
                        if ($this.hasClass(options.icons.date)) {
                            $link.attr('title', options.tooltips.selectDate);
                        } else {
                            $link.attr('title', options.tooltips.selectTime);
                        }
                    } else {
                        $this.find('i').toggleClass(options.icons.time + ' ' + options.icons.date);
                        if ($this.hasClass(options.icons.date)) {
                            $link.attr('title', options.tooltips.selectDate);
                        } else {
                            $link.attr('title', options.tooltips.selectTime);
                        }
                    }

                    // NOTE: uncomment if toggled state will be restored in show()
                    //if (component) {
                    //    component.find('span').toggleClass(options.icons.time + ' ' + options.icons.date);
                    //}
                }
            },

            showPicker: function showPicker() {
                widget.find('.timepicker > div:not(.timepicker-picker)').hide();
                widget.find('.timepicker .timepicker-picker').show();
            },

            showHours: function showHours() {
                widget.find('.timepicker .timepicker-picker').hide();
                widget.find('.timepicker .timepicker-hours').show();
            },

            showMinutes: function showMinutes() {
                widget.find('.timepicker .timepicker-picker').hide();
                widget.find('.timepicker .timepicker-minutes').show();
            },

            showSeconds: function showSeconds() {
                widget.find('.timepicker .timepicker-picker').hide();
                widget.find('.timepicker .timepicker-seconds').show();
            },

            selectHour: function selectHour(e) {
                var hour = parseInt($(e.target).text(), 10);

                if (!use24Hours) {
                    if (date.hours() >= 12) {
                        if (hour !== 12) {
                            hour += 12;
                        }
                    } else {
                        if (hour === 12) {
                            hour = 0;
                        }
                    }
                }
                setValue(date.clone().hours(hour));
                actions.showPicker.call(picker);
            },

            selectMinute: function selectMinute(e) {
                setValue(date.clone().minutes(parseInt($(e.target).text(), 10)));
                actions.showPicker.call(picker);
            },

            selectSecond: function selectSecond(e) {
                setValue(date.clone().seconds(parseInt($(e.target).text(), 10)));
                actions.showPicker.call(picker);
            },

            clear: clear,

            today: function today() {
                var todaysDate = getMoment();
                if (isValid(todaysDate, 'd')) {
                    setValue(todaysDate);
                }
            },

            close: hide
        },
            doAction = function doAction(e) {
            if ($(e.currentTarget).is('.disabled')) {
                return false;
            }
            actions[$(e.currentTarget).data('action')].apply(picker, arguments);
            return false;
        },


        /**
         * Shows the widget. Possibly will emit dp.show and dp.change
         */
        show = function show() {
            var currentMoment,
                useCurrentGranularity = {
                'year': function year(m) {
                    return m.month(0).date(1).hours(0).seconds(0).minutes(0);
                },
                'month': function month(m) {
                    return m.date(1).hours(0).seconds(0).minutes(0);
                },
                'day': function day(m) {
                    return m.hours(0).seconds(0).minutes(0);
                },
                'hour': function hour(m) {
                    return m.seconds(0).minutes(0);
                },
                'minute': function minute(m) {
                    return m.seconds(0);
                }
            };

            if (input.prop('disabled') || !options.ignoreReadonly && input.prop('readonly') || widget) {
                return picker;
            }
            if (input.val() !== undefined && input.val().trim().length !== 0) {
                setValue(parseInputDate(input.val().trim()));
            } else if (unset && options.useCurrent && (options.inline || input.is('input') && input.val().trim().length === 0)) {
                currentMoment = getMoment();
                if (typeof options.useCurrent === 'string') {
                    currentMoment = useCurrentGranularity[options.useCurrent](currentMoment);
                }
                setValue(currentMoment);
            }
            widget = getTemplate();

            fillDow();
            fillMonths();

            widget.find('.timepicker-hours').hide();
            widget.find('.timepicker-minutes').hide();
            widget.find('.timepicker-seconds').hide();

            update();
            showMode();

            $(window).on('resize', place);
            widget.on('click', '[data-action]', doAction); // this handles clicks on the widget
            widget.on('mousedown', false);

            if (component && component.hasClass('btn')) {
                component.toggleClass('active');
            }
            place();
            widget.show();
            if (options.focusOnShow && !input.is(':focus')) {
                input.focus();
            }

            notifyEvent({
                type: 'dp.show'
            });
            return picker;
        },


        /**
         * Shows or hides the widget
         */
        toggle = function toggle() {
            return widget ? hide() : show();
        },
            keydown = function keydown(e) {
            var handler = null,
                index,
                index2,
                pressedKeys = [],
                pressedModifiers = {},
                currentKey = e.which,
                keyBindKeys,
                allModifiersPressed,
                pressed = 'p';

            keyState[currentKey] = pressed;

            for (index in keyState) {
                if (keyState.hasOwnProperty(index) && keyState[index] === pressed) {
                    pressedKeys.push(index);
                    if (parseInt(index, 10) !== currentKey) {
                        pressedModifiers[index] = true;
                    }
                }
            }

            for (index in options.keyBinds) {
                if (options.keyBinds.hasOwnProperty(index) && typeof options.keyBinds[index] === 'function') {
                    keyBindKeys = index.split(' ');
                    if (keyBindKeys.length === pressedKeys.length && keyMap[currentKey] === keyBindKeys[keyBindKeys.length - 1]) {
                        allModifiersPressed = true;
                        for (index2 = keyBindKeys.length - 2; index2 >= 0; index2--) {
                            if (!(keyMap[keyBindKeys[index2]] in pressedModifiers)) {
                                allModifiersPressed = false;
                                break;
                            }
                        }
                        if (allModifiersPressed) {
                            handler = options.keyBinds[index];
                            break;
                        }
                    }
                }
            }

            if (handler) {
                handler.call(picker, widget);
                e.stopPropagation();
                e.preventDefault();
            }
        },
            keyup = function keyup(e) {
            keyState[e.which] = 'r';
            e.stopPropagation();
            e.preventDefault();
        },
            change = function change(e) {
            var val = $(e.target).val().trim(),
                parsedDate = val ? parseInputDate(val) : null;
            setValue(parsedDate);
            e.stopImmediatePropagation();
            return false;
        },
            attachDatePickerElementEvents = function attachDatePickerElementEvents() {
            input.on({
                'change': change,
                'blur': options.debug ? '' : hide,
                'keydown': keydown,
                'keyup': keyup,
                'focus': options.allowInputToggle ? show : ''
            });

            if (element.is('input')) {
                input.on({
                    'focus': show
                });
            } else if (component) {
                component.on('click', toggle);
                component.on('mousedown', false);
            }
        },
            detachDatePickerElementEvents = function detachDatePickerElementEvents() {
            input.off({
                'change': change,
                'blur': blur,
                'keydown': keydown,
                'keyup': keyup,
                'focus': options.allowInputToggle ? hide : ''
            });

            if (element.is('input')) {
                input.off({
                    'focus': show
                });
            } else if (component) {
                component.off('click', toggle);
                component.off('mousedown', false);
            }
        },
            indexGivenDates = function indexGivenDates(givenDatesArray) {
            // Store given enabledDates and disabledDates as keys.
            // This way we can check their existence in O(1) time instead of looping through whole array.
            // (for example: options.enabledDates['2014-02-27'] === true)
            var givenDatesIndexed = {};
            $.each(givenDatesArray, function () {
                var dDate = parseInputDate(this);
                if (dDate.isValid()) {
                    givenDatesIndexed[dDate.format('YYYY-MM-DD')] = true;
                }
            });
            return Object.keys(givenDatesIndexed).length ? givenDatesIndexed : false;
        },
            indexGivenHours = function indexGivenHours(givenHoursArray) {
            // Store given enabledHours and disabledHours as keys.
            // This way we can check their existence in O(1) time instead of looping through whole array.
            // (for example: options.enabledHours['2014-02-27'] === true)
            var givenHoursIndexed = {};
            $.each(givenHoursArray, function () {
                givenHoursIndexed[this] = true;
            });
            return Object.keys(givenHoursIndexed).length ? givenHoursIndexed : false;
        },
            initFormatting = function initFormatting() {
            var format = options.format || 'L LT';

            actualFormat = format.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (formatInput) {
                var newinput = date.localeData().longDateFormat(formatInput) || formatInput;
                return newinput.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (formatInput2) {
                    //temp fix for #740
                    return date.localeData().longDateFormat(formatInput2) || formatInput2;
                });
            });

            parseFormats = options.extraFormats ? options.extraFormats.slice() : [];
            if (parseFormats.indexOf(format) < 0 && parseFormats.indexOf(actualFormat) < 0) {
                parseFormats.push(actualFormat);
            }

            use24Hours = actualFormat.toLowerCase().indexOf('a') < 1 && actualFormat.replace(/\[.*?\]/g, '').indexOf('h') < 1;

            if (isEnabled('y')) {
                minViewModeNumber = 2;
            }
            if (isEnabled('M')) {
                minViewModeNumber = 1;
            }
            if (isEnabled('d')) {
                minViewModeNumber = 0;
            }

            currentViewMode = Math.max(minViewModeNumber, currentViewMode);

            if (!unset) {
                setValue(date);
            }
        };

        /********************************************************************************
         *
         * Public API functions
         * =====================
         *
         * Important: Do not expose direct references to private objects or the options
         * object to the outer world. Always return a clone when returning values or make
         * a clone when setting a private variable.
         *
         ********************************************************************************/
        picker.destroy = function () {
            ///<summary>Destroys the widget and removes all attached event listeners</summary>
            hide();
            detachDatePickerElementEvents();
            element.removeData('DateTimePicker');
            element.removeData('date');
        };

        picker.toggle = toggle;

        picker.show = show;

        picker.hide = hide;

        picker.disable = function () {
            ///<summary>Disables the input element, the component is attached to, by adding a disabled="true" attribute to it.
            ///If the widget was visible before that call it is hidden. Possibly emits dp.hide</summary>
            hide();
            if (component && component.hasClass('btn')) {
                component.addClass('disabled');
            }
            input.prop('disabled', true);
            return picker;
        };

        picker.enable = function () {
            ///<summary>Enables the input element, the component is attached to, by removing disabled attribute from it.</summary>
            if (component && component.hasClass('btn')) {
                component.removeClass('disabled');
            }
            input.prop('disabled', false);
            return picker;
        };

        picker.ignoreReadonly = function (ignoreReadonly) {
            if (arguments.length === 0) {
                return options.ignoreReadonly;
            }
            if (typeof ignoreReadonly !== 'boolean') {
                throw new TypeError('ignoreReadonly () expects a boolean parameter');
            }
            options.ignoreReadonly = ignoreReadonly;
            return picker;
        };

        picker.options = function (newOptions) {
            if (arguments.length === 0) {
                return $.extend(true, {}, options);
            }

            if (!(newOptions instanceof Object)) {
                throw new TypeError('options() options parameter should be an object');
            }
            $.extend(true, options, newOptions);
            $.each(options, function (key, value) {
                if (picker[key] !== undefined) {
                    picker[key](value);
                } else {
                    throw new TypeError('option ' + key + ' is not recognized!');
                }
            });
            return picker;
        };

        picker.date = function (newDate) {
            ///<signature helpKeyword="$.fn.datetimepicker.date">
            ///<summary>Returns the component's model current date, a moment object or null if not set.</summary>
            ///<returns type="Moment">date.clone()</returns>
            ///</signature>
            ///<signature>
            ///<summary>Sets the components model current moment to it. Passing a null value unsets the components model current moment. Parsing of the newDate parameter is made using moment library with the options.format and options.useStrict components configuration.</summary>
            ///<param name="newDate" locid="$.fn.datetimepicker.date_p:newDate">Takes string, Date, moment, null parameter.</param>
            ///</signature>
            if (arguments.length === 0) {
                if (unset) {
                    return null;
                }
                return date.clone();
            }

            if (newDate !== null && typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
                throw new TypeError('date() parameter must be one of [null, string, moment or Date]');
            }

            setValue(newDate === null ? null : parseInputDate(newDate));
            return picker;
        };

        picker.format = function (newFormat) {
            ///<summary>test su</summary>
            ///<param name="newFormat">info about para</param>
            ///<returns type="string|boolean">returns foo</returns>
            if (arguments.length === 0) {
                return options.format;
            }

            if (typeof newFormat !== 'string' && (typeof newFormat !== 'boolean' || newFormat !== false)) {
                throw new TypeError('format() expects a string or boolean:false parameter ' + newFormat);
            }

            options.format = newFormat;
            if (actualFormat) {
                initFormatting(); // reinit formatting
            }
            return picker;
        };

        picker.timeZone = function (newZone) {
            if (arguments.length === 0) {
                return options.timeZone;
            }

            if (typeof newZone !== 'string') {
                throw new TypeError('newZone() expects a string parameter');
            }

            options.timeZone = newZone;

            return picker;
        };

        picker.dayViewHeaderFormat = function (newFormat) {
            if (arguments.length === 0) {
                return options.dayViewHeaderFormat;
            }

            if (typeof newFormat !== 'string') {
                throw new TypeError('dayViewHeaderFormat() expects a string parameter');
            }

            options.dayViewHeaderFormat = newFormat;
            return picker;
        };

        picker.extraFormats = function (formats) {
            if (arguments.length === 0) {
                return options.extraFormats;
            }

            if (formats !== false && !(formats instanceof Array)) {
                throw new TypeError('extraFormats() expects an array or false parameter');
            }

            options.extraFormats = formats;
            if (parseFormats) {
                initFormatting(); // reinit formatting
            }
            return picker;
        };

        picker.disabledDates = function (dates) {
            ///<signature helpKeyword="$.fn.datetimepicker.disabledDates">
            ///<summary>Returns an array with the currently set disabled dates on the component.</summary>
            ///<returns type="array">options.disabledDates</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
            ///options.enabledDates if such exist.</summary>
            ///<param name="dates" locid="$.fn.datetimepicker.disabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
            ///</signature>
            if (arguments.length === 0) {
                return options.disabledDates ? $.extend({}, options.disabledDates) : options.disabledDates;
            }

            if (!dates) {
                options.disabledDates = false;
                update();
                return picker;
            }
            if (!(dates instanceof Array)) {
                throw new TypeError('disabledDates() expects an array parameter');
            }
            options.disabledDates = indexGivenDates(dates);
            options.enabledDates = false;
            update();
            return picker;
        };

        picker.enabledDates = function (dates) {
            ///<signature helpKeyword="$.fn.datetimepicker.enabledDates">
            ///<summary>Returns an array with the currently set enabled dates on the component.</summary>
            ///<returns type="array">options.enabledDates</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of options.disabledDates if such exist.</summary>
            ///<param name="dates" locid="$.fn.datetimepicker.enabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
            ///</signature>
            if (arguments.length === 0) {
                return options.enabledDates ? $.extend({}, options.enabledDates) : options.enabledDates;
            }

            if (!dates) {
                options.enabledDates = false;
                update();
                return picker;
            }
            if (!(dates instanceof Array)) {
                throw new TypeError('enabledDates() expects an array parameter');
            }
            options.enabledDates = indexGivenDates(dates);
            options.disabledDates = false;
            update();
            return picker;
        };

        picker.daysOfWeekDisabled = function (daysOfWeekDisabled) {
            if (arguments.length === 0) {
                return options.daysOfWeekDisabled.splice(0);
            }

            if (typeof daysOfWeekDisabled === 'boolean' && !daysOfWeekDisabled) {
                options.daysOfWeekDisabled = false;
                update();
                return picker;
            }

            if (!(daysOfWeekDisabled instanceof Array)) {
                throw new TypeError('daysOfWeekDisabled() expects an array parameter');
            }
            options.daysOfWeekDisabled = daysOfWeekDisabled.reduce(function (previousValue, currentValue) {
                currentValue = parseInt(currentValue, 10);
                if (currentValue > 6 || currentValue < 0 || isNaN(currentValue)) {
                    return previousValue;
                }
                if (previousValue.indexOf(currentValue) === -1) {
                    previousValue.push(currentValue);
                }
                return previousValue;
            }, []).sort();
            if (options.useCurrent && !options.keepInvalid) {
                var tries = 0;
                while (!isValid(date, 'd')) {
                    date.add(1, 'd');
                    if (tries === 31) {
                        throw 'Tried 31 times to find a valid date';
                    }
                    tries++;
                }
                setValue(date);
            }
            update();
            return picker;
        };

        picker.maxDate = function (maxDate) {
            if (arguments.length === 0) {
                return options.maxDate ? options.maxDate.clone() : options.maxDate;
            }

            if (typeof maxDate === 'boolean' && maxDate === false) {
                options.maxDate = false;
                update();
                return picker;
            }

            if (typeof maxDate === 'string') {
                if (maxDate === 'now' || maxDate === 'moment') {
                    maxDate = getMoment();
                }
            }

            var parsedDate = parseInputDate(maxDate);

            if (!parsedDate.isValid()) {
                throw new TypeError('maxDate() Could not parse date parameter: ' + maxDate);
            }
            if (options.minDate && parsedDate.isBefore(options.minDate)) {
                throw new TypeError('maxDate() date parameter is before options.minDate: ' + parsedDate.format(actualFormat));
            }
            options.maxDate = parsedDate;
            if (options.useCurrent && !options.keepInvalid && date.isAfter(maxDate)) {
                setValue(options.maxDate);
            }
            if (viewDate.isAfter(parsedDate)) {
                viewDate = parsedDate.clone().subtract(options.stepping, 'm');
            }
            update();
            return picker;
        };

        picker.minDate = function (minDate) {
            if (arguments.length === 0) {
                return options.minDate ? options.minDate.clone() : options.minDate;
            }

            if (typeof minDate === 'boolean' && minDate === false) {
                options.minDate = false;
                update();
                return picker;
            }

            if (typeof minDate === 'string') {
                if (minDate === 'now' || minDate === 'moment') {
                    minDate = getMoment();
                }
            }

            var parsedDate = parseInputDate(minDate);

            if (!parsedDate.isValid()) {
                throw new TypeError('minDate() Could not parse date parameter: ' + minDate);
            }
            if (options.maxDate && parsedDate.isAfter(options.maxDate)) {
                throw new TypeError('minDate() date parameter is after options.maxDate: ' + parsedDate.format(actualFormat));
            }
            options.minDate = parsedDate;
            if (options.useCurrent && !options.keepInvalid && date.isBefore(minDate)) {
                setValue(options.minDate);
            }
            if (viewDate.isBefore(parsedDate)) {
                viewDate = parsedDate.clone().add(options.stepping, 'm');
            }
            update();
            return picker;
        };

        picker.defaultDate = function (defaultDate) {
            ///<signature helpKeyword="$.fn.datetimepicker.defaultDate">
            ///<summary>Returns a moment with the options.defaultDate option configuration or false if not set</summary>
            ///<returns type="Moment">date.clone()</returns>
            ///</signature>
            ///<signature>
            ///<summary>Will set the picker's inital date. If a boolean:false value is passed the options.defaultDate parameter is cleared.</summary>
            ///<param name="defaultDate" locid="$.fn.datetimepicker.defaultDate_p:defaultDate">Takes a string, Date, moment, boolean:false</param>
            ///</signature>
            if (arguments.length === 0) {
                return options.defaultDate ? options.defaultDate.clone() : options.defaultDate;
            }
            if (!defaultDate) {
                options.defaultDate = false;
                return picker;
            }

            if (typeof defaultDate === 'string') {
                if (defaultDate === 'now' || defaultDate === 'moment') {
                    defaultDate = getMoment();
                } else {
                    defaultDate = getMoment(defaultDate);
                }
            }

            var parsedDate = parseInputDate(defaultDate);
            if (!parsedDate.isValid()) {
                throw new TypeError('defaultDate() Could not parse date parameter: ' + defaultDate);
            }
            if (!isValid(parsedDate)) {
                throw new TypeError('defaultDate() date passed is invalid according to component setup validations');
            }

            options.defaultDate = parsedDate;

            if (options.defaultDate && options.inline || input.val().trim() === '') {
                setValue(options.defaultDate);
            }
            return picker;
        };

        picker.locale = function (locale) {
            if (arguments.length === 0) {
                return options.locale;
            }

            if (!moment.localeData(locale)) {
                throw new TypeError('locale() locale ' + locale + ' is not loaded from moment locales!');
            }

            options.locale = locale;
            date.locale(options.locale);
            viewDate.locale(options.locale);

            if (actualFormat) {
                initFormatting(); // reinit formatting
            }
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.stepping = function (stepping) {
            if (arguments.length === 0) {
                return options.stepping;
            }

            stepping = parseInt(stepping, 10);
            if (isNaN(stepping) || stepping < 1) {
                stepping = 1;
            }
            options.stepping = stepping;
            return picker;
        };

        picker.useCurrent = function (useCurrent) {
            var useCurrentOptions = ['year', 'month', 'day', 'hour', 'minute'];
            if (arguments.length === 0) {
                return options.useCurrent;
            }

            if (typeof useCurrent !== 'boolean' && typeof useCurrent !== 'string') {
                throw new TypeError('useCurrent() expects a boolean or string parameter');
            }
            if (typeof useCurrent === 'string' && useCurrentOptions.indexOf(useCurrent.toLowerCase()) === -1) {
                throw new TypeError('useCurrent() expects a string parameter of ' + useCurrentOptions.join(', '));
            }
            options.useCurrent = useCurrent;
            return picker;
        };

        picker.collapse = function (collapse) {
            if (arguments.length === 0) {
                return options.collapse;
            }

            if (typeof collapse !== 'boolean') {
                throw new TypeError('collapse() expects a boolean parameter');
            }
            if (options.collapse === collapse) {
                return picker;
            }
            options.collapse = collapse;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.icons = function (icons) {
            if (arguments.length === 0) {
                return $.extend({}, options.icons);
            }

            if (!(icons instanceof Object)) {
                throw new TypeError('icons() expects parameter to be an Object');
            }
            $.extend(options.icons, icons);
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.tooltips = function (tooltips) {
            if (arguments.length === 0) {
                return $.extend({}, options.tooltips);
            }

            if (!(tooltips instanceof Object)) {
                throw new TypeError('tooltips() expects parameter to be an Object');
            }
            $.extend(options.tooltips, tooltips);
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.useStrict = function (useStrict) {
            if (arguments.length === 0) {
                return options.useStrict;
            }

            if (typeof useStrict !== 'boolean') {
                throw new TypeError('useStrict() expects a boolean parameter');
            }
            options.useStrict = useStrict;
            return picker;
        };

        picker.sideBySide = function (sideBySide) {
            if (arguments.length === 0) {
                return options.sideBySide;
            }

            if (typeof sideBySide !== 'boolean') {
                throw new TypeError('sideBySide() expects a boolean parameter');
            }
            options.sideBySide = sideBySide;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.viewMode = function (viewMode) {
            if (arguments.length === 0) {
                return options.viewMode;
            }

            if (typeof viewMode !== 'string') {
                throw new TypeError('viewMode() expects a string parameter');
            }

            if (viewModes.indexOf(viewMode) === -1) {
                throw new TypeError('viewMode() parameter must be one of (' + viewModes.join(', ') + ') value');
            }

            options.viewMode = viewMode;
            currentViewMode = Math.max(viewModes.indexOf(viewMode), minViewModeNumber);

            showMode();
            return picker;
        };

        picker.toolbarPlacement = function (toolbarPlacement) {
            if (arguments.length === 0) {
                return options.toolbarPlacement;
            }

            if (typeof toolbarPlacement !== 'string') {
                throw new TypeError('toolbarPlacement() expects a string parameter');
            }
            if (toolbarPlacements.indexOf(toolbarPlacement) === -1) {
                throw new TypeError('toolbarPlacement() parameter must be one of (' + toolbarPlacements.join(', ') + ') value');
            }
            options.toolbarPlacement = toolbarPlacement;

            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.widgetPositioning = function (widgetPositioning) {
            if (arguments.length === 0) {
                return $.extend({}, options.widgetPositioning);
            }

            if ({}.toString.call(widgetPositioning) !== '[object Object]') {
                throw new TypeError('widgetPositioning() expects an object variable');
            }
            if (widgetPositioning.horizontal) {
                if (typeof widgetPositioning.horizontal !== 'string') {
                    throw new TypeError('widgetPositioning() horizontal variable must be a string');
                }
                widgetPositioning.horizontal = widgetPositioning.horizontal.toLowerCase();
                if (horizontalModes.indexOf(widgetPositioning.horizontal) === -1) {
                    throw new TypeError('widgetPositioning() expects horizontal parameter to be one of (' + horizontalModes.join(', ') + ')');
                }
                options.widgetPositioning.horizontal = widgetPositioning.horizontal;
            }
            if (widgetPositioning.vertical) {
                if (typeof widgetPositioning.vertical !== 'string') {
                    throw new TypeError('widgetPositioning() vertical variable must be a string');
                }
                widgetPositioning.vertical = widgetPositioning.vertical.toLowerCase();
                if (verticalModes.indexOf(widgetPositioning.vertical) === -1) {
                    throw new TypeError('widgetPositioning() expects vertical parameter to be one of (' + verticalModes.join(', ') + ')');
                }
                options.widgetPositioning.vertical = widgetPositioning.vertical;
            }
            update();
            return picker;
        };

        picker.calendarWeeks = function (calendarWeeks) {
            if (arguments.length === 0) {
                return options.calendarWeeks;
            }

            if (typeof calendarWeeks !== 'boolean') {
                throw new TypeError('calendarWeeks() expects parameter to be a boolean value');
            }

            options.calendarWeeks = calendarWeeks;
            update();
            return picker;
        };

        picker.showTodayButton = function (showTodayButton) {
            if (arguments.length === 0) {
                return options.showTodayButton;
            }

            if (typeof showTodayButton !== 'boolean') {
                throw new TypeError('showTodayButton() expects a boolean parameter');
            }

            options.showTodayButton = showTodayButton;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.showClear = function (showClear) {
            if (arguments.length === 0) {
                return options.showClear;
            }

            if (typeof showClear !== 'boolean') {
                throw new TypeError('showClear() expects a boolean parameter');
            }

            options.showClear = showClear;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.widgetParent = function (widgetParent) {
            if (arguments.length === 0) {
                return options.widgetParent;
            }

            if (typeof widgetParent === 'string') {
                widgetParent = $(widgetParent);
            }

            if (widgetParent !== null && typeof widgetParent !== 'string' && !(widgetParent instanceof $)) {
                throw new TypeError('widgetParent() expects a string or a jQuery object parameter');
            }

            options.widgetParent = widgetParent;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.keepOpen = function (keepOpen) {
            if (arguments.length === 0) {
                return options.keepOpen;
            }

            if (typeof keepOpen !== 'boolean') {
                throw new TypeError('keepOpen() expects a boolean parameter');
            }

            options.keepOpen = keepOpen;
            return picker;
        };

        picker.focusOnShow = function (focusOnShow) {
            if (arguments.length === 0) {
                return options.focusOnShow;
            }

            if (typeof focusOnShow !== 'boolean') {
                throw new TypeError('focusOnShow() expects a boolean parameter');
            }

            options.focusOnShow = focusOnShow;
            return picker;
        };

        picker.inline = function (inline) {
            if (arguments.length === 0) {
                return options.inline;
            }

            if (typeof inline !== 'boolean') {
                throw new TypeError('inline() expects a boolean parameter');
            }

            options.inline = inline;
            return picker;
        };

        picker.clear = function () {
            clear();
            return picker;
        };

        picker.keyBinds = function (keyBinds) {
            if (arguments.length === 0) {
                return options.keyBinds;
            }

            options.keyBinds = keyBinds;
            return picker;
        };

        picker.getMoment = function (d) {
            return getMoment(d);
        };

        picker.debug = function (debug) {
            if (typeof debug !== 'boolean') {
                throw new TypeError('debug() expects a boolean parameter');
            }

            options.debug = debug;
            return picker;
        };

        picker.allowInputToggle = function (allowInputToggle) {
            if (arguments.length === 0) {
                return options.allowInputToggle;
            }

            if (typeof allowInputToggle !== 'boolean') {
                throw new TypeError('allowInputToggle() expects a boolean parameter');
            }

            options.allowInputToggle = allowInputToggle;
            return picker;
        };

        picker.showClose = function (showClose) {
            if (arguments.length === 0) {
                return options.showClose;
            }

            if (typeof showClose !== 'boolean') {
                throw new TypeError('showClose() expects a boolean parameter');
            }

            options.showClose = showClose;
            return picker;
        };

        picker.keepInvalid = function (keepInvalid) {
            if (arguments.length === 0) {
                return options.keepInvalid;
            }

            if (typeof keepInvalid !== 'boolean') {
                throw new TypeError('keepInvalid() expects a boolean parameter');
            }
            options.keepInvalid = keepInvalid;
            return picker;
        };

        picker.datepickerInput = function (datepickerInput) {
            if (arguments.length === 0) {
                return options.datepickerInput;
            }

            if (typeof datepickerInput !== 'string') {
                throw new TypeError('datepickerInput() expects a string parameter');
            }

            options.datepickerInput = datepickerInput;
            return picker;
        };

        picker.parseInputDate = function (parseInputDate) {
            if (arguments.length === 0) {
                return options.parseInputDate;
            }

            if (typeof parseInputDate !== 'function') {
                throw new TypeError('parseInputDate() sholud be as function');
            }

            options.parseInputDate = parseInputDate;

            return picker;
        };

        picker.disabledTimeIntervals = function (disabledTimeIntervals) {
            ///<signature helpKeyword="$.fn.datetimepicker.disabledTimeIntervals">
            ///<summary>Returns an array with the currently set disabled dates on the component.</summary>
            ///<returns type="array">options.disabledTimeIntervals</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
            ///options.enabledDates if such exist.</summary>
            ///<param name="dates" locid="$.fn.datetimepicker.disabledTimeIntervals_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
            ///</signature>
            if (arguments.length === 0) {
                return options.disabledTimeIntervals ? $.extend({}, options.disabledTimeIntervals) : options.disabledTimeIntervals;
            }

            if (!disabledTimeIntervals) {
                options.disabledTimeIntervals = false;
                update();
                return picker;
            }
            if (!(disabledTimeIntervals instanceof Array)) {
                throw new TypeError('disabledTimeIntervals() expects an array parameter');
            }
            options.disabledTimeIntervals = disabledTimeIntervals;
            update();
            return picker;
        };

        picker.disabledHours = function (hours) {
            ///<signature helpKeyword="$.fn.datetimepicker.disabledHours">
            ///<summary>Returns an array with the currently set disabled hours on the component.</summary>
            ///<returns type="array">options.disabledHours</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
            ///options.enabledHours if such exist.</summary>
            ///<param name="hours" locid="$.fn.datetimepicker.disabledHours_p:hours">Takes an [ int ] of values and disallows the user to select only from those hours.</param>
            ///</signature>
            if (arguments.length === 0) {
                return options.disabledHours ? $.extend({}, options.disabledHours) : options.disabledHours;
            }

            if (!hours) {
                options.disabledHours = false;
                update();
                return picker;
            }
            if (!(hours instanceof Array)) {
                throw new TypeError('disabledHours() expects an array parameter');
            }
            options.disabledHours = indexGivenHours(hours);
            options.enabledHours = false;
            if (options.useCurrent && !options.keepInvalid) {
                var tries = 0;
                while (!isValid(date, 'h')) {
                    date.add(1, 'h');
                    if (tries === 24) {
                        throw 'Tried 24 times to find a valid date';
                    }
                    tries++;
                }
                setValue(date);
            }
            update();
            return picker;
        };

        picker.enabledHours = function (hours) {
            ///<signature helpKeyword="$.fn.datetimepicker.enabledHours">
            ///<summary>Returns an array with the currently set enabled hours on the component.</summary>
            ///<returns type="array">options.enabledHours</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of options.disabledHours if such exist.</summary>
            ///<param name="hours" locid="$.fn.datetimepicker.enabledHours_p:hours">Takes an [ int ] of values and allows the user to select only from those hours.</param>
            ///</signature>
            if (arguments.length === 0) {
                return options.enabledHours ? $.extend({}, options.enabledHours) : options.enabledHours;
            }

            if (!hours) {
                options.enabledHours = false;
                update();
                return picker;
            }
            if (!(hours instanceof Array)) {
                throw new TypeError('enabledHours() expects an array parameter');
            }
            options.enabledHours = indexGivenHours(hours);
            options.disabledHours = false;
            if (options.useCurrent && !options.keepInvalid) {
                var tries = 0;
                while (!isValid(date, 'h')) {
                    date.add(1, 'h');
                    if (tries === 24) {
                        throw 'Tried 24 times to find a valid date';
                    }
                    tries++;
                }
                setValue(date);
            }
            update();
            return picker;
        };
        /**
         * Returns the component's model current viewDate, a moment object or null if not set. Passing a null value unsets the components model current moment. Parsing of the newDate parameter is made using moment library with the options.format and options.useStrict components configuration.
         * @param {Takes string, viewDate, moment, null parameter.} newDate
         * @returns {viewDate.clone()}
         */
        picker.viewDate = function (newDate) {
            if (arguments.length === 0) {
                return viewDate.clone();
            }

            if (!newDate) {
                viewDate = date.clone();
                return picker;
            }

            if (typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
                throw new TypeError('viewDate() parameter must be one of [string, moment or Date]');
            }

            viewDate = parseInputDate(newDate);
            viewUpdate();
            return picker;
        };

        // initializing element and component attributes
        if (element.is('input')) {
            input = element;
        } else {
            input = element.find(options.datepickerInput);
            if (input.length === 0) {
                input = element.find('input');
            } else if (!input.is('input')) {
                throw new Error('CSS class "' + options.datepickerInput + '" cannot be applied to non input element');
            }
        }

        if (element.hasClass('input-group')) {
            // in case there is more then one 'input-group-addon' Issue #48
            // issue - BS4.4 dropped support for input-group-addon -- changed to input-group-text
            if (element.find('.datepickerbutton').length === 0) {
                component = element.find('.input-group-text');
                if (component.length === 0) {
                    component = element.find('.input-group-addon');
                }
            } else {
                component = element.find('.datepickerbutton');
            }
        }

        if (!options.inline && !input.is('input')) {
            throw new Error('Could not initialize DateTimePicker without an input element');
        }

        // Set defaults for date here now instead of in var declaration
        date = getMoment();
        viewDate = date.clone();

        $.extend(true, options, dataToOptions());

        picker.options(options);

        initFormatting();

        attachDatePickerElementEvents();

        if (input.prop('disabled')) {
            picker.disable();
        }
        if (input.is('input') && input.val().trim().length !== 0) {
            setValue(parseInputDate(input.val().trim()));
        } else if (options.defaultDate && input.attr('placeholder') === undefined) {
            setValue(options.defaultDate);
        }
        if (options.inline) {
            show();
        }
        return picker;
    };

    /********************************************************************************
     *
     * jQuery plugin constructor and defaults object
     *
     ********************************************************************************/

    /**
    * See (http://jquery.com/).
    * @name jQuery
    * @class
    * See the jQuery Library  (http://jquery.com/) for full details.  This just
    * documents the function and classes that are added to jQuery by this plug-in.
    */
    /**
     * See (http://jquery.com/)
     * @name fn
     * @class
     * See the jQuery Library  (http://jquery.com/) for full details.  This just
     * documents the function and classes that are added to jQuery by this plug-in.
     * @memberOf jQuery
     */
    /**
     * Show comments
     * @class datetimepicker
     * @memberOf jQuery.fn
     */
    $.fn.datetimepicker = function (options) {
        options = options || {};

        var args = Array.prototype.slice.call(arguments, 1),
            isInstance = true,
            thisMethods = ['destroy', 'hide', 'show', 'toggle'],
            returnValue;

        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            return this.each(function () {
                var $this = $(this),
                    _options;
                if (!$this.data('DateTimePicker')) {
                    // create a private copy of the defaults object
                    _options = $.extend(true, {}, $.fn.datetimepicker.defaults, options);
                    $this.data('DateTimePicker', dateTimePicker($this, _options));
                }
            });
        } else if (typeof options === 'string') {
            this.each(function () {
                var $this = $(this),
                    instance = $this.data('DateTimePicker');
                if (!instance) {
                    throw new Error('bootstrap-datetimepicker("' + options + '") method was called on an element that is not using DateTimePicker');
                }

                returnValue = instance[options].apply(instance, args);
                isInstance = returnValue === instance;
            });

            if (isInstance || $.inArray(options, thisMethods) > -1) {
                return this;
            }

            return returnValue;
        }

        throw new TypeError('Invalid arguments for DateTimePicker: ' + options);
    };

    $.fn.datetimepicker.defaults = {
        timeZone: '',
        format: false,
        dayViewHeaderFormat: 'MMMM YYYY',
        extraFormats: false,
        stepping: 1,
        minDate: false,
        maxDate: false,
        useCurrent: true,
        collapse: true,
        locale: moment.locale(),
        defaultDate: false,
        disabledDates: false,
        enabledDates: false,
        icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar',
            up: 'fa fa-chevron-up',
            down: 'fa fa-chevron-down',
            previous: 'fa fa-chevron-left',
            next: 'fa fa-chevron-right',
            today: 'fa fa-crosshairs',
            clear: 'fa fa-trash-o',
            close: 'fa fa-times'
        },
        tooltips: {
            today: 'Go to today',
            clear: 'Clear selection',
            close: 'Close the picker',
            selectMonth: 'Select Month',
            prevMonth: 'Previous Month',
            nextMonth: 'Next Month',
            selectYear: 'Select Year',
            prevYear: 'Previous Year',
            nextYear: 'Next Year',
            selectDecade: 'Select Decade',
            prevDecade: 'Previous Decade',
            nextDecade: 'Next Decade',
            prevCentury: 'Previous Century',
            nextCentury: 'Next Century',
            pickHour: 'Pick Hour',
            incrementHour: 'Increment Hour',
            decrementHour: 'Decrement Hour',
            pickMinute: 'Pick Minute',
            incrementMinute: 'Increment Minute',
            decrementMinute: 'Decrement Minute',
            pickSecond: 'Pick Second',
            incrementSecond: 'Increment Second',
            decrementSecond: 'Decrement Second',
            togglePeriod: 'Toggle Period',
            selectTime: 'Select Time',
            selectDate: 'Select Date'
        },
        useStrict: false,
        sideBySide: false,
        daysOfWeekDisabled: false,
        calendarWeeks: false,
        viewMode: 'days',
        toolbarPlacement: 'default',
        showTodayButton: false,
        showClear: false,
        showClose: false,
        widgetPositioning: {
            horizontal: 'auto',
            vertical: 'auto'
        },
        widgetParent: null,
        ignoreReadonly: false,
        keepOpen: false,
        focusOnShow: true,
        inline: false,
        keepInvalid: false,
        datepickerInput: '.datepickerinput',
        keyBinds: {
            up: function up(widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(7, 'd'));
                } else {
                    this.date(d.clone().add(this.stepping(), 'm'));
                }
            },
            down: function down(widget) {
                if (!widget) {
                    this.show();
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(7, 'd'));
                } else {
                    this.date(d.clone().subtract(this.stepping(), 'm'));
                }
            },
            'control up': function controlUp(widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(1, 'y'));
                } else {
                    this.date(d.clone().add(1, 'h'));
                }
            },
            'control down': function controlDown(widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(1, 'y'));
                } else {
                    this.date(d.clone().subtract(1, 'h'));
                }
            },
            left: function left(widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(1, 'd'));
                }
            },
            right: function right(widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(1, 'd'));
                }
            },
            pageUp: function pageUp(widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(1, 'M'));
                }
            },
            pageDown: function pageDown(widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(1, 'M'));
                }
            },
            enter: function enter() {
                this.hide();
            },
            escape: function escape() {
                this.hide();
            },
            //tab: function (widget) { //this break the flow of the form. disabling for now
            //    var toggle = widget.find('.picker-switch a[data-action="togglePicker"]');
            //    if(toggle.length > 0) toggle.click();
            //},
            'control space': function controlSpace(widget) {
                if (!widget) {
                    return;
                }
                if (widget.find('.timepicker').is(':visible')) {
                    widget.find('.btn[data-action="togglePeriod"]').click();
                }
            },
            t: function t() {
                this.date(this.getMoment());
            },
            'delete': function _delete() {
                this.clear();
            }
        },
        debug: false,
        allowInputToggle: false,
        disabledTimeIntervals: false,
        disabledHours: false,
        enabledHours: false,
        viewDate: false
    };

    return $.fn.datetimepicker;
});

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, t) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = t() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.VueColor = t() : e.VueColor = t();
}("undefined" != typeof self ? self : undefined, function () {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;var i = n[r] = { i: r, l: !1, exports: {} };return e[r].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
    }var n = {};return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, { configurable: !1, enumerable: !0, get: r });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 60);
  }([function (e, t) {
    function n(e, t) {
      var n = e[1] || "",
          i = e[3];if (!i) return n;if (t && "function" == typeof btoa) {
        var o = r(i);return [n].concat(i.sources.map(function (e) {
          return "/*# sourceURL=" + i.sourceRoot + e + " */";
        })).concat([o]).join("\n");
      }return [n].join("\n");
    }function r(e) {
      return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
    }e.exports = function (e) {
      var t = [];return t.toString = function () {
        return this.map(function (t) {
          var r = n(t, e);return t[2] ? "@media " + t[2] + "{" + r + "}" : r;
        }).join("");
      }, t.i = function (e, n) {
        "string" == typeof e && (e = [[null, e, ""]]);for (var r = {}, i = 0; i < this.length; i++) {
          var o = this[i][0];"number" == typeof o && (r[o] = !0);
        }for (i = 0; i < e.length; i++) {
          var a = e[i];"number" == typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), t.push(a));
        }
      }, t;
    };
  }, function (e, t, n) {
    function r(e) {
      for (var t = 0; t < e.length; t++) {
        var n = e[t],
            r = u[n.id];if (r) {
          r.refs++;for (var i = 0; i < r.parts.length; i++) {
            r.parts[i](n.parts[i]);
          }for (; i < n.parts.length; i++) {
            r.parts.push(o(n.parts[i]));
          }r.parts.length > n.parts.length && (r.parts.length = n.parts.length);
        } else {
          for (var a = [], i = 0; i < n.parts.length; i++) {
            a.push(o(n.parts[i]));
          }u[n.id] = { id: n.id, refs: 1, parts: a };
        }
      }
    }function i() {
      var e = document.createElement("style");return e.type = "text/css", f.appendChild(e), e;
    }function o(e) {
      var t,
          n,
          r = document.querySelector("style[" + b + '~="' + e.id + '"]');if (r) {
        if (p) return v;r.parentNode.removeChild(r);
      }if (x) {
        var o = h++;r = d || (d = i()), t = a.bind(null, r, o, !1), n = a.bind(null, r, o, !0);
      } else r = i(), t = s.bind(null, r), n = function n() {
        r.parentNode.removeChild(r);
      };return t(e), function (r) {
        if (r) {
          if (r.css === e.css && r.media === e.media && r.sourceMap === e.sourceMap) return;t(e = r);
        } else n();
      };
    }function a(e, t, n, r) {
      var i = n ? "" : r.css;if (e.styleSheet) e.styleSheet.cssText = m(t, i);else {
        var o = document.createTextNode(i),
            a = e.childNodes;a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(o, a[t]) : e.appendChild(o);
      }
    }function s(e, t) {
      var n = t.css,
          r = t.media,
          i = t.sourceMap;if (r && e.setAttribute("media", r), g.ssrId && e.setAttribute(b, t.id), i && (n += "\n/*# sourceURL=" + i.sources[0] + " */", n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */"), e.styleSheet) e.styleSheet.cssText = n;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }e.appendChild(document.createTextNode(n));
      }
    }var c = "undefined" != typeof document;if ("undefined" != typeof DEBUG && DEBUG && !c) throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var l = n(64),
        u = {},
        f = c && (document.head || document.getElementsByTagName("head")[0]),
        d = null,
        h = 0,
        p = !1,
        v = function v() {},
        g = null,
        b = "data-vue-ssr-id",
        x = "undefined" != typeof navigator && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());e.exports = function (e, t, n, i) {
      p = n, g = i || {};var o = l(e, t);return r(o), function (t) {
        for (var n = [], i = 0; i < o.length; i++) {
          var a = o[i],
              s = u[a.id];s.refs--, n.push(s);
        }t ? (o = l(e, t), r(o)) : o = [];for (var i = 0; i < n.length; i++) {
          var s = n[i];if (0 === s.refs) {
            for (var c = 0; c < s.parts.length; c++) {
              s.parts[c]();
            }delete u[s.id];
          }
        }
      };
    };var m = function () {
      var e = [];return function (t, n) {
        return e[t] = n, e.filter(Boolean).join("\n");
      };
    }();
  }, function (e, t) {
    e.exports = function (e, t, n, r, i, o) {
      var a,
          s = e = e || {},
          c = _typeof(e.default);"object" !== c && "function" !== c || (a = e, s = e.default);var l = "function" == typeof s ? s.options : s;t && (l.render = t.render, l.staticRenderFns = t.staticRenderFns, l._compiled = !0), n && (l.functional = !0), i && (l._scopeId = i);var u;if (o ? (u = function u(e) {
        e = e || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, e || "undefined" == typeof __VUE_SSR_CONTEXT__ || (e = __VUE_SSR_CONTEXT__), r && r.call(this, e), e && e._registeredComponents && e._registeredComponents.add(o);
      }, l._ssrRegister = u) : r && (u = r), u) {
        var f = l.functional,
            d = f ? l.render : l.beforeCreate;f ? (l._injectStyles = u, l.render = function (e, t) {
          return u.call(t), d(e, t);
        }) : l.beforeCreate = d ? [].concat(d, u) : [u];
      }return { esModule: a, exports: s, options: l };
    };
  }, function (e, t, n) {
    "use strict";
    function r(e, t) {
      var n,
          r = e && e.a;!(n = e && e.hsl ? (0, o.default)(e.hsl) : e && e.hex && e.hex.length > 0 ? (0, o.default)(e.hex) : e && e.hsv ? (0, o.default)(e.hsv) : e && e.rgba ? (0, o.default)(e.rgba) : e && e.rgb ? (0, o.default)(e.rgb) : (0, o.default)(e)) || void 0 !== n._a && null !== n._a || n.setAlpha(r || 1);var i = n.toHsl(),
          a = n.toHsv();return 0 === i.s && (a.h = i.h = e.h || e.hsl && e.hsl.h || t || 0), { hsl: i, hex: n.toHexString().toUpperCase(), hex8: n.toHex8String().toUpperCase(), rgba: n.toRgb(), hsv: a, oldHue: e.h || t || i.h, source: e.source, a: e.a || n.getAlpha() };
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(65),
        o = function (e) {
      return e && e.__esModule ? e : { default: e };
    }(i);t.default = { props: ["value"], data: function data() {
        return { val: r(this.value) };
      }, computed: { colors: { get: function get() {
            return this.val;
          }, set: function set(e) {
            this.val = e, this.$emit("input", e);
          } } }, watch: { value: function value(e) {
          this.val = r(e);
        } }, methods: { colorChange: function colorChange(e, t) {
          this.oldHue = this.colors.hsl.h, this.colors = r(e, t || this.oldHue);
        }, isValidHex: function isValidHex(e) {
          return (0, o.default)(e).isValid();
        }, simpleCheckForValidColor: function simpleCheckForValidColor(e) {
          for (var t = ["r", "g", "b", "a", "h", "s", "l", "v"], n = 0, r = 0, i = 0; i < t.length; i++) {
            var o = t[i];e[o] && (n++, isNaN(e[o]) || r++);
          }if (n === r) return e;
        }, paletteUpperCase: function paletteUpperCase(e) {
          return e.map(function (e) {
            return e.toUpperCase();
          });
        }, isTransparent: function isTransparent(e) {
          return 0 === (0, o.default)(e).getAlpha();
        } } };
  }, function (e, t) {
    var n = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();"number" == typeof __g && (__g = n);
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      c || n(66);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(36),
        o = n.n(i);for (var a in i) {
      "default" !== a && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(a);
    }var s = n(68),
        c = !1,
        l = n(2),
        u = r,
        f = l(o.a, s.a, !1, u, null, null);f.options.__file = "src/components/common/EditableInput.vue", t.default = f.exports;
  }, function (e, t) {
    var n = {}.hasOwnProperty;e.exports = function (e, t) {
      return n.call(e, t);
    };
  }, function (e, t, n) {
    var r = n(8),
        i = n(18);e.exports = n(9) ? function (e, t, n) {
      return r.f(e, t, i(1, n));
    } : function (e, t, n) {
      return e[t] = n, e;
    };
  }, function (e, t, n) {
    var r = n(16),
        i = n(42),
        o = n(25),
        a = Object.defineProperty;t.f = n(9) ? Object.defineProperty : function (e, t, n) {
      if (r(e), t = o(t, !0), r(n), i) try {
        return a(e, t, n);
      } catch (e) {}if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");return "value" in n && (e[t] = n.value), e;
    };
  }, function (e, t, n) {
    e.exports = !n(17)(function () {
      return 7 != Object.defineProperty({}, "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (e, t, n) {
    var r = n(90),
        i = n(24);e.exports = function (e) {
      return r(i(e));
    };
  }, function (e, t, n) {
    var r = n(29)("wks"),
        i = n(19),
        o = n(4).Symbol,
        a = "function" == typeof o;(e.exports = function (e) {
      return r[e] || (r[e] = a && o[e] || (a ? o : i)("Symbol." + e));
    }).store = r;
  }, function (e, t) {
    e.exports = function (e) {
      return "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) ? null !== e : "function" == typeof e;
    };
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      c || n(111);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(51),
        o = n.n(i);for (var a in i) {
      "default" !== a && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(a);
    }var s = n(113),
        c = !1,
        l = n(2),
        u = r,
        f = l(o.a, s.a, !1, u, null, null);f.options.__file = "src/components/common/Hue.vue", t.default = f.exports;
  }, function (e, t) {
    e.exports = !0;
  }, function (e, t) {
    var n = e.exports = { version: "2.6.11" };"number" == typeof __e && (__e = n);
  }, function (e, t, n) {
    var r = n(12);e.exports = function (e) {
      if (!r(e)) throw TypeError(e + " is not an object!");return e;
    };
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return { enumerable: !(1 & e), configurable: !(2 & e), writable: !(4 & e), value: t };
    };
  }, function (e, t) {
    var n = 0,
        r = Math.random();e.exports = function (e) {
      return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++n + r).toString(36));
    };
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      c || n(123);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(54),
        o = n.n(i);for (var a in i) {
      "default" !== a && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(a);
    }var s = n(127),
        c = !1,
        l = n(2),
        u = r,
        f = l(o.a, s.a, !1, u, null, null);f.options.__file = "src/components/common/Saturation.vue", t.default = f.exports;
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      c || n(128);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(55),
        o = n.n(i);for (var a in i) {
      "default" !== a && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(a);
    }var s = n(133),
        c = !1,
        l = n(2),
        u = r,
        f = l(o.a, s.a, !1, u, null, null);f.options.__file = "src/components/common/Alpha.vue", t.default = f.exports;
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      c || n(130);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(56),
        o = n.n(i);for (var a in i) {
      "default" !== a && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(a);
    }var s = n(132),
        c = !1,
        l = n(2),
        u = r,
        f = l(o.a, s.a, !1, u, null, null);f.options.__file = "src/components/common/Checkboard.vue", t.default = f.exports;
  }, function (e, t) {
    var n = Math.ceil,
        r = Math.floor;e.exports = function (e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? r : n)(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 == e) throw TypeError("Can't call method on  " + e);return e;
    };
  }, function (e, t, n) {
    var r = n(12);e.exports = function (e, t) {
      if (!r(e)) return e;var n, i;if (t && "function" == typeof (n = e.toString) && !r(i = n.call(e))) return i;if ("function" == typeof (n = e.valueOf) && !r(i = n.call(e))) return i;if (!t && "function" == typeof (n = e.toString) && !r(i = n.call(e))) return i;throw TypeError("Can't convert object to primitive value");
    };
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, n) {
    var r = n(46),
        i = n(30);e.exports = Object.keys || function (e) {
      return r(e, i);
    };
  }, function (e, t, n) {
    var r = n(29)("keys"),
        i = n(19);e.exports = function (e) {
      return r[e] || (r[e] = i(e));
    };
  }, function (e, t, n) {
    var r = n(15),
        i = n(4),
        o = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});(e.exports = function (e, t) {
      return o[e] || (o[e] = void 0 !== t ? t : {});
    })("versions", []).push({ version: r.version, mode: n(14) ? "pure" : "global", copyright: "© 2019 Denis Pushkarev (zloirock.ru)" });
  }, function (e, t) {
    e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (e, t, n) {
    var r = n(8).f,
        i = n(6),
        o = n(11)("toStringTag");e.exports = function (e, t, n) {
      e && !i(e = n ? e : e.prototype, o) && r(e, o, { configurable: !0, value: t });
    };
  }, function (e, t, n) {
    t.f = n(11);
  }, function (e, t, n) {
    var r = n(4),
        i = n(15),
        o = n(14),
        a = n(32),
        s = n(8).f;e.exports = function (e) {
      var t = i.Symbol || (i.Symbol = o ? {} : r.Symbol || {});"_" == e.charAt(0) || e in t || s(t, e, { value: a.f(e) });
    };
  }, function (e, t) {
    t.f = {}.propertyIsEnumerable;
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(3),
        o = r(i),
        a = n(5),
        s = r(a),
        c = ["#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080", "#CCCCCC", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF", "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"];t.default = { name: "Compact", mixins: [o.default], props: { palette: { type: Array, default: function _default() {
            return c;
          } } }, components: { "ed-in": s.default }, computed: { pick: function pick() {
          return this.colors.hex.toUpperCase();
        } }, methods: { handlerClick: function handlerClick(e) {
          this.colorChange({ hex: e, source: "hex" });
        } } };
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { name: "editableInput", props: { label: String, labelText: String, desc: String, value: [String, Number], max: Number, min: Number, arrowOffset: { type: Number, default: 1 } }, computed: { val: { get: function get() {
            return this.value;
          }, set: function set(e) {
            if (!(void 0 !== this.max && +e > this.max)) return e;this.$refs.input.value = this.max;
          } }, labelId: function labelId() {
          return "input__label__" + this.label + "__" + Math.random().toString().slice(2, 5);
        }, labelSpanText: function labelSpanText() {
          return this.labelText || this.label;
        } }, methods: { update: function update(e) {
          this.handleChange(e.target.value);
        }, handleChange: function handleChange(e) {
          var t = {};t[this.label] = e, void 0 === t.hex && void 0 === t["#"] ? this.$emit("change", t) : e.length > 5 && this.$emit("change", t);
        }, handleKeyDown: function handleKeyDown(e) {
          var t = this.val,
              n = Number(t);if (n) {
            var r = this.arrowOffset || 1;38 === e.keyCode && (t = n + r, this.handleChange(t), e.preventDefault()), 40 === e.keyCode && (t = n - r, this.handleChange(t), e.preventDefault());
          }
        } } };
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var r = n(3),
        i = function (e) {
      return e && e.__esModule ? e : { default: e };
    }(r),
        o = ["#FFFFFF", "#F2F2F2", "#E6E6E6", "#D9D9D9", "#CCCCCC", "#BFBFBF", "#B3B3B3", "#A6A6A6", "#999999", "#8C8C8C", "#808080", "#737373", "#666666", "#595959", "#4D4D4D", "#404040", "#333333", "#262626", "#0D0D0D", "#000000"];t.default = { name: "Grayscale", mixins: [i.default], props: { palette: { type: Array, default: function _default() {
            return o;
          } } }, components: {}, computed: { pick: function pick() {
          return this.colors.hex.toUpperCase();
        } }, methods: { handlerClick: function handlerClick(e) {
          this.colorChange({ hex: e, source: "hex" });
        } } };
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(5),
        o = r(i),
        a = n(3),
        s = r(a);t.default = { name: "Material", mixins: [s.default], components: { "ed-in": o.default }, methods: { onChange: function onChange(e) {
          e && (e.hex ? this.isValidHex(e.hex) && this.colorChange({ hex: e.hex, source: "hex" }) : (e.r || e.g || e.b) && this.colorChange({ r: e.r || this.colors.rgba.r, g: e.g || this.colors.rgba.g, b: e.b || this.colors.rgba.b, a: e.a || this.colors.rgba.a, source: "rgba" }));
        } } };
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(81),
        o = r(i),
        a = n(3),
        s = r(a),
        c = n(13),
        l = r(c);t.default = { name: "Slider", mixins: [s.default], props: { swatches: { type: Array, default: function _default() {
            return [{ s: .5, l: .8 }, { s: .5, l: .65 }, { s: .5, l: .5 }, { s: .5, l: .35 }, { s: .5, l: .2 }];
          } } }, components: { hue: l.default }, computed: { normalizedSwatches: function normalizedSwatches() {
          return this.swatches.map(function (e) {
            return "object" !== (void 0 === e ? "undefined" : (0, o.default)(e)) ? { s: .5, l: e } : e;
          });
        } }, methods: { isActive: function isActive(e, t) {
          var n = this.colors.hsl;return 1 === n.l && 1 === e.l || 0 === n.l && 0 === e.l || Math.abs(n.l - e.l) < .01 && Math.abs(n.s - e.s) < .01;
        }, hueChange: function hueChange(e) {
          this.colorChange(e);
        }, handleSwClick: function handleSwClick(e, t) {
          this.colorChange({ h: this.colors.hsl.h, s: t.s, l: t.l, source: "hsl" });
        } } };
  }, function (e, t, n) {
    "use strict";
    var r = n(14),
        i = n(41),
        o = n(44),
        a = n(7),
        s = n(26),
        c = n(88),
        l = n(31),
        u = n(95),
        f = n(11)("iterator"),
        d = !([].keys && "next" in [].keys()),
        h = function h() {
      return this;
    };e.exports = function (e, t, n, p, v, g, b) {
      c(n, t, p);var x,
          m,
          _,
          w = function w(e) {
        if (!d && e in F) return F[e];switch (e) {case "keys":case "values":
            return function () {
              return new n(this, e);
            };}return function () {
          return new n(this, e);
        };
      },
          y = t + " Iterator",
          C = "values" == v,
          k = !1,
          F = e.prototype,
          S = F[f] || F["@@iterator"] || v && F[v],
          A = S || w(v),
          O = v ? C ? w("entries") : A : void 0,
          E = "Array" == t ? F.entries || S : S;if (E && (_ = u(E.call(new e()))) !== Object.prototype && _.next && (l(_, y, !0), r || "function" == typeof _[f] || a(_, f, h)), C && S && "values" !== S.name && (k = !0, A = function A() {
        return S.call(this);
      }), r && !b || !d && !k && F[f] || a(F, f, A), s[t] = A, s[y] = h, v) if (x = { values: C ? A : w("values"), keys: g ? A : w("keys"), entries: O }, b) for (m in x) {
        m in F || o(F, m, x[m]);
      } else i(i.P + i.F * (d || k), t, x);return x;
    };
  }, function (e, t, n) {
    var r = n(4),
        i = n(15),
        o = n(86),
        a = n(7),
        s = n(6),
        c = function c(e, t, n) {
      var l,
          u,
          f,
          d = e & c.F,
          h = e & c.G,
          p = e & c.S,
          v = e & c.P,
          g = e & c.B,
          b = e & c.W,
          x = h ? i : i[t] || (i[t] = {}),
          m = x.prototype,
          _ = h ? r : p ? r[t] : (r[t] || {}).prototype;h && (n = t);for (l in n) {
        (u = !d && _ && void 0 !== _[l]) && s(x, l) || (f = u ? _[l] : n[l], x[l] = h && "function" != typeof _[l] ? n[l] : g && u ? o(f, r) : b && _[l] == f ? function (e) {
          var t = function t(_t, n, r) {
            if (this instanceof e) {
              switch (arguments.length) {case 0:
                  return new e();case 1:
                  return new e(_t);case 2:
                  return new e(_t, n);}return new e(_t, n, r);
            }return e.apply(this, arguments);
          };return t.prototype = e.prototype, t;
        }(f) : v && "function" == typeof f ? o(Function.call, f) : f, v && ((x.virtual || (x.virtual = {}))[l] = f, e & c.R && m && !m[l] && a(m, l, f)));
      }
    };c.F = 1, c.G = 2, c.S = 4, c.P = 8, c.B = 16, c.W = 32, c.U = 64, c.R = 128, e.exports = c;
  }, function (e, t, n) {
    e.exports = !n(9) && !n(17)(function () {
      return 7 != Object.defineProperty(n(43)("div"), "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (e, t, n) {
    var r = n(12),
        i = n(4).document,
        o = r(i) && r(i.createElement);e.exports = function (e) {
      return o ? i.createElement(e) : {};
    };
  }, function (e, t, n) {
    e.exports = n(7);
  }, function (e, t, n) {
    var r = n(16),
        i = n(89),
        o = n(30),
        a = n(28)("IE_PROTO"),
        s = function s() {},
        _c = function c() {
      var e,
          t = n(43)("iframe"),
          r = o.length;for (t.style.display = "none", n(94).appendChild(t), t.src = "javascript:", e = t.contentWindow.document, e.open(), e.write("<script>document.F=Object<\/script>"), e.close(), _c = e.F; r--;) {
        delete _c.prototype[o[r]];
      }return _c();
    };e.exports = Object.create || function (e, t) {
      var n;return null !== e ? (s.prototype = r(e), n = new s(), s.prototype = null, n[a] = e) : n = _c(), void 0 === t ? n : i(n, t);
    };
  }, function (e, t, n) {
    var r = n(6),
        i = n(10),
        o = n(91)(!1),
        a = n(28)("IE_PROTO");e.exports = function (e, t) {
      var n,
          s = i(e),
          c = 0,
          l = [];for (n in s) {
        n != a && r(s, n) && l.push(n);
      }for (; t.length > c;) {
        r(s, n = t[c++]) && (~o(l, n) || l.push(n));
      }return l;
    };
  }, function (e, t) {
    var n = {}.toString;e.exports = function (e) {
      return n.call(e).slice(8, -1);
    };
  }, function (e, t, n) {
    var r = n(24);e.exports = function (e) {
      return Object(r(e));
    };
  }, function (e, t) {
    t.f = Object.getOwnPropertySymbols;
  }, function (e, t, n) {
    var r = n(46),
        i = n(30).concat("length", "prototype");t.f = Object.getOwnPropertyNames || function (e) {
      return r(e, i);
    };
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { name: "Hue", props: { value: Object, direction: { type: String, default: "horizontal" } }, data: function data() {
        return { oldHue: 0, pullDirection: "" };
      }, computed: { colors: function colors() {
          var e = this.value.hsl.h;return 0 !== e && e - this.oldHue > 0 && (this.pullDirection = "right"), 0 !== e && e - this.oldHue < 0 && (this.pullDirection = "left"), this.oldHue = e, this.value;
        }, directionClass: function directionClass() {
          return { "vc-hue--horizontal": "horizontal" === this.direction, "vc-hue--vertical": "vertical" === this.direction };
        }, pointerTop: function pointerTop() {
          return "vertical" === this.direction ? 0 === this.colors.hsl.h && "right" === this.pullDirection ? 0 : -100 * this.colors.hsl.h / 360 + 100 + "%" : 0;
        }, pointerLeft: function pointerLeft() {
          return "vertical" === this.direction ? 0 : 0 === this.colors.hsl.h && "right" === this.pullDirection ? "100%" : 100 * this.colors.hsl.h / 360 + "%";
        } }, methods: { handleChange: function handleChange(e, t) {
          !t && e.preventDefault();var n = this.$refs.container;if (n) {
            var r,
                i,
                o = n.clientWidth,
                a = n.clientHeight,
                s = n.getBoundingClientRect().left + window.pageXOffset,
                c = n.getBoundingClientRect().top + window.pageYOffset,
                l = e.pageX || (e.touches ? e.touches[0].pageX : 0),
                u = e.pageY || (e.touches ? e.touches[0].pageY : 0),
                f = l - s,
                d = u - c;"vertical" === this.direction ? (d < 0 ? r = 360 : d > a ? r = 0 : (i = -100 * d / a + 100, r = 360 * i / 100), this.colors.hsl.h !== r && this.$emit("change", { h: r, s: this.colors.hsl.s, l: this.colors.hsl.l, a: this.colors.hsl.a, source: "hsl" })) : (f < 0 ? r = 0 : f > o ? r = 360 : (i = 100 * f / o, r = 360 * i / 100), this.colors.hsl.h !== r && this.$emit("change", { h: r, s: this.colors.hsl.s, l: this.colors.hsl.l, a: this.colors.hsl.a, source: "hsl" }));
          }
        }, handleMouseDown: function handleMouseDown(e) {
          this.handleChange(e, !0), window.addEventListener("mousemove", this.handleChange), window.addEventListener("mouseup", this.handleMouseUp);
        }, handleMouseUp: function handleMouseUp(e) {
          this.unbindEventListeners();
        }, unbindEventListeners: function unbindEventListeners() {
          window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
        } } };
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(118),
        o = r(i),
        a = n(3),
        s = r(a),
        c = ["red", "pink", "purple", "deepPurple", "indigo", "blue", "lightBlue", "cyan", "teal", "green", "lightGreen", "lime", "yellow", "amber", "orange", "deepOrange", "brown", "blueGrey", "black"],
        l = ["900", "700", "500", "300", "100"],
        u = function () {
      var e = [];return c.forEach(function (t) {
        var n = [];"black" === t.toLowerCase() || "white" === t.toLowerCase() ? n = n.concat(["#000000", "#FFFFFF"]) : l.forEach(function (e) {
          var r = o.default[t][e];n.push(r.toUpperCase());
        }), e.push(n);
      }), e;
    }();t.default = { name: "Swatches", mixins: [s.default], props: { palette: { type: Array, default: function _default() {
            return u;
          } } }, computed: { pick: function pick() {
          return this.colors.hex;
        } }, methods: { equal: function equal(e) {
          return e.toLowerCase() === this.colors.hex.toLowerCase();
        }, handlerClick: function handlerClick(e) {
          this.colorChange({ hex: e, source: "hex" });
        } } };
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(3),
        o = r(i),
        a = n(5),
        s = r(a),
        c = n(20),
        l = r(c),
        u = n(13),
        f = r(u),
        d = n(21),
        h = r(d);t.default = { name: "Photoshop", mixins: [o.default], props: { head: { type: String, default: "Color Picker" }, disableFields: { type: Boolean, default: !1 }, hasResetButton: { type: Boolean, default: !1 }, acceptLabel: { type: String, default: "OK" }, cancelLabel: { type: String, default: "Cancel" }, resetLabel: { type: String, default: "Reset" }, newLabel: { type: String, default: "new" }, currentLabel: { type: String, default: "current" } }, components: { saturation: l.default, hue: f.default, alpha: h.default, "ed-in": s.default }, data: function data() {
        return { currentColor: "#FFF" };
      }, computed: { hsv: function hsv() {
          var e = this.colors.hsv;return { h: e.h.toFixed(), s: (100 * e.s).toFixed(), v: (100 * e.v).toFixed() };
        }, hex: function hex() {
          var e = this.colors.hex;return e && e.replace("#", "");
        } }, created: function created() {
        this.currentColor = this.colors.hex;
      }, methods: { childChange: function childChange(e) {
          this.colorChange(e);
        }, inputChange: function inputChange(e) {
          e && (e["#"] ? this.isValidHex(e["#"]) && this.colorChange({ hex: e["#"], source: "hex" }) : e.r || e.g || e.b || e.a ? this.colorChange({ r: e.r || this.colors.rgba.r, g: e.g || this.colors.rgba.g, b: e.b || this.colors.rgba.b, a: e.a || this.colors.rgba.a, source: "rgba" }) : (e.h || e.s || e.v) && this.colorChange({ h: e.h || this.colors.hsv.h, s: e.s / 100 || this.colors.hsv.s, v: e.v / 100 || this.colors.hsv.v, source: "hsv" }));
        }, clickCurrentColor: function clickCurrentColor() {
          this.colorChange({ hex: this.currentColor, source: "hex" });
        }, handleAccept: function handleAccept() {
          this.$emit("ok");
        }, handleCancel: function handleCancel() {
          this.$emit("cancel");
        }, handleReset: function handleReset() {
          this.$emit("reset");
        } } };
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(125),
        o = r(i),
        a = n(126),
        s = r(a);t.default = { name: "Saturation", props: { value: Object }, computed: { colors: function colors() {
          return this.value;
        }, bgColor: function bgColor() {
          return "hsl(" + this.colors.hsv.h + ", 100%, 50%)";
        }, pointerTop: function pointerTop() {
          return -100 * this.colors.hsv.v + 1 + 100 + "%";
        }, pointerLeft: function pointerLeft() {
          return 100 * this.colors.hsv.s + "%";
        } }, methods: { throttle: (0, s.default)(function (e, t) {
          e(t);
        }, 20, { leading: !0, trailing: !1 }), handleChange: function handleChange(e, t) {
          !t && e.preventDefault();var n = this.$refs.container;if (n) {
            var r = n.clientWidth,
                i = n.clientHeight,
                a = n.getBoundingClientRect().left + window.pageXOffset,
                s = n.getBoundingClientRect().top + window.pageYOffset,
                c = e.pageX || (e.touches ? e.touches[0].pageX : 0),
                l = e.pageY || (e.touches ? e.touches[0].pageY : 0),
                u = (0, o.default)(c - a, 0, r),
                f = (0, o.default)(l - s, 0, i),
                d = u / r,
                h = (0, o.default)(-f / i + 1, 0, 1);this.throttle(this.onChange, { h: this.colors.hsv.h, s: d, v: h, a: this.colors.hsv.a, source: "hsva" });
          }
        }, onChange: function onChange(e) {
          this.$emit("change", e);
        }, handleMouseDown: function handleMouseDown(e) {
          window.addEventListener("mousemove", this.handleChange), window.addEventListener("mouseup", this.handleChange), window.addEventListener("mouseup", this.handleMouseUp);
        }, handleMouseUp: function handleMouseUp(e) {
          this.unbindEventListeners();
        }, unbindEventListeners: function unbindEventListeners() {
          window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
        } } };
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var r = n(22),
        i = function (e) {
      return e && e.__esModule ? e : { default: e };
    }(r);t.default = { name: "Alpha", props: { value: Object, onChange: Function }, components: { checkboard: i.default }, computed: { colors: function colors() {
          return this.value;
        }, gradientColor: function gradientColor() {
          var e = this.colors.rgba,
              t = [e.r, e.g, e.b].join(",");return "linear-gradient(to right, rgba(" + t + ", 0) 0%, rgba(" + t + ", 1) 100%)";
        } }, methods: { handleChange: function handleChange(e, t) {
          !t && e.preventDefault();var n = this.$refs.container;if (n) {
            var r,
                i = n.clientWidth,
                o = n.getBoundingClientRect().left + window.pageXOffset,
                a = e.pageX || (e.touches ? e.touches[0].pageX : 0),
                s = a - o;r = s < 0 ? 0 : s > i ? 1 : Math.round(100 * s / i) / 100, this.colors.a !== r && this.$emit("change", { h: this.colors.hsl.h, s: this.colors.hsl.s, l: this.colors.hsl.l, a: r, source: "rgba" });
          }
        }, handleMouseDown: function handleMouseDown(e) {
          this.handleChange(e, !0), window.addEventListener("mousemove", this.handleChange), window.addEventListener("mouseup", this.handleMouseUp);
        }, handleMouseUp: function handleMouseUp() {
          this.unbindEventListeners();
        }, unbindEventListeners: function unbindEventListeners() {
          window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
        } } };
  }, function (e, t, n) {
    "use strict";
    function r(e, t, n) {
      if ("undefined" == typeof document) return null;var r = document.createElement("canvas");r.width = r.height = 2 * n;var i = r.getContext("2d");return i ? (i.fillStyle = e, i.fillRect(0, 0, r.width, r.height), i.fillStyle = t, i.fillRect(0, 0, n, n), i.translate(n, n), i.fillRect(0, 0, n, n), r.toDataURL()) : null;
    }function i(e, t, n) {
      var i = e + "," + t + "," + n;if (o[i]) return o[i];var a = r(e, t, n);return o[i] = a, a;
    }Object.defineProperty(t, "__esModule", { value: !0 });var o = {};t.default = { name: "Checkboard", props: { size: { type: [Number, String], default: 8 }, white: { type: String, default: "#fff" }, grey: { type: String, default: "#e6e6e6" } }, computed: { bgStyle: function bgStyle() {
          return { "background-image": "url(" + i(this.white, this.grey, this.size) + ")" };
        } } };
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(3),
        o = r(i),
        a = n(5),
        s = r(a),
        c = n(20),
        l = r(c),
        u = n(13),
        f = r(u),
        d = n(21),
        h = r(d),
        p = n(22),
        v = r(p),
        g = ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF", "rgba(0,0,0,0)"];t.default = { name: "Sketch", mixins: [o.default], components: { saturation: l.default, hue: f.default, alpha: h.default, "ed-in": s.default, checkboard: v.default }, props: { presetColors: { type: Array, default: function _default() {
            return g;
          } }, disableAlpha: { type: Boolean, default: !1 }, disableFields: { type: Boolean, default: !1 } }, computed: { hex: function hex() {
          var e = void 0;return e = this.colors.a < 1 ? this.colors.hex8 : this.colors.hex, e.replace("#", "");
        }, activeColor: function activeColor() {
          var e = this.colors.rgba;return "rgba(" + [e.r, e.g, e.b, e.a].join(",") + ")";
        } }, methods: { handlePreset: function handlePreset(e) {
          this.colorChange({ hex: e, source: "hex" });
        }, childChange: function childChange(e) {
          this.colorChange(e);
        }, inputChange: function inputChange(e) {
          e && (e.hex ? this.isValidHex(e.hex) && this.colorChange({ hex: e.hex, source: "hex" }) : (e.r || e.g || e.b || e.a) && this.colorChange({ r: e.r || this.colors.rgba.r, g: e.g || this.colors.rgba.g, b: e.b || this.colors.rgba.b, a: e.a || this.colors.rgba.a, source: "rgba" }));
        } } };
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(3),
        o = r(i),
        a = n(5),
        s = r(a),
        c = n(20),
        l = r(c),
        u = n(13),
        f = r(u),
        d = n(21),
        h = r(d),
        p = n(22),
        v = r(p);t.default = { name: "Chrome", mixins: [o.default], props: { disableAlpha: { type: Boolean, default: !1 }, disableFields: { type: Boolean, default: !1 } }, components: { saturation: l.default, hue: f.default, alpha: h.default, "ed-in": s.default, checkboard: v.default }, data: function data() {
        return { fieldsIndex: 0, highlight: !1 };
      }, computed: { hsl: function hsl() {
          var e = this.colors.hsl,
              t = e.h,
              n = e.s,
              r = e.l;return { h: t.toFixed(), s: (100 * n).toFixed() + "%", l: (100 * r).toFixed() + "%" };
        }, activeColor: function activeColor() {
          var e = this.colors.rgba;return "rgba(" + [e.r, e.g, e.b, e.a].join(",") + ")";
        }, hasAlpha: function hasAlpha() {
          return this.colors.a < 1;
        } }, methods: { childChange: function childChange(e) {
          this.colorChange(e);
        }, inputChange: function inputChange(e) {
          if (e) if (e.hex) this.isValidHex(e.hex) && this.colorChange({ hex: e.hex, source: "hex" });else if (e.r || e.g || e.b || e.a) this.colorChange({ r: e.r || this.colors.rgba.r, g: e.g || this.colors.rgba.g, b: e.b || this.colors.rgba.b, a: e.a || this.colors.rgba.a, source: "rgba" });else if (e.h || e.s || e.l) {
            var t = e.s ? e.s.replace("%", "") / 100 : this.colors.hsl.s,
                n = e.l ? e.l.replace("%", "") / 100 : this.colors.hsl.l;this.colorChange({ h: e.h || this.colors.hsl.h, s: t, l: n, source: "hsl" });
          }
        }, toggleViews: function toggleViews() {
          if (this.fieldsIndex >= 2) return void (this.fieldsIndex = 0);this.fieldsIndex++;
        }, showHighlight: function showHighlight() {
          this.highlight = !0;
        }, hideHighlight: function hideHighlight() {
          this.highlight = !1;
        } } };
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(5),
        o = r(i),
        a = n(3),
        s = r(a),
        c = ["#FF6900", "#FCB900", "#7BDCB5", "#00D084", "#8ED1FC", "#0693E3", "#ABB8C3", "#EB144C", "#F78DA7", "#9900EF"];t.default = { name: "Twitter", mixins: [s.default], components: { editableInput: o.default }, props: { width: { type: [String, Number], default: 276 }, defaultColors: { type: Array, default: function _default() {
            return c;
          } }, triangle: { default: "top-left", validator: function validator(e) {
            return ["hide", "top-left", "top-right"].includes(e);
          } } }, computed: { hsv: function hsv() {
          var e = this.colors.hsv;return { h: e.h.toFixed(), s: (100 * e.s).toFixed(), v: (100 * e.v).toFixed() };
        }, hex: function hex() {
          var e = this.colors.hex;return e && e.replace("#", "");
        } }, methods: { equal: function equal(e) {
          return e.toLowerCase() === this.colors.hex.toLowerCase();
        }, handlerClick: function handlerClick(e) {
          this.colorChange({ hex: e, source: "hex" });
        }, inputChange: function inputChange(e) {
          e && (e["#"] ? this.isValidHex(e["#"]) && this.colorChange({ hex: e["#"], source: "hex" }) : e.r || e.g || e.b || e.a ? this.colorChange({ r: e.r || this.colors.rgba.r, g: e.g || this.colors.rgba.g, b: e.b || this.colors.rgba.b, a: e.a || this.colors.rgba.a, source: "rgba" }) : (e.h || e.s || e.v) && this.colorChange({ h: e.h || this.colors.hsv.h, s: e.s / 100 || this.colors.hsv.s, v: e.v / 100 || this.colors.hsv.v, source: "hsv" }));
        } } };
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }var i = n(61),
        o = r(i),
        a = n(70),
        s = r(a),
        c = n(74),
        l = r(c),
        u = n(78),
        f = r(u),
        d = n(115),
        h = r(d),
        p = n(120),
        v = r(p),
        g = n(135),
        b = r(g),
        x = n(139),
        m = r(x),
        _ = n(143),
        w = r(_),
        y = n(21),
        C = r(y),
        k = n(22),
        F = r(k),
        S = n(5),
        A = r(S),
        O = n(13),
        E = r(O),
        M = n(20),
        j = r(M),
        L = n(3),
        P = r(L),
        R = { version: "2.8.1", Compact: o.default, Grayscale: s.default, Twitter: w.default, Material: l.default, Slider: f.default, Swatches: h.default, Photoshop: v.default, Sketch: b.default, Chrome: m.default, Alpha: C.default, Checkboard: F.default, EditableInput: A.default, Hue: E.default, Saturation: j.default, ColorMixin: P.default };e.exports = R;
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      c || n(62);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(35),
        o = n.n(i);for (var a in i) {
      "default" !== a && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(a);
    }var s = n(69),
        c = !1,
        l = n(2),
        u = r,
        f = l(o.a, s.a, !1, u, null, null);f.options.__file = "src/components/Compact.vue", t.default = f.exports;
  }, function (e, t, n) {
    var r = n(63);"string" == typeof r && (r = [[e.i, r, ""]]), r.locals && (e.exports = r.locals);n(1)("6ce8a5a8", r, !1, {});
  }, function (e, t, n) {
    t = e.exports = n(0)(!1), t.push([e.i, "\n.vc-compact {\n  padding-top: 5px;\n  padding-left: 5px;\n  width: 245px;\n  border-radius: 2px;\n  box-sizing: border-box;\n  box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);\n  background-color: #fff;\n}\n.vc-compact-colors {\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n}\n.vc-compact-color-item {\n  list-style: none;\n  width: 15px;\n  height: 15px;\n  float: left;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  position: relative;\n  cursor: pointer;\n}\n.vc-compact-color-item--white {\n  box-shadow: inset 0 0 0 1px #ddd;\n}\n.vc-compact-color-item--white .vc-compact-dot {\n  background: #000;\n}\n.vc-compact-dot {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  bottom: 5px;\n  left: 5px;\n  border-radius: 50%;\n  opacity: 1;\n  background: #fff;\n}\n", ""]);
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = [], r = {}, i = 0; i < t.length; i++) {
        var o = t[i],
            a = o[0],
            s = o[1],
            c = o[2],
            l = o[3],
            u = { id: e + ":" + i, css: s, media: c, sourceMap: l };r[a] ? r[a].parts.push(u) : n.push(r[a] = { id: a, parts: [u] });
      }return n;
    };
  }, function (e, t, n) {
    var r;!function (i) {
      function o(e, t) {
        if (e = e || "", t = t || {}, e instanceof o) return e;if (!(this instanceof o)) return new o(e, t);var n = a(e);this._originalInput = e, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = G(100 * this._a) / 100, this._format = t.format || n.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = G(this._r)), this._g < 1 && (this._g = G(this._g)), this._b < 1 && (this._b = G(this._b)), this._ok = n.ok, this._tc_id = U++;
      }function a(e) {
        var t = { r: 0, g: 0, b: 0 },
            n = 1,
            r = null,
            i = null,
            o = null,
            a = !1,
            c = !1;return "string" == typeof e && (e = N(e)), "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && (H(e.r) && H(e.g) && H(e.b) ? (t = s(e.r, e.g, e.b), a = !0, c = "%" === String(e.r).substr(-1) ? "prgb" : "rgb") : H(e.h) && H(e.s) && H(e.v) ? (r = D(e.s), i = D(e.v), t = f(e.h, r, i), a = !0, c = "hsv") : H(e.h) && H(e.s) && H(e.l) && (r = D(e.s), o = D(e.l), t = l(e.h, r, o), a = !0, c = "hsl"), e.hasOwnProperty("a") && (n = e.a)), n = O(n), { ok: a, format: e.format || c, r: V(255, q(t.r, 0)), g: V(255, q(t.g, 0)), b: V(255, q(t.b, 0)), a: n };
      }function s(e, t, n) {
        return { r: 255 * E(e, 255), g: 255 * E(t, 255), b: 255 * E(n, 255) };
      }function c(e, t, n) {
        e = E(e, 255), t = E(t, 255), n = E(n, 255);var r,
            i,
            o = q(e, t, n),
            a = V(e, t, n),
            s = (o + a) / 2;if (o == a) r = i = 0;else {
          var c = o - a;switch (i = s > .5 ? c / (2 - o - a) : c / (o + a), o) {case e:
              r = (t - n) / c + (t < n ? 6 : 0);break;case t:
              r = (n - e) / c + 2;break;case n:
              r = (e - t) / c + 4;}r /= 6;
        }return { h: r, s: i, l: s };
      }function l(e, t, n) {
        function r(e, t, n) {
          return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + 6 * (t - e) * n : n < .5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
        }var i, o, a;if (e = E(e, 360), t = E(t, 100), n = E(n, 100), 0 === t) i = o = a = n;else {
          var s = n < .5 ? n * (1 + t) : n + t - n * t,
              c = 2 * n - s;i = r(c, s, e + 1 / 3), o = r(c, s, e), a = r(c, s, e - 1 / 3);
        }return { r: 255 * i, g: 255 * o, b: 255 * a };
      }function u(e, t, n) {
        e = E(e, 255), t = E(t, 255), n = E(n, 255);var r,
            i,
            o = q(e, t, n),
            a = V(e, t, n),
            s = o,
            c = o - a;if (i = 0 === o ? 0 : c / o, o == a) r = 0;else {
          switch (o) {case e:
              r = (t - n) / c + (t < n ? 6 : 0);break;case t:
              r = (n - e) / c + 2;break;case n:
              r = (e - t) / c + 4;}r /= 6;
        }return { h: r, s: i, v: s };
      }function f(e, t, n) {
        e = 6 * E(e, 360), t = E(t, 100), n = E(n, 100);var r = i.floor(e),
            o = e - r,
            a = n * (1 - t),
            s = n * (1 - o * t),
            c = n * (1 - (1 - o) * t),
            l = r % 6;return { r: 255 * [n, s, a, a, c, n][l], g: 255 * [c, n, n, s, a, a][l], b: 255 * [a, a, c, n, n, s][l] };
      }function d(e, t, n, r) {
        var i = [R(G(e).toString(16)), R(G(t).toString(16)), R(G(n).toString(16))];return r && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
      }function h(e, t, n, r, i) {
        var o = [R(G(e).toString(16)), R(G(t).toString(16)), R(G(n).toString(16)), R(B(r))];return i && o[0].charAt(0) == o[0].charAt(1) && o[1].charAt(0) == o[1].charAt(1) && o[2].charAt(0) == o[2].charAt(1) && o[3].charAt(0) == o[3].charAt(1) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0) : o.join("");
      }function p(e, t, n, r) {
        return [R(B(r)), R(G(e).toString(16)), R(G(t).toString(16)), R(G(n).toString(16))].join("");
      }function v(e, t) {
        t = 0 === t ? 0 : t || 10;var n = o(e).toHsl();return n.s -= t / 100, n.s = M(n.s), o(n);
      }function g(e, t) {
        t = 0 === t ? 0 : t || 10;var n = o(e).toHsl();return n.s += t / 100, n.s = M(n.s), o(n);
      }function b(e) {
        return o(e).desaturate(100);
      }function x(e, t) {
        t = 0 === t ? 0 : t || 10;var n = o(e).toHsl();return n.l += t / 100, n.l = M(n.l), o(n);
      }function m(e, t) {
        t = 0 === t ? 0 : t || 10;var n = o(e).toRgb();return n.r = q(0, V(255, n.r - G(-t / 100 * 255))), n.g = q(0, V(255, n.g - G(-t / 100 * 255))), n.b = q(0, V(255, n.b - G(-t / 100 * 255))), o(n);
      }function _(e, t) {
        t = 0 === t ? 0 : t || 10;var n = o(e).toHsl();return n.l -= t / 100, n.l = M(n.l), o(n);
      }function w(e, t) {
        var n = o(e).toHsl(),
            r = (n.h + t) % 360;return n.h = r < 0 ? 360 + r : r, o(n);
      }function y(e) {
        var t = o(e).toHsl();return t.h = (t.h + 180) % 360, o(t);
      }function C(e) {
        var t = o(e).toHsl(),
            n = t.h;return [o(e), o({ h: (n + 120) % 360, s: t.s, l: t.l }), o({ h: (n + 240) % 360, s: t.s, l: t.l })];
      }function k(e) {
        var t = o(e).toHsl(),
            n = t.h;return [o(e), o({ h: (n + 90) % 360, s: t.s, l: t.l }), o({ h: (n + 180) % 360, s: t.s, l: t.l }), o({ h: (n + 270) % 360, s: t.s, l: t.l })];
      }function F(e) {
        var t = o(e).toHsl(),
            n = t.h;return [o(e), o({ h: (n + 72) % 360, s: t.s, l: t.l }), o({ h: (n + 216) % 360, s: t.s, l: t.l })];
      }function S(e, t, n) {
        t = t || 6, n = n || 30;var r = o(e).toHsl(),
            i = 360 / n,
            a = [o(e)];for (r.h = (r.h - (i * t >> 1) + 720) % 360; --t;) {
          r.h = (r.h + i) % 360, a.push(o(r));
        }return a;
      }function A(e, t) {
        t = t || 6;for (var n = o(e).toHsv(), r = n.h, i = n.s, a = n.v, s = [], c = 1 / t; t--;) {
          s.push(o({ h: r, s: i, v: a })), a = (a + c) % 1;
        }return s;
      }function O(e) {
        return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
      }function E(e, t) {
        L(e) && (e = "100%");var n = P(e);return e = V(t, q(0, parseFloat(e))), n && (e = parseInt(e * t, 10) / 100), i.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
      }function M(e) {
        return V(1, q(0, e));
      }function j(e) {
        return parseInt(e, 16);
      }function L(e) {
        return "string" == typeof e && -1 != e.indexOf(".") && 1 === parseFloat(e);
      }function P(e) {
        return "string" == typeof e && -1 != e.indexOf("%");
      }function R(e) {
        return 1 == e.length ? "0" + e : "" + e;
      }function D(e) {
        return e <= 1 && (e = 100 * e + "%"), e;
      }function B(e) {
        return i.round(255 * parseFloat(e)).toString(16);
      }function T(e) {
        return j(e) / 255;
      }function H(e) {
        return !!J.CSS_UNIT.exec(e);
      }function N(e) {
        e = e.replace(I, "").replace($, "").toLowerCase();var t = !1;if (W[e]) e = W[e], t = !0;else if ("transparent" == e) return { r: 0, g: 0, b: 0, a: 0, format: "name" };var n;return (n = J.rgb.exec(e)) ? { r: n[1], g: n[2], b: n[3] } : (n = J.rgba.exec(e)) ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = J.hsl.exec(e)) ? { h: n[1], s: n[2], l: n[3] } : (n = J.hsla.exec(e)) ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = J.hsv.exec(e)) ? { h: n[1], s: n[2], v: n[3] } : (n = J.hsva.exec(e)) ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = J.hex8.exec(e)) ? { r: j(n[1]), g: j(n[2]), b: j(n[3]), a: T(n[4]), format: t ? "name" : "hex8" } : (n = J.hex6.exec(e)) ? { r: j(n[1]), g: j(n[2]), b: j(n[3]), format: t ? "name" : "hex" } : (n = J.hex4.exec(e)) ? { r: j(n[1] + "" + n[1]), g: j(n[2] + "" + n[2]), b: j(n[3] + "" + n[3]), a: T(n[4] + "" + n[4]), format: t ? "name" : "hex8" } : !!(n = J.hex3.exec(e)) && { r: j(n[1] + "" + n[1]), g: j(n[2] + "" + n[2]), b: j(n[3] + "" + n[3]), format: t ? "name" : "hex" };
      }function z(e) {
        var t, n;return e = e || { level: "AA", size: "small" }, t = (e.level || "AA").toUpperCase(), n = (e.size || "small").toLowerCase(), "AA" !== t && "AAA" !== t && (t = "AA"), "small" !== n && "large" !== n && (n = "small"), { level: t, size: n };
      }var I = /^\s+/,
          $ = /\s+$/,
          U = 0,
          G = i.round,
          V = i.min,
          q = i.max,
          X = i.random;o.prototype = { isDark: function isDark() {
          return this.getBrightness() < 128;
        }, isLight: function isLight() {
          return !this.isDark();
        }, isValid: function isValid() {
          return this._ok;
        }, getOriginalInput: function getOriginalInput() {
          return this._originalInput;
        }, getFormat: function getFormat() {
          return this._format;
        }, getAlpha: function getAlpha() {
          return this._a;
        }, getBrightness: function getBrightness() {
          var e = this.toRgb();return (299 * e.r + 587 * e.g + 114 * e.b) / 1e3;
        }, getLuminance: function getLuminance() {
          var e,
              t,
              n,
              r,
              o,
              a,
              s = this.toRgb();return e = s.r / 255, t = s.g / 255, n = s.b / 255, r = e <= .03928 ? e / 12.92 : i.pow((e + .055) / 1.055, 2.4), o = t <= .03928 ? t / 12.92 : i.pow((t + .055) / 1.055, 2.4), a = n <= .03928 ? n / 12.92 : i.pow((n + .055) / 1.055, 2.4), .2126 * r + .7152 * o + .0722 * a;
        }, setAlpha: function setAlpha(e) {
          return this._a = O(e), this._roundA = G(100 * this._a) / 100, this;
        }, toHsv: function toHsv() {
          var e = u(this._r, this._g, this._b);return { h: 360 * e.h, s: e.s, v: e.v, a: this._a };
        }, toHsvString: function toHsvString() {
          var e = u(this._r, this._g, this._b),
              t = G(360 * e.h),
              n = G(100 * e.s),
              r = G(100 * e.v);return 1 == this._a ? "hsv(" + t + ", " + n + "%, " + r + "%)" : "hsva(" + t + ", " + n + "%, " + r + "%, " + this._roundA + ")";
        }, toHsl: function toHsl() {
          var e = c(this._r, this._g, this._b);return { h: 360 * e.h, s: e.s, l: e.l, a: this._a };
        }, toHslString: function toHslString() {
          var e = c(this._r, this._g, this._b),
              t = G(360 * e.h),
              n = G(100 * e.s),
              r = G(100 * e.l);return 1 == this._a ? "hsl(" + t + ", " + n + "%, " + r + "%)" : "hsla(" + t + ", " + n + "%, " + r + "%, " + this._roundA + ")";
        }, toHex: function toHex(e) {
          return d(this._r, this._g, this._b, e);
        }, toHexString: function toHexString(e) {
          return "#" + this.toHex(e);
        }, toHex8: function toHex8(e) {
          return h(this._r, this._g, this._b, this._a, e);
        }, toHex8String: function toHex8String(e) {
          return "#" + this.toHex8(e);
        }, toRgb: function toRgb() {
          return { r: G(this._r), g: G(this._g), b: G(this._b), a: this._a };
        }, toRgbString: function toRgbString() {
          return 1 == this._a ? "rgb(" + G(this._r) + ", " + G(this._g) + ", " + G(this._b) + ")" : "rgba(" + G(this._r) + ", " + G(this._g) + ", " + G(this._b) + ", " + this._roundA + ")";
        }, toPercentageRgb: function toPercentageRgb() {
          return { r: G(100 * E(this._r, 255)) + "%", g: G(100 * E(this._g, 255)) + "%", b: G(100 * E(this._b, 255)) + "%", a: this._a };
        }, toPercentageRgbString: function toPercentageRgbString() {
          return 1 == this._a ? "rgb(" + G(100 * E(this._r, 255)) + "%, " + G(100 * E(this._g, 255)) + "%, " + G(100 * E(this._b, 255)) + "%)" : "rgba(" + G(100 * E(this._r, 255)) + "%, " + G(100 * E(this._g, 255)) + "%, " + G(100 * E(this._b, 255)) + "%, " + this._roundA + ")";
        }, toName: function toName() {
          return 0 === this._a ? "transparent" : !(this._a < 1) && (Y[d(this._r, this._g, this._b, !0)] || !1);
        }, toFilter: function toFilter(e) {
          var t = "#" + p(this._r, this._g, this._b, this._a),
              n = t,
              r = this._gradientType ? "GradientType = 1, " : "";if (e) {
            var i = o(e);n = "#" + p(i._r, i._g, i._b, i._a);
          }return "progid:DXImageTransform.Microsoft.gradient(" + r + "startColorstr=" + t + ",endColorstr=" + n + ")";
        }, toString: function toString(e) {
          var t = !!e;e = e || this._format;var n = !1,
              r = this._a < 1 && this._a >= 0;return t || !r || "hex" !== e && "hex6" !== e && "hex3" !== e && "hex4" !== e && "hex8" !== e && "name" !== e ? ("rgb" === e && (n = this.toRgbString()), "prgb" === e && (n = this.toPercentageRgbString()), "hex" !== e && "hex6" !== e || (n = this.toHexString()), "hex3" === e && (n = this.toHexString(!0)), "hex4" === e && (n = this.toHex8String(!0)), "hex8" === e && (n = this.toHex8String()), "name" === e && (n = this.toName()), "hsl" === e && (n = this.toHslString()), "hsv" === e && (n = this.toHsvString()), n || this.toHexString()) : "name" === e && 0 === this._a ? this.toName() : this.toRgbString();
        }, clone: function clone() {
          return o(this.toString());
        }, _applyModification: function _applyModification(e, t) {
          var n = e.apply(null, [this].concat([].slice.call(t)));return this._r = n._r, this._g = n._g, this._b = n._b, this.setAlpha(n._a), this;
        }, lighten: function lighten() {
          return this._applyModification(x, arguments);
        }, brighten: function brighten() {
          return this._applyModification(m, arguments);
        }, darken: function darken() {
          return this._applyModification(_, arguments);
        }, desaturate: function desaturate() {
          return this._applyModification(v, arguments);
        }, saturate: function saturate() {
          return this._applyModification(g, arguments);
        }, greyscale: function greyscale() {
          return this._applyModification(b, arguments);
        }, spin: function spin() {
          return this._applyModification(w, arguments);
        }, _applyCombination: function _applyCombination(e, t) {
          return e.apply(null, [this].concat([].slice.call(t)));
        }, analogous: function analogous() {
          return this._applyCombination(S, arguments);
        }, complement: function complement() {
          return this._applyCombination(y, arguments);
        }, monochromatic: function monochromatic() {
          return this._applyCombination(A, arguments);
        }, splitcomplement: function splitcomplement() {
          return this._applyCombination(F, arguments);
        }, triad: function triad() {
          return this._applyCombination(C, arguments);
        }, tetrad: function tetrad() {
          return this._applyCombination(k, arguments);
        } }, o.fromRatio = function (e, t) {
        if ("object" == (typeof e === "undefined" ? "undefined" : _typeof(e))) {
          var n = {};for (var r in e) {
            e.hasOwnProperty(r) && (n[r] = "a" === r ? e[r] : D(e[r]));
          }e = n;
        }return o(e, t);
      }, o.equals = function (e, t) {
        return !(!e || !t) && o(e).toRgbString() == o(t).toRgbString();
      }, o.random = function () {
        return o.fromRatio({ r: X(), g: X(), b: X() });
      }, o.mix = function (e, t, n) {
        n = 0 === n ? 0 : n || 50;var r = o(e).toRgb(),
            i = o(t).toRgb(),
            a = n / 100;return o({ r: (i.r - r.r) * a + r.r, g: (i.g - r.g) * a + r.g, b: (i.b - r.b) * a + r.b, a: (i.a - r.a) * a + r.a });
      }, o.readability = function (e, t) {
        var n = o(e),
            r = o(t);return (i.max(n.getLuminance(), r.getLuminance()) + .05) / (i.min(n.getLuminance(), r.getLuminance()) + .05);
      }, o.isReadable = function (e, t, n) {
        var r,
            i,
            a = o.readability(e, t);switch (i = !1, r = z(n), r.level + r.size) {case "AAsmall":case "AAAlarge":
            i = a >= 4.5;break;case "AAlarge":
            i = a >= 3;break;case "AAAsmall":
            i = a >= 7;}return i;
      }, o.mostReadable = function (e, t, n) {
        var r,
            i,
            a,
            s,
            c = null,
            l = 0;n = n || {}, i = n.includeFallbackColors, a = n.level, s = n.size;for (var u = 0; u < t.length; u++) {
          (r = o.readability(e, t[u])) > l && (l = r, c = o(t[u]));
        }return o.isReadable(e, c, { level: a, size: s }) || !i ? c : (n.includeFallbackColors = !1, o.mostReadable(e, ["#fff", "#000"], n));
      };var W = o.names = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "0ff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000", blanchedalmond: "ffebcd", blue: "00f", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", burntsienna: "ea7e5d", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "0ff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkgrey: "a9a9a9", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "f0f", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", grey: "808080", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3", lightgreen: "90ee90", lightgrey: "d3d3d3", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslategray: "789", lightslategrey: "789", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "0f0", limegreen: "32cd32", linen: "faf0e6", magenta: "f0f", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370db", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "db7093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", rebeccapurple: "663399", red: "f00", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", slategrey: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", wheat: "f5deb3", white: "fff", whitesmoke: "f5f5f5", yellow: "ff0", yellowgreen: "9acd32" },
          Y = o.hexNames = function (e) {
        var t = {};for (var n in e) {
          e.hasOwnProperty(n) && (t[e[n]] = n);
        }return t;
      }(W),
          J = function () {
        var e = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)",
            t = "[\\s|\\(]+(" + e + ")[,|\\s]+(" + e + ")[,|\\s]+(" + e + ")\\s*\\)?",
            n = "[\\s|\\(]+(" + e + ")[,|\\s]+(" + e + ")[,|\\s]+(" + e + ")[,|\\s]+(" + e + ")\\s*\\)?";return { CSS_UNIT: new RegExp(e), rgb: new RegExp("rgb" + t), rgba: new RegExp("rgba" + n), hsl: new RegExp("hsl" + t), hsla: new RegExp("hsla" + n), hsv: new RegExp("hsv" + t), hsva: new RegExp("hsva" + n), hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/, hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/ };
      }();void 0 !== e && e.exports ? e.exports = o : void 0 !== (r = function () {
        return o;
      }.call(t, n, t, e)) && (e.exports = r);
    }(Math);
  }, function (e, t, n) {
    var r = n(67);"string" == typeof r && (r = [[e.i, r, ""]]), r.locals && (e.exports = r.locals);n(1)("0f73e73c", r, !1, {});
  }, function (e, t, n) {
    t = e.exports = n(0)(!1), t.push([e.i, "\n.vc-editable-input {\n  position: relative;\n}\n.vc-input__input {\n  padding: 0;\n  border: 0;\n  outline: none;\n}\n.vc-input__label {\n  text-transform: capitalize;\n}\n", ""]);
  }, function (e, t, n) {
    "use strict";
    var r = function r() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { staticClass: "vc-editable-input" }, [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.val, expression: "val" }], ref: "input", staticClass: "vc-input__input", attrs: { "aria-labelledby": e.labelId }, domProps: { value: e.val }, on: { keydown: e.handleKeyDown, input: [function (t) {
            t.target.composing || (e.val = t.target.value);
          }, e.update] } }), e._v(" "), n("span", { staticClass: "vc-input__label", attrs: { for: e.label, id: e.labelId } }, [e._v(e._s(e.labelSpanText))]), e._v(" "), n("span", { staticClass: "vc-input__desc" }, [e._v(e._s(e.desc))])]);
    },
        i = [];r._withStripped = !0;var o = { render: r, staticRenderFns: i };t.a = o;
  }, function (e, t, n) {
    "use strict";
    var r = function r() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { staticClass: "vc-compact", attrs: { role: "application", "aria-label": "Compact color picker" } }, [n("ul", { staticClass: "vc-compact-colors", attrs: { role: "listbox" } }, e._l(e.paletteUpperCase(e.palette), function (t) {
        return n("li", { key: t, staticClass: "vc-compact-color-item", class: { "vc-compact-color-item--white": "#FFFFFF" === t }, style: { background: t }, attrs: { role: "option", "aria-label": "color:" + t, "aria-selected": t === e.pick }, on: { click: function click(n) {
              return e.handlerClick(t);
            } } }, [n("div", { directives: [{ name: "show", rawName: "v-show", value: t === e.pick, expression: "c === pick" }], staticClass: "vc-compact-dot" })]);
      }), 0)]);
    },
        i = [];r._withStripped = !0;var o = { render: r, staticRenderFns: i };t.a = o;
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      c || n(71);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(37),
        o = n.n(i);for (var a in i) {
      "default" !== a && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(a);
    }var s = n(73),
        c = !1,
        l = n(2),
        u = r,
        f = l(o.a, s.a, !1, u, null, null);f.options.__file = "src/components/Grayscale.vue", t.default = f.exports;
  }, function (e, t, n) {
    var r = n(72);"string" == typeof r && (r = [[e.i, r, ""]]), r.locals && (e.exports = r.locals);n(1)("21ddbb74", r, !1, {});
  }, function (e, t, n) {
    t = e.exports = n(0)(!1), t.push([e.i, "\n.vc-grayscale {\n  width: 125px;\n  border-radius: 2px;\n  box-shadow: 0 2px 15px rgba(0,0,0,.12), 0 2px 10px rgba(0,0,0,.16);\n  background-color: #fff;\n}\n.vc-grayscale-colors {\n  border-radius: 2px;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n}\n.vc-grayscale-color-item {\n  list-style: none;\n  width: 25px;\n  height: 25px;\n  float: left;\n  position: relative;\n  cursor: pointer;\n}\n.vc-grayscale-color-item--white .vc-grayscale-dot {\n  background: #000;\n}\n.vc-grayscale-dot {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 6px;\n  height: 6px;\n  margin: -3px 0 0 -2px;\n  border-radius: 50%;\n  opacity: 1;\n  background: #fff;\n}\n", ""]);
  }, function (e, t, n) {
    "use strict";
    var r = function r() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { staticClass: "vc-grayscale", attrs: { role: "application", "aria-label": "Grayscale color picker" } }, [n("ul", { staticClass: "vc-grayscale-colors", attrs: { role: "listbox" } }, e._l(e.paletteUpperCase(e.palette), function (t) {
        return n("li", { key: t, staticClass: "vc-grayscale-color-item", class: { "vc-grayscale-color-item--white": "#FFFFFF" == t }, style: { background: t }, attrs: { role: "option", "aria-label": "Color:" + t, "aria-selected": t === e.pick }, on: { click: function click(n) {
              return e.handlerClick(t);
            } } }, [n("div", { directives: [{ name: "show", rawName: "v-show", value: t === e.pick, expression: "c === pick" }], staticClass: "vc-grayscale-dot" })]);
      }), 0)]);
    },
        i = [];r._withStripped = !0;var o = { render: r, staticRenderFns: i };t.a = o;
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      c || n(75);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(38),
        o = n.n(i);for (var a in i) {
      "default" !== a && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(a);
    }var s = n(77),
        c = !1,
        l = n(2),
        u = r,
        f = l(o.a, s.a, !1, u, null, null);f.options.__file = "src/components/Material.vue", t.default = f.exports;
  }, function (e, t, n) {
    var r = n(76);"string" == typeof r && (r = [[e.i, r, ""]]), r.locals && (e.exports = r.locals);n(1)("1ff3af73", r, !1, {});
  }, function (e, t, n) {
    t = e.exports = n(0)(!1), t.push([e.i, '\n.vc-material {\n  width: 98px;\n  height: 98px;\n  padding: 16px;\n  font-family: "Roboto";\n  position: relative;\n  border-radius: 2px;\n  box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);\n  background-color: #fff;\n}\n.vc-material .vc-input__input {\n  width: 100%;\n  margin-top: 12px;\n  font-size: 15px;\n  color: #333;\n  height: 30px;\n}\n.vc-material .vc-input__label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: 11px;\n  color: #999;\n  text-transform: capitalize;\n}\n.vc-material-hex {\n  border-bottom-width: 2px;\n  border-bottom-style: solid;\n}\n.vc-material-split {\n  display: flex;\n  margin-right: -10px;\n  padding-top: 11px;\n}\n.vc-material-third {\n  flex: 1;\n  padding-right: 10px;\n}\n', ""]);
  }, function (e, t, n) {
    "use strict";
    var r = function r() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { staticClass: "vc-material", attrs: { role: "application", "aria-label": "Material color picker" } }, [n("ed-in", { staticClass: "vc-material-hex", style: { borderColor: e.colors.hex }, attrs: { label: "hex" }, on: { change: e.onChange }, model: { value: e.colors.hex, callback: function callback(t) {
            e.$set(e.colors, "hex", t);
          }, expression: "colors.hex" } }), e._v(" "), n("div", { staticClass: "vc-material-split" }, [n("div", { staticClass: "vc-material-third" }, [n("ed-in", { attrs: { label: "r" }, on: { change: e.onChange }, model: { value: e.colors.rgba.r, callback: function callback(t) {
            e.$set(e.colors.rgba, "r", t);
          }, expression: "colors.rgba.r" } })], 1), e._v(" "), n("div", { staticClass: "vc-material-third" }, [n("ed-in", { attrs: { label: "g" }, on: { change: e.onChange }, model: { value: e.colors.rgba.g, callback: function callback(t) {
            e.$set(e.colors.rgba, "g", t);
          }, expression: "colors.rgba.g" } })], 1), e._v(" "), n("div", { staticClass: "vc-material-third" }, [n("ed-in", { attrs: { label: "b" }, on: { change: e.onChange }, model: { value: e.colors.rgba.b, callback: function callback(t) {
            e.$set(e.colors.rgba, "b", t);
          }, expression: "colors.rgba.b" } })], 1)])], 1);
    },
        i = [];r._withStripped = !0;var o = { render: r, staticRenderFns: i };t.a = o;
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      c || n(79);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(39),
        o = n.n(i);for (var a in i) {
      "default" !== a && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(a);
    }var s = n(114),
        c = !1,
        l = n(2),
        u = r,
        f = l(o.a, s.a, !1, u, null, null);f.options.__file = "src/components/Slider.vue", t.default = f.exports;
  }, function (e, t, n) {
    var r = n(80);"string" == typeof r && (r = [[e.i, r, ""]]), r.locals && (e.exports = r.locals);n(1)("7982aa43", r, !1, {});
  }, function (e, t, n) {
    t = e.exports = n(0)(!1), t.push([e.i, "\n.vc-slider {\n  position: relative;\n  width: 410px;\n}\n.vc-slider-hue-warp {\n  height: 12px;\n  position: relative;\n}\n.vc-slider-hue-warp .vc-hue-picker {\n  width: 14px;\n  height: 14px;\n  border-radius: 6px;\n  transform: translate(-7px, -2px);\n  background-color: rgb(248, 248, 248);\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n}\n.vc-slider-swatches {\n  display: flex;\n  margin-top: 20px;\n}\n.vc-slider-swatch {\n  margin-right: 1px;\n  flex: 1;\n  width: 20%;\n}\n.vc-slider-swatch:first-child {\n  margin-right: 1px;\n}\n.vc-slider-swatch:first-child .vc-slider-swatch-picker {\n  border-radius: 2px 0px 0px 2px;\n}\n.vc-slider-swatch:last-child {\n  margin-right: 0;\n}\n.vc-slider-swatch:last-child .vc-slider-swatch-picker {\n  border-radius: 0px 2px 2px 0px;\n}\n.vc-slider-swatch-picker {\n  cursor: pointer;\n  height: 12px;\n}\n.vc-slider-swatch:nth-child(n) .vc-slider-swatch-picker.vc-slider-swatch-picker--active {\n  transform: scaleY(1.8);\n  border-radius: 3.6px/2px;\n}\n.vc-slider-swatch-picker--white {\n  box-shadow: inset 0 0 0 1px #ddd;\n}\n.vc-slider-swatch-picker--active.vc-slider-swatch-picker--white {\n  box-shadow: inset 0 0 0 0.6px #ddd;\n}\n", ""]);
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }t.__esModule = !0;var i = n(82),
        o = r(i),
        a = n(100),
        s = r(a),
        c = "function" == typeof s.default && "symbol" == _typeof(o.default) ? function (e) {
      return typeof e === "undefined" ? "undefined" : _typeof(e);
    } : function (e) {
      return e && "function" == typeof s.default && e.constructor === s.default && e !== s.default.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
    };t.default = "function" == typeof s.default && "symbol" === c(o.default) ? function (e) {
      return void 0 === e ? "undefined" : c(e);
    } : function (e) {
      return e && "function" == typeof s.default && e.constructor === s.default && e !== s.default.prototype ? "symbol" : void 0 === e ? "undefined" : c(e);
    };
  }, function (e, t, n) {
    e.exports = { default: n(83), __esModule: !0 };
  }, function (e, t, n) {
    n(84), n(96), e.exports = n(32).f("iterator");
  }, function (e, t, n) {
    "use strict";
    var r = n(85)(!0);n(40)(String, "String", function (e) {
      this._t = String(e), this._i = 0;
    }, function () {
      var e,
          t = this._t,
          n = this._i;return n >= t.length ? { value: void 0, done: !0 } : (e = r(t, n), this._i += e.length, { value: e, done: !1 });
    });
  }, function (e, t, n) {
    var r = n(23),
        i = n(24);e.exports = function (e) {
      return function (t, n) {
        var o,
            a,
            s = String(i(t)),
            c = r(n),
            l = s.length;return c < 0 || c >= l ? e ? "" : void 0 : (o = s.charCodeAt(c), o < 55296 || o > 56319 || c + 1 === l || (a = s.charCodeAt(c + 1)) < 56320 || a > 57343 ? e ? s.charAt(c) : o : e ? s.slice(c, c + 2) : a - 56320 + (o - 55296 << 10) + 65536);
      };
    };
  }, function (e, t, n) {
    var r = n(87);e.exports = function (e, t, n) {
      if (r(e), void 0 === t) return e;switch (n) {case 1:
          return function (n) {
            return e.call(t, n);
          };case 2:
          return function (n, r) {
            return e.call(t, n, r);
          };case 3:
          return function (n, r, i) {
            return e.call(t, n, r, i);
          };}return function () {
        return e.apply(t, arguments);
      };
    };
  }, function (e, t) {
    e.exports = function (e) {
      if ("function" != typeof e) throw TypeError(e + " is not a function!");return e;
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(45),
        i = n(18),
        o = n(31),
        a = {};n(7)(a, n(11)("iterator"), function () {
      return this;
    }), e.exports = function (e, t, n) {
      e.prototype = r(a, { next: i(1, n) }), o(e, t + " Iterator");
    };
  }, function (e, t, n) {
    var r = n(8),
        i = n(16),
        o = n(27);e.exports = n(9) ? Object.defineProperties : function (e, t) {
      i(e);for (var n, a = o(t), s = a.length, c = 0; s > c;) {
        r.f(e, n = a[c++], t[n]);
      }return e;
    };
  }, function (e, t, n) {
    var r = n(47);e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
      return "String" == r(e) ? e.split("") : Object(e);
    };
  }, function (e, t, n) {
    var r = n(10),
        i = n(92),
        o = n(93);e.exports = function (e) {
      return function (t, n, a) {
        var s,
            c = r(t),
            l = i(c.length),
            u = o(a, l);if (e && n != n) {
          for (; l > u;) {
            if ((s = c[u++]) != s) return !0;
          }
        } else for (; l > u; u++) {
          if ((e || u in c) && c[u] === n) return e || u || 0;
        }return !e && -1;
      };
    };
  }, function (e, t, n) {
    var r = n(23),
        i = Math.min;e.exports = function (e) {
      return e > 0 ? i(r(e), 9007199254740991) : 0;
    };
  }, function (e, t, n) {
    var r = n(23),
        i = Math.max,
        o = Math.min;e.exports = function (e, t) {
      return e = r(e), e < 0 ? i(e + t, 0) : o(e, t);
    };
  }, function (e, t, n) {
    var r = n(4).document;e.exports = r && r.documentElement;
  }, function (e, t, n) {
    var r = n(6),
        i = n(48),
        o = n(28)("IE_PROTO"),
        a = Object.prototype;e.exports = Object.getPrototypeOf || function (e) {
      return e = i(e), r(e, o) ? e[o] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? a : null;
    };
  }, function (e, t, n) {
    n(97);for (var r = n(4), i = n(7), o = n(26), a = n(11)("toStringTag"), s = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), c = 0; c < s.length; c++) {
      var l = s[c],
          u = r[l],
          f = u && u.prototype;f && !f[a] && i(f, a, l), o[l] = o.Array;
    }
  }, function (e, t, n) {
    "use strict";
    var r = n(98),
        i = n(99),
        o = n(26),
        a = n(10);e.exports = n(40)(Array, "Array", function (e, t) {
      this._t = a(e), this._i = 0, this._k = t;
    }, function () {
      var e = this._t,
          t = this._k,
          n = this._i++;return !e || n >= e.length ? (this._t = void 0, i(1)) : "keys" == t ? i(0, n) : "values" == t ? i(0, e[n]) : i(0, [n, e[n]]);
    }, "values"), o.Arguments = o.Array, r("keys"), r("values"), r("entries");
  }, function (e, t) {
    e.exports = function () {};
  }, function (e, t) {
    e.exports = function (e, t) {
      return { value: t, done: !!e };
    };
  }, function (e, t, n) {
    e.exports = { default: n(101), __esModule: !0 };
  }, function (e, t, n) {
    n(102), n(108), n(109), n(110), e.exports = n(15).Symbol;
  }, function (e, t, n) {
    "use strict";
    var r = n(4),
        i = n(6),
        o = n(9),
        a = n(41),
        s = n(44),
        c = n(103).KEY,
        l = n(17),
        u = n(29),
        f = n(31),
        d = n(19),
        h = n(11),
        p = n(32),
        v = n(33),
        g = n(104),
        b = n(105),
        x = n(16),
        m = n(12),
        _ = n(48),
        w = n(10),
        y = n(25),
        C = n(18),
        k = n(45),
        F = n(106),
        S = n(107),
        A = n(49),
        O = n(8),
        E = n(27),
        M = S.f,
        j = O.f,
        L = F.f,
        _P = r.Symbol,
        R = r.JSON,
        D = R && R.stringify,
        B = h("_hidden"),
        T = h("toPrimitive"),
        H = {}.propertyIsEnumerable,
        N = u("symbol-registry"),
        z = u("symbols"),
        I = u("op-symbols"),
        $ = Object.prototype,
        U = "function" == typeof _P && !!A.f,
        G = r.QObject,
        V = !G || !G.prototype || !G.prototype.findChild,
        q = o && l(function () {
      return 7 != k(j({}, "a", { get: function get() {
          return j(this, "a", { value: 7 }).a;
        } })).a;
    }) ? function (e, t, n) {
      var r = M($, t);r && delete $[t], j(e, t, n), r && e !== $ && j($, t, r);
    } : j,
        X = function X(e) {
      var t = z[e] = k(_P.prototype);return t._k = e, t;
    },
        W = U && "symbol" == _typeof(_P.iterator) ? function (e) {
      return "symbol" == (typeof e === "undefined" ? "undefined" : _typeof(e));
    } : function (e) {
      return e instanceof _P;
    },
        Y = function Y(e, t, n) {
      return e === $ && Y(I, t, n), x(e), t = y(t, !0), x(n), i(z, t) ? (n.enumerable ? (i(e, B) && e[B][t] && (e[B][t] = !1), n = k(n, { enumerable: C(0, !1) })) : (i(e, B) || j(e, B, C(1, {})), e[B][t] = !0), q(e, t, n)) : j(e, t, n);
    },
        J = function J(e, t) {
      x(e);for (var n, r = g(t = w(t)), i = 0, o = r.length; o > i;) {
        Y(e, n = r[i++], t[n]);
      }return e;
    },
        K = function K(e, t) {
      return void 0 === t ? k(e) : J(k(e), t);
    },
        Z = function Z(e) {
      var t = H.call(this, e = y(e, !0));return !(this === $ && i(z, e) && !i(I, e)) && (!(t || !i(this, e) || !i(z, e) || i(this, B) && this[B][e]) || t);
    },
        Q = function Q(e, t) {
      if (e = w(e), t = y(t, !0), e !== $ || !i(z, t) || i(I, t)) {
        var n = M(e, t);return !n || !i(z, t) || i(e, B) && e[B][t] || (n.enumerable = !0), n;
      }
    },
        ee = function ee(e) {
      for (var t, n = L(w(e)), r = [], o = 0; n.length > o;) {
        i(z, t = n[o++]) || t == B || t == c || r.push(t);
      }return r;
    },
        te = function te(e) {
      for (var t, n = e === $, r = L(n ? I : w(e)), o = [], a = 0; r.length > a;) {
        !i(z, t = r[a++]) || n && !i($, t) || o.push(z[t]);
      }return o;
    };U || (_P = function P() {
      if (this instanceof _P) throw TypeError("Symbol is not a constructor!");var e = d(arguments.length > 0 ? arguments[0] : void 0),
          t = function t(n) {
        this === $ && t.call(I, n), i(this, B) && i(this[B], e) && (this[B][e] = !1), q(this, e, C(1, n));
      };return o && V && q($, e, { configurable: !0, set: t }), X(e);
    }, s(_P.prototype, "toString", function () {
      return this._k;
    }), S.f = Q, O.f = Y, n(50).f = F.f = ee, n(34).f = Z, A.f = te, o && !n(14) && s($, "propertyIsEnumerable", Z, !0), p.f = function (e) {
      return X(h(e));
    }), a(a.G + a.W + a.F * !U, { Symbol: _P });for (var ne = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), re = 0; ne.length > re;) {
      h(ne[re++]);
    }for (var ie = E(h.store), oe = 0; ie.length > oe;) {
      v(ie[oe++]);
    }a(a.S + a.F * !U, "Symbol", { for: function _for(e) {
        return i(N, e += "") ? N[e] : N[e] = _P(e);
      }, keyFor: function keyFor(e) {
        if (!W(e)) throw TypeError(e + " is not a symbol!");for (var t in N) {
          if (N[t] === e) return t;
        }
      }, useSetter: function useSetter() {
        V = !0;
      }, useSimple: function useSimple() {
        V = !1;
      } }), a(a.S + a.F * !U, "Object", { create: K, defineProperty: Y, defineProperties: J, getOwnPropertyDescriptor: Q, getOwnPropertyNames: ee, getOwnPropertySymbols: te });var ae = l(function () {
      A.f(1);
    });a(a.S + a.F * ae, "Object", { getOwnPropertySymbols: function getOwnPropertySymbols(e) {
        return A.f(_(e));
      } }), R && a(a.S + a.F * (!U || l(function () {
      var e = _P();return "[null]" != D([e]) || "{}" != D({ a: e }) || "{}" != D(Object(e));
    })), "JSON", { stringify: function stringify(e) {
        for (var t, n, r = [e], i = 1; arguments.length > i;) {
          r.push(arguments[i++]);
        }if (n = t = r[1], (m(t) || void 0 !== e) && !W(e)) return b(t) || (t = function t(e, _t2) {
          if ("function" == typeof n && (_t2 = n.call(this, e, _t2)), !W(_t2)) return _t2;
        }), r[1] = t, D.apply(R, r);
      } }), _P.prototype[T] || n(7)(_P.prototype, T, _P.prototype.valueOf), f(_P, "Symbol"), f(Math, "Math", !0), f(r.JSON, "JSON", !0);
  }, function (e, t, n) {
    var r = n(19)("meta"),
        i = n(12),
        o = n(6),
        a = n(8).f,
        s = 0,
        c = Object.isExtensible || function () {
      return !0;
    },
        l = !n(17)(function () {
      return c(Object.preventExtensions({}));
    }),
        u = function u(e) {
      a(e, r, { value: { i: "O" + ++s, w: {} } });
    },
        f = function f(e, t) {
      if (!i(e)) return "symbol" == (typeof e === "undefined" ? "undefined" : _typeof(e)) ? e : ("string" == typeof e ? "S" : "P") + e;if (!o(e, r)) {
        if (!c(e)) return "F";if (!t) return "E";u(e);
      }return e[r].i;
    },
        d = function d(e, t) {
      if (!o(e, r)) {
        if (!c(e)) return !0;if (!t) return !1;u(e);
      }return e[r].w;
    },
        h = function h(e) {
      return l && p.NEED && c(e) && !o(e, r) && u(e), e;
    },
        p = e.exports = { KEY: r, NEED: !1, fastKey: f, getWeak: d, onFreeze: h };
  }, function (e, t, n) {
    var r = n(27),
        i = n(49),
        o = n(34);e.exports = function (e) {
      var t = r(e),
          n = i.f;if (n) for (var a, s = n(e), c = o.f, l = 0; s.length > l;) {
        c.call(e, a = s[l++]) && t.push(a);
      }return t;
    };
  }, function (e, t, n) {
    var r = n(47);e.exports = Array.isArray || function (e) {
      return "Array" == r(e);
    };
  }, function (e, t, n) {
    var r = n(10),
        i = n(50).f,
        o = {}.toString,
        a = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
        s = function s(e) {
      try {
        return i(e);
      } catch (e) {
        return a.slice();
      }
    };e.exports.f = function (e) {
      return a && "[object Window]" == o.call(e) ? s(e) : i(r(e));
    };
  }, function (e, t, n) {
    var r = n(34),
        i = n(18),
        o = n(10),
        a = n(25),
        s = n(6),
        c = n(42),
        l = Object.getOwnPropertyDescriptor;t.f = n(9) ? l : function (e, t) {
      if (e = o(e), t = a(t, !0), c) try {
        return l(e, t);
      } catch (e) {}if (s(e, t)) return i(!r.f.call(e, t), e[t]);
    };
  }, function (e, t) {}, function (e, t, n) {
    n(33)("asyncIterator");
  }, function (e, t, n) {
    n(33)("observable");
  }, function (e, t, n) {
    var r = n(112);"string" == typeof r && (r = [[e.i, r, ""]]), r.locals && (e.exports = r.locals);n(1)("7c5f1a1c", r, !1, {});
  }, function (e, t, n) {
    t = e.exports = n(0)(!1), t.push([e.i, "\n.vc-hue {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  border-radius: 2px;\n}\n.vc-hue--horizontal {\n  background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n}\n.vc-hue--vertical {\n  background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n}\n.vc-hue-container {\n  cursor: pointer;\n  margin: 0 2px;\n  position: relative;\n  height: 100%;\n}\n.vc-hue-pointer {\n  z-index: 2;\n  position: absolute;\n}\n.vc-hue-picker {\n  cursor: pointer;\n  margin-top: 1px;\n  width: 4px;\n  border-radius: 1px;\n  height: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .6);\n  background: #fff;\n  transform: translateX(-2px) ;\n}\n", ""]);
  }, function (e, t, n) {
    "use strict";
    var r = function r() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { class: ["vc-hue", e.directionClass] }, [n("div", { ref: "container", staticClass: "vc-hue-container", attrs: { role: "slider", "aria-valuenow": e.colors.hsl.h, "aria-valuemin": "0", "aria-valuemax": "360" }, on: { mousedown: e.handleMouseDown, touchmove: e.handleChange, touchstart: e.handleChange } }, [n("div", { staticClass: "vc-hue-pointer", style: { top: e.pointerTop, left: e.pointerLeft }, attrs: { role: "presentation" } }, [n("div", { staticClass: "vc-hue-picker" })])])]);
    },
        i = [];r._withStripped = !0;var o = { render: r, staticRenderFns: i };t.a = o;
  }, function (e, t, n) {
    "use strict";
    var r = function r() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { staticClass: "vc-slider", attrs: { role: "application", "aria-label": "Slider color picker" } }, [n("div", { staticClass: "vc-slider-hue-warp" }, [n("hue", { on: { change: e.hueChange }, model: { value: e.colors, callback: function callback(t) {
            e.colors = t;
          }, expression: "colors" } })], 1), e._v(" "), n("div", { staticClass: "vc-slider-swatches", attrs: { role: "group" } }, e._l(e.normalizedSwatches, function (t, r) {
        return n("div", { key: r, staticClass: "vc-slider-swatch", attrs: { "data-index": r, "aria-label": "color:" + e.colors.hex, role: "button" }, on: { click: function click(n) {
              return e.handleSwClick(r, t);
            } } }, [n("div", { staticClass: "vc-slider-swatch-picker", class: { "vc-slider-swatch-picker--active": e.isActive(t, r), "vc-slider-swatch-picker--white": 1 === t.l }, style: { background: "hsl(" + e.colors.hsl.h + ", " + 100 * t.s + "%, " + 100 * t.l + "%)" } })]);
      }), 0)]);
    },
        i = [];r._withStripped = !0;var o = { render: r, staticRenderFns: i };t.a = o;
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      c || n(116);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(52),
        o = n.n(i);for (var a in i) {
      "default" !== a && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(a);
    }var s = n(119),
        c = !1,
        l = n(2),
        u = r,
        f = l(o.a, s.a, !1, u, null, null);f.options.__file = "src/components/Swatches.vue", t.default = f.exports;
  }, function (e, t, n) {
    var r = n(117);"string" == typeof r && (r = [[e.i, r, ""]]), r.locals && (e.exports = r.locals);n(1)("10f839a2", r, !1, {});
  }, function (e, t, n) {
    t = e.exports = n(0)(!1), t.push([e.i, "\n.vc-swatches {\n  width: 320px;\n  height: 240px;\n  overflow-y: scroll;\n  background-color: #fff;\n  box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);\n}\n.vc-swatches-box {\n  padding: 16px 0 6px 16px;\n  overflow: hidden;\n}\n.vc-swatches-color-group {\n  padding-bottom: 10px;\n  width: 40px;\n  float: left;\n  margin-right: 10px;\n}\n.vc-swatches-color-it {\n  box-sizing: border-box;\n  width: 40px;\n  height: 24px;\n  cursor: pointer;\n  background: #880e4f;\n  margin-bottom: 1px;\n  overflow: hidden;\n  -ms-border-radius: 2px 2px 0 0;\n  -moz-border-radius: 2px 2px 0 0;\n  -o-border-radius: 2px 2px 0 0;\n  -webkit-border-radius: 2px 2px 0 0;\n  border-radius: 2px 2px 0 0;\n}\n.vc-swatches-color--white {\n  border: 1px solid #DDD;\n}\n.vc-swatches-pick {\n  fill: rgb(255, 255, 255);\n  margin-left: 8px;\n  display: block;\n}\n.vc-swatches-color--white .vc-swatches-pick {\n  fill: rgb(51, 51, 51);\n}\n", ""]);
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), n.d(t, "red", function () {
      return r;
    }), n.d(t, "pink", function () {
      return i;
    }), n.d(t, "purple", function () {
      return o;
    }), n.d(t, "deepPurple", function () {
      return a;
    }), n.d(t, "indigo", function () {
      return s;
    }), n.d(t, "blue", function () {
      return c;
    }), n.d(t, "lightBlue", function () {
      return l;
    }), n.d(t, "cyan", function () {
      return u;
    }), n.d(t, "teal", function () {
      return f;
    }), n.d(t, "green", function () {
      return d;
    }), n.d(t, "lightGreen", function () {
      return h;
    }), n.d(t, "lime", function () {
      return p;
    }), n.d(t, "yellow", function () {
      return v;
    }), n.d(t, "amber", function () {
      return g;
    }), n.d(t, "orange", function () {
      return b;
    }), n.d(t, "deepOrange", function () {
      return x;
    }), n.d(t, "brown", function () {
      return m;
    }), n.d(t, "grey", function () {
      return _;
    }), n.d(t, "blueGrey", function () {
      return w;
    }), n.d(t, "darkText", function () {
      return y;
    }), n.d(t, "lightText", function () {
      return C;
    }), n.d(t, "darkIcons", function () {
      return k;
    }), n.d(t, "lightIcons", function () {
      return F;
    }), n.d(t, "white", function () {
      return S;
    }), n.d(t, "black", function () {
      return A;
    });var r = { 50: "#ffebee", 100: "#ffcdd2", 200: "#ef9a9a", 300: "#e57373", 400: "#ef5350", 500: "#f44336", 600: "#e53935", 700: "#d32f2f", 800: "#c62828", 900: "#b71c1c", a100: "#ff8a80", a200: "#ff5252", a400: "#ff1744", a700: "#d50000" },
        i = { 50: "#fce4ec", 100: "#f8bbd0", 200: "#f48fb1", 300: "#f06292", 400: "#ec407a", 500: "#e91e63", 600: "#d81b60", 700: "#c2185b", 800: "#ad1457", 900: "#880e4f", a100: "#ff80ab", a200: "#ff4081", a400: "#f50057", a700: "#c51162" },
        o = { 50: "#f3e5f5", 100: "#e1bee7", 200: "#ce93d8", 300: "#ba68c8", 400: "#ab47bc", 500: "#9c27b0", 600: "#8e24aa", 700: "#7b1fa2", 800: "#6a1b9a", 900: "#4a148c", a100: "#ea80fc", a200: "#e040fb", a400: "#d500f9", a700: "#aa00ff" },
        a = { 50: "#ede7f6", 100: "#d1c4e9", 200: "#b39ddb", 300: "#9575cd", 400: "#7e57c2", 500: "#673ab7", 600: "#5e35b1", 700: "#512da8", 800: "#4527a0", 900: "#311b92", a100: "#b388ff", a200: "#7c4dff", a400: "#651fff", a700: "#6200ea" },
        s = { 50: "#e8eaf6", 100: "#c5cae9", 200: "#9fa8da", 300: "#7986cb", 400: "#5c6bc0", 500: "#3f51b5", 600: "#3949ab", 700: "#303f9f", 800: "#283593", 900: "#1a237e", a100: "#8c9eff", a200: "#536dfe", a400: "#3d5afe", a700: "#304ffe" },
        c = { 50: "#e3f2fd", 100: "#bbdefb", 200: "#90caf9", 300: "#64b5f6", 400: "#42a5f5", 500: "#2196f3", 600: "#1e88e5", 700: "#1976d2", 800: "#1565c0", 900: "#0d47a1", a100: "#82b1ff", a200: "#448aff", a400: "#2979ff", a700: "#2962ff" },
        l = { 50: "#e1f5fe", 100: "#b3e5fc", 200: "#81d4fa", 300: "#4fc3f7", 400: "#29b6f6", 500: "#03a9f4", 600: "#039be5", 700: "#0288d1", 800: "#0277bd", 900: "#01579b", a100: "#80d8ff", a200: "#40c4ff", a400: "#00b0ff", a700: "#0091ea" },
        u = { 50: "#e0f7fa", 100: "#b2ebf2", 200: "#80deea", 300: "#4dd0e1", 400: "#26c6da", 500: "#00bcd4", 600: "#00acc1", 700: "#0097a7", 800: "#00838f", 900: "#006064", a100: "#84ffff", a200: "#18ffff", a400: "#00e5ff", a700: "#00b8d4" },
        f = { 50: "#e0f2f1", 100: "#b2dfdb", 200: "#80cbc4", 300: "#4db6ac", 400: "#26a69a", 500: "#009688", 600: "#00897b", 700: "#00796b", 800: "#00695c", 900: "#004d40", a100: "#a7ffeb", a200: "#64ffda", a400: "#1de9b6", a700: "#00bfa5" },
        d = { 50: "#e8f5e9", 100: "#c8e6c9", 200: "#a5d6a7", 300: "#81c784", 400: "#66bb6a", 500: "#4caf50", 600: "#43a047", 700: "#388e3c", 800: "#2e7d32", 900: "#1b5e20", a100: "#b9f6ca", a200: "#69f0ae", a400: "#00e676", a700: "#00c853" },
        h = { 50: "#f1f8e9", 100: "#dcedc8", 200: "#c5e1a5", 300: "#aed581", 400: "#9ccc65", 500: "#8bc34a", 600: "#7cb342", 700: "#689f38", 800: "#558b2f", 900: "#33691e", a100: "#ccff90", a200: "#b2ff59", a400: "#76ff03", a700: "#64dd17" },
        p = { 50: "#f9fbe7", 100: "#f0f4c3", 200: "#e6ee9c", 300: "#dce775", 400: "#d4e157", 500: "#cddc39", 600: "#c0ca33", 700: "#afb42b", 800: "#9e9d24", 900: "#827717", a100: "#f4ff81", a200: "#eeff41", a400: "#c6ff00", a700: "#aeea00" },
        v = { 50: "#fffde7", 100: "#fff9c4", 200: "#fff59d", 300: "#fff176", 400: "#ffee58", 500: "#ffeb3b", 600: "#fdd835", 700: "#fbc02d", 800: "#f9a825", 900: "#f57f17", a100: "#ffff8d", a200: "#ffff00", a400: "#ffea00", a700: "#ffd600" },
        g = { 50: "#fff8e1", 100: "#ffecb3", 200: "#ffe082", 300: "#ffd54f", 400: "#ffca28", 500: "#ffc107", 600: "#ffb300", 700: "#ffa000", 800: "#ff8f00", 900: "#ff6f00", a100: "#ffe57f", a200: "#ffd740", a400: "#ffc400", a700: "#ffab00" },
        b = { 50: "#fff3e0", 100: "#ffe0b2", 200: "#ffcc80", 300: "#ffb74d", 400: "#ffa726", 500: "#ff9800", 600: "#fb8c00", 700: "#f57c00", 800: "#ef6c00", 900: "#e65100", a100: "#ffd180", a200: "#ffab40", a400: "#ff9100", a700: "#ff6d00" },
        x = { 50: "#fbe9e7", 100: "#ffccbc", 200: "#ffab91", 300: "#ff8a65", 400: "#ff7043", 500: "#ff5722", 600: "#f4511e", 700: "#e64a19", 800: "#d84315", 900: "#bf360c", a100: "#ff9e80", a200: "#ff6e40", a400: "#ff3d00", a700: "#dd2c00" },
        m = { 50: "#efebe9", 100: "#d7ccc8", 200: "#bcaaa4", 300: "#a1887f", 400: "#8d6e63", 500: "#795548", 600: "#6d4c41", 700: "#5d4037", 800: "#4e342e", 900: "#3e2723" },
        _ = { 50: "#fafafa", 100: "#f5f5f5", 200: "#eeeeee", 300: "#e0e0e0", 400: "#bdbdbd", 500: "#9e9e9e", 600: "#757575", 700: "#616161", 800: "#424242", 900: "#212121" },
        w = { 50: "#eceff1", 100: "#cfd8dc", 200: "#b0bec5", 300: "#90a4ae", 400: "#78909c", 500: "#607d8b", 600: "#546e7a", 700: "#455a64", 800: "#37474f", 900: "#263238" },
        y = { primary: "rgba(0, 0, 0, 0.87)", secondary: "rgba(0, 0, 0, 0.54)", disabled: "rgba(0, 0, 0, 0.38)", dividers: "rgba(0, 0, 0, 0.12)" },
        C = { primary: "rgba(255, 255, 255, 1)", secondary: "rgba(255, 255, 255, 0.7)", disabled: "rgba(255, 255, 255, 0.5)", dividers: "rgba(255, 255, 255, 0.12)" },
        k = { active: "rgba(0, 0, 0, 0.54)", inactive: "rgba(0, 0, 0, 0.38)" },
        F = { active: "rgba(255, 255, 255, 1)", inactive: "rgba(255, 255, 255, 0.5)" },
        S = "#ffffff",
        A = "#000000";t.default = { red: r, pink: i, purple: o, deepPurple: a, indigo: s, blue: c, lightBlue: l, cyan: u, teal: f, green: d, lightGreen: h, lime: p, yellow: v, amber: g, orange: b, deepOrange: x, brown: m, grey: _, blueGrey: w, darkText: y, lightText: C, darkIcons: k, lightIcons: F, white: S, black: A };
  }, function (e, t, n) {
    "use strict";
    var r = function r() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { staticClass: "vc-swatches", attrs: { role: "application", "aria-label": "Swatches color picker", "data-pick": e.pick } }, [n("div", { staticClass: "vc-swatches-box", attrs: { role: "listbox" } }, e._l(e.palette, function (t, r) {
        return n("div", { key: r, staticClass: "vc-swatches-color-group" }, e._l(t, function (t) {
          return n("div", { key: t, class: ["vc-swatches-color-it", { "vc-swatches-color--white": "#FFFFFF" === t }], style: { background: t }, attrs: { role: "option", "aria-label": "Color:" + t, "aria-selected": e.equal(t), "data-color": t }, on: { click: function click(n) {
                return e.handlerClick(t);
              } } }, [n("div", { directives: [{ name: "show", rawName: "v-show", value: e.equal(t), expression: "equal(c)" }], staticClass: "vc-swatches-pick" }, [n("svg", { staticStyle: { width: "24px", height: "24px" }, attrs: { viewBox: "0 0 24 24" } }, [n("path", { attrs: { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" } })])])]);
        }), 0);
      }), 0)]);
    },
        i = [];r._withStripped = !0;var o = { render: r, staticRenderFns: i };t.a = o;
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      c || n(121);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(53),
        o = n.n(i);for (var a in i) {
      "default" !== a && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(a);
    }var s = n(134),
        c = !1,
        l = n(2),
        u = r,
        f = l(o.a, s.a, !1, u, null, null);f.options.__file = "src/components/Photoshop.vue", t.default = f.exports;
  }, function (e, t, n) {
    var r = n(122);"string" == typeof r && (r = [[e.i, r, ""]]), r.locals && (e.exports = r.locals);n(1)("080365d4", r, !1, {});
  }, function (e, t, n) {
    t = e.exports = n(0)(!1), t.push([e.i, '\n.vc-photoshop {\n  background: #DCDCDC;\n  border-radius: 4px;\n  box-shadow: 0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15);\n  box-sizing: initial;\n  width: 513px;\n  font-family: Roboto;\n}\n.vc-photoshop__disable-fields {\n  width: 390px;\n}\n.vc-ps-head {\n  background-image: linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%);\n  border-bottom: 1px solid #B1B1B1;\n  box-shadow: inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02);\n  height: 23px;\n  line-height: 24px;\n  border-radius: 4px 4px 0 0;\n  font-size: 13px;\n  color: #4D4D4D;\n  text-align: center;\n}\n.vc-ps-body {\n  padding: 15px;\n  display: flex;\n}\n.vc-ps-saturation-wrap {\n  width: 256px;\n  height: 256px;\n  position: relative;\n  border: 2px solid #B3B3B3;\n  border-bottom: 2px solid #F0F0F0;\n  overflow: hidden;\n}\n.vc-ps-saturation-wrap .vc-saturation-circle {\n  width: 12px;\n  height: 12px;\n}\n.vc-ps-hue-wrap {\n  position: relative;\n  height: 256px;\n  width: 19px;\n  margin-left: 10px;\n  border: 2px solid #B3B3B3;\n  border-bottom: 2px solid #F0F0F0;\n}\n.vc-ps-hue-pointer {\n  position: relative;\n}\n.vc-ps-hue-pointer--left,\n.vc-ps-hue-pointer--right {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 5px 0 5px 8px;\n  border-color: transparent transparent transparent #555;\n}\n.vc-ps-hue-pointer--left:after,\n.vc-ps-hue-pointer--right:after {\n  content: "";\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 4px 0 4px 6px;\n  border-color: transparent transparent transparent #fff;\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  transform: translate(-8px, -5px);\n}\n.vc-ps-hue-pointer--left {\n  transform: translate(-13px, -4px);\n}\n.vc-ps-hue-pointer--right {\n  transform: translate(20px, -4px) rotate(180deg);\n}\n.vc-ps-controls {\n  width: 180px;\n  margin-left: 10px;\n  display: flex;\n}\n.vc-ps-controls__disable-fields {\n  width: auto;\n}\n.vc-ps-actions {\n  margin-left: 20px;\n  flex: 1;\n}\n.vc-ps-ac-btn {\n  cursor: pointer;\n  background-image: linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%);\n  border: 1px solid #878787;\n  border-radius: 2px;\n  height: 20px;\n  box-shadow: 0 1px 0 0 #EAEAEA;\n  font-size: 14px;\n  color: #000;\n  line-height: 20px;\n  text-align: center;\n  margin-bottom: 10px;\n}\n.vc-ps-previews {\n  width: 60px;\n}\n.vc-ps-previews__swatches {\n  border: 1px solid #B3B3B3;\n  border-bottom: 1px solid #F0F0F0;\n  margin-bottom: 2px;\n  margin-top: 1px;\n}\n.vc-ps-previews__pr-color {\n  height: 34px;\n  box-shadow: inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000;\n}\n.vc-ps-previews__label {\n  font-size: 14px;\n  color: #000;\n  text-align: center;\n}\n.vc-ps-fields {\n  padding-top: 5px;\n  padding-bottom: 9px;\n  width: 80px;\n  position: relative;\n}\n.vc-ps-fields .vc-input__input {\n  margin-left: 40%;\n  width: 40%;\n  height: 18px;\n  border: 1px solid #888888;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC;\n  margin-bottom: 5px;\n  font-size: 13px;\n  padding-left: 3px;\n  margin-right: 10px;\n}\n.vc-ps-fields .vc-input__label, .vc-ps-fields .vc-input__desc {\n  top: 0;\n  text-transform: uppercase;\n  font-size: 13px;\n  height: 18px;\n  line-height: 22px;\n  position: absolute;\n}\n.vc-ps-fields .vc-input__label {\n  left: 0;\n  width: 34px;\n}\n.vc-ps-fields .vc-input__desc {\n  right: 0;\n  width: 0;\n}\n.vc-ps-fields__divider {\n  height: 5px;\n}\n.vc-ps-fields__hex .vc-input__input {\n  margin-left: 20%;\n  width: 80%;\n  height: 18px;\n  border: 1px solid #888888;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC;\n  margin-bottom: 6px;\n  font-size: 13px;\n  padding-left: 3px;\n}\n.vc-ps-fields__hex .vc-input__label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 14px;\n  text-transform: uppercase;\n  font-size: 13px;\n  height: 18px;\n  line-height: 22px;\n}\n', ""]);
  }, function (e, t, n) {
    var r = n(124);"string" == typeof r && (r = [[e.i, r, ""]]), r.locals && (e.exports = r.locals);n(1)("b5380e52", r, !1, {});
  }, function (e, t, n) {
    t = e.exports = n(0)(!1), t.push([e.i, "\n.vc-saturation,\n.vc-saturation--white,\n.vc-saturation--black {\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.vc-saturation--white {\n  background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n}\n.vc-saturation--black {\n  background: linear-gradient(to top, #000, rgba(0,0,0,0));\n}\n.vc-saturation-pointer {\n  cursor: pointer;\n  position: absolute;\n}\n.vc-saturation-circle {\n  cursor: head;\n  width: 4px;\n  height: 4px;\n  box-shadow: 0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3), 0 0 1px 2px rgba(0,0,0,.4);\n  border-radius: 50%;\n  transform: translate(-2px, -2px);\n}\n", ""]);
  }, function (e, t) {
    function n(e, t, n) {
      return t < n ? e < t ? t : e > n ? n : e : e < n ? n : e > t ? t : e;
    }e.exports = n;
  }, function (e, t) {
    function n(e, t, n) {
      function r(t) {
        var n = v,
            r = g;return v = g = void 0, k = t, x = e.apply(r, n);
      }function o(e) {
        return k = e, m = setTimeout(u, t), F ? r(e) : x;
      }function a(e) {
        var n = e - _,
            r = e - k,
            i = t - n;return S ? y(i, b - r) : i;
      }function l(e) {
        var n = e - _,
            r = e - k;return void 0 === _ || n >= t || n < 0 || S && r >= b;
      }function u() {
        var e = C();if (l(e)) return f(e);m = setTimeout(u, a(e));
      }function f(e) {
        return m = void 0, A && v ? r(e) : (v = g = void 0, x);
      }function d() {
        void 0 !== m && clearTimeout(m), k = 0, v = _ = g = m = void 0;
      }function h() {
        return void 0 === m ? x : f(C());
      }function p() {
        var e = C(),
            n = l(e);if (v = arguments, g = this, _ = e, n) {
          if (void 0 === m) return o(_);if (S) return m = setTimeout(u, t), r(_);
        }return void 0 === m && (m = setTimeout(u, t)), x;
      }var v,
          g,
          b,
          x,
          m,
          _,
          k = 0,
          F = !1,
          S = !1,
          A = !0;if ("function" != typeof e) throw new TypeError(c);return t = s(t) || 0, i(n) && (F = !!n.leading, S = "maxWait" in n, b = S ? w(s(n.maxWait) || 0, t) : b, A = "trailing" in n ? !!n.trailing : A), p.cancel = d, p.flush = h, p;
    }function r(e, t, r) {
      var o = !0,
          a = !0;if ("function" != typeof e) throw new TypeError(c);return i(r) && (o = "leading" in r ? !!r.leading : o, a = "trailing" in r ? !!r.trailing : a), n(e, t, { leading: o, maxWait: t, trailing: a });
    }function i(e) {
      var t = typeof e === "undefined" ? "undefined" : _typeof(e);return !!e && ("object" == t || "function" == t);
    }function o(e) {
      return !!e && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e));
    }function a(e) {
      return "symbol" == (typeof e === "undefined" ? "undefined" : _typeof(e)) || o(e) && _.call(e) == u;
    }function s(e) {
      if ("number" == typeof e) return e;if (a(e)) return l;if (i(e)) {
        var t = "function" == typeof e.valueOf ? e.valueOf() : e;e = i(t) ? t + "" : t;
      }if ("string" != typeof e) return 0 === e ? e : +e;e = e.replace(f, "");var n = h.test(e);return n || p.test(e) ? v(e.slice(2), n ? 2 : 8) : d.test(e) ? l : +e;
    }var c = "Expected a function",
        l = NaN,
        u = "[object Symbol]",
        f = /^\s+|\s+$/g,
        d = /^[-+]0x[0-9a-f]+$/i,
        h = /^0b[01]+$/i,
        p = /^0o[0-7]+$/i,
        v = parseInt,
        g = "object" == (typeof global === "undefined" ? "undefined" : _typeof(global)) && global && global.Object === Object && global,
        b = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
        x = g || b || Function("return this")(),
        m = Object.prototype,
        _ = m.toString,
        w = Math.max,
        y = Math.min,
        C = function C() {
      return x.Date.now();
    };e.exports = r;
  }, function (e, t, n) {
    "use strict";
    var r = function r() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { ref: "container", staticClass: "vc-saturation", style: { background: e.bgColor }, on: { mousedown: e.handleMouseDown, touchmove: e.handleChange, touchstart: e.handleChange } }, [n("div", { staticClass: "vc-saturation--white" }), e._v(" "), n("div", { staticClass: "vc-saturation--black" }), e._v(" "), n("div", { staticClass: "vc-saturation-pointer", style: { top: e.pointerTop, left: e.pointerLeft } }, [n("div", { staticClass: "vc-saturation-circle" })])]);
    },
        i = [];r._withStripped = !0;var o = { render: r, staticRenderFns: i };t.a = o;
  }, function (e, t, n) {
    var r = n(129);"string" == typeof r && (r = [[e.i, r, ""]]), r.locals && (e.exports = r.locals);n(1)("4dc1b086", r, !1, {});
  }, function (e, t, n) {
    t = e.exports = n(0)(!1), t.push([e.i, "\n.vc-alpha {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n}\n.vc-alpha-checkboard-wrap {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  overflow: hidden;\n}\n.vc-alpha-gradient {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n}\n.vc-alpha-container {\n  cursor: pointer;\n  position: relative;\n  z-index: 2;\n  height: 100%;\n  margin: 0 3px;\n}\n.vc-alpha-pointer {\n  z-index: 2;\n  position: absolute;\n}\n.vc-alpha-picker {\n  cursor: pointer;\n  width: 4px;\n  border-radius: 1px;\n  height: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .6);\n  background: #fff;\n  margin-top: 1px;\n  transform: translateX(-2px);\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(131);"string" == typeof r && (r = [[e.i, r, ""]]), r.locals && (e.exports = r.locals);n(1)("7e15c05b", r, !1, {});
  }, function (e, t, n) {
    t = e.exports = n(0)(!1), t.push([e.i, "\n.vc-checkerboard {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  background-size: contain;\n}\n", ""]);
  }, function (e, t, n) {
    "use strict";
    var r = function r() {
      var e = this,
          t = e.$createElement;return (e._self._c || t)("div", { staticClass: "vc-checkerboard", style: e.bgStyle });
    },
        i = [];r._withStripped = !0;var o = { render: r, staticRenderFns: i };t.a = o;
  }, function (e, t, n) {
    "use strict";
    var r = function r() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { staticClass: "vc-alpha" }, [n("div", { staticClass: "vc-alpha-checkboard-wrap" }, [n("checkboard")], 1), e._v(" "), n("div", { staticClass: "vc-alpha-gradient", style: { background: e.gradientColor } }), e._v(" "), n("div", { ref: "container", staticClass: "vc-alpha-container", on: { mousedown: e.handleMouseDown, touchmove: e.handleChange, touchstart: e.handleChange } }, [n("div", { staticClass: "vc-alpha-pointer", style: { left: 100 * e.colors.a + "%" } }, [n("div", { staticClass: "vc-alpha-picker" })])])]);
    },
        i = [];r._withStripped = !0;var o = { render: r, staticRenderFns: i };t.a = o;
  }, function (e, t, n) {
    "use strict";
    var r = function r() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { class: ["vc-photoshop", e.disableFields ? "vc-photoshop__disable-fields" : ""], attrs: { role: "application", "aria-label": "PhotoShop color picker" } }, [n("div", { staticClass: "vc-ps-head", attrs: { role: "heading" } }, [e._v(e._s(e.head))]), e._v(" "), n("div", { staticClass: "vc-ps-body" }, [n("div", { staticClass: "vc-ps-saturation-wrap" }, [n("saturation", { on: { change: e.childChange }, model: { value: e.colors, callback: function callback(t) {
            e.colors = t;
          }, expression: "colors" } })], 1), e._v(" "), n("div", { staticClass: "vc-ps-hue-wrap" }, [n("hue", { attrs: { direction: "vertical" }, on: { change: e.childChange }, model: { value: e.colors, callback: function callback(t) {
            e.colors = t;
          }, expression: "colors" } }, [n("div", { staticClass: "vc-ps-hue-pointer" }, [n("i", { staticClass: "vc-ps-hue-pointer--left" }), n("i", { staticClass: "vc-ps-hue-pointer--right" })])])], 1), e._v(" "), n("div", { class: ["vc-ps-controls", e.disableFields ? "vc-ps-controls__disable-fields" : ""] }, [n("div", { staticClass: "vc-ps-previews" }, [n("div", { staticClass: "vc-ps-previews__label" }, [e._v(e._s(e.newLabel))]), e._v(" "), n("div", { staticClass: "vc-ps-previews__swatches" }, [n("div", { staticClass: "vc-ps-previews__pr-color", style: { background: e.colors.hex }, attrs: { "aria-label": "New color is " + e.colors.hex } }), e._v(" "), n("div", { staticClass: "vc-ps-previews__pr-color", style: { background: e.currentColor }, attrs: { "aria-label": "Current color is " + e.currentColor }, on: { click: e.clickCurrentColor } })]), e._v(" "), n("div", { staticClass: "vc-ps-previews__label" }, [e._v(e._s(e.currentLabel))])]), e._v(" "), e.disableFields ? e._e() : n("div", { staticClass: "vc-ps-actions" }, [n("div", { staticClass: "vc-ps-ac-btn", attrs: { role: "button", "aria-label": e.acceptLabel }, on: { click: e.handleAccept } }, [e._v(e._s(e.acceptLabel))]), e._v(" "), n("div", { staticClass: "vc-ps-ac-btn", attrs: { role: "button", "aria-label": e.cancelLabel }, on: { click: e.handleCancel } }, [e._v(e._s(e.cancelLabel))]), e._v(" "), n("div", { staticClass: "vc-ps-fields" }, [n("ed-in", { attrs: { label: "h", desc: "°", value: e.hsv.h }, on: { change: e.inputChange } }), e._v(" "), n("ed-in", { attrs: { label: "s", desc: "%", value: e.hsv.s, max: 100 }, on: { change: e.inputChange } }), e._v(" "), n("ed-in", { attrs: { label: "v", desc: "%", value: e.hsv.v, max: 100 }, on: { change: e.inputChange } }), e._v(" "), n("div", { staticClass: "vc-ps-fields__divider" }), e._v(" "), n("ed-in", { attrs: { label: "r", value: e.colors.rgba.r }, on: { change: e.inputChange } }), e._v(" "), n("ed-in", { attrs: { label: "g", value: e.colors.rgba.g }, on: { change: e.inputChange } }), e._v(" "), n("ed-in", { attrs: { label: "b", value: e.colors.rgba.b }, on: { change: e.inputChange } }), e._v(" "), n("div", { staticClass: "vc-ps-fields__divider" }), e._v(" "), n("ed-in", { staticClass: "vc-ps-fields__hex", attrs: { label: "#", value: e.hex }, on: { change: e.inputChange } })], 1), e._v(" "), e.hasResetButton ? n("div", { staticClass: "vc-ps-ac-btn", attrs: { "aria-label": "reset" }, on: { click: e.handleReset } }, [e._v(e._s(e.resetLabel))]) : e._e()])])])]);
    },
        i = [];r._withStripped = !0;var o = { render: r, staticRenderFns: i };t.a = o;
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      c || n(136);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(57),
        o = n.n(i);for (var a in i) {
      "default" !== a && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(a);
    }var s = n(138),
        c = !1,
        l = n(2),
        u = r,
        f = l(o.a, s.a, !1, u, null, null);f.options.__file = "src/components/Sketch.vue", t.default = f.exports;
  }, function (e, t, n) {
    var r = n(137);"string" == typeof r && (r = [[e.i, r, ""]]), r.locals && (e.exports = r.locals);n(1)("612c6604", r, !1, {});
  }, function (e, t, n) {
    t = e.exports = n(0)(!1), t.push([e.i, "\n.vc-sketch {\n  position: relative;\n  width: 200px;\n  padding: 10px 10px 0;\n  box-sizing: initial;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, .15), 0 8px 16px rgba(0, 0, 0, .15);\n}\n.vc-sketch-saturation-wrap {\n  width: 100%;\n  padding-bottom: 75%;\n  position: relative;\n  overflow: hidden;\n}\n.vc-sketch-controls {\n  display: flex;\n}\n.vc-sketch-sliders {\n  padding: 4px 0;\n  flex: 1;\n}\n.vc-sketch-sliders .vc-hue,\n.vc-sketch-sliders .vc-alpha-gradient {\n  border-radius: 2px;\n}\n.vc-sketch-hue-wrap {\n  position: relative;\n  height: 10px;\n}\n.vc-sketch-alpha-wrap {\n  position: relative;\n  height: 10px;\n  margin-top: 4px;\n  overflow: hidden;\n}\n.vc-sketch-color-wrap {\n  width: 24px;\n  height: 24px;\n  position: relative;\n  margin-top: 4px;\n  margin-left: 4px;\n  border-radius: 3px;\n}\n.vc-sketch-active-color {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 2px;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15), inset 0 0 4px rgba(0, 0, 0, .25);\n  z-index: 2;\n}\n.vc-sketch-color-wrap .vc-checkerboard {\n  background-size: auto;\n}\n.vc-sketch-field {\n  display: flex;\n  padding-top: 4px;\n}\n.vc-sketch-field .vc-input__input {\n  width: 90%;\n  padding: 4px 0 3px 10%;\n  border: none;\n  box-shadow: inset 0 0 0 1px #ccc;\n  font-size: 10px;\n}\n.vc-sketch-field .vc-input__label {\n  display: block;\n  text-align: center;\n  font-size: 11px;\n  color: #222;\n  padding-top: 3px;\n  padding-bottom: 4px;\n  text-transform: capitalize;\n}\n.vc-sketch-field--single {\n  flex: 1;\n  padding-left: 6px;\n}\n.vc-sketch-field--double {\n  flex: 2;\n}\n.vc-sketch-presets {\n  margin-right: -10px;\n  margin-left: -10px;\n  padding-left: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #eee;\n}\n.vc-sketch-presets-color {\n  border-radius: 3px;\n  overflow: hidden;\n  position: relative;\n  display: inline-block;\n  margin: 0 10px 10px 0;\n  vertical-align: top;\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15);\n}\n.vc-sketch-presets-color .vc-checkerboard {\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15);\n  border-radius: 3px;\n}\n.vc-sketch__disable-alpha .vc-sketch-color-wrap {\n  height: 10px;\n}\n", ""]);
  }, function (e, t, n) {
    "use strict";
    var r = function r() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { class: ["vc-sketch", e.disableAlpha ? "vc-sketch__disable-alpha" : ""], attrs: { role: "application", "aria-label": "Sketch color picker" } }, [n("div", { staticClass: "vc-sketch-saturation-wrap" }, [n("saturation", { on: { change: e.childChange }, model: { value: e.colors, callback: function callback(t) {
            e.colors = t;
          }, expression: "colors" } })], 1), e._v(" "), n("div", { staticClass: "vc-sketch-controls" }, [n("div", { staticClass: "vc-sketch-sliders" }, [n("div", { staticClass: "vc-sketch-hue-wrap" }, [n("hue", { on: { change: e.childChange }, model: { value: e.colors, callback: function callback(t) {
            e.colors = t;
          }, expression: "colors" } })], 1), e._v(" "), e.disableAlpha ? e._e() : n("div", { staticClass: "vc-sketch-alpha-wrap" }, [n("alpha", { on: { change: e.childChange }, model: { value: e.colors, callback: function callback(t) {
            e.colors = t;
          }, expression: "colors" } })], 1)]), e._v(" "), n("div", { staticClass: "vc-sketch-color-wrap" }, [n("div", { staticClass: "vc-sketch-active-color", style: { background: e.activeColor }, attrs: { "aria-label": "Current color is " + e.activeColor } }), e._v(" "), n("checkboard")], 1)]), e._v(" "), e.disableFields ? e._e() : n("div", { staticClass: "vc-sketch-field" }, [n("div", { staticClass: "vc-sketch-field--double" }, [n("ed-in", { attrs: { label: "hex", value: e.hex }, on: { change: e.inputChange } })], 1), e._v(" "), n("div", { staticClass: "vc-sketch-field--single" }, [n("ed-in", { attrs: { label: "r", value: e.colors.rgba.r }, on: { change: e.inputChange } })], 1), e._v(" "), n("div", { staticClass: "vc-sketch-field--single" }, [n("ed-in", { attrs: { label: "g", value: e.colors.rgba.g }, on: { change: e.inputChange } })], 1), e._v(" "), n("div", { staticClass: "vc-sketch-field--single" }, [n("ed-in", { attrs: { label: "b", value: e.colors.rgba.b }, on: { change: e.inputChange } })], 1), e._v(" "), e.disableAlpha ? e._e() : n("div", { staticClass: "vc-sketch-field--single" }, [n("ed-in", { attrs: { label: "a", value: e.colors.a, "arrow-offset": .01, max: 1 }, on: { change: e.inputChange } })], 1)]), e._v(" "), n("div", { staticClass: "vc-sketch-presets", attrs: { role: "group", "aria-label": "A color preset, pick one to set as current color" } }, [e._l(e.presetColors, function (t) {
        return [e.isTransparent(t) ? n("div", { key: t, staticClass: "vc-sketch-presets-color", attrs: { "aria-label": "Color:" + t }, on: { click: function click(n) {
              return e.handlePreset(t);
            } } }, [n("checkboard")], 1) : n("div", { key: t, staticClass: "vc-sketch-presets-color", style: { background: t }, attrs: { "aria-label": "Color:" + t }, on: { click: function click(n) {
              return e.handlePreset(t);
            } } })];
      })], 2)]);
    },
        i = [];r._withStripped = !0;var o = { render: r, staticRenderFns: i };t.a = o;
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      c || n(140);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(58),
        o = n.n(i);for (var a in i) {
      "default" !== a && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(a);
    }var s = n(142),
        c = !1,
        l = n(2),
        u = r,
        f = l(o.a, s.a, !1, u, null, null);f.options.__file = "src/components/Chrome.vue", t.default = f.exports;
  }, function (e, t, n) {
    var r = n(141);"string" == typeof r && (r = [[e.i, r, ""]]), r.locals && (e.exports = r.locals);n(1)("1cd16048", r, !1, {});
  }, function (e, t, n) {
    t = e.exports = n(0)(!1), t.push([e.i, "\n.vc-chrome {\n  background: #fff;\n  border-radius: 2px;\n  box-shadow: 0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3);\n  box-sizing: initial;\n  width: 225px;\n  font-family: Menlo;\n  background-color: #fff;\n}\n.vc-chrome-controls {\n  display: flex;\n}\n.vc-chrome-color-wrap {\n  position: relative;\n  width: 36px;\n}\n.vc-chrome-active-color {\n  position: relative;\n  width: 30px;\n  height: 30px;\n  border-radius: 15px;\n  overflow: hidden;\n  z-index: 1;\n}\n.vc-chrome-color-wrap .vc-checkerboard {\n  width: 30px;\n  height: 30px;\n  border-radius: 15px;\n  background-size: auto;\n}\n.vc-chrome-sliders {\n  flex: 1;\n}\n.vc-chrome-fields-wrap {\n  display: flex;\n  padding-top: 16px;\n}\n.vc-chrome-fields {\n  display: flex;\n  margin-left: -6px;\n  flex: 1;\n}\n.vc-chrome-field {\n  padding-left: 6px;\n  width: 100%;\n}\n.vc-chrome-toggle-btn {\n  width: 32px;\n  text-align: right;\n  position: relative;\n}\n.vc-chrome-toggle-icon {\n  margin-right: -4px;\n  margin-top: 12px;\n  cursor: pointer;\n  position: relative;\n  z-index: 2;\n}\n.vc-chrome-toggle-icon-highlight {\n  position: absolute;\n  width: 24px;\n  height: 28px;\n  background: #eee;\n  border-radius: 4px;\n  top: 10px;\n  left: 12px;\n}\n.vc-chrome-hue-wrap {\n  position: relative;\n  height: 10px;\n  margin-bottom: 8px;\n}\n.vc-chrome-alpha-wrap {\n  position: relative;\n  height: 10px;\n}\n.vc-chrome-hue-wrap .vc-hue {\n  border-radius: 2px;\n}\n.vc-chrome-alpha-wrap .vc-alpha-gradient {\n  border-radius: 2px;\n}\n.vc-chrome-hue-wrap .vc-hue-picker, .vc-chrome-alpha-wrap .vc-alpha-picker {\n  width: 12px;\n  height: 12px;\n  border-radius: 6px;\n  transform: translate(-6px, -2px);\n  background-color: rgb(248, 248, 248);\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n}\n.vc-chrome-body {\n  padding: 16px 16px 12px;\n  background-color: #fff;\n}\n.vc-chrome-saturation-wrap {\n  width: 100%;\n  padding-bottom: 55%;\n  position: relative;\n  border-radius: 2px 2px 0 0;\n  overflow: hidden;\n}\n.vc-chrome-saturation-wrap .vc-saturation-circle {\n  width: 12px;\n  height: 12px;\n}\n.vc-chrome-fields .vc-input__input {\n  font-size: 11px;\n  color: #333;\n  width: 100%;\n  border-radius: 2px;\n  border: none;\n  box-shadow: inset 0 0 0 1px #dadada;\n  height: 21px;\n  text-align: center;\n}\n.vc-chrome-fields .vc-input__label {\n  text-transform: uppercase;\n  font-size: 11px;\n  line-height: 11px;\n  color: #969696;\n  text-align: center;\n  display: block;\n  margin-top: 12px;\n}\n.vc-chrome__disable-alpha .vc-chrome-active-color {\n  width: 18px;\n  height: 18px;\n}\n.vc-chrome__disable-alpha .vc-chrome-color-wrap {\n  width: 30px;\n}\n.vc-chrome__disable-alpha .vc-chrome-hue-wrap {\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n", ""]);
  }, function (e, t, n) {
    "use strict";
    var r = function r() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { class: ["vc-chrome", e.disableAlpha ? "vc-chrome__disable-alpha" : ""], attrs: { role: "application", "aria-label": "Chrome color picker" } }, [n("div", { staticClass: "vc-chrome-saturation-wrap" }, [n("saturation", { on: { change: e.childChange }, model: { value: e.colors, callback: function callback(t) {
            e.colors = t;
          }, expression: "colors" } })], 1), e._v(" "), n("div", { staticClass: "vc-chrome-body" }, [n("div", { staticClass: "vc-chrome-controls" }, [n("div", { staticClass: "vc-chrome-color-wrap" }, [n("div", { staticClass: "vc-chrome-active-color", style: { background: e.activeColor }, attrs: { "aria-label": "current color is " + e.colors.hex } }), e._v(" "), e.disableAlpha ? e._e() : n("checkboard")], 1), e._v(" "), n("div", { staticClass: "vc-chrome-sliders" }, [n("div", { staticClass: "vc-chrome-hue-wrap" }, [n("hue", { on: { change: e.childChange }, model: { value: e.colors, callback: function callback(t) {
            e.colors = t;
          }, expression: "colors" } })], 1), e._v(" "), e.disableAlpha ? e._e() : n("div", { staticClass: "vc-chrome-alpha-wrap" }, [n("alpha", { on: { change: e.childChange }, model: { value: e.colors, callback: function callback(t) {
            e.colors = t;
          }, expression: "colors" } })], 1)])]), e._v(" "), e.disableFields ? e._e() : n("div", { staticClass: "vc-chrome-fields-wrap" }, [n("div", { directives: [{ name: "show", rawName: "v-show", value: 0 === e.fieldsIndex, expression: "fieldsIndex === 0" }], staticClass: "vc-chrome-fields" }, [n("div", { staticClass: "vc-chrome-field" }, [e.hasAlpha ? e._e() : n("ed-in", { attrs: { label: "hex", value: e.colors.hex }, on: { change: e.inputChange } }), e._v(" "), e.hasAlpha ? n("ed-in", { attrs: { label: "hex", value: e.colors.hex8 }, on: { change: e.inputChange } }) : e._e()], 1)]), e._v(" "), n("div", { directives: [{ name: "show", rawName: "v-show", value: 1 === e.fieldsIndex, expression: "fieldsIndex === 1" }], staticClass: "vc-chrome-fields" }, [n("div", { staticClass: "vc-chrome-field" }, [n("ed-in", { attrs: { label: "r", value: e.colors.rgba.r }, on: { change: e.inputChange } })], 1), e._v(" "), n("div", { staticClass: "vc-chrome-field" }, [n("ed-in", { attrs: { label: "g", value: e.colors.rgba.g }, on: { change: e.inputChange } })], 1), e._v(" "), n("div", { staticClass: "vc-chrome-field" }, [n("ed-in", { attrs: { label: "b", value: e.colors.rgba.b }, on: { change: e.inputChange } })], 1), e._v(" "), e.disableAlpha ? e._e() : n("div", { staticClass: "vc-chrome-field" }, [n("ed-in", { attrs: { label: "a", value: e.colors.a, "arrow-offset": .01, max: 1 }, on: { change: e.inputChange } })], 1)]), e._v(" "), n("div", { directives: [{ name: "show", rawName: "v-show", value: 2 === e.fieldsIndex, expression: "fieldsIndex === 2" }], staticClass: "vc-chrome-fields" }, [n("div", { staticClass: "vc-chrome-field" }, [n("ed-in", { attrs: { label: "h", value: e.hsl.h }, on: { change: e.inputChange } })], 1), e._v(" "), n("div", { staticClass: "vc-chrome-field" }, [n("ed-in", { attrs: { label: "s", value: e.hsl.s }, on: { change: e.inputChange } })], 1), e._v(" "), n("div", { staticClass: "vc-chrome-field" }, [n("ed-in", { attrs: { label: "l", value: e.hsl.l }, on: { change: e.inputChange } })], 1), e._v(" "), e.disableAlpha ? e._e() : n("div", { staticClass: "vc-chrome-field" }, [n("ed-in", { attrs: { label: "a", value: e.colors.a, "arrow-offset": .01, max: 1 }, on: { change: e.inputChange } })], 1)]), e._v(" "), n("div", { staticClass: "vc-chrome-toggle-btn", attrs: { role: "button", "aria-label": "Change another color definition" }, on: { click: e.toggleViews } }, [n("div", { staticClass: "vc-chrome-toggle-icon" }, [n("svg", { staticStyle: { width: "24px", height: "24px" }, attrs: { viewBox: "0 0 24 24" }, on: { mouseover: e.showHighlight, mouseenter: e.showHighlight, mouseout: e.hideHighlight } }, [n("path", { attrs: { fill: "#333", d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z" } })])]), e._v(" "), n("div", { directives: [{ name: "show", rawName: "v-show", value: e.highlight, expression: "highlight" }], staticClass: "vc-chrome-toggle-icon-highlight" })])])])]);
    },
        i = [];r._withStripped = !0;var o = { render: r, staticRenderFns: i };t.a = o;
  }, function (e, t, n) {
    "use strict";
    function r(e) {
      c || n(144);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(59),
        o = n.n(i);for (var a in i) {
      "default" !== a && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(a);
    }var s = n(146),
        c = !1,
        l = n(2),
        u = r,
        f = l(o.a, s.a, !1, u, null, null);f.options.__file = "src/components/Twitter.vue", t.default = f.exports;
  }, function (e, t, n) {
    var r = n(145);"string" == typeof r && (r = [[e.i, r, ""]]), r.locals && (e.exports = r.locals);n(1)("669a48a5", r, !1, {});
  }, function (e, t, n) {
    t = e.exports = n(0)(!1), t.push([e.i, "\n.vc-twitter {\n  background: #fff;\n  border: 0 solid rgba(0,0,0,0.25);\n  box-shadow: 0 1px 4px rgba(0,0,0,0.25);\n  border-radius: 4px;\n  position: relative;\n}\n.vc-twitter-triangle {\n  width: 0px;\n  height: 0px;\n  border-style: solid;\n  border-width: 0 9px 10px 9px;\n  border-color: transparent transparent #fff transparent;\n  position: absolute;\n}\n.vc-twitter-triangle-shadow {\n  width: 0px;\n  height: 0px;\n  border-style: solid;\n  border-width: 0 9px 10px 9px;\n  border-color: transparent transparent rgba(0, 0, 0, .1) transparent;\n  position: absolute;\n}\n.vc-twitter-body {\n  padding: 15px 9px 9px 15px;\n}\n.vc-twitter .vc-editable-input {\n  position: relative;\n}\n.vc-twitter .vc-editable-input input {\n  width: 100px;\n  font-size: 14px;\n  color: #666;\n  border: 0px;\n  outline: none;\n  height: 28px;\n  box-shadow: inset 0 0 0 1px #F0F0F0;\n  box-sizing: content-box;\n  border-radius: 0 4px 4px 0;\n  float: left;\n  padding: 1px;\n  padding-left: 8px;\n}\n.vc-twitter .vc-editable-input span {\n  display: none;\n}\n.vc-twitter-hash {\n  background: #F0F0F0;\n  height: 30px;\n  width: 30px;\n  border-radius: 4px 0 0 4px;\n  float: left;\n  color: #98A1A4;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.vc-twitter-swatch {\n  width: 30px;\n  height: 30px;\n  float: left;\n  border-radius: 4px;\n  margin: 0 6px 6px 0;\n  cursor: pointer;\n  position: relative;\n  outline: none;\n}\n.vc-twitter-clear {\n  clear: both;\n}\n.vc-twitter-hide-triangle .vc-twitter-triangle {\n  display: none;\n}\n.vc-twitter-hide-triangle .vc-twitter-triangle-shadow {\n  display: none;\n}\n.vc-twitter-top-left-triangle .vc-twitter-triangle{\n  top: -10px;\n  left: 12px;\n}\n.vc-twitter-top-left-triangle .vc-twitter-triangle-shadow{\n  top: -11px;\n  left: 12px;\n}\n.vc-twitter-top-right-triangle .vc-twitter-triangle{\n  top: -10px;\n  right: 12px;\n}\n.vc-twitter-top-right-triangle .vc-twitter-triangle-shadow{\n  top: -11px;\n  right: 12px;\n}\n", ""]);
  }, function (e, t, n) {
    "use strict";
    var r = function r() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { staticClass: "vc-twitter", class: { "vc-twitter-hide-triangle ": "hide" === e.triangle, "vc-twitter-top-left-triangle ": "top-left" === e.triangle, "vc-twitter-top-right-triangle ": "top-right" === e.triangle }, style: { width: "number" == typeof e.width ? e.width + "px" : e.width } }, [n("div", { staticClass: "vc-twitter-triangle-shadow" }), e._v(" "), n("div", { staticClass: "vc-twitter-triangle" }), e._v(" "), n("div", { staticClass: "vc-twitter-body" }, [e._l(e.defaultColors, function (t, r) {
        return n("span", { key: r, staticClass: "vc-twitter-swatch", style: { background: t, boxShadow: "0 0 4px " + (e.equal(t) ? t : "transparent") }, on: { click: function click(n) {
              return e.handlerClick(t);
            } } });
      }), e._v(" "), n("div", { staticClass: "vc-twitter-hash" }, [e._v("#")]), e._v(" "), n("editable-input", { attrs: { label: "#", value: e.hex }, on: { change: e.inputChange } }), e._v(" "), n("div", { staticClass: "vc-twitter-clear" })], 2)]);
    },
        i = [];r._withStripped = !0;var o = { render: r, staticRenderFns: i };t.a = o;
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39), __webpack_require__(45)(module)))

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_md_message_vue__ = __webpack_require__(398);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f0a04a4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_md_message_vue__ = __webpack_require__(1094);
function injectStyle (ssrContext) {
  __webpack_require__(1089)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_md_message_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f0a04a4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_md_message_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_field_vue__ = __webpack_require__(117);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { formField: __WEBPACK_IMPORTED_MODULE_1__form_field_vue__["default"] },
  props: {
    code: { type: String, required: false },
    kind: { type: String, required: false },
    message: { type: String, required: false },
    title: { type: String, required: false },
    help: { type: String, required: false },
    visible: { type: Boolean, required: false },
    adminPass: { type: Boolean, required: false }
  },
  data: function data() {
    return {
      vTitle: '',
      vMessage: '',
      vHelp: '',
      vClass: '',
      btnConfirmText: 'Confirmar',
      btnCancelText: 'Fechar',
      btnClass: 'nb-btdef',
      btnConfirm: true,
      btnCancel: true,
      metamessage: this.$store.getters.getEntities.messages,
      msg: {},
      senha: ''
    };
  },
  created: function created() {
    if (this.code) {
      if (this.code == 'closeform') {
        this.btnConfirmText = 'Sim';
        this.btnCancelText = 'Não';
        this.vTitle = 'Atenção';
        this.vMessage = 'Deseja realmente sair desta tela????';
        jQuery(this.$refs.btnConfirm).focus();
      } else if (this.metamessage[this.code]) {
        this.msg = this.metamessage[this.code];
        this.vTitle = this.msg.title;
        this.vMessage = this.msg.text;
        this.vHelp = this.msg.help;
      } else {
        this.vTitle = 'Mensagem não encontrada no metadata: ' + this.code;
      }
    } else {
      this.vTitle = this.title;
      this.vMessage = this.message;
      if (this.help) {
        this.vHelp = this.help;
      }
    }
    if (this.kind) {
      if (this.kind == 'delete') {
        this.btnClass = 'btn-danger';
        jQuery(this.$refs.btnClose).focus();
      } else if (this.kind == 'cancel') {
        this.btnClass = 'btn-danger';
        jQuery(this.$refs.btnClose).focus();
      } else if (this.kind == 'error') {
        this.btnClass = 'btn-danger';
        this.btnConfirm = false;
        this.btnCancelText = 'OK';
        jQuery(this.$refs.btnClose).focus();
      } else if (this.kind == 'warning') {
        this.btnClass = 'btn-warning';
        this.btnConfirm = false;
        this.btnCancelText = 'OK';
        jQuery(this.$refs.btnClose).focus();
      }
    }
    console.log(this.kind);
    console.log(this.title);

    this.$nextTick(function () {
      this.$refs.senha.focus();
      window.addEventListener('keyup', this.handleKeyupEvent);
    });
  },
  mounted: function mounted() {},

  methods: {
    handleKeyupEvent: function handleKeyupEvent(event) {
      var self = this;
      if (event.keyCode === 13 && this.senha) {
        // Fecha a modal ao pressionar ENTER
        self.handleConfirmButton();
      }

      if (event.keyCode == 27) {
        // Aciona o método ao pressionar ESC
        self.handleCloseButton();
      }
    },
    handleCloseButton: function handleCloseButton() {

      this.visible = false;
      this.$emit('close');
      window.removeEventListener('keyup', this.handleKeyupEvent);
    },
    handleConfirmButton: function handleConfirmButton() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var obj, modulo, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.adminPass) {
                  _context.next = 13;
                  break;
                }

                if (!(!_this.senha || _this.senha == '')) {
                  _context.next = 4;
                  break;
                }

                _this.$erpToastError('Senha obrigatoria');
                return _context.abrupt('return');

              case 4:
                obj = {};

                obj.senha = _this.senha;

                modulo = 'cg/valida/adminpass/';
                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this.$store, modulo, obj, 'post');

              case 9:
                data = _context.sent;

                if (data.resultado) {
                  _context.next = 13;
                  break;
                }

                _this.$erpToastError('Senha invalida');
                return _context.abrupt('return');

              case 13:
                _this.visible = false;
                _this.$emit('confirm');

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'form-field',

  props: {
    metadata: { type: Object },
    precision: { type: Number },
    addButton: { type: Boolean },
    disabled: { type: Boolean, default: false },
    type: { type: String, default: 'text' },
    label: { type: String },
    col: { type: String },
    selectOptions: { type: Array },
    selectMultiple: { type: Boolean },
    select2: { type: Object },
    value: {},
    vErrors: {},
    name: { type: String },
    tabindex: { type: Number },
    parent: { type: String },
    case: { type: String },
    addon: { type: String },
    preaddon: { type: String },
    nolabel: { type: Boolean },
    placeholder: { type: String },
    optionnull: { type: Boolean },
    showDuplicados: { type: Object },
    maxlength: { type: String },
    cardMonth: { type: String },
    cardYear: { type: String },
    validateDisabledKeys: { type: Boolean, default: true },
    hiddeLoginInformations: { type: Boolean, default: false }
  },

  data: function data() {
    return {
      passwordFieldType: 'password',
      listDuplicados: [],
      showSearching: false,
      iconDuplicado: false,
      cardNumber: "",
      cardCvv: "",
      minCardYear: new Date().getFullYear(),
      amexCardMask: "#### ###### #####",
      otherCardMask: "#### #### #### ####",
      disabledKeys: "\\"
    };
  },


  methods: {
    keymonitor: function keymonitor(event) {
      if (this.validateDisabledKeys) if (this.disabledKeys.indexOf(event.key) >= 0) event.preventDefault();
    },
    handleKeyTab: function handleKeyTab() {
      this.$emit('keydowntab');
    },
    handleBlur: function handleBlur() {
      this.$emit('blur');
    },
    handleFocus: function handleFocus() {
      this.$emit('focus');
    },
    handleEsc: function handleEsc() {
      this.$emit('keyupesc');
    },
    handleEnter: function handleEnter(e) {
      this.$emit('keyupenter');
      this.$emit('keyenter');
    },
    handleKeyDown: function handleKeyDown() {
      this.$emit('keyupdown');
    },
    handleKeyUp: function handleKeyUp() {
      this.$emit('keyupup');
    },


    focusControl: function focusControl(event) {
      event.preventDefault();
      var thisIndex = jQuery(this.$el.querySelector('input')).index(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var next = thisIndex + 1;
      var obj = jQuery(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      for (var x = next; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
          jQuery(obj[x]).focus();
          return;
        }
      }
      for (var x = 0; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
          jQuery(obj[x]).focus();
          return;
        }
      }
    },

    selectfocusControl: function selectfocusControl(event) {
      event.preventDefault();
      var thisIndex = jQuery(this.$el.querySelector('select')).index(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var next = thisIndex + 1;
      var obj = jQuery(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      for (var x = next; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
          jQuery(obj[x]).focus();
          return;
        }
      }
      for (var x = 0; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
          jQuery(obj[x]).focus();
          return;
        }
      }
    },

    input: function input(value) {
      var val = value;
      if (this.type == 'cnpj') {
        val = value.toUpperCase().replace(/[^A-Z0-9]/g, '').substring(0, 14);
      } else if (this.type == 'text') {
        if (!this.case || this.case === 'upper') {
          val = value.toUpperCase();
        } else if (!this.case || this.case === 'lower') {
          val = value.toLowerCase();
        } else {
          val = value;
        }
      }
      this.$emit('input', val);
    },

    focus: function focus() {
      if (this.$refs.input) {
        var self = this;
        this.$nextTick(function () {
          //const rect = this.$refs.pesquisa.getBoundingClientRect();
          self.$refs.input.focus();
        });
      }
    },

    updateCep: function updateCep() {
      this.$emit('update');
    },

    updateFone: function updateFone() {
      this.$emit('update');
    },

    updateEmail: function updateEmail() {
      this.$emit('update');
    },

    select: function select(evt) {
      this.$emit('input', evt.target.value);
    },
    handlePassword: function handlePassword() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    },
    handleAddButton: function handleAddButton() {
      this.$emit('clickAdd');
    },
    handleChange: function handleChange() {
      if (this.showDuplicados) this.timerDuplicados();
    },


    /////////////////// PESQUISA DUPLICADOS
    timerDuplicados: function timerDuplicados() {

      if (this.keytimer) {
        clearTimeout(this.keytimer);
      }

      var vm = this;
      this.keytimer = setTimeout(function () {
        vm.pesquisaDuplicados();
      }, 300);
    },
    pesquisaDuplicados: function pesquisaDuplicados() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.showDuplicados.url) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:

                _this.listDuplicados = [];

                _this.showSearching = true;
                _this.iconDuplicado = false;
                _context.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDS"])(_this.$store, _this.showDuplicados.url + _this.value);

              case 7:
                data = _context.sent;

                _this.searching = false;
                if (data.items && data.items.length > 0) {
                  _this.iconDuplicado = true;
                  _this.listDuplicados = data.items;
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  computed: {
    _case: function _case() {
      if (!this.case || this.case === 'upper') {
        return 'text-transform:uppercase';
      } else if (!this.case || this.case === 'lower') {
        return 'text-transform:lowercase';
      } else {
        return '';
      }
    },

    _entity: function _entity() {
      if (this.entity) {
        return this.entity;
      } else {
        if (this.metadata && this.metadata.select2) {
          return this.metadata.select2.entity;
        } else {
          return null;
        }
      }
    },
    _select2: function _select2() {
      if (this.select2) {
        return this.select2;
      } else {
        if (this.metadata && this.metadata.select2) {
          return this.metadata.select2;
        } else {
          return null;
        }
      }
    },
    _precision: function _precision() {

      if (this.precision && Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["stringToInteger"])(this.precision) > 0) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["stringToInteger"])(this.precision);
      } else {
        if (this.metadata && this.metadata.decimals) {
          return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["stringToInteger"])(this.metadata.decimals);
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["stringToInteger"])(this.precision);
        }
      }
    },
    _selectOptions: function _selectOptions() {
      if (this.selectOptions) {
        return this.selectOptions;
      } else if (this.metadata && this.metadata.options) {
        return this.metadata.options;
      }
    },
    _col: function _col() {
      if (!this.col) {
        return '';
      }
      var col = String(this.col);
      var colxs = 6;
      if (this.col == 1) {
        colxs = 4;
      }
      if (this.col >= 2) {
        colxs = 6;
      }
      if (this.col >= 4) {
        colxs = 12;
      }
      col = col.replace(col, 'col-md-' + col + ' col-' + colxs);
      return col;
    },
    classObject: function classObject() {
      return {
        obrigatorio: this.metadata && this.metadata.validator && this.metadata.validator.required == true && (!this.value || this.value == '')
      };
    },

    // Informações do Cartão
    getCardType: function getCardType() {
      var number = this.cardNumber;
      var re = new RegExp("^4");
      if (number.match(re) != null) return "visa";

      re = new RegExp("^(34|37)");
      if (number.match(re) != null) return "amex";

      re = new RegExp("^5[1-5]");
      if (number.match(re) != null) return "mastercard";

      re = new RegExp("^6011");
      if (number.match(re) != null) return "discover";

      re = new RegExp('^9792');
      if (number.match(re) != null) return 'troy';

      return "visa"; // default type
    },
    generateCardNumberMask: function generateCardNumberMask() {
      return this.getCardType === "amex" ? this.amexCardMask : this.otherCardMask;
    },
    minCardMonth: function minCardMonth() {
      if (this.cardYear === this.minCardYear) return new Date().getMonth() + 1;
      return 1;
    },
    mandatory: function mandatory(name) {
      return name && vErrors && vErrors.has(name);
    }
  },

  watch: {
    vErrors: {
      handler: function handler() {
        this.changed = true;
      },

      deep: true
    },
    cardYear: function cardYear() {
      if (this.cardMonth < this.minCardMonth) {
        this.cardMonth = "";
      }
    }
  },

  created: function created() {}
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'alert',

    props: {
        title: { type: String },
        text: { type: String },
        type: { type: String },
        close: { type: Boolean, default: true },
        messages: { type: Array }
    },

    data: function data() {
        return {
            show: true
        };
    },


    methods: {
        toggleAlert: function toggleAlert() {
            this.show = false;
        },
        clickEdit: function clickEdit(tipo, codpart) {
            this.$emit('edit', tipo, codpart);
        }
    }

});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'alert',

    props: {
        title: { type: String },
        messages: { type: Array },
        showcontinueanyway: { type: Boolean, default: false }
    },

    data: function data() {
        return {
            show: true
        };
    },


    watch: {
        messages: function messages() {
            return this.messages;
        }
    },

    methods: {
        handleContinueAnyWay: function handleContinueAnyWay() {
            console.log('handlecontinueanyway');
            this.$emit('continueanyway');
        },
        toggleAlert: function toggleAlert() {
            this.show = false;
        }
    },

    mounted: function mounted() {},
    created: function created() {}
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'warnings',

    props: {
        messages: { type: Array }
    },

    data: function data() {
        return {
            show: true
        };
    },


    watch: {
        messages: function messages() {
            return this.messages;
        }
    },

    methods: {
        handleContinueAnyWay: function handleContinueAnyWay() {
            console.log('handlecontinueanyway');
            this.$emit('continueanyway');
        },
        toggleAlert: function toggleAlert() {
            this.show = false;
        }
    },

    mounted: function mounted() {},
    created: function created() {}
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_filter__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consultas_filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  /*
  http://ruancarvalho.github.io/webdevacademy/ux/bootstrap-crud/view.html
   v-bind:class="{'is-active': variavelTrueFalse}"
  @click=""
  */
  props: {
    singleEntity: String,
    pluralEntity: String,
    newButton: Boolean,
    filterButton: Boolean, //filtro avançado
    advFiltersObject: Object, //objeto do filtro avançado
    pdfButton: Boolean,
    refreshButton: Boolean,
    xlsButton: Boolean,
    filterMonth: Boolean,
    fieldMonth: {
      type: String,
      default: 'data'
    },
    moreActions: Array,
    incluirActions: Array,
    urlHelp: String,
    monthFilter: Object,
    hideSearch: Boolean,
    titleSearch: String,
    gerarEtiqueta: Boolean,
    videoButton: Boolean,
    videoIcon: String,
    urlVideo: String,
    valueSearch: String
  },

  components: {
    BarFilter: __WEBPACK_IMPORTED_MODULE_1__components_bar_filter__["default"],
    Filtro: __WEBPACK_IMPORTED_MODULE_2__consultas_filtro__["a" /* default */]
  },

  data: function data() {

    return {
      title: 'Clientes',
      searchString: this.valueSearch || '',
      marked: true,
      showAdvancedFilter: false,
      filterList: [], //utilizado para exibicao em tela dos filtros aplicados
      urlQueryString: '', //url com os filtros
      monthObj: { //objeto utilizado pelo filtro de mes
        startDate: null,
        endDate: null
      },
      showVideo: false
    };
  },


  computed: {
    filterListActive: function filterListActive() {
      return this.filterList.filter(function (f) {
        return !f.removed;
      });
    }
  },

  methods: {
    handleApplyFilter: function handleApplyFilter(filtro) {
      this.searchString = '';
      this.filterList = [];
      var filter = {};
      filter.filterIndex = -1;
      filter.text = "FILTROS AVANÇADOS";
      filter.optionId = null;
      filter.removed = false;
      this.filterList.push(filter);

      //emite o evento apply filter com a url do filtro
      this.$emit('advancedfilter', filtro);
      this.showAdvancedFilter = false;
    },
    handleRemoveFilter: function handleRemoveFilter(index, filterIndex, optionId) {
      //acionado quando usuário exclui algum filtro da lista de filtros ativos

      if (filterIndex == -1) {
        //indica que o filtro é pelo campo de texto
        this.searchString = '';
        this.handlePesquisar();
        return;
      }

      var obj = this.advFiltersObject[this.filterListActive[index].filterIndex];

      //desabilita o filtro para efetuar nova requisicao no servidor
      if (obj.filter.options) {
        for (var i = 0; i < obj.filter.options.length; i++) {
          if (obj.filter.options[i].id = optionId) {
            obj.filter.options[i].selected = false;
          }
        }
      }

      //atualiza a url de filtro
      this.updateQueryString();

      //remove filtro aplicado da lista de filtros da tela
      this.filterListActive[index].removed = true;

      //emite o evento apply filter com a url
      this.$emit('filter', this.urlQueryString);
    },
    handleMonthChange: function handleMonthChange() {
      //evento que trata mudançao do filtro de periodo
      //o objeto monthObj foi atualizado com a data inicial e final

      this.searchString = '';
      this.filterList = [];
      this.updateQueryString(); //atualiza a querystring

      //atualiza as datas selecionadas no objeto do componente pai
      if (this.monthFilter) {
        this.monthFilter.startDate = this.monthObj.startDate;
        this.monthFilter.endDate = this.monthObj.endDate;
        this.monthFilter.url = this.urlQueryString;
      }

      //emite o evento filter com a url query string
      if (this.monthObj.startDate && this.monthObj.endDate) this.$emit('filter', this.urlQueryString, Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDateORDS"])(this.monthObj.startDate), Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDateORDS"])(this.monthObj.endDate, true));else this.$emit('filter', this.urlQueryString);
    },
    updateQueryString: function updateQueryString() {
      //monta a url com os filtros informado no filtro avançado e o mês selecionado

      var obj = {};

      var urlFilter = '';
      var arrUrl = [];

      //monta a url com o mês selecionado
      if (this.filterMonth) {
        urlFilter = '{"' + this.fieldMonth + '":{"$between":[{"$date":"' + Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDateORDS"])(this.monthObj.startDate) + '"},{"$date":"' + Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDateORDS"])(this.monthObj.endDate, true) + '"}]}}';
        arrUrl.push(urlFilter);
      }

      //pesquisa todos os objetos do filtro avancado para montagem da url
      if (this.advFiltersObject) {
        for (var i = 0; i < this.advFiltersObject.length; i++) {
          obj = this.advFiltersObject[i];
          urlFilter = '';
          for (var x = 0; x < obj.filter.options.length; x++) {
            //monta a url do filtro com as opcoes selecionadas
            if (obj.filter.options[x].selected) {
              if (urlFilter != '') {
                urlFilter = urlFilter + ',';
              }
              urlFilter = urlFilter + '{"' + obj.filter.fieldName + '":{"$eq":"' + obj.filter.options[x].id + '"}}';
            }
          }
          if (urlFilter != '') {
            urlFilter = '{"$or":[' + urlFilter + ']}';
            arrUrl.push(urlFilter);
          }
        }
      }

      this.urlQueryString = '';
      for (var _i = 0; _i < arrUrl.length; _i++) {
        if (this.urlQueryString != '') {
          this.urlQueryString = this.urlQueryString + ',';
        }
        this.urlQueryString = this.urlQueryString + arrUrl[_i];
      }

      this.urlQueryString = '{"$and":[' + this.urlQueryString + ']}';

      //console.log(this.urlQueryString)
    },
    handlePesquisar: function handlePesquisar() {
      //botao de pesquisa do campo de pesquisa pelo texto
      this.filterList = [];

      var term = this.searchString.toUpperCase();
      // Se o termo parece um CNPJ formatado (contém simbolos e tem tamanho exato de 18 caracteres)
      // removemos a formatação para a pesquisa ser efetiva no banco (alfanumérico puro)
      if (term.length == 18 && (term.indexOf('.') >= 0 || term.indexOf('/') >= 0 || term.indexOf('-') >= 0)) {
        term = term.replace(/[^A-Z0-9]/g, '');
      }

      if (this.searchString != '') {
        var filter = {};
        filter.filterIndex = -1;
        filter.text = term;
        filter.optionId = null;
        filter.removed = false;
        this.filterList.push(filter);
      }
      this.urlQueryString = '';

      this.$emit('search', term);
    },
    clickAction: function clickAction(act) {
      this.$emit('action', act);
    },
    clickPrint: function clickPrint() {
      this.$emit('print');
    },
    clickNew: function clickNew() {
      this.$emit('new');
    },
    clickFilter: function clickFilter() {
      //abre o filtro avancado
      this.showAdvancedFilter = true;
    },
    clickRefresh: function clickRefresh() {
      this.$emit('refresh');
    },
    clickVideo: function clickVideo() {
      this.showVideo = true;
    }
  },

  created: function created() {
    var action = {};

    if (this.moreActions) {
      //adiciona as acoes no botao mais acoes
      if (this.pdfButton) {
        action = { label: 'Gerar PDF', action: 'pdf' };
        this.moreActions.push(action);
      }
      if (this.xlsButton) {
        action = { label: 'Exportar Planilha', action: 'xls' };
        this.moreActions.push(action);
      }
    }
  },
  mounted: function mounted() {
    //atualiza as datas do filtro de mes no objeto FILTERMONTH do componente pai
    if (this.monthFilter) {
      this.updateQueryString(); //atualiza a querystring
      this.monthFilter.startDate = this.monthObj.startDate;
      this.monthFilter.endDate = this.monthObj.endDate;
      this.monthFilter.url = this.urlQueryString;
    }

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_bar_filter_vue__ = __webpack_require__(405);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1d7dc6_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_bar_filter_vue__ = __webpack_require__(1111);
function injectStyle (ssrContext) {
  __webpack_require__(1109)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_bar_filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1d7dc6_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_bar_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    advFiltersObject: Array
  },

  data: function data() {
    return {
      lFilters: []
    };
  },


  methods: {
    selectButton: function selectButton(filter, option) {
      if (option.selected) {
        option.selected = false;
      } else {
        option.selected = true;
      }
    },
    handleApplyFilter: function handleApplyFilter(filters) {
      //envia o objeto local para o chamador
      this.lFilters = filters;
      this.$emit('filter', this.lFilters);
    },
    handleClose: function handleClose() {
      this.$emit('close');
    }
  },

  created: function created() {
    this.lFilters = this.advFiltersObject; //recebe o parametro com os campos do filtro e joga para o objeto local
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import DashCard from '../components/dash-card'

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params: { type: Object },
    showfiltro: { type: Boolean }
  },

  components: {},

  data: function data() {
    return {

      base: {
        usuario: { label: 'Usuario', url: 'usuario', tipo: 'select2', varios: false, values: [{ id: null }] },
        equipe: { label: 'Equipe de Venda', url: '', tipo: 'select2', varios: false, values: [{ id: null }] },
        filial: { label: 'Filial', url: 'filial/', tipo: 'select2', varios: false, values: [{ id: null }] },
        segmento: { label: 'Segmento', url: 'ramoat/', tipo: 'select2', varios: false, values: [{ id: null }] },
        grupocliente: { label: 'Grupo de Clientes', url: 'grucli/', tipo: 'select2', varios: false, values: [{ id: null }] },
        cliente: { label: 'Cliente', url: 'cliente/', tipo: 'select2', varios: false, values: [{ id: null }] },
        clienteusuario: { label: 'Cliente', url: 'clienteusuario/', tipo: 'select2', varios: false, values: [{ id: null }] },
        clientefornecedor: { label: 'Cliente / Fornecedor', url: 'clientefornecedor/', tipo: 'select2', varios: false, values: [{ id: null }] },
        fornecedor: { label: 'Fornecedor', tipo: 'select2', varios: false, values: [{ id: null }] },
        estado: { label: 'Estado', url: 'estado/', tipo: 'select2', varios: false, values: [{ id: null }] },
        cidade: { label: 'Cidade', url: 'mun/', tipo: 'select2', varios: false, values: [{ id: null }] },
        grupoestoque: { label: 'Grupo de Produtos', url: 'gruest/', tipo: 'select2', varios: false, values: [{ id: null }] },
        produto: { label: 'Produto', url: 'item/', tipo: 'select2', varios: false, values: [{ id: null }] },
        formapagamento: { label: 'Forma de Pagamento', url: 'fpag/', tipo: 'select2', varios: false, values: [{ id: null }] },
        pdstatus: { label: 'Status do Pedio', url: 'pdstatus/', tipo: 'select2', varios: false, values: [{ id: null }] }
        // texto: { label: 'Texto', tipo: 'text', varios: false, values: [{ text: null }] },
      },

      filtros: [],

      filtroPeriodos: [{ data_inicio: null, data_termino: null, startDate: null, endDate: null }]

    };
  },


  watch: {},

  methods: {
    inicializa: function inicializa() {
      var obj = null;

      for (var x = 0; x < this.params.filtros.length; x++) {

        obj = this.base[this.params.filtros[x].nome];
        obj.nome = this.params.filtros[x].nome;

        if (this.params.filtros[x].label) obj.label = this.params.filtros[x].label;

        if (this.params.filtros[x].url) obj.url = this.params.filtros[x].url;

        if (this.params.filtros[x].varios) obj.varios = this.params.filtros[x].varios;

        //aqui carrega os valores para os filtros vindos do PARENT
        if (this.params.filtros[x].values && this.params.filtros[x].values.length > 0) {
          obj.values = [];
          for (var y = 0; y < this.params.filtros[x].values.length; y++) {
            obj.values.push({ id: this.params.filtros[x].values[y] });
          }
          // console.log(obj.values)
        }
        //

        this.filtros.push(obj);
      }

      if (this.params.periodos) this.filtroPeriodos = this.params.periodos;else if (this.params.periodo) {
        this.filtroPeriodos = [{
          data_inicio: this.params.periodo.data_inicio,
          data_termino: this.params.periodo.data_termino,
          startDate: this.params.periodo.data_inicio,
          endDate: this.params.periodo.data_termino
        }];
      }

      /*
      query string
      datainicial=99-99-9999&datafinal=99-99-9999&filial=1&grupoestoque=1&grupocliente=1
      */
    },
    readQueryString: function readQueryString() {},
    createQueryString: function createQueryString() {},
    change: function change() {
      var filtro = {};

      var periodos = [];

      for (var x = 0; x < this.filtroPeriodos.length; x++) {
        this.filtroPeriodos[x].data_inicio = this.filtroPeriodos[x].startDate;
        this.filtroPeriodos[x].data_termino = this.filtroPeriodos[x].endDate;
        periodos.push(this.filtroPeriodos[x]);
      }

      filtro.periodos = periodos;

      this.params.periodos = periodos; //atualiza os periodos no objeto pai

      var obj = null;
      var values = null;

      for (var x = 0; x < this.filtros.length; x++) {
        values = [];
        for (var y = 0; y < this.filtros[x].values.length; y++) {
          if (this.filtros[x].values[y].id) values.push(this.filtros[x].values[y].id);
        }
        filtro[this.filtros[x].nome] = values;
      }

      if (this.params.checkbox && this.params.checkbox.length) {
        for (var x = 0; x < this.params.checkbox.length; x++) {
          filtro[this.params.checkbox[x].nome] = this.params.checkbox[x].value;
        }
      }

      this.$modalForm(false);

      console.log(filtro);

      this.$emit('change', filtro);
    },
    cancel: function cancel() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit('cancel');

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handlePeriodoChange: function handlePeriodoChange(index) {
      //alteracao de periodo
    },
    handleAdicionaFiltro: function handleAdicionaFiltro(flt, index) {
      flt.values.push({ id: null });
    },
    handleAdicionaPeriodo: function handleAdicionaPeriodo() {
      this.filtroPeriodos.push({ data_inicio: null, data_termino: null, startDate: null, endDate: null });

      // console.log(this.$route.query)

      // let query = JSON.parse(JSON.stringify(this.$route.query));
      // query.segmento = [1]

      // // this.$router.replace({ query: query })
      // window.location.hash = '#/?segmento=5'
      // console.log(window.location.hash.slice(1))
    },
    handleExcluiPeriodo: function handleExcluiPeriodo(index) {
      this.filtroPeriodos.splice(index, 1);
    },
    handleExcluiValueFiltro: function handleExcluiValueFiltro(flt, index) {
      flt.values.splice(index, 1);
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch('loadSessao', _this2);

              case 2:
                _context2.next = 4;
                return _this2.$store.dispatch('loadUsuariosDashboard', _this2);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },

  computed: {
    showClass: function showClass() {
      if (!this.showfiltro) {
        this.$modalForm(false);
        return 'transform: translate3d(0, 100%, 0);';
      } else {
        this.$modalForm(true);
        return 'transform: translate3d(0%, 0, 0);';
      }
    },

    sessao: function sessao() {
      return this.$store.getters.getSessao;
    }

  },

  destroyed: function destroyed() {
    this.$modalForm(false);
  },
  mounted: function mounted() {

    var vm = this;
    this.keytimer = setTimeout(function () {
      // console.log(vm.filtros)
    }, 100);
  },
  created: function created() {

    this.inicializa();
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        options: {},
        moreActions: '',
        obj: null
    },

    data: function data() {

        return {
            view: false,
            print: false,
            sefaz: false,
            xml: false,
            edit: false,
            email: false,
            faturar: false,
            devolucao: false
        };
    },


    watch: {
        stnf: function stnf() {
            this.updateButtons();
        },

        isView: function isView() {
            this.updateButtons();
        }
    },

    computed: {
        stnf: function stnf() {
            return this.options.stnf;
        },

        isView: function isView() {
            return this.options.isView;
        }
    },

    methods: {
        clickEdit: function clickEdit() {
            this.$emit('edit');
        },
        clickDelete: function clickDelete() {
            this.$emit('delete');
        },
        clickArchive: function clickArchive() {
            this.$emit('archive');
        },
        clickCancel: function clickCancel() {
            this.$emit('cancel');
        },
        clickView: function clickView() {
            this.$emit('view');
        },
        clickSend: function clickSend() {
            this.$emit('send');
        },
        clickEmail: function clickEmail() {
            this.$emit('email');
        },
        clickPrint: function clickPrint() {
            this.$emit('print');
        },
        clickFaturar: function clickFaturar() {
            this.$emit('faturar');
        },
        clickDevolucao: function clickDevolucao() {
            this.$emit('devolucao');
        },
        clickXML: function clickXML() {
            this.$emit('xml');
        },
        clickAction: function clickAction(action, actionObj) {
            this.$emit('action', action, this.obj, actionObj);
        },
        updateButtons: function updateButtons() {
            this.print = this.options.btnPrint;
            this.faturar = this.options.btnFaturar;
            this.devolucao = this.options.btnDevolucao;

            if (this.options.barNF) {
                //BOTOES PARA NOTA FISCAL: habilita os botoes conforme o status da nf
                this.edit = this.options.stnf < '10' && this.options.stnf != '02' || this.options.stnf == '50';
                this.print = this.options.autoriza && this.options.stnf == '10';
                this.email = this.options.autoriza && this.options.stnf == '10';
                this.sefaz = this.options.autoriza && (this.options.stnf == '01' || this.options.stnf == '02' || this.options.stnf == '50');
                this.xml = this.options.stnf == '10' || this.options.stnf >= '50' || this.options.chave;
                this.view = true;
            } else if (this.options.barPedvIt) {
                //BARRA DE PEDIDO: habilita os botoes conforme o status do pedido
                this.view = this.isView || this.options.stpedv != 'D' && this.options.stpedv != 'P';
                this.print = (this.options.stpedv == 'P' || this.options.stpedv == 'F') && this.options.tppedv != 'R';
                this.email = (this.options.stpedv == 'P' || this.options.stpedv == 'F') && this.options.tppedv != 'R';
            }
        }
    },

    destroyed: function destroyed() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip('hide');
        });
    },
    created: function created() {
        this.updateButtons();
    }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        singleEntity: String,
        crud: String,
        entityPK: String,
        btnDelete: Boolean,
        btnCancel: Boolean,
        disableSave: Boolean,
        disableRetorno: Boolean,
        moreActions: Array
    },

    data: function data() {
        return {
            title: '',
            crudText: '',
            titleClose: '',
            titleOK: '',
            titleCancel: '',
            titleDelete: '',
            buttonRetorno: false,
            buttonCancel: false,
            buttonDelete: false,
            buttonSave: false,
            modalCancel: false,
            modalDelete: false,
            disabledTitle: ''
        };
    },


    computed: {},

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleSave: function handleSave() {
            this.$emit('save');
        },
        handleSaveNew: function handleSaveNew() {
            this.$emit('savenew');
        },
        confirm: function confirm() {
            this.$emit('confirm');
        },
        handleCancel: function handleCancel() {
            this.closeModal();
            this.$emit('cancel');
        },
        handleDelete: function handleDelete() {
            this.closeModal();
            this.$emit('delete');
        },
        closeModal: function closeModal() {
            this.modalCancel = false;
            this.modalDelete = false;
        },
        confirmMessage: function confirmMessage(action) {
            //exibe a mensagem de confirmacao de cancelamento ou exclusao
            if (action == 'del') {
                this.modalDelete = true;
            } else {
                this.modalCancel = true;
            }
        },
        clickAction: function clickAction(act) {
            this.$emit('action', act);
        }
    },

    watch: {
        disableSave: function disableSave(newValue, oldValue) {
            if (this.disableSave) {
                this.disabledTitle = 'Por favor, corrija os campos em destaque.';
            } else {
                this.disabledTitle = '';
            }
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
            });
        },

        disableRetorno: function disableRetorno(newValue, oldValue) {
            if (this.disableRetorno) {
                this.buttonRetorno = false;
            } else {
                this.buttonRetorno = true;
            }
        }
    },

    destroyed: function destroyed() {},
    mounted: function mounted() {},
    created: function created() {

        this.crudText = this.$crudText(this.crud);
        this.buttonSave = false;
        this.buttonDelete = false;
        this.buttonCancel = false;
        if (this.disableRetorno) this.buttonRetorno = false;else this.buttonRetorno = true;

        this.titleClose = '';
        /*
                if (this.crud == SysVars.crudI) {
                    this.buttonSave = true
                } else if (this.crud == SysVars.crudU) {
                    this.buttonSave = true
                } else if (this.crud == SysVars.crudD) {
                    this.buttonSave = true
                    this.titleDelete = 'Clique para confirmar a exclusão de ' + this.singleEntity
                } else if (this.crud == SysVars.crudC) {
                    this.buttonCancel = true
                    this.titleCancel = 'Clique para confirmar o cancelamento de ' + this.singleEntity
                }
        */
        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudInsert) {
            this.buttonSave = true;
        } else if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudUpdate) {
            this.buttonSave = true;
        }

        if (this.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudInsert) {
            if (this.btnDelete) {
                this.buttonDelete = true;
                this.titleDelete = 'Clique para confirmar a exclusão';
            }
            if (this.btnCancel) {
                this.buttonCancel = true;
                this.titleCancel = 'Clique para confirmar o cancelamento';
            }
        }

        this.title = this.crudText + ' ' + this.singleEntity;
        if (this.entityPK) {
            this.title = this.title + ' (' + this.entityPK + ')';
        }
    }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

//https://br.vuejs.org/v2/guide/components.html#Usando-v-on-com-Eventos-Personalizados

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-label',
  props: {
    label: { type: String },
    metadataField: { type: Object },
    titleAddButton: { type: String },
    title: { type: String }
  },

  data: function data() {
    return {
      vlabel: '',
      help: '',
      badgeHelp: false,
      badgeNew: false
    };
  },


  computed: {

    _class: function _class() {
      if (this.class) {
        return this.class;
      } else {
        return 'lbl-edit';
      }
    },

    _label: function _label() {
      if (this.label) {
        return this.label;
      } else if (this.metadataField) {
        if (this.metadataField.label) {
          return this.metadataField.label;
        }
      } else {
        return this.label;
      }
    }

  },

  methods: {
    handleAddButton: function handleAddButton() {
      this.$emit('clickAdd');
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
  },
  created: function created() {
    if (this.metadataField) {
      if (this.metadataField.help) {
        this.badgeHelp = true;
        this.help = this.metadataField.help;
      }
    }
    if (this.title) {
      this.badgeHelp = true;
      this.help = this.title;
    }
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_label_title_vue__ = __webpack_require__(411);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_efb54028_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_label_title_vue__ = __webpack_require__(1123);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_label_title_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_efb54028_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_label_title_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'label-title',
  props: {
    title: { type: String },
    icon: { type: String }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-button',
  props: {
    label: { type: String },
    title: { type: String },
    disabled: { type: Boolean },
    nbBtdef: { type: Boolean },
    success: { type: Boolean },
    danger: { type: Boolean },
    video: { type: Boolean },
    link: { type: Boolean },
    icon: { type: String },
    tabindex: [String, Number],
    actions: { type: Array },
    not_min_width: { type: Boolean },
    customStyle: { type: String }
  },

  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.initTooltip();
  },


  watch: {
    title: function title() {
      this.initTooltip();
    }
  },

  methods: {
    initTooltip: function initTooltip() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$refs.botao) {
          jQuery(_this.$refs.botao).tooltip('dispose');
          if (_this.title) {
            jQuery(_this.$refs.botao).tooltip();
          }
        }
      });
    },
    handleClick: function handleClick() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.$refs.botao) {
          jQuery(_this2.$refs.botao).tooltip('hide');
        }
      });
      this.$emit('click');
    },
    handleActions: function handleActions(action) {
      this.$emit('click', action);
    },
    focus: function focus() {
      if (this.$refs.botao) {
        this.$refs.botao.focus();
      }
    }
  },

  computed: {
    btStyle: function btStyle() {
      if (this.label) {
        if (this.not_min_width) {
          return '';
        } else {
          return 'min-width: 150px';
        }
      } else {
        return '';
      }
    },

    _label: function _label() {
      if (this.label) {
        return this.label;
      } else {
        return 'Mais Ações';
      }
    }

  },

  beforeDestroy: function beforeDestroy() {
    if (this.$refs.botao) {
      jQuery(this.$refs.botao).tooltip('dispose');
    }
  },
  created: function created() {}
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//https://br.vuejs.org/v2/guide/components.html#Usando-v-on-com-Eventos-Personalizados





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'value': String
  },

  data: function data() {
    return {
      cep: this.value,
      fucused: false
    };
  },
  created: function created() {},


  watch: {
    value: function value(newValue) {
      this.cep = newValue;
      this.formatValue();
    }
  },

  methods: {
    buscaCep: function buscaCep() {
      var vm = this;
      if (/^[0-9]{5}[0-9]{3}$/.test(this.cep)) {

        Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSapp"])(this, 'cep/?cep=' + this.cep, 'get').then(function (data) {
          console.log('input-cep buscaCep');
          if (data.erro) {
            __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco = {};
          } else {
            //atualiza a SysVars com o endereco
            __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco = data;
            __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.logradouro = vm.$removerAcentos(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.logradouro.toUpperCase());
            __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.bairro = vm.$removerAcentos(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.bairro.toUpperCase());
            __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.localidade = vm.$removerAcentos(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.localidade.toUpperCase());
            vm.$emit('update');
          }
        });

        // jQuery.getJSON(vm.$store.getters.urlApp + 'cep/?cep=' +this.cep, function(data) {
        //   if (data.erro) {
        //     SysVars.endereco = {}
        //   } else {
        //     //atualiza a SysVars com o endereco
        //     SysVars.endereco = data
        //     SysVars.endereco.logradouro = vm.$removerAcentos(SysVars.endereco.logradouro.toUpperCase())
        //     SysVars.endereco.bairro = vm.$removerAcentos(SysVars.endereco.bairro.toUpperCase())
        //     SysVars.endereco.localidade = vm.$removerAcentos(SysVars.endereco.localidade.toUpperCase())
        //     vm.$emit('update')
        //   }
        // })
      }
    },


    updateValue: function updateValue(value) {
      this.cep = value.replace(/\D/g, '');
      this.$emit('input', this.cep);
    },

    formatValue: function formatValue() {
      this.focused = false;
      if (this.$refs.cep.value) {
        this.$refs.cep.value = this.cep.replace(/\D/g, '').replace(/^(\d{5})(\d{3})??/, "$1-$2");
      }
    },

    selectAll: function selectAll(event) {
      if (this.focused == false) {
        this.formatRemove();
      }
      this.focused = true;
      // Workaround for Safari bug
      // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
      setTimeout(function () {
        event.target.select();
      }, 0);
    },

    formatRemove: function formatRemove() {
      if (this.$refs.cep.value) {
        this.$refs.cep.value = this.cep.replace(/\D/g, '');
      }
    },

    focusControl: function focusControl(event) {
      event.preventDefault();
      var thisIndex = jQuery(this.$el).index(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var next = thisIndex + 1;
      var obj = jQuery(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var found = false;
      for (var x = next; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["hasHiddenParent"])(obj[x])) {
          jQuery(obj[x]).focus();
          found = true;
          break;
        }
      }
      if (!found) {
        for (var x = 0; x < obj.length; x++) {
          if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["hasHiddenParent"])(obj[x])) {
            jQuery(obj[x]).focus();
            found = true;
            break;
          }
        }
      }

      this.$emit('keyenter');
    },

    focus: function focus() {
      if (this.$refs.cep) {
        this.$refs.cep.focus();
      }
    }

  }

});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//https://br.vuejs.org/v2/guide/components.html#Usando-v-on-com-Eventos-Personalizados




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'value': String
  },

  data: function data() {
    return {
      fone: this.value,
      fucused: false
    };
  },
  created: function created() {},


  watch: {
    value: function value(newValue) {
      this.fone = newValue;
      this.$nextTick(function () {
        this.formatValue();
      });
    }
  },

  methods: {
    handleKeyTab: function handleKeyTab() {
      this.$emit('keydowntab');
    },
    handleBlur: function handleBlur() {
      this.formatValue();
      this.$emit('blur');
    },
    handleEsc: function handleEsc() {
      this.$emit('keyupesc');
    },
    handleEnter: function handleEnter(event) {
      this.focusControl(event);
      this.$emit('keyupenter');
    },
    handleKeyDown: function handleKeyDown() {
      this.$emit('keyupdown');
    },
    handleKeyUp: function handleKeyUp() {
      this.$emit('keyupup');
    },


    updateValue: function updateValue(value) {
      this.fone = value.replace(/\D/g, '');
      this.$emit('input', this.fone);
    },

    formatValue: function formatValue() {
      this.focused = false;
      if (this.$refs.fone.value) {
        this.$refs.fone.value = this.$formatFone(this.$refs.fone.value);
      }
    },

    handleFocus: function handleFocus(event) {
      this.formatRemove();
      this.focused = true;
      // Workaround for Safari bug
      // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
      this.$emit('focus');
      setTimeout(function () {
        event.target.select();
      }, 0);
    },

    formatRemove: function formatRemove() {
      if (this.$refs.fone.value) {
        this.$refs.fone.value = this.fone.replace(/\D/g, '');
      }
    },

    focusControl: function focusControl(event) {
      event.preventDefault();
      var thisIndex = jQuery(this.$el).index(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var next = thisIndex + 1;
      var obj = jQuery(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var found = false;
      for (var x = next; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
          jQuery(obj[x]).focus();
          found = true;
          break;
        }
      }
      if (!found) {
        for (var x = 0; x < obj.length; x++) {
          if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
            jQuery(obj[x]).focus();
            found = true;
            break;
          }
        }
      }

      this.$emit('keyenter');
    },

    focus: function focus() {
      if (this.$refs.fone) {
        this.$refs.fone.focus();
      }
    }

  }

});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: { String: String }
  },

  data: function data() {
    return {
      hora: this.value,
      horaAjustada: '',
      focused: false,
      isUpdateValue: false

    };
  },
  mounted: function mounted() {},
  created: function created() {},


  methods: {
    updateValue: function updateValue(value) {
      this.isUpdateValue = true;
      this.hora = value.replace(/\D/g, '');
      if (this.validaHora(this.hora)) {
        this.$emit('input', this.horaAjustada);
      }
    },

    handleBlur: function handleBlur() {
      this.focused = false;
      var hora = this.$refs.hora.value;
      if (hora) {
        if (!this.validaHora(hora)) {
          this.$emit('input', null);
          this.$refs.hora.focus();
          this.$erpToastError('Informe uma hora válida');
        } else this.$refs.hora.value = this.horaAjustada;
      }
    },

    validaHora: function validaHora(hora) {
      if (!hora) return false;

      this.horaAjustada = String(hora).replace(':', '');

      if (String(this.horaAjustada).length == 2) this.horaAjustada = this.horaAjustada + '00';else if (String(this.horaAjustada).length == 1) this.horaAjustada = this.horaAjustada + '000';else if (String(this.horaAjustada).length == 3) this.horaAjustada = this.horaAjustada + '0';else if (String(this.horaAjustada).length > 4) return false;

      if (this.horaAjustada.substr(0, 2) > 23) return false;

      if (this.horaAjustada.substr(2, 2) > 59) return false;

      this.horaAjustada = this.$formatHora(this.horaAjustada);

      return true;
    },

    selectAll: function selectAll(event) {
      // if (this.$refs.hora.value) {
      //   this.$refs.hora.value = this.hora.replace(/\D/g, '')
      // }
      this.focused = true;
      // Workaround for Safari bug
      // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
      setTimeout(function () {
        event.target.select();
      }, 0);
    },

    focusControl: function focusControl(event) {
      event.preventDefault();
      var thisIndex = jQuery(this.$el.querySelector('input')).index(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var next = thisIndex + 1;
      var obj = jQuery(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var found = false;
      for (var x = next; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
          jQuery(obj[x]).focus();
          found = true;
          break;
        }
      }
      if (!found) {
        for (var x = 0; x < obj.length; x++) {
          if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
            jQuery(obj[x]).focus();
            found = true;
            break;
          }
        }
      }

      this.$emit('keyenter');
    },

    focus: function focus() {
      if (this.$refs.hora) {
        this.$refs.hora.focus();
      }
    }

  },
  watch: {
    value: function value(_value) {
      if (!this.isUpdateValue) {
        this.$refs.hora.value = _value;
      }
      this.isUpdateValue = false;
    }
  }

});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//https://br.vuejs.org/v2/guide/components.html#Usando-v-on-com-Eventos-Personalizados




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'value': String,
    'name': String
  },

  data: function data() {
    return {
      email: this.value,
      fucused: false
    };
  },
  created: function created() {},


  watch: {
    value: function value(newValue) {
      this.email = newValue;
    }
  },

  methods: {

    updateValue: function updateValue(value) {
      this.email = value.toLowerCase();
      this.$emit('input', this.email);
    },

    handleValidateEmail: function handleValidateEmail() {
      if (!this.email) {
        return;
      }
      if (!this.$isValidEmail(this.email)) {
        this.focus();
      }
    },

    selectAll: function selectAll(event) {
      this.focused = true;
      // Workaround for Safari bug
      // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
      setTimeout(function () {
        event.target.select();
      }, 0);
    },

    focusControl: function focusControl(event) {
      event.preventDefault();
      var thisIndex = jQuery(this.$el).index(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var next = thisIndex + 1;
      var obj = jQuery(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var found = false;
      for (var x = next; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
          jQuery(obj[x]).focus();
          found = true;
          break;
        }
      }
      if (!found) {
        for (var x = 0; x < obj.length; x++) {
          if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
            jQuery(obj[x]).focus();
            found = true;
            break;
          }
        }
      }

      this.$emit('keyenter');
    },

    focus: function focus() {
      if (this.$refs.email) {
        this.$refs.email.focus();
      }
    }

  }

});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'url': String,
    'emails': Array
  },

  data: function data() {
    return {
      email: this.value,
      fucused: false,

      emailList: [],
      //{ email: '', nome: '', label: '', invalid: false }

      inputParams: {
        url: this.url,
        permite_novo: false,
        codigo: null
      },

      showInput: true

    };
  },


  watch: {
    emails: function emails(newValue) {
      this.emailList = newValue;
    }
  },

  methods: {
    handleBlur: function handleBlur(text) {
      if (text) this.addEmailDigitado(text, true);
      this.$emit('blur');
      if (this.emailList.length > 0) this.showInput = false;
    },
    addEmailDigitado: function addEmailDigitado(text, blur) {
      //ADICIONA UM EMAIL DIGITADO
      if (!text) return;
      this.email = text;
      if (this.email) {
        var email = {
          email: this.email, nome: '', label: this.email, invalid: !this.$isValidEmail(this.email)
        };
        this.emailList.push(email);
        this.email = '';
        this.$nextTick(function () {
          if (!blur) this.$refs.email.focus();
          this.$refs.email.textSearch = null;
        });
      }
    },
    handleSelect: function handleSelect(selected) {
      if (selected) {
        var email = {
          email: selected.email,
          nome: selected.nome,
          label: selected.nome + ' (' + selected.email + ')'
        };
        this.email = '';
        this.emailList.push(email);
        this.$nextTick(function () {
          this.$refs.email.textSearch = null;
          this.$refs.email.focus();
        });
      }
    },


    focus: function focus() {
      console.log('input-email-list');
      this.showInput = true;
      this.$nextTick(function () {
        if (this.$refs.email) {
          this.$refs.email.focus();
        }
      });
    },

    isValid: function isValid() {
      var invalid = this.emailList.filter(function (obj) {
        return obj.invalid;
      });

      if (invalid.length > 0) return false;else return true;
    },

    handleRemoveEmail: function handleRemoveEmail(index) {
      this.emailList.splice(index, 1);
    }
  },

  created: function created() {
    if (this.emails) this.emailList = this.emails;
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: { Number: Number, String: String },
    currency: {
      type: String, default: '', required: false
    },
    max: {
      type: Number, default: Number.MAX_SAFE_INTEGER || 9007199254740991, required: false
    },
    min: {
      type: Number, default: Number.MIN_SAFE_INTEGER || -9007199254740991, required: false
    },
    minus: {
      type: Boolean, default: false, required: false
    },
    precision: {
      type: Number, default: 0, required: false
    }
  },

  data: function data() {
    return {
      valor: this.value,
      focused: false
    };
  },


  methods: {
    updateValue: function updateValue(value) {
      this.$emit('input', this.$strToFloat(value, this.precision));
    },

    handleBlur: function handleBlur() {
      this.formatValue();
      this.$emit('blur');
    },


    formatValue: function formatValue() {
      var v = this.$refs.valor.value;
      this.$refs.valor.value = Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["formatValue"])(this.$strToFloat(v, this.precision), this.precision);
      this.focused = false;
    },

    selectAll: function selectAll(event) {
      this.focused = true;
      this.formatRemove();
      // Workaround for Safari bug
      // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
      setTimeout(function () {
        event.target.select();
      }, 0);
    },

    formatRemove: function formatRemove() {
      var vlr = this.$refs.valor.value;
      this.$refs.valor.value = vlr.replace(/\./g, '');
    },

    focusControl: function focusControl(event) {
      event.preventDefault();
      var thisIndex = jQuery(this.$el).index(__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].sFocusControl);
      var next = thisIndex + 1;
      var obj = jQuery(__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].sFocusControl);
      var found = false;
      for (var x = next; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["hasHiddenParent"])(obj[x])) {
          jQuery(obj[x]).focus();
          found = true;
          break;
        }
      }
      if (!found) {
        for (var x = 0; x < obj.length; x++) {
          if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["hasHiddenParent"])(obj[x])) {
            jQuery(obj[x]).focus();
            found = true;
            break;
          }
        }
      }
      this.$emit('keyenter');
    },

    keyEsc: function keyEsc(event) {
      this.$emit('keyesc', event);
    },


    focus: function focus() {
      if (this.$refs.valor) {
        var self = this;
        this.$nextTick(function () {
          //const rect = this.$refs.pesquisa.getBoundingClientRect();
          self.$refs.valor.focus();
        });
      }
    }

  },

  watch: {
    value: function value(_value) {
      if (!this.focused) {
        this.$refs.valor.value = String(_value).replace('.', ',');
        // console.log('inputvalue watch: ' + this.$refs.valor.value)
        this.formatValue();
      }
    }
  },

  mounted: function mounted() {
    this.formatValue();
    // console.log('inputvalue mounted: ' + this.$refs.valor.value)
    // console.log('inputvalue mounted value: ' + this.value)
  },
  created: function created() {
    // console.log('inputvalue created')
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//https://br.vuejs.org/v2/guide/components.html#Usando-v-on-com-Eventos-Personalizados



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'label': String,
    'title': String,
    'valueChecked': [String, Boolean],
    'valueUnchecked': [String, Boolean],
    'metadataField': Object,
    'value': [String, Boolean],
    customStyle: String
  },

  data: function data() {
    return {
      vvalue: this.value,
      vlabel: '',
      help: '',
      bHelp: false,
      checked: false
    };
  },


  methods: {
    updateValue: function updateValue(value) {
      if (value) {
        this.vvalue = this.valueChecked;
        this.checked = true;
      } else {
        this.vvalue = this.valueUnchecked;
        this.checked = false;
      }
      this.$emit('input', this.vvalue);
    },

    focusControl: function focusControl(event) {
      event.preventDefault();
      var thisIndex = jQuery(this.$el.querySelector('input')).index(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var next = thisIndex + 1;
      var obj = jQuery(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var found = false;
      for (var x = next; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
          jQuery(obj[x]).focus();
          found = true;
          break;
        }
      }
      if (!found) {
        for (var x = 0; x < obj.length; x++) {
          if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
            jQuery(obj[x]).focus();
            found = true;
            break;
          }
        }
      }

      this.$emit('keyenter');
    }

  },

  watch: {
    value: function value(newValue) {
      //console.log('checkbox value: ' + newValue)
      this.vvalue = newValue;
      if (this.vvalue == this.valueChecked) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    }
  },

  created: function created() {
    //console.log('checkbox value created: ' + this.value)

    this.vvalue = this.value;
    if (this.vvalue == this.valueChecked) {
      this.checked = true;
    } else {
      this.checked = false;
    }

    if (this.metadataField) {
      if (this.metadataField.help) {
        this.bHelp = true;
        this.help = this.metadataField.help;
      }
      if (this.metadataField.label) {
        this.vlabel = this.metadataField.label;
      }
    }

    if (!this.vlabel) {
      this.vlabel = this.label;
    }
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

//https://br.vuejs.org/v2/guide/components.html#Usando-v-on-com-Eventos-Personalizados

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'label': String,
    'valueChecked': [String, Boolean],
    'valueUnchecked': [String, Boolean],
    'metadataField': Object,
    'value': [String, Boolean],
    'type': String
  },

  data: function data() {
    return {
      vvalue: this.value,
      vlabel: '',
      help: '',
      bHelp: false,
      checked: false
    };
  },


  computed: {
    _class: function _class() {
      if (this.type) {
        return this.type;
      } else {
        return 'default';
      }
    }

  },

  methods: {
    updateValue: function updateValue(value) {
      if (value) {
        this.vvalue = this.valueChecked;
        this.checked = true;
      } else {
        this.vvalue = this.valueUnchecked;
        this.checked = false;
      }
      this.$emit('input', this.vvalue);
    }
  },

  watch: {
    value: function value(newValue) {
      this.vvalue = newValue;
      if (this.vvalue == this.valueChecked) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    }
  },

  created: function created() {

    this.vvalue = this.value;
    if (this.vvalue == this.valueChecked) {
      this.checked = true;
    } else {
      this.checked = false;
    }

    if (this.metadataField) {
      if (this.metadataField.help) {
        this.bHelp = true;
        this.help = this.metadataField.help;
      }
      if (this.metadataField.label) {
        this.vlabel = this.metadataField.label;
      }
    }
    if (this.label) {
      this.vlabel = this.label;
    }
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_utils__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    pMonth: { type: Object },
    showOptions: { type: Boolean }
  },

  data: function data() {
    return {
      month: 0,
      year: 0,
      monthString: '',
      start: Date,
      end: Date,
      inputingDates: false,
      showButtons: true,
      options: [],
      listMonth: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
    };
  },


  methods: {
    formatValue: function formatValue() {
      var v = this.$refs.valor.value;
      this.$refs.valor.value = Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["formatValue"])(this.$strToFloat(v, this.precision), this.precision);
      this.focused = false;
    },

    handleMesAtual: function handleMesAtual(data) {
      var today = new Date();
      if (data) today = this.$strToDate(data);

      this.year = Number(today.getFullYear());
      this.month = today.getMonth();
      this.monthString = this.listMonth[this.month] + '/' + this.year;

      var m = this.month + 1;
      this.end = this.$lastDay(this.year + '-' + m + '-01');
      this.start = this.$firstDay(this.year + '-' + m + '-01');
      this.pMonth.startDate = this.start;
      this.pMonth.endDate = this.end;
      this.inputingDates = false;
      this.showButtons = true;
    },
    handlePeriodo: function handlePeriodo() {
      this.monthString = Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["formatDate"])(this.start) + ' - ' + Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["formatDate"])(this.end);
      this.pMonth.startDate = this.start;
      this.pMonth.endDate = this.end;
      this.inputingDates = false;
      this.showButtons = false;
    },
    clickAction: function clickAction(action) {
      //hoje
      if (action == 1) {
        var data = new Date();
        var dia = String(data.getDate()).padStart(2, '0');
        var mes = String(data.getMonth() + 1).padStart(2, '0');
        var ano = data.getFullYear();
        var dataAtual = ano + '-' + mes + '-' + dia;

        this.start = dataAtual;
        this.end = dataAtual;
        this.monthString = Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["formatDate"])(dataAtual);
      }

      //mes atual
      if (action == 2) {
        this.handleMesAtual();
      }

      //semana atual
      if (action == 3) {
        this.showButtons = false;
        this.inputingDates = false;
        this.start = this.$getDate();
        this.end = this.$addDays(this.$getDate(), 7);
        this.monthString = Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["formatDate"])(this.start) + ' - ' + Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["formatDate"])(this.end);
      }

      //ultimos 30 dias
      if (action == 4) {
        this.showButtons = false;
        this.inputingDates = false;
        this.start = this.$addDays(this.$getDate(), -30);
        this.end = this.$addDays(this.$getDate(), -1);
        this.monthString = Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["formatDate"])(this.start) + ' - ' + Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["formatDate"])(this.end);
      }

      //mes específico
      if (action == 5) {
        this.inputingDates = true;

        this.$nextTick(function () {
          this.$refs.start.focus();
        });
      }

      //intervalo de datas
      if (action == 6) {
        this.inputingDates = true;

        this.$nextTick(function () {
          this.$refs.start.focus();
        });
      }

      this.pMonth.startDate = this.start;
      this.pMonth.endDate = this.end;
      this.$emit('monthChange', this.start, this.end);
    },
    clickProximoMes: function clickProximoMes() {
      if (this.month == 11) {
        this.year++;
        this.month = 0;
      } else {
        this.month++;
      }
      this.monthString = this.listMonth[this.month] + '/' + this.year;
      var m = this.month + 1;
      this.end = this.$lastDay(this.year + '-' + m + '-01');
      this.start = this.$firstDay(this.year + '-' + m + '-01');
      this.pMonth.startDate = this.start;
      this.pMonth.endDate = this.end;
      this.$emit('monthChange', this.start, this.end);
    },
    clickMesAnterior: function clickMesAnterior() {
      if (this.month == 0) {
        this.year--;
        this.month = 11;
      } else {
        this.month--;
      }
      this.monthString = this.listMonth[this.month] + '/' + this.year;
      var m = this.month + 1;
      this.end = this.$lastDay(this.year + '-' + m + '-01');
      this.start = this.$firstDay(this.year + '-' + m + '-01');
      this.pMonth.startDate = this.start;
      this.pMonth.endDate = this.end;
      this.$emit('monthChange', this.start, this.end);
    }
  },

  created: function created() {
    if (!this.pMonth.startDate) this.handleMesAtual();else {
      console.log(this.pMonth);
      this.handleMesAtual(this.pMonth.startDate);
    }

    if (this.showOptions) {
      var act = {};
      act = { action: 1, label: 'Hoje' };
      this.options.push(act);
      act = { action: 2, label: 'Este Mês' };
      this.options.push(act);
      act = { action: 3, label: 'Esta Semana' };
      this.options.push(act);
      act = { action: 4, label: 'Últimos 30 Dias' };
      this.options.push(act);
      act = { action: 5, label: 'Mês Específico' };
      this.options.push(act);
      act = { action: 6, label: 'Período Específico' };
      this.options.push(act);
    }
  }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_month2_vue__ = __webpack_require__(423);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_401a9334_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_month2_vue__ = __webpack_require__(1163);
function injectStyle (ssrContext) {
  __webpack_require__(1161)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-401a9334"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_month2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_401a9334_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_month2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_utils__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    pMonth: { type: Object },
    showOptions: { type: Boolean }
  },

  data: function data() {
    return {
      month: 0,
      year: 0,
      label: '',
      start: Date,
      end: Date,
      inputingDates: false,
      showButtons: true,
      options: [],
      listMonth: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],

      unWatch: false
    };
  },
  mounted: function mounted() {},


  methods: {
    formatValue: function formatValue() {
      var v = this.$refs.valor.value;
      this.$refs.valor.value = Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["formatValue"])(this.$strToFloat(v, this.precision), this.precision);
      this.focused = false;
    },

    handleMesAtual: function handleMesAtual() {
      var today = new Date();
      this.year = Number(today.getFullYear());
      this.month = today.getMonth();
      this.label = this.listMonth[this.month] + '/' + this.year;
      var m = this.month + 1;
      this.start = this.$firstDay(this.year + '-' + m + '-01');
      this.end = this.$lastDay(this.year + '-' + m + '-01');
      this.pMonth.startDate = this.start;
      this.pMonth.endDate = this.end;
      this.inputingDates = false;
      this.showButtons = true;
    },
    handlePeriodo: function handlePeriodo() {
      this.label = 'Período específico';
      this.inputingDates = false;
      this.showButtons = false;
    },
    clickAction: function clickAction(action) {
      if (action == 1) {
        //mes atual
        this.handleMesAtual();
      } else if (action == 2) {
        //semana atual
        this.label = 'Semana atual';
        this.start = this.$getDate();
        this.end = this.$addDays(this.$getDate(), 7);
        this.showButtons = false;
        this.inputingDates = false;
      } else if (action == 3) {
        //ultimos 30 dias
        this.start = this.$addDays(this.$getDate(), -30);
        this.end = this.$getDate();
        this.showButtons = false;
        this.inputingDates = false;
        this.label = 'Últimos 30 dias';
      } else if (action == 4) {
        //Este ano
        var today = new Date();
        this.year = Number(today.getFullYear());
        this.start = this.$firstDay(this.year + '-01' + '-01');
        this.end = this.$lastDay(this.year + '-12' + '-31');
        this.showButtons = false;
        this.inputingDates = false;
        this.label = 'Este Ano';
      } else if (action == 5) {
        this.inputingDates = true;
        this.label = 'Período específico';
        this.$nextTick(function () {
          this.$refs.start.focus();
        });
      } else if (action == 8) {
        //ultimos 6 meses
        var _today = new Date();
        _today.setMonth(_today.getMonth() - 6);
        this.month = _today.getMonth() + 1;
        this.start = this.$firstDay(_today.getFullYear() + '-' + this.month + '-01');
        this.end = this.$getDate();
        this.showButtons = false;
        this.inputingDates = false;
        this.label = 'Últimos 6 meses';
      } else if (action == 9) {
        //ultimos 12 meses
        var _today2 = new Date();
        _today2.setMonth(_today2.getMonth() - 12);
        this.month = _today2.getMonth() + 1;
        this.start = this.$firstDay(_today2.getFullYear() + '-' + this.month + '-01');
        this.end = this.$getDate();
        this.showButtons = false;
        this.inputingDates = false;
        this.label = 'Últimos 12 meses';
      }
      this.updatePeriodo();
    },
    clickProximoMes: function clickProximoMes() {
      this.unWatch = true;
      if (!this.month) {
        var today = new Date();
        this.month = today.getMonth();
        this.year = today.getFullYear();
      }
      if (this.month == 11) {
        this.year++;
        this.month = 0;
      } else {
        this.month++;
      }
      this.label = this.listMonth[this.month] + '/' + this.year;
      var m = this.month + 1;
      this.start = this.$firstDay(this.year + '-' + m + '-01');
      this.end = this.$lastDay(this.year + '-' + m + '-01');
      this.updatePeriodo();
    },
    clickMesAnterior: function clickMesAnterior() {
      this.unWatch = true;
      if (!this.month) {
        var today = new Date();
        this.month = today.getMonth();
        this.year = today.getFullYear();
      }
      if (this.month == 0) {
        this.year--;
        this.month = 11;
      } else {
        this.month--;
      }
      this.label = this.listMonth[this.month] + '/' + this.year;
      var m = this.month + 1;
      this.start = this.$firstDay(this.year + '-' + m + '-01');
      this.end = this.$lastDay(this.year + '-' + m + '-01');
      this.updatePeriodo();
    },
    updatePeriodo: function updatePeriodo() {
      this.pMonth.startDate = this.start;
      this.pMonth.endDate = this.end;
      this.$emit('change', this.start, this.end);
    }
  },

  watch: {

    end: function end() {
      if (this.pMonth.endDate != this.end) {
        this.label = 'Período específico';
        this.updatePeriodo();
      }
    },

    start: function start() {
      if (this.pMonth.startDate != this.start) {
        this.label = 'Período específico';
        this.updatePeriodo();
      }
    }

  },

  created: function created() {

    if (!this.pMonth.startDate) {
      this.start = null;
      this.end = null;
      this.pMonth.startDate = this.start;
      this.pMonth.endDate = this.end;
      //this.handleMesAtual()
    } else {
      this.start = this.pMonth.startDate;
      this.end = this.pMonth.endDate;

      if (this.start) {
        var today = new Date(this.start + 'T00:00:00');
        this.year = Number(today.getFullYear());
        this.month = today.getMonth();
      }
    }

    //if (this.showOptions) {
    var act = {};
    act = { action: 1, label: 'Este Mês' };
    this.options.push(act);
    act = { action: 2, label: 'Esta Semana' };
    this.options.push(act);
    act = { action: 3, label: 'Últimos 30 dias' };
    this.options.push(act);
    act = { action: 7, label: 'Últimos 3 meses' };
    this.options.push(act);
    act = { action: 8, label: 'Últimos 6 meses' };
    this.options.push(act);
    act = { action: 9, label: 'Últimos 12 meses' };
    this.options.push(act);
    act = { action: 4, label: 'Este ano' };
    this.options.push(act);
    act = { action: 6, label: 'Ano Anterior' };
    this.options.push(act);
    act = { action: 5, label: 'Período Específico' };
    this.options.push(act);
    //}
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: { Number: Number, String: String },
    max: {
      type: Number, default: Number.MAX_SAFE_INTEGER || 9007199254740991, required: false
    },
    min: {
      type: Number, default: Number.MIN_SAFE_INTEGER || -9007199254740991, required: false
    },
    minus: {
      type: Boolean, default: false, required: false
    }
  },

  data: function data() {
    return {
      valor: this.value,
      focused: false
    };
  },
  mounted: function mounted() {
    //this.formatValue()
  },
  created: function created() {},


  methods: {

    updateValue: function updateValue(value) {
      //emite somente valores numericos validos
      var v = this.$refs.valor.value;
      v = v.replace(/\D/g, "");
      v = this.$strToFloat(v, 0);
      this.$emit('input', v);
    },

    selectAll: function selectAll(event) {
      this.focused = true;
      // Workaround for Safari bug
      // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
      setTimeout(function () {
        event.target.select();
      }, 0);
      this.$emit('focus');
    },

    formatRemove: function formatRemove() {
      var vlr = this.$refs.valor.value;
      this.$refs.valor.value = vlr.replace(/\./g, '');
    },

    formatValue: function formatValue() {
      var v = this.$refs.valor.value;
      this.$refs.valor.value = this.$strToFloat(v, 0);
      this.focused = false;
      this.$emit('blur');
    },

    focusControl: function focusControl(event) {
      event.preventDefault();
      var thisIndex = jQuery(this.$el).index(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var next = thisIndex + 1;
      var obj = jQuery(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var found = false;
      for (var x = next; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
          jQuery(obj[x]).focus();
          found = true;
          break;
        }
      }
      if (!found) {
        for (var x = 0; x < obj.length; x++) {
          if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
            jQuery(obj[x]).focus();
            found = true;
            break;
          }
        }
      }

      this.$emit('keyenter');
    },

    focus: function focus() {
      if (this.$refs.valor) {
        this.$refs.valor.focus();
      }
    }

  },
  watch: {
    value: function value(_value) {
      // if (!this.focused) {
      //   this.$refs.valor.value = String(value).replace('.', ',')
      // }
      this.$refs.valor.value = String(_value).replace('.', ',');
    }
  }

});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_customer_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_customer_painel_form__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_cpf__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_cpf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_cpf__);
var _methods;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {},
    disabled: Boolean,
    addButton: Boolean,
    varejo: Boolean,
    vErrors: {},
    name: { type: String },
    participante: { type: Boolean },
    showMsgEmail: {
      type: Boolean,
      default: true
    },
    seqcontato: { type: [Number, String] }
  },

  data: function data() {
    return {
      textSearch: "",
      inicio: true,
      showList: false,
      notFound: false,
      originalTop: 0,
      myDropDown: "",
      showPartForm: false,
      showPartForcaVendas: false,
      showSituacao: false,

      saldoLimiteCredito: null,

      isChoosing: true,

      selectedIndex: 0,
      selected: {},

      codpart: null,
      crud: "",

      offset: false,

      selectedContato: null
    };
  },


  computed: {
    isForcaVendas: function isForcaVendas() {
      return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appForcaVendas || __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].usuarioForcaVendas;
    },

    nextPage: function nextPage() {
      return this.$store.getters.getNextPage;
    },

    clienteList: function clienteList() {
      return this.$store.getters.getPartList;
    },

    metadata: function metadata() {
      return this.$store.getters.getEntities.metadata;
    },

    emailDanfe: function emailDanfe() {
      if (this.participante && this.showMsgEmail && this.selected.emaildanfe) {
        return "A NF-e autorizada será enviada para " + this.selected.emaildanfe;
      } else return null;
    },

    partExists: function partExists() {
      return !!this.$store.getters.getEntities.part;
    }
  },

  filters: {},

  methods: (_methods = {
    handleWhatsapp: function handleWhatsapp(fone) {
      window.open("https://wa.me/55" + fone + "?text=", "_blank");
    },
    handleEsc: function handleEsc() {
      if (!this.showList && this.selected.nome) {
        this.isChoosing = false;
        this.codpart = this.selected.codpart;
        this.$emit("input", this.selected.codpart);
        this.$emit("change", this.selected);
      } else {
        this.showList = false;
        this.notFound = false;
        this.textSearch = "";
        this.$refs.pesquisa.focus();
      }
    },
    closePartForm: function closePartForm(id) {
      //ao fechar o formulario de inclusao de clientes
      this.showPartForm = false;
      this.showPartForcaVendas = false;
      if (id) {
        this.loadData(id);
      }
      if (this.isChoosing) {
        this.focus();
      }
    },
    closeSituacaoForm: function closeSituacaoForm() {
      //ao fechar o formulario de inclusao de clientes
      this.showSituacao = false;
    }
  }, _defineProperty(_methods, "closeSituacaoForm", function closeSituacaoForm() {
    //ao fechar o formulario de inclusao de clientes
    this.showSituacao = false;
  }), _defineProperty(_methods, "handleIncluirCliente", function handleIncluirCliente() {
    //EXIBE A TELA DE INCLUSAO
    if (this.disabled) {
      return;
    }
    this.crud = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI;
    if (this.isForcaVendas) this.showPartForcaVendas = true;else this.showPartForm = true;
  }), _defineProperty(_methods, "handleAlterarCliente", function handleAlterarCliente() {
    //EXIBE A TELA DE INCLUSAO
    this.crud = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudU;
    this.codpart = this.selected.codpart;
    this.showPartForm = true;
  }), _defineProperty(_methods, "handleSituacao", function handleSituacao() {
    this.showSituacao = true;
  }), _defineProperty(_methods, "handleKeyDown", function handleKeyDown() {
    //TECLA PARA BAIXO
    if (this.clienteList.length > 0) {
      if (this.selectedIndex > this.clienteList.length) {
        this.selectedIndex = 0;
      } else {
        this.selectedIndex = this.selectedIndex + 1;
      }
    }
  }), _defineProperty(_methods, "handleKeyUp", function handleKeyUp() {
    //TECLA PARA CIMA
    if (this.clienteList.length > 0) {
      if (this.selectedIndex < 1) {
        this.selectedIndex = this.clienteList.length - 1;
      } else {
        this.selectedIndex = this.selectedIndex - 1;
      }
    }
  }), _defineProperty(_methods, "focus", function focus() {
    this.$refs.pesquisa.focus();
  }), _defineProperty(_methods, "closeForm", function closeForm() {
    this.$emit("closeform");
  }), _defineProperty(_methods, "handleBlur", function handleBlur() {
    if (this.varejo) {
      this.textSearch = this.textSearch.toUpperCase();
      if (__WEBPACK_IMPORTED_MODULE_4__shared_cpf___default()(this.textSearch)) {
        // this.$emit('input', this.textSearch)
        this.handleSelect();
      }
    }
    // this.showList = false
  }), _defineProperty(_methods, "handleChange", function handleChange() {
    // if (!this.textSearch) {
    //     this.showList = false
    //     return
    // }
  }), _defineProperty(_methods, "handleTrocar", function handleTrocar() {
    this.isChoosing = true;
    this.textSearch = "";
    this.showList = false;
    this.notFound = false;
    this.codpart = null;
    this.$emit("input", null);
    this.$emit("change", null);
    this.$nextTick(function () {
      this.focus();
    });
  }), _defineProperty(_methods, "handleNewCostumer", function handleNewCostumer() {
    if (this.varejo && this.selected) {
      this.showList = false;
      this.isChoosing = false;
      this.codpart = this.selected.codpart;
      this.$emit("input", this.selected.codpart);
      this.$emit("change", this.selected);
      this.focusControl();
    }
  }), _defineProperty(_methods, "handleSelect", function handleSelect(index) {
    //AO SELECIONAR UM ITEM
    if (index) {
      this.selectedIndex = index;
    }
    if (this.clienteList.length > 0 && this.textSearch) {
      this.selected = this.clienteList[this.selectedIndex];
      this.showList = false;
      this.isChoosing = false;
      this.codpart = this.selected.codpart;
      this.$emit("input", this.selected.codpart);
      this.$emit("change", this.selected);
      this.focusControl();
    } else {
      if (this.varejo && this.textSearch) {
        this.textSearch = this.textSearch.toUpperCase();
        if (__WEBPACK_IMPORTED_MODULE_4__shared_cpf___default()(this.textSearch)) {
          var part = _extends({}, this.$store.getters.getEntities.part);
          part.codpart = null;
          part.cnpjcpf = this.textSearch;
          part.nome = "CONSUMIDOR FINAL";
          this.selected = part;
          this.showList = false;
          this.isChoosing = false;
          this.codpart = this.selected.codpart;
          this.$emit("input", this.textSearch);
          this.$emit("change", this.selected);
          this.focusControl();
        } else {
          this.$erpToastError("CPF inválido");
        }
      } else {
        this.$erpToastError("Insira o cliente");
      }
    }
  }), _defineProperty(_methods, "search", function search() {
    this.inicio = false;

    if (!this.textSearch) {
      this.notFound = false;
      this.showList = false;
      return;
    }

    var term = this.textSearch.toUpperCase();
    // Se o termo parece um CNPJ formatado (contém simbolos e tem tamanho exato de 18 caracteres)
    // removemos a formatação para a pesquisa ser efetiva no banco (alfanumérico puro)
    if (term.length == 18 && (term.indexOf('.') >= 0 || term.indexOf('/') >= 0 || term.indexOf('-') >= 0)) {
      term = term.replace(/[^A-Z0-9]/g, '');
    }

    this.filter = '{"nome":{"$or":[{"$like":"%25' + term + '%25"},{"fantasia":{"$like":"%25' + term + '%25"}},{"cnpjcpf":{"$eq":"' + term + '"}},{"codpart":{"$eq":"' + term + '"}}]}}';

    this.loadData();
  }), _defineProperty(_methods, "loadData", function loadData(id) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var params;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                filter: _this.filter,
                id: id,
                forcaVendas: _this.isForcaVendas,
                participante: _this.participante
              };

              if (_this.offset) {
                params.offset = _this.nextPage;
                _this.offset = false;
              }
              if (id) params.filter = "";
              _context.next = 5;
              return _this.$store.dispatch("loadCliente", params);

            case 5:
              _this.selectedIndex = 0;
              if (id && _this.$store.getters.getPart.length > 0) {
                _this.selected = _this.$store.getters.getPart[0];
                _this.isChoosing = false;
                _this.calculaLimiteCredito();
              }
              _this.loadContato();

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }), _defineProperty(_methods, "calculaLimiteCredito", function calculaLimiteCredito() {
    // CALCULA O SALDO DE LIMITE DE CREDITO AO SELECIONAR UM CLIENTE
    if (this.selected.limcred && this.selected.limcred > 0) {
      this.saldoLimiteCredito = this.$strToFloat(this.selected.limcred, 2) - this.$strToFloat(this.selected.saldo_pedidos, 2) - this.$strToFloat(this.selected.saldo_titulos_vencer, 2) - this.$strToFloat(this.selected.saldo_titulos_vencido, 2);
      //this.saldoLimiteCredito = this.selected.limcred - this.saldo_pedidos - this.saldo_titulos_vencido - this.saldo_titulos_vencer
    } else this.saldoLimiteCredito = null;
  }), _defineProperty(_methods, "focusControl", function focusControl(event) {
    var thisIndex = jQuery(this.$el.querySelector("input")).index(__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].sFocusControl);
    var next = thisIndex + 1;
    var obj = jQuery(__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].sFocusControl);
    for (var x = next; x < obj.length; x++) {
      if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled")) {
        jQuery(obj[x]).focus();
        break;
      }
    }
  }), _defineProperty(_methods, "handleMore", function handleMore() {
    this.offset = true;
    this.loadData();
  }), _defineProperty(_methods, "loadContato", function loadContato() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.selectedContato = null;

              if (!(!_this2.selected || !_this2.selected.codpart || !_this2.seqcontato)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              _context2.next = 5;
              return _this2.$store.dispatch("loadPartcontato", {
                codpart: _this2.selected.codpart,
                id: _this2.seqcontato
              });

            case 5:
              console.log(_this2.$store.getters.getPartContato);
              if (_this2.$store.getters.getPartContato) _this2.selectedContato = _this2.$store.getters.getPartContato[0];

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }), _methods),

  watch: {
    seqcontato: function seqcontato() {
      this.loadContato();
    },

    textSearch: function textSearch() {
      var vm = this;
      if (this.keytimer) {
        clearTimeout(this.keytimer);
      }
      this.keytimer = setTimeout(function () {
        console.log("watch textSearch", vm.textSearch);
        vm.search();
      }, 300);
    },

    value: function value() {
      if (this.value != this.codpart) {
        this.loadData(this.value);
        this.loadContato();
      }
    },

    clienteList: function clienteList() {
      if (this.inicio || !this.textSearch) {
        this.showList = false;
        return;
      }
      if (!this.clienteList.length || this.clienteList.length == 0) {
        this.notFound = true;
        this.showList = false;
      } else {
        this.notFound = false;
        this.showList = true;
      }
    }
  },

  components: {
    Trap: __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default.a,
    CustomerForm: __WEBPACK_IMPORTED_MODULE_2__forms_customer_form__["default"],
    CustomerPainelForm: __WEBPACK_IMPORTED_MODULE_3__forms_customer_painel_form__["default"]
  },

  created: function created() {
    this.$nextTick(function () {
      //const rect = this.$refs.pesquisa.getBoundingClientRect();
      //this.myDropDown = 'top: ' + rect.top + 'px; left: ' + rect.left + 'px;'
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
  },
  mounted: function mounted() {
    if (this.value) {
      this.loadData(this.value);
    }
    this.originalTop = this.$el.getBoundingClientRect().top;
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__grucli_form__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__grufor_form__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__natfin_form__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vend_form__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ramoat_form__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tourguidejs__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tourguidejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_tourguidejs__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: "",
    crud: "",
    varejo: Boolean,
    forcaVendas: Boolean,
    crm: Boolean,
    transportadora: Boolean,
    customerValidate: {},
    receivedData: null
  },

  data: function data() {
    return {
      crudText: "",

      metadata: this.$store.getters.getEntities.metadata,
      part: _extends({}, this.$store.getters.getEntities.part),
      partcontato: [],

      showMessage: false,
      message: "",
      isView: false,
      disableSave: false,
      changed: false,
      duplicado: false,

      showGrucliForm: false,
      showGruforForm: false,
      showRamoForm: false,
      showVendForm: false,

      showInfCredito: false,
      showInfUsuario: false,
      showInfCob: false,
      errorsContact: false,
      // campoteste: [],

      partOptions: [{ id: "C", text: "Cliente" }, { id: "F", text: "Fornecedor" }, { id: "T", text: "Transportadora" }],

      nfeValidations: [],
      passNfeValidate: true,

      hasManyCustomers: false,
      steps: [{
        "selector": "",
        "step": 1,
        "title": "Vamos come\xE7ar!",
        "content": "Vamos te guiar passo a passo por todo o processo de cadastro de cliente.</br></br><a href='javascript:void(0)' class='btn btn-sm btn-danger text-white' onclick='window.dispatchEvent(new CustomEvent(\"desativar-guia\"))'>Não mostrar este guia</a>"
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#cnpjcpf",
        "step": 2,
        "title": "CNPJ",
        "content": "Informe o CNPJ do cliente."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#nome",
        "step": 3,
        "title": "Nome",
        "content": "Informe o Nome do cliente."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#fantasia",
        "step": 4,
        "title": "Nome Fantasia",
        "content": "Informe o Nome Fantasia do cliente."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#contricms",
        "step": 5,
        "title": "O cliente \xE9 Contribuinte de ICMS",
        "content": "Informe se o cliente é contribuinte de ICMS."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#cep",
        "step": 6,
        "title": "CEP do Endere\xE7o",
        "content": "Informe o CEP do endereço do cliente."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#endenr",
        "step": 7,
        "title": "Numero do Endere\xE7o",
        "content": "Informe o Nr. do endereço do cliente."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#email",
        "step": 7,
        "title": "E-mail de contato",
        "content": "Informe o e-mail de contato do cliente."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#fone1",
        "step": 7,
        "title": "Telefone de contato",
        "content": "Informe o telefone de contato do cliente."
        // "image": "https://somehost.com/image.jpeg"
      }]

    };
  },


  computed: {
    administrador: function administrador() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador;
    },

    loja_b2b: function loja_b2b() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].loja_b2b;
    },

    novoRegistro: function novoRegistro() {
      return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI || this.$route.params.id == "novo";
    },

    localCrud: function localCrud() {
      if (this.$route.params.id == "novo") return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI;else return this.crud;
    },

    showPreencherCadastro: function showPreencherCadastro() {
      return this.part.tppessoa == "J" && this.part.cnpjcpf && this.part.cnpjcpf.length == 14;
    },

    formatoTela: function formatoTela() {
      if (this.transportadora) return "transportadora";else if (this.varejo) {
        return "varejo";
      } else if (this.forcaVendas || this.crm || this.pedido) {
        return "forcavendas";
      } else {
        return "normal";
      }
    },

    validationHandler: function validationHandler() {
      return this.errors.items.length;
    },

    cnpjcpf: function cnpjcpf() {
      return this.part.cnpjcpf;
    },

    tppessoa: function tppessoa() {
      return this.part.tppessoa;
    },
    appNFe: function appNFe() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appNFe;
    },
    appERP: function appERP() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appERP;
    },
    usaIntegracao: function usaIntegracao() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usaIntegracao;
    },
    showGuia: function showGuia() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].guia;
    }

  },

  watch: {
    validationHandler: function validationHandler() {
      this.disableSave = this.errors.items.length > 0; //habilita e desabilita botao salvar
    },

    tppessoa: function tppessoa(oldvalue, newvalue) {
      if (oldvalue != newvalue) {
        this.pesquisaCNPJ();
      }
    },

    cnpjcpf: function cnpjcpf(oldvalue, newvalue) {
      if (oldvalue != newvalue) {
        this.pesquisaCNPJ();
      }
    },

    'part.codusuario': {
      handler: function handler(val) {
        if (val) {
          this.showInfUsuario = true;
        }
      },

      immediate: true
    },

    part: {
      handler: function handler() {
        this.changed = true;

        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip();
        });
      },

      deep: true
    }
  },

  methods: {
    focusControl: function focusControl(event) {
      event.preventDefault();
      var thisIndex = jQuery(event.target).index(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var next = thisIndex + 1;
      var obj = jQuery(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      for (var x = next; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["hasHiddenParent"])(obj[x])) {
          jQuery(obj[x]).focus();
          return;
        }
      }
      for (var x = 0; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["hasHiddenParent"])(obj[x])) {
          jQuery(obj[x]).focus();
          return;
        }
      }
    },

    nfeValidateContinueAnyway: function nfeValidateContinueAnyway() {
      this.passNfeValidate = false;
      this.handleSave();
    },
    nfeValidate: function nfeValidate() {
      this.nfeValidations = [];
      if (!this.passNfeValidate) return;

      if (this.usaIntegracao || this.appERP || this.appNFe) {
        if (this.part.tppessoa == "J" && !this.part.cnpjcpf && this.part.cnpjcpf.length < 14) {
          this.nfeValidations.push("CNPJ é inválido.");
        }
        if (!this.part.cep || this.part.cep.length != 8) {
          this.nfeValidations.push("CEP inválido.");
        }
        if (!this.part.ende) {
          this.nfeValidations.push("Endereço não informado.");
        }
        if (!this.part.endenr) {
          this.nfeValidations.push("Número do Endereço não informado.");
        }
        if (!this.part.codmun) {
          this.nfeValidations.push("Município não informado.");
        }
      }
    },
    handlePreencherCadastro: function handlePreencherCadastro() {
      if (!this.cnpjcpf) {
        this.$erpToastError("Preencha o CNPJ e o estado do cliente");
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiConsultaCadastro"])(this, this.cnpjcpf, this.part.uf, this.updateDadosCadastrais);
    },
    updateDadosCadastrais: function updateDadosCadastrais(dados) {
      this.part.nome = (dados.nome || "").substr(0, 100);
      this.part.fantasia = (dados.fantasia || dados.nome || "").substr(0, 100);
      this.part.cnae = dados.cnae;
      this.part.iest = dados.ie;

      if (dados.ie && dados.ie != "ISENTO") {
        this.part.contricms = "S";
      } else if (dados.ie == "ISENTO") {
        this.part.contricms = "I";
      } else {
        this.part.contricms = "N";
      }

      this.part.ende = (dados.endereco || "").substr(0, 100);
      this.part.endenr = dados.nr;
      this.part.endecompl = dados.complemento;
      this.part.mun = dados.mun;
      this.part.codmun = dados.cMun;
      this.part.bairro = dados.bairro;
      this.part.uf = dados.uf;
      this.part.cep = dados.cep;
    },
    closeForm: function closeForm() {
      if (this.$route.params && this.$route.params.id == "novo") this.$router.go(-1);else this.$emit("closeform", this.part.codpart);
    },
    handleAction: function handleAction(act) {
      if (act == 0) {
        //importação de cadastro de clientes
        this.$router.push("/importa/clientes");
      }
    },
    handleCloseForm: function handleCloseForm() {
      this.closeForm();
      // if (this.changed) {                     // se ocorreu alguma alteração exibe mensagem antes de fechar
      //     this.showMessageModal('closeform')
      // } else {
      //     this.closeForm()
      // }
    },
    handleIncluir: function handleIncluir(pTipo) {
      //exibe tela de cadastro
      if (this.isView) {
        return;
      }

      if (pTipo === "vend") {
        this.showVendForm = true;
      }

      if (pTipo === "grucli") {
        this.showGrucliForm = true;
      }

      if (pTipo === "grufor") {
        this.showGruforForm = true;
      }

      if (pTipo === "ramoat") {
        this.showRamoForm = true;
      }
    },
    closeGrucliForm: function closeGrucliForm(id) {
      if (id) this.part.codgrucli = id;
      this.showGrucliForm = false;
    },
    closeVendForm: function closeVendForm(id) {
      if (id) this.part.codvendr = id;
      this.showVendForm = false;
    },
    closeGruforForm: function closeGruforForm(id) {
      if (id) this.part.codgrufor = id;
      this.showGruforForm = false;
    },
    closeRamoForm: function closeRamoForm(id) {
      if (id) this.part.codramo = id;
      this.showRamoForm = false;
    },
    handleConfirmMessage: function handleConfirmMessage() {
      //EVENTO DO BOTAO "CONFIRMAR" DA MENSAGEM
      if (this.codeMessage == "closeform") {
        //fecha o formulario e retornar para o anterior
        this.closeMessage();
        this.closeForm();
      }
    },
    showMessageModal: function showMessageModal(code) {
      //exibe uma mensagem em "code"
      this.codeMessage = code;
      this.showMessage = true;
    },
    closeMessage: function closeMessage() {
      this.showMessage = false;
    },
    handleAddContact: function handleAddContact() {
      //BOTAO PARA ADICIONAR NOVO CONTATO
      var cont = _extends({}, this.$store.getters.getEntities.partcontato);
      this.partcontato.push(cont);
    },
    handleDeleteContact: function handleDeleteContact(index) {
      if (this.part.partcontatoseq == index + 1) {
        this.part.partcontatoseq = null;
      }
      this.partcontato.splice(index, 1);
    },
    handlePrefContact: function handlePrefContact(index) {
      this.part.partcontatoseq = index + 1;
    },
    updateCep: function updateCep() {
      //CARREGA INFORMACOES DO CEP DIGITADO
      this.part.ende = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.logradouro;
      this.part.bairro = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.bairro;
      this.part.codmun = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.ibge;
      this.part.uf = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.uf;
      this.part.codpais = "1058";
    },
    updateCepCob: function updateCepCob() {
      //CARREGA INFORMACOES DO CEP DIGITADO
      this.part.endecob = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.logradouro;
      this.part.bairrocob = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.bairro;
      this.part.codmuncob = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.ibge;
      this.part.ufcob = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.uf;
      this.part.codpaiscob = "1058";
    },
    loadData: function loadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var x;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("loadPart", { id: _this.index });

              case 2:
                if (_this.$store.getters.getPart) {
                  _this.part = _extends({}, _this.$store.getters.getPart[0]);
                  _this.partcontato = [];
                  if (_this.$store.getters.getPart[0].partcontato.length) {
                    for (x = 0; x < _this.$store.getters.getPart[0].partcontato.length; x++) {
                      _this.partcontato.push(_this.$store.getters.getPart[0].partcontato[x]);
                    }
                  }
                }
                _this.changed = false;
                if (_this.partcontato.length < 1 && !_this.varejo) {
                  _this.handleAddContact();
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    pesquisaCNPJ: function pesquisaCNPJ() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var x;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                //checa se já existe participante cadastrado com o cnpj/cpf informado

                _this2.duplicado = false;

                if (!(_this2.part.tppessoa == null || _this2.part.cnpjcpf == null)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                if (!(_this2.part.tppessoa == "F" && _this2.part.cnpjcpf.length < 11)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                if (!(_this2.part.tppessoa == "J" && _this2.part.cnpjcpf.length < 14)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return");

              case 7:
                _context2.next = 9;
                return _this2.$store.dispatch("loadPartDoc", {
                  tppessoa: _this2.part.tppessoa,
                  cnpjcpf: _this2.part.cnpjcpf
                });

              case 9:
                if (!(_this2.$store.getters.getPart && _this2.$store.getters.getPart.length > 0)) {
                  _context2.next = 22;
                  break;
                }

                //sendo inclusao já carrega o participante encontrado para a tela
                _this2.duplicado = true;

                if (!_this2.novoRegistro) {
                  _context2.next = 18;
                  break;
                }

                _this2.duplicado = false;
                _this2.part = _extends({}, _this2.$store.getters.getPart[0]);

                _this2.partcontato = [];
                if (_this2.$store.getters.getPart[0].partcontato.length) {
                  for (x = 0; x < _this2.$store.getters.getPart[0].partcontato.length; x++) {
                    _this2.partcontato.push(_this2.$store.getters.getPart[0].partcontato[x]);
                  }
                }
                _context2.next = 21;
                break;

              case 18:
                if (!(_this2.$store.getters.getPart[0].codpart == _this2.part.codpart)) {
                  _context2.next = 21;
                  break;
                }

                _this2.duplicado = false;
                return _context2.abrupt("return");

              case 21:
                _this2.$erpToastError("Participante já cadastrado com o cnpj informado. Código: " + _this2.$store.getters.getPart[0].codpart);

              case 22:
                _this2.changed = false;

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    apiDelete: function apiDelete(del) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var modulo, sendData, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                //efetua a exclusao do participante

                modulo = "cg/part/" + _this3.part.codpart;
                sendData = {};
                _context3.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

              case 4:
                data = _context3.sent;

                _this3.$erpToastSuccess("Participante excluído.");
                _this3.closeForm();
                // this.errmessages = data.validation

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleSave: function handleSave() {
      var _this4 = this;

      //BOTAO SALVAR
      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this4.errorsContact = true;
          _this4.$erpToastError("Por favor, corrija os campos em destaque para continuar");
        } else {
          _this4.handleValidationForm();
        }
      });
    },
    handleValidationForm: function handleValidationForm() {
      if (this.duplicado) {
        this.$erpToastError("Participante já cadastrado com o cnpj informado.");
        return;
      }

      if (this.part.forn != "S" && this.part.cliente != "S" && this.part.transp != "S") {
        this.$erpToastError("Informe se o participante é fornecedor, cliente ou transportadora.");
        return;
      }

      //obriga telefone no forca de vendas
      if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appForcaVendas && (!this.partcontato || this.partcontato.length == 0)) {
        this.$erpToastError("Informe um contato para o cliente.");
        return;
      }

      if (this.partcontato) {
        var nullRequiredFields = this.partcontato.find(function (part) {
          return !part.fone1 || !part.email;
        });

        if (nullRequiredFields && this.partcontato.length > 0) {
          this.$erpToastError("Informe o telefone ou e-mail do contato.");
        } else {
          if (!this.varejo) {
            this.nfeValidate();
            if (this.nfeValidations.length > 0) return;
          }
          this.apiPost();
        }
      }
    },
    apiPost: function apiPost() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var modulo, sendData, metodo, update, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // console.log(this.part)
                //efetua a gravacao do participante
                _this5.passNfeValidate = true;

                modulo = "cg/part/";
                sendData = {};


                _this5.part.partcontato = _this5.partcontato;
                sendData = { part: _this5.part };

                metodo = "post";
                update = false;

                if (_this5.part.codpart != null) {
                  metodo = "put";
                  update = true;
                }

                _context4.next = 10;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this5.$store, modulo, sendData, metodo);

              case 10:
                data = _context4.sent;

                if (data.items) {
                  _this5.part = data.items[0];

                  _this5.$emit('sendData', _this5.part);

                  if (_this5.part.validation) {
                    _this5.errmessages = JSON.parse(_this5.part.validation);
                  } else {
                    if (update) {
                      _this5.$erpToastSuccess("Participante alterado");
                    } else {
                      _this5.$erpToastSuccess("Participante inserido");
                    }
                    console.log("cliente:", _this5.$store.getters.getEntities.part);
                    _this5.errmessages = {};
                    _this5.closeForm();
                  }
                }
                _this5.changed = false;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    }
  },

  components: {
    GruforForm: __WEBPACK_IMPORTED_MODULE_3__grufor_form__["a" /* default */],
    GrucliForm: __WEBPACK_IMPORTED_MODULE_2__grucli_form__["a" /* default */],
    VendForm: __WEBPACK_IMPORTED_MODULE_5__vend_form__["a" /* default */],
    NatfinForm: __WEBPACK_IMPORTED_MODULE_4__natfin_form__["a" /* default */],
    RamoatForm: __WEBPACK_IMPORTED_MODULE_6__ramoat_form__["a" /* default */],
    Tourguide: __WEBPACK_IMPORTED_MODULE_8_tourguidejs___default.a
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
      if (this.varejo) {
        this.$refs.nome.focus();
      } else {
        this.$refs.tppessoa.focus();
      }
    });
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var filter, params, tourguide;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this6.crudText = _this6.$crudText(_this6.localCrud);

              if (!_this6.novoRegistro) {
                _context5.next = 31;
                break;
              }

              _this6.part.cliente = "S";
              _this6.part.forn = "N";
              _this6.part.transp = "N";
              _this6.part.tppessoa = "J";
              _this6.part.tpcliente = "F";
              _this6.part.optsimples = "N";
              _this6.part.zfranca = "N";
              // this.part.contricms = 'S'
              _this6.part.stipipart = "N";
              _this6.part.stcred = "L";
              _this6.part.calcreten = "N";
              _this6.part.calcst = "S";
              _this6.part.stpart = "A";
              _this6.part.tpfrete = "0";
              _this6.part.codpais = "1058";
              _this6.part.dtcadastro = _this6.$getDate();
              if (_this6.varejo) {
                _this6.part.tppessoa = "F";
              }
              if (_this6.transportadora) {
                _this6.part.cliente = "N";
                _this6.part.transp = "S";
              }
              if (_this6.orgcrm) {
                _this6.part.nome = _this6.orgcrm.nome;
                _this6.part.fantasia = _this6.orgcrm.fantasia;
                if (_this6.orgcrm.cnpj) {
                  _this6.part.cnpjcpf = _this6.orgcrm.cnpj;
                  _this6.part.tppessoa = "J";
                }
                if (_this6.orgcrm.cpf) {
                  _this6.part.cnpjcpf = _this6.orgcrm.cpf;
                  _this6.part.tppessoa = "F";
                }
              }
              //ALTERACAO GLAMOUR priscilasouzalira@hotmail.com
              if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appForcaVendas) {
                _this6.part.tppessoa = null;
                _this6.part.uf = "SP";
              }
              if (_this6.partcontato.length < 1 && !_this6.varejo) {
                _this6.handleAddContact();
              }

              if (!_this6.showGuia) {
                _context5.next = 29;
                break;
              }

              filter = '{"nome":{"$ne":"CLIENTE PADRAO"}}';
              params = { filter: filter };
              _context5.next = 27;
              return _this6.$store.dispatch('loadPart', params);

            case 27:
              _this6.hasManyCustomers = _this6.$store.getters.getPartList.length >= 1;
              if (_this6.showGuia && !_this6.hasManyCustomers) {
                tourguide = new __WEBPACK_IMPORTED_MODULE_8_tourguidejs___default.a({
                  steps: _this6.steps
                });


                tourguide.start();
              }

            case 29:
              _context5.next = 32;
              break;

            case 31:
              _this6.loadData();

            case 32:

              //ALTERACAO GLAMOUR priscilasouzalira@hotmail.com
              if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appForcaVendas) {
                _this6.metadata.part.fantasia.validator.required = false;
                _this6.metadata.part.cep.validator.required = false;
                _this6.metadata.part.ende.validator.required = false;
                _this6.metadata.part.endenr.validator.required = false;
                _this6.metadata.part.endecomp.validator.required = false;
                _this6.metadata.part.bairro.validator.required = false;
                _this6.metadata.part.codmun.validator.required = false;
              }

            case 33:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this6);
    }))();
  }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grucli_form_vue__ = __webpack_require__(428);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_65aa8d7b_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grucli_form_vue__ = __webpack_require__(1175);
function injectStyle (ssrContext) {
  __webpack_require__(1173)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grucli_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_65aa8d7b_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grucli_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            grucli: _extends({}, this.$store.getters.getEntities.grucli),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.grucli.codgrucli);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadGrucli', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getGrucli) {
                                    _this2.grucli = _extends({}, _this2.$store.getters.getGrucli);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiPost: function apiPost() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/grucli/';
                                sendData = {};


                                sendData = { grucli: _this3.grucli };

                                metodo = 'post';
                                update = false;

                                if (_this3.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    update = true;
                                }
                                _context2.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this3.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context2.sent;

                                if (data.errmessages) {
                                    _this3.errmessages = data.errmessages;
                                    _this3.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this3.$erpToastUpdated();
                                    } else {
                                        _this3.$erpToastInserted();
                                    }
                                    _this3.errmessages = {};
                                    _this3.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.descricao.focus();
        });
    }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grufor_form_vue__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f4651b2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grufor_form_vue__ = __webpack_require__(1178);
function injectStyle (ssrContext) {
  __webpack_require__(1176)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grufor_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f4651b2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grufor_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            grufor: _extends({}, this.$store.getters.getEntities.grufor),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.grufor.codgrufor);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO Excluir
            this.apiDelete();
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadGrufor', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getGrufor) {
                                    _this2.grufor = _extends({}, _this2.$store.getters.getGrufor);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/grufor/' + _this3.grufor.codgrufor;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/grufor/';
                                sendData = {};


                                sendData = { grufor: _this4.grufor };

                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {

        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.descricao.focus();
        });
    }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_natfin_form_vue__ = __webpack_require__(432);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4dde27_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_natfin_form_vue__ = __webpack_require__(1181);
function injectStyle (ssrContext) {
  __webpack_require__(1179)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_natfin_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4dde27_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_natfin_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: '',
    crud: '',
    codNatfinPai: '',
    natfinType: ''
  },

  data: function data() {
    return {
      crudText: '',
      natfin: _extends({}, this.$store.getters.getEntities.natfin),
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
      select2Natfin: '',
      select2DRE: '',
      natfinPaiError: false,
      natfinPaiErrorMsg: ''
    };
  },


  computed: {
    editing: function editing() {
      return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
    }
  },

  methods: {
    closeForm: function closeForm() {
      this.$emit('closeform', this.natfin.codnatfin);
    },
    handleSave: function handleSave() {
      var _this = this;

      //BOTAO SALVAR

      if (this.natfinPaiError) {
        this.$erpToastError('Por favor, corrija os campos com alerta em vermelho');
        return;
      }

      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          _this.apiPost();
        }
      });
    },
    handleDelete: function handleDelete() {
      //BOTAO Excluir
      this.apiDelete();
    },
    handleInputPai: function handleInputPai() {
      var _this2 = this;

      // remove a msg de erro
      this.natfinPaiError = false;

      var self = this;
      var codnatfinpai = this.natfin.codnatfinpai ? this.natfin.codnatfinpai : '';
      var url = this.$store.getters.urlOrds + 'cg/natfin/' + codnatfinpai;

      Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDS"])(url, {}).then(function (result) {
        if (result.items && result.items.length) {

          var selectedNatfinPai = result.items[0];

          if (self.natfin.codnatfin == selectedNatfinPai.codnatfin) {
            _this2.natfinPaiError = true;
            _this2.natfinPaiErrorMsg = 'Este item não pode ter ele mesmo como sua própria natureza superior!';
            return;
          }

          if (self.natfin.haschildren) {
            if (selectedNatfinPai.nivel != 1) {
              _this2.natfinPaiErrorMsg = 'A Natureza Superior selecionada deve possuir nível 1!';
              _this2.natfinPaiError = true;
              return;
            }
          }

          if (selectedNatfinPai.nivel == 3) {
            _this2.natfinPaiErrorMsg = 'Nenhum item pode ser movido para dentro de um item de nível 3!';
            _this2.natfinPaiError = true;
            return;
          }
        }
      });
    },
    loadData: function loadData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$store.dispatch('loadNatfin', { id: _this3.index });

              case 2:
                if (_this3.$store.getters.getNatfin) {
                  _this3.natfin = _extends({}, _this3.$store.getters.getNatfin);
                }
                _this3.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    apiDelete: function apiDelete() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                //efetua a exclusao
                modulo = 'cg/natfin/' + _this4.natfin.codnatfin;
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this4.$store, modulo);

              case 3:
                data = _context2.sent;

                _this4.$erpToastDeleted();
                _this4.closeForm();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    apiPost: function apiPost() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var modulo, sendData, metodo, update, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                //efetua a gravacao

                modulo = 'cg/natfin/';
                sendData = {};


                sendData = { natfin: _this5.natfin };

                metodo = 'post';
                update = false;

                if (_this5.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                  metodo = 'put';
                  update = true;
                }

                _context3.next = 8;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this5.$store, modulo, sendData, metodo);

              case 8:
                data = _context3.sent;

                if (data.errmessages) {
                  _this5.errmessages = data.errmessages;
                  _this5.$erpToastError('Alguns erros precisam ser corrigidos.');
                } else {
                  if (update) {
                    _this5.$erpToastUpdated();
                  } else {
                    _this5.$erpToastInserted();
                  }
                  _this5.errmessages = {};
                  _this5.closeForm();
                }

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    }
  },

  components: {},

  beforeCreate: function beforeCreate() {},
  created: function created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });

    this.crudText = this.$crudText(this.crud);

    if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
      this.natfin.entradre = 'N';
      if (this.codNatfinPai) {
        this.natfin.codnatfinpai = this.codNatfinPai;
      }
    } else {
      this.loadData();
    }

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
      this.$refs.descricao.focus();
    });

    if (this.natfinType) {
      if (this.natfinType == 'R') {
        this.select2Natfin = 'natfin/receitas';
        this.select2DRE = 'dre/receitas';
      } else {
        this.select2Natfin = 'natfin/despesas';
        this.select2DRE = 'dre/despesas';
      }
      this.natfin.tpnatfin = this.natfinType;
    }
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            vend: _extends({}, this.$store.getters.getEntities.vend),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.vend.codvend);
        },
        updateCep: function updateCep() {
            //CARREGA INFORMACOES DO CEP
            this.vend.ende = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.logradouro;
            this.vend.bairro = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.bairro;
            this.vend.codmun = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.ibge;
            this.vend.uf = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.uf;
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO Excluir
            this.apiDelete();
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadVend', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getVend) {
                                    _this2.vend = _extends({}, _this2.$store.getters.getVend);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/vend/' + _this3.vend.codvend;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/vend/';
                                sendData = {};


                                sendData = { vend: _this4.vend };

                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
            this.stvend = 'A';
            this.uf = 'SP';
        } else {
            this.loadData();
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.nome.focus();
        });
    }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_ramoat_form_vue__ = __webpack_require__(435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_16efd618_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_ramoat_form_vue__ = __webpack_require__(1187);
function injectStyle (ssrContext) {
  __webpack_require__(1185)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_ramoat_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_16efd618_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_ramoat_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            ramoat: _extends({}, this.$store.getters.getEntities.ramoat),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }
    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.ramoat.codramo);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO Excluir
            this.apiDelete();
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadRamoat', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getRamoat) {
                                    _this2.ramoat = _extends({}, _this2.$store.getters.getRamoat);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/ramoat/' + _this3.ramoat.codramo;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/ramoat/';
                                sendData = {};


                                sendData = { ramoat: _this4.ramoat };

                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }
    }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_customer_painel_form_vue__ = __webpack_require__(437);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fcf8a43_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_customer_painel_form_vue__ = __webpack_require__(1191);
function injectStyle (ssrContext) {
  __webpack_require__(1189)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_customer_painel_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fcf8a43_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_customer_painel_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forms_customer_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_numbers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_numbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_numbers__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: {}, //params.codpart
        modal: { Boolean: Boolean }
    },

    components: {
        CustomerForm: __WEBPACK_IMPORTED_MODULE_1__forms_customer_form__["default"]
    },

    data: function data() {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            codpart: null,
            showPartForm: false,
            crud: __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudUpdate
        };
    },


    computed: {
        partPainel: function partPainel() {
            return this.$store.getters.getPartPainel;
        },

        appForcaVendas: function appForcaVendas() {
            return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appForcaVendas;
        }

    },

    methods: {
        closeForm: function closeForm() {
            if (this.$route.params && this.$route.params.id) {
                this.$router.go(-1);
            } else {
                this.$emit('closeform');
            }
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadPartPainel', { id: _this.codpart });

                            case 2:
                                _this.$set(_this.partPainel, 'saldo_limcred', 0);
                                _this.partPainel.saldo_limcred = _this.$strToFloat(_this.partPainel.limcred, 2) - _this.$strToFloat(_this.partPainel.saldo_pedidos, 2) - _this.$strToFloat(_this.partPainel.saldo_titulos_vencer, 2) - _this.$strToFloat(_this.partPainel.saldo_titulos_vencido, 2);
                                _this.$set(_this.partPainel, 'ticket_medio', 0);
                                _this.partPainel.ticket_medio = Object(__WEBPACK_IMPORTED_MODULE_2__shared_numbers__["arr"])(_this.partPainel.saldo_pedidos / _this.partPainel.qt_pedidos, 2);
                                _this.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        closePartForm: function closePartForm() {
            this.showPartForm = false;
            this.loadData();
        },
        handleEdit: function handleEdit() {
            this.showPartForm = true;
        },
        handleNovaVenda: function handleNovaVenda() {
            if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appForcaVendas) this.$router.push('/fv/pedidos/novo/' + this.partPainel.codpart);else this.$router.push('/pedidos/novo');
        },
        handleShowPedido: function handleShowPedido(codpedv) {
            this.$router.push('/fv/pedidos/' + codpedv);
        }
    },

    beforeCreate: function beforeCreate() {},
    created: function created() {
        console.log(this.params);
        if (this.$route.params && this.$route.params.id) {
            this.codpart = this.$route.params.id;
        } else {
            this.codpart = this.params.codpart;
        }
        this.loadData();
    }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        value: {},
        disabled: Boolean,
        addButton: Boolean,
        exibePreco: { type: Boolean, default: true },
        codtabpre: String,
        tipoitem: { type: String, default: 'P' }
    },

    data: function data() {
        return {
            textSearch: '',
            inicio: true,
            noList: false,
            showList: false,
            originalTop: 0,

            isChoosing: true,

            selectedIndex: 0,
            selected: {},

            coditem: null
        };
    },


    computed: {
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        },

        itemList: function itemList() {
            return this.$store.getters.getItemSalesList;
        },

        metadata: function metadata() {
            return this.$store.getters.getEntities.metadata;
        }

    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(value, 4);
        }
    },

    methods: {
        handleNovoItem: function handleNovoItem() {
            this.$emit('novo', this.textSearch);
        },
        handleEsc: function handleEsc() {
            if (!this.showList && this.selected.nome) {
                this.isChoosing = false;
            } else {
                this.showList = false;
                this.textSearch = '';
                this.$refs.pesquisa.focus();
            }
        },
        handleKeyDown: function handleKeyDown() {
            //TECLA PARA BAIXO
            if (this.itemList.length > 0) {
                if (this.selectedIndex > this.itemList.length) {
                    this.selectedIndex = 0;
                } else {
                    this.selectedIndex = this.selectedIndex + 1;
                }
            }
        },
        handleKeyUp: function handleKeyUp() {
            //TECLA PARA CIMA
            if (this.itemList.length > 0) {
                if (this.selectedIndex < 1) {
                    this.selectedIndex = this.itemList.length - 1;
                } else {
                    this.selectedIndex = this.selectedIndex - 1;
                }
            }
        },
        handleMore: function handleMore() {
            this.offset = true;
            this.loadData();
        },
        handleTrocar: function handleTrocar() {
            this.isChoosing = true;
            this.textSearch = '';
            this.$nextTick(function () {
                this.focus();
            });
        },
        focus: function focus() {
            this.$refs.pesquisa.focus();
        },
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleBlur: function handleBlur() {
            //this.showList = false
        },
        handleChange: function handleChange() {
            // if (!this.textSearch) {
            //     this.showList = false
            //     return
            // }
        },
        handleSelectItem: function handleSelectItem(index) {
            //AO SELECIONAR UM ITEM
            if (index) {
                this.selectedIndex = index;
            }

            if (this.itemList.length > 0) {
                this.selected = this.itemList[this.selectedIndex];
                this.coditem = this.selected.coditem;
                this.showList = false;
                this.isChoosing = false;
                this.textSearch = '';
                this.$emit('input', this.selected.coditem);
                this.$emit('onselect', this.selected);
                this.focusControl();
            }
        },
        search: function search() {
            this.inicio = false;

            if (!this.textSearch) {
                this.showList = false;
                return;
            }

            var tipo = null;
            if (this.tipoitem) {
                tipo = this.tipoitem;
            }

            var text = this.textSearch.toUpperCase();
            this.filter = '{"descricao":{"$or":[{"$like":"%25' + text + '%25"},{"codigo":{"$eq":"' + text + '"}}]} ' + (tipo ? ',"$and":[{"tipoitem":{"$eq":"' + tipo + '"}}]' : '') + ' }';

            this.loadData();
        },
        loadData: function loadData(coditem) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                params = { filter: _this.filter, coditem: coditem, codtabpre: _this.codtabpre };

                                if (_this.offset) {
                                    params.offset = _this.nextPage;
                                    _this.offset = false;
                                }
                                if (coditem) params.filter = '';

                                _context.next = 5;
                                return _this.$store.dispatch('loadItemSales', params);

                            case 5:
                                _this.selectedIndex = 0;
                                if (coditem && _this.itemList.length > 0) {
                                    _this.selected = _this.itemList[0];
                                    _this.isChoosing = false;
                                }

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },


        focusControl: function focusControl(event) {
            var thisIndex = jQuery(this.$el.querySelector('input')).index(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
            var next = thisIndex + 1;
            var obj = jQuery(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
            for (var x = next; x < obj.length; x++) {
                if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled")) {
                    jQuery(obj[x]).focus();
                    break;
                }
            }
        }

    },

    watch: {

        textSearch: function textSearch() {
            var vm = this;
            if (this.keytimer) {
                clearTimeout(this.keytimer);
            }
            this.keytimer = setTimeout(function () {
                vm.search();
            }, 300);
        },

        itemList: function itemList() {
            if (this.inicio) {
                return;
            }
            if (!this.itemList.length) {
                this.noList = true;
                this.showList = false;
            } else {
                this.noList = false;
                this.showList = true;
            }
        },

        value: function value() {
            if (this.value != this.coditem) {
                this.loadData(this.value);
            }
        }

    },

    created: function created() {
        if (this.value) {
            this.loadData(this.value);
        } else this.$store.dispatch('clearItemSales');

        this.$nextTick(function () {
            //const rect = this.$refs.pesquisa.getBoundingClientRect();
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
    },
    mounted: function mounted() {
        if (this.value != this.coditem) {
            this.loadData(this.value);
        }
        this.originalTop = this.$el.getBoundingClientRect().top;
    }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_search_vue__ = __webpack_require__(440);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f843eac4_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_search_vue__ = __webpack_require__(1199);
function injectStyle (ssrContext) {
  __webpack_require__(1197)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f843eac4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f843eac4_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'input-search',
  props: {
    value: {}, // Pode ser o ID (se selecionado) ou o texto (se não selecionado)
    label: { type: String },
    placeholder: { type: String, default: 'Pesquisar...' },
    entity: { type: String, required: true } // Endpoint ORDS, ex: 'cliente' ou 'cliente/'
  },
  data: function data() {
    return {
      textSearch: '',
      showList: false,
      list: [],
      selectedIndex: 0,
      selectedId: null,
      keytimer: null,
      isSelecting: false,
      has_more: false,
      next_page: 0
    };
  },

  watch: {
    textSearch: function textSearch(newVal, oldVal) {
      var _this = this;

      if (this.isSelecting) {
        this.isSelecting = false;
        return;
      }

      // Se alterou o texto manualmente, não temos mais um ID selecionado
      this.selectedId = null;
      this.$emit('input', newVal); // Atualiza o v-model com o texto informado

      if (this.keytimer) clearTimeout(this.keytimer);

      if (!newVal) {
        this.showList = false;
        this.list = [];
        this.has_more = false;
        this.next_page = 0;
        return;
      }

      this.keytimer = setTimeout(function () {
        _this.search();
      }, 300);
    },

    value: {
      immediate: true,
      handler: function handler(val) {
        // Quando o componente pai atualiza o valor
        if (val !== this.selectedId && val !== this.textSearch) {
          this.textSearch = val || '';
        }
      }
    }
  },
  methods: {
    handleBlur: function handleBlur() {
      var _this2 = this;

      // Pequeno atraso para dar tempo do mousedown no item da lista ocorrer
      setTimeout(function () {
        _this2.showList = false;
      }, 150);
    },
    handleEsc: function handleEsc() {
      this.showList = false;
    },
    handleKeyDown: function handleKeyDown() {
      if (this.list.length > 0) {
        if (this.selectedIndex >= this.list.length - 1) {
          this.selectedIndex = 0;
        } else {
          this.selectedIndex++;
        }
        this.fixScroll();
      }
    },
    handleKeyUp: function handleKeyUp() {
      if (this.list.length > 0) {
        if (this.selectedIndex <= 0) {
          this.selectedIndex = this.list.length - 1;
        } else {
          this.selectedIndex--;
        }
        this.fixScroll();
      }
    },
    fixScroll: function fixScroll() {
      var _this3 = this;

      if (this.$refs.list) {
        this.$nextTick(function () {
          var activeItem = _this3.$refs.list.querySelector('.active');
          if (activeItem) {
            activeItem.scrollIntoView({ block: 'nearest', inline: 'start' });
          }
        });
      }
    },
    handleSelect: function handleSelect(index) {
      if (index !== undefined) {
        this.selectedIndex = index;
      }
      if (this.list.length > 0 && this.list[this.selectedIndex]) {
        var item = this.list[this.selectedIndex];
        this.isSelecting = true;
        this.textSearch = item.value || item.descricao || item.nome;
        this.selectedId = item.id || item.codigo;
        this.showList = false;

        // Emite o ID selecionado
        this.$emit('input', this.selectedId);
        this.$emit('change', item);
      }
    },
    handleMore: function handleMore() {
      this.search(true);
    },
    search: function search(loadMore) {
      var _this4 = this;

      if (!this.entity) return;

      if (!loadMore) {
        this.next_page = 0;
      }

      var term = this.textSearch.toUpperCase();
      var endpoint = this.entity;
      if (!endpoint.endsWith('/')) {
        endpoint += '/';
      }

      var url = this.$store.getters.urlOrdsSelect + endpoint + '?q={"value":{"$like":"%25' + term + '%25"}}';
      if (this.next_page > 0) {
        url += '&offset=' + this.next_page;
      }

      jQuery.ajax({
        beforeSend: function beforeSend(xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + _this4.$store.getters.getEnv.token);
          xhr.setRequestHeader("uuid", _this4.$store.getters.getEnv.uuid);
        },
        url: url,
        dataType: 'json',
        success: function success(data) {
          if (data && data.items) {
            if (loadMore) {
              var _list;

              (_list = _this4.list).push.apply(_list, _toConsumableArray(data.items));
            } else {
              _this4.list = data.items;
              _this4.selectedIndex = 0;
            }
            _this4.showList = true;
            _this4.has_more = data.hasMore;
            if (data.hasMore) {
              _this4.next_page = (data.offset || 0) + (data.limit || data.count || 25);
            }
          }
        }
      });
    }
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: { String: String }
  },

  components: {
    datePicker: __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default.a
  },

  data: function data() {
    var self = this;
    return {
      lData: this.value,
      focused: false,
      options: {
        format: 'DD-MM-YYYY',
        useCurrent: false,
        locale: 'pt',
        showClear: true,
        showClose: true,
        icons: {
          time: 'fa fa-clock',
          date: 'fa fa-calendar',
          up: 'fa fa-arrow-up',
          down: 'fa fa-arrow-down',
          previous: 'fa fa-chevron-left',
          next: 'fa fa-chevron-right',
          today: 'fa fa-calendar-check',
          clear: 'fa fa-trash',
          close: 'fa fa-times-circle'
        },
        keyBinds: {
          enter: function enter(e) {
            this.hide();
            self.focusControl(e);
            return false;
          }
        }
      }
    };
  },
  mounted: function mounted() {
    this.formatValue(this.value);

    jQuery(".datepicker").attr("autocomplete", "off");
  },


  computed: {},

  created: function created() {},


  methods: {
    updateValue: function updateValue(value) {
      if (value) {
        var _value$split = value.split("-"),
            _value$split2 = _slicedToArray(_value$split, 3),
            day_ = _value$split2[0],
            month_ = _value$split2[1],
            year_ = _value$split2[2];

        var d = [year_, month_, day_].join('-');
        this.$emit('input', d);
      } else {
        this.$emit('input', value);
      }
    },

    selectAll: function selectAll(event) {
      this.focused = true;
      // Workaround for Safari bug
      // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
      setTimeout(function () {
        event.target.select();
      }, 0);
    },

    formatValue: function formatValue(value) {
      //recebe um valor yyyy-mm-dd e converte em dd-mm-yyyy
      if (value) jQuery(this.$el)[0].value = Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatDate"])(value);

      // if (!checkDate(value))
      //   return
      // console.log('aqui ' + value)
      // const [year_, month_, day_] = value.split("-")
      // jQuery(this.$el)[0].value = [day_, month_, year_].join('-')

      // function pad(s) { return (s < 10) ? '0' + s : s; }
      // var d = new Date(value)
      // jQuery(this.$el)[0].value = [pad(d.getDate()+1), pad(d.getMonth()+1), d.getFullYear()].join('-')
    },

    focusControl: function focusControl(event) {
      var thisIndex = jQuery(this.$el).index(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var next = thisIndex + 1;
      var obj = jQuery(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
      var found = false;
      for (var x = next; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["hasHiddenParent"])(obj[x])) {
          jQuery(obj[x]).focus();
          found = true;
          break;
        }
      }
      if (!found) {
        for (var x = 0; x < obj.length; x++) {
          if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["hasHiddenParent"])(obj[x])) {
            jQuery(obj[x]).focus();
            found = true;
            break;
          }
        }
      }

      this.$emit('keyenter');
    },

    focus: function focus() {
      if (this.$refs.data) {
        jQuery(this.$el)[0].focus();
      }
    }

  },
  watch: {
    value: function value(_value) {
      if (!this.focused) {
        this.formatValue(_value);
      }
    }
  }

});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_color__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_color__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = (_defineProperty({
	props: ['color', 'value'],
	data: function data() {
		return {
			colors: {
				hex: '#000000'
			},
			colorValue: this.value,
			displayPicker: false
		};
	},
	mounted: function mounted() {
		this.setColor(this.color || '#000000');
	},

	methods: {
		setColor: function setColor(color) {
			this.updateColors(color);
			this.colorValue = color;
		},
		updateColors: function updateColors(color) {
			if (color.slice(0, 1) == '#') {
				this.colors = {
					hex: color
				};
			} else if (color.slice(0, 4) == 'rgba') {
				var rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(','),
				    hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
				this.colors = {
					hex: hex,
					a: rgba[3]
				};
			}
		},
		showPicker: function showPicker() {
			document.addEventListener('click', this.documentClick);
			this.displayPicker = true;
		},
		hidePicker: function hidePicker() {
			document.removeEventListener('click', this.documentClick);
			this.displayPicker = false;
		},
		togglePicker: function togglePicker() {
			this.displayPicker ? this.hidePicker() : this.showPicker();
		},
		updateFromInput: function updateFromInput() {
			this.updateColors(this.colorValue);
		},
		updateFromPicker: function updateFromPicker(color) {
			this.colors = color;
			if (color.rgba.a == 1) {
				this.colorValue = color.hex;
			} else {
				this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
			}
		},
		documentClick: function documentClick(e) {
			var el = this.$refs.colorpicker,
			    target = e.target;
			if (el !== target && !el.contains(target)) {
				this.hidePicker();
			}
		}
	},
	watch: {
		colorValue: function colorValue(val) {
			if (val) {
				this.updateColors(val);
				this.$emit('input', val);
				//document.body.style.background = val;
			}
		},


		value: function value(newValue) {
			this.colorValue = newValue;
		}

	},

	components: {
		Chrome: __WEBPACK_IMPORTED_MODULE_2_vue_color__["Chrome"]
	},

	created: function created() {}
}, 'mounted', function mounted() {}));

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    tabs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabsTextStyle: {
      type: String
    },
    setActiveTab: {
      type: Number
    },
    isList: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      activeTab: 0,
      showItems: false
    };
  },


  methods: {
    clickTab: function clickTab(idx) {
      jQuery('[data-toggle="tooltip"]').tooltip("hide");
      this.activeTab = idx;
      this.$emit("onClickTab", idx);

      this.showItems = false;
    }
  },

  watch: {
    setActiveTab: function setActiveTab() {
      this.activeTab = this.setActiveTab;
    }
  },

  mounted: function mounted() {
    if (this.setActiveTab) this.activeTab = this.setActiveTab;

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
  },
  created: function created() {}
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  props: {
    options: { required: false },
    value: { required: false },
    entity: { type: String, default: '', required: false },
    url: { type: String, default: '', required: false },
    minlength: { type: Number, default: '', required: true },
    parent: { type: String, required: false },
    disabled: { type: Boolean, required: false },
    focus: { type: Boolean, default: false },
    tabindex: { type: Number },
    placeholder: { type: String }
  },

  data: function data() {
    return {
      initOptions: this.options,
      only_id: false
    };
  },


  computed: {
    pesquisaItem: function pesquisaItem() {
      return this.entity == 'item';
    },

    cPlaceHolder: function cPlaceHolder() {
      if (this.placeholder) return this.placeholder;else return 'Selecione';
    }
  },

  mounted: function mounted() {
    var vm = this;

    this.initSelect2();
    if (this.value == undefined) {} else {
      this.initValueSelect2();
    }

    /* ATRIBUI VALORES VINDO DA PROP OPTIONS
          window.jQuery(this.$el).find('select')
            .empty().select2({ data: this.initOptions })
            .val(this.value)
    */
  },


  watch: {
    value: function value(_value) {
      // update value
      // console.log('value watch: ' + value)
      jQuery(this.$el).val(_value);
      this.initValueSelect2();
    },

    focus: function focus(value) {
      if (value) this.$el.querySelector('select').focus();
    }

    /*
    options: function (options) {
      // update options
      jQuery(this.$el).empty().select2({ data: options })
    },
    */

  },

  created: function created() {
    //console.log('value created: ' + this.value)
  },


  methods: {
    initValueSelect2: function initValueSelect2() {

      var vm = this;
      if (this.value == '' || this.value == null) {
        //limpa o select2 quando receber um valor nulo
        jQuery(vm.$el).find('select').val('').trigger('change');
        return;
      }

      jQuery.ajax({
        beforeSend: function beforeSend(xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + vm.$store.getters.getEnv.token);
          xhr.setRequestHeader("uuid", vm.$store.getters.getEnv.uuid);
        },
        delay: 300,
        url: vm.$store.getters.urlOrdsSelect + vm.entity + '/' + vm.value,
        dataType: 'json',
        data: function data(params) {
          return '';
        },
        success: function success(data) {
          if (data.items) {
            if (data.items.length == 0) {
              console.log(vm.entity + '/' + vm.value + ': código não encontrato');
            } else {
              var item = data.items[0];
              item.text = item.value;

              var opt = new Option(item.value, item.id, true, true);
              var $select = jQuery(vm.$el).find('select');
              $select.append(opt);

              // attach the data to the option so select2 can see it
              $select.find('option[value="' + item.id + '"]').data('data', item);

              $select.trigger('change');
            }
          }
        }
      });

      /*
              jQuery.getJSON(vm.$store.getters.urlOrdsSelect + this.entity + '/' + this.value, function(data) {
                if (data.items) {
                  if (data.items.length == 0) {
                    console.log(vm.entity + '/' + vm.value + ': código não encontrato')
                  } else {
                    vm.initOptions = {
                      id: data.items[0].id,
                      text: data.items[0].value
                    }
                    var opt = new Option(data.items[0].value, data.items[0].id, true, true)
                    jQuery(vm.$el).find('select').append(opt).trigger('change');
                  }
                }
              })
      */
    },
    initSelect2: function initSelect2() {
      //efetua a inicializacao do Select2
      var vm = this;

      var obj = {
        minimumInputLength: vm.minlength,
        placeholder: this.cPlaceHolder,
        allowClear: true,
        theme: "bootstrap",

        language: {
          inputTooShort: function inputTooShort(args) {
            return "";
          },
          inputTooLong: function inputTooLong(args) {
            return "You typed too much";
          },
          errorLoading: function errorLoading() {
            return "Erro ao carregar opções.";
          },
          loadingMore: function loadingMore() {
            return "Carregando mais...";
          },
          noResults: function noResults() {
            return "Nenhum resultado encontrado.";
          },
          searching: function searching() {
            return "Buscando...";
          },
          maximumSelected: function maximumSelected(args) {
            // args.maximum is the maximum number of items the user may select
            return "Erro ao carregar resultados";
          }
        },
        // language: "pt-BR",
        ajax: {
          beforeSend: function beforeSend(xhr) {
            xhr.setRequestHeader("Authorization", "Bearer " + vm.$store.getters.getEnv.token);
            xhr.setRequestHeader("uuid", vm.$store.getters.getEnv.uuid);
          },
          delay: 300,
          url: function url(params) {
            if (params.term) {
              var str = params.term;
              var term = params.term.toUpperCase();

              // Se o termo parece um CNPJ formatado (contém simbolos e tem tamanho exato de 18 caracteres)
              // removemos a formatação para a pesquisa ser efetiva no banco (alfanumérico puro)
              if (term.length == 18 && (term.indexOf('.') >= 0 || term.indexOf('/') >= 0 || term.indexOf('-') >= 0)) {
                term = term.replace(/[^A-Z0-9]/g, '');
              }

              // Normalizamos o termo de fallback (res) para também aceitar o novo formato alfanumérico
              var res = term.replace(/[^A-Z0-9]/g, "");

              if (vm.pesquisaItem) {
                if (vm.only_id) {
                  return vm.$store.getters.urlOrdsSelect + vm.entity + '/?q={"codigo":{"$or":[{"$eq":"' + term + '"}' + (res ? ',{"codigo":{"$eq":"' + res.toUpperCase() + '"}}' : '') + ']}}';
                } else {
                  return vm.$store.getters.urlOrdsSelect + vm.entity + '/?q={"descricao":{"$or":[{"$eq":"' + term + '"}' + (term.length > 3 ? ',{"$like":"%25' + term + '%25"}' : '') + ',{"codigo":{"$like":"%25' + term + '%25"}}' + (res ? ',{"codigo":{"$eq":"' + res.toUpperCase() + '"}}' : '') + ']}}';
                }
              } else return vm.$store.getters.urlOrdsSelect + vm.entity + '/?q={"value":{"$or":[{"$like":"%25' + term + '%25"},{"id":{"$like":"%25' + term + '%25"}}' + (res ? ',{"id":{"$like":"%25' + res.toUpperCase() + '%25"}}' : '') + ']}}';
            } else {
              return vm.$store.getters.urlOrdsSelect + vm.entity + '/';
            }
          },
          dataType: 'json',
          data: function data(params) {
            return ''; //retorna em branco para montagem dos parametros direto na url do ajax
          },
          processResults: function processResults(data) {
            return {
              results: jQuery.map(data.items, function (item) {
                return {
                  text: item.value,
                  id: item.id,
                  class: item.class,
                  nome: item.nome,
                  fantasia: item.fantasia,
                  cnpjcpf: item.cnpjcpf,
                  codigo: item.codigo
                };
              })
            };
          }
        },
        templateResult: function templateResult(data) {
          if (data.nome) {
            var $container = jQuery('<div class="select2-result-part">' + '<div class="select2-result-part__nome" style="font-weight: bold; font-size: 1.1em;">' + data.nome + '</div>' + '<div class="select2-result-part__fantasia" class="select2-result-part__fantasia" style="font-size: 0.9em;">' + (data.fantasia || '') + '</div>' + '<div class="select2-result-part__info" class="select2-result-part__info" style="font-size: 0.8em;">' + (data.codigo ? 'Cod: ' + data.codigo : '') + (data.cnpjcpf ? ' - ' + data.cnpjcpf : '') + '</div>' + '</div>');
            return $container;
          }
          var $state = jQuery('<span class=select2-item-result "' + (data.class ? data.class : '') + '">' + data.text + '</span>');
          return $state;
        },
        templateSelection: function templateSelection(data) {
          if (data.nome) {
            return data.nome + ' (' + (data.fantasia || '') + ')';
          }
          return data.text;
        }
      };

      var dropdownParent = null;
      if (this.parent) {
        dropdownParent = window.jQuery('#' + this.parent);
      }

      if (!dropdownParent || dropdownParent.length === 0) {
        dropdownParent = jQuery(this.$el).parent();
      }

      Object.assign(obj, { dropdownParent: dropdownParent });

      jQuery(this.$el).find('select') //https://select2.org/data-sources/ajax
      .select2(obj).trigger('change')
      // emit event on change.
      .on('change', function () {
        if (this.value == '') vm.$emit('input', null);else vm.$emit('input', this.value);
      }).on('keyup', function (evt) {});

      jQuery(this.$el).on('keydown', '.select2-selection', function (e) {
        if (e.which === 13) {
          e.preventDefault();
          jQuery(vm.$el).find('select').select2('close');

          var thisIndex = jQuery(vm.$el.querySelector('select')).index(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
          var next = thisIndex + 2;
          var obj = jQuery(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
          for (var x = next; x < obj.length; x++) {
            if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
              jQuery(obj[x]).focus();
              return;
            }
          }
          for (var x = 0; x < obj.length; x++) {
            if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
              jQuery(obj[x]).focus();
              return;
            }
          }
        }
      });
    }
  },

  destroyed: function destroyed() {
    //console.log('select2 destroy:')
    //jQuery(this.$el).off().select2('destroy')
  }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  props: {
    options: { required: false },
    value: { required: false },
    entity: { type: String, default: '', required: false },
    url: { type: String, default: '', required: false },
    minlength: { type: Number, default: '', required: true },
    parent: { type: String, required: false },
    disabled: { type: Boolean, default: false, required: false },
    focus: { type: Boolean, default: false },
    tabindex: { type: Number },
    multiple: { type: Boolean, default: false },
    placeholder: { type: String }
  },

  data: function data() {
    return {
      onChangeEvent: false,
      onWatchEvent: false
    };
  },
  mounted: function mounted() {
    this.initSelect2();
    this.$nextTick(function () {
      this.initValueSelect2();
    });
  },


  watch: {
    value: function value(_value) {
      if (this.onChangeEvent) {
        return;
      }
      this.onWatchEvent = true;
      jQuery(this.$el).find('select').val(_value ? _value : '').trigger('change');
      this.onWatchEvent = false;
    },

    focus: function focus(value) {
      if (value) this.$el.querySelector('select').focus();
    },

    options: function options(value) {
      var obj = {
        minimumInputLength: 0,
        placeholder: "",
        allowClear: true,
        theme: "bootstrap",
        data: this.options,
        closeOnSelect: !this.multiple
      };

      if (this.placeholder) {
        obj.placeholder = {
          id: '-1',
          text: this.placeholder
        };
      }

      var parent = window.jQuery(this.$el).parent();
      Object.assign(obj, { dropdownParent: parent });

      if (this.parent != undefined && this.parent != '') {
        Object.assign(obj, { dropdownParent: window.jQuery('#' + this.parent) });
      }
      jQuery(this.$el).find('select').select2(obj);
    }

  },

  created: function created() {},


  methods: {
    initValueSelect2: function initValueSelect2() {

      var vm = this;
      if (!this.value || this.value == '' || this.value == null) {
        //limpa o select2 quando receber um valor nulo
        jQuery(vm.$el).find('select').val('').trigger('change');
        return;
      }
    },
    initSelect2: function initSelect2() {
      //efetua a inicializacao do Select2

      var vm = this;

      var obj = {
        minimumInputLength: 0,
        placeholder: "",
        allowClear: true,
        theme: "bootstrap",
        data: this.options,
        closeOnSelect: !this.multiple
      };

      if (this.placeholder) {
        obj.placeholder = {
          id: '-1',
          text: this.placeholder
        };
      }

      var parent = window.jQuery(this.$el).parent();
      Object.assign(obj, { dropdownParent: parent });

      if (this.parent != undefined && this.parent != '') {
        Object.assign(obj, { dropdownParent: window.jQuery('#' + this.parent) });
      }

      window.jQuery(this.$el).find('select') //https://select2.org/data-sources/ajax
      .select2(obj).trigger('change') // emit event on change.
      .on('change', function () {
        vm.onChangeEvent = true;
        if (!vm.onWatchEvent) {
          if (this.value == '') vm.$emit('input', null);else {
            if (vm.multiple) {
              vm.value = jQuery(vm.$el).find('select').val();
              vm.$emit('input', jQuery(vm.$el).find('select').val());
            } else {
              vm.$emit('input', this.value);
            }
          }
          //vm.$emit('input', jQuery(vm.$el).find('select').val())
        }
        vm.onChangeEvent = false;
      }).on('keyup', function (e) {}).on('keypress', function (e) {});

      this.obj = jQuery(vm.$el).find('select');

      //        window.jQuery(this.$el).find('select').val(this.value? this.value : '').trigger('change')

      jQuery(vm.$el).on('keydown', '.select2-selection', function (e) {
        if (e.which === 13) {
          e.preventDefault();
          var thisIndex = jQuery(vm.$el.querySelector('select')).index(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
          var next = thisIndex + 2;
          var obj = jQuery(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
          for (var x = next; x < obj.length; x++) {
            if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
              jQuery(obj[x]).focus();
              return;
            }
          }
          for (var x = 0; x < obj.length; x++) {
            if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["hasHiddenParent"])(obj[x])) {
              jQuery(obj[x]).focus();
              return;
            }
          }
        }
      });
    }
  },

  destroyed: function destroyed() {
    //console.log('select2 destroy:')
    //jQuery(this.$el).off().select2('destroy')
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        // options: {
        //     type: Array,
        //     default() {
        //         return []
        //     }
        // },
        value: {
            type: [String, Number],
            default: null
        },
        entity: {
            type: String,
            default: null,
            required: false
        }
    },
    data: function data() {
        return {
            open: false,
            selectIndex: 0,
            displayText: '',
            search: '',
            listWidth: '',
            fontSize: '',
            keytimer: null,
            options: []
        };
    },

    computed: {
        typeaheadState: function typeaheadState() {
            return this.open ? 'typeahead typeahead__open' : 'typeahead';
        },
        filteredOptions: function filteredOptions() {
            var exp = new RegExp(this.search, 'i');
            return this.options.filter(function (option) {
                return exp.test(option.id) || exp.test(option.text);
            });
        }
    },
    methods: {
        onDownKey: function onDownKey() {
            if (this.filteredOptions.length - 1 > this.selectIndex) {
                this.selectIndex++;
                // scroll when overflow
                if (this.selectIndex > 2) {
                    this.$refs.list.scrollTop += 20 + this.selectIndex;
                }
            }
        },
        onUpKey: function onUpKey() {
            if (this.selectIndex > 0) {
                this.selectIndex--;
                // scroll when overflow
                if (this.selectIndex > 0) {
                    this.$refs.list.scrollTop -= 20 + this.selectIndex;
                }
            }
        },
        onEnterKey: function onEnterKey() {
            var option = this.filteredOptions[this.selectIndex];
            if (option) {
                this.select(option);
            }
            var thisIndex = jQuery(this.$el.querySelector('input')).index(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
            var next = thisIndex + 1;
            jQuery(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl).eq(next).focus();
        },
        select: function select(option) {
            this.displayText = option.text, this.$emit('input', option.id);
            this.onBlur();
            //this.$refs.search.blur()
            //console.log(option.id)
        },
        toggle: function toggle(e) {
            if (e.target === this.$refs.toggle || e.target === this.$refs.search || e.target === this.$refs.text) {
                if (this.open) {
                    if (e.target !== this.$refs.search && e.target !== this.$refs.text) {
                        this.$refs.search.blur();
                    }
                } else {
                    this.$refs.search.focus();
                }
            }
        },
        onFocus: function onFocus() {
            // this.open = true
        },
        onBlur: function onBlur() {
            this.search = '';
            this.selectIndex = 0;
            if (this.open) {
                this.$refs.list.scrollTop = 0;
            }
            this.open = false;
        },
        onEscape: function onEscape() {
            this.open = false;
            // this.$refs.search.blur()
        },
        onChangeSearch: function onChangeSearch(ev) {
            // console.log('onkeyup: ' + ev.keyCode)

            if (ev.keyCode == 40 || ev.keyCode == 38) {
                return;
            }

            this.open = true;
            var vm = this;
            if (this.keytimer) {
                clearTimeout(this.keytimer);
            }
            this.keytimer = setTimeout(function () {
                vm.fillOptions();
            }, 200);
        },
        fillOptions: function fillOptions() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var url, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.search.trim() == '')) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                url = _this.$store.getters.urlOrdsSelect + _this.entity + '/?q={"value":{"$or":[{"$like":"%25' + _this.search.toUpperCase() + '%25"},{"id":{"$like":"%25' + _this.search.toUpperCase() + '%25"}}]}}';
                                _context.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDS"])(url);

                            case 5:
                                data = _context.sent;

                                if (data.items) {
                                    _this.options = jQuery.map(data.items, function (item) {
                                        return {
                                            text: item.value,
                                            id: item.id
                                        };
                                    });
                                }

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        resizeList: function resizeList(el) {
            var rect = el.getBoundingClientRect();
            //const listStyle = this.$refs.list.$el.style
            this.listWidth = { width: rect.width + 'px'
                // this.fontSize = { "font-size": el.style['font-size'] }
            };
        }
    },

    created: function created() {},
    mounted: function mounted() {
        this.resizeList(this.$refs.search);
        // console.log(this.$refs.search.style)
    }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'email-form',
    props: {
        index: '', //CODIGO DO PEDIDO, NF, ETC
        tipo: { type: String }, //PEDV, DANFE
        codpart: { type: [String, Number] },
        urlTemplate: { type: String }, //URL DE UM TEMPLATE ESPECIFICO
        title: { type: String }
    },

    data: function data() {
        return {
            errorMessage: '',
            error: false,
            template: {},
            sendto: '',
            text: '',
            subject: '',
            emails: [{ email: '' }], //LISTA DE EMAILS PARA ENVIO
            listEmails: [{ email: 'Adicionar Email', selected: false }] //LISTA DE EMAILS PARA SELEÇÃO
        };
    },


    computed: {},

    filters: {},

    methods: {
        handleEnviar: function handleEnviar() {
            //botao enviar

            var emails = [];

            for (var x = 0; x < this.emails.length; x++) {
                emails.push(this.emails[x].email);
            }

            var data = {
                emails: emails,
                subject: this.subject,
                text: this.text,
                sender: this.template.sender,
                sendername: this.template.sendername };

            this.$emit('send', data);
        },
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        validaEmail: function validaEmail() {
            var _this = this;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.handleEnviar();
                }
            });
        },
        handleDeleteEmail: function handleDeleteEmail(index) {
            //exclui um email
            if (this.emails[index].selectedIndex) {
                this.listEmails[this.emails[index].selectedIndex].selected = false;
            }
            this.emails.splice(index, 1);
        },
        handleSelectEmail: function handleSelectEmail(index) {
            //adiciona selecionado
            var email = { email: this.listEmails[index].email, selectedIndex: index };

            if (index === 0) {
                //ADICIONAR EMAIL
                email.email = '';
            } else {
                this.listEmails[index].selected = true;
            }
            if (!this.emails[0].email) {
                this.emails[0].email = email.email;
            } else {
                this.emails.push(email);
            }
        },
        handleAdicionarEmail: function handleAdicionarEmail() {
            //adiciona email
            var email = { email: '' };
            this.emails.push(email);
        },
        loadTemplate: function loadTemplate() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var url, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //CARREGA O TEMPLATE DO EMAIL DA DANFE OU PEDIDO DE VENDA
                                url = '';

                                if (!(_this2.tipo == 'DANFE')) {
                                    _context.next = 5;
                                    break;
                                }

                                url = 'template/danfe/';
                                _context.next = 26;
                                break;

                            case 5:
                                if (!(_this2.tipo == 'PEDV')) {
                                    _context.next = 9;
                                    break;
                                }

                                url = 'template/pedv/';
                                _context.next = 26;
                                break;

                            case 9:
                                if (!(_this2.tipo == 'CCE')) {
                                    _context.next = 13;
                                    break;
                                }

                                url = 'template/cce/';
                                _context.next = 26;
                                break;

                            case 13:
                                if (!(_this2.tipo == 'CIELOSUPERLINK')) {
                                    _context.next = 17;
                                    break;
                                }

                                url = 'template/cielosuperlink/';
                                _context.next = 26;
                                break;

                            case 17:
                                if (!(_this2.tipo == 'COMPRA')) {
                                    _context.next = 21;
                                    break;
                                }

                                url = 'template/compra/';
                                _context.next = 26;
                                break;

                            case 21:
                                if (_this2.urlTemplate) {
                                    _context.next = 25;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 25:
                                url = _this2.urlTemplate;

                            case 26:

                                url = _this2.$store.getters.urlOrds + url + _this2.index;
                                console.log(url);
                                _context.next = 30;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDS"])(url, {});

                            case 30:
                                data = _context.sent;

                                if (data) {
                                    _this2.template = data;
                                }

                            case 32:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },

    watch: {
        template: function template() {
            if (!this.template.subject) return;
            // this.listEmails = []
            this.sendto = this.template.sendto;
            this.subject = this.template.subject;
            this.text = this.template.text;
            if (this.template.listEmails && this.template.listEmails.length > 0) {
                for (var x = 0; x < this.template.listEmails.length; x++) {
                    this.listEmails.push({ email: this.template.listEmails[x], selected: false });
                }
            }
            this.emails[0].email = this.sendto;
        }
    },

    mounted: function mounted() {
        this.$nextTick(function () {
            this.$refs.sendto[0].focus();
        });
    },
    created: function created() {
        this.loadTemplate();
    }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        codpart: { type: String }
    },

    data: function data() {
        return {
            foneToSend: null,
            newNumber: null,
            part: null
        };
    },


    computed: {},

    methods: {
        loadPart: function loadPart() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadPart', { id: _this.codpart });

                            case 2:

                                if (_this.$store.getters.getPart) {
                                    _this.part = _extends({}, _this.$store.getters.getPart[0]);
                                }

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleCloseMessage: function handleCloseMessage() {
            this.MESSAGE = false;
            this.closeForm();
        },
        handleConfirmMessage: function handleConfirmMessage() {
            window.open(this.link, "_blank");
            this.MESSAGE = false;
            this.closeForm();
        },
        closeModal: function closeModal() {
            this.$emit('closeform', null);
        },
        handleConfirmar: function handleConfirmar() {
            var number = null;
            if (!(this.foneToSend == 4)) {
                number = this.foneToSend;
            } else {
                number = this.newNumber;
            }
            this.$emit('closeform', number);
        }
    },

    watch: {},

    components: {},

    created: function created() {
        this.loadPart();
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
    }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        visible: { type: Boolean, required: false }
    },
    data: function data() {
        return {
            senha: ''
        };
    },

    methods: {
        handleKeyUpEvent: function handleKeyUpEvent(event) {
            var self = this;
            if (event.keyCode === 13) {
                self.handleConfirmButton();
            }
            if (event.keyCode == 27) {
                self.handleCloseButton();
            }
        },
        handleConfirmButton: function handleConfirmButton() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var obj, modulo, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(!_this.senha || _this.senha == '')) {
                                    _context.next = 3;
                                    break;
                                }

                                _this.$erpToastError('Senha obrigatoria');
                                return _context.abrupt('return');

                            case 3:
                                obj = {};

                                obj.senha = _this.senha;

                                modulo = 'cg/valida/adminpass/';
                                _context.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this.$store, modulo, obj, 'post');

                            case 8:
                                data = _context.sent;

                                if (data.resultado) {
                                    _context.next = 12;
                                    break;
                                }

                                _this.$erpToastError('Senha invalida');
                                return _context.abrupt('return');

                            case 12:

                                _this.visible = false;
                                _this.$emit('confirm');

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleCloseButton: function handleCloseButton() {
            this.visible = false;
            this.$emit('close');
        }
    },
    mounted: function mounted() {
        this.$refs.senha.focus();

        window.addEventListener('keyup', this.handleKeyUpEvent);
    },
    updated: function updated() {
        this.$refs.senha.focus();
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('keyup', this.handleKeyUpEvent);
    }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {},

    data: function data() {
        return {
            email: null,
            errmessages: null,
            btEnviar: 'Enviar'
        };
    },


    computed: {},

    methods: {
        handleEnviar: function handleEnviar() {
            //BOTAO ENVIAR
            this.apiPost();
        },
        handleVoltar: function handleVoltar() {
            this.$router.push('login');
        },
        handleCadastrar: function handleCadastrar() {
            this.$router.push('registro');
        },
        apiPost: function apiPost() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var sendData, login;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:

                                //efetua o login em ords/nbapp/login/
                                sendData = { email: _this.email };

                                _this.btEnviar = 'Enviando a senha...';
                                _this.errmessages = null;

                                _context.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSapp"])(_this, 'recuperar/', 'post', sendData);

                            case 5:
                                login = _context.sent;

                                _this.btEnviar = 'Enviar';

                                if (!login.errmessages) {
                                    _context.next = 10;
                                    break;
                                }

                                _this.errmessages = login.errmessages;
                                return _context.abrupt('return');

                            case 10:

                                //login efetuado: recebe o token para autenticacao, urlapi, token app
                                _this.errmessages = null;

                                _this.$router.push('login');

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    components: {},

    created: function created() {
        this.$scrollTo(0);
        this.email = '';
        this.$nextTick(function () {
            this.$refs.email.focus();
        });
    }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_login_js__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_login_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__api_api_login_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: {
            app: String,
            plano: String
        }
    },

    data: function data() {
        return {
            registro: { nome: null, nomeempresa: null, senha: null, telefone: null, email: null, pessoa: null, cnpjcpf: null, tpempresa: null },
            errmessages: null, //armazena as mensagens de validacao do servidor para mostrar em tela
            estagio: '',
            app: '',
            registrando: false,
            plano: '',

            metadata: { registro: {
                    nome: { label: 'Nome', fieldname: 'nome' },
                    nomeempresa: { label: 'Nome da Empresa', fieldname: 'nomeempresa' },
                    email: { label: 'Email Para Login', fieldname: 'email' },
                    senha: { label: 'Senha', fieldname: 'senha' },
                    cnpj: { label: 'Cnpj', fieldname: 'cnpj' },
                    cpf: { label: 'CPF', fieldname: 'cpf' },
                    tpempresa: {
                        label: 'Tipo de Empresa', fieldname: 'tpempresa',
                        options: [{ id: 'S', text: 'Optante do Simples' }, { id: 'N', text: 'Normal' }, { id: 'E', text: 'Escritório Contabil' }]
                    },
                    telefone: { label: 'Telefone', fieldname: 'telefone' },
                    pessoa: {
                        label: 'Tipo de Pessoa', fieldname: 'pessoa',
                        options: [{ id: 'J', text: 'Física' }, { id: 'F', text: 'Jurídica' }]
                    },
                    obsconheceu: { label: 'Observações', fieldname: 'obsconheceu' },
                    comoconheceu: {
                        label: 'Como Conheceu', fieldname: 'comoconheceu',
                        options: [{ id: '1', text: 'Google' }, { id: '2', text: 'Facebook' }, { id: '3', text: 'Indicação' }, { id: '4', text: 'Anuncio' }, { id: '5', text: 'Outros' }]
                    }
                }
            },

            email: '',
            senha: '',

            recaptcha: false

        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_1__api_api_login_js___default.a],

    computed: {
        selecionados: function selecionados() {
            return this.aplicativos.filter(function (obj) {
                return obj.selected;
            });
        },

        botaoRegistrar: function botaoRegistrar() {
            if (this.registrando) return 'Registrando...';else return 'Experimentar por 15 dias';
        }
    },

    methods: {
        verifyRecaptcha: function verifyRecaptcha(response) {
            this.recaptcha = true;
        },
        expiredRecaptcha: function expiredRecaptcha() {
            this.recaptcha = false;
        },
        setGoogleTag: function setGoogleTag() {
            var googleTagHead = document.createElement('script');
            googleTagHead.setAttribute('type', 'text/javascript');
            var googleScriptContent = document.createTextNode('\n                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src= \'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f); })(window,document,\'script\',\'dataLayer\',\'GTM-MP9QGL5\');\n            ');
            googleTagHead.appendChild(googleScriptContent);

            var firstChildScript = document.getElementsByTagName("script")[0];

            document.head.insertBefore(googleTagHead, firstChildScript);

            var googleTagBody = document.createElement('noscript');
            jQuery(googleTagBody).append('\n                <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MP9QGL5" height="0" width="0" style="display:none;visibility:hidden"></iframe>\n            ');

            var firstChildBody = document.body.firstElementChild;

            document.body.insertBefore(googleTagBody, firstChildBody);
        },
        handleRegistrar: function handleRegistrar() {
            var _this = this;

            if (!this.recaptcha) {
                this.$erpToastWarning('A verificação "não sou um robô"(reCAPTCHA) deve ser realizada.');
                return;
            }

            //BOTAO REGISTRAR
            var self = this;
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastWarning('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        apiPost: function apiPost() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var sendData, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //efetua o envio do registro para o servidor

                                _this2.errmessages = null;
                                _this2.registrando = true;

                                sendData = { registro: _this2.registro };

                                sendData.registro.app = _this2.app;
                                sendData.registro.plano = _this2.plano;

                                _this2.$appLoading(true);
                                _context.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSapp"])(_this2, 'assinatura/', 'post', sendData);

                            case 8:
                                data = _context.sent;

                                _this2.$appLoading(false);

                                if (!data.errmessages) {
                                    _context.next = 16;
                                    break;
                                }

                                _this2.errmessages = data.errmessages;
                                _this2.registrando = false;
                                return _context.abrupt('return');

                            case 16:
                                if (!(data.status == 'exist')) {
                                    _context.next = 20;
                                    break;
                                }

                                _this2.errmessages = 'Já existe cadastro para este e-mail';
                                _this2.registrando = false;
                                return _context.abrupt('return');

                            case 20:
                                //sucesso, fecha formulario para efetuar logon
                                _this2.errmessages = null;
                                _this2.registrando = false;
                                _this2.$scrollTo(0);
                                _this2.email = _this2.registro.email;
                                _this2.senha = _this2.registro.senha;
                                _this2.apiLogin();

                            case 26:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        handleLogin: function handleLogin() {
            this.$router.push('/login');
        },
        apiPostLead: function apiPostLead() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var sendData, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua o envio do registro para o servidor

                                _this3.errmessages = null;

                                sendData = { registro: _this3.registro };

                                sendData.registro.app = _this3.app;
                                sendData.registro.plano = _this3.plano;

                                _context2.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSapp"])(_this3, 'savelead/', 'post', sendData);

                            case 6:
                                data = _context2.sent;

                                if (!data.errmessages) {
                                    _context2.next = 10;
                                    break;
                                }

                                _this3.errmessages = data.errmessages;
                                return _context2.abrupt('return');

                            case 10:
                                _this3.errmessages = null;

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        }
    },

    components: {
        VueRecaptcha: __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha___default.a
    },

    beforeCreate: function beforeCreate() {},
    mounted: function mounted() {
        var email = this.$route.query.email;
        if (email) {
            this.registro.email = email;
            this.apiPostLead();
        }
        this.$nextTick(function () {

            this.$refs.email.focus();
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
    },
    created: function created() {
        this.estagio = 'registro';

        if (this.$route.name == 'registro') {
            this.$scrollTo(0);
            this.app = 'ERP';
            this.plano = '1-2022';
        } else if (this.$route.name == 'registropedidos') {
            this.app = 'FV';
            this.plano = 'C';
        } else if (this.$route.name == 'registronfe') {
            this.app = 'NFE';
            this.plano = 'C';
        } else if (this.$route.name == 'registroloja') {
            this.app = 'LOJA';
            this.plano = 'C';
        }

        this.setGoogleTag();

        this.app = this.app.toUpperCase();
    }
});

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiFunctions = __webpack_require__(5);

var _main = __webpack_require__(4);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  methods: {
    apiLogin: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var sendData, login;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.logando = true;
                this.errmessages = null;

                _main.SysVars.appBlocked = false;
                _main.SysVars.appEndTrial = false;
                _main.SysVars.appLogged = false;

                sendData = { login: { email: this.email.toLowerCase(), senha: this.senha } };
                _context.next = 8;
                return (0, _apiFunctions.apiORDSapp)(this, 'login/', 'post', sendData);

              case 8:
                login = _context.sent;

                if (!login.errmessages) {
                  _context.next = 15;
                  break;
                }

                this.errmessages = login.errmessages;
                this.logando = false;
                return _context.abrupt('return');

              case 15:
                if (!(login.status == 'invalid')) {
                  _context.next = 19;
                  break;
                }

                this.errmessages = login.message;
                this.logando = false;
                return _context.abrupt('return');

              case 19:

                // BFF flow returns token already nested in login.auth
                this.apiLoginToken(login);

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function apiLogin() {
        return _ref.apply(this, arguments);
      }

      return apiLogin;
    }(),
    apiLoginToken: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(login) {
        var auth, authObj, cleanUrl;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.errmessages = null;

                // Read auth token nested in the login response (Standard BFF) 
                // Or construct it from the flat 'token' query value (Autologin BFF)
                auth = login.auth || (login.token ? { access_token: login.token, token_type: 'bearer' } : null);


                this.logando = false;

                if (!(!auth || !auth.access_token)) {
                  _context2.next = 6;
                  break;
                }

                this.$erpToastError('Falha na autenticação (Token não gerado pelo BFF)');
                return _context2.abrupt('return');

              case 6:
                authObj = { auth: auth, login: login };

                this.$store.dispatch('loadEnv', authObj);

                if (login.isblocked) _main.SysVars.appBlocked = true;else if (login.isendtrial) _main.SysVars.appEndTrial = true;

                _main.SysVars.appLogged = true;

                // Limpa o token_autologin da URL (antes do hash #)
                if (window.location.search.includes("token_autologin")) {
                  cleanUrl = new URL(window.location.href);

                  cleanUrl.searchParams.delete("token_autologin");
                  window.history.replaceState({}, "", cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
                }

                if (login.tpempresa === 'E') {
                  this.$router.push({ name: 'contador_empresas' });
                } else {
                  if (this.$route.name == 'registro' || this.$route.name == 'registropedidos' || this.$route.name == 'registroloja') {
                    window.location.href = '/';
                  } else {
                    this.$emit('closeform');
                  }
                }

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function apiLoginToken(_x) {
        return _ref2.apply(this, arguments);
      }

      return apiLoginToken;
    }(),
    apiLoginNewAccount: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var sendData, login;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                sendData = { login: { email: this.email.toLowerCase() } };
                _context3.next = 3;
                return (0, _apiFunctions.apiORDSapp)(this, 'tokennewaccount/', 'post', sendData);

              case 3:
                login = _context3.sent;

                if (!login.errmessages) {
                  _context3.next = 10;
                  break;
                }

                this.errmessages = login.errmessages;
                this.logando = false;
                return _context3.abrupt('return');

              case 10:
                if (!(login.status == 'invalid')) {
                  _context3.next = 14;
                  break;
                }

                this.errmessages = login.message;
                this.logando = false;
                return _context3.abrupt('return');

              case 14:

                this.apiLoginToken(login);

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function apiLoginNewAccount() {
        return _ref3.apply(this, arguments);
      }

      return apiLoginNewAccount;
    }()
  }
};

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {},

    data: function data() {
        return {
            errmessages: null, //armazena as mensagens de validacao do servidor para mostrar em tela
            // estagio: '',

            ativando: true,
            sucesso: false,

            uuid: ''

            // aplicativos: [
            //     { title: "Controle de Pedidos", descricao: "Receba pedidos lançados pelos seus representantes", selected: false },
            //     { title: "Emissor de Notas Fiscais", descricao: "Controle de pedidos de venda, emissão de notas fiscais de produtos e boletos", selected: false },
            //     { title: "Emissor de Notas de Importação", descricao: "Emita notas fiscais de importação em 1 minuto", selected: false },
            //     { title: "Frente de Caixa / Varejo", descricao: "Aplicativo de frente de caixa com controle de estoque e controle financeiro", selected: false },
            // ],

        };
    },


    computed: {
        selecionados: function selecionados() {
            return this.aplicativos.filter(function (obj) {
                return obj.selected;
            });
        }
    },

    methods: {
        handleEfetuarAtivacao: function handleEfetuarAtivacao() {
            var selecionou = false;
            for (var x = 0; x < this.aplicativos.length; x++) {
                if (this.aplicativos[x].selected) {
                    selecionou = true;
                }
            }
            if (!selecionou) {
                this.errmessages = 'Selecione um aplicativo para prosseguir';
            } else {
                this.estagio = 'ativando';
            }
        },
        apiPost: function apiPost() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params, data, ativacao;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.sucesso = false;
                                _this.ativando = true;
                                params = '?uuid=' + _this.uuid;
                                data = { aplicativos: _this.aplicativos };
                                _context.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSapp"])(_this, 'assinatura/ativar' + params, 'post', data);

                            case 6:
                                ativacao = _context.sent;

                                _this.$appLoading(false);

                                if (!ativacao.errmessages) {
                                    _context.next = 14;
                                    break;
                                }

                                _this.ativando = false;
                                _this.errmessages = login.errmessages;
                                return _context.abrupt('return');

                            case 14:
                                _this.ativando = false;
                                _this.sucesso = true;

                            case 16:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleLogin: function handleLogin() {
            this.$router.push('/login');
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    mounted: function mounted() {},
    created: function created() {
        if (this.$route.query && this.$route.query.uuid) {
            this.uuid = this.$route.query.uuid;
        } else {
            this.$router.push('/login');
        }

        this.$scrollTo(0);
        this.apiPost();
    }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {},

    data: function data() {
        return {
            errmessages: null,
            showSenha: true,
            sucesso: false,
            senha: null,
            uuid: ''
        };
    },


    computed: {},

    methods: {
        handleConfirmar: function handleConfirmar() {
            //BOTAO Confirmar
            this.errmessages = null;

            if (this.senha !== this.senha2) {
                this.errmessages = 'As senhas não conferem';
                this.$refs.senha2.focus();
                return;
            }
            this.apiPost();
        },
        apiPost: function apiPost() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params, data, ativacao;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.sucesso = false;
                                _this.showSenha = true;
                                params = '?uuid=' + _this.uuid;
                                data = { senha: _this.senha };
                                _context.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSapp"])(_this, 'usuario/senha/' + params, 'post', data);

                            case 6:
                                ativacao = _context.sent;

                                _this.$appLoading(false);

                                if (!ativacao.errmessages) {
                                    _context.next = 14;
                                    break;
                                }

                                _this.showSenha = false;
                                _this.errmessages = login.errmessages;
                                return _context.abrupt('return');

                            case 14:
                                _this.showSenha = false;
                                _this.sucesso = true;

                            case 16:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleEnter: function handleEnter(campo) {
            if (campo === 'senha') {
                this.$refs.senha2.focus();
            } else {
                this.handleConfirmar();
            }
        },
        handleLogin: function handleLogin() {
            this.$router.push('/login');
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    mounted: function mounted() {},
    created: function created() {
        if (this.$route.query && this.$route.query.uuid) {
            this.uuid = this.$route.query.uuid;
        } else {
            this.$router.push('/login');
        }

        this.$scrollTo(0);
        this.$nextTick(function () {
            this.$refs.senha.focus();
        });
    }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},

  data: function data() {
    return {
      email: '',
      id: '',
      errmessages: null,
      title: '',
      isPagamento: false,
      showNFe: true,
      showForcaVendas: true,
      selecionaApp: true,
      sucesso: false,
      appSelected: '',
      planoFV: [{
        app: 'FV',
        plano: 'B',
        nome: 'Básico',
        valor: 120,
        descricao: ['3 usuários inclusos', 'Controle de Pedidos'],
        valor_adicional: 50,
        selected: false
      }, {
        app: 'FV',
        plano: 'I',
        nome: 'Intermediário',
        valor: 160,
        descricao: ['3 usuários inclusos', 'Controle de Pedidos', 'Controle de Rentabilidade', 'Controle de Limite de Crédito'],
        valor_adicional: 50,
        selected: false
      }, {
        app: 'FV',
        plano: 'C',
        nome: 'Completo',
        valor: 230,
        descricao: ['3 usuários inclusos', 'Controle de Pedidos', 'Controle de Rentabilidade', 'Controle de Limite de Crédito', 'Emissão de NF-e', 'Emissão de Boletos'],
        valor_adicional: 50,
        selected: false
      }],

      planoLoja: [{
        app: 'LOJA',
        plano: 'B',
        nome: 'Básico',
        valor: 130.00,
        descricao: ['Catalogo de Produtos', 'Tabela de promoções', 'Gestão dos pedidos recebidos', 'Recebimentos com cartão de crédito'],
        // valor_adicional: 50,
        selected: false
      }],

      planoNFe: [{
        app: 'NFE',
        plano: 'B',
        nome: 'Básico',
        valor: 39.90,
        descricao: ['1 Usuário', 'Emissão de NF-e de Produtos', 'Emissão de NFC-e de Consumidor'],
        valor_adicional: 39.90,
        selected: false
      }, {
        app: 'NFE',
        plano: 'I',
        nome: 'Intermediário',
        valor: 79.90,
        descricao: ['1 Usuário', 'Regras de Impostos', 'Emissão de NF-e de Produtos', 'Emissão de NFC-e de Consumidor', 'Emissão de SAT'],
        valor_adicional: 50,
        selected: false
      }, {
        app: 'NFE',
        plano: 'C',
        nome: 'Completo',
        valor: 119.9,
        descricao: ['1 Usuário', 'Controle de Pedidos', 'Emissão de NF-e de Produtos', 'Emissão de NFC-e de Consumidor', 'Emissão de SAT', 'Emissão de NF-e de importação'],
        valor_adicional: 50,
        selected: false
      }],

      planoVarejo: [{
        app: 'VAREJO',
        plano: 'B',
        nome: 'Básico',
        valor: 190.00,
        descricao: ['3 Usuários Inclusos', 'PDV on-line', 'Tabela de Preços', 'Tabela de Descontos', 'Políticas Comerciais', 'Emissão de SAT e NFc-e', 'Fechamentos'],
        valor_adicional: 50,
        selected: false
      }, {
        app: 'VAREJO',
        plano: 'I',
        nome: 'Intermediário',
        valor: 190.00,
        descricao: ['3 Usuários Inclusos', 'PDV on-line', 'Tabela de Preços', 'Tabela de Descontos', 'Políticas Comerciais', 'Emissão de SAT e NFc-e', 'Fechamentos'],
        valor_adicional: 50,
        selected: false
      }, {
        app: 'VAREJO',
        plano: 'C',
        nome: 'Completo',
        valor: 190.00,
        descricao: ['3 Usuários Inclusos', 'PDV on-line', 'Tabela de Preços', 'Tabela de Descontos', 'Políticas Comerciais', 'Emissão de SAT e NFc-e', 'Fechamentos'],
        valor_adicional: 50,
        selected: false
      }],

      recursos_concorrente: [],

      recursos_fv: [{ text: 'Importação de dados de clientes e produtos', plano1: true, plano2: true, plano3: true }, { text: 'Integração com qualquer ERP', plano1: true, plano2: true, plano3: true }, { text: 'Suporte ilimitado por chat, e-mail ou telefone', plano1: true, plano2: true, plano3: true }, { text: 'Grupos de produtos', plano1: true, plano2: true, plano3: true }, { text: 'Produtos com fotos', plano1: true, plano2: true, plano3: true }, { text: 'Grupos de clientes', plano1: true, plano2: true, plano3: true }, { text: 'Controle de estoque', plano1: true, plano2: true, plano3: true }, { text: 'Cadastro de status de pedido', plano1: true, plano2: true, plano3: true }, { text: 'Cadastro de tipos de pedido', plano1: true, plano2: true, plano3: true }, { text: 'Cadastro de equipes de venda', plano1: true, plano2: true, plano3: true }, { text: 'Tabelas de descontos', plano1: true, plano2: true, plano3: true }, { text: 'Tabelas de destaques', plano1: true, plano2: true, plano3: true }, { text: 'Tabela de preço por vendedor', plano1: true, plano2: true, plano3: true }, { text: 'Tabela de preço por cliente', plano1: true, plano2: true, plano3: true }, { text: 'Relatório de produtos vendidos por valor/quantidade', plano1: true, plano2: true, plano3: true }, { text: 'Relatório de clientes', plano1: true, plano2: true, plano3: true }, { text: 'Relatório/Indicador de evolução das vendas', plano1: true, plano2: true, plano3: true }, { text: 'Relatório/Indicador clientes ativos, inativos', plano1: true, plano2: true, plano3: true }, { text: 'Relatório de curva ABC de clientes', plano1: true, plano2: true, plano3: true }, { text: 'Desconto máximo por usuário', plano1: false, plano2: true, plano3: true }, { text: 'Agenda de atividades', plano1: false, plano2: true, plano3: true }, { text: 'Metas de venda', plano1: false, plano2: true, plano3: true }, { text: 'Rentabilidade do pedido', plano1: false, plano2: true, plano3: true }, { text: 'Bloqueio de rentabilidade por usuário', plano1: false, plano2: true, plano3: true }, { text: 'Controle de limite de crédito', plano1: false, plano2: true, plano3: true, novo: false }, { text: 'Alerta de títulos vencidos', plano1: false, plano2: true, plano3: true }, { text: 'Emissão de NF-e de produtos', plano1: false, plano2: false, plano3: true, novo: false }, { text: 'CRM Oportunidades de venda', plano1: false, plano2: false, plano3: true }]

    };
  },


  computed: {
    selecionados: function selecionados() {
      return this.planoFV.filter(function (obj) {
        return obj.selected;
      });
    },

    isEndTrial: function isEndTrial() {
      return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appEndTrial;
    },

    isBlocked: function isBlocked() {
      return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appBlocked;
    }

  },

  methods: {
    handleTestar: function handleTestar(app, plano) {
      this.$router.push('registro/' + app + '/' + plano);
    },
    handleLogin: function handleLogin() {
      this.$router.push('/login');
    },
    handleSelecionaApp: function handleSelecionaApp(id) {
      this.appSelected = id;
      this.$nextTick(function () {
        var elmnt = document.getElementById(id);
        elmnt.scrollIntoView({ behavior: 'smooth', block: 'start' }); //POSICIONA NO ELEMENTO
      });
    },
    apiPost: function apiPost() {

      // this.$appLoading(true)
      // var params = '?email=' + this.email + '&id=' + this.id
      // const ativacao = await apiORDSapp(this, 'assinatura/ativar' + params, 'get', null)
      // this.$appLoading(false)
      // if (ativacao.errmessages) {
      //   this.errmessages = login.errmessages
      //   return
      // } else {
      //   this.title = 'Sua conta foi ativada. Você será redirecionado à tela de login.'
      //   this.showLogin = true
      // }

      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleAssinar: function handleAssinar(app, plano) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var sendData, pagseguro, self, resultOptions;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:

                _this2.$appLoading(true);
                sendData = { codplan: plano, app: app };
                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSapp"])(_this2, 'sessao/pagseguro/', 'post', sendData);

              case 4:
                pagseguro = _context2.sent;

                _this2.$appLoading(false);

                self = _this2;

                window.open(pagseguro.link, "_blank");
                self.$appLoading(false);
                resultOptions = {};

                resultOptions.updateDataTable = false;
                self.selecionaApp = false;
                self.sucesso = true;

                // window.PagSeguroLightbox({
                //         code: pagseguro.code
                //     },
                //     {
                //         success: function (transactionCode) {
                //             //ATUALIZA O CODIGO DA TRANSACAO NO CODIGO DE AUTENTICACAO (TABELA PAG)
                //             self.$appLoading(true)
                //             const tr = apiORDSapp(self, 'sessao/pagseguro/' + pagseguro.code + '/trcode/' + transactionCode, 'post', null)
                //             self.$appLoading(false)
                //             var resultOptions = {};
                //             resultOptions.updateDataTable = false;
                //             self.selecionaApp = false
                //             self.sucesso = true
                //             // $uibModalInstance.close(resultOptions);
                //         },
                //         abort: function () {
                //             self.$erpToastError('O processo de pagamento foi cancelado, sua assinatura não será renovada.');
                //             var resultOptions = {};
                //             resultOptions.updateDataTable = false;
                //             // $uibModalInstance.close(resultOptions);
                //         }
                //     })

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },

  components: {},

  mounted: function mounted() {
    if (this.isEndTrial && !__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appNFe) this.showNFe = false;

    if (this.isEndTrial && !__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appForcaVendas) this.showForcaVendas = false;
    console.log(this.isBlocked);
    console.log(this.isEndTrial);
    this.isPagamento = this.isEndTrial || this.isBlocked;
    if (this.$route.name == 'assinar') {
      this.isPagamento = true;
    }
  },
  created: function created() {}
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_minha_conta_form_vue__ = __webpack_require__(457);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_551eae18_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_minha_conta_form_vue__ = __webpack_require__(1262);
function injectStyle (ssrContext) {
  __webpack_require__(1258)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_minha_conta_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_551eae18_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_minha_conta_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_alert_asaas_vue__ = __webpack_require__(1260);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},

  data: function data() {
    return {
      errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
      plano: {},
      params: null
    };
  },


  computed: {
    appNFe: function appNFe() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appNFe;
    },


    administrador: function administrador() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador;
    },

    usuarios: function usuarios() {
      if (this.qtUsuarios == 1) return this.qtUsuarios + ' Usuário';else return this.qtUsuarios + ' Usuários';
    },
    planoVencido: function planoVencido() {
      if (!this.isTrial && this.plano.plano_atual) return this.plano.plano_atual.diasrestantes == 0;else return true;
    },

    istrial: function istrial() {
      return this.$store.getters.getSessao.istrial == 'S';
    },

    fimPeriodoTeste: function fimPeriodoTeste() {
      return this.$store.getters.getSessao.isendtrial == 'S';
    },

    labelAssinar: function labelAssinar() {
      if (this.plano.plano_atual && this.plano.plano_atual.istrial) return 'Assinar e Ativar Minha Conta';else return 'Renovar';
    }

  },

  watch: {},

  methods: {
    handleIncrementAddons: function handleIncrementAddons() {
      var params = {
        app: this.plano.app[0].app,
        planoAtual: this.plano.app[0].plano,
        complementos: this.plano.addons,
        dadosFaturamento: this.plano.dadosFaturamento,
        recorrencia: this.plano.app[0].tipo,
        diasRestantes: this.plano.plano_atual.diasrestantes
      };
      __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].planosParams = params;

      this.$router.push('/planos/complementos');
    },
    closeForm: function closeForm() {
      this.$emit('closeform');
    },
    handleTrocarPlano: function handleTrocarPlano() {
      var params = {
        trocaPlano: true,
        app: this.plano.app[0].app,
        planoAtual: this.plano.app[0].plano,
        valorCredito: this.plano.plano_atual.valor_saldo,
        complementos: this.plano.addons,
        dadosFaturamento: this.plano.dadosFaturamento,
        recorrencia: this.plano.app[0].tipo
      };
      __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].planosParams = params;
      this.$router.push('/planos/erp');
    },
    handleAtivar: function handleAtivar() {
      var _params;

      var app = this.plano.plano_atual.controle_app;
      var tipo = 'MENSAL';
      if (this.plano.app.length > 0) {
        app = this.plano.app[0].app;
        tipo = this.plano.app[0].tipo;
      }
      var params = (_params = {
        app: app,
        complementos: this.plano.addons,
        trocaPlano: true,
        renovacao: false
      }, _defineProperty(_params, 'complementos', this.plano.addons), _defineProperty(_params, 'dadosFaturamento', this.plano.dadosFaturamento), _defineProperty(_params, 'recorrencia', tipo), _defineProperty(_params, 'valorCredito', 0), _params);

      if (!this.istrial) if (!this.fimPeriodoTeste && !this.planoVencido) {
        params.planoAtual = this.plano.app[0].plano;
        params.renovacao = true;
      }

      __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].planosParams = params;

      if (app == 'NFE') this.$router.push('/planos/nfe'); //app antigo NFE
      else this.$router.push('/planos/erp');
    },
    updateCep: function updateCep() {
      //CARREGA INFORMACOES DO CEP
      this.plano.dadosFaturamento.endereco = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.logradouro;
      this.plano.dadosFaturamento.bairro = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.bairro;
      this.plano.dadosFaturamento.codmun = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.ibge;
      this.plano.dadosFaturamento.uf = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.uf;
    },
    loadData: function loadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                // apiORDS(this.$store.getters.urlOrds + 'sessao/meuplano').then((result) => {
                Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSapp"])(_this, 'sessao/meuplano/', 'get', null).then(function (result) {
                  if (result) _this.plano = result;else _this.plano = { plano_atual: {}, historico: [] };
                });

                _this.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleSalvarDados: function handleSalvarDados() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this2.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          _this2.apiPost();
        }
      });
    },
    apiPost: function apiPost() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var sendData, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                sendData = {};

                sendData = _this3.plano.dadosFaturamento;

                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSapp"])(_this3, 'sessao/meuplano/dadosfaturamento/', 'post', sendData);

              case 4:
                data = _context2.sent;

                if (data.errmessages) {
                  _this3.errmessages = data.errmessages;
                  _this3.$erpToastError('Alguns erros precisam ser corrigidos.');
                } else {
                  _this3.$erpToastUpdated();
                  _this3.errmessages = {};
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  },

  components: {
    AlertAsaas: __WEBPACK_IMPORTED_MODULE_3__components_alert_asaas_vue__["a" /* default */]
  },

  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
  },
  created: function created() {
    this.crudText = this.$crudText(this.crud);

    this.loadData();

    this.$scrollTo(0);
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//

// import FilialForm from "../forms/filial-form";

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},

  props: {},

  data: function data() {
    return {};
  },


  methods: {},

  computed: {},

  created: function created() {},
  mounted: function mounted() {}
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    saldoPlanoAtual: { Type: Number },
    planoAtual: { Type: String }
  },

  data: function data() {
    return {
      errmessages: null,
      title: '',
      sucesso: false,

      dadosFaturamento: {},
      hasValid: false,
      currentPlan: null,
      periodo: 1,

      periodos: [{ nome: 'Mensal', selected: false }, { nome: 'Trimestral', selected: true }],

      planoNFe: [{
        app: 'NFE',
        plano: 'BTRIM',
        nome: 'Básico Trimestral',
        valor: 49.90,
        total_text: 'R$ 149,70 por Trimestre',
        descricao: ['1 CNPJ', 'Emissão de NF-e de Produtos', 'Emissão de NFC-e de Consumidor', 'Suporte via CHAT'],
        valor_adicional: 0,
        desconto_troca_plano: 0,
        selected: false
      }]

    };
  },


  computed: {

    isEndTrial: function isEndTrial() {
      return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appEndTrial;
    }

  },

  methods: {
    loadParams: function loadParams() {
      var params = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].planosParams;
      this.currentPlan = null;
      this.dadosFaturamento = null;

      if (params) {
        this.currentPlan = params.planoAtual;
        this.dadosFaturamento = params.dadosFaturamento;
      }

      if (!this.dadosFaturamento) {
        this.dadosFaturamento = {
          tppessoa: 'J',
          nome: null,
          cnpj: '',
          cpf: '',
          cep: null,
          endereco: null,
          bairro: null,
          uf: null,
          codmun: null,
          complemento: null,
          nr: null,
          fone: null
        };
      }

      if (!this.dadosFaturamento.tppessoa) {
        this.dadosFaturamento.tppessoa = 'J';
      }
    },
    handleSelectPeriodo: function handleSelectPeriodo(idx) {
      this.periodos[this.periodo].selected = false;
      this.periodo = idx;
      this.periodos[this.periodo].selected = true;
    },
    handleLogin: function handleLogin() {
      this.$router.push('/login');
    },
    handleInicio: function handleInicio() {
      window.location.href = '/';
    },
    apiPost: function apiPost() {

      // this.$appLoading(true)
      // var params = '?email=' + this.email + '&id=' + this.id
      // const ativacao = await apiORDSapp(this, 'assinatura/ativar' + params, 'get', null)
      // this.$appLoading(false)
      // if (ativacao.errmessages) {
      //   this.errmessages = login.errmessages
      //   return
      // } else {
      //   this.title = 'Sua conta foi ativada. Você será redirecionado à tela de login.'
      //   this.showLogin = true
      // }

      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleAssinar: function handleAssinar(app, plano) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var objeto, sendData, pagseguro, self, resultOptions;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.handleValidadados();

              case 2:
                if (!_this2.hasValid) {
                  _context2.next = 23;
                  break;
                }

                objeto = {};

                objeto.plano = plano;
                objeto.codplan = plano;
                objeto.app = app;
                objeto.dadosFaturamento = _this2.dadosFaturamento;
                if (_this2.dadosFaturamento.tppessoa == 'J') objeto.dadosFaturamento.cnpj = _this2.dadosFaturamento.cnpj;else objeto.dadosFaturamento.cpf = _this2.dadosFaturamento.cpf;

                _this2.$appLoading(true);
                sendData = objeto;
                _context2.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSapp"])(_this2, 'sessao/pagseguro/', 'post', sendData);

              case 13:
                pagseguro = _context2.sent;

                _this2.$appLoading(false);

                self = _this2;

                console.log(pagseguro);
                window.open(pagseguro.link, "_blank");
                self.$appLoading(false);
                resultOptions = {};

                resultOptions.updateDataTable = false;
                self.sucesso = true;

                _this2.planSubscriptionSteps = [1];

              case 23:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateCep: function updateCep() {
      //CARREGA INFORMACOES DO CEP
      this.dadosFaturamento.endereco = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.logradouro;
      this.dadosFaturamento.bairro = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.bairro;
      this.dadosFaturamento.codmun = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.ibge;
      this.dadosFaturamento.uf = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.uf;
    },
    handleValidadados: function handleValidadados() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$validator.validateAll().then(function (isValid) {
                  _this3.hasValid = false;
                  if (!isValid || !_this3.dadosFaturamento.cnpj && !_this3.dadosFaturamento.cpf) {
                    _this3.$refs.nome.focus();
                    _this3.$erpToastError(!_this3.dadosFaturamento.cnpj && !_this3.dadosFaturamento.cpf ? 'Por favor, verifique se o campo de CNPJ ou CPF e os demais campos estão preenchidos' : 'Por favor, corrija os campos em destaque para continuar');
                  } else if (!isValid || !Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["isValidPostalCode"])(_this3.dadosFaturamento.cep)) {
                    _this3.$refs.nome.focus();
                    _this3.$erpToastError(!Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["isValidPostalCode"])(_this3.dadosFaturamento.cep) ? 'Por favor, verifique se o campo CEP e os demais campos estão preenchidos corretamente' : 'Por favor, corrija os campos em destaque para continuar');
                  } else {
                    _this3.hasValid = true;
                  }
                });

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  },

  components: {},

  mounted: function mounted() {
    this.loadParams();

    for (var x = 0; x < this.planoNFe.length; x++) {
      if (this.planoNFe[x].plano != this.planoAtual) this.planoNFe[x].desconto_troca_plano = this.saldoPlanoAtual;
    }
  },
  created: function created() {}
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_planos_precos_checklist_vue__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PlanosCheckList: __WEBPACK_IMPORTED_MODULE_2__components_planos_precos_checklist_vue__["a" /* default */]
  },
  props: {
    saldoPlanoAtual: { Type: Number },
    planoAtual: { Type: String }
  },
  data: function data() {
    return {
      showTooltipComplemento: false,
      dadosFaturamento: {},
      hasValid: false,
      planSubscriptionSteps: [1],
      indexRecorrencias: 'M',
      toggleRecorrencia: 'M',
      renovacao: false,
      changePlan: false,
      currentPlan: null,
      currentRecorrencia: null,
      credit: 0,
      title: '',
      errmessages: null,
      sucesso: false,
      pagseguro: { code: null, link: null },

      periodoSelecionado: null,
      complementosSelecionados: null,
      showComplementos: false,
      resumo: {},
      plans: {},
      plano: {}

    };
  },


  computed: {
    getBillingMethod: function getBillingMethod() {
      var tipoSelecionado = this.selectedRecurso.tipo;

      return tipoSelecionado == 'ANUAL' ? 12 : tipoSelecionado == 'SEMESTRAL' ? 6 : tipoSelecionado == 'TRIMESTRAL' ? 3 : 1;
    },
    selectedPlan: function selectedPlan() {
      var selected = null;
      if (this.plans && this.plans.planos && this.plans.planos.length > 0) {
        selected = this.plans.planos.find(function (plan) {
          return plan.selected === true;
        });
      }
      return selected;
    },
    selectedRecurso: function selectedRecurso() {
      var selectedPlan = null;
      if (this.plans && this.plans.planos && this.plans.planos.length > 0) {
        selectedPlan = this.plans.planos.find(function (plan) {
          return plan.selected ? plan.selected : null;
        });
      }
      var selectedRec = {};

      if (selectedPlan) {
        selectedRec = selectedPlan.recorrencias.find(function (rec) {
          return rec.selected ? rec.selected : null;
        });
      }
      if (selectedPlan) {
        return selectedRec;
      }
    },
    selectedComplemento: function selectedComplemento() {
      var selectedPlan = this.plans.planos.find(function (plan) {
        return plan.selected;
      });
      var selectedsComp = {
        addons: [],
        precoTotal: 0
      };

      if (selectedPlan) {
        selectedPlan.addons.forEach(function (comp) {
          if (comp.selected) {
            selectedsComp.addons.push(comp);
            selectedsComp.precoTotal = selectedsComp.precoTotal + comp.precoMensal;
          }
        });
      }
      if (selectedsComp) {
        return selectedsComp;
      }
    },
    isEndTrial: function isEndTrial() {
      return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appEndTrial;
    },

    isBlocked: function isBlocked() {
      return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appBlocked;
    }

  },

  methods: {
    hasRecorrencia: function hasRecorrencia(tipo) {
      if (!this.plans || !this.plans.planos) return false;

      return this.plans.planos.some(function (plano) {
        return plano.recorrencias && plano.recorrencias.some(function (recorrencia) {
          return recorrencia.tipo && recorrencia.tipo.startsWith(tipo.toUpperCase());
        });
      });
    },
    getprecoMensal: function getprecoMensal(plano, tipo) {
      var value = plano.recorrencias.find(function (obj) {
        return obj.tipo.startsWith(tipo);
      });
      return value ? value.precoMensal : 0;
    },
    getprecoTotal: function getprecoTotal(plano, tipo) {
      var value = plano.recorrencias.find(function (obj) {
        return obj.tipo.startsWith(tipo);
      });
      return value ? value.precoTotal : 0;
    },
    handleShowTooltip: function handleShowTooltip(indice) {
      if (!this.selectedPlan.addons[indice].showTooltip) {
        this.$set(this.selectedPlan.addons[indice], 'showTooltip', true);
      } else {
        this.$set(this.selectedPlan.addons[indice], 'showTooltip', false);
      }
    },
    updateCep: function updateCep() {
      //CARREGA INFORMACOES DO CEP
      this.dadosFaturamento.endereco = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.logradouro;
      this.dadosFaturamento.bairro = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.bairro;
      this.dadosFaturamento.codmun = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.ibge;
      this.dadosFaturamento.uf = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.uf;
    },
    handleValidadados: function handleValidadados() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validator.validateAll().then(function (isValid) {
                  _this.hasValid = false;
                  if (!isValid || !_this.dadosFaturamento.cnpj && !_this.dadosFaturamento.cpf) {
                    _this.$refs.nome.focus();
                    _this.$erpToastError(!_this.dadosFaturamento.cnpj && !_this.dadosFaturamento.cpf ? 'Por favor, verifique se o campo de CNPJ ou CPF e os demais campos estão preenchidos' : 'Por favor, corrija os campos em destaque para continuar');
                  } else if (!isValid || !_this.selectedPlan && !_this.selectedRecurso) {
                    _this.$refs.nome.focus();
                    _this.$erpToastError(!_this.selectedPlan && !_this.selectedRecurso ? 'Por favor, selecionar um plano' : 'Por favor, corrija os campos em destaque para continuar');
                  } else if (!isValid || !Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["isValidPostalCode"])(_this.dadosFaturamento.cep)) {
                    _this.$refs.nome.focus();
                    _this.$erpToastError(!Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["isValidPostalCode"])(_this.dadosFaturamento.cep) ? 'Por favor, verifique se o campo CEP e os demais campos estão preenchidos corretamente' : 'Por favor, corrija os campos em destaque para continuar');
                  } else {
                    _this.hasValid = true;
                  }
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleBackStepToPlan: function handleBackStepToPlan() {
      var wrapDocument = document.getElementsByClassName('registro')[0];
      wrapDocument.scrollTop = 0;

      if (this.planSubscriptionSteps.length <= 1) {
        this.$router.push('/');
      }
      if (this.planSubscriptionSteps.length <= 2 && this.selectedComplemento) {
        this.loadDataPlans();
      }
      this.planSubscriptionSteps.pop();
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },
    handleAddStepToPlan: function handleAddStepToPlan() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var wrapDocument;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                wrapDocument = document.getElementsByClassName('registro')[0];

                wrapDocument.scrollTop = 0;

                if (_this2.selectedPlan && _this2.selectedPlan.id == 'free') {
                  while (_this2.planSubscriptionSteps.length <= 3) {
                    _this2.planSubscriptionSteps.push(_this2.planSubscriptionSteps.length + 1);
                  }
                }

                if (!(_this2.planSubscriptionSteps.length == 3)) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 6;
                return _this2.handleValidadados();

              case 6:
                if (!(_this2.planSubscriptionSteps.length < 4)) {
                  _context2.next = 10;
                  break;
                }

                if (!(_this2.planSubscriptionSteps.length == 3 && !_this2.hasValid)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt('return');

              case 9:
                _this2.planSubscriptionSteps.push(_this2.planSubscriptionSteps.length + 1);

              case 10:
                if (_this2.planSubscriptionSteps.length == 2 && _this2.selectedPlan && _this2.selectedPlan.addons.length <= 0) {
                  _this2.planSubscriptionSteps.push(_this2.planSubscriptionSteps.length + 1);
                }

                if (_this2.planSubscriptionSteps.length == 4) {
                  _this2.handleAssinar();
                }

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getPriceDesc: function getPriceDesc(value) {
      if (value != 0 && this.credit) {
        return Math.abs(value - this.credit);
      } else {
        return value;
      }
    },
    handleSelectPlan: function handleSelectPlan(indexPlan) {
      var _this3 = this;

      var indexRec = this.indexRecorrencias;

      this.plans.planos.forEach(function (plan, index) {
        _this3.$set(_this3.plans.planos[index], 'selected', false);
        plan.recorrencias.map(function (el) {
          _this3.$set(el, 'selected', false);
        });
      });

      var plano = this.plans.planos[indexPlan];
      if (plano) {
        this.$set(plano, 'selected', true);
        var recorrencia = plano.recorrencias.find(function (obj) {
          return obj.tipo.startsWith(indexRec);
        });
        if (recorrencia) {
          this.$set(recorrencia, 'selected', true);
        }
      }
    },
    loadParams: function loadParams() {
      var params = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].planosParams;
      this.changePlan = null;
      this.renovacao = null;
      this.currentPlan = null;
      this.currentRecorrencia = null;
      this.credit = null;
      this.dadosFaturamento = null;

      if (params) {
        this.changePlan = params.trocaPlano;
        this.renovacao = params.renovacao;
        this.currentPlan = params.planoAtual;
        this.currentRecorrencia = params.recorrencia;
        this.credit = params.valorCredito;
        this.dadosFaturamento = params.dadosFaturamento;
      }

      if (!this.dadosFaturamento) {
        this.dadosFaturamento = {
          tppessoa: 'J',
          nome: null,
          cnpj: '',
          cpf: '',
          cep: null,
          endereco: null,
          bairro: null,
          uf: null,
          codmun: null,
          complemento: null,
          nr: null,
          fone: null
        };
      }

      if (!this.dadosFaturamento.tppessoa) {
        this.dadosFaturamento.tppessoa = 'J';
      }
    },
    setFeaturedPlan: function setFeaturedPlan(index) {
      var _this4 = this;

      if (this.plans.planos) {
        this.loadParams();
        var plans = this.plans.planos;
        var currentPlan = '' + this.currentPlan;
        var currentRecorrencia = '' + this.currentRecorrencia;

        var hasFeatured = false;
        var indice = index ? index : 'M';

        if (this.changePlan || !this.renovacao) {

          var planSelected = plans.find(function (obj) {
            return obj.selected;
          });
          plans.forEach(function (plan, i) {

            if (!planSelected && plan.id == _this4.plano.plano) {
              _this4.$set(plan, 'selected', true);
            }
            _this4.$set(plan, 'recomendado', false);
            _this4.$set(plan, 'disabled', true);

            var recorrencia = plan.recorrencias.find(function (obj) {
              return obj.tipo.startsWith(indice);
            });
            var precoTotal = recorrencia ? recorrencia.precoTotal : 0;

            if (plan.selected) {
              _this4.currentRecorrencia = recorrencia.tipo;
              _this4.handleSelectPlan(i);
            }
            var credit = _this4.credit || 0;
            if (credit <= 0 || credit > 0 && precoTotal > credit && !(plan.id == currentPlan)) {
              _this4.$set(plan, 'disabled', false);
            } else {
              if (recorrencia) {
                _this4.$set(recorrencia, 'selected', false); // Atribuindo atriuto select para que atributo seja reativo ao DOM
              }
            }

            if (!plan.disabled && !hasFeatured) {

              if (currentPlan == plan.id) {
                return;
              } else {
                hasFeatured = true;
              }
            }
          });
        } else {

          this.credit = 0;

          for (var _index = 0; _index < plans.length; _index++) {
            var plan = plans[_index];
            if (!(plan.id == currentPlan)) {
              plans.splice(_index, 1);
              _index--;
            }
          }

          if (!this.renovacao) {
            for (var _index2 = 0; _index2 < plans[0].recorrencias.length; _index2++) {
              var rec = plans[0].recorrencias[_index2];
              if (!(rec.tipo == currentRecorrencia)) {
                plans[0].recorrencias.splice(_index2, 1);
                _index2--;
              }
            }
          }
          if (plans.length > 0) {
            this.$set(plans[0], 'disabled', false);
            this.$set(plans[0], 'selected', true);
            var firstLetter = currentRecorrencia ? currentRecorrencia.substr(0, 1) : 'M';
            var recIndex = plans[0].recorrencias.findIndex(function (rec) {
              return rec.tipo.startsWith(firstLetter);
            });
            if (recIndex === -1) recIndex = 0;
            plans[0].recorrencias.forEach(function (rec, i) {
              _this4.$set(rec, 'selected', i === recIndex);
            });
          }
        }
      }
    },
    loadDataPlans: function loadDataPlans() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:

                _this5.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                  this.unwatch = false;
                });

                _context3.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSapp"])(_this5, 'sessao/meuplano/', 'get', null).then(function (result) {
                  if (result && result.app && result.app.length > 0) _this5.plano = result.app[0];else _this5.plano = {};
                });

              case 3:

                if (_this5.plano && _this5.plano.tipo) {
                  _this5.currentRecorrencia = _this5.plano.tipo;
                  _this5.indexRecorrencias = _this5.currentRecorrencia.substr(0, 1);
                  _this5.toggleRecorrencia = _this5.currentRecorrencia.substr(0, 1);
                }

                _context3.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDS"])(_this5.$store.getters.urlApp + '/planos/').then(function (data) {
                  var app = 'ERP5';
                  if (_this5.plano.app) {
                    app = _this5.plano.app;
                  }
                  _this5.plans = _extends({}, data[app]);

                  _this5.plans.planos.map(function (el) {
                    _this5.$set(el, 'nome_tag', (el.app + "_" + el.id).toLowerCase().trim());
                  });
                });

              case 6:
                if (_this5.changePlan || _this5.renovacao) {
                  _this5.toggleRecorrencia = _this5.currentRecorrencia.substr(0, 1);
                  _this5.setFeaturedPlan(_this5.toggleRecorrencia);
                } else {
                  _this5.setFeaturedPlan();
                }

                _this5.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    handleSelectPeriodo: function handleSelectPeriodo(idx) {
      this.periodoSelecionado = idx;
      this.periodos.map(function (p) {
        return p.selected = false;
      });
      this.periodos[idx].selected = true;
      this.handleCalcValores();
    },
    handleLogin: function handleLogin() {
      this.$router.push('/login');
    },
    handleInicio: function handleInicio() {
      window.location.href = '/';
    },
    handleScrollTo: function handleScrollTo() {
      var element = document.getElementById("complementos");
      element.scrollIntoView({
        behavior: "smooth"
      });
    },
    handleShowComplementos: function handleShowComplementos() {
      this.showComplementos = true;
    },
    handleAssinar: function handleAssinar() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var objeto, sendData, self, resultOptions;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                objeto = {};

                objeto.plano = _this6.selectedPlan.id;
                objeto.app = _this6.selectedPlan.app;
                objeto.recorrencia = _this6.toggleRecorrencia;
                objeto.trocaPlano = _this6.changePlan;
                objeto.complementos = new Array();

                _this6.selectedPlan.addons.forEach(function (ad) {
                  if (ad.selected) {
                    objeto.complementos.push({
                      uuid: ad.uuid,
                      quantidade: null
                    });
                  }
                });

                objeto.dadosFaturamento = _this6.dadosFaturamento;
                if (_this6.dadosFaturamento.tppessoa == 'J') objeto.dadosFaturamento.cnpj = _this6.dadosFaturamento.cnpj;else objeto.dadosFaturamento.cpf = _this6.dadosFaturamento.cpf;

                _this6.$appLoading(true);
                sendData = objeto;
                _context4.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSapp"])(_this6, 'sessao/pagseguro/', 'post', sendData);

              case 13:
                _this6.pagseguro = _context4.sent;

                _this6.$appLoading(false);

                self = _this6;


                if (_this6.pagseguro && _this6.pagseguro.plano == 'free') {
                  resultOptions = {};

                  resultOptions.updateDataTable = false;
                  self.sucesso = true;

                  _this6.planSubscriptionSteps = [1];
                } else {

                  window.open(_this6.pagseguro.link, "_self");
                  self.$appLoading(false);
                  resultOptions = {};

                  resultOptions.updateDataTable = false;
                  self.sucesso = true;

                  _this6.planSubscriptionSteps = [1];
                }

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    }
  },
  watch: {
    toggleRecorrencia: {
      handler: function handler(n) {
        if (n) {
          this.indexRecorrencias = n;
          this.setFeaturedPlan(n);
        }
        // this.plans.planos.find(plan => plan.selected = false)
      }

    }
  },
  mounted: function mounted() {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this7.loadParams();
              _context5.next = 3;
              return _this7.loadDataPlans();

            case 3:

              _this7.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
              });
              _this7.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
              });

              setTimeout(function () {
                Tawk_API.hideWidget();
              }, 1000);

            case 6:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this7);
    }))();
  },
  created: function created() {
    // this.handleSelectPeriodo(0)
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    planos: { Type: Object }
  },
  data: function data() {
    return {

      tableDetails: [{
        'id': 'RG',
        'desc': 'Recursos gerais',
        'title': true
      }, {
        'id': 'usu',
        'desc': 'Usuário(s)',
        'erp2_0-2023': '1',
        'erp2_1-2023': '3',
        'erp2_2-2023': '10',
        'erp3_0-2023': '1',
        'erp3_1-2023': '3',
        'erp3_2-2023': '3',
        'erp3_3-2023': '10',
        'erp3_free': '1',
        'erp4_0-2025': '1',
        'erp4_1-2025': '3',
        'erp4_free': '1',
        'erp5_0-2026': '1',
        'erp5_1-2026': '3',
        'erp5_2-2026': '10',
        'title': false
      }, {
        'id': 'imp ',
        'desc': 'Importar dados de cliente pelo CNPJ da SEFAZ/Receita',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'imp',
        'desc': 'Importar cadastros de produtos e clientes por XML',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'gradeprod',
        'desc': 'Grade de produtos (cor, tamanho)',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'imgprod',
        'desc': 'Imagens nos produtos',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'tabpre',
        'desc': 'Tabela de preço',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'tabdesc',
        'desc': 'Tabela de descontos',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'suporte',
        'desc': 'Suporte',
        'title': true
      }, {
        'id': 'tut',
        'desc': 'Acesso a base de conhecimento e vídeos tutoriais',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'nfeEnt',
        'desc': 'Abertura de tickets',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'chat',
        'desc': 'Suporte via chat',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'fat',
        'desc': 'Faturamento',
        'title': true
      }, {
        'id': 'fatlimit',
        'desc': 'Limite de notas fiscais eletrônicas (NF-e)',
        'erp2_0-2023': '30<span class="text-[#3F3F41] text-[14px] font-normal">/mês</span>',
        'erp2_1-2023': 'ilimitada',
        'erp2_2-2023': 'ilimitada',
        'erp3_0-2023': '30<span class="text-[#3F3F41] text-[14px] font-normal">/mês</span>',
        'erp3_1-2023': 'ilimitada',
        'erp3_2-2023': 'ilimitada',
        'erp3_3-2023': 'ilimitada',
        'erp3_free': '5',
        'erp4_0-2025': '30<span class="text-[#3F3F41] text-[14px] font-normal">/mês</span>',
        'erp4_1-2025': 'ilimitada',
        'erp4_free': '5',
        'erp5_0-2026': '30<span class="text-[#3F3F41] text-[14px] font-normal">/mês</span>',
        'erp5_1-2026': '100<span class="text-[#3F3F41] text-[14px] font-normal">/mês</span>',
        'erp5_2-2026': 'ilimitada',
        'title': false
      }, {
        'id': 'cert',
        'desc': 'Certificado A1 e A3',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'calcimp',
        'desc': 'Cálculo automático de impostos',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'gerxml',
        'desc': 'Geração do XML por período',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'envxml',
        'desc': 'Envio de XML e DANFE por e-mail',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'consrnfs',
        'desc': 'Consulta e relatório de notas fiscais de saída',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'nfce',
        'desc': 'Nota fiscal de consumidor eletrônica (NFC-e)',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': '30<span class="text-[#3F3F41] text-[14px] font-normal">/mês</span>',
        'erp5_1-2026': '100<span class="text-[#3F3F41] text-[14px] font-normal">/mês</span>',
        'erp5_2-2026': 'ilimitada',

        'title': false
      }, {
        'id': 'vend',
        'desc': 'Vendas',
        'title': true
      }, {
        'id': 'grade',
        'desc': 'Orçamento',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'pedBaixaEst',
        'desc': 'Pedido de venda',
        'erp2_0-2023': false,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': false,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': false,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'pedTit',
        'desc': 'Rastreabilidade do pedido',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'consDados',
        'desc': 'Desconto sobre desconto',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'cliCart',
        'desc': 'Consulta e relatório de pedidos de venda',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'perfCart',
        'desc': 'Consulta e relatório de produtos vendidos',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'Abc',
        'desc': 'Consulta de vendas por carteira de clientes',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'clieVend',
        'desc': 'Curva ABC por clientes',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'listCli',
        'desc': 'Consulta de ranking de vendedores',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'vendRank',
        'desc': 'Anexar documentos ao pedido',
        'erp2_0-2023': false,
        'erp2_1-2023': false,
        'erp2_2-2023': true,
        'erp3_0-2023': false,
        'erp3_1-2023': false,
        'erp3_2-2023': false,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': false,
        'erp4_1-2025': false,
        'erp4_free': false,
        'erp5_0-2026': false,
        'erp5_1-2026': false,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'rep',
        'desc': 'Representante(s)',
        'erp2_0-2023': false,
        'erp2_1-2023': false,
        'erp2_2-2023': '15',
        'erp3_0-2023': false,
        'erp3_1-2023': false,
        'erp3_2-2023': false,
        'erp3_3-2023': '15',
        'erp3_free': false,
        'erp4_0-2025': false,
        'erp4_1-2025': false,
        'erp4_free': false,
        'erp5_0-2026': false,
        'erp5_1-2026': false,
        'erp5_2-2026': '10',
        'title': false
      }, {
        'id': 'est',
        'desc': 'Estoque',
        'title': true
      }, {
        'id': 'visitLim',
        'desc': 'Importação de estoque pela planilha',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'imgProd',
        'desc': 'Controle de estoque do produto por lote, validade e local',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'gradProd',
        'desc': 'Ajuste de estoque',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'tabPre',
        'desc': 'Impressão da etiqueta do produto',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'tabDesc',
        'desc': 'Consulta do estoque atual',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'intCad',
        'desc': 'Consulta do saldo em estoque com quantidade mínima',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'gruCli',
        'desc': 'Consulta da movimentação de entradas e saídas do estoque',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'fin',
        'desc': 'Financeiro',
        'title': true
      }, {
        'id': 'ctr',
        'desc': 'Contas a receber',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'ctp',
        'desc': 'Contas a pagar',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'bx',
        'desc': 'Baixa de títulos',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'nfManifesto',
        'desc': 'Baixa de títulos',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'nfIInut',
        'desc': 'Impressão do recibo',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'nfeIMpSit',
        'desc': 'Consulta de posição do financeiro',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'nfeCons&Rel',
        'desc': 'Consulta de baixas de títulos',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'Estoque',
        'desc': 'Consulta do fluxo de caixa',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'estControleProd',
        'desc': 'Consulta DRE',
        'erp2_0-2023': false,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': false,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': false,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': false,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'estExcel',
        'desc': 'Emissão de boletos',
        'erp2_0-2023': false,
        'erp2_1-2023': false,
        'erp2_2-2023': true,
        'erp3_0-2023': false,
        'erp3_1-2023': false,
        'erp3_2-2023': false,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': false,
        'erp4_1-2025': false,
        'erp4_free': false,
        'erp5_0-2026': false,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'estLote',
        'desc': 'Compras',
        'title': true
      }, {
        'id': 'estAjuste',
        'desc': 'Nota fiscal de entrada pelo arquivo XML',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': true,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': true,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'etqProd',
        'desc': 'Consulta e relatório de notas fiscais de entrada',
        'erp2_0-2023': true,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': true,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': true,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': true,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'finandestceiro',
        'desc': 'Manifestação do destinatário',
        'erp2_0-2023': false,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': false,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': false,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': false,
        'erp5_1-2026': false,
        'erp5_2-2026': true,
        'title': false
      }, {
        'id': 'titCont',
        'desc': 'Nota fiscal de importação por XML',
        'erp2_0-2023': false,
        'erp2_1-2023': true,
        'erp2_2-2023': true,
        'erp3_0-2023': false,
        'erp3_1-2023': true,
        'erp3_2-2023': true,
        'erp3_3-2023': true,
        'erp3_free': false,
        'erp4_0-2025': false,
        'erp4_1-2025': true,
        'erp4_free': false,
        'erp5_0-2026': false,
        'erp5_1-2026': true,
        'erp5_2-2026': true,
        'title': false
      }]
    };
  },

  methods: {
    isBoolean: function isBoolean(value) {
      return typeof value === "boolean";
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    saldoPlanoAtual: { Type: Number },
    planoAtual: { Type: String }
  },

  data: function data() {
    return {
      showTooltipComplemento: false,
      dadosFaturamento: {},
      hasValid: false,
      planSubscriptionSteps: [1],
      currentPlan: null,
      currentRecorrencia: null,
      diasRestantes: 0,
      title: '',
      errmessages: null,
      sucesso: false,

      showComplementos: false,
      plans: {},
      plano: {}

    };
  },


  computed: {
    getBillingMethod: function getBillingMethod() {
      var tipoSelecionado = this.selectedRecurso.tipo;

      return tipoSelecionado == 'ANUAL' ? 12 : tipoSelecionado == 'TRIMESTRAL' ? 3 : 1;
    },
    selectedPlan: function selectedPlan() {
      var _this = this;

      if (this.currentPlan) {
        var selected = this.plans.planos.find(function (plan) {
          return plan.id == _this.currentPlan;
        });
        return selected;
      }
    },
    selectedRecurso: function selectedRecurso() {
      var _this2 = this;

      if (this.currentPlan) {
        var selectedPlan = this.plans.planos.find(function (plan) {
          return plan.id == _this2.currentPlan ? plan : null;
        });

        var selectedRec = {};

        if (selectedPlan) {
          selectedRec = selectedPlan.recorrencias.find(function (rec) {
            return rec.tipo == _this2.currentRecorrencia ? rec : null;
          });
        }
        if (selectedPlan) {
          return selectedRec;
        }
      }
    },
    selectedComplemento: function selectedComplemento() {
      var _this3 = this;

      if (this.currentPlan) {
        var selectedPlan = this.plans.planos.find(function (plan) {
          return plan.id == _this3.currentPlan;
        });
        var selectedsComp = {
          addons: [],
          precoTotal: 0
        };

        if (selectedPlan) {
          selectedPlan.addons.forEach(function (comp) {
            if (comp.selected) {
              selectedsComp.addons.push(comp);
              selectedsComp.precoTotal = selectedsComp.precoTotal + comp.precoMensal;
            }
          });
        }
        if (selectedsComp) {
          return selectedsComp;
        }
      }
    },
    isEndTrial: function isEndTrial() {
      return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appEndTrial;
    },

    isBlocked: function isBlocked() {
      return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appBlocked;
    }

  },

  methods: {
    handleShowTooltip: function handleShowTooltip(indice) {

      if (!this.selectedPlan.addons[indice].showTooltip) {
        this.$set(this.selectedPlan.addons[indice], 'showTooltip', true);
      } else {
        this.$set(this.selectedPlan.addons[indice], 'showTooltip', false);
      }
    },
    updateCep: function updateCep() {
      //CARREGA INFORMACOES DO CEP
      this.dadosFaturamento.endereco = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.logradouro;
      this.dadosFaturamento.bairro = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.bairro;
      this.dadosFaturamento.codmun = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.ibge;
      this.dadosFaturamento.uf = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.uf;
    },
    handleValidadados: function handleValidadados() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.$validator.validateAll().then(function (isValid) {
                  _this4.hasValid = false;
                  if (!isValid || !_this4.dadosFaturamento.cnpjcpf) {
                    _this4.$erpToastError(!_this4.dadosFaturamento.cnpjcpf ? 'Por favor, verifique se o campo de CNPJ ou CPF e os demais campos estão preenchidos' : 'Por favor, corrija os campos em destaque para continuar');
                  } else {
                    _this4.hasValid = true;
                  }
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    handleBackStepToPlan: function handleBackStepToPlan() {
      if (this.planSubscriptionSteps.length <= 1) {
        this.$router.go(-1);
      }
      if (this.planSubscriptionSteps.length <= 2 && this.selectedComplemento) {
        this.loadDataPlans();
      }
      this.planSubscriptionSteps.pop();
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },
    handleAddStepToPlan: function handleAddStepToPlan() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:

                window.scrollBy(0, window.innerHeight);

                if (!(_this5.planSubscriptionSteps.length == 2)) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return _this5.handleValidadados();

              case 4:
                if (!(_this5.planSubscriptionSteps.length < 3)) {
                  _context2.next = 8;
                  break;
                }

                if (!(_this5.planSubscriptionSteps.length == 3 && !_this5.hasValid)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return');

              case 7:
                _this5.planSubscriptionSteps.push(_this5.planSubscriptionSteps.length + 1);

              case 8:
                if (_this5.planSubscriptionSteps.length == 3) {
                  _this5.handleAssinar();
                }

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    loadParams: function loadParams() {
      var params = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].planosParams;

      this.currentPlan = params.planoAtual;
      this.currentRecorrencia = params.recorrencia;
      this.dadosFaturamento = params.dadosFaturamento;
      this.diasRestantes = params.diasRestantes;
      if (this.dadosFaturamento.tppessoa == 'J') this.dadosFaturamento.cnpjcpf = this.dadosFaturamento.cnpj;else this.dadosFaturamento.cnpjcpf = this.dadosFaturamento.cpf;
    },
    loadDataPlans: function loadDataPlans() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:

                _this6.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                  this.unwatch = false;
                });
                _context3.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDS"])(_this6.$store.getters.urlApp + '/planos/').then(function (data) {
                  _this6.plans = _extends({}, data.ERP);
                });

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    handleInicio: function handleInicio() {
      window.location.href = '/';
    },
    handleAssinar: function handleAssinar() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var objeto, sendData, pagseguro, self, resultoptions;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                objeto = {};

                objeto.plano = _this7.selectedPlan.id;
                objeto.app = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].planosParams.app;
                objeto.recorrencia = _this7.selectedRecurso.tipo;
                objeto.newAddon = true;
                objeto.complementos = new Array();

                _this7.selectedPlan.addons.forEach(function (ad) {
                  if (ad.selected) {
                    objeto.complementos.push({
                      uuid: ad.uuid,
                      quantidade: null
                    });
                  }
                });

                objeto.dadosFaturamento = _this7.dadosFaturamento;
                if (_this7.dadosFaturamento.tppessoa == 'J') objeto.dadosFaturamento.cnpj = _this7.dadosFaturamento.cnpjcpf;else objeto.dadosFaturamento.cpf = _this7.dadosFaturamento.cnpjcpf;

                _this7.$appLoading(true);
                sendData = objeto;
                _context4.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSapp"])(_this7, 'sessao/pagseguro/', 'post', sendData);

              case 13:
                pagseguro = _context4.sent;

                _this7.$appLoading(false);

                self = _this7;


                window.open(pagseguro.href, "_blank");
                self.$apploading(false);
                resultoptions = {};

                resultoptions.updatedatatable = false;
                self.sucesso = true;
                _this7.plansubscriptionsteps = [1];

              case 22:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:

              if (!__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].planosParams) {
                _this8.$router.push('/minhaconta');
              }

              _this8.loadParams();

              _context5.next = 4;
              return _this8.loadDataPlans();

            case 4:

              _this8.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
              });

              setTimeout(function () {
                Tawk_API.hideWidget();
              }, 1000);

            case 6:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this8);
    }))();
  }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_login_js__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_login_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__api_api_login_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  componentes: {},

  props: {},

  data: function data() {
    return {

      registro: {},
      email: null,
      senha: null,
      errmessages: null, //armazena as mensagens de validacao do servidor para mostrar em tela

      logando: false,

      metadata: {
        registro: {
          email: { label: 'Email Para Login', fieldname: 'email' },
          senha: { label: 'Senha', fieldname: 'senha' }
        }
      }

    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__api_api_login_js___default.a],

  computed: {
    botaoEntrar: function botaoEntrar() {
      if (this.logando) return 'Acessando...';else return 'Entrar';
    }
  },

  methods: {
    handleEntrar: function handleEntrar() {
      this.apiLogin();
    },
    handleRecuperar: function handleRecuperar() {
      this.$router.push('recuperar');
    },
    handleEnter: function handleEnter(campo) {
      if (campo === 'email') {
        this.$refs.senha.focus();
      } else {
        this.handleEntrar();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var token, url, res, loginData, parsedApps, appsVal, normalizedLogin;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.email = _this.$route.query.email;
              token = _this.$route.query.token_autologin;

              if (!token) {
                _context.next = 17;
                break;
              }

              _this.logando = true;
              _context.prev = 4;
              url = _this.$store.getters.urlApp + 'autologin/auth';
              _context.next = 8;
              return _this.axios.post(url, { token_uuid: token });

            case 8:
              res = _context.sent;


              if (res.data && res.data.items && res.data.items.length) {
                loginData = res.data.items[0];

                // Normaliza os dados retornados pelo autologin para compatibilidade com o formato esperado de login

                parsedApps = [];
                appsVal = loginData.apps || loginData.APPS;

                if (appsVal) {
                  if (Array.isArray(appsVal)) {
                    parsedApps = appsVal;
                  } else if (typeof appsVal === 'string') {
                    try {
                      parsedApps = JSON.parse(appsVal);
                    } catch (e) {
                      parsedApps = [];
                    }
                  }
                }

                normalizedLogin = _extends({}, loginData, {
                  uuid: loginData.uuid || loginData.UUID || loginData.empresa || loginData.EMPRESA,
                  email: loginData.email || loginData.EMAIL,
                  usuarionome: loginData.usuarionome || loginData.nome || loginData.NOME,
                  empresanome: loginData.empresanome || loginData.empresa_nome || loginData.EMPRESA_NOME,
                  empresacod: loginData.empresacod || loginData.empresacod_destino || loginData.EMPRESA_COD,
                  tpempresa: loginData.tpempresa || loginData.TPEMPRESA,
                  istrial: loginData.istrial === 'S' || loginData.istrial === true || loginData.ISTRIAL === 'S' || loginData.ISTRIAL === true,
                  isendtrial: loginData.isendtrial === 'S' || loginData.isendtrial === true || loginData.ISENDTRIAL === 'S' || loginData.ISENDTRIAL === true,
                  isblocked: loginData.isblocked === 'S' || loginData.isblocked === true || loginData.ISBLOCKED === 'S' || loginData.ISBLOCKED === true,
                  apps: parsedApps
                });


                _this.apiLoginToken(normalizedLogin);
              } else {
                alert('Token de acesso expirado ou inválido.');
                _this.logando = false;
              }
              _context.next = 16;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context['catch'](4);

              alert('Erro na autenticação silenciosa.');
              _this.logando = false;

            case 16:
              return _context.abrupt('return');

            case 17:

              if (_this.email && _this.email !== '') {
                if (_this.$route.query.newaccount == 'true') {
                  _this.apiLoginNewAccount();
                } else {
                  _this.$nextTick(function () {
                    this.$refs.senha.focus();
                  });
                }
              }

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[4, 12]]);
    }))();
  },
  created: function created() {
    this.email = '';
    this.$nextTick(function () {
      this.$refs.email.focus();
    });
    this.$scrollTo(0);
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_guia_nfe_vue__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard_guia_forcavendas_vue__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dashboard_nfe_vue__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dashboard_varejo_vue__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dash_card__["a" /* default */],
    DashboardGuiaNfe: __WEBPACK_IMPORTED_MODULE_1__dashboard_guia_nfe_vue__["a" /* default */],
    DashboardGuiaForcavendas: __WEBPACK_IMPORTED_MODULE_2__dashboard_guia_forcavendas_vue__["a" /* default */],
    DashboardNfe: __WEBPACK_IMPORTED_MODULE_3__dashboard_nfe_vue__["a" /* default */],
    DashboardVarejo: __WEBPACK_IMPORTED_MODULE_4__dashboard_varejo_vue__["a" /* default */]
  },

  data: function data() {
    return {
      tabs: [],
      guiaNfe: [{ completed: true }, { completed: true }, { completed: false }, { completed: false }, { completed: false }, { completed: false }],
      idxPainelGuiaForcaVendas: null,
      idxPainelGuiaNfe: null,
      idxPainelNfe: null,
      idxPainelPedido: null,
      idxPainelVarejo: null,

      showDashboardVendas: false,
      showInicio: false,

      filter: {
        startDate: null,
        endDate: null,
        codusuario: null
      },

      activeTab: 0,
      hasGuiaUnchecked: false,
      codusuario: null,

      dashboard: {
        items: [{
          name: "evolucaovendas",
          chart: { type: "LineChart" },
          col: 12,
          detalhes: { url: "/consultas/vendas-vendedor" }
        }, { name: "DASH_VENDAS_PEDIDO", indicator: {}, col: 12 }, {
          name: "performancecarteira",
          chart: { type: "PieChart" },
          col: 4,
          detalhes: { url: "/consultas/vendas-performance-carteira" }
        }, {
          name: "carteiraclientes",
          chart: { type: "PieChart" },
          col: 4,
          detalhes: { url: "/consultas/carteiraclientes" }
        }, {
          name: "curvaclientes",
          chart: { type: "PieChart" },
          col: 4,
          detalhes: { url: "/consultas/curvacliente" }
        }, {
          name: "vendas12meses",
          chart: { type: "ColumnChart" },
          col: 12,
          detalhes: { url: "/consultas/vendas" }
        }]
      }
    };
  },


  watch: {
    codusuario: function codusuario() {
      this.filter.codusuario = this.codusuario;
      this.filter = _extends({}, this.filter);
      this.updateQuery();
    }
  },

  methods: {
    checkHasGuiaUnchecked: function checkHasGuiaUnchecked(value) {
      var hasUnchecked = false;
      value.map(function (item) {
        return item.completed == false ? hasUnchecked = true : "";
      });
      return this.hasGuiaUnchecked = hasUnchecked;
    },
    updateQuery: function updateQuery() {
      var params = new URLSearchParams();
      if (this.filter.startDate) params.set("data_inicio", this.filter.startDate);
      if (this.filter.endDate) params.set("data_termino", this.filter.endDate);
      if (this.codusuario) params.set("usuario", this.codusuario);

      var queryString = params.toString();
      var newUrl = "" + window.location.pathname + (queryString ? '?' + queryString : '');
      window.history.replaceState(window.history.state, '', newUrl);
    },
    changeTab: function changeTab(idx) {
      switch (idx) {
        case this.idxPainelGuiaNfe:
          this.$router.push("/guianfe");
          break;
        case this.idxPainelGuiaForcaVendas:
          this.$router.push("/guiapedidos");
          break;
        case this.idxPainelNfe:
          this.$router.push("/painelnfe");
          break;
        case this.idxPainelVarejo:
          this.$router.push("/painelvarejo");
          break;
        case this.idxPainelPedido:
          this.$router.push("/painelpedidos");
          break;
      }
    },
    adquireCert: function adquireCert() {
      this.$router.push("https://notabrasil.com.br/certificado-digital");
    },
    clickConsulta: function clickConsulta(url) {
      this.$router.push(url);
    },
    handleNovoPedido: function handleNovoPedido() {
      if (this.isContextoForcaVendas) {
        this.$router.push('/fv/pedidos');
      } else {
        this.clickConsulta('/pedido/novo');
      }
    },
    handleMonthChange: function handleMonthChange() {
      this.filter = _extends({}, this.filter);
      this.updateQuery();
    },
    handleClickCard: function handleClickCard(idx) {},
    loadGuiaNfe: function loadGuiaNfe() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var hasCertSessao;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("loadGuiaNFe", _this);

              case 2:

                _this.guiaNfe[0].completed = _this.dadosGuia.empresa;
                hasCertSessao = Boolean(_this.sessao && Array.isArray(_this.sessao.certificado) && _this.sessao.certificado.length > 0);

                _this.guiaNfe[1].completed = Boolean(_this.dadosGuia.certificado || hasCertSessao);
                _this.guiaNfe[2].completed = _this.dadosGuia.item;
                _this.guiaNfe[3].completed = _this.dadosGuia.cliente;
                _this.guiaNfe[4].completed = !!(_this.dadosGuia.pedido || _this.dadosGuia.varejo);
                _this.guiaNfe[5].completed = _this.dadosGuia.nf;

                if (__WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].appForcaVendas) {
                  _this.hasGuiaUnchecked = !(_this.dadosGuia.empresa && _this.dadosGuia.item && _this.dadosGuia.cliente && (_this.dadosGuia.pedido || _this.dadosGuia.varejo));
                } else {
                  _this.checkHasGuiaUnchecked(_this.guiaNfe);
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    resolveHomeTab: function resolveHomeTab() {
      if (__WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].appForcaVendas) {
        if (__WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].guia && this.hasGuiaUnchecked && this.idxPainelGuiaForcaVendas !== null) {
          this.activeTab = this.idxPainelGuiaForcaVendas;
        } else if (this.idxPainelPedido !== null) {
          this.activeTab = this.idxPainelPedido;
        } else {
          this.activeTab = this.tabs.length > 0 ? 0 : null;
        }
      } else if (__WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].guia) {
        this.activeTab = this.idxPainelGuiaNfe;
      } else {
        // ELSE DO SYSVARS.GUIA:
        // 1. Se existem registros na tabela nf, exibir painelnfe
        if (this.dadosGuia.nf && this.idxPainelNfe !== null) {
          this.activeTab = this.idxPainelNfe;
          // 2. Se existem registros na tabela pedv (tipo pedido), exibir painelPedido
        } else if (this.dadosGuia.pedido && this.idxPainelPedido !== null) {
          this.activeTab = this.idxPainelPedido;
          // 3. Se existem registros na tabela pedv (tipo pedido varejo), exibir painelVarejo
        } else if (this.dadosGuia.varejo && this.idxPainelVarejo !== null) {
          this.activeTab = this.idxPainelVarejo;
        } else {
          // Fallback se não houver registros nas tabelas
          if (this.idxPainelNfe !== null && __WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].appNFe) {
            this.activeTab = this.idxPainelNfe;
          } else if (this.idxPainelPedido !== null) {
            this.activeTab = this.idxPainelPedido;
          } else if (this.idxPainelVarejo !== null) {
            this.activeTab = this.idxPainelVarejo;
          } else {
            this.activeTab = this.tabs.length > 0 ? 0 : null;
          }
        }
      }
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch("loadSessao", _this2);

              case 2:
                _context2.next = 4;
                return _this2.$store.dispatch("loadUsuariosDashboard", _this2);

              case 4:
                _context2.next = 6;
                return _this2.$store.dispatch("loadFilial", {});

              case 6:
                _context2.next = 8;
                return _this2.loadGuiaNfe();

              case 8:
                if (_this2.$route.name === "home") {
                  _this2.resolveHomeTab();
                }
                _this2.showDashboardVendas = true;

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },

  computed: {
    dadosGuia: function dadosGuia() {
      return this.$store.getters.getGuiaNFe || {};
    },

    guiaProgresso: function guiaProgresso() {
      if (__WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].appForcaVendas) {
        var _completed = 0;
        if (this.dadosGuia.empresa) _completed++;
        if (this.dadosGuia.item) _completed++;
        if (this.dadosGuia.cliente) _completed++;
        if (this.dadosGuia.pedido || this.dadosGuia.varejo) _completed++;
        return {
          completed: _completed,
          total: 4,
          percent: Math.round(_completed / 4 * 100)
        };
      }
      var completed = this.guiaNfe.filter(function (item) {
        return item.completed;
      }).length;
      return {
        completed: completed,
        total: 6,
        percent: Math.round(completed / 6 * 100)
      };
    },

    showTabPedido: function showTabPedido() {
      return this.activeTab == this.idxPainelPedido;
    },

    showTabGuiaNFe: function showTabGuiaNFe() {
      return this.activeTab == this.idxPainelGuiaNfe;
    },

    showTabGuiaForcaVendas: function showTabGuiaForcaVendas() {
      return this.activeTab == this.idxPainelGuiaForcaVendas;
    },

    showTabNFe: function showTabNFe() {
      return this.activeTab == this.idxPainelNfe;
    },

    showTabVarejo: function showTabVarejo() {
      return this.activeTab == this.idxPainelVarejo;
    },

    sessao: function sessao() {
      return this.$store.getters.getSessao;
    },

    usuarioList: function usuarioList() {
      var options = [];
      var list = this.$store.getters.getUsuarioList || [];
      for (var x = 0; x < list.length; x++) {
        options.push({
          id: list[x].codusuario,
          text: list[x].nome
        });
      }
      return options;
    },

    appNFe: function appNFe() {
      return __WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].appNFe;
    },

    appERP: function appERP() {
      return __WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].appERP;
    },

    appForcaVendas: function appForcaVendas() {
      return __WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].appForcaVendas;
    },

    isContextoForcaVendas: function isContextoForcaVendas() {
      return !!(__WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].usuarioForcaVendas || this.appForcaVendas && !this.appERP && !this.appNFe);
    },

    showBtnEmitirNfe: function showBtnEmitirNfe() {
      if (this.isContextoForcaVendas) return false;
      return !!(this.appNFe || this.appERP);
    },

    isAdmin: function isAdmin() {
      return __WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].usuarioAdministrador;
    },

    guia: function guia() {
      return __WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].guia;
    },

    isRepresentante: function isRepresentante() {
      return !!(__WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].usuarioForcaVendas || this.sessao && (this.sessao.perfil == 3 || this.sessao.perfil == '3'));
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.tabs = [];
    if (__WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].appERP) {
      this.tabs.push({ title: "Guia de Ajuda", icon: null });
      this.idxPainelGuiaNfe = this.tabs.length - 1;
      this.tabs.push({ title: "Painel de Pedidos", icon: null });
      this.idxPainelPedido = this.tabs.length - 1;
      this.tabs.push({ title: "Painel de Notas Fiscais", icon: null });
      this.idxPainelNfe = this.tabs.length - 1;
      this.tabs.push({ title: "Painel Varejo", icon: null });
      this.idxPainelVarejo = this.tabs.length - 1;
    } else if (__WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].appForcaVendas) {
      this.tabs.push({ title: "Guia de Ajuda", icon: null });
      this.idxPainelGuiaForcaVendas = this.tabs.length - 1;
      this.tabs.push({ title: "Painel de Pedidos", icon: null });
      this.idxPainelPedido = this.tabs.length - 1;
    } else if (__WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].appNFe) {
      this.tabs.push({ title: "Guia de Ajuda", icon: null });
      this.idxPainelGuiaNfe = this.tabs.length - 1;
      this.tabs.push({ title: "Painel de Notas Fiscais", icon: null });
      this.idxPainelNfe = this.tabs.length - 1;
    } else if (__WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].appVarejo) {
      this.tabs.push({ title: "Painel Varejo", icon: null });
      this.idxPainelVarejo = this.tabs.length - 1;
    }

    switch (this.$route.name) {
      case "painelvarejo":
        this.activeTab = this.idxPainelVarejo;
        break;
      case "painelnfe":
        this.activeTab = this.idxPainelNfe;
        break;
      case "guianfe":
        this.activeTab = this.idxPainelGuiaNfe;
        break;
      case "guiapedidos":
        if (__WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].appForcaVendas && this.idxPainelGuiaForcaVendas !== null) {
          this.activeTab = this.idxPainelGuiaForcaVendas;
        } else {
          this.activeTab = this.idxPainelPedido;
        }
        break;
      case "painelpedidos":
      case "pedido":
        this.activeTab = this.idxPainelPedido;
        break;
      case "home":
        this.resolveHomeTab();
        break;
      default:
        this.activeTab = this.idxPainelPedido;
        break;
    }

    if (this.$route.query.usuario) {
      this.codusuario = this.$route.query.usuario;
    }

    if (this.$route.query.data_inicio) {
      this.filter.startDate = this.$firstDay(this.$route.query.data_inicio);
      this.filter.endDate = this.$lastDay(this.$route.query.data_termino);
    }

    this.loadData().then(function () {
      if (_this3.hasGuiaUnchecked && _this3.guia && __WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].primeiroAcesso) {
        __WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].primeiroAcesso = false;
        if (__WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].appForcaVendas) {
          _this3.changeTab(_this3.idxPainelGuiaForcaVendas);
        } else {
          _this3.changeTab(_this3.idxPainelGuiaNfe);
        }
      }
    });
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_google_charts_legacy__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_google_charts_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_google_charts_legacy__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dash-card',

    props: {
        params: { type: Object },
        filter: { type: Object }
    },

    components: {
        GChart: __WEBPACK_IMPORTED_MODULE_2_vue_google_charts_legacy__["GChart"]
    },

    data: function data() {
        return {
            values: [],
            lineOptions: {
                curveType: 'function',
                lineWidth: 3,
                pointSize: 6,
                colors: ['#004e94', '#10b981', '#f59e0b', '#8b5cf6', '#ef4444'],
                height: 290,
                backgroundColor: { fill: 'transparent', strokeWidth: 0 },
                chartArea: { top: 30, width: '92%', height: '72%' },
                legend: { position: 'top', alignment: 'center', textStyle: { color: '#475569', fontSize: 12, fontName: 'Inter, sans-serif' } },
                tooltip: { textStyle: { color: '#0f172a', fontSize: 12, fontName: 'Inter, sans-serif' } },
                vAxis: {
                    gridlines: { color: '#f1f5f9' },
                    baselineColor: '#cbd5e1',
                    textStyle: { color: '#64748b', fontSize: 11, fontName: 'Inter, sans-serif' }
                },
                hAxis: {
                    gridlines: { color: 'transparent' },
                    baselineColor: '#cbd5e1',
                    textStyle: { color: '#64748b', fontSize: 11, fontName: 'Inter, sans-serif' }
                }
            },

            columnOptions: {
                isStacked: false,
                bar: { groupWidth: '62%' },
                colors: ['#004e94', '#0ea5e9', '#10b981', '#f59e0b', '#8b5cf6'],
                height: 290,
                backgroundColor: { fill: 'transparent', strokeWidth: 0 },
                chartArea: { top: 30, width: '92%', height: '72%' },
                legend: { position: 'top', alignment: 'center', textStyle: { color: '#475569', fontSize: 12, fontName: 'Inter, sans-serif' } },
                tooltip: { textStyle: { color: '#0f172a', fontSize: 12, fontName: 'Inter, sans-serif' } },
                vAxis: {
                    gridlines: { color: '#f1f5f9' },
                    baselineColor: '#cbd5e1',
                    textStyle: { color: '#64748b', fontSize: 11, fontName: 'Inter, sans-serif' }
                },
                hAxis: {
                    gridlines: { color: 'transparent' },
                    baselineColor: '#cbd5e1',
                    textStyle: { color: '#64748b', fontSize: 11, fontName: 'Inter, sans-serif' }
                }
            },

            pieOptions: {
                isStacked: true,
                colors: ['#004e94', '#10b981', '#0ea5e9', '#f59e0b', '#8b5cf6', '#ef4444'],
                is3D: false,
                pieHole: 0.65,
                height: 290,
                showRowNumber: true,
                sliceVisibilityThreshold: 0,
                backgroundColor: { fill: 'transparent', strokeWidth: 0 },
                chartArea: { top: 30, width: '92%', height: '75%' },
                pieSliceText: 'percentage',
                pieSliceTextStyle: { color: '#ffffff', fontSize: 11, fontName: 'Inter, sans-serif' },
                legend: { position: 'top', alignment: 'center', maxLines: 2, textStyle: { color: '#475569', fontSize: 11, fontName: 'Inter, sans-serif' } },
                tooltip: { textStyle: { color: '#0f172a', fontSize: 12, fontName: 'Inter, sans-serif' } }
            },

            help: '',
            labelMes: '',
            title: '',
            show: false,
            formatValue: false,
            mensagem: null,
            data_inicio: null,
            data_termino: null
        };
    },


    computed: {
        columns: function columns() {
            return 'col-md-' + (this.params.col || 12) + ' col-12';
        },

        chartOptions: function chartOptions() {
            var chartType = this.params.chart ? this.params.chart.type : '';
            if (chartType === 'PieChart') {
                return this.pieOptions;
            } else if (chartType === 'LineChart' || chartType === 'AreaChart') {
                return this.lineOptions;
            } else {
                return this.columnOptions;
            }
        }
    },

    watch: {
        filter: {
            handler: function handler() {
                if (this.filter) {
                    this.loadData();
                }
            },

            deep: true
        }
    },

    methods: {
        getKpiIcon: function getKpiIcon(index) {
            var icons = ['fa fa-money', 'fa fa-shopping-cart', 'fa fa-line-chart', 'fa fa-check-circle-o'];
            return icons[index % icons.length];
        },
        handleDetalhes: function handleDetalhes() {
            var filtro = {
                data_inicio: this.filter.startDate,
                data_termino: this.filter.endDate
            };
            if (this.filter.codusuario) filtro.usuario = this.filter.codusuario;

            if (this.data_inicio) {
                filtro.data_inicio = this.data_inicio;
                filtro.data_termino = this.data_termino;
            }

            this.$router.push({ path: this.params.detalhes.url, query: filtro });
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var filtro, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this.params.name) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                filtro = {
                                    data_inicio: _this.filter.startDate,
                                    data_termino: _this.filter.endDate
                                };

                                if (_this.filter.codusuario) {
                                    filtro.usuario = [_this.filter.codusuario];
                                    filtro.codusuario = _this.filter.codusuario;
                                }
                                _context.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this.$store, 'dashboard/element/' + _this.params.name, filtro, 'post');

                            case 6:
                                data = _context.sent;

                                if (data) {
                                    _this.values = data.data;
                                    _this.labelMes = data.mes;
                                    _this.title = data.title;
                                    _this.help = data.help;
                                    _this.formatValue = data.formatvalue;
                                    _this.mensagem = data.mensagem;
                                    _this.data_inicio = data.data_inicio;
                                    _this.data_termino = data.data_termino;
                                } else {
                                    _this.values = [];
                                }

                                _this.show = true;

                                _this.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getSparkColor: function getSparkColor(index) {
            var colors = ['#004e94', '#f59e0b', '#10b981', '#0ea5e9'];
            return colors[index % colors.length];
        },
        getSparkLinePath: function getSparkLinePath(index, item) {
            if (item && item.history && Array.isArray(item.history) && item.history.length > 1) {
                var data = item.history;
                var max = Math.max.apply(Math, _toConsumableArray(data));
                var min = Math.min.apply(Math, _toConsumableArray(data));
                var range = max === min ? 1 : max - min;
                var count = data.length;

                var path = '';
                for (var i = 0; i < count; i++) {
                    var x = i / (count - 1) * 100;
                    var y = 26 - (data[i] - min) / range * 20;
                    if (i === 0) {
                        path += 'M ' + x.toFixed(1) + ' ' + y.toFixed(1);
                    } else {
                        var prevX = (i - 1) / (count - 1) * 100;
                        var prevY = 26 - (data[i - 1] - min) / range * 20;
                        var midX = (prevX + x) / 2;
                        path += ' C ' + midX.toFixed(1) + ' ' + prevY.toFixed(1) + ', ' + midX.toFixed(1) + ' ' + y.toFixed(1) + ', ' + x.toFixed(1) + ' ' + y.toFixed(1);
                    }
                }
                return path;
            }

            var paths = ['M0 24 Q 25 22, 40 14 T 70 8 T 100 3', 'M0 26 Q 20 18, 45 19 T 75 10 T 100 5', 'M0 20 Q 30 28, 50 12 T 80 16 T 100 4', 'M0 15 Q 25 8, 50 20 T 75 12 T 100 8'];
            return paths[index % paths.length];
        },
        getSparkAreaPath: function getSparkAreaPath(index, item) {
            var linePath = this.getSparkLinePath(index, item);
            return linePath + ' L 100 30 L 0 30 Z';
        },
        getTrendClass: function getTrendClass(index, item) {
            if (item && typeof item.change === 'number') {
                if (item.change > 0) return 'trend-positive';
                if (item.change < 0) return 'trend-negative';
                return 'trend-neutral';
            }
            return 'trend-neutral';
        },
        getTrendIcon: function getTrendIcon(index, item) {
            if (item && typeof item.change === 'number') {
                if (item.change > 0) return 'fa fa-arrow-up';
                if (item.change < 0) return 'fa fa-arrow-down';
                return 'fa fa-minus';
            }
            return 'fa fa-minus';
        },
        getTrendText: function getTrendText(index, item) {
            if (item && typeof item.change === 'number') {
                var prefix = item.change > 0 ? '+' : '';
                return '' + prefix + item.change.toFixed(1).replace('.', ',') + '% vs ant.';
            }
            return '0,0% vs ant.';
        },
        getDocCount: function getDocCount(item) {
            if (item && item.qtd !== undefined && item.qtd !== null && !isNaN(item.qtd)) {
                return item.qtd;
            }
            return 0;
        },
        formatMoney: function formatMoney(val) {
            if (val === null || val === undefined || isNaN(val)) return '0,00';
            return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(val, 2);
        },
        formatShort: function formatShort(val) {
            var num = val === null || val === undefined || isNaN(val) ? 0 : Number(val);
            if (num >= 1000000) {
                return (num / 1000000).toFixed(1).replace('.', ',') + 'M';
            }
            if (num >= 1000) {
                return (num / 1000).toFixed(1).replace('.', ',') + 'k';
            }
            return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(num, 2);
        },
        handleClickCard: function handleClickCard() {
            this.$emit('click', this.params);
        },
        handleButtonClick: function handleButtonClick() {
            this.$emit('buttonclick');
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(value, 2);
        }
    },

    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_guia_nfe_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b842804_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_guia_nfe_vue__ = __webpack_require__(1291);
function injectStyle (ssrContext) {
  __webpack_require__(1289)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b842804"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_guia_nfe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b842804_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_guia_nfe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__guia_step_svg_vue__ = __webpack_require__(163);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "dashboard-guia-nfe",

  components: {
    GuiaStepSvg: __WEBPACK_IMPORTED_MODULE_2__guia_step_svg_vue__["a" /* default */]
  },

  data: function data() {
    return {
      guiaNfe: [{
        completed: false,
        name: "guianfe_empresa",
        title: "Configure os dados da sua empresa",
        subtitle: "empresa",
        video: "//www.youtube.com/embed/0QMVqSEm-ww",
        url: "/guiaempresa"
      }, {
        completed: false,
        name: "guianfe_certificado",
        title: "Configure o certificado digital",
        subtitle: "digital",
        video: "//www.youtube.com/embed/SxQYdDhYs7g",
        url: "/filiallist/certificado"
      }, {
        completed: false,
        name: "guianfe_item",
        title: "Cadastre produtos e serviços",
        subtitle: "produto",
        video: "//www.youtube.com/embed/c241at1ws14",
        url: "/item/novo"
      }, {
        completed: false,
        name: "guianfe_part",
        title: "Cadastre clientes e fornecedores",
        subtitle: "cliente",
        video: "//www.youtube.com/embed/Rb8ygl4dAqk",
        url: "/part/novo"
      }, {
        completed: false,
        name: "guianfe_venda",
        title: "Emita um pedido de venda ou venda no PDV",
        subtitle: "venda / varejo",
        video: "//www.youtube.com/embed/bSJxRmoZePA",
        url: "/pedido/novo"
      }, {
        completed: false,
        name: "guianfe_nf",
        title: "Emita sua primeira Nota Fiscal",
        subtitle: "nota fiscal",
        video: "//www.youtube.com/embed/kxjxOHP8rRs",
        url: "/nf/novo"
      }],

      vendasVideos: [{
        completed: false,
        title: "Frente de Caixa PDV",
        subtitle: "Varejo",
        video: "//www.youtube.com/embed/Du4G_yz1VB8?si=nMyneZI2gx728MYf",
        url: "/varejolist"
      }],

      maisVideos: [{
        completed: false,
        title: "Como importar cadastros via XML emitidos",
        subtitle: "Importação",
        video: "//www.youtube.com/embed/IGPuKHAb_Kk",
        url: "/importaxml"
      }, {
        completed: false,
        title: "Como importar clientes e fornecedores",
        subtitle: "Importação",
        video: "//www.youtube.com/embed/ql3fiqp-Lvk",
        url: "/importa/clientes"
      }, {
        completed: false,
        title: "Como importar cadastro de produtos",
        subtitle: "Importação",
        video: "//www.youtube.com/embed/6Bmo4YZTmII",
        url: "/importa/produtos"
      }, {
        completed: false,
        title: "Como lançar um pedido de venda",
        subtitle: "Vendas",
        video: "//www.youtube.com/embed/oDczqdHbDUc",
        url: "/pedido/novo"
      }, {
        completed: false,
        title: "Configuração de regras fiscais de ICMS",
        subtitle: "Fiscal",
        video: "//www.youtube.com/embed/gjwdNe3q8AM",
        url: "/regraimplist"
      }],

      currVideo: null,
      isVideoLoading: false
    };
  },


  computed: {
    sessao: function sessao() {
      return this.$store.getters.getSessao;
    },

    dadosGuia: function dadosGuia() {
      return this.$store.getters.getGuiaNFe || {};
    },

    showGuia: function showGuia() {
      return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].guia;
    },

    completedCount: function completedCount() {
      return this.guiaNfe.filter(function (item) {
        return item.completed;
      }).length;
    },

    progressPercent: function progressPercent() {
      return Math.round(this.completedCount / 6 * 100);
    },

    allTutorials: function allTutorials() {
      return [].concat(_toConsumableArray(this.vendasVideos), _toConsumableArray(this.maisVideos));
    }
  },

  methods: {
    getStepDescription: function getStepDescription(name) {
      switch (name) {
        case "guianfe_empresa":
          return "Defina CNPJ, Razão Social, Regime Tributário e inscrições fiscais.";
        case "guianfe_certificado":
          return "Vincule seu certificado digital A1 ou A3 para assinatura e transmissão SEFAZ.";
        case "guianfe_item":
          return "Adicione itens com NCM, tributação de ICMS/PIS/COFINS e unidades de medida.";
        case "guianfe_part":
          return "Cadastre seus clientes com endereço, CPF/CNPJ e dados para faturamento.";
        case "guianfe_venda":
          return "Monte pedidos de venda com cálculo fiscal ou realize vendas rápidas no Frente de Caixa (PDV).";
        case "guianfe_nf":
          return "Transmita sua primeira NF-e mercantil ou cupom NFC-e para validação SEFAZ.";
        default:
          return "";
      }
    },
    handleShowVideo: function handleShowVideo(item) {
      var _this = this;

      this.isVideoLoading = true;
      this.currVideo = item.video;
      if (this.videoLoadTimeout) {
        clearTimeout(this.videoLoadTimeout);
      }
      this.videoLoadTimeout = setTimeout(function () {
        _this.isVideoLoading = false;
      }, 7000);
    },
    handleCloseVideo: function handleCloseVideo() {
      this.currVideo = null;
      this.isVideoLoading = false;
      if (this.videoLoadTimeout) {
        clearTimeout(this.videoLoadTimeout);
      }
    },
    onVideoLoad: function onVideoLoad() {
      this.isVideoLoading = false;
      if (this.videoLoadTimeout) {
        clearTimeout(this.videoLoadTimeout);
      }
    },
    handleFazerAgora: function handleFazerAgora(item) {
      if (item.name === "guianfe_venda") {
        if (item.completed && !this.dadosGuia.pedido && this.dadosGuia.varejo) {
          this.$router.push("/varejolist");
          return;
        }
        if (__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appVarejo && !__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appERP) {
          this.$router.push("/varejolist");
          return;
        }
      }
      if (item.url) {
        this.$router.push(item.url);
      }
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var hasCertSessao;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$store.dispatch("loadSessao", _this2);

              case 2:
                _context.next = 4;
                return _this2.$store.dispatch("loadGuiaNFe", _this2);

              case 4:

                _this2.guiaNfe[0].completed = _this2.dadosGuia.empresa;
                hasCertSessao = Boolean(_this2.sessao && Array.isArray(_this2.sessao.certificado) && _this2.sessao.certificado.length > 0);

                _this2.guiaNfe[1].completed = Boolean(_this2.dadosGuia.certificado || hasCertSessao);
                _this2.guiaNfe[2].completed = _this2.dadosGuia.item;
                _this2.guiaNfe[3].completed = _this2.dadosGuia.cliente;
                _this2.guiaNfe[4].completed = !!(_this2.dadosGuia.pedido || _this2.dadosGuia.varejo);
                _this2.guiaNfe[5].completed = _this2.dadosGuia.nf;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    apiGuiaUsuario: function apiGuiaUsuario() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSapp"])(_this3, "usuario/guia/", "post", null);

              case 2:
                _this3.$appLoading(false);
                if (__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].guia) {
                  _this3.$erpToastSuccess("Guia desativado na tela inicial.");
                } else {
                  _this3.$erpToastSuccess("Guia ativado na tela inicial.");
                }
                __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].guia = !__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].guia;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  },

  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var steps, tourguide;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.loadData();

            case 2:
              steps = [];


              if (_this4.guiaNfe.filter(function (item) {
                return item.name === "guianfe_empresa" && !item.completed;
              }).length > 0) {
                steps = [{
                  selector: "",
                  step: 1,
                  title: "Ol\xE1! Seja muito bem-vindo(a) ao Nota Brasil!",
                  content: "Nossa plataforma foi desenvolvida para simplificar o seu dia a dia e aumentar a eficiência da sua empresa.</br>Para te ajudar a dar os primeiros passos, vamos iniciar o tour guiado."
                }, {
                  selector: "#guianfe_empresa_video",
                  step: 2,
                  title: "Configure os dados da sua empresa",
                  content: "Simplifique a configuração do seu cadastro e ganhe tempo! Nossa videoaula te guiará passo a passo por todo o processo."
                }];
              }

              if (_this4.showGuia && steps.length > 0) {
                try {
                  tourguide = new Tourguide({ steps: steps });

                  tourguide.start();
                } catch (e) {
                  // tourguide silent fallback
                }
              }

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.videoLoadTimeout) {
      clearTimeout(this.videoLoadTimeout);
    }
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__guia_step_svg_vue__ = __webpack_require__(163);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "dashboard-guia-forcavendas",

  components: {
    GuiaStepSvg: __WEBPACK_IMPORTED_MODULE_2__guia_step_svg_vue__["a" /* default */]
  },

  data: function data() {
    return {
      etapasGuia: [{
        completed: false,
        name: "guiafv_empresa",
        svgStep: "guianfe_empresa",
        title: "Configure os dados da sua empresa",
        subtitle: "empresa",
        desc: "Defina Razão Social, CNPJ, telefone, endereço e informações da sua empresa.",
        video: "//www.youtube.com/embed/0QMVqSEm-ww",
        url: "/guiaempresa"
      }, {
        completed: false,
        name: "guiafv_item",
        svgStep: "guianfe_item",
        title: "Cadastre produtos e serviços",
        subtitle: "produto",
        desc: "Cadastre seu catálogo com descrição, preço de venda, fotos, estoque e unidade de medida.",
        video: "//www.youtube.com/embed/c241at1ws14",
        url: "/item/novo"
      }, {
        completed: false,
        name: "guiafv_part",
        svgStep: "guianfe_part",
        title: "Cadastre clientes e contatos",
        subtitle: "cliente",
        desc: "Cadastre sua carteira de clientes com contato telefônico para emissão de orçamentos e pedidos.",
        video: "//www.youtube.com/embed/Rb8ygl4dAqk",
        url: "/part/novo"
      }, {
        completed: false,
        name: "guiafv_venda",
        svgStep: "guianfe_venda",
        title: "Emita seu primeiro pedido de venda",
        subtitle: "venda",
        desc: "Gere orçamentos e pedidos com cálculo de descontos, tabelas de preço e envio por WhatsApp ou e-mail.",
        video: "//www.youtube.com/embed/QJC0ZLvBavc",
        url: "/pedido/novo"
      }],

      tutoriaisFV: [{
        title: "Como lançar um pedido de venda",
        subtitle: "Vendas",
        video: "//www.youtube.com/embed/QJC0ZLvBavc",
        url: "/pedido/novo"
      }, {
        title: "Cadastro de produtos",
        subtitle: "Produtos",
        video: "//www.youtube.com/embed/c241at1ws14",
        url: "/item/novo"
      }, {
        title: "Grades de produtos",
        subtitle: "Produtos",
        video: "//www.youtube.com/embed/Ds6DmZ7uzEg",
        url: "/fv/produtos"
      }, {
        title: "Atribuir grade ao produto",
        subtitle: "Produtos",
        video: "//www.youtube.com/embed/BogRiM2uBxM",
        url: "/fv/produtos"
      }, {
        title: "Tabelas de preços",
        subtitle: "Comercial",
        video: "//www.youtube.com/embed/CFIBJw78Auc",
        url: "/fv/produtos"
      }, {
        title: "Tabelas de desconto",
        subtitle: "Comercial",
        video: "//www.youtube.com/embed/atVVQ1Gp3PM",
        url: "/fv/produtos"
      }, {
        title: "Cadastro de clientes",
        subtitle: "Clientes",
        video: "//www.youtube.com/embed/Rb8ygl4dAqk",
        url: "/part/novo"
      }, {
        title: "Cadastrar novos usuários e vendedores",
        subtitle: "Configurações",
        video: "//www.youtube.com/embed/kbZ9kTtajIA",
        url: "/configuracoes"
      }, {
        title: "Como configurar regras de ICMS e substituição tributária",
        subtitle: "Tributação",
        video: "//www.youtube.com/embed/gjwdNe3q8AM",
        url: "/regraimplist"
      }, {
        title: "Como importar clientes e fornecedores",
        subtitle: "Importação",
        video: "//www.youtube.com/embed/ql3fiqp-Lvk",
        url: "/importa/clientes"
      }, {
        title: "Como importar o cadastro de produtos",
        subtitle: "Importação",
        video: "//www.youtube.com/embed/6Bmo4YZTmII",
        url: "/importa/produtos"
      }],

      currVideo: null,
      isVideoLoading: false,
      videoLoadTimeout: null
    };
  },


  computed: {
    sessao: function sessao() {
      return this.$store.getters.getSessao;
    },

    dadosGuia: function dadosGuia() {
      return this.$store.getters.getGuiaNFe || {};
    },

    showGuia: function showGuia() {
      return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].guia;
    },

    completedCount: function completedCount() {
      return this.etapasGuia.filter(function (item) {
        return item.completed;
      }).length;
    },

    progressPercent: function progressPercent() {
      return Math.round(this.completedCount / 4 * 100);
    }
  },

  methods: {
    handleShowVideo: function handleShowVideo(item) {
      var _this = this;

      this.isVideoLoading = true;
      this.currVideo = item.video;
      if (this.videoLoadTimeout) {
        clearTimeout(this.videoLoadTimeout);
      }
      this.videoLoadTimeout = setTimeout(function () {
        _this.isVideoLoading = false;
      }, 7000);
    },
    handleCloseVideo: function handleCloseVideo() {
      this.currVideo = null;
      this.isVideoLoading = false;
      if (this.videoLoadTimeout) {
        clearTimeout(this.videoLoadTimeout);
      }
    },
    onVideoLoad: function onVideoLoad() {
      this.isVideoLoading = false;
      if (this.videoLoadTimeout) {
        clearTimeout(this.videoLoadTimeout);
      }
    },
    handleFazerAgora: function handleFazerAgora(item) {
      if (item.url) {
        this.$router.push(item.url);
      }
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$store.dispatch("loadSessao", _this2);

              case 2:
                _context.next = 4;
                return _this2.$store.dispatch("loadGuiaNFe", _this2);

              case 4:

                _this2.etapasGuia[0].completed = !!_this2.dadosGuia.empresa;
                _this2.etapasGuia[1].completed = !!_this2.dadosGuia.item;
                _this2.etapasGuia[2].completed = !!_this2.dadosGuia.cliente;
                _this2.etapasGuia[3].completed = !!(_this2.dadosGuia.pedido || _this2.dadosGuia.varejo);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    apiGuiaUsuario: function apiGuiaUsuario() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSapp"])(_this3, "usuario/guia/", "post", null);

              case 2:
                _this3.$appLoading(false);
                if (__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].guia) {
                  _this3.$erpToastSuccess("Guia desativado na tela inicial.");
                } else {
                  _this3.$erpToastSuccess("Guia ativado na tela inicial.");
                }
                __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].guia = !__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].guia;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  },

  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.loadData();

            case 2:
              _this4.$nextTick(function () {
                if (window.jQuery) {
                  window.jQuery('[data-toggle="tooltip"]').tooltip();
                }
              });

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard-nfe',

  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dash_card__["a" /* default */]
  },

  props: {
    filterProp: {
      type: Object,
      default: null
    }
  },

  data: function data() {
    return {
      showRejectionDrawer: false,
      rejeicoes: [],

      filter: {
        startDate: null,
        endDate: null,
        codusuario: null
      },

      dashboard: {
        items: [{ name: 'indicadorresumofaturamento', indicator: {}, col: 12 }, { name: 'faturamento12meses', chart: { type: 'ColumnChart' }, col: 8, detalhes: { url: '/consultas/vendas' } }, { name: 'distribuicaocfop', chart: { type: 'PieChart' }, col: 4, detalhes: { url: '/consultas/distribuicaocfop' } }]
      }
    };
  },


  watch: {
    filterProp: {
      handler: function handler(val) {
        if (val) {
          this.filter.startDate = val.startDate;
          this.filter.endDate = val.endDate;
          this.filter.codusuario = val.codusuario;
          this.loadRejeicoes();
        }
      },

      deep: true,
      immediate: true
    }
  },

  computed: {
    sessao: function sessao() {
      return this.$store.getters.getSessao;
    },
    filialList: function filialList() {
      return this.$store.getters.getFilialList || [];
    },
    certData: function certData() {
      // 1. Fonte da verdade: Lista de filiais do tenant ativo
      if (this.filialList && this.filialList.length > 0) {
        var f = this.filialList[0];
        // Se a filial indica cert_pendente === 'S' ou não tem codcertificado válido: NÃO TEM CERTIFICADO!
        if (f.cert_pendente === 'S' || !f.codcertificado || f.codcertificado === 0) {
          return null;
        }

        var sessaoCert = this.sessao && Array.isArray(this.sessao.certificado) ? this.sessao.certificado.find(function (item) {
          return item && (item.codfil == f.codfil || item.codcertificado == f.codcertificado);
        }) : null;

        var tpcertificado = f.cert_tpcertificado || f.tpcertificado || sessaoCert && sessaoCert.tpcertificado || (f.cert_filename ? 'A1' : 'A3');
        var dtval = f.cert_dtval || sessaoCert && sessaoCert.dtval;

        return {
          codcertificado: f.codcertificado,
          codfil: f.codfil,
          dtval: dtval,
          nome: f.cert_nome || sessaoCert && sessaoCert.nome,
          razao: f.razao || f.nome,
          validade: dtval ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(dtval).diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf('day'), 'days') : sessaoCert && typeof sessaoCert.validade === 'number' ? sessaoCert.validade : 0,
          filename: f.cert_filename,
          tpcertificado: tpcertificado
        };
      }

      // 2. Fallback de sessão (quando filialList ainda não carregou ou está vazia)
      if (this.sessao && this.sessao.certificado && Array.isArray(this.sessao.certificado) && this.sessao.certificado.length > 0) {
        var c = this.sessao.certificado.find(function (item) {
          return item && item.codcertificado > 0 && item.dtval;
        });
        if (c && c.codcertificado > 0 && c.dtval) {
          if (this.filialList.length > 0 && this.filialList[0].cert_pendente === 'S') {
            return null;
          }
          return {
            codcertificado: c.codcertificado,
            codfil: c.codfil,
            dtval: c.dtval,
            nome: c.nome,
            razao: this.sessao.empresanome || this.sessao.empresa_nome,
            validade: typeof c.validade === 'number' ? c.validade : __WEBPACK_IMPORTED_MODULE_1_moment___default()(c.dtval).diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf('day'), 'days'),
            filename: c.filename,
            tpcertificado: c.tpcertificado || (c.filename ? 'A1' : 'A3')
          };
        }
      }

      return null;
    },
    hasCertificado: function hasCertificado() {
      if (this.filialList && this.filialList.length > 0) {
        var f = this.filialList[0];
        if (f.cert_pendente === 'S' || !f.codcertificado || f.codcertificado === 0) {
          return false;
        }
      }
      return Boolean(this.certData && this.certData.codcertificado && (this.certData.dtval || this.certData.codcertificado > 0));
    },
    isCertA3: function isCertA3() {
      return Boolean(this.certData && this.certData.tpcertificado === 'A3');
    },
    certNome: function certNome() {
      if (this.certData && this.certData.nome) {
        return this.certData.nome;
      }
      if (this.isCertA3) {
        return 'Certificado Digital A3';
      }
      return 'Certificado Digital A1 (e-CNPJ)';
    },
    certEmpresa: function certEmpresa() {
      if (this.certData && this.certData.razao) {
        return this.certData.razao;
      }
      if (this.sessao && (this.sessao.empresanome || this.sessao.empresa_nome)) {
        return (this.sessao.empresanome || this.sessao.empresa_nome) + ' • ICP-Brasil';
      }
      return 'Nota Brasil • ICP-Brasil';
    },
    certDataVencimento: function certDataVencimento() {
      if (this.certData && this.certData.dtval) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.certData.dtval).format('DD/MM/YYYY');
      }
      return '--/--/----';
    },
    certDiasRestantes: function certDiasRestantes() {
      if (this.certData && typeof this.certData.validade === 'number') {
        return this.certData.validade;
      }
      return 0;
    },
    certDiasTexto: function certDiasTexto() {
      var dias = this.certDiasRestantes;
      if (dias < 0) return 'Vencido há ' + Math.abs(dias) + ' dias';
      if (dias === 0) return 'Vence hoje';
      return 'Vence em ' + dias + ' dias';
    },
    certDaysClass: function certDaysClass() {
      var dias = this.certDiasRestantes;
      if (dias <= 0) return 'text-danger';
      if (dias <= 30) return 'text-warning';
      return 'text-success';
    },
    certStatusText: function certStatusText() {
      var dias = this.certDiasRestantes;
      if (dias <= 0) return 'Vencido';
      if (dias <= 30) return 'Vencimento Próximo';
      return 'Ativo & Válido';
    },
    certBadgeClass: function certBadgeClass() {
      var dias = this.certDiasRestantes;
      if (dias <= 0) return 'badge-danger-soft';
      if (dias <= 30) return 'badge-warning-soft';
      return 'badge-success-soft';
    },
    certIconBgClass: function certIconBgClass() {
      var dias = this.certDiasRestantes;
      if (dias <= 0) return 'cert-bg-danger';
      if (dias <= 30) return 'cert-bg-warning';
      return 'cert-bg-success';
    },
    certIconClass: function certIconClass() {
      var dias = this.certDiasRestantes;
      if (dias <= 0) return 'text-danger';
      if (dias <= 30) return 'text-warning';
      return 'text-success';
    },
    certProgressBarClass: function certProgressBarClass() {
      var dias = this.certDiasRestantes;
      if (dias <= 0) return 'bg-danger';
      if (dias <= 30) return 'bg-warning';
      return 'bg-success';
    },
    certProgressPercent: function certProgressPercent() {
      var dias = this.certDiasRestantes;
      if (dias <= 0) return 100;
      return Math.min(100, Math.max(10, Math.round(dias / 365 * 100)));
    }
  },

  methods: {
    updateQuery: function updateQuery() {
      this.$router.replace({ query: { data_inicio: this.filter.startDate, data_termino: this.filter.endDate } });
    },
    handleGerenciarCertificado: function handleGerenciarCertificado() {
      this.$router.push('/filiallist/certificado');
    },
    handleAdquirirCertificado: function handleAdquirirCertificado() {
      window.open('https://notabrasil.com.br/certificado-digital', '_blank');
    },
    handleCorrigirNota: function handleCorrigirNota(codnf) {
      this.$router.push('/nf/' + codnf);
    },
    loadRejeicoes: function loadRejeicoes() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var filtro, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                filtro = {
                  data_inicio: _this.filter.startDate,
                  data_termino: _this.filter.endDate
                };
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this.$store, 'dashboard/element/notasrejeitadas', filtro, 'post');

              case 4:
                res = _context.sent;

                if (res && res.rejeitadas) {
                  _this.rejeicoes = res.rejeitadas;
                } else {
                  _this.rejeicoes = [];
                }
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                _this.rejeicoes = [];

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Promise.all([_this2.$store.dispatch('loadFilial', {}), _this2.$store.dispatch('loadSessao', _this2)]);

              case 2:
                _this2.loadRejeicoes();

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },

  mounted: function mounted() {
    this.loadData();
  },
  created: function created() {
    if (!this.filterProp && this.$route.query.data_inicio) {
      this.filter.startDate = this.$firstDay(this.$route.query.data_inicio);
      this.filter.endDate = this.$lastDay(this.$route.query.data_termino);
    }
  }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dashboard_guia_nfe_vue__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard-varejo',

  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dash_card__["a" /* default */],
    DashboardGuiaNfe: __WEBPACK_IMPORTED_MODULE_3__dashboard_guia_nfe_vue__["a" /* default */]
  },

  props: {
    filterProp: {
      type: Object,
      default: null
    }
  },

  data: function data() {
    return {
      filter: {
        startDate: null,
        endDate: null,
        codusuario: null
      },

      dashboard: {
        items: [{ name: 'varejoindicadorvendas', indicator: {}, col: 12 }, { name: 'varejograficoformas', chart: { type: 'PieChart' }, col: 4 }]
      },

      caixasList: [],
      formasList: []
    };
  },


  watch: {
    filterProp: {
      handler: function handler(val) {
        if (val) {
          this.filter.startDate = val.startDate;
          this.filter.endDate = val.endDate;
          this.filter.codusuario = val.codusuario;
          this.loadData();
        }
      },

      deep: true,
      immediate: true
    }
  },

  computed: {
    sessao: function sessao() {
      return this.$store.getters.getSessao;
    },

    caixasAbertosList: function caixasAbertosList() {
      return (this.caixasList || []).filter(function (caixa) {
        return caixa.aberto;
      });
    },

    totalFormas: function totalFormas() {
      return this.formasList.reduce(function (acc, row) {
        return acc + (parseFloat(row.valor) || 0);
      }, 0);
    }
  },

  methods: {
    getFormaColor: function getFormaColor(index) {
      var colors = ['#004e94', '#10b981', '#0ea5e9', '#f59e0b', '#8b5cf6', '#ef4444', '#64748b'];
      return colors[index % colors.length];
    },
    updateQuery: function updateQuery() {
      this.$router.replace({ query: { data_inicio: this.filter.startDate, data_termino: this.filter.endDate } });
    },
    clickConsulta: function clickConsulta(url) {
      this.$router.push(url);
    },
    handleMonthChange: function handleMonthChange() {
      this.updateQuery();
    },
    loadData: function loadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var filtro, param, data2, data3;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                filtro = {
                  data_inicio: _this.filter.startDate,
                  data_termino: _this.filter.endDate

                  // Caixas abertos
                };
                param = { query: 'status=0' };
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDS"])(_this.$store.getters.urlOrds + 'varejo/controlecaixa/list', param);

              case 4:
                data2 = _context.sent;

                if (data2 && data2.items) _this.caixasList = data2.items;

                // Resumo de formas de pagamento
                _context.next = 8;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this.$store, 'consulta/vendas/varejoresumoformas', filtro, 'post');

              case 8:
                data3 = _context.sent;

                if (data3 && data3.items) _this.formasList = data3.items;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  filters: {
    formatValue: function formatValue(val, dec) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(val, dec || 2);
    }
  },

  mounted: function mounted() {
    this.loadData();
  },
  created: function created() {
    if (!this.filterProp && this.$route.query.data_inicio) {
      this.filter.startDate = this.$firstDay(this.$route.query.data_inicio);
      this.filter.endDate = this.$lastDay(this.$route.query.data_termino);
    }
  }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

    components: {
        DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */], Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */], Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
    },

    data: function data() {
        return {
            showfiltro: false,

            resumoVendas: [],
            detalheVendas: [],

            tipoResumo: '1',

            opcoesResumo: { 1: 'resumovendas',
                2: 'resumousuario',
                3: 'resumocliente',
                4: 'resumogrupocliente',
                5: 'resumoestado' },

            //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
            paramsFiltro: {
                periodo: {
                    label: 'Data da venda',
                    varios: false,
                    data_inicio: null,
                    data_termino: null
                },

                filtros: [{ nome: 'usuario', label: null, url: null, varios: false, values: [] }, { nome: 'filial', label: null, url: null, varios: false, values: [] }, { nome: 'segmento', label: null, url: null, varios: true, values: [] }, { nome: 'grupocliente', label: null, url: null, varios: true, values: [] }, { nome: 'estado', label: null, url: null, varios: true, values: [] }, { nome: 'grupoestoque', label: null, url: null, varios: true, values: [] }]

            },

            filtro: {
                periodos: [{ data_inicio: null, data_termino: null }]
            },

            filter: { //objeto utilizado pelo filtro de mes
                startDate: null,
                endDate: null,
                codusuario: null
            }

        };
    },


    watch: {
        tipoResumo: function tipoResumo() {
            this.loadResumo();
            this.loadDetalhes();
        }
    },

    methods: {
        handleCloseFiltro: function handleCloseFiltro() {
            this.showfiltro = false;
        },
        clickRetornar: function clickRetornar() {
            this.$router.push('/');
        },
        handleShowFiltro: function handleShowFiltro() {
            //if (this.paramsFiltro)
            this.showfiltro = true;
        },
        filtroChange: function filtroChange(filtro) {

            this.showfiltro = false;

            this.filtro = filtro;

            this.paramsFiltro.filtros[0].values = this.filtro.usuario;
            this.paramsFiltro.filtros[1].values = this.filtro.filial;
            this.paramsFiltro.filtros[2].values = this.filtro.segmento;
            this.paramsFiltro.filtros[3].values = this.filtro.grupocliente;
            this.paramsFiltro.filtros[4].values = this.filtro.estado;
            this.paramsFiltro.filtros[5].values = this.filtro.grupoestoque;

            //this.filtro['opcoes_resumo'].selected

            this.loadResumo();
            this.loadDetalhes();
        },
        loadResumo: function loadResumo(excel) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var url, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                url = 'consulta/vendas/' + _this.opcoesResumo[_this.tipoResumo];


                                _this.filtro.excel = excel;

                                if (!excel) {
                                    _context.next = 6;
                                    break;
                                }

                                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this, url, _this.filtro, 'post');
                                _context.next = 10;
                                break;

                            case 6:
                                _context.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, url, _this.filtro, 'post');

                            case 8:
                                data = _context.sent;

                                if (data) {
                                    _this.resumoVendas = data;
                                } else {
                                    _this.resumoVendas = [];
                                }

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        loadDetalhes: function loadDetalhes(excel) {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.filtro.excel = excel;

                                if (!excel) {
                                    _context2.next = 5;
                                    break;
                                }

                                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this2, url, _this2.filtro, 'post');
                                _context2.next = 9;
                                break;

                            case 5:
                                _context2.next = 7;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this2.$store, 'consulta/vendas/porpedido', _this2.filtro, 'post');

                            case 7:
                                data = _context2.sent;

                                if (data) {
                                    _this2.detalheVendas = data;
                                } else {
                                    _this2.detalheVendas = [];
                                }

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    },

    computed: {

        // sessao: function () {
        //     return this.$store.getters.getSessao
        // },

        // usuarioList: function () {
        //     //lista de usuarios para selecao
        //     let options = []
        //     for (var x = 0; x < this.$store.getters.getUsuarioList.length; x++) {
        //         options.push({ id: this.$store.getters.getUsuarioList[x].codusuario, text: this.$store.getters.getUsuarioList[x].nome })
        //     }
        //     return options
        // },

        paramsChart: function paramsChart() {
            if (this.tipoResumo == '1') return { chart: { type: 'AreaChart' }, values: this.chartValues };else return { chart: { type: 'ColumnChart' }, values: this.chartValues };
        },

        chartValues: function chartValues() {
            // return [ ['Mês', 'Orçamentos'],
            //         ['Orçamentos', 1000],
            //         ['Confirmados', 1170],
            //         ['Recusados', 660],
            // ]

            if (!this.resumoVendas.vendas || this.resumoVendas.vendas.length == 0) return [];

            var values = [['', 'Valor Vendido']];

            console.log(this.resumoVendas);

            if (this.tipoResumo == '1') {
                var meses = this.resumoVendas.vendas[0].valores;
                for (var x = 0; x < this.resumoVendas.meses.length; x++) {
                    values.push([this.resumoVendas.meses[x], meses[x]]);
                }
            } else {
                for (var x = 0; x < this.resumoVendas.vendas.length; x++) {
                    values.push([this.resumoVendas.vendas[x].label, this.resumoVendas.vendas[x].total]);
                }
            }

            return values;
        }

    },

    mounted: function mounted() {},
    created: function created() {
        this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate()); //'2020-02-01'
        this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate()); //'2020-08-17'

        if (this.$route.query.usuario) {
            this.filtro.usuario = [this.$route.query.usuario];
            this.paramsFiltro.filtros[0].values = [this.filtro.usuario];
        }

        if (this.$route.query.data_inicio) {
            this.filtro.periodos[0].data_inicio = this.$firstDay(this.$route.query.data_inicio);
            this.filtro.periodos[0].data_termino = this.$lastDay(this.$route.query.data_termino);
        }

        this.paramsFiltro.periodo.data_inicio = this.filtro.periodos[0].data_inicio;
        this.paramsFiltro.periodo.data_termino = this.filtro.periodos[0].data_termino;

        this.loadResumo();
        this.loadDetalhes();
    }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_google_charts_legacy__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_google_charts_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_google_charts_legacy__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// google-charts
// https://developers.google.com/chart/interactive/docs/gallery/piechart#donut





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: { type: Object }
    },

    components: {
        GChart: __WEBPACK_IMPORTED_MODULE_2_vue_google_charts_legacy__["GChart"]
    },

    data: function data() {
        return {
            values: [],
            otherOptions: {
                chart: {
                    // title: '',
                    // subtitle: '',
                    // legend: { position: 'right' },
                },
                isStacked: false,
                colors: ['#7DCEA0', '#d98880', '#5288ac', '#f8eb71', '#CD6155', '#bb8fce', '#e59866', '#cd6155'],
                height: 300,
                is3D: true,
                showRowNumber: true,
                backgroundColor: { strokeWidth: 0 },
                pointSize: 3,
                // chartArea: { top:50, width:'90%', height:'65%' },
                chartArea: { top: 50, width: '80%' },
                legend: { position: 'top', alignment: 'center', textStyle: { color: 'gray', fontSize: 12 } },
                tooltip: { textStyle: { color: '#222', fontSize: 12 } },
                hAxis: {
                    textStyle: { color: 'gray', fontSize: 12 }
                    // title: 'Time of Day',
                    // format: 'h:mm a',
                    // viewWindow: {
                    //     min: [3, 5, 0],
                    //     max: [5, 10, 0]
                    // }
                },
                vAxis: {
                    textStyle: { color: 'gray', fontSize: 12 }
                    // title: 'Time of Day',
                    // format: '',
                }
            },

            pieOptions: {
                chart: {
                    // title: '',
                    // subtitle: '',
                    // legend: { position: 'right' },
                },
                isStacked: true,
                colors: ['#cd6155', '#a569bd', '#5dade2', '#52be80', '#f5b041', '#dc7633'],
                is3D: false,
                pieHole: 0.7,
                height: 300,
                // width: 400,
                sliceVisibilityThreshold: 0,
                showRowNumber: true,
                crosshair: { trigger: 'both' },
                backgroundColor: { strokeWidth: 0 },
                chartArea: { top: 50, width: '90%', height: '60%' },
                pieSliceText: 'value',
                pieSliceTextStyle: { color: '#222', fontSize: 12 },
                legend: { position: 'bottom', alignment: 'center', textStyle: { color: '#222', fontSize: 11 } },
                tooltip: { textStyle: { color: '#222', fontSize: 12 } }
            },

            help: 'teste de help de indicador do dashboard',
            labelMes: '',
            title: '',
            show: true
        };
    },


    computed: {
        chartOptions: function chartOptions() {
            if (this.params.chart.type === 'PieChart') {
                return this.pieOptions;
            } else {
                if (this.params.colors) this.otherOptions.colors = this.params.colors;
                return this.otherOptions;
            }
        }
    },

    watch: {
        filter: {
            handler: function handler() {
                if (this.filter) {
                    this.loadData();
                }
            },

            deep: true
        }
    },

    methods: {},

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(value, 2);
        }
    },

    created: function created() {
        console.log(this.params);
    }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

    components: {
        DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */], Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */], Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
    },

    data: function data() {
        return {
            showfiltro: false,

            dados: {},

            //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
            paramsFiltro: {
                periodo: {
                    label: 'Data da venda',
                    varios: false,
                    data_inicio: null,
                    data_termino: null
                },

                filtros: [
                // { nome: 'filial', label: null, url: null, varios: false, values: [] },
                // { nome: 'segmento', label: null, url: null, varios: true, values: [] },
                { nome: 'usuario', label: null, url: null, varios: true, values: [] }, { nome: 'grupocliente', label: null, url: null, varios: true, values: [] }]

            },

            filtro: {
                periodos: [{ data_inicio: null, data_termino: null }]
            }

        };
    },


    watch: {},

    methods: {
        handleCloseFiltro: function handleCloseFiltro() {
            this.showfiltro = false;
        },
        clickRetornar: function clickRetornar() {
            this.$router.push('/');
        },
        handleShowFiltro: function handleShowFiltro() {
            this.showfiltro = true;
        },
        filtroChange: function filtroChange(filtro) {

            this.showfiltro = false;

            this.filtro = filtro;

            this.paramsFiltro.filtros[1].values = this.filtro.grupocliente;
            this.paramsFiltro.filtros[0].values = this.filtro.usuario;

            this.loadData();
        },
        loadData: function loadData(excel) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var url, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                url = 'consulta/vendas/curvacliente';


                                _this.filtro.excel = excel;

                                if (!excel) {
                                    _context.next = 6;
                                    break;
                                }

                                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this, url, _this.filtro, 'post');
                                _context.next = 10;
                                break;

                            case 6:
                                _context.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, url, _this.filtro, 'post');

                            case 8:
                                data = _context.sent;

                                if (data) {
                                    _this.dados = data;
                                } else {
                                    _this.dados = {};
                                }

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    computed: {
        clientes: function clientes() {
            if (!this.dados.clientes) return [];else return this.dados.clientes;
        },

        grafico: function grafico() {
            if (!this.dados.grafico) return [];else return this.dados.grafico;
        },

        paramsChart: function paramsChart() {
            return { chart: { type: 'PieChart' }, values: this.chartValues
                // return { chart: { type: 'AreaChart' }, values: this.chartValues }
                // return { chart: { type: 'ColumnChart' }, values: this.chartValues }
            };
        },

        chartValues: function chartValues() {
            if (!this.clientes || this.clientes.length == 0) return [];

            var values = [['', 'Quantidade de Clientes']];

            for (var x = 0; x < this.grafico.length; x++) {
                values.push(this.grafico[x]);
            }

            return values;
        }

    },

    mounted: function mounted() {},
    created: function created() {
        this.filtro.periodos[0].data_inicio = this.$lastDay(this.$getDate());
        this.filtro.periodos[0].data_termino = this.$firstDay(this.$getDate());

        if (this.$route.query.usuario) {
            this.filtro.usuario = [this.$route.query.usuario];
            this.paramsFiltro.filtros[0].values = [this.filtro.usuario];
        }

        if (this.$route.query.data_inicio) {
            this.filtro.periodos[0].data_inicio = this.$firstDay(this.$route.query.data_inicio);
            this.filtro.periodos[0].data_termino = this.$lastDay(this.$route.query.data_termino);
        }

        this.paramsFiltro.periodo.data_inicio = this.filtro.periodos[0].data_inicio;
        this.paramsFiltro.periodo.data_termino = this.filtro.periodos[0].data_termino;

        this.loadData();
    }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

    components: {
        DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */], Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */], Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
    },

    data: function data() {
        return {
            showfiltro: false,

            dados: {},

            data_referencia: null,

            //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
            paramsFiltro: {
                filtros: [
                // { nome: 'filial', label: null, url: null, varios: false, values: [] },
                { nome: 'segmento', label: null, url: null, varios: true, values: [] }, { nome: 'grupocliente', label: null, url: null, varios: true, values: [] }, { nome: 'usuario', label: null, url: null, varios: true, values: [] }]
            },

            filtro: {
                periodos: [{ data_inicio: null, data_termino: null }]
            }

        };
    },


    watch: {
        data_referencia: function data_referencia() {
            this.loadData();
        }
    },

    methods: {
        handleCloseFiltro: function handleCloseFiltro() {
            this.showfiltro = false;
        },
        clickRetornar: function clickRetornar() {
            this.$router.push('/');
        },
        statusColor: function statusColor(dias) {
            if (dias > 365) return 'badge badge-red';else if (dias > 120) return 'badge badge-yellow';else return 'badge badge-green';
        },
        handleShowFiltro: function handleShowFiltro() {
            this.showfiltro = true;
        },
        filtroChange: function filtroChange(filtro) {

            this.showfiltro = false;

            this.filtro = filtro;

            this.paramsFiltro.filtros[0].values = this.filtro.segmento;
            this.paramsFiltro.filtros[1].values = this.filtro.grupocliente;
            this.paramsFiltro.filtros[2].values = this.filtro.usuario;

            this.loadData();
        },
        loadData: function loadData(excel) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var url, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                url = 'consulta/vendas/carteiraclientes';


                                _this.filtro.excel = excel;
                                _this.filtro.data_referencia = _this.data_referencia;

                                if (!excel) {
                                    _context.next = 7;
                                    break;
                                }

                                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this, url, _this.filtro, 'post');
                                _context.next = 11;
                                break;

                            case 7:
                                _context.next = 9;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, url, _this.filtro, 'post');

                            case 9:
                                data = _context.sent;

                                if (data) {
                                    _this.dados = data;
                                } else {
                                    _this.dados = {};
                                }

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    computed: {
        clientes: function clientes() {
            if (!this.dados.clientes) return [];else return this.dados.clientes;
        },

        grafico: function grafico() {
            if (!this.dados.grafico) return [];else return this.dados.grafico;
        },

        paramsChart: function paramsChart() {
            return { chart: { type: 'PieChart' }, values: this.chartValues
                // return { chart: { type: 'AreaChart' }, values: this.chartValues }
                // return { chart: { type: 'ColumnChart' }, values: this.chartValues }
            };
        },

        chartValues: function chartValues() {
            if (!this.grafico) return [];else return this.grafico;
            // if (!this.grafico || this.grafico.length == 0)
            //   return []

            // let values = [ ['', 'Quantidade de Clientes'] ]

            // for (var x = 0; x < this.grafico.length; x++) {
            //     if (this.grafico[x].label != 'Nunca Comprou')
            //       values.push([ this.grafico[x].label, this.grafico[x].value ])
            // }

            // return values
        }

    },

    mounted: function mounted() {
        this.$nextTick(function () {
            this.$refs.data.focus();
        });
    },
    created: function created() {
        this.data_referencia = this.$lastDay(this.$getDate());

        if (this.$route.query.usuario) {
            this.filtro.usuario = [this.$route.query.usuario];
            this.paramsFiltro.filtros[2].values = [this.filtro.usuario];
        }

        if (this.$route.query.data_inicio) {
            this.data_referencia = this.$route.query.data_inicio;
        }

        this.loadData();
    }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */],
    Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
  },

  data: function data() {
    return {
      showfiltro: false,

      dados: {},

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {
        periodo: {
          label: "Data da venda",
          varios: false,
          data_inicio: null,
          data_termino: null
        },

        filtros: [{ nome: "filial", label: null, url: null, varios: false, values: [] }, {
          nome: "segmento",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "grupocliente",
          label: null,
          url: null,
          varios: true,
          values: []
        }, { nome: "estado", label: null, url: null, varios: true, values: [] }, {
          nome: "grupoestoque",
          label: null,
          url: null,
          varios: true,
          values: []
        }]
      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }]
      },

      colunas: [],

      mounting: false

    };
  },


  watch: {},

  methods: {
    clickRetornar: function clickRetornar() {
      this.$router.push('/');
    },
    varColor: function varColor(val) {
      return { 'var-negative': val < 0, 'var-positive': val >= 0, '': val == 0 };
    },
    colSpan: function colSpan(index) {
      if (index > 0) return 6;else return 4;
    },
    montaColunas: function montaColunas() {
      this.colunas = [{ nome: 'descricao_produto', visible: true, label: 'Produto', sortable: true, orderby: null, class: '', style: 'min-width: 200px;' }, { nome: 'id', visible: false, label: 'Código' }];

      var base = [{ nome: 'quantidade', visible: true, label: 'Quantidade', indexperiodo: null, sortable: true, orderby: 'desc', class: 'numerico size130 border-left', style: '' }, { nome: 'valor', visible: true, label: 'Valor Vendido', indexperiodo: null, sortable: true, orderby: null, class: 'numerico size130', style: '' }, { nome: 'medio', visible: false, label: 'Preço Médio', indexperiodo: null, sortable: false, orderby: null, class: 'numerico size130', style: '' }, { nome: 'participacao_quantidade', visible: true, label: 'Participação Quantidade', indexperiodo: null, sortable: false, orderby: null, class: 'numerico size130', style: '' }, { nome: 'participacao_valor', visible: true, label: 'Participação Valor', indexperiodo: null, sortable: false, orderby: null, class: 'numerico size130', style: '' }];

      var variacao = [{ nome: 'variacao_quantidade', visible: true, label: 'Variação Quantidade', indexperiodo: null, sort: false, orderby: null, class: 'numerico size130 border-left', style: '' }, { nome: 'variacao_valor', visible: true, label: 'Variação Valor', indexperiodo: null, sort: false, orderby: null, class: 'numerico size130', style: '' }];

      for (var y = 0; y < this.dados.periodos.length; y++) {
        var _colunas, _colunas2;

        for (var x = 0; x < base.length; x++) {
          base[x].indexperiodo = y; //indexperiodo é utilizado para identificar a coluna de ordenacao dentro do periodo
        }
        (_colunas = this.colunas).push.apply(_colunas, base);
        if (y > 0) (_colunas2 = this.colunas).push.apply(_colunas2, variacao);
      }

      this.colunas.push({ nome: 'quantidade', visible: true, label: 'Quantidade', sortable: true, orderby: null, class: 'numerico size130 border-left', style: '' });
      this.colunas.push({ nome: 'valor', visible: true, label: 'Valor Total', sortable: true, orderby: null, class: 'numerico size130', style: '' });
    },
    handleShowFiltro: function handleShowFiltro() {
      this.showfiltro = true;
    },
    filtroChange: function filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;

      this.paramsFiltro.periodo.data_inicio = this.filtro.periodos[0].data_inicio;
      this.paramsFiltro.periodo.data_termino = this.filtro.periodos[0].data_termino;

      this.paramsFiltro.filtros[0].values = this.filtro.filial;
      this.paramsFiltro.filtros[1].values = this.filtro.segmento;
      this.paramsFiltro.filtros[2].values = this.filtro.grupocliente;
      this.paramsFiltro.filtros[3].values = this.filtro.estado;
      this.paramsFiltro.filtros[4].values = this.filtro.grupoestoque;

      this.loadData();
    },
    loadData: function loadData(excel) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "consulta/vendas/produtosvendidos";


                _this.filtro.excel = excel;

                if (!excel) {
                  _context.next = 6;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this, url, _this.filtro, "post");
                _context.next = 11;
                break;

              case 6:
                _this.mounting = true;
                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, url, _this.filtro, "post");

              case 9:
                data = _context.sent;

                if (data) {
                  _this.dados = data;
                } else {
                  _this.dados = {};
                }

              case 11:
                _this.montaColunas();
                _this.mounting = false;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  computed: {
    produtos: function produtos() {
      if (!this.dados.produtos_vendidos) return [];else return this.dados.produtos_vendidos;
    },

    paramsChart: function paramsChart() {
      return { chart: { type: "ColumnChart" }, values: this.chartValues };
    },

    chartValues: function chartValues() {
      if (!this.produtos || this.produtos.length == 0) return [];

      var title = ["Produto"];
      var produto = [];
      var tipoGrafico = 'Produtos Por Valor Vendido Em';

      for (var x = 0; x < this.dados.periodos.length; x++) {
        title.push(tipoGrafico + ' ' + this.dados.periodos[x].label);
      }

      var values = [title];

      for (var x = 0; x < this.produtos.length; x++) {
        produto = [this.produtos[x].produto_descricao];
        for (var y = 0; y < this.dados.periodos.length; y++) {
          produto.push(this.produtos[x][this.dados.periodos[y].nome].valor);
        }
        values.push(produto);
      }

      return values;
    }
  },

  mounted: function mounted() {},
  created: function created() {
    this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate());
    this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate());
    // this.filtro.periodos[0].data_inicio = "2020-02-01"
    // this.filtro.periodos[0].data_termino = "2020-08-17"

    this.loadData();
  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */],
    Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
  },

  data: function data() {
    return {
      showfiltro: false,

      dados: {},
      grafico: null,

      color: ['#cd6155', '#a569bd', '#52be80', '#5dade2'],

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {
        periodo: {
          label: "Data da venda",
          varios: false,
          data_inicio: null,
          data_termino: null
        },

        filtros: [{
          nome: "usuario",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "segmento",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "grupocliente",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "estado",
          label: null,
          url: null,
          varios: true,
          values: []
        }]
      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }]
      },

      colunas: [],

      mounting: false

    };
  },


  watch: {},

  methods: {
    handleCloseFiltro: function handleCloseFiltro() {
      this.showfiltro = false;
    },
    clickRetornar: function clickRetornar() {
      this.$router.push('/');
    },
    montaColunas: function montaColunas() {
      this.colunas = [{ nome: 'nome', visible: true, label: 'Nome/Razão', sortable: true, orderby: null, class: '', style: 'min-width: 200px;' }, { nome: 'id', visible: false, label: 'Código', sortable: true, orderby: null, class: '', style: '' }, { nome: 'fantasia', visible: false, label: 'Fantasia', sortable: true, orderby: null, class: '', style: '' }, { nome: 'cnpjcpf', visible: false, label: 'CNPJ/CPF', sortable: false, orderby: null, class: 'size130', style: '' }, { nome: 'uf', visible: true, label: 'Estado', sortable: false, orderby: null, class: '', style: '' }, { nome: 'ultimo_pedido', visible: true, label: 'Data Último Pedido', sortable: false, orderby: 'desc', class: 'size130', style: '' }, { nome: 'npedido', visible: true, label: 'Último Pedido', sortable: false, orderby: null, class: '', style: '' }, { nome: 'penultimo_pedido', visible: true, label: 'Penúltimo pedido', sortable: false, orderby: null, class: 'size130', style: '' }, { nome: 'dias_sem_comprar', visible: true, label: 'Dias sem comprar', sortable: false, orderby: null, class: 'numerico', style: '' }, { nome: 'descricao_status', visible: true, label: 'Status', sortable: false, orderby: null, class: 'size130', style: '' }, { nome: 'telefone', visible: true, label: 'Telefone', sortable: false, orderby: null, class: 'size130', style: '' }, { nome: 'email', visible: false, label: 'Email', sortable: false, orderby: null, class: 'size130', style: '' }, { nome: 'segmento', visible: true, label: 'Segmento', sortable: false, orderby: null, class: 'size130', style: '' }, { nome: 'nome_usuario', visible: true, label: 'Usuário', sortable: true, orderby: null, class: 'size130', style: '' }];
    },
    colorStatus: function colorStatus(status) {
      if (status == '4') return 'background: ' + this.color[0];else if (status == '1') return 'background: ' + this.color[2];else if (status == '3') return 'background: ' + this.color[3];else if (status == '2') return 'background: ' + this.color[1];
    },
    handleShowFiltro: function handleShowFiltro() {
      this.showfiltro = true;
    },
    filtroChange: function filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;

      this.paramsFiltro.filtros[0].values = this.filtro.usuario;
      this.paramsFiltro.filtros[1].values = this.filtro.segmento;
      this.paramsFiltro.filtros[2].values = this.filtro.grupocliente;
      this.paramsFiltro.filtros[3].values = this.filtro.estado;

      this.loadData();
    },
    loadData: function loadData(excel) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data, grafico;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "consulta/vendas/performancedacarteira";


                _this.filtro.excel = excel;
                _this.filtro.resumo = false;

                if (!excel) {
                  _context.next = 7;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this, url, _this.filtro, "post");
                _context.next = 17;
                break;

              case 7:
                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, url, _this.filtro, "post");

              case 9:
                data = _context.sent;

                if (data) {
                  _this.dados = data;
                } else {
                  _this.dados = {};
                }
                _this.montaColunas();

                _this.filtro.resumo = true;
                _context.next = 15;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, url, _this.filtro, "post");

              case 15:
                grafico = _context.sent;

                if (grafico) {
                  _this.grafico = grafico.grafico;
                } else {
                  _this.grafico = {};
                }

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  computed: {
    clientes: function clientes() {
      if (!this.dados.clientes) return [];else return this.dados.clientes;
    },

    paramsChart: function paramsChart() {
      return { chart: { type: "PieChart" }, values: this.chartValues };
    },

    chartValues: function chartValues() {
      if (!this.grafico || this.grafico.length == 0) return [];

      var values = [['', 'Quantidade de Clientes']];

      for (var x = 0; x < this.grafico.length; x++) {
        values.push([this.grafico[x].label, this.grafico[x].value]);
      }

      return values;
    }
  },

  mounted: function mounted() {},
  created: function created() {
    this.filtro.periodos[0].data_inicio = this.$lastDay(this.$getDate());
    this.filtro.periodos[0].data_termino = this.$firstDay(this.$getDate());

    if (this.$route.query.usuario) {
      this.filtro.usuario = [this.$route.query.usuario];
      this.paramsFiltro.filtros[0].values = [this.filtro.usuario];
    }

    if (this.$route.query.data_inicio) {
      this.filtro.periodos[0].data_inicio = this.$firstDay(this.$route.query.data_inicio);
      this.filtro.periodos[0].data_termino = this.$lastDay(this.$route.query.data_termino);
    }

    this.paramsFiltro.periodo.data_inicio = this.filtro.periodos[0].data_inicio;
    this.paramsFiltro.periodo.data_termino = this.filtro.periodos[0].data_termino;

    this.loadData();
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */],
    Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
  },

  data: function data() {
    return {
      showfiltro: false,

      dados: {},

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {
        periodo: {
          label: "Data da venda",
          varios: true,
          data_inicio: null,
          data_termino: null
        },

        filtros: [{
          nome: "filial",
          label: null,
          url: null,
          varios: false,
          values: []
        }, {
          nome: "segmento",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "grupocliente",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "estado",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "grupoestoque",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "produto",
          label: null,
          url: null,
          varios: true,
          values: []
        }]
      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }]
      },

      colunas: [],

      mounting: false

    };
  },


  watch: {},

  methods: {
    clickRetornar: function clickRetornar() {
      this.$router.push('/');
    },
    varColor: function varColor(val) {
      return { 'var-negative': val < 0, 'var-positive': val >= 0, '': val == 0 };
    },
    colSpan: function colSpan(index) {
      if (index > 0) return 4;else return 3;
    },
    montaColunas: function montaColunas() {
      this.colunas = [{ nome: 'nome_cliente', visible: true, label: 'Cliente', sortable: true, orderby: null, class: '', style: 'min-width: 200px;' }, { nome: 'id', visible: false, label: 'Código' }, { nome: 'uf', visible: false, label: 'Estado' }, { nome: 'grupo_cliente', visible: false, label: 'Grupo de Cliente' }, { nome: 'segmento', visible: false, label: 'Segmento' }, { nome: 'telefone', visible: false, label: 'Telefone' }, { nome: 'email', visible: false, label: 'Email' }];

      var base = [{ nome: 'quantidade', visible: true, label: 'Quantidade', indexperiodo: null, sortable: true, orderby: 'desc', class: 'numerico size130 border-left', style: '' }, { nome: 'valor', visible: true, label: 'Valor Vendido', indexperiodo: null, sortable: true, orderby: null, class: 'numerico size130', style: '' },
      // { nome: 'participacao_qt_produtos_diferentes', visible: true, label: 'Participação Quantidade', indexperiodo: null, sortable: false, orderby: null, class: 'numerico size130', style: '' },
      { nome: 'participacao_valor', visible: true, label: 'Participação Valor', indexperiodo: null, sortable: false, orderby: null, class: 'numerico size130', style: '' }];

      var variacao = [
      // { nome: 'variacao_qt_produtos_diferentes', visible: true, label: 'Variação Quantidade', indexperiodo: null, sort: false, orderby: null, class: 'numerico size130 border-left', style: '' },
      { nome: 'variacao_valor', visible: true, label: 'Variação Valor', indexperiodo: null, sort: false, orderby: null, class: 'numerico size130', style: '' }];

      for (var y = 0; y < this.dados.periodos.length; y++) {
        var _colunas, _colunas2;

        for (var x = 0; x < base.length; x++) {
          base[x].indexperiodo = y; //indexperiodo é utilizado para identificar a coluna de ordenacao dentro do periodo
        }
        (_colunas = this.colunas).push.apply(_colunas, base);
        if (y > 0) (_colunas2 = this.colunas).push.apply(_colunas2, variacao);
      }

      this.colunas.push({ nome: 'valor', visible: true, label: 'Valor Total', sortable: true, orderby: null, class: 'numerico size130', style: '' });
    },
    handleShowFiltro: function handleShowFiltro() {
      this.showfiltro = true;
    },
    filtroChange: function filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;

      this.paramsFiltro.filtros[0].values = this.filtro.filial;
      this.paramsFiltro.filtros[1].values = this.filtro.segmento;
      this.paramsFiltro.filtros[2].values = this.filtro.grupocliente;
      this.paramsFiltro.filtros[3].values = this.filtro.estado;
      this.paramsFiltro.filtros[4].values = this.filtro.grupoestoque;
      this.paramsFiltro.filtros[5].values = this.filtro.produto;

      this.loadData();
    },
    filtroCancel: function filtroCancel() {
      this.showfiltro = false;
    },
    loadData: function loadData(excel) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "consulta/vendas/vendascliente";


                _this.filtro.excel = excel;

                if (!excel) {
                  _context.next = 6;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this, url, _this.filtro, "post");
                _context.next = 11;
                break;

              case 6:
                _this.mounting = true;
                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, url, _this.filtro, "post");

              case 9:
                data = _context.sent;

                if (data) {
                  _this.dados = data;
                } else {
                  _this.dados = {};
                }

              case 11:
                _this.montaColunas();
                _this.mounting = false;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  computed: {
    produtos: function produtos() {
      if (!this.dados.clientes) return [];else return this.dados.clientes;
    },

    paramsChart: function paramsChart() {
      return { chart: { type: "ColumnChart" }, values: this.chartValues };
    },

    chartValues: function chartValues() {
      if (!this.produtos || this.produtos.length == 0) return [];

      var title = ["Cliente"];
      var produto = [];
      var tipoGrafico = 'Produtos Por Valor Vendido Em';

      for (var x = 0; x < this.dados.periodos.length; x++) {
        title.push(tipoGrafico + ' ' + this.dados.periodos[x].label);
      }

      var values = [title];

      for (var x = 0; x < this.produtos.length; x++) {
        produto = [this.produtos[x].nome_cliente];
        for (var y = 0; y < this.dados.periodos.length; y++) {
          produto.push(this.produtos[x][this.dados.periodos[y].nome].valor);
        }
        values.push(produto);
      }

      return values;
    }
  },

  mounted: function mounted() {},
  created: function created() {
    this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate());
    this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate());
    // this.filtro.periodos[0].data_inicio = "2020-02-01"
    // this.filtro.periodos[0].data_termino = "2020-08-17"

    this.loadData();
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */],
    Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
  },

  data: function data() {
    return {
      showfiltro: false,

      dados: {},
      dadosGrafico: null,

      data_referencia: null,
      filter: { //objeto utilizado pelo filtro de mes
        startDate: null,
        endDate: null
      },

      filtroUsuario: false,

      filtro: {},

      colunas: [],

      mounting: false

    };
  },


  computed: {
    colors: function colors() {
      //valor vendido, meta, mes anterior
      var color = '#d41b1b';
      if (this.dados.vendido_mes >= this.dados.meta_mes) color = '#0d904f';
      return [color, '#1a73e8', '#ffff00', '#5dade2'];
    },

    usuarios: function usuarios() {
      if (!this.dados.usuarios) return [];else return this.dados.usuarios;
    },

    paramsChart: function paramsChart() {
      return { chart: { type: "LineChart" }, values: this.chartValues, colors: this.colors };
    },

    chartValues: function chartValues() {
      if (!this.dadosGrafico || this.dadosGrafico.grafico.length == 0) return [];else return this.dadosGrafico.grafico;
    }

  },

  watch: {
    data_referencia: function data_referencia() {
      this.loadData();
    }
  },

  methods: {
    handleCloseFiltro: function handleCloseFiltro() {
      this.showfiltro = false;
    },
    clickMetas: function clickMetas() {
      this.$router.push('/metas');
    },
    clickRetornar: function clickRetornar() {
      this.$router.push('/');
    },
    montaColunas: function montaColunas() {
      this.colunas = [{ nome: 'nome', visible: true, label: 'Nome do Usuário', sortable: true, orderby: null, class: '', style: 'min-width: 200px;' }, { nome: 'posicao', visible: false, label: 'Posição', sortable: true, orderby: null, class: 'numerico size130', style: '' }, { nome: 'meta_valor', visible: true, label: 'Meta', sortable: true, orderby: null, class: 'numerico size130', style: '' }, { nome: 'valor', visible: true, label: 'Valor Vendido', sortable: true, orderby: null, class: 'numerico size130', style: '' }, { nome: 'meta_percentual', visible: true, label: '% Atingido', sortable: true, orderby: null, class: 'numerico size130', style: '' }, { nome: 'orcamentos_valor', visible: true, label: 'Valor de Orçamentos Abertos', sortable: true, orderby: null, class: 'numerico size130', style: '' }];
    },
    handleShowFiltro: function handleShowFiltro() {
      this.showfiltro = true;
    },
    handleMonthChange: function handleMonthChange(data) {
      this.filter.endDate = this.$lastDay(this.$addMonths(this.filter.startDate, 11));
      this.data_referencia = this.filter.startDate;

      this.$router.push({ path: '/consultas/vendas-vendedor', query: { datareferencia: this.data_referencia } });

      //this.loadData()
    },
    filtroChange: function filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;

      this.loadData();
    },
    loadData: function loadData(excel) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data, grafico;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "consulta/vendas/vendasusuario";


                _this.filtro.excel = excel;
                _this.filtro.data_referencia = _this.data_referencia;
                // this.filtro.resumo = false

                if (!excel) {
                  _context.next = 7;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this, url, _this.filtro, "post");
                _context.next = 17;
                break;

              case 7:
                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, url, _this.filtro, "post");

              case 9:
                data = _context.sent;

                if (data) {
                  _this.dados = data;
                } else {
                  _this.dados = {};
                }
                _this.montaColunas();

                url = "consulta/vendas/graficoevolucaovendas";
                _context.next = 15;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, url, _this.filtro, "post");

              case 15:
                grafico = _context.sent;

                if (grafico) {
                  _this.dadosGrafico = grafico;
                } else {
                  _this.dadosGrafico = {};
                }

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  mounted: function mounted() {},
  created: function created() {
    // this.data_referencia = "2020-06-01"

    this.filter.startDate = this.$firstDay(this.$getDate());
    this.filter.endDate = this.$lastDay(this.$getDate());
    this.data_referencia = this.filter.startDate;

    if (this.$route.query.usuario) {
      this.filtro.usuario = [this.$route.query.usuario];
      this.filtroUsuario = true;
    }

    if (this.$route.query.datareferencia) {
      this.filter.startDate = this.$firstDay(this.$route.query.datareferencia);
      this.filter.endDate = this.$lastDay(this.$route.query.datareferencia);
      this.data_referencia = this.filter.startDate;
    }

    this.loadData();
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */],
    Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
  },

  data: function data() {
    return {
      showfiltro: false,

      dados: {},
      dadosGrafico: null,

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {

        periodo: {
          label: "Data da venda",
          varios: false,
          data_inicio: null,
          data_termino: null
        },

        filtros: [{
          nome: "segmento",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "grupocliente",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "grupoestoque",
          label: null,
          url: null,
          varios: true,
          values: []
        }]
      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }]
      },

      colunas: [],

      mounting: false

    };
  },


  computed: {
    paramsChart: function paramsChart() {
      return { chart: { type: "ColumnChart" }, values: this.chartValues, colors: this.colors };
    },

    chartValues: function chartValues() {
      if (!this.dadosGrafico || this.dadosGrafico.grafico.length == 0) return [];else return this.dadosGrafico.grafico;
    }
  },

  watch: {
    data_referencia: function data_referencia() {
      this.loadData();
    }
  },

  methods: {
    clickRetornar: function clickRetornar() {
      this.$router.push('/');
    },
    montaColunas: function montaColunas() {
      this.colunas = [{ nome: 'pedido', visible: true, label: 'Número do Pedido', sortable: true, orderby: null, class: 'size130', style: '' }, { nome: 'data', visible: true, label: 'Data do Pedido', sortable: true, orderby: null, class: 'size130', style: '' }, { nome: 'cliente', visible: true, label: 'Cliente', sortable: true, orderby: null, class: '', style: 'width: 280px;' }, { nome: 'usuario', visible: true, label: 'Usuario', sortable: true, orderby: null, class: '', style: 'width: 120px;' }, { nome: 'preco_liquido', visible: true, label: 'Preço Unitário', sortable: true, orderby: null, class: 'numerico size130', style: '' }, { nome: 'quantidade', visible: true, label: 'Quantidade', sortable: true, orderby: null, class: 'numerico size130', style: '' }, { nome: 'total_sem_imposto', visible: true, label: 'Total', sortable: true, orderby: null, class: 'numerico size130', style: '' }, { nome: 'total_com_imposto', visible: true, label: 'Total Com Imposto', sortable: true, orderby: null, class: 'numerico size130', style: '' }];
    },
    handleShowFiltro: function handleShowFiltro() {
      this.showfiltro = true;
    },
    filtroChange: function filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;

      this.paramsFiltro.filtros[0].values = this.filtro.segmento;
      this.paramsFiltro.filtros[1].values = this.filtro.grupocliente;
      this.paramsFiltro.filtros[2].values = this.filtro.grupoestoque;

      this.loadData();
    },
    loadData: function loadData(excel) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "consulta/vendas/vendaspedidosporproduto";
                // let url = "consulta/teste";

                _this.filtro.excel = excel;

                if (!excel) {
                  _context.next = 6;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this, url, _this.filtro, "post");
                _context.next = 11;
                break;

              case 6:
                _context.next = 8;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, url, _this.filtro, "post");

              case 8:
                data = _context.sent;

                // const data = await apiORDS(this.$store.getters.urlOrds + url)
                if (data) {
                  _this.dados = data.items;
                } else {
                  _this.dados = {};
                }
                _this.montaColunas();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  mounted: function mounted() {},
  created: function created() {
    this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate());
    this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate());

    this.loadData();
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */],
    Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
  },

  data: function data() {
    return {
      showfiltro: false,

      dados: {},
      dadosGrafico: null,

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {

        filtros: [{
          nome: "usuario",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "segmento",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "grupocliente",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "estado",
          label: null,
          url: null,
          varios: true,
          values: []
        }]

      },

      filtro: {},

      colunas: [],

      nextPage: false

    };
  },


  computed: {
    // paramsChart: function () {
    //   return { chart: { type: "ColumnChart" }, values: this.chartValues, colors: this.colors }
    // },

    // chartValues: function () {
    //   if (!this.dadosGrafico || this.dadosGrafico.grafico.length == 0)
    //     return []
    //   else
    //     return this.dadosGrafico.grafico
    // },
  },

  watch: {},

  methods: {
    handleCloseFiltro: function handleCloseFiltro() {
      this.showfiltro = false;
    },
    clickRetornar: function clickRetornar() {
      this.$router.push('/');
    },
    montaColunas: function montaColunas() {
      this.colunas = [{ nome: 'razao', visible: true, label: 'Nome/Razão', sortable: true, orderby: null, class: '', style: 'width: 280px;' }, { nome: 'fantasia', visible: true, label: 'Nome Fantasia', sortable: true, orderby: null, class: '', style: 'width: 280px;' }, { nome: 'cnpjcpf', visible: true, label: 'CNPJ/CPF', sortable: false, orderby: null, class: 'size130', style: '' }, { nome: 'iest', visible: true, label: 'Inscrição Est', sortable: false, orderby: null, class: 'size130', style: '' }, { nome: 'endereco', visible: true, label: 'Endereço', sortable: false, orderby: null, class: '', style: 'width: 280px;' }, { nome: 'bairro', visible: true, label: 'Bairro', sortable: false, orderby: null, class: '', style: 'width: 280px;' }, { nome: 'cidade', visible: true, label: 'Cidade', sortable: false, orderby: null, class: '', style: 'width: 280px;' }, { nome: 'uf', visible: true, label: 'Estado', sortable: false, orderby: null, class: '', style: '' }, { nome: 'cep', visible: true, label: 'Cep', sortable: false, orderby: null, class: '', style: '' }, { nome: 'nome_usuario', visible: true, label: 'Usuario', sortable: true, orderby: null, class: 'size130', style: '' }, { nome: 'nome_segmento', visible: true, label: 'Segmento', sortable: true, orderby: null, class: 'size130', style: '' }, { nome: 'nome_grupo', visible: true, label: 'Grupo de cliente', sortable: true, orderby: null, class: 'size130', style: '' }, { nome: 'telefone', visible: true, label: 'Telefones', sortable: true, orderby: null, class: 'size130', style: 'min-width: 180px;' }, { nome: 'email', visible: true, label: 'Emails', sortable: true, orderby: null, class: 'size130', style: 'min-width: 120px;' }];
    },
    handleShowFiltro: function handleShowFiltro() {

      this.showfiltro = true;
    },
    filtroChange: function filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;

      this.paramsFiltro.filtros[0].values = this.filtro.usuario;
      this.paramsFiltro.filtros[1].values = this.filtro.segmento;
      this.paramsFiltro.filtros[2].values = this.filtro.grupocliente;
      this.paramsFiltro.filtros[3].values = this.filtro.estado;

      this.loadData();
    },
    scroll: function scroll() {
      var _this = this;

      window.onscroll = function () {
        if (_this.nextPage) return;
        var bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          _this.loadData(false, true);
        }
        // SysVars.scrollPosition = document.documentElement.scrollTop
      };
    },
    loadData: function loadData(excel, loadMore) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data, _dados$items, self;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "consulta/vendas/listagemclientes";
                // let url = "consulta/teste";

                if (!loadMore) {
                  _context.next = 8;
                  break;
                }

                if (!_this2.dados.has_more) {
                  _context.next = 7;
                  break;
                }

                _this2.filtro.page = _this2.dados.next_page;
                _this2.nextPage = true;
                _context.next = 8;
                break;

              case 7:
                return _context.abrupt("return");

              case 8:

                _this2.filtro.excel = excel;

                if (!excel) {
                  _context.next = 14;
                  break;
                }

                _this2.filtro.page = null;
                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this2, url, _this2.filtro, "post");
                _context.next = 19;
                break;

              case 14:
                _context.next = 16;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this2.$store, url, _this2.filtro, "post");

              case 16:
                data = _context.sent;

                if (data) {
                  if (loadMore) {
                    (_dados$items = _this2.dados.items).push.apply(_dados$items, _toConsumableArray(data.items));
                    _this2.dados.has_more = data.has_more;
                    _this2.dados.next_page = data.next_page;
                  } else _this2.dados = data;
                } else {
                  _this2.dados = [];
                }
                _this2.montaColunas();

              case 19:
                self = _this2;

                _this2.$nextTick(function () {
                  self.nextPage = false;
                });

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },

  mounted: function mounted() {
    this.scroll();
  },
  destroyed: function destroyed() {
    window.onscroll = null;
  },
  created: function created() {
    this.loadData();
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */],
    Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
  },

  data: function data() {
    return {
      showfiltro: false,

      dados: {},
      dadosGrafico: null,

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {

        periodo: {
          label: "Data do pedido",
          varios: false,
          data_inicio: null,
          data_termino: null
        },

        filtros: [{
          nome: "usuario",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "cliente",
          label: null,
          url: null,
          varios: true,
          values: []
        }]
      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }]
      },

      colunas: [],

      nextPage: false

    };
  },


  computed: {
    // paramsChart: function () {
    //   return { chart: { type: "ColumnChart" }, values: this.chartValues, colors: this.colors }
    // },

    // chartValues: function () {
    //   if (!this.dadosGrafico || this.dadosGrafico.grafico.length == 0)
    //     return []
    //   else
    //     return this.dadosGrafico.grafico
    // },
  },

  watch: {
    data_referencia: function data_referencia() {
      this.loadData();
    }
  },

  methods: {
    clickRetornar: function clickRetornar() {
      this.$router.push('/');
    },
    montaColunas: function montaColunas() {
      this.colunas = [{ nome: 'pedido', visible: true, label: 'Número do Pedido', sortable: true, orderby: null, class: 'size130', style: '' }, { nome: 'data', visible: true, label: 'Data do Pedido', sortable: true, orderby: null, class: 'size130', style: '' }, { nome: 'razao', visible: true, label: 'Cliente', sortable: true, orderby: null, class: '', style: 'min-width: 280px;' }, { nome: 'cnpjcpf', visible: true, label: 'Cnpj/Cpf', sortable: true, orderby: null, class: '', style: '' }, { nome: 'uf', visible: true, label: 'Estado', sortable: true, orderby: null, class: '', style: '' }, { nome: 'nome_usuario', visible: true, label: 'Usuario', sortable: true, orderby: null, class: '', style: 'min-width: 120px;' }, { nome: 'total_pedido', visible: true, label: 'Total do Pedido', sortable: false, orderby: null, class: 'numerico size130', style: '' }, { nome: 'total_faturado', visible: true, label: 'Total Faturado', sortable: false, orderby: null, class: 'numerico size130', style: '' }, { nome: 'total_aberto', visible: true, label: 'Saldo', sortable: false, orderby: null, class: 'numerico size130', style: '' }, { nome: 'nf', visible: true, label: 'Número NF', sortable: true, orderby: null, class: 'size130', style: '' }, { nome: 'datanf', visible: true, label: 'Data da NF', sortable: true, orderby: null, class: 'size130', style: '' }];
    },
    handleShowFiltro: function handleShowFiltro() {
      this.showfiltro = true;
    },
    filtroChange: function filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;

      this.paramsFiltro.filtros[0].values = this.filtro.usuario;
      this.paramsFiltro.filtros[1].values = this.filtro.cliente;

      this.loadData();
    },
    scroll: function scroll() {
      var _this = this;

      window.onscroll = function () {
        var bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          _this.loadData(false, true);
        }
        // SysVars.scrollPosition = document.documentElement.scrollTop
      };
    },
    loadData: function loadData(excel, loadMore) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data, _dados$items, self;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "consulta/vendas/vendaspedidosfaturados";
                // let url = "consulta/teste";

                if (!loadMore) {
                  _context.next = 8;
                  break;
                }

                if (!_this2.dados.has_more) {
                  _context.next = 7;
                  break;
                }

                _this2.filtro.page = _this2.dados.next_page;
                _this2.nextPage = true;
                _context.next = 8;
                break;

              case 7:
                return _context.abrupt("return");

              case 8:

                _this2.filtro.excel = excel;

                if (!excel) {
                  _context.next = 13;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this2, url, _this2.filtro, "post");
                _context.next = 18;
                break;

              case 13:
                _context.next = 15;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this2.$store, url, _this2.filtro, "post");

              case 15:
                data = _context.sent;

                if (data) {
                  if (loadMore) {
                    (_dados$items = _this2.dados.items).push.apply(_dados$items, _toConsumableArray(data.items));
                    _this2.dados.has_more = data.has_more;
                    _this2.dados.next_page = data.next_page;
                  } else _this2.dados = data;
                } else {
                  _this2.dados = {};
                }
                _this2.montaColunas();

              case 18:
                self = _this2;

                _this2.$nextTick(function () {
                  self.nextPage = false;
                });

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },

  mounted: function mounted() {
    this.scroll();
  },
  destroyed: function destroyed() {
    window.onscroll = null;
  },
  created: function created() {
    this.filtro.periodos[0].data_inicio = "2018-02-01";
    this.filtro.periodos[0].data_termino = "2021-09-01";

    this.loadData();
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */],
    Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
  },

  data: function data() {
    return {
      showfiltro: false,

      dados: {},
      dadosGrafico: null,

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {

        periodo: {
          label: "Data do pedido",
          varios: false,
          data_inicio: null,
          data_termino: null
        },

        filtros: [{
          nome: "usuario",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "cliente",
          label: null,
          url: null,
          varios: true,
          values: []
        }]
      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }]
      },

      colunas: [],

      nextPage: false

    };
  },


  computed: {
    // paramsChart: function () {
    //   return { chart: { type: "ColumnChart" }, values: this.chartValues, colors: this.colors }
    // },

    // chartValues: function () {
    //   if (!this.dadosGrafico || this.dadosGrafico.grafico.length == 0)
    //     return []
    //   else
    //     return this.dadosGrafico.grafico
    // },
  },

  watch: {
    data_referencia: function data_referencia() {
      this.loadData();
    }
  },

  methods: {
    clickRetornar: function clickRetornar() {
      this.$router.push('/');
    },
    montaColunas: function montaColunas() {
      this.colunas = [{ nome: 'pedido', visible: true, label: 'Número do Pedido', sortable: true, orderby: null, class: 'size130', style: '' }, { nome: 'data', visible: true, label: 'Data do Pedido', sortable: true, orderby: null, class: 'size130', style: '' }, { nome: 'razao', visible: true, label: 'Cliente', sortable: true, orderby: null, class: '', style: 'min-width: 280px;' }, { nome: 'cnpjcpf', visible: true, label: 'Cnpj/Cpf', sortable: true, orderby: null, class: '', style: '' }, { nome: 'uf', visible: true, label: 'Estado', sortable: true, orderby: null, class: '', style: '' }, { nome: 'nome_usuario', visible: true, label: 'Usuario', sortable: true, orderby: null, class: '', style: 'min-width: 120px;' }, { nome: 'vendedor_nome', visible: true, label: 'Vendedor', sortable: true, orderby: null, class: '', style: 'min-width: 120px;' }, { nome: 'total_pedido', visible: true, label: 'Total do Pedido', sortable: false, orderby: null, class: 'numerico size130', style: '' }, { nome: 'base_comissao', visible: true, label: 'Base Comissão', sortable: false, orderby: null, class: 'numerico size130', style: '' }, { nome: 'total_comissao', visible: true, label: 'Total Comissão', sortable: false, orderby: null, class: 'numerico size130', style: '' }, { nome: 'percentual_comissao', visible: true, label: '% Comissão', sortable: false, orderby: null, class: 'numerico size130', style: '' }];
    },
    handleShowFiltro: function handleShowFiltro() {
      this.showfiltro = true;
    },
    filtroChange: function filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;

      this.paramsFiltro.filtros[0].values = this.filtro.usuario;
      this.paramsFiltro.filtros[1].values = this.filtro.cliente;

      this.loadData();
    },
    scroll: function scroll() {
      var _this = this;

      window.onscroll = function () {
        var bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          _this.loadData(false, true);
        }
        // SysVars.scrollPosition = document.documentElement.scrollTop
      };
    },
    loadData: function loadData(excel, loadMore) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data, _dados$items, self;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "consulta/vendas/vendascomissaoporpedido";
                // let url = "consulta/teste";

                if (!loadMore) {
                  _context.next = 8;
                  break;
                }

                if (!_this2.dados.has_more) {
                  _context.next = 7;
                  break;
                }

                _this2.filtro.page = _this2.dados.next_page;
                _this2.nextPage = true;
                _context.next = 8;
                break;

              case 7:
                return _context.abrupt("return");

              case 8:

                _this2.filtro.excel = excel;

                if (!excel) {
                  _context.next = 13;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this2, url, _this2.filtro, "post");
                _context.next = 18;
                break;

              case 13:
                _context.next = 15;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this2.$store, url, _this2.filtro, "post");

              case 15:
                data = _context.sent;

                if (data) {
                  if (loadMore) {
                    (_dados$items = _this2.dados.items).push.apply(_dados$items, _toConsumableArray(data.items));
                    _this2.dados.has_more = data.has_more;
                    _this2.dados.next_page = data.next_page;
                  } else _this2.dados = data;
                } else {
                  _this2.dados = {};
                }
                _this2.montaColunas();

              case 18:
                self = _this2;

                _this2.$nextTick(function () {
                  self.nextPage = false;
                });

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },

  mounted: function mounted() {
    this.scroll();
  },
  destroyed: function destroyed() {
    window.onscroll = null;
  },
  created: function created() {
    this.filtro.periodos[0].data_inicio = "2018-02-01";
    this.filtro.periodos[0].data_termino = "2021-09-01";

    this.loadData();
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */],
    Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
  },

  data: function data() {
    return {
      showfiltro: false,

      dados: {},

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {
        periodo: {
          label: "Período",
          varios: false,
          data_inicio: null,
          data_termino: null
        },
        filtros: [{ nome: "filial", label: null, url: null, varios: false, values: [] }, {
          nome: "segmento",
          label: null,
          url: null,
          varios: true,
          values: []
        }]
      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }]
      },

      colunas: [],

      mounting: false

    };
  },


  watch: {},

  methods: {
    handleShowCaixa: function handleShowCaixa(codvabertura) {
      this.$router.push('/varejo/controlecaixa/' + codvabertura);
    },
    clickRetornar: function clickRetornar() {
      this.$router.push('/painelvarejo');
    },
    varColor: function varColor(val) {
      return { 'var-negative': val < 0, 'var-positive': val >= 0, '': val == 0 };
    },
    colSpan: function colSpan(index) {
      if (index > 0) return 6;else return 4;
    },
    handleShowFiltro: function handleShowFiltro() {
      this.showfiltro = true;
    },
    filtroChange: function filtroChange(filtro) {
      this.showfiltro = false;
      this.filtro = filtro;
      this.paramsFiltro.filtros[0].values = this.filtro.filial;

      this.loadData();
    },
    loadData: function loadData(excel) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "consulta/vendas/varejomovimentocaixa";


                _this.filtro.excel = excel;

                if (!excel) {
                  _context.next = 6;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this, url, _this.filtro, "post");
                _context.next = 11;
                break;

              case 6:
                _this.mounting = true;
                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, url, _this.filtro, "post");

              case 9:
                data = _context.sent;

                if (data) {
                  _this.dados = data;
                }

              case 11:
                _this.mounting = false;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  computed: {
    formasPagamento: function formasPagamento() {
      return this.dados.formasPagamento;
    },

    descontos: function descontos() {
      return this.dados.descontosConcedidos;
    },

    devolucoes: function devolucoes() {
      return this.dados.devolucoes;
    },

    resumoVendas: function resumoVendas() {
      return this.dados.resumoVendas;
    },

    movimentosCaixa: function movimentosCaixa() {
      return this.dados.movimentosCaixa;
    },

    caixasPeriodo: function caixasPeriodo() {
      return this.dados.caixasPeriodo;
    },

    dadosCaixa: function dadosCaixa() {
      return this.dados.dadosCaixa;
    },

    paramsChartFormas: function paramsChartFormas() {
      if (!this.formasPagamento) return null;

      var grafico = [["Forma de Pagamento", "Valor"]];

      for (var x = 0; x < this.formasPagamento.lista.length; x++) {
        grafico.push([this.formasPagamento.lista[x].descricao, this.formasPagamento.lista[x].valor]);
      }

      return {
        chart: { type: 'PieChart' },
        values: grafico
      };
    },

    paramsChartResumo: function paramsChartResumo() {
      if (!this.resumoVendas) return null;

      var grafico = [["Grupo de Produto", "Valor"]];

      for (var x = 0; x < this.resumoVendas.lista.length; x++) {
        grafico.push([this.resumoVendas.lista[x].descricao, this.resumoVendas.lista[x].valor]);
      }

      return {
        chart: { type: 'PieChart' },
        values: grafico
      };
    }

  },

  mounted: function mounted() {},
  created: function created() {
    this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate());
    this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate());
    this.loadData();
  }
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_varejo_pendcli_vue__ = __webpack_require__(485);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_41157c08_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_varejo_pendcli_vue__ = __webpack_require__(1362);
function injectStyle (ssrContext) {
  __webpack_require__(1356)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_varejo_pendcli_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_41157c08_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_varejo_pendcli_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consulta_varejo_pendcli_det_vue__ = __webpack_require__(1358);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    codvabertura: null
  },

  components: {
    Filtro: __WEBPACK_IMPORTED_MODULE_1__filtro__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_0__chart__["a" /* default */],
    ConsultaVarejoPendcliDet: __WEBPACK_IMPORTED_MODULE_3__consulta_varejo_pendcli_det_vue__["a" /* default */]
  },

  data: function data() {
    return {
      showfiltro: false,
      showDetalhe: false,

      dados: {},
      detalhe: {},

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {
        periodo: {
          label: "Período",
          varios: false,
          data_inicio: null,
          data_termino: null
        },
        filtros: [{ nome: "filial", label: null, url: null, varios: false, values: [] }, { nome: "cliente", label: null, url: null, varios: false, values: [] }]
      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }]
      },

      colunas: [],

      mounting: false

    };
  },


  watch: {},

  methods: {
    handleView: function handleView(item) {
      console.log(item);
      this.detalhe = item;
      this.showfiltro = false;
      this.showDetalhe = true;
    },
    closeView: function closeView() {
      this.showfiltro = false;
      this.showDetalhe = false;
      this.loadData();
    },
    handleAction: function handleAction(act, obj) {
      //if (act == 21) {
      //  this.handleEdit(obj.codpedv)
      //}
    },
    handleBarGrid: function handleBarGrid(item) {
      var options = { barDefault: true, btnView: true, btnEdit: false };

      return options;
    },
    getActions: function getActions(pedv) {
      var actions = [];

      // actions.push({ action: 21, label: 'Visualização' })
      return actions;
    },
    handleShowCaixa: function handleShowCaixa() {
      this.$router.push('/varejo/controlependenciacliente');
    },
    clickRetornar: function clickRetornar() {
      this.$router.push('/painelvarejo');
    },
    handleShowFiltro: function handleShowFiltro() {
      this.showfiltro = true;
    },
    filtroChange: function filtroChange(filtro) {
      this.showfiltro = false;
      this.filtro = filtro;
      this.paramsFiltro.filtros[0].values = this.filtro.filial;

      this.loadData();
    },
    loadData: function loadData(excel) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "consulta/vendas/varejopendenciacliente";


                _this.filtro.excel = excel;

                if (!excel) {
                  _context.next = 6;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiDownload2"])(_this, url, _this.filtro, "post");
                _context.next = 11;
                break;

              case 6:
                _this.mounting = true;
                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this.$store, url, _this.filtro, "post");

              case 9:
                data = _context.sent;

                if (data) {
                  _this.dados = data;
                }

              case 11:
                _this.mounting = false;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  computed: {},

  mounted: function mounted() {},
  created: function created() {
    this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate());
    this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate());
    this.loadData();
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    codvabertura: null,
    detalhe: {}
  },

  components: {
    Filtro: __WEBPACK_IMPORTED_MODULE_1__filtro__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_0__chart__["a" /* default */]
  },

  data: function data() {
    return {
      valorPagamento: null,

      colunas: [],

      mounting: false

    };
  },


  watch: {},

  methods: {
    handleEnterPaymentValue: function handleEnterPaymentValue() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, obj, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "varejo/recebimento_pendencia_cliente";
                obj = {
                  pendcli: {
                    codvabertura: _this.codvabertura,
                    valor: _this.valorPagamento,
                    fin: _this.detalhe.detalhes
                  }
                };
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this.$store, url, obj, "post");

              case 4:
                data = _context.sent;

                if (data) {
                  _this.handleClose();
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleClose: function handleClose() {
      this.$emit("closeform");
    },
    handleAction: function handleAction(act, obj) {
      //if (act == 21) {
      //  this.handleEdit(obj.codpedv)
      //}
    },
    handleBarGrid: function handleBarGrid(item) {
      var options = { barDefault: true, btnView: false, btnEdit: false };

      return options;
    },
    getActions: function getActions(pedv) {
      var actions = [];

      // actions.push({ action: 21, label: 'Visualização' })
      return actions;
    },
    loadData: function loadData(excel) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },

  computed: {},

  mounted: function mounted() {},
  created: function created() {}
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//








/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            show: false,
            metadata: this.$store.getters.getEntities.metadata,
            colunas: [],
            total: [],
            dados: null,
            filter: { //objeto utilizado pelo filtro de mes
                startDate: null,
                endDate: null
            }

        };
    },


    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"]
    },

    computed: {
        leadList: function leadList() {
            return this.$store.getters.getLeadCrmList;
        }
    },

    watch: {},

    filters: {},

    methods: {
        blurValores: function blurValores(mes) {
            // AO SAIR DO CAMPO DE VALOR, EFETUA A TOTALIZACAO DA COLUNA CORRESPONDENTE AO MES
            var idx = this.dados.meses.indexOf(mes);
            var tot = 0;
            for (var y = 0; y < this.dados.usuarios.length; y++) {
                tot = tot + Number(this.dados.usuarios[y].valores[idx].valor_meta);
            }
            this.$set(this.total, idx, tot);
        },
        handleMonthChange: function handleMonthChange(data) {
            this.filter.endDate = this.$lastDay(this.$addMonths(this.filter.startDate, 11));
            this.loadData();
        },
        loadColunas: function loadColunas() {
            var _this = this;

            this.show = false;

            this.colunas = [{ nome: 'usuario', visible: true, label: 'Usuário', sortable: false, orderby: null, class: '', style: 'min-width: 280px;' }];

            if (!this.dados) return;

            var m = null;
            var month = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

            for (var x = 0; x < this.dados.meses.length; x++) {
                m = this.dados.meses[x];

                var _m$split = m.split("-"),
                    _m$split2 = _slicedToArray(_m$split, 2),
                    ano = _m$split2[0],
                    mes = _m$split2[1];

                this.colunas.push({ nome: m, label: month[mes - 1] + '/' + ano, visible: true, class: 'size130' });
            }

            var valores = null;
            var idx = null;

            for (var x = 0; x < this.dados.usuarios.length; x++) {
                //pega as metas correspondentes ao usuario em dados.valores
                valores = this.dados.valores.filter(function (obj) {
                    return obj.id == _this.dados.usuarios[x].id;
                });

                this.dados.usuarios[x].valores = [];
                for (var y = 0; y < this.dados.meses.length; y++) {
                    this.dados.usuarios[x].valores.push({ mes: this.dados.meses[y], valor_meta: null });
                }

                if (valores[0]) {
                    for (var y = 0; y < valores[0].meses.length; y++) {
                        idx = this.dados.meses.indexOf(valores[0].meses[y].mes);
                        this.dados.usuarios[x].valores[idx].valor_meta = valores[0].meses[y].valor_meta;
                    }
                }
            }

            // efetua a totalizacao das metas

            this.total = [];
            var tot = 0;
            for (var x = 0; x < this.dados.meses.length; x++) {
                tot = 0;
                for (var y = 0; y < this.dados.usuarios.length; y++) {
                    tot = tot + this.dados.usuarios[y].valores[x].valor_meta;
                }
                this.total.push(tot);
            }

            this.show = true;
        },
        closeForm: function closeForm() {
            this.$modalForm(false);
            this.$router.push('/consultas/vendas-vendedor');
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var q, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                // apiORDS(this.$store.getters.urlOrds + 'crm/email/count', null, true).then((result) => { 
                                //     if (result.items.length > 0)
                                //     SysVars.countEmail = result.items[0].email
                                //     else 
                                //     SysVars.countEmail = null

                                q = '?after=' + Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiDateORDS"])(_this2.filter.startDate) + '&before=' + Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiDateORDS"])(_this2.filter.endDate, true);
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDS"])(_this2.$store.getters.urlOrds + 'cg/metav/' + q, null);

                            case 3:
                                data = _context.sent;

                                _this2.dados = data;
                                _this2.loadColunas();

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        handleSalvar: function handleSalvar() {
            this.apiPost();
        },
        handleCancelar: function handleCancelar() {
            this.loadData();
        },
        apiPost: function apiPost() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var metas, obj, x, y, _dados$meses$y$split, _dados$meses$y$split2, ano, mes, dt, modulo, sendData, data;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a gravacao

                                metas = [];
                                obj = null;


                                for (x = 0; x < _this3.dados.usuarios.length; x++) {
                                    obj = { idusuario: _this3.dados.usuarios[x].id, valores: [] };

                                    for (y = 0; y < _this3.dados.usuarios[x].valores.length; y++) {
                                        _dados$meses$y$split = _this3.dados.meses[y].split("-"), _dados$meses$y$split2 = _slicedToArray(_dados$meses$y$split, 2), ano = _dados$meses$y$split2[0], mes = _dados$meses$y$split2[1];
                                        dt = _this3.$firstDay(ano + '-' + mes + '-01');

                                        obj.valores.push({ data: dt, valor_meta: _this3.dados.usuarios[x].valores[y].valor_meta });
                                    }
                                    metas.push(obj);
                                }

                                modulo = 'cg/metav/';
                                sendData = { metas: metas };
                                _context2.next = 7;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this3.$store, modulo, sendData, 'post');

                            case 7:
                                data = _context2.sent;

                                if (data.errmessages) {
                                    _this3.errmessages = data.errmessages;
                                    _this3.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    _this3.$erpToastUpdated();
                                    _this3.errmessages = {};
                                    _this3.closeForm();
                                }

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        }
    },

    created: function created() {
        this.filter.startDate = this.$firstDay(this.$getDate());
        this.filter.endDate = this.$lastDay(this.$addMonths(this.filter.startDate, 11));
        this.loadData();
    }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */],
    Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
  },

  data: function data() {
    return {
      showfiltro: false,

      dados: {},
      dadosGrafico: null,

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {
        selects: [],
        periodo: {
          label: "Data do pedido",
          varios: false,
          data_inicio: null,
          data_termino: null
        },

        filtros: [{
          nome: "usuario",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "cliente",
          label: null,
          url: null,
          varios: true,
          values: []
        }, {
          nome: "pdstatus",
          label: null,
          url: null,
          varios: true,
          values: []
        }]
      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }]

      },

      colunas: [],

      nextPage: false

    };
  },


  computed: {
    // paramsChart: function () {
    //   return { chart: { type: "ColumnChart" }, values: this.chartValues, colors: this.colors }
    // },

    // chartValues: function () {
    //   if (!this.dadosGrafico || this.dadosGrafico.grafico.length == 0)
    //     return []
    //   else
    //     return this.dadosGrafico.grafico
    // },
  },

  watch: {
    data_referencia: function data_referencia() {
      this.loadData();
    }
  },

  methods: {
    clickRetornar: function clickRetornar() {
      this.$router.push('/');
    },
    montaColunas: function montaColunas() {
      this.colunas = [{ nome: 'pedido', visible: true, label: 'Número do Pedido', sortable: true, orderby: null, class: '', style: '' }, { nome: 'data', visible: true, label: 'Data do Pedido', sortable: true, orderby: null, class: '', style: '' }, { nome: 'razao', visible: true, label: 'Cliente', sortable: true, orderby: null, class: '', style: 'min-width: 280px;' }, { nome: 'cnpjcpf', visible: true, label: 'Cnpj/Cpf', sortable: true, orderby: null, class: '', style: '' }, { nome: 'uf', visible: true, label: 'Estado', sortable: true, orderby: null, class: '', style: '' }, { nome: 'nome_usuario', visible: true, label: 'Usuario', sortable: true, orderby: null, class: '', style: 'min-width: 120px;' }, { nome: 'status', visible: true, label: 'Situação', sortable: false, orderby: null, class: 'textual' }, { nome: 'total_pedido', visible: true, label: 'Total do Pedido', sortable: false, orderby: null, class: 'numerico size130', style: '' }];
    },
    handleShowFiltro: function handleShowFiltro() {
      this.showfiltro = true;
    },
    filtroChange: function filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;

      this.paramsFiltro.filtros[0].values = this.filtro.usuario;
      this.paramsFiltro.filtros[1].values = this.filtro.cliente;
      this.paramsFiltro.filtros[2].values = this.filtro.pdstatus;

      this.loadData();
    },
    scroll: function scroll() {
      var _this = this;

      window.onscroll = function () {
        var bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          _this.loadData(false, true);
        }
        // SysVars.scrollPosition = document.documentElement.scrollTop
      };
    },
    loadData: function loadData(excel, loadMore) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data, _dados$items, self;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "consulta/vendas/recebimentospedido";
                // let url = "consulta/teste";

                if (!loadMore) {
                  _context.next = 8;
                  break;
                }

                if (!_this2.dados.has_more) {
                  _context.next = 7;
                  break;
                }

                _this2.filtro.page = _this2.dados.next_page;
                _this2.nextPage = true;
                _context.next = 8;
                break;

              case 7:
                return _context.abrupt("return");

              case 8:

                _this2.filtro.excel = excel;

                console.log(_this2.filtro);

                if (!excel) {
                  _context.next = 14;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this2, url, _this2.filtro, "post");
                _context.next = 19;
                break;

              case 14:
                _context.next = 16;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this2.$store, url, _this2.filtro, "post");

              case 16:
                data = _context.sent;

                if (data) {
                  if (loadMore) {
                    (_dados$items = _this2.dados.items).push.apply(_dados$items, _toConsumableArray(data.items));
                    _this2.dados.has_more = data.has_more;
                    _this2.dados.next_page = data.next_page;
                  } else _this2.dados = data;
                } else {
                  _this2.dados = {};
                }
                _this2.montaColunas();

              case 19:
                self = _this2;

                _this2.$nextTick(function () {
                  self.nextPage = false;
                });

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },

  mounted: function mounted() {
    this.scroll();
  },
  destroyed: function destroyed() {
    window.onscroll = null;
  },
  created: function created() {
    this.filtro.periodos[0].data_inicio = "2018-02-01";
    this.filtro.periodos[0].data_termino = "2021-09-01";

    this.loadData();
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forms_estoque_estoque_ajuste_transferencia_form__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_grade_estoque__ = __webpack_require__(492);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */],
    BarGrid: __WEBPACK_IMPORTED_MODULE_5__components_bar_grid__["default"],
    EstoqueAjusteTransferenciaForm: __WEBPACK_IMPORTED_MODULE_0__forms_estoque_estoque_ajuste_transferencia_form__["default"],
    gradeEstoque: __WEBPACK_IMPORTED_MODULE_6__components_grade_estoque__["a" /* default */]
  },

  data: function data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      coditem: null,
      lote: null,
      codfil: null,

      dados: {},

      estoqueCols: [],
      movCols: [],

      mounting: false,

      maisFiltro: false,

      filtroPeriodo: { //objeto utilizado pelo filtro de mes
        startDate: null,
        endDate: null
      },

      showAjusteTransferenciaForm: false,
      paramsAjusteTransferencia: null,
      viewDetalhesAlocacao: false
    };
  },


  watch: {
    coditem: function coditem() {
      this.loadData();
    }
  },

  methods: {
    handleCloseFiltro: function handleCloseFiltro() {
      this.showfiltro = false;
    },
    handlePesquisar: function handlePesquisar() {
      this.loadData();
    },
    closeAjusteForm: function closeAjusteForm() {
      this.$modalForm(false);
      this.showAjusteTransferenciaForm = false;
      this.loadData();
    },
    handleTransferirEstoque: function handleTransferirEstoque(codqest) {
      this.paramsAjusteTransferencia = { transferencia: true, codqest: codqest, coditem: this.coditem };
      this.showAjusteTransferenciaForm = true;
      this.$modalForm(true);
    },
    handleAjustarEstoque: function handleAjustarEstoque(codqest) {
      this.paramsAjusteTransferencia = { ajuste: true, codqest: codqest, coditem: this.coditem };
      this.showAjusteTransferenciaForm = true;
      this.$modalForm(true);
    },
    clickRetornar: function clickRetornar() {
      this.$router.back();
    },
    handleMonthChange: function handleMonthChange() {
      this.loadData();
    },
    handleSelectItem: function handleSelectItem() {
      this.loadData();
    },
    getActions: function getActions(estoque) {
      var moreActions = [];
      var act = { action: 1, label: 'Transferir Depósito', id: estoque.codqest };
      moreActions.push(act);
      var act = { action: 2, label: 'Ajustar Estoque', id: estoque.codqest };
      moreActions.push(act);
      //        var act = { action: 3, label: 'Bloquear Lote', id: estoque.codqest }
      //        moreActions.push(act)
      return moreActions;
    },
    textTipoDocumento: function textTipoDocumento(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__shared_utils__["getText"])(value, this.metadata.mest.tpdocest);
    },
    handleActionItem: function handleActionItem(action, obj, actionObj) {

      // parametro ID = estoque.codqest

      if (action == 2) {
        //ajustar
        //this.$router.push('/estoque/ajuste/novo/1663')
        this.handleAjustarEstoque(actionObj.id);
      }

      if (action == 1) {
        //transferir estoque
        this.handleTransferirEstoque(actionObj.id);
      }

      //     if (action == 3) { //bloquear lote
      //       this.$router.push('/estoque/bloqueiolote/')
      //     }
    },
    montaColunas: function montaColunas() {
      this.estoqueCols = [{ nome: 'quantidade', visible: true, label: 'Quantidade', indexperiodo: null, sortable: true, orderby: 'desc', class: 'numerico size130', style: '' }, { nome: 'coddeposito', visible: true, label: 'Depósito', sortable: true, orderby: null, class: '', style: 'min-width: 200px;' }, { nome: 'lote', visible: true, label: 'Lote', sortable: true, orderby: null, class: '', style: '' }, { nome: 'sublote', visible: true, label: 'Sublote', sortable: true, orderby: null, class: '', style: '' }, { nome: 'dtval', visible: true, label: 'Validade', sortable: true, orderby: null, class: '', style: '' }, { nome: 'diasvalidade', visible: true, label: 'Dias', sortable: true, orderby: null, class: '', style: '' }, { nome: 'loteforn', visible: true, label: 'Lote Fornecedor', sortable: true, orderby: null, class: '', style: '' }];

      this.movCols = [{ nome: 'data', visible: true, label: 'Data', sortable: true, orderby: null, class: '', style: '' }, { nome: 'tipo', visible: true, label: 'Movimento', sortable: true, orderby: null, class: '', style: '' }, { nome: 'tipodocumento', visible: true, label: 'Tipo Documento', sortable: true, orderby: null, class: '', style: '' },
      //{ nome: 'nf', visible: true, label: 'Nota Fiscal', sortable: true, orderby: null, class: '', style: '' },
      { nome: 'documento', visible: true, label: 'Documento', sortable: true, orderby: null, class: '', style: '' }, { nome: 'quantidade', visible: true, label: 'Quantidade', indexperiodo: null, sortable: true, orderby: 'desc', class: 'numerico size130', style: '' }, { nome: 'coddeposito', visible: true, label: 'Depósito', sortable: true, orderby: null, class: '', style: 'min-width: 200px;' }, { nome: 'linha', visible: true, label: 'Linha(Grade)', sortable: true, orderby: null, class: '', style: '' }, { nome: 'coluna', visible: true, label: 'Coluna(Grade)', sortable: true, orderby: null, class: '', style: '' }, { nome: 'lote', visible: true, label: 'Lote', sortable: true, orderby: null, class: '', style: '' }, { nome: 'sublote', visible: true, label: 'Sublote', sortable: true, orderby: null, class: '', style: '' }, { nome: 'dtval', visible: true, label: 'Validade', sortable: true, orderby: null, class: '', style: '' }, { nome: 'loteforn', visible: true, label: 'Lote Fornecedor', sortable: true, orderby: null, class: '', style: '' }, { nome: 'nome_usuario', visible: true, label: 'Usuário', sortable: true, orderby: null, class: '', style: '' }];
      // this.colunas.push({ nome: 'valor', visible: true, label: 'Valor Total', sortable: true, orderby: null, class: 'numerico size130', style: '' })
    },


    // handleShowFiltro() {
    //   this.showfiltro = true;
    // },

    // filtroChange(filtro) {
    //   this.showfiltro = false;

    //   this.filtro = filtro;

    //   this.paramsFiltro.filtros[0].values = this.filtro.filial
    //   this.paramsFiltro.filtros[1].values = this.filtro.segmento
    //   this.paramsFiltro.filtros[2].values = this.filtro.grupocliente
    //   this.paramsFiltro.filtros[3].values = this.filtro.estado
    //   this.paramsFiltro.filtros[4].values = this.filtro.grupoestoque

    //   this.loadData();
    // },

    showDetalhesAlocacao: function showDetalhesAlocacao() {
      this.viewDetalhesAlocacao = !this.viewDetalhesAlocacao;

      setTimeout(function () {
        var element = document.getElementById("alocacao");
        element.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, 500);
    },
    loadData: function loadData(excel) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.coditem) {
                  _context.next = 3;
                  break;
                }

                _this.dados = {};
                return _context.abrupt("return");

              case 3:
                url = "consulta/estoque/estoqueproduto";


                _this.filtro = {
                  coditem: _this.coditem,
                  codfil: _this.codfil,
                  lote: _this.lote,
                  data_inicio: _this.filtroPeriodo.startDate,
                  data_termino: _this.filtroPeriodo.endDate
                };

                _this.filtro.excel = excel;

                if (!excel) {
                  _context.next = 10;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this, url, _this.filtro, "post");
                _context.next = 15;
                break;

              case 10:
                _this.mounting = true;
                _context.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, url, _this.filtro, "post");

              case 13:
                data = _context.sent;

                if (data) {
                  _this.dados = data;
                } else {
                  _this.dados = {};
                }

              case 15:
                _this.montaColunas();
                _this.mounting = false;

                _this.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  computed: {
    showGradeItem: function showGradeItem() {
      return this.dados.isgrade && !this.mounting;
    },

    estoque: function estoque() {
      if (!this.dados.estoque || !this.dados.estoque.detalhes) return [];else return this.dados.estoque.detalhes;
    },
    movimento: function movimento() {
      if (!this.dados.movimentos || !this.dados.movimentos.detalhes) return [];else return this.dados.movimentos.detalhes;
    },
    alocacao: function alocacao() {
      if (!this.dados.movimentos || !this.dados.movimentos.detalhes_alocacao) return [];else return this.dados.movimentos.detalhes_alocacao;
    }
  },

  mounted: function mounted() {
    // this.coditem = '1663'

  },
  created: function created() {
    if (this.$route.query.coditem) {
      this.coditem = this.$route.query.coditem;
    }
    // this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate())
    // this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate())
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_estoque_ajuste_transferencia_form_vue__ = __webpack_require__(491);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_56cc89ac_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_estoque_ajuste_transferencia_form_vue__ = __webpack_require__(1376);
function injectStyle (ssrContext) {
  __webpack_require__(1374)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_estoque_ajuste_transferencia_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_56cc89ac_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_estoque_ajuste_transferencia_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params: Object
  },

  data: function data() {
    return {
      crudText: '',
      mest: _extends({}, this.$store.getters.getEntities.mest),
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela

      coditem: null,
      coditemgrade: null,
      codqest: null,
      coddeposito: null,
      tipo: null,
      motivo: null,
      qt: null,
      estoque: {
        coddeposito: null,
        local: null,
        lote: null,
        sublote: null
      },
      item: null,
      dadosEstoqueItem: null //item selecionado
    };
  },


  computed: {
    editing: function editing() {
      return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
    },

    transferencia: function transferencia() {
      return this.params.transferencia;
    },

    ajuste: function ajuste() {
      return this.params.ajuste;
    },

    novoSaldo: function novoSaldo() {
      var saldo = Number(this.estoque.qt);
      console.log(saldo);
      if (isNaN(saldo)) {
        saldo = 0;
      }

      if (this.tipo == 'S') {
        saldo -= Number(this.qt);
      } else {
        saldo += Number(this.qt);
      }

      if (this.estoque.lote) return 'O novo saldo para este lote será de: ' + Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(saldo, 4);else return 'O novo saldo será de: ' + Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(saldo, 4);
    },

    itemList: function itemList() {
      return this.$store.getters.getItemSalesList;
    }

  },

  methods: {
    handleSelecionaItem: function handleSelecionaItem(item) {
      this.item = item;
      if (!item) return;
      this.coditem = item.coditem;
      this.loadDadosItem();
    },
    handleSelecionaLote: function handleSelecionaLote() {
      console.log('selecionalote');
      this.estoque = null;
    },
    closeForm: function closeForm() {
      this.$emit('closeform');
    },
    itemgradeValidate: function itemgradeValidate() {
      var result = false;

      this.errmessages = [];

      if (this.item.isgrade && this.item.isgrade === 'S' && !this.coditemgrade) {
        this.errmessages.push("Item grade inválido!");
        result = true;
      }
      // console.log('itemgtin validate ' + result)
      return result;
    },
    handleSave: function handleSave() {
      var _this = this;

      //BOTAO SALVAR
      this.$validator.validateAll().then(function (isValid) {

        var lErro = false;
        if (_this.itemgradeValidate()) {
          lErro = true;
        }
        if (!isValid || lErro) {
          _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          _this.apiPost();
        }
      });
    },
    handleDelete: function handleDelete() {
      //BOTAO Excluir
      this.apiDelete();
    },
    loadDadosItem: function loadDadosItem() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, url, data, self, estoque;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = { filter: null, coditem: _this2.coditem, codtabpre: null };
                _context.next = 3;
                return _this2.$store.dispatch('loadItemSales', params);

              case 3:
                _this2.selectedIndex = 0;
                if (_this2.coditem && _this2.itemList.length > 0) {
                  _this2.item = _this2.itemList[0];
                }

                // CARREGA AS INFORMAÇÕES DE ESTOQUE DO PRODUTO

                url = "consulta/estoque/estoqueproduto";


                _this2.filtro = {
                  coditem: _this2.coditem
                };

                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this2.$store, url, _this2.filtro, "post");

              case 9:
                data = _context.sent;

                if (data) {
                  _this2.dadosEstoqueItem = data;
                } else {}

                self = _this2;
                estoque = null;

                estoque = _this2.dadosEstoqueItem.estoque.detalhes.filter(function (obj) {
                  return obj.codqest == self.codqest;
                });

                if (estoque.length > 0) {
                  _this2.estoque = estoque[0];
                  _this2.coditemgrade = _this2.estoque.coditemgrade;
                }

                _this2.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    loadData: function loadData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var self;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this3;
                // this.mest = null

                Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDS"])(_this3.$store.getters.urlOrds + 'estoque/movimento/' + _this3.index, null, true).then(function (result) {
                  self.mest = result.items[0];
                });

                _this3.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },


    // async apiDelete () {
    //     //efetua a exclusao
    //     var modulo = 'estoque/movimento/' + this.estado.uf

    //     const data = await apiORDSdelete(this.$store, modulo)
    //     this.$erpToastDeleted()
    //     this.closeForm()
    // },

    apiPost: function apiPost() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var modulo, sendData, metodo, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                modulo = 'estoque/movimento/';
                sendData = {};


                sendData = {
                  movimento: {
                    estoque: _this4.estoque,
                    coditem: _this4.coditem,
                    coditemgrade: _this4.coditemgrade,
                    tipo: _this4.tipo,
                    motivo: _this4.motivo,
                    qt: _this4.qt
                  }
                };

                if (_this4.transferencia) {
                  sendData.movimento.destino = { coddeposito: _this4.coddeposito, local: _this4.local };
                  sendData.movimento.transferencia = _this4.transferencia;
                } else {
                  sendData.movimento.ajuste = _this4.ajuste;
                }

                metodo = 'post';
                _context3.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

              case 7:
                data = _context3.sent;

                if (data.errmessages) {
                  _this4.errmessages = data.errmessages;
                  _this4.$erpToastError('O movimento não foi concluído.');
                } else {
                  _this4.$erpToastInserted();
                  _this4.errmessages = [];
                  _this4.closeForm();
                }

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  },

  components: {},

  beforeCreate: function beforeCreate() {},
  created: function created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });

    if (this.params && this.params.coditem) this.coditem = this.params.coditem;
    if (this.params && this.params.codqest) this.codqest = this.params.codqest;

    this.loadDadosItem();

    // this.crudText = this.$crudText(this.crud)

    // if (this.$route.params.item)
    //   this.coditem = this.$route.params.item
  }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grade_estoque_vue__ = __webpack_require__(493);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e1152f2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grade_estoque_vue__ = __webpack_require__(1379);
function injectStyle (ssrContext) {
  __webpack_require__(1377)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grade_estoque_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e1152f2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grade_estoque_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//


/*
params: {
  coditem: '',
  view: false,
  qt: 0,                     //QUANTIDADE TOTAL DIGITADA NA GRADE
  listItemGrade: []          //OBJETO PARA TRANSFERENCIA DOS ITENS DIGITADOS
}
*/



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params: {}
  },

  data: function data() {
    return {
      listItemGrade: [], //LISTA COM CODIGOS DE ITEM/GRADE E QUANTIDADES PREENCHIDAS

      grade: {},
      colunasHead: [] //PARA MONTAGEM DO CABECALHO DA TABELA DE GRADE

    };
  },


  computed: {
    item: function item() {
      return this.$store.getters.getItem[0];
    }
  },

  watch: {
    grade: {
      handler: function handler() {
        //CALCULA A QUANTIDADE TOTAL DA GRADE QUANDO HOUVER ALTERACOES

        this.listItemGrade = [];

        for (var row = 0; row < this.grade.linhas.length; row++) {
          if (this.grade.linhas[row].coditemgrade) {
            this.listItemGrade.push({ qt: this.grade.linhas[row].quantidade, coditemgrade: this.grade.linhas[row].coditemgrade });
          } else if (this.grade.linhas[row].colunas) {
            //EXISTE COLUNAS
            for (var col = 0; col < this.grade.linhas[row].colunas.length; col++) {
              this.listItemGrade.push({ qt: this.grade.linhas[row].colunas[col].quantidade, coditemgrade: this.grade.linhas[row].colunas[col].coditemgrade });
            }
          }
        }
      },

      deep: true
    }
  },

  methods: {
    clickConfirma: function clickConfirma() {},
    getDetails: function getDetails(coditem) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = 'item/sales/pesquisa/produtos/' + coditem + '/grade';
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDS"])(_this.$store.getters.urlOrds + url);

              case 3:
                data = _context.sent;

                if (!data.items) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return', data.items);

              case 6:
                return _context.abrupt('return', []);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    preparaGrade: function preparaGrade() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var temp, row, col;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.getDetails(_this2.params.coditem);

              case 2:
                _this2.listItemGrade = _context2.sent;
                _context2.next = 5;
                return _this2.$store.dispatch('loadItem', { id: _this2.params.coditem });

              case 5:
                if (_this2.item) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return');

              case 7:

                _this2.grade = JSON.parse(_this2.item.grade);
                _this2.colunasHead = [];

                temp = null;


                for (row = 0; row < _this2.grade.linhas.length; row++) {
                  if (_this2.grade.linhas[row].coditemgrade) {
                    temp = _this2.getItemGrade(_this2.grade.linhas[row].coditemgrade);

                    if (temp.length > 0) {
                      _this2.grade.linhas[row].quantidade = temp[0].saldo_estoque;
                    }
                    if (row == 0) {
                      _this2.colunasHead.push({ descricao: "Qtd." });
                    }
                  } else if (_this2.grade.linhas[row].colunas) {
                    //EXISTE COLUNAS
                    for (col = 0; col < _this2.grade.linhas[row].colunas.length; col++) {
                      if (_this2.grade.linhas[row].colunas[col].coditemgrade) {
                        temp = _this2.getItemGrade(_this2.grade.linhas[row].colunas[col].coditemgrade);
                        if (temp.length > 0) {
                          _this2.grade.linhas[row].colunas[col].quantidade = temp[0].saldo_estoque;
                        }
                      }
                      if (row == 0) {
                        _this2.colunasHead.push({ descricao: _this2.grade.linhas[row].colunas[col].descricao });
                      }
                    }
                  }
                }

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getItemGrade: function getItemGrade(coditemgrade) {
      return this.listItemGrade.filter(function (obj) {
        return obj.coditemgrade == coditemgrade;
      });
    },
    focus: function focus() {
      this.$nextTick(function () {
        if (this.$refs.quantidade) this.$refs.quantidade[0].focus();
      });
    }
  },

  created: function created() {
    this.preparaGrade();
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_items_estoque_vue__ = __webpack_require__(495);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2920ee70_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_items_estoque_vue__ = __webpack_require__(1386);
function injectStyle (ssrContext) {
  __webpack_require__(1381)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2920ee70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_items_estoque_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2920ee70_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_items_estoque_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_anexos_form__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            coditem: '',
            descricao: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            showAnexosForm: false,
            offset: false,
            tabelas: [{
                codtabpre: '1',
                descricao: 'Padrão'
            }]
        };
    },


    computed: {
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        },

        produtos: function produtos() {
            return this.$store.getters.getItemSalesList;
        },

        tabelasUsuario: function tabelasUsuario() {
            //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
            var tabelas = this.$store.getters.getTabpreList.filter(function (obj) {
                return obj.sttabpre == 'A';
            });
            return tabelas;

            // let options = []

            // let liberado = []
            // let currTabpre = {}

            // for (var x = 0; x < this.$store.getters.getTabpreList.length; x++) {
            //     currTabpre = this.$store.getters.getTabpreList[x]

            //     //se existir parametros do usuario, libera somente as tabelas permitidas
            //    if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) {
            //         liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter((obj) => { return obj == currTabpre.codtabpre})
            //         if (liberado.length > 0) {
            //             options.push({ id: currTabpre.codtabpre, text: currTabpre.descricao })
            //         }
            //     } else {
            //         options.push({ id: currTabpre.codtabpre, text: currTabpre.descricao })
            //     }
            // }
            // return options
        }

    },

    methods: {
        handleAnexosForm: function handleAnexosForm(coditem, descricao) {
            this.coditem = coditem;
            this.descricao = descricao;
            this.showAnexosForm = true;
        },
        handleMore: function handleMore() {
            this.offset = true;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showAnexosForm = false;
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codigo":{"$eq":"' + value + '"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        textST: function textST(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(value, this.metadata.item.stitem);
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadTabpre', {});

                            case 2:
                                params = { filter: _this.filter };

                                if (_this.offset) {
                                    params.offset = _this.nextPage;
                                }
                                _this.$store.dispatch('loadPesquisaProdutosSales', params);
                                _this.offset = false;

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], AnexosForm: __WEBPACK_IMPORTED_MODULE_1__components_anexos_form__["a" /* default */]
    },

    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params: Object
  },

  data: function data() {
    return {
      mainImage: null, //imagem principal sendo exibida
      listImages: [],
      selectedIndex: 0,
      chaveref: '',
      ref: ''
    };
  },


  computed: {
    title: function title() {
      //if (this.params.ref == 'item') { 
      if (this.fotosProduto && this.params.title) {
        return 'Imagens de ' + this.params.title;
      } else {
        return 'Anexos';
      }
    },

    fotosProduto: function fotosProduto() {
      return this.params.ref == 'item' || this.params.imagem;
    },

    fileTypes: function fileTypes() {
      if (this.fotosProduto) return 'image/*';else return '';
    }
  },

  methods: {
    closeForm: function closeForm(action) {
      this.$emit('closeform');
    },
    handleClickGaleria: function handleClickGaleria(index) {
      this.mainImage = this.listImages[index].url;
      this.selectedIndex = index;
    },
    handleDelete: function handleDelete(index) {
      this.apiDeleteAnexo(this.listImages[index].coddoc);

      this.listImages.splice(index, 1);

      if (index > 0) {
        this.mainImage = this.listImages[index - 1].url;
        this.selectedIndex = index - 1;
      } else {
        this.mainImage = null;
      }
    },
    handleClickAdiciona: function handleClickAdiciona() {
      document.getElementById('fileInput').click();
    },
    handleChange: function handleChange() {
      this.$emit('change', this.listImages);
    },
    handleUpload: function handleUpload(event) {
      if (this.fotosProduto && event.target.files[0]['type'] !== 'image/jpeg' && event.target.files[0]['type'] !== 'image/png') {
        this.$erpToastError('Arquivo não permitido');
        return;
      }

      this.selectedFile = event.target.files[0]; //this.$refs.file.files[0]
      // this.mainImage = URL.createObjectURL(this.selectedFile)
      var image = { image: this.mainImage, url: '', uploading: true };
      this.listImages.push(image);
      this.selectedIndex = this.listImages.length - 1;
      this.apiUploadAnexo();
    },
    loadData: function loadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var x;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch('loadDocs', { id: _this.ref + '/' + _this.chaveref });

              case 2:
                _this.listImages = [].concat(_toConsumableArray(_this.$store.getters.getDocsList));

                //EFETUA O DOWNLOAD DE CADA IMAGEM NA BARRA DE MINIATURAS
                if (_this.params.showform) {
                  for (x = 0; x < _this.listImages.length; x++) {
                    _this.$set(_this.listImages[x], 'image', null);
                    // this.loadMiniatura(x)
                    if (x == 0) _this.mainImage = _this.listImages[x].url;
                  }
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadMiniatura: function loadMiniatura(index) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var self, test;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this2;
                test = index;
                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSmidia"])(_this2.listImages[index].url).then(function (data) {
                  if (data && data.size > 0) {
                    var reader = new window.FileReader();
                    reader.readAsDataURL(data);
                    reader.onload = function () {
                      self.listImages[test].image = reader.result;
                      if (test == 0) {
                        self.mainImage = reader.result;
                      }
                    };
                  }
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    apiUploadAnexo: function apiUploadAnexo() {
      var formData = new FormData();
      formData.append('file', this.selectedFile);

      var url = this.$store.getters.urlOrds + 'docs/';

      var self = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'ref': this.ref,
          'chaveref': this.chaveref,
          'filename': this.selectedFile.name
        }
      }).then(function (response) {
        if (response.data.items) {
          var x = self.listImages.length - 1;
          self.$set(self.listImages[x], 'coddoc', response.data.items[0].coddoc);
          self.$set(self.listImages[x], 'url', response.data.items[0].url);
          self.$set(self.listImages[x], 'filename', response.data.items[0].filename);
          self.$set(self.listImages[x], 'usuario_nome', response.data.items[0].usuario_nome);
          self.$set(self.listImages[x], 'data', response.data.items[0].data);
          self.$set(self.listImages[x], 'uploading', false);
          self.handleChange();
        }
        self.$erpToastSuccess('anexo atualizado');
      });
    },
    apiDeleteAnexo: function apiDeleteAnexo(coddoc) {
      var url = this.$store.getters.urlOrds + 'docs/' + coddoc;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(url).then(function (data) {
        self.$erpToastSuccess('O anexo foi removido');
        self.handleChange();
      });
    }
  },

  created: function created() {
    this.chaveref = this.params.chaveref;
    this.ref = this.params.ref;
    this.loadData();
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */], Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */], Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
  },

  data: function data() {
    return {
      showfiltro: false,

      resumoVendas: [],
      detalheVendas: [],

      tipoResumo: '1',

      opcoesResumo: {
        1: 'resumoservico',
        2: 'resumoservicocliente',
        3: 'resumoservicogrupocliente',
        4: 'resumoservicoestado'
      },

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {
        periodo: {
          label: 'Data do Serviço',
          varios: false,
          data_inicio: null,
          data_termino: null
        },

        filtros: [{ nome: 'filial', label: null, url: null, varios: false, values: [] }, { nome: 'segmento', label: null, url: null, varios: true, values: [] }, { nome: 'grupocliente', label: null, url: null, varios: true, values: [] }, { nome: 'estado', label: null, url: null, varios: true, values: [] }, { nome: 'grupoestoque', label: null, url: null, varios: true, values: [] }]

      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }]
      },

      filter: { //objeto utilizado pelo filtro de mes
        startDate: null,
        endDate: null
      }

    };
  },


  watch: {
    tipoResumo: function tipoResumo() {
      this.loadResumo();
      this.loadDetalhes();
    }
  },

  methods: {
    handleCloseFiltro: function handleCloseFiltro() {
      this.showfiltro = false;
    },
    clickRetornar: function clickRetornar() {
      this.$router.push('/');
    },
    handleShowFiltro: function handleShowFiltro() {
      //if (this.paramsFiltro)
      this.showfiltro = true;
    },
    filtroChange: function filtroChange(filtro) {

      this.showfiltro = false;

      this.filtro = filtro;

      this.paramsFiltro.filtros[0].values = this.filtro.filial;
      this.paramsFiltro.filtros[1].values = this.filtro.segmento;
      this.paramsFiltro.filtros[2].values = this.filtro.grupocliente;
      this.paramsFiltro.filtros[3].values = this.filtro.estado;
      this.paramsFiltro.filtros[4].values = this.filtro.grupoestoque;

      //this.filtro['opcoes_resumo'].selected

      this.loadResumo();
      this.loadDetalhes();
    },
    loadResumo: function loadResumo(excel) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = 'consulta/nfse/' + _this.opcoesResumo[_this.tipoResumo];


                _this.filtro.excel = excel;

                if (!excel) {
                  _context.next = 6;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this, url, _this.filtro, 'post');
                _context.next = 10;
                break;

              case 6:
                _context.next = 8;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, url, _this.filtro, 'post');

              case 8:
                data = _context.sent;

                if (data) {
                  _this.resumoVendas = data;
                } else {
                  _this.resumoVendas = [];
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadDetalhes: function loadDetalhes(excel) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.filtro.excel = excel;

                if (!excel) {
                  _context2.next = 5;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(_this2, url, _this2.filtro, 'post');
                _context2.next = 9;
                break;

              case 5:
                _context2.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this2.$store, 'consulta/nfse/servico', _this2.filtro, 'post');

              case 7:
                data = _context2.sent;

                if (data) {
                  _this2.detalheVendas = data;
                } else {
                  _this2.detalheVendas = [];
                }

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },

  computed: {

    // sessao: function () {
    //     return this.$store.getters.getSessao
    // },

    // usuarioList: function () {
    //     //lista de usuarios para selecao
    //     let options = []
    //     for (var x = 0; x < this.$store.getters.getUsuarioList.length; x++) {
    //         options.push({ id: this.$store.getters.getUsuarioList[x].codusuario, text: this.$store.getters.getUsuarioList[x].nome })
    //     }
    //     return options
    // },

    paramsChart: function paramsChart() {
      if (this.tipoResumo == '1') return { chart: { type: 'AreaChart' }, values: this.chartValues };else return { chart: { type: 'ColumnChart' }, values: this.chartValues };
    },

    chartValues: function chartValues() {
      // return [ ['Mês', 'Orçamentos'],
      //         ['Orçamentos', 1000],
      //         ['Confirmados', 1170],
      //         ['Recusados', 660],
      // ]

      if (!this.resumoVendas.vendas || this.resumoVendas.vendas.length == 0) return [];

      var values = [['', 'Valor Serviço']];

      if (this.tipoResumo == '1') {
        var meses = this.resumoVendas.vendas[0].valores;
        for (var x = 0; x < this.resumoVendas.meses.length; x++) {
          values.push([this.resumoVendas.meses[x], meses[x]]);
        }
      } else {
        for (var x = 0; x < this.resumoVendas.vendas.length; x++) {
          values.push([this.resumoVendas.vendas[x].label, this.resumoVendas.vendas[x].total]);
        }
      }

      return values;
    }

  },

  mounted: function mounted() {},
  created: function created() {
    this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate()); //'2020-02-01'
    this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate()); //'2020-08-17'

    if (this.$route.query.data_inicio) {
      this.filtro.periodos[0].data_inicio = this.$firstDay(this.$route.query.data_inicio);
      this.filtro.periodos[0].data_termino = this.$lastDay(this.$route.query.data_termino);
    }

    this.paramsFiltro.periodo.data_inicio = this.filtro.periodos[0].data_inicio;
    this.paramsFiltro.periodo.data_termino = this.filtro.periodos[0].data_termino;

    this.loadResumo();
    this.loadDetalhes();
  }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_csvReport__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_csvReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_utils__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ConsultaDistribuicaoCfop',
    components: {
        DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */],
        Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */],
        Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
    },

    data: function data() {
        return {
            showfiltro: false,

            dados: {
                grafico: [],
                items: [],
                detalhes: []
            },

            paramsFiltro: {
                periodo: {
                    label: 'Período de Emissão',
                    varios: false,
                    data_inicio: null,
                    data_termino: null
                },
                filtros: [{ nome: 'cliente', label: 'Cliente / Destinatário', url: null, varios: true, values: [] }, { nome: 'filial', label: 'Filial', url: null, varios: false, values: [] }]
            },

            filtro: {
                operacao: 'S',
                periodos: [{ data_inicio: null, data_termino: null }]
            }
        };
    },


    watch: {
        'filtro.operacao': function filtroOperacao() {
            this.loadData();
        }
    },

    computed: {
        paramsChart: function paramsChart() {
            return {
                chart: { type: 'PieChart' },
                values: this.chartValues
            };
        },
        chartValues: function chartValues() {
            if (!this.dados || !this.dados.grafico || this.dados.grafico.length <= 1) {
                return [];
            }
            return this.dados.grafico;
        }
    },

    methods: {
        handleCloseFiltro: function handleCloseFiltro() {
            this.showfiltro = false;
        },
        clickRetornar: function clickRetornar() {
            this.$router.push('/');
        },
        handleShowFiltro: function handleShowFiltro() {
            this.showfiltro = true;
        },
        filtroChange: function filtroChange(filtro) {
            this.showfiltro = false;
            this.filtro = _extends({}, this.filtro, filtro, {
                periodos: filtro.periodos || this.filtro.periodos
            });

            if (this.filtro.periodos && this.filtro.periodos[0]) {
                this.paramsFiltro.periodo.data_inicio = this.filtro.periodos[0].data_inicio;
                this.paramsFiltro.periodo.data_termino = this.filtro.periodos[0].data_termino;
            }

            this.loadData();
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var payload, res;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                payload = {
                                    periodos: _this.filtro.periodos,
                                    operacao: _this.filtro.operacao,
                                    data_inicio: _this.filtro.periodos && _this.filtro.periodos[0] ? _this.filtro.periodos[0].data_inicio : null,
                                    data_termino: _this.filtro.periodos && _this.filtro.periodos[0] ? _this.filtro.periodos[0].data_termino : null,
                                    cliente: _this.filtro.cliente,
                                    filial: _this.filtro.filial
                                };
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, 'consulta/vendas/distribuicaocfop', payload, 'post');

                            case 3:
                                res = _context.sent;

                                if (res) {
                                    _this.dados = {
                                        grafico: res.grafico || [],
                                        items: res.items || [],
                                        detalhes: res.detalhes || []
                                    };
                                } else {
                                    _this.dados = {
                                        grafico: [],
                                        items: [],
                                        detalhes: []
                                    };
                                }

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        exportarExcel: function exportarExcel() {
            if (!this.dados || !this.dados.items || this.dados.items.length === 0) return;

            var exportList = this.dados.items.map(function (item) {
                return {
                    CFOP: item.cfop,
                    Descricao: item.descricao,
                    Qtd_Notas: item.qtd_notas,
                    Qtd_Itens: item.qtd_itens,
                    Total_Mercadorias: Object(__WEBPACK_IMPORTED_MODULE_5__shared_utils__["formatValue"])(item.total_produtos, 2),
                    Total_Faturado: Object(__WEBPACK_IMPORTED_MODULE_5__shared_utils__["formatValue"])(item.total_geral, 2),
                    Participacao_Perc: Object(__WEBPACK_IMPORTED_MODULE_5__shared_utils__["formatValue"])(item.participacao, 2) + '%'
                };
            });

            var csv = Object(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__["objectToCsv"])(exportList);
            Object(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__["downloadCsvReport"])(csv);
        },
        exportarExcelDetalhes: function exportarExcelDetalhes() {
            if (!this.dados || !this.dados.detalhes || this.dados.detalhes.length === 0) return;

            var exportList = this.dados.detalhes.map(function (item) {
                return {
                    NF: item.nf,
                    Serie: item.serie,
                    Data: item.data,
                    Destinatario: item.destinatario,
                    Cidade: item.cidade,
                    UF: item.uf,
                    CFOP: item.cfop,
                    Item: item.item_desc,
                    Qtd: item.qtuni,
                    Total_Item: Object(__WEBPACK_IMPORTED_MODULE_5__shared_utils__["formatValue"])(item.total_item, 2),
                    Total_NF: Object(__WEBPACK_IMPORTED_MODULE_5__shared_utils__["formatValue"])(item.total_nf, 2)
                };
            });

            var csv = Object(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__["objectToCsv"])(exportList);
            Object(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__["downloadCsvReport"])(csv);
        }
    },

    created: function created() {
        this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate());
        this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate());

        if (this.$route.query.data_inicio) {
            this.filtro.periodos[0].data_inicio = this.$firstDay(this.$route.query.data_inicio);
            this.filtro.periodos[0].data_termino = this.$lastDay(this.$route.query.data_termino);
        } else if (this.$route.query.startDate) {
            this.filtro.periodos[0].data_inicio = this.$route.query.startDate;
            this.filtro.periodos[0].data_termino = this.$route.query.endDate;
        }

        this.paramsFiltro.periodo.data_inicio = this.filtro.periodos[0].data_inicio;
        this.paramsFiltro.periodo.data_termino = this.filtro.periodos[0].data_termino;

        this.loadData();
    }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_csvReport__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_csvReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        filial: {}
    },

    data: function data() {
        return {
            estagio: 'inicio',
            errmessage: '',
            selectedFile: {},
            urlFile: '',
            url: Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["urlORDS"])(this.$store, 'cg/importa/clientes'),
            prepara: false,

            dadosResumo: {},
            csv: null
        };
    },


    computed: {
        status: function status() {
            return '';
        }
    },

    methods: {
        handleVoltar: function handleVoltar() {
            this.$router.go(-1);
            //if (this.estagio == 'showresumo'){
            //    this.handleSelecionarOutro();
            //}else{
            //    this.$router.push('/partlist')
            //}
        },
        handleDownloadModelo: function handleDownloadModelo() {
            window.open('https://novo.notabrasil.com.br/planilha_modelo_cliente.csv', "_blank");
        },
        handleFileChange: function handleFileChange() {
            this.selectedFile = this.$refs.file.files[0];
        },
        handleAnalisarArquivo: function handleAnalisarArquivo() {
            //ENVIA O ARQUIVO PARA ANALISE DA IMPORTACAO
            if (!this.selectedFile) return;

            var self = this;
            var extPermitidas = ['csv'];

            if (typeof extPermitidas.find(function (ext) {
                return self.selectedFile.name.split('.').pop() == ext;
            }) == 'undefined') {
                self.$erpToastError('Extensão do arquivo inválida! Somente arquivos ".csv" são permitidos.');
                return;
            }

            this.prepara = true;

            var reader = new FileReader();
            reader.readAsText(this.selectedFile, 'ISO-8859-1');
            reader.onload = function (event) {
                self.csv = event.target.result;
                self.apiUpload();
                // console.log(csv)
            };
            reader.onerror = function (event) {
                if (event.target.error.name == 'NotReadableError') {
                    self.$erpToastError('Não foi possível ler o arquivo!');
                }
            };
            return;
        },
        handleSelecionarOutro: function handleSelecionarOutro() {
            this.estagio = 'inicio';
            this.selectedFile = {};
        },
        handleConfirmarImportacao: function handleConfirmarImportacao() {
            //ENVIA NOVAMENTE O MESMO ARQUIVO PARA IMPORTACAO
            this.prepara = false;
            this.apiUpload();
        },
        apiUpload: function apiUpload() {
            //EFETUA O UPLOAD DO ARQUIVO

            var formData = new FormData();
            formData.append('file.csv', new Blob([this.csv]), { type: 'text/csv' });

            var self = this;

            this.message = null;

            this.$appLoading(true);

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'prepara': self.prepara
                }
            }).then(function (data) {
                if (data.data) {
                    self.dadosResumo = data.data;
                    if (self.prepara) {
                        self.estagio = 'showresumo';
                    } else {
                        self.$erpToastSuccess('Arquivo importado com sucesso');
                        self.handleVoltar();
                    }
                }
                self.$appLoading(false);
            }).catch(function (data) {
                self.$appLoading(false);
                self.errmessage = data.message;
                self.$erpToastError('Erro ao carregar o arquivo');
            });
        },
        handleSelecionarArquivo: function handleSelecionarArquivo() {
            //BOTAO SELECIONAR ARQUIVO
            this.$refs.file.click();
        },
        handleExportaResumo: function handleExportaResumo(tipo) {
            var data = this.dadosResumo.itens.filter(function (it) {
                return it.status == tipo;
            }).map(function (it) {

                var obj = {
                    nome: it.nome,
                    uf: it.uf
                };

                if (it.cnpj) obj.cnpj = it.cnpj;else if (it.cpf) obj.cpf = it.cpf;

                if (it.message) obj.mensagem = it.message;

                return obj;
            });
            if (!data || data.length == 0) this.$erpToastError('Nenhum cliente para visualizar');else {
                var csv = Object(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__["objectToCsv"])(data);
                Object(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__["downloadCsvReport"])(csv);
            }
        }
    },

    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
        this.selectedFile = {};
    }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customer_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__grucli_list_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__grufor_list__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_csvReport__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_csvReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shared_csvReport__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codpart: '',
            metadata: this.$store.getters.getEntities.metadata,
            activeTab: 0,
            offset: false,
            moreActionsBarList: [{ action: 0, label: 'Importar Clientes' }]
        };
    },


    computed: {
        partList: function partList() {
            return this.$store.getters.getPartList;
        },

        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        },

        tabs: function tabs() {
            return [{ title: 'Clientes', icon: 'fa-users' }, { title: 'Grupo de Cliente', icon: 'fa-user' }, { title: 'Grupo de Fornecedor', icon: 'fa-cubes' }];
        },

        tabClientes: function tabClientes() {
            return this.activeTab == 0;
            // return this.activeTab == 0 && !this.usuarioComum
        },

        tabGrupoCli: function tabGrupoCli() {
            return this.activeTab == 1;
            // return this.activeTab == 0 && !this.usuarioComum
        },

        tabGrupoForn: function tabGrupoForn() {
            return this.activeTab == 2;
        }
    },

    methods: {
        textTipo: function textTipo(cli, forn, tra) {
            var text = '';
            if (cli == 'S') text = 'Cliente';
            if (forn == 'S') text = text + ' Fornecedor';
            if (tra == 'S') text = text + ' Transportadora';
            return text;
        },
        textContricms: function textContricms(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_5__shared_utils__["getText"])(value, this.metadata.part.contricms);
        },
        situacao: function situacao(part) {
            if (part.stpart == 'I') {
                return 'Inativo';
            }
            if (part.cliente == 'S') {
                if (part.stcred == 'B') {
                    return 'Crédito Bloqueado';
                }
                if (part.stcred == 'A') {
                    return 'Somente Venda a Vista';
                }
                return 'Crédito Liberado';
            }
            return '';
        },
        situacaoBadgeClass: function situacaoBadgeClass(part) {
            if (part.stpart == 'I' || part.cliente == 'S' && part.stcred == 'B') {
                return 'nb-card-badge--danger';
            }
            if (part.cliente == 'S' && part.stcred == 'A') {
                return 'nb-card-badge--warning';
            }
            return 'nb-card-badge--success';
        },
        handleAction: function handleAction(act) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var data, csv;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (act == 0) {
                                    //importação de cadastro de clientes
                                    _this.$router.push('/importa/clientes');
                                }

                                if (!(act == 'xls')) {
                                    _context.next = 9;
                                    break;
                                }

                            case 2:
                                if (!_this.nextPage) {
                                    _context.next = 7;
                                    break;
                                }

                                _context.next = 5;
                                return _this.handleMore(true);

                            case 5:
                                _context.next = 2;
                                break;

                            case 7:
                                data = _this.partList.map(function (it) {

                                    var obj = {
                                        codigo: it.codpart,
                                        nome: it.nome,
                                        fantasia: it.fantasia,
                                        cnpjcpf: Object(__WEBPACK_IMPORTED_MODULE_5__shared_utils__["formatCNPJCPF"])(it.cnpjcpf),
                                        email: it.email,
                                        inscricao_estadual: it.iest,
                                        tipo: _this.textTipo(it.cliente, it.forn, it.transp),
                                        st: it.stpart
                                    };

                                    return obj;
                                });

                                if (!data || data.length == 0) _this.$erpToastError('Nenhum participante para visualizar');else {
                                    csv = Object(__WEBPACK_IMPORTED_MODULE_7__shared_csvReport__["objectToCsv"])(data);

                                    Object(__WEBPACK_IMPORTED_MODULE_7__shared_csvReport__["downloadCsvReport"])(csv);
                                }

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        textoptsimples: function textoptsimples(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_5__shared_utils__["getText"])(value, this.metadata.part.optsimples);
        },
        editPart: function editPart(codpart) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_6__main__["SysVars"].crudU; //update
            this.codpart = codpart;
            this.showForm = true;
        },
        incluirPart: function incluirPart(codpart) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_6__main__["SysVars"].crudI;
            this.codpart = codpart;
            this.showForm = true;
        },
        onAction: function onAction(action) {},
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"nome":{"$like":"%25' + value.toUpperCase() + '%25"}},{"fantasia":{"$like":"%25' + value.toUpperCase() + '%25"}},{"codpart":{"$eq":"' + value + '"}},{"cnpjcpf":{"$eq":"' + value + '"}}]}';
            // this.filter = '{"nome":{"$like":"' + value + '%25"}}'
            this.loadData();
        },
        loadData: function loadData(wait) {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                params = { filter: _this2.filter };


                                if (_this2.offset) {
                                    params.offset = _this2.nextPage;
                                }

                                if (!wait) {
                                    _context2.next = 7;
                                    break;
                                }

                                _context2.next = 5;
                                return _this2.$store.dispatch('loadPart', params);

                            case 5:
                                _context2.next = 8;
                                break;

                            case 7:
                                _this2.$store.dispatch('loadPart', params);

                            case 8:

                                _this2.offset = false;

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        handleMore: function handleMore(wait) {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this3.offset = true;
                                _context3.next = 3;
                                return _this3.loadData(wait);

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        scroll: function scroll() {
            var _this4 = this;

            window.onscroll = function () {
                if (_this4.showForm || _this4.offset || _this4.nextPage == 0) return;
                var bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= document.documentElement.offsetHeight - 2;

                if (bottomOfWindow) {
                    _this4.offset = true;
                    _this4.loadData();
                }
                __WEBPACK_IMPORTED_MODULE_6__main__["SysVars"].scrollPosition = document.documentElement.scrollTop;
            };
        },
        changeTab: function changeTab(idx) {
            this.activeTab = idx;
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], CustomerForm: __WEBPACK_IMPORTED_MODULE_2__customer_form__["default"], GrucliList: __WEBPACK_IMPORTED_MODULE_3__grucli_list_vue__["default"], GruforList: __WEBPACK_IMPORTED_MODULE_4__grufor_list__["default"]
    },

    mounted: function mounted() {
        this.scroll();
    },
    created: function created() {
        this.showForm = false;
        this.loadData();
    },
    destroyed: function destroyed() {
        window.onscroll = null;
    }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__grucli_form__ = __webpack_require__(427);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            grucli: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            currentGru: {},
            codgrucli: null
        };
    },


    computed: {
        grucliList: function grucliList() {
            return this.$store.getters.getGrucliList;
        }
    },

    filters: {
        format: function format(value) {
            return formatValue(value, 2);
        }

    },

    methods: {
        handleEdit: function handleEdit(grucli) {
            //abre a tela de edicao
            this.currentGru = grucli;
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudU;
            this.$set(grucli, 'show', true);
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudI;
            this.showForm = true;
        },
        closeForm: function closeForm() {
            this.currentGru.show = false;
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codgrucli":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadGrucli', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        },
        handleDelete: function handleDelete(grucli) {
            //BOTAO Excluir
            this.apiDelete(grucli);
        },
        apiDelete: function apiDelete(grucli) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/grucli/' + grucli.codgrucli;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this.$store, modulo);

                            case 3:
                                data = _context.sent;

                                _this.$erpToastDeleted();
                                _this.closeForm();

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], GrucliForm: __WEBPACK_IMPORTED_MODULE_3__grucli_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grufor_list_vue__ = __webpack_require__(503);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_8860b0fa_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grufor_list_vue__ = __webpack_require__(1407);
function injectStyle (ssrContext) {
  __webpack_require__(1405)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8860b0fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grufor_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_8860b0fa_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grufor_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grufor_form__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            grufor: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: ''
        };
    },


    computed: {
        gruforList: function gruforList() {
            return this.$store.getters.getGruforList;
        },
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(value, 2);
        }

    },

    methods: {
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao            
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.codgrufor = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codgrufor = '';
            this.showForm = true;
        },
        handleMore: function handleMore() {
            this.offset = 'offset=' + this.nextPage;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codGrufor":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadGrufor', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], GruforForm: __WEBPACK_IMPORTED_MODULE_1__grufor_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_item_list_vue__ = __webpack_require__(505);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_59a8e102_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_item_list_vue__ = __webpack_require__(1432);
function injectStyle (ssrContext) {
  __webpack_require__(1409)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59a8e102"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_item_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_59a8e102_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_item_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__item_form__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_anexos_form__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _computed;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showForm: false, //exibe a tela de manutencao
      showFormControlePedidos: false, //form de cadastro para controle de pedidos
      crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
      coditem: '',
      descricao: '',
      searchString: '',
      metadata: this.$store.getters.getEntities.metadata,
      filter: '',
      showAnexosForm: false,
      offset: false,
      gerarEtiqueta: false,
      modalEtiqueta: false,
      marcarTodosProdutos: false,
      produtosMarcados: [],
      filial: null,
      parametros: null,
      listaEtiquetas: [],
      etiquetaSelecionada: 1,
      grade: null,
      hasItemChecked: false
    };
  },


  computed: (_computed = {
    possuiPermissao: function possuiPermissao() {
      return __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].appNFe || __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].usuarioAdministrador && __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].appForcaVendas;
    },

    moreActionsBarList: function moreActionsBarList() {
      if (!this.possuiPermissao) return null;else return [{ action: 0, label: 'Importar Produtos' }, { action: 1, label: 'Importar Estoque' }, { action: 2, label: 'Gerar Etiqueta' }];
    },

    nextPage: function nextPage() {
      return this.$store.getters.getNextPage;
    },

    itemList: function itemList() {
      return this.$store.getters.getItemList;
    },

    produtosSelecionados: function produtosSelecionados() {
      return (this.itemList || []).filter(function (item) {
        return item.isChecked;
      }).length;
    }
  }, _defineProperty(_computed, 'possuiPermissao', function possuiPermissao() {
    if (__WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].usaIntegracao) {
      return false;
    }
    return __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].appNFe || __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].appERP || __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].appLoja || __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].usuarioAdministrador && __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].appForcaVendas;
  }), _defineProperty(_computed, 'filialList', function filialList() {
    return this.$store.getters.getFilialList;
  }), _defineProperty(_computed, 'item', function item() {
    return this.$store.getters.getItem[0];
  }), _defineProperty(_computed, 'showGuia', function showGuia() {
    return __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].guia;
  }), _computed),

  watch: {
    itemList: {
      handler: function handler(newValue) {
        var hasItemChecked = newValue.find(function (item) {
          return item.isChecked;
        });
        if (hasItemChecked) {
          this.hasItemChecked = true;
        } else {
          this.hasItemChecked = false;
        }
      },
      deep: true,
      immediatle: true
    },
    marcarTodosProdutos: function marcarTodosProdutos() {
      if (this.marcarTodosProdutos) {
        this.hasItemChecked = true;
        this.itemList.map(function (item) {
          item.isChecked = true;
        });
      } else {
        this.hasItemChecked = false;
        this.itemList.map(function (item) {
          item.isChecked = false;
        });
      }
    }
  },

  methods: {
    scroll: function scroll() {
      var _this = this;

      window.onscroll = function () {
        if (_this.showForm || _this.showFormControlePedidos || _this.offset || _this.nextPage == 0) return;
        var bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= document.documentElement.offsetHeight - 2;

        if (bottomOfWindow) {
          _this.offset = true;
          _this.loadData();
        }
        __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].scrollPosition = document.documentElement.scrollTop;
      };
    },
    handleEdit: function handleEdit(cod, view) {
      //abre a tela de edicao

      if (view) this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudView;else this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudU;

      this.coditem = cod;
      if (__WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].controlePedidos) this.showFormControlePedidos = true;else this.showForm = true;
    },
    handleNew: function handleNew() {
      //inclusao de registro
      if (!this.possuiPermissao) {
        this.$erpToastError('Usuário sem permissão.');
        return;
      }
      this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudI;
      this.coditem = '';
      if (__WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].controlePedidos) this.showFormControlePedidos = true;else this.showForm = true;
    },
    handleAnexosForm: function handleAnexosForm(coditem, descricao) {
      this.coditem = coditem;
      this.descricao = descricao;
      this.showAnexosForm = true;
    },
    handleArchive: function handleArchive(coditem) {
      var state = {
        filter: this.filter,
        searchString: this.searchString
      };
      sessionStorage.setItem('fvProdutosState', JSON.stringify(state));
      this.$router.push({ path: '/consultas/estoque-produto', query: { coditem: coditem } });
    },
    closeForm: function closeForm() {
      this.showForm = false;
      this.showAnexosForm = false;
      this.showFormControlePedidos = false;
      this.loadData();
    },
    handleAction: function handleAction(act) {
      if (act == 0) {
        if (!this.possuiPermissao) this.$erpToastError('Usuário sem permissão.');else
          //importação de cadastro de produtos
          this.$router.push('/importa/produtos');
      }

      if (act == 1) {
        //importação de cadastro de produtos
        this.$router.push('/importa/estoque');
      }

      if (act == 2) {
        this.gerarEtiqueta = true;
      }
    },
    showModalImprimirEtiqueta: function showModalImprimirEtiqueta() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var codfil, produtosMarcados, printProdutos, etiquetas;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(_this2.hasItemChecked, _this2.itemList);

                if (_this2.hasItemChecked) {
                  _context2.next = 4;
                  break;
                }

                _this2.$erpToastError('É necessário selecionar um produto');
                return _context2.abrupt('return');

              case 4:
                codfil = _this2.filialList[0].codfil;
                _context2.next = 7;
                return _this2.$store.dispatch('loadFilial', { id: codfil });

              case 7:

                if (_this2.$store.getters.getFilial) {
                  _this2.filial = _extends({}, _this2.$store.getters.getFilial);
                  if (_this2.filial.parametros) {
                    _this2.parametros = JSON.parse(_this2.filial.parametros);
                  } else {
                    _this2.parametros = {};
                  }
                }

                produtosMarcados = _this2.itemList.filter(function (item) {
                  return item.isChecked == true;
                });
                printProdutos = [];


                produtosMarcados.map(function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(produto) {
                    var gradeItem;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            printProdutos.push({ codigo: produto.codigo, coditem: produto.coditem, descricao: produto.descricao });

                            _context.next = 3;
                            return _this2.$store.dispatch('loadItem', { id: produto.coditem });

                          case 3:
                            if (_this2.item) {
                              gradeItem = JSON.parse(_this2.item.grade);

                              if (gradeItem.linhas.length > 0) {
                                gradeItem.linhas.map(function (linha) {
                                  linha.colunas.map(function (coluna) {
                                    if (coluna.ativo) printProdutos.push({
                                      codigo: produto.codigo,
                                      coditem: produto.coditem,
                                      descricao: produto.descricao + ' ' + linha.descricao + ' ' + coluna.descricao,
                                      coditemgrade: coluna.coditemgrade
                                    });
                                  });
                                });
                              }
                            }

                          case 4:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

                _this2.produtosMarcados = printProdutos;

                etiquetas = _this2.parametros.etiquetas;


                _this2.listaEtiquetas = [];

                etiquetas.map(function (etiqueta, i) {
                  _this2.listaEtiquetas.push({
                    id: i += 1,
                    text: etiqueta.descricao
                  });
                });

                _this2.modalEtiqueta = true;

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    closeModalImprimirEtiqueta: function closeModalImprimirEtiqueta() {
      this.modalEtiqueta = false;
    },
    deleteItemImprimirEtiqueta: function deleteItemImprimirEtiqueta(produto) {
      var indiceProduto = this.produtosMarcados.indexOf(produto);
      this.produtosMarcados.splice(indiceProduto, 1);
    },
    search: function search(value) {
      this.searchString = value;
      //efetua a pesquisa
      this.filter = '{"$or":[{"codigo":{"$eq":"' + value + '"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
      this.loadData();
    },
    textST: function textST(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["getText"])(value, this.metadata.item.stitem);
    },
    loadData: function loadData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = { filter: _this3.filter };


                if (_this3.offset) {
                  params.offset = _this3.nextPage;
                }

                _this3.$store.dispatch('loadItemList', params);
                _this3.offset = false;

                _this3.$store.dispatch('loadFilial', {});

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleMore: function handleMore() {
      this.offset = true;
      this.loadData();
    },
    handleImprimirEtiqueta: function handleImprimirEtiqueta() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var sendData, metodo, modulo;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                sendData = {};

                sendData.item = _this4.produtosMarcados;
                sendData.layout = parseInt(_this4.etiquetaSelecionada);

                metodo = 'post';
                modulo = 'cg/item/etiqueta/';
                //
                // const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
                // if (!data.dados) {
                //   return
                // }
                //

                // modulo = 'pdf'

                Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["apiDownloadPDF"])(_this4, modulo, sendData, metodo, true);

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  },

  components: {
    BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], ItemForm: __WEBPACK_IMPORTED_MODULE_1__item_form__["default"], AnexosForm: __WEBPACK_IMPORTED_MODULE_2__components_anexos_form__["a" /* default */]
  },

  mounted: function mounted() {
    this.scroll();
  },
  created: function created() {
    var savedState = sessionStorage.getItem('fvProdutosState');
    if (savedState) {
      var state = JSON.parse(savedState);
      this.filter = state.filter;
      this.searchString = state.searchString;
      sessionStorage.removeItem('fvProdutosState');
    }
    this.loadData();
  },
  destroyed: function destroyed() {
    window.onscroll = null;
  }
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gruest_form__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__depo_form__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__unimed_form__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_grade__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_anexos_selecionar_form__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_barcode_validator__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_barcode_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_barcode_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tourguidejs__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tourguidejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_tourguidejs__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: '',
    crud: '',
    importXml: {},
    descricao: ''
  },

  data: function data() {
    return {
      lCrud: '',
      crudText: '',
      item: _extends({}, this.$store.getters.getEntities.item),
      pauta: [], //tabela de pauta do item  {...this.$store.getters.getEntities.pauta}
      itemum: [], //unidades de medida do item {...this.$store.getters.getEntities.itemum}
      itemkit: [], //items que compõem o kit
      itemcatmkt: [], //unidades de medida do item {...this.$store.getters.getEntities.itemcatmkt}
      metadata: _extends({}, this.$store.getters.getEntities.metadata),
      errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
      showFormImport: false,
      showGruestForm: false,
      showFamitForm: false,
      showFamicomForm: false,
      showUnimedForm: false,
      showGrucomForm: false,
      showDepoForm: false,
      showProdPerigoso: false,
      showDadosUni: false,
      showKitForm: false,
      showOutrasInf: false,
      showPauta: false,
      showInfEst: false,
      showDadosMarketplace: false,
      showDadosDimensoes: false,
      showDadosAtributosMercadoLivre: false,
      showAnexosForm: false,
      showAtributo: false,
      showCompItens: false,
      atributosmkt: [],
      categoriesAttributes: [],

      formatoTela: 'normal', //normal, forcaVendas, importacaonfe


      editaGrade: false,
      codgradel_bk: null,
      codgradec_bk: null,
      gradelist: [],
      gradeLinha: {},
      gradeColuna: {},

      itemgrade: null,
      complementos_descricao: {},
      atributo: {},
      atributos: {
        loja: {
          complementos_descricao: []
        }
      },
      indiceUpdate: null,
      iconOptions: [{ text: 'fa-file-text-o', selected: false }, { text: 'fa-info-circle', selected: false }, { text: 'fa-comments', selected: false }, { text: 'fa-cog', selected: false }, { text: 'fa-heart-o', selected: false }],
      classIconCheck: '',
      complementos: [],

      hasManyItem: false,
      steps: [{
        "selector": "",
        "step": 1,
        "title": 'Vamos come\xE7ar!',
        "content": "Vamos te guiar passo a passo por todo o processo de cadastro de produto.</br></br><a href='javascript:void(0)' class='btn btn-sm btn-danger text-white' onclick='window.dispatchEvent(new CustomEvent(\"desativar-guia\"))'>Não mostrar este guia</a>"
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#codigo",
        "step": 2,
        "title": 'Codigo',
        "content": "Informe o Código do produto."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#descricao",
        "step": 3,
        "title": 'Descri\xE7\xE3o',
        "content": "Informe o Descrição do produto."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#ncm",
        "step": 4,
        "title": 'Ncm',
        "content": "Informe o ncm do produto."
        // "image": "https://somehost.com/image.jpeg"
      }]

    };
  },


  computed: {
    itemComMovimento: function itemComMovimento() {
      return this.item.item_com_movimento == 'S';
    },

    informaFCI: function informaFCI() {
      return this.item.orimerc == '3' || this.item.orimerc == '5' || this.item.orimerc == '8';
      // return this.item.orimerc == '1' || this.item.orimerc == '2' || this.item.orimerc == '3' ||
      //        this.item.orimerc == '5' || this.item.orimerc == '6' || this.item.orimerc == '7' ||
      //        this.item.orimerc == '8'
    },

    orimerc: function orimerc() {
      return this.item.orimerc;
    },

    catmktList: function catmktList() {
      return this.$store.getters.getCatmktList;
    },

    administrador: function administrador() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador;
    },

    isView: function isView() {
      return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudView;
    },

    permissaoExcluir: function permissaoExcluir() {
      return this.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudView && this.administrador && this.formatoTela != 'forcaVendas';
    },
    showGuia: function showGuia() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].guia;
    },
    appLoja: function appLoja() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appLoja;
    }

  },

  watch: {
    orimerc: function orimerc(value) {
      //ATRIBUI ALIQUOTA 4% QUANDO ORIGEM FOR IMPORTADO
      if (value === '1') {
        this.item.aicm = 4;
      } else {
        this.item.aicm = 0;
      }
    },
    'item.tipoitem': function itemTipoitem(value) {
      this.metadata = JSON.parse(JSON.stringify(this.$store.getters.getEntities.metadata));

      this.metadata.item.ncm.validator.required = true;
      this.metadata.item.cservico.validator.required = false;
      if (value == 'S') {
        this.metadata.item.ncm.validator.required = false;
        this.metadata.item.cservico.validator.required = true;
      }
    }
  },

  methods: {
    handleDeleteAtributo: function handleDeleteAtributo(i) {
      this.atributos.loja.complementos_descricao.splice(i, 1);
      this.item.atributos = this.atributos;
    },
    handleEditAtributo: function handleEditAtributo(i) {
      this.atributo = _extends({}, this.atributos.loja.complementos_descricao[i]);
      this.indiceUpdate = i;
      this.showModalAtributo();
    },
    handleSelectIcon: function handleSelectIcon(icon) {
      this.atributo.icone = icon.text;
      this.iconOptions.forEach(function (e) {
        return e.selected == true ? e.selected = false : false;
      });
      var index = this.iconOptions.indexOf(icon);
      this.iconOptions[index].selected = true;
    },
    handleSaveAtributo: function handleSaveAtributo() {
      console.log(this.indiceUpdate);
      if (this.indiceUpdate >= 0 && this.indiceUpdate !== null) {
        this.atributos.loja.complementos_descricao[this.indiceUpdate] = this.atributo;
      } else {
        this.atributos.loja.complementos_descricao.push(this.atributo);
      }

      this.indiceUpdate = null;

      this.item.atributos = _extends({}, this.atributos);
      this.closeModalAtributo();
    },
    showModalAtributo: function showModalAtributo() {
      this.showAtributo = true;
    },
    closeModalAtributo: function closeModalAtributo() {
      this.atributo = '';
      this.showAtributo = false;
    },
    handleNewAtributo: function handleNewAtributo() {
      this.atributo = { conteudo: '', icone: '', titulo: '', ativo: false };
      this.showModalAtributo();
    },
    handleNewComplemento: function handleNewComplemento() {
      var complemento = { descricao: '', ativo: true };
      this.complementos.unshift(complemento);
    },
    handleDeleteComp: function handleDeleteComp(index) {
      this.complementos.splice(index, 1);
    },
    removeAnexosForm: function removeAnexosForm() {
      for (var x = 0; x < this.gradelist.length; x++) {
        if (this.gradelist[x].codlinha == this.itemgrade.codlinha) {
          if (!this.gradelist[x].parametros) this.gradelist[x].parametros = {};
          this.gradelist[x].parametros.docs = null;
        }
      }
      this.showAnexosForm = false;
    },
    saveAnexosForm: function saveAnexosForm(param) {
      for (var x = 0; x < this.gradelist.length; x++) {
        if (this.gradelist[x].codlinha == this.itemgrade.codlinha) {
          if (!this.gradelist[x].parametros) this.gradelist[x].parametros = {};
          this.gradelist[x].parametros.docs = [];
          this.gradelist[x].parametros.docs.push(param);
        }
      }
      this.showAnexosForm = false;
    },
    closeAnexosForm: function closeAnexosForm() {
      this.itemgrade = null;
      this.showAnexosForm = false;
    },
    handleVincularImagem: function handleVincularImagem(itemgrade) {
      this.itemgrade = itemgrade;
      this.showAnexosForm = true;
    },
    closeForm: function closeForm() {
      if (this.$route.params.id == 'novo') this.$router.go(-1);else this.$emit('closeform');
    },
    closeGruestForm: function closeGruestForm(id) {
      if (id) this.item.codgruest = id;
      this.showGruestForm = false;
    },
    closeGrucomForm: function closeGrucomForm(id) {
      if (id) this.item.codgrucom = id;
      this.showGrucomForm = false;
    },
    closeFamicomForm: function closeFamicomForm(id) {
      if (id) this.item.codfamicom = id;
      this.showFamicomForm = false;
    },
    closeFamiForm: function closeFamiForm(id) {
      if (id) this.item.codfami = id;
      this.showFamiForm = false;
    },
    closeUnimedForm: function closeUnimedForm(id) {
      if (id) this.item.coduni = id;
      this.showUnimedForm = false;
    },
    closeDepoForm: function closeDepoForm(id) {
      if (id) this.item.coddepo = id;
      this.showDepoForm = false;
    },
    handleSave: function handleSave() {
      var _this = this;

      //BOTAO SALVAR
      this.$validator.validateAll().then(function (isValid) {
        //AQUI EFETUA VALIDACAO NA TABELA DE PAUTA E NA UNIDADE DE MEDIDA

        // console.log(this.errors)

        var lErro = false;
        if (_this.pautaValidate()) {
          lErro = true;
        }
        if (_this.uniValidate()) {
          lErro = true;
        }
        if (_this.catmktValidate()) {
          lErro = true;
        }
        if (_this.itemKitValidate()) {
          lErro = true;
        }
        if (_this.itemGTINValidate()) {
          lErro = true;
        }
        if (!isValid || lErro) {
          _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          _this.apiPost();
        }
      });
    },
    handleAdicionaPauta: function handleAdicionaPauta() {
      //adiciona nova linha na tabela de pauta
      var p = _extends({}, this.$store.getters.getEntities.pauta);
      this.pauta.push(p);
    },
    handleDeletePauta: function handleDeletePauta(index) {
      //exclui linha da tabela de pauta
      this.pauta.splice(index, 1);
    },
    handleAdicionaUni: function handleAdicionaUni() {
      //adiciona nova linha na tabela de unidade de medida do item
      var p = _extends({}, this.$store.getters.getEntities.itemum);
      this.itemum.push(p);
    },
    handleDeleteUni: function handleDeleteUni(index) {
      //exclui linha da tabela de unidades de medida do item
      this.itemum.splice(index, 1);
    },
    handleAdicionaItem: function handleAdicionaItem() {
      //adiciona nova linha na tabela de unidade de medida do item
      var i = _extends({}, this.$store.getters.getEntities.itemkit);
      this.itemkit.push(i);
    },
    handleDeleteItem: function handleDeleteItem(index) {
      //exclui linha da tabela de unidades de medida do item
      this.itemkit.splice(index, 1);
    },
    handleAdicionaCatmkt: function handleAdicionaCatmkt() {
      //adiciona nova linha na tabela de categoria do item
      var p = _extends({}, this.$store.getters.getEntities.itemcatmkt);
      this.itemcatmkt.push(p);
    },
    handleCategoriesAttributes: function handleCategoriesAttributes(data) {
      var test = {};

      this.categoriesAttributes = [];

      for (var x = 0; x < data.length; x++) {
        test = data[x];
        if (test.id != 'BRAND') {
          var valor = {
            id: test.id,
            value_type: test.value_type,
            name: test.name,
            value_id: "",
            value_name: "",
            metadata: {
              decimals: 2,
              fieldname: test.id,
              help: test.name,
              label: test.name,
              length: 255,
              options: [],
              pk: "False"
            },
            metadata_units: {
              decimals: 2,
              fieldname: test.id + "_units",
              help: "",
              label: "",
              length: 255,
              options: [],
              pk: "False"
            }

          };

          var atributo = {
            id: "",
            value_id: "",
            value_name: ""
          };
          for (var y = 0; y < this.atributosmkt.length; y++) {
            if (this.atributosmkt[y].id == test.id) {
              atributo = this.atributosmkt[y];
            }
          }

          if (test.value_type == 'string') {
            valor.metadata.length = test.value_max_length;
            if (atributo) {
              valor.value_name = atributo.value_name;
            }
          }
          if (test.value_type == 'list') {
            if (atributo) {
              valor.value_id = atributo.value_id;
            }
            for (var y = 0; y < test.values.length; y++) {
              valor.metadata.options.push({ id: test.values[y].id, text: test.values[y].name });
            }
          }
          if (test.value_type == 'boolean') {
            if (atributo) {
              valor.value_id = atributo.value_id;
            }
            for (var y = 0; y < test.values.length; y++) {
              valor.metadata.options.push({ id: test.values[y].id, text: test.values[y].name });
            }
          }
          if (test.value_type == 'number') {
            valor.metadata.length = test.value_max_length;
            if (atributo) {
              valor.value_name = atributo.value_name;
            }
          }
          if (test.value_type == 'number_unit') {

            for (var y = 0; y < test.allowed_units.length; y++) {
              valor.metadata_units.options.push({ id: test.allowed_units[y].id, text: test.allowed_units[y].name });
              if (atributo && atributo.value_name.includes(' ' + test.allowed_units[y].id)) {
                valor.value_id = test.allowed_units[y].id;
                valor.value_name = atributo.value_name.replace(' ' + test.allowed_units[y].id, "");
              }
            }
          }

          this.categoriesAttributes.push(valor);
        }
      }
    },
    handleCatmkt: function handleCatmkt() {
      this.showDadosAtributosMercadoLivre = false;

      var test = {};
      var catmkt = {};

      for (var x = 0; x < this.itemcatmkt.length; x++) {
        test = this.itemcatmkt[x];
        for (var y = 0; y < this.catmktList.length; y++) {
          if (test.codcatmkt == this.catmktList[y].codcatmkt) {
            if (this.catmktList[y].marketplacecatmkt == 2) {
              this.showDadosAtributosMercadoLivre = true;
              catmkt = this.catmktList[y];
            }
          }
        }
      }

      this.categoriesAttributes = [];

      if (this.showDadosAtributosMercadoLivre) {
        jQuery.get("https://api.mercadolibre.com/categories/" + catmkt.altern + "/attributes", this.handleCategoriesAttributes);
      }
    },
    handleDeleteCatmkt: function handleDeleteCatmkt(index) {
      //exclui linha da tabela de categoria do item
      this.itemcatmkt.splice(index, 1);
    },
    itemValidate: function itemValidate() {
      return false;
    },
    itemGTINValidate: function itemGTINValidate() {
      var result = false;

      this.errmessages = [];

      if (this.item.codbarras && this.item.codbarras.length > 0 && !__WEBPACK_IMPORTED_MODULE_7_barcode_validator___default()(this.item.codbarras)) {
        this.errmessages.push("Código GTIN inválido!");
        result = true;
      }
      // console.log('itemgtin validate ' + result)
      return result;
    },
    uniValidate: function uniValidate() {
      //checa se foi digitado unidade de medida repetida para o item
      //compara também se a unidade digitada é igual à unidade principal do item
      var test = {};
      //cria novo objeto array para fazer a veiricacao de duplicidades
      var uniArr = this.itemum.map(function (obj) {
        return { uni: obj.uni };
      });
      //efetua a verificacao da duplicidade
      var duplicate = false;
      var validate = '';
      for (var x = 0; x < uniArr.length; x++) {
        test = uniArr[x];
        this.$set(this.itemum[x], 'duplicate', false);
        if (this.itemum[x].uni == this.item.uni) {
          this.itemum[x].duplicate = true;
          duplicate = true;
        }
        if (uniArr.findIndex(function (obj) {
          return obj.uni == test.uni;
        }) < x) {
          this.itemum[x].duplicate = true;
          duplicate = true;
        }
        if (this.itemum[x].fatoruni == null || this.itemum[x].fatoruni == 0) {
          validate = 'Obrigatório informar ' + this.metadata.itemum.fatoruni.label;
          this.$set(this.itemum[x], 'validate', validate);
          return true;
        } else {
          this.$set(this.itemum[x], 'validate', '');
        }
      }
      // console.log('uni validate ' + duplicate)
      return duplicate;
    },
    itemKitValidate: function itemKitValidate() {
      //checa se foi digitado unidade de medida repetida para o item
      //compara também se a unidade digitada é igual à unidade principal do item
      var test = {};
      //cria novo objeto array para fazer a veiricacao de duplicidades
      var kitArr = this.itemkit.map(function (obj) {
        return { coditem: obj.coditem };
      });
      //efetua a verificacao da duplicidade
      var duplicate = false;
      var validate = '';
      for (var x = 0; x < kitArr.length; x++) {
        test = kitArr[x];
        this.$set(this.itemkit[x], 'duplicate', false);
        if (this.itemkit[x].coditem == this.item.coditem) {
          this.itemkit[x].duplicate = true;
          duplicate = true;
        }
        if (kitArr.findIndex(function (obj) {
          return obj.coditem == test.coditem;
        }) < x) {
          this.itemkit[x].duplicate = true;
          duplicate = true;
        }
        if (this.itemkit[x].qt == null || this.itemkit[x].qt == 0) {
          validate = 'Obrigatório informar quantidade';
          this.$set(this.itemkit[x], 'validate', validate);
          return true;
        } else {
          this.$set(this.itemkit[x], 'validate', '');
        }
      }

      // console.log('itemkit validate ' + duplicate)
      return duplicate;
    },
    pautaValidate: function pautaValidate() {
      //checa se foi digitado tabela de pauta repetida para o item
      var test = {};
      //cria novo objeto array para fazer a veiricacao de duplicidades
      var pautaArr = this.pauta.map(function (obj) {
        return { ufdest: obj.ufdest, dtinicio: obj.dtinicio };
      });
      //efetua a verificacao da duplicidade
      var duplicate = false;
      var validate = '';
      for (var x = 0; x < pautaArr.length; x++) {
        test = pautaArr[x];
        this.$set(this.pauta[x], 'duplicate', false);
        if (pautaArr.findIndex(function (obj) {
          return obj.ufdest == test.ufdest && obj.dtinicio == test.dtinicio;
        }) < x) {
          this.pauta[x].duplicate = true;
          duplicate = true;
        }
        if (this.pauta[x].pautaicm == null && this.pauta[x].pautaicmst == null) {
          validate = 'Obrigatório informar ' + this.metadata.pauta.pautaicm.label + ' ou ' + this.metadata.pauta.pautaicmst.label;
          this.$set(this.pauta[x], 'validate', validate);
        } else {
          this.$set(this.pauta[x], 'validate', '');
        }
      }
      // console.log('pauta validate ' + duplicate)
      return duplicate;
    },
    catmktValidate: function catmktValidate() {
      //checa se foi digitado unidade de medida repetida para o item
      //compara também se a unidade digitada é igual à unidade principal do item
      var test = {};
      //cria novo objeto array para fazer a verificacao de duplicidades
      var codcatmktArr = this.itemcatmkt.map(function (obj) {
        return { codcatmkt: obj.codcatmkt };
      });
      //efetua a verificacao da duplicidade
      var duplicate = false;
      var validate = '';
      for (var x = 0; x < codcatmktArr.length; x++) {
        test = codcatmktArr[x];
        this.$set(this.itemcatmkt[x], 'duplicate', false);
        if (codcatmktArr.findIndex(function (obj) {
          return obj.codcatmkt == test.codcatmkt;
        }) < x) {
          this.itemcatmkt[x].duplicate = true;
          duplicate = true;
        }
        this.$set(this.itemcatmkt[x], 'validate', '');
      }
      // console.log('catmkt validate ' + duplicate)
      return duplicate;
    },
    inicializaItem: function inicializaItem() {
      this.item.stitem = 'A';
      this.item.tipoitem = 'P';
      this.item.tipoestoque = 'N';
      this.item.tipoproduto = '04';
      this.item.controlalocal = 'N';
      this.item.escalaprod = '0';
      this.item.ipiitem = 'N';
      this.item.icmitem = 'T';
      this.item.issitem = 'N';
      this.item.stpis = '01';
      this.item.stcofins = '01';
      this.item.orimerc = '0';
      this.item.uni = 'UN';
      this.item.incentfiscaliss = 'N';

      this.item.dtcadastro = this.$getDate();
      // this.item.dtcadastro = ''
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var x;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$store.dispatch('loadItem', { id: _this2.item.coditem });

              case 2:
                _context.next = 4;
                return _this2.$store.dispatch('loadCatmkt', {});

              case 4:

                if (_this2.$store.getters.getItem) {
                  _this2.item = _extends({}, _this2.$store.getters.getItem[0]);
                  if (_this2.item.pauta && _this2.item.pauta.length) {
                    _this2.pauta = _this2.item.pauta;
                  }
                  if (_this2.item.itemum && _this2.item.itemum.length) {
                    _this2.itemum = _this2.item.itemum;
                  }
                  if (_this2.item.itemkit && _this2.item.itemkit.length) {
                    _this2.itemkit = _this2.item.itemkit;
                  }
                  if (_this2.item.itemgrade && _this2.item.itemgrade.length) {
                    _this2.gradelist = _this2.item.itemgrade;
                    for (x = 0; x < _this2.gradelist.length; x++) {
                      if (_this2.gradelist[x].parametros) {
                        _this2.gradelist[x].parametros = JSON.parse(_this2.gradelist[x].parametros);
                      }
                    }
                  }
                  if (_this2.item.itemcatmkt && _this2.item.itemcatmkt.length) {
                    _this2.itemcatmkt = _this2.item.itemcatmkt;
                  }
                  if (_this2.item.atributosmkt) {
                    _this2.atributosmkt = JSON.parse(_this2.item.atributosmkt);
                  }
                  if (_this2.item.atributos || _this2.item.atributos == null) {

                    _this2.atributos = JSON.parse(_this2.item.atributos);

                    if (_this2.atributos == null) {
                      _this2.atributos = {};
                    }
                  }

                  if (!_this2.atributos.hasOwnProperty('loja')) {
                    _this2.atributos.loja = {
                      complementos_descricao: []
                    };
                  }

                  if (!_this2.atributos.hasOwnProperty('obs')) {
                    _this2.atributos.obs = {
                      complementos: []
                    };
                  }

                  _this2.complementos = _this2.atributos.obs.complementos;

                  _this2.lCrud = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
                  _this2.crudText = _this2.$crudText(_this2.lCrud);
                } else {
                  _this2.inicializaItem();
                  //QUANDO FOR UMA INCLUSAO DE ITEM PELA IMPORTACAO DE XML DE NFE, ATRIBUI OS CAMPOS DO XML PARA O NOVO ITEM
                  if (_this2.importXml) {
                    _this2.item.coditem = _this2.importXml.codigoxml;
                    _this2.item.descricao = _this2.importXml.descricao;
                    _this2.item.codbarras = _this2.importXml.cean;
                    _this2.item.cest = _this2.importXml.cest;
                    _this2.item.ncm = _this2.importXml.ncm;
                    _this2.item.orimerc = _this2.importXml.orimerc;
                    //ATRIBUI O TIPO DE PRODUTO CONFORME TIPO DE NATUREZA SELECIONADA NA IMPORTACAO DO XML
                    if (_this2.importXml.nates.finentrada == '1') {
                      _this2.item.tipoproduto = '01'; //materia prima
                    } else if (_this2.importXml.nates.finentrada == '2') {
                      _this2.item.tipoproduto = '00'; //mercadoria para revenda
                    } else if (_this2.importXml.nates.finentrada == '3') {
                      _this2.item.tipoproduto = '07'; //uso e consumo
                    } else if (_this2.importXml.nates.finentrada == '4') {
                      _this2.item.tipoproduto = '08'; //ativo
                    } else {
                      _this2.item.tipoproduto = '04'; //acabado
                    }
                  }
                }

                _this2.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    apiDelete: function apiDelete(del) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var modulo, sendData, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!confirm("Confirma a exclusão?")) {
                  _context2.next = 8;
                  break;
                }

                modulo = 'cg/item/' + _this3.item.coditem;
                sendData = {};
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

              case 5:
                data = _context2.sent;

                _this3.$erpToastSuccess('Item excluído.');
                _this3.closeForm();

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    apiPost: function apiPost() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var modulo, sendData, x, test, valor, metodo, update, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                //efetua a gravacao do item

                modulo = 'cg/item/';
                sendData = {};


                _this4.item.pauta = _this4.pauta;
                _this4.item.itemum = _this4.itemum;
                _this4.item.itemkit = _this4.itemkit;
                _this4.item.itemgrade = _this4.gradelist;
                _this4.item.itemcatmkt = _this4.itemcatmkt;

                _this4.item.atributos = _this4.atributos;

                if (!_this4.item.atributos.obs) {
                  _this4.item.atributos.obs = {};
                }

                _this4.item.atributos.obs.complementos = _this4.complementos;

                _this4.atributosmkt = [];
                for (x = 0; x < _this4.categoriesAttributes.length; x++) {
                  test = _this4.categoriesAttributes[x];
                  valor = {
                    id: test.id,
                    value_id: test.value_id,
                    value_name: test.value_name
                  };

                  if (test.value_type == 'number_unit') {
                    valor.value_name = valor.value_name + ' ' + valor.value_id;
                    valor.value_id = "";
                  }
                  if (valor.value_id || valor.value_name) if (valor.value_id.trim() != "" || valor.value_name.trim() != "") _this4.atributosmkt.push(valor);
                }
                _this4.item.atributosmkt = _this4.atributosmkt;

                sendData = { item: _this4.item };

                metodo = 'post';
                update = false;

                if (_this4.lCrud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                  metodo = 'put';
                  update = true;
                }

                _context3.next = 19;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

              case 19:
                data = _context3.sent;

                if (data.errmessages) {
                  _this4.errmessages = data.errmessages;
                  _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                } else {
                  if (update) {
                    _this4.$erpToastSuccess('O item foi alterado com sucesso');
                  } else {
                    _this4.$erpToastSuccess('O item foi inserido com sucesso');
                  }
                  _this4.errmessages = {};
                  if (_this4.$route.params.id !== 'novo') {
                    _this4.$emit('closeform', data.items[0]);
                  } else {
                    _this4.$router.push('/itemlist');
                  }
                }

              case 21:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    handleIncluir: function handleIncluir(pTipo) {
      //exibe tela de cadastro
      if (this.isView) {
        return;
      }

      if (pTipo === 'gruest') {
        this.showGruestForm = true;
      }

      if (pTipo === 'depo') {
        this.showDepoForm = true;
      }

      if (pTipo === 'grucom') {
        this.showGrucomForm = true;
      }

      if (pTipo === 'fami') {
        this.showFamiForm = true;
      }

      if (pTipo === 'famicom') {
        this.showFamicomForm = true;
      }

      if (pTipo === 'uni') {
        this.showUnimedForm = true;
      }
    },


    //
    //
    //TRATAMENTO DA GRADE
    //
    //

    handleHabilitaGrade: function handleHabilitaGrade() {
      if (this.item.possuimovimento) {
        this.$erpToastError('Não é permitido definir grade para este produto');
        return;
      }
      this.editaGrade = true;
      this.codgradel_bk = this.item.codgradel;
      this.codgradec_bk = this.item.codgradec;
      this.$nextTick(function () {
        this.$refs.codgradel.focus();
      });
    },
    handleAplicaGrade: function handleAplicaGrade() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var itemGrade, x, y;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                //A GRADE DE LINHAS É OBRIGATORIA

                _this5.editaGrade = false;

                _this5.gradeLinha = null;
                _this5.gradeColuna = null;

                //CARREGA OS OBJETOS GRADELINHA, GRADECOLUNA PARA INICIAR A MONTAGEM DA GRADE

                if (!_this5.item.codgradel) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 6;
                return _this5.$store.dispatch('loadGrade', { id: _this5.item.codgradel });

              case 6:
                if (_this5.$store.getters.getGrade) {
                  _this5.gradeLinha = _extends({}, _this5.$store.getters.getGrade);
                  // // this.gradeLinha.valores = JSON.parse(this.$store.getters.getGrade.valores)
                  // this.gradeLinha.gradeit = this.$store.getters.getGrade.gradeit
                }

              case 7:
                if (!_this5.item.codgradec) {
                  _context4.next = 11;
                  break;
                }

                _context4.next = 10;
                return _this5.$store.dispatch('loadGrade', { id: _this5.item.codgradec });

              case 10:
                if (_this5.$store.getters.getGrade) {
                  _this5.gradeColuna = _extends({}, _this5.$store.getters.getGrade);
                  // // this.gradeColuna.valores = JSON.parse(this.$store.getters.getGrade.valores)
                  // this.gradeColuna.gradeit = this.$store.getters.getGrade.gradeit
                }

              case 11:

                _this5.gradelist = [];
                itemGrade = {};


                for (x = 0; x < _this5.gradeLinha.gradeit.length; x++) {
                  if (_this5.gradeColuna && _this5.gradeColuna.gradeit.length > 0) {
                    for (y = 0; y < _this5.gradeColuna.gradeit.length; y++) {
                      itemGrade.codlinha = _this5.gradeLinha.gradeit[x].codgradeit;
                      itemGrade.descricaolinha = _this5.gradeLinha.gradeit[x].descricao;
                      itemGrade.codcoluna = _this5.gradeColuna.gradeit[y].codgradeit;
                      itemGrade.descricaocoluna = _this5.gradeColuna.gradeit[y].descricao;
                      itemGrade.coditem = '';
                      itemGrade.codbarras = '';
                      itemGrade.precovenda = 0;
                      itemGrade.ativo = 'S';
                      _this5.gradelist.push(_extends({}, itemGrade));
                    }
                  } else {
                    itemGrade.codlinha = _this5.gradeLinha.gradeit[x].codgradeit;
                    itemGrade.descricaolinha = _this5.gradeLinha.gradeit[x].descricao;
                    itemGrade.codcoluna = null;
                    itemGrade.descricaocoluna = null;
                    itemGrade.coditem = '';
                    itemGrade.codbarras = '';
                    itemGrade.precovenda = 0;
                    itemGrade.ativo = 'S';
                    _this5.gradelist.push(_extends({}, itemGrade));
                  }
                }

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    hasGrid: function hasGrid(coditem) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDS"])(_this6.$store.getters.urlOrds + 'cg/item/' + coditem, null);

              case 2:
                data = _context5.sent;

                _this6.itemkit.filter(function (i) {
                  if (data.items[0].isgrade === 'S') {
                    if (i.coditem === coditem) _this6.$set(i, 'hasGrid', data.items[0].isgrade);
                    return;
                  }
                  if (i.coditem === coditem) {
                    i.coditemgrade = null;
                    if (i.hasGrid) delete i.hasGrid;
                  }
                });
                console.log(_this6.itemkit);

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    }
  },

  components: {
    DepoForm: __WEBPACK_IMPORTED_MODULE_3__depo_form__["a" /* default */], UnimedForm: __WEBPACK_IMPORTED_MODULE_4__unimed_form__["a" /* default */], GruestForm: __WEBPACK_IMPORTED_MODULE_2__gruest_form__["a" /* default */], grade: __WEBPACK_IMPORTED_MODULE_5__components_grade__["a" /* default */], AnexosSelecionarForm: __WEBPACK_IMPORTED_MODULE_6__components_anexos_selecionar_form__["a" /* default */], Tourguide: __WEBPACK_IMPORTED_MODULE_8_tourguidejs___default.a

  },

  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var isValid, filter, params, tourguide;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(_this7.lCrud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI)) {
                _context6.next = 15;
                break;
              }

              _context6.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiValidaLimitePlano"])(_this7, 'produtos');

            case 3:
              isValid = _context6.sent;

              if (isValid) {
                _context6.next = 8;
                break;
              }

              _this7.closeForm();
              _context6.next = 15;
              break;

            case 8:
              if (!_this7.showGuia) {
                _context6.next = 15;
                break;
              }

              filter = '{"codigo":{"$ne":"TESTE"}}';
              params = { filter: filter };
              _context6.next = 13;
              return _this7.$store.dispatch('loadItemList', params);

            case 13:
              _this7.hasManyItem = _this7.$store.getters.getItemList.length >= 1;
              if (_this7.showGuia && !_this7.hasManyItem) {
                tourguide = new __WEBPACK_IMPORTED_MODULE_8_tourguidejs___default.a({
                  steps: _this7.steps
                });


                tourguide.start();
              }

            case 15:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this7);
    }))();
  },
  created: function created() {
    this.lCrud = this.crud;
    if (this.$route.params && this.$route.params.id == 'novo') this.lCrud = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI;

    this.crudText = this.$crudText(this.lCrud);

    if (this.importXml) {
      this.item.coditem = this.importXml.codigoxml;
    } else {
      this.item.coditem = this.index;
    }

    if (this.lCrud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
      this.inicializaItem();
      if (this.descricao) {
        this.item.descricao = this.descricao; //INCLUSAO PELO INPUT-ITEM
      }
    } else {
      this.loadData();
    }

    this.handleCatmkt();

    if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appNFe) {} else if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appForcaVendas) {
      this.formatoTela = 'forcaVendas';
    }

    if (this.importXml) {
      this.formatoTela = 'importacaonfe';
    }

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
      if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) this.$refs.codigo.focus();
    });
  }
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_gruest_form_vue__ = __webpack_require__(508);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_27ce9901_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_gruest_form_vue__ = __webpack_require__(1415);
function injectStyle (ssrContext) {
  __webpack_require__(1413)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_gruest_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_27ce9901_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_gruest_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        pai: { Object: Object },
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            gruest: _extends({}, this.$store.getters.getEntities.gruest),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.gruest.codgruest);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadGruest', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getGruest) {
                                    _this2.gruest = _extends({}, _this2.$store.getters.getGruest);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiPost: function apiPost() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/gruest/';
                                sendData = {};


                                if (_this3.pai) _this3.gruest.codgruestpai = _this3.pai.codgruest;

                                sendData = { gruest: _this3.gruest };

                                metodo = 'post';
                                update = false;

                                if (_this3.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    update = true;
                                }
                                _context2.next = 9;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this3.$store, modulo, sendData, metodo);

                            case 9:
                                data = _context2.sent;

                                if (data.errmessages) {
                                    _this3.errmessages = data.errmessages;
                                    _this3.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this3.$erpToastUpdated();
                                    } else {
                                        _this3.$erpToastInserted();
                                    }
                                    _this3.errmessages = {};
                                    _this3.closeForm();
                                }

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.descricao.focus();
        });
    }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_depo_form_vue__ = __webpack_require__(510);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee787e0a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_depo_form_vue__ = __webpack_require__(1418);
function injectStyle (ssrContext) {
  __webpack_require__(1416)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_depo_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee787e0a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_depo_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            deposito: _extends({}, this.$store.getters.getEntities.deposito),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.deposito.coddeposito);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO Excluir
            this.apiDelete();
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadDeposito', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getDeposito) {
                                    _this2.deposito = _extends({}, _this2.$store.getters.getDeposito);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/deposito/' + _this3.deposito.coddeposito;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/deposito/';
                                sendData = {};


                                sendData = { deposito: _this4.deposito };

                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
            this.deposito.codfil = '1';
        } else {
            this.loadData();
        }

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.descricao.focus();
        });
    }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: '',
        importXml: {}
    },

    data: function data() {
        return {
            crudText: '',
            unimed: _extends({}, this.$store.getters.getEntities.unimed),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: {} //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }
    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO Excluir
            this.apiDelete();
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadUnimed', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getUnimed) {
                                    _this2.unimed = _extends({}, _this2.$store.getters.getUnimed);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/unimed/' + _this3.unimed.uni;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/unimed/';
                                sendData = {};


                                sendData = { unimed: _this4.unimed };

                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.$emit('closeform', data.items[0]);
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
            this.unimed.fracao = 'S';
        } else {
            this.loadData();
        }

        if (this.importXml) {
            this.unimed.uni = this.importXml.uni;
        }

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.uni.focus();
        });
    }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//


/*
params: {
  coditem: '',
  view: false,
  qt: 0,                     //QUANTIDADE TOTAL DIGITADA NA GRADE
  listItemGrade: []          //OBJETO PARA TRANSFERENCIA DOS ITENS DIGITADOS
}
*/

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params: {}
  },

  data: function data() {
    return {
      listItemGrade: [], //LISTA COM CODIGOS DE ITEM/GRADE E QUANTIDADES PREENCHIDAS

      grade: {},
      colunasHead: [], //PARA MONTAGEM DO CABECALHO DA TABELA DE GRADE

      quantidadeTotal: 0
    };
  },


  computed: {
    item: function item() {
      return this.$store.getters.getItem[0];
    }
  },

  watch: {
    grade: {
      handler: function handler() {
        //CALCULA A QUANTIDADE TOTAL DA GRADE QUANDO HOUVER ALTERACOES

        this.listItemGrade = [];
        this.quantidadeTotal = 0;

        for (var row = 0; row < this.grade.linhas.length; row++) {
          if (this.grade.linhas[row].coditemgrade) {
            this.quantidadeTotal = this.quantidadeTotal + parseFloat(this.grade.linhas[row].quantidade);
            this.listItemGrade.push({ qt: this.grade.linhas[row].quantidade, coditemgrade: this.grade.linhas[row].coditemgrade });
          } else if (this.grade.linhas[row].colunas) {
            //EXISTE COLUNAS
            for (var col = 0; col < this.grade.linhas[row].colunas.length; col++) {
              this.quantidadeTotal = this.quantidadeTotal + parseFloat(this.grade.linhas[row].colunas[col].quantidade);
              this.listItemGrade.push({ qt: this.grade.linhas[row].colunas[col].quantidade, coditemgrade: this.grade.linhas[row].colunas[col].coditemgrade });
            }
          }
        }

        this.$emit('update', this.params.index, this.quantidadeTotal, this.listItemGrade);
      },

      deep: true
    }
  },

  methods: {
    clickConfirma: function clickConfirma() {},
    preparaGrade: function preparaGrade() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var temp, row, col;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                /*
                PREPARAÇÃO DA GRADE
                */

                _this.listItemGrade = _this.params.listItemGrade;
                _this.quantidadeTotal = _this.params.qt;

                _context.next = 4;
                return _this.$store.dispatch('loadItem', { id: _this.params.coditem });

              case 4:
                if (_this.item) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return');

              case 6:

                _this.grade = JSON.parse(_this.item.grade);
                _this.colunasHead = [];

                temp = null;


                for (row = 0; row < _this.grade.linhas.length; row++) {
                  if (_this.grade.linhas[row].coditemgrade) {
                    temp = _this.getItemGrade(_this.grade.linhas[row].coditemgrade);
                    if (temp.lenght > 0) {
                      _this.grade.linhas[row].quantidade = temp[0].qt;
                    }
                  } else if (_this.grade.linhas[row].colunas) {
                    //EXISTE COLUNAS
                    for (col = 0; col < _this.grade.linhas[row].colunas.length; col++) {
                      if (_this.grade.linhas[row].colunas[col].coditemgrade) {
                        temp = _this.getItemGrade(_this.grade.linhas[row].colunas[col].coditemgrade);
                        if (temp.length > 0) {
                          _this.grade.linhas[row].colunas[col].quantidade = temp[0].qt;
                        }
                      }
                      if (row == 0) {
                        _this.colunasHead.push({ descricao: _this.grade.linhas[row].colunas[col].descricao });
                      }
                    }
                  }
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getItemGrade: function getItemGrade(coditemgrade) {
      return this.listItemGrade.filter(function (obj) {
        return obj.coditemgrade == coditemgrade;
      });
    },
    focus: function focus() {
      this.$nextTick(function () {
        if (this.$refs.quantidade) this.$refs.quantidade[0].focus();
      });
    }
  },

  created: function created() {
    this.preparaGrade();
  }
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params: Object
  },

  data: function data() {
    return {
      listImages: [],
      selectedIndex: 0,
      chaveref: '',
      ref: ''
    };
  },


  computed: {
    title: function title() {
      if (this.params.ref == 'item') {
        return 'Imagens de ' + this.params.title;
      } else {
        return 'Anexos';
      }
    },

    fotosProduto: function fotosProduto() {
      return this.params.ref == 'item';
    },

    fileTypes: function fileTypes() {
      if (this.fotosProduto) return 'image/*';else return '';
    }
  },

  methods: {
    handleClickRemove: function handleClickRemove() {
      this.$emit('removeform');
    },
    closeForm: function closeForm(action) {
      this.$emit('closeform');
    },
    handleClickGaleria: function handleClickGaleria(index) {

      //this.mainImage = this.listImages[index].url
      this.selectedIndex = index;
      this.$emit('saveform', { coddoc: this.listImages[index].coddoc, img: this.listImages[index].url });
    },
    loadData: function loadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var x;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch('loadDocs', { id: _this.ref + '/' + _this.chaveref });

              case 2:
                _this.listImages = [].concat(_toConsumableArray(_this.$store.getters.getDocsList));

                //EFETUA O DOWNLOAD DE CADA IMAGEM NA BARRA DE MINIATURAS
                if (_this.params.showform) {
                  for (x = 0; x < _this.listImages.length; x++) {
                    _this.$set(_this.listImages[x], 'image', null);
                    // this.loadMiniatura(x)
                  }
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadMiniatura: function loadMiniatura(index) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var self, test;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this2;
                test = index;
                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSmidia"])(_this2.listImages[index].url).then(function (data) {
                  if (data && data.size > 0) {
                    var reader = new window.FileReader();
                    reader.readAsDataURL(data);
                    reader.onload = function () {
                      self.listImages[test].image = reader.result;
                      if (test == 0) {
                        //self.mainImage = reader.result
                      }
                    };
                  }
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },

  created: function created() {
    this.chaveref = this.params.chaveref;
    this.ref = this.params.ref;
    this.loadData();
  }
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_csvReport__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_csvReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        filial: {}
    },

    data: function data() {
        return {
            estagio: 'inicio',
            errmessage: '',
            selectedFile: {},
            urlFile: '',
            url: Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["urlORDS"])(this.$store, 'cg/importa/produtos'),
            prepara: false,

            dadosResumo: {},
            csv: null
        };
    },


    computed: {
        status: function status() {
            return '';
        }
    },

    methods: {
        handleVoltar: function handleVoltar() {
            this.$router.go(-1);
        },
        handleDownloadModelo: function handleDownloadModelo() {
            window.open('https://novo.notabrasil.com.br/planilha_modelo_produto.csv', "_blank");
        },
        handleFileChange: function handleFileChange() {
            this.selectedFile = this.$refs.file.files[0];
        },
        handleAnalisarArquivo: function handleAnalisarArquivo() {
            //ENVIA O ARQUIVO PARA ANALISE DA IMPORTACAO
            if (!this.selectedFile) return;

            var extPermitidas = ['csv'];
            var self = this;

            if (typeof extPermitidas.find(function (ext) {
                return self.selectedFile.name.split('.').pop() == ext;
            }) == 'undefined') {
                self.$erpToastError('Extensão do arquivo inválida! Somente arquivos ".csv" são permitidos.');
                return;
            }

            this.prepara = true;

            var reader = new FileReader();
            reader.readAsText(this.selectedFile, 'ISO-8859-1');
            reader.onload = function (event) {
                self.csv = event.target.result;
                self.apiUpload();
                // console.log(csv)
            };
            reader.onerror = function (event) {
                if (event.target.error.name == 'NotReadableError') {
                    self.$erpToastError('Não foi possível ler o arquivo!');
                }
            };
            return;
        },
        handleSelecionarOutro: function handleSelecionarOutro() {
            this.estagio = 'inicio';
            this.selectedFile = {};
        },
        handleConfirmarImportacao: function handleConfirmarImportacao() {
            //ENVIA NOVAMENTE O MESMO ARQUIVO PARA IMPORTACAO
            this.prepara = false;
            this.apiUpload();
        },
        apiUpload: function apiUpload() {
            //EFETUA O UPLOAD DO ARQUIVO

            var formData = new FormData();
            formData.append('file.csv', new Blob([this.csv]), { type: 'text/csv' });

            var self = this;

            this.message = null;

            this.$appLoading(true);

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.url, formData, {
                headers: {
                    //                    'Content-Type': 'multipart/form-data;charset=ISO-8859-1;', //'application/x-www-form-urlencoded;charset=UTF-8', //'multipart/form-data;',
                    'prepara': self.prepara
                }
            }).then(function (data) {
                if (data.data) {
                    self.dadosResumo = data.data;
                    if (self.prepara) self.estagio = 'showresumo';else self.handleVoltar();
                }
                self.$appLoading(false);
            }).catch(function (data) {
                self.$appLoading(false);
                self.errmessage = data.message;
                self.$erpToastError('Erro ao carregar o arquivo');
            });
        },
        handleSelecionarArquivo: function handleSelecionarArquivo() {
            //BOTAO SELECIONAR ARQUIVO
            this.$refs.file.click();
        },
        handleExportaResumo: function handleExportaResumo(tipo) {
            var data = this.dadosResumo.itens.filter(function (it) {
                return it.status == tipo;
            }).map(function (it) {

                var obj = {
                    codigo: it.codigo,
                    descricao: it.descricao,
                    uni: it.uni,
                    custo: Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(it.custo, 2),
                    precoVenda: Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(it.precovenda, 2),
                    ipi: Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(it.aipi, 2)
                };

                if (it.message) obj.mensagem = it.message;

                return obj;
            });
            if (!data || data.length == 0) this.$erpToastError('Nenhum produto para visualizar');else {
                var csv = Object(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__["objectToCsv"])(data);
                Object(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__["downloadCsvReport"])(csv);
            }
        }
    },

    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
        this.selectedFile = {};
    }
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_csvReport__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_csvReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        filial: {}
    },

    data: function data() {
        return {
            estagio: 'inicio',
            errmessage: '',
            selectedFile: {},
            urlFile: '',
            url: Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["urlORDS"])(this.$store, 'cg/importa/estoque'),
            prepara: false,

            dadosResumo: {},
            csv: null
        };
    },


    computed: {
        status: function status() {
            return '';
        }
    },

    methods: {
        handleVoltar: function handleVoltar() {
            this.$router.push('/itemlist');
        },
        handleDownloadModelo: function handleDownloadModelo() {
            window.open('https://novo.notabrasil.com.br/planilha_modelo_estoque_produto.csv', "_blank");
        },
        handleDownloadModeloComDados: function handleDownloadModeloComDados() {
            //window.open('https://novo.notabrasil.com.br/planilha_modelo_estoque_produto.csv', "_blank")
            var url = 'cg/exporta/planilha_modelo_estoque_produto';
            var data = null;
            Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload2"])(this, url, this.data, "post");
        },
        handleFileChange: function handleFileChange() {
            this.selectedFile = this.$refs.file.files[0];
        },
        handleAnalisarArquivo: function handleAnalisarArquivo() {
            //ENVIA O ARQUIVO PARA ANALISE DA IMPORTACAO
            if (!this.selectedFile) return;

            this.prepara = true;

            var self = this;

            var reader = new FileReader();
            reader.readAsText(this.selectedFile, 'ISO-8859-1');
            reader.onload = function (event) {
                self.csv = event.target.result;
                self.apiUpload();
                //console.log(self.csv)
            };
            reader.onerror = function (event) {
                if (event.target.error.name == 'NotReadableError') {
                    self.$erpToastError('Não foi possível ler o arquivo!');
                }
            };
            return;
        },
        handleSelecionarOutro: function handleSelecionarOutro() {
            this.estagio = 'inicio';
            this.selectedFile = {};
        },
        handleConfirmarImportacao: function handleConfirmarImportacao() {
            //ENVIA NOVAMENTE O MESMO ARQUIVO PARA IMPORTACAO
            this.prepara = false;
            this.apiUpload();
        },
        apiUpload: function apiUpload() {
            //EFETUA O UPLOAD DO ARQUIVO

            var formData = new FormData();
            formData.append('file.csv', new Blob([this.csv]), { type: 'text/csv' });

            var self = this;

            this.message = null;

            this.$appLoading(true);

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.url, formData, {
                headers: {
                    //                    'Content-Type': 'multipart/form-data;charset=ISO-8859-1;', //'application/x-www-form-urlencoded;charset=UTF-8', //'multipart/form-data;',
                    'prepara': self.prepara
                }
            }).then(function (data) {
                if (data.data) {
                    self.dadosResumo = data.data;
                    if (self.prepara) self.estagio = 'showresumo';else self.handleVoltar();
                }
                self.$appLoading(false);
            }).catch(function (data) {
                self.$appLoading(false);
                self.errmessage = data.message;
                self.$erpToastError('Erro ao carregar o arquivo');
            });
        },
        handleSelecionarArquivo: function handleSelecionarArquivo() {
            //BOTAO SELECIONAR ARQUIVO
            this.$refs.file.click();
        },
        handleExportaResumo: function handleExportaResumo(tipo) {
            var data = this.dadosResumo.itens.filter(function (it) {
                return it.status == tipo;
            }).map(function (it) {

                var obj = {
                    codigo: it.codigo,
                    descricao: it.descricao,
                    coditem: it.coditem,
                    uni: it.uni,
                    coditemgrade: it.coditemgrade,
                    gradecor: it.gradecor,
                    gradetamanho: it.gradetamanho,
                    lote: it.lote,
                    sublote: it.sublote,
                    qt: Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(it.qt, 2)
                };

                if (it.message) obj.mensagem = it.message;

                return obj;
            });
            if (!data || data.length == 0) this.$erpToastError('Nenhum produto para visualizar');else {
                var csv = Object(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__["objectToCsv"])(data);
                Object(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__["downloadCsvReport"])(csv);
            }
        }
    },

    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
        this.selectedFile = {};
    }
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nates_list_vue__ = __webpack_require__(517);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_19be116a_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nates_list_vue__ = __webpack_require__(1446);
function injectStyle (ssrContext) {
  __webpack_require__(1441)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19be116a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nates_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_19be116a_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nates_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nates_form__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codnates: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            tabs: [{ title: 'Saída', icon: '' }, { title: 'Entrada', icon: '' }],

            activeTab: 0
        };
    },


    computed: {
        natesList: function natesList() {
            return this.$store.getters.getNatesList;
        },
        natesListSaida: function natesListSaida() {
            return this.$store.getters.getNatesSaidaList;
        },
        natesListEntrada: function natesListEntrada() {
            return this.$store.getters.getNatesEntradaList;
        },

        tabSaida: function tabSaida() {
            return this.activeTab == 0;
        },

        tabEntrada: function tabEntrada() {
            return this.activeTab == 1;
        }
    },

    filters: {
        getText: function getText(value, metadata) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(value, metadata);
        }

    },

    methods: {
        changeTab: function changeTab(idx) {
            this.activeTab = idx;
        },
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.codnates = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codnates = '';
            this.showForm = true;
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"cfop":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadNates', { filter: this.filter });
        },
        textStatus: function textStatus(val) {
            if (val === 'A') return 'Ativo';
            if (val === 'I') return 'Inativo';
            return val;
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], NatesForm: __WEBPACK_IMPORTED_MODULE_1__nates_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: '',
    crud: ''
  },

  data: function data() {
    return {
      crudText: '',
      nates: _extends({}, this.$store.getters.getEntities.nates),
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
      unwatch: true
    };
  },


  computed: {
    finentrada: function finentrada() {
      return this.nates.finentrada;
    },

    cfop: function cfop() {
      return this.nates.cfop;
    },

    tpnf: function tpnf() {
      return this.nates.tpnf;
    },

    tpnat: function tpnat() {
      return this.nates.tpnat;
    },

    csosn: function csosn() {
      return this.nates.csosn;
    },

    sticm: function sticm() {
      return this.nates.sticm;
    },

    cfopImportacao: function cfopImportacao() {
      return this.nates.cfop > '3000' && this.nates.cfop < '5000';
    },

    exibirCalculaDuplicata: function exibirCalculaDuplicata() {
      var tiposExibicao = ['V', 'C', 'S', 'I', 'D', 'CR', 'DB'];
      return tiposExibicao.includes(this.nates.tpnf);
    }
  },

  watch: {
    tpnat: function tpnat(newValue) {
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
      if (this.nates.tpnat == 'E' && this.nates.tpnf == 'V') this.nates.tpnf = 'C';
      if (this.nates.tpnat == 'S' && this.nates.tpnf == 'C') this.nates.tpnf = 'V';

      if (!this.stipi && this.nates.tpnat == 'E') this.sticm = '03';

      // this.metadata.nates.sticm.validator.required = (newValue == 'S')
      // this.metadata.nates.csosn.validator.required = (newValue == 'S')
      this.metadata.nates.sticm.validator.required = false;
      this.metadata.nates.csosn.validator.required = false;

      // this.metadata.nates.motdesicm.validator = this.metadata.nates.motdesicm.validator ? this.metadata.nates.motdesicm.validator : {}
      // this.metadata.nates.motdesicm.validator.required = false
      this.$validator.reset();
    },

    finentrada: function finentrada(newValue, oldValue) {
      if (this.unwatch) {
        return;
      }
      if (newValue == '1' || newValue == '2') {
        this.nates.creicm = 'S';
        this.nates.creipi = 'S';
        this.nates.crepis = 'S';
        this.nates.crecofins = 'S';
      } else {
        this.nates.creicm = 'N';
        this.nates.creipi = 'N';
        this.nates.crepis = 'N';
        this.nates.crecofins = 'N';
      }
    },

    cfop: function cfop() {
      if (this.unwatch) {
        return;
      }
      if (this.nates.cfop < '4000') {
        this.nates.tpnat = 'E';
        this.nates.sticm = '90';
        this.nates.csosn = '900';
        if (this.nates.cfop == '1101') {
          //compra para industr
          this.nates.finentrada = '1';
        } else if (this.nates.cfop == '1102') {
          //compra para comercializacao
          this.nates.finentrada = '2';
        } else if (this.nates.cfop == '1556') {
          //compra para consumo
          this.nates.finentrada = '3';
        } else if (this.nates.cfop == '1551') {
          //compra de ativo
          this.nates.finentrada = '4';
        } else {
          this.nates.finentrada = '5'; //outras
        }
      } else {
        this.nates.tpnat = 'S';
        this.nates.finentrada = null;
      }
    },

    'nates.stipi': function natesStipi() {
      if (this.nates.stipi != '50' && this.nates.stipi != '99' && this.nates.stipi != '00' && this.nates.stipi != '49') {
        this.nates.ipidevol = 'N';
      }
    }

  },

  methods: {
    closeForm: function closeForm() {
      this.$emit('closeform', this.nates.codnates);
    },
    handleSave: function handleSave() {
      var _this = this;

      //BOTAO SALVAR

      if (this.nates.cfop != null) {
        if (this.nates.tpnat == 'E' && this.nates.cfop > 4000) {
          this.$erpToastError('CFOP inválida para operações de entrada');
          return;
        }
        if (this.nates.tpnat == 'S' && this.nates.cfop < 5000) {
          this.$erpToastError('CFOP inválida para operações de saída');
          return;
        }
      }
      if (this.nates.cfop == null && this.nates.tpnf != 'O') {
        this.$erpToastError('Campo CFOP é obrigatório para o tipo de nota selecionado');
        return;
      }

      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          _this.apiPost();
        }
      });
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var vm;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$store.dispatch('loadNates', { id: _this2.index });

              case 2:
                if (_this2.$store.getters.getNates) {
                  _this2.nates = _extends({}, _this2.$store.getters.getNates);
                }
                _this2.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

                //HABILITAR WATCH
                vm = _this2;

                setTimeout(function () {
                  vm.unwatch = false;
                }, 1000);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    apiDelete: function apiDelete(del) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var modulo, sendData, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                //efetua a exclusao da natureza

                modulo = 'cg/nates/' + _this3.nates.codnates;
                sendData = {};
                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

              case 4:
                data = _context2.sent;

                _this3.$erpToastDeleted();
                _this3.closeForm();

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    apiPost: function apiPost() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var modulo, sendData, metodo, update, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                //efetua a gravacao do item

                modulo = 'cg/nates/';
                sendData = {};


                sendData = { nates: _this4.nates };

                metodo = 'post';
                update = false;

                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                  metodo = 'put';
                  update = true;
                }

                _context3.next = 8;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

              case 8:
                data = _context3.sent;

                if (data.errmessages) {
                  _this4.errmessages = data.errmessages;
                  _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                } else {
                  if (update) {
                    _this4.$erpToastUpdated();
                  } else {
                    _this4.$erpToastInserted();
                  }
                  if (data.items) {
                    _this4.nates = data.items[0];
                  }
                  _this4.errmessages = {};
                  _this4.closeForm();
                }

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  },

  components: {},

  beforeCreate: function beforeCreate() {},
  created: function created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });

    this.metadata.nates.cfop.validator = { required: true };

    this.crudText = this.$crudText(this.crud);

    if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
      this.nates.tpnat = 'S';
      this.nates.stnates = 'A';
      this.nates.calcicm = 'N';
      this.nates.calcicmfre = 'S';
      this.nates.calcicmdesp = 'S';
      this.nates.calcdesicm = 'N';
      this.nates.calcst = 'N';
      this.nates.calcipi = 'N';
      this.nates.calcipifre = 'N';
      this.nates.calcipidesp = 'N';
      this.nates.calcpis = 'N';
      this.nates.calccofins = 'N';
      this.nates.calcdespc = 'N';
      this.nates.calcii = 'N';
      this.nates.creicm = 'N';
      this.nates.crepis = 'N';
      this.nates.crecofins = 'N';
      this.nates.creipi = 'N';
      this.nates.movfisica = 'S';
      this.nates.ativofixo = 'N';
      this.nates.integrafis = 'S';
      this.nates.integracont = 'S';
      this.nates.tpcustonates = 'P';
      this.nates.calcreten = 'N';
      this.nates.tpnf = 'V';
      this.nates.calcdup = 'S';
      this.nates.calccomi = 'N';
      this.nates.movest = 'S';
      this.nates.movterc = 'N';
      this.nates.calcdescicm = 'N';
      this.nates.calcaprovcred = 'N';
      this.nates.bonif = 'N';
      this.nates.consumo = 'N';
      //this.setWatch()
    } else {
      this.loadData();
    }
    this.$nextTick(function () {
      this.$refs.descricao.focus();
    });
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__estado_form__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            uf: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: ''
        };
    },


    computed: {
        estadoList: function estadoList() {
            return this.$store.getters.getEstadoList;
        }
    },

    methods: {
        handleEdit: function handleEdit(uf) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.uf = uf;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.uf = '';
            this.showForm = true;
        },
        closeForm: function closeForm() {
            this.showForm = false;
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"uf":{"$like":"%25' + value + '%25"}},{"nomeuf":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadEstado', { filter: this.filter });
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], EstadoForm: __WEBPACK_IMPORTED_MODULE_1__estado_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            estado: _extends({}, this.$store.getters.getEntities.estado),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO Excluir
            this.apiDelete();
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadEstado', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getEstado) {
                                    _this2.estado = _extends({}, _this2.$store.getters.getEstado);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/estado/' + _this3.estado.uf;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/estado/';
                                sendData = {};


                                sendData = { estado: _this4.estado };

                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }
    }
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {

    return {
      crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
      metadata: this.$store.getters.getEntities.metadata,
      filter: ''
    };
  },


  computed: {
    ivaclassList: function ivaclassList() {
      return this.$store.getters.getivaclassList;
    }
  },

  methods: {
    closeForm: function closeForm() {
      this.showForm = false;
    },
    search: function search(value) {
      //efetua a pesquisa
      this.filter = '{"$or":[{"ncm":{"$like":"%25' + value + '%25"}},{"cclass":{"$like":"%25' + value + '%25"}},{"desst":{"$like":"%25' + value + '%25"}},{"nome":{"$like":"%25' + value + '%25"}}]}';
      this.loadData();
    },
    loadData: function loadData() {
      this.$store.dispatch('loadivaclass', { filter: this.filter });
    }
  },

  components: {
    BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"]
  },

  created: function created() {
    this.loadData();
  }
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ivancm_form__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {

    return {
      showForm: false, //exibe a tela de manutencao
      crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
      id: '',
      metadata: this.$store.getters.getEntities.metadata,
      filter: ''
    };
  },


  computed: {
    ivancmList: function ivancmList() {
      return this.$store.getters.getivancmList;
    }
  },

  methods: {
    handleEdit: function handleEdit(id) {
      //abre a tela de edicao
      this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
      this.id = id;
      this.showForm = true;
    },
    handleNew: function handleNew() {
      //inclusao de registro
      this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
      this.id = '';
      this.showForm = true;
    },
    closeForm: function closeForm() {
      this.showForm = false;
      this.loadData();
    },
    search: function search(value) {
      //efetua a pesquisa
      this.filter = '{"$or":[{"ncm":{"$like":"%25' + value + '%25"}},{"cclass":{"$like":"%25' + value + '%25"}}]}';
      this.loadData();
    },
    loadData: function loadData() {
      this.$store.dispatch('loadivancm', { filter: this.filter });
    }
  },

  components: {
    BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], ivancmForm: __WEBPACK_IMPORTED_MODULE_1__ivancm_form__["a" /* default */]
  },

  created: function created() {
    this.showForm = false;
    this.loadData();
  }
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: '',
    crud: ''
  },

  data: function data() {
    return {
      crudText: '',
      ivancm: _extends({}, this.$store.getters.getEntities.ivancm),
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
    };
  },


  computed: {
    editing: function editing() {
      return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
    }

  },

  methods: {
    closeForm: function closeForm() {
      this.$emit('closeform');
    },
    handleSave: function handleSave() {
      var _this = this;

      //BOTAO SALVAR
      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          _this.apiPost();
        }
      });
    },
    handleDelete: function handleDelete() {
      //BOTAO Excluir
      this.apiDelete();
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$store.dispatch('loadivancm', { id: _this2.index });

              case 2:
                if (_this2.$store.getters.getivancm) {
                  _this2.ivancm = _extends({}, _this2.$store.getters.getivancm);
                }
                _this2.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    apiDelete: function apiDelete() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                //efetua a exclusao
                modulo = 'cg/ivancm/' + _this3.ivancm.codivancm;
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

              case 3:
                data = _context2.sent;

                _this3.$erpToastDeleted();
                _this3.closeForm();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    apiPost: function apiPost() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var modulo, sendData, metodo, update, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                //efetua a gravacao

                modulo = 'cg/ivancm/';
                sendData = {};


                sendData = { ivancm: _this4.ivancm };

                metodo = 'post';
                update = false;

                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                  metodo = 'put';
                  update = true;
                }

                _context3.next = 8;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

              case 8:
                data = _context3.sent;

                if (data.errmessages) {
                  _this4.errmessages = data.errmessages;
                  _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                } else {
                  if (update) {
                    _this4.$erpToastUpdated();
                  } else {
                    _this4.$erpToastInserted();
                  }
                  _this4.errmessages = {};
                  _this4.closeForm();
                }

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  },

  components: {},

  beforeCreate: function beforeCreate() {},
  created: function created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });

    this.crudText = this.$crudText(this.crud);

    if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
      this.loadData();
    }
  }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unimed_form__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            uni: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: ''
        };
    },


    computed: {
        unimedList: function unimedList() {
            return this.$store.getters.getUnimedList;
        }
    },

    filters: {
        getText: function getText(value, metadata) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(value, metadata);
        }

    },

    methods: {
        handleEdit: function handleEdit(uni) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.uni = uni;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.uni = '';
            this.showForm = true;
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"uni":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadUnimedList', { filter: this.filter });
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], UnimedForm: __WEBPACK_IMPORTED_MODULE_1__unimed_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ncm_form__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            ncm: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            nextPage: ''
        };
    },


    computed: {
        ncmList: function ncmList() {
            return this.$store.getters.getNcmList;
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(value, 2);
        }

    },

    methods: {
        handleEdit: function handleEdit(ncm) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.ncm = ncm;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.ncm = '';
            this.showForm = true;
        },
        handleMore: function handleMore() {
            this.offset = 'offset=' + this.$store.getters.getNextPage;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"ncm":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.nextPage = '';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadNcmList', { filter: this.filter, page: this.nextPage });
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], NcmForm: __WEBPACK_IMPORTED_MODULE_1__ncm_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            ncm: _extends({}, this.$store.getters.getEntities.ncm),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO Excluir
            this.apiDelete();
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadNcm', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getNcm) {
                                    _this2.ncm = _extends({}, _this2.$store.getters.getNcm);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/ncm/' + _this3.ncm.ncm;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/ncm/';
                                sendData = {};


                                sendData = { ncm: _this4.ncm };

                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }
    }
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grade_list_vue__ = __webpack_require__(528);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9e47f24_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grade_list_vue__ = __webpack_require__(1483);
function injectStyle (ssrContext) {
  __webpack_require__(1477)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c9e47f24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grade_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9e47f24_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grade_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grade_form__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//
//
//


/*



VUEX -> STORE.JS -> this.$store




*/






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            grade: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: ''
        };
    },


    computed: {
        gradeList: function gradeList() {
            return this.$store.getters.getGradeList;
        },
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(value, 2);
        }

    },

    methods: {
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.codgrade = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codgrade = '';
            this.showForm = true;
        },
        handleMore: function handleMore() {
            this.offset = 'offset=' + this.nextPage;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codgrade":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadGrade', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        },
        formataItensGrade: function formataItensGrade(itens) {
            if (!itens) {
                return '';
            }
            var arr = JSON.parse(itens);
            var result = '';
            if (arr.itens && arr.itens.length) {
                for (var x = 0; x < arr.itens.length; x++) {
                    if (result !== '') {
                        result = result + ', ';
                    }
                    result = result + arr.itens[x];
                }
            }

            return result;
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], GradeForm: __WEBPACK_IMPORTED_MODULE_1__grade_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    components: {},

    data: function data() {
        return {
            crudText: '',
            grade: _extends({}, this.$store.getters.getEntities.grade),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
            gradeit: []
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    watch: {},

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.grade.codgrade);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid || _this.variavelValidate()) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            this.apiDelete();
        },
        handleAdicionaVariavel: function handleAdicionaVariavel() {
            //adiciona nova linha na tabela de unidade de medida do item
            var p = { codigo: '', descricao: '' };
            this.gradeit.push(p);

            var index = this.gradeit.length - 1;

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
                this.$refs.descricaoit[index].focus();
            });
        },
        handleDeleteVariavel: function handleDeleteVariavel(index) {
            this.gradeit.splice(index, 1);
        },
        variavelValidate: function variavelValidate() {
            //checa se foi digitado variáveis repetidas
            var test = {};
            //cria novo objeto array para fazer a veiricacao de duplicidades
            var valorArr = this.gradeit.map(function (obj) {
                return { descricao: obj.descricao };
            });
            //efetua a verificacao da duplicidade
            var duplicate = false;
            var validate = '';
            for (var x = 0; x < valorArr.length; x++) {
                test = valorArr[x];
                this.$set(this.gradeit[x], 'duplicate', false);
                if (valorArr.findIndex(function (obj) {
                    return obj.descricao == test.descricao;
                }) < x) {
                    this.gradeit[x].duplicate = true;
                    duplicate = true;
                }
                if (this.gradeit[x].descricao == null || this.gradeit[x].descricao == '') {
                    validate = 'Obrigatório informar a descrição';
                    this.$set(this.gradeit[x], 'validate', validate);
                } else {
                    this.$set(this.gradeit[x], 'validate', '');
                }
            }
            return duplicate || validate != '';
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadGrade', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getGrade) {
                                    _this2.grade = _extends({}, _this2.$store.getters.getGrade);
                                    // this.gradeit = JSON.parse(this.grade.valores)
                                    _this2.gradeit = _this2.grade.gradeit;
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/grade/' + _this3.grade.codgrade;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/grade/';

                                _this4.grade.gradeit = _this4.gradeit;
                                sendData = { grade: _this4.grade };
                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.descricao.focus();
        });
    }
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_gruest_list_vue__ = __webpack_require__(531);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_77c43485_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_gruest_list_vue__ = __webpack_require__(1486);
function injectStyle (ssrContext) {
  __webpack_require__(1484)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77c43485"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_gruest_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_77c43485_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_gruest_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gruest_form__ = __webpack_require__(507);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            gruest: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            currentGru: {},
            codgruest: null
        };
    },


    computed: {
        gruestList: function gruestList() {
            return this.$store.getters.getGruestList;
        }
    },

    filters: {
        format: function format(value) {
            return formatValue(value, 2);
        }

    },

    methods: {
        handleSubgru: function handleSubgru(gruest) {
            //abre a tela de edicao
            this.currentGru = gruest;
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudI;
            this.$set(gruest, 'subgru', true);
        },
        handleEdit: function handleEdit(gruest) {
            //abre a tela de edicao
            this.currentGru = gruest;
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudU;
            this.$set(gruest, 'show', true);
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudI;
            this.showForm = true;
        },
        closeForm: function closeForm() {
            this.currentGru.show = false;
            this.currentGru.subgru = false;
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = 'text=' + value;
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadGruest', { query: this.filter });
            this.offset = '';
        },
        handleDelete: function handleDelete(gruest) {
            //BOTAO Excluir
            this.apiDelete(gruest);
        },
        apiDelete: function apiDelete(gruest) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/gruest/' + gruest.codgruest;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this.$store, modulo);

                            case 3:
                                data = _context.sent;

                                _this.$erpToastDeleted();
                                _this.closeForm();

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], GruestForm: __WEBPACK_IMPORTED_MODULE_3__gruest_form__["a" /* default */]
    },

    mounted: function mounted() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
    },
    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_depo_list_vue__ = __webpack_require__(533);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_61b14bff_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_depo_list_vue__ = __webpack_require__(1489);
function injectStyle (ssrContext) {
  __webpack_require__(1487)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61b14bff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_depo_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_61b14bff_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_depo_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__depo_form__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            deposito: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: ''
        };
    },


    computed: {
        depositoList: function depositoList() {
            return this.$store.getters.getDepositoList;
        },
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(value, 2);
        }

    },

    methods: {
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.coddeposito = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.coddeposito = '';
            this.showForm = true;
        },
        handleMore: function handleMore() {
            this.offset = 'offset=' + this.nextPage;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"coddeposito":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadDeposito', { filter: this.filter, page: this.offset });
            this.offset = '';
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], DepoForm: __WEBPACK_IMPORTED_MODULE_1__depo_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mennf_form__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            mennf: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: ''
        };
    },


    computed: {
        mennfList: function mennfList() {
            return this.$store.getters.getMennfList;
        },
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        }
    },

    methods: {
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.codmennf = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codmennf = '';
            this.showForm = true;
        },
        handleMore: function handleMore() {
            this.offset = 'offset=' + this.nextPage;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codmennf":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadMennf', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], MennfForm: __WEBPACK_IMPORTED_MODULE_1__mennf_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            mennf: _extends({}, this.$store.getters.getEntities.mennf),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.mennf.codmennf);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO Excluir
            this.apiDelete();
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadMennf', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getMennf) {
                                    _this2.mennf = _extends({}, _this2.$store.getters.getMennf);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/mennf/' + _this3.mennf.codmennf;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/mennf/';
                                sendData = {};


                                sendData = { mennf: _this4.mennf };

                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }
    }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_vend_list_vue__ = __webpack_require__(537);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3a13dc_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_vend_list_vue__ = __webpack_require__(1500);
function injectStyle (ssrContext) {
  __webpack_require__(1498)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c3a13dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_vend_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3a13dc_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_vend_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vend_form__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            vend: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: ''
        };
    },


    computed: {
        vendList: function vendList() {
            return this.$store.getters.getVendList;
        },
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        }
    },

    filters: {
        getText: function getText(value, metadata) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(value, metadata);
        }

    },

    methods: {
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.codvend = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codvend = '';
            this.showForm = true;
        },
        handleMore: function handleMore() {
            this.offset = 'offset=' + this.nextPage;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codvend":{"$like":"%25' + value + '%25"}},{"nome":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadVend', { filter: this.filter });
            this.offset = '';
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], VendForm: __WEBPACK_IMPORTED_MODULE_1__vend_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filial_form__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_certificado__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__main__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//









/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            showFormCert: false, //exibe a tela de manutencao do certificado
            showFormLogo: false, //exibe a tela de manutencao do logotipo
            filial: '',
            codfil: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            inicio: true,
            file: {},
            urlImage: '',
            selectedFile: '',
            filialList: {},
            operacao: {}
        };
    },


    computed: {
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        },

        appForcaVendas: function appForcaVendas() {
            return __WEBPACK_IMPORTED_MODULE_6__main__["SysVars"].appForcaVendas;
        },

        usuario: function usuario() {
            return this.$store.getters.getEnv.uuid;
        }

    },

    filters: {
        getText: function getText(value, metadata) {
            return Object(__WEBPACK_IMPORTED_MODULE_5__shared_utils__["getText"])(value, metadata);
        }
    },

    methods: {
        handleGuiaInstalacaoCertificado: function handleGuiaInstalacaoCertificado(cod) {
            //EXIBE O GUIA DE INSTALACAO DO CERTIFICADO DIGITAL
            this.codfil = cod;
            this.showFormCert = true;
        },
        handleClickLogotipo: function handleClickLogotipo(cod) {
            this.$refs.file.value = '';
            this.codfil = cod;
            this.$refs.file.click();
            //document.getElementById('fileInput').click()
        },
        handleUpload: function handleUpload(event) {
            this.selectedFile = event.target.files[0]; //this.$refs.file.files[0]
            this.urlImage = URL.createObjectURL(this.selectedFile);
            this.uploadImage();
        },
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_6__main__["SysVars"].crudU;
            this.codfil = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_6__main__["SysVars"].crudI;
            this.codfil = '';
            this.showForm = true;
        },
        handleMore: function handleMore() {
            this.offset = 'offset=' + this.nextPage;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.showFormCert = false;
            this.showFormLogo = false;
            this.$scrollTo(0);
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codfil":{"$like":"%25' + value + '%25"}},{"nome":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadLogoTipo: function loadLogoTipo(x) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var self, test;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                self = _this;
                                test = x;
                                _context.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSmidia"])(_this.$store.getters.urlApp + 'logo/download/' + _this.filialList[x].codempresa + '/' + _this.filialList[x].codfil).then(function (data) {
                                    if (data && data.size > 0) {
                                        var reader = new window.FileReader();
                                        reader.readAsDataURL(data);
                                        reader.onload = function () {
                                            self.filialList[test].urlimage = reader.result;
                                        };
                                    }
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var self, test, x;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this2.$store.dispatch('loadFilial', { filter: _this2.filter });

                            case 2:
                                _this2.filialList = [].concat(_toConsumableArray(_this2.$store.getters.getFilialList));
                                if (_this2.inicio) {
                                    //FORÇA A INCLUSAO DE UMA FILIAL
                                    if (!_this2.filialList.length || _this2.filialList.length == 0) {
                                        _this2.handleNew();
                                        // } else if (this.appForcaVendas) {
                                        // this.handleEdit(1)
                                    }
                                    if (!_this2.appForcaVendas) _this2.inicio = false;
                                }

                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                                self = _this2;
                                test = 0;


                                for (x = 0; x < _this2.filialList.length; x++) {
                                    _this2.$set(_this2.filialList[x], 'urlimage', null);
                                    _this2.loadLogoTipo(x);
                                }

                                //CARREGA O LOGOTIPO DA EMPRESA

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        data: function data(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_5__shared_utils__["formatDate"])(value);
        },
        uploadImage: function uploadImage() {
            //EFETUA O UPLOAD DO CERTIFICADO

            var formData = new FormData();
            formData.append('file', this.selectedFile);

            var url = this.$store.getters.urlApp + 'logo/';

            var self = this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'codfilial': this.codfil,
                    'filename': this.selectedFile.name
                }
            }).then(function (data) {
                self.$erpToastSuccess('O logotipo foi atualizado com sucesso.');
                self.closeForm();
            });
        },
        handleRemoverImagem: function handleRemoverImagem(filial) {
            this.apiDeleteImage(filial);
        },
        apiDeleteImage: function apiDeleteImage(filial) {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //EFETUA A EXCLUSAO DO LOGOTIPO
                                modulo = 'logo/' + filial.codlogotipo;
                                _context3.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSapp"])(_this3, modulo, 'delete');

                            case 3:
                                data = _context3.sent;

                                filial.urlimage = null;
                                _this3.$erpToastSuccess('O Logotipo foi removido com sucesso.');

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], FilialForm: __WEBPACK_IMPORTED_MODULE_1__filial_form__["default"], AppCertificado: __WEBPACK_IMPORTED_MODULE_2__app_certificado__["default"]
    },

    created: function created() {
        this.showForm = false;
        var self = this;
        this.loadData().then(function () {
            if (self.$route.params && self.$route.params.operacao) {
                self.operacao = self.$route.params.operacao; //numero do pedido de venda

                if (self.operacao == 'certificado' && self.filialList.length && self.filialList.length > 0) {
                    self.handleGuiaInstalacaoCertificado(self.filialList[0].codfil);
                }
            }
        });
    }
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_filter_list__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pedido_form__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pedido_filtro__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_pedido_impressao_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__shared_utils__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//











/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codpedv: '',
            filter: '',
            offset: false,
            monthQuery: '',
            textQuery: '',
            statusQuery: '',
            filterList: [],
            paramFilterList: {},
            metadata: this.$store.getters.getEntities.metadata,

            monthFilter: {},

            query: {
                codusuario: null,
                codequipe: null,
                text: null,
                after: null,
                before: null,
                codstatus: null
            },

            partOptions: [{ id: 'C', text: 'Cliente' }, { id: 'F', text: 'Fornecedor' }, { id: 'T', text: 'Transportadora' }],

            usingFiltros: false,

            paramsFiltro: {
                periodos: [{
                    label: "Data Pedido / Orçamento",
                    nome: "dta",
                    varios: false,
                    values: [{
                        data_inicio: null,
                        data_termino: null
                    }]
                }, {
                    label: "Data da validade (Orçamentos)",
                    nome: "dtvalidade",
                    varios: false,
                    values: [{
                        data_inicio: null,
                        data_termino: null
                    }]
                }],

                selects: [{
                    label: "Dias Validade (Orçamentos)",
                    nome: "diasvalidade",
                    placeholder: "Tipo dias validade",
                    id: null,
                    value: null,
                    value_label: "em até",
                    value_placeholder: "Quantidade de Dias Validade (Orçamentos)",
                    options: [{
                        id: "0",
                        text: "Vencidos"
                    }, {
                        id: "1",
                        text: "À vencer"
                    }]
                }],

                filtros: [
                    /*
                      {
                        nome: "filial",
                        label: null,
                        url: null,
                        varios: false,
                        values: []
                        },
                      {
                        nome: "segmento",
                        label: null,
                        url: null,
                        varios: true,
                        values: [],
                      },
                      {
                        nome: "grupocliente",
                        label: null,
                        url: null,
                        varios: true,
                        values: [],
                      },
                      {
                        nome: "estado",
                        label: null,
                        url: null,
                        varios: true,
                        values: []
                      },
                      */
                ]
            },

            codpedvImpressao: null,
            showImpressao: false
        };
    },

    computed: {
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        },

        notFound: function notFound() {
            return 'Nenhum pedido encontrado para o período ' + Object(__WEBPACK_IMPORTED_MODULE_8__shared_utils__["formatDate"])(this.monthFilter.startDate) + ' a ' + Object(__WEBPACK_IMPORTED_MODULE_8__shared_utils__["formatDate"])(this.monthFilter.endDate);
        },

        pedvList: function pedvList() {
            return this.$store.getters.getPedvList;
        },

        pedvTotal: function pedvTotal() {
            return this.$store.getters.getPedvTotal;
        },
        bloqueia_alterar_pedido: function bloqueia_alterar_pedido() {
            if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) return this.$store.getters.getParametrosUsuario.vendas.bloqueia_alterar_pedido;else return false;
        }

    },

    watch: {
        pedvTotal: function pedvTotal() {

            //AQUI MONTA O OBJETO PARA A LISTA DE FILTROS DO COMPONENTE filter-list BASEADO NO OBJETO DE TOTAIS CARREGADO DO SERVIDOR

            this.filterList = [];
            var total = {};

            var tot = 0;

            if (this.pedvTotal.length > 0 && this.pedvTotal[this.pedvTotal.length - 1].status == 'TOTAL') {
                tot = this.pedvTotal[this.pedvTotal.length - 1].total;
            }

            for (var i = 0; i < this.pedvTotal.length; i++) {
                total = {};
                total.label = '';
                total.total = this.pedvTotal[i].total;
                total.qt = this.pedvTotal[i].qt;
                total.status = this.pedvTotal[i].status;
                if (total.status == 'ORCAMENTO') {
                    total.label = 'Orçamentos';
                } else if (total.status == 'PERDIDO') {
                    total.label = 'Orçamentos Perdidos';
                } else if (total.status == 'VENDA') {
                    total.label = 'Vendas';
                } else if (total.status == 'TOTAL') {
                    total.label = 'Total Geral';
                }

                //calcula o % em relacao ao total
                if (tot > 0) {
                    total.perc = total.total / tot * 100;
                }

                this.filterList.push(_extends({}, total));
            }

            this.paramFilterList = { total: this.filterList, selectedStatus: '' };
        }

    },

    filters: {},

    methods: {
        scroll: function scroll() {
            var _this = this;

            window.onscroll = function () {
                if (_this.showForm || _this.showImpressao || _this.offset || _this.nextPage == 0) return;
                var bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= document.documentElement.offsetHeight - 2;

                if (bottomOfWindow) {
                    _this.offset = true;
                    _this.loadData(true);
                }
                __WEBPACK_IMPORTED_MODULE_7__main__["SysVars"].scrollPosition = document.documentElement.scrollTop;
            };
        },
        notFoundMsg: function notFoundMsg() {
            if (this.query.filtros) {
                return 'Nenhum pedido encontrado para o período';
            } else {
                return 'Nenhum pedido encontrado para o período ' + Object(__WEBPACK_IMPORTED_MODULE_8__shared_utils__["formatDate"])(this.monthFilter.startDate) + ' a ' + Object(__WEBPACK_IMPORTED_MODULE_8__shared_utils__["formatDate"])(this.monthFilter.endDate);
            }
        },
        changeFiltros: function changeFiltros(filtros) {
            this.query.text = null;
            this.query.filtros = filtros;
            this.loadData();
        },


        statusColor: function statusColor(stpedv, tppedv) {
            var color = 'badge-green';
            if (stpedv == 'C' || stpedv == 'R' || tppedv == 'R') {
                color = 'badge-red';
            } else if (stpedv == 'F') {
                color = 'badge-blue';
            } else if (tppedv == 'O') {
                color = 'badge-orange';
            } else if (tppedv == 'P') {
                color = 'badge-green';
            }
            return color;
        },
        handleEditPedido: function handleEditPedido(codpedv, view) {
            //abre a tela de edicao
            if (view) {
                this.crud = __WEBPACK_IMPORTED_MODULE_7__main__["SysVars"].crudView;
            } else {
                this.crud = __WEBPACK_IMPORTED_MODULE_7__main__["SysVars"].crudU; //operacao de edicao
            }
            this.codpedv = codpedv; //numero do pedido
            this.showForm = true; //exibe o form de manutencao
        },
        handleAction: function handleAction(act, codpedv) {
            if (act == 1) {
                //imprimir
                this.codpedvImpressao = codpedv;
                this.showImpressao = true;
                this.$nextTick(function () {
                    this.$refs.impressao.print();
                });
            } else if (act == 2) {
                //faturar
                this.$router.push('/nf/' + codpedv);
            } else if (act == 10) {
                //enviar cobranca
                this.$router.push('/banking?codpedv=' + codpedv);
            }
        },
        handleClosePrint: function handleClosePrint() {
            this.showImpressao = false;
        },
        handleNovoPedido: function handleNovoPedido() {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_7__main__["SysVars"].crudI; //operacao de inclusao
            this.codpedv = '';
            this.$store.dispatch('cleanpart');
            this.showForm = true; //exibe o form de manutencao
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.$scrollTo(0);
            this.loadData();
        },
        textSearch: function textSearch(value) {
            //efetua a pesquisa por texto
            //let str = value.toUpperCase()
            // this.filter = '{"$or":[{"nome":{"$like":"%25' + str + '%25"}},{"npedido":{"$like":"%25' + str + '%25"}}]}'
            //this.textQuery = 'text=' + str
            //this.monthQuery = ''
            this.query.text = value.toUpperCase();
            this.query.after = null;
            this.query.before = null;
            this.query.filtros = null;
            this.loadData();
        },
        handleChangeFilter: function handleChangeFilter(filter, startDate, endDate) {
            //aplicação do filtro avancado
            // FILTRO ORDS DESABILITADO NESTA LISTA this.filter = filter

            //console.log(startDate)
            //if (startDate && endDate)
            //  this.monthQuery = 'after=' + startDate + '&before=' + endDate
            //else
            //  this.monthQuery = ''
            //this.textQuery = ''
            //this.loadData()
            this.query.after = null;
            this.query.before = null;
            if (startDate) this.query.after = startDate;
            if (endDate) this.query.before = endDate;
            this.query.text = null;
            this.query.filtros = null;
            this.loadData();
        },
        handleFilterList: function handleFilterList(status) {
            //CLICK DO FILTER LIST
            if (status === 'TOTAL') {
                this.statusQuery = '';
            } else {
                this.statusQuery = 'status=' + status;
            }
            this.loadData();
        },
        loadData: function loadData(nottotal) {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var param;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                param = {};

                                param.query = '';

                                if (_this2.query.text) param.query = param.query + 'text=' + _this2.query.text + '&';
                                if (_this2.query.after) param.query = param.query + 'after=' + _this2.query.after + '&';
                                if (_this2.query.before) param.query = param.query + 'before=' + _this2.query.before + '&';
                                if (_this2.query.codusuario) param.query = param.query + 'usuario=' + _this2.query.codusuario + '&';
                                if (_this2.query.codequipe) param.query = param.query + 'equipe=' + _this2.query.codequipe + '&';
                                if (_this2.query.codstatus) param.query = param.query + 'codstatus=' + _this2.query.codstatus + '&';
                                if (_this2.statusQuery) param.query = param.query + _this2.statusQuery + '&';
                                if (_this2.offset) param.query = param.query + 'poffset=' + _this2.nextPage + '&';

                                param.query = param.query.trim();
                                if (param.query.endsWith('&')) param.query = param.query.slice(0, -1);

                                _this2.usingFiltros = false;
                                if (_this2.query.filtros) {
                                    param.body = JSON.stringify(_this2.query.filtros);
                                    _this2.usingFiltros = true;
                                }

                                // console.log(param)
                                _this2.$store.dispatch('loadPedvList', param);
                                _this2.offset = false;

                                if (!nottotal) _this2.$store.dispatch('loadPedvTotal', param);

                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 18:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        textST: function textST(st, tipo) {
            var text = 'Pedido';
            if (tipo == 'O') {
                text = 'Orçamento';
            } else if (tipo == 'R') {
                text = 'Orçamento Perdido';
                return text;
            }
            if (st == 'C') {
                text = text + ' Cancelado';
            } else if (st == 'R') {
                text = text + ' Rejeitado';
            } else if (st == 'A') {
                text = text + ' Em Aprovação';
            } else if (st == 'F') {
                text = text + ' Faturado';
            }
            return text;
            // return getText(value, this.metadata.pedv.stpedv)
        },
        textTP: function textTP(value) {
            var item = this.metadata.pedv.tppedv.options.filter(function (x) {
                return x.id === value;
            });
            if (item.length) {
                return item[0].text;
            }
        },
        enablePrint: function enablePrint(st) {
            return st === 'P' || st == 'F';
        },
        enableEdit: function enableEdit(st, cieloidsuperlink, vendarecebida, tp) {
            var result = false;

            if ((st === 'P' || st === 'D') && !(vendarecebida == 'S')) result = true;

            if (tp === 'P' && this.bloqueia_alterar_pedido) result = false;

            return result;
        },
        enableFaturar: function enableFaturar(st, tp) {
            return st === 'P' && tp === 'P'; //somente pedido pendente
        },
        getActions: function getActions(item) {
            var moreActions = [];
            var act = {};
            if (item.stpedv === 'P') {
                act = { action: 2, label: 'Imprimir/PDF' };
                moreActions.push(act);
                act = { action: 6, label: 'Enviar Email' };
                moreActions.push(act);
            }

            if (item.emitecobranca == 'S') {
                act = { action: 10, label: 'Enviar Cobrança' };
                moreActions.push(act);
            }

            if (moreActions.length > 0) {
                return moreActions;
            } else {
                return null;
            }
        },
        orcamentoVencido: function orcamentoVencido(item) {
            return item.tppedv == 'O' && item.stpedv == 'P' && item.dtvalidade && new Date(item.dtvalidade).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], FilterList: __WEBPACK_IMPORTED_MODULE_2__components_filter_list__["a" /* default */], PedidoForm: __WEBPACK_IMPORTED_MODULE_3__pedido_form__["default"], PedidoFiltro: __WEBPACK_IMPORTED_MODULE_4__components_pedido_filtro__["a" /* default */], PedidoImpressao: __WEBPACK_IMPORTED_MODULE_5__forms_pedido_impressao_vue__["default"]
    },

    mounted: function mounted() {
        this.query.after = Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiDateORDS"])(this.monthFilter.startDate);
        this.query.before = Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiDateORDS"])(this.monthFilter.endDate, true);
        this.query.text = null;
        this.query.filtros = null;
        this.loadData();
        this.showForm = false;
        this.scroll();
    },
    created: function created() {
        //this.$store.dispatch('clearItemSales')

        //carrega parametros do usuario para bloqueio das tabelas de precos
        this.$store.dispatch('loadParametrosUsuario');
    },
    destroyed: function destroyed() {
        window.onscroll = null;
    }
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: Object
    },

    data: function data() {
        return {
            selectedIndex: -1
        };
    },


    computed: {
        cols: function cols() {
            if (!this.params || !this.params.total || !this.params.total.length) {
                return '';
            } else if (this.params.total.length == 2) {
                return 'filter-list-2col';
            } else if (this.params.total.length == 3) {
                return 'filter-list-3col';
            } else if (this.params.total.length == 4) {
                return 'filter-list-4col';
            } else if (this.params.total.length == 5) {
                return 'filter-list-5col';
            } else if (this.params.total.length == 6) {
                return 'filter-list-6col';
            }
        }

    },

    methods: {
        handleSelect: function handleSelect(index) {
            //envia para o chamador o status selecionado
            console.log(this.selectedIndex);
            if (this.selectedIndex === index) {
                this.params.selectedStatus = '';
                this.selectedIndex = -1;
            } else {
                this.selectedIndex = index;
            }
            if (this.selectedIndex === -1) {
                this.$emit('select', '');
            } else {
                this.$emit('select', this.params.total[index].status);
            }
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(value, 2);
        }
    },

    created: function created() {}
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_form_vue__ = __webpack_require__(542);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_04c9f672_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_form_vue__ = __webpack_require__(1543);
function injectStyle (ssrContext) {
  __webpack_require__(1510)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04c9f672"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_04c9f672_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_numbers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_numbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_numbers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pedido_addlist__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pedido_additem__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pedido_titulos__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pedido_form_infcpl__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__forms_pedido_impressao_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__customer_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__nates_form__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__customer_contato_form__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__vend_form__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_grade__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_anexos_form__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__forms_estoque_estoque_saida__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_tourguidejs__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_tourguidejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_tourguidejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_api_nfe_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_api_nfe_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__api_api_nfe_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api_api_pedido_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api_api_pedido_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__api_api_pedido_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//























/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: '',
    crud: ''
  },

  components: {
    Trap: __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default.a, PedidoAdditem: __WEBPACK_IMPORTED_MODULE_6__pedido_additem__["a" /* default */], PedidoTitulos: __WEBPACK_IMPORTED_MODULE_7__pedido_titulos__["a" /* default */], PedidoAddlist: __WEBPACK_IMPORTED_MODULE_5__pedido_addlist__["a" /* default */], PedidoFormInfcpl: __WEBPACK_IMPORTED_MODULE_8__pedido_form_infcpl__["a" /* default */], CustomerForm: __WEBPACK_IMPORTED_MODULE_10__customer_form__["default"],
    NatesForm: __WEBPACK_IMPORTED_MODULE_11__nates_form__["a" /* default */], CustomerContatoForm: __WEBPACK_IMPORTED_MODULE_12__customer_contato_form__["a" /* default */], grade: __WEBPACK_IMPORTED_MODULE_14__components_grade__["a" /* default */], AnexosForm: __WEBPACK_IMPORTED_MODULE_15__components_anexos_form__["a" /* default */], EstoqueSaida: __WEBPACK_IMPORTED_MODULE_16__forms_estoque_estoque_saida__["a" /* default */], PedidoImpressao: __WEBPACK_IMPORTED_MODULE_9__forms_pedido_impressao_vue__["default"], Tourguide: __WEBPACK_IMPORTED_MODULE_17_tourguidejs___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_19__api_api_pedido_js___default.a, __WEBPACK_IMPORTED_MODULE_18__api_api_nfe_js___default.a],

  data: function data() {
    return {
      crudText: '',

      view: false, //variavel para controle de visualizacao ou edicao
      formNew: false, //incluindo novo pedido
      showFormInfAd: false, //editando cabecalho
      formPar: false, //editando parcelas
      formOrder: false,
      showFormItem: false, //exibe o formulario de manutencao de item
      showPartForm: false, //exibe o formulario de cliente para inclusao
      showVendForm: false, //exibe o formulario de vendedor para inclusao
      showNatesForm: false, //exibe o formulario de naturezas para inclusao
      showContatoForm: false, //exibe o formulario de contato do cliente para inclusao
      showFormEmail: false, //exibe o formulario para envio de email
      showTotal: false,
      btEnviar: false,
      btImprimir: false,
      btFaturar: false,
      btCancelar: false,
      formItemView: false,
      CANCEL_ITEM_MESSAGE: false,
      DELETE_ITEM_MESSAGE: false,
      CANCEL_MESSAGE: false,

      showListaDestaques: false,

      isValidCabec: true,

      updateItem: false, //indica quando for uma alteracao de item

      hasPriceTab: false, //indica que possui tabela de preço e o campo preço será desabilitado

      //entidades
      pedv: _extends({}, this.$store.getters.getEntities.pedv),
      pedvit: [],
      pedvpar: [], //parcelas do pedido
      pedvit_update: {},
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: {}, //armazena as mensagens de validacao do pedido de venda apos a gravacao

      anexos: [], //lista de anexos do pedido
      showAnexo: false,

      itped: 0, //sequencial do item
      moreActions: [], //botao mais acoes

      unwatch: true,

      partTabela: false,
      partCodTabpre: null,

      showFormAlocacao: false,
      controleEstoqueAtivado: false,
      excluirAlocacao: false,

      local_metadata: {
        "fieldname": "tppedv",
        "label": "Tipo de Documento",
        "length": 1, "decimals": 0, "pk": "False", "options": [{ "id": "O", "text": "Orçamento" }, { "id": "P", "text": "Pedido de Venda" }]
      },

      codpedvImpressao: null,
      showImpressao: null,

      hasManyPedidos: false,
      steps: [{
        "selector": "",
        "step": 1,
        "title": 'Vamos come\xE7ar!',
        "content": "Vamos te guiar passo a passo por todo o processo de lançamento de pedido.</br></br><a href='javascript:void(0)' class='btn btn-sm btn-danger text-white' onclick='window.dispatchEvent(new CustomEvent(\"desativar-guia\"))'>Não mostrar este guia</a>"
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#part",
        "step": 2,
        "title": 'Cliente',
        "content": "Informe o cliente do pedido."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#codnates",
        "step": 3,
        "title": 'Natureza de Opera\xE7\xE3o',
        "content": "Informe a natureza de operação do pedido."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#produtos",
        "step": 4,
        "title": 'Produtos',
        "content": "Adicione os itens ao pedido."
        // "image": "https://somehost.com/image.jpeg"
      }]

    };
  },


  computed: {

    orcamentoVencido: function orcamentoVencido() {
      return this.pedv.tppedv == 'O' && this.pedv.stpedv == 'P' && this.pedv.dtvalidade && new Date(this.pedv.dtvalidade).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);
    },

    alocacaoEfetuada: function alocacaoEfetuada() {
      if (this.pedv.alocado == 'S') return 'Pedido com estoque alocado. Para efetuar alterações será necessário excluir a alocação.';else return null;
    },

    alocacaoPendente: function alocacaoPendente() {
      if (this.controleEstoqueAtivado && this.pedv.tppedv == 'P' && this.pedv.movest == 'S' && this.pedv.alocado != 'S') return 'Efetue a alocação do estoque dos produtos. O pedido não poderá ser alterado após a alocação.';else return null;
    },

    botaoAlocarProdutos: function botaoAlocarProdutos() {
      return this.controleEstoqueAtivado && this.pedv.tppedv == 'P' && this.pedv.movest == 'S' && this.pedv.alocado != 'S';
    },

    botaoGerarPedido: function botaoGerarPedido() {
      return this.pedv.tppedv == 'O' && !this.pedv.codnegocio && !this.bloqueia_gerar_pedido;
    },

    botaoPerdido: function botaoPerdido() {
      return this.pedv.tppedv == 'O' && !this.pedv.codnegocio;
    },

    possuiListaDestaqueValida: function possuiListaDestaqueValida() {
      if (!this.$store.getters.getDestaqList.length) return false;else {
        return this.$store.getters.getDestaqList.filter(function (obj) {
          return obj.isvalid == 'S';
        }).length > 0;
      }
    },

    showPesquisaItens: function showPesquisaItens() {
      return !this.isView && this.pedv.codpart && this.pedv.codnates && !this.showFormItem;
    },

    showTitulosPedido: function showTitulosPedido() {
      return this.crud != __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI && this.pedv.stpedv == 'P' && this.pedv.fin && this.pedv.fin.length > 0;
    },

    select2Contato: function select2Contato() {
      return { entity: 'partcontato/' + this.pedv.codpart, minlength: 0 };
    },

    isView: function isView() {
      //NAO PERMITE ALTERACAO NO PEDIDO QUANDO HÁ TITULOS ENVIADOS, TITULOS BAIXADOS OU NOTA LANÇADA
      return this.view || this.pedv.alocado == 'S' || this.pedv.tppedv == 'R' || this.pedv.stpedv != 'D' && this.pedv.stpedv != 'P' || this.pedv.fin_baixado > 0 || this.pedv.fin_remessa > 0 || this.pedv.nf_emitida > 0 || this.pedv.nf_pendente > 0;
    },

    btTotalizar: function btTotalizar() {
      return this.pedv.stpedv == 'D' && this.pedvit && this.pedvit.length > 0;
    },

    bloqueia_gerar_pedido: function bloqueia_gerar_pedido() {
      if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) return this.$store.getters.getParametrosUsuario.vendas.bloqueia_gerar_pedido;else return false;
    },

    tabelas_preco_options: function tabelas_preco_options() {
      //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
      var options = [];

      var liberado = [];
      var currTabpre = {};
      var addTabela = false;

      for (var x = 0; x < this.$store.getters.getTabpreList.length; x++) {
        currTabpre = this.$store.getters.getTabpreList[x];

        //se existir parametros do usuario, libera somente as tabelas permitidas
        if (this.partCodTabpre && this.partCodTabpre == currTabpre.codtabpre) addTabela = true;else if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.length > 0) {
          liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter(function (obj) {
            return obj == currTabpre.codtabpre;
          });
          if (liberado.length > 0) {
            addTabela = true;
          }
        } else {
          addTabela = true;
        }

        if (addTabela) options.push({ id: currTabpre.codtabpre, text: currTabpre.descricao });

        addTabela = false;
      }

      return options;
    },

    status_customizados_options: function status_customizados_options() {
      //monta objeto de status atraves do cadastro de status
      if (!this.$store.getters.getPdstatusList.length) {
        return [];
      }
      var options = this.$store.getters.getPdstatusList.map(function (obj) {
        return { id: obj.codstatus, text: obj.descricao };
      });
      return options;
    },

    itemList: function itemList() {
      return this.$store.getters.getItemSalesList;
    },

    codpart: function codpart() {
      return this.pedv.codpart;
    },

    part: function part() {
      return this.$store.getters.getPart;
    },

    selectedNates: function selectedNates() {
      return this.$store.getters.getNates;
    },

    codnates: function codnates() {
      return this.pedv.codnates;
    },

    prazodias: function prazodias() {
      return this.pedv.prazodias;
    },

    prazo: function prazo() {
      return this.pedv.prazo;
    },

    validadedias: function validadedias() {
      return this.pedv.validadedias;
    },

    dtvalidade: function dtvalidade() {
      return this.pedv.dtvalidade;
    },

    parcelas: function parcelas() {
      return this.pedv.parcelas;
    },

    title: function title() {
      if (this.pedv.tppedv === 'P' && this.pedv.npedido === null) {
        return 'Incluindo Pedido';
      } else if (this.pedv.tppedv === 'P') {
        return 'Pedido de Venda [' + this.pedv.npedido + ']';
      } else if (this.pedv.ncotacao === null) {
        return 'Incluindo Orçamento';
      } else {
        return 'Orçamento [' + this.pedv.ncotacao + ']';
      }
    },

    disableTppedv: function disableTppedv() {
      //desabilita o campo tipo de documento este já for pedido de venda
      return this.pedv.tppedv === 'P' && this.pedv.codpedv != null;
    },

    _nomeuf: function _nomeuf() {
      if (this.pedv.part) {
        if (this.pedv.part[0].uf) {
          return this.pedv.part[0].uf;
        } else {
          return this.pedv.part[0].estado[0].uf;
        }
      }
    },

    _nomemun: function _nomemun() {
      if (this.pedv.part) {
        if (this.pedv.part[0].nomemun) {
          return this.pedv.part[0].nomemun;
        } else {
          return this.pedv.part[0].mun[0].nomemun;
        }
      }
    },

    _cnpjcpf: function _cnpjcpf() {
      //FORMATACAO DO CNPJ DO CLIENTE
      var doc = '';
      if (this.pedv.part) {
        doc = this.pedv.part[0].cnpjcpf;
      }
      if (String(doc).length > 11) {
        doc = this.$formatCNPJ(doc);
      } else if (String(doc).length == 11) {
        doc = this.$formatCPF(doc);
      }
      return doc;
    },

    _paramsPesquisa: function _paramsPesquisa() {
      var params = {
        pedvit: this.pedvit,
        pedv: this.pedv
      };
      return params;
    },

    _paramsDestaques: function _paramsDestaques() {
      var params = {
        pedvit: this.pedvit,
        pedv: this.pedv,
        produtosDestaque: true
      };
      return params;
    },
    showGuia: function showGuia() {
      return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].guia;
    },

    emiteCobranca: function emiteCobranca() {
      return this.pedv.emitecobranca === 'S';
    }

  },

  filters: {
    format: function format(value, decimals) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["formatValue"])(value, decimals);
    }
  },

  methods: {
    checkAvisoNaturezaIcmFilialSemIE: function checkAvisoNaturezaIcmFilialSemIE(nates) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var cfopStr, codfil, filial;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!nates || _this.unwatch)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (!(nates.calcicm !== 'S')) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                if (!(nates.tpnf === 'D')) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return');

              case 6:
                cfopStr = String(nates.cfop || '').trim();

                if (!(cfopStr.startsWith('12') || cfopStr.startsWith('22') || cfopStr.startsWith('52') || cfopStr.startsWith('62'))) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return');

              case 9:
                codfil = (_this.pedv ? _this.pedv.codfil : null) || (_this.$store.getters.getFilial ? _this.$store.getters.getFilial.codfil : null);

                if (!codfil) {
                  _context.next = 13;
                  break;
                }

                _context.next = 13;
                return _this.$store.dispatch('loadFilial', { id: codfil });

              case 13:
                filial = _this.$store.getters.getFilial;

                if (filial && (!filial.iest || String(filial.iest).trim() === '')) {
                  _this.$erpToastWarning('Aviso: A filial emitente não possui Inscrição Estadual (contribuinte exclusivo IBS/CBS) e a natureza selecionada calcula ICMS. Operações com destaque de ICMS são rejeitadas pela SEFAZ (NT 2026.007), exceto em devoluções.');
                }

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updateImpInfGeraisGarantia: function updateImpInfGeraisGarantia(value) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var modulo, data_json, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.pedv.codpedv) {
                  _context2.next = 9;
                  break;
                }

                modulo = 'sales/pedv/' + _this2.pedv.codpedv + '/impinfgeraisgarantia';
                data_json = {};

                data_json.codpedv = _this2.pedv.codpedv;
                data_json.impinfgeraisgarantia = value;

                _context2.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this2.$store, modulo, data_json, 'post');

              case 7:
                data = _context2.sent;

                if (data && data.errormessage) {
                  console.log(data.validacao);
                  _this2.$erpToastError('Erro ao enviar o pedido para remessa');
                }

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    closeAlocacaoForm: function closeAlocacaoForm() {
      this.$modalForm(false);
      this.showFormAlocacao = false;
      this.excluirAlocacao = false;
      this.loadData(this.pedv.codpedv);
    },
    handleAlocacao: function handleAlocacao() {
      this.$modalForm(true);
      this.showFormAlocacao = true;
    },
    handleExcluirAlocacao: function handleExcluirAlocacao() {
      this.$modalForm(true);
      this.excluirAlocacao = true;
      this.showFormAlocacao = true;
    },


    statusColor: function statusColor(value) {
      var color = 'badge-blue';

      if (value == 'C') {
        color = 'badge-red';
      } else if (value == 'D') {
        color = 'badge-orange';
      } else if (value == 'P') {
        color = 'badge-green';
      }

      return color;
    },

    closeForm: function closeForm() {
      if (this.$route.params && this.$route.params.novo == 'guia') this.$router.go(-1);else if (this.$route.params && this.$route.params.novo == 'novo') this.$router.push('/pedidolist');else if (this.$route.params && this.$route.params.novo) this.$router.go(-1);else this.$emit('closeform');
    },
    closePartForm: function closePartForm(id) {
      //ao fechar o formulario de inclusao de clientes
      if (id) this.pedv.codpart = id;
      this.showPartForm = false;
    },
    closeNatesForm: function closeNatesForm(id) {
      //ao fechar o formulario de inclusao de naturezas
      if (id) this.pedv.codnates = id;
      this.showNatesForm = false;
    },
    closeContatoForm: function closeContatoForm(id) {
      //ao fechar o formulario de inclusao de vendedor
      if (id) this.pedv.seqcontato = id;
      this.showContatoForm = false;
    },
    closeNfForm: function closeNfForm() {
      //ao fechar o formulario de faturamento
      this.showNfForm = false;
    },
    handleShowDestaque: function handleShowDestaque() {
      this.showListaDestaques = true;
    },
    closeDestaque: function closeDestaque() {
      this.showListaDestaques = false;
    },
    handleFaturar: function handleFaturar(tipo) {
      console.log(tipo);
      console.log(this.pedv.varejo);
      console.log(this.pedv);

      var self = this;
      //salva o pedido e direciona para o faturamento
      if (tipo = 'NFE' && this.pedv.varejo != 'S') {
        this.gravaPedido().then(function () {
          self.$router.push('/nf/' + self.pedv.codpedv);
        });
        return;
      }
      var esp = '';
      if (tipo == 'NFCe') esp = '65';else esp = '55';

      this.apiGerarNF(esp).then(function () {
        var tipo = self.$certificadoCheck(self.pedv.codfil);
        if (tipo == 'A1') {
          self.autorizaNFeA1(self.pedv.nf, self.NFeResponseCallbackA1).then(function () {});
        } else if (tipo == "A3") {
          self.autorizaNFeA3(self.pedv.nf, self.NFeResponseCallbackA3).then(function () {});
        }
      });
    },
    NFeResponseCallbackA3: function NFeResponseCallbackA3(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
      if (response.status != "success") {
        this.$erpToastError(response.message);
      } else {
        if (response.response && response.response.nf.length > 0 && response.response.nf[0].cstat == "100") {
          this.$erpToastSuccess("NFe Autorizada");
          Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiDownloadPDF"])(this, "print/danfe/" + response.response.nf[0].codnf, null, null, true);
        } else {
          this.$erpToastError(response.response.xmotivo);
          this.$router.push("/nf/" + response.response.nf[0].codnf + "?tipo=view");
        }
      }
    },
    NFeResponseCallbackA1: function NFeResponseCallbackA1(response) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var rejeitada;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                rejeitada = false;

                if (response.data) {
                  if (!response.data.errmessages) {
                    if (response.data.nf.length > 0) {
                      if (response.data.nf[0].cstat != "100") {
                        rejeitada = true;
                      }
                    } else {
                      rejeitada = true;
                    }
                  }
                }

                if (rejeitada) {
                  _this3.$erpToastError('NFe Rejeitada');
                  _this3.$router.push("/nf/" + _this3.pedv.nf.codnf + "?tipo=view");
                }

                //CASO NF-e AUTORIZADA SERÁ ABERTO TELA DE IMPRESSÃO
                if (response.data.nf.length > 0) {
                  if (response.data.nf[0].codnf) {
                    _this3.$erpToastSuccess("NFe Autorizada");
                    Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiDownloadPDF"])(_this3, "print/danfe/" + response.data.nf[0].codnf, null, null, true);
                  }
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleIncluirCliente: function handleIncluirCliente() {
      //exibe tela de cadastro do cliente
      if (this.isView) {
        return;
      }
      this.showPartForm = true;
    },
    handleIncluirNates: function handleIncluirNates() {
      //exibe tela de cadastro da natureza
      if (this.isView) {
        return;
      }
      this.showNatesForm = true;
    },
    handleIncluirVend: function handleIncluirVend() {
      //exibe tela de cadastro do cliente
      if (this.isView) {
        return;
      }
      this.showVendForm = true;
    },
    handleIncluirContato: function handleIncluirContato() {
      if (this.pedv.codpart == null) {
        this.$erpToastError('Selecione um cliente antes de incluir um contato.');
        return;
      }
      this.showContatoForm = true;
    },
    handleContinuar: function handleContinuar() {
      var _this4 = this;

      //BOTAO "CONTINUAR" DA TELA DE INCLUSAO DE PEDIDO
      //EFETUA A VALIDACAO DOS CAMPOS INICIAIS E ABRE OS DEMAIS DADOS DE CABECALHO
      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this4.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else if (_this4.validacaoInicial()) {
          _this4.handleSaveCab();
        }
      });
    },
    validarParcelas: function validarParcelas() {
      var soma = 0;
      for (var x = 0; x <= this.pedvpar.length - 1; x++) {
        if (x > 0) {
          if (this.pedvpar[x].dias < this.pedvpar[x - 1].dias) {
            this.$erpToastError('Os dias da ' + (x + 1) + 'º parcela deve ser maior que da ' + x + 'º parcela .');
            return false;
          }
          if (this.pedvpar[x].dtv < this.pedvpar[x - 1].dtv) {
            this.$erpToastError('O Vencimento da ' + (x + 1) + 'º parcela deve ser maior que da ' + x + 'º parcela .');
            return false;
          }
          if (this.pedvpar[x].vlr <= 0) {
            this.$erpToastError('O Valor da ' + (x + 1) + 'º parcela deve ser maior que 0.');
            return false;
          }
        }
        soma = Number(soma) + Number(this.pedvpar[x].vlr);
        soma = Number(soma.toFixed(2));
      }

      if (this.pedv.stpedv != 'D' && this.pedvpar.length > 0) {
        if (Number(soma) != Number(this.pedv.totger)) {
          this.$erpToastError('O Total das parcelas está diferente do total do pedido.');
          return false;
        }
      }

      return true;
    },
    handleTotalizar: function handleTotalizar(close) {
      //BOTAO TOTALIZAR PEDIDO - EFETUA VALIDACOES E ENCERRA A DIGITACAO DO PEDIDO (PEDIDO PASSA PARA STATUS PENDENTE)
      if (this.pedvit && this.pedvit.length == 0) {
        this.$erpToastError('O pedido não possui nenhum item. Por favor adicione itens no pedido.');
        return;
      }

      if (!this.validarParcelas()) {
        return;
      }

      if (this.pedv.parcelas == null) {
        this.pedv.parcelas = 0;
      }
      //if (!close) {
      //    this.calculaParcelas()
      //}
      this.pedv.stpedv = 'P';
      var self = this;
      this.gravaPedido().then(function () {
        if (close) {
          self.closeForm();
        } else {
          if (self.$refs.parcelas) {
            self.$refs.parcelas.focus();
            self.loadControleEstoqueFilial(self.pedv.codfil);
            var elmnt = document.getElementById("parcelas");
            elmnt.scrollIntoView(); //POSICIONA NO ELEMENTO CONDICAO DE PAGAMENTO
          }
        }
      });
    },
    loadControleEstoqueFilial: function loadControleEstoqueFilial(codfil) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var parametros, filial;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (codfil) {
                  _context4.next = 3;
                  break;
                }

                _this5.controleEstoqueAtivado = false;
                return _context4.abrupt('return');

              case 3:
                parametros = {};
                _context4.next = 6;
                return _this5.$store.dispatch('loadFilial', { id: codfil });

              case 6:
                if (_this5.$store.getters.getFilial) {
                  filial = _this5.$store.getters.getFilial;

                  if (filial.parametros) {
                    parametros = JSON.parse(filial.parametros);
                  }
                }
                _this5.controleEstoqueAtivado = parametros.controlaestoque;

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    getParcelasFormapagParametrosFilial: function getParcelasFormapagParametrosFilial(codfil) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var parametros, filial;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (codfil) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt('return', '99');

              case 2:
                parametros = {};
                _context5.next = 5;
                return _this6.$store.dispatch('loadFilial', { id: codfil });

              case 5:
                if (_this6.$store.getters.getFilial) {
                  filial = _this6.$store.getters.getFilial;

                  if (filial.parametros) {
                    parametros = JSON.parse(filial.parametros);
                  }
                }

                if (!parametros) {
                  _context5.next = 10;
                  break;
                }

                if (!parametros.parcelas) {
                  _context5.next = 10;
                  break;
                }

                if (!parametros.parcelas.formapag) {
                  _context5.next = 10;
                  break;
                }

                return _context5.abrupt('return', parametros.parcelas.formapag);

              case 10:
                return _context5.abrupt('return', '99');

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    handleGerarPedido: function handleGerarPedido() {
      //BOTAO PARA TRANSFORMAR O PEDIDO EM ORÇAMENTO
      if (this.pedvit && this.pedvit.length == 0) {
        this.$erpToastError('O pedido não possui nenhum item. Por favor adicione itens no pedido.');
        return;
      }
      if (!this.validarParcelas()) {
        return;
      }

      var self = this;
      this.gravaPedido('gerarpedido').then(function () {
        self.loadControleEstoqueFilial(self.pedv.codfil);
        self.$erpToastSuccess('O pedido foi gerado');
      });
    },
    handleOrcamentoPedido: function handleOrcamentoPedido() {
      //BOTAO PARA TRANSFORMAR O PEDIDO EM ORÇAMENTO
      if (this.pedvit && this.pedvit.length == 0) {
        this.$erpToastError('O pedido não possui nenhum item. Por favor adicione itens no pedido.');
        return;
      }
      if (!this.validarParcelas()) {
        return;
      }

      if (confirm("Confirma orçamento perdido?")) {
        var self = this;
        this.gravaPedido('perdido').then(function () {
          self.$erpToastError('Orçamento perdido');
        });
      }
    },
    handleInfAdicionais: function handleInfAdicionais() {
      //click do botao outras informacoes exibe a tela com dados para alteracao
      this.showFormInfAd = true;
    },
    handleSaveCab: function handleSaveCab() {
      //botao salvar dados de cabecalho
      if (this.isView) {
        return;
      }
      this.gravaPedido();
      if (this.errmessages.length) {
        //se retornou erros continua parado na mesma tela
      } else {
        this.formNew = false;
        this.formOrder = true;
        this.showFormInfAd = false;
        this.formItemsPedido = true;
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },
    handleCopia: function handleCopia() {
      //efetua a copia do pedido
      this.apiDuplica();
    },
    handleAddItem: function handleAddItem() {
      //inclusao de item individual
      if (this.isView) {
        this.$erpToastError('Não permitido');
        return;
      }

      this.pedvit_update = _extends({}, this.$store.getters.getEntities.pedvit), this.pedvit_update.pdesc1 = this.pedv.pdesc1;
      this.pedvit_update.pdesc2 = this.pedv.pdesc2;
      this.pedvit_update.pdesc3 = this.pedv.pdesc3;
      this.pedvit_update.pdesc4 = this.pedv.pdesc4;
      this.pedvit_update.finalidade = this.pedv.finalidade;
      this.updateItem = false;
      this.showFormItem = true;
    },
    closeFormItem: function closeFormItem() {
      //fecha tela de inclusao de item
      this.showFormItem = false;
      this.showFormInfAd = false;
      this.formOrder = true;
    },
    handleSalvarItens: function handleSalvarItens(pedvit) {
      //efetua a inclusao de item no pedido
      if (this.pedvit && pedvit.length == 0) {
        return;
      }
      this.showFormItem = false;
      this.formOrder = true;

      var itens = [];

      if (pedvit.length) {
        //se receber uma lista de itens, ajusta a lista para efetuar gravacao
        for (var x = 0; x < pedvit.length; x++) {
          if (pedvit[x].codpedv) {
            itens.push(pedvit[x]);
          } else {
            var it = _extends({}, this.$store.getters.getEntities.pedvit);
            // it.codpedv = this.pedv.codpedv
            it.coditem = pedvit[x].coditem;
            it.vlr = pedvit[x].vlr;
            it.uni = pedvit[x].uni;
            it.qtuni = pedvit[x].qtuni;
            it.pedvgrade = pedvit[x].pedvgrade;
            if (pedvit[x].tabelas_desconto) it.descontotab = pedvit[x].tabelas_desconto.descontos;
            it.pdesc1 = pedvit[x].pdesc1;
            it.pdesc2 = pedvit[x].pdesc2;
            it.pdesc3 = pedvit[x].pdesc3;
            it.pdesc4 = pedvit[x].pdesc4;
            it.pedcliit = pedvit[x].pedcliit;
            it.iskit = pedvit[x].iskit == 'S';
            itens.push(it);
          }
        }
      } else {
        itens.push(pedvit);
      }
      //EFETUA A GRAVACAO DOS ITENS NO PEDIDO
      this.apiItens(itens, false, false);

      this.closeDestaque();

      this.$refs.addList.focus();
    },
    handleShowGradeItem: function handleShowGradeItem(index) {
      //EXIBE A GRADE DO ITEM NA LISTA DE ITENS
      if (this.pedvit[index].showGrade) {
        this.pedvit[index].showGrade = false;
      } else {
        this.$set(this.pedvit[index], 'showGrade', true);
      }
    },
    handleEditItem: function handleEditItem(nSeq, view) {
      //EDITAR O ITEM DO PEDIDO
      this.pedvit_update = {};
      //localiza o item para alteracao atraves da sequencia
      for (var x = 0; x < this.pedvit.length; x++) {
        if (this.pedvit[x].itped == nSeq) {
          this.pedvit_update = _extends({}, this.pedvit[x]);
        }
      }
      this.formItemView = view; //indica se é alteração ou somente visualizacao
      this.updateItem = true;
      this.showFormItem = true;
    },
    handleItemDeleteMsg: function handleItemDeleteMsg(nSeq) {
      //EXCLUI O ITEM DO PEDIDO
      this.pedvit_update = {};
      //localiza o item para alteracao atraves da sequencia
      for (var x = 0; x < this.pedvit.length; x++) {
        if (this.pedvit[x].itped == nSeq) {
          this.pedvit_update = _extends({}, this.pedvit[x]);
        }
      }
      this.DELETE_ITEM_MESSAGE = true;
    },
    handleItemDelete: function handleItemDelete(nSeq) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var pedvit;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                //remove o item do pedido
                _this7.DELETE_ITEM_MESSAGE = false;
                pedvit = [];

                pedvit.push(_this7.pedvit_update);
                _context6.next = 5;
                return _this7.apiItens(pedvit, false, true);

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    handleRetorna: function handleRetorna() {
      //TRATAMENTO DO BOTAO RETORNAR (TELA DE INCLUSAO, DADOS DO PEDIDO E TELA PRINCIPAL DO PEDIDO)
      if (this.formNew) {
        //FECHA A TELA DE INCLUSAO DO PEDIDO
        this.closeForm();
      } else if (this.formOrder) {
        //FECHA A TELA DE EDICAO DO PEDIDO
        this.closeForm();
      }
    },


    //CHAMADAS API

    gravaPedido: function gravaPedido(operacao) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var sendData, metodo, update, modulo, data, validation;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!_this8.isView) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt('return');

              case 2:

                _this8.unwatch = true;

                if (operacao == 'gerarpedido') _this8.pedv.tppedv = 'P';else if (operacao == 'perdido') _this8.pedv.tppedv = 'R';else if (operacao == 'cancelar') _this8.pedv.stpedv = 'C';

                _this8.pedv.pedvit = [].concat(_toConsumableArray(_this8.pedvit));
                _this8.pedv.pedvpar = [].concat(_toConsumableArray(_this8.pedvpar));
                sendData = {};

                sendData = { pedv: _this8.pedv };

                metodo = 'post';
                update = false;

                if (_this8.pedv.codpedv != null) {
                  metodo = 'put';
                  update = true;
                }

                modulo = 'sales/pedv/';
                _context7.next = 14;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this8.$store, modulo, sendData, metodo);

              case 14:
                data = _context7.sent;

                if (data.items) {
                  _this8.pedv = data.items[0];
                  if (_this8.pedv.pedvit) _this8.pedvit = _this8.pedv.pedvit;
                  if (_this8.pedv.anexos && _this8.pedv.anexos.length) _this8.anexos = _this8.pedv.anexos;else _this8.anexos = [];
                  if (_this8.pedv.pedvpar) {
                    _this8.pedvpar = _this8.pedv.pedvpar;
                  }
                  validation = JSON.parse(_this8.pedv.validation);

                  if (validation && validation.errmessages && validation.errmessages.length) {
                    _this8.errmessages = validation;
                    _this8.$scrollTo(0);
                    _this8.$erpToastError('Por favor corrija os erros de validação');
                  } else if (_this8.pedv.stpedv == 'C') {
                    _this8.$erpToastWarning('O pedido foi cancelado');
                    _this8.closeForm();
                  } else {
                    _this8.errmessages = {};
                    if (update) {
                      //this.$erpToastSuccess('Pedido alterado')
                    }
                  }
                }
                _this8.updateActions(); //ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES" AO CARREGAR UM PEDIDO
                _this8.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                  this.unwatch = false;
                });

              case 18:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    apiDuplica: function apiDuplica() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var metodo, modulo, sendData, data;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                //efetua a copia do pedido
                metodo = 'post';
                modulo = 'sales/pedv/duplica';
                sendData = { pedv: _this9.pedv.codpedv };
                _context8.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this9.$store, modulo, sendData, metodo);

              case 5:
                data = _context8.sent;

                if (data.items) {
                  _this9.pedv = data.items[0];
                  if (_this9.pedv.tppedv === 'P') {
                    _this9.$erpToastSuccess('Pedido copiado com sucesso. O novo pedido criado é: ' + _this9.pedv.npedido);
                  } else {
                    _this9.$erpToastSuccess('Orçamento copiado com sucesso. O novo orçamento criado é: ' + _this9.pedv.ncotacao);
                  }
                  _this9.errmessages = {};
                  if (_this9.pedv.validation) {
                    _this9.errmessages = JSON.parse(_this9.pedv.validation);
                  }
                }

              case 7:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    apiItens: function apiItens(pedvIt, cancelItem, deleteItem) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var sendData, modulo, metodo, data;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                //efetua a gravacao dos itens do pedido
                _this10.pedv.pedvit = _extends({}, _this10.pedvit);
                sendData = {};

                sendData = { pedv: _this10.pedv //pega o cabecalho do pedido
                };if (pedvIt.length) {
                  sendData.pedv.pedvit = pedvIt; //adiciona os novos itens ao cabecalho
                } else {
                  sendData.pedv.pedvit = [];
                  sendData.pedv.pedvit.push(pedvIt);
                }

                modulo = 'sales/pedvit/';
                metodo = 'post';

                if (_this10.formNew) {
                  modulo = 'sales/pedv/';
                } else if (_this10.updateItem) {
                  metodo = 'put';
                } else if (cancelItem) {
                  modulo = 'sales/pedvit/cancel/';
                } else if (deleteItem) {
                  modulo = 'sales/pedvit/delete/';
                }

                _context9.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this10.$store, modulo, sendData, metodo);

              case 9:
                data = _context9.sent;

                if (!deleteItem) {
                  _context9.next = 16;
                  break;
                }

                _context9.next = 13;
                return _this10.loadData(_this10.pedv.codpedv);

              case 13:
                _this10.$erpToastSuccess('O produto foi excluído do pedido.');
                _context9.next = 17;
                break;

              case 16:
                if (data.items) {
                  _this10.pedv = data.items[0];
                  _this10.pedvit = data.items[0].pedvit;
                  _this10.updateActions(); //ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES" AO CARREGAR UM PEDIDO
                  if (cancelItem) _this10.$erpToastSuccess('O produto foi cancelado com sucesso.');else if (_this10.updateItem) _this10.$erpToastSuccess('Item alterado com sucesso.');else if (pedvIt.length && pedvIt.length > 1) {
                    _this10.$erpToastSuccess('Os produtos selecionados foram adicionados.');
                  } else {
                    _this10.$erpToastSuccess('Os produtos selecionados foram adicionados.');
                  }
                  if (_this10.pedv.validation) {
                    _this10.errmessages = JSON.parse(_this10.pedv.validation);
                  } else {
                    _this10.errmessages = {};
                  }
                }

              case 17:
                _this10.updateItem = false;
                _this10.formNew = false;

              case 19:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    },
    handleCancelMsg: function handleCancelMsg(nSeq) {
      //cancelar o pedido
      //exibe a confirmacao do cancelamento
      this.CANCEL_MESSAGE = true;
    },
    handleItemCancelMsg: function handleItemCancelMsg(nSeq) {
      //cancelar o item do pedido
      this.pedvit_update = {};
      //localiza o item para cancelar atraves da sequencia
      for (var x = 0; x < this.pedvit.length; x++) {
        if (this.pedvit[x].itped == nSeq) {
          this.pedvit_update = _extends({}, this.pedvit[x]);
        }
      }
      this.pedvit_update.stpedv = 'C';

      //exibe a confirmacao do cancelamento
      this.CANCEL_ITEM_MESSAGE = true;
    },
    handleItemCancel: function handleItemCancel() {
      //efetiva o cancelamento do item
      this.CANCEL_ITEM_MESSAGE = false;
      var pedvit = [];
      pedvit.push(this.pedvit_update);
      this.apiItens(pedvit, true, false);
    },
    handleCancel: function handleCancel() {
      //efetiva o cancelamento do pedido
      this.CANCEL_MESSAGE = false;
      this.gravaPedido('cancelar');
    },
    handleCloseMessage: function handleCloseMessage() {
      this.CANCEL_MESSAGE = false;
      this.CANCEL_ITEM_MESSAGE = false;
      this.DELETE_ITEM_MESSAGE = false;
    },
    handleEmail: function handleEmail() {
      // SALVA O PEDIDO E ENVIA EMAIL
      var self = this;
      this.gravaPedido().then(function () {
        self.handleFormEmail();
      });
    },
    handleAction: function handleAction(act) {
      //click do botao "mais acoes"
      if (act == 12) {
        this.$router.push('/banking?codpedv=' + this.pedv.codpedv);
      }
      if (act == 10) {
        this.handleAnexarDocumento();
      }
      if (act == 20) {
        this.handleExcluirAlocacao();
      }
      if (act == 5) {
        this.apiDuplica();
      } else if (act == 4) {
        this.handleCancelMsg();
      } else if (act == 1) {
        var self = this;
        this.gravaPedido().then(function () {
          self.codpedvImpressao = self.pedv.codpedv;
          self.showImpressao = true;
          self.$nextTick(function () {
            self.$refs.impressao.print();
          });
        });
      }
    },
    handleClosePrint: function handleClosePrint() {
      this.showImpressao = false;
    },
    handleAnexarDocumento: function handleAnexarDocumento() {
      //ANEXAR DOCUMENTOS AO PEDIDO
      if (!this.showAnexo) {
        this.showAnexo = true;
      }
      this.$nextTick(function () {
        this.$refs.anexos.handleClickAdiciona();
      });
    },
    handleChangeAnexos: function handleChangeAnexos(anexosList) {
      //ATUALIZA A LISTA DE ANEXOS
      this.anexos = anexosList;
    },
    handleFormEmail: function handleFormEmail() {
      //Abre a tela para envio de email
      //carrega o template da mensagem antes do envio (ords/webdata/template/salesorder/:id)

      this.showFormEmail = true;
    },
    closeFormEmail: function closeFormEmail() {
      this.showFormEmail = false;
    },
    handleSendEmail: function handleSendEmail(data) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var email;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                //cahamda para envio de email do pedido
                _this11.closeFormEmail();
                _context10.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiEmailPDF"])(_this11, 'pedv/' + _this11.pedv.codpedv, data);

              case 3:
                email = _context10.sent;

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this11);
      }))();
    },
    updateActions: function updateActions() {
      /* ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES"
      - quando pendente permite imprimir, enviar, faturar, cancelar
      - quando em digitacao permite cancelar
      - quando liquidado ou cancelado nao permite açoes
      */
      this.btNFC = this.pedv.varejo == 'S' && this.pedv.stpedv == 'P';

      this.btEnviar = this.pedv.stpedv == 'P' && this.pedv.tppedv != 'R' || this.pedv.stpedv == 'F';
      this.btImprimir = this.pedv.stpedv == 'P' && this.pedv.tppedv != 'R' || this.pedv.stpedv == 'F';
      this.btFaturar = (this.pedv.movest !== 'S' || this.alocacaoEfetuada || !this.controleEstoqueAtivado) && this.pedv.stpedv == 'P' && this.pedv.tppedv == 'P' && !this.pedv.data_leitura;
      // this.btEnviar = ((this.pedv.stpedv == 'P' || this.pedv.stpedv == 'F') && this.pedv.tppedv != 'R')
      // this.btImprimir = ((this.pedv.stpedv == 'P' || this.pedv.stpedv == 'F') && this.pedv.tppedv != 'R')
      // this.btFaturar = this.pedv.stpedv == 'P' && this.pedv.tppedv == 'P' && !(this.pedv.data_leitura)
      this.btCancelar = this.pedv.varejo != 'S' && this.pedv.tppedv === 'P' && this.pedv.nf_pendente === 0 && this.pedv.fin_remessa === 0 && this.pedv.fin_baixado === 0;

      var act = {};
      this.moreActions = [];
      if (this.pedv.varejo != 'S') {
        if (this.pedv.stpedv == 'P') {
          if (this.btCancelar) {
            act = { action: 4, label: 'Cancelar' };
            this.moreActions.push(act);
          }
        }
        if (this.pedv.tppedv === 'P') {
          act = { action: 5, label: 'Copiar Pedido' };
          this.moreActions.push(act);
        } else {
          act = { action: 5, label: 'Copiar Orçamento' };
          this.moreActions.push(act);
        }
        if (this.pedv.tppedv == 'P' && this.alocacaoEfetuada && this.pedv.stpedv !== 'F') {
          act = { action: 20, label: 'Excluir Alocação' };
          this.moreActions.push(act);
        }
      }
      if (this.pedv.stpedv == 'P' || this.pedv.stpedv == 'D') {
        act = { action: 10, label: 'Anexar Documento' };
        this.moreActions.push(act);
      }

      if (this.emiteCobranca) {
        act = { action: 12, label: 'Enviar Cobrança' };
        this.moreActions.push(act);
      }
    },
    textOption: function textOption(value, field) {
      var item = field.options.filter(function (x) {
        return x.id === value;
      });
      if (item.length) {
        return item[0].text;
      }
    },
    calculaTotal: function calculaTotal() {
      //calcula o total do pedido
      var t = 0;
      for (var x = 0; x < this.pedvit.length; x++) {
        this.pedvit[x].totliq = this.pedvit[x].qt * this.pedvit[x].vlr;
        this.pedvit[x].totliq = Object(__WEBPACK_IMPORTED_MODULE_2__shared_numbers__["calcDesconto"])(this.pedvit[x].totliq, this.pedvit[x].pdesc1, this.pedvit[x].pdesc2, this.pedvit[x].pdesc3, this.pedvit[x].pdesc4, 2, true);
        t += this.pedvit[x].totliq;
      }
      this.pedv.totliq = t;
    },
    validacaoInicial: function validacaoInicial() {
      //VALIDA A SITUACAO DE CREDITO DO CLIENTE, STATUS DO CLIENTE E NATUREZA DE OPERACAO
      this.isValidCabec = true;

      if (this.pedv.nates && this.pedv.nates.length && this.pedv.nates[0].stnates == 'I') {
        this.$erpToastError('A Natureza de saída informada está inativa');
        this.isValidCabec = false;
      }
      if (this.pedv.part[0].stcred != 'L') {
        this.$erpToastError('Cliente com crédito bloqueado');
        this.isValidCabec = false;
      }
      if (this.pedv.part[0].stpart == 'I') {
        this.$erpToastError('Cliente inativo');
        this.isValidCabec = false;
      }
      return this.isValidCabec;
    },
    validacaoCab: function validacaoCab() {
      //validar o cliente quanto ao status do credito, status e natureza de operacao
      this.isValidCabec = true;

      if (this.pedv.parttr.length && this.pedv.parttr.stpart == 'I') {
        this.$erpToastError('Transportadora inativa');
        this.isValidCabec = false;
      }
      if (this.pedv.vend.length && this.pedv.vend.stpart == 'I') {
        this.$erpToastError('Representante inativo');
        this.isValidCabec = false;
      }
      if (this.pedv.tabpre.length && this.pedv.tabpre.sttabpre == 'I') {
        this.$erpToastError('Tabela de preço inativa');
        this.isValidCabec = false;
        //falta validar a data da tabela de preco
      }
      if (this.pedv.condicao.length && this.pedv.condicao.ativo != 'A') {
        this.$erpToastError('Condição de pagamento inativa');
        this.isValidCabec = false;
      }
    },
    loadData: function loadData(id) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                //carrega o pedido para alteracao ou visualizacao
                _this12.partTabela = false;
                _this12.partCodTabpre = null;

                _this12.unwatch = true;
                _context11.next = 5;
                return _this12.$store.dispatch('loadPedv', { id: id });

              case 5:
                if (_this12.$store.getters.getPedv) {
                  _this12.pedv = _extends({}, _this12.$store.getters.getPedv[0]);
                  if (_this12.pedv.pedvit) _this12.pedvit = _this12.pedv.pedvit;
                  if (_this12.pedv.part[0].codtabpre) {
                    _this12.partCodTabpre = _this12.pedv.part[0].codtabpre;
                    _this12.partTabela = true;
                  }
                  if (_this12.pedv.validation) _this12.errmessages = JSON.parse(_this12.pedv.validation);
                  if (_this12.pedv.anexos && _this12.pedv.anexos.length) _this12.anexos = _this12.pedv.anexos;else _this12.anexos = [];
                  if (_this12.pedv.pedvpar) {
                    _this12.pedvpar = _this12.pedv.pedvpar;
                  }
                  _this12.updateActions(); //ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES" AO CARREGAR UM PEDIDO
                }
                _this12.loadControleEstoqueFilial(_this12.pedv.codfil);
                _this12.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                  this.unwatch = false;
                });

              case 8:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this12);
      }))();
    },


    // changeTab (idx) {
    //     //controle de visualizacao das paginas
    //     this.formItemsPedido = true
    //     this.activeTab = idx
    // },

    calculaParcelas: function calculaParcelas() {
      var _this13 = this;

      //CALCULA PARCELAS DO PEDIDO
      var vDias = 0;
      var soma = 0;

      if (this.pedvpar.length && this.pedvpar[0].dias > 0) {
        vDias = this.pedvpar[0].dias;
      }

      this.pedvpar = [];
      var vlr = 0;
      if (this.pedv.parcelas == '0') {
        var parcela = _extends({}, this.$store.getters.getEntities.pedvpar);
        parcela.dtv = this.pedv.data;
        parcela.vlr = this.pedv.totger;
        parcela.obspar = '';
        parcela.dias = vDias;
        this.getParcelasFormapagParametrosFilial(this.pedv.codfil).then(function (v) {
          parcela.formapag = v;
        });

        if (parcela.formapag == null) {
          parcela.formapag = "99";
        }
        this.pedvpar.push(parcela);
      } else {
        var _loop = function _loop() {
          var parcela = _extends({}, _this13.$store.getters.getEntities.pedvpar);
          parcela.dias = x * 30;
          parcela.dtv = _this13.$addDays(_this13.pedv.data, parcela.dias);
          vlr = _this13.pedv.totger;
          vlr = Object(__WEBPACK_IMPORTED_MODULE_2__shared_numbers__["arr"])(vlr / _this13.pedv.parcelas, 2, true);
          parcela.vlr = vlr;
          soma = Number(soma) + Number(vlr);
          soma = Number(soma.toFixed(2));

          if (x == _this13.pedv.parcelas) {
            if (soma > _this13.pedv.totger) {
              parcela.vlr = parcela.vlr - (soma - _this13.pedv.totger);
            } else if (soma < _this13.pedv.totger) {
              parcela.vlr = Number(parcela.vlr) + (Number(_this13.pedv.totger) - Number(soma));
            }
          }

          parcela.obspar = '';

          _this13.getParcelasFormapagParametrosFilial(_this13.pedv.codfil).then(function (v) {
            parcela.formapag = v;
          });

          if (parcela.formapag == null) {
            parcela.formapag = "99";
          }
          _this13.pedvpar.push(parcela);
        };

        for (var x = 1; x <= this.pedv.parcelas; x++) {
          _loop();
        }
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },
    pedvparVlrChange: function pedvparVlrChange(index) {
      //evento de controle de alteracao do valor da parcela
      //quando usuario alterar o valor de uma parcela, refaz as demais parcelas
      if (this.pedv.parcelas <= 1) {
        return;
      }
      var vlrparcial = 0;
      var vlrnovaparcela = 0;
      for (var x = 0; x <= index; x++) {
        vlrparcial = vlrparcial + parseFloat(this.pedvpar[x].vlr);
      }
      if (vlrparcial < this.pedv.totger) {
        vlrnovaparcela = (this.pedv.totger - vlrparcial) / (this.pedv.parcelas - (index + 1));
        vlrnovaparcela.toFixed(2);
      } else {}
      for (var x = index + 1; x <= this.pedvpar.length - 1; x++) {
        this.pedvpar[x].vlr = vlrnovaparcela;
      }
    },
    pedvparDiasChange: function pedvparDiasChange(index) {
      //evento de controle de alteracao do nr de dias de vencimento da parcela
      this.pedvpar[index].dtv = this.$addDays(this.pedv.data, this.pedvpar[index].dias);
    },
    pedvparDtvChange: function pedvparDtvChange(index) {
      //evento de controle de alteracao do nr de dias de vencimento da parcela
      this.pedvpar[index].dias = this.$daysBetween(this.pedv.data, this.pedvpar[index].dtv);
    },
    usuarioTemPermissaoNaTabelaPreco: function usuarioTemPermissaoNaTabelaPreco(codtabpre) {
      if (codtabpre) {
        if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.length > 0) {
          var liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter(function (obj) {
            return obj == codtabpre;
          });
          if (liberado.length > 0) {
            return true;
          }
        } else {
          return true;
        }
      }
      return false;
    },
    carregaDadosCliente: function carregaDadosCliente() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return _this14.$store.dispatch('loadPart', { id: _this14.pedv.codpart });

              case 2:
                //atualiza os dados do cliente no pedido quando informado um codigo do cliente
                if (!_this14.pedv.part || _this14.pedv.part[0].codpart != _this14.pedv.codpart) {
                  _this14.pedv.part = _this14.part;
                  _this14.pedv.finalidade = _this14.pedv.part[0].tpcliente;
                  _this14.pedv.codnates = _this14.pedv.part[0].codnates;
                  _this14.pedv.nates = _this14.pedv.part[0].nates[0];
                  _this14.pedv.codvendr = _this14.pedv.part[0].codvendr;
                  _this14.pedv.vendr = _this14.pedv.part[0].vendr[0];
                  _this14.partCodTabpre = null;
                  _this14.partTabela = false;
                  if (_this14.usuarioTemPermissaoNaTabelaPreco(_this14.pedv.part[0].codtabpre)) {
                    _this14.pedv.codtabpre = _this14.pedv.part[0].codtabpre;
                    _this14.partCodTabpre = _this14.pedv.part[0].codtabpre;
                    _this14.partTabela = true;
                  }
                  _this14.pedv.tabpre = _this14.pedv.part[0].tabpre[0];
                  _this14.pedv.codparttr = _this14.pedv.part[0].codparttr;
                  _this14.pedv.parttr = _this14.pedv.part[0].parttr[0];
                  _this14.pedv.codcondicao = _this14.pedv.part[0].codcondicao;
                  _this14.pedv.condicao = _this14.pedv.part[0].condicao[0];
                  _this14.pedv.codvend = _this14.pedv.part[0].codvend;
                  _this14.pedv.vend = _this14.pedv.part[0].vend[0];
                  if (_this14.pedv.part[0].partcontato.length > 0) _this14.pedv.seqcontato = _this14.pedv.part[0].partcontato[0].seqcontato;
                  if (_this14.pedv.part[0].tpfrete) _this14.pedv.tpfrete = _this14.pedv.part[0].tpfrete;
                }
                _this14.validacaoInicial();

              case 4:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this14);
      }))();
    }
  },

  watch: {
    part: function part() {},

    selectedNates: function selectedNates() {
      //atualiza a natureza de operacao
      this.pedv.nates = _extends({}, this.selectedNates);
      this.checkAvisoNaturezaIcmFilialSemIE(this.selectedNates);
    },

    codpart: function codpart(newValue, oldValue) {
      if (newValue != oldValue) {
        this.carregaDadosCliente();
      }
    },

    codnates: function codnates() {
      //carrega os dados da natureza selecionada pelo codigo => /cg/nates/id
      this.$store.dispatch('loadNates', { id: this.pedv.codnates });
    },

    prazodias: function prazodias() {
      //CALCULA O PRAZO DE ENTREGA QUANDO ALTERAR O PRAZO EM DIAS
      if (this.unwatch) return;
      if (this.pedv.prazodias > 0) {
        this.pedv.prazo = this.$addDays(this.pedv.data, this.pedv.prazodias);
      }
    },

    prazo: function prazo() {
      //console.log(this.pedv.prazo)
    },

    validadedias: function validadedias() {
      //CALCULA O PRAZO DE ENTREGA QUANDO ALTERAR O PRAZO EM DIAS
      if (this.unwatch) return;
      if (this.pedv.validadedias > 0) {
        this.pedv.dtvalidade = this.$addDays(this.pedv.data, this.pedv.validadedias);
      }
    },

    dtvalidade: function dtvalidade() {
      //console.log(this.pedv.dtvalidade)
    },

    parcelas: function parcelas() {
      //calcula numero de parcelas da condicao de pagamento
      if (this.unwatch) return;
      this.calculaParcelas();
    }
  },

  created: function created() {
    var _this15 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
      var index, incluir, params, tourguide;
      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              //this.$store.dispatch('clearItemSales')

              //carrega parametros do usuario para bloqueio das tabelas de precos
              _this15.$store.dispatch('loadParametrosUsuario');

              //carrega as tabelas de precos liberadas para o usuario no computed "tabelas_preco_options"
              _this15.$store.dispatch('loadTabpre', {});

              //carrega lista de destaques
              _this15.$store.dispatch('loadDestaq', {});

              //carrega lista de cadastro de status para selecao
              _this15.$store.dispatch('loadPdstatus', {});

              _this15.metadata.pedv.parcelas.options.sort(function (a, b) {
                return Number(a.id) > Number(b.id) ? 1 : Number(b.id) > Number(a.id) ? -1 : 0;
              });

              _this15.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
              });

              _this15.$scrollTo(0);

              index = _this15.index;
              incluir = _this15.crud == __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI;


              if (_this15.$route.params) if (_this15.$route.params.novo == 'novo') incluir = true;else if (_this15.$route.params.novo) index = _this15.$route.params.novo;

              if (incluir) _this15.crudText = _this15.$crudText(__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI);

              if (!incluir) {
                _context13.next = 35;
                break;
              }

              _this15.formNew = true;
              _this15.pedv.data = _this15.$getDate();
              _this15.pedv.stpedv = 'D';
              _this15.pedv.finalidade = 'F';
              _this15.pedv.indpresencial = '0';
              _this15.pedv.bonif = 'N';
              _this15.pedv.amostra = 'N';
              _this15.pedv.pgantecipado = 'N';
              _this15.pedv.tpfrete = '9';
              _this15.pedv.tppedv = 'O';
              if (_this15.tabelas_preco_options && _this15.tabelas_preco_options.length > 0) {
                _this15.pedv.codtabpre = _this15.tabelas_preco_options[0].id;
              } else {
                _this15.pedv.codtabpre = '1';
              }
              _this15.pedv.movest = 'S';
              _this15.unwatch = false;
              _this15.updateActions();
              _this15.$nextTick(function () {
                this.$refs.part.focus();
              });

              if (!_this15.showGuia) {
                _context13.next = 33;
                break;
              }

              params = { filter: null };
              _context13.next = 31;
              return _this15.$store.dispatch('loadPedvList', params);

            case 31:
              _this15.hasManyPedidos = _this15.$store.getters.getPedvList.length >= 1;
              if (_this15.showGuia && !_this15.hasManyPedidos) {
                tourguide = new __WEBPACK_IMPORTED_MODULE_17_tourguidejs___default.a({
                  steps: _this15.steps
                });


                tourguide.start();
              }

            case 33:
              _context13.next = 37;
              break;

            case 35:
              _this15.formOrder = true;
              _this15.loadData(index);

            case 37:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this15);
    }))();
  }
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_focus_lock__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_focus_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_focus_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_grade__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params: Object
  },

  data: function data() {
    return {
      searchString: '',
      inicio: true,
      noItems: false,
      showItems: false,
      errorMessage: '',
      error: false,
      localItemList: [],
      topAdicionar: null,
      leftAdicionar: null,
      scrollY: 0,
      myStyle: {},
      unWatch: false,
      showItemLote: false,
      itemKit: null,
      pesquisaCodigo: false,
      offset: false
    };
  },


  computed: {

    nextPage: function nextPage() {
      return this.$store.getters.getNextPage;
    },

    itemList: function itemList() {
      return this.$store.getters.getItemSalesList;
    },

    metadata: function metadata() {
      return this.$store.getters.getEntities.metadata;
    },

    myDropDown: function myDropDown() {
      // console.log(this.$refs.pesquisa.getBoundingClientRect())
      // const rect = this.$refs.pesquisa.getBoundingClientRect();
      // return 'top: ' + rect.top + 'px; left: ' + rect.left + 'px;'
      //return 'top: 764.297px; left: 235px;'
    },

    bloqueia_preco_item: function bloqueia_preco_item() {
      if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) return this.$store.getters.getParametrosUsuario.vendas.bloqueia_preco_item;else return false;
    }

  },

  methods: {
    handleMore: function handleMore() {
      this.offset = true;
      this.loadData();
    },


    label_tabdesc: function label_tabdesc(value) {
      return "Tab. Desconto: " + value;
    },

    scrollTop: function scrollTop() {},
    handleShowItemLote: function handleShowItemLote(div) {
      jQuery("#" + div).show();
    },
    addItens: function addItens() {
      //botao adicionar itens
      //valida o preço dos itens e quantidades informadas
      //emite o evento additem com a lista de itens que deverão ser adicionados
      var selectedItems = [];
      this.error = false;
      for (var x = 0; x < this.localItemList.length; x++) {
        //CHECA SE O ITEM POSSUI QUANTIDADE INFORMADA PARA ADICIONAR NO PEDIDO
        if (this.localItemList[x].qtuni != null && this.localItemList[x].qtuni != 0) {
          if (!this.localItemList[x].vlr || this.localItemList[x].vlr <= 0) {
            this.localItemList[x].error = 'Necessário informar o preço do item';
            this.error = true;
          } else {
            this.localItemList[x].error = false;
            selectedItems.push(this.localItemList[x]);
          }
        }
      }

      var lixo = [].concat(_toConsumableArray(this.localItemList)); //// ALTERACAO NO this.localItemList[x].error NAO ESTA RENDERIZANDO
      this.localItemList = [];
      this.localItemList = lixo; ///////////////

      if (!this.error) {
        this.handleEsc();
        this.$emit('additem', selectedItems);
        this.focus();
      } else {
        this.$erpToastError('Erro. Alguns itens estão sem valor!');
      }
    },
    handleEsc: function handleEsc() {
      this.noItems = false;
      this.showItems = false;
      this.searchString = '';
      if (this.$refs.pesquisa) this.focus();

      if (this.params.produtosDestaque) {
        this.closeForm();
      }
    },
    handleEnter: function handleEnter(index) {
      if (index + 1 == this.itemList.length) {
        this.addItens();
      }
    },
    handleUpdateGrade: function handleUpdateGrade(index, qt, listItemGrade) {
      //QUANDO FOR DIGITADA QUANTIDADE NA GRADE DO PRODUTO
      this.localItemList[index].qtuni = qt;
      this.localItemList[index].pedvgrade = listItemGrade;
    },
    focus: function focus() {
      this.$nextTick(function () {
        this.$refs.searchpedidoaddlist.focus();
      });
    },
    closeForm: function closeForm() {
      this.$emit('closeform');
    },
    handleChange: function handleChange() {
      // console.log(this.searchString)
      if (!this.searchString) {
        this.noItems = false;
        this.showItems = false;
        return;
      }
    },
    search: function search() {
      //efetua a pesquisa por descricao ou por codigo
      this.inicio = false;

      // if (!this.searchString) {
      //     this.showItems = false
      //     return
      // }

      if (this.params.produtosDestaque) {
        this.filter = '';
      } else {
        this.searchString = this.searchString.toUpperCase();
        if (this.searchString.length <= 0) return;
        if (this.pesquisaCodigo) this.filter = '{"codigo":{"$eq":"' + this.searchString + '"}}';else this.filter = '{"descricao":{"$or":[{"$like":"%25' + this.searchString + '%25"},{"codigo":{"$eq":"' + this.searchString + '"}}]}}';
      }

      this.loadData();
    },
    loadData: function loadData() {
      var params = {
        codtabpre: this.params.pedv.codtabpre,
        codpedv: this.params.pedv.codpedv,
        filter: this.filter,
        produtosDestaque: this.params.produtosDestaque
      };
      if (this.offset) {
        params.offset = this.nextPage;
      }

      this.unWatch = false;
      this.$store.dispatch('loadItemSales', params);
      this.offset = false;
    },
    getKitDetails: function getKitDetails(coditem) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var codtabpre, url, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                codtabpre = _this.params.pedv.codtabpre;
                url = 'item/kit/' + coditem + '/tabpre/' + codtabpre + '/';
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDS"])(_this.$store.getters.urlOrds + url);

              case 4:
                data = _context.sent;


                if (data.items) {
                  data.items.map(function (i) {
                    if (i.itemlote_json) {
                      i.itemlote_json = JSON.parse(i.itemlote_json);
                    }
                  });

                  _this.localItemList.map(function (i) {
                    if (i.coditem == coditem) {
                      _this.$set(i, 'itemKit', data.items);
                    }
                  });
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  watch: {

    itemList: function itemList() {
      if (this.inicio || this.unWatch) {
        return;
      }

      this.unWatch = true;

      if (!this.itemList.length) {
        this.noItems = true;
        this.showItems = false;
      } else {
        this.noItems = false;
        this.showItems = true;

        //JOGA O FOCO PARA O PRIMEIRO ITEM DA PESQUISA
        this.$nextTick(function () {
          // console.log(this.$refs.grade)
          // console.log(this.$refs.qtuni)
          // console.log(this.itemList[0])
          if (this.itemList[0].isgrade == 'S' || this.$refs.grade) {
            this.$refs.grade[0].focus();
          } else if (this.$refs.qtuni.length) {
            this.$refs.qtuni[0].focus();
          }
        });
      }

      //adiciona o objeto PEDVIT à lista de itens local
      this.localItemList = [].concat(_toConsumableArray(this.itemList));
      var vm = this;
      var param = this.params;
      jQuery.map(this.localItemList, function (value) {
        if (_typeof(value.unimed) !== 'object') {
          // value.pedvit = {...vm.$store.getters.getEntities.pedvit}
          value.grade = []; //A GRADE VAI COLOCAR OS ITENS DIGITADOS AQUI
          value.uni = value.uni;
          value.vlr = value.vlrtab;
          value.pdesc1 = null;
          value.pdesc2 = null;
          value.pdesc3 = null;
          value.pdesc4 = null;
          value.pedcliit = null;
          if (value.unimed) value.unimed = JSON.parse(value.unimed);
          value.error = false;
          if (value.tabelas_desconto) value.tabelas_desconto = JSON.parse(value.tabelas_desconto);
          if (value.tabelas_preco) value.tabelas_preco = JSON.parse(value.tabelas_preco);
          if (value.itemlote_json) value.itemlote_json = JSON.parse(value.itemlote_json);
          if (value.estoque_kit_json) value.estoque_kit_json = JSON.parse(value.estoque_kit_json);
          //CARREGA O DESCONTO INFORMADO NO PEDIDO
          if (param) {
            if (param.pedv.pdesc1) {
              value.pdesc1 = param.pedv.pdesc1;
            }
            if (param.pedv.pdesc2) {
              value.pdesc2 = param.pedv.pdesc2;
            }
            if (param.pedv.pdesc3) {
              value.pdesc3 = param.pedv.pdesc3;
            }
            if (param.pedv.pdesc4) {
              value.pdesc4 = param.pedv.pdesc4;
            }
          }
        }
        return value;
      });
    },

    scrollY: function scrollY() {
      //EFETUA O CONTROLE DA BARRA DE PESQUISA EM RELAÇÃO AO SCROLL DA TELA
      if (!this.showItems) return;

      if (!this.leftAdicionar && this.$refs.adicionar) this.leftAdicionar = this.$refs.adicionar.$el.getBoundingClientRect().left;

      var rect = this.$el.getBoundingClientRect();
      var newTop = this.scrollY; // - this.topAdicionar;

      // console.log('posicao inicial: ' + this.topAdicionar)
      // console.log('posicao top: ' + rect.top)
      // console.log('posicao left: ' + this.leftAdicionar)

      if (rect.top < -50) {
        this.$set(this.myStyle, 'top', 0);
        this.$set(this.myStyle, 'left', this.leftAdicionar);
        this.$set(this.myStyle, 'position', 'fixed');
        //this.$delete(this.myStyle, 'margin-left');
        // console.log(this.myStyle)
      } else {
        this.$delete(this.myStyle, 'top');
        this.$delete(this.myStyle, 'position');
        this.$delete(this.myStyle, 'left');
      }
    }
  },

  components: {
    grade: __WEBPACK_IMPORTED_MODULE_2__components_grade__["a" /* default */], Trap: __WEBPACK_IMPORTED_MODULE_1_vue_focus_lock___default.a
  },

  created: function created() {
    //this.$store.dispatch('clearItemSales')

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    // console.log(this.$el)

    this.topAdicionar = this.$el.getBoundingClientRect().top;

    window.addEventListener('scroll', function (event) {
      _this2.scrollY = Math.round(window.scrollY);
      // console.log(this.scrollY)
    });

    if (this.params.produtosDestaque) {
      this.inicio = false;
      this.loadData();
      return;
    }
    this.$refs.searchpedidoaddlist.focus();
  }
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_additem_vue__ = __webpack_require__(545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_027830f9_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_additem_vue__ = __webpack_require__(1520);
function injectStyle (ssrContext) {
  __webpack_require__(1515)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_additem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_027830f9_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_additem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_numbers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_numbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_numbers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_varejo_varejo_add_item__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_grade__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_grade_estoque__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params: {},
    view: Boolean
  },

  components: {
    VarejoAddItem: __WEBPACK_IMPORTED_MODULE_3__forms_varejo_varejo_add_item__["a" /* default */], grade: __WEBPACK_IMPORTED_MODULE_4__components_grade__["a" /* default */], gradeEstoque: __WEBPACK_IMPORTED_MODULE_5__components_grade_estoque__["a" /* default */]
  },

  data: function data() {
    return {
      errorMessage: '',
      error: false,
      pedvit: _extends({}, this.$store.getters.getEntities.pedvit),
      metadata: this.$store.getters.getEntities.metadata,
      qtEstoque: 0,
      unWatch: false,
      showDesconto: false
    };
  },


  computed: {
    isView: function isView() {
      return this.view || this.pedvit && this.pedvit.bloqueado == 'S';
    },
    itemSalesList: function itemSalesList() {
      return this.$store.getters.getItemSalesList;
    },
    coditem: function coditem() {
      return this.pedvit.coditem;
    },
    vlr: function vlr() {
      return this.pedvit.vlr;
    },
    qtuni: function qtuni() {
      return this.pedvit.qtuni;
    },
    pdesc1: function pdesc1() {
      return this.pedvit.pdesc1;
    },
    pdesc2: function pdesc2() {
      return this.pedvit.pdesc2;
    },
    pdesc3: function pdesc3() {
      return this.pedvit.pdesc3;
    },
    pdesc4: function pdesc4() {
      return this.pedvit.pdesc4;
    },
    pedvit_descontotab: function pedvit_descontotab() {
      return this.pedvit.descontotab;
    },
    showGradeItem: function showGradeItem() {
      return this.pedvit.item && this.pedvit.item.isgrade == 'S';
    },
    habilitaUnimed: function habilitaUnimed() {
      return !this.showGradeItem && this.pedvit.item && this.pedvit.unimed && this.pedvit.unimed.length > 0;
    },
    bloqueia_preco_item: function bloqueia_preco_item() {
      if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) return this.$store.getters.getParametrosUsuario.vendas.bloqueia_preco_item;else return false;
    },
    bloqueia_descontos: function bloqueia_descontos() {
      if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) return this.$store.getters.getParametrosUsuario.vendas.bloqueia_descontos;else return false;
    }

  },

  methods: {
    calculaTotal: function calculaTotal() {
      //calcula o total do item ao informar quantidade, preço, descontos, etc
      var aDesc = [];

      if (this.pedvit.descontotab && this.pedvit.descontotab.length > 0) {
        for (var x = 0; x < this.pedvit.descontotab.length; x++) {
          aDesc.push(this.pedvit.descontotab[x].pdesc);
        }
      }
      aDesc.push(this.pedvit.pdesc1);
      aDesc.push(this.pedvit.pdesc2);
      aDesc.push(this.pedvit.pdesc3);
      aDesc.push(this.pedvit.pdesc4);
      this.pedvit.totliq = this.pedvit.qtuni * this.pedvit.vlr;
      this.pedvit.totliq = Object(__WEBPACK_IMPORTED_MODULE_2__shared_numbers__["calcDesconto"])(this.pedvit.totliq, aDesc, 2, true);
    },
    handleSalvar: function handleSalvar() {
      this.error = false;

      if (this.pedvit.qtuni <= 0) {
        this.$erpToastError('Por favor informe a quantidade do item');
        this.error = true;
      }

      if (this.pedvit.vlr <= 0) {
        this.$erpToastError('Por favor informe o preço unitário do item');
        this.error = true;
      }

      if (!this.error) {
        var param = [];
        param.push(this.pedvit);
        this.$emit('save', param);
      }
    },
    closeForm: function closeForm() {
      this.$emit('closeform');
    },
    handleUpdateGrade: function handleUpdateGrade(index, qt, listItemGrade) {
      //QUANDO FOR DIGITADA QUANTIDADE NA GRADE DO PRODUTO
      this.pedvit.qtuni = qt;
      this.pedvit.pedvgrade = listItemGrade;
    }
  },

  watch: {
    coditem: function coditem() {
      this.$store.dispatch('loadItemSales', { coditem: this.coditem, codtabpre: this.params.pedv.codtabpre, codpedv: this.params.pedv.codpedv });
    },

    itemSalesList: function itemSalesList() {
      if (!this.itemSalesList.length) {
        return;
      }
      var data = this.itemSalesList[0];
      if (data.itemlote_json) {
        data.itemlote_json = JSON.parse(data.itemlote_json);
      }

      this.pedvit.item = data;

      if (this.unWatch) {
        this.unWatch = false;
        return;
      }

      this.pedvit.uni = this.pedvit.item.uni;
      this.pedvit.vlrtab = this.pedvit.item.vlrtab;
      this.pedvit.vlr = this.pedvit.item.vlrtab;
      if (this.pedvit.item.tabelas_desconto) this.pedvit.descontotab = this.pedvit.item.tabelas_desconto.descontos;
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },

    qtuni: function qtuni() {
      this.calculaTotal();
    },

    pdesc1: function pdesc1() {
      this.calculaTotal();
    },

    pdesc2: function pdesc2() {
      this.calculaTotal();
    },

    pdesc3: function pdesc3() {
      this.calculaTotal();
    },

    pdesc4: function pdesc4() {
      this.calculaTotal();
    },

    pedvit_descontotab: {
      handler: function handler() {
        this.calculaTotal();
      },

      deep: true
    },

    vlr: function vlr() {
      this.calculaTotal();
    }

  },

  created: function created() {
    //this.$store.dispatch('clearItemSales')

    this.$nextTick(function () {
      if (this.$refs.qtuni) {
        this.$refs.qtuni.focus();
      }
      // this.$refs.item.$el.querySelector('select').focus()
    });

    if (this.params.pedvit) {
      this.unWatch = true;
      if (this.params.pedvit.descontotab) this.params.pedvit.descontotab = JSON.parse(this.params.pedvit.descontotab);
      //if (!Array.isArray(this.params.pedvit.descontotab)) {
      //    this.params.pedvit.descontotab = JSON.parse(this.params.pedvit.descontotab)
      //}
      this.pedvit = this.params.pedvit;

      if (this.pedvit.pdesc2 > 0 || this.pedvit.pdesc3 > 0 || this.pedvit.pdesc4 > 0) {
        this.showDesconto = true;
      }
    }
  }
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_offline__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_offline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_offline__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {},
    disabled: Boolean,
    addButton: Boolean,
    exibePreco: { type: Boolean, default: true },
    tabelaPreco: String,
    balanca: { type: Object },
    simple: Boolean,
    newQt: Number,
    showQt: Boolean
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_offline__["VueOfflineMixin"]],

  data: function data() {
    return {
      textSearch: "",
      inicio: true,
      noList: true,
      showList: false,
      originalTop: 0,

      isChoosing: true,
      modoCodigoBarra: true,
      modoInfoQtd: false,
      modoView: false,

      quantidade: 1,

      selectedIndex: 0,
      selected: {},

      items: [],
      itemssearch: [],

      vbalanca: {},

      crud: ""
    };
  },


  computed: {
    itemList: function itemList() {
      return this.itemssearch;
    },

    metadata: function metadata() {
      return this.$store.getters.getEntities.metadata;
    },

    pesquisarPlaceholder: function pesquisarPlaceholder() {
      if (this.modoInfoQtd) return "Informe a Quantidade...";
      if (this.modoView) return "Informe o código para consulta...";
      if (this.modoCodigoBarra && !this.modoView) return "Informe o código para incluir...";
      return "Informe a descrição ou código...";
    }
  },

  filters: {
    format: function format(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["formatValue"])(value, 4);
    }
  },

  methods: {
    handleBack: function handleBack() {
      if (this.modoCodigoBarra && this.modoView) {
        this.modoView = false;
        return;
      }
      if (this.modoCodigoBarra && !this.modoView) {
        this.modoCodigoBarra = false;
      }
    },
    handlePressf9: function handlePressf9(shortcut) {
      if (shortcut) {
        this.modoCodigoBarra = true;
        this.modoView = true;
        return;
      }
      if (this.modoCodigoBarra) {
        this.modoCodigoBarra = false;
        this.modoView = true;
      } else if (!this.modoCodigoBarra) {
        this.modoCodigoBarra = true;
        this.modoView = false;
      }
    },
    handleisView: function handleisView() {},
    existe: function existe(coditem) {
      //CHECA SE O ITEM JÁ FOI LANCADO NO PEDIDO
      if (this.params && this.params.pedvit) {
        var obj = this.params.pedvit.find(function (o) {
          return o.coditem === coditem;
        });
        if (obj) {
          return true;
        } else {
          return false;
        }
      } else return false;
    },
    handleEsc: function handleEsc() {
      if (this.modoInfoQtd) {
        this.modoInfoQtd = false;
        this.quantidade = 1;
      }

      if (!this.showList && this.selected.nome) {
        this.isChoosing = false;
      } else {
        this.showList = false;
        this.textSearch = "";
        this.$refs.pesquisa.focus();
      }
    },
    handleKeyDown: function handleKeyDown() {
      var listItems = document.getElementById("listitem");
      var array = Array.from(listItems.getElementsByClassName("active"));
      if (!array) {
        array = Array.from(listItems);
      }

      listItems.scrollBy(0, array[0].clientHeight);

      //TECLA PARA BAIXO
      if (this.itemList.length > 0) {
        if (this.selectedIndex >= this.itemList.length - 1) {
          this.selectedIndex = this.itemList.length - 1;
        } else {
          this.selectedIndex = this.selectedIndex + 1;
        }
        console.log(this.itemList.length);
        console.log(this.selectedIndex);
      }
    },
    handleKeyUp: function handleKeyUp() {
      // TECLA PARA CIMA
      var listItems = document.getElementById("listitem");
      var array = Array.from(listItems.getElementsByClassName("active"));

      if (!array) {
        array = Array.from(listItems);
      }

      if (this.selectedIndex >= 1) {
        listItems.scrollBy(0, -array[0].clientHeight);
      }

      if (this.itemList.length > 0) {
        if (this.selectedIndex < 1) {
          this.selectedIndex = 0;
        } else {
          this.selectedIndex = this.selectedIndex - 1;
        }
        console.log(this.itemList.length);
        console.log(this.selectedIndex);
      }
    },
    focus: function focus() {
      this.$refs.pesquisa.focus();
    },
    closeForm: function closeForm() {
      this.$emit("closeform");
    },
    handleBlur: function handleBlur() {
      //this.showList = false
    },
    handleChange: function handleChange() {
      // if (!this.textSearch) {
      //     this.showList = false
      //     return
      // }
    },
    setQtd: function setQtd() {
      var text = this.textSearch.toUpperCase();

      this.quantidade = parseFloat(text);

      this.modoInfoQtd = false;

      this.handleEsc();
    },
    handleEnter: function handleEnter() {
      if (/^\*\d+$/.test(this.textSearch)) {
        var numero = this.textSearch.substring(1);
        this.$emit("defineQt", parseFloat(numero));
      }
      if (this.modoInfoQtd) {
        this.setQtd();
      } else if (this.modoCodigoBarra || this.modoView) {
        this.search();
      } else {
        if (this.textSearch) {
          this.handleSelectItem();
        }
      }
      this.textSearch = "";
    },
    handleInformarQuantidade: function handleInformarQuantidade() {
      this.modoInfoQtd = true;
    },
    handleSelectItem: function handleSelectItem(index) {
      //AO SELECIONAR UM ITEM
      if (index) {
        this.selectedIndex = index;
      }
      if (this.itemList.length > 0) {
        this.selected = this.itemList[this.selectedIndex];
        this.selected.quantidade = this.quantidade;

        if (this.vbalanca.codigo) {
          if (this.vbalanca.barras_peso_ou_valor == "P") {
            this.selected.quantidade = this.vbalanca.valor;
          } else {
            this.selected.vlrtab = this.vbalanca.valor;
          }
        }

        this.showList = false;
        this.isChoosing = false;

        this.quantidade = 1;
        this.$emit("input", this.selected.coditem);
        this.$emit("onselect", this.selected);

        if (this.modoView) {
          this.$emit("setView", this.selected);
        }
        this.focusControl();
      }
    },
    search: function search() {
      this.inicio = false;

      var self = this;

      if (!this.textSearch) {
        this.showList = false;
        return;
      }
      this.itemssearch = [];

      var text = this.textSearch.toUpperCase();
      this.vbalanca = {};

      if (this.modoCodigoBarra) {
        if (this.balanca && this.balanca.numero_identificacao && this.balanca.tamanhobarra && this.balanca.inicio_codigo && this.balanca.fim_codigo) {
          // balanca: {
          //    numero_identificacao: null,
          // tamanhobarra: null,
          // inicio_codigo: null,
          // fim_codigo: null,
          // inicio_valor: null,
          // fim_valor: null,
          // barras_peso_ou_valor: null,
          //     qtd_casas_valor: null,
          // }
          console.log('balanca');
          if (text.length == this.balanca.tamanhobarra) {
            console.log(text.substring(0, 1));
            console.log(this.balanca.numero_identificacao);
            if (text.substring(0, 1) == this.balanca.numero_identificacao) {
              console.log(text);
              var codigo = text.substring(this.balanca.inicio_codigo, this.balanca.fim_codigo);
              console.log(codigo);
              var valor = parseFloat(text.substring(this.balanca.inicio_valor, this.balanca.fim_valor));
              console.log(valor);
              if (this.balanca.qtd_casas_valor == 4) {
                valor = valor * 0.0001;
              } else if (this.balanca.qtd_casas_valor == 3) {
                valor = valor * 0.001;
              } else {
                valor = valor * 0.01;
              }

              this.vbalanca.codigo = codigo;
              this.vbalanca.valor = valor;
              this.vbalanca.barras_peso_ou_valor = this.balanca.barras_peso_ou_valor;

              console.log(this.vbalanca);

              this.filter = '{"codbarras":{"$or":[{"$eq":"' + codigo + '"},{"codigo":{"$eq":"' + codigo + '"}}]}}';
            }
          } else {
            this.filter = '{"codbarras":{"$or":[{"$eq":"' + text + '"},{"codigo":{"$eq":"' + text + '"}}]}}';
          }
        } else {
          this.filter = '{"codbarras":{"$or":[{"$eq":"' + text + '"},{"codigo":{"$eq":"' + text + '"}}]}}';
        }
      } else {
        this.filter = '{"descricao":{"$or":[{"$like":"%25' + text + '%25"},{"codigo":{"$like":"%25' + text + '%25"}},{"codbarras":{"$like":"%25' + text + '%25"}}]}}';
      }

      this.loadData().then(function () {
        self.itemssearch = self.$store.getters.getItemSalesVarejoList;
        if (self.modoView || self.modoCodigoBarra) {
          if (self.itemssearch && self.itemssearch.length > 0) {
            self.itemssearch[0].quantidade = self.quantidade;
            self.$emit("setView", self.itemssearch);
          }
        }
        if (self.modoCodigoBarra && !self.modoView) {
          if (self.itemssearch && self.itemssearch.length > 0) {
            self.handleSelectItem(0);
          } else {
            this.$erpToastError("Item não encontrado");
          }
        }
      });
    },
    loadData: function loadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("loadItemSalesVarejo", {
                  codtabpre: _this.tabelaPreco,
                  filter: _this.filter
                });

              case 2:

                _this.selectedIndex = 0;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },


    focusControl: function focusControl(event) {
      this.textSearch = "";
      this.$refs.pesquisa.focus();
    },

    handlerChangeBarCodeMode: function handlerChangeBarCodeMode() {
      __WEBPACK_IMPORTED_MODULE_1_vue_offline__["VueOfflineStorage"].set("barCodeMode", this.modoCodigoBarra);
    }
  },

  watch: {
    modoCodigoBarra: function modoCodigoBarra(value) {
      // QUANDO O MODOCODIGOBARRA FOR FALSO O MODOVIEW PRECISA SER ALTERADO PARA FALSO
      if (this.modoView && value == false) {
        this.modoView = value;
      }
    },
    textSearch: function textSearch() {
      var vm = this;
      if (this.keytimer) {
        clearTimeout(this.keytimer);
      }
      if (!this.modoCodigoBarra && !this.modoInfoQtd) {
        this.keytimer = setTimeout(function () {
          vm.search();
        }, 300);
      }
    },

    itemList: function itemList() {
      if (this.inicio) {
        return;
      }
      if (!this.itemList.length || this.modoCodigoBarra) {
        this.noList = true;
        this.showList = false;
      } else {
        this.noList = false;
        this.showList = true;
      }
      return this.itemssearch;
    }
  },

  components: {
    // CustomerForm,
  },

  created: function created() {
    if (this.value) {
      this.loadData(this.value);
    }

    this.$nextTick(function () {
      //const rect = this.$refs.pesquisa.getBoundingClientRect();
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
  },
  mounted: function mounted() {
    this.originalTop = this.$el.getBoundingClientRect().top;
    if (__WEBPACK_IMPORTED_MODULE_1_vue_offline__["VueOfflineStorage"] && __WEBPACK_IMPORTED_MODULE_1_vue_offline__["VueOfflineStorage"].keys && __WEBPACK_IMPORTED_MODULE_1_vue_offline__["VueOfflineStorage"].keys.includes("barCodeMode")) {
      this.modoCodigoBarra = __WEBPACK_IMPORTED_MODULE_1_vue_offline__["VueOfflineStorage"].get("barCodeMode");
    }
  }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        finList: Array
    },

    data: function data() {
        return {
            receber: 0,
            recebido: 0,
            vencido: 0,
            urlboleto: 'fin/boleto/'
        };
    },

    computed: {
        metadata: function metadata() {
            return this.$store.getters.getEntities.metadata;
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(value, 2);
        }
    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        data: function data(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatDate"])(value);
        },
        totalizaTitulos: function totalizaTitulos() {
            //CALCULA OS TOTAIS

            this.receber = 0;
            this.recebido = 0;
            this.vencido = 0;

            if (!this.finList.length) {
                return;
            }

            var d = new Date();

            for (var x = 0; x <= this.finList.length - 1; x++) {
                if (this.finList[x].baixado === 'S') {
                    this.recebido = this.recebido + this.finList[x].vlr;
                } else if (this.finList[x].dtv < d) {
                    this.vencido = this.vencido + this.finList[x].vlr;
                } else {
                    this.receber = this.receber + this.finList[x].vlr;
                }
            }
        },
        handleEmiteBoleto: function handleEmiteBoleto(codfin) {
            //EMISSAO DO BOLETO DO TITULO SELECIONADO
            var sendData = { titulos: [{ codfin: codfin }] };
            Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiDownloadPDF"])(this, this.urlboleto, sendData, 'post');
        },
        handleBaixar: function handleBaixar(codfin) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var sendData, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //EFETUA A BAIXA DO TITULO
                                sendData = { titulos: [{ codfin: codfin }] };
                                _context.next = 3;
                                return apiORDSpost(_this.$store, 'fin/ar/pay/', sendData, 'post');

                            case 3:
                                data = _context.sent;

                                if (data.errmessages) {
                                    _this.errmessages = data.errmessages;
                                    _this.$erpToastError(data.errmessages[0]);
                                } else {
                                    _this.$erpToastSuccess('Baixa efetivada com sucesso.');
                                }

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    watch: {},

    components: {},

    created: function created() {
        this.totalizaTitulos();
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
    },
    mounted: function mounted() {}
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customer_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customer_contato_form__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vend_form__ = __webpack_require__(78);
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        pedv: { type: Object },
        partCodTabpre: { type: String },
        metadata: { type: Object },
        isView: { type: Boolean },
        controleEstoqueAtivado: { type: Boolean }
    },

    data: function data() {
        return {
            showPartForm: false, //exibe o formulario de cliente para inclusao
            showVendForm: false, //exibe o formulario de vendedor para inclusao
            showContatoForm: false, //exibe o formulario de contato do cliente para inclusao
            errmessages: {}
        };
    },


    computed: {

        administrador: function administrador() {
            return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador;
        },

        select2Contato: function select2Contato() {
            return { entity: 'partcontato/' + this.pedv.codpart, minlength: 0 };
        },

        bloqueia_tabela_cliente: function bloqueia_tabela_cliente() {
            if (this.pedv.part && this.pedv.part.length > 0 && this.pedv.part[0].codtabpre) {
                if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) return this.$store.getters.getParametrosUsuario.vendas.bloqueia_tabela_cliente;else return false;
            } else return false;
        },

        tabelas_preco_options: function tabelas_preco_options() {
            //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
            var options = [];

            var liberado = [];
            var currTabpre = {};
            var addTabela = false;

            for (var x = 0; x < this.$store.getters.getTabpreList.length; x++) {
                currTabpre = this.$store.getters.getTabpreList[x];

                //se existir parametros do usuario, libera somente as tabelas permitidas
                if (this.partCodTabpre && this.partCodTabpre == currTabpre.codtabpre) addTabela = true;else if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) {
                    liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter(function (obj) {
                        return obj == currTabpre.codtabpre;
                    });
                    if (liberado.length > 0) {
                        addTabela = true;
                    }
                } else {
                    addTabela = true;
                }

                if (addTabela) options.push({ id: currTabpre.codtabpre, text: currTabpre.descricao });

                addTabela = false;
            }

            return options;
        }

    },

    filters: {},

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        validarcampos: function validarcampos() {
            this.errmessages = {};
            this.errmessages.errmessages = [];

            if ((this.pedv.cepret || this.pedv.enderet || this.pedv.nomeret || this.pedv.endenrret) && !this.pedv.cnpjcpfret) {
                this.errmessages.errmessages.push('Cnpj/Cpf Retirada deve ser preenchido.');
            }
            if ((this.pedv.cepret || this.pedv.enderet || this.pedv.nomeret || this.pedv.endenrret) && !this.pedv.tppessoaret) {
                this.errmessages.errmessages.push('Tipo Pessoa Retirada deve ser preenchido.');
            }
            if ((this.pedv.cepret || this.pedv.enderet || this.pedv.nomeret || this.pedv.endenrret) && !this.pedv.endenrret) {
                this.errmessages.errmessages.push('Nr endereço Retirada deve ser preenchido.');
            }
            if ((this.pedv.cepret || this.pedv.enderet || this.pedv.nomeret || this.pedv.endenrret) && !this.pedv.enderet) {
                this.errmessages.errmessages.push('Endereço Retirada deve ser preenchido.');
            }

            if ((this.pedv.cepent || this.pedv.endeent || this.pedv.nomeent || this.pedv.endenrent) && !this.pedv.cnpjcpfent) {
                this.errmessages.errmessages.push('Cnpj/Cpf Entrega deve ser preenchido.');
            }
            if ((this.pedv.cepent || this.pedv.endeent || this.pedv.nomeent || this.pedv.endenrent) && !this.pedv.tppessoaent) {
                this.errmessages.errmessages.push('Tipo Pessoa Entrega deve ser preenchido.');
            }
            if ((this.pedv.cepent || this.pedv.endeent || this.pedv.nomeent || this.pedv.endenrent) && !this.pedv.endenrent) {
                this.errmessages.errmessages.push('Nr endereço Entrega deve ser preenchido.');
            }
            if ((this.pedv.cepent || this.pedv.endeent || this.pedv.nomeent || this.pedv.endenrent) && !this.pedv.endeent) {
                this.errmessages.errmessages.push('Endereço Entrega deve ser preenchido.');
            }
        },
        handleSave: function handleSave() {
            this.validarcampos();
            if (this.errmessages.errmessages.length == 0) {
                this.$emit('save');
            } else {
                this.$erpToastError('Corrigir os erros de validação');
            }
        },
        closeCustomerForm: function closeCustomerForm(id) {
            //ao fechar o formulario de inclusao de clientes
            //if (id) this.pedv.codpart = id
            this.showPartForm = false;
        },
        closeVendForm: function closeVendForm(id) {
            //ao fechar o formulario de inclusao de vendedor
            if (id) this.pedv.codvendr = id;
            this.showVendForm = false;
        },
        closeContatoForm: function closeContatoForm(id) {
            //ao fechar o formulario de inclusao de vendedor
            if (id) this.pedv.seqcontato = id;
            this.showContatoForm = false;
        },
        handleIncluirContato: function handleIncluirContato() {
            this.showContatoForm = true;
        },
        handleIncluir: function handleIncluir(pTipo) {
            //exibe tela de cadastro
            if (this.isView) {
                return;
            }

            if (pTipo === 'part') {
                this.showPartForm = true;
            }

            if (pTipo === 'transp') {
                this.showPartForm = true;
            }

            if (pTipo === 'vend') {
                this.showPartForm = true;
            }
        },
        updateCepEnt: function updateCepEnt() {
            //CARREGA INFORMACOES DO CEP DE ENTREGA
            this.pedv.endeent = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.logradouro;
            this.pedv.bairroent = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.bairro;
            this.pedv.codmunent = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.ibge;
            this.pedv.ufent = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.uf;
            this.pedv.codpaisent = 1058;
        },
        updateCepRet: function updateCepRet() {
            //CARREGA INFORMACOES DO CEP DE RETIRADA
            this.pedv.enderet = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.logradouro;
            this.pedv.bairroret = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.bairro;
            this.pedv.codmunret = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.ibge;
            this.pedv.ufret = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.uf;
            this.pedv.codpaisret = 1058;
        }
    },

    watch: {},

    components: {
        CustomerForm: __WEBPACK_IMPORTED_MODULE_2__customer_form__["default"], CustomerContatoForm: __WEBPACK_IMPORTED_MODULE_3__customer_contato_form__["a" /* default */], VendForm: __WEBPACK_IMPORTED_MODULE_4__vend_form__["a" /* default */]

    },

    created: function created() {},
    mounted: function mounted() {
        this.$nextTick(function () {
            this.$refs.contato.$el.querySelector('select').focus();
            // this.$refs.contato.$el.querySelector('input').focus()
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
    }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        codpart: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            partcontato: _extends({}, this.$store.getters.getEntities.partcontato),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO Excluir
            this.apiDelete();
        },
        loadData: function loadData() {
            //carrega o registro para alteracao ou visualizacao
            // await this.$store.dispatch('loadPartcontato', { codpart: this.codpart, id: this.seqcontato} )
            // if (this.$store.getters.getEstado) {
            //     this.partcontato = {...this.$store.getters.getPartcontato}
            // }  
            // this.$nextTick(function () {
            //     jQuery('[data-toggle="tooltip"]').tooltip()
            // })

            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiPost: function apiPost() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/partcontato/';


                                _this3.partcontato.codpart = _this3.codpart;
                                sendData = {};


                                sendData = { partcontato: _this3.partcontato };

                                metodo = 'post';
                                update = false;

                                if (_this3.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context2.next = 9;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this3.$store, modulo, sendData, metodo);

                            case 9:
                                data = _context2.sent;

                                if (data.errmessages) {
                                    _this3.errmessages = data.errmessages;
                                    _this3.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this3.$erpToastUpdated();
                                    } else {
                                        _this3.$erpToastInserted();
                                    }
                                    _this3.errmessages = {};
                                    _this3.$emit('closeform', data);
                                }

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }
    }
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pedido_content_pdf_vue__ = __webpack_require__(1532);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        PedidoContentPdf: __WEBPACK_IMPORTED_MODULE_1__pedido_content_pdf_vue__["a" /* default */]
    },
    props: {
        index: {
            type: Number,
            require: true
        }
    },
    data: function data() {
        return {
            pedv: null,
            uuid: null,
            image: null
        };
    },

    watch: {
        index: function index() {
            // console.log(this.index)
        }
    },
    computed: {
        orderOrBudgetId: function orderOrBudgetId() {
            if (this.pedv) {
                if (!this.pedv.npedido) {
                    return 'Orçamento: ' + this.pedv.ncotacao;
                } else {
                    return 'Pedido: ' + this.pedv.npedido;
                }
            }
        }
    },
    methods: {
        beforeDownload: function beforeDownload(_ref) {
            var _this = this;

            var html2pdf = _ref.html2pdf,
                options = _ref.options,
                pdfContent = _ref.pdfContent;
            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                options.margin = [0.5, 0];
                                options.image = { type: 'jpeg', quality: 0.98 };
                                options.html2Canvas = { scale: 1 };

                                _context.next = 5;
                                return html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then(function (pdf) {
                                    var totalPages = pdf.internal.getNumberOfPages();
                                    for (var i = 1; i <= totalPages; i++) {
                                        pdf.setPage(i);
                                        pdf.setFontSize(10);
                                        pdf.setTextColor(150);
                                        pdf.text('Page ' + i + ' of ' + totalPages, pdf.internal.pageSize.getWidth() * 0.88, pdf.internal.pageSize.getHeight() - 0.3);
                                        // html2pdf().set({
                                        //     pagebreak: { mode: 'avoid-all', before:`${id}` }
                                        // });
                                    }
                                }).save();

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var data, _data, self;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!_this2.uuid) {
                                    _context2.next = 7;
                                    break;
                                }

                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSapp"])(_this2, 'linkpdf/imprimirpedido/' + _this2.uuid, 'get', null);

                            case 3:
                                data = _context2.sent;

                                if (data) {
                                    _this2.pedv = data.items[0];
                                    if (_this2.pedv.filial.length && _this2.pedv.filial[0].logotipo) {
                                        _this2.image = 'data:image/jpeg;base64,' + _this2.pedv.filial[0].logotipo;
                                    }
                                    _this2.print();
                                }
                                _context2.next = 17;
                                break;

                            case 7:
                                _context2.next = 9;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDS"])(_this2.$store.getters.urlOrds + 'sales/pedv/' + _this2.index, null);

                            case 9:
                                _data = _context2.sent;

                                if (!_data) {
                                    _context2.next = 17;
                                    break;
                                }

                                if (!(!_this2.image && _data.items[0].filial.length)) {
                                    _context2.next = 15;
                                    break;
                                }

                                self = _this2;
                                _context2.next = 15;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSmidia"])(_this2.$store.getters.urlApp + 'logo/download/' + _data.items[0].filial[0].codempresa + '/' + _data.items[0].filial[0].codfil).then(function (response) {
                                    if (response && response.size > 0) {
                                        var reader = new window.FileReader();
                                        reader.readAsDataURL(response);
                                        reader.onload = function () {
                                            self.image = reader.result;
                                        };
                                    }
                                });

                            case 15:
                                _this2.pedv = _data.items[0];
                                if (_this2.pedv.filial.length) {
                                    _this2.pedv.filial[0].parametros = JSON.parse(_this2.pedv.filial[0].parametros);
                                }

                            case 17:

                                _this2.prepareGrade();
                                // console.log('this.pedv.filial[0].logotipo')
                                // console.log(this.pedv.filial[0])

                            case 18:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        printHtmlContent: function printHtmlContent(htmlContent) {
            var filename = this.orderOrBudgetId;
            filename = filename.replace(': ', '') + '.pdf';
            var sendData = { header: htmlContent[0], body: htmlContent[1] };
            Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiDownloadPDF"])(this, '/htmlpdf', sendData, 'post', false, filename);
            this.$emit('close');
        },
        prepareGrade: function prepareGrade() {
            var cp_pedvit = [];
            this.pedv.pedvit.map(function (item) {
                var it = _extends({}, item);
                it.isgrade = false;
                cp_pedvit.push(it);
                if (item.pedvgrade.length > 0) {
                    var it_grade = _extends({}, item);
                    it_grade.totbru = 0;
                    it_grade.totliq = 0;
                    it_grade.qt = 0;
                    it_grade.qtuni = 0;
                    it_grade.isgrade = true;
                    cp_pedvit.push(it_grade);
                }
            });
            this.pedv.pedvit = cp_pedvit;
        },
        print: function print() {
            this.$refs.pedidoContentPdf.getHtmlContent();
        }
    },
    created: function created() {
        if (this.$route.name == 'imprimir-pedido') {
            if (this.$route.query && this.$route.query.uuid) {
                this.uuid = this.$route.query.uuid;
            } else {
                this.$router.push('/login');
                return;
            }
        }

        this.loadData();
    }
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_utils__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: null,
        pedv: null,
        uuid: null,
        image: null
    },
    created: function created() {},
    mounted: function mounted() {},

    computed: {
        hasItem: function hasItem() {
            if (this.pedv && this.pedv.pedvit) {
                var hasItem = false;
                var itens = this.pedv.pedvit;

                itens.forEach(function (item) {
                    console.log('item', item.servico);
                    if (item.servico == 'N') {
                        hasItem = true;
                        return;
                    }
                });

                return hasItem;
            }
        },
        hasServico: function hasServico() {
            if (this.pedv && this.pedv.pedvit) {
                var hasServico = false;
                var itens = this.pedv.pedvit;

                itens.forEach(function (item) {
                    if (item.servico == 'S') {
                        hasServico = true;
                        return;
                    }
                });
                return hasServico;
            }
        },
        totalServicos: function totalServicos() {
            if (this.hasServico) {
                var itens = this.pedv.pedvit;
                var totalServico = 0;
                console.log(totalServico);
                itens.forEach(function (item) {
                    if (item.servico == 'S') {
                        totalServico += item.totbru;
                    }
                    console.log(totalServico);
                });
                console.log(totalServico);
                return totalServico;
            }
        },
        totalProdutos: function totalProdutos() {
            if (this.hasItem) {
                var itens = this.pedv.pedvit;
                var totalProduto = 0;
                itens.forEach(function (item) {
                    if (item.servico != 'S') {
                        totalProduto += item.totbru;
                    }
                });
                return totalProduto;
            }
        }
    },
    watch: {
        index: function index() {}
    },
    methods: {
        getRows: function getRows(item) {
            var array = [];
            // Obtem as linhas dos items com grade
            if (item.pedvgrade && item.pedvgrade.length > 0) {
                item.pedvgrade.map(function (i) {
                    array.push(i.descricao_linha);
                });
            }

            // Array de linhas sem repeticao
            var rows = array.filter(function (item) {
                return !this[JSON.stringify(item)] && (this[JSON.stringify(item)] = true);
            }, Object.create(null));

            return rows;
        },
        getColumns: function getColumns(item) {
            var array = [];
            // Obtem as colunas dos objetos com grade
            if (item.pedvgrade && item.pedvgrade.length > 0) {
                item.pedvgrade.map(function (i) {
                    array.push(i.descricao_coluna);
                });
            }
            // Array de linhas sem repeticao
            var columns = array.filter(function (item) {
                return !this[JSON.stringify(item)] && (this[JSON.stringify(item)] = true);
            }, Object.create(null));

            return columns;
        },
        dados: function dados(item) {
            var columns = this.getColumns(item);
            var rows = this.getRows(item);
            var linhas = [];
            rows.filter(function (row) {
                var array = new Array(columns.length + 1);
                array.splice(0, 1, row);

                if (item.pedvgrade && item.pedvgrade.length > 0) {
                    item.pedvgrade.map(function (i) {
                        if (i.descricao_linha == row) {
                            var indice = columns.indexOf(i.descricao_coluna);
                            array.splice(indice + 1, 1, i.qt);
                        }
                    });
                }
                linhas.push(array);
            });
            return [{ colunas: columns, linhas: linhas }];
        },
        itemLiqImp: function itemLiqImp(index) {
            var item = this.pedv.pedvit[index];

            return item.totliq + item.vipi + item.vicmst;
        },
        itemIpiST: function itemIpiST(index) {
            var item = this.pedv.pedvit[index];

            return item.vipi + item.vicmst;
        },
        getHtmlContent: function getHtmlContent() {
            var _this = this;

            setTimeout(function () {
                var contentHeader = document.getElementById('header').innerHTML;
                var contentBody = document.getElementById('body').innerHTML;
                var htmlContent = [contentHeader, contentBody];
                _this.$emit('handleHtmlContent', htmlContent);
            }, 1000);
        }
    }
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_estoque_saida_vue__ = __webpack_require__(553);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_636edd08_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_estoque_saida_vue__ = __webpack_require__(1542);
function injectStyle (ssrContext) {
  __webpack_require__(1537)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-636edd08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_estoque_saida_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_636edd08_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_estoque_saida_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__estoque_selecionar_lote_vue__ = __webpack_require__(554);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: { type: Number },
    notafiscal: { type: Boolean },
    pedido: { type: Boolean },
    excluir: { type: Boolean }
  },

  components: { EstoqueSelecionarLote: __WEBPACK_IMPORTED_MODULE_1__estoque_selecionar_lote_vue__["a" /* default */] },

  data: function data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      itemList: [],
      selectedItem: null,
      selectedEstoque: null,
      modalVisible: false,
      concluir: false,
      msgErro: null,
      msgConcluir: null,
      exclusaoConfirmada: 'N'
    };
  },


  computed: {
    depositList: function depositList() {
      if (this.selectedItem && this.selectedItem.estoque) {
        return this.selectedItem.estoque.map(function (invent) {
          return invent.coddeposito;
        });
      }
      return [];
    },
    urlEstoque: function urlEstoque() {
      if (this.notafiscal && this.concluir) return 'estoque/nfsaida/baixarestoque/' + this.index;

      if (this.notafiscal) return 'estoque/nfsaida/' + this.index;

      if (this.pedido) return 'estoque/pedidovenda/' + this.index;
    },
    urlSugestao: function urlSugestao() {
      if (this.notafiscal) return 'estoque/nfsaida/sugerirestoque/' + this.index;

      if (this.pedido) return 'estoque/pedidovenda/sugerirestoque/' + this.index;
    },
    urlExcluirEstoque: function urlExcluirEstoque() {
      if (this.pedido) return 'estoque/pedidovenda/' + this.index + '/excluir';
      if (this.notafiscal) return 'estoque/nfsaida/' + this.index + '/excluir';
    }
  },

  methods: {
    loadData: function loadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var r;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDS"])(_this.$store.getters.urlOrds + _this.urlEstoque, null, true);

              case 2:
                r = _context.sent;

                _this.itemList = r.items || r.itens || r;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    qtAlcoated: function qtAlcoated(item) {
      if (!item || !item.estoque) return 0;
      return item.estoque.reduce(function (t, e) {
        if (e.excluido) return t;
        return t + (e.qt || 0);
      }, 0);
    },
    isAlocated: function isAlocated(item) {
      return this.qtAlcoated(item) === item.qt;
    },
    openModal: function openModal(item) {
      this.selectedItem = item;
      this.resetSelecionar();
      this.modalVisible = true;
    },
    resetSelecionar: function resetSelecionar() {
      this.selectedEstoque = _extends({}, this.$store.getters.getEntities.nfqt, {
        qt: null,
        selecionarLote: true
      });
    },
    closeModal: function closeModal() {
      this.modalVisible = false;
      this.selectedEstoque = null;
    },
    confirmAdd: function confirmAdd() {
      if (!this.selectedEstoque || !this.selectedEstoque.qt) return;

      if (!this.selectedItem.estoque) {
        this.$set(this.selectedItem, 'estoque', []);
      }

      this.selectedItem.estoque.push(_extends({}, this.selectedEstoque, {
        selecionado: true,
        excluido: false
      }));

      this.concluir = false;
      this.msgConcluir = null;

      // Check if fully allocated
      if (this.isAlocated(this.selectedItem)) {
        this.closeModal();
      } else {
        // Mantém aberto para fluxo rápido se ainda houver saldo
        this.resetSelecionar();
      }
    },
    remove: function remove(item, i) {
      if (item.estoque && item.estoque[i]) {
        if (!item.estoque[i].codnfqt) {
          item.estoque.splice(i, 1);
        } else {
          this.$set(item.estoque[i], 'excluido', true);
          this.$set(item.estoque[i], 'qt', 0);
        }
        this.concluir = false;
        this.msgConcluir = null;
      }
    },
    handleSeleciona: function handleSeleciona(obj) {
      this.selectedEstoque = _extends({}, this.selectedEstoque, obj);
      var pending = this.selectedItem.qt - this.qtAlcoated(this.selectedItem);
      if (pending > 0) {
        this.selectedEstoque.qt = obj.qt >= pending ? pending : obj.qt;
      }
    },
    labelEstoque: function labelEstoque(e) {
      var l = [];

      if (e.coddeposito) l.push('Dep: ' + (e.descricao || e.coddeposito));
      if (e.local) l.push('Local: ' + e.local);
      if (e.linha || e.coluna) {
        var g = [];
        if (e.linha) g.push(e.linha);
        if (e.coluna) g.push(e.coluna);
        l.push('Grade: ' + g.join('/'));
      }
      if (e.lote) l.push('Lote: ' + e.lote);
      if (e.sublote) l.push('Sub: ' + e.sublote);
      if (e.dtval) {
        var dtFormatada = e.dtval;
        if (typeof e.dtval === 'string' && e.dtval.indexOf('-') > 0) {
          var parts = e.dtval.split('T')[0].split('-');
          if (parts.length === 3) {
            dtFormatada = parts[2] + '/' + parts[1] + '/' + parts[0];
          }
        }
        l.push('Val: ' + dtFormatada);
      }
      if (e.loteforn) l.push('Forn: ' + e.loteforn);

      return l.join(' | ');
    },
    handleSugerirLotes: function handleSugerirLotes() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.msgErro = null;
                _this2.msgConcluir = null;
                _this2.concluir = false;
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this2.$store, _this2.urlSugestao, null, 'put');

              case 5:
                _this2.loadData();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleSalvar: function handleSalvar() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var metodo, i, j, sendData, _data, data, _data2;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                metodo = 'put';

                // Limpeza de itens vazios que não foram removidos por exclusão

                i = 0;

              case 2:
                if (!(i < _this3.itemList.length)) {
                  _context3.next = 17;
                  break;
                }

                if (!_this3.itemList[i].estoque) {
                  _context3.next = 14;
                  break;
                }

                j = 0;

              case 5:
                if (!(j < _this3.itemList[i].estoque.length)) {
                  _context3.next = 14;
                  break;
                }

                if (!(_this3.itemList[i].estoque[j].excluido && !_this3.itemList[i].estoque[j].codnfqt)) {
                  _context3.next = 10;
                  break;
                }

                _this3.itemList[i].estoque.splice(j, 1);
                j--;
                return _context3.abrupt('continue', 11);

              case 10:

                if (!_this3.itemList[i].estoque[j].excluido && (!_this3.itemList[i].estoque[j].qt || _this3.itemList[i].estoque[j].qt == 0) && (!_this3.itemList[i].estoque[j].coddeposito || _this3.itemList[i].estoque[j].coddeposito == 0)) {
                  _this3.itemList[i].estoque.splice(j, 1);
                  j--; // Ajusta o index após o splice
                }

              case 11:
                j++;
                _context3.next = 5;
                break;

              case 14:
                i++;
                _context3.next = 2;
                break;

              case 17:
                sendData = {
                  itens: _this3.itemList,
                  concluir: _this3.concluir
                };


                _this3.msgErro = null;
                _this3.msgConcluir = null;

                if (!_this3.notafiscal) {
                  _context3.next = 31;
                  break;
                }

                if (!_this3.concluir) {
                  _context3.next = 26;
                  break;
                }

                _context3.next = 24;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this3.$store, _this3.urlEstoque, null, 'put');

              case 24:
                _data = _context3.sent;
                return _context3.abrupt('return', _this3.closeForm());

              case 26:
                _context3.next = 28;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this3.$store, _this3.urlEstoque, sendData, metodo);

              case 28:
                data = _context3.sent;

                _this3.itemList = data.itens || data.items || data;

                if (data.erros) {
                  _this3.msgErro = 'Erro encontrado na validação dos produtos. Selecione o estoque para cada produto listado acima conforme a quantidade digitada na nota fiscal.';
                  _this3.concluir = false;
                } else {
                  _this3.msgConcluir = 'Nota fiscal está pronta para ser baixada.';
                  _this3.concluir = true;
                }

              case 31:
                if (!_this3.pedido) {
                  _context3.next = 47;
                  break;
                }

                _context3.next = 34;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this3.$store, _this3.urlEstoque, sendData, metodo);

              case 34:
                _data2 = _context3.sent;

                _this3.itemList = _data2.itens || _data2.items || _data2;

                if (!_data2.erros) {
                  _context3.next = 41;
                  break;
                }

                _this3.msgErro = 'Erro encontrado na alocação do pedido. Selecione o estoque para cada produto listado acima conforme a quantidade digitada no pedido.';
                _this3.concluir = false;
                _context3.next = 47;
                break;

              case 41:
                if (!_this3.concluir) {
                  _context3.next = 45;
                  break;
                }

                return _context3.abrupt('return', _this3.closeForm());

              case 45:
                _this3.msgConcluir = 'Pedido está pronto para ser alocado. Clique em "Concluir" novamente.';
                _this3.concluir = true;

              case 47:

                _this3.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 48:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    apiExcluirEstoque: function apiExcluirEstoque() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var metodo;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                metodo = 'post';
                _context4.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this4.$store, _this4.urlExcluirEstoque, null, metodo);

              case 3:

                if (_this4.pedido) _this4.$erpToastSuccess('Alocação excluída');else if (_this4.notafiscal) _this4.$erpToastSuccess('Baixa da nota fiscal excluída');

                _this4.closeForm();

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    handleExcluir: function handleExcluir() {
      if (this.exclusaoConfirmada == 'S') this.apiExcluirEstoque();else {
        this.$erpToastError('Primeiro confirme a exclusão para continuar.');
      }
    },
    closeForm: function closeForm() {
      this.$emit('closeform');
    },
    checkAutoAllocate: function checkAutoAllocate() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var urlCheck, check, sendData, valData, _valData;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                urlCheck = '';

                if (_this5.pedido) urlCheck = 'estoque/pedidovenda/autoallocate/' + _this5.index;
                if (_this5.notafiscal) urlCheck = 'estoque/nfsaida/autoallocate/' + _this5.index;

                _context5.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDS"])(_this5.$store.getters.urlOrds + urlCheck, null, true);

              case 5:
                check = _context5.sent;

                if (!(check.autoAllocate !== 'S')) {
                  _context5.next = 8;
                  break;
                }

                return _context5.abrupt('return');

              case 8:
                _context5.next = 10;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this5.$store, _this5.urlSugestao, null, 'put');

              case 10:
                _context5.next = 12;
                return _this5.loadData();

              case 12:
                sendData = {
                  itens: _this5.itemList,
                  concluir: false
                };
                _context5.prev = 13;

                if (!_this5.notafiscal) {
                  _context5.next = 24;
                  break;
                }

                _context5.next = 17;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this5.$store, _this5.urlEstoque, sendData, 'put');

              case 17:
                valData = _context5.sent;

                if (!valData.erros) {
                  _context5.next = 20;
                  break;
                }

                return _context5.abrupt('return');

              case 20:
                _context5.next = 22;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this5.$store, _this5.urlEstoque, null, 'put');

              case 22:
                _context5.next = 33;
                break;

              case 24:
                if (!_this5.pedido) {
                  _context5.next = 33;
                  break;
                }

                _context5.next = 27;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this5.$store, _this5.urlEstoque, sendData, 'put');

              case 27:
                _valData = _context5.sent;

                if (!_valData.erros) {
                  _context5.next = 30;
                  break;
                }

                return _context5.abrupt('return');

              case 30:
                sendData.concluir = true;
                _context5.next = 33;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this5.$store, _this5.urlEstoque, sendData, 'put');

              case 33:

                _this5.$erpToastSuccess('Alocação executada com sucesso.');
                _this5.closeForm();
                _context5.next = 40;
                break;

              case 37:
                _context5.prev = 37;
                _context5.t0 = _context5['catch'](13);

                console.error(_context5.t0);

              case 40:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[13, 37]]);
      }))();
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
  },
  created: function created() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this6.loadData();

            case 2:
              if (!_this6.excluir) {
                _this6.checkAutoAllocate();
              }

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_estoque_selecionar_lote_vue__ = __webpack_require__(555);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0754b704_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_estoque_selecionar_lote_vue__ = __webpack_require__(1541);
function injectStyle (ssrContext) {
  __webpack_require__(1539)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_estoque_selecionar_lote_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0754b704_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_estoque_selecionar_lote_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    entrada: { type: Boolean },
    somenteComQuantidade: { type: Boolean },
    coditem: { type: String },
    coditemgrade: { type: String },
    filial: { type: [String, Number] },
    obj: { type: Object }
  },

  components: {
    formatValue: __WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"], formatDate: __WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatDate"]
  },

  data: function data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      estoqueList: [],
      estoque: null,
      codqest: null
    };
  },


  computed: {

    opcoesList: function opcoesList() {
      var options = [];
      //codigo adicionado para evitar erro de autocarregar valor default quando tem somente um registro na lista do select2
      options.push({ id: -1, text: 'selecione uma opção' });
      //end
      for (var x = 0; x < this.estoqueList.length; x++) {
        if (this.somenteComQuantidade && (!this.estoqueList[x].qt || this.estoqueList[x].qt < 0)) {
          continue;
        }
        var value = '';
        if (this.estoqueList[x].coddeposito) value += 'Depósito: ' + this.estoqueList[x].coddeposito;
        if (this.estoqueList[x].coluna || this.estoqueList[x].linha) {
          value += (value ? ' / ' : ' ') + 'Grade: ';
          if (this.estoqueList[x].linha) value += this.estoqueList[x].linha;
          if (this.estoqueList[x].coluna) value += (this.estoqueList[x].linha ? ' ' : '') + this.estoqueList[x].coluna;
        }
        if (this.estoqueList[x].lote) value += (value ? ' / ' : ' ') + 'Lote: ' + this.estoqueList[x].lote;
        if (this.estoqueList[x].sublote) value += (value ? ' / ' : ' ') + 'Sub-lote: ' + this.estoqueList[x].sublote;
        if (this.estoqueList[x].dtval) value += (value ? ' / ' : ' ') + 'Dt.Val.: ' + Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatDate"])(this.estoqueList[x].dtval);
        if (this.estoqueList[x].qt) value += (value ? ' / ' : ' ') + 'Qtd.: ' + Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(this.estoqueList[x].qt, 2);

        options.push({ id: this.estoqueList[x].codqest, text: value });
      }
      return options;
    }

  },

  methods: {
    loadData: function loadData() {
      var self = this;

      var url = this.$store.getters.urlOrds + 'estoque/lotes/item/' + this.coditem;

      if (this.coditemgrade && this.coditemgrade !== '') {
        url = url + '/grade/' + this.coditemgrade;
      }

      url = url + '/filial/' + this.filial;
      if (this.entrada) url = url + '/todos';else url = url + '/disponivel';

      this.estoqueList = [];

      Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDS"])(url, null, true).then(function (result) {
        self.estoqueList = result.items;
        if (self.estoqueList.length == 0) self.$emit('semestoque');
      });
    }
  },

  watch: {
    codqest: function codqest() {
      this.estoque = null;
      var self = this;
      var selected = this.estoqueList.filter(function (obj) {
        return obj.codqest == self.codqest;
      });
      if (selected.length > 0) {
        this.estoque = selected[0];
        this.obj.codqest = this.estoque.codqest;
        this.obj.lote = this.estoque.lote;
        this.obj.sublote = this.estoque.sublote;
        this.obj.coddeposito = this.estoque.coddeposito;
        this.obj.loteforn = this.estoque.loteforn;
        this.obj.dtval = this.estoque.dtval;
        this.obj.dtfab = this.estoque.dtfab;
        this.obj.linha = this.estoque.linha;
        this.obj.coluna = this.estoque.coluna;
        this.obj.coditemgrade = this.estoque.coditemgrade;
        this.obj.selecionarLote = false;
        this.$emit('select', this.estoque);
      } else {
        this.obj.codqest = null;
        this.obj.lote = null;
        this.obj.sublote = null;
        this.obj.coddeposito = null;
        this.obj.loteforn = null;
        this.obj.dtval = null;
        this.obj.dtfab = null;
        this.obj.linha = null;
        this.obj.coluna = null;
        this.obj.coditemgrade = null;
        this.obj.qt = null;
      }
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
  },
  created: function created() {
    this.loadData();
  }
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        query: Object,
        filterTipos: { type: Boolean, default: false },
        filterEspera: { type: Boolean, default: false },
        filterEquipes: { type: Boolean, default: false },
        filterUsuarios: { type: Boolean, default: false },
        filterStatus: { type: Boolean, default: false },
        filterFrete: { type: Boolean, default: false },
        params: { type: Object },
        inUse: { type: Boolean }
    },

    data: function data() {
        return {

            showMaisFiltros: false,

            filtroTipos: {
                list: [{ id: 0, label: 'Todos' }, { id: 1, label: 'Concluídos na loja virtual' }, { id: 2, label: 'Não concluídos na loja virtual' }],
                index: 0
            },

            filtroEspera: {
                list: [{ id: 0, label: 'Todas as Vendas' }, { id: 1, label: 'Vendas Em Espera' }],
                index: 0
            },

            filtroEquipes: {
                list: [],
                index: 0
            },

            filtroUsuarios: {
                list: [],
                index: 0
            },

            filtroStatusPedido: {
                list: [],
                index: 0
            },

            filtroFretes: {
                list: [],
                index: 0
            },

            base: {
                filial: { label: 'Filial', url: 'filial/', tipo: 'select2', varios: false, values: [{ id: null }] },
                segmento: { label: 'Segmento', url: 'ramoat/', tipo: 'select2', varios: false, values: [{ id: null }] },
                grupocliente: { label: 'Grupo de Clientes', url: 'grucli/', tipo: 'select2', varios: false, values: [{ id: null }] },
                cliente: { label: 'Cliente', url: 'cliente/', tipo: 'select2', varios: false, values: [{ id: null }] },
                clienteusuario: { label: 'Cliente', url: 'clienteusuario/', tipo: 'select2', varios: false, values: [{ id: null }] },
                estado: { label: 'Estado', url: 'estado/', tipo: 'select2', varios: false, values: [{ id: null }] },
                cidade: { label: 'Cidade', url: 'mun/', tipo: 'select2', varios: false, values: [{ id: null }] },
                grupoestoque: { label: 'Grupo de Produtos', url: 'gruest/', tipo: 'select2', varios: false, values: [{ id: null }] },
                produto: { label: 'Produto', url: 'item/', tipo: 'select2', varios: false, values: [{ id: null }] },
                formapagamento: { label: 'Forma de Pagamento', url: 'fpag/', tipo: 'select2', varios: false, values: [{ id: null }] }
            },

            filtros: [],

            filtroPeriodos: [{ data_inicio: null, data_termino: null, startDate: null, endDate: null }],

            filtroPedidoSelected: null
        };
    },


    components: {},

    computed: {
        labelTipos: function labelTipos() {
            return this.filtroTipos.list[this.filtroTipos.index].label;
        },

        labelEspera: function labelEspera() {
            return this.filtroEspera.list[this.filtroEspera.index].label;
        },

        usuarioLabel: function usuarioLabel() {
            if (this.filtroUsuarios.list.length > 0) return this.filtroUsuarios.list[this.filtroUsuarios.index].label;else return null;
        },

        equipeLabel: function equipeLabel() {
            if (this.filtroEquipes.list.length > 0) return this.filtroEquipes.list[this.filtroEquipes.index].label;else return null;
        },

        statusLabel: function statusLabel() {
            if (this.filtroStatusPedido.list.length > 0) return this.filtroStatusPedido.list[this.filtroStatusPedido.index].label;else return null;
        },

        usuarioList: function usuarioList() {
            if (this.$store.getters.getUsuarioList) return this.$store.getters.getUsuarioList;else return [];
        },

        equipeList: function equipeList() {
            if (this.$store.getters.getEquipeList) return this.$store.getters.getEquipeList;else return [];
        },

        statusList: function statusList() {
            if (this.$store.getters.getPdstatusList) return this.$store.getters.getPdstatusList;else return [];
        },

        freteList: function freteList() {
            if (this.$store.getters.getFreteList) return this.$store.getters.getFreteList;else return [];
        },

        freteLabel: function freteLabel() {
            if (this.filtroFretes.list.length > 0) return this.filtroFretes.list[this.filtroFretes.index].label;else return null;
        },

        maisfiltrosLabel: function maisfiltrosLabel() {
            return null;
        },

        administrador: function administrador() {
            return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador;
        },

        sessao: function sessao() {
            return this.$store.getters.getSessao;
        }

    },

    watch: {},

    filters: {},

    methods: {
        handleChangeUsuario: function handleChangeUsuario(index) {
            console.log('handlechangeusuario');
            console.log(this.query);
            this.filtroUsuarios.index = index;
            this.query.codusuario = this.filtroUsuarios.list[index].id;
            if (this.query.codusuario == -1) this.query.codusuario = null;
            this.$emit('change', this.query);
        },
        handleChangeFiltroTipo: function handleChangeFiltroTipo(index) {
            this.filtroTipos.index = index;
            this.filtroPedidoSelected = this.filtroTipos.list[index];
            this.$emit('change', this.query);
        },
        handleChangeFiltroEspera: function handleChangeFiltroEspera(index) {
            this.filtroEspera.index = index;
            this.query.espera = index;
            this.$emit('change', this.query);
        },
        handleChangeEquipe: function handleChangeEquipe(index) {
            this.filtroUsuarios.index = 0;
            this.filtroEquipes.index = index;
            this.query.codequipe = this.filtroEquipes.list[index].id;
            if (this.query.codequipe == -1) this.query.codequipe = null;
            this.$emit('change', this.query);
        },
        handleChangeStatus: function handleChangeStatus(index) {
            this.filtroStatusPedido.index = index;
            this.query.codstatus = this.filtroStatusPedido.list[index].id;
            if (this.query.codstatus == -1) this.query.codstatus = null;
            this.$emit('change', this.query);
        },
        handleChangeFrete: function handleChangeFrete(index) {
            this.filtroFretes.index = index;
            this.query.codfrete = this.filtroFretes.list[index].id;
            if (this.query.codfrete == -1) this.query.codfrete = null;
            this.$emit('change', this.query);
        },
        preparaFiltro: function preparaFiltro() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var x;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadUsuariosDashboard', _this);

                            case 2:
                                _context.next = 4;
                                return _this.$store.dispatch('loadEquipesDashboard', {});

                            case 4:
                                _context.next = 6;
                                return _this.$store.dispatch('loadPdstatus', {});

                            case 6:
                                _context.next = 8;
                                return _this.$store.dispatch('loadFrete', {});

                            case 8:

                                //monta a lista de usuarios e equipes
                                if (_this.usuarioList.length > 1) {
                                    _this.filtroUsuarios.list = [{ id: -1, label: 'Todos' }];
                                }
                                for (x = 0; x < _this.usuarioList.length; x++) {
                                    _this.filtroUsuarios.list.push({ id: _this.usuarioList[x].codusuario, label: _this.usuarioList[x].nome });
                                }

                                _this.filtroEquipes.list = [{ id: -1, label: 'Todos' }];
                                if (_this.equipeList.length > 0) {
                                    for (x = 0; x < _this.equipeList.length; x++) {
                                        _this.filtroEquipes.list.push({ id: _this.equipeList[x].codequipe, label: _this.equipeList[x].nome });
                                    }
                                }

                                _this.filtroStatusPedido.list = [{ id: -1, label: 'Todos' }];
                                if (_this.statusList.length > 0) {
                                    for (x = 0; x < _this.statusList.length; x++) {
                                        _this.filtroStatusPedido.list.push({ id: _this.statusList[x].codstatus, label: _this.statusList[x].descricao });
                                    }
                                }

                                _this.filtroFretes.list = [{ id: -1, label: 'Todos' }];
                                if (_this.freteList.length > 0) {
                                    for (x = 0; x < _this.freteList.length; x++) {
                                        _this.filtroFretes.list.push({ id: _this.freteList[x].id, label: _this.freteList[x].value });
                                    }
                                }

                            case 16:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        inicializa: function inicializa() {
            var obj = null;

            for (var x = 0; x < this.params.filtros.length; x++) {

                obj = this.base[this.params.filtros[x].nome];
                obj.nome = this.params.filtros[x].nome;

                if (this.params.filtros[x].label) obj.label = this.params.filtros[x].label;

                if (this.params.filtros[x].url) obj.url = this.params.filtros[x].url;

                if (this.params.filtros[x].varios) obj.varios = this.params.filtros[x].varios;

                //aqui carrega os valores para os filtros vindos do PARENT
                if (this.params.filtros[x].values && this.params.filtros[x].values.length > 0) {
                    obj.values = [];
                    for (var y = 0; y < this.params.filtros[x].values.length; y++) {
                        obj.values.push({ id: this.params.filtros[x].values[y] });
                    }
                    // console.log(obj.values)
                }
                //

                this.filtros.push(obj);
            }

            if (this.params.periodos) this.filtroPeriodos = this.params.periodos;else if (this.params.periodo) {
                this.filtroPeriodos = [{
                    label: this.params.periodo.label,
                    field: this.params.periodo.field,
                    varios: this.params.periodo.varios,
                    values: [{
                        data_inicio: this.params.periodo.data_inicio,
                        data_termino: this.params.periodo.data_termino,
                        startDate: this.params.periodo.data_inicio,
                        endDate: this.params.periodo.data_termino
                    }]
                }];
            }

            /*
            query string
            datainicial=99-99-9999&datafinal=99-99-9999&filial=1&grupoestoque=1&grupocliente=1
            */
        },
        change: function change() {
            var filtro = {};

            var periodos = [];

            for (var x = 0; x < this.filtroPeriodos.length; x++) {
                var hasvalue = false;
                for (var y = 0; y < this.filtroPeriodos[x].values.length; y++) {
                    this.filtroPeriodos[x].values[y].data_inicio = this.filtroPeriodos[x].values[y].startDate;
                    this.filtroPeriodos[x].values[y].data_termino = this.filtroPeriodos[x].values[y].endDate;
                    if (this.filtroPeriodos[x].values[y].data_inicio || this.filtroPeriodos[x].values[y].data_termino) hasvalue = true;
                }
                if (hasvalue) periodos.push(this.filtroPeriodos[x]);
            }

            filtro.periodos = periodos;

            this.params.periodos = periodos; //atualiza os periodos no objeto pai

            var obj = null;
            var values = null;

            for (var x = 0; x < this.filtros.length; x++) {
                values = [];
                for (var y = 0; y < this.filtros[x].values.length; y++) {
                    if (this.filtros[x].values[y].id) values.push(this.filtros[x].values[y].id);
                }
                if (values.length > 0) filtro[this.filtros[x].nome] = values;
            }

            if (this.params.checkbox && this.params.checkbox.length) {
                for (var x = 0; x < this.params.checkbox.length; x++) {
                    filtro[this.params.checkbox[x].nome] = this.params.checkbox[x].value;
                }
            }

            if (this.params.selects && this.params.selects.length) {
                for (var x = 0; x < this.params.selects.length; x++) {
                    if (this.params.selects[x].id) filtro[this.params.selects[x].nome] = this.params.selects[x];
                }
            }

            this.showMaisFiltros = false;

            this.$emit('change', filtro);
        },
        cancel: function cancel() {
            this.showMaisFiltros = false;
            this.$emit('cancel');
        },
        handlePeriodoChange: function handlePeriodoChange(index) {
            //alteracao de periodo
        },
        handleAdicionaFiltro: function handleAdicionaFiltro(flt, index) {
            flt.values.push({ id: null });
        },
        handleAdicionaPeriodo: function handleAdicionaPeriodo(idx) {
            this.filtroPeriodos[idx].values.push({ data_inicio: null, data_termino: null, startDate: null, endDate: null });

            // console.log(this.$route.query)

            // let query = JSON.parse(JSON.stringify(this.$route.query));
            // query.segmento = [1]

            // // this.$router.replace({ query: query })
            // window.location.hash = '#/?segmento=5'
            // console.log(window.location.hash.slice(1))
        },
        handleExcluiPeriodo: function handleExcluiPeriodo(idx, index) {
            this.filtroPeriodos[idx].values.splice(index, 1);
        },
        handleExcluiValueFiltro: function handleExcluiValueFiltro(flt, index) {
            flt.values.splice(index, 1);
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this2.$store.dispatch('loadSessao', _this2);

                            case 2:
                                _context2.next = 4;
                                return _this2.$store.dispatch('loadUsuariosDashboard', _this2);

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    },

    mounted: function mounted() {

        var vm = this;
        this.keytimer = setTimeout(function () {
            // console.log(vm.filtros)
            vm.show = true;
        }, 100);
    },
    created: function created() {
        this.preparaFiltro();
        this.inicializa();
    }
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compra_form__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pedido_compra_impressao_vue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], CompraForm: __WEBPACK_IMPORTED_MODULE_2__compra_form__["default"], PedidoCompraImpressao: __WEBPACK_IMPORTED_MODULE_3__pedido_compra_impressao_vue__["default"]
    },
    data: function data() {
        return {
            showForm: false,
            crud: '',
            selectedId: '',
            filter: '',
            monthFilter: {},
            offset: false,
            metadata: this.$store.getters.getEntities.metadata,
            showImpressao: false,
            filtroAvancado: {
                periodo: {
                    label: 'Data da compra',
                    varios: false,
                    data_inicio: null,
                    data_termino: null
                },

                filtros: [{ nome: 'clientefornecedor', label: null, url: null, varios: true, values: [] }]

            },
            filterList: [], //lista de filtros aplicados que são exibidos em tela

            codcompraImpressao: null
        };
    },

    computed: {
        compraList: function compraList() {
            return this.$store.getters.getCompraList || [];
        },
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        }
    },
    methods: {
        handleChangeFilter: function handleChangeFilter(url) {
            this.filter = url;
            this.loadData();
        },
        handleChangeAdvancedFilter: function handleChangeAdvancedFilter(filtro) {
            var arrUrl = [];

            var urlFilter = '';
            if (filtro.periodos && filtro.periodos.length > 0) {
                if (filtro.periodos[0].startDate && filtro.periodos[0].endDate) {
                    urlFilter = '{"data":{"$between":[{"$date":"' + Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiDateORDS"])(filtro.periodos[0].startDate) + '"},{"$date":"' + Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiDateORDS"])(filtro.periodos[0].endDate, true) + '"}]}}';
                    arrUrl.push(urlFilter);
                }
            }

            urlFilter = '';
            if (filtro.clientefornecedor && filtro.clientefornecedor.length > 0) {
                for (var x = 0; x < filtro.clientefornecedor.length; x++) {
                    if (urlFilter != '') {
                        urlFilter = urlFilter + ',';
                    }
                    urlFilter = urlFilter + '{"codpart":{"$eq":"' + filtro.clientefornecedor[x] + '"}}';
                }
                if (urlFilter != '') {
                    urlFilter = '{"$or":[' + urlFilter + ']}';
                    arrUrl.push(urlFilter);
                }
            }

            var url = '';
            for (var i = 0; i < arrUrl.length; i++) {
                if (i != 0) {
                    url = url + ',';
                }
                url = url + arrUrl[i];
            }
            if (url != '') url = '{"$and":[' + url + ']}';

            console.log(filtro);
            console.log(url);
            this.filter = url;
            this.loadData();
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                params = { filter: _this.filter };

                                if (_this.offset) {
                                    params.offset = _this.nextPage;
                                }
                                _context.next = 4;
                                return _this.$store.dispatch('loadCompraList', params);

                            case 4:
                                _this.offset = false;

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleNew: function handleNew() {
            this.selectedId = '';
            this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudI;
            this.showForm = true;
        },
        handleEdit: function handleEdit(id) {
            var view = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            this.selectedId = id;
            this.crud = view ? __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudView : __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudU;
            this.showForm = true;
        },
        handleAction: function handleAction(act, id) {
            if (act == 1) {
                this.onImprimir(id);
            }
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            var str = value.toUpperCase();
            this.filter = JSON.stringify({
                "$or": [{ "npedido": { "$like": "%25" + str + "%25" } }, { "nome_fornecedor": { "$like": "%25" + str + "%25" } }]
            });
            this.loadData();
        },
        scroll: function scroll() {
            var _this2 = this;

            window.onscroll = function () {
                if (_this2.showForm || _this2.nextPage == 0 || _this2.offset) return;
                var bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= document.documentElement.offsetHeight - 2;
                if (bottomOfWindow) {
                    _this2.offset = true;
                    _this2.loadData();
                }
            };
        },
        statusLabel: function statusLabel(s) {
            var labels = { 'A': 'Aberto', 'F': 'Finalizado', 'C': 'Cancelado' };
            return labels[s] || s;
        },
        statusClass: function statusClass(s) {
            var classes = { 'A': 'badge-blue', 'F': 'badge-green', 'C': 'badge-red' };
            return classes[s] || 'badge-gray';
        },
        onImprimir: function onImprimir(id) {
            this.codcompraImpressao = id;
            this.showImpressao = true;
            this.$nextTick(function () {
                this.$refs.impressao.print();
            });
        },
        handleClosePrint: function handleClosePrint() {
            this.showImpressao = false;
        }
    },
    mounted: function mounted() {
        this.filter = this.monthFilter.url; //carrega as notas do mes corrente
        this.loadData();
        this.scroll();
    },
    created: function created() {
        this.loadData();
    },
    destroyed: function destroyed() {
        window.onscroll = null;
    }
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_compra_form_vue__ = __webpack_require__(559);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbe9aaf6_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_compra_form_vue__ = __webpack_require__(1563);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_compra_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbe9aaf6_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_compra_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_compra__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_compra___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__api_api_compra__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pedido_compra_impressao_vue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compra_itens_vue__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compra_parcelas_vue__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__api_api_compra___default.a],
  components: {
    PedidoCompraImpressao: __WEBPACK_IMPORTED_MODULE_2__pedido_compra_impressao_vue__["default"],
    compraItens: __WEBPACK_IMPORTED_MODULE_3__compra_itens_vue__["a" /* default */],
    compraParcelas: __WEBPACK_IMPORTED_MODULE_4__compra_parcelas_vue__["a" /* default */]
  },
  props: {
    id: '',
    crud: ''
  },
  data: function data() {
    return {
      MODULO: 'purchase/compra/',
      showFormEmail: false,
      showImpressao: false,
      metadata: this.$store.getters.getEntities.metadata,
      compra: _extends({}, this.$store.getters.getEntities.compra),
      errmessages: [],
      localCrud: ''
    };
  },

  watch: {},
  computed: {
    isView: function isView() {
      return this.compra.status !== 'A' || this.compra.financeiro === 'S' || this.localCrud === __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudView;
    },
    subtotal: function subtotal() {
      return (this.compra.comprait || []).reduce(function (acc, item) {
        return acc + (item.total || 0);
      }, 0);
    },
    moreActions: function moreActions() {
      var actions = [];
      if (this.compra.codcompra && this.compra.codcompra !== 'novo') {
        actions.push({ action: 'duplicar', label: 'Duplicar', icon: 'fa-copy' });
        actions.push({ action: 'imprimir', label: 'Imprimir', icon: 'fa-print' });
        actions.push({ action: 'email', label: 'Enviar E-mail', icon: 'fa-envelope' });

        if (this.compra.status === 'A') {
          if (this.compra.financeiro === 'N') {
            actions.push({ action: 'integrar_fin', label: 'Integrar Financeiro', icon: 'fa-money' });
          } else {
            actions.push({ action: 'excluir_fin', label: 'Excluir Financeiro', icon: 'fa-trash' });
          }
          actions.push({ action: 'lancar_entrada', label: 'Lançar Entrada', icon: 'fa-sign-in' });
          actions.push({ action: 'cancelar', label: 'Cancelar Pedido', icon: 'fa-times', danger: true });
        }
      }
      return actions;
    }
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var isNovo;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isNovo = _this.id === 'novo' || _this.crud === __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI;

              _this.localCrud = isNovo ? __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI : _this.crud || __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudU;

              if (isNovo) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return _this.loadData(_this.id);

            case 5:
              _context.next = 13;
              break;

            case 7:
              _this.compra = _extends({}, _this.$store.getters.getEntities.compra);
              _this.compra.data = _this.$getDate();
              _this.compra.status = 'A';
              _this.compra.financeiro = 'N';
              if (!_this.compra.comprait) _this.$set(_this.compra, 'comprait', []);
              if (!_this.compra.comprapar) _this.$set(_this.compra, 'comprapar', []);

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    updateDescFromPerc: function updateDescFromPerc() {
      this.compra.vlrdesc = Number((this.subtotal * (Number(this.compra.percdesc || 0) / 100)).toFixed(2));
      this.calculateTotals();
    },
    handleItemsChange: function handleItemsChange() {
      if (this.subtotal === 0) {
        this.compra.vlrfrete = 0;
        this.compra.vlrdesc = 0;
        this.compra.percdesc = 0;
      }
      this.calculateTotals();
    },
    calculateTotals: function calculateTotals() {
      var itens = this.compra.comprait || [];
      this.compra.toticm = itens.reduce(function (acc, it) {
        return acc + (it.vicms || 0);
      }, 0);
      this.compra.totimp = itens.reduce(function (acc, it) {
        return acc + ((it.vipi || 0) + (it.vibs || 0) + (it.vcbs || 0));
      }, 0);

      if (this.compra.percdesc > 0) {
        this.compra.vlrdesc = Number((this.subtotal * (Number(this.compra.percdesc || 0) / 100)).toFixed(2));
      }

      var total = Number(this.subtotal || 0.0) + Number(this.compra.vlrfrete || 0.0) + Number(this.compra.totimp || 0.0);
      this.compra.totdesc = Number(this.compra.vlrdesc || 0);
      this.compra.totpedido = total - this.compra.totdesc;
    },
    loadData: function loadData(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var selectedId, validation;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                selectedId = id || _this2.id || _this2.compra.codcompra;

                if (!(selectedId && selectedId !== 'novo')) {
                  _context2.next = 10;
                  break;
                }

                _this2.$appLoading(true);
                _context2.next = 6;
                return _this2.$store.dispatch('loadCompra', { id: selectedId });

              case 6:
                _this2.compra = _extends({}, _this2.$store.getters.getCompra);
                if (!_this2.compra.comprait) _this2.$set(_this2.compra, 'comprait', []);
                if (!_this2.compra.comprapar) _this2.$set(_this2.compra, 'comprapar', []);
                if (_this2.compra.validation) {
                  validation = JSON.parse(_this2.compra.validation);

                  _this2.errmessages = validation.errmessages || [];
                } else {
                  _this2.errmessages = [];
                }

              case 10:
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](0);

                _this2.$erpToastError('Erro ao carregar dados do pedido');

              case 15:
                _context2.prev = 15;

                _this2.$appLoading(false);
                return _context2.finish(15);

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 12, 15, 18]]);
      }))();
    },
    handleSave: function handleSave() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var isValid, method, url, response, item, validation;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$validator.validateAll();

              case 2:
                isValid = _context3.sent;

                if (isValid) {
                  _context3.next = 6;
                  break;
                }

                _this3.$erpToastError('Por favor, corrija os campos em destaque');
                return _context3.abrupt('return');

              case 6:
                method = _this3.localCrud === __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI ? 'post' : 'put';
                url = _this3.MODULO + (method === 'put' ? _this3.compra.codcompra : '');
                _context3.next = 10;
                return Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["apiORDSpost"])(_this3.$store, url, { compra: _this3.compra }, method);

              case 10:
                response = _context3.sent;


                if (response && response.items && response.items.length > 0) {
                  item = response.items[0];

                  if (item.validation) {
                    validation = JSON.parse(item.validation);

                    _this3.errmessages = validation.errmessages || [];
                    _this3.$erpToastError(validation.message || 'Erro ao salvar pedido');
                  } else {
                    _this3.$erpToastSuccess('Pedido salvo com sucesso');
                    _this3.$emit('closeform', item.codcompra);
                  }
                } else if (response && response.errmessages) {
                  _this3.errmessages = response.errmessages;
                  _this3.$erpToastError('Erro ao salvar pedido');
                }

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleRetorna: function handleRetorna() {
      this.$emit('closeform');
    },
    handleDelete: function handleDelete() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var url, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                url = _this4.MODULO + _this4.compra.codcompra;
                _context4.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["apiORDSdelete"])(_this4.$store, url);

              case 3:
                res = _context4.sent;

                if (res && res.error) {
                  _this4.$erpToastError(res.error);
                } else {
                  _this4.$erpToastSuccess('Pedido excluído com sucesso');
                  _this4.handleRetorna();
                }

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    handleAction: function handleAction(actionId) {
      var actions = {
        'duplicar': this.onDuplicar,
        'imprimir': this.onImprimir,
        'email': this.onEmail,
        'integrar_fin': this.onIntegrarFin,
        'excluir_fin': this.onExcluirFin,
        'lancar_entrada': this.onLancarEntrada,
        'cancelar': this.onCancelar
      };
      if (actions[actionId]) actions[actionId]();
    },
    onDuplicar: function onDuplicar() {
      var _this5 = this;

      this.apiDuplicaCompra(this.compra.codcompra, function (res) {
        if (res.error) {
          _this5.$erpToastError(res.error);
        } else {
          _this5.$erpToastSuccess('Pedido duplicado com sucesso');
          _this5.$emit('closeform', res.codcompra);
        }
      });
    },
    onImprimir: function onImprimir() {
      this.showImpressao = true;
      this.$nextTick(function () {
        this.$refs.impressao.print();
      });
    },
    onEmail: function onEmail() {
      this.showFormEmail = true;
    },
    closeFormEmail: function closeFormEmail() {
      this.showFormEmail = false;
    },
    handleClosePrint: function handleClosePrint() {
      this.showImpressao = false;
    },
    handleSendEmail: function handleSendEmail(data) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.closeFormEmail();
                _context5.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["apiEmailPDF"])(_this6, 'purchaseorder/' + _this6.compra.codcompra, data);

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    onIntegrarFin: function onIntegrarFin() {
      var _this7 = this;

      this.apiIntegraFinanceiroCompra(this.compra.codcompra, function (res) {
        if (res && res.validation) {
          var validation = typeof res.validation === 'string' ? JSON.parse(res.validation) : res.validation;
          _this7.$erpToastError(validation.message || 'Erro na integração');
        } else {
          _this7.$erpToastSuccess('Financeiro integrado com sucesso');
          _this7.loadData();
        }
      });
    },
    onExcluirFin: function onExcluirFin() {
      var _this8 = this;

      this.apiExcluirFinanceiroCompra(this.compra.codcompra, function (res) {
        if (res && res.validation) {
          var validation = typeof res.validation === 'string' ? JSON.parse(res.validation) : res.validation;
          _this8.$erpToastError(validation.message || 'Erro ao excluir financeiro');
        } else {
          _this8.$erpToastSuccess('Financeiro excluído com sucesso');
          _this8.loadData();
        }
      });
    },
    onLancarEntrada: function onLancarEntrada() {
      this.$router.push({ path: '/nf/' + this.compra.codcompra, query: { tipo: 'entrada' } });
    },
    onCancelar: function onCancelar() {
      var _this9 = this;

      this.apiCancelaCompra(this.compra.codcompra, function (res) {
        if (res && res.validation) {
          var validation = typeof res.validation === 'string' ? JSON.parse(res.validation) : res.validation;
          _this9.$erpToastError(validation.message || 'Erro ao cancelar pedido');
        } else {
          _this9.$erpToastSuccess('Pedido cancelado com sucesso');
          _this9.loadData();
        }
      });
    }
  }
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pedido_compra_content_pdf_vue__ = __webpack_require__(1552);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        PedidoCompraContentPdf: __WEBPACK_IMPORTED_MODULE_1__pedido_compra_content_pdf_vue__["a" /* default */]
    },
    props: {
        index: {
            type: Number,
            require: true
        }
    },
    data: function data() {
        return {
            compra: null,
            uuid: null,
            image: null
        };
    },

    computed: {
        orderId: function orderId() {
            if (this.compra) {
                return 'Pedido de Compra: ' + this.compra.npedido;
            }
        }
    },
    methods: {
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var data, _data, self;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                console.log(_this.uuid);

                                if (!_this.uuid) {
                                    _context.next = 8;
                                    break;
                                }

                                _context.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSapp"])(_this, 'linkpdf/imprimircompra/' + _this.uuid, 'get', null);

                            case 4:
                                data = _context.sent;

                                if (data) {
                                    _this.compra = data.items[0];
                                    if (_this.compra.filial.length && _this.compra.filial[0].logotipo) {
                                        _this.image = 'data:image/jpeg;base64,' + _this.compra.filial[0].logotipo;
                                    }
                                    _this.print();
                                }
                                _context.next = 17;
                                break;

                            case 8:
                                _context.next = 10;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDS"])(_this.$store.getters.urlOrds + 'purchase/compra/' + _this.index + '/print', null);

                            case 10:
                                _data = _context.sent;

                                if (!_data) {
                                    _context.next = 17;
                                    break;
                                }

                                if (!(!_this.image && _data.items[0].filial.length)) {
                                    _context.next = 16;
                                    break;
                                }

                                self = _this;
                                _context.next = 16;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSmidia"])(_this.$store.getters.urlApp + 'logo/download/' + _data.items[0].filial[0].codempresa + '/' + _data.items[0].filial[0].codfil).then(function (response) {
                                    if (response && response.size > 0) {
                                        var reader = new window.FileReader();
                                        reader.readAsDataURL(response);
                                        reader.onload = function () {
                                            self.image = reader.result;
                                        };
                                    }
                                });

                            case 16:
                                _this.compra = _data.items[0];

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        printHtmlContent: function printHtmlContent(htmlContent) {
            var filename = this.orderId;
            filename = filename.replace(': ', '') + '.pdf';
            var sendData = { header: htmlContent[0], body: htmlContent[1] };
            Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiDownloadPDF"])(this, '/htmlpdf', sendData, 'post', false, filename);
            this.$emit('close');
        },
        print: function print() {
            this.$refs.pedidoContentPdf.getHtmlContent();
        }
    },
    created: function created() {
        console.log(this.$route);
        if (this.$route.name == 'imprimir-compra') {
            if (this.$route.query && this.$route.query.uuid) {
                this.uuid = this.$route.query.uuid;
            } else {
                this.$router.push('/login');
                return;
            }
        }

        this.loadData();
    }
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: null,
        compra: null,
        uuid: null,
        image: null
    },
    methods: {
        formatFrete: function formatFrete(tipo) {
            var types = {
                'R': 'Remetente (CIF)',
                'D': 'Destinatário (FOB)',
                'S': 'Sem Frete'
            };
            return types[tipo] || tipo;
        },
        getHtmlContent: function getHtmlContent() {
            var _this = this;

            setTimeout(function () {
                var contentHeader = document.getElementById('header').innerHTML;
                var contentBody = document.getElementById('body').innerHTML;
                var htmlContent = [contentHeader, contentBody];
                _this.$emit('handleHtmlContent', htmlContent);
            }, 1000);
        }
    }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compra_item_vue__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { compraItem: __WEBPACK_IMPORTED_MODULE_0__compra_item_vue__["a" /* default */] },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    readonly: Boolean,
    metadata: Object
  },
  data: function data() {
    return {
      showModal: false,
      selectedIndex: null,
      selectedItem: {}
    };
  },

  methods: {
    handleEditItem: function handleEditItem(index) {
      this.selectedIndex = index;
      this.selectedItem = index !== null ? _extends({}, this.value[index]) : { quantidade: 1, preco: 0, total: 0 };
      this.showModal = true;
    },
    saveItem: function saveItem(item) {
      var newValue = [].concat(_toConsumableArray(this.value || []));
      if (this.selectedIndex !== null) {
        newValue[this.selectedIndex] = item;
      } else {
        newValue.push(item);
      }
      this.$emit('input', newValue);
      this.$emit('change');
      this.showModal = false;
    },
    handleRemoveItem: function handleRemoveItem(index) {
      var newValue = [].concat(_toConsumableArray(this.value || []));
      newValue.splice(index, 1);
      this.$emit('input', newValue);
      this.$emit('change');
    }
  }
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  props: ['value', 'metadata'],
  data: function data() {
    return {
      item: _extends({}, this.value)
    };
  },

  methods: {
    handleProductSelect: function handleProductSelect(prod) {
      if (prod) {
        this.item.coditem = prod.coditem;
        this.item.dscitem = prod.descricao;
        this.item.unidade = prod.uni;
        this.item.preco = prod.precocusto || prod.precovenda || prod.vlrtab;
        this.updateTotal();
      }
    },
    updateTotal: function updateTotal() {
      this.item.total = (this.item.quantidade || 0) * (this.item.preco || 0);
    },
    handleSave: function handleSave() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit('save', _this.item);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_numbers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_numbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_numbers__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    total: {
      type: Number,
      default: 0
    },
    readonly: Boolean,
    metadata: Object,
    qtParcelas: [Number, String]
  },
  data: function data() {
    return {
      localQtParcelas: this.qtParcelas || '0'
    };
  },

  watch: {
    qtParcelas: function qtParcelas(newVal) {
      this.localQtParcelas = newVal || '0';
    },
    localQtParcelas: function localQtParcelas(newVal) {
      this.$emit('update:qtParcelas', newVal);
    }
  },
  computed: {
    totalParcelas: function totalParcelas() {
      return (this.value || []).reduce(function (acc, p) {
        return acc + (Number(p.valor) || 0);
      }, 0);
    },
    totalDiff: function totalDiff() {
      return Number((this.total - this.totalParcelas).toFixed(2));
    },
    parcelaOptions: function parcelaOptions() {
      if (this.metadata && this.metadata.compra && this.metadata.compra.parcelas) {
        return this.metadata.compra.parcelas.options;
      }
      var opts = [{ id: '0', text: 'À Vista' }];
      for (var i = 1; i <= 36; i++) {
        opts.push({ id: String(i), text: i + 'x' });
      }
      return opts;
    }
  },
  methods: {
    calculaParcelas: function calculaParcelas() {
      var numParcelas = Number(this.localQtParcelas);
      var novasParcelas = [];
      var vlr = 0;
      var baseDate = new Date().toISOString().substr(0, 10);

      if (numParcelas === 0) {
        novasParcelas.push({
          parcela: 1,
          dtvenc: baseDate,
          valor: this.total,
          dias: 0,
          percentual: 100,
          formapag: ''
        });
      } else {
        for (var x = 1; x <= numParcelas; x++) {
          var parcela = {
            parcela: x,
            dtvenc: this.$addMonths(baseDate, x),
            dias: x * 30,
            percentual: Number((100 / numParcelas).toFixed(2)),
            formapag: ''
          };
          vlr = this.total;
          vlr = Object(__WEBPACK_IMPORTED_MODULE_1__shared_numbers__["arr"])(vlr / numParcelas, 2, true);
          parcela.valor = vlr;
          novasParcelas.push(parcela);
        }

        // Fix rounding errors in the last installment
        var sum = novasParcelas.reduce(function (acc, p) {
          return acc + (Number(p.valor) || 0);
        }, 0);
        if (sum !== this.total && novasParcelas.length > 0) {
          var diff = Number((this.total - sum).toFixed(2));
          novasParcelas[novasParcelas.length - 1].valor = Number((novasParcelas[novasParcelas.length - 1].valor + diff).toFixed(2));
        }
      }
      this.$emit('input', novasParcelas);
      this.$emit('change');
    },
    handleRemoveParcela: function handleRemoveParcela(index) {
      var newValue = [].concat(_toConsumableArray(this.value || []));
      newValue.splice(index, 1);
      this.$emit('input', newValue);
      this.$emit('change');
    },
    updateDate: function updateDate(index) {
      var par = this.value[index];
      if (!par) return;
      par.dtvenc = this.$addDays(new Date().toISOString().substr(0, 10), par.dias);
    },
    updateDays: function updateDays(index) {
      var par = this.value[index];
      if (!par) return;
      par.dias = this.$daysBetween(new Date().toISOString().substr(0, 10), par.dtvenc);
    },
    updateValueFromPerc: function updateValueFromPerc(index) {
      var par = this.value[index];
      if (!par) return;
      par.valor = Number((this.total * (par.percentual / 100)).toFixed(2));
    },
    updatePercFromValue: function updatePercFromValue(index) {
      var par = this.value[index];
      if (!par) return;
      par.percentual = this.total > 0 ? Number((par.valor / this.total * 100).toFixed(2)) : 0;
    }
  }
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__regrafcp_form__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao
            codregrafcp: 0,
            empty: false
        };
    },


    computed: {
        metadata: function metadata() {
            return this.$store.getters.getEntities.metadata;
        },
        regraList: function regraList() {
            return this.$store.getters.getRegrafcpList;
        }
    },

    methods: {
        handleEdit: function handleEdit(codregrafcp) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudU;
            this.codregrafcp = codregrafcp;
            this.showForm = true;
        },
        handleIncluir: function handleIncluir() {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudI;
            this.codregrafcp = 0;
            this.showForm = true;
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"ncm":{"$like":"' + value + '%25"}}';
            this.loadData();
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadRegrafcpList', { filter: _this.filter });

                            case 2:
                                if (_this.regraList.length == 0) {
                                    _this.empty = true;
                                } else {
                                    _this.empty = false;
                                }

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        textFinalidade: function textFinalidade(value) {
            if (this.metadata) {
                var item = this.metadata.regrafcp.finalidade.options.filter(function (x) {
                    return x.id === value;
                });
                if (item.length) {
                    return item[0].text;
                }
            } else {
                return value;
            }
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], RegrafcpForm: __WEBPACK_IMPORTED_MODULE_2__regrafcp_form__["a" /* default */]
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["formatValue"])(value, 2);
        }

    },

    mounted: function mounted() {},
    beforeDestroy: function beforeDestroy() {},
    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            regrafcp: _extends({}, this.$store.getters.getEntities.regrafcp),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
            estadoList: [],
            saveAndNew: false
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }
    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        loadEstados: function loadEstados() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadEstadoRegras');

                            case 2:
                                if (_this.$store.getters.getEstadoList) {
                                    _this.estadoList = _this.$store.getters.getEstadoList.map(function (obj) {
                                        return { id: obj.uf, text: obj.uf };
                                    });
                                }

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleSave: function handleSave(saveAndNew) {
            var _this2 = this;

            //BOTAO SALVAR
            this.saveAndNew = saveAndNew;
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this2.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this2.apiPost();
                }
            });
        },
        addNew: function addNew() {
            //inclui novo registro após gravação do registro anterior (botao salvar e adicionar novo)
            this.regrafcp.ncm = null;
            this.regrafcp.exncm = null;
            this.regrafcp.afcp = null;
            this.regrafcp.afcpst = null;
            this.saveAndNew = false;
            this.$refs.uf.$el.querySelector('select').focus();
            //limpa os erros de validação
            this.$nextTick(function () {
                this.$validator.reset();
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO Excluir
            this.apiDelete();
        },
        loadData: function loadData() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this3.$store.dispatch('loadRegrafcp', { id: _this3.index });

                            case 2:
                                if (_this3.$store.getters.getRegrafcp) {
                                    _this3.regrafcp = _extends({}, _this3.$store.getters.getRegrafcp);
                                }

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/regrafcp/' + _this4.regrafcp.codregrafcp;
                                _context3.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this4.$store, modulo);

                            case 3:
                                data = _context3.sent;

                                _this4.$erpToastDeleted();
                                _this4.closeForm();

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        apiPost: function apiPost() {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/regrafcp/';
                                sendData = { regrafcp: [] };


                                sendData.regrafcp.push(_this5.regrafcp);

                                metodo = 'post';
                                update = false;

                                if (_this5.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context4.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this5.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context4.sent;

                                if (data.errmessages) {
                                    _this5.errmessages = data.errmessages;
                                    _this5.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this5.$erpToastUpdated();
                                    } else {
                                        _this5.$erpToastInserted();
                                    }
                                    _this5.errmessages = {};
                                    if (!_this5.saveAndNew) {
                                        _this5.closeForm();
                                    } else {
                                        _this5.addNew();
                                    }
                                }

                            case 10:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.loadEstados();

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }

        this.$refs.uf.$el.querySelector('select').focus();
    }
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__regrast_form__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao
            ufori: '',
            ncm: '',
            finalidade: '',
            empty: false
        };
    },


    computed: {
        metadata: function metadata() {
            return this.$store.getters.getEntities.metadata;
        },
        regraList: function regraList() {
            return this.$store.getters.getRegrastList;
        }
    },

    methods: {
        handleEdit: function handleEdit(ufori, finalidade, ncm) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.finalidade = finalidade;
            this.ncm = ncm;
            this.ufori = ufori;
            this.showForm = true;
        },
        handleIncluir: function handleIncluir(codpart) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codpart = codpart;
            this.showForm = true;
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"ncm":{"$like":"' + value + '%25"}}';
            this.loadData();
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadRegrastList', { filter: _this.filter });

                            case 2:
                                if (_this.regraList.length == 0) {
                                    _this.empty = true;
                                } else {
                                    _this.empty = false;
                                }

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        textFinalidade: function textFinalidade(value) {
            if (this.metadata) {
                var item = this.metadata.regrast.finalidade.options.filter(function (x) {
                    return x.id === value;
                });
                if (item.length) {
                    return item[0].text;
                }
            } else {
                return value;
            }
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], RegrastForm: __WEBPACK_IMPORTED_MODULE_2__regrast_form__["a" /* default */]
    },

    mounted: function mounted() {},
    beforeDestroy: function beforeDestroy() {},
    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/*
- falta incluir mais ncms
- obrigatorio informar mva, %icms st, vlr pauta
- % icms fcp
- importar tabela de ncms
- lista de regras (estado origem, finalidade, ncm)

*/




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        crud: '',
        ufori: '',
        finalidade: '',
        ncm: ''
    },

    data: function data() {
        return {
            crudText: '',

            metadata: this.$store.getters.getEntities.metadata,
            regrast: _extends({}, this.$store.getters.getEntities.regrast),

            lFinalidade: '',
            lUfori: '',
            lNcm: '',

            regrastList: [],
            estadoList: [],

            showMessage: false,
            message: '',
            showHint: true,
            showRegras: false,
            showError: false
        };
    },


    computed: {},

    watch: {},

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleCloseForm: function handleCloseForm() {
            if (this.changed) {
                // se ocorreu alguma alteração exibe mensagem antes de fechar
                this.showMessageModal('closeform');
            } else {
                this.closeForm();
            }
        },
        handleDescartar: function handleDescartar() {
            this.showRegras = false;
            this.regrastList = [];
        },
        handleConfirmMessage: function handleConfirmMessage() {
            //EVENTO DO BOTAO "CONFIRMAR" DA MENSAGEM
            if (this.codeMessage == 'closeform') {
                //fecha o formulario e retornar para o anterior
                this.closeMessage();
                this.closeForm();
            }
        },
        showMessageModal: function showMessageModal(code) {
            //exibe uma mensagem em "code"
            this.codeMessage = code;
            this.showMessage = true;
        },
        closeMessage: function closeMessage() {
            this.showMessage = false;
        },
        validate: function validate() {
            var lErro = false;
            var validate = '';

            for (var x = 0; x < this.regrastList.length; x++) {
                validate = '';
                if (this.regrastList[x].mva > 99) {
                    validate = 'O valor informado para o MVA é inválido';
                } else if (this.regrastList[x].aicmst > 99) {
                    validate = 'O valor informado para o % ICMS é inválido';
                } else if (this.regrastList[x].ricmst > 99) {
                    validate = 'O valor informado para a Red ICMS é inválido';
                } else if (this.regrastList[x].aicmst > 0) {
                    if (this.regrastList[x].mva == null || this.regrastList[x].mva == 0) {
                        if (this.regrastList[x].pautaicmst == null || this.regrastList[x].pautaicmst == 0) {
                            validate = 'Obrigatório informar MVA ou valor de pauta';
                        }
                    }
                }
                if (validate.length > 0) {
                    lErro = true;
                    this.$set(this.regrastList[x], 'validate', validate);
                } else {
                    this.$set(this.regrastList[x], 'validate', '');
                }
            }

            if (lErro) {
                this.$erpToastError('Por favor corrija os erros para continuar.');
            } else {
                this.apiPost();
            }
        },
        loadEstados: function loadEstados() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadEstadoRegras');

                            case 2:
                                if (_this.$store.getters.getEstadoList) {
                                    _this.estadoList = _this.$store.getters.getEstadoList;
                                }

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleContinuar: function handleContinuar() {
            var _this2 = this;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this2.showError = true;
                } else {
                    _this2.showError = false;
                    _this2.loadRegra();
                }
            });
        },
        loadRegra: function loadRegra() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params, x, regrast;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //carrega a lista de regras relacionadas ao estado de origem, finalidade e ncm informados.
                                //para facilitar o preenchimento, a lista é carregada com os estados de destino mesmo que nao exista regras cadastradas.
                                params = { path: _this3.lUfori + '/' + _this3.lFinalidade + '/' + _this3.lNcm };
                                _context2.next = 3;
                                return _this3.$store.dispatch('loadRegrast', params);

                            case 3:
                                if (_this3.$store.getters.getRegrast && _this3.$store.getters.getRegrast.length > 0) {
                                    _this3.regrastList = _this3.$store.getters.getRegrast;
                                } else {
                                    _this3.regrastList = [];
                                    for (x = 0; x < _this3.estadoList.length; x++) {
                                        regrast = _extends({}, _this3.regrast);

                                        regrast.ufdest = _this3.estadoList[x].uf;
                                        regrast.ufori = _this3.lUfori;
                                        regrast.finalidade = _this3.lFinalidade;
                                        regrast.ncm = _this3.lNcm;
                                        regrast.optsimples = 'S';
                                        regrast.stregrast = 'A';
                                        _this3.regrastList.push(regrast);
                                    }
                                }
                                _this3.showHint = false;
                                _this3.showRegras = true;

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiDelete: function apiDelete(del) {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a exclusao do participante

                                modulo = 'cg/regrast/' + _this4.part.codpart;
                                sendData = {};
                                _context3.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this4.$store, modulo);

                            case 4:
                                data = _context3.sent;

                                _this4.$erpToastSuccess('A Regra foi excluída.');
                                _this4.closeForm();

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        apiPost: function apiPost() {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var modulo, sendData, metodo, data;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                //efetua a gravacao das regras

                                modulo = 'cg/regrast/';
                                sendData = {};

                                //this.part.partcontato = this.partcontato

                                sendData = { regrast: _this5.regrastList };

                                metodo = 'post';
                                _context4.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this5.$store, modulo, sendData, metodo);

                            case 6:
                                data = _context4.sent;

                                _this5.$erpToastSuccess('As regras foram gravadas com sucesso');
                                _this5.showRegras = false;
                                if (_this5.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU) {
                                    _this5.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        }
    },

    created: function created() {
        this.loadEstados();

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.lFinalidade = 'I';

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU) {
            //if (this.ufori && this.finalidade && this.ncm) {
            this.showHint = false;
            this.lUfori = this.ufori;
            this.lFinalidade = this.finalidade;
            this.lNcm = this.ncm;
            this.loadRegra();
        }
    }
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__regraimp_form__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao
            codgrutrib: null
        };
    },


    computed: {
        metadata: function metadata() {
            return this.$store.getters.getEntities.metadata;
        },
        regraList: function regraList() {
            return this.$store.getters.getRegraimpList;
        },
        grutribList: function grutribList() {
            return this.$store.getters.getGrutribList;
        },
        empty: function empty() {
            return !this.regraList || this.regraList.length == 0;
        }

    },

    methods: {
        handleEdit: function handleEdit(codgrutrib) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.codgrutrib = codgrutrib;
            this.showForm = true;
        },
        handleIncluir: function handleIncluir() {
            //abre a tela de inclusao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.showForm = true;
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"descricao":{"$like":"' + value + '%25"}}';
            this.loadData();
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadGrutribList', { filter: _this.filter });

                            case 2:
                                if (_this.regraList.length == 0) {
                                    _this.empty = true;
                                } else {
                                    _this.empty = false;
                                }

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        textFinalidade: function textFinalidade(value) {
            if (this.metadata) {
                var item = this.metadata.regraimp.finalidade.options.filter(function (x) {
                    return x.id === value;
                });
                if (item.length) {
                    return item[0].text;
                }
            } else {
                return value;
            }
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], RegraimpForm: __WEBPACK_IMPORTED_MODULE_2__regraimp_form__["a" /* default */]
    },

    mounted: function mounted() {},
    beforeDestroy: function beforeDestroy() {},
    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__regraimp_add_form__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    crud: '',
    codgrutrib: ''
  },

  components: {
    regraimpAdd: __WEBPACK_IMPORTED_MODULE_2__regraimp_add_form__["a" /* default */]
  },

  data: function data() {
    return {
      crudText: '',

      metadata: this.$store.getters.getEntities.metadata,
      regraimp: _extends({}, this.$store.getters.getEntities.regraimp),
      grutrib: _extends({}, this.$store.getters.getEntities.grutrib),

      lFinalidade: '',
      lUfori: '',
      lNcm: '',

      regraimpList: [], //array de regras de impostos (tabela regraimp)
      grutribncmList: [], //lista de ncms do grupo de tributacao (tabela grutribncm)
      grutribitemList: [], //lista de produtos do grupo de tributacao (tabela grutribitem)
      estadoList: [],
      controleVisualizacao: [],

      adicionaRegraShow: false,

      showMessage: false,
      message: '',
      showError: false,
      unwatch: false,

      filtroEstado: '*',
      filtroFinalidade: '*',

      tabs: [{ title: 'NCMs Vinculadas ao Grupo' }, { title: 'Produtos Vinculados' }, { title: 'Regras Vinculadas ao Grupo' }],
      activeTab: 0, //pagina ativa

      close: false

    };
  },


  computed: {
    countRegrasValidas: function countRegrasValidas() {
      return this.regraimpList.filter(function (x) {
        return x.stregraimp != 'I' && x.vencida != 'S';
      }).length;
    },
    countRegrasVencidas: function countRegrasVencidas() {
      return this.regraimpList.filter(function (x) {
        return x.vencida === 'S';
      }).length;
    },
    countRegrasDesativadas: function countRegrasDesativadas() {
      return this.regraimpList.filter(function (x) {
        return x.stregraimp === 'I';
      }).length;
    },
    filtroEstadosList: function filtroEstadosList() {
      var distinctEstados = [].concat(_toConsumableArray(new Set(this.regraimpList.map(function (obj) {
        return obj.ufdest;
      }))));
      var list = distinctEstados.map(function (value) {
        return { id: value, text: value };
      });
      list.unshift({ id: '*', text: 'Estado (Todos)' });
      return list;
    },
    filtroFinalidadesList: function filtroFinalidadesList() {
      var vm = this;
      var distinct = [].concat(_toConsumableArray(new Set(this.regraimpList.map(function (obj) {
        return obj.finalidade;
      }))));
      var list = distinct.map(function (value) {
        return { id: value, text: vm.textFinalidade(value) };
      });
      list.unshift({ id: '*', text: 'Finalidade (Todas)' });
      return list;
    },
    distinctEstadosList: function distinctEstadosList() {
      var _this = this;

      var distinctEstados = [].concat(_toConsumableArray(new Set(this.regraimpList.map(function (obj) {
        return obj.ufdest;
      }))));
      var list = distinctEstados.map(function (value) {
        return { ufdest: value };
      });
      if (this.filtroEstado == '*') {
        return list;
      } else {
        return list.filter(function (obj) {
          return obj.ufdest === _this.filtroEstado;
        });
      }
    }
  },

  watch: {
    grutribncmList: {
      handler: function handler(val, oldval) {
        if (this.unwatch) {
          return;
        }
        this.ncmCheck();
      },
      deep: true
    },

    filtroFinalidade: function filtroFinalidade(val) {
      // console.log(val)
    },

    filtroEstado: function filtroEstado(val) {
      // console.log(val)
    }
  },

  filter: {},

  methods: {
    removerFiltros: function removerFiltros() {
      this.filtroEstado = '*';
      this.filtroFinalidade = '*';
    },
    textFinalidade: function textFinalidade(value) {
      if (this.metadata) {
        var item = this.metadata.regraimp.finalidade.options.filter(function (x) {
          return x.id === value;
        });
        if (item.length > 0) {
          return item[0].text;
        }
      } else {
        return value;
      }
    },
    formatDate: function formatDate(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["formatDate"])(value);
    },
    visualizaRegra: function visualizaRegra(codregraimp) {
      return this.controleVisualizacao.indexOf(codregraimp) >= 0;
    },
    openRegra: function openRegra(regra) {
      var x = this.controleVisualizacao.indexOf(regra.codregraimp);
      if (x >= 0) {
        this.controleVisualizacao.splice(x, 1);
      } else {
        this.controleVisualizacao.push(regra.codregraimp);
      }
    },
    closeForm: function closeForm() {
      this.$emit('closeform');
    },
    handleCloseForm: function handleCloseForm() {
      if (this.changed) {
        // se ocorreu alguma alteração exibe mensagem antes de fechar
        this.showMessageModal('closeform');
      } else {
        this.closeForm();
      }
    },
    changeTab: function changeTab(idx) {
      //mudança de pagina
      this.activeTab = idx;
    },
    handleConfirmMessage: function handleConfirmMessage() {
      //EVENTO DO BOTAO "CONFIRMAR" DA MENSAGEM
      if (this.codeMessage == 'closeform') {
        //fecha o formulario e retornar para o anterior
        this.closeMessage();
        this.closeForm();
      }
    },
    showMessageModal: function showMessageModal(code) {
      //exibe uma mensagem em "code"
      this.codeMessage = code;
      this.showMessage = true;
    },
    closeMessage: function closeMessage() {
      this.showMessage = false;
    },
    closeFormAdicionaRegra: function closeFormAdicionaRegra() {
      //FECHA O FORMULARIO DE INCLUSAO DE REGRAS
      this.adicionaRegraShow = false;
    },
    handleAdicionaRegra: function handleAdicionaRegra() {
      //ABRE TELA PARA INCLUSAO DE CONJUNTO DE REGRAS
      if (this.grutrib.descricao == '' || this.grutrib.descricao == null) {
        this.$erpToastError('É necessário o preenchimento da descrição do grupo.');
        this.$nextTick(function () {
          this.$refs.descricao.focus();
        });
        return;
      }
      this.grutrib.grutribncm = this.grutribncmList;
      this.adicionaRegraShow = true;
    },
    handleAdicionaNCM: function handleAdicionaNCM() {
      //adiciona nova linha na lsita de ncms
      var ncm = _extends({}, this.$store.getters.getEntities.grutribncm);
      this.unwatch = true;
      this.grutribncmList.push(ncm);
      this.unwatch = false;
      this.$nextTick(function () {
        this.$refs.ncm[this.grutribncmList.length - 1].focus();
      });
    },
    handleDeleteNCM: function handleDeleteNCM(index) {
      //exclui uma ncm da lista
      this.grutribncmList.splice(index, 1);
    },
    handleAdicionaProduto: function handleAdicionaProduto() {
      //adiciona nova linha na lsita de ncms
      var item = _extends({}, this.$store.getters.getEntities.grutribitem);
      this.unwatch = true;
      this.grutribitemList.push(item);
      this.unwatch = false;
      this.$nextTick(function () {
        this.$refs.item[this.grutribitemList.length - 1].focus();
      });
    },
    handleDeleteProduto: function handleDeleteProduto(index) {
      //exclui um produto da lista
      this.grutribitemList.splice(index, 1);
    },
    handleSaveRegras: function handleSaveRegras(grutrib) {
      //APOS CONFIRMAR A INCLUSAO DE NOVAS REGRAS, CARREGA O OBJETO ATUALIZAOD PARA TELA
      this.grutrib = grutrib;
      this.regraimpList = this.grutrib.regraimp;
      this.grutribncmList = this.grutrib.grutribncm;
      this.grutribitemList = this.grutrib.grutribitem;
      this.removerFiltros;
      this.closeFormAdicionaRegra();
    },
    handleSave: function handleSave(close) {
      //BOTAO SALVAR
      //EFETUA VALIDACAO DE PREENCHIMENTO DAS REGRAS

      this.close = close;

      var lErro = false;
      var validate = '';

      for (var x = 0; x < this.regraimpList.length; x++) {
        validate = '';
        this.regraimpList[x].valid = this.regraimpList[x].finalidade != null && this.regraimpList[x].ufdest != null;

        if (this.regraimpList[x].stregraimp != 'I') {
          if (this.regraimpList[x].finalidade != null && this.regraimpList[x].ufdest == null) {
            validate = 'O campo ' + this.metadata.regraimp.ufdest.label + ' é obrigatório';
          }
          if (this.regraimpList[x].finalidade == null && this.regraimpList[x].ufdest != null) {
            validate = 'O campo ' + this.metadata.regraimp.finalidade.label + ' é obrigatório';
          }
        }
        if (this.regraimpList[x].finalidade != null && this.regraimpList[x].ufdest != null && this.regraimpList[x].stregraimp != 'I') {
          if (this.regraimpList[x].aicmexterno > 99) {
            validate = 'O valor informado é inválido: ' + this.metadata.regraimp.aicmexterno.label;
          } else if (this.regraimpList[x].aicminterno > 99) {
            validate = 'O valor informado é inválido: ' + this.metadata.regraimp.aicminterno.label;
          } else if (this.regraimpList[x].mva > 99) {
            validate = 'O valor informado é inválido: ' + this.metadata.regraimp.mva.label;
          } else if (this.regraimpList[x].mvaorig > 99) {
            validate = 'O valor informado é inválido: ' + this.metadata.regraimp.mvaorig.label;
          } else if (this.regraimpList[x].aicmst > 99) {
            validate = 'O valor informado é inválido: ' + this.metadata.regraimp.aicmst.label;
          } else if (this.regraimpList[x].ricmst > 99) {
            validate = 'O valor informado é inválido: ' + this.metadata.regraimp.ricmst.label;
          } else if (this.regraimpList[x].ricm > 99) {
            validate = 'O valor informado é inválido: ' + this.metadata.regraimp.ricm.label;
            //comentado para permitir o cálculo do diferencial de alíquota
            // } else
            // if (this.regraimpList[x].aicmst > 0) {
            //     if (this.regraimpList[x].mva == null || this.regraimpList[x].mva == 0) {
            //         if (this.regraimpList[x].pautaicmst == null || this.regraimpList[x].pautaicmst == 0) {
            //             validate = 'Obrigatório informar '  + this.metadata.regraimp.mva.label + ' ou '  + this.metadata.regraimp.pautaicm.label
            //         }
            //     }
          }
        }
        if (validate.length > 0) {
          lErro = true;
          this.$set(this.regraimpList[x], 'validate', validate);
          this.regraimpList[x].valid = false;
        } else {
          this.$set(this.regraimpList[x], 'validate', '');
        }
      }

      if (lErro) {
        this.$erpToastError('Por favor corrija os erros de validação nas regras em destaque.');
        return false;
      }

      //AQUI EFETUA VALIDACAO DE DUPLICIDADE NAS REGRAS E NOS NCMS
      for (var x = 0; x < this.grutribncmList.length; x++) {
        if (this.grutribncmList[x].validate || this.grutribncmList[x].duplicate) {
          lErro = true;
        }
      }

      if (lErro) {
        lErro = true;
        this.activeTab = 0; //habilita a pagina de ncms
        this.$erpToastError('Por favor corrija os NCM´s duplicados.');
        return false;
      }

      for (var x = 0; x < this.grutribitemList.length; x++) {
        if (this.grutribitemList[x].validate || this.grutribitemList[x].duplicate) {
          lErro = true;
        }
      }

      if (lErro) {
        lErro = true;
        this.activeTab = 0; //habilita a pagina de ncms e produtos
        this.$erpToastError('Por favor corrija os produtos duplicados.');
        return false;
      }

      var lErro2 = this.regraCheckDuplicate();
      if (lErro2) {
        lErro = true;
        this.activeTab = 1; //habilita a pagina regras
        this.$erpToastError('Por favor corrija as regras duplicadas.');
      }

      if (lErro) {
        return false;
      }

      if (this.grutrib.regra_geral != 'S' && this.grutribncmList.length == 0 && this.grutribitemList.length == 0) {
        this.$erpToastError('Adicione um NCM ou Produto para continuar.');
        return false;
      }

      if (this.grutrib.regra_geral == 'S' && this.grutribncmList.length > 0) {
        this.$erpToastError('Grupo de regra marcado como Geral não pode possuir NCMs Vinculados.');
        return false;
      }

      if (this.grutrib.regra_geral == 'S' && this.grutribitemList.length > 0) {
        this.$erpToastError('Grupo de regra marcado como Geral não pode possuir Produtos Vinculados.');
        return false;
      }

      this.apiPost();
    },
    loadEstados: function loadEstados() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$store.dispatch('loadEstadoRegras');

              case 2:
                if (_this2.$store.getters.getEstadoList) {
                  _this2.estadoList = _this2.$store.getters.getEstadoList.map(function (obj) {
                    return { id: obj.uf, text: obj.uf };
                  });
                }

                if (_this2.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU) {
                  _this2.loadData();
                } else {
                  _this2.regraimpList = [];
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    loadData: function loadData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.unwatch = true;
                params = { id: _this3.codgrutrib };
                _context2.next = 4;
                return _this3.$store.dispatch('loadGrutrib', params);

              case 4:
                if (_this3.$store.getters.getGrutrib) {
                  //carrega os objetos grutrib, grutrib.regraimp, grutrib.grutribncm
                  _this3.grutrib = _this3.$store.getters.getGrutrib;
                  _this3.regraimpList = _this3.grutrib.regraimp;
                  _this3.grutribncmList = _this3.grutrib.grutribncm;
                  _this3.grutribitemList = _this3.grutrib.grutribitem;
                }
                _this3.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });
                _this3.unwatch = false;

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },


    // getInput().then(value => alert(value));

    // async ncmCheck2 () {
    //     return new Promise(resolve => {
    //         let ncm = false
    //         for (var x = 0; x < this.grutribncmList.length; x++) {
    //             this.$set(this.grutribncmList[x], 'validate', '')
    //             let url = this.$store.getters.urlOrds + 'cg/grutrib/ncm/' + this.grutribncmList[x].ncm
    //             const data = await apiORDS(url, {})
    //             console.log(data)
    //             if (data.items && data.items.length > 0) {
    //                 if (data.items[0].codgrutrib != this.grutrib.codgrutrib) {
    //                     this.grutribncmList[x].validate = 'Este NCM já foi associado ao grupo: ' + data.items[0] + ' e não poderá ser associado a outro grupo.'
    //                     ncm = true
    //                 }
    //             }
    //         }
    //         resolve(ncm)
    //     })
    // },

    ncmCheck: function ncmCheck() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var ncm, x, url, data, test, ncmArr, duplicate;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:

                _this4.unwatch = true;

                ncm = false;
                x = 0;

              case 3:
                if (!(x < _this4.grutribncmList.length)) {
                  _context3.next = 15;
                  break;
                }

                if (!_this4.grutribncmList[x].validate) {
                  _this4.$set(_this4.grutribncmList[x], 'validate', '');
                }

                if (!(_this4.grutribncmList[x].ncm == '')) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt('continue', 12);

              case 7:
                url = _this4.$store.getters.urlOrds + 'cg/grutrib/ncm/' + _this4.grutribncmList[x].ncm;
                _context3.next = 10;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDS"])(url, {});

              case 10:
                data = _context3.sent;

                if (data.items && data.items.length > 0) {
                  if (data.items[0].codgrutrib != _this4.grutrib.codgrutrib) {
                    _this4.unwatch = true;
                    _this4.grutribncmList[x].validate = 'Este NCM já foi associado ao grupo: ' + data.items[0].descricao + ' e não poderá ser associado a outro grupo.';
                    ncm = true;
                  } else {
                    _this4.grutribncmList[x].validate = '';
                  }
                } else {
                  _this4.grutribncmList[x].validate = '';
                }

              case 12:
                x++;
                _context3.next = 3;
                break;

              case 15:

                //checa se foi digitado algum NCM/EXNCM duplicado para o grupo de tributacao
                test = {};
                //cria novo objeto array para fazer a verificacao de duplicidades

                ncmArr = _this4.grutribncmList.map(function (obj) {
                  return { ncm: obj.ncm, exncm: obj.exncm };
                });
                //efetua a verificacao da duplicidade

                duplicate = false;

                for (x = 0; x < ncmArr.length; x++) {
                  test = ncmArr[x];
                  if (!_this4.grutribncmList[x].duplicate) {
                    _this4.$set(_this4.grutribncmList[x], 'duplicate', false);
                  }
                  if (ncmArr.findIndex(function (obj) {
                    return obj.ncm === test.ncm && obj.exncm === test.exncm;
                  }) < x) {
                    _this4.grutribncmList[x].duplicate = true;
                    duplicate = true;
                  } else {
                    _this4.grutribncmList[x].duplicate = false;
                  }
                }

                _this4.unwatch = false;

              case 20:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    regraCheckDuplicate: function regraCheckDuplicate() {
      //checa se foi digitado alguma regra duplicado para o grupo de tributacao, pesquisando no array regraList
      //considerando como chave os campos UFDEST, FINALIDADE, ORIMERC, CODGRUCLI

      var test = {};
      //cria novo objeto array para fazer a veiricacao de duplicidades
      var arrRegra = this.regraimpList.map(function (obj) {
        return {
          ufdest: obj.ufdest,
          dtinicio: obj.dtinicio,
          finalidade: obj.finalidade,
          orimerc: obj.orimerc,
          codgrucli: obj.codgrucli,
          stregraimp: obj.stregraimp
        };
      });
      //efetua a verificacao da duplicidade (uf destino, finalidade, origem, data de inicio e grupo de cliente)
      var duplicate = false;
      var i = 0;
      for (var x = 0; x < arrRegra.length; x++) {
        this.$set(this.regraimpList[x], 'duplicate', false);
        if (arrRegra[x].stregraimp == 'I') {
          continue;
        }
        console.log(arrRegra[x].codregraimp);
        test = arrRegra[x];
        if (test.ufdest != null && test.finalidade != null) {
          i = arrRegra.findIndex(function (obj) {
            return obj.ufdest == test.ufdest && obj.finalidade == test.finalidade && obj.orimerc == test.orimerc && obj.dtinicio == test.dtinicio && obj.codgrucli == test.codgrucli;
          });
          if (i < x && arrRegra[i].stregraimp != 'I') {
            this.regraimpList[x].duplicate = true;
            this.regraimpList[x].validate = 'Duplicidade de regra';
            duplicate = true;
          }
        }
      }
      return duplicate;
    },
    apiDelete: function apiDelete() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var modulo, sendData, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                //efetua a exclusao do grupo de tributacao

                modulo = 'cg/grutrib/' + _this5.grutrib.codgrutrib;
                sendData = {};
                _context4.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this5.$store, modulo);

              case 4:
                data = _context4.sent;

                _this5.$erpToastSuccess('O grupo de tributação foi excluído');
                _this5.closeForm();

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    apiPost: function apiPost() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var modulo, sendData, regraimpValid, x, grutribitem, metodo, data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                //efetua a gravacao das regras

                modulo = 'cg/grutrib/';
                sendData = {};
                regraimpValid = [];


                for (x = 0; x < _this6.regraimpList.length; x++) {
                  if (_this6.regraimpList[x].valid) {
                    regraimpValid.push(_this6.regraimpList[x]);
                  }
                }

                grutribitem = [];

                for (x = 0; x < _this6.grutribitemList.length; x++) {
                  if (_this6.grutribitemList[x].coditem) {
                    grutribitem.push(_this6.grutribitemList[x]);
                  }
                }

                sendData = { grutrib: _this6.grutrib };
                sendData.grutrib.regraimp = regraimpValid;
                sendData.grutrib.grutribncm = _this6.grutribncmList;
                sendData.grutrib.grutribitem = grutribitem;

                metodo = 'post';
                _context5.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this6.$store, modulo, sendData, metodo);

              case 13:
                data = _context5.sent;

                _this6.$erpToastSuccess('As regras foram gravadas com sucesso');
                if (_this6.close) {
                  _this6.closeForm();
                }

              case 16:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    }
  },

  created: function created() {
    this.loadEstados();

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
      this.$refs.descricao.focus();
    });
  }
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    grutrib: {}
  },

  data: function data() {
    return {
      crudText: '',
      crud: 'ins',

      metadata: this.$store.getters.getEntities.metadata,
      regraimp: _extends({}, this.$store.getters.getEntities.regraimp),
      regraimpList: [], //array de regras de impostos (tabela regraimp)

      estadoList: [],

      showMessage: false,
      message: '',
      ufdest: '',
      codgrucli: null,
      optsimples: 'S',

      tabs: ['Industrialização', 'Revenda', 'Consumo Final'], //paginas
      activeTab: 0 //pagina ativa

    };
  },


  computed: {

    regraimpInd: function regraimpInd() {
      return this.regraimpList.filter(function (obj) {
        return obj.finalidade == 'I';
      });
    },

    regraimpRev: function regraimpRev() {
      return this.regraimpList.filter(function (obj) {
        return obj.finalidade == 'R';
      });
    },

    regraimpFinal: function regraimpFinal() {
      return this.regraimpList.filter(function (obj) {
        return obj.finalidade == 'F';
      });
    }
  },

  watch: {
    ufdest: function ufdest() {
      //atualiza o campo uf de destino nas regras
      if (this.regraimpList.length == 0) {
        this.handleAdicionaRegra('I');
        this.handleAdicionaRegra('R');
        this.handleAdicionaRegra('F');
      }
      for (var x = 0; x < this.regraimpList.length; x++) {
        this.regraimpList[x].ufdest = this.ufdest;
      }
    },
    codgrucli: function codgrucli() {
      for (var x = 0; x < this.regraimpList.length; x++) {
        this.regraimpList[x].codgrucli = this.codgrucli;
      }
    },
    optsimples: function optsimples() {
      for (var x = 0; x < this.regraimpList.length; x++) {
        this.regraimpList[x].optsimples = this.optsimples;
      }
    }
  },

  methods: {
    closeForm: function closeForm() {
      this.$emit('closeform');
    },
    handleCloseForm: function handleCloseForm() {
      this.closeForm();
    },
    handleSave: function handleSave() {
      var _this = this;

      //botao salvar

      //valida se existe duplicidade de regras e depois valida o preenchimento dos campos
      if (!this.regraCheckDuplicate()) {
        this.$validator.validateAll().then(function (isValid) {
          if (!isValid) {
            _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
          } else {
            _this.apiPost();
          }
        });
      }
    },
    configuraRegrasRegiao: function configuraRegrasRegiao() {
      //EFETUA A CRIACAO DE NOVA LISTA REGRAS PARA SER ENVIADA AO SERVIDOR QUANDO USUARIO SELECIONAR UMA REGIAO
      //PARA CRIACAO DAS REGRAS DE IMPOSTOS

      for (var x = 0; x < this.regraimpList.length; x++) {
        this.regraimpList[x].ufdest = this.ufdest; //atualiza uf caso tenha sido alterado apos definicao
        this.regraimpList[x].optsimples = this.optsimples;
        this.regraimpList[x].codgrucli = this.codgrucli;
      }

      if (this.ufdest != '1' && this.ufdest != '2' && this.ufdest != '3' && this.ufdest != '4' && this.ufdest != '5') {
        return this.regraimpList;
      }

      var regras = [];
      var uf = [];
      var ufsul = ['RS', 'SC', 'PR'];
      var ufsudeste = ['SP', 'ES', 'RJ', 'MG'];
      var ufnorte = ['AM', 'AC', 'RR', 'RO', 'PA', 'TO'];
      var ufcentro = ['MT', 'MS', 'GO', 'DS'];
      var ufnordeste = ['AL', 'BA', 'CE', 'MA', 'RN', 'PB', 'PE', 'SE'];

      if (this.ufdest == '1') {
        uf = ufsul;
      } else if (this.ufdest == '2') {
        uf = ufsudeste;
      } else if (this.ufdest == '5') {
        uf = ufcentro;
      } else if (this.ufdest == '4') {
        uf = ufnordeste;
      } else if (this.ufnorte == '3') {
        uf = ufnorte;
      }

      for (var x = 0; x < this.regraimpList.length; x++) {
        for (var i = 0; i < uf.length; i++) {
          this.regraimp = _extends({}, this.regraimpList[x]);
          this.regraimp.ufdest = uf[i];
          regras.push(this.regraimp);
        }
      }

      return regras;
    },
    changeTab: function changeTab(idx) {
      //mudança de pagina
      this.activeTab = idx;
    },
    handleExcluiRegra: function handleExcluiRegra(index) {
      //exclui uma regra
      this.regraimpList.splice(index, 1);
    },
    handleAdicionaRegra: function handleAdicionaRegra(finalidade) {
      //adiciona nova linha na lsita de regras
      if (this.ufdest === '') {
        this.$erpToastError('Selecione um Estado antes de incluir nova regra');
        return;
      }
      var regra = _extends({}, this.$store.getters.getEntities.regraimp);
      regra.optsimples = 'S';
      regra.bcdifalnovo = 'S';
      regra.stregraimp = 'A';
      if (finalidade) {
        regra.finalidade = finalidade;
      } else {
        if (this.activeTab == 0) {
          regra.finalidade = 'I';
        } else if (this.activeTab == 1) {
          regra.finalidade = 'R';
        } else if (this.activeTab == 2) {
          regra.finalidade = 'F';
        }
      }
      regra.ufdest = this.ufdest; //UF selecionada
      this.regraimpList.push(regra);

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },
    loadEstados: function loadEstados() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var regiao;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$store.dispatch('loadEstadoRegras');

              case 2:
                if (_this2.$store.getters.getEstadoList) {
                  _this2.estadoList = _this2.$store.getters.getEstadoList.map(function (obj) {
                    return { id: obj.uf, text: obj.uf };
                  });
                }

                regiao = { id: '1', text: 'SUL' };

                _this2.estadoList.push(regiao);
                regiao = { id: '2', text: 'SUDESTE' };
                _this2.estadoList.push(regiao);
                regiao = { id: '3', text: 'NORTE' };
                _this2.estadoList.push(regiao);
                regiao = { id: '4', text: 'NORDESTE' };
                _this2.estadoList.push(regiao);
                regiao = { id: '5', text: 'CENTRO' };
                _this2.estadoList.push(regiao);

                _this2.regraimpList = [];

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    regraCheckDuplicate: function regraCheckDuplicate() {
      //checa se foi digitado alguma regra duplicado para o grupo de tributacao, pesquisando no array regraList
      //considerando como chave os campos UFDEST, FINALIDADE, ORIMERC, CODGRUCLI

      var test = {};
      //cria novo objeto array para fazer a veiricacao de duplicidades
      var arrRegra = this.regraimpList.map(function (obj) {
        return { ufdest: obj.ufdest, finalidade: obj.finalidade, orimerc: obj.orimerc, codgrucli: obj.codgrucli };
      });
      //efetua a verificacao da duplicidade
      var duplicate = false;
      for (var x = 0; x < arrRegra.length; x++) {
        this.$set(this.regraimpList[x], 'duplicate', false);
        test = arrRegra[x];
        if (test.ufdest != null && test.finalidade != null) {
          if (arrRegra.findIndex(function (obj) {
            return obj.ufdest == test.ufdest && obj.finalidade == test.finalidade && obj.orimerc == test.orimerc && obj.codgrucli == test.codgrucli;
          }) < x) {
            this.regraimpList[x].duplicate = true;
            this.regraimpList[x].validate = 'Duplicidade de regra';
            duplicate = true;
          }
        }
      }
      return duplicate;
    },
    apiPost: function apiPost() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var modulo, sendData, regraimpValid, metodo, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                //efetua a inclusao das regras

                modulo = 'cg/grutrib/';
                sendData = {};
                regraimpValid = _this3.configuraRegrasRegiao();


                sendData = { grutrib: _this3.grutrib };
                sendData.grutrib.regraimp = regraimpValid;

                metodo = 'post';
                _context2.next = 8;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this3.$store, modulo, sendData, metodo);

              case 8:
                data = _context2.sent;


                _this3.$erpToastSuccess('As regras foram gravadas com sucesso');
                _this3.$emit('save', data.items[0]);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  },

  created: function created() {
    this.loadEstados();

    this.$scrollTo(0);

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
      this.$refs.ufdest.focus();
    });
  }
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usuario_form__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            usuario: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: ''
        };
    },


    computed: {
        usuarioList: function usuarioList() {
            return this.$store.getters.getUsuarioList;
        },
        perfil_usuario_comum: function perfil_usuario_comum() {
            var perfil = this.$store.getters.getSessao.perfil;
            return perfil > '2';
        },
        usuario_logado_uuid: function usuario_logado_uuid() {
            return this.$store.getters.getEnv.uuid;
        }
    },

    filters: {
        getText: function getText(value) {
            if (value == 'A') {
                return 'Ativo';
            } else {
                return 'Inativo';
            }
        },

        getPerfil: function getPerfil(value) {
            if (value == '1') return 'Administrador';else if (value == '0') return 'Responsável criador';else if (value == '3') return 'Representante';else if (value == '5') return 'PDV-Varejo';else if (value == '2') return 'Gerente';else return 'Normal';
        }

    },

    methods: {
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudU;
            this.codusuario = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudI;
            this.codusuario = '';
            this.showForm = true;
        },
        closeForm: function closeForm() {
            this.loadData();
            this.showForm = false;
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codusuario":{"$like":"%25' + value + '%25"}},{"nome":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadUsuario', { filter: this.filter });
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], UsuarioForm: __WEBPACK_IMPORTED_MODULE_1__usuario_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            // usuario: {...this.$store.getters.getEntities.usuario},
            // metadata: this.$store.getters.getEntities.metadata,
            senha1: '',
            senha2: '',
            errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela

            hBloqueiaAlterarPedido: 'Bloqueia alterar pedido',
            hBloqueiaGerarPedido: 'Bloqueia gerar pedido de orçamento',
            hBloqueiaDescontos: 'Bloqueia acesso aos campos de descontos do pedido para este usuário',
            hBloqueiaPreco: 'Bloqueia o acesso ao campo de preço do produto para este usuário',
            hBloqueiaTabela: 'Bloqueia o acesso ao campo de tabela de preços quando o cliente informado já possuir tabela de preços vinculada em seu cadastro',

            metadata: { usuario: {
                    codusuario: { label: 'Código', fieldname: 'codusuario' },
                    nome: { label: 'Nome do Usuário', fieldname: 'nome' },
                    email: { label: 'Email Para Login', fieldname: 'email' },
                    senha: { label: 'Senha', fieldname: 'senha' },
                    stusuario: {
                        label: 'Situação',
                        fieldname: 'stusuario',
                        options: [{ id: 'A', text: 'Ativo' }, { id: 'I', text: 'Inativo' }]
                    }
                }
            },

            usuario: {
                codusuario: null,
                nome: '',
                email: '',
                senha: '',
                stusuario: '',
                perfil: ''
            },

            parametros: {
                vendas: {
                    tabelaspreco: [],
                    desconto_maximo: 0,
                    bloqueia_tabela_cliente: false,
                    bloqueia_preco_item: false,
                    bloqueia_descontos: false,
                    bloqueia_gerar_pedido: false,
                    bloqueia_alterar_pedido: false
                }
            },

            tabelaspreco: null

        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        },

        alteraSenha: function alteraSenha() {
            return this.editing && !this.usuarioComumLogado || this.usuario.uuid === this.$store.getters.getEnv.uuid;
        },

        tabpreList: function tabpreList() {
            return this.$store.getters.getTabpreList;
        },

        usuarioComumLogado: function usuarioComumLogado() {
            return this.$store.getters.getSessao.perfil > '1';
        }

    },

    watch: {},

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleSave: function handleSave() {
            var _this = this;

            if (this.senha1 != this.senha2) {
                alert('As senhas não conferem');
                return;
            }

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO EXCLUIR
            this.apiDelete();
        },
        apiDelete: function apiDelete() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var url, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //EFETUA A EXCLUSAO DO USUARIO
                                url = _this2.$store.getters.urlApp + 'usuario/' + _this2.usuario.codusuario;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSdelete2"])(url);

                            case 3:
                                data = _context.sent;

                                _this2.$erpToastDeleted();
                                _this2.closeForm();

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        loadData: function loadData() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var x, testTabela;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this3.tabelaspreco) {
                                    _context2.next = 5;
                                    break;
                                }

                                _context2.next = 3;
                                return _this3.$store.dispatch('loadTabpre', {});

                            case 3:
                                _this3.tabelaspreco = [].concat(_toConsumableArray(_this3.tabpreList));
                                for (x = 0; x < _this3.tabelaspreco.length; x++) {
                                    _this3.$set(_this3.tabelaspreco[x], 'liberada', false);
                                }

                            case 5:
                                if (_this3.index) {
                                    _context2.next = 7;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 7:
                                _context2.next = 9;
                                return _this3.$store.dispatch('loadUsuario', { id: _this3.index });

                            case 9:
                                if (_this3.$store.getters.getUsuario) {
                                    _this3.usuario = _extends({}, _this3.$store.getters.getUsuario);
                                    _this3.senha1 = _this3.usuario.senha;
                                    _this3.senha2 = _this3.usuario.senha;
                                }
                                _this3.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                                //carrega os parametros do usuario
                                if (_this3.usuario.parametros) {
                                    _this3.parametros = JSON.parse(_this3.usuario.parametros);
                                } else {
                                    _this3.parametros = {
                                        vendas: {
                                            desconto_maximo: null,
                                            tabelaspreco: [],
                                            bloqueia_tabela_cliente: false,
                                            bloqueia_preco_item: false,
                                            bloqueia_descontos: false,
                                            bloqueia_gerar_pedido: false,
                                            bloqueia_alterar_pedido: false
                                        }
                                    };
                                }

                                if (!_this3.parametros.vendas) _this3.parametros.vendas = {
                                    desconto_maximo: null,
                                    tabelaspreco: [],
                                    bloqueia_tabela_cliente: false,
                                    bloqueia_preco_item: false,
                                    bloqueia_descontos: false,
                                    bloqueia_gerar_pedido: false,
                                    bloqueia_alterar_pedido: false
                                };

                                if (!_this3.parametros.vendas.bloqueia_tabela_cliente) _this3.parametros.vendas.bloqueia_tabela_cliente = false;

                                if (!_this3.parametros.vendas.bloqueia_preco_item) _this3.parametros.vendas.bloqueia_preco_item = false;

                                if (!_this3.parametros.vendas.bloqueia_descontos) _this3.parametros.vendas.bloqueia_descontos = false;

                                if (!_this3.parametros.vendas.bloqueia_gerar_pedido) _this3.parametros.vendas.bloqueia_gerar_pedido = false;

                                if (!_this3.parametros.vendas.bloqueia_alterar_pedido) _this3.parametros.vendas.bloqueia_alterar_pedido = false;

                                //marca as tabelas liberadas
                                testTabela = null;

                                for (x = 0; x < _this3.tabelaspreco.length; x++) {
                                    testTabela = _this3.parametros.vendas.tabelaspreco.filter(function (obj) {
                                        return obj == _this3.tabelaspreco[x].codtabpre;
                                    });
                                    _this3.tabelaspreco[x].liberada = testTabela.length > 0;
                                }

                            case 20:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        loadTabpre: function loadTabpre() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        apiPost: function apiPost() {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var isValid, sendData, x, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!(_this5.lCrud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI)) {
                                    _context4.next = 13;
                                    break;
                                }

                                isValid = true;

                                if (!(_this5.usuario.perfil == '3')) {
                                    _context4.next = 8;
                                    break;
                                }

                                _context4.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiValidaLimitePlano"])(_this5, 'representantes');

                            case 5:
                                isValid = _context4.sent;
                                _context4.next = 11;
                                break;

                            case 8:
                                _context4.next = 10;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiValidaLimitePlano"])(_this5, 'usuarios');

                            case 10:
                                isValid = _context4.sent;

                            case 11:
                                if (isValid) {
                                    _context4.next = 13;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 13:
                                sendData = {};


                                _this5.usuario.parametros = null;

                                if (_this5.usuario.perfil != '0') {
                                    _this5.parametros.vendas.tabelaspreco = [];

                                    for (x = 0; x < _this5.tabelaspreco.length; x++) {
                                        if (_this5.tabelaspreco[x].liberada) _this5.parametros.vendas.tabelaspreco.push(_this5.tabelaspreco[x].codtabpre);
                                    }
                                    _this5.usuario.parametros = _this5.parametros;
                                }

                                _this5.usuario.senha = _this5.senha1;
                                sendData = { usuario: _this5.usuario };

                                metodo = 'post';
                                update = false;

                                if (_this5.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context4.next = 23;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSapp"])(_this5, 'usuario/', metodo, sendData);

                            case 23:
                                data = _context4.sent;

                                if (data.errmessages) {
                                    _this5.errmessages = data.errmessages;
                                    _this5.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this5.$erpToastUpdated();
                                    } else {
                                        _this5.$erpToastInserted();
                                    }
                                    _this5.errmessages = {};
                                    _this5.closeForm();
                                }

                            case 25:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    mounted: function mounted() {
        var _this6 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _this6.$nextTick(function () {
                                this.$refs.nome.focus();
                                jQuery('[data-toggle="tooltip"]').tooltip();
                            });

                        case 1:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this6);
        }))();
    },
    created: function created() {

        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
            this.usuario.stusuario = 'A';
            this.usuario.perfil = '1';
        } else {}
        this.loadData();

        this.$scrollTo(0);
    }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nfsaida_form__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nfse_form__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nfentrada_form__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_csvReport__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_csvReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__shared_csvReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_api_nfe_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_api_nfe_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__api_api_nfe_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//














/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showForm: false, //exibe a tela de manutencao de nota de saida
      showFormNfse: false, //exibe a tela de manutencao de nota de saida
      showFormImportXML: false, //tela de manutencao de nota de entrada
      crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
      filter: '',
      metadata: this.$store.getters.getEntities.metadata,
      params: { outrasSaidas: true, codnf: 0, codpedv: 0 },
      filtroAvancado: {
        periodo: {
          label: 'Data da venda',
          varios: false,
          data_inicio: null,
          data_termino: null
        },

        filtros: [{ nome: 'clientefornecedor', label: null, url: null, varios: true, values: [] }]

      },

      filterList: [], //lista de filtros aplicados que são exibidos em tela
      moreActionsBarList: [],
      incluirActionsBarList: [],
      monthFilter: {},
      operacao: {},
      title: '',
      titlePl: '',
      errmessagesDownloadXML: null,
      noFiles: false
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_10__api_api_nfe_js___default.a],

  computed: {
    showVideo: function showVideo() {
      return __WEBPACK_IMPORTED_MODULE_9__main__["SysVars"].appNFe && this.nfList.length == 0 && __WEBPACK_IMPORTED_MODULE_9__main__["SysVars"].appTrial;
    },
    nfList: function nfList() {
      return this.$store.getters.getNfList;
    },
    nf_with_itemList: function nf_with_itemList() {
      return this.$store.getters.getNf_with_itemList;
    },

    inutList: function inutList() {
      return this.$store.getters.getNfAvisos;
    },
    inutCount: function inutCount() {
      if (this.$store.getters.getNfAvisos.length) return this.$store.getters.getNfAvisos[0].inutcount;else return null;
    },
    nfCount: function nfCount() {
      if (this.$store.getters.getNfAvisos.length) return this.$store.getters.getNfAvisos[0].nfcount;else return null;
    },
    url: function url() {
      return this.$route.params.operacao;
    },
    acessoCore: function acessoCore() {
      return this.$store.getters.getEnvAcessoCore;
    }
  },

  watch: {
    url: function url() {
      this.operacao = this.url; //operacao 'entrada' ou 'saida'
      this.updateActions();
      this.handleTitle();
      this.loadData();
    }
  },

  methods: {
    handleEdit: function handleEdit(codnf, importXml, tpnf, responseImport) {
      //abre a tela de edicao
      this.crud = __WEBPACK_IMPORTED_MODULE_9__main__["SysVars"].crudU; //operacao de edicao
      this.params = { codnf: codnf //codigo da nf
      };var self = this;
      this.$nextTick(function () {
        if (importXml) {
          self.params.importXml = true;
          self.params.responseImport = responseImport;
          self.showFormImportXML = true; //exibe o form de manutencao da nota de entrada
        } else {
          if (tpnf == 'S') {
            self.showFormNfse = true;
          } else {
            self.showForm = true; //exibe o form de manutencao da nota de saida
          }
        }
      });
    },
    handleTitle: function handleTitle() {
      if (this.operacao == 'entrada') {
        this.title = 'Nota de Entrada';
        this.titlePl = 'Notas de Entrada';
      } else if (this.operacao == 'servico') {
        this.title = 'Nota de Serviço';
        this.titlePl = 'Notas de Serviço';
      } else {
        this.title = 'Nota de Saída';
        this.titlePl = 'Notas de Saída';
      }
    },
    handleView: function handleView(nf) {
      //abre a tela de edicao
      this.crud = __WEBPACK_IMPORTED_MODULE_9__main__["SysVars"].crudView; //visualizacao
      this.params = { codnf: nf.codnf //codigo da nf
      };var self = this;
      this.$nextTick(function () {
        if (nf.impxml == 'S' && nf.stnf == '00') {
          self.params.importXml = true;
          self.showFormImportXML = true; //exibe o form de manutencao da nota de entrada
        } else {
          if (nf.tpnf == 'S') {
            self.showFormNfse = true;
          } else {
            self.showForm = true; //exibe o form de manutencao da nota de saida
          }
        }
      });
    },
    handleAction: function handleAction(act, codnf) {
      if (act == 10) {
        this.$router.push('/banking?codnf=' + codnf);
      }
    },
    downloadArquivosXMLPeriodo: function downloadArquivosXMLPeriodo(gerarArquivos) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var ref, response, self, blob, reader;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ref = {
                  datareferencia: _this.monthFilter.startDate,
                  gerarArquivos: gerarArquivos
                };
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiDownload"])(_this, 'print/xmlfiles/', ref, 'post', true);

              case 3:
                response = _context.sent;


                //A RESPOSTA PODE SER O ARQUIVO .ZIP OU A LISTA DE ERROS

                self = _this;

                self.noFiles = false;

                if (response.headers['content-type'].includes('json')) {
                  blob = new Blob([response.data], { type: 'text/json' });
                  reader = new FileReader();

                  reader.onload = function () {
                    var obj = JSON.parse(reader.result);
                    self.errmessagesDownloadXML = obj.errmessages;
                    self.noFiles = obj.noDataFound;
                  };
                  reader.readAsText(blob);
                } else {
                  Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiDownloadFile"])(response);
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleActionBarList: function handleActionBarList(act) {
      var _this2 = this;

      if (act == 0) {
        //efetua download dos xmls de nfe no periodo selecionado
        this.downloadArquivosXMLPeriodo();
      }
      if (act == 1) {
        //efetua importacao do xml de nf-e
        this.handleImportarXMLNFe();
      }
      if (act == 2) {
        //exportar a lista de notas para planilha
        var data = this.nfList.map(function (nf) {
          return {
            data: _this2.data(nf.data),
            datalancamento: _this2.data(nf.datalancamento),
            serie: nf.serie,
            numeronf: nf.nf,
            operacao: _this2.operacaoNf(nf.operacaonf),
            natureza: nf.descricao,
            nome: nf.nome,
            total: Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(nf.totger, 2),
            chave: nf.chave,
            status: nf.status,
            cfop: nf.cfop,
            totmer: Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(nf.totmer, 2),
            bcpis: Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(nf.bcpis, 2),
            totpis: Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(nf.totpis, 2),
            bccofins: Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(nf.bccofins, 2),
            totcofins: Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(nf.totcofins, 2),
            bcipi: Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(nf.bcipi, 2),
            totipi: Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(nf.totipi, 2),
            totipidevol: Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(nf.totipidevol, 2),
            bcicm: Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(nf.bcicm, 2),
            toticm: Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(nf.toticm, 2),
            bcicmst: Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(nf.bcicmst, 2),
            toticmst: Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(nf.toticmst, 2),
            totii: Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(nf.totii, 2)
          };
        });
        var csv = Object(__WEBPACK_IMPORTED_MODULE_8__shared_csvReport__["objectToCsv"])(data);
        Object(__WEBPACK_IMPORTED_MODULE_8__shared_csvReport__["downloadCsvReport"])(csv);
      }
      if (act == 4 || act == 5 || act == 6 || act == 7 || act == 8 || act == 10) {
        this.handleNew(act == 6, act == 8, act == 10); //act == 6 => venda livre
      }
      if (act == 3) {
        this.$router.push('/pedido/novo');
      }
      if (act == 9) {
        //exportar a lista de notas para planilha
        this.loadDataDetails();
        var _data = this.nf_with_itemList;
        var _csv = Object(__WEBPACK_IMPORTED_MODULE_8__shared_csvReport__["objectToCsv"])(_data);
        Object(__WEBPACK_IMPORTED_MODULE_8__shared_csvReport__["downloadCsvReport"])(_csv);
      }
    },
    PDFResponseCallbackSAT: function PDFResponseCallbackSAT(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO SAT
      if (response.status != 'success') {
        this.$erpToastError(response.message);
      }
    },
    handlePDF: function handlePDF(nf) {
      //impressao da danfe em PDF
      if (nf.esp == '59') {
        var paramsimp = '&codnf=' + nf.codnf;
        this.$executaExtensaoChromeSAT(nf.codnf, 'imp', this.PDFResponseCallbackSAT, paramsimp);
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiDownloadPDF"])(this, 'print/danfe/' + nf.codnf);
    },
    handleDownloadXML: function handleDownloadXML(codnf, chave) {
      //visualizacao do XML da NFE
      var data = { codnf: codnf, chave: chave, tipo: 'NFE' };
      Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiDownload"])(this, 'print/xmlnfe/', data, 'post');
    },
    handlePreDANFE: function handlePreDANFE(nf) {
      //impressao da danfe em PDF
      Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiDownloadPDF"])(this, 'print/previewdanfe/' + nf.codnf);
    },
    NFeResponseCallbackSAT: function NFeResponseCallbackSAT(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO SAT
      if (response.status != 'success') {
        this.$erpToastError(response.message);
      } else {
        if (response.response.nf.length > 0 && response.response.nf[0].cstat == '100') {
          this.$erpToastSuccess('NFe Autorizada');
        } else {
          this.$erpToastError(response.response.xmotivo);
        }
      }
      this.loadData();
    },
    NFeResponseCallbackA1: function NFeResponseCallbackA1(response) {
      this.loadData();
    },
    NFeResponseCallbackA3: function NFeResponseCallbackA3(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
      if (response.status != 'success') {
        this.$erpToastError(response.message);
      } else {
        if (response.response.nf.length > 0 && response.response.nf[0].cstat == '100') {
          this.$erpToastSuccess('NFe Autorizada');
        } else {
          this.$erpToastError(response.response.xmotivo);
        }
      }
      this.loadData();
    },
    handleAutoriza: function handleAutoriza(nf) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var tipo;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                //envia nf para autorizacao conforme tipo de certificado

                if (nf.emicnpj == '11111111111111') {
                  _this3.$erpToastError('Em período de trial não é possível autorizar, será exibida a pré-visualização da DANFE.');
                  _this3.handlePreDANFE(nf);
                } else {

                  nf.xmotivo = '';
                  if (nf.esp == '59') {
                    _this3.autorizaNFeSAT(nf, _this3.NFeResponseCallbackSAT);
                  } else {
                    tipo = _this3.$certificadoCheck(nf.codfil);

                    if (tipo == 'A1') {
                      _this3.autorizaNFeA1(nf, _this3.NFeResponseCallbackA1);
                    } else if (tipo == 'A3') {
                      _this3.autorizaNFeA3(nf, _this3.NFeResponseCallbackA3);
                    }
                  }
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getActions: function getActions(nf) {
      var moreActions = [];
      var act = {};
      var stnf = nf.stnf;
      if (stnf == '10') {
        act = { action: 2, label: 'Danfe PDF' };
        moreActions.push(act);
        act = { action: 6, label: 'Download do XML' };
        moreActions.push(act);
        // if (nfev && nfev.length > 0) {
        //     act = { action: 9, label: 'Gerar PDF da CC-e' }
        //     moreActions.push(act)
        //     act = { action: 10, label: 'Enviar Email da CC-e' }
        //     moreActions.push(act)
        // }
      }
      if (stnf == '01') {
        act = { action: 7, label: 'Autorizar NF-e' };
        moreActions.push(act);
      }

      return moreActions;
    },
    handleChangeAdvancedFilter: function handleChangeAdvancedFilter(filtro) {
      var arrUrl = [];

      var urlFilter = '';
      if (filtro.periodos && filtro.periodos.length > 0) {
        if (filtro.periodos[0].startDate && filtro.periodos[0].endDate) {
          urlFilter = '{"datalancamento":{"$between":[{"$date":"' + Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiDateORDS"])(filtro.periodos[0].startDate) + '"},{"$date":"' + Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiDateORDS"])(filtro.periodos[0].endDate, true) + '"}]}}';
          arrUrl.push(urlFilter);
        }
      }

      urlFilter = '';
      if (filtro.clientefornecedor && filtro.clientefornecedor.length > 0) {
        for (var x = 0; x < filtro.clientefornecedor.length; x++) {
          if (urlFilter != '') {
            urlFilter = urlFilter + ',';
          }
          urlFilter = urlFilter + '{"codpart":{"$eq":"' + filtro.clientefornecedor[x] + '"}}';
        }
        if (urlFilter != '') {
          urlFilter = '{"$or":[' + urlFilter + ']}';
          arrUrl.push(urlFilter);
        }
      }

      var url = '';
      for (var i = 0; i < arrUrl.length; i++) {
        if (i != 0) {
          url = url + ',';
        }
        url = url + arrUrl[i];
      }
      if (url != '') url = '{"$and":[' + url + ']}';

      this.filter = url;
      this.loadData();
    },
    handleChangeFilter: function handleChangeFilter(url) {
      //aplicação do filtro avancado
      this.filter = url;
      this.loadData();
    },
    handleNew: function handleNew(vendaLivre, vendaNfce, entradaArmazenamento) {
      //abre a tela de edicao
      this.crud = __WEBPACK_IMPORTED_MODULE_9__main__["SysVars"].crudI; //operacao de inclusao
      this.params.codnf = 0;
      this.params.outrasSaidas = true;
      this.$store.dispatch('cleanpart');
      if (this.operacao == 'entrada') {
        this.params.operacaoNf = 'E';
        this.params.entradaArmazenamento = entradaArmazenamento;
      } else if (this.operacao == 'servico') {
        this.params.operacaoNf = 'S';
      } else {
        this.params.operacaoNf = 'S';
        this.params.vendaLivre = vendaLivre || vendaNfce;
        this.params.vendaNfce = vendaNfce;
      }
      this.showFormNfse = false;
      this.showForm = false;
      if (this.operacao == 'servico') {
        this.showFormNfse = true;
      } else {
        this.showForm = true;
      }
    },
    closeForm: function closeForm() {
      this.showForm = false;
      this.showFormNfse = false;
      this.showFormImportXML = false;
      this.loadData();
      this.$scrollTo(0);
    },
    editEntrada: function editEntrada(codnf, importacaoxml) {
      this.showForm = false;
      this.showFormNfse = false;
      this.handleEdit(codnf, importacaoxml);
    },
    handleSearch: function handleSearch(value) {
      //efetua a pesquisa
      this.filter = '{"$or":[{"nome":{"$like":"%25' + value + '%25"}},{"fantasia":{"$like":"%25' + value + '%25"}},{"nf":{"$eq":"' + value + '"}}]}';
      this.loadData();
    },
    loadData: function loadData() {
      this.$store.dispatch('loadNfAvisos'); //avisos de inutilizacao pendentes
      this.$store.dispatch('loadNfList', { operacao: this.operacao, filter: this.filter });
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },
    loadDataDetails: function loadDataDetails() {
      this.$store.dispatch('loadNf_with_itemList', { operacao: this.operacao, filter: this.filter });
    },
    updateActions: function updateActions() {
      //AÇÕES DO BOTAO INCLUIR
      if (this.operacao == 'entrada') {
        this.incluirActionsBarList = [{ action: 1, label: 'Importar XML de NF-e' }, { action: 5, label: 'Incluir Outras Notas' }, { action: 10, label: 'Incluir Nota Armazenamento' }];
      } else if (this.operacao == 'servico') {
        this.incluirActionsBarList = [{ action: 7, label: 'Incluir Serviço' }];
      } else {
        this.incluirActionsBarList = [
        // { action: 3, label: 'Venda com pedido' },
        { action: 6, label: 'Venda Sem Pedido' }, { action: 8, label: 'Nota Fiscal Consumidor NFC-e' }, { action: 4, label: 'Outras Operações' }];
      }
    },
    textST: function textST(value) {
      if (this.metadata && this.metadata.nf) return Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["getText"])(value, this.metadata.nf.stnf);
    },
    operacaoNf: function operacaoNf(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["getText"])(value, this.metadata.nf.operacaonf);
    },
    data: function data(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatDate"])(value);
    },
    handleImportarXMLNFe: function handleImportarXMLNFe() {
      //SELECIONA ARQUIVO XML PARA IMPORTACAO DA NF DE ENTRADA
      this.$refs.xmlFile.value = '';
      this.$refs.xmlFile.click();
    },
    handleUploadXML: function handleUploadXML() {
      //ENVIA O ARQUIVO XML SELECIONADO PARA EFETUAR IMPORTACAO
      var files = this.$refs.xmlFile.files;
      if (files.length == 0) {
        return;
      }

      var self = this;

      var file = files[0];
      var formData = new FormData();
      formData.append(file.name, file);
      var modulo = 'invoice/importxml/';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["urlORDS"])(this.$store, modulo), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if (response.data.errmessages) {
          self.$erpToastError('Erro na importação da XML: ' + response.data.errmessages[0]);
        } else {
          var codnf = response.data.codnf;
          self.handleEdit(codnf, true, null, response.data);
          self.$erpToastSuccess('O XML foi importado com sucesso.');
        }
      });
      // .catch(function(response){
      // self.$erpToastError(response.data.errmessages)
      // })
    },
    apiInvoice: function apiInvoice(p_nf, close, autorizacao) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var nf, sendData, metodo, update, modulo, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.loadNf(p_nf.codnf);

              case 2:
                nf = _context3.sent;

                if (!(nf && nf.stnf !== '02')) {
                  _context3.next = 24;
                  break;
                }

                //efetua a gravacao da nota fiscal
                sendData = {};

                sendData.nf = _extends({}, nf);
                if (autorizacao) sendData.autorizaenvio = true;

                metodo = 'post';
                update = false;

                if (nf.codnf != null) {
                  update = true;
                }

                modulo = 'invoice/nf/';
                _context3.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

              case 13:
                data = _context3.sent;

                if (!data.items) {
                  _context3.next = 24;
                  break;
                }

                nf = data.items[0];

                if (!(nf.validation && nf.validation.errmessages && nf.validation.errmessages.length > 0)) {
                  _context3.next = 21;
                  break;
                }

                _this4.$erpToastError('Validação da nota: ' + nf.validation.errmessages[0]);
                return _context3.abrupt('return', false);

              case 21:
                if (!update) {
                  _context3.next = 24;
                  break;
                }

                if (!close) {
                  _context3.next = 24;
                  break;
                }

                return _context3.abrupt('return');

              case 24:
                if (autorizacao) _this4.handleAutoriza(nf);

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    loadNf: function loadNf(codnf) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var nf;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                nf = {};


                console.log(codnf);

                _context4.next = 4;
                return _this5.$store.dispatch('loadNf', { id: codnf });

              case 4:
                if (_this5.$store.getters.getNf) {
                  nf = _extends({}, _this5.$store.getters.getNf[0]);
                }

                console.log(nf);

                return _context4.abrupt('return', nf);

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    handleAutorizaNF: function handleAutorizaNF(nf) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.apiInvoice(nf, false, true);

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    }
  },

  filters: {
    format: function format(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(value, 2);
    }

  },

  components: {
    BarList: __WEBPACK_IMPORTED_MODULE_1__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_2__components_bar_grid__["default"], nfsaidaForm: __WEBPACK_IMPORTED_MODULE_3__nfsaida_form__["default"], nfentradaForm: __WEBPACK_IMPORTED_MODULE_5__nfentrada_form__["default"], nfseForm: __WEBPACK_IMPORTED_MODULE_4__nfse_form__["default"]
  },

  mounted: function mounted() {
    this.filter = this.monthFilter.url; //carrega as notas do mes corrente
    this.loadData();
  },
  created: function created() {
    if (this.$route.params && this.$route.params.operacao) {
      this.operacao = this.$route.params.operacao; //operacao 'entrada' ou 'saida'
      this.handleTitle();
    }

    this.moreActionsBarList = [{ action: 0, label: 'Gerar Arquivos XML Período' }, { action: 2, label: 'Exportar Para Planilha' }, { action: 9, label: 'Notas e Itens Exportar Para Planilha' }];

    this.updateActions();

    this.showForm = false;
    this.showFormNfse = false;

    this.ambienteHomologacaoNFe();
    //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA

  }
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_numbers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_numbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_numbers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nfsaida_item__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nf_form_ref__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__nf_form_numero__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__customer_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__nates_form__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__forms_estoque_estoque_entrada__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__forms_estoque_estoque_saida__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_msg_banner_modal__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_api_nfe_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_api_nfe_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__api_api_nfe_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_api_nf_item_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_api_nf_item_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__api_api_nf_item_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_tourguidejs__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_tourguidejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_tourguidejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__nfsaida_form_modal_nfxml_vue__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__nfe_eventos_form__ = __webpack_require__(585);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params: {}, //outrasSaidas: false, outrasEntradas: false, codpedv: 0, codnf: 0
    crud: ''
  },

  components: {
    Trap: __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default.a, nfsaidaItem: __WEBPACK_IMPORTED_MODULE_5__nfsaida_item__["a" /* default */], nfFormRef: __WEBPACK_IMPORTED_MODULE_6__nf_form_ref__["a" /* default */], nfFormNumero: __WEBPACK_IMPORTED_MODULE_7__nf_form_numero__["a" /* default */], CustomerForm: __WEBPACK_IMPORTED_MODULE_8__customer_form__["default"], NatesForm: __WEBPACK_IMPORTED_MODULE_9__nates_form__["a" /* default */], EstoqueEntrada: __WEBPACK_IMPORTED_MODULE_10__forms_estoque_estoque_entrada__["a" /* default */], EstoqueSaida: __WEBPACK_IMPORTED_MODULE_11__forms_estoque_estoque_saida__["a" /* default */], Tourguide: __WEBPACK_IMPORTED_MODULE_15_tourguidejs___default.a, nfsaidaModalNfxml: __WEBPACK_IMPORTED_MODULE_16__nfsaida_form_modal_nfxml_vue__["a" /* default */], MsgBannerModal: __WEBPACK_IMPORTED_MODULE_12__components_msg_banner_modal__["a" /* default */], nfeEventosForm: __WEBPACK_IMPORTED_MODULE_17__nfe_eventos_form__["a" /* default */]
  },

  data: function data() {
    return {
      view: false, //variavel para controle de visualizacao ou edicao
      formCab: false, //editando cabecalho da nf
      formPar: false, //editando parcelas da nf
      formNF: false,
      formIncluir: false, //exibe formulario para inclusao de notas (campos participante e natureza)
      nfOutrasNotas: false, //inclusao de outras notas de saida
      nfVendaLivre: false, //nota de venda sem pedido
      nfVendaNfce: false, //nota de venda sem pedido
      showFormItem: false, //exibe o formulario de manutencao de item do pedido
      showNumeroForm: false, //exibe o formulario para alteracao do numero da nf
      showPartForm: false, //exibe o formulario de participante para inclusao
      showNatesForm: false, //exibe o formulario de naturezas para inclusao
      showCancel: false, //exibe a justificativa do cancelamento
      showCorrecao: false, //exibe a tela para emissao da carta de correção
      showEventos: false,
      defaultTpEvento: '',
      defaultTpEventoAut: '',
      defaultNProtEvento: '',
      showModalNfxml: false,
      formItemView: false,
      CANCEL_ITEM_MESSAGE: false,
      DELETE_ITEM_MESSAGE: false,
      showFormEmail: false,
      showFormEmailCC: false,
      showTotal: false,
      modalExcluir: false,
      showNewTaxes: false,
      modalBannerIBSCBS: false,
      entradaArmazenamento: false,

      updateItem: false, //indica quando for uma alteracao de item

      notaFiscalDemo: false,
      dadosNotaFiscalDemo: null,

      //entidades
      nf: _extends({}, this.$store.getters.getEntities.nf),
      nfit: [],
      nfpar: [], //parcelas da nf
      nfref: [], //notas referenciadas
      selectedNf: [], //notas de origem
      _nf: {}, //objeto utilizado para funcionalidade do botao descartar
      nfit_delete: null,
      metadata: _extends({}, this.$store.getters.getEntities.metadata),
      errmessages: [], //armazena as mensagens de validacao da nf apos a gravacao
      textocorrecao: '',
      textocorrecao_anterior: '',
      errCorrecao: [],

      codpedv: 0,
      codcompra: 0,
      codnf: 0,

      codpart: 0, //codigo do participante para alteracao
      crudPart: '', //inclusao ou alteracao de participante
      transportadora: false,

      codmenCpl: '', //mensagem complementar
      codmenFisco: '', //mensagem fisco

      enderecoEntrega: false,
      enderecoRetirada: false,

      nfit_update: {},
      paramItem: {},

      unwatch: true,
      natRetorno: false,

      moreActions: [], //botao mais acoes

      tabs: [{ title: 'Produtos da Nota' }, { title: 'Eventos' }], //paginas
      activeTab: 0, //pagina ativa

      showFormEstoqueEntrada: false,
      showEstoqueSaida: false,
      controleEstoqueHabilitado: false,

      excluirArmazenamento: false,
      excluirEstoqueSaida: false,

      editNfRef: false,

      hasManyNfs: false,
      steps: [{
        "selector": "",
        "step": 1,
        "title": 'Vamos come\xE7ar!',
        "content": "Vamos te guiar passo a passo por todo o processo de emissão de Nota Fiscal.</br></br><a href='javascript:void(0)' class='btn btn-sm btn-danger text-white' onclick='window.dispatchEvent(new CustomEvent(\"desativar-guia\"))'>Não mostrar este guia</a>"
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#part",
        "step": 2,
        "title": 'Cliente',
        "content": "Informe o cliente da nota fiscal."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#codnates",
        "step": 3,
        "title": 'Natureza de Opera\xE7\xE3o',
        "content": "Informe a natureza de operação da nota fiscal."
        // "image": "https://somehost.com/image.jpeg"
      }, {
        "selector": "#cfop",
        "step": 4,
        "title": 'C\xF3digo CFOP',
        "content": "Informe o código da CFOP da nota fiscal."
        // "image": "https://somehost.com/image.jpeg"
      }]

    };
  },


  computed: {

    appERP: function appERP() {
      return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appERP;
    },

    titleParticipante: function titleParticipante() {
      if (this.nf.venda == 'S') return 'Cliente';else if (this.nf.operacaonf == 'S') return 'Cliente/Destinatário';else if (this.nf.operacaonf) return 'Fornecedor/Remetente';
    },

    ambienteHomologacao: function ambienteHomologacao() {
      return Sysvars.ambienteHomologacao;
    },

    entradaArmazenamentoPendente: function entradaArmazenamentoPendente() {
      //habilitar e mostrar mensagem para efetuar armazenamento da nota
      if (!this.controleEstoqueHabilitado) return null;

      if (this.nf && this.nf.stnf && (this.nf.stnf == '01' || this.nf.stnf == '11')) {
        if (this.nf.operacaonf == 'E' && this.nf.movest == 'S' && this.nf.flagarmazenada == 'N') return 'Efetue o armazenamento do estoque da nota de entrada.';else return null;
      } else return null;
    },

    entradaArmazenamentoConcluido: function entradaArmazenamentoConcluido() {
      //mensagem para visualizar armazenamento da nota
      if (this.nf.operacaonf == 'E' && this.nf.movest == 'S' && this.nf.flagarmazenada == 'S') return 'Nota fiscal com estoque armazenado.';else return null;
    },

    saidaEstoqueBaixado: function saidaEstoqueBaixado() {
      if (this.nf.operacaonf == 'S' && this.nf.flagestoquebaixado == 'S') return 'Nota fiscal com estoque baixado. Alterações não são permitidas.';else return null;
    },

    saidaEstoquePendente: function saidaEstoquePendente() {
      if (!this.controleEstoqueHabilitado) return null;
      if (this.nf.operacaonf == 'S' && this.nf.movest == 'S' && this.nf.stnf == '01' && this.nf.flagsempedido == 'S' && this.nf.flagestoquebaixado != 'S') return 'Efetue a baixa de estoque da nota fiscal para concluir.';else return null;
    },

    _alteraNumero: function _alteraNumero() {
      return !this.isView && this.nf.emissaopropria == 'S' && (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50');
    },

    habilitaBotaoProduto: function habilitaBotaoProduto() {
      return !this.isView && (this.nfOutrasNotas || this.nfVendaLivre) && !this.nf.codpedv && this.nf.flagestoquebaixado != 'S' && this.nf.flagarmazenada != 'S';
    },

    habilitaDuplicata: function habilitaDuplicata() {
      return this.selectedNates && this.selectedNates.calcdup == 'S' && (this.nf.operacaonf == 'E' || this.nfOutrasNotas || this.nfVendaLivre);
    },

    deleteItem: function deleteItem() {
      return !this.isView && (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50') && !this.nf.codpedv && this.nf.flagestoquebaixado != 'S' && this.nf.flagarmazenada != 'S';
    },

    editItem: function editItem() {
      return !this.isView && (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50');
    },

    nfAutorizada: function nfAutorizada() {
      return this.nf.stnf === '10';
    },

    nfAguardando: function nfAguardando() {
      return this.nf.emissaopropria === 'S' && (this.nf.stnf === '01' || this.nf.stnf === '50');
    },

    isView: function isView() {
      //nao possibilita edicao da nf quando status diferente de 00 (digitacao), 01 (pendente), 11 (lançada), 50 (rejeitada)
      if (this.view) return true;else {
        var stnfVal = this.nf.stnf ? String(this.nf.stnf).padStart(2, '0') : '';
        return stnfVal !== '00' && stnfVal !== '01' && stnfVal !== '11' && stnfVal !== '50' || this.nf.fin_baixado > 0 || this.nf.fin_remessa > 0;
      }
    },

    nfPossuiEvento: function nfPossuiEvento() {
      //checa se a nf possui evento
      var evento = false;

      evento = this.nf.nfxml && this.nf.nfxml.length > 0 && this.nf.nfxml[0].nprotcan;
      if (!evento) {
        evento = this.nf.nfev && this.nf.nfev.length > 0;
      }
      return evento;
    },

    nfExportacao: function nfExportacao() {
      return this.nf.operacaonf == 'S' && this.nf.part && this.nf.part.length > 0 && this.nf.part[0].uf == 'EX';
    },

    nfImportacao: function nfImportacao() {
      return this.nf.operacaonf == 'E' && this.nf.part && this.nf.part.length > 0 && this.nf.part[0].uf == 'EX';
    },

    selectedPart: function selectedPart() {
      return this.$store.getters.getPart;
    },

    parcelas: {
      // getter
      get: function get() {
        return this.nf.parcelas;
      },
      // setter
      set: function set(newValue) {
        this.nf.parcelas = newValue;
        this.calculaParcelas();
      }
    },

    stnf: function stnf() {
      return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["getText"])(this.nf.stnf, this.metadata.nf.stnf);
    },

    title: function title() {
      if (this.nf.operacaonf == 'E') {
        return 'Nota Fiscal de Entrada ';
      } else if (this.nfOutrasNotas) {
        return 'Nota Fiscal de Saída ';
      } else {
        return 'Nota Fiscal de Venda ';
      }
    },

    _codpart: function _codpart() {
      return this.nf.codpart;
    },

    codnates: function codnates() {
      return this.nf.codnates;
    },

    selectedNates: function selectedNates() {
      return this.$store.getters.getNates;
    },

    _nomeuf: function _nomeuf() {
      if (this.nf.part && this.nf.part.length > 0) {
        if (this.nf.part[0].nomeuf) {
          return this.nf.part[0].nomeuf;
        } else if (this.nf.part[0].estado) {
          return this.nf.part[0].estado[0].nomeuf;
        }
      }
    },

    _nomemun: function _nomemun() {
      if (this.nf.part && this.nf.part.length > 0) {
        if (this.nf.part[0].nomemun) {
          return this.nf.part[0].nomemun;
        } else if (this.nf.part[0].mun) {
          return this.nf.part[0].mun[0].nomemun;
        }
      }
    },
    _toticmsst: function _toticmsst() {
      return this.nf.toticmst + this.nf.totfcpst;
    },

    appLoja: function appLoja() {
      return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appLoja;
    },

    showGuia: function showGuia() {
      return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].guia;
    }

  },

  watch: {
    'nf.codfil': function nfCodfil() {
      this.isControleEstoqueAtivado(this.nf.codfil);
    },
    'nf.emissaopropria': function nfEmissaopropria() {
      if (this.nf.emissaopropria == 'S' && this.nf.operacaonf == 'E' && !this.nf.codnf) {
        this.nf.nf = null;
        this.nf.serie = null;
        this.nf.chave = null;
      }
    },
    'nf.totger': function nfTotger() {
      this.calculaParcelas();
    },
    'nf.tpfrete': function nfTpfrete() {
      this.metadata.nf.codparttr.validator = { required: true };
      if (this.nf.tpfrete == '9') {
        this.metadata.nf.codparttr.validator = null;
        // this.$validator.excludeField('codpart')
      }
      this.$validator.reset();
    },
    'nf.finalidade': function nfFinalidade() {
      this.metadata.nf.codpart.validator = { required: true };
      if (this.nf.finalidade == 'F') {
        this.metadata.nf.codpart.validator = null;
        // this.$validator.excludeField('codpart')
      }
      this.$validator.reset();
    },

    _codpart: function _codpart(newValue, oldValue) {
      //CARREGA DADOS DO PARTICIPANTE QUANDO ALTERADO
      if (newValue != oldValue) {
        this.$store.dispatch('loadPart', { id: this.nf.codpart });
      }
    },

    selectedPart: function selectedPart() {
      //atualiza os dados do participante quando informado o codigo
      if (this.unwatch) {
        return;
      }
      this.nf.part = this.selectedPart;
      if (this.nf.part && this.nf.part.length > 0) {
        this.nf.finalidade = this.nf.part[0].tpcliente;
        if (this.nf.part[0].contricms == 'N' && !this.nf.finalidade || this.nf.nfce == 'S') //evitar rejeição
          this.nf.finalidade = 'F';

        if (this.nf.part[0].codnates && this.nf.venda == 'S') this.nf.codnates = this.nf.part[0].codnates;

        if (this.nf.operacaonf === 'S' && this.nf.part[0].codnatfinrec && this.nf.venda == 'S') this.nf.codnatfin = this.nf.part[0].codnatfinrec;

        if (this.nf.operacaonf === 'E' && this.nf.part[0].codnatfindes) this.nf.codnatfin = this.nf.part[0].codnatfindes;
      }
    },

    codnates: function codnates() {
      // if (this.unwatch) {
      //     return
      // }
      this.$store.dispatch('loadNates', { id: this.nf.codnates });
    },

    selectedNates: function selectedNates() {
      //HABILITA CAMPO DE NOTA REFERENCIADA CONFORME TIPO DE NATUREZA INFORMADA (DEVOLUCAO, AJUSTE, COMPLEMENTO)

      if (this.unwatch) {
        return;
      }
      this.nf.nates = this.selectedNates;
      this.nf.cfop = this.nf.nates.cfop;
      this.nf.tpnf = this.nf.nates.tpnf;
      this.checkAvisoNaturezaIcmFilialSemIE(this.selectedNates);

      if (this.nf.tpnf !== 'CR') {
        this.nf.tpnfcredito = null;
      }
      if (this.nf.tpnf !== 'DB') {
        this.nf.tpnfdebito = null;
      }

      //NOTA FISCAL DE INDUSTRIALIZACAO PERMITE INFORMAR NATUREZA DE RETORNO
      if (this.nf.operacaonf === 'S') {
        if (this.nf.tpnf === 'I' || this.selectedNates.tpnf === 'I') {
          this.natRetorno = true;
        } else {
          this.natRetorno = false;
        }
      }
    },

    codmenCpl: function codmenCpl() {
      if (this.codmenCpl) {
        this.loadInfCpl();
      }
    },

    codmenFisco: function codmenFisco() {
      if (this.codmenFisco) {
        this.loadInfAdFisco();
      }
    }

  },

  mixins: [__WEBPACK_IMPORTED_MODULE_13__api_api_nfe_js___default.a, __WEBPACK_IMPORTED_MODULE_14__api_api_nf_item_js___default.a],

  methods: {
    isNfRefLinked: function isNfRefLinked(nf) {
      if (!this.nfit || this.nfit.length === 0) return false;
      return this.nfit.some(function (it) {
        if (nf.chave && it.chaveorigem && String(nf.chave).trim().toLowerCase() === String(it.chaveorigem).trim().toLowerCase()) {
          return true;
        }
        if (nf.codnfref && it.codnforigem && Number(nf.codnfref) === Number(it.codnforigem)) {
          return true;
        }
        return false;
      });
    },
    handleConfirmBannerIBSCBS: function handleConfirmBannerIBSCBS() {
      localStorage.setItem('nfsaida-form-banner-ibscbs', true);
    },
    checkAvisoNaturezaIcmFilialSemIE: function checkAvisoNaturezaIcmFilialSemIE(nates) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var cfopStr, codfil, filial;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!nates || _this.unwatch)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (!(nates.calcicm !== 'S')) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                if (!(nates.tpnf === 'D')) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return');

              case 6:
                cfopStr = String(nates.cfop || '').trim();

                if (!(cfopStr.startsWith('12') || cfopStr.startsWith('22') || cfopStr.startsWith('52') || cfopStr.startsWith('62'))) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return');

              case 9:
                codfil = (_this.nf ? _this.nf.codfil : null) || (_this.$store.getters.getFilial ? _this.$store.getters.getFilial.codfil : null);

                if (!codfil) {
                  _context.next = 13;
                  break;
                }

                _context.next = 13;
                return _this.$store.dispatch('loadFilial', { id: codfil });

              case 13:
                filial = _this.$store.getters.getFilial;

                if (filial && (!filial.iest || String(filial.iest).trim() === '')) {
                  _this.$erpToastWarning('Aviso: A filial emitente não possui Inscrição Estadual (contribuinte exclusivo IBS/CBS) e a natureza selecionada calcula ICMS. Operações com destaque de ICMS são rejeitadas pela SEFAZ (NT 2026.007), exceto em devoluções.');
                }

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    closeModalNfxml: function closeModalNfxml() {
      this.showModalNfxml = false;
    },
    handleInformaNfxml: function handleInformaNfxml(_ref) {
      var xml = _ref.xml,
          chave = _ref.chave,
          nprot = _ref.nprot;

      this.closeModalNfxml();
      if (!this.nf.nfxmlinfo) this.$set(this.nf, 'nfxmlinfo', {});
      this.nf.nfxmlinfo.xml = xml;
      this.nf.nfxmlinfo.chave = chave;
      this.nf.chave = chave;
      this.nf.nfxmlinfo.nprot = nprot;
      this.apiInvoice();
    },
    closeForm: function closeForm() {
      if (this.$route.params.id == 'novo') this.$router.go(-1);else this.$emit('closeform');
    },
    handleChangeValores: function handleChangeValores() {
      if (this.nf.stnf != '00' && this.nf.stnf != '01' && this.nf.stnf != '11' && this.nf.stnf != '50') return;

      this.nf.totger = this.nf.totmer + this.nf.totser + this.nf.vlrfre + this.nf.vlrdesp + this.nf.vlrseg - this.nf.vlrdesc + this.nf.totipi + this.nf.toticmst + this.nf.totipidevol;

      this.nf.stnf = '00';
    },
    getParcelasFormapagParametrosFilial: function getParcelasFormapagParametrosFilial(codfil) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var parametros, filial;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (codfil) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', '15');

              case 2:
                parametros = {};
                _context2.next = 5;
                return _this2.$store.dispatch('loadFilial', { id: codfil });

              case 5:
                if (_this2.$store.getters.getFilial) {
                  filial = _this2.$store.getters.getFilial;

                  if (filial.parametros) {
                    parametros = JSON.parse(filial.parametros);
                  }
                }

                if (!parametros) {
                  _context2.next = 10;
                  break;
                }

                if (!parametros.parcelas) {
                  _context2.next = 10;
                  break;
                }

                if (!parametros.parcelas.formapag) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt('return', parametros.parcelas.formapag);

              case 10:
                return _context2.abrupt('return', '15');

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    closeNatesForm: function closeNatesForm(id) {
      //ao fechar o formulario de inclusao de naturezas
      if (id) this.nf.codnates = id;
      this.showNatesForm = false;
    },
    handleIncluirNates: function handleIncluirNates() {
      //exibe tela de cadastro da natureza
      this.showNatesForm = true;
    },
    isControleEstoqueAtivado: function isControleEstoqueAtivado(codfil) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var parametros, filial;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (codfil) {
                  _context3.next = 3;
                  break;
                }

                _this3.controleEstoqueHabilitado = false;
                return _context3.abrupt('return');

              case 3:
                parametros = {};
                _context3.next = 6;
                return _this3.$store.dispatch('loadFilial', { id: codfil });

              case 6:
                if (_this3.$store.getters.getFilial) {
                  filial = _this3.$store.getters.getFilial;

                  if (filial.parametros) {
                    parametros = JSON.parse(filial.parametros);
                  }
                }
                _this3.controleEstoqueHabilitado = parametros.controlaestoque;

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleArmazenarEntrada: function handleArmazenarEntrada() {
      this.$modalForm(true);
      this.excluirArmazenamento = false;
      this.showFormEstoqueEntrada = true;
    },
    handleExcluirentradaarmazenamento: function handleExcluirentradaarmazenamento() {
      this.$modalForm(true);
      this.excluirArmazenamento = true;
      this.showFormEstoqueEntrada = true;
    },
    closeEstoqueForm: function closeEstoqueForm() {
      this.$modalForm(false);
      this.showFormEstoqueEntrada = false;
      this.showEstoqueSaida = false;
      this.codnf = this.nf.codnf;
      this.loadData();
    },
    handleEstoqueSaida: function handleEstoqueSaida() {
      this.$modalForm(true);
      this.excluirEstoqueSaida = false;
      this.showEstoqueSaida = true;
    },
    handleExcluirEstoqueSaida: function handleExcluirEstoqueSaida() {
      this.$modalForm(true);
      this.excluirEstoqueSaida = true;
      this.showEstoqueSaida = true;
    },


    // async loadAmbienteNFe () {
    //   await this.$store.dispatch('loadFilial', {})
    //   this.ambienteNFe = this.$store.getters.getFilialList[0].tpambnfe == '2'
    // },

    showNfRef: function showNfRef() {
      //habilita botao de notas referenciadas/selecao de notas de origem
      //notas de complemento, ajuste, devolucao, retorno, credito e debito
      var ref = this.nf.nates && (this.nf.nates.tpnf == 'P' || this.nf.nates.tpnf == 'A' || this.nf.nates.tpnf == 'D' || this.nf.nates.tpnf == 'T' || this.nf.nates.tpnf == 'I' || this.nf.nates.tpnf == 'CR' || this.nf.nates.tpnf == 'DB');
      return ref;
    },
    loadInfCpl: function loadInfCpl() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.$store.dispatch('loadMennf', { id: _this4.codmenCpl });

              case 2:
                if (_this4.$store.getters.getMennf.texto) {
                  if (_this4.nf.obs) {
                    _this4.nf.obs = _this4.nf.obs + _this4.$store.getters.getMennf.texto;
                  } else {
                    _this4.nf.obs = _this4.$store.getters.getMennf.texto;
                  }
                }

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    loadInfAdFisco: function loadInfAdFisco() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.$store.dispatch('loadMennf', { id: _this5.codmenFisco });

              case 2:
                if (_this5.$store.getters.getMennf.texto) {
                  if (_this5.nf.obsfisco) {
                    _this5.nf.obsfisco = _this5.nf.obsfisco + _this5.$store.getters.getMennf.texto;
                  } else {
                    _this5.nf.obsfisco = _this5.$store.getters.getMennf.texto;
                  }
                }

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    data: function data(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["formatDate"])(value);
    },
    closeNumeroForm: function closeNumeroForm() {
      this.showNumeroForm = false;
    },
    handleUpdateNumero: function handleUpdateNumero() {
      //BOTAO ALTERAR NUMERO DA NOTA
      this.showNumeroForm = true;
    },
    handleAlterarOutras: function handleAlterarOutras() {
      this.formCab = true;
    },
    updateNumero: function updateNumero() {
      //EFETUA A ALTERACAO DA NUMERACAO DA NF E GRAVA A NF
      this.closeNumeroForm();
      this.nf.updatenumero = true;
      this.apiInvoice();
    },
    handleIncluirPart: function handleIncluirPart(transportadora) {
      //abre tela para inclusao de cliente ou transportadora
      this.crudPart = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI;
      this.transportadora = false;
      if (transportadora) {
        this.transportadora = true;
      }
      this.showPartForm = true;
    },
    handleAlterarPart: function handleAlterarPart(transportadora) {
      //abre tela de alteracao de participante (participante ou transportadora)
      this.crudPart = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudU;
      this.transportadora = false;
      if (transportadora) {
        this.codpart = this.nf.codparttr; //alteracao de transportadora
        this.transportadora = true;
      } else {
        this.codpart = this.nf.codpart; //alteracao de cliente
      }
      this.showPartForm = true;
    },
    closeCustomerForm: function closeCustomerForm(part) {
      //ao fechar o formulario de inclusao de participantes
      this.showPartForm = false;
      if (part && part.length > 0) {
        //se um novo participante foi incluido
        if (this.transportadora) {
          this.nf.parttr = part; //carrega a transportadora incluida
          this.nf.codparttr = part[0].codpart;
        } else {
          this.nf.part = part; //carrega o cliente incluido
          this.nf.codpart = part[0].codpart;
        }
      }
    },
    handleActions: function handleActions(action) {
      //duplica a nota fiscal
      if (action == 4) {}

      //enviar email
      if (action == 1) {
        this.handleFormEmailDanfe();
      }

      //imprimir danfe
      if (action == 2) {
        this.imprimirDANFE(false);
      }

      //preview da danfe
      if (action == 11) {
        if (this.nf.esp == '59') {
          this.$erpToastError('A Pré NOTA só pode ser visualizada no modelo SAT.');
        } else {
          this.imprimirDANFE(true);
        }
      }

      if (action == 12) {
        this.$router.push('/banking?codnf=' + this.nf.codnf);
      }

      //cancela a nota fiscal
      if (action == 3) {
        this.showCancel = true;
        this.$nextTick(function () {
          this.$refs.obscan.focus();
        });
      }

      //exclui a nota fiscal
      if (action == 5) {
        this.modalExcluir = true;
      }

      //download do xml
      if (action == 6) {
        this.downloadXML();
      }

      //autorizacao
      if (action == 7) {
        var vm = this;
        this.nf.stnf = '01';
        this.apiInvoice(false, true);
      }

      //emitir correcao
      if (action == 8) {
        this.errCorrecao = [];
        this.showCorrecao = true;
        this.$nextTick(function () {
          this.$refs.correcao.focus();
        });
      }

      //emitir cce
      if (action == 9) {
        this.imprimirCC();
      }

      //enviar cce por email
      if (action == 10) {
        this.handleFormEmailCC();
      }

      //excluir armazenamento
      if (action == 20) {
        this.handleExcluirentradaarmazenamento();
      }

      //excluir armazenamento
      if (action == 21) {
        this.handleExcluirEstoqueSaida();
      }

      if (action == 22) {
        this.showModalNfxml = true;
      }

      if (action == 30) {
        this.handleEmitirEvento();
      }
    },
    handleExcluir: function handleExcluir() {
      this.modalExcluir = false;
      this.apiInvoiceDelete();
    },
    closeModal: function closeModal() {
      this.modalExcluir = false;
      this.modalBannerIBSCBS = false;
    },
    handleCancel: function handleCancel() {
      //botao confirmacao de cancelamento da nf
      if (this.nf.obscan == null) {
        this.$erpToastError('Por favor preencha a justificativa para continuar');
        return;
      }
      if (String(this.nf.obscan).length < 15) {
        this.$erpToastError('O texto do cancelamento deve possuir no mínimo 15 caracteres');
        return;
      }
      if (String(this.nf.obscan).length > 255) {
        this.$erpToastError('O texto do cancelamento deve possuir no máximo 255 caracteres');
        return;
      }
      this.apiInvoiceCancel();
    },
    handleCorrecao: function handleCorrecao() {
      //botao confirmacao de cancelamento da nf
      this.textocorrecao = this.$removerAcentos(this.textocorrecao);
      if (this.textocorrecao) this.textocorrecao = this.textocorrecao.replace(/(\r\n|\n|\r)/gm, "");

      if (this.textocorrecao == '') {
        this.$erpToastError('Por favor preencha o texto da correção para continuar');
        return;
      }
      if (String(this.textocorrecao).length < 15) {
        this.$erpToastError('O texto da correção deve possuir no mínimo 15 caracteres');
        return;
      }
      if (String(this.textocorrecao).length > 1000) {
        this.$erpToastError('O texto da correção deve possuir no máximo 1000 caracteres');
        return;
      }
      this.apiInvoiceCorrecao();
    },
    handleCorrecaoClose: function handleCorrecaoClose() {
      //botao descartar correção da nf
      this.showCorrecao = false;
    },
    handleCancelDiscard: function handleCancelDiscard() {
      //botao descartar cancelamento da nf
      this.showCancel = false;
    },
    certificadoA3: function certificadoA3() {
      var tipo = this.$certificadoCheck(this.nf.codfil);
      if (this.esp == '59') {
        this.$erpToastError('A Pré NOTA não pode ser visualizada no modelo SAT.');
        return false;
      } else if (tipo == 'A3') {
        this.$erpToastError('A Pré NOTA só pode ser visualizada com certificado A1.');
        return false;
      } else if (tipo == 'A1') {
        return true;
      } else {
        return false;
      }
    },
    handleIncluir: function handleIncluir() {
      var _this6 = this;

      //INCLUIR NOVA NOTA FISCAL (APOS INFORMAR PARTICIPANTE E NATUREZA)
      // if (this.nf.codpart == null || this.nf.codnates == null || this.nf.cfop == null) {
      //     this.$erpToastError('Por favor preencha os campos para continuar')
      //     return
      // }

      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this6.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          var isValidCabec = true;
          if (_this6.nf.operacaonf === 'E' && _this6.nf.emissaopropria === 'N' && _this6.nf.entradaarmazenamento != 'S' && (!_this6.nf.nf || _this6.nf.nf == '0' || !_this6.nf.serie)) {
            _this6.$erpToastError('Informe a série e número da NF.');
            isValidCabec = false;
          }
          if (_this6.nf.nates && _this6.nf.nates.stnates == 'I') {
            _this6.$erpToastError('A Natureza de saída informada está inativa');
            isValidCabec = false;
          }
          if (_this6.nf.operacaonf === 'S' && _this6.nf.venda === 'S' && _this6.nf.part && _this6.nf.part.length > 0 && _this6.nf.part[0].stcred != 'L') {
            _this6.$erpToastError('Cliente com crédito bloqueado. Operação não permitida.');
            isValidCabec = false;
          }
          if (_this6.nf.part && _this6.nf.part.lenght > 0 && _this6.nf.part[0].stpart == 'I') {
            _this6.$erpToastError('Participante inativo. Operação não permitida.');
            isValidCabec = false;
          }
          if (!_this6.validaRef()) {
            return;
          }
          if (isValidCabec) {
            _this6.apiInvoice();
          }
        }
      });

      // if (!this.validacaoInicial()) {
      //     return
      // }
    },
    handleRetorna: function handleRetorna() {
      //botao retornar
      //fecha a inclusao da nf
      //volta para lista de pedido ou para lista de nf
      if (this.$route.params && this.$route.params.id == 'novo') this.$router.go(-1);else if (this.$route.query.tipo == 'devolucao') this.$router.go(-1);else if (this.$route.query.tipo == 'view') this.$router.go(-1);else if (this.codpedv) {
        if (!this.appLoja) {
          this.$router.push('/pedidolist'); //retorna para a lista de pedido quando for faturamento de pedido
        } else {
          this.$router.push('/fv/pedidos'); //retorna para a lista de pedido quando for faturamento de pedido
        }
      } else if (this.codcompra) {
        this.$router.push('/compralist'); //retorna para a lista de pedido quando for faturamento de pedido
      } else this.$emit('closeform');
    },
    calculaParcelas: function calculaParcelas() {
      var _this7 = this;

      if (this.unwatch) return;

      if (this.nf.operacaonf == 'E' && this.selectedNates && this.selectedNates.calcdup == 'S' && this.nf.parcelas == null) {
        this.nf.parcelas = 0;
      }

      var total = 0;
      if (this.nf.totdup) total = parseFloat(Object(__WEBPACK_IMPORTED_MODULE_2__shared_numbers__["arr"])(Number.parseFloat(this.nf.totdup), 2, true));else total = parseFloat(Object(__WEBPACK_IMPORTED_MODULE_2__shared_numbers__["arr"])(Number.parseFloat(this.nf.totger), 2, true));

      this.nfpar = [];
      var vlr = 0.0;
      var soma = 0.0;
      if (this.nf.parcelas == '0') {
        var parcela = _extends({}, this.$store.getters.getEntities.nfpar);
        parcela.dtv = this.nf.data;
        parcela.vlr = total;
        parcela.obspar = '';
        parcela.error = null;
        parcela.dias = 0;
        this.getParcelasFormapagParametrosFilial(this.nf.codfil).then(function (v) {
          parcela.formapag = v;
        });

        if (parcela.formapag == null) {
          parcela.formapag = "15";
        }

        this.nfpar.push(parcela);
      } else {
        var _loop = function _loop() {
          var parcela = _extends({}, _this7.$store.getters.getEntities.nfpar);
          parcela.dias = x * 30;
          // parcela.dtv = this.$addMonths(this.nf.data, x);
          parcela.dtv = _this7.$addDays(_this7.nf.data, parcela.dias);
          vlr = total;
          vlr = Object(__WEBPACK_IMPORTED_MODULE_2__shared_numbers__["arr"])(vlr / _this7.nf.parcelas, 2, true);
          parcela.vlr = vlr;
          soma = Number(soma) + Number(vlr);
          soma = Number(soma).toFixed(2);

          if (x == _this7.nf.parcelas) {
            if (soma > total) {
              parcela.vlr = parcela.vlr - (soma - total);
            } else if (soma < total) {
              parcela.vlr = Number(parcela.vlr) + (Number(total) - Number(soma));
            }
          }

          parcela.error = null;
          parcela.obspar = '';
          _this7.getParcelasFormapagParametrosFilial(_this7.nf.codfil).then(function (v) {
            parcela.formapag = v;
          });

          if (parcela.formapag == null) {
            parcela.formapag = "15";
          }

          _this7.nfpar.push(parcela);
        };

        for (var x = 1; x <= this.nf.parcelas; x++) {
          _loop();
        }
      }
    },
    handleAutoriza: function handleAutoriza() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var tipo;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                //envia nf para autorizacao
                //this.nf.stnf = ''
                if (_this8.nf.filial[0].cnpj == '11111111111111') {
                  _this8.$erpToastError('Em período de trial não é possível autorizar, será exibida a pré-visualização da DANFE.');
                  _this8.imprimirDANFE(true);
                } else {
                  _this8.nf.xmotivo = '';
                  _this8.$scrollTo(0);

                  if (_this8.nf.esp == '59') {
                    _this8.autorizaNFeSAT(_this8.nf, _this8.NFeResponseCallbackSAT);
                  } else {
                    tipo = _this8.$certificadoCheck(_this8.nf.codfil);

                    if (tipo == 'A1') {
                      _this8.autorizaNFeA1(_this8.nf, _this8.NFeResponseCallbackA1);
                    } else if (tipo == 'A3') {
                      _this8.autorizaNFeA3(_this8.nf, _this8.NFeResponseCallbackA3);
                    }
                  }
                }

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },
    NFeResponseCallbackSAT: function NFeResponseCallbackSAT(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO SAT
      this.errmessages = {};
      this.codnf = this.nf.codnf;
      if (response.status != 'success') {
        this.$erpToastError(response.message);
      } else {
        if (response.response.nf.length > 0 && response.response.nf[0].cstat == '100') {
          this.$erpToastSuccess('NFe Autorizada');
        } else {
          this.updateActions();
          this.nf.xmotivo = response.response.xmotivo;
          this.$erpToastError(response.response.xmotivo);
        }
      }
      this.loadData();
    },
    NFeResponseCallbackA3: function NFeResponseCallbackA3(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
      this.errmessages = {};
      this.codnf = this.nf.codnf;
      if (response.status != 'success') {
        this.$erpToastError(response.message);
      } else {
        if (response.response.nf.length > 0 && response.response.nf[0].cstat == '100') {
          this.$erpToastSuccess('NFe Autorizada');
        } else {
          this.updateActions();
          this.nf.xmotivo = response.response.xmotivo;
          this.$erpToastError(response.response.xmotivo);
        }
      }
      this.loadData();
    },
    NFeResponseCallbackA1: function NFeResponseCallbackA1() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this9.updateActions();

                // const resp = await apiAutNFe(this, this.nf.codfil, this.nf.codnf)
                // if (resp.data) {
                //     if (resp.data.errmessages) {
                //         this.$erpToastError(resp.data.errmessages[0])
                //         this.errmessages.errmessages = resp.data.errmessages
                //     } else {
                //         if (resp.data.nf.length > 0) {
                //             if (resp.data.nf[0].cstat === '100') {
                //                 //EXIBE A MENSAGEM DE NF AUTORIZADA E ATUALIZA O STATUS E CHAVE DA NF NA TELA
                //                 this.$erpToastSuccess('Nota fiscal autorizada')
                //                 this.nf.stnf = '10'
                //                 this.nf.chave = resp.data.nf[0].chave
                //                 this.updateActions()
                //             } else {
                //                 this.nf.stnf = '50'  //NF REJEITADA
                //                 this.errmessages.errmessages = []
                //                 this.errmessages.errmessages.push(resp.data.nf[0].xmotivo)
                //                 this.$erpToastError(resp.data.nf[0].xmotivo)
                //                 this.updateActions()
                //             }
                //         }
                //         else {
                //             //LOTE REJEITADO OU AINDA NAO PROCESSADO
                //             this.nf.stnf = '50'  //NF REJEITADA
                //             //this.nf.xmotivo = resp.data.xmotivo
                //             this.errmessages.errmessages = []
                //             this.errmessages.errmessages.push(resp.data.xmotivo)
                //             this.$erpToastError(resp.data.xmotivo)
                //             this.updateActions()
                //         }
                //     }
                // }

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9);
      }))();
    },
    possuiNForigem: function possuiNForigem() {
      if (this.nf.tpnf === 'I' || this.selectedNates.tpnf === 'I') {
        for (var i = 0; i < this.nfref.length; i++) {
          if (this.nfref[i].codnfref != null) {
            return true;
          }
        }
      }
      return false;
      // return (this.nfref.length > 0);
    },
    validaRef: function validaRef() {
      //efetua a validacao das notas referenciadas
      if (!this.showNfRef()) {
        this.nfref = [];
        return true;
      }
      if (this.nfref.length == 0) {
        if (this.nf.tpnf !== 'DB') {
          this.$erpToastError('A Configuração da natureza de operação utilizada (' + this.nf.cfop + ') exige que seja referenciada uma chave.');
          return false;
        }
      } else {
        if (this.possuiNForigem() === true && this.nf.tpnf === 'I' && this.nf.codnatesret == null) {
          //NOTA DE INDUSTRIALIZACAO OBRIGA NAT DE RETORNO
          this.$erpToastError('Informe a natureza de retorno');
          return false;
        }
      }
      var erro = false;
      for (var i = 0; i < this.nfref.length; i++) {
        this.nfref[i].validation = {};
        if (this.nfref[i].nfreftp == 1 || this.nfref[i].nfreftp == 2) {
          if (this.nfref[i].chave == null || this.nfref[i].chave.length < 44) {
            this.nfref[i].validation.chave = 'Chave inválida';
            erro = true;
          }
        } else if (this.nfref[i].nfreftp == 3 || this.nfref[i].nfreftp == 4) {
          if (this.nfref[i].nf == null || this.nfref[i].nf.length < 1) {
            this.nfref[i].validation.nf = 'Número da NF obrigatório';
            erro = true;
          }
        }
      }
      if (erro) {
        this.$erpToastError('Por favor preencha corretamente os campos em destaque para continuar');
      }
      return !erro;
    },
    handleTotalizar: function handleTotalizar(close) {
      //grava a nota fiscal

      if (this.nfit.length == 0) {
        this.$erpToastError('Erro: Itens não informados.');
        return;
      }

      if (this.habilitaDuplicata && this.nf.venda === 'S' && this.nf.emissaopropria === 'S' && this.nf.parcelas == null) {
        this.$nextTick(function () {
          this.$refs.parcelas.focus();
        });
        this.$erpToastError('Informe a condição de pagamento');
        return;
      }

      if (this.nf.emissaopropria === 'S' && !this.nf.tpfrete) {
        this.$nextTick(function () {
          this.$refs.tpfrete.focus();
        });
        this.$erpToastError('Informe a modalidade do frete');
        return;
      }

      if (this.nf.emissaopropria == 'N') this.nf.stnf = '11';else this.nf.stnf = '01';

      this.isTotalizarRequest = true;
      this.apiInvoice(close);
    },
    handleEditar: function handleEditar() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                //edita a nota fiscal de entrada (somente para nota fiscal importada por xml)
                modulo = 'invoice/edit/' + _this10.nf.codnf;
                _context8.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this10.$store, modulo, {}, 'post');

              case 3:
                data = _context8.sent;

                if (data.errmessages) {
                  _this10.$erpToastError(data.errmessages[0]);
                } else {
                  //RETORNA PARA A LISTA DA NOTA COM EVENTO DE EDICAO ONDE SERÁ ABERTA A TELA DE EDICAO DA NF DE ENTRADA
                  _this10.$emit('edit', _this10.nf.codnf, _this10.nf.importxml == 'S');
                  //    this.nf.stnf = '00'
                  //    this.view = false
                }

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this10);
      }))();
    },
    handleFaturar: function handleFaturar() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                //fatura o pedido de venda
                modulo = 'invoice/order/' + _this11.codpedv;
                _context9.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this11.$store, modulo, {}, 'post');

              case 3:
                data = _context9.sent;

                if (data.codnf) {
                  _this11.codnf = data.codnf;
                  _this11.loadData();
                }

              case 5:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this11);
      }))();
    },
    handleCompra: function handleCompra() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                //fatura o pedido de venda
                modulo = 'invoice/compra/' + _this12.codcompra;
                _context10.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this12.$store, modulo, {}, 'post');

              case 3:
                data = _context10.sent;

                if (data.codnf) {
                  _this12.codnf = data.codnf;
                  _this12.loadData();
                }

              case 5:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this12);
      }))();
    },
    handleDescartar: function handleDescartar() {},
    handleSalvarDadosAdicionais: function handleSalvarDadosAdicionais() {
      var _this13 = this;

      //botao salvar dados do cabecalho da nf
      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this13.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          _this13.nf.stnf = '00'; //obriga que o usuário totalize a nota novamente
          _this13.apiInvoice();
          _this13.closeFormCab();
        }
      });
    },
    closeFormCab: function closeFormCab() {
      this.formCab = false;
    },
    apiInvoice: function apiInvoice(close, autorizacao) {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var nfit, sendData, metodo, update, modulo, data;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (_this14.handleValidaParcelas()) {
                  _context11.next = 3;
                  break;
                }

                _this14.$erpToastError('Erro: Parcelas com datas não permitidas.');
                return _context11.abrupt('return');

              case 3:

                //efetua a gravacao da nota fiscal
                nfit = [];

                nfit = _this14.nfit;
                _this14.nf.nfit = nfit;
                _this14.nf.nfpar = _this14.nfpar;
                _this14.nf.nfref = _this14.nfref;
                sendData = {};

                sendData.nf = _extends({}, _this14.nf);
                if (autorizacao) sendData.autorizaenvio = true;

                if (_this14.isTotalizarRequest) {
                  sendData.istotalizar = true;
                  _this14.isTotalizarRequest = false;
                }

                metodo = 'post';
                update = false;

                if (_this14.nf.codnf != null) {
                  //metodo = 'put'
                  update = true;
                }

                modulo = 'invoice/nf/';
                //if (cancel) {
                //  modulo = 'invoice/nf/cancel/'
                //}

                _context11.next = 18;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this14.$store, modulo, sendData, metodo);

              case 18:
                data = _context11.sent;

                if (!data.items) {
                  _context11.next = 37;
                  break;
                }

                _this14.nf = data.items[0];
                _this14.nf.nates = _this14.nf.nates[0];
                _this14.nfit = _this14.nf.nfit;
                _this14.nfref = _this14.nf.nfref;
                _this14.nfpar = _this14.nf.nfpar;

                if (!_this14.nfErro()) {
                  _context11.next = 31;
                  break;
                }

                _this14.$scrollTo(0);
                _this14.$erpToastError('Por favor corrija os erros de validação');
                return _context11.abrupt('return', false);

              case 31:
                if (!update) {
                  _context11.next = 36;
                  break;
                }

                _this14.$erpToastSuccess('Nota fiscal gravada com sucesso');

                if (!close) {
                  _context11.next = 36;
                  break;
                }

                _this14.handleRetorna();
                return _context11.abrupt('return');

              case 36:
                _this14.errmessages = [];

              case 37:
                _this14.updateActions();

                if (_this14.formIncluir && _this14.notaFiscalDemo) _this14.incluiProdutoNotaFiscalDemo();

                _this14.formIncluir = false;
                _this14.formNF = true;

                if (autorizacao) _this14.handleAutoriza();

              case 42:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this14);
      }))();
    },
    nfErro: function nfErro() {
      if (!this.nf.validation) return false;
      var validation = JSON.parse(this.nf.validation);
      if (validation.errmessages) {
        this.errmessages = validation;
        return true;
      } else return false;
    },
    apiInvoiceDelete: function apiInvoiceDelete() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var modulo;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                //exclui a nota fiscal
                modulo = 'invoice/nf/' + _this15.nf.codnf;
                _context12.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSdelete"])(_this15.$store, modulo);

              case 3:
                _this15.$erpToastSuccess('A Nota fiscal foi excluída com sucesso.');
                _this15.handleRetorna();

              case 5:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this15);
      }))();
    },
    apiInvoiceCancel: function apiInvoiceCancel() {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var paramscancel, tipo, _paramscancel, sendData, modulo, data;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                //cancela a nota fiscal
                _this16.errCorrecao = [];

                if (!(_this16.nf.esp == '59' && _this16.nf.impxml != 'S')) {
                  _context13.next = 5;
                  break;
                }

                paramscancel = '&codnf=' + _this16.nf.codnf + '&texto=' + _this16.nf.obscan;

                _this16.$executaExtensaoChromeSAT(_this16.nf.codnf, 'canc', _this16.CancelResponseCallback, paramscancel);
                return _context13.abrupt('return');

              case 5:
                tipo = _this16.$certificadoCheck(_this16.nf.codfil);

                if (!(tipo == 'A3' && _this16.nf.impxml != 'S')) {
                  _context13.next = 12;
                  break;
                }

                _paramscancel = '&codnf=' + _this16.nf.codnf + '&texto=' + _this16.nf.obscan;

                _this16.$executaExtensaoChromeA3(_this16.nf.codnf, 'canc', _this16.CancelResponseCallback, _paramscancel);
                return _context13.abrupt('return');

              case 12:
                sendData = {};

                sendData = { codnf: _this16.nf.codnf, codfil: _this16.nf.codfil, just: _this16.nf.obscan };

                _this16.showCancel = false;
                _this16.$appLoading(true);
                modulo = 'invoice/cancel/';
                _context13.next = 19;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this16.$store, modulo, sendData, 'post');

              case 19:
                data = _context13.sent;

                if (!data.errmessages) {
                  _context13.next = 28;
                  break;
                }

                _this16.$appLoading(false);
                _this16.showCancel = true;
                _this16.errCorrecao = data.errmessages;
                _this16.$erpToastError('A nota fiscal não foi cancelada');
                return _context13.abrupt('return');

              case 28:
                _this16.$appLoading(false);
                _this16.$erpToastSuccess('Nota fiscal cancelada com sucesso.');
                _this16.loadData();

              case 31:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this16);
      }))();
    },
    CancelResponseCallback: function CancelResponseCallback(response) {
      //CALLBACK QUANDO O CANCELAMENTO É ENVIADO POR CERTIFICADO A3
      this.$appLoading(false);
      this.errmessages = [];
      if (response.status != 'success') {
        this.$erpToastError(response.message);
      } else {
        this.showCancel = false;
        this.$erpToastSuccess('Nota fiscal cancelada com sucesso.');
        this.loadData();
      }
    },
    apiInvoiceCorrecao: function apiInvoiceCorrecao() {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var tipo, paramscce, sendData, data;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                //envio de carta de correcao
                _this17.errCorrecao = [];
                tipo = _this17.$certificadoCheck(_this17.nf.codfil);

                if (!(_this17.nf.esp == '59')) {
                  _context14.next = 7;
                  break;
                }

                _this17.$erpToastError('A carta de correção não é permitida em modelo SAT');
                return _context14.abrupt('return');

              case 7:
                if (!(tipo == 'A3')) {
                  _context14.next = 13;
                  break;
                }

                paramscce = '&codnf=' + _this17.nf.codnf + '&texto=' + _this17.textocorrecao;

                _this17.$executaExtensaoChromeA3(_this17.nf.codnf, 'cce', _this17.CorrecaoResponseCallback, paramscce);
                return _context14.abrupt('return');

              case 13:
                sendData = {};

                sendData = { codnf: _this17.nf.codnf, codfil: _this17.nf.codfil, correcao: _this17.textocorrecao, tpeventonfe: 'R' };

                _this17.showCorrecao = false;
                _this17.$appLoading(true);
                _context14.next = 19;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this17.$store, 'invoice/correcao/', sendData, 'post');

              case 19:
                data = _context14.sent;

                if (!data.errmessages) {
                  _context14.next = 28;
                  break;
                }

                _this17.$appLoading(false);
                _this17.errCorrecao = data.errmessages;
                _this17.showCorrecao = true;
                _this17.$erpToastError('A carta de correção não foi autorizada');
                return _context14.abrupt('return');

              case 28:
                _this17.$appLoading(false);
                _this17.$erpToastSuccess('Carta de correção homologada');
                _this17.loadData();
                _this17.handleFormEmailCC();

              case 32:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this17);
      }))();
    },
    CorrecaoResponseCallback: function CorrecaoResponseCallback(response) {
      //CALLBACK QUANDO A CARTA DE CORREÇÃO É ENVIADA POR CERTIFICADO A3
      this.$appLoading(false);
      this.errmessages = [];
      if (response.status != 'success') {
        this.$erpToastError(response.message);
      } else {
        this.showCorrecao = false;
        this.$erpToastSuccess('Carta de correção homologada');
        this.loadData();
        this.handleFormEmailCC();
      }
    },
    apiItens: function apiItens(nfIt, deleteItem) {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var sendData, metodo, modulo, data;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                //efetua a gravacao dos itens do pedido
                sendData = { nf: _this18.nf };

                if (nfIt.length) {
                  sendData.nf.nfit = nfIt;
                } else {
                  sendData.nf.nfit = [];
                  sendData.nf.nfit.push(nfIt);
                }

                metodo = 'post';
                modulo = 'invoice/nfit/';

                if (deleteItem) {
                  modulo = modulo + 'delete/';
                }

                _context15.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this18.$store, modulo, sendData, metodo);

              case 7:
                data = _context15.sent;

                if (deleteItem) {
                  _this18.codnf = _this18.nf.codnf;
                  _this18.loadData();
                  _this18.$erpToastSuccess('O produto foi excluído.');
                } else if (data.items) {
                  _this18.nf = data.items[0];
                  _this18.nf.nates = _this18.selectedNates;
                  _this18.nfit = data.items[0].nfit;
                  //   this.$erpToastSuccess('Item gravado com sucesso.')
                  if (_this18.nfErro()) {} else {
                    _this18.errmessages = [];
                  }
                }

                _this18.updateItem = false;

              case 10:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this18);
      }))();
    },
    handleDeleteItemMsg: function handleDeleteItemMsg(index) {
      //EXCLUI O ITEM DO PEDIDO
      this.nfit_delete = this.nfit[index];
      this.DELETE_ITEM_MESSAGE = true;
    },
    handleDeleteItem: function handleDeleteItem() {
      if (this.nfAutorizada) {
        this.$erpToastError('Esta nota já foi autorizada e não pode mais ser alterada.');
        this.DELETE_ITEM_MESSAGE = false;
        return;
      }

      //remove o item do pedido
      this.DELETE_ITEM_MESSAGE = false;
      var item = [];
      item.push(this.nfit_delete);
      this.apiItens(item, true);
    },
    closeFormItem: function closeFormItem() {
      //fecha tela de inclusao de item
      this.showFormItem = false;
      this.formNF = true;
    },
    saveItem: function saveItem(nfit) {
      if (this.nfAutorizada) {
        this.$erpToastError('Esta nota já foi autorizada e não pode mais ser alterada.');
        this.showFormItem = false;
        return;
      }

      //fecha tela de alteracao de item e envia para o servidor
      this.activeTab = 0;
      this.showFormItem = false;
      this.formNF = true;
      this.apiItens(nfit);
      this.$nextTick(function () {
        if (this.$refs.incluirProduto) {
          this.$refs.incluirProduto.focus();
        }
      });
    },
    handleIncluirItem: function handleIncluirItem(nSeq, view) {
      //incluir item na nf

      this.nfit_update = _extends({}, this.$store.getters.getEntities.nfit);
      this.nfit_update.finalidade = this.nf.finalidade;
      this.nfit_update.codnf = this.nf.codnf;
      this.nfit_update.pcredsn = this.nf.pcredsn;
      //ajusta os parametros para chamada da tela de item da nf
      this.paramItem = {
        nf: this.nf,
        nfsaida: this.nf.operacaonf == 'S',
        nfit: this.nfit_update,
        nfImportacao: this.nfImportacao,
        nfAjuste: this.nf.tpnf == 'A',
        nfComplementar: this.nf.tpnf == 'P',
        habilitaItem: (this.nfOutrasNotas || this.nfVendaLivre) && this.nf.flagestoquebaixado != 'S' && this.nf.flagarmazenada != 'S',
        optSimples: this.nf.filial[0].crt == '1' || this.nf.filial[0].crt == '4',
        difal: this.selectedPart.uf != this.nf.filial[0].uf && this.nf.finalidade == 'F' && this.nf.venda == 'S',
        ipidevol: this.nf.nates.ipidevol == 'S'
        //
      };this.formItemView = false; //indica se é alteração ou somente visualizacao
      this.updateItem = false;
      this.showFormItem = true;
    },
    handleEditItem: function handleEditItem(nSeq, view) {
      //editar o item da nf
      this.nfit_update = {};

      //localiza o item para alteracao atraves da sequencia
      for (var x = 0; x < this.nfit.length; x++) {
        if (this.nfit[x].itnf == nSeq) {
          this.nfit_update = _extends({}, this.nfit[x]);
        }
      }
      //ajusta os parametros para chamada da tela de item da nf
      this.paramItem = {
        nf: this.nf,
        nfsaida: this.nf.operacaonf == 'S',
        nfit: this.nfit_update,
        nfImportacao: this.nfImportacao,
        nfAjuste: this.nf.tpnf == 'A',
        nfComplementar: this.nf.tpnf == 'P',
        habilitaItem: (this.nfOutrasNotas || this.nfVendaLivre) && this.nf.flagestoquebaixado != 'S' && this.nf.flagarmazenada != 'S',
        optSimples: this.nf.filial[0].crt == '1' || this.nf.filial[0].crt == '4',
        difal: this.selectedPart.uf != this.nf.filial[0].uf && this.nf.finalidade == 'F' && this.nf.venda == 'S',
        isView: view,
        ipidevol: this.nf.nates.ipidevol == 'S'
        //
      };this.formItemView = view; //indica se é alteração ou somente visualizacao
      this.updateItem = true;
      this.showFormItem = true;
    },
    handleCloseMessage: function handleCloseMessage() {
      this.CANCEL_ITEM_MESSAGE = false;
      this.DELETE_ITEM_MESSAGE = false;
    },
    updateActions: function updateActions() {
      this.moreActions = [];
      var act = {};
      if (this.nf.emissaopropria != 'S' && this.nf.stnf >= '11') {
        act = { action: 5, label: 'Excluir NF' };
        this.moreActions.push(act);
      }
      if (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50') {
        act = { action: 5, label: 'Excluir NF' };
        this.moreActions.push(act);
      }

      if ((this.nf.stnf == '11' || this.nf.stnf == '01') && this.nf.flagarmazenada == 'S') {
        act = { action: 20, label: 'Excluir Armazenamento' };
        this.moreActions.push(act);
      }

      if ((this.nf.stnf == '01' || this.nf.stnf >= '11') && this.nf.flagestoquebaixado == 'S') {
        act = { action: 21, label: 'Excluir Baixa do Estoque' };
        this.moreActions.push(act);
      }

      if (this.nf.impxml == 'S' && this.nf.stnf >= '11') {
        act = { action: 6, label: 'Download do XML' };
        this.moreActions.push(act);
      }
      if (this.nf.emissaopropria == 'S' && this.nf.stnf == '11') {
        act = { action: 6, label: 'Download do XML' };
        this.moreActions.push(act);
        act = { action: 3, label: 'Cancelar NF-e' };
        this.moreActions.push(act);
      }
      if (this.nf.emissaopropria == 'S' && this.nf.stnf == '10') {
        act = { action: 2, label: 'Emitir Danfe PDF' };
        this.moreActions.push(act);
        act = { action: 1, label: 'Enviar Email da Danfe' };
        this.moreActions.push(act);
        act = { action: 0, label: '' };
        this.moreActions.push(act);
        act = { action: 8, label: 'Incluir Carta de Correção' };
        this.moreActions.push(act);
        act = { action: 30, label: 'Eventos NF-e' };
        this.moreActions.push(act);
        //falta checar: somente quando houver evento autorizado
        if (this.nf.nfev && this.nf.nfev.length > 0) {
          act = { action: 9, label: 'Gerar PDF da Carta Correção' };
          this.moreActions.push(act);
          act = { action: 10, label: 'Enviar Email da Carta de Correção' };
          this.moreActions.push(act);
        }
        act = { action: 3, label: 'Cancelar NF-e' };
        this.moreActions.push(act);
        //
        // act = { action: 4, label: 'Duplicar Nota Fiscal' }
        // this.moreActions.push(act)
      }
      if (this.nf.emissaopropria == 'S' && this.nf.stnf == '01') {
        act = { action: 7, label: 'Autorizar NF-e' };
        this.moreActions.push(act);
      }

      if (this.nf.emitecobranca == 'S') {
        act = { action: 12, label: 'Enviar Cobrança' };
        this.moreActions.push(act);
      }

      if (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '02' || this.nf.stnf == '10' || this.nf.stnf == '50' || this.nf.emissaopropria != 'S' && this.nf.stnf >= '11') {
        act = { action: 22, label: 'Informar Chave e protocolo Manualmente' };
        this.moreActions.push(act);
      }
    },
    PDFResponseCallbackSAT: function PDFResponseCallbackSAT(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO SAT
      if (response.status != 'success') {
        this.$erpToastError(response.message);
      }
    },
    imprimirDANFE: function imprimirDANFE(preview) {
      //impressao da danfe em PDF
      var vm = this;
      if (preview) {
        this.apiInvoice().then(function () {
          Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiDownloadPDF"])(vm, 'print/previewdanfe/' + vm.nf.codnf);
        });
      } else if (this.nf.esp == '59') {
        var paramsimp = '&codnf=' + this.nf.codnf;
        this.$executaExtensaoChromeSAT(this.nf.codnf, 'imp', this.PDFResponseCallbackSAT, paramsimp);
        return;
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiDownloadPDF"])(this, 'print/danfe/' + this.nf.codnf);
      }
    },
    imprimirCC: function imprimirCC() {
      //impressao da cce em PDF
      Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiDownloadPDF"])(this, 'print/cce/' + this.nf.codnf);
    },
    downloadXML: function downloadXML() {
      //visualizacao do XML da NFE
      var data = { codnf: this.nf.codnf, chave: this.nf.chave, tipo: 'NFE' };
      Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiDownload"])(this, 'print/xmlnfe/', data, 'post');
    },
    getDescricaoEvento: function getDescricaoEvento(tpevento) {
      var descricoes = {
        '110110': 'Carta de Correção',
        '110111': 'Cancelamento',
        '110001': 'Cancelamento de Evento',
        '112110': 'Efetivo Pagamento Integral (IBS/CBS)',
        '112120': 'Importação ALC/ZFM não convertida em isenção',
        '112130': 'Perecimento, Deterioração ou Furto (Operação CIF)',
        '112140': 'Fornecimento Não Realizado',
        '112150': 'Atualização da Data de Previsão de Entrega',
        '211110': 'Solicitação de Apropriação de Crédito Presumido',
        '211124': 'Perecimento, Deterioração ou Furto (Operação FOB)',
        '211128': 'Aceite de Débito de Apuração (IBS/CBS)',
        '211130': 'Imobilização de Item',
        '211140': 'Solicitação de Apropriação de Crédito de Combustível',
        '211150': 'Solicitação de Apropriação de Crédito por Atividade',
        '212110': 'Manifestação de Transferência de Crédito IBS',
        '212120': 'Manifestação de Transferência de Crédito CBS'
      };
      return descricoes[tpevento] || 'Evento Outros (' + tpevento + ')';
    },
    downloadXmlEvento: function downloadXmlEvento(ev, tipo) {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var url, response, xmlContent, file, link;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _this19.$appLoading(true);
                url = _this19.$store.getters.urlOrds + 'invoice/evento/xml?codnf=' + _this19.nf.codnf + '&tpeventonfe=' + ev.tpeventonfe + '&seqevento=' + ev.seqevento + '&tipo=' + tipo;
                _context16.prev = 2;
                _context16.next = 5;
                return _this19.$http.get(url);

              case 5:
                response = _context16.sent;
                xmlContent = response.data.items && response.data.items[0] ? response.data.items[0].xml : null;

                if (xmlContent) {
                  _context16.next = 10;
                  break;
                }

                _this19.$erpToastError('O arquivo XML solicitado está vazio ou não foi encontrado.');
                return _context16.abrupt('return');

              case 10:
                file = new Blob([xmlContent], { type: 'application/xml' });
                link = document.createElement('a');

                link.href = URL.createObjectURL(file);
                link.download = 'evento_' + ev.tpeventonfe + '_' + tipo + '.xml';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                _this19.$erpToastSuccess('Download iniciado com sucesso.');
                _context16.next = 24;
                break;

              case 20:
                _context16.prev = 20;
                _context16.t0 = _context16['catch'](2);

                _this19.$erpToastError('Erro ao baixar o XML do evento.');
                console.error('Download Event XML error:', _context16.t0);

              case 24:
                _context16.prev = 24;

                _this19.$appLoading(false);
                return _context16.finish(24);

              case 27:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this19, [[2, 20, 24, 27]]);
      }))();
    },
    handleEmitirEvento: function handleEmitirEvento() {
      this.defaultTpEvento = '';
      this.defaultTpEventoAut = '';
      this.defaultNProtEvento = '';
      this.showEventos = true;
    },
    handleCancelarEvento: function handleCancelarEvento(ev) {
      this.defaultTpEvento = '110001';
      this.defaultTpEventoAut = ev.tpeventonfe;
      this.defaultNProtEvento = ev.nprot;
      this.showEventos = true;
    },
    isEventoCancelado: function isEventoCancelado(ev) {
      if (!this.nf || !this.nf.nfev) return false;
      return this.nf.nfev.some(function (item) {
        return item.tpeventonfe === '110001' && item.nprotevento === ev.nprot;
      });
    },
    handleFormEmailDanfe: function handleFormEmailDanfe() {
      //Abre a tela para envio de email
      //carrega o template da mensagem antes do envio (ords/webdata/template/danfe/:id)
      this.showFormEmail = true;
    },
    handleFormEmailCC: function handleFormEmailCC() {
      //Abre a tela para envio de email
      //carrega o template da mensagem antes do envio (ords/webdata/template/danfe/:id)
      this.showFormEmailCC = true;
    },
    closeFormEmail: function closeFormEmail() {
      this.showFormEmail = false;
      this.showFormEmailCC = false;
    },
    handleSendEmail: function handleSendEmail(data) {
      var _this20 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var sendData;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                //cahamda para envio de email da danfe
                _this20.closeFormEmail();
                sendData = data;

                sendData.codnf = _this20.nf.codnf;
                sendData.chave = _this20.nf.chave;
                sendData.tipo = 'DANFE';
                _context17.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiEmailPDF"])(_this20, 'danfe/', sendData);

              case 7:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this20);
      }))();
    },
    handleSendEmailCC: function handleSendEmailCC(data) {
      var _this21 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var sendData;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                //cahamda para envio de email da danfe
                _this21.closeFormEmail();
                sendData = data;

                sendData.codnf = _this21.nf.codnf;
                sendData.chave = _this21.nf.chave;
                sendData.tipo = 'CCE';
                _context18.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiEmailPDF"])(_this21, 'danfe/', sendData);

              case 7:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this21);
      }))();
    },
    updateCepEnt: function updateCepEnt() {
      //CARREGA INFORMACOES DO CEP DE ENTREGA
      this.nf.endeent = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.logradouro;
      this.nf.bairroent = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.bairro;
      this.nf.codmunent = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.ibge;
      this.nf.ufent = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.uf;
      if (this.nf.ufent && this.nf.ufent != 'EX') this.nf.codpaisent = '1058';
    },
    updateCepRet: function updateCepRet() {
      //CARREGA INFORMACOES DO CEP DE RETIRADA
      this.nf.enderet = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.logradouro;
      this.nf.bairroret = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.bairro;
      this.nf.codmunret = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.ibge;
      this.nf.ufret = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.uf;
      if (this.nf.ufret && this.nf.ufret != 'EX') this.nf.codpaisret = '1058';
    },
    handleEnderecoEntrega: function handleEnderecoEntrega() {
      this.enderecoEntrega = true;
    },
    handleEnderecoRetirada: function handleEnderecoRetirada() {
      this.enderecoRetirada = true;
    },
    handleExcluirEndereco: function handleExcluirEndereco(tipo) {
      //limpa o endereco de entrega ou retirada
      if (tipo == 'ent') {
        this.enderecoEntrega = false;
        this.nf.tppessoaent = null;
        this.nf.cnpjcpfent = null;
        this.nf.cepent = null;
        this.nf.endeent = null;
        this.nf.endenrent = null;
        this.nf.endecompent = null;
        this.nf.bairroent = null;
        this.nf.codmunent = null;
        this.nf.ufent = null;
      } else {
        this.enderecoRetirada = false;
        this.nf.tppessoaret = null;
        this.nf.cnpjcpfret = null;
        this.nf.cepret = null;
        this.nf.enderet = null;
        this.nf.endenrret = null;
        this.nf.endecompret = null;
        this.nf.bairroret = null;
        this.nf.codmunret = null;
        this.nf.ufret = null;
      }
    },
    loadData: function loadData() {
      var _this22 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var nfev, i;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _this22.textocorrecao_anterior = '';

                _this22.unwatch = true;
                //carrega a nf para alteracao ou visualizacao
                _context19.next = 4;
                return _this22.$store.dispatch('loadNf', { id: _this22.codnf });

              case 4:
                if (_this22.$store.getters.getNf) {
                  _this22.nf = _extends({}, _this22.$store.getters.getNf[0]);
                  _this22.nfit = _this22.nf.nfit;
                  if (_this22.nf.parcelas || _this22.nf.parcelas == 0) {
                    _this22.parcelas = _this22.nf.parcelas;
                  }
                  if (_this22.nf.nfpar) {
                    _this22.nfpar = _this22.nf.nfpar;
                  }
                  if (_this22.nf.nfref) {
                    _this22.nfref = _this22.nf.nfref;
                  }
                  if (_this22.nfErro()) {} else {
                    _this22.errmessages = [];
                  }
                  _this22.moreActions = [];
                  _this22.updateActions();
                  //carrega o texto da ultima correcao efetuada se houver
                  nfev = _this22.nf.nfev;

                  for (i = 0; i < nfev.length; i++) {
                    if (nfev[i].tpeventonfe != 'C') {
                      _this22.textocorrecao_anterior = nfev[i].texto;
                    }
                  }
                }
                _this22.nfOutrasNotas = _this22.nf.operacaonf == 'E' || _this22.nf.venda != 'S';
                _this22.nfVendaLivre = _this22.nf.venda && (_this22.nfit.length == 0 || !_this22.nfit.codpedv);
                _this22.enderecoEntrega = _this22.nf.cepent != null;
                _this22.enderecoRetirada = _this22.nf.cepret != null;

                _this22.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                  this.unwatch = false;
                });

              case 10:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, _this22);
      }))();
    },
    changeTab: function changeTab(idx) {
      //mudança de pagina
      this._nf = this.nf;
      this.activeTab = idx;
    },
    handleValidaParcelas: function handleValidaParcelas() {
      var isValid = true;
      for (var x = 0; x <= this.nfpar.length - 1; x++) {
        if (x > 0 && Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["stringToInteger"])(this.nfpar[x].dias) <= Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["stringToInteger"])(this.nfpar[x - 1].dias)) {
          this.nfpar[x].error = 'Vencimento deve ser superior ao da parcela anterior';
          isValid = false;
          //   this.$set(this.nfpar[x], 'error', 'Vencimento deve ser superior ao da parcela anterior')
        } else this.nfpar[x].error = null;
      }
      return isValid;
    },
    nfparDiasChange: function nfparDiasChange(index) {
      //evento de controle de alteracao do nr de dias de vencimento da parcela
      this.nfpar[index].dtv = this.$addDays(this.nf.data, this.nfpar[index].dias);
      this.handleValidaParcelas();
    },
    nfparDtvChange: function nfparDtvChange(index) {
      //recalcula o nr de dias ao alterar a data
      this.nfpar[index].dias = this.$daysBetween(this.nf.data, this.nfpar[index].dtv);
      this.handleValidaParcelas();
    },
    nfparVlrChange: function nfparVlrChange(index) {
      //evento de controle de alteracao do valor da parcela
      //quando usuario alterar o valor de uma parcela, refaz as demais parcelas
      if (this.nf.parcelas <= 1) {
        return;
      }
      var vlrparcial = 0;
      var vlrnovaparcela = 0;
      for (var x = 0; x <= index; x++) {
        vlrparcial = vlrparcial + parseFloat(this.nfpar[x].vlr);
      }
      if (vlrparcial < this.nf.totger) {
        vlrnovaparcela = (this.nf.totger - vlrparcial) / (this.nf.parcelas - (index + 1));
        vlrnovaparcela.toFixed(2);
      }
      for (var x = index + 1; x <= this.nfpar.length - 1; x++) {
        this.nfpar[x].vlr = vlrnovaparcela;
      }
    },
    incluiNotaFiscalDemo: function incluiNotaFiscalDemo() {
      var _this23 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var self;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                //ROTINA QUE INCLUI UMA NOTA FISCAL DEMONSTRACAO COM 1 PRODUTO DE DEMONSTRACAO
                //ACESSO ATRAVÉS DO GUIA DA NFE
                self = _this23;

                Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDS"])(_this23.$store.getters.urlOrds + 'cg/dadosdemonstracao', null, true).then(function (result) {
                  if (result.codpart && result.coditem) {
                    self.dadosNotaFiscalDemo = result;
                    self.nf.codpart = result.codpart;
                    self.notaFiscalDemo = true;
                  }
                });

              case 2:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, _this23);
      }))();
    },
    incluiProdutoNotaFiscalDemo: function incluiProdutoNotaFiscalDemo() {
      var _this24 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                //INCLUI UM PRODUTO DEMO NA NOTA FISCAL
                _this24.nfit_update = _extends({}, _this24.$store.getters.getEntities.nfit);
                _this24.nfit_update.finalidade = _this24.nf.finalidade;
                _this24.nfit_update.codnf = _this24.nf.codnf;
                _this24.nfit_update.pcredsn = _this24.nf.pcredsn;

                _this24.nfit_update.coditem = _this24.dadosNotaFiscalDemo.coditem; //296

                _context21.next = 7;
                return _this24.apiCarregaProduto(_this24.nfit_update);

              case 7:
                _this24.nfit_update.qt = 1;
                _this24.nfit_update.vlr = 100;
                _this24.apiItens(_this24.nfit_update);

                _this24.$nextTick(function () {
                  if (this.$refs.incluirProduto) {
                    this.$refs.incluirProduto.focus();
                  }
                });

              case 11:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, _this24);
      }))();
    }
  },

  mounted: function mounted() {
    var _this25 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
      var isValid, storedBannerIBSCBS;
      return regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              if (!_this25.formIncluir) {
                _context22.next = 11;
                break;
              }

              if (!(_this25.nf.operacaonf == 'E')) {
                _context22.next = 8;
                break;
              }

              _context22.next = 4;
              return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiValidaLimitePlano"])(_this25, 'nfentrada');

            case 4:
              isValid = _context22.sent;

              if (!isValid) _this25.closeForm();
              _context22.next = 8;
              break;

            case 8:
              storedBannerIBSCBS = localStorage.getItem('nfsaida-form-banner-ibscbs');

              if (!storedBannerIBSCBS) {
                _this25.modalBannerIBSCBS = true;
              }

              _this25.$nextTick(function () {
                if (this.$refs.organizacao) this.$refs.organizacao.focus();
              });

            case 11:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, _this25);
    }))();
  },
  created: function created() {
    var _this26 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
      var operacao, params, tourguide;
      return regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _this26.metadata.nf.parcelas.options.sort(function (a, b) {
                return Number(a.id) > Number(b.id) ? 1 : Number(b.id) > Number(a.id) ? -1 : 0;
              });

              _this26.ambienteHomologacaoNFe(); //api-nfe

              _this26.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
              });

              //this.crudText = this.$crudText(this.crud)

              _this26.formIncluir = _this26.crud == __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI;
              operacao = 'S';


              if (_this26.params) {
                //THIS.PARAMS QUANDO A CHAMADA É FEITA PELA LISTA DE NOTAS
                operacao = _this26.params.operacaoNf;
                _this26.nfVendaLivre = _this26.params.vendaLivre;
                _this26.nfVendaNfce = _this26.params.vendaNfce;
                if (!_this26.nfVendaLivre) _this26.nfOutrasNotas = _this26.params.outrasSaidas;
                _this26.entradaArmazenamento = _this26.params.entradaArmazenamento;
                console.log(_this26.entradaArmazenamento);
              } else if (_this26.$route.params && _this26.$route.params.id == 'novo') {
                //inclusao de nota pelo guianfe ou pelo painel de nfe
                _this26.formIncluir = true;
                if (_this26.$route.query.tipo == 'outras') _this26.nfOutrasNotas = true;else if (_this26.$route.query.tipo == 'entrada') {
                  _this26.nfOutrasNotas = true;
                  operacao = 'E';
                } else _this26.nfVendaLivre = true;
              } else if (_this26.$route.params && _this26.$route.params.id) {
                if (_this26.$route.query.tipo == 'view') {
                  _this26.codnf = _this26.$route.params.id;
                } else if (_this26.$route.query.tipo == 'devolucao') {
                  _this26.codnf = _this26.$route.params.id;
                } else {
                  if (_this26.$route.query.tipo == 'entrada') {
                    _this26.nfOutrasNotas = true;
                    operacao = 'E';
                    _this26.codcompra = _this26.$route.params.id;
                    _this26.handleCompra(); //fatura o pedido
                    _this26.formNF = true;
                  } else {
                    //faturamento de pedido de venda
                    _this26.codpedv = _this26.$route.params.id;
                    _this26.handleFaturar(); //fatura o pedido
                    _this26.formNF = true;
                  }
                }
              }

              if (_this26.formIncluir) {
                //se for uma inclusao
                _this26.unwatch = false;
                if (operacao == 'E') {
                  _this26.nf.emissaopropria = 'N';
                  _this26.nf.operacaonf = 'E';
                  _this26.nf.tpfrete = '9';
                  _this26.nfOutrasNotas = true;
                  _this26.nf.dtent = _this26.$getDate();
                  if (_this26.entradaArmazenamento) {
                    _this26.nf.entradaarmazenamento = 'S';
                  }
                  console.log(_this26.nf.entradaarmazenamento);
                } else {
                  _this26.nf.emissaopropria = 'S';
                  _this26.nf.operacaonf = 'S';
                  _this26.nf.tpfrete = '9';
                  // this.nf.dtsai = this.$getDate() //solicitado para retirar
                  if (_this26.nfVendaLivre) {
                    _this26.nf.venda = 'S';
                  }
                  if (_this26.nfVendaNfce) {
                    _this26.nf.nfce = 'S';
                  }
                }
              } else {
                //carrega a nf para alteracao/visualizacao
                if (!_this26.codnf) _this26.codnf = _this26.params.codnf;
                _this26.loadData();
                _this26.view = _this26.crud == __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudView;
                _this26.formNF = true;
              }

              if (!(_this26.showGuia && !(_this26.nf.operacaonf == 'E'))) {
                _context23.next = 13;
                break;
              }

              params = { operacao: _this26.operacaonf, filter: null };
              _context23.next = 11;
              return _this26.$store.dispatch('loadNfList', params);

            case 11:
              _this26.hasManyNfs = _this26.$store.getters.getNfList.length >= 1;
              if (_this26.showGuia && !_this26.hasManyNfs) {
                tourguide = new __WEBPACK_IMPORTED_MODULE_15_tourguidejs___default.a({
                  steps: _this26.steps
                });


                tourguide.start();
              }

            case 13:

              if (_this26.$route.query.tipo == 'demo') _this26.incluiNotaFiscalDemo();

              _this26.$scrollTo(0);

            case 15:
            case 'end':
              return _context23.stop();
          }
        }
      }, _callee23, _this26);
    }))();
  }
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_nf_item_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_nf_item_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__api_api_nf_item_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__item_form__ = __webpack_require__(89);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params: {} //nfit: objeto, optSimples: false, nfAjuste: false, nfComplemento: false, habilitaItem: true
  },

  components: {
    ItemForm: __WEBPACK_IMPORTED_MODULE_2__item_form__["default"]
  },

  data: function data() {
    return {
      nfit: {},
      //metadata: this.$store.getters.getEntities.metadata,
      local_metadata: _extends({}, this.$store.getters.getEntities.metadata.nfit),
      tributadoIcm: false,
      informaMotdes: false,
      icmDiferido: false,
      habilitaBCIcm: false,
      habilitaAIcm: false,
      tributadoIcmST: false,
      tributadoIpi: false, //habilita ipi
      tributadoPis: false, //habilita pis
      informaFCI: false, //habilita nr do fci conforme origem da mercadoria
      pautaPis: false,
      tributadoCofins: false,
      pautaCofins: false,
      tributadoPisST: false,
      tributadoCofinsST: false,
      creditoSN: false, //habilita % credito icms simples nacional
      icmsRetido: false,
      unWatch: false,
      descricaoNovoItem: '',
      showIBSCBS: true,
      tipoVinculo: 'sistema',
      xmlParsedData: null,
      tabs: [{ title: "Dados do Item (Principal)", icon: "" }, { title: "Documento Fiscal de Origem (Rastreabilidade)", icon: "" }],
      activeTab: 0,
      subTabs: [{ title: "Nota do Sistema", icon: "" }, { title: "Carregar XML", icon: "" }, { title: "Digitação Manual", icon: "" }],
      activeSubTab: 0,
      nfOrigemDados: null,
      nfitemOrigemDados: null,

      errmessages: [],
      crud: '',
      showItemForm: false
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_1__api_api_nf_item_js___default.a],

  computed: {
    isView: function isView() {
      return this.params.isView == true;
    },
    isAjusteCreditoDebito: function isAjusteCreditoDebito() {
      return this.params.nf && (this.params.nf.tpnf === 'CR' || this.params.nf.tpnf === 'DB');
    },
    showLegacyTaxes: function showLegacyTaxes() {
      if (this.isAjusteCreditoDebito) {
        return this.params.nf.tpnf === 'CR' && this.params.nf.tpnfcredito === '03';
      }
      return true;
    },

    coditem: function coditem() {
      return this.nfit.coditem;
    },
    selectedItem: function selectedItem() {
      return this.$store.getters.getItem;
    },
    itemTaxes: function itemTaxes() {
      return this.$store.getters.getItemTaxes;
    },
    sticm: function sticm() {
      return this.nfit.sticm;
    },
    stipi: function stipi() {
      return this.nfit.stipi;
    },
    stpis: function stpis() {
      return this.nfit.stpis;
    },
    stcofins: function stcofins() {
      return this.nfit.stcofins;
    },
    csosn: function csosn() {
      return this.nfit.csosn;
    },
    sticmentrada: function sticmentrada() {
      return this.nfit.sticmentrada;
    },
    orimerc: function orimerc() {
      return this.nfit.orimerc;
    },

    nfImportacao: function nfImportacao() {
      return this.params.nfImportacao;
    },
    ivaclass: function ivaclass() {
      return this.$store.getters.getivaclass;
    },
    xmlSelectOptions: function xmlSelectOptions() {
      if (!this.xmlParsedData || !this.xmlParsedData.itens) return [];
      return this.xmlParsedData.itens.map(function (item) {
        return {
          id: item.nItem,
          text: item.descricao
        };
      });
    }
    // tributadoIcmST () {
    //     return (this.nfit.sticm == '10' || this.nfit.sticm == '30' || this.nfit.sticm == '70' || this.nfit.sticm == '90')
    // }

  },

  methods: {
    onXMLFileSelected: function onXMLFileSelected(event) {
      var _this = this;

      var file = event.target.files[0];
      if (!file) return;

      var reader = new FileReader();
      reader.onload = function (e) {
        try {
          var xmlText = e.target.result;
          var parser = new DOMParser();
          var xmlDoc = parser.parseFromString(xmlText, "application/xml");

          var infNFe = xmlDoc.getElementsByTagName("infNFe")[0];
          var chave = "";
          if (infNFe && infNFe.getAttribute("Id")) {
            chave = infNFe.getAttribute("Id").replace("NFe", "");
          } else {
            var chNFe = xmlDoc.getElementsByTagName("chNFe")[0];
            if (chNFe) chave = chNFe.textContent;
          }

          if (chave.length !== 44) {
            _this.$erpToastError("Não foi possível identificar uma Chave de Acesso válida de 44 dígitos neste XML.");
            return;
          }

          var detElements = xmlDoc.getElementsByTagName("det");
          var itensXml = [];
          for (var i = 0; i < detElements.length; i++) {
            var det = detElements[i];
            var nItem = det.getAttribute("nItem");
            var prod = det.getElementsByTagName("prod")[0];
            var xProd = prod ? prod.getElementsByTagName("xProd")[0].textContent : "";
            var qCom = prod ? parseFloat(prod.getElementsByTagName("qCom")[0].textContent) : 0;
            var vUnCom = prod ? parseFloat(prod.getElementsByTagName("vUnCom")[0].textContent) : 0;

            itensXml.push({
              nItem: nItem,
              descricao: 'Item ' + nItem + ' - ' + xProd + ' (Qtd: ' + qCom + ' / R$ ' + vUnCom.toFixed(2) + ')'
            });
          }

          _this.xmlParsedData = {
            chave: chave,
            itens: itensXml
          };
        } catch (err) {
          _this.$erpToastError("Erro ao processar o arquivo XML: " + err.message);
        }
      };
      reader.readAsText(file);
    },
    selecionarItemXml: function selecionarItemXml(item) {
      if (!item) return;
      this.nfit.chaveorigem = this.xmlParsedData.chave;
      this.nfit.nitemorigem = item.nItem;
      this.nfit.codnforigem = "";
      this.nfit.codnfitorigem = "";
    },
    limparVinculoOrigem: function limparVinculoOrigem() {
      this.nfit.codnforigem = "";
      this.nfit.codnfitorigem = "";
      this.nfit.chaveorigem = "";
      this.nfit.nitemorigem = "";
      this.xmlParsedData = null;
      this.nfOrigemDados = null;
      this.nfitemOrigemDados = null;
      this.$erpToastSuccess("Vínculo de origem removido.");
    },
    loadivaclass: function loadivaclass() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$store.dispatch('loadivaclass', { id: _this2.nfit.ibscbscclass });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleCadastroItem: function handleCadastroItem(text) {
      //abre tela para cadastro de novo produto
      this.crud = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI;
      this.descricaoNovoItem = text;
      this.showItemForm = true;
    },
    closeItemForm: function closeItemForm(item) {
      //ao fechar o formulario de cadastro de produto
      this.showItemForm = false;
      if (item) {
        this.nfit.coditem = item.coditem;
      }
    },
    handleNewItem: function handleNewItem(selectedItem) {
      if (!selectedItem) return;
      this.nfit.coditem = selectedItem.coditem;
    },
    handleSalvar: function handleSalvar() {
      //botao salvar item
      var param = [];
      param.push(this.nfit);
      this.$emit('save', param);
    },
    habilitaTributacaoIcms: function habilitaTributacaoIcms() {
      var sticm = null;
      if (this.nfit.sticmentrada) sticm = this.nfit.sticmentrada;else if (this.params.optSimples) sticm = this.nfit.csosn;else sticm = this.nfit.sticm;

      this.habilitaBCIcm = this.params.nfComplementar || sticm == '90' || sticm == '900';
      this.tributadoIcmST = sticm == '10' || sticm == '30' || sticm == '70' || sticm == '90' || sticm == '201' || sticm == '202' || sticm == '203' || sticm == '900';
      // this.tributadoIcm = (sticm != '30' && sticm != '40' && sticm != '41' && sticm != '50' && sticm != '60')
      this.tributadoIcm = sticm == '00' || sticm == '10' || sticm == '20' || sticm == '70' || sticm == '90' || sticm == '900';
      this.icmDiferido = sticm == '51';
      this.icmsRetido = sticm == '60' || sticm == '90' || sticm == '500' || sticm == '900';
      this.informaMotdes = sticm == '20' || sticm == '70' || sticm == '40' || sticm == '41' || this.nfit.ricm > 0 || sticm == '90' || sticm == '900';
      this.creditoSN = sticm == '201' || sticm == '101';
      this.habilitaAIcm = this.tributadoIcm || sticm == '41' || sticm == '40' || sticm == '201' || sticm == '202' || sticm == '203';
    },
    changeTab: function changeTab(index) {
      this.activeTab = index;
    },
    changeSubTab: function changeSubTab(index) {
      this.activeSubTab = index;
      var mappings = ['sistema', 'xml', 'manual'];
      this.tipoVinculo = mappings[index];
    },
    selecionarItemXmlByValue: function selecionarItemXmlByValue(nItemValue) {
      if (!nItemValue) {
        this.nfit.nitemorigem = "";
        return;
      }
      if (!this.xmlParsedData) return;
      var item = this.xmlParsedData.itens.find(function (i) {
        return i.nItem === nItemValue;
      });
      if (item) {
        this.selecionarItemXml(item);
      }
    },
    apiFetchNfOrigem: function apiFetchNfOrigem(codnforigem) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var nfList, nf;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (codnforigem) {
                  _context2.next = 4;
                  break;
                }

                _this3.nfOrigemDados = null;
                _this3.nfitemOrigemDados = null;
                return _context2.abrupt('return');

              case 4:
                _context2.prev = 4;
                _context2.next = 7;
                return _this3.$store.dispatch('loadNf', { id: codnforigem });

              case 7:
                nfList = _this3.$store.getters.getNf;

                if (nfList && nfList.length > 0) {
                  nf = nfList[0];

                  _this3.nfOrigemDados = {
                    chave: nf.chave || 'Não informada',
                    serie: nf.serie,
                    numnf: nf.nf
                  };
                  _this3.syncNfItemOrigemDados();
                } else {
                  _this3.nfOrigemDados = null;
                  _this3.nfitemOrigemDados = null;
                }
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](4);

                console.error(_context2.t0);
                _this3.nfOrigemDados = null;
                _this3.nfitemOrigemDados = null;

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[4, 11]]);
      }))();
    },
    syncNfItemOrigemDados: function syncNfItemOrigemDados() {
      var codnfitorigem = this.nfit.codnfitorigem;
      if (!codnfitorigem || !this.$store.getters.getNf || this.$store.getters.getNf.length === 0) {
        this.nfitemOrigemDados = null;
        return;
      }
      var nf = this.$store.getters.getNf[0];
      if (nf.nfit && nf.nfit.length > 0) {
        var item = nf.nfit.find(function (i) {
          return i.codnfit === codnfitorigem;
        });
        if (item) {
          this.nfitemOrigemDados = {
            descricao: item.item && item.item.length > 0 ? item.item[0].descricao : 'Produto sem descrição',
            quantidade: item.qtuni,
            valor: item.vlr
          };
        } else {
          this.nfitemOrigemDados = null;
        }
      } else {
        this.nfitemOrigemDados = null;
      }
    },
    closeForm: function closeForm() {
      this.$emit('closeform');
    },
    handleValidation: function handleValidation() {
      this.errmessages = [];

      this.$validator.reset();

      //VALIDACAO DOS CAMPOS DE IMPOSTOS CONFORME SITUACAO TRIBUTARIA DE CADA IMPOSTO
      this.local_metadata.aicm.validator = {};
      this.local_metadata.ricm.validator = {};
      this.local_metadata.aicmst.validator = {};
      this.local_metadata.bcicm.validator = {};
      this.local_metadata.vicm.validator = {};
      this.local_metadata.bcicmst.validator = {};
      this.local_metadata.vicm.validator = {};
      this.local_metadata.aipi.validator = {};
      this.local_metadata.ripi.validator = {};
      this.local_metadata.vipi.validator = {};
      this.local_metadata.bcipi.validator = {};
      this.local_metadata.apis.validator = {};
      this.local_metadata.rpis.validator = {};
      this.local_metadata.apisst.validator = {};
      this.local_metadata.vpis.validator = {};
      this.local_metadata.bcpis.validator = {};
      this.local_metadata.acofins.validator = {};
      this.local_metadata.rcofins.validator = {};
      this.local_metadata.acofinsst.validator = {};
      this.local_metadata.vcofins.validator = {};
      this.local_metadata.bccofins.validator = {};
      this.local_metadata.bcicmretst.validator = { required: false };
      this.local_metadata.vicmretst.validator = { required: false };
      this.local_metadata.chaveorigem.validator = { required: false, digits: 44 };
      this.local_metadata.nitemorigem.validator = { required: false, numeric: true };
      this.local_metadata.codnforigem.validator = { required: false, numeric: true };
      this.local_metadata.codnfitorigem.validator = { required: false, numeric: true };
      this.local_metadata.vlr.validator = { required: true, "valida-zero": true };

      if (this.params.nfAjuste || this.params.nfComplementar) {
        this.local_metadata.ncm.validator = {};
        this.local_metadata.vlr.validator = {};
      }

      if (this.tributadoIcm) {
        this.local_metadata.aicm.validator = { required: true, "valida-zero": false };
        if (this.params.nfAjuste || this.params.nfComplementar) {
          this.local_metadata.bcicm.validator = { required: true, "valida-zero": false };
          this.local_metadata.vicm.validator = { required: true, "valida-zero": false };
        }
      }

      if (this.tributadoIcmST) {
        this.local_metadata.aicmst.validator = { required: true, "valida-zero": false };
        if (this.params.nfAjuste || this.params.nfComplementar) {
          this.local_metadata.bcicmst.validator = { required: true, "valida-zero": false };
          this.local_metadata.vicmst.validator = { required: true, "valida-zero": false };
        }
      }

      if (this.tributadoIpi) {
        this.local_metadata.aipi.validator = { required: true, "valida-zero": false };
        if (this.params.nfAjuste || this.params.nfComplementar) {
          this.local_metadata.bcipi.validator = { required: true, "valida-zero": false };
          this.local_metadata.vipi.validator = { required: true, "valida-zero": false };
        }
      }

      if (this.tributadoPis) {
        this.local_metadata.apis.validator = { required: true, "valida-zero": false };
        if (this.params.nfAjuste || this.params.nfComplementar) {
          this.local_metadata.bcpis.validator = { required: true, "valida-zero": false };
          this.local_metadata.vpis.validator = { required: true, "valida-zero": false };
        }
      }

      if (this.tributadoCofins) {
        this.local_metadata.acofins.validator = { required: true, "valida-zero": false };
        if (this.params.nfAjuste || this.params.nfComplementar) {
          this.local_metadata.bccofins.validator = { required: true, "valida-zero": false };
          this.local_metadata.vcofins.validator = { required: true, "valida-zero": false };
        }
      }

      // console.log('passou aqui')
      // console.log(this.local_metadata.aicm.validator)
      // console.log(this.sticm)
      // console.log(this.nfit.sticm)
      if (this.sticm == '60' || this.sticm == '500') {
        // console.log('this.nfit.sticmentrada ' + this.nfit.sticmentrada)
        // console.log(this.tributadoIcm)
        // console.log(this.habilitaAIcm)
        this.local_metadata.bcicmretst.validator = { required: true, "valida-zero": true };
        this.local_metadata.vicmretst.validator = { required: true, "valida-zero": true };
      }
      // if (this.sticm == '20' || this.sticm == '70') {
      //     this.local_metadata.motdesicm.validator = { required: true }
      // }
    },
    handleValidarItem: function handleValidarItem() {
      var _this4 = this;

      // this.handleValidation();
      if (!(this.params.nfAjuste || this.params.nfComplementar) && this.nfit.vlr == 0) {
        this.$erpToastError('Insira o valor do item');
        return;
      }

      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this4.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          if ((_this4.sticm == '60' || _this4.sticm == '500') && !(_this4.nfit.bcicmretst > 0)) {
            _this4.$erpToastError('Informe a Base do ICMS Retido Anteriormente.');
            return;
          }
          if (_this4.nfit.pdevol > 100) {
            _this4.$erpToastError('Quantidade devolvida acima da permitida');
            return;
          }
          if (!_this4.nfit.qtuni > 0) {
            _this4.$erpToastError('Insira a quantidade do item');
            return;
          }
          _this4.handleSalvar();
        }
      });
    },
    calculaImpostoDevol: function calculaImpostoDevol() {
      if (this.params.ipidevol) {
        if (this.nfit.codnfitorigem && this.nfit.codnfitorigem !== '') {
          this.nfit.pdevol = this.nfit.qtuni / this.nfit.qtorigem * 100;
          this.nfit.vipidevol = this.nfit.vipiorigem * this.nfit.pdevol / 100;
        } else {
          if (!this.nfit.pdevol || this.nfit.pdevol === 0) {
            this.nfit.pdevol = 100;
          }
          this.nfit.vipidevol = (this.nfit.bcipi || 0) * (this.nfit.aipi || 0) / 100 * (this.nfit.pdevol / 100);
        }
      } else {
        this.nfit.pdevol = 0;
        this.nfit.vipidevol = 0;
      }
    }
  },

  watch: {
    'nfit.codnforigem': function nfitCodnforigem(newVal) {
      this.apiFetchNfOrigem(newVal);
    },
    'nfit.codnfitorigem': function nfitCodnfitorigem() {
      this.syncNfItemOrigemDados();
    },
    'nfit.stipi': function nfitStipi() {
      this.handleValidation();
    },
    'nfit.stpis': function nfitStpis() {
      this.handleValidation();
    },
    'nfit.stcofins': function nfitStcofins() {
      this.handleValidation();
    },
    'nfit.sticm': function nfitSticm() {
      this.handleValidation();
    },
    'nfit.ibscbscclass': function nfitIbscbscclass() {
      this.loadivaclass();

      if (this.coditem != null) {
        //this.apiCarregaIvaclass(this.nfit)
      }
      this.handleValidation();
    },

    coditem: function coditem() {
      //ao digitar um item, carrega os dados deste item
      if (this.unWatch) {
        this.unWatch = false;
        return;
      }

      if (this.coditem != null) {
        this.nfit.coditem = this.coditem;
        this.nfit.operacaonf = this.params.nf.operacaonf;

        this.apiCarregaProduto(this.nfit);

        this.handleValidation();

        //chamada de BO_NFS.GET_ITEM_TAXES para carga dos dados de impostos do item informado
        // this.$store.dispatch('loadItem', { id: this.coditem }).then(response => {
        //   console.log('response', this.selectedItem)
        // })
        // this.$store.dispatch('loadItemTaxes', { codnf: this.nfit.codnf, coditem: this.coditem, finalidade: this.nfit.finalidade })
      }
    },

    selectedItem: function selectedItem() {
      //quando selecionar um item, carrega a unidade de medida, ncm e a origem da mercadoria
      if (this.unWatch) return;

      if (!this.selectedItem.length) {
        return;
      }

      //ESTE PROCESSO FOI SUBSTITUIDO PELO this.apiCarregaProduto


      // this.nfit.uni = this.selectedItem[0].uni
      // this.nfit.ncm = this.selectedItem[0].ncm
      // this.nfit.orimerc = this.selectedItem[0].orimerc
      // //agrega o objeto retornado pela API ao objeto NFIT
      // this.nfit.item = this.selectedItem
      // this.nfit.vlr = this.selectedItem[0].precovenda
    },

    itemTaxes: function itemTaxes() {
      //ao selecionar um item, carrega a os dados de impostos deste item
      if (this.unWatch) return;

      if (!this.itemTaxes) {
        return;
      }

      //ESTE PROCESSO FOI SUBSTITUIDO PELO this.apiCarregaProduto


      // this.nfit.nfci = this.itemTaxes.nfci
      // this.nfit.csosn = this.itemTaxes.csosn
      // this.nfit.sticm = this.itemTaxes.sticm
      // this.nfit.stpis = this.itemTaxes.stpis
      // this.nfit.stcofins = this.itemTaxes.stcofins
      // this.nfit.stipi = this.itemTaxes.stipi
      // this.nfit.cfop = this.itemTaxes.cfop
      // this.nfit.motdesicm = this.itemTaxes.motdesicm
      // this.nfit.cest = this.itemTaxes.cest
      // this.nfit.aicm = this.itemTaxes.aicm
      // this.nfit.ricm = this.itemTaxes.ricm
      // this.nfit.afcp = this.itemTaxes.afcp
      // this.nfit.aicmst = this.itemTaxes.aicmst
      // this.nfit.mva = this.itemTaxes.mva
      // this.nfit.pautaicm = this.itemTaxes.pautaicm
      // this.nfit.pautaicmst = this.itemTaxes.pautaicmst
      // this.nfit.ricmst = this.itemTaxes.ricmst
      // this.nfit.afcpst = this.itemTaxes.afcpst
      // this.nfit.picmdif = this.itemTaxes.picmdif

      // this.nfit.pdesicm = this.itemTaxes.pdesicm
      // this.nfit.pdespc = this.itemTaxes.pdespc

      // this.nfit.particmdest = this.itemTaxes.particmdest
      // this.nfit.aicmdest = this.itemTaxes.aicmdest
      // this.nfit.afcpdest = this.itemTaxes.afcpdest

      // this.nfit.aipi = this.itemTaxes.aipi
      // this.nfit.ripi = this.itemTaxes.ripi
      // this.nfit.pautaipi = this.itemTaxes.pautaipi
      // this.nfit.cenqipi = this.itemTaxes.cenqipi

      // this.nfit.apis = this.itemTaxes.apis
      // this.nfit.apisst = this.itemTaxes.apisst
      // this.nfit.rpis = this.itemTaxes.rpis
      // this.nfit.pautapis = this.itemTaxes.pautapis
      // this.nfit.pautapisst = this.itemTaxes.pautapisst

      // // this.nfit.atribest = this.itemTaxes.atribest
      // // this.nfit.atribfed = this.itemTaxes.atribfed
      // // this.nfit.atribimp = this.itemTaxes.atribimp
      // // this.nfit.atribmun = this.itemTaxes.atribmun

      // this.nfit.acofins = this.itemTaxes.acofins
      // this.nfit.acofinsst = this.itemTaxes.acofinsst
      // this.nfit.rcofins = this.itemTaxes.rcofins
      // this.nfit.pautacofins = this.itemTaxes.pautacofins
      // this.nfit.pautacofinsst = this.itemTaxes.pautacofinsst

      // this.nfit.stiss = this.itemTaxes.stiss
      // this.nfit.aiss = this.itemTaxes.aiss

      // this.nfit.bcicmsret
    },

    csosn: function csosn() {
      this.habilitaTributacaoIcms();
    },

    sticmentrada: function sticmentrada() {
      this.habilitaTributacaoIcms();
    },

    sticm: function sticm() {
      this.habilitaTributacaoIcms();
    },

    stipi: function stipi() {
      this.tributadoIpi = this.nfit.stipi == '50' || this.nfit.stipi == '99' || this.nfit.stipi == '00' || this.nfit.stipi == '49';
    },

    stpis: function stpis() {
      this.tributadoPis = this.nfit.stpis == '01' || this.nfit.stpis == '02' || this.nfit.stpis == '49' || this.nfit.stpis == '50' || this.nfit.stpis == '98' || this.nfit.stpis == '99';
      this.tributadoPisST = this.nfit.stpis == '05';
      this.pautaPis = this.nfit.stpis == '03';
    },

    stcofins: function stcofins() {
      this.tributadoCofins = this.nfit.stcofins == '01' || this.nfit.stcofins == '02' || this.nfit.stcofins == '49' || this.nfit.stcofins == '50' || this.nfit.stcofins == '98' || this.nfit.stcofins == '99';
      this.tributadoCofinsST = this.nfit.stcofins == '05';
      this.pautaCofins = this.nfit.stcofins == '03';
    },

    orimerc: function orimerc() {
      this.informaFCI = this.nfit.orimerc == '1' || this.nfit.orimerc == '2' || this.nfit.orimerc == '3' || this.nfit.orimerc == '8';
    },

    'params.ipidevol': function paramsIpidevol() {
      this.calculaImpostoDevol();
    },

    'nfit.qtuni': function nfitQtuni() {
      this.calculaImpostoDevol();
    },

    'nfit.bcipi': function nfitBcipi() {
      this.calculaImpostoDevol();
    },

    'nfit.aipi': function nfitAipi() {
      this.calculaImpostoDevol();
    },

    'nfit.pdevol': function nfitPdevol() {
      this.calculaImpostoDevol();
    },

    novatributacao: function novatributacao() {
      this.showIBSCBS = this.nfit.ibscbscclass != '' || this.nfit.ibsufaliq > 0 || this.nfit.ibsufred > 0 || this.nfit.ibsmunaliq > 0 || this.nfit.ibsmunred > 0 || this.nfit.cbsaliq > 0 || this.nfit.cbsred > 0 || this.nfit.ccredpres != '' || this.nfit.ibspcredpres > 0 || this.nfit.ibsvcredprescondsus > 0 || this.nfit.cbspcredpres > 0 || this.nfit.cbsvcredprescondsus > 0 || this.nfit.ibsamono > 0 || this.nfit.cbsamono > 0 || this.nfit.ibsamonoret > 0 || this.nfit.cbsamonoret > 0 || this.nfit.ibsamonoreten > 0 || this.nfit.cbsamonoreten > 0 || this.nfit.ibsamonodif > 0 || this.nfit.cbsamonodif > 0;
    }

  },

  mounted: function mounted() {},
  created: function created() {
    this.local_metadata.chaveorigem = this.local_metadata.chaveorigem || {
      label: 'Chave de Acesso Referenciada (44 dígitos)',
      validator: { required: false, digits: 44 }
    };
    this.local_metadata.nitemorigem = this.local_metadata.nitemorigem || {
      label: 'Nº do Item de Origem',
      validator: { required: false, numeric: true }
    };
    this.local_metadata.codnforigem = this.local_metadata.codnforigem || {
      label: 'ID da Nota de Origem (Sistema)',
      validator: { required: false, numeric: true }
    };
    this.local_metadata.codnfitorigem = this.local_metadata.codnfitorigem || {
      label: 'ID do Item de Origem (Sistema)',
      validator: { required: false, numeric: true }
    };
    this.local_metadata.xmlSelectedItem = this.local_metadata.xmlSelectedItem || {
      label: 'Selecione o Item da Nota Original',
      validator: { required: false }
    };

    if (this.params.nfit) {
      this.nfit = this.params.nfit;
      if (this.nfit.codnforigem === null) this.nfit.codnforigem = '';
      if (this.nfit.codnfitorigem === null) this.nfit.codnfitorigem = '';
      if (this.nfit.chaveorigem === null) this.nfit.chaveorigem = '';
      if (this.nfit.nitemorigem === null) this.nfit.nitemorigem = '';
    }
    this.unWatch = true;

    this.handleValidation();

    if (this.nfit.codnforigem) {
      this.apiFetchNfOrigem(this.nfit.codnforigem);
    }

    if (this.isAjusteCreditoDebito) {
      this.showIBSCBS = true;
    }

    this.$nextTick(function () {
      if (this.$refs.item) this.$refs.item.focus();
    });
  }
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nf_form_origem__ = __webpack_require__(1609);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        nfref: { type: Array },
        nf: { type: Object },
        title: { type: Boolean, default: true }
    },

    components: {
        nfFormOrigem: __WEBPACK_IMPORTED_MODULE_2__nf_form_origem__["a" /* default */]
    },

    data: function data() {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            selectedNf: [],
            showNfOrigem: false, //exibe o form de selecao de notas de origem
            operacaonfOrigem: ''
        };
    },


    computed: {},

    methods: {
        handleAddRef: function handleAddRef() {
            //ADICIONA NOVA NF REFERENCIADA            
            var ref = _extends({}, this.$store.getters.getEntities.nfref);
            ref.nfreftp = 1;
            ref.modnfref = '01';
            ref.modnfpref = '04';
            ref.modecfref = '2B';
            ref.validation = {};
            this.nfref.push(ref);
        },
        handleDeleteRef: function handleDeleteRef(index) {
            //EXCLUI NF REFERENCIADA
            // console.log(index)
            this.nfref.splice(index, 1);
            // console.log(this.nfref.length)
        },
        closeOrigemForm: function closeOrigemForm(selectedNf) {
            //FECHAMENTO DA TELA DE NF DE ORIGEM
            this.showNfOrigem = false;
            if (!selectedNf) {
                return;
            }
            if (!selectedNf.length) {
                return;
            }
            //selectedNf = NOTAS SELECIONADAS NA TELA DE NOTAS DE ORIGEM
            //ADICIONA AS NOTAS SELECIONADAS NO OBJETO nfref
            for (var x = 0; x < selectedNf.length; x++) {
                if (this.nfref.findIndex(function (obj) {
                    return obj.chave == selectedNf[x].chave;
                }) < 0) {
                    var ref = _extends({}, this.$store.getters.getEntities.nfref);
                    ref.nfreftp = 1;
                    ref.chave = selectedNf[x].chave;
                    ref.codnfref = selectedNf[x].codnf;
                    ref.serie = selectedNf[x].serie;
                    ref.nf = selectedNf[x].nf;
                    ref.validation = {};
                    this.nfref.push(ref);
                }
            }
        },
        handleNfOrigem: function handleNfOrigem() {
            //exibe o formulario de selecao de notas origem
            // console.log(this.codpart)
            // return
            if (this.nf.codpart == null) {
                this.$erpToastError('Informe o participante');
                return;
            }
            if (this.tpnf === 'I' && this.codnatesret == null) {
                //NOTA DE INDUSTRIALIZACAO OBRIGA NAT DE RETORNO
                this.$erpToastError('Informe a natureza de retorno');
                return;
            }

            //PARA NOTAS DE SAIDA: EXIBE NOTAS DE ENTRADA PARA SELECAO
            //PARA NOTAS DE ENTRADA: EXIBE NOTAS DE SAIDA PARA SELECAO
            //PARA NOTAS DE COMPLEMENTO DE IMPOSTO SAIDA: EXIBE NOTAS DE SAIDA PARA SELECAO
            if (this.nf.operacaonf === 'S' && (this.nf.tpnf === 'P' || this.nf.tpnf === 'CR' || this.nf.tpnf === 'DB')) {
                this.operacaonfOrigem = 'S';
            } else if (this.nf.operacaonf === 'E' && (this.nf.tpnf === 'P' || this.nf.tpnf === 'CR' || this.nf.tpnf === 'DB')) {
                this.operacaonfOrigem = 'E';
            } else if (this.nf.operacaonf === 'S') {
                this.operacaonfOrigem = 'E';
            } else {
                this.operacaonfOrigem = 'S';
            }

            this.showNfOrigem = true;
        }
    },

    watch: {},

    created: function created() {
        // if (this.nfref.length == 0) {
        //     this.handleAddRef()
        // }        
    }
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        operacaonf: { type: String },
        codpart: { type: [String, Number] }
    },

    data: function data() {
        return {
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,

            selectedNf: [], //codigos de notas selecionadas

            searchString: ''
        };
    },


    computed: {
        nfList: function nfList() {
            return this.$store.getters.getNfOrigem;
        }
    },

    methods: {
        handleSearch: function handleSearch() {
            //efetua a pesquisa
            if (this.searchString === '') {
                this.filter = '';
            } else {
                this.filter = '{"$or":[{"nf":{"$eq":"' + this.searchString + '"}}]}';
            }
            this.loadData();
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadNfOrigem', { operacaoNf: _this.operacaonf, codpart: _this.codpart, filter: _this.filter });

                            case 2:
                                _this.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });
                                _this.updateListSelected();

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        updateListSelected: function updateListSelected() {
            var _this2 = this;

            //ao carregar as notas no loadData, marca as notas que ja foram selecionadas            
            for (var x = 0; x < this.nfList.length; x++) {
                this.$set(this.nfList[x], 'selected', 'N');
                // this.nfList[x].selected = 'N'
                if (this.selectedNf.findIndex(function (obj) {
                    return obj.codnf == _this2.nfList[x].codnf;
                }) >= 0) {
                    this.nfList[x].selected = 'S';
                }
            }
        },
        handleSelectNf: function handleSelectNf(codnf, chave, serie, nf) {
            //botao de selecao da nf 
            //adiciona a nf selecionada no array "selectNf"            
            if (this.selectedNf.findIndex(function (obj) {
                return obj.codnf == codnf;
            }) >= 0) {
                this.handleUnselectNf(codnf);
            } else {
                var nf = {
                    codnf: codnf,
                    chave: chave,
                    serie: serie,
                    nf: nf
                };
                this.selectedNf.push(nf);
            }
            // console.log(this.selectedNf)
        },
        handleUnselectNf: function handleUnselectNf(codnf) {
            //botao para remover uma nf selecionada
            var idx = -1;
            for (var x = 0; x < this.selectedNf.length; x++) {
                if (this.selectedNf[x].codnf === codnf) {
                    idx = x;
                }
            }
            if (idx >= 0) {
                this.selectedNf.splice(idx, 1);
            }
        },
        textST: function textST(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(value, this.metadata.nf.stnf);
        },
        operacaoNf: function operacaoNf(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(value, this.metadata.nf.operacaonf);
        },
        data: function data(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatDate"])(value);
        },
        handleAddNotas: function handleAddNotas() {
            //envia as notas selecionadas para o formulario chamador
            // for (var x = 0; x < this.nfList.length; x++) {
            //     if (this.nfList[x].selected === 'S') {
            //         var nf = { 
            //             codnf: this.nfList[x].codnf, 
            //             chave: this.nfList[x].chave
            //             }
            //         this.selectedNf.push(nf)
            //     }
            // }
            this.$emit('closeform', this.selectedNf);
        },
        closeForm: function closeForm() {
            this.$emit('closeform');
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(value, 2);
        }

    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"]
    },

    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nf_form_numero_vue__ = __webpack_require__(580);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7419c74_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nf_form_numero_vue__ = __webpack_require__(1616);
function injectStyle (ssrContext) {
  __webpack_require__(1614)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nf_form_numero_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7419c74_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nf_form_numero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    nf: { type: Object }
  },

  data: function data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: '',
      serie: '',
      numero: 0,
      serienf: []
    };
  },


  computed: {
    serienfList: function serienfList() {
      var series = [];
      this.$store.getters.getSerienfList.map(function (ser) {
        series.push({ id: ser.serie, text: ser.serie, nf: ser.nf });
      });
      return series;
    }
  },

  methods: {
    handleSalvar: function handleSalvar() {
      if (this.serie === '' || this.nf.serie === null || this.numero === '0' || this.numero === null) {
        this.errmessages = 'Por favor preencha corretamente os campos';
        return;
      } else {
        this.errmessages = '';
      }
      this.nf.serie = this.serie;
      this.nf.nf = this.numero;
      this.$emit('save');
    },
    loadSerieList: function loadSerieList() {
      this.$store.dispatch('loadSerienf', { filter: this.filter, page: this.nextPage });
    },
    handleCancelar: function handleCancelar(index) {
      this.$emit('closeform');
    }
  },

  watch: {
    'serie': function serie() {
      var _this = this;

      if (this.serienfList.length > 0) {
        var vserie = this.serienfList.find(function (item) {
          return item.id == _this.serie;
        });
        if (vserie) {
          this.numero = vserie.nf;
        }
      }
    }

  },

  created: function created() {
    this.loadSerieList();
    this.serie = this.nf.serie;
    this.numero = this.nf.nf;
    this.$nextTick(function () {
      this.$refs.serie.$el.querySelector('input').focus();
    });
  }
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_estoque_entrada_vue__ = __webpack_require__(582);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b42a2292_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_estoque_entrada_vue__ = __webpack_require__(1619);
function injectStyle (ssrContext) {
  __webpack_require__(1617)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b42a2292"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_estoque_entrada_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b42a2292_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_estoque_entrada_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__estoque_selecionar_lote_vue__ = __webpack_require__(554);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: { type: Number },
    nfEntrada: { type: Boolean },
    excluir: { type: Boolean }
  },

  components: { EstoqueSelecionarLote: __WEBPACK_IMPORTED_MODULE_1__estoque_selecionar_lote_vue__["a" /* default */] },

  data: function data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      itemList: [],
      concluir: false,
      msgErro: null,
      msgConcluir: null,
      depositoUnico: 'N',
      coddeposito: null,
      exclusaoConfirmada: 'N',
      showModal: false,
      activeItemIndex: null
    };
  },


  computed: {
    administrador: function administrador() {
      return SysVars.usuarioAdministrador;
    },

    urlEstoque: function urlEstoque() {
      if (this.concluir) return '/estoque/nfentrada/armazenamento/concluir/' + this.index;

      return '/estoque/nfentrada/armazenamento/' + this.index;
    },
    urlExcluirEstoque: function urlExcluirEstoque() {
      return '/estoque/nfentrada/armazenamento/' + this.index + '/excluir';
    },


    activeItem: function activeItem() {
      if (this.activeItemIndex !== null && this.itemList.length > 0) {
        return this.itemList[this.activeItemIndex];
      }
      return null;
    }
  },

  methods: {
    qtAlcoated: function qtAlcoated(item) {
      if (!item || !item.estoque) return 0;
      return item.estoque.reduce(function (t, e) {
        if (e.excluido) return t;
        return t + (parseFloat(e.qt) || 0);
      }, 0);
    },
    isAlocated: function isAlocated(item) {
      return Math.abs(this.qtAlcoated(item) - item.qt) < 0.0001;
    },
    loadData: function loadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var r;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDS"])(_this.$store.getters.urlOrds + ('/estoque/nfentrada/armazenamento/' + _this.index), null, true);

              case 2:
                r = _context.sent;

                _this.itemList = r.items || r.itens || r;
                _this.inicializaEstoqueItens();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    inicializaEstoqueItens: function inicializaEstoqueItens() {
      for (var x = 0; x < this.itemList.length; x++) {
        var item = this.itemList[x];
        if (!item.estoque) {
          this.$set(item, 'estoque', []);
        }
        if (item.estoque.length === 0) {
          var estoque = _extends({}, this.$store.getters.getEntities.nfqt, {
            lote: null,
            qt: item.qt,
            coddeposito: item.coddeposito || item.fallback_coddeposito,
            descricao: item.deposito_descricao || item.fallback_deposito_descricao,
            selecionarLote: false
          });
          item.estoque.push(estoque);
        }
      }
    },
    handleSugerirLotes: function handleSugerirLotes() {
      this.inicializaEstoqueItens();
      this.msgErro = null;
      this.msgConcluir = null;
      this.concluir = false;
    },
    handleSalvar: function handleSalvar() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var metodo, _data, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                metodo = 'put';

                if (!_this2.concluir) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this2.$store, _this2.urlEstoque, { itens: _this2.itemList }, 'put');

              case 4:
                _data = _context2.sent;

                if (!(_data && _data.erros)) {
                  _context2.next = 9;
                  break;
                }

                _this2.msgErro = 'Erro ao concluir armazenamento.';
                _this2.concluir = false;
                return _context2.abrupt('return');

              case 9:
                _this2.$erpToastSuccess('A Nota fiscal foi armazenada com sucesso');
                return _context2.abrupt('return', _this2.closeForm());

              case 11:
                _context2.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this2.$store, _this2.urlEstoque, { itens: _this2.itemList }, metodo);

              case 13:
                data = _context2.sent;

                if (data && (data.itens || data.items)) {
                  _this2.itemList = data.itens || data.items;
                }

                if (data && data.erros) {
                  _this2.msgErro = 'Corrija os erros para concluir o armazenamento da nota fiscal.';
                  _this2.concluir = false;
                } else {
                  _this2.msgConcluir = 'Nota fiscal pronta para ser armazenada. Clique em Concluir Armazenamento.';
                  _this2.concluir = true;
                }

                _this2.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    apiExcluirEstoque: function apiExcluirEstoque() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var metodo;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                metodo = 'post';
                _context3.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this3.$store, _this3.urlExcluirEstoque, null, metodo);

              case 3:
                _this3.$erpToastSuccess('Armazenamento da nota excluído');
                _this3.closeForm();

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleExcluir: function handleExcluir() {
      if (this.exclusaoConfirmada === 'S') this.apiExcluirEstoque();else {
        this.$erpToastError('Primeiro confirme a exclusão para continuar.');
      }
    },
    closeForm: function closeForm() {
      this.$emit('closeform');
    },
    handleDeleteEstoque: function handleDeleteEstoque(item, estoque, index) {
      item.estoque.splice(index, 1);
      this.concluir = false;
    },
    openModal: function openModal(index) {
      this.activeItemIndex = index;
      this.showModal = true;
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.activeItemIndex = null;
    },
    onEscapeKey: function onEscapeKey(e) {
      if (e.key === 'Escape' && this.showModal) {
        this.closeModal();
      }
    },
    handleAdicionarEstoque: function handleAdicionarEstoque(item, selecionarLote) {
      var total = this.qtAlcoated(item);
      if (total >= item.qt) {
        this.$erpToastError('Quantidade informada já atinge o total do item.');
        return;
      }

      var estoque = _extends({}, this.$store.getters.getEntities.nfqt, {
        qt: parseFloat((item.qt - total).toFixed(4)),
        selecionarLote: selecionarLote
      });
      item.estoque.push(estoque);
      this.concluir = false;
    },
    isControleLote: function isControleLote(item) {
      return item.tipoestoque === 'V' || item.tipoestoque === 'L';
    },
    isControleValidade: function isControleValidade(item) {
      return item.tipoestoque === 'V';
    },
    checkAutoAllocate: function checkAutoAllocate() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var hasLoteControl, hasMissingDeposit, alreadyAllocated, valData;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this4.excluir) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return');

              case 2:
                if (!(!_this4.itemList || _this4.itemList.length === 0)) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt('return');

              case 4:
                hasLoteControl = _this4.itemList.some(function (item) {
                  return _this4.isControleLote(item);
                });
                hasMissingDeposit = _this4.itemList.some(function (item) {
                  return !item.coddeposito && !item.fallback_coddeposito;
                });
                alreadyAllocated = _this4.itemList.every(function (item) {
                  return _this4.isAlocated(item) && item.estoque.length > 0;
                });

                if (!(!hasLoteControl && !hasMissingDeposit && !alreadyAllocated)) {
                  _context4.next = 24;
                  break;
                }

                _this4.inicializaEstoqueItens();
                _context4.prev = 9;
                _context4.next = 12;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this4.$store, '/estoque/nfentrada/armazenamento/' + _this4.index, { itens: _this4.itemList }, 'put');

              case 12:
                valData = _context4.sent;

                if (!(valData && valData.erros)) {
                  _context4.next = 15;
                  break;
                }

                return _context4.abrupt('return');

              case 15:
                _context4.next = 17;
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this4.$store, '/estoque/nfentrada/armazenamento/concluir/' + _this4.index, { itens: _this4.itemList }, 'put');

              case 17:
                _this4.$erpToastSuccess('Armazenamento executado com sucesso.');
                _this4.closeForm();
                _context4.next = 24;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t0 = _context4['catch'](9);

                console.error(_context4.t0);

              case 24:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[9, 21]]);
      }))();
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
    document.addEventListener('keydown', this.onEscapeKey);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.onEscapeKey);
  },
  created: function created() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this5.loadData();

            case 2:
              _this5.checkAutoAllocate();

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['url', 'key', 'message', 'btnClass', 'btnText'],
  created: function created() {
    this.modalState = true;

    //this.$nextTick(function () {
    //  jQuery(this.$el).find('.modal').modal({
    //    backdrop: true,
    //    keyboard: true
    //  })
    //})
  },
  data: function data() {
    return {
      dataToSend: null,
      modalState: false
    };
  },

  methods: {
    handleCloseButton: function handleCloseButton() {
      this.modalState = false;
      this.$emit('close');
    },
    handleActionButton: function handleActionButton() {
      this.modalState = true;
    },
    handleConfirmButton: function handleConfirmButton() {
      this.$emit('onConfirm');
      this.handleCloseButton();
    }
  }
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    nf: Object

  },
  data: function data() {
    return {
      xml: null,
      nprot: null,
      chave: null
    };
  },

  methods: {
    changeToNextEl: function changeToNextEl() {
      this.$nextTick(function () {
        this.$refs.nfxmlConfirmButton.focus();
      });
    },
    closeModal: function closeModal() {
      this.$emit('close');
    },
    handleConfirmNfxml: function handleConfirmNfxml() {
      this.$emit('getNfxml', { xml: this.xml, chave: this.chave, nprot: this.nprot });
      this.closeModal();
    }
  },
  created: function created() {
    if (this.nf.nfxml && this.nf.nfxml.length > 0) {
      this.xml = this.nf.nfxml[0].xml;
      this.chave = this.nf.nfxml[0].chave;
      this.nprot = this.nf.nfxml[0].nprot;
    }
    this.$nextTick(function () {
      this.$refs.chave.focus();
    });

    window.addEventListener('keyup', function (event) {
      if (event.keyCode == 27) {
        this.closeModal();
      }
    });
  }
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfe_eventos_form_vue__ = __webpack_require__(586);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_753c8d48_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfe_eventos_form_vue__ = __webpack_require__(1630);
function injectStyle (ssrContext) {
  __webpack_require__(1628)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-753c8d48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfe_eventos_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_753c8d48_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfe_eventos_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        nf: {
            type: Object,
            required: true
        },
        defaultTpEvento: { type: String, default: '' },
        defaultTpEventoAut: { type: String, default: '' },
        defaultNProtEvento: { type: String, default: '' }
    },
    data: function data() {
        return {
            show: true,
            tpEventoSelecionado: '',
            camposCabecalho: {
                dhPagto: '',
                vPagto: 0,
                tpMeioPagto: '',
                dhPrevisaoEntrega: '',
                indAceitacao: 1,
                xJust: '',
                dhEntrega: '',
                nDoc: '',
                xNome: '',
                hashComprovante: '',
                dhHashComprovante: '',
                latGPS: '',
                longGPS: '',
                nProt: '',
                tpeventoaut: '',
                nprotevento: ''
            },
            itensEvento: [],
            erros: [],
            metadata: this.$store.getters.getEntities.metadata,
            listaEventosSaida: [{ id: '112110', text: '112110 - Informacao de Efetivo Pagamento Integral' }, { id: '112150', text: '112150 - Atualizacao da Data de Previsao de Entrega' }, { id: '112120', text: '112120 - Importacao em ALC/ZFM nao convertida em isencao' }, { id: '112130', text: '112130 - Perecimento/Perda durante o transporte pelo fornecedor (CIF)' }, { id: '112140', text: '112140 - Fornecimento nao realizado com pagamento antecipado' }, { id: '211110', text: '211110 - Solicitacao de Apropriacao de Credito Presumido' }, { id: '110001', text: '110001 - Cancelamento de Evento'
                // { id: '110130', text: '110130 - Comprovante de Entrega da NF-e' },
                // { id: '110192', text: '110192 - Insucesso na Entrega da NF-e' },
                // { id: '110160', text: '110160 - Conciliacao Financeira (ECONF)' },
                // { id: '110131', text: '110131 - Cancelamento do Comprovante de Entrega' }
            }],
            listaEventosEntrada: [{ id: '211110', text: '211110 - Solicitacao de Apropriacao de Credito Presumido' }, { id: '211130', text: '211130 - Imobilizacao de item' }, { id: '211140', text: '211140 - Solicitacao de Apropriacao de Credito de Combustivel' }, { id: '211150', text: '211150 - Solicitacao de Apropriacao de Credito (Bens/Serv. Atividade)' }, { id: '211128', text: '211128 - Aceite de debito (Nota de Credito)' }, { id: '211124', text: '211124 - Perecimento/Perda durante o transporte pelo adquirente (FOB)'
                // { id: '211160', text: '211160 - Fornecimento nao realizado com pagamento antecipado' } // Removido/comentado conforme análise (código incorreto)
            }]
        };
    },

    computed: {
        listaEventos: function listaEventos() {
            return this.nf.operacaonf === 'S' ? this.listaEventosSaida : this.listaEventosEntrada;
        },
        exigeItens: function exigeItens() {
            var eventosComItens = ['211110', '211130', '211140', '211150', '112120', '112130', '112140', '211124'];
            return eventosComItens.includes(this.tpEventoSelecionado);
        }
    },
    watch: {
        tpEventoSelecionado: function tpEventoSelecionado() {
            this.erros = [];
            this.inicializarItens();
        }
    },
    created: function created() {
        this.inicializarItens();
        if (this.defaultTpEvento) {
            this.tpEventoSelecionado = this.defaultTpEvento;
            this.camposCabecalho.tpeventoaut = this.defaultTpEventoAut;
            this.camposCabecalho.nprotevento = this.defaultNProtEvento;
        }
    },

    methods: {
        inicializarItens: function inicializarItens() {
            if (this.nf.nfit) {
                this.itensEvento = this.nf.nfit.map(function (it) {
                    return {
                        nitem: it.itnf || it.nitem,
                        descricao: (it.item && it.item[0] ? it.item[0].descricao : '') || (it.nfitx && it.nfitx[0] ? it.nfitx[0].descricao : '') || it.descitem || it.xprod || it.descricao || 'Item ' + (it.itnf || it.nitem),
                        vbc: 0,
                        pcredpres: 0,
                        vcredpresibs: 0,
                        vcredprescbs: 0,
                        vibs: 0,
                        vcbs: 0,
                        qimob: it.qtd || it.qtde || 0,
                        qcomb: it.qtd || it.qtde || 0,
                        ucomb: it.uni || '',
                        cClassTrib: it.cclasstrib || '',
                        ccredpres: it.ccredpres || null,
                        qperecimento: it.qtd || it.qtde || 0,
                        uperecimento: it.uni || '',
                        vestornoibs: 0,
                        vestornocbs: 0,
                        qnaofornecida: it.qtd || it.qtde || 0,
                        unaofornecida: it.uni || ''
                    };
                });
            }
        },
        handleEnviar: function handleEnviar() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var tipoCert, isA3, payload, response, extraParams;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.erros = [];

                                if (_this.tpEventoSelecionado) {
                                    _context.next = 4;
                                    break;
                                }

                                _this.erros.push('Selecione um tipo de evento.');
                                return _context.abrupt('return');

                            case 4:

                                // Validações básicas por evento
                                if (_this.tpEventoSelecionado === '110001') {
                                    if (!_this.camposCabecalho.tpeventoaut) {
                                        _this.erros.push('O código do evento original a ser cancelado é obrigatório.');
                                    }
                                    if (!_this.camposCabecalho.nprotevento) {
                                        _this.erros.push('O número do protocolo do evento original é obrigatório.');
                                    }
                                    if (!_this.camposCabecalho.xJust) {
                                        _this.erros.push('A justificativa do cancelamento é obrigatória.');
                                    } else if (_this.camposCabecalho.xJust.length < 15) {
                                        _this.erros.push('A justificativa do cancelamento deve ter pelo menos 15 caracteres.');
                                    }
                                }

                                /*
                                if (this.tpEventoSelecionado === '110192') {
                                    if (!this.camposCabecalho.dhPagto) this.erros.push('Data da tentativa é obrigatória.')
                                    if (!this.camposCabecalho.tpMeioPagto) this.erros.push('Motivo do insucesso é obrigatório.')
                                    if (!this.camposCabecalho.xJust && this.camposCabecalho.tpMeioPagto === '4') this.erros.push('Justificativa é obrigatória para o motivo Outros.')
                                    if (!this.camposCabecalho.hashComprovante) this.erros.push('O envio da foto da tentativa infrutífera é obrigatório para gerar o hash do insucesso.')
                                }
                                 if (this.tpEventoSelecionado === '110160') {
                                    if (this.camposCabecalho.vPagto <= 0) this.erros.push('Valor do pagamento deve ser maior que zero.')
                                    if (!this.camposCabecalho.tpMeioPagto) this.erros.push('Meio de pagamento é obrigatório.')
                                }
                                 if (this.tpEventoSelecionado === '110131') {
                                    if (!this.camposCabecalho.nProt) this.erros.push('O protocolo do comprovante de entrega é obrigatório.')
                                }
                                 if (this.tpEventoSelecionado === '110130') {
                                    if (!this.camposCabecalho.dhEntrega) this.erros.push('Data e hora da entrega é obrigatória.')
                                    if (!this.camposCabecalho.nDoc) this.erros.push('Documento do recebedor (CPF/CNPJ) é obrigatório.')
                                    if (!this.camposCabecalho.xNome) this.erros.push('Nome do recebedor é obrigatório.')
                                    if (!this.camposCabecalho.hashComprovante) this.erros.push('O envio da foto do canhoto assinado é obrigatório para gerar o hash do comprovante.')
                                }
                                */

                                if (_this.tpEventoSelecionado === '211110') {
                                    _this.itensEvento.forEach(function (it) {
                                        if ((it.vibs > 0 || it.vcbs > 0 || it.vbc > 0) && !it.ccredpres) {
                                            _this.erros.push('Item ' + it.nitem + ': Código do Crédito Presumido (Cód. Créd. Pres.) é obrigatório quando há valores informados.');
                                        }
                                    });
                                }

                                if (!(_this.erros.length > 0)) {
                                    _context.next = 8;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 8:
                                tipoCert = _this.$certificadoCheck ? _this.$certificadoCheck(_this.nf.codfil) : '';
                                isA3 = tipoCert === 'A3';
                                payload = {
                                    codnf: _this.nf.codnf,
                                    codfil: _this.nf.codfil,
                                    tpeventonfe: _this.tpEventoSelecionado,
                                    a3: isA3,
                                    cabecalho: _this.camposCabecalho,
                                    itens: _this.exigeItens ? _this.itensEvento.filter(function (it) {
                                        return it.vibs > 0 || it.vcbs > 0 || it.vbc > 0 || it.qimob > 0 || it.qcomb > 0 || it.qperecimento > 0 || it.qnaofornecida > 0 || it.vestornoibs > 0 || it.vestornocbs > 0;
                                    }) : []
                                };

                                if (!(_this.exigeItens && payload.itens.length === 0)) {
                                    _context.next = 14;
                                    break;
                                }

                                _this.erros.push('Preencha os dados de ao menos um item para este evento.');
                                return _context.abrupt('return');

                            case 14:
                                _context.prev = 14;
                                _context.next = 17;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this.$store, 'invoice/evento/', payload, 'post');

                            case 17:
                                response = _context.sent;

                                if (!(response.status === 'success')) {
                                    _context.next = 28;
                                    break;
                                }

                                if (!isA3) {
                                    _context.next = 23;
                                    break;
                                }

                                extraParams = '&tpevento=' + _this.tpEventoSelecionado;

                                _this.$executaExtensaoChromeA3(_this.nf.codnf, 'eventortc', function (a3Resp) {
                                    if (a3Resp && a3Resp.status === 'success') {
                                        _this.$erpToastSuccess('Evento autorizado com sucesso');
                                        _this.$emit('success');
                                        _this.handleClose();
                                    } else {
                                        var msg = a3Resp ? a3Resp.message : 'Erro ao processar evento no módulo A3';
                                        _this.erros = [msg];
                                        if (_this.$erpToastError) {
                                            _this.$erpToastError(msg);
                                        }
                                    }
                                }, extraParams);
                                return _context.abrupt('return');

                            case 23:

                                _this.$erpToastSuccess('Evento enviado com sucesso');
                                _this.$emit('success');
                                _this.handleClose();
                                _context.next = 29;
                                break;

                            case 28:
                                _this.erros = response.errmessages || [response.message];

                            case 29:
                                _context.next = 34;
                                break;

                            case 31:
                                _context.prev = 31;
                                _context.t0 = _context['catch'](14);

                                _this.erros.push('Erro ao processar requisição: ' + _context.t0.message);

                            case 34:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[14, 31]]);
            }))();
        },
        handleUploadCanhoto: function handleUploadCanhoto(event) {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var file, reader;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                file = event.target.files[0];

                                if (file) {
                                    _context3.next = 3;
                                    break;
                                }

                                return _context3.abrupt('return');

                            case 3:
                                reader = new FileReader();

                                reader.onload = function () {
                                    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
                                        var base64Data, rawString, encoder, data, hashBuffer, hashArray, hashString, localDate, offsetMs;
                                        return regeneratorRuntime.wrap(function _callee2$(_context2) {
                                            while (1) {
                                                switch (_context2.prev = _context2.next) {
                                                    case 0:
                                                        base64Data = e.target.result.split(',')[1]; // Obtém apenas a string base64 pura

                                                        rawString = (_this2.nf.chavenf || _this2.nf.chave || '') + base64Data;
                                                        _context2.prev = 2;

                                                        // Computa SHA-1 usando a API Web Crypto nativa do navegador
                                                        encoder = new TextEncoder();
                                                        data = encoder.encode(rawString);
                                                        _context2.next = 7;
                                                        return window.crypto.subtle.digest('SHA-1', data);

                                                    case 7:
                                                        hashBuffer = _context2.sent;


                                                        // Converte o hash binário resultante para string e então para Base64
                                                        hashArray = Array.from(new Uint8Array(hashBuffer));
                                                        hashString = hashArray.map(function (b) {
                                                            return String.fromCharCode(b);
                                                        }).join('');

                                                        _this2.camposCabecalho.hashComprovante = window.btoa(hashString);

                                                        // Define dhHashComprovante com a data/hora local atual no formato ISO
                                                        localDate = new Date();
                                                        offsetMs = localDate.getTimezoneOffset() * 60 * 1000;

                                                        _this2.camposCabecalho.dhHashComprovante = new Date(localDate.getTime() - offsetMs).toISOString().substring(0, 19);
                                                        _context2.next = 19;
                                                        break;

                                                    case 16:
                                                        _context2.prev = 16;
                                                        _context2.t0 = _context2['catch'](2);

                                                        _this2.erros.push('Erro ao gerar hash do comprovante: ' + _context2.t0.message);

                                                    case 19:
                                                    case 'end':
                                                        return _context2.stop();
                                                }
                                            }
                                        }, _callee2, _this2, [[2, 16]]);
                                    }));

                                    return function (_x) {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                reader.readAsDataURL(file);

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this2);
            }))();
        },
        handleClose: function handleClose() {
            this.$emit('close');
        }
    }
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfse_form_vue__ = __webpack_require__(588);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cbecb96_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfse_form_vue__ = __webpack_require__(1638);
function injectStyle (ssrContext) {
  __webpack_require__(1632)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cbecb96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfse_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cbecb96_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfse_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_numbers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_numbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_numbers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nfse_item__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nf_form_ref__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__nf_form_numero__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__customer_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__nates_form__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_api_nfe_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_api_nfe_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__api_api_nfe_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_api_nf_item_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_api_nf_item_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__api_api_nf_item_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















var Actions = {
    ENVIAR_EMAIL: 1,
    IMPRIMIR_DANFE: 2,
    CANCELA_NF: 3,
    DUPLICA_NF: 4,
    EXCLUI_NF: 5,
    DOWNLOAD_XML: 6,
    AUTORIZA_NF: 7,
    SINCRONIZA_NF: 12
};

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: {}, //outrasSaidas: false, outrasEntradas: false, codpedv: 0, codnf: 0
        crud: ''
    },

    components: {
        Trap: __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default.a, nfseItem: __WEBPACK_IMPORTED_MODULE_5__nfse_item__["a" /* default */], nfFormRef: __WEBPACK_IMPORTED_MODULE_6__nf_form_ref__["a" /* default */], nfFormNumero: __WEBPACK_IMPORTED_MODULE_7__nf_form_numero__["a" /* default */], CustomerForm: __WEBPACK_IMPORTED_MODULE_8__customer_form__["default"], NatesForm: __WEBPACK_IMPORTED_MODULE_9__nates_form__["a" /* default */], Actions: Actions
    },

    data: function data() {
        return {
            Actions: Actions,
            view: false, //variavel para controle de visualizacao ou edicao
            formCab: false, //editando cabecalho da nf
            formPar: false, //editando parcelas da nf
            formNF: false,
            formIncluir: false, //exibe formulario para inclusao de notas (campos participante e natureza)
            nfOutrasNotas: false, //inclusao de outras notas de saida
            nfVendaLivre: false, //nota de venda sem pedido
            showFormItem: false, //exibe o formulario de manutencao de item do pedido
            showNumeroForm: false, //exibe o formulario para alteracao do numero da nf
            showPartForm: false, //exibe o formulario de participante para inclusao
            showNatesForm: false, //exibe o formulario de naturezas para inclusao
            showCancel: false, //exibe a justificativa do cancelamento
            formItemView: false,
            CANCEL_ITEM_MESSAGE: false,
            DELETE_ITEM_MESSAGE: false,
            showFormEmail: false,
            showTotal: false,
            modalExcluir: false,

            updateItem: false, //indica quando for uma alteracao de item

            notaFiscalDemo: false,
            dadosNotaFiscalDemo: null,

            //entidades
            nf: _extends({}, this.$store.getters.getEntities.nf),
            nfit: [],
            nfpar: [], //parcelas da nf
            nfref: [], //notas referenciadas
            selectedNf: [], //notas de origem
            _nf: {}, //objeto utilizado para funcionalidade do botao descartar
            nfit_delete: null,
            metadata: _extends({}, this.$store.getters.getEntities.metadata),
            errmessages: [], //armazena as mensagens de validacao da nf apos a gravacao
            errCorrecao: [],

            codpedv: 0,
            codnf: 0,

            codpart: 0, //codigo do participante para alteracao
            crudPart: '', //inclusao ou alteracao de participante
            transportadora: false,

            codmenCpl: '', //mensagem complementar
            codmenFisco: '', //mensagem fisco

            enderecoEntrega: false,
            enderecoRetirada: false,

            nfit_update: {},
            paramItem: {},

            unwatch: true,
            natRetorno: false,

            moreActions: [], //botao mais acoes

            tabs: ['Produtos da Nota', 'Eventos'], //paginas
            activeTab: 0, //pagina ativa

            editNfRef: false
        };
    },


    computed: {

        appERP: function appERP() {
            return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appERP;
        },

        titleParticipante: function titleParticipante() {
            return 'Cliente/Destinatário';
        },

        ambienteHomologacao: function ambienteHomologacao() {
            return Sysvars.ambienteHomologacao;
        },

        _alteraNumero: function _alteraNumero() {
            return !this.isView && this.nf.emissaopropria == 'S' && (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50');
        },

        habilitaBotaoProduto: function habilitaBotaoProduto() {
            return !this.isView && (this.nfOutrasNotas || this.nfVendaLivre) && !this.nf.codpedv && this.nf.flagestoquebaixado != 'S' && this.nf.flagarmazenada != 'S' && this.nfit.length <= 0;
        },

        habilitaDuplicata: function habilitaDuplicata() {
            return true;
        },

        deleteItem: function deleteItem() {
            return !this.isView && (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50') && !this.nf.codpedv && this.nf.flagestoquebaixado != 'S' && this.nf.flagarmazenada != 'S';
        },

        editItem: function editItem() {
            return !this.isView && (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50');
        },

        nfAutorizada: function nfAutorizada() {
            return this.nf.stnf === '10';
        },

        nfAguardando: function nfAguardando() {
            return this.nf.emissaopropria === 'S' && (this.nf.stnf === '01' || this.nf.stnf === '50');
        },

        isView: function isView() {
            //nao possibilita edicao da nf quando status diferente de 00 (digitacao), 01 (pendente), 11 (lançada), 50 (rejeitada)
            if (this.view) return true;else {
                var stnfVal = this.nf.stnf ? String(this.nf.stnf).padStart(2, '0') : '';
                return stnfVal !== '00' && stnfVal !== '01' && stnfVal !== '11' && stnfVal !== '50' || this.nf.fin_baixado > 0 || this.nf.fin_remessa > 0;
            }
        },

        nfPossuiEvento: function nfPossuiEvento() {
            //checa se a nf possui evento
            var evento = false;

            evento = this.nf.nfxml && this.nf.nfxml.length > 0 && this.nf.nfxml[0].nprotcan;
            if (!evento) {
                evento = this.nf.nfev && this.nf.nfev.length > 0;
            }
            return evento;
        },

        selectedPart: function selectedPart() {
            return this.$store.getters.getPart;
        },

        parcelas: {
            // getter
            get: function get() {
                return this.nf.parcelas;
            },
            // setter
            set: function set(newValue) {
                this.nf.parcelas = newValue;
                this.calculaParcelas();
            }
        },

        stnf: function stnf() {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["getText"])(this.nf.stnf, this.metadata.nf.stnf);
        },

        title: function title() {
            return 'Nota Fiscal de Serviço ';
        },

        _codpart: function _codpart() {
            return this.nf.codpart;
        },

        codnates: function codnates() {
            return this.nf.codnates;
        },

        selectedNates: function selectedNates() {
            return this.$store.getters.getNates;
        },

        _nomeuf: function _nomeuf() {
            if (this.nf.part) {
                if (this.nf.part[0].nomeuf) {
                    return this.nf.part[0].nomeuf;
                } else if (this.nf.part[0].estado) {
                    return this.nf.part[0].estado[0].nomeuf;
                }
            }
        },

        _nomemun: function _nomemun() {
            if (this.nf.part) {
                if (this.nf.part[0].nomemun) {
                    return this.nf.part[0].nomemun;
                } else if (this.nf.part[0].mun) {
                    return this.nf.part[0].mun[0].nomemun;
                }
            }
        },
        _toticmsst: function _toticmsst() {
            return this.nf.toticmst + this.nf.totfcpst;
        },

        appLoja: function appLoja() {
            return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].appLoja;
        }

    },

    watch: {
        'nf.codfil': function nfCodfil() {
            this.isControleEstoqueAtivado(this.nf.codfil);
        },
        'nf.emissaopropria': function nfEmissaopropria() {
            if (this.nf.emissaopropria == 'S' && this.nf.operacaonf == 'E' && !this.nf.codnf) {
                this.nf.nf = null;
                this.nf.serie = null;
                this.nf.chave = null;
            }
        },
        'nf.totger': function nfTotger() {
            this.calculaParcelas();
        },

        _codpart: function _codpart(newValue, oldValue) {
            //CARREGA DADOS DO PARTICIPANTE QUANDO ALTERADO
            if (newValue != oldValue) {
                this.$store.dispatch('loadPart', { id: this.nf.codpart });
            }
        },

        selectedPart: function selectedPart() {
            //atualiza os dados do participante quando informado o codigo
            if (this.unwatch) {
                return;
            }
            this.nf.part = this.selectedPart;
            this.nf.finalidade = this.nf.part[0].tpcliente;
            if (this.nf.part[0].contricms == 'N') //evitar rejeição
                this.nf.finalidade = 'F';

            if (this.nf.part[0].codnates && this.nf.venda == 'S') this.nf.codnates = this.nf.part[0].codnates;

            if (this.nf.operacaonf === 'S' && this.nf.part[0].codnatfinrec && this.nf.venda == 'S') this.nf.codnatfin = this.nf.part[0].codnatfinrec;

            if (this.nf.operacaonf === 'E' && this.nf.part[0].codnatfindes) this.nf.codnatfin = this.nf.part[0].codnatfindes;
        },

        codnates: function codnates() {
            // if (this.unwatch) {
            //     return
            // }
            this.$store.dispatch('loadNates', { id: this.nf.codnates });
        },

        selectedNates: function selectedNates() {
            //HABILITA CAMPO DE NOTA REFERENCIADA CONFORME TIPO DE NATUREZA INFORMADA (DEVOLUCAO, AJUSTE, COMPLEMENTO)

            if (this.unwatch) {
                return;
            }
            this.nf.nates = this.selectedNates;
            this.nf.cfop = this.nf.nates.cfop;
        },

        codmenCpl: function codmenCpl() {
            if (this.codmenCpl) {
                this.loadInfCpl();
            }
        },

        codmenFisco: function codmenFisco() {
            if (this.codmenFisco) {
                this.loadInfAdFisco();
            }
        }

    },

    mixins: [__WEBPACK_IMPORTED_MODULE_10__api_api_nfe_js___default.a, __WEBPACK_IMPORTED_MODULE_10__api_api_nfe_js___default.a, __WEBPACK_IMPORTED_MODULE_11__api_api_nf_item_js___default.a],

    methods: {
        styleFontRed: function styleFontRed(opt) {
            var value = '';
            if (opt) {
                value = 'color:red; font-weight: bold;';
            }
            return value;
        },
        closeForm: function closeForm() {
            if (this.$route.params.id == 'novo') this.$router.go(-1);else this.$emit('closeform');
        },
        handleChangeValores: function handleChangeValores() {
            if (this.nf.stnf != '00' && this.nf.stnf != '01' && this.nf.stnf != '11' && this.nf.stnf != '50') return;

            this.nf.stnf = '00';
        },
        getParcelasFormapagParametrosFilial: function getParcelasFormapagParametrosFilial(codfil) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var parametros, filial;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (codfil) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return', '15');

                            case 2:
                                parametros = {};
                                _context.next = 5;
                                return _this.$store.dispatch('loadFilial', { id: codfil });

                            case 5:
                                if (_this.$store.getters.getFilial) {
                                    filial = _this.$store.getters.getFilial;

                                    if (filial.parametros) {
                                        parametros = JSON.parse(filial.parametros);
                                    }
                                }

                                if (!parametros) {
                                    _context.next = 10;
                                    break;
                                }

                                if (!parametros.parcelas) {
                                    _context.next = 10;
                                    break;
                                }

                                if (!parametros.parcelas.formapag) {
                                    _context.next = 10;
                                    break;
                                }

                                return _context.abrupt('return', parametros.parcelas.formapag);

                            case 10:
                                return _context.abrupt('return', '15');

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        closeNatesForm: function closeNatesForm(id) {
            //ao fechar o formulario de inclusao de naturezas
            if (id) this.nf.codnates = id;
            this.showNatesForm = false;
        },
        handleIncluirNates: function handleIncluirNates() {
            //exibe tela de cadastro da natureza
            this.showNatesForm = true;
        },
        loadInfCpl: function loadInfCpl() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this2.$store.dispatch('loadMennf', { id: _this2.codmenCpl });

                            case 2:
                                if (_this2.$store.getters.getMennf.texto) {
                                    if (_this2.nf.obs) {
                                        _this2.nf.obs = _this2.nf.obs + _this2.$store.getters.getMennf.texto;
                                    } else {
                                        _this2.nf.obs = _this2.$store.getters.getMennf.texto;
                                    }
                                }

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        loadInfAdFisco: function loadInfAdFisco() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this3.$store.dispatch('loadMennf', { id: _this3.codmenFisco });

                            case 2:
                                if (_this3.$store.getters.getMennf.texto) {
                                    if (_this3.nf.obsfisco) {
                                        _this3.nf.obsfisco = _this3.nf.obsfisco + _this3.$store.getters.getMennf.texto;
                                    } else {
                                        _this3.nf.obsfisco = _this3.$store.getters.getMennf.texto;
                                    }
                                }

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        data: function data(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["formatDate"])(value);
        },
        closeNumeroForm: function closeNumeroForm() {
            this.showNumeroForm = false;
        },
        handleUpdateNumero: function handleUpdateNumero() {
            //BOTAO ALTERAR NUMERO DA NOTA
            this.showNumeroForm = true;
        },
        handleAlterarOutras: function handleAlterarOutras() {
            this.formCab = true;
        },
        updateNumero: function updateNumero() {
            //EFETUA A ALTERACAO DA NUMERACAO DA NF E GRAVA A NF
            this.closeNumeroForm();
            this.nf.updatenumero = true;
            this.apiInvoice();
        },
        handleIncluirPart: function handleIncluirPart(transportadora) {
            //abre tela para inclusao de cliente ou transportadora
            this.crudPart = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI;
            this.transportadora = false;
            if (transportadora) {
                this.transportadora = true;
            }
            this.showPartForm = true;
        },
        handleAlterarPart: function handleAlterarPart(transportadora) {
            //abre tela de alteracao de participante (participante ou transportadora)
            this.crudPart = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudU;
            this.transportadora = false;
            if (transportadora) {
                this.codpart = this.nf.codparttr; //alteracao de transportadora
                this.transportadora = true;
            } else {
                this.codpart = this.nf.codpart; //alteracao de cliente
            }
            this.showPartForm = true;
        },
        closeCustomerForm: function closeCustomerForm(part) {
            //ao fechar o formulario de inclusao de participantes
            this.showPartForm = false;
            if (part) {
                //se um novo participante foi incluido
                if (this.transportadora) {
                    this.nf.parttr = part; //carrega a transportadora incluida
                    this.nf.codparttr = part[0].codpart;
                } else {
                    this.nf.part = part; //carrega o cliente incluido
                    this.nf.codpart = part[0].codpart;
                }
            }
        },
        handleActions: function handleActions(action) {
            //duplica a nota fiscal
            if (action == this.Actions.DUPLICA_NF) {}

            //enviar email
            if (action == this.Actions.ENVIAR_EMAIL) {
                this.handleFormEmailDanfe();
            }

            //imprimir danfe
            if (action == this.Actions.IMPRIMIR_DANFE) {
                this.imprimirDANFE();
            }

            //cancela a nota fiscal
            if (action == this.Actions.CANCELA_NF) {
                this.showCancel = true;
                this.$nextTick(function () {
                    this.$refs.obscan.focus();
                });
            }

            //exclui a nota fiscal
            if (action == this.Actions.EXCLUI_NF) {
                this.modalExcluir = true;
            }

            //download do xml
            if (action == this.Actions.DOWNLOAD_XML) {
                this.downloadXML();
            }

            //autorizacao
            if (action == this.Actions.AUTORIZA_NF) {
                this.nf.stnf = '01';
                this.apiInvoice(false, true);
            }

            if (action == this.Actions.SINCRONIZA_NF) {
                this.nf.stnf = '01';
                this.handleSincroniza();
            }
        },
        handleExcluir: function handleExcluir() {
            this.modalExcluir = false;
            this.apiInvoiceDelete();
        },
        closeModal: function closeModal() {
            this.modalExcluir = false;
        },
        handleCancel: function handleCancel() {
            //botao confirmacao de cancelamento da nf
            if (this.nf.obscan == null) {
                this.$erpToastError('Por favor preencha a justificativa para continuar');
                return;
            }
            if (String(this.nf.obscan).length < 15) {
                this.$erpToastError('O texto do cancelamento deve possuir no mínimo 15 caracteres');
                return;
            }
            if (String(this.nf.obscan).length > 255) {
                this.$erpToastError('O texto do cancelamento deve possuir no máximo 255 caracteres');
                return;
            }
            this.apiInvoiceCancel();
        },
        handleCancelDiscard: function handleCancelDiscard() {
            //botao descartar cancelamento da nf
            this.showCancel = false;
        },
        certificadoA3: function certificadoA3() {
            var tipo = this.$certificadoCheck(this.nf.codfil);
            if (this.esp == '59') {
                this.$erpToastError('A Pré NOTA não pode ser visualizada no modelo SAT.');
                return false;
            } else if (tipo == 'A3') {
                this.$erpToastError('A Pré NOTA só pode ser visualizada com certificado A1.');
                return false;
            } else if (tipo == 'A1') {
                return true;
            } else {
                return false;
            }
        },
        handleIncluir: function handleIncluir() {
            var _this4 = this;

            //INCLUIR NOVA NOTA FISCAL (APOS INFORMAR PARTICIPANTE E NATUREZA)
            // if (this.nf.codpart == null || this.nf.codnates == null || this.nf.cfop == null) {
            //     this.$erpToastError('Por favor preencha os campos para continuar')
            //     return
            // }

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this4.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    var isValidCabec = true;
                    if (_this4.nf.operacaonf === 'E' && _this4.nf.emissaopropria === 'N' && (!_this4.nf.nf || _this4.nf.nf == '0' || !_this4.nf.serie)) {
                        _this4.$erpToastError('Informe a série e número da NF.');
                        isValidCabec = false;
                    }
                    if (_this4.nf.nates && _this4.nf.nates.stnates == 'I') {
                        _this4.$erpToastError('A Natureza de saída informada está inativa');
                        isValidCabec = false;
                    }
                    if (_this4.nf.operacaonf === 'S' && _this4.nf.venda === 'S' && _this4.nf.part[0].stcred != 'L') {
                        _this4.$erpToastError('Cliente com crédito bloqueado. Operação não permitida.');
                        isValidCabec = false;
                    }
                    if (_this4.nf.part[0].stpart == 'I') {
                        _this4.$erpToastError('Participante inativo. Operação não permitida.');
                        isValidCabec = false;
                    }
                    if (isValidCabec) {
                        _this4.apiInvoice();
                    }
                }
            });

            // if (!this.validacaoInicial()) {
            //     return
            // }
        },
        handleRetorna: function handleRetorna() {
            //botao retornar
            //fecha a inclusao da nf
            //volta para lista de pedido ou para lista de nf
            if (this.$route.params && this.$route.params.id == 'novo') this.$router.go(-1);else if (this.$route.query.tipo == 'devolucao') this.$router.go(-1);else if (this.$route.query.tipo == 'view') this.$router.go(-1);else if (this.codpedv) {
                if (!this.appLoja) {
                    this.$router.push('/pedidolist'); //retorna para a lista de pedido quando for faturamento de pedido
                } else {
                    this.$router.push('/fv/pedidos'); //retorna para a lista de pedido quando for faturamento de pedido
                }
            } else this.$emit('closeform');
        },
        calculaParcelas: function calculaParcelas() {
            var _this5 = this;

            if (this.unwatch) return;

            if (this.nf.operacaonf == 'E' && this.selectedNates && this.selectedNates.calcdup == 'S' && this.nf.totger > 0 && this.nf.parcelas == null) {
                this.nf.parcelas = 0;
            }

            this.nfpar = [];
            var vlr = 0;
            var soma = 0;
            if (this.nf.parcelas == '0') {
                var parcela = _extends({}, this.$store.getters.getEntities.nfpar);
                parcela.dtv = this.nf.data;
                parcela.vlr = this.nf.totger;
                parcela.obspar = '';
                parcela.error = null;
                parcela.dias = 0;
                this.getParcelasFormapagParametrosFilial(this.nf.codfil).then(function (v) {
                    parcela.formapag = v;
                });

                if (parcela.formapag == null) {
                    parcela.formapag = "15";
                }

                this.nfpar.push(parcela);
            } else {
                var _loop = function _loop() {
                    var parcela = _extends({}, _this5.$store.getters.getEntities.nfpar);
                    parcela.dtv = _this5.$addMonths(_this5.nf.data, x);
                    parcela.dias = x * 30;
                    vlr = _this5.nf.totger;
                    vlr = Object(__WEBPACK_IMPORTED_MODULE_2__shared_numbers__["arr"])(vlr / _this5.nf.parcelas, 2, true);
                    parcela.vlr = vlr;
                    soma = Number(soma) + Number(vlr);
                    soma = Number(soma.toFixed(2));

                    if (x == _this5.nf.parcelas) {
                        if (soma > _this5.nf.totger) {
                            parcela.vlr = parcela.vlr - (soma - _this5.nf.totger);
                        } else if (soma < _this5.nf.totger) {
                            parcela.vlr = Number(parcela.vlr) + (Number(_this5.nf.totger) - Number(soma));
                        }
                    }

                    parcela.error = null;
                    parcela.obspar = '';
                    _this5.getParcelasFormapagParametrosFilial(_this5.nf.codfil).then(function (v) {
                        parcela.formapag = v;
                    });

                    if (parcela.formapag == null) {
                        parcela.formapag = "15";
                    }

                    _this5.nfpar.push(parcela);
                };

                for (var x = 1; x <= this.nf.parcelas; x++) {
                    _loop();
                }
            }
        },
        handleAutoriza: function handleAutoriza() {
            var _this6 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                //envia nf para autorizacao
                                //this.nf.stnf = ''
                                if (_this6.nf.filial[0].cnpj == '11111111111111') {
                                    _this6.$erpToastError('Em período de trial não é possível autorizar.');
                                } else {
                                    _this6.nf.xmotivo = '';
                                    _this6.$scrollTo(0);

                                    if (_this6.nf.tpnf == 'S') {
                                        _this6.autorizaNFSe(_this6.nf, _this6.NFSeResponseCallback);
                                    } else {
                                        _this6.$erpToastError('Nota fiscal deve ser do tipo serviço.');
                                    }
                                }

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6);
            }))();
        },
        handleSincroniza: function handleSincroniza() {
            var _this7 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (_this7.nf.filial[0].cnpj == '11111111111111') {
                                    _this7.$erpToastError('Em período de trial não é possível sincronizar.');
                                } else {
                                    _this7.nf.xmotivo = '';
                                    _this7.$scrollTo(0);

                                    if (_this7.nf.tpnf == 'S') {
                                        _this7.sincronizaNFSe(_this7.nf, _this7.NFSeResponseCallback);
                                    } else {
                                        _this7.$erpToastError('Nota fiscal deve ser do tipo serviço.');
                                    }
                                }

                            case 1:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this7);
            }))();
        },
        NFSeResponseCallback: function NFSeResponseCallback(response) {
            this.errmessages = {};
            this.codnf = this.nf.codnf;
            this.loadData();
        },
        possuiNForigem: function possuiNForigem() {
            for (var i = 0; i < this.nfref.length; i++) {
                if (this.nfref[i].codnfref != null) {
                    return true;
                }
            }
            return false;
        },
        handleTotalizar: function handleTotalizar(close) {
            //grava a nota fiscal

            if (this.nfit.length == 0) {
                this.$erpToastError('Erro: Itens não informados.');
                return;
            }

            if (this.nf.venda === 'S' && this.nf.emissaopropria === 'S' && this.nf.parcelas == null) {
                this.$nextTick(function () {
                    this.$refs.parcelas.focus();
                });
                this.$erpToastError('Informe a condição de pagamento');
                return;
            }

            if (this.nf.emissaopropria === 'S' && !this.nf.tpfrete) {
                this.$nextTick(function () {
                    this.$refs.tpfrete.focus();
                });
                this.$erpToastError('Informe a modalidade do frete');
                return;
            }

            if (this.nf.emissaopropria == 'N') this.nf.stnf = '11';else this.nf.stnf = '01';

            this.apiInvoice(close);
        },
        handleEditar: function handleEditar() {
            var _this8 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                //edita a nota fiscal de entrada (somente para nota fiscal importada por xml)
                                modulo = 'invoice/edit/' + _this8.nf.codnf;
                                _context6.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this8.$store, modulo, {}, 'post');

                            case 3:
                                data = _context6.sent;

                                if (data.errmessages) {
                                    _this8.$erpToastError(data.errmessages[0]);
                                } else {
                                    //RETORNA PARA A LISTA DA NOTA COM EVENTO DE EDICAO ONDE SERÁ ABERTA A TELA DE EDICAO DA NF DE ENTRADA
                                    _this8.$emit('edit', _this8.nf.codnf, _this8.nf.importxml == 'S');
                                    //    this.nf.stnf = '00'
                                    //    this.view = false
                                }

                            case 5:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this8);
            }))();
        },
        handleFaturar: function handleFaturar() {
            var _this9 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                //fatura o pedido de venda
                                modulo = 'invoice/order/' + _this9.codpedv;
                                _context7.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this9.$store, modulo, {}, 'post');

                            case 3:
                                data = _context7.sent;

                                if (data.codnf) {
                                    _this9.codnf = data.codnf;
                                    _this9.loadData();
                                }

                            case 5:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this9);
            }))();
        },
        handleSalvarDadosAdicionais: function handleSalvarDadosAdicionais() {
            var _this10 = this;

            //botao salvar dados do cabecalho da nf
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this10.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this10.nf.stnf = '00'; //obriga que o usuário totalize a nota novamente
                    _this10.apiInvoice();
                    _this10.closeFormCab();
                }
            });
        },
        closeFormCab: function closeFormCab() {
            this.formCab = false;
        },
        apiInvoice: function apiInvoice(close, autorizacao) {
            var _this11 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var nfit, sendData, metodo, update, modulo, data;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (_this11.handleValidaParcelas()) {
                                    _context8.next = 3;
                                    break;
                                }

                                _this11.$erpToastError('Erro: Parcelas com datas não permitidas.');
                                return _context8.abrupt('return');

                            case 3:

                                //efetua a gravacao da nota fiscal
                                nfit = [];

                                nfit = _this11.nfit;
                                _this11.nf.nfit = nfit;
                                _this11.nf.nfpar = _this11.nfpar;
                                _this11.nf.nfref = _this11.nfref;
                                _this11.nf.tpnf = 'S';
                                sendData = {};

                                sendData.nf = _extends({}, _this11.nf);
                                if (autorizacao) sendData.autorizaenvio = true;

                                metodo = 'post';
                                update = false;

                                if (_this11.nf.codnf != null) {
                                    update = true;
                                }

                                modulo = 'invoice/nf/';
                                _context8.next = 18;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this11.$store, modulo, sendData, metodo);

                            case 18:
                                data = _context8.sent;

                                if (!data.items) {
                                    _context8.next = 37;
                                    break;
                                }

                                _this11.nf = data.items[0];
                                _this11.nf.nates = _this11.nf.nates[0];
                                _this11.nfit = _this11.nf.nfit;
                                _this11.nfref = _this11.nf.nfref;
                                _this11.nfpar = _this11.nf.nfpar;

                                if (!_this11.nfErro()) {
                                    _context8.next = 31;
                                    break;
                                }

                                _this11.$scrollTo(0);
                                _this11.$erpToastError('Por favor corrija os erros de validação');
                                return _context8.abrupt('return', false);

                            case 31:
                                if (!update) {
                                    _context8.next = 36;
                                    break;
                                }

                                _this11.$erpToastSuccess('Nota fiscal gravada com sucesso');

                                if (!close) {
                                    _context8.next = 36;
                                    break;
                                }

                                _this11.handleRetorna();
                                return _context8.abrupt('return');

                            case 36:
                                _this11.errmessages = [];

                            case 37:
                                _this11.updateActions();

                                if (_this11.formIncluir && _this11.notaFiscalDemo) _this11.incluiProdutoNotaFiscalDemo();

                                _this11.formIncluir = false;
                                _this11.formNF = true;

                                if (autorizacao) _this11.handleAutoriza();

                            case 42:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this11);
            }))();
        },
        nfErro: function nfErro() {
            if (!this.nf.validation) return false;
            var validation = JSON.parse(this.nf.validation);
            if (validation.errmessages) {
                this.errmessages = validation;
                return true;
            } else return false;
        },
        apiInvoiceDelete: function apiInvoiceDelete() {
            var _this12 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var modulo;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                //exclui a nota fiscal
                                modulo = 'invoice/nf/' + _this12.nf.codnf;
                                _context9.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSdelete"])(_this12.$store, modulo);

                            case 3:
                                _this12.$erpToastSuccess('A Nota fiscal foi excluída com sucesso.');
                                _this12.handleRetorna();

                            case 5:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this12);
            }))();
        },
        apiInvoiceCancel: function apiInvoiceCancel() {
            var _this13 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var sendData, modulo, data;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                //cancela a nota fiscal
                                _this13.errCorrecao = [];

                                sendData = {};

                                sendData = { codnf: _this13.nf.codnf, codfil: _this13.nf.codfil, just: _this13.nf.obscan };

                                _this13.showCancel = false;
                                _this13.$appLoading(true);
                                modulo = 'invoice/cancel/';
                                _context10.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this13.$store, modulo, sendData, 'post');

                            case 8:
                                data = _context10.sent;

                                if (!data.errmessages) {
                                    _context10.next = 18;
                                    break;
                                }

                                _this13.$appLoading(false);
                                _this13.showCancel = true;
                                _this13.errCorrecao = data.errmessages;
                                _this13.$erpToastError('A nota fiscal não foi cancelada');
                                _this13.loadData();
                                return _context10.abrupt('return');

                            case 18:
                                _this13.$appLoading(false);
                                _this13.$erpToastSuccess('Nota fiscal cancelada com sucesso.');
                                _this13.loadData();

                            case 21:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this13);
            }))();
        },
        CancelResponseCallback: function CancelResponseCallback(response) {
            //CALLBACK QUANDO O CANCELAMENTO É ENVIADO POR CERTIFICADO A3
            this.$appLoading(false);
            this.errmessages = [];
            if (response.status != 'success') {
                this.$erpToastError(response.message);
            } else {
                this.showCancel = false;
                this.$erpToastSuccess('Nota fiscal cancelada com sucesso.');
                this.loadData();
            }
        },
        apiItens: function apiItens(nfIt, deleteItem) {
            var _this14 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var sendData, metodo, modulo, data;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                //efetua a gravacao dos itens do pedido
                                _this14.nf.tpnf = 'S';
                                sendData = { nf: _this14.nf };

                                if (nfIt.length) {
                                    sendData.nf.nfit = nfIt;
                                } else {
                                    sendData.nf.nfit = [];
                                    sendData.nf.nfit.push(nfIt);
                                }

                                metodo = 'post';
                                modulo = 'invoice/nfit/';

                                if (deleteItem) {
                                    modulo = modulo + 'delete/';
                                }

                                _context11.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this14.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context11.sent;

                                if (deleteItem) {
                                    _this14.codnf = _this14.nf.codnf;
                                    _this14.loadData();
                                    _this14.$erpToastSuccess('O produto foi excluído.');
                                } else if (data.items) {
                                    _this14.nf = data.items[0];
                                    _this14.nf.nates = _this14.selectedNates;
                                    _this14.nfit = data.items[0].nfit;
                                    //   this.$erpToastSuccess('Item gravado com sucesso.')
                                    if (_this14.nfErro()) {} else {
                                        _this14.errmessages = [];
                                    }
                                }

                                _this14.updateItem = false;

                            case 11:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, _this14);
            }))();
        },
        handleDeleteItemMsg: function handleDeleteItemMsg(index) {
            //EXCLUI O ITEM DO PEDIDO
            this.nfit_delete = this.nfit[index];
            this.DELETE_ITEM_MESSAGE = true;
        },
        handleDeleteItem: function handleDeleteItem() {
            //remove o item do pedido
            this.DELETE_ITEM_MESSAGE = false;
            var item = [];
            item.push(this.nfit_delete);
            this.apiItens(item, true);
        },
        closeFormItem: function closeFormItem() {
            //fecha tela de inclusao de item
            this.showFormItem = false;
            this.formNF = true;
        },
        saveItem: function saveItem(nfit) {
            //fecha tela de alteracao de item e envia para o servidor
            this.activeTab = 0;
            this.showFormItem = false;
            this.formNF = true;
            this.apiItens(nfit);
            this.$nextTick(function () {
                if (this.$refs.incluirProduto) {
                    this.$refs.incluirProduto.focus();
                }
            });
        },
        handleIncluirItem: function handleIncluirItem(nSeq, view) {
            //incluir item na nf
            this.nfit_update = _extends({}, this.$store.getters.getEntities.nfit);
            this.nfit_update.finalidade = this.nf.finalidade;
            this.nfit_update.codnf = this.nf.codnf;
            this.nfit_update.pcredsn = this.nf.pcredsn;
            //ajusta os parametros para chamada da tela de item da nf
            this.paramItem = {
                nf: this.nf,
                nfsaida: this.nf.operacaonf == 'S',
                nfit: this.nfit_update,
                nfImportacao: this.nfImportacao,
                nfAjuste: this.nf.tpnf == 'A',
                nfComplementar: this.nf.tpnf == 'P',
                habilitaItem: (this.nfOutrasNotas || this.nfVendaLivre) && this.nf.flagestoquebaixado != 'S' && this.nf.flagarmazenada != 'S',
                optSimples: this.nf.filial[0].crt == '1' || this.nf.filial[0].crt == '4',
                difal: this.selectedPart.uf != this.nf.filial[0].uf && this.nf.finalidade == 'F' && this.nf.venda == 'S',
                ipidevol: this.nf.nates && this.nf.nates.ipidevol ? this.nf.nates.ipidevol == 'S' : false
                //
            };this.formItemView = false; //indica se é alteração ou somente visualizacao
            this.updateItem = false;
            this.showFormItem = true;
        },
        handleEditItem: function handleEditItem(nSeq, view) {
            //editar o item da nf
            this.nfit_update = {};

            //localiza o item para alteracao atraves da sequencia
            for (var x = 0; x < this.nfit.length; x++) {
                if (this.nfit[x].itnf == nSeq) {
                    this.nfit_update = _extends({}, this.nfit[x]);
                }
            }
            //ajusta os parametros para chamada da tela de item da nf
            this.paramItem = {
                nf: this.nf,
                nfsaida: this.nf.operacaonf == 'S',
                nfit: this.nfit_update,
                nfImportacao: this.nfImportacao,
                nfAjuste: this.nf.tpnf == 'A',
                nfComplementar: this.nf.tpnf == 'P',
                habilitaItem: (this.nfOutrasNotas || this.nfVendaLivre) && this.nf.flagestoquebaixado != 'S' && this.nf.flagarmazenada != 'S',
                optSimples: this.nf.filial[0].crt == '1' || this.nf.filial[0].crt == '4',
                difal: this.selectedPart.uf != this.nf.filial[0].uf && this.nf.finalidade == 'F' && this.nf.venda == 'S',
                isView: view,
                ipidevol: this.nf.nates && this.nf.nates.ipidevol ? this.nf.nates.ipidevol == 'S' : false
                //
            };this.formItemView = view; //indica se é alteração ou somente visualizacao
            this.updateItem = true;
            this.showFormItem = true;
        },
        handleCloseMessage: function handleCloseMessage() {
            this.CANCEL_ITEM_MESSAGE = false;
            this.DELETE_ITEM_MESSAGE = false;
        },
        updateActions: function updateActions() {
            this.moreActions = [];
            var act = {};
            if (this.nf.emissaopropria != 'S' && this.nf.stnf >= '11') {
                act = { action: this.Actions.EXCLUI_NF, label: 'Excluir NF' };
                this.moreActions.push(act);
            }
            if (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50') {
                act = { action: this.Actions.EXCLUI_NF, label: 'Excluir NF' };
                this.moreActions.push(act);
            }

            if (this.nf.impxml == 'S' && this.nf.stnf >= '11') {
                act = { action: this.Actions.DOWNLOAD_XML, label: 'Download do XML' };
                this.moreActions.push(act);
            }
            if (this.nf.emissaopropria == 'S' && this.nf.stnf == '11') {
                act = { action: this.Actions.DOWNLOAD_XML, label: 'Download do XML' };
                this.moreActions.push(act);
                act = { action: this.Actions.CANCELA_NF, label: 'Cancelar NFS-e' };
                this.moreActions.push(act);
            }
            if (this.nf.emissaopropria == 'S' && this.nf.stnf == '10') {
                act = { action: this.Actions.IMPRIMIR_DANFE, label: 'Emitir PDF' };
                this.moreActions.push(act);
                act = { action: this.Actions.ENVIAR_EMAIL, label: 'Enviar Email PDF' };
                this.moreActions.push(act);
                act = { action: 0, label: '' };
                this.moreActions.push(act);
                act = { action: this.Actions.CANCELA_NF, label: 'Cancelar NFS-e' };
                this.moreActions.push(act);
            }
            if (this.nf.emissaopropria == 'S' && this.nf.stnf == '01') {
                act = { action: this.Actions.AUTORIZA_NF, label: 'Autorizar NF-e' };
                this.moreActions.push(act);

                act = { action: 0, label: '' };
                this.moreActions.push(act);
            }
            if (this.nf.stnf == '02' || this.nf.stnf >= '10') {
                act = { action: this.Actions.SINCRONIZA_NF, label: 'Sincronizar NF-e' };
                this.moreActions.push(act);
            }
        },
        imprimirDANFE: function imprimirDANFE() {
            //impressao da danfe em PDF
            var vm = this;
            Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiDownloadPDF"])(this, 'nfse/pdf/' + this.nf.codnf);
        },
        downloadXML: function downloadXML() {
            //visualizacao do XML da NFE
            var data = { codnf: this.nf.codnf, chave: this.nf.chave, tipo: 'NFE' };
            Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiDownload"])(this, 'print/xmlnfe/', data, 'post');
        },
        handleFormEmailDanfe: function handleFormEmailDanfe() {
            //Abre a tela para envio de email
            //carrega o template da mensagem antes do envio (ords/webdata/template/danfe/:id)
            this.showFormEmail = true;
        },
        closeFormEmail: function closeFormEmail() {
            this.showFormEmail = false;
        },
        handleSendEmail: function handleSendEmail(data) {
            var _this15 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var sendData;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                //cahamda para envio de email da danfe
                                _this15.closeFormEmail();
                                sendData = data;

                                sendData.codnf = _this15.nf.codnf;
                                sendData.chave = _this15.nf.chave;
                                sendData.tipo = 'DANFE';
                                _context12.next = 7;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiEmailPDF"])(_this15, 'danfe/', sendData);

                            case 7:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, _this15);
            }))();
        },
        updateCepEnt: function updateCepEnt() {
            //CARREGA INFORMACOES DO CEP DE ENTREGA
            this.nf.endeent = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.logradouro;
            this.nf.bairroent = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.bairro;
            this.nf.codmunent = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.ibge;
            this.nf.ufent = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.uf;
            if (this.nf.ufent && this.nf.ufent != 'EX') this.nf.codpaisent = '1058';
        },
        updateCepRet: function updateCepRet() {
            //CARREGA INFORMACOES DO CEP DE RETIRADA
            this.nf.enderet = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.logradouro;
            this.nf.bairroret = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.bairro;
            this.nf.codmunret = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.ibge;
            this.nf.ufret = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.uf;
            if (this.nf.ufret && this.nf.ufret != 'EX') this.nf.codpaisret = '1058';
        },
        handleEnderecoEntrega: function handleEnderecoEntrega() {
            this.enderecoEntrega = true;
        },
        handleEnderecoRetirada: function handleEnderecoRetirada() {
            this.enderecoRetirada = true;
        },
        handleExcluirEndereco: function handleExcluirEndereco(tipo) {
            //limpa o endereco de entrega ou retirada
            if (tipo == 'ent') {
                this.enderecoEntrega = false;
                this.nf.tppessoaent = null;
                this.nf.cnpjcpfent = null;
                this.nf.cepent = null;
                this.nf.endeent = null;
                this.nf.endenrent = null;
                this.nf.endecompent = null;
                this.nf.bairroent = null;
                this.nf.codmunent = null;
                this.nf.ufent = null;
            } else {
                this.enderecoRetirada = false;
                this.nf.tppessoaret = null;
                this.nf.cnpjcpfret = null;
                this.nf.cepret = null;
                this.nf.enderet = null;
                this.nf.endenrret = null;
                this.nf.endecompret = null;
                this.nf.bairroret = null;
                this.nf.codmunret = null;
                this.nf.ufret = null;
            }
        },
        loadData: function loadData() {
            var _this16 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:

                                _this16.unwatch = true;
                                //carrega a nf para alteracao ou visualizacao
                                _context13.next = 3;
                                return _this16.$store.dispatch('loadNf', { id: _this16.codnf });

                            case 3:
                                if (_this16.$store.getters.getNf) {
                                    _this16.nf = _extends({}, _this16.$store.getters.getNf[0]);
                                    _this16.nfit = _this16.nf.nfit;
                                    if (_this16.nf.parcelas || _this16.nf.parcelas == 0) {
                                        _this16.parcelas = _this16.nf.parcelas;
                                    }
                                    if (_this16.nf.nfpar) {
                                        _this16.nfpar = _this16.nf.nfpar;
                                    }
                                    if (_this16.nf.nfref) {
                                        _this16.nfref = _this16.nf.nfref;
                                    }
                                    if (_this16.nfErro()) {} else {
                                        _this16.errmessages = [];
                                    }
                                    _this16.moreActions = [];
                                    _this16.updateActions();
                                }
                                _this16.nfOutrasNotas = _this16.nf.operacaonf == 'E' || _this16.nf.venda != 'S';
                                _this16.nfVendaLivre = _this16.nf.venda && (_this16.nfit.length == 0 || !_this16.nfit.codpedv);
                                _this16.enderecoEntrega = _this16.nf.cepent != null;
                                _this16.enderecoRetirada = _this16.nf.cepret != null;

                                _this16.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                    this.unwatch = false;
                                });

                            case 9:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, _this16);
            }))();
        },
        changeTab: function changeTab(idx) {
            //mudança de pagina
            this._nf = this.nf;
            this.activeTab = idx;
        },
        handleValidaParcelas: function handleValidaParcelas() {
            var isValid = true;
            for (var x = 0; x <= this.nfpar.length - 1; x++) {
                if (x > 0 && this.nfpar[x].dias <= this.nfpar[x - 1].dias) {
                    this.nfpar[x].error = 'Vencimento deve ser superior ao da parcela anterior';
                    isValid = false;
                    //   this.$set(this.nfpar[x], 'error', 'Vencimento deve ser superior ao da parcela anterior')
                } else this.nfpar[x].error = null;
            }
            return isValid;
        },
        nfparDiasChange: function nfparDiasChange(index) {
            //evento de controle de alteracao do nr de dias de vencimento da parcela
            this.nfpar[index].dtv = this.$addDays(this.nf.data, this.nfpar[index].dias);
            this.handleValidaParcelas();
        },
        nfparDtvChange: function nfparDtvChange(index) {
            //recalcula o nr de dias ao alterar a data
            this.nfpar[index].dias = this.$daysBetween(this.nf.data, this.nfpar[index].dtv);
            this.handleValidaParcelas();
        },
        nfparVlrChange: function nfparVlrChange(index) {
            //evento de controle de alteracao do valor da parcela
            //quando usuario alterar o valor de uma parcela, refaz as demais parcelas
            if (this.nf.parcelas <= 1) {
                return;
            }
            var vlrparcial = 0;
            var vlrnovaparcela = 0;
            for (var x = 0; x <= index; x++) {
                vlrparcial = vlrparcial + parseFloat(this.nfpar[x].vlr);
            }
            if (vlrparcial < this.nf.totger) {
                vlrnovaparcela = (this.nf.totger - vlrparcial) / (this.nf.parcelas - (index + 1));
                vlrnovaparcela.toFixed(2);
            } else {}
            for (var x = index + 1; x <= this.nfpar.length - 1; x++) {
                this.nfpar[x].vlr = vlrnovaparcela;
            }
        },
        incluiNotaFiscalDemo: function incluiNotaFiscalDemo() {
            var _this17 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
                var self;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                //ROTINA QUE INCLUI UMA NOTA FISCAL DEMONSTRACAO COM 1 PRODUTO DE DEMONSTRACAO
                                //ACESSO ATRAVÉS DO GUIA DA NFE
                                self = _this17;

                                Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDS"])(_this17.$store.getters.urlOrds + 'cg/dadosdemonstracao', null, true).then(function (result) {
                                    if (result.codpart && result.coditem) {
                                        self.dadosNotaFiscalDemo = result;
                                        self.nf.codpart = result.codpart;
                                        self.notaFiscalDemo = true;
                                    }
                                });

                            case 2:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, _this17);
            }))();
        },
        incluiProdutoNotaFiscalDemo: function incluiProdutoNotaFiscalDemo() {
            var _this18 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                //INCLUI UM PRODUTO DEMO NA NOTA FISCAL
                                _this18.nfit_update = _extends({}, _this18.$store.getters.getEntities.nfit);
                                _this18.nfit_update.finalidade = _this18.nf.finalidade;
                                _this18.nfit_update.codnf = _this18.nf.codnf;
                                _this18.nfit_update.pcredsn = _this18.nf.pcredsn;

                                _this18.nfit_update.coditem = _this18.dadosNotaFiscalDemo.coditem; //296

                                _context15.next = 7;
                                return _this18.apiCarregaProduto(_this18.nfit_update);

                            case 7:
                                _this18.nfit_update.qt = 1;
                                _this18.nfit_update.vlr = 100;
                                _this18.apiItens(_this18.nfit_update);

                                _this18.$nextTick(function () {
                                    if (this.$refs.incluirProduto) {
                                        this.$refs.incluirProduto.focus();
                                    }
                                });

                            case 11:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, _this18);
            }))();
        }
    },

    mounted: function mounted() {
        var _this19 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
            return regeneratorRuntime.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            if (_this19.formIncluir) {

                                _this19.$nextTick(function () {
                                    if (this.$refs.organizacao) this.$refs.organizacao.focus();
                                });
                            }

                        case 1:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, _this19);
        }))();
    },
    created: function created() {
        this.metadata.nf.parcelas.options.sort(function (a, b) {
            return Number(a.id) > Number(b.id) ? 1 : Number(b.id) > Number(a.id) ? -1 : 0;
        });
        this.metadata.nf.codnates.validator.required = false;
        this.metadata.nf.cfop.validator.required = false;
        this.metadata.nf.dtsai.label = "Data Prestação Serviço";
        this.metadata.nf.totmer.label = "Valor Total dos Serviços";

        this.ambienteHomologacaoNFe(); //api-nfe

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        //this.crudText = this.$crudText(this.crud)

        this.formIncluir = this.crud == __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI;
        var operacao = 'S';

        if (this.params) {
            //THIS.PARAMS QUANDO A CHAMADA É FEITA PELA LISTA DE NOTAS
            operacao = this.params.operacaoNf;
            this.nfVendaLivre = this.params.vendaLivre;
            if (!this.nfVendaLivre) this.nfOutrasNotas = this.params.outrasSaidas;
        } else if (this.$route.params && this.$route.params.id == 'novo') {
            //inclusao de nota pelo guianfe ou pelo painel de nfe
            this.formIncluir = true;
            if (this.$route.query.tipo == 'outras') this.nfOutrasNotas = true;else if (this.$route.query.tipo == 'entrada') {
                this.nfOutrasNotas = true;
                operacao = 'E';
            } else if (this.$route.query.tipo == 'servico') {
                operacao = 'C';
                this.nfVendaLivre = false;
            } else this.nfVendaLivre = true;
        } else if (this.$route.params && this.$route.params.id) {
            if (this.$route.query.tipo == 'view') {
                this.codnf = this.$route.params.id;
            } else if (this.$route.query.tipo == 'devolucao') {
                this.codnf = this.$route.params.id;
            } else {
                //faturamento de pedido de venda
                this.codpedv = this.$route.params.id;
                this.handleFaturar(); //fatura o pedido
                this.formNF = true;
            }
        }

        if (this.formIncluir) {
            //se for uma inclusao
            this.unwatch = false;
            this.nf.emissaopropria = 'S';
            this.nf.operacaonf = 'S';
            this.nf.tpnf = 'S';
            this.nf.tpfrete = '9';
            this.nfOutrasNotas = true;
        } else {
            //carrega a nf para alteracao/visualizacao
            if (!this.codnf) this.codnf = this.params.codnf;
            this.loadData();
            this.view = this.crud == __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudView;
            this.formNF = true;
        }

        if (this.$route.query.tipo == 'demo') this.incluiNotaFiscalDemo();

        this.$scrollTo(0);
    }
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_nf_item_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_nf_item_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__api_api_nf_item_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__item_form__ = __webpack_require__(89);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params: {} //nfit: objeto, optSimples: false, nfAjuste: false, nfComplemento: false, habilitaItem: true
  },

  components: {
    ItemForm: __WEBPACK_IMPORTED_MODULE_2__item_form__["default"]
  },

  data: function data() {
    return {
      nfit: {},
      //metadata: this.$store.getters.getEntities.metadata,
      local_metadata: _extends({}, this.$store.getters.getEntities.metadata.nfit),
      tributadoIcm: false,
      informaMotdes: false,
      icmDiferido: false,
      tributadoPis: false, //habilita pis
      informaFCI: false, //habilita nr do fci conforme origem da mercadoria
      pautaPis: false,
      tributadoCofins: false,
      pautaCofins: false,
      tributadoPisST: false,
      tributadoCofinsST: false,
      creditoSN: false, //habilita % credito icms simples nacional
      unWatch: false,
      descricaoNovoItem: '',

      errmessages: [],
      crud: '',
      showItemForm: false
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_1__api_api_nf_item_js___default.a],

  computed: {
    isView: function isView() {
      return this.params.isView == true;
    },
    coditem: function coditem() {
      return this.nfit.coditem;
    },
    selectedItem: function selectedItem() {
      return this.$store.getters.getItem;
    },
    itemTaxes: function itemTaxes() {
      return this.$store.getters.getItemTaxes;
    },
    sticm: function sticm() {
      return this.nfit.sticm;
    },
    stipi: function stipi() {
      return this.nfit.stipi;
    },
    stpis: function stpis() {
      return this.nfit.stpis;
    },
    stcofins: function stcofins() {
      return this.nfit.stcofins;
    },
    csosn: function csosn() {
      return this.nfit.csosn;
    },
    sticmentrada: function sticmentrada() {
      return this.nfit.sticmentrada;
    },
    orimerc: function orimerc() {
      return this.nfit.orimerc;
    },

    nfImportacao: function nfImportacao() {
      return this.params.nfImportacao;
    }

    // tributadoIcmST () {
    //     return (this.nfit.sticm == '10' || this.nfit.sticm == '30' || this.nfit.sticm == '70' || this.nfit.sticm == '90')
    // }

  },

  methods: {
    handleCadastroItem: function handleCadastroItem(text) {
      //abre tela para cadastro de novo produto
      this.crud = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI;
      this.descricaoNovoItem = text;
      this.showItemForm = true;
    },
    closeItemForm: function closeItemForm(item) {
      //ao fechar o formulario de cadastro de produto
      this.showItemForm = false;
      if (item) {
        this.nfit.coditem = item.coditem;
      }
    },
    handleNewItem: function handleNewItem(selectedItem) {
      if (!selectedItem) return;
      this.nfit.coditem = selectedItem.coditem;
    },
    handleSalvar: function handleSalvar() {
      //botao salvar item
      var param = [];
      param.push(this.nfit);
      this.$emit('save', param);
    },
    closeForm: function closeForm() {
      this.$emit('closeform');
    },
    handleValidation: function handleValidation() {
      this.errmessages = [];

      this.$validator.reset();

      //VALIDACAO DOS CAMPOS DE IMPOSTOS CONFORME SITUACAO TRIBUTARIA DE CADA IMPOSTO
      this.local_metadata.aicm.validator = {};
      this.local_metadata.ricm.validator = {};
      this.local_metadata.aicmst.validator = {};
      this.local_metadata.bcicm.validator = {};
      this.local_metadata.vicm.validator = {};
      this.local_metadata.bcicmst.validator = {};
      this.local_metadata.vicm.validator = {};
      this.local_metadata.aipi.validator = {};
      this.local_metadata.ripi.validator = {};
      this.local_metadata.vipi.validator = {};
      this.local_metadata.bcipi.validator = {};
      this.local_metadata.apis.validator = {};
      this.local_metadata.rpis.validator = {};
      this.local_metadata.apisst.validator = {};
      this.local_metadata.vpis.validator = {};
      this.local_metadata.bcpis.validator = {};
      this.local_metadata.acofins.validator = {};
      this.local_metadata.rcofins.validator = {};
      this.local_metadata.acofinsst.validator = {};
      this.local_metadata.vcofins.validator = {};
      this.local_metadata.bccofins.validator = {};

      if (this.params.nfAjuste || this.params.nfComplementar) {
        this.local_metadata.ncm.validator = {};
      }

      if (this.tributadoPis) {
        if (this.params.nfAjuste || this.params.nfComplementar) {
          this.local_metadata.apis.validator = { required: true, "valida-zero": true };
          this.local_metadata.bcpis.validator = { required: true, "valida-zero": true };
          this.local_metadata.vpis.validator = { required: true, "valida-zero": true };
        }
      }

      if (this.tributadoCofins) {
        if (this.params.nfAjuste || this.params.nfComplementar) {
          this.local_metadata.acofins.validator = { required: true, "valida-zero": true };
          this.local_metadata.bccofins.validator = { required: true, "valida-zero": true };
          this.local_metadata.vcofins.validator = { required: true, "valida-zero": true };
        }
      }
    },
    handleValidarItem: function handleValidarItem() {
      var _this = this;

      if (this.nfit.vlr == 0) {
        this.$erpToastError('Insira o valor do item');
        return;
      }

      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          _this.handleSalvar();
        }
      });
    }
  },

  watch: {
    'nfit.stpis': function nfitStpis() {
      this.handleValidation();
    },
    'nfit.stcofins': function nfitStcofins() {
      this.handleValidation();
    },

    'nfit.coditem': function nfitCoditem() {
      //ao digitar um item, carrega os dados deste item
      if (this.unWatch) {
        this.unWatch = false;
        return;
      }

      if (this.coditem != null) {
        this.nfit.coditem = this.coditem;
        this.nfit.operacaonf = this.params.nf.operacaonf;
        this.nfit.qt = 1;
        this.nfit.qtuni = 1;

        this.apiCarregaProduto(this.nfit);

        this.handleValidation();
      }
    },

    selectedItem: function selectedItem() {
      //quando selecionar um item, carrega a unidade de medida, ncm e a origem da mercadoria
      if (this.unWatch) return;

      if (!this.selectedItem.length) {
        return;
      }
    },

    itemTaxes: function itemTaxes() {
      //ao selecionar um item, carrega a os dados de impostos deste item
      if (this.unWatch) return;

      if (!this.itemTaxes) {
        return;
      }
    },

    csosn: function csosn() {},

    sticmentrada: function sticmentrada() {},

    sticm: function sticm() {},

    stipi: function stipi() {},

    stpis: function stpis() {
      this.tributadoPis = this.nfit.stpis == '01' || this.nfit.stpis == '02' || this.nfit.stpis == '49' || this.nfit.stpis == '50' || this.nfit.stpis == '98' || this.nfit.stpis == '99';
      this.tributadoPisST = this.nfit.stpis == '05';
      this.pautaPis = this.nfit.stpis == '03';
    },

    stcofins: function stcofins() {
      this.tributadoCofins = this.nfit.stcofins == '01' || this.nfit.stcofins == '02' || this.nfit.stcofins == '49' || this.nfit.stcofins == '50' || this.nfit.stcofins == '98' || this.nfit.stcofins == '99';
      this.tributadoCofinsST = this.nfit.stcofins == '05';
      this.pautaCofins = this.nfit.stcofins == '03';
    },

    orimerc: function orimerc() {
      this.informaFCI = this.nfit.orimerc == '1' || this.nfit.orimerc == '2' || this.nfit.orimerc == '3' || this.nfit.orimerc == '8';
    },

    'params.ipidevol': function paramsIpidevol() {},

    'nfit.qtuni': function nfitQtuni() {}

  },

  mounted: function mounted() {},
  created: function created() {
    if (this.params.nfit) {
      this.nfit = this.params.nfit;
    }
    this.unWatch = true;

    this.$nextTick(function () {
      if (this.$refs.item) this.$refs.item.focus();
    });
  }
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfentrada_form_vue__ = __webpack_require__(591);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_08efb248_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfentrada_form_vue__ = __webpack_require__(1641);
function injectStyle (ssrContext) {
  __webpack_require__(1639)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfentrada_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_08efb248_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfentrada_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_numbers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_numbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_numbers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nf_form_ref__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__item_form__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__unimed_form__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__forms_estoque_estoque_entrada__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__nfe_eventos_form__ = __webpack_require__(585);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params: {},
    crud: ''
  },

  components: {
    nfFormRef: __WEBPACK_IMPORTED_MODULE_4__nf_form_ref__["a" /* default */], ItemForm: __WEBPACK_IMPORTED_MODULE_5__item_form__["default"], UnimedForm: __WEBPACK_IMPORTED_MODULE_6__unimed_form__["a" /* default */], EstoqueEntrada: __WEBPACK_IMPORTED_MODULE_7__forms_estoque_estoque_entrada__["a" /* default */], nfeEventosForm: __WEBPACK_IMPORTED_MODULE_8__nfe_eventos_form__["a" /* default */]
  },

  data: function data() {
    return {
      view: false, //variavel para controle de visualizacao ou edicao
      formCab: false, //editando cabecalho da nf
      formPar: false, //editando parcelas da nf
      formIncluir: false, //exibe formulario para inclusao de notas (campos participante e natureza)
      nfOutrasSaidas: false, //inclusao de outras notas de saida
      showFormItem: false, //exibe o formulario de manutencao de item do pedido
      showItemForm: false, //exibe o formulario de cadastro de produto para inclusao
      showUnimedForm: false, //exibe o formulario de unidade de medida para inclusao
      showCancel: false, //exibe a justificativa do cancelamento
      showEventos: false,
      showCorrecao: false, //exibe a tela para emissao da carta de correção
      showNfRef: false, //exibe a inclusao de notas referenciadas - digitado pelo usuario
      formItemView: false,
      msgCancelItem: false,

      showFormImportXML: true, // formulario para importacao de xml

      updateItem: false, //indica quando for uma alteracao de item

      //entidades
      nf: _extends({}, this.$store.getters.getEntities.nf),
      nfit: [],
      nfpar: [], //parcelas da nf
      nfref: [], //notas referenciadas
      _nf: {}, //objeto utilizado para funcionalidade do botao descartar

      cfop_natureza: [],

      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [], //armazena as mensagens de validacao da nf apos a gravacao
      textocorrecao: '',
      textocorrecao_anterior: '',
      errCorrecao: [],

      codpedv: 0,
      codnf: 0,

      codpart: 0, //codigo do participante para alteracao
      crudItem: '', //inclusao de item
      transportadora: false,

      nfit_update: {},
      paramItem: {},

      moreActions: [], //botao mais acoes

      tabs: [{ title: 'Produtos' }, { title: 'Outros Dados' }, { title: 'Dados de Pagamento' }, { title: 'Total' }], //paginas
      activeTab: 0, //pagina ativa

      unwatch: true,
      changedItemIdx: 0,

      paramsCadastro: {},

      showFormEstoqueEntrada: false,
      excluirArmazenamento: false

    };
  },


  computed: {
    isView: function isView() {
      // Alinhado com bar-grid: permite edição se stnf < '10' (diferente de '02') ou se stnf == '50'
      if (this.view) return true;else return !(this.nf.stnf < '10' && this.nf.stnf != '02' || this.nf.stnf == '50');
    },

    entradaArmazenamentoPendente: function entradaArmazenamentoPendente() {
      //habilitar e mostrar mensagem para efetuar armazenamento da nota
      if (this.nf.stnf == '03') return 'Efetue o armazenamento do estoque da nota de entrada.';else return null;
    },

    partList: function partList() {
      return this.$store.getters.getPartList[0];
    },

    parcelas: function parcelas() {
      return this.nf.parcelas;
    },

    stnf: function stnf() {
      return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(this.nf.stnf, this.metadata.nf.stnf);
    },

    title: function title() {
      if (this.nf.entradaarmazenamento == 'S') {
        return 'Nota Fiscal de Entrada Armazenamento';
      }
      if (this.nf.operacaonf == 'E' && this.nf.stnf == '00' && this.nf.impxml == 'S') {
        return 'Concluir Importação do XML de Entrada ';
      } else if (this.nf.operacaonf == 'E') {
        return 'Nota Fiscal de Entrada ';
      }
    },

    nates: function nates() {
      if (this.nf.nates && this.nf.nates.length > 0) {
        return this.nf.nates[0];
      } else {
        return null;
      }
    },

    codnates: function codnates() {
      return this.nf.codnates;
    },

    selectedNates: function selectedNates() {
      return this.$store.getters.getNates;
    },

    selectedItem: function selectedItem() {
      return this.$store.getters.getItemList;
    },

    _nomeuf: function _nomeuf() {
      if (this.nf.part) {
        if (this.nf.part[0].nomeuf) {
          return this.nf.part[0].nomeuf;
        } else if (this.nf.part[0].estado) {
          return this.nf.part[0].estado[0].nomeuf;
        }
      }
    },

    _nomemun: function _nomemun() {
      if (this.nf.part) {
        if (this.nf.part[0].nomemun) {
          return this.nf.part[0].nomemun;
        } else if (this.nf.part[0].mun) {
          return this.nf.part[0].mun[0].nomemun;
        }
      }
    },

    _cnpjcpf: function _cnpjcpf() {
      //FORMATACAO DO CNPJ DO CLIENTE
      var doc = '';
      if (this.nf.part) {
        doc = this.nf.part[0].cnpjcpf;
      }
      if (String(doc).length > 11) {
        doc = this.$formatCNPJ(doc);
      } else if (String(doc).length == 11) {
        doc = this.$formatCPF(doc);
      }
      return doc;
    }

  },

  filters: {
    format: function format(value, decimals) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(value, decimals);
    }
  },

  methods: {
    itemChange: function itemChange(idx) {
      //CARREGA A UNIDADE DE MEDIDA QUANDO USUARIO ALTERAR O ITEM

      if (this.unwatch) {
        return;
      }

      if (this.nfit[idx].coditem != null) {
        this.changedItemIdx = idx; //GUARDA O INDEX DO ITEM QUE FOI ALTERADO
        this.$store.dispatch('loadItem', { id: this.nfit[idx].coditem });
      }
    },
    unidadeItemChange: function unidadeItemChange(idx) {
      //HABILITA O CAMPO DE FATOR QUANDO ALTERADA A UNIDADE DE MEDIDA DO ITEM PARA UMA UNIDADE NAO RELACIONADA AO ITEM
      if (this.unwatch) {
        return;
      }
      if (!this.nfit[idx]) {
        return;
      }

      if (!this.nfit[idx].item[0]) {
        return;
      }

      if (!this.nfit[idx].uni) {
        return;
      }

      if (!this.nfit[idx].item[0].uni) {
        return;
      }

      //SE A UNIDADE INFORMADA FOR IGUAL À UNIDADE DO ITEM
      if (this.nfit[idx].uni == this.nfit[idx].item[0].uni) {
        this.nfit[idx].fator = 1;
        this.nfit[idx].obrigaFator = false;
        return;
      } else
        //SE NAO EXISTIR NENHUMA UNIDADE ALTERNATIVA
        if (!this.nfit[idx].item[0].itemum.length) {
          this.nfit[idx].obrigaFator = true;
          this.nfit[idx].fator = 0;
          return;
        }

      //PROCURA A UNIDADE INFORMADA NA UNIDADE ALTERNATIVA DO ITEM
      var unidadeValida = false;
      for (var i = 0; i < this.nfit[idx].item[0].itemum.length; i++) {
        if (this.nfit[idx].item[0].itemum[i].uni == this.nfit[idx].uni) {
          unidadeValida = true;
          break;
        }
      }

      if (!unidadeValida) {
        this.nfit[idx].fator = 0;
        this.nfit[idx].obrigaFator = true;
      } else {
        this.nfit[idx].obrigaFator = false;
      }
    },
    closeForm: function closeForm() {
      if (this.$route.params && this.$route.params.id) this.$router.go(-1);else this.$emit('closeform');
    },
    data: function data(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatDate"])(value);
    },
    handleIncluirItem: function handleIncluirItem(idx) {
      //abre tela para cadastro de novo produto
      this.changedItemIdx = idx; //GUARDA O INDICE DO ITEM DA NF

      this.crudItem = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI;
      this.paramsCadastro = {};
      this.paramsCadastro.codigoxml = this.nfit[idx].nfitx[0].codigoxml;
      this.paramsCadastro.descricao = this.nfit[idx].nfitx[0].descricao;
      this.paramsCadastro.uni = this.nfit[idx].nfitx[0].uni;
      this.paramsCadastro.ncm = this.nfit[idx].nfitx[0].ncm;
      this.paramsCadastro.cest = this.nfit[idx].nfitx[0].cest;
      this.paramsCadastro.orimerc = this.nfit[idx].nfitx[0].orimerc;
      this.paramsCadastro.cean = this.nfit[idx].nfitx[0].cean;
      if (this.selectedNates) {
        this.paramsCadastro.nates = this.selectedNates;
      } else {
        this.paramsCadastro.nates = this.nates;
      }
      this.paramsCadastro.coditem = null;
      this.showItemForm = true;
    },
    closeItemForm: function closeItemForm(item) {
      //ao fechar o formulario de cadastro de produto
      this.showItemForm = false;

      //SE UM NOVO ITEM FOI CRIADO, CARREGA O CODIGO DO ITEM CRIADO PARA O ITEM DA NF
      if (item) {
        this.nfit[this.changedItemIdx].coditem = item.coditem;
      }
    },
    handleIncluirUnimed: function handleIncluirUnimed(idx) {
      //abre tela para inclusao de unidade de medida
      this.changedItemIdx = idx; //GUARDA O INDICE DO ITEM DA NF

      this.crudItem = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI;
      this.paramsCadastro = {};
      this.paramsCadastro.uni = this.nfit[idx].nfitx[0].uni;
      this.showUnimedForm = true;
    },
    closeUnimedForm: function closeUnimedForm(uni) {
      //ao fechar o formulario de cadastro de unidade de medida
      this.showUnimedForm = false;

      //SE UMA NOVA UNIDADE FOI CRIADA, CARREGA O CODIGO PARA O ITEM DA NF
      if (uni) {
        this.nfit[this.changedItemIdx].uni = uni.uni;
      }
    },
    handleActions: function handleActions(action) {
      //cancela a nota fiscal
      if (action == 3) {
        this.showCancel = true;
        this.$nextTick(function () {
          this.$refs.obscan.focus();
        });
      }

      //exclui a nota fiscal
      if (action == 5) {
        this.apiInvoiceDelete();
      }

      //download do xml
      if (action == 6) {
        this.downloadXML();
      }

      if (action == 30) {
        this.showEventos = true;
      }
    },
    handleCancel: function handleCancel() {
      //botao confirmacao de cancelamento da nf
      if (this.nf.obscan == null) {
        this.$erpToastError('Por favor preencha a justificativa para continuar');
        return;
      }
      this.apiInvoiceCancel();
    },
    handleCancelDiscard: function handleCancelDiscard() {
      //botao descartar cancelamento da nf
      this.showCancel = false;
    },
    validaRef: function validaRef() {
      //efetua a validacao das notas referenciadas
      if (!this.showNfRef) {
        return true;
      }
      if (this.nfref.length == 0) {
        this.$erpToastError('A Configuração da natureza de operação utilizada (' + this.nf.cfop + ') exige que seja referenciada uma chave.');
        return false;
      }
      var erro = false;
      for (var i = 0; i < this.nfref.length; i++) {
        this.nfref[i].validation = {};
        if (this.nfref[i].nfreftp == 1 || this.nfref[i].nfreftp == 2) {
          if (this.nfref[i].chave == null || this.nfref[i].chave.length < 44) {
            this.nfref[i].validation.chave = 'Chave inválida';
            erro = true;
          }
        } else if (this.nfref[i].nfreftp == 3 || this.nfref[i].nfreftp == 4) {
          if (this.nfref[i].nf == null || this.nfref[i].nf.length < 1) {
            this.nfref[i].validation.nf = 'Número da NF obrigatório';
            erro = true;
          }
        }
      }
      if (erro) {
        this.$erpToastError('Por favor preencha corretamente os campos em destaque para continuar');
      }
      return !erro;
    },
    handleDescartar: function handleDescartar() {},
    handleSalvarDados: function handleSalvarDados() {
      //botao salvar dados do cabecalho da nf

    },
    handleConcluirImportXml: function handleConcluirImportXml() {
      var _this = this;

      //BOTAO PARA CONCLUIR DIGITACAO DA NF DE ENTRADA
      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this.$scrollTo(0);
          _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          _this.apiImportXML(true);
        }
      });
    },
    apiImportXML: function apiImportXML(finalizar) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var sendData, data, x, i, validation;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //efetua a gravacao da identificacao dos itens da importacao do xml da nf de entrada
                if (finalizar) {
                  _this2.nf.stnf = '11'; //entrada concluída
                }

                _this2.nf.nfit = _this2.nfit;
                _this2.nf.nfpar = _this2.nfpar;
                sendData = { nf: _this2.nf };
                _context.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this2.$store, 'invoice/importxml/', sendData, 'put');

              case 6:
                data = _context.sent;

                if (data.items) {
                  _this2.nf = {};
                  _this2.nfit = [];
                  _this2.nf = data.items[0];
                  _this2.nf.nfit = data.items[0].nfit;
                  for (x = 0; x < _this2.nf.nfit.length; x++) {
                    _this2.nfit.push(_this2.nf.nfit[x]);
                  }
                  for (i = 0; i < _this2.nfit.length; i++) {
                    _this2.unidadeItemChange(i);
                  }

                  validation = JSON.parse(_this2.nf.validation);

                  if (_this2.nf.validation && validation.errmessages) {
                    _this2.errmessages = validation;
                    _this2.$scrollTo(0);
                    _this2.$erpToastError('Por favor corrija os erros em destaque para esta nota fiscal');
                  } else {
                    _this2.errmessages = [];
                  }
                }
                _this2.updateActions();

                //console.log(this.nf.nfit[0].nfitx[0].msg)

                if (_this2.nf.import_errors > 0) {
                  _this2.$scrollTo(0);
                  _this2.$erpToastError('Por favor corrija os erros em destaque para esta nota fiscal');
                } else if (_this2.nf.stnf == '11') {
                  _this2.$erpToastSuccess('A nota fiscal foi concluída');
                  _this2.closeForm();
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    apiInvoiceDelete: function apiInvoiceDelete() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var modulo;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                //exclui a nota fiscal
                modulo = 'invoice/nf/' + _this3.nf.codnf;
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

              case 3:
                _this3.$erpToastSuccess('A Nota fiscal foi excluída com sucesso.');
                _this3.$emit('closeform');

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    apiItens: function apiItens(nfIt) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var sendData, metodo, modulo, data, validation;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                //efetua a gravacao dos itens do pedido
                _this4.nf.nfit = _extends({}, _this4.nfit);
                sendData = {};

                sendData = { nf: _this4.nf //pega o cabecalho da nf
                };if (nfIt.length) {
                  sendData.nf.nfit = nfIt; //adiciona os novos itens ao cabecalho
                } else {
                  sendData.nf.nfit = [];
                  sendData.nf.nfit.push(nfIt);
                }

                metodo = 'post';
                // if (this.updateItem){
                // metodo = 'put'
                // }

                modulo = 'invoice/nfit/';
                _context3.next = 8;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

              case 8:
                data = _context3.sent;

                if (data.items) {
                  _this4.nf = data.items[0];
                  _this4.nfit = data.items[0].nfit;
                  _this4.$erpToastSuccess('Item alterado com sucesso.');
                  validation = JSON.parse(_this4.nf.validation);

                  if (_this4.nf.validation && validation.errmessages) {
                    _this4.errmessages = validation;
                  } else {
                    _this4.errmessages = [];
                  }
                }

                _this4.updateItem = false;

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    closeFormItem: function closeFormItem() {
      //fecha tela de inclusao de item
      this.showFormItem = false;
    },
    handleIncluirItemNF: function handleIncluirItemNF(nSeq, view) {
      //incluir item na nf

      this.nfit_update = _extends({}, this.$store.getters.getEntities.nfit);
      this.nfit_update.finalidade = this.nf.finalidade;
      this.nfit_update.codnf = this.nf.codnf;
      //ajusta os parametros para chamada da tela de item da nf
      var nfAjuste = this.nf.tpnf == 'A';
      var nfComplementar = this.nf.tpnf == 'C';
      var optSimples = this.nf.filial[0].crt == '1' || this.nf.filial[0].crt == '4';
      this.paramItem = {
        nfit: this.nfit_update,
        nfAjuste: nfAjuste,
        nfComplementar: nfComplementar,
        habilitaItem: this.nfOutrasSaidas,
        optSimples: optSimples
        //
      };this.formItemView = false; //indica se é alteração ou somente visualizacao
      this.updateItem = false;
      this.showFormItem = true;
    },
    handleEditItem: function handleEditItem(nSeq, view) {
      //editar o item da nf
      this.nfit_update = {};

      //localiza o item para alteracao atraves da sequencia
      for (var x = 0; x < this.nfit.length; x++) {
        if (this.nfit[x].itnf == nSeq) {
          this.nfit_update = _extends({}, this.nfit[x]);
        }
      }

      //ajusta os parametros para chamada da tela de item da nf
      var nfAjuste = this.nf.tpnf == 'A';
      var nfComplementar = this.nf.tpnf == 'C';
      this.paramItem = { nf: this.nf, nfit: this.nfit_update, nfAjuste: nfAjuste, nfComplementar: nfComplementar, isView: view
        //
      };this.formItemView = view; //indica se é alteração ou somente visualizacao
      this.updateItem = true;
      this.showFormItem = true;
    },
    handleCloseMessage: function handleCloseMessage() {
      this.msgCancelItem = false;
    },
    updateActions: function updateActions() {
      this.moreActions = [];
      var act = {};
      if (this.nf.emissaopropria == 'S' && this.nf.stnf == '11') {
        act = { action: 6, label: 'Download do XML' };
        this.moreActions.push(act);
        act = { action: 3, label: 'Cancelar NF-e' };
        this.moreActions.push(act);
      }
      if (this.nf.stnf == '00' || this.nf.stnf == '03') {
        act = { action: 5, label: 'Excluir NF-e' };
        this.moreActions.push(act);
      }

      act = { action: 30, label: 'Eventos NF-e' };
      this.moreActions.push(act);

      // if (this.nf.stnf == '00' && this.nf.import_errors == 0) {
      //     this.concluirImport = true
      // }
    },
    downloadXML: function downloadXML() {
      //visualizacao do XML da NFE
      var data = { codnf: this.nf.codnf, chave: this.nf.chave, tipo: 'NFE' };
      Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiDownload"])(this, 'print/xmlnfe/', data, 'post');
    },
    loadData: function loadData() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var vm, validation, nfev, i, _i;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                vm = _this5;

                _this5.textocorrecao_anterior = '';

                //carrega a nf para alteracao ou visualizacao
                _context4.next = 4;
                return _this5.$store.dispatch('loadNf_impnfe', { id: _this5.codnf });

              case 4:
                if (_this5.$store.getters.getNf) {
                  _this5.nf = _extends({}, _this5.$store.getters.getNf[0]);
                  _this5.nfit = _this5.nf.nfit;
                  if (_this5.nf.nfpar) {
                    _this5.nfpar = _this5.nf.nfpar;
                  }
                  validation = JSON.parse(_this5.nf.validation);

                  if (_this5.nf.validation && validation.errmessages) {
                    _this5.errmessages = validation;
                  } else {
                    _this5.errmessages = [];
                  }
                  _this5.moreActions = [];
                  _this5.updateActions();
                  //carrega o texto da ultima correcao efetuada se houver
                  nfev = _this5.nf.nfev;

                  for (i = 0; i < nfev.length; i++) {
                    if (nfev[i].tpeventonfe == 'R') {
                      _this5.textocorrecao_anterior = nfev[i].texto;
                    }
                  }
                  vm.unwatch = false;
                  for (_i = 0; _i < _this5.nfit.length; _i++) {
                    vm.unidadeItemChange(_i);
                  }
                  vm.unwatch = true;
                }

                // checa se é uma importação de XML ou se houver itens a identificar
                _this5.showFormImportXML = _this5.importXml || _this5.nf.import_xml > 0;
                if (_this5.showFormImportXML) {
                  _this5.activeTab = 0;
                }
                if (_this5.nf.import_errors > 0) {
                  _this5.$scrollTo(0);
                  _this5.$erpToastError('Por favor corrija os erros em destaque para esta nota fiscal');
                }

                //HABILITAR WATCH
                setTimeout(function () {
                  vm.unwatch = false;
                }, 1000);

                _this5.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    changeTab: function changeTab(idx) {
      //mudança de pagina
      this._nf = this.nf;
      this.activeTab = idx;
    },
    nfparVlrChange: function nfparVlrChange(index) {
      //evento de controle de alteracao do valor da parcela
      //quando usuario alterar o valor de uma parcela, refaz as demais parcelas
      if (this.nf.parcelas <= 1) {
        return;
      }
      var vlrparcial = 0;
      var vlrnovaparcela = 0;
      for (var x = 0; x <= index; x++) {
        vlrparcial = vlrparcial + parseFloat(this.nfpar[x].vlr);
      }
      if (vlrparcial < this.nf.totger) {
        vlrnovaparcela = (this.nf.totger - vlrparcial) / (this.nf.parcelas - (index + 1));
        vlrnovaparcela.toFixed(2);
      } else {}
      for (var x = index + 1; x <= this.nfpar.length - 1; x++) {
        this.nfpar[x].vlr = vlrnovaparcela;
      }
    },
    handleChangeCFOP: function handleChangeCFOP(index) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this6.nf.cfop_natureza[index].codnates != null)) {
                  _context5.next = 4;
                  break;
                }

                _context5.next = 3;
                return _this6.$store.dispatch('loadNates', { id: _this6.nf.cfop_natureza[index].codnates });

              case 3:
                _this6.nf.cfop_natureza[index].cfopentrada = _this6.selectedNates.cfop;

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    handleArmazenarEntrada: function handleArmazenarEntrada() {
      this.$modalForm(true);
      this.excluirArmazenamento = false;
      this.showFormEstoqueEntrada = true;
    },
    closeArmazenarForm: function closeArmazenarForm() {
      this.$modalForm(false);
      this.showFormEstoqueEntrada = false;
      this.codnf = this.nf.codnf;
      this.loadData();
    }
  },

  watch: {
    parcelas: function parcelas() {
      //calcula numero de parcelas da condicao de pagamento

      if (this.unwatch) {
        return;
      }

      this.nfpar = [];
      var vlr = 0;
      if (this.nf.parcelas == '0') {
        var parcela = _extends({}, this.$store.getters.getEntities.nfpar);
        parcela.dtv = this.nf.data;
        parcela.vlr = this.nf.totger;
        parcela.obspar = '';
        this.nfpar.push(parcela);
      } else {
        for (var x = 1; x <= this.nf.parcelas; x++) {
          var _parcela = _extends({}, this.$store.getters.getEntities.nfpar);
          _parcela.dtv = this.$addMonths(this.nf.data, x);
          _parcela.dias = x * 30;
          vlr = this.nf.totger;
          vlr = Object(__WEBPACK_IMPORTED_MODULE_1__shared_numbers__["arr"])(vlr / this.nf.parcelas, 2, true);
          // console.log('parcela ' + x + ': ' + vlr)
          _parcela.vlr = vlr;
          _parcela.obspar = '';
          this.nfpar.push(_parcela);
        }
      }
    },

    codnates: function codnates() {
      if (this.unwatch) {
        return;
      }
      if (this.nf.codnates != null) {
        this.$store.dispatch('loadNates', { id: this.nf.codnates });
      }
    },

    //DESABILITADO QUANDO ENTROU A DIGITACAO DE NATUREZA PARA CADA CFOP
    // selectedNates: function () {
    //     //AO SELECIONAR UMA NATUREZA
    //     if (this.unwatch) {
    //         return
    //     }

    //     this.nf.nates = this.selectedNates
    //     this.nf.cfop = this.nf.nates.cfop
    //     if (this.nf.nates && (this.nf.nates.tpnf == 'P' || this.nf.nates.tpnf == 'A' || this.nf.nates.tpnf == 'D')) {
    //         this.showNfRef = true
    //     } else {
    //         this.showNfRef = false
    //         this.nfref = []
    //     }
    // },

    selectedItem: function selectedItem() {
      //quando alterar um item, carrega a unidade de medida e a lista de unidades de medida
      if (this.unwatch) return;
      if (!this.selectedItem.length) return;

      this.nfit[this.changedItemIdx].uni = this.selectedItem[0].uni;
      this.nfit[this.changedItemIdx].item = this.selectedItem;
    }

  },

  created: function created() {
    this.metadata.nf.parcelas.options.sort(function (a, b) {
      return Number(a.id) > Number(b.id) ? 1 : Number(b.id) > Number(a.id) ? -1 : 0;
    });

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });

    //this.crudText = this.$crudText(this.crud)

    if (this.$route.params && this.$route.params.id) {
      //this.codpedv = this.$route.params.id //numero do pedido de venda
      // this.handleFaturar() //fatura o pedido
      //carrega a nf para alteracao
      this.codnf = this.$route.params.id;
      this.loadData();
      this.view = this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudView;
    } else if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
      //se for uma inclusao
      if (this.params.outrasSaidas) {
        this.nf.emissaopropria = 'S';
        this.nf.operacaonf = 'E';
        if (this.params.entradaArmazenamento) {
          this.nf.entradaarmazenamento = 'S';
        }
        this.nfOutrasSaidas = true;
        this.formIncluir = true;
      }
    } else {
      //carrega a nf para alteracao
      this.codnf = this.params.codnf;
      this.loadData();
      this.view = this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudView;
    }
  }
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__serienf_form__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codserienf: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: ''
        };
    },


    computed: {
        serienfList: function serienfList() {
            return this.$store.getters.getSerienfList;
        },
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        }
    },

    filters: {
        getText: function getText(value, metadata) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(value, metadata);
        }

    },

    methods: {
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.codserienf = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codserienf = '';
            this.showForm = true;
        },
        handleMore: function handleMore() {
            this.offset = 'offset=' + this.nextPage;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"serie":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadSerienf', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], SerienfForm: __WEBPACK_IMPORTED_MODULE_1__serienf_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_serienf_form_vue__ = __webpack_require__(594);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_024a5315_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_serienf_form_vue__ = __webpack_require__(1648);
function injectStyle (ssrContext) {
  __webpack_require__(1646)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_serienf_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_024a5315_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_serienf_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            serienf: _extends({}, this.$store.getters.getEntities.serienf),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.serienf.esp);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO Excluir
            this.apiDelete();
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadSerienf', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getSerienf) {
                                    _this2.serienf = _extends({}, _this2.$store.getters.getSerienf);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/serienf/' + _this3.serienf.codserienf;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/serienf/';
                                sendData = {};


                                sendData = { serienf: _this4.serienf };

                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.serienf = data.items[0];
                                    _this4.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
            this.serienf.esp = '55';
        } else {
            this.loadData();
        }
    }
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contador_form__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codcontador: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: ''
        };
    },


    computed: {
        contadorList: function contadorList() {
            return this.$store.getters.getContadorList;
        },
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        }
    },

    filters: {
        getText: function getText(value, metadata) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(value, metadata);
        }

    },

    methods: {
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.codcontador = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codcontador = '';
            this.showForm = true;
        },
        handleMore: function handleMore() {
            this.offset = 'offset=' + this.nextPage;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codcontador":{"$like":"%25' + value + '%25"}},{"nome":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadContador', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], ContadorForm: __WEBPACK_IMPORTED_MODULE_1__contador_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            contador: _extends({}, this.$store.getters.getEntities.contador),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        updateCep: function updateCep() {
            //CARREGA INFORMACOES DO CEP
            this.contador.ende = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.logradouro;
            this.contador.bairro = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.bairro;
            this.contador.codmun = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.ibge;
            this.contador.uf = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.uf;
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO Excluir
            this.apiDelete();
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadContador', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getContador) {
                                    _this2.contador = _extends({}, _this2.$store.getters.getContador);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/contador/' + _this3.contador.codcontador;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/contador/';
                                sendData = {};


                                sendData = { contador: _this4.contador };

                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
            this.uf = 'SP';
        } else {
            this.loadData();
        }
    }
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_ramoat_list_vue__ = __webpack_require__(598);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a032459_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_ramoat_list_vue__ = __webpack_require__(1660);
function injectStyle (ssrContext) {
  __webpack_require__(1658)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a032459"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_ramoat_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a032459_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_ramoat_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramoat_form__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            ramoat: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: ''
        };
    },


    computed: {
        ramoatList: function ramoatList() {
            return this.$store.getters.getRamoatList;
        },
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        }
    },

    filters: {
        getText: function getText(value, metadata) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(value, metadata);
        }

    },

    methods: {
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.codramo = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codramo = '';
            this.showForm = true;
        },
        handleMore: function handleMore() {
            this.offset = 'offset=' + this.nextPage;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codramo":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadRamoat', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], RamoatForm: __WEBPACK_IMPORTED_MODULE_1__ramoat_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__natfin_form__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            activeTab: 0,
            natfinReceitas: [],
            natfinDespesas: [],
            codnatfin: '',
            codNatfinPai: '',
            codnatfinDestino: '',
            natfinItem: '',
            showModalDeleteNatFin: false,
            natfinDestErrorMsg: '',
            natfinDestError: ''
        };
    },


    computed: {
        // natfinList: function () {
        //     return this.$store.getters.getNatfinList
        // },
        tabs: function tabs() {
            var tabs = [];

            tabs = [{ title: 'Receitas', icon: 'fa-archive' }, { title: 'Despesas', icon: 'fa-cubes' }];

            return tabs;
        },
        tabReceitas: function tabReceitas() {
            return this.activeTab == 0;
        },
        tabDespesas: function tabDespesas() {
            return this.activeTab == 1;
        }
    },

    filters: {
        getText: function getText(value, metadata) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(value, metadata);
        }

    },

    methods: {
        handleEdit: function handleEdit(natfin) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.codnatfin = natfin.codnatfin;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codnatfin = '';
            this.showForm = true;
        },
        handleModalDelete: function handleModalDelete(natfin) {
            //MODAL confirmação
            if (natfin.haschildren) {
                this.$erpToastError('Não é permitida a exclusão de um item que possui subitens!');
                return;
            }

            this.showModalDeleteNatFin = true;
            this.natfinItem = natfin;
        },
        handleDelete: function handleDelete(natfin) {
            //BOTAO Excluir
            if (natfin.haschildren) {
                this.$erpToastError('Não é permitida a exclusão de um item que possui subitens!');
                return;
            }

            if (this.natfinDestError) {
                this.$erpToastError('Por favor, corrija os campos com alerta em vermelho');
                return;
            }

            this.apiDelete(natfin);
        },
        handleSubgroup: function handleSubgroup(natfin) {
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codNatfinPai = natfin.codnatfin;
            this.showForm = true;
        },
        handleInputPai: function handleInputPai() {
            var _this = this;

            // remove a msg de erro
            this.natfinDestError = false;

            var self = this;
            var codnfdestino = this.codnatfinDestino ? this.codnatfinDestino : '';
            var url = this.$store.getters.urlOrds + 'cg/natfin/' + codnfdestino;

            Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDS"])(url, {}).then(function (result) {
                if (result.items && result.items.length) {

                    var selectedNfDestino = result.items[0];

                    if (self.natfinItem.codnatfin == selectedNfDestino.codnatfin) {
                        _this.natfinDestError = true;
                        _this.natfinDestErrorMsg = 'A natureza de destino deve ser diferente da natureza que está sendo excluida!';
                        return;
                    }

                    if (selectedNfDestino.haschildren) {
                        _this.natfinDestErrorMsg = 'A natureza de destino não é permitida! Selecione uma natureza que não possua subitens vinculados!';
                        _this.natfinDestError = true;
                        return;
                    }
                }
            });
        },
        apiDelete: function apiDelete(natfin) {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var codNfDestino, modulo, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //efetua a exclusao
                                codNfDestino = _this2.codnatfinDestino ? _this2.codnatfinDestino : '';
                                modulo = 'cg/natfin/' + natfin.codnatfin + '?destino=' + codNfDestino;
                                _context.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSdelete"])(_this2.$store, modulo);

                            case 4:
                                data = _context.sent;

                                _this2.$erpToastDeleted();
                                _this2.closeForm();

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.showModalDeleteNatFin = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            // this.filter = '{"$or":[{"codnatfin":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData();
        },
        loadData: function loadData() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var url, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                // this.$store.dispatch('loadNatfin', { filter: this.filter } )
                                // this.offset = ''
                                url = Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["urlORDS"])(_this3.$store, 'cg/natfin/');
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDS"])(url, {});

                            case 3:
                                data = _context2.sent;


                                // console.log(data)

                                _this3.natfinReceitas = [];
                                _this3.natfinDespesas = [];

                                if (data.receitas) {
                                    _this3.natfinReceitas = data.receitas;
                                }
                                if (data.despesas) {
                                    _this3.natfinDespesas = data.despesas;
                                }

                                // console.log(this.natfinReceitas)

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        changeTab: function changeTab(idx) {
            // Mudança de pagina
            this.activeTab = idx;
        },
        levelFont: function levelFont(level) {
            switch (level) {
                case 1:
                    return 'lbl-title font-weight-bold lvl-1';

                case 2:
                    return 'data-list font-weight-bold lvl-2';

                case 3:
                    return 'data-list lvl-3';
            }
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], NatfinForm: __WEBPACK_IMPORTED_MODULE_1__natfin_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
        console.log(this.natfinItem);
    }
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inut_form__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main__);
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,
            params: {},
            advFilter: {}, //objeto para o filtro avançado da pesquisa de notas
            filterList: [] //lista de filtros aplicados que são exibidos em tela
        };
    },

    computed: {
        inutList: function inutList() {
            return this.$store.getters.getInutList;
        }
    },
    methods: {
        handleEdit: function handleEdit(codinut) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudU; //operacao de edicao
            this.params = {};
            this.params.codinut = codinut;
            this.showForm = true; //exibe o form de manutencao
        },
        handleView: function handleView(codinut) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudView; //visualizacao
            this.params = {};
            this.params.codinut = codinut;
            this.showForm = true; //exibe o form de manutencao
        },
        handleAction: function handleAction(id, keyIndex) {},
        handleIncluir: function handleIncluir() {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudI; //operacao de inclusao
            this.params.codinut = 0;
            this.showForm = true; //exibe o form de manutencao
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        handleSearch: function handleSearch(value) {
            //efetua a pesquisa
            this.filter = '';
            if (value != '') {
                this.filter = '{"$or":[{"nfinicial":{"$eq":"' + value + '"}},{"nffinal":{"$eq":"' + value + '"}}]}';
            }
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadInut', { filter: this.filter });
        },
        data: function data(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["formatDate"])(value);
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], inutForm: __WEBPACK_IMPORTED_MODULE_2__inut_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params: '',
    crud: ''
  },

  data: function data() {
    return {
      crudText: '',
      inut: _extends({}, this.$store.getters.getEntities.inut),
      iest: [],
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
    };
  },


  computed: {
    editing: function editing() {
      return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
    }
  },

  methods: {
    closeForm: function closeForm() {
      this.$emit('closeform');
    },
    handleSave: function handleSave() {
      var _this = this;

      //BOTAO SALVAR
      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          _this.apiPost();
        }
      });
    },
    handleDelete: function handleDelete() {
      this.apiDelete();
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI)) {
                  _context.next = 4;
                  break;
                }

                _this2.inut.serie = '1';
                _this2.inut.esp = '55';
                return _context.abrupt('return');

              case 4:
                _context.next = 6;
                return _this2.$store.dispatch('loadInut', { id: _this2.params.codinut });

              case 6:
                if (_this2.$store.getters.getInut) {
                  _this2.inut = _extends({}, _this2.$store.getters.getInut);
                }
                _this2.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    apiDelete: function apiDelete() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    apiPost: function apiPost() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var tipo, paramsinut, sendData, metodo, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                //efetua a gravacao
                if (!_this4.inut.nffinal || _this4.inut.nffinal <= 0) {
                  _this4.inut.nffinal = _this4.inut.nfinicial;
                }
                _this4.inut.texto = _this4.inut.texto.trim();

                tipo = _this4.$certificadoCheck(_this4.inut.codfil);

                if (!(tipo == 'A3')) {
                  _context3.next = 13;
                  break;
                }

                paramsinut = '&nffinal=' + _this4.inut.nffinal;

                paramsinut = paramsinut + '&nfinicial=' + _this4.inut.nfinicial;
                paramsinut = paramsinut + '&esp=' + _this4.inut.esp;
                paramsinut = paramsinut + '&serie=' + _this4.inut.serie;
                paramsinut = paramsinut + '&texto=' + _this4.inut.texto;
                _this4.$executaExtensaoChromeA3(null, 'inut', _this4.NFeResponseCallback, paramsinut);
                return _context3.abrupt('return');

              case 13:
                sendData = {};

                sendData = _this4.inut;

                metodo = 'post';
                _context3.next = 18;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this4.$store, 'invoice/inut2/', sendData, metodo);

              case 18:
                data = _context3.sent;

                if (data.errmessages) {
                  _this4.errmessages = data.errmessages;
                  _this4.$erpToastError('Erro ao enviar pedido de inutilização');
                } else {
                  _this4.$erpToastSuccess('O Pedido de inutilização foi homologado.');
                  _this4.errmessages = {};
                  _this4.closeForm();
                }

              case 20:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    NFeResponseCallback: function NFeResponseCallback(response) {
      //CALLBACK QUANDO A INUTILIZACAO É ENVIADA POR CERTIFICADO A3
      //console.log(response)
      this.$appLoading(false);
      this.errmessages = [];
      if (response.status != 'success') {
        this.$erpToastError(response.message);
      } else {
        this.$erpToastSuccess('Inutilização homologada');
      }
      this.closeForm();
    }
  },

  components: {},

  beforeCreate: function beforeCreate() {},
  created: function created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });

    this.crudText = this.$crudText(this.crud);

    this.loadData();

    this.metadata.inut.nffinal.validator = null;
    this.metadata.inut.nfinicial.validator = { required: true };
    this.metadata.inut.codfil.validator = { required: true };
  }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            filial: '',
            codfil: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            fileList: [],
            filesResult: [],
            resultList: [],
            showSelecionaArquivos: true,
            showConfirmaImportacao: false,
            uploading: false,
            reRenderList: 0,
            showImportacaoFinalizada: false
        };
    },


    computed: {
        qtFiles: function qtFiles() {
            return this.fileList.length;
        }
    },

    filters: {},

    methods: {
        handleImportacaoFinalizada: function handleImportacaoFinalizada() {
            var finished = this.fileList.length > 0;
            for (var i = 0; i < this.fileList.length; i++) {
                if (!this.fileList[i].finished) finished = false;
            }
            this.showImportacaoFinalizada = finished;
            this.uploading = !this.showImportacaoFinalizada;
        },
        handleFileSelectBtn: function handleFileSelectBtn() {
            //BOTAO SELECIONAR ARQUIVOS
            this.$refs.file.value = '';
            this.$refs.file.click();
        },
        handleFileUpload: function handleFileUpload() {
            //EVENTO AO SELECIONAR ARQUIVOS
            //EFETUA A LEITURA DE CADA ARQUIVO SELECIONADO ATRAVES DO SERVIDOR (SERVIDOR RETORNA O XML)

            //console.log(this.$refs.file.files)

            this.fileList = [];
            var files = this.$refs.file.files;
            this.filesResult = [];

            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                file.finished = false;
                file.uploading = false;
                this.fileList.push(file);
            }

            if (files.length > 30) {
                this.$erpToastError('Seleção não permitida. O limite máximo é de 30 arquivos por importação.');
                return;
            }

            this.showSelecionaArquivos = false;
            this.showConfirmaImportacao = true;
            this.uploading = false;
        },
        readCSV: function readCSV(csvContent, filename, fileIdx) {
            var self = this;

            var estado = filename.substring(12, 14);

            this.fileList[fileIdx].uploading = true;
            this.reRenderList += 1; //re render

            var formData = new FormData();
            formData.append('file', new Blob([csvContent]), filename);

            var path = this.$store.getters.urlApp + 'ibpt/importa/' + estado;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(path, formData, { timeout: 1000 * 120, headers: { 'Content-Type': 'multipart/form-data' } }).then(function (data) {
                var addfile = { filename: filename, result: data.data };
                self.filesResult.push(addfile);
                self.fileList[fileIdx].uploading = false;
                self.fileList[fileIdx].finished = true;
                if (addfile.result.errormessages.length) self.fileList[fileIdx].errors = addfile.result.errormessages.length;else self.fileList[fileIdx].gravados = addfile.result.gravados;
                self.reRenderList += 1; //re render
                self.handleImportacaoFinalizada();
            });
            // .catch(function(data){
            //     self.$erpToastError('Erro ao efetuar upload do arquivo ' + filename + ': ' + data)
            // })
        },
        handleNovaImportacao: function handleNovaImportacao() {
            this.showImportacaoFinalizada = false;
            this.showConfirmaImportacao = false;
            this.showSelecionaArquivos = true;
            this.uploading = false;
        },
        handleExecutaImportacao: function handleExecutaImportacao() {
            this.uploading = true;

            var files = this.$refs.file.files;
            var self = this;

            //formData.append('file', this.selectedFile)

            var _loop = function _loop() {
                var file = files[i];
                var idx = i;
                var reader = new FileReader();
                reader.readAsText(file, 'ISO-8859-1');
                reader.onload = function (event) {
                    var content = event.target.result;
                    self.readCSV(content, file.name, idx);
                };
            };

            for (var i = 0; i < files.length; i++) {
                _loop();
            }

            //     //ENVIA O OBJETO JSON PARA IMPORTAÇÃO
            //     //RETORNA UM OBJETO ARRAY COM A SITUACAO DE CADA ITEM IMPORTADO E OS ERROS SE HOUVER
            //     //[ filename: "", status: "ok", errormessage: "", text: ""]

            //     let sendData = { xmls: this.filesResult }
            //     this.resultList = []

            //     var self = this

            //     axios.post(urlORDS(this.$store, 'cg/importxml/'), sendData, {})
            //         .then(function(data){
            //             // console.log(data.data)
            //             self.transcount = data.data.transcount
            //             self.forncount = data.data.forncount
            //             self.prodcount = data.data.prodcount
            //             self.clicount = data.data.clicount
            //             self.resultList = data.data.result
            //             self.$erpToastSuccess('Importação executada')
            //             self.showConfirmaImportacao = false
            //         })
            //         .catch(function(data){
            //             self.$erpToastError('Erro ao efetuar importação ' + data.message)
            //         })
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleRetornar: function handleRetornar() {
            this.resultList = [];
            this.showSelecionaArquivos = true;
            this.showConfirmaImportacao = false;
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"]
    },

    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            filial: '',
            codfil: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            filesJson: [],
            resultList: [],
            showSelecionaArquivos: true,
            showConfirmaImportacao: false,
            transcount: 0,
            prodcountutos: 0,
            clicountentes: 0,
            forncount: 0
        };
    },


    computed: {
        qtFiles: function qtFiles() {
            return this.filesJson.length;
        }

    },

    filters: {
        getText: function getText(value, metadata) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["getText"])(value, metadata);
        }
    },

    methods: {
        handleFileSelectBtn: function handleFileSelectBtn() {
            //BOTAO SELECIONAR ARQUIVOS
            this.$refs.file.value = '';
            this.$refs.file.click();
        },
        handleFileUpload: function handleFileUpload() {
            //EVENTO AO SELECIONAR ARQUIVOS
            //EFETUA A LEITURA DE CADA ARQUIVO SELECIONADO ATRAVES DO SERVIDOR (SERVIDOR RETORNA O XML)

            //console.log(this.$refs.file.files)

            var files = this.$refs.file.files;
            this.filesJson = [];

            if (files.length > 50) {
                this.$erpToastError('Seleção não permitida. O limite máximo é de 50 arquivos por importação.');
                return;
            }

            var self = this;

            //formData.append('file', this.selectedFile)

            var _loop = function _loop() {
                var file = files[i];
                var reader = new FileReader();
                reader.readAsText(file, 'ISO-8859-1');
                reader.onload = function (event) {
                    var xml = event.target.result;
                    self.readXml(xml, file.name);
                };
            };

            for (var i = 0; i < files.length; i++) {
                _loop();
            }
            this.showSelecionaArquivos = false;
            this.showConfirmaImportacao = true;
        },
        readXml: function readXml(xml, filename) {
            var self = this;
            var formData = new FormData();
            formData.append('file', new Blob([xml]), filename);
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["urlORDS"])(this.$store, 'cg/importreadxml/'), formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (data) {
                var addfile = { filename: filename, xml: data.data };
                self.filesJson.push(addfile);
                console.log(self.filesJson);
            }).catch(function (data) {
                self.$erpToastError('Erro ao efetuar upload do arquivo ' + file.name + ': ' + data.message);
            });
        },
        handleExecutaImportacao: function handleExecutaImportacao() {
            //ENVIA O OBJETO JSON PARA IMPORTAÇÃO
            //RETORNA UM OBJETO ARRAY COM A SITUACAO DE CADA ITEM IMPORTADO E OS ERROS SE HOUVER
            //[ filename: "", status: "ok", errormessage: "", text: ""]

            var sendData = { xmls: this.filesJson };
            this.resultList = [];

            var self = this;

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["urlORDS"])(this.$store, 'cg/importxml/'), sendData, {}).then(function (data) {
                // console.log(data.data)
                self.transcount = data.data.transcount;
                self.forncount = data.data.forncount;
                self.prodcount = data.data.prodcount;
                self.clicount = data.data.clicount;
                self.resultList = data.data.result;
                self.$erpToastSuccess('Importação executada');
                self.showConfirmaImportacao = false;
            }).catch(function (data) {
                self.$erpToastError('Erro ao efetuar importação ' + data.message);
            });
        },
        loadData: function loadData() {
            // this.$store.dispatch('loadFilial', { filter: this.filter, page: this.nextPage } )

            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleRetornar: function handleRetornar() {
            this.resultList = [];
            this.showSelecionaArquivos = true;
            this.showConfirmaImportacao = false;
        },
        closeForm: function closeForm() {
            // this.$router.go(-1)
            this.$emit('closeform');
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"]
    },

    created: function created() {
        this.loadData();
    },
    mounted: function mounted() {
        var _this2 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var isValid;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiValidaLimitePlano"])(_this2, 'importarcadastros');

                        case 2:
                            isValid = _context2.sent;

                            if (!isValid) _this2.closeForm();

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    }
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main__);
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {

    return {
      showForm: false, //exibe a tela de manutencao
      filial: '',
      codfil: '',
      metadata: this.$store.getters.getEntities.metadata,
      filter: '',
      filesJson: [],
      resultList: [],
      showSelecionaArquivos: true,
      showConfirmaImportacao: false,
      xmlcount: 0,
      xmlhist: ''
    };
  },


  computed: {
    qtFiles: function qtFiles() {
      return this.filesJson.length;
    },
    xmlhistList: function xmlhistList() {
      return this.$store.getters.getXMLHistList;
    }

  },

  filters: {
    getText: function getText(value, metadata) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["getText"])(value, metadata);
    }
  },

  methods: {
    handleFileSelectBtn: function handleFileSelectBtn() {
      //BOTAO SELECIONAR ARQUIVOS
      this.$refs.file.value = '';
      this.$refs.file.click();
    },
    handleFileUpload: function handleFileUpload() {
      //EVENTO AO SELECIONAR ARQUIVOS
      //EFETUA A LEITURA DE CADA ARQUIVO SELECIONADO ATRAVES DO SERVIDOR (SERVIDOR RETORNA O XML)

      //console.log(this.$refs.file.files)

      var files = this.$refs.file.files;
      this.filesJson = [];

      if (files.length > 100) {
        this.$erpToastError('Seleção não permitida. O limite máximo é de 100 arquivos por importação.');
        return;
      }

      var self = this;

      //formData.append('file', this.selectedFile)

      var _loop = function _loop() {
        var file = files[i];
        var reader = new FileReader();
        reader.readAsText(file, 'ISO-8859-1');
        reader.onload = function (event) {
          var xml = event.target.result;
          self.readXml(xml, file.name);
        };
      };

      for (var i = 0; i < files.length; i++) {
        _loop();
      }
      this.showSelecionaArquivos = false;
      this.showConfirmaImportacao = true;
    },
    readXml: function readXml(xml, filename) {
      var self = this;
      var formData = new FormData();
      formData.append('file', new Blob([xml]), filename);
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["urlORDS"])(this.$store, 'cg/importreadxml/'), formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (data) {
        var addfile = { filename: filename, xml: data.data };
        self.filesJson.push(addfile);
        console.log(self.filesJson);
      }).catch(function (data) {
        self.$erpToastError('Erro ao efetuar upload do arquivo ' + file.name + ': ' + data.message);
      });
    },
    handleExecutaImportacao: function handleExecutaImportacao() {
      //ENVIA O OBJETO JSON PARA IMPORTAÇÃO
      //RETORNA UM OBJETO ARRAY COM A SITUACAO DE CADA ITEM IMPORTADO E OS ERROS SE HOUVER
      //[ filename: "", status: "ok", errormessage: "", text: ""]

      var sendData = { xmls: this.filesJson, gravaXML: true };
      this.resultList = [];

      var self = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["urlORDS"])(this.$store, 'cg/importxml/'), sendData, {}).then(function (data) {
        // console.log(data.data)
        self.xmlcount = data.data.xmlcount;
        self.resultList = data.data.result;
        self.$erpToastSuccess('Importação executada');
        self.showConfirmaImportacao = false;
      }).catch(function (data) {
        self.$erpToastError('Erro ao efetuar importação ' + data.message);
      });
    },
    search: function search(value) {
      //efetua a pesquisa
      if (value) {
        this.filter = '{"$or":[{"nnf":{"$eq":"' + value + '"}}]}';
      } else {
        this.filter = null;
      }
      this.loadData();
    },
    loadData: function loadData() {
      this.$store.dispatch('loadXMLHist', { filter: this.filter });
      this.offset = '';
    },
    handleRetornar: function handleRetornar() {
      this.resultList = [];
      this.showSelecionaArquivos = true;
      this.showConfirmaImportacao = false;
    },
    handlePDF: function handlePDF(chnfe) {
      //impressao da danfe em PDF

      Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiDownloadPDF"])(this, 'cg/xmlhist/' + chnfe + '/danfe');
    },
    handleDownloadXML: function handleDownloadXML(xml, chnfe) {
      //visualizacao do XML da NFE
      var response = {};
      response.data = xml;
      Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiDownloadFile"])(response, chnfe + '.xml');
    }
  },

  components: {
    BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"]
  },

  created: function created() {
    //this.loadData()
  }
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nfsaida_form__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nfimport_form__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao de DI
            showEntradaForm: false, //exibe a tela de manutencao de nota de entrada
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,
            filterList: [], //lista de filtros aplicados que são exibidos em tela
            moreActionsBarList: [],
            monthFilter: {}
        };
    },

    computed: {
        diList: function diList() {
            return this.$store.getters.getDiList;
        }
    },
    methods: {
        moreActionsGrid: function moreActionsGrid(di) {
            //RETORNA O OBJETO PARA O BOTAO "MAIS ACOES"
            var obj = [];
            if (di.stdi == '1') {
                obj.push({ action: '1', label: 'Gerar NFe', id: di.coddi });
            }
            if (di.codnf) {
                obj.push({ action: '2', label: 'Visualizar Danfe', id: di.codnf });
            }
            return obj;
        },
        optionsGrid: function optionsGrid(di) {
            //RETORNA OBJETO PARA A BARRA DE BOTOES DO GRID DA DI
            if (di.stdi == '0') {
                //DI COM PENDENCIAS
                return { barDefault: true, btnEdit: true, btnDelete: true, btnView: true };
            } else if (di.stdi == '1') {
                //DI PRONTA PARA EMISSAO DE NF
                return { barDefault: true, btnEdit: true, btnDelete: true, btnView: true };
            } else {
                //DI COM NF EMITIDA
                return { barDefault: true, btnEdit: false, btnDelete: false, btnView: true };
            }
        },
        handleEdit: function handleEdit(coddi) {
            //abre formulario para edicao da DI
            this.crud = __WEBPACK_IMPORTED_MODULE_7__main__["SysVars"].crudU; //operacao de edicao
            this.params = { coddi: coddi //codigo da DI
            };this.showForm = true;
        },
        handleDelete: function handleDelete(coddi) {
            //abre formulario para exclusao da DI
            this.crud = __WEBPACK_IMPORTED_MODULE_7__main__["SysVars"].crudD; //operacao de exclusao
            this.params = { coddi: coddi //codigo da DI
            };this.showForm = true;
        },
        handleEditNFe: function handleEditNFe(codnf) {
            //abre formulario para edicao da NFe apos a geracao
            this.crud = __WEBPACK_IMPORTED_MODULE_7__main__["SysVars"].crudU; //operacao de edicao
            this.params = { codnf: codnf //codigo da NF
            };this.showEntradaForm = true;
        },
        handleView: function handleView(coddi) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_7__main__["SysVars"].crudView; //visualizacao
            this.params = {};
            this.params.coddi = coddi; //codigo da nf
            this.showForm = true; //exibe o form de manutencao
        },
        apiPostNFe: function apiPostNFe(coddi) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var sendData, data, codnf;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //EFETUA A GERACAO DA NF DE ENTRADA (NOTA ÚNICA)

                                sendData = { di: { coddi: coddi, diit: [] } //envia o codigo da DI para geracao da nfe

                                };
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["apiORDSpost"])(_this.$store, 'invoice/nfimportacao/di/', sendData, 'post');

                            case 3:
                                data = _context.sent;

                                if (data.items) {
                                    if (data.errmessages) {
                                        _this.$erpToastError('Erro: ' + data.errmessages[0]);
                                    } else {
                                        codnf = data.items[0].codnf;

                                        _this.handleEditNFe(codnf);
                                        _this.$erpToastSuccess('A NF-e foi gerada com sucesso.');
                                    }
                                }

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleAction: function handleAction(act, obj) {
            // BOTAO MAIS ACOES DA DI

            if (act == 1) {
                //GERACAO DA NFE
                this.apiPostNFe(obj.coddi);
            }

            if (act == 2) {
                //PREVIEW DA DANFE
                //VISUALIZACAO DO PDF ANTES DA AUTORIZACAO DA NFE
                if (obj && obj.codnf) Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["apiDownloadPDF"])(this, 'print/previewdanfe/' + obj.codnf);
            }
        },
        handleActionBarList: function handleActionBarList(act) {
            if (act == 1) {
                //efetua importacao do xml da DI
                this.handleImportarXML();
            }
        },
        handleIncluir: function handleIncluir() {
            //Importacao do xml da DI
            this.handleImportarXML();
        },
        closeForm: function closeForm() {
            this.showEntradaForm = false;
            this.showForm = false;
            this.loadData();
        },
        handleSearch: function handleSearch(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"nome":{"$like":"%25' + value + '%25"}},{"numerodi":{"$eq":"' + value + '"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadDiList', { filter: this.filter });
        },
        textST: function textST(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__shared_utils__["getText"])(value, this.metadata.di.stdi);
        },
        data: function data(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__shared_utils__["formatDate"])(value);
        },
        handleImportarXML: function handleImportarXML() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var isValid;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["apiValidaLimitePlano"])(_this2, 'nfimportacao_xmldi');

                            case 2:
                                isValid = _context2.sent;

                                if (!isValid) _this2.closeForm();

                                //SELECIONA ARQUIVO XML PARA IMPORTACAO DA NF DE ENTRADA
                                _this2.$refs.xmlFile.value = '';
                                _this2.$refs.xmlFile.click();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        handleUploadXML: function handleUploadXML() {
            //ENVIA O ARQUIVO XML SELECIONADO PARA EFETUAR IMPORTACAO
            var files = this.$refs.xmlFile.files;
            if (files.length == 0) {
                return;
            }

            var self = this;

            var file = files[0];
            var formData = new FormData();
            formData.append(file.name, file);
            var modulo = 'invoice/di/';
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["urlORDS"])(this.$store, modulo), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                if (response.data.errmessages) {
                    self.$erpToastError('Erro na importação do XML: ' + response.data.errmessages[0]);
                } else {
                    var coddi = response.data.items[0].coddi;
                    self.handleEdit(coddi);
                    self.$erpToastSuccess('O XML foi importado com sucesso.');
                }
            });
            // .catch(function(response){
            // self.$erpToastError(response.data.errmessages)
            // })
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__shared_utils__["formatValue"])(value, 2);
        }

    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_1__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_2__components_bar_grid__["default"], nfimportForm: __WEBPACK_IMPORTED_MODULE_4__nfimport_form__["a" /* default */], nfsaidaForm: __WEBPACK_IMPORTED_MODULE_3__nfsaida_form__["default"]
    },

    created: function created() {
        //botao mais acoes na barra do grid
        this.moreActionsBarList = [{ action: 1, label: 'Importar XML de DI' }];

        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_numbers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_numbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_numbers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nfimport_adicao_form__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nfimport_icms_form__ = __webpack_require__(609);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: {},
        crud: ''
    },

    components: {
        nfimportAdicaoForm: __WEBPACK_IMPORTED_MODULE_4__nfimport_adicao_form__["a" /* default */], nfimportIcmsForm: __WEBPACK_IMPORTED_MODULE_5__nfimport_icms_form__["a" /* default */]
    },

    data: function data() {
        return {
            paramsAdicao: {},
            showFormAdicao: false,
            paramsIcms: {},
            showFormIcms: false,
            showFormDI: true,
            view: false, //variavel para controle de visualizacao ou edicao
            coddi: '',
            di: _extends({}, this.$store.getters.getEntities.di),
            diit: [], //ITENS DA DI
            diad: [], //ADICOES DA DI
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [], //armazena as mensagens de validacao da DI apos a gravacao
            moreActions: [], //botao mais acoes
            unwatch: true
        };
    },


    computed: {
        isView: function isView() {
            //nao possibilita edicao da DI quando status for igual a 2 (NF EMITIDA)
            if (this.view) return true;else return this.di.stdi >= '2';
        },

        isDelete: function isDelete() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudDelete;
        },

        partList: function partList() {
            return this.$store.getters.getPartList[0];
        },

        stdi: function stdi() {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(this.di.stdi, this.metadata.di.stdi);
        },

        title: function title() {
            if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudD) {
                return 'Exclusão da DI';
            } else {
                return 'Importação da DI';
            }
        },

        nates: function nates() {
            if (this.di.nates && this.di.nates.length > 0) {
                return this.di.nates[0];
            } else {
                return null;
            }
        },

        codnates: function codnates() {
            return this.di.codnates;
        },

        selectedNates: function selectedNates() {
            return this.$store.getters.getNates;
        },

        selectedItem: function selectedItem() {
            return this.$store.getters.getItemList;
        },

        vipi_ad: function vipi_ad() {
            var vipi = 0;
            for (var x = 0; x < this.diad.length; x++) {
                vipi = vipi + this.diad[x].vipi;
            }
            return vipi;
        },

        vicm_ad: function vicm_ad() {
            var vicm = 0;
            for (var x = 0; x < this.diad.length; x++) {
                vicm = vicm + this.diad[x].vicm;
            }
            return vicm;
        },

        vipi_it: function vipi_it() {
            var vipi = 0;
            for (var x = 0; x < this.diit.length; x++) {
                vipi = vipi + this.diit[x].vipi;
            }
            return vipi;
        },

        vicm_it: function vicm_it() {
            var vicm = 0;
            for (var x = 0; x < this.diit.length; x++) {
                vicm = vicm + this.diit[x].vicm;
            }
            return vicm;
        },

        valoresDeICMS: function valoresDeICMS() {
            return 'Base: ' + Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(this.vicm_it, 2) + ' Valor: ' + Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(this.vicm_it, 2);
        },

        valoresDeIPI: function valoresDeIPI() {
            return 'Base: ' + Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(this.vipi_it, 2) + ' Valor: ' + Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(this.vipi_it, 2);
        }

    },

    filters: {
        format: function format(value, decimals) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(value, decimals);
        }
    },

    methods: {
        itemChange: function itemChange(idx) {
            //CARREGA A UNIDADE DE MEDIDA QUANDO USUARIO ALTERAR O ITEM

            if (this.unwatch) {
                return;
            }

            if (this.diit[idx].coditem != null) {
                this.changedItemIdx = idx; //GUARDA O INDEX DO ITEM QUE FOI ALTERADO
                this.$store.dispatch('loadItem', { id: this.diit[idx].coditem });
            }
        },


        updateIcmItens: function updateIcmItens() {
            //ATUALIZA O ICMS NOS ITENS DA DI QUANDO ALTERADO O CAMPO DE % DE ICMS NA CAPA DA DI

            for (var x = 0; x < this.diad.length; x++) {
                this.diad[x].aicm = this.di.aicm;
            }

            for (var x = 0; x < this.diit.length; x++) {
                this.diit[x].aicm = this.di.aicm;
            }
        },

        updateIcmDifItens: function updateIcmDifItens() {
            //ATUALIZA O ICMS NOS ITENS DA DI QUANDO ALTERADO O CAMPO DE % DE ICMS NA CAPA DA DI

            for (var x = 0; x < this.diad.length; x++) {
                this.diad[x].picmdif = this.di.picmdif;
            }
        },

        // unidadeItemChange (idx) {
        //     //HABILITA O CAMPO DE FATOR QUANDO ALTERADA A UNIDADE DE MEDIDA DO ITEM PARA UMA UNIDADE NAO RELACIONADA AO ITEM
        //     if (this.unwatch) {
        //         return
        //     }

        //     //SE A UNIDADE INFORMADA FOR IGUAL À UNIDADE DO ITEM
        //     if (this.diit[idx].uni == this.diit[idx].item[0].uni) {
        //         // this.nfit[idx].fator = 1
        //         // this.nfit[idx].obrigaFator = false
        //         return
        //     } else
        //     //SE NAO EXISTIR NENHUMA UNIDADE ALTERNATIVA
        //     if (!this.diit[idx].item[0].itemum.length) {
        //         // this.nfit[idx].obrigaFator = true
        //         // this.nfit[idx].fator = 0
        //         return
        //     }

        //     //PROCURA A UNIDADE INFORMADA NA UNIDADE ALTERNATIVA DO ITEM
        //     let unidadeValida = false
        //     for (let i = 0; i < this.diit[idx].item[0].itemum.length; i++) {
        //         if (this.diit[idx].item[0].itemum[i].uni == this.diit[idx].uni) {
        //             unidadeValida = true
        //             break;
        //         }
        //     }

        //     if (!unidadeValida) {
        //         this.diit[idx].fator = 0
        //         this.diit[idx].obrigaFator = true
        //     } else {
        //         this.diit[idx].obrigaFator = false
        //     }

        // },

        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        data: function data(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatDate"])(value);
        },
        handleDelete: function handleDelete() {
            //BOTAO DE EXCLUSAO DA DI
            if (this.di) {
                this.apiInvoiceDelete();
            }
        },
        handleActions: function handleActions(action) {
            if (action == 6) {}
        },
        handleSalvarDados: function handleSalvarDados() {
            var _this = this;

            //botao salvar dados do cabecalho da DI
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.di.updateitens = true;
                    _this.di.updateadicao = true;
                    _this.apiPost(true);
                }
            });
        },
        handleCalcular: function handleCalcular() {
            this.di.updateitens = true;
            this.di.updateadicao = true;
            this.apiPost(false);
        },
        handleExcluir: function handleExcluir() {
            //BOTAO DE EXCLUSAO DA DI
            this.apiInvoiceDelete();
        },
        apiInvoiceDelete: function apiInvoiceDelete() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var modulo;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //exclui a DI
                                modulo = 'invoice/di/' + _this2.di.coddi;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSdelete"])(_this2.$store, modulo);

                            case 3:
                                _this2.$erpToastSuccess('A DI foi excluída com sucesso.');
                                _this2.$emit('closeform');

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiPost: function apiPost(closeOnSave) {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var sendData, data, x;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a gravacao da DI

                                _this3.di.diit = _this3.diit;
                                _this3.di.diad = _this3.diad;
                                sendData = { di: _this3.di };
                                _context2.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this3.$store, 'invoice/di/', sendData, 'put');

                            case 5:
                                data = _context2.sent;

                                if (data.items) {
                                    _this3.di = {};
                                    _this3.diit = [];
                                    _this3.diad = [];
                                    _this3.di = data.items[0];
                                    for (x = 0; x < _this3.di.diit.length; x++) {
                                        _this3.diit.push(_this3.di.diit[x]);
                                    }
                                    for (x = 0; x < _this3.di.diad.length; x++) {
                                        _this3.diad.push(_this3.di.diad[x]);
                                    }
                                    if (_this3.di.validation) {
                                        _this3.errmessages = JSON.parse(_this3.di.validation);
                                    } else {
                                        _this3.errmessages = [];
                                    }
                                }

                                _this3.updateActions();

                                if (closeOnSave) {
                                    if (_this3.di.stdi == '1') {
                                        _this3.$erpToastSuccess('A DI foi concluída com sucesso');
                                        _this3.closeForm();
                                    }
                                }

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        editAliquotasAdicoes: function editAliquotasAdicoes() {
            //EXIBE O FORMULARIO PARA EDICAO DAS ADICOES
            this.paramsAdicao.di = this.di;
            this.paramsAdicao.diit = this.diit;
            this.paramsAdicao.diad = this.diad;
            this.showFormAdicao = true;
            this.showFormDI = false;
        },
        editIcms: function editIcms() {
            //EXIBE O FORMULARIO PARA EDICAO DE VALOR DO ICMS NOS ITENS
            this.paramsIcms.di = this.di;
            this.paramsIcms.diit = this.diit;
            this.paramsIcms.diad = this.diad;
            this.showFormIcms = true;
            this.showFormDI = false;
        },
        saveAdicao: function saveAdicao() {
            //CONFIRMACAO DE ALTERACAO DAS ALIQUOTAS - ENVIA PARA O SERVIDOR PARA GRAVACAO
            this.closeFormAdicao();
            this.di.updateadicao = true;
            this.di.updateitens = false;
            this.apiPost(false);
        },
        saveIcms: function saveIcms() {
            //CONFIRMACAO DE ALTERACAO DO ICMS NOS ITENS - ENVIA PARA O SERVIDOR PARA GRAVACAO
            this.closeFormIcms();
            this.di.updateadicao = false;
            this.di.updateitens = false;
            this.di.updateicms = true; //variavel para controle de gravacao do valor de icms informado no item
            this.apiPost(false);
        },
        closeFormAdicao: function closeFormAdicao() {
            this.showFormAdicao = false;
            this.showFormDI = true;
        },
        closeFormIcms: function closeFormIcms() {
            this.showFormIcms = false;
            this.showFormDI = true;
        },
        updateActions: function updateActions() {
            this.moreActions = [];
            var act = {};
            // if (this.nf.stnf == '00') {
            //     act = { action: 5, label: 'Excluir NF-e' }
            //     this.moreActions.push(act)
            // }
        },
        loadData: function loadData() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var vm;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this4.$store.dispatch('loadDi', { id: _this4.coddi });

                            case 2:

                                if (_this4.$store.getters.getDi) {
                                    _this4.di = _extends({}, _this4.$store.getters.getDi[0]);
                                    _this4.diit = _this4.di.diit;
                                    _this4.diad = _this4.di.diad;
                                    if (_this4.di.validation) {
                                        _this4.errmessages = JSON.parse(_this4.di.validation);
                                    } else {
                                        _this4.errmessages = [];
                                    }
                                    _this4.updateActions();
                                }

                                // if (this.nf.import_errors > 0) {
                                //     this.$erpToastError('Por favor corrija os erros em destaque para esta nota fiscal')
                                // }

                                //HABILITAR WATCH
                                vm = _this4;

                                setTimeout(function () {
                                    vm.unwatch = false;
                                }, 1000);

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    watch: {
        codnates: function codnates() {
            if (this.unwatch) {
                return;
            }
            if (this.di.codnates != null) {
                this.$store.dispatch('loadNates', { id: this.di.codnates });
            }
        },

        selectedNates: function selectedNates() {
            //HABILITA CAMPO DE NOTA REFERENCIADA CONFORME TIPO DE NATUREZA INFORMADA (DEVOLUCAO, AJUSTE, COMPLEMENTO)
            if (this.unwatch) {
                return;
            }

            this.di.nates = this.selectedNates;
            //this.di.cfop = this.di.nates.cfop -- SEMPRE FORÇAR O USUARIO INFORMAR A CFOP
        },

        selectedItem: function selectedItem() {
            //quando alterar um item, carrega a unidade de medida e a lista de unidades de medida
            if (this.unwatch) return;
            if (!this.selectedItem.length) return;

            this.diit[this.changedItemIdx].uni = this.selectedItem[0].uni;
            this.diit[this.changedItemIdx].item = this.selectedItem;
        },

        'di.aicm': function diAicm() {
            //MONITORA O CAMPO DE % DE ICMS DA CAPA DA DI PARA ATUALIZAR OS ITENS DA DI
            if (this.unwatch) {
                return;
            }
            this.updateIcmItens();
        },

        'di.picmdif': function diPicmdif() {
            //MONITORA O CAMPO DE % DE ICMS DA CAPA DA DI PARA ATUALIZAR OS ITENS DA DI
            if (this.unwatch) {
                return;
            }
            this.updateIcmDifItens();
        },

        'di.cfop': function diCfop() {
            //MONITORA O CAMPO CFOP DA CAPA DA DI PARA ATUALIZAR NAS ADICOES DA DI
            if (this.unwatch) {
                return;
            }
            //ATUALIZA O CFOP NAS ADICOES DA DI QUANDO ALTERADO O CAMPO NA CAPA DA DI
            for (var x = 0; x < this.diad.length; x++) {
                this.diad[x].cfop = this.di.cfop;
            }
        },

        'di.sticm': function diSticm() {
            //MONITORA O CAMPO CFOP DA CAPA DA DI PARA ATUALIZAR NAS ADICOES DA DI
            if (this.unwatch) {
                return;
            }
            //ATUALIZA O CFOP NAS ADICOES DA DI QUANDO ALTERADO O CAMPO NA CAPA DA DI
            for (var x = 0; x < this.diad.length; x++) {
                this.diad[x].sticm = this.di.sticm;
            }
        }

    },

    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.metadata.di.taxamoeda.validator = { required: true, "valida-zero": true

            //this.crudText = this.$crudText(this.crud)

            // if (this.$route.params && this.$route.params.id) {
            //     this.codpedv = this.$route.params.id
            // }
            // else
        };if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudInsert) {} else {
            this.coddi = this.params.coddi;
            this.loadData();
            this.view = this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudView || this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudDelete;
        }

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudDelete) {
            // console.log('teste')
        }

        this.$scrollTo(0);
    }
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfimport_adicao_form_vue__ = __webpack_require__(608);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_787c5545_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfimport_adicao_form_vue__ = __webpack_require__(1689);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfimport_adicao_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_787c5545_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfimport_adicao_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_numbers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_numbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_numbers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: {} //RECEBE 3 OBJETOS: DI, DIIT (itens) E DIAD (adicoes)
    },

    components: {},

    data: function data() {
        return {
            //entidades
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao da nf apos a gravacao
        };
    },


    computed: {
        di: function di() {
            return this.params.di;
        },

        diad: function diad() {
            return this.params.diad;
        },

        diit: function diit() {
            return this.params.diit;
        }

    },

    filters: {
        format: function format(value, decimals) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(value, decimals);
        }
    },

    methods: {
        showAliq: function showAliq(value) {
            return value.aii && value.aii > 0 || value.aipi && value.aipi > 0 || value.apis && value.apis > 0 || value.acofins && value.acofins > 0;
        },

        data: function data(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatDate"])(value);
        },
        handleSalvar: function handleSalvar() {
            //ATUALIZA AS ALIQUOTAS DOS ITENS (OBJETO DIIT) COM AS ALIQUOTAS INFORMADAS NA ADICAO (OBJETO DIAD)
            for (var i = 0; i < this.diit.length; i++) {
                var lAdicao = {};
                for (var x = 0; x < this.diad.length; x++) {
                    if (this.diad[x].nadicao == this.diit[i].nadicao) {
                        lAdicao = this.diad[x];
                    }
                }
                //atualiza as aliquotas da adicao no item
                this.diit[i].aicm = lAdicao.aicm;
                this.diit[i].ricm = lAdicao.ricm;
                this.diit[i].mva = lAdicao.mva;
                this.diit[i].sticm = lAdicao.sticm;
                this.diit[i].motdesicm = lAdicao.motdesicm;
            }
            this.$emit('save');
        },
        closeForm: function closeForm() {
            this.$emit('closeform');
        }
    },

    watch: {},

    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.$scrollTo(0);
    }
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfimport_icms_form_vue__ = __webpack_require__(610);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fab29dc_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfimport_icms_form_vue__ = __webpack_require__(1690);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfimport_icms_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fab29dc_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfimport_icms_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_numbers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_numbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_numbers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: {} //RECEBE 3 OBJETOS: DI, DIIT (itens) E DIAD (adicoes)
    },

    components: {},

    data: function data() {
        return {
            //entidades
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao da nf apos a gravacao
        };
    },


    computed: {
        di: function di() {
            return this.params.di;
        },

        diad: function diad() {
            return this.params.diad;
        },

        diit: function diit() {
            return this.params.diit;
        }
    },

    filters: {
        format: function format(value, decimals) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(value, decimals);
        }
    },

    methods: {
        data: function data(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatDate"])(value);
        },
        handleSalvar: function handleSalvar() {
            // for (let i = 0; i < this.diit.length; i++) {
            //     let lAdicao = {}
            //     for (let x = 0; x < this.diad.length; x++) {
            //         if (this.diad[x].nadicao == this.diit[i].nadicao) {
            //             lAdicao = this.diad[x]
            //         }
            //     }
            //     //atualiza as aliquotas da adicao no item
            //     this.diit[i].aicm = lAdicao.aicm
            //     this.diit[i].ricm = lAdicao.ricm
            //     this.diit[i].mva = lAdicao.mva
            //     this.diit[i].sticm = lAdicao.sticm
            //     this.diit[i].motdesicm = lAdicao.motdesicm
            // }
            this.$emit('save');
        },
        closeForm: function closeForm() {
            this.$emit('closeform');
        }
    },

    watch: {},

    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
        this.$scrollTo(0);
    }
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nfsaida_form__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__duimp_form__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao de DI
            showEntradaForm: false, //exibe a tela de manutencao de nota de entrada
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,
            filterList: [], //lista de filtros aplicados que são exibidos em tela
            moreActionsBarList: [],
            monthFilter: {},
            showModalImport: false,
            duimpNumber: '',
            errorMsg: ''
        };
    },

    computed: {
        diList: function diList() {
            return this.$store.getters.getDuimpList;
        }
    },
    methods: {
        moreActionsGrid: function moreActionsGrid(di) {
            var obj = [];
            if (di.stdi == '1') {
                obj.push({ action: '1', label: 'Gerar NFe', id: di.coddi });
            }
            if (di.codnf) {
                obj.push({ action: '2', label: 'Visualizar Danfe', id: di.codnf });
            }
            return obj;
        },
        optionsGrid: function optionsGrid(di) {
            if (di.stdi == '0') {
                return { barDefault: true, btnEdit: true, btnDelete: true, btnView: true };
            } else if (di.stdi == '1') {
                return { barDefault: true, btnEdit: true, btnDelete: true, btnView: true };
            } else {
                return { barDefault: true, btnEdit: false, btnDelete: false, btnView: true };
            }
        },
        handleEdit: function handleEdit(coddi) {
            this.crud = __WEBPACK_IMPORTED_MODULE_8__main__["SysVars"].crudU;
            this.params = { coddi: coddi };
            this.showForm = true;
        },
        handleDelete: function handleDelete(coddi) {
            this.crud = __WEBPACK_IMPORTED_MODULE_8__main__["SysVars"].crudD;
            this.params = { coddi: coddi };
            this.showForm = true;
        },
        handleEditNFe: function handleEditNFe(codnf) {
            this.crud = __WEBPACK_IMPORTED_MODULE_8__main__["SysVars"].crudU;
            this.params = { codnf: codnf };
            this.showEntradaForm = true;
        },
        handleView: function handleView(coddi) {
            this.crud = __WEBPACK_IMPORTED_MODULE_8__main__["SysVars"].crudView;
            this.params = {};
            this.params.coddi = coddi;
            this.showForm = true;
        },
        apiPostNFe: function apiPostNFe(coddi) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var sendData, data, codnf;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                sendData = { di: { coddi: coddi, diit: [] } };
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiORDSpost"])(_this.$store, 'invoice/nfimportacao/di/', sendData, 'post');

                            case 3:
                                data = _context.sent;

                                if (data.items) {
                                    if (data.errmessages) {
                                        _this.$erpToastError('Erro: ' + data.errmessages[0]);
                                    } else {
                                        codnf = data.items[0].codnf;

                                        _this.handleEditNFe(codnf);
                                        _this.$erpToastSuccess('A NF-e foi gerada com sucesso.');
                                    }
                                }

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleAction: function handleAction(act, obj) {
            if (act == 1) {
                this.apiPostNFe(obj.coddi);
            }
            if (act == 2) {
                if (obj && obj.codnf) Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiDownloadPDF"])(this, 'print/previewdanfe/' + obj.codnf);
            }
        },
        handleActionBarList: function handleActionBarList(act) {
            if (act == 1) {
                this.handleImportarDuimp();
            }
        },
        handleIncluir: function handleIncluir() {
            this.handleImportarDuimp();
        },
        closeForm: function closeForm() {
            this.showEntradaForm = false;
            this.showForm = false;
            this.loadData();
        },
        handleSearch: function handleSearch(value) {
            this.filter = '{"$or":[{"nome":{"$like":"%25' + value + '%25"}},{"numerodi":{"$eq":"' + value + '"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadDuimpList', { filter: this.filter });
        },
        textST: function textST(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["getText"])(value, this.metadata.di.stdi);
        },
        data: function data(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatDate"])(value);
        },
        handleImportarDuimp: function handleImportarDuimp() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var isValid;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiValidaLimitePlano"])(_this2, 'nfimportacao_duimp');

                            case 2:
                                isValid = _context2.sent;

                                if (isValid) {
                                    _context2.next = 5;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 5:

                                _this2.duimpNumber = '';
                                _this2.errorMsg = '';
                                _this2.showModalImport = true;

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        executeImport: function executeImport() {
            if (!this.duimpNumber) {
                this.$erpToastError('Informe o número da DUIMP');
                return;
            }

            var self = this;
            var sendData = { numero: this.duimpNumber };
            this.errorMsg = '';

            var modulo = 'invoice/duimp/';
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$appLoading(true);
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["urlORDS"])(this.$store, modulo), sendData).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$appLoading(false);
                if (response.data.errmessages) {
                    var msg = response.data.errmessages[0];

                    // Tenta limpar a mensagem se for um JSON aninhado
                    var cleanMsg = function cleanMsg(text) {
                        if (!text || typeof text !== 'string') return text;
                        if (text.includes('): {')) {
                            text = text.substring(text.indexOf('): ') + 3);
                        }
                        try {
                            var obj = JSON.parse(text);
                            if (obj.error) return cleanMsg(obj.error);
                            if (obj.message) return cleanMsg(obj.message);
                            if (obj.detail) return cleanMsg(obj.detail);
                        } catch (e) {}
                        return text;
                    };

                    self.errorMsg = cleanMsg(msg);
                    self.$erpToastError('Erro na importação da DUIMP: ' + self.errorMsg);
                } else {
                    self.showModalImport = false;
                    var coddi = response.data.items[0].coddi;
                    self.handleEdit(coddi);
                    self.$erpToastSuccess('A DUIMP foi importada com sucesso.');
                }
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$appLoading(false);
                var msg = 'Erro ao processar requisição no servidor.';
                if (error.response && error.response.data && error.response.data.message) {
                    msg = error.response.data.message;
                } else if (error.message) {
                    msg = error.message;
                }
                self.errorMsg = msg;
                self.$erpToastError('Erro na importação: ' + msg);
            });
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatValue"])(value, 2);
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_2__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_3__components_bar_grid__["default"], duimpForm: __WEBPACK_IMPORTED_MODULE_5__duimp_form__["default"], nfsaidaForm: __WEBPACK_IMPORTED_MODULE_4__nfsaida_form__["default"]
    },

    created: function created() {
        this.moreActionsBarList = [{ action: 1, label: 'Importar DUIMP Siscomex' }];

        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_duimp_form_vue__ = __webpack_require__(613);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_11b37aab_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_duimp_form_vue__ = __webpack_require__(1696);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_duimp_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_11b37aab_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_duimp_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_numbers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_numbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_numbers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nfimport_adicao_form__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nfimport_icms_form__ = __webpack_require__(609);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: {},
        crud: ''
    },

    components: {
        nfimportAdicaoForm: __WEBPACK_IMPORTED_MODULE_4__nfimport_adicao_form__["a" /* default */], nfimportIcmsForm: __WEBPACK_IMPORTED_MODULE_5__nfimport_icms_form__["a" /* default */]
    },

    data: function data() {
        return {
            paramsAdicao: {},
            showFormAdicao: false,
            paramsIcms: {},
            showFormIcms: false,
            showFormDI: true,
            view: false, //variavel para controle de visualizacao ou edicao
            coddi: '',
            di: _extends({}, this.$store.getters.getEntities.di),
            diit: [], //ITENS DA DI
            diad: [], //ADICOES DA DI
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [], //armazena as mensagens de validacao da DI apos a gravacao
            moreActions: [], //botao mais acoes
            unwatch: true
        };
    },


    computed: {
        isView: function isView() {
            //nao possibilita edicao da DI quando status for igual a 2 (NF EMITIDA)
            if (this.view) return true;else return this.di.stdi >= '2';
        },

        isDelete: function isDelete() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudDelete;
        },

        partList: function partList() {
            return this.$store.getters.getPartList[0];
        },

        stdi: function stdi() {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(this.di.stdi, this.metadata.di.stdi);
        },

        title: function title() {
            if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudD) {
                return 'Exclusão da DUIMP';
            } else {
                return 'Importação da DUIMP';
            }
        },

        nates: function nates() {
            if (this.di.nates && this.di.nates.length > 0) {
                return this.di.nates[0];
            } else {
                return null;
            }
        },

        codnates: function codnates() {
            return this.di.codnates;
        },

        selectedNates: function selectedNates() {
            return this.$store.getters.getNates;
        },

        selectedItem: function selectedItem() {
            return this.$store.getters.getItemList;
        },

        vipi_it: function vipi_it() {
            var vipi = 0;
            for (var x = 0; x < this.diit.length; x++) {
                vipi = vipi + this.diit[x].vipi;
            }
            return vipi;
        },

        vicm_it: function vicm_it() {
            var vicm = 0;
            for (var x = 0; x < this.diit.length; x++) {
                vicm = vicm + this.diit[x].vicm;
            }
            return vicm;
        },

        vipi_ad: function vipi_ad() {
            var vipi = 0;
            for (var x = 0; x < this.diad.length; x++) {
                vipi = vipi + this.diad[x].vipi;
            }
            return vipi;
        },

        vicm_ad: function vicm_ad() {
            var vicm = 0;
            for (var x = 0; x < this.diad.length; x++) {
                vicm = vicm + this.diad[x].vicm;
            }
            return vicm;
        },

        valoresDeICMS: function valoresDeICMS() {
            return 'Base: ' + Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(this.vicm_it, 2) + ' Valor: ' + Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(this.vicm_it, 2);
        },

        valoresDeIPI: function valoresDeIPI() {
            return 'Base: ' + Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(this.vipi_it, 2) + ' Valor: ' + Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(this.vipi_it, 2);
        }
    },

    filters: {
        format: function format(value, decimals) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(value, decimals);
        }
    },

    methods: {
        itemChange: function itemChange(idx) {
            if (this.unwatch) return;
            if (this.diit[idx].coditem != null) {
                this.changedItemIdx = idx;
                this.$store.dispatch('loadItem', { id: this.diit[idx].coditem });
            }
        },


        updateIcmItens: function updateIcmItens() {
            for (var x = 0; x < this.diad.length; x++) {
                this.diad[x].aicm = this.di.aicm;
            }
            for (var x = 0; x < this.diit.length; x++) {
                this.diit[x].aicm = this.di.aicm;
            }
        },

        updateIcmDifItens: function updateIcmDifItens() {
            for (var x = 0; x < this.diad.length; x++) {
                this.diad[x].picmdif = this.di.picmdif;
            }
        },

        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        data: function data(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatDate"])(value);
        },
        handleSalvarDados: function handleSalvarDados() {
            var _this = this;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.di.updateitens = true;
                    _this.di.updateadicao = true;
                    _this.apiPost(true);
                }
            });
        },
        handleActions: function handleActions(action) {
            if (action == 6) {}
        },
        updateActions: function updateActions() {
            this.moreActions = [];
            var act = {};
        },
        handleCalcular: function handleCalcular() {
            this.di.updateitens = true;
            this.di.updateadicao = true;
            this.apiPost(false);
        },
        handleExcluir: function handleExcluir() {
            this.apiInvoiceDelete();
        },
        apiInvoiceDelete: function apiInvoiceDelete() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var modulo;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                modulo = 'invoice/duimp/' + _this2.di.coddi;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSdelete"])(_this2.$store, modulo);

                            case 3:
                                _this2.$erpToastSuccess('A DUIMP foi excluída com sucesso.');
                                _this2.$emit('closeform');

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiPost: function apiPost(closeOnSave) {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var sendData, data, x;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this3.di.diit = _this3.diit;
                                _this3.di.diad = _this3.diad;
                                sendData = { di: _this3.di };
                                _context2.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this3.$store, 'invoice/duimp/', sendData, 'put');

                            case 5:
                                data = _context2.sent;

                                if (data.items) {
                                    _this3.di = {};
                                    _this3.diit = [];
                                    _this3.diad = [];
                                    _this3.di = data.items[0];
                                    for (x = 0; x < _this3.di.diit.length; x++) {
                                        _this3.diit.push(_this3.di.diit[x]);
                                    }
                                    for (x = 0; x < _this3.di.diad.length; x++) {
                                        _this3.diad.push(_this3.di.diad[x]);
                                    }
                                    if (_this3.di.validation) {
                                        _this3.errmessages = JSON.parse(_this3.di.validation);
                                    } else {
                                        _this3.errmessages = [];
                                    }
                                }

                                _this3.updateActions();

                                if (closeOnSave) {
                                    if (_this3.di.stdi == '1') {
                                        _this3.$erpToastSuccess('A DUIMP foi concluída com sucesso');
                                        _this3.closeForm();
                                    }
                                }

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        editAliquotasAdicoes: function editAliquotasAdicoes() {
            this.paramsAdicao.di = this.di;
            this.paramsAdicao.diit = this.diit;
            this.paramsAdicao.diad = this.diad;
            this.showFormAdicao = true;
            this.showFormDI = false;
        },
        editIcms: function editIcms() {
            this.paramsIcms.di = this.di;
            this.paramsIcms.diit = this.diit;
            this.paramsIcms.diad = this.diad;
            this.showFormIcms = true;
            this.showFormDI = false;
        },
        saveAdicao: function saveAdicao() {
            this.closeFormAdicao();
            this.di.updateadicao = true;
            this.di.updateitens = false;
            this.apiPost(false);
        },
        saveIcms: function saveIcms() {
            this.closeFormIcms();
            this.di.updateadicao = false;
            this.di.updateitens = false;
            this.di.updateicms = true;
            this.apiPost(false);
        },
        closeFormAdicao: function closeFormAdicao() {
            this.showFormAdicao = false;
            this.showFormDI = true;
        },
        closeFormIcms: function closeFormIcms() {
            this.showFormIcms = false;
            this.showFormDI = true;
        },
        loadData: function loadData() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var vm;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this4.$store.dispatch('loadDuimp', { id: _this4.coddi });

                            case 2:

                                if (_this4.$store.getters.getDuimp) {
                                    _this4.di = _extends({}, _this4.$store.getters.getDuimp[0]);
                                    _this4.diit = _this4.di.diit;
                                    _this4.diad = _this4.di.diad;
                                    if (_this4.di.validation) {
                                        _this4.errmessages = JSON.parse(_this4.di.validation);
                                    } else {
                                        _this4.errmessages = [];
                                    }
                                    _this4.updateActions();
                                }

                                vm = _this4;

                                setTimeout(function () {
                                    vm.unwatch = false;
                                }, 1000);

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    watch: {
        codnates: function codnates() {
            if (this.unwatch) return;
            if (this.di.codnates != null) {
                this.$store.dispatch('loadNates', { id: this.di.codnates });
            }
        },

        selectedNates: function selectedNates() {
            if (this.unwatch) return;
            this.di.nates = this.selectedNates;
        },

        selectedItem: function selectedItem() {
            if (this.unwatch) return;
            if (!this.selectedItem.length) return;
            this.diit[this.changedItemIdx].uni = this.selectedItem[0].uni;
            this.diit[this.changedItemIdx].item = this.selectedItem;
        },

        'di.aicm': function diAicm() {
            if (this.unwatch) return;
            this.updateIcmItens();
        },

        'di.picmdif': function diPicmdif() {
            if (this.unwatch) return;
            this.updateIcmDifItens();
        },

        'di.cfop': function diCfop() {
            if (this.unwatch) return;
            for (var x = 0; x < this.diad.length; x++) {
                this.diad[x].cfop = this.di.cfop;
            }
        },

        'di.sticm': function diSticm() {
            if (this.unwatch) return;
            for (var x = 0; x < this.diad.length; x++) {
                this.diad[x].sticm = this.di.sticm;
            }
        }
    },

    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
        this.metadata.di.taxamoeda.validator = { required: true, "valida-zero": true };
        if (this.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudInsert) {
            this.coddi = this.params.coddi;
            this.loadData();
            this.view = this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudView || this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudDelete;
        }
        this.$scrollTo(0);
    }
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_filter_list__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__receber_list_cnab_vue__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customer_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__financeiro_form__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_csvReport__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_csvReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__shared_csvReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,
            moreActionsBarList: [],
            monthFilter: {},
            operacao: {},

            tabs: [{ title: 'Gerar Remessa' }, { title: 'Arquivos de Remessa Gerados' }, { title: 'Arquivos de Retorno Importados' }, { title: 'Entradas Rejeitadas' }, { title: 'Títulos Sem Conta Vinculada', count: null }],
            activeTab: 0,

            errmessages: [],

            url: '',
            urlsemvinculo: 'cnab/ar/vincularconta/',
            urldesvincular: 'cnab/ar/desvincularconta/',
            urlpendente: 'cnab/ar/pendencia/',
            urlremessa: 'cnab/ar/remessa/',
            urlexcluirremessa: 'cnab/ar/excluirremessa/',
            urlrej: 'cnab/ar/rejeitados/',
            urlretorno: 'cnab/ar/retorno/',

            showDetalhesRetorno: false,
            dadosRetorno: {},
            cnabErrors: [],

            contaSelecionada: null,
            showModalErros: false,
            showModalTitulosRemessa: false,
            titulos: [],
            retornoImportadosItem: {},

            titulosCheckAll: false,

            crud: __WEBPACK_IMPORTED_MODULE_10__main__["SysVars"].crudU,
            showFormPart: false,
            codpart: null,

            showFormFin: false,
            codfin: null,

            confirmaExcluirRemessa: false,
            codcnabExcluir: null,
            messageExcluir: 'Os títulos desta remessa ficarão disponíveis para nova geração de remessa. Confirma a exclusão desta remessa?',
            titleExcluir: 'Excluir Remessa'

        };
    },

    computed: {
        contasconfiguradas: function contasconfiguradas() {
            if (this.$store.getters.getCnabPendente[0]) return this.$store.getters.getCnabPendente[0].contasconfiguradas;else return 0;
        },
        cnabSemVinculo: function cnabSemVinculo() {
            return this.$store.getters.getCnabSemVinculo;
        },
        totalCnabSemVinculo: function totalCnabSemVinculo() {
            return this.cnabSemVinculo && this.cnabSemVinculo.length ? this.cnabSemVinculo.reduce(function (a, b) {
                return a + b.vlr;
            }, 0) : 0;
        },
        totalCnabSemVinculoChecked: function totalCnabSemVinculoChecked() {
            return this.cnabSemVinculo && this.cnabSemVinculo.length ? this.cnabSemVinculo.filter(function (el) {
                return el.isChecked === true;
            }).reduce(function (total, current) {
                return total + current.vlr;
            }, 0) : 0;
        },
        cnabPendente: function cnabPendente() {
            if (this.$store.getters.getCnabPendente[0]) return this.$store.getters.getCnabPendente[0].contas;else return [];
        },
        cnabRemList: function cnabRemList() {
            return this.$store.getters.getCnabRemList;
        },
        cnabRetList: function cnabRetList() {
            return this.$store.getters.getCnabRetList;
        },
        cnabRetDet: function cnabRetDet() {
            if (this.$store.getters.getCnabRetDetList.length && this.$store.getters.getCnabRetDetList[0]) return this.$store.getters.getCnabRetDetList[0];else return {};
        },
        cnabRetDetList: function cnabRetDetList() {
            if (this.$store.getters.getCnabRetDetList.length && this.$store.getters.getCnabRetDetList[0].detalhes) {
                return this.$store.getters.getCnabRetDetList[0].detalhes;
            } else {
                return [];
            }
        },
        cnabRetDetmessages: function cnabRetDetmessages() {
            if (this.$store.getters.getCnabRetDetList.length) {
                return this.$store.getters.getCnabRetDetList[0].messages;
            } else {
                return null;
            }
        },
        cnabRejList: function cnabRejList() {
            return this.$store.getters.getCnabRejList;
        }
    },

    watch: {
        titulosCheckAll: function titulosCheckAll() {
            var _this = this;

            if (this.titulosCheckAll) {
                this.cnabSemVinculo.forEach(function (titulo) {
                    _this.$set(titulo, 'isChecked', true);
                });
            } else {
                this.cnabSemVinculo.forEach(function (titulo) {
                    _this.$set(titulo, 'isChecked', false);
                });
            }
        }
    },

    methods: {
        closeFormFin: function closeFormFin() {
            this.showFormFin = false;
            this.codfin = null;
            this.loadData();
        },
        handleEditFin: function handleEditFin(id) {
            this.codfin = id;
            this.crud = __WEBPACK_IMPORTED_MODULE_10__main__["SysVars"].crudU;
            this.showFormFin = true;
        },
        closeFormPart: function closeFormPart() {
            this.showFormPart = false;
            this.codpart = null;
            this.loadData();
        },
        editPart: function editPart(tipo, codpart) {
            //abre a tela de edicao
            if (tipo == 'part') {
                this.crud = __WEBPACK_IMPORTED_MODULE_10__main__["SysVars"].crudU; //update
                this.codpart = codpart;
                this.showFormPart = true;
            }
        },
        changeTab: function changeTab(idx) {
            //mudança de pagina
            this.activeTab = idx;
            this.loadData();
        },
        handleRemoverTituloRemessa: function handleRemoverTituloRemessa(item) {
            var sendData = {
                titulos: []
            };

            if (item) {
                sendData.titulos.push({ codfin: item.codfin });
            } else {
                if (this.titulos) {
                    this.titulos.forEach(function (tit, index) {
                        console.log(tit);
                        if (tit.isChecked) {
                            sendData.titulos.push({ codfin: tit.codfin });
                        }
                    });
                }
            }

            var self = this;
            Object(__WEBPACK_IMPORTED_MODULE_7__shared_api_functions__["apiORDSpost"])(this.$store, this.urldesvincular, sendData, 'post').then(function () {
                self.$erpToastSuccess('Título desvinculado com sucesso!');
                self.closeModalTitulosRemessa();

                self.changeTab('1');
            });
        },
        handleCloseMessage: function handleCloseMessage() {
            this.confirmaExcluirRemessa = false;
        },
        handleConfirmaExcluirRemessa: function handleConfirmaExcluirRemessa(codcnab) {
            this.confirmaExcluirRemessa = true;
            this.codcnabExcluir = codcnab;
        },
        handleExcluirRemessa: function handleExcluirRemessa() {
            this.confirmaExcluirRemessa = false;
            var sendData = {
                remessa: this.codcnabExcluir
            };

            var self = this;
            Object(__WEBPACK_IMPORTED_MODULE_7__shared_api_functions__["apiORDSpost"])(this.$store, this.urlexcluirremessa, sendData, 'post').then(function () {
                self.$erpToastSuccess('Remessa excluída com sucesso!');
                self.changeTab('1');
            });
        },
        handleShowTitulos: function handleShowTitulos(cta) {
            var _this2 = this;

            this.titulos = cta.titulos;

            if (this.titulos) {
                this.titulos.forEach(function (fin, index) {
                    _this2.$set(_this2.titulos[index], 'isChecked', false);
                });
            }

            this.showModalTitulosRemessa = true;
        },
        handleConfigurarConta: function handleConfigurarConta() {
            this.$router.push('/cta');
        },
        handleDownloadRemessa: function handleDownloadRemessa(codcnab) {
            //DOWNLOAD DO ARQUIVO DE REMESSA
            Object(__WEBPACK_IMPORTED_MODULE_7__shared_api_functions__["apiDownload"])(this, this.urlremessa + codcnab, null, 'get');
        },
        someCtaChecked: function someCtaChecked() {
            return this.cnabSemVinculo.some(function (cta) {
                return cta.hasOwnProperty('isChecked') && cta.isChecked === true;
            });
        },
        showSelectVincularConta: function showSelectVincularConta() {
            if (this.someCtaChecked()) {
                jQuery('[data-toggle="collapse"]').collapse('show');
            } else {
                jQuery('[data-toggle="collapse"]').collapse('hide');
            }
        },
        handleVincular: function handleVincular() {
            var _this3 = this;

            var titulosMarcados = this.cnabSemVinculo.filter(function (obj) {
                return obj.isChecked == true;
            });

            if (!titulosMarcados) {
                this.$erpToastError('É necessário selecionar pelo menos um título.');
                return;
            }

            if (!this.contaSelecionada) {
                this.$erpToastError('É necessário selecionar uma conta.');
                return;
            }

            var data = [];

            titulosMarcados.map(function (titulo) {
                data.push({
                    conta: _this3.contaSelecionada,
                    codfin: titulo.codfin
                });
            });

            var sendData = { titulos: data };
            this.handleGravarVinculo(sendData);
        },
        handleGravarVinculo: function handleGravarVinculo(sendData) {
            if (!sendData) {
                this.$erpToastError('Não há dados a serem gravados.');
                return;
            }

            Object(__WEBPACK_IMPORTED_MODULE_7__shared_api_functions__["apiORDSpost"])(this.$store, this.urlsemvinculo, sendData, 'post');

            this.$erpToastSuccess('Título(s) vinculado(s) com sucesso!');

            this.loadData();
        },
        handleGerarRemessa: function handleGerarRemessa(obj) {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var sendData, data, codcnab;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //GERACAO DO ARQUIVO DE REMESSA PARA A CONTA SELECIONADA
                                sendData = {
                                    cnab: { codcta: obj.codcta }
                                };

                                _this4.$set(obj, 'errmessages', null);
                                _this4.$set(obj, 'errtitulos', null);
                                //DEPOIS DE GERADO SERÁ FEITO O DOWNLOAD DO ARQUIVO

                                _context.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_7__shared_api_functions__["apiORDSpost"])(_this4.$store, _this4.urlremessa, sendData, 'post');

                            case 5:
                                data = _context.sent;

                                if (!data.errmessages) {
                                    _context.next = 12;
                                    break;
                                }

                                // this.$set(obj, 'errmessages', data.errmessages)
                                obj.errmessages = data.errmessages;
                                _this4.$erpToastError('Ocorreu erro ao gerar arquivo de remessa.');
                                return _context.abrupt('return');

                            case 12:
                                if (!data.titulos) {
                                    _context.next = 18;
                                    break;
                                }

                                obj.errtitulos = data.titulos;
                                _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                return _context.abrupt('return');

                            case 18:
                                codcnab = data.codcnab;

                                Object(__WEBPACK_IMPORTED_MODULE_7__shared_api_functions__["apiDownload"])(_this4, _this4.urlremessa + codcnab, null, 'get');
                                _this4.$erpToastSuccess('Arquivo gerado');

                            case 21:
                                _this4.loadData();

                            case 22:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this4);
            }))();
        },
        handleImportarRetorno: function handleImportarRetorno() {
            //SELECIONA ARQUIVO DE RETORNO
            this.errmessages = [];
            this.$refs.retFile.value = '';
            this.$refs.retFile.click();
        },
        handleUploadRetorno: function handleUploadRetorno() {
            //ENVIA O ARQUIVO DE RETORNO SELECIONADO
            var files = this.$refs.retFile.files;
            if (files.length == 0) {
                return;
            }

            var self = this;

            var file = files[0];
            var formData = new FormData();
            formData.append(file.name, file);
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_7__shared_api_functions__["urlORDS"])(this.$store, this.urlretorno), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'filename': file.name
                }
            }).then(function (response) {
                if (response.data.errmessages) {
                    self.errmessages = response.data.errmessages;
                } else {
                    // console.log(response);
                    var data = response.data;
                    console.log(data);
                    self.$erpToastSuccess('O arquivo foi importado.');
                    self.activeTab = 2;
                    self.loadData();
                    if (data) {
                        self.handleDetalhesRetorno(data);
                    }
                }
            });
        },
        handleAction: function handleAction(act, codnf) {},
        handleExportRetorno: function handleExportRetorno() {
            //EXPORTA REGISTROS DO RETORNO PARA PLANILHA
            var data = this.cnabRetDetList.map(function (det) {
                return {
                    data: Object(__WEBPACK_IMPORTED_MODULE_8__shared_utils__["formatDate"])(det.dtoco),
                    ocorrencia: det.ocorrencia,
                    doc: det.doc,
                    nome: det.par_nome,
                    motivo: det.motivo,
                    tarifa: Object(__WEBPACK_IMPORTED_MODULE_8__shared_utils__["formatValue"])(det.vtarifa, 2)
                };
            });
            var csv = Object(__WEBPACK_IMPORTED_MODULE_9__shared_csvReport__["objectToCsv"])(data);
            Object(__WEBPACK_IMPORTED_MODULE_9__shared_csvReport__["downloadCsvReport"])(csv);
        },
        handleExportRejeitados: function handleExportRejeitados() {
            var _this5 = this;

            //EXPORTA TITULOS REJEITADOS PLANILHA
            var data = this.cnabRejList.map(function (det) {
                return {
                    data: Object(__WEBPACK_IMPORTED_MODULE_8__shared_utils__["formatDate"])(det.dtremessa),
                    tipo: _this5.textSTREMESSA(det.stremessacnab),
                    doc: det.doc,
                    nome: det.part_nome,
                    motivo: det.motivo,
                    arquivo_retorno: det.ret_filename
                };
            });
            var csv = Object(__WEBPACK_IMPORTED_MODULE_9__shared_csvReport__["objectToCsv"])(data);
            Object(__WEBPACK_IMPORTED_MODULE_9__shared_csvReport__["downloadCsvReport"])(csv);
        },
        viewErrors: function viewErrors(item) {
            var erros = JSON.parse(item.erros);
            this.retornoImportadosItem.errors = erros.errmessages;
            this.retornoImportadosItem.filename = item.filename;
            this.showModalErros = true;
        },
        closeModalErros: function closeModalErros() {
            this.showModalErros = false;
        },
        closeModalTitulosRemessa: function closeModalTitulosRemessa() {
            this.showModalTitulosRemessa = false;
        },
        handleActionBarList: function handleActionBarList(act) {
            // if (act == 0) {
            //     //efetua download dos xmls de nfe no periodo selecionado
            //     var data = { datareferencia: this.monthFilter.startDate }
            //     apiDownload(this, 'print/xmlfiles/', data, 'post')
            // }
            // if (act == 1) {
            //     //efetua importacao do xml de nf-e
            //     this.handleImportarRetorno()
            // }
            // if (act == 2) {
            //     //exportar a lista de notas para planilha
            //     const data = this.nfList.map(nf => ({
            //         data: this.data(nf.data),
            //         serie: nf.serie,
            //         numeronf: nf.nf,
            //         operacao: this.operacaoNf(nf.operacaonf),
            //         natureza: nf.descricao,
            //         nome: nf.nome,
            //         total: formatValue(nf.totger,2)
            //     }))
            //     const csv = objectToCsv(data)
            //     downloadCsvReport(csv)
            // }

        },
        closeForm: function closeForm() {},
        handleSearch: function handleSearch(value) {
            //efetua a pesquisa
            //this.filter = '{"$or":[{"nome":{"$like":"%25' + value + '%25"}},{"nf":{"$eq":"' + value + '"}}]}'
            this.loadData();
        },
        handleDetalhesRetorno: function handleDetalhesRetorno(retorno) {
            var _this6 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var err;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //EXIBE OS REGISTROS DE DETALHES DO RETORNO CNAB
                                _this6.errmessages = [];
                                _this6.cnabErrors = [];
                                _this6.dadosRetorno = retorno;
                                _context2.next = 5;
                                return _this6.$store.dispatch('loadCnabRetDetList', { id: retorno.codcnab });

                            case 5:
                                _this6.showDetalhesRetorno = true;

                                // console.log(this.$store.getters.getCnabRetDetList)

                                if (_this6.cnabRetDet) {
                                    _this6.dadosRetorno = _this6.cnabRetDet;

                                    // Carrega erros de identificação salvos na nova coluna CLOB do banco
                                    if (_this6.cnabRetDet.erros_identificacao) {
                                        try {
                                            _this6.cnabErrors = JSON.parse(_this6.cnabRetDet.erros_identificacao);
                                        } catch (e) {
                                            console.error('Erro ao processar erros_identificacao:', e);
                                            _this6.cnabErrors = [];
                                        }
                                    }
                                }

                                if (_this6.cnabRetDetmessages) {
                                    //exibe a lista de erros encontrados no arquivo
                                    err = JSON.parse(_this6.cnabRetDetmessages);

                                    _this6.errmessages = err.errmessages;
                                }

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this6);
            }))();
        },
        closeDetalhesRetorno: function closeDetalhesRetorno() {
            //FECHA TELA DE DETALHES DO RETORNO
            this.showDetalhesRetorno = false;
            this.cnabErrors = [];
        },
        loadData: function loadData() {
            var _this7 = this;

            if (this.activeTab == '0') {
                this.$store.dispatch('loadCnabPendente');
            }
            if (this.activeTab == '1') {
                this.$store.dispatch('loadCnabRemList');
            }
            if (this.activeTab == '2') {
                this.$store.dispatch('loadCnabRetList');
            }
            if (this.activeTab == '3') {
                this.$store.dispatch('loadCnabRejList');
            }

            this.$store.dispatch('loadCnabSemVinculo');

            setTimeout(function () {
                _this7.tabs[4].count = _this7.cnabSemVinculo.length;
            }, 1000);

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
            });
        },
        textSTREMESSA: function textSTREMESSA(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_8__shared_utils__["getText"])(value, this.metadata.fin.stremessacnab);
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_1__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_2__components_bar_grid__["default"], FilterList: __WEBPACK_IMPORTED_MODULE_3__components_filter_list__["a" /* default */], Cnab: __WEBPACK_IMPORTED_MODULE_4__receber_list_cnab_vue__["a" /* default */], CustomerForm: __WEBPACK_IMPORTED_MODULE_5__customer_form__["default"], FinanceiroForm: __WEBPACK_IMPORTED_MODULE_6__financeiro_form__["a" /* default */]
    },

    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        cta: {
            type: Object,
            require: true
        }
    },
    watch: {
        'cta.isChecked': function ctaIsChecked(newValue, oldValue) {
            this.$emit('change', newValue);
        }
    }
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_fv_fv_pedido_form__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nfsaida_form__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_utils__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        tipo: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            showFormPedido: false, //exibe a tela de manutencao
            showFormNF: false, //exibe a tela de manutencao
            params: { outrasSaidas: true, codnf: 0, codpedv: 0 },
            fin: _extends({}, this.$store.getters.getEntities.fin),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
            baixado: 'N',
            reabrirBaixado: 'N',
            reabrirCancelado: 'N',
            baixaParcial: false,
            recorrenciaOptions: [{ id: 'U', text: "Única" }, { id: 'P', text: "Parcelado" }, { id: 'M', text: "Mensal" }, { id: 'T', text: "Trimestral" }, { id: 'A', text: "Anual" }],
            recorrencia: 'U',
            dataLimite: null,
            qtParcelas: null,
            showPerguntaRecorrente: false,
            tipoAlteracao: false,

            showPartForm: false,
            showCancelaRec: false,
            showCancela: false,
            titleExclusao: 'Cancelar Titulo',
            tipoCancelamento: null,
            cancelaBaixados: false,
            localCrud: null,
            showAllLogs: false
        };
    },


    components: {
        FvPedidoForm: __WEBPACK_IMPORTED_MODULE_2__forms_fv_fv_pedido_form__["default"], nfsaidaForm: __WEBPACK_IMPORTED_MODULE_3__nfsaida_form__["default"], customerForm: __WEBPACK_IMPORTED_MODULE_4__customer_form__["default"]
    },

    computed: {
        metadataCodnatfin: function metadataCodnatfin() {
            var meta = _extends({}, this.metadata.fin.codnatfin);
            if (this.fin.tipofin == 'R' || this.fin.tipofin == 'E') meta.select2.entity = 'natfin/receitas';else meta.select2.entity = 'natfin/despesas';
            return meta;
        },
        moreActions: function moreActions() {
            if (this.crud == __WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].crudI) return null;

            var actions = [];
            if (this.fin.aberto == 'S' && this.fin.cancelado != 'S' && this.fin.devolvido != 'S' && this.fin.stremessacnab != 1) {
                actions.push({ action: 1, label: 'Cancelar Título' });
            }
            // if (this.fin.cancelado == 'S')
            //     actions.push({ action: 2, label: 'Desfazer Cancelamento' })
            return actions;
        },

        title: function title() {
            if (this.tipo == 'R') return 'Contas a Receber';else return 'Contas a Pagar';
        },

        clienteFornecedor: function clienteFornecedor() {
            if (this.tipo == 'R') return 'Cliente';else return 'Fornecedor';
        },

        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].crudU;
        },

        isView: function isView() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].crudView || this.fin.baixado == 'S' || this.fin.cancelado == 'S' || this.fin.perdido == 'S';
        },

        _habilitaConta: function _habilitaConta() {
            //HABILTA EDICAO DA CONTA BANCARIA SOMENTE QUANDO NAO ENVIADO POR REMESSA
            if (this.fin.stremessacnab != '1' && this.fin.stremessacnab != '2' && !this.isView) {
                return false;
            } else {
                return true;
            }
        },

        _bloqueiaAlteracao: function _bloqueiaAlteracao() {
            return this.fin.cancelado == 'S' || this.fin.devolvido == 'S' || this.fin.stremessacnab == 1 || this.fin.stremessacnab == 2;
        },

        _tituloNF: function _tituloNF() {
            if (!this.fin.codnf && !this.fin.codpedv) {
                return false;
            } else {
                return true;
            }
        },

        vpago: function vpago() {
            return this.fin.vpago;
        },

        vjuros: function vjuros() {
            return this.fin.vjuros;
        },

        vdescontos: function vdescontos() {
            return this.fin.vdescontos;
        },

        vabatimento: function vabatimento() {
            return this.fin.vabatimento;
        }

    },

    methods: {
        closePartForm: function closePartForm(id) {
            if (id) this.fin.codpart = id;
            this.showPartForm = false;
        },
        handleIncluir: function handleIncluir(pTipo) {
            //exibe tela de cadastro
            if (this.isView) {
                return;
            }

            if (pTipo === 'part') {
                this.showPartForm = true;
            }
        },
        handleShowallLogs: function handleShowallLogs() {
            this.showAllLogs = !this.showAllLogs;

            var to = document.getElementById('historico').offsetTop;

            document.getElementById('nb-modal-scrollable').scroll({
                top: this.showAllLogs ? to : 100,
                behavior: 'smooth'
            });
        },
        dataStr: function dataStr(data) {
            if (!data) return '';else return Object(__WEBPACK_IMPORTED_MODULE_6__shared_utils__["formatDate"])(data);
        },
        textSTREMESSA: function textSTREMESSA(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__shared_utils__["getText"])(value, this.metadata.fin.stremessacnab);
        },
        openFormNF: function openFormNF() {
            this.params = { codnf: this.fin.codnf };
            this.showFormNF = true;
        },
        closeFormNF: function closeFormNF() {
            this.showFormNF = false;
        },
        openFormPedido: function openFormPedido() {
            this.showFormPedido = true;
        },
        closeFormPedido: function closeFormPedido() {
            this.showFormPedido = false;
        },
        handleAction: function handleAction(act) {
            if (act == 1) this.handleShowCancela();
        },
        handleConfirmaAlteracao: function handleConfirmaAlteracao() {
            this.showPerguntaRecorrente = false;
            this.handleSave();
        },
        handleCancelarAlteracao: function handleCancelarAlteracao() {
            this.showPerguntaRecorrente = false;
        },
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid && _this.reabrirCancelado !== 'S') {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO Excluir
            this.apiDelete();
        },
        handleLog: function handleLog() {
            if (this.fin.log) {
                this.fin.log = this.fin.log.split('\r');
            }
            if (!this.fin.log || this.fin.log.length == 0) {
                this.fin.log = [''];
            }
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this2.crud == __WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].crudI)) {
                                    _context.next = 10;
                                    break;
                                }

                                _this2.fin.tipofin = _this2.tipo;
                                if (_this2.fin.tipofin == 'R') {
                                    _this2.fin.codnatfin = 3;
                                } else {
                                    _this2.fin.codnatfin = 52;
                                }

                                _this2.fin.aberto = 'S';
                                _this2.fin.baixado = 'N';
                                _this2.fin.parcela = '1';
                                _this2.fin.data = _this2.$getDate();
                                _this2.fin.dtv = _this2.$getDate();
                                _this2.localCrud = _this2.crud;
                                return _context.abrupt('return');

                            case 10:
                                _context.next = 12;
                                return _this2.$store.dispatch('loadFin', { id: _this2.index });

                            case 12:
                                if (_this2.$store.getters.getFin) {
                                    _this2.fin = _extends({}, _this2.$store.getters.getFin);
                                    _this2.baixado = _this2.fin.baixado;
                                }
                                if (_this2.fin.codcta == null) {
                                    _this2.fin.codcta = '';
                                }
                                _this2.baixado = _this2.fin.baixado;
                                _this2.handleLog();
                                if (_this2.fin.baixado == 'S' || _this2.fin.aberto == 'S') _this2.localCrud = __WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].crudUpdate;else _this2.localCrud = _this2.crud;

                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 18:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'fin/movimento/' + _this3.fin.codfin;
                                _context2.next = 3;
                                return apiORDSdelete(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var vbaixado, modulo, metodo, update, sendData, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                vbaixado = parseFloat(_this4.fin.vpago) - parseFloat(_this4.fin.vdescontos) + parseFloat(_this4.fin.vjuros);

                                if (!(_this4.fin.vlr < vbaixado || vbaixado <= 0)) {
                                    _context3.next = 4;
                                    break;
                                }

                                _this4.$erpToastError('O valor pago é inválido');
                                return _context3.abrupt('return');

                            case 4:
                                modulo = 'fin/movimento/';
                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_5__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    modulo = modulo + _this4.fin.codfin;
                                    update = true;
                                }

                                sendData = { fin: _extends({}, _this4.fin) };

                                sendData.tipoAlteracao = _this4.tipoAlteracao;
                                sendData.fin.baixado = _this4.baixado;
                                sendData.fin.qtParcelas = _this4.qtParcelas;
                                sendData.fin.dataLimite = _this4.dataLimite;
                                sendData.fin.recorrencia = _this4.recorrencia;

                                if (_this4.reabrirBaixado == 'S') {
                                    sendData.fin.baixado = 'N';
                                    sendData.fin.aberto = 'S';
                                    sendData.reabrir = true;
                                }
                                if (_this4.reabrirCancelado == 'S') {
                                    sendData.fin.cancelado = 'N';
                                    sendData.fin.aberto = 'S';
                                    sendData.reabrir = true;
                                }

                                _context3.next = 18;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 18:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.reabrirCancelado = 'N';
                                    _this4.reabrirBaixado = 'N';
                                    if (_this4.reabrirBaixado == 'S' || _this4.reabrirCancelado == 'S') _this4.loadData();else _this4.closeForm();
                                }

                            case 20:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        handleShowCancela: function handleShowCancela() {
            this.tipoCancelamento = null;
            this.cancelaBaixados = null;
            if (this.fin.recorrente) this.showCancelaRec = true;else this.showCancela = true;
        },
        handleCancelar: function handleCancelar() {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var modulo, postData, data;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this5.showCancelaRec = false;
                                _this5.showCancela = false;

                                modulo = 'fin/movimento/' + _this5.fin.codfin;
                                postData = { cancela: true, codfin: _this5.fin.codfin, tipo: _this5.tipoCancelamento, cancelaBaixados: _this5.cancelaBaixados };
                                _context4.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this5.$store, modulo, postData, 'put');

                            case 6:
                                data = _context4.sent;

                                _this5.$erpToastDeleted();
                                _this5.closeForm();

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        },
        handleCancelarExclusao: function handleCancelarExclusao() {
            this.showCancelaRec = false;
            this.showCancela = false;
            this.codfin = null;
            this.tipoCancelamento = null;
            this.cancelaBaixados = null;
        },
        handleEventEsc: function handleEventEsc(event) {
            if (event.keyCode == 27) {
                this.closeForm();
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('keyup', this.handleEventEsc);
    },

    watch: {
        baixado: function baixado(value) {
            if (value === 'S') {
                //ATRIBUI A DATA ATUAL À DATA DA BAIXA
                if (!this.fin.dtb) {
                    this.fin.dtb = this.$getDate();
                }
            }
        },

        vjuros: function vjuros(value) {
            this.fin.vpago = parseFloat(this.fin.vlr) - parseFloat(this.fin.vdescontos) + parseFloat(this.fin.vjuros);
        },

        vdescontos: function vdescontos(value) {
            this.fin.vpago = parseFloat(this.fin.vlr) - parseFloat(this.fin.vdescontos) + parseFloat(this.fin.vjuros);
        },

        vpago: function vpago(value) {
            if (this.fin.vlr > parseFloat(this.fin.vpago) + parseFloat(this.fin.vdescontos) - parseFloat(this.fin.vjuros)) {
                this.baixaParcial = true;
            } else {
                this.baixaParcial = false;
            }
        }

    },

    beforeCreate: function beforeCreate() {},
    created: function created() {
        var _this6 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _this6.$nextTick(function () {
                                this.$refs.doc.$el.querySelector('input').focus();
                                jQuery('[data-toggle="tooltip"]').tooltip();
                            });

                            _this6.crudText = _this6.$crudText(_this6.crud);

                            _context5.next = 4;
                            return _this6.loadData();

                        case 4:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this6);
        }))();
    },
    mounted: function mounted() {
        this.showFormNF = false;
        this.showFormPedido = false;
        window.addEventListener('keyup', this.handleEventEsc);
    }
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_numbers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_numbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_numbers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_pedido_addlist__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_pedido_additem__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_pedido_rentabilidade__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fv_pedido_form_infcpl__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__forms_pedido_impressao_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__forms_customer_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__forms_nates_form__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__forms_customer_contato_form__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__forms_vend_form__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_grade__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_anexos_form__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_api_pedido_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_api_pedido_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__api_api_pedido_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: '',
    crud: '',
    negocio: { type: Object }
  },

  components: {
    PedidoAdditem: __WEBPACK_IMPORTED_MODULE_5__forms_pedido_additem__["a" /* default */], PedidoAddlist: __WEBPACK_IMPORTED_MODULE_4__forms_pedido_addlist__["a" /* default */], PedidoFormInfcpl: __WEBPACK_IMPORTED_MODULE_7__fv_pedido_form_infcpl__["a" /* default */], PedidoRentabilidade: __WEBPACK_IMPORTED_MODULE_6__forms_pedido_rentabilidade__["a" /* default */], CustomerForm: __WEBPACK_IMPORTED_MODULE_9__forms_customer_form__["default"], NatesForm: __WEBPACK_IMPORTED_MODULE_10__forms_nates_form__["a" /* default */], CustomerContatoForm: __WEBPACK_IMPORTED_MODULE_11__forms_customer_contato_form__["a" /* default */], grade: __WEBPACK_IMPORTED_MODULE_13__components_grade__["a" /* default */], AnexosForm: __WEBPACK_IMPORTED_MODULE_14__components_anexos_form__["a" /* default */], PedidoImpressao: __WEBPACK_IMPORTED_MODULE_8__forms_pedido_impressao_vue__["default"]
  },

  data: function data() {
    return {
      crudText: '',

      view: false, //variavel para controle de visualizacao ou edicao
      formNew: false, //incluindo novo pedido
      showFormInfAd: false, //editando cabecalho
      formPar: false, //editando parcelas
      formOrder: false,
      showDescontos: false,
      aplicaDescontoItens: false,
      aplicaDescontoTotal: false,
      showFormItem: false, //exibe o formulario de manutencao de item
      showPartForm: false, //exibe o formulario de cliente para inclusao
      showVendForm: false, //exibe o formulario de vendedor para inclusao
      showNatesForm: false, //exibe o formulario de naturezas para inclusao
      showContatoForm: false, //exibe o formulario de contato do cliente para inclusao
      showFormEmail: false, //exibe o formulario para envio de email
      showFormEmailCieloSL: false, //exibe o formulario para envio de email
      showTotal: false,
      btEnviar: false,
      btImprimir: false,
      btFaturar: false,
      btCancelar: false,
      formItemView: false,
      CANCEL_ITEM_MESSAGE: false,
      DELETE_ITEM_MESSAGE: false,
      CANCEL_MESSAGE: false,
      CIELO_SL_MESSAGE: false,

      cielo_sl_link: null,

      codpedv: null,

      showListaDestaques: false,

      isValidCabec: true,

      updateItem: false, //indica quando for uma alteracao de item

      hasPriceTab: false, //indica que possui tabela de preço e o campo preço será desabilitado

      //entidades
      pedv: _extends({}, this.$store.getters.getEntities.pedv),
      pedvit: {},
      pedvpar: [], //parcelas do pedido
      pedvit_update: {},
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: {}, //armazena as mensagens de validacao do pedido de venda apos a gravacao

      anexos: [], //lista de anexos do pedido
      showAnexo: false,

      itped: 0, //sequencial do item
      moreActions: [], //botao mais acoes

      unwatch: true,

      //PEDIDOS VINCULADOS À NEGOCIOS DO CRM
      negociocrm: null,
      pessoa: null,
      organizacao: null,
      telefones: [],
      emails: [],

      partTabela: false,
      partCodTabpre: null,

      pagamentoonline: false,

      logisticaValidation: null,
      codpedvImpressao: null,
      showImpressao: false,
      showContatosWhats: false

    };
  },


  computed: {
    botaoGerarPedido: function botaoGerarPedido() {
      return this.pedv.tppedv == 'O' && !this.pedv.codnegocio && !this.bloqueia_gerar_pedido;
    },

    botaoPerdido: function botaoPerdido() {
      return this.pedv.tppedv == 'O' && !this.pedv.codnegocio;
    },

    orcamentoVencido: function orcamentoVencido() {
      return this.pedv.tppedv == 'O' && this.pedv.stpedv == 'P' && this.pedv.dtvalidade && new Date(this.pedv.dtvalidade).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);
    },

    orcamentoCrm: function orcamentoCrm() {
      return this.negociocrm || this.pedv.codnegocio;
    },

    possuiListaDestaqueValida: function possuiListaDestaqueValida() {
      if (!this.$store.getters.getDestaqList.length) return false;else {
        return this.$store.getters.getDestaqList.filter(function (obj) {
          return obj.isvalid == 'S';
        }).length > 0;
      }
    },

    showPesquisaItens: function showPesquisaItens() {
      return this.pedv.codpart && this.pedv.codnates && !this.showFormItem;
    },

    select2Contato: function select2Contato() {
      return { entity: 'partcontato/' + this.pedv.codpart, minlength: 0 };
    },

    administrador: function administrador() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador;
    },

    dataLeitura: function dataLeitura() {
      return 'O pedido foi recebido pela empresa em ' + Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatDataHoraExtenso"])(this.pedv.data_leitura);
    },

    tagAlteracaoBloqueada: function tagAlteracaoBloqueada() {
      if (!this.administrador && this.pedv.tppedv == 'P' && this.pedv.stpedv == 'P') return 'Alteração não permitida';
    },

    isView: function isView() {
      //NAO PERMITE ALTERACAO NO PEDIDO QUANDO HÁ TITULOS ENVIADOS, TITULOS BAIXADOS OU NOTA LANÇADA
      //NAO PERMITE ALTERACAO DO PEDIDO QUANDO É USUARIO COMUM, SOMENTE ORÇAMENTO
      if (!this.administrador && this.pedv.tppedv == 'P' && this.pedv.stpedv != 'P') {
        return true;
      } else {
        var result = this.view || this.pedv.tppedv == 'R' || this.pedv.stpedv != 'D' && this.pedv.stpedv != 'P' || this.pedv.fin_baixado > 0 || this.pedv.fin_remessa > 0 || this.pedv.nf_emitida > 0 || this.pedv.nf_pendente > 0;
        return result;
      }
    },

    btTotalizar: function btTotalizar() {
      return !this.view && this.pedv.stpedv == 'D' && this.pedvit.length > 0;
    },

    tabelas_preco_options: function tabelas_preco_options() {
      //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
      var options = [];

      var liberado = [];
      var currTabpre = {};
      var addTabela = false;

      for (var x = 0; x < this.$store.getters.getTabpreList.length; x++) {
        currTabpre = this.$store.getters.getTabpreList[x];

        //se existir parametros do usuario, libera somente as tabelas permitidas
        if (this.partCodTabpre && this.partCodTabpre == currTabpre.codtabpre) addTabela = true;else if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.length > 0) {
          liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter(function (obj) {
            return obj == currTabpre.codtabpre;
          });
          if (liberado.length > 0) {
            addTabela = true;
          }
        } else {
          addTabela = true;
        }

        if (addTabela) options.push({ id: currTabpre.codtabpre, text: currTabpre.descricao });

        addTabela = false;
      }

      return options;
    },

    bloqueia_gerar_pedido: function bloqueia_gerar_pedido() {
      if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) return this.$store.getters.getParametrosUsuario.vendas.bloqueia_gerar_pedido;else return false;
    },

    bloqueia_descontos: function bloqueia_descontos() {
      if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) return this.$store.getters.getParametrosUsuario.vendas.bloqueia_descontos;else return false;
    },

    bloqueia_tabela_cliente: function bloqueia_tabela_cliente() {
      if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) {
        if (this.partTabela) return this.$store.getters.getParametrosUsuario.vendas.bloqueia_tabela_cliente;else return false;
      } else return false;
    },

    condicaoList: function condicaoList() {
      return this.$store.getters.getCondicaoList;
    },

    condicao_descricao: function condicao_descricao() {
      if (!this.pedv.codcondicao || !this.condicaoList) return '';else for (var x = 0; x < this.condicaoList.length; x++) {
        if (this.condicaoList[x].codcondicao == this.pedv.codcondicao) {
          return this.condicaoList[x].descricao;
        }
      }
    },

    itemList: function itemList() {
      return this.$store.getters.getItemSalesList;
    },

    natesListSaida: function natesListSaida() {
      return this.$store.getters.getNatesSaidaList;
    },

    codpart: function codpart() {
      return this.pedv.codpart;
    },

    part: function part() {
      return this.$store.getters.getPart;
    },

    selectedNates: function selectedNates() {
      return this.$store.getters.getNates;
    },

    codnates: function codnates() {
      return this.pedv.codnates;
    },

    prazodias: function prazodias() {
      return this.pedv.prazodias;
    },

    prazo: function prazo() {
      return this.pedv.prazo;
    },

    validadedias: function validadedias() {
      return this.pedv.validadedias;
    },

    dtvalidade: function dtvalidade() {
      return this.pedv.dtvalidade;
    },

    parcelas: function parcelas() {
      return this.pedv.parcelas;
    },

    title: function title() {
      if (this.pedv.tppedv === 'P' && this.pedv.npedido === null) {
        return 'Incluindo Pedido';
      } else if (this.pedv.tppedv === 'P') {
        return 'Pedido de Venda [' + this.pedv.npedido + ']';
      } else if (this.pedv.ncotacao === null) {
        return 'Incluindo Orçamento';
      } else {
        return 'Orçamento [' + this.pedv.ncotacao + ']';
      }
    },

    cielo_condicao: function cielo_condicao() {
      var r = false;

      if (this.pedv.codcondicao > 0 && this.pedv.filial[0] !== null) {
        if (this.pedv.filial[0].parametros !== null) {
          var parametros = JSON.parse(this.pedv.filial[0].parametros);

          if (parametros.hasOwnProperty('pagonline') && parametros.pagonline.hasOwnProperty('cielo') && parametros.pagonline.cielo.hasOwnProperty('id')) {

            if (parametros.pagonline.cielo.id == this.pedv.codcondicao) {
              r = true;
            }
          }
        }
      }

      return r;
    },

    rede_condicao: function rede_condicao() {
      var r = false;

      if (this.pedv.codcondicao > 0 && this.pedv.filial[0] !== null) {
        if (this.pedv.filial[0].parametros !== null) {
          var parametros = JSON.parse(this.pedv.filial[0].parametros);

          if (parametros.hasOwnProperty('pagonline') && parametros.pagonline.hasOwnProperty('rede') && parametros.pagonline.rede.hasOwnProperty('id')) {

            if (parametros.pagonline.rede.id == this.pedv.codcondicao) {
              r = true;
            }
          }
        }
      }

      return r;
    },

    pagseguro_condicao: function pagseguro_condicao() {
      var r = false;

      if (this.pedv.codcondicao > 0 && this.pedv.filial[0] !== null) {
        if (this.pedv.filial[0].parametros !== null) {
          var parametros = JSON.parse(this.pedv.filial[0].parametros);
          if (parametros.hasOwnProperty('pagonline') && parametros.pagonline.hasOwnProperty('pagseguro') && parametros.pagonline.pagseguro.hasOwnProperty('id')) {

            if (parametros.pagonline.pagseguro.id == this.pedv.codcondicao) {
              r = true;
            }
          }
        }
      }

      return r;
    },

    disableTppedv: function disableTppedv() {
      //desabilita o campo tipo de documento este já for pedido de venda
      return this.pedv.tppedv === 'P' && this.pedv.codpedv != null;
    },

    _endereco: function _endereco() {
      if (!this.pedv.part) return null;
      var end = this.pedv.part[0].ende;
      if (end) {
        if (this.pedv.part[0].endenr) end = end + ', ' + this.pedv.part[0].endenr;
        if (this.pedv.part[0].endecomp) end = end + ', ' + this.pedv.part[0].endecomp;
        if (this.pedv.part[0].bairro) end = end + ', ' + this.pedv.part[0].bairro;
        if (this._nomemun) end = end + ', ' + this._nomemun;
        end = end + ' - ' + this.pedv.part[0].uf + ' - ' + this.pedv.part[0].cep;
      }

      return end;
    },

    _nomeuf: function _nomeuf() {
      if (this.pedv.part) {
        if (this.pedv.part[0].uf) {
          return this.pedv.part[0].uf;
        } else {
          return this.pedv.part[0].estado[0].uf;
        }
      }
    },

    _nomemun: function _nomemun() {
      if (this.pedv.part) {
        if (this.pedv.part[0].nomemun) {
          return this.pedv.part[0].nomemun;
        } else {
          return this.pedv.part[0].mun[0].nomemun;
        }
      }
    },

    _cnpjcpf: function _cnpjcpf() {
      //FORMATACAO DO CNPJ DO CLIENTE
      var doc = '';
      if (this.pedv.part) {
        doc = this.pedv.part[0].cnpjcpf;
      }
      if (String(doc).length > 11) {
        doc = this.$formatCNPJ(doc);
      } else if (String(doc).length == 11) {
        doc = this.$formatCPF(doc);
      }
      return doc;
    },

    _paramsPesquisa: function _paramsPesquisa() {
      var params = {
        pedvit: this.pedvit,
        pedv: this.pedv
      };
      return params;
    },

    _paramsDestaques: function _paramsDestaques() {
      var params = {
        pedvit: this.pedvit,
        pedv: this.pedv,
        produtosDestaque: true
      };
      return params;
    },

    appLoja: function appLoja() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appLoja;
    },

    appERP: function appERP() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appERP;
    }

  },

  mixins: [__WEBPACK_IMPORTED_MODULE_15__api_api_pedido_js___default.a],

  filters: {
    format: function format(value, decimals) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(value, decimals);
    }
  },

  methods: {
    updateImpInfGeraisGarantia: function updateImpInfGeraisGarantia(value) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var modulo, data_json, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.pedv.codpedv) {
                  _context.next = 9;
                  break;
                }

                modulo = 'sales/pedv/' + _this.pedv.codpedv + '/impinfgeraisgarantia';
                data_json = {};

                data_json.codpedv = _this.pedv.codpedv;
                data_json.impinfgeraisgarantia = value;

                _context.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, modulo, data_json, 'post');

              case 7:
                data = _context.sent;

                if (data && data.errormessage) {
                  console.log(data.validacao);
                  _this.$erpToastError('Erro ao enviar o pedido para remessa');
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },


    statusColor: function statusColor(value) {
      var color = 'badge-green';
      if (value == 'C') {
        color = 'badge-red';
      } else if (value == 'D') {
        color = 'badge-orange';
      } else if (value == 'F') {
        color = 'badge-blue';
      }
      return color;
    },

    handleShowDescontos: function handleShowDescontos(tipo) {
      this.pdesc1 = this.pedv.pdesc1;
      this.pdesc2 = this.pedv.pdesc2;
      this.pdesc3 = this.pedv.pdesc3;
      this.pdesc4 = this.pedv.pdesc4;
      this.aplicaDescontoItens = false;
      this.aplicaDescontoTotal = false;
      if (tipo == 'itens') this.aplicaDescontoItens = true;else this.aplicaDescontoTotal = true;
      this.showDescontos = true;
    },
    handleCloseDescontos: function handleCloseDescontos() {
      this.pedv.pdesc1 = this.pdesc1;
      this.pedv.pdesc2 = this.pdesc2;
      this.pedv.pdesc3 = this.pdesc3;
      this.pedv.pdesc4 = this.pdesc4;
      this.showDescontos = false;
    },
    handleAplicaDescontos: function handleAplicaDescontos() {
      var self = this;
      if (this.aplicaDescontoItens) this.pedv.atualiza_descontos = true;else this.pedv.atualiza_descontos = false;

      this.gravaPedido();
      this.showDescontos = false;
      // this.apiPedido().then(function () {
      //     self.showDescontos = false
      // })
    },
    closeForm: function closeForm() {
      if (this.$route.params && this.$route.params.codnegocio) this.$router.go(-1);else if (this.$route.params && this.$route.params.id) this.$router.push('/pedidolist');else this.$emit('closeform');
    },
    closePartForm: function closePartForm(id) {
      //ao fechar o formulario de inclusao de transportadoras
      if (id) this.pedv.codparttr = id;
      this.showPartForm = false;
    },
    closeNatesForm: function closeNatesForm(id) {
      //ao fechar o formulario de inclusao de naturezas
      if (id) this.pedv.codnates = id;
      this.showNatesForm = false;
    },
    closeContatoForm: function closeContatoForm(id) {
      //ao fechar o formulario de inclusao de vendedor
      if (id) this.pedv.seqcontato = id;
      this.showContatoForm = false;
    },
    closeNfForm: function closeNfForm() {
      //ao fechar o formulario de faturamento
      this.showNfForm = false;
    },
    handleShowDestaque: function handleShowDestaque() {
      this.showListaDestaques = true;
    },
    closeDestaque: function closeDestaque() {
      this.showListaDestaques = false;
    },
    handleFaturar: function handleFaturar() {
      //fatura o pedido
      this.gravaPedido('pedido');

      this.$router.push('/nf/' + this.pedv.codpedv);
    },
    handleIncluir: function handleIncluir() {
      //exibe tela de cadastro do cliente
      if (this.isView) {
        return;
      }
      this.showPartForm = true;
    },
    handleIncluirNates: function handleIncluirNates() {
      //exibe tela de cadastro da natureza
      if (this.isView) {
        return;
      }
      this.showNatesForm = true;
    },
    handleIncluirVend: function handleIncluirVend() {
      //exibe tela de cadastro do cliente
      if (this.isView) {
        return;
      }
      this.showVendForm = true;
    },
    handleIncluirContato: function handleIncluirContato() {
      if (this.pedv.codpart == null) {
        this.$erpToastError('Selecione um cliente antes de incluir um contato.');
        return;
      }
      this.showContatoForm = true;
    },
    handleContinuar: function handleContinuar() {
      var _this2 = this;

      //BOTAO "CONTINUAR" DA TELA DE INCLUSAO DE PEDIDO
      //EFETUA A VALIDACAO DOS CAMPOS INICIAIS E ABRE OS DEMAIS DADOS DE CABECALHO
      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this2.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else if (_this2.validacaoInicial()) {
          _this2.handleSaveCab();
        }
      });
    },
    handleTotalizar: function handleTotalizar(close) {
      //BOTAO TOTALIZAR PEDIDO - EFETUA VALIDACOES E ENCERRA A DIGITACAO DO PEDIDO (PEDIDO PASSA PARA STATUS PENDENTE)
      if (this.pedvit.length == 0) {
        this.$erpToastError('O pedido não possui nenhum item. Por favor adicione itens no pedido.');
        return;
      }

      if (this.condicaoList.length == 0)
        //campo parcelas nao pode ser preenchido quando trabalhar com cadastro de condicoes
        if (this.pedv.parcelas == null) this.pedv.parcelas = 0;

      if (this.pedv.parcelas) this.calculaParcelas();

      this.pedv.stpedv = 'P';

      if (close) this.gravaPedido('close');else this.gravaPedido('totalizar');

      // let self = this
      // this.apiPedido().then(function () {
      //     if (self.errmessages.errmessages)
      //       return
      //     else
      //     if (close) {
      //         self.closeForm()
      //     } else {
      //         if (self.$refs.parcelas) {
      //             let elmnt = document.getElementById("condicao")
      //             elmnt.scrollIntoView() //POSICIONA NO ELEMENTO CONDICAO DE PAGAMENTO
      //             self.$refs.parcelas.focus()
      //         }
      //     }
      // })
    },
    handleGerarPedido: function handleGerarPedido() {
      //BOTAO PARA TRANSFORMAR O PEDIDO EM ORÇAMENTO
      if (this.pedvit.length == 0) {
        this.$erpToastError('O pedido não possui nenhum item. Por favor adicione itens no pedido.');
        return;
      }

      this.gravaPedido('gerarpedido');
      // let self = this
      // this.apiPedido('gerarpedido').then(function () {
      //     console.log(self.errmessages.errmessages)
      //     if (self.errmessages.errmessages)
      //       return
      //     else
      //     self.$erpToastSuccess('O pedido foi gerado')
      //     self.closeForm()
      // })
    },
    handleOrcamentoPedido: function handleOrcamentoPedido() {
      //BOTAO PARA TRANSFORMAR O PEDIDO EM ORÇAMENTO
      if (this.pedvit && this.pedvit.length == 0) {
        this.$erpToastError('O pedido não possui nenhum item. Por favor adicione itens no pedido.');
        return;
      }
      if (confirm("Confirma orçamento perdido?")) {
        this.gravaPedido('perdido');
        // let self = this
        // this.apiPedido('perdido').then(function () {
        //     self.$erpToastError('Orçamento perdido');
        // })
      }
    },
    handleRemessaLogistica: function handleRemessaLogistica() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:

                _this3.logisticaValidation = null;

                modulo = 'sales/pedv/' + _this3.pedv.codpedv + '/remessalogistica';
                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this3.$store, modulo, null, 'post');

              case 4:
                data = _context2.sent;

                if (data && data.errormessage) {
                  _this3.logisticaValidation = data.validacao;
                  _this3.$erpToastError('Erro ao enviar o pedido para remessa');
                } else _this3.loadData(_this3.pedv.codpedv);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    handleRastreioLogistica: function handleRastreioLogistica() {},
    handleEtiquetaLogistica: function handleEtiquetaLogistica() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.logisticaValidation = null;

                modulo = 'sales/pedv/' + _this4.pedv.codpedv + '/etiquetalogistica';
                _context3.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, null, 'post');

              case 4:
                data = _context3.sent;

                if (!(data && data.validacao)) {
                  _context3.next = 11;
                  break;
                }

                _this4.logisticaValidation = data.validacao;
                _this4.$erpToastError('Erro ao imprimir etiquetas');
                return _context3.abrupt('return');

              case 11:
                if (!(data && data.errormessage)) {
                  _context3.next = 14;
                  break;
                }

                _this4.$erpToastError(data.errormessage);
                return _context3.abrupt('return');

              case 14:
                if (data.url) window.open(data.url, "_blank");

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    handleInfAdicionais: function handleInfAdicionais() {
      //click do botao outras informacoes exibe a tela com dados para alteracao
      this.showFormInfAd = true;
    },
    handleSaveCab: function handleSaveCab() {
      //botao salvar dados de cabecalho
      if (this.isView) {
        return;
      }
      this.gravaPedido('incluirPedido');
    },
    handleCopia: function handleCopia() {
      //efetua a copia do pedido
      this.apiDuplica();
    },
    handleAddItem: function handleAddItem() {
      //inclusao de item individual
      if (this.isView) {
        this.$erpToastError('Não permitido');
        return;
      }

      this.pedvit_update = _extends({}, this.$store.getters.getEntities.pedvit), this.pedvit_update.pdesc1 = this.pedv.pdesc1;
      this.pedvit_update.pdesc2 = this.pedv.pdesc2;
      this.pedvit_update.pdesc3 = this.pedv.pdesc3;
      this.pedvit_update.pdesc4 = this.pedv.pdesc4;
      this.pedvit_update.finalidade = this.pedv.finalidade;
      this.updateItem = false;
      this.showFormItem = true;
    },
    closeFormItem: function closeFormItem() {
      //fecha tela de inclusao de item
      this.showFormItem = false;
      this.showFormInfAd = false;
      this.formOrder = true;
    },
    handleSalvarItens: function handleSalvarItens(pedvit) {
      //efetua a inclusao de item no pedido
      if (pedvit.length == 0) {
        return;
      }

      this.showFormItem = false;
      this.formOrder = true;

      var itens = [];

      if (pedvit.length) {
        //se receber uma lista de itens, ajusta a lista para efetuar gravacao
        for (var x = 0; x < pedvit.length; x++) {
          if (pedvit[x].codpedv) {
            itens.push(pedvit[x]);
          } else {
            var it = _extends({}, this.$store.getters.getEntities.pedvit);
            it.coditem = pedvit[x].coditem;
            it.vlr = pedvit[x].vlr;
            it.uni = pedvit[x].uni;
            it.qtuni = pedvit[x].qtuni;
            it.pedvgrade = pedvit[x].pedvgrade;
            if (pedvit[x].tabelas_desconto) it.descontotab = pedvit[x].tabelas_desconto.descontos;
            it.pdesc1 = pedvit[x].pdesc1;
            it.pdesc2 = pedvit[x].pdesc2;
            it.pdesc3 = pedvit[x].pdesc3;
            it.pdesc4 = pedvit[x].pdesc4;
            it.pedcliit = pedvit[x].pedcliit;
            it.iskit = pedvit[x].iskit == 'S';
            itens.push(it);
          }
        }
      } else {
        itens.push(pedvit);
      }
      //EFETUA A GRAVACAO DOS ITENS NO PEDIDO
      this.gravaItens(itens);
      // this.apiItens(itens, false, false)
      this.$refs.addList.focus();

      this.closeDestaque();
    },
    handleShowGradeItem: function handleShowGradeItem(index) {
      //EXIBE A GRADE DO ITEM NA LISTA DE ITENS
      if (this.pedvit[index].showGrade) {
        this.pedvit[index].showGrade = false;
      } else {
        this.$set(this.pedvit[index], 'showGrade', true);
      }
    },
    handleEditItem: function handleEditItem(nSeq, view) {
      //EDITAR O ITEM DO PEDIDO
      this.pedvit_update = {};
      //localiza o item para alteracao atraves da sequencia
      for (var x = 0; x < this.pedvit.length; x++) {
        if (this.pedvit[x].itped == nSeq) {
          this.pedvit_update = _extends({}, this.pedvit[x]);
        }
      }
      this.formItemView = view; //indica se é alteração ou somente visualizacao
      this.updateItem = true;
      this.showFormItem = true;
    },
    handleItemDeleteMsg: function handleItemDeleteMsg(nSeq) {
      //EXCLUI O ITEM DO PEDIDO
      this.pedvit_update = {};
      //localiza o item para alteracao atraves da sequencia
      for (var x = 0; x < this.pedvit.length; x++) {
        if (this.pedvit[x].itped == nSeq) {
          this.pedvit_update = _extends({}, this.pedvit[x]);
        }
      }
      this.DELETE_ITEM_MESSAGE = true;
    },
    handleItemDelete: function handleItemDelete(nSeq) {
      //remove o item do pedido
      this.DELETE_ITEM_MESSAGE = false;
      var pedvit = [];
      pedvit.push(this.pedvit_update);
      this.gravaItens(pedvit, false, true);
      // this.apiItens(pedvit, false, true)
    },
    handleRetorna: function handleRetorna() {
      //TRATAMENTO DO BOTAO RETORNAR (TELA DE INCLUSAO, DADOS DO PEDIDO E TELA PRINCIPAL DO PEDIDO)
      if (this.formNew) {
        //FECHA A TELA DE INCLUSAO DO PEDIDO
        this.closeForm();
      } else if (this.formOrder) {
        //FECHA A TELA DE EDICAO DO PEDIDO
        this.closeForm();
      }
    },
    handleExcluirLinkPagamento: function handleExcluirLinkPagamento() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var self, metodo, modulo, sendData, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.pagamentoonline = false;
                _this5.pedv.cieloidsuperlink = null;
                self = _this5;
                //efetua a copia do pedido

                metodo = 'post';
                modulo = 'sales/pedv/excluircielosuperlink';
                sendData = { pedv: _this5.pedv.codpedv };
                _context4.next = 8;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this5.$store, modulo, sendData, metodo);

              case 8:
                data = _context4.sent;

                _this5.cielo_sl_link = null;
                if (data) {
                  if (data.link) {
                    _this5.CIELO_SL_MESSAGE = true;
                    _this5.cielo_sl_link = data.link;
                  } else {
                    _this5.errmessages = value;
                    _this5.$scrollTo(0);
                    _this5.$erpToastError(data);
                  }
                }

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    handleLinkPagamento: function handleLinkPagamento(tipo) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var self, metodo, modulo, sendData, data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.pagamentoonline = true;
                self = _this6;
                //efetua a copia do pedido

                metodo = 'post';
                modulo = 'sales/pedv/gerarcielosuperlink';
                sendData = { pedv: _this6.pedv.codpedv };
                _context5.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this6.$store, modulo, sendData, metodo);

              case 7:
                data = _context5.sent;

                _this6.cielo_sl_link = null;
                if (data) {
                  if (data.link) {
                    if (tipo == 'whats') {
                      window.open("https://wa.me/55" + data.fone + "?text=Segue link para pagamento da sua compra efetuada em nossa loja virtual " + data.link, "_blank");
                    } else if (tipo == 'acessar') {
                      _this6.CIELO_SL_MESSAGE = true;
                      _this6.cielo_sl_link = data.link;
                    } else {
                      _this6.handleFormEmailCieloSL();
                    }
                  } else {
                    _this6.errmessages = value;
                    _this6.$scrollTo(0);
                    _this6.$erpToastError(data);
                  }
                }

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },


    //CHAMADAS API
    gravaPedido: function gravaPedido(operacao) {
      if (this.isView) {
        return;
      }
      if (operacao == 'gerarpedido') this.pedv.tppedv = 'P';else if (operacao == 'perdido') this.pedv.tppedv = 'R';else if (operacao == 'cancelar') this.pedv.stpedv = 'C';

      this.apiPedido(operacao, this.pedv, this.pedvit, this.pedvpar, this.apiPedidoCallback);
    },
    gravaItens: function gravaItens(pedvit, cancelItem, deleteItem) {
      //efetua a gravacao dos itens do pedido
      this.pedv.pedvit = _extends({}, this.pedvit);
      var sendData = { pedv: this.pedv //pega o cabecalho do pedido

      };if (sendData.pedv.filial) delete sendData.pedv.filial;

      if (pedvit.length) {
        sendData.pedv.pedvit = pedvit; //adiciona os novos itens ao cabecalho
      } else {
        sendData.pedv.pedvit = [];
        sendData.pedv.pedvit.push(pedvit);
      }

      this.apiItemPedido(sendData, this.updateItem, cancelItem, deleteItem, this.apiPedidoCallback);
    },
    apiPedidoCallback: function apiPedidoCallback(operacao, pedv, validation) {
      if (validation && validation.errmessages && validation.errmessages.length) {
        this.errmessages = validation;
        this.$scrollTo(0);
        this.$erpToastError('Por favor corrija os erros de validação');
      } else this.errmessages = {};

      if (pedv && pedv.stpedv == 'C') {
        this.closeForm();
        return;
      }

      if (operacao == 'deleteItem') {
        this.loadData(this.pedv.codpedv);
        return;
      }

      if (operacao == 'rentab') {
        this.loadData(this.pedv.codpedv);
        return;
      }

      if (operacao == 'gerarpedido') this.closeForm();

      if (operacao == 'close') {
        this.closeForm();
      }

      this.pedv = pedv;
      this.pedvit = pedv.pedvit;
      this.updateActions(); //ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES" AO CARREGAR UM PEDIDO
      this.updateItem = false;
      this.formNew = false;

      if (operacao == 'incluirPedido') {
        if (this.errmessages.length) {
          //se retornou erros continua parado na mesma tela
        } else {
          this.formNew = false;
          this.formOrder = true;
          this.showFormInfAd = false;
          this.formItemsPedido = true;
        }
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip();
        });
      }

      if (operacao == 'enviaremail') this.handleFormEmail();

      if (operacao == 'totalizar') {
        //POSICIONA NO ELEMENTO CONDICAO DE PAGAMENTO
        if (this.$refs.parcelas) {
          var elmnt = document.getElementById("parcelas");
          elmnt.scrollIntoView();
          this.$refs.parcelas.focus();
        } else if (this.$refs.condicao) {
          var _elmnt = document.getElementById("condicao");
          _elmnt.scrollIntoView();
          this.$refs.condicao.focus();
        }
      }
    },
    apiDuplica: function apiDuplica() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var metodo, modulo, sendData, data;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                //efetua a copia do pedido
                metodo = 'post';
                modulo = 'sales/pedv/duplica';
                sendData = { pedv: _this7.pedv.codpedv };
                _context6.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this7.$store, modulo, sendData, metodo);

              case 5:
                data = _context6.sent;

                if (data.items) {
                  _this7.pedv = data.items[0];
                  _this7.view = false;
                  if (_this7.pedv.tppedv === 'P') {
                    _this7.$erpToastSuccess('Pedido copiado com sucesso. O novo pedido criado é: ' + _this7.pedv.npedido);
                  } else {
                    _this7.$erpToastSuccess('Orçamento copiado com sucesso. O novo orçamento criado é: ' + _this7.pedv.ncotacao);
                  }
                  _this7.errmessages = {};
                  if (_this7.pedv.validation) {
                    _this7.errmessages = JSON.parse(_this7.pedv.validation);
                  }
                }

              case 7:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    handleCancelMsg: function handleCancelMsg(nSeq) {
      //cancelar o pedido
      //exibe a confirmacao do cancelamento
      if (this.pedv.data_leitura) {
        this.$erpToastError('Não permitido o cancelamento de pedido com leiturada efetuada');
      }
      this.CANCEL_MESSAGE = true;
    },
    handleItemCancelMsg: function handleItemCancelMsg(nSeq) {
      //cancelar o item do pedido
      this.pedvit_update = {};
      //localiza o item para cancelar atraves da sequencia
      for (var x = 0; x < this.pedvit.length; x++) {
        if (this.pedvit[x].itped == nSeq) {
          this.pedvit_update = _extends({}, this.pedvit[x]);
        }
      }
      this.pedvit_update.stpedv = 'C';

      //exibe a confirmacao do cancelamento
      this.CANCEL_ITEM_MESSAGE = true;
    },
    handleItemCancel: function handleItemCancel() {
      //efetiva o cancelamento do item
      this.CANCEL_ITEM_MESSAGE = false;
      var pedvit = [];
      pedvit.push(this.pedvit_update);
      this.gravaItens(pedvit, true);
      // this.apiItens(pedvit, true, false)
    },
    handleCancel: function handleCancel() {
      //efetiva o cancelamento do pedido
      this.CANCEL_MESSAGE = false;
      this.gravaPedido('cancelar');
    },
    handleCloseMessage: function handleCloseMessage() {
      this.CANCEL_MESSAGE = false;
      this.CANCEL_ITEM_MESSAGE = false;
      this.DELETE_ITEM_MESSAGE = false;
      this.CIELO_SL_MESSAGE = false;
      this.cielo_sl_link = null;
    },
    handleEnviaLinkWhats: function handleEnviaLinkWhats(number) {
      this.showModalNumber = false;
      if (!number) return;else if (this.pedv.ecommerce == 'S') {
        var text = encodeURIComponent('Um novo status foi vinculado ao seu pedido em nossa loja virtual acesse: ' + this.link);
        window.open("https://api.whatsapp.com/send/?phone=55" + number + "&text=" + text, "_blank");
        this.closeForm();
      } else {
        this.apiEnviaPedidoWhats(this.pedv, number);
      }
    },
    handleShowContatosWhats: function handleShowContatosWhats() {
      if (!this.pedv.codpedv) return;
      this.showContatosWhats = true;
    },
    handleWhatsapp: function handleWhatsapp(number) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                // ENVIA O PEDIDO POR WHATSAPP
                _this8.showContatosWhats = false;

                if (number) _this8.apiEnviaPedidoWhats(_this8.pedv, number);

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    handleEmail: function handleEmail() {
      // SALVA O PEDIDO E ENVIA EMAIL
      if (this.pedv.codnegocio) {
        this.$showMessage('Orçamento vinculado a negócio', 'O envio de emails de orçamentos vinculados à negócio é permitido somente pela tela de negócio.', 'warning');
        return;
      }

      if (this.isView) this.handleFormEmail();else this.gravaPedido('enviaremail');
    },
    handleAction: function handleAction(act) {
      //click do botao "mais acoes"
      if (act == 10) {
        this.handleAnexarDocumento();
      }

      if (act == 5) {
        this.apiDuplica();
      }

      if (act == 4) {
        this.handleCancelMsg();
      }

      if (act == 1) {
        this.codpedvImpressao = this.pedv.codpedv;
        this.showImpressao = true;
        this.$nextTick(function () {
          this.$refs.impressao.print();
        });
      }
    },
    handleClosePrint: function handleClosePrint() {
      this.showImpressao = false;
    },
    handleAnexarDocumento: function handleAnexarDocumento() {
      //ANEXAR DOCUMENTOS AO PEDIDO
      if (!this.showAnexo) {
        this.showAnexo = true;
      }
      this.$nextTick(function () {
        this.$refs.anexos.handleClickAdiciona();
      });
    },
    handleChangeAnexos: function handleChangeAnexos(anexosList) {
      //ATUALIZA A LISTA DE ANEXOS

      this.anexos = anexosList;
    },
    handleFormEmail: function handleFormEmail() {
      //Abre a tela para envio de email
      //carrega o template da mensagem antes do envio (ords/webdata/template/salesorder/:id)

      this.showFormEmail = true;
    },
    handleFormEmailCieloSL: function handleFormEmailCieloSL() {
      //Abre a tela para envio de email
      //carrega o template da mensagem antes do envio (ords/webdata/template/salesorder/:id)

      this.showFormEmailCieloSL = true;
    },
    closeFormEmail: function closeFormEmail() {
      this.showFormEmail = false;
      this.showFormEmailCieloSL = false;
    },
    handleSendEmail: function handleSendEmail(data) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var email;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                //cahamda para envio de email do pedido
                _this9.closeFormEmail();
                _context8.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiEmailPDF"])(_this9, 'pedv/' + _this9.pedv.codpedv, data);

              case 3:
                email = _context8.sent;

              case 4:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    updateActions: function updateActions() {
      /* ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES"
      - quando pendente permite imprimir, enviar, faturar, cancelar
      - quando em digitacao permite cancelar
      - quando liquidado ou cancelado nao permite açoes
      */
      this.btEnviar = (this.pedv.stpedv == 'P' || this.pedv.stpedv == 'F') && this.pedv.tppedv != 'R';
      this.btImprimir = (this.pedv.stpedv == 'P' || this.pedv.stpedv == 'F') && this.pedv.tppedv != 'R';
      this.btFaturar = this.pedv.stpedv == 'P' && this.pedv.tppedv == 'P' && this.pedv.ecommerce == 'S' && !this.pedv.data_leitura;
      this.btCancelar = this.pedv.tppedv === 'P' && this.pedv.nf_pendente === 0 && this.pedv.fin_remessa === 0 && this.pedv.fin_baixado === 0;

      var act = {};
      this.moreActions = [];
      if (this.pedv.stpedv == 'P') {
        if (this.btCancelar) {
          act = { action: 4, label: 'Cancelar' };
          this.moreActions.push(act);
        }
      }
      if (this.pedv.tppedv === 'P') {
        act = { action: 5, label: 'Copiar Pedido' };
        this.moreActions.push(act);
      } else {
        act = { action: 5, label: 'Copiar Orçamento' };
        this.moreActions.push(act);
      }
      if (this.pedv.stpedv == 'P' || this.pedv.stpedv == 'D') {
        act = { action: 10, label: 'Anexar Documento' };
        this.moreActions.push(act);
      }

      //LIBERACAO DE RENTABILIDADE
      if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador) {
        if (this.pedv.strentab == '1') {
          act = { action: 20, label: 'Liberar Orçamento' };
          this.moreActions.push(act);
        }
        if (this.pedv.strentab == '1') {
          act = { action: 21, label: 'Reprovar Orçamento' };
          this.moreActions.push(act);
        }
        if (this.pedv.strentab == '3' || this.pedv.strentab == '2') {
          act = { action: 22, label: 'Desfazer Liberação' };
          this.moreActions.push(act);
        }
      }
    },
    textOption: function textOption(value, field) {
      var item = field.options.filter(function (x) {
        return x.id === value;
      });
      var st = null;
      if (item.length) st = item[0].text;
      if (this.pedv.tppedv == 'O') st = 'Orçamento ' + st;else st = 'Pedido ' + st;
      return st;
    },
    calculaTotal: function calculaTotal() {
      //calcula o total do pedido
      var t = 0;
      for (var x = 0; x < this.pedvit.length; x++) {
        this.pedvit[x].totliq = this.pedvit[x].qt * this.pedvit[x].vlr;
        this.pedvit[x].totliq = Object(__WEBPACK_IMPORTED_MODULE_1__shared_numbers__["calcDesconto"])(this.pedvit[x].totliq, this.pedvit[x].pdesc1, this.pedvit[x].pdesc2, this.pedvit[x].pdesc3, this.pedvit[x].pdesc4, 2, true);
        t += this.pedvit[x].totliq;
      }
      this.pedv.totliq = t;
    },
    validacaoInicial: function validacaoInicial() {
      //VALIDA A SITUACAO DE CREDITO DO CLIENTE, STATUS DO CLIENTE E NATUREZA DE OPERACAO
      this.isValidCabec = true;

      if (this.pedv.nates && this.pedv.nates.length && this.pedv.nates[0].stnates == 'I') {
        this.$erpToastError('A Natureza de saída informada está inativa');
        this.isValidCabec = false;
      }
      if (this.pedv.part[0].stcred != 'L') {
        this.$erpToastError('Cliente com crédito bloqueado');
        this.isValidCabec = false;
      }
      if (this.pedv.part[0].stpart == 'I') {
        this.$erpToastError('Cliente inativo');
        this.isValidCabec = false;
      }
      return this.isValidCabec;
    },
    validacaoCab: function validacaoCab() {
      //validar o cliente quanto ao status do credito, status e natureza de operacao
      this.isValidCabec = true;
      // if (this.pedv.parttr.length && this.pedv.parttr.stpart == 'I') {
      //     this.$erpToastError('Transportadora inativa')
      //     this.isValidCabec = false
      // }
      // if (this.pedv.vend.length && this.pedv.vend.stpart == 'I') {
      //     this.$erpToastError('Representante inativo')
      //     this.isValidCabec = false
      // }
      // if (this.pedv.tabpre.length && this.pedv.tabpre.sttabpre == 'I') {
      //     this.$erpToastError('Tabela de preço inativa')
      //     this.isValidCabec = false
      // }
      // if (this.pedv.condicao.length && this.pedv.condicao.stcondicao == 'I') {
      //     this.$erpToastError('Condição de pagamento inativa')
      //     this.isValidCabec = false
      // }
    },
    loadData: function loadData(id) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                //carrega o pedido para alteracao ou visualizacao
                _this10.partTabela = false;
                _this10.partCodTabpre = null;

                _this10.unwatch = true;
                _context9.next = 5;
                return _this10.$store.dispatch('loadPedv', { id: id });

              case 5:
                if (_this10.$store.getters.getPedv) {
                  _this10.pedv = _extends({}, _this10.$store.getters.getPedv[0]);
                  _this10.pedvit = _this10.pedv.pedvit;
                  if (_this10.pedv.part[0].codtabpre) {
                    _this10.partCodTabpre = _this10.pedv.part[0].codtabpre;
                    _this10.partTabela = true;
                  }
                  if (_this10.pedv.validation) _this10.errmessages = JSON.parse(_this10.pedv.validation);
                  if (_this10.pedv.anexos.length) _this10.anexos = _this10.pedv.anexos;else _this10.anexos = [];
                  if (_this10.pedv.pedvpar) {
                    _this10.pedvpar = _this10.pedv.pedvpar;
                  }
                  if (_this10.pedv.negociocrm && _this10.pedv.negociocrm.length > 0) {
                    _this10.negociocrm = _this10.pedv.negociocrm[0];
                    if (_this10.pedv.negociocrm[0].pessoa.length > 0) _this10.pessoa = _this10.pedv.negociocrm[0].pessoa[0];
                    if (_this10.pedv.negociocrm[0].organizacao.length > 0) _this10.organizacao = _this10.pedv.negociocrm[0].organizacao[0];
                  }

                  _this10.updateActions(); //ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES" AO CARREGAR UM PEDIDO
                }
                _this10.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                  this.unwatch = false;
                });

              case 7:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    },


    // changeTab (idx) {
    //     //controle de visualizacao das paginas
    //     this.formItemsPedido = true
    //     this.activeTab = idx
    // },

    calculaParcelas: function calculaParcelas() {
      //CALCULA PARCELAS DO PEDIDO
      this.pedvpar = [];
      var vlr = 0;
      if (this.pedv.parcelas == '0') {
        var parcela = _extends({}, this.$store.getters.getEntities.pedvpar);
        parcela.dtv = this.pedv.data;
        parcela.vlr = this.pedv.totger;
        parcela.obspar = '';
        parcela.dias = 0;
        this.pedvpar.push(parcela);
      } else {
        for (var x = 1; x <= this.pedv.parcelas; x++) {
          var _parcela = _extends({}, this.$store.getters.getEntities.pedvpar);
          _parcela.dtv = this.$addMonths(this.pedv.data, x);
          _parcela.dias = x * 30;
          vlr = this.pedv.totger;
          vlr = Object(__WEBPACK_IMPORTED_MODULE_1__shared_numbers__["arr"])(vlr / this.pedv.parcelas, 2, true);
          // console.log('parcela ' + x + ': ' + vlr)
          _parcela.vlr = vlr;
          _parcela.obspar = '';
          this.pedvpar.push(_parcela);
        }
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },
    pedvparVlrChange: function pedvparVlrChange(index) {
      //evento de controle de alteracao do valor da parcela
      //quando usuario alterar o valor de uma parcela, refaz as demais parcelas
      if (this.pedv.parcelas <= 1) {
        return;
      }
      var vlrparcial = 0;
      var vlrnovaparcela = 0;
      for (var x = 0; x <= index; x++) {
        vlrparcial = vlrparcial + parseFloat(this.pedvpar[x].vlr);
      }
      if (vlrparcial < this.pedv.totger) {
        vlrnovaparcela = (this.pedv.totger - vlrparcial) / (this.pedv.parcelas - (index + 1));
        vlrnovaparcela.toFixed(2);
      } else {}
      for (var x = index + 1; x <= this.pedvpar.length - 1; x++) {
        this.pedvpar[x].vlr = vlrnovaparcela;
      }
    },
    pedvparDiasChange: function pedvparDiasChange(index) {
      //evento de controle de alteracao do nr de dias de vencimento da parcela
      this.pedvpar[index].dtv = this.$addDays(this.pedv.data, this.pedvpar[index].dias);
    },
    usuarioTemPermissaoNaTabelaPreco: function usuarioTemPermissaoNaTabelaPreco(codtabpre) {
      if (codtabpre) {
        if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.length > 0) {
          var liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter(function (obj) {
            return obj == codtabpre;
          });
          if (liberado.length > 0) {
            return true;
          }
        } else {
          return true;
        }
      }
      return false;
    },
    carregaDadosCliente: function carregaDadosCliente() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _this11.$store.dispatch('loadPart', { id: _this11.pedv.codpart });

              case 2:
                //atualiza os dados do cliente no pedido quando informado um codigo do cliente
                if (!_this11.pedv.part || _this11.pedv.part[0].codpart != _this11.pedv.codpart) {
                  _this11.pedv.part = _this11.part;
                  _this11.pedv.finalidade = _this11.pedv.part[0].tpcliente;
                  if (_this11.pedv.part[0].codnates) _this11.pedv.codnates = _this11.pedv.part[0].codnates;
                  _this11.pedv.nates = _this11.pedv.part[0].nates[0];

                  _this11.partCodTabpre = null;
                  _this11.partTabela = false;
                  if (_this11.usuarioTemPermissaoNaTabelaPreco(_this11.pedv.part[0].codtabpre)) {
                    _this11.pedv.codtabpre = _this11.pedv.part[0].codtabpre;
                    _this11.partCodTabpre = _this11.pedv.part[0].codtabpre;
                    _this11.partTabela = true;
                  }
                  _this11.pedv.tabpre = _this11.pedv.part[0].tabpre[0];
                  _this11.pedv.codparttr = _this11.pedv.part[0].codparttr;
                  _this11.pedv.parttr = _this11.pedv.part[0].parttr[0];
                  _this11.pedv.codnatfin = _this11.pedv.part[0].codnatfinrec;
                  _this11.pedv.codcondicao = _this11.pedv.part[0].codcondicao;
                  _this11.pedv.condicao = _this11.pedv.part[0].condicao[0];
                  if (_this11.pedv.part[0].partcontato.length > 0) _this11.pedv.seqcontato = _this11.pedv.part[0].partcontato[0].seqcontato;
                  if (_this11.pedv.part[0].tpfrete) _this11.pedv.tpfrete = _this11.pedv.part[0].tpfrete;
                }
                _this11.validacaoInicial();

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this11);
      }))();
    },
    loadNegocio: function loadNegocio(codnegocio) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this12.$store.dispatch('loadNegocio', { id: codnegocio });

              case 2:
                if (_this12.$store.getters.getNegocio) {
                  _this12.negociocrm = _extends({}, _this12.$store.getters.getNegocio);
                  if (_this12.negociocrm.organizacao.length > 0) _this12.organizacao = _this12.negociocrm.organizacao[0];
                  if (_this12.negociocrm.pessoa.length > 0) _this12.pessoa = _this12.negociocrm.pessoa[0];
                  _this12.pedv.codnegocio = _this12.negociocrm.codnegocio;
                  _this12.pedv.codpart = _this12.organizacao.codpart;
                }

              case 3:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this12);
      }))();
    }
  },

  watch: {
    part: function part() {},

    selectedNates: function selectedNates() {
      //atualiza a natureza de operacao
      this.pedv.nates = _extends({}, this.selectedNates);
    },

    codpart: function codpart(newValue, oldValue) {
      if (newValue != oldValue) {
        this.carregaDadosCliente();
      }
    },

    codnates: function codnates() {
      //carrega os dados da natureza selecionada pelo codigo => /cg/nates/id
      this.$store.dispatch('loadNates', { id: this.pedv.codnates });
    },

    prazodias: function prazodias() {
      //CALCULA O PRAZO DE ENTREGA QUANDO ALTERAR O PRAZO EM DIAS
      if (this.unwatch) return;
      if (this.pedv.prazodias > 0) {
        this.pedv.prazo = this.$addDays(this.pedv.data, this.pedv.prazodias);
      }
    },

    prazo: function prazo() {
      //console.log(this.pedv.prazo)
    },

    validadedias: function validadedias() {
      //CALCULA O PRAZO DE ENTREGA QUANDO ALTERAR O PRAZO EM DIAS
      if (this.unwatch) return;
      if (this.pedv.validadedias > 0) {
        this.pedv.dtvalidade = this.$addDays(this.pedv.data, this.pedv.validadedias);
      }
    },

    dtvalidade: function dtvalidade() {
      //console.log(this.pedv.dtvalidade)
    },

    parcelas: function parcelas() {
      //calcula numero de parcelas da condicao de pagamento
      if (this.unwatch) return;
      this.calculaParcelas();
    }
  },

  created: function created() {
    //this.$store.dispatch('clearItemSales')

    //carrega parametros do usuario para bloqueio das tabelas de precos
    this.$store.dispatch('loadParametrosUsuario');

    //carrega as tabelas de precos liberadas para o usuario no computed "tabelas_preco_options"
    this.$store.dispatch('loadTabpre', {});

    this.$store.dispatch('loadNates', {});

    //carrega as condicoes de pagamento
    this.$store.dispatch('loadCondicao', {});

    //carrega lista de destaques
    this.$store.dispatch('loadDestaq', {});

    this.metadata.pedv.parcelas.options.sort(function (a, b) {
      return Number(a.id) > Number(b.id) ? 1 : Number(b.id) > Number(a.id) ? -1 : 0;
    });

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });

    //this.crud = SysVars.crudI;
    this.crudText = this.$crudText(this.crud);
    this.codpedv = this.index;

    this.$scrollTo(0);

    this.view = this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudView;

    var incluir = this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI;
    if (this.$route.params && this.$route.params.id == 'novo') {
      incluir = true;
      if (this.$route.params.codpart) {
        this.pedv.codpart = this.$route.params.codpart;
      }
    }

    //SE A CHAMADA É DE DENTRO DO FORMULARIO DE NEGOCIO DO CRM
    //a rota chamada é /crm/negocio/:codnegocio/orcamento/novo
    if (this.$route.params && this.$route.params.codnegocio) {
      this.loadNegocio(this.$route.params.codnegocio);
      if (this.$route.params.id && this.$route.params.id != 'novo') {
        incluir = false;
        this.codpedv = this.$route.params.id;
      } else incluir = true;
    }

    if (incluir) {
      this.formNew = true;
      this.pedv.data = this.$getDate();
      this.pedv.stpedv = 'D';
      this.pedv.finalidade = 'F';
      this.pedv.indpresencial = '0';
      this.pedv.bonif = 'N';
      this.pedv.amostra = 'N';
      this.pedv.pgantecipado = 'N';
      this.pedv.tpfrete = '0';
      this.pedv.tppedv = 'O';
      this.pedv.impinfgeraisgarantia = 'S';
      if (this.tabelas_preco_options && this.tabelas_preco_options.length > 0) {
        this.pedv.codtabpre = this.tabelas_preco_options[0].id;
      } else {
        this.pedv.codtabpre = '1';
      }
      if (this.natesListSaida && this.natesListSaida.length > 0) {
        this.pedv.codnates = this.natesListSaida[0].codnates;
      } else {
        this.pedv.codnates = '1';
      }

      if (this.negocio) {
        this.negociocrm = this.negocio;
        if (this.negociocrm.organizacao.length > 0) this.organizacao = this.negociocrm.organizacao[0];
        if (this.negociocrm.pessoa.length > 0) this.pessoa = this.negociocrm.pessoa[0];
        this.pedv.codnegocio = this.negocio.codnegocio;
        if (this.organizacao) this.pedv.codpart = this.organizacao.codpart;
      }

      this.unwatch = false;
      this.updateActions();
      this.$nextTick(function () {
        this.$refs.part.focus();
      });
    } else {
      this.formOrder = true;
      this.loadData(this.codpedv);
    }
  }
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_pedido_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_pedido_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__api_api_pedido_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        pedv: { type: Object }
    },

    data: function data() {
        return {
            obs: ''
        };
    },


    computed: {

        liberaRentab: function liberaRentab() {
            return this.pedv.strentab == '1' && __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador;
        },

        liberacaoEfetuada: function liberacaoEfetuada() {
            return this.pedv.strentab == '3';
        },

        liberacaoReprovada: function liberacaoReprovada() {
            return this.pedv.strentab == '2';
        },

        desfazerLiberacao: function desfazerLiberacao() {
            return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador && !this.pedv.data_leitura && this.pedv.tppedv == 'O';
        },

        hist: function hist() {
            var hist = JSON.parse(this.pedv.validation);
            if (hist && hist.historico_rentabilidade) return hist.historico_rentabilidade[hist.historico_rentabilidade.length - 1];else return null;
        }

    },

    mixins: [__WEBPACK_IMPORTED_MODULE_1__api_api_pedido_js___default.a],

    methods: {
        handleSave: function handleSave() {
            this.$emit('save');
        },
        handleLiberar: function handleLiberar(liberada, desfazerLiberacao) {
            this.apiRentab(this.pedv, liberada, desfazerLiberacao, this.obs, this.apiPedidoCallback);
        },
        apiPedidoCallback: function apiPedidoCallback() {
            this.$emit('reload');
        }
    },

    watch: {},

    components: {},

    created: function created() {},
    mounted: function mounted() {}
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_customer_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_customer_contato_form__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_vend_form__ = __webpack_require__(78);
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        pedv: { type: Object },
        partCodTabpre: { type: String },
        metadata: { type: Object },
        isView: { type: Boolean }
    },

    data: function data() {
        return {
            showPartForm: false, //exibe o formulario de cliente para inclusao
            showVendForm: false, //exibe o formulario de vendedor para inclusao
            showContatoForm: false //exibe o formulario de contato do cliente para inclusao
        };
    },


    computed: {
        administrador: function administrador() {
            return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador;
        },

        select2Contato: function select2Contato() {
            return { entity: 'partcontato/' + this.pedv.codpart, minlength: 0 };
        },

        bloqueia_tabela_cliente: function bloqueia_tabela_cliente() {
            if (this.pedv.part && this.pedv.part.length > 0 && this.pedv.part[0].codtabpre) {
                if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) return this.$store.getters.getParametrosUsuario.vendas.bloqueia_tabela_cliente;else return false;
            } else return false;
        },

        tabelas_preco_options: function tabelas_preco_options() {
            //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
            var options = [];

            var liberado = [];
            var currTabpre = {};
            var addTabela = false;

            for (var x = 0; x < this.$store.getters.getTabpreList.length; x++) {
                currTabpre = this.$store.getters.getTabpreList[x];

                //se existir parametros do usuario, libera somente as tabelas permitidas
                if (this.partCodTabpre && this.partCodTabpre == currTabpre.codtabpre) addTabela = true;else if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) {
                    liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter(function (obj) {
                        return obj == currTabpre.codtabpre;
                    });
                    if (liberado.length > 0) {
                        addTabela = true;
                    }
                } else {
                    addTabela = true;
                }

                if (addTabela) options.push({ id: currTabpre.codtabpre, text: currTabpre.descricao });

                addTabela = false;
            }

            return options;
        }

    },

    filters: {},

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleSave: function handleSave() {
            var _this = this;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.validarcampos();
                    if (_this.errmessages.errmessages.length == 0) {
                        _this.$emit('save');
                    } else {
                        _this.$erpToastError('Corrigir os erros de validação');
                    }
                }
            });
        },
        closeCustomerForm: function closeCustomerForm(id) {
            //ao fechar o formulario de inclusao de clientes
            //if (id) this.pedv.codpart = id
            this.showPartForm = false;
        },
        closeVendForm: function closeVendForm(id) {
            //ao fechar o formulario de inclusao de vendedor
            if (id) this.pedv.codvendr = id;
            this.showVendForm = false;
        },
        closeContatoForm: function closeContatoForm(id) {
            //ao fechar o formulario de inclusao de vendedor
            if (id) this.pedv.seqcontato = id;
            this.showContatoForm = false;
        },
        handleIncluirContato: function handleIncluirContato() {
            this.showContatoForm = true;
        },
        handleIncluir: function handleIncluir(pTipo) {
            //exibe tela de cadastro
            if (this.isView) {
                return;
            }

            if (pTipo === 'part') {
                this.showPartForm = true;
            }

            if (pTipo === 'transp') {
                this.showPartForm = true;
            }

            if (pTipo === 'vend') {
                this.showPartForm = true;
            }
        },
        updateCep: function updateCep() {
            //CARREGA INFORMACOES DO CEP
            this.pedv.endeent = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.logradouro;
            this.pedv.bairroent = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.bairro;
            this.pedv.codmunent = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.ibge;
            this.pedv.ufent = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.uf;
        },
        validarcampos: function validarcampos() {
            this.errmessages = {};
            this.errmessages.errmessages = [];

            if ((this.pedv.cepret || this.pedv.enderet || this.pedv.nomeret || this.pedv.endenrret) && !this.pedv.cnpjcpfret) {
                this.errmessages.errmessages.push('Cnpj/Cpf Retirada deve ser preenchido.');
            }
            if ((this.pedv.cepret || this.pedv.enderet || this.pedv.nomeret || this.pedv.endenrret) && !this.pedv.tppessoaret) {
                this.errmessages.errmessages.push('Tipo Pessoa Retirada deve ser preenchido.');
            }
            if ((this.pedv.cepret || this.pedv.enderet || this.pedv.nomeret || this.pedv.endenrret) && !this.pedv.endenrret) {
                this.errmessages.errmessages.push('Nr endereço Retirada deve ser preenchido.');
            }
            if ((this.pedv.cepret || this.pedv.enderet || this.pedv.nomeret || this.pedv.endenrret) && !this.pedv.enderet) {
                this.errmessages.errmessages.push('Endereço Retirada deve ser preenchido.');
            }
            if ((this.pedv.cepent || this.pedv.endeent || this.pedv.nomeent || this.pedv.endenrent) && !this.pedv.cnpjcpfent) {
                this.errmessages.errmessages.push('Cnpj/Cpf Entrega deve ser preenchido.');
            }
            if ((this.pedv.cepent || this.pedv.endeent || this.pedv.nomeent || this.pedv.endenrent) && !this.pedv.tppessoaent) {
                this.errmessages.errmessages.push('Tipo Pessoa Entrega deve ser preenchido.');
            }
            if ((this.pedv.cepent || this.pedv.endeent || this.pedv.nomeent || this.pedv.endenrent) && !this.pedv.endenrent) {
                this.errmessages.errmessages.push('Nr endereço Entrega deve ser preenchido.');
            }
            if ((this.pedv.cepent || this.pedv.endeent || this.pedv.nomeent || this.pedv.endenrent) && !this.pedv.endeent) {
                this.errmessages.errmessages.push('Endereço Entrega deve ser preenchido.');
            }
        }
    },

    watch: {},

    components: {
        CustomerForm: __WEBPACK_IMPORTED_MODULE_2__forms_customer_form__["default"], CustomerContatoForm: __WEBPACK_IMPORTED_MODULE_3__forms_customer_contato_form__["a" /* default */], VendForm: __WEBPACK_IMPORTED_MODULE_4__forms_vend_form__["a" /* default */]

    },

    created: function created() {},
    mounted: function mounted() {
        this.$nextTick(function () {
            this.$refs.contato.$el.querySelector('select').focus();
            // this.$refs.contato.$el.querySelector('input').focus()
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
    }
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_filter_list__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__financeiro_form__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__financeiro_movimento_form__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__financeiro_transf_form__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_csvReport__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_csvReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__shared_csvReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_button_vue__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__forms_financeiro_print_recibo_vue__ = __webpack_require__(1729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__forms_financeiro_relatorio_agrupado_vue__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__forms_financeiro_relatorio_data_vue__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__forms_financeiro_relatorio_extrato_vue__ = __webpack_require__(1741);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,
            moreActionsBarList: [],
            monthFilter: {},
            statusQuery: '',
            filterList: [],
            paramFilterList: {},
            showForm: false,
            showTransfForm: false,
            showMovForm: false,
            codfin: '',
            tipofin: null,
            url: '',
            urlboleto: 'fin/boleto/',
            textQuery: '',

            listContas: null,
            contas: null,
            listTipos: [{ id: 1, text: 'Abertas' }, { id: 2, text: 'Vencidas' }, { id: 3, text: 'Baixadas' }, { id: 4, text: 'Perdidas' }],
            tipos: ['1', '2', '3', '4'],

            filtro: {
                periodos: [{ data_inicio: null, data_termino: null }]
            },
            periodo: { startDate: null, endDate: null },
            periodoEmissao: { startDate: null, endDate: null },
            periodoVencimento: { startDate: null, endDate: null },
            periodoRecebimento: { startDate: null, endDate: null },
            documento: { value: null },
            valor: { start: null, end: null },
            codpart: null,
            codcta: null,
            activeTab: 0,

            showAlert: false,

            dados: null,
            filial: null,

            tabs: [{ title: 'Contas a Receber', icon: 'fa-archive' }, { title: 'Contas a Pagar', icon: 'fa-cubes' }, { title: 'Caixa e Bancos', icon: 'fa-cubes' }],

            tipoRelatorio: null,
            tipoOptions: [{ id: 1, text: "Recibo" }, { id: 2, text: "Relatório" }, { id: 3, text: "Relatório (Data)" }],
            finListGroup: {},
            showModalCobranca: false,
            titulosVencidosPorCliente: [],
            allFinListChecked: false,
            cartaCobrancaCheckAll: false,

            showRelatorio: false,
            showRelatorioData: false,
            showRelatorioExtrato: false,
            showRecibo: false,
            showModalErrosBoleto: false,
            listErrosBoleto: [],
            showModalEnviarEmailBoleto: false,
            selectedTitulosBoleto: [],

            tipo: null,
            listFiltros: [{ id: '1', text: 'A Vencer' }, { id: '2', text: 'Vencidos' }, { id: '5', text: 'Todos Vencidos' }, { id: '3', text: 'Baixados' }, { id: '4', text: 'Cancelados/Perdidos' }, { id: '6', text: 'Todos Por Data Emissão' }, { id: '7', text: 'Abertos Por Data Alteração' }, { id: '9', text: 'Todos Por Data Alteração' }],
            sortKey: '',
            sortOrder: 1

        };
    },


    computed: {
        companyName: function companyName() {
            return this.$store.getters.getFilial.fantasia;
        },
        maisAcoes: function maisAcoes() {
            var acoes = [];
            if (this.receberTab) {
                acoes.push({ label: 'Relatório Agrupado Por Data', action: '3' });
                acoes.push({ label: 'Relatório Agrupado Por Cliente', action: '2' });
            }
            if (this.pagarTab) {
                acoes.push({ label: 'Relatório Agrupado Por Data', action: '3' });
                acoes.push({ label: 'Relatório Agrupado Por Fornecedor', action: '2' });
            }
            if (this.extratoTab) {
                acoes.push({ label: 'Incluir Transferência', action: '1' });
                acoes.push({ label: 'Relatório Extrato', action: '4' });
            }
            acoes.push({ label: 'Configurar Natureza Financeira', action: '20' });
            acoes.push({ label: 'Configurar Contas e Bancos', action: '30' });
            acoes.push({ label: 'Exportar Excel', action: '50' });

            return acoes;
        },

        receberTab: function receberTab() {
            return this.activeTab == 0;
        },

        pagarTab: function pagarTab() {
            return this.activeTab == 1;
        },

        extratoTab: function extratoTab() {
            return this.activeTab == 2;
        },

        finList: function finList() {
            var _this = this;

            var finList = [];

            if (this.dados && this.dados.dados) {
                this.dados.dados.forEach(function (fin, i) {
                    if (_this.dados.dados[i].isChecked === undefined) {
                        _this.$set(_this.dados.dados[i], 'isChecked', false);
                    }
                });

                finList = [].concat(_toConsumableArray(this.dados.dados));

                if (this.sortKey) {
                    var key = this.sortKey;
                    var order = this.sortOrder;

                    finList.sort(function (a, b) {
                        var valA = a[key];
                        var valB = b[key];

                        // Comparação de datas
                        if (key === 'dtemissao' || key === 'vencimento' || key === 'data' || key === 'dataAlteracao' || key === 'dataBaixa') {
                            var dateA = valA ? new Date(valA) : new Date(0);
                            var dateB = valB ? new Date(valB) : new Date(0);
                            return (dateA - dateB) * order;
                        }

                        // Comparação de valores numéricos
                        if (key === 'vlr' || key === 'saldo') {
                            var numA = parseFloat(valA) || 0;
                            var numB = parseFloat(valB) || 0;
                            return (numA - numB) * order;
                        }

                        // Comparação de strings
                        var strA = valA ? String(valA).toLowerCase() : '';
                        var strB = valB ? String(valB).toLowerCase() : '';
                        return strA.localeCompare(strB, 'pt-BR') * order;
                    });
                }
                this.showAlert = true;
            }

            return finList;
        },

        printFinList: function printFinList() {
            var finList = this.finList;
            if (finList) {
                return finList.filter(function (obj) {
                    return obj.isChecked === true;
                });
            }
        },
        finListGrupo: function finListGrupo() {
            var finList = this.finList;

            var fornecedores = finList.map(function (fin) {
                return { codpart: fin.codpart, nome: fin.nome };
            });

            var fornecedoresSemRepeticao = fornecedores.filter(function (item) {
                return !this[JSON.stringify(item)] && (this[JSON.stringify(item)] = true);
            }, Object.create(null));

            var finListGrupo = [];
            var totalGeral = [];

            fornecedoresSemRepeticao.map(function (fornecedores) {
                var total = 0;

                finListGrupo.push(fornecedores);

                finList.filter(function (obj) {
                    if (obj.codpart === fornecedores.codpart) {
                        finListGrupo.push(obj);
                        total = total + obj.vlr;
                    }
                });

                totalGeral.push(total);
                total = { total: total };
                finListGrupo.push(total);
            });

            totalGeral = totalGeral.reduce(function (total, totalGeral) {
                return total + totalGeral;
            }, 0);
            totalGeral = { totalGeral: totalGeral };
            finListGrupo.push(totalGeral);

            return finListGrupo;
        },
        finListGrupoData: function finListGrupoData() {
            var finList = this.finList;

            var datas = finList.map(function (fin) {
                return { data: fin.data };
            });

            var datasSemRepeticao = datas.filter(function (item) {
                return !this[JSON.stringify(item)] && (this[JSON.stringify(item)] = true);
            }, Object.create(null));

            var finListGrupoData = [];
            var totalGeral = [];

            datasSemRepeticao.map(function (datas) {
                var total = 0;

                finListGrupoData.push(datas);

                finList.filter(function (obj) {
                    if (obj.data === datas.data) {
                        finListGrupoData.push(obj);
                        total = total + obj.vlr;
                    }
                });

                totalGeral.push(total);
                total = { total: total };
                finListGrupoData.push(total);
            });

            totalGeral = totalGeral.reduce(function (total, totalGeral) {
                return total + totalGeral;
            }, 0);
            totalGeral = { totalGeral: totalGeral };
            finListGrupoData.push(totalGeral);

            return finListGrupoData;
        }
    },

    watch: {
        tipos: function tipos() {
            this.loadData();
        },

        tipo: function tipo() {
            this.loadData();
        },

        contas: function contas() {
            this.loadData();
        },

        periodo: {
            handler: function handler() {
                this.loadData();
            },

            deep: true
        },

        cartaCobrancaCheckAll: function cartaCobrancaCheckAll() {
            if (this.cartaCobrancaCheckAll) {
                this.titulosVencidosPorCliente.forEach(function (e) {
                    e.isChecked = true;
                });
            } else {
                this.titulosVencidosPorCliente.forEach(function (e) {
                    e.isChecked = false;
                });
            }
        }
    },

    methods: {
        sortBy: function sortBy(key) {
            if (this.sortKey === key) {
                this.sortOrder = this.sortOrder === 1 ? -1 : 1;
            } else {
                this.sortKey = key;
                this.sortOrder = 1;
            }
        },
        getSortIcon: function getSortIcon(key) {
            if (this.sortKey !== key) {
                return 'fa-sort text-muted-light';
            }
            return this.sortOrder === 1 ? 'fa-chevron-up text-primary' : 'fa-chevron-down text-primary';
        },
        closeModalErros: function closeModalErros() {
            this.showModalErrosBoleto = false;
        },
        handleLimparFiltros: function handleLimparFiltros(isLoadData) {
            this.codpart = null;
            this.codcta = null;
            this.documento.value = null;
            this.valor.start = null;
            this.valor.end = null;
            if (!isLoadData) this.loadData();
        },
        textST: function textST(fin) {
            if (fin.perdido) return 'Perdido';else if (fin.cancelado) return 'Cancelado';else if (fin.baixado && fin.parcial) return 'Baixado Parcial';else if (fin.baixado) return 'Baixado';
        },
        handleVerifyToCheckAll: function handleVerifyToCheckAll() {
            var _this2 = this;

            this.allFinListChecked = !this.allFinListChecked;
            this.finList.forEach(function (fin) {
                fin.isChecked = _this2.allFinListChecked;
            });
        },
        dataStr: function dataStr(data) {
            if (!data) return '';else return Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatDate"])(data);
        },
        datasTitulo: function datasTitulo(fin) {
            if (fin.tipo == 'R' || fin.tipo == 'P') {
                var str = 'Emissão: ' + this.dataStr(fin.dtemissao) + '\n Vencimento: ' + this.dataStr(fin.vencimento) + '\n Alteração: ' + this.dataStr(fin.dataAlteracao);

                if (fin.dataBaixa) str = str + '\n Baixa: ' + this.dataStr(fin.dataBaixa);

                return str;
            }

            return null;
        },
        getClienteLabel: function getClienteLabel(fin) {
            var label = fin.nome || '';
            if (fin.descricao) label += ' ' + fin.descricao;
            if (fin.npedido) label += ' Pedido ' + fin.npedido;
            if (fin.texto) label += ' ' + fin.texto;
            return label.trim();
        },
        changeTab: function changeTab(idx) {
            //mudança de pagina
            this.activeTab = idx;
            this.loadData();
        },
        handleEmiteBoleto: function handleEmiteBoleto(fin) {
            //EMISSAO DO BOLETO DO TITULO SELECIONADO
            var sendData = { titulos: [{ codfin: fin.codfin }] };
            Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiDownloadPDF"])(this, this.urlboleto, sendData, 'post');
        },
        handleEdit: function handleEdit(fin) {
            //abre a tela de edicao
            this.$modalForm(true);

            if (fin.aberto) this.crud = __WEBPACK_IMPORTED_MODULE_9__main__["SysVars"].crudU;else this.crud = __WEBPACK_IMPORTED_MODULE_9__main__["SysVars"].crudView;

            this.codfin = fin.codfin;

            if (fin.tipo == 'R' || fin.tipo == 'P') {
                this.tipofin = fin.tipo;
                this.showForm = true;
            } else if (fin.tipo == 'E' || fin.tipo == 'S') this.showMovForm = true;

            if (fin.stremessacnab == 1 || fin.stremessacnab == 2) {
                this.$erpToastError('Este título está em remessa e não pode ser alterado');
            }
        },
        handleNew: function handleNew(action) {
            //inclusao de registro

            if (!action) {
                this.crud = __WEBPACK_IMPORTED_MODULE_9__main__["SysVars"].crudI;
                this.codfin = '';
                if (this.receberTab) this.tipofin = 'R';else if (this.pagarTab) this.tipofin = 'P';

                this.$modalForm(true);
                if (!this.extratoTab) this.showForm = true;else this.showMovForm = true;
            } else if (action == '1') {
                this.crud = __WEBPACK_IMPORTED_MODULE_9__main__["SysVars"].crudI;
                this.$modalForm(true);
                this.showTransfForm = true;
            } else if (action == '20') this.handleNatureza();else if (action == '30') this.handleContas();else if (action == '40') this.handleCobranca();else if (action == '4') //extrato
                this.handlePrint(4);else if (action == '2') //relatorio por fornecedor/cliente
                this.handlePrint(2);else if (action == '3') //relatorio data
                this.handlePrint(3);else if (action == '50') //exportar excel
                this.loadData(true);
        },
        handleBaixar: function handleBaixar(codfin) {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var sendData, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //EFETUA A BAIXA DO TITULO
                                sendData = { titulos: [{ codfin: codfin }] };
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiORDSpost"])(_this3.$store, 'fin/baixar/', sendData, 'post');

                            case 3:
                                data = _context.sent;

                                if (data.errmessages) {
                                    _this3.errmessages = data.errmessages;
                                    _this3.$erpToastError(data.errmessages[0]);
                                } else {
                                    _this3.$erpToastSuccess('Baixa efetivada com sucesso.');
                                    _this3.loadData();
                                }

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        handleEstornarBaixa: function handleEstornarBaixa(codfin) {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var sendData, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //DESFAZ A BAIXA DO TITULO
                                sendData = { titulos: [{ codfin: codfin }] };
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiORDSpost"])(_this4.$store, 'fin/estornarbaixa/', sendData, 'post');

                            case 3:
                                data = _context2.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError(data.errmessages[0]);
                                } else {
                                    _this4.$erpToastSuccess('A baixa foi estornada.');
                                    _this4.loadData();
                                }

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4);
            }))();
        },
        handleNatureza: function handleNatureza() {
            this.$router.push('/natfinlist');
        },
        handleContas: function handleContas() {
            this.$router.push('/cta');
        },
        handleCobranca: function handleCobranca() {
            var _this5 = this;

            var clientes = this.finList.map(function (cliente) {
                return { codpart: cliente.codpart, nome: cliente.nome, email: '' };
            });

            var clientesSemRepeticao = clientes.filter(function (item) {
                return !this[JSON.stringify(item)] && (this[JSON.stringify(item)] = true);
            }, Object.create(null));

            clientesSemRepeticao.map(function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(cliente) {
                    var dadosCliente, total;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this5.$store.dispatch('loadPart', { id: cliente.codpart });

                                case 2:
                                    dadosCliente = _this5.$store.getters.getPart.length ? _extends({}, _this5.$store.getters.getPart[0]) : {};


                                    if (!dadosCliente.emailcobranca && dadosCliente.partcontato.length) {
                                        cliente.email = dadosCliente.partcontato[0].email;
                                    } else {
                                        cliente.email = dadosCliente.emailcobranca;
                                    }

                                    total = 0;


                                    _this5.finList.filter(function (el) {
                                        if (el.codpart === cliente.codpart && el.vencido) {
                                            total = total + el.vlr;
                                        }
                                    });

                                    cliente.total = total;

                                    if (cliente.total) {
                                        _this5.titulosVencidosPorCliente.push(cliente);
                                    }

                                case 8:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this5);
                }));

                return function (_x) {
                    return _ref.apply(this, arguments);
                };
            }());

            this.showModalCobranca = true;
        },
        handleEnviarEmail: function handleEnviarEmail() {
            var _this6 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var data, uniqueCodparts, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, codpart;

                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                data = _this6.finList.filter(function (obj) {
                                    return obj.isChecked === true;
                                });

                                if (data.length) {
                                    _context5.next = 3;
                                    break;
                                }

                                return _context5.abrupt('return', _this6.$erpToastError('Selecione ao menos 1 título antes de enviar o boleto'));

                            case 3:

                                _this6.selectedTitulosBoleto = data.map(function (fin) {
                                    return {
                                        codfin: fin.codfin,
                                        doc: fin.doc,
                                        parcela: fin.parcela,
                                        codpart: fin.codpart,
                                        nome: fin.nome,
                                        vlr: fin.vlr,
                                        email: ''
                                    };
                                });

                                // Carregar e-mails dos clientes sequencialmente para evitar condições de corrida no store global
                                uniqueCodparts = [].concat(_toConsumableArray(new Set(_this6.selectedTitulosBoleto.map(function (t) {
                                    return t.codpart;
                                }))));
                                _loop = /*#__PURE__*/regeneratorRuntime.mark(function _callee4(codpart) {
                                    var dadosCliente, email;
                                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                                        while (1) {
                                            switch (_context4.prev = _context4.next) {
                                                case 0:
                                                    _context4.next = 2;
                                                    return _this6.$store.dispatch('loadPart', { id: codpart });

                                                case 2:
                                                    dadosCliente = _this6.$store.getters.getPart.length ? _extends({}, _this6.$store.getters.getPart[0]) : {};
                                                    email = '';

                                                    if (!dadosCliente.emailcobranca && dadosCliente.partcontato && dadosCliente.partcontato.length) {
                                                        email = dadosCliente.partcontato[0].email;
                                                    } else {
                                                        email = dadosCliente.emailcobranca || '';
                                                    }

                                                    _this6.selectedTitulosBoleto.forEach(function (titulo) {
                                                        if (titulo.codpart === codpart) {
                                                            titulo.email = email;
                                                        }
                                                    });

                                                case 6:
                                                case 'end':
                                                    return _context4.stop();
                                            }
                                        }
                                    }, _callee4, _this6);
                                });
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context5.prev = 9;
                                _iterator = uniqueCodparts[Symbol.iterator]();

                            case 11:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context5.next = 17;
                                    break;
                                }

                                codpart = _step.value;
                                return _context5.delegateYield(_loop(codpart), 't0', 14);

                            case 14:
                                _iteratorNormalCompletion = true;
                                _context5.next = 11;
                                break;

                            case 17:
                                _context5.next = 23;
                                break;

                            case 19:
                                _context5.prev = 19;
                                _context5.t1 = _context5['catch'](9);
                                _didIteratorError = true;
                                _iteratorError = _context5.t1;

                            case 23:
                                _context5.prev = 23;
                                _context5.prev = 24;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 26:
                                _context5.prev = 26;

                                if (!_didIteratorError) {
                                    _context5.next = 29;
                                    break;
                                }

                                throw _iteratorError;

                            case 29:
                                return _context5.finish(26);

                            case 30:
                                return _context5.finish(23);

                            case 31:

                                _this6.showModalEnviarEmailBoleto = true;

                            case 32:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this6, [[9, 19, 23, 31], [24,, 26, 30]]);
            }))();
        },
        closeModalEnviarEmailBoleto: function closeModalEnviarEmailBoleto() {
            this.showModalEnviarEmailBoleto = false;
            this.selectedTitulosBoleto = [];
        },
        handleConfirmarEnviarEmailBoleto: function handleConfirmarEnviarEmailBoleto() {
            var noEmail = this.selectedTitulosBoleto.some(function (e) {
                return !e.email || !e.email.trim();
            });

            if (noEmail) {
                return this.$erpToastError('Todos os boletos selecionados devem ter o campo e-mail preenchido');
            }

            var titulos_array = this.selectedTitulosBoleto.map(function (titulo) {
                return { codfin: titulo.codfin, email: titulo.email };
            });

            var postData = { titulos: titulos_array };
            var URL = 'cnab/ar/boleto/';

            var self = this;

            Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiORDSpost"])(this.$store, URL, postData, 'post').then(function (data) {
                if (data.errosValidacao && data.errosValidacao.length) {
                    console.log('Erros validação: ', data.errosValidacao);
                    self.listErrosBoleto = data.errosValidacao;
                    self.showModalErrosBoleto = true;
                } else {
                    self.$erpToastSuccess('E-mails colocados na fila para o envio!');
                }
                self.closeModalEnviarEmailBoleto();
            }, function () {
                self.$erpToastError('Falha ao colocar E-mails na fila para o envio!');
                self.closeModalEnviarEmailBoleto();
            });
        },
        closeModalCobranca: function closeModalCobranca() {
            this.showModalCobranca = false;
        },
        handleEnviarCobranca: function handleEnviarCobranca() {
            var clientes = this.titulosVencidosPorCliente.filter(function (obj) {
                return obj.isChecked === true;
            });

            var noEmail = clientes.some(function (e) {
                return e.email === null;
            });

            if (noEmail) {
                return this.$erpToastError('Todos os itens selecionados devem ter o campo e-mail preenchido');
            }

            var periodos = [{
                data_inicio: this.periodo.startDate,
                data_termino: this.periodo.endDate
            }];

            var postData = { clientes: clientes, periodos: periodos };
            var URL = 'fin/carta/';

            Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiORDSpost"])(this.$store, URL, postData, 'post');

            this.$erpToastSuccess('Cobrança enviada com sucesso!');

            this.showModalCobranca = false;
        },
        handlePrint: function handlePrint(tipoRelatorio) {
            var _this7 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var naoBaixado;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!(tipoRelatorio == 1)) {
                                    _context6.next = 9;
                                    break;
                                }

                                if (_this7.printFinList.length) {
                                    _context6.next = 4;
                                    break;
                                }

                                _this7.$erpToastError('Selecione ao menos 1 documento para impressão');
                                return _context6.abrupt('return');

                            case 4:
                                naoBaixado = _this7.printFinList.find(function (fin) {
                                    return !fin.baixado;
                                });

                                if (!naoBaixado) {
                                    _context6.next = 8;
                                    break;
                                }

                                _this7.$erpToastError('Somente títulos baixados podem emitir recibo.');
                                return _context6.abrupt('return');

                            case 8:

                                _this7.showRecibo = true;

                            case 9:

                                if (tipoRelatorio == 2) {
                                    _this7.showRelatorio = true;
                                }

                                if (tipoRelatorio == 3) {
                                    _this7.showRelatorioData = true;
                                }

                                if (tipoRelatorio == 4) {
                                    _this7.showRelatorioExtrato = true;
                                }

                            case 12:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this7);
            }))();
        },
        handleClosePrint: function handleClosePrint() {
            this.showRelatorio = false;
            this.showRelatorioData = false;
            this.showRelatorioExtrato = false;
            this.showRecibo = false;
        },
        extensoMoeda: function extensoMoeda(val) {
            var extenso = __webpack_require__(624);
            var value = val.toFixed(2).replace('.', ',');
            var valor = extenso(value, { mode: 'currency', currency: { type: 'BRL' } });
            return valor;
        },
        dataSemiExtenso: function dataSemiExtenso(date) {
            var meses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
            var data = new Date(date);
            var dataFormatada = data.getDate() + " " + meses[data.getMonth()] + " " + data.getFullYear();
            return dataFormatada;
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.showMovForm = false;
            this.showTransfForm = false;
            this.$modalForm(false);
            this.loadData();
        },


        // handleActionBarList (act) {
        //     // if (act == 2) {
        //     //     //exportar a lista de notas para planilha
        //     //     const data = this.nfList.map(nf => ({
        //     //         data: this.data(nf.data),
        //     //         serie: nf.serie,
        //     //         numeronf: nf.nf,
        //     //         operacao: this.operacaoNf(nf.operacaonf),
        //     //         natureza: nf.descricao,
        //     //         nome: nf.nome,
        //     //         total: formatValue(nf.totger,2)
        //     //     }))
        //     //     const csv = objectToCsv(data)
        //     //     downloadCsvReport(csv)
        //     // }

        // },

        // handleSearch(value) {
        //     //efetua a pesquisa
        //     let str = value.toUpperCase()
        //     this.statusQuery = 'text=' + str
        //     // this.filter = ''
        //     // if (value) {
        //     //     this.filter = '{"$or":[{"part_nome":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}},{"doc":{"$eq":"' + value + '"}}]}'
        //     // }
        //     this.loadData()
        // },

        // handleAdvancedFilter (filter, startDate, endDate) {
        //     //aplicação do filtro avancado
        //     this.monthQuery = 'after=' + startDate + '&before=' + endDate
        //     this.textQuery = ''
        //     this.loadData()
        // },

        handleFilterList: function handleFilterList(status) {
            //CLICK DO FILTER LIST
            this.loadData();
        },
        loadData: function loadData(excel) {
            var _this8 = this;

            var param = {};
            param.query = '';

            this.filtro.periodos = [{ data_inicio: this.periodo.startDate, data_termino: this.periodo.endDate }];
            this.filtro.vencimento = [{ data_inicio: this.periodoVencimento.startDate, data_termino: this.periodoVencimento.endDate }];
            this.filtro.recebimento = [{ data_inicio: this.periodoRecebimento.startDate, data_termino: this.periodoRecebimento.endDate }];
            this.filtro.emissao = [{ data_inicio: this.periodoEmissao.startDate, data_termino: this.periodoEmissao.endDate }];
            this.filtro.excel = excel;
            this.filtro.contas = [];

            // this.filtro.emitidosperiodo = (this.tipos.indexOf('6') >= 0)
            // if (!this.filtro.emitidosperiodo) {
            //     this.filtro.aberto = (this.tipos.indexOf('1') >= 0)
            //     this.filtro.vencido = (this.tipos.indexOf('2') >= 0)
            //     this.filtro.baixado = (this.tipos.indexOf('3') >= 0)
            //     this.filtro.perdido = (this.tipos.indexOf('4') >= 0)
            //     this.filtro.todosvencidos = (this.tipos.indexOf('5') >= 0)
            // }

            this.filtro.aberto = this.tipo == '1';
            this.filtro.vencido = this.tipo == '2';
            this.filtro.baixado = this.tipo == '3';
            this.filtro.perdido = this.tipo == '4';
            this.filtro.todosvencidos = this.tipo == '5';
            this.filtro.emitidosperiodo = this.tipo == '6';
            this.filtro.abertosdataalteracao = this.tipo == '7';
            this.filtro.dataalteracao = this.tipo == '9';

            if (this.pagarTab) this.filtro.tipo = 'PAGAR';else if (this.receberTab) this.filtro.tipo = 'RECEBER';else {
                this.handleLimparFiltros(true);
                this.filtro.tipo = 'EXTRATO';
            }
            if (!this.contas || this.contas.length == 0) this.filtro.contas = [];else this.filtro.contas = this.contas;

            this.filtro.codpart = this.codpart;
            this.filtro.codcta = this.codcta;
            this.filtro.vlr = this.valor;
            this.filtro.doc = this.documento;

            var url = "fin/list";

            if (excel) {
                Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiDownload2"])(this, url, this.filtro, "post");
            } else {
                Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiORDSpost"])(this.$store, url, this.filtro, "post").then(function (data) {
                    if (_this8.extratoTab) {
                        var temp = data;
                        var saldoInicial = data.totais.saldoInicial;

                        for (var i = 0; i < temp.dados.length; i++) {
                            if (temp.dados[i].tipo == 'R' || temp.dados[i].tipo == 'E') saldoInicial = saldoInicial + temp.dados[i].vlr;else saldoInicial = saldoInicial - temp.dados[i].vlr;

                            temp.dados[i].saldo = saldoInicial;
                        }

                        _this8.dados = temp;
                    } else {
                        _this8.dados = data;
                    }

                    _this8.$nextTick(function () {
                        jQuery('[data-toggle="tooltip"]').tooltip();
                    });
                });
            }
        },
        getContas: function getContas() {
            var _this9 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var params, modulo, data, contas;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                params = null;
                                modulo = 'select/cta/';
                                _context7.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiORDS"])(_this9.$store.getters.urlOrds + modulo, params);

                            case 4:
                                data = _context7.sent;

                                if (data.items) {
                                    contas = _this9.changeObjKey(data.items);

                                    _this9.listContas = contas;
                                }

                            case 6:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this9);
            }))();
        },

        // Muda a chave do objeto para que seja carregado corretamente no select2
        changeObjKey: function changeObjKey(arr) {
            return arr.map(function (entry) {
                return Object.keys(entry).reduce(function (obj, key) {
                    var value = entry[key]; // ler o valor
                    if (key === 'value') key = 'text'; // mudar o nome da chave
                    obj[key] = value;
                    return obj;
                }, {});
            });
        },
        loadFilial: function loadFilial() {
            var _this10 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return _this10.$store.dispatch('loadFilial', { id: '1' });

                            case 2:
                                if (_this10.$store.getters.getFilial) {
                                    _this10.filial = _extends({}, _this10.$store.getters.getFilial);
                                }

                            case 3:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this10);
            }))();
        }
    },

    filters: {},

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"],
        BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"],
        FilterList: __WEBPACK_IMPORTED_MODULE_2__components_filter_list__["a" /* default */],
        FinanceiroForm: __WEBPACK_IMPORTED_MODULE_3__financeiro_form__["a" /* default */],
        FinanceiroTransfForm: __WEBPACK_IMPORTED_MODULE_5__financeiro_transf_form__["a" /* default */],
        FinanceiroMovimentoForm: __WEBPACK_IMPORTED_MODULE_4__financeiro_movimento_form__["a" /* default */],
        Button: __WEBPACK_IMPORTED_MODULE_10__components_button_vue__["default"],
        FinanceiroPrintRecibo: __WEBPACK_IMPORTED_MODULE_11__forms_financeiro_print_recibo_vue__["a" /* default */],
        FinanceiroRelatorioAgrupado: __WEBPACK_IMPORTED_MODULE_12__forms_financeiro_relatorio_agrupado_vue__["a" /* default */],
        FinanceiroRelatorioData: __WEBPACK_IMPORTED_MODULE_13__forms_financeiro_relatorio_data_vue__["a" /* default */],
        FinanceiroRelatorioExtrato: __WEBPACK_IMPORTED_MODULE_14__forms_financeiro_relatorio_extrato_vue__["a" /* default */]
    },

    mounted: function mounted() {

        this.tipo = '1';
        this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate());
        this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate());
        this.loadFilial();
        this.getContas();
        this.loadData();
    },
    created: function created() {}
});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            fin: _extends({}, this.$store.getters.getEntities.fin),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
            tipoOptions: [{ id: 'E', text: "Entrada" }, { id: 'S', text: "Saída" }],
            tipo: 'E',
            cancelarMovimento: 'N'
        };
    },


    computed: {
        metadataCodnatfin: function metadataCodnatfin() {
            var meta = _extends({}, this.metadata.fin.codnatfin);
            if (this.tipo == 'R' || this.tipo == 'E') meta.select2.entity = 'natfin/receitas';else meta.select2.entity = 'natfin/despesas';
            return meta;
        },
        moreActions: function moreActions() {
            if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) return null;

            var actions = [];
            actions.push({ action: 1, label: 'Cancelar Movimento' });
            return actions;
        },

        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        },

        isView: function isView() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudView;
        },

        _tituloNF: function _tituloNF() {
            if (!this.fin.codnf && !this.fin.codpedv) {
                return false;
            } else {
                return true;
            }
        }

    },

    methods: {
        handleAction: function handleAction(act) {
            if (act == 1) this.cancelarMovimento = 'S';
        },
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this2.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI)) {
                                    _context.next = 5;
                                    break;
                                }

                                _this2.fin.aberto = 'N';
                                _this2.fin.baixado = 'S';
                                _this2.fin.data = _this2.$getDate();
                                return _context.abrupt('return');

                            case 5:
                                _context.next = 7;
                                return _this2.$store.dispatch('loadFin', { id: _this2.index });

                            case 7:
                                if (_this2.$store.getters.getFin) {
                                    _this2.fin = _extends({}, _this2.$store.getters.getFin);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        handleDesistir: function handleDesistir() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this3.cancelarMovimento = 'N';

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        handleCancelar: function handleCancelar() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, postData, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                modulo = 'fin/movimento/' + _this4.fin.codfin;
                                postData = { cancela: true, codfin: _this4.codfin };
                                _context3.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, postData, 'put');

                            case 4:
                                data = _context3.sent;

                                _this4.$erpToastDeleted();
                                _this4.closeForm();

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        apiPost: function apiPost() {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                //efetua a gravacao

                                _this5.fin.baixado = 'S';
                                _this5.fin.aberto = 'N';
                                _this5.fin.tipofin = _this5.tipo;

                                modulo = 'fin/movimento/';
                                sendData = {};

                                sendData = { fin: _this5.fin };

                                metodo = 'post';
                                update = false;

                                if (_this5.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    modulo = modulo + _this5.fin.codfin;
                                    update = true;
                                }

                                _context4.next = 11;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this5.$store, modulo, sendData, metodo);

                            case 11:
                                data = _context4.sent;

                                if (data.errmessages) {
                                    _this5.errmessages = data.errmessages;
                                    _this5.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this5.$erpToastUpdated();
                                    } else {
                                        _this5.$erpToastInserted();
                                    }
                                    _this5.errmessages = {};
                                    _this5.closeForm();
                                }

                            case 13:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        }
    },

    components: {},

    watch: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.$nextTick(function () {
            this.$refs.conta.focus();
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.crudText = this.$crudText(this.crud);

        this.loadData();
    }
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            fin: _extends({}, this.$store.getters.getEntities.fin),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
            modalTitle: 'TRANSFERÊNCIA',
            movimento: {
                origem: {
                    codcta: null,
                    codnatfin: null
                },
                destino: {
                    codcta: null,
                    codnatfin: null
                },
                valor: null,
                float: 0,
                data: null,
                transferencia: true
            }
        };
    },


    computed: {},

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this2.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI)) {
                                    _context.next = 3;
                                    break;
                                }

                                _this2.movimento.data = _this2.$getDate();
                                return _context.abrupt('return');

                            case 3:
                                _context.next = 5;
                                return _this2.$store.dispatch('loadFin', { id: _this2.index });

                            case 5:

                                if (_this2.$store.getters.getFin) {
                                    _this2.fin = _extends({}, _this2.$store.getters.getFin);
                                }

                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiPost: function apiPost() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, sendData, metodo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a gravacao
                                modulo = '/fin/movimento/';
                                sendData = {};

                                sendData = { fin: _this3.movimento };

                                metodo = 'post';
                                _context2.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this3.$store, modulo, sendData, metodo);

                            case 6:
                                data = _context2.sent;


                                if (data.errmessages) {
                                    _this3.errmessages = data.errmessages;
                                    _this3.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    _this3.$erpToastInserted();
                                    _this3.errmessages = {};
                                    _this3.closeForm();
                                }

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        }
    },

    components: {},

    watch: {},

    beforeCreate: function beforeCreate() {},
    mounted: function mounted() {
        this.$nextTick(function () {
            this.$refs.origem.focus();
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.crudText = this.$crudText(this.crud);

        this.loadData();
    }
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['finList', 'receberTab', 'pagarTab', 'filial'],

    methods: {
        extensoMoeda: function extensoMoeda(val) {
            var extenso = __webpack_require__(624);
            var value = val.toFixed(2).replace('.', ',');
            var valor = extenso(value, { mode: 'currency', currency: { type: 'BRL' } });
            return valor;
        },
        dataSemiExtenso: function dataSemiExtenso(date) {
            var meses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
            var data = new Date(date);
            var dataFormatada = data.getDate() + " " + meses[data.getMonth()] + " " + data.getFullYear();
            return dataFormatada;
        },
        relatorio: function relatorio(prtHtml) {

            // const prtHtml = document.getElementById('relatorio').innerHTML

            var stylesHtml = '';

            var _arr = [].concat(_toConsumableArray(document.querySelectorAll('link[rel="stylesheet"], style')));

            for (var _i = 0; _i < _arr.length; _i++) {
                var node = _arr[_i];
                stylesHtml += node.outerHTML;
            }
            var WinPrint = window.open('', '', 'left=0,top=0,toolbar=0,scrollbars=0,status=0');

            if (!WinPrint) {
                return this.$erpToastError('Habilite a exibição de pop-ups');
            }

            WinPrint.document.write('\n                <!DOCTYPE html>\n                <html>\n                    <head>\n                        ' + stylesHtml + '\n                    </head>\n                    <body>\n                        <div>\n                            <div class="w-100 p-3">\n                                ' + prtHtml + '\n                            </div>\n                        </div>\n                    </body>\n                </html>\n            ');

            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();
            WinPrint.close();
            this.$emit('close');
        }
    },

    mounted: function mounted() {
        var vm = this;
        setTimeout(function () {
            var prtHtml = document.getElementById('recibo').innerHTML;
            vm.relatorio(prtHtml);
        }, 1000);
    },
    created: function created() {}
});

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! Extenso.js v2.1.0 | MIT (c) 2015-2024 by Matheus Alves */
(function (e, t) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = t() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.extenso = t() : e.extenso = t();
})("undefined" != typeof self ? self : undefined, function () {
  return n = [function (e) {
    e.exports = JSON.parse('{"BRL":{"singular":"real","plural":"reais","subunit":{"singular":"centavo","plural":"centavos"}},"CVE":{"singular":"escudo","plural":"escudos","subunit":{"singular":"cêntimo","plural":"cêntimos"}},"EUR":{"singular":"euro","plural":"euros","subunit":{"singular":"cêntimo","plural":"cêntimos"}},"MZN":{"singular":"metical","plural":"meticais","subunit":{"singular":"centavos","plural":"centavos"}}}');
  }, function (e, t, n) {
    function f(e) {
      return (f = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return typeof e === "undefined" ? "undefined" : _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
      })(e);
    }var r = Object.prototype.toString,
        s = n(4),
        p = e.exports = function (e) {
      for (var t, n, r = 0, o = arguments.length, i = new Array(1 < o ? o - 1 : 0), a = 1; a < o; a++) {
        i[a - 1] = arguments[a];
      }for (e = (e = ("object" === f(t = e) ? null === t : "function" != typeof t) ? i[r++] : e) || {}; r < i.length; r++) {
        if (d(i[r])) {
          for (var u = 0, c = Object.keys(i[r]); u < c.length; u++) {
            var l = c[u];"__proto__" !== (n = l) && "constructor" !== n && "prototype" !== n && (d(e[l]) && d(i[r][l]) ? p(e[l], i[r][l]) : e[l] = i[r][l]);
          }s(e, i[r]);
        }
      }return e;
    };function d(e) {
      return "function" == typeof e || "[object Object]" === r.call(e);
    }
  }, function (e, t) {
    function n(c) {
      if ((c = c || {}).negativeType = c.negativeType || ("R" === c.negative ? "right" : "left"), "string" != typeof c.negativeLeftSymbol) switch (c.negativeType) {case "left":
          c.negativeLeftSymbol = "-";break;case "brackets":
          c.negativeLeftSymbol = "(";break;default:
          c.negativeLeftSymbol = "";}if ("string" != typeof c.negativeRightSymbol) switch (c.negativeType) {case "right":
          c.negativeRightSymbol = "-";break;case "brackets":
          c.negativeRightSymbol = ")";break;default:
          c.negativeRightSymbol = "";}function e(e, t) {
        if (t = t || {}, !e && 0 !== e) return "";var n = [],
            r = "-" === (e = "" + e).charAt(0);if (e = e.replace(/^\-/g, ""), c.negativeLeftOut || t.noUnits || n.push(c.prefix), r && n.push(c.negativeLeftSymbol), c.negativeLeftOut && !t.noUnits && n.push(c.prefix), e = e.split("."), null != c.round) {
          var o = e,
              i = c.round;if (o[1] && 0 <= i && o[1].length > i) {
            var a = o[1].slice(0, i);if (5 <= +o[1].substr(i, 1)) {
              for (var u = ""; "0" === a.charAt(0);) {
                u += "0", a = a.substr(1);
              }(a = u + (a = +a + 1 + "")).length > i && (o[0] = +o[0] + +a.charAt(0) + "", a = a.substring(1));
            }o[1] = a;
          }
        }return null != c.truncate && (e[1] = function (e, t) {
          return e && (e += ""), e && e.length > t ? e.substr(0, t) : e;
        }(e[1], c.truncate)), 0 < c.padLeft && (e[0] = function (e, t) {
          e += "";for (var n = []; n.length + e.length < t;) {
            n.push("0");
          }return n.join("") + e;
        }(e[0], c.padLeft)), 0 < c.padRight && (e[1] = function (e, t) {
          e ? e += "" : e = "";for (var n = []; n.length + e.length < t;) {
            n.push("0");
          }return e + n.join("");
        }(e[1], c.padRight)), !t.noSeparator && e[1] && (e[1] = function (e, t) {
          if (e += "", t) for (var n = /(\d{3})(\d+)/; n.test(e);) {
            e = e.replace(n, "$1" + t + "$2");
          }return e;
        }(e[1], c.decimalsSeparator)), !t.noSeparator && e[0] && (e[0] = function (e, t) {
          if (e += "", t) for (var n = /(\d+)(\d{3})/; n.test(e);) {
            e = e.replace(n, "$1" + t + "$2");
          }return e;
        }(e[0], c.integerSeparator)), n.push(e[0]), e[1] && (n.push(c.decimal), n.push(e[1])), c.negativeRightOut && !t.noUnits && n.push(c.suffix), r && n.push(c.negativeRightSymbol), c.negativeRightOut || t.noUnits || n.push(c.suffix), n.join("");
      }function t(e, t) {
        t = t || [], c.allowedSeparators && c.allowedSeparators.forEach(function (e) {
          t.push(e);
        }), t.push(c.integerSeparator), t.push(c.decimalsSeparator);var n = e = (e = e.replace(c.prefix, "")).replace(c.suffix, "");do {
          e = n;for (var r = 0; r < t.length; r++) {
            n = n.replace(t[r], "");
          }
        } while (n != e);return e;
      }return "boolean" != typeof c.negativeLeftOut && (c.negativeLeftOut = !1 !== c.negativeOut), "boolean" != typeof c.negativeRightOut && (c.negativeRightOut = !1 !== c.negativeOut), c.prefix = c.prefix || "", c.suffix = c.suffix || "", "string" != typeof c.integerSeparator && (c.integerSeparator = "string" == typeof c.separator ? c.separator : ","), c.decimalsSeparator = "string" == typeof c.decimalsSeparator ? c.decimalsSeparator : "", c.decimal = c.decimal || ".", c.padLeft = c.padLeft || -1, c.padRight = c.padRight || -1, e.negative = c.negative, e.negativeOut = c.negativeOut, e.negativeType = c.negativeType, e.negativeLeftOut = c.negativeLeftOut, e.negativeLeftSymbol = c.negativeLeftSymbol, e.negativeRightOut = c.negativeRightOut, e.negativeRightSymbol = c.negativeRightSymbol, e.prefix = c.prefix, e.suffix = c.suffix, e.separate = c.separate, e.integerSeparator = c.integerSeparator, e.decimalsSeparator = c.decimalsSeparator, e.decimal = c.decimal, e.padLeft = c.padLeft, e.padRight = c.padRight, e.truncate = c.truncate, e.round = c.round, e.unformat = t, e;
    }e.exports = n, e.exports.default = n;
  }, function (e, t, n) {
    e.exports = n(5).default;
  }, function (e, t, n) {
    function s(e, t) {
      var n,
          r,
          o,
          i,
          a = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];if (a) return o = !(r = !0), { s: function s() {
          a = a.call(e);
        }, n: function n() {
          var e = a.next();return r = e.done, e;
        }, e: function e(_e) {
          o = !0, n = _e;
        }, f: function f() {
          try {
            r || null == a.return || a.return();
          } finally {
            if (o) throw n;
          }
        } };if (Array.isArray(e) || (a = function (e, t) {
        var n;if (e) return "string" == typeof e ? u(e, t) : "Map" === (n = "Object" === (n = {}.toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? u(e, t) : void 0;
      }(e)) || t && e && "number" == typeof e.length) return a && (e = a), i = 0, { s: t = function t() {}, n: function n() {
          return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
        }, e: function e(_e2) {
          throw _e2;
        }, f: t };throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }function u(e, t) {
      (null == t || t > e.length) && (t = e.length);for (var n = 0, r = Array(t); n < t; n++) {
        r[n] = e[n];
      }return r;
    }var p = Object.prototype.toString,
        d = Object.prototype.propertyIsEnumerable,
        m = Object.getOwnPropertySymbols;e.exports = function (e) {
      if ("function" != typeof (t = e) && "[object Object]" !== p.call(t) && !Array.isArray(t)) throw new TypeError("expected the first argument to be an object");for (var t, n = arguments.length, r = new Array(1 < n ? n - 1 : 0), o = 1; o < n; o++) {
        r[o - 1] = arguments[o];
      }if (0 !== r.length && "function" == typeof Symbol && "function" == typeof m) for (var i = 0, a = r; i < a.length; i++) {
        var u,
            c = a[i],
            l = s(m(c));try {
          for (l.s(); !(u = l.n()).done;) {
            var f = u.value;d.call(c, f) && (e[f] = c[f]);
          }
        } catch (e) {
          l.e(e);
        } finally {
          l.f();
        }
      }return e;
    };
  }, function (N, e, t) {
    t.r(e), t.d(e, "isValidOpt", function () {
      return _;
    }), t.d(e, "toNegative", function () {
      return M;
    });var n = t(1),
        c = t.n(n);function l(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];if (null != n) {
          var r,
              o,
              i,
              a,
              u = [],
              c = !0,
              l = !1;try {
            if (i = (n = n.call(e)).next, 0 === t) {
              if (Object(n) !== n) return;c = !1;
            } else for (; !(c = (r = i.call(n)).done) && (u.push(r.value), u.length !== t); c = !0) {}
          } catch (e) {
            l = !0, o = e;
          } finally {
            try {
              if (!c && null != n.return && (a = n.return(), Object(a) !== a)) return;
            } finally {
              if (l) throw o;
            }
          }return u;
        }
      }(e, t) || function (e, t) {
        var n;if (e) return "string" == typeof e ? r(e, t) : "Map" === (n = "Object" === (n = {}.toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(e, t) : void 0;
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }function r(e, t) {
      (null == t || t > e.length) && (t = e.length);for (var n = 0, r = Array(t); n < t; n++) {
        r[n] = e[n];
      }return r;
    }function a(e, t, n) {
      return A(w(R(z(I(L(O(e), t, n))), e)), t).join(" ");
    }function u(e) {
      return e.replace(/\bum\b/, "uma").replace(/\bdois\b/, "duas");
    }function f(e) {
      return (/^0+$/.test(e)
      );
    }function s(e, t) {
      var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : "0",
          r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : "0",
          o = 4 < arguments.length ? arguments[4] : void 0;if (i = e, !E(d).includes(i)) throw new Error("Invalid ISO code");1 === r.length && (r += "0");var i = d[e],
          e = function (e, t, n, r) {
        var o = parseInt(e),
            e = $(e, t, "m", r);if (1 === o) return "".concat(e, " ").concat(n.singular);if (1e6 <= o) {
          t = o.toString(), r = parseInt(t.substr(-6, 3)), o = parseInt(t.substr(-3, 3));if (0 === r && 0 === o) return "".concat(e, " de ").concat(n.plural);
        }return "".concat(e, " ").concat(n.plural);
      }(n, t, i, o),
          o = function (e, t, n) {
        return t = $(e, t), 1 === parseInt(e) ? "".concat(t, " ").concat(n.subunit.singular) : "".concat(t, " ").concat(n.subunit.plural);
      }(r, t, i);return f(n) ? o : f(r) ? e : f(n) && f(r) ? "zero ".concat(i.plural) : "".concat(e, " e ").concat(o);
    }function p(e, t, n) {
      return n && "informal" === n ? "vírgula ".concat($(e, t)) : (n = t, e = (t = e).length, r = parseInt(t), t = t.replace(/^0+/, ""), t = $(t, n), o = q(T(e), r), n = v(n)[Math.floor(e / 3 - 1)], e < 3 ? "".concat(t, " ").concat(o) : e % 3 == 0 ? "".concat(t, " ").concat(q(n, r)) : "".concat(t, " ").concat(o, " de ").concat(n));var r, o;
    }var d = t(0),
        o = function o(e) {
      return ["zero", "um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove"];
    },
        i = function i(e) {
      return ["dez", "onze", "doze", "treze", { br: "quatorze", pt: "catorze" }[e], "quinze", { br: "dezesseis", pt: "dezasseis" }[e], { br: "dezessete", pt: "dezassete" }[e], "dezoito", { br: "dezenove", pt: "dezanove" }[e], "vinte", "trinta", "quarenta", "cinquenta", "sessenta", "setenta", "oitenta", "noventa"];
    },
        m = function m(e) {
      return ["cento", "duzentos", "trezentos", "quatrocentos", "quinhentos", "seiscentos", "setecentos", "oitocentos", "novecentos"];
    },
        g = function g(n) {
      var r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "short";return ["mil", "milhões", "bil", "tril", "quatril", "quintil", "sextil", "septil", "octil", "nonil", "decil", "undecil", "duodecil"].map(function (e, t) {
        return t < 2 ? e : e + { br: "hões", pt: "iões" }[n];
      }).map(function (e, t, n) {
        return "long" !== r || t < 2 ? e : t % 2 == 0 ? "mil " + n[t / 2] : n[t / 2 + .5];
      });
    },
        v = function v(e) {
      return ["milésimo", "milionésimo", "bilionésimo", "trilionésimo", "quatrilionésimo", "quintilionésimo", "sextilionésimo", "septilionésimo", "octilionésimo", "nonilionésimo", "decilionésimo", "undecilionésimo", "duodecilionésimo"];
    },
        b = function b(e, t) {
      return o(t)[e];
    },
        y = function y(e, t) {
      var n;return e < 10 ? b(e, t) : e < 20 ? i(t)[e - 10] : (n = b(e % 10, t), t = i(t)[(e - e % 10) / 10 + 8], "zero" !== n ? "".concat(t, " e ").concat(n) : t);
    },
        h = function h(e, t) {
      var n;return e < 100 ? y(e, t) : 100 === e ? "cem" : (n = e - e % 100, e = e % 100, n = m(t)[n / 100 - 1], t = y(e, t), e ? "".concat(n, " e ").concat(t) : n);
    },
        n = t(2),
        S = t.n(n),
        O = function O(e) {
      return S()()(e).split(",");
    },
        x = function x(e) {
      e = O(e), e = e[e.length - 1];return parseInt(e);
    },
        j = function j(e) {
      if (null == e) return [];for (var t, n, r = 0, o = e.length, i = o - 1, a = o / 2 | 0; r < a; r++) {
        n = e[r], e[r] = e[t = i - r], e[t] = n;
      }return e;
    },
        w = function w(e) {
      return e.map(function (e, t, n) {
        return t < n.length - 2 ? "".concat(e, ",") : e;
      });
    },
        R = function R(e, t) {
      t = x(t);return t < 100 || t % 100 == 0 ? e.map(function (e, t, n) {
        return t === n.length - 2 ? "".concat(e, " e") : e;
      }) : e;
    },
        I = function I(e) {
      return e.map(function (e) {
        return e.replace(/^0+\s?/, "");
      }).filter(function (e) {
        return (/^\d/.test(e)
        );
      }).map(function (e) {
        return e.replace(/^1\s(mil)$/, "$1");
      });
    },
        L = function L(e, n, r) {
      return j(j(e).map(function (e, t) {
        t = g(n, r)[t - 1];return t ? "".concat(e, " ").concat(t) : e;
      }));
    },
        z = function z(e) {
      var t = /^(1\s.*)ões/;return e.map(function (e) {
        return e.replace(t, "$1ão");
      });
    },
        A = function A(e, t) {
      return e.map(function (e) {
        return e.replace(/^(\d+)/, function (e) {
          e = parseInt(e);return h(e, t);
        });
      });
    },
        $ = function $(e, t) {
      var n,
          r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : "m",
          o = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : "short",
          i = parseInt(e);return i < 1e3 && (n = h(i, t)), 1e3 === i && (n = "mil"), 1e3 < i && (n = a(e, t, o)), "f" === r ? u(n) : n;
    },
        E = function E(e) {
      return Object.keys(e);
    },
        T = function T(e) {
      switch (e % 3) {case 1:
          return "décimo";case 2:
          return "centésimo";}
    },
        q = function q(e, t) {
      return 1 < t ? "".concat(e, "s") : e;
    },
        _ = function _(e, t) {
      return t.includes(e);
    },
        M = function M(e) {
      return "informal" === (1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "formal") ? "menos ".concat(e) : "".concat(e, " negativo");
    };e.default = function (e, t) {
      if ("string" != typeof e && "number" != typeof e) throw new TypeError("Must be a string or a number");if (t = c()({ mode: "number", locale: "br", negative: "formal", scale: "short", currency: { type: "BRL" }, number: { gender: "m", decimal: "formal", decimalSeparator: "comma" } }, t), !(_(t.mode, ["number", "currency"]) && _(t.locale, ["pt", "br"]) && _(t.negative, ["formal", "informal"]) && _(t.scale, ["short", "long"]) && _(t.currency.type, ["BRL", "EUR", "CVE"]) && _(t.number.gender, ["m", "f"]) && _(t.number.decimal, ["formal", "informal"]) && _(t.number.decimalSeparator, ["comma", "dot"]))) throw new Error("Invalid option");var n,
          r,
          o,
          i,
          a,
          u = "dot" === t.number.decimalSeparator || "number" == typeof e;if (function (e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];if ("number" == typeof e) {
          if (Number.isInteger(e) && !Number.isSafeInteger(e)) return !1;if (!Number.isInteger(e)) return !0;
        }var n = /^-?\d+$/.test(e),
            r = /^-?\d{1,3}\d?((\.\d{3})+)?$/.test(e),
            o = /^-?\d{1,3}\d?((\.\d{3})+)?,\d+$/.test(e),
            i = /^-?\d+,\d+$/.test(e),
            a = /^-?\d{1,3}\d?((,\d{3})+)?$/.test(e),
            u = /^-?\d{1,3}\d?((,\d{3})+)?\.\d+$/.test(e),
            e = /^-?\d+\.\d+$/.test(e);return t ? n || a || u || e : n || r || o || i;
      }(e, u)) return u = (e = function (e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1],
            n = ("number" == typeof e && (e = e.toString(), t = !0), t ? "," : "."),
            t = t ? "." : ",",
            r = /^-/.test(e),
            e = e.replace(RegExp("(-|\\".concat(n, ")"), "g"), "");return e.includes(t) ? { isNegative: r, integer: (n = l(e.split(t).map(function (e) {
            return e.replace(/^0+$/, "0");
          }), 2))[0], decimal: n[1] } : { isNegative: r, integer: e, decimal: "0" };
      }(e, u)).isNegative, n = e.integer, e = e.decimal, "currency" === t.mode ? (o = t.currency.type, i = t.locale, r = e.slice(0, 2), o = s(o, i, n, r, t.scale), u ? M(o, t.negative) : o) : "number" === t.mode ? (i = "f" === t.number.gender ? "inteira" : "inteiro", r = 1 === parseInt(n) ? i : "".concat(i, "s"), o = $(n, t.locale, t.number.gender, t.scale), i = p(e, t.locale, t.number.decimal), "0" === n && "0" === e ? o : "0" !== n && "0" === e ? u ? M(o, t.negative) : o : "0" === n && "0" !== e ? (a = "informal" === t.number.decimal ? "zero ".concat(i) : i, u ? M(a, t.negative) : a) : "0" !== n && "0" !== e ? "informal" === t.number.decimal ? "".concat(o, " ").concat(i) : (a = "".concat(o, " ").concat(r, " e ").concat(i), u ? M(a, t.negative) : a) : void 0) : void 0;throw new Error("Invalid number");
    };
  }], r = {}, o.m = n, o.c = r, o.d = function (e, t, n) {
    o.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;if (4 & e && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && t && t.__esModule) return t;var n = Object.create(null);if (o.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t) for (var r in t) {
      o.d(n, r, function (e) {
        return t[e];
      }.bind(null, r));
    }return n;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 3);function o(e) {
    var t;return (r[e] || (t = r[e] = { i: e, l: !1, exports: {} }, n[e].call(t.exports, t, t.exports, o), t.l = !0, t)).exports;
  }var n, r;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module)))

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['companyName', 'finListGrupo', 'receberTab', 'pagarTab', 'codpart', 'valor', 'documento', 'periodo', 'periodoEmissao', 'periodoVencimento', 'periodoRecebimento'],

    methods: {
        handleAfterPrint: function handleAfterPrint(window) {

            window.addEventListener('afterprint', function () {
                window.close();
            });
        },
        relatorio: function relatorio(prtHtml) {

            // const prtHtml = document.getElementById('relatorio').innerHTML

            var stylesHtml = '';

            var _arr = [].concat(_toConsumableArray(document.querySelectorAll('link[rel="stylesheet"], style')));

            for (var _i = 0; _i < _arr.length; _i++) {
                var node = _arr[_i];
                stylesHtml += node.outerHTML;
            }
            var WinPrint = window.open('', '_blank');

            WinPrint.document.write('\n                <!DOCTYPE html>\n                <html>\n                    <head>\n                        ' + stylesHtml + '\n                    </head>\n                    <body>\n                        <div>\n                            <div class="w-100 p-3">\n                                ' + prtHtml + '\n                            </div>\n                        </div>\n                    </body>\n                </html>\n            ');

            WinPrint.document.close();
            WinPrint.focus();

            this.handleAfterPrint(WinPrint);

            // WinPrint.print();
            // WinPrint.close();

            this.$emit('close');
        }
    },

    mounted: function mounted() {
        var vm = this;
        setTimeout(function () {
            var prtHtml = document.getElementById('relatorio-financeiro').innerHTML;
            vm.relatorio(prtHtml);
        }, 1000);
    },
    created: function created() {}
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['companyName', 'finListGrupo', 'finListGrupoData', 'receberTab', 'pagarTab', 'codpart', 'valor', 'documento', 'periodo', 'periodoEmissao', 'periodoVencimento', 'periodoRecebimento'],
    methods: {
        handleAfterPrint: function handleAfterPrint(window) {

            window.addEventListener('afterprint', function () {
                window.close();
            });
        },
        relatorio: function relatorio(prtHtml) {

            // const prtHtml = document.getElementById('relatorio').innerHTML

            var stylesHtml = '';

            var _arr = [].concat(_toConsumableArray(document.querySelectorAll('link[rel="stylesheet"], style')));

            for (var _i = 0; _i < _arr.length; _i++) {
                var node = _arr[_i];
                stylesHtml += node.outerHTML;
            }

            var WinPrint = window.open('', '_blank');

            WinPrint.document.write('\n                <!DOCTYPE html>\n                <html>\n                    <head>\n                        ' + stylesHtml + '\n                    </head>\n                    <body>\n                        <div>\n                            <div class="w-100 p-3">\n                                ' + prtHtml + '\n                            </div>\n                        </div>\n                    </body>\n                </html>\n            ');

            WinPrint.document.close();

            WinPrint.focus();

            this.handleAfterPrint(WinPrint);

            // WinPrint.close();

            this.$emit('close');
        }
    },

    mounted: function mounted() {
        var vm = this;

        setTimeout(function () {
            var prtHtml = document.getElementById('relatorio-financeiro').innerHTML;
            vm.relatorio(prtHtml);
        }, 1000);
    },
    created: function created() {}
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['companyName', 'periodo', 'dados', 'finList'],

    methods: {
        handleAfterPrint: function handleAfterPrint(window) {

            window.addEventListener('afterprint', function () {
                window.close();
            });
        },
        relatorio: function relatorio(prtHtml) {

            // const prtHtml = document.getElementById('relatorio').innerHTML

            var stylesHtml = '';

            var _arr = [].concat(_toConsumableArray(document.querySelectorAll('link[rel="stylesheet"], style')));

            for (var _i = 0; _i < _arr.length; _i++) {
                var node = _arr[_i];
                stylesHtml += node.outerHTML;
            }
            var WinPrint = window.open('', '_blank');

            WinPrint.document.write('\n                <!DOCTYPE html>\n                <html>\n                    <head>\n                        ' + stylesHtml + '\n                    </head>\n                    <body>\n                        <div>\n                            <div class="w-100 p-3">\n                                ' + prtHtml + '\n                            </div>\n                        </div>\n                    </body>\n                </html>\n            ');

            WinPrint.document.close();

            WinPrint.focus();

            this.handleAfterPrint(WinPrint);
            // WinPrint.print();
            // WinPrint.close();

            this.$emit('close');
        }
    },

    mounted: function mounted() {
        var vm = this;
        setTimeout(function () {
            var prtHtml = document.getElementById('relatorio-extrato').innerHTML;
            vm.relatorio(prtHtml);
        }, 1000);
    },
    created: function created() {}
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            extrato: [{ codextrato: 1, data: '18/02/2022', valor: 88.88, saldo: 88.88, historico: [], conciliado: false, lancamentos: [] }, { codextrato: 2, data: '18/02/2022', valor: 99.99, saldo: 99.99, historico: [], conciliado: false, lancamentos: [] }, { codextrato: 3, data: '18/02/2022', valor: 100.00, saldo: 100.00, historico: [], conciliado: false, lancamentos: [] }, { codextrato: 4, data: '18/02/2022', valor: 100.00, saldo: 100.00, historico: [], conciliado: false, lancamentos: [] }],
            lancamentos: [{ codfin: 1, data: '18/02/2022', valor: 44.44, nome: 'Lanc 01', descricao: null, saldo: 44.44, conciliado: false }, { codfin: 2, data: '18/02/2022', valor: 44.44, nome: 'Lanc 02', descricao: null, saldo: 44.44, conciliado: false }, { codfin: 3, data: '18/02/2022', valor: 99.99, nome: 'Lanc 03', descricao: null, saldo: 99.99, conciliado: false }, { codfin: 4, data: '18/02/2022', valor: 200.00, nome: 'Lanc 04', descricao: null, saldo: 200.00, conciliado: false }]
        };
    },

    computed: {
        lanOpts: function lanOpts() {
            var lansNaovinculados = this.lancamentos.filter(function (lan) {
                return lan.conciliado === false;
            });

            var lanOpts = lansNaovinculados.map(function (lan) {
                return { id: lan.codfin, text: 'Nome: ' + lan.nome + ', Data: ' + lan.data + ', Valor: ' + lan.valor };
            });

            return lanOpts;
        }
    },
    methods: {
        vincularLancamento: function vincularLancamento() {
            var _this = this;

            this.extrato.map(function (item) {
                if (item.lancamento) {
                    _this.lancamentos.map(function (lan) {
                        if (lan.codfin == item.lancamento) {
                            item.lancamentos.push(lan);

                            if (item.saldo >= lan.saldo) {
                                item.saldo = item.saldo - lan.saldo;
                                var valor = lan.saldo;
                                item.historico.push({
                                    id: lan.codfin,
                                    valor: valor
                                });
                            } else {
                                var _valor = lan.saldo - (lan.saldo - item.saldo);
                                item.historico.push({
                                    id: lan.codfin,
                                    valor: _valor
                                });
                                item.saldo = item.saldo - lan.saldo;
                            }

                            if (item.saldo < lan.saldo) lan.saldo = item.saldo * -1;else lan.saldo = lan.saldo - (item.saldo + lan.saldo - item.saldo);

                            if (lan.saldo <= 0) {
                                lan.saldo = 0;
                                lan.conciliado = true;
                            }

                            if (item.saldo <= 0) {
                                item.saldo = 0;
                                item.conciliado = true;
                            }

                            delete item.lancamento;
                        }
                    });
                }
            });
        },
        desvincularLancamento: function desvincularLancamento(extId, lanId) {
            this.restaurarValor(extId, lanId);

            var extrato = this.extrato.filter(function (obj) {
                return obj.codextrato == extId;
            });

            var lancamentos = extrato[0].lancamentos.filter(function (lan) {
                return lan.codfin != lanId;
            });

            this.extrato.map(function (item) {
                if (item.codextrato == extId) {
                    item.lancamentos = lancamentos;
                }
            });
        },
        restaurarValor: function restaurarValor(extId, lanId) {
            var _this2 = this;

            var extrato = this.extrato.filter(function (obj) {
                return obj.codextrato == extId;
            });

            extrato[0].historico.map(function (h) {
                if (h.id == lanId) {
                    _this2.lancamentos.map(function (lan) {
                        if (lan.codfin == lanId) {
                            lan.saldo = lan.saldo + h.valor;
                            if (lan.saldo > 0) {
                                lan.conciliado = false;
                            }
                        }
                    });
                    _this2.extrato.map(function (e) {
                        if (e.codextrato == extId) {
                            e.saldo = e.saldo + h.valor;
                            if (e.saldo > 0) {
                                e.conciliado = false;
                            }
                        }
                    });
                }
            });
        }
    }
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_filter_list__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__financeiro_form__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_csvReport__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_csvReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shared_csvReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__main__);
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            fiter: '',
            metadata: this.$store.getters.getEntities.metadata,
            monthFilter: {},
            statusQuery: '',
            textQuery: ''
        };
    },

    computed: {
        logList: function logList() {
            return this.$store.getters.getLogList;
        }
    },
    watch: {},
    methods: {
        handleTextSearch: function handleTextSearch(value) {
            //efetua a pesquisa por texto
            this.filter = '';
            if (value) {
                this.filter = 'text=' + value;
            }
            this.monthQuery = '';
            this.loadData();
        },
        handleAdvancedFilter: function handleAdvancedFilter(filter, startDate, endDate) {
            //aplicação do filtro avancado
            this.monthQuery = 'after=' + startDate + '&before=' + endDate;
            this.filter = '';
            this.loadData();
        },
        loadData: function loadData() {
            var param = {};
            param.query = '';
            if (this.textQuery) {
                param.query = param.query + this.textQuery;
            } else if (this.monthQuery) {
                param.query = param.query + this.monthQuery;
            }
            this.$store.dispatch('loadLogList', param);
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
            });
        },
        textACAO: function textACAO(log) {
            if (log.tipolog === 'CREATE') {
                return 'Incluiu o recebimento ' + log.texto;
            } else if (log.tipolog === 'UPDATE') {
                return 'Alterou o recebimento ' + log.texto;
            } else if (log.tipolog === 'DELETE') {
                return 'Excluiu o recebimento ' + log.texto;
            } else if (log.tipolog === 'PAY') {
                return 'Baixou o recebimento ' + log.texto;
            } else if (log.tipolog === 'UNPAY') {
                return 'Cancelou a baixa do recebimento ' + log.texto;
            }
        },
        data: function data(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__shared_utils__["formatDate"])(value);
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__shared_utils__["formatValue"])(value, 2);
        }

    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_1__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_2__components_bar_grid__["default"], FilterList: __WEBPACK_IMPORTED_MODULE_3__components_filter_list__["a" /* default */]
    },

    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cta_form__ = __webpack_require__(1757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            filial: '',
            codcta: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: ''
        };
    },


    computed: {
        ctaList: function ctaList() {
            // console.log(this.$store.getters.getCtaList)
            return this.$store.getters.getCtaList;
        },

        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        },

        usuario: function usuario() {
            return this.$store.getters.getEnv.uuid;
        }
    },

    filters: {
        getText: function getText(value, metadata) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["getText"])(value, metadata);
        }
    },

    methods: {
        getTipocta: function getTipocta(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["getText"])(value, this.metadata.cta.tipocta);
        },
        getBoleto: function getBoleto(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["getText"])(value, this.metadata.cta.emiteboleto);
        },
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudU;
            this.codcta = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudI;
            this.codcta = '';
            this.showForm = true;
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codcta":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.$store.dispatch('loadCta', { filter: _this.filter, page: _this.nextPage });

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        data: function data(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["formatDate"])(value);
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], CtaForm: __WEBPACK_IMPORTED_MODULE_1__cta_form__["a" /* default */]
    },

    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            cta: _extends({}, this.$store.getters.getEntities.cta),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
            bancoList: [],
            bancoOptions: [],
            ctaValidate: {}
        };
    },


    computed: {
        emissaoEmpresaError: function emissaoEmpresaError() {
            return this.errors.items.find(function (er) {
                return er.field == 'emissaoempresa';
            });
        },
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        },

        tipocta: function tipocta() {
            return this.cta.tipocta;
        },

        bancoHomologado: function bancoHomologado() {
            var _this = this;

            //PESQUISA SE O BANCO SELECIONADO PERMITE EMISSAO DE BOLETO
            if (this.cta.tipocta === 'B') {
                var banco = this.bancoList.find(function (banco) {
                    return banco.banco === _this.cta.banco;
                });
                return banco && banco.cnab === 'S';
            } else {
                return false;
            }
        }

    },

    watch: {
        tipocta: function tipocta(value) {
            if (this.tipocta != 'B') {
                this.cta.emiteboleto = 'N';
                this.cta.banco = '';
            }
        }
    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.cta.codcta);
        },
        handleSave: function handleSave() {
            var _this2 = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    //Array de erros está trazendo campo emissaoempresa como nulo  
                    _this2.errors.items.map(function (er) {
                        if (er.field == null) {
                            er.field = 'emissaoempresa';
                        }
                    });
                    _this2.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this2.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO Excluir
            this.apiDelete();
        },
        loadData: function loadData() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this3.$store.dispatch('loadBanco');

                            case 2:
                                if (_this3.$store.getters.getBancoList) {
                                    _this3.bancoList = _this3.$store.getters.getBancoList;
                                    _this3.bancoOptions = _this3.$store.getters.getBancoList.map(function (obj) {
                                        return { id: obj.banco, text: obj.nome };
                                    });
                                }

                                if (!(_this3.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI)) {
                                    _context.next = 9;
                                    break;
                                }

                                _this3.cta.tipocta = 'B';
                                _this3.cta.tparquivocnab = '1';
                                _this3.cta.emiteboleto = 'N';
                                _this3.cta.ctapadrao = 'N';
                                return _context.abrupt('return');

                            case 9:
                                _context.next = 11;
                                return _this3.$store.dispatch('loadCta', { id: _this3.index });

                            case 11:
                                if (_this3.$store.getters.getCta) {
                                    _this3.cta = _extends({}, _this3.$store.getters.getCta);
                                    _this3.setCtaValidate(_this3.cta.banco);
                                }
                                _this3.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/cta/' + _this4.cta.codcta;
                                _context2.next = 3;
                                return apiORDSdelete(_this4.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this4.$erpToastDeleted();
                                _this4.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4);
            }))();
        },
        apiPost: function apiPost() {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/cta/';
                                sendData = {};

                                sendData = { cta: _this5.cta };

                                metodo = 'post';
                                update = false;

                                if (_this5.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    modulo = modulo + _this5.cta.codcta;
                                    update = true;
                                }

                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this5.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this5.errmessages = data.errmessages;
                                    _this5.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this5.$erpToastUpdated();
                                    } else {
                                        _this5.$erpToastInserted();
                                    }
                                    _this5.errmessages = {};
                                    _this5.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this5);
            }))();
        },
        setCtaValidate: function setCtaValidate(bancoId) {
            console.log('A conta selecionada é: ' + bancoId);

            if (!bancoId) {
                var ctaValidate = {
                    nrinscricao: { exibe: false, validate: { required: false } },
                    convenio: { exibe: false, validate: { required: false } },
                    carteira: { exibe: false, validate: { required: false } },
                    carteiravariacao: { exibe: false, validate: { required: false } },
                    conta: { exibe: false, validate: { required: false } },
                    digitoagencia: { exibe: false, validate: { required: false } },
                    emissaoempresa: { exibe: false, validate: { required: false } },
                    especietitulo: { exibe: false, validate: { required: false } },
                    codinstr1: { exibe: false, validate: { required: false } },
                    codinstr2: { exibe: false, validate: { required: false } }
                };

                this.ctaValidate = ctaValidate;
            } else {
                var _ctaValidate = {
                    nrinscricao: { exibe: true, validate: { required: false } },
                    convenio: { exibe: true, validate: { required: false } },
                    carteira: { exibe: true, validate: { required: false } },
                    carteiravariacao: { exibe: true, validate: { required: false } },
                    conta: { exibe: true, validate: { required: false } },
                    digitoagencia: { exibe: true, validate: { required: false } },
                    emissaoempresa: { exibe: true, validate: { required: false } },
                    especietitulo: { exibe: true, validate: { required: false } },
                    codinstr1: { exibe: true, validate: { required: false } },
                    codinstr2: { exibe: true, validate: { required: false } }
                };

                this.ctaValidate = _ctaValidate;
            }

            // banco do brasil 
            if (bancoId == '001') {

                var _ctaValidate2 = {
                    nrinscricao: { exibe: true, validate: { required: false, max: 20 } },
                    convenio: { exibe: true, validate: { required: true, max: 20 } },
                    carteira: { exibe: true, validate: { required: true, min: 1, max: 3 } },
                    carteiravariacao: { exibe: true, validate: { required: false, min: 1, max: 3 } },
                    conta: { exibe: true, validate: { required: true, max: 5 } },
                    digitoagencia: { exibe: true, validate: { required: false, max: 1 } },
                    emissaoempresa: { exibe: true, validate: { required: false } },
                    especietitulo: { exibe: true, validate: { required: true, max: 2 } },
                    codinstr1: { exibe: true, validate: { required: false, max: 2 } },
                    codinstr2: { exibe: true, validate: { required: false, max: 2 } }
                };

                this.ctaValidate = _ctaValidate2;
            }

            // Bradesco
            if (bancoId == '237') {

                var _ctaValidate3 = {
                    nrinscricao: { exibe: true, validate: { required: true, max: 20 } },
                    convenio: { exibe: true, validate: { required: false, max: 20 } },
                    carteira: { exibe: true, validate: { required: true, max: 2 } },
                    carteiravariacao: { exibe: true, validate: { required: false } },
                    conta: { exibe: true, validate: { required: true, max: 5 } },
                    digitoagencia: { exibe: true, validate: { required: false, max: 1 } },
                    emissaoempresa: { exibe: true, validate: { required: false } },
                    especietitulo: { exibe: true, validate: { required: true, max: 2 } },
                    codinstr1: { exibe: true, validate: { required: false, max: 2 } },
                    codinstr2: { exibe: true, validate: { required: false, max: 2 } }
                };

                this.ctaValidate = _ctaValidate3;
            }

            // Itaú
            if (bancoId == '341') {

                var _ctaValidate4 = {
                    nrinscricao: { exibe: true, validate: { required: true, max: 20 } },
                    convenio: { exibe: true, validate: { required: false, max: 20 } },
                    carteira: { exibe: true, validate: { required: true, min: 3, max: 3 } },
                    carteiravariacao: { exibe: true, validate: { required: false } },
                    conta: { exibe: true, validate: { required: true, max: 5 } },
                    digitoagencia: { exibe: false, validate: { required: false, max: 1 } },
                    emissaoempresa: { exibe: true, validate: { required: false } },
                    especietitulo: { exibe: true, validate: { required: true, max: 2 } },
                    codinstr1: { exibe: true, validate: { required: false, max: 2 } },
                    codinstr2: { exibe: true, validate: { required: false, max: 2 } }
                };

                this.ctaValidate = _ctaValidate4;
            }

            // Santander
            if (bancoId == '033') {
                //ta dando erro por causa do 0

                var _ctaValidate5 = {
                    nrinscricao: { exibe: true, validate: { required: true, max: 20 } },
                    convenio: { exibe: true, validate: { required: false, max: 20 } },
                    carteira: { exibe: true, validate: { required: true, max: 1 } },
                    carteiravariacao: { exibe: true, validate: { required: false } },
                    conta: { exibe: true, validate: { required: true, min: 7, max: 9 } },
                    digitoagencia: { exibe: true, validate: { required: true, max: 1 } },
                    emissaoempresa: { exibe: true, validate: { required: false } },
                    especietitulo: { exibe: true, validate: { required: true, max: 2 } },
                    codinstr1: { exibe: true, validate: { required: false, max: 2 } },
                    codinstr2: { exibe: true, validate: { required: false, max: 2 } }
                };

                this.ctaValidate = _ctaValidate5;
            }

            // Caixa
            if (bancoId == '104') {
                //ta dando erro por causa do 0

                var _ctaValidate6 = {
                    nrinscricao: { exibe: true, validate: { required: true, min: 6, max: 6 } },
                    convenio: { exibe: true, validate: { required: true, min: 6, max: 6 } },
                    carteira: { exibe: true, validate: { required: true, max: 2 } },
                    carteiravariacao: { exibe: true, validate: { required: false } },
                    especietitulo: { exibe: true, validate: { required: true, max: 2 } },
                    emissaoempresa: { exibe: true, validate: { required: false } },
                    //campos nao necessarios para o layout 400:
                    conta: { exibe: true, validate: { required: false } },
                    digitoagencia: { exibe: true, validate: { required: false } },
                    codinstr1: { exibe: true, validate: { required: false } },
                    codinstr2: { exibe: true, validate: { required: false } }
                };

                this.ctaValidate = _ctaValidate6;
            }
        }
    },

    components: {},
    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.loadData();
        this.setCtaValidate();
        this.crudText = this.$crudText(this.crud);
    }
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fpag_list_vue__ = __webpack_require__(633);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b9db253_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fpag_list_vue__ = __webpack_require__(1768);
function injectStyle (ssrContext) {
  __webpack_require__(1762)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b9db253"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fpag_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b9db253_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fpag_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fpag_form_vue__ = __webpack_require__(1764);
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { FpagForm: __WEBPACK_IMPORTED_MODULE_2__fpag_form_vue__["a" /* default */], BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list_vue__["default"] },
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao,
            fpag: '',
            crud: '',
            filter: '',
            offset: '',
            codfpag: 0,
            metadata: this.$store.getters.getEntities.metadata
        };
    },

    computed: {
        fpagList: function fpagList() {
            return this.$store.getters.getFpagList;
        },
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        }
    },
    methods: {
        handleEdit: function handleEdit(cod, view) {
            if (view) this.crud = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudView;else this.crud = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudU;

            this.codfpag = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            this.crud = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI;
            this.codfpag = '';
            this.showForm = true;
        },
        handleMore: function handleMore() {
            this.offset = 'offset=' + this.nextPage;
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadFpag', { filter: this.filter, page: this.nexPage });
            this.offset = '';
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
            });
        },
        search: function search(value) {
            //efetua a pesquisa
            var valueU = value.toUpperCase();

            this.filter = '{"$or":[{"codfpag":{"$like":"%25' + valueU + '%25"}},{"descricao":{"$like":"%25' + valueU + '%25"}}]}';
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        formapag: function formapag(formpag) {
            var descricao = '';
            this.metadata.fpag.formapag.options.find(function (e) {
                if (e.id == formpag) {
                    descricao = e.text;
                }
            });
            return descricao;
        },
        bandeirapag: function bandeirapag(_bandeirapag) {
            var descricao = '';
            this.metadata.fpag.bandeirapag.options.find(function (e) {
                if (e.id == _bandeirapag) {
                    descricao = e.text;
                }
            });
            return descricao;
        }
    },
    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_input_typeahead__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },
    components: {
        InputTypeahead: __WEBPACK_IMPORTED_MODULE_0__components_input_typeahead__["default"]
    },
    data: function data() {
        return {
            crudText: '',
            fpag: _extends({}, this.$store.getters.getEntities.fpag),
            metadata: this.$store.getters.getEntities.metadata,
            codfpag: 0,
            errMessages: [], // Armazena as mensagens de validações do servidor para mostrar na tela
            filial: {}
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudU;
        },
        isView: function isView() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudView;
        },

        isCreditoLoja: function isCreditoLoja() {
            return this.fpag.formapag == '05'; //credito loja
        },
        habilitaBandeira: function habilitaBandeira() {
            return this.fpag.formapag == '03' || this.fpag.formapag == '04' || this.fpag.formapag == '10' || this.fpag.formapag == '11' || this.fpag.formapag == '12' || this.fpag.formapag == '13';
        }
    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.fpag.codfpag);
        },
        handleSave: function handleSave() {
            var _this = this;

            // delete this.this.fpag.badeirapag && delete this.fpag.tpdiacredito
            //Validação do formulário
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            this.apiDelete();
        },
        loadFilial: function loadFilial() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDS"])(_this2.$store.getters.urlOrds + 'cg/filial/varejo', null, true).then(function (result) {
                                    if (result.items.length > 0) {
                                        _this2.filial = result.items[0];
                                    }
                                });

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        loadData: function loadData() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this3.$store.dispatch('loadFpag', { id: _this3.index });

                            case 2:
                                if (_this3.$store.getters.getFpag) {
                                    _this3.fpag = _extends({}, _this3.$store.getters.getFpag);
                                }
                                _this3.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetuaGravacao

                                modulo = 'cg/fpag/';
                                sendData = {};


                                sendData = { fpag: _this4.fpag };

                                metodo = 'post';
                                update = false;


                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudI) {
                                    update = true;
                                    metodo = 'put';
                                    modulo = modulo + _this4.fpag.codfpag;
                                }
                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                //efetua exclusão
                                modulo = 'cg/fpag/' + _this5.fpag.codfpag;
                                _context4.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this5.$store, modulo);

                            case 3:
                                data = _context4.sent;

                                _this5.$erpToastDeleted();
                                _this5.closeForm();

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        }
    },

    created: function created() {
        var _this6 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _this6.crudText = _this6.$crudText(_this6.crud);

                            _context5.next = 3;
                            return _this6.loadFilial();

                        case 3:

                            if (_this6.crud == __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudI) {
                                _this6.fpag.codfil = _this6.filial.codfil;
                            } else {
                                _this6.loadData();
                            }
                            _this6.$nextTick(function () {
                                jQuery('[data-toggle="tooltip"]').tooltip();
                                this.$refs.descricao.focus();
                            });

                        case 5:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this6);
        }))();
    }
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vcaixa_form_vue__ = __webpack_require__(1772);
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { vcaixaForm: __WEBPACK_IMPORTED_MODULE_2__vcaixa_form_vue__["a" /* default */], BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list_vue__["default"] },
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao,
            vcaixa: '',
            crud: '',
            filter: '',
            offset: '',
            codvcaixa: 0,
            metadata: this.$store.getters.getEntities.metadata
        };
    },

    computed: {
        vcaixaList: function vcaixaList() {
            return this.$store.getters.getVCaixaList;
        },
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        }
    },
    methods: {
        handleEdit: function handleEdit(cod, view) {
            if (view) this.crud = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudView;else this.crud = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudU;

            this.codvcaixa = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            this.crud = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI;
            this.codvcaixa = '';
            this.showForm = true;
        },
        handleMore: function handleMore() {
            this.offset = 'offset=' + this.nextPage;
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadVCaixa', { filter: this.filter, page: this.nexPage });
            this.offset = '';
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
            });
        },
        search: function search(value) {
            //efetua a pesquisa
            var valueU = value.toUpperCase();

            this.filter = '{"$or":[{"codvcaixa":{"$like":"%25' + valueU + '%25"}},{"descricao":{"$like":"%25' + valueU + '%25"}}]}';
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        stcaixa: function stcaixa(st) {
            var descricao = '';
            this.metadata.vcaixa.stcaixa.options.find(function (e) {
                if (e.id == st) {
                    descricao = e.text;
                }
            });
            return descricao;
        }
    },
    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_input_typeahead__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },
    components: {
        InputTypeahead: __WEBPACK_IMPORTED_MODULE_0__components_input_typeahead__["default"]
    },
    data: function data() {
        return {
            crudText: '',
            vcaixa: _extends({}, this.$store.getters.getEntities.vcaixa),
            metadata: this.$store.getters.getEntities.metadata,
            codvcaixa: 0,
            errMessages: [], // Armazena as mensagens de validações do servidor para mostrar na tela
            filial: {}
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudU;
        },
        isView: function isView() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudView;
        },

        isCreditoLoja: function isCreditoLoja() {
            return this.vcaixa.formapag == '05'; //credito loja
        },
        habilitaBandeira: function habilitaBandeira() {
            return this.vcaixa.formapag == '03' || this.vcaixa.formapag == '04' || this.vcaixa.formapag == '10' || this.vcaixa.formapag == '11' || this.vcaixa.formapag == '12' || this.vcaixa.formapag == '13';
        }
    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.vcaixa.codvcaixa);
        },
        handleSave: function handleSave() {
            var _this = this;

            // delete this.this.vcaixa.badeirapag && delete this.vcaixa.tpdiacredito
            //Validação do formulário
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            this.apiDelete();
        },
        loadFilial: function loadFilial() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDS"])(_this2.$store.getters.urlOrds + 'cg/filial/varejo', null, true).then(function (result) {
                                    if (result.items.length > 0) {
                                        _this2.filial = result.items[0];
                                    }
                                });

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        loadData: function loadData() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this3.$store.dispatch('loadVCaixa', { id: _this3.index });

                            case 2:
                                if (_this3.$store.getters.getVCaixa) {
                                    _this3.vcaixa = _extends({}, _this3.$store.getters.getVCaixa);
                                }
                                _this3.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetuaGravacao

                                modulo = 'cg/vcaixa/';
                                sendData = {};


                                sendData = { vcaixa: _this4.vcaixa };

                                metodo = 'post';
                                update = false;


                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudI) {
                                    update = true;
                                    metodo = 'put';
                                    modulo = modulo + _this4.vcaixa.codvcaixa;
                                }
                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                //efetua exclusão
                                modulo = 'cg/vcaixa/' + _this5.vcaixa.codvcaixa;
                                _context4.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this5.$store, modulo);

                            case 3:
                                data = _context4.sent;

                                _this5.$erpToastDeleted();
                                _this5.closeForm();

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        }
    },

    created: function created() {
        var _this6 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _this6.crudText = _this6.$crudText(_this6.crud);

                            _context5.next = 3;
                            return _this6.loadFilial();

                        case 3:

                            if (_this6.crud == __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudI) {
                                _this6.vcaixa.codfil = _this6.filial.codfil;
                            } else {
                                _this6.loadData();
                            }
                            _this6.$nextTick(function () {
                                jQuery('[data-toggle="tooltip"]').tooltip();
                                this.$refs.descricao.focus();
                            });

                        case 5:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this6);
        }))();
    }
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tableGrid__ = __webpack_require__(1780);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tprel: {
        "fieldname": "rel", "label": "Tipo de Relatório",
        "length": 1, "decimals": 0, "pk": "False",
        "options": [{ "id": "P", "text": "Pedidos" }, { "id": "N", "text": "Notas Fiscais" }, { "id": "T", "text": "Produtos Vendidos" }]
      },
      rel: null,
      tppedvfil: {
        "fieldname": "tppedv", "label": "Tipo de Pedido",
        "length": 1, "decimals": 0, "pk": "False",
        "options": [{ "id": "T", "text": "Todos" }, { "id": "VENDA", "text": "Pedidos" }, { "id": "ORCAMENTO", "text": "Orçamentos" }, { "id": "PERDIDO", "text": "Orçamentos Perdidos" }]
      },
      tppedv: 'T',
      stpedvfil: {
        "fieldname": "tppedv", "label": "Status do Pedido",
        "length": 1, "decimals": 0, "pk": "False",
        "options": [{ "id": "T", "text": "Todos" }, { "id": "F", "text": "Faturado" }, { "id": "P", "text": "Pendente" }, { "id": "D", "text": "Em Digitação" }, { "id": "A", "text": "Em Aprovação" }, { "id": "R", "text": "Rejeitado" }, { "id": "S", "text": "Saldo Cancelado" }, { "id": "C", "text": "Cancelado" }]
      },
      stpedv: 'T',
      operacaonffil: {
        "fieldname": "operacaonf", "label": "Tipo de Nota",
        "length": 1, "decimals": 0, "pk": "False",
        "options": [{ "id": "S", "text": "Saída" }, { "id": "E", "text": "Entrada" }]
      },
      operacaonf: 'S',
      image: null,
      columns: [],
      stnf: [],
      cliente: '',
      filial: '',
      filialLogo: '',
      textQuery: '',
      metadata: this.$store.getters.getEntities.metadata,
      filter: { //objeto utilizado pelo filtro de mes
        startDate: null,
        endDate: null,
        codusuario: null
      },
      currentPage: 1,
      sendData: {},
      gruest: '',
      gruestid: '',
      part: '',
      campo1: '',
      campo2: '',
      campo3: '',
      campo4: ''
    };
  },

  computed: {
    list: function list() {
      if (this.rel === 'P') {
        return this.$store.getters.getPedvList;
      } else if (this.rel === 'N') {
        return this.$store.getters.getNfList;
      } else if (this.rel === 'T') {
        return this.$store.getters.getTeste;
      }
    }

  },
  filters: {},
  methods: {
    loadData: function loadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var str, param;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                str = '';
                param = {};

                param.query = '';

                if (_this.textQuery) {
                  param.query = param.query + _this.textQuery;
                }

                if (_this.rel === 'P') {
                  _this.$store.dispatch('loadPedvList', param);
                } else if (_this.rel === 'N') {
                  _this.$store.dispatch('loadListNf', param);
                } else if (_this.rel === 'T') {
                  _this.$store.dispatch('loadTeste', _this.sendData);
                }

                _this.loadLogotipo();
                _this.currentPage === 1 ? _this.currentPage = 0 : _this.currentPage = 1;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    formatar: function formatar(value, tipo) {
      if (tipo == 'D') {
        // Data
        return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatDate"])(value);
      } else if (tipo == 'N') {
        return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(value, 2);
      } else {
        return value;
      }
    },
    filtrosRel: function filtrosRel() {
      var _this2 = this;

      this.campo1 = '';
      this.campo2 = '';
      this.campo3 = '';
      this.campo4 = '';

      if (this.part && this.part.length > 0) {
        this.campo1 = 'Cliente: ' + this.part[0].nome;
      }

      if (this.rel === 'P') {
        this.campo2 = 'Tipo de Pedido: ' + this.tppedvfil.options.find(function (a) {
          return a.id === _this2.tppedv;
        }).text;
        this.campo3 = 'Situação do Pedido: ' + this.stpedvfil.options.find(function (a) {
          return a.id === _this2.stpedv;
        }).text;
      } else if (this.rel === 'N') {
        this.campo2 = 'Tipo de Nota: ' + this.operacaonffil.options.find(function (a) {
          return a.id === _this2.operacaonf;
        }).text;
        this.campo3 = 'Situação das Notas: ';
        for (var x = 0; x < this.stnf.length; x++) {
          if (this.stnf[x].filtrar === true) {
            this.campo3 = this.campo3 + this.stnf[x].label + ' | ';
          }
        }
      } else if (this.rel === 'T') {
        if (this.gruest) {
          this.campo2 = 'Grupo de Estoque: ' + this.gruest.descricao;
        }
      }
    },
    textSearch: function textSearch(value) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var str, x;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.loadPart();

              case 2:
                _context2.next = 4;
                return _this3.loadGruEst();

              case 4:
                _this3.filtrosRel();
                str = '';


                if (_this3.rel === 'T') {
                  _this3.sendData = {};
                  if (_this3.cliente && _this3.cliente != null && _this3.cliente != '') {
                    str = '';
                    str = _this3.cliente.toUpperCase();
                    _this3.sendData.clientes = [];
                    _this3.sendData.clientes.push(str);
                  }
                  if (_this3.filial != '') {
                    str = '';
                    str = _this3.filial.toUpperCase();
                    _this3.sendData.filiais = [];
                    _this3.sendData.filiais.push(str);
                  }

                  if (_this3.filter.startDate != null) {
                    str = '';
                    str = Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatDateTraco"])(_this3.filter.startDate);
                    _this3.sendData.after = str;
                  }
                  if (_this3.filter.endDate != null) {
                    str = '';
                    str = Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatDateTraco"])(_this3.filter.endDate);
                    _this3.sendData.before = str;
                  }
                  if (_this3.gruestid && _this3.gruestid != '') {
                    str = '';
                    str = _this3.gruestid.toUpperCase();
                    _this3.sendData.gruest = [];
                    _this3.sendData.gruest.push(str);
                  }
                } else {
                  // this.filter = '{"$or":[{"nome":{"$like":"%25' + str + '%25"}},{"npedido":{"$like":"%25' + str + '%25"}}]}'
                  if (_this3.rel === 'N' && _this3.cliente && _this3.cliente != null && _this3.cliente != '') {
                    str = '';
                    str = _this3.cliente.toUpperCase();
                  }
                  _this3.textQuery = 'text=' + str;

                  if (_this3.filial != '') {
                    str = '';
                    str = _this3.filial.toUpperCase();
                    _this3.textQuery = _this3.textQuery + '&filial=' + str;
                  }

                  if (_this3.filter.startDate != null) {
                    str = '';
                    str = Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiDateORDS"])(_this3.filter.startDate);
                    _this3.textQuery = _this3.textQuery + '&after=' + str;
                  }
                  if (_this3.filter.endDate != null) {
                    str = '';
                    str = Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiDateORDS"])(_this3.filter.endDate, true);
                    _this3.textQuery = _this3.textQuery + '&before=' + str;
                  }

                  if (_this3.rel === 'P') {
                    if (_this3.tppedv != 'T') {
                      str = '';
                      str = _this3.tppedv.toUpperCase();
                      _this3.textQuery = _this3.textQuery + '&status=' + str;
                    }

                    if (_this3.stpedv != 'T') {
                      str = '';
                      str = _this3.stpedv.toUpperCase();
                      _this3.textQuery = _this3.textQuery + '&stpedv=' + str;
                    }

                    if (_this3.cliente && _this3.cliente != null && _this3.cliente != '') {
                      str = '';
                      str = _this3.cliente.toUpperCase();
                      _this3.textQuery = _this3.textQuery + '&codpart=' + str;
                    }
                  } else if (_this3.rel === 'N') {
                    str = '';
                    str = _this3.operacaonf.toUpperCase();
                    _this3.textQuery = _this3.textQuery + '&operacaonf=' + str;

                    str = '';
                    str = '%5B99';
                    for (x = 0; x < _this3.stnf.length; x++) {
                      if (_this3.stnf[x].filtrar === true) {
                        str = str + '%2C' + _this3.stnf[x].id;
                      }
                    }
                    console.log(str);
                    _this3.textQuery = _this3.textQuery + '&stnf=' + str + '%5D';
                  }
                }

                _this3.loadData();

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    loadLogotipo: function loadLogotipo() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var self;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                self = _this4;

                self.filialLogo = null;
                self.image = null;

                if (!(self.filial != '')) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 6;
                return self.$store.dispatch('loadFilial', { id: self.filial });

              case 6:
                if (self.$store.getters.getFilial) {
                  self.filialLogo = _extends({}, self.$store.getters.getFilial);

                  if (self.filialLogo.logotipo[0]) {
                    self.image = self.filialLogo.logotipo[0].content;
                  }
                }

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    loadPart: function loadPart() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var self;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = _this5;

                self.part = null;

                if (!(self.cliente != '')) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 5;
                return self.$store.dispatch('loadPart', { id: self.cliente });

              case 5:
                if (self.$store.getters.getPart) {
                  self.part = _extends({}, self.$store.getters.getPart);
                }

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    loadGruEst: function loadGruEst() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var self;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                self = _this6;

                self.gruest = null;

                if (!(self.gruestid && self.gruestid != '')) {
                  _context5.next = 6;
                  break;
                }

                _context5.next = 5;
                return self.$store.dispatch('loadGruest', { id: self.gruestid });

              case 5:
                if (self.$store.getters.getGruest) {
                  self.gruest = _extends({}, self.$store.getters.getGruest);
                }

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    downloadTest: function downloadTest() {
      var _this7 = this;

      var somaMer = 0;
      var somaDesc = 0;
      var somaGer = 0;
      var somaDesp = 0;
      var self = this;
      function formatar(value, tipo) {
        if (tipo == 'D') {
          // Data
          return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatDate"])(value);
        } else if (tipo == 'N') {
          return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(value, 2);
        } else {
          return value;
        }
      }

      function cabecalho() {
        if (self.image != null) {
          return {
            margin: [0, 0, 0, 10],
            table: {
              widths: [100, '*'],
              body: [[{ image: 'data:image/png;base64,' + self.image, border: [false, false, false, false], width: 98 }, {
                border: [true, false, false, false],
                table: {
                  body: [[{ text: self.filialLogo.nome, border: [false, false, false, false], fontSize: 20, bold: true }], [{ text: 'Relatório emitido em: ' + formatar(self.$getDate(), 'D'), border: [false, false, false, false] }], [{ text: self.campo1, border: [false, false, false, false] }], [{ text: self.campo2, border: [false, false, false, false] }], [{ text: self.campo3, border: [false, false, false, false] }], [{ text: self.campo4, border: [false, false, false, false] }]]
                }
              }]]
            }
          };
        } else {
          return {
            margin: [0, 0, 0, 10],
            table: {
              widths: ['*'],
              body: [[{
                border: [true, false, false, false],
                table: {
                  body: [[{ text: self.filialLogo != null ? self.filialLogo.nome : '', border: [false, false, false, false], fontSize: 20, bold: true }], [{ text: 'Relatório emitido em: ' + formatar(self.$getDate(), 'D'), border: [false, false, false, false] }], [{ text: self.campo1, border: [false, false, false, false] }], [{ text: self.campo2, border: [false, false, false, false] }], [{ text: self.campo3, border: [false, false, false, false] }], [{ text: self.campo4, border: [false, false, false, false] }]]
                }
              }]]
            }
          };
        }
      }

      Object.byString = function (o, s, f) {
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, ''); // strip a leading dot
        var a = s.split('.');
        for (var i = 0, n = a.length; i < n; ++i) {
          var k = a[i];

          if (k in o) {
            o = formatar(o[k], f);
            //somaMer += o[k]
          } else {
            return;
          }
        }
        return o;
      };
      function buildTableBody(data, columns, showHeaders, headers, fontSize, formatacao, totaliza) {
        var body = [];
        var self = this;
        var valorTotal = [];
        var dataRow = [];
        var i = 0;
        // Inserting headers
        if (showHeaders) {
          body.push(headers);
        }
        columns.forEach(function (column) {
          if (totaliza[i] && formatacao[i] === 'N') {
            valorTotal[i] = 0;
          } else {
            valorTotal[i] = '';
          }
          i++;
        });

        // Inserting items from external data array
        data.forEach(function (row) {
          dataRow = [];
          i = 0;
          columns.forEach(function (column) {
            dataRow.push({
              text: Object.byString(row, column, formatacao[i]), alignment: headers[i].alignment,
              fontSize: fontSize
            });
            if (totaliza[i] && formatacao[i] === 'N') {
              valorTotal[i] += row[column];
            }
            i++;
          });

          body.push(dataRow);
        });
        // Totalização
        dataRow = [];
        i = 0;

        columns.forEach(function (column) {
          dataRow.push({
            text: totaliza[i] ? formatar(valorTotal[i], formatacao[i]) : '', alignment: headers[i].alignment,
            fontSize: fontSize + 1, bold: true
          });
          i++;
        });
        body.push(dataRow);

        return body;
      }

      function table(data, columns, witdhsDef, showHeaders, headers, layoutDef, fontSize, formatacao, totaliza) {
        return {
          table: {
            headerRows: 1,
            widths: witdhsDef,
            body: buildTableBody(data, columns, showHeaders, headerTable(headers), fontSize, formatacao, totaliza)
          },
          layout: layoutDef
        };
      }

      function headerTable(data) {
        var dataRow = [];
        data.forEach(function (row) {
          if (row[4] == true) {
            dataRow.push({ text: row[1], style: 'tableHeader', alignment: row[5] });
          }
        });
        return dataRow;
      }
      function colunas(data, i) {
        var dataRow = [];
        data.forEach(function (row) {
          if (row[4] == true) {
            dataRow.push(row[i]);
          }
        });
        return dataRow;
      }

      if (this.list.length > 0) {
        var docDefinition = {

          pageOrientation: this.rel === 'N' ? 'landscape' : 'portrait',

          // Informações do PDF
          info: {
            title: this.tprel.options.find(function (a) {
              return a.id === _this7.rel;
            }).text,
            author: 'Nota Brasil'
          },

          content: [
          // Cabeçalho
          cabecalho(),

          // Fim Cabeçalho
          {
            margin: 10,
            text: this.tprel.options.find(function (a) {
              return a.id === _this7.rel;
            }).text,
            fontSize: 20,
            bold: true,
            alignment: 'center'
          },
          // Tabela
          table(
          // External data
          this.list,
          // Columns display order
          colunas(this.columns, 0),
          // Custom columns widths
          colunas(this.columns, 6),
          // Show headers?
          true,
          // Custom headers
          this.columns,
          // Custom layout, use '' for no layout
          'lightHorizontalLines', 9, colunas(this.columns, 3), colunas(this.columns, 7))],

          // Paginação
          footer: function footer(currentPage, pageCount) {
            return {
              margin: 10,
              columns: [{
                fontSize: 9,
                text: [currentPage.toString() + ' de ' + pageCount],
                alignment: 'center'
              }]
            };
          },
          // Fim Paginação

          styles: {
            tableRow: {
              fontSize: 10,
              alignment: 'center'
            },
            tableHeader: {
              alignment: 'center',
              bold: true,
              fontSize: 9,
              color: 'black',
              borders: [false, false, true, false]
            }
          }
        };

        pdfMake.createPdf(docDefinition).open();
      }
    }
  },
  components: {
    tableGrid: __WEBPACK_IMPORTED_MODULE_3__components_tableGrid__["a" /* default */]
  },
  watch: {
    rel: function rel() {
      this.currentPage === 1 ? this.currentPage = 0 : this.currentPage = 1;
      /*
      [
          0 = 'Campo',
          1 = 'Descrição do Cabeçalho',
          2 = 'Percentual da Coluna na Grade',
          3 = 'Formatar: D - Data / N - Decimal,
          4 = 'Exibir Coluna: true / false,
          5 = 'Alinhamento: center / left / right,
          6 = 'Tamanho da Coluna no Relatório',
          7 = 'Totaliza',
          8 = 'Valor total'
      ]
      */
      if (this.rel === 'P') {

        this.columns = [['npedido', 'Pedido', '5%', '', true, 'left', '*', false, 0], ['ncotacao', 'Orçamento', '5%', '', true, 'left', '*', false, 0], ['nome', 'Cliente', '60%', '', true, 'left', 150, false, 0], ['data', 'Data', '10%', 'D', true, 'center', '*', false, 0], ['totmer', 'Mercadorias', '5%', 'N', true, 'right', '*', true, 0], ['totaldesp', 'Impostos/Acréscimos', '5%', 'N', true, 'right', '*', true, 0], ['vlrdesc', 'Descontos', '5%', 'N', true, 'right', '*', true, 0], ['totger', 'Totais', '5%', 'N', true, 'right', '*', true, 0]];
      } else if (this.rel === 'N') {
        this.columns = [['serie', 'Série', '5%', '', true, 'center', '*', false, 0], ['nf', 'Nr. NF', '5%', '', true, 'center', '*', false, 0], ['status', 'Status', '15%', '', true, 'left', 50, false, 0], ['nome', 'Cliente', '35%', '', true, 'left', 100, false, 0], ['data', 'Data', '10%', 'D', true, 'center', '*', false, 0], ['dtsai', 'Data de Saída', '10%', 'D', true, 'center', '*', false, 0], ['totmer', 'Mercadorias', '5%', 'N', true, 'right', '*', true, 0], ['totaldesp', 'Impostos/Acréscimos', '5%', 'N', true, 'right', '*', true, 0], ['vlrdesc', 'Descontos', '5%', 'N', true, 'right', '*', true, 0], ['totger', 'Totais', '5%', 'N', true, 'right', '*', true, 0]];

        this.stnf = [{ "id": "10", "label": "Faturadas", "filtrar": true }, { "id": "90%2C92", "label": "Canceladas", "filtrar": true }, { "id": "01%2C02%2C11%2C50", "label": "Abertas", "filtrar": true }, { "id": "00", "label": "Em Digitação", "filtrar": true }];
      } else if (this.rel === 'T') {
        this.columns = [['coditem', 'Código do Item', '5%', '', true, 'center', '*', false, 0], ['descricao', 'Item', '50%', '', true, 'left', 150, false, 0], ['uni', 'Uni', '5%', '', true, 'center', '*', false, 0], ['qt', 'Quantidade', '15%', 'N', true, 'right', '*', true, 0], ['total', 'Total', '15%', 'N', true, 'right', '*', true, 0]
        //,['percentual', 'Percentual', '10%', 'N', true, 'right', '*', true, 0]
        ];
      }
      this.textSearch();
    }
  },
  created: function created() {
    this.rel = "P";
    //this.loadData()
  }
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_utils__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        campos: null,
        columns: Array,
        currentPage: 0
    },
    data: function data() {
        var sortOrders = {};

        this.columns.forEach(function (key) {
            sortOrders[key[0]] = 1;
        });
        return {
            sortKey: '',
            sortOrders: sortOrders,
            pageSize: 20,
            page: 1
        };
    },

    computed: {

        filteredCampos: function filteredCampos() {
            if (this.campos.length > 0) {
                var sortKey = this.sortKey;
                var order = this.sortOrders[sortKey];
                var campos = this.campos;
                var start = (this.page - 1) * this.pageSize;
                var end = this.page * this.pageSize;

                if (sortKey) {
                    campos = campos.sort(function (a, b) {
                        a = a[sortKey];
                        b = b[sortKey];
                        return (a === b ? 0 : a > b ? 1 : -1) * order;
                    });
                }
                campos = campos.slice(start, end);

                return campos;
            }
        }
    },
    filters: {
        capitalize: function capitalize(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }

    },
    methods: {
        sortBy: function sortBy(key) {
            this.sortKey = 0;
            this.sortKey = key;
            this.sortOrders[key] = (this.sortOrders[key] || 1) * -1;
        },
        nextPage: function nextPage() {
            if (this.page * this.pageSize < this.campos.length) this.page++;
        },
        prevPage: function prevPage() {
            if (this.page > 1) this.page--;
        },
        formatar: function formatar(value, tipo) {
            if (tipo == 'D') {
                // Data
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["formatDate"])(value);
            } else if (tipo == 'N') {
                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["formatValue"])(value, 2);
            } else {
                return value;
            }
        },

        subs: function subs(texto) {
            var charMap = { "0": "0", "1": "1", "2": "2", "3": "3", "4": "4", "5": "5", "6": "6", "7": "7", "8": "8", "9": "9", "A": "A", "B": "B", "C": "C", "D": "D", "E": "E", "F": "F", "G": "G", "H": "H", "I": "I", "J": "J", "K": "K", "L": "L", "M": "M", "N": "N", "O": "O", "P": "P", "Q": "Q", "R": "R", "S": "S", "T": "T", "U": "U", "V": "V", "W": "W", "X": "X", "Y": "Y", "Z": "Z", "a": "a", "b": "b", "c": "c", "d": "d", "e": "e", "f": "f", "g": "g", "h": "h", "i": "i", "j": "j", "k": "k", "l": "l", "m": "m", "n": "n", "o": "o", "p": "p", "q": "q", "r": "r", "s": "s", "t": "t", "u": "u", "v": "v", "w": "w", "x": "x", "y": "y", "z": "z", "ª": "a", "²": "2", "³": "3", "¹": "1", "º": "o", "À": "A", "Á": "A", "Â": "A", "Ã": "A", "Ä": "A", "Å": "A", "Ç": "C", "È": "E", "É": "E", "Ê": "E", "Ë": "E", "Ì": "I", "Í": "I", "Î": "I", "Ï": "I", "Ð": "D", "Ñ": "N", "Ò": "O", "Ó": "O", "Ô": "O", "Õ": "O", "Ö": "O", "Ø": "O", "Ù": "U", "Ú": "U", "Û": "U", "Ü": "U", "Ý": "Y", "à": "a", "á": "a", "â": "a", "ã": "a", "ä": "a", "å": "a", "ç": "c", "è": "e", "é": "e", "ê": "e", "ë": "e", "ì": "i", "í": "i", "î": "i", "ï": "i", "ð": "d", "ñ": "n", "ò": "o", "ó": "o", "ô": "o", "õ": "o", "ö": "o", "ø": "o", "ù": "u", "ú": "u", "û": "u", "ü": "u", "ý": "y", "ÿ": "y", "Ā": "A", "ā": "a", "Ă": "A", "ă": "a", "Ą": "A", "ą": "a", "Ć": "C", "ć": "c", "Ĉ": "C", "ĉ": "c", "Ċ": "C", "ċ": "c", "Č": "C", "č": "c", "Ď": "D", "ď": "d", "Đ": "D", "đ": "d", "Ē": "E", "ē": "e", "Ĕ": "E", "ĕ": "e", "Ė": "E", "ė": "e", "Ę": "E", "ę": "e", "Ě": "E", "ě": "e", "Ĝ": "G", "ĝ": "g", "Ğ": "G", "ğ": "g", "Ġ": "G", "ġ": "g", "Ģ": "G", "ģ": "g", "Ĥ": "H", "ĥ": "h", "Ħ": "H", "ħ": "h", "Ĩ": "I", "ĩ": "i", "Ī": "I", "ī": "i", "Ĭ": "I", "ĭ": "i", "Į": "I", "į": "i", "İ": "I", "Ĵ": "J", "ĵ": "j", "Ķ": "K", "ķ": "k", "Ĺ": "L", "ĺ": "l", "Ļ": "L", "ļ": "l", "Ľ": "L", "ľ": "l", "Ŀ": "L", "ŀ": "l", "Ł": "L", "ł": "l", "Ń": "N", "ń": "n", "Ņ": "N", "ņ": "n", "Ň": "N", "ň": "n", "Ō": "O", "ō": "o", "Ŏ": "O", "ŏ": "o", "Ő": "O", "ő": "o", "Ŕ": "R", "ŕ": "r", "Ŗ": "R", "ŗ": "r", "Ř": "R", "ř": "r", "Ś": "S", "ś": "s", "Ŝ": "S", "ŝ": "s", "Ş": "S", "ş": "s", "Š": "S", "š": "s", "Ţ": "T", "ţ": "t", "Ť": "T", "ť": "t", "Ũ": "U", "ũ": "u", "Ū": "U", "ū": "u", "Ŭ": "U", "ŭ": "u", "Ů": "U", "ů": "u", "Ű": "U", "ű": "u", "Ų": "U", "ų": "u", "Ŵ": "W", "ŵ": "w", "Ŷ": "Y", "ŷ": "y", "Ÿ": "Y", "Ź": "Z", "ź": "z", "Ż": "Z", "ż": "z", "Ž": "Z", "ž": "z", "ſ": "s", "Ơ": "O", "ơ": "o", "Ư": "U", "ư": "u", "Ǎ": "A", "ǎ": "a", "Ǐ": "I", "ǐ": "i", "Ǒ": "O", "ǒ": "o", "Ǔ": "U", "ǔ": "u", "Ǖ": "U", "ǖ": "u", "Ǘ": "U", "ǘ": "u", "Ǚ": "U", "ǚ": "u", "Ǜ": "U", "ǜ": "u", "Ǟ": "A", "ǟ": "a", "Ǡ": "A", "ǡ": "a", "Ǧ": "G", "ǧ": "g", "Ǩ": "K", "ǩ": "k", "Ǫ": "O", "ǫ": "o", "Ǭ": "O", "ǭ": "o", "ǰ": "j", "Ǵ": "G", "ǵ": "g", "Ǹ": "N", "ǹ": "n", "Ǻ": "A", "ǻ": "a", "Ǿ": "O", "ǿ": "o", "Ȁ": "A", "ȁ": "a", "Ȃ": "A", "ȃ": "a", "Ȅ": "E", "ȅ": "e", "Ȇ": "E", "ȇ": "e", "Ȉ": "I", "ȉ": "i", "Ȋ": "I", "ȋ": "i", "Ȍ": "O", "ȍ": "o", "Ȏ": "O", "ȏ": "o", "Ȑ": "R", "ȑ": "r", "Ȓ": "R", "ȓ": "r", "Ȕ": "U", "ȕ": "u", "Ȗ": "U", "ȗ": "u", "Ș": "S", "ș": "s", "Ț": "T", "ț": "t", "Ȟ": "H", "ȟ": "h", "Ȧ": "A", "ȧ": "a", "Ȩ": "E", "ȩ": "e", "Ȫ": "O", "ȫ": "o", "Ȭ": "O", "ȭ": "o", "Ȯ": "O", "ȯ": "o", "Ȱ": "O", "ȱ": "o", "Ȳ": "Y", "ȳ": "y", "ʰ": "h", "ʲ": "j", "ʳ": "r", "ʷ": "w", "ʸ": "y", "ˡ": "l", "ˢ": "s", "ˣ": "x", "ͣ": "a", "ͤ": "e", "ͥ": "i", "ͦ": "o", "ͧ": "u", "ͨ": "c", "ͩ": "d", "ͪ": "h", "ͫ": "m", "ͬ": "r", "ͭ": "t", "ͮ": "v", "ͯ": "x", "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4", "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9", "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4", "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9", "߀": "0", "߁": "1", "߂": "2", "߃": "3", "߄": "4", "߅": "5", "߆": "6", "߇": "7", "߈": "8", "߉": "9", "०": "0", "१": "1", "२": "2", "३": "3", "४": "4", "५": "5", "६": "6", "७": "7", "८": "8", "९": "9", "০": "0", "১": "1", "২": "2", "৩": "3", "৪": "4", "৫": "5", "৬": "6", "৭": "7", "৮": "8", "৯": "9", "੦": "0", "੧": "1", "੨": "2", "੩": "3", "੪": "4", "੫": "5", "੬": "6", "੭": "7", "੮": "8", "੯": "9", "૦": "0", "૧": "1", "૨": "2", "૩": "3", "૪": "4", "૫": "5", "૬": "6", "૭": "7", "૮": "8", "૯": "9", "୦": "0", "୧": "1", "୨": "2", "୩": "3", "୪": "4", "୫": "5", "୬": "6", "୭": "7", "୮": "8", "୯": "9", "௦": "0", "௧": "1", "௨": "2", "௩": "3", "௪": "4", "௫": "5", "௬": "6", "௭": "7", "௮": "8", "௯": "9", "౦": "0", "౧": "1", "౨": "2", "౩": "3", "౪": "4", "౫": "5", "౬": "6", "౭": "7", "౮": "8", "౯": "9", "౸": "0", "౹": "1", "౺": "2", "౻": "3", "౼": "1", "౽": "2", "౾": "3", "೦": "0", "೧": "1", "೨": "2", "೩": "3", "೪": "4", "೫": "5", "೬": "6", "೭": "7", "೮": "8", "೯": "9", "൦": "0", "൧": "1", "൨": "2", "൩": "3", "൪": "4", "൫": "5", "൬": "6", "൭": "7", "൮": "8", "൯": "9", "๐": "0", "๑": "1", "๒": "2", "๓": "3", "๔": "4", "๕": "5", "๖": "6", "๗": "7", "๘": "8", "๙": "9", "໐": "0", "໑": "1", "໒": "2", "໓": "3", "໔": "4", "໕": "5", "໖": "6", "໗": "7", "໘": "8", "໙": "9", "༠": "0", "༡": "1", "༢": "2", "༣": "3", "༤": "4", "༥": "5", "༦": "6", "༧": "7", "༨": "8", "༩": "9", "༪": "1", "༫": "2", "༬": "3", "༭": "4", "༮": "5", "༯": "6", "༰": "7", "༱": "8", "༲": "9", "༳": "0", "၀": "0", "၁": "1", "၂": "2", "၃": "3", "၄": "4", "၅": "5", "၆": "6", "၇": "7", "၈": "8", "၉": "9", "႐": "0", "႑": "1", "႒": "2", "႓": "3", "႔": "4", "႕": "5", "႖": "6", "႗": "7", "႘": "8", "႙": "9", "፩": "1", "፪": "2", "፫": "3", "፬": "4", "፭": "5", "፮": "6", "፯": "7", "፰": "8", "፱": "9", "០": "0", "១": "1", "២": "2", "៣": "3", "៤": "4", "៥": "5", "៦": "6", "៧": "7", "៨": "8", "៩": "9", "៰": "0", "៱": "1", "៲": "2", "៳": "3", "៴": "4", "៵": "5", "៶": "6", "៷": "7", "៸": "8", "៹": "9", "᠐": "0", "᠑": "1", "᠒": "2", "᠓": "3", "᠔": "4", "᠕": "5", "᠖": "6", "᠗": "7", "᠘": "8", "᠙": "9", "᥆": "0", "᥇": "1", "᥈": "2", "᥉": "3", "᥊": "4", "᥋": "5", "᥌": "6", "᥍": "7", "᥎": "8", "᥏": "9", "᧐": "0", "᧑": "1", "᧒": "2", "᧓": "3", "᧔": "4", "᧕": "5", "᧖": "6", "᧗": "7", "᧘": "8", "᧙": "9", "᧚": "1", "᪀": "0", "᪁": "1", "᪂": "2", "᪃": "3", "᪄": "4", "᪅": "5", "᪆": "6", "᪇": "7", "᪈": "8", "᪉": "9", "᪐": "0", "᪑": "1", "᪒": "2", "᪓": "3", "᪔": "4", "᪕": "5", "᪖": "6", "᪗": "7", "᪘": "8", "᪙": "9", "᭐": "0", "᭑": "1", "᭒": "2", "᭓": "3", "᭔": "4", "᭕": "5", "᭖": "6", "᭗": "7", "᭘": "8", "᭙": "9", "᮰": "0", "᮱": "1", "᮲": "2", "᮳": "3", "᮴": "4", "᮵": "5", "᮶": "6", "᮷": "7", "᮸": "8", "᮹": "9", "᱀": "0", "᱁": "1", "᱂": "2", "᱃": "3", "᱄": "4", "᱅": "5", "᱆": "6", "᱇": "7", "᱈": "8", "᱉": "9", "᱐": "0", "᱑": "1", "᱒": "2", "᱓": "3", "᱔": "4", "᱕": "5", "᱖": "6", "᱗": "7", "᱘": "8", "᱙": "9", "ᴬ": "A", "ᴮ": "B", "ᴰ": "D", "ᴱ": "E", "ᴳ": "G", "ᴴ": "H", "ᴵ": "I", "ᴶ": "J", "ᴷ": "K", "ᴸ": "L", "ᴹ": "M", "ᴺ": "N", "ᴼ": "O", "ᴾ": "P", "ᴿ": "R", "ᵀ": "T", "ᵁ": "U", "ᵂ": "W", "ᵃ": "a", "ᵇ": "b", "ᵈ": "d", "ᵉ": "e", "ᵍ": "g", "ᵏ": "k", "ᵐ": "m", "ᵒ": "o", "ᵖ": "p", "ᵗ": "t", "ᵘ": "u", "ᵛ": "v", "ᵢ": "i", "ᵣ": "r", "ᵤ": "u", "ᵥ": "v", "ᵹ": "g", "ᶜ": "c", "ᶞ": "d", "ᶠ": "f", "ᶻ": "z", "᷊": "r", "ᷓ": "a", "ᷗ": "c", "ᷘ": "d", "ᷙ": "d", "ᷚ": "g", "ᷜ": "k", "ᷝ": "l", "ᷠ": "n", "ᷤ": "s", "ᷥ": "s", "ᷦ": "z", "Ḁ": "A", "ḁ": "a", "Ḃ": "B", "ḃ": "b", "Ḅ": "B", "ḅ": "b", "Ḇ": "B", "ḇ": "b", "Ḉ": "C", "ḉ": "c", "Ḋ": "D", "ḋ": "d", "Ḍ": "D", "ḍ": "d", "Ḏ": "D", "ḏ": "d", "Ḑ": "D", "ḑ": "d", "Ḓ": "D", "ḓ": "d", "Ḕ": "E", "ḕ": "e", "Ḗ": "E", "ḗ": "e", "Ḙ": "E", "ḙ": "e", "Ḛ": "E", "ḛ": "e", "Ḝ": "E", "ḝ": "e", "Ḟ": "F", "ḟ": "f", "Ḡ": "G", "ḡ": "g", "Ḣ": "H", "ḣ": "h", "Ḥ": "H", "ḥ": "h", "Ḧ": "H", "ḧ": "h", "Ḩ": "H", "ḩ": "h", "Ḫ": "H", "ḫ": "h", "Ḭ": "I", "ḭ": "i", "Ḯ": "I", "ḯ": "i", "Ḱ": "K", "ḱ": "k", "Ḳ": "K", "ḳ": "k", "Ḵ": "K", "ḵ": "k", "Ḷ": "L", "ḷ": "l", "Ḹ": "L", "ḹ": "l", "Ḻ": "L", "ḻ": "l", "Ḽ": "L", "ḽ": "l", "Ḿ": "M", "ḿ": "m", "Ṁ": "M", "ṁ": "m", "Ṃ": "M", "ṃ": "m", "Ṅ": "N", "ṅ": "n", "Ṇ": "N", "ṇ": "n", "Ṉ": "N", "ṉ": "n", "Ṋ": "N", "ṋ": "n", "Ṍ": "O", "ṍ": "o", "Ṏ": "O", "ṏ": "o", "Ṑ": "O", "ṑ": "o", "Ṓ": "O", "ṓ": "o", "Ṕ": "P", "ṕ": "p", "Ṗ": "P", "ṗ": "p", "Ṙ": "R", "ṙ": "r", "Ṛ": "R", "ṛ": "r", "Ṝ": "R", "ṝ": "r", "Ṟ": "R", "ṟ": "r", "Ṡ": "S", "ṡ": "s", "Ṣ": "S", "ṣ": "s", "Ṥ": "S", "ṥ": "s", "Ṧ": "S", "ṧ": "s", "Ṩ": "S", "ṩ": "s", "Ṫ": "T", "ṫ": "t", "Ṭ": "T", "ṭ": "t", "Ṯ": "T", "ṯ": "t", "Ṱ": "T", "ṱ": "t", "Ṳ": "U", "ṳ": "u", "Ṵ": "U", "ṵ": "u", "Ṷ": "U", "ṷ": "u", "Ṹ": "U", "ṹ": "u", "Ṻ": "U", "ṻ": "u", "Ṽ": "V", "ṽ": "v", "Ṿ": "V", "ṿ": "v", "Ẁ": "W", "ẁ": "w", "Ẃ": "W", "ẃ": "w", "Ẅ": "W", "ẅ": "w", "Ẇ": "W", "ẇ": "w", "Ẉ": "W", "ẉ": "w", "Ẋ": "X", "ẋ": "x", "Ẍ": "X", "ẍ": "x", "Ẏ": "Y", "ẏ": "y", "Ẑ": "Z", "ẑ": "z", "Ẓ": "Z", "ẓ": "z", "Ẕ": "Z", "ẕ": "z", "ẖ": "h", "ẗ": "t", "ẘ": "w", "ẙ": "y", "ẛ": "s", "Ạ": "A", "ạ": "a", "Ả": "A", "ả": "a", "Ấ": "A", "ấ": "a", "Ầ": "A", "ầ": "a", "Ẩ": "A", "ẩ": "a", "Ẫ": "A", "ẫ": "a", "Ậ": "A", "ậ": "a", "Ắ": "A", "ắ": "a", "Ằ": "A", "ằ": "a", "Ẳ": "A", "ẳ": "a", "Ẵ": "A", "ẵ": "a", "Ặ": "A", "ặ": "a", "Ẹ": "E", "ẹ": "e", "Ẻ": "E", "ẻ": "e", "Ẽ": "E", "ẽ": "e", "Ế": "E", "ế": "e", "Ề": "E", "ề": "e", "Ể": "E", "ể": "e", "Ễ": "E", "ễ": "e", "Ệ": "E", "ệ": "e", "Ỉ": "I", "ỉ": "i", "Ị": "I", "ị": "i", "Ọ": "O", "ọ": "o", "Ỏ": "O", "ỏ": "o", "Ố": "O", "ố": "o", "Ồ": "O", "ồ": "o", "Ổ": "O", "ổ": "o", "Ỗ": "O", "ỗ": "o", "Ộ": "O", "ộ": "o", "Ớ": "O", "ớ": "o", "Ờ": "O", "ờ": "o", "Ở": "O", "ở": "o", "Ỡ": "O", "ỡ": "o", "Ợ": "O", "ợ": "o", "Ụ": "U", "ụ": "u", "Ủ": "U", "ủ": "u", "Ứ": "U", "ứ": "u", "Ừ": "U", "ừ": "u", "Ử": "U", "ử": "u", "Ữ": "U", "ữ": "u", "Ự": "U", "ự": "u", "Ỳ": "Y", "ỳ": "y", "Ỵ": "Y", "ỵ": "y", "Ỷ": "Y", "ỷ": "y", "Ỹ": "Y", "ỹ": "y", "⁰": "0", "ⁱ": "i", "⁴": "4", "⁵": "5", "⁶": "6", "⁷": "7", "⁸": "8", "⁹": "9", "ⁿ": "n", "₀": "0", "₁": "1", "₂": "2", "₃": "3", "₄": "4", "₅": "5", "₆": "6", "₇": "7", "₈": "8", "₉": "9", "ₐ": "a", "ₑ": "e", "ₒ": "o", "ₓ": "x", "ₕ": "h", "ₖ": "k", "ₗ": "l", "ₘ": "m", "ₙ": "n", "ₚ": "p", "ₛ": "s", "ₜ": "t", "ℂ": "C", "ℊ": "g", "ℋ": "H", "ℌ": "H", "ℍ": "H", "ℎ": "h", "ℏ": "h", "ℐ": "I", "ℑ": "I", "ℒ": "L", "ℓ": "l", "ℕ": "N", "ℙ": "P", "ℚ": "Q", "ℛ": "R", "ℜ": "R", "ℝ": "R", "ℤ": "Z", "ℨ": "Z", "K": "K", "Å": "A", "ℬ": "B", "ℭ": "C", "ℯ": "e", "ℰ": "E", "ℱ": "F", "ℳ": "M", "ℴ": "o", "ℹ": "i", "ⅅ": "D", "ⅆ": "d", "ⅇ": "e", "ⅈ": "i", "ⅉ": "j", "Ⅰ": "I", "Ⅴ": "V", "Ⅹ": "X", "Ⅼ": "L", "Ⅽ": "C", "Ⅾ": "D", "Ⅿ": "M", "ⅰ": "i", "ⅴ": "v", "ⅹ": "x", "ⅼ": "l", "ⅽ": "c", "ⅾ": "d", "ⅿ": "m", "ↅ": "6", "①": "1", "②": "2", "③": "3", "④": "4", "⑤": "5", "⑥": "6", "⑦": "7", "⑧": "8", "⑨": "9", "Ⓐ": "A", "Ⓑ": "B", "Ⓒ": "C", "Ⓓ": "D", "Ⓔ": "E", "Ⓕ": "F", "Ⓖ": "G", "Ⓗ": "H", "Ⓘ": "I", "Ⓙ": "J", "Ⓚ": "K", "Ⓛ": "L", "Ⓜ": "M", "Ⓝ": "N", "Ⓞ": "O", "Ⓟ": "P", "Ⓠ": "Q", "Ⓡ": "R", "Ⓢ": "S", "Ⓣ": "T", "Ⓤ": "U", "Ⓥ": "V", "Ⓦ": "W", "Ⓧ": "X", "Ⓨ": "Y", "Ⓩ": "Z", "ⓐ": "a", "ⓑ": "b", "ⓒ": "c", "ⓓ": "d", "ⓔ": "e", "ⓕ": "f", "ⓖ": "g", "ⓗ": "h", "ⓘ": "i", "ⓙ": "j", "ⓚ": "k", "ⓛ": "l", "ⓜ": "m", "ⓝ": "n", "ⓞ": "o", "ⓟ": "p", "ⓠ": "q", "ⓡ": "r", "ⓢ": "s", "ⓣ": "t", "ⓤ": "u", "ⓥ": "v", "ⓦ": "w", "ⓧ": "x", "ⓨ": "y", "ⓩ": "z", "⓪": "0", "⓵": "1", "⓶": "2", "⓷": "3", "⓸": "4", "⓹": "5", "⓺": "6", "⓻": "7", "⓼": "8", "⓽": "9", "⓿": "0", "❶": "1", "❷": "2", "❸": "3", "❹": "4", "❺": "5", "❻": "6", "❼": "7", "❽": "8", "❾": "9", "➀": "1", "➁": "2", "➂": "3", "➃": "4", "➄": "5", "➅": "6", "➆": "7", "➇": "8", "➈": "9", "➊": "1", "➋": "2", "➌": "3", "➍": "4", "➎": "5", "➏": "6", "➐": "7", "➑": "8", "➒": "9", "ⱼ": "j", "ⱽ": "V", "〇": "0", "〡": "1", "〢": "2", "〣": "3", "〤": "4", "〥": "5", "〦": "6", "〧": "7", "〨": "8", "〩": "9", "꘠": "0", "꘡": "1", "꘢": "2", "꘣": "3", "꘤": "4", "꘥": "5", "꘦": "6", "꘧": "7", "꘨": "8", "꘩": "9", "Ꝺ": "D", "ꝺ": "d", "Ꝼ": "F", "ꝼ": "f", "Ᵹ": "G", "Ꞃ": "R", "ꞃ": "r", "Ꞅ": "S", "ꞅ": "s", "Ꞇ": "T", "ꞇ": "t", "Ꞡ": "G", "ꞡ": "g", "Ꞣ": "K", "ꞣ": "k", "Ꞥ": "N", "ꞥ": "n", "Ꞧ": "R", "ꞧ": "r", "Ꞩ": "S", "ꞩ": "s", "꣐": "0", "꣑": "1", "꣒": "2", "꣓": "3", "꣔": "4", "꣕": "5", "꣖": "6", "꣗": "7", "꣘": "8", "꣙": "9", "꤀": "0", "꤁": "1", "꤂": "2", "꤃": "3", "꤄": "4", "꤅": "5", "꤆": "6", "꤇": "7", "꤈": "8", "꤉": "9", "꧐": "0", "꧑": "1", "꧒": "2", "꧓": "3", "꧔": "4", "꧕": "5", "꧖": "6", "꧗": "7", "꧘": "8", "꧙": "9", "꩐": "0", "꩑": "1", "꩒": "2", "꩓": "3", "꩔": "4", "꩕": "5", "꩖": "6", "꩗": "7", "꩘": "8", "꩙": "9", "꯰": "0", "꯱": "1", "꯲": "2", "꯳": "3", "꯴": "4", "꯵": "5", "꯶": "6", "꯷": "7", "꯸": "8", "꯹": "9", "０": "0", "１": "1", "２": "2", "３": "3", "４": "4", "５": "5", "６": "6", "７": "7", "８": "8", "９": "9", "Ａ": "A", "Ｂ": "B", "Ｃ": "C", "Ｄ": "D", "Ｅ": "E", "Ｆ": "F", "Ｇ": "G", "Ｈ": "H", "Ｉ": "I", "Ｊ": "J", "Ｋ": "K", "Ｌ": "L", "Ｍ": "M", "Ｎ": "N", "Ｏ": "O", "Ｐ": "P", "Ｑ": "Q", "Ｒ": "R", "Ｓ": "S", "Ｔ": "T", "Ｕ": "U", "Ｖ": "V", "Ｗ": "W", "Ｘ": "X", "Ｙ": "Y", "Ｚ": "Z", "ａ": "a", "ｂ": "b", "ｃ": "c", "ｄ": "d", "ｅ": "e", "ｆ": "f", "ｇ": "g", "ｈ": "h", "ｉ": "i", "ｊ": "j", "ｋ": "k", "ｌ": "l", "ｍ": "m", "ｎ": "n", "ｏ": "o", "ｐ": "p", "ｑ": "q", "ｒ": "r", "ｓ": "s", "ｔ": "t", "ｕ": "u", "ｖ": "v", "ｗ": "w", "ｘ": "x", "ｙ": "y", "ｚ": "z" };

            var er = /\W/gi;
            texto = texto.replace(er, function (match) {
                var base = charMap[match];
                return !base || er.test(base) ? "" : match;
            });
        }

    },
    watch: {
        currentPage: function currentPage() {
            this.page = 1;
        }

    }
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tabpre_list_vue__ = __webpack_require__(640);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f84c21b2_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tabpre_list_vue__ = __webpack_require__(1799);
function injectStyle (ssrContext) {
  __webpack_require__(1785)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f84c21b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tabpre_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f84c21b2_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tabpre_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabpre_form__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tabpre_itens_form__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: 'list', //list, itens, form
            crud: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            tabelasList: [],
            codtabpre: null,
            isView: false,
            title: '',
            indexEdit: null,
            showInserirProduto: false
        };
    },


    computed: {
        possuiPermissao: function possuiPermissao() {
            if (__WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].usaIntegracao) {
                return false;
            }
            return __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].appNFe || __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].appERP || __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].appLoja || __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].usuarioAdministrador && __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].appForcaVendas;
        },

        tabpreList: function tabpreList() {
            return this.$store.getters.getTabpreList;
        },

        selectedTabpre: function selectedTabpre() {
            var self = this;
            var tabela = this.tabpreList.filter(function (obj) {
                return obj.codtabpre == self.codtabpre;
            });
            return tabela[0];
        }
    },

    filters: {
        getTipoTabela: function getTipoTabela(value) {
            if (value == 'P') return 'Tabela de preços normal com preços digitados';else if (value == 'D') return 'Tabela automática de desconto aplicado na tabela de preços padrão';else if (value == 'A') return 'Tabela automática de acréscimo aplicado na tabela de preços padrão';
        }
    },

    watch: {
        codtabpre: function codtabpre() {
            this.showInserirProduto = false;
            var self = this;
            var tabela = this.tabpreList.filter(function (obj) {
                return obj.codtabpre == self.codtabpre;
            });
            if (tabela.length > 0) {
                this.title = tabela[0].descricao;
            }
            if (this.codtabpre) {
                this.loadData();
            }
        }
    },

    methods: {
        handleEdit: function handleEdit(cod) {
            if (!this.possuiPermissao) {
                this.$erpToastError('Usuário sem permissão.');
                return;
            }
            this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudU;
            this.codtabpre = cod;
            this.showForm = 'form';
        },
        handleNew: function handleNew() {
            if (!this.possuiPermissao) {
                this.$erpToastError('Usuário sem permissão.');
                return;
            }

            this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudI;
            this.showForm = 'form';
        },
        handleEditItens: function handleEditItens(cod) {
            this.codtabpre = cod;
            this.showForm = 'itens';
        },
        closeForm: function closeForm(codtabpre) {
            this.showForm = 'list';
            this.loadData();
            if (!codtabpre) {
                return;
            }
            this.codtabpre = codtabpre;
            var self = this;
            setTimeout(function () {
                self.showForm = 'itens';
            }, 500);
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codtabpre":{"$eq":"' + value + '"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadTabelas: function loadTabelas(param) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadTabpre', {});

                            case 2:
                                if (_this.$store.getters.getTabpreList) {
                                    _this.tabelasList = _this.$store.getters.getTabpreList.map(function (obj) {
                                        return { id: obj.codtabpre, text: obj.descricao };
                                    });
                                    if (_this.$store.getters.getTabpreList.length > 0) {
                                        if (param) {
                                            _this.codtabpre = param;
                                        }
                                        if (!_this.codtabpre) {
                                            _this.codtabpre = _this.$store.getters.getTabpreList[0].codtabpre;
                                        }
                                    }
                                }

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        textST: function textST(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["getText"])(value, this.metadata.tabpre.sttabpre);
        },
        loadData: function loadData() {
            this.$store.dispatch('loadTabpre', { filter: this.filter });
            this.offset = '';
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], TabpreForm: __WEBPACK_IMPORTED_MODULE_1__tabpre_form__["a" /* default */], TabpreItensForm: __WEBPACK_IMPORTED_MODULE_2__tabpre_itens_form__["a" /* default */]
    },

    created: function created() {
        this.loadTabelas();
    }
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_input_typeahead__ = __webpack_require__(88);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    components: {
        InputTypeahead: __WEBPACK_IMPORTED_MODULE_2__components_input_typeahead__["default"]
    },

    data: function data() {
        return {
            crudText: '',
            tabpre: _extends({}, this.$store.getters.getEntities.tabpre),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
            tabpreit: []
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }
    },

    watch: {},

    methods: {
        closeForm: function closeForm(cod) {
            if (cod) {
                this.$emit('closeform', this.tabpre.codtabpre);
            } else {
                this.$emit('closeform');
            }
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            this.apiDelete();
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadTabpre', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getTabpre) {
                                    _this2.tabpre = _extends({}, _this2.$store.getters.getTabpre);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/tabpre/' + _this3.tabpre.codtabpre;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm(false);

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao
                                modulo = 'cg/tabpre/';

                                _this4.tabpre.tabpreit = _this4.tabpreit;
                                sendData = { tabpre: _this4.tabpre };
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    update = true;
                                }

                                _context3.next = 7;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, 'post');

                            case 7:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.tabpre = data.items[0];
                                    if (update) _this4.closeForm(false);else _this4.closeForm(true);
                                }

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.descricao.focus();
        });
    }
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabpre_add_form__ = __webpack_require__(1794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        tabpre: Object
    },

    data: function data() {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            tabelasList: [],
            isView: false,
            indexEditing: null,
            showInserirProduto: false
        };
    },


    computed: {
        possuiPermissao: function possuiPermissao() {
            if (__WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].usaIntegracao) {
                return false;
            }
            return __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].appNFe || __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].appERP || __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].appLoja || __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].usuarioAdministrador && __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].appForcaVendas;
        },

        tabpreItens: function tabpreItens() {
            return this.$store.getters.getTabpreItens;
        },

        tpTabela: function tpTabela() {
            return this.tabpre.tptabela;
        },

        permiteAlteracao: function permiteAlteracao() {
            return this.tabpre.tptabela == 'P';
        }
    },

    watch: {},

    methods: {
        isExist: function isExist(coditem) {
            for (var i = 0; i < this.tabpreItens.length; i++) {
                if (this.tabpreItens[i].coditem === coditem) {
                    return true;
                }
            }
            return false;
        },
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleAddItem: function handleAddItem() {
            if (!this.possuiPermissao) {
                this.$erpToastError('Usuário sem permissão.');
                return;
            }
            this.showInserirProduto = true;
        },
        handleEditItem: function handleEditItem(index) {
            if (!this.possuiPermissao) {
                this.$erpToastError('Usuário sem permissão.');
                return;
            }
            //HABILITA ITEM PARA ALTERÇÃO
            this.indexEditing = index;
            this.$nextTick(function () {
                this.$refs.vlr[0].focus();
            });
        },
        handleDeleteVariavel: function handleDeleteVariavel(index) {
            if (!this.possuiPermissao) {
                this.$erpToastError('Usuário sem permissão.');
                return;
            }
            this.apiDelete(index);
        },
        handleGravaAlteracaoItem: function handleGravaAlteracaoItem(index) {
            //GRAVA ITEM ALTERADO
            if (this.tabpreItens[index].vlr < 0) {
                this.$erpToastError('Valor não permitido');
                this.$refs.vlr.focus();
            }
            var itens = [];
            itens.push(this.tabpreItens[index]);
            this.apiItens(itens, true);
            this.indexEditing = null;
        },
        handleSalvarItens: function handleSalvarItens(itens) {

            var adicionados = [];
            var itensAdd = [];

            for (var i = 0; i < itens.length; i++) {
                if (this.isExist(itens[i].coditem)) {
                    adicionados.push(itens[i].codigo);
                } else {
                    itensAdd.push(itens[i]);
                }
            }

            if (adicionados.length > 0) {
                this.$erpToastError('Produtos existentes: ' + adicionados.join(", "));
            }

            if (itensAdd.length == 0) {
                return;
            } else {
                this.apiItens(itensAdd);
                this.$refs.addList.focus();
            }
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codigo":{"$eq":"' + value + '"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadTabpreItens', { id: this.tabpre.codtabpre, filter: this.filter });
            this.offset = '';
        },
        apiItens: function apiItens(itens, edtingProduto) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var modulo, sendData, update, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                modulo = 'cg/tabpre/produto/';
                                sendData = {
                                    tabpre: {
                                        codtabpre: _this.tabpre.codtabpre,
                                        tabpreit: itens
                                    }
                                };
                                update = false;

                                if (_this.crud != __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI) {
                                    update = true;
                                }
                                _context.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this.$store, modulo, sendData, 'post');

                            case 6:
                                data = _context.sent;

                                if (data.errmessages) {
                                    _this.errmessages = data.errmessages;
                                    _this.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    _this.errmessages = {};
                                }
                                if (!edtingProduto) {
                                    _this.loadData();
                                }

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        apiDelete: function apiDelete(index) {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/tabpre/produto/' + index;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSdelete"])(_this2.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this2.$erpToastDeleted();
                                _this2.loadData();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], TabpreAddForm: __WEBPACK_IMPORTED_MODULE_1__tabpre_add_form__["a" /* default */]
    },

    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['params'],

    data: function data() {
        return {
            searchString: '',
            inicio: true,
            noItems: true,
            showItems: false,
            errorMessage: '',
            error: false,
            localItemList: [],
            originalTop: 0,
            scrollY: 0,
            myStyle: {}
        };
    },

    computed: {

        itemList: function itemList() {
            return this.$store.getters.getItemSalesList;
        },

        metadata: function metadata() {
            return this.$store.getters.getEntities.metadata;
        },

        myDropDown: function myDropDown() {
            // console.log(this.$refs.pesquisa.getBoundingClientRect())
            var rect = this.$refs.pesquisa.getBoundingClientRect();
            // return 'top: ' + rect.top + 'px; left: ' + rect.left + 'px;'
            //return 'top: 764.297px; left: 235px;'
        }

    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(value, 4);
        }
    },

    methods: {
        scrollTop: function scrollTop() {},
        addItens: function addItens() {
            var selectedItems = [];
            this.error = false;
            for (var x = 0; x < this.localItemList.length; x++) {
                if (this.localItemList[x].vlr && this.localItemList[x].vlr != 0) {
                    var item = _extends({}, this.localItemList[x]);
                    selectedItems.push(item);
                }
            }
            if (!this.error) {
                this.handleEsc();
                this.$emit('additem', selectedItems);
            }
        },
        handleEsc: function handleEsc() {
            this.showItems = false;
            this.searchString = '';
            this.$refs.pesquisa.focus();
        },
        handleEnter: function handleEnter(index) {
            if (index + 1 == this.itemList.length) {
                this.addItens();
            }
        },
        focus: function focus() {
            this.$refs.pesquisa.focus();
        },
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleChange: function handleChange() {
            // console.log(this.searchString)
            if (!this.searchString) {
                this.showItems = false;
                return;
            }
        },
        search: function search() {
            //efetua a pesquisa por descricao ou por codigo
            this.inicio = false;

            if (!this.searchString) {
                this.showItems = false;
                return;
            }

            this.searchString = this.searchString.toUpperCase();
            this.filter = '{"descricao":{"$or":[{"$like":"%25' + this.searchString + '%25"},{"codigo":{"$eq":"' + this.searchString + '"}}]}}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadItemSales', { filter: this.filter });
        },
        existe: function existe(coditem) {
            //CHECA SE O ITEM JÁ FOI LANCADO NO PEDIDO
            if (this.params && this.params.pedvit) {
                var obj = this.params.itens.find(function (o) {
                    return o.coditem === coditem;
                });
                if (obj) {
                    return true;
                } else {
                    return false;
                }
            } else return false;
        }
    },

    watch: {

        itemList: function itemList() {
            if (this.inicio) {
                return;
            }
            if (!this.itemList.length) {
                this.noItems = true;
                this.showItems = false;
            } else {
                this.noItems = false;
                this.showItems = true;
                //JOGA O FOCO PARA O PRIMEIRO ITEM DA PESQUISA
                this.$nextTick(function () {
                    this.$refs.preco[0].focus();
                });
            }
            this.localItemList = [].concat(_toConsumableArray(this.itemList));
            var vm = this;
            jQuery.map(this.localItemList, function (value) {
                value.vlr = null;
                value.vlrmin = null;
                return value;
            });
        },

        scrollY: function scrollY() {
            //EFETUA O CONTROLE DA BARRA DE PESQUISA EM RELAÇÃO AO SCROLL DA TELA
            var rect = this.$el.getBoundingClientRect();
            var newTop = this.scrollY; // - this.originalTop;
            if (rect.top < -50) {
                this.$set(this.myStyle, 'top', 0);
                this.$set(this.myStyle, 'position', 'fixed');
                // this.$set(this.myStyle, 'width', '80%');
            } else {
                this.$delete(this.myStyle, 'top');
                this.$delete(this.myStyle, 'position');
                // this.$set(this.myStyle, 'min-width', '100%');
            }
        }
    },

    components: {},

    created: function created() {
        this.$store.dispatch('clearItemSales');

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
    },
    mounted: function mounted() {
        var _this = this;

        this.$refs.pesquisa.focus();

        // console.log(this.$el)

        this.originalTop = this.$el.getBoundingClientRect().top;

        window.addEventListener('scroll', function (event) {
            _this.scrollY = Math.round(window.scrollY);
            // console.log(this.scrollY)
        });
    }
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_destaq_list_vue__ = __webpack_require__(645);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_164fc055_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_destaq_list_vue__ = __webpack_require__(1806);
function injectStyle (ssrContext) {
  __webpack_require__(1800)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-164fc055"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_destaq_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_164fc055_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_destaq_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__destaq_form__ = __webpack_require__(1802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_anexos_form__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main__);
//
//
//


/*



VUEX -> STORE.JS -> this.$store




*/







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            destaq: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            showAnexosForm: false,
            coddestaq: '',
            descricao: ''
        };
    },


    computed: {
        destaqList: function destaqList() {
            return this.$store.getters.getDestaqList;
        },
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["formatValue"])(value, 2);
        }

    },

    methods: {
        getStatus: function getStatus(status) {
            if (status == '1') return 'Válida';else if (status == '3') return 'Vencida';else if (status == '2') return 'Não iniciada';
        },
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudU;
            this.coddestaq = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudI;
            this.coddestaq = '';
            this.showForm = true;
        },
        handleMore: function handleMore() {
            this.offset = 'offset=' + this.nextPage;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"coddestaq":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadDestaq', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        },
        handleAnexosForm: function handleAnexosForm(coddestaq, descricao) {
            this.coddestaq = coddestaq;
            this.descricao = descricao;
            this.showAnexosForm = true;
        },
        closeAnexosForm: function closeAnexosForm() {
            this.showAnexosForm = false;
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], DestaqForm: __WEBPACK_IMPORTED_MODULE_1__destaq_form__["a" /* default */], AnexosForm: __WEBPACK_IMPORTED_MODULE_2__components_anexos_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_varejo_varejo_add_item__ = __webpack_require__(119);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    components: {
        VarejoAddItem: __WEBPACK_IMPORTED_MODULE_2__forms_varejo_varejo_add_item__["a" /* default */]
    },

    data: function data() {
        return {
            crudText: '',
            destaq: _extends({}, this.$store.getters.getEntities.destaq),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
            destaqit: [],
            coditem: ''
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }
    },

    watch: {},

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.destaq.coddestaq);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            var valido = true;

            if (this.destaq.dtinicio > this.destaq.dttermino) {
                valido = false;
                this.$erpToastError('A data de término não pode ser maior que a data de início');
            }

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Corrija os erros de preenchimento para continuar!');
                } else if (valido) {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            this.apiDelete();
        },
        handleDeleteVariavel: function handleDeleteVariavel(index) {
            this.destaqit.splice(index, 1);
        },
        handleNewItem: function handleNewItem(selectedItem) {
            // Verifica se foi selecionado algum item
            if (!selectedItem) return;

            // Verifica se o item já não foi adicionado
            if (this.destaqit) {
                for (var i = 0; i < this.destaqit.length; i++) {
                    if (this.destaqit[i].coditem === selectedItem.coditem) {
                        return;
                    }
                }
            }

            var p = {
                coditem: selectedItem.coditem,
                coddestaq: '',
                coddestaqit: '',
                descricao: selectedItem.descricao
            };
            this.destaqit.push(p);
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadDestaq', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getDestaq) {
                                    _this2.destaq = _extends({}, _this2.$store.getters.getDestaq);
                                    // this.destaqit = JSON.parse(this.destaq.valores)
                                    _this2.destaqit = _this2.destaq.destaqit;
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/destaq/' + _this3.destaq.coddestaq;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/destaq/';

                                _this4.destaq.destaqit = _this4.destaqit;
                                sendData = { destaq: _this4.destaq };
                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
            this.destaq.stdestaq = 'A';
            this.destaq.dtinicio = this.$getDate();
        } else {
            this.loadData();
        }

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.descricao.focus();
        });
    }
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tabdes_list_vue__ = __webpack_require__(648);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_649e87df_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tabdes_list_vue__ = __webpack_require__(1813);
function injectStyle (ssrContext) {
  __webpack_require__(1807)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-649e87df"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tabdes_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_649e87df_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tabdes_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabdes_form__ = __webpack_require__(1809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            tabdes: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: ''
        };
    },


    computed: {
        tabdesList: function tabdesList() {
            return this.$store.getters.getTabdesList;
        },
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(value, 2);
        }

    },

    methods: {
        getStatus: function getStatus(status) {
            if (status == '1') return 'Válida';else if (status == '3') return 'Vencida';else if (status == '2') return 'Não iniciada';
        },
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.codtabdes = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codtabdes = '';
            this.showForm = true;
        },
        handleMore: function handleMore() {
            this.offset = 'offset=' + this.nextPage;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codtabdes":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadTabdes', { filter: this.filter, page: this.nextPage });
            console.log(this.tabdesList);
            this.offset = '';
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], TabdesForm: __WEBPACK_IMPORTED_MODULE_1__tabdes_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_input_typeahead__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_varejo_varejo_add_item__ = __webpack_require__(119);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    components: {
        InputTypeahead: __WEBPACK_IMPORTED_MODULE_2__components_input_typeahead__["default"], VarejoAddItem: __WEBPACK_IMPORTED_MODULE_3__forms_varejo_varejo_add_item__["a" /* default */]
    },

    data: function data() {
        return {
            crudText: '',
            tabdes: _extends({}, this.$store.getters.getEntities.tabdes),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
            tabdesit: [],
            coditem: ''
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    watch: {},

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.tabdes.codtabdes);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR

            var valido = true;

            if (this.tabdes.dtinicio > this.tabdes.dttermino) {
                valido = false;
                this.$erpToastError('A data de término não pode ser maior que a data de início');
            }

            if (valido) {
                this.$validator.validateAll().then(function (isValid) {
                    //this.tabdes.dtinicio > this.tabdes.dttermino
                    if (!isValid) {
                        _this.$erpToastError('Corrija os erros de preenchimento para continuar!');
                    } else {
                        _this.apiPost();
                    }
                });
            }
        },
        handleDelete: function handleDelete() {
            this.apiDelete();
        },
        handleDeleteVariavel: function handleDeleteVariavel(index) {
            this.tabdesit.splice(index, 1);
        },
        handleNewItem: function handleNewItem(selectedItem) {
            console.log("salvar");

            // Verifica se foi selecionado algum item
            if (!selectedItem) return;

            // Verifica se o item já não foi adicionado
            if (this.tabdesit) {
                for (var i = 0; i < this.tabdesit.length; i++) {
                    if (this.tabdesit[i].coditem === selectedItem.coditem) {
                        return;
                    }
                }
            }

            var p = {
                coditem: selectedItem.coditem,
                codtabdes: '',
                codtabdesit: '',
                descricao: selectedItem.descricao
            };
            this.tabdesit.push(p);
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadTabdes', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getTabdes) {
                                    _this2.tabdes = _extends({}, _this2.$store.getters.getTabdes);
                                    _this2.tabdesit = _this2.tabdes.tabdesit;
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/tabdes/' + _this3.tabdes.codtabdes;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/tabdes/';

                                _this4.tabdes.tabdesit = _this4.tabdesit;
                                sendData = { tabdes: _this4.tabdes };
                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    metodo = 'put';
                                    update = true;
                                }

                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
            this.tabdes.ativa = 'A';
            this.tabdes.dtinicio = this.$getDate();
        } else {
            this.loadData();
        }

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.descricao.focus();
        });
    }
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forms_pdtipo_list__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_pdstatus_list__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_regraimp_list__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_condicao_list__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_nates_list__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_unimed_list__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__forms_estado_list__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__forms_equipe_list__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__forms_regrafcp_list__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__forms_usuario_list__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__forms_filial_list__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__forms_filial_form__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__forms_catmkt_list__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__forms_catmkt_form__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__main__);



















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      activeTab: 0,
      isList: false
    };
  },


  components: {
    BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"],
    PdtipoList: __WEBPACK_IMPORTED_MODULE_1__forms_pdtipo_list__["a" /* default */],
    PdstatusList: __WEBPACK_IMPORTED_MODULE_2__forms_pdstatus_list__["a" /* default */],
    CondicaoList: __WEBPACK_IMPORTED_MODULE_4__forms_condicao_list__["a" /* default */],
    EquipeList: __WEBPACK_IMPORTED_MODULE_8__forms_equipe_list__["a" /* default */],
    RegraimpList: __WEBPACK_IMPORTED_MODULE_3__forms_regraimp_list__["default"],
    UsuarioList: __WEBPACK_IMPORTED_MODULE_10__forms_usuario_list__["default"],
    FilialList: __WEBPACK_IMPORTED_MODULE_11__forms_filial_list__["default"],
    FilialForm: __WEBPACK_IMPORTED_MODULE_12__forms_filial_form__["default"],
    NatesList: __WEBPACK_IMPORTED_MODULE_5__forms_nates_list__["default"],
    EstadoList: __WEBPACK_IMPORTED_MODULE_7__forms_estado_list__["default"],
    UnimedList: __WEBPACK_IMPORTED_MODULE_6__forms_unimed_list__["default"],
    RegrafcpList: __WEBPACK_IMPORTED_MODULE_9__forms_regrafcp_list__["default"],
    CatmktList: __WEBPACK_IMPORTED_MODULE_13__forms_catmkt_list__["default"],
    CatmktForm: __WEBPACK_IMPORTED_MODULE_14__forms_catmkt_form__["default"]
  },

  computed: {
    tabs: function tabs() {
      var tabs = [];
      if (!this.perfil_usuario_comum) {
        tabs = [{ title: "Dados da Empresa", icon: "fa-building" }, { title: "Usuários", icon: "fa-user-o" },
        // { title: 'Equipes de Venda', icon: 'fa-group' },
        // { title: 'Condições', icon: '' },
        // { title: 'Tipos de Pedido', icon: '' },
        { title: "Unidades", icon: "" }, { title: "Naturezas de Operação", icon: "" }, { title: "Estados", icon: "" }, { title: "Regras de Imposto", icon: "" }, { title: "Alíquotas de FCP", icon: "" }, { title: "Status de Pedido", icon: ""
          //{ title: 'Categorias Marketplace', icon: '' },
        }];
      } else {
        tabs = [{ title: "Usuários", icon: "fa-user-o" }];
      }
      return tabs;
    },

    tabEmpresa: function tabEmpresa() {
      return this.activeTab == 0 && !this.perfil_usuario_comum;
    },

    tabUsuarios: function tabUsuarios() {
      if (this.perfil_usuario_comum) return this.activeTab == 0;else return this.activeTab == 1;
    },

    tabEquipes: function tabEquipes() {
      return this.activeTab == 2;
    },

    tabCondicoes: function tabCondicoes() {
      return this.activeTab == 3;
    },

    tabStatus: function tabStatus() {
      return this.activeTab == 7;
    },

    tabTipos: function tabTipos() {
      return this.activeTab == 4;
    },

    tabRegras: function tabRegras() {
      return this.activeTab == 5;
    },

    tabNates: function tabNates() {
      return this.activeTab == 3;
    },

    tabFcp: function tabFcp() {
      return this.activeTab == 6;
    },

    tabUnimed: function tabUnimed() {
      return this.activeTab == 2;
    },

    tabEstado: function tabEstado() {
      return this.activeTab == 4;
    },

    tabCatmkt: function tabCatmkt() {
      return this.activeTab == 8;
    },

    perfil_usuario_comum: function perfil_usuario_comum() {
      return this.$store.getters.getSessao.perfil == "3";
    }
  },

  methods: {
    closeForm: function closeForm() {},
    changeTab: function changeTab(idx) {
      this.activeTab = idx;
    }
  },

  created: function created() {}
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pdtipo_list_vue__ = __webpack_require__(652);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ab28d3_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pdtipo_list_vue__ = __webpack_require__(1823);
function injectStyle (ssrContext) {
  __webpack_require__(1817)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09ab28d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pdtipo_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ab28d3_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pdtipo_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pdtipo_form__ = __webpack_require__(1819);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            pdtipo: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            currentTipo: {},
            codtipo: null
        };
    },


    computed: {
        pdtipoList: function pdtipoList() {
            return this.$store.getters.getPdtipoList;
        }
    },

    filters: {
        format: function format(value) {
            return formatValue(value, 2);
        }

    },

    methods: {
        handleEdit: function handleEdit(tipo) {
            //abre a tela de edicao
            this.currentTipo = tipo;
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudU;
            this.$set(tipo, 'show', true);
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudI;
            this.showForm = true;
        },
        closeForm: function closeForm() {
            this.currentTipo.show = false;
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codtipo":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadPdtipo', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        },
        handleDelete: function handleDelete(pdtipo) {
            //BOTAO Excluir
            this.apiDelete(pdtipo);
        },
        apiDelete: function apiDelete(pdtipo) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/pdtipo/' + pdtipo.codtipo;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this.$store, modulo);

                            case 3:
                                data = _context.sent;

                                _this.$erpToastDeleted();
                                _this.closeForm();

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], PdtipoForm: __WEBPACK_IMPORTED_MODULE_3__pdtipo_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            pdtipo: _extends({}, this.$store.getters.getEntities.pdtipo),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.pdtipo.codtipo);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadPdtipo', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getPdtipo) {
                                    _this2.pdtipo = _extends({}, _this2.$store.getters.getPdtipo);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiPost: function apiPost() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/pdtipo/';
                                sendData = {};


                                sendData = { pdtipo: _this3.pdtipo };

                                metodo = 'post';
                                update = false;

                                if (_this3.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    update = true;
                                }
                                _context2.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this3.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context2.sent;

                                if (data.errmessages) {
                                    _this3.errmessages = data.errmessages;
                                    _this3.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this3.$erpToastUpdated();
                                    } else {
                                        _this3.$erpToastInserted();
                                    }
                                    _this3.errmessages = {};
                                    _this3.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.descricao.focus();
        });
    }
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pdstatus_list_vue__ = __webpack_require__(655);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6790a97b_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pdstatus_list_vue__ = __webpack_require__(1830);
function injectStyle (ssrContext) {
  __webpack_require__(1824)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6790a97b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pdstatus_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6790a97b_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pdstatus_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pdstatus_form__ = __webpack_require__(1826);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            pdstatus: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            currentStatus: {},
            codstatus: null
        };
    },


    computed: {
        pdstatusList: function pdstatusList() {
            return this.$store.getters.getPdstatusList;
        }
    },

    filters: {
        format: function format(value) {
            return formatValue(value, 2);
        }

    },

    methods: {
        handleEdit: function handleEdit(status) {
            //abre a tela de edicao
            this.currentStatus = status;
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudU;
            this.$set(status, 'show', true);
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudI;
            this.showForm = true;
        },
        closeForm: function closeForm() {
            this.currentStatus.show = false;
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codstatus":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadPdstatus', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        },
        handleDelete: function handleDelete(pdstatus) {
            //BOTAO Excluir
            this.apiDelete(pdstatus);
        },
        apiDelete: function apiDelete(pdstatus) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/pdstatus/' + pdstatus.codstatus;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this.$store, modulo);

                            case 3:
                                data = _context.sent;

                                _this.$erpToastDeleted();
                                _this.closeForm();

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], PdstatusForm: __WEBPACK_IMPORTED_MODULE_3__pdstatus_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            pdstatus: _extends({}, this.$store.getters.getEntities.pdstatus),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.pdstatus.codstatus);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadPdstatus', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getPdstatus) {
                                    _this2.pdstatus = _extends({}, _this2.$store.getters.getPdstatus);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiPost: function apiPost() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/pdstatus/';
                                sendData = {};


                                sendData = { pdstatus: _this3.pdstatus };

                                metodo = 'post';
                                update = false;

                                if (_this3.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    update = true;
                                }
                                _context2.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this3.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context2.sent;

                                if (data.errmessages) {
                                    _this3.errmessages = data.errmessages;
                                    _this3.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this3.$erpToastUpdated();
                                    } else {
                                        _this3.$erpToastInserted();
                                    }
                                    _this3.errmessages = {};
                                    _this3.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.descricao.focus();
        });
    }
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_condicao_list_vue__ = __webpack_require__(658);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bcfa7f0_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_condicao_list_vue__ = __webpack_require__(1837);
function injectStyle (ssrContext) {
  __webpack_require__(1831)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bcfa7f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_condicao_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bcfa7f0_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_condicao_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__condicao_form__ = __webpack_require__(1833);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            condicao: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            currentCondicao: {},
            codcondicao: null
        };
    },


    computed: {
        condicaoList: function condicaoList() {
            return this.$store.getters.getCondicaoList;
        }
    },

    filters: {
        format: function format(value) {
            return formatValue(value, 2);
        }

    },

    methods: {
        handleEdit: function handleEdit(condicao) {
            //abre a tela de edicao
            this.currentCondicao = condicao;
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudU;
            this.$set(condicao, 'show', true);
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudI;
            this.showForm = true;
        },
        closeForm: function closeForm() {
            this.currentCondicao.show = false;
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codcondicao":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadCondicao', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        },
        handleDelete: function handleDelete(condicao) {
            //BOTAO Excluir
            this.apiDelete(condicao);
        },
        apiDelete: function apiDelete(condicao) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/condicao/' + condicao.codcondicao;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this.$store, modulo);

                            case 3:
                                data = _context.sent;

                                _this.$erpToastDeleted();
                                _this.closeForm();

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], CondicaoForm: __WEBPACK_IMPORTED_MODULE_3__condicao_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            condicao: _extends({}, this.$store.getters.getEntities.condicao),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.condicao.codcondicao);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadCondicao', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getCondicao) {
                                    _this2.condicao = _extends({}, _this2.$store.getters.getCondicao);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiPost: function apiPost() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/condicao/';
                                sendData = {};


                                sendData = { condicao: _this3.condicao };

                                metodo = 'post';
                                update = false;

                                if (_this3.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    update = true;
                                }
                                _context2.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this3.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context2.sent;

                                if (data.errmessages) {
                                    _this3.errmessages = data.errmessages;
                                    _this3.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this3.$erpToastUpdated();
                                    } else {
                                        _this3.$erpToastInserted();
                                    }
                                    _this3.errmessages = {};
                                    _this3.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.descricao.focus();
        });
    }
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_equipe_list_vue__ = __webpack_require__(661);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6561127e_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_equipe_list_vue__ = __webpack_require__(1844);
function injectStyle (ssrContext) {
  __webpack_require__(1838)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6561127e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_equipe_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6561127e_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_equipe_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equipe_form__ = __webpack_require__(1840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            equipe: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: ''
        };
    },


    computed: {
        equipeList: function equipeList() {
            return this.$store.getters.getEquipeList;
        }
    },

    methods: {
        usuariosEquipe: function usuariosEquipe(jsonUsuarios) {
            if (!jsonUsuarios) {
                return '';
            }

            var arr = JSON.parse(jsonUsuarios);
            var result = '';

            if (arr && arr.usuarios) for (var x = 0; x < arr.usuarios.length; x++) {
                if (result !== '') {
                    result = result + ', ';
                }
                result = result + arr.usuarios[x];
            }
            return result;
        },
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.codequipe = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codequipe = '';
            this.showForm = true;
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codequipe":{"$like":"%25' + value + '%25"}},{"nome":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadEquipe', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], EquipeForm: __WEBPACK_IMPORTED_MODULE_1__equipe_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    components: {},

    data: function data() {
        return {
            crudText: '',
            equipe: _extends({}, this.$store.getters.getEntities.equipe),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
            equipeit: [],
            codusuario: '',
            usuario: null
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }
    },

    watch: {
        codusuario: function codusuario() {
            if (this.codusuario) {
                this.handleNewUsuario();
            }
        }
    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.equipe.codequipe);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            var valido = true;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Corrija os erros de preenchimento para continuar!');
                } else if (valido) {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            this.apiDelete();
        },
        handleDeleteUsuario: function handleDeleteUsuario(index) {
            this.equipeit.splice(index, 1);
        },
        handleDefineResponsavel: function handleDefineResponsavel(index) {
            this.equipeit[index].responsavel = 'S';
        },
        handleRemoveResponsavel: function handleRemoveResponsavel(index) {
            this.equipeit[index].responsavel = 'N';
        },
        handleNewUsuario: function handleNewUsuario() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var i, p;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this2.equipeit) {
                                    _context.next = 8;
                                    break;
                                }

                                i = 0;

                            case 2:
                                if (!(i < _this2.equipeit.length)) {
                                    _context.next = 8;
                                    break;
                                }

                                if (!(_this2.equipeit[i].codusuario === _this2.codusuario)) {
                                    _context.next = 5;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 5:
                                i++;
                                _context.next = 2;
                                break;

                            case 8:
                                _context.next = 10;
                                return _this2.$store.dispatch('loadUsuario', { id: _this2.codusuario });

                            case 10:
                                if (_this2.$store.getters.getUsuario) {
                                    _this2.usuario = _extends({}, _this2.$store.getters.getUsuario);
                                }

                                p = {
                                    codusuario: _this2.codusuario,
                                    codequipe: _this2.equipe.codequipe,
                                    codequipeit: null,
                                    responsavel: 'N',
                                    nome: _this2.usuario.nome
                                };


                                _this2.equipeit.push(p);
                                _this2.codusuario = null;

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        loadData: function loadData() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this3.$store.dispatch('loadEquipe', { id: _this3.index });

                            case 2:
                                if (_this3.$store.getters.getEquipe) {
                                    _this3.equipe = _extends({}, _this3.$store.getters.getEquipe);
                                    _this3.equipeit = _this3.equipe.equipeit;
                                }
                                _this3.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/equipe/' + _this4.equipe.codequipe;
                                _context3.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this4.$store, modulo);

                            case 3:
                                data = _context3.sent;

                                _this4.$erpToastDeleted();
                                _this4.closeForm();

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        apiPost: function apiPost() {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/equipe/';

                                _this5.equipe.equipeit = _this5.equipeit;
                                sendData = { equipe: _this5.equipe };
                                metodo = 'post';
                                update = false;

                                if (_this5.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    update = true;
                                }

                                _context4.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this5.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context4.sent;

                                if (data.errmessages) {
                                    _this5.errmessages = data.errmessages;
                                    _this5.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this5.$erpToastUpdated();
                                    } else {
                                        _this5.$erpToastInserted();
                                    }
                                    _this5.errmessages = {};
                                    _this5.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        }
    },

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.nome.focus();
        });
    }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_catmkt_list_vue__ = __webpack_require__(664);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_131078d6_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_catmkt_list_vue__ = __webpack_require__(1850);
function injectStyle (ssrContext) {
  __webpack_require__(1845)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_catmkt_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_131078d6_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_catmkt_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmkt_form__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            catmkt: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: ''
        };
    },


    computed: {
        catmktList: function catmktList() {
            return this.$store.getters.getCatmktList;
        },
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(value, 2);
        }

    },

    methods: {
        handleEdit: function handleEdit(cod) {
            //abre a tela de edicao            
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
            this.codcatmkt = cod;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codcatmkt = '';
            this.showForm = true;
        },
        handleMore: function handleMore() {
            this.offset = 'offset=' + this.nextPage;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codcatmkt":{"$like":"%25' + value + '%25"}},{"nome":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadCatmkt', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], CatmktForm: __WEBPACK_IMPORTED_MODULE_1__catmkt_form__["default"]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            catmkt: _extends({}, this.$store.getters.getEntities.catmkt),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform', this.catmkt.codcatmkt);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        handleDelete: function handleDelete() {
            //BOTAO Excluir
            this.apiDelete();
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadCatmkt', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getCatmkt) {
                                    _this2.catmkt = _extends({}, _this2.$store.getters.getCatmkt);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a exclusao
                                modulo = 'cg/catmkt/' + _this3.catmkt.codcatmkt;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'cg/catmkt/';
                                sendData = {};


                                sendData = { catmkt: _this4.catmkt };

                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                                    update = true;
                                }

                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 8:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.closeForm();
                                }

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {

        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
            this.catmkt.stcatmkt = 'A';
        } else {
            this.loadData();
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.altern.focus();
        });
    }
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__financeiro_form__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus_lock__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_focus_lock__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    codpedv: '',
    codnf: ''
  },
  components: {
    FinanceiroForm: __WEBPACK_IMPORTED_MODULE_3__financeiro_form__["a" /* default */], Trap: __WEBPACK_IMPORTED_MODULE_4_vue_focus_lock___default.a
  },
  data: function data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      actions: [{ action: 1, label: 'Configurar Cobranças' }],

      codcta: null,
      codnatfin: null,

      showForm: false,
      codfin: "",
      tipofin: null,

      showDetalhesRetorno: false,
      dadosRetorno: {},

      contaSelecionada: null,

      showModalErros: false,
      titulos: [],

      codCtaTitulosAberto: null,

      confirmaExcluirCobranca: false,
      messageExcluir: "Os títulos selecionados serão cancelados da cobrança bancária. Confirma o cancelamento?",
      titleExcluir: "Cancelar Cobrança",

      authcode: null,
      BankingList: null,

      errmessages: null,

      showSuccess: false,

      filtro: {
        codpart: null,
        periodoVencimento: { startDate: null, endDate: null },
        periodoEmissao: { startDate: null, endDate: null },
        doc: ''
      }
    };
  },


  computed: {
    contasconfiguradas: function contasconfiguradas() {
      if (this.BankingList && this.BankingList.contas) return this.BankingList.contas;else return 0;
    },
    contasList: function contasList() {
      if (this.BankingList && this.BankingList.contas) return this.BankingList.contas;else return [];
    },
    titulosList: function titulosList() {
      if (this.BankingList && this.BankingList.titulos) return this.BankingList.titulos;else return [];
    },

    hasTitulosParaEnviar: function hasTitulosParaEnviar() {
      if (this.BankingList && this.BankingList.titulos) return this.BankingList.titulos.some(function (item) {
        return item.enviarcobranca === true;
      });
      return false;
    },

    hasTitulosParaCancelar: function hasTitulosParaCancelar() {
      if (this.BankingList && this.BankingList.titulos) return this.BankingList.titulos.some(function (item) {
        return item.cancelarcobranca === true;
      });
      return false;
    },

    metadataCodnatfin: function metadataCodnatfin() {
      var meta = _extends({}, this.metadata.fin.codnatfin);
      meta.select2.entity = 'natfin/receitas';
      return meta;
    },

    habiltaEnviarCobranca: function habiltaEnviarCobranca() {
      return this.hasTitulosParaEnviar;
    },

    habiltaCancelarCobranca: function habiltaCancelarCobranca() {
      return this.hasTitulosParaCancelar;
    },

    showAccountSelection: function showAccountSelection() {
      return this.habiltaEnviarCobranca || this.habiltaCancelarCobranca;
    },

    contaSelecionada: function contaSelecionada() {
      var _this = this;

      if (this.BankingList && this.BankingList.contas) {
        return this.BankingList.contas.find(function (c) {
          return c.codcta == _this.codcta;
        });
      }
      return null;
    },

    labelBotaoEnviar: function labelBotaoEnviar() {
      if (this.contaSelecionada && this.contaSelecionada.cobrancaconfigurada === 'N') {
        return 'Gerar Boleto (Offline)';
      }
      return 'Emitir Cobrança';
    },

    isFiltrado: function isFiltrado() {
      return !!(this.codpedv || this.codnf || this.$route.query.codpedv || this.$route.query.codnf);
    },

    isSelectAll: {
      get: function get() {
        var list = this.titulosList.filter(function (t) {
          return t.enviarcobranca || !t.enviarcobranca && !t.cancelarcobranca || t.cancelarcobranca;
        });
        return list.length > 0 && list.every(function (t) {
          return t.enviarcobranca || t.cancelarcobranca;
        });
      },
      set: function set(value) {
        this.titulosList.forEach(function (t) {
          if (t.enviarcobranca || !t.enviarcobranca && !t.cancelarcobranca) {
            t.enviarcobranca = value;
          } else if (t.cancelarcobranca) {
            t.cancelarcobranca = value;
          }
        });
      }
    }

  },

  methods: {
    handleButtonMoreActions: function handleButtonMoreActions(action) {
      if (action == 1) {
        this.$router.push('cobranca-config');
      }
    },
    handleEdit: function handleEdit(fin) {
      //abre a tela de edicao
      this.$modalForm(true);
      this.crud = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
      this.codfin = fin.codfin;
      this.tipofin = 'R';
      this.showForm = true;
    },
    closeEdit: function closeEdit() {
      this.showForm = false;
      this.$modalForm(false);
      this.loadData();
    },
    handleEnviarCobranca: function handleEnviarCobranca() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var listaCodigos, payload, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.codcta) {
                  _context.next = 3;
                  break;
                }

                _this2.$erpToastError("Selecione a conta bancária para emissão");
                return _context.abrupt("return");

              case 3:
                listaCodigos = _this2.BankingList.titulos.filter(function (t) {
                  return t.enviarcobranca === true;
                }).map(function (t) {
                  return t.codfin;
                });
                payload = {
                  cobranca: {
                    authorization_code: _this2.authcode,
                    codcta: _this2.codcta,
                    codnatfin: _this2.codnatfin,
                    list: listaCodigos
                  }
                };


                _this2.errmessages = null;
                _context.next = 8;
                return _this2.servicoCobranca(payload);

              case 8:
                response = _context.sent;

                if (response && response.errmessages) {
                  console.log(response);
                  _this2.errmessages = response.errmessages;
                  _this2.$erpToastError("Erro ao enviar cobranças");
                }
                if (response && response.status === 'OK') {
                  _this2.showSuccess = true;
                }
                _this2.loadData();

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleDownloadBoleto: function handleDownloadBoleto(item) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var payload, response, base64, pdfBytes, blob, url, link, docLabel;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.errmessages = null;

                payload = {
                  cobranca: {
                    authorization_code: _this3.authcode,
                    codcta: _this3.codcta,
                    codfin: item.codfin,
                    boleto: true
                  }
                };
                _context2.next = 4;
                return _this3.servicoCobranca(payload);

              case 4:
                response = _context2.sent;

                if (!(response && response.errmessages)) {
                  _context2.next = 9;
                  break;
                }

                _this3.errmessages = response.errmessages;
                _this3.$erpToastError("Erro ao baixar boleto em PDF");
                return _context2.abrupt("return");

              case 9:

                try {
                  base64 = response;
                  pdfBytes = Uint8Array.from(atob(base64), function (c) {
                    return c.charCodeAt(0);
                  });
                  blob = new Blob([pdfBytes], { type: "application/pdf" });
                  url = window.URL.createObjectURL(blob);
                  link = document.createElement("a");

                  link.href = url;

                  docLabel = item.doc || "boleto";

                  link.download = docLabel + ".pdf";

                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(url);
                } catch (err) {
                  console.error("Erro ao exibir boleto PDF:", err);
                  _this3.$erpToastError("Erro ao exibir boleto em PDF.");
                }

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    servicoCobranca: function servicoCobranca(payload) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.showSuccess = false;
                _context3.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this4.$store, "fin/enviacobranca/", payload, "post");

              case 3:
                response = _context3.sent;

                if (!(response && response.status === 'AUTHCODE')) {
                  _context3.next = 10;
                  break;
                }

                sessionStorage.setItem('urlRetornoConsentimento', _this4.$route.fullPath);
                window.location.href = response.url;
                return _context3.abrupt("return", null);

              case 10:
                _this4.authcode = null;

              case 11:
                return _context3.abrupt("return", response);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    handleCloseMessage: function handleCloseMessage() {
      this.confirmaExcluirCobranca = false;
    },
    handleConfirmaExcluirCobranca: function handleConfirmaExcluirCobranca() {
      this.confirmaExcluirCobranca = true;
    },
    handleExcluirCobranca: function handleExcluirCobranca() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var listaCodigos, payload, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.confirmaExcluirCobranca = false;

                _this5.errmessages = null;

                listaCodigos = _this5.BankingList.titulos.filter(function (t) {
                  return t.cancelarcobranca === true;
                }).map(function (t) {
                  return t.codfin;
                });
                payload = {
                  cobranca: {
                    authorization_code: _this5.authcode,
                    list: listaCodigos,
                    delete: true
                  }
                };
                _context4.next = 6;
                return _this5.servicoCobranca(payload);

              case 6:
                response = _context4.sent;

                if (!(response && response.errmessages)) {
                  _context4.next = 13;
                  break;
                }

                _this5.errmessages = response.errmessages;
                _this5.$erpToastError("Erro ao cancelar cobrança");
                return _context4.abrupt("return");

              case 13:
                _this5.$erpToastSuccess("A cobrança foi cancelada com sucesso!");
                _this5.loadData();

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    handleConfigurarConta: function handleConfigurarConta() {
      this.$router.push("/cobranca-config");
    },
    closeModalErros: function closeModalErros() {
      this.showModalErros = false;
    },
    loadData: function loadData() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var vCodpedv, vCodnf, q, data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                vCodpedv = _this6.codpedv || _this6.$route.query.codpedv;
                vCodnf = _this6.codnf || _this6.$route.query.codnf;
                q = vCodpedv ? "?codpedv=" + vCodpedv : vCodnf ? "?codnf=" + vCodnf : '?';


                if (_this6.filtro.codpart) q += "&codpart=" + _this6.filtro.codpart;
                if (_this6.filtro.doc) q += "&doc=" + _this6.filtro.doc;
                if (_this6.filtro.periodoVencimento.startDate) q += "&dtv_ini=" + _this6.filtro.periodoVencimento.startDate;
                if (_this6.filtro.periodoVencimento.endDate) q += "&dtv_fim=" + _this6.filtro.periodoVencimento.endDate;
                if (_this6.filtro.periodoEmissao.startDate) q += "&dte_ini=" + _this6.filtro.periodoEmissao.startDate;
                if (_this6.filtro.periodoEmissao.endDate) q += "&dte_fim=" + _this6.filtro.periodoEmissao.endDate;

                _this6.BankingList = null;
                _this6.codcta = null;
                _this6.codnatfin = null;
                _context5.next = 14;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDS"])(Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["urlORDS"])(_this6.$store, "fin/enviacobranca/" + q));

              case 14:
                data = _context5.sent;

                if (data) {
                  _this6.BankingList = data;
                  _this6.codcta = data.codcta;
                  _this6.codnatfin = data.codnatfin;
                }

                _this6.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    handleClose: function handleClose() {
      if (this.$listeners.close) {
        this.$emit('close');
      } else {
        this.$router.back();
      }
    },
    handleConsentimento: function handleConsentimento() {
      //trata o codigo recebido na url quando efetuado o consentimento do usuario
      var _$route$query = this.$route.query,
          code = _$route$query.code,
          iss = _$route$query.iss;

      this.authcode = code;
    }
  },

  created: function created() {
    this.loadData();

    this.handleConsentimento();
  }
});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus_lock__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_focus_lock__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Trap: __WEBPACK_IMPORTED_MODULE_3_vue_focus_lock___default.a
  },
  data: function data() {
    return {
      showForm: false,
      metadata: this.$store.getters.getEntities.metadata,
      ctaValidate: null,

      contasConfiguradas: [],
      contasExistentes: [],
      listBancos: [],

      cta: null,
      codCtaEditing: null,
      editing: false
    };
  },


  computed: {},

  methods: {
    handleCloseEditing: function handleCloseEditing() {
      this.editing = false;
      this.codCtaEditing = null;
      this.showForm = false;
    },
    handleNovoBanco: function handleNovoBanco(item, isCta) {
      this.codCtaEditing = isCta ? item.codcta : null;
      this.editing = false;

      if (isCta) {
        // Carrega dados de uma conta que ja existe na tabela CTA
        this.cta = {
          codcta: item.codcta,
          descricao: item.descricao,
          banco: item.banco,
          agencia: item.agencia,
          conta: item.conta,
          digito: item.digito,
          convenio: null,
          nrinscricao: null,
          clientid: null,
          clientsecret: null,
          negativacliente: 'N',
          tipocobranca: 'B',
          pmora: null,
          pmulta: null,
          codfil: item.codfil
        };
      } else {
        // Criando do zero para um banco sem conta
        this.cta = {
          codcta: null,
          descricao: null,
          banco: item.banco,
          agencia: null,
          conta: null,
          digito: null,
          convenio: null,
          nrinscricao: null,
          clientid: null,
          clientsecret: null,
          negativacliente: 'N',
          tipocobranca: 'B',
          pmora: null,
          pmulta: null,
          codfil: null
        };
      }

      this.setCtaValidate(item.banco);
      this.showForm = true;
    },
    handleEdit: function handleEdit(cta) {
      this.cta = JSON.parse(JSON.stringify(cta));
      this.codCtaEditing = this.cta.codcta;
      this.setCtaValidate(cta.banco);
      this.editing = true;
      this.showForm = true;
    },
    handleSave: function handleSave() {
      var _this = this;

      //BOTAO SALVAR
      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          _this.handlePost();
        }
      });
    },
    handlePost: function handlePost() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, payload, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["urlORDS"])(_this2.$store, 'fin/configuracobranca/');
                payload = {
                  cobranca: _this2.cta
                };
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, payload);

              case 5:
                response = _context.sent;

                _this2.$erpToastSuccess("Configuração gravada com sucesso");
                _this2.handleCloseEditing();
                _this2.loadData();
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](2);

                console.error("Erro ao configurar enviacobranca:", _context.t0);
                _this2.$erpToastError("Erro ao configurar cobranca: " + _context.t0);
                return _context.abrupt("return");

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[2, 11]]);
      }))();
    },
    setCtaValidate: function setCtaValidate(bancoId) {
      var defaultValidate = {
        agencia: { validate: 'required|max:4', exibe: true },
        conta: { validate: 'required|max:10', exibe: true },
        digitoagencia: { validate: 'max:1', exibe: false },
        nrinscricao: { validate: 'max:15', exibe: false },
        convenio: { validate: 'max:10', exibe: false },
        clientid: { validate: 'max:100', exibe: false },
        clientsecret: { validate: 'max:100', exibe: false }
      };

      if (bancoId == '208') {
        this.ctaValidate = _extends({}, defaultValidate, {
          nrinscricao: { exibe: true, validate: 'max:20' },
          convenio: { exibe: true, validate: 'required|max:20' },
          clientid: { exibe: true, validate: 'required|min:1|max:50' },
          clientsecret: { exibe: true, validate: 'required|min:1|max:255' },
          conta: { exibe: true, validate: 'required|max:10' }
        });
      } else if (bancoId == '033') {
        this.ctaValidate = _extends({}, defaultValidate, {
          nrinscricao: { validate: 'required|max:15', exibe: true },
          clientid: { validate: 'required|max:100', exibe: true },
          clientsecret: { validate: 'required|max:100', exibe: true }
        });
      } else if (bancoId == '001') {
        this.ctaValidate = _extends({}, defaultValidate, {
          convenio: { validate: 'required|max:10', exibe: true },
          clientid: { validate: 'required|max:100', exibe: true },
          clientsecret: { validate: 'required|max:100', exibe: true }
        });
      } else if (bancoId == '341') {
        this.ctaValidate = _extends({}, defaultValidate, {
          clientid: { validate: 'required|max:100', exibe: true },
          clientsecret: { validate: 'required|max:100', exibe: true }
        });
      } else {
        this.ctaValidate = defaultValidate;
      }
    },
    loadData: function loadData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var url, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["urlORDS"])(_this3.$store, 'fin/configuracobranca/');
                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url);

              case 4:
                response = _context2.sent;

                _this3.contasConfiguradas = response.data.contasConfiguradas || [];
                _this3.contasExistentes = response.data.contasExistentes || [];
                _this3.listBancos = response.data.bancosSemConta || [];
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](1);

                _this3.$erpToastError("Erro lista cobranca: " + _context2.t0);
                return _context2.abrupt("return");

              case 14:

                _this3.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 10]]);
      }))();
    }
  },

  created: function created() {
    this.loadData();
  }
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__agenda_form__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_csvReport__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_csvReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__main__);
//









/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao de nota de saida
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            filter: '',
            urlFilterMonth: '',
            metadata: this.$store.getters.getEntities.metadata,

            codagenda: null,
            tpAgenda: null,
            codusuario: null,

            showConcluidas: false,

            monthFilter: {}
        };
    },


    computed: {
        agendaList: function agendaList() {
            return this.$store.getters.getAgendaList;
        },

        perfil_usuario_comum: function perfil_usuario_comum() {
            return this.$store.getters.getSessao.perfil == '3';
        },

        usuarioList: function usuarioList() {
            //lista de usuarios para selecao
            var options = [];
            for (var x = 0; x < this.$store.getters.getUsuarioList.length; x++) {
                options.push({ id: this.$store.getters.getUsuarioList[x].codusuario, text: this.$store.getters.getUsuarioList[x].nome });
            }
            return options;
        }

    },

    watch: {
        codusuario: function codusuario() {
            this.loadData();
        },

        showConcluidas: function showConcluidas() {
            this.loadData();
        }

    },

    methods: {
        handleMonthChange: function handleMonthChange() {
            this.urlFilterMonth = '{"dataagendada":{"$between":[{"$date":"' + Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["apiDateORDS"])(this.monthFilter.startDate) + '"},{"$date":"' + Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["apiDateORDS"])(this.monthFilter.endDate, true) + '"}]}}';
            this.loadData();
        },
        handleEdit: function handleEdit(codagenda) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_6__main__["SysVars"].crudU; //operacao de edicao
            this.codagenda = codagenda;
            this.showForm = true; //exibe o form de manutencao
        },
        handleNew: function handleNew() {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_6__main__["SysVars"].crudI; //operacao de inclusao
            this.codagenda = null;
            this.showForm = true; //exibe o form de manutencao
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.showFormImportXML = false;
            this.loadData();
        },
        handleShowPainelCliente: function handleShowPainelCliente(codpart) {
            this.$router.push('/fv/clientes/painel/' + codpart);
        },
        handleSearch: function handleSearch(value) {
            //efetua a pesquisa
            if (!value) this.filter = '';else this.filter = '{"$or":[{"nome":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            var filter = this.filter;
            if (this.urlFilterMonth) {
                if (filter) filter = filter + ',';
                filter = filter + this.urlFilterMonth;
            }

            if (filter) filter = filter + ',';
            if (this.showConcluidas) filter = filter + '{"$or":[{"concluida":{"$eq":"S"}},{"concluida":{"$eq":"N"}}]}';else filter = filter + '{"$and":[{"concluida":{"$eq":"N"}}]}';

            if (this.codusuario) {
                if (filter) filter = filter + ',';
                filter = filter + '{"$and":[{"codusuario":{"$eq":"' + this.codusuario + '"}}]}';
            }

            if (filter) filter = '{"$and":[' + filter + ']}';

            this.$store.dispatch('loadAgenda', { filter: filter });

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
            });
        }
    },

    filters: {
        format: function format(value) {
            return formatValue(value, 2);
        }

    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], AgendaForm: __WEBPACK_IMPORTED_MODULE_2__agenda_form__["a" /* default */]
    },

    created: function created() {
        //CARREGA LISTA DE USUARIOS
        this.$store.dispatch('loadUsuariosDashboard', this);

        this.loadData();
    }
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: '',
        params: {}
    },

    components: {},

    data: function data() {
        return {
            errmessages: null,
            error: false,
            agenda: _extends({}, this.$store.getters.getEntities.agenda),
            metadata: this.$store.getters.getEntities.metadata,
            isView: false,
            modalDelete: false,
            buttonDelete: false,
            habilitaPartricipante: true,

            negocio: null,
            pessoa: null,
            organizacao: null,
            lead: null,

            inputOrg: {
                url: '/crm/find/organizacao?nome=',
                permite_novo: false,
                codigo: null,
                icon: 'fa-university'
                // label: 'Organização',
                // placeholder: 'Nome da Organização',
            },

            inputPessoa: {
                url: '/crm/find/pessoa?nome=',
                permite_novo: false,
                codigo: null,
                icon: 'fa-user'
            },

            inputNegocio: {
                url: '/crm/find/negocio?titulo=',
                permite_novo: false,
                codigo: null,
                icon: 'fa-dollar'
            }

        };
    },


    computed: {
        administrador: function administrador() {
            return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].usuarioAdministrador;
        },

        usuarioList: function usuarioList() {
            //lista de usuarios para selecao
            var options = [];
            for (var x = 0; x < this.$store.getters.getUsuarioList.length; x++) {
                options.push({ id: this.$store.getters.getUsuarioList[x].codusuario, text: this.$store.getters.getUsuarioList[x].nome });
            }
            return options;
        },

        title: function title() {
            if (this.crud == __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI) return 'Incluindo Agenda';else if (this.crud == __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI) return 'Alterando Agenda';else return 'Agenda';
        }
    },

    methods: {
        handleSalvar: function handleSalvar() {
            var _this = this;

            if (!this.$refs.convidados.isValid) {
                this.$erpToastError('Endereço de e-mail inválido no campo de convidados');
                return;
            }

            this.agenda.convidados = this.$refs.convidados.emailList;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Corrija os erros de preenchimento para continuar!');
                } else _this.apiPost();
            });
        },
        closeForm: function closeForm(agenda) {
            this.$emit('closeform', agenda);
        },
        handleSelectPessoa: function handleSelectPessoa(selected) {
            this.pessoa = selected;
            if (this.pessoa && this.pessoa.codorg) {
                this.agenda.codorg = this.pessoa.codorg;
                this.organizacao = { codorg: this.pessoa.codorg, nome: this.pessoa.nome_org };
                this.$refs.organizacao.setValue(this.organizacao.codorg, this.organizacao.nome, this.organizacao);
            }
        },
        setFieldsLoadData: function setFieldsLoadData() {
            this.negocio = null;
            this.organizacao = null;
            this.pessoa = null;
            this.lead = null;
            if (this.agenda.negocio && this.agenda.negocio.length > 0) {
                this.negocio = this.agenda.negocio[0];
            } else if (this.params && this.params.negocio) {
                this.negocio = this.params.negocio;
                this.agenda.codnegocio = this.params.negocio.codnegocio;
            }
            if (this.agenda.organizacao && this.agenda.organizacao.length > 0) {
                this.organizacao = this.agenda.organizacao[0];
            } else if (this.params && this.params.organizacao) {
                this.organizacao = this.params.organizacao;
                this.agenda.codorg = this.params.organizacao.codorg;
            }
            if (this.agenda.pessoa && this.agenda.pessoa.length > 0) {
                this.pessoa = this.agenda.pessoa[0];
            } else if (this.params && this.params.pessoa) {
                this.pessoa = this.params.pessoa;
                this.agenda.codpessoa = this.params.pessoa.codpessoa;
            }

            if (this.params && this.params.lead) {
                this.agenda.codlead = this.params.lead.codlead;
                this.lead = this.params.lead;
            } else if (this.agenda.negocio && this.agenda.lead.length > 0) {
                this.lead = this.agenda.lead[0];
            }

            //desabilitado por conta da mudança do campo para de input-search para SELECT2
            // if (this.organizacao)
            //   this.$refs.organizacao.setValue (this.organizacao.codorg, this.organizacao.nome, this.organizacao)
            // if (this.pessoa)
            //   this.$refs.pessoa.setValue (this.pessoa.codpessoa, this.pessoa.nome, this.pessoa)

            // this.$refs.negocio.setValue (this.negocio.codnegocio, this.negocio.titulo, this.negocio.codnegocio)
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadAgenda', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getAgenda) {
                                    _this2.agenda = _extends({}, _this2.$store.getters.getAgenda);

                                    if (_this2.agenda.convidados) _this2.agenda.convidados = JSON.parse(_this2.agenda.convidados);

                                    _this2.setFieldsLoadData();
                                }

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                modulo = 'cg/agenda/' + _this3.agenda.codagenda;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSdelete"])(_this3.$store, modulo);

                            case 3:
                                data = _context2.sent;

                                _this3.$erpToastDeleted();
                                _this3.closeForm();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        apiPost: function apiPost() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                modulo = 'cg/agenda/';
                                sendData = { agenda: _this4.agenda };
                                metodo = 'post';
                                update = false;

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI) {
                                    update = true;
                                }

                                _context3.next = 7;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this4.$store, modulo, sendData, metodo);

                            case 7:
                                data = _context3.sent;

                                if (data.errmessages) {
                                    _this4.errmessages = data.errmessages;
                                    _this4.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this4.$erpToastUpdated();
                                    } else {
                                        _this4.$erpToastInserted();
                                    }
                                    _this4.errmessages = {};
                                    _this4.closeForm(data.items[0]);
                                }

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        closeModal: function closeModal() {
            this.modalDelete = false;
        }
    },

    watch: {},

    mounted: function mounted() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            if (this.$refs.usuario) {
                this.$refs.usuario.focus();
                //deve executar apos o form montado
                this.setFieldsLoadData();
            }
        });
    },
    created: function created() {
        this.$store.dispatch('loadUsuariosDashboard', this);

        //desabilita o campo de participante
        if (this.params && (this.params.negocio || this.params.lead || this.params.pessoa || this.params.organizacao)) this.habilitaPartricipante = false;

        if (this.crud == __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI) {
            this.agenda.dataagendada = this.$getDate();
            this.agenda.data = this.$getDate();
            this.agenda.tpagenda = 'V';
            this.agenda.concluida = 'N';
        } else {
            this.buttonDelete = true;
            this.loadData();
        }
    }
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_customer_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_csvReport__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_csvReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codpart: '',
            metadata: this.$store.getters.getEntities.metadata,
            offset: false,
            moreActionsBarList: [{ action: 0, label: 'Importar Clientes' }]
        };
    },


    computed: {
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        },

        partList: function partList() {
            return this.$store.getters.getPartList;
        },

        controleLimiteCredito: function controleLimiteCredito() {
            return true;
        }
    },

    methods: {
        handleAction: function handleAction(act) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var data, csv;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (act == 0) {
                                    //importação de cadastro de clientes
                                    _this.$router.push('/importa/clientes');
                                }

                                if (!(act == 'xls')) {
                                    _context.next = 9;
                                    break;
                                }

                            case 2:
                                if (!_this.nextPage) {
                                    _context.next = 7;
                                    break;
                                }

                                _context.next = 5;
                                return _this.handleMore(true);

                            case 5:
                                _context.next = 2;
                                break;

                            case 7:
                                data = _this.partList.map(function (it) {
                                    var obj = {
                                        codigo: it.codpart,
                                        nome: it.nome,
                                        fantasia: it.fantasia,
                                        cnpjcpf: it.cnpjcpf,
                                        cidade: it.nomemun,
                                        uf: it.uf,
                                        email: it.email,
                                        st: it.stpart
                                    };
                                    if (it.cnpjcpf) obj.cnpjcpf = it.cnpjcpf.toString();else obj.cnpjcpf = '';
                                    if (it.fone1) obj.fone1 = it.fone1.toString();else obj.fone1 = '';
                                    if (it.fone2) obj.fone2 = it.fone2.toString();else obj.fone2 = '';
                                    if (it.fone3) obj.fone3 = it.fone3.toString();else obj.fone3 = '';

                                    if (!obj.email) obj.email = '';

                                    return obj;
                                });

                                if (!data || data.length == 0) _this.$erpToastError('Nenhum cliente para visualizar');else {
                                    csv = Object(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__["objectToCsv"])(data);

                                    Object(__WEBPACK_IMPORTED_MODULE_4__shared_csvReport__["downloadCsvReport"])(csv);
                                }

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        editPart: function editPart(codpart) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU; //update
            this.codpart = codpart;
            this.showForm = true;
            this.$modalForm(true);
        },
        incluirPart: function incluirPart(codpart) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codpart = codpart;
            this.showForm = true;
            this.$modalForm(true);
        },
        handlePainel: function handlePainel(codpart) {
            this.$router.push('/fv/clientes/painel/' + codpart);
        },
        onAction: function onAction(action) {},
        closeForm: function closeForm() {
            this.showForm = false;
            this.$modalForm(false);
            this.loadData();
        },
        search: function search(value) {
            this.filter = '{"$or":[{"nome":{"$like":"%25' + value + '%25"}},{"fantasia":{"$like":"%25' + value + '%25"}},{"codpart":{"$eq":"' + value + '"}},{"cnpjcpf":{"$eq":"' + value + '"}}]}';
            this.loadData();
        },
        loadData: function loadData(wait) {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                params = { filter: _this2.filter };


                                if (_this2.offset) {
                                    params.offset = _this2.nextPage;
                                }

                                if (!wait) {
                                    _context2.next = 7;
                                    break;
                                }

                                _context2.next = 5;
                                return _this2.$store.dispatch('loadClientesFv', params);

                            case 5:
                                _context2.next = 8;
                                break;

                            case 7:
                                _this2.$store.dispatch('loadClientesFv', params);

                            case 8:

                                _this2.offset = false;

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        handleMore: function handleMore(wait) {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this3.offset = true;
                                _context3.next = 3;
                                return _this3.loadData(wait);

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        scroll: function scroll() {
            var _this4 = this;

            window.onscroll = function () {
                if (_this4.offset || _this4.nextPage == 0) return;
                var bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= document.documentElement.offsetHeight - 2;

                if (bottomOfWindow && !_this4.showForm) {
                    _this4.offset = true;
                    _this4.loadData();
                }
                __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].scrollPosition = document.documentElement.scrollTop;
            };
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], CustomerForm: __WEBPACK_IMPORTED_MODULE_2__forms_customer_form__["default"]
    },

    mounted: function mounted() {
        this.scroll();
    },
    beforeDestroy: function beforeDestroy() {
        window.onscroll = null;
        this.$modalForm(false);
    },
    created: function created() {
        this.showForm = false;
        this.loadData();
    },
    destroyed: function destroyed() {
        window.onscroll = null;
        this.$modalForm(false);
        console.log('destroyed fv cliente list');
    }
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_filter_list__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pedido_filtro__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fv_pedido_form__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_pedido_status__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_pedido_status_share__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__forms_pedido_impressao_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__main__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//













/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codpedv: '',
            filter: '',
            monthQuery: '',
            textQuery: '',
            statusQuery: '',
            filterList: [],
            paramFilterList: {},
            metadata: this.$store.getters.getEntities.metadata,

            offset: false,
            monthFilter: {},

            pedv_update_status: {},
            pedv_share_status: {},

            query: {
                codusuario: null,
                codequipe: null,
                text: null,
                after: null,
                before: null,
                codstatus: null
            },

            partOptions: [{ id: 'C', text: 'Cliente' }, { id: 'F', text: 'Fornecedor' }, { id: 'T', text: 'Transportadora' }],

            codpedvImpressao: null,
            showImpressao: false,

            usingFiltros: false,

            paramsFiltro: {
                periodos: [{
                    label: "Data Pedido / Orçamento",
                    nome: "dta",
                    varios: false,
                    values: [{
                        data_inicio: null,
                        data_termino: null
                    }]
                }, {
                    label: "Data da validade (Orçamentos)",
                    nome: "dtvalidade",
                    varios: false,
                    values: [{
                        data_inicio: null,
                        data_termino: null
                    }]
                }],

                selects: [{
                    label: "Dias Validade (Orçamentos)",
                    nome: "diasvalidade",
                    placeholder: "Tipo dias validade",
                    id: null,
                    value: null,
                    value_label: "em até",
                    value_placeholder: "Quantidade de Dias Validade (Orçamentos)",
                    options: [{
                        id: "0",
                        text: "Vencidos"
                    }, {
                        id: "1",
                        text: "À vencer"
                    }]
                }],

                filtros: [
                    /*
                      {
                        nome: "filial",
                        label: null,
                        url: null,
                        varios: false,
                        values: []
                        },
                      {
                        nome: "segmento",
                        label: null,
                        url: null,
                        varios: true,
                        values: [],
                      },
                      {
                        nome: "grupocliente",
                        label: null,
                        url: null,
                        varios: true,
                        values: [],
                      },
                      {
                        nome: "estado",
                        label: null,
                        url: null,
                        varios: true,
                        values: []
                      },
                      */
                ]
            }

        };
    },


    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], FilterList: __WEBPACK_IMPORTED_MODULE_2__components_filter_list__["a" /* default */], FvPedidoForm: __WEBPACK_IMPORTED_MODULE_4__fv_pedido_form__["default"], PedidoFiltro: __WEBPACK_IMPORTED_MODULE_3__components_pedido_filtro__["a" /* default */], PedidoStatus: __WEBPACK_IMPORTED_MODULE_5__forms_pedido_status__["a" /* default */], PedidoStatusShare: __WEBPACK_IMPORTED_MODULE_6__forms_pedido_status_share__["a" /* default */], PedidoImpressao: __WEBPACK_IMPORTED_MODULE_7__forms_pedido_impressao_vue__["default"]
    },

    computed: {

        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        },

        notFound: function notFound() {
            if (this.query.filtros) {
                return 'Nenhum pedido encontrado para o período';
            } else {
                return 'Nenhum pedido encontrado para o período ' + Object(__WEBPACK_IMPORTED_MODULE_9__shared_utils__["formatDate"])(this.monthFilter.startDate) + ' a ' + Object(__WEBPACK_IMPORTED_MODULE_9__shared_utils__["formatDate"])(this.monthFilter.endDate);
            }
        },

        pedvList: function pedvList() {
            return this.$store.getters.getPedvList;
        },

        pedvTotal: function pedvTotal() {
            return this.$store.getters.getPedvTotal;
        },

        appLoja: function appLoja() {
            return __WEBPACK_IMPORTED_MODULE_10__main__["SysVars"].appLoja;
        },

        bloqueia_alterar_pedido: function bloqueia_alterar_pedido() {
            console.log(this.$store.getters.getParametrosUsuario);
            console.log(this.$store.getters.getParametrosUsuario.vendas);
            if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) return this.$store.getters.getParametrosUsuario.vendas.bloqueia_alterar_pedido;else return false;
        }

    },

    watch: {
        pedvTotal: function pedvTotal() {

            //AQUI MONTA O OBJETO PARA A LISTA DE FILTROS DO COMPONENTE filter-list BASEADO NO OBJETO DE TOTAIS CARREGADO DO SERVIDOR

            this.filterList = [];
            var total = {};

            var tot = 0;

            if (this.pedvTotal.length > 0 && this.pedvTotal[this.pedvTotal.length - 1].status == 'TOTAL') {
                tot = this.pedvTotal[this.pedvTotal.length - 1].total;
            }

            for (var i = 0; i < this.pedvTotal.length; i++) {
                total = {};
                total.label = '';
                total.total = this.pedvTotal[i].total;
                total.qt = this.pedvTotal[i].qt;
                total.status = this.pedvTotal[i].status;
                if (total.status == 'ORCAMENTO') {
                    total.label = 'Orçamentos';
                } else if (total.status == 'PERDIDO') {
                    total.label = 'Orçamentos Perdidos';
                } else if (total.status == 'VENDA') {
                    total.label = 'Vendas';
                } else if (total.status == 'TOTAL') {
                    total.label = 'Total Geral';
                }

                //calcula o % em relacao ao total
                if (tot > 0) {
                    total.perc = total.total / tot * 100;
                }

                this.filterList.push(_extends({}, total));
            }

            this.paramFilterList = { total: this.filterList, selectedStatus: '' };
        }

    },

    filters: {},

    methods: {
        scroll: function scroll() {
            var _this = this;

            window.onscroll = function () {
                if (_this.showForm || _this.offset || _this.nextPage == 0) return;
                var bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= document.documentElement.offsetHeight - 2;

                if (bottomOfWindow) {
                    _this.offset = true;
                    _this.loadData(true);
                }
                __WEBPACK_IMPORTED_MODULE_10__main__["SysVars"].scrollPosition = document.documentElement.scrollTop;
            };
        },
        notFoundMsg: function notFoundMsg() {
            if (this.query.filtros) {
                return 'Nenhum pedido encontrado para o período';
            } else {
                return 'Nenhum pedido encontrado para o período ' + Object(__WEBPACK_IMPORTED_MODULE_9__shared_utils__["formatDate"])(this.monthFilter.startDate) + ' a ' + Object(__WEBPACK_IMPORTED_MODULE_9__shared_utils__["formatDate"])(this.monthFilter.endDate);
            }
        },
        horaStatus: function horaStatus(hora) {
            return Object(__WEBPACK_IMPORTED_MODULE_9__shared_utils__["formatDataHoraExtenso"])(hora);
        },
        handleDownloadXML: function handleDownloadXML(codnf, chave) {
            //visualizacao do XML da NFE
            var data = { codnf: codnf, chave: chave, tipo: 'NFE' };
            Object(__WEBPACK_IMPORTED_MODULE_8__shared_api_functions__["apiDownload"])(this, 'print/xmlnfe/', data, 'post');
        },
        handleShareStatus: function handleShareStatus(item) {
            this.pedv_share_status = item;
        },
        handlePostShareStatus: function handlePostShareStatus() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this2.pedv_share_status = {};

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        handleUpdateStatus: function handleUpdateStatus(item) {
            this.pedv_update_status = item;
        },
        handlePostStatus: function handlePostStatus() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, sendData, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                modulo = 'sales/statuspedido/' + _this3.pedv_update_status.codpedv;
                                sendData = {
                                    pedv: {
                                        codpedv: _this3.pedv_update_status.codpedv,
                                        codstatus: _this3.pedv_update_status.codstatus,
                                        obs: ''
                                    }
                                };
                                _context2.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_8__shared_api_functions__["apiORDSpost"])(_this3.$store, modulo, sendData, 'post');

                            case 4:
                                data = _context2.sent;

                                if (data) {
                                    _this3.pedv_update_status.status = data.descricao;
                                    _this3.pedv_update_status = {};
                                }

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },


        formataEndereco: function formataEndereco(pedv) {
            if (pedv.ecommerce != 'S') return null;
            var end = pedv.cliente.endereco;
            if (end) {
                if (pedv.cliente.nr) end = end + ', ' + pedv.cliente.nr;
                if (pedv.cliente.bairro) end = end + ', ' + pedv.cliente.bairro;
                end = end + ', ' + pedv.cliente.cidade + ' - ' + pedv.cliente.uf + ' - ' + pedv.cliente.cep;
                pedv.cliente.endereco_completo = end;
            }
            return end;
        },

        statusColor: function statusColor(stpedv, tppedv) {
            var color = 'badge-green';
            if (stpedv == 'C' || stpedv == 'R' || tppedv == 'R') {
                color = 'badge-red';
            } else if (stpedv == 'F') {
                color = 'badge-blue';
            } else if (tppedv == 'O') {
                color = 'badge-orange';
            } else if (tppedv == 'P') {
                color = 'badge-green';
            }
            return color;
        },
        handleEditPedido: function handleEditPedido(pedido, view) {
            //abre a tela de edicao
            if (view || pedido.data_leitura) this.crud = __WEBPACK_IMPORTED_MODULE_10__main__["SysVars"].crudView;else this.crud = __WEBPACK_IMPORTED_MODULE_10__main__["SysVars"].crudU; //operacao de edicao
            this.codpedv = pedido.codpedv; //numero do pedido
            this.$store.dispatch('cleanpart');
            this.showForm = true; //exibe o form de manutencao
        },
        handleClosePrint: function handleClosePrint() {
            this.showImpressao = false;
        },
        handleAction: function handleAction(act, codpedv) {
            if (act == 1) {
                this.codpedvImpressao = codpedv;
                this.showImpressao = true;
                this.$nextTick(function () {
                    this.$refs.impressao.print();
                });
            } else if (act == 2) {
                //faturar
                this.$router.push('/nf/' + codpedv);
            }
        },
        handleNovoPedido: function handleNovoPedido() {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_10__main__["SysVars"].crudI; //operacao de inclusao
            this.codpedv = '';
            this.$store.dispatch('cleanpart');
            this.showForm = true; //exibe o form de manutencao
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.$scrollTo(0);
            this.loadData();
        },
        changeFiltros: function changeFiltros(filtros) {
            this.query.text = null;
            this.query.filtros = _extends({}, filtros);
            this.loadData();
        },
        changeFiltroTexto: function changeFiltroTexto(value) {
            //efetua a pesquisa por texto
            this.query.text = value.toUpperCase();
            this.query.after = null;
            this.query.before = null;
            this.query.filtros = null;
            this.loadData();
        },
        changeFiltroMes: function changeFiltroMes(filter, startDate, endDate) {
            this.query.after = startDate;
            this.query.before = endDate;
            this.query.text = null;
            this.query.filtros = null;
            this.loadData();
        },
        handleFilterList: function handleFilterList(status) {
            //CLICK DO FILTER LIST
            if (status === 'TOTAL') {
                this.statusQuery = '';
            } else {
                this.statusQuery = 'status=' + status;
            }
            this.loadData();
        },
        loadData: function loadData(nottotal) {
            var param = {};
            param.query = '';

            if (this.query.text) param.query = param.query + 'text=' + this.query.text + '&';
            if (this.query.after) param.query = param.query + 'after=' + this.query.after + '&';
            if (this.query.before) param.query = param.query + 'before=' + this.query.before + '&';
            if (this.query.codusuario) param.query = param.query + 'usuario=' + this.query.codusuario + '&';
            if (this.query.codequipe) param.query = param.query + 'equipe=' + this.query.codequipe + '&';
            if (this.query.codstatus) param.query = param.query + 'codstatus=' + this.query.codstatus + '&';
            if (this.query.codfrete) param.query = param.query + 'codfrete=' + this.query.codfrete + '&';
            if (this.statusQuery) param.query = param.query + this.statusQuery + '&';
            if (this.offset) param.query = param.query + 'poffset=' + this.nextPage + '&';

            param.query = param.query.trim();
            if (param.query.endsWith('&')) param.query = param.query.slice(0, -1);

            this.usingFiltros = false;
            if (this.query.filtros) {
                param.body = JSON.stringify(this.query.filtros);
                this.usingFiltros = true;
            }

            console.log(param);

            this.$store.dispatch('loadPedidosFvList', param);
            this.offset = false;

            if (!nottotal) this.$store.dispatch('loadPedidosFvTotal', param);

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
            });
        },
        textST: function textST(pedv) {
            var text = 'Pedido';
            if (pedv.varejo == 'S') text = 'Venda Varejo';
            if (pedv.tppedv == 'O') {
                text = 'Orçamento';
            } else if (pedv.tppedv == 'R') {
                text = 'Orçamento Perdido';
                return text;
            }

            if (pedv.stpedv == 'C') text = text + ' Cancelado';else if (pedv.stpedv == 'R') text = text + ' Rejeitado';else if (pedv.stpedv == 'A') text = text + ' Em Aprovação';else if (pedv.stpedv == 'F') text = text + ' Faturado';

            return text;
        },
        enablePrint: function enablePrint(st) {
            return st == 'P' || st == 'F';
        },
        enableEdit: function enableEdit(st, cieloidsuperlink, vendarecebida, tp) {
            var result = false;

            if ((st === 'P' || st === 'D') && !(vendarecebida == 'S')) result = true;

            if (tp === 'P' && this.bloqueia_alterar_pedido) result = false;

            return result;
        },
        enableFaturar: function enableFaturar(st, tp) {
            return st === 'P' && tp === 'P'; //somente pedido pendente
        },
        orcamentoVencido: function orcamentoVencido(item) {
            return item.tppedv == 'O' && item.stpedv == 'P' && item.dtvalidade && new Date(item.dtvalidade).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);
        }
    },

    mounted: function mounted() {
        this.query.after = Object(__WEBPACK_IMPORTED_MODULE_8__shared_api_functions__["apiDateORDS"])(this.monthFilter.startDate);
        this.query.before = Object(__WEBPACK_IMPORTED_MODULE_8__shared_api_functions__["apiDateORDS"])(this.monthFilter.endDate, true);
        this.query.text = null;
        this.query.filtros = null;
        this.loadData();
        this.showForm = false;
        this.scroll();
        console.log(window.onscroll);
    },
    created: function created() {
        //this.$store.dispatch('clearItemSales')

        //carrega parametros do usuario para bloqueio das tabelas de precos
        this.$store.dispatch('loadParametrosUsuario');
    },
    destroyed: function destroyed() {
        window.onscroll = null;
        console.log(window.onscroll);
    }
});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        pedv: { type: Object }
    },

    data: function data() {
        return {};
    },


    computed: {
        statusPedido: function statusPedido() {
            return this.$store.getters.getPdstatusList.length > 0;
        }
    },

    filters: {},

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleSave: function handleSave() {
            this.$emit('save');
        }
    },

    watch: {},

    components: {},

    created: function created() {
        //carrega lista de cadastro de status para selecao 
        this.$store.dispatch('loadPdstatus', {});
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            this.$refs.status.focus();
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
    }
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_pedido_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_pedido_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__api_api_pedido_js__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        pedv: { type: Object }
    },

    data: function data() {
        return {
            MESSAGE: false,
            foneToSend: null,
            newNumber: null,
            link: null,
            link_html: null,
            showModalNumber: false,
            showFormEmail: false //exibe o formulario para envio de email
        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_1__api_api_pedido_js___default.a],

    computed: {
        statusPedido: function statusPedido() {
            return this.$store.getters.getPdstatusList.length > 0;
        },

        linkECommerce: function linkECommerce() {
            if (this.$store.getters.getSessao.dominio) {
                var isHomolog = typeof window !== 'undefined' && window.location && (window.location.host.indexOf('teste') >= 0 || window.location.host.indexOf('localhost') >= 0);
                var sufixo = isHomolog ? '.teste.notabrasil.com.br' : '.notabrasil.com.br';
                return 'https://' + this.$store.getters.getSessao.dominio + sufixo + '/loja/#/pedido-concluido?uuid=';
            } else {
                return null;
            }
        }

    },

    methods: {
        handleCloseMessage: function handleCloseMessage() {
            this.MESSAGE = false;
            this.closeForm();
        },
        handleConfirmMessage: function handleConfirmMessage() {
            window.open(this.link, "_blank");
            this.MESSAGE = false;
            this.closeForm();
        },
        handleEnviaEmailECommerce: function handleEnviaEmailECommerce() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var metodo, modulo, sendData, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                metodo = 'post';
                                modulo = 'sales/emailstatuspedido/';
                                sendData = { pedv: _this.pedv.codpedv };
                                _context.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDSpost"])(_this.$store, modulo, sendData, metodo);

                            case 5:
                                data = _context.sent;

                                if (data) {
                                    _this.$scrollTo(0);
                                    _this.$erpToastError(data);
                                } else {
                                    _this.$scrollTo(0);
                                    _this.$erpToastSuccess('Email enviado.');
                                }
                                _this.closeForm();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        handleEnviaLinkWhats: function handleEnviaLinkWhats(number) {
            this.showModalNumber = false;
            if (!number) return;else this.apiEnviaPedidoWhats(this.pedv, number);
            this.closeForm();
        },
        handleLink: function handleLink(tipo) {
            if (this.pedv.ecommerce == 'S') {
                if (this.linkECommerce) {
                    this.link = this.linkECommerce + this.pedv.uuid;
                    this.link_html = '<span class="badge badge-secondary" style="font-size: 18px;"><a style="color: white" :href="' + this.link + '" target="_blank">' + this.link + '</a></span>';
                    if (tipo == 'whats') {
                        this.showModalNumber = true;
                    } else if (tipo == 'link') {
                        this.MESSAGE = true;
                    } else {
                        this.handleEnviaEmailECommerce();
                    }
                } else {
                    this.$erpToastError('Configure o Link de acesso nas configurações da Loja antes de executar essa operação.');
                }
            } else {
                if (tipo == 'whats') {
                    this.showModalNumber = true;
                } else if (tipo == 'link') {
                    this.MESSAGE = true;
                } else {
                    this.handleShowFormEmail();
                }
            }
        },
        handleShowFormEmail: function handleShowFormEmail() {
            //Abre a tela para envio de email
            //carrega o template da mensagem antes do envio (ords/webdata/template/salesorder/:id)
            this.showFormEmail = true;
        },
        closeFormEmail: function closeFormEmail() {
            this.showFormEmail = false;
        },
        handleSendEmail: function handleSendEmail(data) {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var email;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //cahamda para envio de email do pedido
                                _this2.closeFormEmail();
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiEmailPDF"])(_this2, 'pedv/' + _this2.pedv.codpedv, data);

                            case 3:
                                email = _context2.sent;

                                _this2.closeForm();

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    },

    watch: {},

    components: {},

    created: function created() {
        //carrega lista de cadastro de status para selecao 
        this.$store.dispatch('loadPdstatus', {});
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
    }
});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forms_item_list__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_tabpre_list__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_tabdes_list__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_destaq_list__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_gruest_list__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_item_ajuste_estoque__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__forms_item_precos_list__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__consultas_consulta_items_estoque__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__forms_grade_list__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__forms_unimed_list__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__main__);
















/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            activeTab: 0
        };
    },


    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], ItemList: __WEBPACK_IMPORTED_MODULE_1__forms_item_list__["default"], TabpreList: __WEBPACK_IMPORTED_MODULE_2__forms_tabpre_list__["default"], TabdesList: __WEBPACK_IMPORTED_MODULE_3__forms_tabdes_list__["default"], DestaqList: __WEBPACK_IMPORTED_MODULE_4__forms_destaq_list__["default"], GruestList: __WEBPACK_IMPORTED_MODULE_5__forms_gruest_list__["default"], ItemPrecosList: __WEBPACK_IMPORTED_MODULE_7__forms_item_precos_list__["default"], ItemsEstoqueList: __WEBPACK_IMPORTED_MODULE_8__consultas_consulta_items_estoque__["default"], ItemAjusteEstoque: __WEBPACK_IMPORTED_MODULE_6__forms_item_ajuste_estoque__["default"], GradeList: __WEBPACK_IMPORTED_MODULE_9__forms_grade_list__["default"], UnimedList: __WEBPACK_IMPORTED_MODULE_10__forms_unimed_list__["default"]
    },

    computed: {
        tabs: function tabs() {
            var tabs = [];
            if (!this.usuarioComum) {
                tabs = [{ title: 'Produtos', icon: 'fa-archive' }, { title: 'Grupos', icon: 'fa-cubes' }, { title: 'Grades', icon: 'fa-th' }, { title: 'Tabelas Preço', icon: 'fa-dollar' }, { title: 'Tabelas Desconto', icon: 'fa-tag' }, { title: 'Tabelas Destaques', icon: 'fa-star' }, { title: 'Estoque Atual', icon: 'fa-clipboard', hidden: !__WEBPACK_IMPORTED_MODULE_13__main__["SysVars"].appForcaVendas }, { title: 'Unidade Medida', icon: 'fa-sort-numeric-desc' }, { title: 'Pesquisa Preços', icon: 'fa-dollar' }];
            } else {
                tabs = [{ title: 'Produtos', icon: 'fa-archive' }, { title: 'Pesquisa Produtos', icon: 'fa-archive' }, { title: 'Estoque Atual', icon: 'fa-clipboard', hidden: !__WEBPACK_IMPORTED_MODULE_13__main__["SysVars"].appForcaVendas }];
            }
            return tabs;
        },

        tabPesquisa: function tabPesquisa() {
            if (this.usuarioComum) return this.activeTab == 1;else return this.activeTab == 8;
        },

        tabProdutos: function tabProdutos() {
            return this.activeTab == 0;
            // return this.activeTab == 0 && !this.usuarioComum
        },

        tabGrupos: function tabGrupos() {
            if (!this.usuarioComum) return this.activeTab == 1;
        },

        tabGrade: function tabGrade() {
            if (!this.usuarioComum) return this.activeTab == 2;
        },

        tabPreco: function tabPreco() {
            if (!this.usuarioComum) return this.activeTab == 3;
        },

        tabDes: function tabDes() {
            if (!this.usuarioComum) return this.activeTab == 4;
        },

        tabDestaq: function tabDestaq() {
            if (!this.usuarioComum) return this.activeTab == 5;
        },

        tabUndMedidas: function tabUndMedidas() {
            if (!this.usuarioComum) return this.activeTab == 7;
        },

        tabAjusteEstoque: function tabAjusteEstoque() {
            if (!this.usuarioComum) return this.activeTab == 9;
        },

        tabEstoque: function tabEstoque() {
            if (this.usuarioComum) return this.activeTab == 2;else return this.activeTab == 6;
        },

        usuarioComum: function usuarioComum() {
            return this.$store.getters.getSessao.perfil == '3';
        },

        usuario_logado_uuid: function usuario_logado_uuid() {
            return this.$store.getters.getEnv.uuid;
        }
    },

    methods: {
        closeForm: function closeForm() {},
        changeTab: function changeTab(idx) {
            //mudança de pagina
            console.log(idx);
            this.activeTab = idx;
        }
    },

    created: function created() {}
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_item_ajuste_estoque_vue__ = __webpack_require__(676);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_207e2513_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_item_ajuste_estoque_vue__ = __webpack_require__(1888);
function injectStyle (ssrContext) {
  __webpack_require__(1886)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-207e2513"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_item_ajuste_estoque_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_207e2513_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_item_ajuste_estoque_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: false
        };
    },


    computed: {
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        },

        produtos: function produtos() {
            return this.$store.getters.getItemSalesList;
        },

        administrador: function administrador() {
            return __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].usuarioAdministrador;
        }

    },

    methods: {
        handleFocusProduto: function handleFocusProduto(produto, grade) {
            if (grade) grade.saldo_estoque_anterior = grade.saldo_estoque;else produto.saldo_estoque_anterior = produto.saldo_estoque;
        },
        updateQuantidade: function updateQuantidade(produto, grade) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var sendData, data, _sendData, _data;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //EFETUA A ATUALIZACAO DA QUANTIDADE INFORMADA
                                console.log(grade);

                                if (!(grade && grade.saldo_estoque && grade.saldo_estoque != grade.saldo_estoque_anterior)) {
                                    _context.next = 6;
                                    break;
                                }

                                sendData = { coditemgrade: grade.coditemgrade, qt: grade.saldo_estoque };
                                _context.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this.$store, 'estoque/atualizaquantidade/', sendData, 'post');

                            case 5:
                                data = _context.sent;

                            case 6:
                                if (!(!grade && produto.saldo_estoque && produto.saldo_estoque != produto.saldo_estoque_anterior)) {
                                    _context.next = 11;
                                    break;
                                }

                                _sendData = { coditem: produto.coditem, qt: produto.saldo_estoque };
                                _context.next = 10;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this.$store, 'estoque/atualizaquantidade/', _sendData, 'post');

                            case 10:
                                _data = _context.sent;

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleMore: function handleMore() {
            this.offset = true;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codigo":{"$eq":"' + value + '"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        textST: function textST(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(value, this.metadata.item.stitem);
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this2.$store.dispatch('loadTabpre', {});

                            case 2:
                                params = { filter: _this2.filter };

                                if (_this2.offset) {
                                    params.offset = _this2.nextPage;
                                }
                                _this2.$store.dispatch('loadPesquisaProdutosSales', params);
                                _this2.offset = false;

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        loadGrade: function loadGrade(produto) {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var url, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!produto.showGrade) {
                                    _context3.next = 3;
                                    break;
                                }

                                produto.showGrade = false;
                                return _context3.abrupt('return');

                            case 3:
                                url = 'item/sales/pesquisa/produtos/' + produto.coditem + '/grade';
                                _context3.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDS"])(_this3.$store.getters.urlOrds + url, {});

                            case 6:
                                data = _context3.sent;

                                if (data.items) {
                                    _this3.$set(produto, 'showGrade', true);
                                    _this3.$set(produto, 'grade', data.items);
                                }

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"]
    },

    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_item_precos_list_vue__ = __webpack_require__(678);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6313172_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_item_precos_list_vue__ = __webpack_require__(1891);
function injectStyle (ssrContext) {
  __webpack_require__(1889)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d6313172"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_item_precos_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6313172_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_item_precos_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_anexos_form__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            coditem: '',
            descricao: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            showAnexosForm: false,
            offset: false,
            tabelas: [{
                codtabpre: '1',
                descricao: 'Padrão'
            }]
        };
    },


    computed: {
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        },

        produtos: function produtos() {
            return this.$store.getters.getItemSalesList;
        },

        tabelasUsuario: function tabelasUsuario() {
            //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
            var tabelas = this.$store.getters.getTabpreList.length ? this.$store.getters.getTabpreList : [];

            if (__WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].usuarioAdministrador) return tabelas;

            var tabLiberada = false;
            var tabsUsr = [];
            if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) tabsUsr = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco;

            tabelas = tabelas.filter(function (obj) {
                tabLiberada = false;
                tabsUsr.forEach(function (tabUsr) {
                    if (tabUsr.codtabpre == obj.codtabpre) tabLiberada = true;
                });
                return obj.sttabpre == 'A' && tabLiberada;
            });

            return tabelas;
        }

    },

    methods: {
        handleAnexosForm: function handleAnexosForm(coditem, descricao) {
            this.coditem = coditem;
            this.descricao = descricao;
            this.showAnexosForm = true;
        },
        handleMore: function handleMore() {
            this.offset = true;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showAnexosForm = false;
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codigo":{"$eq":"' + value + '"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        textST: function textST(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(value, this.metadata.item.stitem);
        },
        getTabDescricao: function getTabDescricao(codtabpre) {
            var tab = (this.tabelasUsuario || []).find(function (t) {
                return t.codtabpre == codtabpre;
            });
            return tab ? tab.descricao : 'Tabela ' + codtabpre;
        },
        renderTabelasUsuario: function renderTabelasUsuario(tabelasItem) {
            //exibe precos conforme tabelas liberadas para o usuario
            var tabs = [];
            if (tabelasItem && tabelasItem.length) {
                this.tabelasUsuario.forEach(function (tabUsr) {
                    tabs = tabs.concat(tabelasItem.filter(function (tabItem) {
                        return tabItem.codtabpre == tabUsr.codtabpre;
                    }));
                });
            }
            return tabs;
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadTabpre', {});

                            case 2:
                                params = { filter: _this.filter };

                                if (_this.offset) {
                                    params.offset = _this.nextPage;
                                }
                                _this.$store.dispatch('loadPesquisaProdutosSales', params);
                                _this.offset = false;

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], AnexosForm: __WEBPACK_IMPORTED_MODULE_1__components_anexos_form__["a" /* default */]
    },

    created: function created() {
        this.loadData();
        console.log('item-precos-list');
    }
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_pdtipo_list__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_pdstatus_list__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_regraimp_list__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_condicao_list__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__forms_app_minha_conta_form__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__forms_grucli_list__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__forms_ramoat_list__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__forms_equipe_list__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__forms_usuario_list__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__forms_filial_list__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__forms_filial_form__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__forms_loja_config_list_loja__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__forms_transportadora_list__ = __webpack_require__(1951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__forms_vend_list__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__forms_regrafcp_list__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__forms_estado_list__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__forms_fpag_list__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__forms_depo_list__ = __webpack_require__(532);























/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      activeTab: 0,
      activeTabLink: 0,
      activeTabLinkId: 0,
      configSistema: true,
      configVendas: false
    };
  },


  components: {
    BarList: __WEBPACK_IMPORTED_MODULE_2__components_bar_list__["default"],
    PdtipoList: __WEBPACK_IMPORTED_MODULE_3__forms_pdtipo_list__["a" /* default */],
    PdstatusList: __WEBPACK_IMPORTED_MODULE_4__forms_pdstatus_list__["a" /* default */],
    CondicaoList: __WEBPACK_IMPORTED_MODULE_6__forms_condicao_list__["a" /* default */],
    GrucliList: __WEBPACK_IMPORTED_MODULE_8__forms_grucli_list__["default"],
    RamoatList: __WEBPACK_IMPORTED_MODULE_9__forms_ramoat_list__["default"],
    EquipeList: __WEBPACK_IMPORTED_MODULE_10__forms_equipe_list__["a" /* default */],
    RegraimpList: __WEBPACK_IMPORTED_MODULE_5__forms_regraimp_list__["default"],
    UsuarioList: __WEBPACK_IMPORTED_MODULE_11__forms_usuario_list__["default"],
    FilialList: __WEBPACK_IMPORTED_MODULE_12__forms_filial_list__["default"],
    FilialForm: __WEBPACK_IMPORTED_MODULE_13__forms_filial_form__["default"],
    TransportadoraList: __WEBPACK_IMPORTED_MODULE_15__forms_transportadora_list__["a" /* default */],
    ConfigListLoja: __WEBPACK_IMPORTED_MODULE_14__forms_loja_config_list_loja__["default"],
    VendList: __WEBPACK_IMPORTED_MODULE_16__forms_vend_list__["default"],
    AppMinhaContaForm: __WEBPACK_IMPORTED_MODULE_7__forms_app_minha_conta_form__["default"],
    RegrafcpList: __WEBPACK_IMPORTED_MODULE_17__forms_regrafcp_list__["default"],
    EstadoList: __WEBPACK_IMPORTED_MODULE_18__forms_estado_list__["default"],
    FpagList: __WEBPACK_IMPORTED_MODULE_19__forms_fpag_list__["default"],
    DepoList: __WEBPACK_IMPORTED_MODULE_20__forms_depo_list__["default"]
  },

  // { title: 'Dados da Empresa', icon: 'fa-building' },
  // { title: 'Usuários', icon: 'fa-user-o' },
  // { title: 'Equipes', icon: 'fa-group' },
  // { title: 'Cond Pagamento', icon: '' },
  // { title: 'Transportadoras', icon: 'fa-truck' },
  // { title: 'Tipos de Pedido', icon: '' },
  // { title: 'Status de Pedido', icon: '' },
  // { title: 'Regras de Imposto', icon: '' },

  computed: {
    tabs: function tabs() {
      var tabs = [];

      if (this.administrador) {
        if (this.configSistema) tabs = [{ title: "Dados da Empresa", icon: "fa-building" }, { title: "Usuários", icon: "fa-user-o" }, { title: "Equipes", icon: "fa-group" }, { title: "Minha Conta", icon: "fa-table" }];else tabs = [{ title: "Participantes", icon: "fa-group" }, { title: "Comercial", icon: "fa-building" }, { title: "Impostos", icon: "fa-usd" }];
      } else {
        if (this.configSistema) tabs = [{ title: "Usuários", icon: "fa-user-o" }];else tabs = [{ title: "Representantes", icon: "" }, { title: "Transportadoras", icon: "" }];
      }

      return tabs;
    },

    tabEmpresa: function tabEmpresa() {
      return this.configSistema && this.activeTab == 0 && this.administrador;
    },

    tabUsuarios: function tabUsuarios() {
      if (!this.administrador) return this.configSistema && this.activeTab == 0;else return this.configSistema && this.activeTab == 1;
    },

    tabEquipes: function tabEquipes() {
      return this.configSistema && this.activeTab == 2;
    },

    tabConta: function tabConta() {
      return this.configSistema && this.activeTab == 3;
    },

    tabRepresentante: function tabRepresentante() {
      return this.configVendas && this.activeTab == 0 && this.activeTabLinkId == 0;
    },

    tabTransp: function tabTransp() {
      if (!this.administrador) return this.configVendas && this.activeTab == 1;else return this.configVendas && this.activeTab == 0 && this.activeTabLinkId == 4;
    },

    tabGrupoCliente: function tabGrupoCliente() {
      return this.configVendas && this.activeTab == 0 && this.activeTabLinkId == 1;
    },

    tabSegmento: function tabSegmento() {
      return this.configVendas && this.activeTab == 0 && this.activeTabLinkId == 2;
    },

    tabCondicoes: function tabCondicoes() {
      return this.configVendas && this.activeTab == 1 && this.activeTabLinkId == 3;
    },

    tabFormasPag: function tabFormasPag() {
      return this.configVendas && this.activeTab == 1 && this.activeTabLinkId == 10;
    },

    tabTipos: function tabTipos() {
      return this.configVendas && this.activeTab == 1 && this.activeTabLinkId == 5;
    },

    tabStatus: function tabStatus() {
      return this.configVendas && this.activeTab == 1 && this.activeTabLinkId == 6;
    },

    tabRegras: function tabRegras() {
      return this.configVendas && this.activeTab == 2 && this.activeTabLinkId == 7;
    },

    tabRegrasFcp: function tabRegrasFcp() {
      return this.configVendas && this.activeTab == 2 && this.activeTabLinkId == 8;
    },

    tabEstados: function tabEstados() {
      return this.configVendas && this.activeTab == 2 && this.activeTabLinkId == 9;
    },

    tabDepositos: function tabDepositos() {
      return this.configVendas && this.activeTab == 1 && this.activeTabLinkId == 11;
    },

    appForcaVendas: function appForcaVendas() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appForcaVendas;
    },
    appLoja: function appLoja() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appLoja;
    },
    tabLinks: function tabLinks() {
      if (this.activeTab === 0) {
        return [{ id: 0, title: "Representantes", icon: "" }, { id: 4, title: "Transportadoras", icon: "" }, { id: 1, title: "Grupos de Cliente", icon: "" }, { id: 2, title: "Segmentos de Cliente", icon: "" }];
      }

      if (this.activeTab === 1) {
        var tabs = [{ id: 3, title: "Condições de Pagamento", icon: "" }, { id: 10, title: "Formas de Pagamento", icon: "" }, { id: 5, title: "Tipos de Pedido", icon: "" }, { id: 6, title: "Status de Pedido", icon: "" }, { id: 11, title: "Depósitos", icon: "" }];
        if (!this.appForcaVendas && !this.appLoja) {
          tabs.splice(0, 1);
        }
        return tabs;
      }

      if (this.activeTab === 2) {
        return [{ id: 7, title: "Regras de Imposto", icon: "" }, { id: 8, title: "Alíquotas do FCP", icon: "" }, { id: 9, title: "Estados", icon: "" }];
      }

      return [];
    },

    administrador: function administrador() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador;
    }
  },

  methods: {
    changeTab: function changeTab(idx) {
      this.activeTab = idx;
      this.activeTabLink = 0;

      if (!this.configSistema) {
        this.activeTabLinkId = this.tabLinks[0].id;
      }
    },
    changeTabLink: function changeTabLink(idx) {
      var link = this.tabLinks[idx];
      this.activeTabLink = idx;
      this.activeTabLinkId = link.id;
    },
    handleConfigSistema: function handleConfigSistema() {
      this.configVendas = false;
      this.configSistema = true;
    },
    handleConfigVendas: function handleConfigVendas() {
      this.configVendas = true;
      this.configSistema = false;
    }
  },

  created: function created() {
    if (this.$route.query.myaccount) {
      this.changeTab(3);
    }
  }
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_list_loja_vue__ = __webpack_require__(681);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_34b68950_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_list_loja_vue__ = __webpack_require__(1950);
function injectStyle (ssrContext) {
  __webpack_require__(1896)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_list_loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_34b68950_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_list_loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_form_loja__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_utils__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            usuario: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',

            errmessages: [],

            url: '',

            invalidSub: false
        };
    },


    computed: {
        filialList: function filialList() {
            return this.$store.getters.getFilialList;
        },

        dominio: function dominio() {
            return this.$store.getters.getSessao.dominio;
        },

        sufixoDominio: function sufixoDominio() {
            if (typeof window !== 'undefined' && window.location && window.location.host) {
                if (window.location.host.indexOf('teste') >= 0 || window.location.host.indexOf('localhost') >= 0) {
                    return '.teste.notabrasil.com.br';
                }
            }
            return '.notabrasil.com.br';
        },

        urlLojaCompleta: function urlLojaCompleta() {
            return 'https://' + this.dominio + this.sufixoDominio + '/loja';
        }
    },

    filters: {},

    methods: {
        loadData: function loadData() {
            this.$store.dispatch('loadFilial', {});
        },
        handleSalvar: function handleSalvar() {
            var _this = this;

            this.url = this.url.replace('.teste.notabrasil.com.br', '');
            this.url = this.url.replace('.notabrasil.com.br', '');

            this.url = this.$removerAcentos(this.url.toLowerCase());
            //console.log(isValidURLSubdomain(this.url))
            //console.log(this.url)

            this.invalidSub = !Object(__WEBPACK_IMPORTED_MODULE_4__shared_utils__["isValidURLSubdomain"])(this.url);

            if (this.invalidSub) {
                return;
            }
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost();
                }
            });
        },
        apiPost: function apiPost(pDelete) {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var sendData, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                sendData = { dominio: _this2.url, deletar: 'N' };

                                if (pDelete) {
                                    sendData = { dominio: _this2.dominio, deletar: 'S' };
                                }
                                _context.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this2.$store, 'loja/dominio/', sendData, 'post');

                            case 4:
                                data = _context.sent;


                                if (data) {
                                    if (data.errmessages) {
                                        _this2.errmessages = data.errmessages;
                                    } else {

                                        _this2.errmessages = {};
                                    }
                                }
                                _this2.$store.dispatch('loadSessao', _this2);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        handleDeletar: function handleDeletar() {
            this.apiPost(true);
        },
        handleWhatsApp: function handleWhatsApp(opc) {

            if (this.dominio != null) {
                var msg = "";
                var enderecoURL = "";

                switch (opc) {
                    case 1:
                        // Destaques
                        enderecoURL = this.urlLojaCompleta + "/#/destaques";
                        break;
                    case 2:
                        // Promoções
                        enderecoURL = this.urlLojaCompleta + "/#/promocoes";
                        break;
                    default:
                        enderecoURL = this.urlLojaCompleta;
                        break;
                }

                msg = "🛍 *Acesse nossa loja *" + enderecoURL;

                msg = window.encodeURIComponent(msg);

                window.open("https://wa.me/?text=" + msg, "_blank");
            }
        }
    },

    watch: {
        url: function url() {
            if (this.url) {
                this.url = this.url.replace(' ', '-');
            }
        }
    },

    components: {
        ConfigFormLoja: __WEBPACK_IMPORTED_MODULE_1__config_form_loja__["a" /* default */]
    },

    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_formasenvio_list_loja__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_formaspagamento_list_loja__ = __webpack_require__(1909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_retirada_form_loja__ = __webpack_require__(1917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_correios_form_loja__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_melhorenvio_form_loja__ = __webpack_require__(1925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_pagonline_form_loja__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_bandeiras_form_loja__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_analisefraude_form_loja__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_selformasenvio_form_loja__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config_mail_loja_vue__ = __webpack_require__(1945);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    codfil: ''
  },

  components: {
    FormasenvioList: __WEBPACK_IMPORTED_MODULE_3__config_formasenvio_list_loja__["a" /* default */], ConfigMailLoja: __WEBPACK_IMPORTED_MODULE_12__config_mail_loja_vue__["a" /* default */], FormaspagamentoList: __WEBPACK_IMPORTED_MODULE_4__config_formaspagamento_list_loja__["a" /* default */], PagonlineForm: __WEBPACK_IMPORTED_MODULE_8__config_pagonline_form_loja__["a" /* default */], RetiradaForm: __WEBPACK_IMPORTED_MODULE_5__config_retirada_form_loja__["a" /* default */], AnalisefraudeForm: __WEBPACK_IMPORTED_MODULE_10__config_analisefraude_form_loja__["a" /* default */], CorreiosForm: __WEBPACK_IMPORTED_MODULE_6__config_correios_form_loja__["a" /* default */], BandeirasForm: __WEBPACK_IMPORTED_MODULE_9__config_bandeiras_form_loja__["a" /* default */], SelformasenvioForm: __WEBPACK_IMPORTED_MODULE_11__config_selformasenvio_form_loja__["a" /* default */], MelhorenvioForm: __WEBPACK_IMPORTED_MODULE_7__config_melhorenvio_form_loja__["a" /* default */]
  },

  data: function data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela

      uploadingBanner: null,
      uploadingImage: null,
      uploading: false,
      selectedFile: null,
      showPagOnline: false,

      image: null,

      filial: {},

      configloja: {
        codtabpre: null,
        b2b: null,
        valor_minimo_pedido: null,
        controlaestoque: false,
        codusuario: null,
        whatsapp: null,
        facebook: null,
        instagram: null,
        fone: null,
        banners_desktop: [],
        banners_mobile: [],
        bordas_laterais_add: false,
        bordas_laterais: 0,
        categoria_iniciar_aberta: false,
        cores: {
          bg_top_bottom: '#0340A6',
          fc_top_bottom: '#FFFFFF',
          bg_buttons: '#0340A6',
          fc_buttons: '#FFFFFF',
          bg_promocao: '',
          fc_promocao: '',
          bg_destaques: '',
          fc_destaques: '',
          bg_descontos: '',
          fc_descontos: '',
          bg_aviso_sacola: '',
          fc_aviso_sacola: '',
          bg_rodape: '',
          fc_rodape: ''
        },
        formasenvio: [],
        formaspagamento: [],
        tppedv: 'O'
      },

      retirada: {
        nome: null,
        endereco: null
      },

      parametros: {},

      pagonlineObj: {
        habilitaCielo: false,
        habilitaRede: false,
        habilitaShopline: false,
        habilitaCieloCheckout: false,
        habilitaShoplineCheckout: false,
        habilitaRedeCheckout: false,
        habilitaPagseguro: false,
        habilitaPagseguroCheckout: false,
        cielo: {
          clientid: null,
          clientsecret: null,
          desconto: null,
          observacao: null
        },
        shopline: {
          codigosite: null,
          chave: null,
          observacaoboleto: null,
          desconto: null,
          observacao: null
        },
        rede: {
          token: null,
          pv: null,
          desconto: null,
          parcelas: 1,
          valorMinimoParcela: 0,
          observacao: null
        },
        pixitau: {
          clientid: null,
          clientsecret: null,
          desconto: null,
          observacao: null
        },
        pagseguro: {
          email: null,
          token: null,
          desconto: null,
          observacao: null
        }
      },

      rodapeObj: {
        atendimento_obs: null,
        habilitaBandeiras: true,
        bandeiras: {
          boleto: true,
          visa: true,
          mcard: true,
          elo: true,
          american_express: true,
          dinners_club: true,
          hipercard: true,
          jcb: false,
          discover: false,
          aura: true
        },
        habilitaFormasEnvio: true,
        formasenvio: {
          correios: true,
          pac: true,
          sedex: true,
          jadlog: true,
          latam: true,
          azul_express: true
        }
      },

      analisefraudeObj: {
        habilitaClearsale: false,
        clearsale: {
          login: null,
          senha: null,
          token: null,
          fingerprint: null
        }
      },

      correiosObj: {
        contrato: false,
        codempresa: null,
        senha: null,
        habilitasedex: true,
        habilitapac: true,
        codigopac: null,
        codigosedex: null,
        valoradicional: null,
        maopropria: false,
        valordeclarado: false,
        avisorecebimento: false
      },

      melhorenvioObj: {
        clientid: null,
        clientsecret: null,
        maopropria: false,
        valordeclarado: false,
        avisorecebimento: false,
        valoradicional: null,
        prazoadicional: null
      },

      activeTab: 0,

      tabs: [{ title: 'Seus Dados', icon: 'fa-building' }, { title: 'Parâmetros e Aparência', icon: 'fa-cog' }, { title: 'Banners', icon: 'fa-window-maximize' }, { title: 'Formas de Envio', icon: 'fa-truck' }, { title: 'Formas de Pagamento', icon: 'fa-window-maximize' }, { title: 'Análise de Fraude', icon: 'fa-window-maximize' }, { title: 'Configuração de Email', icon: 'fa-envelope-o' }],

      showModalPaginas: false,
      pagina: null
    };
  },


  computed: {
    tabpreList: function tabpreList() {
      return this.$store.getters.getTabpreList;
    },
    tabDados: function tabDados() {
      return this.activeTab == 0;
    },
    tabConfig: function tabConfig() {
      return this.activeTab == 1;
    },
    tabBanner: function tabBanner() {
      return this.activeTab == 2;
    },
    tabFormasEnvio: function tabFormasEnvio() {
      return this.activeTab == 3;
    },
    tabPagamentos: function tabPagamentos() {
      return this.activeTab == 4;
    },
    tabAnaliseFraude: function tabAnaliseFraude() {
      return this.activeTab == 5;
    },
    tabConfigMail: function tabConfigMail() {
      return this.activeTab == 6;
    }
  },

  watch: {},

  methods: {
    handleDelete: function handleDelete(index) {
      this.configloja.emails.splice(index, 1);
    },
    handleInsertMail: function handleInsertMail(mail) {
      this.configloja.emails.unshift(mail);
    },
    handleEditMail: function handleEditMail(obj) {
      console.log(obj);
      this.configloja.emails[obj.index] = obj.mail;
    },
    closeForm: function closeForm() {
      this.$emit('closeform');
    },
    changeTab: function changeTab(idx) {
      this.activeTab = idx;
    },
    handleSaveFilial: function handleSaveFilial() {
      var _this = this;

      if (this.parametros.pagonline.habilitaCieloCheckout || this.parametros.pagonline.habilitaRedeCheckout || this.parametros.pagonline.habilitaShoplineCheckout || this.parametros.pagonline.habilitaPagseguroCheckout) {
        this.configloja.tppedv = 'P';
      }

      if (this.configloja.bordas_laterais_add) {
        this.configloja.bordas_laterais = 10;
      }

      //BOTAO SALVAR
      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          _this.apiPostFilial('put');
        }
      });
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$store.dispatch('loadFilial', { id: _this2.codfil });

              case 2:
                if (!_this2.$store.getters.getFilial) {
                  _context.next = 29;
                  break;
                }

                _this2.filial = _extends({}, _this2.$store.getters.getFilial);
                if (_this2.filial.parametros) {
                  _this2.parametros = JSON.parse(_this2.filial.parametros);
                } else {
                  _this2.parametros = {};
                }
                if (_this2.parametros.hasOwnProperty('pagonline') == false) {
                  _this2.parametros.pagonline = _this2.pagonlineObj;
                }
                if (_this2.parametros.pagonline.hasOwnProperty('rede') == false) {
                  _this2.parametros.pagonline.rede = _this2.pagonlineObj.rede;
                }

                if (_this2.parametros.pagonline.hasOwnProperty('pagseguro') == false) {
                  _this2.parametros.pagonline.pagseguro = _this2.pagonlineObj.pagseguro; //{ email: 'notabrasil@htdsistemas.com.br', token: 'F11D8AECC8D144FF83592BFDF8A22D60' }
                }

                if (_this2.filial.parametrosloja) {
                  _this2.configloja = JSON.parse(_this2.filial.parametrosloja);
                }

                if (_this2.configloja.hasOwnProperty('codempresa') == false) {
                  _this2.configloja.codempresa = _this2.filial.codempresa;
                }
                if (_this2.parametros.hasOwnProperty('codempresa') == false) {
                  _this2.parametros.codempresa = _this2.filial.codempresa;
                }

                if (_this2.configloja.hasOwnProperty('analisefraude') == false) {
                  _this2.configloja.analisefraude = _this2.analisefraudeObj;
                }
                if (_this2.configloja.analisefraude.hasOwnProperty('clearsale') == false) {
                  _this2.configloja.analisefraude.clearsale = _this2.analisefraudeObj.clearsale;
                }
                if (_this2.configloja.analisefraude.clearsale.hasOwnProperty('fingerprint') == false) {
                  _this2.configloja.analisefraude.clearsale.fingerprint = null;
                }
                if (!_this2.configloja.correios) {
                  _this2.configloja.correios = _this2.correiosObj;
                }
                if (!_this2.configloja.melhorenvio) {
                  _this2.configloja.melhorenvio = _this2.melhorenvioObj;
                }
                if (_this2.configloja.hasOwnProperty('rodape') == false) {
                  _this2.configloja.rodape = _this2.rodapeObj;
                }
                if (_this2.configloja.rodape.hasOwnProperty('bandeiras') == false) {
                  _this2.configloja.rodape.habilitaBandeiras = true;
                  _this2.configloja.rodape.bandeiras = _this2.rodapeObj.bandeiras;
                }
                if (_this2.configloja.rodape.hasOwnProperty('formasenvio') == false) {
                  _this2.configloja.rodape.habilitaFormasEnvio = true;
                  _this2.configloja.rodape.formasenvio = _this2.rodapeObj.formasenvio;
                }
                if (_this2.configloja.rodape.hasOwnProperty('atendimento_obs') == false) {
                  _this2.configloja.rodape.atendimento_obs = null;
                }
                if (_this2.configloja.hasOwnProperty('bordas_laterais_add') == false) {
                  _this2.configloja.bordas_laterais_add = false;
                  _this2.configloja.bordas_laterais = 0;
                }
                if (_this2.configloja.hasOwnProperty('bordas_laterais') == false) {
                  _this2.configloja.bordas_laterais = 0;
                }
                if (_this2.configloja.hasOwnProperty('categoria_iniciar_aberta') == false) {
                  _this2.configloja.categoria_iniciar_aberta = false;
                }
                if (_this2.configloja.hasOwnProperty('paginas') == false) {
                  _this2.configloja.paginas = [{ titulo: 'Sobre a Loja/Quem Somos', tituloRodape: null, html: null, ativa: false }, { titulo: 'Politica de Trocas e Devoluções', tituloRodape: null, html: null, ativa: false }, { titulo: 'Como Comprar', tituloRodape: null, html: null, ativa: false }, { titulo: 'Perguntas Frequentes', tituloRodape: null, html: null, ativa: false }];
                }
                if (_this2.configloja.hasOwnProperty('emails') == false) {
                  _this2.configloja.emails = [{ id: null, assunto: null, tipo: null, corpo: null }];
                }
                if (_this2.configloja.hasOwnProperty('b2b') == false) {
                  _this2.configloja.b2b = false;
                }
                if (_this2.configloja.hasOwnProperty('valor_minimo_pedido') == false) {
                  _this2.configloja.valor_minimo_pedido = null;
                }

                _context.next = 37;
                break;

              case 29:
                // INCLUI UMA FILIAL
                _this2.filial = _extends({}, _this2.$store.getters.getEntities.filial);
                _this2.filial.nome = _this2.$store.getters.getSessao.empresa_nome;
                _this2.filial.fantasia = _this2.$store.getters.getSessao.empresa_nome;
                _this2.filial.cnpj = _this2.$store.getters.getSessao.cnpj;
                _context.next = 35;
                return _this2.apiPostFilial('post');

              case 35:
                _this2.loadData();
                return _context.abrupt('return');

              case 37:

                _this2.loadLogotipo();

                if (!_this2.configloja.controlaestoque) _this2.configloja.controlaestoque = false;
                if (!_this2.configloja.formaspagamento) _this2.configloja.formaspagamento = [];
                if (!_this2.configloja.formasenvio) _this2.configloja.formasenvio = [];
                if (!_this2.configloja.habilitaRetirada) {
                  _this2.configloja.habilitaRetirada = false;
                  _this2.configloja.retirada = _this2.retirada;
                }
                if (!_this2.configloja.rodape) {
                  _this2.configloja.rodape = _this2.rodapeObj;
                }
                if (!_this2.configloja.rodape.bandeiras) {
                  _this2.configloja.rodape.habilitaBandeiras = true;
                  _this2.configloja.rodape.bandeiras = _this2.rodapeObj.bandeiras;
                }
                if (!_this2.configloja.rodape.formasenvio) {
                  _this2.configloja.rodape.habilitaFormasEnvio = true;
                  _this2.configloja.rodape.formasenvio = _this2.rodapeObj.formasenvio;
                }
                if (!_this2.configloja.rodape.atendimento_obs) {
                  _this2.configloja.rodape.atendimento_obs = null;
                }
                if (!_this2.configloja.bordas_laterais_add) {
                  _this2.configloja.bordas_laterais_add = false;
                  _this2.configloja.bordas_laterais = 0;
                }
                if (!_this2.configloja.bordas_laterais) {
                  _this2.configloja.bordas_laterais = 0;
                }
                if (!_this2.configloja.categoria_iniciar_aberta) {
                  _this2.configloja.categoria_iniciar_aberta = false;
                }

                if (_this2.parametros.pagonline.hasOwnProperty('cielo')) {
                  if (_this2.parametros.pagonline.cielo.hasOwnProperty('desconto') == false) {
                    _this2.parametros.pagonline.cielo.desconto = null;
                  }
                  if (_this2.parametros.pagonline.cielo.hasOwnProperty('observacao') == false) {
                    _this2.parametros.pagonline.cielo.observacao = null;
                  }
                }

                if (_this2.parametros.pagonline.hasOwnProperty('rede')) {
                  if (_this2.parametros.pagonline.rede.hasOwnProperty('desconto') == false) {
                    _this2.parametros.pagonline.rede.desconto = null;
                  }
                  if (_this2.parametros.pagonline.rede.hasOwnProperty('observacao') == false) {
                    _this2.parametros.pagonline.rede.observacao = null;
                  }
                }

                if (_this2.parametros.pagonline.hasOwnProperty('shopline')) {
                  if (_this2.parametros.pagonline.shopline.hasOwnProperty('desconto') == false) {
                    _this2.parametros.pagonline.shopline.desconto = null;
                  }
                  if (_this2.parametros.pagonline.shopline.hasOwnProperty('observacao') == false) {
                    _this2.parametros.pagonline.shopline.observacao = null;
                  }
                }

                if (_this2.parametros.pagonline.hasOwnProperty('pixitau')) {
                  if (_this2.parametros.pagonline.pixitau.hasOwnProperty('desconto') == false) {
                    _this2.parametros.pagonline.pixitau.desconto = null;
                  }
                  if (_this2.parametros.pagonline.pixitau.hasOwnProperty('observacao') == false) {
                    _this2.parametros.pagonline.pixitau.observacao = null;
                  }
                }

                if (_this2.parametros.pagonline.hasOwnProperty('pagseguro')) {
                  if (_this2.parametros.pagonline.pagseguro.hasOwnProperty('desconto') == false) {
                    _this2.parametros.pagonline.pagseguro.desconto = null;
                  }
                  if (_this2.parametros.pagonline.pagseguro.hasOwnProperty('observacao') == false) {
                    _this2.parametros.pagonline.pagseguro.observacao = null;
                  }
                }

                _this2.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 55:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    apiPostFilial: function apiPostFilial(metodo) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var sendData, modulo, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                //efetua a gravacao
                _this3.filial.parametros = _this3.parametros;
                _this3.filial.parametrosloja = _this3.configloja;
                sendData = { filial: _this3.filial };
                modulo = 'cg/filial/';
                _context2.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this3.$store, modulo, sendData, metodo);

              case 6:
                data = _context2.sent;

                if (data.errmessages) {
                  _this3.errmessages = data.errmessages;
                  _this3.$erpToastError('Alguns erros precisam ser corrigidos.');
                } else {
                  _this3.$erpToastUpdated();
                  _this3.errmessages = {};
                  console.log(_this3.configloja);
                  __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].loja_b2b = _this3.configloja.b2b == true;
                }

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    handleClickAdicionaImagem: function handleClickAdicionaImagem(tipo) {
      var obj = {
        image: null,
        tipo: tipo,
        url: null,
        coddoc: null
      };
      this.uploadingImage = obj;
      this.$refs.file.value = '';
      this.$refs.file.click();
    },
    handleUploadBanner: function handleUploadBanner(event) {
      if (event.target.files[0]['type'] !== 'image/jpeg' && event.target.files[0]['type'] !== 'image/png') {
        this.$erpToastError('Arquivo não permitido');
        return;
      }
      this.selectedFile = this.$refs.file.files[0];
      // image: URL.createObjectURL(this.selectedFile),
      this.uploading = true;
      this.apiUploadBanner(this.selectedFile, this.callBackUpload);
    },
    callBackUpload: function callBackUpload(data, error) {
      this.uploading = false;
      if (data) {
        this.uploadingImage.url = data.url;
        this.uploadingImage.coddoc = data.coddoc;
        if (this.uploadingImage.tipo == 'desktop') this.configloja.banners_desktop.push(this.uploadingImage);else this.configloja.banners_mobile.push(this.uploadingImage);
        this.apiPostFilial('put');
        this.$erpToastSuccess('Documento atualizado');
      }
      if (error) {
        this.$erpToastError('erro: ' + error);
      }
    },
    apiUploadBanner: function apiUploadBanner(selectedFile, callBack) {
      var formData = new FormData();
      formData.append('file', selectedFile);

      var url = this.$store.getters.urlOrds + 'docs/';
      var self = this;
      var ref = 'bannerloja';

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'ref': ref,
          'chaveref': null,
          'filename': selectedFile.name
        }
      }).then(function (response) {
        if (response.data.items) {
          if (callBack) callBack(response.data.items[0]);
        }
      });
    },
    apiDeleteBanner: function apiDeleteBanner(imagens, index) {
      //REMOVE A IMAGEM E ATUALIZA A CONFIGURACAO DA LOJA
      var url = this.$store.getters.urlOrds + 'docs/' + imagens[index].coddoc;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(url).then(function (data) {
        imagens.splice(index, 1);
        //ATUALIZA A CONFIGURACAO DA LOJA
        self.apiPostFilial('put');
        self.$erpToastSuccess('O arquivo foi removido');
      });
    },
    loadLogotipo: function loadLogotipo() {
      var _this4 = this;

      Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSmidia"])(this.$store.getters.urlApp + 'logo/download/' + this.filial.codempresa + '/' + this.filial.codfil).then(function (data) {
        if (data && data.size > 0) {
          var self = _this4;
          var reader = new window.FileReader();
          reader.readAsDataURL(data);
          reader.onload = function () {
            self.image = reader.result;
          };
        }
      });
    },
    handleClickLogotipo: function handleClickLogotipo(cod) {
      this.$refs.logotipo.value = '';
      this.$refs.logotipo.click();
    },
    handleUploadLogotipo: function handleUploadLogotipo(event) {
      this.selectedFile = event.target.files[0];
      // this.urlImage = URL.createObjectURL(this.selectedFile)
      this.uploadLogotipo();
    },
    uploadLogotipo: function uploadLogotipo() {
      //EFETUA O UPLOAD DO LOGOTIPO

      var formData = new FormData();
      formData.append('file', this.selectedFile);

      var url = this.$store.getters.urlApp + 'logo/';

      var self = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'codfilial': this.filial.codfil,
          'filename': this.selectedFile.name
        }
      }).then(function (data) {
        self.$erpToastSuccess('O logotipo foi atualizado com sucesso.');
        self.loadLogotipo();
      });
    },
    updateCep: function updateCep() {
      //CARREGA INFORMACOES DO CEP
      this.filial.ende = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.logradouro;
      this.filial.bairro = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.bairro;
      this.filial.codmun = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.ibge;
      this.filial.uf = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.uf;
    },
    handleNewPagina: function handleNewPagina() {
      this.pagina = { titulo: '', html: '', ativa: false };
      this.showModalPagina();
    },
    handleSavePagina: function handleSavePagina(pagina) {
      var index = this.configloja.paginas.indexOf(pagina);

      if (this.configloja.paginas.includes(pagina)) {
        this.configloja.paginas[index] = pagina;
      } else {
        this.configloja.paginas.unshift(pagina);
      }

      this.closeModalPaginas();
    },
    handleEditPagina: function handleEditPagina(index) {
      this.pagina = this.configloja.paginas[index];
      this.showModalPagina();
    },
    showModalPagina: function showModalPagina() {
      this.showModalPaginas = true;
    },
    closeModalPaginas: function closeModalPaginas() {
      this.pagina = null;
      this.showModalPaginas = false;
    }
  },

  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {
    this.$nextTick(function () {
      // this.$refs.nome.focus()
    });
  },
  created: function created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });

    this.loadData();
  }
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_formasenvio_form_loja__ = __webpack_require__(1904);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        obj: { type: Object }
    },

    components: {
        FormasenvioForm: __WEBPACK_IMPORTED_MODULE_2__config_formasenvio_form_loja__["a" /* default */]
    },

    data: function data() {
        return {
            index: null,
            formaenvioobj: null,
            showForm: false,
            showConfigShippingMethods: false
        };
    },


    computed: {},

    filters: {},

    methods: {
        handleDesativar: function handleDesativar(formaenvio, idx) {
            this.obj.formasenvio[idx].excluido = true;
            this.$emit('saveconfig');
        },
        handleAtivar: function handleAtivar(formaenvio, idx) {
            this.obj.formasenvio[idx].excluido = false;
            this.$emit('saveconfig');
        },
        handleNew: function handleNew() {
            this.index = -1;
            this.formaenvioobj = null;
            this.showForm = true;
        },
        handleEdit: function handleEdit(idx) {
            this.index = idx;
            this.formaenvioobj = _extends({}, this.obj.formasenvio[idx]);
            this.showForm = true;
        },
        handleCancel: function handleCancel() {
            this.showForm = false;
        },
        handleConfirma: function handleConfirma(formaenvio) {
            this.showForm = false;
            if (this.index >= 0) this.obj.formasenvio[this.index] = formaenvio;else this.obj.formasenvio.push(formaenvio);
            this.$emit('saveconfig');
        }
    },

    watch: {},

    mounted: function mounted() {},
    created: function created() {}
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        obj: { type: Object }
    },

    data: function data() {
        return {
            errorMessage: '',

            envioobj: {
                descricao: '',
                prazoenvio: null,
                adicionacusto: false,
                taxaentrega: 0,
                restringepeso: false,
                pesomaximo: 0,
                pesominimo: 0,
                retringevalor: false,
                totalmaximo: 0,
                totalminimo: 0
            }

        };
    },


    computed: {
        title: function title() {
            if (this.obj) return 'Editar forma de envio';else return 'Adicionar forma de envio';
        }
    },

    filters: {},

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        validarDados: function validarDados() {
            var _this = this;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.handleConfirmar();
                }
            });
        },
        handleConfirmar: function handleConfirmar() {
            if (!this.envioobj.adicionacusto) this.envioobj.taxaentrega = 0;
            if (!this.envioobj.restricaopeso) {
                this.envioobj.pesomaximo = null;
                this.envioobj.pesominimo = null;
            }
            if (!this.envioobj.restricaovalor) {
                this.envioobj.valormaximo = null;
                this.envioobj.valorminimo = null;
            }
            this.$emit('confirma', this.envioobj);
        }
    },

    watch: {},

    mounted: function mounted() {
        this.$nextTick(function () {
            this.$refs.descricao.focus();
        });
    },
    created: function created() {
        if (this.obj) {
            this.envioobj = _extends({}, this.obj);
        }
        console.log(this.envioobj);
    }
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_formaspagamento_form_loja__ = __webpack_require__(1912);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        obj: { type: Object }
    },

    components: {
        FormaspagamentoForm: __WEBPACK_IMPORTED_MODULE_2__config_formaspagamento_form_loja__["a" /* default */]
    },

    data: function data() {
        return {
            index: null,
            formapagamentoobj: null,
            showForm: false,
            showConfigPayMethods: false
        };
    },


    computed: {},

    filters: {},

    methods: {
        handleShowConfigPayMethods: function handleShowConfigPayMethods() {
            this.showConfigPayMethods = !this.showConfigPayMethods;
        },
        handleDesativar: function handleDesativar(formapagamento, idx) {
            this.obj.formaspagamento[idx].excluido = true;
            this.$emit('saveconfig');
        },
        handleAtivar: function handleAtivar(formapagamento, idx) {
            this.obj.formaspagamento[idx].excluido = false;
            this.$emit('saveconfig');
        },
        handleNew: function handleNew() {
            this.showConfigPayMethods = true;
            this.index = -1;
            this.formapagamentoobj = null;
            this.showForm = true;
        },
        handleEdit: function handleEdit(idx) {
            this.index = idx;
            this.formapagamentoobj = _extends({}, this.obj.formaspagamento[idx]);
            this.showForm = true;
        },
        handleCancel: function handleCancel() {
            this.showForm = false;
        },
        handleConfirma: function handleConfirma(formapagamento) {
            this.showForm = false;
            if (this.index >= 0) this.obj.formaspagamento[this.index] = formapagamento;else this.obj.formaspagamento.push(formapagamento);
            this.$emit('saveconfig');
        }
    },

    watch: {},

    mounted: function mounted() {},
    created: function created() {}
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        obj: { type: Object }
    },

    data: function data() {
        return {
            errorMessage: '',

            formapagamentoobj: {
                descricao: 'A Combinar',
                obs: 'Entraremos em contato para acertar os detalhes do pagamento.',
                desconto: null,
                id: null,
                habilitarRetirada: true,
                excluido: false
            }

        };
    },


    computed: {
        title: function title() {
            return 'Adicionar forma de pagamento';
        }
    },

    filters: {},

    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        validarDados: function validarDados() {
            var _this = this;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.handleConfirmar();
                }
            });
        },
        handleConfirmar: function handleConfirmar() {
            this.$emit('confirma', this.formapagamentoobj);
        }
    },

    watch: {},

    mounted: function mounted() {
        this.$nextTick(function () {
            this.$refs.descricao.focus();
        });
    },
    created: function created() {
        if (this.obj) this.formapagamentoobj = _extends({}, this.obj);
    }
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        obj: { type: Object }
    },

    components: {},

    data: function data() {
        return {
            editing: false,
            retiradaObj: null
        };
    },


    computed: {},

    filters: {},

    methods: {
        handleDesativar: function handleDesativar() {
            this.obj.habilitaRetirada = false;
            this.$emit('saveconfig');
        },
        handleAtivar: function handleAtivar() {
            this.editing = true;
            this.retiradaObj = _extends({}, this.obj.retirada);
            this.$nextTick(function () {
                this.$refs.nome.focus();
            });
        },
        handleSalvar: function handleSalvar() {
            var _this = this;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.obj.habilitaRetirada = true;
                    _this.editing = false;
                    _this.$emit('saveconfig');
                }
            });
        },
        handleEdit: function handleEdit() {
            this.retiradaObj = _extends({}, this.obj.retirada);
            this.editing = true;
            this.$nextTick(function () {
                this.$refs.nome.focus();
            });
        },
        handleCancelar: function handleCancelar() {
            this.obj.retirada = this.retiradaObj;
            this.editing = false;
            this.$emit('saveconfig');
        }
    },

    watch: {},

    mounted: function mounted() {},
    created: function created() {}
});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        obj: { type: Object }
    },

    components: {},

    data: function data() {
        return {
            editing: false,
            correiosObj: null
        };
    },


    computed: {},

    filters: {},

    methods: {
        handleDesativar: function handleDesativar() {
            this.obj.habilitaCorreios = false;
            this.$emit('saveconfig');
        },
        handleAtivar: function handleAtivar() {
            this.editing = true;
            this.correiosObj = _extends({}, this.obj.correios);
            this.$nextTick(function () {
                this.$refs.nome.focus();
            });
        },
        handleSalvar: function handleSalvar() {
            var _this = this;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.obj.habilitaCorreios = true;
                    _this.editing = false;
                    _this.$emit('saveconfig');
                }
            });
        },
        handleEdit: function handleEdit() {
            this.correiosObj = _extends({}, this.obj.correios);
            this.editing = true;
            this.$nextTick(function () {
                this.$refs.nome.focus();
            });
        },
        handleCancelar: function handleCancelar() {
            this.obj.correios = this.correiosObj;
            this.editing = false;
            this.$emit('saveconfig');
        }
    },

    watch: {},

    mounted: function mounted() {},
    created: function created() {}
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        obj: { type: Object }
    },

    components: {},

    data: function data() {
        return {
            editing: false,
            melhorenvioObj: null
        };
    },


    computed: {},

    filters: {},

    methods: {
        handleDesativar: function handleDesativar() {
            this.obj.habilitaMelhorenvio = false;
            console.log(this.obj.habilitaMelhorenvio);
            this.$emit('saveconfig');
        },
        handleAtivar: function handleAtivar() {
            this.editing = true;
            this.melhorenvioObj = _extends({}, this.obj.melhorenvio);
            this.$nextTick(function () {
                this.$refs.clientid.focus();
            });
        },
        handleSalvar: function handleSalvar() {
            var _this = this;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.obj.habilitaMelhorenvio = true;
                    _this.editing = false;
                    _this.$emit('saveconfig');
                }
            });
        },
        handleEdit: function handleEdit() {
            this.melhorenvioObj = _extends({}, this.obj.melhorenvio);
            this.editing = true;
            this.$nextTick(function () {
                this.$refs.clientid.focus();
            });
        },
        handleCancelar: function handleCancelar() {
            this.obj.melhorenvio = this.melhorenvioObj;
            this.editing = false;
            this.$emit('saveconfig');
        }
    },

    watch: {},

    mounted: function mounted() {},
    created: function created() {}
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_button_vue__ = __webpack_require__(164);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        parametros: { type: Object }
    },

    components: {
        Button: __WEBPACK_IMPORTED_MODULE_2__components_button_vue__["default"]
    },

    data: function data() {
        return {
            editingShopline: false,
            editingCielo: false,
            editingRede: false,
            editingPixitau: false,
            editingPagseguro: false,
            editingRedeObj: null,
            editingCieloObj: null,
            editingShoplineObj: null,
            editingPixitauObj: null,
            editingPagseguroObj: null,
            showAccordionCielo: false,
            showAccordionRede: false,
            showAccordionShopline: false,
            showAccordionPixItau: false,
            showAccordionPagSeguro: false
        };
    },


    computed: {},

    filters: {},
    methods: {
        handleAccordion: function handleAccordion(operadora) {
            this.resetAccordionVariables(operadora);
            if (operadora == 'cielo') {
                this.showAccordionCielo = !this.showAccordionCielo;
            }
            if (operadora == 'rede') {
                this.showAccordionRede = !this.showAccordionRede;
            }
            if (operadora == 'shopline') {
                this.showAccordionShopline = !this.showAccordionShopline;
            }
            if (operadora == 'pix-itau') {
                this.showAccordionPixItau = !this.showAccordionPixItau;
            }
            if (operadora == 'pagseguro') {
                this.showAccordionPagSeguro = !this.showAccordionPagSeguro;
            }
        },
        resetAccordionVariables: function resetAccordionVariables(operadora) {
            if (operadora == 'cielo') {
                this.showAccordionRede = false;
                this.showAccordionShopline = false;
                this.showAccordionPixItau = false;
                this.showAccordionPagSeguro = false;
            }
            if (operadora == 'rede') {
                this.showAccordionCielo = false;
                this.showAccordionShopline = false;
                this.showAccordionPixItau = false;
                this.showAccordionPagSeguro = false;
            }
            if (operadora == 'shopline') {
                this.showAccordionCielo = false;
                this.showAccordionRede = false;
                this.showAccordionPixItau = false;
                this.showAccordionPagSeguro = false;
            }
            if (operadora == 'pix-itau') {
                this.showAccordionCielo = false;
                this.showAccordionRede = false;
                this.showAccordionShopline = false;
                this.showAccordionPagSeguro = false;
            }
            if (operadora == 'pagseguro') {
                this.showAccordionCielo = false;
                this.showAccordionRede = false;
                this.showAccordionShopline = false;
                this.showAccordionPixItau = false;
            }
        },
        handleDesativar: function handleDesativar(operadora) {
            if (operadora == 'cielo') {
                this.parametros.pagonline.habilitaCielo = false;
                this.parametros.pagonline.habilitaCieloCheckout = false;
            }
            if (operadora == 'rede') {
                this.parametros.pagonline.habilitaRede = false;
                this.parametros.pagonline.habilitaRedeCheckout = false;
            }
            if (operadora == 'shopline') {
                this.parametros.pagonline.habilitaShopline = false;
                this.parametros.pagonline.habilitaShoplineCheckout = false;
            }
            if (operadora == 'pixitau') {
                this.parametros.pagonline.habilitaPixitau = false;
                this.parametros.pagonline.habilitaPixitauCheckout = false;
            }
            if (operadora == 'pagseguro') {
                this.parametros.pagonline.habilitaPagseguro = false;
                this.parametros.pagonline.habilitaPagseguroCheckout = false;
            }
            this.$emit('saveconfig');
        },
        handleAtivar: function handleAtivar(operadora) {
            if (operadora == 'cielo') {
                this.editingCielo = true;
                this.editingCieloObj = _extends({}, this.parametros.pagonline.cielo);
            }
            if (operadora == 'shopline') {
                this.editingShopline = true;
                if (!this.parametros.pagonline.shopline) this.parametros.pagonline.shopline = { codigosite: '', chave: '', observacaoboleto: null, desconto: null, observacao: null };
                this.editingShoplineObj = _extends({}, this.parametros.pagonline.shopline);
            }
            if (operadora == 'rede') {
                this.editingRede = true;
                this.editingRedeObj = _extends({}, this.parametros.pagonline.rede);
            }
            if (operadora == 'pixitau') {
                this.editingPixitau = true;
                if (!this.parametros.pagonline.pixitau) this.parametros.pagonline.pixitau = { clientid: null, clientsecret: null, desconto: null, observacao: null };
                this.editingPixitauObj = _extends({}, this.parametros.pagonline.pixitau);
            }
            if (operadora == 'pagseguro') {
                this.editingPagseguro = true;
                if (!this.parametros.pagonline.pagseguro) this.parametros.pagonline.pagseguro = { email: '', token: '', desconto: null, observacao: null };
                this.editingPagseguroObj = _extends({}, this.parametros.pagonline.pagseguro);
            }
        },
        handleSalvarRede: function handleSalvarRede() {
            this.parametros.pagonline.habilitaRede = true;
            this.editingRede = false;
            this.$emit('saveconfig');
        },
        handleCancelarRede: function handleCancelarRede() {
            this.parametros.pagonline.rede = this.editingRedeObj;
            this.editingRede = false;
            this.$emit('saveconfig');
        },
        handleSalvarPixitau: function handleSalvarPixitau() {
            this.parametros.pagonline.habilitaPixitau = true;
            this.editingPixitau = false;
            this.$emit('saveconfig');
        },
        handleCancelarPixitau: function handleCancelarPixitau() {
            this.parametros.pagonline.pixitau = this.editingPixitauObj;
            this.editingPixitau = false;
            this.$emit('saveconfig');
        },
        handleSalvarCielo: function handleSalvarCielo() {
            this.parametros.pagonline.habilitaCielo = true;
            this.editingCielo = false;
            this.$emit('saveconfig');
        },
        handleSalvarShopline: function handleSalvarShopline() {
            this.parametros.pagonline.habilitaShopline = true;
            this.editingShopline = false;
            this.$emit('saveconfig');
        },
        handleCancelarCielo: function handleCancelarCielo() {
            this.parametros.pagonline.cielo = this.editingCieloObj;
            this.editingCielo = false;
            this.$emit('saveconfig');
        },
        handleCancelarShopline: function handleCancelarShopline() {
            this.parametros.pagonline.shopline = this.editingShoplineObj;
            this.editingShopline = false;
            this.$emit('saveconfig');
        },
        handleEditCielo: function handleEditCielo() {
            this.editingCieloObj = _extends({}, this.parametros.pagonline.cielo);
            this.editingCielo = true;
        },
        handleEditPixitau: function handleEditPixitau() {
            this.editingPixitauObj = _extends({}, this.parametros.pagonline.pixitau);
            this.editingPixitau = true;
        },
        handleEditShopline: function handleEditShopline() {
            this.editingShoplineObj = _extends({}, this.parametros.pagonline.shopline);
            this.editingShopline = true;
        },
        handleEditRede: function handleEditRede() {
            this.editingRedeObj = _extends({}, this.parametros.pagonline.rede);
            this.editingRede = true;
        },
        handleEditPagseguro: function handleEditPagseguro() {
            this.editingPagseguroObj = _extends({}, this.parametros.pagonline.pagseguro);
            this.editingPagseguro = true;
        },
        handleSalvarPagseguro: function handleSalvarPagseguro() {
            this.parametros.pagonline.habilitaPagseguro = true;
            this.editingPagseguro = false;
            this.$emit('saveconfig');
        },
        handleCancelarPagseguro: function handleCancelarPagseguro() {
            this.parametros.pagonline.pagseguro = this.editingPagseguroObj;
            this.editingPagseguro = false;
            this.$emit('saveconfig');
        }
    },

    watch: {},

    mounted: function mounted() {},
    created: function created() {
        this.parametros.pagonline.habilitaShopline = false;
    }
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        parametros: { type: Object }
    },

    components: {},

    data: function data() {
        return {
            editingBandeiras: false,
            editingBandeirasObj: null,
            showConfigBrand: false
        };
    },


    computed: {},

    filters: {},

    methods: {
        hanleShowConfigBrand: function hanleShowConfigBrand() {
            console.log('entrou');
            this.showConfigBrand = !this.showConfigBrand;
        },
        handleDesativar: function handleDesativar(operadora) {
            if (operadora == 'bandeiras') {
                this.parametros.rodape.habilitaBandeiras = false;
            }
            this.$emit('saveconfig');
        },
        handleAtivar: function handleAtivar(operadora) {
            if (operadora == 'bandeiras') {
                this.editingBandeiras = true;
                if (!this.parametros.rodape.bandeiras) this.parametros.rodape.bandeiras = { boleto: true, visa: true, mcard: true, elo: true, american_express: true, dinners_club: true, hipercard: true, jcb: true, discover: true, aura: true };
                this.editingBandeirasObj = _extends({}, this.parametros.rodape.bandeiras);
            }
        },
        handleSalvarBandeiras: function handleSalvarBandeiras() {
            this.parametros.rodape.habilitaBandeiras = true;
            this.editingBandeiras = true;
            this.editingBandeiras = false;
            this.$emit('saveconfig');
        },
        handleCancelarBandeiras: function handleCancelarBandeiras() {
            this.parametros.rodape.bandeiras = this.editingBandeirasObj;
            this.editingBandeiras = false;
            // this.$emit('saveconfig')
        },
        handleEditBandeiras: function handleEditBandeiras() {
            this.editingBandeirasObj = _extends({}, this.parametros.rodape.bandeiras);
            this.editingBandeiras = true;
        }
    },

    watch: {},

    mounted: function mounted() {},
    created: function created() {}
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        parametros: { type: Object }
    },

    components: {},

    data: function data() {
        return {
            editingClearsale: false,
            editingClearsaleObj: null
        };
    },


    computed: {},

    filters: {},

    methods: {
        handleDesativar: function handleDesativar(operadora) {
            if (operadora == 'clearsale') {
                this.parametros.analisefraude.habilitaClearsale = false;
            }
            this.$emit('saveconfig');
        },
        handleAtivar: function handleAtivar(operadora) {
            if (operadora == 'clearsale') {
                this.editingClearsale = true;
                this.editingClearsaleObj = _extends({}, this.parametros.analisefraude.clearsale);
            }
        },
        handleSalvarClearsale: function handleSalvarClearsale() {
            this.parametros.analisefraude.habilitaClearsale = true;
            this.editingClearsale = false;
            this.$emit('saveconfig');
        },
        handleCancelarClearsale: function handleCancelarClearsale() {
            this.parametros.analisefraude.clearsale = this.editingClearsaleObj;
            this.editingClearsale = false;
            this.$emit('saveconfig');
        },
        handleEditClearsale: function handleEditClearsale() {
            this.editingClearsaleObj = _extends({}, this.parametros.analisefraude.clearsale);
            this.editingClearsale = true;
        }
    },

    watch: {},

    mounted: function mounted() {},
    created: function created() {}
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        parametros: { type: Object }
    },

    components: {},

    data: function data() {
        return {
            editingFormasEnvio: false,
            editingFormasEnvioObj: null,
            showConfigShippingMethods: false
        };
    },


    computed: {},

    filters: {},

    methods: {
        handleDesativar: function handleDesativar(operadora) {
            if (operadora == 'formasenvio') {
                this.parametros.rodape.habilitaFormasEnvio = false;
            }
            this.$emit('saveconfig');
        },
        handleAtivar: function handleAtivar(operadora) {
            if (operadora == 'formasenvio') {
                this.editingFormasEnvio = true;
                if (!this.parametros.rodape.formasenvio) this.parametros.rodape.formasenvio = { correios: true, pac: true, sedex: true };
                this.editingFormasEnvioObj = _extends({}, this.parametros.rodape.fomasenvio);
            }
        },
        handleSalvarFormasEnvio: function handleSalvarFormasEnvio() {
            this.parametros.rodape.habilitaFormasEnvio = true;
            this.editingFormasEnvio = true;
            this.$emit('saveconfig');
        },
        handleCancelarFormasEnvio: function handleCancelarFormasEnvio() {
            this.parametros.rodape.formasenvio = this.editingFormasEnvioObj;
            this.editingFormasEnvio = false;
            this.$emit('saveconfig');
        },
        handleEditFormasEnvio: function handleEditFormasEnvio() {
            this.editingFormasEnvioObj = _extends({}, this.parametros.rodape.formasenvio);
            this.editingFormasEnvio = true;
        }
    },

    watch: {},

    mounted: function mounted() {},
    created: function created() {}
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        parametros: ''
    },
    data: function data() {
        return {
            mail: {},
            indexUpdate: null,
            showModalMail: false,
            mailBackup: {},
            mailOptions: [{ id: 'BV', text: 'Boas Vindas' }, { id: 'PA', text: 'Pagamento Aprovado' }, { id: 'PN', text: 'Pagamento Não Aprovado' }]
        };
    },

    methods: {
        handleNewMail: function handleNewMail() {
            this.showModalMail = true;
            this.mail = {};
        },
        closeForm: function closeForm() {
            this.showModalMail = false;
        },
        handleCancelMail: function handleCancelMail(index) {
            this.$emit('deleteMode', index);
        },
        handleSaveMail: function handleSaveMail(mail) {
            var index = this.indexUpdate;
            if (index != null) {
                this.$emit('editMode', { mail: mail, index: index });
                this.indexUpdate = null;
                this.mailBackup = {};
            } else {
                this.$emit('insertMode', mail);
            }
            this.closeForm();
        },
        handleEditMail: function handleEditMail(index) {
            this.mail = _extends({}, this.parametros.emails[index]);
            this.indexUpdate = index;
            this.showModalMail = true;
        }
    },
    created: function created() {
        console.log(this.parametros);
    }
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_customer_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codpart: '',
            metadata: this.$store.getters.getEntities.metadata
        };
    },


    computed: {
        partList: function partList() {
            return this.$store.getters.getPartList;
        },

        controleLimiteCredito: function controleLimiteCredito() {
            return true;
        }
    },

    methods: {
        editPart: function editPart(codpart) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU; //update
            this.codpart = codpart;
            this.showForm = true;
        },
        incluirPart: function incluirPart(codpart) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
            this.codpart = codpart;
            this.showForm = true;
        },
        onAction: function onAction(action) {},
        closeForm: function closeForm() {
            this.showForm = false;
        },
        search: function search(value) {
            this.filter = '{"$or":[{"nome":{"$like":"' + value + '%25"}},{"fantasia":{"$like":"' + value + '%25"}},{"codpart":{"$eq":"' + value + '"}},{"cnpjcpf":{"$eq":"' + value + '"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadTransportadoras', { filter: this.filter });
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], CustomerForm: __WEBPACK_IMPORTED_MODULE_2__forms_customer_form__["default"]
    },

    mounted: function mounted() {},
    beforeDestroy: function beforeDestroy() {},
    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',

            idempresa: '',

            pedv: _extends({}, this.$store.getters.getEntities.pedv),
            cartao: { nome: null,
                numero: null,
                valmes: null,
                valano: null,
                codsec: null
            },
            pedvit: {},
            pedvpar: [], //parcelas do pedido
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: {} //armazena as mensagens de validacao do pedido de venda apos a gravacao

        };
    },


    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm() {
            if (this.$route.params && this.$route.params.codnegocio) this.$router.go(-1);else if (this.$route.params && this.$route.params.id) this.$router.push('/pedidolist');else this.$emit('closeform');
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiPost(_this.idempresa);
                }
            });
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this2.crud = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI;

                                if (_this2.$route.params) {
                                    if (_this2.$route.params.id && _this2.$route.params.id != 'novo') {
                                        _this2.index = _this2.$route.params.id;
                                    }
                                    if (_this2.$route.params.idempresa) {
                                        _this2.idempresa = _this2.$route.params.idempresa;
                                    }
                                }

                                //carrega o registro para alteracao ou visualizacao
                                _this2.unwatch = true;

                                _context.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSapp"])(_this2, 'pedv/' + _this2.index + '/' + _this2.idempresa, 'get');

                            case 5:
                                data = _context.sent;

                                if (data.items) {
                                    console.log(data.items[0]);
                                    _this2.pedv = _extends({}, data.items[0]);
                                    _this2.pedvit = _this2.pedv.pedvit;

                                    console.log(_this2.pedv);

                                    _this2.cartao = { nome: null,
                                        numero: null,
                                        valmes: null,
                                        valano: null,
                                        codsec: null
                                    };
                                    if (_this2.pedv.validation) _this2.errmessages = JSON.parse(_this2.pedv.validation);
                                    if (_this2.pedv.pedvpar) {
                                        _this2.pedvpar = _this2.pedv.pedvpar;
                                    }

                                    _this2.updateActions(); //ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES" AO CARREGAR UM PEDIDO
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                    this.unwatch = false;
                                });

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        apiPost: function apiPost(idempresa) {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, sendData, metodo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetua a gravacao

                                modulo = 'pagamentorede/' + _this3.idempresa;
                                sendData = {};


                                sendData = { pedv: _this3.pedv, cartao: _this3.cartao };

                                metodo = 'post';
                                _context2.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["lojaORDSpost"])(_this3.$store, modulo, sendData, metodo);

                            case 6:
                                data = _context2.sent;

                                if (data.errmessages) {
                                    _this3.errmessages = data.errmessages;
                                    _this3.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this3.$erpToastUpdated();
                                    } else {
                                        _this3.$erpToastInserted();
                                    }
                                    _this3.errmessages = {};
                                    _this3.closeForm();
                                }

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.crudText = this.$crudText(this.crud);

        this.loadData();

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.nome.focus();
        });
    }
});

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {},

    data: function data() {
        return {
            videos: {
                visao: {
                    url: '',
                    video: '//www.youtube.com/embed/wvl-3cP4LbA'
                },
                config: {
                    url: '',
                    video: '//www.youtube.com/embed/JWNNS9eHIeI'
                },
                importar: {
                    url: '',
                    video: '//www.youtube.com/embed/6Bmo4YZTmII'
                },
                categorias: {
                    url: '',
                    video: '//www.youtube.com/embed/dTzPlrNo97k'
                },
                produtos: {
                    url: '',
                    video: '//www.youtube.com/embed/Q9UtMhZGyiw'
                },
                precos: {
                    url: '',
                    video: '//www.youtube.com/embed/ZqW9c7_BQGE'
                },
                promocao: {
                    url: '',
                    video: '//www.youtube.com/embed/atVVQ1Gp3PM'
                },
                destaque: {
                    url: '',
                    video: '//www.youtube.com/embed/8QyMz3Xloo0'
                },
                pedidos: {
                    url: '',
                    video: '//www.youtube.com/embed/mD52DRPD5Ck'
                }
            },

            showMensagem: false

        };
    },


    computed: {
        showGuia: function showGuia() {
            return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].guia;
        }
    },

    watch: {},

    methods: {
        apiPost: function apiPost() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var ativacao;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSapp"])(_this, 'usuario/guia/', 'post', null);

                            case 2:
                                ativacao = _context.sent;

                                _this.$appLoading(false);
                                __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].guia = false;
                                _this.showMensagem = true;

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    mounted: function mounted() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
    },
    created: function created() {}
});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__crm_filtros__ = __webpack_require__(1967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__crm_filtros_negocio__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__crm_painel_etapa__ = __webpack_require__(1974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_painel_timeline__ = __webpack_require__(1985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__crm_painel_list__ = __webpack_require__(1993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__crm_pessoa_form__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__crm_pessoa_novo_form__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crm_org_novo_form__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__crm_negocio_novo_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__crm_negocio_form__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__crm_funil_form__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__crm_public_form__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            metadata: this.$store.getters.getEntities.metadata,

            mounted: false,

            showEtapa: true,
            showTimeline: false,
            showLista: false,

            formNegocio: false,
            formNovoNegocio: false,
            codnegocio: null,

            showFormPessoa: false,
            showFormOrg: false,
            showPublicForm: false,

            formFunil: false,
            codfunil: null,

            moreActions: [//botao mais acoes
            { action: 1, label: 'Incluir Funil' }, { action: 2, label: 'Editar Funil Atual' }],

            selectedUsuario: null,
            selectedFunil: null,
            selectedFiltroNegocios: null,

            filtroMes: { //objeto utilizado pelo filtro de mes
                startDate: null,
                endDate: null,
                codusuario: null
            },

            inputOrg: {
                url: '/crm/find/organizacao?nome=',
                permitenovo: true,
                // duplicados: true,
                codigo: null,
                label: 'Organização',
                icon: 'fa-university',
                placeholder: 'Organização'
            },

            inputContato: {
                url: '/crm/find/pessoa?nome=',
                // permitenovo: true,
                duplicados: true,
                codigo: null,
                label: 'Contato',
                icon: 'fa-user',
                placeholder: 'Contato'
            }

        };
    },


    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], CrmOrgNovoForm: __WEBPACK_IMPORTED_MODULE_8__crm_org_novo_form__["a" /* default */], CrmPessoaNovoForm: __WEBPACK_IMPORTED_MODULE_7__crm_pessoa_novo_form__["a" /* default */], CrmNegocioNovoForm: __WEBPACK_IMPORTED_MODULE_9__crm_negocio_novo_form__["a" /* default */], CrmNegocioForm: __WEBPACK_IMPORTED_MODULE_10__crm_negocio_form__["default"], CrmPainelEtapa: __WEBPACK_IMPORTED_MODULE_3__crm_painel_etapa__["a" /* default */], CrmPainelTimeline: __WEBPACK_IMPORTED_MODULE_4__crm_painel_timeline__["a" /* default */],
        CrmPainelList: __WEBPACK_IMPORTED_MODULE_5__crm_painel_list__["a" /* default */], CrmFiltros: __WEBPACK_IMPORTED_MODULE_1__crm_filtros__["a" /* default */], CrmFiltrosNegocio: __WEBPACK_IMPORTED_MODULE_2__crm_filtros_negocio__["a" /* default */], CrmFunilForm: __WEBPACK_IMPORTED_MODULE_11__crm_funil_form__["a" /* default */], CrmPublicForm: __WEBPACK_IMPORTED_MODULE_12__crm_public_form__["a" /* default */]
    },

    computed: {
        // pessoaList: function () {
        //     return this.$store.getters.getPessoaList
        // },

        usuarioList: function usuarioList() {
            //lista de usuarios para selecao
            var options = [];
            for (var x = 0; x < this.$store.getters.getUsuarioList.length; x++) {
                options.push({ id: this.$store.getters.getUsuarioList[x].codusuario, text: this.$store.getters.getUsuarioList[x].nome });
            }
            return options;
        },

        etapaList: function etapaList() {
            if (this.$store.getters.getConfigCrm.etapas) return this.$store.getters.getConfigCrm.etapas;else return [];
        },

        funilList: function funilList() {
            if (this.$store.getters.getConfigCrm) return this.$store.getters.getConfigCrm.funil;else return [];
        },

        showPainel: function showPainel() {
            return !this.formNegocio;
        },

        startDate: function startDate() {
            return this.filtroMes.startDate;
        },
        codusuario: function codusuario() {
            return this.filtroMes.codusuario;
        },


        administrador: function administrador() {
            return __WEBPACK_IMPORTED_MODULE_15__main__["SysVars"].usuarioAdministrador;
        }

    },

    watch: {},

    filters: {},

    methods: {
        closeFormNegocio: function closeFormNegocio(negocio) {
            this.formNegocio = false;
            this.formNovoNegocio = false;

            if (negocio && this.$refs.painelEtapa) {
                //ATUALIZA O PAINEL DE ETAPA
                this.$refs.painelEtapa.loadData();
            } else if (negocio && this.$refs.painelTimeline) {
                //ATUALIZA O PAINEL TIMELINE
                this.$refs.painelTimeline.loadData();
            } else if (negocio && this.$refs.painelLista) {
                //ATUALIZA O PAINEL LISTA
                this.$refs.painelLista.loadData();
            }
        },
        handleChangeUsuario: function handleChangeUsuario(cod) {
            this.selectedUsuario = cod;
        },
        handleChangeEquipe: function handleChangeEquipe(cod) {
            this.selectedEquipe = cod;
        },
        handleChangeFiltroNegocios: function handleChangeFiltroNegocios(filtro) {
            /*
            evento acionado pelo crm-filtros-negocio
            */
            this.selectedFiltroNegocios = filtro;
        },
        handleChangeFunil: function handleChangeFunil(cod) {
            var funil = this.funilList.filter(function (option) {
                return option.codfunil == cod;
            });
            funil[0].etapas = this.etapaList.filter(function (option) {
                return option.codfunil == funil[0].codfunil;
            });
            this.selectedFunil = funil[0];
        },
        handleVisaoEtapa: function handleVisaoEtapa() {
            this.showTimeline = false;
            this.showEtapa = true;
            this.showLista = false;
        },
        handleVisaoLista: function handleVisaoLista() {
            this.showTimeline = false;
            this.showEtapa = false;
            this.showLista = true;
        },
        handleVisaoTimeline: function handleVisaoTimeline() {
            this.showEtapa = false;
            this.showTimeline = true;
            this.showLista = false;
        },
        handleMonthChange: function handleMonthChange() {
            // console.log('handleMonthChange')
            // console.log(this.filter)
        },
        handleNovoNegocio: function handleNovoNegocio() {
            this.formNovoNegocio = true;
        },
        handleEditNegocio: function handleEditNegocio(cod) {
            this.codnegocio = cod;
            this.$router.push('/crm/negocio/' + cod);
        },
        handleNovoPessoa: function handleNovoPessoa() {
            this.showFormPessoa = true;
        },
        handleAction: function handleAction(act) {
            if (act == 1) {
                this.handleNovoFunil();
            }
            if (act == 2) {
                this.handleEditarFunil();
            }
        },
        closeFormPessoa: function closeFormPessoa() {
            this.showFormPessoa = false;
        },
        handleNovoOrg: function handleNovoOrg() {
            this.showFormOrg = true;
        },
        closeFormOrg: function closeFormOrg() {
            this.showFormOrg = false;
        },
        handlePublicForm: function handlePublicForm() {
            this.showPublicForm = true;
        },
        closePublicForm: function closePublicForm(negocio) {
            this.showPublicForm = false;
        },
        handleNovoFunil: function handleNovoFunil() {
            this.codfunil = null;
            this.formFunil = true;
        },
        handleEditarFunil: function handleEditarFunil() {
            this.codfunil = this.selectedFunil.codfunil;
            this.formFunil = true;
        },
        handleCloseFormFunil: function handleCloseFormFunil(cod) {
            console.log(cod);
            if (cod) {
                this.loadData(cod);
            }
            this.formFunil = false;
        },
        loadData: function loadData(funil) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadConfigCrm', _this);

                            case 2:

                                if (funil) {
                                    //SE UM NOVO FUNIL FOI CRIADO OU ALTERADO 
                                    _this.handleChangeFunil(funil.codfunil);
                                } else if (!_this.selectedFunil) {
                                    _this.handleChangeFunil(_this.funilList[0].codfunil);
                                }
                                _this.mounted = true;

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import CrmFunilNovo from './crm-pessoa-novo-form'


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: Object
    },

    data: function data() {
        return {
            usuarioOptions: [],

            indexUsuarioSelected: null,

            codusuario: null,
            codequipe: null,
            codfunil: null
        };
    },


    components: {
        // CrmFunilForm
    },

    computed: {

        configCrm: function configCrm() {
            return this.$store.getters.getConfigCrm;
        },
        usuarioList: function usuarioList() {
            if (this.$store.getters.getConfigCrm) return this.$store.getters.getConfigCrm.usuarios_filtro;else return [];
        },
        equipeList: function equipeList() {
            if (this.$store.getters.getConfigCrm) return this.$store.getters.getConfigCrm.equipes;else return [];
        },
        funilList: function funilList() {
            if (this.$store.getters.getConfigCrm) return this.$store.getters.getConfigCrm.funil;else return [];
        },

        administrador: function administrador() {
            return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador;
        }
    },

    watch: {
        configCrm: function configCrm() {
            this.preparaFiltro();
        }

    },

    filters: {},

    methods: {
        handleEditarFunil: function handleEditarFunil(codfunil) {
            this.$emit('editfunil', this.codfunil);
        },
        handleNovoFunil: function handleNovoFunil(codfunil) {
            console.log('novofunil');
            this.$emit('novofunil');
        },
        handleChangeUsuario: function handleChangeUsuario() {
            this.codusuario = this.usuarioOptions[this.indexUsuarioSelected];
            if (this.codusuario == -1) this.codusuario = null;
            this.$emit('changeUsuario', this.codusuario);
        },
        handleChangeFunil: function handleChangeFunil() {
            if (this.codfunil == -1) this.codfunil = null;
            this.$emit('changeFunil', this.codfunil);
        },
        preparaFiltro: function preparaFiltro() {
            if (!this.codfunil && this.funilList.length > 0) this.codfunil = this.funilList[0].codfunil;

            //monta a lista de usuarios e equipes
            var seq = 0;
            this.usuarioOptions = [];
            this.usuarioOptions.push({ group: 'Usuários' });
            for (var x = 0; x < this.usuarioList.length; x++) {
                this.usuarioOptions.push({ id: seq, codusuario: this.usuarioList[x].codusuario, text: this.usuarioList[x].nome });
                seq = seq + 1;
            }
            if (this.equipeList.length > 0) {
                this.usuarioOptions.push({ group: 'Equipe' });
                for (var x = 0; x < this.equipeList.length; x++) {
                    this.usuarioOptions.push({ id: seq, codequipe: this.equipeList[x].codequipe, text: this.equipeList[x].nome });
                    seq = seq + 1;
                }
            }

            if (!this.codusuario) this.codusuario = this.usuarioList[0].codusuario;
        }
    },

    created: function created() {
        this.preparaFiltro();
    }
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
//
//
//
//
//
//
//
//


// import CrmFunilNovo from './crm-pessoa-novo-form'


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: Object,
        pessoas: Boolean,
        organizacao: Boolean,
        negocios: Boolean,
        leads: Boolean
    },

    data: function data() {
        return {

            arrNegocios: [{ id: 0, label: 'Negócios Abertos' }, { id: 1, label: 'Negócios Perdidos' }, { id: 2, label: 'Negócios Fechados' }, { id: 3, label: 'Negócios Estagnados' }, { id: 4, label: 'Negócios Sem Agenda' }],

            arrEquipes: [],

            arrUsuarios: [],

            arrFunil: [],

            arrContatos: [{ id: 0, label: 'Todos' }, { id: 1, label: 'Com negócio em aberto' }, { id: 2, label: 'Com atividade pendente' }, { id: 9, label: 'Excluídos' }],

            arrLeads: [{ id: 0, label: 'Todos' }, { id: 1, label: 'Sem atividades' }, { id: 2, label: 'Atrasados' }, { id: 3, label: 'Com atividades' }, { id: 4, label: 'Arquivados' }],

            arrOrgs: [{ id: 0, label: 'Todas' }, { id: 1, label: 'Com negócio em aberto' }, { id: 2, label: 'Com atividade pendente' }, { id: 9, label: 'Excluídas' }],

            indexFiltroSelected: 0,
            indexUsuarioSelected: 0,
            indexEquipeSelected: 0,
            indexFunilSelected: 0,
            indexContatoSelected: 0,
            indexOrgSelected: 0,

            codusuario: null,
            codequipe: null,

            filtroSelected: null,
            filtroContatoSelected: null,
            filtroOrgSelected: null,
            funilSelected: null
        };
    },


    components: {},

    computed: {
        showFunil: function showFunil() {
            return this.negocios;
        },

        showNegocios: function showNegocios() {
            return this.negocios;
        },

        showPessoas: function showPessoas() {
            return this.pessoas;
        },

        showLeads: function showLeads() {
            return this.leads;
        },

        showOrganizacao: function showOrganizacao() {
            return this.organizacao;
        },

        labelNegocios: function labelNegocios() {
            return this.arrNegocios[this.indexFiltroSelected].label;
        },

        usuarioLabel: function usuarioLabel() {
            if (this.arrUsuarios.length > 0) return this.arrUsuarios[this.indexUsuarioSelected].label;else return null;
        },

        equipeLabel: function equipeLabel() {
            if (this.arrEquipes.length > 0) return this.arrEquipes[this.indexEquipeSelected].label;else return null;
        },

        funilLabel: function funilLabel() {
            if (this.arrFunil.length) return this.arrFunil[this.indexFunilSelected].label;else return null;
        },

        labelContato: function labelContato() {
            return this.arrContatos[this.indexContatoSelected].label;
        },

        labelOrg: function labelOrg() {
            return this.arrOrgs[this.indexOrgSelected].label;
        },

        configCrm: function configCrm() {
            return this.$store.getters.getConfigCrm;
        },

        usuarioList: function usuarioList() {
            if (this.$store.getters.getConfigCrm) return this.$store.getters.getConfigCrm.usuarios_filtro;else return [];
        },

        equipeList: function equipeList() {
            if (this.$store.getters.getConfigCrm) return this.$store.getters.getConfigCrm.equipes;else return [];
        },

        funilList: function funilList() {
            if (this.$store.getters.getConfigCrm) return this.$store.getters.getConfigCrm.funil;else return [];
        },

        administrador: function administrador() {
            return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador;
        }
    },

    watch: {
        configCrm: function configCrm() {
            this.preparaFiltro();
        }

    },

    filters: {},

    methods: {
        handleChangeUsuario: function handleChangeUsuario(index) {
            this.indexUsuarioSelected = index;
            this.codusuario = this.arrUsuarios[index].id;
            if (this.codusuario == -1) this.codusuario = null;
            this.$emit('changeUsuario', this.codusuario);
        },
        handleChangeFiltro: function handleChangeFiltro(index) {
            this.indexFiltroSelected = index;
            this.filtroSelected = this.arrNegocios[index];
            this.$emit('changeFiltro', this.filtroSelected.id);
        },
        handleChangeContatos: function handleChangeContatos(index) {
            this.indexContatoSelected = index;
            this.filtroContatoSelected = this.arrContatos[index];
            this.$emit('changeFiltroContatos', this.filtroContatoSelected.id);
        },
        handleChangeLeads: function handleChangeLeads(index) {
            this.indexLeadSelected = index;
            this.filtroLeadSelected = this.arrLeads[index];
            this.$emit('changeFiltroLeads', this.filtroLeadSelected.id);
        },
        handleChangeOrgs: function handleChangeOrgs(index) {
            this.indexOrgSelected = index;
            this.filtroOrgSelected = this.arrOrgs[index];
            this.$emit('changeFiltroOrg', this.filtroOrgSelected.id);
        },
        handleChangeEquipe: function handleChangeEquipe(index) {
            this.indexUsuarioSelected = 0;
            this.indexEquipeSelected = index;
            this.codequipe = this.arrEquipes[index].id;
            if (this.codequipe == -1) this.codequipe = null;
            this.$emit('changeEquipe', this.codequipe);
        },
        handleChangeFunil: function handleChangeFunil(index) {
            this.indexFunilSelected = index;
            console.log(this.arrFunil[index]);
            if (this.arrFunil[index].id == -1) this.handleNovoFunil();else if (this.arrFunil[index].id == -2) this.handleEditarFunil();else {
                this.funilSelected = this.arrFunil[index];
                this.$emit('changeFunil', this.funilSelected.id);
            }
        },
        preparaFiltro: function preparaFiltro() {
            if (this.funilList) {
                for (var x = 0; x < this.funilList.length; x++) {
                    this.arrFunil.push({ id: this.funilList[x].codfunil, label: this.funilList[x].descricao });
                }
                if (!this.codfunil && this.funilList.length > 0) this.codfunil = this.funilList[0].codfunil;
            }

            //monta a lista de usuarios e equipes
            this.arrUsuarios = [{ id: -1, label: 'Todos' }];
            for (var x = 0; x < this.usuarioList.length; x++) {
                this.arrUsuarios.push({ id: this.usuarioList[x].codusuario, label: this.usuarioList[x].nome });
            }

            this.arrEquipes = [{ id: -1, label: 'Todas' }];
            if (this.equipeList.length > 0) {
                for (var x = 0; x < this.equipeList.length; x++) {
                    this.arrEquipes.push({ id: this.equipeList[x].codequipe, label: this.equipeList[x].nome });
                }
            }
        }
    },

    created: function created() {
        this.preparaFiltro();
    }
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__api_api_crm_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_agenda_form__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__crm_card__ = __webpack_require__(96);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        funil: Object,
        usuario: Object,
        equipe: Object,
        startDate: '',
        filtro: '' //código do filtro selecionado
    },

    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a, CrmCard: __WEBPACK_IMPORTED_MODULE_6__crm_card__["a" /* default */], AgendaForm: __WEBPACK_IMPORTED_MODULE_5__forms_agenda_form__["a" /* default */]
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4__api_api_crm_js___default.a], //ROTINAS DO CRM

    data: function data() {
        return {
            selectedIndex: -1,

            etapasFunil: [],

            painel: [], //objeto utilizado para apresentacao

            negocioDragging: null,
            codetapa: null,

            isDragging: false,
            delayedDragging: false,

            codnegocio_detalhePopover: null,
            negocio_detalhePopover: null,

            negociocrm: null,
            noDeals: false

        };
    },


    computed: {
        cols: function cols() {
            // return 'pipeline-6col'

            if (this.etapasFunil.length == 2) {
                return 'pipeline-2col';
            } else if (this.etapasFunil.length == 3) {
                return 'pipeline-3col';
            } else if (this.etapasFunil.length == 4) {
                return 'pipeline-4col';
            } else if (this.etapasFunil.length == 5) {
                return 'pipeline-5col';
            } else if (this.etapasFunil.length >= 6) {
                return 'pipeline-6col';
            }
        },

        totalList: function totalList() {
            return this.$store.getters.getNegocioTotais[0];
        },

        negocioList: function negocioList() {
            return this.$store.getters.getNegocioList;
        },

        etapaList: function etapaList() {
            if (this.$store.getters.getConfigCrm.etapas) return this.$store.getters.getConfigCrm.etapas;else return [];
        },

        funilList: function funilList() {
            if (this.$store.getters.getConfigCrm) return this.$store.getters.getConfigCrm.funil;else return [];
        },

        dragOptions: function dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },

    watch: {
        startDate: function startDate(value) {
            this.loadData();
        },

        funil: function funil(value) {
            //se o filtro de funil for alterado
            this.loadData();
        },

        usuario: function usuario(value) {
            //se o filtro de usuario for alterado
            this.loadData();
        },

        equipe: function equipe(value) {
            //se o filtro de equipe for alterado
            this.loadData();
        },

        filtro: function filtro(value) {
            //se o filtro for alterado
            this.loadData();
        }
    },

    methods: {
        handleEditNegocio: function handleEditNegocio(codnegocio) {
            //ABRIR FORM PARA DIGITACAO
            this.$emit('edit', codnegocio);
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var query, obj, totais, negocios, x, y;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.etapasFunil = _this.funil.etapas;

                                query = '';


                                if (_this.filtro) {
                                    if (query) query = query + '&';
                                    query = query + 'filtro=' + _this.filtro;
                                }

                                if (_this.usuario) {
                                    if (query) query = query + '&';
                                    query = query + 'codusuario=' + _this.usuario;
                                }

                                if (_this.equipe) {
                                    if (query) query = query + '&';
                                    query = query + 'codequipe=' + _this.equipe;
                                }

                                if (_this.startDate) {
                                    if (query) query = query + '&';
                                    query = query + 'data=' + Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiDateORDS"])(_this.startDate);
                                }

                                _this.painel = [];

                                _context.next = 9;
                                return _this.$store.dispatch('loadPainelCrm', { codfunil: _this.funil.codfunil, tipo: 'etapas', query: query });

                            case 9:
                                _context.next = 11;
                                return _this.$store.dispatch('loadPainelCrm', { codfunil: _this.funil.codfunil, tipo: 'total', query: query });

                            case 11:
                                obj = {};
                                totais = [];
                                negocios = [];

                                /*
                                MONTA O OBJETO "painel" PARA APRESENTACAO
                                 painel: [
                                    { 
                                        codetapa: '',
                                        descricao: '',
                                        totais: [
                                            { moeda: '', total: 0 },
                                        ],
                                        negocios: [
                                            {},
                                        ]
                                    }
                                ]
                                 */

                                for (x = 0; x < _this.etapasFunil.length; x++) {
                                    obj = _extends({}, _this.etapasFunil[x]);
                                    obj.totais = [];
                                    obj.negocios = [];

                                    if (_this.totalList) {
                                        totais = _this.totalList.por_etapas.filter(function (obj) {
                                            return obj.codetapa == _this.etapasFunil[x].codetapa;
                                        });
                                        for (y = 0; y < totais.length; y++) {
                                            obj.totais = totais[y].moedas;
                                        }
                                    }
                                    if (obj.totais.length == 0) {
                                        obj.totais.push({ count_negocios: 0, moeda: null, valor: 0 });
                                    }

                                    negocios = _this.negocioList.filter(function (obj) {
                                        return obj.codetapa == _this.etapasFunil[x].codetapa;
                                    });
                                    for (y = 0; y < negocios.length; y++) {
                                        obj.negocios.push(negocios[y]);
                                    }

                                    _this.painel.push(obj);
                                }

                                _this.noDeals = _this.negocioList.length == 0;

                                _this.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        gravaEtapa: function gravaEtapa() {
            if (!this.negocioDragging) return;
            var data = {
                codnegocio: this.negocioDragging.codnegocio,
                codetapa: this.codetapa
            };
            this.apiNegocio(data, data.codnegocio, this.callBackPost);
        },
        callBackPost: function callBackPost(negocio) {
            //EFETUA A ATUALIZACAO DOS TOTAIS DAS ETAPAS AO MOVIMENTAR O NEGOCIO

            var etapaAnterior = this.negocioDragging.codetapa;
            var etapaAtual = negocio.codetapa;
            this.negocioDragging = negocio;

            //atualiza os totais no painel
            for (var x = 0; x < this.painel.length; x++) {
                if (this.painel[x].codetapa == etapaAnterior) {
                    this.painel[x].totais[0].valor = this.painel[x].totais[0].valor - negocio.valor;
                    this.painel[x].totais[0].count_negocios = this.painel[x].totais[0].count_negocios - 1;
                }
                if (this.painel[x].codetapa == etapaAtual) {
                    this.painel[x].totais[0].valor = this.painel[x].totais[0].valor + negocio.valor;
                    this.painel[x].totais[0].count_negocios = this.painel[x].totais[0].count_negocios + 1;

                    for (var y = 0; y < this.painel[x].negocios.length; y++) {
                        if (this.painel[x].negocios[y].codnegocio == negocio.codnegocio) this.painel[x].negocios[y].codetapa = negocio.codetapa;
                        this.painel[x].negocios[y].dias_estagnado = 0;
                    }
                }
            }

            this.negocioDragging = null;
        },


        // DRAG EVENTS
        onChange: function onChange(evt) {
            //console.log(evt)
        },
        onMove: function onMove(_ref) {
            var relatedContext = _ref.relatedContext,
                draggedContext = _ref.draggedContext;

            this.negocioDragging = draggedContext.element;

            var relatedElement = relatedContext.element;
            var draggedElement = draggedContext.element;
            return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
        },
        onEnd: function onEnd(obj) {
            this.isDragging = false;
            // console.log(obj.from.attributes)
            // console.log(obj.to.attributes)

            this.codetapa = obj.to.attributes[0].value;
            // console.log('codetapa: ' + this.codetapa)
            // console.log(this.negocioDragging)
            this.gravaEtapa();
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(value, 2);
        }
    },

    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.loadData();
    }
});

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var version = "1.10.2";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !!
    /*@__PURE__*/
    navigator.userAgent.match(pattern);
  }
}

var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};

function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}

function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}

function matches(
/**HTMLElement*/
el,
/**String*/
selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));

  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }

  return false;
}

function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}

function closest(
/**HTMLElement*/
el,
/**String*/
selector,
/**HTMLElement*/
ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;

    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }

      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }

  return null;
}

var R_SPACE = /\s+/g;

function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}

function css(el, prop, val) {
  var style = el && el.style;

  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }

      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }

      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}

function matrix(el, selfOnly) {
  var appliedTransforms = '';

  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');

      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */
    } while (!selfOnly && (el = el.parentNode));
  }

  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */

  return matrixFn && new matrixFn(appliedTransforms);
}

function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;

    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }

    return list;
  }

  return [];
}

function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;

  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */

function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;

  if (el !== window && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }

  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11

    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */
      } while (container = container.parentNode);
    }
  }

  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;

    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }

  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */

function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];
  /* jshint boss:true */

  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;

    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }

    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }

  return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */

function getChild(el, childNum, options) {
  var currentChild = 0,
      i = 0,
      children = el.children;

  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }

      currentChild++;
    }

    i++;
  }

  return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */

function lastChild(el, selector) {
  var last = el.lastElementChild;

  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }

  return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */

function index(el, selector) {
  var index = 0;

  if (!el || !el.parentNode) {
    return -1;
  }
  /* jshint boss:true */

  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }

  return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */

function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();

  if (el) {
    do {
      var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }

  return [offsetLeft, offsetTop];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */

function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }

  return -1;
}

function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;

  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);

      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */
  } while (elem = elem.parentNode);

  return getWindowScrollingElement();
}

function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }

  return dst;
}

function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}

var _throttleTimeout;

function throttle(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
          _this = this;

      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }

      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}

function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}

function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}

function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;

  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}

function setRect(el, rect) {
  css(el, 'position', 'absolute');
  css(el, 'top', rect.top);
  css(el, 'left', rect.left);
  css(el, 'width', rect.width);
  css(el, 'height', rect.height);
}

function unsetRect(el) {
  css(el, 'position', '');
  css(el, 'top', '');
  css(el, 'left', '');
  css(el, 'width', '');
  css(el, 'height', '');
}

var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
      animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });

        var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);

          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }

        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;

      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }

      var animating = false,
          animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);

        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }

        target.toRect = toRect;

        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        } // if fromRect != toRect: animate


        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;

          if (!time) {
            time = _this.options.animation;
          }

          _this.animate(target, animatingRect, toRect, time);
        }

        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);

      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }

      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}

function repaint(target) {
  return target.offsetWidth;
}

function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults) {
      if (defaults.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults[option];
      }
    }

    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;

    this.eventCanceled = false;

    evt.cancel = function () {
      _this.eventCanceled = true;
    };

    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
          sortable: sortable
        }, evt));
      } // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined


      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized; // Add default options from plugin

      _extends(defaults, initialized.defaults);
    });

    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);

      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;

      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }

  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

  var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));

  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }

  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }

  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, ["evt"]);

  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};

function _dispatchEvent(info) {
  dispatchEvent(_objectSpread({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}

var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,

// For positioning ghost absolutely
ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],

// (left, top)
_silent = false,
    savedInputChecked = [];
/** @const */

var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',

// This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
  if (!documentExists) return; // false when <= IE11

  if (IE11OrLess) {
    return false;
  }

  var el = document.createElement('x');
  el.style.cssText = 'pointer-events:auto';
  return el.style.pointerEvents === 'auto';
}(),
    _detectDirection = function _detectDirection(el, options) {
  var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

  if (elCSS.display === 'flex') {
    return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
  }

  if (elCSS.display === 'grid') {
    return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
  }

  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
    var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
    return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
  }

  return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
},
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
},


/**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */
_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
  var ret;
  sortables.some(function (sortable) {
    if (lastChild(sortable)) return;
    var rect = getRect(sortable),
        threshold = sortable[expando].options.emptyInsertThreshold,
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

    if (threshold && insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
},
    _prepareGroup = function _prepareGroup(options) {
  function toFn(value, pull) {
    return function (to, from, dragEl, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

      if (value == null && (pull || sameGroup)) {
        // Default pull value
        // Default pull and put value if same group
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === 'clone') {
        return value;
      } else if (typeof value === 'function') {
        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }

  var group = {};
  var originalGroup = options.group;

  if (!originalGroup || _typeof(originalGroup) != 'object') {
    originalGroup = {
      name: originalGroup
    };
  }

  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
},
    _hideGhostForTarget = function _hideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', 'none');
  }
},
    _unhideGhostForTarget = function _unhideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', '');
  }
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


if (documentExists) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}

var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;

    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

    if (nearest) {
      // Create imitation event
      var event = {};

      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }

      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;

      nearest[expando]._onDragOver(event);
    }
  }
};

var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */

function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }

  this.el = el; // root element

  this.options = options = _extends({}, options); // Export instance

  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults); // Set default options

  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }

  _prepareGroup(options); // Bind all private methods


  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  } // Setup drag mode


  this.nativeDraggable = options.forceFallback ? false : supportDraggable;

  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  } // Bind events


  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }

  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }

  sortables.push(this.el); // Restore sorting

  options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

  _extends(this, AnimationStateManager());
}

Sortable.prototype =
/** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(
  /** Event|TouchEvent */
  evt) {
    if (!evt.cancelable) return;

    var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;

    _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


    if (dragEl) {
      return;
    }

    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    } // cancel dnd if original target is content editable


    if (originalTarget.isContentEditable) {
      return;
    }

    target = closest(target, options.draggable, el, false);

    if (target && target.animated) {
      return;
    }

    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    } // Get the index of the dragged element within its parent


    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable); // Check filter

    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });

        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);

        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });

      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    }

    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    } // Prepare `dragstart`


    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(
  /** Event */
  evt,
  /** Touch */
  touch,
  /** HTMLElement */
  target) {
    var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;

    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';

      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });

        if (Sortable.eventCanceled) {
          _this._onDrop();

          return;
        } // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove


        _this._disableDelayedDragEvents();

        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        } // Bind the events: dragstart/dragend


        _this._triggerDragStart(evt, touch); // Drag start event


        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        }); // Chosen item


        toggleClass(dragEl, options.chosenClass, true);
      }; // Disable "draggable"


      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mouseup', _this._onDrop);
      on(ownerDocument, 'touchend', _this._onDrop);
      on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }

      pluginEvent('delayStart', this, {
        evt: evt
      }); // Delay is impossible for native DnD in Edge or IE

      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();

          return;
        } // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag


        on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
        on(ownerDocument, 'touchend', _this._disableDelayedDrag);
        on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
  /** TouchEvent|PointerEvent **/
  e) {
    var touch = e.touches ? e.touches[0] : e;

    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);

    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(
  /** Event */
  evt,
  /** Touch */
  touch) {
    touch = touch || evt.pointerType == 'touch' && evt;

    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }

    try {
      if (document.selection) {
        // Timeout neccessary for IE9
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {

    awaitingDragStarted = false;

    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });

      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }

      var options = this.options; // Apply effect

      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost(); // Drag start event

      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;

      _hideGhostForTarget();

      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;

      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }

      dragEl.parentNode[expando]._isOutsideThisEl(target);

      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });

            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }

          target = parent; // store last element
        }
        /* jshint boss:true */
        while (parent = parent.parentNode);
      }

      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(
  /**TouchEvent*/
  evt) {
    if (tapEvt) {
      var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }

        this._onDragStart(evt, true);
      }

      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }

        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }

      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options; // Position absolutely

      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;

        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }

        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }

        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }

      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl); // Set transform-origin

      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart(
  /**Event*/
  evt,
  /**boolean*/
  fallback) {
    var _this = this;

    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });

    if (Sortable.eventCanceled) {
      this._onDrop();

      return;
    }

    pluginEvent('setupClone', this);

    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';

      this._hideClone();

      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    } // #1143: IFrame support workaround


    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;

      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }

      _this._hideClone();

      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);

      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }

      on(document, 'drop', _this); // #1276 fix:

      css(dragEl, 'transform', 'translateZ(0)');
    }

    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;

    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(
  /**Event*/
  evt) {
    var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;

    if (_silent) return;

    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    } // Capture animation state


    function capture() {
      dragOverEvent('dragOverAnimationCapture');

      _this.captureAnimationState();

      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    } // Return invocation when dragEl is inserted (or completed)


    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }

        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }

        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        } // Animation


        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }

        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });

        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      } // Null lastTarget if it is not inside a previously swapped element


      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      } // no bubbling and not fallback


      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


        !insertion && nearestEmptyInsertDetectEvent(evt);
      }

      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    } // Call when dragEl has been inserted


    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);

      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }

    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }

    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;

    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }

    ignoreNextClick = false;

    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;

      if (revert) {
        parentEl = rootEl; // actualization

        capture();

        this._hideClone();

        dragOverEvent('revert');

        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }

        return completed(true);
      }

      var elLastChild = lastChild(el, options.draggable);

      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        } // assign target only if condition is true


        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }

        if (target) {
          targetRect = getRect(target);
        }

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }

        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;

        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = index(dragEl);

          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        } // If dragEl is already beside target: Do not insert


        if (direction === 0 || sibling === target) {
          return completed(false);
        }

        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
            after = false;
        after = direction === 1;

        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }

          _silent = true;
          setTimeout(_unsilent, 30);
          capture();

          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          } // Undo chrome's scroll adjustment (has no effect on other browsers)


          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }

          parentEl = dragEl.parentNode; // actualization
          // must be done before animation

          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }

          changed();
          return completed(true);
        }
      }

      if (el.contains(dragEl)) {
        return completed(false);
      }
    }

    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop(
  /**Event*/
  evt) {
    var el = this.el,
        options = this.options; // Get the index of the dragged element within its parent

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);

    if (Sortable.eventCanceled) {
      this._nulling();

      return;
    }

    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);

    _cancelNextTick(this.cloneId);

    _cancelNextTick(this._dragStartId); // Unbind events


    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }

    this._offMoveEvents();

    this._offUpEvents();

    if (Safari) {
      css(document.body, 'user-select', '');
    }

    css(dragEl, 'transform', '');

    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }

      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }

      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }

        _disableDraggable(dragEl);

        dragEl.style['will-change'] = ''; // Remove classes
        // ghostClass is added in dragStarted

        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }

        toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });

        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            }); // Remove event


            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            }); // drag from one list and drop into another


            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }

          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }

        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }

          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          }); // Save sorting


          this.save();
        }
      }
    }

    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function (el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(
  /**Event*/
  evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);

        break;

      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);

          _globalDragOver(evt);
        }

        break;

      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },

  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;

    for (; i < n; i++) {
      el = children[i];

      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }

    return order;
  },

  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order) {
    var items = {},
        rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];

      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
  },

  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },

  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },

  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;

    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);

      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }

      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },

  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);

    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    } // Remove draggable attributes


    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });

    this._onDrop();

    this._disableDelayedDragEvents();

    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');

      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }

      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();

      return;
    }

    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return; // show clone at dragEl or original position

      if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }

      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }

      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};

function _globalDragOver(
/**Event*/
evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }

  evt.cancelable && evt.preventDefault();
}

function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal; // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }

  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);

  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }

  return retVal;
}

function _disableDraggable(el) {
  el.draggable = false;
}

function _unsilent() {
  _silent = false;
}

function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}

function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;

  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }

      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }

  invert = invert || invertSwap;

  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }

  return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */

function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */

function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;

  while (i--) {
    sum += str.charCodeAt(i);
  }

  return sum.toString(36);
}

function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;

  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}

function _nextTick(fn) {
  return setTimeout(fn, 0);
}

function _cancelNextTick(id) {
  return clearTimeout(id);
} // Fixed #973:


if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
} // Export utils


Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend,
  throttle: throttle,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */

Sortable.get = function (element) {
  return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */

Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }

    if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
    PluginManager.mount(plugin);
  });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */

Sortable.create = function (el, options) {
  return new Sortable(el, options);
}; // Export


Sortable.version = version;

var autoScrolls = [],
    scrollEl,
    scrollRootEl,
    scrolling = false,
    lastAutoScrollX,
    lastAutoScrollY,
    touchEvt$1,
    pointerElemChangedInterval;

function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    }; // Bind all private methods

    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
  }

  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;

      if (this.sortable.nativeDraggable) {
        on(document, 'dragover', this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, 'touchmove', this._handleFallbackAutoScroll);
        } else {
          on(document, 'mousemove', this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;

      // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop() {
      if (this.sortable.nativeDraggable) {
        off(document, 'dragover', this._handleAutoScroll);
      } else {
        off(document, 'pointermove', this._handleFallbackAutoScroll);
        off(document, 'touchmove', this._handleFallbackAutoScroll);
        off(document, 'mousemove', this._handleFallbackAutoScroll);
      }

      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;

      var x = (evt.touches ? evt.touches[0] : evt).clientX,
          y = (evt.touches ? evt.touches[0] : evt).clientY,
          elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt; // IE does not seem to have native autoscroll,
      // Edge's autoscroll seems too conditional,
      // MACOS Safari does not have autoscroll,
      // Firefox and Chrome are good

      if (fallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

        var ogElemScroller = getParentAutoScrollElement(elem, true);

        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

          pointerElemChangedInterval = setInterval(function () {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }

            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }

        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: 'scroll',
    initializeByDefault: true
  });
}

function clearAutoScrolls() {
  autoScrolls.forEach(function (autoScroll) {
    clearInterval(autoScroll.pid);
  });
  autoScrolls = [];
}

function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}

var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
  // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
  if (!options.scroll) return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX,
      y = (evt.touches ? evt.touches[0] : evt).clientY,
      sens = options.scrollSensitivity,
      speed = options.scrollSpeed,
      winScroller = getWindowScrollingElement();
  var scrollThisInstance = false,
      scrollCustomFn; // New scroll root, set scrollEl

  if (scrollRootEl !== rootEl) {
    scrollRootEl = rootEl;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;

    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl, true);
    }
  }

  var layersOut = 0;
  var currentParent = scrollEl;

  do {
    var el = currentParent,
        rect = getRect(el),
        top = rect.top,
        bottom = rect.bottom,
        left = rect.left,
        right = rect.right,
        width = rect.width,
        height = rect.height,
        canScrollX = void 0,
        canScrollY = void 0,
        scrollWidth = el.scrollWidth,
        scrollHeight = el.scrollHeight,
        elCSS = css(el),
        scrollPosX = el.scrollLeft,
        scrollPosY = el.scrollTop;

    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
    }

    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }

    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);

      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        /* jshint loopfunc:true */

        autoScrolls[layersOut].pid = setInterval(function () {
          // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely
          }

          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

          if (typeof scrollCustomFn === 'function') {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
              return;
            }
          }

          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }

    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

  scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();

  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};

function Revert() {}

Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();

    if (putSortable) {
      putSortable.captureAnimationState();
    }

    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }

    this.sortable.animateAll();

    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};

_extends(Revert, {
  pluginName: 'revertOnSpill'
});

function Remove() {}

Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};

_extends(Remove, {
  pluginName: 'removeOnSpill'
});

var lastSwapEl;

function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: 'sortable-swap-highlight'
    };
  }

  Swap.prototype = {
    dragStart: function dragStart(_ref) {
      var dragEl = _ref.dragEl;
      lastSwapEl = dragEl;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed,
          target = _ref2.target,
          onMove = _ref2.onMove,
          activeSortable = _ref2.activeSortable,
          changed = _ref2.changed,
          cancel = _ref2.cancel;
      if (!activeSortable.options.swap) return;
      var el = this.sortable.el,
          options = this.options;

      if (target && target !== el) {
        var prevSwapEl = lastSwapEl;

        if (onMove(target) !== false) {
          toggleClass(target, options.swapClass, true);
          lastSwapEl = target;
        } else {
          lastSwapEl = null;
        }

        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }

      changed();
      completed(true);
      cancel();
    },
    drop: function drop(_ref3) {
      var activeSortable = _ref3.activeSortable,
          putSortable = _ref3.putSortable,
          dragEl = _ref3.dragEl;
      var toSortable = putSortable || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

      if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
        if (dragEl !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable) activeSortable.captureAnimationState();
          swapNodes(dragEl, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable) activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends(Swap, {
    pluginName: 'swap',
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}

function swapNodes(n1, n2) {
  var p1 = n1.parentNode,
      p2 = n2.parentNode,
      i1,
      i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
  i1 = index(n1);
  i2 = index(n2);

  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }

  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}

var multiDragElements = [],
    multiDragClones = [],
    lastMultiDragSelect,

// for selection with modifier key down (SHIFT)
multiDragSortable,
    initialFolding = false,

// Initial multi-drag fold when drag started
folding = false,

// Folding any other time
dragStarted = false,
    dragEl$1,
    clonesFromRect,
    clonesHidden;

function MultiDragPlugin() {
  function MultiDrag(sortable) {
    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }

    if (sortable.options.supportPointer) {
      on(document, 'pointerup', this._deselectMultiDrag);
    } else {
      on(document, 'mouseup', this._deselectMultiDrag);
      on(document, 'touchend', this._deselectMultiDrag);
    }

    on(document, 'keydown', this._checkKeyDown);
    on(document, 'keyup', this._checkKeyUp);
    this.defaults = {
      selectedClass: 'sortable-selected',
      multiDragKey: null,
      setData: function setData(dataTransfer, dragEl) {
        var data = '';

        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function (multiDragElement, i) {
            data += (!i ? '' : ', ') + multiDragElement.textContent;
          });
        } else {
          data = dragEl.textContent;
        }

        dataTransfer.setData('Text', data);
      }
    };
  }

  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable,
          cancel = _ref2.cancel;
      if (!this.isMultiDrag) return;

      for (var i = 0; i < multiDragElements.length; i++) {
        multiDragClones.push(clone(multiDragElements[i]));
        multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
        multiDragClones[i].draggable = false;
        multiDragClones[i].style['will-change'] = '';
        toggleClass(multiDragClones[i], this.options.selectedClass, false);
        multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
      }

      sortable._hideClone();

      cancel();
    },
    clone: function clone(_ref3) {
      var sortable = _ref3.sortable,
          rootEl = _ref3.rootEl,
          dispatchSortableEvent = _ref3.dispatchSortableEvent,
          cancel = _ref3.cancel;
      if (!this.isMultiDrag) return;

      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl);
          dispatchSortableEvent('clone');
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown,
          rootEl = _ref4.rootEl,
          cancel = _ref4.cancel;
      if (!this.isMultiDrag) return;
      insertMultiDragClones(false, rootEl);
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', '');
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this = this;

      var sortable = _ref5.sortable,
          cloneNowHidden = _ref5.cloneNowHidden,
          cancel = _ref5.cancel;
      if (!this.isMultiDrag) return;
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', 'none');

        if (_this.options.removeCloneOnHide && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      var sortable = _ref6.sortable;

      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }

      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.sortableIndex = index(multiDragElement);
      }); // Sort multi-drag elements

      multiDragElements = multiDragElements.sort(function (a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted(_ref7) {
      var _this2 = this;

      var sortable = _ref7.sortable;
      if (!this.isMultiDrag) return;

      if (this.options.sort) {
        // Capture rects,
        // hide multi drag elements (by positioning them absolute),
        // set multi drag elements rects to dragRect,
        // show multi drag elements,
        // animate to rects,
        // unset rects & remove from DOM
        sortable.captureAnimationState();

        if (this.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            css(multiDragElement, 'position', 'absolute');
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }

      sortable.animateAll(function () {
        folding = false;
        initialFolding = false;

        if (_this2.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
        } // Remove all auxiliary multidrag items from el, if sorting enabled


        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target = _ref8.target,
          completed = _ref8.completed,
          cancel = _ref8.cancel;

      if (folding && ~multiDragElements.indexOf(target)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable,
          rootEl = _ref9.rootEl,
          sortable = _ref9.sortable,
          dragRect = _ref9.dragRect;

      if (multiDragElements.length > 1) {
        // Setup unfold animation
        multiDragElements.forEach(function (multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable,
          isOwner = _ref10.isOwner,
          insertion = _ref10.insertion,
          activeSortable = _ref10.activeSortable,
          parentEl = _ref10.parentEl,
          putSortable = _ref10.putSortable;
      var options = this.options;

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        }

        initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
          // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

            parentEl.appendChild(multiDragElement);
          });
          folding = true;
        } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


        if (!isOwner) {
          // Only remove if not folding (folding will remove them anyways)
          if (!folding) {
            removeMultiDragElements();
          }

          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;

            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function (clone) {
                activeSortable.addAnimationState({
                  target: clone,
                  rect: clonesFromRect
                });
                clone.fromRect = clonesFromRect;
                clone.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect,
          isOwner = _ref11.isOwner,
          activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });

      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop(_ref12) {
      var evt = _ref12.originalEvent,
          rootEl = _ref12.rootEl,
          parentEl = _ref12.parentEl,
          sortable = _ref12.sortable,
          dispatchSortableEvent = _ref12.dispatchSortableEvent,
          oldIndex = _ref12.oldIndex,
          putSortable = _ref12.putSortable;
      var toSortable = putSortable || this.sortable;
      if (!evt) return;
      var options = this.options,
          children = parentEl.children; // Multi-drag selection

      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }

        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'select',
            targetEl: dragEl$1,
            originalEvt: evt
          }); // Modifier activated, select from last to dragEl

          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = index(lastMultiDragSelect),
                currentIndex = index(dragEl$1);

            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              // Must include lastMultiDragSelect (select it), in case modified selection from no selection
              // (but previous selection existed)
              var n, i;

              if (currentIndex > lastIndex) {
                i = lastIndex;
                n = currentIndex;
              } else {
                i = currentIndex;
                n = lastIndex + 1;
              }

              for (; i < n; i++) {
                if (~multiDragElements.indexOf(children[i])) continue;
                toggleClass(children[i], options.selectedClass, true);
                multiDragElements.push(children[i]);
                dispatchEvent({
                  sortable: sortable,
                  rootEl: rootEl,
                  name: 'select',
                  targetEl: children[i],
                  originalEvt: evt
                });
              }
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }

          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'deselect',
            targetEl: dragEl$1,
            originalEvt: evt
          });
        }
      } // Multi-drag drop


      if (dragStarted && this.isMultiDrag) {
        // Do not "unfold" after around dragEl if reverted
        if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1),
              multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
          if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();

          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;

                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect; // Prepare unfold animation

                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect: rect
                  });
                }
              });
            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
            // properly they must all be removed


            removeMultiDragElements();
            multiDragElements.forEach(function (multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl.appendChild(multiDragElement);
              }

              multiDragIndex++;
            }); // If initial folding is done, the elements may have changed position because they are now
            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
            // must be fired here as Sortable will not.

            if (oldIndex === index(dragEl$1)) {
              var update = false;
              multiDragElements.forEach(function (multiDragElement) {
                if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                  update = true;
                  return;
                }
              });

              if (update) {
                dispatchSortableEvent('update');
              }
            }
          } // Must be done after capturing individual rects (scroll bar)


          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }

        multiDragSortable = toSortable;
      } // Remove clones if necessary


      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        multiDragClones.forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();

      off(document, 'pointerup', this._deselectMultiDrag);
      off(document, 'mouseup', this._deselectMultiDrag);
      off(document, 'touchend', this._deselectMultiDrag);
      off(document, 'keydown', this._checkKeyDown);
      off(document, 'keyup', this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

      if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

      if (evt && evt.button !== 0) return;

      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: 'deselect',
          targetEl: el,
          originalEvt: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends(MultiDrag, {
    // Static methods & properties
    pluginName: 'multiDrag',
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();

          multiDragSortable = sortable;
        }

        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },

      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando],
            index = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index) return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;

      var oldIndicies = [],
          newIndicies = [];
      multiDragElements.forEach(function (multiDragElement) {
        oldIndicies.push({
          multiDragElement: multiDragElement,
          index: multiDragElement.sortableIndex
        }); // multiDragElements will already be sorted if folding

        var newIndex;

        if (folding && multiDragElement !== dragEl$1) {
          newIndex = -1;
        } else if (folding) {
          newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
        } else {
          newIndex = index(multiDragElement);
        }

        newIndicies.push({
          multiDragElement: multiDragElement,
          index: newIndex
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: oldIndicies,
        newIndicies: newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();

        if (key === 'ctrl') {
          key = 'Control';
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }

        return key;
      }
    }
  });
}

function insertMultiDragElements(clonesInserted, rootEl) {
  multiDragElements.forEach(function (multiDragElement, i) {
    var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(multiDragElement, target);
    } else {
      rootEl.appendChild(multiDragElement);
    }
  });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */

function insertMultiDragClones(elementsInserted, rootEl) {
  multiDragClones.forEach(function (clone, i) {
    var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(clone, target);
    } else {
      rootEl.appendChild(clone);
    }
  });
}

function removeMultiDragElements() {
  multiDragElements.forEach(function (multiDragElement) {
    if (multiDragElement === dragEl$1) return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}

Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);

exports.default = Sortable;
exports.MultiDrag = MultiDragPlugin;
exports.Sortable = Sortable;
exports.Swap = SwapPlugin;

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__crm_card_detalhe__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_agenda_form__ = __webpack_require__(79);
//
//
//
//
//
//
//


// import CrmFunilNovo from './crm-pessoa-novo-form'




/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        negocio: Object
    },

    data: function data() {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            codnegocio_detalhePopover: null,
            negocio_detalhePopover: null,

            showFormAgenda: false,
            codagenda: null,
            negociocrm: null,

            crud: ''
        };
    },


    components: {
        CrmCardDetalhe: __WEBPACK_IMPORTED_MODULE_1__crm_card_detalhe__["a" /* default */], AgendaForm: __WEBPACK_IMPORTED_MODULE_2__forms_agenda_form__["a" /* default */]
    },

    computed: {
        organizacao: function organizacao() {
            if (this.negociocrm && this.negociocrm.organizacao.length > 0) return this.negociocrm.organizacao[0];else return null;
        },

        pessoa: function pessoa() {
            if (this.negociocrm && this.negociocrm.pessoa.length > 0) return this.negociocrm.pessoa[0];else return null;
        },

        paramsAgenda: function paramsAgenda() {
            return { negocio: this.negociocrm, organizacao: this.organizacao, pessoa: this.pessoa };
        }
    },

    watch: {},

    filters: {},

    methods: {
        isAberto: function isAberto(st) {
            return st == 'A';
        },
        isGanho: function isGanho(st) {
            return st == 'G';
        },
        isPerdido: function isPerdido(st) {
            return st == 'P';
        },
        handleEditNegocio: function handleEditNegocio(codnegocio) {
            this.$emit('edit', codnegocio);
        },


        // handleAdicionarAgenda (negocio) {
        //     this.$emit('adicionarAgenda', negocio)
        // },

        // handleEditAgenda (negocio, codagenda) {
        //     this.$emit('editAgenda', negocio, codagenda)
        // },

        closeDetalhePopover: function closeDetalhePopover() {
            this.codnegocio_detalhePopover = null;
        },
        showDetalhePopover: function showDetalhePopover(negocio) {
            this.codnegocio_detalhePopover = negocio.codnegocio;
            this.negocio_detalhePopover = negocio;
        },
        handleAdicionarAgenda: function handleAdicionarAgenda(negocio) {
            //abre a tela de edicao
            this.negociocrm = negocio;
            this.crud = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI;
            this.codagenda = null;
            this.showFormAgenda = true;
        },
        handleEditAgenda: function handleEditAgenda(negocio, codagenda) {
            //abre a tela de edicao
            this.negociocrm = negocio;
            this.crud = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU; //operacao de edicao
            this.codagenda = codagenda;
            this.showFormAgenda = true; //exibe o form de agenda
        },
        closeAgenda: function closeAgenda(agenda) {
            this.showFormAgenda = false;
            if (agenda) {
                if (!this.negocio_detalhePopover.count_agenda) this.negocio_detalhePopover.count_agenda = 1;else this.negocio_detalhePopover.count_agenda = this.negocio_detalhePopover.count_agenda + 1;
            }
        }
    },

    created: function created() {}
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//


// import CrmFunilNovo from './crm-pessoa-novo-form'


/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        index: ''
    },

    data: function data() {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            negociocrm: null,
            showFormAgenda: false,
            codagenda: null,
            loading: true
        };
    },


    computed: {

        agendaList: function agendaList() {
            if (!this.negociocrm) return [];else return this.negociocrm.agenda;
        }

    },

    watch: {},

    filters: {},

    methods: {
        closeForm: function closeForm() {
            console.log('closeform');
        },
        handleAdicionarAgenda: function handleAdicionarAgenda() {
            this.$emit('adicionarAgenda', this.negociocrm);
        },
        handleEditAgenda: function handleEditAgenda(codagenda) {
            this.$emit('editAgenda', this.negociocrm, codagenda);
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadNegocio', { id: _this.index });

                            case 2:
                                if (_this.$store.getters.getNegocio) {
                                    _this.negociocrm = _extends({}, _this.$store.getters.getNegocio);
                                }
                                _this.loading = false;

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__api_api_crm_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__crm_card__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__crm_painel_timeline_teste__ = __webpack_require__(1988);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        funil: Object,
        usuario: Object,
        equipe: Object,
        startDate: '',
        filtro: '' //código do filtro selecionado
    },

    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a, CrmCard: __WEBPACK_IMPORTED_MODULE_5__crm_card__["a" /* default */], CrmPainelTimelineTeste: __WEBPACK_IMPORTED_MODULE_6__crm_painel_timeline_teste__["a" /* default */]
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4__api_api_crm_js___default.a], //ROTINAS DO CRM

    data: function data() {
        return {
            etapasFunil: [],
            painel: [], //objeto utilizado para apresentacao

            negocioDragging: null,
            mesTarget: null, //variavel grava o index do mes de destino ao movimentar um card
            isDragging: false,
            delayedDragging: false,

            showFormAgenda: false,
            codagenda: null,

            negociocrm: null
        };
    },


    computed: {
        cols: function cols() {
            return 'pipeline-5col';
        },

        totalList: function totalList() {
            return this.$store.getters.getNegocioTotais;
        },

        negocioList: function negocioList() {
            return this.$store.getters.getNegocioList;
        },

        etapaList: function etapaList() {
            if (this.$store.getters.getConfigCrm.etapas) return this.$store.getters.getConfigCrm.etapas;else return [];
        },

        funilList: function funilList() {
            if (this.$store.getters.getConfigCrm) return this.$store.getters.getConfigCrm.funil;else return [];
        },

        dragOptions: function dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },


        organizacao: function organizacao() {
            if (this.negociocrm && this.negociocrm.organizacao.length > 0) return this.negociocrm.organizacao[0];else return null;
        },

        pessoa: function pessoa() {
            if (this.negociocrm && this.negociocrm.pessoa.length > 0) return this.negociocrm.pessoa[0];else return null;
        },

        paramsAgenda: function paramsAgenda() {
            return { negocio: this.negociocrm, organizacao: this.organizacao, pessoa: this.pessoa };
        },

        noDateTotal: function noDateTotal() {
            return this.$store.getters.getNegocioNoDateTimelineList.total;
        },

        noDateList: function noDateList() {
            if (this.$store.getters.getNegocioNoDateTimelineList.lista) return this.$store.getters.getNegocioNoDateTimelineList.lista;else return [];
        }

    },

    watch: {
        startDate: function startDate(value) {
            this.loadData();
        },

        funil: function funil(value) {
            this.loadData();
        },

        filtro: function filtro(value) {
            this.loadData();
        },

        usuario: function usuario(value) {
            this.loadData();
        }

    },

    methods: {
        closeAgenda: function closeAgenda(agenda) {
            this.showFormAgenda = false;
            if (agenda) {
                if (!this.negocio_detalhePopover.count_agenda) this.negocio_detalhePopover.count_agenda = 1;else this.negocio_detalhePopover.count_agenda = this.negocio_detalhePopover.count_agenda + 1;
            }
        },
        handleAdicionarAgenda: function handleAdicionarAgenda(negocio) {
            //abre a tela de edicao
            this.negociocrm = negocio;
            this.crud = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI;
            this.codagenda = null;
            this.showFormAgenda = true;
        },
        handleEditAgenda: function handleEditAgenda(negocio, codagenda) {
            //abre a tela de edicao
            this.negociocrm = negocio;
            this.crud = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU; //operacao de edicao
            this.codagenda = codagenda;
            this.showFormAgenda = true; //exibe o form de agenda
        },
        handleEditNegocio: function handleEditNegocio(codnegocio) {
            //ABRIR FORM PARA DIGITACAO
            this.$emit('edit', codnegocio);
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var query, obj, totais, negocios;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                query = '';

                                if (_this.usuario && _this.usuario.codusuario) {
                                    query = query + 'codusuario=' + _this.usuario.codusuario;
                                }

                                if (_this.equipe) {
                                    if (query) query = query + '&';
                                    query = query + 'codequipe=' + _this.equipe.codequipe;
                                }

                                //carrega a lista de negocios sem data
                                _context.next = 5;
                                return _this.$store.dispatch('loadPainelNoDateTimelineListCrm', { codfunil: _this.funil.codfunil, query: query });

                            case 5:
                                console.log(_this.$store.getters.getNegocioNoDateTimelineList);
                                if (_this.filtro) {
                                    if (query) query = query + '&';
                                    query = query + 'codfiltro=' + _this.filtro.codfiltro;
                                }

                                if (_this.startDate) {
                                    if (query) query = query + '&';
                                    query = query + 'data=' + Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiDateORDS"])(_this.startDate);
                                }

                                _context.next = 10;
                                return _this.$store.dispatch('loadPainelCrm', { codfunil: _this.funil.codfunil, tipo: 'timeline', query: query });

                            case 10:

                                _this.painel = [];
                                obj = {};
                                totais = [];
                                negocios = [];


                                _this.painel = _this.negocioList;

                                _this.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 16:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        gravaEtapa: function gravaEtapa() {
            if (!this.negocioDragging) return;
            var data = {
                codnegocio: this.negocioDragging.codnegocio,
                codetapa: this.codetapa
            };
            this.apiNegocio(data, data.codnegocio).then;
            this.negocioDragging = null;
        },


        // DRAG EVENTS
        onChange: function onChange(evt) {},
        onMove: function onMove(_ref) {
            var relatedContext = _ref.relatedContext,
                draggedContext = _ref.draggedContext;

            this.negocioDragging = draggedContext.element;

            var relatedElement = relatedContext.element;
            var draggedElement = draggedContext.element;
            return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
        },
        onEnd: function onEnd(obj) {
            this.isDragging = false;
            this.mesTarget = obj.to.attributes[0].value;

            //deve pegar o mesTarget e abrir campo para confirmar a data prevista de fechamento do negocio arrastado
            // this.gravaEtapa()
        }
    },

    filters: {
        format: function format(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(value, 2);
        }
    },

    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
        this.selectedFunil = this.funil;
        this.etapasFunil = this.selectedFunil.etapas;
        this.loadData();
    }
});

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__crm_card__ = __webpack_require__(96);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {},

    components: {
        CrmCard: __WEBPACK_IMPORTED_MODULE_2__crm_card__["a" /* default */]
    },

    data: function data() {
        return {
            minimizado: true
        };
    },


    computed: {

        negocioList: function negocioList() {
            return this.$store.getters.getNegocioNoDateTimelineList.lista;
        },

        total: function total() {
            if (this.$store.getters.getNegocioNoDateTimelineList.total.length > 0) return this.$store.getters.getNegocioNoDateTimelineList.total[0];else return [];
        }

    },

    methods: {
        handleMinimizar: function handleMinimizar() {
            this.minimizado = !this.minimizado;
        },
        handleFecharGuia: function handleFecharGuia() {}
    },

    watch: {},

    beforeCreate: function beforeCreate() {},
    mounted: function mounted() {
        console.log(this.negocioList);

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
    },
    created: function created() {}
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_csvReport__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_csvReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_csvReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__api_api_crm_js__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        funil: Object,
        usuario: Object,
        equipe: Object,
        startDate: '',
        filtro: '' //código do filtro selecionado
    },

    components: {},

    mixins: [__WEBPACK_IMPORTED_MODULE_4__api_api_crm_js___default.a], //ROTINAS DO CRM

    data: function data() {
        return {
            metadata: this.$store.getters.getEntities.metadata,

            selectedIndex: -1,

            etapasFunil: [],

            negociocrm: null,

            offset: false

        };
    },


    computed: {
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        },

        totalList: function totalList() {
            return this.$store.getters.getNegocioTotais[0];
        },

        negocioList: function negocioList() {
            return this.$store.getters.getNegocioList;
        },

        organizacao: function organizacao() {
            if (this.negociocrm && this.negociocrm.organizacao.length > 0) return this.negociocrm.organizacao[0];else return null;
        },

        pessoa: function pessoa() {
            if (this.negociocrm && this.negociocrm.pessoa.length > 0) return this.negociocrm.pessoa[0];else return null;
        },

        datasNegociosList: function datasNegociosList() {
            var datas = [].concat(_toConsumableArray(new Set(this.negocioList.map(function (item) {
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatDataExtenso"])(item.data);
            }))));
            var datasNegocios = [];
            for (var x = 0; x < datas.length; x++) {
                datasNegocios.push({
                    data: datas[x],
                    negocios: this.negocioList.filter(function (obj) {
                        return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatDataExtenso"])(obj.data) == datas[x];
                    })
                });
            }
            return datasNegocios;
        }

    },

    watch: {
        startDate: function startDate(value) {
            this.loadData();
        },

        funil: function funil(value) {
            //se o filtro de funil for alterado
            this.loadData();
        },

        usuario: function usuario(value) {
            //se o filtro de usuario for alterado
            this.loadData();
        },

        equipe: function equipe(value) {
            //se o filtro de equipe for alterado
            this.loadData();
        },

        filtro: function filtro(value) {
            //se o filtro for alterado
            this.loadData();
        }
    },

    methods: {
        data: function data(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatDate"])(value);
        },
        formatDate: function formatDate(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatDataHoraExtenso"])(value, true);
        },
        handleStyleAgenda: function handleStyleAgenda(obj) {
            if (obj.dias_atividade > 0) return 'color: red;';else if (obj.dias_atividade < 0) return 'color: green;';else return '';
        },
        handleExportarPlanilha: function handleExportarPlanilha() {
            var _this = this;

            //exportar a lista de notas para planilha
            var data = this.negocioList.map(function (negocio) {
                return {
                    data: _this.data(negocio.data),
                    titulo: negocio.titulo,
                    pessoa: negocio.pessoa_nome,
                    valor: Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["formatValue"])(negocio.valor, 2)
                };
            });
            var csv = Object(__WEBPACK_IMPORTED_MODULE_3__shared_csvReport__["objectToCsv"])(data);
            Object(__WEBPACK_IMPORTED_MODULE_3__shared_csvReport__["downloadCsvReport"])(csv);
        },
        handleEditNegocio: function handleEditNegocio(codnegocio) {
            //ABRIR FORM PARA DIGITACAO
            this.$emit('edit', codnegocio);
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var query, params;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:

                                _this2.etapasFunil = _this2.funil.etapas;

                                query = '';


                                if (_this2.filtro) {
                                    if (query) query = query + '&';
                                    query = query + 'filtro=' + _this2.filtro;
                                }

                                if (_this2.usuario) {
                                    if (query) query = query + '&';
                                    query = query + 'codusuario=' + _this2.usuario;
                                }

                                if (_this2.equipe) {
                                    if (query) query = query + '&';
                                    query = query + 'codequipe=' + _this2.equipe;
                                }

                                if (_this2.startDate) {
                                    if (query) query = query + '&';
                                    query = query + 'data=' + Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiDateORDS"])(_this2.startDate);
                                }

                                params = { codfunil: _this2.funil.codfunil, tipo: 'lista', query: query };

                                if (_this2.offset) {
                                    params.offset = _this2.nextPage;
                                }

                                _context.next = 10;
                                return _this2.$store.dispatch('loadPainelCrm', params);

                            case 10:

                                console.log(_this2.datasNegociosList);

                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        handleMore: function handleMore() {
            this.offset = true;
            this.loadData();
        }
    },

    filters: {},

    created: function created() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });

        this.loadData();
    }
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_pipeline__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_anexos_form__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__crm_negocio_novo_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__crm_org_novo_form__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crm_pessoa_novo_form__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__crm_negocio_participantes__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__crm_negocio_seguidores__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__crm_negocio_agenda__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__crm_email__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__crm_notes__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__crm_card__ = __webpack_require__(96);
var _methods;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: ''
    },

    components: {
        AnexosForm: __WEBPACK_IMPORTED_MODULE_5__components_anexos_form__["a" /* default */], CrmPipeline: __WEBPACK_IMPORTED_MODULE_4__crm_pipeline__["a" /* default */], CrmNegocioNovoForm: __WEBPACK_IMPORTED_MODULE_6__crm_negocio_novo_form__["a" /* default */], CrmOrgNovoForm: __WEBPACK_IMPORTED_MODULE_7__crm_org_novo_form__["a" /* default */],
        CrmEmail: __WEBPACK_IMPORTED_MODULE_12__crm_email__["a" /* default */], CrmPessoaNovoForm: __WEBPACK_IMPORTED_MODULE_8__crm_pessoa_novo_form__["a" /* default */], CrmNegocioParticipantes: __WEBPACK_IMPORTED_MODULE_9__crm_negocio_participantes__["a" /* default */], CrmNegocioSeguidores: __WEBPACK_IMPORTED_MODULE_10__crm_negocio_seguidores__["a" /* default */], CrmNegocioAgenda: __WEBPACK_IMPORTED_MODULE_11__crm_negocio_agenda__["a" /* default */],
        CrmCard: __WEBPACK_IMPORTED_MODULE_14__crm_card__["a" /* default */], CrmNotes: __WEBPACK_IMPORTED_MODULE_13__crm_notes__["a" /* default */]
    },

    data: function data() {
        return {
            errmessages: null,
            error: false,
            metadata: this.$store.getters.getEntities.metadata,
            modalDelete: false,
            activeTab: 0,

            showFormNegocio: false,
            showFormOrg: false,
            showFormPessoa: false,

            pessoa: null,

            paramsNegocio: null,
            paramsPessoa: null,

            anexos: [], //lista de anexos
            notes: [],
            addingNote: false,

            seguidores: [],
            showFormSeguidores: false,

            indexNote: null,
            texto: null,

            tabs: [{ title: 'Detalhes', help: null, icon: 'fa-paperclip', count: 0 }, { title: 'Arquivos', help: null, icon: 'fa-paperclip', count: 0 },
            // { title: null, help: 'E-mails', icon: 'fa-envelope', count: 0 },
            { title: 'Atividades Concluídas', help: null, icon: 'fa-calendar', count: 0 }, { title: 'Negócios', help: null, icon: 'fa-dollar', count: 0 }, { title: 'Negócios Vinculados', help: null, icon: 'fa-chain', count: 0 }]

        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        permiteAlteracao: function permiteAlteracao() {
            return this.pessoa.excluido != 'S';
        },

        tabDetalhes: function tabDetalhes() {
            return this.activeTab == '0';
        },

        tabAnexos: function tabAnexos() {
            return this.activeTab == '1';
        },

        tabAgenda: function tabAgenda() {
            return this.activeTab == '2';
        },

        tabNegocios: function tabNegocios() {
            return this.activeTab == '3';
        },

        tabNegociosVinculados: function tabNegociosVinculados() {
            return this.activeTab == '4';
        },

        nomeUsuario: function nomeUsuario() {
            if (this.pessoa && this.pessoa.usuario.length > 0) return this.pessoa.usuario[0].nome;else return null;
        },

        organizacao: function organizacao() {
            if (this.pessoa && this.pessoa.organizacao.length > 0) return this.pessoa.organizacao[0];else return null;
        },

        tag: function tag() {
            if (this.pessoa && this.pessoa.tag.length > 0) return this.pessoa.tag[0];else return null;
        },

        agendaList: function agendaList() {
            return this.pessoa.agenda.filter(function (obj) {
                return obj.concluida === 'S';
            });
        },

        agendaListPlanejada: function agendaListPlanejada() {
            return this.pessoa.agenda.filter(function (obj) {
                return obj.concluida != 'S';
            });
        },

        listNegocios: function listNegocios() {
            if (this.pessoa.negocios) return this.pessoa.negocios;else return [];
        },

        listVinculados: function listVinculados() {
            if (this.pessoa.negocios) return this.pessoa.negocios_vinculados;else return [];
        },

        emailList: function emailList() {
            this.tabs[3].count = this.$store.getters.getNegocioEmails.length;
            return this.$store.getters.getNegocioEmails;
        }

    },

    methods: (_methods = {
        changeTab: function changeTab(idx) {
            this.activeTab = idx;
        },
        handleStyle: function handleStyle(color) {
            if (color) return 'color: white; background-color: ' + color;else return '';
        },
        closeFormOrg: function closeFormOrg(organizacao) {
            this.showFormOrg = false;
            if (this.organizacao) {
                this.loadData();
            }
        },
        handleExcluir: function handleExcluir() {
            if (confirm("Confirma a exclusão?")) {
                this.apiPessoasDelete(this.pessoa.codpessoa, this.callBackPessoa);
            }
        },
        handleReabrir: function handleReabrir() {
            var obj = { codpessoa: this.pessoa.codpessoa, excluido: 'N' };
            this.apiPessoas(obj, this.pessoa.codpessoa, this.callBackPessoa);
        },
        callBackPessoa: function callBackPessoa(data) {
            if (data) {
                this.pessoa = data;
                if (!this.pessoa.codorg) this.organizacao = null;
            }
        },
        closeForm: function closeForm() {
            if (this.$route.params.id) this.$router.go(-1);else this.$emit('closeform');
        },
        loadEmails: function loadEmails() {
            this.showCodemail = null;
            this.$store.dispatch('loadNegocioEmails', { id: this.pessoa.codnegocio });
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var codpessoa;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadConfigCrm', _this);

                            case 2:
                                codpessoa = _this.index;

                                if (_this.$route.params && _this.$route.params.id) codpessoa = _this.$route.params.id;
                                _context.next = 6;
                                return _this.$store.dispatch('loadPessoa', { id: codpessoa });

                            case 6:
                                if (_this.$store.getters.getPessoa) {
                                    _this.pessoa = _extends({}, _this.$store.getters.getPessoa);
                                    console.log(_this.pessoa.tag);
                                    console.log(_this.organizacao.tag);
                                    _this.notes = _this.pessoa.notes;
                                    _this.seguidores = _this.pessoa.seguidores;
                                    _this.anexos = _this.pessoa.anexos;
                                }

                                //CONTADORES
                                // this.tabs[1].count = this.anexos.length
                                // this.tabs[2].count = this.emailList.length
                                // this.tabs[2].count = this.agendaList.length
                                // this.tabs[3].count = this.listNegocios.length
                                // this.tabs[4].count = this.listVinculados.length

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleEditarPessoa: function handleEditarPessoa(tipo) {
            this.paramsPessoa = {};
            if (tipo == 'org') this.paramsPessoa.org = true;else if (tipo == 'fone') this.paramsPessoa.fone = true;else if (tipo == 'email') this.paramsPessoa.email = true;else this.paramsPessoa = null;
            this.showFormPessoa = true;
        },
        closeFormPessoa: function closeFormPessoa(pessoa) {
            this.showFormPessoa = false;
            if (pessoa) this.pessoa = pessoa;
        },


        //////////////////////////// ALTERAR OU VISUALIZAR NEGOCIO
        handleShowNegocio: function handleShowNegocio(codnegocio) {
            this.$router.push('/crm/negocio/' + codnegocio);
        },
        handleIncluirNegocio: function handleIncluirNegocio() {
            this.paramsNegocio = { pessoa: this.pessoa, organizacao: this.organizacao };
            this.showFormNegocio = true;
        },
        closeNovoNegocio: function closeNovoNegocio(negocio) {
            this.showFormNegocio = false;
            if (negocio) this.handleShowNegocio(negocio.codnegocio);
        },


        /////////////////////////////////// ORGANIZACAO
        handleDesvincularOrg: function handleDesvincularOrg() {
            var obj = { codpessoa: this.pessoa.codpessoa, codorg: null };
            this.apiPessoas(obj, this.pessoa.codpessoa, this.callBackPessoa);
        },
        handleShowOrg: function handleShowOrg() {
            this.$router.push('/crm/organizacao/' + this.pessoa.codorg);
        },
        handleEditarOrg: function handleEditarOrg() {
            this.showFormOrg = true;
        }
    }, _defineProperty(_methods, 'closeFormOrg', function closeFormOrg() {
        this.showFormOrg = false;
    }), _defineProperty(_methods, 'handleIncluirSeguidor', function handleIncluirSeguidor() {
        this.showFormSeguidores = true;
    }), _defineProperty(_methods, 'handleCloseSeguidor', function handleCloseSeguidor() {
        this.seguidores = this.pessoa.seguidores;
        this.showFormSeguidores = false;
    }), _defineProperty(_methods, 'handleIncluirAgenda', function handleIncluirAgenda(codagenda) {
        //abre a tela de edicao
        this.$refs.agenda.handleIncluirAgenda();
    }), _defineProperty(_methods, 'updateAgenda', function updateAgenda(agenda) {
        this.tabs[3].count = this.agendaList.length;
    }), _defineProperty(_methods, 'handleAnexarDocumento', function handleAnexarDocumento() {
        //ANEXAR DOCUMENTOS
        this.$nextTick(function () {
            this.$refs.anexos.handleClickAdiciona();
        });
    }), _defineProperty(_methods, 'handleChangeAnexos', function handleChangeAnexos(anexosList) {
        //ATUALIZA A LISTA DE ANEXOS
        this.anexos = anexosList;
        this.tabs[1].count = this.anexos.length;
    }), _methods),

    watch: {},

    mounted: function mounted() {
        this.$nextTick(function () {
            if (this.$refs.usuario) {
                this.$refs.usuario.focus();
            }
        });
    },
    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__);
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        negocio: {},
        funil: {},
        negocioNovoForm: Boolean
    },

    components: {},

    data: function data() {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,

            selectedEtapa: null,

            etapaList: [{ descricao: 'Cliente Potencial', probabilidade: 100, estagnado: 0, excluida: false, transfer_codetapa: null }, { descricao: 'Contato Realizado', probabilidade: 100, estagnado: 0, excluida: false, transfer_codetapa: null }, { descricao: 'Visita Técnica', probabilidade: 100, estagnado: 0, excluida: false, transfer_codetapa: null }, { descricao: 'Proposta Feita', probabilidade: 100, estagnado: 0, excluida: false, transfer_codetapa: null }, { descricao: 'Negociação em Andamento', probabilidade: 100, estagnado: 0, excluida: false, transfer_codetapa: null }]

        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {},

    methods: {
        isActive: function isActive(index) {
            if (this.selectedEtapa && this.etapaList[index].sequencia <= this.selectedEtapa.sequencia) return 'active';else return '';
        },
        handleSelectEtapa: function handleSelectEtapa(index) {
            //efetua a gravacao da etapa selecionada
            this.selectedEtapa = this.etapaList[index];
            this.$emit('change', this.selectedEtapa);

            if (!this.negocioNovoForm) {
                var data = {
                    codnegocio: this.negocio.codnegocio,
                    codetapa: this.etapaList[index].codetapa
                };
                this.apiNegocio(data, this.negocio.codnegocio, this.callBack);
            }
        },
        callBack: function callBack(data) {
            //atualiza o codigo da etapa selecionada do objeto pai
            if (data) {
                this.negocio.codetapa = data.codetapa;
            }
        }
    },

    watch: {},

    mounted: function mounted() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
    },
    created: function created() {
        var _this = this;

        this.etapaList = this.funil.etapas;

        for (var x = 0; x < this.etapaList.length; x++) {
            if (this.etapaList[x].codetapa == this.negocio.codetapa) this.selectedEtapa = this.etapaList[x];
        }

        //CARREGA O NR DE DIAS DAS ETAPAS
        if (this.negocio.dias_etapas) {
            var etapa = null;
            for (var x = 0; x < this.etapaList.length; x++) {

                if (this.etapaList[x].sequencia > this.selectedEtapa.sequencia) break;

                etapa = this.negocio.dias_etapas.filter(function (obj) {
                    return obj.codetapa === _this.etapaList[x].codetapa;
                });
                if (etapa.length > 0) {
                    this.etapaList[x].texto_dias = etapa[0].dias + ' dias';
                }
            }
        }

        console.log(this.etapaList);
    }
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_input_color__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_pipeline__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__crm_tag_form__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__crm_negocio_motivo_form__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__api_api_crm_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        funil: {},
        params: {}
    },

    components: {
        InputColor: __WEBPACK_IMPORTED_MODULE_3__components_input_color__["a" /* default */], CrmPipeline: __WEBPACK_IMPORTED_MODULE_4__crm_pipeline__["a" /* default */], CrmTagForm: __WEBPACK_IMPORTED_MODULE_5__crm_tag_form__["a" /* default */], CrmNegocioMotivoForm: __WEBPACK_IMPORTED_MODULE_6__crm_negocio_motivo_form__["a" /* default */]
    },

    data: function data() {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,

            localFunil: null,

            negociocrm: _extends({}, this.$store.getters.getEntities.negociocrm),
            pessoa: {},
            organizacao: {},
            origem: {},

            telefones: [],
            emails: [],

            showTagForm: false,
            codtag: null,
            crudTag: '',

            inputOrg: {
                url: '/crm/find/organizacao?nome=',
                permite_novo: true,
                codigo: null,
                // label: 'Organização',
                icon: 'fa-university'
                // placeholder: 'Nome da Organização',
            },

            inputPessoa: {
                url: '/crm/find/pessoa?nome=',
                permite_novo: true,
                codigo: null,
                icon: 'fa-user'
            },

            inputOrigem: {
                url: '/crm/find/origem?nome=',
                permite_novo: true,
                codigo: null,
                icon: 'fa-user'
            },

            inputFone: {
                url: '/crm/find/pessoa?fone=',
                duplicados: true,
                codigo: null
                // label: this.$store.getters.getEntities.metadata.fonecrm.numero.label,
            },

            inputEmail: {
                url: '/crm/find/pessoa?email=',
                duplicados: true,
                codigo: null
                // label: this.$store.getters.getEntities.metadata.emailcrm.email.label,
            }

        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_7__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        // nome: function () {
        // return this.pessoacrm.nome
        // }
        administrador: function administrador() {
            return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].usuarioAdministrador;
        },

        isNovoNegocio: function isNovoNegocio() {
            return !this.params || !this.params.negocio;
        },

        alterarOutrosCampos: function alterarOutrosCampos() {
            return this.isNovoNegocio || this.params.alterarOutrosCampos;
        },

        alterarPessoa: function alterarPessoa() {
            return this.params.alterarPessoa;
        },

        alterarOrg: function alterarOrg() {
            return this.params.alterarOrg;
        },

        habilitaContatos: function habilitaContatos() {
            return this.pessoa && this.pessoa.novo;
        },

        title: function title() {
            if (this.negociocrm.codnegocio) return 'Alterar Negócio';else return 'Incluir Novo Negócio';
        }

    },

    methods: {
        handleCadastroOrigem: function handleCadastroOrigem() {
            this.$router.push('/crm/config');
        },
        handleSalvar: function handleSalvar() {
            var _this = this;

            var valido = true;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Corrija os erros de preenchimento para continuar!');
                } else if (valido) {
                    _this.pessoa.telefones = _this.telefones;
                    _this.pessoa.emails = _this.emails;
                    _this.organizacao.endereco = null;
                    _this.organizacao.codtag = null;
                    _this.organizacao.visivel = null;
                    _this.negociocrm.dados = {
                        org: _this.organizacao,
                        pessoa: _this.pessoa
                    };
                    _this.apiNegocio(_this.negociocrm, _this.negociocrm.codnegocio, _this.callBackPost);
                }
            });
        },
        callBackPost: function callBackPost(negocio) {
            if (this.negociocrm.codnegocio) this.$erpToastSuccess('Negócio alterado');else this.$erpToastSuccess('Novo negócio criado');
            this.closeForm(negocio);
        },
        closeForm: function closeForm(negocio) {
            this.$emit('closeform', negocio);
        },
        handleNovoOrg: function handleNovoOrg(text) {
            this.organizacao = { novo: true, nome: text };
        },
        handleNovoPessoa: function handleNovoPessoa(text) {
            this.pessoa = {
                novo: true,
                nome: text
            };
            this.telefones = [];
            this.emails = [];
            this.handleAdicionarEmail();
            this.handleAdicionarTelefone();
        },
        handleNovoOrigem: function handleNovoOrigem(text) {
            this.origem = { novo: true, nome: text };
        },
        handleSelectOrg: function handleSelectOrg(selected) {
            this.organizacao = selected;
            if (this.organizacao) {
                this.organizacao.novo = false;
            }
        },
        handleSelectPessoa: function handleSelectPessoa(selected) {
            this.pessoa = selected;
            if (this.pessoa) {
                this.pessoa.novo = false;
                this.telefones = this.pessoa.telefones;
                this.emails = this.pessoa.emails;
                if (this.pessoa.codorg) {
                    this.negociocrm.codorg = this.pessoa.codorg;
                    this.organizacao.codorg = this.pessoa.codorg;
                    this.organizacao.nome = this.pessoa.nome_org;
                    this.organizacao.novo = false;
                    this.$refs.organizacao.setValue(this.organizacao.codorg, this.organizacao.nome, this.organizacao);
                }
            }
        },
        handleSelectOrigem: function handleSelectOrigem(selected) {
            this.origem = selected;
            if (this.origem) {
                this.origem.novo = false;
            }
        },
        handleChangeEtapa: function handleChangeEtapa(etapa) {
            this.negociocrm.codetapa = etapa.codetapa;
        },
        setFields: function setFields() {
            //OS CAMPOS DE NOME DA PESSOA E ORGANIZACAO DEVEM RECEBER OS RESPECTIVOS VALORES
            if (this.negociocrm.codorigem && this.$refs.origem) {
                this.origem = this.negociocrm.origem[0];
                this.origem.novo = false;
                this.$refs.origem.setValue(this.origem.codorigem, this.origem.descricao, this.origem);
            }
            console.log(this.pessoa);
            if (this.params && this.params.lead) {
                this.$refs.pessoa.setValue(this.pessoa.codpessoa, this.pessoa.nome, this.pessoa);
                this.$refs.organizacao.setValue(this.organizacao.codorg, this.organizacao.nome, this.organizacao);
            } else {
                if (this.negociocrm.codpessoa && this.$refs.pessoa) {
                    this.pessoa = this.negociocrm.pessoa[0];
                    this.pessoa.novo = false;
                    this.telefones = this.pessoa.telefones;
                    this.emails = this.pessoa.emails;
                    this.$refs.pessoa.setValue(this.pessoa.codpessoa, this.pessoa.nome, this.pessoa);
                }
                if (this.negociocrm.codorg && this.$refs.organizacao) {
                    this.organizacao = this.negociocrm.organizacao[0];
                    this.organizacao.novo = false;
                    this.$refs.organizacao.setValue(this.organizacao.codorg, this.organizacao.nome, this.organizacao);
                }
            }
        },


        // async loadData (id) {
        //     await this.$store.dispatch('loadNegocio', { id: this.index } )
        //     if (this.$store.getters.getNegocio) {
        //         this.negocio = {...this.$store.getters.getNegocio}
        //     }
        // },

        /////////////////////////////////// TELEFONES

        handleAdicionarTelefone: function handleAdicionarTelefone() {
            this.telefones.push({
                numero: null,
                ramal: null,
                tipofone: '0'
            });
        },
        handleDeleteTelefone: function handleDeleteTelefone(index) {
            this.telefones.splice(index, 1);
        },


        /////////////////////////////////// EMAILS
        handleAdicionarEmail: function handleAdicionarEmail() {
            this.emails.push({
                email: null,
                tipoemail: null
            });
        },
        handleDeleteEmail: function handleDeleteEmail(index) {
            this.emails.splice(index, 1);
        },


        //////////////////////////// TAG FORM
        handleAdicionarTag: function handleAdicionarTag() {
            this.codtag = null;
            this.crudTag = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI;
            this.showTagForm = true;
        },
        handleEditarTag: function handleEditarTag(cod) {
            this.crudTag = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudU;
            this.codtag = cod;
            this.showTagForm = true;
        },
        handleCloseTag: function handleCloseTag(tag) {
            this.$refs.etiqueta.loadData();
            this.showTagForm = false;
            if (tag) {
                this.negociocrm.codtag = tag.codtag;
            }
        },
        loadConfig: function loadConfig() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadConfigCrm', _this2);

                            case 2:

                                _this2.localFunil = _this2.$store.getters.getConfigCrm.funil[0];
                                _this2.localFunil.etapas = _this2.$store.getters.getConfigCrm.etapas.filter(function (option) {
                                    return option.codfunil == _this2.localFunil.codfunil;
                                });

                                _this2.negociocrm.codfunil = _this2.localFunil.codfunil;
                                _this2.negociocrm.codetapa = _this2.localFunil.etapas[0].codetapa;

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },

    watch: {},

    mounted: function mounted() {
        this.setFields();

        this.$nextTick(function () {
            if (this.$refs.pessoa) {
                this.$refs.pessoa.focus();
            }
        });
        // this.handleAdicionarTelefone()
        // this.handleAdicionarEmail()
    },
    created: function created() {
        if (this.funil) {
            this.localFunil = this.funil;
            this.negociocrm.codetapa = this.funil.etapas[0].codetapa;
            this.negociocrm.codfunil = this.funil.codfunil;
        } else this.loadConfig();

        if (this.params) {
            if (this.params.negocio) this.negociocrm = this.params.negocio;
            if (this.params.pessoa) {
                this.negociocrm.codpessoa = this.params.pessoa.codpessoa;
                this.negociocrm.pessoa = [this.params.pessoa];
            }
            if (this.params.organizacao) {
                this.negociocrm.codorg = this.params.organizacao.codpessoa;
                this.negociocrm.organizacao = [this.params.organizacao];
            }
            if (this.params.lead) {
                //CRIA UM NEGOCIO ATRAVES DO LEAD
                this.pessoa.codorg = null;
                this.pessoa.novo = true;
                this.pessoa.nome = this.params.lead.pessoanome;
                this.telefones = [{ numero: this.params.lead.fonenumero, tipofone: null }];
                this.emails = [{ email: this.params.lead.email, tipoemail: null }];
                this.organizacao.codorg = null;
                this.organizacao.novo = true;
                this.organizacao.nome = this.params.lead.orgnome;
                this.negociocrm.codtag = this.params.lead.codtag;
                this.negociocrm.valor = this.params.lead.valor;
                this.negociocrm.titulo = this.params.lead.titulo;
                this.negociocrm.codorigem = this.params.lead.codorigem;
                this.negociocrm.codlead = this.params.lead.codlead;
            }
        }
    }
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: {},
        value: {},
        disabled: Boolean
    },

    data: function data() {
        return {

            textSearch: '',
            inicio: true,
            noList: true,
            showList: false,
            originalTop: 0,

            isChoosing: true,

            selectedIndex: null,
            selected: null,

            list: [{ id: 1, text: 'teste1', color: 'red' }, { id: 2, text: 'teste2', color: 'green' }, { id: 5, text: 'teste3', color: 'green' }, { id: 6, text: 'teste4', color: 'green' }, { id: 7, text: 'teste5', color: 'blue' }]

        };
    },


    computed: {

        metadata: function metadata() {
            return this.$store.getters.getEntities.metadata;
        },

        administrador: function administrador() {
            return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador;
        }

    },

    filters: {},

    methods: {
        handleEsc: function handleEsc() {
            this.showList = false;
        },
        handleKeyDown: function handleKeyDown() {
            //TECLA PARA BAIXO
            if (this.disabled) return;
            if (!this.showList) this.show();

            if (this.list.length > 0) {
                if (this.selectedIndex > this.list.length) {
                    this.selectedIndex = 0;
                } else {
                    this.selectedIndex = this.selectedIndex + 1;
                }
            }
        },
        handleKeyUp: function handleKeyUp() {
            //TECLA PARA CIMA
            if (this.disabled) return;
            if (!this.showList) this.show();
            if (this.list.length > 0) {
                if (this.selectedIndex < 1) {
                    this.selectedIndex = this.list.length - 1;
                } else {
                    this.selectedIndex = this.selectedIndex - 1;
                }
            }
        },
        handleAdicionar: function handleAdicionar() {
            this.$emit('adicionar');
        },
        handleEditar: function handleEditar(index) {
            this.$emit('editar', this.list[index].value);
        },
        focus: function focus() {
            this.$refs.pesquisa.focus();
        },
        handleBlur: function handleBlur() {
            // this.showList = false
        },
        handleChange: function handleChange(evt) {
            this.$refs.pesquisa.value = '';
        },
        handleSelectItem: function handleSelectItem(index) {
            //AO SELECIONAR UM REGISTRO
            if (index === null) {
                this.selectedIndex = null;
                this.selected = null;
                this.$emit('input', null);
                this.$emit('select', null);
                return;
            }
            this.selectedIndex = index;

            if (this.list.length > 0) {
                this.selected = this.list[this.selectedIndex];
                this.showList = false;
                this.isChoosing = false;
                this.textSearch = '';
                this.$emit('input', this.selected.value);
                this.$emit('select', this.selected);
            }
        },
        show: function show() {
            if (this.disabled) return;
            this.showList = !this.showList;
        },
        isSelected: function isSelected(index) {
            return index == this.selectedIndex;
        },
        handleStyle: function handleStyle(color) {
            if (color) return 'color: white; background-color: ' + color;else return '';
        },


        focusControl: function focusControl(event) {
            var thisIndex = jQuery(this.$el.querySelector('input')).index(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
            var next = thisIndex + 1;
            var obj = jQuery(__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].sFocusControl);
            for (var x = next; x < obj.length; x++) {
                if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled")) {
                    jQuery(obj[x]).focus();
                    break;
                }
            }
        },

        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:

                                _this.list = [];

                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDS"])(_this.$store.getters.urlOrds + _this.params.url);

                            case 3:
                                data = _context.sent;

                                if (data.items) {
                                    _this.list = data.items;
                                }

                                if (_this.value && !_this.selected) _this.setValue();

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        setValue: function setValue() {
            this.selectedIndex = null;
            this.selected = null;
            for (var i = 0; i < this.list.length; i++) {
                if (this.list[i].value == this.value) {
                    this.selectedIndex = i;
                    this.selected = this.list[i];
                    break;
                }
            }
        }
    },

    watch: {

        list: function list() {
            if (this.inicio) {
                return;
            }
            if (!this.list.length) {
                this.noList = true;
                this.showList = false;
            } else {
                this.noList = false;
                this.showList = true;
            }
        },

        value: function value() {
            if (!this.selected || this.value != this.selected.value) {
                this.setValue();
            }
        }

    },

    components: {},

    created: function created() {
        if (this.params.url) this.loadData();else this.list = this.params.list; //lista fixa
    },
    mounted: function mounted() {
        if (this.value) {
            this.setValue();
        }
    }
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_input_color__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__api_api_crm_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        tptag: '',
        crud: ''
    },

    components: {
        InputColor: __WEBPACK_IMPORTED_MODULE_1__components_input_color__["a" /* default */]
    },

    data: function data() {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            tagcrm: _extends({}, this.$store.getters.getEntities.tagcrm),
            params: {
                label: this.$store.getters.getEntities.metadata.tagcrm.cor.label,
                edit: false,
                list: [{ value: '#2196f3', title: '', cor: '#2196f3' }, { value: '#ff7300', title: '', cor: '#ff7300' }, { value: 'red', title: '', cor: 'red' }, { value: 'black', title: '', cor: 'black' }, { value: 'gray', title: '', cor: 'gray' }, { value: 'silver', title: '', cor: 'silver' }, { value: 'purple', title: '', cor: 'purple' }]
            },
            selectedCor: ''
        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_4__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        title: function title() {
            if (this.index) return 'Alterar Etiqueta';else return 'Incluir Nova Etiqueta';
        }
    },

    methods: {
        handleSalvar: function handleSalvar() {
            var _this = this;

            this.tagcrm.tptag = this.tptag;

            var valido = true;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Corrija os erros de preenchimento para continuar!');
                } else if (valido) {
                    _this.apiTag(_this.tagcrm, _this.tagcrm.codtag, _this.callBackPost);
                }
            });
        },
        callBackPost: function callBackPost(tag) {
            if (this.index) this.$erpToastSuccess('Etiqueta alterada');else this.$erpToastSuccess('Novo etiqueta inserida');
            this.closeForm(tag);
        },
        closeForm: function closeForm(tag) {
            this.$emit('closeform', tag);
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this2.index) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                _context.next = 4;
                                return _this2.$store.dispatch('loadTagCrm', { id: _this2.index });

                            case 4:
                                if (_this2.$store.getters.getTagCrm) {
                                    _this2.tagcrm = _extends({}, _this2.$store.getters.getTagCrm);
                                }

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },

    watch: {},

    mounted: function mounted() {
        this.$nextTick(function () {
            if (this.$refs.descricao) {
                this.$refs.descricao.focus();
            }
        });
    },
    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: {}
    },

    components: {},

    data: function data() {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,

            negociocrm: _extends({}, this.$store.getters.getEntities.negociocrm),

            inputMotivo: {
                url: '/crm/find/motivo?descricao=',
                permite_novo: false,
                codigo: null,
                label: 'Motivo da Perda'
                // icon: 'fa-university', 
            }
        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        title: function title() {
            return 'Negócio Perdido';
        },
        administrador: function administrador() {
            return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].usuarioAdministrador;
        }
    },

    methods: {
        handleSalvar: function handleSalvar() {
            var _this = this;

            var valido = true;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Corrija os erros de preenchimento para continuar!');
                } else if (valido) {
                    _this.negociocrm.dados = {
                        motivo: _this.motivo
                    };
                    _this.apiNegocio(_this.negociocrm, _this.negociocrm.codnegocio, _this.callBackPost);
                }
            });
        },
        handleCadastroMotivo: function handleCadastroMotivo() {
            this.$router.push('/crm/config');
        },
        callBackPost: function callBackPost(negocio) {
            this.closeForm(negocio);
        },
        closeForm: function closeForm(negocio) {
            this.$emit('closeform', negocio);
        },
        handleNovoMotivo: function handleNovoMotivo(text) {
            this.motivo = { novo: true, descricao: text };
        },
        handleSelectMotivo: function handleSelectMotivo(selected) {
            this.motivo = selected;
            if (this.motivo) {
                this.motivo.novo = false;
            }
        }
    },

    watch: {},

    mounted: function mounted() {
        this.$nextTick(function () {
            if (this.$refs.motivo) {
                this.$refs.motivo.focus();
            }
        });
    },
    created: function created() {
        if (this.params.negocio) {
            this.negociocrm = this.params.negocio;
        }
    }
});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_input_color__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_tag_form__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__api_api_crm_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: '',
        transformarPart: Boolean //para transformar a organização em cliente
    },

    components: {
        InputColor: __WEBPACK_IMPORTED_MODULE_2__components_input_color__["a" /* default */], CrmTagForm: __WEBPACK_IMPORTED_MODULE_4__crm_tag_form__["a" /* default */]
    },

    data: function data() {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            showTagForm: false,
            codtag: null,
            crudTag: '',
            part: _extends({}, this.$store.getters.getEntities.part),
            orgcrm: _extends({}, this.$store.getters.getEntities.orgcrm),

            inputNome: {
                url: '/crm/find/organizacao?nome=',
                permite_novo: false,
                duplicados: true,
                codigo: null,
                icon: 'fa-university'
            }

        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_5__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {

        nome: function nome() {
            return this.orgcrm.nome;
        },

        dadosPart: function dadosPart() {
            return this.orgcrm.cnpj;
        }

    },

    methods: {
        updateCep: function updateCep() {
            //CARREGA INFORMACOES DO CEP DIGITADO            
            this.orgcrm.ende = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.logradouro;
            this.orgcrm.bairro = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.bairro;
            this.orgcrm.codmun = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.ibge;
            this.orgcrm.uf = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].endereco.uf;
            this.orgcrm.codpais = '1058';
        },
        handleSalvar: function handleSalvar() {
            var _this = this;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Corrija os erros de preenchimento para continuar!');
                } else {
                    if (_this.transformarPart) {
                        _this.orgcrm.cliente = _this.part;
                    }
                    _this.apiOrg(_this.orgcrm, _this.orgcrm.codorg, _this.callBackPost);
                }
            });
        },
        handleAdicionarTag: function handleAdicionarTag() {
            this.codtag = null;
            this.crudTag = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI;
            this.showTagForm = true;
        },
        handleEditarTag: function handleEditarTag(cod) {
            this.crudTag = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudU;
            this.codtag = cod;
            this.showTagForm = true;
        },
        handleCloseTag: function handleCloseTag(tag) {
            this.$refs.etiqueta.loadData();
            if (tag) this.orgcrm.codtag = tag.codtag;
            this.showTagForm = false;
        },
        callBackPost: function callBackPost(org) {
            this.closeForm(org);
        },
        closeForm: function closeForm(org) {
            this.$emit('closeform', org);
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadOrganizacao', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getOrganizacao) {
                                    _this2.orgcrm = _extends({}, _this2.$store.getters.getOrganizacao);
                                }

                                _this2.part.tpcliente = 'F';
                                _this2.part.optsimples = 'N';
                                _this2.part.zfranca = 'N';
                                _this2.part.contricms = 'S';

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },

    watch: {
        nome: function nome() {
            // console.log(this.nome)
        }

    },

    mounted: function mounted() {
        this.$nextTick(function () {
            if (this.$refs.nome) {
                this.$refs.nome.focus();
            }
        });
    },
    created: function created() {
        if (this.index) this.loadData();
    }
});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_input_color__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_tag_form__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__api_api_crm_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: '',
        params: {}
    },

    components: {
        InputColor: __WEBPACK_IMPORTED_MODULE_2__components_input_color__["a" /* default */], CrmTagForm: __WEBPACK_IMPORTED_MODULE_4__crm_tag_form__["a" /* default */]
    },

    data: function data() {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            showTagForm: false,
            codtag: null,
            crudTag: '',

            pessoacrm: {
                codpessoa: null,
                nome: null,
                data: null,
                codusuario: null,
                codorg: null,
                codtag: null,
                visivel: null
            },

            telefones: [],
            emails: [],

            organizacao: {
                novo: false,
                nome: null,
                codorg: null
            },

            inputOrg: {
                url: '/crm/find/organizacao?nome=',
                permite_novo: true,
                codigo: null,
                // label: 'Organização',
                icon: 'fa-university'
                // placeholder: 'Nome da Organização',
            },

            inputNome: {
                url: '/crm/find/pessoa?nome=',
                duplicados: true,
                codigo: null,
                // label: this.$store.getters.getEntities.metadata.pessoacrm.codorg.label,
                icon: 'fa-user'
                // placeholder: 'Nome do Contato',
            },

            inputFone: {
                url: '/crm/find/pessoa?fone=',
                duplicados: true,
                codigo: null
                // label: this.$store.getters.getEntities.metadata.fonecrm.numero.label,
            },

            inputEmail: {
                url: '/crm/find/pessoa?email=',
                duplicados: true,
                codigo: null
                // label: this.$store.getters.getEntities.metadata.emailcrm.email.label,
            }

        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_5__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        nome: function nome() {
            return this.pessoacrm.nome;
        }

    },

    methods: {
        handleSalvar: function handleSalvar() {
            var _this = this;

            var valido = true;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Corrija os erros de preenchimento para continuar!');
                } else if (valido) {
                    if (_this.organizacao.novo) _this.pessoacrm.dados = { org: _this.organizacao };
                    _this.pessoacrm.telefones = _this.telefones;
                    _this.pessoacrm.emails = _this.emails;
                    _this.apiPessoas(_this.pessoacrm, _this.pessoacrm.codpessoa, _this.callBackPost);
                }
            });
        },
        handleAdicionarTag: function handleAdicionarTag() {
            this.codtag = null;
            this.crudTag = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI;
            this.showTagForm = true;
        },
        handleEditarTag: function handleEditarTag(cod) {
            this.crudTag = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudU;
            this.codtag = cod;
            this.showTagForm = true;
        },
        handleCloseTag: function handleCloseTag(tag) {
            this.$refs.etiqueta.loadData();
            if (tag) this.pessoacrm.codtag = tag.codtag;
            this.showTagForm = false;
        },
        callBackPost: function callBackPost(pessoa) {
            this.closeForm(pessoa);
        },
        closeForm: function closeForm(pessoa) {
            this.$emit('closeform', pessoa);
        },
        handleNovoOrg: function handleNovoOrg(text) {
            if (!this.organizacao) this.organizacao = {};
            this.organizacao.novo = true;
            this.organizacao.nome = text;
        },
        handleSelectOrg: function handleSelectOrg(selected) {
            this.organizacao = selected;
            if (this.organizacao) {
                this.organizacao.novo = false;
            }
        },
        handleIncluirOrg: function handleIncluirOrg(selected) {
            this.pessoacrm.codorg = selected.codigo;
            this.organizacao.novo = false;
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadPessoa', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getPessoa) {
                                    _this2.pessoacrm = _extends({}, _this2.$store.getters.getPessoa);
                                    _this2.telefones = _this2.pessoacrm.telefones;
                                    _this2.emails = _this2.pessoacrm.emails;
                                    _this2.setFields();
                                }

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },


        /////////////////////////////////// TELEFONES
        handleAdicionarTelefone: function handleAdicionarTelefone() {
            this.telefones.push({
                numero: null,
                ramal: null,
                tipofone: '0'
            });
        },
        handleDeleteTelefone: function handleDeleteTelefone(index) {
            this.telefones.splice(index, 1);
        },


        /////////////////////////////////// EMAILS
        handleAdicionarEmail: function handleAdicionarEmail() {
            this.emails.push({
                email: null,
                tipoemail: null
            });
        },
        handleDeleteEmail: function handleDeleteEmail(index) {
            this.emails.splice(index, 1);
        },
        setFields: function setFields() {
            if (this.pessoacrm.codorg && this.$refs.organizacao) {
                this.organizacao = this.pessoacrm.organizacao[0];
                this.organizacao.novo = false;
                this.$refs.organizacao.setValue(this.organizacao.codorg, this.organizacao.nome, this.organizacao);
            }
        }
    },

    watch: {
        nome: function nome() {}

    },

    mounted: function mounted() {
        this.$nextTick(function () {
            if (this.$refs.nome) {
                this.$refs.nome.focus();
            }
        });

        if (!this.index) {
            this.handleAdicionarTelefone();
            this.handleAdicionarEmail();
        }
    },
    created: function created() {
        if (this.index) this.loadData();
    }
});

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: {}
    },

    components: {},

    data: function data() {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,

            negociocrm: _extends({}, this.$store.getters.getEntities.negociocrm),
            pessoa: null,
            telefones: [],
            emails: [],
            codpessoa: null,

            addingParticipante: false,

            listParticipantes: [],

            inputPessoa: {
                url: '/crm/find/pessoa?nome=',
                permite_novo: true,
                codigo: null,
                icon: 'fa-user'
            },

            inputFone: {
                url: '/crm/find/pessoa?fone=',
                duplicados: true,
                codigo: null
                // label: this.$store.getters.getEntities.metadata.fonecrm.numero.label,
            },

            inputEmail: {
                url: '/crm/find/pessoa?email=',
                duplicados: true,
                codigo: null
                // label: this.$store.getters.getEntities.metadata.emailcrm.email.label,
            }

        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        isNovoNegocio: function isNovoNegocio() {
            return !this.params;
        },

        habilitaContatos: function habilitaContatos() {
            return this.pessoa && this.pessoa.novo;
        },

        title: function title() {
            return 'Participantes do Negócio';
        }

    },

    methods: {
        handleIncluirPessoa: function handleIncluirPessoa() {
            console.log('fila da puta');
            this.addingParticipante = true;
            this.telefones = [];
            this.emails = [];
            this.codpessoa = null;
            this.$nextTick(function () {
                if (this.$refs.pessoa) {
                    this.$refs.pessoa.focus();
                }
            });
        },
        handleSalvar: function handleSalvar() {
            var _this = this;

            if (!this.pessoa) {
                this.$refs.pessoa.focus();
                return;
            }

            if (this.listParticipantes.filter(function (obj) {
                return obj.codpessoa == _this.codpessoa;
            }).length > 0) {
                this.addingParticipante = false;
                return;
            }

            var valido = true;
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Corrija os erros de preenchimento para continuar!');
                } else if (valido) {
                    var obj = { codnegocio: _this.negociocrm.codnegocio };
                    if (_this.pessoa.novo) {
                        _this.pessoa.telefones = _this.telefones;
                        _this.pessoa.emails = _this.emails;
                        obj.dados = { pessoa: _this.pessoa };
                        obj.participante = { codpessoa: null };
                    } else obj.participante = { codpessoa: _this.pessoa.codpessoa };

                    _this.apiNegocio(obj, _this.negociocrm.codnegocio, _this.callBackPost);
                }
            });
        },
        handleDelete: function handleDelete(index) {
            this.pessoa = null;
            var obj = { codnegocio: this.negociocrm.codnegocio };
            obj.participante = { codpessoa: this.listParticipantes[index].codpessoa, excluido: true };

            this.apiNegocio(obj, this.negociocrm.codnegocio, this.callBackPost);
            this.listParticipantes.splice(index, 1);
        },
        callBackPost: function callBackPost(negocio) {
            this.addingParticipante = false;
            if (this.pessoa) {
                this.negociocrm.participantes = negocio.participantes;
                this.listParticipantes = negocio.participantes;
            }
        },
        closeForm: function closeForm() {
            this.$emit('closeform');
        },


        // handleIncluirPessoa (text) {
        //     this.pessoa = {
        //         novo: true,
        //         nome: text,
        //     }
        //     this.telefones = []
        //     this.emails = []
        //     this.handleAdicionarEmail()
        //     this.handleAdicionarTelefone()
        // },

        handleSelectPessoa: function handleSelectPessoa(selected) {
            this.pessoa = selected;
            if (this.pessoa) {
                this.pessoa.novo = false;
                this.telefones = this.pessoa.telefones;
                this.emails = this.pessoa.emails;
            }
        },


        /////////////////////////////////// TELEFONES
        handleAdicionarTelefone: function handleAdicionarTelefone() {
            this.telefones.push({
                numero: null,
                ramal: null,
                tipofone: '0'
            });
        },
        handleDeleteTelefone: function handleDeleteTelefone(index) {
            this.telefones.splice(index, 1);
        },


        /////////////////////////////////// EMAILS
        handleAdicionarEmail: function handleAdicionarEmail() {
            this.emails.push({
                email: null,
                tipoemail: null
            });
        },
        handleDeleteEmail: function handleDeleteEmail(index) {
            this.emails.splice(index, 1);
        }
    },

    watch: {},

    mounted: function mounted() {
        if (this.negociocrm && this.negociocrm.participantes) {
            this.listParticipantes = this.negociocrm.participantes;
        }
        if (this.listParticipantes.length == 0) this.handleIncluirPessoa();
    },
    created: function created() {
        if (this.params && this.params.negocio) {
            this.negociocrm = this.params.negocio;
        }
    }
});

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__);
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: {}
    },

    components: {},

    data: function data() {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            negociocrm: null,
            pessoa: null,
            organizacao: null,
            codseguidor: null,

            addingSeguidor: false,

            listSeguidores: []
        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        title: function title() {
            return 'Vincular Usuários';
        }
    },

    methods: {
        handleDelete: function handleDelete(index) {
            if (confirm("Confirma a exclusão?")) {
                var obj = { seguidor: this.listSeguidores[index] };
                obj.seguidor.excluido = true;
                if (this.negociocrm) {
                    this.apiNegocio(obj, this.negociocrm.codnegocio).then(this.listSeguidores.splice(index, 1));
                }
                if (this.pessoa) {
                    this.apiPessoa(obj, this.pessoa.codpessoa).then(this.listSeguidores.splice(index, 1));
                }
                if (this.organizacao) {
                    this.apiOrg(obj, this.organizacao.codorg).then(this.listSeguidores.splice(index, 1));
                }
            }
        },
        handleSalvar: function handleSalvar() {
            var _this = this;

            if (!this.codseguidor) return;

            if (this.listSeguidores.filter(function (obj) {
                return obj.codusuario == _this.codseguidor;
            }).length > 0) {
                this.addingSeguidor = false;
                return;
            }

            var obj = { seguidor: { codusuario: this.codseguidor } };
            if (this.negociocrm) {
                obj.seguidor.codnegocio = this.negociocrm.codnegocio;
                this.apiNegocio(obj, this.negociocrm.codnegocio, this.callBackSeguidor);
            }
            if (this.pessoa) {
                obj.seguidor.codpessoa = this.pessoa.codpessoa;
                this.apiPessoa(obj, this.pessoa.codpessoa, this.callBackSeguidor);
            }
            if (this.organizacao) {
                obj.seguidor.codorg = this.organizacao.codorg;
                this.apiOrg(obj, this.organizacao.codorg, this.callBackSeguidor);
            }
        },
        handleCancelSeguidor: function handleCancelSeguidor(index) {
            this.addingSeguidor = false;
        },
        callBackSeguidor: function callBackSeguidor(data) {
            if (data) {
                if (this.addingSeguidor) {
                    this.listSeguidores = data.seguidores;
                    if (this.negociocrm) this.negociocrm.seguidores = data.seguidores;
                    if (this.pessoa) this.pessoa.seguidores = data.seguidores;
                    if (this.organizacao) this.organizacao.seguidores = data.seguidores;
                }
                this.addingSeguidor = false;
            }
        },
        handleIncluirSeguidor: function handleIncluirSeguidor() {
            this.addingSeguidor = true;
            this.codseguidor = null;
            this.$nextTick(function () {
                if (this.$refs.seguidor) {
                    this.$refs.seguidor.focus();
                }
            });
        },
        closeForm: function closeForm() {
            this.$emit('closeform');
        }
    },

    watch: {},

    mounted: function mounted() {
        if (this.negociocrm && this.negociocrm.seguidores) {
            this.listSeguidores = this.negociocrm.seguidores;
        }
        if (this.organizacao && this.organizacao.seguidores) {
            this.listSeguidores = this.organizacao.seguidores;
        }
        if (this.pessoa && this.pessoa.seguidores) {
            this.listSeguidores = this.pessoa.seguidores;
        }
        if (this.listSeguidores.length == 0) this.handleIncluirSeguidor();
    },
    created: function created() {
        if (this.params && this.params.negocio) {
            this.negociocrm = this.params.negocio;
        } else if (this.params && this.params.pessoa) {
            this.pessoa = this.params.pessoa;
        } else if (this.params && this.params.organizacao) {
            this.organizacao = this.params.organizacao;
        }
    }
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_agenda_form__ = __webpack_require__(79);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: {}
    },

    components: {
        AgendaForm: __WEBPACK_IMPORTED_MODULE_4__forms_agenda_form__["a" /* default */]
    },

    data: function data() {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            showFormAgenda: false,
            codagenda: null
        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {

        listAgenda: function listAgenda() {
            if (this.params.listAgendaShow) return this.params.listAgendaShow;else return this.params.listAgenda;
        },

        paramsAgenda: function paramsAgenda() {
            return { negocio: this.params.negocio, lead: this.params.lead, organizacao: this.params.organizacao, pessoa: this.params.pessoa };
        }

    },

    methods: {
        handleIncluirAgenda: function handleIncluirAgenda(codagenda) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI;
            this.codagenda = null;
            this.showFormAgenda = true;
        },
        handleEditAgenda: function handleEditAgenda(codagenda) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudU; //operacao de edicao
            this.codagenda = codagenda;
            this.showFormAgenda = true; //exibe o form de agenda
        },
        closeFormAgenda: function closeFormAgenda(agenda) {
            this.showFormAgenda = false;

            if (agenda) {
                var index = -1;
                for (var x = 0; x < this.params.listAgenda.length; x++) {
                    if (this.params.listAgenda[x].codagenda == agenda.codagenda) index = x;
                }
                if (index >= 0) {
                    this.params.listAgenda[index].concluida = agenda.concluida;
                    this.params.listAgenda[index].texto = agenda.texto;
                    this.params.listAgenda[index].titulo = agenda.titulo;
                } else this.params.listAgenda.push(agenda);
            }

            this.$emit('update', agenda);
        },
        handleDeleteAgenda: function handleDeleteAgenda(codagenda) {
            var index = null;
            for (var x = 0; x < this.params.listAgenda.length; x++) {
                if (this.params.listAgenda[x].codagenda == codagenda) index = x;
            }
            if (confirm("Confirma a exclusão?")) {
                this.params.listAgenda.splice(index, 1);
                this.apiAgendaDelete(codagenda).then(this.$emit('delete', this.params.listAgenda[x]));
            }
        }
    },

    watch: {},

    mounted: function mounted() {},
    created: function created() {}
});

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__api_api_crm_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__crm_email_destinatarios__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_utils__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        codemail: '',
        negocio: Object,
        pessoa: Object
    },

    data: function data() {
        return {
            editing: false,
            metadata: this.$store.getters.getEntities.metadata,

            bodyContent: null,
            bodyContentCopy: null,
            editor: null,

            config: {
                // { [module]: boolean (set true to hide) }
                hideModules: { "bold": true },
                iconOverrides: { "bold": "<i class='your-custom-icon'></i>" },
                image: {
                    uploadURL: "/api/myEndpoint",
                    dropzoneOptions: {}
                },
                maxHeight: "500px",
                forcePlainTextOnPaste: true,
                locale: 'pt'
            },

            upaloading: false,

            editingEmail: null,
            editingToList: [],
            editingCCList: [],
            editingBCCList: [],
            editingSubject: null,
            editingAttachments: [],
            sendMode: null,
            editingEnc: false,
            editingRe: false,

            selectedFile: null,

            codtempl: null,

            templateOptions: null

        };
    },


    components: {
        CrmEmailDestinatarios: __WEBPACK_IMPORTED_MODULE_3__crm_email_destinatarios__["a" /* default */] // EditorContent,
    },

    computed: {
        usuarionome: function usuarionome() {
            return this.$store.getters.getEnv.usuarionome;
        },

        templEmailList: function templEmailList() {
            return this.$store.getters.getTemplEmailList;
        },

        email: function email() {
            if (this.$store.getters.getEmailCrm) return this.$store.getters.getEmailCrm;else return null;
        },

        destinatarios: function destinatarios() {
            return {
                toList: this.editingToList,
                ccList: this.editingCCist,
                bccList: this.editingBCCList
            };
        },
        fromAddress: function fromAddress() {
            var addr = 'crm.mail.nb+' + this.$store.getters.getSessao.urlstring;
            if (this.editingEmail.link_codnegocio) addr = addr + '+deal' + this.editingEmail.link_codnegocio;
            return { email: addr + '@gmail.com', nome: this.usuarionome };
        }
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_2__api_api_crm_js___default.a], //ROTINAS DO CRM

    filters: {},

    methods: {
        loadTemplates: function loadTemplates() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var x;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadTemplEmail', {});

                            case 2:

                                _this.templateOptions = [];
                                for (x = 0; x < _this.$store.getters.getTemplEmailList.length; x++) {
                                    _this.templateOptions.push({ id: _this.$store.getters.getTemplEmailList[x].codtempl, text: _this.$store.getters.getTemplEmailList[x].descricao });
                                }

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        template: function template() {
            //CARREGA O TEMPLATE SELECIONADO PELO USUARIO
            console.log('teste1');
            if (!this.codtempl) return;

            var self = this;

            var template = this.templEmailList.filter(function (obj) {
                return obj.codtempl == self.codtempl;
            });
            this.bodyContent = template[0].body_content;
            if (this.sendMode == 'new') {
                this.editingSubject = template[0].subject;
            }
        },
        loadData: function loadData(codemail) {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var cod, self;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //carrega o email do servidor
                                cod = codemail;

                                if (!cod) cod = _this2.codemail;
                                _context2.next = 4;
                                return _this2.$store.dispatch('loadEmailCrm', { id: cod });

                            case 4:

                                //carrega o corpo do email armazenado no S3
                                if (_this2.email.bodyurl) {
                                    self = _this2;

                                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(_this2.email.bodyurl, {
                                        headers: {
                                            'Content-Type': 'multipart/form-data',
                                            'Access-Control-Allow-Origin': '*',
                                            'Access-Control-Allow-Headers': 'content-type'
                                        }
                                    }).then(function (data) {
                                        self.bodyContent = data.data;
                                    });
                                }

                                if (_this2.email.visualizado == 'N' && _this2.email.inbox == 'S') _this2.apiEmailLido(_this2.email.codemail);

                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                                _this2.show = 'collapsing';

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        handleResponder: function handleResponder() {
            if (!this.editingEmail) this.editingEmail = {};

            this.editingToList = [];
            this.editingCCList = [];

            for (var x = 0; x < this.email.from_list.length; x++) {
                if (this.email.from_list[x].email) this.editingToList.push({ email: this.email.from_list[x].email, nome: this.email.from_list[x].nome, label: this.email.from_list[x].nome + ' ' + this.email.from_list[x].email });else this.editingToList.push({ email: this.email.from_list[x], nome: '', label: this.email.from_list[x] });
            }

            if (this.email.cc_list) {
                for (var x = 0; x < this.email.cc_list.length; x++) {
                    if (this.email.cc_list[x].email) this.editingCCList.push({ email: this.email.cc_list[x].email, nome: this.email.cc_list[x].nome, label: this.email.cc_list[x].nome + ' ' + this.email.cc_list[x].email });else this.editingCCList.push({ email: this.email.cc_list[x], nome: '', label: this.email.cc_list[x] });
                }
            }

            this.editingEmail.link_codnegocio = this.email.link_codnegocio;
            this.editingSubject = 'Re: ' + this.email.subject;
            this.editingAttachments = [];

            this.editingRe = true;
            this.editingEnc = false;
            this.sendMode = 'reply';

            this.addReplyBlock();
            this.editing = true;

            this.$nextTick(function () {
                this.$refs.destinatarios.focus();
            });
        },
        handleEncaminhar: function handleEncaminhar() {
            if (!this.editingEmail) this.editingEmail = {};

            this.editingToList = [];
            this.editingCCList = [];

            this.editingEmail.link_codnegocio = this.email.link_codnegocio;
            this.editingSubject = 'Enc: ' + this.email.subject;
            this.editingAttachments = this.email.attachments;

            this.editingEnc = true;
            this.editingRe = false;
            this.sendMode = 'forward';

            this.addReplyBlock();
            this.editing = true;

            this.$nextTick(function () {
                this.$refs.destinatarios.focus();
            });

            if (this.editingAttachments.length > 0) this.handleSalvar(false); //salva a mensagem quando esta possuir arquivos anexos 
        },
        handleRemoverAnexo: function handleRemoverAnexo(idx) {
            //REMOVE ANEXO DO EMAIL EM EDICAO
            this.$set(this.editingAttachments[idx], 'excluido', true);
            this.apiDeleteAnexo(this.editingAttachments[idx].coddoc);
        },
        addReplyBlock: function addReplyBlock() {
            //ADICIONA O BLOCO DE RESPOSTA AO CORPO DO EMAIL

            if (!this.bodyContentCopy) this.bodyContentCopy = this.bodyContent;else this.bodyContent = this.bodyContentCopy;

            var data = Object(__WEBPACK_IMPORTED_MODULE_4__shared_utils__["formatDataHoraExtenso"])(this.email.data);
            var nome = '';
            var from = '';
            var to = '';
            var cc = '';

            if (this.email.from_list.length > 0) {
                if (this.email.from_list[0].email) from = this.email.from_list[0].email;else from = this.email.from_list[0];
            }

            for (var x = 0; x < this.email.to_list.length; x++) {
                if (to != '') to = to + ', ';
                if (this.email.to_list[x].email) to = to + this.email.to_list[x].email;else to = to + this.email.to_list[x];
            }
            to = 'To: ' + to;

            if (this.email.cc_list.length > 0) {
                for (var x = 0; x < this.email.cc_list.length; x++) {
                    if (!cc) cc = cc + ', ';
                    if (this.email.cc_list[x].email) cc = cc + this.email.cc_list[x].email;else cc = cc + this.email.cc_list[x];
                }
                cc = 'Cc: ' + cc;
            }

            if (this.sendMode == 'reply') this.bodyContent = '<br>' + '<div class="gmail_quote">' + '<div dir="ltr" class="gmail_attr">Em {{data}}, {{nome}} &lt;{{from}}&gt; escreveu:<br></div>' + '<blockquote class="gmail_quote" style="margin: 0px 0px 0px 0.8ex; border-left: 1px solid rgb(204, 204, 204); padding-left: 1ex;">' + this.bodyContent + '</blockquote>' + '</div>';else this.bodyContent = '<br>' + '<blockquote data-type="forward">' + '<div dir="ltr" class="gmail_attr">---------- Forwarded message ---------<br>' + 'De: <strong class="gmail_sendername" dir="auto">{{nome}}</strong> <span dir="auto">&lt;{{from}}&gt;</span><br>' + 'Date: {{data}}<br>Subject: {{subject}}<br>{{to}}<br>{{cc}}<br></div>' + '<div>' + this.bodyContent + '</div>' + '</blockquote>';

            this.bodyContent = this.bodyContent.replace('{{nome}}', nome);
            this.bodyContent = this.bodyContent.replace('{{data}}', data);
            this.bodyContent = this.bodyContent.replace('{{from}}', from);
            this.bodyContent = this.bodyContent.replace('{{to}}', to);
            this.bodyContent = this.bodyContent.replace('{{cc}}', cc);
            this.bodyContent = this.bodyContent.replace('{{subject}}', this.email.subject);
        },


        ////////////////////////////////// ANEXAR ARQUIVOS NO EMAIL
        /*
        emails encaminhados: quando há anexos, os anexos são copiados e vinculados ao novo email criado, então a rotina cria novos
        registros na tabela NBAPP.docs
         */

        handleAnexo: function handleAnexo() {
            this.$refs.file.value = '';
            this.$refs.file.click();
        },
        handleAdicionarAnexo: function handleAdicionarAnexo(event) {
            // if (event.target.files[0]['type']!=='image/jpeg' && event.target.files[0]['type']!=='image/png') {
            //     this.$erpToastError('Arquivo não permitido')
            //     return 
            // }

            this.selectedFile = event.target.files[0]; //this.$refs.file.files[0]

            if (!this.editingEmail || !this.editingEmail.codemail) {
                // quando usuario anexar arquivo no email, deve checar se o email possui codigo, se nao, 
                //deve gravar a mensagem e depois anexar
                this.upaloading = true;
                this.handleSalvar(false);
                return;
            }

            var obj = {
                codemail: this.editingEmail.codemail,
                selectedFile: this.selectedFile
            };
            this.apiUploadAnexo(obj, this.callbackAdicionarAnexo);
        },
        callbackAdicionarAnexo: function callbackAdicionarAnexo(data) {
            this.editingAttachments.push(data);
        },


        //////////////////////////////////// ROTINAS SALVAR EMAIL RASCUNHO E ENVIAR EMAIL

        handleEnviar: function handleEnviar() {

            if (!this.$refs.destinatarios.isValid) {
                return;
            }

            this.handleSalvar(true);
        },
        handleSalvar: function handleSalvar(enviar) {
            //salvar email

            if (!this.editingEmail) this.editingEmail = {};

            if (this.$refs.destinatarios) {
                this.$refs.destinatarios.isValid();
                var destinatarios = this.$refs.destinatarios.getDestinatarios;
                this.editingEmail.to = destinatarios.toList;
                this.editingEmail.cc = destinatarios.ccList;
                this.editingEmail.bcc = destinatarios.bccList;
            } else {
                this.editingEmail.to = [];
                this.editingEmail.cc = [];
                this.editingEmail.bcc = [];
            }

            this.editingEmail.from = [this.fromAddress];
            this.editingEmail.subject = this.editingSubject;
            if (this.bodyContent) this.editingEmail.body = this.bodyContent;
            this.editingEmail.sendmode = this.sendMode;

            if (this.codemail) this.editingEmail.replyto_codemail = this.codemail;else this.editingEmail.replyto_codemail = null;

            if (!enviar) this.editingEmail.draft = true;else this.editingEmail.draft = false;

            if (this.negocio) this.editingEmail.link_codnegocio = this.negocio.codnegocio;

            if (this.pessoa) this.editingEmail.link_codpessoa = this.pessoa.codpessoa;

            this.emailPost(this.editingEmail, this.editingEmail.codemail, this.callbackSalvar);
        },
        callbackSalvar: function callbackSalvar(email) {
            //EXECUTA APOS GRAVAR O EMAIL
            this.editingEmail.codemail = email.codemail;

            if (!email) return;

            if (email.enviado == 'S') {
                //email enviado, recarrega o email na tela
                this.editing = false;
                this.loadData(email.codemail);
                this.$erpToastSuccess('E-mail enviado');
            }
            if (this.upaloading) {
                this.upaloading = false;
                var obj = {
                    codemail: this.editingEmail.codemail,
                    selectedFile: this.selectedFile
                };
                this.apiUploadAnexo(obj, this.callbackAdicionarAnexo);
            }

            if (this.sendMode == 'new' && !this.editingEmail.draft) {
                this.$emit('closeform', email, true);
            }
        },
        handleCancelar: function handleCancelar() {
            this.$emit('closeform');
        },
        handleClose: function handleClose() {
            this.$emit('closeform', this.email);
        }
    },

    watch: {
        codtempl: function codtempl(value) {
            this.template();
        },

        bodyContent: function bodyContent() {
            // this.editor = new Editor({
            //     content: this.bodyContent
            // })            
        }

    },

    created: function created() {
        this.loadTemplates();

        if (this.codemail) this.loadData();else {
            this.sendMode = 'new';
            this.editingEmail = {};
            if (this.negocio) {
                this.editingEmail.link_codnegocio = this.negocio.codnegocio;
                this.editingSubject = this.negocio.titulo;
            }
            if (this.pessoa) {
                if (this.pessoa.emails && this.pessoa.emails.length > 0) this.editingToList.push({ email: this.pessoa.emails[0].email, nome: this.pessoa.nome, label: this.pessoa.nome + ' ' + this.pessoa.emails[0].email });
            }

            this.editing = true;
            this.$nextTick(function () {
                this.$refs.destinatarios.focus();
            });
        }
    },
    beforeDestroy: function beforeDestroy() {
        // this.editor.destroy()
    }
});

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        destinatarios: Object,
        url: String
    },

    data: function data() {
        return {

            showCC: false,
            showBCC: false,

            toList: [],
            ccList: [],
            bccList: []

        };
    },


    computed: {
        getDestinatarios: function getDestinatarios() {
            var destinatarios = {};

            if (this.$refs.to.isValid) destinatarios.toList = this.$refs.to.emailList;

            if (this.$refs.cc.isValid) destinatarios.ccList = this.$refs.cc.emailList;

            if (this.$refs.bcc.isValid) destinatarios.bccList = this.$refs.bcc.emailList;

            return destinatarios;
        }

    },

    watch: {
        destinatarios: function destinatarios() {
            this.toList = this.destinatarios.toList;
            this.ccList = this.destinatarios.ccList;
            this.bccList = this.destinatarios.bccList;
        }
    },

    filters: {},

    methods: {
        isValid: function isValid() {
            if (!this.$refs.to.isValid) {
                this.$erpToastError('Endereço de e-mail inválido');
                this.$refs.to.focus();
                return false;
            }

            if (!this.$refs.cc.isValid) {
                this.$erpToastError('Endereço de e-mail inválido');
                this.$refs.cc.focus();
                return false;
            }

            if (!this.$refs.bcc.isValid) {
                this.$erpToastError('Endereço de e-mail inválido');
                this.$refs.bcc.focus();
                return false;
            }

            return true;
        },
        focus: function focus() {
            this.$refs.to.focus();
        },
        handleBlurCC: function handleBlurCC() {
            if (this.$refs.cc.emailList.length == 0) this.showCC = false;
        },
        handleBlurBCC: function handleBlurBCC() {
            console.log(this.$refs.bcc.emailList.length);
            if (this.$refs.bcc.emailList.length == 0) this.showBCC = false;
        }
    },

    created: function created() {
        if (this.destinatarios) {
            this.toList = this.destinatarios.toList;
            this.ccList = this.destinatarios.ccList;
            this.bccList = this.destinatarios.bccList;
        }
    }
});

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__);
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: {}
    },

    components: {},

    data: function data() {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            addingNote: false
        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {

        notes: function notes() {
            return this.params.notes;
        }

    },

    methods: {
        handleIncluirObs: function handleIncluirObs() {
            this.texto = null;
            this.addingNote = true;
            this.$nextTick(function () {
                this.$refs.texto.focus();
            });
        },
        handleEditObs: function handleEditObs(index) {
            this.$set(this.notes[index], 'editing', true);
            this.texto = this.notes[index].texto;
            // this.$nextTick(function () {
            //     this.$refs.texto.focus()
            // })
        },
        handleDeleteObs: function handleDeleteObs(index) {
            if (confirm("Confirma a exclusão?")) {
                this.apiNotesDelete(this.notes[index].codnote).then(this.notes.splice(index, 1));
            }
        },
        handlePutObs: function handlePutObs(index) {
            if (!this.texto) return;
            var note = this.notes[index];
            note.texto = this.texto;
            this.indexNote = index;
            this.apiNotes(note, note.codnote, this.callBackNote);
        },
        handlePostObs: function handlePostObs(texto) {
            if (!this.texto) {
                return;
            }
            var note = { texto: this.texto, codnegocio: this.params.codnegocio, codorg: this.params.codorg, codpessoa: this.params.codpessoa, codlead: this.params.codlead };
            this.apiNotes(note, null, this.callBackNote);
        },
        handleCancelObs: function handleCancelObs(index) {
            if (index >= 0) this.notes[index].editing = false;else this.addingNote = false;
        },
        callBackNote: function callBackNote(data) {
            if (data) {
                if (this.addingNote) this.notes.push(data);else {
                    this.notes[this.indexNote].texto = data.texto;
                    this.notes[this.indexNote].editing = false;
                }
                this.addingNote = false;
                this.indexNote = null;
            }
        }
    },

    watch: {},

    mounted: function mounted() {},
    created: function created() {}
});

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_negocio_form_vue__ = __webpack_require__(723);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b92aac94_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_negocio_form_vue__ = __webpack_require__(2042);
function injectStyle (ssrContext) {
  __webpack_require__(2040)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b92aac94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_negocio_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b92aac94_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_negocio_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_pipeline__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_agenda_form__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_anexos_form__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__crm_negocio_novo_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crm_negocio_motivo_form__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__crm_org_novo_form__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__crm_pessoa_novo_form__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__crm_negocio_participantes__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__crm_negocio_seguidores__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__crm_negocio_agenda__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__crm_notes__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__forms_fv_fv_pedido_form__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__crm_email__ = __webpack_require__(127);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//




















/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: ''
    },

    components: {
        AgendaForm: __WEBPACK_IMPORTED_MODULE_5__forms_agenda_form__["a" /* default */], AnexosForm: __WEBPACK_IMPORTED_MODULE_6__components_anexos_form__["a" /* default */], CrmPipeline: __WEBPACK_IMPORTED_MODULE_4__crm_pipeline__["a" /* default */], CrmNegocioNovoForm: __WEBPACK_IMPORTED_MODULE_7__crm_negocio_novo_form__["a" /* default */], CrmNegocioMotivoForm: __WEBPACK_IMPORTED_MODULE_8__crm_negocio_motivo_form__["a" /* default */], CrmOrgNovoForm: __WEBPACK_IMPORTED_MODULE_9__crm_org_novo_form__["a" /* default */],
        FvPedidoForm: __WEBPACK_IMPORTED_MODULE_15__forms_fv_fv_pedido_form__["default"], CrmEmail: __WEBPACK_IMPORTED_MODULE_16__crm_email__["a" /* default */], CrmPessoaNovoForm: __WEBPACK_IMPORTED_MODULE_10__crm_pessoa_novo_form__["a" /* default */], CrmNegocioParticipantes: __WEBPACK_IMPORTED_MODULE_11__crm_negocio_participantes__["a" /* default */], CrmNegocioSeguidores: __WEBPACK_IMPORTED_MODULE_12__crm_negocio_seguidores__["a" /* default */], CrmNegocioAgenda: __WEBPACK_IMPORTED_MODULE_13__crm_negocio_agenda__["a" /* default */],
        CrmNotes: __WEBPACK_IMPORTED_MODULE_14__crm_notes__["a" /* default */]
    },

    data: function data() {
        return {
            errmessages: null,
            error: false,
            metadata: this.$store.getters.getEntities.metadata,
            modalDelete: false,
            activeTab: 0,

            showFormNegocio: false,
            showFormMotivo: false,
            showFormOrg: false,
            showFormOrcamento: false,
            showFormPessoa: false,

            negociocrm: null,

            showCodemail: null,

            paramsNegocio: null,

            usuarioOptions: [],

            incluirOrcamento: false,
            codpedv: null,
            showFormEmail: false,

            anexos: [], //lista de anexos do pedido
            notes: [],

            novoEmail: false,

            seguidores: [],
            showFormSeguidores: false,

            participantes: [],
            showFormParticipantes: false,

            texto: null,

            tabs: [{ title: null, help: 'Principal', icon: 'fa-paperclip', count: 0 }, { title: null, help: 'E-mails', icon: 'fa-envelope', count: 0 }, { title: null, help: 'Atividades Realizadas', icon: 'fa-calendar', count: 0 }, { title: null, help: 'Histórico de Alterações', icon: 'fa-exchange', count: 0 }]

        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        permiteAlteracao: function permiteAlteracao() {
            return this.negociocrm.excluido != 'S';
        },

        permiteDesvincularPessoa: function permiteDesvincularPessoa() {
            return this.negociocrm.codorg;
        },
        tabHistorico: function tabHistorico() {
            return this.activeTab == '3';
        },

        tabPrincipal: function tabPrincipal() {
            return this.activeTab == '0';
        },

        tabEmails: function tabEmails() {
            return this.activeTab == '1';
        },

        tabAgenda: function tabAgenda() {
            return this.activeTab == '2';
        },

        nomeUsuario: function nomeUsuario() {
            if (this.negociocrm && this.negociocrm.usuario.length > 0) return this.negociocrm.usuario[0].nome;else return null;
        },

        organizacao: function organizacao() {
            if (this.negociocrm && this.negociocrm.organizacao.length > 0) return this.negociocrm.organizacao[0];else return null;
        },

        pessoa: function pessoa() {
            if (this.negociocrm && this.negociocrm.pessoa.length > 0) return this.negociocrm.pessoa[0];else return null;
        },

        tag: function tag() {
            if (this.negociocrm && this.negociocrm.tag.length > 0) return this.negociocrm.tag[0];else return null;
        },

        agendaList: function agendaList() {
            return this.negociocrm.agenda.filter(function (obj) {
                return obj.concluida === 'S';
            });
        },

        agendaListPlanejada: function agendaListPlanejada() {
            return this.negociocrm.agenda.filter(function (obj) {
                return obj.concluida != 'S';
            });
        },

        orcamentoList: function orcamentoList() {
            return this.negociocrm.orcamentos;
        },

        hist: function hist() {
            return this.$store.getters.getNegocioHist;
        },

        emailList: function emailList() {
            return this.$store.getters.getNegocioEmails;
        },

        etapaList: function etapaList() {
            if (this.$store.getters.getConfigCrm.etapas) return this.$store.getters.getConfigCrm.etapas;else return [];
        },

        funilList: function funilList() {
            if (this.$store.getters.getConfigCrm) return this.$store.getters.getConfigCrm.funil;else return [];
        },

        funil: function funil() {
            var funil = this.funilList[0];
            funil.etapas = this.etapaList.filter(function (option) {
                return option.codfunil == funil.codfunil;
            });
            return funil;
        },

        botaoPerdidoGanho: function botaoPerdidoGanho() {
            return this.negociocrm.stnegocio == 'A' && this.negociocrm.excluido != 'S';
        },
        botaoAlterar: function botaoAlterar() {
            return this.negociocrm.stnegocio == 'A' && this.negociocrm.excluido != 'S';
        },
        botaoReabrir: function botaoReabrir() {
            return this.negociocrm.excluido == 'S';
        },
        botaoExcluir: function botaoExcluir() {
            return this.negociocrm.stnegocio == 'A' && this.negociocrm.excluido != 'S';
        }
    },

    methods: {
        changeTab: function changeTab(idx) {
            this.activeTab = idx;
            if (this.tabEmails) this.loadEmails();
        },


        statusColor: function statusColor(value) {
            if (value == 'G') {
                return 'badge-green';
            } else return 'badge-red';
        },

        handleStyle: function handleStyle(color) {
            if (color) return 'color: white; background-color: ' + color;else return '';
        },
        handleSalvar: function handleSalvar() {
            var _this = this;

            var valido = true;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Corrija os erros de preenchimento para continuar!');
                } else if (valido) {
                    _this.apiPost();
                }
            });
        },
        handleGanho: function handleGanho() {
            var obj = { codnegocio: this.negociocrm.codnegocio, stnegocio: 'G' };
            this.apiNegocio(obj, this.negociocrm.codnegocio, this.callBackNegocio);
        },
        handlePerdido: function handlePerdido() {
            // abrir motivo para digitacao
            this.showFormMotivo = true;
        },
        closeFormMotivo: function closeFormMotivo(negocio) {
            this.showFormMotivo = false;
            if (negocio) {
                var obj = { codnegocio: this.negociocrm.codnegocio, stnegocio: 'P', codmotivo: negocio.codmotivo, textomotivo: negocio.textomotivo };
                this.apiNegocio(obj, this.negociocrm.codnegocio, this.callBackNegocio);
            }
        },
        closeFormOrg: function closeFormOrg(org) {
            this.showFormOrg = false;
            if (this.incluirOrcamento && org) {
                this.negociocrm.organizacao = [org];
                this.incluirOrcamento = false;
                this.handleIncluirOrcamento();
            }
        },
        handleExcluir: function handleExcluir() {
            if (confirm("Confirma a exclusão?")) {
                this.apiNegocioDelete(this.negociocrm.codnegocio, this.callBackNegocio);
            }
        },
        handleReabrir: function handleReabrir() {
            var obj = { codnegocio: this.negociocrm.codnegocio, stnegocio: 'A' };
            this.apiNegocio(obj, this.negociocrm.codnegocio, this.callBackNegocio);
        },
        callBackNegocio: function callBackNegocio(data) {
            if (data) {
                this.negociocrm = data;
            }
        },
        closeForm: function closeForm() {
            if (this.$route.params.codnegocio) this.$router.go(-1);else this.$emit('closeform');
        },
        closeOrcamento: function closeOrcamento(orcamento) {
            this.showFormOrcamento = false;
        },
        closeNovoNegocio: function closeNovoNegocio(negocio) {
            if (negocio) this.negociocrm = negocio;
            this.showFormNegocio = false;
        },
        handleChangeEtapa: function handleChangeEtapa(etapa) {
            this.negociocrm.codetapa = etapa.codetapa;
        },
        loadEmails: function loadEmails() {
            this.showCodemail = null;
            this.$store.dispatch('loadNegocioEmails', { id: this.negociocrm.codnegocio });
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var codnegocio;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadConfigCrm', _this2);

                            case 2:
                                codnegocio = _this2.index;

                                if (_this2.$route.params && _this2.$route.params.codnegocio) codnegocio = _this2.$route.params.codnegocio;
                                _context.next = 6;
                                return _this2.$store.dispatch('loadNegocioHist', { id: codnegocio });

                            case 6:
                                _context.next = 8;
                                return _this2.$store.dispatch('loadNegocio', { id: codnegocio });

                            case 8:
                                if (_this2.$store.getters.getNegocio) {
                                    _this2.negociocrm = _extends({}, _this2.$store.getters.getNegocio);
                                    _this2.notes = _this2.negociocrm.notes;
                                    _this2.seguidores = _this2.negociocrm.seguidores;
                                    _this2.anexos = _this2.negociocrm.anexos;
                                    _this2.participantes = _this2.negociocrm.participantes;
                                }

                                _this2.loadEmails();

                                //CONTADORES
                                _this2.tabs[3].count = _this2.hist.length;
                                // this.tabs[1].count = this.anexos.length
                                _this2.tabs[2].count = _this2.agendaList.length;
                                // this.tabs[4].count = this.orcamentoList.length

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        handleEditNegocio: function handleEditNegocio() {
            this.paramsNegocio = { negocio: this.negociocrm, alterarOutrosCampos: true };
            this.showFormNegocio = true;
        },
        handleEditNegocioPessoa: function handleEditNegocioPessoa() {
            this.paramsNegocio = { negocio: this.negociocrm, alterarPessoa: true };
            this.showFormNegocio = true;
        },
        handleEditNegocioOrg: function handleEditNegocioOrg() {
            this.paramsNegocio = { negocio: this.negociocrm, alterarOrg: true };
            this.showFormNegocio = true;
        },


        /////////////////////////////////// ORGANIZACAO
        handleDesvincularOrg: function handleDesvincularOrg() {
            if (this.orcamentoList.length > 0) {
                this.$showMessage('Não Permitido', 'Não é permitido desvincular organização quando o negócio possui orçamento vinculado.', 'warning');
                return;
            }
            var obj = { codnegocio: this.negociocrm.codnegocio, codorg: null };
            this.organizacao = null;
            this.apiNegocio(obj, this.negociocrm.codnegocio, this.callBackNegocio);
        },
        handleShowOrg: function handleShowOrg() {
            this.$router.push('/crm/organizacao/' + this.negociocrm.codorg);
        },
        handleEditarOrg: function handleEditarOrg() {
            this.incluirOrcamento = false;
            this.showFormOrg = true;
        },


        /////////////////////////////////// PESSOA DE CONTATO
        handleDesvincularPessoa: function handleDesvincularPessoa() {
            var obj = { codnegocio: this.negociocrm.codnegocio, codpessoa: null };
            this.pessoa = null;
            this.apiNegocio(obj, this.negociocrm.codnegocio, this.callBackNegocio);
        },
        handleShowPessoa: function handleShowPessoa() {
            this.$router.push('/crm/pessoa/' + this.pessoa.codpessoa);
        },
        handleEditarPessoa: function handleEditarPessoa() {
            this.showFormPessoa = true;
        },
        closeFormPessoa: function closeFormPessoa(pessoa) {
            this.loadData();
            this.showFormPessoa = false;
        },


        /////////////////////////////////// EMAILS
        handleNovoEmail: function handleNovoEmail() {
            this.novoEmail = true;
        },
        closeEmail: function closeEmail(email, novo) {
            if (novo) {
                this.emailList.splice(0, 0, email);
            } else if (email) {
                var list = this.emailList.filter(function (obj) {
                    return obj.codemail == email.codemail && obj.visualizado == 'N';
                });
                if (list.length > 0) list[0].visualizado = 'S';
            }
            this.showCodemail = null;
            this.novoEmail = null;
        },


        /////////////////////////////////// SEGUIDORES
        handleIncluirSeguidor: function handleIncluirSeguidor() {
            this.showFormSeguidores = true;
        },
        handleCloseSeguidor: function handleCloseSeguidor() {
            this.seguidores = this.negociocrm.seguidores;
            this.showFormSeguidores = false;
        },

        /////////////////////////////////// FIM SEGUIDORES


        /////////////////////////////////// PARTICIPANTES DO NEGOCIO
        handleIncluirParticipante: function handleIncluirParticipante() {
            this.showFormParticipantes = true;
        },
        handleCloseParticipante: function handleCloseParticipante() {
            this.participantes = this.negociocrm.participantes;
            this.showFormParticipantes = false;
        },

        /////////////////////////////////// FIM PARTICIPANTES


        /////////////////////////////////// ATIVIDADES  / AGENDA
        handleIncluirAgenda: function handleIncluirAgenda(codagenda) {
            //abre a tela de edicao
            this.$refs.agenda.handleIncluirAgenda();
            // this.crud = SysVars.crudI 
            // this.codagenda = null
            // this.showFormAgenda = true;
        },

        // handleEditAgenda (codagenda) {
        //     //abre a tela de edicao
        //     this.crud = SysVars.crudU //operacao de edicao
        //     this.codagenda = codagenda
        //     this.showFormAgenda = true; //exibe o form de agenda
        // },
        updateAgenda: function updateAgenda(agenda) {
            this.tabs[3].count = this.agendaList.length;

            //     this.showFormAgenda = false

            //     if (agenda) {
            //         let index = null
            //         for (var x = 0; x < this.negociocrm.agenda.length; x++) {
            //             if (this.negociocrm.agenda[x].codagenda == agenda.codagenda)
            //               index = x
            //         }
            //         if (index >= 0) {
            //             this.negociocrm.agenda[index].concluida = agenda.concluida
            //         }
            //         else
            //             this.negociocrm.agenda.push(agenda)
            //     }
        },


        // handleDeleteAgenda (codagenda) {
        //     let index = null
        //     for (var x = 0; x < this.negociocrm.agenda.length; x++) {
        //         if (this.negociocrm.agenda[x].codagenda == codagenda)
        //           index = x
        //     }
        //     if (confirm("Confirma a exclusão?")) {
        //         this.apiAgendaDelete(codagenda).then(
        //             this.negociocrm.agenda.splice(index, 1)
        //         )
        //     }
        // },


        /////////////////////////////////// FIM ATIVIDADES


        /////////////////////////////////// ANEXOS
        handleAnexarDocumento: function handleAnexarDocumento() {
            //ANEXAR DOCUMENTOS
            this.$nextTick(function () {
                this.$refs.anexos.handleClickAdiciona();
            });
        },
        handleChangeAnexos: function handleChangeAnexos(anexosList) {
            //ATUALIZA A LISTA DE ANEXOS
            this.anexos = anexosList;
            this.tabs[1].count = this.anexos.length;
        },

        /////////////////////////////////// FIM ANEXOS


        /////////////////////////////////// ORÇAMENTOS

        handleEditOrcamento: function handleEditOrcamento(codpedv) {
            //abre a tela de edicao
            //this.crud = SysVars.crudU //operacao de edicao
            //this.codpedv = codpedv
            //this.showFormOrcamento = true;
            this.$router.push('/crm/negocio/' + this.negociocrm.codnegocio + '/orcamento/' + codpedv);
        },
        handleIncluirOrcamento: function handleIncluirOrcamento() {
            //abre a tela de inclusao de orçamento
            if (!this.organizacao.codpart) {
                //verifica se a organizacao está associada a um cliente
                this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudI;
                this.incluirOrcamento = true;
                this.showFormOrg = true;
                return;
            }
            // this.crud = SysVars.crudI
            // this.codpedv = null
            // this.showFormOrcamento = true;
            this.$router.push('/crm/negocio/' + this.negociocrm.codnegocio + '/orcamento/novo');
        },
        handleImprimir: function handleImprimir(codpedv) {
            Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiDownloadPDF"])(this, 'print/sales/' + codpedv);
        },
        handleEmailOrcamento: function handleEmailOrcamento(codpedv) {
            // ENVIA EMAIL
            this.showFormEmail = true;
            this.codpedv = codpedv;
        },
        closeFormEmail: function closeFormEmail() {
            this.showFormEmail = false;
        },
        handleSendEmail: function handleSendEmail(data) {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var email;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //cahamda para envio de email do pedido
                                _this3.closeFormEmail();
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiEmailPDF"])(_this3, 'pedv/' + _this3.codpedv, data);

                            case 3:
                                email = _context2.sent;

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        }
    },

    watch: {
        emailList: function emailList() {
            this.tabs[1].count = this.$store.getters.getNegocioEmails.length;
        }
    },

    mounted: function mounted() {
        this.$nextTick(function () {
            if (this.$refs.usuario) {
                this.$refs.usuario.focus();
            }
        });
    },
    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__api_api_crm_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default.a
    },

    data: function data() {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,

            funil: {
                codfunil: null,
                descricao: null,
                data: null,
                codusuario: null
            },

            etapas: [
                // { descricao: 'Cliente Potencial', probabilidade: 0, diasestagnado: 0, excluida: false, transfer_to_codetapa: null },
                // { descricao: 'Contato Realizado', probabilidade: 0, diasestagnado: 0, excluida: false, transfer_to_codetapa: null },
                // { descricao: 'Visita Técnica', probabilidade: 0, diasestagnado: 0, excluida: false, transfer_to_codetapa: null },
                // { descricao: 'Proposta Feita', probabilidade: 0, diasestagnado: 0, excluida: false, transfer_to_codetapa: null },
                // { descricao: 'Negociação em Andamento', probabilidade: 0, diasestagnado: 0, excluida: false, transfer_to_codetapa: null },
            ],

            idxExcluindoEtapa: null,

            transferEtapas: []

        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_5__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        optionsTransferEtapas: function optionsTransferEtapas() {
            return this.transferEtapas.map(function (obj) {
                return { id: obj.codetapa, text: obj.descricao };
            });
        },

        countEtapas: function countEtapas() {
            return this.etapas.filter(function (obj) {
                return !obj.excluida;
            }).length;
        }
    },

    methods: {
        handleSalvar: function handleSalvar() {
            var _this = this;

            var valido = true;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Corrija os erros de preenchimento para continuar!');
                } else if (valido) {
                    _this.funil.etapas = _this.etapas;
                    _this.apiFunil(_this.funil, null, _this.callBackPost);
                }
            });
        },
        callBackPost: function callBackPost(funil) {
            if (this.index) this.$erpToastSuccess('Funil alterado com sucesso');else this.$erpToastSuccess('Novo funil criado com sucesso');
            this.closeForm(funil);
        },
        closeForm: function closeForm(funil) {
            this.$store.dispatch('loadFunilCrm', {});
            this.$emit('closeform', funil);
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadFunilCrm', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getFunilCrm) {
                                    _this2.funil = _extends({}, _this2.$store.getters.getFunilCrm);
                                    _this2.etapas = _this2.funil.etapas;
                                }

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },


        /////////////////////////////////// etapas
        handleAdicionarEtapa: function handleAdicionarEtapa() {
            this.etapas.push({
                descricao: 'Nova Etapa',
                probabilidade: 0,
                diasestagnado: 0,
                excluida: false,
                transfer_to_codetapa: null
            });
        },
        handleShowDeleteEtapa: function handleShowDeleteEtapa(index) {
            if (this.etapas[index].count_negocios > 0) {
                this.transferEtapas = this.etapas;
                this.transferEtapas.splice(index, 1);
            } else {
                this.transferEtapas = [];
            }
            this.idxExcluindoEtapa = index;
        },
        excluindoEtapa: function excluindoEtapa(index) {
            return this.idxExcluindoEtapa == index;
        },
        handleDeleteEtapa: function handleDeleteEtapa(index) {
            //EXCLUIR ETAPA
            this.etapas[index].excluida = true;
            this.idxExcluindoEtapa = null;
        },
        handleMoverEtapa: function handleMoverEtapa(index, position) {
            Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["arrayMoveIndex"])(this.etapas, index, position);

            for (var x = 0; x < this.etapas.length; x++) {
                this.etapas[x].sequencia = x + 1;
            }
        }
    },

    watch: {},

    mounted: function mounted() {
        this.$nextTick(function () {
            if (this.$refs.descricao) {
                this.$refs.descricao.focus();
            }
        });
    },
    created: function created() {
        if (this.index) {
            this.loadData();
        }
    }
});

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__);
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {},

    components: {},

    data: function data() {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            leadcrm: {
                pessoanome: null,
                email: null,
                orgnome: null,
                fonenumero: null,
                publicform: true
            }
        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {},

    methods: {
        handleSalvar: function handleSalvar() {
            var _this = this;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {} else {
                    _this.apiLead(_this.leadcrm, null, _this.callBackPost);
                }
            });
        },
        callBackPost: function callBackPost(lead) {
            if (lead) this.$erpToastSuccess('Um novo lead foi criado');
            this.closeForm(lead);
        },
        closeForm: function closeForm() {
            this.$emit('closeform');
        }
    },

    watch: {},

    mounted: function mounted() {
        this.$nextTick(function () {
            if (this.$refs.nome) {
                this.$refs.nome.focus();
            }
        });
    },
    created: function created() {}
});

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_filter_list__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__crm_lead_form__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_lead_novo_form__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__crm_filtros_negocio__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__main__);
//











/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showFormNovo: false, //exibe a tela de manutencao
            codlead: null,
            filter: '',
            textQuery: '',
            statusQuery: '',
            metadata: this.$store.getters.getEntities.metadata,
            selectedFiltro: null,
            selectedUsuario: null,
            selectedEquipe: null
        };
    },


    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], FilterList: __WEBPACK_IMPORTED_MODULE_2__components_filter_list__["a" /* default */], CrmLeadNovoForm: __WEBPACK_IMPORTED_MODULE_4__crm_lead_novo_form__["a" /* default */], CrmLeadForm: __WEBPACK_IMPORTED_MODULE_3__crm_lead_form__["a" /* default */], CrmFiltrosNegocio: __WEBPACK_IMPORTED_MODULE_5__crm_filtros_negocio__["a" /* default */]
    },

    computed: {
        leadList: function leadList() {
            return this.$store.getters.getLeadCrmList;
        }
    },

    watch: {},

    filters: {},

    methods: {
        formatDate: function formatDate(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__shared_utils__["formatDataHoraExtenso"])(value, true);
        },
        handleStyle: function handleStyle(color) {
            if (color) return 'color: white; background-color: ' + color;else return '';
        },
        handleStyleAgenda: function handleStyleAgenda(obj) {
            if (obj.dias_atividade > 0) return 'color: red;';else if (obj.dias_atividade < 0) return 'color: green;';else return '';
        },
        handleChangeUsuario: function handleChangeUsuario(cod) {
            this.selectedUsuario = cod;
            this.loadData();
        },
        handleChangeFiltroLeads: function handleChangeFiltroLeads(cod) {
            this.selectedFiltro = cod;
            this.loadData();
        },
        handleChangeEquipe: function handleChangeEquipe(cod) {
            this.selectedEquipe = cod;
            this.loadData();
        },
        handleEdit: function handleEdit(codlead) {
            //abre a tela de edicao
            this.codlead = codlead;
            this.$modalForm(true);
            // this.$router.push('/crm/pessoa/' + codlead)
        },
        handleAction: function handleAction(act, codlead) {
            if (act == 1) {
                //print
                //apiDownloadPDF(this, 'print/sales/' + codlead)
            }
        },
        handleNovo: function handleNovo() {
            //abre a tela de edicao
            this.codlead = null;
            this.showFormNovo = true; //exibe o form de manutencao
            this.$modalForm(true);
        },
        closeForm: function closeForm() {
            this.showFormNovo = false;
            this.codlead = null;
            this.$modalForm(false);
            // this.$scrollTo(0)
            this.loadData();
        },
        textSearch: function textSearch(value) {
            //efetua a pesquisa por texto
            this.textQuery = 'text=' + value;
            this.loadData();
        },
        handleFilterList: function handleFilterList(status) {
            if (status === 'todos') {
                this.statusQuery = '';
            } else {
                this.statusQuery = 'filtro=' + status;
            }
            this.loadData();
        },
        textAtividade: function textAtividade(count) {
            if (count == 1) return '1 Atividade Atrasada';else if (count > 1) return count + ' Atividades Atrasadas';else return '';
        },
        loadData: function loadData() {
            var query = '';
            if (!this.selectedFiltro || this.selectedFiltro === 0) {
                query = '';
            } else {
                query = 'filtro=' + this.selectedFiltro;
            }

            if (this.selectedUsuario) {
                if (query) query = query + '&';
                query = query + 'codusuario=' + this.selectedUsuario;
            }

            if (this.selectedEquipe) {
                if (query) query = query + '&';
                query = query + 'codequipe=' + this.selectedEquipe;
            }

            var param = {};
            param.query = '';
            if (query) {
                param.query = query;
                if (this.textQuery) {
                    param.query = param.query + '&';
                }
            }
            if (this.textQuery) {
                param.query = param.query + this.textQuery;
            } else {
                param.filter = this.filter;
            }
            this.$store.dispatch('loadLead', param);
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
            });
        }
    },

    created: function created() {
        this.$store.dispatch('loadConfigCrm', this).then(this.loadData());

        // let filters = [
        //     { label: 'Todos os Contatos', qt: null, status: null },
        //     { label: 'Contatos com negócio em aberto', qt: null, status: 'comnegocio' },
        //     { label: 'Contatos com atividade pendente', qt: null, status: 'comagenda' },
        // ]
        // this.paramFilterList = { total: filters, selectedStatus: '' }
    }
});

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_lead_novo_form__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__crm_negocio_novo_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__crm_negocio_agenda__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__crm_notes__ = __webpack_require__(128);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: ''
    },

    components: {
        CrmNegocioNovoForm: __WEBPACK_IMPORTED_MODULE_5__crm_negocio_novo_form__["a" /* default */], CrmLeadNovoForm: __WEBPACK_IMPORTED_MODULE_4__crm_lead_novo_form__["a" /* default */], CrmNegocioAgenda: __WEBPACK_IMPORTED_MODULE_6__crm_negocio_agenda__["a" /* default */], CrmNotes: __WEBPACK_IMPORTED_MODULE_7__crm_notes__["a" /* default */]
    },

    data: function data() {
        return {
            errmessages: null,
            error: false,
            metadata: this.$store.getters.getEntities.metadata,
            modalDelete: false,
            activeTab: 0,

            showFormNegocio: false,
            showFormLead: false,

            leadcrm: null,

            paramsNegocio: null,

            notes: [],
            addingNote: false,

            indexNote: null,
            texto: null

        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        permiteAlteracao: function permiteAlteracao() {
            return this.leadcrm.stlead == 'A' && this.leadcrm.excluido != 'S';
        },
        nomeUsuario: function nomeUsuario() {
            if (this.leadcrm && this.leadcrm.usuario.length > 0) return this.leadcrm.usuario[0].nome;else return null;
        },

        organizacao: function organizacao() {
            if (this.leadcrm && this.leadcrm.organizacao.length > 0) return this.leadcrm.organizacao[0];else return null;
        },

        tag: function tag() {
            if (this.leadcrm && this.leadcrm.tag.length > 0) return this.leadcrm.tag[0];else return null;
        },

        agendaList: function agendaList() {
            return this.leadcrm.agenda.filter(function (obj) {
                return obj.concluida === 'S';
            });
        },

        agendaListPlanejada: function agendaListPlanejada() {
            return this.leadcrm.agenda.filter(function (obj) {
                return obj.concluida != 'S';
            });
        }

    },

    methods: {
        changeTab: function changeTab(idx) {
            this.activeTab = idx;
        },
        handleStyle: function handleStyle(color) {
            if (color) return 'color: white; background-color: ' + color;else return '';
        },
        closeFormOrg: function closeFormOrg(organizacao) {
            this.showFormOrg = false;
            if (this.organizacao) {
                this.loadData();
            }
        },
        handleExcluir: function handleExcluir() {
            if (confirm("Confirma a exclusão?")) {
                this.apiLeadDelete(this.leadcrm.codlead, this.callBackLead);
            }
        },
        handleReabrir: function handleReabrir() {
            var obj = { codlead: this.leadcrm.codlead, excluido: 'N' };
            this.apiLead(obj, this.leadcrm.codlead, this.callBackLead);
        },
        callBackLead: function callBackLead(data) {
            if (data) {
                this.leadcrm = data;
            }
        },
        closeForm: function closeForm() {
            if (this.$route.params.id) this.$router.go(-1);else this.$emit('closeform');
        },
        loadEmails: function loadEmails() {
            this.showCodemail = null;
            this.$store.dispatch('loadNegocioEmails', { id: this.leadcrm.codnegocio });
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var codlead;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadConfigCrm', _this);

                            case 2:
                                codlead = _this.index;

                                if (_this.$route.params && _this.$route.params.id) codlead = _this.$route.params.id;
                                _context.next = 6;
                                return _this.$store.dispatch('loadLead', { id: codlead });

                            case 6:
                                if (_this.$store.getters.getLeadCrm) {
                                    _this.leadcrm = _extends({}, _this.$store.getters.getLeadCrm);
                                    _this.notes = _this.leadcrm.notes;
                                }

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleEditar: function handleEditar() {
            this.showFormLead = true;
        },
        closeFormNegocio: function closeFormNegocio(data) {
            console.log(data);
            this.showFormNegocio = false;
            if (data) this.closeForm();
        },
        closeFormLead: function closeFormLead(data) {
            this.showFormLead = false;
            if (data) this.leadcrm = data;
        },
        handleTransformToDeal: function handleTransformToDeal() {
            //CRIA UM NEGOCIO ATRAVÉS DO LEAD
            this.paramsNegocio = { lead: this.leadcrm };
            this.showFormNegocio = true;
        },
        handleArquivar: function handleArquivar() {
            var obj = { codlead: this.leadcrm.codlead, stlead: 'F' };
            this.apiLead(obj, this.leadcrm.codlead, this.callBackLead);
        },


        /////////////////////////////////// ATIVIDADES  / AGENDA
        handleIncluirAgenda: function handleIncluirAgenda(codagenda) {
            //abre a tela de edicao
            this.$refs.agenda.handleIncluirAgenda();
        },
        updateAgenda: function updateAgenda(agenda) {
            // this.tabs[3].count = this.agendaList.length
        }
    },

    watch: {},

    mounted: function mounted() {
        this.$nextTick(function () {});
    },
    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_lead_novo_form_vue__ = __webpack_require__(729);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_34bdb834_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_lead_novo_form_vue__ = __webpack_require__(2060);
function injectStyle (ssrContext) {
  __webpack_require__(2058)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_lead_novo_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_34bdb834_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_lead_novo_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_input_color__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_tag_form__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__api_api_crm_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: '',
        params: {}
    },

    components: {
        InputColor: __WEBPACK_IMPORTED_MODULE_2__components_input_color__["a" /* default */], CrmTagForm: __WEBPACK_IMPORTED_MODULE_4__crm_tag_form__["a" /* default */]
    },

    data: function data() {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            showTagForm: false,
            codtag: null,
            crudTag: '',

            leadcrm: {
                codlead: null,
                nome: null,
                data: null,
                codusuario: null,
                codorg: null,
                codtag: null,
                visivel: null
            },

            telefones: [],
            emails: [],

            organizacao: {
                novo: false,
                nome: null,
                codorg: null
            },

            inputOrg: {
                url: '/crm/find/organizacao?nome=',
                permite_novo: true,
                codigo: null,
                // label: 'Organização',
                icon: 'fa-university'
                // placeholder: 'Nome da Organização',
            },

            inputNome: {
                url: '/crm/find/pessoa?nome=',
                duplicados: true,
                codigo: null,
                // label: this.$store.getters.getEntities.metadata.leadcrm.codorg.label,
                icon: 'fa-user'
                // placeholder: 'Nome do Contato',
            },

            inputFone: {
                url: '/crm/find/pessoa?fone=',
                duplicados: true,
                codigo: null
                // label: this.$store.getters.getEntities.metadata.fonecrm.numero.label,
            },

            inputEmail: {
                url: '/crm/find/pessoa?email=',
                duplicados: true,
                codigo: null
                // label: this.$store.getters.getEntities.metadata.emailcrm.email.label,
            }

        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_5__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        administrador: function administrador() {
            return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].usuarioAdministrador;
        }
    },

    methods: {
        handleCadastroOrigem: function handleCadastroOrigem() {
            this.$router.push('/crm/config');
        },
        handleSalvar: function handleSalvar() {
            var _this = this;

            var valido = true;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Corrija os erros de preenchimento para continuar!');
                } else if (valido) {
                    // if (this.organizacao.novo)
                    // this.leadcrm.dados = { org: this.organizacao }
                    // this.leadcrm.telefones = this.telefones
                    // this.leadcrm.emails = this.emails
                    _this.apiLead(_this.leadcrm, _this.leadcrm.codlead, _this.callBackPost);
                }
            });
        },
        handleAdicionarTag: function handleAdicionarTag() {
            this.codtag = null;
            this.crudTag = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudI;
            this.showTagForm = true;
        },
        handleEditarTag: function handleEditarTag(cod) {
            this.crudTag = __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudU;
            this.codtag = cod;
            this.showTagForm = true;
        },
        handleCloseTag: function handleCloseTag(tag) {
            this.$refs.etiqueta.loadData();
            if (tag) this.leadcrm.codtag = tag.codtag;
            this.showTagForm = false;
        },
        callBackPost: function callBackPost(pessoa) {
            this.closeForm(pessoa);
        },
        closeForm: function closeForm(pessoa) {
            this.$emit('closeform', pessoa);
        },
        handleNovoOrg: function handleNovoOrg(text) {
            if (!this.organizacao) this.organizacao = {};
            this.organizacao.novo = true;
            this.organizacao.nome = text;
        },
        handleSelectOrg: function handleSelectOrg(selected) {
            this.organizacao = selected;
            if (this.organizacao) {
                this.organizacao.novo = false;
            }
        },
        handleIncluirOrg: function handleIncluirOrg(selected) {
            this.leadcrm.codorg = selected.codigo;
            this.organizacao.novo = false;
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadLead', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getLeadCrm) {
                                    _this2.leadcrm = _extends({}, _this2.$store.getters.getLeadCrm);
                                    _this2.setFields();
                                }

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        setFields: function setFields() {
            // if (this.leadcrm.codorg && this.$refs.organizacao) {
            //     this.organizacao = this.leadcrm.organizacao[0]
            //     this.organizacao.novo = false
            //     this.$refs.organizacao.setValue(this.organizacao.codorg, this.organizacao.nome, this.organizacao)
            // }
        }
    },

    watch: {},

    mounted: function mounted() {
        this.$nextTick(function () {
            if (this.$refs.titulo) {
                this.$refs.titulo.focus();
            }
        });
    },
    created: function created() {
        if (this.index) this.loadData();
    }
});

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_filter_list__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__crm_pessoa_form__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_pessoa_novo_form__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__crm_filtros_negocio__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__main__);
//












/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showFormNovo: false, //exibe a tela de manutencao
            codpessoa: null,
            filter: '',
            textQuery: '',
            statusQuery: '',
            metadata: this.$store.getters.getEntities.metadata,
            selectedFiltro: null,
            selectedUsuario: null,
            selectedEquipe: null
        };
    },


    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], FilterList: __WEBPACK_IMPORTED_MODULE_2__components_filter_list__["a" /* default */], CrmPessoaNovoForm: __WEBPACK_IMPORTED_MODULE_4__crm_pessoa_novo_form__["a" /* default */], CrmPessoaForm: __WEBPACK_IMPORTED_MODULE_3__crm_pessoa_form__["default"], CrmFiltrosNegocio: __WEBPACK_IMPORTED_MODULE_5__crm_filtros_negocio__["a" /* default */]
    },

    computed: {
        pessoaList: function pessoaList() {
            return this.$store.getters.getPessoaList;
        }
    },

    watch: {},

    filters: {},

    methods: {
        formatDate: function formatDate(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_7__shared_utils__["formatDataHoraExtenso"])(value, true);
        },
        handleStyle: function handleStyle(color) {
            if (color) return 'color: white; background-color: ' + color;else return '';
        },
        handleStyleAgenda: function handleStyleAgenda(obj) {
            if (obj.dias_atividade > 0) return 'color: red;';else if (obj.dias_atividade < 0) return 'color: green;';else return '';
        },
        handleChangeUsuario: function handleChangeUsuario(cod) {
            this.selectedUsuario = cod;
            this.loadData();
        },
        handleChangeContatos: function handleChangeContatos(cod) {
            this.selectedFiltro = cod;
            this.loadData();
        },
        handleChangeEquipe: function handleChangeEquipe(cod) {
            this.selectedEquipe = cod;
            this.loadData();
        },
        handleEdit: function handleEdit(codpessoa) {
            //abre a tela de edicao
            this.codpessoa = codpessoa;
            this.$modalForm(true);
            // this.$router.push('/crm/pessoa/' + codpessoa)
        },
        handleAction: function handleAction(act, codpessoa) {
            if (act == 1) {
                //print
                //apiDownloadPDF(this, 'print/sales/' + codpessoa)
            }
        },
        handleNovo: function handleNovo() {
            //abre a tela de edicao
            this.codpessoa = null;
            this.showFormNovo = true; //exibe o form de manutencao
            this.$modalForm(true);
        },
        closeForm: function closeForm() {
            this.showFormNovo = false;
            this.codpessoa = null;
            this.$modalForm(false);
            // this.$scrollTo(0)
            this.loadData();
        },
        textSearch: function textSearch(value) {
            //efetua a pesquisa por texto
            this.textQuery = 'text=' + value;
            this.loadData();
        },
        handleFilterList: function handleFilterList(status) {
            if (status === 'todos') {
                this.statusQuery = '';
            } else {
                this.statusQuery = 'filtro=' + status;
            }
            this.loadData();
        },
        textAtividade: function textAtividade(count) {
            if (count == 1) return '1 Atividade Atrasada';else if (count > 1) return count + ' Atividades Atrasadas';else return '';
        },
        loadData: function loadData() {
            var query = '';
            if (!this.selectedFiltro || this.selectedFiltro === 0) {
                query = '';
            } else {
                query = 'filtro=' + this.selectedFiltro;
            }

            if (this.selectedUsuario) {
                if (query) query = query + '&';
                query = query + 'codusuario=' + this.selectedUsuario;
            }

            if (this.selectedEquipe) {
                if (query) query = query + '&';
                query = query + 'codequipe=' + this.selectedEquipe;
            }

            var param = {};
            param.query = '';
            if (query) {
                param.query = query;
                if (this.textQuery) {
                    param.query = param.query + '&';
                }
            }
            if (this.textQuery) {
                param.query = param.query + this.textQuery;
            } else {
                param.filter = this.filter;
            }
            this.$store.dispatch('loadPessoa', param);
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
            });
        }
    },

    created: function created() {
        this.$store.dispatch('loadConfigCrm', this).then(this.loadData());

        // let filters = [
        //     { label: 'Todos os Contatos', qt: null, status: null },
        //     { label: 'Contatos com negócio em aberto', qt: null, status: 'comnegocio' },
        //     { label: 'Contatos com atividade pendente', qt: null, status: 'comagenda' },
        // ]
        // this.paramFilterList = { total: filters, selectedStatus: '' }
    }
});

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_pipeline__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_agenda_form__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_anexos_form__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__crm_negocio_novo_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crm_negocio_motivo_form__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__crm_org_novo_form__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__crm_pessoa_novo_form__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__crm_negocio_participantes__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__crm_negocio_seguidores__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__crm_negocio_agenda__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__crm_notes__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__crm_email__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__crm_card__ = __webpack_require__(96);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//




















/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: ''
    },

    components: {
        AgendaForm: __WEBPACK_IMPORTED_MODULE_5__forms_agenda_form__["a" /* default */], AnexosForm: __WEBPACK_IMPORTED_MODULE_6__components_anexos_form__["a" /* default */], CrmPipeline: __WEBPACK_IMPORTED_MODULE_4__crm_pipeline__["a" /* default */], CrmNegocioNovoForm: __WEBPACK_IMPORTED_MODULE_7__crm_negocio_novo_form__["a" /* default */], CrmNegocioMotivoForm: __WEBPACK_IMPORTED_MODULE_8__crm_negocio_motivo_form__["a" /* default */], CrmOrgNovoForm: __WEBPACK_IMPORTED_MODULE_9__crm_org_novo_form__["a" /* default */],
        CrmEmail: __WEBPACK_IMPORTED_MODULE_15__crm_email__["a" /* default */], CrmPessoaNovoForm: __WEBPACK_IMPORTED_MODULE_10__crm_pessoa_novo_form__["a" /* default */], CrmNegocioParticipantes: __WEBPACK_IMPORTED_MODULE_11__crm_negocio_participantes__["a" /* default */], CrmNegocioSeguidores: __WEBPACK_IMPORTED_MODULE_12__crm_negocio_seguidores__["a" /* default */], CrmNegocioAgenda: __WEBPACK_IMPORTED_MODULE_13__crm_negocio_agenda__["a" /* default */], CrmCard: __WEBPACK_IMPORTED_MODULE_16__crm_card__["a" /* default */],
        CrmNotes: __WEBPACK_IMPORTED_MODULE_14__crm_notes__["a" /* default */]
    },

    data: function data() {
        return {
            errmessages: null,
            error: false,
            metadata: this.$store.getters.getEntities.metadata,
            modalDelete: false,
            activeTab: 0,

            showFormNegocio: false,
            showFormOrg: false,
            showFormPessoa: false,

            codpessoa: null,

            organizacao: null,

            paramsNegocio: null,
            paramsPessoa: null,

            showVincularPessoa: false,

            anexos: [], //lista de anexos do pedido
            notes: [],
            addingNote: false,

            seguidores: [],
            showFormSeguidores: false,

            indexNote: null,
            texto: null,

            tabs: [{ title: 'Detalhes', help: null, icon: 'fa-bars', count: 0 }, { title: 'Arquivos', help: null, icon: 'fa-paperclip', count: 0 },
            // { title: null, help: 'E-mails', icon: 'fa-envelope', count: 0 },
            { title: 'Atividades Concluídas', help: null, icon: 'fa-calendar', count: 0 }, { title: 'Negócios', help: null, icon: 'fa-dollar', count: 0 }]

        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        permiteAlteracao: function permiteAlteracao() {
            return this.organizacao.excluido != 'S';
        },

        tabDetalhes: function tabDetalhes() {
            return this.activeTab == '0';
        },

        tabAnexos: function tabAnexos() {
            return this.activeTab == '1';
        },

        tabAgenda: function tabAgenda() {
            return this.activeTab == '2';
        },

        tabNegocios: function tabNegocios() {
            return this.activeTab == '3';
        },

        nomeUsuario: function nomeUsuario() {
            if (this.organizacao && this.organizacao.usuario.length > 0) return this.organizacao.usuario[0].nome;else return null;
        },

        tag: function tag() {
            if (this.organizacao && this.organizacao.tag.length > 0) return this.organizacao.tag[0];else return null;
        },

        agendaList: function agendaList() {
            return this.organizacao.agenda.filter(function (obj) {
                return obj.concluida === 'S';
            });
        },

        agendaListPlanejada: function agendaListPlanejada() {
            return this.organizacao.agenda.filter(function (obj) {
                return obj.concluida != 'S';
            });
        },

        listNegocios: function listNegocios() {
            if (this.organizacao.negocios) return this.organizacao.negocios;else return [];
        },

        // emailList: function () {
        //     this.tabs[2].count = this.$store.getters.getNegocioEmails.length
        //     return this.$store.getters.getNegocioEmails
        // },

        administrador: function administrador() {
            return __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].usuarioAdministrador;
        }

    },

    methods: {
        changeTab: function changeTab(idx) {
            this.activeTab = idx;
        },
        handleExcluir: function handleExcluir() {
            if (confirm("Confirma a exclusão?")) {
                this.apiOrgDelete(this.organizacao.codorg, this.callBackPost);
            }
        },
        handleReabrir: function handleReabrir() {
            var obj = { codorg: this.org.codorg, excluido: 'N' };
            this.apiOrg(obj, this.org.codorg, this.callBackPost);
        },
        callBackPost: function callBackPost(org) {
            if (org) this.organizacao = org;
        },
        handleStyle: function handleStyle(color) {
            if (color) return 'color: white; background-color: ' + color;else return '';
        },
        closeFormPessoa: function closeFormPessoa(pessoa) {
            this.showFormPessoa = false;
            if (this.pessoa) {
                this.loadData();
            }
        },
        closeForm: function closeForm() {
            if (this.$route.params.id) this.$router.go(-1);else this.$emit('closeform');
        },
        loadEmails: function loadEmails() {
            this.showCodemail = null;
            this.$store.dispatch('loadNegocioEmails', { id: this.organizacao.codnegocio });
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var codorg;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadConfigCrm', _this);

                            case 2:
                                codorg = _this.index;

                                if (_this.$route.params && _this.$route.params.id) codorg = _this.$route.params.id;
                                _context.next = 6;
                                return _this.$store.dispatch('loadOrganizacao', { id: codorg });

                            case 6:
                                if (_this.$store.getters.getOrganizacao) {
                                    _this.organizacao = _extends({}, _this.$store.getters.getOrganizacao);
                                    _this.notes = _this.organizacao.notes;
                                    _this.seguidores = _this.organizacao.seguidores;
                                    _this.anexos = _this.organizacao.anexos;
                                }

                                //CONTADORES
                                _this.tabs[1].count = _this.anexos.length;
                                // this.tabs[2].count = this.emailList.length
                                _this.tabs[2].count = _this.agendaList.length;
                                _this.tabs[3].count = _this.listNegocios.length;

                                _this.$nextTick(function () {
                                    return document.getElementById('formorg').scrollIntoView({ behavior: "smooth" });
                                });

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleCloseVincularPessoa: function handleCloseVincularPessoa() {
            this.loadData();
            this.showVincularPessoa = false;
        },
        handleVincularPessoa: function handleVincularPessoa(tipo) {
            this.showVincularPessoa = true;
        },
        closeFormOrg: function closeFormOrg(organizacao) {
            this.showFormOrg = false;
            if (organizacao) this.organizacao = organizacao;
        },


        //////////////////////////// ALTERAR OU VISUALIZAR NEGOCIO
        handleShowNegocio: function handleShowNegocio(codnegocio) {
            this.$router.push('/crm/negocio/' + codnegocio);
        },
        handleIncluirNegocio: function handleIncluirNegocio() {
            this.paramsNegocio = { organizacao: this.organizacao };
            this.showFormNegocio = true;
        },
        closeNovoNegocio: function closeNovoNegocio(negocio) {
            this.showFormNegocio = false;
            if (negocio) this.handleShowNegocio(negocio.codnegocio);
        },
        handleAdicionarAgendaNegocio: function handleAdicionarAgendaNegocio(negocio) {
            //abre a tela de edicao
            // this.negociocrm = negocio
            // this.crud = SysVars.crudI 
            // this.codagenda = null
            // this.showFormAgenda = true;
        },
        handleEditAgendaNegocio: function handleEditAgendaNegocio(negocio, codagenda) {
            //abre a tela de edicao
            // this.negociocrm = negocio
            // this.crud = SysVars.crudU //operacao de edicao
            // this.codagenda = codagenda
            // this.showFormAgenda = true; //exibe o form de agenda
        },
        handleShowPessoa: function handleShowPessoa(codpessoa) {
            this.$router.push('/crm/pessoa/' + codpessoa);
        },
        handleEditarOrg: function handleEditarOrg() {
            this.showFormOrg = true;
        },


        /////////////////////////////////// OBSERVACOES
        handleIncluirObs: function handleIncluirObs() {
            this.texto = null;
            this.addingNote = true;
        },
        handleEditObs: function handleEditObs(index) {
            this.$set(this.notes[index], 'editing', true);
            this.texto = this.notes[index].texto;
        },
        handleDeleteObs: function handleDeleteObs(index) {
            if (confirm("Confirma a exclusão?")) {
                this.apiNotesDelete(this.notes[index].codnote).then(this.notes.splice(index, 1));
            }
        },
        handlePutObs: function handlePutObs(index) {
            if (!this.texto) return;
            var note = this.notes[index];
            note.texto = this.texto;
            this.indexNote = index;
            this.apiNotes(note, note.codnote, this.callBackNote);
        },
        handlePostObs: function handlePostObs(texto) {
            if (!this.texto) {
                return;
            }
            var note = { texto: this.texto, codorg: this.organizacao.codorg };
            this.apiNotes(note, null, this.callBackNote);
        },
        handleCancelObs: function handleCancelObs(index) {
            if (index >= 0) this.notes[index].editing = false;else this.addingNote = false;
        },
        callBackNote: function callBackNote(data) {
            if (data) {
                if (this.addingNote) this.notes.push(data);else {
                    this.notes[this.indexNote].texto = data.texto;
                    this.notes[this.indexNote].editing = false;
                }
                this.addingNote = false;
                this.indexNote = null;
            }
        },

        /////////////////////////////////// FIM notes


        /////////////////////////////////// SEGUIDORES
        handleIncluirSeguidor: function handleIncluirSeguidor() {
            this.showFormSeguidores = true;
        },
        handleCloseSeguidor: function handleCloseSeguidor() {
            this.seguidores = this.organizacao.seguidores;
            this.showFormSeguidores = false;
        },

        /////////////////////////////////// FIM SEGUIDORES


        /////////////////////////////////// ATIVIDADES  / AGENDA
        handleIncluirAgenda: function handleIncluirAgenda(codagenda) {
            //abre a tela de edicao
            this.$refs.agenda.handleIncluirAgenda();
        },
        updateAgenda: function updateAgenda(agenda) {
            this.tabs[2].count = this.agendaList.length;
        },

        /////////////////////////////////// FIM ATIVIDADES


        /////////////////////////////////// ANEXOS
        handleAnexarDocumento: function handleAnexarDocumento() {
            //ANEXAR DOCUMENTOS
            this.$nextTick(function () {
                this.$refs.anexos.handleClickAdiciona();
            });
        },
        handleChangeAnexos: function handleChangeAnexos(anexosList) {
            //ATUALIZA A LISTA DE ANEXOS
            this.anexos = anexosList;
            this.tabs[1].count = this.anexos.length;
        }
    },

    watch: {},

    mounted: function mounted() {
        this.$nextTick(function () {
            if (this.$refs.usuario) {
                this.$refs.usuario.focus();
            }
        });
    },
    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__crm_org_form__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__crm_org_novo_form__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_filtros_negocio__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__main__);
//











/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showFormNovo: false,
            filter: '',
            textQuery: '',
            statusQuery: '',
            metadata: this.$store.getters.getEntities.metadata,
            selectedFiltro: null,
            selectedUsuario: null,
            selectedEquipe: null,

            codorg: null
        };
    },


    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], CrmOrgNovoForm: __WEBPACK_IMPORTED_MODULE_3__crm_org_novo_form__["a" /* default */], CrmOrgForm: __WEBPACK_IMPORTED_MODULE_2__crm_org_form__["default"], CrmFiltrosNegocio: __WEBPACK_IMPORTED_MODULE_4__crm_filtros_negocio__["a" /* default */]
    },

    computed: {
        organizacaoList: function organizacaoList() {
            return this.$store.getters.getOrganizacaoList;
        }
    },

    watch: {},

    filters: {},

    methods: {
        formatDate: function formatDate(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__shared_utils__["formatDataHoraExtenso"])(value, true);
        },
        handleStyle: function handleStyle(color) {
            if (color) return 'color: white; background-color: ' + color;else return '';
        },
        handleStyleAgenda: function handleStyleAgenda(obj) {
            if (obj.dias_atividade > 0) return 'color: red;';else if (obj.dias_atividade < 0) return 'color: green;';else return '';
        },
        handleChangeUsuario: function handleChangeUsuario(cod) {
            this.selectedUsuario = cod;
            this.loadData();
        },
        handleChangeFiltroOrg: function handleChangeFiltroOrg(cod) {
            this.selectedFiltro = cod;
            this.loadData();
        },
        handleChangeEquipe: function handleChangeEquipe(cod) {
            this.selectedEquipe = cod;
            this.loadData();
        },
        handleEdit: function handleEdit(codorg) {
            this.codorg = codorg;
            this.$modalForm(true);
            // this.$router.push('/crm/organizacao/' + codorg)
        },
        handleAction: function handleAction(act, codorg) {
            if (act == 1) {
                //print
                //apiDownloadPDF(this, 'print/sales/' + codorg)
            }
        },
        handleNovo: function handleNovo() {
            //abre a tela de edicao
            this.codorg = null;
            this.$modalForm(true);
            this.showFormNovo = true; //exibe o form de manutencao
        },
        closeForm: function closeForm() {
            this.showFormNovo = false;
            this.codorg = null;
            this.$modalForm(false);
            // this.$scrollTo(0)
            this.loadData();
        },
        textSearch: function textSearch(value) {
            //efetua a pesquisa por texto
            this.textQuery = 'text=' + value;
            this.loadData();
        },
        textAtividade: function textAtividade(count) {
            if (count == 1) return '1 Atividade Atrasada';else if (count > 1) return count + ' Atividades Atrasadas';else return '';
        },
        loadData: function loadData() {
            var query = '';
            if (!this.selectedFiltro || this.selectedFiltro === 0) {
                query = '';
            } else {
                query = 'filtro=' + this.selectedFiltro;
            }

            if (this.selectedUsuario) {
                if (query) query = query + '&';
                query = query + 'codusuario=' + this.selectedUsuario;
            }

            if (this.selectedEquipe) {
                if (query) query = query + '&';
                query = query + 'codequipe=' + this.selectedEquipe;
            }

            var param = {};
            param.query = '';
            if (query) {
                param.query = query;
                if (this.textQuery) {
                    param.query = param.query + '&';
                }
            }
            if (this.textQuery) {
                param.query = param.query + this.textQuery;
            } else {
                param.filter = this.filter;
            }
            this.$store.dispatch('loadOrganizacao', param);
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
            });
        }
    },

    created: function created() {
        this.$store.dispatch('loadConfigCrm', this).then(this.loadData());

        // let filters = [
        //     { label: 'Todos os Contatos', qt: null, status: null },
        //     { label: 'Contatos com negócio em aberto', qt: null, status: 'comnegocio' },
        //     { label: 'Contatos com atividade pendente', qt: null, status: 'comagenda' },
        // ]
        // this.paramFilterList = { total: filters, selectedStatus: '' }
    }
});

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__crm_org_form__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crm_email__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__crm_filtros_negocio__ = __webpack_require__(95);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//









/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            selectedFiltro: null,
            selectedUsuario: null,
            selectedEquipe: null,
            showCodemail: null,

            novoEmail: false,

            activeTab: 0,

            tabs: [{ title: 'Recebidos', help: null, icon: 'fa-arrow-down', count: 0 }, { title: 'Enviados', help: null, icon: 'fa-arrow-right', count: 0 }],

            emailList: []

        };
    },


    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], CrmEmail: __WEBPACK_IMPORTED_MODULE_4__crm_email__["a" /* default */], CrmFiltrosNegocio: __WEBPACK_IMPORTED_MODULE_5__crm_filtros_negocio__["a" /* default */]
    },

    computed: {
        naoLidosList: function naoLidosList() {
            if (this.$store.getters.getEmailCrmList.length) return this.$store.getters.getEmailCrmList.filter(function (obj) {
                return obj.visualizado === 'N' && obj.inbox === 'S';
            });else return [];
        },
        recebidosList: function recebidosList() {
            if (this.$store.getters.getEmailCrmList.length) return this.$store.getters.getEmailCrmList.filter(function (obj) {
                return obj.inbox === 'S';
            });else return [];
        },
        enviadosList: function enviadosList() {
            if (this.$store.getters.getEmailCrmList.length) return this.$store.getters.getEmailCrmList.filter(function (obj) {
                return obj.enviado == 'S';
            });else return [];
        }
    },

    watch: {},

    filters: {},

    methods: {
        changeTab: function changeTab(idx) {
            this.activeTab = idx;
            this.loadData();
        },
        handleChangeUsuario: function handleChangeUsuario(cod) {
            this.selectedUsuario = cod;
            this.loadData();
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var param;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                param = {};

                                if (_this.selectedFiltro > 0) param.filtro = _this.selectedFiltro;
                                if (_this.selectedUsuario > 0) param.codusuario = _this.selectedUsuario;

                                _this.showCodemail = null;
                                _context.next = 6;
                                return _this.$store.dispatch('loadEmailCrm', param);

                            case 6:

                                if (_this.activeTab == 0) {
                                    _this.emailList = _this.recebidosList;
                                } else if (_this.activeTab == 1) {
                                    _this.emailList = _this.enviadosList;
                                }

                                _this.tabs[0].count = _this.naoLidosList.length;

                                _this.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleNovoEmail: function handleNovoEmail() {
            this.novoEmail = true;
        },
        closeEmail: function closeEmail(email) {
            if (email) {
                var list = this.emailList.filter(function (obj) {
                    return obj.codemail == email.codemail && obj.visualizado == 'N';
                });
                if (list.length > 0) list[0].visualizado = 'S';
            }
            this.showCodemail = null;
        }
    },

    created: function created() {
        this.$store.dispatch('loadConfigCrm', this).then(this.loadData());
    }
});

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__crm_motivo_list__ = __webpack_require__(2081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__crm_origem_list__ = __webpack_require__(2089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_email_list__ = __webpack_require__(2097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__main__);








/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            activeTab: 0
        };
    },


    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], CrmOrigemList: __WEBPACK_IMPORTED_MODULE_2__crm_origem_list__["a" /* default */], CrmMotivoList: __WEBPACK_IMPORTED_MODULE_1__crm_motivo_list__["a" /* default */], TemplateEmailList: __WEBPACK_IMPORTED_MODULE_3__template_email_list__["a" /* default */]
    },

    computed: {
        tabs: function tabs() {
            var tabs = [];
            tabs = [{ title: 'Motivos de Perda', icon: null }, { title: 'Canais de Origem', icon: null }, { title: 'Templates de Email', icon: null }];
            return tabs;
        },

        tabMotivo: function tabMotivo() {
            return this.activeTab == 0;
        },

        tabOrigem: function tabOrigem() {
            return this.activeTab == 1;
        },

        tabTemplate: function tabTemplate() {
            return this.activeTab == 2;
        }

    },

    methods: {
        closeForm: function closeForm() {},
        changeTab: function changeTab(idx) {
            this.activeTab = idx;
        }
    },

    created: function created() {}
});

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__crm_motivo_form__ = __webpack_require__(2084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__api_api_crm_js__);
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            motivo: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            currentMotivo: {},
            codmotivo: null
        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_4__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        motivoList: function motivoList() {
            return this.$store.getters.getMotivoCrmList;
        }
    },

    filters: {
        format: function format(value) {
            return formatValue(value, 2);
        }
    },

    methods: {
        handleEdit: function handleEdit(motivo) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudU;
            this.$set(motivo, 'show', true);
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudI;
            this.showForm = true;
        },
        closeForm: function closeForm(motivo) {
            if (motivo) motivo.show = false;
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codmotivo":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadMotivoCrm', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        },
        handleDelete: function handleDelete(motivo) {
            //BOTAO Excluir
            this.apiMotivoDelete(motivo.codmotivo);
            this.loadData();
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], CrmMotivoForm: __WEBPACK_IMPORTED_MODULE_3__crm_motivo_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__api_api_crm_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            motivocrm: _extends({}, this.$store.getters.getEntities.motivocrm),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_2__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm(motivo) {
            this.$emit('closeform', motivo);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiMotivo(_this.motivocrm, _this.motivocrm.codmotivo, _this.callBackPost);
                }
            });
        },
        callBackPost: function callBackPost(motivo) {
            this.$erpToastSuccess('Motivo gravado com sucesso');
            this.closeForm(motivo);
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadMotivoCrm', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getMotivoCrm) {
                                    _this2.motivocrm = _extends({}, _this2.$store.getters.getMotivoCrm);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.descricao.focus();
        });
    }
});

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__crm_origem_form__ = __webpack_require__(2092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__api_api_crm_js__);
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            codorigem: null
        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_4__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        origemList: function origemList() {
            return this.$store.getters.getOrigemCrmList;
        }
    },

    filters: {
        format: function format(value) {
            return formatValue(value, 2);
        }
    },

    methods: {
        handleEdit: function handleEdit(origem) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudU;
            this.$set(origem, 'show', true);
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudI;
            this.showForm = true;
        },
        closeForm: function closeForm(origem) {
            if (origem) origem.show = false;
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codorigem":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadOrigemCrm', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        },
        handleDelete: function handleDelete(origem) {
            //BOTAO Excluir
            this.apiOrigemDelete(origem.codorigem);
            this.loadData();
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], CrmOrigemForm: __WEBPACK_IMPORTED_MODULE_3__crm_origem_form__["a" /* default */]
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__api_api_crm_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    data: function data() {
        return {
            crudText: '',
            origemcrm: _extends({}, this.$store.getters.getEntities.origemcrm),
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_2__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        editing: function editing() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
        }

    },

    methods: {
        closeForm: function closeForm(obj) {
            this.$emit('closeform', obj);
        },
        handleSave: function handleSave() {
            var _this = this;

            //BOTAO SALVAR
            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this.apiOrigem(_this.origemcrm, _this.origemcrm.codorigem, _this.callBackPost);
                }
            });
        },
        callBackPost: function callBackPost(obj) {
            this.$erpToastSuccess('Origem gravada com sucesso');
            this.closeForm(obj);
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadOrigemCrm', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getOrigemCrm) {
                                    _this2.origemcrm = _extends({}, _this2.$store.getters.getOrigemCrm);
                                }
                                _this2.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },

    components: {},

    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.crudText = this.$crudText(this.crud);

        if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
            this.loadData();
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.descricao.focus();
        });
    }
});

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_email_form__ = __webpack_require__(2100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__api_api_crm_js__);
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            codtempl: null
        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_4__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {
        templEmailList: function templEmailList() {
            return this.$store.getters.getTemplEmailList;
        }
    },

    filters: {
        format: function format(value) {
            return formatValue(value, 2);
        }
    },

    methods: {
        handleEdit: function handleEdit(template) {
            //abre a tela de edicao
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudU;
            this.codtempl = template.codtempl;
            this.showForm = true;
        },
        handleNew: function handleNew() {
            //inclusao de registro
            this.crud = __WEBPACK_IMPORTED_MODULE_2__main__["SysVars"].crudI;
            this.codtempl = null;
            this.showForm = true;
        },
        closeForm: function closeForm(template) {
            this.showForm = false;
            this.loadData();
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codtempl":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        loadData: function loadData() {
            this.$store.dispatch('loadTemplEmail', { filter: this.filter, page: this.nextPage });
            this.offset = '';
        },
        handleDelete: function handleDelete(template) {
            //BOTAO Excluir
            this.apiTemplateDelete(templemail.codtempl);
            this.loadData();
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], TemplateEmailForm: __WEBPACK_IMPORTED_MODULE_3__template_email_form__["a" /* default */]
    },

    mounted: function mounted() {},
    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },

    components: {},

    data: function data() {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            templemail: _extends({}, this.$store.getters.getEntities.templemail)
        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_3__api_api_crm_js___default.a], //ROTINAS DO CRM

    computed: {},

    methods: {
        handleSalvar: function handleSalvar() {
            var _this = this;

            this.$validator.validateAll().then(function (isValid) {
                if (!isValid) {
                    _this.$erpToastError('Corrija os erros de preenchimento para continuar!');
                } else {
                    _this.apiTemplate(_this.templemail, _this.templemail.codtempl, _this.callBackPost);
                }
            });
        },
        callBackPost: function callBackPost(template) {
            this.closeForm(template);
        },
        closeForm: function closeForm(template) {
            this.$emit('closeform', template);
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadTemplEmail', { id: _this2.index });

                            case 2:
                                if (_this2.$store.getters.getTemplEmail) {
                                    _this2.templemail = _extends({}, _this2.$store.getters.getTemplEmail);
                                }

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },

    watch: {
        nome: function nome() {
            // console.log(this.nome)
        }

    },

    mounted: function mounted() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            if (this.$refs.descricao) {
                this.$refs.descricao.focus();
            }
        });
    },
    created: function created() {
        if (this.index) this.loadData();
    }
});

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        filial: {}
    },

    data: function data() {
        return {
            code2: null
        };
    },


    computed: {
        status: function status() {
            return '';
        }
    },

    methods: {
        data: function data(value) {
            return formatDate(value);
        },
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var queryString, urlParams;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                //CARREGA OS DADOS DO CERTIFICADO DA FILIAL
                                queryString = window.location.search;
                                urlParams = new URLSearchParams(queryString);

                                _this.code2 = urlParams.get('code');

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__manifesto_form__ = __webpack_require__(2113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_manifesto_filtro__ = __webpack_require__(2117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_api_manifesto__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_api_manifesto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__api_api_manifesto__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }









/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            showForm: false, //exibe a tela de manutencao
            showList: true,
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            chNfe: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',

            query: {
                text: null,
                confdest: -1
            },

            moreActionsBarList: [{ action: 0, label: 'Pesquisar na receita novos registros' }, { action: 1, label: 'Pesquisar na receita últimos 3 meses' }],

            currentManifesto: {}
        };
    },


    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], ManifestoForm: __WEBPACK_IMPORTED_MODULE_1__manifesto_form__["a" /* default */], ManifestoFiltro: __WEBPACK_IMPORTED_MODULE_2__components_manifesto_filtro__["a" /* default */]

    },

    mixins: [__WEBPACK_IMPORTED_MODULE_6__api_api_manifesto___default.a],

    computed: {
        manifestoList: function manifestoList() {
            return this.$store.getters.getManifestoList;
        }
    },

    methods: {

        // getActionsManifesto (manifesto) {
        //     let list = []

        //     if (manifesto.confdest == '0'){
        //       list.push({ id: 0, text: 'Ciência da Operação' })
        //       list.push({ id: 1, text: 'Confirmação da Operação' })
        //       list.push({ id: 2, text: 'Confirmação da Operação, Download do XML e Gerar NF de Entrada' })
        //       list.push({ id: 3, text: 'Desconhecimento da Operação' } )
        //       list.push({ id: 4, text: 'Operação não realizada' } )
        //     }
        //     if (manifesto.confdest != '0' && (!manifesto.xml || manifesto.xml == '')){
        //       list.push({ id: 5, text: 'Carregar XML dos Servidores da Receita' })
        //     }
        //     if (manifesto.xml && manifesto.xml != ''){
        //       list.push({ id: 6, text: 'Gerar NF de Entrada por XML' })
        //     }
        //     if (manifesto.xml && manifesto.xml != ''){
        //       list.push({ id: 7, text: 'Download XML' })
        //     }
        //     return list
        // },

        //deve habilitar todas as operacoes quando confdest==4
        getActionsManifesto: function getActionsManifesto(manifesto) {
            var list = [];

            if (manifesto.confdest == '0' || manifesto.confdest == '4') {
                if (manifesto.confdest != '4') list.push({ action: 0, label: 'Ciência da Operação' });
                if (manifesto.confdest != '1') list.push({ action: 1, label: 'Confirmação da Operação' });
                //   list.push({ action: 2, label: 'Confirmação da Operação, Download do XML e Gerar NF de Entrada' })
                if (manifesto.confdest != '2') list.push({ action: 3, label: 'Desconhecimento da Operação' });
                if (manifesto.confdest != '3') list.push({ action: 4, label: 'Operação não realizada' });
            }
            if (manifesto.confdest != '0' && (!manifesto.xml || manifesto.xml == '')) {
                list.push({ action: 5, label: 'Download do XML' });
            }
            if (manifesto.confdest == '1' && manifesto.xml && manifesto.xml != '') {
                list.push({ action: 6, label: 'Gerar NF de Entrada por XML' });
            }
            if (manifesto.xml && manifesto.xml != '') {
                list.push({ action: 7, label: 'Download do XML' });
            }
            return list;
        },
        teste_timeout: function teste_timeout() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var modulo, sendData, metodo, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                modulo = 'manifesto/timeout/';
                                sendData = {};

                                sendData = { "teste": true };

                                metodo = 'post';
                                _context.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["apiORDSpostlongtimeout"])(_this.$store, modulo, sendData, metodo);

                            case 6:
                                data = _context.sent;


                                if (data.errmessages) {
                                    _this.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    _this.$erpToastSuccess('Alguns erros precisam ser corrigidos.');
                                }

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        changeFiltros: function changeFiltros(confdes) {
            // this.query.text = null
            this.query.confdest = confdes;
            this.loadData();
        },
        descricaoEvento: function descricaoEvento(tpevento) {
            var status = tpevento;
            if (tpevento == '210210') {
                status = 'Ciencia da Operação';
            }
            if (tpevento == '210200') {
                status = 'Confirmação da Operação';
            }
            if (tpevento == '210220') {
                status = 'Desconhecimento da Operação';
            }
            if (tpevento == '210240') {
                status = 'Operação não Realizada';
            }
            return status;
        },
        statusManifesto: function statusManifesto(confdest) {
            var statusmanifesto = 'Sem Manifestação';
            if (confdest == '1') {
                statusmanifesto = 'Confirmada Operação';
            }
            if (confdest == '2') {
                statusmanifesto = 'Desconhecida';
            }
            if (confdest == '3') {
                statusmanifesto = 'Operação não Realizada';
            }
            if (confdest == '4') {
                statusmanifesto = 'Ciente da Operação';
            }
            return statusmanifesto;
        },
        statusNFe: function statusNFe(stnfe) {
            var statusNFe = '';
            if (stnfe == '1') {
                statusNFe = 'Normal';
            }
            if (stnfe == '2') {
                statusNFe = 'Denegada';
            }
            if (stnfe == '3') {
                statusNFe = 'Cancelada';
            }
            return statusNFe;
        },
        manifestoPesquisarA1: function manifestoPesquisarA1(pesqapartirultimoregistro, pesqultimos15dias) {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, sendData, metodo, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                modulo = 'manifesto/pesquisar/';
                                sendData = {};

                                sendData = { "pesqapartirultimoregistro": pesqapartirultimoregistro, "pesqultimos15dias": pesqultimos15dias };

                                metodo = 'post';
                                _context2.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["apiORDSpost"])(_this2.$store, modulo, sendData, metodo);

                            case 6:
                                data = _context2.sent;


                                if (data.errmessages) {
                                    _this2.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    _this2.query.confdest = -1;
                                    _this2.loadData();
                                    _this2.closeForm();
                                }

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        manifestoPesquisarA3ResponseCallback: function manifestoPesquisarA3ResponseCallback(response) {
            //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
            if (response.status != 'success') {
                this.$erpToastError(response.message);
            } else {
                this.$erpToastSuccess('Pesquisa realizada');
            }
            this.loadData();
        },
        manifestoPesquisarA3: function manifestoPesquisarA3(pesqapartirultimoregistro, pesqultimos15dias) {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var sendData;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this3.$appLoading(true);

                                sendData = "&pesqapartirultimoregistro=" + pesqapartirultimoregistro + "&pesqultimos15dias=" + pesqultimos15dias;

                                _this3.$executaExtensaoChromeA3(null, 'manifestopesq', manifestoPesquisarA3ResponseCallback, sendData);

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        handleAction: function handleAction(act) {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var tipo;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:

                                if (act == 2) {
                                    _this4.teste_timeout();
                                }

                                tipo = _this4.$certificadoCheck(null);

                                if (tipo == 'A1') {
                                    if (act == 0) {
                                        _this4.manifestoPesquisarA1(true, false);
                                    } else if (act == 1) {
                                        _this4.manifestoPesquisarA1(false, true);
                                    }
                                } else if (tipo == 'A3') {
                                    if (act == 0) {
                                        _this4.manifestoPesquisarA3(true, false);
                                    } else if (act == 1) {
                                        _this4.manifestoPesquisarA3(false, true);
                                    }
                                }

                            case 3:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        handleEdit: function handleEdit(chNfe, view) {
            //abre a tela de edicao

            if (view) this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudView;else this.crud = __WEBPACK_IMPORTED_MODULE_4__main__["SysVars"].crudU;

            this.chNfe = chNfe;
            this.showForm = true;
        },
        closeForm: function closeForm() {
            this.showForm = false;
        },
        search: function search(value) {
            //efetua a pesquisa
            this.query.text = value;
            this.query.confdest = -1;
            this.loadData();
        },
        loadCurrentManifesto: function loadCurrentManifesto(manifesto) {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var self;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                //carrega o registro para alteracao ou visualizacao
                                _this5.currentManifesto = null;
                                _context5.next = 3;
                                return _this5.$store.dispatch('loadManifesto', { id: manifesto.chnfe });

                            case 3:
                                if (_this5.$store.getters.getManifesto) {
                                    _this5.currentManifesto = _extends({}, _this5.$store.getters.getManifesto);
                                    self = _this5;

                                    _this5.currentManifesto.list_manifesto.map(function (m) {
                                        if (m.xml) {
                                            self.currentManifesto.xml = m.xml;
                                        }
                                    });
                                }

                            case 4:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        },
        loadData: function loadData() {
            this.filter = '';

            this.$store.commit('SET_INDEXFILTROTIPOSMANIFESTO', this.query.confdest + 1);

            if (this.query.confdest != -1) {
                this.filter = this.filter + (this.filter != '' ? ',' : '') + '{"$and":[{"confdest":{"$eq":"' + this.query.confdest + '"}}]}';
            }
            if (this.query.text) {
                this.filter = this.filter + (this.filter != '' ? ',' : '') + '{"$or":[{"emi_cnpjcpf":{"$like":"%25' + this.query.text + '%25"}},{"emi_nome":{"$like":"%25' + this.query.text + '%25"}},{"nrdoc":{"$like":"%25' + this.query.text + '%25"}},{"chnfe":{"$like":"%25' + this.query.text + '%25"}}]}';
            }

            var self = this;

            // self.showList = false
            this.$store.dispatch('loadManifesto', { filter: this.filter }).then(function () {
                self.showList = true;
            });
        },
        callbackManifesto: function callbackManifesto(tipo, success, manifesto, codevento) {
            var _this6 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var msg;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!success) {
                                    _context6.next = 18;
                                    break;
                                }

                                _context6.next = 3;
                                return _this6.loadData();

                            case 3:
                                if (codevento == '210210') {
                                    //quando enviou evento de ciencia da operacao
                                    if (manifesto.actmanifesto == 0) _this6.handleActionManifesto(5, manifesto); //efetua o download do xml
                                }
                                if (codevento == '210200') {
                                    //quando enviou evento de confirmacao da operacao
                                    if (manifesto.actmanifesto == 2) {
                                        manifesto.gerar_nf = true;
                                        _this6.handleActionManifesto(2, manifesto); //download do xml e geracao da nf entrada no nb
                                    } else {
                                        _this6.handleActionManifesto(5, manifesto); //download do xml
                                    }
                                }
                                if (!codevento && manifesto.gerar_nf) {
                                    manifesto.actmanifesto = 6;
                                    _this6.handleActionManifesto(6, manifesto);
                                }

                                if (!(manifesto.actmanifesto == 5)) {
                                    _context6.next = 18;
                                    break;
                                }

                                _context6.next = 9;
                                return _this6.loadCurrentManifesto(manifesto);

                            case 9:
                                if (!_this6.currentManifesto.xml) {
                                    _context6.next = 13;
                                    break;
                                }

                                _this6.handleDownloadFile(_this6.currentManifesto);
                                _context6.next = 18;
                                break;

                            case 13:
                                if (_this6.currentManifesto.xml) {
                                    _context6.next = 18;
                                    break;
                                }

                                msg = null;
                                _context6.next = 17;
                                return _this6.currentManifesto.list_manifesto.map(function (m) {
                                    if (m.msg) {
                                        msg = m.msg;
                                    }
                                });

                            case 17:
                                _this6.$erpToastError(msg);

                            case 18:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this6);
            }))();
        },
        handleActionManifesto: function handleActionManifesto(actionId, manifesto) {
            var _this7 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var act, ljust;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                act = actionId;
                                _context7.next = 3;
                                return _this7.loadCurrentManifesto(manifesto);

                            case 3:
                                _this7.currentManifesto.actmanifesto = act;

                                if (act == 0) {
                                    //Ciência da Operação
                                    _this7.EnviarEvento(_this7.currentManifesto, '210210', 'Ciencia da Operacao', '', _this7.callbackManifesto);
                                }
                                if (act == 1) {
                                    //Confirmação da Operação
                                    _this7.EnviarEvento(_this7.currentManifesto, '210200', 'Confirmacao da Operacao', '', _this7.callbackManifesto);
                                }
                                if (act == 2) {
                                    //Confirmação da Operação, download e gerarNFxml
                                    _this7.EnviarEvento(_this7.currentManifesto, '210200', 'Confirmacao da Operacao', '', _this7.callbackManifesto);
                                }
                                if (act == 3) {
                                    //Desconhecimento da Operação
                                    _this7.EnviarEvento(_this7.currentManifesto, '210220', 'Desconhecimento da Operacao', '', _this7.callbackManifesto);
                                }
                                if (act == 4) {
                                    //Operação não realizada
                                    ljust = prompt("Digite a justificativa porque a operação não foi realizada:", "");

                                    if (ljust != null && ljust != "") {
                                        _this7.EnviarEvento(_this7.currentManifesto, '210240', 'Operacao nao Realizada', ljust, _this7.callbackManifesto);
                                    }
                                }
                                if (act == 5) {
                                    if (_this7.currentManifesto.xml) _this7.handleDownloadFile(_this7.currentManifesto);else {
                                        _this7.Downloadxml(_this7.currentManifesto, _this7.callbackManifesto);
                                    }
                                }
                                if (act == 6) {
                                    _this7.handleGerarNFXML(_this7.currentManifesto);
                                }
                                if (act == 7) {
                                    _this7.handleDownloadFile(_this7.currentManifesto);
                                }

                            case 12:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this7);
            }))();
        }
    },

    created: function created() {
        this.showForm = false;
        this.loadData();
    }
});

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_manifesto__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_manifesto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__api_api_manifesto__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var Actions = {
  CIENCIA_OPERACAO: 0,
  CONFIRMACAO_OPERACAO: 1,
  DESCONHECIMENTO_OPERACAO: 2,
  OPERACAO_NAO_REALIZADA: 3,
  CARREGAR_XML: 4,
  GERAR_NF_ENTRADA: 5,
  DOWNLOAD_XML: 6
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: '',
    crud: ''
  },

  data: function data() {
    return {
      Actions: Actions,
      crudText: '',
      showInfXml: false,
      manifesto: _extends({}, this.$store.getters.getEntities.manifesto),
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [] //armazena as mensagens de validacao do servidor para mostrar em tela
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_3__api_api_manifesto___default.a],

  computed: {
    editing: function editing() {
      return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudU;
    },

    isView: function isView() {
      return this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudView;
    }

  },

  methods: {
    statusManifesto: function statusManifesto(confdest) {
      var statusmanifesto = confdest + ' - Sem Manifestação do Destinatário';
      if (confdest == '0') {
        statusmanifesto = confdest + ' - Sem Manifestação do Destinatário';
      }
      if (confdest == '1') {
        statusmanifesto = confdest + ' - Confirmada Operação';
      }
      if (confdest == '2') {
        statusmanifesto = confdest + ' - Desconhecida';
      }
      if (confdest == '3') {
        statusmanifesto = confdest + ' - Operação não Realizada';
      }
      if (confdest == '4') {
        statusmanifesto = confdest + ' - Ciência';
      }
      return statusmanifesto;
    },
    getActionsManifesto: function getActionsManifesto() {
      var moreActions = [];
      var act = { action: 0, label: 'Ciência da Operação' };
      moreActions.push(act);
      var act = { action: 1, label: 'Confirmação da Operação' };
      moreActions.push(act);
      var act = { action: 2, label: 'Desconhecimento da Operação' };
      moreActions.push(act);
      var act = { action: 3, label: 'Operação não realizada' };
      moreActions.push(act);
      return moreActions;
    },
    getActions: function getActions() {
      var moreActions = [];
      var act = { action: this.Actions.CIENCIA_OPERACAO, label: 'Ciência da Operação' };
      moreActions.push(act);
      var act = { action: this.Actions.CONFIRMACAO_OPERACAO, label: 'Confirmação da Operação' };
      moreActions.push(act);
      var act = { action: this.Actions.DESCONHECIMENTO_OPERACAO, label: 'Desconhecimento da Operação' };
      moreActions.push(act);
      var act = { action: this.Actions.OPERACAO_NAO_REALIZADA, label: 'Operação não realizada' };
      moreActions.push(act);
      var act = { action: this.Actions.CARREGAR_XML, label: 'Carregar XML dos Servidores da Receita' };
      moreActions.push(act);
      var act = { action: this.Actions.GERAR_NF_ENTRADA, label: 'Gerar NF de Entrada por XML' };
      moreActions.push(act);
      var act = { action: this.Actions.DOWNLOAD_XML, label: 'Download XML' };
      moreActions.push(act);
      return moreActions;
    },
    callbackManifesto: function callbackManifesto(tipo, success, manifesto, codevento) {
      if (success) {
        this.loadData();
      }
    },
    callbackManifestoConfirmacao: function callbackManifestoConfirmacao(tipo, success, manifesto, codevento) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('manifesto confirmacao: ');
                console.log(success);

                if (!success) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return _this.loadData();

              case 5:
                console.log('efetuar download de confirmacao');
                console.log(_this.manifesto);
                //efetua o download apos a confirmacao da operacao
                _this.Downloadxml(_this.manifesto, _this.callbackManifestoDownload);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    callbackManifestoDownload: function callbackManifestoDownload(tipo, success, manifesto, codevento) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var msg;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!success) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 3;
                return _this2.loadData();

              case 3:
                if (!_this2.manifesto.xml) {
                  _context2.next = 7;
                  break;
                }

                _this2.$erpToastSuccess('Operação executada com sucesso.');
                _context2.next = 11;
                break;

              case 7:
                msg = null;
                _context2.next = 10;
                return _this2.manifesto.list_manifesto.map(function (m) {
                  if (m.msg) {
                    msg = m.msg;
                  }
                });

              case 10:
                _this2.$erpToastError('Mensagem Retorno servidor NFe: ' + msg);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleAction: function handleAction(act) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var ljust;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:

                if (act == _this3.Actions.CIENCIA_OPERACAO) {
                  //Ciência da Operação
                  _this3.EnviarEvento(_this3.manifesto, '210210', 'Ciencia da Operacao', '', _this3.callbackManifesto);
                }
                if (act == _this3.Actions.CONFIRMACAO_OPERACAO) {
                  //Confirmação da Operação
                  _this3.EnviarEvento(_this3.manifesto, '210200', 'Confirmacao da Operacao', '', _this3.callbackManifestoConfirmacao);
                }
                if (act == _this3.Actions.DESCONHECIMENTO_OPERACAO) {
                  //Desconhecimento da Operação
                  _this3.EnviarEvento(_this3.manifesto, '210220', 'Desconhecimento da Operacao', '', _this3.callbackManifesto);
                }
                if (act == _this3.Actions.OPERACAO_NAO_REALIZADA) {
                  //Operação não realizada
                  ljust = prompt("Digite a justificativa porque a operação não foi realizada:", "");

                  if (ljust != null && ljust != "") {
                    _this3.EnviarEvento(_this3.manifesto, '210240', 'Operacao nao Realizada', ljust, _this3.callbackManifesto);
                  }
                }
                if (act == _this3.Actions.CARREGAR_XML) {
                  _this3.Downloadxml(_this3.manifesto, _this3.callbackManifestoDownload);
                }
                if (act == _this3.Actions.GERAR_NF_ENTRADA) {
                  _this3.handleGerarNFXML(_this3.manifesto);
                }
                if (act == _this3.Actions.DOWNLOAD_XML) {
                  _this3.handleDownloadFile(_this3.manifesto);
                }

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    descricaoEvento: function descricaoEvento(tpevento) {
      var status = tpevento;
      if (tpevento == '210210') {
        status = 'Ciencia da Operação';
      }
      if (tpevento == '210200') {
        status = 'Confirmação da Operação';
      }
      if (tpevento == '210220') {
        status = 'Desconhecimento da Operação';
      }
      if (tpevento == '210240') {
        status = 'Operação não Realizada';
      }
      return status;
    },
    closeForm: function closeForm() {
      this.$emit('closeform');
    },
    handleSave: function handleSave() {
      //BOTAO SALVAR
      // this.$validator.validateAll().then(isValid => {
      //     if (!isValid) {
      //         this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
      //     } else {
      //         this.apiPost()
      //     }
      // })
    },
    loadData: function loadData() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var self;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.$store.dispatch('loadManifesto', { id: _this4.index });

              case 2:
                if (_this4.$store.getters.getManifesto) {
                  _this4.manifesto = _extends({}, _this4.$store.getters.getManifesto);
                  self = _this4;

                  _this4.manifesto.list_manifesto.map(function (m) {
                    if (m.xml) {
                      self.manifesto.xml = m.xml;
                    }
                  });
                }
                _this4.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                });

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    apiPost: function apiPost() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var modulo, sendData, metodo, update, data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                //efetua a gravacao

                modulo = 'manifesto/pesquisar/';
                sendData = {};


                sendData = { manifesto: _this5.manifesto };

                metodo = 'post';
                update = false;

                if (_this5.crud != __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {
                  metodo = 'put';
                  update = true;
                }

                _context5.next = 8;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this5.$store, modulo, sendData, metodo);

              case 8:
                data = _context5.sent;

                if (data.errmessages) {
                  _this5.errmessages = data.errmessages;
                  _this5.$erpToastError('Alguns erros precisam ser corrigidos.');
                } else {
                  if (update) {
                    _this5.$erpToastUpdated();
                  } else {
                    _this5.$erpToastInserted();
                  }
                  _this5.errmessages = {};
                  _this5.closeForm();
                }

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  },

  components: {
    Actions: Actions
  },

  beforeCreate: function beforeCreate() {},
  created: function created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });

    this.crudText = this.$crudText(this.crud);

    if (this.crud == __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI) {} else {
      this.loadData();
    }
  }
});

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(9);

var _axios2 = _interopRequireDefault(_axios);

var _apiFunctions = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var MODULO_IMPORTARXML = 'invoice/importxml/';
var MODULO_MANIFESTO_EVENTO = 'manifesto/evento/';
var MODULO_DOWNLOADXML = 'manifesto/downloadxml/';

exports.default = {

    methods: {
        handleDownloadFile: function handleDownloadFile(manifesto) {

            var filename = 'NFe' + manifesto.chnfe + '.xml';
            var filedata = manifesto.list_manifesto[0].xml;

            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(filedata));
            element.setAttribute('download', filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        },
        handleGerarNFXML: function handleGerarNFXML(manifesto) {
            var self = this;

            var filename = 'NFe' + manifesto.chnfe + '.xml';
            //let filedata = decodeURIComponent(manifesto.xml.replace(/\+/g,  " "));
            var filedata = unescape(manifesto.list_manifesto[0].xml.replace(/\+/g, " "));

            var file = new File([filedata], filename, { type: "text/xml", lastModified: new Date() });

            var formData = new FormData();
            formData.append(file.name, file);
            _axios2.default.post((0, _apiFunctions.urlORDS)(this.$store, MODULO_IMPORTARXML), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                if (response.data.errmessages) {
                    self.$erpToastError('Erro na importação da XML: ' + response.data.errmessages[0]);
                } else {
                    var codnf = response.data.codnf;
                    if (codnf) self.$router.push('/nfentrada/' + codnf);
                }
            });
            // .catch(function(response){
            // self.$erpToastError(response.data.errmessages)
            // })
        },
        EnviarEventoA1: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(manifesto, codevento, descevento, xjust, callback) {
                var sendData, metodo, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                sendData = {};

                                sendData = { "codmanifesto": manifesto.list_manifesto[0].codmanifesto, "chave": manifesto.chnfe, "codevento": codevento, "descevento": descevento, "xjust": xjust };

                                metodo = 'post';
                                _context.next = 5;
                                return (0, _apiFunctions.apiORDSpost)(this.$store, MODULO_MANIFESTO_EVENTO, sendData, metodo);

                            case 5:
                                data = _context.sent;

                                if (data.errmessages) {
                                    this.$erpToastError('Alguns erros precisam ser corrigidos.');
                                }
                                callback("A1", !data.errmessages, manifesto, codevento);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function EnviarEventoA1(_x, _x2, _x3, _x4, _x5) {
                return _ref.apply(this, arguments);
            }

            return EnviarEventoA1;
        }(),
        EnviarEventoA3ResponseCallback: function EnviarEventoA3ResponseCallback(response, callback, manifesto, codevento) {
            //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
            if (response.status != 'success') {
                this.$erpToastError(response.message);
            } else {
                this.$erpToastSuccess('Evento realizado!');
            }
            callback("A3", response.status == 'success', manifesto, codevento);
        },
        EnviarEventoA3: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(manifesto, codevento, descevento, xjust, callback) {
                var sendData;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.$appLoading(true);

                                sendData = "&codmanifesto=" + manifesto.list_manifesto[0].codmanifesto + "&codevento=" + codevento + "&descevento=" + descevento + "&xjust=" + xjust;

                                this.$executaExtensaoChromeA3(null, 'manifestoevento', function (response) {
                                    this.EnviarEventoA3ResponseCallback(response, callback, manifesto, codevento);
                                }, sendData);

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function EnviarEventoA3(_x6, _x7, _x8, _x9, _x10) {
                return _ref2.apply(this, arguments);
            }

            return EnviarEventoA3;
        }(),
        EnviarEvento: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(manifesto, codevento, descevento, xjust, callback) {
                var tipo;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                tipo = this.$certificadoCheck(null);

                                if (tipo == 'A1') {
                                    this.EnviarEventoA1(manifesto, codevento, descevento, xjust, callback);
                                } else if (tipo == 'A3') {
                                    this.EnviarEventoA3(manifesto, codevento, descevento, xjust, callback);
                                }

                            case 2:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function EnviarEvento(_x11, _x12, _x13, _x14, _x15) {
                return _ref3.apply(this, arguments);
            }

            return EnviarEvento;
        }(),
        DownloadxmlA1: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(manifesto, callback) {
                var sendData, metodo, data;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                sendData = {};

                                sendData = { "codmanifesto": manifesto.list_manifesto[0].codmanifesto, "chave": manifesto.chnfe };

                                metodo = 'post';
                                _context4.next = 5;
                                return (0, _apiFunctions.apiORDSpost)(this.$store, MODULO_DOWNLOADXML, sendData, metodo);

                            case 5:
                                data = _context4.sent;

                                if (data.errmessages) {
                                    this.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    // this.$erpToastSuccess('Operação executada com sucesso.')
                                }

                                callback("A1", !data.errmessages, manifesto);

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function DownloadxmlA1(_x16, _x17) {
                return _ref4.apply(this, arguments);
            }

            return DownloadxmlA1;
        }(),
        DownloadxmlA3ResponseCallback: function DownloadxmlA3ResponseCallback(response, callback, manifesto) {
            //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
            if (response.status != 'success') {
                this.$erpToastError(response.message);
            } else {
                this.$erpToastSuccess('Download efetuado');
            }
            callback("A3", response.status == 'success', manifesto);
        },
        DownloadxmlA3: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(manifesto, callback) {
                var sendData;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                this.$appLoading(true);

                                sendData = "&codmanifesto=" + manifesto.list_manifesto[0].codmanifesto;

                                this.$executaExtensaoChromeA3(null, 'manifestodownloadxml', function (response) {
                                    this.DownloadxmlA3ResponseCallback(response, callback, manifesto);
                                }, sendData);

                            case 3:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function DownloadxmlA3(_x18, _x19) {
                return _ref5.apply(this, arguments);
            }

            return DownloadxmlA3;
        }(),
        Downloadxml: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(manifesto, callback) {
                var tipo;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                tipo = this.$certificadoCheck(null);

                                if (tipo == 'A1') {
                                    this.DownloadxmlA1(manifesto, callback);
                                } else if (tipo == 'A3') {
                                    this.DownloadxmlA3(manifesto, callback);
                                }

                            case 2:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function Downloadxml(_x20, _x21) {
                return _ref6.apply(this, arguments);
            }

            return Downloadxml;
        }()
    }
};

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        query: Object
    },

    data: function data() {
        return {

            filtroTipos: {
                list: [{ id: -1, label: 'Todos' }, { id: 0, label: 'Sem Manifestação do Destinatário' }, { id: 1, label: 'Confirmada Operação' }, { id: 2, label: 'Desconhecida' }, { id: 3, label: 'Operação não Realizada' }, { id: 4, label: 'Ciência' }],
                index: -1
            },

            filtroManifestoSelected: null
        };
    },


    components: {},

    computed: {
        labelManifesto: function labelManifesto() {
            return this.filtroTipos.list[this.$store.getters.getIndexfiltroTiposManifesto].label;
        }
    },

    watch: {},

    filters: {},

    methods: {
        handleChangeFiltroManifesto: function handleChangeFiltroManifesto(index) {
            this.$store.commit('SET_INDEXFILTROTIPOSMANIFESTO', index);
            this.filtroManifestoSelected = this.filtroTipos.list[index];
            this.query.confdest = this.filtroManifestoSelected.id;
            if (this.query.confdest == null) this.query.confdest = -1;
            this.$emit('change', this.query.confdest);
        }
    },

    created: function created() {}
});

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_input_search__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_input_month2__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_label_title__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shared_api_functions__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */], Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */], Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */], InputSearch: __WEBPACK_IMPORTED_MODULE_3__components_input_search__["default"], LabelTitle: __WEBPACK_IMPORTED_MODULE_5__components_label_title__["default"], InputMonth2: __WEBPACK_IMPORTED_MODULE_4__components_input_month2__["default"]
  },
  data: function data() {
    return {
      showFiltro: false,
      dados: {},
      itemPesquisa: null,
      nextPage: false,
      monthObj: {
        startDate: null,
        endDate: null
      },
      paramsFiltro: {
        checkbox: [],
        filtros: [{ nome: 'grupoestoque', label: null, url: null, varios: true, values: [] }, { nome: 'clientefornecedor', label: null, url: null, varios: true, values: [] }]
      },
      filtro: {
        data_inicio: null,
        data_termino: null,
        produto: [],
        fornecedor: [],
        grupoestoque: [],
        page: 1
      }
    };
  },

  methods: {
    handleCloseFiltro: function handleCloseFiltro() {
      this.showFiltro = false;
    },
    handleCancel: function handleCancel() {
      this.showFiltro = false;
    },
    filtroChange: function filtroChange(filtro) {
      this.filtro.grupoestoque = filtro.grupoestoque || [];
      this.filtro.fornecedor = filtro.clientefornecedor || [];
      this.filtro.page = 1;
      this.showFiltro = false;
    },
    clickRetornar: function clickRetornar() {
      this.$router.push('/');
    },
    handleShowFiltro: function handleShowFiltro() {
      this.showFiltro = true;
    },
    periodoChange: function periodoChange(start, end) {
      this.filtro.data_inicio = start;
      this.filtro.data_termino = end;
      this.filtro.page = 1;
    },
    handleItemSelect: function handleItemSelect(item) {
      this.filtro.produto = [item.id || item.codigo];
      this.filtro.descricao = null;
      this.filtro.page = 1;
    },
    handleSearch: function handleSearch() {
      if (this.itemPesquisa) {
        // Se o que está no input é diferente do ID selecionado, tratamos como busca por descrição
        if (!this.filtro.produto || this.filtro.produto.length === 0 || this.itemPesquisa !== this.filtro.produto[0]) {
          this.filtro.descricao = this.itemPesquisa;
          this.filtro.produto = [];
        }
      } else {
        this.filtro.descricao = null;
        this.filtro.produto = [];
      }
      this.filtro.page = 1;
      this.loadData();
    },
    scroll: function scroll() {
      var _this = this;

      window.onscroll = function () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        var windowHeight = window.innerHeight;
        var scrollHeight = document.documentElement.scrollHeight;

        if (scrollTop + windowHeight >= scrollHeight - 10) {
          if (_this.dados.has_more && !_this.nextPage) {
            _this.loadData(false, true);
          }
        }
        __WEBPACK_IMPORTED_MODULE_6__main__["SysVars"].scrollPosition = scrollTop;
      };
    },
    loadData: function loadData(excel, loadMore) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data, _dados$items, self;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "consulta/estoque/movimentacaoestoque";

                if (!loadMore) {
                  _context.next = 10;
                  break;
                }

                if (!(_this2.dados.has_more && !_this2.nextPage)) {
                  _context.next = 7;
                  break;
                }

                _this2.filtro.page = _this2.dados.next_page;
                _this2.nextPage = true;
                _context.next = 8;
                break;

              case 7:
                return _context.abrupt('return');

              case 8:
                _context.next = 11;
                break;

              case 10:
                if (!excel) {
                  _this2.filtro.page = 1;
                }

              case 11:

                _this2.filtro.excel = excel;

                if (!excel) {
                  _context.next = 16;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_7__shared_api_functions__["apiDownload2"])(_this2, url, _this2.filtro, "post");
                _context.next = 20;
                break;

              case 16:
                _context.next = 18;
                return Object(__WEBPACK_IMPORTED_MODULE_7__shared_api_functions__["apiORDSpost"])(_this2.$store, url, _this2.filtro, "post");

              case 18:
                data = _context.sent;

                if (data) {
                  if (loadMore && _this2.dados.items) {
                    (_dados$items = _this2.dados.items).push.apply(_dados$items, _toConsumableArray(data.items));
                    _this2.dados.has_more = data.has_more;
                    _this2.dados.next_page = data.next_page;
                  } else {
                    _this2.dados = data;
                  }
                } else {
                  if (!loadMore) {
                    _this2.dados = { items: [] };
                  }
                }

              case 20:
                self = _this2;

                _this2.$nextTick(function () {
                  self.nextPage = false;
                });

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },
  mounted: function mounted() {
    this.scroll();
  },
  destroyed: function destroyed() {
    window.onscroll = null;
  },
  created: function created() {
    // Inicia com o mês atual para evitar consulta gigantesca
    var hoje = new Date();
    var dataInicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);

    this.filtro.data_inicio = dataInicio.toISOString().split('T')[0];
    this.filtro.data_termino = hoje.toISOString().split('T')[0];

    this.monthObj.startDate = this.filtro.data_inicio;
    this.monthObj.endDate = this.filtro.data_termino;
  }
});

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */], Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */], Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
    },
    data: function data() {
        return {
            showFiltro: false,
            dados: {},
            itemPesquisa: '',
            periodo: { data_inicio: null, data_termino: null, startDate: null, endDate: null },
            paramsFiltro: {
                checkbox: [{ nome: 'com_estoque', label: 'Somente Produtos com Estoque', valueChecked: true, valueUnchecked: false, value: false }, { nome: 'sem_circulacao', label: 'Somente Produtos sem circulação', valueChecked: true, valueUnchecked: false, value: false }],
                filtros: [{ nome: 'clientefornecedor', label: null, url: null, varios: true, values: [] }]
            },
            filtro: {
                periodos: [{ data_inicio: null, data_termino: null }]
            },
            nextPage: false
        };
    },

    watch: {
        itemPesquisa: function itemPesquisa(newVal) {
            var _this = this;

            if (!newVal) {
                delete this.filtro.produto;
                delete this.filtro.descricao;
            } else {
                // Delay to allow handleItemSelect to process first if an item was clicked
                setTimeout(function () {
                    if (!_this.filtro.produto || String(_this.filtro.produto[0]) !== String(newVal)) {
                        delete _this.filtro.produto;
                        _this.filtro.descricao = newVal;
                    }
                }, 100);
            }
        }
    },
    computed: {},
    methods: {
        handleItemSelect: function handleItemSelect(item) {
            if (item && (item.id || item.codigo)) {
                this.filtro.produto = [item.id || item.codigo];
                delete this.filtro.descricao;
            }
        },
        handleCloseFiltro: function handleCloseFiltro() {
            this.showFiltro = false;
        },
        handleCancel: function handleCancel() {
            this.showFiltro = false;
        },
        filtroChange: function filtroChange(filtro) {
            if (this.filtro.produto) filtro.produto = this.filtro.produto;
            if (this.filtro.descricao) filtro.descricao = this.filtro.descricao;

            this.filtro = filtro;
            this.loadData();
            this.showFiltro = false;
        },
        clickRetornar: function clickRetornar() {
            this.$router.push('/');
        },
        handleShowFiltro: function handleShowFiltro() {
            this.showFiltro = true;
        },
        scroll: function scroll() {
            var _this2 = this;

            window.onscroll = function () {
                if (_this2.nextPage) return;

                var bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= document.documentElement.offsetHeight - 50;

                if (bottomOfWindow && _this2.dados.has_more) {
                    _this2.loadData(false, true);
                }
                __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].scrollPosition = document.documentElement.scrollTop;
            };
        },
        loadData: function loadData(excel, loadMore) {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var url, data, _dados$items, self;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                url = "consulta/estoque/resumomovimentacaoestoque";
                                // let url = "consulta/teste";

                                _this3.periodo.data_inicio = _this3.periodo.startDate;
                                _this3.periodo.data_termino = _this3.periodo.endDate;
                                _this3.filtro.periodos = [_this3.periodo];
                                _this3.filtro.data_inicio = _this3.periodo.startDate;
                                _this3.filtro.data_termino = _this3.periodo.endDate;

                                console.log(_this3.filtro);

                                if (!loadMore) {
                                    _context.next = 16;
                                    break;
                                }

                                if (!_this3.dados.has_more) {
                                    _context.next = 13;
                                    break;
                                }

                                _this3.filtro.page = _this3.dados.next_page;
                                _this3.nextPage = true;
                                _context.next = 14;
                                break;

                            case 13:
                                return _context.abrupt('return');

                            case 14:
                                _context.next = 17;
                                break;

                            case 16:
                                delete _this3.filtro.page;

                            case 17:

                                _this3.filtro.excel = excel;

                                if (!excel) {
                                    _context.next = 22;
                                    break;
                                }

                                Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiDownload2"])(_this3, url, _this3.filtro, "post");
                                _context.next = 26;
                                break;

                            case 22:
                                _context.next = 24;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this3.$store, url, _this3.filtro, "post");

                            case 24:
                                data = _context.sent;

                                if (data) {
                                    if (loadMore) {
                                        (_dados$items = _this3.dados.items).push.apply(_dados$items, _toConsumableArray(data.items));
                                        _this3.dados.has_more = data.has_more;
                                        _this3.dados.next_page = data.next_page;
                                    } else _this3.dados = data;
                                } else {
                                    if (!loadMore) _this3.dados = {};
                                }

                            case 26:
                                self = _this3;

                                _this3.$nextTick(function () {
                                    self.nextPage = false;
                                });

                            case 28:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        }
    },

    created: function created() {
        this.periodo.data_inicio = this.$firstDay(this.$getDate());
        this.periodo.data_termino = this.$lastDay(this.$getDate());
        this.periodo.startDate = this.$firstDay(this.$getDate());
        this.periodo.endDate = this.$lastDay(this.$getDate());
    },
    mounted: function mounted() {
        this.scroll();
    },
    destroyed: function destroyed() {
        window.onscroll = null;
    }
});

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashCard: __WEBPACK_IMPORTED_MODULE_0__dashboards_dash_card__["a" /* default */],
    Filtro: __WEBPACK_IMPORTED_MODULE_2__filtro__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]
  },

  data: function data() {
    return {
      showfiltro: false,
      tableColumns: [],
      dados: {},
      dadosGrafico: null,

      itemPesquisa: '',
      status_estoque: '',

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {

        checkbox: [],
        filtros: [{
          nome: "grupoestoque",
          label: 'Grupo de Produtos',
          url: null,
          varios: true,
          values: []
        }]
      },

      filtro: {
        //       periodos: [{ data_inicio: null, data_termino: null }],
        resumoEstoque: true
      },

      colunas: [],

      nextPage: false

    };
  },

  watch: {
    itemPesquisa: function itemPesquisa(newVal) {
      var _this = this;

      if (!newVal) {
        delete this.filtro.produto;
        delete this.filtro.descricao;
      } else {
        // Delay to allow handleItemSelect to process first if an item was clicked
        setTimeout(function () {
          if (!_this.filtro.produto || String(_this.filtro.produto[0]) !== String(newVal)) {
            delete _this.filtro.produto;
            _this.filtro.descricao = newVal;
          }
        }, 100);
      }
    },
    status_estoque: function status_estoque(newVal) {
      this.filtro.abaixo_estoque_minimo = newVal === 'abaixo_estoque_minimo';
      this.filtro.somente_sem_estoque = newVal === 'somente_sem_estoque';
      this.filtro.somente_com_estoque = newVal === 'somente_com_estoque';
      this.filtro.lotes_vencidos = newVal === 'lotes_vencidos';
    }
  },

  methods: {
    handleSearch: function handleSearch() {
      this.loadData();
    },
    handleItemSelect: function handleItemSelect(item) {
      if (item && (item.id || item.codigo)) {
        this.filtro.produto = [item.id || item.codigo];
        delete this.filtro.descricao;
      }
    },
    handleCloseFiltro: function handleCloseFiltro() {
      this.showfiltro = false;
    },
    handleCancel: function handleCancel() {
      this.showfiltro = false;
    },
    clickRetornar: function clickRetornar() {
      this.$router.push('/');
    },
    loadCols: function loadCols() {
      if (!this.filtro.resumoEstoque) {
        this.tableColumns = [{ label: 'Código', tp: 'textual' }, { label: 'Descrição', tp: 'textual' }, { label: 'Unitario', tp: 'textual' }, { label: 'Qtd Estoque', tp: 'numerico' }, { label: 'Qtd Minima', tp: 'numerico' }];
      } else {
        this.tableColumns = [{ label: 'Código', tp: 'textual' }, { label: 'Descrição', tp: 'textual' }, { label: 'Unitario', tp: 'textual' }, { label: 'Qtd Estoque', tp: 'numerico' }, { label: 'Qtd Minima', tp: 'numerico' },
        //{label: 'Qtd Reservada', tp: 'numerico'},
        { label: 'Preço de venda', tp: 'numerico' }, { label: 'Preço de compra', tp: 'numerico' }, { label: 'Custo', tp: 'numerico' }];
      }
    },
    handleShowFiltro: function handleShowFiltro() {
      this.showfiltro = true;
    },
    filtroChange: function filtroChange(filtro) {
      this.showfiltro = false;

      // Mantém os filtros da tela principal
      filtro.resumoEstoque = this.filtro.resumoEstoque;
      filtro.abaixo_estoque_minimo = this.filtro.abaixo_estoque_minimo;
      filtro.somente_sem_estoque = this.filtro.somente_sem_estoque;
      filtro.somente_com_estoque = this.filtro.somente_com_estoque;
      filtro.lotes_vencidos = this.filtro.lotes_vencidos;

      if (this.filtro.produto) filtro.produto = this.filtro.produto;
      if (this.filtro.descricao) filtro.descricao = this.filtro.descricao;

      this.filtro = filtro;

      this.loadData();
    },
    scroll: function scroll() {
      var _this2 = this;

      window.onscroll = function () {
        var bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          _this2.loadData(false, true);
        }
        __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].scrollPosition = document.documentElement.scrollTop;
      };
    },
    loadData: function loadData(excel, loadMore) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, data, _dados$items, self;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "consulta/estoque/saldoestoque";
                // let url = "consulta/teste";

                if (!loadMore) {
                  _context.next = 8;
                  break;
                }

                if (!_this3.dados.has_more) {
                  _context.next = 7;
                  break;
                }

                _this3.filtro.page = _this3.dados.next_page;
                _this3.nextPage = true;
                _context.next = 8;
                break;

              case 7:
                return _context.abrupt("return");

              case 8:

                _this3.filtro.excel = excel;

                if (!excel) {
                  _context.next = 13;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiDownload2"])(_this3, url, _this3.filtro, "post");
                _context.next = 18;
                break;

              case 13:
                _context.next = 15;
                return Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(_this3.$store, url, _this3.filtro, "post");

              case 15:
                data = _context.sent;

                if (data) {
                  if (loadMore) {
                    (_dados$items = _this3.dados.items).push.apply(_dados$items, _toConsumableArray(data.items));
                    _this3.dados.has_more = data.has_more;
                    _this3.dados.next_page = data.next_page;
                    // Mantém o total da primeira carga
                  } else _this3.dados = data;
                } else {
                  _this3.dados = {};
                }
                _this3.loadCols();

              case 18:
                self = _this3;

                _this3.$nextTick(function () {
                  self.nextPage = false;
                });

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    }
  },

  mounted: function mounted() {
    this.scroll();
  },
  destroyed: function destroyed() {
    window.onscroll = null;
  },
  created: function created() {
    this.loadCols();
  }
});

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_anexos_form__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            coditem: '',
            descricao: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            showAnexosForm: false,
            offset: false,
            tabelas: [{
                codtabpre: '1',
                descricao: 'Padrão'
            }]
        };
    },


    computed: {
        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        },

        produtos: function produtos() {
            return this.$store.getters.getItemSalesList;
        },

        tabelasUsuario: function tabelasUsuario() {
            //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
            var tabelas = this.$store.getters.getTabpreList.filter(function (obj) {
                return obj.sttabpre == 'A';
            });
            return tabelas;

            // let options = []

            // let liberado = []
            // let currTabpre = {}

            // for (var x = 0; x < this.$store.getters.getTabpreList.length; x++) {
            //     currTabpre = this.$store.getters.getTabpreList[x]

            //     //se existir parametros do usuario, libera somente as tabelas permitidas
            //    if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) {
            //         liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter((obj) => { return obj == currTabpre.codtabpre})
            //         if (liberado.length > 0) {
            //             options.push({ id: currTabpre.codtabpre, text: currTabpre.descricao })
            //         }
            //     } else {
            //         options.push({ id: currTabpre.codtabpre, text: currTabpre.descricao })
            //     }
            // }
            // return options
        }

    },

    methods: {
        handleAnexosForm: function handleAnexosForm(coditem, descricao) {
            this.coditem = coditem;
            this.descricao = descricao;
            this.showAnexosForm = true;
        },
        handleMore: function handleMore() {
            this.offset = true;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showAnexosForm = false;
        },
        search: function search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codigo":{"$eq":"' + value + '"}},{"descricao":{"$like":"%25' + value + '%25"}}]}';
            this.loadData();
        },
        textST: function textST(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__shared_utils__["getText"])(value, this.metadata.item.stitem);
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadTabpre', {});

                            case 2:
                                params = { filter: _this.filter };

                                if (_this.offset) {
                                    params.offset = _this.nextPage;
                                }
                                _this.$store.dispatch('loadPesquisaProdutosSales', params);
                                _this.offset = false;

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], AnexosForm: __WEBPACK_IMPORTED_MODULE_1__components_anexos_form__["a" /* default */]
    },

    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__varejo_emissao_cupom__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__varejo_devolucao_form_vue__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pedido_filtro__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_api_pedido_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_api_pedido_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__api_api_pedido_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_api_nfe_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_api_nfe_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__api_api_nfe_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//





// import { VueOfflineMixin } from 'vue-offline',






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: '',
    codvabertura: ''
  },

  components: {
    BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], VarejoEmissaoCupom: __WEBPACK_IMPORTED_MODULE_4__varejo_emissao_cupom__["a" /* default */], DevolucaoForm: __WEBPACK_IMPORTED_MODULE_5__varejo_devolucao_form_vue__["a" /* default */], PedidoFiltro: __WEBPACK_IMPORTED_MODULE_6__components_pedido_filtro__["a" /* default */]
  },

  data: function data() {

    return {
      showForm: false, //exibe a tela de manutencao
      crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
      vend: '',
      metadata: this.$store.getters.getEntities.metadata,
      filter: '',
      offset: false,

      nfSearch: null,
      textSearch: null,

      showDevolucao: false,
      codpedv: null,
      pedv: null,
      tipo_devolucao: false,

      query: {
        codusuario: null,
        codequipe: null,
        text: null,
        after: null,
        before: null,
        codstatus: null
      },
      caixasList: null,
      isOnline: true,
      cupomCodpedv: null,
      showEmissaoCupom: false,

      actions: [{ action: 1, label: 'Configurar PDV' }, { action: 2, label: 'Cadastro de Caixas' }, { action: 3, label: 'Formas de Pagamento' }]

    };
  },


  computed: {
    varejoList: function varejoList() {
      return this.$store.getters.getPedvList;
    },
    nextPage: function nextPage() {
      return this.$store.getters.getNextPage;
    }
  },

  filters: {
    getText: function getText(value, metadata) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["getText"])(value, metadata);
    }

  },

  methods: {
    scroll: function scroll() {
      var _this = this;

      window.onscroll = function () {
        if (_this.offset || _this.nextPage == 0) return;
        var bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= document.documentElement.offsetHeight - 2;

        if (bottomOfWindow) {
          _this.offset = true;
          _this.loadData(true);
        }
        __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].scrollPosition = document.documentElement.scrollTop;
      };
    },
    horaStatus: function horaStatus(hora) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatDataHoraExtenso"])(hora);
    },


    statusColor: function statusColor(stpedv, tppedv) {
      var color = 'badge-green';
      if (stpedv == 'C' || stpedv == 'R' || tppedv == 'R') {
        color = 'badge-red';
      } else if (stpedv == 'F') {
        color = 'badge-blue';
      } else if (tppedv == 'O') {
        color = 'badge-orange';
      } else if (stpedv == 'D') {
        color = 'badge-warning';
      } else if (tppedv == 'P') {
        color = 'badge-green';
      }
      return color;
    },

    textST: function textST(item) {
      var text = 'Venda';
      if (item.tppedv == 'O') {
        text = 'Orçamento';
      } else if (item.tppedv == 'R') {
        text = 'Orçamento Perdido';
        return text;
      }

      if (item.stpedv == 'C') {
        text = text + ' Cancelada';
      } else if (item.stpedv == 'R') {
        text = text + ' Rejeitado';
      } else if (item.stpedv == 'A') {
        text = text + ' Em Aprovação';
      } else if (item.stpedv == 'F') {
        text = 'Nota Emitida';
      } else if (item.stpedv == 'D') {
        text = text + ' em Espera';
      }
      return text;
      // return getText(value, this.metadata.pedv.stpedv)
    },
    handleConnectivityChange: function handleConnectivityChange(status) {
      this.isOnline = status.online;
    },
    handleCompletEdit: function handleCompletEdit(cod) {
      //abre a tela de edicao
      this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudU;
      this.codpedv = cod;
      this.$router.push('/pedido/' + this.codpedv);
      this.showForm = true;
    },
    handleNew: function handleNew() {
      //inclusao de registro
      this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudI;
      this.codpedv = '';

      if (this.codvabertura) //quando a chamada foi por dentro do form de varejo
        this.$emit('resultadolist', null, '');
      this.$router.push('/varejo/0');
      this.showForm = true;
    },
    handleMore: function handleMore() {
      this.offset = true;
      this.loadData();
    },
    closeForm: function closeForm() {
      this.showForm = false;
      this.loadData();
    },
    closeFormDevolucao: function closeFormDevolucao() {
      this.showDevolucao = false;
      this.scroll();
    },
    changeFiltros: function changeFiltros() {
      this.query.text = null;
      this.query.nf = null;
      this.nfSearch = null;
      this.loadData();
    },
    handleTextSearch: function handleTextSearch() {
      //efetua a pesquisa
      this.query.text = this.textSearch.toUpperCase();
      this.query.nf = null;
      this.nfSearch = null;
      this.loadData();
    },
    handleNfSearch: function handleNfSearch() {
      //efetua a pesquisa
      this.query.text = null;
      this.query.nf = this.nfSearch;
      this.textSearch = null;
      this.loadData();
    },
    handleChangeMonth: function handleChangeMonth(filter, startDate, endDate) {
      this.query.after = startDate;
      this.query.before = endDate;
      this.query.text = null;
      this.query.nf = null;
      this.textSearch = null;
      this.nfSearch = null;
      this.loadData();
    },
    handleSearch: function handleSearch(value) {
      this.textSearch = value;
      this.handleTextSearch();
    },
    handleRefresh: function handleRefresh() {
      this.query.text = null;
      this.query.nf = null;
      this.textSearch = null;
      this.nfSearch = null;
      this.loadData();
    },
    handleButtonMoreActions: function handleButtonMoreActions(action) {
      if (action == 1) {
        this.$router.push('guiaempresa/pdv?b=varejolist');
      }
      if (action == 2) {
        this.$router.push('caixas');
      }
      if (action == 3) {
        this.$router.push('fpag');
      }
    },
    handleFaturarVenda: function handleFaturarVenda(pedv, tipo) {
      this.pedv = _extends({}, pedv);
      var esp = '';
      if (tipo == 'NFCe') esp = '65';else esp = '55';
      var self = this;

      this.apiGerarNF(esp).then(function () {
        var tipo = self.$certificadoCheck(self.pedv.codfil);
        if (tipo == 'A1') {
          self.autorizaNFeA1(self.pedv.nf, self.NFeResponseCallbackA1).then(function () {});
        } else if (tipo == "A3") {
          self.autorizaNFeA3(self.pedv.nf, self.NFeResponseCallbackA3).then(function () {});
        }
      });
    },
    NFeResponseCallbackA3: function NFeResponseCallbackA3(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
      if (response.status != "success") {
        this.$erpToastError(response.message);
      } else {
        if (response.response && response.response.nf.length > 0 && response.response.nf[0].cstat == "100") {
          this.$erpToastSuccess("NFe Autorizada");
          Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiDownloadPDF"])(this, "print/danfe/" + response.response.nf[0].codnf, null, null, true);
        } else {
          this.$erpToastError(response.response.xmotivo);
          this.$router.push("/nf/" + response.response.nf[0].codnf + "?tipo=view");
        }
      }
    },
    NFeResponseCallbackA1: function NFeResponseCallbackA1(response) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var rejeitada;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                rejeitada = false;

                if (response.data) {
                  if (!response.data.errmessages) {
                    if (response.data.nf.length > 0) {
                      if (response.data.nf[0].cstat != "100") {
                        rejeitada = true;
                      }
                    } else {
                      rejeitada = true;
                    }
                  }
                }

                if (rejeitada) {
                  _this2.$erpToastError('NFe Rejeitada');
                  _this2.$router.push("/nf/" + _this2.pedv.nf.codnf + "?tipo=view");
                }

                //CASO NF-e AUTORIZADA SERÁ ABERTO TELA DE IMPRESSÃO
                if (response.data.nf.length > 0) {
                  if (response.data.nf[0].codnf) {
                    _this2.$erpToastSuccess("NFe Autorizada");
                    Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiDownloadPDF"])(_this2, "print/danfe/" + response.data.nf[0].codnf, null, null, true);
                  }
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    loadData: function loadData() {
      //this.$store.dispatch('loadVend', { filter: this.filter, page: this.nextPage } )
      //this.offset = ''

      var param = {};
      param.query = '';
      if (this.query.after) param.query = param.query + 'after=' + this.query.after + '&';
      if (this.query.before) param.query = param.query + 'before=' + this.query.before + '&';

      if (this.query.espera) param.query = param.query + 'filtroorigem=4&';else param.query = param.query + 'filtroorigem=3&';

      if (this.codvabertura) param.query = param.query + 'codabertura=' + this.codvabertura + '&';
      if (this.query.text) param.query = param.query + 'text=' + this.query.text + '&';
      if (this.query.nf) param.query = param.query + 'nf=' + this.query.nf + '&';
      if (this.offset) param.query = param.query + 'poffset=' + this.nextPage + '&';

      param.query = param.query.trim();
      if (param.query.endsWith('&')) param.query = param.query.slice(0, -1);

      this.$store.dispatch('loadPedvList', param);
      this.offset = false;
    },
    loadDataCaixas: function loadDataCaixas() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var self;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this3;

                self.caixasList = [];
                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDS"])(_this3.$store.getters.urlOrds + 'varejo/caixas', null, true).then(function (result) {
                  if (!result) return;
                  for (var index = 0; index < result.items.length; index++) {
                    if (result.items[index].aberto == 'S') self.loadDetCaixa(result.items[index]);else {
                      var caixa = {
                        caixa: result.items[index].caixa,
                        operadorabertura: null,
                        resumoVendas: { total: 0 },
                        aberto: false,
                        status: 'Caixa Fechado'
                      };
                      self.caixasList.push(caixa);
                    }
                  }
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    loadDetCaixa: function loadDetCaixa(caixa) {
      var self = this;
      Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDS"])(this.$store.getters.urlOrds + 'varejo/controlecaixa/' + caixa.codvabertura, null, true).then(function (result) {
        if (!result) return;
        self.caixasList.push(result);
      });
    },
    handleBarGrid: function handleBarGrid(stpedv) {
      var options = { barDefault: true, btnView: !this.tipo_devolucao, btnEdit: false };

      if (stpedv == 'D') options.btnEdit = true;

      if (stpedv == 'P' || stpedv == 'F') options.btnDevolucao = this.tipo_devolucao;

      return options;
    },
    handleAction: function handleAction(act, obj) {
      if (act == 12) {
        this.handleFaturarVenda(obj, 'NFe');
        return;
      }
      if (act == 10) {
        this.handleFaturarVenda(obj, 'NFCe');
        return;
      }

      if (act == 16) {
        //visualizacao do XML da NFE
        if (obj.stnf != '10') {
          this.$erpToastWarning('A nota fiscal não está autorizada');
          return;
        }
        var data = { codnf: obj.codnf, chave: obj.chave, tipo: 'NFE' };
        Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiDownload"])(this, 'print/xmlnfe/', data, 'post');
      }

      if (act == 15) {
        //impressao da danfe em PDF
        if (obj.esp == '59') {
          var paramsimp = '&codnf=' + obj.codnf;
          this.$executaExtensaoChromeSAT(obj.codnf, 'imp', this.PDFResponseCallbackSAT, paramsimp);
          return;
        }
        if (obj.stnf != '10') this.$erpToastWarning('A nota fiscal não está autorizada');else Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiDownloadPDF"])(this, 'print/danfe/' + obj.codnf);
      }

      if (act == 13) {
        this.cupomCodpedv = obj.codpedv;
        this.showEmissaoCupom = true;
      }

      if (act == 20) {
        this.handleDevolucao(obj.codpedv);
      }
      if (act == 14) {
        this.handleCompletEdit(obj.codpedv);
      }
      if (act == 21) {
        this.handleEdit(obj.codpedv);
      }
    },
    handleDevolucao: function handleDevolucao(codpedv) {
      this.codpedv = codpedv;
      this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudInsert;
      window.onscroll = null;
      this.showDevolucao = true;
    },
    getActions: function getActions(pedv) {
      var actions = [];

      if (this.tipo_devolucao) return;

      if (pedv.stpedv == 'P') {
        actions.push({ action: 10, label: 'Emitir NFc-e' });
        // actions.push({ action: 11, label: 'Emitir SAT' })
        actions.push({ action: 12, label: 'Emitir NF-e' });
        actions.push({ action: 13, label: 'Cupom Não Fiscal' });
        // actions.push({ action: 14, label: 'Visualização Completa' })
      }

      if (pedv.stpedv == 'F') {
        actions.push({ action: 15, label: 'Danfe PDF' });
        actions.push({ action: 16, label: 'Download do XML' });
      }

      if (pedv.stpedv == 'P' || pedv.stpedv == 'F') {
        actions.push({ action: 20, label: 'Lançar Devolução' });
      }
      // actions.push({ action: 21, label: 'Visualização' })
      return actions;
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7__api_api_pedido_js___default.a, __WEBPACK_IMPORTED_MODULE_8__api_api_nfe_js___default.a],

  created: function created() {

    this.$on("online", function () {
      self.handleConnectivityChange({ online: true });
    });

    this.$on("offline", function () {
      self.handleConnectivityChange({ online: false });
    });

    this.showForm = false;
    this.loadData();
    this.loadDataCaixas();

    this.tipo_devolucao = false;
    if (this.$route.params) {
      if (this.$route.params.tipo == 'devolucao') this.tipo_devolucao = true;
    }

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
  },
  mounted: function mounted() {
    this.scroll();
  },
  destroyed: function destroyed() {
    window.onscroll = null;
  }
});

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
var _props$components$fil;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = (_props$components$fil = {
  props: {
    index: '',
    tipo: ''
  },

  components: {},

  filters: {
    changeToFloat: function changeToFloat(value) {
      return value.toFixed(2).replace('.', ',');
    }
  },

  data: function data() {
    return {
      cupom: null
    };
  },


  computed: {
    urlLogotipo: function urlLogotipo() {
      return this.$store.getters.urlApp + 'logo/download/' + this.cupom.empresa.logo;
    },
    curentDate: function curentDate() {
      var data = new Date();
      var dia = String(data.getDate()).padStart(2, '0');
      var horas = data.getHours() + ':' + data.getMinutes() + ':' + data.getSeconds();
      var mes = String(data.getMonth() + 1).padStart(2, '0');
      var ano = data.getFullYear();
      var dataAtual = dia + '-' + mes + '-' + ano + ' ' + horas;
      return dataAtual.toString();
    },
    itemsSum: function itemsSum() {
      var total = 0.0;
      if (this.cupom && this.cupom.itens) this.cupom.itens.map(function (e) {
        return total = e.total + total;
      });
      return (total / 1).toFixed(2).replace('.', ',');
    }
  },

  watch: {}

}, _defineProperty(_props$components$fil, 'filters', {}), _defineProperty(_props$components$fil, 'methods', {
  loadData: function loadData() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_0__shared_api_functions__["apiORDS"])(_this.$store.getters.urlOrds + 'varejo/cupom/' + _this.tipo + '/' + _this.index, null);

            case 2:
              data = _context.sent;


              // Retorno da requisição está trazendo quando tipo == cupomfiscal data.items(Array) : object{}

              if (_this.tipo == 'cupomnaofiscal') {
                _this.cupom = data.items[0];
                _this.cupom.mensagemCupom = 'Obrigado e volte sempre';
              } else {
                _this.cupom = data.items[0];
                _this.cupom.items = [{ obs: _this.cupom.obs, valor: 100 }];
              }
              _this.$nextTick(function () {
                this.print();
              });

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  print: function print() {

    var prtHtml = document.getElementById('cupom').innerHTML; //CARREGAR TIPO

    var stylesHtml = '';

    var _arr = [].concat(_toConsumableArray(document.querySelectorAll('link[rel="stylesheet"], style')));

    for (var _i = 0; _i < _arr.length; _i++) {
      var node = _arr[_i];
      stylesHtml += node.outerHTML;
    }

    var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
    // const total = formatValue(this.vendaAberta.total_com_desconto,2)
    var total = Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(this.cupom.total, 2);

    WinPrint.document.write('\n          <!DOCTYPE html>\n          <html>\n            <head>\n              ' + stylesHtml + '\n            </head>\n            <body>\n              <div>\n                <div class="w-100 p-3">\n                    ' + prtHtml + '\n                </div>\n              </div>\n            </body>\n          </html>\n        ');

    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();

    this.$emit('resultadoemissaocupom');
  }
}), _defineProperty(_props$components$fil, 'created', function created() {
  this.loadData();
}), _props$components$fil);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_devolucao_form_vue__ = __webpack_require__(753);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d8ff3e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_devolucao_form_vue__ = __webpack_require__(2146);
function injectStyle (ssrContext) {
  __webpack_require__(2144)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_devolucao_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d8ff3e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_devolucao_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forms_pedido_addlist__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_serienf_form__ = __webpack_require__(593);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            vdevol: '',
            metadata: this.$store.getters.getEntities.metadata,
            devTipo: '',
            totalDev: 0,
            errorClienteValCPF: '',
            errorClienteVal: '',
            crudText: '',
            errmessages: [], // Armazena as mensagens de validações do servidor para mostrar na tela
            showModalSerie: false,
            avisoSerie55: false
        };
    },

    computed: {
        isView: function isView() {
            return this.crud == __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudView;
        },
        crudSerie: function crudSerie() {
            return __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudInsert;
        }
    },
    watch: {
        devTipo: function devTipo(val) {
            var _this = this;

            if (val == '' || null) {
                this.vdevol.itens.forEach(function (e, i) {

                    _this.$set(_this.vdevol.itens[i], 'check', false);
                    _this.$set(_this.vdevol.itens[i], 'qtdev', 0);
                    _this.$set(_this.vdevol.itens[i], 'totdev', 0);
                });
            }
            if (val == '1') {
                this.vdevol.itens.forEach(function (e, i) {
                    _this.$set(_this.vdevol.itens[i], 'check', false);
                    _this.$set(_this.vdevol.itens[i], 'qtdev', 0);
                    _this.$set(_this.vdevol.itens[i], 'totdev', 0);
                    _this.totalDev = 0;
                    _this.vdevol.itens.find(function (e, i) {
                        _this.totalDev = e.valor * e.qtdev + _this.totalDev;
                    });
                });
            }
            if (val == '2') {
                this.vdevol.itens.forEach(function (e, i) {
                    _this.$set(_this.vdevol.itens[i], 'check', true);
                    _this.$set(_this.vdevol.itens[i], 'qtdev', e.qt);
                    _this.$set(_this.vdevol.itens[i], 'totdev', e.qtdev * e.valor);
                });
                this.totalDev = 0;
            }
            this.calcDev();
        }
    },
    props: {
        index: '',
        crud: ''

    },
    components: {
        PedidoAddlist: __WEBPACK_IMPORTED_MODULE_0__forms_pedido_addlist__["a" /* default */], SerienfForm: __WEBPACK_IMPORTED_MODULE_3__forms_serienf_form__["a" /* default */]
    },
    methods: {
        handleShowSerie: function handleShowSerie() {
            this.showModalSerie = true;
        },
        closeSerie: function closeSerie(esp) {
            this.showModalSerie = false;
            if (esp == '55') this.avisoSerie55 = false;
        },
        calcDev: function calcDev() {
            this.totalDev = 0;
            var total = 0;
            this.vdevol.itens.find(function (e) {
                total = e.valor * e.qtdev + total;
            });
            return this.totalDev = total;
        },
        handleChangeCheck: function handleChangeCheck(item, i) {
            if (item.check == false) {
                this.$set(this.vdevol.itens[i], 'qtdev', 0);
                this.calcDev();
                this.vdevol.itens[i].errors = '';
                this.$set(this.vdevol.itens[i], 'totdev', 0);
                this.$set(this.vdevol.itens[i], 'check', false);
                this.totalDev = this.vdevol.itens[i].totdev + this.totalDev;
                this.calcDev();
            }
        },
        handleEditQtDev: function handleEditQtDev(evt) {
            var _this2 = this;

            this.vdevol.itens.map(function (e, i) {
                if (e.qtdev > e.qt) {
                    _this2.$set(_this2.vdevol.itens[i], 'errors', 'Qtd a devolver não pode ser maior que qtd do item');
                } else {
                    _this2.$set(_this2.vdevol.itens[i], 'errors', '');
                }

                _this2.$set(_this2.vdevol.itens[i], 'totdev', e.qtdev * e.valor);

                if (e.qtdev == 0) {
                    _this2.$set(_this2.vdevol.itens[i], 'totdev', 0);
                    _this2.totalDev = 0;
                }
            });
            this.calcDev();
        },
        closeForm: function closeForm() {
            this.$emit('closeform', this.vdevol.codvdevol);
        },
        handleAutorizaNF: function handleAutorizaNF() {
            return this.$router.push('/nf/' + this.vdevol.nfDevolucao.codnf + '?tipo=devolucao');
        },
        handleSave: function handleSave() {
            var _this3 = this;

            this.errmessages = [];
            var isValid = true;
            var isValidIt = true;

            if (this.avisoSerie55) {
                this.$erpToastError('Cadastre uma s\xE9rie de NF para prosseguir');
                return;
            }

            if (this.vdevol.obrigaDadosCliente || this.vdevol.lancamentodevol == 'C') if (!this.vdevol.part.codpart) {
                isValid = false;
                this.$erpToastError('Selecione ou cadastre um cliente para concluir');
                return;
            }

            this.vdevol.itens.map(function (e) {
                if (e.errors == '' || e.errors == null) {
                    isValidIt = true;
                } else {
                    isValidIt = false;
                    _this3.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                }
            });

            if (this.totalDev == 0) {
                isValid = false;
                this.$erpToastError('Valor da devolu\xE7\xE3o n\xE3o pode estar zerado');
            }
            if (isValid & isValidIt) {
                this.apiPost();
            }
        },
        loadData: function loadData() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this4.crud == __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudView)) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return _this4.$store.dispatch('loadVdevol', { id: _this4.index });

                            case 3:
                                _context.next = 7;
                                break;

                            case 5:
                                _context.next = 7;
                                return _this4.$store.dispatch('loadVdevolPed', { id: _this4.index });

                            case 7:
                                _this4.vdevol = _this4.$store.getters.getVdevol;
                                if (_this4.vdevol.part.cnpjcpf == 'CONSUMIDOR') {
                                    _this4.vdevol.part.codpart = null;
                                }

                                if (_this4.crud != __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudView && _this4.vdevol.nfVenda && !_this4.vdevol.serienf) {
                                    _this4.avisoSerie55 = true;
                                }

                                _this4.$nextTick(function () {
                                    jQuery('[data-toggle="tooltip"]').tooltip();
                                    this.unwatch = false;
                                });

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this4);
            }))();
        },
        apiPost: function apiPost() {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo, sendData, metodo, update, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //efetuaGravação
                                modulo = 'varejo/devolucao';
                                sendData = { vdevol: {}
                                    // CAMPOS REFATORADOS PARA ENVIO DO METODO POST
                                };
                                sendData.vdevol.codpedv = _this5.vdevol.codpedv;
                                sendData.vdevol.codpart = _this5.vdevol.part.codpart;
                                // sendData.vdevol.pessoaFisica= this.vdevol.part.pessoaFisica,
                                // sendData.vdevol.cnpjcpf= this.vdevol.part.cnpjcpf,
                                // sendData.vdevol.nome= this.vdevol.part.nome,
                                // sendData.vdevol.endereco= this.vdevol.part.endereco,
                                // sendData.vdevol.nr= this.vdevol.part.nr,
                                // sendData.vdevol.bairro= this.vdevol.part.bairro,
                                // sendData.vdevol.cep= this.vdevol.part.cep,
                                // sendData.vdevol.complemento= this.vdevol.part.complemento,
                                // sendData.vdevol.codmun= this.vdevol.part.codmun,
                                // sendData.vdevol.uf= this.vdevol.part.uf,
                                sendData.vdevol.codnates = null;
                                sendData.vdevol.lancamentodevol = _this5.vdevol.lancamentodevol;
                                sendData.vdevol.codvabertura = _this5.vdevol.codvabertura;
                                sendData.vdevol.itens = _this5.vdevol.itens;
                                // sendData.vdevol.pedvit.map(e=> {
                                //     e.valor = e.vlr
                                //     delete e.vlr
                                //     })

                                metodo = 'post';
                                update = false;


                                if (_this5.crud == __WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].crudUpdate) {
                                    update = true;
                                }
                                _context2.next = 13;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this5.$store, modulo, sendData, metodo);

                            case 13:
                                data = _context2.sent;

                                console.log(data);
                                if (data.errmessages) {
                                    _this5.errmessages = data.errmessages;
                                    _this5.$erpToastError('Alguns erros precisam ser corrigidos.');
                                } else {
                                    if (update) {
                                        _this5.$erpToastUpdated();
                                        _this5.$router.push('/varejo/devolucaolist');
                                    } else {
                                        _this5.$erpToastInserted();
                                        _this5.$router.push('/varejo/devolucaolist');
                                    }
                                    _this5.errmessages = [];
                                }

                            case 16:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this5);
            }))();
        },
        apiDelete: function apiDelete() {
            var _this6 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var modulo, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                modulo = 'varejo/devolucao/' + _this6.index;
                                _context3.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSdelete"])(_this6.$store, modulo);

                            case 3:
                                data = _context3.sent;

                                _this6.$erpToastDeleted();
                                _this6.closeForm();

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this6);
            }))();
        },
        situation: function situation(item) {
            return item == 'C' ? 'badge-danger' : 'badge-success';
        }
    },
    created: function created() {
        this.loadData(), this.$scrollTo(0);
    }
});

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_varejo_bar_top__ = __webpack_require__(2151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_customer_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__varejo_add_item__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__varejo_modal_opcoes__ = __webpack_require__(2155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__varejo_pag_form__ = __webpack_require__(2159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__varejo_vabertura_form__ = __webpack_require__(2171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__varejo_vmcaixa_form__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__varejo_emissao_cupom__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__varejo_modal_item_sequencia__ = __webpack_require__(2176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__varejo_modal_nfce__ = __webpack_require__(2183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_current_date_hour__ = __webpack_require__(2187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__varejo_modal_cliente__ = __webpack_require__(2191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__varejo_modal_vendas_vue__ = __webpack_require__(2195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api_api_pedido_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api_api_pedido_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__api_api_pedido_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_api_nfe_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_api_nfe_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__api_api_nfe_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_offline__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_offline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_offline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_cpf__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_cpf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__shared_cpf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_md_message_vue__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_sidebar_comandas_vue__ = __webpack_require__(2199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_produtos_destaques_vue__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__varejo_quantidade_item_vue__ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__varejo_modal_obs_vue__ = __webpack_require__(2211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__varejo_modal_caixa_vue__ = __webpack_require__(2215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__varejo_modal_pendcli_vue__ = __webpack_require__(2219);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

































//ALGUMAS CONFIGURACOES E PERMISSOES DO OPERADOR DO CAIXA
//DEFINIR A CARGA DESTAS INFORMACOES AO INICIAR A TELA DE FRENTE DE CAIXA
var PARAMS_CAIXA = {
  nome: "", //nome do operador
  codfil: "1",
  permissoes: {
    qtparcelas: 12,
    alterapreco: true,
    cadastraprodutovenda: true,
    pdescontoitem: 10,
    pdescontovenda: 10,
    descontonavenda: true,
    descontonoitem: true,
    abrefechacaixa: true,
    cancelavenda: true,
    cancelaitem: true,
    recebecheque: true,
    sangria: true,
    valorsangria: 100
  },
  caixa: {
    codcaixa: 1, //codigo do caixa selecionado na abertura do caixa (tabela VCAIXA)
    descricao: "",
    agrupaprodutos: true,
    permitevendaespera: true,
    permitefiado: true,
    imprimedesconto: true,
    vendasimples: true,
    tokensat: "",
    senhasat: "",
    codmcaixa: 0, //CODIGO DO MOVIMENTO DE ABERTURA DO CAIXA (TABELA VMCAIXA)
    databerturacaixa: "",
    valoraberturacaixa: 0
  },
  tpag: {
    //TIPOS CORRESPONDENTES AO CAMPO FPAG.FORMAPAG
    dinheiro: "01",
    cheque: "02",
    credito: "03",
    debito: "04",
    creditoloja: "05",
    alimentacao: "10",
    refeicao: "11",
    presente: "12",
    combustivel: "13",
    boleto: "15",
    outros: "99"
  },
  listaFavoritos: [], //LISTA DE PRODUTOS FAVORITOS
  selectedItem: {}
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},

  components: {
    VarejoAddItem: __WEBPACK_IMPORTED_MODULE_5__varejo_add_item__["a" /* default */],
    VarejoPagForm: __WEBPACK_IMPORTED_MODULE_7__varejo_pag_form__["a" /* default */],
    VarejoModalOpcoes: __WEBPACK_IMPORTED_MODULE_6__varejo_modal_opcoes__["a" /* default */],
    CustomerForm: __WEBPACK_IMPORTED_MODULE_4__forms_customer_form__["default"],
    VarejoVmCaixaForm: __WEBPACK_IMPORTED_MODULE_9__varejo_vmcaixa_form__["a" /* default */],
    VarejoVaberturaForm: __WEBPACK_IMPORTED_MODULE_8__varejo_vabertura_form__["a" /* default */],
    VarejoBarTop: __WEBPACK_IMPORTED_MODULE_3__components_varejo_bar_top__["a" /* default */],
    VarejoEmissaoCupom: __WEBPACK_IMPORTED_MODULE_10__varejo_emissao_cupom__["a" /* default */],
    MdMessage: __WEBPACK_IMPORTED_MODULE_20__components_md_message_vue__["default"],
    currentDateHour: __WEBPACK_IMPORTED_MODULE_13__components_current_date_hour__["a" /* default */],
    SidebarComandas: __WEBPACK_IMPORTED_MODULE_21__components_sidebar_comandas_vue__["a" /* default */],
    VarejoModalItemSequencia: __WEBPACK_IMPORTED_MODULE_11__varejo_modal_item_sequencia__["a" /* default */],
    VarejoModalNfce: __WEBPACK_IMPORTED_MODULE_12__varejo_modal_nfce__["a" /* default */],
    VarejoModalPendcli: __WEBPACK_IMPORTED_MODULE_26__varejo_modal_pendcli_vue__["a" /* default */],
    ProdutosDestaques: __WEBPACK_IMPORTED_MODULE_22__components_produtos_destaques_vue__["a" /* default */],
    VarejoModalCliente: __WEBPACK_IMPORTED_MODULE_14__varejo_modal_cliente__["a" /* default */],
    VarejoQuantidadeItem: __WEBPACK_IMPORTED_MODULE_23__varejo_quantidade_item_vue__["a" /* default */],
    VarejoModalObs: __WEBPACK_IMPORTED_MODULE_24__varejo_modal_obs_vue__["a" /* default */],
    VarejoModalVendas: __WEBPACK_IMPORTED_MODULE_15__varejo_modal_vendas_vue__["a" /* default */],
    VarejoModalCaixa: __WEBPACK_IMPORTED_MODULE_25__varejo_modal_caixa_vue__["a" /* default */],
    isValidHashColor: __WEBPACK_IMPORTED_MODULE_1__shared_utils__["isValidHashColor"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_16__api_api_pedido_js___default.a, __WEBPACK_IMPORTED_MODULE_18_vue_offline__["VueOfflineMixin"], __WEBPACK_IMPORTED_MODULE_17__api_api_nfe_js___default.a],

  data: function data() {
    return {
      index: null,
      runningItemRequest: false,
      filaRequicaoItens: [],
      showModalObs: "",
      windowListener: "",
      comandas: "",
      showModalMesa: false,
      showModalComanda: false,
      codmesa: "",
      mesaobs: "",
      codcomanda: "",
      windowHeight: "",
      inFocus: false,
      showFullScreenRequest: true,
      selectedMesa: false,
      deletarCliente: false,

      showMesaObs: false,

      showModalnfce: false,

      shortcuts: "",
      crud: "",
      crudText: "",
      listSequence: 0, //Exibe sequencia na lista de itens
      view: false, //variavel para controle de visualizacao ou edicao
      modoView: false,
      formItemsPedido: true, //exibe a lista de itens
      showPartForm: false, //exibe o formulario de cliente para inclusao
      showTotal: false,
      showModalDesconto: false,
      showModalAcrescimo: false,
      CANCEL_MESSAGE: false,
      SHOW_CONFIRMADMINPASS: false,
      adminPass: "",
      isValidCabec: true,

      //entidades
      filial: {},
      params_pdv: {},
      savedOrder: null,
      pedv: [_extends({}, this.$store.getters.getEntities.pedv)],
      pedvit: [],
      pedvpar: [], //parcelas do pedido
      vmovcaixa: {},
      pedvit_update: {},
      pedvit_beforeUpdate: {},
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: {}, //armazena as mensagens de validacao do pedido de venda apos a gravacao
      params_confirmAdminPass: "",
      item_editing: false,
      showModalCliente: false,
      pedvit_index: "",
      listaComandas: [],

      moreActions: [], //botao mais acoes

      vabertura: null,

      showPagamentoVenda: false,
      showVAbertura: false,
      showVmovCaixaForm: false,
      showEmissaoCupom: false,
      showEmissaoCupomVmov: false,

      paramsPagamento: {},
      paramsvmovcaixa: {},

      unwatch: true,

      selectedItem: {}, //item selecionado na pesquisa
      coditem: "",

      editItemValue: null, // valor do item modal
      showModalEditItem: false,
      errMessageModalEditItem: "",
      modalCrud: "",
      messageCallModal: "",

      showViewItem: false,
      itemView: [],

      codpart: null,
      selectedPart: null,

      action: "",
      finalizaVendaAction: null,

      urlimage: this.$store.getters.urlApp + "logo/download/6/1",

      showSidebar: false,
      showDestaques: false,

      pdesc: 0,
      vlrdesc: 0,
      pdesp: 0,
      vlrdesp: "",
      watching: "",

      showModalQtd: false,
      showVendas: false,
      showCaixa: false,
      showModalPendcli: false,

      qtdItemInformada: 0,
      vlrItemInformado: 0,
      showModalMaisAcoes: false,
      vendaManual: false,
      item_waiting: false,
      informed_qt: false,
      cx_code: null,
      caixa: null
    };
  },


  computed: {
    listMesas: function listMesas() {
      var mesas = [];
      if (this.params_pdv.listMesas) {
        mesas = this.params_pdv.listMesas;
      } else {
        mesas.push({ descricao: null, id: null, obs: null });
      }
      if (!mesas.hasOwnProperty("pedidos")) {
        mesas.pedidos = [{}];
      }
      return mesas;
    },
    closeCaixa: function closeCaixa() {
      return this.showCaixa;
    },
    hasComandaControl: function hasComandaControl() {
      return this.params_pdv.tipo_controle_cm_ms == "CM";
    },
    hasMesaControl: function hasMesaControl() {
      return this.params_pdv.tipo_controle_cm_ms == "MS";
    },
    hasMesaComandaControl: function hasMesaComandaControl() {
      return this.params_pdv.tipo_controle_cm_ms == "MC";
    },
    logoStyle: function logoStyle() {
      if (!this.pedv || this.pedvit < 5 || this.pedv.pedvit < 5) {
        return "opacity: 20%; position:absolute; top:200px;";
      } else {
        return "opacity:8%; position:absolute; top:200px;";
      }
    },
    usuarionome: function usuarionome() {
      return this.$store.getters.getEnv.usuarionome;
    },

    isEmpty: function isEmpty() {
      if (jQuery.isEmptyObject(this.pedv)) {
        return true;
      } else {
        return !this.pedv.data;
      }
    },

    isView: function isView() {
      //NAO PERMITE ALTERACAO NO PEDIDO QUANDO HÁ TITULOS ENVIADOS, TITULOS BAIXADOS OU NOTA LANÇADA
      return this.view || this.pedv.stpedv != "D" && this.pedv.stpedv != "P" || this.pedv.fin_baixado > 0 || this.pedv.fin_remessa > 0 || this.pedv.nf_emitida > 0 || this.pedv.nf_pendente > 0;
    },

    listaItensPreferencias: function listaItensPreferencias() {
      return this.$store.getters.getItemSalesList;
    },

    part: function part() {
      if (this.$store.getters.getPart.length > 0) {
        return this.$store.getters.getPart[0];
      } else {
        return null;
      }
    },
    currentDate: function currentDate() {
      var data = new Date();
      return data;
    },

    disableTppedv: function disableTppedv() {
      //desabilita o campo tipo de documento este já for pedido de venda
      return this.pedv.tppedv === "P" && this.pedv.codpedv != null;
    },

    _cnpjcpf: function _cnpjcpf() {
      //FORMATACAO DO CNPJ DO CLIENTE
      var doc = "";
      if (this.pedv.part) {
        doc = this.pedv.part[0].cnpjcpf;
      }
      if (String(doc).length > 11) {
        doc = this.$formatCNPJ(doc);
      } else if (String(doc).length == 11) {
        doc = this.$formatCPF(doc);
      }
      return doc;
    },

    alterapreco: function alterapreco() {
      return this.params_pdv.altera_preco;
    },
    btnCustomStyle: function btnCustomStyle() {
      return "font-size:" + 5 + "px";
    }
  },

  filters: {
    format: function format(value, decimals) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatValue"])(value, decimals);
    },
    formatDataHora: function formatDataHora(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatDataHora"])(value);
    },


    formatDate: function formatDate(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["formatDate"])(value);
    }
  },

  methods: {
    focusItem: function focusItem() {
      var self = this;
      self.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
        if (self.$refs.item) self.$refs.item.focus();
      });
      self.inFocus = false;
    },
    handleConfig: function handleConfig() {
      this.showModalMaisAcoes = !this.showModalMaisAcoes;
    },
    handleSelectedOption: function handleSelectedOption(selected) {
      //RETORNO DO BOTAO MAIS OPCOES
      if (selected == 'fecharcaixa' || selected == 'sangrar' || selected == 'reforcar') {
        if (this.isVendaAberta()) {
          this.$erpToastWarning('Finalize a venda em andamento');
          return;
        }
      }

      this.showModalMaisAcoes = false;
      if (selected == 'fecharcaixa') this.handleFecharCaixa();else if (selected == 'sangrar') this.showConfirmAdminPass(this.handlerSangrar);else if (selected == 'reforcar') this.showConfirmAdminPass(this.handlerReforcar);else if (selected == 'excluir') this.handleShowModalEditItem('delete');else if (selected == 'mesacomanda')
        // params_pdv.tipo_controle_cm_ms == "CM" || params_pdv.tipo_controle_cm_ms == "MC"
        this.handleShowModalMesaComanda();else if (selected == 'destaques') this.handleShowDestaques();else if (selected == 'pendcli') this.handleShowPendcli();
    },
    handleShowPendcli: function handleShowPendcli() {
      this.showModalPendcli = true;
    },
    handleInformaMesa: function handleInformaMesa(_ref) {
      var obs = _ref.obs,
          mesa = _ref.mesa;

      this.closeModalObs();
      this.handleCloseComandas();
      this.novavenda();
      this.pedv.obspedido = obs;
      this.pedv.mesa = mesa;
    },
    handleShowMesaComanda: function handleShowMesaComanda(codmesa) {
      this.pedv.mesa = codmesa;
      if (this.hasMesaControl) {
        this.handleShowModalObs();
      } else {
        this.handleShowModalComanda();
      }
    },
    handlePdesp: function handlePdesp(newValue) {
      this.vlrdesp = 0;

      if (!this.watching) {
        this.watching = "P";
      }
      if (newValue && this.watching == "P") {
        this.vlrdesp = newValue * this.pedv.totmer / 100;
      } else {
        this.vlrdesp = 0;
      }

      this.watching = "";
    },
    handleVlrdesp: function handleVlrdesp(newValue) {
      this.pdesp = 0;

      if (!this.watching) {
        this.watching = "V";
      }

      if (newValue && this.watching == "V") {
        var lAux = this.pedv.totmer;

        lAux = (newValue ? newValue : 0) * 100 / lAux;

        this.pdesp = Math.round((lAux + Number.EPSILON) * 100) / 100;
      }

      this.watching = "";
    },
    handlePdesc: function handlePdesc(newValue) {
      this.vlrdesc = 0;

      if (!this.watching) {
        this.watching = "P";
      }
      if (newValue && this.watching == "P") {
        this.vlrdesc = newValue * this.pedv.totmer / 100;
      } else {
        this.vlrdesc = 0;
      }

      this.watching = "";
    },
    handleVlrDesc: function handleVlrDesc(newValue) {
      this.pdesc = 0;

      if (!this.watching) {
        this.watching = "V";
      }

      if (newValue && this.watching == "V") {
        var lAux = this.pedv.totmer;

        lAux = (newValue ? newValue : 0) * 100 / lAux;

        this.pdesc = Math.round((lAux + Number.EPSILON) * 100) / 100;
      }

      this.watching = "";
    },
    loadAbertura: function loadAbertura() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var codcaixa, caixaaberto;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //efetua a abertura do caixa
                codcaixa = null;
                caixaaberto = false;
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDS"])(_this.$store.getters.urlOrds + 'varejo/caixas', null, true).then(function (result) {
                  if (result.items.length == 1) {
                    if (result.items[0].uuid != _this.$store.getters.getEnv.uuid) {
                      return;
                    }
                    codcaixa = result.items[0].codvcaixa;
                    caixaaberto = result.items[0].caixaaberto == 'S';
                    _this.vabertura = result.items[0];
                  }
                });

              case 4:
                if (!caixaaberto) {
                  _this.handleAberturaCaixa();
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadFilial: function loadFilial() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDS"])(_this2.$store.getters.urlOrds + "cg/filial/varejo", null, true).then(function (result) {
                  if (result.items.length > 0) {
                    _this2.filial = result.items[0];
                    _this2.handleParamPDV();
                    _this2.loadLogoTipo();
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    closeModalObs: function closeModalObs() {
      this.showModalObs = false;
      this.$nextTick(function () {
        document.getElementById("searchComanda").focus();
      });
    },
    handleShowModalObs: function handleShowModalObs() {
      this.showModalObs = true;
    },
    closeModalQtd: function closeModalQtd() {
      this.showModalQtd = false;
      this.$nextTick(function () {
        this.$refs.item.focus();
      });
    },
    handleShowModalQtd: function handleShowModalQtd() {
      this.showModalQtd = true;
    },
    closeModalPendcli: function closeModalPendcli() {
      this.showModalPendcli = false;
    },
    handleChangeCodPart: function handleChangeCodPart(value) {
      if (!value) {
        this.selectedPart = null;
        this.codpart = null;
      } else {
        this.selectedPart = {};
        this.selectedPart.codpart = value;
        this.codpart = value;
      }
      this.carregaDadosCliente();

      if (!this.showPagamentoVenda) {
        this.$nextTick(function () {
          this.$refs.item.focus();
        });
      }
    },
    loadMesaComanda: function loadMesaComanda() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var param, _param, comandas;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                param = {};

                param.query = "";

                if (!(_this3.hasMesaControl || _this3.hasMesaComandaControl)) {
                  _context4.next = 5;
                  break;
                }

                _this3.listMesas.forEach(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(mesa, ind) {
                    var index, ped;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            param.query = "mesa=" + mesa.id + "&";

                            _context3.next = 3;
                            return _this3.$store.dispatch("loadPedvList", param);

                          case 3:

                            mesa.pedidos = [].concat(_toConsumableArray(_this3.$store.getters.getPedvList));

                            for (index = 0; index < mesa.pedidos.length; index++) {
                              ped = mesa.pedidos[index];


                              if (_this3.hasMesaComandaControl && (ped.comanda == null || ped.comanda == "" || !ped.comanda)) {
                                mesa.pedidos.splice(index, 1);
                                index--;
                              } else if (_this3.hasMesaControl && ped.comanda) {
                                mesa.pedidos.splice(index, 1);
                                index--;
                              } else if (ped.stpedv != "D") {
                                mesa.pedidos.splice(index, 1);
                                index--;
                              }
                            }

                          case 5:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  }));

                  return function (_x, _x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());
                return _context4.abrupt("return");

              case 5:
                if (!_this3.hasComandaControl) {
                  _context4.next = 16;
                  break;
                }

                _param = {};

                _param.query = "";

                _param.query = "comanda=" + "-1" + "&";

                _context4.next = 11;
                return _this3.$store.dispatch("loadPedvList", _param);

              case 11:
                comandas = [];

                _this3.listaComandas = [];
                _this3.$store.getters.getPedvList.forEach(function (comanda, index) {
                  if (comanda.stpedv == "D" && !comanda.mesa) {
                    comandas.push({
                      codpedv: comanda.codpedv,
                      comanda: comanda.comanda,
                      stpedv: comanda.stpedv,
                      data: comanda.data
                    });
                  } else {
                    return;
                  }
                });

                _this3.listaComandas = comandas;
                return _context4.abrupt("return");

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    handleCancelInput: function handleCancelInput(index) {
      this.$set(this.params_pdv.listMesas[index], "showObs", false);
      this.mesaobs = "";
      this.$nextTick(function () {
        this.$refs.inputmesa.focus();
      });
    },
    handleChangeMesa: function handleChangeMesa(index) {
      var _this4 = this;

      var mesaIndex = "";
      if (index || index == 0) {
        mesaIndex = index;
        this.codmesa = this.params_pdv.listMesas[mesaIndex].id;
      } else {
        this.params_pdv.listMesas.find(function (e, i) {
          if (e.id == _this4.codmesa) {
            mesaIndex = i;
          }
        });
      }

      this.$set(this.params_pdv.listMesas[mesaIndex], "showObs", true);

      if (this.hasMesaComandaControl) {
        this.$nextTick(function () {
          this.$refs.confirmMesaBtn.focus();
        });
      }

      var self = this;
      if (this.params_pdv.listMesas[mesaIndex].showObs) {
        self.$nextTick(function () {
          self.$refs.mesaobs[0].focus();
        });
      }
    },
    handleInformaComanda: function handleInformaComanda() {
      this.showModalComanda = false;
      if (!this.codcomanda) {
        this.$erpToastError("Campo o obrigatorio");
        return;
      }

      this.novavenda();

      this.pedv.mesa = this.codmesa;
      this.pedv.comanda = this.codcomanda;

      this.$nextTick(function () {
        this.$refs.inputmesa.focus();
      });
      this.handleCloseComandas();
    },
    handleCloseModalComanda: function handleCloseModalComanda() {
      this.showModalComanda = false;
      this.codcomanda = "";

      this.$nextTick(function () {
        document.getElementById("searchComanda").focus();
      });

      if (this.showViewItem) {
        this.showViewItem = false;
      }
    },
    handleShowModalComanda: function handleShowModalComanda() {
      this.showModalComanda = true;

      this.$nextTick(function () {
        this.$refs.comandaid.focus();
      });
    },
    handleCloseModalMesa: function handleCloseModalMesa() {
      this.showModalMesa = false;
      this.codmesa = "";
      this.mesaobs = "";

      this.listMesas.forEach(function (mesa) {
        mesa.showObs = false;
      });

      this.$nextTick(function () {
        document.getElementById("searchComanda").focus();
      });

      if (this.showViewItem) {
        this.showViewItem = false;
      }
    },
    handleShowModalMesa: function handleShowModalMesa() {
      this.loadMesaComanda();
      this.showModalMesa = true;
      this.codmesa = "";
      this.mesaobs = "";

      this.listMesas.forEach(function (mesa) {
        if (mesa.showObs) mesa.showObs = false;
      });

      this.$nextTick(function () {
        this.$refs.inputmesa.focus();
      });
    },
    handleModalCliente: function handleModalCliente(deletar) {
      if (!this.isVendaAberta()) {
        this.$erpToastWarning("Inicie uma venda");
        return;
      }
      if (deletar) {
        this.deletarCliente = deletar;
      }
      this.showModalCliente = true;
    },
    closeModalCliente: function closeModalCliente() {
      this.showModalCliente = false;

      if (this.showPagamentoVenda) {
        if (document.getElementById("btnPaymentDone")) document.getElementById("btnPaymentDone").focus();else if (document.getElementById("paymentType")) document.getElementById("paymentType").focus();
      } else this.focusItem();
    },
    closeModalDescontoAcrescimo: function closeModalDescontoAcrescimo() {
      if (this.showModalAcrescimo) {
        this.showModalAcrescimo = false;
      }
      if (this.showModalDesconto) {
        this.showModalDesconto = false;
      }
    },
    loadLogoTipo: function loadLogoTipo() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var self;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                self = _this5;
                _context5.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSmidia"])(_this5.$store.getters.urlApp + "logo/download/" + _this5.filial.codempresa + "/" + _this5.filial.codfil).then(function (data) {
                  if (data && data.size > 0) {
                    var reader = new window.FileReader();
                    reader.readAsDataURL(data);
                    reader.onload = function () {
                      self.$set(self.filial, "urlimage", reader.result);
                    };
                  }
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    showModalViewItem: function showModalViewItem(itemssearch) {
      var _this6 = this;

      this.showViewItem = true;
      if (this.$refs.btnClose) {
        this.$nextTick(function () {
          _this6.$refs.btnClose.focus();
        });
      }

      if (itemssearch[0]) {
        this.itemView = itemssearch[0];
        return;
      } else {
        this.itemView = itemssearch;
      }
    },
    handleViewItem: function handleViewItem() {
      var _this7 = this;

      if (!this.showViewItem) {
        return;
      }

      this.showViewItem = false;

      this.$nextTick(function () {
        _this7.$refs.item.focus();
      });
    },
    handleInputModalEditIt: function handleInputModalEditIt() {
      if (!this.showModalEditItem) return;

      if (this.editItemValue > this.pedvit.length) {
        if (this.editItemValue == null || this.editItemValue == 0) {
          return this.errmessages = "";
        } else {
          this.errMessageModalEditItem = "Valor não permitido";
        }
      } else {
        this.errMessageModalEditItem = "";
      }
    },
    closeModalEditItem: function closeModalEditItem() {
      var _this8 = this;

      if (this.showModalEditItem) this.showModalEditItem = false;
      this.editItemValue = null;
      this.modalCrud = null;
      this.$nextTick(function () {
        _this8.$refs.item.focus();
      });
    },
    handleShowModalEditItem: function handleShowModalEditItem(crud) {
      if (!this.isVendaAberta()) {
        this.$erpToastWarning("Inicie uma venda");
        return;
      }
      if (this.runningItemRequest || this.filaRequicaoItens.length > 0) {
        this.$erpToastError("Não foi possivel realizar Aguarde até que todos os intens sejam inseridos");
        return;
      }
      this.showModalEditItem = true;
      this.modalCrud = crud;
    },
    handlerSangrar: function handlerSangrar() {
      this.handleVmovCaixaForm("S");
    },
    handlerReforcar: function handlerReforcar() {
      this.handleVmovCaixaForm("E");
    },
    confirmAdminPass: function confirmAdminPass() {
      this.SHOW_CONFIRMADMINPASS = false;
      this.params_confirmAdminPass();
    },
    showConfirmAdminPass: function showConfirmAdminPass(params) {
      this.SHOW_CONFIRMADMINPASS = true;
      this.params_confirmAdminPass = params;
    },
    hideConfirmAdminPass: function hideConfirmAdminPass() {
      this.SHOW_CONFIRMADMINPASS = false;
      this.$nextTick(function () {
        this.$refs.item.focus();
      });
    },
    handleShowModalMesaComanda: function handleShowModalMesaComanda() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this9.params_pdv.tipo_controle_cm_ms) {
                  _context6.next = 3;
                  break;
                }

                _this9.$erpToastError("Habilite o parâmetro para controle de mesas ou comandas");
                return _context6.abrupt("return");

              case 3:
                _context6.next = 5;
                return _this9.loadMesaComanda();

              case 5:
                _this9.showSidebar = true;

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    handleCloseComandas: function handleCloseComandas() {
      this.showSidebar = false;
      this.$nextTick(function () {
        this.$refs.item.focus();
      });
      if (this.showViewItem) {
        this.showViewItem = false;
      }
    },
    handleFecharCaixa: function handleFecharCaixa() {
      if (this.showCaixa) {
        this.showCaixa = false;
      } else {
        this.showCaixa = true;
      }
      // this.$router.push(`/varejo/controlecaixa/${this.vabertura.codvabertura}`);
      // let body = document.querySelector("body");
      // body.style.overflow = "auto";
    },
    handleClosePDV: function handleClosePDV() {
      this.$router.push("/varejolist");
    },
    getAction: function getAction(action) {
      //executa a acao dos botoes do menu
      this.action = action;
    },
    handleParamPDV: function handleParamPDV() {
      if (this.filial && this.filial.parametros_pdv) {
        this.params_pdv = JSON.parse(this.filial.parametros_pdv);
        this.vendaManual = this.params_pdv.formato_venda_manual == 'S';
        this.loadMesaComanda();
      } else {
        this.params_pdv = _extends({}, this.$store.getters.getParamPDV);
      }
    },
    calculaPercentualAcrescimo: function calculaPercentualAcrescimo() {
      this.pedv.pdesp_aux = 0;
      this.pedv.vlrdesp_aux = 0;
      this.pedv.pdesp = 0;
      if (this.pedv.totmer > 0) {
        var lAux = this.pedv.vlrdesp * 100 / this.pedv.totmer;
        lAux = Math.round((lAux + Number.EPSILON) * 100) / 100;
        this.pedv.pdesp = lAux;
        this.pdesp = lAux;
      }
    },
    calculaPercentualDesconto: function calculaPercentualDesconto() {
      this.pedv.pdesc_aux = 0;
      this.pedv.vlrdesc_aux = 0;
      this.pedv.pdesc = 0;
      if (this.pedv.totmer > 0) {
        var lAux = this.pedv.vlrdesc * 100 / this.pedv.totmer;
        lAux = Math.round((lAux + Number.EPSILON) * 100) / 100;
        this.pedv.pdesc = lAux;
        this.pdesc = lAux;
      }
    },
    handleInformarDesconto: function handleInformarDesconto() {
      if (!this.isVendaAberta()) {
        this.$erpToastWarning("Inicie uma venda");
        return;
      }

      if (this.params_pdv.permite_desconto != 'S' && this.params_pdv.permite_acrescimo != 'S') {
        this.$erpToastWarning("Não é permitido");
        return;
      }

      this.vlrdesc = this.pedv.vlrdesc;
      this.vlrdesp = this.pedv.vlrdesp;

      this.calculaPercentualDesconto();
      this.calculaPercentualAcrescimo();

      if (this.showModalDesconto) {
        this.showModalDesconto = false;
      } else {
        this.showModalDesconto = true;

        this.$nextTick(function () {
          this.$refs.desconto.focus();
        });
      }
    },
    handleDesconto: function handleDesconto() {
      // Desconto
      this.pedv.pdesc_aux = this.pdesc;
      this.pedv.vlrdesc_aux = this.vlrdesc;

      console.log(parseFloat(this.params_pdv.desconto_max));
      console.log(parseFloat(this.pedv.pdesc_aux));

      if (this.params_pdv.desconto_max) {
        if (parseFloat(this.pedv.pdesc_aux) > parseFloat(this.params_pdv.desconto_max)) {
          this.showModalDesconto = true;
          this.$erpToastError("Desconto maior que o máximo permitido (" + this.params_pdv.desconto_max + ")!");
          return;
        }
      }

      this.pedv.vlrdesc = Number(Math.round(this.pedv.vlrdesc_aux * 100) / 100);
      this.pedv.pdesc = Math.round((this.pedv.pdesc_aux + Number.EPSILON) * 100) / 100;

      // Acrescimo

      this.pedv.pdesp_aux = this.pdesp;
      this.pedv.vlrdesp_aux = this.vlrdesp;

      if (this.pedv.pdesp_aux > this.params_pdv.acrescimo_max) {
        this.$erpToastError("Acrescimo maior que o máximo permitido (" + this.params_pdv.acrescimo_max + "%)! ");
        return;
      }

      this.pedv.vlrdesp = Number(Math.round(this.pedv.vlrdesp_aux * 100) / 100);
      this.pedv.pdesp = Math.round((this.pedv.pdesp_aux + Number.EPSILON) * 100) / 100;

      this.showModalDesconto = false;

      this.pedv.totger = this.pedv.totmer + (this.pedv.vlrdesp ? this.pedv.vlrdesp : 0) - (this.pedv.vlrdesc ? this.pedv.vlrdesc : 0);

      if (this.showPagamentoVenda) {
        this.paramsPagamento.totalVenda = this.pedv.totger;
        this.$refs.pagamentoVenda.handleLimparPag();
      } else this.focusItem();

      //DISPARA O TIMER PARA GRAVACAO DO PEDIDO
      var vm = this;
      if (this.apiTimer) {
        clearTimeout(this.apiTimer);
      }
      this.apiTimer = setTimeout(function () {
        vm.gravaItem(false, false);
      }, 1000);
    },
    calculaItem: function calculaItem(novoitem) {
      this.pedv.totmer = 0;
      this.pedv.totger = 0;

      for (var x = 0; x < this.pedvit.length; x++) {
        var lAux = 0.0;
        lAux = this.pedvit[x].qtuni * this.pedvit[x].vlr;
        lAux = Math.round((lAux + Number.EPSILON) * 100) / 100;
        this.pedvit[x].totbru = lAux;

        lAux = lAux * ((100 - (this.pedvit[x].pdesc1 ? this.pedvit[x].pdesc1 : 0)) / 100);

        lAux = Math.round((lAux + Number.EPSILON) * 100) / 100;
        this.pedvit[x].totliq = lAux;

        this.pedvit[x].totdes = this.pedvit[x].totbru - this.pedvit[x].totliq;

        this.pedv.totmer = this.pedv.totmer + this.pedvit[x].totbru;
        this.pedv.totger = this.pedv.totger + this.pedvit[x].totliq;
      }

      this.pedv.totger = this.pedv.totger + (this.pedv.vlrdesp ? this.pedv.vlrdesp : 0) - (this.pedv.vlrdesc ? this.pedv.vlrdesc : 0);

      this.pedv.totdes = this.pedv.totger - this.pedv.totmer - this.pedv.vlrdesp;

      if (novoitem) {
        //ao incluir novo produto, zera o desconto ou acrescimo informado no total da venda
        this.pedv.pdesc = 0;
        this.pedv.pdesp = 0;
        this.pedv.vlrdesc = 0;
        this.pedv.vlrdesp = 0;
        this.vlrdesc = 0;
        this.vlrdesp = 0;
        this.pdesc = 0;
        this.pdesp = 0;
      }

      this.calculaPercentualDesconto();
      this.calculaPercentualAcrescimo();
    },


    statusColor: function statusColor(value) {
      var color = "badge-green";
      if (value == "C") {
        color = "badge-red";
      } else if (value == "D") {
        color = "badge-orange";
      }
      return color;
    },

    closeForm: function closeForm() {
      if (this.$route.params && this.$route.params.novo) {
        this.$router.push("/pedidolist");
        var body = document.querySelector("body");
        body.style.overflow = "auto";
      } else {
        this.$emit("closeform");
      }
    },
    closePartForm: function closePartForm(id) {
      //ao fechar o formulario de inclusao de clientes
      if (id) this.pedv.codpart = id;
      this.showPartForm = false;
    },
    closeNfForm: function closeNfForm() {
      //ao fechar o formulario de faturamento
      this.showNfForm = false;
    },
    handleNewItem: function handleNewItem(selectedItem) {
      //AO SELECIONAR UM ITEM NA PESQUISA, ADICIONA O ITEM NA VENDA
      if (!selectedItem) {
        return;
      }
      if (this.isEmpty) {
        this.handleNovaVenda();
      }
      if ((this.hasMesaComandaControl || this.hasMesaControl) && !this.pedv.mesa && !this.pedv.codpedv) {
        this.handleNovaVenda();
        return;
      }
      if (this.hasComandaControl && !this.pedv.comanda && !this.pedv.codpedv) {
        this.handleNovaVenda();
        return;
      }

      if (this.qtdItemInformada) {
        selectedItem.quantidade = this.qtdItemInformada;
      }

      if (this.vlrItemInformado) {
        selectedItem.vlrtab = this.vlrItemInformado;
      }

      if (this.pedv.stpedv != "D" && this.pedv.stpedv != "P") {
        return;
      }

      if (!selectedItem.vlrtab) {
        selectedItem = {};
        this.selectedItem = {};
        this.$erpToastError("Não é possivel inserir itens com valor zerado. Verificar tabela de preço");
        return;
      }

      this.showViewItem = true;
      this.itemView = selectedItem;

      //ADICIONA O ITEM NO ARRAY pedvit_update
      this.pedvit_update = _extends({}, this.$store.getters.getEntities.pedvit), this.pedvit_update.coditem = selectedItem.coditem;
      this.pedvit_update.descricao = selectedItem.descricao;
      this.pedvit_update.item = [];
      this.pedvit_update.item.push({
        descricao: selectedItem.descricao,
        codigo: selectedItem.codigo
      });
      this.pedvit_update.coditemgrade = selectedItem.coditemgrade;
      this.pedvit_update.uni = selectedItem.uni;
      this.pedvit_update.vlr = selectedItem.vlrtab;
      this.pedvit_update.qtuni = selectedItem.quantidade;
      this.pedvit_update.obs = selectedItem.obs;

      // Adiciona item que acaba de ser incluido na rotina da fila de requisição
      this.filaRequicaoItens.push(this.pedvit_update);

      this.calculaItem(true);

      //DISPARA O TIMER PARA GRAVACAO DO PEDIDO
      var vm = this;
      if (this.apiTimer) {
        clearTimeout(this.apiTimer);
      }

      this.apiTimer = setTimeout(function () {
        vm.gravaItem(false, false);
      }, 500);

      this.coditem = null;
      this.qtdItemInformada = 0;
      this.informed_qt = false;

      if (this.vendaManual) {
        this.$nextTick(function () {
          this.itemView = {};
          this.vlrItemInformado = 0;
          this.selectedItem = {};
          this.showViewItem = false;
        });
        this.focusItem();
      }
    },
    selectNewItem: function selectNewItem(selectedItem) {
      //AO SELECIONAR UM ITEM NA PESQUISA, ADICIONA O ITEM NA VENDA
      if (this.qtdItemInformada) {
        selectedItem.quantidade = this.qtdItemInformada;
      }

      if (selectedItem.vlrtab) {
        this.vlrItemInformado = selectedItem.vlrtab;
      }

      this.item_waiting = true;
      this.showViewItem = true;
      this.selectedItem = selectedItem;
      this.itemView = selectedItem;
      this.$nextTick(function () {
        this.$refs.qtdItemInformada.focus();
      });
    },
    handleTypeofSell: function handleTypeofSell(selectedItem) {
      if (this.vendaManual) {
        this.selectNewItem(selectedItem);
      } else {
        this.handleNewItem(selectedItem);
      }
    },
    handleQtd: function handleQtd(selectedQt) {
      if (selectedQt) {
        this.qtdItemInformada = selectedQt;
        this.informed_qt = true;
      }
    },
    handleModalVendasEspera: function handleModalVendasEspera() {
      if (this.showVendas) {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip('dispose').removeAttr('data-toggle');
        });
        this.showVendas = false;
        this.focusItem();
      } else {
        this.showVendas = true;
      }
    },
    handleResult: function handleResult(params, result) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(result == "OK")) {
                  _context7.next = 17;
                  break;
                }

                if (!params) {
                  _context7.next = 17;
                  break;
                }

                _context7.next = 4;
                return _this10.$store.dispatch("loadPedv", { id: params });

              case 4:
                if (!_this10.$store.getters.getPedv) {
                  _context7.next = 15;
                  break;
                }

                _this10.pedv = _extends({}, _this10.$store.getters.getPedv[0]);
                _this10.pedvit = _this10.pedv.pedvit;

                if (_this10.pedv.pedvpar) {
                  _this10.pedvpar = _this10.pedv.pedvpar;
                }
                _this10.selectedPart = null;
                _this10.codpart = _this10.pedv.codpart;
                _this10.carregaDadosCliente();

                if (!_this10.pedv.codnf) {
                  _context7.next = 15;
                  break;
                }

                _context7.next = 14;
                return _this10.$store.dispatch("loadNf", { id: _this10.pedv.codnf });

              case 14:
                if (_this10.$store.getters.getNf) {
                  _this10.pedv.nf = _extends({}, _this10.$store.getters.getNf[0]);
                }

              case 15:

                _this10.showViewItem = false;
                _this10.$nextTick(function () {
                  this.$refs.item.focus();
                });

              case 17:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this10);
      }))();
    },
    handleVmovCaixaForm: function handleVmovCaixaForm(valuetpmovcaixa) {
      this.paramsvmovcaixa.tpmovcaixa = valuetpmovcaixa;
      this.paramsvmovcaixa.codvabertura = this.vabertura.codvabertura;
      this.showVmovCaixaForm = true;
    },
    handleResultadoVmovCaixaForm: function handleResultadoVmovCaixaForm(paramvmovcaixa, result) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var vmovc;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this11.showVmovCaixaForm = false;

                if (!(result == "RETORNA")) {
                  _context8.next = 3;
                  break;
                }

                return _context8.abrupt("return");

              case 3:

                if (result == "OK") {
                  if (paramvmovcaixa) {
                    vmovc = paramvmovcaixa;

                    vmovc.codvabertura = _this11.vabertura.codvabertura;

                    _this11.apiVarejoVMovCaixa(vmovc, false, _this11.responseVmovcaixa);
                  }
                }

                _this11.$nextTick(function () {
                  _this11.$refs.item.focus();
                });

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this11);
      }))();
    },
    responseVmovcaixa: function responseVmovcaixa(vmovcaixa, errmessages) {
      this.errmessages = errmessages;

      if (this.errmessages == null || this.errmessages.length <= 0) {
        this.vmovcaixa = vmovcaixa;
        this.showEmissaoCupomVmov = true;
      } else {
        for (var x = 0; x < this.errmessages.errmessages.length; x++) {
          this.$erpToastError(this.errmessages.errmessages[x]);
        }

        this.errmessages = {};
      }
    },
    handleAberturaCaixa: function handleAberturaCaixa() {
      this.showVAbertura = true;
    },
    handleResultadoVabertura: function handleResultadoVabertura(paramvabertura, result) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var body, vabertura, sendData, metodo, endpoint, data;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(result == "RETORNA")) {
                  _context9.next = 5;
                  break;
                }

                _this12.$router.push("/varejolist");
                body = document.querySelector("body");

                body.style.overflow = "auto";
                return _context9.abrupt("return");

              case 5:
                vabertura = null;


                if (result == "TROCARUSUARIO") {
                  vabertura = _this12.vabertura;
                  vabertura.aberto = "S";
                  vabertura.dtfechamento = null;
                }

                if (result == "OK") {
                  if (paramvabertura) {
                    vabertura = paramvabertura;
                    vabertura.aberto = "S";
                    vabertura.dtfechamento = null;
                    if (vabertura.aberturadecaixa) vabertura.codvabertura = null;
                  }
                }

                if (!vabertura) {
                  _context9.next = 23;
                  break;
                }

                sendData = { vabertura: vabertura };
                metodo = "post";
                endpoint = 'varejo/vabertura/';

                if (vabertura.codvabertura) endpoint += vabertura.codvabertura;else endpoint += '0';

                _context9.next = 15;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this12.$store, endpoint, sendData, metodo).then();

              case 15:
                data = _context9.sent;

                if (data.items) {
                  _context9.next = 19;
                  break;
                }

                _this12.$router.push('/varejolist');
                return _context9.abrupt("return");

              case 19:

                _this12.vabertura = data.items[0];
                _this12.showVAbertura = false;
                _this12.$erpToastSuccess("Abertura do caixa efetuada com sucesso");

                _this12.$nextTick(function () {
                  this.$refs.item.focus();
                });

              case 23:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this12);
      }))();
    },
    PDFResponseCallbackSAT: function PDFResponseCallbackSAT(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO SAT
      if (response.status != "success") {
        this.$erpToastError(response.message);
      }
    },
    handleClickImprimir: function handleClickImprimir() {
      if (this.pedv.nf) {
        if (this.pedv.nf.esp == "59") {
          var paramsimp = "&codnf=" + this.pedv.nf.codnf;
          this.$executaExtensaoChromeSAT(this.pedv.nf.codnf, "imp", this.PDFResponseCallbackSAT, paramsimp);
          return;
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiDownloadPDF"])(this, "print/danfe/" + this.pedv.nf.codnf, null, null, true, null, true);
        }
      } else {
        if (!this.pedv.codpedv) {
          this.$erpToastError("Pedido não informado");
          return;
        } else {
          this.showEmissaoCupomVmov = false;
          this.savedOrder = this.pedv.codpedv;
          this.showEmissaoCupom = true;
        }
      }
    },
    handleShowDestaques: function handleShowDestaques() {
      this.showDestaques = true;
    },
    handleCloseDestaques: function handleCloseDestaques() {
      this.showDestaques = false;
      this.$nextTick(function () {
        this.$refs.item.focus();
      });
    },
    handleClickPagamento: function handleClickPagamento() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (_this13.isVendaAberta()) {
                  _context10.next = 3;
                  break;
                }

                _this13.$erpToastWarning("Inicie uma venda");
                return _context10.abrupt("return");

              case 3:
                _context10.next = 5;
                return _this13.gravaItem(false, false);

              case 5:
                if (!_this13.errmessages || !_this13.errmessages.errmessages || _this13.errmessages.errmessages.length < 0) {
                  _this13.paramsPagamento = {
                    totalVenda: _this13.pedv.totger,
                    data: _this13.pedv.data,
                    codpart: _this13.codpart,
                    email: _this13.pedv.emaildanfe,
                    pedv: _this13.pedv,
                    pedvit: _this13.pedvit,
                    paramscaixa: PARAMS_CAIXA
                  };
                  _this13.showPagamentoVenda = true;
                }

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this13);
      }))();
    },
    handleResultadoPagamento: function handleResultadoPagamento(listPagamentos, selectedPart, email, result) {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                //TRATA O RESULTADO DO PAGAMENTO DA VENDA
                //COLOCA VENDA EM ESPERA
                //ENCERRA A VENDA COM O PAGAMENTO

                // if (selectedPart) {
                //   if (selectedPart.codpart)
                //     this.codpart = selectedPart.codpart;
                //   else
                //     this.codpart = selectedPart.cnpjcpf;
                //   await this.carregaDadosCliente();
                //   this.pedv.codpart = selectedPart.codpart;
                //   this.pedv.cpfcnpj = selectedPart.cnpjcpf;
                // }

                _this14.pedv.emaildanfe = email;

                if (!(result == "RETORNAVENDA")) {
                  _context11.next = 5;
                  break;
                }

                _this14.showPagamentoVenda = false;
                _this14.$nextTick(function () {
                  this.$refs.item.focus();
                });
                return _context11.abrupt("return");

              case 5:
                if (result) {
                  _context11.next = 7;
                  break;
                }

                return _context11.abrupt("return");

              case 7:

                _this14.finalizaVendaAction = result;
                _this14.savedOrder = _this14.pedv.codpedv;
                _this14.pedv.listPagamentos = listPagamentos;
                _this14.pedv.vendaFinalizada = true;
                _this14.handleGravaPedido(false);

              case 12:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this14);
      }))();
    },
    executaSAT: function executaSAT() {
      this.autorizaNFeSAT(this.pedv.nf, this.NFeResponseCallbackSAT);
    },
    NFeResponseCallbackSAT: function NFeResponseCallbackSAT(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO SAT

      if (response.status != "success") {
        this.$erpToastError(response.message);
      } else {
        if (response.response.nf.length > 0 && response.response.nf[0].cstat == "100") {
          this.handleGravaPedido(false);
          this.$erpToastSuccess("SAT Autorizado");
        } else {
          this.pedv.nf.xmotivo = response.response.xmotivo;
          this.$erpToastError(response.response.xmotivo);
        }
      }
      this.index = this.pedv.codpedv;
      this.limparTela();
    },
    NFeResponseCallbackA3: function NFeResponseCallbackA3(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
      var rejeitada = false;
      var msg = [];
      this.errmessages = {};

      if (response.status != "success") {
        this.$erpToastError(response.message);
      } else {
        if (response.response.nf.length > 0 && response.response.nf[0].cstat == "100") {
          this.$erpToastSuccess("NFe Autorizada");
          rejeitada = false;
        } else {
          this.pedv.nf.xmotivo = response.response.xmotivo;
          msg.push(response.data.nf[0].xmotivo);
          // this.$erpToastError(response.response.xmotivo);
          rejeitada = true;
        }
      }

      if (rejeitada) {
        this.$refs.modalnfce.rejeitada(msg);
        if (this.params_pdv.ir_para_emissao_nf == "NF") {
          this.index = this.pedv.codpedv;
          this.loadData().then(function () {
            this.$router.push("/nf/" + this.pedv.codnf + "?tipo=view");
            return;
          });
        } else {
          this.handleNovaVenda();
        }
      } else {
        this.index = this.pedv.codpedv;
        this.loadData().then(function () {
          //CASO NF-e AUTORIZADA SERÁ ABERTO TELA DE IMPRESSÃO
          if (this.pedv.nf.stnf == 10) {
            this.handleClickImprimir();
          }
          this.showModalnfce = false;
          this.handleNovaVenda();
        });
      }
    },
    NFeResponseCallbackA1: function NFeResponseCallbackA1(response) {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var rejeitada, msg;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                rejeitada = false;
                msg = [];

                if (response.data) {
                  if (response.data.errmessages) rejeitada = true;
                  if (response.data.nf && response.data.nf.length > 0) {
                    _this15.pedv.nf = response.data.nf[0];
                    if (response.data.nf[0].cstat != "100") {
                      rejeitada = true;
                      msg.push(response.data.nf[0].xmotivo);
                    }
                  }
                }

                if (!rejeitada) {
                  _context12.next = 13;
                  break;
                }

                _this15.$refs.modalnfce.rejeitada(msg);

                if (!(_this15.params_pdv.ir_para_emissao_nf == "NF" && _this15.pedv.nf)) {
                  _context12.next = 10;
                  break;
                }

                _this15.$router.push("/nf/" + _this15.pedv.nf.codnf + "?tipo=view");
                return _context12.abrupt("return");

              case 10:
                _this15.handleNovaVenda();

              case 11:
                _context12.next = 16;
                break;

              case 13:
                //CASO NF-e AUTORIZADA SERÁ ABERTO TELA DE IMPRESSÃO
                _this15.showModalnfce = false;
                if (_this15.pedv.nf.cstat == "100") {
                  _this15.handleClickImprimir();
                }
                _this15.handleNovaVenda();

              case 16:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this15);
      }))();
    },
    confirmaItemCancel: function confirmaItemCancel() {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                //remove o item do pedido
                if (_this16.showModalEditItem) {
                  _this16.showModalEditItem = false;
                }

                _this16.pedvit[_this16.pedvit_update].stpedv = "C";
                _this16.gravaItem(true, false);
                _this16.$nextTick(function () {
                  this.$refs.item.focus();
                });

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this16);
      }))();
    },
    handleCancelEditItem: function handleCancelEditItem(index) {
      //CARREGA DADOS DO CAIXA
      this.pedvit[index].qtuni = this.pedvit_beforeUpdate.qtuni;
      this.pedvit[index].vlr = this.pedvit_beforeUpdate.vlr;
      this.pedvit[index].pdesc1 = this.pedvit_beforeUpdate.pdesc1;
      this.pedvit[index].obs = this.pedvit_beforeUpdate.obs;
      this.$set(this.pedvit[index], "editing", false);
      this.pedvit_beforeUpdate = {};

      this.pedvit_index = "";
      this.item_editing = false;
    },
    handleButtonEditItem: function handleButtonEditItem(index) {
      this.editItemValue = index;
      this.handleEditItem(index);
    },
    handleButtonDeleteItem: function handleButtonDeleteItem(index) {
      this.editItemValue = index;
      this.handleShowModalEditItem("delete");
    },
    handleEditItem: function handleEditItem(index) {
      if (this.editItemValue) {
        index--;
        this.editItemValue = null;
        this.showModalEditItem = false;
        this.item_editing = true;
        this.pedvit_index = index;
      }

      var store = this.pedvit_beforeUpdate;
      store.qtuni = this.pedvit[index].qtuni;
      store.vlr = this.pedvit[index].vlr;
      store.pdesc1 = this.pedvit[index].pdesc1;
      store.obs = this.pedvit[index].obs;

      if (this.pedv.stpedv != "D" && this.pedv.stpedv != "P") {
        return;
      }

      //CLICK NO ITEM DA VENDA - ABRE PARA EDICAO DA QUANTIDADE, PREÇO, DESCONTO
      if (this.pedvit[index].editing) {
        this.pedvit[index].editing = false;
        this.gravaItem(false, false);
        this.$nextTick(function () {
          this.$refs.item.focus();
        });
        this.item_editing = false;
        this.pedvit_index = "";
      } else {
        this.$set(this.pedvit[index], "editing", true); //PARA ABRIR OS DADOS DO ITEM
        this.pedvit[index].editing = true;

        this.$nextTick(function () {
          this.$refs.quantidade.focus();
        });
      }

      if (this.showModalEditItem) {
        this.closeModalEditItem();
      }
    },
    handleRetorna: function handleRetorna() {
      this.closeForm();
    },
    handleDescartarVenda: function handleDescartarVenda() {
      if (!this.isVendaAberta()) {
        this.$erpToastWarning("Inicie uma venda");
        return;
      }
      if (this.pedv.stpedv == "D" || this.pedv.stpedv == "P") {
        this.CANCEL_MESSAGE = true;
      }
      this.handleViewItem();
    },
    handleCancelarVenda: function handleCancelarVenda() {
      this.handleCloseMessage();
      if (this.pedv.stpedv == "D" || this.pedv.stpedv == "P") {
        this.pedv.stpedv = "C";
        this.handleGravaPedido(true);
        this.limparTela();
        this.novavenda();
        this.$erpToastSuccess("A venda foi descartada");
      }
      if (this.itemView) {
        this.handleViewItem();
      }
    },
    handleVendaEspera: function handleVendaEspera() {
      if (this.pedv.stpedv == "D" || this.pedv.stpedv == "P") {
        this.pedv.espera = "S";
        this.handleGravaPedido(false);
        this.novavenda();
        this.$erpToastSuccess("A venda foi colocada em espera");
      }
      if (this.itemView) {
        this.handleViewItem();
      }
    },
    limparTela: function limparTela() {
      // this.pedv = { ...this.$store.getters.getEntities.pedv };
      // this.codpart = null;
      // this.selectedPart = null;
      // this.carregaDadosCliente();
      this.novavenda();
    },
    handleNovaVenda: function handleNovaVenda(showMsg) {
      this.showPagamentoVenda = false;
      if (!this.params_pdv.tipo_controle_cm_ms) {
        this.novavenda();
        if (showMsg) this.$erpToastSuccess("Nova Venda Iniciada");
      } else {
        this.handleShowModalMesaComanda();
      }
    },
    novavenda: function novavenda() {
      this.showFullScreenRequest = false;
      this.pedv = _extends({}, this.$store.getters.getEntities.pedv);
      this.pedv.varejo = "S";
      this.pedv.stpedv = "D";
      this.pedv.data = this.$getDate();
      this.pedv.finalidade = "F";
      this.pedv.indpresencial = "0";
      this.pedv.bonif = "N";
      this.pedv.amostra = "N";
      this.pedv.pgantecipado = "N";
      this.pedv.tpfrete = "0";
      this.pedv.tppedv = "P";
      this.pedvit = [];
      this.pedv.pedvit = this.pedvit;
      this.pedv.obspedido = this.params_pdv.observacao;
      this.selectedPart = null;
      this.codpart = this.pedv.codpart;

      this.errmessages = {};

      this.$nextTick(function () {
        this.$refs.item.focus();
      });

      this.itemView = {};
    },
    handleGravaPedido: function handleGravaPedido(cancel) {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var pedv;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this17.pedv.pedvit = _this17.pedvit;
                _this17.pedv.codvabertura = _this17.vabertura.codvabertura;
                _this17.pedv.codpart = _this17.selectedPart ? _this17.selectedPart.codpart : null;
                _this17.pedv.cpfcnpj = _this17.selectedPart ? _this17.selectedPart.cnpjcpf : null;

                _this17.handleGrade();

                pedv = _this17.pedv;

                if (!(_this17.pedv.pedvit && _this17.pedv.pedvit.length > 0)) {
                  _context14.next = 9;
                  break;
                }

                _context14.next = 9;
                return _this17.apiVarejoPedido(pedv, pedv.pedvit, null, cancel, _this17.responsePedido);

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this17);
      }))();
    },
    responsePedido: function responsePedido(pedv, errmessages) {
      this.pedv = pedv;
      this.pedvit = pedv.pedvit;

      if (errmessages && errmessages.errmessages && errmessages.errmessages.length > 0) {
        for (var x = 0; x <= errmessages.errmessages.length; x++) {
          console.log(errmessages.errmessages[x]);
          this.$erpToastError(errmessages.errmessages[x]);
        }
        return;
      }
      //Existem produtos sem estoque que devem ser removidos do pedido

      this.pedv.atualizado = true;
      if (this.finalizaVendaAction) this.emiteDocumento();else {
        this.loadMesaComanda();
        this.handleNovaVenda();
      }
    },
    handleGrade: function handleGrade() {
      if (this.pedvit && this.pedvit.length) {
        for (var x = 0; x < this.pedvit.length; x++) {
          if (this.pedvit[x].coditemgrade) {
            this.pedvit[x].pedvgrade = [];
            var pedvgrade = {};
            pedvgrade.coditemgrade = this.pedvit[x].coditemgrade;
            pedvgrade.qt = 1;
            this.pedvit[x].pedvgrade.push(pedvgrade);
          }
        }
      }
    },
    handleDescricaoGrade: function handleDescricaoGrade() {
      if (this.pedvit && this.pedvit.length) for (var x = 0; x < this.pedvit.length; x++) {
        var item = this.pedvit[x];
        if (item.pedvgrade && item.pedvgrade.length > 0) {
          if (item.pedvgrade[0] && item.pedvgrade[0].descricao_linha) this.pedvit[x].item[0].descricao = item.item[0].descricao + " " + item.pedvgrade[0].descricao_linha;
          if (item.pedvgrade[0] && item.pedvgrade[0].descricao_coluna) this.pedvit[x].item[0].descricao = item.item[0].descricao + " " + item.pedvgrade[0].descricao_coluna;
        }
      }
    },
    emiteDocumento: function emiteDocumento() {
      if (this.finalizaVendaAction == "NFe") {
        this.showModalnfce = true;
        this.finalizaVendaAction = null;
        var self = this;
        this.apiGerarNF('55').then(function () {
          var tipo = self.$certificadoCheck(self.pedv.nf.codfil);
          self.$refs.modalnfce.enviando();
          if (tipo == "A1") {
            self.autorizaNFeA1(self.pedv.nf, self.NFeResponseCallbackA1);
          } else if (tipo == "A3") {
            self.autorizaNFeA3(self.pedv.nf, self.NFeResponseCallbackA3);
          }
        });
      }
      if (this.finalizaVendaAction == 'NFCe') {
        this.finalizaVendaAction = null;
        this.showModalnfce = true;
        var _self = this;
        this.apiGerarNF('65').then(function () {
          var tipo = _self.$certificadoCheck(_self.pedv.nf.codfil);
          _self.$refs.modalnfce.enviando();
          if (tipo == 'A1') {
            _self.autorizaNFeA1(_self.pedv.nf, _self.NFeResponseCallbackA1);
          } else if (tipo == "A3") {
            _self.autorizaNFeA3(_self.pedv.nf, _self.NFeResponseCallbackA3);
          }
        });
      }
      if (this.finalizaVendaAction == "SAT") {
        this.finalizaVendaAction = null;
        var _self2 = this;
        this.apiGerarNF('59').then(function () {
          _self2.executaSAT();
        });
      }
      if (this.finalizaVendaAction == "PRINT") {
        this.showEmissaoCupomVmov = false;
        this.savedOrder = this.pedv.codpedv;
        this.showEmissaoCupom = true;
        this.handleNovaVenda();
      }
      if (this.finalizaVendaAction == "OK") {
        this.handleNovaVenda();
      }

      this.finalizaVendaAction = null;
    },
    gravaItem: function gravaItem(cancelItem, deleteItem) {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var hasItem, pedv;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                hasItem = false;

                if (!_this18.runningItemRequest) {
                  _context15.next = 3;
                  break;
                }

                return _context15.abrupt("return");

              case 3:

                _this18.runningItemRequest = true;

                _this18.filaRequicaoItens.map(function (item) {
                  if (_this18.params_pdv.agrupar_itens_pedido) {
                    _this18.pedv.pedvit.forEach(function (e, i) {
                      if (e.coditem == item.coditem) {
                        hasItem = true;
                        _this18.pedv.pedvit[i].qtuni += item.qtuni;
                      }
                    });
                  }

                  if (!_this18.params_pdv.agrupar_itens_pedido || !hasItem) {
                    _this18.pedv.pedvit.push(item);
                    _this18.pedvit = _this18.pedv.pedvit;
                    _this18.$refs.divitems.scrollTop = _this18.$refs.divitems.scrollHeight;
                  }
                });

                _this18.filaRequicaoItens = [];

                _this18.pedv.codpart = _this18.selectedPart ? _this18.selectedPart.codpart : null;
                _this18.pedv.cpfcnpj = _this18.selectedPart ? _this18.selectedPart.cnpjcpf : null;
                _this18.pedv.varejo = "S";
                _this18.pedv.st = "P";
                _this18.pedv.codtabpre = _this18.params_pdv.tabela_preco;

                if (_this18.hasComandaControl) {
                  if (!_this18.pedv.codpedv) {
                    _this18.$set(_this18.pedv, "comanda", _this18.codcomanda);
                    _this18.pedv.comanda = _this18.codcomanda;
                    _this18.codcomanda = "";
                  }
                }
                _this18.handleGrade();

                if (_this18.pedvit.length <= 1 && cancelItem) {
                  _this18.handleCancelarVenda();
                }

                _this18.pedvit.forEach(function (e) {
                  return e.codtabpre = _this18.params_pdv.tabela_preco;
                });

                _this18.pedv.pedvit = _this18.pedvit;

                _this18.calculaItem();

                _this18.pedv.codvabertura = _this18.vabertura.codvabertura;

                pedv = _this18.pedv;
                _context15.next = 21;
                return _this18.apiVarejoPedido(pedv, pedv.pedvit, null, false, _this18.responseVarejoPedido);

              case 21:
                _context15.next = 23;
                return _this18.loadMesaComanda();

              case 23:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this18);
      }))();
    },
    responseVarejoPedido: function responseVarejoPedido(pedv, errmessages) {
      this.pedv = pedv;
      this.pedvit = pedv.pedvit;
      this.handleDescricaoGrade();

      this.calculaPercentualDesconto();
      this.calculaPercentualAcrescimo();

      if (errmessages == null || !errmessages.errmessages || errmessages.errmessages.length <= 0) {
        this.pedv.atualizado = true;
      } else {
        for (var x = 0; x < errmessages.errmessages.length; x++) {
          console.log(errmessages.errmessages[x]);
          this.$erpToastError(errmessages.errmessages[x]);
        }
      }
      this.loadMesaComanda();

      this.runningItemRequest = false;

      if (this.filaRequicaoItens.length > 0) {
        this.gravaItem(false, false);
      }
    },
    handleCloseMessage: function handleCloseMessage() {
      this.CANCEL_MESSAGE = false;
      this.$nextTick(function () {
        this.$refs.item.focus();
      });
    },
    textOption: function textOption(value, field) {
      var item = field.options.filter(function (x) {
        return x.id === value;
      });
      if (item.length) {
        return item[0].text;
      }
    },
    validacaoInicial: function validacaoInicial() {
      //VALIDA A SITUACAO DE CREDITO DO CLIENTE, STATUS DO CLIENTE E NATUREZA DE OPERACAO
      this.isValidCabec = true;

      if (this.pedv.nates && this.pedv.nates.length && this.pedv.nates[0].stnates == "I") {
        this.$erpToastError("A Natureza de saída informada está inativa");
        this.isValidCabec = false;
      }
      if (this.pedv.part[0].stcred != "L") {
        this.$erpToastError("Cliente com crédito bloqueado");
        this.isValidCabec = false;
      }
      if (this.pedv.part[0].stpart == "I") {
        this.$erpToastError("Cliente inativo");
        this.isValidCabec = false;
      }
      return this.isValidCabec;
    },
    loadVendaEspera: function loadVendaEspera(codpedv) {
      if (!codpedv) return;

      this.handleModalVendasEspera();

      this.index = codpedv;
      this.loadData();
    },
    loadData: function loadData() {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                //carrega o pedido para alteracao ou visualizacao
                // if (!this.index)
                //   return

                _this19.unwatch = true;
                _context16.next = 3;
                return _this19.$store.dispatch("loadPedv", { id: _this19.index });

              case 3:
                if (_this19.$store.getters.getPedv) {
                  _this19.pedv = _extends({}, _this19.$store.getters.getPedv[0]);
                  if (_this19.pedv.pedvit) _this19.pedvit = _this19.pedv.pedvit;
                  if (_this19.pedv.pedvpar) {
                    _this19.pedvpar = _this19.pedv.pedvpar;
                  }

                  _this19.handleDescricaoGrade();
                  _this19.selectedPart = null;
                  _this19.codpart = _this19.pedv.codpart;
                  _this19.carregaDadosCliente();
                }
                _this19.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                  this.unwatch = false;
                });

              case 5:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this19);
      }))();
    },
    loadPedvAtualUsuario: function loadPedvAtualUsuario() {
      var _this20 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                //carrega o pedido para alteracao ou visualizacao
                _this20.unwatch = true;
                _context17.next = 3;
                return _this20.$store.dispatch("loadPedvAtualUsuario", {
                  id: _this20.$store.getters.getEnv.uuid
                });

              case 3:
                if (_this20.$store.getters.getPedv) {
                  _this20.pedv = _extends({}, _this20.$store.getters.getPedv[0]);
                  if (_this20.pedv.pedvit) _this20.pedvit = _this20.pedv.pedvit;
                  if (_this20.pedv.pedvpar) {
                    _this20.pedvpar = _this20.pedv.pedvpar;
                  }

                  _this20.handleDescricaoGrade();
                  _this20.selectedPart = null;
                  if (_this20.pedvit && _this20.pedvit.length > 0) {
                    _this20.codpart = _this20.pedv.codpart;
                    _this20.carregaDadosCliente();
                    _this20.$erpToastSuccess('Pedido não finalizado carregado com sucesso! Para iniciar uma nova venda coloque essa em espera em "mais Ações"');
                  }
                }
                _this20.$nextTick(function () {
                  jQuery('[data-toggle="tooltip"]').tooltip();
                  this.unwatch = false;
                });

              case 5:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this20);
      }))();
    },
    carregaDadosCliente: function carregaDadosCliente() {
      var _this21 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var part;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (!(_this21.codpart && _this21.codpart != "")) {
                  _context18.next = 13;
                  break;
                }

                if (!__WEBPACK_IMPORTED_MODULE_19__shared_cpf___default()(_this21.codpart.toString())) {
                  _context18.next = 10;
                  break;
                }

                part = _extends({}, _this21.$store.getters.getEntities.part);

                part.codpart = null;
                part.cnpjcpf = _this21.codpart;
                part.nome = "CONSUMIDOR FINAL";
                _this21.selectedPart = part;
                _this21.pedv.cpfcnpj = part.cnpjcpf;
                _context18.next = 13;
                break;

              case 10:
                _context18.next = 12;
                return _this21.$store.dispatch("loadPart", { id: _this21.codpart });

              case 12:
                if (_this21.$store.getters.getPart) {
                  _this21.selectedPart = _extends({}, _this21.$store.getters.getPart[0]);
                }

              case 13:
                if (_this21.showPagamentoVenda) _this21.$refs.pagamentoVenda.loadCreditoLoja(_this21.selectedPart);

              case 14:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this21);
      }))();
    },
    handleResultadoEmissaoCupom: function handleResultadoEmissaoCupom() {
      this.showEmissaoCupom = false;
      this.showEmissaoCupomVmov = false;
    },
    hasBgconfig: function hasBgconfig(onlyBgOption) {
      if (this.params_pdv) {
        if (onlyBgOption) {
          return "background-color: " + (Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["isValidHashColor"])(this.params_pdv.colors.bg_top_bottom) ? this.params_pdv.colors.bg_top_bottom : "#174b79") + "; color:" + (Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["isValidHashColor"])(this.params_pdv.colors.fc_top_bottom) ? this.params_pdv.colors.fc_top_bottom : "white;") + "!important;";
        } else {
          return "background-color: " + (Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["isValidHashColor"])(this.params_pdv.colors.bg_top_bottom) ? this.params_pdv.colors.bg_top_bottom : "#174b79") + "; color:" + (Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["isValidHashColor"])(this.params_pdv.colors.fc_top_bottom) ? this.params_pdv.colors.fc_top_bottom : "white;") + "!important; border-bottom: 1px solid #e9e5e5; height: 30px;";
        }
      } else {
        return "background-color: #174b79; color: white; border-bottom: 1px solid #e9e5e5; height: 55px;";
      }
    },
    hasBgButtomconfig: function hasBgButtomconfig() {
      if (this.params_pdv && this.params_pdv.colors) {
        return "background-color: " + (Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["isValidHashColor"])(this.params_pdv.colors.bg_buttom) ? this.params_pdv.colors.bg_buttom : "#174b79") + "; color:" + (Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["isValidHashColor"])(this.params_pdv.colors.fc_buttom) ? this.params_pdv.colors.fc_buttom : "white;") + "!important;";
      } else {
        return "background-color: #174b79; color: white; border-bottom: 1px solid #e9e5e5; height: 55px;";
      }
    },
    hasBgConfirmconfig: function hasBgConfirmconfig() {
      if (this.params_pdv && this.params_pdv.colors) {
        return "background-color: " + (this.params_pdv.colors.bg_buttom ? this.params_pdv.colors.bg_buttom : "#37648b") + "; color:" + (this.params_pdv.colors.fc_buttom ? this.params_pdv.colors.fc_buttom : "white;") + "!important;";
      } else {
        return "background-color: #b5e792; color: white; border-bottom: 1px solid #e9e5e5; height: 55px;";
      }
    },
    handlePushState: function handlePushState(event) {
      history.pushState(null, null, document.URL);
    },
    isModalActive: function isModalActive() {
      if (this.showModalAcrescimo || this.showModalDesconto || this.showModalEditItem || this.showModalCliente || this.showModalMesa || this.showModalComanda || this.showModalMaisAcoes || this.showModalPendcli) return true;else return false;
    },
    isVendaAberta: function isVendaAberta() {
      if (this.pedvit && this.pedvit.length > 0) return true;else return false;
    },
    handleKeyPress: function handleKeyPress(event) {
      var self = this;

      // desabilita tecla F3, F5, F6 do navegador
      if (event.keyCode === 116 || event.keyCode === 114 || event.keyCode === 117) event.preventDefault();

      // console.log(event.keyCode)

      if (!this.isModalActive()) {
        // F2
        if (event.keyCode === 113 && !self.showPagamentoVenda) {
          self.handleNovaVenda(true);
          return;
        }

        // F4
        if (event.keyCode === 115 && self.isVendaAberta()) {
          self.handleModalCliente();
          return;
        }

        // F3
        if (event.keyCode === 114 && self.showPagamentoVenda) {
          if (this.params_pdv.permite_desconto || this.params_pdv.permite_acrescimo) {
            self.handleInformarDesconto();
          }
          return;
        }

        // F3
        if (event.keyCode === 114 && !self.showPagamentoVenda) {
          self.handleModalVendasEspera();
          return;
        }

        // F5
        if (event.keyCode === 116) {
          if (!self.showPagamentoVenda) self.handleDescartarVenda();
          return;
        }

        // F6
        if (event.keyCode === 117 && !self.showPagamentoVenda) {
          self.handleClickPagamento();
          return;
        }

        // F9
        if (event.keyCode === 120 && !self.showPagamentoVenda) {
          self.focusItem();
          return;
        }
      }

      // ESC
      if (event.keyCode === 27) {
        if (self.showModalEditItem) {
          self.closeModalEditItem();
          return;
        } else if (this.showVendas) {
          this.handleModalVendasEspera();
          return;
        } else if (self.showModalDesconto || self.showModalAcrescimo) {
          self.closeModalDescontoAcrescimo();
          return;
        } else if (self.showModalEditItem) {
          self.closeModalEditItem();
          return;
        } else if (self.showModalCliente) {
          self.closeModalCliente();
          return;
        } else if (self.showModalMesa) {
          self.handleCloseModalMesa();
          return;
        } else if (self.showModalComanda) {
          self.handleCloseModalComanda();
          return;
        } else if (self.showModalPendcli) {
          self.closeModalPendcli();
          return;
        } else if (self.showPagamentoVenda) {
          if (self.$refs.pagamentoVenda.$refs.paymentType.focused) {
            self.showPagamentoVenda = false;
            self.focusItem();
          } else {
            self.$refs.pagamentoVenda.$refs.paymentType.focus();
          }
          return;
        } else if (self.inFocus) {
          //Voltar ao campo do item
          this.focusItem();
        }
        if (self.modoView) {
          this.focusItem;
          self.modoView = false;
          self.$refs.item.handleisView(self.modoView);
        }
        if (this.$refs.qtdItemInformada && this.$refs.qtdItemInformada.focused) {
          this.focusItem();
          return;
        }
        if (this.$refs.vlrItemInformado && this.$refs.vlrItemInformado.focused) {
          this.$refs.qtdItemInformada.focus();
          return;
        }
      }

      // ALT EVENT
      if (event.altKey) {
        switch (event.keyCode) {
          case 80:
            // Pagamento (Alt + P)
            self.handleClickPagamento();
            break;
          case 79:
            // Manda Foco para Seleção de Atalho (Alt + O)
            event.preventDefault();
            self.showModalMaisAcoes = true;
            break;
          case 68:
            // alt + D
            event.preventDefault();
            self.handleSelectedOption('excluir');
            // self.handleShowModalEditItem('delete');
            break;
          case 70:
            // alt + F
            event.preventDefault();
            self.handleSelectedOption('fecharcaixa'); //handleFecharCaixa();
            break;
          case 83:
            // alt + S
            event.preventDefault();
            self.handleSelectedOption('sangrar');
            // self.showConfirmAdminPass(self.handlerSangrar);
            break;
          case 82:
            // alt + R
            event.preventDefault();
            self.handleSelectedOption('reforcar');
            // self.showConfirmAdminPass(self.handlerReforcar);
            break;
        }
      }
    }
  },

  watch: {
    editItemValue: function editItemValue(n) {
      if (n == null || n == "") {
        this.errMessageModalEditItem = "";
      }
    },


    codpart: function codpart() {},

    vabertura: {
      handler: function handler(newValue) {
        if (newValue) this.caixa = newValue.caixa; //descricao do caixa no topo da tela
        else this.caixa = null;
      },
      immediate: true,
      deep: true
    }
  },

  created: function created() {
    //this.$store.dispatch('clearItemSales')
    this.filial = null;
    this.handleParamPDV();

    var index = null;

    setTimeout(function () {
      Tawk_API.hideWidget();
    }, 1000);

    this.metadata.pedv.parcelas.options.sort(function (a, b) {
      return Number(a.id) > Number(b.id) ? 1 : Number(b.id) > Number(a.id) ? -1 : 0;
    });

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });

    this.crud = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].crudI;
    this.crudText = this.$crudText(this.crud);

    this.$scrollTo(0);

    // this.$store.dispatch("loadItemSales", {
    //   codtabpre: this.params_pdv.tabela_preco
    // });
  },
  beforeDestroy: function beforeDestroy() {
    var body = document.querySelector("body");
    body.style.overflow = "auto";
    window.removeEventListener("popstate", this.handlePushState);
    window.removeEventListener("keydown", this.bound_handleKeyPress);
  },
  mounted: function mounted() {
    var _this22 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
      var index, self;
      return regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _this22.handlePushState;
              window.addEventListener("popstate", _this22.handlePushState);

              index = null;
              self = _this22;
              _context20.next = 6;
              return _this22.loadFilial();

            case 6:
              _context20.next = 8;
              return _this22.loadAbertura();

            case 8:
              // this.hasBgconfig();

              if (_this22.$route.params) {
                if (_this22.$route.params.novo == "novo") incluir = true;else if (_this22.$route.params.novo) index = _this22.$route.params.novo;
              }

              if (_this22.vabertura) {
                if (!index && _this22.$store.getters.getEnv.uuid && !_this22.hasMesaControl && !_this22.hasComandaControl && !_this22.hasMesaComandaControl) {
                  //this.loadPedvAtualUsuario();
                } else {
                  _this22.handleResult(index, "OK");
                  if (_this22.hasMesaControl || self.hasMesaComandaControl) {
                    _this22.handleShowModalMesaComanda();
                  } else if (self.hasComandaControl) {
                    _this22.handleShowModalMesaComanda();
                  }
                }
              }

              self = _this22;

              _this22.$nextTick(function () {
                //const rect = this.$refs.pesquisa.getBoundingClientRect();
                jQuery('[data-toggle="tooltip"]').tooltip();

                if (!self.hasMesaControl && !self.hasComandaControl && !self.hasMesaComandaControl) {
                  if (self.$refs.item) self.$refs.item.focus();
                }
              });

              _this22.bound_handleKeyPress = _this22.handleKeyPress.bind(_this22);
              window.removeEventListener("keydown", _this22.bound_handleKeyPress);
              _this22.windowListener = window.addEventListener("keydown", _this22.bound_handleKeyPress);

              //Retira barra de rolagem da tela
              document.querySelector("body").style.overflow = "hidden";

              _this22.windowHeight = window.innerHeight;

              if (_this22.windowHeight > 663) {
                _this22.showFullScreenRequest = false;
              }

              //Verifica tamanho da tela para renderizar alert ao usuário
              window.addEventListener("resize", _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
                return regeneratorRuntime.wrap(function _callee19$(_context19) {
                  while (1) {
                    switch (_context19.prev = _context19.next) {
                      case 0:
                        _this22.windowHeight = window.innerHeight;
                        if (_this22.windowHeight > 663) {
                          _this22.showFullScreenRequest = false;
                        } else {
                          _this22.showFullScreenRequest = true;
                        }

                      case 2:
                      case "end":
                        return _context19.stop();
                    }
                  }
                }, _callee19, _this22);
              })));

            case 19:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, _this22);
    }))();
  }
});

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    pedv: "",
    params_colors: {},
    params_msg: "",
    caixa: "",
    showBtnConfig: { type: Boolean, default: true },
    config: Boolean,
    part: ""
  },
  data: function data() {
    return {
      currVideo: null,
      isFullScreen: false
    };
  },


  computed: {
    hasFontconfig: function hasFontconfig() {
      if (this.config) {
        if (this.params_colors.bg_top_bottom) {
          return "color:" + this.params_colors.bg_top_bottom + ";";
        }
        return "color:#174b79;";
      }
      return "color:#174b79;";
    },
    hasBgconfig: function hasBgconfig() {
      return "background-color: " + (this.params_colors.bg_top_bottom ? this.params_colors.bg_top_bottom : "#174b79") + "; color:" + (this.params_colors.fc_top_bottom ? this.params_colors.fc_top_bottom : "white;") + "!important; border-bottom: 1px solid #e9e5e5; height: 45px; border-bottom-left-radius: 5px;";
    },

    usuarionome: function usuarionome() {
      return this.$store.getters.getEnv.usuarionome;
    },
    empresanome: function empresanome() {
      return this.$store.getters.getEnv.empresanome;
    },
    empresacod: function empresacod() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["zeroPad"])(this.$store.getters.getEnv.empresacod, 6);
    },
    email: function email() {
      return this.$store.getters.getEnv.email;
    },
    acessoCore: function acessoCore() {
      return this.$store.getters.getEnvAcessoCore;
    },
    istrial: function istrial() {
      return this.$store.getters.getSessao.istrial == "S";
    },
    app: function app() {
      if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appNFe) return "nfe";else if (__WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].appForcaVendas) return "forcaVendas";
    },
    url_router: function url_router() {
      return this.$route.name;
    },
    helpList: function helpList() {
      var _this = this;

      var list = this.$store.getters.getHelpList;
      return list.filter(function (obj) {
        return obj.app.indexOf(_this.app) > -1 && obj.route == _this.url_router;
      });
    },
    administrador: function administrador() {
      return __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].usuarioAdministrador;
    }
  },

  methods: {
    clickAction: function clickAction(action) {
      this.$emit("action", action);
    },
    handleManual: function handleManual() {
      window.open("https://s3.amazonaws.com/htdti/Gestor/NBManual.pdf", "_blank");
    },
    handleClose: function handleClose() {
      this.$emit('logout');
    },
    handleCentral: function handleCentral() {
      window.open("http://notabrasil.com.br/suporte/", "_blank");
    },
    handleConfig: function handleConfig() {
      this.$emit("config");
    },
    handleFullScreen: function handleFullScreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
        this.isFullScreen = true;
      } else {
        document.exitFullscreen();
        this.isFullScreen = false;
      }
    },
    handleHome: function handleHome() {
      this.$router.push({ path: "/" });
    }
  },

  created: function created() {}
});

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Trap: __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default.a
  },

  props: {
    params_pdv: {
      type: Object,
      default: function _default() {
        return { colors: {} };
      }
    },
    bgButton: null
  },
  data: function data() {
    return {};
  },

  computed: {},
  methods: {
    handleEmit: function handleEmit(selected) {
      this.$emit('selected', selected);
    },
    closeModal: function closeModal() {
      this.$emit("close");
    }
  },
  created: function created() {
    var _this = this;

    window.addEventListener("keyup", function (event) {
      if (event.key === "Escape") _this.closeModal();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("keyup", this.closeModal);
  }
});

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__varejo_parcelas_form__ = __webpack_require__(2162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_cpf__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_cpf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_cpf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__varejo_modal_opcoes_final__ = __webpack_require__(2166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_focus_lock__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_focus_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_focus_lock__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params: {},
    params_pdv: {},
    selectedPart: {}
  },

  data: function data() {
    return {
      eventAlt: "",
      listPagamentos: [], //LISTA DE PAGAMENTOS SELECIONADOS,
      formaPagamento: "",

      totalPago: 0, //TOTAL PAGO BASEADO NOS PAGAMENTOS SELECIONADOS
      saldoPagar: 0,
      saldo: 0,
      valorPagamento: 0,
      inFocusVlrPag: false,
      confirmPag: false,
      loadbutton: false,

      email: "",
      pedv: null,

      codpart: null,
      enableCreditoLoja: false, //HABILITA BOTAO "CREDITO LOJA"
      creditoLoja: { saldo: null, codfpag: null },

      pagamentoFinalizado: false,

      selectedFormaPagamento: {}, //forma de pagamento selecionada
      valorCash: 0,

      showParcelas: false, //exibe parcelas quando for selecionado pagamento em ch, boleto, cartao
      paramParcelas: {},

      dadosParcela: {
        dias: 0,
        data: "",
        valor: 0,
        banco: "",
        documento: ""
      },

      listParcelas: [], //array com parcelas e dados dos cheques

      botoesPagamentoEnabled: true, //botoes de pagamento habilitados

      // fpagList: [],

      sat: null,

      showModalDocumentos: false
    };
  },


  computed: {
    changeCurrency: function changeCurrency() {
      var trocoTotal = 0;
      this.listPagamentos.map(function (e) {
        trocoTotal = trocoTotal + e.troco;
      });
    },
    fpagList: function fpagList() {
      var paglist = this.$store.getters.getFpagList;
      var self = this;
      for (var i = 0; i < paglist.length; i++) {
        paglist[i].descricao = paglist[i].descricao.toUpperCase();
        paglist[i].atalho = "Alt + " + (i + 1) + "";
        var cod = paglist[i].formapag;
        paglist[i].fpagText = "";
        this.metadata.fpag.formapag.options.map(function (e) {
          if (paglist[i].formapag == e.id) {
            paglist[i].fpagText = e.text;
          }
        });
        switch (cod) {
          case "15":
            paglist[i].icon = "fa fa-barcode";
            break;
          case "03":
            paglist[i].icon = "fa fa-credit-card";
            break;
          case "04":
            paglist[i].icon = "fa fa-credit-card-alt";
            break;
          case "02":
            paglist[i].icon = "fa fa-credit-card";
            break;
          case "05":
            paglist[i].icon = "fa fa-shopping-bag";
            break;
          case "16":
            paglist[i].icon = "fa fa-plus";
            break;
          case "01":
            paglist[i].icon = "fa fa-money";
            break;
          case "17":
            paglist[i].icon = "fa fa-dollar";
            break;
          case "18":
            paglist[i].icon = "fa fa-exchange";
            break;
          case "11":
            paglist[i].icon = "fa fa-shopping-basket";
            break;
          case "19":
            paglist[i].icon = "fa fa-handshake";
            break;
          case "10":
            paglist[i].icon = "fa fa-dollar";
            break;
          case "13":
            paglist[i].icon = "fa fa-dollar";
            break;
          case "12":
            paglist[i].icon = "fa fa-dollar";
            break;
        }
      }
      return paglist;
    },

    part: function part() {
      if (this.$store.getters.getPart.length > 0) {
        return this.$store.getters.getPart[0];
      } else {
        return null;
      }
    },

    metadata: function metadata() {
      return this.$store.getters.getEntities.metadata;
    },

    titulo: function titulo() {
      if (this.saldoPagar < 0) {
        return "Troco: " + Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["formatValue"])(this.saldoPagar * -1, 2);
      } else if (this.saldoPagar > 0) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["formatValue"])(this.saldoPagar, 2) + " a Pagar";
      } else {
        return "Informe o valor para pagamento";
      }
    }
  },

  watch: {
    totalPago: function totalPago() {
      this.saldo = this.params.totalVenda - this.totalPago;
    },

    valorPagamento: function valorPagamento() {
      //CALCULA O SALDO A PAGAR
      this.saldoPagar = this.params.totalVenda - this.totalPago - this.valorPagamento;
    }
  },

  filters: {},

  methods: {
    hasBgButtomconfig: function hasBgButtomconfig() {
      if (this.params_pdv && this.params_pdv.colors) {
        return "background-color: " + (Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["isValidHashColor"])(this.params_pdv.colors.bg_buttom) ? this.params_pdv.colors.bg_buttom : "#174b79") + "; color:" + (Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["isValidHashColor"])(this.params_pdv.colors.fc_buttom) ? this.params_pdv.colors.fc_buttom : "write;") + "!important;";
      }
    },
    hasBgconfig: function hasBgconfig(onlyBgOption) {
      if (this.params_pdv) {
        if (onlyBgOption) {
          return "background-color: " + (this.params_pdv.colors.bg_top_bottom ? this.params_pdv.colors.bg_top_bottom : "#174b79") + "; color:" + (this.params_pdv.colors.fc_top_bottom ? this.params_pdv.colors.fc_top_bottom : "white;") + "!important;";
        } else {
          return "background-color: " + (this.params_pdv.colors.bg_top_bottom ? this.params_pdv.colors.bg_top_bottom : "#174b79") + "; color:" + (this.params_pdv.colors.fc_top_bottom ? this.params_pdv.colors.fc_top_bottom : "white;") + "!important; border-bottom: 1px solid #e9e5e5; height: 30px;";
        }
      } else {
        return "background-color: #174b79; color: white; border-bottom: 1px solid #e9e5e5; height: 55px;";
      }
    },
    hasBgTopButtonconfig: function hasBgTopButtonconfig() {
      if (this.params_pdv && this.params_pdv.colors) {
        return "background:" + (Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["isValidHashColor"])(this.params_pdv.colors.bg_top_bottom) ? this.params_pdv.colors.bg_top_bottom : "#174b79") + "; color:" + (Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils__["isValidHashColor"])(this.params_pdv.colors.fc_top_bottom) ? this.params_pdv.colors.fc_top_bottom : "white;");
      } else {
        return "background: #174b79; color: white;";
      }
    },
    handleDescontoAcrescimo: function handleDescontoAcrescimo() {
      this.$emit("showModalDesconto");
    },
    handleCliente: function handleCliente() {
      this.$emit("showModalCliente", true);
    },
    handleLimparPag: function handleLimparPag() {
      this.totalPago = 0;
      this.saldo = this.params.totalVenda - this.totalPago;
      this.valorPagamento = this.params.totalVenda;
      this.saldoPagar = this.params.totalVenda;
      this.listPagamentos = []; //LISTA DE PAGAMENTOS SELECIONADOS,
      this.formaPagamento = "";
      this.$nextTick(function () {
        this.$refs.paymentType.focus();
      });
    },
    handleObs: function handleObs(obspedido) {
      this.pedv.obspedido = obspedido;
      this.handleRetorna();
    },
    handleClickNFe: function handleClickNFe() {
      var self = this;
      if (!this.selectedPart || !this.selectedPart.codpart || this.selectedPart.codpart && this.selectedPart.cnpjcpf == "CONSUMIDOR") {
        this.selectedPart = null;
        this.codpart = null;

        if (this.$refs.part) {
          this.$nextTick(function () {
            this.$refs.part.focus();
          });
        }
        this.$erpToastError("Para gerar a nota fiscal o cliente deve ser informado.");
      } else {
        this.$emit("resultadopagamento", this.listPagamentos, this.selectedPart, this.email, "NFe");
      }
    },
    handleConfirmPag: function handleConfirmPag() {
      var self = this;
      this.loadbutton = true;
      this.confirmPag = true;
      this.$nextTick(function () {
        this.$refs.btnPaymentDone.focus();
      });
    },
    handleDocument: function handleDocument(value) {
      console.log(value);
      switch (value) {
        case "CP":
          this.handleClickPrint();
          break;
        case "ES":
          this.handleClickSAT();
          break;
        case "NC":
          this.handleClickNFCe();
          break;
        case "NF":
          this.handleClickNFe();
          break;
        case "FV":
          this.handleFinalizaVenda();
          break;
      }
    },
    handleDonePayment: function handleDonePayment() {
      var self = this;

      this.showModalDocumentos = false;

      if (this.params_pdv.default_focus_btn_pag) {
        switch (this.params_pdv.default_focus_btn_pag) {
          case "CP":
            this.handleClickPrint();
            break;
          case "ES":
            this.handleClickSAT();
            break;
          case "NC":
            this.handleClickNFCe();
            break;
          case "NF":
            this.handleClickNFe();
            break;
          case "FV":
            this.handleFinalizaVenda();
            break;
        }
        return;
      } else {
        this.handleFinalizaVenda();
        return;
      }
    },
    handleEnterTypePay: function handleEnterTypePay() {
      if (this.formaPagamento && this.formaPagamento > this.fpagList.length) {
        this.$nextTick(function () {
          this.$refs.paymentType.focus();
        });
        return;
      }
      if (this.formaPagamento) {
        this.$nextTick(function () {
          this.$refs.valorpagamento.focus();
        });
      } else {
        this.$nextTick(function () {
          this.$refs.paymentType.focus();
        });
      }
    },
    handleEnterPaymentValue: function handleEnterPaymentValue() {
      var _this = this;

      var forma = this.formaPagamento - 1;

      this.fpagList.map(function (e, i) {
        if (forma == i) {
          _this.handleClickFormaPagamento(i);
          return;
        }
      });
      this.formaPagamento = "";

      if (this.totalPago >= this.params.totalVenda) {
        this.$nextTick(function () {
          this.$refs.btnconfirmpag.focus();
        });
      } else if (!this.showParcelas) {
        this.$nextTick(function () {
          this.$refs.paymentType.focus();
        });
      }
    },
    loadCreditoLoja: function loadCreditoLoja(selectedPart) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var pagCredito, self, url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // CARREGA O SALDO EM CREDITO DO CLIENTE SELECIONADO
                _this2.enableCreditoLoja = false;
                _this2.creditoLoja.saldo = null;

                pagCredito = 0;

                _this2.listPagamentos.forEach(function (pag, index) {
                  if (pag.fpag.codfpag == _this2.creditoLoja.codfpag) pagCredito += pag.valor;
                });
                if (pagCredito > 0) {
                  _this2.handleLimparPag();
                }

                if (!(!selectedPart || !selectedPart.codpart)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                self = _this2;
                url = _this2.$store.getters.urlOrds + "varejo/creditoloja/" + selectedPart.codpart;

                Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDS"])(url, {}).then(function (result) {
                  if (result.creditoloja) {
                    // self.$set(self.selectedPart, "creditoLoja", result.creditoloja);
                    self.creditoLoja.saldo = result.creditoloja;
                    self.creditoLoja.codfpag = result.codfpag;
                    self.enableCreditoLoja = true;
                    self.handleClickCredito();
                  } else {
                    self.creditoLoja.saldo = null;
                    self.enableCreditoLoja = false;
                  }
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleClickPrint: function handleClickPrint() {
      this.$emit("resultadopagamento", this.listPagamentos, this.selectedPart, this.email, "PRINT");
    },
    handleClickNFCe: function handleClickNFCe() {
      this.$emit("resultadopagamento", this.listPagamentos, this.selectedPart, this.email, "NFCe");
    },
    handleRetorna: function handleRetorna(event) {
      //BOTAO RETORNAR PARA VENDA
      if (this.showParcelas) {
        this.cancelFormParcelas();
        return;
      }
      if (this.showModalDocumentos) {
        this.showModalDocumentos = false;
        this.$nextTick(function () {
          this.$refs.btnPaymentDone.focus();
        });
        return;
      }
      if (!this.showDocs && !this.showParcelas) {
        this.$emit("resultadopagamento", null, this.selectedPart, this.email, "RETORNAVENDA");
        return;
      }

      if (this.pagamentoFinalizado) {
        this.pagamentoFinalizado = false;
        this.$nextTick(function () {
          this.$refs.paymentType.focus();
        });
        return;
      }
    },
    handleEnterValorCash: function handleEnterValorCash() {
      //ENTER NO CAMPO DE VALOR EM DINHEIRO
    },
    handleClickValoresCash: function handleClickValoresCash(index) {
      //CLICK NOS VALORES DO PAGAMENTO EM DINHEIRO
    },
    cancelFormParcelas: function cancelFormParcelas() {
      //CANCELAMENTO NO FORM DE PARCELAS
      this.selectedFormaPagamento = null;
      this.showParcelas = false;
      this.$nextTick(function () {
        this.$refs.paymentType.focus();
      });
    },
    handleClickSAT: function handleClickSAT() {
      /*
        PARA CANCELAMENTO DO SAT:
      - CHAMAR A EXTENSAO ENVIANDO O XML DO SAT
       */
      this.$emit("resultadopagamento", this.listPagamentos, this.selectedPart, this.email, "SAT");

      //this.sat = { message: 'Enviando...' }
      //let XMLSAT = '<CFe><ide><signAC>SGR-SAT SISTEMA DE GESTAO E RETAGUARDA DO SAT</signAC><codigoDeAtivacao>12345678</codigoDeAtivacao><modSAT>2</modSAT><nomeDLL>C:\NB\SAT\SAT.dll</nomeDLL><numeroCaixa>1</numeroCaixa><swCNPJ>16716114000172</swCNPJ><emitCNPJ>08723218000186</emitCNPJ><emitIE>149626224113</emitIE><emitIM></emitIM><regTrib>0</regTrib><regTribISSQN></regTribISSQN><indRatISSQN>N</indRatISSQN><tpAmb>2</tpAmb><cNF>10</cNF></ide><dest><CNPJCPF>05481336000137</CNPJCPF><xNome>Empresa de Teste</xNome><entrega><xLgr></xLgr><nro></nro><xCpl></xCpl><xBairro></xBairro><xMun></xMun><UF></UF></entrega></dest><item><det nItem="1"><cProd>ACBR0001</cProd><cEAN>6291041500213</cEAN><xProd>Assinatura SAC</xProd><NCM>99</NCM><CFOP>5120</CFOP><uCom>UN</uCom><qCom>1.0000</qCom><vUnCom>10.00</vUnCom><indRegra>A</indRegra><vItem>10.00</vItem><orig>0</orig><ICMS><sitTrib>102</sitTrib></ICMS><PIS><sitTrib>49</sitTrib></PIS><COFINS><sitTrib>49</sitTrib></COFINS></det><det nItem="2"><cProd>6291041500213</cProd><cEAN>6291041500213</cEAN><xProd>Outro produto Qualquer, com a Descricao Grande</xProd><CFOP>5529</CFOP><uCom>un</uCom><qCom>1.0000</qCom><vUnCom>100.00</vUnCom><indRegra>A</indRegra><ICMS><sitTrib>102</sitTrib></ICMS><PIS><sitTrib>49</sitTrib></PIS><COFINS><sitTrib>49</sitTrib></COFINS></det></item><total></total><pgto><MP><cMP>03</cMP><vMP>10.00</vMP></MP><MP><cMP>01</cMP><vMP>100.00</vMP></MP></pgto></CFe>'
      //this.$SATExtension(XMLSAT, this.SATCallBack)
    },
    SATCallBack: function SATCallBack(response) {
      //CALLBACK QUANDO O SAT É ENVIADO

      this.$appLoading(false);
      if (response.xml) {
        //FALTA CARREGAR O XML DO SAT RECEBIDO PARA GRAVAR NA TABELA DE VENDA
        //CHAMAR API PARA GRAVAR SAT
      }

      this.sat = response;

      // this.errmessages = {}
      // if (response.status != 'success') {
      //     this.$erpToastError(response.message)
      // } else {
      //     if (response.response.nf.length > 0 && response.response.nf[0].cstat == '100') {
      //         this.$erpToastSuccess(response.message)
      //     }
      //     else {
      //         this.$erpToastError(response.response.nf[0].xmotivo)
      //     }
      // }
      // this.loadData()
    },
    handleClickCredito: function handleClickCredito() {
      var _this3 = this;

      //UTILIZAR CREDITO LOJA

      if (this.creditoLoja.saldo > 0) {
        this.$erpToastWarning("Este cliente possui saldo em crédito!");
      } else {
        return;
      }

      var idx = null;
      this.fpagList.forEach(function (pag, index) {
        if (pag.codfpag == _this3.creditoLoja.codfpag) idx = index;
      });

      if (!idx) {
        this.$erpToastError("Erro: Cadastre uma forma de pagamento Crédito Loja!");
        return;
      }

      this.valorPagamento = 0;
      this.saldoPagar = this.params.totalVenda - this.totalPago;
      if (this.creditoLoja.saldo < this.saldoPagar) {
        this.valorPagamento = this.creditoLoja.saldo;
      } else {
        this.valorPagamento = this.saldoPagar;
      }

      this.saldoPagar = this.params.totalVenda - this.totalPago - this.valorPagamento;

      this.handleClickFormaPagamento(idx);

      //       let pagamento = {
      //         valor: this.valorPagamento,
      //         troco: 0,
      //         fpag: this.selectedFormaPagamento,
      //         listParcelas: null
      //       };

      //       this.listPagamentos.push(pagamento);
      //       this.totalPago = parseFloat(this.totalPago) + parseFloat(this.valorPagamento);
      //       this.saldo = this.params.totalVenda - this.totalPago;
      //       this.valorPagamento = 0;
      //       this.saldoPagar = this.params.totalVenda - this.totalPago - this.valorPagamento;

      //       if (this.saldoPagar <= 0) {
      //         this.pagamentoFinalizado = true;
      //       }
    },
    handleFinalizaVenda: function handleFinalizaVenda() {
      //retorna os dados do pagamento para o objeto pai
      //emite o evento "finaliza"
      this.$emit("resultadopagamento", this.listPagamentos, this.selectedPart, this.email, "OK");
    },
    handleClickFormaPagamento: function handleClickFormaPagamento(index) {
      var _this4 = this;

      //BOTAO PAGAR, AO SELECIONAR UMA FORMA DE PAGAMENTO
      if (this.valorPagamento > 0) {
        //ADICIONA UMA FORMA DE PAGAMENTO
        this.selectedFormaPagamento = this.fpagList[index];

        //BOLETO, CHEQUE OU CARTAO CREDITO SELECIONADO
        if (this.selectedFormaPagamento.formapag == this.params.paramscaixa.tpag.cheque || this.selectedFormaPagamento.formapag == this.params.paramscaixa.tpag.boleto || this.selectedFormaPagamento.formapag == this.params.paramscaixa.tpag.credito) {
          this.showDigitacaoParcelas();
          return;
        }

        var troco = 0;

        if (this.saldoPagar < 0) {
          if (this.selectedFormaPagamento.formapag == this.params.paramscaixa.tpag.dinheiro) {
            troco = this.saldoPagar * -1;
          } else {
            this.$erpToastWarning("O valor informado não é permitido");
            return;
          }
        }

        //valida o saldo em credito
        if (this.selectedFormaPagamento.formapag == this.params.paramscaixa.tpag.creditoloja) {
          if (this.enableCreditoLoja && this.creditoLoja.saldo > 0) {
            var pagCredito = 0;
            this.listPagamentos.forEach(function (pag, index) {
              if (pag.fpag.codfpag == _this4.creditoLoja.codfpag) pagCredito += pag.valor;
            });
            if (pagCredito + this.valorPagamento > this.creditoLoja.saldo) {
              this.$erpToastWarning("O valor informado é superior ao saldo do cliente");
              return;
            }
          } else {
            this.$erpToastWarning("Forma de pagamento não permitida para clientes sem saldo em crédito");
            return;
          }
        }

        //
        var pagamento = {
          valor: this.valorPagamento,
          troco: troco,
          fpag: this.selectedFormaPagamento,
          listParcelas: null
        };

        this.listPagamentos.push(pagamento);

        this.totalPago = parseFloat(this.totalPago) + parseFloat(this.valorPagamento);

        this.saldo = this.params.totalVenda - this.totalPago;
        this.valorPagamento = this.saldo;
      }
      if (this.saldoPagar <= 0) {
        this.pagamentoFinalizado = true;
        this.handleSetFocusBtn();
      } else {
        this.valorPagamento = this.saldoPagar;
        this.$refs.paymentType.focus();
      }

      //SETANDO FOCO PARA BTN DEFAULT
      // if ((!this.selectedPart) || (!this.selectedPart.codpart) || (this.selectedPart.codpart && this.selectedPart.cnpjcpf == 'CONSUMIDOR')){
      //     this.selectedPart = null
      //     this.codpart = null
      //     this.$nextTick(function () {
      //         this.$refs.part.focus()
      //     })
      // }
    },
    handleSetFocusBtn: function handleSetFocusBtn() {
      var _this5 = this;

      this.$nextTick(function () {
        if (_this5.params_pdv.default_focus_btn_pag == "CP") {
          if (_this5.$refs.CP) {
            _this5.$refs.CP.focus();
          }
        }
        if (_this5.params_pdv.default_focus_btn_pag == "ES") {
          if (_this5.$refs.ES) {
            _this5.$refs.ES.focus();
          }
        }
        if (_this5.params_pdv.default_focus_btn_pag == "NC") {
          if (_this5.$refs.NC) {
            _this5.$refs.NC.focus();
          }
        }
        if (_this5.params_pdv.default_focus_btn_pag == "NF") {
          if (_this5.$refs.NF) {
            _this5.$refs.NF.focus();
          }
        }
        if (_this5.params_pdv.default_focus_btn_pag == "FV") {
          if (_this5.$refs.FV) {
            _this5.$refs.FV.focus();
          }
        }
      });
    },
    showDigitacaoParcelas: function showDigitacaoParcelas() {
      //MONTA OS PARAMETROS PARA DIGITACAO DAS PARCELAS
      this.paramParcelas = {
        parcelas: 1,
        valorPagamento: this.valorPagamento,
        cheque: this.selectedFormaPagamento.formapag == this.params.paramscaixa.tpag.cheque,
        cartaoCredito: this.selectedFormaPagamento.formapag == this.params.paramscaixa.tpag.credito,
        boleto: this.selectedFormaPagamento.formapag == this.params.paramscaixa.tpag.boleto,
        paramscaixa: this.params.paramscaixa
      };
      //EXIBE A DIGITACAO DAS PARCELAS
      this.showParcelas = true;
    },
    handleConfirmaParcelas: function handleConfirmaParcelas(parcelas, listParcelas) {
      //CONFIRMACAO DAS PARCELAS DAS VENDAS EM BOLETO, CHEQUE OU CARTAO
      //ADICIONA A FORMA DE PAGAMENTO E SUAS PARCELAS NA LISTA DE PAGAMENTOS EFETUADOS
      this.showParcelas = false;

      var pagamento = {
        valor: this.valorPagamento,
        troco: 0,
        fpag: this.selectedFormaPagamento,
        listParcelas: listParcelas,
        parcelas: listParcelas.length
      };

      this.listPagamentos.push(pagamento);

      this.totalPago = parseFloat(this.totalPago) + parseFloat(this.valorPagamento);

      this.saldo = this.params.totalVenda - this.totalPago;

      //SE O SALDO A PAGAR FOR 0, FINALIZA A VENDA
      if (this.saldoPagar == 0) {
        this.pagamentoFinalizado = true;
        this.$nextTick(function () {
          this.$refs.btnconfirmpag.focus();
        });
      } else {
        if (this.saldoPagar > 0) this.valorPagamento = this.saldoPagar;
        this.$refs.paymentType.focus();
      }
    },
    calculaParcelas: function calculaParcelas() {
      //CALCULA PARCELAS DO PEDIDO
      this.pedvpar = [];
      var vlr = 0;
      if (this.pedv.parcelas == "0") {
        var parcela = _extends({}, this.$store.getters.getEntities.pedvpar);
        parcela.dtv = this.pedv.data;
        parcela.vlr = this.pedv.totger;
        parcela.obspar = "";
        parcela.dias = 0;
        this.pedvpar.push(parcela);
      } else {
        for (var x = 1; x <= this.pedv.parcelas; x++) {
          var _parcela = _extends({}, this.$store.getters.getEntities.pedvpar);
          _parcela.dtv = this.$addMonths(this.pedv.data, x);
          _parcela.dias = x * 30;
          vlr = this.pedv.totger;
          vlr = arr(vlr / this.pedv.parcelas, 2, true);
          _parcela.vlr = vlr;
          _parcela.obspar = "";
          this.pedvpar.push(_parcela);
        }
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },
    parcelasVlrChange: function parcelasVlrChange(index) {
      //evento de controle de alteracao do valor da parcela
      //quando usuario alterar o valor de uma parcela, refaz as demais parcelas
      if (this.pedv.parcelas <= 1) {
        return;
      }
      var vlrparcial = 0;
      var vlrnovaparcela = 0;
      for (var x = 0; x <= index; x++) {
        vlrparcial = vlrparcial + parseFloat(this.pedvpar[x].vlr);
      }
      if (vlrparcial < this.pedv.totger) {
        vlrnovaparcela = (this.pedv.totger - vlrparcial) / (this.pedv.parcelas - (index + 1));
        vlrnovaparcela.toFixed(2);
      } else {}
      for (var x = index + 1; x <= this.pedvpar.length - 1; x++) {
        this.pedvpar[x].vlr = vlrnovaparcela;
      }
    },
    parcelasDiasChange: function parcelasDiasChange(index) {
      //evento de controle de alteracao do nr de dias de vencimento da parcela
      this.pedvpar[index].dtv = this.$addDays(this.pedv.data, this.pedvpar[index].dias);
    },
    parcelasBancoChange: function parcelasBancoChange(index) {},
    loadData: function loadData() {
      //await this.$store.dispatch('loadItemSales', { codtabpre: this.priceTab, filter: this.filter })

      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    }
  },

  components: {
    VarejoParcelasForm: __WEBPACK_IMPORTED_MODULE_2__varejo_parcelas_form__["a" /* default */],
    VarejoModalOpcoesFinal: __WEBPACK_IMPORTED_MODULE_4__varejo_modal_opcoes_final__["a" /* default */],
    Trap: __WEBPACK_IMPORTED_MODULE_5_vue_focus_lock___default.a
  },

  created: function created() {},
  destroyed: function destroyed() {
    clearInterval();
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      //const rect = this.$refs.pesquisa.getBoundingClientRect();
      jQuery('[data-toggle="tooltip"]').tooltip();
      this.$refs.paymentType.focus();
    });

    this.$store.dispatch("loadFpag", { filter: null, page: null });

    this.valorPagamento = this.params.totalVenda;
    this.saldoPagar = this.params.totalVenda;
    this.totalPago = 0;
    this.saldo = this.params.totalVenda - this.totalPago;

    this.codpart = this.params.codpart;
    this.email = this.params.email;
    this.pedv = this.params.pedv;

    this.loadCreditoLoja(this.selectedPart);
  }
});

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_numbers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_numbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_numbers__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//



/*
params: {
    valorPagamento: 0,
    data: '',
    cheque: false,
    boleto: false,
    cartaoCredito: false,
    listParcelas: [],
    qtparcelas: 0,
}
*/

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: {},
        params_pdv: ''
    },

    data: function data() {
        return {

            dadosParcela: {
                dias: 0,
                data: '',
                valor: 0,
                banco: '',
                documento: ''
            },
            parcelas: 0,
            listParcelas: []

        };
    },


    computed: {
        metadata: function metadata() {
            return this.$store.getters.getEntities.metadata;
        },
        nrExcedido: function nrExcedido() {
            if (!this.params.qtparcelas) {
                return false;
            } else {
                return this.parcelas > this.params.qtparcelas;
            }
        }
    },

    watch: {
        parcelas: function parcelas() {
            this.calculaParcelas();
        }

    },

    filters: {},

    methods: {
        cancelFormParcelas: function cancelFormParcelas() {
            this.$emit('cancel');
        },
        handleConfirmaParcelas: function handleConfirmaParcelas() {
            //AO CONFIRMAR AS PARCELAS, RETORNA O NUMERO DE PARCELAS E AS PARCELAS PARA O COMPONENTE PAI
            this.$emit('confirma', this.parcelas, this.listParcelas);
        },
        calculaParcelas: function calculaParcelas() {
            //CALCULA PARCELAS DO PEDIDO

            this.listParcelas = [];
            var vlr = 0;
            var soma = 0;
            var parcela = {};
            if (this.parcelas > 12) {
                this.$erpToastWarning("O máximo permitido é 12");
                this.parcelas = 0;
                return;
            }

            if (this.parcelas == '0') {
                parcela = _extends({}, this.dadosParcela);
                parcela.dtv = this.params.data;
                parcela.vlr = this.params.valorPagamento;
                parcela.obspar = '';
                parcela.dias = 0;
                this.listParcelas.push(parcela);
            } else {
                for (var x = 1; x <= this.parcelas; x++) {
                    parcela = _extends({}, this.dadosParcela);
                    parcela.dtv = this.$getDate();
                    parcela.dtv = this.$addMonths(parcela.dtv, x);
                    parcela.dias = x * 30;
                    vlr = this.params.valorPagamento;
                    vlr = Object(__WEBPACK_IMPORTED_MODULE_0__shared_numbers__["arr"])(vlr / this.parcelas, 2, true);
                    parcela.vlr = vlr;
                    parcela.obspar = '';
                    this.listParcelas.push(parcela);
                    soma = soma + vlr;
                }
                if (soma != this.params.valorPagamento) soma = this.params.valorPagamento - soma;else soma = 0;
                this.listParcelas[0].vlr = Object(__WEBPACK_IMPORTED_MODULE_0__shared_numbers__["arr"])(this.listParcelas[0].vlr + soma, 2, true);
            }
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
            });
        },
        parcelasVlrChange: function parcelasVlrChange(index) {
            //evento de controle de alteracao do valor da parcela
            //quando usuario alterar o valor de uma parcela, refaz as demais parcelas
            if (this.parcelas <= 1) {
                return;
            }
            var vlrparcial = 0;
            var vlrnovaparcela = 0;
            for (var x = 0; x <= index; x++) {
                vlrparcial = vlrparcial + parseFloat(this.listParcelas[x].vlr);
            }
            if (vlrparcial < this.params.valorPagamento) {
                vlrnovaparcela = (this.params.valorPagamento - vlrparcial) / (this.parcelas - (index + 1));
                vlrnovaparcela.toFixed(2);
            } else {}
            for (var x = index + 1; x <= this.listParcelas.length - 1; x++) {
                this.listParcelas[x].vlr = vlrnovaparcela;
            }
        },
        parcelasDiasChange: function parcelasDiasChange(index) {
            //evento de controle de alteracao do nr de dias de vencimento da parcela
            this.listParcelas[index].dtv = this.$addDays(this.pedv.data, this.listParcelas[index].dias);
        },
        parcelasBancoChange: function parcelasBancoChange(index) {
            //evento para repetir o banco ou documento do cheque para os demais cheques abaixo
            if (index + 1 == this.parcelas) {
                return;
            }

            var banco = this.listParcelas[index].banco;
            var documento = this.listParcelas[index].documento;

            for (var x = index + 1; x <= this.listParcelas.length - 1; x++) {
                this.listParcelas[x].banco = banco;
                this.listParcelas[x].documento = documento;
            }
        }
    },

    components: {},

    created: function created() {},
    mounted: function mounted() {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
            this.$refs.parcelas.focus();
        });
    }
});

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Trap: __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default.a
  },

  props: {
    params_pdv: {
      type: Object,
      default: function _default() {
        return { colors: {} };
      }
    }
  },

  data: function data() {
    return {
      selectedOption: null
    };
  },


  computed: {},

  methods: {
    handleEmit: function handleEmit() {
      this.$emit('selected', this.selectedOption);
    },
    handleSelect: function handleSelect(evt) {
      this.selectedOption = evt.target.value;
    },
    closeModal: function closeModal(event) {
      this.$emit("closeModal", event);
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      this.$refs.list.focus();
    });
  },
  beforeDestroy: function beforeDestroy() {}
});

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params: {}
  },

  data: function data() {
    return {
      lCrud: 'ins',

      vabertura: {
        codvcaixa: null,
        codfil: null,
        valor: 0,
        obs: null,
        data: null
      },

      listCaixas: [],
      codvcaixa: null,
      caixaaberto: false,
      aberturadecaixa: false,
      nomeoperador: null,
      uuidoperador: null,
      valor_ultimo_fechamento: 0,
      setFocusCaixa: false
    };
  },


  computed: {

    metadata: function metadata() {
      return this.$store.getters.getEntities.metadata;
    },

    usuarionome: function usuarionome() {
      return this.$store.getters.getEnv.usuarionome;
    },

    uuid: function uuid() {
      return this.$store.getters.getEnv.uuid;
    }

  },

  watch: {
    codvcaixa: function codvcaixa() {
      this.aberturadecaixa = false;

      if (this.codvcaixa) {
        this.vabertura.codvcaixa = this.codvcaixa;
        this.loadData();
      }
    }
  },

  filters: {},

  methods: {
    selectCaixa: function selectCaixa(evt) {
      this.codvcaixa = evt.target.value;
    },
    loadCaixaOptions: function loadCaixaOptions() {
      this.listCaixas = [];
      var self = this;
      Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDS"])(this.$store.getters.urlOrds + 'varejo/caixas', null, true).then(function (result) {
        result.items.forEach(function (caixa, idx) {
          if (caixa.aberto == 'S') self.listCaixas.push({ id: caixa.codvcaixa, value: caixa.caixa + ' (ABERTO)' });else self.listCaixas.push({ id: caixa.codvcaixa, value: caixa.caixa });
        });
      });
    },
    handleRetorna: function handleRetorna() {
      //BOTAO RETORNAR PARA VENDA
      this.$emit('resultadovabertura', null, 'RETORNA');
    },
    handleFinaliza: function handleFinaliza() {
      var _this = this;

      //retorna os dados do pagamento para o objeto pai
      //emite o evento "finaliza"
      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          _this.$emit('resultadovabertura', _this.vabertura, 'OK');
        }
      });
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.caixaaberto = false;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDS"])(_this2.$store.getters.urlOrds + 'varejo/ultimofechamento/' + _this2.vabertura.codvcaixa, null);

              case 3:
                data = _context.sent;

                if (data) {
                  _this2.valor_ultimo_fechamento = data.valor_ultimo_fechamento;
                  _this2.caixaaberto = data.caixaaberto;
                  _this2.nomeoperador = data.nomeoperador;
                  _this2.uuidoperador = data.uuid;
                  _this2.vabertura.codvabertura = data.codvabertura;
                }
                _this2.aberturadecaixa = !_this2.caixaaberto;
                _this2.vabertura.aberturadecaixa = !_this2.caixaaberto;
                _this2.vabertura.data = _this2.$getDate();

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleFocus: function handleFocus() {
      if (this.caixaaberto) {
        this.$refs.btnConfirma.focus();
      } else {
        this.$refs.valor.focus();
      }
    }
  },

  components: {
    Trap: __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default.a
  },

  created: function created() {},
  mounted: function mounted() {
    this.vabertura.data = this.$getDate();

    this.loadCaixaOptions();
    var self = this;
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
      self.$refs.listCaixas.focus();
      console.log('aqui');
      console.log(self.$refs.listCaixas);
      // self.setFocusCaixa = true
    });
  }
});

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_vmcaixa_form_vue__ = __webpack_require__(762);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_22da5748_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_vmcaixa_form_vue__ = __webpack_require__(2175);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_vmcaixa_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_22da5748_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_vmcaixa_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'varejo-vmcaixa-form',

  props: {
    params: {}
  },

  data: function data() {
    return {
      lCrud: 'ins',

      vmovcaixa: {
        tpmovcaixa: null,
        valor: 0,
        obs: null
      },

      vmovcaixaList: []

      // imprimirComprovante: true,
    };
  },


  computed: {

    metadata: function metadata() {
      return this.$store.getters.getEntities.metadata;
    },

    tpmovcaixaList: function tpmovcaixaList() {
      //lista de usuarios para selecao
      var options = [];
      options.push({ id: "E", text: "Reforço" });
      options.push({ id: "S", text: "Sangria" });
      options.push({ id: "A", text: "Abertura" });
      return options;
    }

  },

  watch: {},

  filters: {},

  methods: {
    handleRetorna: function handleRetorna() {
      //BOTAO RETORNAR PARA VENDA
      this.$emit('resultadovmovcaixa', null, 'RETORNA');
    },
    handleFinaliza: function handleFinaliza() {
      var _this = this;

      //retorna os dados do pagamento para o objeto pai
      //emite o evento "finaliza"
      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this.$erpToastError('Por favor, corrija os campos em destaque para continuar');
        } else {
          _this.$emit('resultadovmovcaixa', _this.vmovcaixa, 'OK');
        }
      });
    },
    handleImprimir: function handleImprimir(index) {
      this.codvmovcaixa = this.vmovcaixaList[index].codvmovcaixa;
    },
    handleConfirmaDelete: function handleConfirmaDelete(index) {
      this.$set(this.vmovcaixaList[index], 'confirmaexclusao', true);
    },
    handleDelete: function handleDelete(vmovcaixa) {
      this.vmovcaixa.confirmaexclusao = false;

      var self = this;

      Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSdelete"])(this.$store, 'varejo/vmovcaixa/' + vmovcaixa.codvmovcaixa).then(function (result) {
        self.loadData();
        self.$erpToastSuccess('O movimento foi excluído');
      });
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                modulo = '';

                if (_this2.params.tpmovcaixa == 'S') modulo = 'varejo/vmovcaixa/list/sangria/';else modulo = 'varejo/vmovcaixa/list/reforco/';

                modulo = modulo + _this2.params.codvabertura;

                _context.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDS"])(_this2.$store.getters.urlOrds + modulo, null);

              case 5:
                data = _context.sent;

                if (data.items) _this2.vmovcaixaList = data.items;else _this2.vmovcaixaList = [];

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },

  components: {
    Trap: __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default.a
  },

  created: function created() {},
  mounted: function mounted() {

    this.vmovcaixa.tpmovcaixa = this.params.tpmovcaixa;
    this.vmovcaixa.valor = this.params.valor;
    this.vmovcaixa.obs = this.params.obs;
    this.loadData();

    this.$nextTick(function () {
      //const rect = this.$refs.pesquisa.getBoundingClientRect();
      jQuery('[data-toggle="tooltip"]').tooltip();
      this.$refs.valor.focus();
    });
  }
});

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__varejo_fecharcaixa_form__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: "",
    pedvit: "",
    modalCrud: "",
    teste: "",
    pedv: "",
    value: ""
  },

  components: {
    fecharCaixa: __WEBPACK_IMPORTED_MODULE_0__varejo_fecharcaixa_form__["a" /* default */]
  },

  data: function data() {
    return {
      show: false,
      adminPass: "",
      editItemValue: "",
      errMessageModalEditItem: "",
      pedvit_update: ""
    };
  },


  computed: {
    showClass: function showClass() {
      if (!this.show) return "transform: translate3d(0%, 100%, 0);";else return "transform: translate3d(0%, 0, 0);";
    }
  },

  watch: {},

  filters: {},

  methods: {
    handleItemCancel: function handleItemCancel(index) {
      if (this.editItemValue) {
        index--;
      }
      if (this.pedv.stpedv != "D" && this.pedv.stpedv != "P") return;

      this.pedvit_update = index;
    },
    handleConfirmButtonPass: function handleConfirmButtonPass() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var obj, modulo, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this.adminPass || _this.adminPass == "")) {
                  _context.next = 3;
                  break;
                }

                _this.$erpToastError("Senha obrigatoria");
                return _context.abrupt("return");

              case 3:
                //executa a rotina do Enter do campo da sequencia do item
                _this.handleEnterModalEditIt();
                obj = {};

                obj.senha = _this.adminPass;

                modulo = "cg/valida/adminpass/";
                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSpost"])(_this.$store, modulo, obj, "post");

              case 9:
                data = _context.sent;

                if (data.resultado) {
                  _context.next = 13;
                  break;
                }

                _this.$erpToastError("Senha invalida");
                return _context.abrupt("return");

              case 13:
                _this.$emit("confirmedPass", _this.pedvit_update);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleEnterModalEditIt: function handleEnterModalEditIt() {
      if (this.editItemValue <= this.pedvit.length && this.editItemValue != 0) {
        this.modalCrud == "delete" && this.editItemValue ? this.handleItemCancel(this.editItemValue) : this.modalCrud == "update" && this.editItemValue ? this.$emit("updateMode", this.editItemValue) : "";
      }
      if (this.editItemValue == 0 || this.editItemValue == null || this.editItemValue > this.pedvit.length) {
        //Envia foco de volta ao input do component varejo-item-modal-side-form
        this.errMessageModalEditItem = "Valor não permitido";

        this.$nextTick(function () {
          this.$refs.itemvalue.focus();
        });
      }
    },
    handleRetorna: function handleRetorna() {
      this.editItemValue = null;
      this.$emit("closeModal");
    },
    handleInputModalEditIt: function handleInputModalEditIt() {
      if (this.editItemValue > this.pedvit.length) {
        if (this.editItemValue == null || this.editItemValue == 0) {
          return this.errMessageModalEditItem = "";
        } else {
          this.errMessageModalEditItem = "Valor não permitido";
        }
      } else {
        this.errMessageModalEditItem = "";
      }
    }
  },

  created: function created() {},
  mounted: function mounted() {
    if (this.pedvit.length <= 0) {
      this.$nextTick(function () {
        this.$refs.closeModalBtn.focus();
      });
    }
    var vm = this;
    this.keytimer = setTimeout(function () {
      // console.log(vm.filtros)
      vm.show = true;
    }, 100);

    if (this.value) {
      this.editItemValue = this.value;
      this.$nextTick(function () {
        this.$refs.senhaModal.focus();
      });
      return;
    }
    this.$nextTick(function () {
      this.$refs.itemvalue.focus();
    });
  }
});

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_focus_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_pedido_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_pedido_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__api_api_pedido_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__varejo_vmcaixa_form__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__varejo_emissao_cupom__ = __webpack_require__(129);
var _methods;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    VarejoEmissaoCupom: __WEBPACK_IMPORTED_MODULE_5__varejo_emissao_cupom__["a" /* default */],
    VarejoVmCaixaForm: __WEBPACK_IMPORTED_MODULE_4__varejo_vmcaixa_form__["a" /* default */],
    Trap: __WEBPACK_IMPORTED_MODULE_0_vue_focus_lock___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__api_api_pedido_js___default.a],
  props: {
    index: '',
    modal: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      errmessages: null,
      vabertura: null,
      formasPagamento: null,
      movimentosCaixa: null,
      vendasAbertas: null,
      resumoVendas: null,
      showVmovCaixaForm: false,
      paramsvmovcaixa: {},
      SHOW_CONFIRMADMINPASS: false,
      params_confirmAdminPass: null,
      valorfechamento_calculado: 0,
      showEmissaoCupomVmov: false,
      showEmissaoCupomFechamento: false,
      vmovcaixa: {}
    };
  },


  computed: {
    idView: function idView() {
      return !this.vabertura.aberto;
    },

    metadata: function metadata() {
      return this.$store.getters.getEntities.metadata;
    },

    varejoList: function varejoList() {
      return this.$store.getters.getPedvList;
    }
  },

  watch: {},

  filters: {},

  methods: (_methods = {
    handleEmissaoCupom: function handleEmissaoCupom(value) {
      this.vmovcaixa = { codvmovcaixa: value };
      this.showEmissaoCupomVmov = true;
    },
    handleResultadoEmissaoCupom: function handleResultadoEmissaoCupom() {
      this.showEmissaoCupomVmov = false;
      this.vmovcaixa = null;
    },
    handleEmissaoCupomFechamento: function handleEmissaoCupomFechamento() {
      this.showEmissaoCupomFechamento = true;
    },
    handleResultadoEmissaoCupomFechamento: function handleResultadoEmissaoCupomFechamento() {
      this.showEmissaoCupomFechamento = false;
      this.handleRetorna();
    },
    handleOpenVendaAberta: function handleOpenVendaAberta(venda) {
      if (venda && venda.codpedv) this.$router.push('/varejo/' + venda.codpedv);
    },
    responseVmovcaixa: function responseVmovcaixa(vmovcaixa, errmessages, validation) {
      if (validation) {
        this.paramsvmovcaixa.valor = this.vmovcaixa.valor;
        this.paramsvmovcaixa.obs = this.vmovcaixa.obs;
        this.showVmovCaixaForm = true;
        return;
      }

      this.errmessages = errmessages;

      if (this.errmessages == null || this.errmessages.length <= 0) {
        this.vmovcaixa = vmovcaixa;
        this.showEmissaoCupomVmov = true;
      } else {
        for (var x = 0; x < this.errmessages.errmessages.length; x++) {
          this.$erpToastError(this.errmessages.errmessages[x]);
        }
        this.errmessages = {};
      }

      this.loadData();
    },
    handleResultadoVmovCaixaForm: function handleResultadoVmovCaixaForm(paramvmovcaixa, result) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.showVmovCaixaForm = false;

                if (!(result == 'RETORNA')) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:

                if (result == 'OK') {
                  if (paramvmovcaixa) {
                    _this.vmovcaixa = paramvmovcaixa;
                    _this.vmovcaixa.codvabertura = _this.vabertura.codvabertura;
                    _this.apiVarejoVMovCaixa(_this.vmovcaixa, false, _this.responseVmovcaixa);
                  }
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showConfirmAdminPass: function showConfirmAdminPass(param) {
      this.SHOW_CONFIRMADMINPASS = true;
      this.params_confirmAdminPass = param;
    },
    hideConfirmAdminPass: function hideConfirmAdminPass() {
      this.SHOW_CONFIRMADMINPASS = false;
    },
    confirmAdminPass: function confirmAdminPass() {
      this.params_confirmAdminPass();
      this.hideConfirmAdminPass();
    },
    handleSangrar: function handleSangrar() {
      this.handleVmovCaixaForm('S');
    },
    handlerReforcar: function handlerReforcar() {
      this.handleVmovCaixaForm('E');
    },
    handleVmovCaixaForm: function handleVmovCaixaForm(valuetpmovcaixa) {
      this.paramsvmovcaixa.tpmovcaixa = valuetpmovcaixa;
      this.paramsvmovcaixa.codvabertura = this.vabertura.codvabertura;
      this.paramsvmovcaixa.valor = 0;
      this.paramsvmovcaixa.obs = null;
      this.showVmovCaixaForm = true;
    },
    handlerSangrar: function handlerSangrar() {
      this.handleVmovCaixaForm('S');
    }
  }, _defineProperty(_methods, 'handlerReforcar', function handlerReforcar() {
    this.handleVmovCaixaForm('E');
  }), _defineProperty(_methods, 'handleRetorna', function handleRetorna() {
    if (this.$route.path == '/varejo') this.$router.push('/varejolist');else this.$emit('closeform');
  }), _defineProperty(_methods, 'handleReabrir', function handleReabrir() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var sendData, data;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              sendData = {
                caixa: {
                  id: _this2.vabertura.codvabertura,
                  reabrir: true
                }
              };
              _context2.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this2.$store, 'varejo/controlecaixa/' + _this2.index + '/fechar', sendData, 'post');

            case 3:
              data = _context2.sent;

              _this2.loadData();
              if (data.errmessages) {
                _this2.$erpToastError('Erro na reabertura do caixa');
                _this2.errmessages = data.errmessages;
              } else _this2.$erpToastSuccess('Caixa Reaberto');

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }), _defineProperty(_methods, 'handleFechar', function handleFechar() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var sendData, data;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              sendData = {
                caixa: {
                  id: _this3.vabertura.codvabertura,
                  fechar: true,
                  obs: _this3.vabertura.obs,
                  valorfechamento: _this3.vabertura.valorfechamento,
                  formasPagamento: _this3.formasPagamento.lista
                }
              };
              _context3.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this3.$store, 'varejo/controlecaixa/' + _this3.index + '/fechar', sendData, 'post');

            case 3:
              data = _context3.sent;

              if (data.errmessages) {
                _this3.$erpToastError('Erro no fechamento do caixa');
                _this3.errmessages = data.errmessages;
              } else {
                _this3.$erpToastSuccess('Caixa Fechado');
                _this3.handleEmissaoCupomFechamento();
              }

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }), _defineProperty(_methods, 'loadData', function loadData() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var data;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDS"])(_this4.$store.getters.urlOrds + 'varejo/controlecaixa/' + _this4.index, null);

            case 2:
              data = _context4.sent;

              if (data) {
                _this4.vabertura = data;
                _this4.resumoVendas = _this4.vabertura.resumoVendas;
                _this4.formasPagamento = _this4.vabertura.formasPagamento;
                _this4.movimentosCaixa = _this4.vabertura.movimentosCaixa;
                _this4.vendasAbertas = _this4.vabertura.vendasAbertas;
              }

              _this4.valorfechamento_calculado = 0;
              //valor para fechamento do caixa deve ser a soma de abertura, reforço, sangria e pagamentos em dinheiro
              //os demais pagamentos não devem somar no valor em caixa
              _this4.valorfechamento_calculado += _this4.vabertura.valorEmCaixa;
              // if (this.formasPagamento && this.formasPagamento.total) {
              //   this.valorfechamento_calculado += this.formasPagamento.total
              // }
              // if (this.movimentosCaixa && this.movimentosCaixa.total) {
              //   this.valorfechamento_calculado += this.movimentosCaixa.total
              // }

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }), _defineProperty(_methods, 'loadPedv', function loadPedv() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var param;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              param = {
                query: Object.entries(_this5.query).filter(function (_ref) {
                  var _ref2 = _slicedToArray(_ref, 2),
                      _ = _ref2[0],
                      value = _ref2[1];

                  return value !== null;
                }).map(function (_ref3) {
                  var _ref4 = _slicedToArray(_ref3, 2),
                      key = _ref4[0],
                      value = _ref4[1];

                  return key + '=' + value;
                }).join("&") + (_this5.offset ? '&poffset=' + _this5.nextPage : "")
              };
              _context5.next = 3;
              return _this5.$store.dispatch("loadPedvList", param);

            case 3:
              _this5.offset = false;

            case 4:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }), _methods),

  created: function created() {
    this.loadData();
    if (this.modal) {
      this.loadPedv();
    }
  },
  mounted: function mounted() {

    this.$nextTick(function () {
      //const rect = this.$refs.pesquisa.getBoundingClientRect();
      jQuery('[data-toggle="tooltip"]').tooltip();
      //this.$refs.valor.focus()
    });
  }
});

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},

  components: {},

  data: function data() {
    return {
      erro: true,
      message: 'Gerando nota fiscal...',
      errmessages: []
    };
  },


  computed: {},

  watch: {},

  filters: {},

  methods: {
    handleCloseModal: function handleCloseModal() {
      this.$emit("closeModal");
    },
    enviando: function enviando() {
      this.message = 'Enviando nf-e...';
    },
    rejeitada: function rejeitada(msg, erro) {
      this.message = 'A nota fiscal foi rejeitada:';
      this.erro = true;
      this.errmessages = msg;
    }
  },

  created: function created() {},
  mounted: function mounted() {
    // this.erro = true
    // this.errmessages = ['tesste de rejeicao']
  }
});

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            datenow: ''
        };
    },

    methods: {
        time: function time() {
            var data = new Date();
            // Guarda cada pedaço em uma variável
            var dia = data.getDate(); // 1-31
            var mes = data.getMonth(); // 0-11 (zero=janeiro)
            var ano = data.getFullYear(); // 4 dígitos
            var hora = data.getHours(); // 0-23
            var min = data.getMinutes(); // 0-59
            var seg = data.getSeconds(); // 0-59


            var str_data = '' + (dia < 10 ? '0' : '') + dia + '/' + ('' + (mes < 10 ? '0' : '')) + (mes + 1) + '/' + ano;
            var str_hora = '' + (hora < 10 ? '0' : '') + hora + ':' + ('' + (min < 10 ? '0' : '')) + min + ':' + ('' + (seg < 10 ? '0' : '')) + seg;

            this.datenow = str_data + ' ' + str_hora;
        }
    },
    mounted: function mounted() {
        this.interval = setInterval(this.time, 1000);
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(this.interval);
    }
});

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    params_pdv: {
      type: Object,
      default: []
    },
    selectedPart: {
      type: Object,
      default: {}
    },
    client_editing: {
      type: Boolean,
      default: false
    },
    deletar: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      codpart: null,
      localPart: null
    };
  },

  methods: {
    handleConfirm: function handleConfirm() {
      // this.$refs.part.handleNewCostumer();
      this.$emit("changeCodpart", this.codpart);
      this.closeModal();
    },
    handleSetCodpart: function handleSetCodpart(selected) {
      console.log(selected);
      // this.$emit("changeCodpart", this.codpart);
      // this.closeModal();
    },
    closeModal: function closeModal() {
      this.$emit("close");
    },
    handleDeleteCliente: function handleDeleteCliente() {
      // this.$emit("changeCodpart", null);
      this.localPart = null;
      this.codpart = null;
      this.$nextTick(function () {
        this.$refs.part.focus();
      });
    },
    handleAlteraCliente: function handleAlteraCliente() {
      //REMOVE O CLIENTE SELECIONADO E ABRE PARA INFORMAR NOVO CLIENTE
      this.handleDeleteCliente();
    }
  },
  created: function created() {
    if (this.selectedPart) if (this.selectedPart.codpart || this.selectedPart.cnpjcpf) {
      this.localPart = _extends({}, this.selectedPart);
      if (this.selectedPart.codpart) this.codpart = this.localPart.codpart;else this.codpart = this.localPart.cnpjcpf;
    }
    this.$nextTick(function () {
      if (this.deletar) {
        this.handleDeleteCliente();
      }
      if (!this.localPart) {
        this.$refs.part.focus();
      } else {
        this.$refs.btnPart.focus();
      }
    });
  }
});

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  data: function data() {
    return {
      codpart: null,
      query: {
        text: null,
        after: null,
        before: null,
        codstatus: null
      },
      offset: false,
      isLoading: false,
      show: false
    };
  },

  computed: {
    varejoList: function varejoList() {
      return this.$store.getters.getPedvList;
    },
    filteredVarejoList: function filteredVarejoList() {
      return this.varejoList.filter(function (item) {
        return item.stpedv === 'D';
      });
    },
    nextPage: function nextPage() {
      return this.$store.getters.getNextPage;
    }
  },
  methods: {
    handleScroll: function handleScroll(event) {
      var _event$target = event.target,
          scrollTop = _event$target.scrollTop,
          scrollHeight = _event$target.scrollHeight,
          clientHeight = _event$target.clientHeight;

      if (scrollHeight - (scrollTop + clientHeight) < 50 && !this.isLoading && this.nextPage > 0) {
        this.loadMoreData();
      }
    },
    loadMoreData: function loadMoreData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.isLoading || _this.nextPage === 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _this.isLoading = true;
                _this.offset = true;
                _context.next = 6;
                return _this.loadData();

              case 6:
                _this.isLoading = false;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var param;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                param = { query: 'filtroorigem=4' + (_this2.offset ? '&poffset=' + _this2.nextPage : "") };
                _context2.next = 3;
                return _this2.$store.dispatch("loadPedvList", param);

              case 3:
                console.log(_this2.varejoList);
                _this2.offset = false;
                _this2.show = true;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    closeModal: function closeModal() {
      this.$emit("close");
    },
    handleEdit: function handleEdit(index) {
      this.$emit('selectedItem', index);
    },
    handleAction: function handleAction(index) {},
    statusColor: function statusColor(stpedv, tppedv) {
      if (stpedv === "C" || stpedv === "R" || tppedv === "R") return "badge-red";
      if (stpedv === "F") return "badge-blue";
      if (tppedv === "O") return "badge-orange";
      if (stpedv === "D") return "badge-warning";
      if (tppedv === "P") return "badge-green";
      return "badge-green";
    },
    textST: function textST(item) {
      var text = item.tppedv === "O" ? "Orçamento" : "Venda";
      if (item.tppedv === "R") return "Orçamento Perdido";
      if (item.stpedv === "C") text += " Cancelada";else if (item.stpedv === "R") text += " Rejeitado";else if (item.stpedv === "A") text += " Em Aprovação";else if (item.stpedv === "F") text = "Nota Emitida";else if (item.stpedv === "D") text += " Aberta";
      return text;
    },
    handleBarGrid: function handleBarGrid(stpedv) {
      return { barDefault: true, btnView: true };
    }
  },
  created: function created() {
    this.loadData();
  },
  beforeDestroy: function beforeDestroy() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip('dispose').removeAttr('data-toggle');
    });
  }
});

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_field_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_focus_lock__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_focus_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_focus_lock__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { formField: __WEBPACK_IMPORTED_MODULE_0__form_field_vue__["default"], Trap: __WEBPACK_IMPORTED_MODULE_2_vue_focus_lock___default.a },
    props: {
        params_pdv: {
            type: Object,
            default: {}
        },
        listMesas: {
            type: Array,
            default: []
        },
        listComandas: {
            type: Array,
            default: []
        }
    },
    data: function data() {
        return {
            showDetails: false,
            modoComanda: false,
            comandas: null,
            mesas: null,
            codigo: null,
            hasId: false,
            listaComandas: this.listComandas
        };
    },

    computed: {
        hasPedido: function hasPedido() {
            var mesas = this.listMesas;
            var idMesa = this.codigo;
            var hasPedido = false;
            mesas.find(function (mesa) {
                if (mesa.pedidos) {
                    if (mesa.id == idMesa) {
                        if (mesa.pedidos.length > 0) {
                            hasPedido = true;
                        }
                    }
                }
            });

            return hasPedido;
        },
        pesquisacomandaPlaceholder: function pesquisacomandaPlaceholder() {
            if (this.modoComanda) {
                return 'Digite número da comanda';
            }
            if (!this.modoComanda) {
                return 'Digite a mesa';
            }
        }
    },
    methods: {
        handleSetNewSale: function handleSetNewSale() {
            this.$emit('newSale', this.codigo);
        },
        handleChose: function handleChose(id) {
            if (id) {
                this.codigo = id;
                this.loadMesas(this.codigo);
            }

            if (!this.hasPedido) {
                this.$nextTick(function () {
                    this.$refs.newPed[0].focus();
                });
                return;
            }

            this.$nextTick(function () {
                this.$refs.ped0[0].focus();
            });
        },
        handleLeftNewPed: function handleLeftNewPed() {
            var index = this.mesas[0].pedidos.length;

            if (index <= 0) {
                if (this.$refs.pesquisacomanda) {
                    this.$nextTick(function () {
                        this.$refs.pesquisacomanda.focus();
                    });
                }
                return;
            }

            document.getElementById('ped' + (index - 1)).focus();
        },
        handleLeft: function handleLeft(index) {
            var indice = index - 1;
            if (indice < 0) {
                if (this.$refs.pesquisacomanda) {
                    this.$nextTick(function () {
                        this.$refs.pesquisacomanda.focus();
                    });
                }
                return;
            }
            document.getElementById('ped' + indice).focus();
        },
        handleRight: function handleRight(index, id) {
            var _this = this;

            var indice = index + 1;
            var indiceMesa = '';
            var self = this;

            this.mesas.find(function (mesa, index) {
                if (mesa.id == id) return indiceMesa = index;
            });

            if (indice >= this.mesas[indiceMesa].pedidos.length) {
                this.$nextTick(function () {
                    _this.$refs.newPed[0].focus();
                });
                return;
            }
            document.getElementById('ped' + indice).focus();
        },
        handleChosePedido: function handleChosePedido(id) {
            var _this2 = this;

            this.$emit('chosePedidoMesa', id);
            if (!id) {
                this.listaComandas.forEach(function (comanda) {
                    if (comanda.comanda == _this2.codigo) {
                        _this2.$emit('chosePedidoMesa', comanda.codpedv);
                    }
                });
            }
        },

        focusControl: function focusControl(event) {
            var thisIndex = jQuery(this.$el.querySelector('input')).index(__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].sFocusControl);
            var next = thisIndex + 1;
            var obj = jQuery(__WEBPACK_IMPORTED_MODULE_1__main__["SysVars"].sFocusControl);
            for (var x = next; x < obj.length; x++) {
                if (jQuery(obj[x]).prop("tabindex") === 1 && !jQuery(obj[x]).is("disabled")) {
                    jQuery(obj[x]).focus();
                    break;
                }
            }
        },
        loadMesas: function loadMesas(numeroMesa) {
            var _this3 = this;

            var mesas = this.listMesas.filter(function (mesa) {

                if (mesa.pedidos.length > 0 && !_this3.modoComanda) {
                    var valor = 0;
                    for (var i = 0; i < mesa.pedidos.length; i++) {
                        valor += mesa.pedidos[i].totmer;
                    }
                    mesa.totmesa = valor;
                }

                if (numeroMesa) return mesa.id == numeroMesa || mesa.descricao == numeroMesa;else if (_this3.params_pdv.tipo_controle_cm_ms == 'MC') {

                    _this3.comandas = [];
                    _this3.listaComandas = [];
                    _this3.listMesas.forEach(function (e) {
                        e.pedidos.forEach(function (ped) {
                            _this3.comandas.push(ped);
                            _this3.listaComandas.push(ped);
                        });
                    });
                } else return mesa;
            });
            var self = this;

            if (mesas.length > 0) {
                this.hasId = false;
                this.mesas = mesas;
                return;
            } else {
                this.mesas = mesas;
                this.hasId = true;
            }
            this.showDetails = false;
        },
        loadComandas: function loadComandas(codigo) {
            this.comandas = [];
            var comandas = this.listaComandas.filter(function (comanda) {
                if (codigo) return comanda.comanda == codigo;else return comanda;
            });
            this.comandas = comandas;
        },
        handleCloseSidebar: function handleCloseSidebar() {
            this.$emit('close');
        }
    },
    watch: {
        codigo: function codigo(n, o) {
            o = '';
            n = '';
            this.showDetails = false;
            if (this.modoComanda) {
                this.loadComandas(this.codigo);
            }
            if (!this.modoComanda) {
                var self = this;
                setInterval(function () {
                    if (self.codigo) {
                        self.showDetails = true;
                    }
                    self.loadMesas(self.codigo);
                }, 200);
            }
        },

        modoComanda: {
            handler: function handler(before, afeter) {
                var _this4 = this;

                if (this.modoComanda && this.params_pdv.tipo_controle_cm_ms == 'MC') {
                    this.codigo = '';
                    this.comandas = [];
                    this.listaComandas = [];
                    if (this.params_pdv.tipo_controle_cm_ms == 'MC') {
                        this.listMesas.forEach(function (e) {
                            e.pedidos.forEach(function (ped) {
                                _this4.comandas.push(ped);
                                _this4.listaComandas.push(ped);
                            });
                        });
                        return;
                    } else {
                        this.comandas = _extends({}, this.listaComandas);
                    }
                }
                if (!this.modoComanda) {
                    this.codigo = '';
                    this.mesas = _extends({}, this.listMesas);
                }
            },
            immediate: true

        }

        // numeroPedido() {
        //     this.loadPedidos(this.numeroPedido)
        // }
    },
    created: function created() {
        var _this5 = this;

        this.listMesas.forEach(function (e, indice) {
            if (!_this5.listMesas[indice].hasOwnProperty('pedidos')) {
                _this5.listMesas[indice].pedidos = [];
            }
        });
    },
    mounted: function mounted() {
        var _this6 = this;

        this.comandas = [];
        if (!this.params_pdv.listMesas || this.params_pdv.listMesas == null || this.params_pdv.listMesas.length <= 0 || this.params_pdv.tipo_controle_cm_ms == 'CM') {
            this.modoComanda = true;
            this.loadComandas();
        }

        if (!this.modoComanda && this.params_pdv.listMesas.length > 0) {
            this.modoComanda = false;
            this.loadMesas();
        }

        if (this.params_pdv.tipo_controle_cm_ms == 'MC') {
            this.modoComanda = false;

            setTimeout(function () {
                _this6.modoComanda = false;
            }, 10);

            this.loadMesas();
            clearTimeout();
        }
        this.$nextTick(function () {
            this.$refs.pesquisacomanda.focus();
        });
        var self = this;

        window.addEventListener('keyup', function (event) {
            if (event.altKey) {
                if (event.keyCode == 78) {
                    self.handleSetNewSale('newSale', this.codigo);
                }
            }
        });
    }
});

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_field_vue__ = __webpack_require__(117);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        FormField: __WEBPACK_IMPORTED_MODULE_0__form_field_vue__["default"]
    },
    props: {
        tabelaPreco: {
            type: String,
            require: true
        },
        itemsList: {
            type: Array,
            require: true
        }
    },
    data: function data() {
        return {
            product: null,
            productQty: 1,
            showDestaques: true,
            showItems: false,
            showModal: false,
            numeroDestaque: null,
            destaques: null,
            interval: null
        };
    },

    computed: {

        nextPage: function nextPage() {
            return this.$store.getters.getNextPage;
        },
        destaqList: function destaqList() {
            return this.$store.getters.getDestaqList;
        },
        products: function products() {
            return this.$store.getters.getItemSalesList;
        }
    },
    methods: {
        handleEnterObs: function handleEnterObs() {
            this.$nextTick(function () {
                this.$refs.btnAdic.focus();
            });
        },
        handleRetorna: function handleRetorna() {
            if (this.showModal) {
                this.showCloseDetalhes();
                this.$nextTick(function () {
                    document.getElementById('id' + 0).focus();
                });
            }
            if (!this.showItems && this.showDestaques) {
                this.handleClose();
            }
        },
        handleEnter: function handleEnter() {
            this.$nextTick(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.$refs.destaqueobs.focus();

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            })));
        },
        handleLeft: function handleLeft(i) {
            var indice = i - 1;
            if (indice < 0) {
                this.handleReturnDestaques();
                return;
            }

            document.getElementById('id' + indice).focus();
        },
        handleRight: function handleRight(i) {
            var indice = i + 1;
            if (indice >= this.products.length) {
                return;
            }
            this.$nextTick(function () {
                document.getElementById('id' + indice).focus();
            });
        },
        loadDestaques: function loadDestaques(numeroDestaque) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var destaques;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                destaques = _this.$store.getters.getDestaqList.filter(function (dest) {
                                    var desc = dest.descricao.toString();
                                    if (numeroDestaque) return desc.match(numeroDestaque) || dest.coddestaq.match(numeroDestaque);else return dest;
                                });

                                _this.destaques = destaques;

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }))();
        },
        loadData: function loadData() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this2.$store.dispatch('loadDestaq', {
                                    filter: '',
                                    page: _this2.nextPage
                                });

                            case 2:
                                _this2.loadDestaques();

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this2);
            }))();
        },
        showItemsDestaque: function showItemsDestaque(coddestaq) {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (coddestaq) {
                                    _context4.next = 2;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 2:
                                _context4.next = 4;
                                return _this3.$store.dispatch('loadItemSales', {
                                    codtabpre: _this3.tabelaPreco,
                                    codpedv: 0,
                                    filter: '{"coddestaq":{"$eq":' + coddestaq + '}}',
                                    produtosDestaque: true
                                });

                            case 4:

                                _this3.qtyItem();
                                _this3.showDestaques = false;
                                _this3.showItems = true;
                                _this3.$nextTick(function () {
                                    document.getElementById('id' + 0).focus();
                                });

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this3);
            }))();
        },
        showModalDetalhes: function showModalDetalhes(product) {
            this.product = product;
            this.showModal = true;
            var self = this;
            this.$nextTick(function () {
                document.getElementById('quantidadedest').focus();
            });
        },
        showCloseDetalhes: function showCloseDetalhes() {
            this.showModal = false;
            document.getElementById('id' + 0).focus();
            this.productQty = 1;
        },
        handleAdicionar: function handleAdicionar(product, productQty) {
            product.quantidade = parseInt(productQty);
            product.qty += parseInt(product.quantidade);
            this.$emit('newItem', product);
            this.showCloseDetalhes();
            this.$nextTick(function () {
                document.getElementById('id' + 0).focus();
            });
        },
        handleClose: function handleClose() {
            this.$emit('closeDestaques');
        },
        subtract: function subtract() {
            if (this.productQty === 1) {
                return;
            }
            this.productQty--;
        },
        qtyItem: function qtyItem() {
            var items = this.itemsList;
            var products = this.products;

            for (var i = 0; i < products.length; i++) {
                var product = products[i];
                product.qty = 0;

                for (var _i = 0; _i < items.length; _i++) {
                    var item = items[_i];

                    if (item.coditem == product.coditem) {
                        product.qty = parseInt(product.qty) + parseInt(item.qt);
                    }
                }
            }
        },
        handleReturnDestaques: function handleReturnDestaques() {
            this.loadData();
            this.showDestaques = true;
            this.showItems = false;

            this.$nextTick(function () {
                this.$refs.pesquisaDestaque.focus();
            });
        }
    },
    created: function created() {
        this.loadData();
        this.$nextTick(function () {
            this.$refs.pesquisaDestaque.focus();
        });
    },
    mounted: function mounted() {
        var self = this;

        window.addEventListener('keyup', function (event) {
            if (event.keyCode == 27) {
                self.handleRetorna();
            }
        });
    },
    destroyed: function destroyed() {
        clearInterval(this.interval);
        this.interval = '';
    },

    watch: {
        numeroDestaque: function numeroDestaque() {
            var _this4 = this;

            if (this.numeroDestaque) {
                this.interval = setInterval(function () {
                    _this4.loadDestaques(_this4.numeroDestaque.toUpperCase());
                }, 200);
            }
        }
    }
});

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params_pdv: {
            type: Object,
            default: []
        }

    },
    data: function data() {
        return {
            quantidade: 1
        };
    },

    methods: {
        handleConfirmQtd: function handleConfirmQtd() {
            var qtdInformada = this.quantidade;
            this.$emit('getQtdInformada', qtdInformada);
            this.closeModal();
        },
        changeToNextEl: function changeToNextEl() {
            this.$nextTick(function () {
                this.$refs.qtdConfirmButton.focus();
            });
        },
        closeModal: function closeModal() {
            this.$emit('close');
        }
    },
    created: function created() {
        this.$nextTick(function () {
            this.quantidade = 1;
            this.$nextTick(function () {
                this.$refs.qtd.focus();
            });
        });

        window.addEventListener('keyup', function (event) {
            if (event.keyCode == 27) {
                this.closeModal();
            }
        });
    }
});

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params_pdv: {
            type: Object,
            default: []
        },
        pedv: ''

    },
    data: function data() {
        return {
            obs: ''
        };
    },

    methods: {
        handleConfirmObs: function handleConfirmObs() {
            var obs = this.obs;
            var mesa = this.pedv.mesa;
            console.log('teste');
            this.$emit('getObs', { obs: obs, mesa: mesa });
            this.closeModal();
        },
        changeToNextEl: function changeToNextEl() {
            this.$nextTick(function () {
                this.$refs.obsConfirmButton.focus();
            });
        },
        closeModal: function closeModal() {
            this.$emit('close');
        }
    },
    created: function created() {
        this.$nextTick(function () {
            this.obs = '';
            this.$nextTick(function () {
                this.$refs.obs.focus();
            });
        });

        window.addEventListener('keyup', function (event) {
            if (event.keyCode == 27) {
                this.closeModal();
            }
        });
    }
});

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__varejo_fecharcaixa_form__ = __webpack_require__(183);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"],
    fecharCaixa: __WEBPACK_IMPORTED_MODULE_2__varejo_fecharcaixa_form__["a" /* default */]
  },
  props: {
    params_pdv: {
      type: Object,
      default: function _default() {
        return { colors: {} };
      }
    },
    caixa: null
  },
  data: function data() {
    return {
      showForm: false,
      codvabertura: null,
      filter: "",
      monthQuery: "",
      textQuery: "",
      statusQuery: "",
      filtroStatus: {
        list: [{ id: 0, label: "Todos" }, { id: 1, label: "Em Aberto" }, { id: 2, label: "Fechados" }, { id: 3, label: "Conferidos" }],
        index: 0
      },
      query: {
        codusuario: null,
        codequipe: null,
        text: null,
        after: null,
        before: null,
        codstatus: null
      },
      vaberturaList: [],
      isLoading: false,
      offset: false
    };
  },

  computed: {
    labelStatus: function labelStatus() {
      return this.filtroStatus.list[this.filtroStatus.index].label;
    },
    headerStyle: function headerStyle() {
      return {
        background: this.params_pdv.colors.bg_top_bottom || "#174b79"
      };
    },
    titleStyle: function titleStyle() {
      return {
        color: this.params_pdv.colors.fc_top_bottom || "white"
      };
    }
  },
  methods: {
    // handleScroll(event) {
    //   const { scrollTop, scrollHeight, clientHeight } = event.target;
    //   if (scrollHeight - (scrollTop + clientHeight) < 50 && !this.isLoading) {
    //     this.loadMoreData();
    //   }
    // },
    // async loadMoreData() {
    //   if (this.isLoading) return;
    //   this.isLoading = true;
    //   this.offset = true;
    //   await this.loadData();
    //   this.isLoading = false;
    // },
    loadData: function loadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var param, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                param = {};

                param.query = "";

                if (_this.filtroStatus.index) {
                  param.query += "status=" + _this.filtroStatus.index + "&";
                }
                if (_this.query.text) {
                  param.query += "text=" + _this.query.text + "&";
                }
                if (_this.query.after) {
                  param.query += "after=" + _this.query.after + "&";
                }
                if (_this.query.before) {
                  param.query += "before=" + _this.query.before + "&";
                }
                if (_this.offset) {
                  param.query += "poffset=" + _this.vaberturaList.length + "&";
                }

                param.query = param.query.trim();
                if (param.query.endsWith("&")) {
                  param.query = param.query.slice(0, -1);
                }

                _context.next = 11;
                return Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDS"])(_this.$store.getters.urlOrds + "varejo/controlecaixa/list", param);

              case 11:
                data = _context.sent;

                if (data.items) {
                  _this.vaberturaList = _this.offset ? [].concat(_toConsumableArray(_this.vaberturaList), _toConsumableArray(data.items)) : data.items;
                }

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleShowForm: function handleShowForm(caixa) {
      this.codvabertura = caixa.codvabertura;
      this.showForm = true;
    },
    handleChangeFiltroStatus: function handleChangeFiltroStatus(index) {
      this.filtroStatus.index = index;
      this.loadData();
    },
    changeFiltroTexto: function changeFiltroTexto(value) {
      this.query.text = value.toUpperCase();
      this.query.after = null;
      this.query.before = null;
      this.loadData();
    },
    changeFiltroMes: function changeFiltroMes(filter, startDate, endDate) {
      this.query.after = startDate;
      this.query.before = endDate;
      this.query.text = null;
      this.loadData();
    },
    closeModal: function closeModal() {
      this.$emit("close");
    }
  },
  created: function created() {
    var _this2 = this;

    this.loadData();
    window.addEventListener("keyup", function (event) {
      if (event.key === "Escape") _this2.closeModal();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("keyup", this.closeModal);
  }
});

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pedido_filtro__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bar_grid_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consultas_consulta_varejo_pendcli_vue__ = __webpack_require__(484);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BarGrid: __WEBPACK_IMPORTED_MODULE_2__components_bar_grid_vue__["default"],
    Barlist: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"],
    PedidoFiltro: __WEBPACK_IMPORTED_MODULE_1__components_pedido_filtro__["a" /* default */],
    ConsultaVarejoPendcli: __WEBPACK_IMPORTED_MODULE_3__consultas_consulta_varejo_pendcli_vue__["default"]
  },

  props: {
    codvabertura: null
  },

  data: function data() {
    return {

      show: true
    };
  },


  methods: {
    closeModal: function closeModal() {
      this.$emit("close");
    }
  },
  computed: {},
  created: function created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip('dispose').removeAttr('data-toggle');
    });
  }
});

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_filter_list__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__varejo_controlecaixa_form__ = __webpack_require__(2227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__varejo_emissao_cupom__ = __webpack_require__(129);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"],
    BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"],
    ControlecaixaForm: __WEBPACK_IMPORTED_MODULE_6__varejo_controlecaixa_form__["a" /* default */],
    VarejoEmissaoCupom: __WEBPACK_IMPORTED_MODULE_7__varejo_emissao_cupom__["a" /* default */]
  },

  props: {
    params_pdv: {
      type: Object,
      default: function _default() {
        return { colors: {} };
      }
    }
  },

  data: function data() {
    var _ref;

    return _ref = {
      showForm: false,
      showCupom: false,
      codvabertura: null,
      filter: "",
      monthQuery: "",
      textQuery: "",
      statusQuery: "",
      filterList: [],
      paramFilterList: {},
      metadata: this.$store.getters.getEntities.metadata,

      SHOW_CONFIRMADMINPASS: false,
      params_confirmAdminPass: "",

      vaberturaList: []
    }, _defineProperty(_ref, "vaberturaList", []), _defineProperty(_ref, "filtroStatus", {
      list: [{ id: 0, label: "Todos" }, { id: 1, label: "Em Aberto" }, { id: 2, label: "Fechados" }, { id: 3, label: "Conferidos" }],
      index: 0
    }), _defineProperty(_ref, "query", {
      codusuario: null,
      codequipe: null,
      text: null,
      after: null,
      before: null,
      codstatus: null
    }), _ref;
  },


  computed: {
    labelStatus: function labelStatus() {
      return this.filtroStatus.list[this.filtroStatus.index].label;
    }
  },

  methods: {
    confirmAdminPass: function confirmAdminPass() {
      this.SHOW_CONFIRMADMINPASS = false;
      this.params_confirmAdminPass();
    },
    showConfirmAdminPass: function showConfirmAdminPass(params) {
      this.SHOW_CONFIRMADMINPASS = true;
      this.params_confirmAdminPass = params;
    },
    hideConfirmAdminPass: function hideConfirmAdminPass() {
      this.SHOW_CONFIRMADMINPASS = false;
    },
    handleChangeUser: function handleChangeUser(caixa) {
      this.codvabertura = caixa.codvabertura;
      this.showConfirmAdminPass(this.handlerUpdateUser);
    },
    handlerUpdateUser: function handlerUpdateUser() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var sendData, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.codvabertura) {
                  _context.next = 7;
                  break;
                }

                sendData = {
                  caixa: {
                    id: _this.codvabertura
                  }
                };
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDSpost"])(_this.$store, 'varejo/controlecaixa/' + _this.codvabertura + '/operador', sendData, 'post');

              case 4:
                data = _context.sent;

                _this.loadData();
                if (data.errmessages) {
                  _this.$erpToastError('Erro erro ao mudar operador do caixa');
                  _this.errmessages = data.errmessages;
                } else _this.$erpToastSuccess('Caixa atualizado');

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleShowForm: function handleShowForm(caixa) {
      this.codvabertura = caixa.codvabertura;
      this.showForm = true;
    },
    handleShowCupom: function handleShowCupom(caixa) {
      this.codvabertura = caixa.codvabertura;
      this.showCupom = true;
    },
    handleResultadoEmissaoCupomFechamento: function handleResultadoEmissaoCupomFechamento() {
      this.showCupom = false;
    },
    handleChangeFiltroStatus: function handleChangeFiltroStatus(obj) {
      this.filtroStatus.index = obj.id;
      this.loadData();
    },


    statusColor: function statusColor(stpedv, tppedv) {
      var color = "badge-green";
      if (stpedv == "C" || stpedv == "R" || tppedv == "R") {
        color = "badge-red";
      } else if (stpedv == "F") {
        color = "badge-blue";
      } else if (tppedv == "O") {
        color = "badge-orange";
      } else if (tppedv == "P") {
        color = "badge-green";
      }
      return color;
    },

    closeForm: function closeForm() {
      this.showForm = false;
      this.$scrollTo(0);
      this.loadData();
    },
    changeFiltroTexto: function changeFiltroTexto(value) {
      //efetua a pesquisa por texto
      this.query.text = value.toUpperCase();
      this.query.after = null;
      this.query.before = null;
      this.loadData();
    },
    horaStatus: function horaStatus(hora) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__shared_utils__["formatDataHoraExtenso"])(hora);
    },
    changeFiltroMes: function changeFiltroMes(filter, startDate, endDate) {
      this.query.after = startDate;
      this.query.before = endDate;
      this.query.text = null;
      this.loadData();
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var param, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                param = {};

                param.query = "";

                // if (this.query.text)
                //   param.query = param.query + 'text=' + this.query.text + '&'
                // if (this.query.after)
                //   param.query = param.query + 'after=' + this.query.after + '&'
                // if (this.query.before)
                //   param.query = param.query + 'before=' + this.query.before + '&'
                // if (this.query.codstatus)
                //   param.query = param.query + 'codstatus=' + this.query.codstatus + '&'

                param.query = null;
                if (_this2.filtroStatus.index) if (_this2.filtroStatus.index == 1) param.query = "status=aberto";else if (_this2.filtroStatus.index == 2) param.query = "status=fechado";else if (_this2.filtroStatus.index == 3) param.query = "status=conferido";

                _context2.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_3__shared_api_functions__["apiORDS"])(_this2.$store.getters.urlOrds + "varejo/controlecaixa/list", param);

              case 6:
                data = _context2.sent;

                if (data.items) _this2.vaberturaList = data.items;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },

  created: function created() {
    if (this.$route.params.id) {
      this.showForm = true;
      this.codvabertura = this.$route.params.id;
    }
    this.loadData();
  }
});

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__varejo_fecharcaixa_form__ = __webpack_require__(183);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        index: ''
    },

    components: {
        fecharCaixa: __WEBPACK_IMPORTED_MODULE_0__varejo_fecharcaixa_form__["a" /* default */]
    },

    data: function data() {
        return {};
    },


    computed: {},

    watch: {},

    filters: {},

    methods: {
        handleRetorna: function handleRetorna() {
            this.$emit('closeform');
        }
    },

    created: function created() {},
    mounted: function mounted() {}
});

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_filter_list__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consultas_filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_csvReport__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_csvReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_csvReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      filter: '',
      metadata: this.$store.getters.getEntities.metadata,
      moreActionsBarList: [],
      monthFilter: {},
      statusQuery: '',
      filterList: [],
      paramFilterList: {},
      showForm: false,
      codfin: '',
      url: '',
      textQuery: '',
      dados: [],
      resumo: [],
      totais: null,

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      showfiltro: false,
      paramsFiltro: {
        periodo: {
          label: "Data de Vencimento",
          varios: false,
          data_inicio: null,
          data_termino: null
        },
        filtros: [{
          nome: "formapagamento",
          label: null,
          url: null,
          varios: false,
          values: []
        }, {
          nome: "filial",
          label: null,
          url: null,
          varios: false,
          values: []
        }]
      },
      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }]
      }

    };
  },


  computed: {},

  watch: {
    finTotal: function finTotal() {
      //AQUI MONTA O OBJETO PARA A LISTA DE FILTROS DO COMPONENTE filter-list BASEADO NO OBJETO DE TOTAIS CARREGADO DO SERVIDOR

      this.filterList = [];
      var total = {};

      var tot = 0;
      var qt = 0;
      for (var i = 0; i < this.finTotal.length; i++) {
        tot = tot + this.finTotal[i].total;
        qt = qt + this.finTotal[i].qt;
      }

      for (var _i = 0; _i < this.finTotal.length; _i++) {
        total = {};
        total.label = '';
        total.total = this.finTotal[_i].total;
        total.qt = this.finTotal[_i].qt;
        total.status = this.finTotal[_i].status;
        //calcula o % em relacao ao total
        if (tot > 0) {
          total.perc = total.total / tot * 100;
        }
        if (total.status == 'VENCIDOS') {
          total.label = 'Vencidos';
        } else if (total.status == 'ABERTOS') {
          total.label = 'A Receber';
        } else if (total.status == 'RECEBIDOS') {
          total.label = 'Recebidos';
        }
        this.filterList.push(_extends({}, total));
      }
      total = {};
      total.status = 'TOTAL';
      total.label = 'Total';
      total.total = tot;
      total.qt = qt;
      this.filterList.push(_extends({}, total));
      this.paramFilterList = { total: this.filterList, selectedStatus: '' };
    }
  },
  methods: {
    handleShowFiltro: function handleShowFiltro() {
      this.showfiltro = true;
    },
    filtroChange: function filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;
      this.paramsFiltro.filtros[0].values = this.filtro.formapagamento;
      this.paramsFiltro.filtros[1].values = this.filtro.filial;

      this.loadData(false);
    },
    closeForm: function closeForm() {
      this.showForm = false;
      this.loadData(false);
    },
    loadData: function loadData(excel) {
      var url = "consulta/vendas/varejorecebiveis";

      this.filtro.excel = excel;

      if (excel) Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiDownload2"])(this, url, this.filtro, "post");else {
        this.mounting = true;
        var self = this;
        Object(__WEBPACK_IMPORTED_MODULE_6__shared_api_functions__["apiORDSpost"])(this.$store, url, this.filtro, "post").then(function (data) {
          self.dados = data.items;
          self.resumo = data.resumo;
          self.totais = data.totais;
          self.mounting = false;
        });
      }
    },
    textST: function textST(aberto, baixado, cancelado) {
      if (aberto === 'S') {
        return 'A Receber';
      } else if (baixado === 'S') {
        return 'Recebido';
      } else if (cancelado === 'S') {
        return 'Cancelado';
      }
    }
  },

  filters: {},

  components: {
    BarList: __WEBPACK_IMPORTED_MODULE_1__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_2__components_bar_grid__["default"], FilterList: __WEBPACK_IMPORTED_MODULE_3__components_filter_list__["a" /* default */], Filtro: __WEBPACK_IMPORTED_MODULE_4__consultas_filtro__["a" /* default */]
  },

  created: function created() {
    this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate());
    this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate());
    this.loadData(false);
  }
});

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pedido_filtro__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bar_grid_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__varejo_devolucao_form_vue__ = __webpack_require__(752);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BarGrid: __WEBPACK_IMPORTED_MODULE_2__components_bar_grid_vue__["default"],
        Barlist: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"],
        PedidoFiltro: __WEBPACK_IMPORTED_MODULE_1__components_pedido_filtro__["a" /* default */],
        DevolucaoForm: __WEBPACK_IMPORTED_MODULE_4__varejo_devolucao_form_vue__["a" /* default */]
    },

    data: function data() {
        return {
            pedv: this.$store.getters.getPedvDev,
            query: {
                codusuario: null,
                codequipe: null,
                text: null,
                after: null,
                before: null,
                codstatus: null,
                showForm: false
            },
            codvdevol: 0,
            showForm: false,
            crud: ''
        };
    },


    methods: _defineProperty({
        loadData: function loadData() {
            var param = {};
            param.query = '';

            if (this.query.text) param.query = param.query + 'text=' + ('' + this.query.text) + '&';
            if (this.query.after) param.query = param.query + 'after=' + this.query.after + '&';
            if (this.query.before) param.query = param.query + 'before=' + this.query.before + '&';
            if (this.query.codusuario) param.query = param.query + 'usuario=' + this.query.codusuario + '&';
            if (this.query.codequipe) param.query = param.query + 'equipe=' + this.query.codequipe + '&';
            if (this.query.codstatus) param.query = param.query + 'codstatus=' + this.query.codstatus + '&';
            if (this.statusQuery) param.query = param.query + this.statusQuery + '&';

            param.query = param.query.trim('&');
            this.$store.dispatch('loadvDevolList', param);

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip();
            });
        },
        handleAutorizaNF: function handleAutorizaNF(path) {
            return this.$router.push('/nf/' + path + '?tipo=devolucao');
        },
        changeFiltroTexto: function changeFiltroTexto(value) {
            this.query.text = value.toUpperCase();
            this.query.after = null;
            this.query.before = null;
            this.loadData();
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData();
        },
        handleNew: function handleNew() {
            this.codvdevol = null;
            this.showForm = false;
            return this.$router.push('/varejolist/devolucao');
        },
        handleView: function handleView(cod) {
            this.crud = __WEBPACK_IMPORTED_MODULE_3__main__["SysVars"].crudView;
            this.codvdevol = cod;
            this.showForm = true;
        },
        changeFiltros: function changeFiltros() {
            this.query.text = null;
            this.loadData();
        },
        changeFiltroMes: function changeFiltroMes(filter, startDate, endDate) {

            this.query.after = startDate;
            this.query.before = endDate;
            this.query.text = null;
            this.loadData();
        }
    }, 'changeFiltroTexto', function changeFiltroTexto(value) {
        this.query.text = value.toUpperCase();
        this.query.after = null;
        this.query.before = null;
        this.loadData();
    }),
    computed: {
        pedvDevList: function pedvDevList() {
            return this.$store.getters.getvDevolList;
        }
    },
    created: function created() {
        this.loadData();
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        });
    }
});

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_filter_list__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consultas_filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_csvReport__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_csvReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_csvReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_google_charts_legacy__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_google_charts_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_google_charts_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__consultas_chart_vue__ = __webpack_require__(20);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,
            moreActionsBarList: [],
            monthFilter: {},
            statusQuery: '',
            filterList: [],
            paramFilterList: {},
            showForm: false,
            codfin: '',
            url: '',
            textQuery: '',
            dados: [],
            resumo: [],
            totais: null,
            fluxoCaixaDados: null,
            showModal: false,
            showModalDiario: false,
            dadosDetalhes: '',
            contas: null,
            listContas: null,
            atrasos: false,
            atrasosTempo: null,
            tipo: 'M',
            tipoOptions: [{ id: 'D', text: "Diário" }, { id: 'M', text: "Mensal" }],

            //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
            showfiltro: false,
            paramsFiltro: {
                periodo: {
                    label: "Período",
                    varios: false,
                    data_inicio: null,
                    data_termino: null
                },
                filtros: [{
                    nome: "formapagamento",
                    label: null,
                    url: null,
                    varios: false,
                    values: []
                }, {
                    nome: "filial",
                    label: null,
                    url: null,
                    varios: false,
                    values: []
                }]
            },
            filtro: {
                periodos: [{ data_inicio: null, data_termino: null }]
            },

            periodo: { data_inicio: null, data_termino: null, startDate: null, endDate: null },

            chart: {},

            diario: {
                dataDia: '',
                diarioDetalhes: []
            }

        };
    },


    computed: {},

    watch: {},

    methods: {
        handleShowFiltro: function handleShowFiltro() {
            this.showfiltro = true;
        },
        filtroChange: function filtroChange(filtro) {
            // this.showfiltro = false;

            // this.filtro = filtro;
            // this.paramsFiltro.filtros[0].values = this.filtro.formapagamento
            // this.paramsFiltro.filtros[1].values = this.filtro.filial

            // this.loadData(false);
        },
        closeForm: function closeForm() {
            this.showForm = false;
            this.loadData(false);
        },
        showModalDetalhes: function showModalDetalhes(dados, idxPeriodo) {

            var dataIni = null;
            var dataFim = null;
            if (this.fluxoCaixaDados.periodos[idxPeriodo].inicio) dataIni = new Date(this.fluxoCaixaDados.periodos[idxPeriodo].inicio);
            if (this.fluxoCaixaDados.periodos[idxPeriodo].termino) dataFim = new Date(this.fluxoCaixaDados.periodos[idxPeriodo].termino);
            var data = null;

            var detalhes = dados.detalhes.filter(function (obj) {
                data = new Date(obj.dtvr);
                if (!dataIni || !dataFim || data >= dataIni && data <= dataFim) return obj;
            });

            this.dadosDetalhes = _extends({}, dados);
            this.dadosDetalhes.detalhes = detalhes;

            this.showModal = true;
        },
        showModalDetalhesDiario: function showModalDetalhesDiario(detalhes, dataDia) {
            this.diario.dataDia = dataDia;
            this.diario.diarioDetalhes = detalhes;
            this.showModalDiario = true;
        },
        closeModalDetalhes: function closeModalDetalhes() {
            this.showModal = false;
            this.showModalDiario = false;
        },
        handleLoadDataFilter: function handleLoadDataFilter() {
            this.loadData(false);
        },
        loadData: function loadData(excel) {
            var _this = this;

            var url = "consulta/vendas/fluxodecaixa";

            this.periodo.data_inicio = this.periodo.startDate;
            this.periodo.data_termino = this.periodo.endDate;

            this.filtro.periodos = [this.periodo];
            this.filtro.excel = excel;
            if (this.contas && this.contas.length == 0) this.filtro.contas = null;else this.filtro.contas = this.contas;
            this.filtro.atrasos = this.atrasos;
            this.filtro.atrasosTempo = this.atrasosTempo;
            this.filtro.tipo = this.tipo;

            if (excel) Object(__WEBPACK_IMPORTED_MODULE_7__shared_api_functions__["apiDownload2"])(this, url, this.filtro, "post");else {
                this.mounting = true;
                var self = this;
                Object(__WEBPACK_IMPORTED_MODULE_7__shared_api_functions__["apiORDSpost"])(this.$store, url, this.filtro, "post").then(function (data) {
                    if (data.flx == undefined) {
                        self.fluxoCaixaDados = [];
                        return;
                    }
                    if (data.flx && data.flx.dados.length) {
                        self.fluxoCaixaDados = data.flx;
                        self.fluxoCaixaDados.despesas.map(function (value, i) {
                            if (Math.sign(value) == -1) {
                                self.fluxoCaixaDados.despesas[i] = value * -1;
                                console.log(value);
                            }
                        });
                    } else self.fluxoCaixaDados = null;

                    console.log(data);
                    console.log(self.fluxoCaixaDados.despesas);
                    _this.handleChart();
                });
            }
        },
        getContas: function getContas() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params, modulo, data, contas;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                params = null;
                                modulo = 'select/cta/';
                                _context.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_7__shared_api_functions__["apiORDS"])(_this2.$store.getters.urlOrds + modulo, params);

                            case 4:
                                data = _context.sent;

                                if (data.items) {
                                    contas = _this2.changeObjKey(data.items);

                                    _this2.listContas = contas;
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },

        // Muda a chave do objeto para que seja carregado corretamente no select2
        changeObjKey: function changeObjKey(arr) {
            return arr.map(function (entry) {
                return Object.keys(entry).reduce(function (obj, key) {
                    var value = entry[key]; // ler o valor
                    if (key === 'value') key = 'text'; // mudar o nome da chave
                    obj[key] = value;
                    return obj;
                }, {});
            });
        },
        handleChart: function handleChart() {
            var _this3 = this;

            this.chart.type = 'ComboChart';

            this.chart.data = [['Período', 'Receita', 'Despesa', 'Saldo']];

            this.chart.options = {
                title: '',
                vAxis: { title: 'Valores' },
                hAxis: { title: 'Períodos' },
                seriesType: 'bars',
                series: { 2: { type: 'line' } },
                width: 1050,
                height: 500
            };

            if (this.tipo === 'M') {
                this.fluxoCaixaDados.periodos.forEach(function (e, index) {
                    _this3.chart.data.push([e.label, _this3.fluxoCaixaDados.receitas[index], _this3.fluxoCaixaDados.despesas[index], _this3.fluxoCaixaDados.saldoAcumulado[index]]);
                });
            }

            if (this.tipo === 'D') {
                this.fluxoCaixaDados.dados.forEach(function (e) {
                    _this3.chart.data.push([e.data === 'Atrasos' ? e.data : Object(__WEBPACK_IMPORTED_MODULE_6__shared_utils__["formatDataExtenso"])(e.data, true), e.receitas, e.despesas, e.saldo]);
                });
            }

            // console.log(this.chart.data)
        },
        formatColorValue: function formatColorValue(value) {
            if (value < 0) {
                return 'negative';
            }

            if (value > 0) {
                return 'positive';
            }

            return '';
        }
    },

    filters: {},

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_1__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_2__components_bar_grid__["default"], FilterList: __WEBPACK_IMPORTED_MODULE_3__components_filter_list__["a" /* default */], Filtro: __WEBPACK_IMPORTED_MODULE_4__consultas_filtro__["a" /* default */], GChart: __WEBPACK_IMPORTED_MODULE_8_vue_google_charts_legacy__["GChart"], Chart: __WEBPACK_IMPORTED_MODULE_9__consultas_chart_vue__["a" /* default */]
    },
    // destroyed(){
    //     localStorage.removeItem('loadChart')
    // },
    created: function created() {
        // const loadChart = localStorage.getItem('loadChart');

        // if(!loadChart){
        //     document.location.reload(true)
        // }

        // localStorage.setItem('loadChart', true);

        this.tipo = 'M';
        this.atrasos = true;
        this.atrasosTempo = 60;
        this.getContas();

        this.periodo.data_inicio = this.$firstDay(this.$getDate());
        this.periodo.data_termino = this.$lastDay(this.$getDate());
        this.periodo.startDate = this.$firstDay(this.$getDate());
        this.periodo.endDate = this.$lastDay(this.$getDate());
        this.loadData(false);
    }
});

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_filter_list__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consultas_filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_google_charts_legacy__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_google_charts_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_google_charts_legacy__);
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,
            moreActionsBarList: [],
            monthFilter: {},
            statusQuery: '',
            filterList: [],
            paramFilterList: {},
            showForm: false,
            codfin: '',
            url: '',
            textQuery: '',
            dados: [],
            resumo: [],
            totais: null,
            dadosDre: null,
            showModal: false,
            showModalDiario: false,
            dadosDetalhes: '',
            contas: null,
            listContas: null,
            atrasos: false,
            atrasosTempo: null,

            //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
            showfiltro: false,

            tipo: null,
            listPeriodos: [{ id: 'MENSAL', text: 'Mensal' }, { id: 'TRIMESTRAL', text: 'Trimestral' }, { id: 'ANUAL', text: 'Anual' }],
            ano: null

        };
    },


    computed: {},

    watch: {},

    methods: {
        // showModalDetalhes(dados, idxPeriodo) {
        //     let dataIni = null;
        //     let dataFim = null;
        //     if (this.dadosDre.periodos[idxPeriodo].inicio)
        //       dataIni = new Date(this.dadosDre.periodos[idxPeriodo].inicio)
        //     if (this.dadosDre.periodos[idxPeriodo].termino)  
        //       dataFim = new Date(this.dadosDre.periodos[idxPeriodo].termino)
        //     let data = null

        //     let detalhes = dados.detalhes.filter(function (obj) {
        //         data = new Date(obj.dtvr)
        //         if ((!dataIni) || (!dataFim) || (data >= dataIni && data <= dataFim))
        //           return obj
        //     })

        //     this.dadosDetalhes = {...dados}
        //     this.dadosDetalhes.detalhes = detalhes

        //     this.showModal = true
        // },

        // showModalDetalhesDiario(detalhes, dataDia) {
        //     this.diario.dataDia = dataDia
        //     this.diario.diarioDetalhes = detalhes
        //     this.showModalDiario = true
        // },

        // closeModalDetalhes() {
        //     this.showModal = false
        //     this.showModalDiario = false
        // },

        loadData: function loadData() {
            var _this = this;

            var url = "consulta/vendas/dre";
            var filtro = {
                ano: this.ano,
                tipo: this.tipo
            };

            this.mounting = true;
            var self = this;
            Object(__WEBPACK_IMPORTED_MODULE_4__shared_api_functions__["apiORDSpost"])(this.$store, url, filtro, "post").then(function (data) {
                if (data.dre && data.dre.length) self.dadosDre = data;else self.dadosDre = null;
                console.log(_this.dadosDre);
            });
        },
        formatColorValue: function formatColorValue(value) {
            if (value < 0) {
                return 'negative';
            }

            if (value > 0) {
                return 'positive';
            }

            return '';
        },
        levelClass: function levelClass(dre) {
            switch (dre.nivel) {
                case 0:
                    return 'lvl-0';

                case 1:
                    return 'lvl-1';

                case 2:
                    return 'lvl-2';
            }
        },
        levelBorderClass: function levelBorderClass(dre) {
            switch (dre.nivel) {
                case 0:
                    return 'border-left-gray';

                case 1:
                    return 'border-left-gray';

                case 2:
                    return dre.tipo === 'R' ? 'border-left-green' : 'border-left-red';
            }
        }
    },

    filters: {},

    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], FilterList: __WEBPACK_IMPORTED_MODULE_2__components_filter_list__["a" /* default */], Filtro: __WEBPACK_IMPORTED_MODULE_3__consultas_filtro__["a" /* default */], GChart: __WEBPACK_IMPORTED_MODULE_5_vue_google_charts_legacy__["GChart"]
    },

    created: function created() {
        var date = new Date();
        this.ano = date.getFullYear();
        this.tipo = 'TRIMESTRAL';
        this.loadData();
    }
});

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_filter_list__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consultas_filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__);
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], FilterList: __WEBPACK_IMPORTED_MODULE_2__components_filter_list__["a" /* default */], Filtro: __WEBPACK_IMPORTED_MODULE_3__consultas_filtro__["a" /* default */]
    },

    data: function data() {
        return {
            data: null,
            total: null,
            codpart: null,
            codcta: null,
            tipo: 'R',
            tipoOptions: [{ id: 'R', text: "A Receber" }, { id: 'P', text: "A Pagar" }],
            periodo: { data_inicio: null, data_termino: null, startDate: null, endDate: null },
            paramFiltro: null,
            filtro: {
                periodos: [{ data_inicio: null, data_termino: null }]
            }
        };
    },


    computed: {
        paramsChart: function paramsChart() {
            if (!this.grafico) return null;

            var grafico = [];
            grafico.push(this.grafico.labels[0]);

            for (var x = 0; x < this.grafico.length; x++) {
                grafico.push([this.grafico[x].descricao, this.grafico[x].valor]);
            }

            return {
                chart: { type: 'PieChart' },
                values: grafico
            };
        },

        dataFilter: function dataFilter() {
            var data = this.data;
            var param = this.paramFiltro;

            if (param) {
                return data.filter(function (obj) {
                    if (param == 'aberto' && obj.aberto) return true;
                    if (param == 'baixado' && obj.baixado) return true;
                    if (param == 'vencido' && obj.vencido) return true;
                    if (param == 'cancelado' && obj.cancelado) return true;
                });
            }

            return data;
        }
    },

    watch: {},

    methods: {
        loadData: function loadData(excel) {
            var url = "consulta/vendas/posicaofinanceiro";

            this.periodo.data_inicio = this.periodo.startDate;
            this.periodo.data_termino = this.periodo.endDate;
            this.filtro.tipo = this.tipo;
            this.filtro.codcta = this.codcta;
            this.filtro.codpart = this.codpart;
            this.filtro.periodos = [this.periodo];
            this.filtro.excel = excel;

            if (excel) Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["apiDownload2"])(this, url, this.filtro, "post");else {
                var self = this;
                Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["apiORDSpost"])(this.$store, url, this.filtro, "post").then(function (data) {
                    if (data) {
                        self.total = data.total;
                        self.data = data.dados;
                    }
                });
            }
        },
        filtrarTitulos: function filtrarTitulos(payload) {
            if (payload === 0) {
                this.paramFiltro = null;
                return;
            }

            if (payload === 1) {
                this.paramFiltro = 'vencido';
                return;
            }

            if (payload === 2) {
                this.paramFiltro = 'aberto';
                return;
            }

            if (payload === 3) {
                this.paramFiltro = 'cancelado';
                return;
            }

            if (payload === 4) {
                this.paramFiltro = 'baixado';
                return;
            }
        }
    },

    filters: {},

    mounted: function mounted() {
        this.loadData();
    },
    created: function created() {
        this.periodo.data_inicio = this.$firstDay(this.$getDate());
        this.periodo.data_termino = this.$lastDay(this.$getDate());
        this.periodo.startDate = this.$firstDay(this.$getDate());
        this.periodo.endDate = this.$lastDay(this.$getDate());
        // this.loadData(false)
    }
});

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bar_list__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_filter_list__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consultas_filtro__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chart__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__);
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BarList: __WEBPACK_IMPORTED_MODULE_0__components_bar_list__["default"], BarGrid: __WEBPACK_IMPORTED_MODULE_1__components_bar_grid__["default"], FilterList: __WEBPACK_IMPORTED_MODULE_2__components_filter_list__["a" /* default */], Filtro: __WEBPACK_IMPORTED_MODULE_3__consultas_filtro__["a" /* default */], Chart: __WEBPACK_IMPORTED_MODULE_4__chart__["a" /* default */]
    },

    data: function data() {
        return {
            dados: [],
            grafico: null,
            tipo: 'R',
            tipoOptions: [{ id: 'R', text: "Recebido" }, { id: 'P', text: "Pago" }],
            periodo: { data_inicio: null, data_termino: null, startDate: null, endDate: null },
            titulos: null,
            filtro: {
                periodos: [{ data_inicio: null, data_termino: null }]
            }
        };
    },


    computed: {
        paramsChart: function paramsChart() {
            if (!this.grafico) return null;

            var grafico = [];
            grafico.push(this.grafico.labels);

            for (var x = 0; x < this.grafico.dados.length; x++) {
                grafico.push([this.grafico.dados[x].descricao, this.grafico.dados[x].valor]);
            }

            return {
                chart: { type: 'PieChart' },
                values: grafico
            };
        }
    },

    watch: {},

    methods: {
        loadData: function loadData(excel) {
            var url = "consulta/vendas/pagamentosfinanceiro";

            this.periodo.data_inicio = this.periodo.startDate;
            this.periodo.data_termino = this.periodo.endDate;
            this.filtro.periodos = [this.periodo];
            this.filtro.tipo = this.tipo;

            if (excel) Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["apiDownload2"])(this, url, this.filtro, "post");else {
                var self = this;
                Object(__WEBPACK_IMPORTED_MODULE_5__shared_api_functions__["apiORDSpost"])(this.$store, url, this.filtro, "post").then(function (data) {
                    console.log(data);
                    if (data) {
                        self.dados = data.dados;
                        self.grafico = data.grafico;
                    }
                });
            }

            this.changeTitle();
        },
        changeTitle: function changeTitle() {
            if (this.tipo === 'P') {
                this.titulo = 'Pagamentos do período por natureza financeira';
            } else {
                this.titulo = 'Recebimentos do período por natureza financeira';
            }
        }
    },

    filters: {},

    created: function created() {
        // this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate())
        // this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate())

        this.periodo.data_inicio = this.$firstDay(this.$getDate());
        this.periodo.data_termino = this.$lastDay(this.$getDate());
        this.periodo.startDate = this.$firstDay(this.$getDate());
        this.periodo.endDate = this.$lastDay(this.$getDate());
        // this.loadData(false)
    }
});

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__perfil_contador_form_vue__ = __webpack_require__(2259);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contador-empresas',
  components: {
    PerfilContadorForm: __WEBPACK_IMPORTED_MODULE_2__perfil_contador_form_vue__["a" /* default */]
  },
  data: function data() {
    return {
      logoContador: null,
      nomeFilial: '',
      codfil: null,
      showEditProfile: false,
      codusuario: null,
      showClientDetails: false,
      loadingClientDetails: false,
      selectedClient: null,
      showFullData: false,
      filtroTexto: '',
      filtroStatus: 'todos'
    };
  },

  computed: {
    empresas: function empresas() {
      return this.$store.getters.getSessao.listaempresas_contador || [];
    },
    nomeEscritorio: function nomeEscritorio() {
      return this.$store.getters.getSessao.empresanome || '';
    },
    nomeUsuario: function nomeUsuario() {
      return this.$store.getters.getSessao.usuarionome || '';
    },
    totalClientes: function totalClientes() {
      return this.empresas.length;
    },
    totalCertificadosCriticos: function totalCertificadosCriticos() {
      var _this = this;

      return this.empresas.filter(function (e) {
        return _this.precisaCertificado(e.validade_certificado);
      }).length;
    },
    totalPlanosRenovacao: function totalPlanosRenovacao() {
      var _this2 = this;

      return this.empresas.filter(function (e) {
        return _this2.precisaRenovarPlano(e.data_termino_plano);
      }).length;
    },
    totalClientesRegulares: function totalClientesRegulares() {
      var _this3 = this;

      return this.empresas.filter(function (e) {
        return !_this3.precisaCertificado(e.validade_certificado) && !_this3.precisaRenovarPlano(e.data_termino_plano);
      }).length;
    },
    empresasFiltradas: function empresasFiltradas() {
      var _this4 = this;

      return this.empresas.filter(function (emp) {
        // Filtro de texto (nome ou cnpj)
        if (_this4.filtroTexto) {
          var termo = _this4.filtroTexto.toLowerCase();
          var nomeMatch = emp.nome && emp.nome.toLowerCase().includes(termo);
          var cnpjLimpo = (emp.cnpj || '').replace(/\D/g, '');
          var termoLimpo = termo.replace(/\D/g, '');
          var cnpjMatch = termoLimpo && cnpjLimpo.includes(termoLimpo);
          if (!nomeMatch && !cnpjMatch) return false;
        }

        // Filtro de status
        if (_this4.filtroStatus === 'cert_critico') {
          return _this4.precisaCertificado(emp.validade_certificado);
        }
        if (_this4.filtroStatus === 'plano_critico') {
          return _this4.precisaRenovarPlano(emp.data_termino_plano);
        }

        return true;
      });
    }
  },
  methods: {
    formatarDataGenerica: function formatarDataGenerica(dateStr) {
      if (!dateStr) return '-';
      try {
        if (typeof dateStr !== 'string') {
          var d = new Date(dateStr);
          if (!isNaN(d.getTime())) return d.toLocaleDateString('pt-BR');
          return '-';
        }
        var datePart = dateStr.split('T')[0];
        if (datePart.includes('-')) {
          var parts = datePart.split('-');
          if (parts.length === 3) {
            var _parts = _slicedToArray(parts, 3),
                year = _parts[0],
                month = _parts[1],
                day = _parts[2];

            return day + '/' + month + '/' + year;
          }
        }
        return datePart || dateStr;
      } catch (e) {
        return '-';
      }
    },
    formatarMoeda: function formatarMoeda(val) {
      var numericVal = parseFloat(val || 0);
      return 'R$ ' + numericVal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    verificarDataExpirada: function verificarDataExpirada(dateStr) {
      if (!dateStr) return false;
      try {
        var expiryDate = new Date(dateStr);
        if (isNaN(expiryDate.getTime())) return false;
        return expiryDate < new Date();
      } catch (e) {
        return false;
      }
    },
    consultarEmpresa: function consultarEmpresa(empresaUuid) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, res, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this5.selectedClient = null;
                _this5.showFullData = false;
                _this5.showClientDetails = true;
                _this5.loadingClientDetails = true;
                _context.prev = 4;
                url = _this5.$store.getters.urlOrds + 'cg/contador/cliente/detalhes';
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, {
                  params: {
                    uuid_destino: empresaUuid
                  }
                });

              case 8:
                res = _context.sent;
                data = res.data;

                if (typeof data === 'string') {
                  try {
                    data = JSON.parse(data);
                  } catch (e) {
                    console.error('Erro ao fazer parse dos dados da empresa:', e);
                  }
                }
                if (Array.isArray(data)) {
                  data = data[0] || {};
                } else if (data && data.items && Array.isArray(data.items)) {
                  data = data.items[0] || {};
                }
                _this5.selectedClient = data;
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](4);

                alert('Erro ao buscar detalhes do cliente: ' + (_context.t0.response && _context.t0.response.data && _context.t0.response.data.message ? _context.t0.response.data.message : _context.t0.message));
                _this5.showClientDetails = false;

              case 19:
                _context.prev = 19;

                _this5.loadingClientDetails = false;
                return _context.finish(19);

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5, [[4, 15, 19, 22]]);
      }))();
    },
    formatarData: function formatarData(dt) {
      if (!dt) return 'Sem Certificado';
      return new Date(dt).toLocaleDateString('pt-BR');
    },
    precisaCertificado: function precisaCertificado(dt) {
      if (!dt) return true;
      var diff = new Date(dt) - new Date();
      var dias = Math.ceil(diff / (1000 * 60 * 60 * 24));
      return dias < 30;
    },
    precisaRenovarPlano: function precisaRenovarPlano(dt) {
      if (!dt) return false;
      var diff = new Date(dt) - new Date();
      var dias = Math.ceil(diff / (1000 * 60 * 60 * 24));
      return dias < 15;
    },
    acessarEmpresaParaRenovacao: function acessarEmpresaParaRenovacao(empresaUuid) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var url, res, token, redirectUrl;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                url = _this6.$store.getters.urlOrds + 'cg/contador/autologin';
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
                  uuid_destino: empresaUuid
                });

              case 4:
                res = _context2.sent;
                token = res.data.token_uuid;
                redirectUrl = window.location.origin + window.location.pathname + '?token_autologin=' + token + '&redirect_to=/minhaconta';

                window.open(redirectUrl, '_blank');
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                alert('Erro ao solicitar renovação do plano.');

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[0, 10]]);
      }))();
    },
    badgeCertificado: function badgeCertificado(dt) {
      if (!dt) return 'badge-soft badge-danger-soft';
      var diff = new Date(dt) - new Date();
      var dias = Math.ceil(diff / (1000 * 60 * 60 * 24));
      if (dias < 0) return 'badge-soft badge-danger-soft';
      if (dias < 30) return 'badge-soft badge-warning-soft';
      return 'badge-soft badge-success-soft';
    },
    formatarDataTermino: function formatarDataTermino(dt) {
      if (!dt) return 'Sem Prazo';
      return new Date(dt).toLocaleDateString('pt-BR');
    },
    badgeDataTermino: function badgeDataTermino(dt) {
      if (!dt) return 'badge-soft badge-secondary-soft';
      var diff = new Date(dt) - new Date();
      var dias = Math.ceil(diff / (1000 * 60 * 60 * 24));
      if (dias < 0) return 'badge-soft badge-danger-soft';
      if (dias < 15) return 'badge-soft badge-warning-soft';
      return 'badge-soft badge-success-soft';
    },
    getDescricaoCRT: function getDescricaoCRT(crt) {
      var crts = {
        '1': 'Simples Nacional',
        '2': 'Simples Nacional - excesso de sublimite',
        '3': 'Regime Normal',
        '4': 'Simples Nacional - MEI'
      };
      return crts[crt] || crt || '-';
    },
    getDescricaoRegimePisCofins: function getDescricaoRegimePisCofins(regime) {
      var regimes = {
        '1': 'Lucro Real (Não-Cumulativo)',
        '2': 'Lucro Presumido (Cumulativo)',
        '3': 'Simples Nacional'
      };
      return regimes[regime] || regime || '-';
    },
    getDescricaoAmbienteNfe: function getDescricaoAmbienteNfe(amb) {
      var ambs = {
        '1': 'Produção',
        '2': 'Homologação'
      };
      return ambs[amb] || amb || '-';
    },
    acessarEmpresa: function acessarEmpresa(empresaUuid) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var url, res, token, redirectUrl;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                url = _this7.$store.getters.urlOrds + 'cg/contador/autologin';
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
                  uuid_destino: empresaUuid
                });

              case 4:
                res = _context3.sent;
                token = res.data.token_uuid;
                redirectUrl = window.location.origin + window.location.pathname + '?token_autologin=' + token;

                window.open(redirectUrl, '_blank');
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);

                alert('Erro ao solicitar acesso silencioso.');

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7, [[0, 10]]);
      }))();
    },
    handleLogout: function handleLogout() {
      this.$store.dispatch('logout');
      window.location.href = '/';
    },
    handleEditProfile: function handleEditProfile() {
      var sessao = this.$store.getters.getSessao;
      if (sessao && sessao.codusuario) {
        this.codusuario = sessao.codusuario.toString();
        this.showEditProfile = true;
      } else {
        alert('Dados da sessão não carregados. Tente atualizar a página.');
      }
    },
    loadFilialData: function loadFilialData() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var filialList, mainFilial, sessao, url;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _this8.$store.dispatch('loadFilial', {});

              case 3:
                filialList = _this8.$store.getters.getFilialList || [];

                if (filialList.length > 0) {
                  mainFilial = filialList[0];

                  _this8.codfil = mainFilial.codfil;
                  _this8.nomeFilial = mainFilial.nome;

                  // Carrega o logotipo usando o codfil dinâmico da filial principal
                  sessao = _this8.$store.getters.getSessao;

                  if (sessao && sessao.empresacod && _this8.codfil) {
                    url = _this8.$store.getters.urlApp + "logo/download/" + sessao.empresacod + "/" + _this8.codfil;

                    Object(__WEBPACK_IMPORTED_MODULE_1__shared_api_functions__["apiORDSmidia"])(url).then(function (data) {
                      if (data && data.size > 0) {
                        var self = _this8;
                        var reader = new window.FileReader();
                        reader.readAsDataURL(data);
                        reader.onload = function () {
                          self.logoContador = reader.result;
                        };
                      } else {
                        _this8.logoContador = null;
                      }
                    }).catch(function () {
                      _this8.logoContador = null;
                    });
                  }
                }
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);

                console.error('Erro ao carregar dados da filial do contador', _context4.t0);

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this8, [[0, 7]]);
      }))();
    },
    handleCloseProfile: function handleCloseProfile() {
      this.showEditProfile = false;
      this.loadFilialData();
    }
  },
  created: function created() {
    this.loadFilialData();
  }
});

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_api_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: '',
        crud: ''
    },
    data: function data() {
        return {
            activeTab: 0,
            tabs: [{ title: 'Usuário / Login', icon: '' }, { title: 'Filial / Escritório de contabilidade', icon: '' }],
            senha1: '',
            senha2: '',
            errmessages: [],
            codfil: null,
            image: null,
            selectedFile: null,
            usuario: {
                codusuario: null,
                nome: '',
                email: '',
                senha: '',
                stusuario: '',
                perfil: ''
            },
            filial: {
                codfil: null,
                nome: '',
                cnpj: '',
                cep: '',
                ende: '',
                endenr: '',
                endecomp: '',
                bairro: '',
                uf: '',
                codmun: '',
                fone1: '',
                fone2: '',
                fone3: '',
                email: '',
                stfilial: 'A',
                logotipo: []
            },
            metadata: {
                filial: this.$store.getters.getEntities.metadata ? this.$store.getters.getEntities.metadata.filial : {}
            }
        };
    },

    computed: {
        tabUsuario: function tabUsuario() {
            return this.activeTab === 0;
        },
        tabFilial: function tabFilial() {
            return this.activeTab === 1;
        }
    },
    methods: {
        closeForm: function closeForm() {
            this.$emit('closeform');
        },
        changeTab: function changeTab(idx) {
            this.activeTab = idx;
            this.$validator.reset();
        },
        updateCep: function updateCep() {
            this.filial.ende = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.logradouro;
            this.filial.bairro = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.bairro;
            this.filial.codmun = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.ibge;
            this.filial.uf = __WEBPACK_IMPORTED_MODULE_0__main__["SysVars"].endereco.uf;
        },
        loadData: function loadData() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var filialList;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this.index) {
                                    _context.next = 4;
                                    break;
                                }

                                _context.next = 3;
                                return _this.$store.dispatch('loadUsuario', { id: _this.index });

                            case 3:
                                if (_this.$store.getters.getUsuario) {
                                    _this.usuario = _extends({}, _this.$store.getters.getUsuario);
                                    _this.senha1 = '';
                                    _this.senha2 = '';
                                }

                            case 4:
                                _context.next = 6;
                                return _this.$store.dispatch('loadFilial', {});

                            case 6:
                                filialList = _this.$store.getters.getFilialList || [];

                                if (!(filialList.length > 0)) {
                                    _context.next = 12;
                                    break;
                                }

                                _this.codfil = filialList[0].codfil;
                                _context.next = 11;
                                return _this.$store.dispatch('loadFilial', { id: _this.codfil });

                            case 11:
                                if (_this.$store.getters.getFilial) {
                                    _this.filial = _extends({}, _this.$store.getters.getFilial);

                                    // Parse JSON fields to prevent ORA-40587 on save
                                    if (typeof _this.filial.parametros === 'string' && _this.filial.parametros) {
                                        try {
                                            _this.filial.parametros = JSON.parse(_this.filial.parametros);
                                        } catch (e) {
                                            _this.filial.parametros = {};
                                        }
                                    } else if (!_this.filial.parametros) {
                                        _this.filial.parametros = {};
                                    }

                                    if (typeof _this.filial.parametrosloja === 'string' && _this.filial.parametrosloja) {
                                        try {
                                            _this.filial.parametrosloja = JSON.parse(_this.filial.parametrosloja);
                                        } catch (e) {
                                            _this.filial.parametrosloja = null;
                                        }
                                    }

                                    _this.loadLogotipo();
                                }

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        loadLogotipo: function loadLogotipo() {
            var _this2 = this;

            if (!this.filial.codempresa) return;
            Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSmidia"])(this.$store.getters.urlApp + "logo/download/" + this.filial.codempresa + "/" + this.filial.codfil).then(function (data) {
                if (data && data.size > 0) {
                    var self = _this2;
                    var reader = new window.FileReader();
                    reader.readAsDataURL(data);
                    reader.onload = function () {
                        self.image = reader.result;
                    };
                }
            });
        },
        handleClickLogotipo: function handleClickLogotipo() {
            this.$refs.file.value = '';
            this.$refs.file.click();
        },
        handleUpload: function handleUpload(event) {
            this.selectedFile = event.target.files[0];
            this.uploadImage();
        },
        uploadImage: function uploadImage() {
            var formData = new FormData();
            formData.append("file", this.selectedFile);
            var url = this.$store.getters.urlApp + "logo/";
            var self = this;
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    codfilial: this.filial.codfil,
                    filename: this.selectedFile.name
                }
            }).then(function () {
                self.$erpToastSuccess("O logotipo foi atualizado com sucesso.");
                self.loadLogotipo();
            });
        },
        apiDeleteImage: function apiDeleteImage() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var modulo;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(!_this3.filial.logotipo || _this3.filial.logotipo.length == 0)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                modulo = "logo/" + _this3.filial.logotipo[0].codlogotipo;
                                _context2.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSapp"])(_this3, modulo, "delete");

                            case 5:
                                _this3.image = null;
                                _this3.$erpToastSuccess("O logotipo foi removido com sucesso.");

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        handleSave: function handleSave() {
            var _this4 = this;

            if (this.senha1 && this.senha1 != this.senha2) {
                alert('As senhas não conferem');
                return;
            }

            var scope = this.activeTab === 0 ? 'usuario' : 'filial';
            this.$validator.validateAll(scope).then(function (isValid) {
                if (!isValid) {
                    _this4.$erpToastError('Por favor, corrija os campos em destaque para continuar');
                } else {
                    _this4.apiPost();
                }
            });
        },
        apiPost: function apiPost() {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var sendData, data, modulo, filialSendData, filialRes;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this5.errmessages = [];

                                // Salvar Usuário (core DB / urlApp)
                                if (_this5.senha1) {
                                    _this5.usuario.senha = _this5.senha1;
                                }
                                sendData = { usuario: _this5.usuario };
                                _context3.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSapp"])(_this5, 'usuario/', 'put', sendData);

                            case 5:
                                data = _context3.sent;

                                if (!data.errmessages) {
                                    _context3.next = 11;
                                    break;
                                }

                                _this5.errmessages = data.errmessages;
                                _this5.$erpToastError('Alguns erros precisam ser corrigidos.');
                                _context3.next = 23;
                                break;

                            case 11:
                                if (!_this5.filial.codfil) {
                                    _context3.next = 21;
                                    break;
                                }

                                modulo = "cg/filial/";
                                filialSendData = { filial: _this5.filial };
                                _context3.next = 16;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__shared_api_functions__["apiORDSpost"])(_this5.$store, modulo, filialSendData, "put");

                            case 16:
                                filialRes = _context3.sent;

                                if (!(filialRes && filialRes.errmessages)) {
                                    _context3.next = 21;
                                    break;
                                }

                                _this5.errmessages = filialRes.errmessages;
                                _this5.$erpToastError('Erro ao salvar os dados da filial.');
                                return _context3.abrupt('return');

                            case 21:
                                _this5.$erpToastUpdated();
                                _this5.closeForm();

                            case 23:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this5);
            }))();
        }
    },
    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(786);
module.exports = __webpack_require__(4);


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(787);

__webpack_require__(984);

__webpack_require__(985);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(788);
__webpack_require__(791);
__webpack_require__(792);
__webpack_require__(793);
__webpack_require__(794);
__webpack_require__(795);
__webpack_require__(796);
__webpack_require__(797);
__webpack_require__(798);
__webpack_require__(799);
__webpack_require__(800);
__webpack_require__(801);
__webpack_require__(802);
__webpack_require__(803);
__webpack_require__(804);
__webpack_require__(805);
__webpack_require__(806);
__webpack_require__(807);
__webpack_require__(808);
__webpack_require__(809);
__webpack_require__(810);
__webpack_require__(811);
__webpack_require__(812);
__webpack_require__(813);
__webpack_require__(814);
__webpack_require__(815);
__webpack_require__(816);
__webpack_require__(817);
__webpack_require__(818);
__webpack_require__(819);
__webpack_require__(820);
__webpack_require__(821);
__webpack_require__(822);
__webpack_require__(823);
__webpack_require__(824);
__webpack_require__(825);
__webpack_require__(826);
__webpack_require__(827);
__webpack_require__(828);
__webpack_require__(829);
__webpack_require__(830);
__webpack_require__(831);
__webpack_require__(832);
__webpack_require__(833);
__webpack_require__(834);
__webpack_require__(835);
__webpack_require__(836);
__webpack_require__(837);
__webpack_require__(838);
__webpack_require__(839);
__webpack_require__(840);
__webpack_require__(841);
__webpack_require__(842);
__webpack_require__(843);
__webpack_require__(844);
__webpack_require__(845);
__webpack_require__(846);
__webpack_require__(847);
__webpack_require__(848);
__webpack_require__(849);
__webpack_require__(850);
__webpack_require__(851);
__webpack_require__(852);
__webpack_require__(853);
__webpack_require__(854);
__webpack_require__(855);
__webpack_require__(856);
__webpack_require__(857);
__webpack_require__(858);
__webpack_require__(859);
__webpack_require__(860);
__webpack_require__(861);
__webpack_require__(862);
__webpack_require__(863);
__webpack_require__(864);
__webpack_require__(865);
__webpack_require__(866);
__webpack_require__(868);
__webpack_require__(869);
__webpack_require__(871);
__webpack_require__(872);
__webpack_require__(873);
__webpack_require__(874);
__webpack_require__(875);
__webpack_require__(876);
__webpack_require__(877);
__webpack_require__(879);
__webpack_require__(880);
__webpack_require__(881);
__webpack_require__(882);
__webpack_require__(883);
__webpack_require__(884);
__webpack_require__(885);
__webpack_require__(886);
__webpack_require__(887);
__webpack_require__(888);
__webpack_require__(889);
__webpack_require__(890);
__webpack_require__(891);
__webpack_require__(150);
__webpack_require__(892);
__webpack_require__(203);
__webpack_require__(893);
__webpack_require__(204);
__webpack_require__(894);
__webpack_require__(895);
__webpack_require__(896);
__webpack_require__(897);
__webpack_require__(898);
__webpack_require__(207);
__webpack_require__(209);
__webpack_require__(210);
__webpack_require__(899);
__webpack_require__(900);
__webpack_require__(901);
__webpack_require__(902);
__webpack_require__(903);
__webpack_require__(904);
__webpack_require__(905);
__webpack_require__(906);
__webpack_require__(907);
__webpack_require__(908);
__webpack_require__(909);
__webpack_require__(910);
__webpack_require__(911);
__webpack_require__(912);
__webpack_require__(913);
__webpack_require__(914);
__webpack_require__(915);
__webpack_require__(916);
__webpack_require__(917);
__webpack_require__(918);
__webpack_require__(919);
__webpack_require__(920);
__webpack_require__(921);
__webpack_require__(922);
__webpack_require__(923);
__webpack_require__(924);
__webpack_require__(925);
__webpack_require__(926);
__webpack_require__(927);
__webpack_require__(928);
__webpack_require__(929);
__webpack_require__(930);
__webpack_require__(931);
__webpack_require__(932);
__webpack_require__(933);
__webpack_require__(934);
__webpack_require__(935);
__webpack_require__(936);
__webpack_require__(937);
__webpack_require__(938);
__webpack_require__(939);
__webpack_require__(940);
__webpack_require__(941);
__webpack_require__(942);
__webpack_require__(943);
__webpack_require__(944);
__webpack_require__(945);
__webpack_require__(946);
__webpack_require__(947);
__webpack_require__(948);
__webpack_require__(949);
__webpack_require__(950);
__webpack_require__(951);
__webpack_require__(952);
__webpack_require__(953);
__webpack_require__(954);
__webpack_require__(955);
__webpack_require__(956);
__webpack_require__(957);
__webpack_require__(958);
__webpack_require__(959);
__webpack_require__(960);
__webpack_require__(961);
__webpack_require__(962);
__webpack_require__(963);
__webpack_require__(964);
__webpack_require__(965);
__webpack_require__(966);
__webpack_require__(967);
__webpack_require__(968);
__webpack_require__(969);
__webpack_require__(970);
__webpack_require__(971);
__webpack_require__(972);
__webpack_require__(973);
__webpack_require__(974);
__webpack_require__(975);
__webpack_require__(976);
__webpack_require__(977);
__webpack_require__(978);
__webpack_require__(979);
__webpack_require__(980);
__webpack_require__(981);
__webpack_require__(982);
__webpack_require__(983);
module.exports = __webpack_require__(40);

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var global = __webpack_require__(12);
var has = __webpack_require__(35);
var DESCRIPTORS = __webpack_require__(21);
var $export = __webpack_require__(6);
var redefine = __webpack_require__(30);
var META = __webpack_require__(54).KEY;
var $fails = __webpack_require__(14);
var shared = __webpack_require__(80);
var setToStringTag = __webpack_require__(70);
var uid = __webpack_require__(58);
var wks = __webpack_require__(18);
var wksExt = __webpack_require__(185);
var wksDefine = __webpack_require__(131);
var enumKeys = __webpack_require__(790);
var isArray = __webpack_require__(103);
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(15);
var toObject = __webpack_require__(24);
var toIObject = __webpack_require__(36);
var toPrimitive = __webpack_require__(46);
var createDesc = __webpack_require__(57);
var _create = __webpack_require__(61);
var gOPNExt = __webpack_require__(188);
var $GOPD = __webpack_require__(37);
var $GOPS = __webpack_require__(102);
var $DP = __webpack_require__(22);
var $keys = __webpack_require__(59);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function get() {
      return dP(this, 'a', { value: 7 }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && _typeof($Symbol.iterator) == 'symbol' ? function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    }return setSymbolDesc(it, key, D);
  }return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function _Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function $set(value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(62).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(82).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(53)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols =
// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
  wks(es6Symbols[j++]);
}for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
  wksDefine(wellKnownSymbols[k++]);
}$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function _for(key) {
    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) {
      if (SymbolRegistry[key] === sym) return key;
    }
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () {
  $GOPS.f(1);
});

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }$replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function replacer(key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(29)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(80)('native-function-to-string', Function.toString);

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(59);
var gOPS = __webpack_require__(102);
var pIE = __webpack_require__(82);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }return result;
};

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(61) });

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(21), 'Object', { defineProperty: __webpack_require__(22).f });

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(21), 'Object', { defineProperties: __webpack_require__(187) });

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(36);
var $getOwnPropertyDescriptor = __webpack_require__(37).f;

__webpack_require__(48)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(24);
var $getPrototypeOf = __webpack_require__(38);

__webpack_require__(48)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(24);
var $keys = __webpack_require__(59);

__webpack_require__(48)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(48)('getOwnPropertyNames', function () {
  return __webpack_require__(188).f;
});

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(15);
var meta = __webpack_require__(54).onFreeze;

__webpack_require__(48)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(15);
var meta = __webpack_require__(54).onFreeze;

__webpack_require__(48)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(15);
var meta = __webpack_require__(54).onFreeze;

__webpack_require__(48)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(15);

__webpack_require__(48)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(15);

__webpack_require__(48)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(15);

__webpack_require__(48)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(6);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(189) });

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(6);
$export($export.S, 'Object', { is: __webpack_require__(190) });

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(6);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(135).set });

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()

var classof = __webpack_require__(71);
var test = {};
test[__webpack_require__(18)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(30)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(6);

$export($export.P, 'Function', { bind: __webpack_require__(191) });

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dP = __webpack_require__(22).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(21) && dP(FProto, NAME, {
  configurable: true,
  get: function get() {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(15);
var getPrototypeOf = __webpack_require__(38);
var HAS_INSTANCE = __webpack_require__(18)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(22).f(FunctionProto, HAS_INSTANCE, { value: function value(O) {
    if (typeof this != 'function' || !isObject(O)) return false;
    if (!isObject(this.prototype)) return O instanceof this;
    // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
    while (O = getPrototypeOf(O)) {
      if (this.prototype === O) return true;
    }return false;
  } });

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $parseInt = __webpack_require__(193);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $parseFloat = __webpack_require__(194);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(12);
var has = __webpack_require__(35);
var cof = __webpack_require__(42);
var inheritIfRequired = __webpack_require__(137);
var toPrimitive = __webpack_require__(46);
var fails = __webpack_require__(14);
var gOPN = __webpack_require__(62).f;
var gOPD = __webpack_require__(37).f;
var dP = __webpack_require__(22).f;
var $trim = __webpack_require__(72).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(61)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function toNumber(argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66:case 98:
          radix = 2;maxCode = 49;break; // fast equal /^0b[01]+$/i
        case 79:case 111:
          radix = 8;maxCode = 55;break; // fast equal /^0o[0-7]+$/i
        default:
          return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      }return parseInt(digits, radix);
    }
  }return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
    // check on 1..constructor(foo) case
    && (BROKEN_COF ? fails(function () {
      proto.valueOf.call(that);
    }) : cof(that) != NUMBER) ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(21) ? gOPN(Base) : (
  // ES3:
  'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
  // ES6 (in case, if modules with ES6 Number statics required before):
  'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(30)(global, NUMBER, $Number);
}

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var toInteger = __webpack_require__(43);
var aNumberValue = __webpack_require__(195);
var repeat = __webpack_require__(138);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function multiply(n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function divide(n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = c % n * 1e7;
  }
};
var numToString = function numToString() {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  }return s;
};
var pow = function pow(x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function log(x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  }return n;
};

$export($export.P + $export.F * (!!$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128.0.toFixed(0) !== '1000000000000000128') || !__webpack_require__(14)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    }return m;
  }
});

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $fails = __webpack_require__(14);
var aNumberValue = __webpack_require__(195);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(6);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(6);
var _isFinite = __webpack_require__(12).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(6);

$export($export.S, 'Number', { isInteger: __webpack_require__(196) });

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(6);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(6);
var isInteger = __webpack_require__(196);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(6);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(6);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $parseFloat = __webpack_require__(194);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $parseInt = __webpack_require__(193);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(6);
var log1p = __webpack_require__(197);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
// V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
&& Math.floor($acosh(Number.MAX_VALUE)) == 710
// Tor Browser bug: Math.acosh(Infinity) -> NaN
&& $acosh(Infinity) == Infinity), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(6);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(6);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(6);
var sign = __webpack_require__(139);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(6);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(6);
var $expm1 = __webpack_require__(140);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', { fround: __webpack_require__(198) });

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(6);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) {
    // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(6);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(14)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', { log1p: __webpack_require__(197) });

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', { sign: __webpack_require__(139) });

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(6);
var expm1 = __webpack_require__(140);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(14)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(6);
var expm1 = __webpack_require__(140);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var toAbsoluteIndex = __webpack_require__(60);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) {
    // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
    }return res.join('');
  }
});

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var toIObject = __webpack_require__(36);
var toLength = __webpack_require__(19);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    }return res.join('');
  }
});

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()

__webpack_require__(72)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $at = __webpack_require__(104)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(141)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $at = __webpack_require__(104)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])


var $export = __webpack_require__(6);
var toLength = __webpack_require__(19);
var context = __webpack_require__(143);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(144)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
  }
});

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)


var $export = __webpack_require__(6);
var context = __webpack_require__(143);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(144)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(138)
});

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])


var $export = __webpack_require__(6);
var toLength = __webpack_require__(19);
var context = __webpack_require__(143);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(144)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
  }
});

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)

__webpack_require__(31)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()

__webpack_require__(31)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()

__webpack_require__(31)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()

__webpack_require__(31)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()

__webpack_require__(31)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)

__webpack_require__(31)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)

__webpack_require__(31)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()

__webpack_require__(31)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)

__webpack_require__(31)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()

__webpack_require__(31)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()

__webpack_require__(31)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()

__webpack_require__(31)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()

__webpack_require__(31)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(6);

$export($export.S, 'Date', { now: function now() {
    return new Date().getTime();
  } });

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var toObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(46);

$export($export.P + $export.F * __webpack_require__(14)(function () {
  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({ toISOString: function toISOString() {
      return 1;
    } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(6);
var toISOString = __webpack_require__(867);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()

var fails = __webpack_require__(14);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function lz(num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
}) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) + 'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) + ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(30)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TO_PRIMITIVE = __webpack_require__(18)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(29)(proto, TO_PRIMITIVE, __webpack_require__(870));

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(46);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(6);

$export($export.S, 'Array', { isArray: __webpack_require__(103) });

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ctx = __webpack_require__(41);
var $export = __webpack_require__(6);
var toObject = __webpack_require__(24);
var call = __webpack_require__(199);
var isArrayIter = __webpack_require__(145);
var toLength = __webpack_require__(19);
var createProperty = __webpack_require__(146);
var getIterFn = __webpack_require__(147);

$export($export.S + $export.F * !__webpack_require__(106)(function (iter) {
  Array.from(iter);
}), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var createProperty = __webpack_require__(146);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(14)(function () {
  function F() {/* empty */}
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of() /* ...args */{
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) {
      createProperty(result, index, arguments[index++]);
    }result.length = aLen;
    return result;
  }
});

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)

var $export = __webpack_require__(6);
var toIObject = __webpack_require__(36);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(81) != Object || !__webpack_require__(44)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var html = __webpack_require__(134);
var cof = __webpack_require__(42);
var toAbsoluteIndex = __webpack_require__(60);
var toLength = __webpack_require__(19);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(14)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) {
      cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
    }return cloned;
  }
});

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var aFunction = __webpack_require__(25);
var toObject = __webpack_require__(24);
var fails = __webpack_require__(14);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(44)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined ? $sort.call(toObject(this)) : $sort.call(toObject(this), aFunction(comparefn));
  }
});

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $forEach = __webpack_require__(49)(0);
var STRICT = __webpack_require__(44)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(15);
var isArray = __webpack_require__(103);
var SPECIES = __webpack_require__(18)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }return C === undefined ? Array : C;
};

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $map = __webpack_require__(49)(1);

$export($export.P + $export.F * !__webpack_require__(44)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $filter = __webpack_require__(49)(2);

$export($export.P + $export.F * !__webpack_require__(44)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $some = __webpack_require__(49)(3);

$export($export.P + $export.F * !__webpack_require__(44)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $every = __webpack_require__(49)(4);

$export($export.P + $export.F * !__webpack_require__(44)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $reduce = __webpack_require__(200);

$export($export.P + $export.F * !__webpack_require__(44)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $reduce = __webpack_require__(200);

$export($export.P + $export.F * !__webpack_require__(44)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $indexOf = __webpack_require__(101)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(44)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
    // convert -0 to +0
    ? $native.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments[1]);
  }
});

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var toIObject = __webpack_require__(36);
var toInteger = __webpack_require__(43);
var toLength = __webpack_require__(19);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(44)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (; index >= 0; index--) {
      if (index in O) if (O[index] === searchElement) return index || 0;
    }return -1;
  }
});

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(6);

$export($export.P, 'Array', { copyWithin: __webpack_require__(201) });

__webpack_require__(55)('copyWithin');

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(6);

$export($export.P, 'Array', { fill: __webpack_require__(149) });

__webpack_require__(55)('fill');

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

var $export = __webpack_require__(6);
var $find = __webpack_require__(49)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () {
  forced = false;
});
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(55)(KEY);

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

var $export = __webpack_require__(6);
var $find = __webpack_require__(49)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () {
  forced = false;
});
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(55)(KEY);

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(63)('Array');

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(12);
var inheritIfRequired = __webpack_require__(137);
var dP = __webpack_require__(22).f;
var gOPN = __webpack_require__(62).f;
var isRegExp = __webpack_require__(105);
var $flags = __webpack_require__(83);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(21) && (!CORRECT_NEW || __webpack_require__(14)(function () {
  re2[__webpack_require__(18)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p : inheritIfRequired(CORRECT_NEW ? new Base(piRE && !fiU ? p.source : p, f) : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f), tiRE ? this : proto, $RegExp);
  };
  var proxy = function proxy(key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function get() {
        return Base[key];
      },
      set: function set(it) {
        Base[key] = it;
      }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) {
    proxy(keys[i++]);
  }proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(30)(global, 'RegExp', $RegExp);
}

__webpack_require__(63)('RegExp');

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(204);
var anObject = __webpack_require__(10);
var $flags = __webpack_require__(83);
var DESCRIPTORS = __webpack_require__(21);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function define(fn) {
  __webpack_require__(30)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(14)(function () {
  return $toString.call({ source: 'a', flags: 'b' }) != '/a/b';
})) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
  // FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(10);
var toLength = __webpack_require__(19);
var advanceStringIndex = __webpack_require__(152);
var regExpExec = __webpack_require__(107);

// @@match logic
__webpack_require__(108)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
  // `String.prototype.match` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.match
  function match(regexp) {
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  },
  // `RegExp.prototype[@@match]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
  function (regexp) {
    var res = maybeCallNative($match, regexp, this);
    if (res.done) return res.value;
    var rx = anObject(regexp);
    var S = String(this);
    if (!rx.global) return regExpExec(rx, S);
    var fullUnicode = rx.unicode;
    rx.lastIndex = 0;
    var A = [];
    var n = 0;
    var result;
    while ((result = regExpExec(rx, S)) !== null) {
      var matchStr = String(result[0]);
      A[n] = matchStr;
      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      n++;
    }
    return n === 0 ? null : A;
  }];
});

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(10);
var toObject = __webpack_require__(24);
var toLength = __webpack_require__(19);
var toInteger = __webpack_require__(43);
var advanceStringIndex = __webpack_require__(152);
var regExpExec = __webpack_require__(107);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function maybeToString(it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(108)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
  // `String.prototype.replace` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.replace
  function replace(searchValue, replaceValue) {
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
  },
  // `RegExp.prototype[@@replace]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
  function (regexp, replaceValue) {
    var res = maybeCallNative($replace, regexp, this, replaceValue);
    if (res.done) return res.value;

    var rx = anObject(regexp);
    var S = String(this);
    var functionalReplace = typeof replaceValue === 'function';
    if (!functionalReplace) replaceValue = String(replaceValue);
    var global = rx.global;
    if (global) {
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
    }
    var results = [];
    while (true) {
      var result = regExpExec(rx, S);
      if (result === null) break;
      results.push(result);
      if (!global) break;
      var matchStr = String(result[0]);
      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
    }
    var accumulatedResult = '';
    var nextSourcePosition = 0;
    for (var i = 0; i < results.length; i++) {
      result = results[i];
      var matched = String(result[0]);
      var position = max(min(toInteger(result.index), S.length), 0);
      var captures = [];
      // NOTE: This is equivalent to
      //   captures = result.slice(1).map(maybeToString)
      // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
      // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
      // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
      for (var j = 1; j < result.length; j++) {
        captures.push(maybeToString(result[j]));
      }var namedCaptures = result.groups;
      if (functionalReplace) {
        var replacerArgs = [matched].concat(captures, position, S);
        if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
        var replacement = String(replaceValue.apply(undefined, replacerArgs));
      } else {
        replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
      }
      if (position >= nextSourcePosition) {
        accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
        nextSourcePosition = position + matched.length;
      }
    }
    return accumulatedResult + S.slice(nextSourcePosition);
  }];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$':
          return '$';
        case '&':
          return matched;
        case '`':
          return str.slice(0, position);
        case "'":
          return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default:
          // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(10);
var sameValue = __webpack_require__(190);
var regExpExec = __webpack_require__(107);

// @@search logic
__webpack_require__(108)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
  // `String.prototype.search` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.search
  function search(regexp) {
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  },
  // `RegExp.prototype[@@search]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
  function (regexp) {
    var res = maybeCallNative($search, regexp, this);
    if (res.done) return res.value;
    var rx = anObject(regexp);
    var S = String(this);
    var previousLastIndex = rx.lastIndex;
    if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
    var result = regExpExec(rx, S);
    if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
    return result === null ? -1 : result.index;
  }];
});

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(105);
var anObject = __webpack_require__(10);
var speciesConstructor = __webpack_require__(84);
var advanceStringIndex = __webpack_require__(152);
var toLength = __webpack_require__(19);
var callRegExpExec = __webpack_require__(107);
var regexpExec = __webpack_require__(151);
var fails = __webpack_require__(14);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () {
  RegExp(MAX_UINT32, 'y');
});

// @@split logic
__webpack_require__(108)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function internalSplit(separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
    // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function internalSplit(separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
  // `String.prototype.split` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.split
  function split(separator, limit) {
    var O = defined(this);
    var splitter = separator == undefined ? undefined : separator[SPLIT];
    return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
  },
  // `RegExp.prototype[@@split]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
  //
  // NOTE: This cannot be properly polyfilled in engines that don't support
  // the 'y' flag.
  function (regexp, limit) {
    var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
    if (res.done) return res.value;

    var rx = anObject(regexp);
    var S = String(this);
    var C = speciesConstructor(rx, RegExp);

    var unicodeMatching = rx.unicode;
    var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (SUPPORTS_Y ? 'y' : 'g');

    // ^(? + rx + ) is needed, in combination with some S slicing, to
    // simulate the 'y' flag.
    var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
    var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
    if (lim === 0) return [];
    if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
    var p = 0;
    var q = 0;
    var A = [];
    while (q < S.length) {
      splitter.lastIndex = SUPPORTS_Y ? q : 0;
      var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
      var e;
      if (z === null || (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p) {
        q = advanceStringIndex(S, q, unicodeMatching);
      } else {
        A.push(S.slice(p, q));
        if (A.length === lim) return A;
        for (var i = 1; i <= z.length - 1; i++) {
          A.push(z[i]);
          if (A.length === lim) return A;
        }
        q = p = e;
      }
    }
    A.push(S.slice(p));
    return A;
  }];
});

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__(53);
var global = __webpack_require__(12);
var ctx = __webpack_require__(41);
var classof = __webpack_require__(71);
var $export = __webpack_require__(6);
var isObject = __webpack_require__(15);
var aFunction = __webpack_require__(25);
var anInstance = __webpack_require__(64);
var forOf = __webpack_require__(65);
var speciesConstructor = __webpack_require__(84);
var task = __webpack_require__(153).set;
var microtask = __webpack_require__(154)();
var newPromiseCapabilityModule = __webpack_require__(155);
var perform = __webpack_require__(205);
var userAgent = __webpack_require__(109);
var promiseResolve = __webpack_require__(206);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function empty() {/* empty */};
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(18)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise
    // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // we can't detect it synchronously, so just check versions
    && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) {/* empty */}
}();

// helpers
var isThenable = function isThenable(it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function notify(promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function run(reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) {
      run(chain[i++]);
    } // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function onUnhandled(promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    }promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function isUnhandled(promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function onHandleUnhandled(promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function $reject(value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function $resolve(value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = []; // <- awaiting reactions
    this._a = undefined; // <- checked in isUnhandled reactions
    this._s = 0; // <- state
    this._d = false; // <- done
    this._v = undefined; // <- value
    this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false; // <- notify
  };
  Internal.prototype = __webpack_require__(66)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function _catch(onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function OwnPromiseCapability() {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
    return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(70)($Promise, PROMISE);
__webpack_require__(63)(PROMISE);
Wrapper = __webpack_require__(40)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(106)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var weak = __webpack_require__(211);
var validate = __webpack_require__(67);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(110)(WEAK_SET, function (get) {
  return function WeakSet() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $typed = __webpack_require__(111);
var buffer = __webpack_require__(156);
var anObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(60);
var toLength = __webpack_require__(19);
var isObject = __webpack_require__(15);
var ArrayBuffer = __webpack_require__(12).ArrayBuffer;
var speciesConstructor = __webpack_require__(84);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(14)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    }return result;
  }
});

__webpack_require__(63)(ARRAY_BUFFER);

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
$export($export.G + $export.W + $export.F * !__webpack_require__(111).ABV, {
  DataView: __webpack_require__(156).DataView
});

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(51)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(51)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(51)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(51)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(51)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(51)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(51)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(51)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(51)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(6);
var aFunction = __webpack_require__(25);
var anObject = __webpack_require__(10);
var rApply = (__webpack_require__(12).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(14)(function () {
  rApply(function () {/* empty */});
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(6);
var create = __webpack_require__(61);
var aFunction = __webpack_require__(25);
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(15);
var fails = __webpack_require__(14);
var bind = __webpack_require__(191);
var rConstruct = (__webpack_require__(12).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() {/* empty */}
  return !(rConstruct(function () {/* empty */}, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () {/* empty */});
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0:
          return new Target();
        case 1:
          return new Target(args[0]);
        case 2:
          return new Target(args[0], args[1]);
        case 3:
          return new Target(args[0], args[1], args[2]);
        case 4:
          return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(22);
var $export = __webpack_require__(6);
var anObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(46);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(14)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(6);
var gOPD = __webpack_require__(37).f;
var anObject = __webpack_require__(10);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)

var $export = __webpack_require__(6);
var anObject = __webpack_require__(10);
var Enumerate = function Enumerate(iterated) {
  this._t = anObject(iterated); // target
  this._i = 0; // next index
  var keys = this._k = []; // keys
  var key;
  for (key in iterated) {
    keys.push(key);
  }
};
__webpack_require__(142)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(37);
var getPrototypeOf = __webpack_require__(38);
var has = __webpack_require__(35);
var $export = __webpack_require__(6);
var isObject = __webpack_require__(15);
var anObject = __webpack_require__(10);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(37);
var $export = __webpack_require__(6);
var anObject = __webpack_require__(10);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(6);
var getProto = __webpack_require__(38);
var anObject = __webpack_require__(10);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(6);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(6);
var anObject = __webpack_require__(10);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(6);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(213) });

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(6);
var anObject = __webpack_require__(10);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(22);
var gOPD = __webpack_require__(37);
var getPrototypeOf = __webpack_require__(38);
var has = __webpack_require__(35);
var $export = __webpack_require__(6);
var createDesc = __webpack_require__(57);
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(15);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(6);
var setProto = __webpack_require__(135);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes

var $export = __webpack_require__(6);
var $includes = __webpack_require__(101)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(55)('includes');

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap

var $export = __webpack_require__(6);
var flattenIntoArray = __webpack_require__(214);
var toObject = __webpack_require__(24);
var toLength = __webpack_require__(19);
var aFunction = __webpack_require__(25);
var arraySpeciesCreate = __webpack_require__(148);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(55)('flatMap');

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten

var $export = __webpack_require__(6);
var flattenIntoArray = __webpack_require__(214);
var toObject = __webpack_require__(24);
var toLength = __webpack_require__(19);
var toInteger = __webpack_require__(43);
var arraySpeciesCreate = __webpack_require__(148);

$export($export.P, 'Array', {
  flatten: function flatten() /* depthArg = 1 */{
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(55)('flatten');

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at

var $export = __webpack_require__(6);
var $at = __webpack_require__(104)(true);
var $fails = __webpack_require__(14);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end

var $export = __webpack_require__(6);
var $pad = __webpack_require__(215);
var userAgent = __webpack_require__(109);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end

var $export = __webpack_require__(6);
var $pad = __webpack_require__(215);
var userAgent = __webpack_require__(109);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim

__webpack_require__(72)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim

__webpack_require__(72)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/

var $export = __webpack_require__(6);
var defined = __webpack_require__(47);
var toLength = __webpack_require__(19);
var isRegExp = __webpack_require__(105);
var getFlags = __webpack_require__(83);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function $RegExpStringIterator(regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(142)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(131)('asyncIterator');

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(131)('observable');

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(6);
var ownKeys = __webpack_require__(213);
var toIObject = __webpack_require__(36);
var gOPD = __webpack_require__(37);
var createProperty = __webpack_require__(146);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(6);
var $values = __webpack_require__(216)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(6);
var $entries = __webpack_require__(216)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var toObject = __webpack_require__(24);
var aFunction = __webpack_require__(25);
var $defineProperty = __webpack_require__(22);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(21) && $export($export.P + __webpack_require__(112), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var toObject = __webpack_require__(24);
var aFunction = __webpack_require__(25);
var $defineProperty = __webpack_require__(22);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(21) && $export($export.P + __webpack_require__(112), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var toObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(46);
var getPrototypeOf = __webpack_require__(38);
var getOwnPropertyDescriptor = __webpack_require__(37).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(21) && $export($export.P + __webpack_require__(112), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var toObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(46);
var getPrototypeOf = __webpack_require__(38);
var getOwnPropertyDescriptor = __webpack_require__(37).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(21) && $export($export.P + __webpack_require__(112), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(6);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(217)('Map') });

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(6);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(217)('Set') });

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(113)('Map');

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(113)('Set');

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(113)('WeakMap');

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(113)('WeakSet');

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(114)('Map');

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(114)('Set');

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(114)('WeakMap');

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(114)('WeakSet');

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/tc39/proposal-global
var $export = __webpack_require__(6);

$export($export.G, { global: __webpack_require__(12) });

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/tc39/proposal-global
var $export = __webpack_require__(6);

$export($export.S, 'System', { global: __webpack_require__(12) });

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(6);
var cof = __webpack_require__(42);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(6);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(6);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(6);
var scale = __webpack_require__(219);
var fround = __webpack_require__(198);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(6);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(6);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(6);

$export($export.S, 'Math', { scale: __webpack_require__(219) });

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(6);

$export($export.S, 'Math', { signbit: function signbit(x) {
    // eslint-disable-next-line no-self-compare
    return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
  } });

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally


var $export = __webpack_require__(6);
var core = __webpack_require__(40);
var global = __webpack_require__(12);
var speciesConstructor = __webpack_require__(84);
var promiseResolve = __webpack_require__(206);

$export($export.P + $export.R, 'Promise', { 'finally': function _finally(onFinally) {
    var C = speciesConstructor(this, core.Promise || global.Promise);
    var isFunction = typeof onFinally == 'function';
    return this.then(isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () {
        return x;
      });
    } : onFinally, isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () {
        throw e;
      });
    } : onFinally);
  } });

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try

var $export = __webpack_require__(6);
var newPromiseCapability = __webpack_require__(155);
var perform = __webpack_require__(205);

$export($export.S, 'Promise', { 'try': function _try(callbackfn) {
    var promiseCapability = newPromiseCapability.f(this);
    var result = perform(callbackfn);
    (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
    return promiseCapability.promise;
  } });

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
    ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
  } });

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
    var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
    var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
    if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
    if (metadataMap.size) return true;
    var targetMetadata = store.get(target);
    targetMetadata['delete'](targetKey);
    return !!targetMetadata.size || store['delete'](target);
  } });

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(38);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function ordinaryGetMetadata(MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
    return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
  } });

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Set = __webpack_require__(209);
var from = __webpack_require__(218);
var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(38);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function ordinaryMetadataKeys(O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
    return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
  } });

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
    return ordinaryGetOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
  } });

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
    return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
  } });

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(38);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function ordinaryHasMetadata(MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
    return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
  } });

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
    return ordinaryHasOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
  } });

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var aFunction = __webpack_require__(25);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
    return function decorator(target, targetKey) {
      ordinaryDefineOwnMetadata(metadataKey, metadataValue, (targetKey !== undefined ? anObject : aFunction)(target), toMetaKey(targetKey));
    };
  } });

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(6);
var microtask = __webpack_require__(154)();
var process = __webpack_require__(12).process;
var isNode = __webpack_require__(42)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable

var $export = __webpack_require__(6);
var global = __webpack_require__(12);
var core = __webpack_require__(40);
var microtask = __webpack_require__(154)();
var OBSERVABLE = __webpack_require__(18)('observable');
var aFunction = __webpack_require__(25);
var anObject = __webpack_require__(10);
var anInstance = __webpack_require__(64);
var redefineAll = __webpack_require__(66);
var hide = __webpack_require__(29);
var forOf = __webpack_require__(65);
var RETURN = forOf.RETURN;

var getMethod = function getMethod(fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function cleanupSubscription(subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function subscriptionClosed(subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function closeSubscription(subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function Subscription(observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function cleanup() {
        subscription.unsubscribe();
      };else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  }if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() {
    closeSubscription(this);
  }
});

var SubscriptionObserver = function SubscriptionObserver(subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    }cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      }cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function next(value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          }observer.complete();
        }
      });
      return function () {
        done = true;
      };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) {
      items[i] = arguments[i++];
    }return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          }observer.complete();
        }
      });
      return function () {
        done = true;
      };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () {
  return this;
});

$export($export.G, { Observable: $Observable });

__webpack_require__(63)('Observable');

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(12);
var $export = __webpack_require__(6);
var userAgent = __webpack_require__(109);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function wrap(set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(6);
var $task = __webpack_require__(153);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $iterators = __webpack_require__(150);
var getKeys = __webpack_require__(59);
var redefine = __webpack_require__(30);
var global = __webpack_require__(12);
var hide = __webpack_require__(29);
var Iterators = __webpack_require__(73);
var wks = __webpack_require__(18);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) {
      if (!proto[key]) redefine(proto, key, $iterators[key], true);
    }
  }
}

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!function (global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = ( false ? "undefined" : _typeof(module)) === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  runtime.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function (arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (_typeof(global.process) === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));

    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function stop() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
}(
// Among the various tricks for obtaining a reference to the global
// object, this seems to be the most reliable technique that does not
// use indirect eval (which violates Content Security Policy).
(typeof global === "undefined" ? "undefined" : _typeof(global)) === "object" ? global : (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" ? window : (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" ? self : undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39), __webpack_require__(45)(module)))

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(986);
module.exports = __webpack_require__(40).RegExp.escape;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(6);
var $re = __webpack_require__(987)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) {
    return $re(it);
  } });

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {};
Timeout.prototype.close = function () {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(989);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || undefined && undefined.setImmediate;
exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || undefined && undefined.clearImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") {
            callback = new Function("" + callback);
        }
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i + 1];
        }
        // Store and register the task
        var task = { callback: callback, args: args };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
            process.nextTick(function () {
                runIfPresent(handle);
            });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function onGlobalMessage(event) {
            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function registerImmediate(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function registerImmediate(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function registerImmediate(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();
    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();
    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();
    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39), __webpack_require__(220)))

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * vue-resource v1.5.3
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */
var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;
function Promise$1(executor) {
  this.state = PENDING;
  this.value = undefined;
  this.deferred = [];
  var promise = this;

  try {
    executor(function (x) {
      promise.resolve(x);
    }, function (r) {
      promise.reject(r);
    });
  } catch (e) {
    promise.reject(e);
  }
}

Promise$1.reject = function (r) {
  return new Promise$1(function (resolve, reject) {
    reject(r);
  });
};

Promise$1.resolve = function (x) {
  return new Promise$1(function (resolve, reject) {
    resolve(x);
  });
};

Promise$1.all = function all(iterable) {
  return new Promise$1(function (resolve, reject) {
    var count = 0,
        result = [];

    if (iterable.length === 0) {
      resolve(result);
    }

    function resolver(i) {
      return function (x) {
        result[i] = x;
        count += 1;

        if (count === iterable.length) {
          resolve(result);
        }
      };
    }

    for (var i = 0; i < iterable.length; i += 1) {
      Promise$1.resolve(iterable[i]).then(resolver(i), reject);
    }
  });
};

Promise$1.race = function race(iterable) {
  return new Promise$1(function (resolve, reject) {
    for (var i = 0; i < iterable.length; i += 1) {
      Promise$1.resolve(iterable[i]).then(resolve, reject);
    }
  });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
  var promise = this;

  if (promise.state === PENDING) {
    if (x === promise) {
      throw new TypeError('Promise settled with itself.');
    }

    var called = false;

    try {
      var then = x && x['then'];

      if (x !== null && (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && typeof then === 'function') {
        then.call(x, function (x) {
          if (!called) {
            promise.resolve(x);
          }

          called = true;
        }, function (r) {
          if (!called) {
            promise.reject(r);
          }

          called = true;
        });
        return;
      }
    } catch (e) {
      if (!called) {
        promise.reject(e);
      }

      return;
    }

    promise.state = RESOLVED;
    promise.value = x;
    promise.notify();
  }
};

p.reject = function reject(reason) {
  var promise = this;

  if (promise.state === PENDING) {
    if (reason === promise) {
      throw new TypeError('Promise settled with itself.');
    }

    promise.state = REJECTED;
    promise.value = reason;
    promise.notify();
  }
};

p.notify = function notify() {
  var promise = this;
  nextTick(function () {
    if (promise.state !== PENDING) {
      while (promise.deferred.length) {
        var deferred = promise.deferred.shift(),
            onResolved = deferred[0],
            onRejected = deferred[1],
            resolve = deferred[2],
            reject = deferred[3];

        try {
          if (promise.state === RESOLVED) {
            if (typeof onResolved === 'function') {
              resolve(onResolved.call(undefined, promise.value));
            } else {
              resolve(promise.value);
            }
          } else if (promise.state === REJECTED) {
            if (typeof onRejected === 'function') {
              resolve(onRejected.call(undefined, promise.value));
            } else {
              reject(promise.value);
            }
          }
        } catch (e) {
          reject(e);
        }
      }
    }
  });
};

p.then = function then(onResolved, onRejected) {
  var promise = this;
  return new Promise$1(function (resolve, reject) {
    promise.deferred.push([onResolved, onRejected, resolve, reject]);
    promise.notify();
  });
};

p["catch"] = function (onRejected) {
  return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
  window.Promise = Promise$1;
}

function PromiseObj(executor, context) {
  if (executor instanceof Promise) {
    this.promise = executor;
  } else {
    this.promise = new Promise(executor.bind(context));
  }

  this.context = context;
}

PromiseObj.all = function (iterable, context) {
  return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
  return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
  return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
  return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
  this.context = context;
  return this;
};

p$1.then = function (fulfilled, rejected) {
  if (fulfilled && fulfilled.bind && this.context) {
    fulfilled = fulfilled.bind(this.context);
  }

  if (rejected && rejected.bind && this.context) {
    rejected = rejected.bind(this.context);
  }

  return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1["catch"] = function (rejected) {
  if (rejected && rejected.bind && this.context) {
    rejected = rejected.bind(this.context);
  }

  return new PromiseObj(this.promise["catch"](rejected), this.context);
};

p$1["finally"] = function (callback) {
  return this.then(function (value) {
    callback.call(this);
    return value;
  }, function (reason) {
    callback.call(this);
    return Promise.reject(reason);
  });
};

/**
 * Utility functions.
 */
var _ref = {},
    hasOwnProperty = _ref.hasOwnProperty,
    slice = [].slice,
    debug = false,
    ntick;
var inBrowser = typeof window !== 'undefined';
function Util(_ref2) {
  var config = _ref2.config,
      nextTick = _ref2.nextTick;
  ntick = nextTick;
  debug = config.debug || !config.silent;
}
function warn(msg) {
  if (typeof console !== 'undefined' && debug) {
    console.warn('[VueResource warn]: ' + msg);
  }
}
function error(msg) {
  if (typeof console !== 'undefined') {
    console.error(msg);
  }
}
function nextTick(cb, ctx) {
  return ntick(cb, ctx);
}
function trim(str) {
  return str ? str.replace(/^\s*|\s*$/g, '') : '';
}
function trimEnd(str, chars) {
  if (str && chars === undefined) {
    return str.replace(/\s+$/, '');
  }

  if (!str || !chars) {
    return str;
  }

  return str.replace(new RegExp("[" + chars + "]+$"), '');
}
function toLower(str) {
  return str ? str.toLowerCase() : '';
}
function toUpper(str) {
  return str ? str.toUpperCase() : '';
}
var isArray = Array.isArray;
function isString(val) {
  return typeof val === 'string';
}
function isFunction(val) {
  return typeof val === 'function';
}
function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}
function isPlainObject(obj) {
  return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}
function isBlob(obj) {
  return typeof Blob !== 'undefined' && obj instanceof Blob;
}
function isFormData(obj) {
  return typeof FormData !== 'undefined' && obj instanceof FormData;
}
function when(value, fulfilled, rejected) {
  var promise = PromiseObj.resolve(value);

  if (arguments.length < 2) {
    return promise;
  }

  return promise.then(fulfilled, rejected);
}
function options(fn, obj, opts) {
  opts = opts || {};

  if (isFunction(opts)) {
    opts = opts.call(obj);
  }

  return merge(fn.bind({
    $vm: obj,
    $options: opts
  }), fn, {
    $options: opts
  });
}
function each(obj, iterator) {
  var i, key;

  if (isArray(obj)) {
    for (i = 0; i < obj.length; i++) {
      iterator.call(obj[i], obj[i], i);
    }
  } else if (isObject(obj)) {
    for (key in obj) {
      if (hasOwnProperty.call(obj, key)) {
        iterator.call(obj[key], obj[key], key);
      }
    }
  }

  return obj;
}
var assign = Object.assign || _assign;
function merge(target) {
  var args = slice.call(arguments, 1);
  args.forEach(function (source) {
    _merge(target, source, true);
  });
  return target;
}
function defaults(target) {
  var args = slice.call(arguments, 1);
  args.forEach(function (source) {
    for (var key in source) {
      if (target[key] === undefined) {
        target[key] = source[key];
      }
    }
  });
  return target;
}

function _assign(target) {
  var args = slice.call(arguments, 1);
  args.forEach(function (source) {
    _merge(target, source);
  });
  return target;
}

function _merge(target, source, deep) {
  for (var key in source) {
    if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
      if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
        target[key] = {};
      }

      if (isArray(source[key]) && !isArray(target[key])) {
        target[key] = [];
      }

      _merge(target[key], source[key], deep);
    } else if (source[key] !== undefined) {
      target[key] = source[key];
    }
  }
}

/**
 * Root Prefix Transform.
 */
function root(options$$1, next) {
  var url = next(options$$1);

  if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
    url = trimEnd(options$$1.root, '/') + '/' + url;
  }

  return url;
}

/**
 * Query Parameter Transform.
 */
function query(options$$1, next) {
  var urlParams = Object.keys(Url.options.params),
      query = {},
      url = next(options$$1);
  each(options$$1.params, function (value, key) {
    if (urlParams.indexOf(key) === -1) {
      query[key] = value;
    }
  });
  query = Url.params(query);

  if (query) {
    url += (url.indexOf('?') == -1 ? '?' : '&') + query;
  }

  return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */
function expand(url, params, variables) {
  var tmpl = parse(url),
      expanded = tmpl.expand(params);

  if (variables) {
    variables.push.apply(variables, tmpl.vars);
  }

  return expanded;
}
function parse(template) {
  var operators = ['+', '#', '.', '/', ';', '?', '&'],
      variables = [];
  return {
    vars: variables,
    expand: function expand(context) {
      return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
        if (expression) {
          var operator = null,
              values = [];

          if (operators.indexOf(expression.charAt(0)) !== -1) {
            operator = expression.charAt(0);
            expression = expression.substr(1);
          }

          expression.split(/,/g).forEach(function (variable) {
            var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
            values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
            variables.push(tmp[1]);
          });

          if (operator && operator !== '+') {
            var separator = ',';

            if (operator === '?') {
              separator = '&';
            } else if (operator !== '#') {
              separator = operator;
            }

            return (values.length !== 0 ? operator : '') + values.join(separator);
          } else {
            return values.join(',');
          }
        } else {
          return encodeReserved(literal);
        }
      });
    }
  };
}

function getValues(context, operator, key, modifier) {
  var value = context[key],
      result = [];

  if (isDefined(value) && value !== '') {
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      value = value.toString();

      if (modifier && modifier !== '*') {
        value = value.substring(0, parseInt(modifier, 10));
      }

      result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
    } else {
      if (modifier === '*') {
        if (Array.isArray(value)) {
          value.filter(isDefined).forEach(function (value) {
            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
          });
        } else {
          Object.keys(value).forEach(function (k) {
            if (isDefined(value[k])) {
              result.push(encodeValue(operator, value[k], k));
            }
          });
        }
      } else {
        var tmp = [];

        if (Array.isArray(value)) {
          value.filter(isDefined).forEach(function (value) {
            tmp.push(encodeValue(operator, value));
          });
        } else {
          Object.keys(value).forEach(function (k) {
            if (isDefined(value[k])) {
              tmp.push(encodeURIComponent(k));
              tmp.push(encodeValue(operator, value[k].toString()));
            }
          });
        }

        if (isKeyOperator(operator)) {
          result.push(encodeURIComponent(key) + '=' + tmp.join(','));
        } else if (tmp.length !== 0) {
          result.push(tmp.join(','));
        }
      }
    }
  } else {
    if (operator === ';') {
      result.push(encodeURIComponent(key));
    } else if (value === '' && (operator === '&' || operator === '?')) {
      result.push(encodeURIComponent(key) + '=');
    } else if (value === '') {
      result.push('');
    }
  }

  return result;
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
  return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {
  value = operator === '+' || operator === '#' ? encodeReserved(value) : encodeURIComponent(value);

  if (key) {
    return encodeURIComponent(key) + '=' + value;
  } else {
    return value;
  }
}

function encodeReserved(str) {
  return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
    if (!/%[0-9A-Fa-f]/.test(part)) {
      part = encodeURI(part);
    }

    return part;
  }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */
function template(options) {
  var variables = [],
      url = expand(options.url, options.params, variables);
  variables.forEach(function (key) {
    delete options.params[key];
  });
  return url;
}

/**
 * Service for URL templating.
 */
function Url(url, params) {
  var self = this || {},
      options$$1 = url,
      transform;

  if (isString(url)) {
    options$$1 = {
      url: url,
      params: params
    };
  }

  options$$1 = merge({}, Url.options, self.$options, options$$1);
  Url.transforms.forEach(function (handler) {
    if (isString(handler)) {
      handler = Url.transform[handler];
    }

    if (isFunction(handler)) {
      transform = factory(handler, transform, self.$vm);
    }
  });
  return transform(options$$1);
}
/**
 * Url options.
 */

Url.options = {
  url: '',
  root: null,
  params: {}
};
/**
 * Url transforms.
 */

Url.transform = {
  template: template,
  query: query,
  root: root
};
Url.transforms = ['template', 'query', 'root'];
/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {
  var params = [],
      escape = encodeURIComponent;

  params.add = function (key, value) {
    if (isFunction(value)) {
      value = value();
    }

    if (value === null) {
      value = '';
    }

    this.push(escape(key) + '=' + escape(value));
  };

  serialize(params, obj);
  return params.join('&').replace(/%20/g, '+');
};
/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {
  var el = document.createElement('a');

  if (document.documentMode) {
    el.href = url;
    url = el.href;
  }

  el.href = url;
  return {
    href: el.href,
    protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
    port: el.port,
    host: el.host,
    hostname: el.hostname,
    pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
    search: el.search ? el.search.replace(/^\?/, '') : '',
    hash: el.hash ? el.hash.replace(/^#/, '') : ''
  };
};

function factory(handler, next, vm) {
  return function (options$$1) {
    return handler.call(vm, options$$1, next);
  };
}

function serialize(params, obj, scope) {
  var array = isArray(obj),
      plain = isPlainObject(obj),
      hash;
  each(obj, function (value, key) {
    hash = isObject(value) || isArray(value);

    if (scope) {
      key = scope + '[' + (plain || hash ? key : '') + ']';
    }

    if (!scope && array) {
      params.add(value.name, value.value);
    } else if (hash) {
      serialize(params, value, key);
    } else {
      params.add(key, value);
    }
  });
}

/**
 * XDomain client (Internet Explorer).
 */
function xdrClient(request) {
  return new PromiseObj(function (resolve) {
    var xdr = new XDomainRequest(),
        handler = function handler(_ref) {
      var type = _ref.type;
      var status = 0;

      if (type === 'load') {
        status = 200;
      } else if (type === 'error') {
        status = 500;
      }

      resolve(request.respondWith(xdr.responseText, {
        status: status
      }));
    };

    request.abort = function () {
      return xdr.abort();
    };

    xdr.open(request.method, request.getUrl());

    if (request.timeout) {
      xdr.timeout = request.timeout;
    }

    xdr.onload = handler;
    xdr.onabort = handler;
    xdr.onerror = handler;
    xdr.ontimeout = handler;

    xdr.onprogress = function () {};

    xdr.send(request.getBody());
  });
}

/**
 * CORS Interceptor.
 */
var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();
function cors(request) {
  if (inBrowser) {
    var orgUrl = Url.parse(location.href);
    var reqUrl = Url.parse(request.getUrl());

    if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {
      request.crossOrigin = true;
      request.emulateHTTP = false;

      if (!SUPPORTS_CORS) {
        request.client = xdrClient;
      }
    }
  }
}

/**
 * Form data Interceptor.
 */
function form(request) {
  if (isFormData(request.body)) {
    request.headers["delete"]('Content-Type');
  } else if (isObject(request.body) && request.emulateJSON) {
    request.body = Url.params(request.body);
    request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
  }
}

/**
 * JSON Interceptor.
 */
function json(request) {
  var type = request.headers.get('Content-Type') || '';

  if (isObject(request.body) && type.indexOf('application/json') === 0) {
    request.body = JSON.stringify(request.body);
  }

  return function (response) {
    return response.bodyText ? when(response.text(), function (text) {
      var type = response.headers.get('Content-Type') || '';

      if (type.indexOf('application/json') === 0 || isJson(text)) {
        try {
          response.body = JSON.parse(text);
        } catch (e) {
          response.body = null;
        }
      } else {
        response.body = text;
      }

      return response;
    }) : response;
  };
}

function isJson(str) {
  var start = str.match(/^\s*(\[|\{)/);
  var end = {
    '[': /]\s*$/,
    '{': /}\s*$/
  };
  return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */
function jsonpClient(request) {
  return new PromiseObj(function (resolve) {
    var name = request.jsonp || 'callback',
        callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2),
        body = null,
        handler,
        script;

    handler = function handler(_ref) {
      var type = _ref.type;
      var status = 0;

      if (type === 'load' && body !== null) {
        status = 200;
      } else if (type === 'error') {
        status = 500;
      }

      if (status && window[callback]) {
        delete window[callback];
        document.body.removeChild(script);
      }

      resolve(request.respondWith(body, {
        status: status
      }));
    };

    window[callback] = function (result) {
      body = JSON.stringify(result);
    };

    request.abort = function () {
      handler({
        type: 'abort'
      });
    };

    request.params[name] = callback;

    if (request.timeout) {
      setTimeout(request.abort, request.timeout);
    }

    script = document.createElement('script');
    script.src = request.getUrl();
    script.type = 'text/javascript';
    script.async = true;
    script.onload = handler;
    script.onerror = handler;
    document.body.appendChild(script);
  });
}

/**
 * JSONP Interceptor.
 */
function jsonp(request) {
  if (request.method == 'JSONP') {
    request.client = jsonpClient;
  }
}

/**
 * Before Interceptor.
 */
function before(request) {
  if (isFunction(request.before)) {
    request.before.call(this, request);
  }
}

/**
 * HTTP method override Interceptor.
 */
function method(request) {
  if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
    request.headers.set('X-HTTP-Method-Override', request.method);
    request.method = 'POST';
  }
}

/**
 * Header Interceptor.
 */
function header(request) {
  var headers = assign({}, Http.headers.common, !request.crossOrigin ? Http.headers.custom : {}, Http.headers[toLower(request.method)]);
  each(headers, function (value, name) {
    if (!request.headers.has(name)) {
      request.headers.set(name, value);
    }
  });
}

/**
 * XMLHttp client (Browser).
 */
function xhrClient(request) {
  return new PromiseObj(function (resolve) {
    var xhr = new XMLHttpRequest(),
        handler = function handler(event) {
      var response = request.respondWith('response' in xhr ? xhr.response : xhr.responseText, {
        status: xhr.status === 1223 ? 204 : xhr.status,
        // IE9 status bug
        statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
      });
      each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
        response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
      });
      resolve(response);
    };

    request.abort = function () {
      return xhr.abort();
    };

    xhr.open(request.method, request.getUrl(), true);

    if (request.timeout) {
      xhr.timeout = request.timeout;
    }

    if (request.responseType && 'responseType' in xhr) {
      xhr.responseType = request.responseType;
    }

    if (request.withCredentials || request.credentials) {
      xhr.withCredentials = true;
    }

    if (!request.crossOrigin) {
      request.headers.set('X-Requested-With', 'XMLHttpRequest');
    } // deprecated use downloadProgress


    if (isFunction(request.progress) && request.method === 'GET') {
      xhr.addEventListener('progress', request.progress);
    }

    if (isFunction(request.downloadProgress)) {
      xhr.addEventListener('progress', request.downloadProgress);
    } // deprecated use uploadProgress


    if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
      xhr.upload.addEventListener('progress', request.progress);
    }

    if (isFunction(request.uploadProgress) && xhr.upload) {
      xhr.upload.addEventListener('progress', request.uploadProgress);
    }

    request.headers.forEach(function (value, name) {
      xhr.setRequestHeader(name, value);
    });
    xhr.onload = handler;
    xhr.onabort = handler;
    xhr.onerror = handler;
    xhr.ontimeout = handler;
    xhr.send(request.getBody());
  });
}

/**
 * Http client (Node).
 */
function nodeClient(request) {
  var client = __webpack_require__(991);

  return new PromiseObj(function (resolve) {
    var url = request.getUrl();
    var body = request.getBody();
    var method = request.method;
    var headers = {},
        handler;
    request.headers.forEach(function (value, name) {
      headers[name] = value;
    });
    client(url, {
      body: body,
      method: method,
      headers: headers
    }).then(handler = function handler(resp) {
      var response = request.respondWith(resp.body, {
        status: resp.statusCode,
        statusText: trim(resp.statusMessage)
      });
      each(resp.headers, function (value, name) {
        response.headers.set(name, value);
      });
      resolve(response);
    }, function (error$$1) {
      return handler(error$$1.response);
    });
  });
}

/**
 * Base client.
 */
function Client(context) {
  var reqHandlers = [sendRequest],
      resHandlers = [];

  if (!isObject(context)) {
    context = null;
  }

  function Client(request) {
    while (reqHandlers.length) {
      var handler = reqHandlers.pop();

      if (isFunction(handler)) {
        var _ret = function () {
          var response = void 0,
              next = void 0;
          response = handler.call(context, request, function (val) {
            return next = val;
          }) || next;

          if (isObject(response)) {
            return {
              v: new PromiseObj(function (resolve, reject) {
                resHandlers.forEach(function (handler) {
                  response = when(response, function (response) {
                    return handler.call(context, response) || response;
                  }, reject);
                });
                when(response, resolve, reject);
              }, context)
            };
          }

          if (isFunction(response)) {
            resHandlers.unshift(response);
          }
        }();

        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
      } else {
        warn("Invalid interceptor of type " + (typeof handler === 'undefined' ? 'undefined' : _typeof(handler)) + ", must be a function");
      }
    }
  }

  Client.use = function (handler) {
    reqHandlers.push(handler);
  };

  return Client;
}

function sendRequest(request) {
  var client = request.client || (inBrowser ? xhrClient : nodeClient);
  return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = /*#__PURE__*/function () {
  function Headers(headers) {
    var _this = this;

    this.map = {};
    each(headers, function (value, name) {
      return _this.append(name, value);
    });
  }

  var _proto = Headers.prototype;

  _proto.has = function has(name) {
    return getName(this.map, name) !== null;
  };

  _proto.get = function get(name) {
    var list = this.map[getName(this.map, name)];
    return list ? list.join() : null;
  };

  _proto.getAll = function getAll(name) {
    return this.map[getName(this.map, name)] || [];
  };

  _proto.set = function set(name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
  };

  _proto.append = function append(name, value) {
    var list = this.map[getName(this.map, name)];

    if (list) {
      list.push(trim(value));
    } else {
      this.set(name, value);
    }
  };

  _proto["delete"] = function _delete(name) {
    delete this.map[getName(this.map, name)];
  };

  _proto.deleteAll = function deleteAll() {
    this.map = {};
  };

  _proto.forEach = function forEach(callback, thisArg) {
    var _this2 = this;

    each(this.map, function (list, name) {
      each(list, function (value) {
        return callback.call(thisArg, value, name, _this2);
      });
    });
  };

  return Headers;
}();

function getName(map, name) {
  return Object.keys(map).reduce(function (prev, curr) {
    return toLower(name) === toLower(curr) ? curr : prev;
  }, null);
}

function normalizeName(name) {
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name');
  }

  return trim(name);
}

/**
 * HTTP Response.
 */

var Response = /*#__PURE__*/function () {
  function Response(body, _ref) {
    var url = _ref.url,
        headers = _ref.headers,
        status = _ref.status,
        statusText = _ref.statusText;
    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {
      this.bodyText = body;
    } else if (isBlob(body)) {
      this.bodyBlob = body;

      if (isBlobText(body)) {
        this.bodyText = blobText(body);
      }
    }
  }

  var _proto = Response.prototype;

  _proto.blob = function blob() {
    return when(this.bodyBlob);
  };

  _proto.text = function text() {
    return when(this.bodyText);
  };

  _proto.json = function json() {
    return when(this.text(), function (text) {
      return JSON.parse(text);
    });
  };

  return Response;
}();
Object.defineProperty(Response.prototype, 'data', {
  get: function get() {
    return this.body;
  },
  set: function set(body) {
    this.body = body;
  }
});

function blobText(body) {
  return new PromiseObj(function (resolve) {
    var reader = new FileReader();
    reader.readAsText(body);

    reader.onload = function () {
      resolve(reader.result);
    };
  });
}

function isBlobText(body) {
  return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = /*#__PURE__*/function () {
  function Request(options$$1) {
    this.body = null;
    this.params = {};
    assign(this, options$$1, {
      method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
      this.headers = new Headers(this.headers);
    }
  }

  var _proto = Request.prototype;

  _proto.getUrl = function getUrl() {
    return Url(this);
  };

  _proto.getBody = function getBody() {
    return this.body;
  };

  _proto.respondWith = function respondWith(body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {
      url: this.getUrl()
    }));
  };

  return Request;
}();

/**
 * Service for sending network requests.
 */
var COMMON_HEADERS = {
  'Accept': 'application/json, text/plain, */*'
};
var JSON_CONTENT_TYPE = {
  'Content-Type': 'application/json;charset=utf-8'
};
function Http(options$$1) {
  var self = this || {},
      client = Client(self.$vm);
  defaults(options$$1 || {}, self.$options, Http.options);
  Http.interceptors.forEach(function (handler) {
    if (isString(handler)) {
      handler = Http.interceptor[handler];
    }

    if (isFunction(handler)) {
      client.use(handler);
    }
  });
  return client(new Request(options$$1)).then(function (response) {
    return response.ok ? response : PromiseObj.reject(response);
  }, function (response) {
    if (response instanceof Error) {
      error(response);
    }

    return PromiseObj.reject(response);
  });
}
Http.options = {};
Http.headers = {
  put: JSON_CONTENT_TYPE,
  post: JSON_CONTENT_TYPE,
  patch: JSON_CONTENT_TYPE,
  "delete": JSON_CONTENT_TYPE,
  common: COMMON_HEADERS,
  custom: {}
};
Http.interceptor = {
  before: before,
  method: method,
  jsonp: jsonp,
  json: json,
  form: form,
  header: header,
  cors: cors
};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];
['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {
  Http[method$$1] = function (url, options$$1) {
    return this(assign(options$$1 || {}, {
      url: url,
      method: method$$1
    }));
  };
});
['post', 'put', 'patch'].forEach(function (method$$1) {
  Http[method$$1] = function (url, body, options$$1) {
    return this(assign(options$$1 || {}, {
      url: url,
      method: method$$1,
      body: body
    }));
  };
});

/**
 * Service for interacting with RESTful services.
 */
function Resource(url, params, actions, options$$1) {
  var self = this || {},
      resource = {};
  actions = assign({}, Resource.actions, actions);
  each(actions, function (action, name) {
    action = merge({
      url: url,
      params: assign({}, params)
    }, options$$1, action);

    resource[name] = function () {
      return (self.$http || Http)(opts(action, arguments));
    };
  });
  return resource;
}

function opts(action, args) {
  var options$$1 = assign({}, action),
      params = {},
      body;

  switch (args.length) {
    case 2:
      params = args[0];
      body = args[1];
      break;

    case 1:
      if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
        body = args[0];
      } else {
        params = args[0];
      }

      break;

    case 0:
      break;

    default:
      throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
  }

  options$$1.body = body;
  options$$1.params = assign({}, options$$1.params, params);
  return options$$1;
}

Resource.actions = {
  get: {
    method: 'GET'
  },
  save: {
    method: 'POST'
  },
  query: {
    method: 'GET'
  },
  update: {
    method: 'PUT'
  },
  remove: {
    method: 'DELETE'
  },
  "delete": {
    method: 'DELETE'
  }
};

/**
 * Install plugin.
 */

function plugin(Vue) {
  if (plugin.installed) {
    return;
  }

  Util(Vue);
  Vue.url = Url;
  Vue.http = Http;
  Vue.resource = Resource;
  Vue.Promise = PromiseObj;
  Object.defineProperties(Vue.prototype, {
    $url: {
      get: function get() {
        return options(Vue.url, this, this.$options.url);
      }
    },
    $http: {
      get: function get() {
        return options(Vue.http, this, this.$options.http);
      }
    },
    $resource: {
      get: function get() {
        return Vue.resource.bind(this);
      }
    },
    $promise: {
      get: function get() {
        var _this = this;

        return function (executor) {
          return new Vue.Promise(executor, _this);
        };
      }
    }
  });
}

if (typeof window !== 'undefined' && window.Vue && !window.Vue.resource) {
  window.Vue.use(plugin);
}

exports.default = plugin;
exports.Url = Url;
exports.Http = Http;
exports.Resource = Resource;

/***/ }),
/* 991 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(32);
var bind = __webpack_require__(222);
var Axios = __webpack_require__(993);
var mergeConfig = __webpack_require__(228);
var defaults = __webpack_require__(225);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(229);
axios.CancelToken = __webpack_require__(1006);
axios.isCancel = __webpack_require__(224);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1007);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(32);
var buildURL = __webpack_require__(223);
var InterceptorManager = __webpack_require__(994);
var dispatchRequest = __webpack_require__(995);
var mergeConfig = __webpack_require__(228);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(32);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(32);
var transformData = __webpack_require__(996);
var isCancel = __webpack_require__(224);
var defaults = __webpack_require__(225);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);

  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(32);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(32);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(227);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function () {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(1001);
var combineURLs = __webpack_require__(1002);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
  );
};

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(32);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(32);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(32);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(229);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (o) {
  return typeof o === "undefined" ? "undefined" : _typeof2(o);
} : function (o) {
  return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o === "undefined" ? "undefined" : _typeof2(o);
};!function () {
  function o(e, t) {
    if (!o.installed) {
      if (o.installed = !0, !t) return void console.error("You have to install axios");e.axios = t, Object.defineProperties(e.prototype, { axios: { get: function get() {
            return t;
          } }, $http: { get: function get() {
            return t;
          } } });
    }
  }"object" == ( false ? "undefined" : _typeof(exports)) ? module.exports = o :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return o;
  }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : window.Vue && window.axios && Vue.use(o, window.axios);
}();

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  * vue-router v3.6.5
  * (c) 2022 Evan You
  * @license MIT
  */
/*  */

function assert(condition, message) {
  if (!condition) {
    throw new Error("[vue-router] " + message);
  }
}

function warn(condition, message) {
  if (!condition) {
    typeof console !== 'undefined' && console.warn("[vue-router] " + message);
  }
}

function extend(a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a;
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function encodeReserveReplacer(c) {
  return '%' + c.charCodeAt(0).toString(16);
};
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function encode(str) {
  return encodeURIComponent(str).replace(encodeReserveRE, encodeReserveReplacer).replace(commaRE, ',');
};

function decode(str) {
  try {
    return decodeURIComponent(str);
  } catch (err) {
    if (false) {
      warn(false, "Error decoding \"" + str + "\". Leaving it intact.");
    }
  }
  return str;
}

function resolveQuery(query, extraQuery, _parseQuery) {
  if (extraQuery === void 0) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value) ? value.map(castQueryParamValue) : castQueryParamValue(value);
  }
  return parsedQuery;
}

var castQueryParamValue = function castQueryParamValue(value) {
  return value == null || (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' ? value : String(value);
};

function parseQuery(query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res;
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res;
}

function stringifyQuery(obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return '';
    }

    if (val === null) {
      return encode(key);
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return;
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&');
    }

    return encode(key) + '=' + encode(val);
  }).filter(function (x) {
    return x.length > 0;
  }).join('&') : null;
  return res ? "?" + res : '';
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute(record, location, redirectedFrom, router) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || record && record.name,
    meta: record && record.meta || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route);
}

function clone(value) {
  if (Array.isArray(value)) {
    return value.map(clone);
  } else if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res;
  } else {
    return value;
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch(record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res;
}

function getFullPath(ref, _stringifyQuery) {
  var path = ref.path;
  var query = ref.query;if (query === void 0) query = {};
  var hash = ref.hash;if (hash === void 0) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash;
}

function isSameRoute(a, b, onlyPath) {
  if (b === START) {
    return a === b;
  } else if (!b) {
    return false;
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && (onlyPath || a.hash === b.hash && isObjectEqual(a.query, b.query));
  } else if (a.name && b.name) {
    return a.name === b.name && (onlyPath || a.hash === b.hash && isObjectEqual(a.query, b.query) && isObjectEqual(a.params, b.params));
  } else {
    return false;
  }
}

function isObjectEqual(a, b) {
  if (a === void 0) a = {};
  if (b === void 0) b = {};

  // handle null value #1566
  if (!a || !b) {
    return a === b;
  }
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false;
  }
  return aKeys.every(function (key, i) {
    var aVal = a[key];
    var bKey = bKeys[i];
    if (bKey !== key) {
      return false;
    }
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) {
      return aVal === bVal;
    }
    // check nested equality
    if ((typeof aVal === "undefined" ? "undefined" : _typeof(aVal)) === 'object' && (typeof bVal === "undefined" ? "undefined" : _typeof(bVal)) === 'object') {
      return isObjectEqual(aVal, bVal);
    }
    return String(aVal) === String(bVal);
  });
}

function isIncludedRoute(current, target) {
  return current.path.replace(trailingSlashRE, '/').indexOf(target.path.replace(trailingSlashRE, '/')) === 0 && (!target.hash || current.hash === target.hash) && queryIncludes(current.query, target.query);
}

function queryIncludes(current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false;
    }
  }
  return true;
}

function handleRouteEntered(route) {
  for (var i = 0; i < route.matched.length; i++) {
    var record = route.matched[i];
    for (var name in record.instances) {
      var instance = record.instances[name];
      var cbs = record.enteredCbs[name];
      if (!instance || !cbs) {
        continue;
      }
      delete record.enteredCbs[name];
      for (var i$1 = 0; i$1 < cbs.length; i$1++) {
        if (!instance._isBeingDestroyed) {
          cbs[i$1](instance);
        }
      }
    }
  }
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render(_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children);
      } else {
        // render previous empty view
        return h();
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h();
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (val && current !== vm || !val && current === vm) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive && vnode.componentInstance && vnode.componentInstance !== matched.instances[name]) {
        matched.instances[name] = vnode.componentInstance;
      }

      // if the route transition has already been confirmed then we weren't
      // able to call the cbs during confirmation as the component was not
      // registered yet, so we call it here.
      handleRouteEntered(route);
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children);
  }
};

function fillPropsinData(component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps(route, config) {
  switch (typeof config === "undefined" ? "undefined" : _typeof(config)) {
    case 'undefined':
      return;
    case 'object':
      return config;
    case 'function':
      return config(route);
    case 'boolean':
      return config ? route.params : undefined;
    default:
      if (false) {
        warn(false, "props in \"" + route.path + "\" is a " + (typeof config === "undefined" ? "undefined" : _typeof(config)) + ", " + "expecting an object, function or boolean.");
      }
  }
}

/*  */

function resolvePath(relative, base, append) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative;
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative;
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/');
}

function parsePath(path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  };
}

function cleanPath(path) {
  return path.replace(/\/(?:\s*\/)+/g, '/');
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
// Match escaped characters that would otherwise appear in future matches.
// This allows the user to escape special characters that won't transform.
'(\\\\.)',
// Match Express-style parameters and un-named parameters with a prefix
// and optional suffixes. Matches appear as:
//
// "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
// "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
// "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
'([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse(str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue;
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?'
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens;
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile(str, options) {
  return tokensToFunction(parse(str, options), options);
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty(str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk(str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (_typeof(tokens[i]) === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue;
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue;
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined');
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
        }

        if (value.length === 0) {
          if (token.optional) {
            continue;
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty');
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue;
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
      }

      path += token.prefix + segment;
    }

    return path;
  };
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString(str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup(group) {
  return group.replace(/([=!:$\/()])/g, '\\$1');
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys(re, keys) {
  re.keys = keys;
  return re;
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags(options) {
  return options && options.sensitive ? '' : 'i';
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp(path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys);
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp(path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys);
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp(path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options);
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp(tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys);
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp(path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */keys);
  }

  if (isarray(path)) {
    return arrayToRegexp( /** @type {!Array} */path, /** @type {!Array} */keys, options);
  }

  return stringToRegexp( /** @type {string} */path, /** @type {!Array} */keys, options);
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams(path, params, routeMsg) {
  params = params || {};
  try {
    var filler = regexpCompileCache[path] || (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') {
      params[0] = params.pathMatch;
    }

    return filler(params, { pretty: true });
  } catch (e) {
    if (false) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', "missing param for " + routeMsg + ": " + e.message);
    }
    return '';
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation(raw, current, append, router) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next;
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && (typeof params === "undefined" ? "undefined" : _typeof(params)) === 'object') {
      next.params = extend({}, params);
    }
    return next;
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, "path " + current.path);
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next;
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = current && current.path || '/';
  var path = parsedPath.path ? resolvePath(parsedPath.path, basePath, append || next.append) : basePath;

  var query = resolveQuery(parsedPath.query, next.query, router && router.options.parseQuery);

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  };
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function noop() {};

var warnedCustomSlot;
var warnedTagProp;
var warnedEventProp;

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render(h) {
    var this$1$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null ? 'router-link-exact-active' : globalExactActiveClass;
    var activeClass = this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null ? exactActiveClassFallback : this.exactActiveClass;

    var compareTarget = route.redirectedFrom ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router) : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget, this.exactPath);
    classes[activeClass] = this.exact || this.exactPath ? classes[exactActiveClass] : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function handler(e) {
      if (guardEvent(e)) {
        if (this$1$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot = !this.$scopedSlots.$hasNormal && this.$scopedSlots.default && this.$scopedSlots.default({
      href: href,
      route: route,
      navigate: handler,
      isActive: classes[activeClass],
      isExactActive: classes[exactActiveClass]
    });

    if (scopedSlot) {
      if (false) {
        !warnedCustomSlot && warn(false, 'In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:\n<router-link v-slot="{ navigate, href }" custom></router-link>\n');
        warnedCustomSlot = true;
      }
      if (scopedSlot.length === 1) {
        return scopedSlot[0];
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(false, "<router-link> with to=\"" + this.to + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.");
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot);
      }
    }

    if (false) {
      if ('tag' in this.$options.propsData && !warnedTagProp) {
        warn(false, "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link.");
        warnedTagProp = true;
      }
      if ('event' in this.$options.propsData && !warnedEventProp) {
        warn(false, "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link.");
        warnedEventProp = true;
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = a.data = extend({}, a.data);
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default);
  }
};

function guardEvent(e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) {
    return;
  }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) {
    return;
  }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) {
    return;
  }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) {
      return;
    }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true;
}

function findAnchor(children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child;
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child;
      }
    }
  }
}

var _Vue;

function install(Vue) {
  if (install.installed && _Vue === Vue) {
    return;
  }
  install.installed = true;

  _Vue = Vue;

  var isDef = function isDef(v) {
    return v !== undefined;
  };

  var registerInstance = function registerInstance(vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate() {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = this.$parent && this.$parent._routerRoot || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed() {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get() {
      return this._routerRoot._router;
    }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get() {
      return this._routerRoot._route;
    }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap(routes, oldPathList, oldPathMap, oldNameMap, parentRoute) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route, parentRoute);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
    .filter(function (path) {
      return path && path.charAt(0) !== '*' && path.charAt(0) !== '/';
    });

    if (found.length > 0) {
      var pathNames = found.map(function (path) {
        return "- " + path;
      }).join('\n');
      warn(false, "Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames);
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  };
}

function addRouteRecord(pathList, pathMap, nameMap, route, parent, matchAs) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(typeof route.component !== 'string', "route config \"component\" for path: " + String(path || name) + " cannot be a " + "string id. Use an actual component instead.");

    warn(
    // eslint-disable-next-line no-control-regex
    !/[^\u0000-\u007F]+/.test(path), "Route with path \"" + path + "\" contains unencoded characters, make sure " + "your path is correctly encoded before passing it to the router. Use " + "encodeURI to encode static segments of your path.");
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    alias: route.alias ? typeof route.alias === 'string' ? [route.alias] : route.alias : [],
    instances: {},
    enteredCbs: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null ? {} : route.components ? route.props : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) {
        return (/^\/?$/.test(child.path)
        );
      })) {
        warn(false, "Named Route '" + route.name + "' has a default child route. " + "When navigating to this named route (:to=\"{name: '" + route.name + "'}\"), " + "the default child route will not be rendered. Remove the name from " + "this route and use the name of the default child route for named " + "links instead.");
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs ? cleanPath(matchAs + "/" + child.path) : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(false, "Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.");
        // skip in dev to make it work
        continue;
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(pathList, pathMap, nameMap, aliasRoute, parent, record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(false, "Duplicate named routes definition: " + "{ name: \"" + name + "\", path: \"" + record.path + "\" }");
    }
  }
}

function compileRouteRegex(path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], "Duplicate param keys in route with path: \"" + path + "\"");
      keys[key.name] = true;
    });
  }
  return regex;
}

function normalizePath(path, parent, strict) {
  if (!strict) {
    path = path.replace(/\/$/, '');
  }
  if (path[0] === '/') {
    return path;
  }
  if (parent == null) {
    return path;
  }
  return cleanPath(parent.path + "/" + path);
}

/*  */

function createMatcher(routes, router) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes(routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function addRoute(parentOrRoute, route) {
    var parent = (typeof parentOrRoute === "undefined" ? "undefined" : _typeof(parentOrRoute)) !== 'object' ? nameMap[parentOrRoute] : undefined;
    // $flow-disable-line
    createRouteMap([route || parentOrRoute], pathList, pathMap, nameMap, parent);

    // add aliases of parent
    if (parent && parent.alias.length) {
      createRouteMap(
      // $flow-disable-line route is defined if parent is
      parent.alias.map(function (alias) {
        return { path: alias, children: [route] };
      }), pathList, pathMap, nameMap, parent);
    }
  }

  function getRoutes() {
    return pathList.map(function (path) {
      return pathMap[path];
    });
  }

  function match(raw, currentRoute, redirectedFrom) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, "Route with name '" + name + "' does not exist");
      }
      if (!record) {
        return _createRoute(null, location);
      }
      var paramNames = record.regex.keys.filter(function (key) {
        return !key.optional;
      }).map(function (key) {
        return key.name;
      });

      if (_typeof(location.params) !== 'object') {
        location.params = {};
      }

      if (currentRoute && _typeof(currentRoute.params) === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, "named route \"" + name + "\"");
      return _createRoute(record, location, redirectedFrom);
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom);
        }
      }
    }
    // no match
    return _createRoute(null, location);
  }

  function redirect(record, location) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function' ? originalRedirect(createRoute(record, location, null, router)) : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || (typeof redirect === "undefined" ? "undefined" : _typeof(redirect)) !== 'object') {
      if (false) {
        warn(false, "invalid redirect option: " + JSON.stringify(redirect));
      }
      return _createRoute(null, location);
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, "redirect failed: named route \"" + name + "\" not found.");
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location);
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, "redirect route with path \"" + rawPath + "\"");
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location);
    } else {
      if (false) {
        warn(false, "invalid redirect option: " + JSON.stringify(redirect));
      }
      return _createRoute(null, location);
    }
  }

  function alias(record, location, matchAs) {
    var aliasedPath = fillParams(matchAs, location.params, "aliased route with path \"" + matchAs + "\"");
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location);
    }
    return _createRoute(null, location);
  }

  function _createRoute(record, location, redirectedFrom) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location);
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs);
    }
    return createRoute(record, location, redirectedFrom, router);
  }

  return {
    match: match,
    addRoute: addRoute,
    getRoutes: getRoutes,
    addRoutes: addRoutes
  };
}

function matchRoute(regex, path, params) {
  var m = path.match(regex);

  if (!m) {
    return false;
  } else if (!params) {
    return true;
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = typeof m[i] === 'string' ? decode(m[i]) : m[i];
    }
  }

  return true;
}

function resolveRecordPath(path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true);
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now ? window.performance : Date;

function genStateKey() {
  return Time.now().toFixed(3);
}

var _key = genStateKey();

function getStateKey() {
  return _key;
}

function setStateKey(key) {
  return _key = key;
}

/*  */

var positionStore = Object.create(null);

function setupScroll() {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  };
}

function handleScroll(router, to, from, isPop) {
  if (!router.app) {
    return;
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return;
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(router, to, from, isPop ? position : null);

    if (!shouldScroll) {
      return;
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition(shouldScroll, position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition() {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState(e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition() {
  var key = getStateKey();
  if (key) {
    return positionStore[key];
  }
}

function getElementPosition(el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  };
}

function isValidPosition(obj) {
  return isNumber(obj.x) || isNumber(obj.y);
}

function normalizePosition(obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  };
}

function normalizeOffset(obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  };
}

function isNumber(v) {
  return typeof v === 'number';
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition(shouldScroll, position) {
  var isObject = (typeof shouldScroll === "undefined" ? "undefined" : _typeof(shouldScroll)) === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
    ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
    : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset = shouldScroll.offset && _typeof(shouldScroll.offset) === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    // $flow-disable-line
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: position.x,
        top: position.y,
        // $flow-disable-line
        behavior: shouldScroll.behavior
      });
    } else {
      window.scrollTo(position.x, position.y);
    }
  }
}

/*  */

var supportsPushState = inBrowser && function () {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
    return false;
  }

  return window.history && typeof window.history.pushState === 'function';
}();

function pushState(url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState(url) {
  pushState(url, true);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError(from, to) {
  return createRouterError(from, to, NavigationFailureType.redirected, "Redirected when going from \"" + from.fullPath + "\" to \"" + stringifyRoute(to) + "\" via a navigation guard.");
}

function createNavigationDuplicatedError(from, to) {
  var error = createRouterError(from, to, NavigationFailureType.duplicated, "Avoided redundant navigation to current location: \"" + from.fullPath + "\".");
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error;
}

function createNavigationCancelledError(from, to) {
  return createRouterError(from, to, NavigationFailureType.cancelled, "Navigation cancelled from \"" + from.fullPath + "\" to \"" + to.fullPath + "\" with a new navigation.");
}

function createNavigationAbortedError(from, to) {
  return createRouterError(from, to, NavigationFailureType.aborted, "Navigation aborted from \"" + from.fullPath + "\" to \"" + to.fullPath + "\" via a navigation guard.");
}

function createRouterError(from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error;
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute(to) {
  if (typeof to === 'string') {
    return to;
  }
  if ('path' in to) {
    return to.path;
  }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) {
      location[key] = to[key];
    }
  });
  return JSON.stringify(location, null, 2);
}

function isError(err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1;
}

function isNavigationFailure(err, errorType) {
  return isError(err) && err._isRouter && (errorType == null || err.type === errorType);
}

/*  */

function runQueue(queue, fn, cb) {
  var step = function step(index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents(matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function' ? resolvedDef : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason) ? reason : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) {
      next();
    }
  };
}

function flatMapComponents(matched, fn) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return fn(m.components[key], m.instances[key], m, key);
    });
  }));
}

function flatten(arr) {
  return Array.prototype.concat.apply([], arr);
}

var hasSymbol = typeof Symbol === 'function' && _typeof(Symbol.toStringTag) === 'symbol';

function isESModule(obj) {
  return obj.__esModule || hasSymbol && obj[Symbol.toStringTag] === 'Module';
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once(fn) {
  var called = false;
  return function () {
    var args = [],
        len = arguments.length;
    while (len--) {
      args[len] = arguments[len];
    }if (called) {
      return;
    }
    called = true;
    return fn.apply(this, args);
  };
}

/*  */

var History = function History(router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen(cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady(cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError(errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo(location, onComplete, onAbort) {
  var this$1$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e;
  }
  var prev = this.current;
  this.confirmTransition(route, function () {
    this$1$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1$1.ensureURL();
    this$1$1.router.afterHooks.forEach(function (hook) {
      hook && hook(route, prev);
    });

    // fire ready cbs once
    if (!this$1$1.ready) {
      this$1$1.ready = true;
      this$1$1.readyCbs.forEach(function (cb) {
        cb(route);
      });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1$1.ready) {
      // Initial redirection should not mark the history as ready yet
      // because it's triggered by the redirection instead
      // https://github.com/vuejs/vue-router/issues/3225
      // https://github.com/vuejs/vue-router/issues/3331
      if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
        this$1$1.ready = true;
        this$1$1.readyErrorCbs.forEach(function (cb) {
          cb(err);
        });
      }
    }
  });
};

History.prototype.confirmTransition = function confirmTransition(route, onComplete, onAbort) {
  var this$1$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function abort(err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1$1.errorCbs.length) {
        this$1$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        if (false) {
          warn(false, 'uncaught error during route navigation:');
        }
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (isSameRoute(route, current) &&
  // in the case the route map has been dynamically appended to
  lastRouteIndex === lastCurrentIndex && route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]) {
    this.ensureURL();
    if (route.hash) {
      handleScroll(this.router, current, route, false);
    }
    return abort(createNavigationDuplicatedError(current, route));
  }

  var ref = resolveQueue(this.current.matched, route.matched);
  var updated = ref.updated;
  var deactivated = ref.deactivated;
  var activated = ref.activated;

  var queue = [].concat(
  // in-component leave guards
  extractLeaveGuards(deactivated),
  // global before hooks
  this.router.beforeHooks,
  // in-component update hooks
  extractUpdateHooks(updated),
  // in-config enter guards
  activated.map(function (m) {
    return m.beforeEnter;
  }),
  // async components
  resolveAsyncComponents(activated));

  var iterator = function iterator(hook, next) {
    if (this$1$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route));
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1$1.ensureURL(true);
          abort(to);
        } else if (typeof to === 'string' || (typeof to === "undefined" ? "undefined" : _typeof(to)) === 'object' && (typeof to.path === 'string' || typeof to.name === 'string')) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if ((typeof to === "undefined" ? "undefined" : _typeof(to)) === 'object' && to.replace) {
            this$1$1.replace(to);
          } else {
            this$1$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated);
    var queue = enterGuards.concat(this$1$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route));
      }
      this$1$1.pending = null;
      onComplete(route);
      if (this$1$1.router.app) {
        this$1$1.router.app.$nextTick(function () {
          handleRouteEntered(route);
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute(route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners() {
  // Default implementation is empty
};

History.prototype.teardown = function teardown() {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase(base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = baseEl && baseEl.getAttribute('href') || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '');
}

function resolveQueue(current, next) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break;
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  };
}

function extractGuards(records, name, bind, reverse) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard) ? guard.map(function (guard) {
        return bind(guard, instance, match, key);
      }) : bind(guard, instance, match, key);
    }
  });
  return flatten(reverse ? guards.reverse() : guards);
}

function extractGuard(def, key) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key];
}

function extractLeaveGuards(deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true);
}

function extractUpdateHooks(updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard);
}

function bindGuard(guard, instance) {
  if (instance) {
    return function boundRouteGuard() {
      return guard.apply(instance, arguments);
    };
  }
}

function extractEnterGuards(activated) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key);
  });
}

function bindEnterGuard(guard, match, key) {
  return function routeEnterGuard(to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        if (!match.enteredCbs[key]) {
          match.enteredCbs[key] = [];
        }
        match.enteredCbs[key].push(cb);
      }
      next(cb);
    });
  };
}

/*  */

var HTML5History = /*@__PURE__*/function (History) {
  function HTML5History(router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if (History) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create(History && History.prototype);
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners() {
    var this$1$1 = this;

    if (this.listeners.length > 0) {
      return;
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function handleRoutingEvent() {
      var current = this$1$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1$1.base);
      if (this$1$1.current === START && location === this$1$1._startLocation) {
        return;
      }

      this$1$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go(n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push(location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1$1.base + route.fullPath));
      handleScroll(this$1$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace(location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1$1.base + route.fullPath));
      handleScroll(this$1$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL(push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation() {
    return getLocation(this.base);
  };

  return HTML5History;
}(History);

function getLocation(base) {
  var path = window.location.pathname;
  var pathLowerCase = path.toLowerCase();
  var baseLowerCase = base.toLowerCase();
  // base="/a" shouldn't turn path="/app" into "/a/pp"
  // https://github.com/vuejs/vue-router/issues/3555
  // so we ensure the trailing slash in the base
  if (base && (pathLowerCase === baseLowerCase || pathLowerCase.indexOf(cleanPath(baseLowerCase + '/')) === 0)) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash;
}

/*  */

var HashHistory = /*@__PURE__*/function (History) {
  function HashHistory(router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return;
    }
    ensureSlash();
  }

  if (History) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create(History && History.prototype);
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners() {
    var this$1$1 = this;

    if (this.listeners.length > 0) {
      return;
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function handleRoutingEvent() {
      var current = this$1$1.current;
      if (!ensureSlash()) {
        return;
      }
      this$1$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(eventType, handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push(location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace(location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go(n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL(push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation() {
    return getHash();
  };

  return HashHistory;
}(History);

function checkFallback(base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true;
  }
}

function ensureSlash() {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true;
  }
  replaceHash('/' + path);
  return false;
}

function getHash() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) {
    return '';
  }

  href = href.slice(index + 1);

  return href;
}

function getUrl(path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return base + "#" + path;
}

function pushHash(path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash(path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/function (History) {
  function AbstractHistory(router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if (History) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create(History && History.prototype);
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push(location, onComplete, onAbort) {
    var this$1$1 = this;

    this.transitionTo(location, function (route) {
      this$1$1.stack = this$1$1.stack.slice(0, this$1$1.index + 1).concat(route);
      this$1$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace(location, onComplete, onAbort) {
    var this$1$1 = this;

    this.transitionTo(location, function (route) {
      this$1$1.stack = this$1$1.stack.slice(0, this$1$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go(n) {
    var this$1$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return;
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      var prev = this$1$1.current;
      this$1$1.index = targetIndex;
      this$1$1.updateRoute(route);
      this$1$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });
    }, function (err) {
      if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
        this$1$1.index = targetIndex;
      }
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation() {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/';
  };

  AbstractHistory.prototype.ensureURL = function ensureURL() {
    // noop
  };

  return AbstractHistory;
}(History);

/*  */

var VueRouter = function VueRouter(options) {
  if (options === void 0) options = {};

  if (false) {
    warn(this instanceof VueRouter, "Router must be called with the new operator.");
  }
  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break;
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break;
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break;
    default:
      if (false) {
        assert(false, "invalid mode: " + mode);
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match(raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom);
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current;
};

VueRouter.prototype.init = function init(app /* Vue component instance */) {
  var this$1$1 = this;

  "production" !== 'production' && assert(install.installed, "not installed. Make sure to call `Vue.use(VueRouter)` " + "before creating root instance.");

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1$1.apps.indexOf(app);
    if (index > -1) {
      this$1$1.apps.splice(index, 1);
    }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1$1.app === app) {
      this$1$1.app = this$1$1.apps[0] || null;
    }

    if (!this$1$1.app) {
      this$1$1.history.teardown();
    }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return;
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function handleInitialScroll(routeOrError) {
      var from = history.current;
      var expectScroll = this$1$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1$1, routeOrError, from, false);
      }
    };
    var setupListeners = function setupListeners(routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(history.getCurrentLocation(), setupListeners, setupListeners);
  }

  history.listen(function (route) {
    this$1$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach(fn) {
  return registerHook(this.beforeHooks, fn);
};

VueRouter.prototype.beforeResolve = function beforeResolve(fn) {
  return registerHook(this.resolveHooks, fn);
};

VueRouter.prototype.afterEach = function afterEach(fn) {
  return registerHook(this.afterHooks, fn);
};

VueRouter.prototype.onReady = function onReady(cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError(errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push(location, onComplete, onAbort) {
  var this$1$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1$1.history.push(location, resolve, reject);
    });
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace(location, onComplete, onAbort) {
  var this$1$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1$1.history.replace(location, resolve, reject);
    });
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go(n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back() {
  this.go(-1);
};

VueRouter.prototype.forward = function forward() {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents(to) {
  var route = to ? to.matched ? to : this.resolve(to).route : this.currentRoute;
  if (!route) {
    return [];
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key];
    });
  }));
};

VueRouter.prototype.resolve = function resolve(to, current, append) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  };
};

VueRouter.prototype.getRoutes = function getRoutes() {
  return this.matcher.getRoutes();
};

VueRouter.prototype.addRoute = function addRoute(parentOrRoute, route) {
  this.matcher.addRoute(parentOrRoute, route);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

VueRouter.prototype.addRoutes = function addRoutes(routes) {
  if (false) {
    warn(false, 'router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead.');
  }
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties(VueRouter.prototype, prototypeAccessors);

var VueRouter$1 = VueRouter;

function registerHook(list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) {
      list.splice(i, 1);
    }
  };
}

function createHref(base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path;
}

// We cannot remove this as it would be a breaking change
VueRouter.install = install;
VueRouter.version = '3.6.5';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;
VueRouter.START_LOCATION = START;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

var version = '3.6.5';

exports.NavigationFailureType = NavigationFailureType;
exports.RouterLink = Link;
exports.RouterView = View;
exports.START_LOCATION = START;
exports.default = VueRouter$1;
exports.isNavigationFailure = isNavigationFailure;
exports.version = version;

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue__ = __webpack_require__(230);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2007f9c6_hasScoped_true_buble_transforms_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeahead_vue__ = __webpack_require__(1020);
function injectStyle (ssrContext) {
  __webpack_require__(1011)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2007f9c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2007f9c6_hasScoped_true_buble_transforms_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeahead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1012);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1013)("47cefc62", content, true, {});

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".vbt-autcomplete-list[data-v-2007f9c6]{padding-top:5px;position:absolute;max-height:350px;overflow-y:auto;z-index:999}", ""]);

// exports


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(1014)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles(parentId, list) {
  var styles = [];
  var newStyles = {};
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = item[0];
    var css = item[1];
    var media = item[2];
    var sourceMap = item[3];
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    };
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] });
    } else {
      newStyles[id].parts.push(part);
    }
  }
  return styles;
};

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_71b14046_hasScoped_false_buble_transforms_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadList_vue__ = __webpack_require__(1018);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_71b14046_hasScoped_false_buble_transforms_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_8543de86_hasScoped_false_buble_transforms_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadListItem_vue__ = __webpack_require__(1017);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_8543de86_hasScoped_false_buble_transforms_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.textClasses,attrs:{"tabindex":"0","href":"#"},on:{"mouseover":function($event){_vm.active = true},"mouseout":function($event){_vm.active = false}}},[_vm._t("suggestion",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.htmlText)}})]},null,{ data: _vm.data, htmlText: _vm.htmlText })],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-group shadow"},_vm._l((_vm.matchedItems),function(item,id){return _c('vue-bootstrap-typeahead-list-item',{key:id,attrs:{"data":item.data,"html-text":_vm.highlight(item.text),"background-variant":_vm.backgroundVariant,"text-variant":_vm.textVariant},nativeOn:{"click":function($event){return _vm.handleHit(item, $event)}},scopedSlots:_vm._u([{key:"suggestion",fn:function(ref){
var data = ref.data;
var htmlText = ref.htmlText;
return (_vm.$scopedSlots.suggestion)?[_vm._t("suggestion",null,null,{ data: data, htmlText: htmlText })]:undefined}}],null,true)})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return (/** @class */function () {
            function class_1() {
                this.__entries__ = [];
            }
            Object.defineProperty(class_1.prototype, "size", {
                /**
                 * @returns {boolean}
                 */
                get: function get() {
                    return this.__entries__.length;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * @param {*} key
             * @returns {*}
             */
            class_1.prototype.get = function (key) {
                var index = getIndex(this.__entries__, key);
                var entry = this.__entries__[index];
                return entry && entry[1];
            };
            /**
             * @param {*} key
             * @param {*} value
             * @returns {void}
             */
            class_1.prototype.set = function (key, value) {
                var index = getIndex(this.__entries__, key);
                if (~index) {
                    this.__entries__[index][1] = value;
                } else {
                    this.__entries__.push([key, value]);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.delete = function (key) {
                var entries = this.__entries__;
                var index = getIndex(entries, key);
                if (~index) {
                    entries.splice(index, 1);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.has = function (key) {
                return !!~getIndex(this.__entries__, key);
            };
            /**
             * @returns {void}
             */
            class_1.prototype.clear = function () {
                this.__entries__.splice(0);
            };
            /**
             * @param {Function} callback
             * @param {*} [ctx=null]
             * @returns {void}
             */
            class_1.prototype.forEach = function (callback, ctx) {
                if (ctx === void 0) {
                    ctx = null;
                }
                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                    var entry = _a[_i];
                    callback.call(ctx, entry[1], entry[0]);
                }
            };
            return class_1;
        }()
    );
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) {
        return setTimeout(function () {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle(callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName,
            propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function defineConfigurable(target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = function getWindowOf(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth,
        clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) {
            return target instanceof getWindowOf(target).SVGGraphicsElement;
        };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) {
        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x,
        y = _a.y,
        width = _a.width,
        height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();

var ResizeObserverEntry = /** @class */function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}();

var ResizeObserverSPI = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
}();

exports.default = index;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.sizeClasses},[(_vm.$slots.prepend || _vm.prepend)?_c('div',{ref:"prependDiv",staticClass:"input-group-prepend"},[_vm._t("prepend",function(){return [_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(_vm.prepend))])]})],2):_vm._e(),_vm._v(" "),_c('input',{ref:"input",class:("form-control " + _vm.inputClass),attrs:{"type":"search","placeholder":_vm.placeholder,"aria-label":_vm.placeholder,"autocomplete":"off"},domProps:{"value":_vm.inputValue},on:{"focus":function($event){_vm.isFocused = true},"blur":_vm.handleBlur,"input":function($event){return _vm.handleInput($event.target.value)}}}),_vm._v(" "),(_vm.$slots.append || _vm.append)?_c('div',{staticClass:"input-group-append"},[_vm._t("append",function(){return [_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(_vm.append))])]})],2):_vm._e()]),_vm._v(" "),_c('vue-bootstrap-typeahead-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFocused && _vm.data.length > 0),expression:"isFocused && data.length > 0"}],ref:"list",staticClass:"vbt-autcomplete-list",attrs:{"query":_vm.inputValue,"data":_vm.formattedData,"background-variant":_vm.backgroundVariant,"text-variant":_vm.textVariant,"maxMatches":_vm.maxMatches,"minMatchingChars":_vm.minMatchingChars},on:{"hit":_vm.handleHit},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(slot,slotName){return {key:slotName,fn:function(ref){
var data = ref.data;
var htmlText = ref.htmlText;
return [_vm._t(slotName,null,null,{ data: data, htmlText: htmlText })]}}})],null,true)})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var placeholderChar = '_';
var strFunction = 'function';

var emptyArray$1 = [];
function convertMaskToPlaceholder() {
  var mask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyArray$1;
  var placeholderChar$1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : placeholderChar;

  if (!isArray(mask)) {
    throw new Error('Text-mask:convertMaskToPlaceholder; The mask property must be an array.');
  }

  if (mask.indexOf(placeholderChar$1) !== -1) {
    throw new Error('Placeholder character must not be used as part of the mask. Please specify a character ' + 'that is not present in your mask as your placeholder character.\n\n' + "The placeholder character that was received is: ".concat(JSON.stringify(placeholderChar$1), "\n\n") + "The mask that was received is: ".concat(JSON.stringify(mask)));
  }

  return mask.map(function (char) {
    return char instanceof RegExp ? placeholderChar$1 : char;
  }).join('');
}
function isArray(value) {
  return Array.isArray && Array.isArray(value) || value instanceof Array;
}
var strCaretTrap = '[]';
function processCaretTraps(mask) {
  var indexes = [];
  var indexOfCaretTrap;

  while (indexOfCaretTrap = mask.indexOf(strCaretTrap), indexOfCaretTrap !== -1) {
    indexes.push(indexOfCaretTrap);
    mask.splice(indexOfCaretTrap, 1);
  }

  return {
    maskWithoutCaretTraps: mask,
    indexes: indexes
  };
}

var emptyArray = [];
var emptyString = '';
function conformToMask() {
  var rawValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyString;
  var mask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyArray;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!isArray(mask)) {
    if (_typeof(mask) === strFunction) {
      mask = mask(rawValue, config);
      mask = processCaretTraps(mask).maskWithoutCaretTraps;
    } else {
      throw new Error('Text-mask:conformToMask; The mask property must be an array.');
    }
  }

  var _config$guide = config.guide,
      guide = _config$guide === void 0 ? true : _config$guide,
      _config$previousConfo = config.previousConformedValue,
      previousConformedValue = _config$previousConfo === void 0 ? emptyString : _config$previousConfo,
      _config$placeholderCh = config.placeholderChar,
      placeholderChar$1 = _config$placeholderCh === void 0 ? placeholderChar : _config$placeholderCh,
      _config$placeholder = config.placeholder,
      placeholder = _config$placeholder === void 0 ? convertMaskToPlaceholder(mask, placeholderChar$1) : _config$placeholder,
      currentCaretPosition = config.currentCaretPosition,
      keepCharPositions = config.keepCharPositions;
  var suppressGuide = guide === false && previousConformedValue !== undefined;
  var rawValueLength = rawValue.length;
  var previousConformedValueLength = previousConformedValue.length;
  var placeholderLength = placeholder.length;
  var maskLength = mask.length;
  var editDistance = rawValueLength - previousConformedValueLength;
  var isAddition = editDistance > 0;
  var indexOfFirstChange = currentCaretPosition + (isAddition ? -editDistance : 0);
  var indexOfLastChange = indexOfFirstChange + Math.abs(editDistance);

  if (keepCharPositions === true && !isAddition) {
    var compensatingPlaceholderChars = emptyString;

    for (var i = indexOfFirstChange; i < indexOfLastChange; i++) {
      if (placeholder[i] === placeholderChar$1) {
        compensatingPlaceholderChars += placeholderChar$1;
      }
    }

    rawValue = rawValue.slice(0, indexOfFirstChange) + compensatingPlaceholderChars + rawValue.slice(indexOfFirstChange, rawValueLength);
  }

  var rawValueArr = rawValue.split(emptyString).map(function (char, i) {
    return {
      char: char,
      isNew: i >= indexOfFirstChange && i < indexOfLastChange
    };
  });

  for (var _i = rawValueLength - 1; _i >= 0; _i--) {
    var char = rawValueArr[_i].char;

    if (char !== placeholderChar$1) {
      var shouldOffset = _i >= indexOfFirstChange && previousConformedValueLength === maskLength;

      if (char === placeholder[shouldOffset ? _i - editDistance : _i]) {
        rawValueArr.splice(_i, 1);
      }
    }
  }

  var conformedValue = emptyString;
  var someCharsRejected = false;

  placeholderLoop: for (var _i2 = 0; _i2 < placeholderLength; _i2++) {
    var charInPlaceholder = placeholder[_i2];

    if (charInPlaceholder === placeholderChar$1) {
      if (rawValueArr.length > 0) {
        while (rawValueArr.length > 0) {
          var _rawValueArr$shift = rawValueArr.shift(),
              rawValueChar = _rawValueArr$shift.char,
              isNew = _rawValueArr$shift.isNew;

          if (rawValueChar === placeholderChar$1 && suppressGuide !== true) {
            conformedValue += placeholderChar$1;
            continue placeholderLoop;
          } else if (mask[_i2].test(rawValueChar)) {
            if (keepCharPositions !== true || isNew === false || previousConformedValue === emptyString || guide === false || !isAddition) {
              conformedValue += rawValueChar;
            } else {
              var rawValueArrLength = rawValueArr.length;
              var indexOfNextAvailablePlaceholderChar = null;

              for (var _i3 = 0; _i3 < rawValueArrLength; _i3++) {
                var charData = rawValueArr[_i3];

                if (charData.char !== placeholderChar$1 && charData.isNew === false) {
                  break;
                }

                if (charData.char === placeholderChar$1) {
                  indexOfNextAvailablePlaceholderChar = _i3;
                  break;
                }
              }

              if (indexOfNextAvailablePlaceholderChar !== null) {
                conformedValue += rawValueChar;
                rawValueArr.splice(indexOfNextAvailablePlaceholderChar, 1);
              } else {
                _i2--;
              }
            }

            continue placeholderLoop;
          } else {
            someCharsRejected = true;
          }
        }
      }

      if (suppressGuide === false) {
        conformedValue += placeholder.substr(_i2, placeholderLength);
      }

      break;
    } else {
      conformedValue += charInPlaceholder;
    }
  }

  if (suppressGuide && isAddition === false) {
    var indexOfLastFilledPlaceholderChar = null;

    for (var _i4 = 0; _i4 < conformedValue.length; _i4++) {
      if (placeholder[_i4] === placeholderChar$1) {
        indexOfLastFilledPlaceholderChar = _i4;
      }
    }

    if (indexOfLastFilledPlaceholderChar !== null) {
      conformedValue = conformedValue.substr(0, indexOfLastFilledPlaceholderChar + 1);
    } else {
      conformedValue = emptyString;
    }
  }

  return {
    conformedValue: conformedValue,
    meta: {
      someCharsRejected: someCharsRejected
    }
  };
}

var NEXT_CHAR_OPTIONAL = {
  __nextCharOptional__: true
};
var defaultMaskReplacers = {
  '#': /\d/,
  A: /[a-z]/i,
  N: /[a-z0-9]/i,
  '?': NEXT_CHAR_OPTIONAL,
  X: /./
};

var stringToRegexp = function stringToRegexp(str) {
  var lastSlash = str.lastIndexOf('/');
  return new RegExp(str.slice(1, lastSlash), str.slice(lastSlash + 1));
};

var makeRegexpOptional = function makeRegexpOptional(charRegexp) {
  return stringToRegexp(charRegexp.toString().replace(/.(\/)[gmiyus]{0,6}$/, function (match) {
    return match.replace('/', '?/');
  }));
};

var escapeIfNeeded = function escapeIfNeeded(char) {
  return '[\\^$.|?*+()'.indexOf(char) > -1 ? "\\".concat(char) : char;
};

var charRegexp = function charRegexp(char) {
  return new RegExp("/[".concat(escapeIfNeeded(char), "]/"));
};

var isRegexp$1 = function isRegexp(entity) {
  return entity instanceof RegExp;
};

var castToRegexp = function castToRegexp(char) {
  return isRegexp$1(char) ? char : charRegexp(char);
};

function maskToRegExpMask(mask) {
  var maskReplacers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMaskReplacers;
  return mask.map(function (char, index, array) {
    var maskChar = maskReplacers[char] || char;
    var previousChar = array[index - 1];
    var previousMaskChar = maskReplacers[previousChar] || previousChar;

    if (maskChar === NEXT_CHAR_OPTIONAL) {
      return null;
    }

    if (previousMaskChar === NEXT_CHAR_OPTIONAL) {
      return makeRegexpOptional(castToRegexp(maskChar));
    }

    return maskChar;
  }).filter(Boolean);
}

function stringMaskToRegExpMask(stringMask) {
  var maskReplacers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMaskReplacers;
  return maskToRegExpMask(stringMask.split(''), maskReplacers);
}
function arrayMaskToRegExpMask(arrayMask) {
  var maskReplacers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMaskReplacers;
  var flattenedMask = arrayMask.map(function (part) {
    if (part instanceof RegExp) {
      return part;
    }

    if (typeof part === 'string') {
      return part.split('');
    }

    return null;
  }).filter(Boolean).reduce(function (mask, part) {
    return mask.concat(part);
  }, []);
  return maskToRegExpMask(flattenedMask, maskReplacers);
}

var trigger = function trigger(el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};
var queryInputElementInside = function queryInputElementInside(el) {
  return el instanceof HTMLInputElement ? el : el.querySelector('input') || el;
};
var isFunction = function isFunction(val) {
  return typeof val === 'function';
};
var isString = function isString(val) {
  return typeof val === 'string';
};
var isRegexp = function isRegexp(val) {
  return val instanceof RegExp;
};

function parseMask(inputMask, maskReplacers) {
  if (Array.isArray(inputMask)) {
    return arrayMaskToRegExpMask(inputMask, maskReplacers);
  }

  if (isFunction(inputMask)) {
    return inputMask;
  }

  if (isString(inputMask) && inputMask.length > 0) {
    return stringMaskToRegExpMask(inputMask, maskReplacers);
  }

  return inputMask;
}

function createOptions() {
  var elementOptions = new Map();
  var defaultOptions = {
    previousValue: '',
    mask: []
  };

  function get(el) {
    return elementOptions.get(el) || _objectSpread2({}, defaultOptions);
  }

  function partiallyUpdate(el, newOptions) {
    elementOptions.set(el, _objectSpread2(_objectSpread2({}, get(el)), newOptions));
  }

  function remove(el) {
    elementOptions.delete(el);
  }

  return {
    partiallyUpdate: partiallyUpdate,
    remove: remove,
    get: get
  };
}

function extendMaskReplacers(maskReplacers) {
  var baseMaskReplacers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMaskReplacers;

  if (maskReplacers === null || Array.isArray(maskReplacers) || _typeof(maskReplacers) !== 'object') {
    return baseMaskReplacers;
  }

  return Object.keys(maskReplacers).reduce(function (extendedMaskReplacers, key) {
    var value = maskReplacers[key];

    if (value !== null && !(value instanceof RegExp)) {
      return extendedMaskReplacers;
    }

    return _objectSpread2(_objectSpread2({}, extendedMaskReplacers), {}, _defineProperty({}, key, value));
  }, baseMaskReplacers);
}

var options = createOptions();

function triggerInputUpdate(el) {
  trigger(el, 'input');
}

function updateValue(el) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var value = el.value;

  var _options$get = options.get(el),
      previousValue = _options$get.previousValue,
      mask = _options$get.mask;

  var isValueChanged = value !== previousValue;
  var isLengthIncreased = value.length > previousValue.length;
  var isUpdateNeeded = value && isValueChanged && isLengthIncreased;

  if ((force || isUpdateNeeded) && mask) {
    var _conformToMask = conformToMask(value, mask, {
      guide: false
    }),
        conformedValue = _conformToMask.conformedValue;

    el.value = conformedValue;
    triggerInputUpdate(el);
  }

  options.partiallyUpdate(el, {
    previousValue: value
  });
}

function updateMask(el, inputMask, maskReplacers) {
  var mask = parseMask(inputMask, maskReplacers);
  options.partiallyUpdate(el, {
    mask: mask
  });
}

function maskToString(mask) {
  var maskArray = Array.isArray(mask) ? mask : [mask];
  var filteredMaskArray = maskArray.filter(function (part) {
    return isString(part) || isRegexp(part);
  });
  return filteredMaskArray.toString();
}

function createDirective() {
  var directiveOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var instanceMaskReplacers = extendMaskReplacers(directiveOptions && directiveOptions.placeholders);
  return {
    bind: function bind(el, _ref) {
      var value = _ref.value;
      el = queryInputElementInside(el);
      updateMask(el, value, instanceMaskReplacers);
      updateValue(el);
    },
    componentUpdated: function componentUpdated(el, _ref2) {
      var value = _ref2.value,
          oldValue = _ref2.oldValue;
      el = queryInputElementInside(el);
      var isMaskChanged = isFunction(value) || maskToString(oldValue) !== maskToString(value);

      if (isMaskChanged) {
        updateMask(el, value, instanceMaskReplacers);
      }

      updateValue(el, isMaskChanged);
    },
    unbind: function unbind(el) {
      el = queryInputElementInside(el);
      options.remove(el);
    }
  };
}
var directive = createDirective();

function createFilter() {
  var filterOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var instanceMaskReplacers = extendMaskReplacers(filterOptions && filterOptions.placeholders);
  return function (value, inputMask) {
    if (!isString(value) && !Number.isFinite(value)) return value;
    var mask = parseMask(inputMask, instanceMaskReplacers);

    var _conformToMask = conformToMask("".concat(value), mask, {
      guide: false
    }),
        conformedValue = _conformToMask.conformedValue;

    return conformedValue;
  };
}
var filter = createFilter();

var plugin = function plugin(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Vue.directive('mask', createDirective(options));
  Vue.filter('VMask', createFilter(options));
};

exports.VueMaskDirective = directive;
exports.VueMaskFilter = filter;
exports.VueMaskPlugin = plugin;
exports.default = plugin;

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(233);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_842aee52_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1080);
function injectStyle (ssrContext) {
  __webpack_require__(1023)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_842aee52_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1024);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("58b53be7", content, true, {});

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".height-80{height:80vh}.height-90{height:90vh}.height-70{height:70vh}.height-60{height:60vh}.def-title{color:#2b6292;font-weight:700;font-size:18px}.def-title,.def-title2{text-transform:uppercase}.def-title2{color:#07a7cf;font-size:14px}.btn{border:1px solid transparent;padding:.375rem .75rem;line-height:2;font-size:13px}.btn-outline-secondary{background-color:transparent;border-color:#5f5f5f3b}.btn-outline-secondary,.btn-video{color:#174b79;background-image:none}.btn-video{background-color:#ffc107;border-color:#ffc107}.btn.nb-btn-video{width:36px;height:36px;padding:0;border-radius:8px;display:inline-flex;align-items:center;justify-content:center;background:#fef2f2;color:#ef4444;border:1px solid #fecaca;box-shadow:0 2px 4px rgba(239,68,68,.12);cursor:pointer;transition:all .2s cubic-bezier(.4,0,.2,1)}.btn.nb-btn-video .fa-youtube-play{color:#ef4444;font-size:20px;line-height:1;transition:transform .2s ease,color .2s ease}.btn.nb-btn-video:hover{background:#ef4444;border-color:#dc2626;color:#fff;box-shadow:0 4px 10px rgba(239,68,68,.35);transform:translateY(-2px) scale(1.05)}.btn.nb-btn-video:hover .fa-youtube-play{color:#fff;transform:scale(1.1)}.btn.nb-btn-video:focus{outline:none;box-shadow:0 0 0 3px rgba(239,68,68,.25)}.btn-green{background-color:green;border-color:green}.btn-blue,.btn-green{color:#fff;background-image:none}.btn-blue{background-color:#174b79;border-color:#174b79}.btn-red{background-color:red;border-color:red}.btn-orange,.btn-red{color:#fff;background-image:none}.btn-orange{background-color:orange;border-color:orange}.nb-btdef{color:#fff;background-color:#174b79;border-color:#aeafb1}.nb-btdef.active,.nb-btdef:active,.nb-btdef:focus,.nb-btdef:hover,.open .dropdown-toggle.nb-btdef{color:#fff;background-color:#c59f2f;border-color:#dbb233}.nb-btdef.active,.nb-btdef:active,.open .dropdown-toggle.nb-btdef{background-image:none}.nb-btdef.disabled,.nb-btdef.disabled.active,.nb-btdef.disabled:active,.nb-btdef.disabled:focus,.nb-btdef.disabled:hover,.nb-btdef[disabled],.nb-btdef[disabled].active,.nb-btdef[disabled]:active,.nb-btdef[disabled]:focus,.nb-btdef[disabled]:hover,fieldset[disabled] .nb-btdef,fieldset[disabled] .nb-btdef.active,fieldset[disabled] .nb-btdef:active,fieldset[disabled] .nb-btdef:focus,fieldset[disabled] .nb-btdef:hover{background-color:#dfba49;border-color:#dbb233}.nb-btdef .badge{color:#dfba49;background-color:#fff}.lbl{display:inline-block;max-width:100%;margin-bottom:5px;margin-right:5px;color:#636262;font-size:13px;text-overflow:ellipsis;white-space:nowrap}.lbl2{color:gray}.lbl2,.lbl-title-produto{display:inline-block;max-width:100%;margin-bottom:5px;margin-right:5px;font-weight:700}.lbl-title-produto{font-size:16px;color:#4993d2}.lbl-list-produto{color:#4993d2}.lbl-list-produto,.lbl-title-orcamento{display:inline-block;max-width:100%;font-weight:700}.lbl-title-orcamento{margin-bottom:5px;margin-right:5px;font-size:12px;color:#b8b50b}.lbl-total-documento{font-size:24px;font-weight:800;color:#636363}.lbl-edit,.lbl-total-documento{display:inline-block;max-width:100%;margin-bottom:5px;margin-right:5px}.lbl-edit{text-overflow:ellipsis;overflow:hidden;vertical-align:middle;white-space:nowrap;font-size:13px;color:#808080bb;font-weight:500}.lbl-edit-sm{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-size:12px;color:hsla(0,0%,50%,.733)}.lbl-edit-sm,.lbl-link{display:inline-block;max-width:100%;margin-bottom:5px;margin-right:5px}.lbl-link{font-weight:700;font-size:16px;color:#4eafc7;cursor:pointer}.lbl-title{display:inline-block;max-width:100%;font-size:20px;text-transform:uppercase;color:#565656;font-weight:400;padding-top:10px;padding-bottom:10px;margin:0 0 -1px}.lbl-list{margin-bottom:5px;max-width:100%;margin-right:5px;font-size:13px;color:#808080bb;white-space:nowrap;text-overflow:ellipsis}.lbl-list-detalhe{font-size:12px;font-weight:600;line-height:20px;margin-left:0;margin-right:10px;color:#424242;white-space:nowrap}.data-list{font-size:14px}.data-list,.data-list-sm{display:inline-block;max-width:100%;margin-bottom:5px;margin-right:5px;color:#383838}.data-list-sm{font-size:12px;white-space:nowrap;text-overflow:ellipsis}.list-icon{font-size:24px;align-items:center;justify-content:center;background-color:#f5f5f5;border:1px solid #e0e0e0;box-sizing:border-box;height:38px;width:42px;flex-shrink:0}.lbl-tot{width:100%;white-space:nowrap;display:inline-block;max-width:100%;margin-bottom:5px;margin-right:5px;color:gray;font-size:14px}.lbl-center{text-align:center}.lbl-yellow{color:#ff0}.lbl-green{color:green}.lbl-blue{color:blue}.lbl-orange{color:#daa520}.lbl-gray{color:gray}.lbl-red{color:red}.decrase-lbl-title{font-size:13px}.decrase-lbl{font-size:10px}.error{color:red}.border-yellow{border-color:#ff0}.border-green{border-color:green}.border-black{border-color:#000}.border-gray{border-color:gray}.border-red{border-color:red}.border-blue{border-color:blue}.border-orange{border-color:#daa520}.badge{display:inline-block;padding:.5em;font-size:13px;font-weight:600;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:1.3rem}.badge-green{color:#fff;background-color:#80b852}.badge-green-color{color:#627d4c}.badge-red{color:#fff;background-color:#a72828e1}.badge-red-o{color:#a72828e1;border:2px solid #a72828e1}.badge-orange{color:#fff;background-color:#daa520}.badge-yellow{color:gray;background-color:#ffe871}.badge-blue{color:#fff;background-color:#006dfc8a}.badge-gray{color:#fff;background-color:gray}.badge-silver{color:#fff;background-color:silver}.badge-yellow-outline{color:#07a7cf;border:2px solid #07a7cf}.badge-dash-mes{color:#07a7cf;border:1px solid #07a7cf;font-size:12px;margin-top:5px}.badge-green-outline{color:#80b852;border:2px solid #80b852}.badge-incluir{display:inline-block;padding:.2em .3em;font-size:12px;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.7rem}.mark-gray{background-color:gray}.mark-gray,.mark-green{position:absolute;width:3px;height:100%;float:left;z-index:2}.mark-green{background-color:#7cfc00}.mark-red{background-color:red}.mark-red,.mark-yellow{position:absolute;width:3px;height:100%;float:left;z-index:2}.mark-yellow{background-color:#ff0}.mark-orange{position:absolute;width:3px;height:100%;float:left;background-color:orange;z-index:2}.mainbox{overflow:hidden}.mainbox,.mainbox-select{position:relative;width:100%;margin:5px 0;border-bottom:1px solid #eee}.mainbox-select{display:flex}.nb-modal-scrollable-container .mainbox{overflow:visible!important;border-bottom:none}.box{position:relative;width:100%;float:right;padding:5px;background-color:#fff}.nb-modal-mask{background-color:#00000080;display:table}.nb-modal-mask,.nb-modal-varejo{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;transition:opacity .3s ease}.nb-modal-varejo{bottom:0;right:0;overflow:auto;background-color:#ffffffff;display:inherit;padding:0}.nb-modal{max-width:95%;max-height:95%;position:absolute;top:2%;left:50%;z-index:2;opacity:1;border:6px solid #000;background:#fff;-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out;-webkit-transform:translate(-50%);-ms-transform:translate(-50%);transform:translate(-50%);-webkit-transition-delay:.5s;-ms-transition-delay:.5s;transition-delay:.5s}.nb-modal-90{min-width:95%;min-height:95%}.nb-modal-70{min-width:70%;min-height:70%}.nb-modal-80{min-width:80%;min-height:80%}.nb-modal-50{min-width:50%;max-height:50%}.nb-modal-60{min-width:60%;min-height:60%}.nb-modal-body{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;padding:1rem;display:block;position:absolute;width:100%;height:75%;overflow:auto;padding-bottom:80px}.nb-modal-footer{display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end;position:absolute;bottom:0;left:0;width:100%;background:#f1f4f9;border-top:1px solid #c9d3dd;padding:20px 0;max-height:80px}.nb-modal-header{display:flex;-webkit-box-align:start;align-items:flex-start;-webkit-box-pack:justify;justify-content:space-between;padding:10px 0;border-bottom:1px solid #e9ecef}.nb-modal-scrollable{position:fixed;z-index:9998;top:0;bottom:0;left:0;right:0;width:100%;height:100%;overflow:auto;background-color:rgba(15,43,73,.25);display:inherit;transition:opacity .3s ease}.nb-modal-scrollable-container{position:absolute;top:2%;opacity:1;border:6px solid #000}.nb-modal-full-height,.nb-modal-scrollable-container{left:50%;z-index:2;background:#fff;-webkit-transform:translate(-50%);-ms-transform:translate(-50%);transform:translate(-50%);-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out;-webkit-transition-delay:.5s;-ms-transition-delay:.5s;transition-delay:.5s}.nb-modal-full-height{position:relative;padding:10px;max-height:100%;max-width:100%;z-index:1;box-shadow:0 0 2px 0 #0000003d,0 8px 10px 1px #0000000d,0 3px 14px 2px #0000000f,0 5px 5px -3px rgba(0,0,0,.1)}.nb-modal-scrollable-body{padding-top:15px}.nb-modal-scrollable-footer{display:flex;justify-content:flex-end;position:relative;width:100%;border-top:1px solid #c9d3dd;padding:20px 0;max-height:80px}.loading{z-index:9999;height:2em;width:2em;overflow:show;margin:auto;bottom:0;right:0}.loading,.loading:before{position:fixed;top:0;left:0}.loading:before{content:\"\";display:block;width:100%;height:100%;background-color:hsla(0,47%,94%,.3)}.loading:not(:required){font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.loading:not(:required):after{content:\"\";display:block;font-size:10px;width:1em;height:1em;margin-top:-.5em;-webkit-animation:spinner 1.5s infinite linear;-moz-animation:spinner 1.5s infinite linear;-ms-animation:spinner 1.5s infinite linear;-o-animation:spinner 1.5s infinite linear;animation:spinner 1.5s infinite linear;border-radius:.5em;-webkit-box-shadow:rgba(0,0,0,.75) 1.5em 0 0 0,rgba(0,0,0,.75) 1.1em 1.1em 0 0,rgba(0,0,0,.75) 0 1.5em 0 0,rgba(0,0,0,.75) -1.1em 1.1em 0 0,rgba(0,0,0,.5) -1.5em 0 0 0,rgba(0,0,0,.5) -1.1em -1.1em 0 0,rgba(0,0,0,.75) 0 -1.5em 0 0,rgba(0,0,0,.75) 1.1em -1.1em 0 0;box-shadow:1.5em 0 0 0 rgba(0,0,0,.75),1.1em 1.1em 0 0 rgba(0,0,0,.75),0 1.5em 0 0 rgba(0,0,0,.75),-1.1em 1.1em 0 0 rgba(0,0,0,.75),-1.5em 0 0 0 rgba(0,0,0,.75),-1.1em -1.1em 0 0 rgba(0,0,0,.75),0 -1.5em 0 0 rgba(0,0,0,.75),1.1em -1.1em 0 0 rgba(0,0,0,.75)}@-webkit-keyframes spinner{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);-moz-transform:rotate(1turn);-ms-transform:rotate(1turn);-o-transform:rotate(1turn);transform:rotate(1turn)}}@-moz-keyframes spinner{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);-moz-transform:rotate(1turn);-ms-transform:rotate(1turn);-o-transform:rotate(1turn);transform:rotate(1turn)}}@-o-keyframes spinner{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);-moz-transform:rotate(1turn);-ms-transform:rotate(1turn);-o-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);-moz-transform:rotate(1turn);-ms-transform:rotate(1turn);-o-transform:rotate(1turn);transform:rotate(1turn)}}.jumbotron{background-color:transparent!important}.nb-top-message{text-align:center;top:0;left:0;position:fixed;width:100%;z-index:10000;max-width:100%;font-size:14px;font-weight:500;padding:20px;background:#ffd600}.nb-trial{font-weight:600;padding:5px;background:#fffa70;color:gray}.nb-renova,.nb-trial{text-align:center;position:relative;width:100%;font-size:14px}.nb-renova{padding:10px;color:#0052a5;border-color:#b7cdfd #b7cdfd #b7cdfd #2687e9;background:#dbe6fe}.nb-homolog{text-align:center;position:relative;width:100%;font-size:14px;font-weight:600;padding:10px;background:#f86161;color:#fff;z-index:10}.fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}.nb-margin-bottom{margin-bottom:20px!important}.nb-margin-top,.nb-margin-topbottom{margin-top:20px!important}.nb-margin-topbottom{margin-bottom:20px!important}.nb-margin-right{margin-right:5px}.nb-fixed-footer-toolbar{position:fixed;bottom:0;left:0;width:100%;background:#f1f4f9;border-top:1px solid #c9d3dd;padding:20px 0;max-height:80px;z-index:203}.nb-shortcut{border:1px solid transparent;border-radius:.7rem;color:#174b79;border-color:#5f5f5f3b}.nb-shortcut,.nb-shortcut-danger{font-size:14px;padding:.375rem .75rem}.nb-shortcut-danger{border:1px solid transparent;border-radius:.7rem;color:#bc1132;border-color:#f9b3c1;background-color:F9B3C1}.nb-shortcut-img{font-size:1rem}.nav-tabs{background-color:#fff}.nav-tabs .nav-link{align-items:center;justify-content:center;min-width:100px;color:gray;font-size:14px;border-radius:0}.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active{background-color:#fff;border:none;border-bottom:3px solid #1161bc;font-weight:600;color:#2b6292;font-size:14px}.nav-tabs .nav-link:hover{background-color:#eee}.nav-tabs-mobile .nav-link-mobile{align-items:center;justify-content:center;min-width:100px;color:gray;font-size:14px;border-radius:0}.nav-tabs-mobile .nav-item.show .nav-link-mobile,.nav-tabs-mobile .nav-link-mobile.active{background-color:#fff;border:none;border-bottom:3px solid #1161bc;font-weight:600;color:#2b6292;font-size:14px}.nav-tabs-mobile .nav-link-mobile:hover{background-color:#eee}.nb-dash-card{display:flex;flex-direction:column;border:1px solid #e2e8f0;border-radius:10px;background-color:#fff;box-shadow:0 1px 3px 0 rgba(0,0,0,.05);height:100%;position:relative;margin:0;overflow:hidden;transition:transform .2s ease,box-shadow .2s ease}.nb-dash-card:hover{transform:translateY(-2px);box-shadow:0 4px 10px -1px rgba(0,0,0,.08)}.nb-dash-detalhes{display:flex;align-items:center!important;height:40px;border-top:1px solid #f1f5f9;background:#f8fafc;padding:0 14px}@keyframes spinner-border{to{transform:rotate(1turn)}}.spinner-border{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:spinner-border .75s linear infinite;animation:spinner-border .75s linear infinite}.spinner-border-sm{height:1rem;border-width:.2em}.botao-novo-pedido{top:75px;left:36px;position:fixed;z-index:30}.botao-novo-pedido a,.botao-novo-pedido a:hover{background-color:#fff;border-radius:5px;box-shadow:0 0 0 rgba(0,0,0,.5),0 2px 10px rgba(0,0,0,.2);color:#00cc62;cursor:pointer;display:flex;position:relative;height:52px;width:52px;justify-content:center;align-items:center}.default-container{background:#fff;border:1px solid #c9d3dd;padding:15px;box-shadow:0 0 10px 0 rgba(201,211,221,.4)}.select2-container--open{z-index:999999!important;width:100%!important}.typeahead{z-index:1051;margin-top:2px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;box-shadow:0 5px 10px rgba(0,0,0,.2);color:gray}.typeahead li{border-bottom:1px solid #efefef;padding:10px}.typeahead li:hover{cursor:pointer}.typeahead .active,.typeahead li:hover{color:#fff;background-color:#267da5}.typeahead *,.typeahead-data{white-space:normal!important}.typeahead-title{display:inline-block;max-width:100%;margin-bottom:5px;margin-right:5px;font-size:18px}.typeahead-dropdown{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);*border-right-width:2px;*border-bottom-width:2px;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);-moz-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2);-webkit-background-clip:padding-box;-moz-background-clip:padding;background-clip:padding-box}.counter{background-color:#fc0000bf;color:#fff;font-size:10px;border-radius:50%;line-height:16px;width:16px;height:16px;text-align:center;display:inline-block;position:absolute}.no-scroll{overflow:hidden}body{-webkit-font-smoothing:antialiased;font-style:normal;font-size:14px;margin:0;font-family:Open Sans,-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;color:#333;background-color:#f5f5f5}.nb-alert{border-radius:0 3px 3px 0;border:1px solid;border-left:3px solid;padding:20px;position:relative}.nb-alert.info{color:#0052a5;border-color:#b7cdfd #b7cdfd #b7cdfd #2687e9;background:#dbe6fe}.nb-alert.warning{color:#b98e00;border-color:#ffdf79 #ffdf79 #ffdf79 #ffc200;background:#fff4ce}.nb-alert.error{color:red a2!important;border-top:1px solid #ff0000a2;border-bottom:1px solid #ff0000a2;border-left:3px solid #fd0a3b;border-right:1px solid #ff0000a2;background:#ff000011 url(/versions/current/assets/images/icones/icon-error.png) no-repeat 11px 10px!important}.nb-alert.nb-alert-title{display:block;font-size:14px;font-weight:700}ul.timeline{list-style-type:none;position:relative}ul.timeline:before{content:\" \";background:#d4d9df;display:inline-block;position:absolute;left:29px;width:2px;height:100%;z-index:400}ul.timeline>li{margin:20px 0;padding-left:20px}ul.timeline>li:before{content:\" \";background:#fff;display:inline-block;position:absolute;border-radius:50%;border:3px solid #22c0e8;left:20px;width:20px;height:20px;z-index:400}.email-address{display:inline-block;max-width:100%;margin-bottom:5px;margin-right:5px;color:#808080bb;font-size:14px}.pipeline .etapa{box-sizing:border-box;background-image:none;float:left;color:#7a7a7f;margin:0;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding-left:0;margin-bottom:0;height:auto}.pipeline .header{display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;height:60px;position:relative;color:#7a7a7f;width:100%;padding:5px 5px 5px 10px;background-color:#ebebeb;clip-path:polygon(calc(100% - 6px) 0,100% 50%,calc(100% - 6px) 100%,2px 100%,8px 50%,2px 0)}.pipeline-6col .etapa{width:16.66%}.pipeline-5col .etapa{width:20%}.pipeline-4col .etapa{width:25%}.pipeline-3col .etapa{width:33.33%}.pipeline-10col .etapa{width:10%}.pipeline strong{font-size:20px;font-weight:700}.pipeline .list-group{padding-top:5px;padding-bottom:5px;margin-top:5px;margin-bottom:20px;min-height:500px;display:flex;-ms-flex-direction:column;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding-left:0;margin-bottom:0;height:100%}.pipeline .list-group:hover{background-color:#ebebeb}.card-perdido{background-color:#f3f1f1}.card-negocio{position:relative;max-width:100%;border:1px solid #c9d3dd;background-color:#fff;padding:10px;margin-left:6px;margin-right:6px;margin-bottom:6px}.card-negocio .title:hover{cursor:pointer}.card-title{font-weight:600;color:87;cursor:pointer;color:#020202bb}.card-text,.card-title{font-size:13px;overflow:hidden;text-overflow:ellipsis}.card-text{white-space:nowrap}.card-text,.card-value{display:inline-block;max-width:100%;margin-right:5px;color:#969696}.card-value{font-size:13px;overflow:hidden}.title-etapa{font-weight:700;font-size:16px;color:#00000087}.icon{display:inline-block;width:25px;font-size:18px;text-align:center}.icon-outros{color:#dedede}.icon-email{color:#04da44}.icon-atrasado{color:red}.icon-sem-agenda{color:#ffe871;cursor:pointer}.icon-agenda{color:#627d4c;cursor:pointer}.card-negocio .estagnado{font-size:12px;padding:0 5px;margin-right:5px;position:relative;background:#ffe871}.card-negocio .tag{position:absolute;font-size:12px;padding:0 5px;right:-15px;width:15px;height:20px}.tag.atrasado{background:red}.perdido{font-size:12px;padding:0 5px;margin-right:5px;position:relative;background:#c4004b;color:#fff}.ganho{border-radius:4px;margin-left:3px;padding:3px;background:#0c852a;color:#fff;font-size:10px}.lbl-negocio{font-size:28px}.lbl-deal-subtitle,.lbl-deal-title,.lbl-negocio{font-weight:600;color:#000}.lbl-deal-title{font-size:120%}.lbl-no-deal{font-size:22px;font-weight:600;color:#000}.flip-list-move{transition:transform .5s}.no-move{transition:transform 0s}.ghost{opacity:.5;background:#c8ebfb}.no-deals{position:absolute;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;margin:auto;top:0;bottom:0;left:0;right:0;height:0}.section{border-bottom:1px solid #dee2e6;color:#757575!important;font-size:18px;text-transform:uppercase}.atrasado{color:red}.default-container .card{background-color:#dbdbdb07}.container .container-full-width{position:absolute;margin-left:0;margin-right:0;max-width:100%;width:100%;left:0}@media only screen and (max-width:768px){.container{width:100%!important;margin:0!important;padding:0!important}}.icon-negocio{display:inline-block;margin-right:10px;line-height:28px;width:48px;height:48px;text-align:center;border:1px solid #bdbdbd;border-radius:50px;color:#3e2f68;box-shadow:0 0 1px 1px #e0e0e0;background-color:#fff}.deal-icon{font-size:24px;color:#808080bb}.tag-input-color{border-radius:2px;margin-left:3px;padding:2px;color:#fff;text-transform:uppercase;font-size:11px}.tag-input-color:hover{cursor:pointer;box-shadow:0 3px 3px 0 #979797}.title-form{display:inline-block;max-width:100%;font-size:20px;text-transform:uppercase;color:#020202;font-weight:400;padding-top:10px;padding-bottom:10px;margin:0 0 -1px}.no-content{min-height:60px;padding-top:30px;font-size:18px;font-weight:500;text-align:center!important;width:100%!important}.deal-list{overflow:hidden;position:relative;width:100%;padding:5px;border-bottom:1px solid #eee;min-height:35px;cursor:pointer}.deal-list:hover{background-color:#fafafa}.deal-form-side{position:fixed;top:0;right:0;width:900px;max-width:100%;height:100%;z-index:1;box-shadow:0 0 2px 0 #0000003d,0 8px 10px 1px #0000000d,0 3px 14px 2px #0000000f,0 5px 5px -3px rgba(0,0,0,.1)}.deal-form{background-color:#fff;display:flex;position:relative;height:100%}.deal-form-1{width:100%;box-sizing:border-box;display:block;z-index:3;position:relative;right:0;top:0;bottom:0;box-shadow:0 0 5px rgba(38,41,44,.12);transform:translateZ(0);flex-flow:column;background:#fff;transition:transform .4s cubic-bezier(.08,.47,.27,.98) 0s;overflow:hidden;transition:height .25s ease-in}.deal-form-2{opacity:1;height:100%;width:100%;transition:opacity .2s cubic-bezier(.08,.47,.27,.98) .2s}.deal-form-3{width:100%;box-sizing:border-box;display:flex;position:relative;z-index:3;height:100%;overflow-x:auto}.deal-form-left{max-width:400px;padding:0 16px 16px;padding-top:12px;border-right:1px solid #eee}.deal-form-left,.deal-form-right{width:100%;display:flex;flex-direction:column}.deal-form-right{padding:0 16px 16px}.sticky{padding:10px 0;display:flex;-webkit-box-pack:end;justify-content:flex-end;top:0;z-index:1}.guia-video{position:fixed;z-index:9998;top:0;bottom:0;left:0;right:0;width:100%;height:100%;overflow:auto;background-color:rgba(15,43,73,.25);display:flex;transition:opacity .3s ease;align-items:center;justify-content:center}.guia-video-content{position:absolute;left:50%;z-index:2;opacity:1;-webkit-transform:translate(-50%);-ms-transform:translate(-50%);transform:translate(-50%);-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out;-webkit-transition-delay:.5s;-ms-transition-delay:.5s;transition-delay:.5s;width:650px;background-color:#fff;padding-bottom:30px;border-radius:10px}.cursor-pointer,.guia-icon{cursor:pointer}.obrigatorio{box-shadow:0 2px 0 #f30202}.current-color{display:inline-block;width:16px;height:16px;background-color:#000;cursor:pointer}.color-container{display:-ms-flexbox;-ms-flex-align:center;align-items:center;padding:.1rem .3rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.vd-text-grand{font-size:27.5px;line-height:1.16667;color:#3a4953}.vd-text-grand,.vd-text-hero{font-synthesis:none;-webkit-font-smoothing:antialiased}.vd-text-hero{font-size:24px;line-height:1.5}.vd-text-medium{font-synthesis:none;-webkit-font-smoothing:antialiased;font-size:1rem;line-height:1.16667;color:#3a4953}.vd-text-grand,.vd-text-hero,.vd-text-medium{text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;word-break:break-word;margin:0}body:has(.modal-dialog){overflow:hidden}.modal-dialog.modal-full-w{max-width:100%;overflow-y:initial!important;margin:5px}.modal-content.modal-full-h{max-width:100%;margin:5px;height:98vh!important;max-height:100%;overflow-y:auto}", ""]);

// exports


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles(parentId, list) {
  var styles = [];
  var newStyles = {};
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = item[0];
    var css = item[1];
    var media = item[2];
    var sourceMap = item[3];
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    };
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] });
    } else {
      newStyles[id].parts.push(part);
    }
  }
  return styles;
};

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_bar_top_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2551ef8d_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_bar_top_vue__ = __webpack_require__(1071);
function injectStyle (ssrContext) {
  __webpack_require__(1027)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2551ef8d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_bar_top_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2551ef8d_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_bar_top_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1028);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7a4a77aa", content, true, {});

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".title[data-v-2551ef8d]{font-size:25px;font-weight:600;color:#2b6292}.card-body span[data-v-2551ef8d]{font-size:15px;font-weight:600;color:#5c5c5c;white-space:pre-line}.nb-menu-config[data-v-2551ef8d]{color:#9c9a9a;font-size:18px}.nb-menu-config[data-v-2551ef8d]:hover{color:#fff}.nb-menu-title[data-v-2551ef8d]{color:#fff;font-size:15px;padding:.5rem 1.5rem;background-color:#2b6292}.nb-dropdown-header[data-v-2551ef8d]{display:block;padding:.5rem 1.5rem;margin-bottom:0;color:#c2c4c5;font-size:85%;background:#2b6292;white-space:nowrap;text-align:center}.columns-1[data-v-2551ef8d]{min-width:250px}.columns-2[data-v-2551ef8d]{min-width:525px}.columns-3[data-v-2551ef8d]{min-width:700px}.left-divider[data-v-2551ef8d]{overflow:hidden;border-left:1px solid #e9ecef}.nb-dropdownmenu[data-v-2551ef8d]{margin-left:auto}.nb-dropdownmenu li[data-v-2551ef8d],.nb-dropdownmenu ul[data-v-2551ef8d]{margin:0;padding:0}.nb-dropdownmenu ul[data-v-2551ef8d]{background:#fff;list-style:none}.nb-dropdownmenu li[data-v-2551ef8d]{float:left;position:relative;width:auto}.nb-dropdownmenu li:hover a[data-v-2551ef8d]{background:#2b6292;color:#fff}.nb-dropdown-divider[data-v-2551ef8d]{background:#2b6292;width:1;overflow:hidden;border-bottom:1px solid #e9ecef}#submenu[data-v-2551ef8d]{position:absolute;left:0;opacity:0;padding:.5rem;visibility:hidden;background:#2b6292;z-index:1000}li:hover ul#submenu[data-v-2551ef8d]{opacity:1;top:40px;visibility:visible}#submenu li[data-v-2551ef8d]{float:none;width:100%}#submenu a[data-v-2551ef8d]:hover{background:#2b629285}#submenu a[data-v-2551ef8d]{background-color:#2b6292}.nb-help-video-icon[data-v-2551ef8d]{display:inline-flex;width:22px;height:22px;align-items:center;justify-content:center;margin-right:10px;color:#ef4444;background:#fef2f2;border-radius:5px;font-size:13px;vertical-align:middle}#submenu .row[data-v-2551ef8d]{background:#2b6292;margin-right:0;margin-left:0}#submenu .submenu-col-2[data-v-2551ef8d]{flex:0 0 50%;max-width:50%}#submenu .submenu-col-3[data-v-2551ef8d]{flex:0 0 33.33%;max-width:33.33%}#submenu.submenu-right[data-v-2551ef8d]{right:0;left:auto}.notification[data-v-2551ef8d]{max-height:400px;overflow:auto}.notification-text[data-v-2551ef8d]{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}#badge[data-v-2551ef8d]{position:absolute;top:-3px;left:20px;width:20px;height:20px;line-height:5px;z-index:1;display:flex;justify-content:center;align-items:center;font-size:12px!important}#badge-mobile[data-v-2551ef8d]{width:23px;height:23px;line-height:10px}.mobile-device[data-v-2551ef8d]{display:block}.other-device[data-v-2551ef8d]{display:none}@media (min-width:768px){.mobile-device[data-v-2551ef8d]{display:none}.other-device[data-v-2551ef8d]{display:block}}.submenu-header[data-v-2551ef8d]{display:block;padding:.5rem 1.5rem;margin-bottom:0;color:gray;font-weight:700;white-space:nowrap;text-align:center}.menu-user[data-v-2551ef8d]{color:#fff;font-size:.75rem;background:#2b6292}.menu-email[data-v-2551ef8d]{display:block;padding:.5rem;margin-bottom:0;color:#fff;font-size:85%;background:#2b6292}.menu-email i[data-v-2551ef8d],.menu-user i[data-v-2551ef8d]{font-size:.85rem;padding:.25rem}#btn-exit[data-v-2551ef8d]:hover{background-color:#2b629285!important}.close[data-v-2551ef8d]{font-size:5rem}.nb-dropdownmenu a[data-v-2551ef8d]{background:#fff;color:gray;display:block;font-size:12px;line-height:40px;text-transform:uppercase;padding:0 10px;text-decoration:none;white-space:nowrap;-webkit-transition:all .25s ease;-moz-transition:all .25s ease;-ms-transition:all .25s ease;-o-transition:all .25s ease;transition:all .25s ease}.nb-dropdownmenu a[data-v-2551ef8d]:hover{color:#fff}@media screen and (max-width:992px){.navbar-desktop[data-v-2551ef8d]{display:none}.navbar-mobile[data-v-2551ef8d]{display:flex!important}.hamburger[data-v-2551ef8d]{width:55px;height:45px;padding:.75rem;display:flex!important;flex-direction:column;justify-content:space-between;cursor:pointer;transition:transform .33s ease-out;z-index:999!important}.hamburger.active[data-v-2551ef8d]{transform:rotate(-45deg);width:25px;height:25px;padding:0;margin-right:.75rem}.line-menu[data-v-2551ef8d]{background-color:gray;border-radius:5px;width:100%;height:3px}.line-menu.half[data-v-2551ef8d]{width:50%}.line-menu.start[data-v-2551ef8d]{transition:transform .33s cubic-bezier(.54,-.81,.57,.57);transform-origin:right}.active .line-menu.start[data-v-2551ef8d]{transform:rotate(-90deg) translateX(2px)}.line-menu.end[data-v-2551ef8d]{align-self:flex-end;transition:transform .33s cubic-bezier(.54,-.81,.57,.57);transform-origin:left}.active .line-menu.end[data-v-2551ef8d]{transform:rotate(-90deg) translateX(-2px)}.wrapper[data-v-2551ef8d]{display:flex!important;flex-direction:column;justify-content:flex-start;align-items:flex-start;position:fixed;top:60px;left:-100%;padding:0 1rem;width:80%;height:calc(100vh - 60px)!important;transition:.5s ease;overflow-y:auto;scrollbar-width:none;z-index:999!important}.wrapper.active[data-v-2551ef8d]{left:0}.accordion[data-v-2551ef8d]{background-color:transparent;color:#444;cursor:pointer;padding:.5rem;width:100%;text-align:left;border:none;outline:none}.accordion i[data-v-2551ef8d]{font-size:.75rem}.panel[data-v-2551ef8d]{padding:0 1rem;background-color:#f6f6f6;overflow:hidden;width:100%;transition:max-height .5s}.panel p[data-v-2551ef8d]{margin:0;padding:.5rem .25rem;font-size:.85rem}}.bell[data-v-2551ef8d]{-webkit-animation:ring-data-v-2551ef8d 4s .7s ease-in-out infinite;-webkit-transform-origin:50% 4px;-moz-animation:ring-data-v-2551ef8d 4s .7s ease-in-out infinite;-moz-transform-origin:50% 4px;animation:ring-data-v-2551ef8d 4s .7s ease-in-out infinite;transform-origin:50% 4px}@-webkit-keyframes ring-data-v-2551ef8d{0%{-webkit-transform:rotate(0)}1%{-webkit-transform:rotate(30deg)}3%{-webkit-transform:rotate(-28deg)}5%{-webkit-transform:rotate(34deg)}7%{-webkit-transform:rotate(-32deg)}9%{-webkit-transform:rotate(30deg)}11%{-webkit-transform:rotate(-28deg)}13%{-webkit-transform:rotate(26deg)}15%{-webkit-transform:rotate(-24deg)}17%{-webkit-transform:rotate(22deg)}19%{-webkit-transform:rotate(-20deg)}21%{-webkit-transform:rotate(18deg)}23%{-webkit-transform:rotate(-16deg)}25%{-webkit-transform:rotate(14deg)}27%{-webkit-transform:rotate(-12deg)}29%{-webkit-transform:rotate(10deg)}31%{-webkit-transform:rotate(-8deg)}33%{-webkit-transform:rotate(6deg)}35%{-webkit-transform:rotate(-4deg)}37%{-webkit-transform:rotate(2deg)}39%{-webkit-transform:rotate(-1deg)}41%{-webkit-transform:rotate(1deg)}43%{-webkit-transform:rotate(0)}to{-webkit-transform:rotate(0)}}@-moz-keyframes ring-data-v-2551ef8d{0%{-moz-transform:rotate(0)}1%{-moz-transform:rotate(30deg)}3%{-moz-transform:rotate(-28deg)}5%{-moz-transform:rotate(34deg)}7%{-moz-transform:rotate(-32deg)}9%{-moz-transform:rotate(30deg)}11%{-moz-transform:rotate(-28deg)}13%{-moz-transform:rotate(26deg)}15%{-moz-transform:rotate(-24deg)}17%{-moz-transform:rotate(22deg)}19%{-moz-transform:rotate(-20deg)}21%{-moz-transform:rotate(18deg)}23%{-moz-transform:rotate(-16deg)}25%{-moz-transform:rotate(14deg)}27%{-moz-transform:rotate(-12deg)}29%{-moz-transform:rotate(10deg)}31%{-moz-transform:rotate(-8deg)}33%{-moz-transform:rotate(6deg)}35%{-moz-transform:rotate(-4deg)}37%{-moz-transform:rotate(2deg)}39%{-moz-transform:rotate(-1deg)}41%{-moz-transform:rotate(1deg)}43%{-moz-transform:rotate(0)}to{-moz-transform:rotate(0)}}@keyframes ring-data-v-2551ef8d{0%{transform:rotate(0)}1%{transform:rotate(30deg)}3%{transform:rotate(-28deg)}5%{transform:rotate(34deg)}7%{transform:rotate(-32deg)}9%{transform:rotate(30deg)}11%{transform:rotate(-28deg)}13%{transform:rotate(26deg)}15%{transform:rotate(-24deg)}17%{transform:rotate(22deg)}19%{transform:rotate(-20deg)}21%{transform:rotate(18deg)}23%{transform:rotate(-16deg)}25%{transform:rotate(14deg)}27%{transform:rotate(-12deg)}29%{transform:rotate(10deg)}31%{transform:rotate(-8deg)}33%{transform:rotate(6deg)}35%{transform:rotate(-4deg)}37%{transform:rotate(2deg)}39%{transform:rotate(-1deg)}41%{transform:rotate(1deg)}43%{transform:rotate(0)}to{transform:rotate(0)}}", ""]);

// exports


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebTransport = exports.WebSocket = exports.NodeWebSocket = exports.XHR = exports.NodeXHR = exports.Fetch = exports.default = exports.connect = exports.io = exports.Socket = exports.Manager = exports.protocol = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _socket = __webpack_require__(157);

Object.defineProperty(exports, "protocol", {
    enumerable: true,
    get: function get() {
        return _socket.protocol;
    }
});

var _engine = __webpack_require__(158);

Object.defineProperty(exports, "Fetch", {
    enumerable: true,
    get: function get() {
        return _engine.Fetch;
    }
});
Object.defineProperty(exports, "NodeXHR", {
    enumerable: true,
    get: function get() {
        return _engine.NodeXHR;
    }
});
Object.defineProperty(exports, "XHR", {
    enumerable: true,
    get: function get() {
        return _engine.XHR;
    }
});
Object.defineProperty(exports, "NodeWebSocket", {
    enumerable: true,
    get: function get() {
        return _engine.NodeWebSocket;
    }
});
Object.defineProperty(exports, "WebSocket", {
    enumerable: true,
    get: function get() {
        return _engine.WebSocket;
    }
});
Object.defineProperty(exports, "WebTransport", {
    enumerable: true,
    get: function get() {
        return _engine.WebTransport;
    }
});

var _url = __webpack_require__(1037);

var _manager = __webpack_require__(1038);

var _socket2 = __webpack_require__(241);

/**
 * Managers cache.
 */
var cache = {};
function lookup(uri, opts) {
    if ((typeof uri === "undefined" ? "undefined" : _typeof(uri)) === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    var parsed = (0, _url.url)(uri, opts.path || "/socket.io");
    var source = parsed.source;
    var id = parsed.id;
    var path = parsed.path;
    var sameNamespace = cache[id] && path in cache[id]["nsps"];
    var newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    var io = void 0;
    if (newConnection) {
        io = new _manager.Manager(source, opts);
    } else {
        if (!cache[id]) {
            cache[id] = new _manager.Manager(source, opts);
        }
        io = cache[id];
    }
    if (parsed.query && !opts.query) {
        opts.query = parsed.queryKey;
    }
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign(lookup, {
    Manager: _manager.Manager,
    Socket: _socket2.Socket,
    io: lookup,
    connect: lookup
});
/**
 * Protocol version.
 *
 * @public
 */

/**
 * Expose constructors for standalone build.
 *
 * @public
 */
exports.Manager = _manager.Manager;
exports.Socket = _socket2.Socket;
exports.io = lookup;
exports.connect = lookup;
exports.default = lookup;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.deconstructPacket = deconstructPacket;
exports.reconstructPacket = reconstructPacket;

var _isBinary = __webpack_require__(235);

/**
 * Replaces every Buffer | ArrayBuffer | Blob | File in packet with a numbered placeholder.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @public
 */
function deconstructPacket(packet) {
    var buffers = [];
    var packetData = packet.data;
    var pack = packet;
    pack.data = _deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return { packet: pack, buffers: buffers };
}
function _deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, _isBinary.isBinary)(data)) {
        var placeholder = { _placeholder: true, num: buffers.length };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        var newData = new Array(data.length);
        for (var i = 0; i < data.length; i++) {
            newData[i] = _deconstructPacket(data[i], buffers);
        }
        return newData;
    } else if ((typeof data === "undefined" ? "undefined" : _typeof(data)) === "object" && !(data instanceof Date)) {
        var _newData = {};
        for (var key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                _newData[key] = _deconstructPacket(data[key], buffers);
            }
        }
        return _newData;
    }
    return data;
}
/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @public
 */
function reconstructPacket(packet, buffers) {
    packet.data = _reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function _reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        var isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) {
            return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        } else {
            throw new Error("illegal attachments");
        }
    } else if (Array.isArray(data)) {
        for (var i = 0; i < data.length; i++) {
            data[i] = _reconstructPacket(data[i], buffers);
        }
    } else if ((typeof data === "undefined" ? "undefined" : _typeof(data)) === "object") {
        for (var key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                data[key] = _reconstructPacket(data[key], buffers);
            }
        }
    }
    return data;
}

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Socket = exports.SocketWithUpgrade = exports.SocketWithoutUpgrade = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(236);

var _util = __webpack_require__(75);

var _parseqs = __webpack_require__(238);

var _parseuri = __webpack_require__(240);

var _componentEmitter = __webpack_require__(74);

var _engine = __webpack_require__(86);

var _globalsNode = __webpack_require__(76);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
var OFFLINE_EVENT_LISTENERS = [];
if (withEventListeners) {
    // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
    // script, so we create one single event listener here which will forward the event to the socket instances
    addEventListener("offline", function () {
        OFFLINE_EVENT_LISTENERS.forEach(function (listener) {
            return listener();
        });
    }, false);
}
/**
 * This class provides a WebSocket-like interface to connect to an Engine.IO server. The connection will be established
 * with one of the available low-level transports, like HTTP long-polling, WebSocket or WebTransport.
 *
 * This class comes without upgrade mechanism, which means that it will keep the first low-level transport that
 * successfully establishes the connection.
 *
 * In order to allow tree-shaking, there are no transports included, that's why the `transports` option is mandatory.
 *
 * @example
 * import { SocketWithoutUpgrade, WebSocket } from "engine.io-client";
 *
 * const socket = new SocketWithoutUpgrade({
 *   transports: [WebSocket]
 * });
 *
 * socket.on("open", () => {
 *   socket.send("hello");
 * });
 *
 * @see SocketWithUpgrade
 * @see Socket
 */

var SocketWithoutUpgrade = exports.SocketWithoutUpgrade = function (_Emitter) {
    _inherits(SocketWithoutUpgrade, _Emitter);

    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */
    function SocketWithoutUpgrade(uri, opts) {
        _classCallCheck(this, SocketWithoutUpgrade);

        var _this = _possibleConstructorReturn(this, (SocketWithoutUpgrade.__proto__ || Object.getPrototypeOf(SocketWithoutUpgrade)).call(this));

        _this.binaryType = _globalsNode.defaultBinaryType;
        _this.writeBuffer = [];
        _this._prevBufferLen = 0;
        _this._pingInterval = -1;
        _this._pingTimeout = -1;
        _this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */
        _this._pingTimeoutTime = Infinity;
        if (uri && "object" === (typeof uri === "undefined" ? "undefined" : _typeof(uri))) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            var parsedUri = (0, _parseuri.parse)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) {
            opts.hostname = (0, _parseuri.parse)(opts.host).host;
        }
        (0, _util.installTimerFunctions)(_this, opts);
        _this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) {
            // if no port is specified manually, use the protocol default
            opts.port = _this.secure ? "443" : "80";
        }
        _this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        _this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : _this.secure ? "443" : "80");
        _this.transports = [];
        _this._transportsByName = {};
        opts.transports.forEach(function (t) {
            var transportName = t.prototype.name;
            _this.transports.push(transportName);
            _this._transportsByName[transportName] = t;
        });
        _this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        _this.opts.path = _this.opts.path.replace(/\/$/, "") + (_this.opts.addTrailingSlash ? "/" : "");
        if (typeof _this.opts.query === "string") {
            _this.opts.query = (0, _parseqs.decode)(_this.opts.query);
        }
        if (withEventListeners) {
            if (_this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                _this._beforeunloadEventListener = function () {
                    if (_this.transport) {
                        // silently close the transport
                        _this.transport.removeAllListeners();
                        _this.transport.close();
                    }
                };
                addEventListener("beforeunload", _this._beforeunloadEventListener, false);
            }
            if (_this.hostname !== "localhost") {
                _this._offlineEventListener = function () {
                    _this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                OFFLINE_EVENT_LISTENERS.push(_this._offlineEventListener);
            }
        }
        if (_this.opts.withCredentials) {
            _this._cookieJar = (0, _globalsNode.createCookieJar)();
        }
        _this._open();
        return _this;
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */


    _createClass(SocketWithoutUpgrade, [{
        key: "createTransport",
        value: function createTransport(name) {
            var query = Object.assign({}, this.opts.query);
            // append engine.io protocol identifier
            query.EIO = _engine.protocol;
            // transport name
            query.transport = name;
            // session id if we already have one
            if (this.id) query.sid = this.id;
            var opts = Object.assign({}, this.opts, {
                query: query,
                socket: this,
                hostname: this.hostname,
                secure: this.secure,
                port: this.port
            }, this.opts.transportOptions[name]);
            return new this._transportsByName[name](opts);
        }
        /**
         * Initializes transport to use and starts probe.
         *
         * @private
         */

    }, {
        key: "_open",
        value: function _open() {
            var _this2 = this;

            if (this.transports.length === 0) {
                // Emit error on next tick so it can be listened to
                this.setTimeoutFn(function () {
                    _this2.emitReserved("error", "No transports available");
                }, 0);
                return;
            }
            var transportName = this.opts.rememberUpgrade && SocketWithoutUpgrade.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
            this.readyState = "opening";
            var transport = this.createTransport(transportName);
            transport.open();
            this.setTransport(transport);
        }
        /**
         * Sets the current transport. Disables the existing one (if any).
         *
         * @private
         */

    }, {
        key: "setTransport",
        value: function setTransport(transport) {
            var _this3 = this;

            if (this.transport) {
                this.transport.removeAllListeners();
            }
            // set up transport
            this.transport = transport;
            // set up transport listeners
            transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", function (reason) {
                return _this3._onClose("transport close", reason);
            });
        }
        /**
         * Called when connection is deemed open.
         *
         * @private
         */

    }, {
        key: "onOpen",
        value: function onOpen() {
            this.readyState = "open";
            SocketWithoutUpgrade.priorWebsocketSuccess = "websocket" === this.transport.name;
            this.emitReserved("open");
            this.flush();
        }
        /**
         * Handles a packet.
         *
         * @private
         */

    }, {
        key: "_onPacket",
        value: function _onPacket(packet) {
            if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
                this.emitReserved("packet", packet);
                // Socket is live - any packet counts
                this.emitReserved("heartbeat");
                switch (packet.type) {
                    case "open":
                        this.onHandshake(JSON.parse(packet.data));
                        break;
                    case "ping":
                        this._sendPacket("pong");
                        this.emitReserved("ping");
                        this.emitReserved("pong");
                        this._resetPingTimeout();
                        break;
                    case "error":
                        var err = new Error("server error");
                        // @ts-ignore
                        err.code = packet.data;
                        this._onError(err);
                        break;
                    case "message":
                        this.emitReserved("data", packet.data);
                        this.emitReserved("message", packet.data);
                        break;
                }
            } else {}
        }
        /**
         * Called upon handshake completion.
         *
         * @param {Object} data - handshake obj
         * @private
         */

    }, {
        key: "onHandshake",
        value: function onHandshake(data) {
            this.emitReserved("handshake", data);
            this.id = data.sid;
            this.transport.query.sid = data.sid;
            this._pingInterval = data.pingInterval;
            this._pingTimeout = data.pingTimeout;
            this._maxPayload = data.maxPayload;
            this.onOpen();
            // In case open handler closes socket
            if ("closed" === this.readyState) return;
            this._resetPingTimeout();
        }
        /**
         * Sets and resets ping timeout timer based on server pings.
         *
         * @private
         */

    }, {
        key: "_resetPingTimeout",
        value: function _resetPingTimeout() {
            var _this4 = this;

            this.clearTimeoutFn(this._pingTimeoutTimer);
            var delay = this._pingInterval + this._pingTimeout;
            this._pingTimeoutTime = Date.now() + delay;
            this._pingTimeoutTimer = this.setTimeoutFn(function () {
                _this4._onClose("ping timeout");
            }, delay);
            if (this.opts.autoUnref) {
                this._pingTimeoutTimer.unref();
            }
        }
        /**
         * Called on `drain` event
         *
         * @private
         */

    }, {
        key: "_onDrain",
        value: function _onDrain() {
            this.writeBuffer.splice(0, this._prevBufferLen);
            // setting prevBufferLen = 0 is very important
            // for example, when upgrading, upgrade packet is sent over,
            // and a nonzero prevBufferLen could cause problems on `drain`
            this._prevBufferLen = 0;
            if (0 === this.writeBuffer.length) {
                this.emitReserved("drain");
            } else {
                this.flush();
            }
        }
        /**
         * Flush write buffers.
         *
         * @private
         */

    }, {
        key: "flush",
        value: function flush() {
            if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
                var packets = this._getWritablePackets();
                this.transport.send(packets);
                // keep track of current length of writeBuffer
                // splice writeBuffer and callbackBuffer on `drain`
                this._prevBufferLen = packets.length;
                this.emitReserved("flush");
            }
        }
        /**
         * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
         * long-polling)
         *
         * @private
         */

    }, {
        key: "_getWritablePackets",
        value: function _getWritablePackets() {
            var shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
            if (!shouldCheckPayloadSize) {
                return this.writeBuffer;
            }
            var payloadSize = 1; // first packet type
            for (var i = 0; i < this.writeBuffer.length; i++) {
                var data = this.writeBuffer[i].data;
                if (data) {
                    payloadSize += (0, _util.byteLength)(data);
                }
                if (i > 0 && payloadSize > this._maxPayload) {
                    return this.writeBuffer.slice(0, i);
                }
                payloadSize += 2; // separator + packet type
            }
            return this.writeBuffer;
        }
        /**
         * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
         *
         * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
         * `write()` method then the message would not be buffered by the Socket.IO client.
         *
         * @return {boolean}
         * @private
         */
        /* private */
    }, {
        key: "_hasPingExpired",
        value: function _hasPingExpired() {
            var _this5 = this;

            if (!this._pingTimeoutTime) return true;
            var hasExpired = Date.now() > this._pingTimeoutTime;
            if (hasExpired) {
                this._pingTimeoutTime = 0;
                (0, _globalsNode.nextTick)(function () {
                    _this5._onClose("ping timeout");
                }, this.setTimeoutFn);
            }
            return hasExpired;
        }
        /**
         * Sends a message.
         *
         * @param {String} msg - message.
         * @param {Object} options.
         * @param {Function} fn - callback function.
         * @return {Socket} for chaining.
         */

    }, {
        key: "write",
        value: function write(msg, options, fn) {
            this._sendPacket("message", msg, options, fn);
            return this;
        }
        /**
         * Sends a message. Alias of {@link Socket#write}.
         *
         * @param {String} msg - message.
         * @param {Object} options.
         * @param {Function} fn - callback function.
         * @return {Socket} for chaining.
         */

    }, {
        key: "send",
        value: function send(msg, options, fn) {
            this._sendPacket("message", msg, options, fn);
            return this;
        }
        /**
         * Sends a packet.
         *
         * @param {String} type: packet type.
         * @param {String} data.
         * @param {Object} options.
         * @param {Function} fn - callback function.
         * @private
         */

    }, {
        key: "_sendPacket",
        value: function _sendPacket(type, data, options, fn) {
            if ("function" === typeof data) {
                fn = data;
                data = undefined;
            }
            if ("function" === typeof options) {
                fn = options;
                options = null;
            }
            if ("closing" === this.readyState || "closed" === this.readyState) {
                return;
            }
            options = options || {};
            options.compress = false !== options.compress;
            var packet = {
                type: type,
                data: data,
                options: options
            };
            this.emitReserved("packetCreate", packet);
            this.writeBuffer.push(packet);
            if (fn) this.once("flush", fn);
            this.flush();
        }
        /**
         * Closes the connection.
         */

    }, {
        key: "close",
        value: function close() {
            var _this6 = this;

            var close = function close() {
                _this6._onClose("forced close");
                _this6.transport.close();
            };
            var cleanupAndClose = function cleanupAndClose() {
                _this6.off("upgrade", cleanupAndClose);
                _this6.off("upgradeError", cleanupAndClose);
                close();
            };
            var waitForUpgrade = function waitForUpgrade() {
                // wait for upgrade to finish since we can't send packets while pausing a transport
                _this6.once("upgrade", cleanupAndClose);
                _this6.once("upgradeError", cleanupAndClose);
            };
            if ("opening" === this.readyState || "open" === this.readyState) {
                this.readyState = "closing";
                if (this.writeBuffer.length) {
                    this.once("drain", function () {
                        if (_this6.upgrading) {
                            waitForUpgrade();
                        } else {
                            close();
                        }
                    });
                } else if (this.upgrading) {
                    waitForUpgrade();
                } else {
                    close();
                }
            }
            return this;
        }
        /**
         * Called upon transport error
         *
         * @private
         */

    }, {
        key: "_onError",
        value: function _onError(err) {
            SocketWithoutUpgrade.priorWebsocketSuccess = false;
            if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
                this.transports.shift();
                return this._open();
            }
            this.emitReserved("error", err);
            this._onClose("transport error", err);
        }
        /**
         * Called upon transport close.
         *
         * @private
         */

    }, {
        key: "_onClose",
        value: function _onClose(reason, description) {
            if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
                // clear timers
                this.clearTimeoutFn(this._pingTimeoutTimer);
                // stop event from firing again for transport
                this.transport.removeAllListeners("close");
                // ensure transport won't stay open
                this.transport.close();
                // ignore further transport communication
                this.transport.removeAllListeners();
                if (withEventListeners) {
                    if (this._beforeunloadEventListener) {
                        removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                    }
                    if (this._offlineEventListener) {
                        var i = OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                        if (i !== -1) {
                            OFFLINE_EVENT_LISTENERS.splice(i, 1);
                        }
                    }
                }
                // set ready state
                this.readyState = "closed";
                // clear session id
                this.id = null;
                // emit close event
                this.emitReserved("close", reason, description);
                // clean buffers after, so users can still
                // grab the buffers on `close` event
                this.writeBuffer = [];
                this._prevBufferLen = 0;
            }
        }
    }]);

    return SocketWithoutUpgrade;
}(_componentEmitter.Emitter);

SocketWithoutUpgrade.protocol = _engine.protocol;
/**
 * This class provides a WebSocket-like interface to connect to an Engine.IO server. The connection will be established
 * with one of the available low-level transports, like HTTP long-polling, WebSocket or WebTransport.
 *
 * This class comes with an upgrade mechanism, which means that once the connection is established with the first
 * low-level transport, it will try to upgrade to a better transport.
 *
 * In order to allow tree-shaking, there are no transports included, that's why the `transports` option is mandatory.
 *
 * @example
 * import { SocketWithUpgrade, WebSocket } from "engine.io-client";
 *
 * const socket = new SocketWithUpgrade({
 *   transports: [WebSocket]
 * });
 *
 * socket.on("open", () => {
 *   socket.send("hello");
 * });
 *
 * @see SocketWithoutUpgrade
 * @see Socket
 */

var SocketWithUpgrade = exports.SocketWithUpgrade = function (_SocketWithoutUpgrade) {
    _inherits(SocketWithUpgrade, _SocketWithoutUpgrade);

    function SocketWithUpgrade() {
        _classCallCheck(this, SocketWithUpgrade);

        var _this7 = _possibleConstructorReturn(this, (SocketWithUpgrade.__proto__ || Object.getPrototypeOf(SocketWithUpgrade)).apply(this, arguments));

        _this7._upgrades = [];
        return _this7;
    }

    _createClass(SocketWithUpgrade, [{
        key: "onOpen",
        value: function onOpen() {
            _get(SocketWithUpgrade.prototype.__proto__ || Object.getPrototypeOf(SocketWithUpgrade.prototype), "onOpen", this).call(this);
            if ("open" === this.readyState && this.opts.upgrade) {
                for (var i = 0; i < this._upgrades.length; i++) {
                    this._probe(this._upgrades[i]);
                }
            }
        }
        /**
         * Probes a transport.
         *
         * @param {String} name - transport name
         * @private
         */

    }, {
        key: "_probe",
        value: function _probe(name) {
            var _this8 = this;

            var transport = this.createTransport(name);
            var failed = false;
            SocketWithoutUpgrade.priorWebsocketSuccess = false;
            var onTransportOpen = function onTransportOpen() {
                if (failed) return;
                transport.send([{ type: "ping", data: "probe" }]);
                transport.once("packet", function (msg) {
                    if (failed) return;
                    if ("pong" === msg.type && "probe" === msg.data) {
                        _this8.upgrading = true;
                        _this8.emitReserved("upgrading", transport);
                        if (!transport) return;
                        SocketWithoutUpgrade.priorWebsocketSuccess = "websocket" === transport.name;
                        _this8.transport.pause(function () {
                            if (failed) return;
                            if ("closed" === _this8.readyState) return;
                            cleanup();
                            _this8.setTransport(transport);
                            transport.send([{ type: "upgrade" }]);
                            _this8.emitReserved("upgrade", transport);
                            transport = null;
                            _this8.upgrading = false;
                            _this8.flush();
                        });
                    } else {
                        var err = new Error("probe error");
                        // @ts-ignore
                        err.transport = transport.name;
                        _this8.emitReserved("upgradeError", err);
                    }
                });
            };
            function freezeTransport() {
                if (failed) return;
                // Any callback called by transport should be ignored since now
                failed = true;
                cleanup();
                transport.close();
                transport = null;
            }
            // Handle any error that happens while probing
            var onerror = function onerror(err) {
                var error = new Error("probe error: " + err);
                // @ts-ignore
                error.transport = transport.name;
                freezeTransport();
                _this8.emitReserved("upgradeError", error);
            };
            function onTransportClose() {
                onerror("transport closed");
            }
            // When the socket is closed while we're probing
            function onclose() {
                onerror("socket closed");
            }
            // When the socket is upgraded while we're probing
            function onupgrade(to) {
                if (transport && to.name !== transport.name) {
                    freezeTransport();
                }
            }
            // Remove all listeners on the transport and on self
            var cleanup = function cleanup() {
                transport.removeListener("open", onTransportOpen);
                transport.removeListener("error", onerror);
                transport.removeListener("close", onTransportClose);
                _this8.off("close", onclose);
                _this8.off("upgrading", onupgrade);
            };
            transport.once("open", onTransportOpen);
            transport.once("error", onerror);
            transport.once("close", onTransportClose);
            this.once("close", onclose);
            this.once("upgrading", onupgrade);
            if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") {
                // favor WebTransport
                this.setTimeoutFn(function () {
                    if (!failed) {
                        transport.open();
                    }
                }, 200);
            } else {
                transport.open();
            }
        }
    }, {
        key: "onHandshake",
        value: function onHandshake(data) {
            this._upgrades = this._filterUpgrades(data.upgrades);
            _get(SocketWithUpgrade.prototype.__proto__ || Object.getPrototypeOf(SocketWithUpgrade.prototype), "onHandshake", this).call(this, data);
        }
        /**
         * Filters upgrades, returning only those matching client transports.
         *
         * @param {Array} upgrades - server upgrades
         * @private
         */

    }, {
        key: "_filterUpgrades",
        value: function _filterUpgrades(upgrades) {
            var filteredUpgrades = [];
            for (var i = 0; i < upgrades.length; i++) {
                if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
            }
            return filteredUpgrades;
        }
    }]);

    return SocketWithUpgrade;
}(SocketWithoutUpgrade);
/**
 * This class provides a WebSocket-like interface to connect to an Engine.IO server. The connection will be established
 * with one of the available low-level transports, like HTTP long-polling, WebSocket or WebTransport.
 *
 * This class comes with an upgrade mechanism, which means that once the connection is established with the first
 * low-level transport, it will try to upgrade to a better transport.
 *
 * @example
 * import { Socket } from "engine.io-client";
 *
 * const socket = new Socket();
 *
 * socket.on("open", () => {
 *   socket.send("hello");
 * });
 *
 * @see SocketWithoutUpgrade
 * @see SocketWithUpgrade
 */


var Socket = exports.Socket = function (_SocketWithUpgrade) {
    _inherits(Socket, _SocketWithUpgrade);

    function Socket(uri) {
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Socket);

        var o = (typeof uri === "undefined" ? "undefined" : _typeof(uri)) === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") {
            o.transports = (o.transports || ["polling", "websocket", "webtransport"]).map(function (transportName) {
                return _index.transports[transportName];
            }).filter(function (t) {
                return !!t;
            });
        }
        return _possibleConstructorReturn(this, (Socket.__proto__ || Object.getPrototypeOf(Socket)).call(this, uri, o));
    }

    return Socket;
}(SocketWithUpgrade);

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.encodePacket = undefined;
exports.encodePacketToBinary = encodePacketToBinary;

var _commons = __webpack_require__(160);

var withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
var withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
var isView = function isView(obj) {
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
var encodePacket = function encodePacket(_ref, supportsBinary, callback) {
    var type = _ref.type,
        data = _ref.data;

    if (withNativeBlob && data instanceof Blob) {
        if (supportsBinary) {
            return callback(data);
        } else {
            return encodeBlobAsBase64(data, callback);
        }
    } else if (withNativeArrayBuffer && (data instanceof ArrayBuffer || isView(data))) {
        if (supportsBinary) {
            return callback(data);
        } else {
            return encodeBlobAsBase64(new Blob([data]), callback);
        }
    }
    // plain string
    return callback(_commons.PACKET_TYPES[type] + (data || ""));
};
var encodeBlobAsBase64 = function encodeBlobAsBase64(data, callback) {
    var fileReader = new FileReader();
    fileReader.onload = function () {
        var content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function toArray(data) {
    if (data instanceof Uint8Array) {
        return data;
    } else if (data instanceof ArrayBuffer) {
        return new Uint8Array(data);
    } else {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
    }
}
var TEXT_ENCODER = void 0;
function encodePacketToBinary(packet, callback) {
    if (withNativeBlob && packet.data instanceof Blob) {
        return packet.data.arrayBuffer().then(toArray).then(callback);
    } else if (withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || isView(packet.data))) {
        return callback(toArray(packet.data));
    }
    encodePacket(packet, false, function (encoded) {
        if (!TEXT_ENCODER) {
            TEXT_ENCODER = new TextEncoder();
        }
        callback(TEXT_ENCODER.encode(encoded));
    });
}
exports.encodePacket = encodePacket;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.decodePacket = undefined;

var _commons = __webpack_require__(160);

var _base64Arraybuffer = __webpack_require__(1034);

var withNativeArrayBuffer = typeof ArrayBuffer === "function";
var decodePacket = exports.decodePacket = function decodePacket(encodedPacket, binaryType) {
    if (typeof encodedPacket !== "string") {
        return {
            type: "message",
            data: mapBinary(encodedPacket, binaryType)
        };
    }
    var type = encodedPacket.charAt(0);
    if (type === "b") {
        return {
            type: "message",
            data: decodeBase64Packet(encodedPacket.substring(1), binaryType)
        };
    }
    var packetType = _commons.PACKET_TYPES_REVERSE[type];
    if (!packetType) {
        return _commons.ERROR_PACKET;
    }
    return encodedPacket.length > 1 ? {
        type: _commons.PACKET_TYPES_REVERSE[type],
        data: encodedPacket.substring(1)
    } : {
        type: _commons.PACKET_TYPES_REVERSE[type]
    };
};
var decodeBase64Packet = function decodeBase64Packet(data, binaryType) {
    if (withNativeArrayBuffer) {
        var decoded = (0, _base64Arraybuffer.decode)(data);
        return mapBinary(decoded, binaryType);
    } else {
        return { base64: true, data: data }; // fallback for old browsers
    }
};
var mapBinary = function mapBinary(data, binaryType) {
    switch (binaryType) {
        case "blob":
            if (data instanceof Blob) {
                // from WebSocket + binaryType "blob"
                return data;
            } else {
                // from HTTP long-polling or WebTransport
                return new Blob([data]);
            }
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) {
                // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
                return data;
            } else {
                // from WebTransport (Uint8Array)
                return data.buffer;
            }
    }
};

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// imported from https://github.com/socketio/base64-arraybuffer
var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
}
var encode = exports.encode = function encode(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
        i = void 0,
        len = bytes.length,
        base64 = '';
    for (i = 0; i < len; i += 3) {
        base64 += chars[bytes[i] >> 2];
        base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) {
        base64 = base64.substring(0, base64.length - 1) + '=';
    } else if (len % 3 === 1) {
        base64 = base64.substring(0, base64.length - 2) + '==';
    }
    return base64;
};
var decode = exports.decode = function decode(base64) {
    var bufferLength = base64.length * 0.75,
        len = base64.length,
        i = void 0,
        p = 0,
        encoded1 = void 0,
        encoded2 = void 0,
        encoded3 = void 0,
        encoded4 = void 0;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') {
            bufferLength--;
        }
    }
    var arraybuffer = new ArrayBuffer(bufferLength),
        bytes = new Uint8Array(arraybuffer);
    for (i = 0; i < len; i += 4) {
        encoded1 = lookup[base64.charCodeAt(i)];
        encoded2 = lookup[base64.charCodeAt(i + 1)];
        encoded3 = lookup[base64.charCodeAt(i + 2)];
        encoded4 = lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// imported from https://github.com/component/has-cors
var value = false;
try {
    value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
    // if XMLHttp support is disabled in IE then it will throw
    // when trying to create
}
var hasCORS = exports.hasCORS = value;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Fetch = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _polling = __webpack_require__(237);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * HTTP long-polling based on the built-in `fetch()` method.
 *
 * Usage: browser, Node.js (since v18), Deno, Bun
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/fetch
 * @see https://caniuse.com/fetch
 * @see https://nodejs.org/api/globals.html#fetch
 */
var Fetch = exports.Fetch = function (_Polling) {
    _inherits(Fetch, _Polling);

    function Fetch() {
        _classCallCheck(this, Fetch);

        return _possibleConstructorReturn(this, (Fetch.__proto__ || Object.getPrototypeOf(Fetch)).apply(this, arguments));
    }

    _createClass(Fetch, [{
        key: "doPoll",
        value: function doPoll() {
            var _this2 = this;

            this._fetch().then(function (res) {
                if (!res.ok) {
                    return _this2.onError("fetch read error", res.status, res);
                }
                res.text().then(function (data) {
                    return _this2.onData(data);
                });
            }).catch(function (err) {
                _this2.onError("fetch read error", err);
            });
        }
    }, {
        key: "doWrite",
        value: function doWrite(data, callback) {
            var _this3 = this;

            this._fetch(data).then(function (res) {
                if (!res.ok) {
                    return _this3.onError("fetch write error", res.status, res);
                }
                callback();
            }).catch(function (err) {
                _this3.onError("fetch write error", err);
            });
        }
    }, {
        key: "_fetch",
        value: function _fetch(data) {
            var _this4 = this;

            var _a;
            var isPost = data !== undefined;
            var headers = new Headers(this.opts.extraHeaders);
            if (isPost) {
                headers.set("content-type", "text/plain;charset=UTF-8");
            }
            (_a = this.socket._cookieJar) === null || _a === void 0 ? void 0 : _a.appendCookies(headers);
            return fetch(this.uri(), {
                method: isPost ? "POST" : "GET",
                body: isPost ? data : null,
                headers: headers,
                credentials: this.opts.withCredentials ? "include" : "omit"
            }).then(function (res) {
                var _a;
                // @ts-ignore getSetCookie() was added in Node.js v19.7.0
                (_a = _this4.socket._cookieJar) === null || _a === void 0 ? void 0 : _a.parseCookies(res.headers.getSetCookie());
                return res;
            });
        }
    }]);

    return Fetch;
}(_polling.Polling);

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.url = url;

var _engine = __webpack_require__(158);

/**
 * URL parser.
 *
 * @param uri - url
 * @param path - the request path of the connection
 * @param loc - An object meant to mimic window.location.
 *        Defaults to window.location.
 * @public
 */
function url(uri) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var loc = arguments[2];

    var obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) {
                uri = loc.protocol + uri;
            } else {
                uri = loc.host + uri;
            }
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) {
                uri = loc.protocol + "//" + uri;
            } else {
                uri = "https://" + uri;
            }
        }
        // parse
        obj = (0, _engine.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) {
            obj.port = "80";
        } else if (/^(http|ws)s$/.test(obj.protocol)) {
            obj.port = "443";
        }
    }
    obj.path = obj.path || "/";
    var ipv6 = obj.host.indexOf(":") !== -1;
    var host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Manager = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _engine = __webpack_require__(158);

var _socket2 = __webpack_require__(241);

var _socket3 = __webpack_require__(157);

var parser = _interopRequireWildcard(_socket3);

var _on = __webpack_require__(242);

var _backo = __webpack_require__(1039);

var _componentEmitter = __webpack_require__(74);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Manager = exports.Manager = function (_Emitter) {
    _inherits(Manager, _Emitter);

    function Manager(uri, opts) {
        _classCallCheck(this, Manager);

        var _a;

        var _this = _possibleConstructorReturn(this, (Manager.__proto__ || Object.getPrototypeOf(Manager)).call(this));

        _this.nsps = {};
        _this.subs = [];
        if (uri && "object" === (typeof uri === "undefined" ? "undefined" : _typeof(uri))) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        _this.opts = opts;
        (0, _engine.installTimerFunctions)(_this, opts);
        _this.reconnection(opts.reconnection !== false);
        _this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        _this.reconnectionDelay(opts.reconnectionDelay || 1000);
        _this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        _this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        _this.backoff = new _backo.Backoff({
            min: _this.reconnectionDelay(),
            max: _this.reconnectionDelayMax(),
            jitter: _this.randomizationFactor()
        });
        _this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        _this._readyState = "closed";
        _this.uri = uri;
        var _parser = opts.parser || parser;
        _this.encoder = new _parser.Encoder();
        _this.decoder = new _parser.Decoder();
        _this._autoConnect = opts.autoConnect !== false;
        if (_this._autoConnect) _this.open();
        return _this;
    }

    _createClass(Manager, [{
        key: "reconnection",
        value: function reconnection(v) {
            if (!arguments.length) return this._reconnection;
            this._reconnection = !!v;
            if (!v) {
                this.skipReconnect = true;
            }
            return this;
        }
    }, {
        key: "reconnectionAttempts",
        value: function reconnectionAttempts(v) {
            if (v === undefined) return this._reconnectionAttempts;
            this._reconnectionAttempts = v;
            return this;
        }
    }, {
        key: "reconnectionDelay",
        value: function reconnectionDelay(v) {
            var _a;
            if (v === undefined) return this._reconnectionDelay;
            this._reconnectionDelay = v;
            (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMin(v);
            return this;
        }
    }, {
        key: "randomizationFactor",
        value: function randomizationFactor(v) {
            var _a;
            if (v === undefined) return this._randomizationFactor;
            this._randomizationFactor = v;
            (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setJitter(v);
            return this;
        }
    }, {
        key: "reconnectionDelayMax",
        value: function reconnectionDelayMax(v) {
            var _a;
            if (v === undefined) return this._reconnectionDelayMax;
            this._reconnectionDelayMax = v;
            (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMax(v);
            return this;
        }
    }, {
        key: "timeout",
        value: function timeout(v) {
            if (!arguments.length) return this._timeout;
            this._timeout = v;
            return this;
        }
        /**
         * Starts trying to reconnect if reconnection is enabled and we have not
         * started reconnecting yet
         *
         * @private
         */

    }, {
        key: "maybeReconnectOnOpen",
        value: function maybeReconnectOnOpen() {
            // Only try to reconnect if it's the first time we're connecting
            if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) {
                // keeps reconnection from firing twice for the same reconnection loop
                this.reconnect();
            }
        }
        /**
         * Sets the current transport `socket`.
         *
         * @param {Function} fn - optional, callback
         * @return self
         * @public
         */

    }, {
        key: "open",
        value: function open(fn) {
            var _this2 = this;

            if (~this._readyState.indexOf("open")) return this;
            this.engine = new _engine.Socket(this.uri, this.opts);
            var socket = this.engine;
            var self = this;
            this._readyState = "opening";
            this.skipReconnect = false;
            // emit `open`
            var openSubDestroy = (0, _on.on)(socket, "open", function () {
                self.onopen();
                fn && fn();
            });
            var onError = function onError(err) {
                _this2.cleanup();
                _this2._readyState = "closed";
                _this2.emitReserved("error", err);
                if (fn) {
                    fn(err);
                } else {
                    // Only do this if there is no fn to handle the error
                    _this2.maybeReconnectOnOpen();
                }
            };
            // emit `error`
            var errorSub = (0, _on.on)(socket, "error", onError);
            if (false !== this._timeout) {
                var timeout = this._timeout;
                // set timer
                var timer = this.setTimeoutFn(function () {
                    openSubDestroy();
                    onError(new Error("timeout"));
                    socket.close();
                }, timeout);
                if (this.opts.autoUnref) {
                    timer.unref();
                }
                this.subs.push(function () {
                    _this2.clearTimeoutFn(timer);
                });
            }
            this.subs.push(openSubDestroy);
            this.subs.push(errorSub);
            return this;
        }
        /**
         * Alias for open()
         *
         * @return self
         * @public
         */

    }, {
        key: "connect",
        value: function connect(fn) {
            return this.open(fn);
        }
        /**
         * Called upon transport open.
         *
         * @private
         */

    }, {
        key: "onopen",
        value: function onopen() {
            // clear old subs
            this.cleanup();
            // mark as open
            this._readyState = "open";
            this.emitReserved("open");
            // add new subs
            var socket = this.engine;
            this.subs.push((0, _on.on)(socket, "ping", this.onping.bind(this)), (0, _on.on)(socket, "data", this.ondata.bind(this)), (0, _on.on)(socket, "error", this.onerror.bind(this)), (0, _on.on)(socket, "close", this.onclose.bind(this)),
            // @ts-ignore
            (0, _on.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
        }
        /**
         * Called upon a ping.
         *
         * @private
         */

    }, {
        key: "onping",
        value: function onping() {
            this.emitReserved("ping");
        }
        /**
         * Called with data.
         *
         * @private
         */

    }, {
        key: "ondata",
        value: function ondata(data) {
            try {
                this.decoder.add(data);
            } catch (e) {
                this.onclose("parse error", e);
            }
        }
        /**
         * Called when parser fully decodes a packet.
         *
         * @private
         */

    }, {
        key: "ondecoded",
        value: function ondecoded(packet) {
            var _this3 = this;

            // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
            (0, _engine.nextTick)(function () {
                _this3.emitReserved("packet", packet);
            }, this.setTimeoutFn);
        }
        /**
         * Called upon socket error.
         *
         * @private
         */

    }, {
        key: "onerror",
        value: function onerror(err) {
            this.emitReserved("error", err);
        }
        /**
         * Creates a new socket for the given `nsp`.
         *
         * @return {Socket}
         * @public
         */

    }, {
        key: "socket",
        value: function socket(nsp, opts) {
            var socket = this.nsps[nsp];
            if (!socket) {
                socket = new _socket2.Socket(this, nsp, opts);
                this.nsps[nsp] = socket;
            } else if (this._autoConnect && !socket.active) {
                socket.connect();
            }
            return socket;
        }
        /**
         * Called upon a socket close.
         *
         * @param socket
         * @private
         */

    }, {
        key: "_destroy",
        value: function _destroy(socket) {
            var nsps = Object.keys(this.nsps);
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = nsps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var nsp = _step.value;

                    var _socket = this.nsps[nsp];
                    if (_socket.active) {
                        return;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this._close();
        }
        /**
         * Writes a packet.
         *
         * @param packet
         * @private
         */

    }, {
        key: "_packet",
        value: function _packet(packet) {
            var encodedPackets = this.encoder.encode(packet);
            for (var i = 0; i < encodedPackets.length; i++) {
                this.engine.write(encodedPackets[i], packet.options);
            }
        }
        /**
         * Clean up transport subscriptions and packet buffer.
         *
         * @private
         */

    }, {
        key: "cleanup",
        value: function cleanup() {
            this.subs.forEach(function (subDestroy) {
                return subDestroy();
            });
            this.subs.length = 0;
            this.decoder.destroy();
        }
        /**
         * Close the current socket.
         *
         * @private
         */

    }, {
        key: "_close",
        value: function _close() {
            this.skipReconnect = true;
            this._reconnecting = false;
            this.onclose("forced close");
        }
        /**
         * Alias for close()
         *
         * @private
         */

    }, {
        key: "disconnect",
        value: function disconnect() {
            return this._close();
        }
        /**
         * Called when:
         *
         * - the low-level engine is closed
         * - the parser encountered a badly formatted packet
         * - all sockets are disconnected
         *
         * @private
         */

    }, {
        key: "onclose",
        value: function onclose(reason, description) {
            var _a;
            this.cleanup();
            (_a = this.engine) === null || _a === void 0 ? void 0 : _a.close();
            this.backoff.reset();
            this._readyState = "closed";
            this.emitReserved("close", reason, description);
            if (this._reconnection && !this.skipReconnect) {
                this.reconnect();
            }
        }
        /**
         * Attempt a reconnection.
         *
         * @private
         */

    }, {
        key: "reconnect",
        value: function reconnect() {
            var _this4 = this;

            if (this._reconnecting || this.skipReconnect) return this;
            var self = this;
            if (this.backoff.attempts >= this._reconnectionAttempts) {
                this.backoff.reset();
                this.emitReserved("reconnect_failed");
                this._reconnecting = false;
            } else {
                var delay = this.backoff.duration();
                this._reconnecting = true;
                var timer = this.setTimeoutFn(function () {
                    if (self.skipReconnect) return;
                    _this4.emitReserved("reconnect_attempt", self.backoff.attempts);
                    // check again for the case socket closed in above events
                    if (self.skipReconnect) return;
                    self.open(function (err) {
                        if (err) {
                            self._reconnecting = false;
                            self.reconnect();
                            _this4.emitReserved("reconnect_error", err);
                        } else {
                            self.onreconnect();
                        }
                    });
                }, delay);
                if (this.opts.autoUnref) {
                    timer.unref();
                }
                this.subs.push(function () {
                    _this4.clearTimeoutFn(timer);
                });
            }
        }
        /**
         * Called upon successful reconnect.
         *
         * @private
         */

    }, {
        key: "onreconnect",
        value: function onreconnect() {
            var attempt = this.backoff.attempts;
            this._reconnecting = false;
            this.backoff.reset();
            this.emitReserved("reconnect", attempt);
        }
    }]);

    return Manager;
}(_componentEmitter.Emitter);

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Backoff = Backoff;
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */
function Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */
Backoff.prototype.duration = function () {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */
Backoff.prototype.reset = function () {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */
Backoff.prototype.setMin = function (min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */
Backoff.prototype.setMax = function (max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */
Backoff.prototype.setJitter = function (jitter) {
    this.jitter = jitter;
};

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_notification_history_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a433d0_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_notification_history_vue__ = __webpack_require__(1043);
function injectStyle (ssrContext) {
  __webpack_require__(1041)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65a433d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_notification_history_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a433d0_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_notification_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1042);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("09708aa8", content, true, {});

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "ul li[data-v-65a433d0]{list-style-type:none;padding:0;margin:0}ul[data-v-65a433d0]{padding:0;margin:0}.icon[data-v-65a433d0]{color:#2b6292;font-size:25px}.btn-view i[data-v-65a433d0]{color:#2b6292;font-size:18px}.btn-trash[data-v-65a433d0]{color:#f74040;font-size:18px}.assunto-text[data-v-65a433d0]{color:#2b6292;font-size:15px;font-weight:700;margin-left:25px}", ""]);

// exports


/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important","max-width":"800px !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"max-height":"350px","overflow-y":"auto"}},[_c('span',{staticClass:"text-secondary",staticStyle:{"font-size":"15px","font-weight":"500"}},[_vm._v("Notificações já lidas")]),_vm._v(" "),_vm._l((_vm.notificationList),function(not,index){return _c('ul',{key:index},[_c('li',{staticClass:"card p-3 my-3 shadow-sm flex-row align-items-center justify-content-between"},[_c('div',[_c('i',{staticClass:"fa fa-envelope-open icon"}),_vm._v(" "),_c('span',{staticClass:"assunto-text"},[_c('span',{staticClass:"mr-2"},[_vm._v("#"+_vm._s(not.codnotificacao)+" ")]),_vm._v(_vm._s(not.assunto))])]),_vm._v(" "),_c('div',{staticClass:"position-absolute mt-2",staticStyle:{"top":"0","right":"30%"}},[_c('small',{staticClass:"text-secondary",staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm._f("formatDataHora")(not.data)))])]),_vm._v(" "),_c('div',{staticClass:"align-self-end"},[_c('button',{staticClass:"btn btn-view",attrs:{"data-toggle":"tooltip","title":"Visualizar"},on:{"click":function($event){return _vm.handleViewNotification(not)}}},[_c('i',{staticClass:"fa fa-eye"})])])])])})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{ref:"btnClose",staticClass:"btn btn-secondary btn-sm",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" Fechar ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"def-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(" Histórico de Notificações ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1045);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("f34d254e", content, true, {});

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".step-wrapper{flex-direction:column}.circle,.step-wrapper{display:flex;align-items:center}.circle{width:30px;height:30px;border-radius:50%;background-color:#ccc;color:#fff;justify-content:center;font-weight:700}.circle.active{background-color:#174b79}.line{width:18rem;height:4px;background-color:#ccc;margin:13px 5px 0}.label{margin-top:6px;font-size:.75rem;text-align:center;color:#555;max-width:60px}", ""]);

// exports


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1047);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("261afdef", content, true, {});

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".container h5{text-transform:uppercase}.text-editor{margin-left:.1rem}", ""]);

// exports


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cidades = undefined;

var cidades = exports.cidades = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(store, codmun, responseCallback) {
    var params, path, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = { id: codmun };
            path = (0, _apiFunctions.urlORDS)(store, 'nfse/cidade/', params);
            _context.next = 4;
            return (0, _apiFunctions.apiORDS)(path);

          case 4:
            response = _context.sent;

            if (response.data) {
              if (response.data.errmessages) {
                this.$erpToastError(response.data.errmessages[0]);
                this.errmessages = {};
                this.errmessages.errmessages = response.data.errmessages;
              } else {
                if (response.data > 0) {
                  // this.$erpToastSuccess('Nota fiscal autorizada')
                } else {
                  this.$erpToastError(response.data.xmotivo);
                }
              }
            }
            console.log(response);
            if (responseCallback) {
              responseCallback(response);
            }

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function cidades(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var _apiFunctions = __webpack_require__(5);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_layout_etiqueta_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ca1cfd4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_layout_etiqueta_vue__ = __webpack_require__(1055);
function injectStyle (ssrContext) {
  __webpack_require__(1050)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_layout_etiqueta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ca1cfd4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_layout_etiqueta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1051);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3cfa21af", content, true, {});

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#dpi{height:1in;left:-100%;position:absolute;top:-100%;width:1in}.drop-zone{background-color:#eee;margin-bottom:10px}.drag-el{background-color:#add8e6;margin-bottom:10px;padding:5px}.layout-etiqueta{margin:10px;min-height:200px}.caixa-layout-etiqueta{background-size:20px 20px;background-image:repeating-linear-gradient(90deg,transparent 1px,transparent 39px,rgba(0,0,0,.3) 40px,rgba(0,0,0,.3) 0),repeating-linear-gradient(180deg,transparent 1px,transparent 39px,rgba(0,0,0,.3) 40px,rgba(0,0,0,.3) 0);border-bottom:1px solid rgba(0,0,0,.15);border-right:1px solid rgba(0,0,0,.15)}.caixa-layout-etiqueta,.pagina{overflow:auto;padding:10px;width:100%;height:100%}.pagina{border:1px solid rgba(0,0,0,.15)}.btn-style-font{padding:4px 7px;border-radius:5px}.btn-style-font:hover{background:#d8d6d6;transition:.3s}.btn-style-font:focus{outline:none}.btn-style-font-selected{padding:4px 7px;border-radius:5px;background:#d8d6d6}", ""]);

// exports


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (t, e) {
  "object" === ( false ? "undefined" : _typeof(exports)) && "object" === ( false ? "undefined" : _typeof(module)) ? module.exports = e() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" === (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["VueDraggableResizable"] = e() : t["VueDraggableResizable"] = e();
})("undefined" !== typeof self ? self : undefined, function () {
  return function (t) {
    var e = {};function n(i) {
      if (e[i]) return e[i].exports;var r = e[i] = { i: i, l: !1, exports: {} };return t[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }return n.m = t, n.c = e, n.d = function (t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: i });
    }, n.r = function (t) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;if (4 & e && "object" === (typeof t === "undefined" ? "undefined" : _typeof(t)) && t && t.__esModule) return t;var i = Object.create(null);if (n.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t) for (var r in t) {
        n.d(i, r, function (e) {
          return t[e];
        }.bind(null, r));
      }return i;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = "fb15");
  }({ "0029": function _(t, e) {
      t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    }, "0185": function _(t, e, n) {
      var i = n("e5fa");t.exports = function (t) {
        return Object(i(t));
      };
    }, "01f9": function f9(t, e, n) {
      "use strict";
      var i = n("2d00"),
          r = n("5ca1"),
          o = n("2aba"),
          a = n("32e9"),
          c = n("84f2"),
          u = n("41a0"),
          s = n("7f20"),
          f = n("38fd"),
          h = n("2b4c")("iterator"),
          l = !([].keys && "next" in [].keys()),
          d = "@@iterator",
          p = "keys",
          m = "values",
          g = function g() {
        return this;
      };t.exports = function (t, e, n, v, b, y, x) {
        u(n, e, v);var w,
            S,
            _,
            O = function O(t) {
          if (!l && t in L) return L[t];switch (t) {case p:
              return function () {
                return new n(this, t);
              };case m:
              return function () {
                return new n(this, t);
              };}return function () {
            return new n(this, t);
          };
        },
            E = e + " Iterator",
            T = b == m,
            P = !1,
            L = t.prototype,
            M = L[h] || L[d] || b && L[b],
            R = M || O(b),
            j = b ? T ? O("entries") : R : void 0,
            A = "Array" == e && L.entries || M;if (A && (_ = f(A.call(new t())), _ !== Object.prototype && _.next && (s(_, E, !0), i || "function" == typeof _[h] || a(_, h, g))), T && M && M.name !== m && (P = !0, R = function R() {
          return M.call(this);
        }), i && !x || !l && !P && L[h] || a(L, h, R), c[e] = R, c[E] = g, b) if (w = { values: T ? R : O(m), keys: y ? R : O(p), entries: j }, x) for (S in w) {
          S in L || o(L, S, w[S]);
        } else r(r.P + r.F * (l || P), e, w);return w;
      };
    }, "02f4": function f4(t, e, n) {
      var i = n("4588"),
          r = n("be13");t.exports = function (t) {
        return function (e, n) {
          var o,
              a,
              c = String(r(e)),
              u = i(n),
              s = c.length;return u < 0 || u >= s ? t ? "" : void 0 : (o = c.charCodeAt(u), o < 55296 || o > 56319 || u + 1 === s || (a = c.charCodeAt(u + 1)) < 56320 || a > 57343 ? t ? c.charAt(u) : o : t ? c.slice(u, u + 2) : a - 56320 + (o - 55296 << 10) + 65536);
        };
      };
    }, "0a49": function a49(t, e, n) {
      var i = n("9b43"),
          r = n("626a"),
          o = n("4bf8"),
          a = n("9def"),
          c = n("cd1c");t.exports = function (t, e) {
        var n = 1 == t,
            u = 2 == t,
            s = 3 == t,
            f = 4 == t,
            h = 6 == t,
            l = 5 == t || h,
            d = e || c;return function (e, c, p) {
          for (var m, g, v = o(e), b = r(v), y = i(c, p, 3), x = a(b.length), w = 0, S = n ? d(e, x) : u ? d(e, 0) : void 0; x > w; w++) {
            if ((l || w in b) && (m = b[w], g = y(m, w, v), t)) if (n) S[w] = g;else if (g) switch (t) {case 3:
                return !0;case 5:
                return m;case 6:
                return w;case 2:
                S.push(m);} else if (f) return !1;
          }return h ? -1 : s || f ? f : S;
        };
      };
    }, "0a91": function a91(t, e, n) {
      n("b42c"), n("93c4"), t.exports = n("b77f");
    }, "0bfb": function bfb(t, e, n) {
      "use strict";
      var i = n("cb7c");t.exports = function () {
        var t = i(this),
            e = "";return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
      };
    }, "0d58": function d58(t, e, n) {
      var i = n("ce10"),
          r = n("e11e");t.exports = Object.keys || function (t) {
        return i(t, r);
      };
    }, "0f89": function f89(t, e, n) {
      var i = n("6f8a");t.exports = function (t) {
        if (!i(t)) throw TypeError(t + " is not an object!");return t;
      };
    }, "103a": function a(t, e, n) {
      var i = n("da3c").document;t.exports = i && i.documentElement;
    }, 1169: function _(t, e, n) {
      var i = n("2d95");t.exports = Array.isArray || function (t) {
        return "Array" == i(t);
      };
    }, "11e9": function e9(t, e, n) {
      var i = n("52a7"),
          r = n("4630"),
          o = n("6821"),
          a = n("6a99"),
          c = n("69a8"),
          u = n("c69a"),
          s = Object.getOwnPropertyDescriptor;e.f = n("9e1e") ? s : function (t, e) {
        if (t = o(t), e = a(e, !0), u) try {
          return s(t, e);
        } catch (n) {}if (c(t, e)) return r(!i.f.call(t, e), t[e]);
      };
    }, "12fd": function fd(t, e, n) {
      var i = n("6f8a"),
          r = n("da3c").document,
          o = i(r) && i(r.createElement);t.exports = function (t) {
        return o ? r.createElement(t) : {};
      };
    }, 1495: function _(t, e, n) {
      var i = n("86cc"),
          r = n("cb7c"),
          o = n("0d58");t.exports = n("9e1e") ? Object.defineProperties : function (t, e) {
        r(t);var n,
            a = o(e),
            c = a.length,
            u = 0;while (c > u) {
          i.f(t, n = a[u++], e[n]);
        }return t;
      };
    }, 1938: function _(t, e, n) {
      var i = n("d13f");i(i.S, "Array", { isArray: n("b5aa") });
    }, "1b55": function b55(t, e, n) {
      var i = n("7772")("wks"),
          r = n("7b00"),
          o = n("da3c").Symbol,
          a = "function" == typeof o,
          c = t.exports = function (t) {
        return i[t] || (i[t] = a && o[t] || (a ? o : r)("Symbol." + t));
      };c.store = i;
    }, "1b8f": function b8f(t, e, n) {
      var i = n("a812"),
          r = Math.max,
          o = Math.min;t.exports = function (t, e) {
        return t = i(t), t < 0 ? r(t + e, 0) : o(t, e);
      };
    }, "1c01": function c01(t, e, n) {
      var i = n("5ca1");i(i.S + i.F * !n("9e1e"), "Object", { defineProperty: n("86cc").f });
    }, "1fa8": function fa8(t, e, n) {
      var i = n("cb7c");t.exports = function (t, e, n, r) {
        try {
          return r ? e(i(n)[0], n[1]) : e(n);
        } catch (a) {
          var o = t["return"];throw void 0 !== o && i(o.call(t)), a;
        }
      };
    }, "230e": function e(t, _e, n) {
      var i = n("d3f4"),
          r = n("7726").document,
          o = i(r) && i(r.createElement);t.exports = function (t) {
        return o ? r.createElement(t) : {};
      };
    }, 2312: function _(t, e, n) {
      t.exports = n("8ce0");
    }, "23c6": function c6(t, e, n) {
      var i = n("2d95"),
          r = n("2b4c")("toStringTag"),
          o = "Arguments" == i(function () {
        return arguments;
      }()),
          a = function a(t, e) {
        try {
          return t[e];
        } catch (n) {}
      };t.exports = function (t) {
        var e, n, c;return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = a(e = Object(t), r)) ? n : o ? i(e) : "Object" == (c = i(e)) && "function" == typeof e.callee ? "Arguments" : c;
      };
    }, 2418: function _(t, e, n) {
      var i = n("6a9b"),
          r = n("a5ab"),
          o = n("1b8f");t.exports = function (t) {
        return function (e, n, a) {
          var c,
              u = i(e),
              s = r(u.length),
              f = o(a, s);if (t && n != n) {
            while (s > f) {
              if (c = u[f++], c != c) return !0;
            }
          } else for (; s > f; f++) {
            if ((t || f in u) && u[f] === n) return t || f || 0;
          }return !t && -1;
        };
      };
    }, "245b": function b(t, e) {
      t.exports = function (t, e) {
        return { value: e, done: !!t };
      };
    }, 2621: function _(t, e) {
      e.f = Object.getOwnPropertySymbols;
    }, 2695: function _(t, e, n) {
      var i = n("43c8"),
          r = n("6a9b"),
          o = n("2418")(!1),
          a = n("5d8f")("IE_PROTO");t.exports = function (t, e) {
        var n,
            c = r(t),
            u = 0,
            s = [];for (n in c) {
          n != a && i(c, n) && s.push(n);
        }while (e.length > u) {
          i(c, n = e[u++]) && (~o(s, n) || s.push(n));
        }return s;
      };
    }, "27ee": function ee(t, e, n) {
      var i = n("23c6"),
          r = n("2b4c")("iterator"),
          o = n("84f2");t.exports = n("8378").getIteratorMethod = function (t) {
        if (void 0 != t) return t[r] || t["@@iterator"] || o[i(t)];
      };
    }, "2a4e": function a4e(t, e, n) {
      var i = n("a812"),
          r = n("e5fa");t.exports = function (t) {
        return function (e, n) {
          var o,
              a,
              c = String(r(e)),
              u = i(n),
              s = c.length;return u < 0 || u >= s ? t ? "" : void 0 : (o = c.charCodeAt(u), o < 55296 || o > 56319 || u + 1 === s || (a = c.charCodeAt(u + 1)) < 56320 || a > 57343 ? t ? c.charAt(u) : o : t ? c.slice(u, u + 2) : a - 56320 + (o - 55296 << 10) + 65536);
        };
      };
    }, "2aba": function aba(t, e, n) {
      var i = n("7726"),
          r = n("32e9"),
          o = n("69a8"),
          a = n("ca5a")("src"),
          c = "toString",
          u = Function[c],
          s = ("" + u).split(c);n("8378").inspectSource = function (t) {
        return u.call(t);
      }, (t.exports = function (t, e, n, c) {
        var u = "function" == typeof n;u && (o(n, "name") || r(n, "name", e)), t[e] !== n && (u && (o(n, a) || r(n, a, t[e] ? "" + t[e] : s.join(String(e)))), t === i ? t[e] = n : c ? t[e] ? t[e] = n : r(t, e, n) : (delete t[e], r(t, e, n)));
      })(Function.prototype, c, function () {
        return "function" == typeof this && this[a] || u.call(this);
      });
    }, "2aeb": function aeb(t, e, n) {
      var i = n("cb7c"),
          r = n("1495"),
          o = n("e11e"),
          a = n("613b")("IE_PROTO"),
          c = function c() {},
          u = "prototype",
          _s = function s() {
        var t,
            e = n("230e")("iframe"),
            i = o.length,
            r = "<",
            a = ">";e.style.display = "none", n("fab2").appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write(r + "script" + a + "document.F=Object" + r + "/script" + a), t.close(), _s = t.F;while (i--) {
          delete _s[u][o[i]];
        }return _s();
      };t.exports = Object.create || function (t, e) {
        var n;return null !== t ? (c[u] = i(t), n = new c(), c[u] = null, n[a] = t) : n = _s(), void 0 === e ? n : r(n, e);
      };
    }, "2b4c": function b4c(t, e, n) {
      var i = n("5537")("wks"),
          r = n("ca5a"),
          o = n("7726").Symbol,
          a = "function" == typeof o,
          c = t.exports = function (t) {
        return i[t] || (i[t] = a && o[t] || (a ? o : r)("Symbol." + t));
      };c.store = i;
    }, "2d00": function d00(t, e) {
      t.exports = !1;
    }, "2d95": function d95(t, e) {
      var n = {}.toString;t.exports = function (t) {
        return n.call(t).slice(8, -1);
      };
    }, "2ea1": function ea1(t, e, n) {
      var i = n("6f8a");t.exports = function (t, e) {
        if (!i(t)) return t;var n, r;if (e && "function" == typeof (n = t.toString) && !i(r = n.call(t))) return r;if ("function" == typeof (n = t.valueOf) && !i(r = n.call(t))) return r;if (!e && "function" == typeof (n = t.toString) && !i(r = n.call(t))) return r;throw TypeError("Can't convert object to primitive value");
      };
    }, "2f21": function f21(t, e, n) {
      "use strict";
      var i = n("79e5");t.exports = function (t, e) {
        return !!t && i(function () {
          e ? t.call(null, function () {}, 1) : t.call(null);
        });
      };
    }, "2fdb": function fdb(t, e, n) {
      "use strict";
      var i = n("5ca1"),
          r = n("d2c8"),
          o = "includes";i(i.P + i.F * n("5147")(o), "String", { includes: function includes(t) {
          return !!~r(this, t, o).indexOf(t, arguments.length > 1 ? arguments[1] : void 0);
        } });
    }, "32e9": function e9(t, e, n) {
      var i = n("86cc"),
          r = n("4630");t.exports = n("9e1e") ? function (t, e, n) {
        return i.f(t, e, r(1, n));
      } : function (t, e, n) {
        return t[e] = n, t;
      };
    }, "33a4": function a4(t, e, n) {
      var i = n("84f2"),
          r = n("2b4c")("iterator"),
          o = Array.prototype;t.exports = function (t) {
        return void 0 !== t && (i.Array === t || o[r] === t);
      };
    }, 3425: function _(t, e, n) {
      "use strict";
      var i = function i() {
        var t,
            e = this,
            n = e.$createElement,
            i = e._self._c || n;return i("div", { class: [(t = {}, t[e.classNameActive] = e.enabled, t[e.classNameDragging] = e.dragging, t[e.classNameResizing] = e.resizing, t[e.classNameDraggable] = e.draggable, t[e.classNameResizable] = e.resizable, t), e.className], style: e.style, on: { mousedown: e.elementMouseDown, touchstart: e.elementTouchDown } }, [e._l(e.actualHandles, function (t) {
          return i("div", { key: t, class: [e.classNameHandle, e.classNameHandle + "-" + t], style: { display: e.enabled ? "block" : "none" }, on: { mousedown: function mousedown(n) {
                n.stopPropagation(), n.preventDefault(), e.handleDown(t, n);
              }, touchstart: function touchstart(n) {
                n.stopPropagation(), n.preventDefault(), e.handleTouchDown(t, n);
              } } }, [e._t(t)], 2);
        }), e._v(" "), e._t("default")], 2);
      },
          r = [],
          o = (n("1c01"), n("58b2"), n("8e6e"), n("f3e2"), n("456d"), n("85f2")),
          a = n.n(o);function c(t, e, n) {
        return e in t ? a()(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
      }n("3b2b");var u = n("a745"),
          s = n.n(u);function f(t) {
        if (s()(t)) return t;
      }var h = n("5d73"),
          l = n.n(h),
          d = n("c8bb"),
          p = n.n(d);function m(t, e) {
        if (p()(Object(t)) || "[object Arguments]" === Object.prototype.toString.call(t)) {
          var n = [],
              i = !0,
              r = !1,
              o = void 0;try {
            for (var a, c = l()(t); !(i = (a = c.next()).done); i = !0) {
              if (n.push(a.value), e && n.length === e) break;
            }
          } catch (u) {
            r = !0, o = u;
          } finally {
            try {
              i || null == c["return"] || c["return"]();
            } finally {
              if (r) throw o;
            }
          }return n;
        }
      }function g() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }function v(t, e) {
        return f(t) || m(t, e) || g();
      }n("6762"), n("2fdb"), n("d25f"), n("ac6a"), n("cadf"), n("5df3"), n("4f7f"), n("c5f6"), n("7514"), n("6b54"), n("87b3");function b(t) {
        return "function" === typeof t || "[object Function]" === Object.prototype.toString.call(t);
      }function y(t, e, n) {
        var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1,
            r = "number" === typeof i ? [i, i] : i,
            o = v(r, 2),
            a = o[0],
            c = o[1],
            u = Math.round(e / a / t[0]) * t[0],
            s = Math.round(n / c / t[1]) * t[1];return [u, s];
      }function x(t, e, n) {
        return t - e - n;
      }function w(t, e, n) {
        return t - e - n;
      }function S(t, e, n) {
        return null !== e && t < e ? e : null !== n && n < t ? n : t;
      }function _(t, e, n) {
        var i = t,
            r = ["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"].find(function (t) {
          return b(i[t]);
        });if (!b(i[r])) return !1;do {
          if (i[r](e)) return !0;if (i === n) return !1;i = i.parentNode;
        } while (i);return !1;
      }function O(t) {
        var e = window.getComputedStyle(t);return [parseFloat(e.getPropertyValue("width"), 10), parseFloat(e.getPropertyValue("height"), 10)];
      }function E(t, e, n) {
        t && (t.attachEvent ? t.attachEvent("on" + e, n) : t.addEventListener ? t.addEventListener(e, n, !0) : t["on" + e] = n);
      }function T(t, e, n) {
        t && (t.detachEvent ? t.detachEvent("on" + e, n) : t.removeEventListener ? t.removeEventListener(e, n, !0) : t["on" + e] = null);
      }function P(t, e) {
        var n = Object.keys(t);if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }return n;
      }function L(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};e % 2 ? P(n, !0).forEach(function (e) {
            c(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : P(n).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }return t;
      }var M = { mouse: { start: "mousedown", move: "mousemove", stop: "mouseup" }, touch: { start: "touchstart", move: "touchmove", stop: "touchend" } },
          R = { userSelect: "none", MozUserSelect: "none", WebkitUserSelect: "none", MsUserSelect: "none" },
          j = { userSelect: "auto", MozUserSelect: "auto", WebkitUserSelect: "auto", MsUserSelect: "auto" },
          A = M.mouse,
          k = { replace: !0, name: "vue-draggable-resizable", props: { className: { type: String, default: "vdr" }, classNameDraggable: { type: String, default: "draggable" }, classNameResizable: { type: String, default: "resizable" }, classNameDragging: { type: String, default: "dragging" }, classNameResizing: { type: String, default: "resizing" }, classNameActive: { type: String, default: "active" }, classNameHandle: { type: String, default: "handle" }, disableUserSelect: { type: Boolean, default: !0 }, enableNativeDrag: { type: Boolean, default: !1 }, preventDeactivation: { type: Boolean, default: !1 }, active: { type: Boolean, default: !1 }, draggable: { type: Boolean, default: !0 }, resizable: { type: Boolean, default: !0 }, lockAspectRatio: { type: Boolean, default: !1 }, w: { type: [Number, String], default: 200, validator: function validator(t) {
              return "number" === typeof t ? t > 0 : "auto" === t;
            } }, h: { type: [Number, String], default: 200, validator: function validator(t) {
              return "number" === typeof t ? t > 0 : "auto" === t;
            } }, minWidth: { type: Number, default: 0, validator: function validator(t) {
              return t >= 0;
            } }, minHeight: { type: Number, default: 0, validator: function validator(t) {
              return t >= 0;
            } }, maxWidth: { type: Number, default: null, validator: function validator(t) {
              return t >= 0;
            } }, maxHeight: { type: Number, default: null, validator: function validator(t) {
              return t >= 0;
            } }, x: { type: Number, default: 0 }, y: { type: Number, default: 0 }, z: { type: [String, Number], default: "auto", validator: function validator(t) {
              return "string" === typeof t ? "auto" === t : t >= 0;
            } }, handles: { type: Array, default: function _default() {
              return ["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"];
            }, validator: function validator(t) {
              var e = new Set(["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"]);return new Set(t.filter(function (t) {
                return e.has(t);
              })).size === t.length;
            } }, dragHandle: { type: String, default: null }, dragCancel: { type: String, default: null }, axis: { type: String, default: "both", validator: function validator(t) {
              return ["x", "y", "both"].includes(t);
            } }, grid: { type: Array, default: function _default() {
              return [1, 1];
            } }, parent: { type: Boolean, default: !1 }, scale: { type: [Number, Array], default: 1, validator: function validator(t) {
              return "number" === typeof t ? t > 0 : 2 === t.length && t[0] > 0 && t[1] > 0;
            } }, onDragStart: { type: Function, default: function _default() {
              return !0;
            } }, onDrag: { type: Function, default: function _default() {
              return !0;
            } }, onResizeStart: { type: Function, default: function _default() {
              return !0;
            } }, onResize: { type: Function, default: function _default() {
              return !0;
            } } }, data: function data() {
          return { left: this.x, top: this.y, right: null, bottom: null, width: null, height: null, widthTouched: !1, heightTouched: !1, aspectFactor: null, parentWidth: null, parentHeight: null, minW: this.minWidth, minH: this.minHeight, maxW: this.maxWidth, maxH: this.maxHeight, handle: null, enabled: this.active, resizing: !1, dragging: !1, dragEnable: !1, resizeEnable: !1, zIndex: this.z };
        }, created: function created() {
          this.maxWidth && this.minWidth > this.maxWidth && console.warn("[Vdr warn]: Invalid prop: minWidth cannot be greater than maxWidth"), this.maxWidth && this.minHeight > this.maxHeight && console.warn("[Vdr warn]: Invalid prop: minHeight cannot be greater than maxHeight"), this.resetBoundsAndMouseState();
        }, mounted: function mounted() {
          this.enableNativeDrag || (this.$el.ondragstart = function () {
            return !1;
          });var t = this.getParentSize(),
              e = v(t, 2),
              n = e[0],
              i = e[1];this.parentWidth = n, this.parentHeight = i;var r = O(this.$el),
              o = v(r, 2),
              a = o[0],
              c = o[1];this.aspectFactor = ("auto" !== this.w ? this.w : a) / ("auto" !== this.h ? this.h : c), this.width = "auto" !== this.w ? this.w : a, this.height = "auto" !== this.h ? this.h : c, this.right = this.parentWidth - this.width - this.left, this.bottom = this.parentHeight - this.height - this.top, this.active && this.$emit("activated"), E(document.documentElement, "mousedown", this.deselect), E(document.documentElement, "touchend touchcancel", this.deselect), E(window, "resize", this.checkParentSize);
        }, beforeDestroy: function beforeDestroy() {
          T(document.documentElement, "mousedown", this.deselect), T(document.documentElement, "touchstart", this.handleUp), T(document.documentElement, "mousemove", this.move), T(document.documentElement, "touchmove", this.move), T(document.documentElement, "mouseup", this.handleUp), T(document.documentElement, "touchend touchcancel", this.deselect), T(window, "resize", this.checkParentSize);
        }, methods: { resetBoundsAndMouseState: function resetBoundsAndMouseState() {
            this.mouseClickPosition = { mouseX: 0, mouseY: 0, x: 0, y: 0, w: 0, h: 0 }, this.bounds = { minLeft: null, maxLeft: null, minRight: null, maxRight: null, minTop: null, maxTop: null, minBottom: null, maxBottom: null };
          }, checkParentSize: function checkParentSize() {
            if (this.parent) {
              var t = this.getParentSize(),
                  e = v(t, 2),
                  n = e[0],
                  i = e[1];this.parentWidth = n, this.parentHeight = i, this.right = this.parentWidth - this.width - this.left, this.bottom = this.parentHeight - this.height - this.top;
            }
          }, getParentSize: function getParentSize() {
            if (this.parent) {
              var t = window.getComputedStyle(this.$el.parentNode, null);return [parseInt(t.getPropertyValue("width"), 10), parseInt(t.getPropertyValue("height"), 10)];
            }return [null, null];
          }, elementTouchDown: function elementTouchDown(t) {
            A = M.touch, this.elementDown(t);
          }, elementMouseDown: function elementMouseDown(t) {
            A = M.mouse, this.elementDown(t);
          }, elementDown: function elementDown(t) {
            if (!(t instanceof MouseEvent && 1 !== t.which)) {
              var e = t.target || t.srcElement;if (this.$el.contains(e)) {
                if (!1 === this.onDragStart(t)) return;if (this.dragHandle && !_(e, this.dragHandle, this.$el) || this.dragCancel && _(e, this.dragCancel, this.$el)) return void (this.dragging = !1);this.enabled || (this.enabled = !0, this.$emit("activated"), this.$emit("update:active", !0)), this.draggable && (this.dragEnable = !0), this.mouseClickPosition.mouseX = t.touches ? t.touches[0].pageX : t.pageX, this.mouseClickPosition.mouseY = t.touches ? t.touches[0].pageY : t.pageY, this.mouseClickPosition.left = this.left, this.mouseClickPosition.right = this.right, this.mouseClickPosition.top = this.top, this.mouseClickPosition.bottom = this.bottom, this.parent && (this.bounds = this.calcDragLimits()), E(document.documentElement, A.move, this.move), E(document.documentElement, A.stop, this.handleUp);
              }
            }
          }, calcDragLimits: function calcDragLimits() {
            return { minLeft: this.left % this.grid[0], maxLeft: Math.floor((this.parentWidth - this.width - this.left) / this.grid[0]) * this.grid[0] + this.left, minRight: this.right % this.grid[0], maxRight: Math.floor((this.parentWidth - this.width - this.right) / this.grid[0]) * this.grid[0] + this.right, minTop: this.top % this.grid[1], maxTop: Math.floor((this.parentHeight - this.height - this.top) / this.grid[1]) * this.grid[1] + this.top, minBottom: this.bottom % this.grid[1], maxBottom: Math.floor((this.parentHeight - this.height - this.bottom) / this.grid[1]) * this.grid[1] + this.bottom };
          }, deselect: function deselect(t) {
            var e = t.target || t.srcElement,
                n = new RegExp(this.className + "-([trmbl]{2})", "");this.$el.contains(e) || n.test(e.className) || (this.enabled && !this.preventDeactivation && (this.enabled = !1, this.$emit("deactivated"), this.$emit("update:active", !1)), T(document.documentElement, A.move, this.handleResize)), this.resetBoundsAndMouseState();
          }, handleTouchDown: function handleTouchDown(t, e) {
            A = M.touch, this.handleDown(t, e);
          }, handleDown: function handleDown(t, e) {
            e instanceof MouseEvent && 1 !== e.which || !1 !== this.onResizeStart(t, e) && (e.stopPropagation && e.stopPropagation(), this.lockAspectRatio && !t.includes("m") ? this.handle = "m" + t.substring(1) : this.handle = t, this.resizeEnable = !0, this.mouseClickPosition.mouseX = e.touches ? e.touches[0].pageX : e.pageX, this.mouseClickPosition.mouseY = e.touches ? e.touches[0].pageY : e.pageY, this.mouseClickPosition.left = this.left, this.mouseClickPosition.right = this.right, this.mouseClickPosition.top = this.top, this.mouseClickPosition.bottom = this.bottom, this.bounds = this.calcResizeLimits(), E(document.documentElement, A.move, this.handleResize), E(document.documentElement, A.stop, this.handleUp));
          }, calcResizeLimits: function calcResizeLimits() {
            var t = this.minW,
                e = this.minH,
                n = this.maxW,
                i = this.maxH,
                r = this.aspectFactor,
                o = v(this.grid, 2),
                a = o[0],
                c = o[1],
                u = this.width,
                s = this.height,
                f = this.left,
                h = this.top,
                l = this.right,
                d = this.bottom;this.lockAspectRatio && (t / e > r ? e = t / r : t = r * e, n && i ? (n = Math.min(n, r * i), i = Math.min(i, n / r)) : n ? i = n / r : i && (n = r * i)), n -= n % a, i -= i % c;var p = { minLeft: null, maxLeft: null, minTop: null, maxTop: null, minRight: null, maxRight: null, minBottom: null, maxBottom: null };return this.parent ? (p.minLeft = f % a, p.maxLeft = f + Math.floor((u - t) / a) * a, p.minTop = h % c, p.maxTop = h + Math.floor((s - e) / c) * c, p.minRight = l % a, p.maxRight = l + Math.floor((u - t) / a) * a, p.minBottom = d % c, p.maxBottom = d + Math.floor((s - e) / c) * c, n && (p.minLeft = Math.max(p.minLeft, this.parentWidth - l - n), p.minRight = Math.max(p.minRight, this.parentWidth - f - n)), i && (p.minTop = Math.max(p.minTop, this.parentHeight - d - i), p.minBottom = Math.max(p.minBottom, this.parentHeight - h - i)), this.lockAspectRatio && (p.minLeft = Math.max(p.minLeft, f - h * r), p.minTop = Math.max(p.minTop, h - f / r), p.minRight = Math.max(p.minRight, l - d * r), p.minBottom = Math.max(p.minBottom, d - l / r))) : (p.minLeft = null, p.maxLeft = f + Math.floor((u - t) / a) * a, p.minTop = null, p.maxTop = h + Math.floor((s - e) / c) * c, p.minRight = null, p.maxRight = l + Math.floor((u - t) / a) * a, p.minBottom = null, p.maxBottom = d + Math.floor((s - e) / c) * c, n && (p.minLeft = -(l + n), p.minRight = -(f + n)), i && (p.minTop = -(d + i), p.minBottom = -(h + i)), this.lockAspectRatio && n && i && (p.minLeft = Math.min(p.minLeft, -(l + n)), p.minTop = Math.min(p.minTop, -(i + d)), p.minRight = Math.min(p.minRight, -f - n), p.minBottom = Math.min(p.minBottom, -h - i))), p;
          }, move: function move(t) {
            this.resizing ? this.handleResize(t) : this.dragEnable && this.handleDrag(t);
          }, handleDrag: function handleDrag(t) {
            var e = this.axis,
                n = this.grid,
                i = this.bounds,
                r = this.mouseClickPosition,
                o = e && "y" !== e ? r.mouseX - (t.touches ? t.touches[0].pageX : t.pageX) : 0,
                a = e && "x" !== e ? r.mouseY - (t.touches ? t.touches[0].pageY : t.pageY) : 0,
                c = y(n, o, a, this.scale),
                u = v(c, 2),
                s = u[0],
                f = u[1],
                h = S(r.left - s, i.minLeft, i.maxLeft),
                l = S(r.top - f, i.minTop, i.maxTop);if (!1 !== this.onDrag(h, l)) {
              var d = S(r.right + s, i.minRight, i.maxRight),
                  p = S(r.bottom + f, i.minBottom, i.maxBottom);this.left = h, this.top = l, this.right = d, this.bottom = p, this.$emit("dragging", this.left, this.top), this.dragging = !0;
            }
          }, moveHorizontally: function moveHorizontally(t) {
            var e = y(this.grid, t, this.top, 1),
                n = v(e, 2),
                i = n[0],
                r = (n[1], S(i, this.bounds.minLeft, this.bounds.maxLeft));this.left = r, this.right = this.parentWidth - this.width - r;
          }, moveVertically: function moveVertically(t) {
            var e = y(this.grid, this.left, t, 1),
                n = v(e, 2),
                i = (n[0], n[1]),
                r = S(i, this.bounds.minTop, this.bounds.maxTop);this.top = r, this.bottom = this.parentHeight - this.height - r;
          }, handleResize: function handleResize(t) {
            var e = this.left,
                n = this.top,
                i = this.right,
                r = this.bottom,
                o = this.mouseClickPosition,
                a = (this.lockAspectRatio, this.aspectFactor),
                c = o.mouseX - (t.touches ? t.touches[0].pageX : t.pageX),
                u = o.mouseY - (t.touches ? t.touches[0].pageY : t.pageY);!this.widthTouched && c && (this.widthTouched = !0), !this.heightTouched && u && (this.heightTouched = !0);var s = y(this.grid, c, u, this.scale),
                f = v(s, 2),
                h = f[0],
                l = f[1];this.handle.includes("b") ? (r = S(o.bottom + l, this.bounds.minBottom, this.bounds.maxBottom), this.lockAspectRatio && this.resizingOnY && (i = this.right - (this.bottom - r) * a)) : this.handle.includes("t") && (n = S(o.top - l, this.bounds.minTop, this.bounds.maxTop), this.lockAspectRatio && this.resizingOnY && (e = this.left - (this.top - n) * a)), this.handle.includes("r") ? (i = S(o.right + h, this.bounds.minRight, this.bounds.maxRight), this.lockAspectRatio && this.resizingOnX && (r = this.bottom - (this.right - i) / a)) : this.handle.includes("l") && (e = S(o.left - h, this.bounds.minLeft, this.bounds.maxLeft), this.lockAspectRatio && this.resizingOnX && (n = this.top - (this.left - e) / a));var d = x(this.parentWidth, e, i),
                p = w(this.parentHeight, n, r);!1 !== this.onResize(this.handle, e, n, d, p) && (this.left = e, this.top = n, this.right = i, this.bottom = r, this.width = d, this.height = p, this.$emit("resizing", this.left, this.top, this.width, this.height), this.resizing = !0);
          }, changeWidth: function changeWidth(t) {
            var e = y(this.grid, t, 0, 1),
                n = v(e, 2),
                i = n[0],
                r = (n[1], S(this.parentWidth - i - this.left, this.bounds.minRight, this.bounds.maxRight)),
                o = this.bottom;this.lockAspectRatio && (o = this.bottom - (this.right - r) / this.aspectFactor);var a = x(this.parentWidth, this.left, r),
                c = w(this.parentHeight, this.top, o);this.right = r, this.bottom = o, this.width = a, this.height = c;
          }, changeHeight: function changeHeight(t) {
            var e = y(this.grid, 0, t, 1),
                n = v(e, 2),
                i = (n[0], n[1]),
                r = S(this.parentHeight - i - this.top, this.bounds.minBottom, this.bounds.maxBottom),
                o = this.right;this.lockAspectRatio && (o = this.right - (this.bottom - r) * this.aspectFactor);var a = x(this.parentWidth, this.left, o),
                c = w(this.parentHeight, this.top, r);this.right = o, this.bottom = r, this.width = a, this.height = c;
          }, handleUp: function handleUp(t) {
            this.handle = null, this.resetBoundsAndMouseState(), this.dragEnable = !1, this.resizeEnable = !1, this.resizing && (this.resizing = !1, this.$emit("resizestop", this.left, this.top, this.width, this.height)), this.dragging && (this.dragging = !1, this.$emit("dragstop", this.left, this.top)), T(document.documentElement, A.move, this.handleResize);
          } }, computed: { style: function style() {
            return L({ transform: "translate(".concat(this.left, "px, ").concat(this.top, "px)"), width: this.computedWidth, height: this.computedHeight, zIndex: this.zIndex }, this.dragging && this.disableUserSelect ? R : j);
          }, actualHandles: function actualHandles() {
            return this.resizable ? this.handles : [];
          }, computedWidth: function computedWidth() {
            return "auto" !== this.w || this.widthTouched ? this.width + "px" : "auto";
          }, computedHeight: function computedHeight() {
            return "auto" !== this.h || this.heightTouched ? this.height + "px" : "auto";
          }, resizingOnX: function resizingOnX() {
            return Boolean(this.handle) && (this.handle.includes("l") || this.handle.includes("r"));
          }, resizingOnY: function resizingOnY() {
            return Boolean(this.handle) && (this.handle.includes("t") || this.handle.includes("b"));
          }, isCornerHandle: function isCornerHandle() {
            return Boolean(this.handle) && ["tl", "tr", "br", "bl"].includes(this.handle);
          } }, watch: { active: function active(t) {
            this.enabled = t, t ? this.$emit("activated") : this.$emit("deactivated");
          }, z: function z(t) {
            (t >= 0 || "auto" === t) && (this.zIndex = t);
          }, x: function x(t) {
            this.resizing || this.dragging || (this.parent && (this.bounds = this.calcDragLimits()), this.moveHorizontally(t));
          }, y: function y(t) {
            this.resizing || this.dragging || (this.parent && (this.bounds = this.calcDragLimits()), this.moveVertically(t));
          }, lockAspectRatio: function lockAspectRatio(t) {
            this.aspectFactor = t ? this.width / this.height : void 0;
          }, minWidth: function minWidth(t) {
            t > 0 && t <= this.width && (this.minW = t);
          }, minHeight: function minHeight(t) {
            t > 0 && t <= this.height && (this.minH = t);
          }, maxWidth: function maxWidth(t) {
            this.maxW = t;
          }, maxHeight: function maxHeight(t) {
            this.maxH = t;
          }, w: function w(t) {
            this.resizing || this.dragging || (this.parent && (this.bounds = this.calcResizeLimits()), this.changeWidth(t));
          }, h: function h(t) {
            this.resizing || this.dragging || (this.parent && (this.bounds = this.calcResizeLimits()), this.changeHeight(t));
          } } },
          z = k;function N(t, e, n, i, r, o, a, c) {
        var u,
            s = "function" === typeof t ? t.options : t;if (e && (s.render = e, s.staticRenderFns = n, s._compiled = !0), i && (s.functional = !0), o && (s._scopeId = "data-v-" + o), a ? (u = function u(t) {
          t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, t || "undefined" === typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), r && r.call(this, t), t && t._registeredComponents && t._registeredComponents.add(a);
        }, s._ssrRegister = u) : r && (u = c ? function () {
          r.call(this, this.$root.$options.shadowRoot);
        } : r), u) if (s.functional) {
          s._injectStyles = u;var f = s.render;s.render = function (t, e) {
            return u.call(e), f(t, e);
          };
        } else {
          var h = s.beforeCreate;s.beforeCreate = h ? [].concat(h, u) : [u];
        }return { exports: t, options: s };
      }var D = N(z, i, r, !1, null, null, null);e["a"] = D.exports;
    }, 3846: function _(t, e, n) {
      n("9e1e") && "g" != /./g.flags && n("86cc").f(RegExp.prototype, "flags", { configurable: !0, get: n("0bfb") });
    }, "38fd": function fd(t, e, n) {
      var i = n("69a8"),
          r = n("4bf8"),
          o = n("613b")("IE_PROTO"),
          a = Object.prototype;t.exports = Object.getPrototypeOf || function (t) {
        return t = r(t), i(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? a : null;
      };
    }, "3adc": function adc(t, e, n) {
      var i = n("0f89"),
          r = n("a47f"),
          o = n("2ea1"),
          a = Object.defineProperty;e.f = n("7d95") ? Object.defineProperty : function (t, e, n) {
        if (i(t), e = o(e, !0), i(n), r) try {
          return a(t, e, n);
        } catch (c) {}if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");return "value" in n && (t[e] = n.value), t;
      };
    }, "3b2b": function b2b(t, e, n) {
      var i = n("7726"),
          r = n("5dbc"),
          o = n("86cc").f,
          a = n("9093").f,
          c = n("aae3"),
          u = n("0bfb"),
          _s2 = i.RegExp,
          f = _s2,
          h = _s2.prototype,
          l = /a/g,
          d = /a/g,
          p = new _s2(l) !== l;if (n("9e1e") && (!p || n("79e5")(function () {
        return d[n("2b4c")("match")] = !1, _s2(l) != l || _s2(d) == d || "/a/i" != _s2(l, "i");
      }))) {
        _s2 = function s(t, e) {
          var n = this instanceof _s2,
              i = c(t),
              o = void 0 === e;return !n && i && t.constructor === _s2 && o ? t : r(p ? new f(i && !o ? t.source : t, e) : f((i = t instanceof _s2) ? t.source : t, i && o ? u.call(t) : e), n ? this : h, _s2);
        };for (var m = function m(t) {
          (t in _s2) || o(_s2, t, { configurable: !0, get: function get() {
              return f[t];
            }, set: function set(e) {
              f[t] = e;
            } });
        }, g = a(f), v = 0; g.length > v;) {
          m(g[v++]);
        }h.constructor = _s2, _s2.prototype = h, n("2aba")(i, "RegExp", _s2);
      }n("7a56")("RegExp");
    }, "41a0": function a0(t, e, n) {
      "use strict";
      var i = n("2aeb"),
          r = n("4630"),
          o = n("7f20"),
          a = {};n("32e9")(a, n("2b4c")("iterator"), function () {
        return this;
      }), t.exports = function (t, e, n) {
        t.prototype = i(a, { next: r(1, n) }), o(t, e + " Iterator");
      };
    }, "43c8": function c8(t, e) {
      var n = {}.hasOwnProperty;t.exports = function (t, e) {
        return n.call(t, e);
      };
    }, "456d": function d(t, e, n) {
      var i = n("4bf8"),
          r = n("0d58");n("5eda")("keys", function () {
        return function (t) {
          return r(i(t));
        };
      });
    }, 4588: function _(t, e) {
      var n = Math.ceil,
          i = Math.floor;t.exports = function (t) {
        return isNaN(t = +t) ? 0 : (t > 0 ? i : n)(t);
      };
    }, 4630: function _(t, e) {
      t.exports = function (t, e) {
        return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e };
      };
    }, "4a59": function a59(t, e, n) {
      var i = n("9b43"),
          r = n("1fa8"),
          o = n("33a4"),
          a = n("cb7c"),
          c = n("9def"),
          u = n("27ee"),
          s = {},
          f = {};e = t.exports = function (t, e, n, h, l) {
        var d,
            p,
            m,
            g,
            v = l ? function () {
          return t;
        } : u(t),
            b = i(n, h, e ? 2 : 1),
            y = 0;if ("function" != typeof v) throw TypeError(t + " is not iterable!");if (o(v)) {
          for (d = c(t.length); d > y; y++) {
            if (g = e ? b(a(p = t[y])[0], p[1]) : b(t[y]), g === s || g === f) return g;
          }
        } else for (m = v.call(t); !(p = m.next()).done;) {
          if (g = r(m, b, p.value, e), g === s || g === f) return g;
        }
      };e.BREAK = s, e.RETURN = f;
    }, "4bf8": function bf8(t, e, n) {
      var i = n("be13");t.exports = function (t) {
        return Object(i(t));
      };
    }, "4f7f": function f7f(t, e, n) {
      "use strict";
      var i = n("c26b"),
          r = n("b39a"),
          o = "Set";t.exports = n("e0b8")(o, function (t) {
        return function () {
          return t(this, arguments.length > 0 ? arguments[0] : void 0);
        };
      }, { add: function add(t) {
          return i.def(r(this, o), t = 0 === t ? 0 : t, t);
        } }, i);
    }, 5147: function _(t, e, n) {
      var i = n("2b4c")("match");t.exports = function (t) {
        var e = /./;try {
          "/./"[t](e);
        } catch (n) {
          try {
            return e[i] = !1, !"/./"[t](e);
          } catch (r) {}
        }return !0;
      };
    }, "52a7": function a7(t, e) {
      e.f = {}.propertyIsEnumerable;
    }, 5537: function _(t, e, n) {
      var i = n("8378"),
          r = n("7726"),
          o = "__core-js_shared__",
          a = r[o] || (r[o] = {});(t.exports = function (t, e) {
        return a[t] || (a[t] = void 0 !== e ? e : {});
      })("versions", []).push({ version: i.version, mode: n("2d00") ? "pure" : "global", copyright: "© 2018 Denis Pushkarev (zloirock.ru)" });
    }, "58b2": function b2(t, e, n) {
      var i = n("5ca1");i(i.S + i.F * !n("9e1e"), "Object", { defineProperties: n("1495") });
    }, "5ca1": function ca1(t, e, n) {
      var i = n("7726"),
          r = n("8378"),
          o = n("32e9"),
          a = n("2aba"),
          c = n("9b43"),
          u = "prototype",
          s = function s(t, e, n) {
        var f,
            h,
            l,
            d,
            p = t & s.F,
            m = t & s.G,
            g = t & s.S,
            v = t & s.P,
            b = t & s.B,
            y = m ? i : g ? i[e] || (i[e] = {}) : (i[e] || {})[u],
            x = m ? r : r[e] || (r[e] = {}),
            w = x[u] || (x[u] = {});for (f in m && (n = e), n) {
          h = !p && y && void 0 !== y[f], l = (h ? y : n)[f], d = b && h ? c(l, i) : v && "function" == typeof l ? c(Function.call, l) : l, y && a(y, f, l, t & s.U), x[f] != l && o(x, f, d), v && w[f] != l && (w[f] = l);
        }
      };i.core = r, s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, s.U = 64, s.R = 128, t.exports = s;
    }, "5cc5": function cc5(t, e, n) {
      var i = n("2b4c")("iterator"),
          r = !1;try {
        var o = [7][i]();o["return"] = function () {
          r = !0;
        }, Array.from(o, function () {
          throw 2;
        });
      } catch (a) {}t.exports = function (t, e) {
        if (!e && !r) return !1;var n = !1;try {
          var o = [7],
              c = o[i]();c.next = function () {
            return { done: n = !0 };
          }, o[i] = function () {
            return c;
          }, t(o);
        } catch (a) {}return n;
      };
    }, "5ce7": function ce7(t, e, n) {
      "use strict";
      var i = n("7108"),
          r = n("f845"),
          o = n("c0d8"),
          a = {};n("8ce0")(a, n("1b55")("iterator"), function () {
        return this;
      }), t.exports = function (t, e, n) {
        t.prototype = i(a, { next: r(1, n) }), o(t, e + " Iterator");
      };
    }, "5d73": function d73(t, e, n) {
      t.exports = n("0a91");
    }, "5d8f": function d8f(t, e, n) {
      var i = n("7772")("keys"),
          r = n("7b00");t.exports = function (t) {
        return i[t] || (i[t] = r(t));
      };
    }, "5dbc": function dbc(t, e, n) {
      var i = n("d3f4"),
          r = n("8b97").set;t.exports = function (t, e, n) {
        var o,
            a = e.constructor;return a !== n && "function" == typeof a && (o = a.prototype) !== n.prototype && i(o) && r && r(t, o), t;
      };
    }, "5df3": function df3(t, e, n) {
      "use strict";
      var i = n("02f4")(!0);n("01f9")(String, "String", function (t) {
        this._t = String(t), this._i = 0;
      }, function () {
        var t,
            e = this._t,
            n = this._i;return n >= e.length ? { value: void 0, done: !0 } : (t = i(e, n), this._i += t.length, { value: t, done: !1 });
      });
    }, "5eda": function eda(t, e, n) {
      var i = n("5ca1"),
          r = n("8378"),
          o = n("79e5");t.exports = function (t, e) {
        var n = (r.Object || {})[t] || Object[t],
            a = {};a[t] = e(n), i(i.S + i.F * o(function () {
          n(1);
        }), "Object", a);
      };
    }, "613b": function b(t, e, n) {
      var i = n("5537")("keys"),
          r = n("ca5a");t.exports = function (t) {
        return i[t] || (i[t] = r(t));
      };
    }, "626a": function a(t, e, n) {
      var i = n("2d95");t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
        return "String" == i(t) ? t.split("") : Object(t);
      };
    }, 6762: function _(t, e, n) {
      "use strict";
      var i = n("5ca1"),
          r = n("c366")(!0);i(i.P, "Array", { includes: function includes(t) {
          return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
        } }), n("9c6c")("includes");
    }, "67ab": function ab(t, e, n) {
      var i = n("ca5a")("meta"),
          r = n("d3f4"),
          o = n("69a8"),
          a = n("86cc").f,
          c = 0,
          u = Object.isExtensible || function () {
        return !0;
      },
          s = !n("79e5")(function () {
        return u(Object.preventExtensions({}));
      }),
          f = function f(t) {
        a(t, i, { value: { i: "O" + ++c, w: {} } });
      },
          h = function h(t, e) {
        if (!r(t)) return "symbol" == (typeof t === "undefined" ? "undefined" : _typeof(t)) ? t : ("string" == typeof t ? "S" : "P") + t;if (!o(t, i)) {
          if (!u(t)) return "F";if (!e) return "E";f(t);
        }return t[i].i;
      },
          l = function l(t, e) {
        if (!o(t, i)) {
          if (!u(t)) return !0;if (!e) return !1;f(t);
        }return t[i].w;
      },
          d = function d(t) {
        return s && p.NEED && u(t) && !o(t, i) && f(t), t;
      },
          p = t.exports = { KEY: i, NEED: !1, fastKey: h, getWeak: l, onFreeze: d };
    }, 6821: function _(t, e, n) {
      var i = n("626a"),
          r = n("be13");t.exports = function (t) {
        return i(r(t));
      };
    }, "69a8": function a8(t, e) {
      var n = {}.hasOwnProperty;t.exports = function (t, e) {
        return n.call(t, e);
      };
    }, "6a99": function a99(t, e, n) {
      var i = n("d3f4");t.exports = function (t, e) {
        if (!i(t)) return t;var n, r;if (e && "function" == typeof (n = t.toString) && !i(r = n.call(t))) return r;if ("function" == typeof (n = t.valueOf) && !i(r = n.call(t))) return r;if (!e && "function" == typeof (n = t.toString) && !i(r = n.call(t))) return r;throw TypeError("Can't convert object to primitive value");
      };
    }, "6a9b": function a9b(t, e, n) {
      var i = n("8bab"),
          r = n("e5fa");t.exports = function (t) {
        return i(r(t));
      };
    }, "6b54": function b54(t, e, n) {
      "use strict";
      n("3846");var i = n("cb7c"),
          r = n("0bfb"),
          o = n("9e1e"),
          a = "toString",
          c = /./[a],
          u = function u(t) {
        n("2aba")(RegExp.prototype, a, t, !0);
      };n("79e5")(function () {
        return "/a/b" != c.call({ source: "a", flags: "b" });
      }) ? u(function () {
        var t = i(this);return "/".concat(t.source, "/", "flags" in t ? t.flags : !o && t instanceof RegExp ? r.call(t) : void 0);
      }) : c.name != a && u(function () {
        return c.call(this);
      });
    }, "6e1f": function e1f(t, e) {
      var n = {}.toString;t.exports = function (t) {
        return n.call(t).slice(8, -1);
      };
    }, "6f42": function f42(t, e, n) {}, "6f8a": function f8a(t, e) {
      t.exports = function (t) {
        return "object" === (typeof t === "undefined" ? "undefined" : _typeof(t)) ? null !== t : "function" === typeof t;
      };
    }, 7108: function _(t, e, n) {
      var i = n("0f89"),
          r = n("f568"),
          o = n("0029"),
          a = n("5d8f")("IE_PROTO"),
          c = function c() {},
          u = "prototype",
          _s3 = function s() {
        var t,
            e = n("12fd")("iframe"),
            i = o.length,
            r = "<",
            a = ">";e.style.display = "none", n("103a").appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write(r + "script" + a + "document.F=Object" + r + "/script" + a), t.close(), _s3 = t.F;while (i--) {
          delete _s3[u][o[i]];
        }return _s3();
      };t.exports = Object.create || function (t, e) {
        var n;return null !== t ? (c[u] = i(t), n = new c(), c[u] = null, n[a] = t) : n = _s3(), void 0 === e ? n : r(n, e);
      };
    }, 7514: function _(t, e, n) {
      "use strict";
      var i = n("5ca1"),
          r = n("0a49")(5),
          o = "find",
          a = !0;o in [] && Array(1)[o](function () {
        a = !1;
      }), i(i.P + i.F * a, "Array", { find: function find(t) {
          return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
        } }), n("9c6c")(o);
    }, 7633: function _(t, e, n) {
      var i = n("2695"),
          r = n("0029");t.exports = Object.keys || function (t) {
        return i(t, r);
      };
    }, 7726: function _(t, e) {
      var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();"number" == typeof __g && (__g = n);
    }, 7772: function _(t, e, n) {
      var i = n("a7d3"),
          r = n("da3c"),
          o = "__core-js_shared__",
          a = r[o] || (r[o] = {});(t.exports = function (t, e) {
        return a[t] || (a[t] = void 0 !== e ? e : {});
      })("versions", []).push({ version: i.version, mode: n("b457") ? "pure" : "global", copyright: "© 2019 Denis Pushkarev (zloirock.ru)" });
    }, "77f1": function f1(t, e, n) {
      var i = n("4588"),
          r = Math.max,
          o = Math.min;t.exports = function (t, e) {
        return t = i(t), t < 0 ? r(t + e, 0) : o(t, e);
      };
    }, "79e5": function e5(t, e) {
      t.exports = function (t) {
        try {
          return !!t();
        } catch (e) {
          return !0;
        }
      };
    }, "7a56": function a56(t, e, n) {
      "use strict";
      var i = n("7726"),
          r = n("86cc"),
          o = n("9e1e"),
          a = n("2b4c")("species");t.exports = function (t) {
        var e = i[t];o && e && !e[a] && r.f(e, a, { configurable: !0, get: function get() {
            return this;
          } });
      };
    }, "7b00": function b00(t, e) {
      var n = 0,
          i = Math.random();t.exports = function (t) {
        return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + i).toString(36));
      };
    }, "7d8a": function d8a(t, e, n) {
      var i = n("6e1f"),
          r = n("1b55")("toStringTag"),
          o = "Arguments" == i(function () {
        return arguments;
      }()),
          a = function a(t, e) {
        try {
          return t[e];
        } catch (n) {}
      };t.exports = function (t) {
        var e, n, c;return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = a(e = Object(t), r)) ? n : o ? i(e) : "Object" == (c = i(e)) && "function" == typeof e.callee ? "Arguments" : c;
      };
    }, "7d95": function d95(t, e, n) {
      t.exports = !n("d782")(function () {
        return 7 != Object.defineProperty({}, "a", { get: function get() {
            return 7;
          } }).a;
      });
    }, "7f20": function f20(t, e, n) {
      var i = n("86cc").f,
          r = n("69a8"),
          o = n("2b4c")("toStringTag");t.exports = function (t, e, n) {
        t && !r(t = n ? t : t.prototype, o) && i(t, o, { configurable: !0, value: e });
      };
    }, 8378: function _(t, e) {
      var n = t.exports = { version: "2.6.1" };"number" == typeof __e && (__e = n);
    }, "84f2": function f2(t, e) {
      t.exports = {};
    }, "85f2": function f2(t, e, n) {
      t.exports = n("ec5b");
    }, "86cc": function cc(t, e, n) {
      var i = n("cb7c"),
          r = n("c69a"),
          o = n("6a99"),
          a = Object.defineProperty;e.f = n("9e1e") ? Object.defineProperty : function (t, e, n) {
        if (i(t), e = o(e, !0), i(n), r) try {
          return a(t, e, n);
        } catch (c) {}if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");return "value" in n && (t[e] = n.value), t;
      };
    }, "87b3": function b3(t, e, n) {
      var i = Date.prototype,
          r = "Invalid Date",
          o = "toString",
          a = i[o],
          c = i.getTime;new Date(NaN) + "" != r && n("2aba")(i, o, function () {
        var t = c.call(this);return t === t ? a.call(this) : r;
      });
    }, 8875: function _(t, e, n) {
      var i, r, o;(function (n, a) {
        r = [], i = a, o = "function" === typeof i ? i.apply(e, r) : i, void 0 === o || (t.exports = o);
      })("undefined" !== typeof self && self, function () {
        function t() {
          if (document.currentScript) return document.currentScript;try {
            throw new Error();
          } catch (h) {
            var t,
                e,
                n,
                i = /.*at [^(]*\((.*):(.+):(.+)\)$/gi,
                r = /@([^@]*):(\d+):(\d+)\s*$/gi,
                o = i.exec(h.stack) || r.exec(h.stack),
                a = o && o[1] || !1,
                c = o && o[2] || !1,
                u = document.location.href.replace(document.location.hash, ""),
                s = document.getElementsByTagName("script");a === u && (t = document.documentElement.outerHTML, e = new RegExp("(?:[^\\n]+?\\n){0," + (c - 2) + "}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*", "i"), n = t.replace(e, "$1").trim());for (var f = 0; f < s.length; f++) {
              if ("interactive" === s[f].readyState) return s[f];if (s[f].src === a) return s[f];if (a === u && s[f].innerHTML && s[f].innerHTML.trim() === n) return s[f];
            }return null;
          }
        }return t;
      });
    }, "89ca": function ca(t, e, n) {
      n("b42c"), n("93c4"), t.exports = n("d38f");
    }, "8b97": function b97(t, e, n) {
      var i = n("d3f4"),
          r = n("cb7c"),
          o = function o(t, e) {
        if (r(t), !i(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
      };t.exports = { set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, e, i) {
          try {
            i = n("9b43")(Function.call, n("11e9").f(Object.prototype, "__proto__").set, 2), i(t, []), e = !(t instanceof Array);
          } catch (r) {
            e = !0;
          }return function (t, n) {
            return o(t, n), e ? t.__proto__ = n : i(t, n), t;
          };
        }({}, !1) : void 0), check: o };
    }, "8bab": function bab(t, e, n) {
      var i = n("6e1f");t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
        return "String" == i(t) ? t.split("") : Object(t);
      };
    }, "8ce0": function ce0(t, e, n) {
      var i = n("3adc"),
          r = n("f845");t.exports = n("7d95") ? function (t, e, n) {
        return i.f(t, e, r(1, n));
      } : function (t, e, n) {
        return t[e] = n, t;
      };
    }, "8e6e": function e6e(t, e, n) {
      var i = n("5ca1"),
          r = n("990b"),
          o = n("6821"),
          a = n("11e9"),
          c = n("f1ae");i(i.S, "Object", { getOwnPropertyDescriptors: function getOwnPropertyDescriptors(t) {
          var e,
              n,
              i = o(t),
              u = a.f,
              s = r(i),
              f = {},
              h = 0;while (s.length > h) {
            n = u(i, e = s[h++]), void 0 !== n && c(f, e, n);
          }return f;
        } });
    }, 9093: function _(t, e, n) {
      var i = n("ce10"),
          r = n("e11e").concat("length", "prototype");e.f = Object.getOwnPropertyNames || function (t) {
        return i(t, r);
      };
    }, "93c4": function c4(t, e, n) {
      "use strict";
      var i = n("2a4e")(!0);n("e4a9")(String, "String", function (t) {
        this._t = String(t), this._i = 0;
      }, function () {
        var t,
            e = this._t,
            n = this._i;return n >= e.length ? { value: void 0, done: !0 } : (t = i(e, n), this._i += t.length, { value: t, done: !1 });
      });
    }, "990b": function b(t, e, n) {
      var i = n("9093"),
          r = n("2621"),
          o = n("cb7c"),
          a = n("7726").Reflect;t.exports = a && a.ownKeys || function (t) {
        var e = i.f(o(t)),
            n = r.f;return n ? e.concat(n(t)) : e;
      };
    }, "9b43": function b43(t, e, n) {
      var i = n("d8e8");t.exports = function (t, e, n) {
        if (i(t), void 0 === e) return t;switch (n) {case 1:
            return function (n) {
              return t.call(e, n);
            };case 2:
            return function (n, i) {
              return t.call(e, n, i);
            };case 3:
            return function (n, i, r) {
              return t.call(e, n, i, r);
            };}return function () {
          return t.apply(e, arguments);
        };
      };
    }, "9c6c": function c6c(t, e, n) {
      var i = n("2b4c")("unscopables"),
          r = Array.prototype;void 0 == r[i] && n("32e9")(r, i, {}), t.exports = function (t) {
        r[i][t] = !0;
      };
    }, "9def": function def(t, e, n) {
      var i = n("4588"),
          r = Math.min;t.exports = function (t) {
        return t > 0 ? r(i(t), 9007199254740991) : 0;
      };
    }, "9e1e": function e1e(t, e, n) {
      t.exports = !n("79e5")(function () {
        return 7 != Object.defineProperty({}, "a", { get: function get() {
            return 7;
          } }).a;
      });
    }, a47f: function a47f(t, e, n) {
      t.exports = !n("7d95") && !n("d782")(function () {
        return 7 != Object.defineProperty(n("12fd")("div"), "a", { get: function get() {
            return 7;
          } }).a;
      });
    }, a5ab: function a5ab(t, e, n) {
      var i = n("a812"),
          r = Math.min;t.exports = function (t) {
        return t > 0 ? r(i(t), 9007199254740991) : 0;
      };
    }, a745: function a745(t, e, n) {
      t.exports = n("d604");
    }, a7d3: function a7d3(t, e) {
      var n = t.exports = { version: "2.6.9" };"number" == typeof __e && (__e = n);
    }, a812: function a812(t, e) {
      var n = Math.ceil,
          i = Math.floor;t.exports = function (t) {
        return isNaN(t = +t) ? 0 : (t > 0 ? i : n)(t);
      };
    }, aa77: function aa77(t, e, n) {
      var i = n("5ca1"),
          r = n("be13"),
          o = n("79e5"),
          a = n("fdef"),
          c = "[" + a + "]",
          u = "​",
          s = RegExp("^" + c + c + "*"),
          f = RegExp(c + c + "*$"),
          h = function h(t, e, n) {
        var r = {},
            c = o(function () {
          return !!a[t]() || u[t]() != u;
        }),
            s = r[t] = c ? e(l) : a[t];n && (r[n] = s), i(i.P + i.F * c, "String", r);
      },
          l = h.trim = function (t, e) {
        return t = String(r(t)), 1 & e && (t = t.replace(s, "")), 2 & e && (t = t.replace(f, "")), t;
      };t.exports = h;
    }, aae3: function aae3(t, e, n) {
      var i = n("d3f4"),
          r = n("2d95"),
          o = n("2b4c")("match");t.exports = function (t) {
        var e;return i(t) && (void 0 !== (e = t[o]) ? !!e : "RegExp" == r(t));
      };
    }, ac6a: function ac6a(t, e, n) {
      for (var i = n("cadf"), r = n("0d58"), o = n("2aba"), a = n("7726"), c = n("32e9"), u = n("84f2"), s = n("2b4c"), f = s("iterator"), h = s("toStringTag"), l = u.Array, d = { CSSRuleList: !0, CSSStyleDeclaration: !1, CSSValueList: !1, ClientRectList: !1, DOMRectList: !1, DOMStringList: !1, DOMTokenList: !0, DataTransferItemList: !1, FileList: !1, HTMLAllCollection: !1, HTMLCollection: !1, HTMLFormElement: !1, HTMLSelectElement: !1, MediaList: !0, MimeTypeArray: !1, NamedNodeMap: !1, NodeList: !0, PaintRequestList: !1, Plugin: !1, PluginArray: !1, SVGLengthList: !1, SVGNumberList: !1, SVGPathSegList: !1, SVGPointList: !1, SVGStringList: !1, SVGTransformList: !1, SourceBufferList: !1, StyleSheetList: !0, TextTrackCueList: !1, TextTrackList: !1, TouchList: !1 }, p = r(d), m = 0; m < p.length; m++) {
        var g,
            v = p[m],
            b = d[v],
            y = a[v],
            x = y && y.prototype;if (x && (x[f] || c(x, f, l), x[h] || c(x, h, v), u[v] = l, b)) for (g in i) {
          x[g] || o(x, g, i[g], !0);
        }
      }
    }, b22a: function b22a(t, e) {
      t.exports = {};
    }, b39a: function b39a(t, e, n) {
      var i = n("d3f4");t.exports = function (t, e) {
        if (!i(t) || t._t !== e) throw TypeError("Incompatible receiver, " + e + " required!");return t;
      };
    }, b3e7: function b3e7(t, e) {
      t.exports = function () {};
    }, b42c: function b42c(t, e, n) {
      n("fa54");for (var i = n("da3c"), r = n("8ce0"), o = n("b22a"), a = n("1b55")("toStringTag"), c = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), u = 0; u < c.length; u++) {
        var s = c[u],
            f = i[s],
            h = f && f.prototype;h && !h[a] && r(h, a, s), o[s] = o.Array;
      }
    }, b457: function b457(t, e) {
      t.exports = !0;
    }, b5aa: function b5aa(t, e, n) {
      var i = n("6e1f");t.exports = Array.isArray || function (t) {
        return "Array" == i(t);
      };
    }, b635: function b635(t, e, n) {
      "use strict";
      (function (t) {
        n.d(e, "b", function () {
          return r;
        });n("6f42");var i = n("3425");function r(t) {
          r.installed || (r.installed = !0, t.component("VueDraggableResizable", i["a"]));
        }var o = { install: r },
            a = null;"undefined" !== typeof window ? a = window.Vue : "undefined" !== typeof t && (a = t.Vue), a && a.use(o), e["a"] = i["a"];
      }).call(this, n("c8ba"));
    }, b77f: function b77f(t, e, n) {
      var i = n("0f89"),
          r = n("f159");t.exports = n("a7d3").getIterator = function (t) {
        var e = r(t);if ("function" != typeof e) throw TypeError(t + " is not iterable!");return i(e.call(t));
      };
    }, bc25: function bc25(t, e, n) {
      var i = n("f2fe");t.exports = function (t, e, n) {
        if (i(t), void 0 === e) return t;switch (n) {case 1:
            return function (n) {
              return t.call(e, n);
            };case 2:
            return function (n, i) {
              return t.call(e, n, i);
            };case 3:
            return function (n, i, r) {
              return t.call(e, n, i, r);
            };}return function () {
          return t.apply(e, arguments);
        };
      };
    }, be13: function be13(t, e) {
      t.exports = function (t) {
        if (void 0 == t) throw TypeError("Can't call method on  " + t);return t;
      };
    }, c0d8: function c0d8(t, e, n) {
      var i = n("3adc").f,
          r = n("43c8"),
          o = n("1b55")("toStringTag");t.exports = function (t, e, n) {
        t && !r(t = n ? t : t.prototype, o) && i(t, o, { configurable: !0, value: e });
      };
    }, c26b: function c26b(t, e, n) {
      "use strict";
      var i = n("86cc").f,
          r = n("2aeb"),
          o = n("dcbc"),
          a = n("9b43"),
          c = n("f605"),
          u = n("4a59"),
          s = n("01f9"),
          f = n("d53b"),
          h = n("7a56"),
          l = n("9e1e"),
          d = n("67ab").fastKey,
          p = n("b39a"),
          m = l ? "_s" : "size",
          g = function g(t, e) {
        var n,
            i = d(e);if ("F" !== i) return t._i[i];for (n = t._f; n; n = n.n) {
          if (n.k == e) return n;
        }
      };t.exports = { getConstructor: function getConstructor(t, e, n, s) {
          var f = t(function (t, i) {
            c(t, f, e, "_i"), t._t = e, t._i = r(null), t._f = void 0, t._l = void 0, t[m] = 0, void 0 != i && u(i, n, t[s], t);
          });return o(f.prototype, { clear: function clear() {
              for (var t = p(this, e), n = t._i, i = t._f; i; i = i.n) {
                i.r = !0, i.p && (i.p = i.p.n = void 0), delete n[i.i];
              }t._f = t._l = void 0, t[m] = 0;
            }, delete: function _delete(t) {
              var n = p(this, e),
                  i = g(n, t);if (i) {
                var r = i.n,
                    o = i.p;delete n._i[i.i], i.r = !0, o && (o.n = r), r && (r.p = o), n._f == i && (n._f = r), n._l == i && (n._l = o), n[m]--;
              }return !!i;
            }, forEach: function forEach(t) {
              p(this, e);var n,
                  i = a(t, arguments.length > 1 ? arguments[1] : void 0, 3);while (n = n ? n.n : this._f) {
                i(n.v, n.k, this);while (n && n.r) {
                  n = n.p;
                }
              }
            }, has: function has(t) {
              return !!g(p(this, e), t);
            } }), l && i(f.prototype, "size", { get: function get() {
              return p(this, e)[m];
            } }), f;
        }, def: function def(t, e, n) {
          var i,
              r,
              o = g(t, e);return o ? o.v = n : (t._l = o = { i: r = d(e, !0), k: e, v: n, p: i = t._l, n: void 0, r: !1 }, t._f || (t._f = o), i && (i.n = o), t[m]++, "F" !== r && (t._i[r] = o)), t;
        }, getEntry: g, setStrong: function setStrong(t, e, n) {
          s(t, e, function (t, n) {
            this._t = p(t, e), this._k = n, this._l = void 0;
          }, function () {
            var t = this,
                e = t._k,
                n = t._l;while (n && n.r) {
              n = n.p;
            }return t._t && (t._l = n = n ? n.n : t._t._f) ? f(0, "keys" == e ? n.k : "values" == e ? n.v : [n.k, n.v]) : (t._t = void 0, f(1));
          }, n ? "entries" : "values", !n, !0), h(e);
        } };
    }, c366: function c366(t, e, n) {
      var i = n("6821"),
          r = n("9def"),
          o = n("77f1");t.exports = function (t) {
        return function (e, n, a) {
          var c,
              u = i(e),
              s = r(u.length),
              f = o(a, s);if (t && n != n) {
            while (s > f) {
              if (c = u[f++], c != c) return !0;
            }
          } else for (; s > f; f++) {
            if ((t || f in u) && u[f] === n) return t || f || 0;
          }return !t && -1;
        };
      };
    }, c5f6: function c5f6(t, e, n) {
      "use strict";
      var i = n("7726"),
          r = n("69a8"),
          o = n("2d95"),
          a = n("5dbc"),
          c = n("6a99"),
          u = n("79e5"),
          s = n("9093").f,
          f = n("11e9").f,
          h = n("86cc").f,
          l = n("aa77").trim,
          d = "Number",
          _p = i[d],
          m = _p,
          g = _p.prototype,
          v = o(n("2aeb")(g)) == d,
          b = "trim" in String.prototype,
          y = function y(t) {
        var e = c(t, !1);if ("string" == typeof e && e.length > 2) {
          e = b ? e.trim() : l(e, 3);var n,
              i,
              r,
              o = e.charCodeAt(0);if (43 === o || 45 === o) {
            if (n = e.charCodeAt(2), 88 === n || 120 === n) return NaN;
          } else if (48 === o) {
            switch (e.charCodeAt(1)) {case 66:case 98:
                i = 2, r = 49;break;case 79:case 111:
                i = 8, r = 55;break;default:
                return +e;}for (var a, u = e.slice(2), s = 0, f = u.length; s < f; s++) {
              if (a = u.charCodeAt(s), a < 48 || a > r) return NaN;
            }return parseInt(u, i);
          }
        }return +e;
      };if (!_p(" 0o1") || !_p("0b1") || _p("+0x1")) {
        _p = function p(t) {
          var e = arguments.length < 1 ? 0 : t,
              n = this;return n instanceof _p && (v ? u(function () {
            g.valueOf.call(n);
          }) : o(n) != d) ? a(new m(y(e)), n, _p) : y(e);
        };for (var x, w = n("9e1e") ? s(m) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), S = 0; w.length > S; S++) {
          r(m, x = w[S]) && !r(_p, x) && h(_p, x, f(m, x));
        }_p.prototype = g, g.constructor = _p, n("2aba")(i, d, _p);
      }
    }, c69a: function c69a(t, e, n) {
      t.exports = !n("9e1e") && !n("79e5")(function () {
        return 7 != Object.defineProperty(n("230e")("div"), "a", { get: function get() {
            return 7;
          } }).a;
      });
    }, c8ba: function c8ba(t, e) {
      var n;n = function () {
        return this;
      }();try {
        n = n || new Function("return this")();
      } catch (i) {
        "object" === (typeof window === "undefined" ? "undefined" : _typeof(window)) && (n = window);
      }t.exports = n;
    }, c8bb: function c8bb(t, e, n) {
      t.exports = n("89ca");
    }, ca5a: function ca5a(t, e) {
      var n = 0,
          i = Math.random();t.exports = function (t) {
        return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + i).toString(36));
      };
    }, cadf: function cadf(t, e, n) {
      "use strict";
      var i = n("9c6c"),
          r = n("d53b"),
          o = n("84f2"),
          a = n("6821");t.exports = n("01f9")(Array, "Array", function (t, e) {
        this._t = a(t), this._i = 0, this._k = e;
      }, function () {
        var t = this._t,
            e = this._k,
            n = this._i++;return !t || n >= t.length ? (this._t = void 0, r(1)) : r(0, "keys" == e ? n : "values" == e ? t[n] : [n, t[n]]);
      }, "values"), o.Arguments = o.Array, i("keys"), i("values"), i("entries");
    }, cb7c: function cb7c(t, e, n) {
      var i = n("d3f4");t.exports = function (t) {
        if (!i(t)) throw TypeError(t + " is not an object!");return t;
      };
    }, cd1c: function cd1c(t, e, n) {
      var i = n("e853");t.exports = function (t, e) {
        return new (i(t))(e);
      };
    }, ce10: function ce10(t, e, n) {
      var i = n("69a8"),
          r = n("6821"),
          o = n("c366")(!1),
          a = n("613b")("IE_PROTO");t.exports = function (t, e) {
        var n,
            c = r(t),
            u = 0,
            s = [];for (n in c) {
          n != a && i(c, n) && s.push(n);
        }while (e.length > u) {
          i(c, n = e[u++]) && (~o(s, n) || s.push(n));
        }return s;
      };
    }, d13f: function d13f(t, e, n) {
      var i = n("da3c"),
          r = n("a7d3"),
          o = n("bc25"),
          a = n("8ce0"),
          c = n("43c8"),
          u = "prototype",
          s = function s(t, e, n) {
        var f,
            h,
            l,
            d = t & s.F,
            p = t & s.G,
            m = t & s.S,
            g = t & s.P,
            v = t & s.B,
            b = t & s.W,
            y = p ? r : r[e] || (r[e] = {}),
            x = y[u],
            w = p ? i : m ? i[e] : (i[e] || {})[u];for (f in p && (n = e), n) {
          h = !d && w && void 0 !== w[f], h && c(y, f) || (l = h ? w[f] : n[f], y[f] = p && "function" != typeof w[f] ? n[f] : v && h ? o(l, i) : b && w[f] == l ? function (t) {
            var e = function e(_e2, n, i) {
              if (this instanceof t) {
                switch (arguments.length) {case 0:
                    return new t();case 1:
                    return new t(_e2);case 2:
                    return new t(_e2, n);}return new t(_e2, n, i);
              }return t.apply(this, arguments);
            };return e[u] = t[u], e;
          }(l) : g && "function" == typeof l ? o(Function.call, l) : l, g && ((y.virtual || (y.virtual = {}))[f] = l, t & s.R && x && !x[f] && a(x, f, l)));
        }
      };s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, s.U = 64, s.R = 128, t.exports = s;
    }, d25f: function d25f(t, e, n) {
      "use strict";
      var i = n("5ca1"),
          r = n("0a49")(2);i(i.P + i.F * !n("2f21")([].filter, !0), "Array", { filter: function filter(t) {
          return r(this, t, arguments[1]);
        } });
    }, d2c8: function d2c8(t, e, n) {
      var i = n("aae3"),
          r = n("be13");t.exports = function (t, e, n) {
        if (i(e)) throw TypeError("String#" + n + " doesn't accept regex!");return String(r(t));
      };
    }, d38f: function d38f(t, e, n) {
      var i = n("7d8a"),
          r = n("1b55")("iterator"),
          o = n("b22a");t.exports = n("a7d3").isIterable = function (t) {
        var e = Object(t);return void 0 !== e[r] || "@@iterator" in e || o.hasOwnProperty(i(e));
      };
    }, d3f4: function d3f4(t, e) {
      t.exports = function (t) {
        return "object" === (typeof t === "undefined" ? "undefined" : _typeof(t)) ? null !== t : "function" === typeof t;
      };
    }, d53b: function d53b(t, e) {
      t.exports = function (t, e) {
        return { value: e, done: !!t };
      };
    }, d604: function d604(t, e, n) {
      n("1938"), t.exports = n("a7d3").Array.isArray;
    }, d782: function d782(t, e) {
      t.exports = function (t) {
        try {
          return !!t();
        } catch (e) {
          return !0;
        }
      };
    }, d8e8: function d8e8(t, e) {
      t.exports = function (t) {
        if ("function" != typeof t) throw TypeError(t + " is not a function!");return t;
      };
    }, da3c: function da3c(t, e) {
      var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();"number" == typeof __g && (__g = n);
    }, dcbc: function dcbc(t, e, n) {
      var i = n("2aba");t.exports = function (t, e, n) {
        for (var r in e) {
          i(t, r, e[r], n);
        }return t;
      };
    }, e0b8: function e0b8(t, e, n) {
      "use strict";
      var i = n("7726"),
          r = n("5ca1"),
          o = n("2aba"),
          a = n("dcbc"),
          c = n("67ab"),
          u = n("4a59"),
          s = n("f605"),
          f = n("d3f4"),
          h = n("79e5"),
          l = n("5cc5"),
          d = n("7f20"),
          p = n("5dbc");t.exports = function (t, e, n, m, g, v) {
        var b = i[t],
            y = b,
            x = g ? "set" : "add",
            w = y && y.prototype,
            S = {},
            _ = function _(t) {
          var e = w[t];o(w, t, "delete" == t || "has" == t ? function (t) {
            return !(v && !f(t)) && e.call(this, 0 === t ? 0 : t);
          } : "get" == t ? function (t) {
            return v && !f(t) ? void 0 : e.call(this, 0 === t ? 0 : t);
          } : "add" == t ? function (t) {
            return e.call(this, 0 === t ? 0 : t), this;
          } : function (t, n) {
            return e.call(this, 0 === t ? 0 : t, n), this;
          });
        };if ("function" == typeof y && (v || w.forEach && !h(function () {
          new y().entries().next();
        }))) {
          var O = new y(),
              E = O[x](v ? {} : -0, 1) != O,
              T = h(function () {
            O.has(1);
          }),
              P = l(function (t) {
            new y(t);
          }),
              L = !v && h(function () {
            var t = new y(),
                e = 5;while (e--) {
              t[x](e, e);
            }return !t.has(-0);
          });P || (y = e(function (e, n) {
            s(e, y, t);var i = p(new b(), e, y);return void 0 != n && u(n, g, i[x], i), i;
          }), y.prototype = w, w.constructor = y), (T || L) && (_("delete"), _("has"), g && _("get")), (L || E) && _(x), v && w.clear && delete w.clear;
        } else y = m.getConstructor(e, t, g, x), a(y.prototype, n), c.NEED = !0;return d(y, t), S[t] = y, r(r.G + r.W + r.F * (y != b), S), v || m.setStrong(y, t, g), y;
      };
    }, e11e: function e11e(t, e) {
      t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    }, e341: function e341(t, e, n) {
      var i = n("d13f");i(i.S + i.F * !n("7d95"), "Object", { defineProperty: n("3adc").f });
    }, e4a9: function e4a9(t, e, n) {
      "use strict";
      var i = n("b457"),
          r = n("d13f"),
          o = n("2312"),
          a = n("8ce0"),
          c = n("b22a"),
          u = n("5ce7"),
          s = n("c0d8"),
          f = n("ff0c"),
          h = n("1b55")("iterator"),
          l = !([].keys && "next" in [].keys()),
          d = "@@iterator",
          p = "keys",
          m = "values",
          g = function g() {
        return this;
      };t.exports = function (t, e, n, v, b, y, x) {
        u(n, e, v);var w,
            S,
            _,
            O = function O(t) {
          if (!l && t in L) return L[t];switch (t) {case p:
              return function () {
                return new n(this, t);
              };case m:
              return function () {
                return new n(this, t);
              };}return function () {
            return new n(this, t);
          };
        },
            E = e + " Iterator",
            T = b == m,
            P = !1,
            L = t.prototype,
            M = L[h] || L[d] || b && L[b],
            R = M || O(b),
            j = b ? T ? O("entries") : R : void 0,
            A = "Array" == e && L.entries || M;if (A && (_ = f(A.call(new t())), _ !== Object.prototype && _.next && (s(_, E, !0), i || "function" == typeof _[h] || a(_, h, g))), T && M && M.name !== m && (P = !0, R = function R() {
          return M.call(this);
        }), i && !x || !l && !P && L[h] || a(L, h, R), c[e] = R, c[E] = g, b) if (w = { values: T ? R : O(m), keys: y ? R : O(p), entries: j }, x) for (S in w) {
          S in L || o(L, S, w[S]);
        } else r(r.P + r.F * (l || P), e, w);return w;
      };
    }, e5fa: function e5fa(t, e) {
      t.exports = function (t) {
        if (void 0 == t) throw TypeError("Can't call method on  " + t);return t;
      };
    }, e853: function e853(t, e, n) {
      var i = n("d3f4"),
          r = n("1169"),
          o = n("2b4c")("species");t.exports = function (t) {
        var e;return r(t) && (e = t.constructor, "function" != typeof e || e !== Array && !r(e.prototype) || (e = void 0), i(e) && (e = e[o], null === e && (e = void 0))), void 0 === e ? Array : e;
      };
    }, ec5b: function ec5b(t, e, n) {
      n("e341");var i = n("a7d3").Object;t.exports = function (t, e, n) {
        return i.defineProperty(t, e, n);
      };
    }, f159: function f159(t, e, n) {
      var i = n("7d8a"),
          r = n("1b55")("iterator"),
          o = n("b22a");t.exports = n("a7d3").getIteratorMethod = function (t) {
        if (void 0 != t) return t[r] || t["@@iterator"] || o[i(t)];
      };
    }, f1ae: function f1ae(t, e, n) {
      "use strict";
      var i = n("86cc"),
          r = n("4630");t.exports = function (t, e, n) {
        e in t ? i.f(t, e, r(0, n)) : t[e] = n;
      };
    }, f2fe: function f2fe(t, e) {
      t.exports = function (t) {
        if ("function" != typeof t) throw TypeError(t + " is not a function!");return t;
      };
    }, f3e2: function f3e2(t, e, n) {
      "use strict";
      var i = n("5ca1"),
          r = n("0a49")(0),
          o = n("2f21")([].forEach, !0);i(i.P + i.F * !o, "Array", { forEach: function forEach(t) {
          return r(this, t, arguments[1]);
        } });
    }, f568: function f568(t, e, n) {
      var i = n("3adc"),
          r = n("0f89"),
          o = n("7633");t.exports = n("7d95") ? Object.defineProperties : function (t, e) {
        r(t);var n,
            a = o(e),
            c = a.length,
            u = 0;while (c > u) {
          i.f(t, n = a[u++], e[n]);
        }return t;
      };
    }, f605: function f605(t, e) {
      t.exports = function (t, e, n, i) {
        if (!(t instanceof e) || void 0 !== i && i in t) throw TypeError(n + ": incorrect invocation!");return t;
      };
    }, f845: function f845(t, e) {
      t.exports = function (t, e) {
        return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e };
      };
    }, fa54: function fa54(t, e, n) {
      "use strict";
      var i = n("b3e7"),
          r = n("245b"),
          o = n("b22a"),
          a = n("6a9b");t.exports = n("e4a9")(Array, "Array", function (t, e) {
        this._t = a(t), this._i = 0, this._k = e;
      }, function () {
        var t = this._t,
            e = this._k,
            n = this._i++;return !t || n >= t.length ? (this._t = void 0, r(1)) : r(0, "keys" == e ? n : "values" == e ? t[n] : [n, t[n]]);
      }, "values"), o.Arguments = o.Array, i("keys"), i("values"), i("entries");
    }, fab2: function fab2(t, e, n) {
      var i = n("7726").document;t.exports = i && i.documentElement;
    }, fb15: function fb15(t, e, n) {
      "use strict";
      if (n.r(e), n.d(e, "install", function () {
        return a["b"];
      }), "undefined" !== typeof window) {
        var i = window.document.currentScript,
            r = n("8875");i = r(), "currentScript" in document || Object.defineProperty(document, "currentScript", { get: r });var o = i && i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);o && (n.p = o[1]);
      }var a = n("b635");e["default"] = a["a"];
    }, fdef: function fdef(t, e) {
      t.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
    }, ff0c: function ff0c(t, e, n) {
      var i = n("43c8"),
          r = n("0185"),
          o = n("5d8f")("IE_PROTO"),
          a = Object.prototype;t.exports = Object.getPrototypeOf || function (t) {
        return t = r(t), i(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? a : null;
      };
    } })["default"];
});
//# sourceMappingURL=VueDraggableResizable.umd.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module)))

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1054);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("19bcc554", content, true, {});

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".vdr{touch-action:none;border:1px dashed #000}.handle,.vdr{position:absolute;box-sizing:border-box}.handle{width:10px;height:10px;background:#eee;border:1px solid #333}.handle-tl{top:-10px;left:-10px;cursor:nw-resize}.handle-tm{top:-10px;left:50%;margin-left:-5px;cursor:n-resize}.handle-tr{top:-10px;right:-10px;cursor:ne-resize}.handle-ml{left:-10px;cursor:w-resize}.handle-ml,.handle-mr{top:50%;margin-top:-5px}.handle-mr{right:-10px;cursor:e-resize}.handle-bl{bottom:-10px;left:-10px;cursor:sw-resize}.handle-bm{bottom:-10px;left:50%;margin-left:-5px;cursor:s-resize}.handle-br{bottom:-10px;right:-10px;cursor:se-resize}@media only screen and (max-width:768px){[class*=handle-]:before{content:\"\";left:-10px;right:-10px;bottom:-10px;top:-10px;position:absolute}}", ""]);

// exports


/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"etiqueta"},[_c('tabs',{staticClass:"mb-4",attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}),_vm._v(" "),_c('div',{attrs:{"id":"dpi"}}),_vm._v(" "),(_vm.tabEtiqueta)?_c('div',{staticClass:"row layout-etiqueta"},[_c('div',{staticClass:"default-container col-md-2 col-12",staticStyle:{"overflow-y":"scroll","height":"100vh"},on:{"drop":function($event){return _vm.onDropItem($event)},"dragover":function($event){$event.preventDefault();},"dragenter":function($event){$event.preventDefault();}}},[_vm._m(0),_vm._v(" "),_vm._l((_vm.fields),function(field){return (field.family == 'produto')?_c('div',{key:field.name,staticClass:"drag-el",attrs:{"draggable":""},on:{"dragstart":function($event){return _vm.startDragFields($event, field)}}},[_vm._v("\n                "+_vm._s(field.label)+"\n            ")]):_vm._e()}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._l((_vm.fields),function(field){return (field.family == 'empresa')?_c('div',{key:field.name,staticClass:"drag-el",attrs:{"draggable":""},on:{"dragstart":function($event){return _vm.startDragFields($event, field)}}},[_vm._v("\n                "+_vm._s(field.label)+"\n            ")]):_vm._e()}),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._l((_vm.fields),function(field){return (field.family == 'outros')?_c('div',{key:field.name,staticClass:"drag-el",attrs:{"draggable":""},on:{"dragstart":function($event){return _vm.startDragFields($event, field)}}},[_vm._v("\n                "+_vm._s(field.label)+"\n            ")]):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-12"},[_c('div',{staticClass:"caixa-layout-etiqueta d-flex justify-content-center",attrs:{"id":"foo"},on:{"click":function($event){$event.stopPropagation();_vm.item = null}}},[_c('div',{staticClass:"drop-zone",style:('width:'+_vm.etiquetalargura+'px;height:'+_vm.etiquetaaltura+'px;'),on:{"drop":function($event){return _vm.onDropFields($event)},"dragover":function($event){$event.preventDefault();},"dragenter":function($event){$event.preventDefault();}}},_vm._l((_vm.items),function(aux){return _c('vue-draggable-resizable',{key:aux.index,staticClass:"drag-el",style:(_vm.handleTextStyle(aux)),attrs:{"id":'item'+aux.index,"w":_vm.mmTopx(aux.width),"h":_vm.mmTopx(aux.height),"x":_vm.mmTopx(aux.x),"y":_vm.mmTopx(aux.y),"min-width":10,"min-height":10,"parent":true},on:{"dragging":function (x, y) { return _vm.onDragingItem(aux.index, x, y); },"resizing":function (x, y, width, height) { return _vm.onResizeItem(aux.index, x, y, width, height); },"activated":function () { return _vm.onActivated(aux.index); },"deactivated":function($event){return _vm.onDeactivated()}}},[_c('div',{style:('width:100%;height:100%;'),on:{"click":function($event){$event.stopPropagation();}}},[_vm._v("\n                        "+_vm._s(aux.label)+"\n                        ")])])}),1)])]),_vm._v(" "),_c('div',{staticClass:"default-container col-md-2 col-12"},[(_vm.item)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 d-flex justify-content-between"},[_c('v-label',{attrs:{"label":_vm.item.label}}),_vm._v(" "),_c('a',{staticClass:"btn-sm btn-danger",staticStyle:{"font-size":"15px"},attrs:{"href":"#"},on:{"click":function($event){return _vm.handleCancelItem(_vm.item)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.fieldRotulo)?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"label":"Rótulo","required":false,"name":_vm.item.name + _vm.item.index,"type":"text","col":"12"},model:{value:(_vm.item.rotulo),callback:function ($$v) {_vm.$set(_vm.item, "rotulo", $$v)},expression:"item.rotulo"}})],1):_vm._e(),_vm._v(" "),(_vm.fieldTextFont)?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"label":"Fonte","placeholder":"Selecione a fonte","metadata":{options: _vm.optionsFont, label:'Fonte'},"type":"select","col":"12","disabled":_vm.isView,"name":_vm.item.name + _vm.item.index},model:{value:(_vm.item.textFont),callback:function ($$v) {_vm.$set(_vm.item, "textFont", $$v)},expression:"item.textFont"}})],1):_vm._e(),_vm._v(" "),(_vm.fieldFontSize)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required: false}),expression:"{required: false}"}],attrs:{"label":"Tamanho","type":"number","col":"7","name":_vm.item.name + _vm.item.index},model:{value:(_vm.item.fontSize),callback:function ($$v) {_vm.$set(_vm.item, "fontSize", _vm._n($$v))},expression:"item.fontSize"}})],1):_vm._e(),_vm._v(" "),(_vm.fieldTypeGTIN)?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"metadata":{options:_vm.optionsTypeGTIN, label:'Tipo'},"required":false,"type":"select","col":"12","name":_vm.item.name + _vm.item.index},model:{value:(_vm.item.typeGTIN),callback:function ($$v) {_vm.$set(_vm.item, "typeGTIN", $$v)},expression:"item.typeGTIN"}})],1):_vm._e(),_vm._v(" "),(_vm.fieldFormatGTIN)?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"metadata":{options:_vm.optionsFormatGTIN, label:'Formato'},"required":false,"type":"select","col":"12","name":_vm.item.name + _vm.item.index},model:{value:(_vm.item.formatGTIN),callback:function ($$v) {_vm.$set(_vm.item, "formatGTIN", $$v)},expression:"item.formatGTIN"}})],1):_vm._e(),_vm._v(" "),(_vm.fieldFormatGTIN)?_c('div',{staticClass:"row d-flex m-auto align-items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.codemtexto),expression:"item.codemtexto"}],staticClass:"mr-0 pr-0",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.item.codemtexto)?_vm._i(_vm.item.codemtexto,null)>-1:(_vm.item.codemtexto)},on:{"change":function($event){var $$a=_vm.item.codemtexto,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.item, "codemtexto", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.item, "codemtexto", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.item, "codemtexto", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"lbl-edit mt-2 ml-1",staticStyle:{"font-size":"10px"}},[_vm._v("código em texto")])]):_vm._e(),_vm._v(" "),(_vm.fieldObs)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"d-flex flex-column mt-0 col-12"},[_c('v-label',{staticClass:"lbl-list",attrs:{"label":"Observação"}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.obs),expression:"item.obs"}],staticClass:"form-control",staticStyle:{"font-size":"12px"},attrs:{"cols":"20","rows":"10","name":_vm.item.name + _vm.item.index},domProps:{"value":(_vm.item.obs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "obs", $event.target.value)}}})],1)]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.fieldWidth)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true, name:'Largura'}),expression:"{required:true, name:'Largura'}"}],attrs:{"label":"Largura","v-errors":_vm.errors,"required":true,"type":"number","col":"12","disabled":_vm.isView,"name":_vm.item.name + _vm.item.index},model:{value:(_vm.item.width),callback:function ($$v) {_vm.$set(_vm.item, "width", $$v)},expression:"item.width"}})],1):_vm._e(),_vm._v(" "),(_vm.fieldHeight)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true, name: 'Altura'}),expression:"{required:true, name: 'Altura'}"}],attrs:{"label":"Altura","v-errors":_vm.errors,"required":true,"type":"number","col":"12","disabled":_vm.isView,"name":_vm.item.name + _vm.item.index},model:{value:(_vm.item.height),callback:function ($$v) {_vm.$set(_vm.item, "height", $$v)},expression:"item.height"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true, name:'X'}),expression:"{required:true, name:'X'}"}],attrs:{"label":"X","v-errors":_vm.errors,"required":true,"type":"number","col":"12","disabled":_vm.isView,"name":_vm.item.name + _vm.item.index},model:{value:(_vm.item.x),callback:function ($$v) {_vm.$set(_vm.item, "x", $$v)},expression:"item.x"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true, name: 'Y'}),expression:"{required:true, name: 'Y'}"}],attrs:{"label":"Y","v-errors":_vm.errors,"required":true,"type":"number","col":"12","disabled":_vm.isView,"name":_vm.item.name + _vm.item.index},model:{value:(_vm.item.y),callback:function ($$v) {_vm.$set(_vm.item, "y", $$v)},expression:"item.y"}})],1)]):_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-label',{attrs:{"label":"Etiqueta"}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true}),expression:"{required:true}"}],attrs:{"label":"Largura","v-errors":_vm.errors,"required":true,"type":"number","col":"12","disabled":_vm.isView,"name":"etiquetalargura"},model:{value:(_vm.etiqueta.largura),callback:function ($$v) {_vm.$set(_vm.etiqueta, "largura", $$v)},expression:"etiqueta.largura"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true}),expression:"{required:true}"}],attrs:{"label":"Altura","v-errors":_vm.errors,"required":true,"type":"number","col":"12","disabled":_vm.isView,"name":"etiquetaaltura"},model:{value:(_vm.etiqueta.altura),callback:function ($$v) {_vm.$set(_vm.etiqueta, "altura", $$v)},expression:"etiqueta.altura"}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.tabPagina)?_c('div',{staticClass:"row layout-etiqueta"},[_c('div',{staticClass:"default-container col-md-2 col-12"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-label',{attrs:{"label":"Pagina"}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true}),expression:"{required:true}"}],attrs:{"label":"Espaçamento Horizontal","v-errors":_vm.errors,"required":true,"type":"number","col":"12","disabled":_vm.isView},on:{"input":function($event){return _vm.preview_pagina_nexttick()},"focus":_vm.onFocusHorizontal,"blur":_vm.onBlurHorizontal},model:{value:(_vm.etiqueta.espacamento_horizontal),callback:function ($$v) {_vm.$set(_vm.etiqueta, "espacamento_horizontal", $$v)},expression:"etiqueta.espacamento_horizontal"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true}),expression:"{required:true}"}],attrs:{"label":"Espaçamento Vertical","v-errors":_vm.errors,"required":true,"type":"number","col":"12","disabled":_vm.isView},on:{"input":function($event){return _vm.preview_pagina_nexttick()},"focus":_vm.onFocusVertical,"blur":_vm.onBlurVertical},model:{value:(_vm.etiqueta.espacamento_vertical),callback:function ($$v) {_vm.$set(_vm.etiqueta, "espacamento_vertical", $$v)},expression:"etiqueta.espacamento_vertical"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true}),expression:"{required:true}"}],attrs:{"label":"Formato","v-errors":_vm.errors,"required":true,"type":"select","col":"12","select-options":_vm.formatOptions,"disabled":_vm.isView},on:{"input":function($event){return _vm.setFormat()}},model:{value:(_vm.pagina.format),callback:function ($$v) {_vm.$set(_vm.pagina, "format", $$v)},expression:"pagina.format"}})],1),_vm._v(" "),(_vm.pagina.format == 1)?[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true}),expression:"{required:true}"}],attrs:{"label":"Largura","v-errors":_vm.errors,"required":true,"type":"number","col":"12","disabled":_vm.isView},on:{"input":function($event){return _vm.preview_pagina_nexttick()}},model:{value:(_vm.pagina.largura),callback:function ($$v) {_vm.$set(_vm.pagina, "largura", $$v)},expression:"pagina.largura"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true}),expression:"{required:true}"}],attrs:{"label":"Altura","v-errors":_vm.errors,"required":true,"type":"number","col":"12","disabled":_vm.isView},on:{"input":function($event){return _vm.preview_pagina_nexttick()}},model:{value:(_vm.pagina.altura),callback:function ($$v) {_vm.$set(_vm.pagina, "altura", $$v)},expression:"pagina.altura"}})],1)]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true}),expression:"{required:true}"}],attrs:{"label":"Margem Superior","v-errors":_vm.errors,"required":true,"type":"number","col":"12","disabled":_vm.isView},on:{"input":function($event){return _vm.preview_pagina_nexttick()},"focus":_vm.onFocusSuperior,"blur":_vm.onBlurSuperior},model:{value:(_vm.pagina.margin.top),callback:function ($$v) {_vm.$set(_vm.pagina.margin, "top", $$v)},expression:"pagina.margin.top"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true}),expression:"{required:true}"}],attrs:{"label":"Margin Inferior","v-errors":_vm.errors,"required":true,"type":"number","col":"12","disabled":_vm.isView},on:{"input":function($event){return _vm.preview_pagina_nexttick()},"focus":_vm.onFocusInferior,"blur":_vm.onBlurInferior},model:{value:(_vm.pagina.margin.bottom),callback:function ($$v) {_vm.$set(_vm.pagina.margin, "bottom", $$v)},expression:"pagina.margin.bottom"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true}),expression:"{required:true}"}],attrs:{"label":"Margin Esquerda","v-errors":_vm.errors,"required":true,"type":"number","col":"12","disabled":_vm.isView},on:{"input":function($event){return _vm.preview_pagina_nexttick()},"focus":_vm.onFocusEsquerda,"blur":_vm.onBlurEsquerda},model:{value:(_vm.pagina.margin.left),callback:function ($$v) {_vm.$set(_vm.pagina.margin, "left", $$v)},expression:"pagina.margin.left"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true}),expression:"{required:true}"}],attrs:{"label":"Margin Direita","v-errors":_vm.errors,"required":true,"type":"number","col":"12","disabled":_vm.isView},on:{"input":function($event){return _vm.preview_pagina_nexttick()},"focus":_vm.onFocusDireita,"blur":_vm.onBlurDireita},model:{value:(_vm.pagina.margin.right),callback:function ($$v) {_vm.$set(_vm.pagina.margin, "right", $$v)},expression:"pagina.margin.right"}})],1)],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-12"},[_c('canvas',{staticClass:"pagina",attrs:{"id":"canvas","width":(_vm.mmTopx(_vm.pagina.largura)*1.5),"height":(_vm.mmTopx(_vm.pagina.altura)*1.5)}})])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strong',{staticClass:"lbl-list-title text-secondary"},[_vm._v("Produto")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[_c('strong',{staticClass:"lbl-list-title text-secondary"},[_vm._v("Dados da Empresa")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[_c('strong',{staticClass:"lbl-list-title text-secondary"},[_vm._v("Outros")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1057);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a59bdcfc", content, true, {});

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-cert-page-header{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:16px}.nb-cert-title-wrap{flex:1 1 auto;min-width:0}.nb-cert-page-title{margin:0;color:#0b1c30;font-size:22px;font-weight:700;line-height:1.3}.nb-cert-filial-meta{display:flex;flex-wrap:wrap;align-items:center;column-gap:12px;row-gap:3px;margin-top:4px}.nb-cert-filial-meta>strong{color:#334155;font-size:14px;font-weight:600;overflow-wrap:anywhere}.nb-cert-filial-cnpj{color:#64748b;font-size:12px;white-space:nowrap}.nb-cert-back-action{flex:0 0 auto;white-space:nowrap}.nb-cert-status{--cert-status-color:#64748b;--cert-status-bg:#f1f5f9;--cert-status-border:#cbd5e1;display:block;padding:16px 18px;background:#fff;border:1px solid #e2e8f0;border-left:4px solid var(--cert-status-color);border-radius:12px;box-shadow:0 1px 3px rgba(0,0,0,.04)}.nb-cert-status-summary{display:flex;align-items:flex-start;gap:14px}.nb-cert-status-record{margin:14px 0 0 56px;padding-top:14px;border-top:1px solid #e2e8f0}.nb-cert-status--valido{--cert-status-color:#059669;--cert-status-bg:#ecfdf5;--cert-status-border:#a7f3d0}.nb-cert-status--pendente,.nb-cert-status--proximo,.nb-cert-status--vence-hoje{--cert-status-color:#d97706;--cert-status-bg:#fffbeb;--cert-status-border:#fde68a}.nb-cert-status--vencido{--cert-status-color:#dc2626;--cert-status-bg:#fef2f2;--cert-status-border:#fecaca}.nb-cert-status--indisponivel{--cert-status-color:#64748b;--cert-status-bg:#f1f5f9;--cert-status-border:#cbd5e1}.nb-cert-status-icon{display:flex;flex:0 0 42px;width:42px;height:42px;align-items:center;justify-content:center;color:var(--cert-status-color);background:var(--cert-status-bg);border-radius:10px;font-size:19px}.nb-cert-status-content{flex:1;min-width:0}.nb-cert-status-heading{display:flex;flex-wrap:wrap;align-items:center;gap:8px}.nb-cert-status-heading h3{margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.4}.nb-cert-status-badge{padding:3px 8px;color:var(--cert-status-color);background:var(--cert-status-bg);border:1px solid var(--cert-status-border);border-radius:6px;font-size:11px;font-weight:700;line-height:1.4}.nb-cert-status-detail{margin:3px 0 0;color:#64748b;font-size:12px}.nb-cert-expiry{display:flex;flex-wrap:wrap;justify-content:space-between;gap:4px 16px;margin-top:10px;color:#475569;font-size:12px}.nb-cert-expiry-days{color:var(--cert-status-color);font-weight:700}.nb-cert-progress{height:6px;margin-top:7px;overflow:hidden;background:#f1f5f9;border-radius:10px}.nb-cert-progress-bar{height:100%;background:var(--cert-status-color);border-radius:inherit;transition:width .25s ease}.nb-cert-a1-form,.nb-cert-a1-help,.nb-cert-setup,.nb-cert-type-section{padding:20px;background:#fff;border:1px solid #e2e8f0;border-radius:12px}.nb-cert-section-heading{margin-bottom:14px}.nb-cert-a1-form h3,.nb-cert-a1-help h4,.nb-cert-section-heading h3,.nb-cert-setup-heading h3{margin:0;color:#0b1c30;font-size:16px;font-weight:700}.nb-cert-a1-form>p,.nb-cert-a1-help>p,.nb-cert-section-heading p,.nb-cert-setup-heading p{margin:4px 0 0;color:#64748b;font-size:13px}.nb-cert-type-card{display:flex;min-height:82px;align-items:center;gap:12px;padding:15px;margin:0;color:#0b1c30;background:#fff;border:1px solid #cbd5e1;border-radius:10px;cursor:pointer;transition:border-color .15s ease,background-color .15s ease,box-shadow .15s ease}.nb-cert-type-card.is-selected,.nb-cert-type-card:hover{background:#f8fbff;border-color:#004e94;box-shadow:0 0 0 2px rgba(0,78,148,.08)}.nb-cert-type-card:focus-within{outline:2px solid #004e94;outline-offset:2px}.nb-cert-type-icon{display:flex;flex:0 0 42px;width:42px;height:42px;align-items:center;justify-content:center;color:#004e94;background:#eff4ff;border-radius:9px;font-size:18px}.nb-cert-type-copy{display:flex;flex:1;flex-direction:column;gap:3px}.nb-cert-type-copy strong{font-size:14px;font-weight:700}.nb-cert-type-copy small{color:#64748b;font-size:12px}.nb-cert-type-check{display:flex;width:22px;height:22px;flex:0 0 22px;align-items:center;justify-content:center;color:#fff;background:transparent;border:1px solid #cbd5e1;border-radius:50%;font-size:11px}.nb-cert-type-card.is-selected .nb-cert-type-check{background:#004e94;border-color:#004e94}.nb-cert-setup-heading{display:flex;flex-wrap:wrap;align-items:flex-start;justify-content:space-between;gap:12px 20px;padding-bottom:14px;border-bottom:1px solid #e2e8f0}.nb-cert-help{width:min(100%,360px);color:#004e94;font-size:13px}.nb-cert-help summary{cursor:pointer;font-weight:600}.nb-cert-steps{display:flex;flex-direction:column;gap:10px;padding-top:14px}.nb-cert-step{display:flex;align-items:center;gap:14px;padding:13px 14px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:9px}.nb-cert-step-number{display:flex;flex:0 0 30px;width:30px;height:30px;align-items:center;justify-content:center;color:#004e94;background:#eff4ff;border-radius:50%;font-size:13px;font-weight:700}.nb-cert-step-copy{flex:1;min-width:0}.nb-cert-step-copy h4{margin:0;color:#0b1c30;font-size:13px;font-weight:700}.nb-cert-step-copy p{margin:2px 0 0;color:#64748b;font-size:12px}.nb-cert-step-action{flex:0 0 auto}.nb-cert-a1-help{background:#f8fafc}.nb-cert-a1-help .embed-responsive{margin-top:12px;border-radius:8px;overflow:hidden}.cert-title{margin-bottom:32px;font-size:30.4px;font-weight:300;font-style:normal;font-stretch:normal;line-height:1.58;letter-spacing:-.5px;color:#222}.cert-button{border:2px solid #267da5!important;border-radius:.7rem;margin-top:50px;cursor:pointer;width:200px!important;height:45px!important;background-color:#267da5!important;color:#fff!important;font-size:15px!important}.numero{display:inline-block;margin-right:10px;line-height:28px;width:32px;height:32px;text-align:center;border:2px solid #bdbdbd;border-radius:50px;color:#3e2f68;text-shadow:0 1px 0 rgba(0,0,0,.5);box-shadow:0 0 1px 1px #e0e0e0;background-color:#fff}@media (max-width:575.98px){.nb-cert-page-header{align-items:flex-start}.nb-cert-page-title{font-size:19px}.nb-cert-status{padding:14px}.nb-cert-status-summary{gap:10px}.nb-cert-status-icon{flex-basis:36px;width:36px;height:36px;font-size:16px}.nb-cert-status-record{margin-left:46px}.nb-cert-a1-form,.nb-cert-a1-help,.nb-cert-setup,.nb-cert-type-section{padding:15px}.nb-cert-step{align-items:flex-start;flex-wrap:wrap}.nb-cert-step-action{margin-left:44px}.nb-cert-status-heading h3{font-size:14px}}", ""]);

// exports


/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_certificado_form_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2bc6ee4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_certificado_form_vue__ = __webpack_require__(1061);
function injectStyle (ssrContext) {
  __webpack_require__(1059)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_certificado_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2bc6ee4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_certificado_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1060);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e5ed89ec", content, true, {});

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.configurarNovoCertificado)?_c('div',{staticClass:"row mb-3"},[_c('form-field',{attrs:{"type":"text","col":"12","label":"Certificado Emitido Para","disabled":true},model:{value:(_vm.certificado[0].nome),callback:function ($$v) {_vm.$set(_vm.certificado[0], "nome", $$v)},expression:"certificado[0].nome"}}),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 nb-margin-top mb-3"},[_c('v-button',{attrs:{"label":"Excluir Certificado Atual","title":"Remove o certificado vinculado atualmente","icon":"fa-trash","nb-btdef":true},on:{"click":_vm.handleDeleteFile}}),_vm._v(" "),(!_vm.filial.certificado[0].filename)?_c('v-button',{attrs:{"label":"Atualizar Nota Brasil A3","nb-btdef":true},on:{"click":_vm.handleDownloadA3}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.configurarNovoCertificado)?_c('div',{staticClass:"row nb-margin-top mb-3"},[_c('form-field',{attrs:{"type":"text","col":"12","label":"Arquivo","disabled":true},model:{value:(_vm.selectedFile.name),callback:function ($$v) {_vm.$set(_vm.selectedFile, "name", $$v)},expression:"selectedFile.name"}}),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 mb-3"},[_c('v-button',{attrs:{"label":"Selecionar Arquivo","nb-btdef":true,"icon":"fa-folder"},on:{"click":function($event){return _vm.handleFileSelectBtn()}}})],1),_vm._v(" "),_c('form-field',{ref:"senha",attrs:{"type":"password","col":"12","label":"Senha"},on:{"key":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSend()}},model:{value:(_vm.senha1),callback:function ($$v) {_vm.senha1=$$v},expression:"senha1"}}),_vm._v(" "),(_vm.message)?_c('div',{staticClass:"col-md-12 col-12 mb-3"},[_c('span',{staticClass:"error"},[_vm._v(_vm._s(_vm.message))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 mb-3"},[(_vm.selectedFile.name)?_c('v-button',{attrs:{"label":"Enviar Certificado","nb-btdef":true},on:{"click":function($event){return _vm.handleSend()}}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('input',{ref:"file",attrs:{"type":"file","accept":".pfx"},on:{"change":function($event){return _vm.handleFileUpload()}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1063);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0e42ffbc", content, true, {});

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-cert-alert-banner[data-v-0373086a]{background-color:#eccf34;padding:16px;border-radius:12px;margin:14px 0;display:flex;flex-direction:column;align-items:center;gap:16px;width:100%;box-sizing:border-box}@media (min-width:992px){.nb-cert-alert-banner[data-v-0373086a]{flex-direction:row;justify-content:space-between;padding:16px 20px;gap:20px;border-radius:0 12px 0 12px}}.nb-cert-alert-img-box[data-v-0373086a]{background-color:#fff;padding:8px 12px;border-radius:10px;display:flex;justify-content:center;align-items:center;flex-shrink:0;width:160px;box-sizing:border-box}@media (min-width:992px){.nb-cert-alert-img-box[data-v-0373086a]{width:180px;padding:12px;border-radius:0 10px 0 10px}}.nb-cert-alert-content[data-v-0373086a]{flex:1 1 auto;min-width:0;width:100%}@media (max-width:991px){.nb-cert-alert-content[data-v-0373086a]{text-align:center}}.nb-cert-alert-title[data-v-0373086a]{color:#211c1e;font-size:18px;font-weight:700;line-height:1.35;margin-bottom:10px}@media (min-width:576px){.nb-cert-alert-title[data-v-0373086a]{font-size:20px}}@media (min-width:992px){.nb-cert-alert-title[data-v-0373086a]{font-size:24px;line-height:1.3}}.nb-cert-tag-white[data-v-0373086a]{background-color:#fff;border-radius:6px;padding:2px 8px;display:inline-block;margin-right:4px;box-shadow:0 1px 2px rgba(0,0,0,.05)}.nb-cert-alert-desc[data-v-0373086a]{color:#211c1e;font-size:13.5px;line-height:1.5;opacity:.92}.nb-cert-alert-cta-box[data-v-0373086a]{background-color:#fff;padding:16px;border-radius:10px;display:flex;flex-direction:column;justify-content:center;align-items:center;gap:10px;width:100%;flex-shrink:0;box-sizing:border-box}@media (min-width:992px){.nb-cert-alert-cta-box[data-v-0373086a]{width:230px;max-width:30%;padding:20px 14px;border-radius:0 10px 0 10px}}.nb-cert-badge-offer[data-v-0373086a]{font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.3px;padding:4px 8px}.nb-cert-price-wrap[data-v-0373086a]{display:flex;flex-direction:column;align-items:center;text-align:center}.nb-cert-model-text[data-v-0373086a]{font-size:14.5px;font-weight:600;color:#334155}.nb-cert-price-val[data-v-0373086a]{color:#0b1c30;display:flex;align-items:baseline;justify-content:center;gap:3px}.nb-cert-currency[data-v-0373086a]{font-size:14px;font-weight:600;color:#334155}.nb-cert-amount[data-v-0373086a]{font-size:26px;font-weight:700;line-height:1.1}.nb-cert-btn-buy[data-v-0373086a]{color:#fff!important;background-color:#004e94;border:1px solid #004e94;padding:10px 18px;font-size:13.5px;font-weight:600;border-radius:6px;width:100%;display:inline-flex;align-items:center;justify-content:center;text-decoration:none!important;transition:background-color .15s ease,transform .1s ease;cursor:pointer}.nb-cert-btn-buy[data-v-0373086a]:hover{background-color:#00386b;border-color:#00386b;transform:translateY(-1px)}.nb-cert-btn-buy[data-v-0373086a]:active{transform:translateY(0)}", ""]);

// exports


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1065);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("ca989bae", content, true, {});

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-step-svg-wrapper[data-v-0fc63062]{width:100%;display:flex;justify-content:center;align-items:center;border-radius:10px;overflow:hidden;transition:transform .25s ease,filter .25s ease}.nb-step-svg[data-v-0fc63062]{width:100%;max-width:260px;height:auto;aspect-ratio:220/130;display:block}.nb-step-svg-wrapper:hover .nb-step-svg[data-v-0fc63062]{transform:scale(1.02);transition:transform .25s ease}.nb-step-svg-wrapper.is-completed[data-v-0fc63062]{filter:saturate(1.05)}", ""]);

// exports


/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-step-svg-wrapper",class:{ 'is-completed': _vm.completed }},[(_vm.step === 'guianfe_empresa')?_c('svg',{staticClass:"nb-step-svg",attrs:{"viewBox":"0 0 220 130","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"v_emp_bg","x1":"110","y1":"10","x2":"110","y2":"120","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#EFF4FF","stop-opacity":"0.9"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#DBEAFE","stop-opacity":"0.35"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_emp_bldg","x1":"110","y1":"28","x2":"110","y2":"112","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FFFFFF"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#F8FAFC"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_emp_badge","x1":"128","y1":"20","x2":"206","y2":"20","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#004E94"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#00376C"}})],1),_vm._v(" "),_c('filter',{attrs:{"id":"v_emp_shadow","x":"124","y":"16","width":"88","height":"52","filterUnits":"userSpaceOnUse"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"4","stdDeviation":"4","flood-color":"#004E94","flood-opacity":"0.14"}})],1),_vm._v(" "),_c('filter',{attrs:{"id":"v_emp_bldg_shadow","x":"38","y":"24","width":"144","height":"98","filterUnits":"userSpaceOnUse"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"6","stdDeviation":"5","flood-color":"#0B1C30","flood-opacity":"0.08"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"x":"15","y":"10","width":"190","height":"110","rx":"16","fill":"url(#v_emp_bg)"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"175","cy":"35","r":"28","fill":"#DBEAFE","fill-opacity":"0.5"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"45","cy":"85","r":"22","fill":"#E0F2FE","fill-opacity":"0.6"}}),_vm._v(" "),_c('path',{attrs:{"d":"M25 112H195","stroke":"#CBD5E1","stroke-width":"2.5","stroke-linecap":"round"}}),_vm._v(" "),_c('g',{attrs:{"filter":"url(#v_emp_bldg_shadow)"}},[_c('rect',{attrs:{"x":"46","y":"60","width":"40","height":"52","rx":"4","fill":"#FFFFFF","stroke":"#004E94","stroke-width":"1.8"}}),_vm._v(" "),_c('path',{attrs:{"d":"M44 60H88","stroke":"#00376C","stroke-width":"2.5","stroke-linecap":"round"}}),_vm._v(" "),_c('rect',{attrs:{"x":"54","y":"80","width":"24","height":"32","rx":"2","fill":"#F1F5F9","stroke":"#94A3B8","stroke-width":"1.2"}}),_vm._v(" "),_c('line',{attrs:{"x1":"54","y1":"88","x2":"78","y2":"88","stroke":"#CBD5E1","stroke-width":"1"}}),_vm._v(" "),_c('line',{attrs:{"x1":"54","y1":"96","x2":"78","y2":"96","stroke":"#CBD5E1","stroke-width":"1"}}),_vm._v(" "),_c('line',{attrs:{"x1":"54","y1":"104","x2":"78","y2":"104","stroke":"#CBD5E1","stroke-width":"1"}}),_vm._v(" "),_c('rect',{attrs:{"x":"80","y":"28","width":"58","height":"84","rx":"5","fill":"url(#v_emp_bldg)","stroke":"#004E94","stroke-width":"2"}}),_vm._v(" "),_c('rect',{attrs:{"x":"77","y":"24","width":"64","height":"6","rx":"2.5","fill":"#00376C"}}),_vm._v(" "),_c('line',{attrs:{"x1":"109","y1":"14","x2":"109","y2":"24","stroke":"#004E94","stroke-width":"2","stroke-linecap":"round"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"109","cy":"13","r":"3","fill":"#0EA5E9"}}),_vm._v(" "),_c('path',{attrs:{"d":"M103 13C103 9.686 105.686 7 109 7C112.314 7 115 9.686 115 13","stroke":"#0EA5E9","stroke-width":"1.2","stroke-linecap":"round","stroke-opacity":"0.6"}}),_vm._v(" "),_c('rect',{attrs:{"x":"87","y":"36","width":"10","height":"8","rx":"1.5","fill":"#0EA5E9"}}),_vm._v(" "),_c('rect',{attrs:{"x":"104","y":"36","width":"10","height":"8","rx":"1.5","fill":"#38BDF8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"121","y":"36","width":"10","height":"8","rx":"1.5","fill":"#0EA5E9"}}),_vm._v(" "),_c('rect',{attrs:{"x":"87","y":"50","width":"10","height":"8","rx":"1.5","fill":"#38BDF8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"104","y":"50","width":"10","height":"8","rx":"1.5","fill":"#EFF4FF","stroke":"#0EA5E9","stroke-width":"0.8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"121","y":"50","width":"10","height":"8","rx":"1.5","fill":"#38BDF8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"87","y":"64","width":"10","height":"8","rx":"1.5","fill":"#0EA5E9"}}),_vm._v(" "),_c('rect',{attrs:{"x":"104","y":"64","width":"10","height":"8","rx":"1.5","fill":"#0EA5E9"}}),_vm._v(" "),_c('rect',{attrs:{"x":"121","y":"64","width":"10","height":"8","rx":"1.5","fill":"#EFF4FF","stroke":"#0EA5E9","stroke-width":"0.8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"87","y":"78","width":"10","height":"8","rx":"1.5","fill":"#EFF4FF","stroke":"#0EA5E9","stroke-width":"0.8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"104","y":"78","width":"10","height":"8","rx":"1.5","fill":"#38BDF8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"121","y":"78","width":"10","height":"8","rx":"1.5","fill":"#0EA5E9"}}),_vm._v(" "),_c('rect',{attrs:{"x":"101","y":"94","width":"16","height":"18","rx":"2","fill":"#00376C"}}),_vm._v(" "),_c('rect',{attrs:{"x":"103","y":"96","width":"5","height":"16","rx":"1","fill":"#EFF4FF","fill-opacity":"0.9"}}),_vm._v(" "),_c('rect',{attrs:{"x":"110","y":"96","width":"5","height":"16","rx":"1","fill":"#EFF4FF","fill-opacity":"0.9"}}),_vm._v(" "),_c('rect',{attrs:{"x":"134","y":"68","width":"34","height":"44","rx":"3","fill":"#FFFFFF","stroke":"#004E94","stroke-width":"1.8"}}),_vm._v(" "),_c('path',{attrs:{"d":"M132 68H170","stroke":"#00376C","stroke-width":"2.5","stroke-linecap":"round"}}),_vm._v(" "),_c('rect',{attrs:{"x":"140","y":"76","width":"8","height":"7","rx":"1.5","fill":"#0EA5E9"}}),_vm._v(" "),_c('rect',{attrs:{"x":"154","y":"76","width":"8","height":"7","rx":"1.5","fill":"#38BDF8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"140","y":"89","width":"8","height":"7","rx":"1.5","fill":"#EFF4FF","stroke":"#0EA5E9","stroke-width":"0.8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"154","y":"89","width":"8","height":"7","rx":"1.5","fill":"#0EA5E9"}})]),_vm._v(" "),_c('g',{attrs:{"filter":"url(#v_emp_shadow)"}},[_c('rect',{attrs:{"x":"128","y":"20","width":"78","height":"38","rx":"7","fill":"#FFFFFF","stroke":"#E2E8F0","stroke-width":"1.5"}}),_vm._v(" "),_c('path',{attrs:{"d":"M128 27C128 23.134 131.134 20 135 20H199C202.866 20 206 23.134 206 27V33H128V27Z","fill":"url(#v_emp_badge)"}}),_vm._v(" "),_c('text',{attrs:{"x":"167","y":"26.5","text-anchor":"middle","dominant-baseline":"central","fill":"#FFFFFF","font-family":"'Inter', sans-serif","font-size":"6.5","font-weight":"700","letter-spacing":"0.4"}},[_vm._v("DADOS DA EMPRESA")]),_vm._v(" "),_c('rect',{attrs:{"x":"135","y":"38","width":"34","height":"3","rx":"1.5","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"135","y":"45","width":"46","height":"2.5","rx":"1","fill":"#94A3B8"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"194","cy":"42","r":"6.5","fill":"#10B981"}}),_vm._v(" "),_c('path',{attrs:{"d":"M191.5 42L193.5 44L196.5 40.5","stroke":"#FFFFFF","stroke-width":"1.3","stroke-linecap":"round","stroke-linejoin":"round"}})]),_vm._v(" "),_c('path',{attrs:{"d":"M36 42L37.5 46L41.5 47.5L37.5 49L36 53L34.5 49L30.5 47.5L34.5 46L36 42Z","fill":"#F59E0B"}})]):(_vm.step === 'guianfe_certificado')?_c('svg',{staticClass:"nb-step-svg",attrs:{"viewBox":"0 0 220 130","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"v_cert_bg","x1":"110","y1":"10","x2":"110","y2":"120","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#EFF4FF","stop-opacity":"0.9"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#DBEAFE","stop-opacity":"0.35"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_cert_card","x1":"38","y1":"28","x2":"148","y2":"102","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FFFFFF"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#F8FAFC"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_cert_hdr","x1":"36","y1":"28","x2":"148","y2":"28","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#004E94"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#00376C"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_cert_chip","x1":"50","y1":"50","x2":"70","y2":"68","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FBBF24"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#D97706"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_cert_lock","x1":"140","y1":"52","x2":"182","y2":"94","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#004E94"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#002D57"}})],1),_vm._v(" "),_c('filter',{attrs:{"id":"v_cert_card_shadow","x":"30","y":"24","width":"128","height":"88","filterUnits":"userSpaceOnUse"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"5","stdDeviation":"5","flood-color":"#0B1C30","flood-opacity":"0.09"}})],1),_vm._v(" "),_c('filter',{attrs:{"id":"v_cert_lock_shadow","x":"126","y":"26","width":"68","height":"84","filterUnits":"userSpaceOnUse"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"6","stdDeviation":"6","flood-color":"#004E94","flood-opacity":"0.25"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"x":"15","y":"10","width":"190","height":"110","rx":"16","fill":"url(#v_cert_bg)"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"160","cy":"65","r":"38","fill":"#DBEAFE","fill-opacity":"0.4"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"160","cy":"65","r":"48","stroke":"#BFDBFE","stroke-width":"1","stroke-dasharray":"3 3"}}),_vm._v(" "),_c('g',{attrs:{"filter":"url(#v_cert_card_shadow)"}},[_c('rect',{attrs:{"x":"36","y":"28","width":"112","height":"74","rx":"8","fill":"url(#v_cert_card)","stroke":"#004E94","stroke-width":"1.8"}}),_vm._v(" "),_c('path',{attrs:{"d":"M36 36C36 31.582 39.582 28 44 28H140C144.418 28 148 31.582 148 36V44H36V36Z","fill":"url(#v_cert_hdr)"}}),_vm._v(" "),_c('text',{attrs:{"x":"92","y":"36","text-anchor":"middle","dominant-baseline":"central","fill":"#FFFFFF","font-family":"'Inter', sans-serif","font-size":"7.5","font-weight":"700","letter-spacing":"0.5"}},[_vm._v(_vm._s(_vm.label || 'CERTIFICADO A1 / A3'))]),_vm._v(" "),_c('rect',{attrs:{"x":"48","y":"52","width":"22","height":"18","rx":"3.5","fill":"url(#v_cert_chip)","stroke":"#B45309","stroke-width":"1"}}),_vm._v(" "),_c('line',{attrs:{"x1":"48","y1":"61","x2":"70","y2":"61","stroke":"#B45309","stroke-width":"0.8"}}),_vm._v(" "),_c('line',{attrs:{"x1":"59","y1":"52","x2":"59","y2":"70","stroke":"#B45309","stroke-width":"0.8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"54","y":"56","width":"10","height":"10","rx":"1","fill":"#FEF3C7","stroke":"#B45309","stroke-width":"0.7"}}),_vm._v(" "),_c('rect',{attrs:{"x":"76","y":"53","width":"46","height":"3","rx":"1.5","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"76","y":"60","width":"56","height":"2.5","rx":"1","fill":"#64748B"}}),_vm._v(" "),_c('rect',{attrs:{"x":"76","y":"66","width":"38","height":"2.5","rx":"1","fill":"#94A3B8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"48","y":"78","width":"36","height":"12","rx":"4","fill":"#ECFDF5","stroke":"#A7F3D0","stroke-width":"1"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"55","cy":"84","r":"2.5","fill":"#10B981"}}),_vm._v(" "),_c('rect',{attrs:{"x":"61","y":"82.5","width":"18","height":"3","rx":"1.5","fill":"#059669"}})]),_vm._v(" "),_c('g',{attrs:{"filter":"url(#v_cert_lock_shadow)"}},[_c('path',{attrs:{"d":"M148 52V42C148 35.373 153.373 30 160 30C166.627 30 172 35.373 172 42V52","stroke":"#F59E0B","stroke-width":"4.5","stroke-linecap":"round"}}),_vm._v(" "),_c('rect',{attrs:{"x":"138","y":"50","width":"44","height":"42","rx":"9","fill":"url(#v_cert_lock)","stroke":"#00376C","stroke-width":"1.5"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"160","cy":"68","r":"4.5","fill":"#FFFFFF"}}),_vm._v(" "),_c('path',{attrs:{"d":"M158.5 70L157.5 77H162.5L161.5 70H158.5Z","fill":"#FFFFFF"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"178","cy":"86","r":"9","fill":"#10B981","stroke":"#FFFFFF","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M174.5 86L177 88.5L181.5 83.5","stroke":"#FFFFFF","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}})]),_vm._v(" "),_c('path',{attrs:{"d":"M192 48L193.5 52L197.5 53.5L193.5 55L192 59L190.5 55L186.5 53.5L190.5 52L192 48Z","fill":"#F59E0B"}})]):(_vm.step === 'guianfe_item')?_c('svg',{staticClass:"nb-step-svg",attrs:{"viewBox":"0 0 220 130","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"v_item_bg","x1":"110","y1":"10","x2":"110","y2":"120","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#EFF4FF","stop-opacity":"0.9"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#DBEAFE","stop-opacity":"0.35"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_item_top","x1":"60","y1":"36","x2":"135","y2":"60","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#DBEAFE"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#BFDBFE"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_item_left","x1":"60","y1":"58","x2":"105","y2":"105","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#004E94"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#00376C"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_item_right","x1":"105","y1":"58","x2":"150","y2":"105","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#0EA5E9"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#0284C7"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_item_tag","x1":"136","y1":"22","x2":"204","y2":"62","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FFFFFF"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#F8FAFC"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_item_plus","x1":"32","y1":"32","x2":"60","y2":"60","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#004E94"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#0EA5E9"}})],1),_vm._v(" "),_c('filter',{attrs:{"id":"v_item_box_shadow","x":"50","y":"32","width":"112","height":"84","filterUnits":"userSpaceOnUse"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"8","stdDeviation":"6","flood-color":"#004E94","flood-opacity":"0.22"}})],1),_vm._v(" "),_c('filter',{attrs:{"id":"v_item_tag_shadow","x":"128","y":"16","width":"82","height":"56","filterUnits":"userSpaceOnUse"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"4","stdDeviation":"4","flood-color":"#0B1C30","flood-opacity":"0.12"}})],1),_vm._v(" "),_c('filter',{attrs:{"id":"v_item_plus_shadow","x":"28","y":"28","width":"38","height":"38","filterUnits":"userSpaceOnUse"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"3","stdDeviation":"3","flood-color":"#004E94","flood-opacity":"0.25"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"x":"15","y":"10","width":"190","height":"110","rx":"16","fill":"url(#v_item_bg)"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"105","cy":"72","r":"42","fill":"#DBEAFE","fill-opacity":"0.5"}}),_vm._v(" "),_c('ellipse',{attrs:{"cx":"106","cy":"110","rx":"48","ry":"7","fill":"#CBD5E1","fill-opacity":"0.7"}}),_vm._v(" "),_c('g',{attrs:{"filter":"url(#v_item_box_shadow)"}},[_c('path',{attrs:{"d":"M106 38L148 54L106 70L64 54L106 38Z","fill":"url(#v_item_top)","stroke":"#00376C","stroke-width":"1.5","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M96 42L116 49.5L116 66L96 58.5L96 42Z","fill":"#93C5FD","fill-opacity":"0.8"}}),_vm._v(" "),_c('path',{attrs:{"d":"M64 54L106 70V105L64 89V54Z","fill":"url(#v_item_left)","stroke":"#00376C","stroke-width":"1.5","stroke-linejoin":"round"}}),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(1 0.38 0 0.92 72 63)"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"24","height":"16","rx":"2","fill":"#FFFFFF","fill-opacity":"0.95"}}),_vm._v(" "),_c('rect',{attrs:{"x":"3","y":"3","width":"1.5","height":"10","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"6","y":"3","width":"2.5","height":"10","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"9.5","y":"3","width":"1","height":"10","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"12","y":"3","width":"3","height":"10","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"16","y":"3","width":"1.2","height":"10","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"18.5","y":"3","width":"2","height":"10","fill":"#0B1C30"}})]),_vm._v(" "),_c('path',{attrs:{"d":"M106 70L148 54V89L106 105V70Z","fill":"url(#v_item_right)","stroke":"#00376C","stroke-width":"1.5","stroke-linejoin":"round"}}),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(1 -0.38 0 0.92 118 84)"}},[_c('path',{attrs:{"d":"M5 12V4M5 4L2 7M5 4L8 7","stroke":"#FFFFFF","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14 12V4M14 4L11 7M14 4L17 7","stroke":"#FFFFFF","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])]),_vm._v(" "),_c('g',{attrs:{"filter":"url(#v_item_tag_shadow)"}},[_c('path',{attrs:{"d":"M150 22C144 16 136 18 130 24","stroke":"#004E94","stroke-width":"1.5","stroke-linecap":"round","fill":"none"}}),_vm._v(" "),_c('rect',{attrs:{"x":"134","y":"22","width":"70","height":"38","rx":"7","fill":"url(#v_item_tag)","stroke":"#0EA5E9","stroke-width":"1.8"}}),_vm._v(" "),_c('path',{attrs:{"d":"M134 29C134 25.134 137.134 22 141 22H197C200.866 22 204 25.134 204 29V34H134V29Z","fill":"#EFF4FF"}}),_vm._v(" "),_c('text',{attrs:{"x":"169","y":"28","text-anchor":"middle","dominant-baseline":"central","fill":"#004E94","font-family":"'Inter', sans-serif","font-size":"7.5","font-weight":"800","letter-spacing":"0.5"}},[_vm._v("PRODUTOS")]),_vm._v(" "),_c('rect',{attrs:{"x":"142","y":"42","width":"22","height":"6","rx":"2","fill":"#ECFDF5","stroke":"#A7F3D0","stroke-width":"0.8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"145","y":"44","width":"16","height":"2","rx":"1","fill":"#059669"}}),_vm._v(" "),_c('rect',{attrs:{"x":"168","y":"43.5","width":"28","height":"3","rx":"1.5","fill":"#004E94"}})]),_vm._v(" "),_c('g',{attrs:{"filter":"url(#v_item_plus_shadow)"}},[_c('circle',{attrs:{"cx":"47","cy":"47","r":"14","fill":"url(#v_item_plus_grad)"}}),_vm._v(" "),_c('path',{attrs:{"d":"M47 41V53M41 47H53","stroke":"#FFFFFF","stroke-width":"2.5","stroke-linecap":"round"}})]),_vm._v(" "),_c('path',{attrs:{"d":"M34 85L35.5 88.5L39 90L35.5 91.5L34 95L32.5 91.5L29 90L32.5 88.5L34 85Z","fill":"#F59E0B"}})]):(_vm.step === 'guianfe_part')?_c('svg',{staticClass:"nb-step-svg",attrs:{"viewBox":"0 0 220 130","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"v_part_bg","x1":"110","y1":"10","x2":"110","y2":"120","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#EFF4FF","stop-opacity":"0.9"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#DBEAFE","stop-opacity":"0.35"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_part_card","x1":"42","y1":"24","x2":"152","y2":"104","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FFFFFF"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#F8FAFC"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_part_hdr","x1":"42","y1":"24","x2":"152","y2":"24","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#004E94"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#00376C"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_part_sup","x1":"140","y1":"42","x2":"186","y2":"88","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#0EA5E9"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#0284C7"}})],1),_vm._v(" "),_c('filter',{attrs:{"id":"v_part_card_shadow","x":"34","y":"20","width":"128","height":"92","filterUnits":"userSpaceOnUse"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"5","stdDeviation":"5","flood-color":"#0B1C30","flood-opacity":"0.09"}})],1),_vm._v(" "),_c('filter',{attrs:{"id":"v_part_sup_shadow","x":"134","y":"38","width":"58","height":"58","filterUnits":"userSpaceOnUse"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"4","stdDeviation":"4","flood-color":"#0EA5E9","flood-opacity":"0.25"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"x":"15","y":"10","width":"190","height":"110","rx":"16","fill":"url(#v_part_bg)"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"95","cy":"65","r":"42","fill":"#DBEAFE","fill-opacity":"0.4"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"165","cy":"65","r":"32","fill":"#E0F2FE","fill-opacity":"0.5"}}),_vm._v(" "),_c('path',{attrs:{"d":"M120 62C130 62 135 62 145 62","stroke":"#38BDF8","stroke-width":"2.5","stroke-dasharray":"3 3"}}),_vm._v(" "),_c('g',{attrs:{"filter":"url(#v_part_card_shadow)"}},[_c('rect',{attrs:{"x":"42","y":"24","width":"110","height":"78","rx":"8","fill":"url(#v_part_card)","stroke":"#004E94","stroke-width":"1.8"}}),_vm._v(" "),_c('path',{attrs:{"d":"M42 32C42 27.582 45.582 24 50 24H144C148.418 24 152 27.582 152 32V40H42V32Z","fill":"url(#v_part_hdr)"}}),_vm._v(" "),_c('text',{attrs:{"x":"97","y":"32","text-anchor":"middle","dominant-baseline":"central","fill":"#FFFFFF","font-family":"'Inter', sans-serif","font-size":"7","font-weight":"700","letter-spacing":"0.5"}},[_vm._v("CLIENTES E PARCEIROS")]),_vm._v(" "),_c('circle',{attrs:{"cx":"64","cy":"58","r":"13","fill":"#EFF4FF","stroke":"#004E94","stroke-width":"1.5"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"64","cy":"54","r":"4.5","fill":"#004E94"}}),_vm._v(" "),_c('path',{attrs:{"d":"M55 68C55 63 59 62.5 64 62.5C69 62.5 73 63 73 68","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"85","y":"49","width":"56","height":"4","rx":"2","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"85","y":"57","width":"42","height":"3","rx":"1.5","fill":"#64748B"}}),_vm._v(" "),_c('rect',{attrs:{"x":"85","y":"63","width":"34","height":"2.5","rx":"1","fill":"#94A3B8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"52","y":"78","width":"40","height":"14","rx":"4","fill":"#EFF4FF","stroke":"#BFDBFE","stroke-width":"1"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"60","cy":"85","r":"3.5","fill":"#10B981"}}),_vm._v(" "),_c('path',{attrs:{"d":"M58.5 85L59.5 86L61.5 84","stroke":"#FFFFFF","stroke-width":"1","stroke-linecap":"round"}}),_vm._v(" "),_c('rect',{attrs:{"x":"67","y":"83.5","width":"18","height":"3","rx":"1.5","fill":"#004E94"}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(104, 76)"}},[_c('circle',{attrs:{"cx":"7","cy":"7","r":"7","fill":"#FEF2F2","stroke":"#FECACA","stroke-width":"1"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7 4C5.343 4 4 5.343 4 7C4 9.25 7 12 7 12C7 12 10 9.25 10 7C10 5.343 8.657 4 7 4Z","fill":"#EF4444"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"7","cy":"7","r":"1.2","fill":"#FFFFFF"}})]),_vm._v(" "),_c('rect',{attrs:{"x":"122","y":"82","width":"22","height":"3","rx":"1.5","fill":"#CBD5E1"}})]),_vm._v(" "),_c('g',{attrs:{"filter":"url(#v_part_sup_shadow)"}},[_c('circle',{attrs:{"cx":"163","cy":"62","r":"22","fill":"url(#v_part_sup)","stroke":"#FFFFFF","stroke-width":"2"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"163","cy":"56","r":"6","fill":"#FFFFFF"}}),_vm._v(" "),_c('path',{attrs:{"d":"M151 74C151 67.5 156.5 67 163 67C169.5 67 175 67.5 175 74","fill":"#FFFFFF"}}),_vm._v(" "),_c('path',{attrs:{"d":"M161.5 67L163 71L164.5 67H161.5Z","fill":"#004E94"}})]),_vm._v(" "),_c('circle',{attrs:{"cx":"178","cy":"77","r":"8.5","fill":"#10B981","stroke":"#FFFFFF","stroke-width":"1.8"}}),_vm._v(" "),_c('path',{attrs:{"d":"M174.5 77L177 79.5L181.5 74.5","stroke":"#FFFFFF","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M36 82L37.5 85.5L41 87L37.5 88.5L36 92L34.5 88.5L31 87L34.5 85.5L36 82Z","fill":"#F59E0B"}})]):(_vm.step === 'guianfe_venda')?_c('svg',{staticClass:"nb-step-svg",attrs:{"viewBox":"0 0 220 130","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"v_venda_bg","x1":"110","y1":"10","x2":"110","y2":"120","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#EFF4FF","stop-opacity":"0.9"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#DBEAFE","stop-opacity":"0.35"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_venda_clip","x1":"40","y1":"20","x2":"135","y2":"108","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FFFFFF"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#F8FAFC"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_venda_cart","x1":"120","y1":"52","x2":"175","y2":"100","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#004E94"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#00376C"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_venda_coin","x1":"165","y1":"22","x2":"195","y2":"52","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FBBF24"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#D97706"}})],1),_vm._v(" "),_c('filter',{attrs:{"id":"v_venda_clip_shadow","x":"32","y":"16","width":"112","height":"98","filterUnits":"userSpaceOnUse"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"5","stdDeviation":"5","flood-color":"#0B1C30","flood-opacity":"0.09"}})],1),_vm._v(" "),_c('filter',{attrs:{"id":"v_venda_cart_shadow","x":"110","y":"44","width":"76","height":"66","filterUnits":"userSpaceOnUse"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"6","stdDeviation":"5","flood-color":"#004E94","flood-opacity":"0.25"}})],1),_vm._v(" "),_c('filter',{attrs:{"id":"v_venda_coin_shadow","x":"160","y":"18","width":"40","height":"40","filterUnits":"userSpaceOnUse"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"3","stdDeviation":"3","flood-color":"#D97706","flood-opacity":"0.3"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"x":"15","y":"10","width":"190","height":"110","rx":"16","fill":"url(#v_venda_bg)"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"85","cy":"65","r":"42","fill":"#DBEAFE","fill-opacity":"0.4"}}),_vm._v(" "),_c('g',{attrs:{"filter":"url(#v_venda_clip_shadow)"}},[_c('rect',{attrs:{"x":"40","y":"22","width":"94","height":"84","rx":"7","fill":"url(#v_venda_clip)","stroke":"#004E94","stroke-width":"1.8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"70","y":"18","width":"34","height":"8","rx":"2.5","fill":"#00376C"}}),_vm._v(" "),_c('rect',{attrs:{"x":"78","y":"15","width":"18","height":"5","rx":"1.5","fill":"#94A3B8"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"87","cy":"22","r":"2","fill":"#FFFFFF"}}),_vm._v(" "),_c('text',{attrs:{"x":"87","y":"36","text-anchor":"middle","dominant-baseline":"central","fill":"#004E94","font-family":"'Inter', sans-serif","font-size":"7.5","font-weight":"800","letter-spacing":"0.4"}},[_vm._v("PEDIDO DE VENDA")]),_vm._v(" "),_c('line',{attrs:{"x1":"50","y1":"43","x2":"124","y2":"43","stroke":"#E2E8F0","stroke-width":"1"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"54","cy":"51","r":"3.5","fill":"#ECFDF5","stroke":"#10B981","stroke-width":"1"}}),_vm._v(" "),_c('path',{attrs:{"d":"M52.5 51L53.5 52L55.5 50","stroke":"#10B981","stroke-width":"1","stroke-linecap":"round"}}),_vm._v(" "),_c('rect',{attrs:{"x":"62","y":"49.5","width":"40","height":"3","rx":"1.5","fill":"#334155"}}),_vm._v(" "),_c('rect',{attrs:{"x":"108","y":"49.5","width":"14","height":"3","rx":"1.5","fill":"#0EA5E9"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"54","cy":"61","r":"3.5","fill":"#ECFDF5","stroke":"#10B981","stroke-width":"1"}}),_vm._v(" "),_c('path',{attrs:{"d":"M52.5 61L53.5 62L55.5 60","stroke":"#10B981","stroke-width":"1","stroke-linecap":"round"}}),_vm._v(" "),_c('rect',{attrs:{"x":"62","y":"59.5","width":"34","height":"3","rx":"1.5","fill":"#334155"}}),_vm._v(" "),_c('rect',{attrs:{"x":"108","y":"59.5","width":"14","height":"3","rx":"1.5","fill":"#0EA5E9"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"54","cy":"71","r":"3.5","fill":"#EFF4FF","stroke":"#004E94","stroke-width":"1"}}),_vm._v(" "),_c('rect',{attrs:{"x":"62","y":"69.5","width":"38","height":"3","rx":"1.5","fill":"#94A3B8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"108","y":"69.5","width":"14","height":"3","rx":"1.5","fill":"#0EA5E9"}}),_vm._v(" "),_c('rect',{attrs:{"x":"48","y":"80","width":"78","height":"18","rx":"4","fill":"#EFF4FF","stroke":"#BFDBFE","stroke-width":"1"}}),_vm._v(" "),_c('rect',{attrs:{"x":"54","y":"87","width":"22","height":"4","rx":"2","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"84","y":"86","width":"36","height":"6","rx":"2","fill":"#ECFDF5","stroke":"#A7F3D0","stroke-width":"0.8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"88","y":"88","width":"28","height":"2","rx":"1","fill":"#059669"}})]),_vm._v(" "),_c('g',{attrs:{"filter":"url(#v_venda_cart_shadow)"}},[_c('path',{attrs:{"d":"M120 54H127L133 80H166L172 58H130","stroke":"#0EA5E9","stroke-width":"2.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M128 58H170L165 79H133L128 58Z","fill":"url(#v_venda_cart)","fill-opacity":"0.9","stroke":"#004E94","stroke-width":"1.5"}}),_vm._v(" "),_c('line',{attrs:{"x1":"137","y1":"58","x2":"139","y2":"79","stroke":"#38BDF8","stroke-width":"1","stroke-opacity":"0.6"}}),_vm._v(" "),_c('line',{attrs:{"x1":"147","y1":"58","x2":"147","y2":"79","stroke":"#38BDF8","stroke-width":"1","stroke-opacity":"0.6"}}),_vm._v(" "),_c('line',{attrs:{"x1":"157","y1":"58","x2":"155","y2":"79","stroke":"#38BDF8","stroke-width":"1","stroke-opacity":"0.6"}}),_vm._v(" "),_c('line',{attrs:{"x1":"130","y1":"68","x2":"168","y2":"68","stroke":"#38BDF8","stroke-width":"1","stroke-opacity":"0.6"}}),_vm._v(" "),_c('rect',{attrs:{"x":"136","y":"48","width":"12","height":"12","rx":"2","fill":"#FEF3C7","stroke":"#F59E0B","stroke-width":"1"}}),_vm._v(" "),_c('rect',{attrs:{"x":"148","y":"44","width":"14","height":"14","rx":"2","fill":"#ECFDF5","stroke":"#10B981","stroke-width":"1"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"137","cy":"88","r":"4.5","fill":"#00376C","stroke":"#FFFFFF","stroke-width":"1.2"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"137","cy":"88","r":"1.5","fill":"#FFFFFF"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"162","cy":"88","r":"4.5","fill":"#00376C","stroke":"#FFFFFF","stroke-width":"1.2"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"162","cy":"88","r":"1.5","fill":"#FFFFFF"}})]),_vm._v(" "),_c('g',{attrs:{"filter":"url(#v_venda_coin_shadow)"}},[_c('circle',{attrs:{"cx":"178","cy":"36","r":"14","fill":"url(#v_venda_coin_grad)","stroke":"#B45309","stroke-width":"1.5"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"178","cy":"36","r":"11","stroke":"#FEF3C7","stroke-width":"1","stroke-dasharray":"2 2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M178 28V44M174 32C174 30.5 175.5 29.5 178 29.5C180.5 29.5 182 30.8 182 32.5C182 34.5 180 35.2 178 35.8C175.8 36.4 174 37.2 174 39.5C174 41.2 175.5 42.5 178 42.5C180.5 42.5 182 41.5 182 40","stroke":"#FFFFFF","stroke-width":"2","stroke-linecap":"round"}})]),_vm._v(" "),_c('circle',{attrs:{"cx":"188","cy":"72","r":"8","fill":"#10B981","stroke":"#FFFFFF","stroke-width":"1.8"}}),_vm._v(" "),_c('path',{attrs:{"d":"M185 75L188 70L191 75M188 70V76","stroke":"#FFFFFF","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]):(_vm.step === 'guianfe_nf')?_c('svg',{staticClass:"nb-step-svg",attrs:{"viewBox":"0 0 220 130","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"v_nf_bg","x1":"110","y1":"10","x2":"110","y2":"120","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#EFF4FF","stop-opacity":"0.9"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#DBEAFE","stop-opacity":"0.35"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_nf_doc","x1":"50","y1":"16","x2":"145","y2":"114","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FFFFFF"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#F8FAFC"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_nf_hdr","x1":"50","y1":"18","x2":"144","y2":"18","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#004E94"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#00376C"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_nf_stamp","x1":"130","y1":"58","x2":"182","y2":"106","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#ECFDF5"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#D1FAE5"}})],1),_vm._v(" "),_c('linearGradient',{attrs:{"id":"v_nf_rocket","x1":"155","y1":"20","x2":"185","y2":"50","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#0EA5E9"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#004E94"}})],1),_vm._v(" "),_c('filter',{attrs:{"id":"v_nf_doc_shadow","x":"42","y":"12","width":"112","height":"106","filterUnits":"userSpaceOnUse"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"6","stdDeviation":"6","flood-color":"#004E94","flood-opacity":"0.16"}})],1),_vm._v(" "),_c('filter',{attrs:{"id":"v_nf_stamp_shadow","x":"124","y":"52","width":"66","height":"66","filterUnits":"userSpaceOnUse"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"4","stdDeviation":"4","flood-color":"#10B981","flood-opacity":"0.25"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"x":"15","y":"10","width":"190","height":"110","rx":"16","fill":"url(#v_nf_bg)"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"100","cy":"65","r":"44","fill":"#DBEAFE","fill-opacity":"0.4"}}),_vm._v(" "),_c('path',{attrs:{"d":"M152 24C162 20 174 21 184 26","stroke":"#38BDF8","stroke-width":"2","stroke-linecap":"round","stroke-dasharray":"2 3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M158 18C172 14 186 16 198 22","stroke":"#0EA5E9","stroke-width":"2","stroke-linecap":"round"}}),_vm._v(" "),_c('g',{attrs:{"filter":"url(#v_nf_doc_shadow)"}},[_c('rect',{attrs:{"x":"50","y":"18","width":"94","height":"92","rx":"7","fill":"url(#v_nf_doc)","stroke":"#004E94","stroke-width":"1.8"}}),_vm._v(" "),_c('path',{attrs:{"d":"M50 25C50 21.134 53.134 18 57 18H137C140.866 18 144 21.134 144 25V36H50V25Z","fill":"url(#v_nf_hdr)"}}),_vm._v(" "),_c('text',{attrs:{"x":"97","y":"27","text-anchor":"middle","dominant-baseline":"central","fill":"#FFFFFF","font-family":"'Inter', sans-serif","font-size":"7","font-weight":"800","letter-spacing":"0.5"}},[_vm._v("NOTA FISCAL (NF-e)")]),_vm._v(" "),_c('g',{attrs:{"transform":"translate(58, 41)"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"78","height":"11","rx":"2","fill":"#FFFFFF","stroke":"#E2E8F0","stroke-width":"0.8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"4","y":"2","width":"1.5","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"7","y":"2","width":"2.5","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"11","y":"2","width":"1","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"13.5","y":"2","width":"3","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"18","y":"2","width":"1.5","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"21","y":"2","width":"2","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"25","y":"2","width":"1","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"28","y":"2","width":"2.5","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"32","y":"2","width":"1.5","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"35","y":"2","width":"3","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"40","y":"2","width":"1","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"43","y":"2","width":"2","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"47","y":"2","width":"3","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"52","y":"2","width":"1.5","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"55","y":"2","width":"2","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"59","y":"2","width":"1","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"62","y":"2","width":"3","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"67","y":"2","width":"2","height":"7","fill":"#0B1C30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"71","y":"2","width":"1.5","height":"7","fill":"#0B1C30"}})]),_vm._v(" "),_c('rect',{attrs:{"x":"58","y":"56","width":"34","height":"2.5","rx":"1.2","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"58","y":"61","width":"46","height":"2","rx":"1","fill":"#94A3B8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"58","y":"65","width":"38","height":"2","rx":"1","fill":"#CBD5E1"}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(58, 73)"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"26","height":"26","rx":"3","fill":"#FFFFFF","stroke":"#004E94","stroke-width":"1.2"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2","y":"2","width":"7","height":"7","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"3.5","y":"3.5","width":"4","height":"4","fill":"#FFFFFF"}}),_vm._v(" "),_c('rect',{attrs:{"x":"4.5","y":"4.5","width":"2","height":"2","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"17","y":"2","width":"7","height":"7","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"18.5","y":"3.5","width":"4","height":"4","fill":"#FFFFFF"}}),_vm._v(" "),_c('rect',{attrs:{"x":"19.5","y":"4.5","width":"2","height":"2","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2","y":"17","width":"7","height":"7","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"3.5","y":"18.5","width":"4","height":"4","fill":"#FFFFFF"}}),_vm._v(" "),_c('rect',{attrs:{"x":"4.5","y":"19.5","width":"2","height":"2","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"11","y":"3","width":"2","height":"2","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"14","y":"5","width":"2","height":"2","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"11","y":"11","width":"4","height":"4","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"18","y":"11","width":"2","height":"3","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"11","y":"17","width":"3","height":"2","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"17","y":"17","width":"2","height":"4","fill":"#004E94"}}),_vm._v(" "),_c('rect',{attrs:{"x":"21","y":"21","width":"3","height":"3","fill":"#004E94"}})]),_vm._v(" "),_c('rect',{attrs:{"x":"90","y":"76","width":"32","height":"2.5","rx":"1.2","fill":"#64748B"}}),_vm._v(" "),_c('rect',{attrs:{"x":"90","y":"81","width":"26","height":"2.5","rx":"1.2","fill":"#94A3B8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"90","y":"89","width":"36","height":"6","rx":"2","fill":"#ECFDF5","stroke":"#A7F3D0","stroke-width":"0.8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"94","y":"91","width":"24","height":"2","rx":"1","fill":"#059669"}})]),_vm._v(" "),_c('g',{attrs:{"filter":"url(#v_nf_stamp_shadow)","transform":"rotate(-6 156 80)"}},[_c('circle',{attrs:{"cx":"156","cy":"80","r":"22","fill":"url(#v_nf_stamp_grad)","stroke":"#10B981","stroke-width":"2.5"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"156","cy":"80","r":"18","stroke":"#34D399","stroke-width":"1","stroke-dasharray":"3 2"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"156","cy":"77","r":"9","fill":"#10B981"}}),_vm._v(" "),_c('path',{attrs:{"d":"M152 77L155 80L160.5 74.5","stroke":"#FFFFFF","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"149","cy":"91","r":"1.5","fill":"#059669"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"156","cy":"92","r":"2","fill":"#059669"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"163","cy":"91","r":"1.5","fill":"#059669"}})]),_vm._v(" "),_c('path',{attrs:{"d":"M185 35L178 37L176 44L173 41L174 38L171 37L178 30L185 35Z","fill":"url(#v_nf_rocket_grad)"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"180","cy":"34","r":"1.2","fill":"#FFFFFF"}}),_vm._v(" "),_c('path',{attrs:{"d":"M174 41L169 44L171 40L174 41Z","fill":"#F59E0B"}}),_vm._v(" "),_c('path',{attrs:{"d":"M34 82L35.5 85.5L39 87L35.5 88.5L34 92L32.5 88.5L29 87L32.5 85.5L34 82Z","fill":"#F59E0B"}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mensagem && _vm.mensagem != 0)?_c('div',{staticClass:"nb-cert-alert-banner shadow-sm"},[_c('div',{staticClass:"nb-cert-alert-img-box shadow-sm"},[_c('guia-step-svg',{attrs:{"step":"guianfe_certificado","label":"CERTIFICADO A1","completed":_vm.mensagem == 0}})],1),_vm._v(" "),_c('div',{staticClass:"nb-cert-alert-content"},[(_vm.mensagem == 3)?_c('h2',{staticClass:"nb-cert-alert-title"},[_vm._v("\n      Seu certificado vencerá em "+_vm._s(_vm._f("formatData")(_vm.certificados[0].dtval))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.mensagem == 2)?_c('h2',{staticClass:"nb-cert-alert-title"},[_vm._v("\n      Seu certificado digital está\n      "),_c('span',{staticClass:"nb-cert-tag-white"},[_vm._v("Vencido!")])]):_vm._e(),_vm._v(" "),((_vm.mensagem == 1) || (_vm.mensagem == 2))?_c('h2',{staticClass:"nb-cert-alert-title"},[_c('span',{staticClass:"nb-cert-tag-white"},[_vm._v("Adquira já")]),_vm._v("\n      seu certificado digital A1\n      "),_vm._m(0),_vm._v("\n      para emitir sua NF-e sem complicações\n    ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"nb-cert-alert-desc mb-0"},[_vm._v("\n      Com o Nota Brasil você pode adquirir o certificado digital da sua empresa até no mesmo dia que solicitar.\n    ")])]),_vm._v(" "),_c('div',{staticClass:"nb-cert-alert-cta-box shadow-sm"},[_c('span',{staticClass:"badge badge-success nb-cert-badge-offer"},[_vm._v("melhor preço do mercado")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn nb-cert-btn-buy",attrs:{"type":"button"},on:{"click":_vm.handleQueroCertificadoDigital}},[_c('i',{staticClass:"fa fa-shopping-cart mr-1"}),_vm._v(" Quero o certificado\n    ")])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-none d-sm-inline"},[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-cert-price-wrap"},[_c('span',{staticClass:"nb-cert-model-text"},[_vm._v("Certificado Digital A1")]),_vm._v(" "),_c('div',{staticClass:"nb-cert-price-val"},[_c('span',{staticClass:"nb-cert-currency"},[_vm._v("R$")]),_vm._v(" "),_c('span',{staticClass:"nb-cert-amount"},[_vm._v("148,00")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showForm)?_c('div',{staticClass:"container"},[(_vm.passo === 'extension')?_c('div',{staticClass:"default-container"},[_c('h3',{staticClass:"cert-title"},[_vm._v("Atualização necessária do módulo assinador com certificado A3.")]),_vm._v(" "),_c('alert',{attrs:{"type":"info","title":"Aviso","text":"É necessário efeturar a atualização do módulo assinador para continuar emitindo notas fiscais."}}),_vm._v(" "),_c('div',{staticClass:"row align-items-center ml-2"},[_c('span',{staticClass:"numero"},[_vm._v("1")]),_vm._v(" "),_c('label-title',{attrs:{"title":"Entenda Como Funciona"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"data-list"},[_vm._v("Assista no vídeo abaixo o passo a passo para vincular o certificado A3 no Nota Brasil.\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('iframe',{staticClass:"ca-u-vertical-offset3",attrs:{"src":"//www.youtube.com/embed/Ds6DmZ7uzEg","width":"560","height":"315","frameborder":"0","allowfullscreen":""}})])]),_vm._v(" "),_c('div',{staticClass:"row align-items-center ml-2 mt-5"},[_c('span',{staticClass:"numero"},[_vm._v("2")]),_vm._v(" "),_c('label-title',{attrs:{"title":"Atualize a Extensão do Chrome"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl"},[_vm._v("Primeiramente certifique-se de que seu certificado A3 esteja conectado (Cartão ou\n            Pendrive)")]),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("Em seguida, clique no botão abaixo para ativar a extensão do google chrome para\n            utilização do certificado A3 com o Nota Brasil")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Ativar Extensão no Chrome","nb-btdef":true},on:{"click":_vm.handleAtivarExtensao}})],1)]),_vm._v(" "),_c('div',{staticClass:"row align-items-center ml-2 mt-5"},[_c('span',{staticClass:"numero"},[_vm._v("3")]),_vm._v(" "),_c('label-title',{attrs:{"title":"Atualização do Módulo A3"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl"},[_vm._v("Agora efetue o download do módulo de assinatura A3 do Nota Brasil.")]),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_c('strong',[_vm._v("Após a instalação ser concluída, é necessário reiniciar o seu\n              navegador!")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Download do Nota Brasil A3","nb-btdef":true},on:{"click":_vm.handleDownloadA3}})],1)]),_vm._v(" "),_c('div',{staticClass:"row align-items-center ml-2 mt-5"},[_c('span',{staticClass:"numero"},[_vm._v("4")]),_vm._v(" "),_c('label-title',{attrs:{"title":"Retorne para a emissão de notas"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl"},[_vm._v("Agora é só continuar emitindo suas notas.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-button',{attrs:{"label":"Retornar Para Lista de Notas","nb-btdef":true},on:{"click":_vm.handleVoltarListaNF}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.passo != 'extension')?_c('div',[_c('div',{staticClass:"nb-cert-page-header"},[_c('div',{staticClass:"nb-cert-title-wrap"},[_c('h2',{staticClass:"nb-cert-page-title"},[_vm._v("Vincular Certificado Digital")]),_vm._v(" "),_c('div',{staticClass:"nb-cert-filial-meta"},[_c('strong',[_vm._v(_vm._s(_vm.filial.nome))]),_vm._v(" "),(_vm.filial.cnpj)?_c('span',{staticClass:"nb-cert-filial-cnpj"},[_c('i',{staticClass:"fa fa-id-card-o mr-1",attrs:{"aria-hidden":"true"}}),_vm._v("\n              CNPJ "+_vm._s(_vm._f("formatCNPJCPF")(_vm.filial.cnpj))+"\n            ")]):_vm._e()])]),_vm._v(" "),(!_vm.disableBtnVoltar)?_c('div',{staticClass:"nb-cert-back-action"},[_c('v-button',{attrs:{"label":"Voltar","icon":"fa-arrow-left"},on:{"click":function($event){return _vm.handleVoltar('closeform')}}})],1):_vm._e()]),_vm._v(" "),(_vm.passo === 'empresa')?_c('div',{staticClass:"cert-title text-center"},[_c('h3',{staticClass:"cert-title"},[_vm._v("Primeiramente configure os dados da empresa para prosseguir com a vinculação do\n          certificado digital.")]),_vm._v(" "),_c('button',{staticClass:"cert-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleEmpresaRedirect()}}},[_vm._v("Dados da Empresa")])]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"nb-cert-status mb-4",class:'nb-cert-status--' + _vm.statusCertificado,attrs:{"aria-live":"polite"}},[_c('div',{staticClass:"nb-cert-status-summary"},[_c('div',{staticClass:"nb-cert-status-icon",attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"fa",class:_vm.statusCertificadoIcone})]),_vm._v(" "),_c('div',{staticClass:"nb-cert-status-content"},[_c('div',{staticClass:"nb-cert-status-heading"},[_c('h3',[_vm._v(_vm._s(_vm.statusCertificadoTitulo))]),_vm._v(" "),_c('span',{staticClass:"nb-cert-status-badge"},[_vm._v(_vm._s(_vm.statusCertificadoLabel))])]),_vm._v(" "),(_vm.certificadoVinculado)?_c('p',{staticClass:"nb-cert-status-detail"},[_vm._v("\n              Certificado "+_vm._s(_vm.tipoCertificado)+"\n            ")]):_c('p',{staticClass:"nb-cert-status-detail"},[_vm._v("Vincule um certificado para emitir documentos fiscais.")]),_vm._v(" "),(_vm.validadeDisponivel)?_c('div',{staticClass:"nb-cert-expiry"},[_c('span',[_vm._v("Validade: "),_c('strong',[_vm._v(_vm._s(_vm._f("formatData")(_vm.filial.certificado[0].dtval)))])]),_vm._v(" "),_c('span',{staticClass:"nb-cert-expiry-days"},[_vm._v(_vm._s(_vm.validadeCertificadoTexto))])]):_vm._e(),_vm._v(" "),(_vm.validadeDisponivel)?_c('div',{staticClass:"nb-cert-progress",attrs:{"role":"progressbar","aria-valuenow":_vm.progressoValidade,"aria-valuemin":"0","aria-valuemax":"100","aria-label":'Validade restante: ' + _vm.progressoValidade + '%'}},[_c('div',{staticClass:"nb-cert-progress-bar",style:({ width: _vm.progressoValidade + '%' })})]):_vm._e()])]),_vm._v(" "),(_vm.certificadoVinculado)?_c('div',{staticClass:"nb-cert-status-record"},[_c('app-certificado-form',{attrs:{"filial":this.filial},on:{"refresh":_vm.handleRefresh}})],1):_vm._e()]),_vm._v(" "),(!_vm.disableBtnVoltar && (!_vm.certificadoVinculado || _vm.validadeDisponivel))?_c('alert-cert',{attrs:{"certificados":_vm.certificadosVenda}}):_vm._e(),_vm._v(" "),(!_vm.certificadoVinculado)?_c('div',{staticClass:"nb-cert-type-section mb-3",attrs:{"id":"tipocertificado"}},[_c('div',{staticClass:"nb-cert-section-heading"},[_c('h3',[_vm._v("Escolha o tipo de certificado")]),_vm._v(" "),_c('p',[_vm._v("Selecione o modelo que sua empresa utiliza para ver as instruções de configuração.")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12 mb-2 mb-md-0"},[_c('label',{staticClass:"nb-cert-type-card",class:{ 'is-selected': _vm.tipoCertificado === 'A1' }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoCertificado),expression:"tipoCertificado"}],staticClass:"sr-only",attrs:{"type":"radio","name":"tipoCertificado","value":"A1"},domProps:{"checked":_vm._q(_vm.tipoCertificado,"A1")},on:{"change":function($event){_vm.tipoCertificado="A1"}}}),_vm._v(" "),_c('span',{staticClass:"nb-cert-type-icon"},[_c('i',{staticClass:"fa fa-file-o",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"nb-cert-type-copy"},[_c('strong',[_vm._v("Certificado A1")]),_vm._v(" "),_c('small',[_vm._v("Arquivo digital no formato .pfx")])]),_vm._v(" "),_c('span',{staticClass:"nb-cert-type-check",attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"fa fa-check"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('label',{staticClass:"nb-cert-type-card",class:{ 'is-selected': _vm.tipoCertificado === 'A3' }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoCertificado),expression:"tipoCertificado"}],staticClass:"sr-only",attrs:{"type":"radio","name":"tipoCertificado","value":"A3"},domProps:{"checked":_vm._q(_vm.tipoCertificado,"A3")},on:{"change":function($event){_vm.tipoCertificado="A3"}}}),_vm._v(" "),_c('span',{staticClass:"nb-cert-type-icon"},[_c('i',{staticClass:"fa fa-credit-card",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"nb-cert-type-copy"},[_c('strong',[_vm._v("Certificado A3")]),_vm._v(" "),_c('small',[_vm._v("Cartão ou token conectado ao computador")])]),_vm._v(" "),_c('span',{staticClass:"nb-cert-type-check",attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"fa fa-check"})])])])])]):_vm._e(),_vm._v(" "),(!_vm.certificadoVinculado && _vm.tipoCertificado == 'A3')?_c('div',{staticClass:"nb-cert-setup mt-3"},[_c('div',{staticClass:"nb-cert-setup-heading"},[_c('div',[_c('h3',[_vm._v("Configurar certificado A3")]),_vm._v(" "),_c('p',[_vm._v("Conecte o cartão ou token e siga as etapas abaixo.")])]),_vm._v(" "),_c('details',{staticClass:"nb-cert-help"},[_c('summary',[_c('i',{staticClass:"fa fa-play-circle mr-1",attrs:{"aria-hidden":"true"}}),_vm._v(" Assistir tutorial")]),_vm._v(" "),_c('div',{staticClass:"embed-responsive embed-responsive-16by9 mt-2"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"src":"//www.youtube.com/embed/Ds6DmZ7uzEg","title":"Tutorial para configurar certificado A3","frameborder":"0","allowfullscreen":""}})])])]),_vm._v(" "),_c('div',{staticClass:"nb-cert-steps"},[_c('article',{staticClass:"nb-cert-step"},[_c('span',{staticClass:"nb-cert-step-number"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"nb-cert-step-copy"},[_c('h4',[_vm._v("Ative a extensão do Chrome")]),_vm._v(" "),_c('p',[_vm._v("Ela permite que o Nota Brasil encontre o certificado conectado.")])]),_vm._v(" "),_c('div',{staticClass:"nb-cert-step-action"},[_c('v-button',{attrs:{"label":"Ativar extensão","nb-btdef":true},on:{"click":_vm.handleAtivarExtensao}})],1)]),_vm._v(" "),_c('article',{staticClass:"nb-cert-step"},[_c('span',{staticClass:"nb-cert-step-number"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"nb-cert-step-copy"},[_c('h4',[_vm._v("Instale o módulo A3")]),_vm._v(" "),_c('p',[_vm._v("Depois da instalação, reinicie o navegador.")])]),_vm._v(" "),_c('div',{staticClass:"nb-cert-step-action"},[_c('v-button',{attrs:{"label":"Baixar módulo A3","nb-btdef":true},on:{"click":_vm.handleDownloadA3}})],1)]),_vm._v(" "),_c('article',{staticClass:"nb-cert-step"},[_c('span',{staticClass:"nb-cert-step-number"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"nb-cert-step-copy"},[_c('h4',[_vm._v("Vincule o certificado")]),_vm._v(" "),_c('p',[_vm._v("Selecione o certificado disponível no computador.")])]),_vm._v(" "),_c('div',{staticClass:"nb-cert-step-action"},[_c('v-button',{attrs:{"label":"Selecionar certificado","nb-btdef":true},on:{"click":_vm.handleCheckExtensionA3}})],1)])])]):_vm._e(),_vm._v(" "),(!_vm.certificadoVinculado && _vm.tipoCertificado == 'A1')?_c('div',{staticClass:"nb-cert-a1-layout mt-3"},[_c('div',{staticClass:"row align-items-start"},[_c('div',{staticClass:"col-md-7 col-12 order-1 nb-margin-top"},[_c('div',{staticClass:"nb-cert-a1-form"},[_c('h3',[_vm._v("Importar certificado A1")]),_vm._v(" "),_c('p',[_vm._v("Selecione o arquivo .pfx e informe a senha para vincular o certificado.")]),_vm._v(" "),_c('app-certificado-form',{attrs:{"filial":this.filial},on:{"refresh":_vm.handleRefresh}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-5 col-12 order-2 mt-3 mt-md-0"},[_c('div',{staticClass:"nb-cert-a1-help"},[_c('h4',[_vm._v("Precisa de ajuda?")]),_vm._v(" "),_c('p',[_vm._v("Assista ao passo a passo para localizar o arquivo e concluir a importação.")]),_vm._v(" "),_c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"src":"//www.youtube.com/embed/S6QsrgWAaRM","title":"Tutorial para importar certificado A1","frameborder":"0","allowfullscreen":""}})])])])])]):_vm._e(),_vm._v(" "),(_vm.passo == 'extension')?_c('div',{staticClass:"row card nb-margin-top",staticStyle:{"padding":"15px"}},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-12 col-12 nb-margin-bottom text-center"},[_c('h3',{staticClass:"cert-title"},[_vm._v("Efetue a instalação da extensão do Google Chrome agora.")]),_vm._v(" "),_c('p',{staticClass:"data-list"},[_vm._v("Após a instalação é necessário reiniciar o navegador.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12 nb-margin-top"},[_c('v-button',{attrs:{"label":"Instalar","nb-btdef":true},on:{"click":function($event){return _vm.handleAtivarExtensao()}}})],1)])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.configurandoA3)?_c('div',[_c('div',{staticClass:"nb-modal-mask"},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h3',{staticClass:"cert-title",staticStyle:{"margin-bottom":"0"}},[_vm._v("Certificado A3")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.passo === 'inicio')?_c('div',{staticClass:"row col text-center nb-margin-top nb-margin-bottom"},[_c('p',{staticClass:"data-list"},[_vm._v("Primeiramente conecte seu certificado A3 (Cartão ou Pendrive) para iniciar a\n                  configuração.")]),_vm._v(" "),_c('p',{staticClass:"data-list"},[_vm._v("Em seguida, clique no botão abaixo para ativar a extensão do google chrome para\n                  utilização do certificado A3 com o Nota Brasil")])]):_vm._e(),_vm._v(" "),(_vm.passo === 'downloadA3')?_c('div',{staticClass:"activation text-center"},[_c('p',{staticClass:"data-list"},[_vm._v("Agora efetue o download do módulo de assinatura A3 do Nota Brasil.")]),_vm._v(" "),_c('p',{staticClass:"data-list"},[_c('strong',[_vm._v("Após a instalação ser concluída, é necessário reiniciar o seu\n                    navegador!")])])]):_vm._e(),_vm._v(" "),(_vm.passo === 'concluido')?_c('div',{staticClass:"activation text-center"},[_c('p',{staticClass:"data-list"},[_c('strong',[_vm._v("Após a instalação ser concluída, é necessário reiniciar o seu\n                    navegador!")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(_vm.passo === 'inicio')?_c('div',[_c('v-button',{attrs:{"label":"Voltar"},on:{"click":function($event){_vm.configurandoA3 = false}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Ativar Extensão no Chrome","nb-btdef":true},on:{"click":_vm.handleAtivarExtensao}})],1):_vm._e(),_vm._v(" "),(_vm.passo === 'downloadA3')?_c('div',[_c('v-button',{attrs:{"label":"Voltar"},on:{"click":function($event){_vm.passo = 'inicio'}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Download do Nota Brasil A3","nb-btdef":true},on:{"click":_vm.handleDownloadA3}})],1):_vm._e(),_vm._v(" "),(_vm.passo === 'concluido')?_c('div',[_c('v-button',{attrs:{"label":"Ok","nb-btdef":true},on:{"click":_vm.handleConcluiA3}})],1):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(_vm.testandoA3)?_c('div',[_c('div',{staticClass:"nb-modal-mask"},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h3',{staticClass:"cert-title",staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(_vm.titleValidacaoCertificado))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row col text-center nb-margin-top nb-margin-bottom"},[_c('p',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.procurandoCertificado))])]),_vm._v(" "),_c('div',{staticClass:"row col text-center nb-margin-top nb-margin-bottom"},[_c('p',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.procurandoCertificado2))])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"label":"Voltar"},on:{"click":function($event){_vm.testandoA3 = false}}})],1)])])])]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[(!_vm.guide)?_c('bar-manut',{attrs:{"single-entity":_vm.titleForm,"crud":this.crud,"disable-retorno":_vm.disableRetorno},on:{"closeform":_vm.closeForm,"save":_vm.handleSave}}):_vm._e(),_vm._v(" "),(!_vm.guide)?_c('tabs',{staticClass:"mb-4",attrs:{"tabs":_vm.filteredTabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}):_vm._e(),_vm._v(" "),_c('div',[_c('div',{},[(_vm.errmessages.length)?_c('validation',{attrs:{"title":"Erros de Validação","messages":_vm.errmessages}}):_vm._e(),_vm._v(" "),(_vm.tabDados)?_c('div',{attrs:{"id":"tabDAdos"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('label-title',{attrs:{"title":"Dados da Empresa"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.cnpj.validator),expression:"metadata.filial.cnpj.validator"}],ref:"cnpj",attrs:{"type":"cnpj","col":"2","metadata":_vm.metadata.filial.cnpj,"name":"cnpj","id":"cnpj","v-errors":_vm.errors},model:{value:(_vm.filial.cnpj),callback:function ($$v) {_vm.$set(_vm.filial, "cnpj", $$v)},expression:"filial.cnpj"}}),_vm._v(" "),(_vm.showPreencherCadastro)?_c('v-button',{attrs:{"label":"Preencher Cadastro","icon":"","title":"Para uma pesquisa mais completa, informe o estado!"},on:{"click":function($event){return _vm.handlePreencherCadastro()}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{attrs:{"label":"Token integração com sistemas ERP"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(_vm.tokenEmpresa)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.nome.validator),expression:"metadata.filial.nome.validator"}],ref:"nome",attrs:{"type":"text","col":"6","metadata":_vm.metadata.filial.nome,"name":"nome","id":"nome","v-errors":_vm.errors},model:{value:(_vm.filial.nome),callback:function ($$v) {_vm.$set(_vm.filial, "nome", $$v)},expression:"filial.nome"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.fantasia.validator),expression:"metadata.filial.fantasia.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.filial.fantasia,"nome":"fantasia","id":"fantasia","v-errors":_vm.errors},model:{value:(_vm.filial.fantasia),callback:function ($$v) {_vm.$set(_vm.filial, "fantasia", $$v)},expression:"filial.fantasia"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"4","label":"Inscrição Estadual (Situação)","select-options":_vm.tipo_ie_options,"name":"tipo_ie","id":"tipo_ie"},model:{value:(_vm.tipo_ie),callback:function ($$v) {_vm.tipo_ie=$$v},expression:"tipo_ie"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.tipo_ie === 'COM_IE' ? _vm.metadata.filial.iest.validator : ''),expression:"tipo_ie === 'COM_IE' ? metadata.filial.iest.validator : ''"}],attrs:{"disabled":_vm.tipo_ie !== 'COM_IE',"type":"text","col":"4","metadata":_vm.metadata.filial.iest,"name":"iest","id":"iest","v-errors":_vm.errors},model:{value:(_vm.filial.iest),callback:function ($$v) {_vm.$set(_vm.filial, "iest", $$v)},expression:"filial.iest"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"4","name":"crt","id":"crt","metadata":_vm.metadata.filial.crt},model:{value:(_vm.filial.crt),callback:function ($$v) {_vm.$set(_vm.filial, "crt", $$v)},expression:"filial.crt"}}),_vm._v(" "),(_vm.filial.crt != '3')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.pcredsn.validator),expression:"metadata.filial.pcredsn.validator"}],attrs:{"type":"value","col":"4","addon":"%","metadata":_vm.metadata.filial.pcredsn,"name":"pcredsn","id":"pcredsn","v-errors":_vm.errors},model:{value:(_vm.filial.pcredsn),callback:function ($$v) {_vm.$set(_vm.filial, "pcredsn", $$v)},expression:"filial.pcredsn"}}):_vm._e()],1),_vm._v(" "),(_vm.filial.crt != '1' && _vm.filial.crt != '4')?_c('div',{staticClass:"row"},[(_vm.filial.crt != '1' && _vm.filial.crt != '4')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.apis.validator),expression:"metadata.filial.apis.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.filial.apis,"precision":2,"name":"apis","v-errors":_vm.errors},model:{value:(_vm.filial.apis),callback:function ($$v) {_vm.$set(_vm.filial, "apis", $$v)},expression:"filial.apis"}}):_vm._e(),_vm._v(" "),(_vm.filial.crt != '1' && _vm.filial.crt != '4')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.acofins.validator),expression:"metadata.filial.acofins.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.filial.acofins,"precision":2,"name":"acofins","v-errors":_vm.errors},model:{value:(_vm.filial.acofins),callback:function ($$v) {_vm.$set(_vm.filial, "acofins", $$v)},expression:"filial.acofins"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.filial.crt != '1' && _vm.filial.crt != '4')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.filialcclass.validator),expression:"metadata.filial.filialcclass.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.filial.filialcclass,"disabled":_vm.isView,"name":"filialcclass","v-errors":_vm.errors,"parent":"mymodal","select2":{ entity: 'ivaclass', minlength: 0 }},model:{value:(_vm.filial.filialcclass),callback:function ($$v) {_vm.$set(_vm.filial, "filialcclass", $$v)},expression:"filial.filialcclass"}}),_vm._v(" "),(_vm.filial.crt != '1' && _vm.filial.crt != '4')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.aliquotaibsuf.validator),expression:"metadata.filial.aliquotaibsuf.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.filial.aliquotaibsuf,"precision":2,"name":"aliquotaibsuf","v-errors":_vm.errors},model:{value:(_vm.filial.aliquotaibsuf),callback:function ($$v) {_vm.$set(_vm.filial, "aliquotaibsuf", $$v)},expression:"filial.aliquotaibsuf"}}):_vm._e(),_vm._v(" "),(_vm.filial.crt != '1' && _vm.filial.crt != '4')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.aliquotacbs.validator),expression:"metadata.filial.aliquotacbs.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.filial.aliquotacbs,"precision":2,"name":"aliquotacbs","v-errors":_vm.errors},model:{value:(_vm.filial.aliquotacbs),callback:function ($$v) {_vm.$set(_vm.filial, "aliquotacbs", $$v)},expression:"filial.aliquotacbs"}}):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-5 col-12"})]),_vm._v(" "),_c('label-title',{attrs:{"title":"Logotipo"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[(_vm.filial.codfil)?_c('div',{staticStyle:{"padding":"10px"},attrs:{"data-toggle":"tooltip","data-placement":"bottom"}},[(_vm.image)?_c('img',{staticClass:"img-thumbnail d-block",staticStyle:{"max-width":"130px","max-height":"130px","cursor":"pointer"},attrs:{"src":_vm.image,"alt":"Logotipo"},on:{"click":function($event){return _vm.handleClickLogotipo(_vm.filial.codfil)}}}):_vm._e(),_vm._v(" "),(_vm.image)?_c('span',{staticClass:"data-list text-danger",staticStyle:{"cursor":"pointer"},on:{"click":_vm.apiDeleteImage}},[_vm._m(0)]):_vm._e(),_vm._v(" "),(!_vm.image)?_c('i',{staticClass:"fa fa-camera d-block",staticStyle:{"font-size":"72px","color":"silver","cursor":"pointer"},on:{"click":function($event){return _vm.handleClickLogotipo(_vm.filial.codfil)}}}):_vm._e(),_vm._v(" "),(!_vm.image)?_c('span',{staticClass:"data-list",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.handleClickLogotipo(_vm.filial.codfil)}}},[_vm._v("Selecionar Imagem")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"file",attrs:{"id":"anexo","type":"file","accept":"image/*"},on:{"change":function($event){return _vm.handleUpload($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"w-100 mt-1"}),_vm._v(" "),_c('label-title',{attrs:{"title":"Endereço"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.cep.validator),expression:"metadata.filial.cep.validator"}],attrs:{"type":"cep","col":"2","metadata":_vm.metadata.filial.cep,"name":"cep","id":"cep","v-errors":_vm.errors},on:{"update":_vm.updateCep},model:{value:(_vm.filial.cep),callback:function ($$v) {_vm.$set(_vm.filial, "cep", $$v)},expression:"filial.cep"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.ende.validator),expression:"metadata.filial.ende.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.filial.ende,"name":"ende","id":"ende","v-errors":_vm.errors},model:{value:(_vm.filial.ende),callback:function ($$v) {_vm.$set(_vm.filial, "ende", $$v)},expression:"filial.ende"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.endenr.validator),expression:"metadata.filial.endenr.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.filial.endenr,"name":"endenr","id":"endenr","v-errors":_vm.errors},model:{value:(_vm.filial.endenr),callback:function ($$v) {_vm.$set(_vm.filial, "endenr", $$v)},expression:"filial.endenr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.endecomp.validator),expression:"metadata.filial.endecomp.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.filial.endecomp,"name":"endecomp","id":"endecomp","v-errors":_vm.errors},model:{value:(_vm.filial.endecomp),callback:function ($$v) {_vm.$set(_vm.filial, "endecomp", $$v)},expression:"filial.endecomp"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.bairro.validator),expression:"metadata.filial.bairro.validator"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.filial.bairro,"name":"bairro","id":"bairro","v-errors":_vm.errors},model:{value:(_vm.filial.bairro),callback:function ($$v) {_vm.$set(_vm.filial, "bairro", $$v)},expression:"filial.bairro"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.uf.validator),expression:"metadata.filial.uf.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.filial.uf,"name":"uf","id":"uf","v-errors":_vm.errors},model:{value:(_vm.filial.uf),callback:function ($$v) {_vm.$set(_vm.filial, "uf", $$v)},expression:"filial.uf"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.codmun.validator),expression:"metadata.filial.codmun.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.filial.codmun,"name":"codmun","id":"codmun","v-errors":_vm.errors,"select2":{ entity: 'mun/uf/' + _vm.filial.uf, minlength: 2 }},model:{value:(_vm.filial.codmun),callback:function ($$v) {_vm.$set(_vm.filial, "codmun", $$v)},expression:"filial.codmun"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.fone1.validator),expression:"metadata.filial.fone1.validator"}],attrs:{"type":"fone","col":"2","metadata":_vm.metadata.filial.fone1,"name":"fone1","v-errors":_vm.errors},model:{value:(_vm.filial.fone1),callback:function ($$v) {_vm.$set(_vm.filial, "fone1", $$v)},expression:"filial.fone1"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.fone2.validator),expression:"metadata.filial.fone2.validator"}],attrs:{"type":"fone","col":"2","metadata":_vm.metadata.filial.fone2,"name":"fone2","v-errors":_vm.errors},model:{value:(_vm.filial.fone2),callback:function ($$v) {_vm.$set(_vm.filial, "fone2", $$v)},expression:"filial.fone2"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.fone3.validator),expression:"metadata.filial.fone3.validator"}],attrs:{"type":"fone","col":"2","metadata":_vm.metadata.filial.fone3,"name":"fone3","v-errors":_vm.errors},model:{value:(_vm.filial.fone3),callback:function ($$v) {_vm.$set(_vm.filial, "fone3", $$v)},expression:"filial.fone3"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.email.validator),expression:"metadata.filial.email.validator"}],attrs:{"type":"email","col":"6","metadata":_vm.metadata.filial.email,"name":"email","v-errors":_vm.errors},model:{value:(_vm.filial.email),callback:function ($$v) {_vm.$set(_vm.filial, "email", $$v)},expression:"filial.email"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.site.validator),expression:"metadata.filial.site.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.filial.site,"name":"site","v-errors":_vm.errors,"validateDisabledKeys":false},model:{value:(_vm.filial.site),callback:function ($$v) {_vm.$set(_vm.filial, "site", $$v)},expression:"filial.site"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.appNFe)?_c('div',[_c('div',{staticClass:"row"})]):_vm._e(),_vm._v(" "),(_vm.tabNf)?_c('div',[_c('label-title',{staticClass:"mt-2",attrs:{"title":"Informações Para Emissão de NF-e"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.filial.tpambnfe},model:{value:(_vm.filial.tpambnfe),callback:function ($$v) {_vm.$set(_vm.filial, "tpambnfe", $$v)},expression:"filial.tpambnfe"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.filial.contingencia},model:{value:(_vm.filial.contingencia),callback:function ($$v) {_vm.$set(_vm.filial, "contingencia", $$v)},expression:"filial.contingencia"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.imun.validator),expression:"metadata.filial.imun.validator"}],attrs:{"type":"number","col":"3","metadata":_vm.metadata.filial.imun,"name":"imun","v-errors":_vm.errors},model:{value:(_vm.filial.imun),callback:function ($$v) {_vm.$set(_vm.filial, "imun", $$v)},expression:"filial.imun"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.cnae.validator),expression:"metadata.filial.cnae.validator"}],attrs:{"type":"number","col":"3","metadata":_vm.metadata.filial.cnae,"name":"cnae","v-errors":_vm.errors},model:{value:(_vm.filial.cnae),callback:function ($$v) {_vm.$set(_vm.filial, "cnae", $$v)},expression:"filial.cnae"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.autcnpj.validator),expression:"metadata.filial.autcnpj.validator"}],attrs:{"type":"cnpj","col":"3","metadata":_vm.metadata.filial.autcnpj,"name":"autcnpj","v-errors":_vm.errors},model:{value:(_vm.filial.autcnpj),callback:function ($$v) {_vm.$set(_vm.filial, "autcnpj", $$v)},expression:"filial.autcnpj"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.autcpf.validator),expression:"metadata.filial.autcpf.validator"}],attrs:{"type":"number","col":"3","metadata":_vm.metadata.filial.autcpf,"name":"autcpf","v-errors":_vm.errors},model:{value:(_vm.filial.autcpf),callback:function ($$v) {_vm.$set(_vm.filial, "autcpf", $$v)},expression:"filial.autcpf"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({max: 18}),expression:"{max: 18}"}],attrs:{"type":"cnpj","col":"3","label":"CNPJ do Contador","name":"cnpjcontador","v-errors":_vm.errors},model:{value:(_vm.filial.cnpjcontador),callback:function ($$v) {_vm.$set(_vm.filial, "cnpjcontador", $$v)},expression:"filial.cnpjcontador"}})],1),_vm._v(" "),_c('label-title',{staticClass:"mt-5",attrs:{"title":"Informações Para Emissão de NF Consumidor"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.csc.validator),expression:"metadata.filial.csc.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.filial.csc,"name":"csc","v-errors":_vm.errors,"case":"normal"},model:{value:(_vm.filial.csc),callback:function ($$v) {_vm.$set(_vm.filial, "csc", $$v)},expression:"filial.csc"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.idcsc.validator),expression:"metadata.filial.idcsc.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.filial.idcsc,"name":"idcsc","case":"normal","v-errors":_vm.errors},model:{value:(_vm.filial.idcsc),callback:function ($$v) {_vm.$set(_vm.filial, "idcsc", $$v)},expression:"filial.idcsc"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.filial.crt != '1' && _vm.filial.crt != '4')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.apis.validator),expression:"metadata.filial.apis.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.filial.apis,"precision":2,"name":"apis","v-errors":_vm.errors},model:{value:(_vm.filial.apis),callback:function ($$v) {_vm.$set(_vm.filial, "apis", $$v)},expression:"filial.apis"}}):_vm._e(),_vm._v(" "),(_vm.filial.crt != '1' && _vm.filial.crt != '4')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.acofins.validator),expression:"metadata.filial.acofins.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.filial.acofins,"precision":2,"name":"acofins","v-errors":_vm.errors},model:{value:(_vm.filial.acofins),callback:function ($$v) {_vm.$set(_vm.filial, "acofins", $$v)},expression:"filial.acofins"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"w-100 mt-5"}),_vm._v(" "),_c('label-title',{attrs:{"title":"Inscrições de Substituto Tributário"}}),_vm._v(" "),_vm._l((_vm.listSubstitutos),function(iest,index){return _c('div',{key:index,staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-2 col-12"},[_c('form-field',{attrs:{"type":"select","metadata":_vm.metadata.iest.uf,"select-options":_vm.estadoList},model:{value:(iest.uf),callback:function ($$v) {_vm.$set(iest, "uf", $$v)},expression:"iest.uf"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-10"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.iest.iest.validator),expression:"metadata.iest.iest.validator"}],attrs:{"type":"text","metadata":_vm.metadata.iest.iest,"name":"iest","v-errors":_vm.errors},model:{value:(iest.iest),callback:function ($$v) {_vm.$set(iest, "iest", $$v)},expression:"iest.iest"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-button',{attrs:{"label":"","title":"Excluir Estado","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteUF(index)}}})],1)])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Adicionar Estado","title":"","nb-btdef":true},on:{"click":_vm.handleAdicionaUF}})],1)])],2):_vm._e(),_vm._v(" "),(_vm.tabPed)?_c('div',{staticClass:"mb-4"},[_c('label-title',{attrs:{"title":"Permissões"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{attrs:{"label":"Informe o % de rentabilidade para bloquear o pedido de venda"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('form-field',{attrs:{"type":"value","addon":"%","precision":2,"data-toggle":"tooltip","data-placement":"top","title":"Possibilita o bloqueio do pedido de venda pela rentabilidade mínima em relação ao custo informado no cadastro de produto."},model:{value:(_vm.parametros.rentabilidade_minima),callback:function ($$v) {_vm.$set(_vm.parametros, "rentabilidade_minima", $$v)},expression:"parametros.rentabilidade_minima"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 mb-3"},[_c('input-checkbox',{attrs:{"estilo":'text-info',"label":"Controla estoque dos produtos?","value-checked":true,"value-unchecked":false},model:{value:(_vm.parametros.controlaestoque),callback:function ($$v) {_vm.$set(_vm.parametros, "controlaestoque", $$v)},expression:"parametros.controlaestoque"}})],1),_vm._v(" "),(_vm.parametros.controlaestoque)?_c('div',{staticClass:"col-md-12 col-12 pl-5 mb-3"},[_c('input-checkbox',{attrs:{"estilo":'text-info',"label":"Bloquear venda sem estoque","value-checked":true,"value-unchecked":false},model:{value:(_vm.parametros.venda_sem_estoque),callback:function ($$v) {_vm.$set(_vm.parametros, "venda_sem_estoque", $$v)},expression:"parametros.venda_sem_estoque"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 mb-3"},[_c('input-checkbox',{attrs:{"estilo":'text-info',"label":"Bloquear venda para clientes sem crédito","value-checked":true,"value-unchecked":false},model:{value:(_vm.parametros.venda_sem_credito),callback:function ($$v) {_vm.$set(_vm.parametros, "venda_sem_credito", $$v)},expression:"parametros.venda_sem_credito"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 mb-3"},[_c('input-checkbox',{attrs:{"estilo":'text-info',"label":"Agrupar itens repetidos no pedido?","value-checked":true,"value-unchecked":false},model:{value:(_vm.parametros.agrupar_itens_pedido),callback:function ($$v) {_vm.$set(_vm.parametros, "agrupar_itens_pedido", $$v)},expression:"parametros.agrupar_itens_pedido"}})],1)]),_vm._v(" "),_c('div',{staticClass:"w-100 mt-3"}),_vm._v(" "),_c('label-title',{attrs:{"title":"Pedido e Nota Fiscal"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{attrs:{"label":"Selecione uma forma de pagamento padrão das parcelas do pedido e nota Fiscal"}})],1),_vm._v(" "),_c('form-field',{ref:"formapag",attrs:{"type":"select","col":"3","metadata":_vm.metadata.pedvpar.formapag},model:{value:(_vm.parametros.parcelas.formapag),callback:function ($$v) {_vm.$set(_vm.parametros.parcelas, "formapag", $$v)},expression:"parametros.parcelas.formapag"}})],1),_vm._v(" "),_c('div',[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Dados integração com sistema FF"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('input-checkbox',{attrs:{"estilo":'text-info',"label":"Exibir dados do estoque na digitação do pedido","value-checked":true,"value-unchecked":false},model:{value:(_vm.parametros.exibir_estoque_integracao),callback:function ($$v) {_vm.$set(_vm.parametros, "exibir_estoque_integracao", $$v)},expression:"parametros.exibir_estoque_integracao"}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"w-100 mt-3"}),_vm._v(" "),_c('label-title',{attrs:{"title":"Informações Gerais e Garantia dos produtos"}}),_vm._v(" "),_c('div',{staticClass:"row text-editor"},[_c('div',{staticClass:"col-md-7 my-3"},[_c('wysiwyg',{model:{value:(_vm.parametros.pedido.observacao_garantia),callback:function ($$v) {_vm.$set(_vm.parametros.pedido, "observacao_garantia", $$v)},expression:"parametros.pedido.observacao_garantia"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.tabEcommerce)?_c('div',[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Dados Marketplace B2W"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('v-label',{attrs:{"label":"Usuário-Email"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","case":"normal","data-toggle":"tooltip","data-placement":"top","title":"Usuário-Email para login no marketplace B2W."},model:{value:(_vm.parametros.marketplaces.b2w.userlogin),callback:function ($$v) {_vm.$set(_vm.parametros.marketplaces.b2w, "userlogin", $$v)},expression:"parametros.marketplaces.b2w.userlogin"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12"},[_c('v-label',{attrs:{"label":"Api-key"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","case":"normal","data-toggle":"tooltip","data-placement":"top","title":"Api-key para acesso no marketplace B2W."},model:{value:(_vm.parametros.marketplaces.b2w.apikey),callback:function ($$v) {_vm.$set(_vm.parametros.marketplaces.b2w, "apikey", $$v)},expression:"parametros.marketplaces.b2w.apikey"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12"},[_c('v-label',{attrs:{"label":"Account Manager Key"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","case":"normal","data-toggle":"tooltip","data-placement":"top","title":"Account Manager Key para acesso no marketplace B2W."},model:{value:(_vm.parametros.marketplaces.b2w.accountmanagerkey),callback:function ($$v) {_vm.$set(_vm.parametros.marketplaces.b2w, "accountmanagerkey", $$v)},expression:"parametros.marketplaces.b2w.accountmanagerkey"}})],1)]),_vm._v(" "),_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Dados Marketplace Mercado Livre"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{staticClass:"text-right",attrs:{"label":"Requisitar Permissão Mercado Livre","icon":"fa-id-card"},on:{"click":function($event){return _vm.handlePermissaoMercadoLivre()}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Code"}}),_vm._v(" "),_c('form-field',{key:"mlcode",attrs:{"type":"text","case":"normal","data-toggle":"tooltip","data-placement":"top","title":"Code para acesso no marketplace B2W."},model:{value:(_vm.parametros.marketplaces.mercadolivre.code),callback:function ($$v) {_vm.$set(_vm.parametros.marketplaces.mercadolivre, "code", $$v)},expression:"parametros.marketplaces.mercadolivre.code"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Access Token"}}),_vm._v(" "),_c('form-field',{ref:"mlaccesstoken",attrs:{"type":"text","case":"normal","data-toggle":"tooltip","data-placement":"top","title":"Access token para acesso no marketplace Mercado Livre."},model:{value:(_vm.parametros.marketplaces.mercadolivre.accesstoken),callback:function ($$v) {_vm.$set(_vm.parametros.marketplaces.mercadolivre, "accesstoken", $$v)},expression:"parametros.marketplaces.mercadolivre.accesstoken"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Refresh Token"}}),_vm._v(" "),_c('form-field',{ref:"mlrefreshtoken",attrs:{"type":"text","case":"normal","data-toggle":"tooltip","data-placement":"top","title":"Refresh token para acesso no marketplace Mercado Livre."},model:{value:(_vm.parametros.marketplaces.mercadolivre.refreshtoken),callback:function ($$v) {_vm.$set(_vm.parametros.marketplaces.mercadolivre, "refreshtoken", $$v)},expression:"parametros.marketplaces.mercadolivre.refreshtoken"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"User ID"}}),_vm._v(" "),_c('form-field',{ref:"mluserid",attrs:{"type":"text","case":"normal","data-toggle":"tooltip","data-placement":"top","title":"User ID para acesso no marketplace Mercado Livre."},model:{value:(_vm.parametros.marketplaces.mercadolivre.userid),callback:function ($$v) {_vm.$set(_vm.parametros.marketplaces.mercadolivre, "userid", $$v)},expression:"parametros.marketplaces.mercadolivre.userid"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.tabFrente)?_c('div',{attrs:{"id":"tabFrente"}},[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Configurações de aparência do PDV"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"type":"color","col":"3","label":"Cor de Fundo Cabeçalho e Rodapé","name":"bg_top_bottom","v-errors":_vm.errors},model:{value:(_vm.parametros.pdv.colors.bg_top_bottom),callback:function ($$v) {_vm.$set(_vm.parametros.pdv.colors, "bg_top_bottom", $$v)},expression:"parametros.pdv.colors.bg_top_bottom"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"type":"color","col":"3","label":"Cor de Fonte Cabeçalho e Rodapé","name":"fc_top_bottom","v-errors":_vm.errors},model:{value:(_vm.parametros.pdv.colors.fc_top_bottom),callback:function ($$v) {_vm.$set(_vm.parametros.pdv.colors, "fc_top_bottom", $$v)},expression:"parametros.pdv.colors.fc_top_bottom"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"type":"color","col":"3","label":"Cor de fundo dos botões","name":"bg_buttom","v-errors":_vm.errors},model:{value:(_vm.parametros.pdv.colors.bg_buttom),callback:function ($$v) {_vm.$set(_vm.parametros.pdv.colors, "bg_buttom", $$v)},expression:"parametros.pdv.colors.bg_buttom"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"type":"color","col":"3","label":"Cor da fonte dos botões","name":"fc_buttom","v-errors":_vm.errors},model:{value:(_vm.parametros.pdv.colors.fc_buttom),callback:function ($$v) {_vm.$set(_vm.parametros.pdv.colors, "fc_buttom", $$v)},expression:"parametros.pdv.colors.fc_buttom"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6"},[_c('form-field',{attrs:{"type":"text","metadata":{ help: 'Informe o texto para exibição no topo da tela do PDV' },"label":"Mensagem tela do PDV"},model:{value:(_vm.parametros.pdv.default_header_title),callback:function ($$v) {_vm.$set(_vm.parametros.pdv, "default_header_title", $$v)},expression:"parametros.pdv.default_header_title"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6"},[_c('form-field',{attrs:{"type":"select","label":"Informar Qtd e Preço?","select-options":_vm.nao_sim_options,"name":"formato_venda_manual"},model:{value:(_vm.parametros.pdv.formato_venda_manual),callback:function ($$v) {_vm.$set(_vm.parametros.pdv, "formato_venda_manual", $$v)},expression:"parametros.pdv.formato_venda_manual"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6"},[_c('form-field',{attrs:{"type":"select","label":"Permite gerar NFC-e pelo PDV","select-options":_vm.nao_sim_options},model:{value:(_vm.parametros.pdv.exibe_opcao_gerar_nfce),callback:function ($$v) {_vm.$set(_vm.parametros.pdv, "exibe_opcao_gerar_nfce", $$v)},expression:"parametros.pdv.exibe_opcao_gerar_nfce"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6"},[_c('form-field',{attrs:{"type":"select","label":"Em caso de rejeição da (Nfe/Nfce)","select-options":_vm.pdv_ir_para_emissao_nf_options,"metadata":{ help: 'Definao o que fazer quando a NF for rejeitada' }},model:{value:(_vm.parametros.pdv.ir_para_emissao_nf),callback:function ($$v) {_vm.$set(_vm.parametros.pdv, "ir_para_emissao_nf", $$v)},expression:"parametros.pdv.ir_para_emissao_nf"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6"},[_c('form-field',{attrs:{"type":"select","label":"Ação Padrão Após Pagamento","select-options":_vm.focus_btn_pag_options},model:{value:(_vm.parametros.pdv.default_focus_btn_pag),callback:function ($$v) {_vm.$set(_vm.parametros.pdv, "default_focus_btn_pag", $$v)},expression:"parametros.pdv.default_focus_btn_pag"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6"},[_c('form-field',{attrs:{"type":"text","case":"normal","label":"Observações","data-toggle":"tooltip","data-placement":"top","metadata":{ help: 'Observações para impressão do cupom não fiscal' }},model:{value:(_vm.parametros.pdv.observacao),callback:function ($$v) {_vm.$set(_vm.parametros.pdv, "observacao", $$v)},expression:"parametros.pdv.observacao"}})],1)]),_vm._v(" "),_c('label-title',{staticClass:"mb-2 mt-5",attrs:{"title":"Controle do Estoque"}}),_vm._v(" "),_c('div',{staticClass:"row m-2"},[_c('div',{staticClass:"col-md-4 col-6"},[_c('input-checkbox',{attrs:{"estilo":'text-info',"label":"Baixa estoque dos produtos?","value-checked":true,"value-unchecked":false},model:{value:(_vm.parametros.controlaestoque),callback:function ($$v) {_vm.$set(_vm.parametros, "controlaestoque", $$v)},expression:"parametros.controlaestoque"}})],1)]),_vm._v(" "),_c('label-title',{staticClass:"mb-2 mt-5",attrs:{"title":"Preços"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6"},[_c('form-field',{attrs:{"type":"select","label":"Tabela de preço do PDV","select-options":_vm.tabelas_preco_options},model:{value:(_vm.parametros.pdv.tabela_preco),callback:function ($$v) {_vm.$set(_vm.parametros.pdv, "tabela_preco", $$v)},expression:"parametros.pdv.tabela_preco"}})],1)]),_vm._v(" "),(_vm.parametros.pdv.tabela_preco)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6"},[_c('form-field',{attrs:{"type":"select","label":"Permite alterar o preço de venda","select-options":_vm.nao_sim_options},model:{value:(_vm.parametros.pdv.altera_preco),callback:function ($$v) {_vm.$set(_vm.parametros.pdv, "altera_preco", $$v)},expression:"parametros.pdv.altera_preco"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6"},[_c('form-field',{attrs:{"type":"select","label":"Permite desconto na venda?","select-options":_vm.nao_sim_options},model:{value:(_vm.parametros.pdv.permite_desconto),callback:function ($$v) {_vm.$set(_vm.parametros.pdv, "permite_desconto", $$v)},expression:"parametros.pdv.permite_desconto"}})],1),_vm._v(" "),(_vm.parametros.pdv.permite_desconto == 'S')?_c('div',{staticClass:"col-md-2 col-6"},[_c('form-field',{attrs:{"type":"value","addon":"%","precision":2,"label":"Desconto máximo","data-toggle":"tooltip","data-placement":"top","title":"Desconto máximo que o vendedor pode aplicar em uma venda."},model:{value:(_vm.parametros.pdv.desconto_max),callback:function ($$v) {_vm.$set(_vm.parametros.pdv, "desconto_max", $$v)},expression:"parametros.pdv.desconto_max"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6"},[_c('form-field',{attrs:{"type":"select","label":"Permite acrescimo na venda?","select-options":_vm.nao_sim_options},model:{value:(_vm.parametros.pdv.permite_acrescimo),callback:function ($$v) {_vm.$set(_vm.parametros.pdv, "permite_acrescimo", $$v)},expression:"parametros.pdv.permite_acrescimo"}})],1),_vm._v(" "),(_vm.parametros.pdv.permite_acrescimo == 'S')?_c('div',{staticClass:"col-md-2 col-6"},[_c('form-field',{attrs:{"type":"value","addon":"%","precision":2,"label":"Acréscimo máximo","data-toggle":"tooltip","data-placement":"top","title":"Acréscimo máximo que o vendedor pode aplicar em uma venda."},model:{value:(_vm.parametros.pdv.acrescimo_max),callback:function ($$v) {_vm.$set(_vm.parametros.pdv, "acrescimo_max", $$v)},expression:"parametros.pdv.acrescimo_max"}})],1):_vm._e()]),_vm._v(" "),_c('label-title',{staticClass:"mb-2 mt-5",attrs:{"title":"Controle de Comandas e Mesas"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6"},[_c('form-field',{attrs:{"type":"select","placeholder":"Não","label":"Controle Comanda / Mesa","select-options":_vm.tipo_controle_cm_ms_options},model:{value:(_vm.parametros.pdv.tipo_controle_cm_ms),callback:function ($$v) {_vm.$set(_vm.parametros.pdv, "tipo_controle_cm_ms", $$v)},expression:"parametros.pdv.tipo_controle_cm_ms"}})],1)]),_vm._v(" "),(
          _vm.parametros.pdv.tipo_controle_cm_ms == 'MC' ||
          _vm.parametros.pdv.tipo_controle_cm_ms == 'MS'
        )?_c('div',{staticClass:"mb-4"},[_c('label-title',{attrs:{"title":"Adicionar uma mesa"}}),_vm._v(" "),_vm._l((_vm.parametros.pdv.listMesas),function(mesa,index){return _c('div',{key:index,staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-2 col-12"},[_c('form-field',{attrs:{"type":"text","label":"Código"},model:{value:(mesa.id),callback:function ($$v) {_vm.$set(mesa, "id", $$v)},expression:"mesa.id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('form-field',{attrs:{"type":"text","label":"Descrição"},model:{value:(mesa.descricao),callback:function ($$v) {_vm.$set(mesa, "descricao", $$v)},expression:"mesa.descricao"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('form-field',{attrs:{"type":"text","label":"Observação"},model:{value:(mesa.obs),callback:function ($$v) {_vm.$set(mesa, "obs", $$v)},expression:"mesa.obs"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-button',{attrs:{"label":"","title":"Excluir Mesa","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteMesa(index)}}})],1)])}),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Adicionar Mesa","nb-btdef":true},on:{"click":function($event){return _vm.handleAdicionarMesa()}}})],1)])],2):_vm._e(),_vm._v(" "),_c('label-title',{staticClass:"mb-2 mt-5",attrs:{"title":"Configuração para leitura de balanças"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('warnings',{attrs:{"messages":['Configure aqui as posições para leitura de código de barras de balanças!']}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('form-field',{attrs:{"type":"value","precision":0,"label":"Tamanho total do código de barras da balança","data-toggle":"tooltip","data-placement":"top"},model:{value:(_vm.parametros.pdv.balanca.tamanhobarra),callback:function ($$v) {_vm.$set(_vm.parametros.pdv.balanca, "tamanhobarra", $$v)},expression:"parametros.pdv.balanca.tamanhobarra"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('form-field',{attrs:{"type":"value","precision":0,"label":"Identificar do código de barras da balança","data-toggle":"tooltip","data-placement":"top"},model:{value:(_vm.parametros.pdv.balanca.numero_identificacao),callback:function ($$v) {_vm.$set(_vm.parametros.pdv.balanca, "numero_identificacao", $$v)},expression:"parametros.pdv.balanca.numero_identificacao"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('form-field',{attrs:{"type":"value","precision":0,"label":"Posição inicial do código do produto","data-toggle":"tooltip","data-placement":"top"},model:{value:(_vm.parametros.pdv.balanca.inicio_codigo),callback:function ($$v) {_vm.$set(_vm.parametros.pdv.balanca, "inicio_codigo", $$v)},expression:"parametros.pdv.balanca.inicio_codigo"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12"},[_c('form-field',{attrs:{"type":"value","precision":0,"label":"Posição final do código do produto","data-toggle":"tooltip","data-placement":"top"},model:{value:(_vm.parametros.pdv.balanca.fim_codigo),callback:function ($$v) {_vm.$set(_vm.parametros.pdv.balanca, "fim_codigo", $$v)},expression:"parametros.pdv.balanca.fim_codigo"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('form-field',{attrs:{"type":"select","label":"O código de barras contém o peso ou o valor?","select-options":_vm.pdv_balanca_peso_valor_options},model:{value:(_vm.parametros.pdv.balanca.barras_peso_ou_valor),callback:function ($$v) {_vm.$set(_vm.parametros.pdv.balanca, "barras_peso_ou_valor", $$v)},expression:"parametros.pdv.balanca.barras_peso_ou_valor"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('form-field',{attrs:{"type":"value","precision":0,"label":"Posição inicial do Peso ou Valor","data-toggle":"tooltip","data-placement":"top"},model:{value:(_vm.parametros.pdv.balanca.inicio_valor),callback:function ($$v) {_vm.$set(_vm.parametros.pdv.balanca, "inicio_valor", $$v)},expression:"parametros.pdv.balanca.inicio_valor"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12"},[_c('form-field',{attrs:{"type":"value","precision":0,"label":"Posição final do Peso ou Valor","data-toggle":"tooltip","data-placement":"top"},model:{value:(_vm.parametros.pdv.balanca.fim_valor),callback:function ($$v) {_vm.$set(_vm.parametros.pdv.balanca, "fim_valor", $$v)},expression:"parametros.pdv.balanca.fim_valor"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('form-field',{attrs:{"type":"select","label":"Quantidade de dígitos de casas decimais do valor","select-options":_vm.pdv_qtd_casas_valor_options},model:{value:(_vm.parametros.pdv.balanca.qtd_casas_valor),callback:function ($$v) {_vm.$set(_vm.parametros.pdv.balanca, "qtd_casas_valor", $$v)},expression:"parametros.pdv.balanca.qtd_casas_valor"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.tabDuimp)?_c('div',[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Integração Siscomex / Duimp"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('v-label',{attrs:{"label":"Ambiente Siscomex"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","select-options":_vm.siscomex_env_options,"name":"siscomex_environment"},model:{value:(_vm.filial.siscomex_environment),callback:function ($$v) {_vm.$set(_vm.filial, "siscomex_environment", $$v)},expression:"filial.siscomex_environment"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Client ID"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","case":"normal","data-toggle":"tooltip","data-placement":"top","title":"Client ID obtido no Portal Único Siscomex."},model:{value:(_vm.filial.siscomex_clientid),callback:function ($$v) {_vm.$set(_vm.filial, "siscomex_clientid", $$v)},expression:"filial.siscomex_clientid"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Client Secret"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"password","case":"normal","data-toggle":"tooltip","data-placement":"top","title":"Client Secret obtido no Portal Único Siscomex."},model:{value:(_vm.filial.siscomex_clientsecret),callback:function ($$v) {_vm.$set(_vm.filial, "siscomex_clientsecret", $$v)},expression:"filial.siscomex_clientsecret"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.tabEtiqueta)?_c('div',[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Configuração Layout de Etiquetas"}}),_vm._v(" "),_vm._l((_vm.listEtiquetas),function(etiqueta,index){return _c('div',{key:index,staticClass:"row"},[_c('div',{staticClass:"col-12 d-flex align-items-center mt-3"},[_c('form-field',{attrs:{"type":"text","col":"3","label":"Descrição Etiqueta"},model:{value:(etiqueta.descricao),callback:function ($$v) {_vm.$set(etiqueta, "descricao", $$v)},expression:"etiqueta.descricao"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"3","label":"Tipo","select-options":_vm.etiquetaTipoOptions},model:{value:(etiqueta.tipo),callback:function ($$v) {_vm.$set(etiqueta, "tipo", $$v)},expression:"etiqueta.tipo"}}),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('v-button',{attrs:{"label":"","title":"Configurar Etiqueta","icon":"fa-cog"},on:{"click":function($event){return _vm.handleSetEtiqueta(etiqueta)}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"","title":"Deletar Etiqueta","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteEtiqueta(index)}}})],1)],1)])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-button',{attrs:{"label":"Nova Etiqueta","title":"Adicionar Nova Etiqueta","icon":"fa-plus","nb-btdef":true},on:{"click":_vm.handleAdicionaEtiqueta}})],1)]),_vm._v(" "),(_vm.showModalEtiqueta)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h5',[_vm._v("Criar Nova Etiqueta")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.handleCloseModal()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('layout-etiqueta',{ref:"etiqueta",attrs:{"dados-etiqueta":this.etiqueta}})],1)]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{ref:"btnConfirm",attrs:{"label":"Salvar","title":"","nb-btdef":true},on:{"click":_vm.handleSaveEtiqueta}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":function($event){return _vm.handleCloseModal()}}})],1)])])]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.tabFinanceiro)?_c('div',[_c('div',[_c('h5',{staticClass:"mx-3"},[_vm._v("Carta de Cobrança")]),_vm._v(" "),_c('div',[_c('form-field',{ref:"nome",attrs:{"label":"Email de Resposta","type":"email","col":"7","name":"email"},model:{value:(_vm.parametros.cartaCobranca.emailResposta),callback:function ($$v) {_vm.$set(_vm.parametros.cartaCobranca, "emailResposta", $$v)},expression:"parametros.cartaCobranca.emailResposta"}})],1),_vm._v(" "),_c('div',[_c('form-field',{ref:"nome",attrs:{"label":"Assunto","type":"text","col":"7","name":"assunto"},model:{value:(_vm.parametros.cartaCobranca.assunto),callback:function ($$v) {_vm.$set(_vm.parametros.cartaCobranca, "assunto", $$v)},expression:"parametros.cartaCobranca.assunto"}})],1),_vm._v(" "),_c('div',{staticClass:"row text-editor"},[_c('div',{staticClass:"col-md-7 my-3"},[_c('wysiwyg',{model:{value:(_vm.parametros.cartaCobranca.textoEmail),callback:function ($$v) {_vm.$set(_vm.parametros.cartaCobranca, "textoEmail", $$v)},expression:"parametros.cartaCobranca.textoEmail"}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.tabCertificado)?_c('div',[_c('app-certificado',{attrs:{"codfil":_vm.filial.codfil,"disableBtnVoltar":true}})],1):_vm._e()],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}}),_vm._v(" Remover\n                  Imagem\n                ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeModal()}}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-xl",staticStyle:{"overflow-y":"initial !important","margin":"5px auto"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content modal-full-h"},[_c('div',{staticClass:"modal-header",staticStyle:{"background":"'#174b79' !important"}},[_c('div',{staticClass:"d-flex w-100 justify-content-center"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,staticClass:"d-flex"},[_c('div',{staticClass:"step-wrapper"},[_c('div',{class:['circle', { active: index === _vm.localStep }]},[_vm._v("\n                  "+_vm._s(index + 1)+"\n                ")])]),_vm._v(" "),(index < _vm.steps.length - 1)?_c('div',{staticClass:"line"}):_vm._e()])}),0)]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"height":"180px!important","max-height":"100%","overflow-y":"auto"}},[_c('FilialForm',{ref:"filialFormRef",attrs:{"guide":this.guide,"type":_vm.guideType},on:{"gonextstep":_vm.nextStep}})],1),_vm._v(" "),_c('div',{staticClass:"modal-footer d-flex justify-content-center",staticStyle:{"width":"100%"}},[_c('v-button',{ref:"qtdConfirmButton",staticClass:"ml-3",staticStyle:{"position":"absolute","left":"0"},attrs:{"label":"Continuar Depois"},on:{"click":function($event){return _vm.closeModal()}}}),_vm._v(" "),(_vm.canGoBack)?_c('v-button',{ref:"qtdConfirmButton",attrs:{"nbBtdef":"","label":"Anterior"},on:{"click":function($event){return _vm.backStep()}}}):_vm._e(),_vm._v(" "),(_vm.lastStep)?_c('v-button',{ref:"qtdConfirmButton",attrs:{"nbBtdef":"","label":"Salvar"},on:{"click":function($event){return _vm.handleSave()}}}):_c('v-button',{ref:"qtdConfirmButton",attrs:{"nbBtdef":"","label":this.guide ? 'Próximo' : 'Confirmar'},on:{"click":function($event){return _vm.tryNextStep()}}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"tabindex":1}},[_c('nav',{staticClass:"navbar navbar-expand-lg navbar-light",class:_vm.classDesktopMobile,staticStyle:{"background-color":"white","border-bottom":"1px solid #e9e5e5"}},[_vm._m(0),_vm._v(" "),(_vm.menu == 'menuforcavendas')?_c('ul',{staticClass:"navbar-nav nb-dropdownmenu w-100"},[_c('div',{staticClass:"w-100 mt-2 mb-2 mobile-device"},[_c('span',{staticClass:"submenu-header"},[_vm._v("\n            "+_vm._s(_vm.usuarionome)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"submenu-header"},[_vm._v("\n            "+_vm._s(_vm.email)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"ml-md-auto"}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/fv/produtos"}},[_c('i',{staticClass:"fa fa-archive pr-2",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n            Produtos")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/fv/clientes"}},[_c('i',{staticClass:"fa fa-university pr-2",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n            Clientes")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/fv/pedidos"}},[_c('i',{staticClass:"fa fa-money pr-2",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n            Vendas")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/configuracoes"}},[_c('i',{staticClass:"fa fa-cog pr-2",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}})])],1),_vm._v(" "),(_vm.appLoja)?_c('li',[_c('router-link',{attrs:{"to":"/loja"}},[_c('i',{staticClass:"fa fa-shopping-basket",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}})])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ml-md-auto"}),_vm._v(" "),_c('li',{staticClass:"other-device float-right"},[_vm._m(2),_vm._v(" "),_c('ul',{staticClass:"columns-2 submenu-right",attrs:{"id":"submenu"}},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":_vm.handleGuia}},[_c('i',{staticClass:"fa fa-mortar-board pr-3"}),_vm._v("Guia\n                  Primeiros Passos")])]),_vm._v(" "),_vm._l((_vm.helpList),function(help,index){return _c('li',{key:index},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.handleShowVideo(index)}}},[_c('i',{staticClass:"fa fa-youtube-play nb-help-video-icon",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(help.title))])])})],2)])]),_vm._v(" "),_c('li',{staticClass:"other-device float-right"},[_vm._m(3),_vm._v(" "),_c('ul',{staticClass:"columns-1 submenu-right",attrs:{"id":"submenu"}},[_c('ul',[_c('span',{staticClass:"menu-user d-flex py-2"},[_c('i',{staticClass:"fa fa-user-circle",staticStyle:{"font-size":"3.5rem"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column justify-content-center align-items-start ml-2"},[_c('span',[_vm._v(_vm._s(_vm.usuarionome))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.email))]),_vm._v(" "),_c('span',[_vm._v("Cod. Empresa: "+_vm._s(_vm.empresacod))])])]),_vm._v(" "),_c('span',{staticClass:"menu-email text-uppercase"},[_c('i',{staticClass:"fa fa-university",attrs:{"aria-hidden":"true"}}),_vm._v("\n                "+_vm._s(_vm.empresanome)+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"menu-email text-uppercase",staticStyle:{"cursor":"pointer"},attrs:{"id":"btn-exit"},on:{"click":_vm.handleLogout}},[_c('i',{staticClass:"fa fa-sign-out",attrs:{"aria-hidden":"true"}}),_vm._v("\n                Sair\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider mobile-device"}),_vm._v(" "),_c('li',{staticClass:"mobile-device"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.handleLogout}},[_vm._v("Sair")])]),_vm._v(" "),_c('li',{staticClass:"mobile-device"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.handleCentral}},[_vm._v("Central de Ajuda")])])]):_vm._e(),_vm._v(" "),(_vm.menu == 'menuvarejopdv')?_c('ul',{staticClass:"navbar-nav nb-dropdownmenu w-100"},[_c('div',{staticClass:"w-100 mt-2 mb-2 mobile-device"},[_c('span',{staticClass:"submenu-header"},[_vm._v("\n            "+_vm._s(_vm.usuarionome)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"submenu-header"},[_vm._v("\n            "+_vm._s(_vm.email)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"ml-md-auto"}),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/fv/produtos"}},[_c('i',{staticClass:"fa fa-archive pr-2",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n            Produtos")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/fv/clientes"}},[_c('i',{staticClass:"fa fa-university pr-2",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n            Clientes")])],1),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Varejo")]),_vm._v(" "),_c('ul',{staticClass:"columns-2",attrs:{"id":"submenu"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"submenu-col-2"},[_c('ul',[_c('div',{staticClass:"nb-menu-title custom-text-shadow font-weight-bold ml-n2"},[_vm._v("\n                    Movimentos\n                  ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/varejo"}},[_vm._v("PDV")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/varejolist"}},[_vm._v("Vendas Frente de Caixa")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/varejo/devolucaolist"}},[_vm._v("Devolução de Venda")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/varejo/controlecaixa"}},[_vm._v("Controle de Caixas")])],1)])]),_vm._v(" "),_c('div',{staticClass:"submenu-col-2 left-divider pl-2"},[_c('ul',[_c('div',{staticClass:"nb-menu-title font-weight-bold ml-n2"},[_vm._v("\n                    Consultas\n                  ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/varejo-movimento-caixa"}},[_vm._v("Consulta Fechamento de Caixa")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/varejo/recebiveis"}},[_vm._v("Consulta Recebiveis")])],1),_vm._v(" "),_c('div',{staticClass:"nb-menu-title font-weight-bold ml-n2"},[_vm._v("\n                    Cadastros\n                  ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/fpag"}},[_vm._v("Formas de Pagamento")])],1)])])])])]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/configuracoes"}},[_c('i',{staticClass:"fa fa-cog pr-2",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}})])],1),_vm._v(" "),_c('div',{staticClass:"ml-md-auto"}),_vm._v(" "),_c('li',{staticClass:"other-device float-right"},[_vm._m(5),_vm._v(" "),_c('ul',{staticClass:"columns-2 submenu-right",attrs:{"id":"submenu"}},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":_vm.handleGuia}},[_c('i',{staticClass:"fa fa-mortar-board pr-3"}),_vm._v("Guia\n                  Primeiros Passos")])]),_vm._v(" "),_vm._l((_vm.helpList),function(help,index){return _c('li',{key:index},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.handleShowVideo(index)}}},[_c('i',{staticClass:"fa fa-youtube-play nb-help-video-icon",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(help.title))])])})],2)])]),_vm._v(" "),_c('li',{staticClass:"other-device float-right"},[_vm._m(6),_vm._v(" "),_c('ul',{staticClass:"columns-1 submenu-right",attrs:{"id":"submenu"}},[_c('ul',[_c('span',{staticClass:"menu-user d-flex py-2"},[_c('i',{staticClass:"fa fa-user-circle",staticStyle:{"font-size":"3.5rem"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column justify-content-center align-items-start ml-2"},[_c('span',[_vm._v(_vm._s(_vm.usuarionome))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.email))]),_vm._v(" "),_c('span',[_vm._v("Cod. Empresa: "+_vm._s(_vm.empresacod))])])]),_vm._v(" "),_c('span',{staticClass:"menu-email text-uppercase"},[_c('i',{staticClass:"fa fa-university",attrs:{"aria-hidden":"true"}}),_vm._v("\n                "+_vm._s(_vm.empresanome)+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"menu-email text-uppercase",staticStyle:{"cursor":"pointer"},attrs:{"id":"btn-exit"},on:{"click":_vm.handleLogout}},[_c('i',{staticClass:"fa fa-sign-out",attrs:{"aria-hidden":"true"}}),_vm._v("\n                Sair\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider mobile-device"}),_vm._v(" "),_c('li',{staticClass:"mobile-device"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.handleLogout}},[_vm._v("Sair")])]),_vm._v(" "),_c('li',{staticClass:"mobile-device"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.handleCentral}},[_vm._v("Central de Ajuda")])])]):_vm._e(),_vm._v(" "),(_vm.menu == 'menucompleto')?_c('div',{staticClass:"d-flex justify-content-between align-items-center w-100"},[_c('div',{staticClass:"nb-dropdownmenu"},[_c('ul',[_vm._m(7),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Cadastros")]),_vm._v(" "),_c('ul',{staticClass:"columns-1",attrs:{"id":"submenu"}},[_c('ul',[_c('div',{staticClass:"nb-menu-title font-weight-bold ml-n2"},[_vm._v("\n                    Principais\n                  ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/fv/produtos"}},[_vm._v("Produtos")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/partlist"}},[_vm._v("Participantes\n                      "),_c('span',[_c('small',[_vm._v("Clientes/Fornecedores/Transportadoras")])])])],1),_vm._v(" "),_c('div',{staticClass:"nb-menu-title font-weight-bold ml-n2"},[_vm._v("\n                    Básicos\n                  ")]),_vm._v(" "),(_vm.administrador)?_c('li',[_c('router-link',{attrs:{"to":"/importaxml"}},[_vm._v("Importar Cadastros por XML")])],1):_vm._e()])])]),_vm._v(" "),(_vm.appERP || _vm.appForcaVendas)?_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Pedidos")]),_vm._v(" "),_c('ul',{staticClass:"columns-2",attrs:{"id":"submenu"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"submenu-col-2"},[_c('ul',[_c('div',{staticClass:"nb-menu-title custom-text-shadow font-weight-bold ml-n2"},[_vm._v("\n                        Movimentos\n                      ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":_vm.appERP ? '/pedidolist' : '/fv/pedidos'}},[_vm._v("Pedidos de Venda")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/compralist"}},[_vm._v("Pedidos de Compra")])],1),_vm._v(" "),(_vm.appERP)?_c('li',[((_vm.isAdmin && _vm.hasRep) || _vm.isRep)?_c('router-link',{attrs:{"to":"/fv/pedidos"}},[_vm._v("Gestão Representante\n                        ")]):_vm._e()],1):_vm._e()])]),_vm._v(" "),(_vm.planoConsultasComercial)?_c('div',{staticClass:"submenu-col-2 left-divider pl-2"},[_c('ul',[_c('div',{staticClass:"nb-menu-title font-weight-bold ml-n2"},[_vm._v("\n                        Consultas\n                      ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/carteiraclientes"}},[_vm._v("Carteira de clientes")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/vendas-performance-carteira"}},[_vm._v("Performance da carteira")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/curvacliente"}},[_vm._v("Curva ABC de clientes")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/vendas-por-cliente"}},[_vm._v("Vendas por cliente")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/lista-clientes"}},[_vm._v("Listagem de clientes")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/vendas-vendedor"}},[_vm._v("Ranking de vendedores")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/vendas"}},[_vm._v("Consulta Vendas")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/vendas-produtos"}},[_vm._v("Produtos vendidos")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/vendas-pedidos-produto"}},[_vm._v("Pedidos por produto")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/vendas-pedidos-faturados"}},[_vm._v("Pedidos faturados")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/vendas-pedidos-comissao-por-pedido"}},[_vm._v("Comissão por Pedido\n                        ")])],1)])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.appERP)?_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Varejo")]),_vm._v(" "),_c('ul',{staticClass:"columns-2",attrs:{"id":"submenu"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"submenu-col-2"},[_c('ul',[_c('div',{staticClass:"nb-menu-title custom-text-shadow font-weight-bold ml-n2"},[_vm._v("\n                        Movimentos\n                      ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/varejo"}},[_vm._v("PDV")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/varejolist"}},[_vm._v("Vendas Frente de Caixa")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/varejo/devolucaolist"}},[_vm._v("Devolução de Venda")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/varejo/controlecaixa"}},[_vm._v("Controle de Caixas")])],1)])]),_vm._v(" "),_c('div',{staticClass:"submenu-col-2 left-divider pl-2"},[_c('ul',[_c('div',{staticClass:"nb-menu-title font-weight-bold ml-n2"},[_vm._v("\n                        Consultas\n                      ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/varejo-movimento-caixa"}},[_vm._v("Consulta Fechamento de Caixa")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/varejo/recebiveis"}},[_vm._v("Consulta Recebiveis")])],1),_vm._v(" "),_c('div',{staticClass:"nb-menu-title font-weight-bold ml-n2"},[_vm._v("\n                        Cadastros\n                      ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/fpag"}},[_vm._v("Formas de Pagamento")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/caixas"}},[_vm._v("Caixas PDV")])],1)])])])])]):_vm._e(),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Faturamento")]),_vm._v(" "),_c('ul',{staticClass:"columns-2",attrs:{"id":"submenu"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"submenu-col-2"},[_c('ul',[_c('div',{staticClass:"nb-menu-title custom-text-shadow font-weight-bold ml-n2"},[_vm._v("\n                        Movimentos\n                      ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/nflist/saida"}},[_vm._v("Notas de Saída")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/nflist/entrada"}},[_vm._v("Notas de Entrada")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/nfimportlist"}},[_vm._v("Notas de Importação")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/duimplist"}},[_vm._v("DUIMP (Siscomex)")])],1)])]),_vm._v(" "),_c('div',{staticClass:"submenu-col-2 left-divider pl-2"},[_c('ul',[_c('div',{staticClass:"nb-menu-title font-weight-bold ml-n2"},[_vm._v("\n                        Outras Rotinas\n                      ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/manifesto"}},[_vm._v("Manifestação Destinatário")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/inutlist"}},[_vm._v("Inutilizar Numeração")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/mennflist"}},[_vm._v("Mensagens Para NF")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/ivancmlist"}},[_vm._v("NCM x CST-IBS/CBS")])],1),_vm._v(" "),(_vm.administrador)?_c('li',[_c('router-link',{attrs:{"to":"/importaxmlhist"}},[_vm._v("Importar NF-e por XML")])],1):_vm._e(),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('div',{staticClass:"nb-menu-title font-weight-bold ml-n2"},[_vm._v("\n                        Relatórios\n                      ")]):_vm._e(),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('li',[_c('router-link',{attrs:{"to":"/printform"}},[_vm._v("Notas e Pedidos")])],1):_vm._e(),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('li',[_c('router-link',{attrs:{"to":"/consultas/distribuicaocfop"}},[_vm._v("Distribuição por CFOP")])],1):_vm._e(),_vm._v(" "),((_vm.appERP || _vm.appNFe) && _vm.showConsultasAntigas)?_c('li',[_c('router-link',{attrs:{"to":"/estoque/saldoentradasaida"}},[_vm._v("Saldo Entradas/Saídas")])],1):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(_vm.menuLiberado('estoque'))?_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Estoque")]),_vm._v(" "),_c('ul',{staticClass:"columns-2",attrs:{"id":"submenu"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"submenu-col-2"},[_c('ul',[_c('div',{staticClass:"nb-menu-title custom-text-shadow font-weight-bold ml-n2"},[_vm._v("\n                        Movimentos\n                      ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/importa/estoque"}},[_vm._v("Importar Estoque")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/estoque-produto"}},[_vm._v("Consulta Estoque do Produto")])],1),_vm._v(" "),(_vm.showConsultasAntigas)?_c('li',[_c('router-link',{attrs:{"to":"/consultas/items-estoque"}},[_vm._v("Consulta Estoque Atual")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nb-menu-title custom-text-shadow font-weight-bold ml-n2"},[_vm._v("\n                        Básicos\n                      ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/depolist"}},[_vm._v("Depósito")])],1)])]),_vm._v(" "),(_vm.planoConsultasEstoque)?_c('div',{staticClass:"submenu-col-2 left-divider pl-2"},[_c('ul',[_c('div',{staticClass:"nb-menu-title font-weight-bold ml-n2"},[_vm._v("\n                        Consultas\n                      ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/estoque-saldo"}},[_vm._v("Consulta Saldo Estoque")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/entrada-e-saida"}},[_vm._v("Movimentos de Entradas e Saídas")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/consultas/resumo-entrada-e-saida"}},[_vm._v("Resumo de Entradas e Saídas")])],1),_vm._v(" "),(_vm.showConsultasAntigas)?_c('li',[_c('router-link',{attrs:{"to":"/estoque/saldoentradasaida"}},[_vm._v("Saldo Entradas/Saídas")])],1):_vm._e()])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.menuLiberado('financeiro'))?_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Financeiro")]),_vm._v(" "),_c('ul',{staticClass:"columns-2",attrs:{"id":"submenu"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"submenu-col-2"},[_c('ul',[_c('div',{staticClass:"nb-menu-title custom-text-shadow font-weight-bold ml-n2"},[_vm._v("\n                        Movimentos\n                      ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/financeiro"}},[_vm._v("Painel Financeiro")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/cnab"}},[_vm._v("Arquivos de Cobrança")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/banking"}},[_vm._v("Cobrança Banking")])],1),_vm._v(" "),(_vm.planoConsultasFinanceiro)?_c('div',{staticClass:"nb-menu-title font-weight-bold ml-n2"},[_vm._v("\n                        Consultas\n                      ")]):_vm._e(),_vm._v(" "),(_vm.planoConsultasFinanceiro)?_c('li',[_c('router-link',{attrs:{"to":"/financeiro/posicaofinanceiro"}},[_vm._v("Posição do Financeiro")])],1):_vm._e(),_vm._v(" "),(_vm.planoConsultasFinanceiro)?_c('li',[_c('router-link',{attrs:{"to":"/financeiro/financeirobaixas"}},[_vm._v("Consulta Baixas")])],1):_vm._e(),_vm._v(" "),(_vm.planoConsultasFinanceiro)?_c('li',[_c('router-link',{attrs:{"to":"/financeiro/fluxodecaixa"}},[_vm._v("Fluxo de Caixa")])],1):_vm._e(),_vm._v(" "),(_vm.planoConsultasFinanceiro)?_c('li',[_c('router-link',{attrs:{"to":"/financeiro/dre"}},[_vm._v("Consulta DRE")])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"submenu-col-2 left-divider pl-2"},[_c('ul',[_c('div',{staticClass:"nb-menu-title font-weight-bold ml-n2"},[_vm._v("\n                        Cadastros\n                      ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/cta"}},[_vm._v("Contas")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/natfinlist"}},[_vm._v("Natureza Financeira")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/fpag"}},[_vm._v("Formas de Pagamento")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/cobranca-config"}},[_vm._v("Configuração de Cobrança")])],1)])])])])]):_vm._e(),_vm._v(" "),(false)?_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("CRM")]),_vm._v(" "),_c('ul',{staticClass:"columns-1",attrs:{"id":"submenu"}},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/crm/lead/list"}},[_c('i',{staticClass:"fa fa-exclamation pr-2",staticStyle:{"font-size":"18px","width":"25px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n                      Leads")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/crm/pessoa/list"}},[_c('i',{staticClass:"fa fa-user pr-2",staticStyle:{"font-size":"18px","width":"25px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n                      Contatos")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/crm/organizacao/list"}},[_c('i',{staticClass:"fa fa-university pr-2",staticStyle:{"font-size":"18px","width":"25px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n                      Organizações")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/crm/painel"}},[_c('i',{staticClass:"fa fa-dollar pr-2",staticStyle:{"font-size":"18px","width":"25px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n                      Negócios")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/crm/config"}},[_c('i',{staticClass:"fa fa-cog pr-2",staticStyle:{"font-size":"18px","width":"25px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n                      Configurações")])],1)])])]):_vm._e(),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Configurações")]),_vm._v(" "),_c('ul',{staticClass:"columns-2 submenu-right",attrs:{"id":"submenu"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"submenu-col-2"},[_c('ul',[_c('div',{staticClass:"nb-menu-title font-weight-bold ml-n2"},[_vm._v("\n                        Configurações Gerais\n                      ")]),_vm._v(" "),(_vm.administrador && !_vm.isGuide)?_c('li',[_c('router-link',{attrs:{"to":"/configuracoes"}},[_vm._v("Configurações da Conta")])],1):_vm._e(),_vm._v(" "),(_vm.administrador && _vm.isGuide)?_c('li',[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.handleConfigModal}},[_vm._v("\n                          Configurações da Conta")])]):_vm._e(),_vm._v(" "),(_vm.administrador)?_c('li',[_c('router-link',{attrs:{"to":"/filiallist/certificado"}},[_vm._v("Certificado Digital")])],1):_vm._e(),_vm._v(" "),(_vm.administrador && _vm.hasRep)?_c('li',[_c('router-link',{attrs:{"to":"/configuracoes"}},[_vm._v("Config. Força de Vendas\n                        ")])],1):_vm._e(),_vm._v(" "),(_vm.administrador)?_c('li',[_c('router-link',{attrs:{"to":"/minhaconta"}},[_vm._v("Minha Conta ")])],1):_vm._e(),_vm._v(" "),(_vm.administrador && _vm.appLoja)?_c('li',[_c('router-link',{attrs:{"to":"/loja"}},[_vm._v("Config. Loja ")])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"submenu-col-2 left-divider pl-2"},[_c('ul',[_c('div',{staticClass:"nb-menu-title font-weight-bold ml-n2"},[_vm._v("\n                        Cadastros\n                      ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/nateslist"}},[_vm._v("Natureza Entrada e Saída")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/serienflist"}},[_vm._v("Séries de Nota Fiscal")])],1),_vm._v(" "),_c('div',{staticClass:"nb-menu-title font-weight-bold ml-n2"},[_vm._v("\n                        Consultas\n                      ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/ivaclasslist"}},[_vm._v("CST-IBS/CBS")])],1)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"menu-icons nb-dropdownmenu w-auto"},[_c('ul',{staticClass:"list-unstyled d-flex justify-content-end align-items-center"},[_c('li',{staticClass:"float-right"},[_c('a',{staticClass:"nb-menu-config",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-bell",class:{ bell: _vm.unreadNotification },staticStyle:{"font-size":"20px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.unreadNotification)?_c('span',{staticClass:"badge badge-danger",attrs:{"id":"badge"}},[_vm._v(_vm._s(_vm.unreadNotification))]):_vm._e()]),_vm._v(" "),_c('ul',{staticClass:"columns-1 submenu-right notification",attrs:{"id":"submenu"}},[_vm._l((_vm.notificationsList),function(notification,index){return _c('ul',{key:index},[_c('li',[_c('a',{staticClass:"notification-text",attrs:{"href":"#"},on:{"click":function($event){return _vm.handleNotifications(notification)}}},[_c('i',{staticClass:"pr-3 fa",class:_vm.iconNotifications(notification),staticStyle:{"font-size":"18px"}}),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(notification.codnotificacao))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(notification.assunto))])])])])}),_vm._v(" "),(_vm.nextPage > 0)?_c('li',[_c('a',{staticClass:"notification-text",attrs:{"href":"#"},on:{"click":function($event){return _vm.loadNotifications(true)}}},[_c('i',{staticClass:"pr-3 fa fa-plus",staticStyle:{"font-size":"18px"}}),_vm._v(" "),_c('span',[_vm._v("Carregar mais")])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn text-light flex-row justify-content-end w-100",on:{"click":function($event){return _vm.handleShowNotificationHistory()}}},[_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("\n                    Exibir histórico de notificações\n                  ")]),_vm._v(" "),_c('i',{staticClass:"fa fa-share ml-2"})])],2)]),_vm._v(" "),_c('li',{staticClass:"other-device float-right"},[_vm._m(8),_vm._v(" "),_c('ul',{staticClass:"columns-1 submenu-right",attrs:{"id":"submenu"}},[_c('ul',[_c('span',{staticClass:"menu-user d-flex py-2"},[_c('i',{staticClass:"fa fa-user-circle",staticStyle:{"font-size":"3.5rem"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column justify-content-center align-items-start ml-2"},[_c('span',[_vm._v(_vm._s(_vm.usuarionome))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.email))]),_vm._v(" "),_c('span',[_vm._v("Cod. Empresa: "+_vm._s(_vm.empresacod))])])]),_vm._v(" "),_c('span',{staticClass:"menu-email text-uppercase"},[_c('i',{staticClass:"fa fa-university",attrs:{"aria-hidden":"true"}}),_vm._v("\n                    "+_vm._s(_vm.empresanome)+"\n                  ")]),_vm._v(" "),_c('span',{staticClass:"menu-email text-uppercase",staticStyle:{"cursor":"pointer"},attrs:{"id":"btn-exit"},on:{"click":_vm.handleLogout}},[_c('i',{staticClass:"fa fa-sign-out",attrs:{"aria-hidden":"true"}}),_vm._v("\n                    Sair\n                  ")])])])]),_vm._v(" "),_c('li',{staticClass:"other-device float-right"},[_vm._m(9),_vm._v(" "),_c('ul',{staticClass:"columns-3 submenu-right",attrs:{"id":"submenu"}},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":_vm.handleGuia}},[_c('i',{staticClass:"fa fa-mortar-board pr-3"}),_vm._v("Guia\n                      Primeiros Passos")])]),_vm._v(" "),_vm._l((_vm.helpList),function(help,index){return _c('li',{key:index},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.handleShowVideo(index)}}},[_c('i',{staticClass:"fa fa-youtube-play nb-help-video-icon",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(help.title))])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider mobile-device"}),_vm._v(" "),_c('li',{staticClass:"mobile-device"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.handleLogout}},[_vm._v("Sair")])]),_vm._v(" "),_c('li',{staticClass:"mobile-device"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.handleCentral}},[_vm._v("Central de Ajuda")])])])])]):_vm._e()]),_vm._v(" "),_c('nav',{staticClass:"navbar navbar-mobile bg-white w-100 d-none",staticStyle:{"height":"60px"}},[_c('div',{staticClass:"d-flex justify-content-start align-items-center"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"wrapper bg-white d-none",class:{ active: _vm.viewMobileMenu }},[(_vm.menu == 'menucompleto')?_c('div',{staticClass:"menu mb-5"},[_c('div',{staticClass:"user-info d-flex justify-content-start align-items-center ml-2 my-3"},[_c('i',{staticClass:"fa fa-user-circle",staticStyle:{"font-size":"40px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column ml-3"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.usuarionome))]),_vm._v(" "),_c('span',{},[_vm._v(_vm._s(_vm.email))])])]),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('div',{staticClass:"panel",staticStyle:{"max-height":"0"}},[(_vm.appERP || _vm.appNFe)?_c('p',{staticClass:"text-secondary font-weight-bold"},[_vm._v("\n                Principais\n              ")]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"list-unstyled ml-3"},[_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/fv/produtos"}},[_vm._v("Produtos")])],1),_vm._v(" "),_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/partlist"}},[_vm._v("Participantes "),_c('small',[_vm._v("Cli/Forn/Transp")])])],1)]),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('p',{staticClass:"text-secondary font-weight-bold"},[_vm._v("\n                Básicos\n              ")]):_vm._e(),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('ul',{staticClass:"list-unstyled ml-3"},[_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/gruclilist"}},[_vm._v("Grupos de Clientes")])],1),_vm._v(" "),_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/gruforlist"}},[_vm._v("Grupos de Fornecedores")])],1),_vm._v(" "),_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/gradelist"}},[_vm._v("Grades")])],1),_vm._v(" "),_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/mennflist"}},[_vm._v("Mensagens Para NF")])],1)]):_vm._e()]),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('div',{staticClass:"panel",staticStyle:{"max-height":"0"}},[(_vm.appERP || _vm.appNFe)?_c('p',{staticClass:"text-secondary font-weight-bold"},[_vm._v("\n                Movimentos\n              ")]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"list-unstyled ml-3"},[(_vm.appERP || _vm.appNFe)?_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/pedidolist"}},[_vm._v("Pedidos de Venda")])],1):_vm._e(),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/compralist"}},[_vm._v("Pedidos de Compra")])],1):_vm._e(),_vm._v(" "),(_vm.appForcaVendas)?_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/fv/pedidos"}},[_vm._v("Pedidos")])],1):_vm._e(),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/nflist/saida"}},[_vm._v("Notas de Saída")])],1):_vm._e(),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/nflist/entrada"}},[_vm._v("Notas de Entrada")])],1):_vm._e(),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/nfimportlist"}},[_vm._v("Notas de Importação")])],1):_vm._e(),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/duimplist"}},[_vm._v("DUIMP (Siscomex)")])],1):_vm._e(),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/manifesto"}},[_vm._v("Manifestação Destinatário")])],1):_vm._e(),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/inutlist"}},[_vm._v("Inutilizar Numeração")])],1):_vm._e()]),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('p',{staticClass:"text-secondary font-weight-bold"},[_vm._v("\n                Relatórios\n              ")]):_vm._e(),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('ul',{staticClass:"list-unstyled ml-3"},[(_vm.showConsultasAntigas)?_c('li',{staticClass:"py-2 ml-n2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/estoque/saldoentradasaida"}},[_vm._v("Saldo Entradas/Saídas\n                  ")])],1):_vm._e(),_vm._v(" "),_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/printform"}},[_vm._v("Notas e Pedidos")])],1),_vm._v(" "),_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/consultas/distribuicaocfop"}},[_vm._v("Distribuição por CFOP")])],1)]):_vm._e()]),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('div',{staticClass:"panel",staticStyle:{"max-height":"0"}},[(_vm.appERP || _vm.appNFe)?_c('p',{staticClass:"text-secondary font-weight-bold"},[_vm._v("\n                Configuração\n              ")]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"list-unstyled ml-3"},[(_vm.administrador && _vm.appLoja)?_c('li',[_c('router-link',{attrs:{"to":"/loja"}},[_vm._v("Config. Loja ")])],1):_vm._e(),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark text-decoration-none",attrs:{"to":"/fv/configuracoes"}},[_vm._v("Configurações da\n                    Conta")])],1):_vm._e(),_vm._v(" "),(_vm.appForcaVendas)?_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark text-decoration-none",attrs:{"to":"/filiallist/certificado"}},[_vm._v("Certificado\n                    Digital")])],1):_vm._e(),_vm._v(" "),(_vm.appERP || _vm.appNFe)?_c('li',{staticClass:"py-2"},[_c('router-link',{staticClass:"menu-link text-dark text-decoration-none",attrs:{"to":"/minhaconta"}},[_vm._v("Minha Conta\n                  ")])],1):_vm._e()])]),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('div',{staticClass:"panel",staticStyle:{"max-height":"0"}},[_c('ul',{staticClass:"list-unstyled ml-3"},[_c('li',{staticClass:"py-2 ml-n2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/varejo"}},[_vm._v("Frente de Caixa")])],1),_vm._v(" "),_c('li',{staticClass:"py-2 ml-n2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/varejolist"}},[_vm._v("Vendas Frente de Caixa")])],1),_vm._v(" "),_c('li',{staticClass:"py-2 ml-n2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/varejo/devolucaolist"}},[_vm._v("Devolução de Venda")])],1),_vm._v(" "),_c('li',{staticClass:"py-2 ml-n2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/varejo/controlecaixa"}},[_vm._v("Controle dos Caixas")])],1),_vm._v(" "),_c('li',{staticClass:"py-2 ml-n2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/consultas/varejo-movimento-caixa"}},[_vm._v("Consulta Fechamento de\n                    Caixa")])],1),_vm._v(" "),_c('li',{staticClass:"py-2 ml-n2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/varejo/recebiveis"}},[_vm._v("Consulta Recebiveis")])],1),_vm._v(" "),_c('li',{staticClass:"py-2 ml-n2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/fpag"}},[_vm._v("Formas de Pagamento")])],1)])]),_vm._v(" "),_c('button',{staticClass:"accordion text-uppercase",on:{"click":_vm.handleLogout}},[_c('i',{staticClass:"fa fa-sign-out",staticStyle:{"font-size":"16px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n              Sair\n            ")])]):_vm._e(),_vm._v(" "),(_vm.menu == 'menuforcavendas')?_c('div',{staticClass:"menu mb-5"},[_c('div',{staticClass:"user-info d-flex justify-content-start align-items-center ml-2 my-3"},[_c('i',{staticClass:"fa fa-user-circle",staticStyle:{"font-size":"40px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column ml-3"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.usuarionome))]),_vm._v(" "),_c('span',{},[_vm._v(_vm._s(_vm.email))])])]),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('button',{staticClass:"accordion text-uppercase"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/fv/produtos"}},[_vm._v("Produtos")])],1),_vm._v(" "),_c('button',{staticClass:"accordion text-uppercase"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/fv/clientes"}},[_vm._v("Clientes")])],1),_vm._v(" "),_c('button',{staticClass:"accordion text-uppercase"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/fv/pedidos"}},[_vm._v("Vendas")])],1),_vm._v(" "),_c('button',{staticClass:"accordion text-uppercase"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/configuracoes"}},[_vm._v("Configurações")])],1),_vm._v(" "),(_vm.appLoja)?_c('button',{staticClass:"accordion text-uppercase"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/loja"}},[_vm._v("Configurações Loja")])],1):_vm._e(),_vm._v(" "),_c('button',{staticClass:"accordion text-uppercase",on:{"click":_vm.handleLogout}},[_c('i',{staticClass:"fa fa-sign-out",staticStyle:{"font-size":"16px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n              Sair\n            ")])]):_vm._e(),_vm._v(" "),(_vm.menu == 'menuvarejopdv')?_c('div',{staticClass:"menu mb-5"},[_c('div',{staticClass:"user-info d-flex justify-content-start align-items-center ml-2 my-3"},[_c('i',{staticClass:"fa fa-user-circle",staticStyle:{"font-size":"40px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column ml-3"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.usuarionome))]),_vm._v(" "),_c('span',{},[_vm._v(_vm._s(_vm.email))])])]),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('button',{staticClass:"accordion text-uppercase"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/fv/produtos"}},[_vm._v("Produtos")])],1),_vm._v(" "),_c('button',{staticClass:"accordion text-uppercase"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/fv/clientes"}},[_vm._v("Clientes")])],1),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('div',{staticClass:"panel",staticStyle:{"max-height":"0"}},[_c('ul',{staticClass:"list-unstyled ml-3"},[_c('li',{staticClass:"py-2 ml-n2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/varejo"}},[_vm._v("Frente de Caixa")])],1),_vm._v(" "),_c('li',{staticClass:"py-2 ml-n2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/varejolist"}},[_vm._v("Vendas Frente de Caixa")])],1),_vm._v(" "),_c('li',{staticClass:"py-2 ml-n2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/varejo/devolucaolist"}},[_vm._v("Devolução de Venda")])],1),_vm._v(" "),_c('li',{staticClass:"py-2 ml-n2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/varejo/controlecaixa"}},[_vm._v("Controle dos Caixas")])],1),_vm._v(" "),_c('li',{staticClass:"py-2 ml-n2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/consultas/varejo-movimento-caixa"}},[_vm._v("Consulta Fechamento de\n                    Caixa")])],1),_vm._v(" "),_c('li',{staticClass:"py-2 ml-n2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/varejo/recebiveis"}},[_vm._v("Consulta Recebiveis")])],1),_vm._v(" "),_c('li',{staticClass:"py-2 ml-n2"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/fpag"}},[_vm._v("Formas de Pagamento")])],1)])]),_vm._v(" "),_c('button',{staticClass:"accordion text-uppercase"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/configuracoes"}},[_vm._v("Configurações")])],1),_vm._v(" "),(_vm.appLoja)?_c('button',{staticClass:"accordion text-uppercase"},[_c('router-link',{staticClass:"menu-link text-dark",attrs:{"to":"/loja"}},[_vm._v("Configurações Loja")])],1):_vm._e(),_vm._v(" "),_c('button',{staticClass:"accordion text-uppercase",on:{"click":_vm.handleLogout}},[_c('i',{staticClass:"fa fa-sign-out",staticStyle:{"font-size":"16px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n              Sair\n            ")])]):_vm._e()])]),_vm._v(" "),_c('span',{staticClass:"hamburger float-right d-none",class:{ active: _vm.viewMobileMenu },on:{"click":_vm.toggleMenu}},[_c('div',{staticClass:"line-menu half start"}),_vm._v(" "),_c('div',{staticClass:"line-menu"}),_vm._v(" "),_c('div',{staticClass:"line-menu half end"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.currVideo)?_c('div',{staticClass:"guia-video",on:{"click":function($event){_vm.currVideo = null}}},[_c('div',{staticClass:"guia-video-content text-center",staticStyle:{"width":"650px"}},[_c('div',{staticClass:"row col justify-content-end"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.currVideo = null}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('iframe',{staticStyle:{"max-width":"800px"},attrs:{"width":"560","height":"315","src":_vm.currVideo,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.notification || _vm.showNotificationHistory)?_c('div',[(_vm.notification)?_c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"def-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Mensagem")])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"max-height":"255px","overflow-y":"auto"}},[_c('div',[_c('span',{staticClass:"card shadow-sm"},[_c('div',{staticClass:"card-header bg-transparent d-flex justify-content-between align-items-center"},[_c('h2',{staticClass:"title"},[_c('span',{staticClass:"mr-3",staticStyle:{"font-size":"18px"}},[_vm._v("\n                          #"+_vm._s(_vm.notification.codnotificacao)+"\n                        ")]),_vm._v("\n                        "+_vm._s(_vm.notification.assunto)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.notification.mensagem)?_c('span',[_vm._v(_vm._s(_vm.notificationMsg))]):_c('span',[_vm._v("Não há mensagem")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"w-100 d-flex justify-content-end my-2"},[_c('small',{staticStyle:{"color":"#2b6292","font-size":"14px","font-weight":"700"}},[_vm._v("Data: "+_vm._s(_vm._f("formatDataHora")(_vm.notification.data)))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(!_vm.backToNotificationHistoryModal ? true : false)?_c('button',{ref:"btnConfirm",staticClass:"btn btn-success btn-sm",attrs:{"type":"button","title":_vm.backToNotificationHistoryModal
                    ? 'Notificação já está marcada como lida'
                    : ''},on:{"click":function($event){return _vm.handleConfirmNotification()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                  Marcar como lida\n                ")]):_vm._e(),_vm._v(" "),_c('button',{ref:"btnClose",staticClass:"btn btn-secondary btn-sm",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.handleCloseNotification()}}},[_vm._v("\n                  Fechar\n                ")])])])])]):_vm._e(),_vm._v(" "),(_vm.showNotificationHistory)?_c('NotificationHistory',{on:{"close":function($event){return _vm.handleCloseNotificationHistory()},"view":function($event){return _vm.handleShowViewNotification($event)},"cancel":function($event){return _vm.handleCancelNotification($event)}}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.configGuide)?_c('ConfigGuia',{on:{"close":_vm.handleConfigModal}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand mt-n2",attrs:{"href":"/"}},[_c('img',{staticStyle:{"height":"30px"},attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo1.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"fa fa-bar-chart",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n            Início\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nb-menu-config",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-question-circle mt-2",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-user-circle nb-menu-config mt-2",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"fa fa-bar-chart",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n            Início\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nb-menu-config",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-question-circle mt-2",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-user-circle nb-menu-config mt-2",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#/"}},[_vm._v("Início")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nb-menu-config",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-user mt-2",staticStyle:{"font-size":"22px"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nb-menu-config",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-question-circle mt-2",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"logo mr-3"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"/"}},[_c('img',{staticStyle:{"height":"30px"},attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo1.png"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"accordion text-uppercase"},[_c('i',{staticClass:"fa fa-home mr-1",staticStyle:{"font-size":"16px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('a',{staticClass:"menu-link text-dark",attrs:{"href":"#/"}},[_vm._v("Início")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"accordion text-uppercase"},[_c('i',{staticClass:"fa fa-plus mr-1",attrs:{"aria-hidden":"true"}}),_vm._v("\n              Cadastros\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"accordion text-uppercase"},[_c('i',{staticClass:"fa fa-plus mr-1",attrs:{"aria-hidden":"true"}}),_vm._v("\n              Movimentos\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"accordion text-uppercase"},[_c('i',{staticClass:"fa fa-cog mr-1",attrs:{"aria-hidden":"true"}}),_vm._v("\n              Configurações\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"accordion text-uppercase"},[_c('i',{staticClass:"fa fa-plus mr-1",attrs:{"aria-hidden":"true"}}),_vm._v("\n              Frente de Caixa\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"accordion text-uppercase"},[_c('a',{staticClass:"menu-link text-dark",attrs:{"href":"#/"}},[_vm._v("Início")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"accordion text-uppercase"},[_c('a',{staticClass:"menu-link text-dark",attrs:{"href":"#/"}},[_vm._v("Início")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"accordion text-uppercase"},[_c('i',{staticClass:"fa fa-plus mr-1",attrs:{"aria-hidden":"true"}}),_vm._v("\n              Frente de Caixa\n            ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_guia_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a5f89e2_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_guia_vue__ = __webpack_require__(1075);
function injectStyle (ssrContext) {
  __webpack_require__(1073)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a5f89e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_guia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a5f89e2_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_guia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1074);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("603ebe08", content, true, {});

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".guia-popover[data-v-9a5f89e2]{position:fixed;top:auto;left:auto;bottom:20px;right:20px;display:inline-flex;align-items:center;z-index:1;flex-direction:row}.guia-popover-content[data-v-9a5f89e2]{width:100%;font:400 15px/20px Source Sans Pro,sans-serif;color:#26292c;background-color:#fff;border-radius:4px;box-shadow:0 0 2px 0 #0000003d,0 8px 10px 1px #0000000d,0 3px 14px 2px #0000000f,0 5px 5px -3px rgba(0,0,0,.1);order:2}.guia-list[data-v-9a5f89e2]{max-height:400px;display:flex;flex-direction:column}.guia-list__content[data-v-9a5f89e2]{overflow-y:auto;flex:1 1 auto;padding:8px 0}.guia-title[data-v-9a5f89e2]{font-size:18px;font-weight:600;color:#2b6292}.box[data-v-9a5f89e2]:hover{background-color:#f7f5f5}.guia-button[data-v-9a5f89e2]{z-index:30;background-color:#fff;border-radius:5px;box-shadow:0 0 0 rgba(0,0,0,.5),0 2px 10px rgba(0,0,0,.2);color:#2b6292;cursor:pointer;display:flex;height:52px;width:52px;justify-content:center;align-items:center;font-size:18px}.close[data-v-9a5f89e2]{font-size:5rem}", ""]);

// exports


/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guia-popover"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.minimizado),expression:"minimizado"}],staticClass:"guia-button",on:{"click":_vm.handleMinimizar}},[_c('i',{staticClass:"float-right fa fa-mortar-board",attrs:{"aria-hidden":"true","title":"Guia de Primeiros Passos","data-toggle":"tooltip","data-placement":"top"}})]),_vm._v(" "),(!_vm.minimizado)?_c('div',[_c('div',{staticClass:"guia-popover-content"},[(!_vm.minimizado)?_c('div',{staticClass:"row mx-auto align-items-center",staticStyle:{"border-bottom":"1px solid gray"}},[_c('div',{staticClass:"col-12 mt-2 mb-2 p-3",staticStyle:{"cursor":"pointer"},on:{"click":_vm.handleMinimizar}},[_c('span',{staticClass:"guia-title"},[_vm._v(" Guia primeiros passos ")]),_vm._v(" "),_c('i',{staticClass:"float-right guia-icon fa",class:{ 'fa-chevron-circle-up': _vm.minimizado, 'fa-chevron-circle-down': !_vm.minimizado },attrs:{"aria-hidden":"true"}})])]):_vm._e(),_vm._v(" "),(!_vm.minimizado)?_c('div',{staticClass:"guia-list"},[_c('div',{staticClass:"guia-list__content"},_vm._l((_vm.guiaList),function(item,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"col-10",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.handleShowVideo(index)}}},[_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(item.title))])])])])])}),0)]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.currVideo)?_c('div',{staticClass:"guia-video",on:{"click":function($event){_vm.currVideo = null}}},[_c('div',{staticClass:"guia-video-content text-center",staticStyle:{"width":"650px"}},[_c('div',{staticClass:"row col justify-content-end"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.handleCloseVideo}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('iframe',{staticStyle:{"max-width":"800px"},attrs:{"width":"560","height":"315","src":_vm.currVideo,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2 text-center"},[_c('i',{staticClass:"fa fa-play"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_md_limite_plano_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b200d6e8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_md_limite_plano_vue__ = __webpack_require__(1079);
function injectStyle (ssrContext) {
  __webpack_require__(1077)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_md_limite_plano_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b200d6e8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_md_limite_plano_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1078);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2ae49e60", content, true, {});

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"def-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(" Limite de Plano Atingido ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.handleCloseButton()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"max-height":"255px","overflow-y":"auto"}},[_c('div',{staticClass:"col-12 mt-3 mb-3"},[_c('span',{},[_vm._v(" O limite do plano foi alcançado para esta funcionalidade! ")])]),_vm._v(" "),(_vm.mensagemAdicioneUsuarios)?_c('div',{staticClass:"col-12 mb-3"},[_c('span',{},[_vm._v(" Acrescente mais usuários ou faça o upgrade de plano para acrescentar mais usuários e mais recursos! ")])]):_c('div',{staticClass:"col-12 mb-3"},[_c('span',{},[_vm._v(" Efetue a agora mesmo o upgrade de plano para acrescentar mais recursos! ")])]),_vm._v(" "),(_vm.mensagem)?_c('div',{staticClass:"col-12 mb-3"},[_c('span',{},[_vm._v(" "+_vm._s(_vm.mensagem)+" ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-sm btn-warning",attrs:{"type":"button"},on:{"click":_vm.handleMinhaConta}},[_vm._v(" Ver Meu Plano ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classContainer,attrs:{"id":"app"}},[(_vm.appLoading)?_c('div',[_c('div',{staticClass:"loading"})]):_vm._e(),_vm._v(" "),(_vm.serverError)?_c('div',{staticClass:"alert-dismissable nb-top-message fade show",attrs:{"role":"alert"}},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert"},on:{"click":function($event){return _vm.handleCloseError()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.message))])]):_vm._e(),_vm._v(" "),(_vm.appLogin)?_c('div',[_c('router-view')],1):_vm._e(),_vm._v(" "),(_vm.appLogged && !_vm.appLogin && _vm.$route.name !== 'contador_empresas')?_c('div',{attrs:{"tabindex":1}},[(_vm.appNFe || _vm.appERP)?_c('div',{staticClass:"d-md-none nb-renova"},[_c('span',[_vm._v("Para uma melhor utilização do sistema e vinculação do certificado\n        digital para o envio de Nota Fiscal utilizar o sistema em\n        computadores.")])]):_vm._e(),_vm._v(" "),((_vm.appTrial || _vm.appFree) && _vm.appERP)?_c('div',{staticClass:"nb-trial"},[_c('span',[_vm._v("Você está utilizando uma conta gratuita!")]),_vm._v(" "),_c('v-button',{staticClass:"ml-3",attrs:{"label":"Assinar Agora!","success":true},on:{"click":_vm.handleRenovar}})],1):_vm._e(),_vm._v(" "),(_vm.appTrial && !_vm.appERP)?_c('div',{staticClass:"nb-trial"},[_c('span',[_vm._v("Seu período de testes expira em\n        "+_vm._s(_vm._f("formatData")(_vm.appDataExpiracao)))]),_vm._v(" "),_c('v-button',{staticClass:"ml-3",attrs:{"label":"Assinar Agora!","success":true},on:{"click":_vm.handleRenovar}})],1):_vm._e(),_vm._v(" "),(_vm.appAvisoRenovacao)?_c('div',{staticClass:"nb-renova"},[_c('span',[_c('strong',[_vm._v("Sua assinatura vence em\n          "+_vm._s(_vm._f("formatData")(_vm.appDataExpiracao))+"! ")]),_vm._v("Clique no botão ao lado caso ainda não tenha renovado.")]),_vm._v(" "),_c('v-button',{staticClass:"ml-3",attrs:{"label":"Renovar","success":true},on:{"click":_vm.handleRenovar}})],1):_vm._e(),_vm._v(" "),(_vm.showAmbienteHomologacao)?_c('div',{staticClass:"nb-homolog"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('bar-top',{on:{"action":_vm.getAction,"logout":_vm.handleLogout}}),_vm._v(" "),(_vm.showAlertCert)?_c('div',{staticClass:"container"},[_c('alert-cert',{attrs:{"certificados":_vm.certificado}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.showApp && !_vm.appLogin)?_c('div',{staticClass:"container",staticStyle:{"padding-top":"20px"},attrs:{"id":"main"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1),_vm._v(" "),_vm._m(1),_vm._v(" "),(_vm.appShowMessage)?_c('md-message',{attrs:{"title":_vm.appTitleMessage,"message":_vm.appMessage,"kind":_vm.appKindMessage},on:{"close":_vm.handleCloseMessage}}):_vm._e(),_vm._v(" "),(false)?_c('md-message',{attrs:{"title":_vm.titleMessage,"message":_vm.message,"kind":_vm.kindMessage},on:{"close":function($event){return _vm.handleCloseError()}}}):_vm._e(),_vm._v(" "),(_vm.showLimitePlano)?_c('md-limite-plano'):_vm._e()],1):_vm._e(),_vm._v(" "),_c('vue-snotify')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-1"},[_c('span',[_vm._v("Atenção! Sistema em ambiente de homologação.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron jumbotron-fluid"},[_c('p',{staticClass:"text-center",staticStyle:{"color":"silver"}},[_vm._v("Nota Brasil 2026")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SnotifyToast = exports.SnotifyStyle = exports.SnotifyPosition = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * vue-snotify v3.2.0
                                                                                                                                                                                                                                                                               * (c) 2018 artemsky <mr.artemsky@gmail.com>
                                                                                                                                                                                                                                                                               * @license MIT
                                                                                                                                                                                                                                                                               */


var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Toast position
 */
var SnotifyPosition;
(function (SnotifyPosition) {
    SnotifyPosition["leftTop"] = "leftTop";
    SnotifyPosition["leftCenter"] = "leftCenter";
    SnotifyPosition["leftBottom"] = "leftBottom";
    SnotifyPosition["rightTop"] = "rightTop";
    SnotifyPosition["rightCenter"] = "rightCenter";
    SnotifyPosition["rightBottom"] = "rightBottom";
    SnotifyPosition["centerTop"] = "centerTop";
    SnotifyPosition["centerCenter"] = "centerCenter";
    SnotifyPosition["centerBottom"] = "centerBottom";
})(SnotifyPosition || (exports.SnotifyPosition = SnotifyPosition = {}));

/**
 * Toast style.
 */
var SnotifyStyle = {
    simple: 'simple',
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'info',
    async: 'async',
    confirm: 'confirm',
    prompt: 'prompt'
};

var script = _vue2.default.extend({
    props: ['toast'],
    data: function data() {
        return {
            isPromptFocused: false
        };
    },
    methods: {
        valueChanged: function valueChanged(e) {
            this.toast.value = e.target.value;
            this.toast.eventEmitter.$emit('input');
        }
    }
});

/* script */

var __vue_script__ = script;

/* template */
var __vue_render__ = function __vue_render__() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('span', { staticClass: "snotifyToast__input", class: { 'snotifyToast__input--filled': _vm.isPromptFocused } }, [_c('input', { staticClass: "snotifyToast__input__field", attrs: { "type": "text", "id": _vm.toast.id }, on: { "input": _vm.valueChanged, "focus": function focus($event) {
                _vm.isPromptFocused = true;
            }, "blur": function blur($event) {
                _vm.isPromptFocused = !!_vm.toast.value.length;
            } } }), _vm._v(" "), _c('label', { staticClass: "snotifyToast__input__label", attrs: { "for": _vm.toast.id } }, [_c('span', { staticClass: "snotifyToast__input__labelContent" }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.toast.config.placeholder)))])])]);
};
var __vue_staticRenderFns__ = [];

/* style */
var __vue_inject_styles__ = undefined;
/* scoped */
var __vue_scope_id__ = undefined;
/* module identifier */
var __vue_module_identifier__ = undefined;
/* functional template */
var __vue_is_functional_template__ = false;
/* component normalizer */
function __vue_normalize__(template, style, script$$1, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
    var component = (typeof script$$1 === 'function' ? script$$1.options : script$$1) || {};

    if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component;
}
/* style inject */
function __vue_create_injector__() {
    var head = document.head || document.getElementsByTagName('head')[0];
    var styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {});
    var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

    return function addStyle(id, css) {
        if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return; // SSR styles are present.

        var group = isOldIE ? css.media || 'default' : id;
        var style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

        if (!style.ids.includes(id)) {
            var code = css.source;
            var index = style.ids.length;

            style.ids.push(id);

            if (true && css.map) {
                // https://developer.chrome.com/devtools/docs/javascript-debugging
                // this makes source maps inside style tags work properly in Chrome
                code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
                // http://stackoverflow.com/a/26603875
                code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
            }

            if (isOldIE) {
                style.element = style.element || document.querySelector('style[data-group=' + group + ']');
            }

            if (!style.element) {
                var el = style.element = document.createElement('style');
                el.type = 'text/css';

                if (css.media) el.setAttribute('media', css.media);
                if (isOldIE) {
                    el.setAttribute('data-group', group);
                    el.setAttribute('data-next-index', '0');
                }

                head.appendChild(el);
            }

            if (isOldIE) {
                index = parseInt(style.element.getAttribute('data-next-index'));
                style.element.setAttribute('data-next-index', index + 1);
            }

            if (style.element.styleSheet) {
                style.parts.push(code);
                style.element.styleSheet.cssText = style.parts.filter(Boolean).join('\n');
            } else {
                var textNode = document.createTextNode(code);
                var nodes = style.element.childNodes;
                if (nodes[index]) style.element.removeChild(nodes[index]);
                if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
            }
        }
    };
}
/* style inject SSR */

var SnotifyPrompt = __vue_normalize__({ render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ }, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, __vue_create_injector__, undefined);

var script$1 = _vue2.default.extend({
    props: ['toast'],
    methods: {
        remove: function remove() {
            this.$snotify.remove(this.toast.id);
        }
    }
});

/* script */

var __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function __vue_render__$1() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "snotifyToast__buttons" }, _vm._l(_vm.toast.config.buttons, function (button) {
        return _c('button', { class: [{ 'snotifyToast__buttons--bold': button.bold }, button.className], attrs: { "type": "button" }, on: { "click": function click($event) {
                    $event.preventDefault();$event.stopPropagation();button.action ? button.action(_vm.toast) : _vm.remove();
                } } }, [_vm._v("\n    " + _vm._s(button.text) + "\n  ")]);
    }));
};
var __vue_staticRenderFns__$1 = [];

/* style */
var __vue_inject_styles__$1 = undefined;
/* scoped */
var __vue_scope_id__$1 = undefined;
/* module identifier */
var __vue_module_identifier__$1 = undefined;
/* functional template */
var __vue_is_functional_template__$1 = false;
/* component normalizer */
function __vue_normalize__$1(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
    var component = (typeof script === 'function' ? script.options : script) || {};

    if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component;
}
/* style inject */
function __vue_create_injector__$1() {
    var head = document.head || document.getElementsByTagName('head')[0];
    var styles = __vue_create_injector__$1.styles || (__vue_create_injector__$1.styles = {});
    var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

    return function addStyle(id, css) {
        if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return; // SSR styles are present.

        var group = isOldIE ? css.media || 'default' : id;
        var style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

        if (!style.ids.includes(id)) {
            var code = css.source;
            var index = style.ids.length;

            style.ids.push(id);

            if (true && css.map) {
                // https://developer.chrome.com/devtools/docs/javascript-debugging
                // this makes source maps inside style tags work properly in Chrome
                code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
                // http://stackoverflow.com/a/26603875
                code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
            }

            if (isOldIE) {
                style.element = style.element || document.querySelector('style[data-group=' + group + ']');
            }

            if (!style.element) {
                var el = style.element = document.createElement('style');
                el.type = 'text/css';

                if (css.media) el.setAttribute('media', css.media);
                if (isOldIE) {
                    el.setAttribute('data-group', group);
                    el.setAttribute('data-next-index', '0');
                }

                head.appendChild(el);
            }

            if (isOldIE) {
                index = parseInt(style.element.getAttribute('data-next-index'));
                style.element.setAttribute('data-next-index', index + 1);
            }

            if (style.element.styleSheet) {
                style.parts.push(code);
                style.element.styleSheet.cssText = style.parts.filter(Boolean).join('\n');
            } else {
                var textNode = document.createTextNode(code);
                var nodes = style.element.childNodes;
                if (nodes[index]) style.element.removeChild(nodes[index]);
                if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
            }
        }
    };
}
/* style inject SSR */

var SnotifyButton = __vue_normalize__$1({ render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 }, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, __vue_create_injector__$1, undefined);

var script$2 = _vue2.default.extend({
    props: ['toastData'],
    components: {
        SnotifyPrompt: SnotifyPrompt,
        SnotifyButton: SnotifyButton
    },
    data: function data() {
        return {
            toast: this.toastData,
            animationFrame: null,
            state: {
                paused: false,
                progress: 0,
                animation: '',
                isDestroying: false,
                promptType: SnotifyStyle.prompt
            }
        };
    },
    methods: {
        /**
         * Initialize base toast config
         */
        initToast: function initToast() {
            if (this.toast.config.timeout > 0) {
                this.startTimeout(0);
            }
        },
        onClick: function onClick() {
            this.toast.eventEmitter.$emit('click');
            if (this.toast.config.closeOnClick) {
                this.$snotify.remove(this.toast.id);
            }
        },
        onMouseEnter: function onMouseEnter() {
            this.toast.eventEmitter.$emit('mouseenter');
            if (this.toast.config.pauseOnHover) {
                this.state.paused = true;
            }
        },
        onMouseLeave: function onMouseLeave() {
            if (this.toast.config.pauseOnHover && this.toast.config.timeout) {
                this.state.paused = false;
                this.startTimeout(this.toast.config.timeout * this.state.progress);
            }
            this.toast.eventEmitter.$emit('mouseleave');
        },
        /**
         * Remove toast completely after animation
         */
        onExitTransitionEnd: function onExitTransitionEnd() {
            if (this.state.isDestroying) {
                return;
            }
            this.initToast();
            this.toast.eventEmitter.$emit('shown');
        },
        /**
         * Start progress bar
         * @param startTime {number}
         * @default 0
         */
        startTimeout: function startTimeout(startTime) {
            var _this = this;
            if (startTime === void 0) {
                startTime = 0;
            }
            var start = performance.now();
            var calculate = function calculate() {
                _this.animationFrame = requestAnimationFrame(function (timestamp) {
                    var runtime = timestamp + startTime - start;
                    var progress = Math.min(runtime / _this.toast.config.timeout, 1);
                    if (_this.state.paused) {
                        cancelAnimationFrame(_this.animationFrame);
                    } else if (runtime < _this.toast.config.timeout) {
                        _this.state.progress = progress;
                        calculate();
                    } else {
                        _this.state.progress = 1;
                        cancelAnimationFrame(_this.animationFrame);
                        _this.$snotify.emitter.$emit('remove', _this.toast.id);
                    }
                });
            };
            calculate();
        },
        /**
         * Trigger beforeDestroy lifecycle. Removes toast
         */
        onRemove: function onRemove() {
            var _this = this;
            this.state.isDestroying = true;
            this.$emit('stateChanged', 'beforeHide');
            this.toast.eventEmitter.$emit('beforeHide');
            this.state.animation = this.toast.config.animation.exit;
            setTimeout(function () {
                _this.$emit('stateChanged', 'hidden');
                _this.state.animation = 'snotifyToast--out';
                _this.toast.eventEmitter.$emit('hidden');
                setTimeout(function () {
                    return _this.$snotify.remove(_this.toast.id, true);
                }, _this.toast.config.animation.time / 2);
            }, this.toast.config.animation.time / 2);
        }
    },
    created: function created() {
        var _this = this;
        this.$snotify.emitter.$on('toastChanged', function (toast) {
            if (_this.toast.id === toast.id) {
                _this.initToast();
            }
        });
        this.$snotify.emitter.$on('remove', function (id) {
            if (_this.toast.id === id) {
                _this.onRemove();
            }
        });
    },
    mounted: function mounted() {
        var _this = this;
        this.$nextTick(function () {
            _this.toast.eventEmitter.$emit('mounted');
            _this.state.animation = 'snotifyToast--in';
            _this.$nextTick(function () {
                setTimeout(function () {
                    _this.$emit('stateChanged', 'beforeShow');
                    _this.toast.eventEmitter.$emit('beforeShow');
                    _this.state.animation = _this.toast.config.animation.enter;
                }, _this.toast.config.animation.time / 5); // time to show toast push animation (snotifyToast--in)
            });
        });
    },
    destroyed: function destroyed() {
        cancelAnimationFrame(this.animationFrame);
        this.toast.eventEmitter.$emit('destroyed');
    }
});

/* script */

var __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function __vue_render__$2() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "snotifyToast animated", class: ['snotify-' + _vm.toast.config.type, _vm.state.animation, _vm.toast.valid === undefined ? '' : _vm.toast.valid ? 'snotifyToast--valid' : 'snotifyToast--invalid'], style: {
            '-webkit-animation-duration': _vm.toast.config.animation.time + 'ms',
            'animation-duration': _vm.toast.config.animation.time + 'ms',
            '-webkit-transition': _vm.toast.config.animation.time + 'ms',
            transition: _vm.toast.config.animation.time + 'ms'
        }, on: { "click": _vm.onClick, "mouseenter": _vm.onMouseEnter, "mouseleave": _vm.onMouseLeave, "animationend": _vm.onExitTransitionEnd } }, [_vm.toast.config.showProgressBar && _vm.toast.config.timeout > 0 ? _c('div', { staticClass: "snotifyToast__progressBar" }, [_c('span', { staticClass: "snotifyToast__progressBar__percentage", style: { 'width': _vm.state.progress * 100 + '%' } })]) : _vm._e(), _vm._v(" "), !_vm.toast.config.html ? _c('div', { staticClass: "snotifyToast__inner", class: { 'snotifyToast__noIcon': _vm.toast.config.icon === false } }, [_vm.toast.title ? _c('div', { staticClass: "snotifyToast__title" }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.toast.title, _vm.toast.config.titleMaxLength)))]) : _vm._e(), _vm._v(" "), _vm.toast.body ? _c('div', { staticClass: "snotifyToast__body" }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.toast.body, _vm.toast.config.bodyMaxLength)))]) : _vm._e(), _vm._v(" "), _vm.toast.config.type === _vm.state.promptType ? _c('snotify-prompt', { attrs: { "toast": _vm.toast } }) : _vm._e(), _vm._v(" "), typeof _vm.toast.config.icon === 'undefined' ? _c('div', { class: ['snotify-icon', 'snotify-icon--' + _vm.toast.config.type] }) : _vm.toast.config.icon !== false ? _c('div', [_c('img', { staticClass: "snotify-icon", attrs: { "src": _vm.toast.config.icon } })]) : _vm._e()], 1) : _c('div', { staticClass: "snotifyToast__inner", domProps: { "innerHTML": _vm._s(_vm.toast.config.html) } }), _vm._v(" "), _vm.toast.config.buttons ? _c('snotify-button', { attrs: { "toast": _vm.toast } }) : _vm._e()], 1);
};
var __vue_staticRenderFns__$2 = [];

/* style */
var __vue_inject_styles__$2 = undefined;
/* scoped */
var __vue_scope_id__$2 = undefined;
/* module identifier */
var __vue_module_identifier__$2 = undefined;
/* functional template */
var __vue_is_functional_template__$2 = false;
/* component normalizer */
function __vue_normalize__$2(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
    var component = (typeof script === 'function' ? script.options : script) || {};

    if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component;
}
/* style inject */
function __vue_create_injector__$2() {
    var head = document.head || document.getElementsByTagName('head')[0];
    var styles = __vue_create_injector__$2.styles || (__vue_create_injector__$2.styles = {});
    var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

    return function addStyle(id, css) {
        if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return; // SSR styles are present.

        var group = isOldIE ? css.media || 'default' : id;
        var style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

        if (!style.ids.includes(id)) {
            var code = css.source;
            var index = style.ids.length;

            style.ids.push(id);

            if (true && css.map) {
                // https://developer.chrome.com/devtools/docs/javascript-debugging
                // this makes source maps inside style tags work properly in Chrome
                code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
                // http://stackoverflow.com/a/26603875
                code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
            }

            if (isOldIE) {
                style.element = style.element || document.querySelector('style[data-group=' + group + ']');
            }

            if (!style.element) {
                var el = style.element = document.createElement('style');
                el.type = 'text/css';

                if (css.media) el.setAttribute('media', css.media);
                if (isOldIE) {
                    el.setAttribute('data-group', group);
                    el.setAttribute('data-next-index', '0');
                }

                head.appendChild(el);
            }

            if (isOldIE) {
                index = parseInt(style.element.getAttribute('data-next-index'));
                style.element.setAttribute('data-next-index', index + 1);
            }

            if (style.element.styleSheet) {
                style.parts.push(code);
                style.element.styleSheet.cssText = style.parts.filter(Boolean).join('\n');
            } else {
                var textNode = document.createTextNode(code);
                var nodes = style.element.childNodes;
                if (nodes[index]) style.element.removeChild(nodes[index]);
                if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
            }
        }
    };
}
/* style inject SSR */

var Toast = __vue_normalize__$2({ render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 }, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, __vue_create_injector__$2, undefined);

var script$3 = _vue2.default.extend({
    components: {
        Toast: Toast
    },
    data: function data() {
        return {
            /**
             * Toasts array
             */
            notifications: {
                left_top: [],
                left_center: [],
                left_bottom: [],
                right_top: [],
                right_center: [],
                right_bottom: [],
                center_top: [],
                center_center: [],
                center_bottom: []
            },
            /**
             * Helper for slice pipe (maxOnScreen)
             */
            dockSize_a: 0,
            /**
             * Helper for slice pipe (maxOnScreen)
             */
            dockSize_b: 0,
            /**
             * Helper for slice pipe (maxAtPosition)
             */
            blockSize_a: 0,
            /**
             * Helper for slice pipe (maxAtPosition)
             */
            blockSize_b: 0,
            /**
             * Backdrop Opacity
             */
            backdrop: -1,
            /**
             * How many toasts with backdrop in current queue
             */
            withBackdrop: []
        };
    },
    methods: {
        setOptions: function setOptions(toasts) {
            if (this.$snotify.config.global.newOnTop) {
                this.dockSize_a = -this.$snotify.config.global.maxOnScreen;
                this.dockSize_b = undefined;
                this.blockSize_a = -this.$snotify.config.global.maxAtPosition;
                this.blockSize_b = undefined;
                this.withBackdrop = toasts.filter(function (toast) {
                    return toast.config.backdrop >= 0;
                });
            } else {
                this.dockSize_a = 0;
                this.dockSize_b = this.$snotify.config.global.maxOnScreen;
                this.blockSize_a = 0;
                this.blockSize_b = this.$snotify.config.global.maxAtPosition;
                this.withBackdrop = toasts.filter(function (toast) {
                    return toast.config.backdrop >= 0;
                }).reverse();
            }
            this.notifications = this.splitToasts(toasts.slice(this.dockSize_a, this.dockSize_b));
            this.stateChanged('mounted');
        },
        // TODO: fix backdrop if more than one toast called in a row
        /**
         * Changes the backdrop opacity
         * @param {SnotifyEvent} event
         */
        stateChanged: function stateChanged(event) {
            if (!this.withBackdrop.length) {
                return;
            }
            switch (event) {
                case 'mounted':
                    if (this.backdrop < 0) {
                        this.backdrop = 0;
                    }
                    break;
                case 'beforeShow':
                    this.backdrop = this.withBackdrop[this.withBackdrop.length - 1].config.backdrop;
                    break;
                case 'beforeHide':
                    if (this.withBackdrop.length === 1) {
                        this.backdrop = 0;
                    }
                    break;
                case 'hidden':
                    if (this.withBackdrop.length === 1) {
                        this.backdrop = -1;
                    }
                    break;
            }
        },
        /**
         * Split toasts toasts into different objects
         * @param {SnotifyToast[]} toasts
         * @returns {SnotifyNotifications}
         */
        splitToasts: function splitToasts(toasts) {
            var result = {};
            for (var property in SnotifyPosition) {
                if (SnotifyPosition.hasOwnProperty(property)) {
                    result[SnotifyPosition[property]] = [];
                }
            }
            toasts.forEach(function (toast) {
                result[toast.config.position].push(toast);
            });
            return result;
        }
    },
    created: function created() {
        var _this = this;
        this.$snotify.emitter.$on('snotify', function (toasts) {
            _this.setOptions(toasts);
        });
    }
});

/* script */

var __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function __vue_render__$3() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', [_vm.backdrop >= 0 ? _c('div', { staticClass: "snotify-backdrop", style: { opacity: _vm.backdrop } }) : _vm._e(), _vm._v(" "), _vm._l(_vm.notifications, function (position, index) {
        return _c('div', { staticClass: "snotify", class: 'snotify-' + index }, _vm._l(_vm.notifications[index].slice(_vm.blockSize_a, _vm.blockSize_b), function (toast) {
            return _c('toast', { key: toast.id, attrs: { "toastData": toast }, on: { "stateChanged": _vm.stateChanged } });
        }));
    })], 2);
};
var __vue_staticRenderFns__$3 = [];

/* style */
var __vue_inject_styles__$3 = undefined;
/* scoped */
var __vue_scope_id__$3 = undefined;
/* module identifier */
var __vue_module_identifier__$3 = undefined;
/* functional template */
var __vue_is_functional_template__$3 = false;
/* component normalizer */
function __vue_normalize__$3(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
    var component = (typeof script === 'function' ? script.options : script) || {};

    if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component;
}
/* style inject */
function __vue_create_injector__$3() {
    var head = document.head || document.getElementsByTagName('head')[0];
    var styles = __vue_create_injector__$3.styles || (__vue_create_injector__$3.styles = {});
    var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

    return function addStyle(id, css) {
        if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return; // SSR styles are present.

        var group = isOldIE ? css.media || 'default' : id;
        var style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

        if (!style.ids.includes(id)) {
            var code = css.source;
            var index = style.ids.length;

            style.ids.push(id);

            if (true && css.map) {
                // https://developer.chrome.com/devtools/docs/javascript-debugging
                // this makes source maps inside style tags work properly in Chrome
                code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
                // http://stackoverflow.com/a/26603875
                code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
            }

            if (isOldIE) {
                style.element = style.element || document.querySelector('style[data-group=' + group + ']');
            }

            if (!style.element) {
                var el = style.element = document.createElement('style');
                el.type = 'text/css';

                if (css.media) el.setAttribute('media', css.media);
                if (isOldIE) {
                    el.setAttribute('data-group', group);
                    el.setAttribute('data-next-index', '0');
                }

                head.appendChild(el);
            }

            if (isOldIE) {
                index = parseInt(style.element.getAttribute('data-next-index'));
                style.element.setAttribute('data-next-index', index + 1);
            }

            if (style.element.styleSheet) {
                style.parts.push(code);
                style.element.styleSheet.cssText = style.parts.filter(Boolean).join('\n');
            } else {
                var textNode = document.createTextNode(code);
                var nodes = style.element.childNodes;
                if (nodes[index]) style.element.removeChild(nodes[index]);
                if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
            }
        }
    };
}
/* style inject SSR */

var Snotify = __vue_normalize__$3({ render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 }, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, __vue_create_injector__$3, undefined);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};

function __decorate(decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

/**
 * Toast model
 */
var SnotifyToast = /** @class */function () {
    /**
     *
     * @param {number|string} id
     * @param {string} title
     * @param {string} body
     * @param {SnotifyToastConfig} [config]
     */
    function SnotifyToast(id, title, body, config) {
        var _this = this;
        this.id = id;
        this.title = title;
        this.body = body;
        this.config = config;
        /**
         * Emits {SnotifyEvent}
         * @type {Vue}
         */
        this.eventEmitter = new _vue2.default();
        /**
         * Holds all subscribers because we need to unsubscribe from all before toast get destroyed
         * @type {Vue[]}
         * @private
         */
        this._eventsHolder = [];
        /**
         * Toast validator
         */
        this.valid = undefined;
        if (this.config.type === SnotifyStyle.prompt) {
            this.value = '';
        }
        this.on('hidden', function () {
            _this._eventsHolder.forEach(function (o) {
                _this.eventEmitter.$off(o.event, o.action);
            });
        });
    }
    /**
     * This callback is displayed as a global member.
     * @callback action
     * @param {toast} responseCode
     * @returns {void}
     */
    /**
     * Subscribe to toast events
     * @param {String<SnotifyEvent>} event
     * @param  {SnotifyToast~action} action
     * @returns {SnotifyToast}
     */
    SnotifyToast.prototype.on = function (event, action) {
        var _this = this;
        this._eventsHolder.push({ event: event, action: action });
        this.eventEmitter.$on(event, function () {
            return action(_this);
        });
        return this;
    };
    return SnotifyToast;
}();

/**
 * Snotify default configuration object
 * @type {SnotifyDefaults}
 */
var ToastDefaults = {
    global: {
        newOnTop: true,
        maxOnScreen: 8,
        maxAtPosition: 8,
        oneAtTime: false,
        preventDuplicates: false
    },
    toast: {
        type: SnotifyStyle.simple,
        showProgressBar: true,
        timeout: 2000,
        closeOnClick: true,
        pauseOnHover: true,
        bodyMaxLength: 150,
        titleMaxLength: 16,
        backdrop: -1,
        icon: undefined,
        html: null,
        position: SnotifyPosition.rightBottom,
        animation: { enter: 'fadeIn', exit: 'fadeOut', time: 400 }
    },
    type: (_a = {}, _a[SnotifyStyle.prompt] = {
        timeout: 0,
        closeOnClick: false,
        buttons: [{ text: 'Ok', action: null, bold: true }, { text: 'Cancel', action: null, bold: false }],
        placeholder: 'Enter answer here...',
        type: SnotifyStyle.prompt
    }, _a[SnotifyStyle.confirm] = {
        timeout: 0,
        closeOnClick: false,
        buttons: [{ text: 'Ok', action: null, bold: true }, { text: 'Cancel', action: null, bold: false }],
        type: SnotifyStyle.confirm
    }, _a[SnotifyStyle.simple] = {
        type: SnotifyStyle.simple
    }, _a[SnotifyStyle.success] = {
        type: SnotifyStyle.success
    }, _a[SnotifyStyle.error] = {
        type: SnotifyStyle.error
    }, _a[SnotifyStyle.warning] = {
        type: SnotifyStyle.warning
    }, _a[SnotifyStyle.info] = {
        type: SnotifyStyle.info
    }, _a[SnotifyStyle.async] = {
        pauseOnHover: false,
        closeOnClick: false,
        timeout: 0,
        showProgressBar: false,
        type: SnotifyStyle.async
    }, _a)
};
var _a;

/**
 * Transform arguments to Snotify object
 * @param target
 * @param {SnotifyType} propertyKey
 * @param {PropertyDescriptor} descriptor
 * @returns {Snotify}
 * @constructor
 */
function TransformArgument(target, propertyKey, descriptor) {
    if (propertyKey === SnotifyStyle.async) {
        return {
            value: function value() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var result;
                if (args.length === 2) {
                    result = {
                        title: null,
                        body: args[0],
                        config: null,
                        action: args[1]
                    };
                } else if (args.length === 3) {
                    if (typeof args[1] === 'string') {
                        result = {
                            title: args[1],
                            body: args[0],
                            config: null,
                            action: args[2]
                        };
                    } else {
                        result = {
                            title: null,
                            body: args[0],
                            config: args[2],
                            action: args[1]
                        };
                    }
                } else {
                    result = {
                        title: args[1],
                        body: args[0],
                        config: args[3],
                        action: args[2]
                    };
                }
                return descriptor.value.apply(this, [result]);
            }
        };
    } else {
        return {
            value: function value() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var result;
                if (args.length === 1) {
                    result = {
                        title: null,
                        body: args[0],
                        config: null
                    };
                } else if (args.length === 3) {
                    result = {
                        title: args[1],
                        body: args[0],
                        config: args[2]
                    };
                } else {
                    result = (_a = {
                        title: null,
                        config: null,
                        body: args[0]
                    }, _a[typeof args[1] === 'string' ? 'title' : 'config'] = args[1], _a);
                }
                return descriptor.value.apply(this, [result]);
                var _a;
            }
        };
    }
}

/**
 * Generates random id
 * @return {number}
 */
function uuid() {
    return Math.floor(Math.random() * (Date.now() - 1)) + 1;
}
/**
 * Simple is object check.
 * @param item {Object<any>}
 * @returns {boolean}
 */
function isObject(item) {
    return item && (typeof item === "undefined" ? "undefined" : _typeof(item)) === 'object' && !Array.isArray(item) && item !== null;
}
/**
 * Deep merge objects.
 * @param sources {Array<Object<any>>}
 * @returns {Object<any>}
 */
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var target = {};
    if (!sources.length) {
        return target;
    }
    while (sources.length > 0) {
        var source = sources.shift();
        if (isObject(source)) {
            for (var key in source) {
                if (isObject(source[key])) {
                    target[key] = mergeDeep(target[key], source[key]);
                } else {
                    Object.assign(target, (_a = {}, _a[key] = source[key], _a));
                }
            }
        }
    }
    return target;
    var _a;
}

/**
 * Defines toast style depending on method name
 * @param target
 * @param {SnotifyType} propertyKey
 * @param {PropertyDescriptor} descriptor
 * @returns {{value: ((...args: any[]) => any)}}
 * @constructor
 */
function SetToastType(target, propertyKey, descriptor) {
    return {
        value: function value() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            args[0].config = __assign({}, args[0].config, { type: propertyKey });
            return descriptor.value.apply(this, args);
        }
    };
}

/**
 * this - create, remove, config toasts
 */
// tslint:disable:unified-signatures
var SnotifyService = /** @class */function () {
    function SnotifyService() {
        this.emitter = new _vue2.default();
        this.notifications = [];
        this.config = ToastDefaults;
    }
    /**
     * emit changes in notifications array
     */
    SnotifyService.prototype.emit = function () {
        this.emitter.$emit('snotify', this.notifications.slice());
    };
    /**
     * returns SnotifyToast object
     * @param id {Number}
     * @return {SnotifyToast|undefined}
     */
    SnotifyService.prototype.get = function (id) {
        return this.notifications.find(function (toast) {
            return toast.id === id;
        });
    };
    /**
     * add SnotifyToast to notifications array
     * @param toast {SnotifyToast}
     */
    SnotifyService.prototype.add = function (toast) {
        if (this.config.global.newOnTop) {
            this.notifications.unshift(toast);
        } else {
            this.notifications.push(toast);
        }
        this.emit();
    };
    /**
     * If ID passed, emits toast animation remove, if ID & REMOVE passed, removes toast from notifications array
     * @param id {number}
     * @param remove {boolean}
     */
    SnotifyService.prototype.remove = function (id, remove) {
        if (!id) {
            return this.clear();
        } else if (remove) {
            this.notifications = this.notifications.filter(function (toast) {
                return toast.id !== id;
            });
            return this.emit();
        }
        this.emitter.$emit('remove', id);
    };
    /**
     * Clear notifications array
     */
    SnotifyService.prototype.clear = function () {
        this.notifications = [];
        this.emit();
    };
    SnotifyService.prototype.button = function (text, closeOnClick, action, bold) {
        var _this = this;
        if (closeOnClick === void 0) {
            closeOnClick = true;
        }
        if (action === void 0) {
            action = null;
        }
        if (bold === void 0) {
            bold = false;
        }
        return {
            text: text,
            action: closeOnClick ? function (toast) {
                action(toast);
                _this.remove(toast.id);
            } : action,
            bold: bold
        };
    };
    /**
     * Creates toast and add it to array, returns toast id
     * @param snotify {Snotify}
     * @return {number}
     */
    SnotifyService.prototype.create = function (snotify) {
        if (this.config.global.oneAtTime && this.notifications.length !== 0) return;
        if (this.config.global.preventDuplicates && this.notifications.filter(function (t) {
            return t.config.type === snotify.config.type;
        }).length === 1) return;
        var config = mergeDeep(this.config.toast, this.config.type[snotify.config.type], snotify.config);
        var toast = new SnotifyToast(config.id ? config.id : uuid(), snotify.title, snotify.body, config);
        this.add(toast);
        return toast;
    };
    SnotifyService.prototype.setDefaults = function (defaults) {
        return this.config = mergeDeep(this.config, defaults);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.simple = function (args) {
        return this.create(args);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.success = function (args) {
        return this.create(args);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.error = function (args) {
        return this.create(args);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.info = function (args) {
        return this.create(args);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.warning = function (args) {
        return this.create(args);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.confirm = function (args) {
        return this.create(args);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.prompt = function (args) {
        return this.create(args);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.async = function (args) {
        var _this = this;
        var async = args.action;
        var toast = this.create(args);
        toast.on('mounted', function () {
            async().then(function (next) {
                return _this.mergeToast(toast, next, SnotifyStyle.success);
            }).catch(function (error) {
                return _this.mergeToast(toast, error, SnotifyStyle.error);
            });
        });
        return toast;
    };
    SnotifyService.prototype.mergeToast = function (toast, next, type) {
        if (next.body) {
            toast.body = next.body;
        }
        if (next.title) {
            toast.title = next.title;
        }
        if (type) {
            toast.config = mergeDeep(toast.config, this.config.global, this.config.toast[type], { type: type }, next.config);
        } else {
            toast.config = mergeDeep(toast.config, next.config);
        }
        if (next.html) {
            toast.config.html = next.html;
        }
        this.emit();
        this.emitter.$emit('toastChanged', toast);
    };
    /**
     * Creates empty toast with html string inside
     * @param {string} html
     * @param {SnotifyToastConfig} config
     * @returns {number}
     */
    SnotifyService.prototype.html = function (html, config) {
        return this.create({
            title: null,
            body: null,
            config: __assign({}, config, { html: html })
        });
    };
    __decorate([TransformArgument
    /**
     * Determines current toast type and collects default configuration
     */

    , SetToastType, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", SnotifyToast)], SnotifyService.prototype, "simple", null);
    __decorate([TransformArgument
    /**
     * Determines current toast type and collects default configuration
     */

    , SetToastType, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", SnotifyToast)], SnotifyService.prototype, "success", null);
    __decorate([TransformArgument
    /**
     * Determines current toast type and collects default configuration
     */

    , SetToastType, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", SnotifyToast)], SnotifyService.prototype, "error", null);
    __decorate([TransformArgument
    /**
     * Determines current toast type and collects default configuration
     */

    , SetToastType, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", SnotifyToast)], SnotifyService.prototype, "info", null);
    __decorate([TransformArgument
    /**
     * Determines current toast type and collects default configuration
     */

    , SetToastType, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", SnotifyToast)], SnotifyService.prototype, "warning", null);
    __decorate([TransformArgument
    /**
     * Determines current toast type and collects default configuration
     */

    , SetToastType, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", SnotifyToast)], SnotifyService.prototype, "confirm", null);
    __decorate([TransformArgument
    /**
     * Determines current toast type and collects default configuration
     */

    , SetToastType, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", SnotifyToast)], SnotifyService.prototype, "prompt", null);
    __decorate([TransformArgument
    /**
     * Determines current toast type and collects default configuration
     */

    , SetToastType, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", SnotifyToast)], SnotifyService.prototype, "async", null);
    return SnotifyService;
}();

var Plugin = {
    install: function install(Vue$$1, options) {
        if (options === void 0) {
            options = {};
        }
        Vue$$1.filter('truncate', function (value, limit, trail) {
            if (limit === void 0) {
                limit = 40;
            }
            if (trail === void 0) {
                trail = '...';
            }
            return value.length > limit ? value.substring(0, limit) + trail : value;
        });
        var service = new SnotifyService();
        service.setDefaults(options);
        Vue$$1.prototype.$snotify = service;
        Vue$$1.component('vue-snotify', Snotify);
        // auto install
        if (typeof window !== 'undefined' && window.hasOwnProperty('Vue')) {
            window.Snotify = service;
        }
    }
};
// auto install
if (typeof window !== 'undefined' && window.hasOwnProperty('Vue')) {
    window.Vue.use(Plugin.install);
}

exports.SnotifyPosition = SnotifyPosition;
exports.SnotifyStyle = SnotifyStyle;
exports.SnotifyToast = SnotifyToast;
exports.default = Plugin;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function _update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref3) {
    var name = _ref3.name,
        enabled = _ref3.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function _destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function _enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function _disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref4) {
    var name = _ref4.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets2 = data.offsets,
      popper = _data$offsets2.popper,
      reference = _data$offsets2.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, _defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), _defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets3 = data.offsets,
      popper = _data$offsets3.popper,
      reference = _data$offsets3.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref5) {
  var offset = _ref5.offset;
  var placement = data.placement,
      _data$offsets4 = data.offsets,
      popper = _data$offsets4.popper,
      reference = _data$offsets4.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return _defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return _defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets5 = data.offsets,
        reference = _data$offsets5.reference,
        popper = _data$offsets5.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: _defineProperty({}, side, reference[side]),
      end: _defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets6 = data.offsets,
      popper = _data$offsets6.popper,
      reference = _data$offsets6.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods

var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  _createClass(Popper, [{
    key: 'update',
    value: function update() {
      return _update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      return _destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners() {
      return _enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners() {
      return _disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */

    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);

  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */

Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

exports.default = Popper;
//# sourceMappingURL=popper.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! Select2 4.0.13 | https://github.com/select2/select2/blob/master/LICENSE.md */
!function (n) {
   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(56)], __WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = function (e, t) {
    return void 0 === t && (t = "undefined" != typeof window ? require("jquery") : require("jquery")(e)), n(t), t;
  } : n(jQuery);
}(function (u) {
  var e = function () {
    if (u && u.fn && u.fn.select2 && u.fn.select2.amd) var e = u.fn.select2.amd;var t, n, r, h, o, _s, f, g, m, v, y, _, i, a, b;function w(e, t) {
      return i.call(e, t);
    }function l(e, t) {
      var n,
          r,
          i,
          o,
          s,
          a,
          l,
          c,
          u,
          d,
          p,
          h = t && t.split("/"),
          f = y.map,
          g = f && f["*"] || {};if (e) {
        for (s = (e = e.split("/")).length - 1, y.nodeIdCompat && b.test(e[s]) && (e[s] = e[s].replace(b, "")), "." === e[0].charAt(0) && h && (e = h.slice(0, h.length - 1).concat(e)), u = 0; u < e.length; u++) {
          if ("." === (p = e[u])) e.splice(u, 1), --u;else if (".." === p) {
            if (0 === u || 1 === u && ".." === e[2] || ".." === e[u - 1]) continue;0 < u && (e.splice(u - 1, 2), u -= 2);
          }
        }e = e.join("/");
      }if ((h || g) && f) {
        for (u = (n = e.split("/")).length; 0 < u; --u) {
          if (r = n.slice(0, u).join("/"), h) for (d = h.length; 0 < d; --d) {
            if (i = (i = f[h.slice(0, d).join("/")]) && i[r]) {
              o = i, a = u;break;
            }
          }if (o) break;!l && g && g[r] && (l = g[r], c = u);
        }!o && l && (o = l, a = c), o && (n.splice(0, a, o), e = n.join("/"));
      }return e;
    }function A(t, n) {
      return function () {
        var e = a.call(arguments, 0);return "string" != typeof e[0] && 1 === e.length && e.push(null), _s.apply(h, e.concat([t, n]));
      };
    }function x(t) {
      return function (e) {
        m[t] = e;
      };
    }function D(e) {
      if (w(v, e)) {
        var t = v[e];delete v[e], _[e] = !0, o.apply(h, t);
      }if (!w(m, e) && !w(_, e)) throw new Error("No " + e);return m[e];
    }function c(e) {
      var t,
          n = e ? e.indexOf("!") : -1;return -1 < n && (t = e.substring(0, n), e = e.substring(n + 1, e.length)), [t, e];
    }function S(e) {
      return e ? c(e) : [];
    }return e && e.requirejs || (e ? n = e : e = {}, m = {}, v = {}, y = {}, _ = {}, i = Object.prototype.hasOwnProperty, a = [].slice, b = /\.js$/, f = function f(e, t) {
      var n,
          r,
          i = c(e),
          o = i[0],
          s = t[1];return e = i[1], o && (n = D(o = l(o, s))), o ? e = n && n.normalize ? n.normalize(e, (r = s, function (e) {
        return l(e, r);
      })) : l(e, s) : (o = (i = c(e = l(e, s)))[0], e = i[1], o && (n = D(o))), { f: o ? o + "!" + e : e, n: e, pr: o, p: n };
    }, g = { require: function require(e) {
        return A(e);
      }, exports: function exports(e) {
        var t = m[e];return void 0 !== t ? t : m[e] = {};
      }, module: function module(e) {
        return { id: e, uri: "", exports: m[e], config: (t = e, function () {
            return y && y.config && y.config[t] || {};
          }) };var t;
      } }, o = function o(e, t, n, r) {
      var i,
          o,
          s,
          a,
          l,
          c,
          u,
          d = [],
          p = typeof n === "undefined" ? "undefined" : _typeof(n);if (c = S(r = r || e), "undefined" == p || "function" == p) {
        for (t = !t.length && n.length ? ["require", "exports", "module"] : t, l = 0; l < t.length; l += 1) {
          if ("require" === (o = (a = f(t[l], c)).f)) d[l] = g.require(e);else if ("exports" === o) d[l] = g.exports(e), u = !0;else if ("module" === o) i = d[l] = g.module(e);else if (w(m, o) || w(v, o) || w(_, o)) d[l] = D(o);else {
            if (!a.p) throw new Error(e + " missing " + o);a.p.load(a.n, A(r, !0), x(o), {}), d[l] = m[o];
          }
        }s = n ? n.apply(m[e], d) : void 0, e && (i && i.exports !== h && i.exports !== m[e] ? m[e] = i.exports : s === h && u || (m[e] = s));
      } else e && (m[e] = n);
    }, t = n = _s = function s(e, t, n, r, i) {
      if ("string" == typeof e) return g[e] ? g[e](t) : D(f(e, S(t)).f);if (!e.splice) {
        if ((y = e).deps && _s(y.deps, y.callback), !t) return;t.splice ? (e = t, t = n, n = null) : e = h;
      }return t = t || function () {}, "function" == typeof n && (n = r, r = i), r ? o(h, e, t, n) : setTimeout(function () {
        o(h, e, t, n);
      }, 4), _s;
    }, _s.config = function (e) {
      return _s(e);
    }, t._defined = m, (r = function r(e, t, n) {
      if ("string" != typeof e) throw new Error("See almond README: incorrect module build, no module name");t.splice || (n = t, t = []), w(m, e) || w(v, e) || (v[e] = [e, t, n]);
    }).amd = { jQuery: !0 }, e.requirejs = t, e.require = n, e.define = r), e.define("almond", function () {}), e.define("jquery", [], function () {
      var e = u || $;return null == e && console && console.error && console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."), e;
    }), e.define("select2/utils", ["jquery"], function (o) {
      var i = {};function u(e) {
        var t = e.prototype,
            n = [];for (var r in t) {
          "function" == typeof t[r] && "constructor" !== r && n.push(r);
        }return n;
      }i.Extend = function (e, t) {
        var n = {}.hasOwnProperty;function r() {
          this.constructor = e;
        }for (var i in t) {
          n.call(t, i) && (e[i] = t[i]);
        }return r.prototype = t.prototype, e.prototype = new r(), e.__super__ = t.prototype, e;
      }, i.Decorate = function (r, i) {
        var e = u(i),
            t = u(r);function o() {
          var e = Array.prototype.unshift,
              t = i.prototype.constructor.length,
              n = r.prototype.constructor;0 < t && (e.call(arguments, r.prototype.constructor), n = i.prototype.constructor), n.apply(this, arguments);
        }i.displayName = r.displayName, o.prototype = new function () {
          this.constructor = o;
        }();for (var n = 0; n < t.length; n++) {
          var s = t[n];o.prototype[s] = r.prototype[s];
        }function a(e) {
          var t = function t() {};e in o.prototype && (t = o.prototype[e]);var n = i.prototype[e];return function () {
            return Array.prototype.unshift.call(arguments, t), n.apply(this, arguments);
          };
        }for (var l = 0; l < e.length; l++) {
          var c = e[l];o.prototype[c] = a(c);
        }return o;
      };function e() {
        this.listeners = {};
      }e.prototype.on = function (e, t) {
        this.listeners = this.listeners || {}, e in this.listeners ? this.listeners[e].push(t) : this.listeners[e] = [t];
      }, e.prototype.trigger = function (e) {
        var t = Array.prototype.slice,
            n = t.call(arguments, 1);this.listeners = this.listeners || {}, null == n && (n = []), 0 === n.length && n.push({}), (n[0]._type = e) in this.listeners && this.invoke(this.listeners[e], t.call(arguments, 1)), "*" in this.listeners && this.invoke(this.listeners["*"], arguments);
      }, e.prototype.invoke = function (e, t) {
        for (var n = 0, r = e.length; n < r; n++) {
          e[n].apply(this, t);
        }
      }, i.Observable = e, i.generateChars = function (e) {
        for (var t = "", n = 0; n < e; n++) {
          t += Math.floor(36 * Math.random()).toString(36);
        }return t;
      }, i.bind = function (e, t) {
        return function () {
          e.apply(t, arguments);
        };
      }, i._convertData = function (e) {
        for (var t in e) {
          var n = t.split("-"),
              r = e;if (1 !== n.length) {
            for (var i = 0; i < n.length; i++) {
              var o = n[i];(o = o.substring(0, 1).toLowerCase() + o.substring(1)) in r || (r[o] = {}), i == n.length - 1 && (r[o] = e[t]), r = r[o];
            }delete e[t];
          }
        }return e;
      }, i.hasScroll = function (e, t) {
        var n = o(t),
            r = t.style.overflowX,
            i = t.style.overflowY;return (r !== i || "hidden" !== i && "visible" !== i) && ("scroll" === r || "scroll" === i || n.innerHeight() < t.scrollHeight || n.innerWidth() < t.scrollWidth);
      }, i.escapeMarkup = function (e) {
        var t = { "\\": "&#92;", "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "/": "&#47;" };return "string" != typeof e ? e : String(e).replace(/[&<>"'\/\\]/g, function (e) {
          return t[e];
        });
      }, i.appendMany = function (e, t) {
        if ("1.7" === o.fn.jquery.substr(0, 3)) {
          var n = o();o.map(t, function (e) {
            n = n.add(e);
          }), t = n;
        }e.append(t);
      }, i.__cache = {};var n = 0;return i.GetUniqueElementId = function (e) {
        var t = e.getAttribute("data-select2-id");return null == t && (e.id ? (t = e.id, e.setAttribute("data-select2-id", t)) : (e.setAttribute("data-select2-id", ++n), t = n.toString())), t;
      }, i.StoreData = function (e, t, n) {
        var r = i.GetUniqueElementId(e);i.__cache[r] || (i.__cache[r] = {}), i.__cache[r][t] = n;
      }, i.GetData = function (e, t) {
        var n = i.GetUniqueElementId(e);return t ? i.__cache[n] && null != i.__cache[n][t] ? i.__cache[n][t] : o(e).data(t) : i.__cache[n];
      }, i.RemoveData = function (e) {
        var t = i.GetUniqueElementId(e);null != i.__cache[t] && delete i.__cache[t], e.removeAttribute("data-select2-id");
      }, i;
    }), e.define("select2/results", ["jquery", "./utils"], function (h, f) {
      function r(e, t, n) {
        this.$element = e, this.data = n, this.options = t, r.__super__.constructor.call(this);
      }return f.Extend(r, f.Observable), r.prototype.render = function () {
        var e = h('<ul class="select2-results__options" role="listbox"></ul>');return this.options.get("multiple") && e.attr("aria-multiselectable", "true"), this.$results = e;
      }, r.prototype.clear = function () {
        this.$results.empty();
      }, r.prototype.displayMessage = function (e) {
        var t = this.options.get("escapeMarkup");this.clear(), this.hideLoading();var n = h('<li role="alert" aria-live="assertive" class="select2-results__option"></li>'),
            r = this.options.get("translations").get(e.message);n.append(t(r(e.args))), n[0].className += " select2-results__message", this.$results.append(n);
      }, r.prototype.hideMessages = function () {
        this.$results.find(".select2-results__message").remove();
      }, r.prototype.append = function (e) {
        this.hideLoading();var t = [];if (null != e.results && 0 !== e.results.length) {
          e.results = this.sort(e.results);for (var n = 0; n < e.results.length; n++) {
            var r = e.results[n],
                i = this.option(r);t.push(i);
          }this.$results.append(t);
        } else 0 === this.$results.children().length && this.trigger("results:message", { message: "noResults" });
      }, r.prototype.position = function (e, t) {
        t.find(".select2-results").append(e);
      }, r.prototype.sort = function (e) {
        return this.options.get("sorter")(e);
      }, r.prototype.highlightFirstItem = function () {
        var e = this.$results.find(".select2-results__option[aria-selected]"),
            t = e.filter("[aria-selected=true]");0 < t.length ? t.first().trigger("mouseenter") : e.first().trigger("mouseenter"), this.ensureHighlightVisible();
      }, r.prototype.setClasses = function () {
        var t = this;this.data.current(function (e) {
          var r = h.map(e, function (e) {
            return e.id.toString();
          });t.$results.find(".select2-results__option[aria-selected]").each(function () {
            var e = h(this),
                t = f.GetData(this, "data"),
                n = "" + t.id;null != t.element && t.element.selected || null == t.element && -1 < h.inArray(n, r) ? e.attr("aria-selected", "true") : e.attr("aria-selected", "false");
          });
        });
      }, r.prototype.showLoading = function (e) {
        this.hideLoading();var t = { disabled: !0, loading: !0, text: this.options.get("translations").get("searching")(e) },
            n = this.option(t);n.className += " loading-results", this.$results.prepend(n);
      }, r.prototype.hideLoading = function () {
        this.$results.find(".loading-results").remove();
      }, r.prototype.option = function (e) {
        var t = document.createElement("li");t.className = "select2-results__option";var n = { role: "option", "aria-selected": "false" },
            r = window.Element.prototype.matches || window.Element.prototype.msMatchesSelector || window.Element.prototype.webkitMatchesSelector;for (var i in (null != e.element && r.call(e.element, ":disabled") || null == e.element && e.disabled) && (delete n["aria-selected"], n["aria-disabled"] = "true"), null == e.id && delete n["aria-selected"], null != e._resultId && (t.id = e._resultId), e.title && (t.title = e.title), e.children && (n.role = "group", n["aria-label"] = e.text, delete n["aria-selected"]), n) {
          var o = n[i];t.setAttribute(i, o);
        }if (e.children) {
          var s = h(t),
              a = document.createElement("strong");a.className = "select2-results__group";h(a);this.template(e, a);for (var l = [], c = 0; c < e.children.length; c++) {
            var u = e.children[c],
                d = this.option(u);l.push(d);
          }var p = h("<ul></ul>", { class: "select2-results__options select2-results__options--nested" });p.append(l), s.append(a), s.append(p);
        } else this.template(e, t);return f.StoreData(t, "data", e), t;
      }, r.prototype.bind = function (t, e) {
        var l = this,
            n = t.id + "-results";this.$results.attr("id", n), t.on("results:all", function (e) {
          l.clear(), l.append(e.data), t.isOpen() && (l.setClasses(), l.highlightFirstItem());
        }), t.on("results:append", function (e) {
          l.append(e.data), t.isOpen() && l.setClasses();
        }), t.on("query", function (e) {
          l.hideMessages(), l.showLoading(e);
        }), t.on("select", function () {
          t.isOpen() && (l.setClasses(), l.options.get("scrollAfterSelect") && l.highlightFirstItem());
        }), t.on("unselect", function () {
          t.isOpen() && (l.setClasses(), l.options.get("scrollAfterSelect") && l.highlightFirstItem());
        }), t.on("open", function () {
          l.$results.attr("aria-expanded", "true"), l.$results.attr("aria-hidden", "false"), l.setClasses(), l.ensureHighlightVisible();
        }), t.on("close", function () {
          l.$results.attr("aria-expanded", "false"), l.$results.attr("aria-hidden", "true"), l.$results.removeAttr("aria-activedescendant");
        }), t.on("results:toggle", function () {
          var e = l.getHighlightedResults();0 !== e.length && e.trigger("mouseup");
        }), t.on("results:select", function () {
          var e = l.getHighlightedResults();if (0 !== e.length) {
            var t = f.GetData(e[0], "data");"true" == e.attr("aria-selected") ? l.trigger("close", {}) : l.trigger("select", { data: t });
          }
        }), t.on("results:previous", function () {
          var e = l.getHighlightedResults(),
              t = l.$results.find("[aria-selected]"),
              n = t.index(e);if (!(n <= 0)) {
            var r = n - 1;0 === e.length && (r = 0);var i = t.eq(r);i.trigger("mouseenter");var o = l.$results.offset().top,
                s = i.offset().top,
                a = l.$results.scrollTop() + (s - o);0 === r ? l.$results.scrollTop(0) : s - o < 0 && l.$results.scrollTop(a);
          }
        }), t.on("results:next", function () {
          var e = l.getHighlightedResults(),
              t = l.$results.find("[aria-selected]"),
              n = t.index(e) + 1;if (!(n >= t.length)) {
            var r = t.eq(n);r.trigger("mouseenter");var i = l.$results.offset().top + l.$results.outerHeight(!1),
                o = r.offset().top + r.outerHeight(!1),
                s = l.$results.scrollTop() + o - i;0 === n ? l.$results.scrollTop(0) : i < o && l.$results.scrollTop(s);
          }
        }), t.on("results:focus", function (e) {
          e.element.addClass("select2-results__option--highlighted");
        }), t.on("results:message", function (e) {
          l.displayMessage(e);
        }), h.fn.mousewheel && this.$results.on("mousewheel", function (e) {
          var t = l.$results.scrollTop(),
              n = l.$results.get(0).scrollHeight - t + e.deltaY,
              r = 0 < e.deltaY && t - e.deltaY <= 0,
              i = e.deltaY < 0 && n <= l.$results.height();r ? (l.$results.scrollTop(0), e.preventDefault(), e.stopPropagation()) : i && (l.$results.scrollTop(l.$results.get(0).scrollHeight - l.$results.height()), e.preventDefault(), e.stopPropagation());
        }), this.$results.on("mouseup", ".select2-results__option[aria-selected]", function (e) {
          var t = h(this),
              n = f.GetData(this, "data");"true" !== t.attr("aria-selected") ? l.trigger("select", { originalEvent: e, data: n }) : l.options.get("multiple") ? l.trigger("unselect", { originalEvent: e, data: n }) : l.trigger("close", {});
        }), this.$results.on("mouseenter", ".select2-results__option[aria-selected]", function (e) {
          var t = f.GetData(this, "data");l.getHighlightedResults().removeClass("select2-results__option--highlighted"), l.trigger("results:focus", { data: t, element: h(this) });
        });
      }, r.prototype.getHighlightedResults = function () {
        return this.$results.find(".select2-results__option--highlighted");
      }, r.prototype.destroy = function () {
        this.$results.remove();
      }, r.prototype.ensureHighlightVisible = function () {
        var e = this.getHighlightedResults();if (0 !== e.length) {
          var t = this.$results.find("[aria-selected]").index(e),
              n = this.$results.offset().top,
              r = e.offset().top,
              i = this.$results.scrollTop() + (r - n),
              o = r - n;i -= 2 * e.outerHeight(!1), t <= 2 ? this.$results.scrollTop(0) : (o > this.$results.outerHeight() || o < 0) && this.$results.scrollTop(i);
        }
      }, r.prototype.template = function (e, t) {
        var n = this.options.get("templateResult"),
            r = this.options.get("escapeMarkup"),
            i = n(e, t);null == i ? t.style.display = "none" : "string" == typeof i ? t.innerHTML = r(i) : h(t).append(i);
      }, r;
    }), e.define("select2/keys", [], function () {
      return { BACKSPACE: 8, TAB: 9, ENTER: 13, SHIFT: 16, CTRL: 17, ALT: 18, ESC: 27, SPACE: 32, PAGE_UP: 33, PAGE_DOWN: 34, END: 35, HOME: 36, LEFT: 37, UP: 38, RIGHT: 39, DOWN: 40, DELETE: 46 };
    }), e.define("select2/selection/base", ["jquery", "../utils", "../keys"], function (n, r, i) {
      function o(e, t) {
        this.$element = e, this.options = t, o.__super__.constructor.call(this);
      }return r.Extend(o, r.Observable), o.prototype.render = function () {
        var e = n('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');return this._tabindex = 0, null != r.GetData(this.$element[0], "old-tabindex") ? this._tabindex = r.GetData(this.$element[0], "old-tabindex") : null != this.$element.attr("tabindex") && (this._tabindex = this.$element.attr("tabindex")), e.attr("title", this.$element.attr("title")), e.attr("tabindex", this._tabindex), e.attr("aria-disabled", "false"), this.$selection = e;
      }, o.prototype.bind = function (e, t) {
        var n = this,
            r = e.id + "-results";this.container = e, this.$selection.on("focus", function (e) {
          n.trigger("focus", e);
        }), this.$selection.on("blur", function (e) {
          n._handleBlur(e);
        }), this.$selection.on("keydown", function (e) {
          n.trigger("keypress", e), e.which === i.SPACE && e.preventDefault();
        }), e.on("results:focus", function (e) {
          n.$selection.attr("aria-activedescendant", e.data._resultId);
        }), e.on("selection:update", function (e) {
          n.update(e.data);
        }), e.on("open", function () {
          n.$selection.attr("aria-expanded", "true"), n.$selection.attr("aria-owns", r), n._attachCloseHandler(e);
        }), e.on("close", function () {
          n.$selection.attr("aria-expanded", "false"), n.$selection.removeAttr("aria-activedescendant"), n.$selection.removeAttr("aria-owns"), n.$selection.trigger("focus"), n._detachCloseHandler(e);
        }), e.on("enable", function () {
          n.$selection.attr("tabindex", n._tabindex), n.$selection.attr("aria-disabled", "false");
        }), e.on("disable", function () {
          n.$selection.attr("tabindex", "-1"), n.$selection.attr("aria-disabled", "true");
        });
      }, o.prototype._handleBlur = function (e) {
        var t = this;window.setTimeout(function () {
          document.activeElement == t.$selection[0] || n.contains(t.$selection[0], document.activeElement) || t.trigger("blur", e);
        }, 1);
      }, o.prototype._attachCloseHandler = function (e) {
        n(document.body).on("mousedown.select2." + e.id, function (e) {
          var t = n(e.target).closest(".select2");n(".select2.select2-container--open").each(function () {
            this != t[0] && r.GetData(this, "element").select2("close");
          });
        });
      }, o.prototype._detachCloseHandler = function (e) {
        n(document.body).off("mousedown.select2." + e.id);
      }, o.prototype.position = function (e, t) {
        t.find(".selection").append(e);
      }, o.prototype.destroy = function () {
        this._detachCloseHandler(this.container);
      }, o.prototype.update = function (e) {
        throw new Error("The `update` method must be defined in child classes.");
      }, o.prototype.isEnabled = function () {
        return !this.isDisabled();
      }, o.prototype.isDisabled = function () {
        return this.options.get("disabled");
      }, o;
    }), e.define("select2/selection/single", ["jquery", "./base", "../utils", "../keys"], function (e, t, n, r) {
      function i() {
        i.__super__.constructor.apply(this, arguments);
      }return n.Extend(i, t), i.prototype.render = function () {
        var e = i.__super__.render.call(this);return e.addClass("select2-selection--single"), e.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'), e;
      }, i.prototype.bind = function (t, e) {
        var n = this;i.__super__.bind.apply(this, arguments);var r = t.id + "-container";this.$selection.find(".select2-selection__rendered").attr("id", r).attr("role", "textbox").attr("aria-readonly", "true"), this.$selection.attr("aria-labelledby", r), this.$selection.on("mousedown", function (e) {
          1 === e.which && n.trigger("toggle", { originalEvent: e });
        }), this.$selection.on("focus", function (e) {}), this.$selection.on("blur", function (e) {}), t.on("focus", function (e) {
          t.isOpen() || n.$selection.trigger("focus");
        });
      }, i.prototype.clear = function () {
        var e = this.$selection.find(".select2-selection__rendered");e.empty(), e.removeAttr("title");
      }, i.prototype.display = function (e, t) {
        var n = this.options.get("templateSelection");return this.options.get("escapeMarkup")(n(e, t));
      }, i.prototype.selectionContainer = function () {
        return e("<span></span>");
      }, i.prototype.update = function (e) {
        if (0 !== e.length) {
          var t = e[0],
              n = this.$selection.find(".select2-selection__rendered"),
              r = this.display(t, n);n.empty().append(r);var i = t.title || t.text;i ? n.attr("title", i) : n.removeAttr("title");
        } else this.clear();
      }, i;
    }), e.define("select2/selection/multiple", ["jquery", "./base", "../utils"], function (i, e, l) {
      function n(e, t) {
        n.__super__.constructor.apply(this, arguments);
      }return l.Extend(n, e), n.prototype.render = function () {
        var e = n.__super__.render.call(this);return e.addClass("select2-selection--multiple"), e.html('<ul class="select2-selection__rendered"></ul>'), e;
      }, n.prototype.bind = function (e, t) {
        var r = this;n.__super__.bind.apply(this, arguments), this.$selection.on("click", function (e) {
          r.trigger("toggle", { originalEvent: e });
        }), this.$selection.on("click", ".select2-selection__choice__remove", function (e) {
          if (!r.isDisabled()) {
            var t = i(this).parent(),
                n = l.GetData(t[0], "data");r.trigger("unselect", { originalEvent: e, data: n });
          }
        });
      }, n.prototype.clear = function () {
        var e = this.$selection.find(".select2-selection__rendered");e.empty(), e.removeAttr("title");
      }, n.prototype.display = function (e, t) {
        var n = this.options.get("templateSelection");return this.options.get("escapeMarkup")(n(e, t));
      }, n.prototype.selectionContainer = function () {
        return i('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>');
      }, n.prototype.update = function (e) {
        if (this.clear(), 0 !== e.length) {
          for (var t = [], n = 0; n < e.length; n++) {
            var r = e[n],
                i = this.selectionContainer(),
                o = this.display(r, i);i.append(o);var s = r.title || r.text;s && i.attr("title", s), l.StoreData(i[0], "data", r), t.push(i);
          }var a = this.$selection.find(".select2-selection__rendered");l.appendMany(a, t);
        }
      }, n;
    }), e.define("select2/selection/placeholder", ["../utils"], function (e) {
      function t(e, t, n) {
        this.placeholder = this.normalizePlaceholder(n.get("placeholder")), e.call(this, t, n);
      }return t.prototype.normalizePlaceholder = function (e, t) {
        return "string" == typeof t && (t = { id: "", text: t }), t;
      }, t.prototype.createPlaceholder = function (e, t) {
        var n = this.selectionContainer();return n.html(this.display(t)), n.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"), n;
      }, t.prototype.update = function (e, t) {
        var n = 1 == t.length && t[0].id != this.placeholder.id;if (1 < t.length || n) return e.call(this, t);this.clear();var r = this.createPlaceholder(this.placeholder);this.$selection.find(".select2-selection__rendered").append(r);
      }, t;
    }), e.define("select2/selection/allowClear", ["jquery", "../keys", "../utils"], function (i, r, a) {
      function e() {}return e.prototype.bind = function (e, t, n) {
        var r = this;e.call(this, t, n), null == this.placeholder && this.options.get("debug") && window.console && console.error && console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."), this.$selection.on("mousedown", ".select2-selection__clear", function (e) {
          r._handleClear(e);
        }), t.on("keypress", function (e) {
          r._handleKeyboardClear(e, t);
        });
      }, e.prototype._handleClear = function (e, t) {
        if (!this.isDisabled()) {
          var n = this.$selection.find(".select2-selection__clear");if (0 !== n.length) {
            t.stopPropagation();var r = a.GetData(n[0], "data"),
                i = this.$element.val();this.$element.val(this.placeholder.id);var o = { data: r };if (this.trigger("clear", o), o.prevented) this.$element.val(i);else {
              for (var s = 0; s < r.length; s++) {
                if (o = { data: r[s] }, this.trigger("unselect", o), o.prevented) return void this.$element.val(i);
              }this.$element.trigger("input").trigger("change"), this.trigger("toggle", {});
            }
          }
        }
      }, e.prototype._handleKeyboardClear = function (e, t, n) {
        n.isOpen() || t.which != r.DELETE && t.which != r.BACKSPACE || this._handleClear(t);
      }, e.prototype.update = function (e, t) {
        if (e.call(this, t), !(0 < this.$selection.find(".select2-selection__placeholder").length || 0 === t.length)) {
          var n = this.options.get("translations").get("removeAllItems"),
              r = i('<span class="select2-selection__clear" title="' + n() + '">&times;</span>');a.StoreData(r[0], "data", t), this.$selection.find(".select2-selection__rendered").prepend(r);
        }
      }, e;
    }), e.define("select2/selection/search", ["jquery", "../utils", "../keys"], function (r, a, l) {
      function e(e, t, n) {
        e.call(this, t, n);
      }return e.prototype.render = function (e) {
        var t = r('<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></li>');this.$searchContainer = t, this.$search = t.find("input");var n = e.call(this);return this._transferTabIndex(), n;
      }, e.prototype.bind = function (e, t, n) {
        var r = this,
            i = t.id + "-results";e.call(this, t, n), t.on("open", function () {
          r.$search.attr("aria-controls", i), r.$search.trigger("focus");
        }), t.on("close", function () {
          r.$search.val(""), r.$search.removeAttr("aria-controls"), r.$search.removeAttr("aria-activedescendant"), r.$search.trigger("focus");
        }), t.on("enable", function () {
          r.$search.prop("disabled", !1), r._transferTabIndex();
        }), t.on("disable", function () {
          r.$search.prop("disabled", !0);
        }), t.on("focus", function (e) {
          r.$search.trigger("focus");
        }), t.on("results:focus", function (e) {
          e.data._resultId ? r.$search.attr("aria-activedescendant", e.data._resultId) : r.$search.removeAttr("aria-activedescendant");
        }), this.$selection.on("focusin", ".select2-search--inline", function (e) {
          r.trigger("focus", e);
        }), this.$selection.on("focusout", ".select2-search--inline", function (e) {
          r._handleBlur(e);
        }), this.$selection.on("keydown", ".select2-search--inline", function (e) {
          if (e.stopPropagation(), r.trigger("keypress", e), r._keyUpPrevented = e.isDefaultPrevented(), e.which === l.BACKSPACE && "" === r.$search.val()) {
            var t = r.$searchContainer.prev(".select2-selection__choice");if (0 < t.length) {
              var n = a.GetData(t[0], "data");r.searchRemoveChoice(n), e.preventDefault();
            }
          }
        }), this.$selection.on("click", ".select2-search--inline", function (e) {
          r.$search.val() && e.stopPropagation();
        });var o = document.documentMode,
            s = o && o <= 11;this.$selection.on("input.searchcheck", ".select2-search--inline", function (e) {
          s ? r.$selection.off("input.search input.searchcheck") : r.$selection.off("keyup.search");
        }), this.$selection.on("keyup.search input.search", ".select2-search--inline", function (e) {
          if (s && "input" === e.type) r.$selection.off("input.search input.searchcheck");else {
            var t = e.which;t != l.SHIFT && t != l.CTRL && t != l.ALT && t != l.TAB && r.handleSearch(e);
          }
        });
      }, e.prototype._transferTabIndex = function (e) {
        this.$search.attr("tabindex", this.$selection.attr("tabindex")), this.$selection.attr("tabindex", "-1");
      }, e.prototype.createPlaceholder = function (e, t) {
        this.$search.attr("placeholder", t.text);
      }, e.prototype.update = function (e, t) {
        var n = this.$search[0] == document.activeElement;this.$search.attr("placeholder", ""), e.call(this, t), this.$selection.find(".select2-selection__rendered").append(this.$searchContainer), this.resizeSearch(), n && this.$search.trigger("focus");
      }, e.prototype.handleSearch = function () {
        if (this.resizeSearch(), !this._keyUpPrevented) {
          var e = this.$search.val();this.trigger("query", { term: e });
        }this._keyUpPrevented = !1;
      }, e.prototype.searchRemoveChoice = function (e, t) {
        this.trigger("unselect", { data: t }), this.$search.val(t.text), this.handleSearch();
      }, e.prototype.resizeSearch = function () {
        this.$search.css("width", "25px");var e = "";"" !== this.$search.attr("placeholder") ? e = this.$selection.find(".select2-selection__rendered").width() : e = .75 * (this.$search.val().length + 1) + "em";this.$search.css("width", e);
      }, e;
    }), e.define("select2/selection/eventRelay", ["jquery"], function (s) {
      function e() {}return e.prototype.bind = function (e, t, n) {
        var r = this,
            i = ["open", "opening", "close", "closing", "select", "selecting", "unselect", "unselecting", "clear", "clearing"],
            o = ["opening", "closing", "selecting", "unselecting", "clearing"];e.call(this, t, n), t.on("*", function (e, t) {
          if (-1 !== s.inArray(e, i)) {
            t = t || {};var n = s.Event("select2:" + e, { params: t });r.$element.trigger(n), -1 !== s.inArray(e, o) && (t.prevented = n.isDefaultPrevented());
          }
        });
      }, e;
    }), e.define("select2/translation", ["jquery", "require"], function (t, n) {
      function r(e) {
        this.dict = e || {};
      }return r.prototype.all = function () {
        return this.dict;
      }, r.prototype.get = function (e) {
        return this.dict[e];
      }, r.prototype.extend = function (e) {
        this.dict = t.extend({}, e.all(), this.dict);
      }, r._cache = {}, r.loadPath = function (e) {
        if (!(e in r._cache)) {
          var t = n(e);r._cache[e] = t;
        }return new r(r._cache[e]);
      }, r;
    }), e.define("select2/diacritics", [], function () {
      return { "Ⓐ": "A", "Ａ": "A", "À": "A", "Á": "A", "Â": "A", "Ầ": "A", "Ấ": "A", "Ẫ": "A", "Ẩ": "A", "Ã": "A", "Ā": "A", "Ă": "A", "Ằ": "A", "Ắ": "A", "Ẵ": "A", "Ẳ": "A", "Ȧ": "A", "Ǡ": "A", "Ä": "A", "Ǟ": "A", "Ả": "A", "Å": "A", "Ǻ": "A", "Ǎ": "A", "Ȁ": "A", "Ȃ": "A", "Ạ": "A", "Ậ": "A", "Ặ": "A", "Ḁ": "A", "Ą": "A", "Ⱥ": "A", "Ɐ": "A", "Ꜳ": "AA", "Æ": "AE", "Ǽ": "AE", "Ǣ": "AE", "Ꜵ": "AO", "Ꜷ": "AU", "Ꜹ": "AV", "Ꜻ": "AV", "Ꜽ": "AY", "Ⓑ": "B", "Ｂ": "B", "Ḃ": "B", "Ḅ": "B", "Ḇ": "B", "Ƀ": "B", "Ƃ": "B", "Ɓ": "B", "Ⓒ": "C", "Ｃ": "C", "Ć": "C", "Ĉ": "C", "Ċ": "C", "Č": "C", "Ç": "C", "Ḉ": "C", "Ƈ": "C", "Ȼ": "C", "Ꜿ": "C", "Ⓓ": "D", "Ｄ": "D", "Ḋ": "D", "Ď": "D", "Ḍ": "D", "Ḑ": "D", "Ḓ": "D", "Ḏ": "D", "Đ": "D", "Ƌ": "D", "Ɗ": "D", "Ɖ": "D", "Ꝺ": "D", "Ǳ": "DZ", "Ǆ": "DZ", "ǲ": "Dz", "ǅ": "Dz", "Ⓔ": "E", "Ｅ": "E", "È": "E", "É": "E", "Ê": "E", "Ề": "E", "Ế": "E", "Ễ": "E", "Ể": "E", "Ẽ": "E", "Ē": "E", "Ḕ": "E", "Ḗ": "E", "Ĕ": "E", "Ė": "E", "Ë": "E", "Ẻ": "E", "Ě": "E", "Ȅ": "E", "Ȇ": "E", "Ẹ": "E", "Ệ": "E", "Ȩ": "E", "Ḝ": "E", "Ę": "E", "Ḙ": "E", "Ḛ": "E", "Ɛ": "E", "Ǝ": "E", "Ⓕ": "F", "Ｆ": "F", "Ḟ": "F", "Ƒ": "F", "Ꝼ": "F", "Ⓖ": "G", "Ｇ": "G", "Ǵ": "G", "Ĝ": "G", "Ḡ": "G", "Ğ": "G", "Ġ": "G", "Ǧ": "G", "Ģ": "G", "Ǥ": "G", "Ɠ": "G", "Ꞡ": "G", "Ᵹ": "G", "Ꝿ": "G", "Ⓗ": "H", "Ｈ": "H", "Ĥ": "H", "Ḣ": "H", "Ḧ": "H", "Ȟ": "H", "Ḥ": "H", "Ḩ": "H", "Ḫ": "H", "Ħ": "H", "Ⱨ": "H", "Ⱶ": "H", "Ɥ": "H", "Ⓘ": "I", "Ｉ": "I", "Ì": "I", "Í": "I", "Î": "I", "Ĩ": "I", "Ī": "I", "Ĭ": "I", "İ": "I", "Ï": "I", "Ḯ": "I", "Ỉ": "I", "Ǐ": "I", "Ȉ": "I", "Ȋ": "I", "Ị": "I", "Į": "I", "Ḭ": "I", "Ɨ": "I", "Ⓙ": "J", "Ｊ": "J", "Ĵ": "J", "Ɉ": "J", "Ⓚ": "K", "Ｋ": "K", "Ḱ": "K", "Ǩ": "K", "Ḳ": "K", "Ķ": "K", "Ḵ": "K", "Ƙ": "K", "Ⱪ": "K", "Ꝁ": "K", "Ꝃ": "K", "Ꝅ": "K", "Ꞣ": "K", "Ⓛ": "L", "Ｌ": "L", "Ŀ": "L", "Ĺ": "L", "Ľ": "L", "Ḷ": "L", "Ḹ": "L", "Ļ": "L", "Ḽ": "L", "Ḻ": "L", "Ł": "L", "Ƚ": "L", "Ɫ": "L", "Ⱡ": "L", "Ꝉ": "L", "Ꝇ": "L", "Ꞁ": "L", "Ǉ": "LJ", "ǈ": "Lj", "Ⓜ": "M", "Ｍ": "M", "Ḿ": "M", "Ṁ": "M", "Ṃ": "M", "Ɱ": "M", "Ɯ": "M", "Ⓝ": "N", "Ｎ": "N", "Ǹ": "N", "Ń": "N", "Ñ": "N", "Ṅ": "N", "Ň": "N", "Ṇ": "N", "Ņ": "N", "Ṋ": "N", "Ṉ": "N", "Ƞ": "N", "Ɲ": "N", "Ꞑ": "N", "Ꞥ": "N", "Ǌ": "NJ", "ǋ": "Nj", "Ⓞ": "O", "Ｏ": "O", "Ò": "O", "Ó": "O", "Ô": "O", "Ồ": "O", "Ố": "O", "Ỗ": "O", "Ổ": "O", "Õ": "O", "Ṍ": "O", "Ȭ": "O", "Ṏ": "O", "Ō": "O", "Ṑ": "O", "Ṓ": "O", "Ŏ": "O", "Ȯ": "O", "Ȱ": "O", "Ö": "O", "Ȫ": "O", "Ỏ": "O", "Ő": "O", "Ǒ": "O", "Ȍ": "O", "Ȏ": "O", "Ơ": "O", "Ờ": "O", "Ớ": "O", "Ỡ": "O", "Ở": "O", "Ợ": "O", "Ọ": "O", "Ộ": "O", "Ǫ": "O", "Ǭ": "O", "Ø": "O", "Ǿ": "O", "Ɔ": "O", "Ɵ": "O", "Ꝋ": "O", "Ꝍ": "O", "Œ": "OE", "Ƣ": "OI", "Ꝏ": "OO", "Ȣ": "OU", "Ⓟ": "P", "Ｐ": "P", "Ṕ": "P", "Ṗ": "P", "Ƥ": "P", "Ᵽ": "P", "Ꝑ": "P", "Ꝓ": "P", "Ꝕ": "P", "Ⓠ": "Q", "Ｑ": "Q", "Ꝗ": "Q", "Ꝙ": "Q", "Ɋ": "Q", "Ⓡ": "R", "Ｒ": "R", "Ŕ": "R", "Ṙ": "R", "Ř": "R", "Ȑ": "R", "Ȓ": "R", "Ṛ": "R", "Ṝ": "R", "Ŗ": "R", "Ṟ": "R", "Ɍ": "R", "Ɽ": "R", "Ꝛ": "R", "Ꞧ": "R", "Ꞃ": "R", "Ⓢ": "S", "Ｓ": "S", "ẞ": "S", "Ś": "S", "Ṥ": "S", "Ŝ": "S", "Ṡ": "S", "Š": "S", "Ṧ": "S", "Ṣ": "S", "Ṩ": "S", "Ș": "S", "Ş": "S", "Ȿ": "S", "Ꞩ": "S", "Ꞅ": "S", "Ⓣ": "T", "Ｔ": "T", "Ṫ": "T", "Ť": "T", "Ṭ": "T", "Ț": "T", "Ţ": "T", "Ṱ": "T", "Ṯ": "T", "Ŧ": "T", "Ƭ": "T", "Ʈ": "T", "Ⱦ": "T", "Ꞇ": "T", "Ꜩ": "TZ", "Ⓤ": "U", "Ｕ": "U", "Ù": "U", "Ú": "U", "Û": "U", "Ũ": "U", "Ṹ": "U", "Ū": "U", "Ṻ": "U", "Ŭ": "U", "Ü": "U", "Ǜ": "U", "Ǘ": "U", "Ǖ": "U", "Ǚ": "U", "Ủ": "U", "Ů": "U", "Ű": "U", "Ǔ": "U", "Ȕ": "U", "Ȗ": "U", "Ư": "U", "Ừ": "U", "Ứ": "U", "Ữ": "U", "Ử": "U", "Ự": "U", "Ụ": "U", "Ṳ": "U", "Ų": "U", "Ṷ": "U", "Ṵ": "U", "Ʉ": "U", "Ⓥ": "V", "Ｖ": "V", "Ṽ": "V", "Ṿ": "V", "Ʋ": "V", "Ꝟ": "V", "Ʌ": "V", "Ꝡ": "VY", "Ⓦ": "W", "Ｗ": "W", "Ẁ": "W", "Ẃ": "W", "Ŵ": "W", "Ẇ": "W", "Ẅ": "W", "Ẉ": "W", "Ⱳ": "W", "Ⓧ": "X", "Ｘ": "X", "Ẋ": "X", "Ẍ": "X", "Ⓨ": "Y", "Ｙ": "Y", "Ỳ": "Y", "Ý": "Y", "Ŷ": "Y", "Ỹ": "Y", "Ȳ": "Y", "Ẏ": "Y", "Ÿ": "Y", "Ỷ": "Y", "Ỵ": "Y", "Ƴ": "Y", "Ɏ": "Y", "Ỿ": "Y", "Ⓩ": "Z", "Ｚ": "Z", "Ź": "Z", "Ẑ": "Z", "Ż": "Z", "Ž": "Z", "Ẓ": "Z", "Ẕ": "Z", "Ƶ": "Z", "Ȥ": "Z", "Ɀ": "Z", "Ⱬ": "Z", "Ꝣ": "Z", "ⓐ": "a", "ａ": "a", "ẚ": "a", "à": "a", "á": "a", "â": "a", "ầ": "a", "ấ": "a", "ẫ": "a", "ẩ": "a", "ã": "a", "ā": "a", "ă": "a", "ằ": "a", "ắ": "a", "ẵ": "a", "ẳ": "a", "ȧ": "a", "ǡ": "a", "ä": "a", "ǟ": "a", "ả": "a", "å": "a", "ǻ": "a", "ǎ": "a", "ȁ": "a", "ȃ": "a", "ạ": "a", "ậ": "a", "ặ": "a", "ḁ": "a", "ą": "a", "ⱥ": "a", "ɐ": "a", "ꜳ": "aa", "æ": "ae", "ǽ": "ae", "ǣ": "ae", "ꜵ": "ao", "ꜷ": "au", "ꜹ": "av", "ꜻ": "av", "ꜽ": "ay", "ⓑ": "b", "ｂ": "b", "ḃ": "b", "ḅ": "b", "ḇ": "b", "ƀ": "b", "ƃ": "b", "ɓ": "b", "ⓒ": "c", "ｃ": "c", "ć": "c", "ĉ": "c", "ċ": "c", "č": "c", "ç": "c", "ḉ": "c", "ƈ": "c", "ȼ": "c", "ꜿ": "c", "ↄ": "c", "ⓓ": "d", "ｄ": "d", "ḋ": "d", "ď": "d", "ḍ": "d", "ḑ": "d", "ḓ": "d", "ḏ": "d", "đ": "d", "ƌ": "d", "ɖ": "d", "ɗ": "d", "ꝺ": "d", "ǳ": "dz", "ǆ": "dz", "ⓔ": "e", "ｅ": "e", "è": "e", "é": "e", "ê": "e", "ề": "e", "ế": "e", "ễ": "e", "ể": "e", "ẽ": "e", "ē": "e", "ḕ": "e", "ḗ": "e", "ĕ": "e", "ė": "e", "ë": "e", "ẻ": "e", "ě": "e", "ȅ": "e", "ȇ": "e", "ẹ": "e", "ệ": "e", "ȩ": "e", "ḝ": "e", "ę": "e", "ḙ": "e", "ḛ": "e", "ɇ": "e", "ɛ": "e", "ǝ": "e", "ⓕ": "f", "ｆ": "f", "ḟ": "f", "ƒ": "f", "ꝼ": "f", "ⓖ": "g", "ｇ": "g", "ǵ": "g", "ĝ": "g", "ḡ": "g", "ğ": "g", "ġ": "g", "ǧ": "g", "ģ": "g", "ǥ": "g", "ɠ": "g", "ꞡ": "g", "ᵹ": "g", "ꝿ": "g", "ⓗ": "h", "ｈ": "h", "ĥ": "h", "ḣ": "h", "ḧ": "h", "ȟ": "h", "ḥ": "h", "ḩ": "h", "ḫ": "h", "ẖ": "h", "ħ": "h", "ⱨ": "h", "ⱶ": "h", "ɥ": "h", "ƕ": "hv", "ⓘ": "i", "ｉ": "i", "ì": "i", "í": "i", "î": "i", "ĩ": "i", "ī": "i", "ĭ": "i", "ï": "i", "ḯ": "i", "ỉ": "i", "ǐ": "i", "ȉ": "i", "ȋ": "i", "ị": "i", "į": "i", "ḭ": "i", "ɨ": "i", "ı": "i", "ⓙ": "j", "ｊ": "j", "ĵ": "j", "ǰ": "j", "ɉ": "j", "ⓚ": "k", "ｋ": "k", "ḱ": "k", "ǩ": "k", "ḳ": "k", "ķ": "k", "ḵ": "k", "ƙ": "k", "ⱪ": "k", "ꝁ": "k", "ꝃ": "k", "ꝅ": "k", "ꞣ": "k", "ⓛ": "l", "ｌ": "l", "ŀ": "l", "ĺ": "l", "ľ": "l", "ḷ": "l", "ḹ": "l", "ļ": "l", "ḽ": "l", "ḻ": "l", "ſ": "l", "ł": "l", "ƚ": "l", "ɫ": "l", "ⱡ": "l", "ꝉ": "l", "ꞁ": "l", "ꝇ": "l", "ǉ": "lj", "ⓜ": "m", "ｍ": "m", "ḿ": "m", "ṁ": "m", "ṃ": "m", "ɱ": "m", "ɯ": "m", "ⓝ": "n", "ｎ": "n", "ǹ": "n", "ń": "n", "ñ": "n", "ṅ": "n", "ň": "n", "ṇ": "n", "ņ": "n", "ṋ": "n", "ṉ": "n", "ƞ": "n", "ɲ": "n", "ŉ": "n", "ꞑ": "n", "ꞥ": "n", "ǌ": "nj", "ⓞ": "o", "ｏ": "o", "ò": "o", "ó": "o", "ô": "o", "ồ": "o", "ố": "o", "ỗ": "o", "ổ": "o", "õ": "o", "ṍ": "o", "ȭ": "o", "ṏ": "o", "ō": "o", "ṑ": "o", "ṓ": "o", "ŏ": "o", "ȯ": "o", "ȱ": "o", "ö": "o", "ȫ": "o", "ỏ": "o", "ő": "o", "ǒ": "o", "ȍ": "o", "ȏ": "o", "ơ": "o", "ờ": "o", "ớ": "o", "ỡ": "o", "ở": "o", "ợ": "o", "ọ": "o", "ộ": "o", "ǫ": "o", "ǭ": "o", "ø": "o", "ǿ": "o", "ɔ": "o", "ꝋ": "o", "ꝍ": "o", "ɵ": "o", "œ": "oe", "ƣ": "oi", "ȣ": "ou", "ꝏ": "oo", "ⓟ": "p", "ｐ": "p", "ṕ": "p", "ṗ": "p", "ƥ": "p", "ᵽ": "p", "ꝑ": "p", "ꝓ": "p", "ꝕ": "p", "ⓠ": "q", "ｑ": "q", "ɋ": "q", "ꝗ": "q", "ꝙ": "q", "ⓡ": "r", "ｒ": "r", "ŕ": "r", "ṙ": "r", "ř": "r", "ȑ": "r", "ȓ": "r", "ṛ": "r", "ṝ": "r", "ŗ": "r", "ṟ": "r", "ɍ": "r", "ɽ": "r", "ꝛ": "r", "ꞧ": "r", "ꞃ": "r", "ⓢ": "s", "ｓ": "s", "ß": "s", "ś": "s", "ṥ": "s", "ŝ": "s", "ṡ": "s", "š": "s", "ṧ": "s", "ṣ": "s", "ṩ": "s", "ș": "s", "ş": "s", "ȿ": "s", "ꞩ": "s", "ꞅ": "s", "ẛ": "s", "ⓣ": "t", "ｔ": "t", "ṫ": "t", "ẗ": "t", "ť": "t", "ṭ": "t", "ț": "t", "ţ": "t", "ṱ": "t", "ṯ": "t", "ŧ": "t", "ƭ": "t", "ʈ": "t", "ⱦ": "t", "ꞇ": "t", "ꜩ": "tz", "ⓤ": "u", "ｕ": "u", "ù": "u", "ú": "u", "û": "u", "ũ": "u", "ṹ": "u", "ū": "u", "ṻ": "u", "ŭ": "u", "ü": "u", "ǜ": "u", "ǘ": "u", "ǖ": "u", "ǚ": "u", "ủ": "u", "ů": "u", "ű": "u", "ǔ": "u", "ȕ": "u", "ȗ": "u", "ư": "u", "ừ": "u", "ứ": "u", "ữ": "u", "ử": "u", "ự": "u", "ụ": "u", "ṳ": "u", "ų": "u", "ṷ": "u", "ṵ": "u", "ʉ": "u", "ⓥ": "v", "ｖ": "v", "ṽ": "v", "ṿ": "v", "ʋ": "v", "ꝟ": "v", "ʌ": "v", "ꝡ": "vy", "ⓦ": "w", "ｗ": "w", "ẁ": "w", "ẃ": "w", "ŵ": "w", "ẇ": "w", "ẅ": "w", "ẘ": "w", "ẉ": "w", "ⱳ": "w", "ⓧ": "x", "ｘ": "x", "ẋ": "x", "ẍ": "x", "ⓨ": "y", "ｙ": "y", "ỳ": "y", "ý": "y", "ŷ": "y", "ỹ": "y", "ȳ": "y", "ẏ": "y", "ÿ": "y", "ỷ": "y", "ẙ": "y", "ỵ": "y", "ƴ": "y", "ɏ": "y", "ỿ": "y", "ⓩ": "z", "ｚ": "z", "ź": "z", "ẑ": "z", "ż": "z", "ž": "z", "ẓ": "z", "ẕ": "z", "ƶ": "z", "ȥ": "z", "ɀ": "z", "ⱬ": "z", "ꝣ": "z", "Ά": "Α", "Έ": "Ε", "Ή": "Η", "Ί": "Ι", "Ϊ": "Ι", "Ό": "Ο", "Ύ": "Υ", "Ϋ": "Υ", "Ώ": "Ω", "ά": "α", "έ": "ε", "ή": "η", "ί": "ι", "ϊ": "ι", "ΐ": "ι", "ό": "ο", "ύ": "υ", "ϋ": "υ", "ΰ": "υ", "ώ": "ω", "ς": "σ", "’": "'" };
    }), e.define("select2/data/base", ["../utils"], function (r) {
      function n(e, t) {
        n.__super__.constructor.call(this);
      }return r.Extend(n, r.Observable), n.prototype.current = function (e) {
        throw new Error("The `current` method must be defined in child classes.");
      }, n.prototype.query = function (e, t) {
        throw new Error("The `query` method must be defined in child classes.");
      }, n.prototype.bind = function (e, t) {}, n.prototype.destroy = function () {}, n.prototype.generateResultId = function (e, t) {
        var n = e.id + "-result-";return n += r.generateChars(4), null != t.id ? n += "-" + t.id.toString() : n += "-" + r.generateChars(4), n;
      }, n;
    }), e.define("select2/data/select", ["./base", "../utils", "jquery"], function (e, a, l) {
      function n(e, t) {
        this.$element = e, this.options = t, n.__super__.constructor.call(this);
      }return a.Extend(n, e), n.prototype.current = function (e) {
        var n = [],
            r = this;this.$element.find(":selected").each(function () {
          var e = l(this),
              t = r.item(e);n.push(t);
        }), e(n);
      }, n.prototype.select = function (i) {
        var o = this;if (i.selected = !0, l(i.element).is("option")) return i.element.selected = !0, void this.$element.trigger("input").trigger("change");if (this.$element.prop("multiple")) this.current(function (e) {
          var t = [];(i = [i]).push.apply(i, e);for (var n = 0; n < i.length; n++) {
            var r = i[n].id;-1 === l.inArray(r, t) && t.push(r);
          }o.$element.val(t), o.$element.trigger("input").trigger("change");
        });else {
          var e = i.id;this.$element.val(e), this.$element.trigger("input").trigger("change");
        }
      }, n.prototype.unselect = function (i) {
        var o = this;if (this.$element.prop("multiple")) {
          if (i.selected = !1, l(i.element).is("option")) return i.element.selected = !1, void this.$element.trigger("input").trigger("change");this.current(function (e) {
            for (var t = [], n = 0; n < e.length; n++) {
              var r = e[n].id;r !== i.id && -1 === l.inArray(r, t) && t.push(r);
            }o.$element.val(t), o.$element.trigger("input").trigger("change");
          });
        }
      }, n.prototype.bind = function (e, t) {
        var n = this;(this.container = e).on("select", function (e) {
          n.select(e.data);
        }), e.on("unselect", function (e) {
          n.unselect(e.data);
        });
      }, n.prototype.destroy = function () {
        this.$element.find("*").each(function () {
          a.RemoveData(this);
        });
      }, n.prototype.query = function (r, e) {
        var i = [],
            o = this;this.$element.children().each(function () {
          var e = l(this);if (e.is("option") || e.is("optgroup")) {
            var t = o.item(e),
                n = o.matches(r, t);null !== n && i.push(n);
          }
        }), e({ results: i });
      }, n.prototype.addOptions = function (e) {
        a.appendMany(this.$element, e);
      }, n.prototype.option = function (e) {
        var t;e.children ? (t = document.createElement("optgroup")).label = e.text : void 0 !== (t = document.createElement("option")).textContent ? t.textContent = e.text : t.innerText = e.text, void 0 !== e.id && (t.value = e.id), e.disabled && (t.disabled = !0), e.selected && (t.selected = !0), e.title && (t.title = e.title);var n = l(t),
            r = this._normalizeItem(e);return r.element = t, a.StoreData(t, "data", r), n;
      }, n.prototype.item = function (e) {
        var t = {};if (null != (t = a.GetData(e[0], "data"))) return t;if (e.is("option")) t = { id: e.val(), text: e.text(), disabled: e.prop("disabled"), selected: e.prop("selected"), title: e.prop("title") };else if (e.is("optgroup")) {
          t = { text: e.prop("label"), children: [], title: e.prop("title") };for (var n = e.children("option"), r = [], i = 0; i < n.length; i++) {
            var o = l(n[i]),
                s = this.item(o);r.push(s);
          }t.children = r;
        }return (t = this._normalizeItem(t)).element = e[0], a.StoreData(e[0], "data", t), t;
      }, n.prototype._normalizeItem = function (e) {
        e !== Object(e) && (e = { id: e, text: e });return null != (e = l.extend({}, { text: "" }, e)).id && (e.id = e.id.toString()), null != e.text && (e.text = e.text.toString()), null == e._resultId && e.id && null != this.container && (e._resultId = this.generateResultId(this.container, e)), l.extend({}, { selected: !1, disabled: !1 }, e);
      }, n.prototype.matches = function (e, t) {
        return this.options.get("matcher")(e, t);
      }, n;
    }), e.define("select2/data/array", ["./select", "../utils", "jquery"], function (e, f, g) {
      function r(e, t) {
        this._dataToConvert = t.get("data") || [], r.__super__.constructor.call(this, e, t);
      }return f.Extend(r, e), r.prototype.bind = function (e, t) {
        r.__super__.bind.call(this, e, t), this.addOptions(this.convertToOptions(this._dataToConvert));
      }, r.prototype.select = function (n) {
        var e = this.$element.find("option").filter(function (e, t) {
          return t.value == n.id.toString();
        });0 === e.length && (e = this.option(n), this.addOptions(e)), r.__super__.select.call(this, n);
      }, r.prototype.convertToOptions = function (e) {
        var t = this,
            n = this.$element.find("option"),
            r = n.map(function () {
          return t.item(g(this)).id;
        }).get(),
            i = [];function o(e) {
          return function () {
            return g(this).val() == e.id;
          };
        }for (var s = 0; s < e.length; s++) {
          var a = this._normalizeItem(e[s]);if (0 <= g.inArray(a.id, r)) {
            var l = n.filter(o(a)),
                c = this.item(l),
                u = g.extend(!0, {}, a, c),
                d = this.option(u);l.replaceWith(d);
          } else {
            var p = this.option(a);if (a.children) {
              var h = this.convertToOptions(a.children);f.appendMany(p, h);
            }i.push(p);
          }
        }return i;
      }, r;
    }), e.define("select2/data/ajax", ["./array", "../utils", "jquery"], function (e, t, o) {
      function n(e, t) {
        this.ajaxOptions = this._applyDefaults(t.get("ajax")), null != this.ajaxOptions.processResults && (this.processResults = this.ajaxOptions.processResults), n.__super__.constructor.call(this, e, t);
      }return t.Extend(n, e), n.prototype._applyDefaults = function (e) {
        var t = { data: function data(e) {
            return o.extend({}, e, { q: e.term });
          }, transport: function transport(e, t, n) {
            var r = o.ajax(e);return r.then(t), r.fail(n), r;
          } };return o.extend({}, t, e, !0);
      }, n.prototype.processResults = function (e) {
        return e;
      }, n.prototype.query = function (n, r) {
        var i = this;null != this._request && (o.isFunction(this._request.abort) && this._request.abort(), this._request = null);var t = o.extend({ type: "GET" }, this.ajaxOptions);function e() {
          var e = t.transport(t, function (e) {
            var t = i.processResults(e, n);i.options.get("debug") && window.console && console.error && (t && t.results && o.isArray(t.results) || console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")), r(t);
          }, function () {
            "status" in e && (0 === e.status || "0" === e.status) || i.trigger("results:message", { message: "errorLoading" });
          });i._request = e;
        }"function" == typeof t.url && (t.url = t.url.call(this.$element, n)), "function" == typeof t.data && (t.data = t.data.call(this.$element, n)), this.ajaxOptions.delay && null != n.term ? (this._queryTimeout && window.clearTimeout(this._queryTimeout), this._queryTimeout = window.setTimeout(e, this.ajaxOptions.delay)) : e();
      }, n;
    }), e.define("select2/data/tags", ["jquery"], function (u) {
      function e(e, t, n) {
        var r = n.get("tags"),
            i = n.get("createTag");void 0 !== i && (this.createTag = i);var o = n.get("insertTag");if (void 0 !== o && (this.insertTag = o), e.call(this, t, n), u.isArray(r)) for (var s = 0; s < r.length; s++) {
          var a = r[s],
              l = this._normalizeItem(a),
              c = this.option(l);this.$element.append(c);
        }
      }return e.prototype.query = function (e, c, u) {
        var d = this;this._removeOldTags(), null != c.term && null == c.page ? e.call(this, c, function e(t, n) {
          for (var r = t.results, i = 0; i < r.length; i++) {
            var o = r[i],
                s = null != o.children && !e({ results: o.children }, !0);if ((o.text || "").toUpperCase() === (c.term || "").toUpperCase() || s) return !n && (t.data = r, void u(t));
          }if (n) return !0;var a = d.createTag(c);if (null != a) {
            var l = d.option(a);l.attr("data-select2-tag", !0), d.addOptions([l]), d.insertTag(r, a);
          }t.results = r, u(t);
        }) : e.call(this, c, u);
      }, e.prototype.createTag = function (e, t) {
        var n = u.trim(t.term);return "" === n ? null : { id: n, text: n };
      }, e.prototype.insertTag = function (e, t, n) {
        t.unshift(n);
      }, e.prototype._removeOldTags = function (e) {
        this.$element.find("option[data-select2-tag]").each(function () {
          this.selected || u(this).remove();
        });
      }, e;
    }), e.define("select2/data/tokenizer", ["jquery"], function (d) {
      function e(e, t, n) {
        var r = n.get("tokenizer");void 0 !== r && (this.tokenizer = r), e.call(this, t, n);
      }return e.prototype.bind = function (e, t, n) {
        e.call(this, t, n), this.$search = t.dropdown.$search || t.selection.$search || n.find(".select2-search__field");
      }, e.prototype.query = function (e, t, n) {
        var i = this;t.term = t.term || "";var r = this.tokenizer(t, this.options, function (e) {
          var t,
              n = i._normalizeItem(e);if (!i.$element.find("option").filter(function () {
            return d(this).val() === n.id;
          }).length) {
            var r = i.option(n);r.attr("data-select2-tag", !0), i._removeOldTags(), i.addOptions([r]);
          }t = n, i.trigger("select", { data: t });
        });r.term !== t.term && (this.$search.length && (this.$search.val(r.term), this.$search.trigger("focus")), t.term = r.term), e.call(this, t, n);
      }, e.prototype.tokenizer = function (e, t, n, r) {
        for (var i = n.get("tokenSeparators") || [], o = t.term, s = 0, a = this.createTag || function (e) {
          return { id: e.term, text: e.term };
        }; s < o.length;) {
          var l = o[s];if (-1 !== d.inArray(l, i)) {
            var c = o.substr(0, s),
                u = a(d.extend({}, t, { term: c }));null != u ? (r(u), o = o.substr(s + 1) || "", s = 0) : s++;
          } else s++;
        }return { term: o };
      }, e;
    }), e.define("select2/data/minimumInputLength", [], function () {
      function e(e, t, n) {
        this.minimumInputLength = n.get("minimumInputLength"), e.call(this, t, n);
      }return e.prototype.query = function (e, t, n) {
        t.term = t.term || "", t.term.length < this.minimumInputLength ? this.trigger("results:message", { message: "inputTooShort", args: { minimum: this.minimumInputLength, input: t.term, params: t } }) : e.call(this, t, n);
      }, e;
    }), e.define("select2/data/maximumInputLength", [], function () {
      function e(e, t, n) {
        this.maximumInputLength = n.get("maximumInputLength"), e.call(this, t, n);
      }return e.prototype.query = function (e, t, n) {
        t.term = t.term || "", 0 < this.maximumInputLength && t.term.length > this.maximumInputLength ? this.trigger("results:message", { message: "inputTooLong", args: { maximum: this.maximumInputLength, input: t.term, params: t } }) : e.call(this, t, n);
      }, e;
    }), e.define("select2/data/maximumSelectionLength", [], function () {
      function e(e, t, n) {
        this.maximumSelectionLength = n.get("maximumSelectionLength"), e.call(this, t, n);
      }return e.prototype.bind = function (e, t, n) {
        var r = this;e.call(this, t, n), t.on("select", function () {
          r._checkIfMaximumSelected();
        });
      }, e.prototype.query = function (e, t, n) {
        var r = this;this._checkIfMaximumSelected(function () {
          e.call(r, t, n);
        });
      }, e.prototype._checkIfMaximumSelected = function (e, n) {
        var r = this;this.current(function (e) {
          var t = null != e ? e.length : 0;0 < r.maximumSelectionLength && t >= r.maximumSelectionLength ? r.trigger("results:message", { message: "maximumSelected", args: { maximum: r.maximumSelectionLength } }) : n && n();
        });
      }, e;
    }), e.define("select2/dropdown", ["jquery", "./utils"], function (t, e) {
      function n(e, t) {
        this.$element = e, this.options = t, n.__super__.constructor.call(this);
      }return e.Extend(n, e.Observable), n.prototype.render = function () {
        var e = t('<span class="select2-dropdown"><span class="select2-results"></span></span>');return e.attr("dir", this.options.get("dir")), this.$dropdown = e;
      }, n.prototype.bind = function () {}, n.prototype.position = function (e, t) {}, n.prototype.destroy = function () {
        this.$dropdown.remove();
      }, n;
    }), e.define("select2/dropdown/search", ["jquery", "../utils"], function (o, e) {
      function t() {}return t.prototype.render = function (e) {
        var t = e.call(this),
            n = o('<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></span>');return this.$searchContainer = n, this.$search = n.find("input"), t.prepend(n), t;
      }, t.prototype.bind = function (e, t, n) {
        var r = this,
            i = t.id + "-results";e.call(this, t, n), this.$search.on("keydown", function (e) {
          r.trigger("keypress", e), r._keyUpPrevented = e.isDefaultPrevented();
        }), this.$search.on("input", function (e) {
          o(this).off("keyup");
        }), this.$search.on("keyup input", function (e) {
          r.handleSearch(e);
        }), t.on("open", function () {
          r.$search.attr("tabindex", 0), r.$search.attr("aria-controls", i), r.$search.trigger("focus"), window.setTimeout(function () {
            r.$search.trigger("focus");
          }, 0);
        }), t.on("close", function () {
          r.$search.attr("tabindex", -1), r.$search.removeAttr("aria-controls"), r.$search.removeAttr("aria-activedescendant"), r.$search.val(""), r.$search.trigger("blur");
        }), t.on("focus", function () {
          t.isOpen() || r.$search.trigger("focus");
        }), t.on("results:all", function (e) {
          null != e.query.term && "" !== e.query.term || (r.showSearch(e) ? r.$searchContainer.removeClass("select2-search--hide") : r.$searchContainer.addClass("select2-search--hide"));
        }), t.on("results:focus", function (e) {
          e.data._resultId ? r.$search.attr("aria-activedescendant", e.data._resultId) : r.$search.removeAttr("aria-activedescendant");
        });
      }, t.prototype.handleSearch = function (e) {
        if (!this._keyUpPrevented) {
          var t = this.$search.val();this.trigger("query", { term: t });
        }this._keyUpPrevented = !1;
      }, t.prototype.showSearch = function (e, t) {
        return !0;
      }, t;
    }), e.define("select2/dropdown/hidePlaceholder", [], function () {
      function e(e, t, n, r) {
        this.placeholder = this.normalizePlaceholder(n.get("placeholder")), e.call(this, t, n, r);
      }return e.prototype.append = function (e, t) {
        t.results = this.removePlaceholder(t.results), e.call(this, t);
      }, e.prototype.normalizePlaceholder = function (e, t) {
        return "string" == typeof t && (t = { id: "", text: t }), t;
      }, e.prototype.removePlaceholder = function (e, t) {
        for (var n = t.slice(0), r = t.length - 1; 0 <= r; r--) {
          var i = t[r];this.placeholder.id === i.id && n.splice(r, 1);
        }return n;
      }, e;
    }), e.define("select2/dropdown/infiniteScroll", ["jquery"], function (n) {
      function e(e, t, n, r) {
        this.lastParams = {}, e.call(this, t, n, r), this.$loadingMore = this.createLoadingMore(), this.loading = !1;
      }return e.prototype.append = function (e, t) {
        this.$loadingMore.remove(), this.loading = !1, e.call(this, t), this.showLoadingMore(t) && (this.$results.append(this.$loadingMore), this.loadMoreIfNeeded());
      }, e.prototype.bind = function (e, t, n) {
        var r = this;e.call(this, t, n), t.on("query", function (e) {
          r.lastParams = e, r.loading = !0;
        }), t.on("query:append", function (e) {
          r.lastParams = e, r.loading = !0;
        }), this.$results.on("scroll", this.loadMoreIfNeeded.bind(this));
      }, e.prototype.loadMoreIfNeeded = function () {
        var e = n.contains(document.documentElement, this.$loadingMore[0]);if (!this.loading && e) {
          var t = this.$results.offset().top + this.$results.outerHeight(!1);this.$loadingMore.offset().top + this.$loadingMore.outerHeight(!1) <= t + 50 && this.loadMore();
        }
      }, e.prototype.loadMore = function () {
        this.loading = !0;var e = n.extend({}, { page: 1 }, this.lastParams);e.page++, this.trigger("query:append", e);
      }, e.prototype.showLoadingMore = function (e, t) {
        return t.pagination && t.pagination.more;
      }, e.prototype.createLoadingMore = function () {
        var e = n('<li class="select2-results__option select2-results__option--load-more"role="option" aria-disabled="true"></li>'),
            t = this.options.get("translations").get("loadingMore");return e.html(t(this.lastParams)), e;
      }, e;
    }), e.define("select2/dropdown/attachBody", ["jquery", "../utils"], function (f, a) {
      function e(e, t, n) {
        this.$dropdownParent = f(n.get("dropdownParent") || document.body), e.call(this, t, n);
      }return e.prototype.bind = function (e, t, n) {
        var r = this;e.call(this, t, n), t.on("open", function () {
          r._showDropdown(), r._attachPositioningHandler(t), r._bindContainerResultHandlers(t);
        }), t.on("close", function () {
          r._hideDropdown(), r._detachPositioningHandler(t);
        }), this.$dropdownContainer.on("mousedown", function (e) {
          e.stopPropagation();
        });
      }, e.prototype.destroy = function (e) {
        e.call(this), this.$dropdownContainer.remove();
      }, e.prototype.position = function (e, t, n) {
        t.attr("class", n.attr("class")), t.removeClass("select2"), t.addClass("select2-container--open"), t.css({ position: "absolute", top: -999999 }), this.$container = n;
      }, e.prototype.render = function (e) {
        var t = f("<span></span>"),
            n = e.call(this);return t.append(n), this.$dropdownContainer = t;
      }, e.prototype._hideDropdown = function (e) {
        this.$dropdownContainer.detach();
      }, e.prototype._bindContainerResultHandlers = function (e, t) {
        if (!this._containerResultsHandlersBound) {
          var n = this;t.on("results:all", function () {
            n._positionDropdown(), n._resizeDropdown();
          }), t.on("results:append", function () {
            n._positionDropdown(), n._resizeDropdown();
          }), t.on("results:message", function () {
            n._positionDropdown(), n._resizeDropdown();
          }), t.on("select", function () {
            n._positionDropdown(), n._resizeDropdown();
          }), t.on("unselect", function () {
            n._positionDropdown(), n._resizeDropdown();
          }), this._containerResultsHandlersBound = !0;
        }
      }, e.prototype._attachPositioningHandler = function (e, t) {
        var n = this,
            r = "scroll.select2." + t.id,
            i = "resize.select2." + t.id,
            o = "orientationchange.select2." + t.id,
            s = this.$container.parents().filter(a.hasScroll);s.each(function () {
          a.StoreData(this, "select2-scroll-position", { x: f(this).scrollLeft(), y: f(this).scrollTop() });
        }), s.on(r, function (e) {
          var t = a.GetData(this, "select2-scroll-position");f(this).scrollTop(t.y);
        }), f(window).on(r + " " + i + " " + o, function (e) {
          n._positionDropdown(), n._resizeDropdown();
        });
      }, e.prototype._detachPositioningHandler = function (e, t) {
        var n = "scroll.select2." + t.id,
            r = "resize.select2." + t.id,
            i = "orientationchange.select2." + t.id;this.$container.parents().filter(a.hasScroll).off(n), f(window).off(n + " " + r + " " + i);
      }, e.prototype._positionDropdown = function () {
        var e = f(window),
            t = this.$dropdown.hasClass("select2-dropdown--above"),
            n = this.$dropdown.hasClass("select2-dropdown--below"),
            r = null,
            i = this.$container.offset();i.bottom = i.top + this.$container.outerHeight(!1);var o = { height: this.$container.outerHeight(!1) };o.top = i.top, o.bottom = i.top + o.height;var s = this.$dropdown.outerHeight(!1),
            a = e.scrollTop(),
            l = e.scrollTop() + e.height(),
            c = a < i.top - s,
            u = l > i.bottom + s,
            d = { left: i.left, top: o.bottom },
            p = this.$dropdownParent;"static" === p.css("position") && (p = p.offsetParent());var h = { top: 0, left: 0 };(f.contains(document.body, p[0]) || p[0].isConnected) && (h = p.offset()), d.top -= h.top, d.left -= h.left, t || n || (r = "below"), u || !c || t ? !c && u && t && (r = "below") : r = "above", ("above" == r || t && "below" !== r) && (d.top = o.top - h.top - s), null != r && (this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--" + r), this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--" + r)), this.$dropdownContainer.css(d);
      }, e.prototype._resizeDropdown = function () {
        var e = { width: this.$container.outerWidth(!1) + "px" };this.options.get("dropdownAutoWidth") && (e.minWidth = e.width, e.position = "relative", e.width = "auto"), this.$dropdown.css(e);
      }, e.prototype._showDropdown = function (e) {
        this.$dropdownContainer.appendTo(this.$dropdownParent), this._positionDropdown(), this._resizeDropdown();
      }, e;
    }), e.define("select2/dropdown/minimumResultsForSearch", [], function () {
      function e(e, t, n, r) {
        this.minimumResultsForSearch = n.get("minimumResultsForSearch"), this.minimumResultsForSearch < 0 && (this.minimumResultsForSearch = 1 / 0), e.call(this, t, n, r);
      }return e.prototype.showSearch = function (e, t) {
        return !(function e(t) {
          for (var n = 0, r = 0; r < t.length; r++) {
            var i = t[r];i.children ? n += e(i.children) : n++;
          }return n;
        }(t.data.results) < this.minimumResultsForSearch) && e.call(this, t);
      }, e;
    }), e.define("select2/dropdown/selectOnClose", ["../utils"], function (o) {
      function e() {}return e.prototype.bind = function (e, t, n) {
        var r = this;e.call(this, t, n), t.on("close", function (e) {
          r._handleSelectOnClose(e);
        });
      }, e.prototype._handleSelectOnClose = function (e, t) {
        if (t && null != t.originalSelect2Event) {
          var n = t.originalSelect2Event;if ("select" === n._type || "unselect" === n._type) return;
        }var r = this.getHighlightedResults();if (!(r.length < 1)) {
          var i = o.GetData(r[0], "data");null != i.element && i.element.selected || null == i.element && i.selected || this.trigger("select", { data: i });
        }
      }, e;
    }), e.define("select2/dropdown/closeOnSelect", [], function () {
      function e() {}return e.prototype.bind = function (e, t, n) {
        var r = this;e.call(this, t, n), t.on("select", function (e) {
          r._selectTriggered(e);
        }), t.on("unselect", function (e) {
          r._selectTriggered(e);
        });
      }, e.prototype._selectTriggered = function (e, t) {
        var n = t.originalEvent;n && (n.ctrlKey || n.metaKey) || this.trigger("close", { originalEvent: n, originalSelect2Event: t });
      }, e;
    }), e.define("select2/i18n/en", [], function () {
      return { errorLoading: function errorLoading() {
          return "The results could not be loaded.";
        }, inputTooLong: function inputTooLong(e) {
          var t = e.input.length - e.maximum,
              n = "Please delete " + t + " character";return 1 != t && (n += "s"), n;
        }, inputTooShort: function inputTooShort(e) {
          return "Please enter " + (e.minimum - e.input.length) + " or more characters";
        }, loadingMore: function loadingMore() {
          return "Loading more results…";
        }, maximumSelected: function maximumSelected(e) {
          var t = "You can only select " + e.maximum + " item";return 1 != e.maximum && (t += "s"), t;
        }, noResults: function noResults() {
          return "No results found";
        }, searching: function searching() {
          return "Searching…";
        }, removeAllItems: function removeAllItems() {
          return "Remove all items";
        } };
    }), e.define("select2/defaults", ["jquery", "require", "./results", "./selection/single", "./selection/multiple", "./selection/placeholder", "./selection/allowClear", "./selection/search", "./selection/eventRelay", "./utils", "./translation", "./diacritics", "./data/select", "./data/array", "./data/ajax", "./data/tags", "./data/tokenizer", "./data/minimumInputLength", "./data/maximumInputLength", "./data/maximumSelectionLength", "./dropdown", "./dropdown/search", "./dropdown/hidePlaceholder", "./dropdown/infiniteScroll", "./dropdown/attachBody", "./dropdown/minimumResultsForSearch", "./dropdown/selectOnClose", "./dropdown/closeOnSelect", "./i18n/en"], function (c, u, d, p, h, f, g, m, v, y, s, t, _, $, b, w, A, x, D, S, E, C, O, T, q, L, I, j, e) {
      function n() {
        this.reset();
      }return n.prototype.apply = function (e) {
        if (null == (e = c.extend(!0, {}, this.defaults, e)).dataAdapter) {
          if (null != e.ajax ? e.dataAdapter = b : null != e.data ? e.dataAdapter = $ : e.dataAdapter = _, 0 < e.minimumInputLength && (e.dataAdapter = y.Decorate(e.dataAdapter, x)), 0 < e.maximumInputLength && (e.dataAdapter = y.Decorate(e.dataAdapter, D)), 0 < e.maximumSelectionLength && (e.dataAdapter = y.Decorate(e.dataAdapter, S)), e.tags && (e.dataAdapter = y.Decorate(e.dataAdapter, w)), null == e.tokenSeparators && null == e.tokenizer || (e.dataAdapter = y.Decorate(e.dataAdapter, A)), null != e.query) {
            var t = u(e.amdBase + "compat/query");e.dataAdapter = y.Decorate(e.dataAdapter, t);
          }if (null != e.initSelection) {
            var n = u(e.amdBase + "compat/initSelection");e.dataAdapter = y.Decorate(e.dataAdapter, n);
          }
        }if (null == e.resultsAdapter && (e.resultsAdapter = d, null != e.ajax && (e.resultsAdapter = y.Decorate(e.resultsAdapter, T)), null != e.placeholder && (e.resultsAdapter = y.Decorate(e.resultsAdapter, O)), e.selectOnClose && (e.resultsAdapter = y.Decorate(e.resultsAdapter, I))), null == e.dropdownAdapter) {
          if (e.multiple) e.dropdownAdapter = E;else {
            var r = y.Decorate(E, C);e.dropdownAdapter = r;
          }if (0 !== e.minimumResultsForSearch && (e.dropdownAdapter = y.Decorate(e.dropdownAdapter, L)), e.closeOnSelect && (e.dropdownAdapter = y.Decorate(e.dropdownAdapter, j)), null != e.dropdownCssClass || null != e.dropdownCss || null != e.adaptDropdownCssClass) {
            var i = u(e.amdBase + "compat/dropdownCss");e.dropdownAdapter = y.Decorate(e.dropdownAdapter, i);
          }e.dropdownAdapter = y.Decorate(e.dropdownAdapter, q);
        }if (null == e.selectionAdapter) {
          if (e.multiple ? e.selectionAdapter = h : e.selectionAdapter = p, null != e.placeholder && (e.selectionAdapter = y.Decorate(e.selectionAdapter, f)), e.allowClear && (e.selectionAdapter = y.Decorate(e.selectionAdapter, g)), e.multiple && (e.selectionAdapter = y.Decorate(e.selectionAdapter, m)), null != e.containerCssClass || null != e.containerCss || null != e.adaptContainerCssClass) {
            var o = u(e.amdBase + "compat/containerCss");e.selectionAdapter = y.Decorate(e.selectionAdapter, o);
          }e.selectionAdapter = y.Decorate(e.selectionAdapter, v);
        }e.language = this._resolveLanguage(e.language), e.language.push("en");for (var s = [], a = 0; a < e.language.length; a++) {
          var l = e.language[a];-1 === s.indexOf(l) && s.push(l);
        }return e.language = s, e.translations = this._processTranslations(e.language, e.debug), e;
      }, n.prototype.reset = function () {
        function a(e) {
          return e.replace(/[^\u0000-\u007E]/g, function (e) {
            return t[e] || e;
          });
        }this.defaults = { amdBase: "./", amdLanguageBase: "./i18n/", closeOnSelect: !0, debug: !1, dropdownAutoWidth: !1, escapeMarkup: y.escapeMarkup, language: {}, matcher: function e(t, n) {
            if ("" === c.trim(t.term)) return n;if (n.children && 0 < n.children.length) {
              for (var r = c.extend(!0, {}, n), i = n.children.length - 1; 0 <= i; i--) {
                null == e(t, n.children[i]) && r.children.splice(i, 1);
              }return 0 < r.children.length ? r : e(t, r);
            }var o = a(n.text).toUpperCase(),
                s = a(t.term).toUpperCase();return -1 < o.indexOf(s) ? n : null;
          }, minimumInputLength: 0, maximumInputLength: 0, maximumSelectionLength: 0, minimumResultsForSearch: 0, selectOnClose: !1, scrollAfterSelect: !1, sorter: function sorter(e) {
            return e;
          }, templateResult: function templateResult(e) {
            return e.text;
          }, templateSelection: function templateSelection(e) {
            return e.text;
          }, theme: "default", width: "resolve" };
      }, n.prototype.applyFromElement = function (e, t) {
        var n = e.language,
            r = this.defaults.language,
            i = t.prop("lang"),
            o = t.closest("[lang]").prop("lang"),
            s = Array.prototype.concat.call(this._resolveLanguage(i), this._resolveLanguage(n), this._resolveLanguage(r), this._resolveLanguage(o));return e.language = s, e;
      }, n.prototype._resolveLanguage = function (e) {
        if (!e) return [];if (c.isEmptyObject(e)) return [];if (c.isPlainObject(e)) return [e];var t;t = c.isArray(e) ? e : [e];for (var n = [], r = 0; r < t.length; r++) {
          if (n.push(t[r]), "string" == typeof t[r] && 0 < t[r].indexOf("-")) {
            var i = t[r].split("-")[0];n.push(i);
          }
        }return n;
      }, n.prototype._processTranslations = function (e, t) {
        for (var n = new s(), r = 0; r < e.length; r++) {
          var i = new s(),
              o = e[r];if ("string" == typeof o) try {
            i = s.loadPath(o);
          } catch (e) {
            try {
              o = this.defaults.amdLanguageBase + o, i = s.loadPath(o);
            } catch (e) {
              t && window.console && console.warn && console.warn('Select2: The language file for "' + o + '" could not be automatically loaded. A fallback will be used instead.');
            }
          } else i = c.isPlainObject(o) ? new s(o) : o;n.extend(i);
        }return n;
      }, n.prototype.set = function (e, t) {
        var n = {};n[c.camelCase(e)] = t;var r = y._convertData(n);c.extend(!0, this.defaults, r);
      }, new n();
    }), e.define("select2/options", ["require", "jquery", "./defaults", "./utils"], function (r, d, i, p) {
      function e(e, t) {
        if (this.options = e, null != t && this.fromElement(t), null != t && (this.options = i.applyFromElement(this.options, t)), this.options = i.apply(this.options), t && t.is("input")) {
          var n = r(this.get("amdBase") + "compat/inputData");this.options.dataAdapter = p.Decorate(this.options.dataAdapter, n);
        }
      }return e.prototype.fromElement = function (e) {
        var t = ["select2"];null == this.options.multiple && (this.options.multiple = e.prop("multiple")), null == this.options.disabled && (this.options.disabled = e.prop("disabled")), null == this.options.dir && (e.prop("dir") ? this.options.dir = e.prop("dir") : e.closest("[dir]").prop("dir") ? this.options.dir = e.closest("[dir]").prop("dir") : this.options.dir = "ltr"), e.prop("disabled", this.options.disabled), e.prop("multiple", this.options.multiple), p.GetData(e[0], "select2Tags") && (this.options.debug && window.console && console.warn && console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'), p.StoreData(e[0], "data", p.GetData(e[0], "select2Tags")), p.StoreData(e[0], "tags", !0)), p.GetData(e[0], "ajaxUrl") && (this.options.debug && window.console && console.warn && console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."), e.attr("ajax--url", p.GetData(e[0], "ajaxUrl")), p.StoreData(e[0], "ajax-Url", p.GetData(e[0], "ajaxUrl")));var n = {};function r(e, t) {
          return t.toUpperCase();
        }for (var i = 0; i < e[0].attributes.length; i++) {
          var o = e[0].attributes[i].name,
              s = "data-";if (o.substr(0, s.length) == s) {
            var a = o.substring(s.length),
                l = p.GetData(e[0], a);n[a.replace(/-([a-z])/g, r)] = l;
          }
        }d.fn.jquery && "1." == d.fn.jquery.substr(0, 2) && e[0].dataset && (n = d.extend(!0, {}, e[0].dataset, n));var c = d.extend(!0, {}, p.GetData(e[0]), n);for (var u in c = p._convertData(c)) {
          -1 < d.inArray(u, t) || (d.isPlainObject(this.options[u]) ? d.extend(this.options[u], c[u]) : this.options[u] = c[u]);
        }return this;
      }, e.prototype.get = function (e) {
        return this.options[e];
      }, e.prototype.set = function (e, t) {
        this.options[e] = t;
      }, e;
    }), e.define("select2/core", ["jquery", "./options", "./utils", "./keys"], function (o, c, u, r) {
      var d = function d(e, t) {
        null != u.GetData(e[0], "select2") && u.GetData(e[0], "select2").destroy(), this.$element = e, this.id = this._generateId(e), t = t || {}, this.options = new c(t, e), d.__super__.constructor.call(this);var n = e.attr("tabindex") || 0;u.StoreData(e[0], "old-tabindex", n), e.attr("tabindex", "-1");var r = this.options.get("dataAdapter");this.dataAdapter = new r(e, this.options);var i = this.render();this._placeContainer(i);var o = this.options.get("selectionAdapter");this.selection = new o(e, this.options), this.$selection = this.selection.render(), this.selection.position(this.$selection, i);var s = this.options.get("dropdownAdapter");this.dropdown = new s(e, this.options), this.$dropdown = this.dropdown.render(), this.dropdown.position(this.$dropdown, i);var a = this.options.get("resultsAdapter");this.results = new a(e, this.options, this.dataAdapter), this.$results = this.results.render(), this.results.position(this.$results, this.$dropdown);var l = this;this._bindAdapters(), this._registerDomEvents(), this._registerDataEvents(), this._registerSelectionEvents(), this._registerDropdownEvents(), this._registerResultsEvents(), this._registerEvents(), this.dataAdapter.current(function (e) {
          l.trigger("selection:update", { data: e });
        }), e.addClass("select2-hidden-accessible"), e.attr("aria-hidden", "true"), this._syncAttributes(), u.StoreData(e[0], "select2", this), e.data("select2", this);
      };return u.Extend(d, u.Observable), d.prototype._generateId = function (e) {
        return "select2-" + (null != e.attr("id") ? e.attr("id") : null != e.attr("name") ? e.attr("name") + "-" + u.generateChars(2) : u.generateChars(4)).replace(/(:|\.|\[|\]|,)/g, "");
      }, d.prototype._placeContainer = function (e) {
        e.insertAfter(this.$element);var t = this._resolveWidth(this.$element, this.options.get("width"));null != t && e.css("width", t);
      }, d.prototype._resolveWidth = function (e, t) {
        var n = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;if ("resolve" == t) {
          var r = this._resolveWidth(e, "style");return null != r ? r : this._resolveWidth(e, "element");
        }if ("element" == t) {
          var i = e.outerWidth(!1);return i <= 0 ? "auto" : i + "px";
        }if ("style" != t) return "computedstyle" != t ? t : window.getComputedStyle(e[0]).width;var o = e.attr("style");if ("string" != typeof o) return null;for (var s = o.split(";"), a = 0, l = s.length; a < l; a += 1) {
          var c = s[a].replace(/\s/g, "").match(n);if (null !== c && 1 <= c.length) return c[1];
        }return null;
      }, d.prototype._bindAdapters = function () {
        this.dataAdapter.bind(this, this.$container), this.selection.bind(this, this.$container), this.dropdown.bind(this, this.$container), this.results.bind(this, this.$container);
      }, d.prototype._registerDomEvents = function () {
        var t = this;this.$element.on("change.select2", function () {
          t.dataAdapter.current(function (e) {
            t.trigger("selection:update", { data: e });
          });
        }), this.$element.on("focus.select2", function (e) {
          t.trigger("focus", e);
        }), this._syncA = u.bind(this._syncAttributes, this), this._syncS = u.bind(this._syncSubtree, this), this.$element[0].attachEvent && this.$element[0].attachEvent("onpropertychange", this._syncA);var e = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;null != e ? (this._observer = new e(function (e) {
          t._syncA(), t._syncS(null, e);
        }), this._observer.observe(this.$element[0], { attributes: !0, childList: !0, subtree: !1 })) : this.$element[0].addEventListener && (this.$element[0].addEventListener("DOMAttrModified", t._syncA, !1), this.$element[0].addEventListener("DOMNodeInserted", t._syncS, !1), this.$element[0].addEventListener("DOMNodeRemoved", t._syncS, !1));
      }, d.prototype._registerDataEvents = function () {
        var n = this;this.dataAdapter.on("*", function (e, t) {
          n.trigger(e, t);
        });
      }, d.prototype._registerSelectionEvents = function () {
        var n = this,
            r = ["toggle", "focus"];this.selection.on("toggle", function () {
          n.toggleDropdown();
        }), this.selection.on("focus", function (e) {
          n.focus(e);
        }), this.selection.on("*", function (e, t) {
          -1 === o.inArray(e, r) && n.trigger(e, t);
        });
      }, d.prototype._registerDropdownEvents = function () {
        var n = this;this.dropdown.on("*", function (e, t) {
          n.trigger(e, t);
        });
      }, d.prototype._registerResultsEvents = function () {
        var n = this;this.results.on("*", function (e, t) {
          n.trigger(e, t);
        });
      }, d.prototype._registerEvents = function () {
        var n = this;this.on("open", function () {
          n.$container.addClass("select2-container--open");
        }), this.on("close", function () {
          n.$container.removeClass("select2-container--open");
        }), this.on("enable", function () {
          n.$container.removeClass("select2-container--disabled");
        }), this.on("disable", function () {
          n.$container.addClass("select2-container--disabled");
        }), this.on("blur", function () {
          n.$container.removeClass("select2-container--focus");
        }), this.on("query", function (t) {
          n.isOpen() || n.trigger("open", {}), this.dataAdapter.query(t, function (e) {
            n.trigger("results:all", { data: e, query: t });
          });
        }), this.on("query:append", function (t) {
          this.dataAdapter.query(t, function (e) {
            n.trigger("results:append", { data: e, query: t });
          });
        }), this.on("keypress", function (e) {
          var t = e.which;n.isOpen() ? t === r.ESC || t === r.TAB || t === r.UP && e.altKey ? (n.close(e), e.preventDefault()) : t === r.ENTER ? (n.trigger("results:select", {}), e.preventDefault()) : t === r.SPACE && e.ctrlKey ? (n.trigger("results:toggle", {}), e.preventDefault()) : t === r.UP ? (n.trigger("results:previous", {}), e.preventDefault()) : t === r.DOWN && (n.trigger("results:next", {}), e.preventDefault()) : (t === r.ENTER || t === r.SPACE || t === r.DOWN && e.altKey) && (n.open(), e.preventDefault());
        });
      }, d.prototype._syncAttributes = function () {
        this.options.set("disabled", this.$element.prop("disabled")), this.isDisabled() ? (this.isOpen() && this.close(), this.trigger("disable", {})) : this.trigger("enable", {});
      }, d.prototype._isChangeMutation = function (e, t) {
        var n = !1,
            r = this;if (!e || !e.target || "OPTION" === e.target.nodeName || "OPTGROUP" === e.target.nodeName) {
          if (t) {
            if (t.addedNodes && 0 < t.addedNodes.length) for (var i = 0; i < t.addedNodes.length; i++) {
              t.addedNodes[i].selected && (n = !0);
            } else t.removedNodes && 0 < t.removedNodes.length ? n = !0 : o.isArray(t) && o.each(t, function (e, t) {
              if (r._isChangeMutation(e, t)) return !(n = !0);
            });
          } else n = !0;return n;
        }
      }, d.prototype._syncSubtree = function (e, t) {
        var n = this._isChangeMutation(e, t),
            r = this;n && this.dataAdapter.current(function (e) {
          r.trigger("selection:update", { data: e });
        });
      }, d.prototype.trigger = function (e, t) {
        var n = d.__super__.trigger,
            r = { open: "opening", close: "closing", select: "selecting", unselect: "unselecting", clear: "clearing" };if (void 0 === t && (t = {}), e in r) {
          var i = r[e],
              o = { prevented: !1, name: e, args: t };if (n.call(this, i, o), o.prevented) return void (t.prevented = !0);
        }n.call(this, e, t);
      }, d.prototype.toggleDropdown = function () {
        this.isDisabled() || (this.isOpen() ? this.close() : this.open());
      }, d.prototype.open = function () {
        this.isOpen() || this.isDisabled() || this.trigger("query", {});
      }, d.prototype.close = function (e) {
        this.isOpen() && this.trigger("close", { originalEvent: e });
      }, d.prototype.isEnabled = function () {
        return !this.isDisabled();
      }, d.prototype.isDisabled = function () {
        return this.options.get("disabled");
      }, d.prototype.isOpen = function () {
        return this.$container.hasClass("select2-container--open");
      }, d.prototype.hasFocus = function () {
        return this.$container.hasClass("select2-container--focus");
      }, d.prototype.focus = function (e) {
        this.hasFocus() || (this.$container.addClass("select2-container--focus"), this.trigger("focus", {}));
      }, d.prototype.enable = function (e) {
        this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'), null != e && 0 !== e.length || (e = [!0]);var t = !e[0];this.$element.prop("disabled", t);
      }, d.prototype.data = function () {
        this.options.get("debug") && 0 < arguments.length && window.console && console.warn && console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');var t = [];return this.dataAdapter.current(function (e) {
          t = e;
        }), t;
      }, d.prototype.val = function (e) {
        if (this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'), null == e || 0 === e.length) return this.$element.val();var t = e[0];o.isArray(t) && (t = o.map(t, function (e) {
          return e.toString();
        })), this.$element.val(t).trigger("input").trigger("change");
      }, d.prototype.destroy = function () {
        this.$container.remove(), this.$element[0].detachEvent && this.$element[0].detachEvent("onpropertychange", this._syncA), null != this._observer ? (this._observer.disconnect(), this._observer = null) : this.$element[0].removeEventListener && (this.$element[0].removeEventListener("DOMAttrModified", this._syncA, !1), this.$element[0].removeEventListener("DOMNodeInserted", this._syncS, !1), this.$element[0].removeEventListener("DOMNodeRemoved", this._syncS, !1)), this._syncA = null, this._syncS = null, this.$element.off(".select2"), this.$element.attr("tabindex", u.GetData(this.$element[0], "old-tabindex")), this.$element.removeClass("select2-hidden-accessible"), this.$element.attr("aria-hidden", "false"), u.RemoveData(this.$element[0]), this.$element.removeData("select2"), this.dataAdapter.destroy(), this.selection.destroy(), this.dropdown.destroy(), this.results.destroy(), this.dataAdapter = null, this.selection = null, this.dropdown = null, this.results = null;
      }, d.prototype.render = function () {
        var e = o('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');return e.attr("dir", this.options.get("dir")), this.$container = e, this.$container.addClass("select2-container--" + this.options.get("theme")), u.StoreData(e[0], "element", this.$element), e;
      }, d;
    }), e.define("jquery-mousewheel", ["jquery"], function (e) {
      return e;
    }), e.define("jquery.select2", ["jquery", "jquery-mousewheel", "./select2/core", "./select2/defaults", "./select2/utils"], function (i, e, o, t, s) {
      if (null == i.fn.select2) {
        var a = ["open", "close", "destroy"];i.fn.select2 = function (t) {
          if ("object" == _typeof(t = t || {})) return this.each(function () {
            var e = i.extend(!0, {}, t);new o(i(this), e);
          }), this;if ("string" != typeof t) throw new Error("Invalid arguments for Select2: " + t);var n,
              r = Array.prototype.slice.call(arguments, 1);return this.each(function () {
            var e = s.GetData(this, "select2");null == e && window.console && console.error && console.error("The select2('" + t + "') method was called on an element that is not using Select2."), n = e[t].apply(e, r);
          }), -1 < i.inArray(t, a) ? this : n;
        };
      }return null == i.fn.select2.defaults && (i.fn.select2.defaults = t), o;
    }), { define: e.define, require: e.require };
  }(),
      t = e.require("jquery.select2");return u.fn.select2.amd = e, t;
});

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 258,
	"./af.js": 258,
	"./ar": 259,
	"./ar-dz": 260,
	"./ar-dz.js": 260,
	"./ar-kw": 261,
	"./ar-kw.js": 261,
	"./ar-ly": 262,
	"./ar-ly.js": 262,
	"./ar-ma": 263,
	"./ar-ma.js": 263,
	"./ar-ps": 264,
	"./ar-ps.js": 264,
	"./ar-sa": 265,
	"./ar-sa.js": 265,
	"./ar-tn": 266,
	"./ar-tn.js": 266,
	"./ar.js": 259,
	"./az": 267,
	"./az.js": 267,
	"./be": 268,
	"./be.js": 268,
	"./bg": 269,
	"./bg.js": 269,
	"./bm": 270,
	"./bm.js": 270,
	"./bn": 271,
	"./bn-bd": 272,
	"./bn-bd.js": 272,
	"./bn.js": 271,
	"./bo": 273,
	"./bo.js": 273,
	"./br": 274,
	"./br.js": 274,
	"./bs": 275,
	"./bs.js": 275,
	"./ca": 276,
	"./ca.js": 276,
	"./cs": 277,
	"./cs.js": 277,
	"./cv": 278,
	"./cv.js": 278,
	"./cy": 279,
	"./cy.js": 279,
	"./da": 280,
	"./da.js": 280,
	"./de": 281,
	"./de-at": 282,
	"./de-at.js": 282,
	"./de-ch": 283,
	"./de-ch.js": 283,
	"./de.js": 281,
	"./dv": 284,
	"./dv.js": 284,
	"./el": 285,
	"./el.js": 285,
	"./en-au": 286,
	"./en-au.js": 286,
	"./en-ca": 287,
	"./en-ca.js": 287,
	"./en-gb": 288,
	"./en-gb.js": 288,
	"./en-ie": 289,
	"./en-ie.js": 289,
	"./en-il": 290,
	"./en-il.js": 290,
	"./en-in": 291,
	"./en-in.js": 291,
	"./en-nz": 292,
	"./en-nz.js": 292,
	"./en-sg": 293,
	"./en-sg.js": 293,
	"./eo": 294,
	"./eo.js": 294,
	"./es": 295,
	"./es-do": 296,
	"./es-do.js": 296,
	"./es-mx": 297,
	"./es-mx.js": 297,
	"./es-us": 298,
	"./es-us.js": 298,
	"./es.js": 295,
	"./et": 299,
	"./et.js": 299,
	"./eu": 300,
	"./eu.js": 300,
	"./fa": 301,
	"./fa.js": 301,
	"./fi": 302,
	"./fi.js": 302,
	"./fil": 303,
	"./fil.js": 303,
	"./fo": 304,
	"./fo.js": 304,
	"./fr": 305,
	"./fr-ca": 306,
	"./fr-ca.js": 306,
	"./fr-ch": 307,
	"./fr-ch.js": 307,
	"./fr.js": 305,
	"./fy": 308,
	"./fy.js": 308,
	"./ga": 309,
	"./ga.js": 309,
	"./gd": 310,
	"./gd.js": 310,
	"./gl": 311,
	"./gl.js": 311,
	"./gom-deva": 312,
	"./gom-deva.js": 312,
	"./gom-latn": 313,
	"./gom-latn.js": 313,
	"./gu": 314,
	"./gu.js": 314,
	"./he": 315,
	"./he.js": 315,
	"./hi": 316,
	"./hi.js": 316,
	"./hr": 317,
	"./hr.js": 317,
	"./hu": 318,
	"./hu.js": 318,
	"./hy-am": 319,
	"./hy-am.js": 319,
	"./id": 320,
	"./id.js": 320,
	"./is": 321,
	"./is.js": 321,
	"./it": 322,
	"./it-ch": 323,
	"./it-ch.js": 323,
	"./it.js": 322,
	"./ja": 324,
	"./ja.js": 324,
	"./jv": 325,
	"./jv.js": 325,
	"./ka": 326,
	"./ka.js": 326,
	"./kk": 327,
	"./kk.js": 327,
	"./km": 328,
	"./km.js": 328,
	"./kn": 329,
	"./kn.js": 329,
	"./ko": 330,
	"./ko.js": 330,
	"./ku": 331,
	"./ku-kmr": 332,
	"./ku-kmr.js": 332,
	"./ku.js": 331,
	"./ky": 333,
	"./ky.js": 333,
	"./lb": 334,
	"./lb.js": 334,
	"./lo": 335,
	"./lo.js": 335,
	"./lt": 336,
	"./lt.js": 336,
	"./lv": 337,
	"./lv.js": 337,
	"./me": 338,
	"./me.js": 338,
	"./mi": 339,
	"./mi.js": 339,
	"./mk": 340,
	"./mk.js": 340,
	"./ml": 341,
	"./ml.js": 341,
	"./mn": 342,
	"./mn.js": 342,
	"./mr": 343,
	"./mr.js": 343,
	"./ms": 344,
	"./ms-my": 345,
	"./ms-my.js": 345,
	"./ms.js": 344,
	"./mt": 346,
	"./mt.js": 346,
	"./my": 347,
	"./my.js": 347,
	"./nb": 348,
	"./nb.js": 348,
	"./ne": 349,
	"./ne.js": 349,
	"./nl": 350,
	"./nl-be": 351,
	"./nl-be.js": 351,
	"./nl.js": 350,
	"./nn": 352,
	"./nn.js": 352,
	"./oc-lnc": 353,
	"./oc-lnc.js": 353,
	"./pa-in": 354,
	"./pa-in.js": 354,
	"./pl": 355,
	"./pl.js": 355,
	"./pt": 356,
	"./pt-br": 357,
	"./pt-br.js": 357,
	"./pt.js": 356,
	"./ro": 358,
	"./ro.js": 358,
	"./ru": 359,
	"./ru.js": 359,
	"./sd": 360,
	"./sd.js": 360,
	"./se": 361,
	"./se.js": 361,
	"./si": 362,
	"./si.js": 362,
	"./sk": 363,
	"./sk.js": 363,
	"./sl": 364,
	"./sl.js": 364,
	"./sq": 365,
	"./sq.js": 365,
	"./sr": 366,
	"./sr-cyrl": 367,
	"./sr-cyrl.js": 367,
	"./sr.js": 366,
	"./ss": 368,
	"./ss.js": 368,
	"./sv": 369,
	"./sv.js": 369,
	"./sw": 370,
	"./sw.js": 370,
	"./ta": 371,
	"./ta.js": 371,
	"./te": 372,
	"./te.js": 372,
	"./tet": 373,
	"./tet.js": 373,
	"./tg": 374,
	"./tg.js": 374,
	"./th": 375,
	"./th.js": 375,
	"./tk": 376,
	"./tk.js": 376,
	"./tl-ph": 377,
	"./tl-ph.js": 377,
	"./tlh": 378,
	"./tlh.js": 378,
	"./tr": 379,
	"./tr.js": 379,
	"./tzl": 380,
	"./tzl.js": 380,
	"./tzm": 381,
	"./tzm-latn": 382,
	"./tzm-latn.js": 382,
	"./tzm.js": 381,
	"./ug-cn": 383,
	"./ug-cn.js": 383,
	"./uk": 384,
	"./uk.js": 384,
	"./ur": 385,
	"./ur.js": 385,
	"./uz": 386,
	"./uz-latn": 387,
	"./uz-latn.js": 387,
	"./uz.js": 386,
	"./vi": 388,
	"./vi.js": 388,
	"./x-pseudo": 389,
	"./x-pseudo.js": 389,
	"./yo": 390,
	"./yo.js": 390,
	"./zh-cn": 391,
	"./zh-cn.js": 391,
	"./zh-hk": 392,
	"./zh-hk.js": 392,
	"./zh-mo": 393,
	"./zh-mo.js": 393,
	"./zh-tw": 394,
	"./zh-tw.js": 394
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1084;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1086);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("c0a4ce30", content, true, {});

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "/*!\n * Datetimepicker for Bootstrap 3\n * version : 4.17.47\n * https://github.com/Eonasdan/bootstrap-datetimepicker/\n */\n.bootstrap-datetimepicker-widget {\n  list-style: none;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu {\n  display: block;\n  margin: 2px 0;\n  padding: 4px;\n  width: 19em;\n}\n@media (min-width: 576px) {\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n@media (min-width: 768px) {\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n@media (min-width: 992px) {\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n.bootstrap-datetimepicker-widget.dropdown-menu:before,\n.bootstrap-datetimepicker-widget.dropdown-menu:after {\n  content: '';\n  display: inline-block;\n  position: absolute;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #ccc;\n  border-bottom-color: rgba(0, 0, 0, 0.2);\n  top: -7px;\n  left: 7px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after {\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid white;\n  top: -6px;\n  left: 8px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.top:before {\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-top: 7px solid #ccc;\n  border-top-color: rgba(0, 0, 0, 0.2);\n  bottom: -7px;\n  left: 6px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.top:after {\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 6px solid white;\n  bottom: -6px;\n  left: 7px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {\n  left: auto;\n  right: 6px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {\n  left: auto;\n  right: 7px;\n}\n.bootstrap-datetimepicker-widget .list-unstyled {\n  margin: 0;\n}\n.bootstrap-datetimepicker-widget a[data-action] {\n  padding: 6px 0;\n}\n.bootstrap-datetimepicker-widget a[data-action]:active {\n  box-shadow: none;\n}\n.bootstrap-datetimepicker-widget .timepicker-hour,\n.bootstrap-datetimepicker-widget .timepicker-minute,\n.bootstrap-datetimepicker-widget .timepicker-second {\n  width: 54px;\n  font-weight: bold;\n  font-size: 1.2em;\n  margin: 0;\n}\n.bootstrap-datetimepicker-widget button[data-action] {\n  padding: 6px;\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Increment Hours\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Increment Minutes\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Decrement Hours\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Decrement Minutes\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Show Hours\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Show Minutes\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Toggle AM/PM\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Clear the picker\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Set the date to today\";\n}\n.bootstrap-datetimepicker-widget .picker-switch {\n  text-align: center;\n}\n.bootstrap-datetimepicker-widget .picker-switch::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Toggle Date and Time Screens\";\n}\n.bootstrap-datetimepicker-widget .picker-switch td {\n  padding: 0;\n  margin: 0;\n  height: auto;\n  width: auto;\n  line-height: inherit;\n}\n.bootstrap-datetimepicker-widget .picker-switch td span,\n.bootstrap-datetimepicker-widget .picker-switch td i {\n  line-height: 2.5;\n  height: 2.5em;\n  width: 100%;\n}\n.bootstrap-datetimepicker-widget table {\n  width: 100%;\n  margin: 0;\n}\n.bootstrap-datetimepicker-widget table td,\n.bootstrap-datetimepicker-widget table th {\n  text-align: center;\n  border-radius: 0.25rem;\n  padding: 0.5em;\n}\n.bootstrap-datetimepicker-widget table th {\n  height: 20px;\n  line-height: 20px;\n  width: 20px;\n}\n.bootstrap-datetimepicker-widget table th.picker-switch {\n  width: 145px;\n}\n.bootstrap-datetimepicker-widget table th.disabled,\n.bootstrap-datetimepicker-widget table th.disabled:hover {\n  background: none;\n  color: #dee2e6;\n  cursor: not-allowed;\n}\n.bootstrap-datetimepicker-widget table th.prev::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Previous Month\";\n}\n.bootstrap-datetimepicker-widget table th.next::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Next Month\";\n}\n.bootstrap-datetimepicker-widget table thead tr:first-child th {\n  cursor: pointer;\n}\n.bootstrap-datetimepicker-widget table thead tr:first-child th:hover {\n  background: #f8f9fa;\n}\n.bootstrap-datetimepicker-widget table td {\n  height: 54px;\n  line-height: 54px;\n  width: 54px;\n}\n.bootstrap-datetimepicker-widget table td.cw {\n  font-size: 0.8em;\n  height: 20px;\n  line-height: 20px;\n  color: #dee2e6;\n}\n.bootstrap-datetimepicker-widget table td.day {\n  height: 20px;\n  line-height: 20px;\n  width: 20px;\n}\n.bootstrap-datetimepicker-widget table td.day:hover,\n.bootstrap-datetimepicker-widget table td.hour:hover,\n.bootstrap-datetimepicker-widget table td.minute:hover,\n.bootstrap-datetimepicker-widget table td.second:hover {\n  background: #f8f9fa;\n  cursor: pointer;\n}\n.bootstrap-datetimepicker-widget table td.old,\n.bootstrap-datetimepicker-widget table td.new {\n  color: #dee2e6;\n}\n.bootstrap-datetimepicker-widget table td.today {\n  position: relative;\n}\n.bootstrap-datetimepicker-widget table td.today:before {\n  content: '';\n  display: inline-block;\n  border: solid transparent;\n  border-width: 0 0 7px 7px;\n  border-bottom-color: #dee2e6;\n  border-top-color: rgba(0, 0, 0, 0.2);\n  position: absolute;\n  bottom: 4px;\n  right: 4px;\n}\n.bootstrap-datetimepicker-widget table td.active,\n.bootstrap-datetimepicker-widget table td.active:hover {\n  background-color: #dee2e6;\n  color: #007bff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n}\n.bootstrap-datetimepicker-widget table td.active.today:before {\n  border-bottom-color: #fff;\n}\n.bootstrap-datetimepicker-widget table td.disabled,\n.bootstrap-datetimepicker-widget table td.disabled:hover {\n  background: none;\n  color: #dee2e6;\n  cursor: not-allowed;\n}\n.bootstrap-datetimepicker-widget table td span,\n.bootstrap-datetimepicker-widget table td i {\n  display: inline-block;\n  width: 54px;\n  height: 54px;\n  line-height: 54px;\n  margin: 2px 1.5px;\n  cursor: pointer;\n  border-radius: 0.25rem;\n}\n.bootstrap-datetimepicker-widget table td span:hover,\n.bootstrap-datetimepicker-widget table td i:hover {\n  background: #f8f9fa;\n}\n.bootstrap-datetimepicker-widget table td span.active,\n.bootstrap-datetimepicker-widget table td i.active {\n  background-color: #dee2e6;\n  color: #007bff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n}\n.bootstrap-datetimepicker-widget table td span.old,\n.bootstrap-datetimepicker-widget table td i.old {\n  color: #dee2e6;\n}\n.bootstrap-datetimepicker-widget table td span.disabled,\n.bootstrap-datetimepicker-widget table td i.disabled,\n.bootstrap-datetimepicker-widget table td span.disabled:hover,\n.bootstrap-datetimepicker-widget table td i.disabled:hover {\n  background: none;\n  color: #dee2e6;\n  cursor: not-allowed;\n}\n.bootstrap-datetimepicker-widget.usetwentyfour td.hour {\n  height: 27px;\n  line-height: 27px;\n}\n.bootstrap-datetimepicker-widget.wider {\n  width: 21em;\n}\n.bootstrap-datetimepicker-widget .datepicker-decades .decade {\n  line-height: 1.8em !important;\n}\n.input-group.date .input-group-addon {\n  cursor: pointer;\n}\n.input-group.date .input-group-text {\n  cursor: pointer;\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n", ""]);

// exports


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _axios = __webpack_require__(9);

var _axios2 = _interopRequireDefault(_axios);

var _main = __webpack_require__(4);

var _apiFunctions = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// const EXTENSIONA3_ID = 'mfjkeojojhnlcfjjlooeapoinljbfjbf'
// const EXTENSIONA3_ID = 'lhkfmdaljdanjegknbjpcgjjppfhcloc'
// const EXTENSIONA3_ID = 'ahchkdhcpjjafimjljlnghdaofgdhjpe' //OFICIAL ANTERIOR
var EXTENSIONA3_ID = 'epmndncpbbgiclhagbgoienhimkjhdck'; //NOVA EXTENSAO

var EXTENSIONSAT_ID = 'loepffieojmppmchmjhiokjmdkffiiin';

var GlobalFunctions = {
  install: function install(Vue) {
    //Vue.prototype.$globalusername = 'TESTE'
    Vue.prototype.$crudText = function (oper) {
      var crudText = '';
      if (oper == _main.SysVars.crudI) {
        crudText = 'Incluir';
      } else if (oper == _main.SysVars.crudU) {
        crudText = 'Alterar';
      } else if (oper == _main.SysVars.crudD) {
        crudText = 'Excluir';
      } else if (oper == _main.SysVars.crudC) {
        crudText = 'Cancelar';
      }
      return crudText;
    },

    //
    //
    // TRATAMENTO DE ERRO DAS REQUISICOES API
    //
    //

    Vue.prototype.$restRegisterInterceptor = function (entity) {
      var _this = this;

      _axios2.default.interceptors.request.use(function (config) {
        var token = _this.$store.getters.getEnv.token;
        var uuid = _this.$store.getters.getEnv.uuid;
        if (token) {
          if (!config.url.includes('htmlpdf') && !config.url.includes('s3.amazon') && !config.url.includes('localhost')) {
            config.headers['Authorization'] = 'Bearer ' + token;
            config.headers['uuid'] = '' + uuid;
          }
          // config.headers['Access-Control-Allow-Headers'] = '*'
          // config.headers['Access-Control-Allow-Origin'] = '*'
          //config.headers['Accept'] = 'application/json'
          //config.headers['Authorization'] = `Basic  c2NvdHQ6dGlnZXI=`
        }
        return config;
      });

      _axios2.default.interceptors.response.use(function (response) {
        return response;
      }, function (err) {
        // console.log(err.response)
        if (err.response && err.response.status === 400 && err.response.data && err.response.data.errmessages) {
          //tratamento de erros enviados pela API (err.response.data.errmessages)
          _main.SysVars.serverErrorStatus = 0;

          var errMsg = err.response.data.errmessages[0];
          try {
            // Check if the error message is a JSON string and parse it to extract the description
            if (errMsg && (errMsg.startsWith('{') || errMsg.startsWith('['))) {
              var parsed = JSON.parse(errMsg);
              if (parsed) {
                if (parsed.reponse_data && parsed.reponse_data.errors && parsed.reponse_data.errors[0] && parsed.reponse_data.errors[0].description) {
                  errMsg = parsed.reponse_data.errors[0].description;
                } else if (parsed.errors && parsed.errors[0] && parsed.errors[0].description) {
                  errMsg = parsed.errors[0].description;
                } else if (parsed.error) {
                  errMsg = parsed.error;
                }
              }
            }
          } catch (e) {
            // Ignore parsing errors, display errMsg as plain text
          }

          _main.SysVars.serverErrorText = errMsg;
          _main.SysVars.serverError = true;
        } else if (err.response && err.response.status === 400 && err.response.data && err.response.data.message) {
          _main.SysVars.serverErrorStatus = 0;
          _main.SysVars.serverErrorText = err.response.data.message;
          _main.SysVars.serverError = true;
        } else if (err.response && err.response.status === 401) {
          //401 unauthorized
          _main.SysVars.appLogged = false;
        } else if (err.response) {
          var error = err.response;
          //400 bad request
          //403 forbidden
          //404 not found
          //500 erro interno servidor
          _main.SysVars.serverErrorStatus = error.status;
          _main.SysVars.serverErrorText = error.statusText;
          _main.SysVars.serverError = true;
          //if (error.status === 401 && error.config && !error.config.__isRetryRequest) {
          //    console.log('unauthorized, logging out ...');
          //    auth.logout();
          //    router.replace('/auth/login');
          //}
        } else {
          //network error
          _main.SysVars.serverErrorStatus = '';
          _main.SysVars.serverErrorText = 'Erro na conexão com o servidor. Verifique a rede e tente novamente.';
          _main.SysVars.serverError = true;
        }
        _this.$appLoading(false);
        return Promise.reject(err);
      });
    },

    //
    //
    // MENSAGEM DE ERRO E NOTIFICACOES
    //
    //

    Vue.prototype.$appLoading = function (value) {
      _main.SysVars.appLoading = value;
    }, Vue.prototype.$serverError = function (value) {
      _main.SysVars.serverError = value;
    }, Vue.prototype.$showMessage = function (title, message, kind) {
      _main.SysVars.appMessage = message;
      _main.SysVars.appTitleMessage = title;
      _main.SysVars.kindMessage = kind;
      _main.SysVars.appShowMessage = true;
    }, Vue.prototype.$erpToastSuccess = function (message) {
      _main.SysVars.toastSuccess = message; //exibe a notificacao pelo watch no app.vue
    }, Vue.prototype.$erpToastDeleted = function () {
      _main.SysVars.toastSuccess = 'O registro foi excluído.';
    }, Vue.prototype.$erpToastUpdated = function () {
      _main.SysVars.toastSuccess = 'O registro foi alterado.';
    }, Vue.prototype.$erpToastInserted = function () {
      _main.SysVars.toastSuccess = 'O registro foi inserido.';
    }, Vue.prototype.$erpToastWarning = function (message) {
      _main.SysVars.toastWarning = message; //exibe a notificacao pelo watch no app.vue
    }, Vue.prototype.$erpToastError = function (message) {
      _main.SysVars.toastError = message; //exibe a notificacao pelo watch no app.vue
    },

    //Vue.prototype.$erpToastConfirm = function (title, message, teste) {
    //var buttons = [
    //    {text: 'Depois', action: (toast) => {console.log('Clicked: Later'); this.$snotify.remove(toast.id); } },
    //    {text: 'Fechar', action: (toast) => {console.log('Clicked: No'); this.$snotify.remove(toast.id); this.closeForm() }, bold: true},
    //]
    //this.$erpToastConfirm('Example body', 'teste', buttons)
    //  this.$snotify.confirm(message, title, { buttons: teste })
    //},

    //Vue.prototype.$erpToastClose2 = function (title, message, form) {
    //    this.$snotify.confirm(message, {
    //    buttons: [
    //      {text: 'Depois', action: (toast) => {console.log('Clicked: Later'); this.$snotify.remove(toast.id); } },
    //      {text: 'Fechar', action: (toast) => {console.log('Clicked: No'); this.$snotify.remove(toast.id); form.closeForm() }, bold: true},
    //    ]
    //  })
    //},


    //
    //
    //TELA
    //
    //
    Vue.prototype.$scrollTo = function (top) {
      window.scrollTo({
        top: top,
        left: 0,
        behavior: 'smooth'
      });
    }, Vue.prototype.$modalForm = function (value) {
      if (value) document.body.classList.add('no-scroll');else document.body.classList.remove('no-scroll');
    }, Vue.prototype.$disableScroll = function (value) {
      if (value) document.body.classList.add('no-scroll');else document.body.classList.remove('no-scroll');
    },

    //
    //
    //VERIFICACAO DE CERTIFICADO
    //
    //

    Vue.prototype.$certificadoCheck = function (codfil) {
      var _this2 = this;

      //RETORNA O TIPO DE CERTIFICADO CONFIGURADO NA FILIAL - UTILIZADO PARA ENVIO DA NFE

      //VERIFICA A LISTA DE CERTIFICADOS DA SESSAO
      if (!this.$store.getters.getSessao || this.$store.getters.getSessao.certificado.length == 0) {
        this.$store.dispatch('loadSessao', this);
        this.$erpToastError('Nenhum certificado foi localizado');
        return '';
      }

      var certificado = null;

      if (codfil) {
        certificado = this.$store.getters.getSessao.certificado.filter(function (cert) {
          return cert.codfil == codfil;
        });
      } else {
        certificado = this.$store.getters.getSessao.certificado;
      }
      //

      //SE NAO ENCONTRAR O CERTIFICADO DA FILIAL, REDIRECIONA PARA INSTALACAO
      if (!certificado || certificado.length == 0) {
        this.$erpToastError('Vincule um certificado digital para continuar');
        if (this.$router) {
          this.$router.push(codfil ? '/certificado/' + codfil : '/certificado').catch(function () {});
        }
        return '';
      }

      if (certificado[certificado.length - 1].tpcertificado == 'A1') {
        return 'A1';
      }

      //EFETUA A VERIFICACAO DA EXTENSAO SE ESTÁ INSTALADA
      if (!chrome) {
        this.$erpToastError('Certificado digital A3 homologado apenas no Chrome');
        return '';
      }
      chrome.runtime.sendMessage(EXTENSIONA3_ID, 'version', function (response) {
        console.log(response);
        if (!response || response.version != '1.3') {
          _this2.$erpToastError('Extensão do chrome não foi encontrada. Reconfigure o certificado A3.');
          _this2.$router.push('/certificado/extension'); //ENVIA PARA A TELA DE CONFIGURACAO DO CERTIFICADO
        }
      });

      return 'A3';
    }, Vue.prototype.$executaExtensaoChromeSAT = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(codnf, servico, responseCallback, paramsinut) {
        var token, uuid, params, result, servidor, self;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //CHAMADA DA EXTENSAO PARA ENVIO DA NFE
                token = this.$store.getters.getEnv.token;
                uuid = this.$store.getters.getEnv.uuid;
                params = 'uuid=' + uuid + '&servico=' + servico + '&token=' + token;

                if (codnf) params = params + '&codnf=' + codnf;

                _context.next = 6;
                return (0, _apiFunctions.apiORDS)(this.$store.getters.urlOrds + 'cg/ambientenfe', null, true);

              case 6:
                result = _context.sent;


                if (result) _main.SysVars.ambienteHomologacaoNFe = result.homologacao;else _main.SysVars.ambienteHomologacaoNFe = null;

                servidor = '1';

                if (_main.SysVars.ambienteHomologacaoNFe) {
                  servidor = '2';
                  params = params + '&swcnpj=16716114000172';
                }
                params = params + '&servidor=' + servidor;

                if (paramsinut) params = params + paramsinut;

                this.$appLoading(true);
                self = this;

                //console.log(params)

                chrome.runtime.sendMessage(EXTENSIONSAT_ID, params, function (response) {
                  self.$appLoading(false);
                  if (!response || response.status != 'success') {
                    if (response.status == 'update') {
                      self.$erpToastError('É necessário atualizar a versão do módulo SAT');
                      self.$router.push('/certificado/extension'); //ENVIA PARA A TELA DE CONFIGURACAO DO CERTIFICADO
                    } else if (response.status != 'success') {
                      self.$erpToastError(response.message);
                    }
                    return;
                  } else {
                    responseCallback(response);
                  }
                });

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      };
    }(), Vue.prototype.$executaExtensaoChromeA3 = function (codnf, servico, responseCallback, paramsinut) {
      //CHAMADA DA EXTENSAO PARA ENVIO DA NFE
      var token = this.$store.getters.getEnv.token;
      var uuid = this.$store.getters.getEnv.uuid;
      var params = 'uuid=' + uuid + '&servico=' + servico + '&token=' + token;
      if (codnf) params = params + '&codnf=' + codnf;

      if (paramsinut) params = params + paramsinut;

      this.$appLoading(true);
      var self = this;

      console.log(params);

      chrome.runtime.sendMessage(EXTENSIONA3_ID, params, function (response) {
        console.log(response);
        self.$appLoading(false);
        if (!response || response.status != 'success') {
          if (response.status == 'update') {
            self.$erpToastError('É necessário atualizar a versão do módulo A3');
            self.$router.push('/certificado/extension'); //ENVIA PARA A TELA DE CONFIGURACAO DO CERTIFICADO
          } else if (response.status != 'success') {
            self.$erpToastError(response.message);
          }
          return;
        } else {
          responseCallback(response);
        }
      });
    }, Vue.prototype.$checkExtensaoChromeA3 = function (responseCallback) {
      //CHECA SE A EXTENSAO ESTÁ INSTALADA
      chrome.runtime.sendMessage(EXTENSIONA3_ID, 'version', responseCallback);
    }, Vue.prototype.$certificadoTesteA3 = function (responseCallback) {
      //EFETUA O TESTE NO CERTIFICADO A3
      chrome.runtime.sendMessage(EXTENSIONA3_ID, 'servico=teste', responseCallback);
    },

    //
    //
    //
    //
    //
    //
    Vue.prototype.$SATExtension = function (xml, responseCallback) {
      //CHAMADA DA EXTENSAO PARA EMISSAO DO SAT
      chrome.runtime.sendMessage(EXTENSIONSAT_ID, xml, responseCallback);
    },

    //
    //
    // CONVERSÕES
    //
    //

    Vue.prototype.$strToFloat = function (value, dec) {
      var decimal = 0;
      if (Number.isInteger(dec)) {
        decimal = dec;
      }
      var v = value;
      if (v == '' || v == null) v = '';else if (!this.$isValidFloat(v)) {
        if (parseFloat(v)) {
          v = parseFloat(v).toFixed(decimal);
          return v;
        } else {
          v = '';
        }
      }
      if (v) {
        if (v && v.length) {
          v = v.replace(',', '.');
        } else {
          v = parseFloat(v).toFixed(decimal);
        }
      }
      return v;
    }, Vue.prototype.$floatToStr = function (value, dec) {
      var v = value;
      if (v == null) {
        v = 0;
      }
      v = parseFloat(v).toFixed(dec);
      v = v.replace('.', ','); //.toLocaleString('pt-BR')
      return v;
    }, Vue.prototype.$removerAcentos = function (s) {
      var map = { "â": "a", "Â": "A", "à": "a", "À": "A", "á": "a", "Á": "A", "ã": "a", "Ã": "A", "ê": "e", "Ê": "E", "è": "e", "È": "E", "é": "e", "É": "E", "î": "i", "Î": "I", "ì": "i", "Ì": "I", "í": "i", "Í": "I", "õ": "o", "Õ": "O", "ô": "o", "Ô": "O", "ò": "o", "Ò": "O", "ó": "o", "Ó": "O", "ü": "u", "Ü": "U", "û": "u", "Û": "U", "ú": "u", "Ú": "U", "ù": "u", "Ù": "U", "ç": "c", "Ç": "C" };
      return s.replace(/[\W\[\] ]/g, function (a) {
        return map[a] || a;
      });
    }, Vue.prototype.$getDate = function () {
      //RETORNA A DATA ATUAL NO FORMATO YYYY-MM-DD
      var d = new Date();

      var month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    }, Vue.prototype.$strToDate = function (dateStr) {
      if (dateStr == null) {
        return null;
      }

      var _dateStr$split = dateStr.split("-"),
          _dateStr$split2 = _slicedToArray(_dateStr$split, 3),
          year_ = _dateStr$split2[0],
          month_ = _dateStr$split2[1],
          day_ = _dateStr$split2[2];

      var day = day_.substr(0, 2);
      var d = new Date(year_, month_ - 1, day);
      return d;
      // var month = '' + (d.getMonth() + 1),
      // day = '' + d.getDate(),
      // year = d.getFullYear()
      // if (month.length < 2) month = '0' + month;
      // if (day.length < 2) day = '0' + day;
      // return [year, month, day].join('-');
    }, Vue.prototype.$addDays = function (dateStr, days) {
      var nDays = 0;
      nDays = parseFloat(days);

      // console.log('entrada: ' + dateStr)

      var _dateStr$split3 = dateStr.split("-"),
          _dateStr$split4 = _slicedToArray(_dateStr$split3, 3),
          year_ = _dateStr$split4[0],
          month_ = _dateStr$split4[1],
          day_ = _dateStr$split4[2];

      if (isNaN(nDays)) {
        return dateStr;
      }
      var day = day_.substr(0, 2);
      var d = new Date(year_, month_ - 1, day);
      d.setDate(d.getDate() + nDays);
      // console.log('saida:' + d.toString())
      var month = '' + (d.getMonth() + 1);
      day = '' + (d.getDate() + 0);
      //day = '' + (d.getDate() + 1)
      var year = d.getFullYear();
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    }, Vue.prototype.$addMonths = function (dateStr, months) {
      var _dateStr$split5 = dateStr.split("-"),
          _dateStr$split6 = _slicedToArray(_dateStr$split5, 3),
          year_ = _dateStr$split6[0],
          month_ = _dateStr$split6[1],
          day_ = _dateStr$split6[2];

      var day = day_.substr(0, 2);
      var d = new Date(year_, month_ - 1, day);
      d.setMonth(d.getMonth() + months);
      var month = '' + (d.getMonth() + 1);
      day = '' + d.getDate();
      var year = d.getFullYear();
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    }, Vue.prototype.$lastDay = function (dateStr) {
      var _dateStr$split7 = dateStr.split("-"),
          _dateStr$split8 = _slicedToArray(_dateStr$split7, 3),
          year_ = _dateStr$split8[0],
          month_ = _dateStr$split8[1],
          day_ = _dateStr$split8[2];

      var d = new Date(year_, month_, 0);
      var last = new Date(d.getFullYear(), d.getMonth() + 1, 0),
          day = last.getDate(),
          year = last.getFullYear(),
          month = last.getMonth();
      month++;
      if (String(month).length < 2) month = '0' + month;
      if (String(day).length < 2) day = '0' + day;
      return [year, month, day].join('-');
    }, Vue.prototype.$firstDay = function (dateStr) {
      var _dateStr$split9 = dateStr.split("-"),
          _dateStr$split10 = _slicedToArray(_dateStr$split9, 3),
          year_ = _dateStr$split10[0],
          month_ = _dateStr$split10[1],
          day_ = _dateStr$split10[2];

      var day = '' + 1;
      var month = '' + month_;
      var year = year_;
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    }, Vue.prototype.$daysBetween = function (first, second) {
      if (!first || !second || typeof first !== 'string' || typeof second !== 'string') {
        return 0;
      }
      var fParts = first.split("-");
      var sParts = second.split("-");
      if (fParts.length < 3 || sParts.length < 3) {
        return 0;
      }

      var _fParts = _slicedToArray(fParts, 3),
          yearf_ = _fParts[0],
          monthf_ = _fParts[1],
          dayf_ = _fParts[2];

      var dayf = dayf_.substr(0, 2);
      var df = new Date(yearf_, monthf_ - 1, dayf);

      var _sParts = _slicedToArray(sParts, 3),
          years_ = _sParts[0],
          months_ = _sParts[1],
          days_ = _sParts[2];

      var days = days_.substr(0, 2);
      var ds = new Date(years_, months_ - 1, days);
      df.setMinutes(df.getMinutes() - df.getTimezoneOffset());
      ds.setMinutes(ds.getMinutes() - ds.getTimezoneOffset());

      var millisecondsPerDay = 24 * 60 * 60 * 1000;

      return (ds - df) / millisecondsPerDay;
    },

    //
    //
    // FORMATACAO DE CAMPOS
    //
    //

    Vue.prototype.$formatFone = function (value) {
      if (!value) {
        return value;
      }
      var t = value.length;
      if (t == 8) {
        return value.replace(/\D/g, '').replace(/^(\d{4})(\d{4})??/, "$1-$2");
      } else if (t == 9) {
        return value.replace(/\D/g, '').replace(/^(\d{1})(\d{4})(\d{4})??/, "$1 $2-$3");
      } else if (t == 11) {
        return value.replace(/\D/g, '').replace(/^(\d{2})(\d{1})(\d{4})(\d{4})??/, "($1) $2 $3-$4");
      } else if (t == 10) {
        return value.replace(/\D/g, '').replace(/^(\d{2})(\d{4})(\d{4})??/, "($1) $2-$3");
      } else {
        return value;
      }
    }, Vue.prototype.$formatCNPJCPF = function (value) {
      if (!value) {
        return value;
      }
      if (value.length == 14) {
        return value.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1.$2.$3/$4-$5");
      }
      if (value.length == 11) {
        return value.replace(/^(\d{3})?(\d{3})?(\d{3})?(\d{2})?/, "$1.$2.$3-$4");
      } else {
        return value;
      }
    }, Vue.prototype.$formatCNPJ = function (value) {
      if (!value) {
        return value;
      }
      if (value.length == 14) {
        return value.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1.$2.$3/$4-$5");
      } else {
        return value;
      }
    }, Vue.prototype.$formatCPF = function (value) {
      if (!value) {
        return value;
      }
      if (value.length == 11) {
        return value.replace(/^(\d{3})?(\d{3})?(\d{3})?(\d{2})?/, "$1.$2.$3-$4");
      } else {
        return value;
      }
    }, Vue.prototype.$formatDate = function (value) {
      if (!value) {
        return value;
      }
      if (value.length == 8) {
        return value.replace(/^(\d{2})?(\d{2})?(\d{4})?/, "$1/$2/$3");
      } else {
        return value;
      }
    }, Vue.prototype.$formatHora = function (value) {
      if (!value) {
        return value;
      }
      var t = value.length;
      if (t == 4) return value.replace(/\D/g, '').replace(/^(\d{2})(\d{2})??/, "$1:$2");else return value;
    },

    /* SUBSTITUIDO POR UTILS.FORMATVALUE
    Vue.prototype.$formatValue = function(value, precision) {
      var numero = 0;
      if (value != null) {
        numero = value
      }
      numero = parseFloat(numero).toFixed(precision).split('.')
      numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.')
      return numero.join(',')
    },
    */

    //
    //
    // VALIDACOES
    //
    //

    //VALORES
    Vue.prototype.$isValidFloat = function (value) {
      if (Number(value)) return true;else if (value.match(/^[0-9,]+$/)) {
        return true;
      } else {
        return false;
      }
    },
    //EMAIL
    Vue.prototype.$isValidEmail = function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    //DATAS
    Vue.prototype.$isValidDate = function (pDate) {
      var vdata = pDate;
      var vday = vdata.substring(0, 2);
      var vmonth = vdata.substring(3, 5);
      var vyear = vdata.substring(6, 10);

      if (vday == "") {
        return false;
      }
      if (vmonth == "") {
        return false;
      }
      if (vyear == "") {
        return false;
      }

      day = parseInt(vday);
      month = parseInt(vmonth);
      year = parseInt(vyear);

      if (day < 1 || day > 31) {
        return false;
      }
      if (month < 1 || month > 12) {
        return false;
      }
      if (year < 1900) {
        return false;
      }

      // Valindao mes com 31 dias
      if (month == 1 || month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12) {
        if (day < 1 || day > 31) {
          return false;
        }
      } else {
        // Valindado mes com 30 dias
        if (month == 4 || month == 6 || month == 9 || month == 11) {
          if (day < 1 || day > 30) {
            return false;
          }
        } else
          // Valindado Feveiro no ano bixsexto
          if (month == 2) {
            if (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0)) {
              if (day < 1 || day > 29) {
                return false;
              }
            } else {
              if (day < 1 || day > 28) {
                return false;
              }
            }
          }
      }
      return true;
    },

    //validacao de CNPJ
    Vue.prototype.$isValidCNPJ = function (cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g, '');

      if (cnpj == '') return false;

      if (cnpj.length != 14) return false;

      // Elimina CNPJs invalidos conhecidos
      if (cnpj == "00000000000000" || cnpj == "11111111111111" || cnpj == "22222222222222" || cnpj == "33333333333333" || cnpj == "44444444444444" || cnpj == "55555555555555" || cnpj == "66666666666666" || cnpj == "77777777777777" || cnpj == "88888888888888" || cnpj == "99999999999999") return false;

      // Valida DVs
      var tamanho = cnpj.length - 2;
      var numeros = cnpj.substring(0, tamanho);
      var digitos = cnpj.substring(tamanho);
      var soma = 0;
      var pos = tamanho - 7;
      for (var i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0)) return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (var _i = tamanho; _i >= 1; _i--) {
        soma += numeros.charAt(tamanho - _i) * pos--;
        if (pos < 2) pos = 9;
      }
      var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1)) return false;

      return true;
    }, Vue.prototype.$apiGuiaUsuarioDesativar = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _apiFunctions.apiORDSapp)(this, "usuario/guia/", "post", null);

            case 2:
              _main.SysVars.guia = false;

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));
  }
};

exports.default = GlobalFunctions;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = undefined;

var _vuex = __webpack_require__(221);

var _vuex2 = _interopRequireDefault(_vuex);

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _apiFunctions = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Video sobre VUEX
                                                                                                                                                                                                                                                                                                                                                                                                                                                                           https://www.youtube.com/watch?v=i2yc_ACcMA0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

_vue2.default.use(_vuex2.default);

var getDefaultState = function getDefaultState() {
  return {
    env: {
      email: "",
      token: null, //token ords
      apptoken: null, //token aplicacao com dados da conexao, empresa, usuario
      uuid: null, //uuid da empresa
      tpempresa: null
    },

    sessao: {},

    // urlApi: '/ords/webdata',
    // urlApp: '/ords/nbapp/',
    // urlLoja: '/ords/apiloja/',
    // urlNotifications: 'http://ec2-52-202-145-226.compute-1.amazonaws.com:3232',


    urlApi: "https://api.notabrasil.com.br/ords/webdata",
    urlApp: "https://api.notabrasil.com.br/ords/nbapp/",
    urlLoja: "https://api.notabrasil.com.br/ords/apiloja/",
    urlNotifications: "https://apinotification.notabrasil.com.br",

    // urlApi: 'https://teste.notabrasil.com.br/ords/webdata',
    // urlApp: 'https://teste.notabrasil.com.br/ords/nbapp/',
    // urlLoja: 'https://teste.notabrasil.com.br/ords/apiloja/',
    // urlNotifications: 'http://ec2-52-202-145-226.compute-1.amazonaws.com:3232',

    nextPage: 0, //controle de paginação de listas

    entities: {},

    parametrosUsuario: {},

    partList: {},
    part: {},
    partContato: {},
    partPainel: {},
    item: {},
    itemList: {},
    natesList: {},
    nates: {},
    itemSalesList: {},
    itemSalesVarejoList: {},
    itemTaxes: {},
    pedvList: {},
    pedvTotal: {},
    pedv: {},
    nfList: {},
    compraList: {},
    compra: {},
    nf_with_itemList: {},
    nfOrigem: {},
    nf: {},
    diList: {},
    duimpList: {},
    di: {},
    duimp: {},
    regrafcpList: {},
    regrafcp: {},
    regrast: {},
    regrastList: {},
    regraimp: {},
    regraimpList: {},
    grutribList: {},
    grutrib: {},
    estadoList: {},
    estado: {},
    ivancmList: {},
    ivancm: {},
    ivaclassList: {},
    ivaclass: {},

    unimedList: {},
    unimed: {},
    ncmList: {},
    ncm: {},
    gruestList: {},
    gruest: {},
    grucliList: {},
    grucli: {},
    xmlhistList: {},
    xmlhist: {},
    gruforList: {},
    grufor: {},
    mennfList: {},
    mennf: {},
    depositoList: {},
    deposito: {},
    vendList: {},
    vend: {},
    filialList: {},
    filial: {},
    usuarioList: {},
    usuario: {},
    natfinList: {},
    natfin: {},
    ramoatList: {},
    ramoat: {},
    contadorList: {},
    contador: {},
    serienfList: {},
    serienf: {},
    inutList: {},
    inut: {},
    nfAvisos: {},
    grade: {},
    gradeList: {},
    tabpre: {},
    tabpreList: {},
    tabpreItens: {},
    destaq: {},
    destaqList: {},
    tabdes: {},
    tabdesList: {},

    docsList: {},

    pdtipoList: {},
    pdtipo: {},
    pdstatusList: {},
    pdstatus: {},
    condicaoList: {},
    condicao: {},
    equipeList: {},
    equipe: {},
    agendaList: {},
    agenda: {},

    catmktList: {},
    catmkt: {},

    manifestoList: {},
    manifesto: {},

    guiaNFe: {},

    notificationsList: {},

    //FINANCEIRO
    ctaList: {},
    cta: {},
    fpagList: {},
    fpag: {},
    vcaixaList: {},
    vcaixa: {},
    bancoList: {},
    cnabSemVinculo: {},
    cnabPendente: {},
    cnabRemList: {},
    cnabRejList: {},
    cnabRetList: {},
    cnabRetDetList: {},
    fin: {},
    finarList: {},
    finarTotal: {}, //TOTALIZACAO CONTAS A RECEBER
    finapList: {}, //LISTAGEM CONTAS A PAGAR
    finapTotal: {}, //TOTALIZACOA CONTAS A PAGAR
    finExtratoList: {}, //EXTRATO FINANCEIRO DEBITOS E CREDITOS

    logList: {}, //TABLE DE LOG DE ALTERACOES DO SISTEMA

    templEmailList: [],
    templEmail: {},

    freteList: {},

    //CRM
    pessoa: {},
    pessoaList: {},
    organizacao: {},
    organizacaoList: {},
    negocio: {},
    negocioList: {},
    negocioNoDateTimelineList: {},
    negocioHist: {},
    negocioEmails: {},
    configCrm: {},
    tagCrm: {},
    origemCrm: {},
    origemCrmList: {},
    motivoCrm: {},
    motivoCrmList: {},
    funilCrm: {},
    emailCrm: {},
    emailCrmList: {},
    leadCrmList: [],
    leadCrm: {},
    // FIM CRM

    vDevolList: {},
    vDevol: {},

    // LOJA
    configLoja: {},
    // FIM LOJA

    paramPDV: {
      formato_venda_manual: "N",
      permite_desconto: "N",
      desconto_max: null,
      permite_acrescimo: "N",
      acrescimo_max: null,
      parcelas_somente_dias_uteis: "N",
      tabela_preco: null,
      altera_preco: null,
      exibe_opcao_gerar_sat: null,
      exibe_opcao_gerar_nfce: "S",
      tipo_controle_cm_ms: null,
      default_focus_btn_pag: null,
      default_header_title: null,
      observacao: null,
      ir_para_emissao_nf: "NV",
      colors: {
        bg_top_bottom: null,
        fc_top_bottom: null,
        bg_buttom: null,
        fc_buttom: null
      },
      listMesas: [],
      balanca: {
        numero_identificacao: null,
        tamanhobarra: null,
        inicio_codigo: null,
        fim_codigo: null,
        inicio_valor: null,
        fim_valor: null,
        barras_peso_ou_valor: null,
        qtd_casas_valor: null
      }
    },

    teste: {},

    indexfiltroTiposManifesto: 0,

    helpList: [{
      app: null,
      route: null,
      title: "Como renovar sua assinatura no Nota Brasil",
      icon: "fa-play",
      url: "//www.youtube.com/embed/JSFoOrlI4yo"
    }, {
      app: ["nfe", "erp", "fv"],
      route: "partlist",
      title: "Como cadastrar clientes e fornecedores",
      icon: "fa-play",
      url: "//www.youtube.com/embed/Rb8ygl4dAqk"
    },

    // { app: ['nfe','erp'], route: 'partlist', title: 'Adicionar contatos', icon: 'fa-play', url: '//www.youtube.com/embed/Ji8TZTb04vk' },
    {
      app: ["nfe", "erp"],
      route: "partlist",
      title: "Importe seus clientes e fornecedores",
      icon: "fa-play",
      url: "//www.youtube.com/embed/ql3fiqp-Lvk"
    },
    // { app: ['nfe','erp'], route: 'partlist', title: 'Clientes com limite de crédito', icon: 'fa-play', url: '//www.youtube.com/embed/lUBvppUtM9U' },

    {
      app: ["nfe", "erp"],
      route: "gruforlist",
      title: "Cadastrar grupos de fornecedores",
      icon: "fa-play",
      url: "//www.youtube.com/embed/ybUK15Jvhrk"
    }, {
      app: ["nfe", "erp"],
      route: "nfimportlist",
      title: "DI",
      icon: "fa-play",
      url: "//www.youtube.com/embed/PlH8n2h3_aw"
    }, {
      app: ["nfe", "erp", "fv"],
      route: "fvprodutosmenu",
      title: "Como cadastrar produtos",
      icon: "fa-play",
      url: "//www.youtube.com/embed/c241at1ws14"
    },
    // { app: ['nfe','erp'], route: 'fvprodutosmenu', title: 'Produtos e configuração de impostos', icon: 'fa-play', url: '//www.youtube.com/embed/gjwdNe3q8AM' },
    {
      app: ["nfe", "erp", "fv"],
      route: "fvprodutosmenu",
      title: "Como importar produtos",
      icon: "fa-play",
      url: "//www.youtube.com/embed/6Bmo4YZTmII"
    }, {
      app: ["nfe", "erp", "fv"],
      route: "fvprodutosmenu",
      title: "Grades",
      icon: "fa-play",
      url: "//www.youtube.com/embed/kjCvTcjM16o"
    },
    // { app: ['nfe','erp', 'fv'], route: 'fvprodutosmenu', title: 'Unidades de medida', icon: 'fa-play', url: '//www.youtube.com/embed/rZvRsuDRNSc' },

    {
      app: ["nfe", "erp"],
      route: "fvprodutosmenu",
      title: "Tabelas de desconto",
      icon: "fa-play",
      url: "//www.youtube.com/embed/atVVQ1Gp3PM"
    }, {
      app: ["nfe", "erp"],
      route: "pedidolist",
      title: "Tabelas de desconto",
      icon: "fa-play",
      url: "//www.youtube.com/embed/atVVQ1Gp3PM"
    }, {
      app: ["nfe", "erp"],
      route: "fvprodutosmenu",
      title: "Tabelas de preços",
      icon: "fa-play",
      url: "//www.youtube.com/embed/ZqW9c7_BQGE"
    }, {
      app: ["nfe", "erp"],
      route: "pedidolist",
      title: "Tabelas de preços",
      icon: "fa-play",
      url: "//www.youtube.com/embed/ZqW9c7_BQGE"
    }, {
      app: ["nfe", "erp", "fv"],
      route: "gradelist",
      title: "Grades",
      icon: "fa-play",
      url: "//www.youtube.com/embed/BogRiM2uBxM"
    }, {
      app: ["nfe", "erp"],
      route: "nflist",
      title: "Como emitir notas de saída",
      icon: "fa-play",
      url: "//www.youtube.com/embed/UFfTZdJJdLw"
    }, {
      app: ["nfe", "erp"],
      route: "nflist",
      title: "Como emitir uma carta de correção",
      icon: "fa-play",
      url: "//www.youtube.com/embed/O9OvFKti6cI"
    }, {
      app: ["nfe", "erp"],
      route: "nflist",
      title: "Como cancelar uma NF-e emitida",
      icon: "fa-play",
      url: "//www.youtube.com/embed/9Vh3rEFh-MM"
    }, {
      app: ["nfe", "erp"],
      route: "nflist",
      title: "Lançar notas de entrada de fornecedores",
      icon: "fa-play",
      url: "//www.youtube.com/embed/kZehwtZJpyc"
    }, {
      app: ["nfe", "erp"],
      route: "nflist",
      title: "Importar XML de NF-e",
      icon: "fa-play",
      url: "//www.youtube.com/embed/9ObY3ziNqv4"
    },
    // { app: ['nfe','erp'], route: 'nflist', title: 'Cadastrar mensagens padrões para nota fiscal', icon: 'fa-play', url: '//www.youtube.com/embed/FaehFIR15t0' },
    {
      app: ["nfe", "erp"],
      route: "nflist",
      title: "Cadastrar naturezas de operação",
      icon: "fa-play",
      url: "//www.youtube.com/embed/vwmjvWBc6cM"
    }, {
      app: ["nfe", "erp"],
      route: "nflist",
      title: "Regras de ICMS",
      icon: "fa-play",
      url: "//www.youtube.com/embed/c7K1Pt9KY8M"
    }, {
      app: ["nfe", "erp"],
      route: "inutlist",
      title: "Como inutilizar numeração de NF-e",
      icon: "fa-play",
      url: "//www.youtube.com/embed/tobpmc34LBA"
    }, {
      app: ["nfe", "erp", "fv"],
      route: "pedidolist",
      title: "Lançar uma venda",
      url: "//www.youtube.com/embed/oDczqdHbDUc"
    }, {
      app: ["nfe", "erp"],
      route: "regraimplist",
      title: "Regras de ICMS",
      icon: "fa-play",
      url: "//www.youtube.com/embed/c7K1Pt9KY8M"
    }, {
      app: ["nfe", "erp", "fv"],
      route: "filiallist",
      title: "Configure os dados da sua empresa",
      icon: "fa-play",
      url: "//www.youtube.com/embed/0QMVqSEm-ww"
    }, {
      app: ["nfe", "erp", "fv"],
      route: "filiallist",
      title: "Vincular um certificado A3",
      icon: "fa-play",
      url: "//www.youtube.com/embed/Ds6DmZ7uzEg"
    }, {
      app: ["nfe", "erp", "fv"],
      route: "filiallist",
      title: "Vincular um certificado A1",
      icon: "fa-play",
      url: "//www.youtube.com/embed/S6QsrgWAaRM"
    }, {
      app: ["nfe", "erp", "fv"],
      route: "configmenu",
      title: "Configure os dados da sua empresa",
      icon: "fa-play",
      url: "//www.youtube.com/embed/0QMVqSEm-ww"
    }, {
      app: ["nfe", "erp", "fv"],
      route: "configmenu",
      title: "Vincular um certificado A3",
      icon: "fa-play",
      url: "//www.youtube.com/embed/Ds6DmZ7uzEg"
    }, {
      app: ["nfe", "erp", "fv"],
      route: "configmenu",
      title: "Vincular um certificado A1",
      icon: "fa-play",
      url: "//www.youtube.com/embed/S6QsrgWAaRM"
    }, {
      app: ["nfe", "erp", "fv"],
      route: "usuariolist",
      title: "Cadastrar novos usuários",
      icon: "fa-play",
      url: "//www.youtube.com/embed/zrLh76xUIcM"
    }, {
      app: ["nfe", "erp"],
      route: "regrafcplist",
      title: "Alíquotas do FCP",
      icon: "fa-play",
      url: "//www.youtube.com/embed/iDViSF1rOYk"
    }, {
      app: ["nfe", "erp"],
      route: "nateslist",
      title: "Cadastrar naturezas de operação",
      icon: "fa-play",
      url: "//www.youtube.com/embed/vwmjvWBc6cM"
    }]
  };
};

var store = exports.store = new _vuex2.default.Store({
  state: getDefaultState(),

  getters: {
    urlOrdsSelect: function urlOrdsSelect(state) {
      return state.urlApi + "/select/";
    },
    urlOrds: function urlOrds(state) {
      return state.urlApi + "/";
    },
    urlApp: function urlApp(state) {
      return state.urlApp;
    },
    urlLoja: function urlLoja(state) {
      return state.urlLoja;
    },
    urlMetadata: function urlMetadata(state) {
      return state.urlApp + "metadata/";
    },
    urlNotifications: function urlNotifications(state) {
      return state.urlNotifications;
    },
    getEnv: function getEnv(state) {
      return state.env;
    },
    getEnvAcessoCore: function getEnvAcessoCore(state) {
      return state.env.email == "teste@gmail.com" || state.env.email == "rodrigosaso@terra.com.br";
    },
    getSessao: function getSessao(state) {
      return state.sessao;
    },
    getToken: function getToken(state) {
      return state.env.token;
    },
    getEntities: function getEntities(state) {
      return state.entities;
    },
    getParametrosUsuario: function getParametrosUsuario(state) {
      return state.parametrosUsuario;
    },
    getNextPage: function getNextPage(state) {
      return state.nextPage;
    },
    getMessages: function getMessages(state) {
      return state.entities.messages;
    },
    getHelpList: function getHelpList(state) {
      return state.helpList;
    },
    getPartList: function getPartList(state) {
      return state.partList;
    },
    getPart: function getPart(state) {
      return state.part;
    },
    getPartContato: function getPartContato(state) {
      return state.partContato;
    },
    getPartPainel: function getPartPainel(state) {
      return state.partPainel;
    },
    getItem: function getItem(state) {
      return state.item;
    },
    getItemList: function getItemList(state) {
      return state.itemList;
    },
    getItemSalesVarejoList: function getItemSalesVarejoList(state) {
      return state.itemSalesVarejoList;
    },
    getItemSalesList: function getItemSalesList(state) {
      return state.itemSalesList;
    },
    getItemTaxes: function getItemTaxes(state) {
      return state.itemTaxes;
    },
    getNatesList: function getNatesList(state) {
      return state.natesList;
    },
    getNatesSaidaList: function getNatesSaidaList(state) {
      if (state.natesList && state.natesList.length) return state.natesList.filter(function (nates) {
        return !nates.tpnat || nates.tpnat == "" || nates.tpnat == "S";
      });
    },
    getNatesEntradaList: function getNatesEntradaList(state) {
      if (state.natesList && state.natesList.length) return state.natesList.filter(function (nates) {
        return nates.tpnat == "E";
      });
    },
    getNates: function getNates(state) {
      return state.nates;
    },
    getPedvList: function getPedvList(state) {
      return state.pedvList;
    },
    getPedvTotal: function getPedvTotal(state) {
      return state.pedvTotal;
    },
    getPedv: function getPedv(state) {
      return state.pedv;
    },
    getPedvDev: function getPedvDev(state) {
      return state.pedvDev;
    },
    getvDevolList: function getvDevolList(state) {
      return state.vDevolList;
    },
    getVdevol: function getVdevol(state) {
      return state.vDevol;
    },
    getNfList: function getNfList(state) {
      return state.nfList;
    },
    getCompraList: function getCompraList(state) {
      return state.compraList;
    },
    getCompra: function getCompra(state) {
      return state.compra;
    },
    getNf_with_itemList: function getNf_with_itemList(state) {
      return state.nf_with_itemList;
    },

    getNfOrigem: function getNfOrigem(state) {
      return state.nfOrigem;
    },
    getNf: function getNf(state) {
      return state.nf;
    },
    getDiList: function getDiList(state) {
      return state.diList;
    },
    getDuimpList: function getDuimpList(state) {
      return state.duimpList;
    },

    getDi: function getDi(state) {
      return state.di;
    },
    getDuimp: function getDuimp(state) {
      return state.duimp;
    },

    getRegrast: function getRegrast(state) {
      return state.regrast;
    },
    getRegrastList: function getRegrastList(state) {
      return state.regrastList;
    },
    getRegraimp: function getRegraimp(state) {
      return state.regraimp;
    },
    getRegraimpList: function getRegraimpList(state) {
      return state.regraimpList;
    },
    getGrutrib: function getGrutrib(state) {
      return state.grutrib;
    },
    getGrutribList: function getGrutribList(state) {
      return state.grutribList;
    },
    getRegrafcp: function getRegrafcp(state) {
      return state.regrafcp;
    },
    getRegrafcpList: function getRegrafcpList(state) {
      return state.regrafcpList;
    },
    getEstadoList: function getEstadoList(state) {
      return state.estadoList;
    },
    getEstado: function getEstado(state) {
      return state.estado;
    },
    getivancmList: function getivancmList(state) {
      return state.ivancmList;
    },
    getivancm: function getivancm(state) {
      return state.ivancm;
    },
    getivaclassList: function getivaclassList(state) {
      return state.ivaclassList;
    },
    getivaclass: function getivaclass(state) {
      return state.ivaclass;
    },
    getUnimedList: function getUnimedList(state) {
      return state.unimedList;
    },
    getUnimed: function getUnimed(state) {
      return state.unimed;
    },
    getNcmList: function getNcmList(state) {
      return state.ncmList;
    },
    getNcm: function getNcm(state) {
      return state.ncm;
    },
    getGruestList: function getGruestList(state) {
      return state.gruestList;
    },
    getGruest: function getGruest(state) {
      return state.gruest;
    },
    getGrucliList: function getGrucliList(state) {
      return state.grucliList;
    },
    getGrucli: function getGrucli(state) {
      return state.grucli;
    },
    getXMLHistList: function getXMLHistList(state) {
      return state.xmlhistList;
    },
    getXMLHist: function getXMLHist(state) {
      return state.xmlhist;
    },
    getGruforList: function getGruforList(state) {
      return state.gruforList;
    },
    getGrufor: function getGrufor(state) {
      return state.grufor;
    },
    getMennf: function getMennf(state) {
      return state.mennf;
    },
    getMennfList: function getMennfList(state) {
      return state.mennfList;
    },
    getDeposito: function getDeposito(state) {
      return state.deposito;
    },
    getDepositoList: function getDepositoList(state) {
      return state.depositoList;
    },
    getFilial: function getFilial(state) {
      return state.filial;
    },
    getFilialList: function getFilialList(state) {
      return state.filialList;
    },
    getVend: function getVend(state) {
      return state.vend;
    },
    getVendList: function getVendList(state) {
      return state.vendList;
    },
    getUsuario: function getUsuario(state) {
      return state.usuario;
    },
    getUsuarioList: function getUsuarioList(state) {
      return state.usuarioList;
    },
    getSerienf: function getSerienf(state) {
      return state.serienf;
    },
    getSerienfList: function getSerienfList(state) {
      return state.serienfList;
    },
    getContador: function getContador(state) {
      return state.contador;
    },
    getContadorList: function getContadorList(state) {
      return state.contadorList;
    },
    getNatfin: function getNatfin(state) {
      return state.natfin;
    },
    getNatfinList: function getNatfinList(state) {
      return state.natfinList;
    },
    getRamoat: function getRamoat(state) {
      return state.ramoat;
    },
    getRamoatList: function getRamoatList(state) {
      return state.ramoatList;
    },
    getInut: function getInut(state) {
      return state.inut;
    },
    getInutList: function getInutList(state) {
      return state.inutList;
    },
    getNfAvisos: function getNfAvisos(state) {
      return state.nfAvisos;
    },
    getCta: function getCta(state) {
      return state.cta;
    },
    getCtaList: function getCtaList(state) {
      return state.ctaList;
    },
    getFpag: function getFpag(state) {
      return state.fpag;
    },
    getFpagList: function getFpagList(state) {
      return state.fpagList;
    },
    getVCaixa: function getVCaixa(state) {
      return state.vcaixa;
    },
    getVCaixaList: function getVCaixaList(state) {
      return state.vcaixaList;
    },
    getBancoList: function getBancoList(state) {
      return state.bancoList;
    },
    getCnabSemVinculo: function getCnabSemVinculo(state) {
      return state.cnabSemVinculo;
    },
    getCnabPendente: function getCnabPendente(state) {
      return state.cnabPendente;
    },
    getCnabRemList: function getCnabRemList(state) {
      return state.cnabRemList;
    },
    getCnabRejList: function getCnabRejList(state) {
      return state.cnabRejList;
    },
    getCnabRetList: function getCnabRetList(state) {
      return state.cnabRetList;
    },
    getCnabRetDetList: function getCnabRetDetList(state) {
      return state.cnabRetDetList;
    },
    getFin: function getFin(state) {
      return state.fin;
    },
    getLogList: function getLogList(state) {
      return state.logList;
    },
    getGrade: function getGrade(state) {
      return state.grade;
    },
    getGradeList: function getGradeList(state) {
      return state.gradeList;
    },
    getTabpre: function getTabpre(state) {
      return state.tabpre;
    },
    getTabpreList: function getTabpreList(state) {
      return state.tabpreList;
    },
    getTabpreItens: function getTabpreItens(state) {
      return state.tabpreItens;
    },
    getDestaq: function getDestaq(state) {
      return state.destaq;
    },
    getDestaqList: function getDestaqList(state) {
      return state.destaqList;
    },
    getTabdes: function getTabdes(state) {
      return state.tabdes;
    },
    getTabdesList: function getTabdesList(state) {
      return state.tabdesList;
    },

    getDocsList: function getDocsList(state) {
      return state.docsList;
    },

    getPdtipoList: function getPdtipoList(state) {
      return state.pdtipoList;
    },
    getPdtipo: function getPdtipo(state) {
      return state.pdtipo;
    },
    getPdstatusList: function getPdstatusList(state) {
      return state.pdstatusList;
    },
    getPdstatus: function getPdstatus(state) {
      return state.pdstatus;
    },
    getCondicaoList: function getCondicaoList(state) {
      return state.condicaoList;
    },
    getCondicao: function getCondicao(state) {
      return state.condicao;
    },
    getEquipeList: function getEquipeList(state) {
      return state.equipeList;
    },
    getEquipe: function getEquipe(state) {
      return state.equipe;
    },
    getAgendaList: function getAgendaList(state) {
      return state.agendaList;
    },
    getAgenda: function getAgenda(state) {
      return state.agenda;
    },
    getCatmktList: function getCatmktList(state) {
      return state.catmktList;
    },
    getCatmkt: function getCatmkt(state) {
      return state.catmkt;
    },
    getPessoa: function getPessoa(state) {
      return state.pessoa;
    },
    getPessoaList: function getPessoaList(state) {
      return state.pessoaList;
    },
    getOrganizacao: function getOrganizacao(state) {
      return state.organizacao;
    },
    getOrganizacaoList: function getOrganizacaoList(state) {
      return state.organizacaoList;
    },
    getNegocio: function getNegocio(state) {
      return state.negocio;
    },
    getNegocioList: function getNegocioList(state) {
      return state.negocioList;
    },
    getNegocioNoDateTimelineList: function getNegocioNoDateTimelineList(state) {
      return state.negocioNoDateTimelineList;
    },
    getNegocioHist: function getNegocioHist(state) {
      return state.negocioHist;
    },
    getNegocioEmails: function getNegocioEmails(state) {
      return state.negocioEmails;
    },
    getEmailCrm: function getEmailCrm(state) {
      return state.emailCrm;
    },
    getEmailCrmList: function getEmailCrmList(state) {
      return state.emailCrmList;
    },
    getLeadCrm: function getLeadCrm(state) {
      return state.leadCrm;
    },
    getLeadCrmList: function getLeadCrmList(state) {
      return state.leadCrmList;
    },
    getNegocioTotais: function getNegocioTotais(state) {
      return state.negocioTotais;
    },
    getConfigCrm: function getConfigCrm(state) {
      return state.configCrm;
    },
    getTagCrm: function getTagCrm(state) {
      return state.tagCrm;
    },
    getOrigemCrm: function getOrigemCrm(state) {
      return state.origemCrm;
    },
    getOrigemCrmList: function getOrigemCrmList(state) {
      return state.origemCrmList;
    },
    getFunilCrm: function getFunilCrm(state) {
      return state.funilCrm;
    },
    getMotivoCrm: function getMotivoCrm(state) {
      return state.motivoCrm;
    },
    getMotivoCrmList: function getMotivoCrmList(state) {
      return state.motivoCrmList;
    },
    getTemplEmail: function getTemplEmail(state) {
      return state.templEmail;
    },
    getTemplEmailList: function getTemplEmailList(state) {
      return state.templEmailList;
    },
    getManifestoList: function getManifestoList(state) {
      return state.manifestoList;
    },
    getManifesto: function getManifesto(state) {
      return state.manifesto;
    },
    getFreteList: function getFreteList(state) {
      return state.freteList;
    },

    getGuiaNFe: function getGuiaNFe(state) {
      return state.guiaNFe;
    },
    getNotificationsList: function getNotificationsList(state) {
      return state.notificationsList;
    },

    // LOJA

    getConfigLoja: function getConfigLoja(state) {
      return state.configLoja;
    },

    // FIM LOJA

    // PARAMETROS PDV

    getParamPDV: function getParamPDV(state) {
      return state.paramPDV;
    },

    getTeste: function getTeste(state) {
      return state.teste;
    },

    getIndexfiltroTiposManifesto: function getIndexfiltroTiposManifesto(state) {
      return state.indexfiltroTiposManifesto;
    }
  },

  mutations: {
    LOAD_ENV: function LOAD_ENV(state, data) {
      if (data.auth && data.auth.access_token) {
        state.env.token = data.auth.access_token;
      } else {
        state.env.token = null;
      }
      state.env.apptoken = data.login.apptoken;
      state.env.uuid = data.login.uuid;
      state.env.empresanome = data.login.empresanome;
      state.env.empresacod = data.login.empresacod;
      state.env.usuarionome = data.login.usuarionome;
      state.env.email = data.login.email;
      state.env.tpempresa = data.login.tpempresa;
      state.urlApi = data.login.urlapi;
      // state.urlApi = 'https://novo.notabrasil.com.br' + data.login.urlapi
      //armazena o objeto de autenticacao para utilizar ao recarregar a pagina
      window.sessionStorage.setItem("authObj", JSON.stringify(data));
    },
    LOAD_SESSAO: function LOAD_SESSAO(state, data) {
      state.sessao = {};
      if (data.items) {
        state.sessao = data.items[0];
      }
    },
    LOGOUT: function LOGOUT(state) {
      //remove a autenticacao para efetuar novo login
      Object.assign(state, getDefaultState());

      // state.env = {}
      window.sessionStorage.removeItem("authObj");
    },
    LOAD_METADATA: function LOAD_METADATA(state, entities) {
      state.entities = entities;
    },
    LOAD_PARTLIST: function LOAD_PARTLIST(state, data) {
      if (data.offset > 0) {
        var newItems = data.items.filter(function (newItem) {
          return !state.partList.some(function (existingItem) {
            return existingItem.codpart === newItem.codpart;
          });
        });
        state.partList = state.partList.concat(newItems);
      } else {
        state.partList = data.items;
      }
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_PARAMETROSUSUARIO: function LOAD_PARAMETROSUSUARIO(state, data) {
      state.parametrosUsuario = data;
    },
    LOAD_PART: function LOAD_PART(state, data) {
      state.part = data;
    },
    LOAD_PARTCONTATO: function LOAD_PARTCONTATO(state, data) {
      state.partContato = data;
    },
    LOAD_PARTPAINEL: function LOAD_PARTPAINEL(state, data) {
      state.partPainel = data;
    },
    LOAD_ITEM: function LOAD_ITEM(state, data) {
      state.item = data.items;
    },
    LOAD_ITEMLIST: function LOAD_ITEMLIST(state, data) {
      if (data.offset > 0) {
        var newItems = data.items.filter(function (newItem) {
          return !state.itemList.some(function (existingItem) {
            return existingItem.coditem === newItem.coditem;
          });
        });
        state.itemList = state.itemList.concat(newItems);
      } else {
        state.itemList = data.items;
      }
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_ITEMSALESLIST: function LOAD_ITEMSALESLIST(state, data) {
      if (data.items.length > 0 && data.items[0].tabelas_preco) {
        for (var x = 0; x < data.items.length; x++) {
          data.items[x].tabelas_preco = JSON.parse(data.items[x].tabelas_preco_json);
          if (!data.items[x].tabelas_preco) data.items[x].tabelas_preco = { tabelas: [] };
        }
      }

      if (data.offset > 0) state.itemSalesList = state.itemSalesList.concat(data.items);else state.itemSalesList = data.items;

      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    CLEAR_ITEMSALESLIST: function CLEAR_ITEMSALESLIST(state) {
      state.itemSalesList = {};
    },
    LOAD_ITEMSALESVAREJOLIST: function LOAD_ITEMSALESVAREJOLIST(state, data) {
      if (data.items.length > 0 && data.items[0].tabelas_preco) {
        for (var x = 0; x < data.items.length; x++) {
          data.items[x].tabelas_preco = JSON.parse(data.items[x].tabelas_preco_json);
          if (!data.items[x].tabelas_preco) data.items[x].tabelas_preco = { tabelas: [] };
        }
      }

      if (data.offset > 0) state.itemSalesVarejoList = state.itemSalesVarejoList.concat(data.items);else state.itemSalesVarejoList = data.items;

      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    CLEAR_ITEMSALESVAREJOLIST: function CLEAR_ITEMSALESVAREJOLIST(state) {
      state.itemSalesVarejoList = {};
    },
    CLEAR_ITEMLIST: function CLEAR_ITEMLIST(state) {
      state.itemList = {};
    },
    LOAD_ITEMTAXES: function LOAD_ITEMTAXES(state, data) {
      state.itemTaxes = data;
    },
    LOAD_NATES: function LOAD_NATES(state, data) {
      state.nates = data.items[0];
    },
    LOAD_NATESLIST: function LOAD_NATESLIST(state, data) {
      state.natesList = data.items;
    },
    LOAD_PEDVLIST: function LOAD_PEDVLIST(state, data) {
      //if (((data.offset) && (parseInt(data.offset) > 0)) || ((data.nextPage) && (parseInt(data.nextPage) > 0)))
      //  state.pedvList = state.pedvList.concat(data.items)
      //else

      if (data.nextPage && parseInt(data.nextPage) > 0) {
        var newItems = data.items.filter(function (newItem) {
          return !state.pedvList.some(function (existingItem) {
            return existingItem.codpedv === newItem.codpedv;
          });
        });
        state.pedvList = state.pedvList.concat(newItems);
      } else {
        state.pedvList = data.items;
      }

      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = (parseInt(data.limit) || 0) + (parseInt(data.nextPage) || 0);
      }

      //state.nextPage = 0
      //if (data.hasMore == "true") {
      //  if (data.offset)
      //    state.nextPage = parseInt(data.limit) + parseInt(data.offset)
      //  if (data.nextPage)
      //    state.nextPage = parseInt(data.limit) + parseInt(data.nextPage)
      //}
    },
    LOAD_PEDVTOTAL: function LOAD_PEDVTOTAL(state, data) {
      state.pedvTotal = data.items;
    },
    LOAD_PEDV: function LOAD_PEDV(state, items) {
      state.pedv = items;
    },
    LOAD_PEDVATUALUSUARIO: function LOAD_PEDVATUALUSUARIO(state, data) {
      state.pedv = data;
    },
    LOAD_VDEVOL: function LOAD_VDEVOL(state, items) {
      state.vDevol = items;
    },
    LOAD_VDEVOLLIST: function LOAD_VDEVOLLIST(state, data) {
      state.vDevolList = data.items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_NFLIST: function LOAD_NFLIST(state, data) {
      state.nfList = data.items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_COMPRALIST: function LOAD_COMPRALIST(state, data) {
      if (data.offset > 0) state.compraList = state.compraList.concat(data.items);else state.compraList = data.items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_COMPRA: function LOAD_COMPRA(state, data) {
      state.compra = data.items[0];
      if (!state.compra.comprait) state.compra.comprait = [];
      if (!state.compra.comprapar) state.compra.comprapar = [];
    },
    LOAD_NF_WITH_ITEMLIST: function LOAD_NF_WITH_ITEMLIST(state, data) {
      state.nf_with_itemList = data.items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_LISTNF: function LOAD_LISTNF(state, data) {
      state.nfList = data.items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_NFORIGEM: function LOAD_NFORIGEM(state, data) {
      state.nfOrigem = data.items;
    },
    LOAD_NF: function LOAD_NF(state, items) {
      state.nf = items;
    },
    LOAD_DILIST: function LOAD_DILIST(state, data) {
      state.diList = data.items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_DI: function LOAD_DI(state, items) {
      state.di = items;
    },
    LOAD_DUIMPLIST: function LOAD_DUIMPLIST(state, data) {
      state.duimpList = data.items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_DUIMP: function LOAD_DUIMP(state, items) {
      state.duimp = items;
    },
    LOAD_REGRAFCP: function LOAD_REGRAFCP(state, data) {
      state.regrafcp = data.items[0];
    },
    LOAD_REGRAFCPLIST: function LOAD_REGRAFCPLIST(state, data) {
      state.regrafcpList = data.items;
    },
    LOAD_REGRAST: function LOAD_REGRAST(state, items) {
      state.regrast = items;
    },
    LOAD_REGRASTLIST: function LOAD_REGRASTLIST(state, items) {
      state.regrastList = items;
    },
    LOAD_REGRAIMP: function LOAD_REGRAIMP(state, items) {
      state.regraimp = items;
    },
    LOAD_REGRAIMPLIST: function LOAD_REGRAIMPLIST(state, items) {
      state.regraimpList = items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_GRUTRIB: function LOAD_GRUTRIB(state, data) {
      state.grutrib = data.items[0];
    },
    LOAD_GRUTRIBLIST: function LOAD_GRUTRIBLIST(state, data) {
      state.grutribList = data.items;
    },
    LOAD_ESTADOLIST: function LOAD_ESTADOLIST(state, data) {
      state.estadoList = data.items;
    },
    LOAD_ESTADO: function LOAD_ESTADO(state, data) {
      state.estado = data.items[0];
    },
    LOAD_IVANCMLIST: function LOAD_IVANCMLIST(state, data) {
      state.ivancmList = data.items;
    },
    LOAD_IVANCM: function LOAD_IVANCM(state, data) {
      state.ivancm = data.items[0];
    },
    LOAD_IVACLASSLIST: function LOAD_IVACLASSLIST(state, data) {
      state.ivaclassList = data.items;
    },
    LOAD_IVACLASS: function LOAD_IVACLASS(state, data) {
      state.ivaclass = data.items[0];
    },
    LOAD_UNIMEDLIST: function LOAD_UNIMEDLIST(state, items) {
      state.unimedList = items;
    },
    LOAD_UNIMED: function LOAD_UNIMED(state, items) {
      state.unimed = items;
    },
    LOAD_NCMLIST: function LOAD_NCMLIST(state, data) {
      state.ncmList = data.items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_NCM: function LOAD_NCM(state, items) {
      state.ncm = items;
    },
    LOAD_GRUESTLIST: function LOAD_GRUESTLIST(state, data) {
      state.gruestList = data.items;
    },
    LOAD_GRUEST: function LOAD_GRUEST(state, data) {
      state.gruest = data.items[0];
    },
    LOAD_GRUFORLIST: function LOAD_GRUFORLIST(state, data) {
      state.gruforList = data.items;
    },
    LOAD_GRUFOR: function LOAD_GRUFOR(state, data) {
      state.grufor = data.items[0];
    },
    LOAD_GRUCLILIST: function LOAD_GRUCLILIST(state, data) {
      state.grucliList = data.items;
    },
    LOAD_GRUCLI: function LOAD_GRUCLI(state, data) {
      state.grucli = data.items[0];
    },
    LOAD_XMLHISTLIST: function LOAD_XMLHISTLIST(state, data) {
      state.xmlhistList = data.items;
    },
    LOAD_XMLHIST: function LOAD_XMLHIST(state, data) {
      state.xmlhist = data.items[0];
    },
    LOAD_MENNFLIST: function LOAD_MENNFLIST(state, data) {
      state.mennfList = data.items;
    },
    LOAD_MENNF: function LOAD_MENNF(state, data) {
      state.mennf = data.items[0];
    },
    LOAD_VENDLIST: function LOAD_VENDLIST(state, data) {
      state.vendList = data.items;
    },
    LOAD_VEND: function LOAD_VEND(state, data) {
      state.vend = data.items[0];
    },
    LOAD_FILIALLIST: function LOAD_FILIALLIST(state, data) {
      state.filialList = data.items;
    },
    LOAD_FILIAL: function LOAD_FILIAL(state, data) {
      state.filial = data.items[0];
    },
    LOAD_USUARIOLIST: function LOAD_USUARIOLIST(state, data) {
      state.usuarioList = data.items;
    },
    LOAD_USUARIO: function LOAD_USUARIO(state, data) {
      state.usuario = data.items[0];
    },
    LOAD_DEPOSITOLIST: function LOAD_DEPOSITOLIST(state, data) {
      state.depositoList = data.items;
    },
    LOAD_DEPOSITO: function LOAD_DEPOSITO(state, data) {
      state.deposito = data.items[0];
    },
    LOAD_SERIENFLIST: function LOAD_SERIENFLIST(state, data) {
      state.serienfList = data.items;
    },
    LOAD_SERIENF: function LOAD_SERIENF(state, data) {
      state.serienf = data.items[0];
    },
    LOAD_CONTADORLIST: function LOAD_CONTADORLIST(state, data) {
      state.contadorList = data.items;
    },
    LOAD_CONTADOR: function LOAD_CONTADOR(state, data) {
      state.contador = data.items[0];
    },
    LOAD_NATFINLIST: function LOAD_NATFINLIST(state, data) {
      state.natfinList = data.items;
    },
    LOAD_NATFIN: function LOAD_NATFIN(state, data) {
      state.natfin = data.items[0];
    },
    LOAD_RAMOATLIST: function LOAD_RAMOATLIST(state, data) {
      state.ramoatList = data.items;
    },
    LOAD_RAMOAT: function LOAD_RAMOAT(state, data) {
      state.ramoat = data.items[0];
    },
    LOAD_INUTLIST: function LOAD_INUTLIST(state, data) {
      state.inutList = data.items;
    },
    LOAD_NFAVISOS: function LOAD_NFAVISOS(state, data) {
      state.nfAvisos = data.items;
    },
    LOAD_INUT: function LOAD_INUT(state, data) {
      state.inut = data.items[0];
    },
    LOAD_CTALIST: function LOAD_CTALIST(state, data) {
      state.ctaList = data.items;
    },
    LOAD_CTA: function LOAD_CTA(state, data) {
      state.cta = data.items[0];
    },
    LOAD_FPAGLIST: function LOAD_FPAGLIST(state, data) {
      state.fpagList = data.items;
    },
    LOAD_FPAG: function LOAD_FPAG(state, data) {
      state.fpag = data.items[0];
    },
    LOAD_VCAIXALIST: function LOAD_VCAIXALIST(state, data) {
      state.vcaixaList = data.items;
    },
    LOAD_VCAIXA: function LOAD_VCAIXA(state, data) {
      state.vcaixa = data.items[0];
    },
    LOAD_BANCO: function LOAD_BANCO(state, data) {
      state.bancoList = data.items;
    },
    LOAD_CNABSEMVINCULO: function LOAD_CNABSEMVINCULO(state, data) {
      state.cnabSemVinculo = data.items;
    },
    LOAD_CNABPENDENTE: function LOAD_CNABPENDENTE(state, data) {
      state.cnabPendente = data.items;
    },
    LOAD_CNABREMLIST: function LOAD_CNABREMLIST(state, data) {
      state.cnabRemList = data.items;
    },
    LOAD_CNABREJLIST: function LOAD_CNABREJLIST(state, data) {
      state.cnabRejList = data.items;
    },
    LOAD_CNABRETLIST: function LOAD_CNABRETLIST(state, data) {
      state.cnabRetList = data.items;
    },
    LOAD_CNABRETDETLIST: function LOAD_CNABRETDETLIST(state, data) {
      state.cnabRetDetList = data.items;
    },
    LOAD_FIN: function LOAD_FIN(state, data) {
      state.fin = data.items[0];
    },
    LOAD_LOG: function LOAD_LOG(state, data) {
      state.logList = data.items;
    },
    LOAD_GRADELIST: function LOAD_GRADELIST(state, data) {
      state.gradeList = data.items;
    },
    LOAD_GRADE: function LOAD_GRADE(state, data) {
      state.grade = data.items[0];
    },
    LOAD_DESTAQLIST: function LOAD_DESTAQLIST(state, data) {
      state.destaqList = data.items;
    },
    LOAD_DESTAQ: function LOAD_DESTAQ(state, data) {
      state.destaq = data.items[0];
    },
    LOAD_TABDESLIST: function LOAD_TABDESLIST(state, data) {
      state.tabdesList = data.items;
    },
    LOAD_TABDES: function LOAD_TABDES(state, data) {
      state.tabdes = data.items[0];
    },
    LOAD_TABPREITENS: function LOAD_TABPREITENS(state, data) {
      state.tabpreItens = data.items;
    },
    LOAD_TABPRELIST: function LOAD_TABPRELIST(state, data) {
      state.tabpreList = data.items;
    },
    LOAD_TABPRE: function LOAD_TABPRE(state, data) {
      state.tabpre = data.items[0];
    },
    LOAD_DOCS: function LOAD_DOCS(state, data) {
      state.docsList = data.items;
    },
    LOAD_PDTIPOLIST: function LOAD_PDTIPOLIST(state, data) {
      state.pdtipoList = data.items;
    },
    LOAD_PDTIPO: function LOAD_PDTIPO(state, data) {
      state.pdtipo = data.items[0];
    },
    LOAD_PDSTATUSLIST: function LOAD_PDSTATUSLIST(state, data) {
      state.pdstatusList = data.items;
    },
    LOAD_PDSTATUS: function LOAD_PDSTATUS(state, data) {
      state.pdstatus = data.items[0];
    },
    LOAD_CONDICAOLIST: function LOAD_CONDICAOLIST(state, data) {
      state.condicaoList = data.items;
    },
    LOAD_CONDICAO: function LOAD_CONDICAO(state, data) {
      state.condicao = data.items[0];
    },
    LOAD_EQUIPELIST: function LOAD_EQUIPELIST(state, data) {
      state.equipeList = data.items;
    },
    LOAD_EQUIPE: function LOAD_EQUIPE(state, data) {
      state.equipe = data.items[0];
    },
    LOAD_AGENDALIST: function LOAD_AGENDALIST(state, data) {
      state.agendaList = data.items;
    },
    LOAD_AGENDA: function LOAD_AGENDA(state, data) {
      state.agenda = data.items[0];
    },
    LOAD_CATMKTLIST: function LOAD_CATMKTLIST(state, data) {
      state.catmktList = data.items;
    },
    LOAD_CATMKT: function LOAD_CATMKT(state, data) {
      state.catmkt = data.items[0];
    },
    LOAD_PESSOALIST: function LOAD_PESSOALIST(state, data) {
      state.pessoaList = data.items;
    },
    LOAD_PESSOA: function LOAD_PESSOA(state, data) {
      state.pessoa = data.items[0];
    },
    LOAD_ORGANIZACAOLIST: function LOAD_ORGANIZACAOLIST(state, data) {
      state.organizacaoList = data.items;
    },
    LOAD_ORGANIZACAO: function LOAD_ORGANIZACAO(state, data) {
      state.organizacao = data.items[0];
    },
    LOAD_NEGOCIOLIST: function LOAD_NEGOCIOLIST(state, data) {
      state.negocioList = data.items;
    },
    LOAD_NEGOCIONODATELIST: function LOAD_NEGOCIONODATELIST(state, data) {
      if (data.items.length > 0) state.negocioNoDateTimelineList = data.items[0];
    },
    LOAD_NEGOCIOHIST: function LOAD_NEGOCIOHIST(state, data) {
      state.negocioHist = data.items;
    },
    LOAD_NEGOCIOEMAILS: function LOAD_NEGOCIOEMAILS(state, data) {
      state.negocioEmails = data.items;
    },
    LOAD_EMAILCRM: function LOAD_EMAILCRM(state, data) {
      state.emailCrm = data.items[0];
    },
    LOAD_EMAILCRMLIST: function LOAD_EMAILCRMLIST(state, data) {
      state.emailCrmList = data.items;
    },
    LOAD_LEADCRM: function LOAD_LEADCRM(state, data) {
      state.leadCrm = data.items[0];
    },
    LOAD_LEADCRMLIST: function LOAD_LEADCRMLIST(state, data) {
      state.leadCrmList = data.items;
    },
    LOAD_NEGOCIOTOTAIS: function LOAD_NEGOCIOTOTAIS(state, data) {
      state.negocioTotais = data.items;
    },
    LOAD_NEGOCIO: function LOAD_NEGOCIO(state, data) {
      state.negocio = data.items[0];
    },
    LOAD_CONFIGCRM: function LOAD_CONFIGCRM(state, data) {
      state.configCrm = data.items[0];
    },
    LOAD_TAGCRM: function LOAD_TAGCRM(state, data) {
      state.tagCrm = data.items[0];
    },
    LOAD_ORIGEMCRM: function LOAD_ORIGEMCRM(state, data) {
      state.origemCrm = data.items[0];
    },
    LOAD_ORIGEMCRMLIST: function LOAD_ORIGEMCRMLIST(state, data) {
      state.origemCrmList = data.items;
    },
    LOAD_MOTIVOCRM: function LOAD_MOTIVOCRM(state, data) {
      state.motivoCrm = data.items[0];
    },
    LOAD_MOTIVOCRMLIST: function LOAD_MOTIVOCRMLIST(state, data) {
      state.motivoCrmList = data.items;
    },
    LOAD_FUNILCRM: function LOAD_FUNILCRM(state, data) {
      state.funilCrm = data.items[0];
    },
    LOAD_TEMPLEMAIL: function LOAD_TEMPLEMAIL(state, data) {
      state.templEmail = data.items[0];
    },
    LOAD_TEMPLEMAILLIST: function LOAD_TEMPLEMAILLIST(state, data) {
      state.templEmailList = data.items;
    },
    LOAD_CONFIGLOJA: function LOAD_CONFIGLOJA(state, data) {
      state.configLoja = data.items[0];
    },
    LOAD_GUIANFE: function LOAD_GUIANFE(state, data) {
      state.guiaNFe = data;
    },
    LOAD_NOTIFICATIONSLIST: function LOAD_NOTIFICATIONSLIST(state, data) {
      if (data.offset > 0) state.notificationsList = state.notificationsList.concat(data.items);else state.notificationsList = data.items;
      state.nextPage = 0;

      if (data.hasMore) {
        state.nextPage = parseInt(data.limit) + parseInt(data.offset);
      }
    },
    LOAD_TESTE: function LOAD_TESTE(state, data) {
      state.teste = data.items;
    },
    CLEAN_PART: function CLEAN_PART(state) {
      state.partList = {};
      state.part = {};
    },
    LOAD_MANIFESTOLIST: function LOAD_MANIFESTOLIST(state, data) {
      state.manifestoList = data.items;
    },
    LOAD_MANIFESTO: function LOAD_MANIFESTO(state, data) {
      state.manifesto = data.items[0];
    },
    LOAD_FRETELIST: function LOAD_FRETELIST(state, data) {
      state.freteList = data.items;
    },


    SET_INDEXFILTROTIPOSMANIFESTO: function SET_INDEXFILTROTIPOSMANIFESTO(state, data) {
      state.indexfiltroTiposManifesto = data;
    }
  },

  actions: {
    loadEnv: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, data) {
        var commit = _ref.commit;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit("LOAD_ENV", data);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadEnv(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return loadEnv;
    }(),
    loadSessao: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3, vm) {
        var commit = _ref3.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _apiFunctions.apiORDSapp)(vm, "sessao/", "get", null);

              case 2:
                data = _context2.sent;

                commit("LOAD_SESSAO", data);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadSessao(_x3, _x4) {
        return _ref4.apply(this, arguments);
      }

      return loadSessao;
    }(),
    logout: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref5) {
        var commit = _ref5.commit;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit("LOGOUT");

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function logout(_x5) {
        return _ref6.apply(this, arguments);
      }

      return logout;
    }(),
    loadMetadata: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref7) {
        var commit = _ref7.commit;
        var entities;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _apiFunctions.apiMetadata)(this.getters.urlMetadata);

              case 2:
                entities = _context4.sent;

                commit("LOAD_METADATA", entities);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function loadMetadata(_x6) {
        return _ref8.apply(this, arguments);
      }

      return loadMetadata;
    }(),
    loadParametrosUsuario: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref9) {
        var commit = _ref9.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "sales/parametros_usuario", {});

              case 2:
                data = _context5.sent;

                if (data.items.length && data.items[0].parametros) {
                  commit("LOAD_PARAMETROSUSUARIO", JSON.parse(data.items[0].parametros));
                } else {
                  commit("LOAD_PARAMETROSUSUARIO", {});
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function loadParametrosUsuario(_x7) {
        return _ref10.apply(this, arguments);
      }

      return loadParametrosUsuario;
    }(),
    loadUsuariosDashboard: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref11) {
        var commit = _ref11.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "dashboard/usuarios", {}, true);

              case 2:
                data = _context6.sent;

                if (data.items) {
                  commit("LOAD_USUARIOLIST", data);
                }

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function loadUsuariosDashboard(_x8) {
        return _ref12.apply(this, arguments);
      }

      return loadUsuariosDashboard;
    }(),
    loadEquipesDashboard: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref13) {
        var commit = _ref13.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "dashboard/equipes", {}, true);

              case 2:
                data = _context7.sent;

                if (data.items) {
                  commit("LOAD_EQUIPELIST", data);
                }

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function loadEquipesDashboard(_x9) {
        return _ref14.apply(this, arguments);
      }

      return loadEquipesDashboard;
    }(),


    //PARTICIPANTES
    loadPart: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref15, params) {
        var commit = _ref15.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/part/", params);

              case 2:
                data = _context8.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_PART", data.items);
                  } else {
                    commit("LOAD_PARTLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function loadPart(_x10, _x11) {
        return _ref16.apply(this, arguments);
      }

      return loadPart;
    }(),


    //TRANSPORTADORAS
    loadTransportadoras: function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(_ref17, params) {
        var commit = _ref17.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/part/transportadoras/", params);

              case 2:
                data = _context9.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_PART", data.items);
                  } else {
                    commit("LOAD_PARTLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function loadTransportadoras(_x12, _x13) {
        return _ref18.apply(this, arguments);
      }

      return loadTransportadoras;
    }(),
    loadPartDoc: function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(_ref19, params) {
        var commit = _ref19.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                url = this.getters.urlOrds + "cg/part/" + params.tppessoa + "/" + params.cnpjcpf;
                _context10.next = 3;
                return (0, _apiFunctions.apiORDS)(url);

              case 3:
                data = _context10.sent;

                if (data.items) {
                  commit("LOAD_PART", data.items);
                }

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function loadPartDoc(_x14, _x15) {
        return _ref20.apply(this, arguments);
      }

      return loadPartDoc;
    }(),
    loadPartPainel: function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(_ref21, params) {
        var commit = _ref21.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                url = this.getters.urlOrds + "cg/part/" + params.id + "/painel/";
                _context11.next = 3;
                return (0, _apiFunctions.apiORDS)(url);

              case 3:
                data = _context11.sent;

                if (data.items && data.items.length) {
                  commit("LOAD_PARTPAINEL", data.items[0]);
                }

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function loadPartPainel(_x16, _x17) {
        return _ref22.apply(this, arguments);
      }

      return loadPartPainel;
    }(),
    loadCliente: function () {
      var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(_ref23, params) {
        var commit = _ref23.commit;
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                modulo = "select/cliente2/";

                if (params.participante) modulo = "select/participante/";else if (params.forcaVendas) modulo = "select/forcavendas/cliente2/";
                _context12.next = 4;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + modulo, params);

              case 4:
                data = _context12.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_PART", data.items);
                  } else {
                    commit("LOAD_PARTLIST", data);
                  }
                }

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function loadCliente(_x18, _x19) {
        return _ref24.apply(this, arguments);
      }

      return loadCliente;
    }(),


    //CONTATO DE PARTICIPANTES
    loadPartcontato: function () {
      var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(_ref25, params) {
        var commit = _ref25.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/partcontato/" + params.codpart + "/", params);

              case 2:
                data = _context13.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_PARTCONTATO", data.items);
                  }
                }

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function loadPartcontato(_x20, _x21) {
        return _ref26.apply(this, arguments);
      }

      return loadPartcontato;
    }(),


    //ITENS
    loadItem: function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(_ref27, params) {
        var commit = _ref27.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/item/", params);

              case 2:
                data = _context14.sent;

                if (data.items) {
                  commit("LOAD_ITEM", data);
                }

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function loadItem(_x22, _x23) {
        return _ref28.apply(this, arguments);
      }

      return loadItem;
    }(),
    loadItemList: function () {
      var _ref30 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(_ref29, params) {
        var commit = _ref29.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/item/", params);

              case 2:
                data = _context15.sent;

                if (data.items) {
                  commit("LOAD_ITEMLIST", data);
                }

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function loadItemList(_x24, _x25) {
        return _ref30.apply(this, arguments);
      }

      return loadItemList;
    }(),
    loadItemSales: function () {
      var _ref32 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(_ref31, params) {
        var commit = _ref31.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                url = "";

                if (params.produtosDestaque) url = "item/sales/destaques/tabpre/";else if (params.produtosVarejo) url = "item/sales/varejo/tabpre/";else url = "item/sales/tabpre/";

                if (params.codtabpre) {
                  url = url + params.codtabpre + "/";
                } else {
                  url = url + "null/";
                }

                if (params.coditem) {
                  url = url + params.coditem;
                } else {
                  url = url + "pedido/";
                  if (params.codpedv) {
                    url = url + params.codpedv + "/";
                  } else {
                    url = url + "0/";
                  }
                }
                _context16.next = 6;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + url, params);

              case 6:
                data = _context16.sent;


                if (data.items) {
                  commit("LOAD_ITEMSALESLIST", data);
                }

              case 8:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function loadItemSales(_x26, _x27) {
        return _ref32.apply(this, arguments);
      }

      return loadItemSales;
    }(),
    loadItemSalesVarejo: function () {
      var _ref34 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(_ref33, params) {
        var commit = _ref33.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                url = "";

                url = "item/sales/varejo/tabpre/";

                if (params.codtabpre) {
                  url = url + params.codtabpre + "/";
                } else {
                  url = url + "null/";
                }

                if (params.coditem) {
                  url = url + params.coditem;
                } else {
                  url = url + "pedido/";
                  if (params.codpedv) {
                    url = url + params.codpedv + "/";
                  } else {
                    url = url + "0/";
                  }
                }

                console.log("chamada feita", url, params);
                _context17.next = 7;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + url, params);

              case 7:
                data = _context17.sent;


                if (data.items) {
                  commit("LOAD_ITEMSALESVAREJOLIST", data);
                }

              case 9:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function loadItemSalesVarejo(_x28, _x29) {
        return _ref34.apply(this, arguments);
      }

      return loadItemSalesVarejo;
    }(),
    clearItemSales: function () {
      var _ref36 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(_ref35) {
        var commit = _ref35.commit;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                commit("CLEAR_ITEMSALESLIST");

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function clearItemSales(_x30) {
        return _ref36.apply(this, arguments);
      }

      return clearItemSales;
    }(),
    clearItemVarejoSales: function () {
      var _ref38 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(_ref37) {
        var commit = _ref37.commit;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                commit("CLEAR_ITEMSALESVAREJOLIST");

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function clearItemVarejoSales(_x31) {
        return _ref38.apply(this, arguments);
      }

      return clearItemVarejoSales;
    }(),
    clearItemList: function () {
      var _ref40 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(_ref39) {
        var commit = _ref39.commit;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                commit("CLEAR_ITEMLIST");

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function clearItemList(_x32) {
        return _ref40.apply(this, arguments);
      }

      return clearItemList;
    }(),
    loadPesquisaProdutosSales: function () {
      var _ref42 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(_ref41, params) {
        var commit = _ref41.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                url = "item/sales/pesquisa/produtos";
                _context21.next = 3;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + url, params);

              case 3:
                data = _context21.sent;

                if (data.items) {
                  commit("LOAD_ITEMSALESLIST", data);
                }

              case 5:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function loadPesquisaProdutosSales(_x33, _x34) {
        return _ref42.apply(this, arguments);
      }

      return loadPesquisaProdutosSales;
    }(),


    //CARREGA IMPOSTOS DO ITEM (INCLUSAO DE ITEM NA NF)
    loadItemTaxes: function () {
      var _ref44 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(_ref43, sendData) {
        var commit = _ref43.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return (0, _apiFunctions.apiORDSpost)(this, "invoice/gettaxes/", sendData, "post");

              case 2:
                data = _context22.sent;

                if (data) {
                  commit("LOAD_ITEMTAXES", data);
                }

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function loadItemTaxes(_x35, _x36) {
        return _ref44.apply(this, arguments);
      }

      return loadItemTaxes;
    }(),


    //NATES
    loadNates: function () {
      var _ref46 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(_ref45, params) {
        var commit = _ref45.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/nates/", params);

              case 2:
                data = _context23.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_NATES", data);
                  } else {
                    commit("LOAD_NATESLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function loadNates(_x37, _x38) {
        return _ref46.apply(this, arguments);
      }

      return loadNates;
    }(),


    //PEDIDO DE VENDA
    loadPedvList: function () {
      var _ref48 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(_ref47, params) {
        var commit = _ref47.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "sales/pedv/", params);

              case 2:
                data = _context24.sent;

                if (data.items) {
                  commit("LOAD_PEDVLIST", data);
                }

              case 4:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function loadPedvList(_x39, _x40) {
        return _ref48.apply(this, arguments);
      }

      return loadPedvList;
    }(),
    loadPedvTotal: function () {
      var _ref50 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(_ref49, params) {
        var commit = _ref49.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "sales/pedv/total/", params);

              case 2:
                data = _context25.sent;

                if (data.items) {
                  commit("LOAD_PEDVTOTAL", data);
                }

              case 4:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function loadPedvTotal(_x41, _x42) {
        return _ref50.apply(this, arguments);
      }

      return loadPedvTotal;
    }(),
    loadPedv: function () {
      var _ref52 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(_ref51, params) {
        var commit = _ref51.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "sales/pedv/", params);

              case 2:
                data = _context26.sent;

                if (data.items) {
                  commit("LOAD_PEDV", data.items);
                }

              case 4:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function loadPedv(_x43, _x44) {
        return _ref52.apply(this, arguments);
      }

      return loadPedv;
    }(),
    loadPedvAtualUsuario: function () {
      var _ref54 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27(_ref53, params) {
        var commit = _ref53.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "sales/pedv/atualusuario/", params);

              case 2:
                data = _context27.sent;

                if (data.items[0]) {
                  commit("LOAD_PEDVATUALUSUARIO", data.items[0]);
                } else commit("LOAD_PEDVATUALUSUARIO", {});

              case 4:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function loadPedvAtualUsuario(_x45, _x46) {
        return _ref54.apply(this, arguments);
      }

      return loadPedvAtualUsuario;
    }(),


    // DEVOLUCAO VAREJO
    loadVdevolPed: function () {
      var _ref56 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28(_ref55, params) {
        var commit = _ref55.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "varejo/devolucao/pedido/", params);

              case 2:
                data = _context28.sent;

                if (data) {
                  commit("LOAD_VDEVOL", data);
                }

              case 4:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function loadVdevolPed(_x47, _x48) {
        return _ref56.apply(this, arguments);
      }

      return loadVdevolPed;
    }(),
    loadVdevol: function () {
      var _ref58 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29(_ref57, params) {
        var commit = _ref57.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "varejo/devolucao/", params);

              case 2:
                data = _context29.sent;

                if (data) {
                  commit("LOAD_VDEVOL", data);
                }

              case 4:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function loadVdevol(_x49, _x50) {
        return _ref58.apply(this, arguments);
      }

      return loadVdevol;
    }(),
    loadvDevolList: function () {
      var _ref60 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30(_ref59, params) {
        var commit = _ref59.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "varejo/devolucao/list", params);

              case 2:
                data = _context30.sent;

                if (data) {
                  commit("LOAD_VDEVOLLIST", data);
                }

              case 4:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function loadvDevolList(_x51, _x52) {
        return _ref60.apply(this, arguments);
      }

      return loadvDevolList;
    }(),


    //NOTA FISCAL
    loadNfList: function () {
      var _ref62 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31(_ref61, params) {
        var commit = _ref61.commit;
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                modulo = "invoice/list/";

                if (params.operacao) {
                  modulo = modulo + params.operacao;
                } else {
                  modulo = modulo + "saida";
                }
                _context31.next = 4;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + modulo, params);

              case 4:
                data = _context31.sent;

                if (data.items) {
                  commit("LOAD_NFLIST", data);
                }

              case 6:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function loadNfList(_x53, _x54) {
        return _ref62.apply(this, arguments);
      }

      return loadNfList;
    }(),
    loadCompraList: function () {
      var _ref64 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32(_ref63, params) {
        var commit = _ref63.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + 'purchase/compra/', params);

              case 2:
                data = _context32.sent;

                if (data.items) {
                  commit('LOAD_COMPRALIST', data);
                }

              case 4:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function loadCompraList(_x55, _x56) {
        return _ref64.apply(this, arguments);
      }

      return loadCompraList;
    }(),
    loadCompra: function () {
      var _ref66 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee33(_ref65, params) {
        var commit = _ref65.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + 'purchase/compra/', params);

              case 2:
                data = _context33.sent;

                if (data.items) {
                  commit('LOAD_COMPRA', data);
                }

              case 4:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function loadCompra(_x57, _x58) {
        return _ref66.apply(this, arguments);
      }

      return loadCompra;
    }(),
    loadNf_with_itemList: function () {
      var _ref68 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee34(_ref67, params) {
        var commit = _ref67.commit;
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                modulo = "invoice/list_with_item/";

                if (params.operacao) {
                  modulo = modulo + params.operacao;
                } else {
                  modulo = modulo + "saida";
                }
                _context34.next = 4;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + modulo, params);

              case 4:
                data = _context34.sent;

                if (data.items) {
                  commit("LOAD_NF_WITH_ITEMLIST", data);
                }

              case 6:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function loadNf_with_itemList(_x59, _x60) {
        return _ref68.apply(this, arguments);
      }

      return loadNf_with_itemList;
    }(),
    loadListNf: function () {
      var _ref70 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee35(_ref69, params) {
        var commit = _ref69.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "invoice/listnf/", params);

              case 2:
                data = _context35.sent;

                if (data.items) {
                  commit("LOAD_LISTNF", data);
                }

              case 4:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function loadListNf(_x61, _x62) {
        return _ref70.apply(this, arguments);
      }

      return loadListNf;
    }(),
    loadNf: function () {
      var _ref72 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee36(_ref71, params) {
        var commit = _ref71.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "invoice/nf/", params);

              case 2:
                data = _context36.sent;

                if (data.items) {
                  commit("LOAD_NF", data.items);
                }

              case 4:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function loadNf(_x63, _x64) {
        return _ref72.apply(this, arguments);
      }

      return loadNf;
    }(),
    loadNf_impnfe: function () {
      var _ref74 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee37(_ref73, params) {
        var commit = _ref73.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "invoice/importxml/", params);

              case 2:
                data = _context37.sent;

                if (data.items) {
                  commit("LOAD_NF", data.items);
                }

              case 4:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function loadNf_impnfe(_x65, _x66) {
        return _ref74.apply(this, arguments);
      }

      return loadNf_impnfe;
    }(),
    loadNfOrigem: function () {
      var _ref76 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee38(_ref75, params) {
        var commit = _ref75.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "invoice/origem/" + params.operacaoNf + "/" + params.codpart + "/", params);

              case 2:
                data = _context38.sent;

                if (data.items) {
                  commit("LOAD_NFORIGEM", data);
                }

              case 4:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function loadNfOrigem(_x67, _x68) {
        return _ref76.apply(this, arguments);
      }

      return loadNfOrigem;
    }(),


    //DI - DECLARACAO DE IMPORTACA
    loadDiList: function () {
      var _ref78 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee39(_ref77, params) {
        var commit = _ref77.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "invoice/di/list/", params);

              case 2:
                data = _context39.sent;

                if (data.items) {
                  commit("LOAD_DILIST", data);
                }

              case 4:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function loadDiList(_x69, _x70) {
        return _ref78.apply(this, arguments);
      }

      return loadDiList;
    }(),
    loadDi: function () {
      var _ref80 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee40(_ref79, params) {
        var commit = _ref79.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                _context40.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "invoice/di/", params);

              case 2:
                data = _context40.sent;

                if (data.items) {
                  commit("LOAD_DI", data.items);
                }

              case 4:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function loadDi(_x71, _x72) {
        return _ref80.apply(this, arguments);
      }

      return loadDi;
    }(),
    loadDuimpList: function () {
      var _ref82 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee41(_ref81, params) {
        var commit = _ref81.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                _context41.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + 'invoice/duimp/list/', params);

              case 2:
                data = _context41.sent;

                if (data.items) {
                  commit('LOAD_DUIMPLIST', data);
                }

              case 4:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));

      function loadDuimpList(_x73, _x74) {
        return _ref82.apply(this, arguments);
      }

      return loadDuimpList;
    }(),
    loadDuimp: function () {
      var _ref84 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee42(_ref83, params) {
        var commit = _ref83.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                _context42.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + 'invoice/duimp/', params);

              case 2:
                data = _context42.sent;

                if (data.items) {
                  commit('LOAD_DUIMP', data.items);
                }

              case 4:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function loadDuimp(_x75, _x76) {
        return _ref84.apply(this, arguments);
      }

      return loadDuimp;
    }(),


    //UNIDADES DE MEDIDA
    loadUnimedList: function () {
      var _ref86 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee43(_ref85, params) {
        var commit = _ref85.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/unimed/", params);

              case 2:
                data = _context43.sent;

                if (data.items) {
                  commit("LOAD_UNIMEDLIST", data.items);
                }

              case 4:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function loadUnimedList(_x77, _x78) {
        return _ref86.apply(this, arguments);
      }

      return loadUnimedList;
    }(),
    loadUnimed: function () {
      var _ref88 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee44(_ref87, params) {
        var commit = _ref87.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                _context44.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/unimed/", params);

              case 2:
                data = _context44.sent;

                if (data.items) {
                  commit("LOAD_UNIMED", data.items[0]);
                }

              case 4:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));

      function loadUnimed(_x79, _x80) {
        return _ref88.apply(this, arguments);
      }

      return loadUnimed;
    }(),


    //NCM
    loadNcmList: function () {
      var _ref90 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee45(_ref89, params) {
        var commit = _ref89.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                _context45.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/ncm/", params);

              case 2:
                data = _context45.sent;

                if (data.items) {
                  commit("LOAD_NCMLIST", data);
                }

              case 4:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));

      function loadNcmList(_x81, _x82) {
        return _ref90.apply(this, arguments);
      }

      return loadNcmList;
    }(),
    loadNcm: function () {
      var _ref92 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee46(_ref91, params) {
        var commit = _ref91.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                _context46.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/ncm/", params);

              case 2:
                data = _context46.sent;

                if (data.items) {
                  commit("LOAD_NCM", data.items[0]);
                }

              case 4:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));

      function loadNcm(_x83, _x84) {
        return _ref92.apply(this, arguments);
      }

      return loadNcm;
    }(),


    //GRUPOS DE ESTOQUE
    loadGruest: function () {
      var _ref94 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee47(_ref93, params) {
        var commit = _ref93.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                _context47.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/gruest/", params);

              case 2:
                data = _context47.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_GRUEST", data);
                  } else {
                    commit("LOAD_GRUESTLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));

      function loadGruest(_x85, _x86) {
        return _ref94.apply(this, arguments);
      }

      return loadGruest;
    }(),


    //GRUPOS DE FORNECEDOR
    loadGrufor: function () {
      var _ref96 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee48(_ref95, params) {
        var commit = _ref95.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                _context48.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/grufor/", params);

              case 2:
                data = _context48.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_GRUFOR", data);
                  } else {
                    commit("LOAD_GRUFORLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));

      function loadGrufor(_x87, _x88) {
        return _ref96.apply(this, arguments);
      }

      return loadGrufor;
    }(),


    //GRUPOS DE CLIENTE
    loadGrucli: function () {
      var _ref98 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee49(_ref97, params) {
        var commit = _ref97.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                _context49.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/grucli/", params);

              case 2:
                data = _context49.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_GRUCLI", data);
                  } else {
                    commit("LOAD_GRUCLILIST", data);
                  }
                }

              case 4:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function loadGrucli(_x89, _x90) {
        return _ref98.apply(this, arguments);
      }

      return loadGrucli;
    }(),


    //XMLHIST
    loadXMLHist: function () {
      var _ref100 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee50(_ref99, params) {
        var commit = _ref99.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                _context50.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/xmlhist/", params);

              case 2:
                data = _context50.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_XMLHIST", data);
                  } else {
                    commit("LOAD_XMLHISTLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));

      function loadXMLHist(_x91, _x92) {
        return _ref100.apply(this, arguments);
      }

      return loadXMLHist;
    }(),
    loadPdtipo: function () {
      var _ref102 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee51(_ref101, params) {
        var commit = _ref101.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                _context51.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/pdtipo/", params);

              case 2:
                data = _context51.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_PDTIPO", data);
                  } else {
                    commit("LOAD_PDTIPOLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));

      function loadPdtipo(_x93, _x94) {
        return _ref102.apply(this, arguments);
      }

      return loadPdtipo;
    }(),
    loadPdstatus: function () {
      var _ref104 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee52(_ref103, params) {
        var commit = _ref103.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                _context52.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/pdstatus/", params, true);

              case 2:
                data = _context52.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_PDSTATUS", data);
                  } else {
                    commit("LOAD_PDSTATUSLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));

      function loadPdstatus(_x95, _x96) {
        return _ref104.apply(this, arguments);
      }

      return loadPdstatus;
    }(),
    loadCondicao: function () {
      var _ref106 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee53(_ref105, params) {
        var commit = _ref105.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                _context53.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/condicao/", params);

              case 2:
                data = _context53.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_CONDICAO", data);
                  } else {
                    commit("LOAD_CONDICAOLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));

      function loadCondicao(_x97, _x98) {
        return _ref106.apply(this, arguments);
      }

      return loadCondicao;
    }(),
    loadEquipe: function () {
      var _ref108 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee54(_ref107, params) {
        var commit = _ref107.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                _context54.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/equipe/", params, true);

              case 2:
                data = _context54.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_EQUIPE", data);
                  } else {
                    commit("LOAD_EQUIPELIST", data);
                  }
                }

              case 4:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this);
      }));

      function loadEquipe(_x99, _x100) {
        return _ref108.apply(this, arguments);
      }

      return loadEquipe;
    }(),
    loadAgenda: function () {
      var _ref110 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee55(_ref109, params) {
        var commit = _ref109.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                _context55.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/agenda/", params);

              case 2:
                data = _context55.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_AGENDA", data);
                  } else {
                    commit("LOAD_AGENDALIST", data);
                  }
                }

              case 4:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));

      function loadAgenda(_x101, _x102) {
        return _ref110.apply(this, arguments);
      }

      return loadAgenda;
    }(),
    loadCatmkt: function () {
      var _ref112 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee56(_ref111, params) {
        var commit = _ref111.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                _context56.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/catmkt/", params);

              case 2:
                data = _context56.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_CATMKT", data);
                  } else {
                    commit("LOAD_CATMKTLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this);
      }));

      function loadCatmkt(_x103, _x104) {
        return _ref112.apply(this, arguments);
      }

      return loadCatmkt;
    }(),


    //CRM
    loadPessoa: function () {
      var _ref114 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee57(_ref113, params) {
        var commit = _ref113.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                _context57.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "crm/pessoa/", params);

              case 2:
                data = _context57.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_PESSOA", data);
                  } else {
                    commit("LOAD_PESSOALIST", data);
                  }
                }

              case 4:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));

      function loadPessoa(_x105, _x106) {
        return _ref114.apply(this, arguments);
      }

      return loadPessoa;
    }(),
    loadOrganizacao: function () {
      var _ref116 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee58(_ref115, params) {
        var commit = _ref115.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                _context58.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "crm/organizacao/", params);

              case 2:
                data = _context58.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_ORGANIZACAO", data);
                  } else {
                    commit("LOAD_ORGANIZACAOLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this);
      }));

      function loadOrganizacao(_x107, _x108) {
        return _ref116.apply(this, arguments);
      }

      return loadOrganizacao;
    }(),
    loadNegocio: function () {
      var _ref118 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee59(_ref117, params) {
        var commit = _ref117.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                _context59.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "crm/negocio/", params);

              case 2:
                data = _context59.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_NEGOCIO", data);
                  } else {
                    commit("LOAD_NEGOCIOLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this);
      }));

      function loadNegocio(_x109, _x110) {
        return _ref118.apply(this, arguments);
      }

      return loadNegocio;
    }(),
    loadNegocioHist: function () {
      var _ref120 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee60(_ref119, params) {
        var commit = _ref119.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "crm/negocio/" + params.id + "/hist", null);

              case 2:
                data = _context60.sent;

                if (data.items) {
                  commit("LOAD_NEGOCIOHIST", data);
                }

              case 4:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));

      function loadNegocioHist(_x111, _x112) {
        return _ref120.apply(this, arguments);
      }

      return loadNegocioHist;
    }(),
    loadNegocioEmails: function () {
      var _ref122 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee61(_ref121, params) {
        var commit = _ref121.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                _context61.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "crm/email/list?codnegocio=" + params.id, null);

              case 2:
                data = _context61.sent;

                if (data.items) {
                  commit("LOAD_NEGOCIOEMAILS", data);
                }

              case 4:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, this);
      }));

      function loadNegocioEmails(_x113, _x114) {
        return _ref122.apply(this, arguments);
      }

      return loadNegocioEmails;
    }(),
    loadLead: function () {
      var _ref124 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee62(_ref123, params) {
        var commit = _ref123.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                _context62.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "crm/lead/", params);

              case 2:
                data = _context62.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_LEADCRM", data);
                  } else {
                    commit("LOAD_LEADCRMLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this);
      }));

      function loadLead(_x115, _x116) {
        return _ref124.apply(this, arguments);
      }

      return loadLead;
    }(),
    loadEmailCrm: function () {
      var _ref126 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee63(_ref125, params) {
        var commit = _ref125.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                url = this.getters.urlOrds + "crm/email/list";

                if (params.id) url = url + "?codemail=" + params.id;else if (params.codnegocio) url = url + "?codnegocio=" + params.codnegocio;else if (params.codpessoa) url = url + "?codpessoa=" + params.codpessoa;else if (params.codusuario) url = url + "?codusuario=" + params.codusuario;

                _context63.next = 4;
                return (0, _apiFunctions.apiORDS)(url, null);

              case 4:
                data = _context63.sent;

                if (data.items) if (params.id) commit("LOAD_EMAILCRM", data);else commit("LOAD_EMAILCRMLIST", data);

              case 6:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this);
      }));

      function loadEmailCrm(_x117, _x118) {
        return _ref126.apply(this, arguments);
      }

      return loadEmailCrm;
    }(),
    loadTemplEmail: function () {
      var _ref128 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee64(_ref127, params) {
        var commit = _ref127.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                _context64.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "crm/template/", params);

              case 2:
                data = _context64.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_TEMPLEMAIL", data);
                  } else {
                    commit("LOAD_TEMPLEMAILLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this);
      }));

      function loadTemplEmail(_x119, _x120) {
        return _ref128.apply(this, arguments);
      }

      return loadTemplEmail;
    }(),
    loadConfigCrm: function () {
      var _ref130 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee65(_ref129) {
        var commit = _ref129.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                _context65.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "crm/painel/config");

              case 2:
                data = _context65.sent;

                if (data.items) {
                  commit("LOAD_CONFIGCRM", data);
                }

              case 4:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, this);
      }));

      function loadConfigCrm(_x121) {
        return _ref130.apply(this, arguments);
      }

      return loadConfigCrm;
    }(),
    loadTagCrm: function () {
      var _ref132 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee66(_ref131, params) {
        var commit = _ref131.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                _context66.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "crm/tag/", params);

              case 2:
                data = _context66.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_TAGCRM", data);
                  } else {
                    commit("LOAD_TAGCRMLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this);
      }));

      function loadTagCrm(_x122, _x123) {
        return _ref132.apply(this, arguments);
      }

      return loadTagCrm;
    }(),
    loadOrigemCrm: function () {
      var _ref134 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee67(_ref133, params) {
        var commit = _ref133.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                _context67.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "crm/origem/", params);

              case 2:
                data = _context67.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_ORIGEMCRM", data);
                  } else {
                    commit("LOAD_ORIGEMCRMLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, this);
      }));

      function loadOrigemCrm(_x124, _x125) {
        return _ref134.apply(this, arguments);
      }

      return loadOrigemCrm;
    }(),
    loadMotivoCrm: function () {
      var _ref136 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee68(_ref135, params) {
        var commit = _ref135.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                _context68.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "crm/motivo/", params);

              case 2:
                data = _context68.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_MOTIVOCRM", data);
                  } else {
                    commit("LOAD_MOTIVOCRMLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, this);
      }));

      function loadMotivoCrm(_x126, _x127) {
        return _ref136.apply(this, arguments);
      }

      return loadMotivoCrm;
    }(),
    loadFunilCrm: function () {
      var _ref138 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee69(_ref137, params) {
        var commit = _ref137.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                _context69.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "crm/funil/", params);

              case 2:
                data = _context69.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_FUNILCRM", data);
                  } else {
                    commit("LOAD_FUNILCRMLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, this);
      }));

      function loadFunilCrm(_x128, _x129) {
        return _ref138.apply(this, arguments);
      }

      return loadFunilCrm;
    }(),
    loadPainelCrm: function () {
      var _ref140 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee70(_ref139, params) {
        var commit = _ref139.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                url = "";

                if (params.tipo == "timeline") url = "crm/painel/timeline/" + params.codfunil;else if (params.tipo == "lista") url = "crm/painel/" + params.codfunil + "/lista";else url = "crm/painel/" + params.codfunil + "/etapas/" + params.tipo;

                _context70.next = 4;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + url, params);

              case 4:
                data = _context70.sent;


                if (data.items) if (params.tipo == "total") commit("LOAD_NEGOCIOTOTAIS", data);else commit("LOAD_NEGOCIOLIST", data);

              case 6:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70, this);
      }));

      function loadPainelCrm(_x130, _x131) {
        return _ref140.apply(this, arguments);
      }

      return loadPainelCrm;
    }(),
    loadPainelNoDateTimelineListCrm: function () {
      var _ref142 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee71(_ref141, params) {
        var commit = _ref141.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee71$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                url = "crm/painel/" + params.codfunil + "/lista/nodate";
                _context71.next = 3;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + url, params);

              case 3:
                data = _context71.sent;


                if (data.items) commit("LOAD_NEGOCIONODATELIST", data);

              case 5:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee71, this);
      }));

      function loadPainelNoDateTimelineListCrm(_x132, _x133) {
        return _ref142.apply(this, arguments);
      }

      return loadPainelNoDateTimelineListCrm;
    }(),


    //MENSAGENS NF
    loadMennf: function () {
      var _ref144 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee72(_ref143, params) {
        var commit = _ref143.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee72$(_context72) {
          while (1) {
            switch (_context72.prev = _context72.next) {
              case 0:
                _context72.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/mennf/", params);

              case 2:
                data = _context72.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_MENNF", data);
                  } else {
                    commit("LOAD_MENNFLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context72.stop();
            }
          }
        }, _callee72, this);
      }));

      function loadMennf(_x134, _x135) {
        return _ref144.apply(this, arguments);
      }

      return loadMennf;
    }(),


    //VENDEDORES
    loadVend: function () {
      var _ref146 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee73(_ref145, params) {
        var commit = _ref145.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee73$(_context73) {
          while (1) {
            switch (_context73.prev = _context73.next) {
              case 0:
                _context73.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/vend/", params);

              case 2:
                data = _context73.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_VEND", data);
                  } else {
                    commit("LOAD_VENDLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context73.stop();
            }
          }
        }, _callee73, this);
      }));

      function loadVend(_x136, _x137) {
        return _ref146.apply(this, arguments);
      }

      return loadVend;
    }(),


    //FILIAIS
    loadFilial: function () {
      var _ref148 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee74(_ref147, params) {
        var commit = _ref147.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee74$(_context74) {
          while (1) {
            switch (_context74.prev = _context74.next) {
              case 0:
                _context74.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/filial/", params);

              case 2:
                data = _context74.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_FILIAL", data);
                  } else {
                    commit("LOAD_FILIALLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context74.stop();
            }
          }
        }, _callee74, this);
      }));

      function loadFilial(_x138, _x139) {
        return _ref148.apply(this, arguments);
      }

      return loadFilial;
    }(),


    //USUARIOS
    loadUsuario: function () {
      var _ref150 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee75(_ref149, params) {
        var commit = _ref149.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee75$(_context75) {
          while (1) {
            switch (_context75.prev = _context75.next) {
              case 0:
                _context75.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlApp + "usuario/", params);

              case 2:
                data = _context75.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_USUARIO", data);
                  } else {
                    commit("LOAD_USUARIOLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context75.stop();
            }
          }
        }, _callee75, this);
      }));

      function loadUsuario(_x140, _x141) {
        return _ref150.apply(this, arguments);
      }

      return loadUsuario;
    }(),


    //DEPOSITO
    loadDeposito: function () {
      var _ref152 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee76(_ref151, params) {
        var commit = _ref151.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee76$(_context76) {
          while (1) {
            switch (_context76.prev = _context76.next) {
              case 0:
                _context76.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/deposito/", params);

              case 2:
                data = _context76.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_DEPOSITO", data);
                  } else {
                    commit("LOAD_DEPOSITOLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context76.stop();
            }
          }
        }, _callee76, this);
      }));

      function loadDeposito(_x142, _x143) {
        return _ref152.apply(this, arguments);
      }

      return loadDeposito;
    }(),


    //ESTADOS
    loadEstado: function () {
      var _ref154 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee77(_ref153, params) {
        var commit = _ref153.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee77$(_context77) {
          while (1) {
            switch (_context77.prev = _context77.next) {
              case 0:
                _context77.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/estado/", params);

              case 2:
                data = _context77.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_ESTADO", data);
                  } else {
                    commit("LOAD_ESTADOLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context77.stop();
            }
          }
        }, _callee77, this);
      }));

      function loadEstado(_x144, _x145) {
        return _ref154.apply(this, arguments);
      }

      return loadEstado;
    }(),
    loadEstadoRegras: function () {
      var _ref156 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee78(_ref155, params) {
        var commit = _ref155.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee78$(_context78) {
          while (1) {
            switch (_context78.prev = _context78.next) {
              case 0:
                _context78.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/estado/regras/", params);

              case 2:
                data = _context78.sent;

                if (data.items) {
                  commit("LOAD_ESTADOLIST", data);
                }

              case 4:
              case "end":
                return _context78.stop();
            }
          }
        }, _callee78, this);
      }));

      function loadEstadoRegras(_x146, _x147) {
        return _ref156.apply(this, arguments);
      }

      return loadEstadoRegras;
    }(),


    //ivancm
    loadivancm: function () {
      var _ref158 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee79(_ref157, params) {
        var commit = _ref157.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee79$(_context79) {
          while (1) {
            switch (_context79.prev = _context79.next) {
              case 0:
                _context79.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/ivancm/", params);

              case 2:
                data = _context79.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_IVANCM", data);
                  } else {
                    commit("LOAD_IVANCMLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context79.stop();
            }
          }
        }, _callee79, this);
      }));

      function loadivancm(_x148, _x149) {
        return _ref158.apply(this, arguments);
      }

      return loadivancm;
    }(),


    //ivaclass
    loadivaclass: function () {
      var _ref160 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee80(_ref159, params) {
        var commit = _ref159.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee80$(_context80) {
          while (1) {
            switch (_context80.prev = _context80.next) {
              case 0:
                _context80.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/ivaclass/", params);

              case 2:
                data = _context80.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_IVACLASS", data);
                  } else {
                    commit("LOAD_IVACLASSLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context80.stop();
            }
          }
        }, _callee80, this);
      }));

      function loadivaclass(_x150, _x151) {
        return _ref160.apply(this, arguments);
      }

      return loadivaclass;
    }(),


    //REGRA ICMS ST
    loadRegrast: function () {
      var _ref162 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee81(_ref161, params) {
        var commit = _ref161.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee81$(_context81) {
          while (1) {
            switch (_context81.prev = _context81.next) {
              case 0:
                url = "cg/regrast/";

                if (params.path) {
                  url = url + params.path;
                }
                _context81.next = 4;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + url, params);

              case 4:
                data = _context81.sent;

                if (data.items) {
                  commit("LOAD_REGRAST", data.items);
                }

              case 6:
              case "end":
                return _context81.stop();
            }
          }
        }, _callee81, this);
      }));

      function loadRegrast(_x152, _x153) {
        return _ref162.apply(this, arguments);
      }

      return loadRegrast;
    }(),
    loadRegrastList: function () {
      var _ref164 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee82(_ref163, params) {
        var commit = _ref163.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee82$(_context82) {
          while (1) {
            switch (_context82.prev = _context82.next) {
              case 0:
                url = "cg/regrast/";
                _context82.next = 3;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + url, params);

              case 3:
                data = _context82.sent;

                if (data.items) {
                  commit("LOAD_REGRASTLIST", data.items);
                }

              case 5:
              case "end":
                return _context82.stop();
            }
          }
        }, _callee82, this);
      }));

      function loadRegrastList(_x154, _x155) {
        return _ref164.apply(this, arguments);
      }

      return loadRegrastList;
    }(),


    //REGRAIMP
    loadRegraimp: function () {
      var _ref166 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee83(_ref165, params) {
        var commit = _ref165.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee83$(_context83) {
          while (1) {
            switch (_context83.prev = _context83.next) {
              case 0:
                url = "cg/regraimp/";

                if (params.path) {
                  url = url + params.path;
                }
                _context83.next = 4;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + url, params);

              case 4:
                data = _context83.sent;

                if (data.items) {
                  commit("LOAD_REGRAIMP", data.items);
                }

              case 6:
              case "end":
                return _context83.stop();
            }
          }
        }, _callee83, this);
      }));

      function loadRegraimp(_x156, _x157) {
        return _ref166.apply(this, arguments);
      }

      return loadRegraimp;
    }(),
    loadRegraimpList: function () {
      var _ref168 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee84(_ref167, params) {
        var commit = _ref167.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee84$(_context84) {
          while (1) {
            switch (_context84.prev = _context84.next) {
              case 0:
                url = "cg/regraimp/";
                _context84.next = 3;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + url, params);

              case 3:
                data = _context84.sent;

                if (data.items) {
                  commit("LOAD_REGRAIMPLIST", data.items);
                }

              case 5:
              case "end":
                return _context84.stop();
            }
          }
        }, _callee84, this);
      }));

      function loadRegraimpList(_x158, _x159) {
        return _ref168.apply(this, arguments);
      }

      return loadRegraimpList;
    }(),


    //REGRAS FCP
    loadRegrafcpList: function () {
      var _ref170 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee85(_ref169, params) {
        var commit = _ref169.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee85$(_context85) {
          while (1) {
            switch (_context85.prev = _context85.next) {
              case 0:
                url = "cg/regrafcp/";
                _context85.next = 3;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + url, params);

              case 3:
                data = _context85.sent;

                if (data.items) {
                  commit("LOAD_REGRAFCPLIST", data);
                }

              case 5:
              case "end":
                return _context85.stop();
            }
          }
        }, _callee85, this);
      }));

      function loadRegrafcpList(_x160, _x161) {
        return _ref170.apply(this, arguments);
      }

      return loadRegrafcpList;
    }(),
    loadRegrafcp: function () {
      var _ref172 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee86(_ref171, params) {
        var commit = _ref171.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee86$(_context86) {
          while (1) {
            switch (_context86.prev = _context86.next) {
              case 0:
                url = "cg/regrafcp/";
                _context86.next = 3;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + url, params);

              case 3:
                data = _context86.sent;

                if (data.items) {
                  commit("LOAD_REGRAFCP", data);
                }

              case 5:
              case "end":
                return _context86.stop();
            }
          }
        }, _callee86, this);
      }));

      function loadRegrafcp(_x162, _x163) {
        return _ref172.apply(this, arguments);
      }

      return loadRegrafcp;
    }(),


    //GRUPO DE TRIBUTACAO
    loadGrutribList: function () {
      var _ref174 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee87(_ref173, params) {
        var commit = _ref173.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee87$(_context87) {
          while (1) {
            switch (_context87.prev = _context87.next) {
              case 0:
                url = "cg/grutrib/";
                _context87.next = 3;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + url, params);

              case 3:
                data = _context87.sent;

                if (data.items) {
                  commit("LOAD_GRUTRIBLIST", data);
                }

              case 5:
              case "end":
                return _context87.stop();
            }
          }
        }, _callee87, this);
      }));

      function loadGrutribList(_x164, _x165) {
        return _ref174.apply(this, arguments);
      }

      return loadGrutribList;
    }(),
    loadGrutrib: function () {
      var _ref176 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee88(_ref175, params) {
        var commit = _ref175.commit;
        var url, data;
        return regeneratorRuntime.wrap(function _callee88$(_context88) {
          while (1) {
            switch (_context88.prev = _context88.next) {
              case 0:
                url = "cg/grutrib/";
                _context88.next = 3;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + url, params);

              case 3:
                data = _context88.sent;

                if (data.items) {
                  commit("LOAD_GRUTRIB", data);
                }

              case 5:
              case "end":
                return _context88.stop();
            }
          }
        }, _callee88, this);
      }));

      function loadGrutrib(_x166, _x167) {
        return _ref176.apply(this, arguments);
      }

      return loadGrutrib;
    }(),


    //SERIE NF
    loadSerienf: function () {
      var _ref178 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee89(_ref177, params) {
        var commit = _ref177.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee89$(_context89) {
          while (1) {
            switch (_context89.prev = _context89.next) {
              case 0:
                _context89.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/serienf/", params);

              case 2:
                data = _context89.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_SERIENF", data);
                  } else {
                    commit("LOAD_SERIENFLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context89.stop();
            }
          }
        }, _callee89, this);
      }));

      function loadSerienf(_x168, _x169) {
        return _ref178.apply(this, arguments);
      }

      return loadSerienf;
    }(),


    //CONTADOR
    loadContador: function () {
      var _ref180 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee90(_ref179, params) {
        var commit = _ref179.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee90$(_context90) {
          while (1) {
            switch (_context90.prev = _context90.next) {
              case 0:
                _context90.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/contador/", params);

              case 2:
                data = _context90.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_CONTADOR", data);
                  } else {
                    commit("LOAD_CONTADORLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context90.stop();
            }
          }
        }, _callee90, this);
      }));

      function loadContador(_x170, _x171) {
        return _ref180.apply(this, arguments);
      }

      return loadContador;
    }(),


    //NATUREZA FINANCEIRA
    loadNatfin: function () {
      var _ref182 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee91(_ref181, params) {
        var commit = _ref181.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee91$(_context91) {
          while (1) {
            switch (_context91.prev = _context91.next) {
              case 0:
                _context91.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/natfin/", params);

              case 2:
                data = _context91.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_NATFIN", data);
                  } else {
                    commit("LOAD_NATFINLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context91.stop();
            }
          }
        }, _callee91, this);
      }));

      function loadNatfin(_x172, _x173) {
        return _ref182.apply(this, arguments);
      }

      return loadNatfin;
    }(),


    //RAMO DE ATIVIDADE
    loadRamoat: function () {
      var _ref184 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee92(_ref183, params) {
        var commit = _ref183.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee92$(_context92) {
          while (1) {
            switch (_context92.prev = _context92.next) {
              case 0:
                _context92.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/ramoat/", params);

              case 2:
                data = _context92.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_RAMOAT", data);
                  } else {
                    commit("LOAD_RAMOATLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context92.stop();
            }
          }
        }, _callee92, this);
      }));

      function loadRamoat(_x174, _x175) {
        return _ref184.apply(this, arguments);
      }

      return loadRamoat;
    }(),


    //INUTILIZACOES
    loadInut: function () {
      var _ref186 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee93(_ref185, params) {
        var commit = _ref185.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee93$(_context93) {
          while (1) {
            switch (_context93.prev = _context93.next) {
              case 0:
                _context93.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "invoice/inut/", params);

              case 2:
                data = _context93.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_INUT", data);
                  } else {
                    commit("LOAD_INUTLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context93.stop();
            }
          }
        }, _callee93, this);
      }));

      function loadInut(_x176, _x177) {
        return _ref186.apply(this, arguments);
      }

      return loadInut;
    }(),
    loadNfAvisos: function () {
      var _ref188 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee94(_ref187, params) {
        var commit = _ref187.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee94$(_context94) {
          while (1) {
            switch (_context94.prev = _context94.next) {
              case 0:
                _context94.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "invoice/avisos/", params);

              case 2:
                data = _context94.sent;

                if (data.items) {
                  commit("LOAD_NFAVISOS", data);
                }

              case 4:
              case "end":
                return _context94.stop();
            }
          }
        }, _callee94, this);
      }));

      function loadNfAvisos(_x178, _x179) {
        return _ref188.apply(this, arguments);
      }

      return loadNfAvisos;
    }(),


    //conta bancaria
    loadCta: function () {
      var _ref190 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee95(_ref189, params) {
        var commit = _ref189.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee95$(_context95) {
          while (1) {
            switch (_context95.prev = _context95.next) {
              case 0:
                _context95.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/cta/", params);

              case 2:
                data = _context95.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_CTA", data);
                  } else {
                    commit("LOAD_CTALIST", data);
                  }
                }

              case 4:
              case "end":
                return _context95.stop();
            }
          }
        }, _callee95, this);
      }));

      function loadCta(_x180, _x181) {
        return _ref190.apply(this, arguments);
      }

      return loadCta;
    }(),


    //formas de pagamento
    loadFpag: function () {
      var _ref192 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee96(_ref191, params) {
        var commit = _ref191.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee96$(_context96) {
          while (1) {
            switch (_context96.prev = _context96.next) {
              case 0:
                _context96.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/fpag/", params);

              case 2:
                data = _context96.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_FPAG", data);
                  } else {
                    commit("LOAD_FPAGLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context96.stop();
            }
          }
        }, _callee96, this);
      }));

      function loadFpag(_x182, _x183) {
        return _ref192.apply(this, arguments);
      }

      return loadFpag;
    }(),


    //caixa pdv
    loadVCaixa: function () {
      var _ref194 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee97(_ref193, params) {
        var commit = _ref193.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee97$(_context97) {
          while (1) {
            switch (_context97.prev = _context97.next) {
              case 0:
                _context97.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/vcaixa/", params);

              case 2:
                data = _context97.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_VCAIXA", data);
                  } else {
                    commit("LOAD_VCAIXALIST", data);
                  }
                }

              case 4:
              case "end":
                return _context97.stop();
            }
          }
        }, _callee97, this);
      }));

      function loadVCaixa(_x184, _x185) {
        return _ref194.apply(this, arguments);
      }

      return loadVCaixa;
    }(),


    //bancos
    loadBanco: function () {
      var _ref196 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee98(_ref195, params) {
        var commit = _ref195.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee98$(_context98) {
          while (1) {
            switch (_context98.prev = _context98.next) {
              case 0:
                _context98.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "fin/bancos/", params);

              case 2:
                data = _context98.sent;

                if (data.items) {
                  commit("LOAD_BANCO", data);
                }

              case 4:
              case "end":
                return _context98.stop();
            }
          }
        }, _callee98, this);
      }));

      function loadBanco(_x186, _x187) {
        return _ref196.apply(this, arguments);
      }

      return loadBanco;
    }(),


    //CNAB AR
    loadCnabSemVinculo: function () {
      var _ref198 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee99(_ref197, params) {
        var commit = _ref197.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee99$(_context99) {
          while (1) {
            switch (_context99.prev = _context99.next) {
              case 0:
                _context99.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cnab/ar/vincularconta/", params);

              case 2:
                data = _context99.sent;

                if (data.items) {
                  commit("LOAD_CNABSEMVINCULO", data);
                }

              case 4:
              case "end":
                return _context99.stop();
            }
          }
        }, _callee99, this);
      }));

      function loadCnabSemVinculo(_x188, _x189) {
        return _ref198.apply(this, arguments);
      }

      return loadCnabSemVinculo;
    }(),
    loadCnabPendente: function () {
      var _ref200 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee100(_ref199, params) {
        var commit = _ref199.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee100$(_context100) {
          while (1) {
            switch (_context100.prev = _context100.next) {
              case 0:
                _context100.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cnab/ar/pendencia/", params);

              case 2:
                data = _context100.sent;

                if (data.items) {
                  commit("LOAD_CNABPENDENTE", data);
                }

              case 4:
              case "end":
                return _context100.stop();
            }
          }
        }, _callee100, this);
      }));

      function loadCnabPendente(_x190, _x191) {
        return _ref200.apply(this, arguments);
      }

      return loadCnabPendente;
    }(),
    loadCnabRetList: function () {
      var _ref202 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee101(_ref201, params) {
        var commit = _ref201.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee101$(_context101) {
          while (1) {
            switch (_context101.prev = _context101.next) {
              case 0:
                _context101.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cnab/ar/retorno/", params);

              case 2:
                data = _context101.sent;

                if (data.items) {
                  commit("LOAD_CNABRETLIST", data);
                }

              case 4:
              case "end":
                return _context101.stop();
            }
          }
        }, _callee101, this);
      }));

      function loadCnabRetList(_x192, _x193) {
        return _ref202.apply(this, arguments);
      }

      return loadCnabRetList;
    }(),
    loadCnabRetDetList: function () {
      var _ref204 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee102(_ref203, params) {
        var commit = _ref203.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee102$(_context102) {
          while (1) {
            switch (_context102.prev = _context102.next) {
              case 0:
                _context102.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cnab/ar/retorno/", params);

              case 2:
                data = _context102.sent;

                if (data.items) {
                  commit("LOAD_CNABRETDETLIST", data);
                }

              case 4:
              case "end":
                return _context102.stop();
            }
          }
        }, _callee102, this);
      }));

      function loadCnabRetDetList(_x194, _x195) {
        return _ref204.apply(this, arguments);
      }

      return loadCnabRetDetList;
    }(),
    loadCnabRemList: function () {
      var _ref206 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee103(_ref205, params) {
        var commit = _ref205.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee103$(_context103) {
          while (1) {
            switch (_context103.prev = _context103.next) {
              case 0:
                _context103.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cnab/ar/remessa/", params);

              case 2:
                data = _context103.sent;

                if (data.items) {
                  commit("LOAD_CNABREMLIST", data);
                }

              case 4:
              case "end":
                return _context103.stop();
            }
          }
        }, _callee103, this);
      }));

      function loadCnabRemList(_x196, _x197) {
        return _ref206.apply(this, arguments);
      }

      return loadCnabRemList;
    }(),
    loadCnabRejList: function () {
      var _ref208 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee104(_ref207, params) {
        var commit = _ref207.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee104$(_context104) {
          while (1) {
            switch (_context104.prev = _context104.next) {
              case 0:
                _context104.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cnab/ar/rejeitados/", params);

              case 2:
                data = _context104.sent;

                if (data.items) {
                  commit("LOAD_CNABREJLIST", data);
                }

              case 4:
              case "end":
                return _context104.stop();
            }
          }
        }, _callee104, this);
      }));

      function loadCnabRejList(_x198, _x199) {
        return _ref208.apply(this, arguments);
      }

      return loadCnabRejList;
    }(),


    //FINACEIRO
    loadFin: function () {
      var _ref210 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee105(_ref209, params) {
        var commit = _ref209.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee105$(_context105) {
          while (1) {
            switch (_context105.prev = _context105.next) {
              case 0:
                _context105.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "fin/movimento/", params);

              case 2:
                data = _context105.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_FIN", data);
                  } else {
                    commit("LOAD_FINARLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context105.stop();
            }
          }
        }, _callee105, this);
      }));

      function loadFin(_x200, _x201) {
        return _ref210.apply(this, arguments);
      }

      return loadFin;
    }(),
    loadLogList: function () {
      var _ref212 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee106(_ref211, params) {
        var commit = _ref211.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee106$(_context106) {
          while (1) {
            switch (_context106.prev = _context106.next) {
              case 0:
                _context106.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "fin/log/", params);

              case 2:
                data = _context106.sent;

                if (data.items) {
                  commit("LOAD_LOG", data);
                }

              case 4:
              case "end":
                return _context106.stop();
            }
          }
        }, _callee106, this);
      }));

      function loadLogList(_x202, _x203) {
        return _ref212.apply(this, arguments);
      }

      return loadLogList;
    }(),


    //grade
    loadGrade: function () {
      var _ref214 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee107(_ref213, params) {
        var commit = _ref213.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee107$(_context107) {
          while (1) {
            switch (_context107.prev = _context107.next) {
              case 0:
                _context107.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/grade/", params);

              case 2:
                data = _context107.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_GRADE", data);
                  } else {
                    commit("LOAD_GRADELIST", data);
                  }
                }

              case 4:
              case "end":
                return _context107.stop();
            }
          }
        }, _callee107, this);
      }));

      function loadGrade(_x204, _x205) {
        return _ref214.apply(this, arguments);
      }

      return loadGrade;
    }(),


    // Destaq
    loadDestaq: function () {
      var _ref216 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee108(_ref215, params) {
        var commit = _ref215.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee108$(_context108) {
          while (1) {
            switch (_context108.prev = _context108.next) {
              case 0:
                _context108.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/destaq/", params);

              case 2:
                data = _context108.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_DESTAQ", data);
                  } else {
                    commit("LOAD_DESTAQLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context108.stop();
            }
          }
        }, _callee108, this);
      }));

      function loadDestaq(_x206, _x207) {
        return _ref216.apply(this, arguments);
      }

      return loadDestaq;
    }(),


    // Tabdes
    loadTabdes: function () {
      var _ref218 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee109(_ref217, params) {
        var commit = _ref217.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee109$(_context109) {
          while (1) {
            switch (_context109.prev = _context109.next) {
              case 0:
                _context109.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/tabdes/", params);

              case 2:
                data = _context109.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_TABDES", data);
                  } else {
                    commit("LOAD_TABDESLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context109.stop();
            }
          }
        }, _callee109, this);
      }));

      function loadTabdes(_x208, _x209) {
        return _ref218.apply(this, arguments);
      }

      return loadTabdes;
    }(),


    //tabela de precos
    loadTabpre: function () {
      var _ref220 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee110(_ref219, params) {
        var commit = _ref219.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee110$(_context110) {
          while (1) {
            switch (_context110.prev = _context110.next) {
              case 0:
                _context110.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/tabpre/", params);

              case 2:
                data = _context110.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_TABPRE", data);
                  } else {
                    commit("LOAD_TABPRELIST", data);
                  }
                }

              case 4:
              case "end":
                return _context110.stop();
            }
          }
        }, _callee110, this);
      }));

      function loadTabpre(_x210, _x211) {
        return _ref220.apply(this, arguments);
      }

      return loadTabpre;
    }(),


    //itens da tabela de preço
    loadTabpreItens: function () {
      var _ref222 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee111(_ref221, params) {
        var commit = _ref221.commit;
        var modulo, data;
        return regeneratorRuntime.wrap(function _callee111$(_context111) {
          while (1) {
            switch (_context111.prev = _context111.next) {
              case 0:
                modulo = "cg/tabpre/" + params.id + "/produtos/";
                _context111.next = 3;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + modulo);

              case 3:
                data = _context111.sent;

                if (data.items) {
                  commit("LOAD_TABPREITENS", data);
                }

              case 5:
              case "end":
                return _context111.stop();
            }
          }
        }, _callee111, this);
      }));

      function loadTabpreItens(_x212, _x213) {
        return _ref222.apply(this, arguments);
      }

      return loadTabpreItens;
    }(),


    //docs/anexos
    loadDocs: function () {
      var _ref224 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee112(_ref223, params) {
        var commit = _ref223.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee112$(_context112) {
          while (1) {
            switch (_context112.prev = _context112.next) {
              case 0:
                _context112.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "docs/", params);

              case 2:
                data = _context112.sent;

                if (data.items) {
                  commit("LOAD_DOCS", data);
                }

              case 4:
              case "end":
                return _context112.stop();
            }
          }
        }, _callee112, this);
      }));

      function loadDocs(_x214, _x215) {
        return _ref224.apply(this, arguments);
      }

      return loadDocs;
    }(),


    //MANIFESTO
    loadManifesto: function () {
      var _ref226 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee113(_ref225, params) {
        var commit = _ref225.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee113$(_context113) {
          while (1) {
            switch (_context113.prev = _context113.next) {
              case 0:
                _context113.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "manifesto/pesquisar/", params);

              case 2:
                data = _context113.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_MANIFESTO", data);
                  } else {
                    commit("LOAD_MANIFESTOLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context113.stop();
            }
          }
        }, _callee113, this);
      }));

      function loadManifesto(_x216, _x217) {
        return _ref226.apply(this, arguments);
      }

      return loadManifesto;
    }(),
    loadFrete: function () {
      var _ref228 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee114(_ref227, params) {
        var commit = _ref227.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee114$(_context114) {
          while (1) {
            switch (_context114.prev = _context114.next) {
              case 0:
                _context114.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrdsSelect + "frete/", params);

              case 2:
                data = _context114.sent;

                if (data.items) {
                  commit("LOAD_FRETELIST", data);
                }

              case 4:
              case "end":
                return _context114.stop();
            }
          }
        }, _callee114, this);
      }));

      function loadFrete(_x218, _x219) {
        return _ref228.apply(this, arguments);
      }

      return loadFrete;
    }(),


    //
    // FORCA DE VENDAS
    //
    loadClientesFv: function () {
      var _ref230 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee115(_ref229, params) {
        var commit = _ref229.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee115$(_context115) {
          while (1) {
            switch (_context115.prev = _context115.next) {
              case 0:
                _context115.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/part/forcavendas/clientes/", params);

              case 2:
                data = _context115.sent;

                if (data.items) {
                  if (params.id) {
                    commit("LOAD_PART", data.items);
                  } else {
                    commit("LOAD_PARTLIST", data);
                  }
                }

              case 4:
              case "end":
                return _context115.stop();
            }
          }
        }, _callee115, this);
      }));

      function loadClientesFv(_x220, _x221) {
        return _ref230.apply(this, arguments);
      }

      return loadClientesFv;
    }(),
    loadPedidosFvList: function () {
      var _ref232 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee116(_ref231, params) {
        var commit = _ref231.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee116$(_context116) {
          while (1) {
            switch (_context116.prev = _context116.next) {
              case 0:
                _context116.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "sales/pedv/forcavendas/list/", params);

              case 2:
                data = _context116.sent;

                //const data = await apiORDSgetViaPost(this.getters.urlOrds + 'sales/pedv/filtros/forcavendas/list/', params)
                if (data.items) {
                  commit("LOAD_PEDVLIST", data);
                }

              case 4:
              case "end":
                return _context116.stop();
            }
          }
        }, _callee116, this);
      }));

      function loadPedidosFvList(_x222, _x223) {
        return _ref232.apply(this, arguments);
      }

      return loadPedidosFvList;
    }(),
    loadPedidosFvTotal: function () {
      var _ref234 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee117(_ref233, params) {
        var commit = _ref233.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee117$(_context117) {
          while (1) {
            switch (_context117.prev = _context117.next) {
              case 0:
                _context117.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "sales/pedv/forcavendas/total/", params);

              case 2:
                data = _context117.sent;

                //const data = await apiORDSgetViaPost(this.getters.urlOrds + 'sales/pedv/filtros/forcavendas/total/', params)
                if (data.items) {
                  commit("LOAD_PEDVTOTAL", data);
                }

              case 4:
              case "end":
                return _context117.stop();
            }
          }
        }, _callee117, this);
      }));

      function loadPedidosFvTotal(_x224, _x225) {
        return _ref234.apply(this, arguments);
      }

      return loadPedidosFvTotal;
    }(),
    loadGuiaNFe: function () {
      var _ref236 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee118(_ref235) {
        var commit = _ref235.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee118$(_context118) {
          while (1) {
            switch (_context118.prev = _context118.next) {
              case 0:
                _context118.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/guianfe");

              case 2:
                data = _context118.sent;

                if (data) {
                  commit("LOAD_GUIANFE", data);
                }

              case 4:
              case "end":
                return _context118.stop();
            }
          }
        }, _callee118, this);
      }));

      function loadGuiaNFe(_x226) {
        return _ref236.apply(this, arguments);
      }

      return loadGuiaNFe;
    }(),
    loadNotificationsList: function () {
      var _ref238 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee119(_ref237, params) {
        var commit = _ref237.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee119$(_context119) {
          while (1) {
            switch (_context119.prev = _context119.next) {
              case 0:
                _context119.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "cg/notifications/", params, true);

              case 2:
                data = _context119.sent;

                if (data.items) {
                  commit("LOAD_NOTIFICATIONSLIST", data);
                }

              case 4:
              case "end":
                return _context119.stop();
            }
          }
        }, _callee119, this);
      }));

      function loadNotificationsList(_x227, _x228) {
        return _ref238.apply(this, arguments);
      }

      return loadNotificationsList;
    }(),


    // LOJA

    loadConfigLoja: function () {
      var _ref240 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee120(_ref239, params) {
        var commit = _ref239.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee120$(_context120) {
          while (1) {
            switch (_context120.prev = _context120.next) {
              case 0:
                _context120.next = 2;
                return (0, _apiFunctions.apiORDS)(this.getters.urlOrds + "loja/config/", params);

              case 2:
                data = _context120.sent;

                if (data.items) {
                  commit("LOAD_CONFIGLOJA", data);
                }

              case 4:
              case "end":
                return _context120.stop();
            }
          }
        }, _callee120, this);
      }));

      function loadConfigLoja(_x229, _x230) {
        return _ref240.apply(this, arguments);
      }

      return loadConfigLoja;
    }(),


    // FIM LOJA

    loadTeste: function () {
      var _ref242 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee121(_ref241, sendData, params) {
        var commit = _ref241.commit;
        var data;
        return regeneratorRuntime.wrap(function _callee121$(_context121) {
          while (1) {
            switch (_context121.prev = _context121.next) {
              case 0:
                _context121.next = 2;
                return (0, _apiFunctions.apiORDSpost)(this, "cg/teste/", sendData, "post", params);

              case 2:
                data = _context121.sent;

                if (data) {
                  commit("LOAD_TESTE", data);
                }

              case 4:
              case "end":
                return _context121.stop();
            }
          }
        }, _callee121, this);
      }));

      function loadTeste(_x231, _x232, _x233) {
        return _ref242.apply(this, arguments);
      }

      return loadTeste;
    }(),
    cleanpart: function () {
      var _ref244 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee122(_ref243) {
        var commit = _ref243.commit;
        return regeneratorRuntime.wrap(function _callee122$(_context122) {
          while (1) {
            switch (_context122.prev = _context122.next) {
              case 0:
                commit("CLEAN_PART");

              case 1:
              case "end":
                return _context122.stop();
            }
          }
        }, _callee122, this);
      }));

      function cleanpart(_x234) {
        return _ref244.apply(this, arguments);
      }

      return cleanpart;
    }()
  }
});

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1090);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a89dbb9e", content, true, {});

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".hidde-input{width:0;height:0;border:0;padding:0}", ""]);

// exports


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1092);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4ed7f925", content, true, {});

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._col},[_c('div',{staticClass:"form-group form-group-sm"},[(((_vm.label || _vm.metadata) && (_vm.nolabel != true)))?_c('div',[(!_vm.addButton)?_c('v-label',{attrs:{"label":_vm.label,"metadata-field":_vm.metadata}}):_vm._e(),_vm._v(" "),(_vm.addButton)?_c('v-label',{attrs:{"label":_vm.label,"metadata-field":_vm.metadata,"title-add-button":"Cadastrar"},on:{"clickAdd":function($event){return _vm.handleAddButton()}}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-group input-group-sm",class:_vm.classObject},[(_vm.preaddon)?_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(_vm.preaddon))])]):_vm._e(),_vm._v(" "),(_vm.type == 'text')?_c('input',{ref:"input",staticClass:"form-control form-control-sm",style:(_vm._case),attrs:{"type":"text","autocomplete":"off","disabled":_vm.disabled,"tabindex":_vm.tabindex,"placeholder":_vm.placeholder,"maxlength":_vm.maxlength},domProps:{"value":_vm.value},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.focusControl($event)},_vm.keymonitor],"input":function($event){return _vm.input($event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.type == 'cardnumber')?_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.generateCardNumberMask),expression:"generateCardNumberMask"}],ref:"input",staticClass:"form-control form-control-sm",attrs:{"type":"text","autocomplete":"off","disabled":_vm.disabled,"tabindex":_vm.tabindex,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.focusControl($event)},"input":function($event){return _vm.input($event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.type == 'month')?_c('select',{ref:"input",staticClass:"form-control form-control-sm",attrs:{"tabindex":_vm.tabindex,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.selectfocusControl($event)},"keyenter":_vm.handleEnter,"change":_vm.select}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Mês")]),_vm._v(" "),_vm._l((12),function(n){return _c('option',{key:n,attrs:{"disabled":n < _vm.minCardMonth},domProps:{"value":n < 10 ? '0' + n : n,"textContent":_vm._s(n < 10 ? '0' + n : n)}})})],2):_vm._e(),_vm._v(" "),(_vm.type == 'year')?_c('select',{ref:"input",staticClass:"form-control form-control-sm",attrs:{"tabindex":_vm.tabindex,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.selectfocusControl($event)},"keyenter":_vm.handleEnter,"change":_vm.select}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Ano")]),_vm._v(" "),_vm._l((12),function(n,$index){return _c('option',{key:n,domProps:{"value":$index + _vm.minCardYear,"textContent":_vm._s($index + _vm.minCardYear)}})})],2):_vm._e(),_vm._v(" "),(_vm.type == 'password')?_c('div',{staticClass:"input-group"},[(_vm.hiddeLoginInformations)?_c('input',{attrs:{"type":"password","name":"none","hidden":""}}):_vm._e(),_vm._v(" "),_c('input',{ref:"input",staticClass:"form-control form-control-sm",attrs:{"type":_vm.passwordFieldType,"disabled":_vm.disabled,"autocomplete":"new-password","readonly":"","onfocus":"this.removeAttribute('readonly')"},domProps:{"value":_vm.value},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.focusControl($event)},"input":function($event){return _vm.input($event.target.value)}}}),_vm._v(" "),(_vm.type == 'password')?_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text",staticStyle:{"cursor":"pointer"},attrs:{"title":"Exibir a senha"},on:{"click":_vm.handlePassword}},[_c('i',{staticClass:"fa fa-eye"})])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.type == 'memo')?_c('textarea',{ref:"input",staticClass:"form-control form-control-sm",attrs:{"rows":"4","disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.input($event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.type == 'value')?_c('input-value',{ref:"input",staticClass:"form-control form-control-sm",attrs:{"precision":_vm._precision,"tabindex":_vm.tabindex,"disabled":_vm.disabled,"value":_vm.value},on:{"keyenter":_vm.handleEnter,"input":_vm.input}}):_vm._e(),_vm._v(" "),(_vm.type == 'number')?_c('input-number',{ref:"input",staticClass:"form-control form-control-sm",attrs:{"disabled":_vm.disabled,"tabindex":_vm.tabindex,"value":_vm.value,"maxlength":_vm.maxlength},on:{"keyenter":_vm.handleEnter,"focus":_vm.handleFocus,"blur":_vm.handleBlur,"input":_vm.input}}):_vm._e(),_vm._v(" "),(_vm.type == 'cnpj')?_c('input',{ref:"input",staticClass:"form-control form-control-sm",style:(_vm._case),attrs:{"type":"text","autocomplete":"off","disabled":_vm.disabled,"tabindex":_vm.tabindex,"placeholder":_vm.placeholder,"maxlength":18},domProps:{"value":_vm.value},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.focusControl($event)},_vm.keymonitor],"input":function($event){return _vm.input($event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.type == 'cpf')?_c('input-number',{ref:"input",staticClass:"form-control form-control-sm",attrs:{"disabled":_vm.disabled,"tabindex":_vm.tabindex,"value":_vm.value},on:{"keyenter":_vm.handleEnter,"input":_vm.input}}):_vm._e(),_vm._v(" "),(_vm.type == 'date')?_c('input-date',{ref:"input",staticClass:"form-control form-control-sm",attrs:{"disabled":_vm.disabled,"tabindex":_vm.tabindex,"value":_vm.value},on:{"keyenter":_vm.handleEnter,"input":_vm.input}}):_vm._e(),_vm._v(" "),(_vm.type == 'hora')?_c('input-hora',{ref:"input",staticClass:"form-control form-control-sm",attrs:{"disabled":_vm.disabled,"tabindex":_vm.tabindex,"value":_vm.value},on:{"keyenter":_vm.handleEnter,"input":_vm.input}}):_vm._e(),_vm._v(" "),(_vm.type == 'select')?_c('select',{ref:"input",staticClass:"form-control form-control-sm",attrs:{"tabindex":_vm.tabindex,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.selectfocusControl($event)},"keyenter":_vm.handleEnter,"change":_vm.select}},[(_vm.optionnull !== true)?_c('option',{attrs:{"value":""}},[_vm._v(" "+_vm._s(_vm.placeholder)+" ")]):_vm._e(),_vm._v(" "),_vm._l((_vm._selectOptions),function(opt){return _c('option',{key:opt.id,domProps:{"value":opt.id}},[_vm._v(_vm._s(opt.text))])})],2):_vm._e(),_vm._v(" "),(_vm.type == 'select2' && _vm._select2)?_c('select2',{attrs:{"value":_vm.value,"entity":_vm._select2.entity,"parent":_vm.parent,"placeholder":_vm.placeholder,"tabindex":_vm.tabindex,"disabled":_vm.disabled,"minlength":_vm._select2.minlength},on:{"input":_vm.input,"keyenter":_vm.handleEnter}}):_vm._e(),_vm._v(" "),(_vm.type == 'select2static')?_c('select2static',{attrs:{"parent":_vm.parent,"placeholder":_vm.placeholder,"value":_vm.value,"options":_vm._selectOptions,"multiple":_vm.selectMultiple,"minlength":0,"tabindex":_vm.tabindex,"disabled":_vm.disabled},on:{"keyenter":_vm.handleEnter,"input":_vm.input}}):_vm._e(),_vm._v(" "),(_vm.type == 'cep')?_c('input-cep',{ref:"input",staticClass:"form-control form-control-sm",attrs:{"tabindex":_vm.tabindex,"maxlength":"8","disabled":_vm.disabled,"value":_vm.value},on:{"update":_vm.updateCep,"keyenter":_vm.handleEnter,"input":_vm.input}}):_vm._e(),_vm._v(" "),(_vm.type == 'fone')?_c('input-fone',{ref:"input",staticClass:"form-control form-control-sm",attrs:{"tabindex":_vm.tabindex,"disabled":_vm.disabled,"value":_vm.value},on:{"focus":_vm.handleFocus,"blur":_vm.handleBlur,"keyupesc":function($event){return _vm.handleEsc()},"keyupenter":function($event){return _vm.handleEnter()},"keydowntab":function($event){return _vm.handleKeyTab()},"keyupdown":function($event){return _vm.handleKeyDown()},"keyupup":function($event){return _vm.handleKeyUp()},"update":_vm.updateFone,"keyenter":_vm.handleEnter,"input":_vm.input}}):_vm._e(),_vm._v(" "),(_vm.type == 'email')?_c('input-email',{ref:"input",staticClass:"form-control form-control-sm",attrs:{"name":_vm.name,"tabindex":_vm.tabindex,"maxlength":"255","disabled":_vm.disabled,"value":_vm.value},on:{"update":_vm.updateEmail,"keyenter":_vm.handleEnter,"input":_vm.input}}):_vm._e(),_vm._v(" "),(_vm.type == 'color')?_c('input-color-picker',{ref:"input",attrs:{"tabindex":_vm.tabindex,"disabled":_vm.disabled,"value":_vm.value},on:{"keyenter":_vm.handleEnter,"input":_vm.input}}):_vm._e(),_vm._v(" "),(_vm.addon)?_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(_vm.addon))])]):_vm._e(),_vm._v(" "),(_vm.showSearching)?_c('div',{staticClass:"spinner-border ml-auto",attrs:{"role":"status","aria-hidden":"true"}}):_vm._e()],1),_vm._v(" "),(_vm.name && _vm.vErrors && _vm.vErrors.has(_vm.name))?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.vErrors.first(_vm.name)))]):_vm._e(),_vm._v(" "),(_vm.listDuplicados.length > 0)?_c('div',{staticClass:"dropdown-total col-md-4 col-10"},[_c('div',{staticClass:"row mb-2",staticStyle:{"border-bottom":"1px solid gray"}},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){_vm.showTotal = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_vm._l((_vm.listDuplicados),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_vm._v(" "+_vm._s(item.text)+"\n            "),_vm._m(0,true)]),_vm._v(" "),(item.text2)?_c('div',{staticClass:"col-md-12 col-12"},[_vm._v(" "+_vm._s(item.text2)+" ")]):_vm._e(),_vm._v(" "),(item.text3)?_c('div',{staticClass:"col-md-12 col-12"},[_vm._v(" "+_vm._s(item.text3)+" ")]):_vm._e()])])})],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-right"},[_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"}},[_c('i',{staticClass:"fa fa-paperclip"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"def-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(" "+_vm._s(_vm.vTitle)+" ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.handleCloseButton()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"max-height":"255px","overflow-y":"auto"}},[_c('div',{staticClass:"col-12"},[_c('span',{},[_vm._v(" "+_vm._s(_vm.vMessage)+" ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.adminPass)?_c('div',[_c('input',{staticClass:"hidde-input",attrs:{"type":"text"}}),_vm._v(" "),_c('form-field',{ref:"senha",attrs:{"hiddeLoginInformations":true,"type":"password","col":"6","label":"Digite a senha de administrador"},on:{"key":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleConfirmButton()}},model:{value:(_vm.senha),callback:function ($$v) {_vm.senha=$$v},expression:"senha"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(_vm.btnConfirm)?_c('button',{ref:"btnConfirm",staticClass:"btn btn-sm",class:_vm.btnClass,attrs:{"type":"button"},on:{"click":function($event){return _vm.handleConfirmButton()}}},[_vm._v(" "+_vm._s(_vm.btnConfirmText)+" ")]):_vm._e(),_vm._v(" "),(_vm.btnCancel)?_c('button',{ref:"btnClose",staticClass:"btn btn-sm",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.handleCloseButton()}}},[_vm._v(" "+_vm._s(_vm.btnCancelText)+" ")]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_alert_vue__ = __webpack_require__(400);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_464e747e_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_alert_vue__ = __webpack_require__(1098);
function injectStyle (ssrContext) {
  __webpack_require__(1096)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-464e747e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_464e747e_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1097);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d2187f08", content, true, {});

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row nb-margin-topbottom"},[(_vm.type!=='norecord')?_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"nb-alert",class:_vm.type,attrs:{"role":"alert"}},[(_vm.close)?_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.toggleAlert}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.title)?_c('p',{staticClass:"nb-alert-title"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(!_vm.messages)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._v(" "),_vm._l((_vm.messages),function(text,index){return _c('p',{key:index},[(text.message)?_c('span',[_vm._v(_vm._s(text.message))]):_c('span',[_vm._v(_vm._s(text))]),_vm._v(" "),(text.codpart)?_c('span',[_c('a',{attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Alterar"},on:{"click":function($event){return _vm.clickEdit('part', text.codpart)}}},[_c('i',{staticClass:"fa fa-pencil fa-fw"}),_vm._v("\n                        Editar Cliente\n                ")])]):_vm._e()])})],2)]):_vm._e(),_vm._v(" "),(_vm.type==='norecord')?_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"nb-alert warning",attrs:{"role":"alert"}},[(_vm.close)?_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.toggleAlert}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Nenhum registro foi encontrado.")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_validation_vue__ = __webpack_require__(401);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2509a044_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_validation_vue__ = __webpack_require__(1102);
function injectStyle (ssrContext) {
  __webpack_require__(1100)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2509a044"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_validation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2509a044_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_validation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1101);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0542aada", content, true, {});

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-validation[data-v-2509a044]{box-sizing:border-box;height:100%;position:relative;margin:0}.nb-validation-message[data-v-2509a044]{border-radius:0 3px 3px 0;border:1px solid;border-left:3px solid;padding:3px;padding-left:10px;margin:3px;position:relative}.nb-validation-message.message-error[data-v-2509a044]{color:#bc1132;border-top:1px solid #f9b3c1;border-bottom:1px solid #f9b3c1;border-left:3px solid #f43e61;border-right:1px solid #f9b3c1;background:#fff4ce}.nb-validation.title[data-v-2509a044]{display:block;font-size:14px;font-weight:700}", ""]);

// exports


/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"nb-validation"},[_vm._l((_vm.messages),function(err,index){return _c('div',{key:index,staticClass:"nb-validation-message message-error",attrs:{"role":"alert"}},[_c('span',[_vm._v(_vm._s(err))])])}),_vm._v(" "),(_vm.showcontinueanyway && _vm.messages && _vm.messages.length > 0)?_c('div',{staticClass:"float-right"},[_c('v-button',{attrs:{"label":"Salvar mesmo com errors de validação","icon":"","title":"Salvar mesmo com errors de validação"},on:{"click":function($event){return _vm.handleContinueAnyWay()}}})],1):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_warnings_vue__ = __webpack_require__(402);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e833f47_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_warnings_vue__ = __webpack_require__(1106);
function injectStyle (ssrContext) {
  __webpack_require__(1104)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e833f47"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_warnings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e833f47_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_warnings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1105);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a38268d0", content, true, {});

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-warning[data-v-2e833f47]{box-sizing:border-box;height:100%;position:relative;margin:0}.nb-warning-message[data-v-2e833f47]{border-radius:0 3px 3px 0;border:1px solid;border-left:3px solid;padding:3px;padding-left:10px;margin:3px;position:relative;font-size:15px}.nb-warning-message.error[data-v-2e833f47]{color:#bc1132;border-top:1px solid #f9b3c1;border-bottom:1px solid #f9b3c1;border-left:3px solid #f43e61;border-right:1px solid #f9b3c1;background:#fff4ce}.nb-warning-message.default[data-v-2e833f47]{color:#dfa701;border-top:1px solid #f9eeb3;border-bottom:1px solid #f9eeb3;border-left:3px solid #ffc107;border-right:1px solid #f9eeb3;background:#fffbee}.nb-warning.title[data-v-2e833f47]{display:block;font-size:14px;font-weight:700}", ""]);

// exports


/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"nb-warning"},_vm._l((_vm.messages),function(err,index){return _c('div',{key:index,staticClass:"nb-warning-message default"},[_c('span',[_vm._v(_vm._s(err))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1108);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("c6378db8", content, true, {});

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".badgefilter[data-v-66ab8e44]{display:inline-block;padding:5px;font-size:12px;font-weight:400;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.7rem}.close[data-v-66ab8e44]:focus,.close[data-v-66ab8e44]:hover{color:#000;text-decoration:none;opacity:.75}.close[data-v-66ab8e44]{float:right;font-size:1rem;color:#fff;text-shadow:0 1px 0 #fff;opacity:1;margin-left:6px}", ""]);

// exports


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1110);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("14e698e8", content, true, {});

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-mask",attrs:{"id":"filtermodal"}},[_c('div',{staticClass:"nb-modal nb-modal-60"},[_c('div',{staticClass:"nb-modal-inner"},[_c('label-title',{attrs:{"title":"Pesquisa Avançada"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.lFilters),function(filter,index){return _c('div',{key:index,staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":filter.filter.label}}),_vm._v(" "),_c('select2static',{attrs:{"options":filter.filter.options,"value":_vm.campoteste,"multiple":true,"minlength":0,"parent":"filtermodal"},model:{value:(_vm.campoteste),callback:function ($$v) {_vm.campoteste=$$v},expression:"campoteste"}})],1)}),0),_vm._v(" "),_c('div',{staticClass:"row"}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col"},[_c('v-button',{staticClass:"float-right",attrs:{"label":"Aplicar","nb-btdef":true},on:{"click":_vm.handleApplyFilter}}),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Cancelar"},on:{"click":_vm.handleClose}})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1113);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7e383c40", content, true, {});

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".select{height:30px;font-size:14px;padding:3px}.filtro-bar{position:fixed;top:0;left:0;bottom:0;transform:translate3d(100%,0,0);transition:all .35s;will-change:transform;z-index:10000}.filtro-bar-sombra{box-shadow:0 0 32px 0 #a9aaac80}.filtro-bar-inner{display:flex;flex-direction:column;background-color:#fff;overflow:hidden;height:100%}@media (max-width:768px){.filtro-bar-inner{width:90vw}}.filtro-bar-footer{display:flex;align-items:center;background-color:#f5f5f5;padding:10px 20px;flex:0 0 78px}.filtro-bar-body{padding:1rem!important;overflow-y:auto;height:100%}", ""]);

// exports


/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filtro-bar",style:(_vm.showClass)},[_c('div',{staticClass:"filtro-bar-inner filtro-bar-sombra"},[_c('div',{staticClass:"filtro-bar-body"},[(_vm.params.periodo)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.params.periodo)?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{attrs:{"label":_vm.params.periodo.label}})],1),_vm._v(" "),_vm._l((_vm.filtroPeriodos),function(periodo,index){return _c('div',{key:index,staticClass:"col-md-12 col-12 d-flex"},[_c('input-month2',{attrs:{"p-month":periodo},on:{"monthChange":function($event){return _vm.handlePeriodoChange(index)}}}),_vm._v(" "),(_vm.filtroPeriodos.length > 1)?_c('v-button',{staticClass:"ml-3",attrs:{"icon":"fa-trash","link":true},on:{"click":function($event){return _vm.handleExcluiPeriodo(index)}}}):_vm._e(),_vm._v(" "),(_vm.params.variosPeriodos && index == _vm.filtroPeriodos.length - 1)?_c('v-button',{staticClass:"ml-3",attrs:{"label":"Adicionar","icon":"fa-plus","link":true},on:{"click":_vm.handleAdicionaPeriodo}}):_vm._e()],1)}),_vm._v(" "),(_vm.params.periodo.varios)?_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Adicionar Período","icon":"fa-plus","link":true},on:{"click":_vm.handleAdicionaPeriodo}})],1):_vm._e()],2):_vm._e(),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._l((_vm.filtros),function(flt,index){return _c('div',{key:index,staticClass:"mb-2"},[_vm._l((flt.values),function(value,index2){return _c('div',{key:index2,staticClass:"row"},[_c('div',{staticClass:"col-10"},[_c('form-field',{attrs:{"type":"select2","select2":{ entity: flt.url, minlength: 0 },"placeholder":flt.label},model:{value:(value.id),callback:function ($$v) {_vm.$set(value, "id", $$v)},expression:"value.id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(flt.values.length > 1),expression:"flt.values.length > 1"}],attrs:{"icon":"fa-trash","link":true},on:{"click":function($event){return _vm.handleExcluiValueFiltro(flt, index2)}}})],1)])}),_vm._v(" "),(flt.varios)?_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Adicionar","icon":"fa-plus","link":true},on:{"click":function($event){return _vm.handleAdicionaFiltro(flt)}}})],1)]):_vm._e()],2)}),_vm._v(" "),_vm._l((_vm.params.checkbox),function(check,index){return _c('div',{key:index},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('input-checkbox',{attrs:{"label":check.label,"value-checked":check.valueChecked,"value-unchecked":check.valueUnchecked},model:{value:(check.value),callback:function ($$v) {_vm.$set(check, "value", $$v)},expression:"check.value"}})],1)])])}),_vm._v(" "),_vm._l((_vm.params.selects),function(select,index){return _c('div',{key:index},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('select',{staticClass:"form-control select",attrs:{"name":"","id":""}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v(_vm._s(select.placeholder))]),_vm._v(" "),_c('option',{attrs:{"value":""}}),_vm._v(" "),_vm._l((select.options),function(op,i){return _c('option',{key:i,domProps:{"value":op.id}},[_vm._v(_vm._s(op.label))])})],2)])])])})],2),_vm._v(" "),_c('div',{staticClass:"filtro-bar-footer"},[_c('v-button',{attrs:{"label":"Ok"},on:{"click":_vm.change}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.cancel}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 col-12 mb-3"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_vm._v("Período")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12 mb-3"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_vm._v("Filtros")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12 mb-2 ml-2"},[_c('h4',{staticClass:"def-title"},[_vm._v(_vm._s(_vm.pluralEntity))])]),_vm._v(" "),(!_vm.hideSearch)?_c('div',{staticClass:"col-md-4 col-11 mx-auto mb-2"},[_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchString),expression:"searchString"}],staticClass:"form-control form-control-sm",attrs:{"id":"search","type":"text","placeholder":'Pesquisar ' + _vm.pluralEntity,"title":_vm.titleSearch,"data-toggle":"tooltip","data-placement":"top"},domProps:{"value":(_vm.searchString)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handlePesquisar.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.searchString=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary",staticStyle:{"margin-right":"5px"},on:{"click":_vm.handlePesquisar}},[_c('i',{staticClass:"fa fa-search",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),(_vm.filterButton)?_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"title":"Mais Filtros"},on:{"click":_vm.clickFilter}},[_c('i',{staticClass:"fa fa-filter",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.refreshButton)?_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"title":"Atualizar Grid"},on:{"click":_vm.clickRefresh}},[_c('i',{staticClass:"fa fa-refresh",attrs:{"aria-hidden":"true"}})]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12 mt-2 mt-md-0"},[(_vm.filterMonth)?_c('input-month',{attrs:{"p-month":_vm.monthObj},on:{"monthChange":_vm.handleMonthChange}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-5 col-12 ml-auto float-right my-3 mt-md-0"},[(_vm.videoButton)?_c('div',{staticClass:"btn-group float-right"},[_c('v-button',{attrs:{"label":"","icon":_vm.videoIcon || 'fa-play',"video":true,"title":"Veja o vídeo","data-toggle":"tooltip","data-placement":"top"},on:{"click":_vm.clickVideo}})],1):_vm._e(),_vm._v(" "),(_vm.moreActions && _vm.moreActions.length)?_c('div',{staticClass:"btn-group float-right"},[_c('v-button',{attrs:{"label":"Mais Ações","actions":_vm.moreActions},on:{"click":_vm.clickAction}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn-group float-right"},[(_vm.newButton && !_vm.incluirActions)?_c('a',{staticClass:"btn btn-sm nb-btdef btn-newitem",staticStyle:{"margin-right":"5px","min-width":"150px"},attrs:{"href":"javascript:void(0);"},on:{"click":_vm.clickNew}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.singleEntity)+" ")]):_vm._e()]),_vm._v(" "),(_vm.incluirActions)?_c('div',{staticClass:"btn-group float-right"},[_c('v-button',{attrs:{"label":_vm.singleEntity,"icon":"fa-plus","nb-btdef":true,"actions":_vm.incluirActions},on:{"click":_vm.clickAction}})],1):_vm._e(),_vm._v(" "),(_vm.gerarEtiqueta)?_c('div',{staticClass:"btn-group float-right"},[_c('button',{staticClass:"btn btn-sm nb-btdef mr-1",on:{"click":_vm.clickPrint}},[_c('i',{staticClass:"fa fa-print"}),_vm._v(" Imprimir")])]):_vm._e()])]),_vm._v(" "),_c('filtro',{attrs:{"showfiltro":_vm.showAdvancedFilter,"params":_vm.advFiltersObject},on:{"change":_vm.handleApplyFilter,"cancel":function($event){_vm.showAdvancedFilter = false}}}),_vm._v(" "),(_vm.filterListActive.length > 0)?_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"lbl-edit"},[_vm._v("Filtros: ")]),_vm._v(" "),_vm._l((_vm.filterListActive),function(filter,index){return _c('div',{key:index,staticClass:"badgefilter badge-secondary",attrs:{"role":"alert"}},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert"},on:{"click":function($event){return _vm.handleRemoveFilter(index, filter.filterIndex, filter.optionId)}}},[_vm._v("\n          x")]),_vm._v(" "),_c('label',{staticClass:"mt-1"},[_vm._v(_vm._s(filter.text))])])})],2)]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showVideo)?_c('div',{staticClass:"guia-video",on:{"click":function($event){_vm.showVideo = false}}},[_c('div',{staticClass:"guia-video-content text-center d-flex justify-content-center align-items-center flex-column shadow"},[_c('div',{staticClass:"d-flex justify-content-end",staticStyle:{"width":"100%","margin-right":"10px"}},[_c('button',{staticClass:"close",staticStyle:{"font-size":"2.5rem"},attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.showVideo = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('iframe',{staticStyle:{"max-width":"800px"},attrs:{"width":"560","height":"315","src":_vm.urlVideo,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-right"},[(_vm.options.barDefault)?_c('div',{staticClass:"btn-group"},[(_vm.options.btnEdit)?_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Alterar"},on:{"click":function($event){return _vm.clickEdit()}}},[_c('i',{staticClass:"fa fa-pencil fa-fw"}),_vm._v(" "),(_vm.options.btnEditLabel)?_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.options.btnEditLabel))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.options.btnDelete)?_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Excluir"},on:{"click":function($event){return _vm.clickDelete()}}},[_c('i',{staticClass:"fa fa-trash fa-fw"})]):_vm._e(),_vm._v(" "),(_vm.options.btnArchive)?_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Consulta Estoque"},on:{"click":function($event){return _vm.clickArchive()}}},[_c('i',{staticClass:"fa fa-archive fa-fw"}),_vm._v(" "),(_vm.options.btnArchiveLabel)?_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.options.btnArchiveLabel))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.options.btnView)?_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Visualizar mais detalhes"},on:{"click":function($event){return _vm.clickView()}}},[_c('i',{staticClass:"fa fa-search fa-fw"})]):_vm._e(),_vm._v(" "),(_vm.options.btnPrint)?_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Imprimir/PDF"},on:{"click":function($event){return _vm.clickPrint()}}},[_c('i',{staticClass:"fa fa-print fa-fw"})]):_vm._e(),_vm._v(" "),(_vm.faturar)?_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Faturar"},on:{"click":function($event){return _vm.clickFaturar()}}},[_c('i',{staticClass:"fa fa-dollar fa-fw"})]):_vm._e(),_vm._v(" "),(_vm.devolucao)?_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Devolucao"},on:{"click":function($event){return _vm.clickDevolucao()}}},[_vm._v("\n                Devolução\n                    "),_c('i',{staticClass:"fa fa-undo fa-fw"})]):_vm._e(),_vm._v(" "),(_vm.moreActions && _vm.moreActions.length > 0)?_c('div',{staticClass:"btn-group float-right"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",staticStyle:{"z-index":"9999"},attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.moreActions),function(action){return _c('a',{key:action.action,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)","title":action.title},on:{"click":function($event){return _vm.clickAction(action.action, action)}}},[_vm._v(_vm._s(action.label))])}),0)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.options.barPedvIt)?_c('div',{staticClass:"btn-group"},[(!_vm.view)?_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Alterar Item"},on:{"click":function($event){return _vm.clickEdit()}}},[_c('i',{staticClass:"fa fa-pencil fa-fw"})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Visualizar mais detalhes do item"},on:{"click":function($event){return _vm.clickView()}}},[_c('i',{staticClass:"fa fa-search fa-fw"})]),_vm._v(" "),(!_vm.view)?_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Excluir Item"},on:{"click":function($event){return _vm.clickDelete()}}},[_c('i',{staticClass:"fa fa-trash fa-fw"})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.options.barNF)?_c('div',{staticClass:"btn-group"},[(_vm.edit)?_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Alterar"},on:{"click":function($event){return _vm.clickEdit()}}},[_c('i',{staticClass:"fa fa-pencil fa-fw"})]):_vm._e(),_vm._v(" "),(_vm.view)?_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Visualizar detalhes"},on:{"click":function($event){return _vm.clickView()}}},[_c('i',{staticClass:"fa fa-search fa-fw"})]):_vm._e(),_vm._v(" "),(_vm.sefaz)?_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Enviar NF-e para SEFAZ"},on:{"click":function($event){return _vm.clickSend()}}},[_c('i',{staticClass:"fa fa-rss-square fa-fw"})]):_vm._e(),_vm._v(" "),(_vm.print)?_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Gerar Danfe PDF"},on:{"click":function($event){return _vm.clickPrint()}}},[_c('i',{staticClass:"fa fa-file-pdf-o fa-fw"})]):_vm._e(),_vm._v(" "),(_vm.xml)?_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Baixar XML da NF-e"},on:{"click":function($event){return _vm.clickXML()}}},[_vm._v("xml\n            ")]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-outline-secondary dropdown-toggle",attrs:{"data-toggle":"dropdown"}},[_vm._v("Mais Ações "),_c('span',{staticClass:"caret"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_bar_manut_vue__ = __webpack_require__(408);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3775384a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_bar_manut_vue__ = __webpack_require__(1118);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_bar_manut_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3775384a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_bar_manut_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row nb-margin-bottom align-items-center",attrs:{"id":"top"}},[_c('div',{staticClass:"col-md-6 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12 mt-md-0 mt-3"},[_c('div',{staticClass:"btn-group float-right"},[(_vm.buttonRetorno)?_c('v-button',{attrs:{"tabindex":1,"label":"Retornar","title":"","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"d-inline-block",attrs:{"tabindex":"0","data-toggle":"tooltip","title":_vm.disabledTitle}},[(_vm.buttonSave)?_c('v-button',{attrs:{"label":"Salvar","nb-btdef":true,"icon":"fa-save","disabled":_vm.disableSave},on:{"click":_vm.handleSave}}):_vm._e()],1),_vm._v(" "),(_vm.buttonCancel)?_c('v-button',{attrs:{"tabindex":1,"label":"Cancelar","title":_vm.titleCancel,"danger":true},on:{"click":function($event){return _vm.confirmMessage('can')}}}):_vm._e(),_vm._v(" "),(_vm.buttonDelete)?_c('v-button',{attrs:{"tabindex":1,"label":"","title":_vm.titleDelete,"icon":"fa-trash"},on:{"click":function($event){return _vm.confirmMessage('del')}}}):_vm._e()],1),_vm._v(" "),(_vm.moreActions && _vm.moreActions.length)?_c('div',{staticClass:"btn-group float-right"},[_c('v-button',{attrs:{"label":"Mais Ações","actions":_vm.moreActions},on:{"click":_vm.clickAction}})],1):_vm._e()]),_vm._v(" "),(_vm.modalDelete)?_c('md-message',{attrs:{"tabindex":1,"code":"delete"},on:{"confirm":function($event){return _vm.handleDelete()},"close":function($event){return _vm.closeModal()}}}):_vm._e(),_vm._v(" "),(_vm.modalCancel)?_c('md-message',{attrs:{"tabindex":1,"code":"cancel"},on:{"confirm":function($event){return _vm.handleCancel()},"close":function($event){return _vm.closeModal()}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_label_vue__ = __webpack_require__(409);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d0f67fe_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_label_vue__ = __webpack_require__(1122);
function injectStyle (ssrContext) {
  __webpack_require__(1120)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_label_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d0f67fe_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_label_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1121);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("66bdae81", content, true, {});

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".tooltip{z-index:10000000}", ""]);

// exports


/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm._class},[_vm._v("\n    "+_vm._s(_vm._label)+" \n    "),(_vm.titleAddButton)?_c('span',{staticClass:"badge-incluir badge-blue",staticStyle:{"color":"white"},attrs:{"href":"#"},on:{"click":_vm.handleAddButton}},[_vm._v(" "+_vm._s(_vm.titleAddButton)+" ")]):_vm._e(),_vm._v(" "),(_vm.badgeHelp)?_c('i',{staticClass:"fa fa-question-circle-o",staticStyle:{"color":"#07a7cf"},attrs:{"data-toggle":"tooltip","data-placement":"top","title":_vm.help,"aria-hidden":"true"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl-title"},[(_vm.icon)?_c('i',{staticClass:"fa",class:_vm.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1125);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0a5be022", content, true, {});

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".btn.green{color:#fff;background-color:#627d4c;border-color:#aeafb1}.btn.green.active,.btn.green:active,.btn.green:focus,.btn.green:hover{color:#fff;background-color:#759c55;border-color:#759c55}.btn.red{color:#fff;background-color:#f71414}.btn.red.active,.btn.red:active,.btn.red:focus,.btn.red:hover{color:#fff;background-color:#fa7272;border-color:#fa7272}", ""]);

// exports


/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.link)?_c('div',{staticClass:"btn-group align-items-center"},[(!_vm.actions)?_c('div',[_c('a',{ref:"botao",staticClass:"btn",class:{'disabled': _vm.disabled, 'nb-btdef': _vm.nbBtdef, 'btn-success': _vm.success , 'btn-danger': _vm.danger, 'btn-video': _vm.video, 'nb-btn-video': _vm.video && _vm.icon === 'fa-youtube-play', 'btn-outline-secondary': !_vm.nbBtdef && !_vm.success && !_vm.danger && !_vm.video},staticStyle:{"margin-right":"5px"},style:(_vm.customStyle ? _vm.customStyle : _vm.btStyle),attrs:{"href":"javascript:void(0);","customStyle":_vm.customStyle,"data-toggle":"tooltip","data-placement":"top","title":_vm.title,"tabindex":_vm.tabindex},on:{"click":function($event){return _vm.handleClick()}}},[(_vm.icon)?_c('i',{staticClass:"fa",class:_vm.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.label))])]):_vm._e(),_vm._v(" "),(_vm.actions)?_c('div',[_c('button',{staticClass:"btn dropdown-toggle",class:{'disabled': _vm.disabled, 'nb-btdef': _vm.nbBtdef, 'btn-success': _vm.success , 'btn-danger': _vm.danger, 'btn-outline-secondary': !_vm.nbBtdef && !_vm.success && !_vm.danger},staticStyle:{"margin-right":"5px"},style:(_vm.btStyle),attrs:{"tabindex":_vm.tabindex,"data-toggle":"dropdown"}},[(_vm.icon)?_c('i',{staticClass:"fa",class:_vm.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "+_vm._s(_vm._label)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.actions),function(action){return _c('a',{key:action.action,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleActions(action.action)}}},[_vm._v(_vm._s(action.label))])}),0)]):_vm._e()]):_c('div',[_c('a',{ref:"botao",staticClass:"pr-2",staticStyle:{"cursor":"pointer","color":"#0091ea"},attrs:{"tabindex":_vm.tabindex,"title":_vm.title,"data-toggle":"tooltip","data-placement":"top"},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('i',{staticClass:"fa",class:_vm.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_cep_vue__ = __webpack_require__(413);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_68efa02a_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_cep_vue__ = __webpack_require__(1130);
function injectStyle (ssrContext) {
  __webpack_require__(1128)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68efa02a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_cep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_68efa02a_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_cep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1129);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("70ecd73f", content, true, {});

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "input[data-v-68efa02a]{width:100%}", ""]);

// exports


/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"cep",attrs:{"type":"text"},domProps:{"value":_vm.cep},on:{"keyup":_vm.buscaCep,"input":function($event){return _vm.updateValue($event.target.value)},"blur":_vm.formatValue,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.focusControl.apply(null, arguments)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_fone_vue__ = __webpack_require__(414);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca534a84_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_fone_vue__ = __webpack_require__(1134);
function injectStyle (ssrContext) {
  __webpack_require__(1132)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca534a84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_fone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca534a84_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_fone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1133);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("8dc4fade", content, true, {});

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "input[data-v-ca534a84]{width:100%}", ""]);

// exports


/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"fone",attrs:{"type":"text","maxlenght":"15","placeholder":"(00) 0000-0000"},domProps:{"value":_vm.fone},on:{"focus":_vm.handleFocus,"input":function($event){return _vm.updateValue($event.target.value)},"blur":_vm.handleBlur,"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleEsc.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.handleKeyDown.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.handleKeyUp.apply(null, arguments)}],"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleEnter.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.handleKeyTab.apply(null, arguments)}]}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_hora_vue__ = __webpack_require__(415);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b63fedd4_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_hora_vue__ = __webpack_require__(1138);
function injectStyle (ssrContext) {
  __webpack_require__(1136)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b63fedd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_hora_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b63fedd4_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_hora_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1137);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1fe6d7a4", content, true, {});

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "input[data-v-b63fedd4]{width:100%}", ""]);

// exports


/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"hora",attrs:{"type":"text","placeholder":"00:00"},domProps:{"value":_vm.hora},on:{"focus":_vm.selectAll,"input":function($event){return _vm.updateValue($event.target.value)},"blur":_vm.handleBlur,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.focusControl.apply(null, arguments)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_email_vue__ = __webpack_require__(416);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ab78dd0_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_email_vue__ = __webpack_require__(1142);
function injectStyle (ssrContext) {
  __webpack_require__(1140)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9ab78dd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_email_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ab78dd0_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_email_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1141);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("52087393", content, true, {});

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "input[data-v-9ab78dd0]{width:100%}", ""]);

// exports


/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"email",attrs:{"type":"text","name":_vm.name},domProps:{"value":_vm.email},on:{"focus":_vm.selectAll,"input":function($event){return _vm.updateValue($event.target.value)},"blur":_vm.handleValidateEmail,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.focusControl.apply(null, arguments)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_email_list_vue__ = __webpack_require__(417);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6693c120_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_email_list_vue__ = __webpack_require__(1146);
function injectStyle (ssrContext) {
  __webpack_require__(1144)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6693c120"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_email_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6693c120_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_email_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1145);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0fb100e0", content, true, {});

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".badge-email[data-v-6693c120]{display:inline-block;padding:0 5px;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;background:#fff;border:1px solid;border-radius:10px;border-color:#ebebeb}.badge-email[data-v-6693c120]:hover{background-color:#f7f7f7}.invalid[data-v-6693c120]{border-color:red}.close[data-v-6693c120]:focus,.close[data-v-6693c120]:hover{text-decoration:none;opacity:.75}.close[data-v-6693c120]{float:right;font-size:1rem;color:#c5c4c4;opacity:1;margin:3px 5px 0}", ""]);

// exports


/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-control form-control-sm"},[(_vm.emailList.length > 0)?_c('div',{staticClass:"row",staticStyle:{"cursor":"text"},on:{"click":_vm.focus}},[_c('div',{staticClass:"col-md-12"},_vm._l((_vm.emailList),function(email,index){return _c('div',{key:index,staticClass:"badge-email mr-2",class:{ 'invalid': email.invalid },attrs:{"role":"alert"}},[_c('button',{staticClass:"close",attrs:{"type":"button","tabindex":"1","data-dismiss":"alert"},on:{"click":function($event){return _vm.handleRemoveEmail(index)}}},[_vm._v("\n                  x")]),_vm._v(" "),_c('label',{staticClass:"mt-1"},[_vm._v(_vm._s(email.label))])])}),0)]):_vm._e(),_vm._v(" "),_c('input-search',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInput),expression:"showInput"}],ref:"email",attrs:{"isEmailList":true,"params":_vm.inputParams},on:{"select":_vm.handleSelect,"enter":_vm.addEmailDigitado,"blur":_vm.handleBlur},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_value_vue__ = __webpack_require__(418);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_76504c2b_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_value_vue__ = __webpack_require__(1150);
function injectStyle (ssrContext) {
  __webpack_require__(1148)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76504c2b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_value_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_76504c2b_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_value_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1149);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3d12e577", content, true, {});

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "input[data-v-76504c2b]{width:100%}", ""]);

// exports


/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"valor",attrs:{"type":"text"},domProps:{"value":_vm.valor},on:{"focus":_vm.selectAll,"input":function($event){return _vm.updateValue($event.target.value)},"blur":_vm.handleBlur,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.keyEsc.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.focusControl.apply(null, arguments)}]}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_checkbox_vue__ = __webpack_require__(419);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab786ff4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_checkbox_vue__ = __webpack_require__(1152);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab786ff4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"lbl-edit",attrs:{"data-toggle":"tooltip","data-placement":"top","title":_vm.title}},[_c('input',{ref:"cb",staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked,"value":_vm.vvalue},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.focusControl.apply(null, arguments)},"change":function($event){return _vm.updateValue($event.target.checked)}}}),_c('span',{style:(_vm.customStyle)},[_vm._v(_vm._s(_vm.vlabel))]),_vm._v(" "),(_vm.bHelp)?_c('span',{staticClass:"badge badge-secondary"},[_vm._v("?")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_switch_vue__ = __webpack_require__(420);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d31975bc_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_switch_vue__ = __webpack_require__(1156);
function injectStyle (ssrContext) {
  __webpack_require__(1154)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d31975bc_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1155);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e9e66df6", content, true, {});

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".switch{position:relative;display:inline-block;width:60px;height:34px}.switch input{display:none}.slider{cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc}.slider,.slider:before{position:absolute;-webkit-transition:.4s;transition:.4s}.slider:before{content:\"\";height:26px;width:26px;left:4px;bottom:4px;background-color:#fff}input.default:checked+.slider{background-color:#444}input.primary:checked+.slider{background-color:#2196f3}input.success:checked+.slider{background-color:#8bc34a}input.info:checked+.slider{background-color:#3de0f5}input.warning:checked+.slider{background-color:#ffc107}input.danger:checked+.slider{background-color:#f44336}input:focus+.slider{box-shadow:0 0 1px #2196f3}input:checked+.slider:before{-webkit-transform:translateX(26px);-ms-transform:translateX(26px);transform:translateX(26px)}.slider.round{border-radius:34px}.slider.round:before{border-radius:50%}", ""]);

// exports


/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-check d-flex align-items-center"},[_c('label',{staticClass:"switch"},[_c('input',{ref:"cb",class:_vm._class,attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked,"value":_vm.vvalue},on:{"change":function($event){return _vm.updateValue($event.target.checked)}}}),_vm._v(" "),_c('span',{staticClass:"slider round"})]),_vm._v(" "),_c('label',{staticClass:"ml-3 lbl-edit",attrs:{"data-toggle":"tooltip","data-placement":"top","title":_vm.help}},[_vm._v(_vm._s(_vm.vlabel)+" "),(_vm.bHelp)?_c('span',[_c('i',{staticClass:"fa fa-question-circle-o",staticStyle:{"color":"#07a7cf"}})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_month_vue__ = __webpack_require__(421);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f61c1552_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_month_vue__ = __webpack_require__(1160);
function injectStyle (ssrContext) {
  __webpack_require__(1158)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f61c1552"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_month_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f61c1552_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_month_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1159);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("77b2ef61", content, true, {});

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "input[data-v-f61c1552]{width:100%}.dropdown-total[data-v-f61c1552]{z-index:1051;margin-top:3px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;position:absolute;padding:10px;z-index:1000;float:left;min-width:160px;list-style:none;background-color:#fff;border:1px solid #00000033;box-shadow:0 5px 10px #00000033;background-clip:padding-box}", ""]);

// exports


/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-items-center"},[_c('div',{staticClass:"form-group form-group-sm"},[_c('div',{staticClass:"input-group input-group-sm"},[_c('span',{staticClass:"input-group-append"},[(_vm.showButtons)?_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"title":"Mês Anterior"},on:{"click":_vm.clickMesAnterior}},[_c('i',{staticClass:"fa fa-minus",attrs:{"aria-hidden":"true"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-control form-control-sm",staticStyle:{"min-width":"150px","display":"flex","justify-content":"space-between"},attrs:{"data-toggle":"dropdown"}},[_c('span',[_vm._v(_vm._s(_vm.monthString))]),_vm._v(" "),(_vm.showOptions)?_c('span',{staticClass:"dropdown-toggle"}):_vm._e()]),_vm._v(" "),(_vm.showOptions)?_c('div',{staticClass:"dropdown-menu"},_vm._l((_vm.options),function(action){return _c('a',{key:action.action,staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){return _vm.clickAction(action.action)}}},[_vm._v(_vm._s(action.label))])}),0):_vm._e(),_vm._v(" "),_c('span',{staticClass:"input-group-append"},[(_vm.showButtons)?_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"title":"Próximo Mês"},on:{"click":_vm.clickProximoMes}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}})]):_vm._e()])]),_vm._v(" "),(_vm.inputingDates)?_c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"dropdown-total col-md-12 col-12 mt-n3",staticStyle:{"padding":"15px","width":"250px"}},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){_vm.inputingDates = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('form-field',{ref:"start",attrs:{"type":"date","col":"12","label":"Data Inicial"},model:{value:(_vm.start),callback:function ($$v) {_vm.start=$$v},expression:"start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-center"},[_c('form-field',{ref:"end",attrs:{"type":"date","col":"12","label":"Data Final"},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('v-button',{attrs:{"label":"Ok","title":"","icon":"fa-check","nb-btdef":true},on:{"click":_vm.handlePeriodo}})],1)])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1162);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("52d52a97", content, true, {});

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "input[data-v-401a9334]{width:100%}.dropdown-total[data-v-401a9334]{z-index:1051;margin-top:3px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;position:absolute;padding:10px;z-index:1000;float:left;min-width:160px;list-style:none;background-color:#fff;border:1px solid #00000033;box-shadow:0 5px 10px #00000033;background-clip:padding-box}", ""]);

// exports


/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"form-group form-group-sm d-flex"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},_vm._l((_vm.options),function(action){return _c('a',{key:action.action,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickAction(action.action)}}},[_vm._v(_vm._s(action.label))])}),0)]),_vm._v(" "),_c('div',{staticClass:"ml-3"}),_vm._v(" "),_c('form-field',{ref:"start",staticClass:"align-items-center",attrs:{"type":"date"},model:{value:(_vm.start),callback:function ($$v) {_vm.start=$$v},expression:"start"}}),_vm._v(" "),_c('div',{staticClass:"ml-3"}),_vm._v(" "),_c('form-field',{ref:"end",attrs:{"type":"date"},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}}),_vm._v(" "),(_vm.showButtons)?_c('span',{staticStyle:{"cursor":"pointer","font-size":"18px"},attrs:{"title":"Mês Anterior"},on:{"click":function($event){return _vm.clickMesAnterior()}}},[_c('i',{staticClass:"fa fa-chevron-left ml-3",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.showButtons)?_c('span',{staticStyle:{"cursor":"pointer","font-size":"18px"},attrs:{"title":"Próximo Mês"},on:{"click":function($event){return _vm.clickProximoMes()}}},[_c('i',{staticClass:"fa fa-chevron-right ml-3",attrs:{"aria-hidden":"true"}})]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-control form-control-sm",staticStyle:{"width":"28px","justify-content":"space-between"},attrs:{"data-toggle":"dropdown"}},[_c('span',{staticClass:"dropdown-toggle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_number_vue__ = __webpack_require__(424);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_42e584b3_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_number_vue__ = __webpack_require__(1167);
function injectStyle (ssrContext) {
  __webpack_require__(1165)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42e584b3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_number_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_42e584b3_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_number_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1166);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("f24af78e", content, true, {});

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "input[data-v-42e584b3]{width:100%}", ""]);

// exports


/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"valor",attrs:{"type":"text"},domProps:{"value":_vm.valor},on:{"focus":_vm.selectAll,"input":function($event){return _vm.updateValue($event.target.value)},"blur":_vm.formatValue,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.focusControl.apply(null, arguments)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_part_vue__ = __webpack_require__(425);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_a75982c8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_part_vue__ = __webpack_require__(1192);
function injectStyle (ssrContext) {
  __webpack_require__(1169)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_part_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_a75982c8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_part_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1170);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("50c2c7f0", content, true, {});

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "li{line-height:20px}", ""]);

// exports


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1172);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d3772482", content, true, {});

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1174);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("655357fe", content, true, {});

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row align-items-center"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.grucli.descricao.validator),expression:"metadata.grucli.descricao.validator"}],ref:"descricao",attrs:{"type":"text","col":"6","metadata":_vm.metadata.grucli.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.grucli.descricao),callback:function ($$v) {_vm.$set(_vm.grucli, "descricao", $$v)},expression:"grucli.descricao"}}),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-button',{attrs:{"label":"Salvar","nb-btdef":true},on:{"click":_vm.handleSave}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.closeForm}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1177);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1cbfe276", content, true, {});

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Grupo de Fornecedor","plural-entity":"Grupos de Fornecedor","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"metadata":_vm.metadata.grufor.codgrufor,"type":"text","col":"2","disabled":true},model:{value:(_vm.grufor.codgrufor),callback:function ($$v) {_vm.$set(_vm.grufor, "codgrufor", $$v)},expression:"grufor.codgrufor"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.grufor.descricao.validator),expression:"metadata.grufor.descricao.validator"}],ref:"descricao",attrs:{"type":"text","col":"6","metadata":_vm.metadata.grufor.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.grufor.descricao),callback:function ($$v) {_vm.$set(_vm.grufor, "descricao", $$v)},expression:"grufor.descricao"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1180);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d1b95aba", content, true, {});

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Natureza Financeira","plural-entity":"Naturezas Financeira","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',{attrs:{"id":"natfin"}},[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.natfin.descricao.validator),expression:"metadata.natfin.descricao.validator"}],ref:"descricao",attrs:{"type":"text","col":"6","metadata":_vm.metadata.natfin.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.natfin.descricao),callback:function ($$v) {_vm.$set(_vm.natfin, "descricao", $$v)},expression:"natfin.descricao"}})],1),_vm._v(" "),_c('div',{staticClass:"row d-flex flex-column"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.natfin.codnatfinpai.validator),expression:"metadata.natfin.codnatfinpai.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.natfin.codnatfinpai,"name":"codnatfinpai","v-errors":_vm.errors,"disabled":true,"parent":"natfin","select2":{ entity: _vm.select2Natfin, minlength: 0 }},model:{value:(_vm.natfin.codnatfinpai),callback:function ($$v) {_vm.$set(_vm.natfin, "codnatfinpai", $$v)},expression:"natfin.codnatfinpai"}})],1),_vm._v(" "),_c('div',{staticClass:"row d-flex flex-column"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('input-checkbox',{attrs:{"label":"Considera no DRE?","value-checked":"S","value-unchecked":"N"},model:{value:(_vm.natfin.entradre),callback:function ($$v) {_vm.$set(_vm.natfin, "entradre", $$v)},expression:"natfin.entradre"}})],1),_vm._v(" "),(_vm.natfin.entradre == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.natfin.coddre.validator),expression:"metadata.natfin.coddre.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.natfin.coddre,"name":"coddre","v-errors":_vm.errors,"parent":"natfin","select2":{ entity: _vm.select2DRE, minlength: 0 }},model:{value:(_vm.natfin.coddre),callback:function ($$v) {_vm.$set(_vm.natfin, "coddre", $$v)},expression:"natfin.coddre"}}):_vm._e()],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1183);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("726f6ceb", content, true, {});

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vend"}},[_c('bar-manut',{attrs:{"single-entity":"Vendedor","plural-entity":"Vendedores","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"metadata":_vm.metadata.vend.codvend,"type":"text","col":"2","disabled":true},model:{value:(_vm.vend.codvend),callback:function ($$v) {_vm.$set(_vm.vend, "codvend", $$v)},expression:"vend.codvend"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vend.nome.validator),expression:"metadata.vend.nome.validator"}],ref:"nome",attrs:{"type":"text","col":"4","metadata":_vm.metadata.vend.nome,"name":"nome","v-errors":_vm.errors},model:{value:(_vm.vend.nome),callback:function ($$v) {_vm.$set(_vm.vend, "nome", $$v)},expression:"vend.nome"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.vend.stvend},model:{value:(_vm.vend.stvend),callback:function ($$v) {_vm.$set(_vm.vend, "stvend", $$v)},expression:"vend.stvend"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vend.cnpj.validator),expression:"metadata.vend.cnpj.validator"}],attrs:{"type":"cnpj","col":"2","metadata":_vm.metadata.vend.cnpj,"name":"cnpj","v-errors":_vm.errors},model:{value:(_vm.vend.cnpj),callback:function ($$v) {_vm.$set(_vm.vend, "cnpj", $$v)},expression:"vend.cnpj"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vend.cpf.validator),expression:"metadata.vend.cpf.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.vend.cpf,"name":"cpf","v-errors":_vm.errors},model:{value:(_vm.vend.cpf),callback:function ($$v) {_vm.$set(_vm.vend, "cpf", $$v)},expression:"vend.cpf"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vend.cep.validator),expression:"metadata.vend.cep.validator"}],attrs:{"type":"cep","col":"2","metadata":_vm.metadata.vend.cep,"name":"cep","v-errors":_vm.errors},on:{"update":_vm.updateCep},model:{value:(_vm.vend.cep),callback:function ($$v) {_vm.$set(_vm.vend, "cep", $$v)},expression:"vend.cep"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vend.ende.validator),expression:"metadata.vend.ende.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.vend.ende,"name":"ende","v-errors":_vm.errors},model:{value:(_vm.vend.ende),callback:function ($$v) {_vm.$set(_vm.vend, "ende", $$v)},expression:"vend.ende"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vend.endenr.validator),expression:"metadata.vend.endenr.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.vend.endenr,"name":"endenr","v-errors":_vm.errors},model:{value:(_vm.vend.endenr),callback:function ($$v) {_vm.$set(_vm.vend, "endenr", $$v)},expression:"vend.endenr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vend.endecomp.validator),expression:"metadata.vend.endecomp.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.vend.endecomp,"name":"endecomp","v-errors":_vm.errors},model:{value:(_vm.vend.endecomp),callback:function ($$v) {_vm.$set(_vm.vend, "endecomp", $$v)},expression:"vend.endecomp"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vend.uf.validator),expression:"metadata.vend.uf.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.vend.uf,"name":"uf","v-errors":_vm.errors,"parent":"vend"},model:{value:(_vm.vend.uf),callback:function ($$v) {_vm.$set(_vm.vend, "uf", $$v)},expression:"vend.uf"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vend.codmun.validator),expression:"metadata.vend.codmun.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.vend.codmun,"name":"codmun","v-errors":_vm.errors,"select2":{entity: 'mun/uf/' + _vm.vend.uf, minlength: 2},"parent":"vend"},model:{value:(_vm.vend.codmun),callback:function ($$v) {_vm.$set(_vm.vend, "codmun", $$v)},expression:"vend.codmun"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vend.fone1.validator),expression:"metadata.vend.fone1.validator"}],attrs:{"type":"fone","col":"2","metadata":_vm.metadata.vend.fone1,"name":"fone1","v-errors":_vm.errors},model:{value:(_vm.vend.fone1),callback:function ($$v) {_vm.$set(_vm.vend, "fone1", $$v)},expression:"vend.fone1"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vend.fone2.validator),expression:"metadata.vend.fone2.validator"}],attrs:{"type":"fone","col":"2","metadata":_vm.metadata.vend.fone2,"name":"fone2","v-errors":_vm.errors},model:{value:(_vm.vend.fone2),callback:function ($$v) {_vm.$set(_vm.vend, "fone2", $$v)},expression:"vend.fone2"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vend.fone3.validator),expression:"metadata.vend.fone3.validator"}],attrs:{"type":"fone","col":"2","metadata":_vm.metadata.vend.fone3,"name":"fone3","v-errors":_vm.errors},model:{value:(_vm.vend.fone3),callback:function ($$v) {_vm.$set(_vm.vend, "fone3", $$v)},expression:"vend.fone3"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vend.email.validator),expression:"metadata.vend.email.validator"}],attrs:{"type":"email","col":"6","metadata":_vm.metadata.vend.email,"name":"email","v-errors":_vm.errors},model:{value:(_vm.vend.email),callback:function ($$v) {_vm.$set(_vm.vend, "email", $$v)},expression:"vend.email"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1186);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0c2fcbea", content, true, {});

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Ramo de Atividade","plural-entity":"Ramos de Atividade","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"metadata":_vm.metadata.ramoat.codramo,"type":"text","col":"2","disabled":true},model:{value:(_vm.ramoat.codramo),callback:function ($$v) {_vm.$set(_vm.ramoat, "codramo", $$v)},expression:"ramoat.codramo"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.ramoat.descricao.validator),expression:"metadata.ramoat.descricao.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.ramoat.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.ramoat.descricao),callback:function ($$v) {_vm.$set(_vm.ramoat, "descricao", $$v)},expression:"ramoat.descricao"}})],1),_vm._v(" "),_c('div',{staticClass:"row"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.formatoTela == 'varejo')?_c('div',[_c('bar-manut',{attrs:{"single-entity":"Cliente","crud":this.localCrud,"disableSave":this.disableSave,"btn-delete":true},on:{"closeform":_vm.handleCloseForm,"delete":function($event){return _vm.apiDelete()},"save":function($event){return _vm.handleSave()},"savenew":function($event){return _vm.handleSave(true)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.nome.validator),expression:"metadata.part.nome.validator"}],ref:"nome",attrs:{"type":"text","col":"6","metadata":_vm.metadata.part.nome,"name":"nome","v-errors":_vm.errors},model:{value:(_vm.part.nome),callback:function ($$v) {_vm.$set(_vm.part, "nome", $$v)},expression:"part.nome"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.tppessoa.validator),expression:"metadata.part.tppessoa.validator"}],ref:"tppessoa",attrs:{"type":"select","col":"3","metadata":_vm.metadata.part.tppessoa,"name":"tppessoa","v-errors":_vm.errors,"disabled":_vm.part.part_com_movimento == 'S'},model:{value:(_vm.part.tppessoa),callback:function ($$v) {_vm.$set(_vm.part, "tppessoa", $$v)},expression:"part.tppessoa"}}),_vm._v(" "),(_vm.part.tppessoa == 'J')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({
          cnpj: true,
          required: true,
          min: 14,
          max: 14
        }),expression:"{\n          cnpj: true,\n          required: true,\n          min: 14,\n          max: 14\n        }"}],attrs:{"type":"cnpj","col":"3","label":"Cnpj","metadata":_vm.metadata.part.cnpjcpf,"name":"cnpjcpf","v-errors":_vm.errors,"disabled":_vm.part.part_com_movimento == 'S'},model:{value:(_vm.part.cnpjcpf),callback:function ($$v) {_vm.$set(_vm.part, "cnpjcpf", $$v)},expression:"part.cnpjcpf"}}):_vm._e(),_vm._v(" "),(_vm.part.tppessoa == 'F')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({
          cpf: true,
          required: true,
          
          min: 11,
          max: 11
        }),expression:"{\n          cpf: true,\n          required: true,\n          \n          min: 11,\n          max: 11\n        }"}],attrs:{"type":"number","col":"3","label":"Cpf","metadata":_vm.metadata.part.cnpjcpf,"name":"cnpjcpf","v-errors":_vm.errors},model:{value:(_vm.part.cnpjcpf),callback:function ($$v) {_vm.$set(_vm.part, "cnpjcpf", $$v)},expression:"part.cnpjcpf"}}):_vm._e(),_vm._v(" "),(_vm.showPreencherCadastro)?_c('form-field',{attrs:{"type":"text","col":"1","metadata":_vm.metadata.part.uf},model:{value:(_vm.part.uf),callback:function ($$v) {_vm.$set(_vm.part, "uf", $$v)},expression:"part.uf"}}):_vm._e(),_vm._v(" "),(_vm.showPreencherCadastro)?_c('v-button',{attrs:{"label":"Preencher Cadastro","icon":"","title":"Para uma pesquisa mais completa, informe o estado!"},on:{"click":function($event){return _vm.handlePreencherCadastro()}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true,  min: 10 }),expression:"{ required: true,  min: 10 }"}],attrs:{"label":"Telefone","type":"fone","col":"3","name":"fone","v-errors":_vm.errors,"mask":""},model:{value:(_vm.part.fone1),callback:function ($$v) {_vm.$set(_vm.part, "fone1", $$v)},expression:"part.fone1"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.emaildanfe.validator),expression:"metadata.part.emaildanfe.validator"}],attrs:{"type":"text","col":"8","metadata":_vm.metadata.part.emaildanfe,"case":"lower","name":"emaildanfe","v-errors":_vm.errors},model:{value:(_vm.part.emaildanfe),callback:function ($$v) {_vm.$set(_vm.part, "emaildanfe", $$v)},expression:"part.emaildanfe"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.dtnasc.validator),expression:"metadata.part.dtnasc.validator"}],attrs:{"type":"date","col":"3","metadata":_vm.metadata.part.dtnasc,"name":"dtnasc","v-errors":_vm.errors},model:{value:(_vm.part.dtnasc),callback:function ($$v) {_vm.$set(_vm.part, "dtnasc", $$v)},expression:"part.dtnasc"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.sexo.validator),expression:"metadata.part.sexo.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.part.sexo,"name":"sexo","v-errors":_vm.errors},model:{value:(_vm.part.sexo),callback:function ($$v) {_vm.$set(_vm.part, "sexo", $$v)},expression:"part.sexo"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.formatoTela == 'forcavendas')?_c('div',{attrs:{"id":"controlepedidos"}},[_c('bar-manut',{attrs:{"single-entity":"Cliente","crud":this.localCrud,"disableSave":this.disableSave,"btn-delete":true},on:{"closeform":_vm.handleCloseForm,"delete":function($event){return _vm.apiDelete()},"save":function($event){return _vm.handleSave(false)},"savenew":function($event){return _vm.handleSave(true)}}}),_vm._v(" "),(_vm.nfeValidations)?_c('validation',{staticClass:"mt-3",attrs:{"title":"Erros de Validação","showcontinueanyway":true,"messages":_vm.nfeValidations},on:{"continueanyway":_vm.nfeValidateContinueAnyway}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.tppessoa.validator),expression:"metadata.part.tppessoa.validator"}],ref:"tppessoa",attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.tppessoa,"name":"tppessoa","v-errors":_vm.errors,"disabled":_vm.part.part_com_movimento == 'S'},model:{value:(_vm.part.tppessoa),callback:function ($$v) {_vm.$set(_vm.part, "tppessoa", $$v)},expression:"part.tppessoa"}}),_vm._v(" "),(_vm.part.tppessoa == 'J')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ cnpj: true, required: false, min: 14, max: 14 }),expression:"{ cnpj: true, required: false, min: 14, max: 14 }"}],attrs:{"type":"cnpj","col":"4","label":"Cnpj","metadata":_vm.metadata.part.cnpjcpf,"name":"cnpjcpf","id":"cnpjcpf","v-errors":_vm.errors,"disabled":_vm.part.part_com_movimento == 'S'},model:{value:(_vm.part.cnpjcpf),callback:function ($$v) {_vm.$set(_vm.part, "cnpjcpf", $$v)},expression:"part.cnpjcpf"}}):_vm._e(),_vm._v(" "),(_vm.part.tppessoa == 'F')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ cpf: true, required: false,  min: 11, max: 11 }),expression:"{ cpf: true, required: false,  min: 11, max: 11 }"}],attrs:{"type":"number","col":"4","label":"Cpf","metadata":_vm.metadata.part.cnpjcpf,"name":"cnpjcpf","id":"cnpjcpf","v-errors":_vm.errors},model:{value:(_vm.part.cnpjcpf),callback:function ($$v) {_vm.$set(_vm.part, "cnpjcpf", $$v)},expression:"part.cnpjcpf"}}):_vm._e(),_vm._v(" "),(_vm.showPreencherCadastro)?_c('form-field',{attrs:{"type":"text","col":"1","metadata":_vm.metadata.part.uf},model:{value:(_vm.part.uf),callback:function ($$v) {_vm.$set(_vm.part, "uf", $$v)},expression:"part.uf"}}):_vm._e(),_vm._v(" "),(_vm.showPreencherCadastro)?_c('v-button',{attrs:{"label":"Preencher Cadastro","icon":"","title":"Para uma pesquisa mais completa, informe o estado!"},on:{"click":function($event){return _vm.handlePreencherCadastro()}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.nome.validator),expression:"metadata.part.nome.validator"}],ref:"nome",attrs:{"type":"text","col":"12","metadata":_vm.metadata.part.nome,"name":"nome","id":"nome","v-errors":_vm.errors},model:{value:(_vm.part.nome),callback:function ($$v) {_vm.$set(_vm.part, "nome", $$v)},expression:"part.nome"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.fantasia.validator),expression:"metadata.part.fantasia.validator"}],attrs:{"type":"text","col":"12","metadata":_vm.metadata.part.fantasia,"name":"fantasia","id":"fantasia","v-errors":_vm.errors},model:{value:(_vm.part.fantasia),callback:function ($$v) {_vm.$set(_vm.part, "fantasia", $$v)},expression:"part.fantasia"}})],1),_vm._v(" "),(_vm.part.tppessoa == 'J')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.contricms.validator),expression:"metadata.part.contricms.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.contricms,"name":"contricms","id":"contricms","v-errors":_vm.errors},model:{value:(_vm.part.contricms),callback:function ($$v) {_vm.$set(_vm.part, "contricms", $$v)},expression:"part.contricms"}}),_vm._v(" "),(_vm.part.contricms == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.iest.validator),expression:"metadata.part.iest.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.part.iest,"name":"iest","v-errors":_vm.errors},model:{value:(_vm.part.iest),callback:function ($$v) {_vm.$set(_vm.part, "iest", $$v)},expression:"part.iest"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.optsimples.validator),expression:"metadata.part.optsimples.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.optsimples,"name":"optsimples","v-errors":_vm.errors},model:{value:(_vm.part.optsimples),callback:function ($$v) {_vm.$set(_vm.part, "optsimples", $$v)},expression:"part.optsimples"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.tpcliente.validator),expression:"metadata.part.tpcliente.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.tpcliente,"name":"tpcliente","v-errors":_vm.errors},model:{value:(_vm.part.tpcliente),callback:function ($$v) {_vm.$set(_vm.part, "tpcliente", $$v)},expression:"part.tpcliente"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.zfranca.validator),expression:"metadata.part.zfranca.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.zfranca,"name":"zfranca","v-errors":_vm.errors},model:{value:(_vm.part.zfranca),callback:function ($$v) {_vm.$set(_vm.part, "zfranca", $$v)},expression:"part.zfranca"}}),_vm._v(" "),(_vm.part.zfranca == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.inscsuframa.validator),expression:"metadata.part.inscsuframa.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.part.inscsuframa,"name":"inscsuframa","v-errors":_vm.errors},model:{value:(_vm.part.inscsuframa),callback:function ($$v) {_vm.$set(_vm.part, "inscsuframa", $$v)},expression:"part.inscsuframa"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.limcred.validator),expression:"metadata.part.limcred.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.metadata.part.limcred,"name":"limcred","v-errors":_vm.errors},model:{value:(_vm.part.limcred),callback:function ($$v) {_vm.$set(_vm.part, "limcred", $$v)},expression:"part.limcred"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.tpentegov.validator),expression:"metadata.part.tpentegov.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.tpentegov,"name":"tpentegov","v-errors":_vm.errors},model:{value:(_vm.part.tpentegov),callback:function ($$v) {_vm.$set(_vm.part, "tpentegov", $$v)},expression:"part.tpentegov"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codgrucli.validator),expression:"metadata.part.codgrucli.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.part.codgrucli,"name":"codgrucli","v-errors":_vm.errors,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluir('grucli')}},model:{value:(_vm.part.codgrucli),callback:function ($$v) {_vm.$set(_vm.part, "codgrucli", $$v)},expression:"part.codgrucli"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codramo.validator),expression:"metadata.part.codramo.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.part.codramo,"name":"codramo","v-errors":_vm.errors,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluir('ramoat')}},model:{value:(_vm.part.codramo),callback:function ($$v) {_vm.$set(_vm.part, "codramo", $$v)},expression:"part.codramo"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.emaildanfe.validator),expression:"metadata.part.emaildanfe.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.part.emaildanfe,"case":"lower","name":"emaildanfe","v-errors":_vm.errors},model:{value:(_vm.part.emaildanfe),callback:function ($$v) {_vm.$set(_vm.part, "emaildanfe", $$v)},expression:"part.emaildanfe"}})],1),_vm._v(" "),(_vm.loja_b2b)?_c('label-title',{staticClass:"mt-2",attrs:{"title":"Vendas B2B"}}):_vm._e(),_vm._v(" "),(_vm.loja_b2b)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('input-switch',{attrs:{"type":"success","value-checked":"S","value-unchecked":"N","metadata-field":_vm.metadata.part.habilita_b2b},model:{value:(_vm.part.habilita_b2b),callback:function ($$v) {_vm.$set(_vm.part, "habilita_b2b", $$v)},expression:"part.habilita_b2b"}})],1)]):_vm._e(),_vm._v(" "),_c('label-title',{staticClass:"mt-2",attrs:{"title":"Contatos"}}),_vm._v(" "),_vm._l((_vm.partcontato),function(cont,index){return _c('div',{key:index,staticClass:"card ml-5 p-3 mb-2"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.partcontato.nomecontato.validator),expression:"metadata.partcontato.nomecontato.validator"}],attrs:{"type":"text","col":"12","metadata":_vm.metadata.partcontato.nomecontato,"name":"nomecontato","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(cont.nomecontato),callback:function ($$v) {_vm.$set(cont, "nomecontato", $$v)},expression:"cont.nomecontato"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.partcontato.email.validator),expression:"metadata.partcontato.email.validator"}],attrs:{"type":"email","col":"3","metadata":_vm.metadata.partcontato.email,"name":"email","id":"email","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(cont.email),callback:function ($$v) {_vm.$set(cont, "email", $$v)},expression:"cont.email"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.partcontato.fone1.validator),expression:"metadata.partcontato.fone1.validator"}],attrs:{"type":"fone","col":"3","metadata":_vm.metadata.partcontato.fone1,"name":"fone1","id":"fone1","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(cont.fone1),callback:function ($$v) {_vm.$set(cont, "fone1", $$v)},expression:"cont.fone1"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.partcontato.fone2.validator),expression:"metadata.partcontato.fone2.validator"}],attrs:{"type":"fone","col":"3","metadata":_vm.metadata.partcontato.fone2,"name":"fone2","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(cont.fone2),callback:function ($$v) {_vm.$set(cont, "fone2", $$v)},expression:"cont.fone2"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.partcontato.fone3.validator),expression:"metadata.partcontato.fone3.validator"}],attrs:{"type":"fone","col":"3","metadata":_vm.metadata.partcontato.fone3,"name":"fone3","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(cont.fone3),callback:function ($$v) {_vm.$set(cont, "fone3", $$v)},expression:"cont.fone3"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-button',{attrs:{"label":"","title":"Excluir Contato","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteContact(index)}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"","nb-btdef":index + 1 == _vm.part.partcontatoseq,"title":"Contato Preferencial","icon":"fa-check"},on:{"click":function($event){return _vm.handlePrefContact(index)}}})],1)])])}),_vm._v(" "),_c('div',{staticClass:"row pl-5 mb-3"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"btn-group"},[_c('a',{staticClass:"btn btn-sm btn-outline-secondary",staticStyle:{"margin-right":"5px"},attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.handleAddContact()}}},[_vm._v("Adicionar Contato")])])])]),_vm._v(" "),_c('label-title',{staticClass:"mb-2",attrs:{"title":"Endereço Principal"}}),_vm._v(" "),_c('div',{staticClass:"row pl-5 pb-3"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 8 }),expression:"{ max: 8 }"}],attrs:{"type":"cep","col":"3","metadata":_vm.metadata.part.cep,"name":"cep","v-errors":_vm.errors},on:{"update":_vm.updateCep},model:{value:(_vm.part.cep),callback:function ($$v) {_vm.$set(_vm.part, "cep", $$v)},expression:"part.cep"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 100 }),expression:"{ max: 100 }"}],attrs:{"type":"text","col":"9","metadata":_vm.metadata.part.ende,"name":"ende","v-errors":_vm.errors},model:{value:(_vm.part.ende),callback:function ($$v) {_vm.$set(_vm.part, "ende", $$v)},expression:"part.ende"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 40 }),expression:"{ max: 40 }"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.part.endenr,"name":"endenr","v-errors":_vm.errors},model:{value:(_vm.part.endenr),callback:function ($$v) {_vm.$set(_vm.part, "endenr", $$v)},expression:"part.endenr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 100 }),expression:"{ max: 100 }"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.part.endecomp,"name":"endecomp","v-errors":_vm.errors},model:{value:(_vm.part.endecomp),callback:function ($$v) {_vm.$set(_vm.part, "endecomp", $$v)},expression:"part.endecomp"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 60 }),expression:"{ max: 60 }"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.part.bairro,"name":"bairro","v-errors":_vm.errors},model:{value:(_vm.part.bairro),callback:function ($$v) {_vm.$set(_vm.part, "bairro", $$v)},expression:"part.bairro"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.uf.validator),expression:"metadata.part.uf.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.part.uf,"name":"uf","v-errors":_vm.errors},model:{value:(_vm.part.uf),callback:function ($$v) {_vm.$set(_vm.part, "uf", $$v)},expression:"part.uf"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.part.codmun,"name":"codmun","v-errors":_vm.errors,"select2":{ entity: 'mun/uf/' + _vm.part.uf, minlength: 2 }},model:{value:(_vm.part.codmun),callback:function ($$v) {_vm.$set(_vm.part, "codmun", $$v)},expression:"part.codmun"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codpais.validator),expression:"metadata.part.codpais.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.part.codpais,"name":"codpais","v-errors":_vm.errors},model:{value:(_vm.part.codpais),callback:function ($$v) {_vm.$set(_vm.part, "codpais", $$v)},expression:"part.codpais"}})],1),_vm._v(" "),_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Vendas"}}),_vm._v(" "),_c('div',{staticClass:"row pl-5"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codtabpre.validator),expression:"metadata.part.codtabpre.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.part.codtabpre,"name":"codtabpre","v-errors":_vm.errors},model:{value:(_vm.part.codtabpre),callback:function ($$v) {_vm.$set(_vm.part, "codtabpre", $$v)},expression:"part.codtabpre"}})],1),_vm._v(" "),_c('div',{staticClass:"row pl-5"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codcondicao.validator),expression:"metadata.part.codcondicao.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.part.codcondicao,"name":"codcondicao","v-errors":_vm.errors},model:{value:(_vm.part.codcondicao),callback:function ($$v) {_vm.$set(_vm.part, "codcondicao", $$v)},expression:"part.codcondicao"}})],1),_vm._v(" "),_c('div',{staticClass:"row pl-5 pb-5"},[_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.part.tpfrete,"disabled":_vm.isView},model:{value:(_vm.part.tpfrete),callback:function ($$v) {_vm.$set(_vm.part, "tpfrete", $$v)},expression:"part.tpfrete"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codparttr.validator),expression:"metadata.part.codparttr.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.part.codparttr,"name":"codparttr","v-errors":_vm.errors},model:{value:(_vm.part.codparttr),callback:function ($$v) {_vm.$set(_vm.part, "codparttr", $$v)},expression:"part.codparttr"}})],1),_vm._v(" "),(_vm.administrador)?_c('div',[(!_vm.showInfUsuario)?_c('div',{staticClass:"mt-2 mb-2"},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.showInfUsuario = true}}},[_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" Exibir\n          informações de usuário")])]):_vm._e(),_vm._v(" "),(_vm.showInfUsuario)?_c('div',[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Usuario vinculado ao cliente"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codusuario.validator),expression:"metadata.part.codusuario.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.part.codusuario,"disabled":_vm.isView,"name":"codusuario","v-errors":_vm.errors},model:{value:(_vm.part.codusuario),callback:function ($$v) {_vm.$set(_vm.part, "codusuario", $$v)},expression:"part.codusuario"}})],1)],1):_vm._e()]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.transportadora)?_c('div',{attrs:{"id":"transportadora"}},[_c('bar-manut',{attrs:{"single-entity":"Transportadora","crud":this.localCrud,"disableSave":this.disableSave,"btn-delete":true},on:{"closeform":_vm.handleCloseForm,"delete":function($event){return _vm.apiDelete()},"save":function($event){return _vm.handleSave(false)},"savenew":function($event){return _vm.handleSave(true)}}}),_vm._v(" "),(_vm.nfeValidations)?_c('validation',{staticClass:"mt-3",attrs:{"title":"Erros de Validação","showcontinueanyway":true,"messages":_vm.nfeValidations},on:{"continueanyway":_vm.nfeValidateContinueAnyway}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.nome.validator),expression:"metadata.part.nome.validator"}],ref:"nome",attrs:{"type":"text","col":"12","metadata":_vm.metadata.part.nome,"name":"nome","v-errors":_vm.errors},model:{value:(_vm.part.nome),callback:function ($$v) {_vm.$set(_vm.part, "nome", $$v)},expression:"part.nome"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.fantasia.validator),expression:"metadata.part.fantasia.validator"}],attrs:{"type":"text","col":"12","metadata":_vm.metadata.part.fantasia,"name":"fantasia","v-errors":_vm.errors},model:{value:(_vm.part.fantasia),callback:function ($$v) {_vm.$set(_vm.part, "fantasia", $$v)},expression:"part.fantasia"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.tppessoa.validator),expression:"metadata.part.tppessoa.validator"}],ref:"tppessoa",attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.tppessoa,"name":"tppessoa","v-errors":_vm.errors,"disabled":_vm.part.part_com_movimento == 'S'},model:{value:(_vm.part.tppessoa),callback:function ($$v) {_vm.$set(_vm.part, "tppessoa", $$v)},expression:"part.tppessoa"}}),_vm._v(" "),(_vm.part.tppessoa == 'J')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ cnpj: true, required: false, min: 14, max: 14 }),expression:"{ cnpj: true, required: false, min: 14, max: 14 }"}],attrs:{"type":"cnpj","col":"4","label":"Cnpj","metadata":_vm.metadata.part.cnpjcpf,"name":"cnpjcpf","id":"cnpjcpf","v-errors":_vm.errors,"disabled":_vm.part.part_com_movimento == 'S'},model:{value:(_vm.part.cnpjcpf),callback:function ($$v) {_vm.$set(_vm.part, "cnpjcpf", $$v)},expression:"part.cnpjcpf"}}):_vm._e(),_vm._v(" "),(_vm.part.tppessoa == 'F')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ cpf: true, required: false,  min: 11, max: 11 }),expression:"{ cpf: true, required: false,  min: 11, max: 11 }"}],attrs:{"type":"number","col":"4","label":"Cpf","metadata":_vm.metadata.part.cnpjcpf,"name":"cnpjcpf","id":"cnpjcpf","v-errors":_vm.errors},model:{value:(_vm.part.cnpjcpf),callback:function ($$v) {_vm.$set(_vm.part, "cnpjcpf", $$v)},expression:"part.cnpjcpf"}}):_vm._e(),_vm._v(" "),(_vm.showPreencherCadastro)?_c('form-field',{attrs:{"type":"text","col":"1","metadata":_vm.metadata.part.uf},model:{value:(_vm.part.uf),callback:function ($$v) {_vm.$set(_vm.part, "uf", $$v)},expression:"part.uf"}}):_vm._e(),_vm._v(" "),(_vm.showPreencherCadastro)?_c('v-button',{attrs:{"label":"Preencher Cadastro","icon":"","title":"Para uma pesquisa mais completa, informe o estado!"},on:{"click":function($event){return _vm.handlePreencherCadastro()}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.nome.validator),expression:"metadata.part.nome.validator"}],ref:"nome",attrs:{"type":"text","col":"12","metadata":_vm.metadata.part.nome,"name":"nome","v-errors":_vm.errors},model:{value:(_vm.part.nome),callback:function ($$v) {_vm.$set(_vm.part, "nome", $$v)},expression:"part.nome"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.fantasia.validator),expression:"metadata.part.fantasia.validator"}],attrs:{"type":"text","col":"12","metadata":_vm.metadata.part.fantasia,"name":"fantasia","v-errors":_vm.errors},model:{value:(_vm.part.fantasia),callback:function ($$v) {_vm.$set(_vm.part, "fantasia", $$v)},expression:"part.fantasia"}})],1),_vm._v(" "),_c('label-title',{staticClass:"mt-2",attrs:{"title":"Contatos"}}),_vm._v(" "),_vm._l((_vm.partcontato),function(cont,index){return _c('div',{key:index,staticClass:"card ml-5 p-3 mb-2"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.partcontato.nomecontato.validator),expression:"metadata.partcontato.nomecontato.validator"}],attrs:{"type":"text","col":"12","metadata":_vm.metadata.partcontato.nomecontato,"name":"nomecontato","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(cont.nomecontato),callback:function ($$v) {_vm.$set(cont, "nomecontato", $$v)},expression:"cont.nomecontato"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.partcontato.email.validator),expression:"metadata.partcontato.email.validator"}],attrs:{"type":"email","col":"3","metadata":_vm.metadata.partcontato.email,"name":"email","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(cont.email),callback:function ($$v) {_vm.$set(cont, "email", $$v)},expression:"cont.email"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.partcontato.fone1.validator),expression:"metadata.partcontato.fone1.validator"}],attrs:{"type":"fone","col":"3","metadata":_vm.metadata.partcontato.fone1,"name":"fone1","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(cont.fone1),callback:function ($$v) {_vm.$set(cont, "fone1", $$v)},expression:"cont.fone1"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.partcontato.fone2.validator),expression:"metadata.partcontato.fone2.validator"}],attrs:{"type":"fone","col":"3","metadata":_vm.metadata.partcontato.fone2,"name":"fone2","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(cont.fone2),callback:function ($$v) {_vm.$set(cont, "fone2", $$v)},expression:"cont.fone2"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.partcontato.fone3.validator),expression:"metadata.partcontato.fone3.validator"}],attrs:{"type":"fone","col":"3","metadata":_vm.metadata.partcontato.fone3,"name":"fone3","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(cont.fone3),callback:function ($$v) {_vm.$set(cont, "fone3", $$v)},expression:"cont.fone3"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-button',{attrs:{"label":"","title":"Excluir Contato","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteContact(index)}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"","nb-btdef":index + 1 == _vm.part.partcontatoseq,"title":"Contato Preferencial","icon":"fa-check"},on:{"click":function($event){return _vm.handlePrefContact(index)}}})],1)])])}),_vm._v(" "),_c('div',{staticClass:"row pl-5 mb-3"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"btn-group"},[_c('a',{staticClass:"btn btn-sm btn-outline-secondary",staticStyle:{"margin-right":"5px"},attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.handleAddContact()}}},[_vm._v("Adicionar Contato")])])])]),_vm._v(" "),_c('label-title',{staticClass:"mb-2",attrs:{"title":"Endereço"}}),_vm._v(" "),_c('div',{staticClass:"row pl-5 pb-3"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 8 }),expression:"{ max: 8 }"}],attrs:{"type":"cep","col":"3","metadata":_vm.metadata.part.cep,"name":"cep","v-errors":_vm.errors},on:{"update":_vm.updateCep},model:{value:(_vm.part.cep),callback:function ($$v) {_vm.$set(_vm.part, "cep", $$v)},expression:"part.cep"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 100 }),expression:"{ max: 100 }"}],attrs:{"type":"text","col":"9","metadata":_vm.metadata.part.ende,"name":"ende","v-errors":_vm.errors},model:{value:(_vm.part.ende),callback:function ($$v) {_vm.$set(_vm.part, "ende", $$v)},expression:"part.ende"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 40 }),expression:"{ max: 40 }"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.part.endenr,"name":"endenr","v-errors":_vm.errors},model:{value:(_vm.part.endenr),callback:function ($$v) {_vm.$set(_vm.part, "endenr", $$v)},expression:"part.endenr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 100 }),expression:"{ max: 100 }"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.part.endecomp,"name":"endecomp","v-errors":_vm.errors},model:{value:(_vm.part.endecomp),callback:function ($$v) {_vm.$set(_vm.part, "endecomp", $$v)},expression:"part.endecomp"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 60 }),expression:"{ max: 60 }"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.part.bairro,"name":"bairro","v-errors":_vm.errors},model:{value:(_vm.part.bairro),callback:function ($$v) {_vm.$set(_vm.part, "bairro", $$v)},expression:"part.bairro"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.uf.validator),expression:"metadata.part.uf.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.part.uf,"name":"uf","v-errors":_vm.errors},model:{value:(_vm.part.uf),callback:function ($$v) {_vm.$set(_vm.part, "uf", $$v)},expression:"part.uf"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.part.codmun,"name":"codmun","v-errors":_vm.errors,"select2":{ entity: 'mun/uf/' + _vm.part.uf, minlength: 2 }},model:{value:(_vm.part.codmun),callback:function ($$v) {_vm.$set(_vm.part, "codmun", $$v)},expression:"part.codmun"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codpais.validator),expression:"metadata.part.codpais.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.part.codpais,"name":"codpais","v-errors":_vm.errors},model:{value:(_vm.part.codpais),callback:function ($$v) {_vm.$set(_vm.part, "codpais", $$v)},expression:"part.codpais"}})],1)],2):_vm._e(),_vm._v(" "),(_vm.formatoTela == 'normal')?_c('div',{staticClass:"default-container",attrs:{"id":"participanteForm"}},[_c('bar-manut',{attrs:{"single-entity":"Participante","crud":this.localCrud,"disableSave":this.disableSave,"btn-delete":true},on:{"closeform":_vm.handleCloseForm,"delete":function($event){return _vm.apiDelete()},"save":function($event){return _vm.handleSave(false)},"savenew":function($event){return _vm.handleSave(true)}}}),_vm._v(" "),(_vm.nfeValidations)?_c('validation',{staticClass:"mt-3",attrs:{"title":"Erros de Validação","showcontinueanyway":true,"messages":_vm.nfeValidations},on:{"continueanyway":_vm.nfeValidateContinueAnyway}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"deafult-container"},[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Dados do Participante"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-12"},[_c('input-switch',{attrs:{"type":"success","label":"Cliente","value-checked":"S","value-unchecked":"N","metadata":_vm.metadata.part.cliente},model:{value:(_vm.part.cliente),callback:function ($$v) {_vm.$set(_vm.part, "cliente", $$v)},expression:"part.cliente"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12"},[_c('input-switch',{attrs:{"type":"success","label":"Fornecedor","value-checked":"S","value-unchecked":"N","metadata":_vm.metadata.part.forn},model:{value:(_vm.part.forn),callback:function ($$v) {_vm.$set(_vm.part, "forn", $$v)},expression:"part.forn"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12"},[_c('input-switch',{attrs:{"type":"success","label":"Transportadora","value-checked":"S","value-unchecked":"N","metadata":_vm.metadata.part.transp},model:{value:(_vm.part.transp),callback:function ($$v) {_vm.$set(_vm.part, "transp", $$v)},expression:"part.transp"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codpart.validator),expression:"metadata.part.codpart.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.part.codpart,"name":"codpart","v-errors":_vm.errors,"disabled":""},model:{value:(_vm.part.codpart),callback:function ($$v) {_vm.$set(_vm.part, "codpart", $$v)},expression:"part.codpart"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.dtcadastro.validator),expression:"metadata.part.dtcadastro.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.part.dtcadastro,"name":"dtcadastro","v-errors":_vm.errors,"disabled":""},model:{value:(_vm.part.dtcadastro),callback:function ($$v) {_vm.$set(_vm.part, "dtcadastro", $$v)},expression:"part.dtcadastro"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.stpart.validator),expression:"metadata.part.stpart.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.part.stpart,"name":"stpart","v-errors":_vm.errors},model:{value:(_vm.part.stpart),callback:function ($$v) {_vm.$set(_vm.part, "stpart", $$v)},expression:"part.stpart"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.tppessoa.validator),expression:"metadata.part.tppessoa.validator"}],ref:"tppessoa",attrs:{"type":"select","col":"3","metadata":_vm.metadata.part.tppessoa,"name":"tppessoa","v-errors":_vm.errors,"disabled":_vm.part.part_com_movimento == 'S'},model:{value:(_vm.part.tppessoa),callback:function ($$v) {_vm.$set(_vm.part, "tppessoa", $$v)},expression:"part.tppessoa"}}),_vm._v(" "),(_vm.part.tppessoa == 'J')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ cnpj: true, required: true, min: 14, max: 14 }),expression:"{ cnpj: true, required: true, min: 14, max: 14 }"}],attrs:{"type":"cnpj","col":"3","metadata":_vm.metadata.part.cnpjcpf,"name":"cnpjcpf","id":"cnpjcpf","v-errors":_vm.errors,"disabled":_vm.part.part_com_movimento == 'S'},model:{value:(_vm.part.cnpjcpf),callback:function ($$v) {_vm.$set(_vm.part, "cnpjcpf", $$v)},expression:"part.cnpjcpf"}}):_vm._e(),_vm._v(" "),(_vm.part.tppessoa == 'F')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ cpf: true, required: true,  min: 11, max: 11 }),expression:"{ cpf: true, required: true,  min: 11, max: 11 }"}],attrs:{"id":"cnpjcpf","type":"cnpj","col":"3","metadata":_vm.metadata.part.cnpjcpf,"name":"cnpjcpf","v-errors":_vm.errors},model:{value:(_vm.part.cnpjcpf),callback:function ($$v) {_vm.$set(_vm.part, "cnpjcpf", $$v)},expression:"part.cnpjcpf"}}):_vm._e(),_vm._v(" "),(_vm.showPreencherCadastro)?_c('form-field',{attrs:{"type":"text","col":"1","metadata":_vm.metadata.part.uf},model:{value:(_vm.part.uf),callback:function ($$v) {_vm.$set(_vm.part, "uf", $$v)},expression:"part.uf"}}):_vm._e(),_vm._v(" "),(_vm.showPreencherCadastro)?_c('v-button',{attrs:{"label":"Preencher Cadastro","icon":"","title":"Para uma pesquisa mais completa, informe o estado!"},on:{"click":function($event){return _vm.handlePreencherCadastro()}}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.part.tppessoa != 'J'),expression:"part.tppessoa != 'J'"},{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.rg.validator),expression:"metadata.part.rg.validator"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.part.rg,"name":"rg","v-errors":_vm.errors},model:{value:(_vm.part.rg),callback:function ($$v) {_vm.$set(_vm.part, "rg", $$v)},expression:"part.rg"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.nome.validator),expression:"metadata.part.nome.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.part.nome,"name":"nome","id":"nome","v-errors":_vm.errors},model:{value:(_vm.part.nome),callback:function ($$v) {_vm.$set(_vm.part, "nome", $$v)},expression:"part.nome"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.fantasia.validator),expression:"metadata.part.fantasia.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.part.fantasia,"name":"fantasia","id":"fantasia","v-errors":_vm.errors},model:{value:(_vm.part.fantasia),callback:function ($$v) {_vm.$set(_vm.part, "fantasia", $$v)},expression:"part.fantasia"}})],1),_vm._v(" "),(_vm.part.tppessoa == 'J')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.contricms.validator),expression:"metadata.part.contricms.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.contricms,"name":"contricms","id":"contricms","v-errors":_vm.errors},model:{value:(_vm.part.contricms),callback:function ($$v) {_vm.$set(_vm.part, "contricms", $$v)},expression:"part.contricms"}}),_vm._v(" "),(_vm.part.contricms == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.iest.validator),expression:"metadata.part.iest.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.part.iest,"name":"iest","v-errors":_vm.errors},model:{value:(_vm.part.iest),callback:function ($$v) {_vm.$set(_vm.part, "iest", $$v)},expression:"part.iest"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.optsimples.validator),expression:"metadata.part.optsimples.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.optsimples,"name":"optsimples","v-errors":_vm.errors},model:{value:(_vm.part.optsimples),callback:function ($$v) {_vm.$set(_vm.part, "optsimples", $$v)},expression:"part.optsimples"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.tpcliente.validator),expression:"metadata.part.tpcliente.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.tpcliente,"name":"tpcliente","v-errors":_vm.errors},model:{value:(_vm.part.tpcliente),callback:function ($$v) {_vm.$set(_vm.part, "tpcliente", $$v)},expression:"part.tpcliente"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.zfranca.validator),expression:"metadata.part.zfranca.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.zfranca,"name":"zfranca","v-errors":_vm.errors},model:{value:(_vm.part.zfranca),callback:function ($$v) {_vm.$set(_vm.part, "zfranca", $$v)},expression:"part.zfranca"}}),_vm._v(" "),(_vm.part.zfranca == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.inscsuframa.validator),expression:"metadata.part.inscsuframa.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.part.inscsuframa,"name":"inscsuframa","v-errors":_vm.errors},model:{value:(_vm.part.inscsuframa),callback:function ($$v) {_vm.$set(_vm.part, "inscsuframa", $$v)},expression:"part.inscsuframa"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.tpentegov.validator),expression:"metadata.part.tpentegov.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.tpentegov,"name":"tpentegov","v-errors":_vm.errors},model:{value:(_vm.part.tpentegov),callback:function ($$v) {_vm.$set(_vm.part, "tpentegov", $$v)},expression:"part.tpentegov"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.part.cliente == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codgrucli.validator),expression:"metadata.part.codgrucli.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.part.codgrucli,"name":"codgrucli","v-errors":_vm.errors,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluir('grucli')}},model:{value:(_vm.part.codgrucli),callback:function ($$v) {_vm.$set(_vm.part, "codgrucli", $$v)},expression:"part.codgrucli"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.part.cliente == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codramo.validator),expression:"metadata.part.codramo.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.part.codramo,"name":"codramo","v-errors":_vm.errors,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluir('ramoat')}},model:{value:(_vm.part.codramo),callback:function ($$v) {_vm.$set(_vm.part, "codramo", $$v)},expression:"part.codramo"}}):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"id":"addr"}},[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Endereço Principal"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.cep.validator),expression:"metadata.part.cep.validator"}],attrs:{"type":"cep","col":"2","metadata":_vm.metadata.part.cep,"name":"cep","id":"cep","v-errors":_vm.errors},on:{"update":_vm.updateCep},model:{value:(_vm.part.cep),callback:function ($$v) {_vm.$set(_vm.part, "cep", $$v)},expression:"part.cep"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.ende.validator),expression:"metadata.part.ende.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.part.ende,"name":"ende","v-errors":_vm.errors},model:{value:(_vm.part.ende),callback:function ($$v) {_vm.$set(_vm.part, "ende", $$v)},expression:"part.ende"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.endenr.validator),expression:"metadata.part.endenr.validator"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.part.endenr,"name":"endenr","id":"endenr","v-errors":_vm.errors},model:{value:(_vm.part.endenr),callback:function ($$v) {_vm.$set(_vm.part, "endenr", $$v)},expression:"part.endenr"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.endecomp.validator),expression:"metadata.part.endecomp.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.part.endecomp,"name":"endecomp","v-errors":_vm.errors},model:{value:(_vm.part.endecomp),callback:function ($$v) {_vm.$set(_vm.part, "endecomp", $$v)},expression:"part.endecomp"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.bairro.validator),expression:"metadata.part.bairro.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.part.bairro,"name":"bairro","v-errors":_vm.errors},model:{value:(_vm.part.bairro),callback:function ($$v) {_vm.$set(_vm.part, "bairro", $$v)},expression:"part.bairro"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.uf.validator),expression:"metadata.part.uf.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.part.uf,"name":"uf","v-errors":_vm.errors},model:{value:(_vm.part.uf),callback:function ($$v) {_vm.$set(_vm.part, "uf", $$v)},expression:"part.uf"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codmun.validator),expression:"metadata.part.codmun.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.part.codmun,"name":"codmun","v-errors":_vm.errors,"select2":{ entity: 'mun/uf/' + _vm.part.uf, minlength: 2 }},model:{value:(_vm.part.codmun),callback:function ($$v) {_vm.$set(_vm.part, "codmun", $$v)},expression:"part.codmun"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codpais.validator),expression:"metadata.part.codpais.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.part.codpais,"name":"codpais","v-errors":_vm.errors},model:{value:(_vm.part.codpais),callback:function ($$v) {_vm.$set(_vm.part, "codpais", $$v)},expression:"part.codpais"}})],1)],1),_vm._v(" "),(_vm.part.cliente == 'S')?_c('div',{attrs:{"id":"fiscal"}},[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Informações Para Faturamento"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codnatfinrec.validator),expression:"metadata.part.codnatfinrec.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.part.codnatfinrec,"name":"codnatfinrec","v-errors":_vm.errors},model:{value:(_vm.part.codnatfinrec),callback:function ($$v) {_vm.$set(_vm.part, "codnatfinrec", $$v)},expression:"part.codnatfinrec"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.emaildanfe.validator),expression:"metadata.part.emaildanfe.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.part.emaildanfe,"case":"lower","name":"emaildanfe","v-errors":_vm.errors},model:{value:(_vm.part.emaildanfe),callback:function ($$v) {_vm.$set(_vm.part, "emaildanfe", $$v)},expression:"part.emaildanfe"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.emailcobranca.validator),expression:"metadata.part.emailcobranca.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.part.emailcobranca,"case":"lower","name":"emailcobranca","v-errors":_vm.errors},model:{value:(_vm.part.emailcobranca),callback:function ($$v) {_vm.$set(_vm.part, "emailcobranca", $$v)},expression:"part.emailcobranca"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.calcst.validator),expression:"metadata.part.calcst.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.part.calcst,"name":"calcst","v-errors":_vm.errors},model:{value:(_vm.part.calcst),callback:function ($$v) {_vm.$set(_vm.part, "calcst", $$v)},expression:"part.calcst"}}),_vm._v(" "),(_vm.part.calcst == 'M')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.pcargamedia.validator),expression:"metadata.part.pcargamedia.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.part.pcargamedia,"name":"pcargamedia","v-errors":_vm.errors},model:{value:(_vm.part.pcargamedia),callback:function ($$v) {_vm.$set(_vm.part, "pcargamedia", $$v)},expression:"part.pcargamedia"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.stipipart.validator),expression:"metadata.part.stipipart.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.part.stipipart,"name":"stipipart","v-errors":_vm.errors},model:{value:(_vm.part.stipipart),callback:function ($$v) {_vm.$set(_vm.part, "stipipart", $$v)},expression:"part.stipipart"}}),_vm._v(" "),(_vm.part.stipipart == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.validadeipi.validator),expression:"metadata.part.validadeipi.validator"}],attrs:{"type":"date","col":"3","metadata":_vm.metadata.part.validadeipi,"name":"validadeipi","v-errors":_vm.errors},model:{value:(_vm.part.validadeipi),callback:function ($$v) {_vm.$set(_vm.part, "validadeipi", $$v)},expression:"part.validadeipi"}}):_vm._e(),_vm._v(" "),(_vm.part.stipipart == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.cenqipi.validator),expression:"metadata.part.cenqipi.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.part.cenqipi,"name":"cenqipi","v-errors":_vm.errors},model:{value:(_vm.part.cenqipi),callback:function ($$v) {_vm.$set(_vm.part, "cenqipi", $$v)},expression:"part.cenqipi"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.calcreten.validator),expression:"metadata.part.calcreten.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.part.calcreten,"name":"calcreten","v-errors":_vm.errors},model:{value:(_vm.part.calcreten),callback:function ($$v) {_vm.$set(_vm.part, "calcreten", $$v)},expression:"part.calcreten"}}),_vm._v(" "),(_vm.part.calcreten == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.pretcsll.validator),expression:"metadata.part.pretcsll.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.part.pretcsll,"name":"pretcsll","v-errors":_vm.errors},model:{value:(_vm.part.pretcsll),callback:function ($$v) {_vm.$set(_vm.part, "pretcsll", $$v)},expression:"part.pretcsll"}}):_vm._e(),_vm._v(" "),(_vm.part.calcreten == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.pretcofins.validator),expression:"metadata.part.pretcofins.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.part.pretcofins,"name":"pretcofins","v-errors":_vm.errors},model:{value:(_vm.part.pretcofins),callback:function ($$v) {_vm.$set(_vm.part, "pretcofins", $$v)},expression:"part.pretcofins"}}):_vm._e(),_vm._v(" "),(_vm.part.calcreten == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.pretpis.validator),expression:"metadata.part.pretpis.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.part.pretpis,"name":"pretpis","v-errors":_vm.errors},model:{value:(_vm.part.pretpis),callback:function ($$v) {_vm.$set(_vm.part, "pretpis", $$v)},expression:"part.pretpis"}}):_vm._e(),_vm._v(" "),(_vm.part.calcreten == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.pretinss.validator),expression:"metadata.part.pretinss.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.part.pretinss,"name":"pretinss","v-errors":_vm.errors},model:{value:(_vm.part.pretinss),callback:function ($$v) {_vm.$set(_vm.part, "pretinss", $$v)},expression:"part.pretinss"}}):_vm._e(),_vm._v(" "),(_vm.part.calcreten == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.pretirrf.validator),expression:"metadata.part.pretirrf.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.part.pretirrf,"name":"pretirrf","v-errors":_vm.errors},model:{value:(_vm.part.pretirrf),callback:function ($$v) {_vm.$set(_vm.part, "pretirrf", $$v)},expression:"part.pretirrf"}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"contacts"}},[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Contatos"}}),_vm._v(" "),_c('div',{staticClass:"row pl-3"},[(_vm.partcontato.length > 0)?_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.partcontato.nomecontato}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.partcontato.email}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.partcontato.fone1}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.partcontato.fone2}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.partcontato.fone3}})],1)]),_vm._v(" "),_vm._l((_vm.partcontato),function(cont,index){return _c('div',{key:index,staticClass:"row pl-3"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(cont.nomecontato),expression:"cont.nomecontato"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","name":"nomecontato","maxlenght":"60","disabled":_vm.isView},domProps:{"value":(cont.nomecontato)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.focusControl($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(cont, "nomecontato", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('div',{staticClass:"form-group"},[(_vm.type == 'email')?_c('input-email',{ref:"input",refInFor:true,staticClass:"form-control form-control-sm",attrs:{"tabindex":_vm.tabindex,"maxlength":"255","disabled":_vm.disabled,"value":_vm.value},on:{"update":_vm.updateEmail,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.focusControl($event)},"input":_vm.input}}):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(cont.email),expression:"cont.email"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","name":"email","maxlenght":"255","disabled":_vm.isView},domProps:{"value":(cont.email)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.focusControl($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(cont, "email", $event.target.value)}}}),_vm._v(" "),(!cont.email)?_c('small',{staticClass:"error"},[_vm._v(_vm._s("Campo obrigatório"))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('div',{staticClass:"form-group"},[_c('input-fone',{staticClass:"form-control form-control-sm",attrs:{"disabled":_vm.isView},model:{value:(cont.fone1),callback:function ($$v) {_vm.$set(cont, "fone1", $$v)},expression:"cont.fone1"}}),_vm._v(" "),(!cont.fone1)?_c('small',{staticClass:"error"},[_vm._v(_vm._s("Campo obrigatório"))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('div',{staticClass:"form-group"},[_c('input-fone',{staticClass:"form-control form-control-sm",attrs:{"disabled":_vm.isView},model:{value:(cont.fone2),callback:function ($$v) {_vm.$set(cont, "fone2", $$v)},expression:"cont.fone2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('div',{staticClass:"form-group"},[_c('input-fone',{staticClass:"form-control form-control-sm",attrs:{"disabled":_vm.isView},model:{value:(cont.fone3),callback:function ($$v) {_vm.$set(cont, "fone3", $$v)},expression:"cont.fone3"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-button',{attrs:{"label":"","title":"Excluir Contato","icon":"fa-trash","tabindex":1},on:{"click":function($event){return _vm.handleDeleteContact(index)}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"","nb-btdef":index + 1 == _vm.part.partcontatoseq,"tabindex":1,"title":"Contato Preferencial","icon":"fa-check"},on:{"click":function($event){return _vm.handlePrefContact(index)}}})],1)])}),_vm._v(" "),_c('div',{staticClass:"row pl-3"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"btn-group"},[_c('a',{staticClass:"btn btn-sm btn-outline-secondary",staticStyle:{"margin-right":"5px"},attrs:{"href":"javascript:void(0);","tabindex":1},on:{"click":function($event){return _vm.handleAddContact()}}},[_vm._v("Adicionar Contato")])])])]),_vm._v(" "),_c('br')],2),_vm._v(" "),(_vm.part.cliente == 'S')?_c('div',[(!_vm.showInfCredito)?_c('div',{staticClass:"mt-2 mb-2"},[_c('a',{attrs:{"href":"javascript:void(0);","tabindex":1},on:{"click":function($event){_vm.showInfCredito = true}}},[_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" Exibir\n            informações de crédito")])]):_vm._e(),_vm._v(" "),(_vm.showInfCredito)?_c('div',[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Informações de Crédito"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.stcred.validator),expression:"metadata.part.stcred.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.part.stcred,"name":"stcred","v-errors":_vm.errors},model:{value:(_vm.part.stcred),callback:function ($$v) {_vm.$set(_vm.part, "stcred", $$v)},expression:"part.stcred"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.limcred.validator),expression:"metadata.part.limcred.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.part.limcred,"name":"limcred","v-errors":_vm.errors},model:{value:(_vm.part.limcred),callback:function ($$v) {_vm.$set(_vm.part, "limcred", $$v)},expression:"part.limcred"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.maxdiasatraso.validator),expression:"metadata.part.maxdiasatraso.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.part.maxdiasatraso,"name":"maxdiasatraso","v-errors":_vm.errors},model:{value:(_vm.part.maxdiasatraso),callback:function ($$v) {_vm.$set(_vm.part, "maxdiasatraso", $$v)},expression:"part.maxdiasatraso"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.maxvlratraso.validator),expression:"metadata.part.maxvlratraso.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.part.maxvlratraso,"name":"maxvlratraso","v-errors":_vm.errors},model:{value:(_vm.part.maxvlratraso),callback:function ($$v) {_vm.$set(_vm.part, "maxvlratraso", $$v)},expression:"part.maxvlratraso"}})],1),_vm._v(" "),_c('div',{staticClass:"row"})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.part.forn == 'S' || _vm.part.transp == 'S')?_c('div',{attrs:{"id":"forn"}},[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Informações de Fornecedor/Transportadora"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codgrufor.validator),expression:"metadata.part.codgrufor.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.part.codgrufor,"name":"codgrufor","v-errors":_vm.errors,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluir('grufor')}},model:{value:(_vm.part.codgrufor),callback:function ($$v) {_vm.$set(_vm.part, "codgrufor", $$v)},expression:"part.codgrufor"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codnatfindes.validator),expression:"metadata.part.codnatfindes.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.part.codnatfindes,"name":"codnatfindes","v-errors":_vm.errors},model:{value:(_vm.part.codnatfindes),callback:function ($$v) {_vm.$set(_vm.part, "codnatfindes", $$v)},expression:"part.codnatfindes"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.contabanco.validator),expression:"metadata.part.contabanco.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.part.contabanco,"name":"contabanco","v-errors":_vm.errors},model:{value:(_vm.part.contabanco),callback:function ($$v) {_vm.$set(_vm.part, "contabanco", $$v)},expression:"part.contabanco"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.contaagencia.validator),expression:"metadata.part.contaagencia.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.part.contaagencia,"name":"contaagencia","v-errors":_vm.errors},model:{value:(_vm.part.contaagencia),callback:function ($$v) {_vm.$set(_vm.part, "contaagencia", $$v)},expression:"part.contaagencia"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.contacorrente.validator),expression:"metadata.part.contacorrente.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.part.contacorrente,"name":"contacorrente","v-errors":_vm.errors},model:{value:(_vm.part.contacorrente),callback:function ($$v) {_vm.$set(_vm.part, "contacorrente", $$v)},expression:"part.contacorrente"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.contanome.validator),expression:"metadata.part.contanome.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.part.contanome,"name":"contanome","v-errors":_vm.errors},model:{value:(_vm.part.contanome),callback:function ($$v) {_vm.$set(_vm.part, "contanome", $$v)},expression:"part.contanome"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.administrador)?_c('div',[(!_vm.showInfUsuario)?_c('div',{staticClass:"mt-2 mb-2"},[_c('a',{attrs:{"href":"javascript:void(0);","tabindex":1},on:{"click":function($event){_vm.showInfUsuario = true}}},[_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" Exibir\n            informações de usuário")])]):_vm._e(),_vm._v(" "),(_vm.showInfUsuario)?_c('div',[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Usuario vinculado ao cliente"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.codusuario.validator),expression:"metadata.part.codusuario.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.part.codusuario,"disabled":_vm.isView,"name":"codusuario","v-errors":_vm.errors},model:{value:(_vm.part.codusuario),callback:function ($$v) {_vm.$set(_vm.part, "codusuario", $$v)},expression:"part.codusuario"}})],1)],1):_vm._e()]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.showMessage)?_c('md-message',{attrs:{"code":_vm.codeMessage},on:{"close":function($event){return _vm.closeMessage()},"confirm":function($event){return _vm.handleConfirmMessage()}}}):_vm._e(),_vm._v(" "),(_vm.showRamoForm)?_c('div',{staticClass:"nb-modal-mask"},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('ramoat-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closeRamoForm}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.showVendForm)?_c('div',{staticClass:"nb-modal-mask"},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('vend-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closeVendForm}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.showGrucliForm)?_c('div',{staticClass:"nb-modal-mask"},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('grucli-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closeGrucliForm}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.showGruforForm)?_c('div',{staticClass:"nb-modal-mask"},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('grufor-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closeGruforForm}})],1)])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1190);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("17593f99", content, true, {});

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".icone-pedidos-detalhes{font-size:35px;position:absolute;padding:30px;color:#a7a9aa}", ""]);

// exports


/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Situação do Cliente"},on:{"closeform":_vm.closeForm}}),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"lbl-edit w-100"},[_vm._v("Nome Fantasia")]),_vm._v(" "),_c('label-title',{attrs:{"title":_vm.partPainel.fantasia}})],1),_vm._v(" "),(!_vm.modal)?_c('div',{staticClass:"col-md-6"},[_c('v-button',{staticClass:"float-right",attrs:{"label":"Alterar Cliente","icon":"fa-pencil","nb-btdef":true},on:{"click":_vm.handleEdit}}),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Incluir Nova Venda","icon":"fa-plus"},on:{"click":_vm.handleNovaVenda}})],1):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"nb-margin-top pl-5"},[_c('div',{staticClass:"row col"},[_c('div',{staticClass:"lbl w-100"},[_vm._v(_vm._s(_vm.partPainel.nome))]),_vm._v(" "),_c('div',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(_vm.partPainel.cnpjcpf)))]),_vm._v(" "),_c('i',{staticClass:"fa fa-location-arrow pr-2"}),_vm._v(" "),_c('div',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.partPainel.ende)+" "+_vm._s(_vm.partPainel.endenr)+" "+_vm._s(_vm.partPainel.endecomp))]),_vm._v(" "),_c('div',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm.partPainel.bairro)+" - "+_vm._s(_vm.partPainel.mun)+" - "+_vm._s(_vm.partPainel.uf))]),_vm._v(" "),_c('div',{staticClass:"data-list w-100"},[_vm._v("CEP "+_vm._s(_vm.partPainel.cep))])]),_vm._v(" "),(_vm.partPainel.contatos && _vm.partPainel.contatos.length > 0)?_c('div',{staticClass:"row col"},[_c('v-label',{staticClass:"w-100",attrs:{"label":"Contatos"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.partPainel.contatos),function(contato,index){return _c('div',{key:index,staticClass:"row col"},[(contato.nome)?_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"lbl"},[_c('i',{staticClass:"fa fa-user-circle pr-2"}),_vm._v(_vm._s(contato.nome))])]):_vm._e(),_vm._v(" "),(contato.fone1)?_c('div',{staticClass:"w-100"},[_c('i',{staticClass:"fa fa-phone pr-2"}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatFone")(contato.fone1)))])]):_vm._e(),_vm._v(" "),(contato.fone2)?_c('div',{staticClass:"w-100"},[_c('i',{staticClass:"fa fa-phone pr-2"}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatFone")(contato.fone2)))])]):_vm._e(),_vm._v(" "),(contato.fone3)?_c('div',{staticClass:"w-100"},[_c('i',{staticClass:"fa fa-phone pr-2"}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatFone")(contato.fone3)))])]):_vm._e(),_vm._v(" "),(contato.email)?_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"lbl"},[_c('i',{staticClass:"fa fa-envelope pr-2"}),_vm._v(" "+_vm._s(contato.email))])]):_vm._e()])})],2)]),_vm._v(" "),_c('div',{staticClass:"default-container nb-margin-top"},[_c('label-title',{attrs:{"title":"Situação do Cliente"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row pl-5"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"w-100",attrs:{"label":"Limite de Crédito"}}),_vm._v(" "),_c('div',{staticClass:"nb-dash-total w-100"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.partPainel.limcred,2)))]),_vm._v(" "),_c('v-label',{staticClass:"w-100",attrs:{"label":"Títulos Vencidos (-)"}}),_vm._v(" "),_c('div',{staticClass:"nb-dash-total w-100"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.partPainel.saldo_titulos_vencido,2)))]),_vm._v(" "),_c('v-label',{staticClass:"w-100",attrs:{"label":"Títulos à Vencer (-)"}}),_vm._v(" "),_c('div',{staticClass:"nb-dash-total w-100"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.partPainel.saldo_titulos_vencer,2)))]),_vm._v(" "),_c('v-label',{staticClass:"w-100",attrs:{"label":"Pedidos (-)"}}),_vm._v(" "),_c('div',{staticClass:"nb-dash-total w-100"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.partPainel.saldo_pedidos,2)))]),_vm._v(" "),_c('v-label',{staticClass:"w-100",attrs:{"label":"Crédito Disponível"}}),_vm._v(" "),_c('div',{staticClass:"nb-dash-total w-100"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.partPainel.saldo_limcred,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"w-100",attrs:{"label":"Última compra"}}),_vm._v(" "),(!_vm.partPainel.dias_ultima_compra)?_c('div',{staticClass:"nb-dash-total w-100"},[_vm._v("Nenhuma compra efetuada")]):_vm._e(),_vm._v(" "),(_vm.partPainel.dias_ultima_compra)?_c('div',{staticClass:"nb-dash-total w-100"},[_vm._v(_vm._s(_vm.partPainel.dias_ultima_compra)+" dias sem comprar ")]):_vm._e(),_vm._v(" "),_c('v-label',{staticClass:"w-100",attrs:{"label":"Valor em Compras"}}),_vm._v(" "),_c('div',{staticClass:"nb-dash-total w-100"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.partPainel.valor_comprado,2)))]),_vm._v(" "),_c('v-label',{staticClass:"w-100",attrs:{"label":"Ticket Médio"}}),_vm._v(" "),_c('div',{staticClass:"nb-dash-total w-100"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.partPainel.ticket_medio,2)))]),_vm._v(" "),_c('v-label',{staticClass:"w-100",attrs:{"label":"Valor em Orçamentos"}}),_vm._v(" "),_c('div',{staticClass:"nb-dash-total w-100"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.partPainel.valor_orçado,2)))])],1)])],1),_vm._v(" "),_c('div',{staticClass:"default-container nb-margin-top",staticStyle:{"max-height":"50%"}},[_c('label-title',{attrs:{"title":"Títulos Vencidos"}}),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.partPainel.fin_vencido || _vm.partPainel.fin_vencido.length == 0)?_c('div',{staticClass:"w-100 text-center lbl",staticStyle:{"padding":"60px"}},[_vm._v("Nenhum dado encontrado")]):_vm._e(),_vm._v(" "),_vm._l((_vm.partPainel.fin_vencido),function(fin,index){return _c('div',{key:index,staticClass:"row pl-5 nb-margin-bottom",staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"w-100",staticStyle:{"margin-right":"60px","border-bottom":"1px solid #e7e7e7"}},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"lbl"},[_c('i',{staticClass:"fa fa-file-text-o pr-2"}),_vm._v(" "+_vm._s(fin.doc))])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"lbl"},[_c('i',{staticClass:"fa fa-calendar pr-2"}),_vm._v(" "+_vm._s(_vm._f("formatData")(fin.dtv)))]),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(fin.dias)+" dia(s)")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"lbl"},[_c('i',{staticClass:"fa fa-dollar pr-2"}),_vm._v(" "+_vm._s(_vm._f("formatValue")(fin.vlr,2)))])])])])})],2),_vm._v(" "),_c('div',{staticClass:"default-container nb-margin-top"},[_c('label-title',{attrs:{"title":"Últimos Pedidos e Orçamentos"}}),_vm._v(" "),_c('div',{staticClass:"lbl-edit w-100"},[_vm._v("Últimos 6 meses")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.partPainel.pedidos.length == 0)?_c('div',{staticClass:"w-100 text-center lbl",staticStyle:{"padding":"60px"}},[_vm._v("Nenhum lançamento encontrado")]):_vm._e(),_vm._v(" "),_vm._l((_vm.partPainel.pedidos),function(pedido,index){return _c('div',{key:index,staticClass:"row nb-margin-bottom"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"w-100",staticStyle:{"margin-left":"90px","margin-right":"60px","border-bottom":"1px solid #e7e7e7"}},[(pedido.tppedv == 'P')?_c('div',{staticClass:"lbl-title-produto",on:{"click":_vm.handleShowPedido}},[_vm._v("Pedido "+_vm._s(pedido.npedido))]):_vm._e(),_vm._v(" "),(pedido.tppedv != 'P')?_c('div',{staticClass:"lbl-title-produto",on:{"click":_vm.handleShowPedido}},[_vm._v("Orçamento "+_vm._s(pedido.ncotacao))]):_vm._e(),_vm._v(" "),(pedido.stpedv=='F')?_c('span',{staticClass:"badge badge-blue float-right"},[_vm._v("Faturado")]):_vm._e(),_vm._v(" "),(pedido.stpedv=='C')?_c('span',{staticClass:"badge badge-red float-right"},[_vm._v("Cancelado")]):_vm._e(),_vm._v(" "),(pedido.tppedv!='P')?_c('span',{staticClass:"badge badge-yellow float-right"},[_vm._v("Orçamento")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-list w-100"},[_vm._v("Emitido em: "+_vm._s(_vm._f("formatData")(pedido.data)))]),_vm._v(" "),_c('div',{staticClass:"data-list w-100"},[_vm._v("Criado por: "+_vm._s(pedido.nome_usuario))]),_vm._v(" "),_c('div',{staticClass:"data-list"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(pedido.totger,2)))])])])})],2),_vm._v(" "),_c('div',{staticClass:"default-container nb-margin-top mb-3"},[_c('label-title',{attrs:{"title":"Produtos Comprados"}}),_vm._v(" "),_c('div',{staticClass:"lbl-edit w-100"},[_vm._v("Últimos 12 meses")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.partPainel.produtos.length == 0)?_c('div',{staticClass:"w-100 text-center lbl",staticStyle:{"padding":"60px"}},[_vm._v("Nenhum produto comprado")]):_vm._e(),_vm._v(" "),_vm._l((_vm.partPainel.produtos),function(produto,index){return _c('div',{key:index,staticClass:"row",staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"col-md-6 col-6"},[_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(produto.descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-3"},[_c('div',{staticClass:"lbl"},[_vm._v("Total R$ "+_vm._s(_vm._f("formatValue")(produto.totliq,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-3"},[_c('div',{staticClass:"lbl"},[_vm._v("Quantidade "+_vm._s(produto.qt))])])])})],2),_vm._v(" "),(_vm.showPartForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"800px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('customer-form',{attrs:{"crud":_vm.crud,"index":_vm.codpart,"pedidos":_vm.appForcaVendas},on:{"closeform":_vm.closePartForm}})],1)])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left"},[_c('i',{staticClass:"fa fa-file-text-o icone-pedidos-detalhes"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('div',{staticClass:"w-100",staticStyle:{"position":"relative","z-index":"1","background-color":"white"}},[(!_vm.addButton || _vm.disabled)?_c('v-label',{attrs:{"label":_vm.name}}):_vm._e(),_vm._v(" "),(_vm.addButton && !_vm.disabled)?_c('v-label',{attrs:{"label":_vm.name,"title-add-button":"Cadastrar"},on:{"clickAdd":function($event){return _vm.handleIncluirCliente()}}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isChoosing),expression:"!isChoosing"}]},[_c('div',{staticClass:"row col"},[_c('span',{staticClass:"lbl-title-produto",staticStyle:{"cursor":"pointer"},attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Ver situação do cliente"},on:{"click":_vm.handleSituacao}},[_vm._v("\n          "+_vm._s(_vm.selected.nome)+"\n        ")]),_vm._v(" "),(_vm.selected.codpart && !_vm.disabled)?_c('a',{staticClass:"mx-2",staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleAlterarCliente}},[_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true","data-toggle":"tooltip","data-placement":"top","title":"Alterar dados cadastrais"}})]):_vm._e(),_vm._v(" "),(_vm.selected.codpart)?_c('a',{staticClass:"mx-2",staticStyle:{"width":"25px","height":"25px","cursor":"pointer","color":"#0091ea","border":"1px solid #0091ea","border-radius":"50px","text-align":"center"},on:{"click":_vm.handleSituacao}},[_c('i',{staticClass:"fa fa-dollar",attrs:{"aria-hidden":"true","data-toggle":"tooltip","data-placement":"top","title":"Informações do Cliente"}})]):_vm._e(),_vm._v(" "),(!_vm.disabled)?_c('a',{staticClass:"mx-2",staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleTrocar}},[_c('i',{staticClass:"fa fa-exchange",attrs:{"aria-hidden":"true","data-toggle":"tooltip","data-placement":"top","title":"Trocar"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row col"},[(_vm.selected.cnpjcpf)?_c('span',{staticClass:"data-list mr-2"},[_vm._v("\n          "+_vm._s(_vm._f("formatCNPJCPF")(_vm.selected.cnpjcpf))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.selected.fantasia)?_c('span',{staticClass:"data-list mr-2"},[_vm._v("\n          "+_vm._s(_vm.selected.fantasia)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.selected.nomemun)?_c('span',{staticClass:"data-list"},[_c('i',{staticClass:"fa fa-location-arrow pr-2",attrs:{"aria-hidden":"true"}}),_vm._v("\n          "+_vm._s(_vm.selected.nomemun)+" - "+_vm._s(_vm.selected.uf))]):_vm._e()]),_vm._v(" "),(_vm.emailDanfe)?_c('div',{staticClass:"row col"},[_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(_vm.emailDanfe)+" ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row col"},[(_vm.saldoLimiteCredito)?_c('span',{staticClass:"lbl-edit"},[_vm._v("\n          Limite de Crédito Disponível\n        ")]):_vm._e(),_vm._v(" "),(_vm.saldoLimiteCredito)?_c('span',{staticClass:"data-list"},[_vm._v("\n          "+_vm._s(_vm._f("formatValue")(_vm.saldoLimiteCredito,2)))]):_vm._e()]),_vm._v(" "),(_vm.selectedContato)?_c('div',{staticClass:"row col"},[(_vm.selectedContato.nomecontato)?_c('span',{staticClass:"data-list pr-3"},[_c('i',{staticClass:"fa fa-user",attrs:{"aria-hidden":"true"}}),_vm._v("\n          "+_vm._s(_vm.selectedContato.nomecontato))]):_vm._e(),_vm._v(" "),(_vm.selectedContato.fone1)?_c('span',{staticClass:"data-list pr-3"},[_c('i',{staticClass:"fa fa-phone",attrs:{"aria-hidden":"true"}}),_vm._v("\n          "+_vm._s(_vm._f("formatFone")(_vm.selectedContato.fone1))+"\n          "),_c('i',{staticClass:"fa fa-whatsapp pl-2",staticStyle:{"color":"green","cursor":"pointer"},attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.handleWhatsapp(_vm.selectedContato.fone1)}}})]):_vm._e(),_vm._v(" "),(_vm.selectedContato.fone2)?_c('span',{staticClass:"data-list pr-3"},[_c('i',{staticClass:"fa fa-phone",attrs:{"aria-hidden":"true"}}),_vm._v("\n          "+_vm._s(_vm._f("formatFone")(_vm.selectedContato.fone2))+"\n          "),_c('i',{staticClass:"fa fa-whatsapp pl-2",staticStyle:{"color":"green","cursor":"pointer"},attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.handleWhatsapp(_vm.selectedContato.fone2)}}})]):_vm._e(),_vm._v(" "),(_vm.selectedContato.fone3)?_c('span',{staticClass:"data-list pr-3"},[_c('i',{staticClass:"fa fa-phone",attrs:{"aria-hidden":"true"}}),_vm._v("\n          "+_vm._s(_vm._f("formatFone")(_vm.selectedContato.fone3))+"\n          "),_c('i',{staticClass:"fa fa-whatsapp pl-2",staticStyle:{"color":"green","cursor":"pointer"},attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.handleWhatsapp(_vm.selectedContato.fone3)}}})]):_vm._e(),_vm._v(" "),(_vm.selectedContato.email)?_c('span',{staticClass:"data-list pr-3"},[_c('i',{staticClass:"fa fa-envelope",attrs:{"aria-hidden":"true"}}),_vm._v("\n          "+_vm._s(_vm.selectedContato.email))]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChoosing),expression:"isChoosing"}],staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.textSearch),expression:"textSearch"}],ref:"pesquisa",staticClass:"form-control form-control-sm",attrs:{"autocomplete":"off","id":"search","type":"text","placeholder":"Pesquisa o cliente pelo nome, nome fantasia ou CNPJ/CPF"},domProps:{"value":(_vm.textSearch)},on:{"blur":function($event){return _vm.handleBlur()},"change":function($event){return _vm.handleChange()},"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleEsc()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.handleKeyDown()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.handleKeyUp()}],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSelect()},"input":function($event){if($event.target.composing){ return; }_vm.textSearch=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"btn-group"},[(false)?_c('a',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"href":"javascript:void(0);","title":"Mais Filtros"},on:{"click":function($event){return _vm.search()}}},[_vm._v("...")]):_vm._e()]),_vm._v(" "),(_vm.name && _vm.vErrors && _vm.vErrors.has(_vm.name))?_c('small',{staticClass:"error w-100"},[_vm._v(_vm._s(_vm.vErrors.first(_vm.name)))]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"col-md-12 col-12"},[(_vm.notFound && !_vm.varejo)?_c('ul',{staticClass:"typeahead typeahead-dropdown col",staticStyle:{"display":"block"},style:(_vm.myDropDown)},[_c('li',[_c('div',[_c('span',{staticClass:"typeahead-data"},[_vm._v("Nenhum dado foi localizado")])])])]):_vm._e(),_vm._v(" "),(_vm.showList && _vm.clienteList.length > 0)?_c('ul',{staticClass:"typeahead typeahead-dropdown col",staticStyle:{"display":"block"},style:(_vm.myDropDown)},[_vm._l((_vm.clienteList),function(item,index){return _c('li',{key:index,class:{ active: index == _vm.selectedIndex },on:{"click":function($event){return _vm.handleSelect(index)}}},[_c('div',[_c('span',{staticClass:"typeahead-title"},[_c('small',[_vm._v(" "+_vm._s(item.nome)+" ")])]),_vm._v(" "),_c('span',{staticClass:"typeahead-data"},[_c('small',[_vm._v(" "+_vm._s(_vm._f("formatCNPJCPF")(item.cnpjcpf))+" ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('span',[_c('small',[_vm._v(" "+_vm._s(item.fantasia)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[(item.nomemun)?_c('span',[_c('small',[_c('i',{staticClass:"fa fa-location-arrow",attrs:{"aria-hidden":"true"}}),_vm._v("\n                          "+_vm._s(item.nomemun)+" "+_vm._s(item.uf)+"\n                        ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[(item.fone1)?_c('span',[_c('small',[_c('i',{staticClass:"fa fa-phone",attrs:{"aria-hidden":"true"}}),_vm._v("\n                          "+_vm._s(_vm._f("formatFone")(item.fone1))+"\n                          "+_vm._s(_vm._f("formatFone")(item.fone2))+"\n                          "+_vm._s(_vm._f("formatFone")(item.fone3))+"\n                        ")])]):_vm._e()])])])])}),_vm._v(" "),(_vm.nextPage > 0)?_c('li',{on:{"click":function($event){return _vm.handleMore()}}},[_c('div',[_c('span',{staticClass:"typeahead-title"},[_c('small',[_vm._v(" Exibir Mais ")])])])]):_vm._e()],2):_vm._e()])])],1)])],1),_vm._v(" "),(_vm.showSituacao && !_vm.varejo)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('Trap',[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('customer-painel-form',{attrs:{"modal":true,"params":{ codpart: _vm.selected.codpart, modal: true }},on:{"closeform":_vm.closeSituacaoForm}})],1)])])],1):_vm._e(),_vm._v(" "),(_vm.showPartForm && !_vm.varejo)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('Trap',[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('customer-form',{attrs:{"crud":_vm.crud,"index":_vm.codpart},on:{"sendData":_vm.handleSendData,"closeform":_vm.closePartForm}})],1)])])],1):_vm._e(),_vm._v(" "),(_vm.showPartForm && _vm.varejo)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('Trap',[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('customer-form',{attrs:{"crud":_vm.crud,"index":_vm.codpart,"varejo":true},on:{"closeform":_vm.closePartForm}})],1)])])],1):_vm._e(),_vm._v(" "),(_vm.showPartForcaVendas)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('Trap',[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"800px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('customer-form',{attrs:{"crud":_vm.crud,"index":_vm.codpart,"forcaVendas":true},on:{"closeform":_vm.closePartForm}})],1)])])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_item_vue__ = __webpack_require__(438);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_455b29e8_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_item_vue__ = __webpack_require__(1196);
function injectStyle (ssrContext) {
  __webpack_require__(1194)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-455b29e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_455b29e8_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1195);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1e3a75cc", content, true, {});

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "li[data-v-455b29e8]{line-height:20px}", ""]);

// exports


/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row nb-margin-bottom"},[_c('div',{staticStyle:{"position":"relative","width":"100%","z-index":"10","background-color":"white"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isChoosing),expression:"!isChoosing"}]},[_c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(" "+_vm._s(_vm.selected.descricao)+" ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" ("+_vm._s(_vm.selected.codigo)+")")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[(!_vm.disabled)?_c('v-button',{attrs:{"icon":"fa-exchange","label":"Trocar Produto","title":"Selecionar outro produto"},on:{"click":_vm.handleTrocar}}):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChoosing),expression:"isChoosing"}]},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.textSearch),expression:"textSearch"}],ref:"pesquisa",staticClass:"form-control",attrs:{"id":"search","type":"text","placeholder":"Informe a descrição ou código do produto"},domProps:{"value":(_vm.textSearch)},on:{"blur":function($event){return _vm.handleBlur()},"change":function($event){return _vm.handleChange()},"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleEsc()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSelectItem()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.handleKeyDown()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.handleKeyUp()}],"input":function($event){if($event.target.composing){ return; }_vm.textSearch=$event.target.value}}})]),_vm._v(" "),(_vm.addButton)?_c('v-label',{attrs:{"label":"","title-add-button":"Cadastrar Novo Produto"},on:{"clickAdd":_vm.handleNovoItem}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[(_vm.noList)?_c('ul',{staticClass:"typeahead typeahead-dropdown col",staticStyle:{"display":"block"}},[_c('li',{on:{"click":_vm.handleNovoItem}},[_c('span',{staticClass:"typeahead-data"},[_vm._v("Nenhum produto localizado. Clique aqui para incluir um novo.")])])]):_vm._e(),_vm._v(" "),(_vm.showList)?_c('ul',{staticClass:"typeahead typeahead-dropdown col",staticStyle:{"display":"block"}},[_vm._l((_vm.itemList),function(item,index){return _c('li',{key:index,class:{'active': index == _vm.selectedIndex},on:{"click":function($event){return _vm.handleSelectItem(index)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col-2"},[(item.url)?_c('img',{staticClass:"mx-auto d-block img-thumbnail",staticStyle:{"width":"45px","height":"45px"},attrs:{"src":item.url}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-8"},[_c('span',{staticClass:"typeahead-data"},[_c('strong',[_vm._v(_vm._s(item.descricao))]),_vm._v(" - "+_vm._s(item.codigo))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.exibePreco),expression:"exibePreco"}],staticClass:"col-md-3 col-4"},[_c('span',{staticClass:"typeahead-data"},[_vm._v("R$ "),_c('strong',[_vm._v(_vm._s(_vm._f("format")(item.vlrtab)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-3"})])])}),_vm._v(" "),(_vm.nextPage>0)?_c('li',{on:{"click":function($event){return _vm.handleMore()}}},[_vm._m(0)]):_vm._e()],2):_vm._e()])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"typeahead-title"},[_c('small',[_vm._v(" Exibir Mais ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1198);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a1554a4c", content, true, {});

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "li[data-v-f843eac4]{line-height:20px}", ""]);

// exports


/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100",staticStyle:{"position":"relative"}},[(_vm.label)?_c('v-label',{attrs:{"label":_vm.label}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.textSearch),expression:"textSearch"}],ref:"pesquisa",staticClass:"form-control form-control-sm",attrs:{"autocomplete":"off","type":"text","placeholder":_vm.placeholder},domProps:{"value":(_vm.textSearch)},on:{"blur":_vm.handleBlur,"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleEsc.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.handleKeyDown.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.handleKeyUp.apply(null, arguments)}],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.handleSelect()},"input":function($event){if($event.target.composing){ return; }_vm.textSearch=$event.target.value}}})]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showList)?_c('div',{staticClass:"col-md-12 col-12 p-0",staticStyle:{"position":"absolute","z-index":"1000","width":"100%"}},[_c('ul',{ref:"list",staticClass:"typeahead typeahead-dropdown col",staticStyle:{"display":"block","margin-top":"0","max-height":"300px","overflow-y":"auto"}},[(_vm.list.length === 0)?_c('li',[_c('div',[_c('span',{staticClass:"typeahead-data"},[_vm._v("Nenhum dado localizado")])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('li',{key:index,class:{ active: index === _vm.selectedIndex },staticStyle:{"cursor":"pointer"},on:{"mousedown":function($event){$event.preventDefault();return _vm.handleSelect(index)}}},[_c('div',[_c('span',{staticClass:"typeahead-title"},[_c('small',[_vm._v(_vm._s(item.value || item.descricao || item.nome))])]),_vm._v(" "),(item.id || item.codigo)?_c('span',{staticClass:"typeahead-data float-right"},[_c('small',[_vm._v(_vm._s(item.id || item.codigo))])]):_vm._e()])])}),_vm._v(" "),(_vm.has_more)?_c('li',{staticStyle:{"cursor":"pointer","text-align":"center","background-color":"#f8f9fa"},on:{"mousedown":function($event){$event.preventDefault();return _vm.handleMore()}}},[_c('div',[_c('span',{staticClass:"typeahead-title"},[_c('small',[_c('strong',[_vm._v("Exibir Mais")])])])])]):_vm._e()],2)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_date_vue__ = __webpack_require__(441);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f781877c_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_date_vue__ = __webpack_require__(1203);
function injectStyle (ssrContext) {
  __webpack_require__(1201)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f781877c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_date_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f781877c_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_date_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1202);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("57df3d1d", content, true, {});

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "input[data-v-f781877c]{width:100%}", ""]);

// exports


/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{ref:"data",attrs:{"value":_vm.lData,"config":_vm.options},on:{"input":function($event){return _vm.updateValue($event)},"keyup":function($event){}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_color_picker_vue__ = __webpack_require__(442);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_690e5a58_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_color_picker_vue__ = __webpack_require__(1207);
function injectStyle (ssrContext) {
  __webpack_require__(1205)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_input_color_picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_690e5a58_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_input_color_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1206);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("05864948", content, true, {});

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".vc-chrome{position:absolute;top:35px;right:0;z-index:9}.footer{margin-top:20px;text-align:center}", ""]);

// exports


/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"colorpicker",staticClass:"input-group input-group-sm color-picker"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.colorValue),expression:"colorValue"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.colorValue)},on:{"focus":function($event){return _vm.showPicker()},"input":[function($event){if($event.target.composing){ return; }_vm.colorValue=$event.target.value},_vm.updateFromInput]}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text color-picker-container"},[_c('span',{staticClass:"current-color",style:('background-color: ' + _vm.colorValue),on:{"click":function($event){return _vm.togglePicker()}}}),_vm._v(" "),(_vm.displayPicker)?_c('chrome',{attrs:{"value":_vm.colors},on:{"input":_vm.updateFromPicker}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tabs_vue__ = __webpack_require__(443);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2288192d_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tabs_vue__ = __webpack_require__(1211);
function injectStyle (ssrContext) {
  __webpack_require__(1209)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2288192d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2288192d_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1210);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5e182f7c", content, true, {});

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".icon-tab[data-v-2288192d]{font-size:20px}.counter[data-v-2288192d]{top:20px;right:5px}.nav-link-mobile.active[data-v-2288192d]{border-left:3px solid #1161bc;border-bottom:1px #e5e5e5!important}.nav-link-mobile[data-v-2288192d]{border-left:3px solid transparent;border-bottom:1px #e5e5e5!important}.nav-tabs[data-v-2288192d]{overflow-y:hidden}.animation-height[data-v-2288192d]{transition:all;transition-duration:.5s}.max-height[data-v-2288192d]{max-height:54px}.no-max-height[data-v-2288192d]{max-height:500px}", ""]);

// exports


/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[(_vm.isList)?_c('div',{staticClass:"w-100 d-none d-md-block default-container"},[_c('ul',{staticClass:"nav-tabs list-group"},_vm._l((_vm.tabs),function(tab,index){return (!tab.hidden)?_c('li',{key:index,staticClass:"nav-item text-center",attrs:{"data-toggle":"tooltip","data-placement":"top","title":tab.help}},[(!tab.title)?_c('a',{staticClass:"nav-link",class:{ active: _vm.activeTab === index },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.clickTab(index)}}},[(tab.icon)?_c('i',{staticClass:"icon-tab fa",class:tab.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(tab.count)?_c('span',{staticClass:"counter"},[_vm._v(" "+_vm._s(tab.count)+" ")]):_vm._e()]):_vm._e(),_vm._v(" "),(tab.title)?_c('a',{staticClass:"nav-link position-relative",class:{ active: _vm.activeTab === index },staticStyle:{"padding":"10px"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.clickTab(index)}}},[(tab.icon)?_c('i',{staticClass:"icon-tab fa",class:tab.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(tab.count)?_c('span',{staticClass:"counter position-absolute"},[_vm._v("\n            "+_vm._s(tab.count)+"\n          ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{style:(_vm.tabsTextStyle)},[_vm._v(" "+_vm._s(tab.title)+" ")])]):_vm._e()]):_vm._e()}),0)]):_c('div',{staticClass:"w-100 d-none d-md-block"},[_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.tabs),function(tab,index){return (!tab.hidden)?_c('li',{key:index,staticClass:"nav-item text-center",attrs:{"data-toggle":"tooltip","data-placement":"top","title":tab.help}},[(!tab.title)?_c('a',{staticClass:"nav-link",class:{ active: _vm.activeTab === index },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.clickTab(index)}}},[(tab.icon)?_c('i',{staticClass:"icon-tab fa",class:tab.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(tab.count)?_c('span',{staticClass:"counter"},[_vm._v(" "+_vm._s(tab.count)+" ")]):_vm._e()]):_vm._e(),_vm._v(" "),(tab.title)?_c('a',{staticClass:"nav-link position-relative",class:{ active: _vm.activeTab === index },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.clickTab(index)}}},[(tab.icon)?_c('i',{staticClass:"icon-tab fa",class:tab.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(tab.count)?_c('span',{staticClass:"counter position-absolute"},[_vm._v("\n            "+_vm._s(tab.count)+"\n          ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{style:(_vm.tabsTextStyle)},[_vm._v(" "+_vm._s(tab.title)+" ")])]):_vm._e()]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"w-100 d-block d-md-none"},[_c('ul',{staticClass:"nav-tabs p-0 w-100 animation-height",class:!_vm.showItems ? 'max-height' : 'no-max-height',staticStyle:{"list-style-type":"none"}},_vm._l((_vm.tabs),function(tab,index){return (!tab.hidden)?_c('li',{key:index,staticClass:"nav-item nav-link-mobile text-center d-flex w-100",attrs:{"data-toggle":"tooltip","data-placement":"top","title":tab.help}},[(!tab.title && _vm.activeTab === index)?_c('a',{staticClass:"nav-link nav-link-mobile w-100 d-flex align-items-center py-3",class:{ active: _vm.activeTab === index },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.clickTab(index)}}},[(tab.icon)?_c('i',{staticClass:"icon-tab fa col-2",class:tab.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(tab.count)?_c('span',{staticClass:"counter col-auto"},[_vm._v("\n            "+_vm._s(tab.count)+"\n          ")]):_vm._e(),_vm._v(" "),(tab.count)?_c('i',{staticClass:"counter col-auto fa fa-angle-down"},[_vm._v("\n            "+_vm._s(tab.count)+"\n          ")]):_vm._e()]):_vm._e(),_vm._v(" "),(tab.title && _vm.showItems)?_c('a',{staticClass:"nav-link nav-link-mobile position-relative w-100 d-flex align-items-center justify-content-start shaddow py-3 position-relative",class:{ active: _vm.activeTab === index },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.clickTab(index)}}},[(tab.icon)?_c('i',{staticClass:"col-2 icon-tab fa",class:tab.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(tab.count)?_c('span',{staticClass:"col-auto counter position-absolute"},[_vm._v("\n            "+_vm._s(tab.count)+"\n          ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{style:(_vm.tabsTextStyle)},[_vm._v(" "+_vm._s(tab.title)+" ")]),_vm._v(" "),(index == 0)?_c('i',{staticClass:"fa position-absolute right-0",class:_vm.showItems ? 'fa-angle-up' : 'fa-angle-down',staticStyle:{"right":"20px","font-size":"20px"},on:{"click":function($event){$event.stopPropagation();_vm.showItems = false}}},[_vm._v("\n            "+_vm._s(tab.count)+"\n          ")]):_vm._e()]):_vm._e(),_vm._v(" "),(tab.title && !_vm.showItems && _vm.activeTab === index)?_c('a',{staticClass:"nav-link nav-link-mobile position-relative w-100 d-flex align-items-center justify-content-start shaddow py-3 position-relative",class:{ active: _vm.activeTab === index },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.showItems = true}}},[(tab.icon)?_c('i',{staticClass:"col-2 icon-tab fa",class:tab.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(tab.count)?_c('span',{staticClass:"col-auto counter position-absolute"},[_vm._v("\n            "+_vm._s(tab.count)+"\n          ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{style:(_vm.tabsTextStyle)},[_vm._v(" "+_vm._s(tab.title)+" ")]),_vm._v(" "),_c('i',{staticClass:"fa position-absolute right-0",class:_vm.showItems ? 'fa-angle-up' : 'fa-angle-down',staticStyle:{"right":"20px","font-size":"20px"}},[_vm._v("\n            "+_vm._s(tab.count)+"\n          ")])]):_vm._e()]):_vm._e()}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_select2_vue__ = __webpack_require__(444);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_49617115_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_select2_vue__ = __webpack_require__(1217);
function injectStyle (ssrContext) {
  __webpack_require__(1213)
  __webpack_require__(1215)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49617115"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_select2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_49617115_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_select2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1214);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4ba6ef48", content, true, {});

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "select[data-v-49617115]{width:100%}", ""]);

// exports


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1216);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5dd3e4c6", content, true, {});

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".select2-result-part__fantasia{color:#555}.select2-result-part__info{color:#888}.select2-results__option--highlighted .select2-result-part__fantasia,.select2-results__option--highlighted .select2-result-part__info{color:#000!important}", ""]);

// exports


/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[(_vm.pesquisaItem)?_c('input-checkbox',{attrs:{"estilo":'text-info',"label":"Pesquisar por código","value-checked":true,"value-unchecked":false},model:{value:(_vm.only_id),callback:function ($$v) {_vm.only_id=$$v},expression:"only_id"}}):_vm._e(),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"tabindex":_vm.tabindex,"disabled":_vm.disabled,"placeholder":_vm.placeholder}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_select2static_vue__ = __webpack_require__(445);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_15bee7e7_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_select2static_vue__ = __webpack_require__(1221);
function injectStyle (ssrContext) {
  __webpack_require__(1219)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15bee7e7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_select2static_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_15bee7e7_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_select2static_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1220);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("49cbffe9", content, true, {});

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "select[data-v-15bee7e7]{width:100%}", ""]);

// exports


/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('select',{staticClass:"form-control",attrs:{"tabindex":_vm.tabindex,"disabled":_vm.disabled,"multiple":_vm.multiple}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1223);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7fa3a896", content, true, {});

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".ta-list[data-v-cfb955ec]{padding-top:5px;position:absolute;max-height:350px;overflow-y:auto;z-index:999;background-clip:border-box;background-color:#fff;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.typeahead__open[data-v-cfb955ec]{border:1px solid #41b883}.typeahead__open .typeahead__text[data-v-cfb955ec]{color:#999;opacity:.4}.typeahead__toggle[data-v-cfb955ec]{position:relative;z-index:1;width:100%}.typeahead__search[data-v-cfb955ec]{position:absolute;padding:5px;width:100%;display:block;cursor:text;background:transparent;z-index:2}.typeahead__text[data-v-cfb955ec]{min-height:30px;padding:5px;display:inline-block;position:relative;z-index:3}.typeahead__list[data-v-cfb955ec]{margin:0;padding:0;overflow-y:scroll;max-height:200px;position:absolute;z-index:999;overflow-y:auto;box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important;-webkit-box-direction:normal;-webkit-box-orient:vertical;background-clip:border-box;background-color:#fff;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.typeahead__item[data-v-cfb955ec]{display:block;border-top:1px solid #f4f4f4}.typeahead__link[data-v-cfb955ec]{display:block;padding:10px;line-height:1em;font-size:1em;cursor:pointer}.typeahead__active[data-v-cfb955ec]{background:blue;color:#fff}", ""]);

// exports


/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.typeaheadState},[_c('div',{ref:"toggle",staticClass:"typeahead__toggle",style:(_vm.fontSize),on:{"mousedown":function($event){$event.preventDefault();return _vm.toggle.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],ref:"search",staticClass:"form-control form-control-sm typeahead__search",staticStyle:{"text-transform":"uppercase"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.search)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onEscape.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.onDownKey.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.onUpKey.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnterKey.apply(null, arguments)}],"keyup":_vm.onChangeSearch,"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('span',{ref:"text",staticClass:"typeahead__text"},[_vm._v(_vm._s(_vm.displayText))])]),_vm._v(" "),(_vm.open)?_c('ul',{ref:"list",staticClass:"ta-list list-group shadow",style:(_vm.listWidth)},_vm._l((_vm.filteredOptions),function(option,index){return _c('li',{key:index,staticClass:"typeahead__item"},[_c('a',{staticClass:"typeahead__link",class:[_vm.selectIndex === index ? 'typeahead__active':''],on:{"mousedown":function($event){$event.preventDefault();return _vm.select(option)}}},[_vm._v("\n                "+_vm._s(option.text)+"\n            ")])])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_email_form_vue__ = __webpack_require__(447);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9715bb22_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_email_form_vue__ = __webpack_require__(1228);
function injectStyle (ssrContext) {
  __webpack_require__(1226)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_email_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9715bb22_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_email_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1227);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b5e5e056", content, true, {});

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-email-container{width:100%;max-width:680px}", ""]);

// exports


/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{staticClass:"nb-modal-scrollable",attrs:{"id":"mymodal"}},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_vm._l((_vm.emails),function(email,index){return _c('div',{key:index,staticClass:"row"},[(index===0)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 255, required: true, email: true }),expression:"{ max: 255, required: true, email: true }"}],ref:"sendto",refInFor:true,attrs:{"label":"Email","type":"email","col":"12","name":'email_' + index,"case":"lower","v-errors":_vm.errors},model:{value:(email.email),callback:function ($$v) {_vm.$set(email, "email", $$v)},expression:"email.email"}}):_vm._e(),_vm._v(" "),(index > 0)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 255, required: true, email: true }),expression:"{ max: 255, required: true, email: true }"}],attrs:{"type":"email","col":"12","name":'email_' + index,"case":"lower","v-errors":_vm.errors},model:{value:(email.email),callback:function ($$v) {_vm.$set(email, "email", $$v)},expression:"email.email"}},[_c('a',{attrs:{"href":"javascript:void(0);","data-toggle":"tooltip","data-placement":"top","title":_vm.title,"tabindex":1},on:{"click":function($event){return _vm.handleDeleteEmail(index)}}},[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}}),_vm._v(" Remover E-mail ")])]):_vm._e()],1)}),_vm._v(" "),_c('div',{staticClass:"row col nb-margin-bottom"},_vm._l((_vm.listEmails),function(email,index){return _c('div',{key:index},[(!email.selected)?_c('v-button',{attrs:{"icon":"fa-envelope-open","tabindex":1,"label":email.email,"title":""},on:{"click":function($event){return _vm.handleSelectEmail(index)}}}):_vm._e()],1)}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"text","col":"12","label":"Assunto","name":"subject","v-errors":_vm.errors},model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=$$v},expression:"subject"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"case":"normal","type":"memo","col":"12","label":"Texto do Email","name":"text","v-errors":_vm.errors},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{ref:"btnConfirm",attrs:{"label":"Enviar Email","title":"","nb-btdef":true},on:{"click":_vm.validaEmail}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeForm}})],1)],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fones_part_share_vue__ = __webpack_require__(448);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_30625a63_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fones_part_share_vue__ = __webpack_require__(1232);
function injectStyle (ssrContext) {
  __webpack_require__(1230)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fones_part_share_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_30625a63_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fones_part_share_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1231);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("c5b834ee", content, true, {});

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable",attrs:{"id":"mymodal"}},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container",staticStyle:{"max-width":"500px"}},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v("Selecione um contato para envio")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_vm._l((_vm.part.partcontato),function(contact,index){return (_vm.part.partcontato)?_c('div',{key:index,staticClass:"d-flex flex-column align-items-start justify-content-center"},[(contact.fone1)?_c('div',{staticClass:"d-flex mb-1",staticStyle:{"gap":"20px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.foneToSend),expression:"foneToSend"}],attrs:{"type":"radio","id":'customRadio_1'+index},domProps:{"value":contact.fone1,"checked":_vm._q(_vm.foneToSend,contact.fone1)},on:{"change":function($event){_vm.foneToSend=contact.fone1}}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('label',{staticClass:"lbl",staticStyle:{"line-height":"18px","font-size":"15px"},attrs:{"for":'customRadio_1'+index}},[_vm._v("Enviar para "+_vm._s(contact.nomecontato))]),_vm._v(" "),_c('label',{staticClass:"lbl",staticStyle:{"line-height":"18px","font-size":"15px","word-break":"break-all"},attrs:{"for":'customRadio_1'+index}},[_vm._v(_vm._s(_vm._f("formatFone")(contact.fone1)))])])]):_vm._e(),_vm._v(" "),(contact.fone2)?_c('div',{staticClass:"d-flex mb-1",staticStyle:{"gap":"20px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.foneToSend),expression:"foneToSend"}],attrs:{"type":"radio","id":'customRadio_2'+index},domProps:{"value":contact.fone2,"checked":_vm._q(_vm.foneToSend,contact.fone2)},on:{"change":function($event){_vm.foneToSend=contact.fone2}}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('label',{staticClass:"lbl",staticStyle:{"line-height":"18px","font-size":"15px"},attrs:{"for":'customRadio_2'+index}},[_vm._v("Enviar para "+_vm._s(contact.nomecontato))]),_vm._v(" "),_c('label',{staticClass:"lbl",staticStyle:{"line-height":"18px","font-size":"15px","word-break":"break-all"},attrs:{"for":'customRadio_2'+index}},[_vm._v(_vm._s(_vm._f("formatFone")(contact.fone2)))])])]):_vm._e(),_vm._v(" "),(contact.fone3)?_c('div',{staticClass:"d-flex mb-1",staticStyle:{"gap":"20px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.foneToSend),expression:"foneToSend"}],attrs:{"type":"radio","id":'customRadio_3'+index},domProps:{"value":contact.fone3,"checked":_vm._q(_vm.foneToSend,contact.fone3)},on:{"change":function($event){_vm.foneToSend=contact.fone3}}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('label',{staticClass:"lbl",staticStyle:{"line-height":"18px","font-size":"15px","word-break":"break-all"},attrs:{"for":'customRadio_3'+index}},[_vm._v(_vm._s(_vm._f("formatFone")(contact.fone3)))]),_vm._v(" "),_c('label',{staticClass:"lbl",staticStyle:{"line-height":"18px","font-size":"15px","word-break":"break-all"},attrs:{"for":'customRadio_3'+index}},[_vm._v(_vm._s(_vm._f("formatFone")(contact.fone3)))])])]):_vm._e()]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"d-flex mb-1 align-items-center",staticStyle:{"gap":"20px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.foneToSend),expression:"foneToSend"}],staticStyle:{"margin-bottom":"1rem"},attrs:{"type":"radio","id":"customRadio999"},domProps:{"value":4,"checked":_vm._q(_vm.foneToSend,4)},on:{"change":function($event){_vm.foneToSend=4}}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('label',{staticClass:"lbl",staticStyle:{"line-height":"18px","font-size":"15px","word-break":"break-all"},attrs:{"for":"customRadio999"}},[_vm._v("Outro Número")]),_vm._v(" "),_c('form-field',{attrs:{"type":"number"},model:{value:(_vm.newNumber),callback:function ($$v) {_vm.newNumber=$$v},expression:"newNumber"}})],1)]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{ref:"btnConfirm",attrs:{"label":"Enviar Mensagem","disabled":!_vm.foneToSend,"title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleConfirmar()}}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeModal}})],1)],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_adminpass_vue__ = __webpack_require__(449);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a29f209_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_confirm_adminpass_vue__ = __webpack_require__(1236);
function injectStyle (ssrContext) {
  __webpack_require__(1234)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_adminpass_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a29f209_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_confirm_adminpass_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1235);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1550d15d", content, true, {});

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1 !important"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeModal.apply(null, arguments)}}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-md",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body pt-3",staticStyle:{"max-height":"100%","overflow-y":"auto"}},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"close",on:{"click":_vm.handleCloseButton}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"modal-body",staticStyle:{"max-height":"255px","overflow-y":"auto"}},[_c('div',{staticClass:"row justify-content-center"},[_c('form-field',{ref:"senha",attrs:{"type":"password","col":"8","label":"Digite a senha de administrador"},on:{"key":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleConfirmButton()}},model:{value:(_vm.senha),callback:function ($$v) {_vm.senha=$$v},expression:"senha"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer",staticStyle:{"justify-content":"initial"}},[_c('button',{ref:"btnConfirm",staticClass:"btn btn-success btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleConfirmButton()}}},[_vm._v(" Confirmar ")]),_vm._v(" "),_c('button',{ref:"btnClose",staticClass:"btn btn-outline-secondary btn-sm",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.handleCloseButton()}}},[_vm._v(" Fechar ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lbl mb-2",staticStyle:{"font-size":"20px"}},[_c('strong',[_vm._v("Informe a senha de administrador")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_recuperar_form_vue__ = __webpack_require__(450);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b498df7_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_recuperar_form_vue__ = __webpack_require__(1240);
function injectStyle (ssrContext) {
  __webpack_require__(1238)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_recuperar_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b498df7_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_recuperar_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1239);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("52a15120", content, true, {});

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"login-row"},[_c('div',{staticClass:"login justify-content-center"},[_c('div',[_c('div',{staticClass:"row col justify-content-center"},[_c('a',{staticClass:"valign",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png"}})])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center",staticStyle:{"padding":"40px"}},[_c('h2',{staticClass:"title-principal"},[_vm._v("Recuperar Senha")])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"label":"E-mail"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"email",staticClass:"form-control",attrs:{"type":"text","placeholder":"exemplo@exemplo.com.br"},domProps:{"value":(_vm.email)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleEnviar.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-10 mb-2"},[_c('button',{staticClass:"login-button",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":_vm.handleEnviar}},[_vm._v(" Recuperar Senha ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10 text-center mt-2"},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.handleVoltar}},[_vm._v("\n                                Voltar\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10 mt-3"},[(_vm.errmessages)?_c('alert',{attrs:{"type":"warning","close":false,"title":"Erro","messages":_vm.errmessages}}):_vm._e()],1)])])]),_vm._v(" "),_c('div',{staticClass:"login-side-column"},[_c('div',{staticClass:"login-side-container login-side-container-bg-blue"},[_c('img',{staticClass:"login-side",attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/login.png","alt":"Aplicativo de"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_registro_form_vue__ = __webpack_require__(451);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7929720f_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_registro_form_vue__ = __webpack_require__(1245);
function injectStyle (ssrContext) {
  __webpack_require__(1242)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_registro_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7929720f_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_registro_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1243);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7d64cfd0", content, true, {});

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".shared-header{display:block;padding:15px 0;margin-top:15px}.shared-header .valign{line-height:30px;vertical-align:middle}.registro{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:#fff;display:block;transition:opacity .3s ease;overflow:auto}.activation,.activation h3{margin-top:64px}.activation h3{margin-bottom:32px;font-size:30.4px;font-weight:300;font-style:normal;font-stretch:normal;line-height:1.58;letter-spacing:-.5px;color:#222}.activation-button{border:2px solid #267da5!important;border-radius:.7rem;margin-top:50px;cursor:pointer;width:200px!important;height:45px!important;background-color:#267da5!important;color:#fff!important;font-size:15px!important}.title-principal{color:#222;font-size:36px;font-weight:800;letter-spacing:-1.13px;line-height:44px;margin:25px 0 0}.box-registro{margin:10px 0 100px;display:flex;width:472px;flex-direction:column;align-items:center;border-radius:15px;padding:15px;letter-spacing:-.15px;line-height:24px;transition:all .2s;box-shadow:0 15px 45px 0 rgba(82,95,127,.15)}.login-button{border:2px solid #267da5!important;border-radius:.7rem;cursor:pointer;height:45px!important;background-color:#267da5!important;color:#fff!important;font-size:15px!important}", ""]);

// exports


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var defer = function defer() {
  var state = false; // Resolved or not

  var callbacks = [];

  var resolve = function resolve(val) {
    if (state) {
      return;
    }

    state = true;

    for (var i = 0, len = callbacks.length; i < len; i++) {
      callbacks[i](val);
    }
  };

  var then = function then(cb) {
    if (!state) {
      callbacks.push(cb);
      return;
    }

    cb();
  };

  var deferred = {
    resolved: function resolved() {
      return state;
    },
    resolve: resolve,
    promise: {
      then: then
    }
  };
  return deferred;
};

var ownProp = Object.prototype.hasOwnProperty;
function createRecaptcha() {
  var deferred = defer();
  return {
    notify: function notify() {
      deferred.resolve();
    },
    wait: function wait() {
      return deferred.promise;
    },
    render: function render(ele, options, cb) {
      this.wait().then(function () {
        cb(window.grecaptcha.render(ele, options));
      });
    },
    reset: function reset(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.reset(widgetId);
      });
    },
    execute: function execute(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.execute(widgetId);
      });
    },
    checkRecaptchaLoad: function checkRecaptchaLoad() {
      if (ownProp.call(window, 'grecaptcha') && ownProp.call(window.grecaptcha, 'render')) {
        this.notify();
      }
    },
    assertLoaded: function assertLoaded() {
      if (!deferred.resolved()) {
        throw new Error('ReCAPTCHA has not been loaded');
      }
    }
  };
}
var recaptcha = createRecaptcha();

if (typeof window !== 'undefined') {
  window.vueRecaptchaApiLoaded = recaptcha.notify;
}

var VueRecaptcha = {
  name: 'VueRecaptcha',
  props: {
    sitekey: {
      type: String,
      required: true
    },
    theme: {
      type: String
    },
    badge: {
      type: String
    },
    type: {
      type: String
    },
    size: {
      type: String
    },
    tabindex: {
      type: String
    },
    loadRecaptchaScript: {
      type: Boolean,
      "default": false
    },
    recaptchaScriptId: {
      type: String,
      "default": '__RECAPTCHA_SCRIPT'
    },
    recaptchaHost: {
      type: String,
      "default": 'www.google.com'
    },
    language: {
      type: String,
      "default": ''
    }
  },
  beforeMount: function beforeMount() {
    if (this.loadRecaptchaScript) {
      if (!document.getElementById(this.recaptchaScriptId)) {
        // Note: vueRecaptchaApiLoaded load callback name is per the latest documentation
        var script = document.createElement('script');
        script.id = this.recaptchaScriptId;
        script.src = "https://" + this.recaptchaHost + "/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=" + this.language;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    recaptcha.checkRecaptchaLoad();

    var opts = _extends({}, this.$props, {
      callback: this.emitVerify,
      'expired-callback': this.emitExpired,
      'error-callback': this.emitError
    });

    var container = this.$slots["default"] ? this.$el.children[0] : this.$el;
    recaptcha.render(container, opts, function (id) {
      _this.$widgetId = id;

      _this.$emit('render', id);
    });
  },
  methods: {
    reset: function reset() {
      recaptcha.reset(this.$widgetId);
    },
    execute: function execute() {
      recaptcha.execute(this.$widgetId);
    },
    emitVerify: function emitVerify(response) {
      this.$emit('verify', response);
    },
    emitExpired: function emitExpired() {
      this.$emit('expired');
    },
    emitError: function emitError() {
      this.$emit('error');
    }
  },
  render: function render(h) {
    return h('div', {}, this.$slots["default"]);
  }
};

exports.default = VueRecaptcha;

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registro"},[_vm._m(0),_vm._v(" "),(_vm.estagio=='registro')?_c('div',[_c('div',{staticClass:"container"},[_c('div',[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"box-registro"},[_c('div',{staticClass:"row p-3"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, email: true}),expression:"{required: true, email: true}"}],ref:"email",attrs:{"metadata":_vm.metadata.registro.email,"type":"email","col":"12","name":"email_","v-errors":_vm.errors},model:{value:(_vm.registro.email),callback:function ($$v) {_vm.$set(_vm.registro, "email", $$v)},expression:"registro.email"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],ref:"nome",attrs:{"metadata":_vm.metadata.registro.nome,"type":"text","col":"12","name":"nome","v-errors":_vm.errors},model:{value:(_vm.registro.nome),callback:function ($$v) {_vm.$set(_vm.registro, "nome", $$v)},expression:"registro.nome"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],attrs:{"metadata":_vm.metadata.registro.nomeempresa,"type":"text","col":"12","name":"nomeempresa","v-errors":_vm.errors},model:{value:(_vm.registro.nomeempresa),callback:function ($$v) {_vm.$set(_vm.registro, "nomeempresa", $$v)},expression:"registro.nomeempresa"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, numeric: true, min: 10, max: 11}),expression:"{required: true, numeric: true, min: 10, max: 11}"}],attrs:{"metadata":_vm.metadata.registro.telefone,"type":"fone","col":"12","name":"telefone","v-errors":_vm.errors,"mask":""},model:{value:(_vm.registro.telefone),callback:function ($$v) {_vm.$set(_vm.registro, "telefone", $$v)},expression:"registro.telefone"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, min: 8}),expression:"{required: true, min: 8}"}],attrs:{"metadata":_vm.metadata.registro.senha,"type":"password","col":"12","name":"senha_","v-errors":_vm.errors},model:{value:(_vm.registro.senha),callback:function ($$v) {_vm.$set(_vm.registro, "senha", $$v)},expression:"registro.senha"}}),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-3",staticStyle:{"text-align":"center"}},[_c('div',{staticStyle:{"display":"inline-block"}},[_c('vue-recaptcha',{attrs:{"sitekey":"6LfSaFwaAAAAAE7xHvOUv8oMzqBgigvpLYNnj2Od","loadRecaptchaScript":true},on:{"verify":_vm.verifyRecaptcha,"expired":_vm.expiredRecaptcha}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-2"},[_c('span',{staticClass:"error"},[_vm._v(" "+_vm._s(_vm.errmessages)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"login-button",staticStyle:{"width":"100%"},attrs:{"type":"button","disabled":_vm.registrando},on:{"click":_vm.handleRegistrar}},[_vm._v(" "+_vm._s(_vm.botaoRegistrar)+" ")])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-center"},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.handleLogin()}}},[_vm._v("Retornar para o login")])])],1)])])])])]):_vm._e(),_vm._v(" "),(_vm.estagio == 'fim')?_c('div',[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"activation text-center"},[_c('h2',{staticClass:"title-principal"},[_vm._v("A conta foi criada com sucesso!")]),_vm._v(" "),_c('h3',[_vm._v("Em breve você receberá um e-mail para ativação da conta.")]),_vm._v(" "),_c('button',{staticClass:"activation-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleLogin()}}},[_vm._v("Ok")])])])],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"shared-header"},[_c('div',{staticClass:"col-md-12 col-12 text-center"},[_c('a',{staticClass:"valign",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center",staticStyle:{"padding":"40px"}},[_c('h2',{staticClass:"title-principal"},[_vm._v("Experimente o Nota Brasil")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center",staticStyle:{"padding-bottom":"40px"}},[_c('h6',[_vm._v("Informe-nos alguns dados para efetuar o cadastro:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit"},[_vm._v("\n                                        Clicando no botão acima você concorda com nossos "),_c('a',{attrs:{"href":"http://notabrasil.com.br/termos-de-uso/","target":"_blank"}},[_vm._v("termos")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_ativacao_form_vue__ = __webpack_require__(453);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b461c0e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_ativacao_form_vue__ = __webpack_require__(1249);
function injectStyle (ssrContext) {
  __webpack_require__(1247)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_ativacao_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b461c0e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_ativacao_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1248);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5f960855", content, true, {});

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".shared-header{display:block;padding:15px 0;margin-top:15px}.shared-header .valign{line-height:30px;vertical-align:middle}.activation,.activation h3{margin-top:64px}.activation h3{margin-bottom:32px;font-size:30.4px;font-weight:300;font-style:normal;font-stretch:normal;line-height:1.58;letter-spacing:-.5px;color:#222}.activation-button{border:2px solid #267da5!important;border-radius:.7rem;margin-top:50px;cursor:pointer;width:200px!important;height:45px!important;background-color:#267da5!important;color:#fff!important;font-size:15px!important}.title-principal{color:#222;font-size:36px;font-weight:800;letter-spacing:-1.13px;line-height:44px;margin:25px 0 0}.registro{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:#fff;display:block;transition:opacity .3s ease;overflow:auto}.login-button{border:2px solid #267da5!important;border-radius:.7rem;cursor:pointer;height:45px!important;background-color:#267da5!important;color:#fff!important;font-size:15px!important}.app{width:50%;margin:10px;display:flex;flex-direction:column;align-items:center;border:2px solid #e0e0e0;border-radius:15px;padding:15px;cursor:pointer;font-size:22px;letter-spacing:-.15px;line-height:24px;transition:all .2s}.active,.app:hover{border:3px solid #00cc62}.app .title{color:#222;margin-bottom:32px;font-size:22px;letter-spacing:-.15px;line-height:27px;display:flex;align-items:flex-end}.app .title,.app p{flex:1;transition:all .2s}.app p{color:#757575;font-family:Open Sans,sans-serif;letter-spacing:-.5px;font-size:14px;line-height:19px}", ""]);

// exports


/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registro"},[_vm._m(0),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.ativando)?_c('div',{staticClass:"activation text-center"},[_c('h2',{staticClass:"title-principal"},[_vm._v("Efetuando ativação...")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"activation text-center"},[(_vm.sucesso)?_c('h2',{staticClass:"title-principal"},[_vm._v("Sucesso!")]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v("Sua conta foi ativada. Você será redirecionado à tela de login.")]),_vm._v(" "),_c('button',{staticClass:"activation-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleLogin()}}},[_vm._v("Ok")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"shared-header"},[_c('div',{staticClass:"col-md-12 col-12 text-center"},[_c('a',{staticClass:"valign",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_senha_usuario_form_vue__ = __webpack_require__(454);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e149fe_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_senha_usuario_form_vue__ = __webpack_require__(1253);
function injectStyle (ssrContext) {
  __webpack_require__(1251)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_senha_usuario_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e149fe_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_senha_usuario_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1252);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4125b96c", content, true, {});

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".shared-header{display:block;padding:15px 0;margin-top:15px}.shared-header .valign{line-height:30px;vertical-align:middle}.activation,.activation h3{margin-top:64px}.activation h3{margin-bottom:32px;font-size:30.4px;font-weight:300;font-style:normal;font-stretch:normal;line-height:1.58;letter-spacing:-.5px;color:#222}.activation-button{border:2px solid #267da5!important;border-radius:.7rem;margin-top:50px;cursor:pointer;width:200px!important;height:45px!important;background-color:#267da5!important;color:#fff!important;font-size:15px!important}.title-principal{color:#222;font-size:36px;font-weight:800;letter-spacing:-1.13px;line-height:44px;margin:25px 0 0}.registro{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:#fff;display:block;transition:opacity .3s ease;overflow:auto}.login-button{border:2px solid #267da5!important;border-radius:.7rem;cursor:pointer;height:45px!important;background-color:#267da5!important;color:#fff!important;font-size:15px!important}.app{width:50%;margin:10px;display:flex;flex-direction:column;align-items:center;border:2px solid #e0e0e0;border-radius:15px;padding:15px;cursor:pointer;font-size:22px;letter-spacing:-.15px;line-height:24px;transition:all .2s}.active,.app:hover{border:3px solid #00cc62}.app .title{color:#222;margin-bottom:32px;font-size:22px;letter-spacing:-.15px;line-height:27px;display:flex;align-items:flex-end}.app .title,.app p{flex:1;transition:all .2s}.app p{color:#757575;font-family:Open Sans,sans-serif;letter-spacing:-.5px;font-size:14px;line-height:19px}", ""]);

// exports


/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registro"},[_vm._m(0),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showSenha)?_c('div',{staticClass:"activation text-center"},[_c('h2',{staticClass:"title-principal"},[_vm._v("Defina uma senha")]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center nb-margin-top"},[_c('div',{staticClass:"col-md-3 col-6 box-login"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"label":"Defina uma senha"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.senha),expression:"senha"}],ref:"senha",staticClass:"form-control",attrs:{"type":"password","placeholder":""},domProps:{"value":(_vm.senha)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleEnter('senha1')},"input":function($event){if($event.target.composing){ return; }_vm.senha=$event.target.value}}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"label":"Repita a Senha"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.senha2),expression:"senha2"}],ref:"senha2",staticClass:"form-control",attrs:{"type":"password","placeholder":""},domProps:{"value":(_vm.senha2)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleEnter('senha2')},"input":function($event){if($event.target.composing){ return; }_vm.senha2=$event.target.value}}})],1)])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[(_vm.errmessages)?_c('alert',{attrs:{"type":"warning","close":false,"title":_vm.errmessages}}):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('button',{staticClass:"login-button",staticStyle:{"width":"100%"},attrs:{"type":"button","disabled":_vm.logando},on:{"click":_vm.handleConfirmar}},[_vm._v("Confirmar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"activation text-center"},[(_vm.sucesso)?_c('h2',{staticClass:"title-principal"},[_vm._v("Sucesso!")]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v("Sua senha foi definida. Você será redirecionado à tela de login.")]),_vm._v(" "),_c('button',{staticClass:"activation-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleLogin()}}},[_vm._v("Ok")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"shared-header"},[_c('div',{staticClass:"col-md-12 col-12 text-center"},[_c('a',{staticClass:"valign",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_assinatura_form_vue__ = __webpack_require__(455);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a9f286_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_assinatura_form_vue__ = __webpack_require__(1257);
function injectStyle (ssrContext) {
  __webpack_require__(1255)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_assinatura_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a9f286_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_assinatura_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1256);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("27d1b9eb", content, true, {});

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".shared-header{display:block;padding:15px 0;margin-top:15px}.shared-header .valign{line-height:30px;vertical-align:middle}.activation{margin-top:64px}.activation h3{margin-bottom:32px;font-size:30.4px;margin-top:64px}.activation h3,.activation h5{font-weight:300;font-style:normal;font-stretch:normal;line-height:1.58;letter-spacing:-.5px;color:#222}.activation h5{margin-top:30px;margin-bottom:64px}.activation-button{border:2px solid #267da5!important;border-radius:.7rem;margin-top:50px;cursor:pointer;width:200px!important;height:45px!important;background-color:#267da5!important;color:#fff!important;font-size:15px!important}.registro{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:#fff;display:block;transition:opacity .3s ease;overflow:auto}.app-button{border:2px solid #ffe871!important;border-radius:.7rem;cursor:pointer;height:45px!important;background-color:#ffe871!important;color:#000!important;font-size:16px!important;font-weight:600}.app{margin:10px;display:flex;flex-direction:column;align-items:center;border:1px solid #d3d2d2;padding:15px;font-size:22px;letter-spacing:-.15px;line-height:24px;transition:all .2s;box-shadow:0 5px 15px 0 rgba(82,95,127,.15)}.app:hover{border:1px solid #22f387;cursor:pointer}.active{border:3px solid #22f387}.app .title{color:#222;font-size:22px;letter-spacing:-.15px;line-height:27px;display:flex;flex:1;transition:all .2s;margin:0;text-align:center}.app .margin{margin-bottom:32px}.app .info,.app .price-info{margin:30px 0 50px}.app p{color:#757575;font-family:Open Sans,sans-serif;font-size:16px;line-height:19px;flex:1}.price{color:#1cc925;font-size:36px;font-weight:700;line-height:normal}.title-price{display:inline-block;font-size:18px;color:#151414;text-align:center;font-weight:600}.app-info h5{margin:10px 0 20px;font-weight:300;line-height:1.58;letter-spacing:-.5px;color:#222}.title{color:#222;font-size:36px;font-weight:600;letter-spacing:-1.13px;line-height:44px;margin:90px 0 0}.box-clientes{margin:10px;display:flex;flex-direction:column;align-items:center;padding:15px}.box-clientes,.recursos-container{transition:all .2s;box-shadow:0 5px 15px 0 #3a405048}.recursos-container{margin-top:10px;border:1px solid #d3d2d2}.recursos-container th{padding:20px 30px 5px}.recursos-container td{padding:20px 30px;border:1px solid #f4f5f7}.recursos-container .feature-check{width:215px}.recursos-container .title{color:#222;font-size:18px;font-weight:400;margin:0}", ""]);

// exports


/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registro"},[_vm._m(0),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.selecionaApp)?_c('div',{staticClass:"container",staticStyle:{"margin-bottom":"100px"}},[(_vm.isEndTrial)?_c('div',[_c('div',{staticClass:"activation text-center mb-2"},[_c('h3',[_vm._v("Seu período de testes expirou!")])]),_vm._v(" "),_c('div',{staticClass:"activation text-center mb-2"},[_c('h3',[_vm._v("Selecione agora um plano para continuar a utilizar o Nota Brasil")])])]):_vm._e(),_vm._v(" "),(!_vm.isEndTrial && _vm.isPagamento)?_c('div',[_c('div',{staticClass:"activation text-center mb-2"},[_c('h3',[_vm._v("Selecione agora um plano para continuar a utilizar o Nota Brasil")])])]):_vm._e(),_vm._v(" "),(!_vm.isEndTrial && !_vm.isPagamento)?_c('div',[_c('div',{staticClass:"title text-center"},[_c('div',[_vm._v("Aplicativos Disponíveis")])]),_vm._v(" "),_c('div',{staticClass:"app-info text-center mb-2"},[_c('h5',[_vm._v("Selecione um dos aplicativos e teste grátis por 15 dias")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row activation justify-content-center"},[(_vm.showForcaVendas)?_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"app w-100 h-100",class:{ 'active': _vm.appSelected == 'FV' },on:{"click":function($event){return _vm.handleSelecionaApp('FV')}}},[_c('div',{staticClass:"title"},[_vm._v(" Força de Vendas ")]),_vm._v(" "),_c('div',{staticClass:"app-info w-100 text-center"},[_c('h5',[_vm._v(" Aplicativo para potencializar as vendas de Industrias, Atacadistas e Representantes ")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"app w-100 h-100",class:{ 'active': _vm.appSelected == 'LOJA' },on:{"click":function($event){return _vm.handleSelecionaApp('LOJA')}}},[_c('div',{staticClass:"title"},[_vm._v(" Loja Virtual ")]),_vm._v(" "),_c('div',{staticClass:"app-info w-100 text-center"},[_c('h5',[_vm._v(" Loja virtual para pequenos comércios e vendedores autônomos que queiram divulgar seus produtos nas\n                redes sociais e organizar as vendas de forma on-line")])])])]),_vm._v(" "),(_vm.showNFe)?_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"app w-100 h-100",class:{ 'active': _vm.appSelected == 'NFE' },on:{"click":function($event){return _vm.handleSelecionaApp('NFE')}}},[_c('div',{staticClass:"title"},[_vm._v(" Emissor de NF-e ")]),_vm._v(" "),_c('div',{staticClass:"app-info w-100 text-center"},[_c('h5',[_vm._v(" Aplicativo para emissão de NF-e de produtos e controle de pedidos com automação de regras de\n                impostos definidas pelo seu contador")])])])]):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"app w-100 h-100",class:{ 'active': _vm.appSelected == 'VAREJO' },on:{"click":function($event){return _vm.handleSelecionaApp('VAREJO')}}},[_c('div',{staticClass:"title"},[_vm._v(" Varejo On-Line ")]),_vm._v(" "),_c('div',{staticClass:"app-info w-100 text-center"},[_c('h5',[_vm._v(" Aplicativo de frente de caixa on-line ")])])])]):_vm._e()]),_vm._v(" "),(_vm.appSelected == 'FV')?_c('div',{attrs:{"id":"FV"}},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"w-100 title"},[_vm._v(" Planos Disponíveis ")])]),_vm._v(" "),_c('div',{staticClass:"activation"},[_c('div',{staticClass:"row"},_vm._l((_vm.planoFV),function(plano,index){return _c('div',{key:index,staticClass:"col-md-4 col-12 justify-content-center"},[_c('div',{staticClass:"app h-100"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"justify-content-center title"},[_vm._v(" "+_vm._s(plano.nome)+" ")]),_vm._v(" "),_c('div',{staticClass:"row price-info align-items-center text-center"},[_c('span',{staticClass:"w-100 text-price"},[_vm._v(" Consulte ")])]),_vm._v(" "),_c('div',{staticClass:"info"},_vm._l((plano.descricao),function(descricao,index){return _c('p',{key:index},[_vm._v(" "+_vm._s(descricao)+" ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center w-100"},[(!_vm.isPagamento)?_c('button',{staticClass:"app-button w-50",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleTestar(plano.app, plano.plano)}}},[_vm._v(" Testar ")]):_vm._e(),_vm._v(" "),(_vm.isPagamento)?_c('button',{staticClass:"app-button w-50",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleAssinar(plano.app, plano.plano)}}},[_vm._v(" Assinar ")]):_vm._e()])])])}),0),_vm._v(" "),_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"w-100 title"},[_vm._v(" Versões e Recursos ")])]),_vm._v(" "),_c('div',{staticClass:"recursos-container w-100 mt-5"},[_c('table',{staticClass:"w-100"},[_c('thead',[_c('tr',[_c('th',[_c('p',{staticClass:"title text-center"},[_vm._v("Descrição")])]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_c('p',{staticClass:"title text-center"},[_c('strong',[_vm._v("Básico")])])]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_c('p',{staticClass:"title text-center"},[_c('strong',[_vm._v("Intermediário")])])]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_c('p',{staticClass:"title text-center"},[_c('strong',[_vm._v("Completo")])])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.recursos_fv),function(recurso,index){return _c('tr',{key:index},[_c('td',[_vm._v("\n                    "+_vm._s(recurso.text)+"\n                    "),(recurso.novo)?_c('span',{staticClass:"badge badge-red ml-2"},[_vm._v(" NOVO ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(recurso.plano1)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"25px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(recurso.plano2)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"25px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(recurso.plano3)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"25px"},attrs:{"aria-hidden":"true"}}):_vm._e()])])}),0)])])])]):_vm._e(),_vm._v(" "),(_vm.appSelected == 'NFE')?_c('div',{attrs:{"id":"NFE"}},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"w-100 title"},[_vm._v(" Planos Disponíveis ")])]),_vm._v(" "),_c('div',{staticClass:"activation"},[_c('div',{staticClass:"row"},_vm._l((_vm.planoNFe),function(plano,index){return _c('div',{key:index,staticClass:"col-md-4 col-12 justify-content-center"},[_c('div',{staticClass:"app h-100"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"justify-content-center title"},[_vm._v(" "+_vm._s(plano.nome)+" ")]),_vm._v(" "),_c('div',{staticClass:"row price-info align-items-center text-center"},[_c('span',{staticClass:"w-100 text-price"},[_vm._v("\n                      R$\n                      "),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("formatValue")(plano.valor,2))+" ")])]),_vm._v(" "),_c('span',{staticClass:"w-100 text-price"},[_vm._v(" por mês/CNPJ ")])]),_vm._v(" "),_c('div',{staticClass:"info"},_vm._l((plano.descricao),function(descricao,index){return _c('p',{key:index},[_vm._v(" "+_vm._s(descricao)+" ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center w-100"},[(!_vm.isPagamento)?_c('button',{staticClass:"app-button w-50",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleTestar(plano.app, plano.plano)}}},[_vm._v(" Testar ")]):_vm._e(),_vm._v(" "),(_vm.isPagamento)?_c('button',{staticClass:"app-button w-50",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleAssinar(plano.app, plano.plano)}}},[_vm._v(" Assinar ")]):_vm._e()])])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.appSelected == 'LOJA')?_c('div',{attrs:{"id":"LOJA"}},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"w-100 title"},[_vm._v(" Loja Virtual ")])]),_vm._v(" "),_c('div',{staticClass:"app-info w-100 text-center"},[_c('h5',[_vm._v(" Loja virtual ")])]),_vm._v(" "),_c('div',{staticClass:"activation"},[_c('div',{staticClass:"row"},_vm._l((_vm.planoLoja),function(plano,index){return _c('div',{key:index,staticClass:"col-md-4 col-12 m-auto"},[_c('div',{staticClass:"app h-100"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"justify-content-center title"},[_vm._v(" "+_vm._s(plano.nome)+" ")]),_vm._v(" "),_c('div',{staticClass:"row price-info align-items-center text-center"},[_c('span',{staticClass:"w-100 text-price"},[_vm._v("\n                      R$\n                      "),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("formatValue")(plano.valor,2))+" ")])]),_vm._v(" "),_c('span',{staticClass:"w-100 text-price"},[_vm._v(" mensal/estabelecimento ")])]),_vm._v(" "),_c('div',{staticClass:"info"},_vm._l((plano.descricao),function(descricao,index){return _c('p',{key:index},[_vm._v(" "+_vm._s(descricao)+" ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center w-100"},[(!_vm.isPagamento)?_c('button',{staticClass:"app-button w-50",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleTestar(plano.app, plano.plano)}}},[_vm._v(" Testar ")]):_vm._e(),_vm._v(" "),(_vm.isPagamento)?_c('button',{staticClass:"app-button w-50",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleAssinar(plano.app, plano.plano)}}},[_vm._v(" Assinar ")]):_vm._e()])])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.appSelected == 'VAREJO')?_c('div',{attrs:{"id":"VAREJO"}},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"w-100 title"},[_vm._v(" Varejo On-Line ")])]),_vm._v(" "),_c('div',{staticClass:"app-info w-100 text-center"},[_c('h5',[_vm._v(" Aplicativo de frente de caixa on-line ")])]),_vm._v(" "),_c('div',{staticClass:"activation"},[_c('div',{staticClass:"row"},_vm._l((_vm.planoVarejo),function(plano,index){return _c('div',{key:index,staticClass:"col-md-4 col-12 justify-content-center"},[_c('div',{staticClass:"app h-100"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"justify-content-center title"},[_vm._v(" "+_vm._s(plano.nome)+" ")]),_vm._v(" "),_c('span',{staticClass:"badge badge-red"},[_vm._v(" Disponível em Janeiro/2020 ")]),_vm._v(" "),_c('div',{staticClass:"row price-info align-items-center text-center"},[_c('span',{staticClass:"w-100 text-price"},[_vm._v("\n                      R$\n                      "),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("formatValue")(plano.valor,2))+" ")])]),_vm._v(" "),_c('span',{staticClass:"w-100 text-price"},[_vm._v(" por mês/CNPJ ")])]),_vm._v(" "),_c('div',{staticClass:"info"},_vm._l((plano.descricao),function(descricao,index){return _c('p',{key:index},[_vm._v(" "+_vm._s(descricao)+" ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center w-100"})])])}),0)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"activation row justify-content-center text-center"},[_c('h3',[_vm._v(" Em caso de dúvidas, entre em contato com nosso atendimento via chat ou por telefone ")]),_vm._v(" "),_c('h5',[_vm._v(" Nossos planos incluem suporte via CHAT ou telefone de segunda à sexta das 08:30 às 17:30 ")])]),_vm._v(" "),_c('div',{staticClass:"box-clientes"},[_c('div',{staticClass:"row text-center p-5"},[_c('div',{staticClass:"title"},[_vm._v("\n            Junte-se a mais de 1.200 clientes que já utilizam nossas ferramentas\n          ")])]),_vm._v(" "),_c('div',{staticClass:"row text-center"})])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.sucesso)?_c('div',[_c('div',{staticClass:"activation text-center"},[_c('h2',{staticClass:"title"},[_vm._v("Sucesso!")]),_vm._v(" "),_c('h3',[_vm._v("Em breve processaremos seu pagamento e renovaremos sua assinatura.")])])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"shared-header"},[_c('div',{staticClass:"col-md-12 col-12 text-center"},[_c('a',{staticClass:"valign",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1259);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2af83a3b", content, true, {});

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_alert_asaas_vue__ = __webpack_require__(458);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b47d094_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_alert_asaas_vue__ = __webpack_require__(1261);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_alert_asaas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b47d094_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_alert_asaas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"col-12 d-flex justify-content-between shadow-sm",staticStyle:{"align-items":"center","margin":"10px 0px"}},[_c('div',{staticClass:"col-12 d-flex justify-content-center align-items-center shadow",staticStyle:{"background-color":"white"}},[_c('img',{attrs:{"src":"https://s3.us-east-1.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/banners/banner_nb_asaas.png","alt":"Comunicado novo meio de pagamento"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"default-container"},[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Dados do Plano","icon":""}}),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('div',[_c('v-label',{attrs:{"label":"Nome do Plano"}}),_c('br'),_vm._v(" "),(_vm.plano.app && _vm.plano.app.length)?_c('span',{staticClass:"lbl-deal-title"},[_vm._v("\n            "+_vm._s(_vm.plano.app[0].nome_plano)+"\n          ")]):_vm._e()],1),_vm._v(" "),_c('div',[_c('v-label',{attrs:{"label":"Complementos"}}),_c('br'),_vm._v(" "),_vm._l((_vm.plano.addons),function(addon,index){return [(_vm.plano.app && _vm.plano.app.length)?_c('span',{key:index,staticClass:"my-2 d-block"},[_vm._v("\n              "+_vm._s(addon.nome)+"\n            ")]):_vm._e()]})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-3"},[_c('v-label',{attrs:{"label":"Data de Validade"}}),_c('br'),_vm._v(" "),(_vm.plano.plano_atual)?_c('span',{staticClass:"lbl-data"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.plano.plano_atual.dttermino)))]):_vm._e()],1)]),_vm._v(" "),(_vm.fimPeriodoTeste)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('alert',{attrs:{"type":"info","title":"Seu Período de Testes Acabou!","text":"Ative agora seu plano para continuar a utilizar o Nota Brasil!"}})],1)]):_vm._e(),_vm._v(" "),(_vm.plano && _vm.plano.plano_atual && _vm.planoVencido)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('alert',{attrs:{"type":"warning","title":"Efetue o Pagamento","text":"Efetue o pagamento para continuar a utilizar!"}})],1)]):_vm._e(),_vm._v(" "),(_vm.administrador)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-button',{attrs:{"label":_vm.labelAssinar,"success":true},on:{"click":_vm.handleAtivar}}),_vm._v(" "),(!_vm.appNFe && !_vm.planoVencido && !_vm.istrial)?_c('v-button',{attrs:{"label":"Trocar Meu Plano","icon":"fa-exchange"},on:{"click":_vm.handleTrocarPlano}}):_vm._e(),_vm._v(" "),(!_vm.appNFe && !_vm.planoVencido && !_vm.istrial)?_c('v-button',{attrs:{"label":"Adicionar Complementos","icon":"fa-plus"},on:{"click":_vm.handleIncrementAddons}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('alert-asaas'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label-title',{staticClass:"mb-2 mt-3",attrs:{"title":"Recursos Utilizados","icon":""}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12"},_vm._l((_vm.plano.recursosUtilizados),function(recurso,index){return _c('div',{key:index,staticClass:"row col-12 align-items-center my-0"},[_c('v-label',{attrs:{"label":index}}),_vm._v(" "),_c('span',{staticClass:"lbl-deal-title ml-2",staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(recurso))])],1)}),0)]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.planoVencido)?_c('div',{staticClass:"mt-5 mb-5 row col justify-content-center"},[_c('iframe',{staticStyle:{"max-width":"800px"},attrs:{"width":"560","height":"315","src":"//www.youtube.com/embed/JSFoOrlI4yo","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})]):_vm._e(),_vm._v(" "),(!_vm.planoVencido)?_c('div',{staticClass:"mt-5 mb-5 row col justify-content-center"},[_c('iframe',{staticStyle:{"max-width":"800px"},attrs:{"width":"560","height":"315","src":"//www.youtube.com/embed/D_PE2O16_aI","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.administrador && _vm.plano.dadosFaturamento)?_c('label-title',{staticClass:"mb-2 mt-3",attrs:{"title":"Dados Para Nota Fiscal","icon":""}}):_vm._e(),_vm._v(" "),(_vm.administrador && _vm.plano.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, cnpj: true }),expression:"{ required: true, cnpj: true }"}],ref:"cnpj",attrs:{"type":"cnpj","col":"3","label":"CNPJ","name":"cnpj","v-errors":_vm.errors},model:{value:(_vm.plano.dadosFaturamento.cnpj),callback:function ($$v) {_vm.$set(_vm.plano.dadosFaturamento, "cnpj", $$v)},expression:"plano.dadosFaturamento.cnpj"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 60 }),expression:"{ required: true, max: 60 }"}],ref:"nome",attrs:{"type":"text","col":"6","label":"Nome","name":"nome","v-errors":_vm.errors},model:{value:(_vm.plano.dadosFaturamento.nome),callback:function ($$v) {_vm.$set(_vm.plano.dadosFaturamento, "nome", $$v)},expression:"plano.dadosFaturamento.nome"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"cep","col":"2","label":"Cep","name":"cep","v-errors":_vm.errors},on:{"update":_vm.updateCep},model:{value:(_vm.plano.dadosFaturamento.cep),callback:function ($$v) {_vm.$set(_vm.plano.dadosFaturamento, "cep", $$v)},expression:"plano.dadosFaturamento.cep"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 60 }),expression:"{ required: true, max: 60 }"}],attrs:{"type":"text","col":"4","label":"Endereço","name":"endereco","v-errors":_vm.errors},model:{value:(_vm.plano.dadosFaturamento.endereco),callback:function ($$v) {_vm.$set(_vm.plano.dadosFaturamento, "endereco", $$v)},expression:"plano.dadosFaturamento.endereco"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 20 }),expression:"{ required: true, max: 20 }"}],attrs:{"type":"text","col":"2","label":"Número","name":"nr","v-errors":_vm.errors},model:{value:(_vm.plano.dadosFaturamento.nr),callback:function ($$v) {_vm.$set(_vm.plano.dadosFaturamento, "nr", $$v)},expression:"plano.dadosFaturamento.nr"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 40 }),expression:"{ max: 40 }"}],attrs:{"type":"text","col":"4","label":"Complemento","name":"complemento","v-errors":_vm.errors},model:{value:(_vm.plano.dadosFaturamento.complemento),callback:function ($$v) {_vm.$set(_vm.plano.dadosFaturamento, "complemento", $$v)},expression:"plano.dadosFaturamento.complemento"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 60 }),expression:"{ required: true, max: 60 }"}],attrs:{"type":"text","col":"4","label":"Bairro","name":"bairro","v-errors":_vm.errors},model:{value:(_vm.plano.dadosFaturamento.bairro),callback:function ($$v) {_vm.$set(_vm.plano.dadosFaturamento, "bairro", $$v)},expression:"plano.dadosFaturamento.bairro"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"select2","col":"4","label":"Estado","name":"uf","v-errors":_vm.errors,"select2":{ entity: 'estado', minlength: 0 }},model:{value:(_vm.plano.dadosFaturamento.uf),callback:function ($$v) {_vm.$set(_vm.plano.dadosFaturamento, "uf", $$v)},expression:"plano.dadosFaturamento.uf"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"select2","col":"4","label":"Cidade","name":"codmun","v-errors":_vm.errors,"select2":{ entity: 'mun/uf/' + _vm.plano.dadosFaturamento.uf, minlength: 2 }},model:{value:(_vm.plano.dadosFaturamento.codmun),callback:function ($$v) {_vm.$set(_vm.plano.dadosFaturamento, "codmun", $$v)},expression:"plano.dadosFaturamento.codmun"}}),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSalvarDados}})],1)],1):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label-title',{staticClass:"mb-2 mt-3",attrs:{"title":"Histórico de Pagamentos","icon":""}}),_vm._v(" "),(_vm.plano.historico && _vm.plano.historico.length == 0)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.plano.historico),function(item,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3 text-center"},[_c('v-label',{attrs:{"label":"Data de Pagamento"}}),_vm._v(" "),_c('span',{staticClass:"lbl w-100"},[_vm._v(_vm._s(_vm._f("formatData")(item.data)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3 text-center"},[_c('v-label',{attrs:{"label":"Valor"}}),_vm._v(" "),_c('span',{staticClass:"lbl w-100"},[_c('small',[_vm._v("R$")]),_vm._v(" "+_vm._s(_vm._f("formatValue")(item.valor,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3 text-center"},[_c('v-label',{attrs:{"label":"Status"}}),_vm._v(" "),_c('span',{staticClass:"lbl w-100"},[_vm._v(_vm._s(item.status))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6 text-center"},[_c('v-label',{attrs:{"label":"Plano"}}),_vm._v(" "),_c('span',{staticClass:"lbl w-100"},[_vm._v(_vm._s(item.nome_plano))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6 text-center"},[_c('v-label',{attrs:{"label":"Forma de Pagamento"}}),_vm._v(" "),_c('span',{staticClass:"lbl w-100"},[_vm._v(_vm._s(item.formapagamento))])],1)])])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 col-12 text-center"},[_c('span',{staticClass:"lbl"},[_vm._v("Não há dados de pagamento")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_planos_nfe_vue__ = __webpack_require__(459);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_64971cd4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_planos_nfe_vue__ = __webpack_require__(1266);
function injectStyle (ssrContext) {
  __webpack_require__(1264)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_planos_nfe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_64971cd4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_planos_nfe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1265);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("387d945a", content, true, {});

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".shared-header{display:block;padding:15px 0;margin-top:15px}.shared-header .valign{line-height:30px;vertical-align:middle}.activation{margin-top:64px}.activation h3{margin-bottom:32px;font-size:30.4px;margin-top:64px}.activation h3,.activation h5{font-weight:300;font-style:normal;font-stretch:normal;line-height:1.58;letter-spacing:-.5px;color:#222}.activation h5{margin-top:30px;margin-bottom:64px}.activation-button{border:2px solid #267da5!important;border-radius:.7rem;margin-top:50px;cursor:pointer;width:200px!important;height:45px!important;background-color:#267da5!important;color:#fff!important;font-size:15px!important}.registro{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:#fff;display:block;transition:opacity .3s ease;overflow:auto}.app-button{border:2px solid #ffe871!important;border-radius:.7rem;cursor:pointer;height:45px!important;background-color:#ffe871!important;color:#000!important;font-size:16px!important;font-weight:600}.app{margin:10px;display:flex;flex-direction:column;align-items:center;border:1px solid #d3d2d2;padding:15px;font-size:22px;letter-spacing:-.15px;line-height:24px;transition:all .2s;box-shadow:0 5px 15px 0 rgba(82,95,127,.15)}.app:hover{border:1px solid #22f387;cursor:pointer}.active{border:3px solid #22f387}.app .title{color:#222;font-size:22px;letter-spacing:-.15px;line-height:27px;display:flex;flex:1;transition:all .2s;margin:0;text-align:center}.app .margin{margin-bottom:32px}.app .info,.app .price-info{margin:30px 0 50px}.app p{color:#757575;font-family:Open Sans,sans-serif;font-size:16px;line-height:19px;flex:1}.price{color:#1cc925;font-size:36px;font-weight:700;line-height:normal}.title-price{display:inline-block;font-size:18px;color:#151414;text-align:center;font-weight:600}.app-info h5{margin:10px 0 20px;font-weight:300;line-height:1.58;letter-spacing:-.5px;color:#222}.title{color:#222;font-size:36px;font-weight:600;letter-spacing:-1.13px;line-height:44px;margin:90px 0 0}.box-clientes{margin:10px;display:flex;flex-direction:column;align-items:center;padding:15px}.box-clientes,.recursos-container{transition:all .2s;box-shadow:0 5px 15px 0 #3a405048}.recursos-container{margin-top:10px;border:1px solid #d3d2d2}.recursos-container th{padding:20px 30px 5px}.recursos-container td{padding:20px 30px;border:1px solid #f4f5f7}.recursos-container .feature-check{width:215px}.recursos-container .title{color:#222;font-size:18px;font-weight:400;margin:0}.primary{background-color:#1cc925}.periodo-info{font-size:22px;letter-spacing:-.15px;line-height:24px}.periodo-text{color:#1cc925;font-weight:700;line-height:normal}", ""]);

// exports


/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registro"},[_vm._m(0),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.sucesso)?_c('div',{staticClass:"container",staticStyle:{"margin-bottom":"100px"}},[(_vm.isEndTrial)?_c('div',[_c('div',{staticClass:"activation text-center mb-2"},[_c('h3',[_vm._v("Seu período de testes expirou!")])]),_vm._v(" "),_c('div',{staticClass:"activation text-center mb-2"},[_c('h3',[_vm._v("Selecione agora um plano para continuar a utilizar o Nota Brasil")])])]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"NFE"}},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"w-100 title"},[_vm._v(" Planos Disponíveis ")])]),_vm._v(" "),_c('div',{staticClass:"activation"},[_c('div',{staticClass:"row justify-content-center"},_vm._l((_vm.planoNFe),function(plano,index){return _c('div',{key:index,staticClass:"col-md-4 col-12 justify-content-center"},[_c('div',{staticClass:"app h-100"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"justify-content-center title"},[_vm._v(" "+_vm._s(plano.nome)+" ")]),_vm._v(" "),_c('div',{staticClass:"row price-info align-items-center text-center"},[_c('span',{staticClass:"w-100"},[_vm._v("\n                      R$\n                      "),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("formatValue")(plano.valor,2))+" ")]),_vm._v("\n                      /mês\n                    ")]),_vm._v(" "),_c('span',{staticClass:"w-100 periodo-text"},[_vm._v(" "+_vm._s(plano.total_text)+" ")])]),_vm._v(" "),_c('div',{staticClass:"info"},_vm._l((plano.descricao),function(descricao,index){return _c('p',{key:index},[_vm._v(" "+_vm._s(descricao)+" ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-12"},[_c('warnings',{staticClass:"text-center",attrs:{"messages":['Este plano foi reajustado pela inflação acumulada dos últimos 48 meses.']}})],1)]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center w-100"},[_c('button',{staticClass:"app-button w-50",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleAssinar(plano.app, plano.plano)}}},[_vm._v("\n                    Assinar ")])])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"activation row justify-content-center text-center"},[_c('h3',[_vm._v(" Em caso de dúvidas, entre em contato com nosso atendimento via chat ")]),_vm._v(" "),_c('h5',[_vm._v(" Nossos planos incluem suporte via CHAT de segunda à sexta das 08:30 às 17:30 ")])]),_vm._v(" "),_c('div',{staticClass:"container-dados-faturamento"},[_c('h3',[_vm._v("Informe seus dados para nota fiscal")]),_vm._v(" "),_c('div',{staticClass:"default-container mt-4"},[_c('div',{staticClass:"my-3"},[_c('label',{staticClass:"lbl-edit pb-1",attrs:{"for":""}},[_vm._v("Tipo de Pessoa")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dadosFaturamento.tppessoa),expression:"dadosFaturamento.tppessoa"}],attrs:{"type":"radio","name":"tppessoa","id":"","value":"F"},domProps:{"checked":_vm._q(_vm.dadosFaturamento.tppessoa,"F")},on:{"change":function($event){return _vm.$set(_vm.dadosFaturamento, "tppessoa", "F")}}}),_vm._v(" "),_c('label',{staticClass:"lbl",attrs:{"for":""}},[_vm._v("Pessoa Fisica")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dadosFaturamento.tppessoa),expression:"dadosFaturamento.tppessoa"}],attrs:{"type":"radio","name":"tppessoa","id":"","value":"J"},domProps:{"checked":_vm._q(_vm.dadosFaturamento.tppessoa,"J")},on:{"change":function($event){return _vm.$set(_vm.dadosFaturamento, "tppessoa", "J")}}}),_vm._v(" "),_c('label',{staticClass:"lbl",attrs:{"for":""}},[_vm._v("Pesso Juridica")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 60, cpf: false }),expression:"{ required: true, max: 60, cpf: false }"}],ref:"nome",attrs:{"type":"text","col":"6","label":"Nome","name":"nome","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.nome),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "nome", $$v)},expression:"dadosFaturamento.nome"}})],1),_vm._v(" "),(_vm.dadosFaturamento.tppessoa == 'J')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ cnpj: true, cpf: false }),expression:"{ cnpj: true, cpf: false }"}],ref:"cnpj",attrs:{"type":"cnpj","col":"3","label":"CNPJ","name":"cnpj","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.cnpj),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "cnpj", $$v)},expression:"dadosFaturamento.cnpj"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento.tppessoa == 'F')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ cpf: true, cnpj: false }),expression:"{ cpf: true, cnpj: false }"}],ref:"cpf",attrs:{"type":"number","col":"3","label":"CPF","name":"cpf","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.cpf),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "cpf", $$v)},expression:"dadosFaturamento.cpf"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"cep","col":"3","label":"Cep","name":"cep","v-errors":_vm.errors},on:{"update":_vm.updateCep},model:{value:(_vm.dadosFaturamento.cep),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "cep", $$v)},expression:"dadosFaturamento.cep"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 60 }),expression:"{ required: true, max: 60 }"}],attrs:{"type":"text","col":"4","label":"Endereço","name":"ende","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.endereco),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "endereco", $$v)},expression:"dadosFaturamento.endereco"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 20 }),expression:"{ required: true, max: 20 }"}],attrs:{"type":"text","col":"2","label":"Número","name":"endenr","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.nr),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "nr", $$v)},expression:"dadosFaturamento.nr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 40 }),expression:"{ max: 40 }"}],attrs:{"type":"text","col":"4","label":"Complemento","name":"endecomp","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.complemento),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "complemento", $$v)},expression:"dadosFaturamento.complemento"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 60 }),expression:"{ required: true, max: 60 }"}],attrs:{"type":"text","col":"4","label":"Bairro","name":"bairro","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.bairro),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "bairro", $$v)},expression:"dadosFaturamento.bairro"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"select2","col":"4","label":"Estado","name":"uf","v-errors":_vm.errors,"select2":{ entity: 'estado', minlength: 0 }},model:{value:(_vm.dadosFaturamento.uf),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "uf", $$v)},expression:"dadosFaturamento.uf"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"select2","col":"4","label":"Cidade","name":"codmun","v-errors":_vm.errors,"select2":{ entity: 'mun/uf/' + _vm.dadosFaturamento.uf, minlength: 2 }},model:{value:(_vm.dadosFaturamento.codmun),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "codmun", $$v)},expression:"dadosFaturamento.codmun"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 15, required: true }),expression:"{ max: 15, required: true }"}],attrs:{"type":"fone","col":"4","label":"Telefone","name":"fone","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.fone),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "fone", $$v)},expression:"dadosFaturamento.fone"}})],1):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.sucesso)?_c('div',[_c('div',{staticClass:"activation text-center"},[_c('h2',{staticClass:"title"},[_vm._v("Sucesso!")]),_vm._v(" "),_c('h3',[_vm._v("Estamos aguardando a confirmação do seu pagamento.")])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center w-100"},[_c('button',{staticClass:"app-button",attrs:{"type":"button"},on:{"click":_vm.handleInicio}},[_vm._v(" Retornar ao Nota Brasil ")])])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"shared-header"},[_c('div',{staticClass:"col-md-12 col-12 text-center"},[_c('a',{staticClass:"valign",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_planos_erp_vue__ = __webpack_require__(460);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7026068b_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_planos_erp_vue__ = __webpack_require__(1274);
function injectStyle (ssrContext) {
  __webpack_require__(1268)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7026068b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_planos_erp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7026068b_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_planos_erp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1269);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("70badb96", content, true, {});

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".component-addons[data-v-7026068b]{transition:all .5s ease}@keyframes changeOpacity-data-v-7026068b{0%{opacity:0}40%{opacity:1%}to{opacity:1%}}.easeShow-enter-actiejove[data-v-7026068b]{animation:changeOpacity-data-v-7026068b .2s ease}.easeShow-leave-active[data-v-7026068b]{animation:changeOpacity-data-v-7026068b .2s reverse}.default-container[data-v-7026068b]{padding-bottom:9rem}.line-through[data-v-7026068b]{text-decoration:line-through}.container-info[data-v-7026068b]{display:flex;text-align:right;align-self:center;margin-left:5px;justify-content:center;z-index:50}.container-bagde[data-v-7026068b]{width:80%;margin:0 auto;display:flex;justify-content:start;max-width:720px;margin-top:50px}.container-dados-faturamento[data-v-7026068b]{width:80%;margin:50px auto;padding:10px 20px;max-width:1260px}.connection[data-v-7026068b]{border:4px solid #0f3e76;width:100%;height:10px;padding:5px 0;margin-left:-5px;z-index:0}.steps[data-v-7026068b]{width:80%;margin:0 auto;margin-top:50px;margin-bottom:80px}.steps-fluxo[data-v-7026068b]{display:flex;width:80%;margin:0 auto;max-width:650px;justify-content:space-between;align-items:center}.steps-texts[data-v-7026068b]{display:flex;justify-content:center;gap:9%;margin-top:15px;font-weight:700;font-size:15px}.steps-fluxo .item[data-v-7026068b]{border:2px solid #0f3e76;border-width:8px;padding:5px 12px;border-radius:50%;background:#fff;color:#0f3e76;font-size:1.1rem;font-weight:700;z-index:1;margin-left:-5px}.steps-fluxo .item.active[data-v-7026068b]{background:#0f3e76;color:#fff;border-left-color:#0f3e76}.line[data-v-7026068b]{border:1px solid hsla(0,0%,50%,.603)}.footer[data-v-7026068b]{background-color:#fff;z-index:99999;overflow-x:hidden;max-height:100px}.footer .footer-container[data-v-7026068b]{display:flex;justify-content:space-between;width:90%;margin:0 auto}.shadow-warning[data-v-7026068b]{box-shadow:0 .5rem 1rem #ffc107!important}.border-warning[data-v-7026068b]{border:5px solid #ffc107!important;transform:scale(1.05)!important;z-index:100!important;padding:20px 15px!important}.badge-credit[data-v-7026068b]{padding:10px 20px;min-width:100px;text-align:left;width:250px;font-weight:700;font-size:.8rem;color:#fff;border:1px solid transparent;background-color:#0f3e76;border-radius:20px}.text-stripe .stripe-content[data-v-7026068b]{text-decoration:line-through;opacity:1%}.fita[data-v-7026068b]{background:#e51c46;position:relative;margin:10px auto;right:0;width:140px;color:#fff;line-height:40px;height:40px;font-size:18px;text-align:center;font-weight:700;text-transform:uppercase}.fita[data-v-7026068b]:after,.fita[data-v-7026068b]:before{content:\"\";line-height:0;border-style:solid;border-width:14px;position:absolute;top:22px;z-index:-2000;width:8px}.fita[data-v-7026068b]:before{border-color:#bc1438 #bc1438 #bc1438 transparent;left:-17px}.fita[data-v-7026068b]:after{border-color:#bc1438 transparent #bc1438 #bc1438;right:-17px}.conteudo[data-v-7026068b]:after,.conteudo[data-v-7026068b]:before{position:absolute;content:\"\";height:0;line-height:1px;border-style:solid;border-width:5px;z-index:-1999}.conteudo[data-v-7026068b]:before{border-color:#940d2a #940d2a transparent transparent;bottom:-10px;left:0}.conteudo[data-v-7026068b]:after{border-color:#940d2a transparent transparent #940d2a;bottom:-10px;right:0}.plan-disabled[data-v-7026068b]{background:rgba(83,83,83,.425)!important;opacity:1%;cursor:not-allowed!important}.plan-disabled[data-v-7026068b]:hover{transform:scale(1)!important;cursor:not-allowed!important}.container-planos-preco[data-v-7026068b]{z-index:90;display:flex;justify-content:center;align-items:stretch;margin-top:2rem}.card-plano-preco[data-v-7026068b]{z-index:90;transition:transform .3s;position:relative;display:flex;flex-direction:column;justify-content:flex-start;padding:20px 0;padding-left:1.5rem;padding-right:1rem;width:280px;min-height:580px;height:100%;cursor:pointer;border:2px solid #ced1d5;transform:scale(1);background:#fff}.card-plano-preco[data-v-7026068b]:hover{transform:scale(1.05);z-index:9999}.container-planos-preco #first[data-v-7026068b]{border-top-left-radius:16px;border-bottom-left-radius:16px}.container-planos-preco #last[data-v-7026068b]{border-top-right-radius:16px;border-bottom-right-radius:16px}.card-plano-preco-destaque[data-v-7026068b]{transition:transform .3s;display:flex;flex-direction:column;justify-content:flex-start;width:253.33px;min-height:580px;height:100%;position:relative;padding-left:1.25rem;padding-right:.5rem;margin-top:1.25rem;border:6px solid #acd22d;border-radius:16px;transform:scale(1);cursor:pointer}.card-plano-preco-destaque[data-v-7026068b]:hover{transform:scale(1.05)}.card-plano-preco-destaque:hover~.button-green[data-v-7026068b]{border-color:#acd22d!important;background-color:#fff!important;color:#acd22d!important}.card-plano-preco-destaque div strong[data-v-7026068b],.card-plano-preco div strong[data-v-7026068b]{font-weight:700;font-size:1.7rem;line-height:130%;color:#0f3e76}.card-plano-preco-destaque div small[data-v-7026068b],.card-plano-preco div small[data-v-7026068b]{padding-left:.5rem;font-weight:500;font-size:.75rem;color:#0f3e76;line-height:130%}.card-plano-preco-destaque div span[data-v-7026068b],.card-plano-preco div span[data-v-7026068b]{font-weight:800;font-size:.813rem;line-height:none;color:#0f3e76}ul[data-v-7026068b]{padding-inline-start:0}ul li[data-v-7026068b]{list-style:none;display:flex;align-items:center;margin-bottom:3px}.card-plano-preco-destaque ul li span[data-v-7026068b],.card-plano-preco ul li span[data-v-7026068b]{font-size:13px;color:#0f3e76;line-height:130%;font-weight:600}.card-plano-preco-destaque ul li span[data-v-7026068b]{font-weight:600;font-size:14px;color:#0f3e76;line-height:130%}.card-plano-preco-destaque ul[data-v-7026068b],.card-plano-preco ul[data-v-7026068b]{margin:10px 0}.badge-recomendado[data-v-7026068b]{position:absolute;top:-30px;align-self:center;margin-right:.5rem;padding:.5rem 1.75rem;border:1px solid transparent;border-radius:40px;color:#fff;background:#ffc824;cursor:pointer}.recorrencias-switch-toggle[data-v-7026068b]{background-color:#0f3e76;width:90%;max-width:660px;border-radius:100px;position:relative;display:flex;justify-content:space-between;padding:0 .5rem;margin:0 auto;margin-top:30px}.recorrencias-switch-toggle input[data-v-7026068b]{display:none}.recorrencias-switch-toggle label[data-v-7026068b]{width:33.3%;margin:0 auto;z-index:5;font-weight:700;color:#fff;font-size:1rem;cursor:pointer;padding:.5rem 0;text-align:center}.toggle-selector[data-v-7026068b]{left:0;transition:all .3s ease-in-out;background-color:#fff;position:absolute;width:34%;top:0;height:100%;border-radius:100px;border:3px solid;border-color:#0f3e76;z-index:1}#Mensal:checked+label[data-v-7026068b],#Trimestral:checked+label[data-v-7026068b]{transition:all .5s;color:#0f3e76}#Trimestral:checked~.toggle-selector[data-v-7026068b]{left:32.2%}#Trimestral.only2:checked~.toggle-selector[data-v-7026068b]{left:66%}#Semestral:checked+label[data-v-7026068b]{transition:all .5s;color:#0f3e76}#Semestral:checked~.toggle-selector[data-v-7026068b]{left:66%}.shared-header[data-v-7026068b]{display:block;padding:15px 0;margin-top:15px}.shared-header .valign[data-v-7026068b]{line-height:30px;vertical-align:middle}.activation[data-v-7026068b]{margin-top:64px}.activation h3[data-v-7026068b]{margin-bottom:32px;font-size:54px;font-weight:500;margin-top:64px}.activation h3[data-v-7026068b],.activation h5[data-v-7026068b]{font-style:normal;font-stretch:normal;line-height:1.58;letter-spacing:-.5px;color:#222}.activation h5[data-v-7026068b]{margin-top:30px;margin-bottom:64px;font-weight:300}.activation-button[data-v-7026068b]{border:2px solid #267da5!important;border-radius:.7rem;margin-top:50px;cursor:pointer;width:200px!important;height:45px!important;background-color:#267da5!important;color:#fff!important;font-size:15px!important}.registro[data-v-7026068b]{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:#fff;display:block;transition:opacity .3s ease;overflow:auto}.registro[data-v-7026068b]::-webkit-scrollbar-track{background-color:#f4f4f4}.registro[data-v-7026068b]::-webkit-scrollbar{width:3px;background:#f4f4f4}.registro[data-v-7026068b]::-webkit-scrollbar-thumb{background:#dad7d7}.container-planos[data-v-7026068b]{width:100%;margin:auto}.title[data-v-7026068b]{color:#222;font-size:36px;font-weight:600;letter-spacing:-1.13px;line-height:44px}.subtitle[data-v-7026068b]{color:gray;font-size:1.1rem;line-height:130%;font-weight:400;text-align:center;width:100%;margin-top:10px}.title-price[data-v-7026068b]{display:inline-block;font-size:18px;color:#151414;text-align:center;font-weight:600}.nav[data-v-7026068b]{display:flex;justify-content:center;margin-top:1rem}.navbar[data-v-7026068b]{padding:0;border:1px solid #d3d2d2;box-shadow:0 5px 15px 0 rgba(82,95,127,.15)}.nav-link[data-v-7026068b]{color:#174b79;font-size:1.5rem;padding:.5rem 2.5rem;cursor:pointer}.active[data-v-7026068b],.nav-link[data-v-7026068b]:hover{color:#fff;background-color:#174b79}.card-wrapper[data-v-7026068b]{width:90%;margin:auto}.card[data-v-7026068b]{padding:0 .25rem .5rem;border:none}.card-content[data-v-7026068b]{font-size:1.5rem;line-height:24px;letter-spacing:-.15px;border-radius:0;border:1px solid #d3d2d2!important;box-shadow:0 5px 15px 0 rgba(82,95,127,.15)}.card-content[data-v-7026068b]:hover{border:2px solid #22f387!important}.card-title[data-v-7026068b]{font-size:26px;color:#174b79;margin-top:1.85rem}.card-desconto[data-v-7026068b]{color:#b54848;font-size:1rem;font-weight:700;text-decoration:line-through}.card-price-info[data-v-7026068b]{color:#757575;font-size:1.1rem}.card-price[data-v-7026068b]{color:#1cc925;font-size:2.5rem;font-weight:700;line-height:normal}.card-periodo[data-v-7026068b]{color:#9ca5ac;font-size:14px;line-height:normal;padding:0 2.3rem}.card-action[data-v-7026068b]{width:85%;margin:auto;padding:.75rem 0;border:1px solid #e6d168;border-radius:5px;background-color:#ffe871;cursor:pointer}.card-button[data-v-7026068b]{color:#191919;text-align:center;text-decoration:none;font-size:1.3rem;outline:none}.card-button[data-v-7026068b]:hover{background-color:#ffe45f}.card-info[data-v-7026068b]{padding:1.5rem 2.3rem}.card-info p[data-v-7026068b]{color:#385a7b;font-size:1rem;text-align:left;margin:.35rem 0}.linethrough[data-v-7026068b]{color:#757575!important;text-decoration:line-through}.complementos-wrapper[data-v-7026068b]{width:90%;margin:auto}.complementos[data-v-7026068b]{width:80%;min-height:300px;margin:50px auto;overflow:auto;padding:10px 20px;max-width:1260px}.complementos .item-complementos[data-v-7026068b]{width:100%;margin:0 auto}.complementos[data-v-7026068b]::-webkit-scrollbar-track{background-color:#f4f4f4}.complementos[data-v-7026068b]::-webkit-scrollbar{width:3px;background:#f4f4f4}.complementos[data-v-7026068b]::-webkit-scrollbar-thumb{background:#dad7d7}.comp-title[data-v-7026068b]{color:#385a7b;font-size:1.5rem;font-weight:500}.complemento[data-v-7026068b]{margin:0;padding:0}.complemento div[data-v-7026068b]{min-height:120px;margin:.25rem;padding:.85rem;border:1px solid #d3d2d2;box-shadow:0 5px 5px 0 rgba(82,95,127,.15);cursor:pointer}.selected[data-v-7026068b]{border:2px solid #22f387!important}.complemento .desc[data-v-7026068b]{color:#385a7b;font-size:1rem;text-align:left;margin:.35rem 0}.complemento .valor[data-v-7026068b]{color:#1cc925;font-size:1.5rem;font-weight:700;line-height:normal}.complemento .forma-pag[data-v-7026068b]{color:#757575}.resumo[data-v-7026068b]{width:100%;height:510px;margin-top:.5rem;overflow:auto;border:1px solid #d3d2d2!important;box-shadow:0 5px 15px 0 rgba(82,95,127,.15)}.resumo[data-v-7026068b]::-webkit-scrollbar-track{background-color:#f4f4f4}.resumo[data-v-7026068b]::-webkit-scrollbar{width:3px;background:#f4f4f4}.resumo[data-v-7026068b]::-webkit-scrollbar-thumb{background:#dad7d7}.resumo-wrapper[data-v-7026068b]{display:flex;flex-direction:column;padding:1.5rem;height:100%}.plano[data-v-7026068b]{border-bottom:1px solid #d3d2d2!important}.plano-resumo[data-v-7026068b],.plano span[data-v-7026068b]{font-size:1.3rem;font-weight:500}.plano span[data-v-7026068b]{color:#174b79}.plano small[data-v-7026068b]{color:#757575;font-size:.85rem;font-weight:600;margin:0}.plano p[data-v-7026068b]{font-size:.85rem;line-height:.5rem;letter-spacing:.03rem;margin:0}.itens-resumo[data-v-7026068b]{display:flex;flex-direction:column;align-items:flex-start;flex:1;color:#385a7b}.itens-wrapper[data-v-7026068b]{display:flex;justify-content:space-between;align-items:start;width:100%;padding:.35rem 0;border-bottom:1px solid #d3d2d2!important}.itens-resumo span[data-v-7026068b]{font-size:1rem;line-height:1.1rem}.itens-resumo strong[data-v-7026068b]{font-size:1rem;font-weight:800;min-width:27%;text-align:right}.total-resumo[data-v-7026068b]{display:flex;justify-content:space-between;align-items:center}.total-resumo span[data-v-7026068b]{font-size:1.3rem;font-weight:900;text-transform:uppercase;margin-top:1rem}.btn-finalizar[data-v-7026068b]{color:#fff;font-size:1.3rem;font-weight:700;text-transform:uppercase;padding:.75rem 13%;border:none;border-radius:5px;background:#1cc925;cursor:pointer}.btn-resumo[data-v-7026068b]:hover{background:#23bb2b}.app-button[data-v-7026068b]{border:2px solid #ffe871!important;border-radius:.7rem;cursor:pointer;height:45px!important;background-color:#ffe871!important;color:#000!important;font-size:16px!important;font-weight:600}.box-clientes[data-v-7026068b]{margin:10px;display:flex;flex-direction:column;align-items:center;padding:15px;transition:all .2s;box-shadow:0 5px 15px 0 #3a405048}.primary[data-v-7026068b]{background-color:#1cc925}.periodo-info[data-v-7026068b]{font-size:22px;letter-spacing:-.15px;line-height:24px}.duvidas .content[data-v-7026068b]{font-size:1rem;color:#385a7b;padding:10px;margin-bottom:1rem;cursor:pointer;border:1px solid transparent}.duvidas .content[data-v-7026068b]:hover{border:1px solid #1cc925!important}.bottom-bar[data-v-7026068b]{position:fixed;bottom:0;width:100%;height:70px;background-color:#fff;box-shadow:0 5px 15px 0 #3a405048}.bottom-bar div[data-v-7026068b]{display:flex;justify-content:center;align-items:center;padding-top:.5rem;width:50%;margin:auto}.bottom-bar span[data-v-7026068b]{font-size:1.3rem;font-weight:800;margin:0 .5rem;text-transform:uppercase}.button-green[data-v-7026068b]{cursor:pointer;transition:.3s;display:flex;justify-content:center;align-items:center;gap:15px;width:100%;height:100%;max-width:154px;max-height:39px;background-color:#acd22d;font-size:1rem;line-height:130%;padding:9px 0;border:1px solid transparent;border-radius:50px;color:#fff;margin-left:auto;margin-right:auto;text-decoration:none;font-weight:600}.button-green[data-v-7026068b]:hover{border-color:#acd22d;background-color:#fff;color:#acd22d}.button-light-blue[data-v-7026068b]{cursor:pointer;transition:.3s;display:flex;justify-content:center;align-items:center;gap:15px;width:100%;height:100%;max-width:154px;max-height:39px;background-color:#fff;font-size:1rem;line-height:130%;padding:9px 0;border:1px solid #0f3e76;border-radius:50px;color:#0f3e76;margin-left:auto;margin-right:auto;text-decoration:none;font-weight:600}.button-light-blue[data-v-7026068b]:hover,.card-plano-preco:hover~.button-light-blue[data-v-7026068b]{background-color:#0f3e76;color:#fff}@media only screen and (max-width:960px){.card-wrapper[data-v-7026068b]{width:100%;margin:0}.bottom-bar div[data-v-7026068b]{width:60%}.footer-container div[data-v-7026068b]{display:flex;justify-content:space-between;width:90%;margin:0 auto;gap:0;overflow-x:hidden}}@media only screen and (max-width:540px){.line[data-v-7026068b]{display:none!important}.container-planos-preco[data-v-7026068b]{display:flex;flex-direction:column;gap:40px}.container-planos-preco .box-custom[data-v-7026068b]{width:100%}.card-plano-preco[data-v-7026068b]{border-radius:20px}.card-plano-preco-destaque[data-v-7026068b],.card-plano-preco[data-v-7026068b]{width:90%;margin:0 auto;max-width:100%}.card[data-v-7026068b]{padding:0 1rem .5rem;border:none}.nav[data-v-7026068b]{margin-top:1rem}.navbar[data-v-7026068b]{margin:0 1rem}.nav-link[data-v-7026068b]{font-size:.85rem;padding:.5rem 1.5rem}.resumo-wrapper[data-v-7026068b]{padding:1rem}.complemento div[data-v-7026068b]{width:100%;margin:0}.bottom-bar div[data-v-7026068b]{width:90%;margin:auto;margin-top:.25rem}.bottom-bar span[data-v-7026068b]{font-size:1.2rem}.btn-finalizar[data-v-7026068b]{font-size:1rem;padding:.75rem 8%}}", ""]);

// exports


/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_planos_precos_checklist_vue__ = __webpack_require__(461);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c20f4bb_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_planos_precos_checklist_vue__ = __webpack_require__(1273);
function injectStyle (ssrContext) {
  __webpack_require__(1271)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c20f4bb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_planos_precos_checklist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c20f4bb_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_planos_precos_checklist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1272);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5c865a1c", content, true, {});

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table[data-v-1c20f4bb]{max-width:500px;margin:0 auto;width:90%;margin-top:61px}thead .table-col-1[data-v-1c20f4bb],thead .table-col-2[data-v-1c20f4bb]{background:\"\";color:\"\";border:0;font-size:16px}.table-col-2 th[data-v-1c20f4bb]{font-weight:700;font-size:14px;border:0}.table-col-1[data-v-1c20f4bb]{word-break:break-all;width:100%;max-width:200px;display:flex;justify-content:center;padding:1rem 10px;border-bottom:1px solid;border-color:#e3e3e3;border-left:1px solid #e3e3e3;font-size:12px}.table-col-full[data-v-1c20f4bb]{background:#f7f7f7;width:100%;display:flex;justify-content:start;padding:1rem 1.5rem;text-align:left;font-weight:500;border:1px solid #f3f3f4;font-size:16px}.table-col-2[data-v-1c20f4bb]{word-break:break-all;max-width:480px;padding:1rem 1.5rem;width:100%;font-weight:400;border-bottom:1px solid;border-color:#f3f3f4;font-size:14px}", ""]);

// exports


/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mt-5 pt-5",staticStyle:{"background":"white"}},[_c('h4',{staticClass:"text-center",staticStyle:{"color":""}},[_vm._v("Compare os planos")]),_vm._v(" "),_c('table',{staticClass:"mx-auto shadow",staticStyle:{"width":"80%","max-width":"1080px","background":"white","border":"1px solid #f3f3f4"}},[_c('thead',[_c('tr',{staticClass:"d-flex",staticStyle:{"border-bottom":"2px solid #f3f3f4","background-color":"#f7f7f7"}},[_c('th',{staticClass:"table-col-2",staticStyle:{"font-weight":"500"}},[_vm._v("Detalhes")]),_vm._v(" "),_vm._l((_vm.planos.planos),function(plan,index){return _c('th',{key:index,staticClass:"table-col-1",staticStyle:{"font-weight":"500"}},[_vm._v("\n          "+_vm._s(plan.nome)+"\n        ")])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.tableDetails),function(det){return _c('tr',{key:det.id,staticClass:"d-flex"},[(!det.title)?[_c('th',{staticClass:"table-col-2"},[_vm._v("\n            "+_vm._s(det.desc)+"\n          ")]),_vm._v(" "),_vm._l((_vm.planos.planos),function(plan,index){return _c('th',{key:index,staticClass:"table-col-1"},[(!_vm.isBoolean(det[plan.nome_tag]))?[(det[plan.nome_tag][0] !== 'i')?_c('strong',{domProps:{"innerHTML":_vm._s(det[plan.nome_tag])}}):_c('span',[_vm._v("\n                  "+_vm._s(det[plan.nome_tag])+"\n                  "),_c('i',{staticClass:"fa fa-check text-success",staticStyle:{"font-size":"25px"}})])]:[(det[plan.nome_tag] && !Number.isInteger(det[plan.nome_tag]))?_c('i',{staticClass:"fa fa-check text-success",staticStyle:{"font-size":"25px"}}):_c('i',{staticClass:"fa fa-times text-danger",staticStyle:{"font-size":"25px"}})]],2)})]:[_c('th',{staticClass:"table-col-full"},[_vm._v(_vm._s(det.desc))])]],2)}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registro"},[_vm._m(0),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.sucesso)?_c('div',{staticClass:"container-planos",staticStyle:{"margin-bottom":"100px"}},[(_vm.isEndTrial)?_c('div',[_c('div',{staticClass:"activation text-center mb-2"},[_c('h3',[_vm._v("Seu período de testes expirou!")])]),_vm._v(" "),_c('div',{staticClass:"activation text-center mb-2"},[_c('h3',[_vm._v("Selecione agora um plano para continuar a utilizar o Nota Brasil")])])]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"NFE"}},[_c('div',{staticClass:"text-center mb-5 mt-3"},[_c('div',{staticClass:"w-100 title"},[_vm._v(_vm._s(_vm.renovacao ? 'Renovação do Plano' : 'Planos e Preços')+" ")])]),_vm._v(" "),_c('div',{staticClass:"steps"},[_c('div',{staticClass:"container-steps"},[_c('div',{staticClass:"steps-fluxo"},[_c('div',{class:_vm.planSubscriptionSteps.length >= 1 ? 'item active' : 'item '},[_c('span',[_vm._v("1")])]),_vm._v(" "),_c('div',{class:_vm.planSubscriptionSteps.length >= 2 ? 'connection active' : 'connection'}),_vm._v(" "),_c('div',{class:_vm.planSubscriptionSteps.length >= 2 ? 'item active' : 'item'},[_c('span',[_vm._v("2")])]),_vm._v(" "),_c('div',{class:_vm.planSubscriptionSteps.length >= 3 ? 'connection active' : 'connection'}),_vm._v(" "),_c('div',{class:_vm.planSubscriptionSteps.length >= 3 ? 'item active' : 'item'},[_c('span',[_vm._v("3")])]),_vm._v(" "),_c('div',{class:_vm.planSubscriptionSteps.length >= 4 ? 'connection active' : 'connection'}),_vm._v(" "),_c('div',{class:_vm.planSubscriptionSteps.length >= 4 ? 'item active' : 'item'},[_c('span',[_vm._v("4")])])]),_vm._v(" "),_c('div',{staticClass:"steps-texts position-relative d-none d-md-flex"},[_c('span',{staticClass:"w-100 text-center position-absolute",staticStyle:{"left":"-300px"}},[_vm._v("Escolha o plano")]),_vm._v(" "),_c('span',{staticClass:"w-100 text-center position-absolute",staticStyle:{"left":"-100px"}},[_vm._v("Adicionar Complementos")]),_vm._v(" "),_c('span',{staticClass:"w-100 text-center position-absolute",staticStyle:{"left":"100px"}},[_vm._v("Faturamento")]),_vm._v(" "),_c('span',{staticClass:"w-100 text-center position-absolute",staticStyle:{"left":"300px"}},[_vm._v("Pagamento")])])])]),_vm._v(" "),(_vm.planSubscriptionSteps.length == 1)?_c('nav',{staticClass:"nav"},[_c('div',{staticClass:"recorrencias-switch-toggle"},[(_vm.hasRecorrencia('M'))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toggleRecorrencia),expression:"toggleRecorrencia"}],attrs:{"type":"radio","name":"toggle","value":"M","id":"Mensal"},domProps:{"checked":_vm._q(_vm.toggleRecorrencia,"M")},on:{"change":function($event){_vm.toggleRecorrencia="M"}}}):_vm._e(),_vm._v(" "),(_vm.hasRecorrencia('M'))?_c('label',{attrs:{"for":"Mensal"}},[_vm._v("Mensal")]):_vm._e(),_vm._v(" "),(_vm.hasRecorrencia('T'))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toggleRecorrencia),expression:"toggleRecorrencia"}],class:{ 'only2': !(_vm.hasRecorrencia('S')||_vm.hasRecorrencia('A')) },attrs:{"type":"radio","name":"toggle","value":"T","id":"Trimestral"},domProps:{"checked":_vm._q(_vm.toggleRecorrencia,"T")},on:{"change":function($event){_vm.toggleRecorrencia="T"}}}):_vm._e(),_vm._v(" "),(_vm.hasRecorrencia('T'))?_c('label',{attrs:{"for":"Trimestral"}},[_vm._v("Trimestral")]):_vm._e(),_vm._v(" "),(_vm.hasRecorrencia('S'))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toggleRecorrencia),expression:"toggleRecorrencia"}],attrs:{"type":"radio","name":"toggle","value":"S","id":"Semestral"},domProps:{"checked":_vm._q(_vm.toggleRecorrencia,"S")},on:{"change":function($event){_vm.toggleRecorrencia="S"}}}):_vm._e(),_vm._v(" "),(_vm.hasRecorrencia('S'))?_c('label',{attrs:{"for":"Semestral"}},[_vm._v("Semestral")]):_vm._e(),_vm._v(" "),(_vm.hasRecorrencia('A'))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toggleRecorrencia),expression:"toggleRecorrencia"}],attrs:{"type":"radio","name":"toggle","value":"A","id":"Anual"},domProps:{"checked":_vm._q(_vm.toggleRecorrencia,"A")},on:{"change":function($event){_vm.toggleRecorrencia="A"}}}):_vm._e(),_vm._v(" "),(_vm.hasRecorrencia('A'))?_c('label',{attrs:{"for":"Anual"}},[_vm._v("Anual")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"toggle-selector"},[_vm._v(" ")])])]):_vm._e(),_vm._v(" "),(_vm.credit && _vm.planSubscriptionSteps.length == 1)?_c('div',{staticClass:"container-bagde d-flex justify-content-start mb-5"},[_c('span',{staticClass:"badge-credit"},[_vm._v("Seu crédito é de : R$ "+_vm._s(_vm.credit)+" ")])]):_vm._e(),_vm._v(" "),(_vm.planSubscriptionSteps.length == 1)?[_c('div',{staticClass:"container-planos-preco d-flex"},_vm._l((_vm.plans.planos),function(plan,index){return _c('div',{key:index,staticClass:"box-custom"},[(plan.visible)?_c('div',{class:[!plan.recomendado && plan.disabled
              ?
              'card-plano-preco plan-disabled shadow'
              :
              !plan.recomendado && !plan.disabled
                ?
                'card-plano-preco  shadow '
                :
                'card-plano-preco-destaque shadow', plan.selected ? 'shadow-warning  border-warning' : ''],attrs:{"title":plan.disabled ? 'Este plano não está disponivel' : null,"id":(index == 0) ? 'first' : ((index == _vm.plans.planos.length - 1) ? 'last' : ("" + (plan.nome)))},on:{"click":function($event){return _vm.handleSelectPlan(index)}}},[_c('div',{staticClass:"w-100 text-right"},[_c('div',{staticClass:"text-center"},[_c('strong',[_vm._v(_vm._s(plan.nome))]),_vm._v(" "),(plan.selected)?_c('i',{staticClass:"float text-warning text-center fa fa-thumb-tack"}):_vm._e()]),_vm._v(" "),(!plan.disabled && _vm.credit)?_c('div',{staticClass:"w-100 text-center text-stripe"},[_c('div',{staticClass:"stripe-content"},[_vm._v("de R$"+_vm._s(_vm.getprecoTotal(plan, _vm.toggleRecorrencia))+"\n                    ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-center mb-1"},[(plan.recorrencias.length > 0)?_c('strong',{},[_vm._v("R$\n                    "+_vm._s(_vm._f("formatValue")(!plan.disabled
                          ?
                          _vm.getPriceDesc(_vm.getprecoTotal(plan, _vm.toggleRecorrencia))
                          :
                          _vm.getprecoTotal(plan, _vm.toggleRecorrencia),2, true))+"\n                  ")]):_vm._e(),_vm._v(" "),_c('small',[_vm._v("/ "+_vm._s(_vm.toggleRecorrencia == 'S' ? 'semestre' : _vm.toggleRecorrencia == 'T' ? 'trimestre' : _vm.toggleRecorrencia == 'A' ? 'anual' : 'mês')+"\n                  ")])]),_vm._v(" "),(_vm.toggleRecorrencia == 'T' || _vm.toggleRecorrencia == 'S')?_c('div',{staticClass:"text-center mb-3"},[(plan.recorrencias.length > 0)?_c('strong',{staticClass:"text-dark",staticStyle:{"font-size":"23px"}},[_vm._v("R$\n                    "+_vm._s(_vm._f("formatValue")(!plan.disabled
                          ?
                          _vm.getPriceDesc(_vm.getprecoMensal(plan, _vm.toggleRecorrencia))
                          :
                          _vm.getprecoTotal(plan, _vm.toggleRecorrencia),2, true))+"\n                  ")]):_vm._e(),_vm._v(" "),_c('small',[_vm._v("/ mês ")])]):_vm._e(),_vm._v(" "),_c('div',[(!plan.disabled)?_c('a',{class:!plan.recomendado && plan.disabled ? 'button-light-blue plan-disabled' : !plan.recomendado ? 'button-light-blue ' : 'button-green mt-4',on:{"click":function($event){return _vm.handleSelectPlan(index)}}},[_vm._v(_vm._s(!_vm.changePlan
                          || !_vm.renovacao ? 'Renovar' : 'Escolher')+" Plano")]):_vm._e()]),_vm._v(" "),_c('ul',[(plan.parametros && plan.parametros.recursos_landingpage && plan.parametros.recursos_landingpage.length > 0)?_vm._l((plan.parametros.recursos_landingpage),function(item,i){return _c('li',{key:'lp'+i},[_c('i',{staticClass:"fa fa-check-circle",staticStyle:{"color":"#ACD22D","font-size":"24px","z-index":"0"}}),_vm._v(" "),_c('span',{staticClass:"ml-2 text-left",staticStyle:{"z-index":"0"}},[_vm._v(_vm._s(item))])])}):_vm._l((plan.recursos),function(rec,i){return _c('li',{key:i},[_c('i',{class:rec.disabled ? 'fa fa-ban text-secondary' : 'fa fa-check-circle',staticStyle:{"color":"#ACD22D","font-size":"24px","z-index":"0"}}),_vm._v(" "),_c('span',{class:("ml-2 text-left text-left " + (rec.disabled ? 'line-through ' : null)),staticStyle:{"z-index":"0"}},[(!isNaN(rec.quantidade))?_c('strong',{},[_vm._v(_vm._s(rec.quantidade))]):_vm._e(),_vm._v(" "),_c('span',{},[_vm._v(" "+_vm._s(rec.nome))]),_vm._v(" "),(isNaN(rec.quantidade))?_c('strong',{},[_vm._v(_vm._s(rec.quantidade))]):_vm._e()]),_vm._v(" "),(rec.tooltip && !plan.disabled)?_c('div',{staticClass:"container-info"},[_c('i',{staticClass:"fa fa-info-circle",staticStyle:{"color":"#0C72AD"},attrs:{"data-toggle":"tooltip","data-placement":"top","title":rec.tooltip}})]):_vm._e()])})],2),_vm._v(" "),(plan.id == _vm.currentPlan && _vm.toggleRecorrencia == _vm.currentRecorrencia.substr(0, 1))?_c('div',{staticClass:"badge-recomendado"},[_vm._v("Plano Atual\n                ")]):_vm._e()]):_vm._e()])}),0),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('PlanosCheckList',{attrs:{"planos":_vm.plans}})],1)]:_vm._e()],2),_vm._v(" "),(false)?_c('div',{staticClass:"container mx-auto",staticStyle:{"margin-top":"100px"}},[_c('div',{staticClass:"row mb-3 text-center"},[_c('div',{staticClass:"col"},[_c('h2',{staticClass:"ml-3"},[_vm._v("Perguntas Frequentes")])])]),_vm._v(" "),_c('div',{staticClass:"row duvidas"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v("Quais são as formas de pagamento disponíveis?")]),_vm._v(" "),_c('p',[_vm._v("Você pode pagar o valor total do plano parcelado no cartão de crédito ou à vista no boleto.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v("O que acontece se acabar meu limite de emissão de notas?")]),_vm._v(" "),_c('p',[_vm._v("Caso seu limite de notas ficais no mês seja extrapolado, uma cobrança adicional será feita na próxima\n                renovação.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v("Tenho desconto se assinar a Conta Azul para mais de uma empresa?")]),_vm._v(" "),_c('p',[_vm._v("Para saber mais sobre esse benefício, fale com um de nossos especialistas no 0800 600 0920 ou\n                solicite\n                uma ligação de um consultor.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v("Posso contratar alguma funcionalidade de um plano superior?")]),_vm._v(" "),_c('p',[_vm._v("Para todos os planos pagos é possível contratar extensões: módulos de funcionalidade, pacote de\n                usuários ou espaço adicional para banco de dados ou anexos.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v("Posso cancelar a minha assinatura?")]),_vm._v(" "),_c('p',[_vm._v("Sua satisfação é muito importante para nós. Caso perceba que a Conta Azul não atende mais as suas\n                necessidades, vamos fazer de tudo para que você não vá embora insatisfeito. Mas lembre-se: conforme os\n                nossos termos de uso, você só vai receber devolução total dos valores se pedir o cancelamento em até 7\n                dias a partir do dia da compra independentemente do uso.")])])])])]):_vm._e(),_vm._v(" "),(_vm.planSubscriptionSteps.length == 2)?_c('div',{staticClass:"complementos"},[(_vm.selectedPlan.addons.length > 0)?_c('div',[_c('h3',[_vm._v("Selecione funcionalidades adicionais para melhorar o seu plano")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',_vm._l((_vm.selectedPlan.addons),function(comp,index){return _c('div',{key:index,staticClass:"border shadow my-3 component-addons"},[_c('div',{staticClass:"px-5 py-3 d-flex row align-items-center"},[_c('div',{staticClass:"d-flex col-6 align-items-start"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(comp.selected),expression:"comp.selected"}],staticClass:"mr-5",staticStyle:{"width":"16px","height":"16px"},attrs:{"type":"checkbox","name":"","id":""},domProps:{"checked":Array.isArray(comp.selected)?_vm._i(comp.selected,null)>-1:(comp.selected)},on:{"change":function($event){var $$a=comp.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(comp, "selected", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(comp, "selected", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(comp, "selected", $$c)}}}}),_vm._v(" "),_c('strong',{staticClass:"mr-4"},[_vm._v(_vm._s(comp.nome))])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-col text-right align-items-center justify-content-end col-6"},[_c('div',{staticClass:"line d-block mr-5",staticStyle:{"height":"30px","opacity":"50%"}}),_vm._v(" "),_c('strong',{staticClass:"text-right mx-5"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(comp.precoMensal,2, true))+" / mês")])]),_vm._v(" "),_c('transition',{attrs:{"name":"easeShow"}},[(comp.tooltip)?_c('small',{staticStyle:{"margin-left":"80px","line-height":"0px"}},[_vm._v(_vm._s(comp.tooltip))]):_vm._e()])],1)])}),0)]):_c('div',[_c('h3',[_vm._v("Plano sem funcionalidades adicionais disponíveis")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-success px-3",staticStyle:{"max-height":"50px"},attrs:{"disabled":!_vm.selectedPlan},on:{"click":_vm.handleAddStepToPlan}},[_vm._v("Avançar")])])]):_vm._e(),_vm._v(" "),(_vm.planSubscriptionSteps.length == 3)?_c('div',{staticClass:"container-dados-faturamento"},[_c('h3',[_vm._v("Informe seus dados para nota fiscal")]),_vm._v(" "),_c('div',{staticClass:"default-container mt-4"},[_c('div',{staticClass:"my-3"},[_c('label',{staticClass:"lbl-edit pb-1",attrs:{"for":""}},[_vm._v("Tipo de Pessoa")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dadosFaturamento.tppessoa),expression:"dadosFaturamento.tppessoa"}],attrs:{"type":"radio","name":"tppessoa","id":"","value":"F"},domProps:{"checked":_vm._q(_vm.dadosFaturamento.tppessoa,"F")},on:{"change":function($event){return _vm.$set(_vm.dadosFaturamento, "tppessoa", "F")}}}),_vm._v(" "),_c('label',{staticClass:"lbl",attrs:{"for":""}},[_vm._v("Pessoa Fisica")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dadosFaturamento.tppessoa),expression:"dadosFaturamento.tppessoa"}],attrs:{"type":"radio","name":"tppessoa","id":"","value":"J"},domProps:{"checked":_vm._q(_vm.dadosFaturamento.tppessoa,"J")},on:{"change":function($event){return _vm.$set(_vm.dadosFaturamento, "tppessoa", "J")}}}),_vm._v(" "),_c('label',{staticClass:"lbl",attrs:{"for":""}},[_vm._v("Pesso Juridica")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 60, cpf: false }),expression:"{ required: true, max: 60, cpf: false }"}],ref:"nome",attrs:{"type":"text","col":"6","label":"Nome","name":"nome","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.nome),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "nome", $$v)},expression:"dadosFaturamento.nome"}})],1),_vm._v(" "),(_vm.dadosFaturamento.tppessoa == 'J')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ cnpj: true, cpf: false }),expression:"{ cnpj: true, cpf: false }"}],ref:"cnpj",attrs:{"type":"cnpj","col":"3","label":"CNPJ","name":"cnpj","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.cnpj),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "cnpj", $$v)},expression:"dadosFaturamento.cnpj"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento.tppessoa == 'F')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ cpf: true, cnpj: false }),expression:"{ cpf: true, cnpj: false }"}],ref:"cpf",attrs:{"type":"number","col":"3","label":"CPF","name":"cpf","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.cpf),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "cpf", $$v)},expression:"dadosFaturamento.cpf"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"cep","col":"3","label":"Cep","name":"cep","v-errors":_vm.errors},on:{"update":_vm.updateCep},model:{value:(_vm.dadosFaturamento.cep),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "cep", $$v)},expression:"dadosFaturamento.cep"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 60 }),expression:"{ required: true, max: 60 }"}],attrs:{"type":"text","col":"4","label":"Endereço","name":"ende","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.endereco),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "endereco", $$v)},expression:"dadosFaturamento.endereco"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 20 }),expression:"{ required: true, max: 20 }"}],attrs:{"type":"text","col":"2","label":"Número","name":"endenr","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.nr),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "nr", $$v)},expression:"dadosFaturamento.nr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 40 }),expression:"{ max: 40 }"}],attrs:{"type":"text","col":"4","label":"Complemento","name":"endecomp","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.complemento),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "complemento", $$v)},expression:"dadosFaturamento.complemento"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 60 }),expression:"{ required: true, max: 60 }"}],attrs:{"type":"text","col":"4","label":"Bairro","name":"bairro","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.bairro),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "bairro", $$v)},expression:"dadosFaturamento.bairro"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"select2","col":"4","label":"Estado","name":"uf","v-errors":_vm.errors,"select2":{ entity: 'estado', minlength: 0 }},model:{value:(_vm.dadosFaturamento.uf),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "uf", $$v)},expression:"dadosFaturamento.uf"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"select2","col":"4","label":"Cidade","name":"codmun","v-errors":_vm.errors,"select2":{ entity: 'mun/uf/' + _vm.dadosFaturamento.uf, minlength: 2 }},model:{value:(_vm.dadosFaturamento.codmun),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "codmun", $$v)},expression:"dadosFaturamento.codmun"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 15, required: true }),expression:"{ max: 15, required: true }"}],attrs:{"type":"fone","col":"4","label":"Telefone","name":"fone","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.fone),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "fone", $$v)},expression:"dadosFaturamento.fone"}})],1):_vm._e()])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.sucesso)?_c('div',[_c('div',{staticClass:"activation d-flex flex-column align-items-center text-center",staticStyle:{"gap":"20px"}},[_c('div',[_c('i',{staticClass:"fa fa-check border-2 border-success bg-success bg-success text-light p-3 rounded-circle",staticStyle:{"font-size":"22px"}})]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Sucesso!")]),_vm._v(" "),((_vm.pagseguro && _vm.pagseguro.plano == 'free'))?_c('h2',{staticStyle:{"font-weight":"normal"}},[_vm._v("Plano escolhido com sucesso.\n        ")]):_c('h2',{staticStyle:{"font-weight":"normal"}},[_vm._v("Estamos aguardando a confirmação do seu pagamento.")]),_vm._v(" "),_c('button',{staticClass:"app-button",attrs:{"type":"button"},on:{"click":_vm.handleLogin}},[_vm._v(" Retornar ao Nota Brasil ")])])]):_vm._e()]),_vm._v(" "),(_vm.showComplementos)?_c('div',{staticClass:"bottom-bar"},[_c('div',[_c('span',[_vm._v("Total: R$"+_vm._s(_vm._f("formatValue")(_vm.resumo.total)))])])]):_vm._e(),_vm._v(" "),(!_vm.sucesso)?_c('div',{staticClass:"footer fixed-bottom shadow-lg overflow-x-hidden"},[_c('div',{staticClass:"footer-container my-3 lbl-gray",staticStyle:{"font-size":"14px","font-weight":"400"}},[_c('button',{staticClass:"btn btn-outline-secondary px-3",staticStyle:{"max-height":"50px"},on:{"click":_vm.handleBackStepToPlan}},[_vm._v("Voltar")]),_vm._v(" "),(_vm.selectedRecurso && _vm.selectedPlan)?_c('div',{staticClass:"d-flex flex-wrap",staticStyle:{"font-size":"15px","color":"black","font-weight":"500"}},[_c('div',{staticClass:"d-flex flex-column"},[_c('div',[_c('span',[_vm._v("Resumo da compra:\n              "),_c('strong',[_c('br',{staticClass:"d-none d-lg-block"}),_vm._v("\n                "+_vm._s(_vm.selectedPlan.nome + ' ')+" "+_vm._s(_vm.selectedRecurso.tipo)+"\n              ")])]),_vm._v(" - "),_c('span',[_vm._v("\n              R$ "+_vm._s(_vm._f("formatValue")(!_vm.selectedComplemento ? (_vm.getPriceDesc(_vm.selectedRecurso.precoTotal) / 12).toFixed(2) :
                  ((_vm.getPriceDesc(_vm.selectedRecurso.precoTotal) + (_vm.selectedComplemento.precoTotal * _vm.getBillingMethod)) /
                    _vm.getBillingMethod).toFixed(2),2, true))+"/mês\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"line mx-4 d-none d-lg-block"}),_vm._v(" "),_c('div',{staticClass:"d-flex h-auto h-lg-100 align-items-end",staticStyle:{"max-width":"210px"}},[_c('span',[_vm._v("Total: R$ "+_vm._s(_vm._f("formatValue")(!_vm.selectedComplemento ? _vm.getPriceDesc(_vm.selectedRecurso.precoTotal) :
              _vm.getPriceDesc(_vm.selectedRecurso.precoTotal) + (_vm.selectedComplemento.precoTotal * _vm.getBillingMethod),2, true))+"\n            "),_c('span',{staticClass:"d-none d-lg-block"},[_vm._v(" no boleto ou cartão de crédito ")]),_c('strong',[_vm._v("em até 12x")])])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success px-3",staticStyle:{"max-height":"50px"},attrs:{"disabled":!(_vm.selectedRecurso && _vm.selectedPlan)},on:{"click":_vm.handleAddStepToPlan}},[_vm._v("Avançar")])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"shared-header"},[_c('div',{staticClass:"col-md-12 col-12 text-center"},[_c('a',{staticClass:"valign",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_plano_increment_addons_vue__ = __webpack_require__(462);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_faf0c5e0_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_plano_increment_addons_vue__ = __webpack_require__(1278);
function injectStyle (ssrContext) {
  __webpack_require__(1276)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-faf0c5e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_plano_increment_addons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_faf0c5e0_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_plano_increment_addons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1277);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("848f83fe", content, true, {});

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".component-addons[data-v-faf0c5e0]{transition:all .5s ease}@keyframes changeOpacity-data-v-faf0c5e0{0%{opacity:0}40%{opacity:1%}to{opacity:1%}}.easeShow-enter-active[data-v-faf0c5e0]{animation:changeOpacity-data-v-faf0c5e0 .2s ease}.easeShow-leave-active[data-v-faf0c5e0]{animation:changeOpacity-data-v-faf0c5e0 .2s reverse}.default-container[data-v-faf0c5e0]{padding-bottom:9rem}.line-through[data-v-faf0c5e0]{text-decoration:line-through}.container-info[data-v-faf0c5e0]{display:flex;text-align:right;align-self:center;margin-left:5px;justify-content:center;z-index:50}.container-dados-faturamento[data-v-faf0c5e0]{width:80%;margin:50px auto;padding:10px 20px;max-width:1260px}.line[data-v-faf0c5e0]{border:1px solid hsla(0,0%,50%,.603)}.footer[data-v-faf0c5e0]{background-color:#fff;z-index:99999;overflow-x:hidden;max-height:100px}.footer .footer-container[data-v-faf0c5e0]{display:flex;justify-content:space-between;width:90%;margin:0 auto}ul[data-v-faf0c5e0]{padding-inline-start:0}ul li[data-v-faf0c5e0]{list-style:none;display:flex;align-items:center;margin-bottom:3px}.activation[data-v-faf0c5e0]{margin-top:64px}.activation h3[data-v-faf0c5e0]{margin-bottom:32px;font-size:54px;font-weight:500;margin-top:64px}.activation h3[data-v-faf0c5e0],.activation h5[data-v-faf0c5e0]{font-style:normal;font-stretch:normal;line-height:1.58;letter-spacing:-.5px;color:#222}.activation h5[data-v-faf0c5e0]{margin-top:30px;margin-bottom:64px;font-weight:300}.registro[data-v-faf0c5e0]{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:#fff;display:block;transition:opacity .3s ease;overflow:auto}.registro[data-v-faf0c5e0]::-webkit-scrollbar-track{background-color:#f4f4f4}.registro[data-v-faf0c5e0]::-webkit-scrollbar{width:3px;background:#f4f4f4}.registro[data-v-faf0c5e0]::-webkit-scrollbar-thumb{background:#dad7d7}.title[data-v-faf0c5e0]{color:#222;font-size:36px;font-weight:600;letter-spacing:-1.13px;line-height:44px}.subtitle[data-v-faf0c5e0]{color:gray;font-size:1.1rem;line-height:130%;font-weight:400;text-align:center;width:100%;margin-top:10px}.complementos[data-v-faf0c5e0]{width:80%;min-height:300px;margin:50px auto;overflow:auto;padding:10px 20px;max-width:1260px}.complementos .item-complementos[data-v-faf0c5e0]{width:100%;margin:0 auto}.complementos[data-v-faf0c5e0]::-webkit-scrollbar-track{background-color:#f4f4f4}.complementos[data-v-faf0c5e0]::-webkit-scrollbar{width:3px;background:#f4f4f4}.complementos[data-v-faf0c5e0]::-webkit-scrollbar-thumb{background:#dad7d7}.selected[data-v-faf0c5e0]{border:2px solid #22f387!important}.complemento .desc[data-v-faf0c5e0]{color:#385a7b;font-size:1rem;text-align:left;margin:.35rem 0}.complemento .valor[data-v-faf0c5e0]{color:#1cc925;font-size:1.5rem;font-weight:700;line-height:normal}.complemento .forma-pag[data-v-faf0c5e0]{color:#757575}.resumo[data-v-faf0c5e0]{width:100%;height:510px;margin-top:.5rem;overflow:auto;border:1px solid #d3d2d2!important;box-shadow:0 5px 15px 0 rgba(82,95,127,.15)}.resumo[data-v-faf0c5e0]::-webkit-scrollbar-track{background-color:#f4f4f4}.resumo[data-v-faf0c5e0]::-webkit-scrollbar{width:3px;background:#f4f4f4}.resumo[data-v-faf0c5e0]::-webkit-scrollbar-thumb{background:#dad7d7}.resumo-wrapper[data-v-faf0c5e0]{display:flex;flex-direction:column;padding:1.5rem;height:100%}.plano[data-v-faf0c5e0]{border-bottom:1px solid #d3d2d2!important}.plano-resumo[data-v-faf0c5e0],.plano span[data-v-faf0c5e0]{font-size:1.3rem;font-weight:500}.plano span[data-v-faf0c5e0]{color:#174b79}.plano small[data-v-faf0c5e0]{color:#757575;font-size:.85rem;font-weight:600;margin:0}.plano p[data-v-faf0c5e0]{font-size:.85rem;line-height:.5rem;letter-spacing:.03rem;margin:0}.itens-resumo[data-v-faf0c5e0]{display:flex;flex-direction:column;align-items:flex-start;flex:1;color:#385a7b}.itens-wrapper[data-v-faf0c5e0]{display:flex;justify-content:space-between;align-items:start;width:100%;padding:.35rem 0;border-bottom:1px solid #d3d2d2!important}.itens-resumo span[data-v-faf0c5e0]{font-size:1rem;line-height:1.1rem}.itens-resumo strong[data-v-faf0c5e0]{font-size:1rem;font-weight:800;min-width:27%;text-align:right}.total-resumo[data-v-faf0c5e0]{display:flex;justify-content:space-between;align-items:center}.total-resumo span[data-v-faf0c5e0]{font-size:1.3rem;font-weight:900;text-transform:uppercase;margin-top:1rem}.btn-finalizar[data-v-faf0c5e0]{color:#fff;font-size:1.3rem;font-weight:700;text-transform:uppercase;padding:.75rem 13%;border:none;border-radius:5px;background:#1cc925;cursor:pointer}.btn-resumo[data-v-faf0c5e0]:hover{background:#23bb2b}.app-button[data-v-faf0c5e0]{border:2px solid #ffe871!important;border-radius:.7rem;cursor:pointer;height:45px!important;background-color:#ffe871!important;color:#000!important;font-size:16px!important;font-weight:600}.box-clientes[data-v-faf0c5e0]{margin:10px;display:flex;flex-direction:column;align-items:center;padding:15px;transition:all .2s;box-shadow:0 5px 15px 0 #3a405048}.primary[data-v-faf0c5e0]{background-color:#1cc925}.periodo-info[data-v-faf0c5e0]{font-size:22px;letter-spacing:-.15px;line-height:24px}.duvidas .content[data-v-faf0c5e0]{font-size:1rem;color:#385a7b;padding:10px;margin-bottom:1rem;cursor:pointer;border:1px solid transparent}.duvidas .content[data-v-faf0c5e0]:hover{border:1px solid #1cc925!important}.bottom-bar[data-v-faf0c5e0]{position:fixed;bottom:0;width:100%;height:70px;background-color:#fff;box-shadow:0 5px 15px 0 #3a405048}.bottom-bar div[data-v-faf0c5e0]{display:flex;justify-content:center;align-items:center;padding-top:.5rem;width:50%;margin:auto}.bottom-bar span[data-v-faf0c5e0]{font-size:1.3rem;font-weight:800;margin:0 .5rem;text-transform:uppercase}.button-green[data-v-faf0c5e0]{cursor:pointer;transition:.3s;display:flex;justify-content:center;align-items:center;gap:15px;width:100%;height:100%;max-width:154px;max-height:39px;background-color:#acd22d;font-size:1rem;line-height:130%;padding:9px 0;border:1px solid transparent;border-radius:50px;color:#fff;margin-left:auto;margin-right:auto;text-decoration:none;font-weight:600}.button-green[data-v-faf0c5e0]:hover{border-color:#acd22d;background-color:#fff;color:#acd22d}.button-light-blue[data-v-faf0c5e0]{cursor:pointer;transition:.3s;display:flex;justify-content:center;align-items:center;gap:15px;width:100%;height:100%;max-height:39px;background-color:#fff;font-size:1rem;line-height:130%;padding:9px 0;border:1px solid #0f3e76;border-radius:50px;color:#0f3e76;margin-left:auto;margin-right:auto;text-decoration:none;font-weight:600}.button-light-blue[data-v-faf0c5e0]:hover,.card-plano-preco:hover~.button-light-blue[data-v-faf0c5e0]{background-color:#0f3e76;color:#fff}@media only screen and (max-width:960px){.card-wrapper[data-v-faf0c5e0]{width:100%;margin:0}.bottom-bar div[data-v-faf0c5e0]{width:60%}.footer-container div[data-v-faf0c5e0]{display:flex;justify-content:space-between;width:90%;margin:0 auto;gap:0;overflow-x:hidden}}@media only screen and (max-width:540px){.line[data-v-faf0c5e0]{display:none!important}.container-planos-preco[data-v-faf0c5e0]{display:flex;flex-direction:column;gap:40px}.container-planos-preco .box-custom[data-v-faf0c5e0]{width:100%}.card-plano-preco[data-v-faf0c5e0]{border-radius:20px}.card-plano-preco-destaque[data-v-faf0c5e0],.card-plano-preco[data-v-faf0c5e0]{width:90%;margin:0 auto;max-width:100%}.card[data-v-faf0c5e0]{padding:0 1rem .5rem;border:none}.nav[data-v-faf0c5e0]{margin-top:1rem}.navbar[data-v-faf0c5e0]{margin:0 1rem}.nav-link[data-v-faf0c5e0]{font-size:.85rem;padding:.5rem 1.5rem}.resumo-wrapper[data-v-faf0c5e0]{padding:1rem}.complemento div[data-v-faf0c5e0]{width:100%;margin:0}.bottom-bar div[data-v-faf0c5e0]{width:90%;margin:auto;margin-top:.25rem}.bottom-bar span[data-v-faf0c5e0]{font-size:1.2rem}.btn-finalizar[data-v-faf0c5e0]{font-size:1rem;padding:.75rem 8%}}", ""]);

// exports


/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registro"},[_vm._m(0),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.sucesso)?_c('div',{staticClass:"container-planos",staticStyle:{"margin-bottom":"100px"}},[(_vm.isEndTrial)?_c('div',[_c('div',{staticClass:"activation text-center mb-2"},[_c('h3',[_vm._v("Seu período de testes expirou!")])]),_vm._v(" "),_c('div',{staticClass:"activation text-center mb-2"},[_c('h3',[_vm._v("Selecione agora um plano para continuar a utilizar o Nota Brasil")])])]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"NFE"}},[_c('div',{staticClass:"text-center mb-5",staticStyle:{"margin-top":"100px"}},[_c('div',{staticClass:"w-100 title"},[_vm._v("Adicione Complementos")])])]),_vm._v(" "),(_vm.planSubscriptionSteps.length == 1)?_c('div',{staticClass:"complementos"},[_c('h4',[_vm._v("Selecione funcionalidades adicionais para melhorar o seu plano")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.plans.planos)?_c('div',_vm._l((_vm.selectedPlan.addons),function(comp,index){return _c('div',{key:index,staticClass:"border shadow my-3 component-addons"},[_c('div',{staticClass:"px-5 py-3 d-flex row align-items-center"},[_c('div',{staticClass:"d-flex col-6 align-items-start"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(comp.selected),expression:"comp.selected"}],staticClass:"mr-5",staticStyle:{"width":"16px","height":"16px"},attrs:{"type":"checkbox","name":"","id":""},domProps:{"checked":Array.isArray(comp.selected)?_vm._i(comp.selected,null)>-1:(comp.selected)},on:{"change":function($event){var $$a=comp.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(comp, "selected", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(comp, "selected", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(comp, "selected", $$c)}}}}),_vm._v(" "),_c('strong',{staticClass:"mr-4"},[_vm._v(_vm._s(comp.nome))]),_vm._v(" "),(comp.tooltip)?_c('div',{staticClass:"container-info cursor-pointer"},[_c('i',{staticClass:"fa fa-info-circle",staticStyle:{"color":"#0C72AD"},on:{"mouseover":function($event){return _vm.handleShowTooltip(index)},"mouseleave":function($event){return _vm.handleShowTooltip(index)}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-col text-right align-items-center justify-content-end col-6"},[_c('div',{staticClass:"line d-block mr-5",staticStyle:{"height":"30px","opacity":"50%"}}),_vm._v(" "),_c('strong',{staticClass:"text-right mx-5"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(comp.precoMensal,2))+" / mês")])]),_vm._v(" "),_c('transition',{attrs:{"name":"easeShow"}},[(comp.showTooltip)?_c('small',{staticStyle:{"margin-left":"80px","line-height":"0px"}},[_vm._v(_vm._s(comp.tooltip))]):_vm._e()])],1)])}),0):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.planSubscriptionSteps.length == 2)?_c('div',{staticClass:"container-dados-faturamento"},[_c('h3',[_vm._v("Dados Para Nota Fiscal")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"default-container mt-4"},[_c('div',{staticClass:"my-3"},[_c('label',{staticClass:"lbl-edit pb-1",attrs:{"for":""}},[_vm._v("Tipo de Pessoa")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dadosFaturamento.tppessoa),expression:"dadosFaturamento.tppessoa"}],attrs:{"type":"radio","name":"tppessoa","id":"","value":"F"},domProps:{"checked":_vm._q(_vm.dadosFaturamento.tppessoa,"F")},on:{"change":function($event){return _vm.$set(_vm.dadosFaturamento, "tppessoa", "F")}}}),_vm._v(" "),_c('label',{staticClass:"lbl",attrs:{"for":""}},[_vm._v("Pessoa Fisica")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dadosFaturamento.tppessoa),expression:"dadosFaturamento.tppessoa"}],attrs:{"type":"radio","name":"tppessoa","id":"","value":"J"},domProps:{"checked":_vm._q(_vm.dadosFaturamento.tppessoa,"J")},on:{"change":function($event){return _vm.$set(_vm.dadosFaturamento, "tppessoa", "J")}}}),_vm._v(" "),_c('label',{staticClass:"lbl",attrs:{"for":""}},[_vm._v("Pesso Juridica")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 60, cpf: false }),expression:"{ required: true, max: 60, cpf: false }"}],ref:"nome",attrs:{"type":"text","col":"4","label":"Nome","name":"nome","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.nome),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "nome", $$v)},expression:"dadosFaturamento.nome"}}),_vm._v(" "),(_vm.dadosFaturamento.tppessoa == 'J')?_c('div',{staticClass:"col-4"},[(_vm.dadosFaturamento.tppessoa == 'J')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, cnpj: true, cpf: false }),expression:"{ required: true, cnpj: true, cpf: false }"}],ref:"cnpj",attrs:{"type":"cnpj","col":"12","label":"CNPJ","name":"cnpj","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.cnpjcpf),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "cnpjcpf", $$v)},expression:"dadosFaturamento.cnpjcpf"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento.tppessoa == 'F')?_c('div',{staticClass:"col-4"},[(_vm.dadosFaturamento.tppessoa == 'F')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, cpf: true, cnpj: false }),expression:"{ required: true, cpf: true, cnpj: false }"}],ref:"cpf",attrs:{"type":"cnpj","col":"12","label":"CPF","name":"cpf","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.cnpjcpf),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "cnpjcpf", $$v)},expression:"dadosFaturamento.cnpjcpf"}}):_vm._e()],1):_vm._e()],1),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"cep","col":"4","label":"Cep","name":"cep","v-errors":_vm.errors},on:{"update":_vm.updateCep},model:{value:(_vm.dadosFaturamento.cep),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "cep", $$v)},expression:"dadosFaturamento.cep"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 60 }),expression:"{ required: true, max: 60 }"}],attrs:{"type":"text","col":"4","label":"Endereço","name":"ende","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.endereco),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "endereco", $$v)},expression:"dadosFaturamento.endereco"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 20 }),expression:"{ required: true, max: 20 }"}],attrs:{"type":"text","col":"2","label":"Número","name":"endenr","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.nr),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "nr", $$v)},expression:"dadosFaturamento.nr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 40 }),expression:"{ max: 40 }"}],attrs:{"type":"text","col":"4","label":"Complemento","name":"endecomp","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.complemento),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "complemento", $$v)},expression:"dadosFaturamento.complemento"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 60 }),expression:"{ required: true, max: 60 }"}],attrs:{"type":"text","col":"4","label":"Bairro","name":"bairro","v-errors":_vm.errors},model:{value:(_vm.dadosFaturamento.bairro),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "bairro", $$v)},expression:"dadosFaturamento.bairro"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"select2","col":"4","label":"Estado","name":"uf","v-errors":_vm.errors,"select2":{ entity: 'estado', minlength: 0 }},model:{value:(_vm.dadosFaturamento.uf),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "uf", $$v)},expression:"dadosFaturamento.uf"}})],1):_vm._e(),_vm._v(" "),(_vm.dadosFaturamento)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"select2","col":"4","label":"Cidade","name":"codmun","v-errors":_vm.errors,"select2":{ entity: 'mun/uf/' + _vm.dadosFaturamento.uf, minlength: 2 }},model:{value:(_vm.dadosFaturamento.codmun),callback:function ($$v) {_vm.$set(_vm.dadosFaturamento, "codmun", $$v)},expression:"dadosFaturamento.codmun"}})],1):_vm._e()])]):_vm._e(),_vm._v(" "),_c('hr')]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.sucesso)?_c('div',[_c('div',{staticClass:"activation text-center"},[_c('h2',{staticClass:"title"},[_vm._v("Sucesso!")]),_vm._v(" "),_c('h3',[_vm._v("Estamos aguardando a confirmação do seu pagamento.")])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center w-100"},[_c('button',{staticClass:"app-button",attrs:{"type":"button"},on:{"click":_vm.handleInicio}},[_vm._v(" Retornar ao Nota Brasil ")])])]):_vm._e()]),_vm._v(" "),(_vm.showComplementos)?_c('div',{staticClass:"bottom-bar"},[_c('div',[_c('span',[_vm._v("Total: R$"+_vm._s(_vm._f("formatValue")(_vm.resumo.total)))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"footer fixed-bottom shadow-lg overflow-x-hidden"},[_c('div',{staticClass:"footer-container my-3 lbl-gray",staticStyle:{"font-size":"14px","font-weight":"400"}},[_c('button',{staticClass:"btn btn-outline-secondary px-3",staticStyle:{"max-height":"50px"},on:{"click":_vm.handleBackStepToPlan}},[_vm._v("Voltar")]),_vm._v(" "),(_vm.selectedComplemento && _vm.selectedPlan && _vm.selectedRecurso)?_c('div',{staticClass:"d-flex flex-wrap",staticStyle:{"font-size":"15px"}},[_c('div',{staticClass:"d-flex flex-column"},[(_vm.selectedComplemento)?_c('div',[_c('span',[_vm._v("Resumo da compra:\n              R$ "+_vm._s(_vm._f("formatValue")((_vm.selectedComplemento.precoTotal).toFixed(2),2))+"/mês\n            ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"line mx-4 d-none d-lg-block"}),_vm._v(" "),_c('div',{staticClass:"d-flex h-auto h-lg-100 align-items-end",staticStyle:{"max-width":"210px"}},[_c('span',[_vm._v("Total: R$ "+_vm._s(_vm._f("formatValue")(_vm.selectedComplemento.precoTotal / 30 * _vm.diasRestantes,2))+"\n            "),_c('span',{staticClass:"d-none d-lg-block"},[_vm._v(" no boleto ou cartão de crédito ")]),_c('strong',[_vm._v("em até 12x")])])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success px-3",staticStyle:{"max-height":"50px"},attrs:{"disabled":!_vm.selectedPlan},on:{"click":_vm.handleAddStepToPlan}},[_vm._v("Avançar")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"shared-header"},[_c('div',{staticClass:"col-md-12 col-12 text-center"},[_c('a',{staticClass:"valign",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png","alt":"Logo Nota Brasil"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_login_form_vue__ = __webpack_require__(463);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_67f93645_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_login_form_vue__ = __webpack_require__(1282);
function injectStyle (ssrContext) {
  __webpack_require__(1280)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_login_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_67f93645_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_login_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1281);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("66f497b4", content, true, {});

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".shared-header{padding:15px 0;margin-top:15px}.shared-header .valign{line-height:30px;vertical-align:middle}.login-row{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;margin:0;height:100vh}.login{display:flex;-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%;min-height:100vh}.login,.login-side-column{background-color:#fff;-webkit-box-flex:0;box-sizing:border-box;padding:0;position:relative}.login-side-column{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.login-side-container{width:100%;height:100%;position:fixed;display:flex;align-items:end}.login-side-container-bg-blue{background-color:#0f3e76}@media screen and (max-width:1199px){.login{display:flex;background-color:#fff;-webkit-box-flex:0;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%;min-height:100vh}.login-side-column{display:none}}.login-side{width:66.666667%;position:absolute}.box-login{margin:10px 0 100px;display:flex;flex-direction:column;align-items:center;border-radius:15px;padding:100px 30px;letter-spacing:-.15px;line-height:24px;transition:all .2s;box-shadow:0 15px 45px 0 rgba(82,95,127,.15)}.login-button{border:2px solid #267da5!important;border-radius:.7rem;cursor:pointer;height:45px!important;background-color:#267da5!important;color:#fff!important;font-size:15px!important}.title-principal{color:#222;font-size:36px;letter-spacing:-1.13px;line-height:44px;margin:25px 0 0}", ""]);

// exports


/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"login-row"},[_c('div',{staticClass:"login justify-content-center"},[_c('div',[_c('div',{staticClass:"row col justify-content-center"},[_c('a',{staticClass:"valign",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png"}})])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center",staticStyle:{"padding":"40px"}},[_c('h2',{staticClass:"title-principal"},[_vm._v("Acesso ao Sistema")])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-10 col-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"label":"E-mail"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"email",staticClass:"form-control",attrs:{"id":"email","type":"text","placeholder":"exemplo@exemplo.com.br"},domProps:{"value":(_vm.email)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleEnter('email')},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"label":"Senha"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.senha),expression:"senha"}],ref:"senha",staticClass:"form-control",attrs:{"id":"senha","type":"password","placeholder":""},domProps:{"value":(_vm.senha)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleEnter('senha')},"input":function($event){if($event.target.composing){ return; }_vm.senha=$event.target.value}}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row col mb-3"},[_c('a',{attrs:{"tabindex":"1","href":"javascript:void(0);"},on:{"click":_vm.handleRecuperar}},[_vm._v("\n                Esqueci minha senha\n              ")])]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[(_vm.errmessages)?_c('alert',{attrs:{"type":"warning","close":false,"title":"Erro","text":_vm.errmessages}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('button',{staticClass:"login-button",staticStyle:{"width":"100%"},attrs:{"type":"button","id":"entrar","disabled":_vm.logando},on:{"click":_vm.handleEntrar}},[_vm._v(" "+_vm._s(_vm.botaoEntrar)+" ")])]),_vm._v(" "),_c('div',{staticClass:"row col justify-content-center mt-2"},[_c('a',{attrs:{"tabindex":"1","href":"https://www.notabrasil.com.br/criarcontav2/"}},[_vm._v("\n                Criar uma Conta\n              ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"login-side-column"},[_c('div',{staticClass:"login-side-container login-side-container-bg-blue"},[_c('img',{staticClass:"login-side",attrs:{"src":"/nb/atualizacao.png","onerror":"this.onerror=null; this.src='https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/login.png';","alt":"Aplicativo Nota Brasil"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_form_vue__ = __webpack_require__(464);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a60622c_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_form_vue__ = __webpack_require__(1304);
function injectStyle (ssrContext) {
  __webpack_require__(1284)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a60622c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a60622c_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1285);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2853366a", content, true, {});

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-dashboard-container[data-v-5a60622c]{font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;color:#0b1c30}.nb-tab-navigation-wrapper[data-v-5a60622c]{background:#fff;border:1px solid #e2e8f0;border-radius:12px;padding:6px;box-shadow:0 1px 3px rgba(0,0,0,.03)}.nb-tab-navigation[data-v-5a60622c]{display:flex;flex-wrap:wrap;gap:6px}.nb-tab-btn[data-v-5a60622c]{background:transparent;border:none;outline:none;padding:10px 18px;border-radius:8px;font-size:13.5px;font-weight:600;color:#64748b;cursor:pointer;display:inline-flex;align-items:center;transition:all .2s ease}.nb-tab-btn[data-v-5a60622c]:hover{background:#f8fafc;color:#0b1c30}.nb-tab-btn.active[data-v-5a60622c]{background:#004e94;color:#fff;box-shadow:0 2px 6px rgba(0,78,148,.25)}.nb-tab-badge[data-v-5a60622c]{font-size:11px;font-weight:700;padding:2px 8px;border-radius:12px;background:#eff4ff;color:#004e94}.nb-tab-btn.active .nb-tab-badge[data-v-5a60622c]{background:#fff;color:#004e94}.nb-tab-badge.badge-complete[data-v-5a60622c]{background:#ecfdf5;color:#059669}.nb-toolbar-card[data-v-5a60622c]{background:#fff;border:1px solid #e2e8f0;border-radius:12px;padding:14px 18px;box-shadow:0 1px 3px rgba(0,0,0,.03)}.nb-btn-primary[data-v-5a60622c]{background:#004e94;color:#fff;border:1px solid #004e94;font-weight:600;font-size:13px;padding:7px 14px;border-radius:8px;transition:all .15s ease}.nb-btn-primary[data-v-5a60622c]:hover{background:#00376c;color:#fff}.nb-btn-secondary[data-v-5a60622c]{background:#f8fafc;color:#0b1c30;border:1px solid #cbd5e1;font-weight:600;font-size:13px;padding:7px 14px;border-radius:8px}.nb-btn-secondary[data-v-5a60622c]:hover{background:#f1f5f9}.nb-btn-success[data-v-5a60622c]{background:#005a3c;color:#fff;border:1px solid #005a3c;font-weight:600;font-size:13px;padding:7px 14px;border-radius:8px}.nb-btn-success[data-v-5a60622c]:hover{background:#00402a;color:#fff}.nb-megamenu[data-v-5a60622c]{min-width:480px;border-radius:12px;border:1px solid #e2e8f0;padding:12px}.nb-menu-category[data-v-5a60622c]{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;color:#94a3b8;margin-bottom:6px;padding-left:8px}.nb-menu-item[data-v-5a60622c]{font-size:12.5px;font-weight:500;color:#1e293b;padding:6px 10px;border-radius:6px;transition:all .15s ease}.nb-menu-item[data-v-5a60622c]:hover{background:#eff4ff;color:#004e94}@media (max-width:768px){.nb-megamenu[data-v-5a60622c]{min-width:290px}}", ""]);

// exports


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1287);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("034a019e", content, true, {});

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-dash-card[data-v-1cd05c86]{background:#fff;border:1px solid #e2e8f0;border-radius:12px;box-shadow:0 1px 3px rgba(0,0,0,.04),0 1px 2px rgba(0,0,0,.02);transition:all .2s ease;overflow:hidden;display:flex;flex-direction:column;height:100%}.nb-dash-card[data-v-1cd05c86]:hover{box-shadow:0 4px 12px rgba(0,0,0,.06)}.nb-dash-header[data-v-1cd05c86]{padding:14px 20px;border-bottom:1px solid #f1f5f9;display:flex;align-items:center;justify-content:space-between;background:#fff}.nb-dash-title-text[data-v-1cd05c86]{font-family:Plus Jakarta Sans,Inter,sans-serif;font-size:14px;font-weight:700;color:#0b1c30;letter-spacing:-.2px}.nb-info-icon[data-v-1cd05c86]{color:#94a3b8;font-size:13px;cursor:pointer;transition:color .15s}.nb-info-icon[data-v-1cd05c86]:hover{color:#004e94}.nb-badge-mes[data-v-1cd05c86]{font-size:11px;font-weight:600;color:#004e94;background:#eff4ff;border:1px solid #dce9ff;padding:3px 9px;border-radius:20px;letter-spacing:.2px}.dash-kpi-card[data-v-1cd05c86]{background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 2px rgba(0,0,0,.03);position:relative;overflow:hidden;min-height:100px;transition:all .2s ease}.dash-kpi-card[data-v-1cd05c86]:hover{transform:translateY(-2px);box-shadow:0 4px 10px rgba(0,0,0,.06)}.kpi-top-bar[data-v-1cd05c86]{height:3px;width:100%}.kpi-accent-0 .kpi-top-bar[data-v-1cd05c86]{background:#004e94}.kpi-accent-1 .kpi-top-bar[data-v-1cd05c86]{background:#f59e0b}.kpi-accent-2 .kpi-top-bar[data-v-1cd05c86]{background:#10b981}.kpi-accent-3 .kpi-top-bar[data-v-1cd05c86]{background:#0ea5e9}.kpi-title[data-v-1cd05c86]{font-size:11.5px;font-weight:600;color:#64748b;text-transform:uppercase;letter-spacing:.4px}.kpi-value[data-v-1cd05c86]{font-family:Plus Jakarta Sans,Inter,sans-serif;font-size:22px;font-weight:700;color:#0b1c30;letter-spacing:-.5px;line-height:1.2}.kpi-icon-wrapper[data-v-1cd05c86]{width:32px;height:32px;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:14px}.kpi-icon-bg-0[data-v-1cd05c86]{background:#eff4ff;color:#004e94}.kpi-icon-bg-1[data-v-1cd05c86]{background:#fffbeb;color:#d97706}.kpi-icon-bg-2[data-v-1cd05c86]{background:#ecfdf5;color:#059669}.kpi-icon-bg-3[data-v-1cd05c86]{background:#f0f9ff;color:#0284c7}.kpi-sparkline[data-v-1cd05c86]{width:78px;height:26px;flex-shrink:0}.kpi-trend[data-v-1cd05c86]{font-size:11px;font-weight:600;display:inline-flex;align-items:center;padding:2px 7px;border-radius:6px;letter-spacing:.2px}.trend-positive[data-v-1cd05c86]{background:#ecfdf5;color:#059669}.trend-negative[data-v-1cd05c86]{background:#fef2f2;color:#dc2626}.trend-warning[data-v-1cd05c86]{background:#fffbeb;color:#d97706}.trend-neutral[data-v-1cd05c86]{background:#eff4ff;color:#004e94}.kpi-meta-footer[data-v-1cd05c86]{border-top:1px dashed #e2e8f0}.font-11[data-v-1cd05c86]{font-size:11px}.badge-tax-icms[data-v-1cd05c86]{background:#f0fdf4;color:#15803d;border:1px solid #bbf7d0;font-size:10px;font-weight:600;padding:2px 5px;border-radius:4px}.badge-tax-pis[data-v-1cd05c86]{background:#f0f9ff;color:#0369a1;border:1px solid #bae6fd;font-size:10px;font-weight:600;padding:2px 5px;border-radius:4px}.badge-tax-ipi[data-v-1cd05c86]{background:#faf5ff;color:#7e22ce;border:1px solid #e9d5ff;font-size:10px;font-weight:600;padding:2px 5px;border-radius:4px}.chart-wrapper[data-v-1cd05c86]{width:100%;min-height:290px}.empty-state-box[data-v-1cd05c86]{padding:30px}.nb-dash-footer[data-v-1cd05c86]{padding:10px 20px;background:#f8fafc;border-top:1px solid #f1f5f9;text-align:right}.nb-footer-link[data-v-1cd05c86]{font-size:12px;font-weight:600;color:#004e94;text-decoration:none!important;transition:all .15s;display:inline-flex;align-items:center}.nb-footer-link[data-v-1cd05c86]:hover{color:#00376c}", ""]);

// exports


/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"mb-4",class:_vm.columns},[_c('div',{staticClass:"nb-dash-card",on:{"click":_vm.handleClickCard}},[_c('div',{staticClass:"nb-dash-header"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"nb-dash-title-text"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.help)?_c('i',{staticClass:"fa fa-info-circle nb-info-icon ml-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":_vm.help,"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[(_vm.labelMes)?_c('span',{staticClass:"nb-badge-mes"},[_c('i',{staticClass:"fa fa-calendar-o mr-1"}),_vm._v(" "+_vm._s(_vm.labelMes)+"\n                ")]):_vm._e()])]),_vm._v(" "),(_vm.params.indicator && _vm.show)?_c('div',{staticClass:"row p-3"},_vm._l((_vm.values),function(value,index){return _c('div',{key:index,staticClass:"col-lg-3 col-sm-6 col-12 mb-3"},[_c('div',{staticClass:"dash-kpi-card",class:'kpi-accent-' + (index % 4)},[_c('div',{staticClass:"kpi-top-bar"}),_vm._v(" "),_c('div',{staticClass:"p-3 d-flex flex-column justify-content-between h-100"},[_c('div',{staticClass:"d-flex justify-content-between align-items-start"},[_c('span',{staticClass:"kpi-title"},[_vm._v(_vm._s(value.title))]),_vm._v(" "),_c('div',{staticClass:"kpi-icon-wrapper",class:'kpi-icon-bg-' + (index % 4)},[_c('i',{class:_vm.getKpiIcon(index),attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[(_vm.formatValue)?_c('span',{staticClass:"kpi-value"},[_vm._v("R$ "+_vm._s(_vm._f("format")(value.value)))]):_vm._e(),_vm._v(" "),(!_vm.formatValue)?_c('span',{staticClass:"kpi-value"},[_vm._v(_vm._s(value.value))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"kpi-bottom-row mt-2 d-flex align-items-center justify-content-between"},[_c('div',{staticClass:"kpi-trend",class:_vm.getTrendClass(index, value)},[_c('i',{staticClass:"mr-1",class:_vm.getTrendIcon(index, value)}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getTrendText(index, value)))])]),_vm._v(" "),_c('svg',{staticClass:"kpi-sparkline",attrs:{"viewBox":"0 0 100 30","preserveAspectRatio":"none"}},[_c('defs',[_c('linearGradient',{attrs:{"id":'sparkGrad-' + index,"x1":"0","y1":"0","x2":"0","y2":"1"}},[_c('stop',{attrs:{"offset":"0%","stop-color":_vm.getSparkColor(index),"stop-opacity":"0.25"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":_vm.getSparkColor(index),"stop-opacity":"0.0"}})],1)],1),_vm._v(" "),_c('path',{attrs:{"fill":'url(#sparkGrad-' + index + ')',"d":_vm.getSparkAreaPath(index, value)}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","stroke":_vm.getSparkColor(index),"stroke-width":"2.2","stroke-linecap":"round","stroke-linejoin":"round","d":_vm.getSparkLinePath(index, value)}})])]),_vm._v(" "),_c('div',{staticClass:"kpi-meta-footer mt-2 pt-2"},[(value.breakdown)?_c('div',{staticClass:"d-flex align-items-center justify-content-between flex-wrap gap-1"},[_c('span',{staticClass:"badge badge-tax-icms",attrs:{"title":'ICMS: R$ ' + _vm.formatMoney(value.breakdown.icms)}},[_vm._v("ICMS "),_c('strong',[_vm._v(_vm._s(_vm.formatShort(value.breakdown.icms)))])]),_vm._v(" "),_c('span',{staticClass:"badge badge-tax-pis",attrs:{"title":'PIS/COFINS: R$ ' + _vm.formatMoney(value.breakdown.piscofins)}},[_vm._v("PIS/COF "),_c('strong',[_vm._v(_vm._s(_vm.formatShort(value.breakdown.piscofins)))])]),_vm._v(" "),_c('span',{staticClass:"badge badge-tax-ipi",attrs:{"title":'IPI: R$ ' + _vm.formatMoney(value.breakdown.ipi)}},[_vm._v("IPI "),_c('strong',[_vm._v(_vm._s(_vm.formatShort(value.breakdown.ipi)))])])]):_c('div',{staticClass:"d-flex align-items-center text-muted font-11"},[_c('span',[_c('i',{staticClass:"fa fa-file-text-o mr-1"}),_vm._v(_vm._s(_vm.getDocCount(value))+" doc(s)")])])])])])])}),0):_vm._e(),_vm._v(" "),(_vm.params.chart && _vm.show && !_vm.mensagem)?_c('div',{staticClass:"p-3 chart-wrapper"},[_c('GChart',{attrs:{"type":_vm.params.chart.type,"data":_vm.values,"options":_vm.chartOptions}})],1):_vm._e(),_vm._v(" "),(_vm.params.chart && _vm.mensagem)?_c('div',{staticClass:"row align-items-center p-5 d-flex",staticStyle:{"flex-grow":"1"}},[_c('div',{staticClass:"col text-center empty-state-box"},[_c('i',{staticClass:"fa fa-bar-chart-o mb-2 text-muted",staticStyle:{"font-size":"28px","opacity":"0.5"}}),_vm._v(" "),_c('div',{staticClass:"text-muted font-weight-medium"},[_vm._v(_vm._s(_vm.mensagem))])])]):_vm._e(),_vm._v(" "),(_vm.params.detalhes)?_c('div',{staticClass:"nb-dash-footer"},[_c('a',{staticClass:"nb-footer-link",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){$event.stopPropagation();return _vm.handleDetalhes.apply(null, arguments)}}},[_c('span',[_vm._v("Ver relatório detalhado")]),_vm._v(" "),_c('i',{staticClass:"fa fa-arrow-right ml-1",attrs:{"aria-hidden":"true"}})])]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1290);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6676bc90", content, true, {});

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-dashboard-guia[data-v-3b842804]{font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;color:#0b1c30}.nb-hero-card[data-v-3b842804]{background:#fff;border:1px solid #e2e8f0;border-radius:12px;padding:24px;box-shadow:0 1px 3px rgba(0,0,0,.03)}.nb-hero-icon[data-v-3b842804]{width:38px;height:38px;border-radius:10px;background:#eff4ff;display:flex;align-items:center;justify-content:center;font-size:18px}.nb-hero-title[data-v-3b842804]{font-family:Plus Jakarta Sans,Inter,sans-serif;font-size:20px;font-weight:700;color:#0b1c30}.nb-hero-subtitle[data-v-3b842804]{font-size:13.5px;color:#64748b;max-width:720px;line-height:1.5}.nb-btn-guide-toggle[data-v-3b842804]{background:#f8fafc;color:#004e94;border:1px solid #cbd5e1;font-size:12.5px;font-weight:600;padding:7px 14px;border-radius:8px;transition:all .15s ease;display:inline-flex;align-items:center;gap:6px}.nb-btn-guide-toggle[data-v-3b842804]:hover{background:#eff4ff;border-color:#004e94}.nb-progress-wrapper[data-v-3b842804]{background:#f8fafc;border:1px solid #f1f5f9;border-radius:10px;padding:12px 16px}.nb-progress-label[data-v-3b842804]{font-size:12px;font-weight:700;color:#334155;text-transform:uppercase;letter-spacing:.4px}.nb-progress-percent[data-v-3b842804]{font-size:12.5px;font-weight:700;color:#004e94}.nb-progress-bar-container[data-v-3b842804]{height:8px;border-radius:10px;background:#e2e8f0}.nb-progress-bar-fill[data-v-3b842804]{background:#004e94;border-radius:10px;transition:width .4s ease}.nb-step-card[data-v-3b842804]{background:#fff;border:1px solid #e2e8f0;border-radius:12px;padding:20px;box-shadow:0 1px 3px rgba(0,0,0,.03);display:flex;flex-direction:column;justify-content:space-between;height:100%;transition:all .2s ease}.nb-step-card[data-v-3b842804]:hover{box-shadow:0 6px 16px rgba(0,0,0,.06);transform:translateY(-2px)}.nb-step-card.step-completed[data-v-3b842804]{border-color:#a7f3d0;background:#fafdfb}.nb-step-number[data-v-3b842804]{width:24px;height:24px;border-radius:6px;background:#eff4ff;color:#004e94;font-size:12px;font-weight:700;display:flex;align-items:center;justify-content:center}.badge-success-soft[data-v-3b842804]{background:#ecfdf5;color:#059669;border:1px solid #a7f3d0;font-size:11px;font-weight:700;padding:3px 8px;border-radius:6px}.badge-pending-soft[data-v-3b842804]{background:#fffbeb;color:#b45309;border:1px solid #fde68a;font-size:11px;font-weight:700;padding:3px 8px;border-radius:6px}.nb-step-card-header[data-v-3b842804]{display:flex;align-items:center;justify-content:space-between;width:100%}.nb-btn-video[data-v-3b842804]{width:36px;height:36px;padding:0;border-radius:8px;display:inline-flex;align-items:center;justify-content:center;background:#fef2f2;color:#ef4444;border:1px solid #fecaca;box-shadow:0 2px 4px rgba(239,68,68,.12);cursor:pointer;transition:all .2s cubic-bezier(.4,0,.2,1)}.nb-btn-video .fa-youtube-play[data-v-3b842804]{color:#ef4444;font-size:20px;line-height:1;transition:transform .2s ease,color .2s ease}.nb-btn-video[data-v-3b842804]:hover{background:#ef4444;border-color:#dc2626;color:#fff;box-shadow:0 4px 10px rgba(239,68,68,.35);transform:translateY(-2px) scale(1.05)}.nb-btn-video:hover .fa-youtube-play[data-v-3b842804]{color:#fff;transform:scale(1.1)}.nb-btn-video[data-v-3b842804]:focus{outline:none;box-shadow:0 0 0 3px rgba(239,68,68,.25)}.nb-step-illustration[data-v-3b842804]{display:flex;align-items:center;justify-content:center;width:100%;background:#f8fafc;border:1px solid #f1f5f9;border-radius:10px;padding:6px 10px;overflow:hidden;transition:all .2s ease}.nb-step-card:hover .nb-step-illustration[data-v-3b842804]{background:#eff4ff;border-color:#dbeafe}.nb-step-card.step-completed .nb-step-illustration[data-v-3b842804]{background:#f0fdf4;border-color:#dcfce7}.nb-step-title[data-v-3b842804]{font-family:Plus Jakarta Sans,Inter,sans-serif;font-size:15px;font-weight:700;color:#0b1c30;margin-top:12px;margin-bottom:6px}.nb-step-desc[data-v-3b842804]{font-size:12.5px;color:#64748b;line-height:1.4;margin-bottom:16px}.nb-btn-action[data-v-3b842804]{background:#004e94;color:#fff;border:none;font-size:12.5px;font-weight:600;padding:8px 14px;border-radius:8px;transition:all .15s ease}.nb-btn-action[data-v-3b842804]:hover{background:#00376c;color:#fff}.nb-btn-view[data-v-3b842804]{background:#ecfdf5;color:#059669;border:1px solid #a7f3d0;font-size:12.5px;font-weight:600;padding:8px 14px;border-radius:8px;transition:all .15s ease}.nb-btn-view[data-v-3b842804]:hover{background:#d1fae5;color:#047857}.nb-section-title[data-v-3b842804]{font-family:Plus Jakarta Sans,Inter,sans-serif;font-size:17px;font-weight:700;color:#0b1c30}.nb-section-subtitle[data-v-3b842804]{font-size:13px;color:#64748b}.nb-tutorial-card[data-v-3b842804]{background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 2px rgba(0,0,0,.03);display:flex;flex-direction:column;justify-content:space-between;height:100%}.nb-tutorial-link[data-v-3b842804]{cursor:pointer;text-decoration:none;width:100%;transition:opacity .15s ease;outline:none}.nb-tutorial-link:hover .nb-tutorial-title[data-v-3b842804]{color:#004e94;text-decoration:underline}.nb-tutorial-link:hover .nb-tutorial-icon[data-v-3b842804]{transform:scale(1.15)}.nb-tutorial-icon[data-v-3b842804]{font-size:32px;line-height:1;display:flex;align-items:center;justify-content:center;transition:transform .2s ease}.nb-tutorial-title[data-v-3b842804]{font-size:13px;font-weight:600;color:#0b1c30;transition:color .15s ease}.nb-tutorial-tag[data-v-3b842804]{font-size:10.5px;font-weight:700;text-transform:uppercase;color:#64748b;background:#f1f5f9;padding:2px 6px;border-radius:4px}.nb-tutorial-footer[data-v-3b842804]{border-top:1px solid #f1f5f9;background:#f8fafc;border-bottom-left-radius:10px;border-bottom-right-radius:10px}.nb-btn-play-sm[data-v-3b842804]{color:#004e94}.nb-btn-open-sm[data-v-3b842804],.nb-btn-play-sm[data-v-3b842804]{background:transparent;font-size:11.5px;font-weight:600;padding:2px 6px}.nb-btn-open-sm[data-v-3b842804]{color:#64748b}.nb-btn-open-sm[data-v-3b842804]:hover{color:#004e94}.nb-video-backdrop[data-v-3b842804]{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(11,28,48,.7);backdrop-filter:blur(2px);display:flex;align-items:center;justify-content:center;z-index:9999}.nb-video-modal[data-v-3b842804]{width:90%;max-width:700px;background:#fff;border-radius:12px;border:1px solid #e2e8f0;overflow:hidden}.nb-video-modal-header[data-v-3b842804]{background:#f8fafc;border-bottom:1px solid #e2e8f0}.nb-modal-header-icon[data-v-3b842804]{font-size:18px;color:#004e94;display:flex;align-items:center}.nb-modal-header-title[data-v-3b842804]{font-family:Plus Jakarta Sans,Inter,sans-serif;font-size:15px;font-weight:700;color:#0b1c30}.nb-modal-close[data-v-3b842804]{font-size:20px;color:#64748b;opacity:.7;transition:all .15s ease;line-height:1}.nb-modal-close[data-v-3b842804]:hover{color:#0b1c30;opacity:1}.nb-video-frame-container[data-v-3b842804]{border:1px solid #e2e8f0;background:#f8fafc}.nb-video-loading[data-v-3b842804]{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;background:#f8fafc;z-index:2;display:flex;flex-direction:column;align-items:center;justify-content:center}.nb-video-spinner-wrapper[data-v-3b842804]{width:52px;height:52px;border-radius:50%;background:#eff4ff;border:1px solid #dbeafe;display:flex;align-items:center;justify-content:center}.nb-video-spinner[data-v-3b842804]{font-size:24px;color:#004e94}.nb-video-loading-title[data-v-3b842804]{font-family:Plus Jakarta Sans,Inter,sans-serif;color:#0b1c30;font-size:14px;font-weight:700;letter-spacing:-.1px}.nb-video-loading-subtitle[data-v-3b842804]{color:#64748b;font-size:12px;font-weight:500;margin-top:2px}", ""]);

// exports


/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-dashboard-guia pb-5"},[_c('div',{staticClass:"nb-hero-card mb-4"},[_c('div',{staticClass:"d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center gap-3"},[_c('button',{staticClass:"btn nb-btn-guide-toggle",attrs:{"type":"button"},on:{"click":_vm.apiGuiaUsuario}},[_c('i',{staticClass:"fa",class:_vm.showGuia ? 'fa-eye-slash' : 'fa-eye'}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.showGuia ? 'Não exibir este guia ao logar' : 'Exibir este guia ao logar'))])])])]),_vm._v(" "),_c('div',{staticClass:"nb-progress-wrapper mt-4"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-1"},[_c('span',{staticClass:"nb-progress-label"},[_vm._v("\n          Progresso de Configuração\n        ")]),_vm._v(" "),_c('span',{staticClass:"nb-progress-percent"},[_vm._v("\n          "+_vm._s(_vm.completedCount)+" de 6 etapas concluídas ("+_vm._s(_vm.progressPercent)+"%)\n        ")])]),_vm._v(" "),_c('div',{staticClass:"progress nb-progress-bar-container"},[_c('div',{staticClass:"progress-bar nb-progress-bar-fill",style:({ width: _vm.progressPercent + '%' }),attrs:{"role":"progressbar","aria-valuenow":_vm.progressPercent,"aria-valuemin":"0","aria-valuemax":"100"}})])])]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},_vm._l((_vm.guiaNfe),function(item,index){return _c('div',{key:index,staticClass:"col-xl-4 col-md-6 col-12 mb-4"},[_c('div',{staticClass:"nb-step-card",class:{ 'step-completed': item.completed }},[_c('div',{staticClass:"nb-step-card-header d-flex align-items-center justify-content-between"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"nb-step-number mr-2"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),(item.completed)?_c('span',{staticClass:"badge badge-success-soft"},[_c('i',{staticClass:"fa fa-check mr-1"}),_vm._v(" Concluído\n            ")]):_c('span',{staticClass:"badge badge-pending-soft"},[_c('i',{staticClass:"fa fa-clock-o mr-1"}),_vm._v(" Pendente\n            ")])]),_vm._v(" "),(item.video)?_c('button',{staticClass:"btn nb-btn-video ml-auto",attrs:{"id":item.name + '_video',"title":"Assistir tutorial em vídeo","aria-label":"Assistir tutorial em vídeo"},on:{"click":function($event){return _vm.handleShowVideo(item)}}},[_c('i',{staticClass:"fa fa-youtube-play"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nb-step-illustration mt-3 mb-2"},[_c('guia-step-svg',{attrs:{"step":item.name,"completed":item.completed}})],1),_vm._v(" "),_c('div',{staticClass:"nb-step-card-body"},[_c('h5',{staticClass:"nb-step-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"nb-step-desc"},[_vm._v("\n            "+_vm._s(_vm.getStepDescription(item.name))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"nb-step-card-footer"},[_c('button',{staticClass:"btn btn-block",class:item.completed ? 'nb-btn-view' : 'nb-btn-action',on:{"click":function($event){return _vm.handleFazerAgora(item)}}},[_c('i',{staticClass:"fa",class:item.completed ? 'fa-check' : 'fa-arrow-right',attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(item.completed ? 'Configuração Concluída' : 'Configurar Agora'))])])])])])}),0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.allTutorials),function(item,index){return _c('div',{key:index,staticClass:"col-xl-4 col-md-6 col-12 mb-3"},[_c('div',{staticClass:"nb-tutorial-card"},[_c('div',{staticClass:"d-flex align-items-start justify-content-between p-3"},[_c('div',{staticClass:"d-flex align-items-center nb-tutorial-link",attrs:{"role":"button","tabindex":"0","title":"Assistir tutorial em vídeo"},on:{"click":function($event){return _vm.handleShowVideo(item)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleShowVideo(item)}}},[_vm._m(2,true),_vm._v(" "),_c('div',[_c('h6',{staticClass:"nb-tutorial-title mb-1"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),(item.subtitle)?_c('span',{staticClass:"nb-tutorial-tag"},[_vm._v(_vm._s(item.subtitle))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"nb-tutorial-footer p-2 d-flex justify-content-between align-items-center"},[_c('button',{staticClass:"btn btn-sm nb-btn-play-sm",on:{"click":function($event){return _vm.handleShowVideo(item)}}},[_c('i',{staticClass:"fa fa-play mr-1"}),_vm._v(" Assistir Vídeo\n          ")]),_vm._v(" "),(item.url)?_c('button',{staticClass:"btn btn-sm nb-btn-open-sm",on:{"click":function($event){return _vm.handleFazerAgora(item)}}},[_vm._v("\n            Abrir tela "),_c('i',{staticClass:"fa fa-external-link ml-1"})]):_vm._e()])])])}),0),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.currVideo)?_c('div',{staticClass:"nb-video-backdrop",on:{"click":_vm.handleCloseVideo}},[_c('div',{staticClass:"nb-video-modal shadow-lg",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"nb-video-modal-header d-flex justify-content-between align-items-center px-3 py-3"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"nb-modal-header-icon mr-2"},[_c('i',{staticClass:"fa fa-play-circle text-primary"})]),_vm._v(" "),_c('h5',{staticClass:"nb-modal-header-title mb-0"},[_vm._v("Tutorial em Vídeo")])]),_vm._v(" "),_c('button',{staticClass:"close nb-modal-close",attrs:{"type":"button","aria-label":"Fechar"},on:{"click":_vm.handleCloseVideo}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"embed-responsive embed-responsive-16by9 rounded overflow-hidden position-relative nb-video-frame-container"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.isVideoLoading)?_c('div',{staticClass:"nb-video-loading"},[_c('div',{staticClass:"nb-video-spinner-wrapper mb-3"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin nb-video-spinner"})]),_vm._v(" "),_c('span',{staticClass:"nb-video-loading-title"},[_vm._v("Carregando tutorial...")]),_vm._v(" "),_c('span',{staticClass:"nb-video-loading-subtitle"},[_vm._v("Aguarde um instante")])]):_vm._e()]),_vm._v(" "),_c('iframe',{staticClass:"embed-responsive-item",attrs:{"src":_vm.currVideo,"allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""},on:{"load":_vm.onVideoLoad}})],1)])])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"d-flex align-items-center mb-1"},[_c('div',{staticClass:"nb-hero-icon mr-2"},[_c('i',{staticClass:"fa fa-rocket text-primary"})]),_vm._v(" "),_c('h3',{staticClass:"nb-hero-title mb-0"},[_vm._v("Guia de Primeiros Passos")])]),_vm._v(" "),_c('p',{staticClass:"nb-hero-subtitle mb-0"},[_vm._v("\n          Siga as 6 etapas essenciais abaixo para configurar sua empresa e começar a emitir notas com rapidez e conformidade fiscal.\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-section-header mb-3"},[_c('h4',{staticClass:"nb-section-title"},[_c('i',{staticClass:"fa fa-video-camera text-primary mr-2"}),_vm._v(" Tutoriais e Treinamentos em Vídeo\n    ")]),_vm._v(" "),_c('p',{staticClass:"nb-section-subtitle"},[_vm._v("\n      Aprenda a utilizar os recursos de Frente de Caixa (PDV), importações de XML e cadastros em massa.\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-tutorial-icon mr-3"},[_c('i',{staticClass:"fa fa-youtube-play text-danger"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_guia_forcavendas_vue__ = __webpack_require__(468);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_39248b93_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_guia_forcavendas_vue__ = __webpack_require__(1295);
function injectStyle (ssrContext) {
  __webpack_require__(1293)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39248b93"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_guia_forcavendas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_39248b93_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_guia_forcavendas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1294);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("ea95856e", content, true, {});

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-dashboard-guia[data-v-39248b93]{font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;color:#0b1c30}.nb-hero-card[data-v-39248b93]{background:#fff;border:1px solid #e2e8f0;border-radius:14px;padding:24px;box-shadow:0 2px 6px rgba(0,0,0,.03)}.nb-hero-icon[data-v-39248b93]{font-size:20px;width:38px;height:38px;border-radius:10px;background:#eff4ff;display:inline-flex;align-items:center;justify-content:center}.nb-hero-title[data-v-39248b93]{font-size:20px;font-weight:700;color:#0b1c30;letter-spacing:-.2px}.nb-hero-subtitle[data-v-39248b93]{font-size:13.5px;color:#64748b;margin-top:4px;max-width:820px}.nb-btn-guide-toggle[data-v-39248b93]{background:#f8fafc;color:#475569;border:1px solid #cbd5e1;font-size:12.5px;font-weight:600;padding:8px 14px;border-radius:8px;display:inline-flex;align-items:center;gap:8px;transition:all .15s ease}.nb-btn-guide-toggle[data-v-39248b93]:hover{background:#f1f5f9;color:#0b1c30;border-color:#94a3b8}.nb-progress-wrapper[data-v-39248b93]{background:#f8fafc;border:1px solid #f1f5f9;border-radius:10px;padding:12px 16px}.nb-progress-label[data-v-39248b93]{font-size:13px;font-weight:600;color:#334155}.nb-progress-percent[data-v-39248b93]{font-size:12.5px;font-weight:700;color:#004e94}.nb-progress-bar-container[data-v-39248b93]{height:8px;border-radius:6px;background-color:#e2e8f0;overflow:hidden}.nb-progress-bar-fill[data-v-39248b93]{background:linear-gradient(90deg,#004e94,#00875a);transition:width .4s ease}.nb-step-card[data-v-39248b93]{background:#fff;border:1px solid #e2e8f0;border-radius:12px;display:flex;flex-direction:column;height:100%;padding:16px;position:relative;transition:all .2s ease;box-shadow:0 1px 3px rgba(0,0,0,.02)}.nb-step-card[data-v-39248b93]:hover{border-color:#cbd5e1;box-shadow:0 4px 14px rgba(0,78,148,.06);transform:translateY(-2px)}.nb-step-card.step-completed[data-v-39248b93]{border-color:#c6f6d5;background:#fcfffd}.nb-step-number[data-v-39248b93]{width:24px;height:24px;border-radius:50%;background:#f1f5f9;color:#475569;font-size:12px;font-weight:700;display:inline-flex;align-items:center;justify-content:center}.badge-success-soft[data-v-39248b93]{background:#ecfdf5;color:#059669;font-weight:600;font-size:11px;padding:4px 8px;border-radius:6px}.badge-pending-soft[data-v-39248b93]{background:#fffbeb;color:#b45309;font-weight:600;font-size:11px;padding:4px 8px;border-radius:6px}.nb-btn-video[data-v-39248b93]{color:#ef4444;font-size:20px;padding:0;line-height:1;background:transparent;border:none;transition:transform .15s ease}.nb-btn-video[data-v-39248b93]:hover{transform:scale(1.15);color:#dc2626}.nb-step-illustration[data-v-39248b93]{display:flex;align-items:center;justify-content:center;min-height:130px}.nb-step-title[data-v-39248b93]{font-size:15px;font-weight:700;color:#0b1c30;margin-bottom:6px;line-height:1.3}.nb-step-desc[data-v-39248b93]{font-size:12.5px;color:#64748b;margin-bottom:16px;line-height:1.45;min-height:52px}.nb-step-card-footer[data-v-39248b93]{margin-top:auto}.nb-btn-action[data-v-39248b93]{background:#004e94;color:#fff;font-weight:600;font-size:13px;padding:9px 14px;border-radius:8px;border:1px solid #004e94;transition:all .15s ease}.nb-btn-action[data-v-39248b93]:hover{background:#00376c;border-color:#00376c;color:#fff}.nb-btn-view[data-v-39248b93]{background:#ecfdf5;color:#059669;font-weight:600;font-size:13px;padding:9px 14px;border-radius:8px;border:1px solid #a7f3d0;transition:all .15s ease}.nb-btn-view[data-v-39248b93]:hover{background:#d1fae5;color:#047857}.nb-section-header[data-v-39248b93]{border-bottom:1px solid #e2e8f0;padding-bottom:12px}.nb-section-title[data-v-39248b93]{font-size:17px;font-weight:700;color:#0b1c30}.nb-section-subtitle[data-v-39248b93]{font-size:13px;color:#64748b;margin-bottom:0}.nb-tutorial-card[data-v-39248b93]{background:#fff;border:1px solid #e2e8f0;border-radius:10px;height:100%;display:flex;flex-direction:column;transition:all .15s ease}.nb-tutorial-card[data-v-39248b93]:hover{border-color:#cbd5e1;box-shadow:0 3px 8px rgba(0,0,0,.04)}.nb-tutorial-link[data-v-39248b93]{cursor:pointer;width:100%}.nb-tutorial-icon[data-v-39248b93]{font-size:26px;line-height:1}.nb-tutorial-title[data-v-39248b93]{font-size:13.5px;font-weight:600;color:#1e293b;line-height:1.35}.nb-tutorial-tag[data-v-39248b93]{font-size:11px;font-weight:600;color:#64748b;background:#f1f5f9;padding:2px 6px;border-radius:4px}.nb-tutorial-footer[data-v-39248b93]{margin-top:auto;background:#f8fafc;border-top:1px solid #f1f5f9;border-radius:0 0 10px 10px}.nb-btn-play-sm[data-v-39248b93]{background:#004e94;color:#fff;font-size:12px;font-weight:600;border-radius:6px;padding:4px 10px}.nb-btn-play-sm[data-v-39248b93]:hover{background:#00376c;color:#fff}.nb-btn-open-sm[data-v-39248b93]{background:#fff;color:#475569;border:1px solid #cbd5e1;font-size:12px;font-weight:600;border-radius:6px;padding:4px 10px}.nb-btn-open-sm[data-v-39248b93]:hover{background:#f1f5f9;color:#0b1c30}.nb-video-backdrop[data-v-39248b93]{position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(11,28,48,.65);backdrop-filter:blur(4px);z-index:1050;display:flex;align-items:center;justify-content:center;padding:16px}.nb-video-modal[data-v-39248b93]{background:#fff;border-radius:14px;max-width:820px;width:100%;overflow:hidden}.nb-video-modal-header[data-v-39248b93]{border-bottom:1px solid #e2e8f0;background:#f8fafc}.nb-modal-header-icon[data-v-39248b93]{font-size:22px;line-height:1}.nb-modal-header-title[data-v-39248b93]{font-size:16px;font-weight:700;color:#0b1c30}.nb-modal-close[data-v-39248b93]{font-size:24px;color:#64748b;opacity:.8;outline:none}.nb-modal-close[data-v-39248b93]:hover{color:#0b1c30;opacity:1}.nb-video-frame-container[data-v-39248b93]{background:#0b1c30;min-height:400px}.nb-video-loading[data-v-39248b93]{position:absolute;top:0;left:0;width:100%;height:100%;background:#0b1c30;display:flex;flex-direction:column;align-items:center;justify-content:center;z-index:2;color:#fff}.nb-video-spinner[data-v-39248b93]{font-size:38px;color:#38bdf8}.nb-video-loading-title[data-v-39248b93]{font-size:15px;font-weight:600;margin-top:8px}.nb-video-loading-subtitle[data-v-39248b93]{font-size:12px;color:#94a3b8}", ""]);

// exports


/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-dashboard-guia pb-5"},[_c('div',{staticClass:"nb-hero-card mb-4"},[_c('div',{staticClass:"d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center gap-3"},[_c('button',{staticClass:"btn nb-btn-guide-toggle",attrs:{"type":"button"},on:{"click":_vm.apiGuiaUsuario}},[_c('i',{staticClass:"fa",class:_vm.showGuia ? 'fa-eye-slash' : 'fa-eye'}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.showGuia ? 'Não exibir este guia ao logar' : 'Exibir este guia ao logar'))])])])]),_vm._v(" "),_c('div',{staticClass:"nb-progress-wrapper mt-4"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-1"},[_c('span',{staticClass:"nb-progress-label"},[_vm._v("\n          Progresso de Configuração Comercial\n        ")]),_vm._v(" "),_c('span',{staticClass:"nb-progress-percent"},[_vm._v("\n          "+_vm._s(_vm.completedCount)+" de 4 etapas concluídas ("+_vm._s(_vm.progressPercent)+"%)\n        ")])]),_vm._v(" "),_c('div',{staticClass:"progress nb-progress-bar-container"},[_c('div',{staticClass:"progress-bar nb-progress-bar-fill",style:({ width: _vm.progressPercent + '%' }),attrs:{"role":"progressbar","aria-valuenow":_vm.progressPercent,"aria-valuemin":"0","aria-valuemax":"100"}})])])]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},_vm._l((_vm.etapasGuia),function(item,index){return _c('div',{key:index,staticClass:"col-xl-3 col-md-6 col-12 mb-4"},[_c('div',{staticClass:"nb-step-card",class:{ 'step-completed': item.completed }},[_c('div',{staticClass:"nb-step-card-header d-flex align-items-center justify-content-between"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"nb-step-number mr-2"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),(item.completed)?_c('span',{staticClass:"badge badge-success-soft"},[_c('i',{staticClass:"fa fa-check mr-1"}),_vm._v(" Concluído\n            ")]):_c('span',{staticClass:"badge badge-pending-soft"},[_c('i',{staticClass:"fa fa-clock-o mr-1"}),_vm._v(" Pendente\n            ")])]),_vm._v(" "),(item.video)?_c('button',{staticClass:"btn nb-btn-video ml-auto",attrs:{"id":item.name + '_video',"title":"Assistir tutorial em vídeo","aria-label":"Assistir tutorial em vídeo"},on:{"click":function($event){return _vm.handleShowVideo(item)}}},[_c('i',{staticClass:"fa fa-youtube-play"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nb-step-illustration mt-3 mb-2"},[_c('guia-step-svg',{attrs:{"step":item.svgStep,"completed":item.completed}})],1),_vm._v(" "),_c('div',{staticClass:"nb-step-card-body"},[_c('h5',{staticClass:"nb-step-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"nb-step-desc"},[_vm._v("\n            "+_vm._s(item.desc)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"nb-step-card-footer"},[_c('button',{staticClass:"btn btn-block",class:item.completed ? 'nb-btn-view' : 'nb-btn-action',on:{"click":function($event){return _vm.handleFazerAgora(item)}}},[_c('i',{staticClass:"fa",class:item.completed ? 'fa-check' : 'fa-arrow-right',attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(item.completed ? 'Configuração Concluída' : 'Configurar Agora'))])])])])])}),0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.tutoriaisFV),function(item,index){return _c('div',{key:index,staticClass:"col-xl-4 col-md-6 col-12 mb-3"},[_c('div',{staticClass:"nb-tutorial-card"},[_c('div',{staticClass:"d-flex align-items-start justify-content-between p-3"},[_c('div',{staticClass:"d-flex align-items-center nb-tutorial-link",attrs:{"role":"button","tabindex":"0","title":"Assistir tutorial em vídeo"},on:{"click":function($event){return _vm.handleShowVideo(item)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleShowVideo(item)}}},[_vm._m(2,true),_vm._v(" "),_c('div',[_c('h6',{staticClass:"nb-tutorial-title mb-1"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),(item.subtitle)?_c('span',{staticClass:"nb-tutorial-tag"},[_vm._v(_vm._s(item.subtitle))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"nb-tutorial-footer p-2 d-flex justify-content-between align-items-center"},[_c('button',{staticClass:"btn btn-sm nb-btn-play-sm",on:{"click":function($event){return _vm.handleShowVideo(item)}}},[_c('i',{staticClass:"fa fa-play mr-1"}),_vm._v(" Assistir Vídeo\n          ")]),_vm._v(" "),(item.url)?_c('button',{staticClass:"btn btn-sm nb-btn-open-sm",on:{"click":function($event){return _vm.handleFazerAgora(item)}}},[_vm._v("\n            Abrir tela "),_c('i',{staticClass:"fa fa-external-link ml-1"})]):_vm._e()])])])}),0),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.currVideo)?_c('div',{staticClass:"nb-video-backdrop",on:{"click":_vm.handleCloseVideo}},[_c('div',{staticClass:"nb-video-modal shadow-lg",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"nb-video-modal-header d-flex justify-content-between align-items-center px-3 py-3"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"nb-modal-header-icon mr-2"},[_c('i',{staticClass:"fa fa-play-circle text-primary"})]),_vm._v(" "),_c('h5',{staticClass:"nb-modal-header-title mb-0"},[_vm._v("Tutorial em Vídeo")])]),_vm._v(" "),_c('button',{staticClass:"close nb-modal-close",attrs:{"type":"button","aria-label":"Fechar"},on:{"click":_vm.handleCloseVideo}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"embed-responsive embed-responsive-16by9 rounded overflow-hidden position-relative nb-video-frame-container"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.isVideoLoading)?_c('div',{staticClass:"nb-video-loading"},[_c('div',{staticClass:"nb-video-spinner-wrapper mb-3"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin nb-video-spinner"})]),_vm._v(" "),_c('span',{staticClass:"nb-video-loading-title"},[_vm._v("Carregando tutorial...")]),_vm._v(" "),_c('span',{staticClass:"nb-video-loading-subtitle"},[_vm._v("Aguarde um instante")])]):_vm._e()]),_vm._v(" "),_c('iframe',{staticClass:"embed-responsive-item",attrs:{"src":_vm.currVideo,"allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""},on:{"load":_vm.onVideoLoad}})],1)])])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"d-flex align-items-center mb-1"},[_c('div',{staticClass:"nb-hero-icon mr-2"},[_c('i',{staticClass:"fa fa-rocket text-primary"})]),_vm._v(" "),_c('h3',{staticClass:"nb-hero-title mb-0"},[_vm._v("Guia de Primeiros Passos - Força de Vendas")])]),_vm._v(" "),_c('p',{staticClass:"nb-hero-subtitle mb-0"},[_vm._v("\n          Siga as 4 etapas essenciais abaixo para configurar sua empresa, cadastrar produtos e clientes e começar a emitir pedidos de venda.\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-section-header mb-3"},[_c('h4',{staticClass:"nb-section-title"},[_c('i',{staticClass:"fa fa-video-camera text-primary mr-2"}),_vm._v(" Tutoriais e Treinamentos Comerciais\n    ")]),_vm._v(" "),_c('p',{staticClass:"nb-section-subtitle"},[_vm._v("\n      Aprenda a cadastrar tabelas de preços, controlar grades de produtos, gerenciar descontos e emitir pedidos com facilidade.\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-tutorial-icon mr-3"},[_c('i',{staticClass:"fa fa-youtube-play text-danger"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_nfe_vue__ = __webpack_require__(469);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b60a838_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_nfe_vue__ = __webpack_require__(1299);
function injectStyle (ssrContext) {
  __webpack_require__(1297)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b60a838"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_nfe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b60a838_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_nfe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1298);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("687fcb2b", content, true, {});

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-dashboard-nfe[data-v-4b60a838]{font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;color:#0b1c30}.nb-cert-panel[data-v-4b60a838]{background:#fff;border:1px solid #e2e8f0;border-radius:12px;padding:16px 20px;box-shadow:0 1px 3px rgba(0,0,0,.03)}.nb-cert-icon[data-v-4b60a838]{width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px}.cert-bg-success[data-v-4b60a838]{background:#ecfdf5}.cert-bg-warning[data-v-4b60a838]{background:#fffbeb}.cert-bg-danger[data-v-4b60a838]{background:#fef2f2}.nb-cert-title[data-v-4b60a838]{font-size:14px;font-weight:700;color:#0b1c30}.nb-cert-subtitle[data-v-4b60a838]{font-size:12px;color:#64748b;margin-top:1px}.nb-cert-date-label[data-v-4b60a838]{font-size:12px;color:#475569}.nb-cert-days[data-v-4b60a838]{font-size:12px;font-weight:700}.nb-cert-progress[data-v-4b60a838]{height:6px;border-radius:10px;background:#f1f5f9}.nb-btn-cert[data-v-4b60a838]{background:#f8fafc;color:#004e94;border:1px solid #cbd5e1;font-size:12.5px;font-weight:600;padding:7px 14px;border-radius:8px;transition:all .15s ease}.nb-btn-cert[data-v-4b60a838]:hover{background:#eff4ff;border-color:#004e94}.nb-btn-primary-cert[data-v-4b60a838]{background:#004e94;color:#fff;border:1px solid #004e94;font-size:12.5px;font-weight:600;padding:7px 14px;border-radius:8px;transition:all .15s ease}.nb-btn-primary-cert[data-v-4b60a838]:hover{background:#00376c;color:#fff}.nb-btn-outline-cert[data-v-4b60a838]{background:#fff;color:#0b1c30;border:1px solid #cbd5e1;font-size:12.5px;font-weight:600;padding:7px 14px;border-radius:8px;transition:all .15s ease}.nb-btn-outline-cert[data-v-4b60a838]:hover{background:#f8fafc;border-color:#94a3b8}.badge-success-soft[data-v-4b60a838]{background:#ecfdf5;color:#059669;border:1px solid #a7f3d0;font-size:11px;font-weight:700;padding:3px 8px;border-radius:6px}.badge-warning-soft[data-v-4b60a838]{background:#fffbeb;color:#d97706;border:1px solid #fde68a;font-size:11px;font-weight:700;padding:3px 8px;border-radius:6px}.badge-danger-soft[data-v-4b60a838]{background:#fef2f2;color:#dc2626;border:1px solid #fecaca;font-size:11px;font-weight:700;padding:3px 8px;border-radius:6px}.nb-rejection-alert[data-v-4b60a838]{background:#fff;border:1px solid #fecaca;border-left:4px solid #ef4444;border-radius:12px;padding:16px 20px;box-shadow:0 1px 3px rgba(0,0,0,.03)}.nb-alert-icon[data-v-4b60a838]{width:38px;height:38px;border-radius:10px;background:#fee2e2;color:#ef4444;display:flex;align-items:center;justify-content:center;font-size:18px}.nb-alert-title[data-v-4b60a838]{font-size:14px;font-weight:700;color:#0b1c30}.nb-alert-desc[data-v-4b60a838]{font-size:12.5px;color:#64748b}.nb-btn-inspect[data-v-4b60a838]{background:#fee2e2;color:#b91c1c;border:none;font-size:12.5px;font-weight:600;padding:7px 14px;border-radius:8px;transition:all .15s ease}.nb-btn-inspect[data-v-4b60a838]:hover{background:#fecaca}.nb-rejection-drawer[data-v-4b60a838]{border-top:1px dashed #fecaca}.nb-rejection-card[data-v-4b60a838]{background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:10px 12px}.nb-rejection-reason[data-v-4b60a838]{font-size:11.5px;color:#334155;line-height:1.3}.nb-fix-link[data-v-4b60a838]{font-size:11.5px;font-weight:700;color:#004e94;text-decoration:none!important}.nb-fix-link[data-v-4b60a838]:hover{color:#00376c;text-decoration:underline!important}", ""]);

// exports


/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-dashboard-nfe"},[_c('div',{staticClass:"nb-cert-panel mb-4"},[(_vm.hasCertificado)?_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-lg-5 col-md-6 col-12 mb-3 mb-md-0 d-flex align-items-center"},[_c('div',{staticClass:"nb-cert-icon mr-3",class:_vm.certIconBgClass},[_c('i',{staticClass:"fa fa-shield",class:_vm.certIconClass})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"nb-cert-title"},[_vm._v(_vm._s(_vm.certNome))]),_vm._v(" "),_c('span',{staticClass:"badge ml-2",class:_vm.certBadgeClass},[_vm._v(_vm._s(_vm.certStatusText))])]),_vm._v(" "),_c('div',{staticClass:"nb-cert-subtitle"},[_vm._v(_vm._s(_vm.certEmpresa))])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-md-6 col-12 mb-3 mb-lg-0"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-1"},[_c('span',{staticClass:"nb-cert-date-label"},[_vm._v("Vencimento: "),_c('strong',[_vm._v(_vm._s(_vm.certDataVencimento))])]),_vm._v(" "),_c('span',{staticClass:"nb-cert-days",class:_vm.certDaysClass},[_vm._v(_vm._s(_vm.certDiasTexto))])]),_vm._v(" "),_c('div',{staticClass:"progress nb-cert-progress"},[_c('div',{staticClass:"progress-bar",class:_vm.certProgressBarClass,style:({ width: _vm.certProgressPercent + '%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-12 d-flex justify-content-lg-end"},[_c('button',{staticClass:"btn nb-btn-cert",attrs:{"type":"button"},on:{"click":_vm.handleGerenciarCertificado}},[_c('i',{staticClass:"fa fa-cog mr-1"}),_vm._v(" Gerenciar / Renovar\n        ")])])]):_c('div',{staticClass:"row align-items-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-md-6 col-12 d-flex justify-content-lg-end flex-wrap gap-2"},[_c('button',{staticClass:"btn nb-btn-primary-cert mr-2",attrs:{"type":"button"},on:{"click":_vm.handleGerenciarCertificado}},[_c('i',{staticClass:"fa fa-plus-circle mr-1"}),_vm._v(" Configurar Certificado\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn nb-btn-outline-cert",attrs:{"type":"button"},on:{"click":_vm.handleAdquirirCertificado}},[_c('i',{staticClass:"fa fa-shopping-cart mr-1"}),_vm._v(" Adquirir Certificado A1\n        ")])])])]),_vm._v(" "),(_vm.rejeicoes && _vm.rejeicoes.length > 0)?_c('div',{staticClass:"nb-rejection-alert mb-4"},[_c('div',{staticClass:"d-flex align-items-start justify-content-between flex-wrap gap-3"},[_c('div',{staticClass:"d-flex align-items-start"},[_vm._m(1),_vm._v(" "),_c('div',[_c('div',{staticClass:"d-flex align-items-center flex-wrap"},[_c('span',{staticClass:"nb-alert-title"},[_vm._v(_vm._s(_vm.rejeicoes.length)+" Documento(s) com Falha de Validação SEFAZ")]),_vm._v(" "),_c('span',{staticClass:"badge badge-danger-soft ml-2"},[_vm._v("Ação Necessária")])]),_vm._v(" "),_c('p',{staticClass:"nb-alert-desc mb-0 mt-1"},[_vm._v("\n            Notas fiscais retidas com erro de validação SEFAZ. Corrija alíquotas, somatório de itens ou duplicidades para liberar o envio.\n          ")])])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn nb-btn-inspect",attrs:{"type":"button"},on:{"click":function($event){_vm.showRejectionDrawer = !_vm.showRejectionDrawer}}},[_c('span',[_vm._v("Inspecionar Rejeições")]),_vm._v(" "),_c('i',{staticClass:"fa ml-1",class:_vm.showRejectionDrawer ? 'fa-chevron-up' : 'fa-chevron-down'})])])]),_vm._v(" "),(_vm.showRejectionDrawer)?_c('div',{staticClass:"nb-rejection-drawer mt-3 pt-3"},[_c('div',{staticClass:"row"},_vm._l((_vm.rejeicoes),function(item){return _c('div',{key:item.codnf,staticClass:"col-md-4 col-12 mb-2"},[_c('div',{staticClass:"nb-rejection-card"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('span',{staticClass:"badge badge-danger font-mono"},[_vm._v("Rejeição "+_vm._s(item.cstat))]),_vm._v(" "),_c('span',{staticClass:"font-mono text-muted"},[_vm._v("NF "+_vm._s(item.numero)+" / S"+_vm._s(item.serie))])]),_vm._v(" "),_c('div',{staticClass:"nb-rejection-reason mt-2"},[_vm._v(_vm._s(item.motivo || 'Erro de validação de regras da SEFAZ'))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-link nb-fix-link p-0 mt-2",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleCorrigirNota(item.codnf)}}},[_vm._v("\n              Corrigir e Reenviar "),_c('i',{staticClass:"fa fa-arrow-right ml-1"})])])])}),0)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('dash-card',{attrs:{"params":_vm.dashboard.items[0],"filter":_vm.filter}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('dash-card',{attrs:{"params":_vm.dashboard.items[1],"filter":_vm.filter}}),_vm._v(" "),_c('dash-card',{attrs:{"params":_vm.dashboard.items[2],"filter":_vm.filter}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-7 col-md-6 col-12 mb-3 mb-md-0 d-flex align-items-center"},[_c('div',{staticClass:"nb-cert-icon cert-bg-warning mr-3"},[_c('i',{staticClass:"fa fa-exclamation-triangle text-warning"})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"nb-cert-title"},[_vm._v("Certificado Digital Não Configurado")]),_vm._v(" "),_c('span',{staticClass:"badge badge-warning-soft ml-2"},[_vm._v("Pendente")])]),_vm._v(" "),_c('div',{staticClass:"nb-cert-subtitle"},[_vm._v("\n            Para emitir e transmitir NF-e/NFC-e na SEFAZ, vincule seu Certificado Digital A1 ou A3.\n          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-alert-icon mr-3"},[_c('i',{staticClass:"fa fa-exclamation-triangle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_varejo_vue__ = __webpack_require__(470);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_73948000_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_varejo_vue__ = __webpack_require__(1303);
function injectStyle (ssrContext) {
  __webpack_require__(1301)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73948000"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_varejo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_73948000_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_varejo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1302);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("06f554b8", content, true, {});

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-dashboard-varejo[data-v-73948000]{font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif}.nb-dash-card[data-v-73948000]{background:#fff;border:1px solid #e2e8f0;border-radius:12px;box-shadow:0 1px 3px rgba(0,0,0,.04)}.nb-dash-header[data-v-73948000]{padding:14px 20px;border-bottom:1px solid #f1f5f9;display:flex;align-items:center;justify-content:space-between}.nb-dash-title-text[data-v-73948000]{font-family:Plus Jakarta Sans,Inter,sans-serif;font-size:14px;font-weight:700;color:#0b1c30}.nb-badge-sub[data-v-73948000]{font-size:11.5px;font-weight:700;color:#004e94;background:#eff4ff;border:1px solid #dce9ff;padding:3px 9px;border-radius:20px}.nb-varejo-shortcuts[data-v-73948000]{background:#fff;border:1px solid #e2e8f0;border-radius:12px;padding:14px 18px;box-shadow:0 1px 3px rgba(0,0,0,.03)}.nb-shortcuts-title[data-v-73948000]{font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:.4px;color:#64748b}.nb-quick-btn[data-v-73948000]{background:#f8fafc;border:1px solid #e2e8f0;color:#1e293b;font-size:12.5px;font-weight:600;padding:6px 14px;border-radius:8px;transition:all .15s ease}.nb-quick-btn[data-v-73948000]:hover{background:#eff4ff;border-color:#9ac1ff;color:#004e94;transform:translateY(-1px)}.nb-register-box[data-v-73948000]{background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;border-left:3px solid #10b981}.register-operator[data-v-73948000]{font-size:12px;font-weight:700;color:#0b1c30}.register-lbl[data-v-73948000]{font-size:11px;color:#64748b;text-transform:uppercase;font-weight:600}.register-val[data-v-73948000]{font-family:Plus Jakarta Sans,Inter,sans-serif;font-size:18px;font-weight:700;color:#004e94}.nb-status-dot[data-v-73948000]{width:10px;height:10px;border-radius:50%;background:#10b981}.pulse-green[data-v-73948000]{box-shadow:0 0 0 0 rgba(16,185,129,.7);animation:pulseGreen-data-v-73948000 2s infinite}@keyframes pulseGreen-data-v-73948000{0%{transform:scale(.95);box-shadow:0 0 0 0 rgba(16,185,129,.7)}70%{transform:scale(1);box-shadow:0 0 0 6px rgba(16,185,129,0)}to{transform:scale(.95);box-shadow:0 0 0 0 rgba(16,185,129,0)}}.badge-success-soft[data-v-73948000]{background:#ecfdf5;color:#059669;border:1px solid #a7f3d0;font-size:10.5px;font-weight:700;padding:2px 7px;border-radius:6px}.badge-info-soft[data-v-73948000]{background:#eff4ff;color:#004e94;border:1px solid #dce9ff;font-size:11px;font-weight:600;padding:4px 8px;border-radius:6px}.badge-perc[data-v-73948000]{background:#f1f5f9;color:#334155;font-size:11px;font-weight:600;padding:3px 6px;border-radius:4px}.nb-table th[data-v-73948000]{font-size:11.5px;font-weight:700;text-transform:uppercase;letter-spacing:.4px;color:#64748b;border-top:none;background:#f8fafc}.nb-table td[data-v-73948000]{font-size:13px;vertical-align:middle}.nb-table-total-row th[data-v-73948000]{background:#eff4ff;color:#004e94;font-size:13px;font-weight:700;border-top:2px solid #9ac1ff}", ""]);

// exports


/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-dashboard-varejo"},[_c('div',{staticClass:"nb-varejo-shortcuts mb-4"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between flex-wrap gap-2"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap gap-2"},[_c('button',{staticClass:"btn nb-quick-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.clickConsulta('/varejo/novo')}}},[_c('i',{staticClass:"fa fa-desktop text-success mr-1"}),_vm._v(" Frente de Caixa (PDV)\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn nb-quick-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.clickConsulta('/varejo/controlecaixa')}}},[_c('i',{staticClass:"fa fa-calculator text-primary mr-1"}),_vm._v(" Gerenciar Caixas\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn nb-quick-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.clickConsulta('/fvpedidolist')}}},[_c('i',{staticClass:"fa fa-list-alt text-info mr-1"}),_vm._v(" Gerenciar Vendas\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn nb-quick-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.clickConsulta('/consultas/varejo-movimento-caixa')}}},[_c('i',{staticClass:"fa fa-money text-warning mr-1"}),_vm._v(" Movimento de Caixa\n        ")])])])]),_vm._v(" "),(_vm.caixasAbertosList.length)?_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"nb-dash-card p-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between mb-3"},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"badge badge-info-soft"},[_vm._v(_vm._s(_vm.caixasAbertosList.length)+" terminal(is) ativo(s)")])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.caixasAbertosList),function(caixa,index){return _c('div',{key:index,staticClass:"col-xl-3 col-md-6 col-12 mb-2"},[_c('div',{staticClass:"nb-register-box p-3"},[_c('div',{staticClass:"d-flex justify-content-between align-items-start mb-2"},[_c('span',{staticClass:"register-operator"},[_c('i',{staticClass:"fa fa-user-circle-o mr-1"}),_vm._v(" "+_vm._s(caixa.operador || 'Operador')+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"badge badge-success-soft"},[_vm._v("Aberto")])]),_vm._v(" "),_c('div',{staticClass:"register-lbl"},[_vm._v("Total em Vendas")]),_vm._v(" "),_c('div',{staticClass:"register-val"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(caixa.totalvendas,2)))])])])}),0)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_c('dash-card',{attrs:{"params":_vm.dashboard.items[0],"filter":_vm.filter}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('dash-card',{attrs:{"params":_vm.dashboard.items[1],"filter":_vm.filter}}),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-12 mb-4"},[_c('div',{staticClass:"nb-dash-card"},[_c('div',{staticClass:"nb-dash-header"},[_vm._m(2),_vm._v(" "),(_vm.totalFormas > 0)?_c('span',{staticClass:"nb-badge-sub"},[_vm._v("\n            Total: R$ "+_vm._s(_vm._f("formatValue")(_vm.totalFormas,2))+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"p-3",staticStyle:{"max-height":"340px","overflow-y":"auto"}},[_c('table',{staticClass:"table table-hover nb-table mb-0"},[_vm._m(3),_vm._v(" "),_c('tbody',[_vm._l((_vm.formasList),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"font-weight-medium"},[_c('i',{staticClass:"fa fa-circle mr-2",style:({ color: _vm.getFormaColor(index) })}),_vm._v("\n                  "+_vm._s(row.descricao)+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-right font-weight-bold text-dark"},[_vm._v("\n                  R$ "+_vm._s(_vm._f("formatValue")(row.valor,2))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"badge badge-perc"},[_vm._v(_vm._s(_vm._f("formatValue")(row.perc,2))+"%")])])])}),_vm._v(" "),(_vm.formasList.length === 0)?_c('tr',[_c('td',{staticClass:"text-center text-muted py-4",attrs:{"colspan":"3"}},[_vm._v("\n                  Nenhuma venda registrada no período selecionado.\n                ")])]):_vm._e()],2),_vm._v(" "),(_vm.formasList.length > 0)?_c('tfoot',[_c('tr',{staticClass:"nb-table-total-row"},[_c('th',[_vm._v("Total Geral")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.totalFormas,2)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("100,00%")])])]):_vm._e()])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-shortcuts-title"},[_c('i',{staticClass:"fa fa-shopping-basket text-primary mr-1"}),_vm._v(" Operação de Frente de Caixa & PDV\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"nb-status-dot pulse-green mr-2"}),_vm._v(" "),_c('span',{staticClass:"font-weight-bold text-dark",staticStyle:{"font-size":"14px"}},[_vm._v("Caixas em Operação (Abertos)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"nb-dash-title-text"},[_c('i',{staticClass:"fa fa-credit-card mr-2 text-primary"}),_vm._v(" Vendas por Forma de Pagamento\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Forma de Pagamento")]),_vm._v(" "),_c('th',{staticClass:"text-right",staticStyle:{"width":"140px"}},[_vm._v("Valor (R$)")]),_vm._v(" "),_c('th',{staticClass:"text-right",staticStyle:{"width":"120px"}},[_vm._v("% Percentual")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDashboardVendas)?_c('div',{staticClass:"d-flex flex-column w-100 nb-dashboard-container"},[_c('div',{staticClass:"nb-tab-navigation-wrapper mb-4"},[_c('div',{staticClass:"nb-tab-navigation"},[(_vm.idxPainelPedido !== null)?_c('button',{staticClass:"nb-tab-btn",class:{ active: _vm.showTabPedido },attrs:{"type":"button"},on:{"click":function($event){return _vm.changeTab(_vm.idxPainelPedido)}}},[_c('i',{staticClass:"fa fa-line-chart mr-2"}),_vm._v(" "),_c('span',[_vm._v("Painel de Vendas & Pedidos")])]):_vm._e(),_vm._v(" "),(_vm.idxPainelNfe !== null && (_vm.appNFe || _vm.appERP))?_c('button',{staticClass:"nb-tab-btn",class:{ active: _vm.showTabNFe },attrs:{"type":"button"},on:{"click":function($event){return _vm.changeTab(_vm.idxPainelNfe)}}},[_c('i',{staticClass:"fa fa-file-text-o mr-2"}),_vm._v(" "),_c('span',[_vm._v("Faturamento & NF-e")])]):_vm._e(),_vm._v(" "),(_vm.idxPainelVarejo !== null)?_c('button',{staticClass:"nb-tab-btn",class:{ active: _vm.showTabVarejo },attrs:{"type":"button"},on:{"click":function($event){return _vm.changeTab(_vm.idxPainelVarejo)}}},[_c('i',{staticClass:"fa fa-shopping-basket mr-2"}),_vm._v(" "),_c('span',[_vm._v("Frente de Caixa & Varejo")])]):_vm._e(),_vm._v(" "),(_vm.idxPainelGuiaNfe !== null || _vm.idxPainelGuiaForcaVendas !== null)?_c('button',{staticClass:"nb-tab-btn",class:{ active: _vm.showTabGuiaNFe || _vm.showTabGuiaForcaVendas },attrs:{"type":"button"},on:{"click":function($event){return _vm.changeTab(_vm.idxPainelGuiaNfe !== null ? _vm.idxPainelGuiaNfe : _vm.idxPainelGuiaForcaVendas)}}},[_c('i',{staticClass:"fa fa-rocket mr-2"}),_vm._v(" "),_c('span',[_vm._v("Guia Primeiros Passos")]),_vm._v(" "),_c('span',{staticClass:"nb-tab-badge ml-2",class:{ 'badge-complete': _vm.guiaProgresso.completed === _vm.guiaProgresso.total }},[_vm._v("\n          "+_vm._s(_vm.guiaProgresso.completed)+"/"+_vm._s(_vm.guiaProgresso.total)+" concluído\n        ")])]):_vm._e()])]),_vm._v(" "),(!_vm.showTabGuiaNFe && !_vm.showTabGuiaForcaVendas)?_c('div',{staticClass:"nb-toolbar-card mb-4"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-xl-3 col-lg-4 col-md-5 col-12 mb-2 mb-md-0 d-flex align-items-center"},[_c('div',{staticClass:"w-100",staticStyle:{"min-width":"145px"}},[_c('input-month',{attrs:{"p-month":_vm.filter,"show-options":false},on:{"monthChange":_vm.handleMonthChange}})],1)]),_vm._v(" "),(_vm.showTabPedido)?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-12 mb-2 mb-md-0 d-flex align-items-center"},[(_vm.usuarioList && _vm.usuarioList.length > 0)?_c('div',{staticClass:"w-100 mr-2"},[_c('form-field',{attrs:{"type":"select","col":"12","select-options":_vm.usuarioList,"placeholder":"Todos os Vendedores"},model:{value:(_vm.codusuario),callback:function ($$v) {_vm.codusuario=$$v},expression:"codusuario"}})],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 d-flex align-items-center justify-content-md-end flex-wrap gap-2",class:_vm.showTabPedido ? 'col-xl-5 col-lg-4' : 'col-xl-9 col-lg-8'},[(!_vm.isRepresentante)?_c('div',{staticClass:"dropdown mr-2"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right nb-megamenu shadow-lg",attrs:{"aria-labelledby":"dropdownConsultas"}},[_c('div',{staticClass:"row px-3 py-2"},[_c('div',{staticClass:"col-md-6 col-12 mb-2"},[_c('div',{staticClass:"nb-menu-category"},[_vm._v("CLIENTES")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item nb-menu-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickConsulta('/consultas/carteiraclientes')}}},[_c('i',{staticClass:"fa fa-users mr-1"}),_vm._v(" Carteira de Clientes\n                ")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item nb-menu-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickConsulta('/consultas/vendas-performance-carteira')}}},[_c('i',{staticClass:"fa fa-line-chart mr-1"}),_vm._v(" Performance Carteira\n                ")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item nb-menu-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickConsulta('/consultas/curvacliente')}}},[_c('i',{staticClass:"fa fa-pie-chart mr-1"}),_vm._v(" Curva ABC de Clientes\n                ")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item nb-menu-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickConsulta('/consultas/vendas-por-cliente')}}},[_c('i',{staticClass:"fa fa-user mr-1"}),_vm._v(" Vendas por Cliente\n                ")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item nb-menu-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickConsulta('/consultas/lista-clientes')}}},[_c('i',{staticClass:"fa fa-list mr-1"}),_vm._v(" Listagem de Clientes\n                ")]),_vm._v(" "),_c('div',{staticClass:"nb-menu-category mt-3"},[_vm._v("VENDEDORES")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item nb-menu-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickConsulta('/consultas/vendas-vendedor')}}},[_c('i',{staticClass:"fa fa-trophy mr-1"}),_vm._v(" Ranking de Vendedores\n                ")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item nb-menu-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickConsulta('/consultas/vendas')}}},[_c('i',{staticClass:"fa fa-search mr-1"}),_vm._v(" Consulta Vendas\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12 mb-2"},[_c('div',{staticClass:"nb-menu-category"},[_vm._v("PRODUTOS & ESTOQUE")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item nb-menu-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickConsulta('/consultas/vendas-produtos')}}},[_c('i',{staticClass:"fa fa-tag mr-1"}),_vm._v(" Produtos Vendidos\n                ")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item nb-menu-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickConsulta('/consultas/entrada-e-saida')}}},[_c('i',{staticClass:"fa fa-exchange mr-1"}),_vm._v(" Movimentação (E/S)\n                ")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item nb-menu-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickConsulta('/consultas/resumo-entrada-e-saida')}}},[_c('i',{staticClass:"fa fa-bar-chart mr-1"}),_vm._v(" Resumo Movimentação\n                ")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item nb-menu-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickConsulta('/consultas/estoque-saldo')}}},[_c('i',{staticClass:"fa fa-cubes mr-1"}),_vm._v(" Saldo em Estoque\n                ")]),_vm._v(" "),_c('div',{staticClass:"nb-menu-category mt-3"},[_vm._v("PEDIDOS")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item nb-menu-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickConsulta('/consultas/vendas-pedidos-produto')}}},[_c('i',{staticClass:"fa fa-shopping-cart mr-1"}),_vm._v(" Pedidos por Produto\n                ")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item nb-menu-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickConsulta('/consultas/vendas-pedidos-faturados')}}},[_c('i',{staticClass:"fa fa-check mr-1"}),_vm._v(" Pedidos Faturados\n                ")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item nb-menu-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickConsulta('/consultas/vendas-pedidos-comissao-por-pedido')}}},[_c('i',{staticClass:"fa fa-percent mr-1"}),_vm._v(" Comissão por Pedido\n                ")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item nb-menu-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clickConsulta('/consultas/vendas-pedido-recebimentos')}}},[_c('i',{staticClass:"fa fa-credit-card mr-1"}),_vm._v(" Recebimentos Cartão\n                ")])])])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn nb-btn-primary mr-1",attrs:{"type":"button","title":"Criar novo pedido"},on:{"click":_vm.handleNovoPedido}},[_c('i',{staticClass:"fa fa-plus mr-1"}),_vm._v(" Novo Pedido\n        ")]),_vm._v(" "),(_vm.showBtnEmitirNfe)?_c('button',{staticClass:"btn nb-btn-success",attrs:{"type":"button","title":"Emitir nova NF-e"},on:{"click":function($event){return _vm.clickConsulta('/nf/novo')}}},[_c('i',{staticClass:"fa fa-file-text mr-1"}),_vm._v(" Emitir NF-e\n        ")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.showTabPedido && _vm.showDashboardVendas)?_c('div',{staticClass:"w-100",class:!_vm.hasGuiaUnchecked || !_vm.guia ? 'order-0' : 'order-1'},[_c('div',{staticClass:"row"},[_c('dash-card',{attrs:{"params":_vm.dashboard.items[1],"filter":_vm.filter},on:{"clickbutton":_vm.handleClickCard}}),_vm._v(" "),_c('dash-card',{attrs:{"params":_vm.dashboard.items[0],"filter":_vm.filter},on:{"clickbutton":_vm.handleClickCard}}),_vm._v(" "),_c('dash-card',{attrs:{"params":_vm.dashboard.items[2],"filter":_vm.filter},on:{"clickbutton":_vm.handleClickCard}}),_vm._v(" "),_c('dash-card',{attrs:{"params":_vm.dashboard.items[3],"filter":_vm.filter},on:{"clickbutton":_vm.handleClickCard}}),_vm._v(" "),_c('dash-card',{attrs:{"params":_vm.dashboard.items[4],"filter":_vm.filter},on:{"clickbutton":_vm.handleClickCard}}),_vm._v(" "),_c('dash-card',{attrs:{"params":_vm.dashboard.items[5],"filter":_vm.filter},on:{"clickbutton":_vm.handleClickCard}})],1)]):_vm._e(),_vm._v(" "),(_vm.showTabGuiaNFe)?_c('div',{class:_vm.hasGuiaUnchecked && _vm.guia ? 'order-0' : 'order-1'},[_c('dashboard-guia-nfe')],1):_vm._e(),_vm._v(" "),(_vm.showTabGuiaForcaVendas)?_c('div',{class:_vm.hasGuiaUnchecked && _vm.guia ? 'order-0' : 'order-1'},[_c('dashboard-guia-forcavendas')],1):_vm._e(),_vm._v(" "),(_vm.showTabNFe && (_vm.appNFe || _vm.appERP))?_c('div',[_c('dashboard-nfe',{attrs:{"filter-prop":_vm.filter}})],1):_vm._e(),_vm._v(" "),(_vm.showTabVarejo)?_c('div',[_c('dashboard-varejo',{attrs:{"filter-prop":_vm.filter}})],1):_vm._e()]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn nb-btn-secondary dropdown-toggle",attrs:{"type":"button","id":"dropdownConsultas","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"fa fa-bolt text-warning mr-1"}),_vm._v(" Consultas\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_vue__ = __webpack_require__(471);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c46daac8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_vue__ = __webpack_require__(1311);
function injectStyle (ssrContext) {
  __webpack_require__(1306)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c46daac8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1307);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("cf63479a", content, true, {});

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}", ""]);

// exports


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1309);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4f7dcdfa", content, true, {});

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.chart && _vm.show)?_c('div',[_c('GChart',{attrs:{"type":_vm.params.chart.type,"data":_vm.params.values,"options":_vm.chartOptions}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full-width default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":_vm.handleCloseFiltro}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("CONSULTA VENDAS")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 p-5"},[_c('div',{staticClass:"col-6"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}})],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoResumo),expression:"tipoResumo"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio1","value":"1"},domProps:{"checked":_vm._q(_vm.tipoResumo,"1")},on:{"change":function($event){_vm.tipoResumo="1"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio1"}},[_vm._v("Não agrupar")])])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoResumo),expression:"tipoResumo"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio2","value":"2"},domProps:{"checked":_vm._q(_vm.tipoResumo,"2")},on:{"change":function($event){_vm.tipoResumo="2"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio2"}},[_vm._v("Agrupar por usuário")])])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoResumo),expression:"tipoResumo"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio3","value":"3"},domProps:{"checked":_vm._q(_vm.tipoResumo,"3")},on:{"change":function($event){_vm.tipoResumo="3"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio3"}},[_vm._v("Agrupar por cliente")])])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoResumo),expression:"tipoResumo"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio4","value":"4"},domProps:{"checked":_vm._q(_vm.tipoResumo,"4")},on:{"change":function($event){_vm.tipoResumo="4"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio4"}},[_vm._v("Agrupar por grupo de cliente")])])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoResumo),expression:"tipoResumo"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio5","value":"5"},domProps:{"checked":_vm._q(_vm.tipoResumo,"5")},on:{"change":function($event){_vm.tipoResumo="5"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio5"}},[_vm._v("Agrupar por estado")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.detalheVendas.length > 0)?_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_vm._v("\n            RESUMO DAS VENDAS\n            "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadResumo(true)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100",attrs:{"id":"relatorio"}},[_c('thead',[_c('tr',{staticStyle:{"height":"37px"}},[_vm._m(0),_vm._v(" "),_vm._l((_vm.resumoVendas.meses),function(col,index){return _c('th',{key:index,staticClass:"numerico header",attrs:{"title":""}},[_vm._v(" "+_vm._s(col)+" "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})])}),_vm._v(" "),_vm._m(1)],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.resumoVendas.vendas),function(row,index){return _c('tr',{key:index,staticStyle:{"height":"37px"}},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.label))]),_vm._v(" "),_vm._l((row.valores),function(val,index){return _c('td',{key:index,staticClass:"numerico",attrs:{"title":""}},[_vm._v(" "+_vm._s(_vm._f("formatValue")(val,2))+" "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})])}),_vm._v(" "),_c('td',{staticClass:"numerico",attrs:{"title":""}},[_vm._v(" "+_vm._s(_vm._f("formatValue")(row.total,2))+" "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})])],2)}),0)])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[(_vm.chartValues.length > 0)?_c('div',{staticClass:"col-12"},[_c('chart',{attrs:{"params":_vm.paramsChart}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_vm._v("\n            PEDIDOS\n            "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadResumo(true)}}})],1),_vm._v(" "),(_vm.detalheVendas.length == 0)?_c('div',{staticClass:"col-12"},[_vm._v("\n            Nenhuma venda encontrada\n        ")]):_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100",attrs:{"id":"relatorio"}},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.detalheVendas),function(row,index){return _c('tr',{key:index,staticStyle:{"height":"37px"}},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.npedido))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatData")(row.data)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.nome))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.cidade))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.uf))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(row.total_com_imposto,2)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.nome_usuario))])])}),0)])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"textual header",staticStyle:{"width":"15%"},attrs:{"title":""}},[_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"numerico header",attrs:{"title":""}},[_vm._v(" Total "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"height":"37px"}},[_c('th',{staticClass:"textual header",staticStyle:{"width":"5%"},attrs:{"title":""}},[_vm._v("Pedido")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"5%"},attrs:{"title":""}},[_vm._v("Data")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"10%"},attrs:{"title":""}},[_vm._v("Cliente")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"10%"},attrs:{"title":""}},[_vm._v("Cidade")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"2%"},attrs:{"title":""}},[_vm._v("Estado")]),_vm._v(" "),_c('th',{staticClass:"numerico header",staticStyle:{"width":"6%"},attrs:{"title":""}},[_vm._v("Total do Pedido")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"10%"},attrs:{"title":""}},[_vm._v("Nome Usuário")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_curva_cliente_vue__ = __webpack_require__(473);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b511139_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_curva_cliente_vue__ = __webpack_require__(1315);
function injectStyle (ssrContext) {
  __webpack_require__(1313)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_curva_cliente_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b511139_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_curva_cliente_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1314);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4d8208bf", content, true, {});

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}.consulta__total{display:flex;align-items:center;justify-content:center}.consulta__total_valor{font-size:40px;display:block;line-height:normal}.consulta__cifrao{font-size:16px;display:block;line-height:normal}.resumo__performance{display:flex;align-items:center;justify-content:space-between}.resumo__performance__value{padding:5px 15px;font-size:18px;font-weight:600;text-align:left;border-radius:10%}", ""]);

// exports


/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full-width default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":_vm.handleCloseFiltro}}),_vm._v(" "),_c('div',{staticClass:"row mb-3 p-3"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("CURVA ABC DE CLIENTES")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}})],1)]),_vm._v(" "),(_vm.chartValues.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12 p-3"},[_c('span',{staticClass:"lbl-title mb-2"},[_vm._v("Resumo")]),_vm._v(" "),_c('div',{staticClass:"p-4",staticStyle:{"border-top":"1px solid #dee2e6 !important","background":"#fafafa"}},[_c('div',{staticClass:"resumo__performance my-5"},[_c('span',{staticClass:"lbl-data mr-2"},[_vm._v("Valor total em pedidos")]),_vm._v(" "),_c('span',{staticClass:"resumo__performance__value"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.dados.total,2)))])]),_vm._v(" "),_c('div',{staticClass:"resumo__performance my-5"},[_c('span',{staticClass:"lbl-data mr-2"},[_vm._v("Total de Clientes")]),_vm._v(" "),(_vm.dados.count_clientes)?_c('span',{staticClass:"resumo__performance__value"},[_vm._v(_vm._s(_vm.dados.count_clientes))]):_c('span',{staticClass:"resumo__performance__value"},[_vm._v("Nenhum")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-12 p-3"},[_c('span',{staticClass:"lbl-title mb-2"},[_vm._v("Gráfico da Quantidade de Clientes")]),_vm._v(" "),_c('div',{staticClass:"p-4",staticStyle:{"border-top":"1px solid #dee2e6 !important"}},[_c('chart',{attrs:{"params":_vm.paramsChart}})],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_vm._v("\n            CLIENTES\n            "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100",attrs:{"id":"relatorio"}},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.clientes.length == 0)?_c('tr',[_c('td',{staticClass:"textual"},[_vm._v("Nenhum cliente encontrado")]),_vm._v(" "),_c('td',{staticClass:"textual"}),_vm._v(" "),_c('td',{staticClass:"textual"}),_vm._v(" "),_c('td',{staticClass:"textual"}),_vm._v(" "),_c('td',{staticClass:"textual"}),_vm._v(" "),_c('td',{staticClass:"numerico"}),_vm._v(" "),_c('td',{staticClass:"numerico"})]):_vm._l((_vm.clientes),function(row,index){return _c('tr',{key:index,staticStyle:{"height":"37px"}},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.nome))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(row.cnpjcpf)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.cidade))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.uf))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.curva))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valor,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.participacao_valor,2)))])])})],2)])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"height":"37px"}},[_c('th',{staticClass:"textual header",staticStyle:{"width":"20%"},attrs:{"title":""}},[_vm._v("Cliente")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"5%"},attrs:{"title":""}},[_vm._v("CNPJ/CPF")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"10%"},attrs:{"title":""}},[_vm._v("Cidade")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"2%"},attrs:{"title":""}},[_vm._v("Estado")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"2%"},attrs:{"title":""}},[_vm._v("Curva")]),_vm._v(" "),_c('th',{staticClass:"numerico header",staticStyle:{"width":"6%"},attrs:{"title":""}},[_vm._v("Total Vendido")]),_vm._v(" "),_c('th',{staticClass:"numerico header",staticStyle:{"width":"6%"},attrs:{"title":""}},[_vm._v("% Representação")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_carteira_clientes_vue__ = __webpack_require__(474);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f4eadd8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_carteira_clientes_vue__ = __webpack_require__(1319);
function injectStyle (ssrContext) {
  __webpack_require__(1317)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_carteira_clientes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f4eadd8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_carteira_clientes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1318);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("37139b70", content, true, {});

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}.consulta__total{display:flex;align-items:center;justify-content:center}.consulta__total_valor{font-size:40px;display:block;line-height:normal}.consulta__cifrao{font-size:16px;display:block;line-height:normal}", ""]);

// exports


/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full-width default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":_vm.handleCloseFiltro}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("CARTEIRA DE CLIENTES")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 align-items-center"},[_c('div',{staticClass:"col-md-auto"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('form-field',{ref:"data",attrs:{"type":"date","col":"12","label":"Referência"},model:{value:(_vm.data_referencia),callback:function ($$v) {_vm.data_referencia=$$v},expression:"data_referencia"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}})],1)]),_vm._v(" "),(_vm.chartValues.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-12 p-3"},[_c('span',{staticClass:"lbl-title mb-2"},[_vm._v("Quantidade de Clientes")]),_vm._v(" "),_c('div',{staticClass:"p-4",staticStyle:{"border-top":"1px solid #dee2e6 !important","background":"#fafafa"}},_vm._l((_vm.grafico),function(row,index){return _c('div',{key:index,staticClass:"resumo__performance my-4"},[_c('span',{staticClass:"lbl-data mr-2"},[_vm._v(_vm._s(row.label))]),_vm._v(" "),_c('span',{staticClass:"resumo__performance__value"},[_vm._v(_vm._s(row.value))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-9 col-12 p-3"},[_c('div',{staticClass:"lbl-title mb-2"},[_vm._v("Gráfico")]),_vm._v(" "),_c('div',{staticClass:"border"},[_c('chart',{attrs:{"params":_vm.paramsChart}})],1)])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title mb-2"},[_vm._v("\n            CLIENTES\n            "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100",attrs:{"id":"relatorio"}},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.clientes.length == 0)?_c('tr',[_c('td',{staticClass:"textual"},[_vm._v("Nenhum cliente encontrado")]),_vm._v(" "),_c('td',{staticClass:"textual"}),_vm._v(" "),_c('td',{staticClass:"textual"}),_vm._v(" "),_c('td',{staticClass:"textual"}),_vm._v(" "),_c('td',{staticClass:"textual"}),_vm._v(" "),_c('td',{staticClass:"textual"}),_vm._v(" "),_c('td',{staticClass:"textual"}),_vm._v(" "),_c('td',{staticClass:"numerico"}),_vm._v(" "),_c('td',{staticClass:"numerico"}),_vm._v(" "),_c('td',{staticClass:"textual"}),_vm._v(" "),_c('td',{staticClass:"textual"})]):_vm._l((_vm.clientes),function(row,index){return _c('tr',{key:index,staticStyle:{"height":"37px"}},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.nome)+" "+_vm._s(_vm._f("formatCNPJCPF")(row.cnpjcpf)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_c('span',{class:_vm.statusColor(row.dias_ultimo_pedido)},[_vm._v(" "+_vm._s(row.status)+" ")])]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.uf))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.segmento))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.npedido))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatData")(row.data_pedido)))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.total_pedido,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(row.dias_ultimo_pedido))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatFone")(row.telefone)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.email))])])})],2)])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"height":"37px"}},[_c('th',{staticClass:"textual header",staticStyle:{"width":"15%"},attrs:{"title":""}},[_vm._v("Cliente")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"10%"},attrs:{"title":""}},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"2%"},attrs:{"title":""}},[_vm._v("Estado")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"10%"},attrs:{"title":""}},[_vm._v("Segmento")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"2%"},attrs:{"title":""}},[_vm._v("Nr Pedido")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"6%"},attrs:{"title":""}},[_vm._v("Data Último Pedido")]),_vm._v(" "),_c('th',{staticClass:"numerico header",staticStyle:{"width":"6%"},attrs:{"title":""}},[_vm._v("Total do Pedido")]),_vm._v(" "),_c('th',{staticClass:"numerico header",staticStyle:{"width":"6%"},attrs:{"title":""}},[_vm._v("Nr Dias")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"10%"},attrs:{"title":""}},[_vm._v("Telefone")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"10%"},attrs:{"title":""}},[_vm._v("Email")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_por_produto_vue__ = __webpack_require__(475);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_25ae15e4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_por_produto_vue__ = __webpack_require__(1323);
function injectStyle (ssrContext) {
  __webpack_require__(1321)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_por_produto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_25ae15e4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_por_produto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1322);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2e461b1d", content, true, {});

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}table .size130{min-width:130px}table .total{background:#c1c4c7;border:none}table .var{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative{color:#fff;background:#cd5c5c}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.consulta__total{display:flex;align-items:center;justify-content:center}.consulta__total_valor{font-size:40px;display:block;line-height:normal}.consulta__cifrao{font-size:16px;display:block;line-height:normal}", ""]);

// exports


/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full-width default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":function($event){_vm.showfiltro=false}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("VENDAS POR PRODUTO")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 align-items-center"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}})],1)]),_vm._v(" "),(_vm.chartValues.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12 p-3"},[_c('div',{staticClass:"lbl-title mb-2"},[_vm._v("Gráfico")]),_vm._v(" "),_c('div',{staticClass:"border"},[_c('chart',{attrs:{"params":_vm.paramsChart}})],1)])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title mb-2"},[_vm._v("\n      PRODUTOS\n      "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[(_vm.produtos.length == 0)?_c('div',{staticClass:"col-12"},[_vm._v("\n      Nenhum produto encontrado\n    ")]):_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"border":"none"},attrs:{"colspan":"1"}}),_vm._v(" "),_vm._l((_vm.dados.periodos),function(periodo,index){return _c('th',{key:index,staticClass:"text-center",staticStyle:{"border-bottom":"none","border-left":"1px solid #dee2e6","border-right":"1px solid #dee2e6"},attrs:{"colspan":_vm.colSpan(index)}},[_c('span',[_vm._v(_vm._s(periodo.label))])])})],2),_vm._v(" "),_c('tr',[_vm._l((_vm.colunas),function(col){return [(col.visible)?_c('th',{class:col.class,style:(col.style)},[_vm._v(_vm._s(col.label))]):_vm._e()]})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.produtos),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.produto_descricao))]),_vm._v(" "),_vm._l((_vm.dados.periodos),function(item){return [_c('td',{staticClass:"numerico size130",staticStyle:{"border-left":"1px solid #dee2e6"}},[_vm._v(_vm._s(_vm._f("formatValue")(row[item.nome].quantidade,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico size130"},[_vm._v(_vm._s(_vm._f("formatValue")(row[item.nome].valor,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico size130"},[_vm._v(_vm._s(_vm._f("formatValue")(row[item.nome].participacao_quantidade,2))+"%")]),_vm._v(" "),_c('td',{staticClass:"numerico size130"},[_vm._v(_vm._s(_vm._f("formatValue")(row[item.nome].participacao_valor,2))+"%")]),_vm._v(" "),(item.agrupamento > 1)?_c('td',{staticClass:"numerico size130"},[_c('span',{staticClass:"var",class:_vm.varColor(row[item.nome].variacao_quantidade)},[_vm._v(_vm._s(_vm._f("formatValue")(row[item.nome].variacao_quantidade,2))+"%")])]):_vm._e(),_vm._v(" "),(item.agrupamento > 1)?_c('td',{staticClass:"numerico size130"},[_c('span',{staticClass:"var",class:_vm.varColor(row[item.nome].variacao_valor)},[_vm._v(_vm._s(_vm._f("formatValue")(row[item.nome].variacao_valor,2))+"%")])]):_vm._e()]}),_vm._v(" "),_c('td',{staticClass:"numerico",staticStyle:{"border-left":"1px solid #dee2e6"}},[_vm._v(_vm._s(row.quantidade))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valor,2)))])],2)}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total"},[_vm._v("Total")]),_vm._v(" "),_vm._l((_vm.dados.periodos),function(item){return [_c('th',{staticClass:"numerico size130 total",staticStyle:{"border-left":"1px solid #dee2e6"}},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total[item.nome].quantidade,2)))]),_vm._v(" "),_c('th',{staticClass:"numerico size130 total"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total[item.nome].valor,2)))]),_vm._v(" "),_c('th',{staticClass:"numerico size130 total"}),_vm._v(" "),_c('th',{staticClass:"numerico size130 total"}),_vm._v(" "),(item.agrupamento > 1)?_c('th',{staticClass:"numerico size130 total"},[_c('span',{staticClass:"var",class:_vm.varColor(_vm.dados.total[item.nome].variacao_quantidade)},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total[item.nome].variacao_quantidade,2))+"%")])]):_vm._e(),_vm._v(" "),(item.agrupamento > 1)?_c('th',{staticClass:"numerico size130 total"},[_c('span',{staticClass:"var",class:_vm.varColor(_vm.dados.total[item.nome].variacao_valor)},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total[item.nome].variacao_valor,2))+"%")])]):_vm._e()]}),_vm._v(" "),_c('th',{staticClass:"numerico total",staticStyle:{"border-left":"1px solid #dee2e6"}},[_vm._v(_vm._s(_vm.dados.total.quantidade))]),_vm._v(" "),_c('th',{staticClass:"numerico total"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total.valor,2)))])],2)])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_performance_carteira_vue__ = __webpack_require__(476);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d82774a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_performance_carteira_vue__ = __webpack_require__(1327);
function injectStyle (ssrContext) {
  __webpack_require__(1325)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_performance_carteira_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d82774a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_performance_carteira_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1326);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e32448f2", content, true, {});

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}table .size130{min-width:130px}table .total{background:#c1c4c7;border:none}table .var{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative{color:#fff;background:#cd5c5c}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.resumo__performance{display:flex;align-items:center;justify-content:space-between}.resumo__performance__value{padding:5px 15px;font-size:18px;font-weight:600;text-align:left;border-radius:10%}", ""]);

// exports


/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full-width default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":_vm.handleCloseFiltro}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("PERFORMANCE DA CARTEIRA DE CLIENTES NO PERÍODO")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 align-items-center"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}})],1)]),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.clientes.length > 0)?_c('div',{staticClass:"row"},[(_vm.chartValues.length > 0)?_c('div',{staticClass:"col-md-4 col-12 p-3"},[_c('span',{staticClass:"lbl-title mb-2"},[_vm._v("Resumo dos Clientes")]),_vm._v(" "),_c('div',{staticClass:"p-4",staticStyle:{"border-top":"1px solid #dee2e6 !important","background":"#fafafa"}},[_c('span',{staticClass:"lbl-edit mb-5"},[_vm._v("Dos clientes que compraram esse mês:")]),_vm._v(" "),_vm._l((_vm.grafico),function(row,index){return _c('div',{key:index},[_c('div',{staticClass:"resumo__performance mb-3"},[_c('span',{staticClass:"lbl-data"},[_vm._v(_vm._s(row.label))]),_vm._v(" "),_c('span',{staticClass:"resumo__performance__value mr-2",style:(_vm.colorStatus(row.status))},[_vm._v(_vm._s(_vm._f("formatValue")(row.value,0))+"%")])])])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-12 p-3"},[_c('div',{staticClass:"lbl-title mb-2"},[_vm._v("Gráfico")]),_vm._v(" "),_c('div',{staticStyle:{"border-top":"1px solid #dee2e6 !important"}},[_c('chart',{attrs:{"params":_vm.paramsChart}})],1)])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title mb-2"},[_vm._v("\n      CLIENTES\n      "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[(_vm.clientes.length == 0)?_c('div',{staticClass:"col-12"},[_vm._v("\n        Nenhum cliente encontrado\n    ")]):_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"border":"none"},attrs:{"colspan":"1"}}),_vm._v(" "),_vm._l((_vm.dados.periodos),function(periodo,index){return _c('th',{key:index,staticClass:"text-center",staticStyle:{"border-bottom":"none","border-left":"1px solid #dee2e6","border-right":"1px solid #dee2e6"},attrs:{"colspan":_vm.colSpan(index)}},[_c('span',[_vm._v(_vm._s(periodo.label))])])})],2),_vm._v(" "),_c('tr',[_vm._l((_vm.colunas),function(col){return [(col.visible)?_c('th',{class:col.class,style:(col.style)},[_vm._v(_vm._s(col.label))]):_vm._e()]})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.clientes),function(row,index){return _c('tr',{key:index},[(_vm.colunas[0].visible)?_c('td',{},[_vm._v(_vm._s(row.nome))]):_vm._e(),_vm._v(" "),(_vm.colunas[1].visible)?_c('td',{},[_vm._v(_vm._s(row.id))]):_vm._e(),_vm._v(" "),(_vm.colunas[2].visible)?_c('td',{},[_vm._v(_vm._s(row.fantasia))]):_vm._e(),_vm._v(" "),(_vm.colunas[3].visible)?_c('td',{},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(row.cnpjcpf)))]):_vm._e(),_vm._v(" "),(_vm.colunas[4].visible)?_c('td',{},[_vm._v(_vm._s(row.uf))]):_vm._e(),_vm._v(" "),(_vm.colunas[5].visible)?_c('td',{},[_vm._v(_vm._s(_vm._f("formatData")(row.ultimo_pedido)))]):_vm._e(),_vm._v(" "),(_vm.colunas[6].visible)?_c('td',{},[_vm._v(_vm._s(row.npedido))]):_vm._e(),_vm._v(" "),(_vm.colunas[7].visible)?_c('td',{},[_vm._v(_vm._s(_vm._f("formatData")(row.penultimo_pedido)))]):_vm._e(),_vm._v(" "),(_vm.colunas[8].visible)?_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(row.dias_sem_comprar))]):_vm._e(),_vm._v(" "),(_vm.colunas[8].visible)?_c('td',{},[_vm._v(_vm._s(row.descricao_status))]):_vm._e(),_vm._v(" "),(_vm.colunas[9].visible)?_c('td',{},[_vm._v(_vm._s(_vm._f("formatFone")(row.telefone)))]):_vm._e(),_vm._v(" "),(_vm.colunas[10].visible)?_c('td',{},[_vm._v(_vm._s(row.email))]):_vm._e(),_vm._v(" "),(_vm.colunas[11].visible)?_c('td',{},[_vm._v(_vm._s(row.segmento))]):_vm._e(),_vm._v(" "),(_vm.colunas[12].visible)?_c('td',{},[_vm._v(_vm._s(row.nome_usuario))]):_vm._e()])}),0)])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 p-3"},[_c('div',{staticClass:"border p-2"},[_c('span',[_c('i',{staticClass:"fa fa-exclamation"}),_vm._v(" Relação dos clientes que foram reativados no período informado")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_por_cliente_vue__ = __webpack_require__(477);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_28231112_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_por_cliente_vue__ = __webpack_require__(1331);
function injectStyle (ssrContext) {
  __webpack_require__(1329)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_por_cliente_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_28231112_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_por_cliente_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1330);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("506e70ad", content, true, {});

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}table .size130{min-width:130px}table .total{background:#c1c4c7;border:none}table .var{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative{color:#fff;background:#cd5c5c}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.consulta__total{display:flex;align-items:center;justify-content:center}.consulta__total_valor{font-size:40px;display:block;line-height:normal}.consulta__cifrao{font-size:16px;display:block;line-height:normal}", ""]);

// exports


/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full-width default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":_vm.filtroCancel}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("VENDAS POR CLIENTE")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 align-items-center"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}})],1)]),_vm._v(" "),(_vm.chartValues.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12 p-3"},[_c('div',{staticClass:"lbl-title mb-2"},[_vm._v("Gráfico")]),_vm._v(" "),_c('div',{staticClass:"border"},[_c('chart',{attrs:{"params":_vm.paramsChart}})],1)])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title mb-2"},[_vm._v("\n      CLIENTES\n      "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[(_vm.produtos.length == 0)?_c('div',{staticClass:"col-12"},[_vm._v("\n      Nenhum cliente encontrado\n    ")]):_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"border":"none"},attrs:{"colspan":"1"}}),_vm._v(" "),_vm._l((_vm.dados.periodos),function(periodo,index){return _c('th',{key:index,staticClass:"text-center",staticStyle:{"border-bottom":"none","border-left":"1px solid #dee2e6","border-right":"1px solid #dee2e6"},attrs:{"colspan":_vm.colSpan(index)}},[_c('span',[_vm._v(_vm._s(periodo.label))])])})],2),_vm._v(" "),_c('tr',[_vm._l((_vm.colunas),function(col){return [(col.visible)?_c('th',{class:col.class,style:(col.style)},[_vm._v(_vm._s(col.label))]):_vm._e()]})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.produtos),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.nome_cliente))]),_vm._v(" "),_vm._l((_vm.dados.periodos),function(item){return [_c('td',{staticClass:"numerico size130",staticStyle:{"border-left":"1px solid #dee2e6"}},[_vm._v(_vm._s(row[item.nome].qt_produtos_diferentes))]),_vm._v(" "),_c('td',{staticClass:"numerico size130"},[_vm._v(_vm._s(_vm._f("formatValue")(row[item.nome].valor,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico size130"},[_vm._v(_vm._s(_vm._f("formatValue")(row[item.nome].participacao_valor,2))+"%")]),_vm._v(" "),(item.agrupamento > 1)?_c('td',{staticClass:"numerico size130"},[_c('span',{staticClass:"var",class:_vm.varColor(row[item.nome].variacao_valor)},[_vm._v(_vm._s(_vm._f("formatValue")(row[item.nome].variacao_valor,2))+"%")])]):_vm._e()]}),_vm._v(" "),_c('td',{staticClass:"numerico",staticStyle:{"border-left":"1px solid #dee2e6"}},[_vm._v(_vm._s(_vm._f("formatValue")(row.valor,2)))])],2)}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total"},[_vm._v("Total")]),_vm._v(" "),_vm._l((_vm.dados.periodos),function(item){return [_c('th',{staticClass:"numerico size130 total",staticStyle:{"border-left":"1px solid #dee2e6"}},[_vm._v(_vm._s(_vm.dados.total[item.nome].qt_produtos_diferentes))]),_vm._v(" "),_c('th',{staticClass:"numerico size130 total"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total[item.nome].valor,2)))]),_vm._v(" "),_c('th',{staticClass:"numerico size130 total"}),_vm._v(" "),(item.agrupamento > 1)?_c('th',{staticClass:"numerico size130 total"},[_c('span',{staticClass:"var",class:_vm.varColor(_vm.dados.total[item.nome].variacao_valor)},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total[item.nome].variacao_valor,2))+"%")])]):_vm._e()]}),_vm._v(" "),_c('th',{staticClass:"numerico total",staticStyle:{"border-left":"1px solid #dee2e6"}},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total.valor,2)))])],2)])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_vendedor_vue__ = __webpack_require__(478);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_a99a5324_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_vendedor_vue__ = __webpack_require__(1335);
function injectStyle (ssrContext) {
  __webpack_require__(1333)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_vendedor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_a99a5324_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_vendedor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1334);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1ccb0c26", content, true, {});

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}table .size130{min-width:130px}table .total{background:#c1c4c7;border:none}table .var{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative{color:#fff;background:#cd5c5c}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.resumo__performance{display:flex;align-items:center;justify-content:space-between}.resumo__performance__value{padding:5px 15px;font-size:18px;font-weight:600;text-align:left;border-radius:10%}", ""]);

// exports


/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full-width default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":_vm.handleCloseFiltro}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("PERFORMANCE DE VENDAS POR VENDEDOR")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Metas de Venda"},on:{"click":_vm.clickMetas}}),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 align-items-center"},[_c('div',{staticClass:"col-md-auto"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("Período")]),_vm._v(" "),_c('input-month',{attrs:{"p-month":_vm.filter,"show-options":false},on:{"monthChange":_vm.handleMonthChange}})],1)])]),_vm._v(" "),(_vm.chartValues.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-12 p-3"},[_c('span',{staticClass:"lbl-title mb-2"},[_vm._v("Resumo do Mês")]),_vm._v(" "),_c('div',{staticClass:"p-4",staticStyle:{"border-top":"1px solid #dee2e6 !important","background":"#fafafa"}},[_c('div',{staticClass:"resumo__performance mb-2"},[_c('span',{staticClass:"lbl-data mr-2"},[_vm._v("Vendido no mês")]),_vm._v(" "),_c('span',{staticClass:"resumo__performance__value"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dadosGrafico.vendido_mes,2)))])]),_vm._v(" "),_c('div',{staticClass:"resumo__performance mb-4"},[_c('span',{staticClass:"lbl-data mr-2"},[_vm._v("Vendido hoje")]),_vm._v(" "),_c('span',{staticClass:"resumo__performance__value"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dadosGrafico.vendido_hoje,2)))])]),_vm._v(" "),_c('div',{staticClass:"resumo__performance mb-4"},[_c('span',{staticClass:"lbl-data mr-2"},[_vm._v("Vendido no mês anterior")]),_vm._v(" "),_c('span',{staticClass:"resumo__performance__value"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dadosGrafico.vendido_mes_anterior,2)))])]),_vm._v(" "),_c('div',{staticClass:"resumo__performance mb-4"},[_c('span',{staticClass:"lbl-data mr-2"},[_vm._v("Meta")]),_vm._v(" "),(_vm.dadosGrafico.meta_mes)?_c('span',{staticClass:"resumo__performance__value"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dadosGrafico.meta_mes,2)))]):_c('span',{staticClass:"resumo__performance__value"},[_vm._v("Não definida")])]),_vm._v(" "),(_vm.dadosGrafico.objetivo_dia)?_c('div',{staticClass:"resumo__performance mb-4"},[_c('span',{staticClass:"lbl-data mr-2"},[_vm._v("Objetivo Diário")]),_vm._v(" "),_c('span',{staticClass:"resumo__performance__value"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dadosGrafico.objetivo_dia,2)))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-9 col-12 p-3"},[_c('div',{staticClass:"lbl-title mb-2"},[_vm._v("Gráfico")]),_vm._v(" "),_c('div',{staticStyle:{"border-top":"1px solid #dee2e6 !important"}},[_c('chart',{attrs:{"params":_vm.paramsChart}})],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title mb-2"},[_vm._v("\n      USUÁRIOS/VENDEDORES\n      "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100"},[_c('thead',[_c('tr',[_vm._l((_vm.colunas),function(col){return [(col.visible)?_c('th',{class:col.class,style:(col.style)},[_vm._v(_vm._s(col.label))]):_vm._e()]})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.usuarios),function(row,index){return _c('tr',{key:index},[(_vm.colunas[0].visible)?_c('td',{attrs:{"title":"Visualizar este usuário"}},[(!_vm.filtroUsuario)?_c('a',{attrs:{"href":'#/consultas/vendas-vendedor?usuario=' + row.id + '&datareferencia=' + _vm.data_referencia}},[_vm._v(_vm._s(row.nome_usuario)+" "),_c('i',{staticClass:"fa fa-search",attrs:{"aria-hidden":"true"}})]):_c('span',[_vm._v(_vm._s(row.nome_usuario))])]):_vm._e(),_vm._v(" "),(_vm.colunas[1].visible)?_c('td',{},[_vm._v(_vm._s(row.posicao))]):_vm._e(),_vm._v(" "),(_vm.colunas[2].visible)?_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.meta_valor,2)))]):_vm._e(),_vm._v(" "),(_vm.colunas[3].visible)?_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valor,2)))]):_vm._e(),_vm._v(" "),(_vm.colunas[4].visible)?_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.meta_percentual,2))+"%")]):_vm._e(),_vm._v(" "),(_vm.colunas[5].visible)?_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.orcamentos_valor,2)))]):_vm._e()])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"total"},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"numerico total"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total.meta_valor,2)))]),_vm._v(" "),_c('th',{staticClass:"numerico total"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total.valor,2)))]),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"numerico total"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total.orcamentos_valor,2)))])])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_pedidos_produto_vue__ = __webpack_require__(479);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_a42e6492_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_pedidos_produto_vue__ = __webpack_require__(1339);
function injectStyle (ssrContext) {
  __webpack_require__(1337)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_pedidos_produto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_a42e6492_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_pedidos_produto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1338);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("26141356", content, true, {});

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}table .size130{min-width:130px}table .total{background:#c1c4c7;border:none}table .var{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative{color:#fff;background:#cd5c5c}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.resumo__performance{display:flex;align-items:center;justify-content:space-between}.resumo__performance__value{padding:5px 15px;font-size:18px;font-weight:600;text-align:left;border-radius:10%}", ""]);

// exports


/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":function($event){_vm.showfiltro=false}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("PEDIDOS POR PRODUTO")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 align-items-center"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title mb-2"},[_vm._v("\n      PRODUTOS E PEDIDOS\n      "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[(!_vm.dados || _vm.dados.length == 0)?_c('div',{staticClass:"mb-5"},[_c('h6',[_vm._v("Não há vendas para o período")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.dados),function(produto,index){return _c('div',{key:index,staticClass:"mb-5"},[_c('h6',[_vm._v(_vm._s(produto.produto_descricao))]),_vm._v(" "),_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100"},[_c('thead',[_c('tr',[_vm._l((_vm.colunas),function(col){return [(col.visible)?_c('th',{class:col.class,style:(col.style)},[_vm._v(_vm._s(col.label))]):_vm._e()]})],2)]),_vm._v(" "),_c('tbody',_vm._l((produto.pedidos),function(row,index){return _c('tr',{key:index},[(_vm.colunas[0].visible)?_c('td',{},[_vm._v(_vm._s(row.npedido))]):_vm._e(),_vm._v(" "),(_vm.colunas[1].visible)?_c('td',{},[_vm._v(_vm._s(_vm._f("formatData")(row.data)))]):_vm._e(),_vm._v(" "),(_vm.colunas[2].visible)?_c('td',{},[_vm._v(_vm._s(row.nome_cliente))]):_vm._e(),_vm._v(" "),(_vm.colunas[3].visible)?_c('td',{},[_vm._v(_vm._s(row.nome_usuario))]):_vm._e(),_vm._v(" "),(_vm.colunas[4].visible)?_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.quantidade,2)))]):_vm._e(),_vm._v(" "),(_vm.colunas[5].visible)?_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.preco_sem_imposto,2)))]):_vm._e(),_vm._v(" "),(_vm.colunas[6].visible)?_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.total_com_imposto,2)))]):_vm._e(),_vm._v(" "),(_vm.colunas[7].visible)?_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.total_sem_imposto,2)))]):_vm._e()])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total"},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"numerico size130 total"},[_vm._v(_vm._s(_vm._f("formatValue")(produto.quantidade,2)))]),_vm._v(" "),_c('th',{staticClass:"numerico size130 total"},[_vm._v(_vm._s(_vm._f("formatValue")(produto.preco_sem_imposto,2)))]),_vm._v(" "),_c('th',{staticClass:"numerico size130 total"},[_vm._v(_vm._s(_vm._f("formatValue")(produto.total_com_imposto,2)))]),_vm._v(" "),_c('th',{staticClass:"numerico size130 total"},[_vm._v(_vm._s(_vm._f("formatValue")(produto.total_sem_imposto,2)))])])])])])})],2)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_listagem_clientes_vue__ = __webpack_require__(480);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c33c6fe_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_listagem_clientes_vue__ = __webpack_require__(1343);
function injectStyle (ssrContext) {
  __webpack_require__(1341)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_listagem_clientes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c33c6fe_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_listagem_clientes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1342);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("8ea79d92", content, true, {});

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}table .size130{min-width:130px}table .total{background:#c1c4c7;border:none}table .var{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative{color:#fff;background:#cd5c5c}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.resumo__performance{display:flex;align-items:center;justify-content:space-between}.resumo__performance__value{padding:5px 15px;font-size:18px;font-weight:600;text-align:left;border-radius:10%}", ""]);

// exports


/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":_vm.handleCloseFiltro}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("LISTAGEM DE CLIENTES")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 align-items-center"},[_c('div',{staticClass:"col-md-12 col-12 mb-3"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 p-3"},[_c('div',{staticClass:"border p-3",staticStyle:{"background":"#f1f1f1"}},[_vm._m(0),_vm._v(" "),_vm._l((_vm.colunas),function(col,idx){return _c('div',{key:idx,staticClass:"form-check form-check-inline",staticStyle:{"min-width":"15%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(col.visible),expression:"col.visible"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"idx","value":"option1"},domProps:{"checked":Array.isArray(col.visible)?_vm._i(col.visible,"option1")>-1:(col.visible)},on:{"change":function($event){var $$a=col.visible,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="option1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(col, "visible", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(col, "visible", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(col, "visible", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"inlineCheckbox1"}},[_vm._v(_vm._s(col.label))])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title mb-2"},[_vm._v("\n      CLIENTES\n      "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100"},[_c('thead',[_c('tr',[_vm._l((_vm.colunas),function(col){return [(col.visible)?_c('th',{class:col.class,style:(col.style)},[_vm._v(_vm._s(col.label))]):_vm._e()]})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dados.items),function(row,index){return _c('tr',{key:index},[(_vm.colunas[0].visible)?_c('td',{class:_vm.colunas[0].class,style:(_vm.colunas[0].style)},[_vm._v(_vm._s(row.razao))]):_vm._e(),_vm._v(" "),(_vm.colunas[1].visible)?_c('td',{class:_vm.colunas[1].class,style:(_vm.colunas[1].style)},[_vm._v(_vm._s(row.fantasia))]):_vm._e(),_vm._v(" "),(_vm.colunas[2].visible)?_c('td',{class:_vm.colunas[2].class,style:(_vm.colunas[2].style)},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(row.cnpjcpf)))]):_vm._e(),_vm._v(" "),(_vm.colunas[3].visible)?_c('td',{class:_vm.colunas[3].class,style:(_vm.colunas[3].style)},[_vm._v(_vm._s(row.iest))]):_vm._e(),_vm._v(" "),(_vm.colunas[4].visible)?_c('td',{class:_vm.colunas[4].class,style:(_vm.colunas[4].style)},[_vm._v(_vm._s(row.endereco))]):_vm._e(),_vm._v(" "),(_vm.colunas[5].visible)?_c('td',{class:_vm.colunas[5].class,style:(_vm.colunas[5].style)},[_vm._v(_vm._s(row.bairro))]):_vm._e(),_vm._v(" "),(_vm.colunas[6].visible)?_c('td',{class:_vm.colunas[6].class,style:(_vm.colunas[6].style)},[_vm._v(_vm._s(row.cidade))]):_vm._e(),_vm._v(" "),(_vm.colunas[7].visible)?_c('td',{class:_vm.colunas[7].class,style:(_vm.colunas[7].style)},[_vm._v(_vm._s(row.uf))]):_vm._e(),_vm._v(" "),(_vm.colunas[8].visible)?_c('td',{class:_vm.colunas[8].class,style:(_vm.colunas[8].style)},[_vm._v(_vm._s(row.cep))]):_vm._e(),_vm._v(" "),(_vm.colunas[9].visible)?_c('td',{class:_vm.colunas[9].class,style:(_vm.colunas[9].style)},[_vm._v(_vm._s(row.nome_usuario))]):_vm._e(),_vm._v(" "),(_vm.colunas[10].visible)?_c('td',{class:_vm.colunas[10].class,style:(_vm.colunas[10].style)},[_vm._v(_vm._s(row.nome_segmento))]):_vm._e(),_vm._v(" "),(_vm.colunas[11].visible)?_c('td',{class:_vm.colunas[11].class,style:(_vm.colunas[11].style)},[_vm._v(_vm._s(row.nome_grupo))]):_vm._e(),_vm._v(" "),(_vm.colunas[12].visible)?_c('td',{class:_vm.colunas[12].class,style:(_vm.colunas[12].style)},_vm._l((row.telefones),function(fone,index){return _c('span',{key:index},[_vm._v(_vm._s(_vm._f("formatFone")(fone))),_c('br')])}),0):_vm._e(),_vm._v(" "),(_vm.colunas[13].visible)?_c('td',{class:_vm.colunas[13].class,style:(_vm.colunas[13].style)},_vm._l((row.emails),function(email,index){return _c('span',{key:index},[_vm._v(_vm._s(_vm._f("formatFone")(email))),_c('br')])}),0):_vm._e()])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total"},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"numerico total"},[_vm._v(_vm._s(_vm.dados.length))]),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"})])])])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 mb-2"},[_c('span',[_vm._v("Selecione as colunas visíveis")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_pedidos_faturados_vue__ = __webpack_require__(481);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bcf9c10_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_pedidos_faturados_vue__ = __webpack_require__(1347);
function injectStyle (ssrContext) {
  __webpack_require__(1345)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_pedidos_faturados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bcf9c10_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_pedidos_faturados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1346);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6a04d71d", content, true, {});

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}table .size130{min-width:130px}table .total{background:#c1c4c7;border:none}table .var{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative{color:#fff;background:#cd5c5c}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.resumo__performance{display:flex;align-items:center;justify-content:space-between}.resumo__performance__value{padding:5px 15px;font-size:18px;font-weight:600;text-align:left;border-radius:10%}", ""]);

// exports


/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":function($event){_vm.showfiltro=false}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("PEDIDOS FATURADOS")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 align-items-center"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title mb-2"},[_vm._v("\n      PEDIDOS\n      "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100"},[_c('thead',[_c('tr',[_vm._l((_vm.colunas),function(col){return [(col.visible)?_c('th',{class:col.class,style:(col.style)},[_vm._v(_vm._s(col.label))]):_vm._e()]})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dados.items),function(row,index){return _c('tr',{key:index},[(_vm.colunas[0].visible)?_c('td',{class:_vm.colunas[0].class,style:(_vm.colunas[0].style)},[_vm._v(_vm._s(row.npedido))]):_vm._e(),_vm._v(" "),(_vm.colunas[1].visible)?_c('td',{class:_vm.colunas[1].class,style:(_vm.colunas[1].style)},[_vm._v(_vm._s(_vm._f("formatData")(row.data)))]):_vm._e(),_vm._v(" "),(_vm.colunas[2].visible)?_c('td',{class:_vm.colunas[2].class,style:(_vm.colunas[2].style)},[_vm._v(_vm._s(row.razao))]):_vm._e(),_vm._v(" "),(_vm.colunas[3].visible)?_c('td',{class:_vm.colunas[3].class,style:(_vm.colunas[3].style)},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(row.cnpjcpf)))]):_vm._e(),_vm._v(" "),(_vm.colunas[4].visible)?_c('td',{class:_vm.colunas[4].class,style:(_vm.colunas[4].style)},[_vm._v(_vm._s(row.uf))]):_vm._e(),_vm._v(" "),(_vm.colunas[5].visible)?_c('td',{class:_vm.colunas[5].class,style:(_vm.colunas[5].style)},[_vm._v(_vm._s(row.nome_usuario))]):_vm._e(),_vm._v(" "),(_vm.colunas[6].visible)?_c('td',{class:_vm.colunas[6].class,style:(_vm.colunas[6].style)},[_vm._v(_vm._s(_vm._f("formatValue")(row.total_pedido,2)))]):_vm._e(),_vm._v(" "),(_vm.colunas[7].visible)?_c('td',{class:_vm.colunas[7].class,style:(_vm.colunas[7].style)},[_vm._v(_vm._s(_vm._f("formatValue")(row.total_faturado,2)))]):_vm._e(),_vm._v(" "),(_vm.colunas[8].visible)?_c('td',{class:_vm.colunas[8].class,style:(_vm.colunas[8].style)},[_vm._v(_vm._s(_vm._f("formatValue")(row.total_aberto,2)))]):_vm._e(),_vm._v(" "),(_vm.colunas[9].visible)?_c('td',{class:_vm.colunas[9].class,style:(_vm.colunas[9].style)},[_vm._v(_vm._s(row.nf))]):_vm._e(),_vm._v(" "),(_vm.colunas[10].visible)?_c('td',{class:_vm.colunas[10].class,style:(_vm.colunas[10].style)},[_vm._v(_vm._s(_vm._f("formatData")(row.datanf)))]):_vm._e()])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total"},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"numerico total"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total.total_pedido,2)))]),_vm._v(" "),_c('th',{staticClass:"numerico total"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total.total_faturado,2)))]),_vm._v(" "),_c('th',{staticClass:"numerico total"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total.total_aberto,2)))]),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"})])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_comissao_por_pedido_vue__ = __webpack_require__(482);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c2f8787_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_comissao_por_pedido_vue__ = __webpack_require__(1351);
function injectStyle (ssrContext) {
  __webpack_require__(1349)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_vendas_comissao_por_pedido_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c2f8787_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_vendas_comissao_por_pedido_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1350);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("81d26994", content, true, {});

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}table .size130{min-width:130px}table .total{background:#c1c4c7;border:none}table .var{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative{color:#fff;background:#cd5c5c}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.resumo__performance{display:flex;align-items:center;justify-content:space-between}.resumo__performance__value{padding:5px 15px;font-size:18px;font-weight:600;text-align:left;border-radius:10%}", ""]);

// exports


/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":function($event){_vm.showfiltro=false}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("COMISSÃO POR PEDIDO")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 align-items-center"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title mb-2"},[_vm._v("\n      PEDIDOS\n      "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100"},[_c('thead',[_c('tr',[_vm._l((_vm.colunas),function(col){return [(col.visible)?_c('th',{class:col.class,style:(col.style)},[_vm._v(_vm._s(col.label))]):_vm._e()]})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dados.items),function(row,index){return _c('tr',{key:index},[(_vm.colunas[0].visible)?_c('td',{class:_vm.colunas[0].class,style:(_vm.colunas[0].style)},[_vm._v(_vm._s(row.npedido))]):_vm._e(),_vm._v(" "),(_vm.colunas[1].visible)?_c('td',{class:_vm.colunas[1].class,style:(_vm.colunas[1].style)},[_vm._v(_vm._s(_vm._f("formatData")(row.data)))]):_vm._e(),_vm._v(" "),(_vm.colunas[2].visible)?_c('td',{class:_vm.colunas[2].class,style:(_vm.colunas[2].style)},[_vm._v(_vm._s(row.razao))]):_vm._e(),_vm._v(" "),(_vm.colunas[3].visible)?_c('td',{class:_vm.colunas[3].class,style:(_vm.colunas[3].style)},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(row.cnpjcpf)))]):_vm._e(),_vm._v(" "),(_vm.colunas[4].visible)?_c('td',{class:_vm.colunas[4].class,style:(_vm.colunas[4].style)},[_vm._v(_vm._s(row.uf))]):_vm._e(),_vm._v(" "),(_vm.colunas[5].visible)?_c('td',{class:_vm.colunas[5].class,style:(_vm.colunas[5].style)},[_vm._v(_vm._s(row.nome_usuario))]):_vm._e(),_vm._v(" "),(_vm.colunas[6].visible)?_c('td',{class:_vm.colunas[6].class,style:(_vm.colunas[6].style)},[_vm._v(_vm._s(row.vendedor_nome))]):_vm._e(),_vm._v(" "),(_vm.colunas[7].visible)?_c('td',{class:_vm.colunas[7].class,style:(_vm.colunas[7].style)},[_vm._v(_vm._s(_vm._f("formatValue")(row.total_pedido,2)))]):_vm._e(),_vm._v(" "),(_vm.colunas[8].visible)?_c('td',{class:_vm.colunas[8].class,style:(_vm.colunas[8].style)},[_vm._v(_vm._s(_vm._f("formatValue")(row.base_comissao,2)))]):_vm._e(),_vm._v(" "),(_vm.colunas[9].visible)?_c('td',{class:_vm.colunas[9].class,style:(_vm.colunas[9].style)},[_vm._v(_vm._s(_vm._f("formatValue")(row.total_comissao,2)))]):_vm._e(),_vm._v(" "),(_vm.colunas[10].visible)?_c('td',{class:_vm.colunas[10].class,style:(_vm.colunas[10].style)},[_vm._v(_vm._s(_vm._f("formatValue")(row.percentual_comissao,2)))]):_vm._e()])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total"},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"numerico total"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total.total_pedido,2)))]),_vm._v(" "),_c('th',{staticClass:"numerico total"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total.base_comissao,2)))]),_vm._v(" "),_c('th',{staticClass:"numerico total"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total.total_comissao,2)))]),_vm._v(" "),_c('th',{staticClass:"numerico total"})])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_varejo_movimento_caixa_vue__ = __webpack_require__(483);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d7ae47c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_varejo_movimento_caixa_vue__ = __webpack_require__(1355);
function injectStyle (ssrContext) {
  __webpack_require__(1353)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_varejo_movimento_caixa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d7ae47c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_varejo_movimento_caixa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1354);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e8a5a54a", content, true, {});

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}table .size130{min-width:130px}table .size100{width:100px}table .total{background:#c1c4c7;border:none}table .var{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative{color:#fff;background:#cd5c5c}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.consulta__total{display:flex;align-items:center;justify-content:center}.consulta__total_valor{font-size:40px;display:block;line-height:normal}.consulta__cifrao{font-size:16px;display:block;line-height:normal}", ""]);

// exports


/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full-width default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":function($event){_vm.showfiltro = false}}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 align-items-center"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[(!_vm.caixasPeriodo || _vm.caixasPeriodo.lista.length == 0)?_c('div',{staticClass:"col-12"},[_vm._v("\n      Nenhum movimento encontrado\n    ")]):_c('div',{staticClass:"col-md-8"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-bordered table-sm responsive w-100"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.caixasPeriodo.lista),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatDataHora")(row.dataabertura)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.operadorabertura))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valorabertura,2)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.status))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.operadorfechamento))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatDataHora")(row.datafechamento)))])])}),0)])])])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[(!_vm.formasPagamento || _vm.formasPagamento.lista.length == 0)?_c('div',{staticClass:"col-12"},[_vm._v("\n      Nenhum movimento encontrado\n    ")]):_c('div',{staticClass:"col-md-8"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-bordered table-sm responsive w-100"},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.formasPagamento.lista),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.descricao))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valor,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.taxas,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valorliquido,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.perc,2)))])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total",attrs:{"colspan":"1"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.formasPagamento.total,2))+" ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.formasPagamento.totaltaxas,2))+" ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.formasPagamento.totalliquido,2))+" ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(100,2))+" ")])])])])])])]),_vm._v(" "),(_vm.formasPagamento.lista.length > 0)?_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"border"},[_c('chart',{attrs:{"params":_vm.paramsChartFormas}})],1)]):_vm._e()]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[(_vm.movimentosCaixa && _vm.movimentosCaixa.lista.length == 0)?_c('div',{staticClass:"col-12"},[_vm._v("\n      Nenhum movimento encontrado para o período\n    ")]):_vm._e(),_vm._v(" "),(_vm.movimentosCaixa && _vm.movimentosCaixa.lista.length)?_c('div',{staticClass:"col-md-8"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-bordered table-sm responsive w-100"},[_vm._m(6),_vm._v(" "),_c('tbody',_vm._l((_vm.movimentosCaixa.lista),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual text-center"},[_c('a',{staticClass:"text-center",on:{"click":function($event){return _vm.handleShowCaixa(row.codvabertura)}}},[_vm._v("Detalhar caixa")])]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatDataHora")(row.data)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.tipo))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.obs))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valor,2)))])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total",attrs:{"colspan":"3"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.movimentosCaixa.total,2))+" ")])])])])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n      Devoluções\n    ")]),_vm._v(" "),(_vm.devolucoes && _vm.devolucoes.lista.length)?_c('div',{staticClass:"col-12"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[(!_vm.devolucoes || _vm.devolucoes.lista.length == 0)?_c('div',{staticClass:"col-12"},[_vm._v("\n      Nenhum movimento encontrado\n    ")]):_c('div',{staticClass:"col-md-8"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-bordered table-sm responsive w-100"},[_vm._m(7),_vm._v(" "),_c('tbody',_vm._l((_vm.devolucoes.lista),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatDataHora")(row.data)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.operador))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valor,2)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(row.cnpjcpf)))])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total",attrs:{"colspan":"3"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.devolucoes.total,2))+" ")]),_vm._v(" "),_c('th',{staticClass:"text-right total"})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n      Descontos Concedidos\n    ")]),_vm._v(" "),(_vm.descontos && _vm.descontos.lista.length)?_c('div',{staticClass:"col-12"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[(!_vm.descontos || _vm.descontos.lista.length == 0)?_c('div',{staticClass:"col-12"},[_vm._v("\n      Nenhum movimento encontrado\n    ")]):_c('div',{staticClass:"col-md-8"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-bordered table-sm responsive w-100"},[_vm._m(8),_vm._v(" "),_c('tbody',_vm._l((_vm.descontos.lista),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.npedido))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatDataHora")(row.data)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.operador))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.desconto,2)))])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total",attrs:{"colspan":"3"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.descontos.total,2))+" ")]),_vm._v(" "),_c('th',{staticClass:"text-right total"})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n      Resumo das Vendas Por Grupo de PRODUTOS\n    ")]),_vm._v(" "),(_vm.resumoVendas && _vm.resumoVendas.lista.length > 0)?_c('div',{staticClass:"col-12"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[(!_vm.resumoVendas || _vm.resumoVendas.lista.length == 0)?_c('div',{staticClass:"col-12"},[_vm._v("\n      Nenhum produto encontrado\n    ")]):_vm._e(),_vm._v(" "),(_vm.resumoVendas && _vm.resumoVendas.lista.length > 0)?_c('div',{staticClass:"col-md-8"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-bordered table-sm responsive w-100"},[_vm._m(9),_vm._v(" "),_c('tbody',_vm._l((_vm.resumoVendas.lista),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.descricao))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.qt,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valor,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.perc,2))+" %")])])}),0)])])])]):_vm._e(),_vm._v(" "),(_vm.resumoVendas.lista.length > 0)?_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"border"},[_c('chart',{attrs:{"params":_vm.paramsChartResumo}})],1)]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("CONSULTA CONTROLE DO CAIXA")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n      ABERTURAS DE CAIXA DO PERÍODO\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  Data da Abertura\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  Operador Abertura\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Valor na Abertura\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  Status\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  Operador Fechamento\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  Data do Fechamento\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n      Recebimentos por Forma de Pagamento\n    ")]),_vm._v(" "),_c('div',{staticClass:"col-12"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  Descrição\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Valor\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Taxas (-)\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Valor Líquido\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  %\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n      MOVIMENTOS DO CAIXA\n    ")]),_vm._v(" "),_c('div',{staticClass:"col-12"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  Data\n                ")]),_vm._v(" "),_c('th',{staticClass:"textual",attrs:{"colspan":"1"}},[_vm._v("\n                  Descrição\n                ")]),_vm._v(" "),_c('th',{staticClass:"textual",attrs:{"colspan":"1"}},[_vm._v("\n                  Observações\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Valor\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  Data da Abertura\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  Operador\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Valor\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  CNPJ/CPF\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"numerico",attrs:{"colspan":"1"}},[_vm._v("\n                  Número do Pedido/Mesa\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  Data da Abertura\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  Operador\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Valor Desconto\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"textual",attrs:{"colspan":"1"}},[_vm._v("\n                  Descrição\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Quantidade\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Valor\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  %\n                ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1357);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3cfe589c", content, true, {});

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}table .size130{min-width:130px}table .size100{width:100px}table .total{background:#c1c4c7;border:none}table .var{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative{color:#fff;background:#cd5c5c}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.consulta__total{display:flex;align-items:center;justify-content:center}.consulta__total_valor{font-size:40px;display:block;line-height:normal}.consulta__cifrao{font-size:16px;display:block;line-height:normal}", ""]);

// exports


/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_varejo_pendcli_det_vue__ = __webpack_require__(486);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_87ffc692_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_varejo_pendcli_det_vue__ = __webpack_require__(1361);
function injectStyle (ssrContext) {
  __webpack_require__(1359)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_varejo_pendcli_det_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_87ffc692_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_varejo_pendcli_det_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1360);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("44f5c2be", content, true, {});

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}table .size130{min-width:130px}table .size100{width:100px}table .total{background:#c1c4c7;border:none}table .var{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative{color:#fff;background:#cd5c5c}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.consulta__total{display:flex;align-items:center;justify-content:center}.consulta__total_valor{font-size:40px;display:block;line-height:normal}.consulta__cifrao{font-size:16px;display:block;line-height:normal}.bottom-center{position:absolute;bottom:0;left:0}", ""]);

// exports


/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full-width default-container p-3"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-10 lbl-title"},[_vm._v("\n      CLIENTE: "+_vm._s(_vm.detalhe.nome)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_c('v-button',{attrs:{"label":"Voltar","success":false},on:{"click":_vm.handleClose}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[(!_vm.detalhe || !_vm.detalhe.detalhes || _vm.detalhe.detalhes.length == 0)?_c('div',{staticClass:"col-12"},[_vm._v("\n      Nenhum movimento encontrado\n    ")]):_vm._e()]),_vm._v(" "),(_vm.detalhe || _vm.detalhe.detalhes || _vm.detalhe.detalhes.length != 0)?_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-2 lbl-title"},[_c('div',{staticClass:"d-flex flex-column"},[_c('span',{staticClass:"mr-2"},[_vm._v("Valor do Pagamento")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"d-flex justify-content-start align-items-start",staticStyle:{"gap":"30px"}},[_c('input-value',{ref:"valorpagamento",staticClass:"vd-input",attrs:{"precision":2},model:{value:(_vm.valorPagamento),callback:function ($$v) {_vm.valorPagamento=$$v},expression:"valorPagamento"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('v-button',{staticClass:"bottom-center",attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleEnterPaymentValue}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"default-container position-relative"},[(_vm.detalhe.detalhes.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.detalhe.detalhes),function(item,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box d-flex flex-wrap"},[_c('div',{staticClass:"col-3"},[(index == 0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Data"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatDataHora")(item.data)))])],1),_vm._v(" "),_c('div',{staticClass:"col-3"},[(index == 0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Nr.Documento"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.doc)+" ")])],1),_vm._v(" "),_c('div',{staticClass:"col-3"},[(index == 0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Vencimento"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatDataHora")(item.dtv)))])],1),_vm._v(" "),_c('div',{staticClass:"col-3 text-right"},[(index == 0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Valor"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(item.vlr,2)))])],1)])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full-width default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":function($event){_vm.showfiltro = false}}}),_vm._v(" "),_vm._m(0),_vm._v(" "),(!_vm.showDetalhe)?_c('hr'):_vm._e(),_vm._v(" "),(!_vm.showDetalhe)?_c('div',{staticClass:"row mb-3 align-items-center"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}})],1)]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.showDetalhe)?_c('div',{staticClass:"default-container position-relative"},[(_vm.dados.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.dados),function(item,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box d-flex flex-wrap"},[_c('div',{staticClass:"col-md-6 col-6"},[(index == 0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Cliente"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.nome)+" ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2 text-right"},[(index == 0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Quantidade"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(item.qt,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2 text-right"},[(index == 0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Valor"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(item.valor,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2 align-items-right ml-auto"},[_c('bar-grid',{attrs:{"obj":item,"options":_vm.handleBarGrid(item),"moreActions":_vm.getActions(item)},on:{"action":_vm.handleAction,"view":function($event){return _vm.handleView(item)}}})],1)])])})],2):_vm._e(),_vm._v(" "),(_vm.showDetalhe)?_c('ConsultaVarejoPendcliDet',{attrs:{"detalhe":this.detalhe,"codvabertura":this.codvabertura},on:{"closeform":_vm.closeView}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("CONSULTA CONTROLE PENDENCIAS CLIENTE")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_metavendas_form_vue__ = __webpack_require__(487);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3ef31d2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_metavendas_form_vue__ = __webpack_require__(1366);
function injectStyle (ssrContext) {
  __webpack_require__(1364)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_metavendas_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3ef31d2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_metavendas_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1365);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5e12b559", content, true, {});

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',{attrs:{"id":"list"}},[_c('div',{staticClass:"border mb-2",staticStyle:{"padding":"15px 0px 0 15px","background":"#fff"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12 def-title mb-2"},[_vm._v("\n                    METAS DE VENDA POR USUÁRIO/VENDEDOR\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12 text-right"},[_c('v-button',{attrs:{"label":"Salvar","nb-btdef":true},on:{"click":_vm.handleSalvar}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.handleCancelar}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-4 mb-2"},[_c('input-month',{attrs:{"p-month":_vm.filter,"show-options":false},on:{"monthChange":_vm.handleMonthChange}})],1)])]),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-hover responsive tablesorter w-100"},[_c('thead',[_c('tr',[_vm._l((_vm.colunas),function(col){return [_c('th',{class:col.class,style:(col.style)},[_vm._v(_vm._s(col.label))])]})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dados.usuarios),function(row,index){return _c('tr',{key:index},[_c('td',{class:_vm.colunas[0].class,style:(_vm.colunas[0].style)},[_vm._v(_vm._s(row.nome))]),_vm._v(" "),_vm._l((row.valores),function(valor){return [_c('th',{staticStyle:{"min-width":"130px"}},[_c('input-value',{staticClass:"form-control form-control-sm",attrs:{"precision":2},on:{"blur":function($event){return _vm.blurValores(valor.mes)}},model:{value:(valor.valor_meta),callback:function ($$v) {_vm.$set(valor, "valor_meta", $$v)},expression:"valor.valor_meta"}})],1)]})],2)}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total"},[_vm._v("Total")]),_vm._v(" "),_vm._l((_vm.total),function(tot){return [_c('th',{staticClass:"numerico total"},[_c('span',[_vm._v(_vm._s(_vm._f("formatValue")(tot,2)))])])]})],2)])])])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_recebimentos_pedido_vue__ = __webpack_require__(488);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb3ec9f2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_recebimentos_pedido_vue__ = __webpack_require__(1370);
function injectStyle (ssrContext) {
  __webpack_require__(1368)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_recebimentos_pedido_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb3ec9f2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_recebimentos_pedido_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1369);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b08fb240", content, true, {});

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}table .size130{min-width:130px}table .total{background:#c1c4c7;border:none}table .var{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative{color:#fff;background:#cd5c5c}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.resumo__performance{display:flex;align-items:center;justify-content:space-between}.resumo__performance__value{padding:5px 15px;font-size:18px;font-weight:600;text-align:left;border-radius:10%}", ""]);

// exports


/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":function($event){_vm.showfiltro=false}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("Status dos Pedidos")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 align-items-center"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title mb-2"},[_vm._v("\n      PEDIDOS\n      "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100"},[_c('thead',[_c('tr',[_vm._l((_vm.colunas),function(col){return [(col.visible)?_c('th',{class:col.class,style:(col.style)},[_vm._v(_vm._s(col.label))]):_vm._e()]})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dados.items),function(row,index){return _c('tr',{key:index},[(_vm.colunas[0].visible)?_c('td',{class:_vm.colunas[0].class,style:(_vm.colunas[0].style)},[_vm._v(_vm._s(row.npedido))]):_vm._e(),_vm._v(" "),(_vm.colunas[1].visible)?_c('td',{class:_vm.colunas[1].class,style:(_vm.colunas[1].style)},[_vm._v(_vm._s(_vm._f("formatData")(row.data)))]):_vm._e(),_vm._v(" "),(_vm.colunas[2].visible)?_c('td',{class:_vm.colunas[2].class,style:(_vm.colunas[2].style)},[_vm._v(_vm._s(row.razao))]):_vm._e(),_vm._v(" "),(_vm.colunas[3].visible)?_c('td',{class:_vm.colunas[3].class,style:(_vm.colunas[3].style)},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(row.cnpjcpf)))]):_vm._e(),_vm._v(" "),(_vm.colunas[4].visible)?_c('td',{class:_vm.colunas[4].class,style:(_vm.colunas[4].style)},[_vm._v(_vm._s(row.uf))]):_vm._e(),_vm._v(" "),(_vm.colunas[5].visible)?_c('td',{class:_vm.colunas[5].class,style:(_vm.colunas[5].style)},[_vm._v(_vm._s(row.nome_usuario))]):_vm._e(),_vm._v(" "),(_vm.colunas[6].visible)?_c('td',{class:_vm.colunas[6].class,style:(_vm.colunas[6].style)},[_vm._v(_vm._s(row.status))]):_vm._e(),_vm._v(" "),(_vm.colunas[7].visible)?_c('td',{class:_vm.colunas[7].class,style:(_vm.colunas[7].style)},[_vm._v(_vm._s(_vm._f("formatValue")(row.total_pedido,2)))]):_vm._e()])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total"},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),_c('th',{staticClass:"total"}),_vm._v(" "),(_vm.dados && _vm.dados.total && _vm.dados.total.total_pedido)?_c('th',{staticClass:"numerico total"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.total.total_pedido,2)))]):_vm._e()])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_estoque_produto_vue__ = __webpack_require__(489);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bbe4288_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_estoque_produto_vue__ = __webpack_require__(1380);
function injectStyle (ssrContext) {
  __webpack_require__(1372)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_estoque_produto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bbe4288_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_estoque_produto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1373);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("678e2386", content, true, {});

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}table .size130{min-width:130px}table .total{background:#c1c4c7;border:none}table .var{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative{color:#fff;background:#cd5c5c}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.consulta__total{display:flex;align-items:center;justify-content:center}.consulta__total_valor{font-size:24px;display:block;line-height:normal}.consulta__cifrao{font-size:16px;display:block;line-height:normal}", ""]);

// exports


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1375);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("c61c95d6", content, true, {});

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[(_vm.ajuste)?_c('div',{staticClass:"col-12 def-title"},[_vm._v("\n      Ajuste de Estoque\n    ")]):_vm._e(),_vm._v(" "),(_vm.transferencia)?_c('div',{staticClass:"col-12 def-title"},[_vm._v("\n      Transferência de Depósito\n    ")]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row pl-5"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.mest.coditem}}),_vm._v(" "),_c('div',{},[_c('input-item',{ref:"item",on:{"onselect":_vm.handleSelecionaItem},model:{value:(_vm.coditem),callback:function ($$v) {_vm.coditem=$$v},expression:"coditem"}})],1)],1)]),_vm._v(" "),(_vm.item.isgrade && _vm.item.isgrade === 'S')?_c('div',{staticClass:"row pl-5"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.mest.coditemgrade}}),_vm._v(" "),_c('div',{},[_c('form-field',{attrs:{"type":"select2","col":"4","select2":{ entity: '/grades/item/' + _vm.item.coditem, minlength: 0 }},model:{value:(_vm.coditemgrade),callback:function ($$v) {_vm.coditemgrade=$$v},expression:"coditemgrade"}})],1)],1)]):_vm._e(),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row pl-5"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('label',{staticClass:"lbl-edit w-100"},[_vm._v("Depósito")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.estoque.descricao))])]),_vm._v(" "),(_vm.estoque.linha && _vm.estoque.linha !== '')?_c('div',{staticClass:"col-md-12 col-12"},[_c('label',{staticClass:"lbl-edit w-100"},[_vm._v("Linha(Grade)")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.estoque.linha))])]):_vm._e(),_vm._v(" "),(_vm.estoque.coluna && _vm.estoque.coluna !== '')?_c('div',{staticClass:"col-md-12 col-12"},[_c('label',{staticClass:"lbl-edit w-100"},[_vm._v("Coluna(Grade)")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.estoque.coluna))])]):_vm._e(),_vm._v(" "),(_vm.dadosEstoqueItem.controlalocal)?_c('div',{staticClass:"col-md-12 col-12"},[_c('label',{staticClass:"lbl-edit w-100"},[_vm._v("Local")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.estoque.local))])]):_vm._e(),_vm._v(" "),(_vm.dadosEstoqueItem.controlalote)?_c('div',{staticClass:"col-md-12 col-12"},[_c('label',{staticClass:"lbl-edit w-100"},[_vm._v("Identificação do Lote")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.estoque.lote))])]):_vm._e(),_vm._v(" "),(_vm.dadosEstoqueItem.controlalote)?_c('div',{staticClass:"col-md-12 col-12"},[_c('label',{staticClass:"lbl-edit w-100"},[_vm._v("Sublote")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.estoque.sublote))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[_c('label',{staticClass:"lbl-edit w-100"},[_vm._v("Quantidade")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.estoque.qt,4)))])])]),_vm._v(" "),(_vm.ajuste)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n      INFORME O TIPO DE AJUSTE E A QUANTIDADE\n    ")])]):_vm._e(),_vm._v(" "),(_vm.ajuste)?_c('div',{staticClass:"row pl-5"},[_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.mest.tpmest},model:{value:(_vm.tipo),callback:function ($$v) {_vm.tipo=$$v},expression:"tipo"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.mest.qt.validator),expression:"metadata.mest.qt.validator"}],attrs:{"type":"value","col":"3","label":"Quantidade do ajuste","precision":2,"name":"qt","v-errors":_vm.errors},model:{value:(_vm.qt),callback:function ($$v) {_vm.qt=$$v},expression:"qt"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 50 }),expression:"{ required: true, max: 50 }"}],attrs:{"type":"text","col":"6","label":"Motivo do ajuste","name":"motivo","v-errors":_vm.errors},model:{value:(_vm.motivo),callback:function ($$v) {_vm.motivo=$$v},expression:"motivo"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(!_vm.codqest && _vm.coditem)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.mest.coddeposito.validator),expression:"metadata.mest.coddeposito.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.mest.coddeposito,"name":"coddeposito","v-errors":_vm.errors},model:{value:(_vm.estoque.coddeposito),callback:function ($$v) {_vm.$set(_vm.estoque, "coddeposito", $$v)},expression:"estoque.coddeposito"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(!_vm.codqest && _vm.coditem && _vm.item && _vm.item.controlalocal == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.mest.local.validator),expression:"metadata.mest.local.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.mest.local,"name":"local","v-errors":_vm.errors},model:{value:(_vm.estoque.local),callback:function ($$v) {_vm.$set(_vm.estoque, "local", $$v)},expression:"estoque.local"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(!_vm.codqest && _vm.coditem && _vm.item && _vm.item.controlalote)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.mest.lote.validator),expression:"metadata.mest.lote.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.mest.lote,"name":"lote","v-errors":_vm.errors},model:{value:(_vm.estoque.lote),callback:function ($$v) {_vm.$set(_vm.estoque, "lote", $$v)},expression:"estoque.lote"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(!_vm.codqest && _vm.coditem && _vm.item && _vm.item.controlalote)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.mest.sublote.validator),expression:"metadata.mest.sublote.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.mest.sublote,"name":"sublote","v-errors":_vm.errors},model:{value:(_vm.estoque.sublote),callback:function ($$v) {_vm.$set(_vm.estoque, "sublote", $$v)},expression:"estoque.sublote"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ajuste && _vm.errmessages.length == 0 && _vm.qt > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('alert',{attrs:{"type":"success","text":_vm.novoSaldo}})],1)]):_vm._e(),_vm._v(" "),(_vm.transferencia)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n      INFORME O DEPÓSITO OU LOCAL DE DESTINO E A QUANTIDADE\n    ")])]):_vm._e(),_vm._v(" "),(_vm.transferencia)?_c('div',{staticClass:"row pl-5"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.mest.coddeposito.validator),expression:"metadata.mest.coddeposito.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.mest.coddeposito,"name":"coddeposito","v-errors":_vm.errors},model:{value:(_vm.coddeposito),callback:function ($$v) {_vm.coddeposito=$$v},expression:"coddeposito"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.item && _vm.item.controlalocal == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.mest.local.validator),expression:"metadata.mest.local.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.mest.local,"name":"local","v-errors":_vm.errors},model:{value:(_vm.local),callback:function ($$v) {_vm.local=$$v},expression:"local"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.mest.qt.validator),expression:"metadata.mest.qt.validator"}],attrs:{"type":"value","col":"2","label":"Quantidade a transferir","precision":2,"name":"qt","v-errors":_vm.errors},model:{value:(_vm.qt),callback:function ($$v) {_vm.qt=$$v},expression:"qt"}}),_vm._v(" "),_c('div',{staticClass:"w-100"})],1):_vm._e(),_vm._v(" "),(_vm.errmessages.length != 0)?_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('validation',{attrs:{"title":"Erros de Validação","messages":_vm.errmessages}})],1)]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-2"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Salvar","nb-btdef":true},on:{"click":_vm.handleSave}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.closeForm}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n      PRODUTO SELECIONADO\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n      LOCAL / LOTE SELECIONADO\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1378);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("f3144f2e", content, true, {});

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".grade-cor{height:40px;padding:10px;width:200px;border-bottom:1px solid #e0e0e0;-webkit-box-shadow:3px 0 10px -4px #d3cdcd;-moz-box-shadow:3px 0 10px -4px #d3cdcd;box-shadow:3px 0 10px -4px #d3cdcd;background-color:#fff;left:0}", ""]);

// exports


/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.params.view)?_c('div',[_c('table',{staticClass:"table table-sm table-bordered table-striped",staticStyle:{"width":"auto"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"grade-cor"}),_vm._v(" "),_vm._l((_vm.colunasHead),function(col,index){return _c('td',{key:index,staticClass:"text-center",staticStyle:{"min-width":"70px"}},[_c('div',{staticStyle:{"text-overflow":"ellipsis","overflow":"hidden"},attrs:{"data-placement":"top","data-original-title":""}},[_vm._v(_vm._s(col.descricao))])])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.grade.linhas),function(row,index){return _c('tr',{key:index},[_c('th',{staticClass:"grade-cor",staticStyle:{"max-width":"200px","heigth":"40px"}},[_c('div',{staticStyle:{"text-overflow":"ellipsis","overflow":"hidden","white-space":"nowrap"},attrs:{"data-placement":"top","data-original-title":"azul"}},[_vm._v(_vm._s(row.descricao))])]),_vm._v(" "),_vm._l((row.colunas),function(col,index){return _c('td',{key:index,staticClass:"text-center",staticStyle:{"max-width":"70px"}},[(!_vm.params.view && col.ativo)?_c('input-number',{ref:"quantidade",refInFor:true,staticClass:"form-control form-control-sm",model:{value:(col.quantidade),callback:function ($$v) {_vm.$set(col, "quantidade", $$v)},expression:"col.quantidade"}}):_vm._e(),_vm._v(" "),(_vm.params.view)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(col.quantidade))]):_vm._e()],1)}),_vm._v(" "),(row.coditemgrade)?_c('td',{staticClass:"text-center",staticStyle:{"max-width":"70px"}},[(!_vm.params.view && row.ativo)?_c('input-number',{ref:"quantidade",refInFor:true,staticClass:"form-control form-control-sm",model:{value:(row.quantidade),callback:function ($$v) {_vm.$set(row, "quantidade", $$v)},expression:"row.quantidade"}}):_vm._e(),_vm._v(" "),(_vm.params.view)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(row.quantidade))]):_vm._e()],1):_vm._e()],2)}),0)])]):_vm._e(),_vm._v(" "),(_vm.params.view)?_c('div',[_c('table',{staticClass:"table table-sm table-bordered table-striped",staticStyle:{"font-size":"11px","margin-left":"0","width":"auto"}},[_c('thead',[_c('tr',[_c('th',{}),_vm._v(" "),_vm._l((_vm.colunasHead),function(col,index){return _c('td',{key:index,staticClass:"text-center"},[_c('div',{staticStyle:{"text-overflow":"ellipsis","overflow":"hidden"}},[_vm._v(_vm._s(col.descricao))])])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.grade.linhas),function(row,index){return _c('tr',{key:index},[_c('th',{staticStyle:{"max-width":"200px"}},[_c('div',{staticStyle:{"text-overflow":"ellipsis","overflow":"hidden","white-space":"nowrap"}},[_vm._v(_vm._s(row.descricao)+"\n            ")])]),_vm._v(" "),_vm._l((row.colunas),function(col,index){return _c('td',{key:index,staticClass:"text-center"},[(_vm.params.view)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(col.quantidade))]):_vm._e()])}),_vm._v(" "),(row.coditemgrade)?_c('td',{staticClass:"text-center"},[(_vm.params.view)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(row.quantidade))]):_vm._e()]):_vm._e()],2)}),0)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full-width default-container p-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("ESTOQUE DO PRODUTO")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[_c('form-field',{attrs:{"type":"select2","col":"6","metadata":_vm.metadata.pedvit.coditem},model:{value:(_vm.coditem),callback:function ($$v) {_vm.coditem=$$v},expression:"coditem"}}),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('v-button',{attrs:{"label":"Mais Filtros","data-toggle":"collapse","data-target":"#maisFiltros","aria-expanded":"false","aria-controls":"maisFiltros"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row collapse align-items-center",attrs:{"id":"maisFiltros"}},[_c('form-field',{attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.codfil},model:{value:(_vm.codfil),callback:function ($$v) {_vm.codfil=$$v},expression:"codfil"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","col":"2","metadata":_vm.metadata.mest.lote},model:{value:(_vm.lote),callback:function ($$v) {_vm.lote=$$v},expression:"lote"}}),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('v-button',{attrs:{"label":"Pesquisar","aria-expanded":"false"},on:{"click":_vm.handlePesquisar}})],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.coditem)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n      ESTOQUE DISPONÍVEL\n      ")])]):_vm._e(),_vm._v(" "),(_vm.coditem && _vm.estoque.length)?_c('div',{staticClass:"row p-3"},[_c('div',{staticClass:"col-md-5 col-sm-6 col-12"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Quantidade Disponível")]),_c('span',{staticClass:"consulta__total_valor"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.estoque.total.estoque_disponivel,4)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 col-sm-6 col-12"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Quantidade")]),_c('span',{staticClass:"consulta__total_valor"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.estoque.total.estoque_quantidade,4)))])])]):_vm._e(),_vm._v(" "),(_vm.coditem && _vm.estoque.length)?_c('div',{staticClass:"row p-3"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Quantidade Alocada")]),_c('span',{staticClass:"consulta__total_valor"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.estoque.total.estoque_alocado,4)))])]),_vm._v(" "),(_vm.dados.controlalote)?_c('div',{staticClass:"col-md-4 col-12"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Quantidade Lotes Bloqueados")]),_c('span',{staticClass:"consulta__total_valor"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.estoque.total.estoque_bloqueado,4)))])]):_vm._e(),_vm._v(" "),(_vm.dados.controlalote)?_c('div',{staticClass:"col-md-4 col-12"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Quantidade Lotes Vencidos")]),_c('span',{staticClass:"consulta__total_valor"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.estoque.total.estoque_vencido,4)))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.coditem && !_vm.estoque.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v("\n      Estoque indisponível para o produto\n    ")])]):_vm._e(),_vm._v(" "),(_vm.coditem)?_c('button',{staticClass:"btn nb-btdef my-3",on:{"click":function($event){return _vm.handleAjustarEstoque(null)}}},[_vm._v("Ajustar Estoque")]):_vm._e(),_vm._v(" "),(_vm.coditem)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n      ESTOQUE DETALHADO POR DEPÓSITOS / LOTES\n    ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.estoque),function(row,index){return _c('div',{key:index,staticClass:"mainbox-select"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Depósito")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(row.descricao))])]),_vm._v(" "),(row.linha && row.linha !== '')?_c('div',{staticClass:"col-md-1 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Linha(Grade)")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(row.linha))])]):_vm._e(),_vm._v(" "),(row.coluna && row.coluna !== '')?_c('div',{staticClass:"col-md-1 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Coluna(Grade)")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(row.coluna))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Qtd. Disponível")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(row.qtdisponivel,4)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Quantidade")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(row.qt,4)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Qtd. Alocada")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(row.qtalocado,4)))])]),_vm._v(" "),(_vm.dados.controlalocal)?_c('div',{staticClass:"col-md-1 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Local")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(row.local))])]):_vm._e(),_vm._v(" "),(_vm.dados.controlalote)?_c('div',{staticClass:"col-md-1 col-2"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Lote")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(row.lote))]),_vm._v(" "),(row.lotebloqueado)?_c('span',{staticClass:"badge badge-yellow",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Lote bloqueado para consumo"}},[_vm._v("Bloqueado")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.dados.controlalote)?_c('div',{staticClass:"col-md-1 col-2"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Sublote")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(row.sublote))])]):_vm._e(),_vm._v(" "),(_vm.dados.controlalote)?_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Validade")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(row.dtval)))]),_vm._v(" "),(row.lotevencido)?_c('span',{staticClass:"badge badge-yellow",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Lote com data de validade expirada"}},[_vm._v("Vencido")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-auto col-12"},[_c('bar-grid',{attrs:{"options":{ barDefault: true, btnView: false },"moreActions":_vm.getActions(row)},on:{"action":_vm.handleActionItem}})],1)]),_vm._v(" "),(_vm.dados.controlalote)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},attrs:{"data-toggle":"collapse","data-target":'#detalheLote' + index,"aria-expanded":"false","aria-controls":'detalheLote' + index}},[_vm._v("Detalhar")])])]):_vm._e(),_vm._v(" "),(_vm.dados.controlalote)?_c('div',{staticClass:"row collapse",attrs:{"id":'detalheLote' + index}},[_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Dias Validade")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(row.diasvalidade))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Lote Fornecedor")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(row.loteforn))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Fornecedor do lote")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(row.loteforn))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Data de Entrada")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(row.loteforn))])])]):_vm._e()])])}),_vm._v(" "),(!_vm.coditem)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title mb-2"},[_vm._v("\n      Selecione um Produto\n      ")])]):_vm._e(),_vm._v(" "),(_vm.showGradeItem)?_c('div',{staticClass:"row col"},[_c('span',{staticClass:"lbl-title-produto mb-3"},[_vm._v("Estoque em Grade")]),_vm._v(" "),_c('div',{staticClass:"row col"},[_c('grade-estoque',{ref:"grade-estoque",attrs:{"params":{ view: true, coditem: this.coditem }}})],1)]):_vm._e(),_vm._v(" "),(_vm.coditem)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12 lbl-title"},[_vm._v("\n      MOVIMENTOS\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('input-month',{attrs:{"p-month":_vm.filtroPeriodo,"show-options":true},on:{"monthChange":_vm.handleMonthChange}})],1)]):_vm._e(),_vm._v(" "),(_vm.coditem && _vm.movimento.length)?_c('div',{staticClass:"row p-3"},[_c('div',{staticClass:"col-md-5 col-sm-7 col-12"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Total de Entradas no Período")]),_c('span',{staticClass:"consulta__total_valor"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.movimentos.total.entradas,4)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 col-sm-5 col-12"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Total de Saídas no Período")]),_c('span',{staticClass:"consulta__total_valor"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.movimentos.total.saidas,4)))])])]):_vm._e(),_vm._v(" "),(_vm.coditem)?_c('div',{staticClass:"row mb-5"},[(_vm.movimento.length == 0)?_c('div',{staticClass:"col-12"},[_vm._v("\n      Sem movimentos para o período\n    ")]):_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100"},[_c('thead',[_c('tr',[_vm._l((_vm.movCols),function(col){return [(col.visible)?_c('th',{class:col.class,style:(col.style)},[_vm._v(_vm._s(col.label))]):_vm._e()]})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.movimento),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatData")(row.data)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.tipo))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm.textTipoDocumento(row.tipodocumento))+"\n                  "+_vm._s(row.tipodocumento)+"\n                  "),(row.varejo == 'S')?_c('span',{staticClass:"float-right badge badge-orange"},[_vm._v("Varejo")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.documento)+"\n                  "),(row.tipodocumento == 'AJ')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},attrs:{"data-toggle":"collapse","data-target":'#detalheMovimento' + index,"aria-expanded":"false","aria-controls":'detalheLote' + index}},[_vm._v("Detalhar")])])]):_vm._e(),_vm._v(" "),(row.tipodocumento == 'AJ')?_c('div',{staticClass:"row collapse",attrs:{"id":'detalheMovimento' + index}},[_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Observação")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(row.obs))])])]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"numerico size130"},[_vm._v(_vm._s(_vm._f("formatValue")(row.qt,4)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.coddeposito)+" - "+_vm._s(row.deposito))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.linha))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.coluna))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.lote))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.sublote))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatData")(row.dtval)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.loteforn))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.nome_usuario))])])}),0),_vm._v(" "),_vm._m(0)])])])])]):_vm._e(),_vm._v(" "),(_vm.coditem)?_c('button',{staticClass:"btn nb-btdef mb-3",on:{"click":_vm.showDetalhesAlocacao}},[_vm._v("Ver/Ocultar Detalhes\n    Alocação")]):_vm._e(),_vm._v(" "),(_vm.coditem && _vm.viewDetalhesAlocacao)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12 lbl-title"},[_vm._v("\n      ALOCAÇÃO\n      ")])]):_vm._e(),_vm._v(" "),(_vm.coditem && _vm.alocacao.length && _vm.viewDetalhesAlocacao)?_c('div',{staticClass:"row p-3"},[_c('div',{staticClass:"col-md-5 col-sm-5 col-12"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Quantidade Total Alocada")]),_c('span',{staticClass:"consulta__total_valor"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.dados.movimentos.total_alocacao.saidas,4)))])])]):_vm._e(),_vm._v(" "),(_vm.coditem && _vm.viewDetalhesAlocacao)?_c('div',{staticClass:"row mb-5",attrs:{"id":"alocacao"}},[(_vm.alocacao.length == 0)?_c('div',{staticClass:"col-12"},[_vm._v("\n      Sem alocações para o período\n    ")]):_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100"},[_c('thead',[_c('tr',[_vm._l((_vm.movCols),function(col){return [(col.visible)?_c('th',{class:col.class,style:(col.style)},[_vm._v(_vm._s(col.label))]):_vm._e()]})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.alocacao),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatData")(row.data)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.tipo))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm.textTipoDocumento(row.tipodocumento))+"\n                  "+_vm._s(row.tipodocumento)+"\n                  "),(row.varejo == 'S')?_c('span',{staticClass:"float-right badge badge-orange"},[_vm._v("Varejo")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.documento)+"\n                  "),(row.tipodocumento == 'AJ')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},attrs:{"data-toggle":"collapse","data-target":'#detalheMovimento' + index,"aria-expanded":"false","aria-controls":'detalheLote' + index}},[_vm._v("Detalhar")])])]):_vm._e(),_vm._v(" "),(row.tipodocumento == 'AJ')?_c('div',{staticClass:"row collapse",attrs:{"id":'detalheMovimento' + index}},[_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Observação")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(row.obs))])])]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"numerico size130"},[_vm._v(_vm._s(_vm._f("formatValue")(row.qt,4)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.coddeposito)+" - "+_vm._s(row.deposito))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.lote))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.sublote))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatData")(row.dtval)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.loteforn))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.nome_usuario))])])}),0),_vm._v(" "),_vm._m(1)])])])])]):_vm._e(),_vm._v(" "),(_vm.showAjusteTransferenciaForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"nb-modal-scrollable-container",staticStyle:{"padding":"15px","width":"90%"}},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('estoque-ajuste-transferencia-form',{attrs:{"params":_vm.paramsAjusteTransferencia},on:{"closeform":_vm.closeAjusteForm}})],1)])]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tfoot',[_c('tr')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tfoot',[_c('tr')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1382);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1c28e9b6", content, true, {});

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-2920ee70]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-2920ee70]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-2920ee70]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-2920ee70]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-2920ee70]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-image[data-v-2920ee70]{position:relative;display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;padding:4px;color:#64748b;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;cursor:pointer}.nb-card-image[data-v-2920ee70]:focus-visible{outline:2px solid #004e94;outline-offset:2px}.nb-card-image>img[data-v-2920ee70]{max-width:100%;max-height:100%;object-fit:contain}.nb-card-image>.fa[data-v-2920ee70]{font-size:19px}.nb-card-image-edit[data-v-2920ee70]{position:absolute;right:-5px;bottom:-5px;display:flex;width:18px;height:18px;align-items:center;justify-content:center;color:#fff;background:#004e94;border:2px solid #fff;border-radius:50%;font-size:8px}.nb-card-title[data-v-2920ee70]{flex:1;min-width:0}.nb-card-title-line[data-v-2920ee70]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-2920ee70]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-2920ee70]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-2920ee70]{color:#334155;font-weight:600}.nb-card-badge[data-v-2920ee70]{display:inline-flex;align-items:center;gap:4px;padding:4px 7px;border:1px solid transparent;border-radius:5px;font-size:10px;font-weight:700;line-height:1.2}.nb-card-badge--success[data-v-2920ee70]{color:#166534;background:#f0fdf4;border-color:#bbf7d0}.nb-card-badge--danger[data-v-2920ee70]{color:#991b1b;background:#fef2f2;border-color:#fecaca}.nb-card-actions[data-v-2920ee70]{flex:0 0 auto}.nb-stock-display[data-v-2920ee70]{display:flex;flex-direction:column;align-items:flex-end;text-align:right}.nb-stock-label[data-v-2920ee70]{font-size:11px;color:#64748b}.nb-stock-value[data-v-2920ee70]{font-size:16px;font-weight:700}.nb-stock-value small[data-v-2920ee70]{font-size:11px;color:#64748b;font-weight:500}.nb-card-details[data-v-2920ee70]{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;margin:12px 0 0 60px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-card-detail[data-v-2920ee70]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-card-detail-label[data-v-2920ee70]{color:#64748b;font-size:11px}.nb-card-detail>strong[data-v-2920ee70]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}@media (max-width:767.98px){.nb-card-top[data-v-2920ee70]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-2920ee70]{align-self:flex-start}.nb-stock-display[data-v-2920ee70]{align-items:flex-start;text-align:left}.nb-card-details[data-v-2920ee70]{grid-template-columns:repeat(2,minmax(0,1fr));margin-left:0}}", ""]);

// exports


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1384);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("fbaf9640", content, true, {});

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".imagem-galeria{max-height:80px}.imagem-galeria-loading{height:100%;width:80px;padding-top:30px}.imagem-list{padding:4px;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);-webkit-box-shadow:0 1px 3px rgba(0,0,0,.1);-moz-box-shadow:0 1px 3px rgba(0,0,0,.1);box-shadow:0 1px 3px rgba(0,0,0,.1);margin-right:5px}.imagem-list.active{background-color:#67a0be!important}.imagem-excluir{cursor:pointer;background:#fff;border:1px solid #ccc;padding:4px}.no-image{font-size:72px;color:silver;cursor:pointer}.adicionar-imagem{min-height:100px;width:152px;padding:38px 5px 5px;float:left;font-size:18px;text-align:center;border:1px dashed #bbb;color:#888;background-color:#fff;cursor:pointer}.attach-icon{color:#808080bb}", ""]);

// exports


/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"file",attrs:{"id":"fileInput","type":"file","accept":_vm.fileTypes},on:{"change":function($event){return _vm.handleUpload($event)}}}),_vm._v(" "),(!_vm.params.showform)?_c('div',{staticStyle:{"padding-left":"20px height: 20%"}},_vm._l((_vm.listImages),function(img,index){return _c('div',{key:index,staticClass:"row mb-3 align-items-center"},[_vm._m(0,true),_vm._v(" "),(!img.uploading)?_c('div',{staticClass:"col-md-11"},[_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataExtenso")(img.data)))]),_vm._v(" "),_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(img.usuario_nome))]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('a',{attrs:{"href":img.url}},[_vm._v(" "+_vm._s(img.filename)+" ")])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.handleDelete(index)}}},[_c('i',{staticClass:"fa fa-trash pr-2"}),_vm._v("Remover")])])]):_c('div',{staticClass:"col-md-11"},[_c('span',{staticClass:"lbl-list"},[_vm._v("Salvando...")])])])}),0):_vm._e(),_vm._v(" "),(_vm.params.showform)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container",staticStyle:{"height":"90%","overflow":"auto"}},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body",staticStyle:{"height":"70%"}},[_c('div',{staticClass:"row text-center",staticStyle:{"height":"80%"}},[_c('div',{staticClass:"row align-items-center",staticStyle:{"width":"100%","height":"100%","padding":"10px"}},[(_vm.mainImage)?_c('img',{staticClass:"mx-auto d-block justify-content-center",staticStyle:{"max-height":"100%"},attrs:{"src":_vm.mainImage}}):_vm._e(),_vm._v(" "),(!_vm.mainImage)?_c('i',{staticClass:"fa fa-camera mx-auto d-block no-image",on:{"click":_vm.handleClickAdiciona}}):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row col",staticStyle:{"padding-left":"20px height: 20%"}},[_vm._l((_vm.listImages),function(img,index){return _c('div',{key:index,staticClass:"imagem-list text-center nb-margin-bottom",class:{'active': _vm.selectedIndex == index}},[(!img.coddoc || !img.url)?_c('div',{staticClass:"imagem-galeria-loading"},[_c('div',{staticClass:"spinner-border text-muted"})]):_vm._e(),_vm._v(" "),(img.coddoc && img.url)?_c('img',{staticClass:"imagem-galeria",attrs:{"src":img.url},on:{"click":function($event){return _vm.handleClickGaleria(index)}}}):_vm._e(),_c('br'),_vm._v(" "),(img.coddoc && img.url)?_c('span',{staticClass:"imagem-excluir",on:{"click":function($event){return _vm.handleDelete(index)}}},[_vm._m(1,true)]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"adicionar-imagem nb-margin-bottom",on:{"click":_vm.handleClickAdiciona}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                  Anexar\n              ")])],2)])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-1 text-center"},[_c('i',{staticClass:"fa fa-paperclip attach-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}}),_vm._v(" Remover Imagem ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"xls-button":true,"single-entity":"","plural-entity":"Estoque Atual dos Produtos","title-search":"Pesquise pelo código ou pela descrição do produto"},on:{"search":_vm.search,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.produtos.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.produtos),function(produto,index){return _c('article',{key:produto.coditem || index,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_c('button',{staticClass:"nb-card-image",attrs:{"type":"button","aria-label":'Gerenciar imagem de ' + produto.descricao,"title":"Gerenciar imagem"},on:{"click":function($event){return _vm.handleAnexosForm(produto.coditem, produto.descricao)}}},[(produto.url)?_c('img',{attrs:{"src":produto.url,"alt":""}}):_c('i',{staticClass:"fa fa-camera",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(produto.descricao))]),_vm._v(" "),_c('span',{staticClass:"nb-card-badge",class:produto.saldo_estoque > 0 ? 'nb-card-badge--success' : 'nb-card-badge--danger'},[_vm._v("\n                                    "+_vm._s(produto.saldo_estoque > 0 ? 'Em Estoque' : 'Sem Estoque')+"\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(produto.codigo || '—'))])])])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('div',{staticClass:"nb-stock-display"},[_c('span',{staticClass:"nb-stock-label"},[_vm._v("Saldo")]),_vm._v(" "),_c('span',{staticClass:"nb-stock-value",class:produto.saldo_estoque > 0 ? 'text-success' : 'text-danger'},[_vm._v("\n                                "+_vm._s(_vm._f("formatValue")(produto.saldo_estoque,2))+"\n                                "),(produto.uni)?_c('small',[_vm._v(_vm._s(produto.uni))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"nb-card-details"},[_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Código")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(produto.codigo || '—'))])]),_vm._v(" "),_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Unidade de Medida")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(produto.uni || '—'))])]),_vm._v(" "),_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Saldo de Estoque")]),_vm._v(" "),_c('strong',{class:produto.saldo_estoque > 0 ? 'text-success' : 'text-danger'},[_vm._v("\n                            "+_vm._s(_vm._f("formatValue")(produto.saldo_estoque,2))+" "),(produto.uni)?_c('small',[_vm._v(_vm._s(produto.uni))]):_vm._e()])])])])}),_vm._v(" "),(_vm.nextPage > 0)?_c('div',{staticClass:"text-center my-3"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",on:{"click":function($event){return _vm.handleMore()}}},[_c('i',{staticClass:"fa fa-chevron-down mr-1"}),_vm._v(" Exibir mais produtos\n                ")])]):_vm._e()],2)],1),_vm._v(" "),(_vm.showAnexosForm)?_c('anexos-form',{attrs:{"params":{ ref: 'item', chaveref: _vm.coditem, title: _vm.descricao, showform: true }},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"nb-card-image-edit"},[_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_nfse_vue__ = __webpack_require__(497);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea4f024_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_nfse_vue__ = __webpack_require__(1390);
function injectStyle (ssrContext) {
  __webpack_require__(1388)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_nfse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea4f024_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_nfse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1389);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("f948099c", content, true, {});

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}", ""]);

// exports


/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full-width default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":_vm.handleCloseFiltro}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("CONSULTA SERVIÇOS")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 p-5"},[_c('div',{staticClass:"col-6"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}})],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoResumo),expression:"tipoResumo"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio1","value":"1"},domProps:{"checked":_vm._q(_vm.tipoResumo,"1")},on:{"change":function($event){_vm.tipoResumo="1"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio1"}},[_vm._v("Não agrupar")])])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoResumo),expression:"tipoResumo"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio3","value":"2"},domProps:{"checked":_vm._q(_vm.tipoResumo,"2")},on:{"change":function($event){_vm.tipoResumo="2"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio3"}},[_vm._v("Agrupar por cliente")])])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoResumo),expression:"tipoResumo"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio4","value":"3"},domProps:{"checked":_vm._q(_vm.tipoResumo,"3")},on:{"change":function($event){_vm.tipoResumo="3"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio4"}},[_vm._v("Agrupar por grupo de cliente")])])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoResumo),expression:"tipoResumo"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio5","value":"4"},domProps:{"checked":_vm._q(_vm.tipoResumo,"4")},on:{"change":function($event){_vm.tipoResumo="4"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio5"}},[_vm._v("Agrupar por estado")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.detalheVendas.length > 0)?_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_vm._v("\n      RESUMO SERVIÇOS\n      "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadResumo(true)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100",attrs:{"id":"relatorio"}},[_c('thead',[_c('tr',{staticStyle:{"height":"37px"}},[_vm._m(0),_vm._v(" "),_vm._l((_vm.resumoVendas.meses),function(col,index){return _c('th',{key:index,staticClass:"numerico header",attrs:{"title":""}},[_vm._v("\n                  "+_vm._s(col)+" "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})])}),_vm._v(" "),_vm._m(1)],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.resumoVendas.vendas),function(row,index){return _c('tr',{key:index,staticStyle:{"height":"37px"}},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.label))]),_vm._v(" "),_vm._l((row.valores),function(val,index){return _c('td',{key:index,staticClass:"numerico",attrs:{"title":""}},[_vm._v(" "+_vm._s(_vm._f("formatValue")(val,2))+" "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})])}),_vm._v(" "),_c('td',{staticClass:"numerico",attrs:{"title":""}},[_vm._v(" "+_vm._s(_vm._f("formatValue")(row.total,2))+" "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})])],2)}),0)])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[(_vm.chartValues.length > 0)?_c('div',{staticClass:"col-12"},[_c('chart',{attrs:{"params":_vm.paramsChart}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_vm._v("\n      SERVIÇOS\n      "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadResumo(true)}}})],1),_vm._v(" "),(_vm.detalheVendas.length == 0)?_c('div',{staticClass:"col-12"},[_vm._v("\n      Nenhuma venda encontrada\n    ")]):_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100",attrs:{"id":"relatorio"}},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.detalheVendas),function(row,index){return _c('tr',{key:index,staticStyle:{"height":"37px"}},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.nf))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatData")(row.data)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.nome))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.cidade))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.uf))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(row.total_com_imposto,2)))])])}),0)])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"textual header",staticStyle:{"width":"15%"},attrs:{"title":""}},[_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"numerico header",attrs:{"title":""}},[_vm._v(" Total "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"height":"37px"}},[_c('th',{staticClass:"textual header",staticStyle:{"width":"5%"},attrs:{"title":""}},[_vm._v("Nr. Nota Fiscal")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"5%"},attrs:{"title":""}},[_vm._v("Data")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"10%"},attrs:{"title":""}},[_vm._v("Cliente")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"10%"},attrs:{"title":""}},[_vm._v("Cidade")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"2%"},attrs:{"title":""}},[_vm._v("Estado")]),_vm._v(" "),_c('th',{staticClass:"numerico header",staticStyle:{"width":"6%"},attrs:{"title":""}},[_vm._v("Total")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_distribuicao_cfop_vue__ = __webpack_require__(498);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_836ed3e4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_distribuicao_cfop_vue__ = __webpack_require__(1394);
function injectStyle (ssrContext) {
  __webpack_require__(1392)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_distribuicao_cfop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_836ed3e4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_distribuicao_cfop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1393);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("46037996", content, true, {});

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}", ""]);

// exports


/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full-width default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":_vm.handleCloseFiltro}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("DISTRIBUIÇÃO POR CFOP")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 p-5"},[_c('div',{staticClass:"col-6"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}})],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.operacao),expression:"filtro.operacao"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio1","value":"S"},domProps:{"checked":_vm._q(_vm.filtro.operacao,"S")},on:{"change":function($event){return _vm.$set(_vm.filtro, "operacao", "S")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio1"}},[_vm._v("Saídas (Vendas)")])])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.operacao),expression:"filtro.operacao"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio2","value":"E"},domProps:{"checked":_vm._q(_vm.filtro.operacao,"E")},on:{"change":function($event){return _vm.$set(_vm.filtro, "operacao", "E")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio2"}},[_vm._v("Entradas")])])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.operacao),expression:"filtro.operacao"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio3","value":"T"},domProps:{"checked":_vm._q(_vm.filtro.operacao,"T")},on:{"change":function($event){return _vm.$set(_vm.filtro, "operacao", "T")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio3"}},[_vm._v("Todas")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.dados.items && _vm.dados.items.length > 0)?_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_vm._v("\n            RESUMO POR CFOP\n            "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":_vm.exportarExcel}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100",attrs:{"id":"relatorio"}},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.dados.items),function(row,index){return _c('tr',{key:index,staticStyle:{"height":"37px"}},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.cfop))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.descricao))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(row.qtd_notas))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(row.qtd_itens))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.total_produtos,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.total_geral,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.participacao,2))+"%")])])}),0)])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[(_vm.chartValues.length > 0)?_c('div',{staticClass:"col-12"},[_c('chart',{attrs:{"params":_vm.paramsChart}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_vm._v("\n            NOTAS FISCAIS\n            "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":_vm.exportarExcelDetalhes}})],1),_vm._v(" "),(!_vm.dados.detalhes || _vm.dados.detalhes.length == 0)?_c('div',{staticClass:"col-12"},[_vm._v("\n            Nenhuma nota fiscal encontrada\n        ")]):_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100",attrs:{"id":"relatorio"}},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.dados.detalhes),function(row,index){return _c('tr',{key:index,staticStyle:{"height":"37px"}},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.nf))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.serie))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatData")(row.data)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.destinatario))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.cidade))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.uf))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.cfop))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.item_desc))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(row.qtuni))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.total_item,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.total_nf,2)))])])}),0)])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"height":"37px"}},[_c('th',{staticClass:"textual header",staticStyle:{"width":"10%"},attrs:{"title":""}},[_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"}),_vm._v("CFOP")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"40%"},attrs:{"title":""}},[_vm._v("Descrição da Natureza / Operação "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('th',{staticClass:"numerico header",staticStyle:{"width":"10%"},attrs:{"title":""}},[_vm._v("Qtd Notas "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('th',{staticClass:"numerico header",staticStyle:{"width":"10%"},attrs:{"title":""}},[_vm._v("Qtd Itens "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('th',{staticClass:"numerico header",staticStyle:{"width":"15%"},attrs:{"title":""}},[_vm._v("Total Mercadorias "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('th',{staticClass:"numerico header",staticStyle:{"width":"15%"},attrs:{"title":""}},[_vm._v("Total Faturado "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('th',{staticClass:"numerico header",staticStyle:{"width":"10%"},attrs:{"title":""}},[_vm._v("Participação "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"height":"37px"}},[_c('th',{staticClass:"textual header",staticStyle:{"width":"6%"},attrs:{"title":""}},[_vm._v("NF")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"4%"},attrs:{"title":""}},[_vm._v("Série")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"8%"},attrs:{"title":""}},[_vm._v("Data")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"20%"},attrs:{"title":""}},[_vm._v("Destinatário")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"12%"},attrs:{"title":""}},[_vm._v("Cidade")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"4%"},attrs:{"title":""}},[_vm._v("UF")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"6%"},attrs:{"title":""}},[_vm._v("CFOP")]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"20%"},attrs:{"title":""}},[_vm._v("Item")]),_vm._v(" "),_c('th',{staticClass:"numerico header",staticStyle:{"width":"4%"},attrs:{"title":""}},[_vm._v("Qtd")]),_vm._v(" "),_c('th',{staticClass:"numerico header",staticStyle:{"width":"8%"},attrs:{"title":""}},[_vm._v("Total Item")]),_vm._v(" "),_c('th',{staticClass:"numerico header",staticStyle:{"width":"8%"},attrs:{"title":""}},[_vm._v("Total NF")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_customer_importa_form_vue__ = __webpack_require__(499);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3c0f93_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_customer_importa_form_vue__ = __webpack_require__(1398);
function injectStyle (ssrContext) {
  __webpack_require__(1396)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_customer_importa_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3c0f93_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_customer_importa_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1397);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6810bc28", content, true, {});

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',[_c('bar-manut',{attrs:{"single-entity":"Importação de Clientes","disableSave":true},on:{"closeform":_vm.handleVoltar}}),_vm._v(" "),(_vm.estagio == 'inicio')?_c('div',{staticClass:"default-container"},[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Planilha Modelo"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl"},[_vm._v("Efetue o download da planilha modelo.")]),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("Preencha as colunas da planilha com os dados dos clientes a serem importados, respeitando a ordem das colunas.")]),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("A importação não será realizada caso a planilha esteja em formato diferente da planilha de modelo.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Download da planilha modelo","icon":"fa-download"},on:{"click":function($event){return _vm.handleDownloadModelo()}}})],1)]),_vm._v(" "),_c('label-title',{staticClass:"mt-5",attrs:{"title":"Selecionar Arquivo Para Importação"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"100px"}},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl"},[_vm._v("Selecione o arquivo a ser importado.")]),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("Os clientes da planilha inexistentes no sistema serão inseridos. Os demais serão atualizados.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Selecionar Arquivo","nb-btdef":false,"icon":"fa-upload"},on:{"click":function($event){return _vm.handleSelecionarArquivo()}}}),_vm._v("\n                    "+_vm._s(_vm.selectedFile.name)+"\n                    "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('input',{ref:"file",attrs:{"type":"file","accept":".csv"},on:{"change":function($event){return _vm.handleFileChange()}}})])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[(_vm.errmessage)?_c('alert',{attrs:{"type":"warning","title":"Erro na importação do arquivo","text":_vm.errmessage}}):_vm._e()],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Continuar","nb-btdef":true},on:{"click":function($event){return _vm.handleAnalisarArquivo()}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":function($event){return _vm.handleVoltar()}}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.estagio == 'showresumo')?_c('div',{staticClass:"default-container"},[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Resumo da Importação"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"100px"}},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(" "+_vm._s(_vm.dadosResumo.novos)+" ")]),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(" clientes serão inseridos. ")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){return _vm.handleExportaResumo('novo')}}},[_vm._v("Visualizar")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(" "+_vm._s(_vm.dadosResumo.alterados)+" ")]),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(" clientes serão atualizados. ")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){return _vm.handleExportaResumo('alterar')}}},[_vm._v("Visualizar")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(" "+_vm._s(_vm.dadosResumo.naoimportados)+" ")]),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(" clientes não serão importados. ")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){return _vm.handleExportaResumo('naoimportado')}}},[_vm._v("Visualizar")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('alert',{attrs:{"type":"warning","title":"Confirmar Importação","text":"A importação ainda não foi efetuada. Confirme para efetivar."}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-2"},[(_vm.dadosResumo.novos == 0 && _vm.dadosResumo.alterados == 0)?_c('v-button',{attrs:{"label":"Selecionar Outro Arquivo","nb-btdef":true},on:{"click":function($event){return _vm.handleSelecionarOutro()}}}):_vm._e(),_vm._v(" "),(_vm.dadosResumo.novos > 0 || _vm.dadosResumo.alterados > 0)?_c('v-button',{attrs:{"label":"Confirmar Importação","nb-btdef":true},on:{"click":function($event){return _vm.handleConfirmarImportacao()}}}):_vm._e(),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":function($event){return _vm.handleSelecionarOutro()}}})],1)])],1):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_customer_list_vue__ = __webpack_require__(500);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0021caa_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_customer_list_vue__ = __webpack_require__(1408);
function injectStyle (ssrContext) {
  __webpack_require__(1400)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d0021caa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_customer_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0021caa_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_customer_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1401);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("625c6af3", content, true, {});

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-d0021caa]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-d0021caa]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-d0021caa]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-d0021caa]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-d0021caa]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-d0021caa]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-d0021caa]{flex:1;min-width:0}.nb-card-title-line[data-v-d0021caa]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-d0021caa]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-subtitle[data-v-d0021caa]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code[data-v-d0021caa]{color:#64748b;font-size:12px}.nb-card-code strong[data-v-d0021caa]{color:#334155;font-weight:600}.nb-card-badge[data-v-d0021caa]{display:inline-flex;align-items:center;gap:4px;padding:4px 7px;border:1px solid transparent;border-radius:5px;font-size:10px;font-weight:700;line-height:1.2}.nb-card-badge--success[data-v-d0021caa]{color:#166534;background:#f0fdf4;border-color:#bbf7d0}.nb-card-badge--warning[data-v-d0021caa]{color:#92400e;background:#fffbeb;border-color:#fde68a}.nb-card-badge--danger[data-v-d0021caa]{color:#991b1b;background:#fef2f2;border-color:#fecaca}.nb-card-badge--info[data-v-d0021caa]{color:#0369a1;background:#f0f9ff;border-color:#bae6fd}.nb-card-actions[data-v-d0021caa]{flex:0 0 auto}.nb-card-details[data-v-d0021caa]{display:grid;grid-template-columns:repeat(auto-fill,minmax(180px,1fr));gap:12px;margin:12px 0 0 60px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-card-detail[data-v-d0021caa]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-card-detail-label[data-v-d0021caa]{color:#64748b;font-size:11px}.nb-card-detail>strong[data-v-d0021caa]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}@media (max-width:767.98px){.nb-card-top[data-v-d0021caa]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-d0021caa]{align-self:flex-end}.nb-card-details[data-v-d0021caa]{grid-template-columns:repeat(2,minmax(0,1fr));margin-left:0}}", ""]);

// exports


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1403);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("65c13776", content, true, {});

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-390fcce6]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-390fcce6]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-390fcce6]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-390fcce6]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-390fcce6]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-390fcce6]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-390fcce6]{flex:1;min-width:0}.nb-card-title-line[data-v-390fcce6]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-390fcce6]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-390fcce6]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-390fcce6]{color:#334155;font-weight:600}.nb-card-actions[data-v-390fcce6]{flex:0 0 auto}.nb-card-inline-form[data-v-390fcce6]{padding:12px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px}@media (max-width:767.98px){.nb-card-top[data-v-390fcce6]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-390fcce6]{align-self:flex-end}}", ""]);

// exports


/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Grupos de Clientes","plural-entity":"Grupos de Clientes","title-search":"Pesquise pelo nome do grupo"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.grucliList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),(_vm.showForm)?_c('div',{staticClass:"nb-card-inline-form mb-3"},[_c('grucli-form',{attrs:{"index":_vm.codgrucli,"crud":_vm.crud},on:{"closeform":_vm.closeForm}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.grucliList),function(grucli){return _c('article',{key:grucli.codgrucli,staticClass:"nb-card"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!grucli.show),expression:"!grucli.show"}],staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(grucli.descricao))])]),_vm._v(" "),(grucli.codgrucli)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(grucli.codgrucli))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{ barDefault: true, btnDelete: true, btnEdit: true, btnEditLabel: 'Editar' },"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(grucli)},"view":function($event){return _vm.handleEdit(grucli, true)},"delete":function($event){return _vm.handleDelete(grucli)}}})],1)]),_vm._v(" "),(grucli.show)?_c('div',{staticClass:"nb-card-inline-form mt-2"},[_c('grucli-form',{attrs:{"index":grucli.codgrucli,"crud":_vm.crud},on:{"closeform":_vm.closeForm}})],1):_vm._e()])})],2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-user",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1406);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6176178e", content, true, {});

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-8860b0fa]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-8860b0fa]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-8860b0fa]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-8860b0fa]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-8860b0fa]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-8860b0fa]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-8860b0fa]{flex:1;min-width:0}.nb-card-title-line[data-v-8860b0fa]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-8860b0fa]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-8860b0fa]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-8860b0fa]{color:#334155;font-weight:600}.nb-card-actions[data-v-8860b0fa]{flex:0 0 auto}@media (max-width:767.98px){.nb-card-top[data-v-8860b0fa]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-8860b0fa]{align-self:flex-end}}", ""]);

// exports


/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Grupo de Fornecedor","plural-entity":"Grupos de Fornecedor","title-search":"Pesquise pela nome do grupo"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.gruforList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.gruforList),function(grufor){return _c('article',{key:grufor.codgrufor,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(grufor.descricao))])]),_vm._v(" "),(grufor.codgrufor)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(grufor.codgrufor))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{ barDefault: true, btnView: true, btnEdit: true, btnEditLabel: 'Editar' },"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(grufor.codgrufor)},"view":function($event){return _vm.handleEdit(grufor.codgrufor, true)}}})],1)])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('grufor-form',{attrs:{"index":this.codgrufor,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-truck",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"grid"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('tabs',{staticClass:"pb-5",attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}),_vm._v(" "),(!_vm.tabGrupoCli && !_vm.tabGrupoForn)?_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":true,"single-entity":"Participante (Cliente, Fornecedor e Transportadora)","plural-entity":"Participantes (Clientes, Fornecedores e Transportadoras)","moreActions":_vm.moreActionsBarList,"title-search":"Pesquise pelo nome, nome fantasia, código, cnpj ou cpf"},on:{"action":_vm.handleAction,"search":_vm.search,"new":_vm.incluirPart,"refresh":_vm.loadData}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nb-margin-top"},[(_vm.tabGrupoCli)?_c('transition',[_c('grucli-list')],1):_vm._e(),_vm._v(" "),(_vm.tabGrupoForn)?_c('transition',[_c('grufor-list')],1):_vm._e()],1),_vm._v(" "),(_vm.tabClientes)?_c('div',{staticClass:"default-container nb-card-list"},[(_vm.partList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.partList),function(part){return _c('article',{key:part.codpart,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_c('div',{staticClass:"nb-card-icon"},[_c('i',{class:(part.cnpjcpf && part.cnpjcpf.length > 11) ? 'fa fa-building-o' : 'fa fa-user',attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(part.nome))]),_vm._v(" "),(_vm.situacao(part))?_c('span',{staticClass:"nb-card-badge",class:_vm.situacaoBadgeClass(part)},[_vm._v("\n                                    "+_vm._s(_vm.situacao(part))+"\n                                ")]):_vm._e(),_vm._v(" "),(_vm.textTipo(part.cliente, part.forn, part.transp))?_c('span',{staticClass:"nb-card-badge nb-card-badge--info"},[_vm._v("\n                                    "+_vm._s(_vm.textTipo(part.cliente, part.forn, part.transp))+"\n                                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nb-card-subtitle"},[(part.fantasia)?_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(part.fantasia))]):_vm._e(),_vm._v(" "),(part.cnpjcpf)?_c('span',{staticClass:"mr-2 font-weight-bold"},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(part.cnpjcpf)))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"nb-card-code"},[_vm._v("Código "),_c('strong',[_vm._v(_vm._s(part.codpart))])])])])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{ barDefault: true, btnView: true, btnEdit: true, btnEditLabel: 'Editar' },"moreActions":[]},on:{"edit":function($event){return _vm.editPart(part.codpart)},"view":function($event){return _vm.editPart(part.codpart)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"nb-card-details"},[(part.nomemun || part.uf)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Localização")]),_vm._v(" "),_c('strong',[_c('i',{staticClass:"fa fa-map-marker text-muted mr-1",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(part.nomemun)+" "),(part.uf)?_c('span',[_vm._v("/ "+_vm._s(part.uf))]):_vm._e()])]):_vm._e(),_vm._v(" "),(part.fone1 || part.fone2 || part.fone3)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Telefone")]),_vm._v(" "),_c('strong',[_c('i',{staticClass:"fa fa-phone text-muted mr-1",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm._f("formatFone")(part.fone1))+" "),(part.fone2)?_c('span',[_vm._v(_vm._s(_vm._f("formatFone")(part.fone2)))]):_vm._e()])]):_vm._e(),_vm._v(" "),(part.email)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("E-mail")]),_vm._v(" "),_c('strong',[_c('i',{staticClass:"fa fa-envelope text-muted mr-1",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(part.email))])]):_vm._e(),_vm._v(" "),(part.iest)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Inscrição Estadual")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(part.iest))])]):_vm._e(),_vm._v(" "),(part.data_ultima_compra)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Última Compra")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("formatData")(part.data_ultima_compra)))])]):_vm._e()])])}),_vm._v(" "),(_vm.nextPage > 0)?_c('div',{staticClass:"text-center my-3"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",on:{"click":function($event){return _vm.handleMore()}}},[_c('i',{staticClass:"fa fa-chevron-down mr-1"}),_vm._v(" Exibir mais participantes\n                ")])]):_vm._e()],2):_vm._e()],1),_vm._v(" "),(_vm.showForm)?_c('customer-form',{attrs:{"crud":_vm.crud,"index":_vm.codpart},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1410);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("602796c0", content, true, {});

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-product-bulkbar[data-v-59a8e102]{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:9px 14px;margin-bottom:10px;background:#fff;border:1px solid #e2e8f0;border-radius:9px}.nb-product-select-all[data-v-59a8e102]{flex:1;min-width:0}.nb-product-selection-count[data-v-59a8e102]{color:#475569;font-size:12px;font-weight:600;white-space:nowrap}.default-container.nb-product-list[data-v-59a8e102]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-product-card[data-v-59a8e102]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-product-card[data-v-59a8e102]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-product-actions[data-v-59a8e102],.nb-product-card-top[data-v-59a8e102],.nb-product-identity[data-v-59a8e102]{display:flex;align-items:center}.nb-product-card-top[data-v-59a8e102]{justify-content:space-between;gap:16px}.nb-product-identity[data-v-59a8e102]{flex:1;min-width:0;gap:11px}.nb-product-select[data-v-59a8e102]{flex:0 0 24px;width:24px}.nb-product-image[data-v-59a8e102]{position:relative;display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;padding:4px;color:#64748b;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;cursor:pointer}.nb-product-image[data-v-59a8e102]:focus-visible{outline:2px solid #004e94;outline-offset:2px}.nb-product-image>img[data-v-59a8e102]{max-width:100%;max-height:100%;object-fit:contain}.nb-product-image>.fa[data-v-59a8e102]{font-size:19px}.nb-product-image-edit[data-v-59a8e102]{position:absolute;right:-5px;bottom:-5px;display:flex;width:18px;height:18px;align-items:center;justify-content:center;color:#fff;background:#004e94;border:2px solid #fff;border-radius:50%;font-size:8px}.nb-product-title[data-v-59a8e102]{flex:1;min-width:0}.nb-product-title-line[data-v-59a8e102]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-product-title-line h2[data-v-59a8e102]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-product-code[data-v-59a8e102]{margin-top:3px;color:#64748b;font-size:12px}.nb-product-code strong[data-v-59a8e102]{color:#334155;font-weight:600}.nb-product-badge[data-v-59a8e102]{display:inline-flex;align-items:center;gap:4px;padding:4px 7px;border:1px solid transparent;border-radius:5px;font-size:10px;font-weight:700;line-height:1.2}.nb-product-badge--inactive[data-v-59a8e102]{color:#92400e;background:#fffbeb;border-color:#fde68a}.nb-product-badge--blocked[data-v-59a8e102]{color:#b91c1c;background:#fef2f2;border-color:#fecaca}.nb-product-actions[data-v-59a8e102]{flex:0 0 auto}.nb-product-details[data-v-59a8e102]{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;margin:12px 0 0 59px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-product-card--selectable .nb-product-details[data-v-59a8e102]{margin-left:94px}.nb-product-detail[data-v-59a8e102]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-product-detail-label[data-v-59a8e102]{color:#64748b;font-size:11px}.nb-product-detail>strong[data-v-59a8e102]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}.nb-product-detail>strong small[data-v-59a8e102]{color:#64748b;font-size:11px;font-weight:500}.nb-product-detail--store-block[data-v-59a8e102]{align-items:flex-start}@media (max-width:767.98px){.nb-product-card-top[data-v-59a8e102]{align-items:flex-start;flex-direction:column}.nb-product-actions[data-v-59a8e102]{align-self:flex-end}.nb-product-details[data-v-59a8e102]{grid-template-columns:repeat(2,minmax(0,1fr));margin-left:0}.nb-product-card--selectable .nb-product-details[data-v-59a8e102]{margin-left:0}.nb-product-detail--store-block[data-v-59a8e102]{grid-column:1/-1}}@media (max-width:575.98px){.nb-product-card[data-v-59a8e102]{padding:12px}.nb-product-actions[data-v-59a8e102]{align-self:flex-end}.nb-product-bulkbar[data-v-59a8e102]{padding:8px 10px}}.btn-outline-sm[data-v-59a8e102]{background:#f6f6f6!important;border:1px solid #f6f6f6!important;border-radius:3px;padding:.25rem .85rem}", ""]);

// exports


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1412);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6d3182bc", content, true, {});

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".current-color{border:1px solid #ced4da;border-radius:.25rem}.btn-icon{background:transparent;font-weight:700}.iconSelected{background:#c9c9c9;border:1px solid #aeaeae}.btn-icon:focus{outline:none}", ""]);

// exports


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1414);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3e9df2e4", content, true, {});

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row align-items-center"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.gruest.descricao.validator),expression:"metadata.gruest.descricao.validator"}],ref:"descricao",attrs:{"type":"text","col":"6","metadata":_vm.metadata.gruest.descricao,"case":"normal","name":"descricao","v-errors":_vm.errors},model:{value:(_vm.gruest.descricao),callback:function ($$v) {_vm.$set(_vm.gruest, "descricao", $$v)},expression:"gruest.descricao"}}),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-button',{attrs:{"label":"Salvar","nb-btdef":true},on:{"click":_vm.handleSave}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.closeForm}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1417);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3afa1454", content, true, {});

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gruest"}},[_c('bar-manut',{attrs:{"single-entity":"Depósito","plural-entity":"Depósitos","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"metadata":_vm.metadata.deposito.coddeposito,"type":"text","col":"2","disabled":true},model:{value:(_vm.deposito.coddeposito),callback:function ($$v) {_vm.$set(_vm.deposito, "coddeposito", $$v)},expression:"deposito.coddeposito"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.deposito.descricao.validator),expression:"metadata.deposito.descricao.validator"}],ref:"descricao",attrs:{"type":"text","col":"6","metadata":_vm.metadata.deposito.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.deposito.descricao),callback:function ($$v) {_vm.$set(_vm.deposito, "descricao", $$v)},expression:"deposito.descricao"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.deposito.codfil.validator),expression:"metadata.deposito.codfil.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.deposito.codfil,"parent":"gruest","name":"cfop","v-errors":_vm.errors},model:{value:(_vm.deposito.codfil),callback:function ($$v) {_vm.$set(_vm.deposito, "codfil", $$v)},expression:"deposito.codfil"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1420);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("24bec24a", content, true, {});

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Unidade de Medida","plural-entity":"Unidades de Medida","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),(_vm.errmessages.length)?_c('validation',{attrs:{"title":"Erros de validação","messages":_vm.errmessages}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.unimed.uni.validator),expression:"metadata.unimed.uni.validator"}],ref:"uni",attrs:{"metadata":_vm.metadata.unimed.uni,"type":"text","col":"3","disabled":_vm.editing,"name":"uni","v-errors":_vm.errors},model:{value:(_vm.unimed.uni),callback:function ($$v) {_vm.$set(_vm.unimed, "uni", $$v)},expression:"unimed.uni"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.unimed.descricao.validator),expression:"metadata.unimed.descricao.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.unimed.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.unimed.descricao),callback:function ($$v) {_vm.$set(_vm.unimed, "descricao", $$v)},expression:"unimed.descricao"}}),_vm._v(" "),_c('div',{staticClass:"w-100"})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1423);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("104a2658", content, true, {});

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".sticky-col{position:-webkit-sticky;position:sticky}.grade-cor,.sticky-col{background-color:#fff;left:0}.grade-cor{height:40px;padding:10px;width:200px;border-bottom:1px solid #e0e0e0;-webkit-box-shadow:3px 0 10px -4px #d3cdcd;-moz-box-shadow:3px 0 10px -4px #d3cdcd;box-shadow:3px 0 10px -4px #d3cdcd}", ""]);

// exports


/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"80vh","overflow-x":"auto"}},[(!_vm.params.view)?_c('div',[_c('table',{staticClass:"table table-sm table-bordered table-striped",staticStyle:{"width":"auto"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"grade-cor sticky-col"}),_vm._v(" "),_vm._l((_vm.colunasHead),function(col,index){return _c('td',{key:index,staticClass:"text-center",staticStyle:{"min-width":"70px"}},[_c('div',{staticStyle:{"text-overflow":"ellipsis","overflow":"hidden"},attrs:{"data-placement":"top","data-original-title":""}},[_vm._v(_vm._s(col.descricao))])])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.grade.linhas),function(row,index){return _c('tr',{key:index},[_c('th',{staticClass:"grade-cor sticky-col",staticStyle:{"max-width":"200px","heigth":"40px"}},[_c('div',{staticStyle:{"text-overflow":"ellipsis","overflow":"hidden","white-space":"nowrap"},attrs:{"data-placement":"top","data-original-title":"azul"}},[_vm._v(_vm._s(row.descricao))])]),_vm._v(" "),_vm._l((row.colunas),function(col,index){return _c('td',{key:index,staticClass:"text-center",staticStyle:{"max-width":"70px"}},[(!_vm.params.view && col.ativo)?_c('input-number',{ref:"quantidade",refInFor:true,staticClass:"form-control form-control-sm",model:{value:(col.quantidade),callback:function ($$v) {_vm.$set(col, "quantidade", $$v)},expression:"col.quantidade"}}):_vm._e(),_vm._v(" "),(_vm.params.view)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(col.quantidade))]):_vm._e()],1)}),_vm._v(" "),(row.coditemgrade)?_c('td',{staticClass:"text-center",staticStyle:{"max-width":"70px"}},[(!_vm.params.view && row.ativo)?_c('input-number',{ref:"quantidade",refInFor:true,staticClass:"form-control form-control-sm",model:{value:(row.quantidade),callback:function ($$v) {_vm.$set(row, "quantidade", $$v)},expression:"row.quantidade"}}):_vm._e(),_vm._v(" "),(_vm.params.view)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(row.quantidade))]):_vm._e()],1):_vm._e()],2)}),0)]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('v-label',{attrs:{"label":"Quantidade Total"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(_vm.quantidadeTotal,0)))])])],1)]):_vm._e(),_vm._v(" "),(_vm.params.view)?_c('div',[_c('table',{staticClass:"table table-sm table-bordered table-striped",staticStyle:{"font-size":"11px","margin-left":"0","width":"auto"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"sticky-col"}),_vm._v(" "),_vm._l((_vm.colunasHead),function(col,index){return _c('td',{key:index,staticClass:"text-center"},[_c('div',{staticStyle:{"text-overflow":"ellipsis","overflow":"hidden"}},[_vm._v(_vm._s(col.descricao))])])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.grade.linhas),function(row,index){return _c('tr',{key:index},[_c('th',{staticClass:"sticky-col",staticStyle:{"max-width":"200px"}},[_c('div',{staticStyle:{"text-overflow":"ellipsis","overflow":"hidden","white-space":"nowrap"}},[_vm._v(_vm._s(row.descricao))])]),_vm._v(" "),_vm._l((row.colunas),function(col,index){return _c('td',{key:index,staticClass:"text-center"},[(_vm.params.view)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(col.quantidade))]):_vm._e()])})],2)}),0)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_anexos_selecionar_form_vue__ = __webpack_require__(513);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_13752818_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_anexos_selecionar_form_vue__ = __webpack_require__(1428);
function injectStyle (ssrContext) {
  __webpack_require__(1426)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_anexos_selecionar_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_13752818_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_anexos_selecionar_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1427);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("558fc4ae", content, true, {});

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".imagem-galeria{max-height:80px}.imagem-galeria-loading{height:100%;width:80px;padding-top:30px}.imagem-list{padding:4px;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);-webkit-box-shadow:0 1px 3px rgba(0,0,0,.1);-moz-box-shadow:0 1px 3px rgba(0,0,0,.1);box-shadow:0 1px 3px rgba(0,0,0,.1);margin-right:5px}.imagem-list.active{background-color:#67a0be!important}.imagem-excluir{cursor:pointer;background:#fff;border:1px solid #ccc;padding:4px}.no-image{font-size:72px;color:silver;cursor:pointer}.adicionar-imagem{min-height:100px;width:152px;padding:38px 5px 5px;float:left;font-size:18px;text-align:center;border:1px dashed #bbb;color:#888;background-color:#fff;cursor:pointer}.attach-icon{color:#808080bb}", ""]);

// exports


/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[(_vm.params.showform)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container",staticStyle:{"height":"90%","overflow":"auto"}},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body",staticStyle:{"height":"70%"}},[_c('div',{staticClass:"row col",staticStyle:{"padding-left":"20px height: 80%"}},_vm._l((_vm.listImages),function(img,index){return _c('div',{key:index,staticClass:"imagem-list text-center nb-margin-bottom",class:{'active': _vm.selectedIndex == index}},[(!img.coddoc || !img.url)?_c('div',{staticClass:"imagem-galeria-loading"},[_c('div',{staticClass:"spinner-border text-muted"})]):_vm._e(),_vm._v(" "),(img.coddoc && img.url)?_c('img',{staticClass:"imagem-galeria",attrs:{"src":img.url},on:{"click":function($event){return _vm.handleClickGaleria(index)}}}):_vm._e(),_c('br')])}),0)]),_vm._v(" "),_c('div',{staticClass:"nb-modal-footer",staticStyle:{"height":"10%"}},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.handleClickRemove()}}},[_vm._m(0)])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}}),_vm._v(" Remover Imagem ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1430);

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (barcode) {
  var code = "" + barcode;
  var digits = function digits() {
    return (/^\d{8,13}$/g.test(code)
    );
  };
  var validlengths = [8, 12, 13];
  if (!digits() || !validlengths.includes(code.length)) return false;

  var checksum = 0;
  var codelist = code.split("");
  var checkdigit = parseInt(codelist.pop(), 10);
  codelist.map(function (value, index) {
    var digit = parseInt(value, 10);
    if (code.length % 2 === 1) checksum += index % 2 ? digit * 3 : digit;else checksum += index % 2 ? digit : digit * 3;
  });

  var check = checksum % 10;
  if (check !== 0) check = 10 - check;
  if (check === checkdigit) return true;
  return false;
};

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Produto","plural-entity":"Produtos","crud":_vm.lCrud,"btn-delete":_vm.permissaoExcluir},on:{"delete":_vm.apiDelete,"closeform":_vm.closeForm,"save":_vm.handleSave}}),_vm._v(" "),(_vm.errmessages.length != 0)?_c('validation',{attrs:{"messages":_vm.errmessages}}):_vm._e(),_vm._v(" "),(_vm.formatoTela == 'importacaonfe')?_c('div',{attrs:{"id":"modal"}},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codigo.validator),expression:"metadata.item.codigo.validator"}],ref:"codigo",attrs:{"metadata":_vm.metadata.item.codigo,"type":"text","col":"3","name":"codigo","id":"codigo","v-errors":_vm.errors,"disabled":_vm.isView || _vm.itemComMovimento},model:{value:(_vm.item.codigo),callback:function ($$v) {_vm.$set(_vm.item, "codigo", $$v)},expression:"item.codigo"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.descricao.validator),expression:"metadata.item.descricao.validator"}],attrs:{"type":"text","col":"12","metadata":_vm.metadata.item.descricao,"name":"descricao","id":"descricao","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.descricao),callback:function ($$v) {_vm.$set(_vm.item, "descricao", $$v)},expression:"item.descricao"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.tipoproduto.validator),expression:"metadata.item.tipoproduto.validator"}],attrs:{"type":"select2","col":"12","metadata":_vm.metadata.item.tipoproduto,"name":"tipoproduto","v-errors":_vm.errors,"parent":"modal","disabled":_vm.isView},model:{value:(_vm.item.tipoproduto),callback:function ($$v) {_vm.$set(_vm.item, "tipoproduto", $$v)},expression:"item.tipoproduto"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.uni.validator),expression:"metadata.item.uni.validator"}],attrs:{"type":"select2","col":"12","metadata":_vm.metadata.item.uni,"name":"uni","v-errors":_vm.errors,"parent":"modal","disabled":_vm.isView || _vm.itemComMovimento},model:{value:(_vm.item.uni),callback:function ($$v) {_vm.$set(_vm.item, "uni", $$v)},expression:"item.uni"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.ncm.validator),expression:"metadata.item.ncm.validator"}],attrs:{"type":"select2","col":"12","metadata":_vm.metadata.item.ncm,"name":"ncm","id":"ncm","v-errors":_vm.errors,"parent":"modal","disabled":_vm.isView},model:{value:(_vm.item.ncm),callback:function ($$v) {_vm.$set(_vm.item, "ncm", $$v)},expression:"item.ncm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.orimerc.validator),expression:"metadata.item.orimerc.validator"}],attrs:{"type":"select2","col":"12","metadata":_vm.metadata.item.orimerc,"name":"orimerc","v-errors":_vm.errors,"parent":"modal","disabled":_vm.isView},model:{value:(_vm.item.orimerc),callback:function ($$v) {_vm.$set(_vm.item, "orimerc", $$v)},expression:"item.orimerc"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"12","metadata":_vm.metadata.item.formaaq,"disabled":_vm.isView},model:{value:(_vm.item.formaaq),callback:function ($$v) {_vm.$set(_vm.item, "formaaq", $$v)},expression:"item.formaaq"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codgruest.validator),expression:"metadata.item.codgruest.validator"}],attrs:{"type":"select2","col":"12","metadata":_vm.metadata.item.codgruest,"name":"codgruest","v-errors":_vm.errors,"parent":"modal","disabled":_vm.isView},model:{value:(_vm.item.codgruest),callback:function ($$v) {_vm.$set(_vm.item, "codgruest", $$v)},expression:"item.codgruest"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.cest.validator),expression:"metadata.item.cest.validator"}],attrs:{"type":"number","col":"6","metadata":_vm.metadata.item.cest,"name":"cest","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.cest),callback:function ($$v) {_vm.$set(_vm.item, "cest", $$v)},expression:"item.cest"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codbarras.validator),expression:"metadata.item.codbarras.validator"}],attrs:{"type":"number","col":"6","metadata":_vm.metadata.item.codbarras,"name":"codbarras","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.codbarras),callback:function ($$v) {_vm.$set(_vm.item, "codbarras", $$v)},expression:"item.codbarras"}})],1)]):_vm._e(),_vm._v(" "),(_vm.formatoTela == 'forcaVendas' || _vm.isView)?_c('div',{attrs:{"id":"modal"}},[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codigo.validator),expression:"metadata.item.codigo.validator"}],ref:"codigo",attrs:{"metadata":_vm.metadata.item.codigo,"type":"text","col":"3","name":"codigo","id":"codigo","v-errors":_vm.errors,"disabled":_vm.isView || _vm.itemComMovimento},model:{value:(_vm.item.codigo),callback:function ($$v) {_vm.$set(_vm.item, "codigo", $$v)},expression:"item.codigo"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.descricao.validator),expression:"metadata.item.descricao.validator"}],attrs:{"type":"text","col":"12","metadata":_vm.metadata.item.descricao,"name":"descricao","id":"descricao","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.descricao),callback:function ($$v) {_vm.$set(_vm.item, "descricao", $$v)},expression:"item.descricao"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.desccomp.validator),expression:"metadata.item.desccomp.validator"}],attrs:{"type":"memo","col":"12","metadata":_vm.metadata.item.desccomp,"name":"desccomp","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.desccomp),callback:function ($$v) {_vm.$set(_vm.item, "desccomp", $$v)},expression:"item.desccomp"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.uni.validator),expression:"metadata.item.uni.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.item.uni,"name":"uni","v-errors":_vm.errors,"parent":"modal","disabled":_vm.isView || _vm.itemComMovimento},model:{value:(_vm.item.uni),callback:function ($$v) {_vm.$set(_vm.item, "uni", $$v)},expression:"item.uni"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.qtlotemult.validator),expression:"metadata.item.qtlotemult.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.item.qtlotemult,"precision":2,"name":"qtlotemult","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.qtlotemult),callback:function ($$v) {_vm.$set(_vm.item, "qtlotemult", $$v)},expression:"item.qtlotemult"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.pliq.validator),expression:"metadata.item.pliq.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.item.pliq,"name":"pliq","v-errors":_vm.errors,"addon":"Kg","disabled":_vm.isView},model:{value:(_vm.item.pliq),callback:function ($$v) {_vm.$set(_vm.item, "pliq", $$v)},expression:"item.pliq"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.pbru.validator),expression:"metadata.item.pbru.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.item.pbru,"addon":"Kg","name":"pbru","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.pbru),callback:function ($$v) {_vm.$set(_vm.item, "pbru", $$v)},expression:"item.pbru"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.stitem.validator),expression:"metadata.item.stitem.validator"}],attrs:{"tabindex":1,"type":"select","col":"3","metadata":_vm.metadata.item.stitem,"name":"stitem","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.stitem),callback:function ($$v) {_vm.$set(_vm.item, "stitem", $$v)},expression:"item.stitem"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.item.tipoitem,"disabled":_vm.isView},model:{value:(_vm.item.tipoitem),callback:function ($$v) {_vm.$set(_vm.item, "tipoitem", $$v)},expression:"item.tipoitem"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codgruest.validator),expression:"metadata.item.codgruest.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.item.codgruest,"name":"codgruest","v-errors":_vm.errors,"parent":"modal","disabled":_vm.isView},model:{value:(_vm.item.codgruest),callback:function ($$v) {_vm.$set(_vm.item, "codgruest", $$v)},expression:"item.codgruest"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.orimerc.validator),expression:"metadata.item.orimerc.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.item.orimerc,"name":"orimerc","v-errors":_vm.errors,"parent":"modal","disabled":_vm.isView},model:{value:(_vm.item.orimerc),callback:function ($$v) {_vm.$set(_vm.item, "orimerc", $$v)},expression:"item.orimerc"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.item.formaaq,"disabled":_vm.isView},model:{value:(_vm.item.formaaq),callback:function ($$v) {_vm.$set(_vm.item, "formaaq", $$v)},expression:"item.formaaq"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.item.icmitem,"disabled":_vm.isView},model:{value:(_vm.item.icmitem),callback:function ($$v) {_vm.$set(_vm.item, "icmitem", $$v)},expression:"item.icmitem"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.ncm.validator),expression:"metadata.item.ncm.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.item.ncm,"name":"ncm","id":"ncm","v-errors":_vm.errors,"parent":"modal","disabled":_vm.isView},model:{value:(_vm.item.ncm),callback:function ($$v) {_vm.$set(_vm.item, "ncm", $$v)},expression:"item.ncm"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.item.ipiitem,"disabled":_vm.isView},model:{value:(_vm.item.ipiitem),callback:function ($$v) {_vm.$set(_vm.item, "ipiitem", $$v)},expression:"item.ipiitem"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.aipi.validator),expression:"metadata.item.aipi.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.item.aipi,"precision":2,"name":"aipi","v-errors":_vm.errors,"addon":"%","disabled":_vm.isView},model:{value:(_vm.item.aipi),callback:function ($$v) {_vm.$set(_vm.item, "aipi", $$v)},expression:"item.aipi"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.cest.validator),expression:"metadata.item.cest.validator"}],attrs:{"type":"number","col":"3","metadata":_vm.metadata.item.cest,"name":"cest","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.cest),callback:function ($$v) {_vm.$set(_vm.item, "cest", $$v)},expression:"item.cest"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.cuspadrao.validator),expression:"metadata.item.cuspadrao.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.item.cuspadrao,"precision":2,"preaddon":"R$","name":"cuspadrao","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.cuspadrao),callback:function ($$v) {_vm.$set(_vm.item, "cuspadrao", $$v)},expression:"item.cuspadrao"}})],1),_vm._v(" "),_c('div',{attrs:{"id":"accordion"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('button',{staticClass:"btn btn-link",attrs:{"data-toggle":"collapse","data-target":"#collapseOne","aria-expanded":_vm.appLoja ? 'true' : 'false',"aria-controls":"collapseOne"}},[_vm._v("\n                Dados da Loja\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"collapse",class:_vm.appLoja ? 'show' : 'hide',attrs:{"id":"collapseOne","aria-labelledby":"headingOne","data-parent":"#accordion"}},[_c('div',{staticClass:"card-body"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.ecommerce.validator),expression:"metadata.item.ecommerce.validator"}],attrs:{"tabindex":1,"type":"select","col":"3","metadata":_vm.metadata.item.ecommerce,"name":"stitem","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.ecommerce),callback:function ($$v) {_vm.$set(_vm.item, "ecommerce", $$v)},expression:"item.ecommerce"}})],1)])])]),_vm._v(" "),(_vm.item.tipoitem == 'P')?_c('div',[_c('label-title',{staticClass:"mt-2",attrs:{"title":"Controle de Grade"}}),_vm._v(" "),(!_vm.editaGrade && _vm.item.codgradel)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codgradel.validator),expression:"metadata.item.codgradel.validator"}],attrs:{"reg":"codgradel","type":"select2","col":"6","metadata":_vm.metadata.item.codgradel,"disabled":true,"name":"codgradel","v-errors":_vm.errors},model:{value:(_vm.item.codgradel),callback:function ($$v) {_vm.$set(_vm.item, "codgradel", $$v)},expression:"item.codgradel"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codgradec.validator),expression:"metadata.item.codgradec.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.item.codgradec,"disabled":true,"name":"codgradec","v-errors":_vm.errors},model:{value:(_vm.item.codgradec),callback:function ($$v) {_vm.$set(_vm.item, "codgradec", $$v)},expression:"item.codgradec"}})],1):_vm._e(),_vm._v(" "),(!_vm.editaGrade)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Definir Uma Grade","nb-btdef":true,"disabled":_vm.isView},on:{"click":_vm.handleHabilitaGrade}})],1)]):_vm._e(),_vm._v(" "),(_vm.editaGrade)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codgradel.validator),expression:"metadata.item.codgradel.validator"}],ref:"codgradel",attrs:{"type":"select2","col":"6","metadata":_vm.metadata.item.codgradel,"name":"codgradel","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.codgradel),callback:function ($$v) {_vm.$set(_vm.item, "codgradel", $$v)},expression:"item.codgradel"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codgradec.validator),expression:"metadata.item.codgradec.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.item.codgradec,"name":"codgradec","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.codgradec),callback:function ($$v) {_vm.$set(_vm.item, "codgradec", $$v)},expression:"item.codgradec"}})],1):_vm._e(),_vm._v(" "),(_vm.editaGrade)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Aplicar Grade","title":"","nb-btdef":true},on:{"click":_vm.handleAplicaGrade}})],1)]):_vm._e(),_vm._v(" "),_c('div',_vm._l((_vm.gradelist),function(grade,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[(grade.parametros && grade.parametros.docs && (grade.parametros.docs.length > 0))?_c('div',{staticClass:"col-md-1 col-12 text-center"},[_c('img',{staticClass:"mx-auto d-block img-thumbnail",staticStyle:{"max-width":"45px","max-height":"45px"},attrs:{"src":grade.parametros.docs[0].img,"alt":"Logotipo"},on:{"click":function($event){return _vm.handleVincularImagem(grade)}}})]):_c('div',{staticClass:"col-md-1 col-12 text-center"},[_c('i',{staticClass:"fa fa-camera mx-auto d-block",staticStyle:{"font-size":"25px","color":"silver","cursor":"pointer"},on:{"click":function($event){return _vm.handleVincularImagem(grade)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[(grade.corlinha)?_c('span',{staticClass:"current-color",style:('background-color: ' + grade.corlinha)}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto"},[_vm._v(" "+_vm._s(grade.descricaolinha)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[(grade.corcoluna)?_c('span',{staticClass:"current-color",style:('background-color: ' + grade.corcoluna)}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto"},[_vm._v(" "+_vm._s(grade.descricaocoluna)+" ")])]),_vm._v(" "),_c('form-field',{attrs:{"type":"text","col":"2","metadata":_vm.metadata.item.codbarras,"disabled":_vm.isView},model:{value:(grade.codbarras),callback:function ($$v) {_vm.$set(grade, "codbarras", $$v)},expression:"grade.codbarras"}}),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12"},[_c('input-switch',{attrs:{"type":"success","label":"Ativo?","value-checked":"S","value-unchecked":"N"},model:{value:(grade.ativo),callback:function ($$v) {_vm.$set(grade, "ativo", $$v)},expression:"grade.ativo"}})],1)],1)])])}),0)],1):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.formatoTela == 'normal' || _vm.isView)?_c('div',{staticClass:"default-container"},[_c('div',[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codigo.validator),expression:"metadata.item.codigo.validator"}],ref:"codigo",attrs:{"metadata":_vm.metadata.item.codigo,"type":"text","col":"2","name":"codigo","id":"codigo","v-errors":_vm.errors,"disabled":_vm.isView || _vm.itemComMovimento},model:{value:(_vm.item.codigo),callback:function ($$v) {_vm.$set(_vm.item, "codigo", $$v)},expression:"item.codigo"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.descricao.validator),expression:"metadata.item.descricao.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.item.descricao,"name":"descricao","id":"descricao","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.descricao),callback:function ($$v) {_vm.$set(_vm.item, "descricao", $$v)},expression:"item.descricao"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.descnf.validator),expression:"metadata.item.descnf.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.item.descnf,"name":"descnf","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.descnf),callback:function ($$v) {_vm.$set(_vm.item, "descnf", $$v)},expression:"item.descnf"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.item.tipoitem,"disabled":_vm.isView},model:{value:(_vm.item.tipoitem),callback:function ($$v) {_vm.$set(_vm.item, "tipoitem", $$v)},expression:"item.tipoitem"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.tipoproduto.validator),expression:"metadata.item.tipoproduto.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.item.tipoproduto,"name":"tipoproduto","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.tipoproduto),callback:function ($$v) {_vm.$set(_vm.item, "tipoproduto", $$v)},expression:"item.tipoproduto"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.stitem.validator),expression:"metadata.item.stitem.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.item.stitem,"name":"stitem","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.stitem),callback:function ($$v) {_vm.$set(_vm.item, "stitem", $$v)},expression:"item.stitem"}})],1),_vm._v(" "),(_vm.item.tipoitem == 'P')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.tipoestoque.validator),expression:"metadata.item.tipoestoque.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.item.tipoestoque,"name":"tipoestoque","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.tipoestoque),callback:function ($$v) {_vm.$set(_vm.item, "tipoestoque", $$v)},expression:"item.tipoestoque"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.uni.validator),expression:"metadata.item.uni.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.item.uni,"name":"uni","v-errors":_vm.errors,"add-button":true,"disabled":_vm.isView || _vm.itemComMovimento},on:{"clickAdd":function($event){return _vm.handleIncluir('uni')}},model:{value:(_vm.item.uni),callback:function ($$v) {_vm.$set(_vm.item, "uni", $$v)},expression:"item.uni"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.item.tipoitem == 'P')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.pliq.validator),expression:"metadata.item.pliq.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.pliq,"name":"pliq","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.pliq),callback:function ($$v) {_vm.$set(_vm.item, "pliq", $$v)},expression:"item.pliq"}}):_vm._e(),_vm._v(" "),(_vm.item.tipoitem == 'P')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.pbru.validator),expression:"metadata.item.pbru.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.pbru,"name":"pbru","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.pbru),callback:function ($$v) {_vm.$set(_vm.item, "pbru", $$v)},expression:"item.pbru"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.cuspadrao.validator),expression:"metadata.item.cuspadrao.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.metadata.item.cuspadrao,"precision":2,"name":"cuspadrao","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.cuspadrao),callback:function ($$v) {_vm.$set(_vm.item, "cuspadrao", $$v)},expression:"item.cuspadrao"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"4","metadata":_vm.metadata.item.precovenda,"precision":2,"name":"precovenda","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.precovenda),callback:function ($$v) {_vm.$set(_vm.item, "precovenda", $$v)},expression:"item.precovenda"}})],1),_vm._v(" "),(_vm.item.tipoitem == 'P')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codbarras.validator),expression:"metadata.item.codbarras.validator"}],attrs:{"type":"number","col":"4","metadata":_vm.metadata.item.codbarras,"name":"codbarras","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.codbarras),callback:function ($$v) {_vm.$set(_vm.item, "codbarras", $$v)},expression:"item.codbarras"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codbarrastrib.validator),expression:"metadata.item.codbarrastrib.validator"}],attrs:{"type":"number","col":"4","metadata":_vm.metadata.item.codbarrastrib,"name":"codbarrastrib","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.codbarrastrib),callback:function ($$v) {_vm.$set(_vm.item, "codbarrastrib", $$v)},expression:"item.codbarrastrib"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codgruest.validator),expression:"metadata.item.codgruest.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.item.codgruest,"name":"codgruest","v-errors":_vm.errors,"add-button":true,"disabled":_vm.isView},on:{"clickAdd":function($event){return _vm.handleIncluir('gruest')}},model:{value:(_vm.item.codgruest),callback:function ($$v) {_vm.$set(_vm.item, "codgruest", $$v)},expression:"item.codgruest"}})],1):_vm._e()]),_vm._v(" "),(_vm.item.tipoitem == 'S')?_c('div',[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Serviços"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.issitem.validator),expression:"metadata.item.issitem.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.item.issitem,"name":"issitem","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.issitem),callback:function ($$v) {_vm.$set(_vm.item, "issitem", $$v)},expression:"item.issitem"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.cservico.validator),expression:"metadata.item.cservico.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.item.cservico,"name":"cservico","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.cservico),callback:function ($$v) {_vm.$set(_vm.item, "cservico", $$v)},expression:"item.cservico"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.cservmun.validator),expression:"metadata.item.cservmun.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.item.cservmun,"name":"cservmun","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.cservmun),callback:function ($$v) {_vm.$set(_vm.item, "cservmun", $$v)},expression:"item.cservmun"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.cnae.validator),expression:"metadata.item.cnae.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.item.cnae,"name":"cnae","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.cnae),callback:function ($$v) {_vm.$set(_vm.item, "cnae", $$v)},expression:"item.cnae"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.aiss.validator),expression:"metadata.item.aiss.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.metadata.item.aiss,"name":"aiss","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.aiss),callback:function ($$v) {_vm.$set(_vm.item, "aiss", $$v)},expression:"item.aiss"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.item.retiss,"disabled":_vm.isView},model:{value:(_vm.item.retiss),callback:function ($$v) {_vm.$set(_vm.item, "retiss", $$v)},expression:"item.retiss"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.item.descontariss,"disabled":_vm.isView},model:{value:(_vm.item.descontariss),callback:function ($$v) {_vm.$set(_vm.item, "descontariss", $$v)},expression:"item.descontariss"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.airrf.validator),expression:"metadata.item.airrf.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.metadata.item.airrf,"name":"airrf","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.airrf),callback:function ($$v) {_vm.$set(_vm.item, "airrf", $$v)},expression:"item.airrf"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.obs_ir.validator),expression:"metadata.item.obs_ir.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.item.obs_ir,"name":"obs_ir","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.obs_ir),callback:function ($$v) {_vm.$set(_vm.item, "obs_ir", $$v)},expression:"item.obs_ir"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.item.descontarir,"disabled":_vm.isView},model:{value:(_vm.item.descontarir),callback:function ($$v) {_vm.$set(_vm.item, "descontarir", $$v)},expression:"item.descontarir"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.acsll.validator),expression:"metadata.item.acsll.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.metadata.item.acsll,"name":"acsll","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.acsll),callback:function ($$v) {_vm.$set(_vm.item, "acsll", $$v)},expression:"item.acsll"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.item.reter_csllpiscofins,"disabled":_vm.isView},model:{value:(_vm.item.reter_csllpiscofins),callback:function ($$v) {_vm.$set(_vm.item, "reter_csllpiscofins", $$v)},expression:"item.reter_csllpiscofins"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.item.reter_inss,"disabled":_vm.isView},model:{value:(_vm.item.reter_inss),callback:function ($$v) {_vm.$set(_vm.item, "reter_inss", $$v)},expression:"item.reter_inss"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.item.tipoitem == 'P')?_c('div',[_c('label-title',{staticClass:"mt-2",attrs:{"title":"Dimensão"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.comprimento.validator),expression:"metadata.item.comprimento.validator"}],attrs:{"type":"number","col":"3","metadata":_vm.metadata.item.comprimento,"name":"comprimento","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.comprimento),callback:function ($$v) {_vm.$set(_vm.item, "comprimento", $$v)},expression:"item.comprimento"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.largura.validator),expression:"metadata.item.largura.validator"}],attrs:{"type":"number","col":"3","metadata":_vm.metadata.item.largura,"name":"largura","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.largura),callback:function ($$v) {_vm.$set(_vm.item, "largura", $$v)},expression:"item.largura"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.espessura.validator),expression:"metadata.item.espessura.validator"}],attrs:{"type":"number","col":"3","metadata":_vm.metadata.item.espessura,"name":"espessura","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.espessura),callback:function ($$v) {_vm.$set(_vm.item, "espessura", $$v)},expression:"item.espessura"}})],1),_vm._v(" "),_c('label-title',{staticClass:"mt-2",attrs:{"title":"Informações Para Faturamento"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.ncm.validator),expression:"metadata.item.ncm.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.item.ncm,"name":"ncm","id":"ncm","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.ncm),callback:function ($$v) {_vm.$set(_vm.item, "ncm", $$v)},expression:"item.ncm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.exncm.validator),expression:"metadata.item.exncm.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.item.exncm,"name":"exncm","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.exncm),callback:function ($$v) {_vm.$set(_vm.item, "exncm", $$v)},expression:"item.exncm"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.item.ipiitem,"disabled":_vm.isView},model:{value:(_vm.item.ipiitem),callback:function ($$v) {_vm.$set(_vm.item, "ipiitem", $$v)},expression:"item.ipiitem"}}),_vm._v(" "),(_vm.item.ipiitem == 'T')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.aipi.validator),expression:"metadata.item.aipi.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.aipi,"precision":2,"name":"aipi","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.aipi),callback:function ($$v) {_vm.$set(_vm.item, "aipi", $$v)},expression:"item.aipi"}}):_vm._e(),_vm._v(" "),(_vm.item.ipiitem == 'T')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.ripi.validator),expression:"metadata.item.ripi.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.ripi,"precision":2,"name":"ripi","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.ripi),callback:function ($$v) {_vm.$set(_vm.item, "ripi", $$v)},expression:"item.ripi"}}):_vm._e(),_vm._v(" "),(_vm.item.ipiitem == 'T')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.pautaipi.validator),expression:"metadata.item.pautaipi.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.pautaipi,"precision":2,"name":"pautaipi","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.pautaipi),callback:function ($$v) {_vm.$set(_vm.item, "pautaipi", $$v)},expression:"item.pautaipi"}}):_vm._e(),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.item.escalaprod,"disabled":_vm.isView},model:{value:(_vm.item.escalaprod),callback:function ($$v) {_vm.$set(_vm.item, "escalaprod", $$v)},expression:"item.escalaprod"}}),_vm._v(" "),(_vm.item.escalaprod == 'N')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.cnpjfab.validator),expression:"metadata.item.cnpjfab.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.item.cnpjfab,"name":"cnpjfab","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.cnpjfab),callback:function ($$v) {_vm.$set(_vm.item, "cnpjfab", $$v)},expression:"item.cnpjfab"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.canp.validator),expression:"metadata.item.canp.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.item.canp,"name":"canp","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.canp),callback:function ($$v) {_vm.$set(_vm.item, "canp", $$v)},expression:"item.canp"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.orimerc.validator),expression:"metadata.item.orimerc.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.item.orimerc,"name":"orimerc","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.orimerc),callback:function ($$v) {_vm.$set(_vm.item, "orimerc", $$v)},expression:"item.orimerc"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.item.icmitem,"disabled":_vm.isView},model:{value:(_vm.item.icmitem),callback:function ($$v) {_vm.$set(_vm.item, "icmitem", $$v)},expression:"item.icmitem"}}),_vm._v(" "),(_vm.item.icmitem == 'T' || _vm.item.icmitem == 'R' || _vm.item.icmitem == 'O')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.aicm.validator),expression:"metadata.item.aicm.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.aicm,"precision":2,"name":"aicm","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.aicm),callback:function ($$v) {_vm.$set(_vm.item, "aicm", $$v)},expression:"item.aicm"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.cest.validator),expression:"metadata.item.cest.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.item.cest,"name":"cest","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.cest),callback:function ($$v) {_vm.$set(_vm.item, "cest", $$v)},expression:"item.cest"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.stpis.validator),expression:"metadata.item.stpis.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.item.stpis,"name":"stpis","v-errors":_vm.errors,"select2":{ entity: 'stpiscofins/saidas', minlength: 0 },"disabled":_vm.isView},model:{value:(_vm.item.stpis),callback:function ($$v) {_vm.$set(_vm.item, "stpis", $$v)},expression:"item.stpis"}}),_vm._v(" "),(_vm.item.stpis == '01' || _vm.item.stpis == '02')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.apis.validator),expression:"metadata.item.apis.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.apis,"precision":2,"name":"apis","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.apis),callback:function ($$v) {_vm.$set(_vm.item, "apis", $$v)},expression:"item.apis"}}):_vm._e(),_vm._v(" "),(_vm.item.stpis == '01' || _vm.item.stpis == '02')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.rpis.validator),expression:"metadata.item.rpis.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.rpis,"precision":2,"name":"rpis","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.rpis),callback:function ($$v) {_vm.$set(_vm.item, "rpis", $$v)},expression:"item.rpis"}}):_vm._e(),_vm._v(" "),(_vm.item.stpis == '03')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.pautapis.validator),expression:"metadata.item.pautapis.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.pautapis,"precision":2,"name":"pautapis","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.pautapis),callback:function ($$v) {_vm.$set(_vm.item, "pautapis", $$v)},expression:"item.pautapis"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.stcofins.validator),expression:"metadata.item.stcofins.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.item.stcofins,"name":"stcofins","v-errors":_vm.errors,"select2":{ entity: 'stpiscofins/saidas', minlength: 0 },"disabled":_vm.isView},model:{value:(_vm.item.stcofins),callback:function ($$v) {_vm.$set(_vm.item, "stcofins", $$v)},expression:"item.stcofins"}}),_vm._v(" "),(_vm.item.stcofins == '01' || _vm.item.stcofins == '02')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.acofins.validator),expression:"metadata.item.acofins.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.acofins,"precision":2,"name":"acofins","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.acofins),callback:function ($$v) {_vm.$set(_vm.item, "acofins", $$v)},expression:"item.acofins"}}):_vm._e(),_vm._v(" "),(_vm.item.stcofins == '01' || _vm.item.stcofins == '02')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.rcofins.validator),expression:"metadata.item.rcofins.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.rcofins,"precision":2,"name":"rcofins","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.rcofins),callback:function ($$v) {_vm.$set(_vm.item, "rcofins", $$v)},expression:"item.rcofins"}}):_vm._e(),_vm._v(" "),(_vm.item.stcofins == '03')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.pautacofins.validator),expression:"metadata.item.pautacofins.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.pautacofins,"precision":2,"name":"pautacofins","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.pautacofins),callback:function ($$v) {_vm.$set(_vm.item, "pautacofins", $$v)},expression:"item.pautacofins"}}):_vm._e()],1),_vm._v(" "),(_vm.informaFCI)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.nfci.validator),expression:"metadata.item.nfci.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.item.nfci,"name":"nfci","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.nfci),callback:function ($$v) {_vm.$set(_vm.item, "nfci", $$v)},expression:"item.nfci"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.fciconteudo.validator),expression:"metadata.item.fciconteudo.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.fciconteudo,"precision":2,"name":"fciconteudo","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.fciconteudo),callback:function ($$v) {_vm.$set(_vm.item, "fciconteudo", $$v)},expression:"item.fciconteudo"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.fciparcela.validator),expression:"metadata.item.fciparcela.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.fciparcela,"precision":2,"name":"fciparcela","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.fciparcela),callback:function ($$v) {_vm.$set(_vm.item, "fciparcela", $$v)},expression:"item.fciparcela"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.fcivenda.validator),expression:"metadata.item.fcivenda.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.fcivenda,"precision":2,"name":"fcivenda","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.fcivenda),callback:function ($$v) {_vm.$set(_vm.item, "fcivenda", $$v)},expression:"item.fcivenda"}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.item.tipoitem == 'P')?_c('div',[(!_vm.showInfEst)?_c('div',{staticClass:"mt-2 mb-2"},[_c('a',{attrs:{"href":"javascript:void(0);","tabindex":1},on:{"click":function($event){_vm.showInfEst = true}}},[_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" Exibir dados de estoque")])]):_vm._e(),_vm._v(" "),(_vm.showInfEst)?_c('div',[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Informações Para Controle de Estoque"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.coddeposito.validator),expression:"metadata.item.coddeposito.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.item.coddeposito,"name":"coddeposito","v-errors":_vm.errors,"add-button":true,"disabled":_vm.isView},on:{"clickAdd":function($event){return _vm.handleIncluir('depo')}},model:{value:(_vm.item.coddeposito),callback:function ($$v) {_vm.$set(_vm.item, "coddeposito", $$v)},expression:"item.coddeposito"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.item.controlalocal,"disabled":_vm.isView},model:{value:(_vm.item.controlalocal),callback:function ($$v) {_vm.$set(_vm.item, "controlalocal", $$v)},expression:"item.controlalocal"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.qtemb.validator),expression:"metadata.item.qtemb.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.qtemb,"precision":2,"name":"qtemb","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.qtemb),callback:function ($$v) {_vm.$set(_vm.item, "qtemb", $$v)},expression:"item.qtemb"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.qtmin.validator),expression:"metadata.item.qtmin.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.qtmin,"precision":2,"name":"qtmin","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.qtmin),callback:function ($$v) {_vm.$set(_vm.item, "qtmin", $$v)},expression:"item.qtmin"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.qtpontopedido.validator),expression:"metadata.item.qtpontopedido.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.qtpontopedido,"precision":2,"name":"qtpontopedido","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.qtpontopedido),callback:function ($$v) {_vm.$set(_vm.item, "qtpontopedido", $$v)},expression:"item.qtpontopedido"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.qtloteeco.validator),expression:"metadata.item.qtloteeco.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.qtloteeco,"precision":2,"name":"qtloteeco","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.qtloteeco),callback:function ($$v) {_vm.$set(_vm.item, "qtloteeco", $$v)},expression:"item.qtloteeco"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.qtlotemult.validator),expression:"metadata.item.qtlotemult.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.qtlotemult,"precision":2,"name":"qtlotemult","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.qtlotemult),callback:function ($$v) {_vm.$set(_vm.item, "qtlotemult", $$v)},expression:"item.qtlotemult"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.qtlotemin.validator),expression:"metadata.item.qtlotemin.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.qtlotemin,"precision":2,"name":"qtlotemin","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.qtlotemin),callback:function ($$v) {_vm.$set(_vm.item, "qtlotemin", $$v)},expression:"item.qtlotemin"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.qtlotemax.validator),expression:"metadata.item.qtlotemax.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.qtlotemax,"precision":2,"name":"qtlotemax","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.qtlotemax),callback:function ($$v) {_vm.$set(_vm.item, "qtlotemax", $$v)},expression:"item.qtlotemax"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.qtperda.validator),expression:"metadata.item.qtperda.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.qtperda,"precision":2,"name":"qtperda","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.qtperda),callback:function ($$v) {_vm.$set(_vm.item, "qtperda", $$v)},expression:"item.qtperda"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.fatorrefugo.validator),expression:"metadata.item.fatorrefugo.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.fatorrefugo,"precision":2,"name":"fatorrefugo","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.fatorrefugo),callback:function ($$v) {_vm.$set(_vm.item, "fatorrefugo", $$v)},expression:"item.fatorrefugo"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.tolerancia.validator),expression:"metadata.item.tolerancia.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.tolerancia,"precision":2,"name":"tolerancia","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.tolerancia),callback:function ($$v) {_vm.$set(_vm.item, "tolerancia", $$v)},expression:"item.tolerancia"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.temporepos.validator),expression:"metadata.item.temporepos.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.item.temporepos,"name":"temporepos","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.temporepos),callback:function ($$v) {_vm.$set(_vm.item, "temporepos", $$v)},expression:"item.temporepos"}})],1)],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"my-2"},[_c('label-title',{attrs:{"title":"Dimensão"}}),_vm._v(" "),_c('div',{staticClass:"row py-2"},[_c('div',{staticClass:"col-md-12 mb-3"},[_c('warnings',{attrs:{"messages":['Configure aqui os atributos adicionais do item, descrição complementar, ficha técnica, entre outros assuntos importantes.']}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-3"},[_c('v-button',{attrs:{"label":"Novo Atributo","tabindex":1,"disabled":_vm.isView},on:{"click":_vm.handleNewAtributo}})],1),_vm._v(" "),_vm._l((_vm.atributos.loja.complementos_descricao),function(atributo,i){return _c('div',{key:i,staticClass:"col-md-12 d-flex align-items-center"},[_c('div',{staticClass:"col-1 row justify-content-start py-1"},[(atributo.icone)?_c('i',{class:'border text-secondary p-2 fa' + ' ' + atributo.icone,staticStyle:{"font-size":"18px"}}):_c('small',{staticClass:"text-secondary"},[_vm._v("Não informado")])]),_vm._v(" "),_c('form-field',{attrs:{"type":"text","label":"Titulo","col":"4","disabled":true},model:{value:(atributo.titulo),callback:function ($$v) {_vm.$set(atributo, "titulo", $$v)},expression:"atributo.titulo"}}),_vm._v(" "),_c('i',{staticClass:"fa",class:atributo.ativo ? 'fa-check text-success mr-2' : 'fa-ban text-danger mr-2'}),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"title":"Configurar Página "},on:{"click":function($event){return _vm.handleEditAtributo(i)}}},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline text-secondary ml-1",attrs:{"title":"Deletar"},on:{"click":function($event){return _vm.handleDeleteAtributo(i)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"font-size":"17px"}})])],1)})],2)],1),_vm._v(" "),(_vm.showAtributo)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h5',[_vm._v("Novo Atributo")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","tabindex":1,"data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.closeModalAtributo}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row d-flex align-items-center"},[_c('div',{staticClass:"col-5 d-flex flex-column"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("Ícone")]),_vm._v(" "),_c('div',{staticClass:"d-inline mb-3 btn-icon"},_vm._l((_vm.iconOptions),function(icon,i){return _c('button',{key:i,staticClass:"p-2 mr-2 border text-secondary btn-icon",class:icon.selected ? 'iconSelected' : '',on:{"click":function($event){return _vm.handleSelectIcon(icon)}}},[_c('i',{class:'fa ' + icon.text,staticStyle:{"font-size":"16px"}})])}),0)]),_vm._v(" "),_c('form-field',{attrs:{"type":"text","label":"Título","col":"7"},model:{value:(_vm.atributo.titulo),callback:function ($$v) {_vm.$set(_vm.atributo, "titulo", $$v)},expression:"atributo.titulo"}})],1),_vm._v(" "),_c('div',{staticClass:"row"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('wysiwyg',{model:{value:(_vm.atributo.conteudo),callback:function ($$v) {_vm.$set(_vm.atributo, "conteudo", $$v)},expression:"atributo.conteudo"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-12"},[_c('input-checkbox',{attrs:{"label":"Ativo","value-checked":true,"value-unchecked":false},model:{value:(_vm.atributo.ativo),callback:function ($$v) {_vm.$set(_vm.atributo, "ativo", $$v)},expression:"atributo.ativo"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer mt-4"},[_c('v-button',{ref:"btnConfirm",attrs:{"label":"Salvar","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleSaveAtributo()}}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":function($event){return _vm.closeModalAtributo()}}})],1)])]):_vm._e(),_vm._v(" "),(_vm.item.tipoitem == 'P')?_c('div',[(!_vm.showCompItens && !_vm.isView)?_c('div',{staticClass:"mt-2 mb-2"},[_c('a',{attrs:{"href":"javascript:void(0);","tabindex":1},on:{"click":function($event){_vm.showCompItens = true}}},[_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" Exibir complementos do item")])]):_vm._e(),_vm._v(" "),(_vm.showCompItens || _vm.isView)?_c('div',{staticClass:"my-2"},[_c('label-title',{attrs:{"title":"Complementos do Produto"}}),_vm._v(" "),_c('div',{staticClass:"row py-2"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-3"},[_c('v-button',{attrs:{"label":"Novo Complemento","disabled":_vm.isView},on:{"click":_vm.handleNewComplemento}})],1),_vm._v(" "),(_vm.complementos.length)?_vm._l((_vm.complementos),function(complemento,i){return _c('div',{key:i,staticClass:"col-md-12 d-flex align-items-center"},[_c('form-field',{attrs:{"type":"text","label":"Descrição","col":"4"},model:{value:(complemento.descricao),callback:function ($$v) {_vm.$set(complemento, "descricao", $$v)},expression:"complemento.descricao"}}),_vm._v(" "),_c('span',{staticStyle:{"margin-top":"10px"}},[_c('input-checkbox',{attrs:{"label":"Ativo","value-checked":true,"value-unchecked":false},model:{value:(complemento.ativo),callback:function ($$v) {_vm.$set(complemento, "ativo", $$v)},expression:"complemento.ativo"}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-outline text-secondary m-1",attrs:{"title":"Deletar"},on:{"click":function($event){return _vm.handleDeleteComp(i)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"font-size":"17px","margin-top":"10px"}})])],1)}):_vm._e()],2)],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.item.tipoitem == 'P')?_c('div',[(!_vm.showProdPerigoso && !_vm.isView)?_c('div',{staticClass:"mt-2 mb-2"},[_c('a',{attrs:{"href":"javascript:void(0);","tabindex":1},on:{"click":function($event){_vm.showProdPerigoso = true}}},[_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" Exibir dados de produtos perigosos")])]):_vm._e(),_vm._v(" "),(_vm.showProdPerigoso || _vm.isView)?_c('div',[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Produtos Perigosos"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.nronu.validator),expression:"metadata.item.nronu.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.item.nronu,"name":"nronu","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.nronu),callback:function ($$v) {_vm.$set(_vm.item, "nronu", $$v)},expression:"item.nronu"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.classerisco.validator),expression:"metadata.item.classerisco.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.item.classerisco,"name":"classerisco","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.classerisco),callback:function ($$v) {_vm.$set(_vm.item, "classerisco", $$v)},expression:"item.classerisco"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.classifrisco.validator),expression:"metadata.item.classifrisco.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.item.classifrisco,"name":"classifrisco","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.classifrisco),callback:function ($$v) {_vm.$set(_vm.item, "classifrisco", $$v)},expression:"item.classifrisco"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.grupoembalagem.validator),expression:"metadata.item.grupoembalagem.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.item.grupoembalagem,"name":"grupoembalagem","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.grupoembalagem),callback:function ($$v) {_vm.$set(_vm.item, "grupoembalagem", $$v)},expression:"item.grupoembalagem"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.qtlimitada.validator),expression:"metadata.item.qtlimitada.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.item.qtlimitada,"precision":2,"name":"qtlimitada","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.qtlimitada),callback:function ($$v) {_vm.$set(_vm.item, "qtlimitada", $$v)},expression:"item.qtlimitada"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.descembarque.validator),expression:"metadata.item.descembarque.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.item.descembarque,"name":"descembarque","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.descembarque),callback:function ($$v) {_vm.$set(_vm.item, "descembarque", $$v)},expression:"item.descembarque"}})],1)],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.item.tipoitem == 'P')?_c('div',[(!_vm.showOutrasInf && !_vm.isView)?_c('div',{staticClass:"mt-2 mb-2"},[_c('a',{attrs:{"href":"javascript:void(0);","tabindex":1},on:{"click":function($event){_vm.showOutrasInf = true}}},[_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" Exibir outras informações")])]):_vm._e(),_vm._v(" "),(_vm.showOutrasInf || _vm.isView)?_c('div',[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Outras Informações"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.desccomp.validator),expression:"metadata.item.desccomp.validator"}],attrs:{"type":"memo","col":"8","metadata":_vm.metadata.item.desccomp,"name":"desccomp","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.desccomp),callback:function ($$v) {_vm.$set(_vm.item, "desccomp", $$v)},expression:"item.desccomp"}})],1),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.ecommerce.validator),expression:"metadata.item.ecommerce.validator"}],attrs:{"tabindex":1,"type":"select","col":"3","metadata":_vm.metadata.item.ecommerce,"name":"stitem","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.ecommerce),callback:function ($$v) {_vm.$set(_vm.item, "ecommerce", $$v)},expression:"item.ecommerce"}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.item.tipoitem == 'P')?_c('div',[(_vm.showPauta && _vm.isView)?_c('div',[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Tabela de Pauta ICMS"}}),_vm._v(" "),_c('div',[_vm._l((_vm.pauta),function(pauta,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{class:[{ 'mark-red': pauta.duplicate }]}),_vm._v(" "),_c('div',{staticClass:"box"},[(pauta.duplicate)?_c('div',{staticClass:"col"},[_c('small',{staticClass:"error"},[_vm._v("Estado duplicado")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[_c('form-field',{attrs:{"type":"select2","col":"4","metadata":_vm.metadata.pauta.ufdest,"disabled":_vm.isView},model:{value:(pauta.ufdest),callback:function ($$v) {_vm.$set(pauta, "ufdest", $$v)},expression:"pauta.ufdest"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.pauta.pautaicm,"precision":2,"disabled":_vm.isView},model:{value:(pauta.pautaicm),callback:function ($$v) {_vm.$set(pauta, "pautaicm", $$v)},expression:"pauta.pautaicm"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.pauta.pautaicmst,"precision":2,"disabled":_vm.isView},model:{value:(pauta.pautaicmst),callback:function ($$v) {_vm.$set(pauta, "pautaicmst", $$v)},expression:"pauta.pautaicmst"}}),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-button',{attrs:{"label":"","title":"Excluir Pauta","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeletePauta(index)}}})],1)],1)])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Adicionar Pauta","title":"","nb-btdef":true},on:{"click":_vm.handleAdicionaPauta}})],1)])],2)],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.item.tipoitem == 'P')?_c('div',[(!_vm.showDadosUni && !_vm.isView)?_c('div',{staticClass:"mt-2 mb-2"},[_c('a',{attrs:{"href":"javascript:void(0);","tabindex":1},on:{"click":function($event){_vm.showDadosUni = true}}},[_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" Exibir unidades de medida adicionais ")])]):_vm._e(),_vm._v(" "),(_vm.showDadosUni || _vm.isView)?_c('div',{staticClass:"pb-3"},[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Outras Unidades de Medida"}}),_vm._v(" "),_vm._l((_vm.itemum),function(uni,index){return _c('div',{key:index,staticClass:"d-flex"},[_c('div',{staticClass:"ml-n2",class:[{ 'mark-red': uni.duplicate || uni.validate }],staticStyle:{"height":"15% !important"}}),_vm._v(" "),_c('div',{staticClass:"box ml-1"},[(uni.duplicate)?_c('div',{staticClass:"col"},[_c('small',{staticClass:"error ml-n3"},[_vm._v("Unidade de Medida duplicada")])]):_vm._e(),_vm._v(" "),(uni.validate)?_c('div',{staticClass:"col"},[_c('small',{staticClass:"error ml-n3"},[_vm._v(_vm._s(uni.validate))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[_c('form-field',{attrs:{"type":"select2","col":"4","metadata":_vm.metadata.itemum.uni,"disabled":_vm.isView},model:{value:(uni.uni),callback:function ($$v) {_vm.$set(uni, "uni", $$v)},expression:"uni.uni"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.itemum.fatoruni,"precision":6,"disabled":_vm.isView},model:{value:(uni.fatoruni),callback:function ($$v) {_vm.$set(uni, "fatoruni", $$v)},expression:"uni.fatoruni"}}),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-button',{attrs:{"label":"","title":"Excluir Unidade de Medida","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteUni(index)}}})],1)],1)])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Adicionar Unidade de Medida","title":"","nb-btdef":true,"disabled":_vm.isView},on:{"click":_vm.handleAdicionaUni}})],1)])],2):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.item.tipoitem == 'P')?_c('div',[(!_vm.showKitForm && !_vm.isView)?_c('div',{staticClass:"mt-2 3"},[_c('a',{attrs:{"href":"javascript:void(0);","tabindex":1},on:{"click":function($event){_vm.showKitForm = true}}},[_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" Exibir itens do Kit ")])]):_vm._e(),_vm._v(" "),(_vm.showKitForm || _vm.isView)?_c('div',{staticClass:"pb-3"},[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"'Itens do Kit"}}),_vm._v(" "),_vm._l((_vm.itemkit),function(item,index){return _c('div',{key:index,staticClass:"d-flex"},[_c('div',{staticClass:"ml-n2",class:[{ 'mark-red': item.duplicate || item.validate }],staticStyle:{"height":"15% !important"}}),_vm._v(" "),_c('div',{staticClass:"box ml-1"},[(item.duplicate)?_c('div',{staticClass:"col"},[_c('small',{staticClass:"error ml-n3"},[_vm._v("Item duplicado")])]):_vm._e(),_vm._v(" "),(item.validate)?_c('div',{staticClass:"col"},[_c('small',{staticClass:"error ml-n3"},[_vm._v(_vm._s(item.validate))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[_c('form-field',{attrs:{"type":"select2","label":"Selecione um item","col":"4","metadata":_vm.metadata.pedvit.coditem,"disabled":true},on:{"input":function($event){return _vm.hasGrid(item.coditem)}},model:{value:(item.coditem),callback:function ($$v) {_vm.$set(item, "coditem", $$v)},expression:"item.coditem"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"number","label":"Quantidade","col":"2","disabled":true},model:{value:(item.qt),callback:function ($$v) {_vm.$set(item, "qt", $$v)},expression:"item.qt"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[(item.hasGrid && item.hasGrid === 'S')?_c('form-field',{attrs:{"type":"select2","col":"4","select2":{ entity: '/grades/item/' + item.coditem, minlength: 0 },"disabled":true},model:{value:(item.coditemgrade),callback:function ($$v) {_vm.$set(item, "coditemgrade", $$v)},expression:"item.coditemgrade"}}):_vm._e()],1)])])})],2):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.showDadosMarketplace && !_vm.isView && _vm.item.tipoitem == 'P')?_c('div',{staticClass:"mt-2 mb-2"},[_c('a',{attrs:{"href":"javascript:void(0);","tabindex":1},on:{"click":function($event){_vm.showDadosMarketplace = true}}},[_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" Exibir dados do marketplace ")])]):_vm._e(),_vm._v(" "),(((_vm.showDadosMarketplace || _vm.isView) && _vm.item.tipoitem == 'P'))?_c('div',[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Marketplace"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.titulomkt.validator),expression:"metadata.item.titulomkt.validator"}],attrs:{"type":"text","col":"12","metadata":_vm.metadata.item.titulomkt,"name":"titulomkt","v-errors":_vm.errors,"case":"normal","disabled":_vm.isView},model:{value:(_vm.item.titulomkt),callback:function ($$v) {_vm.$set(_vm.item, "titulomkt", $$v)},expression:"item.titulomkt"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.marcamkt.validator),expression:"metadata.item.marcamkt.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.item.marcamkt,"name":"marcamkt","v-errors":_vm.errors,"case":"normal","disabled":_vm.isView},model:{value:(_vm.item.marcamkt),callback:function ($$v) {_vm.$set(_vm.item, "marcamkt", $$v)},expression:"item.marcamkt"}}),_vm._v(" "),_c('form-field',{attrs:{"tabindex":1,"type":"select","col":"6","metadata":_vm.metadata.item.planomktml,"disabled":_vm.isView},model:{value:(_vm.item.planomktml),callback:function ($$v) {_vm.$set(_vm.item, "planomktml", $$v)},expression:"item.planomktml"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"tabindex":1,"type":"select","col":"6","metadata":_vm.metadata.item.modoenviomlmkt,"disabled":_vm.isView},model:{value:(_vm.item.modoenviomlmkt),callback:function ($$v) {_vm.$set(_vm.item, "modoenviomlmkt", $$v)},expression:"item.modoenviomlmkt"}}),_vm._v(" "),_c('form-field',{attrs:{"tabindex":1,"type":"select","col":"6","metadata":_vm.metadata.item.localpickupmlmkt,"disabled":_vm.isView},model:{value:(_vm.item.localpickupmlmkt),callback:function ($$v) {_vm.$set(_vm.item, "localpickupmlmkt", $$v)},expression:"item.localpickupmlmkt"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.descricaomkt.validator),expression:"metadata.item.descricaomkt.validator"}],attrs:{"type":"memo","col":"12","metadata":_vm.metadata.item.descricaomkt,"name":"descricaomkt","v-errors":_vm.errors,"case":"normal","disabled":_vm.isView},model:{value:(_vm.item.descricaomkt),callback:function ($$v) {_vm.$set(_vm.item, "descricaomkt", $$v)},expression:"item.descricaomkt"}})],1),_vm._v(" "),_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Categorias Marketplace"}}),_vm._v(" "),_vm._l((_vm.itemcatmkt),function(catmkt,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{class:[{ 'mark-red': catmkt.duplicate }]}),_vm._v(" "),_c('div',{staticClass:"box"},[(catmkt.duplicate)?_c('div',{staticClass:"col"},[_c('small',{staticClass:"error"},[_vm._v("Categoria Marketplace duplicada")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[_c('form-field',{attrs:{"type":"select2","col":"4","metadata":_vm.metadata.itemcatmkt.codcatmkt,"disabled":_vm.isView},on:{"input":_vm.handleCatmkt},model:{value:(catmkt.codcatmkt),callback:function ($$v) {_vm.$set(catmkt, "codcatmkt", $$v)},expression:"catmkt.codcatmkt"}}),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-button',{attrs:{"label":"","title":"Excluir Categoria Marketplace","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteCatmkt(index)}}})],1)],1)])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Adicionar Categoria Marketplace","title":"","disabled":_vm.isView,"nb-btdef":true},on:{"click":_vm.handleAdicionaCatmkt}})],1)])],2):_vm._e(),_vm._v(" "),(_vm.showDadosAtributosMercadoLivre)?_c('div',[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Atributos Mercado Livre"}}),_vm._v(" "),_vm._l((_vm.categoriesAttributes),function(atribmkt,index){return _c('div',{key:index,staticClass:"mainbox"},[(atribmkt.value_type == 'string')?_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('form-field',{attrs:{"type":"text","col":"4","metadata":atribmkt.metadata,"disabled":_vm.isView},model:{value:(atribmkt.value_name),callback:function ($$v) {_vm.$set(atribmkt, "value_name", $$v)},expression:"atribmkt.value_name"}})],1)]):_vm._e(),_vm._v(" "),(atribmkt.value_type == 'number')?_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('form-field',{attrs:{"type":"value","col":"4","precision":2,"v-errors":_vm.errors,"metadata":atribmkt.metadata,"disabled":_vm.isView},model:{value:(atribmkt.value_name),callback:function ($$v) {_vm.$set(atribmkt, "value_name", $$v)},expression:"atribmkt.value_name"}})],1)]):_vm._e(),_vm._v(" "),(atribmkt.value_type == 'list')?_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('form-field',{attrs:{"tabindex":1,"type":"select","col":"4","metadata":atribmkt.metadata,"disabled":_vm.isView},model:{value:(atribmkt.value_id),callback:function ($$v) {_vm.$set(atribmkt, "value_id", $$v)},expression:"atribmkt.value_id"}})],1)]):_vm._e(),_vm._v(" "),(atribmkt.value_type == 'boolean')?_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('form-field',{attrs:{"tabindex":1,"type":"select","col":"4","metadata":atribmkt.metadata,"disabled":_vm.isView},model:{value:(atribmkt.value_id),callback:function ($$v) {_vm.$set(atribmkt, "value_id", $$v)},expression:"atribmkt.value_id"}})],1)]):_vm._e(),_vm._v(" "),(atribmkt.value_type == 'number_unit')?_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('form-field',{attrs:{"type":"value","col":"4","precision":2,"v-errors":_vm.errors,"metadata":atribmkt.metadata,"disabled":_vm.isView},model:{value:(atribmkt.value_name),callback:function ($$v) {_vm.$set(atribmkt, "value_name", $$v)},expression:"atribmkt.value_name"}}),_vm._v(" "),_c('form-field',{attrs:{"tabindex":1,"type":"select","col":"4","metadata":atribmkt.metadata_units,"disabled":_vm.isView},model:{value:(atribmkt.value_id),callback:function ($$v) {_vm.$set(atribmkt, "value_id", $$v)},expression:"atribmkt.value_id"}})],1)]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.item.tipoitem == 'P')?_c('div',[_c('label-title',{staticClass:"mb-2 mt-2",attrs:{"title":"Controle de Grade"}}),_vm._v(" "),(!_vm.editaGrade && _vm.item.codgradel)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codgradel.validator),expression:"metadata.item.codgradel.validator"}],attrs:{"reg":"codgradel","type":"select2","col":"6","metadata":_vm.metadata.item.codgradel,"disabled":true,"name":"codgradel","v-errors":_vm.errors},model:{value:(_vm.item.codgradel),callback:function ($$v) {_vm.$set(_vm.item, "codgradel", $$v)},expression:"item.codgradel"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codgradec.validator),expression:"metadata.item.codgradec.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.item.codgradec,"disabled":true,"name":"codgradec","v-errors":_vm.errors},model:{value:(_vm.item.codgradec),callback:function ($$v) {_vm.$set(_vm.item, "codgradec", $$v)},expression:"item.codgradec"}})],1):_vm._e(),_vm._v(" "),(!_vm.editaGrade)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Definir Grade No Produto","btdef":"true","disabled":_vm.isView,"tabindex":1},on:{"click":_vm.handleHabilitaGrade}})],1)]):_vm._e(),_vm._v(" "),(_vm.editaGrade)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codgradel.validator),expression:"metadata.item.codgradel.validator"}],ref:"codgradel",attrs:{"type":"select2","col":"6","metadata":_vm.metadata.item.codgradel,"name":"codgradel","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.codgradel),callback:function ($$v) {_vm.$set(_vm.item, "codgradel", $$v)},expression:"item.codgradel"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.item.codgradec.validator),expression:"metadata.item.codgradec.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.item.codgradec,"name":"codgradec","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.item.codgradec),callback:function ($$v) {_vm.$set(_vm.item, "codgradec", $$v)},expression:"item.codgradec"}})],1):_vm._e(),_vm._v(" "),(_vm.editaGrade)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Aplicar Grade","title":"","nb-btdef":true},on:{"click":_vm.handleAplicaGrade}})],1)]):_vm._e(),_vm._v(" "),_c('div',_vm._l((_vm.gradelist),function(grade,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box py-3"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-1 col-12 text-center"},[(grade.parametros && grade.parametros.docs)?_c('img',{staticClass:"mx-auto d-block img-thumbnail",staticStyle:{"max-width":"45px","max-height":"45px"},attrs:{"src":grade.parametros.docs[0].img,"alt":"Logotipo"},on:{"click":function($event){return _vm.handleVincularImagem(grade)}}}):_c('i',{staticClass:"fa fa-camera mx-auto d-block",staticStyle:{"font-size":"25px","color":"silver","cursor":"pointer"},on:{"click":function($event){return _vm.handleVincularImagem(grade)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[(grade.corlinha)?_c('span',{staticClass:"current-color",style:('background-color: ' + grade.corlinha)}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto"},[_vm._v(" "+_vm._s(grade.descricaolinha)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[(grade.corcoluna)?_c('span',{staticClass:"current-color",style:('background-color: ' + grade.corcoluna)}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto"},[_vm._v(" "+_vm._s(grade.descricaocoluna)+" ")])]),_vm._v(" "),_c('form-field',{attrs:{"type":"text","col":"2","metadata":_vm.metadata.item.codbarras,"disabled":_vm.isView},model:{value:(grade.codbarras),callback:function ($$v) {_vm.$set(grade, "codbarras", $$v)},expression:"grade.codbarras"}}),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12"},[_c('input-switch',{attrs:{"type":"success","label":"Ativo?","value-checked":"S","value-unchecked":"N"},model:{value:(grade.ativo),callback:function ($$v) {_vm.$set(grade, "ativo", $$v)},expression:"grade.ativo"}})],1)],1)])])}),0)],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.showGruestForm)?_c('div',{staticClass:"nb-modal-mask"},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('gruest-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closeGruestForm}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.showUnimedForm)?_c('div',{staticClass:"nb-modal-mask"},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('unimed-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closeUnimedForm}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.showDepoForm)?_c('div',{staticClass:"nb-modal-mask"},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('depo-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closeDepoForm}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.showAnexosForm)?_c('anexos-selecionar-form',{attrs:{"params":{ ref: 'item', chaveref: _vm.item.coditem, title: _vm.item.descricao, showform: true }},on:{"removeform":_vm.removeAnexosForm,"saveform":_vm.saveAnexosForm,"closeform":_vm.closeAnexosForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 mb-3"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("\n              Configure aqui as observações e/ou complementos adicionais do produto.\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm && !_vm.showFormControlePedidos),expression:"!showForm && !showFormControlePedidos"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":_vm.possuiPermissao,"pdf-button":false,"xls-button":false,"gerar-etiqueta":this.gerarEtiqueta,"single-entity":"Produto","plural-entity":"Produtos","valueSearch":_vm.searchString,"moreActions":_vm.moreActionsBarList,"title-search":"Pesquise pelo código ou pela descrição"},on:{"action":_vm.handleAction,"print":_vm.showModalImprimirEtiqueta,"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),(_vm.gerarEtiqueta)?_c('div',{staticClass:"nb-product-bulkbar"},[_c('div',{staticClass:"nb-product-select-all"},[_c('input-checkbox',{attrs:{"label":"Selecionar todos","value-checked":true,"value-unchecked":false},model:{value:(_vm.marcarTodosProdutos),callback:function ($$v) {_vm.marcarTodosProdutos=$$v},expression:"marcarTodosProdutos"}})],1),_vm._v(" "),_c('span',{staticClass:"nb-product-selection-count"},[_vm._v(_vm._s(_vm.produtosSelecionados)+" selecionado(s)")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"default-container nb-product-list"},[(!_vm.itemList.length)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.itemList),function(item,index){return _c('article',{key:item.coditem || index,staticClass:"nb-product-card",class:{ 'nb-product-card--selectable': _vm.gerarEtiqueta }},[_c('div',{staticClass:"nb-product-card-top"},[_c('div',{staticClass:"nb-product-identity"},[(_vm.gerarEtiqueta)?_c('div',{staticClass:"nb-product-select"},[_c('input-checkbox',{staticClass:"nb-product-checkbox",attrs:{"label":"","value-checked":true,"value-unchecked":false},model:{value:(item.isChecked),callback:function ($$v) {_vm.$set(item, "isChecked", $$v)},expression:"item.isChecked"}})],1):_vm._e(),_vm._v(" "),_c('button',{staticClass:"nb-product-image",attrs:{"type":"button","aria-label":'Gerenciar imagem de ' + item.descricao,"title":"Gerenciar imagem"},on:{"click":function($event){return _vm.handleAnexosForm(item.coditem, item.descricao)}}},[(item.url)?_c('img',{attrs:{"src":item.url,"alt":""}}):_c('i',{staticClass:"fa fa-camera",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('div',{staticClass:"nb-product-title"},[_c('div',{staticClass:"nb-product-title-line"},[_c('h2',[_vm._v(_vm._s(item.descricao))]),_vm._v(" "),(item.stitem == 'I')?_c('span',{staticClass:"nb-product-badge nb-product-badge--inactive"},[_vm._v("\n                  "+_vm._s(_vm.textST(item.stitem))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nb-product-code"},[_vm._v("Código "),_c('strong',[_vm._v(_vm._s(item.codigo || '—'))])])])]),_vm._v(" "),_c('div',{staticClass:"nb-product-actions"},[_c('bar-grid',{attrs:{"moreActions":[],"options":{ barDefault: true, btnArchive: true, btnArchiveLabel: 'Estoque', btnEdit: _vm.possuiPermissao, btnEditLabel: 'Editar' }},on:{"edit":function($event){return _vm.handleEdit(item.coditem)},"archive":function($event){return _vm.handleArchive(item.coditem)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"nb-product-details"},[_c('div',{staticClass:"nb-product-detail"},[_c('span',{staticClass:"nb-product-detail-label"},[_vm._v("NCM")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(item.ncm || '—'))])]),_vm._v(" "),_c('div',{staticClass:"nb-product-detail"},[_c('span',{staticClass:"nb-product-detail-label"},[_vm._v("Estoque")]),_vm._v(" "),(item.saldo_estoque !== null && item.saldo_estoque !== undefined && item.saldo_estoque !== '')?_c('strong',[_vm._v("\n              "+_vm._s(item.saldo_estoque)),(item.uni)?_c('small',[_vm._v(" "+_vm._s(item.uni))]):_vm._e()]):_c('strong',[_vm._v("—")])]),_vm._v(" "),(item.bloqueio_loja)?_c('div',{staticClass:"nb-product-detail nb-product-detail--store-block"},[_c('span',{staticClass:"nb-product-detail-label"},[_vm._v("Loja")]),_vm._v(" "),_c('span',{staticClass:"nb-product-badge nb-product-badge--blocked",attrs:{"title":'Bloqueio loja: ' + item.bloqueio_loja}},[_c('i',{staticClass:"fa fa-ban",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.bloqueio_loja)+"\n            ")])]):_vm._e()])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('item-form',{attrs:{"index":_vm.coditem,"crud":_vm.crud},on:{"closeform":_vm.closeForm}}):_vm._e(),_vm._v(" "),(_vm.showFormControlePedidos)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"max-width":"700px"}},[_c('div',{staticClass:"nb-modal-scrollable-body",attrs:{"id":"mymodal"}},[_c('item-form',{attrs:{"index":_vm.coditem,"crud":_vm.crud},on:{"closeform":_vm.closeForm}})],1)])]):_vm._e(),_vm._v(" "),(_vm.showAnexosForm)?_c('anexos-form',{attrs:{"params":{ ref: 'item', chaveref: _vm.coditem, title: _vm.descricao, showform: true }},on:{"closeform":_vm.closeForm}}):_vm._e(),_vm._v(" "),(_vm.modalEtiqueta)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h5',[_vm._v("Imprimir Etiqueta")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.closeModalImprimirEtiqueta}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',[_c('form-field',{attrs:{"type":"select","label":"Tipo de Etiqueta","col":"4","select-options":_vm.listaEtiquetas},model:{value:(_vm.etiquetaSelecionada),callback:function ($$v) {_vm.etiquetaSelecionada=$$v},expression:"etiquetaSelecionada"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"container mb-3"},[_vm._m(1),_vm._v(" "),_c('table',{staticClass:"table table-sm table-borderless"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.produtosMarcados),function(produto){return _c('tr',{key:produto.id,staticClass:"border-bottom border-light"},[_c('th',{attrs:{"scope":"row"}},[_c('span',[_vm._v(_vm._s(produto.codigo))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(produto.descricao))])]),_vm._v(" "),_c('td',{staticClass:"float-right"},[_c('button',{staticClass:"btn-outline-sm",on:{"click":function($event){return _vm.deleteItemImprimirEtiqueta(produto)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" Excluir\n                  ")])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{ref:"btnConfirm",attrs:{"label":"Imprimir","title":""},on:{"click":function($event){return _vm.handleImprimirEtiqueta()}}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeModalImprimirEtiqueta}})],1)])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"nb-product-image-edit"},[_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"container mb-2"},[_c('span',[_c('strong',[_vm._v("ITENS SELECIONADOS")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"border-top border-bottom border-light"},[_c('th',{attrs:{"scope":"col"}},[_vm._v("Codigo")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Nome")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_item_importa_form_vue__ = __webpack_require__(514);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_35d0bca1_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_item_importa_form_vue__ = __webpack_require__(1436);
function injectStyle (ssrContext) {
  __webpack_require__(1434)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_item_importa_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_35d0bca1_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_item_importa_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1435);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5fbcfb22", content, true, {});

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',[_c('bar-manut',{attrs:{"single-entity":"Importação de Produtos","disableSave":true},on:{"closeform":_vm.handleVoltar}}),_vm._v(" "),(_vm.estagio == 'inicio')?_c('div',{staticClass:"default-container"},[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Planilha Modelo"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl"},[_vm._v("Efetue o download da planilha modelo.")]),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("Preencha as colunas da planilha com os dados dos produtos a serem importados, respeitando a ordem das colunas.")]),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("A importação não será realizada caso a planilha esteja em formato diferente da planilha de modelo.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Download da planilha modelo","icon":"fa-download"},on:{"click":function($event){return _vm.handleDownloadModelo()}}})],1)]),_vm._v(" "),_c('label-title',{staticClass:"mt-5",attrs:{"title":"Selecionar Arquivo Para Importação"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"100px"}},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl"},[_vm._v("Selecione o arquivo a ser importado.")]),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("Os produtos da planilha inexistentes no sistema serão inseridos. Os demais serão atualizados.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Selecionar Arquivo","nb-btdef":false,"icon":"fa-upload"},on:{"click":function($event){return _vm.handleSelecionarArquivo()}}}),_vm._v("\n                    "+_vm._s(_vm.selectedFile.name)+"\n                    "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('input',{ref:"file",attrs:{"type":"file","accept":".csv"},on:{"change":function($event){return _vm.handleFileChange()}}})])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[(_vm.errmessage)?_c('alert',{attrs:{"type":"warning","title":"Erro na importação do arquivo","text":_vm.errmessage}}):_vm._e()],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Continuar","nb-btdef":true},on:{"click":function($event){return _vm.handleAnalisarArquivo()}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":function($event){return _vm.handleVoltar()}}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.estagio == 'showresumo')?_c('div',{staticClass:"default-container"},[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Resumo da Importação"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"100px"}},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"lbl"},[_c('strong',[_vm._v(_vm._s(_vm.dadosResumo.novos))])]),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(" produtos serão inseridos. ")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){return _vm.handleExportaResumo('novo')}}},[_vm._v("Visualizar")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"lbl"},[_c('strong',[_vm._v(_vm._s(_vm.dadosResumo.alterados))])]),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(" produtos serão atualizados. ")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){return _vm.handleExportaResumo('alterar')}}},[_vm._v("Visualizar")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"lbl"},[_c('strong',[_vm._v(_vm._s(_vm.dadosResumo.naoimportados))])]),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(" não serão importados. ")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){return _vm.handleExportaResumo('naoimportado')}}},[_vm._v("Visualizar")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('alert',{attrs:{"type":"warning","title":"Confirmar Importação","text":"A importação ainda não foi efetuada. Confirme para efetivar."}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-2"},[(_vm.dadosResumo.novos == 0 && _vm.dadosResumo.alterados == 0)?_c('v-button',{attrs:{"label":"Selecionar Outro Arquivo","nb-btdef":true},on:{"click":function($event){return _vm.handleSelecionarOutro()}}}):_vm._e(),_vm._v(" "),(_vm.dadosResumo.novos > 0 || _vm.dadosResumo.alterados > 0)?_c('v-button',{attrs:{"label":"Confirmar Importação","nb-btdef":true},on:{"click":function($event){return _vm.handleConfirmarImportacao()}}}):_vm._e(),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":function($event){return _vm.handleVoltar()}}})],1)])],1):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_item_importa_estoque_form_vue__ = __webpack_require__(515);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cbb4aa0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_item_importa_estoque_form_vue__ = __webpack_require__(1440);
function injectStyle (ssrContext) {
  __webpack_require__(1438)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_item_importa_estoque_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cbb4aa0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_item_importa_estoque_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1439);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("69c6b772", content, true, {});

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',[_c('bar-manut',{attrs:{"single-entity":"Importação de estoque dos Produtos","disableSave":true},on:{"closeform":_vm.handleVoltar}}),_vm._v(" "),(_vm.estagio == 'inicio')?_c('div',{staticClass:"default-container"},[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Planilha Modelo"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"50px"}},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl"},[_vm._v("Efetue o download da planilha modelo.")]),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("Preencha as colunas da planilha com os dados do estoque a serem importados, respeitando a ordem das colunas.")]),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("A importação não será realizada caso a planilha esteja em formato diferente da planilha de modelo.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Download da planilha modelo","icon":"fa-download"},on:{"click":function($event){return _vm.handleDownloadModelo()}}})],1)]),_vm._v(" "),_c('label-title',{staticClass:"mb-2",attrs:{"title":"Planilha Modelo com dados dos produtos"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"50px"}},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl"},[_vm._v("Efetue o download da planilha modelo com os dados dos produtos cadastratos.")]),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("Preencha as colunas da planilha com os dados do estoque a serem importados, respeitando a ordem das colunas.")]),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("A importação não será realizada caso a planilha esteja em formato diferente da planilha de modelo.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Download da planilha modelo","icon":"fa-download"},on:{"click":function($event){return _vm.handleDownloadModeloComDados()}}})],1)]),_vm._v(" "),_c('label-title',{staticClass:"mt-5",attrs:{"title":"Selecionar Arquivo Para Importação"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"100px"}},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl"},[_vm._v("Selecione o arquivo a ser importado.")]),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("O estoque dos produtos da planilha serão inseridos ou atualizados.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Selecionar Arquivo","nb-btdef":false,"icon":"fa-upload"},on:{"click":function($event){return _vm.handleSelecionarArquivo()}}}),_vm._v("\n                    "+_vm._s(_vm.selectedFile.name)+"\n                    "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('input',{ref:"file",attrs:{"type":"file","accept":".csv"},on:{"change":function($event){return _vm.handleFileChange()}}})])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[(_vm.errmessage)?_c('alert',{attrs:{"type":"warning","title":"Erro na importação do arquivo","text":_vm.errmessage}}):_vm._e()],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Continuar","nb-btdef":true},on:{"click":function($event){return _vm.handleAnalisarArquivo()}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":function($event){return _vm.handleVoltar()}}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.estagio == 'showresumo')?_c('div',{staticClass:"default-container"},[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Resumo da Importação"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"100px"}},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"lbl"},[_c('strong',[_vm._v(_vm._s(_vm.dadosResumo.importados))])]),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(" estoque que serão importados. ")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){return _vm.handleExportaResumo('importado')}}},[_vm._v("Visualizar")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"lbl"},[_c('strong',[_vm._v(_vm._s(_vm.dadosResumo.naoimportados))])]),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(" não serão importados. ")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){return _vm.handleExportaResumo('naoimportado')}}},[_vm._v("Visualizar")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('alert',{attrs:{"type":"warning","title":"Confirmar Importação","text":"A importação ainda não foi efetuada. Confirme para efetivar."}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-2"},[(_vm.dadosResumo.importados == 0)?_c('v-button',{attrs:{"label":"Selecionar Outro Arquivo","nb-btdef":true},on:{"click":function($event){return _vm.handleSelecionarOutro()}}}):_vm._e(),_vm._v(" "),(_vm.dadosResumo.importados > 0)?_c('v-button',{attrs:{"label":"Confirmar Importação","nb-btdef":true},on:{"click":function($event){return _vm.handleConfirmarImportacao()}}}):_vm._e(),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":function($event){return _vm.handleVoltar()}}})],1)])],1):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1442);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5f8cd9ad", content, true, {});

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-19be116a]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-19be116a]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-19be116a]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-19be116a]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-19be116a]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-19be116a]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-19be116a]{flex:1;min-width:0}.nb-card-title-line[data-v-19be116a]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-19be116a]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-19be116a]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-19be116a]{color:#334155;font-weight:600}.nb-card-badge[data-v-19be116a]{display:inline-flex;align-items:center;gap:4px;padding:4px 7px;border:1px solid transparent;border-radius:5px;font-size:10px;font-weight:700;line-height:1.2}.nb-card-badge--success[data-v-19be116a]{color:#166534;background:#f0fdf4;border-color:#bbf7d0}.nb-card-badge--inactive[data-v-19be116a]{color:#92400e;background:#fffbeb;border-color:#fde68a}.nb-card-actions[data-v-19be116a]{flex:0 0 auto}.nb-card-details[data-v-19be116a]{display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:12px;margin:12px 0 0 60px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-card-detail[data-v-19be116a]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-card-detail-label[data-v-19be116a]{color:#64748b;font-size:11px}.nb-card-detail>strong[data-v-19be116a]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}@media (max-width:767.98px){.nb-card-top[data-v-19be116a]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-19be116a]{align-self:flex-end}.nb-card-details[data-v-19be116a]{margin-left:0}}", ""]);

// exports


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1444);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3b7c07c4", content, true, {});

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"natesForm"}},[_c('bar-manut',{attrs:{"single-entity":"Natureza","plural-entity":"Naturezas","crud":this.crud},on:{"closeform":_vm.closeForm,"save":_vm.handleSave}}),_vm._v(" "),(_vm.errmessages.length != 0)?_c('validation',{attrs:{"messages":_vm.errmessages}}):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[_c('label-title',{attrs:{"title":"Dados da Natureza"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"metadata":_vm.metadata.nates.codnates,"type":"text","col":"2","disabled":true},model:{value:(_vm.nates.codnates),callback:function ($$v) {_vm.$set(_vm.nates, "codnates", $$v)},expression:"nates.codnates"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.tpnat},model:{value:(_vm.nates.tpnat),callback:function ($$v) {_vm.$set(_vm.nates, "tpnat", $$v)},expression:"nates.tpnat"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.tpnf},model:{value:(_vm.nates.tpnf),callback:function ($$v) {_vm.$set(_vm.nates, "tpnf", $$v)},expression:"nates.tpnf"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.movfisica},model:{value:(_vm.nates.movfisica),callback:function ($$v) {_vm.$set(_vm.nates, "movfisica", $$v)},expression:"nates.movfisica"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.descricao.validator),expression:"metadata.nates.descricao.validator"}],ref:"descricao",attrs:{"type":"text","col":"6","metadata":_vm.metadata.nates.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.nates.descricao),callback:function ($$v) {_vm.$set(_vm.nates, "descricao", $$v)},expression:"nates.descricao"}}),_vm._v(" "),(_vm.nates.tpnat == 'E')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.cfop.validator),expression:"metadata.nates.cfop.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.nates.cfop,"select2":{ entity: 'cfop/entradas', minlength: 0 },"name":"cfop","v-errors":_vm.errors},model:{value:(_vm.nates.cfop),callback:function ($$v) {_vm.$set(_vm.nates, "cfop", $$v)},expression:"nates.cfop"}}):_vm._e(),_vm._v(" "),(_vm.nates.tpnat == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.cfop.validator),expression:"metadata.nates.cfop.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.nates.cfop,"select2":{ entity: 'cfop/saidas', minlength: 0 },"name":"cfop","v-errors":_vm.errors},model:{value:(_vm.nates.cfop),callback:function ($$v) {_vm.$set(_vm.nates, "cfop", $$v)},expression:"nates.cfop"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.exibirCalculaDuplicata)?_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.calcdup},model:{value:(_vm.nates.calcdup),callback:function ($$v) {_vm.$set(_vm.nates, "calcdup", $$v)},expression:"nates.calcdup"}}):_vm._e()],1),_vm._v(" "),(_vm.nates.tpnat == 'E')?_c('div',[_c('label-title',{attrs:{"title":"Impostos na Entrada"}}),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.nates.tpnf == 'C')?_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.nates.finentrada},model:{value:(_vm.nates.finentrada),callback:function ($$v) {_vm.$set(_vm.nates, "finentrada", $$v)},expression:"nates.finentrada"}}):_vm._e(),_vm._v(" "),(_vm.cfopImportacao)?_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.nates.calcii},model:{value:(_vm.nates.calcii),callback:function ($$v) {_vm.$set(_vm.nates, "calcii", $$v)},expression:"nates.calcii"}}):_vm._e(),_vm._v(" "),(_vm.cfopImportacao && _vm.nates.calcii == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.aii.validator),expression:"metadata.nates.aii.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nates.aii,"precision":6,"name":"aii","v-errors":_vm.errors},model:{value:(_vm.nates.aii),callback:function ($$v) {_vm.$set(_vm.nates, "aii", $$v)},expression:"nates.aii"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.sticm.validator),expression:"metadata.nates.sticm.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nates.sticm,"name":"sticm","v-errors":_vm.errors},model:{value:(_vm.nates.sticm),callback:function ($$v) {_vm.$set(_vm.nates, "sticm", $$v)},expression:"nates.sticm"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.csosn.validator),expression:"metadata.nates.csosn.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.nates.csosn,"name":"csosn","v-errors":_vm.errors},model:{value:(_vm.nates.csosn),callback:function ($$v) {_vm.$set(_vm.nates, "csosn", $$v)},expression:"nates.csosn"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.stipi.validator),expression:"metadata.nates.stipi.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nates.stipi,"name":"stipi","v-errors":_vm.errors,"select2":{ entity: 'stipi/entradas', minlength: 0 }},model:{value:(_vm.nates.stipi),callback:function ($$v) {_vm.$set(_vm.nates, "stipi", $$v)},expression:"nates.stipi"}}),_vm._v(" "),(_vm.nates.stipi == '49' || _vm.nates.stipi == '00')?_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.ipidevol},model:{value:(_vm.nates.ipidevol),callback:function ($$v) {_vm.$set(_vm.nates, "ipidevol", $$v)},expression:"nates.ipidevol"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.stpis.validator),expression:"metadata.nates.stpis.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nates.stpis,"name":"stpis","v-errors":_vm.errors,"select2":{ entity: 'stpiscofins/entradas', minlength: 0 }},model:{value:(_vm.nates.stpis),callback:function ($$v) {_vm.$set(_vm.nates, "stpis", $$v)},expression:"nates.stpis"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.stcofins.validator),expression:"metadata.nates.stcofins.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nates.stcofins,"name":"stcofins","v-errors":_vm.errors,"select2":{ entity: 'stpiscofins/entradas', minlength: 0 }},model:{value:(_vm.nates.stcofins),callback:function ($$v) {_vm.$set(_vm.nates, "stcofins", $$v)},expression:"nates.stcofins"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.nates.tpnat == 'S')?_c('div',[_c('label-title',{attrs:{"title":"ICMS"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.calcicm},model:{value:(_vm.nates.calcicm),callback:function ($$v) {_vm.$set(_vm.nates, "calcicm", $$v)},expression:"nates.calcicm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.sticm.validator),expression:"metadata.nates.sticm.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nates.sticm,"name":"sticm","v-errors":_vm.errors},model:{value:(_vm.nates.sticm),callback:function ($$v) {_vm.$set(_vm.nates, "sticm", $$v)},expression:"nates.sticm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.csosn.validator),expression:"metadata.nates.csosn.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.nates.csosn,"name":"csosn","v-errors":_vm.errors},model:{value:(_vm.nates.csosn),callback:function ($$v) {_vm.$set(_vm.nates, "csosn", $$v)},expression:"nates.csosn"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.calcst},model:{value:(_vm.nates.calcst),callback:function ($$v) {_vm.$set(_vm.nates, "calcst", $$v)},expression:"nates.calcst"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.calcicmfre},model:{value:(_vm.nates.calcicmfre),callback:function ($$v) {_vm.$set(_vm.nates, "calcicmfre", $$v)},expression:"nates.calcicmfre"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.calcicmdesp},model:{value:(_vm.nates.calcicmdesp),callback:function ($$v) {_vm.$set(_vm.nates, "calcicmdesp", $$v)},expression:"nates.calcicmdesp"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.nates.tpnf == 'V' || _vm.nates.tpnf == 'I' )?_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.calcaprovcred},model:{value:(_vm.nates.calcaprovcred),callback:function ($$v) {_vm.$set(_vm.nates, "calcaprovcred", $$v)},expression:"nates.calcaprovcred"}}):_vm._e(),_vm._v(" "),(_vm.nates.tpnf == 'V')?_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.calcdesicm},model:{value:(_vm.nates.calcdesicm),callback:function ($$v) {_vm.$set(_vm.nates, "calcdesicm", $$v)},expression:"nates.calcdesicm"}}):_vm._e(),_vm._v(" "),(_vm.nates.calcdesicm == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.pdesicm.validator),expression:"metadata.nates.pdesicm.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.metadata.nates.pdesicm,"precision":2,"name":"pdesicm","v-errors":_vm.errors},model:{value:(_vm.nates.pdesicm),callback:function ($$v) {_vm.$set(_vm.nates, "pdesicm", $$v)},expression:"nates.pdesicm"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.nates.tpnf == 'V')?_c('form-field',{attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nates.motdesicm,"name":"motdesicm"},model:{value:(_vm.nates.motdesicm),callback:function ($$v) {_vm.$set(_vm.nates, "motdesicm", $$v)},expression:"nates.motdesicm"}}):_vm._e(),_vm._v(" "),(_vm.nates.tpnf == 'V')?_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.soma_icmdeson_nf},model:{value:(_vm.nates.soma_icmdeson_nf),callback:function ($$v) {_vm.$set(_vm.nates, "soma_icmdeson_nf", $$v)},expression:"nates.soma_icmdeson_nf"}}):_vm._e()],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Cálculo de IPI"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.calcipi},model:{value:(_vm.nates.calcipi),callback:function ($$v) {_vm.$set(_vm.nates, "calcipi", $$v)},expression:"nates.calcipi"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.cenqipi.validator),expression:"metadata.nates.cenqipi.validator"}],attrs:{"type":"number","col":"4","metadata":_vm.metadata.nates.cenqipi,"name":"cenqipi","v-errors":_vm.errors},model:{value:(_vm.nates.cenqipi),callback:function ($$v) {_vm.$set(_vm.nates, "cenqipi", $$v)},expression:"nates.cenqipi"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.calcipifre},model:{value:(_vm.nates.calcipifre),callback:function ($$v) {_vm.$set(_vm.nates, "calcipifre", $$v)},expression:"nates.calcipifre"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.calcipidesp},model:{value:(_vm.nates.calcipidesp),callback:function ($$v) {_vm.$set(_vm.nates, "calcipidesp", $$v)},expression:"nates.calcipidesp"}}),_vm._v(" "),(_vm.nates.calcipi == 'N')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.stipi.validator),expression:"metadata.nates.stipi.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nates.stipi,"name":"stipi","v-errors":_vm.errors,"select2":{ entity: 'stipi/saidas', minlength: 0 }},model:{value:(_vm.nates.stipi),callback:function ($$v) {_vm.$set(_vm.nates, "stipi", $$v)},expression:"nates.stipi"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.nates.stipi == '50' || _vm.nates.stipi == '99')?_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.ipidevol},model:{value:(_vm.nates.ipidevol),callback:function ($$v) {_vm.$set(_vm.nates, "ipidevol", $$v)},expression:"nates.ipidevol"}}):_vm._e()],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Cálculo de PIS e COFINS"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.calcpis},model:{value:(_vm.nates.calcpis),callback:function ($$v) {_vm.$set(_vm.nates, "calcpis", $$v)},expression:"nates.calcpis"}}),_vm._v(" "),(_vm.nates.calcpis == 'N')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.stpis.validator),expression:"metadata.nates.stpis.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nates.stpis,"name":"stpis","v-errors":_vm.errors,"select2":{ entity: 'stpiscofins/saidas', minlength: 0 }},model:{value:(_vm.nates.stpis),callback:function ($$v) {_vm.$set(_vm.nates, "stpis", $$v)},expression:"nates.stpis"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.calccofins},model:{value:(_vm.nates.calccofins),callback:function ($$v) {_vm.$set(_vm.nates, "calccofins", $$v)},expression:"nates.calccofins"}}),_vm._v(" "),(_vm.nates.calccofins == 'N')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.stcofins.validator),expression:"metadata.nates.stcofins.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nates.stcofins,"name":"stcofins","v-errors":_vm.errors,"select2":{ entity: 'stpiscofins/saidas', minlength: 0 }},model:{value:(_vm.nates.stcofins),callback:function ($$v) {_vm.$set(_vm.nates, "stcofins", $$v)},expression:"nates.stcofins"}}):_vm._e(),_vm._v(" "),(_vm.nates.tpnf == 'V')?_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.calcdespc},model:{value:(_vm.nates.calcdespc),callback:function ($$v) {_vm.$set(_vm.nates, "calcdespc", $$v)},expression:"nates.calcdespc"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.nates.calcdespc == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.pdespc.validator),expression:"metadata.nates.pdespc.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.metadata.nates.pdespc,"precision":2,"name":"pdespc","v-errors":_vm.errors},model:{value:(_vm.nates.pdespc),callback:function ($$v) {_vm.$set(_vm.nates, "pdespc", $$v)},expression:"nates.pdespc"}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('label-title',{attrs:{"title":"Outras Informações"}}),_vm._v(" "),_c('div',{staticClass:"row"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.codmennf1.validator),expression:"metadata.nates.codmennf1.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nates.codmennf1,"name":"codmennf1","v-errors":_vm.errors},model:{value:(_vm.nates.codmennf1),callback:function ($$v) {_vm.$set(_vm.nates, "codmennf1", $$v)},expression:"nates.codmennf1"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.codmennf2.validator),expression:"metadata.nates.codmennf2.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nates.codmennf2,"name":"codmennf2","v-errors":_vm.errors},model:{value:(_vm.nates.codmennf2),callback:function ($$v) {_vm.$set(_vm.nates, "codmennf2", $$v)},expression:"nates.codmennf2"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.codmennf3.validator),expression:"metadata.nates.codmennf3.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nates.codmennf3,"name":"codmennf3","v-errors":_vm.errors},model:{value:(_vm.nates.codmennf3),callback:function ($$v) {_vm.$set(_vm.nates, "codmennf3", $$v)},expression:"nates.codmennf3"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Impostos Unificados (IBS e CBS)"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.natescclass.validator),expression:"metadata.nates.natescclass.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nates.natescclass,"disabled":_vm.isView,"name":"natescclass","v-errors":_vm.errors,"parent":"mymodal","select2":{ entity: 'ivaclass', minlength: 0 }},model:{value:(_vm.nates.natescclass),callback:function ($$v) {_vm.$set(_vm.nates, "natescclass", $$v)},expression:"nates.natescclass"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.ivatributacao.validator),expression:"metadata.nates.ivatributacao.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.nates.ivatributacao,"name":"sticm","v-errors":_vm.errors},model:{value:(_vm.nates.ivatributacao),callback:function ($$v) {_vm.$set(_vm.nates, "ivatributacao", $$v)},expression:"nates.ivatributacao"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nates.natesccredpres.validator),expression:"metadata.nates.natesccredpres.validator"}],attrs:{"type":"select","col":"6","metadata":_vm.metadata.nates.natesccredpres,"name":"natesccredpres","v-errors":_vm.errors},model:{value:(_vm.nates.natesccredpres),callback:function ($$v) {_vm.$set(_vm.nates, "natesccredpres", $$v)},expression:"nates.natesccredpres"}})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Natureza","plural-entity":"Naturezas","title-search":"Pesquise pelo CFOP ou pela descrição"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('tabs',{attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[((_vm.tabSaida && (!_vm.natesListSaida || _vm.natesListSaida.length == 0)) || (_vm.tabEntrada && (!_vm.natesListEntrada || _vm.natesListEntrada.length == 0)))?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.natesListSaida),function(nates){return (_vm.tabSaida)?_c('article',{key:nates.codnates,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(nates.descricao))]),_vm._v(" "),(nates.stnates)?_c('span',{staticClass:"nb-card-badge",class:nates.stnates == 'A' ? 'nb-card-badge--success' : 'nb-card-badge--inactive'},[_vm._v("\n                                    "+_vm._s(_vm.textStatus(nates.stnates))+"\n                                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                CFOP "),_c('strong',[_vm._v(_vm._s(nates.cfop))]),_vm._v(" "),(nates.codnates)?_c('span',{staticClass:"ml-2"},[_vm._v("Código "),_c('strong',[_vm._v(_vm._s(nates.codnates))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: false, btnEdit: true, btnEditLabel: 'Editar'},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(nates.codnates)},"view":function($event){return _vm.handleEdit(nates.codnates, true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"nb-card-details"},[(_vm.metadata && _vm.metadata.nates && _vm.metadata.nates.tpnat)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v(_vm._s(_vm.metadata.nates.tpnat.label))]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("getText")(nates.tpnat,_vm.metadata.nates.tpnat)))])]):_vm._e(),_vm._v(" "),(_vm.metadata && _vm.metadata.nates && _vm.metadata.nates.tpnf)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v(_vm._s(_vm.metadata.nates.tpnf.label))]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("getText")(nates.tpnf,_vm.metadata.nates.tpnf)))])]):_vm._e()])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.natesListEntrada),function(nates){return (_vm.tabEntrada)?_c('article',{key:nates.codnates,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(nates.descricao))]),_vm._v(" "),(nates.stnates)?_c('span',{staticClass:"nb-card-badge",class:nates.stnates == 'A' ? 'nb-card-badge--success' : 'nb-card-badge--inactive'},[_vm._v("\n                                    "+_vm._s(_vm.textStatus(nates.stnates))+"\n                                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                CFOP "),_c('strong',[_vm._v(_vm._s(nates.cfop))]),_vm._v(" "),(nates.codnates)?_c('span',{staticClass:"ml-2"},[_vm._v("Código "),_c('strong',[_vm._v(_vm._s(nates.codnates))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: false, btnEdit: true, btnEditLabel: 'Editar'},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(nates.codnates)},"view":function($event){return _vm.handleEdit(nates.codnates, true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"nb-card-details"},[(_vm.metadata && _vm.metadata.nates && _vm.metadata.nates.tpnat)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v(_vm._s(_vm.metadata.nates.tpnat.label))]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("getText")(nates.tpnat,_vm.metadata.nates.tpnat)))])]):_vm._e(),_vm._v(" "),(_vm.metadata && _vm.metadata.nates && _vm.metadata.nates.tpnf)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v(_vm._s(_vm.metadata.nates.tpnf.label))]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("getText")(nates.tpnf,_vm.metadata.nates.tpnf)))])]):_vm._e()])]):_vm._e()})],2)],1),_vm._v(" "),(_vm.showForm)?_c('nates-form',{attrs:{"index":this.codnates,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-file-text-o",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-file-text-o",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1448);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4046cf30", content, true, {});

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-5aa3d8de]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-5aa3d8de]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-5aa3d8de]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-5aa3d8de]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-5aa3d8de]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-unit[data-v-5aa3d8de]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:15px;font-weight:700;text-transform:uppercase}.nb-card-title[data-v-5aa3d8de]{flex:1;min-width:0}.nb-card-title-line[data-v-5aa3d8de]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-5aa3d8de]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-5aa3d8de]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-5aa3d8de]{color:#334155;font-weight:600}.nb-card-actions[data-v-5aa3d8de]{flex:0 0 auto}.nb-card-details[data-v-5aa3d8de]{display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:12px;margin:12px 0 0 60px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-card-detail[data-v-5aa3d8de]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-card-detail-label[data-v-5aa3d8de]{color:#64748b;font-size:11px}.nb-card-detail>strong[data-v-5aa3d8de]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}@media (max-width:767.98px){.nb-card-top[data-v-5aa3d8de]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-5aa3d8de]{align-self:flex-end}.nb-card-details[data-v-5aa3d8de]{margin-left:0}}", ""]);

// exports


/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_estado_form_vue__ = __webpack_require__(520);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_403aab83_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_estado_form_vue__ = __webpack_require__(1452);
function injectStyle (ssrContext) {
  __webpack_require__(1450)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_estado_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_403aab83_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_estado_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1451);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("aabb03a4", content, true, {});

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Estado","plural-entity":"Estados","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),(_vm.errmessages.length != 0)?_c('validation',{attrs:{"messages":_vm.errmessages}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.estado.uf.validator),expression:"metadata.estado.uf.validator"}],attrs:{"metadata":_vm.metadata.estado.uf,"type":"text","col":"2","disabled":_vm.editing,"name":"uf","v-errors":_vm.errors},model:{value:(_vm.estado.uf),callback:function ($$v) {_vm.$set(_vm.estado, "uf", $$v)},expression:"estado.uf"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.estado.nomeuf.validator),expression:"metadata.estado.nomeuf.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.estado.nomeuf,"name":"nomeuf","v-errors":_vm.errors},model:{value:(_vm.estado.nomeuf),callback:function ($$v) {_vm.$set(_vm.estado, "nomeuf", $$v)},expression:"estado.nomeuf"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.estado.codibge.validator),expression:"metadata.estado.codibge.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.estado.codibge,"name":"codibge","v-errors":_vm.errors},model:{value:(_vm.estado.codibge),callback:function ($$v) {_vm.$set(_vm.estado, "codibge", $$v)},expression:"estado.codibge"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.estado.aicminterno.validator),expression:"metadata.estado.aicminterno.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.estado.aicminterno,"precision":2,"name":"aicminterno","v-errors":_vm.errors},model:{value:(_vm.estado.aicminterno),callback:function ($$v) {_vm.$set(_vm.estado, "aicminterno", $$v)},expression:"estado.aicminterno"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.estado.aicminter.validator),expression:"metadata.estado.aicminter.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.estado.aicminter,"precision":2,"name":"aicminter","v-errors":_vm.errors},model:{value:(_vm.estado.aicminter),callback:function ($$v) {_vm.$set(_vm.estado, "aicminter", $$v)},expression:"estado.aicminter"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.estado.mva.validator),expression:"metadata.estado.mva.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.estado.mva,"precision":2,"name":"mva","v-errors":_vm.errors},model:{value:(_vm.estado.mva),callback:function ($$v) {_vm.$set(_vm.estado, "mva", $$v)},expression:"estado.mva"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.estado.ricm.validator),expression:"metadata.estado.ricm.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.estado.ricm,"precision":2,"name":"ricm","v-errors":_vm.errors},model:{value:(_vm.estado.ricm),callback:function ($$v) {_vm.$set(_vm.estado, "ricm", $$v)},expression:"estado.ricm"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Estado","plural-entity":"Estados","title-search":"Pesquise pela UF ou pelo nome"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.estadoList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.estadoList),function(estado){return _c('article',{key:estado.uf,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_c('div',{staticClass:"nb-card-unit"},[_vm._v("\n                            "+_vm._s(estado.uf)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(estado.nomeuf))])]),_vm._v(" "),_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                UF "),_c('strong',[_vm._v(_vm._s(estado.uf))])])])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: true, btnEditLabel: 'Editar'},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(estado.uf)},"view":function($event){return _vm.handleEdit(estado.uf, true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"nb-card-details"},[(_vm.metadata && _vm.metadata.estado && _vm.metadata.estado.aicminterno)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v(_vm._s(_vm.metadata.estado.aicminterno.label))]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(estado.aicminterno))+"%")])]):_vm._e(),_vm._v(" "),(_vm.metadata && _vm.metadata.estado && _vm.metadata.estado.aicminter)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v(_vm._s(_vm.metadata.estado.aicminter.label))]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(estado.aicminter))+"%")])]):_vm._e(),_vm._v(" "),(_vm.metadata && _vm.metadata.estado && _vm.metadata.estado.ricm)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v(_vm._s(_vm.metadata.estado.ricm.label))]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(estado.ricm))+"%")])]):_vm._e(),_vm._v(" "),(_vm.metadata && _vm.metadata.estado && _vm.metadata.estado.mva)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v(_vm._s(_vm.metadata.estado.mva.label))]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(estado.mva))+"%")])]):_vm._e()])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('estado-form',{attrs:{"index":this.uf,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_ivaclass_list_vue__ = __webpack_require__(521);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_668f1d4e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_ivaclass_list_vue__ = __webpack_require__(1457);
function injectStyle (ssrContext) {
  __webpack_require__(1455)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_ivaclass_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_668f1d4e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_ivaclass_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1456);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("20e11b9c", content, true, {});

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":false,"pdf-button":false,"xls-button":false,"single-entity":"Classificação Tributária do IBS e CBS ","plural-entity":"Classificações Tributária do IBS e CBS ","title-search":"Pesquise pelo NCM ou pelo Classificação"},on:{"search":_vm.search,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.ivaclassList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.ivaclassList),function(ivaclass){return _c('div',{key:ivaclass.cclass,staticClass:"mainbox"},[_c('div',{staticClass:"mark-green"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-12"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(ivaclass.nome)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" Cod. Class ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.cclass))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" CST ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.cst))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" Desc. CST ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.desst))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" Nome ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" Descrição ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.des))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" % Red. CBS ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.predcbs))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" % Red. IBS ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.predibs))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" Trib. Regular ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.gtribregular))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" Cred. Pres. ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.credpres))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" Redutor Bc. ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.redutorbc))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" Mono ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.mono))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" Mono Ret. ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.monoret))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" Mono Reten ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.monoreten))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" Mono Dif. ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.monodif))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" G. ibscbs ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.ind_gibscbs))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" G. Ibscbsmono ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.ind_gibscbsmono))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" G. red ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.ind_gred))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" G. Dif. ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.ind_gdif))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" G. Transf Cred ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivaclass.ind_gtransfcred))])])])])])})],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_ivancm_list_vue__ = __webpack_require__(522);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_32c6aea4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_ivancm_list_vue__ = __webpack_require__(1465);
function injectStyle (ssrContext) {
  __webpack_require__(1459)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_ivancm_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_32c6aea4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_ivancm_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1460);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("09e61e29", content, true, {});

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_ivancm_form_vue__ = __webpack_require__(523);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dc986ee_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_ivancm_form_vue__ = __webpack_require__(1464);
function injectStyle (ssrContext) {
  __webpack_require__(1462)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_ivancm_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dc986ee_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_ivancm_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1463);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0427ea4e", content, true, {});

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"ivancm","plural-entity":"NCM`s x CST-IBS/CBS","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),(_vm.errmessages.length != 0)?_c('validation',{attrs:{"messages":_vm.errmessages}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.ivancm.codivancm.validator),expression:"metadata.ivancm.codivancm.validator"}],attrs:{"metadata":_vm.metadata.ivancm.codivancm,"type":"text","col":"2","disabled":true,"name":"codivancm","v-errors":_vm.errors},model:{value:(_vm.ivancm.codivancm),callback:function ($$v) {_vm.$set(_vm.ivancm, "codivancm", $$v)},expression:"ivancm.codivancm"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{ref:"ncm",attrs:{"type":"select2","col":"6","metadata":_vm.metadata.ivancm.ncm,"select2":{ entity: 'ncm', minlength: 1 }},model:{value:(_vm.ivancm.ncm),callback:function ($$v) {_vm.$set(_vm.ivancm, "ncm", $$v)},expression:"ivancm.ncm"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.ivancm.cclass.validator),expression:"metadata.ivancm.cclass.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.ivancm.cclass,"name":"cclass","v-errors":_vm.errors,"parent":"mymodal","select2":{ entity: 'ivaclass', minlength: 0 }},model:{value:(_vm.ivancm.cclass),callback:function ($$v) {_vm.$set(_vm.ivancm, "cclass", $$v)},expression:"ivancm.cclass"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"NCM x CST-IBS/CBS","plural-entity":"NCM`s x CST-IBS/CBS","title-search":"Pesquise pelo NCM ou pelo Cod.class"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.ivancmList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.ivancmList),function(ivancm){return _c('div',{key:ivancm.uf,staticClass:"mainbox"},[_c('div',{staticClass:"mark-green"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-12"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(ivancm.ncm)+" ("+_vm._s(ivancm.cclass)+") ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('bar-grid',{attrs:{"options":{ barDefault: true, btnView: true, btnEdit: true },"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(ivancm.codivancm)},"view":function($event){return _vm.handleEdit(ivancm.ivancm, true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.ivancm.ncm.label)+" ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivancm.ncm))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.ivancm.cclass.label)+" ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ivancm.cclass))])])])])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('ivancm-form',{attrs:{"index":this.id,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1467);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6f22cc5d", content, true, {});

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-931c335c]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-931c335c]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-931c335c]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-931c335c]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-931c335c]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-unit[data-v-931c335c]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:14px;font-weight:700;text-transform:uppercase}.nb-card-title[data-v-931c335c]{flex:1;min-width:0}.nb-card-title-line[data-v-931c335c]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-931c335c]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-931c335c]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-931c335c]{color:#334155;font-weight:600}.nb-card-actions[data-v-931c335c]{flex:0 0 auto}@media (max-width:767.98px){.nb-card-top[data-v-931c335c]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-931c335c]{align-self:flex-end}}", ""]);

// exports


/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Unidade de Medida","plural-entity":"Unidades de Medida","title-search":"Pesquise pelo código ou pela descrição"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.unimedList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.unimedList),function(unimed){return _c('article',{key:unimed.uni,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_c('div',{staticClass:"nb-card-unit"},[_vm._v("\n                            "+_vm._s(unimed.uni)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(unimed.descricao))])]),_vm._v(" "),_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Sigla "),_c('strong',[_vm._v(_vm._s(unimed.uni))])])])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{ barDefault: true, btnView: true, btnEdit: true, btnEditLabel: 'Editar' },"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(unimed.uni)},"view":function($event){return _vm.handleEdit(unimed.uni, true)}}})],1)])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('unimed-form',{attrs:{"index":this.uni,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_ncm_list_vue__ = __webpack_require__(525);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8a2bee2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_ncm_list_vue__ = __webpack_require__(1476);
function injectStyle (ssrContext) {
  __webpack_require__(1470)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_ncm_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8a2bee2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_ncm_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1471);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3cef04b0", content, true, {});

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_ncm_form_vue__ = __webpack_require__(526);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b335f4c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_ncm_form_vue__ = __webpack_require__(1475);
function injectStyle (ssrContext) {
  __webpack_require__(1473)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_ncm_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b335f4c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_ncm_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1474);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0ffdb387", content, true, {});

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"NCM","plural-entity":"NCMs","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),(_vm.errmessages.length != 0)?_c('validation',{attrs:{"messages":_vm.errmessages}}):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.ncm.ncm.validator),expression:"metadata.ncm.ncm.validator"}],attrs:{"metadata":_vm.metadata.ncm.ncm,"type":"text","col":"2","disabled":_vm.editing,"name":"ncm","v-errors":_vm.errors},model:{value:(_vm.ncm.ncm),callback:function ($$v) {_vm.$set(_vm.ncm, "ncm", $$v)},expression:"ncm.ncm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.ncm.descricao.validator),expression:"metadata.ncm.descricao.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.ncm.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.ncm.descricao),callback:function ($$v) {_vm.$set(_vm.ncm, "descricao", $$v)},expression:"ncm.descricao"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.ncm.aipi.validator),expression:"metadata.ncm.aipi.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.ncm.aipi,"precision":2,"name":"aipi","v-errors":_vm.errors},model:{value:(_vm.ncm.aipi),callback:function ($$v) {_vm.$set(_vm.ncm, "aipi", $$v)},expression:"ncm.aipi"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.ncm.cest.validator),expression:"metadata.ncm.cest.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.ncm.cest,"name":"cest","v-errors":_vm.errors},model:{value:(_vm.ncm.cest),callback:function ($$v) {_vm.$set(_vm.ncm, "cest", $$v)},expression:"ncm.cest"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"NCM","plural-entity":"NCMs","title-search":"Pesquise pelo NCM ou pela descrição"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.ncmList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.ncmList),function(ncm){return _c('div',{key:ncm.ncm,staticClass:"mainbox"},[_c('div',{staticClass:"mark-green"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("NCM")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ncm.ncm))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-9"},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.ncm.descricao.label)+" ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ncm.descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.ncm.aipi.label)+": ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(ncm.aipi)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.ncm.cest.label)+": ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ncm.cest))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(ncm.ncm)},"view":function($event){return _vm.handleEdit(ncm.ncm, true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"})])])}),_vm._v(" "),(_vm.nextPage > 0)?_c('div',{staticClass:"col"},[_c('v-button',{attrs:{"label":"Carregar Mais","title":""},on:{"click":_vm.handleMore}})],1):_vm._e()],2)],1),_vm._v(" "),(_vm.showForm)?_c('ncm-form',{attrs:{"index":this.ncm,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1478);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3668c726", content, true, {});

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-c9e47f24]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-c9e47f24]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-c9e47f24]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-c9e47f24]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-c9e47f24]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-c9e47f24]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-c9e47f24]{flex:1;min-width:0}.nb-card-title-line[data-v-c9e47f24]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-c9e47f24]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-c9e47f24]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-c9e47f24]{color:#334155;font-weight:600}.nb-card-badge[data-v-c9e47f24]{display:inline-flex;align-items:center;gap:4px;padding:4px 7px;border:1px solid transparent;border-radius:5px;font-size:10px;font-weight:700;line-height:1.2}.nb-card-badge--info[data-v-c9e47f24]{color:#0369a1;background:#f0f9ff;border-color:#bae6fd}.nb-card-actions[data-v-c9e47f24]{flex:0 0 auto}.nb-card-details[data-v-c9e47f24]{display:grid;grid-template-columns:minmax(0,1fr);gap:12px;margin:12px 0 0 60px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-card-detail[data-v-c9e47f24]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-card-detail-label[data-v-c9e47f24]{color:#64748b;font-size:11px}.nb-card-detail>strong[data-v-c9e47f24]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}@media (max-width:767.98px){.nb-card-top[data-v-c9e47f24]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-c9e47f24]{align-self:flex-end}.nb-card-details[data-v-c9e47f24]{margin-left:0}}", ""]);

// exports


/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grade_form_vue__ = __webpack_require__(529);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b47d6b48_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grade_form_vue__ = __webpack_require__(1482);
function injectStyle (ssrContext) {
  __webpack_require__(1480)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_grade_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b47d6b48_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_grade_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1481);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("39379b8b", content, true, {});

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Grade","plural-entity":"Grade","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"metadata":_vm.metadata.grade.codgrade,"type":"text","col":"3","disabled":true},model:{value:(_vm.grade.codgrade),callback:function ($$v) {_vm.$set(_vm.grade, "codgrade", $$v)},expression:"grade.codgrade"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.grade.descricao.validator),expression:"metadata.grade.descricao.validator"}],ref:"descricao",attrs:{"type":"text","col":"6","metadata":_vm.metadata.grade.descricao,"case":"normal","name":"descricao","v-errors":_vm.errors},model:{value:(_vm.grade.descricao),callback:function ($$v) {_vm.$set(_vm.grade, "descricao", $$v)},expression:"grade.descricao"}})],1),_vm._v(" "),_c('label-title',{staticClass:"nb-margin-bottom nb-margin-top",attrs:{"title":"Variáveis"}}),_vm._v(" "),_c('div',[_vm._l((_vm.gradeit),function(valor,index){return _c('div',{key:index},[_c('div',{class:[{ 'mark-red': valor.duplicate }]}),_vm._v(" "),_c('div',{staticClass:"box"},[(valor.duplicate)?_c('div',{staticClass:"col"},[_c('small',{staticClass:"error"},[_vm._v("Variável duplicada não permitido")])]):_vm._e(),_vm._v(" "),(valor.validate)?_c('div',{staticClass:"col"},[_c('small',{staticClass:"error"},[_vm._v(_vm._s(valor.validate))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[_c('form-field',{ref:"descricaoit",refInFor:true,attrs:{"type":"text","col":"4","label":"Descrição"},model:{value:(valor.descricao),callback:function ($$v) {_vm.$set(valor, "descricao", $$v)},expression:"valor.descricao"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],ref:"corit",refInFor:true,attrs:{"type":"color","col":"2","label":"Cor","v-errors":_vm.errors},model:{value:(valor.cor),callback:function ($$v) {_vm.$set(valor, "cor", $$v)},expression:"valor.cor"}}),_vm._v(" "),_c('form-field',{ref:"seqit",refInFor:true,attrs:{"type":"number","col":"2","label":"Sequência"},model:{value:(valor.seq),callback:function ($$v) {_vm.$set(valor, "seq", $$v)},expression:"valor.seq"}}),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[(!valor.vinculos > 0)?_c('v-button',{attrs:{"label":"","title":"Excluir Variável","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteVariavel(index)}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[(valor.vinculos > 0)?_c('span',{staticClass:"badge badge-gray"},[_vm._v("Produtos vinculados nesta variável: "+_vm._s(valor.vinculos))]):_vm._e()])],1)])])}),_vm._v(" "),_c('div',{staticClass:"row nb-margin-top"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Adicionar Variável","title":"","nb-btdef":true},on:{"click":_vm.handleAdicionaVariavel}})],1)])],2)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Grade","plural-entity":"Grades de Produto","title-search":"Pesquise pela descrição"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.gradeList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.gradeList),function(grade){return _c('article',{key:grade.codgrade,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(grade.descricao))]),_vm._v(" "),(grade.vinculos)?_c('span',{staticClass:"nb-card-badge nb-card-badge--info"},[_vm._v("\n                                    "+_vm._s(grade.vinculos)+" produto(s) vinculado(s)\n                                ")]):_vm._e()]),_vm._v(" "),(grade.codgrade)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(grade.codgrade))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{ barDefault: true, btnView: true, btnEdit: true, btnEditLabel: 'Editar' },"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(grade.codgrade)},"view":function($event){return _vm.handleEdit(grade.codgrade, true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"nb-card-details"},[_c('div',{staticClass:"nb-card-detail nb-card-detail--full"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Itens / Variações da Grade")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.formataItensGrade(grade.itens) || '—'))])])])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('grade-form',{attrs:{"index":this.codgrade,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-th",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1485);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("8953f7b0", content, true, {});

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-77c43485]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-77c43485]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-77c43485]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-77c43485]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-77c43485]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-77c43485]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-77c43485]{flex:1;min-width:0}.nb-card-title-line[data-v-77c43485]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-77c43485]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-77c43485]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-77c43485]{color:#334155;font-weight:600}.nb-card-badge[data-v-77c43485]{display:inline-flex;align-items:center;gap:4px;padding:4px 7px;border:1px solid transparent;border-radius:5px;font-size:10px;font-weight:700;line-height:1.2}.nb-card-badge--info[data-v-77c43485]{color:#0369a1;background:#f0f9ff;border-color:#bae6fd}.nb-card-actions[data-v-77c43485]{display:flex;align-items:center;gap:6px;flex:0 0 auto}.nb-card-actions .btn[data-v-77c43485]{color:#475569;border-color:#cbd5e1}.nb-card-actions .btn[data-v-77c43485]:hover{color:#0f172a;background:#f1f5f9;border-color:#94a3b8}.nb-card-subitems[data-v-77c43485]{margin-top:12px;margin-left:24px;padding-left:16px;border-left:2px solid #e2e8f0;display:flex;flex-direction:column;gap:8px}.nb-card-subitem[data-v-77c43485]{background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:8px 12px}.nb-card-subitem-top[data-v-77c43485]{display:flex;align-items:center;justify-content:space-between;gap:12px}.nb-card-subitem-identity[data-v-77c43485]{display:flex;align-items:center;min-width:0;gap:8px}.nb-subitem-arrow[data-v-77c43485]{color:#94a3b8;font-size:14px}.nb-subitem-title[data-v-77c43485]{color:#1e293b;font-size:13px;font-weight:600}.nb-card-inline-form[data-v-77c43485]{padding:12px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px}@media (max-width:767.98px){.nb-card-top[data-v-77c43485]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-77c43485]{align-self:flex-end}.nb-card-subitems[data-v-77c43485]{margin-left:10px;padding-left:10px}}", ""]);

// exports


/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Grupos de Produtos","plural-entity":"Grupos de Produtos","hideSearch":true,"title-search":"Pesquise pelo nome do grupo"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.gruestList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),(_vm.showForm)?_c('div',{staticClass:"nb-card-inline-form mb-3"},[_c('gruest-form',{attrs:{"index":_vm.codgruest,"crud":_vm.crud},on:{"closeform":_vm.closeForm}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.gruestList),function(gruest){return _c('article',{key:gruest.codgruest,staticClass:"nb-card"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!gruest.show),expression:"!gruest.show"}],staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(gruest.descricao))]),_vm._v(" "),(gruest.sub && gruest.sub.length)?_c('span',{staticClass:"nb-card-badge nb-card-badge--info"},[_vm._v("\n                                    "+_vm._s(gruest.sub.length)+" subgrupo(s)\n                                ")]):_vm._e()]),_vm._v(" "),(gruest.codgruest)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(gruest.codgruest))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"type":"button","title":"Alterar"},on:{"click":function($event){return _vm.handleEdit(gruest)}}},[_c('i',{staticClass:"fa fa-pencil fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"type":"button","title":"Excluir"},on:{"click":function($event){return _vm.handleDelete(gruest)}}},[_c('i',{staticClass:"fa fa-trash fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"type":"button","title":"Adicionar grupo filho"},on:{"click":function($event){return _vm.handleSubgru(gruest)}}},[_c('i',{staticClass:"fa fa-plus fa-fw"}),_vm._v(" "),_c('span',{staticClass:"d-none d-sm-inline ml-1"},[_vm._v("Subgrupo")])])])]),_vm._v(" "),(gruest.show)?_c('div',{staticClass:"nb-card-inline-form mt-2"},[_c('gruest-form',{attrs:{"index":gruest.codgruest,"crud":_vm.crud},on:{"closeform":_vm.closeForm}})],1):_vm._e(),_vm._v(" "),(gruest.subgru)?_c('div',{staticClass:"nb-card-inline-form mt-2"},[_c('gruest-form',{attrs:{"pai":gruest,"crud":_vm.crud},on:{"closeform":_vm.closeForm}})],1):_vm._e(),_vm._v(" "),(gruest.sub && gruest.sub.length)?_c('div',{staticClass:"nb-card-subitems"},_vm._l((gruest.sub),function(sub,index){return _c('div',{key:index,staticClass:"nb-card-subitem"},[(!sub.show)?_c('div',{staticClass:"nb-card-subitem-top"},[_c('div',{staticClass:"nb-card-subitem-identity"},[_c('i',{staticClass:"fa fa-level-up fa-rotate-90 nb-subitem-arrow",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"nb-subitem-title"},[_vm._v(_vm._s(sub.descricao))]),_vm._v(" "),(sub.codgruest)?_c('span',{staticClass:"nb-card-code ml-2"},[_vm._v("#"+_vm._s(sub.codgruest))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"type":"button","title":"Alterar"},on:{"click":function($event){return _vm.handleEdit(sub)}}},[_c('i',{staticClass:"fa fa-pencil fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"type":"button","title":"Excluir"},on:{"click":function($event){return _vm.handleDelete(sub)}}},[_c('i',{staticClass:"fa fa-trash fa-fw"})])])]):_vm._e(),_vm._v(" "),(sub.show)?_c('div',{staticClass:"nb-card-inline-form mt-2"},[_c('gruest-form',{attrs:{"index":sub.codgruest,"crud":_vm.crud},on:{"closeform":_vm.closeForm}})],1):_vm._e()])}),0):_vm._e()])})],2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-cubes",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1488);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("03c4dc77", content, true, {});

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-61b14bff]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-61b14bff]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-61b14bff]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-61b14bff]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-61b14bff]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-61b14bff]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-61b14bff]{flex:1;min-width:0}.nb-card-title-line[data-v-61b14bff]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-61b14bff]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-61b14bff]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-61b14bff]{color:#334155;font-weight:600}.nb-card-actions[data-v-61b14bff]{flex:0 0 auto}@media (max-width:767.98px){.nb-card-top[data-v-61b14bff]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-61b14bff]{align-self:flex-end}}", ""]);

// exports


/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Depósito","plural-entity":"Depósitos"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.depositoList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.depositoList),function(deposito){return _c('article',{key:deposito.coddeposito,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(deposito.descricao))])]),_vm._v(" "),(deposito.coddeposito)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(deposito.coddeposito))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: true, btnEditLabel: 'Editar'},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(deposito.coddeposito)},"view":function($event){return _vm.handleEdit(deposito.coddeposito, true)}}})],1)])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('depo-form',{attrs:{"index":this.coddeposito,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-archive",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_mennf_list_vue__ = __webpack_require__(534);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_46eda4f2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_mennf_list_vue__ = __webpack_require__(1497);
function injectStyle (ssrContext) {
  __webpack_require__(1491)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_mennf_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_46eda4f2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_mennf_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1492);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0a2fbe88", content, true, {});

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_mennf_form_vue__ = __webpack_require__(535);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c3171e6_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_mennf_form_vue__ = __webpack_require__(1496);
function injectStyle (ssrContext) {
  __webpack_require__(1494)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_mennf_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c3171e6_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_mennf_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1495);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("9bc4e2de", content, true, {});

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Mensagem","plural-entity":"Mensagens Padrão","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"metadata":_vm.metadata.mennf.codmennf,"type":"text","col":"2","disabled":true},model:{value:(_vm.mennf.codmennf),callback:function ($$v) {_vm.$set(_vm.mennf, "codmennf", $$v)},expression:"mennf.codmennf"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.mennf.descricao.validator),expression:"metadata.mennf.descricao.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.mennf.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.mennf.descricao),callback:function ($$v) {_vm.$set(_vm.mennf, "descricao", $$v)},expression:"mennf.descricao"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.mennf.texto.validator),expression:"metadata.mennf.texto.validator"}],attrs:{"type":"memo","col":"6","metadata":_vm.metadata.mennf.texto,"name":"texto","v-errors":_vm.errors},model:{value:(_vm.mennf.texto),callback:function ($$v) {_vm.$set(_vm.mennf, "texto", $$v)},expression:"mennf.texto"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Mensagem","plural-entity":"Mensagens Padrão","title-search":"Pesquise pela descrição"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.mennfList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.mennfList),function(mennf){return _c('div',{key:mennf.codmennf,staticClass:"mainbox"},[_c('div',{staticClass:"mark-green"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3",staticStyle:{"float":"left"}},[_c('span',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.mennf.codmennf.label)+" ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(mennf.codmennf))])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-6",staticStyle:{"float":"left"}},[_c('span',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.mennf.descricao.label)+" ")]),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(mennf.descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(mennf.codmennf)},"view":function($event){return _vm.handleEdit(mennf.codmennf, true)}}})],1)])])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('mennf-form',{attrs:{"index":this.codmennf,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1499);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("467d48f8", content, true, {});

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-1c3a13dc]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-1c3a13dc]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-1c3a13dc]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-1c3a13dc]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-1c3a13dc]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-1c3a13dc]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-1c3a13dc]{flex:1;min-width:0}.nb-card-title-line[data-v-1c3a13dc]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-1c3a13dc]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-1c3a13dc]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-1c3a13dc]{color:#334155;font-weight:600}.nb-card-badge[data-v-1c3a13dc]{display:inline-flex;align-items:center;gap:4px;padding:4px 7px;border:1px solid transparent;border-radius:5px;font-size:10px;font-weight:700;line-height:1.2}.nb-card-badge--success[data-v-1c3a13dc]{color:#166534;background:#f0fdf4;border-color:#bbf7d0}.nb-card-badge--inactive[data-v-1c3a13dc]{color:#92400e;background:#fffbeb;border-color:#fde68a}.nb-card-actions[data-v-1c3a13dc]{flex:0 0 auto}.nb-card-details[data-v-1c3a13dc]{display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:12px;margin:12px 0 0 60px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-card-detail[data-v-1c3a13dc]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-card-detail-label[data-v-1c3a13dc]{color:#64748b;font-size:11px}.nb-card-detail>strong[data-v-1c3a13dc]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}.nb-card-detail>strong .fa[data-v-1c3a13dc]{margin-right:4px;color:#64748b}@media (max-width:767.98px){.nb-card-top[data-v-1c3a13dc]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-1c3a13dc]{align-self:flex-end}.nb-card-details[data-v-1c3a13dc]{margin-left:0}}", ""]);

// exports


/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Vendedor","plural-entity":"Vendedores"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.vendList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.vendList),function(vend){return _c('article',{key:vend.codvend,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(vend.nome))]),_vm._v(" "),(vend.stvend)?_c('span',{staticClass:"nb-card-badge",class:vend.stvend == 'I' ? 'nb-card-badge--inactive' : 'nb-card-badge--success'},[_vm._v("\n                                    "+_vm._s(vend.stvend == 'I' ? 'Inativo' : 'Ativo')+"\n                                ")]):_vm._e()]),_vm._v(" "),(vend.codvend)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(vend.codvend))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: true, btnEditLabel: 'Editar'},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(vend.codvend)},"view":function($event){return _vm.handleEdit(vend.codvend, true)}}})],1)]),_vm._v(" "),(vend.email || vend.uf)?_c('div',{staticClass:"nb-card-details"},[(vend.email)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("E-mail")]),_vm._v(" "),_c('strong',[_c('i',{staticClass:"fa fa-envelope-o",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(vend.email))])]):_vm._e(),_vm._v(" "),(vend.uf)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("UF")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(vend.uf))])]):_vm._e()]):_vm._e()])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('vend-form',{attrs:{"index":this.codvend,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-user",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1502);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3744a78d", content, true, {});

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-filial-list{display:flex;flex-direction:column;gap:12px}.nb-filial-card{padding:16px 18px;background:#fff;border:1px solid #e2e8f0;border-radius:12px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-filial-card:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-filial-card-main{display:grid;grid-template-columns:minmax(260px,1fr) auto auto;align-items:center;gap:18px}.nb-filial-identity{display:flex;min-width:0;align-items:center;gap:14px}.nb-filial-logo-wrap{position:relative;flex:0 0 58px;width:58px;height:58px}.nb-filial-logo{display:flex;width:58px;height:58px;align-items:center;justify-content:center;padding:5px;color:#64748b;background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;cursor:pointer}.nb-filial-logo-remove:focus-visible,.nb-filial-logo:focus-visible{outline:2px solid #004e94;outline-offset:2px}.nb-filial-logo>img{display:block;max-width:100%;max-height:100%;object-fit:contain}.nb-filial-logo>.fa{font-size:24px}.nb-filial-logo-edit{right:-4px;bottom:-4px;color:#fff;background:#004e94;border:2px solid #fff;border-radius:50%;font-size:9px}.nb-filial-logo-edit,.nb-filial-logo-remove{position:absolute;display:flex;width:21px;height:21px;align-items:center;justify-content:center}.nb-filial-logo-remove{top:-6px;right:-6px;padding:0;color:#b91c1c;background:#fff;border:1px solid #fecaca;border-radius:50%;cursor:pointer;font-size:10px}.nb-filial-info{min-width:0}.nb-filial-info h2{margin:0;color:#0b1c30;font-size:16px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-filial-meta{display:flex;flex-wrap:wrap;gap:3px 12px;margin-top:4px;color:#64748b;font-size:12px}.nb-filial-code{padding-left:12px;border-left:1px solid #cbd5e1}.nb-filial-statuses{display:flex;flex-wrap:wrap;align-items:center;gap:6px}.nb-filial-badge{display:inline-flex;align-items:center;gap:5px;padding:5px 8px;border:1px solid transparent;border-radius:6px;font-size:11px;font-weight:600;line-height:1.2;white-space:nowrap}.nb-filial-badge .fa-circle{font-size:6px}.nb-filial-badge--active,.nb-filial-badge--production{color:#047857;background:#ecfdf5;border-color:#a7f3d0}.nb-filial-badge--homologation,.nb-filial-badge--pending{color:#b45309;background:#fffbeb;border-color:#fde68a}.nb-filial-badge--expired{color:#b91c1c;background:#fef2f2;border-color:#fecaca}.nb-filial-badge--neutral{color:#475569;background:#f1f5f9;border-color:#cbd5e1}.nb-filial-actions{display:flex;align-items:center;gap:8px}.nb-filial-action .btn-group,.nb-filial-action .btn-group>div{width:100%}.nb-filial-action a.btn{display:block;margin-right:0!important;white-space:nowrap}@media (max-width:991.98px){.nb-filial-card-main{grid-template-columns:minmax(0,1fr) auto;gap:12px 16px}.nb-filial-identity{grid-column:1/-1}}@media (max-width:575.98px){.nb-filial-card{padding:13px}.nb-filial-card-main{grid-template-columns:minmax(0,1fr);gap:12px}.nb-filial-statuses{grid-column:1}.nb-filial-actions{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));grid-column:1}.nb-filial-action a.btn{width:100%;padding-right:7px;padding-left:7px;white-space:normal}}", ""]);

// exports


/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm && !_vm.showFormCert),expression:"!showForm && !showFormCert"}],attrs:{"id":"list"}},[(!_vm.appForcaVendas)?_c('bar-list',{attrs:{"refresh-button":true,"new-button":false,"pdf-button":false,"xls-button":false,"single-entity":"Empresa","plural-entity":"Empresas","title-search":"Pesquise pelo nome","videoButton":"true","video-icon":"fa-youtube-play","urlVideo":"//www.youtube.com/embed/0QMVqSEm-ww"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"nb-filial-list"},[(_vm.filialList.length == 0)?_c('div',[_c('alert',{attrs:{"type":"warning","text":"Nenhuma Filial foi encontrada."}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.filialList),function(filial,index){return _c('article',{key:filial.codfil || index,staticClass:"nb-filial-card"},[_c('div',{staticClass:"nb-filial-card-main"},[_c('div',{staticClass:"nb-filial-identity"},[_c('div',{staticClass:"nb-filial-logo-wrap"},[_c('button',{staticClass:"nb-filial-logo",attrs:{"type":"button","title":"Selecionar logotipo","aria-label":'Selecionar logotipo para ' + filial.nome},on:{"click":function($event){return _vm.handleClickLogotipo(filial.codfil)}}},[(filial.urlimage)?_c('img',{attrs:{"src":filial.urlimage,"alt":""}}):_c('i',{staticClass:"fa fa-building-o",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),(filial.urlimage)?_c('button',{staticClass:"nb-filial-logo-remove",attrs:{"type":"button","title":"Remover logotipo","aria-label":'Remover logotipo de ' + filial.nome},on:{"click":function($event){return _vm.handleRemoverImagem(filial)}}},[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nb-filial-info"},[_c('h2',[_vm._v(_vm._s(filial.nome))]),_vm._v(" "),_c('div',{staticClass:"nb-filial-meta"},[(filial.cnpj)?_c('span',[_vm._v("CNPJ/CPF "+_vm._s(_vm._f("formatCNPJCPF")(filial.cnpj)))]):_vm._e(),_vm._v(" "),(filial.codfil)?_c('span',{staticClass:"nb-filial-code"},[_vm._v("Filial "+_vm._s(filial.codfil))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"nb-filial-statuses"},[(filial.tpambnfe == '1')?_c('span',{staticClass:"nb-filial-badge nb-filial-badge--production"},[_c('i',{staticClass:"fa fa-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" Produção\n                        ")]):(filial.tpambnfe == '2')?_c('span',{staticClass:"nb-filial-badge nb-filial-badge--homologation"},[_c('i',{staticClass:"fa fa-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" Homologação\n                        ")]):_c('span',{staticClass:"nb-filial-badge nb-filial-badge--neutral"},[_vm._v("Ambiente não definido")]),_vm._v(" "),(filial.cert_pendente == 'S')?_c('span',{staticClass:"nb-filial-badge nb-filial-badge--pending"},[_c('i',{staticClass:"fa fa-exclamation-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" Certificado pendente\n                        ")]):(filial.cert_vencido == 'S')?_c('span',{staticClass:"nb-filial-badge nb-filial-badge--expired"},[_c('i',{staticClass:"fa fa-exclamation-triangle",attrs:{"aria-hidden":"true"}}),_vm._v(" Certificado vencido\n                        ")]):_c('span',{staticClass:"nb-filial-badge nb-filial-badge--active"},[_c('i',{staticClass:"fa fa-check-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" Certificado ativo\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"nb-filial-actions"},[_c('div',{staticClass:"nb-filial-action"},[_c('v-button',{attrs:{"label":filial.cert_pendente == 'S' ? 'Configurar certificado' : (filial.cert_vencido == 'S' ? 'Renovar certificado' : 'Certificado'),"icon":"fa-id-card","nb-btdef":filial.cert_pendente == 'S' || filial.cert_vencido == 'S'},on:{"click":function($event){return _vm.handleGuiaInstalacaoCertificado(filial.codfil)}}})],1),_vm._v(" "),_c('div',{staticClass:"nb-filial-action"},[_c('v-button',{attrs:{"label":"Editar","icon":"fa-pencil"},on:{"click":function($event){return _vm.handleEdit(filial.codfil)}}})],1)])])])})],2)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"file",attrs:{"type":"file","accept":"image/*"},on:{"change":function($event){return _vm.handleUpload($event)}}})]),_vm._v(" "),(_vm.showForm)?_c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1 !important"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeModal()}}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-full-w",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content modal-full-h"},[_c('div',{staticClass:"modal-body"},[_c('filial-form',{attrs:{"index":_vm.codfil,"crud":this.crud},on:{"closeform":_vm.closeForm}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.showFormCert)?_c('div',[_c('app-certificado',{attrs:{"codfil":_vm.codfil},on:{"closeform":_vm.closeForm}})],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"nb-filial-logo-edit"},[_c('i',{staticClass:"fa fa-camera",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_list_vue__ = __webpack_require__(539);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_282cfb98_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_list_vue__ = __webpack_require__(1547);
function injectStyle (ssrContext) {
  __webpack_require__(1505)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_282cfb98_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1506);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2f96dae0", content, true, {});

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1508);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7d9f4368", content, true, {});

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".mobile-device[data-v-01a209a0]{display:block}.other-device[data-v-01a209a0]{display:none}@media (min-width:768px){.mobile-device[data-v-01a209a0]{display:none}.other-device[data-v-01a209a0]{display:block}}.filter-list .filter[data-v-01a209a0]:first-child{border-left:1px solid #c9d3dd;padding-left:6px}.filter-list .filter[data-v-01a209a0]{box-sizing:border-box;background-color:#fff;background-image:none;border-top:1px solid #c9d3dd;border-bottom:1px solid #c9d3dd;height:100%;cursor:pointer;float:left;position:relative;border-right:1px solid #c9d3dd;color:#7a7a7f;margin:0;padding:14px 7px 7px;text-align:center}.filter-list.filter[data-v-01a209a0]:hover{border-top:2px solid #267da5;background-color:#25244711}.filter-list.filter.active[data-v-01a209a0]{border-top:2px solid #267da5;background-color:#2524472f}.filter-list-5col .filter[data-v-01a209a0]{width:20%}.filter-list-4col .filter[data-v-01a209a0]{width:25%}.filter-list-3col .filter[data-v-01a209a0]{width:33.33%}.filter-list-10col .filter[data-v-01a209a0]{width:10%}.filter-list strong[data-v-01a209a0]{font-size:20px;font-weight:700}", ""]);

// exports


/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2 other-device"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"filter-list col-md-12 col-12",class:_vm.cols},_vm._l((_vm.params.total),function(total,index){return _c('div',{key:index,staticClass:"filter-list filter",class:{'active': _vm.selectedIndex === index},on:{"click":function($event){return _vm.handleSelect(index)}}},[(total.total)?_c('div',[_c('label',{staticClass:"lbl-edit w-100"},[_vm._v(" "+_vm._s(total.label)+" "),(total.qt)?_c('span',[_vm._v(" ("+_vm._s(total.qt)+") ")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"total"},[_vm._v("R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("format")(total.total))+" ")])]),_vm._v(" "),(total.perc)?_c('span',{staticClass:"badge badge-blue"},[_vm._v(_vm._s(_vm._f("format")(total.perc))+"% ")]):_vm._e()]):_c('div',[_c('label',{staticClass:"lbl-edit"},[_vm._v(" "+_vm._s(total.label)+" ")])])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1511);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6a3d5c2c", content, true, {});

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".dropdown-total[data-v-04c9f672]{z-index:1051;margin-top:3px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;position:absolute;padding:10px;z-index:1000;float:left;min-width:160px;list-style:none;background-color:#fff;border:1px solid #00000033;box-shadow:0 5px 10px #00000033;background-clip:padding-box}", ""]);

// exports


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1513);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("dfb4cede", content, true, {});

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".add-itens{background-color:#fff;top:0;width:800px;max-width:100%}.add-itens,.add-itens-inner{display:flex;height:100%;overflow:hidden}.add-itens-inner{width:100%;flex-direction:column}.add-itens-header{border-bottom:1px solid #e9ecef}.add-itens-body{overflow-x:hidden;height:100%}.dropdown-select-item{z-index:1051;margin-top:3px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;position:absolute;padding:10px;z-index:1000;float:left;min-width:160px;list-style:none;background-color:#fff;border:1px solid rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2);background-clip:padding-box}", ""]);

// exports


/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"mb-2"},[(!_vm.params.produtosDestaque)?_c('div',{staticClass:"headerpesquisa",staticStyle:{"position":"relative","width":"100%","z-index":"10","background-color":"white"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchString),expression:"searchString"}],ref:"searchpedidoaddlist",staticClass:"form-control form-control-sm",attrs:{"id":"search-pedido-addlist","type":"text","placeholder":"Pesquisa pela descrição ou pelo código do item"},domProps:{"value":(_vm.searchString)},on:{"change":function($event){return _vm.handleChange()},"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleEsc()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search()}],"input":function($event){if($event.target.composing){ return; }_vm.searchString=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary",staticStyle:{"margin-right":"5px"},attrs:{"tabindex":"1","type":"submit"},on:{"click":function($event){return _vm.search()}}},[_c('i',{staticClass:"fa fa-search",attrs:{"aria-hidden":"true"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Pesquisar somente por código"},model:{value:(_vm.pesquisaCodigo),callback:function ($$v) {_vm.pesquisaCodigo=$$v},expression:"pesquisaCodigo"}})],1)])]):_vm._e(),_vm._v(" "),(_vm.noItems)?_c('div',{staticClass:"dropdown-select-item",staticStyle:{"min-width":"50%"},style:(_vm.myDropDown),on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleEsc()}}},[_c('span',{staticClass:"lbl"},[_vm._v("Nenhum item foi encontrado")])]):_vm._e()]),_vm._v(" "),(_vm.showItems)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('Trap',[_c('div',{staticClass:"nb-modal-scrollable-container add-itens",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleEsc()}}},[_c('div',{staticClass:"add-itens-inner"},[_c('div',{staticClass:"add-itens-header sticky p-2"},[_c('div',{staticClass:"w-100"},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleEsc()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"def-title pt-2"},[_vm._v("Pesquisa de Produtos")])])]),_vm._v(" "),_c('div',{staticClass:"add-itens-body"},[_vm._l((_vm.localItemList),function(item,index){return _c('div',{key:index},[_c('div',{staticStyle:{"border":"1px solid #f9f9f9","margin-bottom":"10px"}},[_c('div',{staticStyle:{"background":"#f9f9f9","padding":"10px","margin-bottom":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(item.descricao))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('v-label',{staticClass:"my-0",attrs:{"label":"Código: "}}),_vm._v(" "),_c('span',{staticClass:"data-list my-0"},[_vm._v(_vm._s(item.codigo))]),_vm._v(" "),(item.existe)?_c('span',{staticClass:"badge badge-yellow"},[_vm._v("Adicionado")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row align-items-start py-2"},[_c('div',{staticClass:"col-md-3 col-3 d-flex flex-column"},[_c('v-label',{attrs:{"label":"Preço"}}),_vm._v(" "),(item.vlrtab)?_c('span',{staticClass:"data-list"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(item.vlrtab,2)))]):_vm._e(),_vm._v(" "),(item.desconto_tabela > 0)?_c('span',{staticClass:"badge badge-yellow"},[_vm._v(" Desconto em Tabela -"+_vm._s(item.desconto_tabela)+"% ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"label":"Estoque"}}),_vm._v(" "),_c('div',[(item.itemlote_qt == 0 && item.iskit != 'S')?_c('span',{staticClass:"data-list"},[_vm._v("\n                          "+_vm._s(item.saldo_estoque)+"\n                        ")]):_vm._e(),_vm._v(" "),(item.itemlote_qt == 0 && item.iskit == 'S')?_c('span',{staticClass:"data-list"},[_vm._v("\n                          "+_vm._s(item.saldo_estoque)+"\n\n                          "),(item.estoque_kit_json && item.estoque_kit_json.itemlotes && item.estoque_kit_json.itemlotes.length)?_c('a',{attrs:{"aria-controls":"collapseExample","aria-expanded":"false","data-toggle":"collapse","href":("#div_itemkitlotes_" + (item.coditem)),"role":"button"}},[_c('i',{staticClass:"fa fa-caret-down ml-2",attrs:{"aria-hidden":"true"}}),_vm._v("\n                            Lotes\n                          ")]):_vm._e()]):_vm._e(),_vm._v(" "),(item.itemlote_qt > 0 && item.itemlote_json.itemlotes.length)?_c('span',{staticClass:"data-list"},[_vm._v("\n                          "+_vm._s(item.saldo_estoque)+"\n\n                          "),_c('a',{attrs:{"aria-controls":"collapseExample","aria-expanded":"false","data-toggle":"collapse","href":("#div_itemlotes_" + (item.coditem)),"role":"button"}},[_c('i',{staticClass:"fa fa-caret-down ml-2",attrs:{"aria-hidden":"true"}}),_vm._v("\n                            Lotes\n                          ")])]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Ver composição do Kit"}},[(item.iskit == 'S')?_c('button',{staticClass:"btn btn-outline-secondary btn-sm",attrs:{"tabindex":-1,"data-toggle":"collapse","href":("#multiCollapseExample" + (item.coditem)),"role":"button","aria-expanded":"false","aria-controls":("multiCollapseExample" + (item.coditem))},on:{"click":function($event){return _vm.getKitDetails(item.coditem)}}},[_c('i',{staticClass:"fa fa-cubes"})]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"collapse",staticStyle:{"background":"#f9f9f9","padding":"10px","margin-top":"-10px"},attrs:{"id":("multiCollapseExample" + (item.coditem))}},_vm._l((item.itemKit),function(kit,index){return (item.itemKit)?_c('div',{key:index,staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[(index == 0)?_c('v-label',{attrs:{"label":"Descrição"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list w-100 text-dark"},[_vm._v(_vm._s(kit.descricao)+" "+_vm._s(kit.descricaolinha)+" "+_vm._s(kit.descricaocoluna))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 d-flex flex-column"},[(index == 0)?_c('v-label',{attrs:{"label":"Quantidade"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(kit.qt)+" "+_vm._s(kit.uni))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 d-flex flex-column"},[(index == 0)?_c('v-label',{attrs:{"label":"Saldo Estoque"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(kit.saldo_estoque)+"\n                        "),_c('a',{attrs:{"aria-controls":"collapseExample","aria-expanded":"false","data-toggle":"collapse","href":("#div_itemkitestoque_" + (item.coditem) + "_" + index),"role":"button"}},[_c('i',{staticClass:"fa fa-caret-down ml-2",attrs:{"aria-hidden":"true"}}),_vm._v("\n                          Lotes\n                        ")])])],1),_vm._v(" "),_c('div',{staticClass:"collapse",staticStyle:{"background":"#f9f9f9","padding":"10px","margin-top":"-10px"},attrs:{"id":("div_itemkitestoque_" + (item.coditem) + "_" + index)}},[_c('span',{staticClass:"lbl-title-produto mb-3"},[_vm._v("Lotes de Estoque")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-6 col-6"},[_c('v-label',{attrs:{"label":"Depósito"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-6"},[_c('v-label',{attrs:{"label":"Quantidade"}})],1)]),_vm._v(" "),_vm._l((kit.itemlote_json.itemlotes),function(itemlote,indexitemlote){return (kit.itemlote_json && kit.itemlote_json.itemlotes)?_c('div',{key:indexitemlote},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-6 col-6"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(itemlote.coddeposito))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-6"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(itemlote.qt))])])])]):_vm._e()})],2)])]):_vm._e()}),0),_vm._v(" "),_c('div',{staticClass:"collapse",staticStyle:{"padding":"10px"},attrs:{"id":("div_itemlotes_" + (item.coditem))}},[_c('span',{staticClass:"lbl-title-produto mb-3"},[_vm._v("Lotes de Estoque")]),_vm._v(" "),(item.itemlote_qt > 0)?_c('div',[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Depósito"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Lote"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Sublote"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Lote Fornecedor"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Validade"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Quantidade"}})],1)]),_vm._v(" "),_vm._l((item.itemlote_json.itemlotes),function(itemlote,indexlote){return _c('div',{key:indexlote},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(itemlote.coddeposito))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(itemlote.lote))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(itemlote.sublote))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(itemlote.lotefornecedor))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(itemlote.dtvalidade)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(itemlote.qt))])])])])})],2):_vm._e()]),_vm._v(" "),(item.estoque_kit_json && item.estoque_kit_json.itemlotes && item.estoque_kit_json.itemlotes.length)?_c('div',{staticClass:"collapse",staticStyle:{"padding":"10px"},attrs:{"id":("div_itemkitlotes_" + (item.coditem))}},[_c('span',{staticClass:"lbl-title-produto mb-3"},[_vm._v("Lotes de Estoque")]),_vm._v(" "),(item.itemlote_qt == 0)?_c('div',[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"label":"Depósito"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"label":"Quantidade"}})],1)]),_vm._v(" "),_vm._l((item.estoque_kit_json.itemlotes),function(itemlote,indexlote){return _c('div',{key:indexlote},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-4 col-6"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(itemlote.coddeposito))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(itemlote.qt))])])])])})],2):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"padding":"10px"}},[(item.isgrade == 'S')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('grade',{ref:"grade",refInFor:true,attrs:{"params":{ view: false, coditem: item.coditem, index: index, qt: item.qtuni, listItemGrade: item.grade }},on:{"update":_vm.handleUpdateGrade}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(item.isgrade != 'S')?_c('form-field',{ref:"qtuni",refInFor:true,attrs:{"type":"value","col":"3","metadata":_vm.metadata.pedvit.qtuni},model:{value:(item.qtuni),callback:function ($$v) {_vm.$set(item, "qtuni", $$v)},expression:"item.qtuni"}}):_vm._e(),_vm._v(" "),(!_vm.bloqueia_preco_item)?_c('form-field',{attrs:{"type":"value","col":"3","metadata":_vm.metadata.pedvit.vlr,"preaddon":"R$","disabled":item.iskit === 'S' ? true : false},on:{"keyenter":function($event){return _vm.handleEnter(index)}},model:{value:(item.vlr),callback:function ($$v) {_vm.$set(item, "vlr", $$v)},expression:"item.vlr"}}):_c('div',{staticClass:"col-md-3 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedvit.vlr}}),_vm._v(" "),_c('strong',{staticClass:"lbl w-100"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(item.vlr,2)))])],1),_vm._v(" "),(item.unimed && item.unimed.length > 0)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvit.uni.validator),expression:"metadata.pedvit.uni.validator"}],attrs:{"tabindex":-1,"type":"select2","col":"3","metadata":_vm.metadata.pedvit.uni,"name":"uni","v-errors":_vm.errors},model:{value:(item.uni),callback:function ($$v) {_vm.$set(item, "uni", $$v)},expression:"item.uni"}}):_vm._e(),_vm._v(" "),_c('form-field',{attrs:{"tabindex":((item.iskit != 'S') ? -1 : 0),"type":"value","col":"2","metadata":_vm.metadata.pedvit.pdesc1},model:{value:(item.pdesc1),callback:function ($$v) {_vm.$set(item, "pdesc1", $$v)},expression:"item.pdesc1"}}),_vm._v(" "),_c('form-field',{attrs:{"tabindex":((item.iskit != 'S') ? -1 : 0),"type":"value","col":"2","metadata":_vm.metadata.pedvit.pdesc2},model:{value:(item.pdesc2),callback:function ($$v) {_vm.$set(item, "pdesc2", $$v)},expression:"item.pdesc2"}}),_vm._v(" "),_c('form-field',{attrs:{"tabindex":((item.iskit != 'S') ? -1 : 0),"type":"value","col":"2","metadata":_vm.metadata.pedvit.pdesc3},model:{value:(item.pdesc3),callback:function ($$v) {_vm.$set(item, "pdesc3", $$v)},expression:"item.pdesc3"}}),_vm._v(" "),_c('form-field',{attrs:{"tabindex":((item.iskit != 'S') ? -1 : 0),"type":"value","col":"3","metadata":_vm.metadata.pedvit.pedcliit},model:{value:(item.pedcliit),callback:function ($$v) {_vm.$set(item, "pedcliit", $$v)},expression:"item.pedcliit"}})],1),_vm._v(" "),(item.error)?_c('div',{staticClass:"row col"},[_c('span',{staticClass:"error"},[_vm._v(_vm._s(item.error))])]):_vm._e(),_vm._v(" "),(item.tabelas_desconto)?_c('div',{staticClass:"row"},_vm._l((item.tabelas_desconto.descontos),function(desconto,index){return _c('form-field',{key:index,attrs:{"tabindex":-1,"type":"value","col":"3","precision":2,"label":_vm.label_tabdesc(desconto.descricao),"addon":"%"},model:{value:(desconto.pdesc),callback:function ($$v) {_vm.$set(desconto, "pdesc", $$v)},expression:"desconto.pdesc"}})}),1):_vm._e()])])])}),_vm._v(" "),_c('div',{staticClass:"text-center p-3"},[(_vm.nextPage > 0)?_c('a',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.handleMore()}}},[_vm._v("Exibir mais")]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"add-itens-footer"},[_c('div',{staticClass:"d-flex"},[_c('v-button',{ref:"adicionar",staticClass:"ml-auto p-2",attrs:{"nb-btdef":true,"tabindex":1,"icon":"fa-plus","label":"Adicionar","title":"Adiciona no pedido os itens selecionados abaixo"},on:{"click":function($event){return _vm.addItens()}}})],1)])])])])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1516);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d7b3d662", content, true, {});

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1518);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3b99266b", content, true, {});

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".typeahead[data-v-1bb74473]{z-index:1051;margin-top:2px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;box-shadow:0 5px 10px rgba(0,0,0,.2);color:#383838}.typeahead li[data-v-1bb74473]{border-bottom:1px solid #efefef;padding:15px}.typeahead li[data-v-1bb74473]:hover{cursor:pointer}.typeahead .active[data-v-1bb74473],.typeahead li[data-v-1bb74473]:hover{color:#fff!important;background-color:#1d5b96}.typeahead [data-v-1bb74473]{white-space:normal!important}[data-v-1bb74473]{margin:0;padding:0;text-decoration:none;outline:none!important;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.typeahead-data[data-v-1bb74473]{white-space:normal!important}.typeahead-title[data-v-1bb74473]{display:inline-block;max-width:100%;margin-bottom:5px;margin-right:5px;font-size:18px}li[data-v-1bb74473]{line-height:20px}.dropdown-part[data-v-1bb74473]{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);*border-right-width:2px;*border-bottom-width:2px;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);-moz-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2);-webkit-background-clip:padding-box;-moz-background-clip:padding;background-clip:padding-box}", ""]);

// exports


/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"float-left"},[(_vm.modoCodigoBarra)?_c('strong',{staticStyle:{"font-size":"12px"}},[_vm._v("Codigo de Barras | Balança")]):_c('strong',{staticStyle:{"font-size":"12px"}},[_vm._v("Codigo ou Descrição")])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","min-width":"30vw","width":"100%","z-index":"1","background-color":"white"}},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.textSearch),expression:"textSearch"}],ref:"pesquisa",staticClass:"col-12 vd-input px-3 py-2",staticStyle:{"font-size":"17px!important","padding":"11px","border-radius":"5px","border":"1px solid #C9D3DD"},attrs:{"type":"text","id":"search","autocomplete":"off","placeholder":_vm.pesquisarPlaceholder},domProps:{"value":(_vm.textSearch)},on:{"blur":function($event){return _vm.handleBlur()},"change":function($event){return _vm.handleChange()},"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleEsc()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleEnter()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.handleKeyDown()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.handleKeyUp()},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==120){ return null; }return _vm.handlePressf9()},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==27){ return null; }return _vm.handleBack()}],"input":function($event){if($event.target.composing){ return; }_vm.textSearch=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[(_vm.showQt)?_c('span',{staticClass:"text-secondary float-right",staticStyle:{"font-size":"12px","margin-left":"auto"}},[_vm._v("\n          Quantidade: "+_vm._s(_vm.newQt)+"\n        ")]):_c('span',{staticClass:"text-secondary float-right",staticStyle:{"font-size":"12px"}},[_vm._v("\n          Use * para informar a quantidade (Ex *5)\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[(_vm.showList)?_c('ul',{staticClass:"typeahead dropdown-part col",staticStyle:{"display":"block","height":"62vh","overflow":"auto!important"},attrs:{"id":"listitem"}},_vm._l((_vm.itemList),function(item,index){return _c('li',{key:index,class:{ active: index == _vm.selectedIndex },attrs:{"id":'ilistitem' + index},on:{"click":function($event){return _vm.handleSelectItem(index)}}},[_c('div',{staticClass:"row",staticStyle:{"gap":"30px"}},[_c('div',{staticClass:"col-md-1 col-2 text-center"},[(item.url)?_c('img',{staticClass:"mx-auto d-block img-thumbnail",staticStyle:{"max-width":"45px","max-height":"45px","cursor":"pointer"},attrs:{"src":item.url,"alt":"Logotipo"},on:{"click":function($event){return _vm.handleAnexosForm(item.coditem, item.descricao)}}}):_vm._e(),_vm._v(" "),(!item.url)?_c('i',{staticClass:"fa fa-camera d-block",staticStyle:{"font-size":"25px","color":"silver","cursor":"pointer"},on:{"click":function($event){return _vm.handleAnexosForm(item.coditem, item.descricao)}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-8"},[_c('span',{},[_c('strong',[_vm._v(_vm._s(item.descricao))]),_vm._v(" -\n                  "+_vm._s(item.codigo))]),_vm._v(" "),(_vm.existe(item.coditem))?_c('span',{staticClass:"badge badge-yellow-outline"},[_vm._v("Adicionado")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.exibePreco),expression:"exibePreco"}],staticClass:"col-md-3 col-4"},[_c('span',{},[_vm._v("R$ "),_c('strong',[_vm._v(_vm._s(_vm._f("format")(item.vlrtab)))])])])])])}),0):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-right"},[_c('strong',{staticStyle:{"font-size":"12px"}},[_vm._v("Use F9 para leitor de código de barras")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{staticClass:"nb-modal-scrollable",attrs:{"id":"mymodal"}},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v(" Item do Pedido ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(_vm.pedvit.item.descricao))]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm.pedvit.item.codigo))]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_c('small',[_vm._v(_vm._s(_vm.pedvit.item.descricao_completa))])]),_vm._v(" "),(_vm.pedvit.vlrtab > 0)?_c('span',{staticClass:"badge badge-yellow"},[_c('i',{staticClass:"fa fa-tag pr-2"}),_vm._v("Preço de Tabela "+_vm._s(_vm._f("formatValue")(_vm.pedvit.vlrtab,2))+" ")]):_vm._e(),_vm._v(" "),(_vm.pedvit.item.desconto_tabela > 0)?_c('span',{staticClass:"badge badge-red"},[_c('i',{staticClass:"fa fa-tag pr-2"}),_vm._v("Desconto em Tabela "+_vm._s(_vm._f("formatValue")(_vm.pedvit.item.desconto_tabela,2))+"%\n            ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"badge badge-blue"},[_c('i',{staticClass:"fa fa-tag pr-2"}),_vm._v("Estoque "+_vm._s(_vm._f("formatValue")(_vm.pedvit.item.saldo_estoque,2))+"\n              "),(_vm.pedvit.item.itemlote_json && _vm.pedvit.item.itemlote_json.itemlotes && _vm.pedvit.item.itemlote_json.itemlotes.length > 0)?_c('a',{attrs:{"aria-controls":"collapseExample","aria-expanded":"false","data-toggle":"collapse","href":("#div_itemlotes_" + (_vm.pedvit.item.coditem)),"role":"button"}},[_c('i',{staticClass:"fa fa-caret-down ml-2",attrs:{"aria-hidden":"true"}}),_vm._v("\n                Lotes\n              ")]):_vm._e()]),_vm._v(" "),(_vm.pedvit.item.qtlotemult > 0)?_c('span',{staticClass:"badge badge-yellow"},[_c('i',{staticClass:"fa fa-tag pr-2"}),_vm._v("Lote\n              Multiplo "+_vm._s(_vm.pedvit.item.qtlotemult)+" ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"collapse",staticStyle:{"padding":"10px"},attrs:{"id":("div_itemlotes_" + (_vm.pedvit.item.coditem))}},[(_vm.showGradeItem)?_c('div',{staticClass:"row col"},[_c('span',{staticClass:"lbl-title-produto mb-3"},[_vm._v("Estoque em Grade")]),_vm._v(" "),_c('div',{staticClass:"row col"},[_c('grade-estoque',{ref:"grade-estoque",attrs:{"params":{ view: true, coditem: _vm.pedvit.coditem }}})],1)]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto mb-3"},[_vm._v("Lotes de Estoque")]),_vm._v(" "),(_vm.pedvit.item.itemlote_json && _vm.pedvit.item.itemlote_json.itemlotes && _vm.pedvit.item.itemlote_json.itemlotes.length > 0)?_c('div',[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Depósito"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Lote"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Sublote"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Lote Fornecedor"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Validade"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Quantidade"}})],1)]),_vm._v(" "),_vm._l((_vm.pedvit.item.itemlote_json.itemlotes),function(itemlote,indexlote){return _c('div',{key:indexlote},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(itemlote.coddeposito))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(itemlote.lote))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(itemlote.sublote))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(itemlote.lotefornecedor))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(itemlote.dtvalidade)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(itemlote.qt))])])])])})],2):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.showGradeItem)?_c('div',{staticClass:"row col"},[_c('grade',{ref:"grade",attrs:{"params":{ view: _vm.isView, coditem: _vm.pedvit.coditem, qt: _vm.pedvit.qtuni, listItemGrade: _vm.pedvit.pedvgrade }},on:{"update":_vm.handleUpdateGrade}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(!_vm.showGradeItem)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvit.qtuni.validator),expression:"metadata.pedvit.qtuni.validator"}],ref:"qtuni",attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedvit.qtuni,"name":"qtuni","v-errors":_vm.errors,"disabled":_vm.isView,"addon":_vm.pedvit.uni},model:{value:(_vm.pedvit.qtuni),callback:function ($$v) {_vm.$set(_vm.pedvit, "qtuni", $$v)},expression:"pedvit.qtuni"}}):_vm._e(),_vm._v(" "),(_vm.habilitaUnimed)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvit.uni.validator),expression:"metadata.pedvit.uni.validator"}],attrs:{"tabindex":-1,"type":"select2","col":"2","metadata":_vm.metadata.pedvit.uni,"parent":"mymodal","name":"uni","v-errors":_vm.errors},model:{value:(_vm.pedvit.uni),callback:function ($$v) {_vm.$set(_vm.pedvit, "uni", $$v)},expression:"pedvit.uni"}}):_vm._e(),_vm._v(" "),(!_vm.bloqueia_preco_item)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvit.vlr.validator),expression:"metadata.pedvit.vlr.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedvit.vlr,"disabled":_vm.isView,"preaddon":"R$","name":"vlr","v-errors":_vm.errors},model:{value:(_vm.pedvit.vlr),callback:function ($$v) {_vm.$set(_vm.pedvit, "vlr", $$v)},expression:"pedvit.vlr"}}):_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedvit.vlr}}),_vm._v(" "),_c('strong',{staticClass:"lbl w-100"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.pedvit.vlr,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedvit.totliq}}),_vm._v(" "),_c('strong',{staticClass:"lbl w-100"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.pedvit.totliq,2)))])],1)],1),_vm._v(" "),(_vm.pedvit.descontotab)?_c('div',{staticClass:"row"},[_c('v-label',{staticClass:"col-md-12 col-12",attrs:{"label":"Descontos de Tabela"}}),_vm._v(" "),_vm._l((_vm.pedvit.descontotab),function(desconto,index){return _c('form-field',{key:index,attrs:{"tabindex":-1,"type":"value","col":"2","precision":2,"title":desconto.descricao,"addon":"%","disabled":_vm.isView},model:{value:(desconto.pdesc),callback:function ($$v) {_vm.$set(desconto, "pdesc", $$v)},expression:"desconto.pdesc"}})})],2):_vm._e(),_vm._v(" "),(!_vm.bloqueia_descontos)?_c('div',{staticClass:"row"},[_c('v-label',{staticClass:"col-md-12 col-12",attrs:{"label":"Desconto sobre desconto"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvit.pdesc1.validator),expression:"metadata.pedvit.pdesc1.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedv.pdesc1,"precision":2,"disabled":_vm.isView,"addon":"%","name":"pdesc1","v-errors":_vm.errors},model:{value:(_vm.pedvit.pdesc1),callback:function ($$v) {_vm.$set(_vm.pedvit, "pdesc1", $$v)},expression:"pedvit.pdesc1"}}),_vm._v(" "),(!_vm.showDesconto)?_c('div',{staticClass:"nb-margin-top nb-margin-bottom"},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.showDesconto = true}}},[_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" Outros descontos")])]):_vm._e(),_vm._v(" "),(_vm.showDesconto)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvit.pdesc2.validator),expression:"metadata.pedvit.pdesc2.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedv.pdesc2,"precision":2,"disabled":_vm.isView,"addon":"%","name":"pdesc2","v-errors":_vm.errors},model:{value:(_vm.pedvit.pdesc2),callback:function ($$v) {_vm.$set(_vm.pedvit, "pdesc2", $$v)},expression:"pedvit.pdesc2"}}):_vm._e(),_vm._v(" "),(_vm.showDesconto)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvit.pdesc3.validator),expression:"metadata.pedvit.pdesc3.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedv.pdesc3,"precision":2,"disabled":_vm.isView,"addon":"%","name":"pdesc3","v-errors":_vm.errors},model:{value:(_vm.pedvit.pdesc3),callback:function ($$v) {_vm.$set(_vm.pedvit, "pdesc3", $$v)},expression:"pedvit.pdesc3"}}):_vm._e(),_vm._v(" "),(_vm.showDesconto)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvit.pdesc4.validator),expression:"metadata.pedvit.pdesc4.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedv.pdesc4,"precision":2,"disabled":_vm.isView,"addon":"%","name":"pdesc4","v-errors":_vm.errors},model:{value:(_vm.pedvit.pdesc4),callback:function ($$v) {_vm.$set(_vm.pedvit, "pdesc4", $$v)},expression:"pedvit.pdesc4"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvit.obs.validator),expression:"metadata.pedvit.obs.validator"}],attrs:{"type":"memo","col":"6","metadata":_vm.metadata.pedvit.obs,"disabled":_vm.isView,"name":"obs","v-errors":_vm.errors},model:{value:(_vm.pedvit.obs),callback:function ($$v) {_vm.$set(_vm.pedvit, "obs", $$v)},expression:"pedvit.obs"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvit.pedcliit.validator),expression:"metadata.pedvit.pedcliit.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedvit.pedcliit,"disabled":_vm.isView,"name":"pedcliit","v-errors":_vm.errors},model:{value:(_vm.pedvit.pedcliit),callback:function ($$v) {_vm.$set(_vm.pedvit, "pedcliit", $$v)},expression:"pedvit.pedcliit"}})],1),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[(!_vm.isView)?_c('v-button',{ref:"btnConfirm",attrs:{"label":"Salvar","title":"","nb-btdef":true},on:{"click":_vm.handleSalvar}}):_vm._e(),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeForm}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_titulos_vue__ = __webpack_require__(547);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_28632543_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_titulos_vue__ = __webpack_require__(1524);
function injectStyle (ssrContext) {
  __webpack_require__(1522)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_titulos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_28632543_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_titulos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1523);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5e2a3701", content, true, {});

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".summary-border{padding:20px}.summary-statement-container{margin-top:-23px;width:180px;float:left}.summary-statement-container small{color:#7a7a7f;font-size:13px;float:right;position:relative;top:-6px}.summary-number{color:#656565;font-size:24px;float:left;font-weight:600;width:180px;text-align:right}.summary-number small{font-size:18px;color:#656565;top:0;left:3px;position:relative;float:none}", ""]);

// exports


/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-margin-bottom nb-margin-top"},[_c('label-title',{attrs:{"icon":"fa-dollar","title":"Recebimentos"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row summary-border"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('div',{staticClass:"summary-statement-container"},[_c('small',[_vm._v("A Receber")]),_vm._v(" "),_c('div',{staticClass:"summary-number"},[_c('small',[_vm._v("R$")]),_vm._v("\n                           "+_vm._s(_vm._f("format")(_vm.receber))+"\n                       ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('div',{staticClass:"summary-statement-container"},[_c('small',[_vm._v("recebido")]),_vm._v(" "),_c('div',{staticClass:"summary-number"},[_c('small',[_vm._v("R$")]),_vm._v("\n                           "+_vm._s(_vm._f("format")(_vm.recebido))+"\n                       ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('div',{staticClass:"summary-statement-container"},[_c('small',[_vm._v("Vencido")]),_vm._v(" "),_c('div',{staticClass:"summary-number"},[_c('small',[_vm._v("R$")]),_vm._v("\n                           "+_vm._s(_vm._f("format")(_vm.vencido))+"\n                       ")])])])]),_vm._v(" "),_vm._l((_vm.finList),function(fin,index){return _c('div',{key:index,staticClass:"mainbox"},[(fin.baixado=='S')?_c('div',{staticClass:"mark-green"}):_vm._e(),_vm._v(" "),(fin.aberto=='S')?_c('div',{staticClass:"mark-gray"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Parcela")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(fin.parcela))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Vencimento")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.data(fin.dtv)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Valor")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(fin.vlr)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Recebido em")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.data(fin.dtb)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Valor Recebido")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(fin.vpago)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[(fin.aberto=='S' || fin.emite_boleto=='S')?_c('v-button',{attrs:{"title":"Emitir Boleto","icon":"fa-barcode"},on:{"click":function($event){return _vm.handleEmiteBoleto(fin.codfin)}}}):_vm._e(),_vm._v(" "),(fin.aberto=='S')?_c('v-button',{attrs:{"title":"Baixar como recebido","icon":"fa-check"},on:{"click":function($event){return _vm.handleBaixar(fin.codfin)}}}):_vm._e()],1)])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_form_infcpl_vue__ = __webpack_require__(548);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8c2c41_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_form_infcpl_vue__ = __webpack_require__(1529);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_form_infcpl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8c2c41_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_form_infcpl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1527);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("c8d862c4", content, true, {});

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable",attrs:{"id":"mymodal"}},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"600px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-header"},[_c('bar-manut',{attrs:{"single-entity":"Contato","crud":this.crud},on:{"closeform":_vm.closeForm,"save":_vm.handleSave}})],1),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.partcontato.nomecontato.validator),expression:"metadata.partcontato.nomecontato.validator"}],attrs:{"type":"text","col":"12","metadata":_vm.metadata.partcontato.nomecontato,"name":"nomecontato","v-errors":_vm.errors},model:{value:(_vm.partcontato.nomecontato),callback:function ($$v) {_vm.$set(_vm.partcontato, "nomecontato", $$v)},expression:"partcontato.nomecontato"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.partcontato.email.validator),expression:"metadata.partcontato.email.validator"}],attrs:{"type":"email","col":"12","metadata":_vm.metadata.partcontato.email,"name":"email","v-errors":_vm.errors},model:{value:(_vm.partcontato.email),callback:function ($$v) {_vm.$set(_vm.partcontato, "email", $$v)},expression:"partcontato.email"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.partcontato.fone1.validator),expression:"metadata.partcontato.fone1.validator"}],attrs:{"type":"fone","col":"12","metadata":_vm.metadata.partcontato.fone1,"name":"fone1","v-errors":_vm.errors},model:{value:(_vm.partcontato.fone1),callback:function ($$v) {_vm.$set(_vm.partcontato, "fone1", $$v)},expression:"partcontato.fone1"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.partcontato.fone2.validator),expression:"metadata.partcontato.fone2.validator"}],attrs:{"type":"fone","col":"12","metadata":_vm.metadata.partcontato.fone2,"name":"fone2","v-errors":_vm.errors},model:{value:(_vm.partcontato.fone2),callback:function ($$v) {_vm.$set(_vm.partcontato, "fone2", $$v)},expression:"partcontato.fone2"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.partcontato.fone3.validator),expression:"metadata.partcontato.fone3.validator"}],attrs:{"type":"fone","col":"12","metadata":_vm.metadata.partcontato.fone3,"name":"fone3","v-errors":_vm.errors},model:{value:(_vm.partcontato.fone3),callback:function ($$v) {_vm.$set(_vm.partcontato, "fone3", $$v)},expression:"partcontato.fone3"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('div',{staticClass:"col-md-12 col-12"},[(_vm.pedv.tppedv == 'P')?_c('h4',{staticClass:"def-title"},[_vm._v("Dados do Pedido ("+_vm._s(_vm.pedv.npedido)+") "+_vm._s(_vm.pedv.part[0].nome)+" ")]):_vm._e(),_vm._v(" "),(_vm.pedv.tppedv == 'O')?_c('h4',{staticClass:"def-title"},[_vm._v("Dados do Orçamento ("+_vm._s(_vm.pedv.ncotacao)+") "+_vm._s(_vm.pedv.part[0].nome)+" ")]):_vm._e()])]),_vm._v(" "),(_vm.errmessages)?_c('validation',{attrs:{"title":"Erros de Validação","messages":_vm.errmessages.errmessages}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body",attrs:{"id":"cabec"}},[_c('label-title',{attrs:{"title":"Condições Comerciais"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.seqcontato.validator),expression:"metadata.pedv.seqcontato.validator"}],ref:"contato",attrs:{"type":"select2","col":"6","metadata":_vm.metadata.pedv.seqcontato,"disabled":_vm.isView,"name":"seqcontato","v-errors":_vm.errors,"select2":_vm.select2Contato,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluirContato()}},model:{value:(_vm.pedv.seqcontato),callback:function ($$v) {_vm.$set(_vm.pedv, "seqcontato", $$v)},expression:"pedv.seqcontato"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.pedcli.validator),expression:"metadata.pedv.pedcli.validator"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.pedv.pedcli,"disabled":_vm.isView,"name":"pedcli","v-errors":_vm.errors},model:{value:(_vm.pedv.pedcli),callback:function ($$v) {_vm.$set(_vm.pedv, "pedcli", $$v)},expression:"pedv.pedcli"}})],1),_vm._v(" "),(_vm.controleEstoqueAtivado)?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"optionnull":true,"type":"select","col":"3","metadata":_vm.metadata.pedv.movest,"disabled":_vm.isView},model:{value:(_vm.pedv.movest),callback:function ($$v) {_vm.$set(_vm.pedv, "movest", $$v)},expression:"pedv.movest"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.pedv.finalidade,"disabled":_vm.isView},model:{value:(_vm.pedv.finalidade),callback:function ($$v) {_vm.$set(_vm.pedv, "finalidade", $$v)},expression:"pedv.finalidade"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.pedv.indpresencial,"disabled":_vm.isView},model:{value:(_vm.pedv.indpresencial),callback:function ($$v) {_vm.$set(_vm.pedv, "indpresencial", $$v)},expression:"pedv.indpresencial"}}),_vm._v(" "),(_vm.pedv.indpresencial == '2' || _vm.pedv.indpresencial == '3' || _vm.pedv.indpresencial == '4' || _vm.pedv.indpresencial == '9')?_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.pedv.indintermed,"disabled":_vm.isView},model:{value:(_vm.pedv.indintermed),callback:function ($$v) {_vm.$set(_vm.pedv, "indintermed", $$v)},expression:"pedv.indintermed"}}):_vm._e(),_vm._v(" "),(!_vm.bloqueia_tabela_cliente)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codtabpre.validator),expression:"metadata.pedv.codtabpre.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.pedv.codtabpre,"select-options":_vm.tabelas_preco_options,"disabled":_vm.isView,"name":"codtabpre","v-errors":_vm.errors},model:{value:(_vm.pedv.codtabpre),callback:function ($$v) {_vm.$set(_vm.pedv, "codtabpre", $$v)},expression:"pedv.codtabpre"}}):_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.codtabpre}}),_vm._v(" "),(_vm.pedv.tabpre && _vm.pedv.tabpre.length)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.tabpre[0].descricao))]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.prazodias.validator),expression:"metadata.pedv.prazodias.validator"}],attrs:{"type":"number","col":"3","metadata":_vm.metadata.pedv.prazodias,"disabled":_vm.isView,"name":"prazodias","v-errors":_vm.errors},model:{value:(_vm.pedv.prazodias),callback:function ($$v) {_vm.$set(_vm.pedv, "prazodias", $$v)},expression:"pedv.prazodias"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.prazo.validator),expression:"metadata.pedv.prazo.validator"}],attrs:{"type":"date","col":"3","metadata":_vm.metadata.pedv.prazo,"disabled":_vm.isView,"name":"prazo","v-errors":_vm.errors},model:{value:(_vm.pedv.prazo),callback:function ($$v) {_vm.$set(_vm.pedv, "prazo", $$v)},expression:"pedv.prazo"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.validadedias.validator),expression:"metadata.pedv.validadedias.validator"}],attrs:{"type":"number","col":"3","metadata":_vm.metadata.pedv.validadedias,"disabled":_vm.isView,"name":"validadedias","v-errors":_vm.errors},model:{value:(_vm.pedv.validadedias),callback:function ($$v) {_vm.$set(_vm.pedv, "validadedias", $$v)},expression:"pedv.validadedias"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.dtvalidade.validator),expression:"metadata.pedv.dtvalidade.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.pedv.dtvalidade,"disabled":_vm.isView,"name":"dtvalidade","v-errors":_vm.errors},model:{value:(_vm.pedv.dtvalidade),callback:function ($$v) {_vm.$set(_vm.pedv, "dtvalidade", $$v)},expression:"pedv.dtvalidade"}})],1),_vm._v(" "),((_vm.pedv.tppedv == 'P' || _vm.pedv.tppedv == 'O') && _vm.pedv.venda == 'S')?_c('div',[_c('label-title',{attrs:{"title":"Comissão"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codvendr.validator),expression:"metadata.pedv.codvendr.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.pedv.codvendr,"disabled":_vm.isView,"name":"codvendr","v-errors":_vm.errors,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluir('vend')}},model:{value:(_vm.pedv.codvendr),callback:function ($$v) {_vm.$set(_vm.pedv, "codvendr", $$v)},expression:"pedv.codvendr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.pcomir.validator),expression:"metadata.pedv.pcomir.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.pedv.pcomir,"precision":2,"disabled":_vm.isView,"name":"pcomir","v-errors":_vm.errors},model:{value:(_vm.pedv.pcomir),callback:function ($$v) {_vm.$set(_vm.pedv, "pcomir", $$v)},expression:"pedv.pcomir"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codvend2.validator),expression:"metadata.pedv.codvend2.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.pedv.codvend2,"disabled":_vm.isView,"name":"codvend2","v-errors":_vm.errors,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluir('vend')}},model:{value:(_vm.pedv.codvend2),callback:function ($$v) {_vm.$set(_vm.pedv, "codvend2", $$v)},expression:"pedv.codvend2"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.pcomi2.validator),expression:"metadata.pedv.pcomi2.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.pedv.pcomi2,"precision":2,"disabled":_vm.isView,"name":"pcomi2","v-errors":_vm.errors},model:{value:(_vm.pedv.pcomi2),callback:function ($$v) {_vm.$set(_vm.pedv, "pcomi2", $$v)},expression:"pedv.pcomi2"}})],1)],1):_vm._e(),_vm._v(" "),_c('label-title',{attrs:{"title":"Transporte"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.pedv.tpfrete,"disabled":_vm.isView},model:{value:(_vm.pedv.tpfrete),callback:function ($$v) {_vm.$set(_vm.pedv, "tpfrete", $$v)},expression:"pedv.tpfrete"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codparttr.validator),expression:"metadata.pedv.codparttr.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.pedv.codparttr,"disabled":_vm.isView,"name":"codparttr","v-errors":_vm.errors,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluir('transp')}},model:{value:(_vm.pedv.codparttr),callback:function ($$v) {_vm.$set(_vm.pedv, "codparttr", $$v)},expression:"pedv.codparttr"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.vlrfre.validator),expression:"metadata.pedv.vlrfre.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedv.vlrfre,"disabled":_vm.isView,"preaddon":"R$","name":"vlrfre","v-errors":_vm.errors},model:{value:(_vm.pedv.vlrfre),callback:function ($$v) {_vm.$set(_vm.pedv, "vlrfre", $$v)},expression:"pedv.vlrfre"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.vlrseg.validator),expression:"metadata.pedv.vlrseg.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedv.vlrseg,"disabled":_vm.isView,"preaddon":"R$","name":"vlrseg","v-errors":_vm.errors},model:{value:(_vm.pedv.vlrseg),callback:function ($$v) {_vm.$set(_vm.pedv, "vlrseg", $$v)},expression:"pedv.vlrseg"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.vlrdesp.validator),expression:"metadata.pedv.vlrdesp.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedv.vlrdesp,"disabled":_vm.isView,"preaddon":"R$","name":"vlrdesp","v-errors":_vm.errors},model:{value:(_vm.pedv.vlrdesp),callback:function ($$v) {_vm.$set(_vm.pedv, "vlrdesp", $$v)},expression:"pedv.vlrdesp"}})],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.pliq.validator),expression:"metadata.pedv.pliq.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedv.pliq,"disabled":_vm.isView,"addon":"Kg","name":"pliq","v-errors":_vm.errors},model:{value:(_vm.pedv.pliq),callback:function ($$v) {_vm.$set(_vm.pedv, "pliq", $$v)},expression:"pedv.pliq"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.pbru.validator),expression:"metadata.pedv.pbru.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedv.pbru,"disabled":_vm.isView,"addon":"Kg","name":"pbru","v-errors":_vm.errors},model:{value:(_vm.pedv.pbru),callback:function ($$v) {_vm.$set(_vm.pedv, "pbru", $$v)},expression:"pedv.pbru"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.qtvolumes.validator),expression:"metadata.pedv.qtvolumes.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedv.qtvolumes,"disabled":_vm.isView,"name":"qtvolumes","v-errors":_vm.errors},model:{value:(_vm.pedv.qtvolumes),callback:function ($$v) {_vm.$set(_vm.pedv, "qtvolumes", $$v)},expression:"pedv.qtvolumes"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.volespecie.validator),expression:"metadata.pedv.volespecie.validator"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.pedv.volespecie,"disabled":_vm.isView,"name":"volespecie","v-errors":_vm.errors},model:{value:(_vm.pedv.volespecie),callback:function ($$v) {_vm.$set(_vm.pedv, "volespecie", $$v)},expression:"pedv.volespecie"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.volmarca.validator),expression:"metadata.pedv.volmarca.validator"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.pedv.volmarca,"disabled":_vm.isView,"name":"volmarca","v-errors":_vm.errors},model:{value:(_vm.pedv.volmarca),callback:function ($$v) {_vm.$set(_vm.pedv, "volmarca", $$v)},expression:"pedv.volmarca"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.volnr.validator),expression:"metadata.pedv.volnr.validator"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.pedv.volnr,"disabled":_vm.isView,"name":"volnr","v-errors":_vm.errors},model:{value:(_vm.pedv.volnr),callback:function ($$v) {_vm.$set(_vm.pedv, "volnr", $$v)},expression:"pedv.volnr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.rastreamento.validator),expression:"metadata.pedv.rastreamento.validator"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.pedv.rastreamento,"disabled":_vm.isView,"name":"rastreamento","v-errors":_vm.errors},model:{value:(_vm.pedv.rastreamento),callback:function ($$v) {_vm.$set(_vm.pedv, "rastreamento", $$v)},expression:"pedv.rastreamento"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.pedv.stentrega,"disabled":_vm.isView},model:{value:(_vm.pedv.stentrega),callback:function ($$v) {_vm.$set(_vm.pedv, "stentrega", $$v)},expression:"pedv.stentrega"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Endereço de Retirada"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.pedv.tppessoaret,"disabled":_vm.isView},model:{value:(_vm.pedv.tppessoaret),callback:function ($$v) {_vm.$set(_vm.pedv, "tppessoaret", $$v)},expression:"pedv.tppessoaret"}}),_vm._v(" "),(_vm.pedv.tppessoaret=='F')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({cpf: true, required: true,  min: 11, max: 11}),expression:"{cpf: true, required: true,  min: 11, max: 11}"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.pedv.cnpjcpfret,"disabled":_vm.isView,"name":"cpf","v-errors":_vm.errors},model:{value:(_vm.pedv.cnpjcpfret),callback:function ($$v) {_vm.$set(_vm.pedv, "cnpjcpfret", $$v)},expression:"pedv.cnpjcpfret"}}):_vm._e(),_vm._v(" "),(_vm.pedv.tppessoaret=='J')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({cnpj: true, required: true,  min: 14, max: 14}),expression:"{cnpj: true, required: true,  min: 14, max: 14}"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.pedv.cnpjcpfret,"disabled":_vm.isView,"name":"cnpj","v-errors":_vm.errors},model:{value:(_vm.pedv.cnpjcpfret),callback:function ($$v) {_vm.$set(_vm.pedv, "cnpjcpfret", $$v)},expression:"pedv.cnpjcpfret"}}):_vm._e(),_vm._v(" "),(_vm.pedv.tppessoaret=='J')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.iestret.validator),expression:"metadata.pedv.iestret.validator"}],attrs:{"metadata":_vm.metadata.pedv.iestret,"type":"text","col":"3","disabled":_vm.isView,"name":"iestret","v-errors":_vm.errors},model:{value:(_vm.pedv.iestret),callback:function ($$v) {_vm.$set(_vm.pedv, "iestret", $$v)},expression:"pedv.iestret"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.nomeret.validator),expression:"metadata.pedv.nomeret.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.pedv.nomeret,"disabled":_vm.isView,"name":"nomeret","v-errors":_vm.errors},model:{value:(_vm.pedv.nomeret),callback:function ($$v) {_vm.$set(_vm.pedv, "nomeret", $$v)},expression:"pedv.nomeret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.emailret.validator),expression:"metadata.pedv.emailret.validator"}],attrs:{"type":"email","col":"4","metadata":_vm.metadata.pedv.emailret,"disabled":_vm.isView,"name":"emailret","v-errors":_vm.errors},model:{value:(_vm.pedv.emailret),callback:function ($$v) {_vm.$set(_vm.pedv, "emailret", $$v)},expression:"pedv.emailret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.foneret.validator),expression:"metadata.pedv.foneret.validator"}],attrs:{"type":"fone","col":"2","metadata":_vm.metadata.pedv.foneret,"disabled":_vm.isView,"name":"foneret","v-errors":_vm.errors},model:{value:(_vm.pedv.foneret),callback:function ($$v) {_vm.$set(_vm.pedv, "foneret", $$v)},expression:"pedv.foneret"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.cepret.validator),expression:"metadata.pedv.cepret.validator"}],attrs:{"type":"cep","col":"2","metadata":_vm.metadata.pedv.cepret,"disabled":_vm.isView,"name":"cepret","v-errors":_vm.errors},on:{"update":_vm.updateCepRet},model:{value:(_vm.pedv.cepret),callback:function ($$v) {_vm.$set(_vm.pedv, "cepret", $$v)},expression:"pedv.cepret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.enderet.validator),expression:"metadata.pedv.enderet.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.pedv.enderet,"disabled":_vm.isView,"name":"enderet","v-errors":_vm.errors},model:{value:(_vm.pedv.enderet),callback:function ($$v) {_vm.$set(_vm.pedv, "enderet", $$v)},expression:"pedv.enderet"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.endenrret.validator),expression:"metadata.pedv.endenrret.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.pedv.endenrret,"disabled":_vm.isView,"name":"endenrret","v-errors":_vm.errors},model:{value:(_vm.pedv.endenrret),callback:function ($$v) {_vm.$set(_vm.pedv, "endenrret", $$v)},expression:"pedv.endenrret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.endecompret.validator),expression:"metadata.pedv.endecompret.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.pedv.endecompret,"disabled":_vm.isView,"name":"endecompret","v-errors":_vm.errors},model:{value:(_vm.pedv.endecompret),callback:function ($$v) {_vm.$set(_vm.pedv, "endecompret", $$v)},expression:"pedv.endecompret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.bairroret.validator),expression:"metadata.pedv.bairroret.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.pedv.bairroret,"disabled":_vm.isView,"name":"bairroret","v-errors":_vm.errors},model:{value:(_vm.pedv.bairroret),callback:function ($$v) {_vm.$set(_vm.pedv, "bairroret", $$v)},expression:"pedv.bairroret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.ufret.validator),expression:"metadata.pedv.ufret.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.pedv.ufret,"disabled":_vm.isView,"name":"ufret","v-errors":_vm.errors},model:{value:(_vm.pedv.ufret),callback:function ($$v) {_vm.$set(_vm.pedv, "ufret", $$v)},expression:"pedv.ufret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codmunret.validator),expression:"metadata.pedv.codmunret.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.pedv.codmunret,"disabled":_vm.isView,"name":"codmunret","v-errors":_vm.errors,"select2":{entity: 'mun/uf/' + _vm.pedv.ufret, minlength: 2}},model:{value:(_vm.pedv.codmunret),callback:function ($$v) {_vm.$set(_vm.pedv, "codmunret", $$v)},expression:"pedv.codmunret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codpaisret.validator),expression:"metadata.pedv.codpaisret.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.pedv.codpaisret,"disabled":_vm.isView,"name":"codpaisret","v-errors":_vm.errors},model:{value:(_vm.pedv.codpaisret),callback:function ($$v) {_vm.$set(_vm.pedv, "codpaisret", $$v)},expression:"pedv.codpaisret"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Endereço de Entrega"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.pedv.tppessoaent,"disabled":_vm.isView},model:{value:(_vm.pedv.tppessoaent),callback:function ($$v) {_vm.$set(_vm.pedv, "tppessoaent", $$v)},expression:"pedv.tppessoaent"}}),_vm._v(" "),(_vm.pedv.tppessoaent=='F')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({cpf: true, required: true,  min: 11, max: 11}),expression:"{cpf: true, required: true,  min: 11, max: 11}"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.pedv.cnpjcpfent,"disabled":_vm.isView,"name":"cpf","v-errors":_vm.errors},model:{value:(_vm.pedv.cnpjcpfent),callback:function ($$v) {_vm.$set(_vm.pedv, "cnpjcpfent", $$v)},expression:"pedv.cnpjcpfent"}}):_vm._e(),_vm._v(" "),(_vm.pedv.tppessoaent=='J')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({cnpj: true, required: true,  min: 14, max: 14}),expression:"{cnpj: true, required: true,  min: 14, max: 14}"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.pedv.cnpjcpfent,"disabled":_vm.isView,"name":"cnpj","v-errors":_vm.errors},model:{value:(_vm.pedv.cnpjcpfent),callback:function ($$v) {_vm.$set(_vm.pedv, "cnpjcpfent", $$v)},expression:"pedv.cnpjcpfent"}}):_vm._e(),_vm._v(" "),(_vm.pedv.tppessoaent=='J')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.iestent.validator),expression:"metadata.pedv.iestent.validator"}],attrs:{"metadata":_vm.metadata.pedv.iestent,"type":"text","col":"3","disabled":_vm.isView,"name":"iestent","v-errors":_vm.errors},model:{value:(_vm.pedv.iestent),callback:function ($$v) {_vm.$set(_vm.pedv, "iestent", $$v)},expression:"pedv.iestent"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.nomeent.validator),expression:"metadata.pedv.nomeent.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.pedv.nomeent,"disabled":_vm.isView,"name":"nomeent","v-errors":_vm.errors},model:{value:(_vm.pedv.nomeent),callback:function ($$v) {_vm.$set(_vm.pedv, "nomeent", $$v)},expression:"pedv.nomeent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.emailent.validator),expression:"metadata.pedv.emailent.validator"}],attrs:{"type":"email","col":"4","metadata":_vm.metadata.pedv.emailent,"disabled":_vm.isView,"name":"emailent","v-errors":_vm.errors},model:{value:(_vm.pedv.emailent),callback:function ($$v) {_vm.$set(_vm.pedv, "emailent", $$v)},expression:"pedv.emailent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.foneent.validator),expression:"metadata.pedv.foneent.validator"}],attrs:{"type":"fone","col":"2","metadata":_vm.metadata.pedv.foneent,"disabled":_vm.isView,"name":"foneent","v-errors":_vm.errors},model:{value:(_vm.pedv.foneent),callback:function ($$v) {_vm.$set(_vm.pedv, "foneent", $$v)},expression:"pedv.foneent"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.cepent.validator),expression:"metadata.pedv.cepent.validator"}],attrs:{"type":"cep","col":"2","metadata":_vm.metadata.pedv.cepent,"disabled":_vm.isView,"name":"cepent","v-errors":_vm.errors},on:{"update":_vm.updateCepEnt},model:{value:(_vm.pedv.cepent),callback:function ($$v) {_vm.$set(_vm.pedv, "cepent", $$v)},expression:"pedv.cepent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.endeent.validator),expression:"metadata.pedv.endeent.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.pedv.endeent,"disabled":_vm.isView,"name":"endeent","v-errors":_vm.errors},model:{value:(_vm.pedv.endeent),callback:function ($$v) {_vm.$set(_vm.pedv, "endeent", $$v)},expression:"pedv.endeent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.endenrent.validator),expression:"metadata.pedv.endenrent.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.pedv.endenrent,"disabled":_vm.isView,"name":"endenrent","v-errors":_vm.errors},model:{value:(_vm.pedv.endenrent),callback:function ($$v) {_vm.$set(_vm.pedv, "endenrent", $$v)},expression:"pedv.endenrent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.endecompent.validator),expression:"metadata.pedv.endecompent.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.pedv.endecompent,"disabled":_vm.isView,"name":"endecompent","v-errors":_vm.errors},model:{value:(_vm.pedv.endecompent),callback:function ($$v) {_vm.$set(_vm.pedv, "endecompent", $$v)},expression:"pedv.endecompent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.bairroent.validator),expression:"metadata.pedv.bairroent.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.pedv.bairroent,"disabled":_vm.isView,"name":"bairroent","v-errors":_vm.errors},model:{value:(_vm.pedv.bairroent),callback:function ($$v) {_vm.$set(_vm.pedv, "bairroent", $$v)},expression:"pedv.bairroent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.ufent.validator),expression:"metadata.pedv.ufent.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.pedv.ufent,"disabled":_vm.isView,"name":"ufent","v-errors":_vm.errors},model:{value:(_vm.pedv.ufent),callback:function ($$v) {_vm.$set(_vm.pedv, "ufent", $$v)},expression:"pedv.ufent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codmunent.validator),expression:"metadata.pedv.codmunent.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.pedv.codmunent,"disabled":_vm.isView,"name":"codmunent","v-errors":_vm.errors,"select2":{entity: 'mun/uf/' + _vm.pedv.ufent, minlength: 2}},model:{value:(_vm.pedv.codmunent),callback:function ($$v) {_vm.$set(_vm.pedv, "codmunent", $$v)},expression:"pedv.codmunent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codpaisent.validator),expression:"metadata.pedv.codpaisent.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.pedv.codpaisent,"disabled":_vm.isView,"name":"codpaisent","v-errors":_vm.errors},model:{value:(_vm.pedv.codpaisent),callback:function ($$v) {_vm.$set(_vm.pedv, "codpaisent", $$v)},expression:"pedv.codpaisent"}})],1),_vm._v(" "),(_vm.administrador && _vm.metadata.pedv.codusuario.select2 && _vm.metadata.pedv.codusuario.select2.entity)?_c('div',[_c('label-title',{attrs:{"title":"Usuario vinculado ao pedido"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codusuario.validator),expression:"metadata.pedv.codusuario.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.pedv.codusuario,"disabled":_vm.isView,"name":"codusuario","v-errors":_vm.errors},model:{value:(_vm.pedv.codusuario),callback:function ($$v) {_vm.$set(_vm.pedv, "codusuario", $$v)},expression:"pedv.codusuario"}})],1)],1):_vm._e(),_vm._v(" "),_c('label-title',{attrs:{"title":"Observações"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.obspedido.validator),expression:"metadata.pedv.obspedido.validator"}],attrs:{"type":"memo","col":"6","metadata":_vm.metadata.pedv.obspedido,"disabled":_vm.isView,"name":"obspedido","v-errors":_vm.errors},model:{value:(_vm.pedv.obspedido),callback:function ($$v) {_vm.$set(_vm.pedv, "obspedido", $$v)},expression:"pedv.obspedido"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.obsnf.validator),expression:"metadata.pedv.obsnf.validator"}],attrs:{"type":"memo","col":"6","metadata":_vm.metadata.pedv.obsnf,"disabled":_vm.isView,"name":"obsnf","v-errors":_vm.errors},model:{value:(_vm.pedv.obsnf),callback:function ($$v) {_vm.$set(_vm.pedv, "obsnf", $$v)},expression:"pedv.obsnf"}}),_vm._v(" "),(_vm.pedv.part && _vm.pedv.part[0].uf == 'EX')?_c('div',[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.ufsaidapais.validator),expression:"metadata.pedv.ufsaidapais.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.pedv.ufsaidapais,"name":"ufsaidapais","v-errors":_vm.errors},model:{value:(_vm.pedv.ufsaidapais),callback:function ($$v) {_vm.$set(_vm.pedv, "ufsaidapais", $$v)},expression:"pedv.ufsaidapais"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.localemb.validator),expression:"metadata.pedv.localemb.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.pedv.localemb,"name":"localemb","v-errors":_vm.errors},model:{value:(_vm.pedv.localemb),callback:function ($$v) {_vm.$set(_vm.pedv, "localemb", $$v)},expression:"pedv.localemb"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.localdesp.validator),expression:"metadata.pedv.localdesp.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.pedv.localdesp,"name":"localdesp","v-errors":_vm.errors},model:{value:(_vm.pedv.localdesp),callback:function ($$v) {_vm.$set(_vm.pedv, "localdesp", $$v)},expression:"pedv.localdesp"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isView),expression:"!isView"}],attrs:{"label":"Salvar","title":"","nb-btdef":true},on:{"click":_vm.handleSave}}),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isView),expression:"!isView"}],attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeForm}}),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isView),expression:"isView"}],attrs:{"label":"Fechar","title":""},on:{"click":_vm.closeForm}})],1)],1)],1),_vm._v(" "),(_vm.showContatoForm)?_c('div',[_c('customer-contato-form',{attrs:{"crud":"ins","codpart":_vm.pedv.codpart},on:{"closeform":_vm.closeContatoForm}})],1):_vm._e(),_vm._v(" "),(_vm.showPartForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('customer-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closeCustomerForm}})],1)])]):_vm._e(),_vm._v(" "),(_vm.showVendForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('vend-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closeVendForm}})],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1531);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("47476f7d", content, true, {});

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_content_pdf_vue__ = __webpack_require__(551);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c06fac72_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_content_pdf_vue__ = __webpack_require__(1535);
function injectStyle (ssrContext) {
  __webpack_require__(1533)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_content_pdf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c06fac72_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_content_pdf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1534);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1257e316", content, true, {});

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "div.page_break+div.page_break{page-break-before:always}.wrapper-page{page-break-after:always}.wrapper-page:last-child{page-break-after:avoid}", ""]);

// exports


/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pedv)?_c('div',{staticClass:"container-default p-5"},[_c('div',{staticClass:"pdf-content",staticStyle:{"height":"130px","min-width":"800px"},attrs:{"id":"header"}},[_c('div',{staticClass:"row bg-white border border-dark"},[_c('table',{staticClass:"table table-borderless w-100"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"text-left",staticStyle:{"width":"30%"}},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":"LOGO","height":"45px"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center",staticStyle:{"width":"50%"}},[_c('h6',[_vm._v(_vm._s(_vm.pedv.filial[0].nome))]),_vm._v(" "),(_vm.pedv.tppedv == 'P')?_c('span',[_vm._v("PEDIDO Nº "+_vm._s(_vm.pedv.npedido))]):_vm._e(),_vm._v(" "),(_vm.pedv.tppedv != 'P')?_c('span',[_vm._v("ORÇAMENTO Nº "+_vm._s(_vm.pedv.ncotacao))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"width":"20%"}},[_vm._v("\n                            Data: "+_vm._s(_vm._f("formatData")(_vm.pedv.data))+"\n                        ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"pdf-content",staticStyle:{"min-width":"800px"},attrs:{"id":"body"}},[_c('div',{staticClass:"row bg-white border-bottom border-left border-right border-dark"},[_c('table',{staticClass:"table table-borderless table-sm w-100 mb-0"},[_c('tbody',[_c('tr',[_c('td',{attrs:{"width":"60%"}},[_c('span',[_c('strong',[_vm._v("Cliente:")]),_vm._v(" "+_vm._s(_vm.pedv.part[0].nome))])]),_vm._v(" "),_c('td',{attrs:{"width":"40%"}},[_c('span',[_c('strong',[_vm._v("CNPJ:")]),_vm._v(" "+_vm._s(_vm._f("formatCNPJCPF")(_vm.pedv.part[0].cnpjcpf)))])])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"70%"}},[_c('span',[_c('strong',[_vm._v("Nome Fantasia:")]),_vm._v(" "+_vm._s(_vm.pedv.part[0].fantasia))])]),_vm._v(" "),_c('td',{attrs:{"width":"40%"}},[_c('span',[_c('strong',[_vm._v("SUFRAMA:")]),_vm._v(" "+_vm._s(_vm.pedv.part[0].suframa))])])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"50%"}},[_c('span',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.pedv.contato.length ? _vm.pedv.contato[0].fone1 : ''))])]),_vm._v(" "),_c('td',{attrs:{"width":"50%"}},[_c('span',[_c('strong',[_vm._v("Email:")]),_vm._v(" "+_vm._s(_vm.pedv.contato.length ? _vm.pedv.contato[0].email : ''))])])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('span',[_c('strong',[_vm._v("Endereço:")]),_vm._v("\n                                "+_vm._s(_vm.pedv.part[0].ende)+" "+_vm._s(_vm.pedv.part[0].endenr)+" "+_vm._s(_vm.pedv.part[0].endecomp)+" - "+_vm._s(_vm.pedv.part[0].bairro)+" - "+_vm._s(_vm.pedv.part[0].nomemun)+" - "+_vm._s(_vm.pedv.part[0].uf)+" - CEP "+_vm._s(_vm.pedv.part[0].cep)+"\n                            ")])])]),_vm._v(" "),(_vm.pedv.endeent || _vm.pedv.endenrent || _vm.pedv.endecompent || _vm.pedv.bairroent || _vm.pedv.nomemunent || _vm.pedv.ufent || _vm.pedv.cepent )?_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('span',[_c('strong',[_vm._v("Endereço Entrega:")]),_vm._v("\n                                "+_vm._s(_vm.pedv.endeent)+" "+_vm._s(_vm.pedv.endenrent)+" "+_vm._s(_vm.pedv.endecompent)+" - "+_vm._s(_vm.pedv.bairroent)+" - "+_vm._s(_vm.pedv.nomemunent)+" - "+_vm._s(_vm.pedv.ufent)+" - CEP "+_vm._s(_vm.pedv.cepent)+"\n                            ")])])]):_vm._e()])])]),_vm._v(" "),(_vm.hasItem)?_c('div',{staticClass:"row flex-column bg-white border-right border-left border-dark",staticStyle:{"overflow-x":"scroll"}},[_c('table',{staticClass:"table table-sm table-bordered tb-detalhes-produto mb-0"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.pedv.pedvit),function(item,i){return (item.servico != 'S')?_c('tr',{key:i},[(item.isgrade)?_c('td',{attrs:{"colspan":"7"}},[(item.pedvgrade.length > 0)?_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"font-size":"6px"}},[_vm._l((_vm.dados(item)),function(dado,i){return [_c('thead',{key:i},[_c('tr',[_vm._m(1,true),_vm._v(" "),_vm._l((dado.colunas),function(coluna,i){return [_c('th',{key:i,staticStyle:{"padding":"0 5px"},attrs:{"scope":"col"}},[_c('small',{staticStyle:{"font-size":"8px","font-weight":"bold"}},[_vm._v(_vm._s(coluna))])])]})],2)]),_vm._v(" "),_c('tbody',{key:i},_vm._l((dado.linhas),function(linha,i){return _c('tr',{key:i},[_vm._l((linha),function(valor,index){return [_c('td',{key:index,staticClass:"text-center",attrs:{"width":"100"}},[(index==0)?_c('small',{staticStyle:{"font-size":"8px","font-weight":"bold"}},[_vm._v(_vm._s(valor))]):_c('small',{staticStyle:{"font-size":"8px","font-weight":"bold"}},[_vm._v(_vm._s(_vm._f("formatValue")(valor ? valor : 0,2)))])])]})],2)}),0)]})],2):_vm._e()]):_vm._e(),_vm._v(" "),(!item.isgrade)?_c('td',{attrs:{"width":"45%"}},[(item.item[0].url)?_c('img',{staticClass:"ml-2 mr-2",attrs:{"src":item.item[0].url,"alt":"Img","height":"35px"}}):_vm._e(),_vm._v(" "+_vm._s(item.item[0].descricao)+"\n                        ")]):_vm._e(),_vm._v(" "),(!item.isgrade)?_c('td',{staticClass:"text-right"},[_vm._v("R$"+_vm._s(_vm._f("formatValue")(item.vlr,2,true)))]):_vm._e(),_vm._v(" "),(!item.isgrade)?_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("formatValue")(item.qtuni,2,true))+" "),_c('strong',{staticClass:"ml-1"},[_vm._v(_vm._s(item.uni))])]):_vm._e(),_vm._v(" "),(!item.isgrade)?_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("formatValue")(item.ptotdes,2,true)))]):_vm._e(),_vm._v(" "),(!item.isgrade)?_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.itemIpiST(i),2,true)))]):_vm._e(),_vm._v(" "),(!item.isgrade)?_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.itemLiqImp(i),2,true)))]):_vm._e(),_vm._v(" "),(!item.isgrade)?_c('td',{staticClass:"text-right"},[_vm._v("R$"+_vm._s(_vm._f("formatValue")(item.totliq,2,true)))]):_vm._e()]):_vm._e()}),0)]),_vm._v(" "),(_vm.pedv.pedvit.obs)?_c('div',{staticClass:"border border-light p-3 mt-n2"},[_c('span',[_c('strong',[_vm._v("Observações: "+_vm._s(_vm.pedv.pedvit.obs))])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.hasServico)?_c('div',{staticClass:"row flex-column bg-white border-top border-right border-left border-dark",staticStyle:{"overflow-x":"scroll"}},[_c('table',{staticClass:"table table-sm table-bordered tb-detalhes-produto mb-0"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.pedv.pedvit),function(item,i){return (item.servico == 'S')?_c('tr',{key:i},[(item.isgrade)?_c('td',{attrs:{"colspan":"5"}},[(item.pedvgrade.length > 0)?_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"font-size":"6px"}},[_vm._l((_vm.dados(item)),function(dado,i){return [_c('thead',{key:i},[_c('tr',[_vm._m(3,true),_vm._v(" "),_vm._l((dado.colunas),function(coluna,i){return [_c('th',{key:i,staticStyle:{"padding":"0 5px"},attrs:{"scope":"col"}},[_c('small',{staticStyle:{"font-size":"8px","font-weight":"bold"}},[_vm._v(_vm._s(coluna))])])]})],2)]),_vm._v(" "),_c('tbody',{key:i},_vm._l((dado.linhas),function(linha,i){return _c('tr',{key:i},[_vm._l((linha),function(valor,index){return [_c('td',{key:index,staticClass:"text-center",attrs:{"width":"100"}},[(index==0)?_c('small',{staticStyle:{"font-size":"8px","font-weight":"bold"}},[_vm._v(_vm._s(valor))]):_c('small',{staticStyle:{"font-size":"8px","font-weight":"bold"}},[_vm._v(_vm._s(_vm._f("formatValue")(valor ? valor : 0,2)))])])]})],2)}),0)]})],2):_vm._e()]):_vm._e(),_vm._v(" "),(!item.isgrade)?_c('td',{attrs:{"width":"45%"}},[(item.item[0].url)?_c('img',{staticClass:"ml-2 mr-2",attrs:{"src":item.item[0].url,"alt":"Img","height":"35px"}}):_vm._e(),_vm._v(" "+_vm._s(item.item[0].descricao)+"\n                        ")]):_vm._e(),_vm._v(" "),(!item.isgrade)?_c('td',{staticClass:"text-right"},[_vm._v("R$"+_vm._s(_vm._f("formatValue")(item.vlr,2, true)))]):_vm._e(),_vm._v(" "),(!item.isgrade)?_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("formatValue")(item.qtuni,2, true)))]):_vm._e(),_vm._v(" "),(!item.isgrade)?_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("formatValue")(item.ptotdes,2, true)))]):_vm._e(),_vm._v(" "),(!item.isgrade)?_c('td',{staticClass:"text-right"},[_vm._v("R$"+_vm._s(_vm._f("formatValue")(item.totliq,2, true)))]):_vm._e()]):_vm._e()}),0)]),_vm._v(" "),(_vm.pedv.pedvit.obs)?_c('div',{staticClass:"border border-light p-3 mt-n2"},[_c('span',[_c('strong',[_vm._v("Observações: "+_vm._s(_vm.pedv.pedvit.obs))])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row bg-white border-top border-right border-left border-dark d-flex justify-content-end"},[_c('table',{staticClass:"border ml-auto"},[_c('tr',{staticClass:"col-12"},[_c('th',{staticClass:"px-3 border text-right",attrs:{"width":"73","scope":"col"}},[_vm._v("Total Produtos")]),_vm._v(" "),_c('td',{staticClass:"border text-right pr-1",attrs:{"width":"73"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.totalProdutos,2, true)))])]),_vm._v(" "),(_vm.hasServico && _vm.totalServicos)?_c('tr',{staticClass:"col-12"},[_c('th',{staticClass:"px-3 border text-right",attrs:{"width":"73","scope":"col"}},[_vm._v("Total Serviços")]),_vm._v(" "),_c('td',{staticClass:"border text-right pr-1",attrs:{"width":"73"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.totalServicos,2, true)))])]):_vm._e(),_vm._v(" "),(_vm.pedv.vlrdesc && !_vm.pedv.totdes)?_c('tr',[_c('th',{staticClass:"px-3 border text-right",attrs:{"width":"73"}},[_vm._v("Descontos")]),_vm._v(" "),_c('td',{staticClass:"border text-right pr-1",attrs:{"width":"73"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.pedv.vlrdesc,2, true)))])]):_vm._e(),_vm._v(" "),(_vm.pedv.totdes)?_c('tr',[_c('th',{staticClass:"px-3 border text-right",attrs:{"width":"73"}},[_vm._v("Descontos")]),_vm._v(" "),_c('td',{staticClass:"border text-right pr-1",attrs:{"width":"73"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.pedv.totdes,2, true)))])]):_vm._e(),_vm._v(" "),(_vm.pedv.vlrfre)?_c('tr',[_c('th',{staticClass:"px-3 border text-right",attrs:{"width":"73"}},[_vm._v("Frete")]),_vm._v(" "),_c('td',{staticClass:"border text-right pr-1",attrs:{"width":"73"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.pedv.vlrfre,2, true)))])]):_vm._e(),_vm._v(" "),(_vm.pedv.toticmst)?_c('tr',[_c('th',{staticClass:"px-3 border text-right",attrs:{"width":"73"}},[_vm._v("ICMS ST")]),_vm._v(" "),_c('td',{staticClass:"border text-right pr-1",attrs:{"width":"73"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.pedv.toticmst,2, true)))])]):_vm._e(),_vm._v(" "),(_vm.pedv.totipi)?_c('tr',[_c('th',{staticClass:"px-3 border text-right",attrs:{"width":"73"}},[_vm._v("IPI")]),_vm._v(" "),_c('td',{staticClass:"border text-right pr-1",attrs:{"width":"73"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.pedv.totipi,2, true)))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('th',{staticClass:"px-3 border text-right",attrs:{"width":"73"}},[_vm._v("Total do Pedido")]),_vm._v(" "),_c('td',{staticClass:"border text-right pr-1",attrs:{"width":"73"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.pedv.totger,2, true)))])])])]),_vm._v(" "),_c('div',{staticClass:"row bg-white border-top border-bottom border-left border-right border-dark"},[_c('table',{staticClass:"table table-borderless table-sm w-100 mb-0 p-1"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"text-left",attrs:{"colspan":"4"}},[_c('span',[_c('strong',[_vm._v("Transportadora:")]),_vm._v("\n                                "+_vm._s(_vm.pedv.parttr.length ? _vm.pedv.parttr[0].nome : '')+"\n                            ")])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-left"},[_c('span',[_c('strong',[_vm._v("Pedido do Cliente:")]),_vm._v("\n                                "+_vm._s(_vm.pedv.pedcli)+"\n                            ")])]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_c('span',[_c('strong',[_vm._v("Peso Líquido:")]),_vm._v("\n                                "+_vm._s(_vm._f("formatValue")(_vm.pedv.pliq,2))+"\n                            ")])]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_c('span',[_c('strong',[_vm._v("Peso Bruto:")]),_vm._v("\n                                "+_vm._s(_vm._f("formatValue")(_vm.pedv.pbru,2))+"\n                            ")])]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_c('span',[_c('strong',[_vm._v("Volumes:")]),_vm._v("\n                                "+_vm._s(_vm._f("formatValue")(_vm.pedv.qtvol,2))+"\n                            ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row bg-white border-bottom border-left border-right border-dark"},[_c('div',{staticClass:"col-md-12 d-flex flex-column p-2"},[_c('span',[_c('strong',[_vm._v("Vendedor:")]),_vm._v(" "+_vm._s(_vm.pedv.usuario_nome)+" ")])])]),_vm._v(" "),(_vm.pedv.condicao)?_c('div',{staticClass:"row border-bottom border-left border-right border-dark"},[_c('div',{staticClass:"col-md-12 d-flex flex-column p-2"},[_c('span',[_c('strong',[_vm._v("Condição de Pagamento:")]),_vm._v(" "+_vm._s(_vm.pedv.condicao)+" ")])])]):_vm._e(),_vm._v(" "),(_vm.pedv.pedvpar && _vm.pedv.pedvpar.length > 0)?_c('div',{staticClass:"row bg-white border-bottom border-left border-right border-dark"},[_c('table',{staticClass:"table table-borderless table-sm w-50 mb-0"},[_c('tbody',[_c('tr',[_c('td',[_c('table',{staticClass:"table table-borderless table-sm mb-0"},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.pedv.pedvpar),function(item,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-left"},[_c('span',[_vm._v(_vm._s(_vm._f("formatData")(item.dtv)))])])])}),0)])]),_vm._v(" "),_c('td',[_c('table',{staticClass:"table table-borderless table-sm"},[_vm._m(5),_vm._v(" "),_c('tbody',_vm._l((_vm.pedv.pedvpar),function(item,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-left"},[_c('span',[_vm._v("R$"+_vm._s(_vm._f("formatValue")(item.vlr,2)))])])])}),0)])])])])])]):_vm._e(),_vm._v(" "),(_vm.pedv.obspedido)?_c('div',{staticClass:"row bg-white border-bottom border-left border-right border-dark"},[_c('div',{staticClass:"col-md-12 p-2",staticStyle:{"width":"95%","white-space":"pre-line"}},[_c('strong',[_vm._v("Observações: ")]),_vm._v("\n                "+_vm._s(_vm.pedv.obspedido)+"\n            ")])]):_vm._e(),_vm._v(" "),_vm._m(6),_vm._v(" "),(_vm.pedv.impinfgeraisgarantia == 'S' && _vm.pedv.filial && _vm.pedv.filial.length && _vm.pedv.filial[0].parametros && _vm.pedv.filial[0].parametros.pedido && _vm.pedv.filial[0].parametros.pedido.observacao_garantia)?_c('div',{staticClass:"row bg-white"},[_c('div',{staticClass:"col-md-12 p-2",staticStyle:{"width":"95%","white-space":"pre-line"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.pedv.filial[0].parametros.pedido.observacao_garantia)}})])]):_vm._e()])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"font-size":"10px"}},[_c('th',{attrs:{"scope":"col"}},[_vm._v(" Produto")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col","width":"50"}},[_vm._v("Preço Uni")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col","width":"50"}},[_vm._v("Quantidade")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col","width":"30"}},[_vm._v("Desc(%)")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col","width":"30"}},[_vm._v("IPI + ST")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col","width":"60"}},[_vm._v("Preço Liq + Imp")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col","width":"auto"}},[_vm._v("Subtotal")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"scope":"col"}},[_c('small',{staticStyle:{"padding":"0 20px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"font-size":"10px"}},[_c('th',{attrs:{"scope":"col"}},[_vm._v(" Serviço")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Preço Unitário")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Quantidade")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("%Desconto")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col","width":"100"}},[_vm._v("Subtotal")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"scope":"col"}},[_c('small',{staticStyle:{"padding":"0 20px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Vencimento: ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Valor Parcela: ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row bg-white"},[_c('div',{staticClass:"col-md-12",staticStyle:{"min-height":"100px"}},[_c('br'),_vm._v(" "),_c('span',[_c('strong',[_vm._v("Assinatura / Aprovado ")])]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("______________________________________________________")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PedidoContentPdf',{ref:"pedidoContentPdf",attrs:{"image":_vm.image,"pedv":_vm.pedv,"index":_vm.index},on:{"handleHtmlContent":_vm.printHtmlContent}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1538);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("10abd9d6", content, true, {});

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".badge-success[data-v-636edd08]{background-color:#28a745!important}.badge-warning[data-v-636edd08]{background-color:#ffc107!important;color:#212529!important}.main-screen[data-v-636edd08]{min-height:80vh;overflow-y:auto;display:flex;flex-direction:column}", ""]);

// exports


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1540);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("09cf9272", content, true, {});

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px-0"},[_c('div',{staticClass:"row m-0"},[_c('form-field',{attrs:{"type":"select2static","col":"12","label":"Selecione um lote","placeholder":"Selecione um lote","select-options":_vm.opcoesList},model:{value:(_vm.codqest),callback:function ($$v) {_vm.codqest=$$v},expression:"codqest"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid px-0 main-screen",staticStyle:{"font-size":"12.5px"}},[(!_vm.excluir)?_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12 text-right"},[_c('a',{staticClass:"text-primary font-weight-bold",staticStyle:{"cursor":"pointer","font-size":"12px"},on:{"click":_vm.handleSugerirLotes}},[_vm._v("\n        Sugerir alocação automática\n      ")])])]):_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12"},[(_vm.pedido)?_c('h4',{staticClass:"def-title"},[_vm._v(" Excluir Alocação do Pedido ")]):_vm._e(),_vm._v(" "),(_vm.notafiscal)?_c('h4',{staticClass:"def-title"},[_vm._v(" Excluir baixa de estoque da nota fiscal ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"border rounded bg-white"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.itemList),function(item,indexItem){return _c('div',{key:item.coditem || indexItem,staticClass:"row m-0 p-2 border-bottom align-items-center"},[_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"font-weight-bold"},[_vm._v("\n          "+_vm._s(item.codigo)+" - "+_vm._s(item.descricao)+"\n        ")]),_vm._v(" "),(item.linha || item.coluna)?_c('div',{staticClass:"text-muted",staticStyle:{"font-size":"10px"}},[_vm._v("\n          "+_vm._s(item.linha)+" "+_vm._s(item.coluna)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-2 text-right font-weight-bold"},[_vm._v("\n        "+_vm._s(item.qt)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_c('span',{staticClass:"badge",class:_vm.isAlocated(item) ? 'badge-success bg-success text-white' : 'badge-warning bg-warning text-dark',staticStyle:{"padding":"4px 8px","border-radius":"10px"}},[_vm._v("\n          "+_vm._s(_vm.qtAlcoated(item))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-1 text-center"},[(!_vm.excluir)?_c('button',{staticClass:"btn btn-primary btn-sm rounded p-0 d-flex justify-content-center align-items-center",staticStyle:{"width":"24px","height":"24px","margin":"0 auto"},on:{"click":function($event){return _vm.openModal(item)}}},[_c('i',{staticClass:"fa fa-plus",staticStyle:{"font-size":"10px"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-2 d-flex flex-wrap",staticStyle:{"gap":"4px"}},[(item.validacao && item.validacao.length > 0)?_c('div',{staticClass:"w-100 mb-1"},[_c('i',{staticClass:"fa fa-exclamation-circle text-danger",staticStyle:{"font-size":"14px"},attrs:{"data-toggle":"tooltip","data-placement":"top","title":item.validacao[0]}}),_vm._v(" "),_c('span',{staticClass:"text-danger ml-1",staticStyle:{"font-size":"11px"}},[_vm._v(_vm._s(item.validacao[0]))])]):_vm._e(),_vm._v(" "),_vm._l((item.estoque),function(e,i){return (!e.excluido)?_c('div',{key:i,staticClass:"d-flex align-items-center bg-light border rounded px-2 py-1",staticStyle:{"font-size":"11px"}},[_c('span',{staticClass:"text-secondary mr-2"},[_vm._v("\n            "+_vm._s(_vm.labelEstoque(e))+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"font-weight-bold mr-2"},[_vm._v("\n            "+_vm._s(e.qt)+"\n          ")]),_vm._v(" "),(!_vm.excluir)?_c('i',{staticClass:"fa fa-times text-danger",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.remove(item, i)}}}):_vm._e(),_vm._v(" "),(e.validacao && e.validacao.length)?_c('div',{staticClass:"ml-2"},[_c('i',{staticClass:"fa fa-exclamation-circle text-danger",attrs:{"title":e.validacao[0],"data-toggle":"tooltip"}})]):_vm._e()]):_vm._e()})],2)])})],2),_vm._v(" "),(_vm.msgErro)?_c('alert',{staticClass:"mt-3",attrs:{"type":"error","text":_vm.msgErro}}):_vm._e(),_vm._v(" "),(_vm.msgConcluir)?_c('alert',{staticClass:"mt-3",attrs:{"type":"warning","text":_vm.msgConcluir}}):_vm._e(),_vm._v(" "),(_vm.excluir)?_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12 mb-2"},[_c('input-checkbox',{ref:"confirmar",attrs:{"label":"Clique aqui para confirmar a exclusão","value-checked":"S","value-unchecked":"N"},model:{value:(_vm.exclusaoConfirmada),callback:function ($$v) {_vm.exclusaoConfirmada=$$v},expression:"exclusaoConfirmada"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-12 d-flex justify-content-end",staticStyle:{"gap":"8px"}},[(!_vm.excluir)?[_c('v-button',{attrs:{"label":_vm.concluir ? 'Concluir' : 'Validar Estoque',"nb-btdef":true},on:{"click":_vm.handleSalvar}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Fechar","nb-btdef":false},on:{"click":_vm.closeForm}})]:[_c('v-button',{attrs:{"label":"Confirmar Exclusão","nb-btdef":true},on:{"click":_vm.handleExcluir}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Fechar","nb-btdef":false},on:{"click":_vm.closeForm}})]],2)]),_vm._v(" "),(_vm.modalVisible)?_c('div',{staticClass:"modal d-block",staticStyle:{"background":"rgba(0,0,0,0.5)"},attrs:{"tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"550px","transition":"all 0.3s ease"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"height":"auto"}},[_c('div',{staticClass:"modal-header py-2 px-3"},[_c('h5',{staticClass:"modal-title",staticStyle:{"font-size":"14px","font-weight":"600"}},[_vm._v("Selecionar lote / local")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body p-3"},[(_vm.selectedItem)?_c('div',{staticClass:"mb-3 p-2 bg-light border rounded"},[_c('div',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.selectedItem.codigo)+" - "+_vm._s(_vm.selectedItem.descricao))]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between mt-1",staticStyle:{"font-size":"11px"}},[_c('span',[_vm._v("Total: "),_c('strong',[_vm._v(_vm._s(_vm.selectedItem.qt))])]),_vm._v(" "),_c('span',[_vm._v("Alocado: "),_c('strong',[_vm._v(_vm._s(_vm.qtAlcoated(_vm.selectedItem)))])]),_vm._v(" "),_c('span',{staticClass:"text-primary"},[_vm._v("Pendente: "),_c('strong',[_vm._v(_vm._s((_vm.selectedItem.qt - _vm.qtAlcoated(_vm.selectedItem)).toFixed(4)))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row m-0"},[(_vm.selectedItem)?_c('estoque-selecionar-lote',{attrs:{"coditem":_vm.selectedItem.coditem,"coditemgrade":_vm.selectedItem.coditemgrade,"entrada":true,"filial":_vm.selectedItem.codfil,"obj":_vm.selectedEstoque,"depList":_vm.depositList,"somenteComQuantidade":true},on:{"select":_vm.handleSeleciona}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row mt-3 m-0"},[_c('form-field',{attrs:{"type":"value","col":"12","label":"Quantidade","metadata":_vm.metadata.nfqt.qt},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirmAdd.apply(null, arguments)}},model:{value:(_vm.selectedEstoque.qt),callback:function ($$v) {_vm.$set(_vm.selectedEstoque, "qt", _vm._n($$v))},expression:"selectedEstoque.qt"}})],1),_vm._v(" "),(_vm.selectedItem && _vm.selectedItem.estoque && _vm.selectedItem.estoque.length)?_c('div',{staticClass:"mt-3"},[_c('button',{staticClass:"btn btn-light w-100",staticStyle:{"font-size":"12px","background-color":"#f4f6f9"},on:{"click":_vm.resetSelecionar}},[_c('i',{staticClass:"fa fa-plus mr-1"}),_vm._v(" Adicionar outro local\n            ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer py-2 px-3"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":_vm.confirmAdd}},[_vm._v("Confirmar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light btn-sm",attrs:{"type":"button"},on:{"click":_vm.closeModal}},[_vm._v("Cancelar")])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row m-0 bg-light p-2 font-weight-bold",staticStyle:{"font-size":"12px","border-bottom":"1px solid #e3e6ea"}},[_c('div',{staticClass:"col-7"},[_vm._v("Item")]),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_vm._v("Qt")]),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_vm._v("Alocado")]),_vm._v(" "),_c('div',{staticClass:"col-1"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"default-container",attrs:{"id":"formOrder"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v(" "+_vm._s(_vm.title)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"float-right"},[_c('v-button',{attrs:{"label":"Retornar","title":"","icon":"fa-arrow-left"},on:{"click":function($event){return _vm.handleRetorna()}}}),_vm._v(" "),(_vm.btTotalizar)?_c('v-button',{attrs:{"label":"Finalizar Digitação de Produtos","nb-btdef":true,"title":"Efetua a totalização do pedido e encerra a digitação"},on:{"click":function($event){return _vm.handleTotalizar()}}}):_vm._e(),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.btImprimir),expression:"btImprimir"}],attrs:{"title":"Visualizar","icon":"fa-print","nb-btdef":false},on:{"click":function($event){return _vm.handleAction(1)}}}),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.btEnviar),expression:"btEnviar"}],attrs:{"title":"Enviar Email","icon":"fa-envelope-open","nb-btdef":false},on:{"click":function($event){return _vm.handleEmail()}}}),_vm._v(" "),(_vm.moreActions.length > 0)?_c('v-button',{attrs:{"actions":_vm.moreActions},on:{"click":_vm.handleAction}}):_vm._e()],1)]),_vm._v(" "),(_vm.pedv.codpedv !== null)?_c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-user mr-2"}),_vm._v("Proprietário "+_vm._s(_vm.pedv.usuario_nome)+" ")]),_vm._v(" "),_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Criado em "+_vm._s(_vm._f("formatDataExtenso")(_vm.pedv.data)))]),_vm._v(" "),(_vm.pedv.ncotacao)?_c('span',{staticClass:"lbl-list pr-3"},[_vm._v("Orçamento "+_vm._s(_vm.pedv.ncotacao))]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.pedv.codpedv !== null)?_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-md-12 col-12"},[(_vm.pedv.varejo == 'S')?_c('span',{staticClass:"badge badge-success"},[_vm._v("Frente de Caixa")]):_vm._e(),_vm._v(" "),(_vm.pedv.tppedv == 'P')?_c('span',{staticClass:"badge",class:_vm.statusColor(_vm.pedv.stpedv)},[_vm._v(_vm._s(_vm.textOption(_vm.pedv.stpedv,
              _vm.metadata.pedv.stpedv)))]):_vm._e(),_vm._v(" "),(_vm.pedv.tppedv == 'R')?_c('span',{staticClass:"badge badge-red"},[_vm._v("Orçamento Perdido")]):_vm._e(),_vm._v(" "),(_vm.pedv.nf_pendente)?_c('span',{staticClass:"badge badge-red"},[_c('strong',[_vm._v("Pedido com nota fiscal pendente")])]):_vm._e(),_vm._v(" "),(_vm.pedv.fin_baixado)?_c('span',{staticClass:"badge badge-yellow"},[_vm._v("Pedido com título recebido")]):_vm._e(),_vm._v(" "),(_vm.pedv.fin_remessa)?_c('span',{staticClass:"badge badge-yellow"},[_vm._v("Título enviado em remessa bancaria")]):_vm._e(),_vm._v(" "),(_vm.pedv.status)?_c('span',{staticClass:"badge badge-blue"},[_vm._v(" "+_vm._s(_vm.pedv.status)+" ")]):_vm._e(),_vm._v(" "),(_vm.orcamentoVencido)?_c('span',{staticClass:"badge badge-red mr-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Orçamento com data de validade vencida"}},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v("\n            Vencido")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.errmessages)?_c('validation',{attrs:{"title":"Erros de Validação","messages":_vm.errmessages.errmessages}}):_vm._e(),_vm._v(" "),(_vm.alocacaoPendente)?_c('div',[_c('alert',{attrs:{"type":"info","text":_vm.alocacaoPendente}})],1):_vm._e(),_vm._v(" "),(_vm.alocacaoEfetuada)?_c('div',[_c('alert',{attrs:{"type":"info","title":"Aviso","text":_vm.alocacaoEfetuada}})],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formNew && _vm.pedv.codpedv === null),expression:"formNew && pedv.codpedv === null"}]},[_c('label-title',{staticClass:"nb-margin-bottom",attrs:{"title":"Cliente","icon":"fa-university"}}),_vm._v(" "),_c('div',{staticClass:"row nb-margin-bottom"},[_c('div',{staticClass:"col-md-6"},[_c('input-part',{ref:"part",attrs:{"id":"part","add-button":true,"name":"Cliente"},model:{value:(_vm.pedv.codpart),callback:function ($$v) {_vm.$set(_vm.pedv, "codpart", $$v)},expression:"pedv.codpart"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row nb-margin-bottom"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.seqcontato.validator),expression:"metadata.pedv.seqcontato.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.pedv.seqcontato,"disabled":_vm.isView,"name":"seqcontato","v-errors":_vm.errors,"select2":_vm.select2Contato,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluirContato()}},model:{value:(_vm.pedv.seqcontato),callback:function ($$v) {_vm.$set(_vm.pedv, "seqcontato", $$v)},expression:"pedv.seqcontato"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.local_metadata,"disabled":_vm.isView},model:{value:(_vm.pedv.tppedv),callback:function ($$v) {_vm.$set(_vm.pedv, "tppedv", $$v)},expression:"pedv.tppedv"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.pedv.finalidade},model:{value:(_vm.pedv.finalidade),callback:function ($$v) {_vm.$set(_vm.pedv, "finalidade", $$v)},expression:"pedv.finalidade"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.pedcli.validator),expression:"metadata.pedv.pedcli.validator"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.pedv.pedcli,"name":"pedcli","v-errors":_vm.errors},model:{value:(_vm.pedv.pedcli),callback:function ($$v) {_vm.$set(_vm.pedv, "pedcli", $$v)},expression:"pedv.pedcli"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codnates.validator),expression:"metadata.pedv.codnates.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.pedv.codnates,"disabled":_vm.isView,"add-button":true,"name":"codnates","id":"codnates","v-errors":_vm.errors},on:{"clickAdd":function($event){return _vm.handleIncluirNates()}},model:{value:(_vm.pedv.codnates),callback:function ($$v) {_vm.$set(_vm.pedv, "codnates", $$v)},expression:"pedv.codnates"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codtabpre.validator),expression:"metadata.pedv.codtabpre.validator"}],attrs:{"type":"select","col":"6","metadata":_vm.metadata.pedv.codtabpre,"select-options":_vm.tabelas_preco_options,"name":"codtabpre","v-errors":_vm.errors},model:{value:(_vm.pedv.codtabpre),callback:function ($$v) {_vm.$set(_vm.pedv, "codtabpre", $$v)},expression:"pedv.codtabpre"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.pedv.tpfrete,"disabled":_vm.isView},model:{value:(_vm.pedv.tpfrete),callback:function ($$v) {_vm.$set(_vm.pedv, "tpfrete", $$v)},expression:"pedv.tpfrete"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codparttr.validator),expression:"metadata.pedv.codparttr.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.pedv.codparttr,"disabled":_vm.isView,"name":"codparttr","v-errors":_vm.errors,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluir('transp')}},model:{value:(_vm.pedv.codparttr),callback:function ($$v) {_vm.$set(_vm.pedv, "codparttr", $$v)},expression:"pedv.codparttr"}})],1)],1),_vm._v(" "),(_vm.pedv.codpedv !== null)?_c('div',[_c('label-title',{attrs:{"title":"Cliente","icon":"fa-university"}}),_vm._v(" "),_c('div',{staticClass:"row col nb-margin-bottom"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('input-part',{ref:"part",attrs:{"disabled":true},model:{value:(_vm.pedv.codpart),callback:function ($$v) {_vm.$set(_vm.pedv, "codpart", $$v)},expression:"pedv.codpart"}})],1),_vm._v(" "),(_vm.pedv.impinfgeraisgarantia)?_c('div',{staticClass:"col-12 col-md-6"},[_c('input-switch',{attrs:{"type":"success","label":"Imprimir Informações Gerais e Garantia dos Produtos","value-checked":"S","value-unchecked":"N"},on:{"input":_vm.updateImpInfGeraisGarantia},model:{value:(_vm.pedv.impinfgeraisgarantia),callback:function ($$v) {_vm.$set(_vm.pedv, "impinfgeraisgarantia", $$v)},expression:"pedv.impinfgeraisgarantia"}})],1):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.pedv.dtvalidade)?_c('div',{staticClass:"col-md-2 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.dtvalidade}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.pedv.dtvalidade)))])],1):_vm._e(),_vm._v(" "),(_vm.pedv.prazo)?_c('div',{staticClass:"col-md-2 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.prazo}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.pedv.prazo)))])],1):_vm._e(),_vm._v(" "),(_vm.pedv.pedcli)?_c('div',{staticClass:"col-md-2 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.pedcli}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.pedcli))])],1):_vm._e(),_vm._v(" "),(!_vm.isView && _vm.status_customizados_options.length > 0)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codstatus.validator),expression:"metadata.pedv.codstatus.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.pedv.codstatus,"select-options":_vm.status_customizados_options,"name":"codstatus","v-errors":_vm.errors},model:{value:(_vm.pedv.codstatus),callback:function ($$v) {_vm.$set(_vm.pedv, "codstatus", $$v)},expression:"pedv.codstatus"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-4"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.finalidade}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.textOption(_vm.pedv.finalidade, _vm.metadata.pedv.finalidade)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-4"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.codnates}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.nates.descricao))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-4"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.tppedv}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.textOption(_vm.pedv.tppedv, _vm.metadata.pedv.tppedv)))])],1)],1),_vm._v(" "),_c('div',[(_vm.anexos.length > 0)?_c('label-title',{attrs:{"title":"Anexos","icon":"fa-paperclip"}}):_vm._e(),_vm._v(" "),(_vm.anexos.length > 0 || _vm.showAnexo)?_c('anexos-form',{ref:"anexos",attrs:{"params":{ ref: 'pedv', chaveref: _vm.pedv.codpedv, showForm: false }},on:{"change":_vm.handleChangeAnexos}}):_vm._e()],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"default-container nb-margin-top",staticStyle:{"border-top":"3px solid black"}},[_c('div',{attrs:{"id":"produtos"}},[_c('label-title',{attrs:{"title":"Produtos","icon":"fa-archive"}}),_vm._v(" "),(!_vm.isView && _vm.showPesquisaItens)?_c('pedido-addlist',{ref:"addList",attrs:{"params":_vm._paramsPesquisa},on:{"closeform":_vm.closeFormItem,"additem":_vm.handleSalvarItens}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row col mt-2 mb-3"},[(!_vm.isView && _vm.possuiListaDestaqueValida)?_c('v-button',{attrs:{"label":"Lista de Destaques","title":"Visualizar lista de produtos em destaque","icon":"fa-tags"},on:{"click":_vm.handleShowDestaque}}):_vm._e()],1),_vm._v(" "),(!_vm.isView && _vm.showListaDestaques)?_c('pedido-addlist',{attrs:{"params":_vm._paramsDestaques},on:{"closeform":_vm.closeDestaque,"additem":_vm.handleSalvarItens}}):_vm._e(),_vm._v(" "),(!this.pedv.codnates > 0)?_c('div',[_c('alert',{attrs:{"type":"warning","text":"Informe a Natureza de Operação para inserir os produtos."}})],1):(_vm.pedvit && _vm.pedvit.length == 0)?_c('div',[_c('alert',{attrs:{"type":"warning","text":"O pedido ainda não possui produtos."}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.pedvit),function(it,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"mark-green"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col-2 text-center"},[(it.item[0].url)?_c('img',{staticClass:"mx-auto d-block img-thumbnail",staticStyle:{"max-width":"45px","max-height":"45px","cursor":"pointer"},attrs:{"src":it.item[0].url,"alt":"Logotipo"}}):_c('i',{staticClass:"fa fa-camera mx-auto d-block",staticStyle:{"font-size":"25px","color":"silver"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-10"},[_c('span',{staticClass:"lbl-list-produto w-100"},[_vm._v(_vm._s(it.item[0].descricao))]),_vm._v(" "),_c('v-label',{attrs:{"label":"Codigo"}}),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(it.item[0].codigo))]),_vm._v(" "),(it.pedvgrade && it.pedvgrade.length > 0)?_c('v-button',{attrs:{"title":"Exibir grade","icon":"fa-th"},on:{"click":function($event){return _vm.handleShowGradeItem(index)}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(it.faltaestoque == 'S')?_c('span',{staticClass:"error"},[_vm._v("Produto não possui estoque suficiente.")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedvit.qtuni}}),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(it.qtuni)+" "+_vm._s(it.uni))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-4"},[_c('v-label',{attrs:{"label":"Preço"}}),_vm._v(" "),_c('span',{staticClass:"lbl"},[_c('small',[_vm._v("R$")]),_vm._v(" "+_vm._s(_vm._f("format")(it.vlr,2)))])],1),_vm._v(" "),(it.qt != it.qtuni)?_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedvit.qt}}),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(it.qt))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-4"},[_c('v-label',{attrs:{"label":"Desconto"}}),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(it.ptotdes,2))+"%")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-4"},[_c('v-label',{attrs:{"label":"Total"}}),_vm._v(" "),_c('span',{staticClass:"lbl"},[_c('small',[_vm._v("R$")]),_vm._v(" "+_vm._s(_vm._f("format")(it.totger,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-4"},[_c('v-label',{attrs:{"label":"Impostos"}}),_vm._v(" "),_c('span',{staticClass:"lbl w-100"},[_c('small',[_vm._v("IPI")]),_vm._v(" "+_vm._s(it.aipi)+"%")]),_vm._v(" "),_c('span',{staticClass:"lbl"},[_c('small',[_vm._v("ST R$")]),_vm._v(" "+_vm._s(_vm._f("format")(it.vicmst,2)))])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(it.stpedv == 'D' || it.stpedv == 'P'),expression:"it.stpedv == 'D' || it.stpedv == 'P'"}],staticClass:"col-md-2 col-12"},[_c('bar-grid',{attrs:{"options":{ barPedvIt: true, stpedv: it.stpedv, isView: _vm.isView },"moreActions":{}},on:{"edit":function($event){return _vm.handleEditItem(it.itped, false)},"view":function($event){return _vm.handleEditItem(it.itped, true)},"cancel":function($event){return _vm.handleItemCancelMsg(it.itped)},"delete":function($event){return _vm.handleItemDeleteMsg(it.itped)},"action":function($event){return _vm.closeForm()}}})],1),_vm._v(" "),(it.showGrade)?_c('div',{staticClass:"col"},[_c('grade',{ref:"grade",refInFor:true,attrs:{"params":{ view: true, coditem: it.coditem, qt: it.qtuni, listItemGrade: it.pedvgrade }}})],1):_vm._e()])])])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formOrder),expression:"formOrder"}],attrs:{"id":"formTotal"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pedvit.length > 0),expression:"pedvit.length > 0"}]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7 col-12"}),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedv.totmer}}),_vm._v(" "),_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.totmer,2)))]),_vm._v(" "),(_vm.pedv.ptotdes > 0)?_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedv.ptotdes}}):_vm._e(),_vm._v(" "),(_vm.pedv.ptotdes > 0)?_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("format")(_vm.pedv.ptotdes,2))+"%")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.pedv.vlrdesc > 0)?_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedv.vlrdesc}}):_vm._e(),_vm._v(" "),(_vm.pedv.vlrdesc > 0)?_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("format")(_vm.pedv.vlrdesc,2)))]):_vm._e(),_vm._v(" "),_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedv.rentab}}),_vm._v(" "),_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("format")(_vm.pedv.rentab,2))+"%")]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('a',{staticClass:"float-right",staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){_vm.showTotal = true}}},[_vm._v("Detalhar\n                  Totais")]),_vm._v(" "),(_vm.showTotal)?_c('div',{staticClass:"dropdown-total align-self-end",staticStyle:{"position":"absolute","right":"0","padding":"15px"}},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){_vm.showTotal = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"row col mb-2"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.pedv.totmer}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.totmer,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.pedv.toticm}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.toticm,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.pedv.toticmst}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.toticmst,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.pedv.totipi}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.totipi,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.pedv.vlrfre}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.vlrfre,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.pedv.totdes}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.totdes,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.pedv.ptotdes}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.ptotdes,2)))])])])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('v-label',{staticClass:"float-right",attrs:{"metadata-field":_vm.metadata.pedv.totger}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl-total-documento float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.totger,2)))])],1)])])])],2)]),_vm._v(" "),_c('div',{staticClass:"default-container nb-margin-top",staticStyle:{"border-top":"3px solid black"}},[_c('div',{staticClass:"nb-margin-top",attrs:{"name":"parcelas","id":"parcelas"}},[_c('label-title',{attrs:{"title":"Condição de Pagamento","icon":"fa-credit-card"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{ref:"parcelas",attrs:{"type":"select","col":"2","metadata":_vm.metadata.pedv.parcelas,"disabled":_vm.isView},model:{value:(_vm.pedv.parcelas),callback:function ($$v) {_vm.$set(_vm.pedv, "parcelas", $$v)},expression:"pedv.parcelas"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codnatfin.validator),expression:"metadata.pedv.codnatfin.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.pedv.codnatfin,"disabled":_vm.isView,"select2":{ entity: 'natfin/receitas/', minlength: 0 },"name":"codnatfin","v-errors":_vm.errors},model:{value:(_vm.pedv.codnatfin),callback:function ($$v) {_vm.$set(_vm.pedv, "codnatfin", $$v)},expression:"pedv.codnatfin"}})],1),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[((_vm.pedv.parcelas > '0') || (_vm.pedvpar && _vm.pedvpar.length))?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedvpar.dias}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedvpar.dtv}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedvpar.vlr}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedvpar.obspar}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedvpar.formapag}})],1)]),_vm._v(" "),_vm._l((_vm.pedvpar),function(par,index){return _c('div',{key:index,staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvpar.dias.validator),expression:"metadata.pedvpar.dias.validator"}],attrs:{"type":"number","col":"2","disabled":_vm.isView,"name":"dias","v-errors":_vm.errors},on:{"input":function($event){return _vm.pedvparDiasChange(index)}},model:{value:(par.dias),callback:function ($$v) {_vm.$set(par, "dias", $$v)},expression:"par.dias"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvpar.dtv.validator),expression:"metadata.pedvpar.dtv.validator"}],attrs:{"type":"date","col":"2","disabled":_vm.isView,"name":"dtv","v-errors":_vm.errors},on:{"input":function($event){return _vm.pedvparDtvChange(index)}},model:{value:(par.dtv),callback:function ($$v) {_vm.$set(par, "dtv", $$v)},expression:"par.dtv"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvpar.vlr.validator),expression:"metadata.pedvpar.vlr.validator"}],attrs:{"type":"value","col":"2","precision":2,"disabled":_vm.isView,"name":"vlr","v-errors":_vm.errors},on:{"input":function($event){return _vm.pedvparVlrChange(index)}},model:{value:(par.vlr),callback:function ($$v) {_vm.$set(par, "vlr", $$v)},expression:"par.vlr"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","col":"2","disabled":_vm.isView,"name":"obspar"},model:{value:(par.obspar),callback:function ($$v) {_vm.$set(par, "obspar", $$v)},expression:"par.obspar"}}),_vm._v(" "),_c('form-field',{attrs:{"optionnull":true,"type":"select","col":"3","metadata":_vm.metadata.pedvpar.formapag,"disabled":_vm.isView,"nolabel":true},model:{value:(par.formapag),callback:function ($$v) {_vm.$set(par, "formapag", $$v)},expression:"par.formapag"}})],1)})],2):_vm._e()]),_vm._v(" "),_c('hr')],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Informações Adicionais","icon":"fa-info-circle"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-button',{staticClass:"mb-3",attrs:{"label":"Alterar Informações Adicionais","title":"","nb-btdef":false},on:{"click":_vm.handleInfAdicionais}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.finalidade}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.textOption(_vm.pedv.finalidade, _vm.metadata.pedv.finalidade)))])],1),_vm._v(" "),(_vm.pedv.validadedias)?_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.validadedias}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.validadedias))])],1):_vm._e(),_vm._v(" "),(_vm.pedv.dtvalidade)?_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.dtvalidade}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.pedv.dtvalidade)))])],1):_vm._e(),_vm._v(" "),(_vm.pedv.prazodias)?_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.prazodias}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.prazodias))])],1):_vm._e(),_vm._v(" "),(_vm.pedv.prazo)?_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.prazo}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.pedv.prazo)))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.pedcli}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.pedcli))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.codtabpre}}),_vm._v(" "),(_vm.pedv.tabpre && _vm.pedv.tabpre.length)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.tabpre[0].descricao))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.tpfrete}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.textOption(_vm.pedv.tpfrete, _vm.metadata.pedv.tpfrete)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.codparttr}}),_vm._v(" "),(_vm.pedv.parttr && _vm.pedv.parttr.length)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.parttr[0].nome))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.pliq}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.pedv.pliq,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.pbru}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.pedv.pbru,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.qtvolumes}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.qtvolumes))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.seqcontato}}),_vm._v(" "),(_vm.pedv.contato && _vm.pedv.contato.length)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.contato[0].nomecontato))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.enderet}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.enderet)+" "+_vm._s(_vm.pedv.endenrret)+" "+_vm._s(_vm.pedv.bairroret)+" "+_vm._s(_vm.pedv.ufret))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.endeent}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.endeent)+" "+_vm._s(_vm.pedv.endenrent)+" "+_vm._s(_vm.pedv.bairroent)+" "+_vm._s(_vm.pedv.ufent))])],1)]),_vm._v(" "),(_vm.pedv.historico_status)?_c('label-title',{attrs:{"title":"Histório Status","icon":"fa-list"}}):_vm._e(),_vm._v(" "),(_vm.pedv.historico_status)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ul',{staticClass:"timeline"},[_c('li',[_c('span',{staticClass:"card-text"},[_vm._v("Pedido Realizado")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"card-text"},[_vm._v(_vm._s(_vm._f("formatDataHoraExtenso")(_vm.pedv.data)))])]),_vm._v(" "),_vm._l((_vm.pedv.historico_status),function(hist,index){return _c('li',{key:index},[_c('span',{staticClass:"card-text"},[_vm._v(_vm._s(hist.descricao))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"card-text"},[_vm._v(_vm._s(_vm._f("formatDataHoraExtenso")(hist.data)))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(hist.obs))])])})],2)])]):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.btTotalizar || _vm.pedv.stpedv === 'P'),expression:"btTotalizar || pedv.stpedv === 'P'"}],staticClass:"w-100 text-center",staticStyle:{"position":"fixed","left":"0","bottom":"0","z-index":"10","border-top":"1px solid #eee","background-color":"#fdfbfb","padding":"15px","-webkit-box-shadow":"0 -2px 5px rgba(0,0,0,0.2)","-moz-box-shadow":"0 -2px 5px rgba(0,0,0,0.2)","box-shadow":"0 -2px 5px rgba(0,0,0,0.2)"}},[_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.btTotalizar),expression:"btTotalizar"}],attrs:{"tabindex":"1","label":"Finalizar Digitação de Produtos","nb-btdef":true,"title":"Efetua a totalização do pedido e encerra a digitação","icon":""},on:{"click":function($event){return _vm.handleTotalizar()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pedv.stpedv === 'P'),expression:"pedv.stpedv === 'P'"}]},[(_vm.botaoGerarPedido)?_c('v-button',{attrs:{"label":"Gerar Pedido","icon":"","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleGerarPedido()}}}):_vm._e(),_vm._v(" "),(!_vm.isView)?_c('v-button',{attrs:{"label":"Salvar e Fechar","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleTotalizar(true)}}}):_vm._e(),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.btImprimir),expression:"btImprimir"}],attrs:{"label":"Imprimir","icon":"fa-print","nb-btdef":false},on:{"click":function($event){return _vm.handleAction(1)}}}),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.btEnviar),expression:"btEnviar"}],attrs:{"label":"Enviar Email","icon":"fa-envelope-open","nb-btdef":false},on:{"click":function($event){return _vm.handleEmail()}}}),_vm._v(" "),(_vm.botaoPerdido)?_c('v-button',{attrs:{"label":"Orçamento Perdido","icon":"","title":"","danger":true},on:{"click":function($event){return _vm.handleOrcamentoPedido()}}}):_vm._e(),_vm._v(" "),(_vm.botaoAlocarProdutos)?_c('v-button',{attrs:{"label":"Alocar Produtos","title":"","icon":""},on:{"click":_vm.handleAlocacao}}):_vm._e(),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.btFaturar),expression:"btFaturar"}],attrs:{"label":"Emitir NF-e","title":"","success":true},on:{"click":function($event){return _vm.handleFaturar('NFE')}}}),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.btFaturar),expression:"btFaturar"}],attrs:{"label":"Emitir NFC-e","title":"","success":true},on:{"click":function($event){return _vm.handleFaturar('NFCe')}}})],1)],1),_vm._v(" "),(_vm.showFormAlocacao)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"nb-modal-scrollable-container",staticStyle:{"padding":"15px","width":"90%"}},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('estoque-saida',{attrs:{"index":_vm.pedv.codpedv,"excluir":_vm.excluirAlocacao,"pedido":true},on:{"closeform":_vm.closeAlocacaoForm}})],1)])]):_vm._e(),_vm._v(" "),(_vm.showTitulosPedido)?_c('div',{staticClass:"default-container mt-2",staticStyle:{"border-top":"3px solid black"}},[_c('pedido-titulos',{attrs:{"fin-list":_vm.pedv.fin}})],1):_vm._e(),_vm._v(" "),(_vm.CANCEL_ITEM_MESSAGE)?_c('md-message',{attrs:{"code":"cancelit"},on:{"close":function($event){return _vm.handleCloseMessage()},"confirm":function($event){return _vm.handleItemCancel()}}}):_vm._e(),_vm._v(" "),(_vm.DELETE_ITEM_MESSAGE)?_c('md-message',{attrs:{"code":"deleteit"},on:{"close":function($event){return _vm.handleCloseMessage()},"confirm":function($event){return _vm.handleItemDelete()}}}):_vm._e(),_vm._v(" "),(_vm.CANCEL_MESSAGE)?_c('md-message',{attrs:{"code":"cancelpedv"},on:{"close":function($event){return _vm.handleCloseMessage()},"confirm":function($event){return _vm.handleCancel()}}}):_vm._e(),_vm._v(" "),(_vm.showFormItem)?_c('div',[_c('Trap',[_c('pedido-additem',{attrs:{"params":{ pedv: _vm.pedv, pedvit: _vm.pedvit_update },"view":_vm.formItemView},on:{"closeform":_vm.closeFormItem,"save":_vm.handleSalvarItens}})],1)],1):_vm._e(),_vm._v(" "),(_vm.showFormInfAd)?_c('div',[_c('Trap',[_c('pedido-form-infcpl',{attrs:{"controleEstoqueAtivado":_vm.controleEstoqueAtivado,"is-view":_vm.isView,"metadata":_vm.metadata,"pedv":_vm.pedv,"partCodTabpre":_vm.partCodTabpre},on:{"closeform":_vm.closeFormItem,"save":_vm.handleSaveCab}})],1)],1):_vm._e(),_vm._v(" "),(_vm.showContatoForm)?_c('div',[_c('Trap',[_c('customer-contato-form',{attrs:{"crud":"ins","codpart":_vm.pedv.codpart},on:{"closeform":_vm.closeContatoForm}})],1)],1):_vm._e(),_vm._v(" "),(_vm.showPartForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('Trap',[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('customer-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closePartForm}})],1)])])],1):_vm._e(),_vm._v(" "),(_vm.showNatesForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('Trap',[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('nates-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closeNatesForm}})],1)])])],1):_vm._e(),_vm._v(" "),(_vm.showFormEmail)?_c('div',[_c('Trap',[_c('email-form',{attrs:{"index":_vm.pedv.codpedv,"tipo":"PEDV","title":"Envio de Pedido"},on:{"closeform":_vm.closeFormEmail,"send":_vm.handleSendEmail}})],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[(_vm.showImpressao)?_c('PedidoImpressao',{ref:"impressao",attrs:{"index":_vm.codpedvImpressao},on:{"close":_vm.handleClosePrint}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1545);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("54da2bec", content, true, {});

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row align-items-center mb-3"},[_c('div',{staticClass:"col-12"},[(_vm.filterTipos)?_c('span',{staticClass:"lbl"},[_vm._v("Pedidos\n            "),_c('a',{staticClass:"dropdown-toggle pr-2",staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"1","data-toggle":"dropdown"}},[_vm._v(" "+_vm._s(_vm.labelTipos)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.filtroTipos.list),function(filtro,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleChangeFiltroTipo(index)}}},[_vm._v(_vm._s(filtro.label))])}),0)]):_vm._e(),_vm._v(" "),(_vm.filterEspera)?_c('span',{staticClass:"lbl"},[_vm._v("Vendas em Espera\n            "),_c('a',{staticClass:"dropdown-toggle pr-2",staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"1","data-toggle":"dropdown"}},[_vm._v(" "+_vm._s(_vm.labelEspera)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.filtroEspera.list),function(filtro,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleChangeFiltroEspera(index)}}},[_vm._v(_vm._s(filtro.label))])}),0)]):_vm._e(),_vm._v(" "),(_vm.filterStatus && (_vm.filtroStatusPedido.list.length > 1))?_c('span',{staticClass:"lbl pl-3"},[_vm._v("Status\n            "),_c('a',{staticClass:"dropdown-toggle pr-2",staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"1","data-toggle":"dropdown"}},[_vm._v(" "+_vm._s(_vm.statusLabel)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.filtroStatusPedido.list),function(item,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleChangeStatus(index)}}},[_vm._v(_vm._s(item.label))])}),0)]):_vm._e(),_vm._v(" "),(_vm.filterUsuarios && (_vm.filtroUsuarios.list.length > 1))?_c('span',{staticClass:"lbl pl-3"},[_vm._v("Usuário\n            "),_c('a',{staticClass:"dropdown-toggle pr-2",staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"1","data-toggle":"dropdown"}},[_vm._v(" "+_vm._s(_vm.usuarioLabel)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.filtroUsuarios.list),function(item,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleChangeUsuario(index)}}},[_vm._v(_vm._s(item.label))])}),0)]):_vm._e(),_vm._v(" "),(_vm.filterEquipes && (_vm.filtroEquipes.list.length > 1))?_c('span',{staticClass:"lbl pl-3"},[_vm._v("Equipe\n            "),_c('a',{staticClass:"dropdown-toggle pr-2",staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"1","data-toggle":"dropdown"}},[_vm._v(" "+_vm._s(_vm.equipeLabel)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.filtroEquipes.list),function(item,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleChangeEquipe(index)}}},[_vm._v(_vm._s(item.label))])}),0)]):_vm._e(),_vm._v(" "),(_vm.filterFrete && (_vm.filtroFretes.list.length > 1))?_c('span',{staticClass:"lbl pl-3"},[_vm._v("Forma de Envio\n            "),_c('a',{staticClass:"dropdown-toggle pr-2",staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"1","data-toggle":"dropdown"}},[_vm._v(" "+_vm._s(_vm.freteLabel)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.filtroFretes.list),function(item,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleChangeFrete(index)}}},[_vm._v(_vm._s(item.label))])}),0)]):_vm._e(),_vm._v(" "),(_vm.params)?_c('span',{staticClass:"lbl pl-3"},[_vm._v("Mais Filtros\n            "),_c('a',{staticClass:"dropdown-toggle",staticStyle:{"cursor":"pointer"},attrs:{"href":"#","tabindex":"1"},on:{"click":function($event){_vm.showMaisFiltros = !_vm.showMaisFiltros}}},[_vm._v(" "+_vm._s(_vm.maisfiltrosLabel)+" "),(_vm.inUse)?_c('span',{staticClass:"badge badge-info",attrs:{"id":"badge"}},[_c('span',{staticClass:"caret"})]):_vm._e(),_c('span',{staticClass:"caret"})])]):_vm._e()]),_vm._v(" "),(_vm.showMaisFiltros)?_c('div',{staticClass:"border p-4"},[(_vm.filtroPeriodos && _vm.filtroPeriodos > 0)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.filtroPeriodos),function(item,idx){return (_vm.filtroPeriodos && _vm.filtroPeriodos.length > 0)?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{attrs:{"label":item.label}})],1),_vm._v(" "),_vm._l((item.values),function(periodo,index){return _c('div',{key:index,staticClass:"col-md-12 col-12 d-flex"},[_c('input-month2',{attrs:{"p-month":periodo},on:{"monthChange":function($event){return _vm.handlePeriodoChange(idx, index)}}}),_vm._v(" "),(item.values.length > 1)?_c('v-button',{staticClass:"ml-3",attrs:{"icon":"fa-trash","link":true},on:{"click":function($event){return _vm.handleExcluiPeriodo(idx, index)}}}):_vm._e()],1)}),_vm._v(" "),(item.varios)?_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Adicionar Período","icon":"fa-plus","link":true},on:{"click":function($event){return _vm.handleAdicionaPeriodo(idx)}}})],1):_vm._e(),_vm._v(" "),_c('hr')],2):_vm._e()}),_vm._v(" "),(((_vm.filtros && _vm.filtros.length > 0) || (_vm.params.checkbox && _vm.params.checkbox.length > 0) || (_vm.params.selects && _vm.params.selects.length > 0)))?_c('div',{staticClass:"row"},[_vm._m(1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.filtros),function(flt,index){return _c('div',{key:index,staticClass:"mb-2"},[_vm._l((flt.values),function(value,index2){return _c('div',{key:index2,staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{attrs:{"label":flt.label}})],1),_vm._v(" "),_c('div',{staticClass:"col-10"},[_c('form-field',{attrs:{"type":"select2","select2":{ entity: flt.url, minlength: 0 },"placeholder":flt.label},model:{value:(value.id),callback:function ($$v) {_vm.$set(value, "id", $$v)},expression:"value.id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(flt.values.length > 1),expression:"flt.values.length > 1"}],attrs:{"icon":"fa-trash","link":true},on:{"click":function($event){return _vm.handleExcluiValueFiltro(flt, index2)}}})],1)])}),_vm._v(" "),(flt.varios)?_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Adicionar","icon":"fa-plus","link":true},on:{"click":function($event){return _vm.handleAdicionaFiltro(flt)}}})],1)]):_vm._e()],2)}),_vm._v(" "),_vm._l((_vm.params.checkbox),function(check,index){return _c('div',{key:index},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('input-checkbox',{attrs:{"label":check.label,"value-checked":check.valueChecked,"value-unchecked":check.valueUnchecked},model:{value:(check.value),callback:function ($$v) {_vm.$set(check, "value", $$v)},expression:"check.value"}})],1)])])}),_vm._v(" "),_vm._l((_vm.params.selects),function(select,index){return _c('div',{key:index},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12 d-flex-inline"},[_c('form-field',{attrs:{"type":"select2static","label":select.label,"placeholder":select.placeholder,"select-options":select.options},model:{value:(select.id),callback:function ($$v) {_vm.$set(select, "id", $$v)},expression:"select.id"}})],1),_vm._v(" "),(select.hasOwnProperty('value'))?_c('div',{staticClass:"col-md-6 col-12 d-flex-inline"},[_c('form-field',{attrs:{"type":"text","case":"normal","label":select.value_label,"placeholder":select.value_placeholder},model:{value:(select.value),callback:function ($$v) {_vm.$set(select, "value", $$v)},expression:"select.value"}})],1):_vm._e()])])}),_vm._v(" "),_c('div',{staticClass:"filtro-bar-footer pt-5"},[_c('v-button',{attrs:{"label":"Ok"},on:{"click":_vm.change}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.cancel}})],1)],2):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 col-12 mb-3"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_vm._v("Período")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 col-12 mb-3"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_vm._v("Filtros")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"filter-month":true,"single-entity":"Orçamento/Venda","plural-entity":"Orçamentos/Vendas","month-filter":_vm.monthFilter,"title-search":"Pesquise pelo número ou nome do cliente ou cnpj/cpf"},on:{"search":_vm.textSearch,"new":_vm.handleNovoPedido,"refresh":_vm.loadData,"filter":_vm.handleChangeFilter}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('pedido-filtro',{attrs:{"filter-tipos":false,"filter-equipes":true,"filter-usuarios":true,"filter-status":true,"params":_vm.paramsFiltro,"in-use":_vm.usingFiltros,"query":_vm.query},on:{"change":_vm.changeFiltros,"cancel":_vm.changeFiltros}}),_vm._v(" "),_c('filter-list',{attrs:{"params":_vm.paramFilterList},on:{"select":_vm.handleFilterList}}),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.pedvList.length == 0)?_c('alert',{attrs:{"type":"warning","text":_vm.notFoundMsg()}}):_vm._e(),_vm._v(" "),_vm._l((_vm.pedvList),function(item){return _c('div',{key:item.codpedv,staticClass:"mainbox"},[_c('div',{staticClass:"box row"},[_c('div',{staticClass:"col-md-9 col-8 d-none d-md-block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[(item.tppedv=='P')?_c('span',{staticClass:"lbl-list"},[_vm._v(" Pedido ")]):_vm._e(),_vm._v(" "),(item.tppedv=='P')?_c('span',{staticClass:"lbl-title-produto",attrs:{"title":"Número do Pedido"}},[_vm._v(" #"+_vm._s(item.npedido))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_vm._v(" Orçamento ")]),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto",attrs:{"title":"Número do Orçamento"}},[_vm._v(" #"+_vm._s(item.ncotacao))]),_vm._v(" "),_c('span',{staticClass:"lbl-list px-3"},[_c('i',{staticClass:"fa fa-user mr-2"}),_vm._v(" "+_vm._s(item.nome_usuario)+" ")]),_vm._v(" "),_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataExtenso")(item.data)))]),_vm._v(" "),(item.qtanexo > 0)?_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-paperclip pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.qtanexo)+" anexo(s)")]):_vm._e(),_vm._v(" "),(item.stpedv != 'C' && item.status)?_c('span',{staticClass:"badge badge-yellow ml-2"},[_vm._v(" "+_vm._s(item.status)+" ")]):_vm._e(),_vm._v(" "),(item.dtvalidade && item.tppedv=='O' )?_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v("Validade: "+_vm._s(_vm._f("formatDataExtenso")(item.dtvalidade)))]):_vm._e(),_vm._v(" "),(item.data_leitura)?_c('span',{staticClass:"badge badge-yellow ml-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":item.data_leitura}},[_vm._v("Leitura Efetuada")]):_vm._e(),_vm._v(" "),(_vm.orcamentoVencido(item))?_c('span',{staticClass:"badge badge-red mr-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Orçamento com data de validade vencida"}},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Vencido")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(item.nome))]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(item.cnpjcpf))+" - "+_vm._s(item.uf))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('span',{staticClass:"data-list"},[_vm._v("R$ "),_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(item.totger,2)))])])]),_vm._v(" "),(item.datanfsync || item.nf)?_c('div',{staticClass:"col-md-12 col-12"},[(item.datanfsync)?_c('label',{staticClass:"lbl-list"},[_vm._v("Faturado em")]):_vm._e(),_vm._v(" "),(item.datanfsync)?_c('span',{staticClass:"lbl-list"},[_vm._v(_vm._s(_vm._f("formatData")(item.datanfsync)))]):_vm._e(),_vm._v(" "),(item.nf)?_c('label',{staticClass:"lbl-list"},[_vm._v("Nota Fiscal")]):_vm._e(),_vm._v(" "),(item.nf)?_c('span',{staticClass:"lbl-list"},[_vm._v("Serie: "+_vm._s(item.serienf))]):_vm._e(),_vm._v(" "),(item.nf)?_c('span',{staticClass:"lbl-list"},[_vm._v(" Nr.: "+_vm._s(item.nf))]):_vm._e(),_vm._v(" "),(item.chavenfsync)?_c('span',{staticClass:"lbl-list"},[_vm._v(" Chave: "+_vm._s(item.chavenfsync))]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-4 d-none d-md-block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"badge float-right mb-2",class:_vm.statusColor(item.stpedv, item.tppedv)},[_vm._v(_vm._s(_vm.textST(item.stpedv, item.tppedv)))]),_vm._v(" "),(item.varejo == 'S')?_c('span',{staticClass:"badge badge-success float-right mr-2"},[_vm._v(" Varejo ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col align-items-right"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: _vm.enableEdit(item.stpedv, item.cieloidsuperlink, item.vendarecebida, item.tppedv), btnPrint: _vm.enablePrint(item.stpedv), btnFaturar: false},"moreActions":_vm.getActions(item)},on:{"edit":function($event){return _vm.handleEditPedido(item.codpedv)},"view":function($event){return _vm.handleEditPedido(item.codpedv)},"print":function($event){return _vm.handleAction(1, item.codpedv)},"faturar":function($event){return _vm.handleAction(2, item.codpedv)},"action":function($event){return _vm.handleAction($event, item.codpedv)}}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-md-none d-xs-block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-2"},[(item.tppedv=='P')?_c('span',{staticClass:"lbl-list"},[_vm._v(" Pedido ")]):_vm._e(),_vm._v(" "),(item.tppedv=='P')?_c('span',{staticClass:"lbl-title-produto",attrs:{"title":"Número do Pedido"}},[_vm._v(" #"+_vm._s(item.npedido))]):_vm._e(),_vm._v(" "),(item.tppedv=='O')?_c('span',{staticClass:"lbl-list"},[_vm._v(" Orçamento ")]):_vm._e(),_vm._v(" "),(item.tppedv=='O')?_c('span',{staticClass:"lbl-title-produto",attrs:{"title":"Número do Orçamento"}},[_vm._v(" #"+_vm._s(item.ncotacao))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatData")(item.data)))]),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-user mr-2"}),_vm._v(" "+_vm._s(item.nome_usuario)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-2"},[_c('span',{staticClass:"badge",class:_vm.statusColor(item.stpedv, item.tppedv)},[_vm._v(_vm._s(_vm.textST(item)))]),_vm._v(" "),(item.ecommerce == 'S')?_c('span',{staticClass:"badge badge-warning"},[_c('i',{staticClass:"fa fa-shopping-basket"})]):_vm._e(),_vm._v(" "),(item.dtvalidade && item.tppedv=='O')?_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v("Validade "+_vm._s(_vm._f("formatDataExtenso")(item.dtvalidade)))]):_vm._e(),_vm._v(" "),(_vm.orcamentoVencido(item))?_c('span',{staticClass:"badge badge-red mr-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Orçamento com data de validade vencida"}},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v("Vencido")]):_vm._e(),_vm._v(" "),(item.data_leitura)?_c('span',{staticClass:"badge badge-yellow ml-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":'Leitura efetuada em ' + item.data_leitura}},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"lbl-deal-title d-block"},[_vm._v(_vm._s(item.nome))]),_vm._v(" "),(item.fone1)?_c('span',{staticClass:"data-list-sm"},[_c('i',{staticClass:"fa fa-phone",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatFone")(item.fone1))+" ")]):_vm._e(),_vm._v(" "),(item.email)?_c('span',{staticClass:"data-list-sm"},[_c('i',{staticClass:"fa fa-envelope",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.email)+" ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-2"},[_c('span',{staticClass:"data-list-sm"},[_vm._v("R$ "),_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(item.totger,2)))])]),_vm._v(" "),_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: _vm.enableEdit(item.stpedv, item.cieloidsuperlink, item.vendarecebida, item.tppedv), btnPrint: _vm.enablePrint(item.stpedv), btnFaturar: false},"moreActions":_vm.getActions(item)},on:{"edit":function($event){return _vm.handleEditPedido(item.codpedv)},"view":function($event){return _vm.handleEditPedido(item.codpedv, true)},"print":function($event){return _vm.handleAction(1, item.codpedv)},"faturar":function($event){return _vm.handleAction(2, item.codpedv)},"action":function($event){return _vm.handleAction($event, item.codpedv)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-2"},[(_vm.appLoja && item.tppedv == 'P' && item.stfraud == '3')?_c('span',{staticClass:"badge badge-error mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Reprovado Clearsale ")]):_vm._e(),_vm._v(" "),(_vm.appLoja && item.tppedv == 'P' && item.stpedv != 'C' && item.stfraud == '2')?_c('span',{staticClass:"badge badge-success mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Clearsale ")]):_vm._e(),_vm._v(" "),(_vm.appLoja && item.tppedv == 'P' && item.stpedv != 'C' && item.cieloidsuperlink && item.vendarecebida != 'S' && item.vendarecebida != 'N')?_c('span',{staticClass:"badge badge-warning mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Aguardando Pagamento Online ")]):_vm._e(),_vm._v(" "),(_vm.appLoja && item.tppedv == 'P' && item.cieloidsuperlink && item.vendarecebida == 'N')?_c('span',{staticClass:"badge badge-warning mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Pagamento Não realizado ")]):_vm._e(),_vm._v(" "),(_vm.appLoja && item.tppedv == 'P' && item.vendarecebida == 'S')?_c('span',{staticClass:"badge badge-success mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Pagamento Efetuado ")]):_vm._e()])])])])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('pedido-form',{attrs:{"index":this.codpedv,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[(_vm.showImpressao)?_c('PedidoImpressao',{ref:"impressao",attrs:{"index":_vm.codpedvImpressao},on:{"close":_vm.handleClosePrint}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_compra_list_vue__ = __webpack_require__(557);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f3f365_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_compra_list_vue__ = __webpack_require__(1564);
function injectStyle (ssrContext) {
  __webpack_require__(1549)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79f3f365"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_compra_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f3f365_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_compra_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1550);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0694f5d0", content, true, {});

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _apiFunctions = __webpack_require__(5);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var MODULO = 'purchase/compra/';
var MODULOIT = 'purchase/comprait/';

exports.default = {
  methods: {
    apiCompra: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(operacao, compra, comprait, comprapar, responseCallback) {
        var data_compra, sendData, metodo, data, validation;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data_compra = _extends({}, compra);

                data_compra.comprait = comprait;
                data_compra.comprapar = comprapar;

                sendData = { compra: data_compra };
                metodo = 'post';
                _context.next = 7;
                return (0, _apiFunctions.apiORDSpost)(this.$store, MODULO, sendData, metodo);

              case 7:
                data = _context.sent;

                if (data.items) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return');

              case 10:
                validation = null;

                if (data.items[0].validation) {
                  validation = JSON.parse(data.items[0].validation);
                }

                if (responseCallback) {
                  responseCallback(operacao, data.items[0], validation);
                }

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function apiCompra(_x, _x2, _x3, _x4, _x5) {
        return _ref.apply(this, arguments);
      }

      return apiCompra;
    }(),
    apiIntegraFinanceiroCompra: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(codcompra, responseCallback) {
        var url, sendData, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = MODULO + 'financeiro';
                sendData = { codcompra: codcompra };
                _context2.next = 4;
                return (0, _apiFunctions.apiORDSpost)(this.$store, url, sendData, 'post');

              case 4:
                data = _context2.sent;


                if (responseCallback) {
                  responseCallback(data.items ? data.items[0] : data);
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function apiIntegraFinanceiroCompra(_x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return apiIntegraFinanceiroCompra;
    }(),
    apiExcluirFinanceiroCompra: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(codcompra, responseCallback) {
        var url, sendData, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = MODULO + 'financeiro/excluir';
                sendData = { codcompra: codcompra };
                _context3.next = 4;
                return (0, _apiFunctions.apiORDSpost)(this.$store, url, sendData, 'post');

              case 4:
                data = _context3.sent;


                if (responseCallback) {
                  responseCallback(data.items ? data.items[0] : data);
                }

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function apiExcluirFinanceiroCompra(_x8, _x9) {
        return _ref3.apply(this, arguments);
      }

      return apiExcluirFinanceiroCompra;
    }(),
    apiDuplicaCompra: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(codcompra, responseCallback) {
        var url, sendData, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                url = MODULO + 'duplica';
                sendData = { codcompra: codcompra };
                _context4.next = 4;
                return (0, _apiFunctions.apiORDSpost)(this.$store, url, sendData, 'post');

              case 4:
                data = _context4.sent;


                if (responseCallback) {
                  responseCallback(data.items ? data.items[0] : data);
                }

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function apiDuplicaCompra(_x10, _x11) {
        return _ref4.apply(this, arguments);
      }

      return apiDuplicaCompra;
    }(),
    apiCancelaCompra: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(codcompra, responseCallback) {
        var url, sendData, data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                url = MODULO + 'cancelar';
                sendData = { codcompra: codcompra };
                _context5.next = 4;
                return (0, _apiFunctions.apiORDSpost)(this.$store, url, sendData, 'post');

              case 4:
                data = _context5.sent;


                if (responseCallback) {
                  responseCallback(data.items ? data.items[0] : data);
                }

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function apiCancelaCompra(_x12, _x13) {
        return _ref5.apply(this, arguments);
      }

      return apiCancelaCompra;
    }(),
    apiEnviaEmailCompra: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(codcompra, data, responseCallback) {
        var _require, apiEmailPDF, email;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _require = __webpack_require__(5), apiEmailPDF = _require.apiEmailPDF;
                _context6.next = 3;
                return apiEmailPDF(this, 'purchaseorder/' + codcompra, data);

              case 3:
                email = _context6.sent;

                if (responseCallback) {
                  responseCallback(email);
                }

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function apiEnviaEmailCompra(_x14, _x15, _x16) {
        return _ref6.apply(this, arguments);
      }

      return apiEnviaEmailCompra;
    }()
  }
};

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_compra_content_pdf_vue__ = __webpack_require__(561);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c608fee8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_compra_content_pdf_vue__ = __webpack_require__(1555);
function injectStyle (ssrContext) {
  __webpack_require__(1553)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_compra_content_pdf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c608fee8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_compra_content_pdf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1554);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5aaa864d", content, true, {});

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "div.page_break+div.page_break{page-break-before:always}.wrapper-page{page-break-after:always}.wrapper-page:last-child{page-break-after:avoid}", ""]);

// exports


/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.compra)?_c('div',{staticClass:"container-default p-5"},[_c('div',{staticClass:"pdf-content",staticStyle:{"height":"130px","min-width":"800px"},attrs:{"id":"header"}},[_c('div',{staticClass:"row bg-white border border-dark"},[_c('table',{staticClass:"table table-borderless w-100"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"text-left",staticStyle:{"width":"30%"}},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":"LOGO","height":"45px"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center",staticStyle:{"width":"50%"}},[_c('h6',[_vm._v(_vm._s(_vm.compra.filial[0].nome))]),_vm._v(" "),_c('span',[_vm._v("PEDIDO DE COMPRA Nº "+_vm._s(_vm.compra.npedido))]),_vm._v(" "),(_vm.compra.status === 'C')?_c('br'):_vm._e(),(_vm.compra.status === 'C')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("CANCELADO")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"width":"20%"}},[_vm._v("\n                            Data: "+_vm._s(_vm._f("formatData")(_vm.compra.data))+"\n                        ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"pdf-content",staticStyle:{"min-width":"800px"},attrs:{"id":"body"}},[_c('div',{staticClass:"row bg-white border-bottom border-left border-right border-dark"},[_c('table',{staticClass:"table table-borderless table-sm w-100 mb-0"},[_c('tbody',[_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('span',[_c('strong',[_vm._v("Fornecedor:")]),_vm._v(" "+_vm._s(_vm.compra.part[0].nome))])])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"60%"}},[_c('span',[_c('strong',[_vm._v("CNPJ:")]),_vm._v(" "+_vm._s(_vm._f("formatCNPJCPF")(_vm.compra.part[0].cnpjcpf)))])]),_vm._v(" "),_c('td',{attrs:{"width":"40%"}},[_c('span',[_c('strong',[_vm._v("Telefone:")]),_vm._v(" "+_vm._s(_vm.compra.part[0].fone_contato || _vm.compra.part[0].fone1))])])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('span',[_c('strong',[_vm._v("Email:")]),_vm._v(" "+_vm._s(_vm.compra.part[0].emaildanfe))])])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('span',[_c('strong',[_vm._v("Endereço:")]),_vm._v("\n                                "+_vm._s(_vm.compra.part[0].ende)+" "+_vm._s(_vm.compra.part[0].endenr)+" "+_vm._s(_vm.compra.part[0].endecomp)+" - "+_vm._s(_vm.compra.part[0].bairro)+" - "+_vm._s(_vm.compra.part[0].nomemun)+" - "+_vm._s(_vm.compra.part[0].uf)+" - CEP "+_vm._s(_vm.compra.part[0].cep)+"\n                            ")])])])])])]),_vm._v(" "),(_vm.compra.comprait && _vm.compra.comprait.length > 0)?_c('div',{staticClass:"row flex-column bg-white border-right border-left border-dark",staticStyle:{"overflow-x":"scroll"}},[_c('table',{staticClass:"table table-sm table-bordered tb-detalhes-produto mb-0"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.compra.comprait),function(item,i){return _c('tr',{key:i},[_c('td',{attrs:{"width":"55%"}},[_vm._v("\n                            "+_vm._s(item.refitem)+" - "+_vm._s(item.dscitem)+"\n                            "),(item.obsitem)?_c('div',{staticClass:"mt-1 small"},[_c('strong',[_vm._v("Obs:")]),_vm._v(" "+_vm._s(item.obsitem)+"\n                            ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("R$"+_vm._s(_vm._f("formatValue")(item.preco,2,true)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("formatValue")(item.quantidade,2,true))+" "),_c('strong',{staticClass:"ml-1"},[_vm._v(_vm._s(item.unidade))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("R$"+_vm._s(_vm._f("formatValue")(item.total,2,true)))])])}),0)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row bg-white border-top border-right border-left border-dark d-flex justify-content-end"},[_c('table',{staticClass:"ml-auto"},[(_vm.compra.vlrfrete)?_c('tr',[_c('th',{staticClass:"px-3 text-right",attrs:{"width":"150"}},[_vm._v("Frete")]),_vm._v(" "),_c('td',{staticClass:"text-right pr-1",attrs:{"width":"150"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.compra.vlrfrete,2, true)))])]):_vm._e(),_vm._v(" "),(_vm.compra.totdesc)?_c('tr',[_c('th',{staticClass:"px-3 text-right",attrs:{"width":"150"}},[_vm._v("Descontos")]),_vm._v(" "),_c('td',{staticClass:"text-right pr-1",attrs:{"width":"150"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.compra.totdesc,2, true)))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('th',{staticClass:"px-3 text-right",attrs:{"width":"150"}},[_vm._v("Total do Pedido")]),_vm._v(" "),_c('td',{staticClass:"text-right pr-1",attrs:{"width":"150"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.compra.totpedido,2, true)))])])])]),_vm._v(" "),_c('div',{staticClass:"row bg-white border-top border-bottom border-left border-right border-dark"},[_c('table',{staticClass:"table table-borderless table-sm w-100 mb-0 p-1"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"text-left",attrs:{"width":"60%"}},[_c('span',[_c('strong',[_vm._v("Transportadora:")]),_vm._v("\n                                "+_vm._s(_vm.compra.parttr.length ? _vm.compra.parttr[0].nome : '')+"\n                            ")])]),_vm._v(" "),_c('td',{staticClass:"text-left",attrs:{"width":"40%"}},[_c('span',[_c('strong',[_vm._v("Frete:")]),_vm._v("\n                                "+_vm._s(_vm.formatFrete(_vm.compra.tipofrete))+"\n                            ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row bg-white border-bottom border-left border-right border-dark"},[_c('div',{staticClass:"col-md-12 d-flex flex-column p-2"},[_c('span',[_c('strong',[_vm._v("Solicitante:")]),_vm._v(" "+_vm._s(_vm.compra.usuario_nome)+" ")])])]),_vm._v(" "),(_vm.compra.comprapar && _vm.compra.comprapar.length > 0)?_c('div',{staticClass:"row bg-white border-bottom border-left border-right border-dark"},[_c('table',{staticClass:"table table-borderless table-sm w-50 mb-0"},[_c('tbody',[_c('tr',[_c('td',[_c('table',{staticClass:"table table-borderless table-sm mb-0"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.compra.comprapar),function(item,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-left"},[_c('span',[_vm._v(_vm._s(_vm._f("formatData")(item.dtvenc)))])])])}),0)])]),_vm._v(" "),_c('td',[_c('table',{staticClass:"table table-borderless table-sm"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.compra.comprapar),function(item,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-left"},[_c('span',[_vm._v("R$"+_vm._s(_vm._f("formatValue")(item.valor,2)))])])])}),0)])])])])])]):_vm._e(),_vm._v(" "),(_vm.compra.obs)?_c('div',{staticClass:"row bg-white border-bottom border-left border-right border-dark"},[_c('div',{staticClass:"col-md-12 p-2",staticStyle:{"width":"95%","white-space":"pre-line"}},[_c('strong',[_vm._v("Observações: ")]),_vm._v("\n                "+_vm._s(_vm.compra.obs)+"\n            ")])]):_vm._e(),_vm._v(" "),_vm._m(3)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"font-size":"10px"}},[_c('th',{attrs:{"scope":"col"}},[_vm._v(" Produto")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col","width":"100"}},[_vm._v("Preço Unitário")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col","width":"100"}},[_vm._v("Quantidade")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col","width":"100"}},[_vm._v("Subtotal")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Vencimento: ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Valor Parcela: ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row bg-white"},[_c('div',{staticClass:"col-md-12",staticStyle:{"min-height":"100px"}},[_c('br'),_vm._v(" "),_c('span',[_c('strong',[_vm._v("Assinatura / Aprovado ")])]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("______________________________________________________")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PedidoCompraContentPdf',{ref:"pedidoContentPdf",attrs:{"image":_vm.image,"compra":_vm.compra,"index":_vm.index},on:{"handleHtmlContent":_vm.printHtmlContent}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_compra_itens_vue__ = __webpack_require__(562);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d7d0f70_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_compra_itens_vue__ = __webpack_require__(1560);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_compra_itens_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d7d0f70_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_compra_itens_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_compra_item_vue__ = __webpack_require__(563);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_07cc838a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_compra_item_vue__ = __webpack_require__(1559);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_compra_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_07cc838a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_compra_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v("Item do Pedido de Compra")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('closeform')}}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body p-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.comprait.coditem}}),_vm._v(" "),_c('div',{},[_c('input-item',{ref:"item",attrs:{"add-button":true},on:{"onselect":_vm.handleProductSelect},model:{value:(_vm.item.coditem),callback:function ($$v) {_vm.$set(_vm.item, "coditem", $$v)},expression:"item.coditem"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.comprait.quantidade.validator),expression:"metadata.comprait.quantidade.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.comprait.quantidade,"name":"quantidade","v-errors":_vm.errors},on:{"input":_vm.updateTotal},model:{value:(_vm.item.quantidade),callback:function ($$v) {_vm.$set(_vm.item, "quantidade", $$v)},expression:"item.quantidade"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.comprait.unidade.validator),expression:"metadata.comprait.unidade.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.comprait.unidade,"name":"unidade","v-errors":_vm.errors},model:{value:(_vm.item.unidade),callback:function ($$v) {_vm.$set(_vm.item, "unidade", $$v)},expression:"item.unidade"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.comprait.preco.validator),expression:"metadata.comprait.preco.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.comprait.preco,"name":"preco","v-errors":_vm.errors},on:{"input":_vm.updateTotal},model:{value:(_vm.item.preco),callback:function ($$v) {_vm.$set(_vm.item, "preco", $$v)},expression:"item.preco"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.comprait.total.validator),expression:"metadata.comprait.total.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.metadata.comprait.total,"disabled":"","name":"total","v-errors":_vm.errors},model:{value:(_vm.item.total),callback:function ($$v) {_vm.$set(_vm.item, "total", $$v)},expression:"item.total"}})],1),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.comprait.obsitem.validator),expression:"metadata.comprait.obsitem.validator"}],attrs:{"type":"memo","col":"12","metadata":_vm.metadata.comprait.obsitem,"name":"obsitem","v-errors":_vm.errors},model:{value:(_vm.item.obsitem),callback:function ($$v) {_vm.$set(_vm.item, "obsitem", $$v)},expression:"item.obsitem"}})],1)]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer p-3 text-right"},[_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":function($event){return _vm.$emit('closeform')}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Salvar Item","success":true,"icon":"fa-check"},on:{"click":_vm.handleSave}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.readonly)?_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12"},[_c('v-button',{attrs:{"label":"Adicionar Item","icon":"fa-plus"},on:{"click":function($event){return _vm.handleEditItem(null)}}})],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.value),function(it,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Produto")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(it.dscitem || 'Produto ' + it.coditem))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Qtd")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(it.quantidade)+" "+_vm._s(it.unidade))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Preço")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(it.preco,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4 text-right"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Total")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(it.total,2, true)))])]),_vm._v(" "),(!_vm.readonly)?_c('div',{staticClass:"col-md-2 col-12 text-right"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnEdit: true, btnDelete: true}},on:{"edit":function($event){return _vm.handleEditItem(index)},"delete":function($event){return _vm.handleRemoveItem(index)}}})],1):_vm._e()])])])}),_vm._v(" "),(_vm.showModal)?_c('compra-item',{attrs:{"value":_vm.selectedItem,"metadata":_vm.metadata},on:{"closeform":function($event){_vm.showModal = false},"save":_vm.saveItem}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_compra_parcelas_vue__ = __webpack_require__(564);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f05a13f_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_compra_parcelas_vue__ = __webpack_require__(1562);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_compra_parcelas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f05a13f_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_compra_parcelas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.readonly)?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-3 col-12"},[_c('div',{staticClass:"form-group form-group-sm"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.compra.parcelas}}),_vm._v(" "),_c('div',{staticClass:"input-group input-group-sm"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.localQtParcelas),expression:"localQtParcelas"}],ref:"parcelas",staticClass:"form-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.localQtParcelas=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.calculaParcelas]}},_vm._l((_vm.parcelaOptions),function(opt){return _c('option',{key:opt.id,domProps:{"value":opt.id}},[_vm._v(_vm._s(opt.text))])}),0)])],1)])]):_vm._e(),_vm._v(" "),(_vm.value.length > 0)?_c('div',{staticClass:"row mb-2 font-bold"},[_c('div',{staticClass:"col-md-1 col-2 text-center"},[_vm._v("Nº")]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.comprapar.dias}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.comprapar.dtvenc}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.comprapar.valor}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.comprapar.formapag}})],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.value),function(par,index){return _c('div',{key:index,staticClass:"row mb-2 align-items-center"},[_c('div',{staticClass:"col-md-1 col-2 text-center"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(index + 1))])]),_vm._v(" "),_c('form-field',{attrs:{"type":"number","col":"2","disabled":_vm.readonly || _vm.localQtParcelas === '0',"name":"dias","metadata":_vm.metadata.comprapar.dias,"nolabel":true},on:{"input":function($event){return _vm.updateDate(index)}},model:{value:(par.dias),callback:function ($$v) {_vm.$set(par, "dias", $$v)},expression:"par.dias"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"date","col":"2","disabled":_vm.readonly,"name":"dtvenc","metadata":_vm.metadata.comprapar.dtvenc,"nolabel":true},on:{"input":function($event){return _vm.updateDays(index)}},model:{value:(par.dtvenc),callback:function ($$v) {_vm.$set(par, "dtvenc", $$v)},expression:"par.dtvenc"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"3","precision":2,"disabled":_vm.readonly,"name":"valor","metadata":_vm.metadata.comprapar.valor,"nolabel":true},on:{"input":function($event){return _vm.updatePercFromValue(index)}},model:{value:(par.valor),callback:function ($$v) {_vm.$set(par, "valor", $$v)},expression:"par.valor"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.comprapar.formapag,"disabled":_vm.readonly,"nolabel":true,"optionnull":true},model:{value:(par.formapag),callback:function ($$v) {_vm.$set(par, "formapag", $$v)},expression:"par.formapag"}}),_vm._v(" "),(!_vm.readonly)?_c('div',{staticClass:"col-md-1 col-3 text-right"},[_c('v-button',{attrs:{"title":"Remover","icon":"fa-times","danger":true},on:{"click":function($event){return _vm.handleRemoveParcela(index)}}})],1):_vm._e()],1)}),_vm._v(" "),(_vm.value.length > 0)?_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12 text-right"},[_c('span',{class:_vm.totalDiff === 0 ? 'text-green' : 'text-red'},[_vm._v("\n        Diferença: R$ "+_vm._s(_vm._f("formatValue")(_vm.totalDiff,2, true))+"\n      ")])])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Pedido de Compra","crud":_vm.localCrud,"btn-delete":true,"more-actions":_vm.moreActions},on:{"save":_vm.handleSave,"closeform":_vm.handleRetorna,"delete":_vm.handleDelete,"action":_vm.handleAction}}),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.errmessages.length)?_c('validation',{attrs:{"title":"Erros de Validação","messages":_vm.errmessages}}):_vm._e(),_vm._v(" "),(_vm.compra.financeiro === 'S')?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n      Alterações bloqueadas. Pedido integrado com financeiro.\n    ")]):_vm._e(),_vm._v(" "),(_vm.compra.status === 'F')?_c('div',{staticClass:"alert alert-info"},[_vm._v("\n      Alterações bloqueadas. Pedido finalizado.\n    ")]):_vm._e(),_vm._v(" "),(_vm.compra.status === 'C')?_c('div',{staticClass:"alert alert-danger"},[_vm._v("\n      Alterações bloqueadas. Pedido cancelado.\n    ")]):_vm._e(),_vm._v(" "),_c('label-title',{attrs:{"title":"Dados do Pedido","icon":"fa-shopping-cart"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"text","col":"2","metadata":_vm.metadata.compra.npedido,"disabled":""},model:{value:(_vm.compra.npedido),callback:function ($$v) {_vm.$set(_vm.compra, "npedido", $$v)},expression:"compra.npedido"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.compra.data.validator),expression:"metadata.compra.data.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.compra.data,"disabled":_vm.isView,"name":"data","v-errors":_vm.errors},model:{value:(_vm.compra.data),callback:function ($$v) {_vm.$set(_vm.compra, "data", $$v)},expression:"compra.data"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.compra.dtentrega.validator),expression:"metadata.compra.dtentrega.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.compra.dtentrega,"disabled":_vm.isView,"name":"dtentrega","v-errors":_vm.errors},model:{value:(_vm.compra.dtentrega),callback:function ($$v) {_vm.$set(_vm.compra, "dtentrega", $$v)},expression:"compra.dtentrega"}}),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('input-part',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.compra.codpart.validator),expression:"metadata.compra.codpart.validator"}],ref:"part",attrs:{"initial-label":_vm.compra.nome_fornecedor,"disabled":_vm.isView,"name":"Fornecedor","v-errors":_vm.errors},model:{value:(_vm.compra.codpart),callback:function ($$v) {_vm.$set(_vm.compra, "codpart", $$v)},expression:"compra.codpart"}})],1)],1),_vm._v(" "),_c('label-title',{staticClass:"mt-4",attrs:{"title":"Produtos","icon":"fa-archive"}}),_vm._v(" "),_c('compra-itens',{attrs:{"readonly":_vm.isView,"metadata":_vm.metadata},on:{"change":_vm.handleItemsChange},model:{value:(_vm.compra.comprait),callback:function ($$v) {_vm.$set(_vm.compra, "comprait", $$v)},expression:"compra.comprait"}}),_vm._v(" "),_c('div',{staticClass:"card bg-light border-0 shadow-sm mt-4"},[_c('div',{staticClass:"card-body p-2"},[_c('div',{staticClass:"row align-items-center mx-0"},[_c('div',{staticClass:"col-md-2 col-6 text-center border-right"},[_c('small',{staticClass:"text-muted d-block"},[_vm._v("Subtotal")]),_vm._v(" "),_c('span',{staticClass:"font-bold"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.subtotal,2, true)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 border-right"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.compra.vlrfrete.validator),expression:"metadata.compra.vlrfrete.validator"}],staticClass:"mb-0",attrs:{"type":"value","col":"12","metadata":_vm.metadata.compra.vlrfrete,"disabled":_vm.isView,"name":"vlrfrete","v-errors":_vm.errors},on:{"input":_vm.calculateTotals},model:{value:(_vm.compra.vlrfrete),callback:function ($$v) {_vm.$set(_vm.compra, "vlrfrete", $$v)},expression:"compra.vlrfrete"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 border-right"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.compra.percdesc.validator),expression:"metadata.compra.percdesc.validator"}],staticClass:"mb-0",attrs:{"type":"value","col":"12","metadata":_vm.metadata.compra.percdesc,"disabled":_vm.isView,"name":"percdesc","v-errors":_vm.errors},on:{"input":_vm.updateDescFromPerc},model:{value:(_vm.compra.percdesc),callback:function ($$v) {_vm.$set(_vm.compra, "percdesc", $$v)},expression:"compra.percdesc"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 text-center border-right"},[_c('small',{staticClass:"text-muted d-block"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.compra.totdesc}})],1),_vm._v(" "),_c('span',{staticClass:"text-red font-bold"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.compra.totdesc,2, true)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12 text-center"},[_c('small',{staticClass:"text-muted d-block"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.compra.totpedido}})],1),_vm._v(" "),_c('span',{staticClass:"text-xl font-bold text-blue"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.compra.totpedido,2, true)))])])])])]),_vm._v(" "),_c('label-title',{staticClass:"mt-4",attrs:{"title":"Logística","icon":"fa-truck"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.compra.tipofrete.validator),expression:"metadata.compra.tipofrete.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.compra.tipofrete,"disabled":_vm.isView,"name":"tipofrete","v-errors":_vm.errors},model:{value:(_vm.compra.tipofrete),callback:function ($$v) {_vm.$set(_vm.compra, "tipofrete", $$v)},expression:"compra.tipofrete"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.compra.codtransp.validator),expression:"metadata.compra.codtransp.validator"}],attrs:{"type":"select2","col":"8","metadata":_vm.metadata.compra.codtransp,"name":"codtransp","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.compra.codtransp),callback:function ($$v) {_vm.$set(_vm.compra, "codtransp", $$v)},expression:"compra.codtransp"}})],1),_vm._v(" "),_c('label-title',{staticClass:"mt-4",attrs:{"title":"Financeiro","icon":"fa-money"}}),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.compra.codnatfin.validator),expression:"metadata.compra.codnatfin.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.compra.codnatfin,"select2":{entity: 'natfin/despesas/', minlength: 0},"disabled":_vm.isView,"name":"codnatfin","v-errors":_vm.errors},model:{value:(_vm.compra.codnatfin),callback:function ($$v) {_vm.$set(_vm.compra, "codnatfin", $$v)},expression:"compra.codnatfin"}})],1),_vm._v(" "),_c('compra-parcelas',{attrs:{"total":_vm.compra.totpedido,"readonly":_vm.isView,"metadata":_vm.metadata,"qt-parcelas":_vm.compra.parcelas},on:{"update:qtParcelas":function($event){return _vm.$set(_vm.compra, "parcelas", $event)},"update:qt-parcelas":function($event){return _vm.$set(_vm.compra, "parcelas", $event)}},model:{value:(_vm.compra.comprapar),callback:function ($$v) {_vm.$set(_vm.compra, "comprapar", $$v)},expression:"compra.comprapar"}}),_vm._v(" "),_c('label-title',{staticClass:"mt-4",attrs:{"title":"Observações","icon":"fa-comment"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.compra.obs.validator),expression:"metadata.compra.obs.validator"}],attrs:{"type":"memo","col":"12","metadata":_vm.metadata.compra.obs,"disabled":_vm.isView,"placeholder":"Sairão no pedido impresso...","name":"obs","v-errors":_vm.errors},model:{value:(_vm.compra.obs),callback:function ($$v) {_vm.$set(_vm.compra, "obs", $$v)},expression:"compra.obs"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.compra.obs_interna.validator),expression:"metadata.compra.obs_interna.validator"}],attrs:{"type":"memo","col":"12","metadata":_vm.metadata.compra.obs_interna,"disabled":_vm.isView,"placeholder":"Uso restrito da empresa...","name":"obs_interna","v-errors":_vm.errors},model:{value:(_vm.compra.obs_interna),callback:function ($$v) {_vm.$set(_vm.compra, "obs_interna", $$v)},expression:"compra.obs_interna"}})],1)],1),_vm._v(" "),(_vm.showFormEmail)?_c('email-form',{attrs:{"index":_vm.compra.codcompra,"tipo":"COMPRA","title":"Envio de Pedido de Compra"},on:{"closeform":_vm.closeFormEmail,"send":_vm.handleSendEmail}}):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[(_vm.showImpressao)?_c('pedido-compra-impressao',{ref:"impressao",attrs:{"index":_vm.compra.codcompra},on:{"close":_vm.handleClosePrint}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"grid"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"filter-button":true,"filter-month":true,"month-filter":_vm.monthFilter,"adv-filters-object":_vm.filtroAvancado,"field-month":'data',"single-entity":"Pedido de Compra","plural-entity":"Pedidos de Compra","title-search":"Pesquise pelo número do pedido ou nome do fornecedor"},on:{"search":_vm.search,"filter":_vm.handleChangeFilter,"advancedfilter":_vm.handleChangeAdvancedFilter,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.compraList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.compraList),function(item){return _c('div',{key:item.codcompra,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v("#"+_vm._s(item.npedido))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_c('i',{staticClass:"fa fa-calendar mr-1"}),_vm._v(" "+_vm._s(_vm._f("formatData")(item.data)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Fornecedor")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.nome_fornecedor))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v("R$ "),_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(item.totpedido,2)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12 text-center"},[_c('span',{staticClass:"badge",class:_vm.statusClass(item.status)},[_vm._v("\n                                "+_vm._s(_vm.statusLabel(item.status))+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: item.status == 'A'},"moreActions":[{action: 1, label: 'Imprimir', icon: 'fa-print'}]},on:{"edit":function($event){return _vm.handleEdit(item.codcompra)},"view":function($event){return _vm.handleEdit(item.codcompra, true)},"action":function($event){return _vm.handleAction($event, item.codcompra)}}})],1)])])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('compra-form',{attrs:{"crud":_vm.crud,"id":_vm.selectedId},on:{"closeform":_vm.closeForm}}):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[(_vm.showImpressao)?_c('pedido-compra-impressao',{ref:"impressao",attrs:{"index":_vm.codcompraImpressao},on:{"close":_vm.handleClosePrint}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1566);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("afcf824e", content, true, {});

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-cf46f8ba]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-cf46f8ba]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-cf46f8ba]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-cf46f8ba]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-cf46f8ba]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-unit[data-v-cf46f8ba]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:15px;font-weight:700;text-transform:uppercase}.nb-card-title[data-v-cf46f8ba]{flex:1;min-width:0}.nb-card-title-line[data-v-cf46f8ba]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-cf46f8ba]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-cf46f8ba]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-cf46f8ba]{color:#334155;font-weight:600}.nb-card-actions[data-v-cf46f8ba]{flex:0 0 auto}.nb-card-details[data-v-cf46f8ba]{display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:12px;margin:12px 0 0 60px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-card-detail[data-v-cf46f8ba]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-card-detail-label[data-v-cf46f8ba]{color:#64748b;font-size:11px}.nb-card-detail>strong[data-v-cf46f8ba]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}@media (max-width:767.98px){.nb-card-top[data-v-cf46f8ba]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-cf46f8ba]{align-self:flex-end}.nb-card-details[data-v-cf46f8ba]{margin-left:0}}", ""]);

// exports


/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_regrafcp_form_vue__ = __webpack_require__(566);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a4acb8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_regrafcp_form_vue__ = __webpack_require__(1570);
function injectStyle (ssrContext) {
  __webpack_require__(1568)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_regrafcp_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a4acb8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_regrafcp_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1569);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("572fbb81", content, true, {});

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Alíquota FCP","plural-entity":"Alíquota FCP","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regrafcp.uf.validator),expression:"metadata.regrafcp.uf.validator"}],ref:"uf",attrs:{"type":"select","col":"2","metadata":_vm.metadata.regrafcp.uf,"select-options":_vm.estadoList,"name":"uf","v-errors":_vm.errors},model:{value:(_vm.regrafcp.uf),callback:function ($$v) {_vm.$set(_vm.regrafcp, "uf", $$v)},expression:"regrafcp.uf"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regrafcp.ncm.validator),expression:"metadata.regrafcp.ncm.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.regrafcp.ncm,"select2":{entity: 'ncm', minlength: 1},"name":"ncm","v-errors":_vm.errors},model:{value:(_vm.regrafcp.ncm),callback:function ($$v) {_vm.$set(_vm.regrafcp, "ncm", $$v)},expression:"regrafcp.ncm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regrafcp.exncm.validator),expression:"metadata.regrafcp.exncm.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.regrafcp.exncm,"name":"exncm","v-errors":_vm.errors},model:{value:(_vm.regrafcp.exncm),callback:function ($$v) {_vm.$set(_vm.regrafcp, "exncm", $$v)},expression:"regrafcp.exncm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regrafcp.afcp.validator),expression:"metadata.regrafcp.afcp.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.regrafcp.afcp,"precision":2,"name":"afcp","v-errors":_vm.errors},model:{value:(_vm.regrafcp.afcp),callback:function ($$v) {_vm.$set(_vm.regrafcp, "afcp", $$v)},expression:"regrafcp.afcp"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regrafcp.afcpst.validator),expression:"metadata.regrafcp.afcpst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.regrafcp.afcpst,"precision":2,"name":"afcp","v-errors":_vm.errors},model:{value:(_vm.regrafcp.afcpst),callback:function ($$v) {_vm.$set(_vm.regrafcp, "afcpst", $$v)},expression:"regrafcp.afcpst"}})],1)]),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.editing)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Salvar e Adicionar Novo","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleSave(true)}}})],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"grid"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"single-entity":"Alíquota FCP","plural-entity":"Alíquotas FCP","title-search":"Pesquise pelo ncm"},on:{"search":_vm.search,"new":_vm.handleIncluir,"refresh":function($event){return _vm.loadData()}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.empty)?_c('alert',{attrs:{"type":"warning","text":"Nenhuma regra foi encontrada."}}):_vm._e(),_vm._v(" "),_vm._l((_vm.regraList),function(regra,index){return _c('article',{key:regra.codregrafcp || index,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_c('div',{staticClass:"nb-card-unit"},[_vm._v("\n                            "+_vm._s(regra.uf)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(regra.descricao || ('NCM ' + regra.ncm)))])]),_vm._v(" "),_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                NCM "),_c('strong',[_vm._v(_vm._s(regra.ncm))]),_vm._v(" "),_c('span',{staticClass:"ml-2"},[_vm._v("UF "),_c('strong',[_vm._v(_vm._s(regra.uf))])])])])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: false, btnEdit: true, btnEditLabel: 'Editar'},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(regra.codregrafcp)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"nb-card-details"},[(_vm.metadata && _vm.metadata.regrafcp && _vm.metadata.regrafcp.afcp)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v(_vm._s(_vm.metadata.regrafcp.afcp.label))]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(regra.afcp)+"%")])]):_vm._e(),_vm._v(" "),(_vm.metadata && _vm.metadata.regrafcp && _vm.metadata.regrafcp.afcpst)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v(_vm._s(_vm.metadata.regrafcp.afcpst.label))]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(regra.afcpst)+"%")])]):_vm._e()])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('regrafcp-form',{attrs:{"crud":_vm.crud,"index":_vm.codregrafcp},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_regrast_list_vue__ = __webpack_require__(567);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_32f22c0c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_regrast_list_vue__ = __webpack_require__(1579);
function injectStyle (ssrContext) {
  __webpack_require__(1573)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_regrast_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_32f22c0c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_regrast_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1574);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a92a802a", content, true, {});

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_regrast_form_vue__ = __webpack_require__(568);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af36c92_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_regrast_form_vue__ = __webpack_require__(1578);
function injectStyle (ssrContext) {
  __webpack_require__(1576)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_regrast_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af36c92_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_regrast_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1577);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0818715a", content, true, {});

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"cabec"}},[_c('div',{staticClass:"col"},[(_vm.showHint)?_c('div',{staticClass:"alert alert-warning fade show",attrs:{"role":"alert"}},[_vm._m(1),_vm._v(" "),_c('small',[_vm._v("Preencha os campos abaixo para prosseguir com a configuração das regras do icms por subtituição tributária")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.regrast.ufori}}),_vm._v(" "),_c('select2',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],attrs:{"name":"ufori","options":{},"value":_vm.lUfori,"entity":"estado","minlength":0,"disabled":_vm.showRegras},model:{value:(_vm.lUfori),callback:function ($$v) {_vm.lUfori=$$v},expression:"lUfori"}}),_vm._v(" "),(_vm.errors.has('ufori'))?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.first('ufori')))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.regrast.finalidade}}),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(_vm.lFinalidade),expression:"lFinalidade"}],staticClass:"form-control form-control-sm",attrs:{"name":"finalidade","disabled":_vm.showRegras},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.lFinalidade=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.metadata.regrast.finalidade.options),function(opt){return _c('option',{key:opt.id,domProps:{"value":opt.id}},[_vm._v(_vm._s(opt.text))])}),0),_vm._v(" "),(_vm.errors.has('finalidade'))?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.first('finalidade')))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.regrast.ncm}}),_vm._v(" "),_c('select2',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],attrs:{"name":"ncm","options":{},"value":_vm.lNcm,"entity":"ncm","minlength":1,"disabled":_vm.showRegras},model:{value:(_vm.lNcm),callback:function ($$v) {_vm.lNcm=$$v},expression:"lNcm"}}),_vm._v(" "),(_vm.errors.has('ncm'))?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.first('ncm')))]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col"},[(_vm.showError)?_c('div',{staticClass:"alert alert-danger fade show",attrs:{"role":"alert"}},[_vm._m(2),_vm._v(" "),_c('small',[_vm._v("Por favor preencha os campos antes de continuar")])]):_vm._e()]),_vm._v(" "),(!_vm.showRegras)?_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('div',{staticClass:"btn-group"},[_c('a',{staticClass:"btn btn-sm btn-outline-secondary",staticStyle:{"margin-right":"5px"},attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.closeForm()}}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}},[_vm._v(" Voltar")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showRegras),expression:"!showRegras"}],staticClass:"btn-group"},[_c('a',{staticClass:"btn btn-sm nb-btdef",staticStyle:{"margin-right":"5px"},attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.handleContinuar()}}},[_c('i',{staticClass:"fa fa-arrow-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Continuar")])])])]):_vm._e()]),_vm._v(" "),(_vm.showRegras)?_c('div',{attrs:{"id":"regras"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-6"},[_c('div',{staticClass:"btn-group"},[_c('a',{staticClass:"btn btn-sm btn-outline-secondary",staticStyle:{"margin-right":"5px"},attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.handleDescartar()}}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}},[_vm._v(" Descartar")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRegras),expression:"showRegras"}],staticClass:"btn-group"},[_c('a',{staticClass:"btn btn-sm nb-btdef",staticStyle:{"margin-right":"5px"},attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.validate()}}},[_c('i',{staticClass:"fa fa-arrow-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Salvar")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',_vm._l((_vm.regrastList),function(regrast,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{class:[{ 'mark-red': (regrast.stregrast === 'I') }, { 'mark-green': (regrast.stregrast === 'A') }]}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"lbl-title"},[_vm._v("Estado: "+_vm._s(regrast.ufdest)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-2"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.regrast.mva}}),_vm._v(" "),_c('input-value',{staticClass:"form-control form-control-sm",attrs:{"precision":2},model:{value:(regrast.mva),callback:function ($$v) {_vm.$set(regrast, "mva", $$v)},expression:"regrast.mva"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.regrast.aicmst}}),_vm._v(" "),_c('input-value',{staticClass:"form-control form-control-sm",attrs:{"precision":2},model:{value:(regrast.aicmst),callback:function ($$v) {_vm.$set(regrast, "aicmst", $$v)},expression:"regrast.aicmst"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.regrast.pautaicmst}}),_vm._v(" "),_c('input-value',{staticClass:"form-control form-control-sm",attrs:{"precision":2},model:{value:(regrast.pautaicmst),callback:function ($$v) {_vm.$set(regrast, "pautaicmst", $$v)},expression:"regrast.pautaicmst"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.regrast.ricmst}}),_vm._v(" "),_c('input-value',{staticClass:"form-control form-control-sm",attrs:{"precision":2},model:{value:(regrast.ricmst),callback:function ($$v) {_vm.$set(regrast, "ricmst", $$v)},expression:"regrast.ricmst"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.regrast.dtinicio}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(regrast.dtinicio),expression:"regrast.dtinicio"}],staticClass:"form-control form-control-sm",attrs:{"type":"date"},domProps:{"value":(regrast.dtinicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(regrast, "dtinicio", $event.target.value)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.regrast.optsimples}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(regrast.optsimples),expression:"regrast.optsimples"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(regrast, "optsimples", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.metadata.regrast.optsimples.options),function(opt){return _c('option',{key:opt.id,domProps:{"value":opt.id}},[_vm._v(_vm._s(opt.text))])}),0)],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-2"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.regrast.stregrast}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(regrast.stregrast),expression:"regrast.stregrast"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(regrast, "stregrast", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.metadata.regrast.stregrast.options),function(opt){return _c('option',{key:opt.id,domProps:{"value":opt.id}},[_vm._v(_vm._s(opt.text))])}),0)],1)])]),_vm._v(" "),(regrast.validate)?_c('div',{staticClass:"col"},[_c('small',{staticClass:"error"},[_vm._v(" "+_vm._s(regrast.validate)+" ")])]):_vm._e()])])}),0)]):_vm._e()]),_vm._v(" "),_c('vue-snotify'),_vm._v(" "),(_vm.showMessage)?_c('md-message',{attrs:{"code":_vm.codeMessage},on:{"close":function($event){return _vm.closeMessage()},"confirm":function($event){return _vm.handleConfirmMessage()}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v("Regras de ICMS ST")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"grid"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"single-entity":"Regra de ICMS ST","plural-entity":"Regras de ICMS ST"},on:{"search":_vm.search,"new":_vm.handleIncluir,"refresh":function($event){return _vm.loadData()}}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.regraList.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Estado de Origem"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Finalidade"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('v-label',{attrs:{"label":"NCM"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-2"},[_c('v-label',{attrs:{"label":"Descrição NCM"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"})]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.empty)?_c('alert',{attrs:{"type":"warning","text":"Nenhuma regra de ICMS ST foi encontrada."}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"height-80",staticStyle:{"overflow":"auto"}},_vm._l((_vm.regraList),function(regra,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(regra.ufori))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.textFinalidade(regra.finalidade)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(regra.ncm))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(regra.descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(regra.ufori, regra.finalidade, regra.ncm)},"view":function($event){return _vm.handleEdit(regra.ufori, regra.finalidade, regra.ncm)}}})],1)])])])}),0)],1),_vm._v(" "),(_vm.showForm)?_c('regrast-form',{attrs:{"crud":_vm.crud,"ufori":_vm.ufori,"finalidade":_vm.finalidade,"ncm":_vm.ncm},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1581);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3861835b", content, true, {});

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-48b4810c]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-48b4810c]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-48b4810c]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-48b4810c]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-48b4810c]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-48b4810c]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-48b4810c]{flex:1;min-width:0}.nb-card-title-line[data-v-48b4810c]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-48b4810c]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-48b4810c]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-48b4810c]{color:#334155;font-weight:600}.nb-card-badge[data-v-48b4810c]{display:inline-flex;align-items:center;gap:4px;padding:4px 7px;border:1px solid transparent;border-radius:5px;font-size:10px;font-weight:700;line-height:1.2}.nb-card-badge--neutral[data-v-48b4810c]{color:#475569;background:#f1f5f9;border-color:#e2e8f0}.nb-card-actions[data-v-48b4810c]{flex:0 0 auto}@media (max-width:767.98px){.nb-card-top[data-v-48b4810c]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-48b4810c]{align-self:flex-end}}", ""]);

// exports


/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_regraimp_form_vue__ = __webpack_require__(570);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_084ac991_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_regraimp_form_vue__ = __webpack_require__(1589);
function injectStyle (ssrContext) {
  __webpack_require__(1583)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_regraimp_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_084ac991_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_regraimp_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1584);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("608b4ac5", content, true, {});

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_regraimp_add_form_vue__ = __webpack_require__(571);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1887d0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_regraimp_add_form_vue__ = __webpack_require__(1588);
function injectStyle (ssrContext) {
  __webpack_require__(1586)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_regraimp_add_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1887d0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_regraimp_add_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1587);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("697dc0cc", content, true, {});

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-dica{position:relative;background:#267da5;padding:8px;color:#fff;font-weight:400;line-height:18px;border-radius:3px;height:35px;z-index:20;margin:-3px 0 0 15px;user-select:none;animation:tooltip_animation 2s linear infinite}@keyframes tooltip_animation{0%,20%,40%,60%,80%,to{transform:translateX(0)}50%{transform:translateX(-5px)}}.nb-dica:before{content:\" \";width:0;height:0;position:absolute;left:-7px;top:8px;border-color:transparent #267da5;border-style:solid;border-width:8px 8px 8px 0}", ""]);

// exports


/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v("Incluir Regras de Imposto")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',[(_vm.grutrib)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.grutrib.codgrutrib}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.grutrib.codgrutrib))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-9"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.grutrib.descricao}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.grutrib.descricao))])],1)]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('label-title',{staticClass:"nb-margin-bottom",attrs:{"title":"Selecione o Estado ou Região de Destino"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{ref:"ufdest",attrs:{"type":"select","col":"3","select-options":_vm.estadoList,"metadata":_vm.metadata.regraimp.ufdest},model:{value:(_vm.ufdest),callback:function ($$v) {_vm.ufdest=$$v},expression:"ufdest"}}),_vm._v(" "),(!_vm.ufdest)?_c('span',{staticClass:"nb-dica"},[_vm._v("As regras de impostos são definidas para o estado de destino e\n            por tipo de cliente")]):_vm._e()],1),_vm._v(" "),(_vm.ufdest)?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.regraimp.optsimples},model:{value:(_vm.optsimples),callback:function ($$v) {_vm.optsimples=$$v},expression:"optsimples"}})],1):_vm._e(),_vm._v(" "),(_vm.ufdest)?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select2","col":"3","metadata":_vm.metadata.regraimp.codgrucli,"select2":{ entity: 'grucli', minlength: 0 }},model:{value:(_vm.codgrucli),callback:function ($$v) {_vm.codgrucli=$$v},expression:"codgrucli"}})],1):_vm._e(),_vm._v(" "),_c('div',_vm._l((_vm.regraimpList),function(regraimp,index){return _c('div',{key:index,staticClass:"mainbox",staticStyle:{"background-color":"#eee"}},[_c('div',{staticClass:"box"},[(regraimp.finalidade == 'I')?_c('label-title',{attrs:{"title":"Industrialização"}}):_vm._e(),_vm._v(" "),(regraimp.finalidade == 'R')?_c('label-title',{attrs:{"title":"Revenda"}}):_vm._e(),_vm._v(" "),(regraimp.finalidade == 'F')?_c('label-title',{attrs:{"title":"Consumo Final"}}):_vm._e(),_vm._v(" "),(regraimp.validate)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"alert alert-warning fade show",attrs:{"role":"alert"}},[_c('span',[_c('strong',[_vm._v("Erro de validação:")]),_vm._v(" "+_vm._s(regraimp.validate)+" ")])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.grutrib.regra_geral != 'S')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.aicminterno.validator),expression:"metadata.regraimp.aicminterno.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.aicminterno,"precision":2,"name":"aicminterno","v-errors":_vm.errors},model:{value:(regraimp.aicminterno),callback:function ($$v) {_vm.$set(regraimp, "aicminterno", $$v)},expression:"regraimp.aicminterno"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.aicmexterno.validator),expression:"metadata.regraimp.aicmexterno.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.aicmexterno,"precision":2,"name":"aicmexterno","v-errors":_vm.errors},model:{value:(regraimp.aicmexterno),callback:function ($$v) {_vm.$set(regraimp, "aicmexterno", $$v)},expression:"regraimp.aicmexterno"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.ricm.validator),expression:"metadata.regraimp.ricm.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.ricm,"precision":2,"name":"ricm","v-errors":_vm.errors},model:{value:(regraimp.ricm),callback:function ($$v) {_vm.$set(regraimp, "ricm", $$v)},expression:"regraimp.ricm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.mva.validator),expression:"metadata.regraimp.mva.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.mva,"precision":2,"name":"mva","v-errors":_vm.errors},model:{value:(regraimp.mva),callback:function ($$v) {_vm.$set(regraimp, "mva", $$v)},expression:"regraimp.mva"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.mvaorig.validator),expression:"metadata.regraimp.mvaorig.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.mvaorig,"precision":2,"name":"mvaorig","v-errors":_vm.errors},model:{value:(regraimp.mvaorig),callback:function ($$v) {_vm.$set(regraimp, "mvaorig", $$v)},expression:"regraimp.mvaorig"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.aicmst.validator),expression:"metadata.regraimp.aicmst.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.aicmst,"precision":2,"name":"aicmst","v-errors":_vm.errors},model:{value:(regraimp.aicmst),callback:function ($$v) {_vm.$set(regraimp, "aicmst", $$v)},expression:"regraimp.aicmst"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.pautaicmst.validator),expression:"metadata.regraimp.pautaicmst.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.pautaicmst,"precision":2,"name":"pautaicmst","v-errors":_vm.errors},model:{value:(regraimp.pautaicmst),callback:function ($$v) {_vm.$set(regraimp, "pautaicmst", $$v)},expression:"regraimp.pautaicmst"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.ricmst.validator),expression:"metadata.regraimp.ricmst.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.ricmst,"precision":2,"name":"ricmst","v-errors":_vm.errors},model:{value:(regraimp.ricmst),callback:function ($$v) {_vm.$set(regraimp, "ricmst", $$v)},expression:"regraimp.ricmst"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.afcpst.validator),expression:"metadata.regraimp.afcpst.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.afcpst,"precision":2,"name":"afcpst","v-errors":_vm.errors},model:{value:(regraimp.afcpst),callback:function ($$v) {_vm.$set(regraimp, "afcpst", $$v)},expression:"regraimp.afcpst"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select2","col":"6","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.cfop,"select2":{ entity: 'cfop/saidas', minlength: 0 }},model:{value:(regraimp.cfop),callback:function ($$v) {_vm.$set(regraimp, "cfop", $$v)},expression:"regraimp.cfop"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select2","col":"6","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.sticm,"select2":{ entity: 'tabpadval/11', minlength: 0 }},model:{value:(regraimp.sticm),callback:function ($$v) {_vm.$set(regraimp, "sticm", $$v)},expression:"regraimp.sticm"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select2","col":"6","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.csosn,"select2":{ entity: 'tabpadval/7', minlength: 0 }},model:{value:(regraimp.csosn),callback:function ($$v) {_vm.$set(regraimp, "csosn", $$v)},expression:"regraimp.csosn"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"3","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.bcdifalnovo},model:{value:(regraimp.bcdifalnovo),callback:function ($$v) {_vm.$set(regraimp, "bcdifalnovo", $$v)},expression:"regraimp.bcdifalnovo"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.optsimples},model:{value:(regraimp.optsimples),callback:function ($$v) {_vm.$set(regraimp, "optsimples", $$v)},expression:"regraimp.optsimples"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.dtinicio.validator),expression:"metadata.regraimp.dtinicio.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.regraimp.dtinicio,"name":"dtinicio","v-errors":_vm.errors},model:{value:(regraimp.dtinicio),callback:function ($$v) {_vm.$set(regraimp, "dtinicio", $$v)},expression:"regraimp.dtinicio"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.dtfim.validator),expression:"metadata.regraimp.dtfim.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.regraimp.dtfim,"name":"dtfim","v-errors":_vm.errors},model:{value:(regraimp.dtfim),callback:function ($$v) {_vm.$set(regraimp, "dtfim", $$v)},expression:"regraimp.dtfim"}})],1):_vm._e(),_vm._v(" "),(_vm.grutrib.regra_geral == 'S')?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"3","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.tipo_calc_difal},model:{value:(regraimp.tipo_calc_difal),callback:function ($$v) {_vm.$set(regraimp, "tipo_calc_difal", $$v)},expression:"regraimp.tipo_calc_difal"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.dtinicio.validator),expression:"metadata.regraimp.dtinicio.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.regraimp.dtinicio,"name":"dtinicio","v-errors":_vm.errors},model:{value:(regraimp.dtinicio),callback:function ($$v) {_vm.$set(regraimp, "dtinicio", $$v)},expression:"regraimp.dtinicio"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.dtfim.validator),expression:"metadata.regraimp.dtfim.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.regraimp.dtfim,"name":"dtfim","v-errors":_vm.errors},model:{value:(regraimp.dtfim),callback:function ($$v) {_vm.$set(regraimp, "dtfim", $$v)},expression:"regraimp.dtfim"}})],1):_vm._e()],1)])}),0)],1),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{ref:"btnConfirm",attrs:{"label":"Salvar","title":"","nb-btdef":true},on:{"click":_vm.handleSave}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.handleCloseForm}})],1),_vm._v(" "),_c('vue-snotify'),_vm._v(" "),(_vm.showMessage)?_c('md-message',{attrs:{"code":_vm.codeMessage},on:{"close":function($event){return _vm.closeMessage()},"confirm":function($event){return _vm.handleConfirmMessage()}}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('bar-manut',{attrs:{"single-entity":"Grupo de Regra de Imposto","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.handleCloseForm,"save":function($event){return _vm.handleSave(true)},"delete":function($event){return _vm.apiDelete()}}}),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"text","col":"2","metadata":_vm.metadata.grutrib.codgrutrib,"disabled":""},model:{value:(_vm.grutrib.codgrutrib),callback:function ($$v) {_vm.$set(_vm.grutrib, "codgrutrib", $$v)},expression:"grutrib.codgrutrib"}}),_vm._v(" "),_c('form-field',{ref:"descricao",attrs:{"type":"text","col":"4","metadata":_vm.metadata.grutrib.descricao,"max-length":"40"},model:{value:(_vm.grutrib.descricao),callback:function ($$v) {_vm.$set(_vm.grutrib, "descricao", $$v)},expression:"grutrib.descricao"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.grutrib.regra_geral},model:{value:(_vm.grutrib.regra_geral),callback:function ($$v) {_vm.$set(_vm.grutrib, "regra_geral", $$v)},expression:"grutrib.regra_geral"}})],1),_vm._v(" "),_c('div',{staticClass:"row nb-margin-bottom nb-margin-top"},[_c('div',{staticClass:"col-md-12"},[((_vm.grutrib.regra_geral != 'S') && ((_vm.grutribncmList.length == 0) || (_vm.grutribitemList.length == 0)))?_c('strong',{staticClass:"badge badge-danger"},[_vm._v("Nenhuma NCM ou Produto foi relacionado a este grupo")]):_vm._e(),_vm._v(" "),(_vm.regraimpList.length > 0)?_c('strong',{staticClass:"lbl badge badge-green data-list"},[_vm._v(_vm._s(_vm.countRegrasValidas)+"\n            Regras\n            válidas")]):_vm._e(),_vm._v(" "),(_vm.regraimpList.length > 0)?_c('strong',{staticClass:"lbl badge badge-gray data-list"},[_vm._v(_vm._s(_vm.countRegrasDesativadas)+"\n            Regras desativadas")]):_vm._e(),_vm._v(" "),(_vm.regraimpList.length > 0)?_c('strong',{staticClass:"lbl badge badge-gray data-list"},[_vm._v(_vm._s(_vm.countRegrasVencidas)+"\n            Regras\n            vencidas")]):_vm._e(),_vm._v(" "),(_vm.grutribncmList.length > 0)?_c('strong',{staticClass:"lbl badge badge-green data-list"},[_vm._v(_vm._s(_vm.grutribncmList.length)+"\n            NCM´s relacionadas")]):_vm._e(),_vm._v(" "),(_vm.grutribitemList.length > 0)?_c('strong',{staticClass:"lbl badge badge-green data-list"},[_vm._v(_vm._s(_vm.grutribitemList.length)+"\n            Produto´s relacionados")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('tabs',{attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab == 2),expression:"activeTab == 2"}],staticClass:"mt-3"},[(_vm.regraimpList.length == 0)?_c('div',[_c('alert',{attrs:{"type":"warning","title":"Informações Importantes","text":"O grupo de NCM´s envolve o relacionamento das regras de impostos e vários NCM´s com as mesmas características.\n                                  Efetue a inclusão das regras para cada estado e finalidade através do botão abaixo, e depois relacione os NCM´s a este grupo através da guia 'NCM´s Relacionadas'."}})],1):_vm._e(),_vm._v(" "),_c('div',[_c('div',[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6 col-3"},[_c('v-button',{attrs:{"label":"Adicionar Regras a Este Grupo","title":"","icon":"fa-plus","nb-btdef":true},on:{"click":_vm.handleAdicionaRegra}})],1),_vm._v(" "),(_vm.regraimpList.length > 0)?_c('form-field',{attrs:{"type":"select","col":"3","select-options":_vm.filtroEstadosList,"label":""},model:{value:(_vm.filtroEstado),callback:function ($$v) {_vm.filtroEstado=$$v},expression:"filtroEstado"}}):_vm._e(),_vm._v(" "),(_vm.regraimpList.length > 0)?_c('form-field',{attrs:{"type":"select","col":"3","select-options":_vm.filtroFinalidadesList,"label":""},model:{value:(_vm.filtroFinalidade),callback:function ($$v) {_vm.filtroFinalidade=$$v},expression:"filtroFinalidade"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-2"})],1)])]),_vm._v(" "),_vm._l((_vm.distinctEstadosList),function(estado,index){return _c('div',{key:index,attrs:{"if":"(estado.ufdest==filtroEstado || filtroEstado == '*')"}},[_c('div',{staticClass:"row nb-margin-top nb-margin-bottom"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{attrs:{"label":"Estade de Destino"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(estado.ufdest))]),_c('br')],1)]),_vm._v(" "),_vm._l((_vm.regraimpList),function(regraimp,index){return _c('div',{key:index,staticStyle:{"padding-left":"30px"}},[((estado.ufdest == regraimp.ufdest) && (_vm.filtroFinalidade == '*' || regraimp.finalidade == _vm.filtroFinalidade))?_c('div',{staticClass:"mainbox"},[_c('div',{class:[{ 'mark-red': (regraimp.stregraimp === 'I' || regraimp.duplicate || regraimp.validate) }, { 'mark-green': (regraimp.stregraimp === 'A') }]}),_vm._v(" "),_c('div',{staticClass:"box"},[(regraimp.validate)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"alert alert-warning fade show",attrs:{"role":"alert"}},[_c('span',[_c('strong',[_vm._v("Erro de validação:")]),_vm._v(" "+_vm._s(regraimp.validate)+" ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"label":"Código da Regra"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(regraimp.codregraimp))])],1),_vm._v(" "),(regraimp.grucli && regraimp.grucli.legnth > 0)?_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"label":"Tipo/Finalidade"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(regraimp.grucli[0].descricao))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"label":"Tipo/Finalidade"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.textFinalidade(regraimp.finalidade)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"label":"Data de Início"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.formatDate(regraimp.dtinicio)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"label":"Data de Validade"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.formatDate(regraimp.dtfim)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},attrs:{"data-toggle":"collapse","data-target":'#detalheRegra' + index,"aria-expanded":"false","aria-controls":'detalheRegra' + index}},[_vm._v("Detalhar")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[(regraimp.stregraimp == 'I')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Regra desativada")]):_vm._e(),_vm._v(" "),(regraimp.vencida == 'S')?_c('span',{staticClass:"lbl badge badge-orange"},[_vm._v("Regra com validade\n                      vencida")]):_vm._e(),_vm._v(" "),(regraimp.foraperiodo == 'N')?_c('span',{staticClass:"lbl badge badge-gray"},[_vm._v("Regra fora do período")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row align-items-center collapse",attrs:{"id":'detalheRegra' + index}},[(_vm.grutrib.regra_geral != 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.aicminterno.validator),expression:"metadata.regraimp.aicminterno.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.aicminterno,"precision":2,"name":"aicminterno","v-errors":_vm.errors},model:{value:(regraimp.aicminterno),callback:function ($$v) {_vm.$set(regraimp, "aicminterno", $$v)},expression:"regraimp.aicminterno"}}):_vm._e(),_vm._v(" "),(_vm.grutrib.regra_geral != 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.aicmexterno.validator),expression:"metadata.regraimp.aicmexterno.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.aicmexterno,"precision":2,"name":"aicmexterno","v-errors":_vm.errors},model:{value:(regraimp.aicmexterno),callback:function ($$v) {_vm.$set(regraimp, "aicmexterno", $$v)},expression:"regraimp.aicmexterno"}}):_vm._e(),_vm._v(" "),(_vm.grutrib.regra_geral != 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.ricm.validator),expression:"metadata.regraimp.ricm.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.ricm,"precision":2,"name":"ricm","v-errors":_vm.errors},model:{value:(regraimp.ricm),callback:function ($$v) {_vm.$set(regraimp, "ricm", $$v)},expression:"regraimp.ricm"}}):_vm._e(),_vm._v(" "),(_vm.grutrib.regra_geral != 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.mva.validator),expression:"metadata.regraimp.mva.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.mva,"precision":2,"name":"mva","v-errors":_vm.errors},model:{value:(regraimp.mva),callback:function ($$v) {_vm.$set(regraimp, "mva", $$v)},expression:"regraimp.mva"}}):_vm._e(),_vm._v(" "),(_vm.grutrib.regra_geral != 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.mvaorig.validator),expression:"metadata.regraimp.mvaorig.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.mvaorig,"precision":2,"name":"mvaorig","v-errors":_vm.errors},model:{value:(regraimp.mvaorig),callback:function ($$v) {_vm.$set(regraimp, "mvaorig", $$v)},expression:"regraimp.mvaorig"}}):_vm._e(),_vm._v(" "),(_vm.grutrib.regra_geral != 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.aicmst.validator),expression:"metadata.regraimp.aicmst.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.aicmst,"precision":2,"name":"aicmst","v-errors":_vm.errors},model:{value:(regraimp.aicmst),callback:function ($$v) {_vm.$set(regraimp, "aicmst", $$v)},expression:"regraimp.aicmst"}}):_vm._e(),_vm._v(" "),(_vm.grutrib.regra_geral != 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.pautaicmst.validator),expression:"metadata.regraimp.pautaicmst.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.pautaicmst,"precision":2,"name":"pautaicmst","v-errors":_vm.errors},model:{value:(regraimp.pautaicmst),callback:function ($$v) {_vm.$set(regraimp, "pautaicmst", $$v)},expression:"regraimp.pautaicmst"}}):_vm._e(),_vm._v(" "),(_vm.grutrib.regra_geral != 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.ricmst.validator),expression:"metadata.regraimp.ricmst.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.ricmst,"precision":2,"name":"ricmst","v-errors":_vm.errors},model:{value:(regraimp.ricmst),callback:function ($$v) {_vm.$set(regraimp, "ricmst", $$v)},expression:"regraimp.ricmst"}}):_vm._e(),_vm._v(" "),(_vm.grutrib.regra_geral != 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.regraimp.afcpst.validator),expression:"metadata.regraimp.afcpst.validator"}],attrs:{"type":"value","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.afcpst,"precision":2,"name":"afcpst","v-errors":_vm.errors},model:{value:(regraimp.afcpst),callback:function ($$v) {_vm.$set(regraimp, "afcpst", $$v)},expression:"regraimp.afcpst"}}):_vm._e(),_vm._v(" "),(_vm.grutrib.regra_geral != 'S')?_c('form-field',{attrs:{"type":"select2","col":"6","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.cfop,"select2":{ entity: 'cfop/saidas', minlength: 0 }},model:{value:(regraimp.cfop),callback:function ($$v) {_vm.$set(regraimp, "cfop", $$v)},expression:"regraimp.cfop"}}):_vm._e(),_vm._v(" "),(_vm.grutrib.regra_geral != 'S')?_c('form-field',{attrs:{"type":"select2","col":"6","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.sticm,"select2":{ entity: 'tabpadval/11', minlength: 0 }},model:{value:(regraimp.sticm),callback:function ($$v) {_vm.$set(regraimp, "sticm", $$v)},expression:"regraimp.sticm"}}):_vm._e(),_vm._v(" "),(_vm.grutrib.regra_geral != 'S')?_c('form-field',{attrs:{"type":"select2","col":"6","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.csosn,"select2":{ entity: 'tabpadval/7', minlength: 0 }},model:{value:(regraimp.csosn),callback:function ($$v) {_vm.$set(regraimp, "csosn", $$v)},expression:"regraimp.csosn"}}):_vm._e(),_vm._v(" "),(_vm.grutrib.regra_geral != 'S')?_c('form-field',{attrs:{"type":"select","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.bcdifalnovo},model:{value:(regraimp.bcdifalnovo),callback:function ($$v) {_vm.$set(regraimp, "bcdifalnovo", $$v)},expression:"regraimp.bcdifalnovo"}}):_vm._e(),_vm._v(" "),(_vm.grutrib.regra_geral != 'S')?_c('form-field',{attrs:{"type":"select","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.optsimples},model:{value:(regraimp.optsimples),callback:function ($$v) {_vm.$set(regraimp, "optsimples", $$v)},expression:"regraimp.optsimples"}}):_vm._e(),_vm._v(" "),(_vm.grutrib.regra_geral == 'S')?_c('form-field',{attrs:{"type":"select","col":"2","disabled":regraimp.stregraimp == 'I',"metadata":_vm.metadata.regraimp.tipo_calc_difal},model:{value:(regraimp.tipo_calc_difal),callback:function ($$v) {_vm.$set(regraimp, "tipo_calc_difal", $$v)},expression:"regraimp.tipo_calc_difal"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-4"},[_c('input-switch',{attrs:{"type":"success","label":"Regra Ativa","value-checked":"A","value-unchecked":"I","metadata":regraimp.stregraimp},model:{value:(regraimp.stregraimp),callback:function ($$v) {_vm.$set(regraimp, "stregraimp", $$v)},expression:"regraimp.stregraimp"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-button',{attrs:{"label":"Salvar","nb-btdef":true},on:{"click":function($event){return _vm.handleSave(false)}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar","data-toggle":"collapse","data-target":'#detalheRegra' + index,"aria-expanded":"false","aria-controls":'detalheRegra' + index}})],1)],1)]),_vm._v(" "),_c('br')]):_vm._e()])})],2)})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab == 0),expression:"activeTab == 0"}]},[(_vm.regraimpList.length == 0)?_c('div',[_c('alert',{attrs:{"type":"warning","title":"Adicionar NCM´s","text":"Adicione vários NCM´s com caracterísitcas semelhantes ao grupo de NCM´s. Os NCM´s informados aqui compartilharão das mesmas regras e não poderão ser adicionados à outros grupos de NCM."}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.grutribncmList),function(grutribncm,index){return _c('div',{key:index,staticClass:"mainbox-select",staticStyle:{"background-color":"#eee"}},[_c('div',{class:[{ 'mark-red': grutribncm.duplicate || grutribncm.validate }]}),_vm._v(" "),_c('div',{staticClass:"box"},[(grutribncm.duplicate)?_c('div',{staticClass:"col"},[_c('span',{staticClass:"error"},[_vm._v("NCM Duplicado")])]):_vm._e(),_vm._v(" "),(grutribncm.validate)?_c('div',{staticClass:"col"},[_c('span',{staticClass:"error"},[_vm._v(" "+_vm._s(grutribncm.validate)+" ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[_c('form-field',{ref:"ncm",refInFor:true,attrs:{"type":"select2","col":"6","metadata":_vm.metadata.grutribncm.ncm,"select2":{ entity: 'ncm', minlength: 1 }},model:{value:(grutribncm.ncm),callback:function ($$v) {_vm.$set(grutribncm, "ncm", $$v)},expression:"grutribncm.ncm"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"number","col":"2","metadata":_vm.metadata.grutribncm.exncm},model:{value:(grutribncm.exncm),callback:function ($$v) {_vm.$set(grutribncm, "exncm", $$v)},expression:"grutribncm.exncm"}}),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-button',{attrs:{"label":"","title":"Excluir NCM","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteNCM(index)}}})],1)],1)])])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Adicionar NCM a Este Grupo","title":"","icon":"fa-plus","nb-btdef":true},on:{"click":_vm.handleAdicionaNCM}}),_vm._v(" "),(_vm.grutribncmList.length > 0)?_c('v-button',{attrs:{"label":"Adicionar Regras a Este Grupo","title":"","icon":"fa-plus","nb-btdef":true},on:{"click":_vm.handleAdicionaRegra}}):_vm._e()],1)])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab == 1),expression:"activeTab == 1"}]},[(_vm.regraimpList.length == 0)?_c('div',[_c('alert',{attrs:{"type":"warning","title":"Adicionar Produtos","text":"Adicione vários produtos com caracterísitcas semelhantes ao grupo de NCM´s. Os NCM´s informados aqui compartilharão das mesmas regras e não poderão ser adicionados à outros grupos de NCM."}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.grutribitemList),function(grutribitem,index){return _c('div',{key:index,staticClass:"mainbox-select",staticStyle:{"background-color":"#eee"}},[_c('div',{class:[{ 'mark-red': grutribitem.duplicate || grutribitem.validate }]}),_vm._v(" "),_c('div',{staticClass:"box"},[(grutribitem.duplicate)?_c('div',{staticClass:"col"},[_c('span',{staticClass:"error"},[_vm._v("Produto Duplicado")])]):_vm._e(),_vm._v(" "),(grutribitem.validate)?_c('div',{staticClass:"col"},[_c('span',{staticClass:"error"},[_vm._v(" "+_vm._s(grutribitem.validate)+" ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[_c('form-field',{ref:"item",refInFor:true,attrs:{"type":"select2","col":"6","metadata":_vm.metadata.grutribitem.coditem,"select2":{ entity: 'item', minlength: 2 }},model:{value:(grutribitem.coditem),callback:function ($$v) {_vm.$set(grutribitem, "coditem", $$v)},expression:"grutribitem.coditem"}}),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-button',{attrs:{"label":"","title":"Excluir Item","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteProduto(index)}}})],1)],1)])])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Adicionar Produto","title":"","icon":"fa-plus","nb-btdef":true},on:{"click":_vm.handleAdicionaProduto}}),_vm._v(" "),(_vm.grutribitemList.length > 0)?_c('v-button',{attrs:{"label":"Adicionar Regras a Este Grupo","title":"","icon":"fa-plus","nb-btdef":true},on:{"click":_vm.handleAdicionaRegra}}):_vm._e()],1)])],2)],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.adicionaRegraShow)?_c('regraimp-add',{attrs:{"grutrib":_vm.grutrib,"crud":"ins"},on:{"save":_vm.handleSaveRegras,"closeform":_vm.closeFormAdicionaRegra}}):_vm._e()],1),_vm._v(" "),_c('vue-snotify'),_vm._v(" "),(_vm.showMessage)?_c('md-message',{attrs:{"code":_vm.codeMessage},on:{"close":function($event){return _vm.closeMessage()},"confirm":function($event){return _vm.handleConfirmMessage()}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"grid"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"single-entity":"Grupo de Regra de Imposto","plural-entity":"Grupos de Regras de Impostos","title-search":"Pesquise pela descrição do grupo"},on:{"search":_vm.search,"new":_vm.handleIncluir,"refresh":function($event){return _vm.loadData()}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.empty)?_c('alert',{attrs:{"type":"warning","text":"Nenhuma regra foi encontrada."}}):_vm._e(),_vm._v(" "),_vm._l((_vm.grutribList),function(grutrib,index){return _c('article',{key:grutrib.codgrutrib || index,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(grutrib.descricao))]),_vm._v(" "),(grutrib.regra_geral == 'S')?_c('span',{staticClass:"nb-card-badge nb-card-badge--neutral"},[_vm._v("\n                                    Regra Geral\n                                ")]):_vm._e()]),_vm._v(" "),(grutrib.codgrutrib)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(grutrib.codgrutrib))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: true, btnEditLabel: 'Editar'},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(grutrib.codgrutrib)},"view":function($event){return _vm.handleEdit(grutrib.codgrutrib)}}})],1)])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('regraimp-form',{attrs:{"crud":_vm.crud,"codgrutrib":_vm.codgrutrib},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-percent",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1592);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4b66af14", content, true, {});

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-0cf492c8]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-0cf492c8]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-0cf492c8]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-0cf492c8]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-0cf492c8]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-0cf492c8]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-0cf492c8]{flex:1;min-width:0}.nb-card-title-line[data-v-0cf492c8]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-0cf492c8]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-0cf492c8]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-0cf492c8]{color:#334155;font-weight:600}.nb-card-badge[data-v-0cf492c8]{display:inline-flex;align-items:center;gap:4px;padding:4px 7px;border:1px solid transparent;border-radius:5px;font-size:10px;font-weight:700;line-height:1.2}.nb-card-badge--success[data-v-0cf492c8]{color:#166534;background:#f0fdf4;border-color:#bbf7d0}.nb-card-badge--inactive[data-v-0cf492c8]{color:#92400e;background:#fffbeb;border-color:#fde68a}.nb-card-badge--neutral[data-v-0cf492c8]{color:#475569;background:#f1f5f9;border-color:#e2e8f0}.nb-card-actions[data-v-0cf492c8]{flex:0 0 auto}.nb-card-details[data-v-0cf492c8]{display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:12px;margin:12px 0 0 60px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-card-detail[data-v-0cf492c8]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-card-detail-label[data-v-0cf492c8]{color:#64748b;font-size:11px}.nb-card-detail>strong[data-v-0cf492c8]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}.nb-card-detail>strong .fa[data-v-0cf492c8]{margin-right:4px;color:#64748b}@media (max-width:767.98px){.nb-card-top[data-v-0cf492c8]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-0cf492c8]{align-self:flex-end}.nb-card-details[data-v-0cf492c8]{margin-left:0}}", ""]);

// exports


/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_usuario_form_vue__ = __webpack_require__(573);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db381f5_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_usuario_form_vue__ = __webpack_require__(1596);
function injectStyle (ssrContext) {
  __webpack_require__(1594)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_usuario_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db381f5_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_usuario_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1595);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("37a227e9", content, true, {});

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Usuário","plural-entity":"Usuários","crud":this.crud,"btn-delete":!_vm.usuarioComumLogado && _vm.index != _vm.$store.getters.getSessao.codusuario && _vm.usuario.uuid !== _vm.$store.getters.getEnv.uuid},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, max: 60}),expression:"{required: true, max: 60}"}],ref:"nome",attrs:{"type":"text","col":"6","label":"Nome","name":"nome","v-errors":_vm.errors},model:{value:(_vm.usuario.nome),callback:function ($$v) {_vm.$set(_vm.usuario, "nome", $$v)},expression:"usuario.nome"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, max: 255, email: true}),expression:"{required: true, max: 255, email: true}"}],attrs:{"type":"email","col":"6","label":"Email","disabled":_vm.usuarioComumLogado,"name":"email","v-errors":_vm.errors},model:{value:(_vm.usuario.email),callback:function ($$v) {_vm.$set(_vm.usuario, "email", $$v)},expression:"usuario.email"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({max: 30}),expression:"{max: 30}"}],attrs:{"type":"fone","col":"3","label":"Telefone","name":"fone","v-errors":_vm.errors},model:{value:(_vm.usuario.fone),callback:function ($$v) {_vm.$set(_vm.usuario, "fone", $$v)},expression:"usuario.fone"}})],1),_vm._v(" "),(!_vm.usuarioComumLogado)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-2 mb-5"},[_c('input-checkbox',{attrs:{"value-checked":"A","value-unchecked":"I","label":"Usuário Ativo","disabled":_vm.isView},model:{value:(_vm.usuario.stusuario),callback:function ($$v) {_vm.$set(_vm.usuario, "stusuario", $$v)},expression:"usuario.stusuario"}})],1)]):_vm._e(),_vm._v(" "),(_vm.alteraSenha)?_c('div',[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Senha","icon":""}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, max: 20}),expression:"{required: true, max: 20}"}],attrs:{"type":"password","col":"4","label":"Senha","name":"senha1","v-errors":_vm.errors},model:{value:(_vm.senha1),callback:function ($$v) {_vm.senha1=$$v},expression:"senha1"}},[_c('span',{staticClass:"data-list w-100"},[_c('small',[_vm._v("Defina a senha com no máximo 20 caracteres")])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, max: 20}),expression:"{required: true, max: 20}"}],attrs:{"type":"password","col":"4","label":"Repetir Senha","name":"senha2","v-errors":_vm.errors},model:{value:(_vm.senha2),callback:function ($$v) {_vm.senha2=$$v},expression:"senha2"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.editing)?_c('div',[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Senha","icon":""}}),_vm._v(" "),_c('alert',{attrs:{"type":"warning","title":"Definição de senha","text":"O novo usuário receberá um email para definição da senha"}})],1):_vm._e(),_vm._v(" "),(!_vm.usuarioComumLogado)?_c('div',[_c('label-title',{staticClass:"mt-5",attrs:{"title":"Selecione o Perfil de Usuário","icon":""}}),_vm._v(" "),(_vm.usuario.perfil == '0')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-6 nb-margin-top mb-2"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.perfil),expression:"usuario.perfil"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio0","value":"0"},domProps:{"checked":_vm._q(_vm.usuario.perfil,"0")},on:{"change":function($event){return _vm.$set(_vm.usuario, "perfil", "0")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio0"}},[_vm._v("Usuário criador da conta")]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v("Trata-se do criador da conta e portanto possui acesso irrestrito à todas as funcionalidades do sistema")])])])]):_vm._e(),_vm._v(" "),(_vm.usuario.perfil != '0')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-6 nb-margin-top mb-2"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.perfil),expression:"usuario.perfil"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio1","value":"1"},domProps:{"checked":_vm._q(_vm.usuario.perfil,"1")},on:{"change":function($event){return _vm.$set(_vm.usuario, "perfil", "1")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio1"}},[_vm._v("Administrador do sistema")]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v("Possui acesso irrestrito à todas as funcionalidades do sistema")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-6 nb-margin-top mb-2"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.perfil),expression:"usuario.perfil"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio3","value":"4"},domProps:{"checked":_vm._q(_vm.usuario.perfil,"4")},on:{"change":function($event){return _vm.$set(_vm.usuario, "perfil", "4")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio3"}},[_vm._v("Usuário Normal")]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v("Trata-se de usuário comum com acesso restrito às funcionalidades de cadastros e movimentações do sistema")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-6 nb-margin-top mb-2"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.perfil),expression:"usuario.perfil"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio4","value":"3"},domProps:{"checked":_vm._q(_vm.usuario.perfil,"3")},on:{"change":function($event){return _vm.$set(_vm.usuario, "perfil", "3")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio4"}},[_vm._v("Representante ou Vendedor")]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v("Trata-se de representante comercial que utiliza o sistema somente para lançamento de pedidos sem acesso a nenhuma outra funcionalidade")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-6 nb-margin-top mb-2"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.perfil),expression:"usuario.perfil"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio5","value":"5"},domProps:{"checked":_vm._q(_vm.usuario.perfil,"5")},on:{"change":function($event){return _vm.$set(_vm.usuario, "perfil", "5")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio5"}},[_vm._v("Usuário PDV")]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v("Trata-se de usuário com acesso restrito às funcionalidades de Varejo")])])])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.usuario.perfil != '0' && !_vm.usuarioComumLogado)?_c('div',[_c('label-title',{staticClass:"mt-5",attrs:{"title":"Permissões Para Pedidos","icon":""}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12 mt-2"},[_c('input-checkbox',{attrs:{"title":_vm.hBloqueiaTabela,"value-checked":true,"value-unchecked":false,"label":"Bloqueia alteração de tabela de preço quando o cliente informado já possuir tabela de preços vinculada em seu cadastro"},model:{value:(_vm.parametros.vendas.bloqueia_tabela_cliente),callback:function ($$v) {_vm.$set(_vm.parametros.vendas, "bloqueia_tabela_cliente", $$v)},expression:"parametros.vendas.bloqueia_tabela_cliente"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 mt-2"},[_c('input-checkbox',{attrs:{"title":_vm.hBloqueiaPreco,"value-checked":true,"value-unchecked":false,"label":"Bloqueia alteração no preço do produto"},model:{value:(_vm.parametros.vendas.bloqueia_preco_item),callback:function ($$v) {_vm.$set(_vm.parametros.vendas, "bloqueia_preco_item", $$v)},expression:"parametros.vendas.bloqueia_preco_item"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 mt-2"},[_c('input-checkbox',{attrs:{"title":_vm.hBloqueiaDescontos,"value-checked":true,"value-unchecked":false,"label":"Bloqueia descontos no pedido"},model:{value:(_vm.parametros.vendas.bloqueia_descontos),callback:function ($$v) {_vm.$set(_vm.parametros.vendas, "bloqueia_descontos", $$v)},expression:"parametros.vendas.bloqueia_descontos"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 mt-2"},[_c('input-checkbox',{attrs:{"title":_vm.hBloqueiaGerarPedido,"value-checked":true,"value-unchecked":false,"label":"Bloqueia gerar pedido de orçamento"},model:{value:(_vm.parametros.vendas.bloqueia_gerar_pedido),callback:function ($$v) {_vm.$set(_vm.parametros.vendas, "bloqueia_gerar_pedido", $$v)},expression:"parametros.vendas.bloqueia_gerar_pedido"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 mt-2"},[_c('input-checkbox',{attrs:{"title":_vm.hBloqueiaAlterarPedido,"value-checked":true,"value-unchecked":false,"label":"Bloqueia alterar pedido"},model:{value:(_vm.parametros.vendas.bloqueia_alterar_pedido),callback:function ($$v) {_vm.$set(_vm.parametros.vendas, "bloqueia_alterar_pedido", $$v)},expression:"parametros.vendas.bloqueia_alterar_pedido"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 mt-2"},[_c('v-label',{attrs:{"label":"Informe o desconto máximo permitido na venda"}})],1),_vm._v(" "),_c('form-field',{attrs:{"type":"value","addon":"%","col":"2","precision":2},model:{value:(_vm.parametros.vendas.desconto_maximo),callback:function ($$v) {_vm.$set(_vm.parametros.vendas, "desconto_maximo", $$v)},expression:"parametros.vendas.desconto_maximo"}})],1),_vm._v(" "),_c('label-title',{staticClass:"mt-5",attrs:{"title":"Tabelas de preços","icon":""}}),_vm._v(" "),_c('div',{staticClass:"row col"},[_c('v-label',{attrs:{"label":"Selecione as tabelas de preços que serão liberadas para este usuário"}})],1),_vm._v(" "),_c('div',{staticClass:"border p-3"},[_c('div',{staticClass:"row"},_vm._l((_vm.tabelaspreco),function(tabela,index){return _c('div',{key:index,staticClass:"col-md-6 col-12"},[_c('input-switch',{attrs:{"type":"success","label":tabela.descricao,"value-checked":true,"value-unchecked":false},model:{value:(tabela.liberada),callback:function ($$v) {_vm.$set(tabela, "liberada", $$v)},expression:"tabela.liberada"}})],1)}),0)])],1):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":!_vm.perfil_usuario_comum,"pdf-button":false,"xls-button":false,"single-entity":"Usuário","plural-entity":"Usuários","title-search":"Pesquise pelo nome"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.usuarioList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.usuarioList),function(usuario){return _c('article',{key:usuario.codusuario,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(usuario.nome))]),_vm._v(" "),_c('span',{staticClass:"nb-card-badge",class:usuario.stusuario == 'A' ? 'nb-card-badge--success' : 'nb-card-badge--inactive'},[_vm._v("\n                                    "+_vm._s(_vm._f("getText")(usuario.stusuario))+"\n                                ")]),_vm._v(" "),_c('span',{staticClass:"nb-card-badge nb-card-badge--neutral"},[_vm._v("\n                                    "+_vm._s(_vm._f("getPerfil")(usuario.perfil))+"\n                                ")])]),_vm._v(" "),(usuario.codusuario)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(usuario.codusuario))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[(!_vm.perfil_usuario_comum || usuario.uuid===_vm.usuario_logado_uuid)?_c('v-button',{attrs:{"label":"Alterar","nb-btdef":true,"icon":"fa-pencil"},on:{"click":function($event){return _vm.handleEdit(usuario.codusuario)}}}):_vm._e()],1)]),_vm._v(" "),(usuario.email || usuario.fone)?_c('div',{staticClass:"nb-card-details"},[(usuario.email)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("E-mail")]),_vm._v(" "),_c('strong',[_c('i',{staticClass:"fa fa-envelope-o",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(usuario.email))])]):_vm._e(),_vm._v(" "),(usuario.fone)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Telefone")]),_vm._v(" "),_c('strong',[_c('i',{staticClass:"fa fa-phone",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatFone")(usuario.fone)))])]):_vm._e()]):_vm._e()])})],2)],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showForm)?_c('usuario-form',{attrs:{"index":this.codusuario,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-user",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nf_list_vue__ = __webpack_require__(574);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e32b43c6_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nf_list_vue__ = __webpack_require__(1642);
function injectStyle (ssrContext) {
  __webpack_require__(1599)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nf_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e32b43c6_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nf_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1600);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("f16699b0", content, true, {});

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1602);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6d20556d", content, true, {});

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".lbl-edit[data-v-ac8af540],label[data-v-ac8af540]{margin-bottom:0}.dropdown-total[data-v-ac8af540]{z-index:1051;margin-top:3px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;position:absolute;padding:10px;z-index:1000;float:left;min-width:160px;list-style:none;background-color:#fff;border:1px solid #00000033;box-shadow:0 5px 10px #00000033;background-clip:padding-box}", ""]);

// exports


/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfsaida_item_vue__ = __webpack_require__(576);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f44fbd0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfsaida_item_vue__ = __webpack_require__(1606);
function injectStyle (ssrContext) {
  __webpack_require__(1604)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfsaida_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f44fbd0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfsaida_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1605);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("20cbaef6", content, true, {});

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[(!_vm.showItemForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v("Item da Nota Fiscal")]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[(!_vm.isView)?_c('v-button',{ref:"btnConfirm",attrs:{"label":"Salvar (F9)","nb-btdef":true},on:{"click":_vm.handleValidarItem}}):_vm._e(),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar"},on:{"click":_vm.closeForm}})],1),_vm._v(" "),_c('button',{staticClass:"close ml-2",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body",attrs:{"id":"mymodal"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"f9",undefined,$event.key,undefined)){ return null; }return _vm.handleValidarItem.apply(null, arguments)}}},[_c('tabs',{staticClass:"mb-4",attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 0),expression:"activeTab === 0"}]},[(!_vm.params.habilitaItem)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-1"},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(_vm.nfit.item[0].descricao))]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm.nfit.item[0].codigo))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2",attrs:{"align":"center"}},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(this.local_metadata.uni.label))]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(this.nfit.uni))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3",attrs:{"align":"right"}},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(this.local_metadata.qtuni.label))]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm._f("formatValue")(this.nfit.qtuni,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4",attrs:{"align":"right"}},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(this.local_metadata.vlr.label))]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm._f("formatValue")(this.nfit.vlr,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-5",attrs:{"align":"right"}},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(this.local_metadata.totliq.label))]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm._f("formatValue")(this.nfit.totliq,2)))])])]):_vm._e(),_vm._v(" "),(_vm.params.habilitaItem)?_c('div',{attrs:{"id":"item"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.local_metadata.coditem}}),_vm._v(" "),_c('div',{},[_c('input-item',{ref:"item",attrs:{"add-button":true,"disabled":_vm.nfit.codpedv},on:{"onselect":_vm.handleNewItem,"novo":_vm.handleCadastroItem},model:{value:(_vm.nfit.coditem),callback:function ($$v) {_vm.$set(_vm.nfit, "coditem", $$v)},expression:"nfit.coditem"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.qtuni.validator),expression:"local_metadata.qtuni.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.qtuni,"disabled":(_vm.isView && _vm.params.habilitaItem) || _vm.nfit.codpedv,"name":"qtuni","v-errors":_vm.errors},model:{value:(_vm.nfit.qtuni),callback:function ($$v) {_vm.$set(_vm.nfit, "qtuni", $$v)},expression:"nfit.qtuni"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vlr.validator),expression:"local_metadata.vlr.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.vlr,"disabled":_vm.isView || _vm.nfit.codpedv,"name":"vlr","v-errors":_vm.errors},model:{value:(_vm.nfit.vlr),callback:function ($$v) {_vm.$set(_vm.nfit, "vlr", $$v)},expression:"nfit.vlr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.uni.validator),expression:"local_metadata.uni.validator"}],attrs:{"tabindex":1,"type":"select2","col":"2","metadata":_vm.local_metadata.uni,"disabled":_vm.isView || _vm.nfit.codpedv,"parent":"mymodal","name":"uni","v-errors":_vm.errors},model:{value:(_vm.nfit.uni),callback:function ($$v) {_vm.$set(_vm.nfit, "uni", $$v)},expression:"nfit.uni"}}),_vm._v(" "),(_vm.params.nfComplementar)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.totliq.validator),expression:"local_metadata.totliq.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.totliq,"disabled":_vm.isView,"name":"totliq","v-errors":_vm.errors},model:{value:(_vm.nfit.totliq),callback:function ($$v) {_vm.$set(_vm.nfit, "totliq", $$v)},expression:"nfit.totliq"}}):_vm._e(),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.local_metadata.indtot},model:{value:(_vm.nfit.indtot),callback:function ($$v) {_vm.$set(_vm.nfit, "indtot", $$v)},expression:"nfit.indtot"}}),_vm._v(" "),((_vm.nfit.indtot != 'N'))?_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.local_metadata.inddup},model:{value:(_vm.nfit.inddup),callback:function ($$v) {_vm.$set(_vm.nfit, "inddup", $$v)},expression:"nfit.inddup"}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"ncm"}},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ncm.validator),expression:"local_metadata.ncm.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.ncm,"disabled":_vm.isView,"parent":"mymodal","name":"ncm","v-errors":_vm.errors},model:{value:(_vm.nfit.ncm),callback:function ($$v) {_vm.$set(_vm.nfit, "ncm", $$v)},expression:"nfit.ncm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.orimerc.validator),expression:"local_metadata.orimerc.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.orimerc,"disabled":_vm.isView,"name":"orimerc","v-errors":_vm.errors,"parent":"mymodal"},model:{value:(_vm.nfit.orimerc),callback:function ($$v) {_vm.$set(_vm.nfit, "orimerc", $$v)},expression:"nfit.orimerc"}}),_vm._v(" "),(!_vm.params.nfsaida)?_c('form-field',{attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.cfop,"disabled":_vm.isView,"parent":"mymodal","select2":{ entity: 'cfop/entradas', minlength: 0 }},model:{value:(_vm.nfit.cfop),callback:function ($$v) {_vm.$set(_vm.nfit, "cfop", $$v)},expression:"nfit.cfop"}}):_vm._e(),_vm._v(" "),(_vm.params.nfsaida)?_c('form-field',{attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.cfop,"disabled":_vm.isView,"parent":"mymodal","select2":{ entity: 'cfop/saidas', minlength: 0 }},model:{value:(_vm.nfit.cfop),callback:function ($$v) {_vm.$set(_vm.nfit, "cfop", $$v)},expression:"nfit.cfop"}}):_vm._e(),_vm._v(" "),(_vm.informaFCI)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.nfci.validator),expression:"local_metadata.nfci.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.local_metadata.nfci,"disabled":_vm.isView,"name":"nfci","v-errors":_vm.errors},model:{value:(_vm.nfit.nfci),callback:function ($$v) {_vm.$set(_vm.nfit, "nfci", $$v)},expression:"nfit.nfci"}}):_vm._e()],1),_vm._v(" "),(_vm.params.nfComplementar)?_c('div',{attrs:{"id":"complemento"}}):_vm._e(),_vm._v(" "),(_vm.params.nfAjuste)?_c('div',{attrs:{"id":"ajuste"}},[_c('div',{staticClass:"row"},[(_vm.params.nfComplementar)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vicm.validator),expression:"local_metadata.vicm.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.vicm,"disabled":_vm.isView,"name":"vicm","v-errors":_vm.errors},model:{value:(_vm.nfit.vicm),callback:function ($$v) {_vm.$set(_vm.nfit, "vicm", $$v)},expression:"nfit.vicm"}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.showLegacyTaxes)?_c('div',[_c('div',[_c('label-title',{attrs:{"title":"ICMS"}}),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.params.nf.operacaonf == 'S' && !_vm.params.optSimples)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.sticm.validator),expression:"local_metadata.sticm.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.sticm,"disabled":_vm.isView,"parent":"mymodal","name":"sticm","v-errors":_vm.errors},model:{value:(_vm.nfit.sticm),callback:function ($$v) {_vm.$set(_vm.nfit, "sticm", $$v)},expression:"nfit.sticm"}}):_vm._e(),_vm._v(" "),(_vm.params.nf.operacaonf == 'S' && _vm.params.optSimples)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.csosn.validator),expression:"local_metadata.csosn.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.csosn,"disabled":_vm.isView,"parent":"mymodal","name":"csosn","v-errors":_vm.errors},model:{value:(_vm.nfit.csosn),callback:function ($$v) {_vm.$set(_vm.nfit, "csosn", $$v)},expression:"nfit.csosn"}}):_vm._e(),_vm._v(" "),(_vm.params.nf.operacaonf == 'E' && _vm.params.nf.emissaopropria == 'N')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.sticm.validator),expression:"local_metadata.sticm.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.sticmentrada,"disabled":_vm.isView,"parent":"mymodal","name":"sticm","v-errors":_vm.errors},model:{value:(_vm.nfit.sticmentrada),callback:function ($$v) {_vm.$set(_vm.nfit, "sticmentrada", $$v)},expression:"nfit.sticmentrada"}}):_vm._e(),_vm._v(" "),(_vm.params.nf.operacaonf == 'E' && _vm.params.nf.emissaopropria == 'S' && !_vm.params.optSimples)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.sticm.validator),expression:"local_metadata.sticm.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.sticm,"disabled":_vm.isView,"parent":"mymodal","name":"sticm","v-errors":_vm.errors},model:{value:(_vm.nfit.sticm),callback:function ($$v) {_vm.$set(_vm.nfit, "sticm", $$v)},expression:"nfit.sticm"}}):_vm._e(),_vm._v(" "),(_vm.params.nf.operacaonf == 'E' && _vm.params.nf.emissaopropria == 'S' && _vm.params.optSimples)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.csosn.validator),expression:"local_metadata.csosn.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.csosn,"disabled":_vm.isView,"parent":"mymodal","name":"csosn","v-errors":_vm.errors},model:{value:(_vm.nfit.csosn),callback:function ($$v) {_vm.$set(_vm.nfit, "csosn", $$v)},expression:"nfit.csosn"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.habilitaBCIcm)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.bcicm.validator),expression:"local_metadata.bcicm.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.bcicm,"disabled":_vm.isView,"name":"bcicm","v-errors":_vm.errors},model:{value:(_vm.nfit.bcicm),callback:function ($$v) {_vm.$set(_vm.nfit, "bcicm", $$v)},expression:"nfit.bcicm"}}):_vm._e(),_vm._v(" "),(_vm.habilitaAIcm)?_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.aicm,"disabled":_vm.isView,"name":"aicm","v-errors":_vm.errors},model:{value:(_vm.nfit.aicm),callback:function ($$v) {_vm.$set(_vm.nfit, "aicm", $$v)},expression:"nfit.aicm"}}):_vm._e(),_vm._v(" "),(_vm.tributadoIcm)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ricm.validator),expression:"local_metadata.ricm.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.ricm,"disabled":_vm.isView,"name":"ricm","v-errors":_vm.errors},model:{value:(_vm.nfit.ricm),callback:function ($$v) {_vm.$set(_vm.nfit, "ricm", $$v)},expression:"nfit.ricm"}}):_vm._e(),_vm._v(" "),(_vm.icmDiferido)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.picmdif.validator),expression:"local_metadata.picmdif.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.picmdif,"disabled":_vm.isView,"name":"picmdif","v-errors":_vm.errors},model:{value:(_vm.nfit.picmdif),callback:function ($$v) {_vm.$set(_vm.nfit, "picmdif", $$v)},expression:"nfit.picmdif"}}):_vm._e(),_vm._v(" "),(_vm.params.nfComplementar)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vicm.validator),expression:"local_metadata.vicm.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.vicm,"disabled":_vm.isView,"name":"vicm","v-errors":_vm.errors},model:{value:(_vm.nfit.vicm),callback:function ($$v) {_vm.$set(_vm.nfit, "vicm", $$v)},expression:"nfit.vicm"}}):_vm._e(),_vm._v(" "),(_vm.tributadoIcm)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.afcp.validator),expression:"local_metadata.afcp.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.afcp,"disabled":_vm.isView,"name":"afcp","v-errors":_vm.errors},model:{value:(_vm.nfit.afcp),callback:function ($$v) {_vm.$set(_vm.nfit, "afcp", $$v)},expression:"nfit.afcp"}}):_vm._e(),_vm._v(" "),(_vm.params.nfComplementar)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vfcp.validator),expression:"local_metadata.vfcp.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.vfcp,"disabled":_vm.isView,"name":"vfcp","v-errors":_vm.errors},model:{value:(_vm.nfit.vfcp),callback:function ($$v) {_vm.$set(_vm.nfit, "vfcp", $$v)},expression:"nfit.vfcp"}}):_vm._e(),_vm._v(" "),(_vm.creditoSN)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.pcredsn.validator),expression:"local_metadata.pcredsn.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.pcredsn,"disabled":_vm.isView,"name":"pcredsn","v-errors":_vm.errors},model:{value:(_vm.nfit.pcredsn),callback:function ($$v) {_vm.$set(_vm.nfit, "pcredsn", $$v)},expression:"nfit.pcredsn"}}):_vm._e(),_vm._v(" "),(_vm.icmsRetido)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.bcicmretst.validator),expression:"local_metadata.bcicmretst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.bcicmretst,"disabled":_vm.isView,"name":"bcicmretst","v-errors":_vm.errors},model:{value:(_vm.nfit.bcicmretst),callback:function ($$v) {_vm.$set(_vm.nfit, "bcicmretst", $$v)},expression:"nfit.bcicmretst"}}):_vm._e(),_vm._v(" "),(_vm.icmsRetido)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.aicmretst.validator),expression:"local_metadata.aicmretst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.aicmretst,"disabled":_vm.isView,"name":"aicmretst","v-errors":_vm.errors},model:{value:(_vm.nfit.aicmretst),callback:function ($$v) {_vm.$set(_vm.nfit, "aicmretst", $$v)},expression:"nfit.aicmretst"}}):_vm._e(),_vm._v(" "),(_vm.icmsRetido)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vicmssubstituto.validator),expression:"local_metadata.vicmssubstituto.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.vicmssubstituto,"disabled":_vm.isView,"name":"vicmssubstituto","v-errors":_vm.errors},model:{value:(_vm.nfit.vicmssubstituto),callback:function ($$v) {_vm.$set(_vm.nfit, "vicmssubstituto", $$v)},expression:"nfit.vicmssubstituto"}}):_vm._e(),_vm._v(" "),(_vm.icmsRetido)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vicmretst.validator),expression:"local_metadata.vicmretst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.vicmretst,"disabled":_vm.isView,"name":"vicmretst","v-errors":_vm.errors},model:{value:(_vm.nfit.vicmretst),callback:function ($$v) {_vm.$set(_vm.nfit, "vicmretst", $$v)},expression:"nfit.vicmretst"}}):_vm._e(),_vm._v(" "),(_vm.icmsRetido)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vbcfcpstret.validator),expression:"local_metadata.vbcfcpstret.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.vbcfcpstret,"disabled":_vm.isView,"name":"vbcfcpstret","v-errors":_vm.errors},model:{value:(_vm.nfit.vbcfcpstret),callback:function ($$v) {_vm.$set(_vm.nfit, "vbcfcpstret", $$v)},expression:"nfit.vbcfcpstret"}}):_vm._e(),_vm._v(" "),(_vm.icmsRetido)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.afcpretst.validator),expression:"local_metadata.afcpretst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.afcpretst,"disabled":_vm.isView,"name":"afcpretst","v-errors":_vm.errors},model:{value:(_vm.nfit.afcpretst),callback:function ($$v) {_vm.$set(_vm.nfit, "afcpretst", $$v)},expression:"nfit.afcpretst"}}):_vm._e(),_vm._v(" "),(_vm.icmsRetido)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vfcpretst.validator),expression:"local_metadata.vfcpretst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.vfcpretst,"disabled":_vm.isView,"name":"vfcpretst","v-errors":_vm.errors},model:{value:(_vm.nfit.vfcpretst),callback:function ($$v) {_vm.$set(_vm.nfit, "vfcpretst", $$v)},expression:"nfit.vfcpretst"}}):_vm._e(),_vm._v(" "),(_vm.icmsRetido)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cest.validator),expression:"local_metadata.cest.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.local_metadata.cest,"disabled":_vm.isView,"name":"cest","v-errors":_vm.errors},model:{value:(_vm.nfit.cest),callback:function ($$v) {_vm.$set(_vm.nfit, "cest", $$v)},expression:"nfit.cest"}}):_vm._e(),_vm._v(" "),(_vm.informaMotdes)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.motdesicm.validator),expression:"local_metadata.motdesicm.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.motdesicm,"disabled":_vm.isView,"parent":"mymodal","name":"motdesicm","v-errors":_vm.errors},model:{value:(_vm.nfit.motdesicm),callback:function ($$v) {_vm.$set(_vm.nfit, "motdesicm", $$v)},expression:"nfit.motdesicm"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbenef.validator),expression:"local_metadata.cbenef.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.local_metadata.cbenef,"disabled":_vm.isView,"name":"cbenef","v-errors":_vm.errors},model:{value:(_vm.nfit.cbenef),callback:function ($$v) {_vm.$set(_vm.nfit, "cbenef", $$v)},expression:"nfit.cbenef"}})],1)],1),_vm._v(" "),(_vm.tributadoIcmST)?_c('div',[_c('div',{staticClass:"row"},[(_vm.habilitaBCIcm)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.bcicmst.validator),expression:"local_metadata.bcicmst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.bcicmst,"disabled":_vm.isView,"name":"bcicmst","v-errors":_vm.errors},model:{value:(_vm.nfit.bcicmst),callback:function ($$v) {_vm.$set(_vm.nfit, "bcicmst", $$v)},expression:"nfit.bcicmst"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ricmst.validator),expression:"local_metadata.ricmst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.ricmst,"disabled":_vm.isView,"name":"ricmst","v-errors":_vm.errors},model:{value:(_vm.nfit.ricmst),callback:function ($$v) {_vm.$set(_vm.nfit, "ricmst", $$v)},expression:"nfit.ricmst"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.mva.validator),expression:"local_metadata.mva.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.mva,"disabled":_vm.isView,"name":"mva","v-errors":_vm.errors},model:{value:(_vm.nfit.mva),callback:function ($$v) {_vm.$set(_vm.nfit, "mva", $$v)},expression:"nfit.mva"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.aicmst.validator),expression:"local_metadata.aicmst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.aicmst,"disabled":_vm.isView,"name":"aicmst","v-errors":_vm.errors},model:{value:(_vm.nfit.aicmst),callback:function ($$v) {_vm.$set(_vm.nfit, "aicmst", $$v)},expression:"nfit.aicmst"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.pautaicmst.validator),expression:"local_metadata.pautaicmst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.pautaicmst,"disabled":_vm.isView,"name":"pautaicmst","v-errors":_vm.errors},model:{value:(_vm.nfit.pautaicmst),callback:function ($$v) {_vm.$set(_vm.nfit, "pautaicmst", $$v)},expression:"nfit.pautaicmst"}}),_vm._v(" "),(_vm.params.nfComplementar)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vicmst.validator),expression:"local_metadata.vicmst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.vicmst,"disabled":_vm.isView,"name":"vicmst","v-errors":_vm.errors},model:{value:(_vm.nfit.vicmst),callback:function ($$v) {_vm.$set(_vm.nfit, "vicmst", $$v)},expression:"nfit.vicmst"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.afcpst.validator),expression:"local_metadata.afcpst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.afcpst,"disabled":_vm.isView,"name":"afcpst","v-errors":_vm.errors},model:{value:(_vm.nfit.afcpst),callback:function ($$v) {_vm.$set(_vm.nfit, "afcpst", $$v)},expression:"nfit.afcpst"}}),_vm._v(" "),(_vm.params.nfComplementar)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vfcpst.validator),expression:"local_metadata.vfcpst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.vfcpst,"disabled":_vm.isView,"name":"vfcpst","v-errors":_vm.errors},model:{value:(_vm.nfit.vfcpst),callback:function ($$v) {_vm.$set(_vm.nfit, "vfcpst", $$v)},expression:"nfit.vfcpst"}}):_vm._e(),_vm._v(" "),(!_vm.icmsRetido)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cest.validator),expression:"local_metadata.cest.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.local_metadata.cest,"disabled":_vm.isView,"name":"cest","v-errors":_vm.errors},model:{value:(_vm.nfit.cest),callback:function ($$v) {_vm.$set(_vm.nfit, "cest", $$v)},expression:"nfit.cest"}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.params.difal)?_c('div',[_c('label-title',{attrs:{"title":"DIFAL"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.aicmdest.validator),expression:"local_metadata.aicmdest.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.aicmdest,"disabled":_vm.isView,"name":"aicmdest","v-errors":_vm.errors},model:{value:(_vm.nfit.aicmdest),callback:function ($$v) {_vm.$set(_vm.nfit, "aicmdest", $$v)},expression:"nfit.aicmdest"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.afcpdest.validator),expression:"local_metadata.afcpdest.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.afcpdest,"disabled":_vm.isView,"name":"afcpdest","v-errors":_vm.errors},model:{value:(_vm.nfit.afcpdest),callback:function ($$v) {_vm.$set(_vm.nfit, "afcpdest", $$v)},expression:"nfit.afcpdest"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.particmdest.validator),expression:"local_metadata.particmdest.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.particmdest,"disabled":_vm.isView,"name":"particmdest","v-errors":_vm.errors},model:{value:(_vm.nfit.particmdest),callback:function ($$v) {_vm.$set(_vm.nfit, "particmdest", $$v)},expression:"nfit.particmdest"}})],1)],1):_vm._e(),_vm._v(" "),_c('div',[_c('label-title',{attrs:{"title":"IPI"}}),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.params.nfsaida)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.stipi.validator),expression:"local_metadata.stipi.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.stipi,"disabled":_vm.isView,"name":"stipi","v-errors":_vm.errors,"parent":"mymodal","select2":{ entity: 'stipi/saidas', minlength: 0 }},model:{value:(_vm.nfit.stipi),callback:function ($$v) {_vm.$set(_vm.nfit, "stipi", $$v)},expression:"nfit.stipi"}}):_vm._e(),_vm._v(" "),(!_vm.params.nfsaida)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.stipi.validator),expression:"local_metadata.stipi.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.stipi,"name":"stipi","v-errors":_vm.errors,"parent":"mymodal","select2":{ entity: 'stipi/entradas', minlength: 0 },"disabled":_vm.isView},model:{value:(_vm.nfit.stipi),callback:function ($$v) {_vm.$set(_vm.nfit, "stipi", $$v)},expression:"nfit.stipi"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cenqipi.validator),expression:"local_metadata.cenqipi.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.local_metadata.cenqipi,"name":"cenqipi","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.nfit.cenqipi),callback:function ($$v) {_vm.$set(_vm.nfit, "cenqipi", $$v)},expression:"nfit.cenqipi"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.params.nfComplementar)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.bcipi.validator),expression:"local_metadata.bcipi.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.bcipi,"disabled":_vm.isView,"name":"bcipi","v-errors":_vm.errors},model:{value:(_vm.nfit.bcipi),callback:function ($$v) {_vm.$set(_vm.nfit, "bcipi", $$v)},expression:"nfit.bcipi"}}):_vm._e(),_vm._v(" "),(_vm.tributadoIpi)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.aipi.validator),expression:"local_metadata.aipi.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.aipi,"disabled":_vm.isView,"name":"aipi","v-errors":_vm.errors},model:{value:(_vm.nfit.aipi),callback:function ($$v) {_vm.$set(_vm.nfit, "aipi", $$v)},expression:"nfit.aipi"}}):_vm._e(),_vm._v(" "),(_vm.tributadoIpi)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.pautaipi.validator),expression:"local_metadata.pautaipi.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.pautaipi,"disabled":_vm.isView,"name":"pautaipi","v-errors":_vm.errors},model:{value:(_vm.nfit.pautaipi),callback:function ($$v) {_vm.$set(_vm.nfit, "pautaipi", $$v)},expression:"nfit.pautaipi"}}):_vm._e(),_vm._v(" "),(_vm.tributadoIpi)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ripi.validator),expression:"local_metadata.ripi.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.ripi,"disabled":_vm.isView,"name":"ripi","v-errors":_vm.errors},model:{value:(_vm.nfit.ripi),callback:function ($$v) {_vm.$set(_vm.nfit, "ripi", $$v)},expression:"nfit.ripi"}}):_vm._e(),_vm._v(" "),(_vm.params.nfComplementar)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vipi.validator),expression:"local_metadata.vipi.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.vipi,"disabled":_vm.isView,"name":"vipi","v-errors":_vm.errors},model:{value:(_vm.nfit.vipi),callback:function ($$v) {_vm.$set(_vm.nfit, "vipi", $$v)},expression:"nfit.vipi"}}):_vm._e(),_vm._v(" "),((_vm.params.ipidevol))?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.pdevol.validator),expression:"local_metadata.pdevol.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.pdevol,"disabled":_vm.isView || (_vm.nfit.codnfitorigem !== null && _vm.nfit.codnfitorigem !== undefined && _vm.nfit.codnfitorigem !== ''),"name":"pdevol","v-errors":_vm.errors},model:{value:(_vm.nfit.pdevol),callback:function ($$v) {_vm.$set(_vm.nfit, "pdevol", $$v)},expression:"nfit.pdevol"}}):_vm._e(),_vm._v(" "),((_vm.params.ipidevol))?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vipidevol.validator),expression:"local_metadata.vipidevol.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.vipidevol,"disabled":_vm.isView || (_vm.nfit.codnfitorigem !== null && _vm.nfit.codnfitorigem !== undefined && _vm.nfit.codnfitorigem !== ''),"name":"vipidevol","v-errors":_vm.errors},model:{value:(_vm.nfit.vipidevol),callback:function ($$v) {_vm.$set(_vm.nfit, "vipidevol", $$v)},expression:"nfit.vipidevol"}}):_vm._e()],1)],1),_vm._v(" "),_c('div',[_c('label-title',{attrs:{"title":"PIS/COFINS"}}),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.params.nfsaida)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.stpis.validator),expression:"local_metadata.stpis.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.stpis,"disabled":_vm.isView,"name":"stpis","v-errors":_vm.errors,"parent":"mymodal","select2":{ entity: 'stpiscofins/saidas', minlength: 0 }},model:{value:(_vm.nfit.stpis),callback:function ($$v) {_vm.$set(_vm.nfit, "stpis", $$v)},expression:"nfit.stpis"}}):_vm._e(),_vm._v(" "),(!_vm.params.nfsaida)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.stpis.validator),expression:"local_metadata.stpis.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.stpis,"disabled":_vm.isView,"name":"stpis","v-errors":_vm.errors,"parent":"mymodal","select2":{ entity: 'stpiscofins/entradas', minlength: 0 }},model:{value:(_vm.nfit.stpis),callback:function ($$v) {_vm.$set(_vm.nfit, "stpis", $$v)},expression:"nfit.stpis"}}):_vm._e(),_vm._v(" "),(_vm.params.nfComplementar)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.bcpis.validator),expression:"local_metadata.bcpis.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.bcpis,"disabled":_vm.isView,"name":"bcpis","v-errors":_vm.errors},model:{value:(_vm.nfit.bcpis),callback:function ($$v) {_vm.$set(_vm.nfit, "bcpis", $$v)},expression:"nfit.bcpis"}}):_vm._e(),_vm._v(" "),(_vm.tributadoPis)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.apis.validator),expression:"local_metadata.apis.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.apis,"disabled":_vm.isView,"name":"apis","v-errors":_vm.errors},model:{value:(_vm.nfit.apis),callback:function ($$v) {_vm.$set(_vm.nfit, "apis", $$v)},expression:"nfit.apis"}}):_vm._e(),_vm._v(" "),(_vm.pautaPis)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.pautapis.validator),expression:"local_metadata.pautapis.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.pautapis,"disabled":_vm.isView,"name":"pautapis","v-errors":_vm.errors},model:{value:(_vm.nfit.pautapis),callback:function ($$v) {_vm.$set(_vm.nfit, "pautapis", $$v)},expression:"nfit.pautapis"}}):_vm._e(),_vm._v(" "),(_vm.tributadoPis)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.rpis.validator),expression:"local_metadata.rpis.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.rpis,"disabled":_vm.isView,"name":"rpis","v-errors":_vm.errors},model:{value:(_vm.nfit.rpis),callback:function ($$v) {_vm.$set(_vm.nfit, "rpis", $$v)},expression:"nfit.rpis"}}):_vm._e(),_vm._v(" "),(_vm.tributadoPisST)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.apisst.validator),expression:"local_metadata.apisst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.apisst,"disabled":_vm.isView,"name":"apisst","v-errors":_vm.errors},model:{value:(_vm.nfit.apisst),callback:function ($$v) {_vm.$set(_vm.nfit, "apisst", $$v)},expression:"nfit.apisst"}}):_vm._e(),_vm._v(" "),(_vm.tributadoPisST)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.pautapisst.validator),expression:"local_metadata.pautapisst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.pautapisst,"disabled":_vm.isView,"name":"pautapisst","v-errors":_vm.errors},model:{value:(_vm.nfit.pautapisst),callback:function ($$v) {_vm.$set(_vm.nfit, "pautapisst", $$v)},expression:"nfit.pautapisst"}}):_vm._e(),_vm._v(" "),(_vm.params.nfComplementar)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vpis.validator),expression:"local_metadata.vpis.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.vpis,"disabled":_vm.isView,"name":"vpis","v-errors":_vm.errors},model:{value:(_vm.nfit.vpis),callback:function ($$v) {_vm.$set(_vm.nfit, "vpis", $$v)},expression:"nfit.vpis"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.params.nfsaida)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.stcofins.validator),expression:"local_metadata.stcofins.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.stcofins,"disabled":_vm.isView,"name":"stcofins","v-errors":_vm.errors,"parent":"mymodal","select2":{ entity: 'stpiscofins/saidas', minlength: 0 }},model:{value:(_vm.nfit.stcofins),callback:function ($$v) {_vm.$set(_vm.nfit, "stcofins", $$v)},expression:"nfit.stcofins"}}):_vm._e(),_vm._v(" "),(!_vm.params.nfsaida)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.stcofins.validator),expression:"local_metadata.stcofins.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.stcofins,"disabled":_vm.isView,"name":"stcofins","v-errors":_vm.errors,"parent":"mymodal","select2":{ entity: 'stpiscofins/entradas', minlength: 0 }},model:{value:(_vm.nfit.stcofins),callback:function ($$v) {_vm.$set(_vm.nfit, "stcofins", $$v)},expression:"nfit.stcofins"}}):_vm._e(),_vm._v(" "),(_vm.params.nfComplementar)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.bccofins.validator),expression:"local_metadata.bccofins.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.bccofins,"disabled":_vm.isView,"name":"bccofins","v-errors":_vm.errors},model:{value:(_vm.nfit.bccofins),callback:function ($$v) {_vm.$set(_vm.nfit, "bccofins", $$v)},expression:"nfit.bccofins"}}):_vm._e(),_vm._v(" "),(_vm.tributadoCofins)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.acofins.validator),expression:"local_metadata.acofins.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.acofins,"disabled":_vm.isView,"name":"acofins","v-errors":_vm.errors},model:{value:(_vm.nfit.acofins),callback:function ($$v) {_vm.$set(_vm.nfit, "acofins", $$v)},expression:"nfit.acofins"}}):_vm._e(),_vm._v(" "),(_vm.pautaCofins)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.pautacofins.validator),expression:"local_metadata.pautacofins.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.pautacofins,"disabled":_vm.isView,"name":"pautacofins","v-errors":_vm.errors},model:{value:(_vm.nfit.pautacofins),callback:function ($$v) {_vm.$set(_vm.nfit, "pautacofins", $$v)},expression:"nfit.pautacofins"}}):_vm._e(),_vm._v(" "),(_vm.tributadoCofins)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.rcofins.validator),expression:"local_metadata.rcofins.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.rcofins,"disabled":_vm.isView,"name":"rcofins","v-errors":_vm.errors},model:{value:(_vm.nfit.rcofins),callback:function ($$v) {_vm.$set(_vm.nfit, "rcofins", $$v)},expression:"nfit.rcofins"}}):_vm._e(),_vm._v(" "),(_vm.tributadoCofinsST)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.acofinsst.validator),expression:"local_metadata.acofinsst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.acofinsst,"disabled":_vm.isView,"name":"acofinsst","v-errors":_vm.errors},model:{value:(_vm.nfit.acofinsst),callback:function ($$v) {_vm.$set(_vm.nfit, "acofinsst", $$v)},expression:"nfit.acofinsst"}}):_vm._e(),_vm._v(" "),(_vm.tributadoCofinsST)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.pautacofinsst.validator),expression:"local_metadata.pautacofinsst.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.pautacofinsst,"disabled":_vm.isView,"name":"pautacofinsst","v-errors":_vm.errors},model:{value:(_vm.nfit.pautacofinsst),callback:function ($$v) {_vm.$set(_vm.nfit, "pautacofinsst", $$v)},expression:"nfit.pautacofinsst"}}):_vm._e(),_vm._v(" "),(_vm.params.nfComplementar)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vcofins.validator),expression:"local_metadata.vcofins.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.vcofins,"disabled":_vm.isView,"name":"vcofins","v-errors":_vm.errors},model:{value:(_vm.nfit.vcofins),callback:function ($$v) {_vm.$set(_vm.nfit, "vcofins", $$v)},expression:"nfit.vcofins"}}):_vm._e()],1)],1)]):_vm._e(),_vm._v(" "),_c('div',[(!_vm.showIBSCBS && !_vm.isView)?_c('div',{staticClass:"mt-2 mb-2"},[_c('a',{attrs:{"href":"javascript:void(0);","tabindex":1},on:{"click":function($event){_vm.showIBSCBS = true}}},[_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" Exibir Nova Tributação(IS,IBS,CBS)")])]):_vm._e(),_vm._v(" "),(_vm.showIBSCBS || _vm.isView)?_c('div',{staticClass:"my-2"},[_c('label-title',{attrs:{"title":"Impostos Unificados (IBS e CBS)"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibscbscclass.validator),expression:"local_metadata.ibscbscclass.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.ibscbscclass,"disabled":_vm.isView,"name":"ibscbscclass","v-errors":_vm.errors,"parent":"mymodal","select2":{ entity: 'ivaclass', minlength: 0 }},model:{value:(_vm.nfit.ibscbscclass),callback:function ($$v) {_vm.$set(_vm.nfit, "ibscbscclass", $$v)},expression:"nfit.ibscbscclass"}})],1),_vm._v(" "),(_vm.ivaclass.ind_gibscbs == 1)?_c('label-title',{attrs:{"title":"IBS UF"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gibscbs == 1)?_c('div',{staticClass:"row"},[(_vm.ivaclass.ind_gibscbs == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsufaliq.validator),expression:"local_metadata.ibsufaliq.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsufaliq,"disabled":_vm.isView,"name":"ibsufaliq","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsufaliq),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsufaliq", $$v)},expression:"nfit.ibsufaliq"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gdif == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsufpdif.validator),expression:"local_metadata.ibsufpdif.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsufpdif,"disabled":_vm.isView,"name":"ibsufpdif","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsufpdif),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsufpdif", $$v)},expression:"nfit.ibsufpdif"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gred == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsufred.validator),expression:"local_metadata.ibsufred.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsufred,"disabled":_vm.isView,"name":"ibsufred","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsufred),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsufred", $$v)},expression:"nfit.ibsufred"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gibscbs == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsufvdevtrib.validator),expression:"local_metadata.ibsufvdevtrib.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsufvdevtrib,"disabled":_vm.isView,"name":"ibsufvdevtrib","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsufvdevtrib),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsufvdevtrib", $$v)},expression:"nfit.ibsufvdevtrib"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gibscbs == 1)?_c('label-title',{attrs:{"title":"IBS Município"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gibscbs == 1)?_c('div',{staticClass:"row"},[(_vm.ivaclass.ind_gibscbs == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsmunaliq.validator),expression:"local_metadata.ibsmunaliq.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsmunaliq,"disabled":_vm.isView,"name":"ibsmunaliq","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsmunaliq),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsmunaliq", $$v)},expression:"nfit.ibsmunaliq"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gdif == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsmunpdif.validator),expression:"local_metadata.ibsmunpdif.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsmunpdif,"disabled":_vm.isView,"name":"ibsmunpdif","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsmunpdif),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsmunpdif", $$v)},expression:"nfit.ibsmunpdif"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gred == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsmunred.validator),expression:"local_metadata.ibsmunred.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsmunred,"disabled":_vm.isView,"name":"ibsmunred","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsmunred),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsmunred", $$v)},expression:"nfit.ibsmunred"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gibscbs == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsmunvdevtrib.validator),expression:"local_metadata.ibsmunvdevtrib.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsmunvdevtrib,"disabled":_vm.isView,"name":"ibsmunvdevtrib","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsmunvdevtrib),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsmunvdevtrib", $$v)},expression:"nfit.ibsmunvdevtrib"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gibscbs == 1)?_c('label-title',{attrs:{"title":"CBS"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gibscbs == 1)?_c('div',{staticClass:"row"},[(_vm.ivaclass.ind_gibscbs == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbsaliq.validator),expression:"local_metadata.cbsaliq.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.cbsaliq,"disabled":_vm.isView,"name":"cbsaliq","v-errors":_vm.errors},model:{value:(_vm.nfit.cbsaliq),callback:function ($$v) {_vm.$set(_vm.nfit, "cbsaliq", $$v)},expression:"nfit.cbsaliq"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gdif == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbspdif.validator),expression:"local_metadata.cbspdif.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.cbspdif,"disabled":_vm.isView,"name":"cbspdif","v-errors":_vm.errors},model:{value:(_vm.nfit.cbspdif),callback:function ($$v) {_vm.$set(_vm.nfit, "cbspdif", $$v)},expression:"nfit.cbspdif"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gred == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbsred.validator),expression:"local_metadata.cbsred.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.cbsred,"disabled":_vm.isView,"name":"cbsred","v-errors":_vm.errors},model:{value:(_vm.nfit.cbsred),callback:function ($$v) {_vm.$set(_vm.nfit, "cbsred", $$v)},expression:"nfit.cbsred"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gibscbs == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbsvdevtrib.validator),expression:"local_metadata.cbsvdevtrib.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.cbsvdevtrib,"disabled":_vm.isView,"name":"cbsvdevtrib","v-errors":_vm.errors},model:{value:(_vm.nfit.cbsvdevtrib),callback:function ($$v) {_vm.$set(_vm.nfit, "cbsvdevtrib", $$v)},expression:"nfit.cbsvdevtrib"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ivaclass.gtribregular == 1)?_c('label-title',{attrs:{"title":"Grupo de Tributação Regular"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.gtribregular == 1)?_c('div',{staticClass:"row"},[(_vm.ivaclass.gtribregular == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibscbsregcclass.validator),expression:"local_metadata.ibscbsregcclass.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.local_metadata.ibscbsregcclass,"disabled":_vm.isView,"name":"ibscbsregcclass","v-errors":_vm.errors,"parent":"mymodal","select2":{ entity: 'ivaclass', minlength: 0 }},model:{value:(_vm.nfit.ibscbsregcclass),callback:function ($$v) {_vm.$set(_vm.nfit, "ibscbsregcclass", $$v)},expression:"nfit.ibscbsregcclass"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.gtribregular == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsufregaliq.validator),expression:"local_metadata.ibsufregaliq.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsufregaliq,"disabled":_vm.isView,"name":"ibsufregaliq","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsufregaliq),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsufregaliq", $$v)},expression:"nfit.ibsufregaliq"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.gtribregular == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsmunregaliq.validator),expression:"local_metadata.ibsmunregaliq.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsmunregaliq,"disabled":_vm.isView,"name":"ibsmunregaliq","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsmunregaliq),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsmunregaliq", $$v)},expression:"nfit.ibsmunregaliq"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.gtribregular == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbsregaliq.validator),expression:"local_metadata.cbsregaliq.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.cbsregaliq,"disabled":_vm.isView,"name":"cbsregaliq","v-errors":_vm.errors},model:{value:(_vm.nfit.cbsregaliq),callback:function ($$v) {_vm.$set(_vm.nfit, "cbsregaliq", $$v)},expression:"nfit.cbsregaliq"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gibscbsmono == 1)?_c('label-title',{attrs:{"title":"Regime Monofásico"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gibscbsmono == 1)?_c('div',{staticClass:"row"},[(_vm.ivaclass.mono == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.qbcmono.validator),expression:"local_metadata.qbcmono.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.qbcmono,"disabled":_vm.isView,"name":"qbcmono","v-errors":_vm.errors},model:{value:(_vm.nfit.qbcmono),callback:function ($$v) {_vm.$set(_vm.nfit, "qbcmono", $$v)},expression:"nfit.qbcmono"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.mono == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsamono.validator),expression:"local_metadata.ibsamono.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsamono,"disabled":_vm.isView,"name":"ibsamono","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsamono),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsamono", $$v)},expression:"nfit.ibsamono"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.mono == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsvmono.validator),expression:"local_metadata.ibsvmono.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsvmono,"disabled":_vm.isView,"name":"ibsvmono","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsvmono),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsvmono", $$v)},expression:"nfit.ibsvmono"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.mono == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbsamono.validator),expression:"local_metadata.cbsamono.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.cbsamono,"disabled":_vm.isView,"name":"cbsamono","v-errors":_vm.errors},model:{value:(_vm.nfit.cbsamono),callback:function ($$v) {_vm.$set(_vm.nfit, "cbsamono", $$v)},expression:"nfit.cbsamono"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.mono == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbsvmono.validator),expression:"local_metadata.cbsvmono.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.cbsvmono,"disabled":_vm.isView,"name":"cbsvmono","v-errors":_vm.errors},model:{value:(_vm.nfit.cbsvmono),callback:function ($$v) {_vm.$set(_vm.nfit, "cbsvmono", $$v)},expression:"nfit.cbsvmono"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.monoret == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.qbcmonoret.validator),expression:"local_metadata.qbcmonoret.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.qbcmonoret,"disabled":_vm.isView,"name":"qbcmonoret","v-errors":_vm.errors},model:{value:(_vm.nfit.qbcmonoret),callback:function ($$v) {_vm.$set(_vm.nfit, "qbcmonoret", $$v)},expression:"nfit.qbcmonoret"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.monoret == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsamonoret.validator),expression:"local_metadata.ibsamonoret.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsamonoret,"disabled":_vm.isView,"name":"ibsamonoret","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsamonoret),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsamonoret", $$v)},expression:"nfit.ibsamonoret"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.monoret == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsvmonoret.validator),expression:"local_metadata.ibsvmonoret.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsvmonoret,"disabled":_vm.isView,"name":"ibsvmonoret","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsvmonoret),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsvmonoret", $$v)},expression:"nfit.ibsvmonoret"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.monoret == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbsamonoret.validator),expression:"local_metadata.cbsamonoret.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.cbsamonoret,"disabled":_vm.isView,"name":"cbsamonoret","v-errors":_vm.errors},model:{value:(_vm.nfit.cbsamonoret),callback:function ($$v) {_vm.$set(_vm.nfit, "cbsamonoret", $$v)},expression:"nfit.cbsamonoret"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.monoret == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbsvmonoret.validator),expression:"local_metadata.cbsvmonoret.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.cbsvmonoret,"disabled":_vm.isView,"name":"cbsvmonoret","v-errors":_vm.errors},model:{value:(_vm.nfit.cbsvmonoret),callback:function ($$v) {_vm.$set(_vm.nfit, "cbsvmonoret", $$v)},expression:"nfit.cbsvmonoret"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.monoreten == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.qbcmonoreten.validator),expression:"local_metadata.qbcmonoreten.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.qbcmonoreten,"disabled":_vm.isView,"name":"qbcmonoreten","v-errors":_vm.errors},model:{value:(_vm.nfit.qbcmonoreten),callback:function ($$v) {_vm.$set(_vm.nfit, "qbcmonoreten", $$v)},expression:"nfit.qbcmonoreten"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.monoreten == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsamonoreten.validator),expression:"local_metadata.ibsamonoreten.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsamonoreten,"disabled":_vm.isView,"name":"ibsamonoreten","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsamonoreten),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsamonoreten", $$v)},expression:"nfit.ibsamonoreten"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.monoreten == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsvmonoreten.validator),expression:"local_metadata.ibsvmonoreten.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsvmonoreten,"disabled":_vm.isView,"name":"ibsvmonoreten","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsvmonoreten),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsvmonoreten", $$v)},expression:"nfit.ibsvmonoreten"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.monoreten == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbsamonoreten.validator),expression:"local_metadata.cbsamonoreten.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.cbsamonoreten,"disabled":_vm.isView,"name":"cbsamonoreten","v-errors":_vm.errors},model:{value:(_vm.nfit.cbsamonoreten),callback:function ($$v) {_vm.$set(_vm.nfit, "cbsamonoreten", $$v)},expression:"nfit.cbsamonoreten"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.monoreten == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbsvmonoreten.validator),expression:"local_metadata.cbsvmonoreten.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.cbsvmonoreten,"disabled":_vm.isView,"name":"cbsvmonoreten","v-errors":_vm.errors},model:{value:(_vm.nfit.cbsvmonoreten),callback:function ($$v) {_vm.$set(_vm.nfit, "cbsvmonoreten", $$v)},expression:"nfit.cbsvmonoreten"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.monodif == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsamonodif.validator),expression:"local_metadata.ibsamonodif.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsamonodif,"disabled":_vm.isView,"name":"ibsamonodif","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsamonodif),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsamonodif", $$v)},expression:"nfit.ibsamonodif"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.monodif == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbsamonodif.validator),expression:"local_metadata.cbsamonodif.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.cbsamonodif,"disabled":_vm.isView,"name":"cbsamonodif","v-errors":_vm.errors},model:{value:(_vm.nfit.cbsamonodif),callback:function ($$v) {_vm.$set(_vm.nfit, "cbsamonodif", $$v)},expression:"nfit.cbsamonodif"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.monodif == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsvmonodif.validator),expression:"local_metadata.ibsvmonodif.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsvmonodif,"disabled":_vm.isView,"name":"ibsvmonodif","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsvmonodif),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsvmonodif", $$v)},expression:"nfit.ibsvmonodif"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.monodif == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbsvmonodif.validator),expression:"local_metadata.cbsvmonodif.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.cbsvmonodif,"disabled":_vm.isView,"name":"cbsvmonodif","v-errors":_vm.errors},model:{value:(_vm.nfit.cbsvmonodif),callback:function ($$v) {_vm.$set(_vm.nfit, "cbsvmonodif", $$v)},expression:"nfit.cbsvmonodif"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gtransfcred == 1)?_c('label-title',{attrs:{"title":"Transferência de Crédito"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gtransfcred == 1)?_c('div',{staticClass:"row"},[(_vm.ivaclass.ind_gtransfcred == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vibstransf.validator),expression:"local_metadata.vibstransf.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.vibstransf,"disabled":_vm.isView,"name":"vibstransf","v-errors":_vm.errors},model:{value:(_vm.nfit.vibstransf),callback:function ($$v) {_vm.$set(_vm.nfit, "vibstransf", $$v)},expression:"nfit.vibstransf"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gtransfcred == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vcbstransf.validator),expression:"local_metadata.vcbstransf.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.vcbstransf,"disabled":_vm.isView,"name":"vcbstransf","v-errors":_vm.errors},model:{value:(_vm.nfit.vcbstransf),callback:function ($$v) {_vm.$set(_vm.nfit, "vcbstransf", $$v)},expression:"nfit.vcbstransf"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ivaclass.estornocred == 1)?_c('label-title',{attrs:{"title":"Estorno de Crédito"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.estornocred == 1)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.estcredvibs.validator),expression:"local_metadata.estcredvibs.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.estcredvibs,"disabled":_vm.isView,"name":"estcredvibs","v-errors":_vm.errors},model:{value:(_vm.nfit.estcredvibs),callback:function ($$v) {_vm.$set(_vm.nfit, "estcredvibs", $$v)},expression:"nfit.estcredvibs"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.estcredvcbs.validator),expression:"local_metadata.estcredvcbs.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.estcredvcbs,"disabled":_vm.isView,"name":"estcredvcbs","v-errors":_vm.errors},model:{value:(_vm.nfit.estcredvcbs),callback:function ($$v) {_vm.$set(_vm.nfit, "estcredvcbs", $$v)},expression:"nfit.estcredvcbs"}})],1):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gajustecompet == 1)?_c('label-title',{attrs:{"title":"Ajuste de Competência"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gajustecompet == 1)?_c('div',{staticClass:"row"},[(_vm.ivaclass.ind_gajustecompet == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ajustecompetapur.validator),expression:"local_metadata.ajustecompetapur.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.local_metadata.ajustecompetapur,"disabled":_vm.isView,"name":"ajustecompetapur","v-errors":_vm.errors},model:{value:(_vm.nfit.ajustecompetapur),callback:function ($$v) {_vm.$set(_vm.nfit, "ajustecompetapur", $$v)},expression:"nfit.ajustecompetapur"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gajustecompet == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ajustecompetvibs.validator),expression:"local_metadata.ajustecompetvibs.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ajustecompetvibs,"disabled":_vm.isView,"name":"ajustecompetvibs","v-errors":_vm.errors},model:{value:(_vm.nfit.ajustecompetvibs),callback:function ($$v) {_vm.$set(_vm.nfit, "ajustecompetvibs", $$v)},expression:"nfit.ajustecompetvibs"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gajustecompet == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ajustecompetvcbs.validator),expression:"local_metadata.ajustecompetvcbs.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ajustecompetvcbs,"disabled":_vm.isView,"name":"ajustecompetvcbs","v-errors":_vm.errors},model:{value:(_vm.nfit.ajustecompetvcbs),callback:function ($$v) {_vm.$set(_vm.nfit, "ajustecompetvcbs", $$v)},expression:"nfit.ajustecompetvcbs"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ivaclass.credpres == 1)?_c('label-title',{attrs:{"title":"Crédito Presumido"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.credpres == 1)?_c('div',{staticClass:"row"},[(_vm.ivaclass.credpres == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.credpresvbc.validator),expression:"local_metadata.credpresvbc.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.credpresvbc,"disabled":_vm.isView,"name":"credpresvbc","v-errors":_vm.errors},model:{value:(_vm.nfit.credpresvbc),callback:function ($$v) {_vm.$set(_vm.nfit, "credpresvbc", $$v)},expression:"nfit.credpresvbc"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.credpres == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ccredpres.validator),expression:"local_metadata.ccredpres.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.local_metadata.ccredpres,"disabled":_vm.isView,"name":"ccredpres","v-errors":_vm.errors},model:{value:(_vm.nfit.ccredpres),callback:function ($$v) {_vm.$set(_vm.nfit, "ccredpres", $$v)},expression:"nfit.ccredpres"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ivaclass.credpres == 1)?_c('label-title',{attrs:{"title":"Crédito Presumido (IBS)"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.credpres == 1)?_c('div',{staticClass:"row"},[(_vm.ivaclass.credpres == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibspcredpres.validator),expression:"local_metadata.ibspcredpres.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibspcredpres,"disabled":_vm.isView,"name":"ibspcredpres","v-errors":_vm.errors},model:{value:(_vm.nfit.ibspcredpres),callback:function ($$v) {_vm.$set(_vm.nfit, "ibspcredpres", $$v)},expression:"nfit.ibspcredpres"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.credpres == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsvcredpres.validator),expression:"local_metadata.ibsvcredpres.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.ibsvcredpres,"disabled":_vm.isView,"name":"ibsvcredpres","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsvcredpres),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsvcredpres", $$v)},expression:"nfit.ibsvcredpres"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.credpres == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibsvcredprescondsus.validator),expression:"local_metadata.ibsvcredprescondsus.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibsvcredprescondsus,"disabled":_vm.isView,"name":"ibsvcredprescondsus","v-errors":_vm.errors},model:{value:(_vm.nfit.ibsvcredprescondsus),callback:function ($$v) {_vm.$set(_vm.nfit, "ibsvcredprescondsus", $$v)},expression:"nfit.ibsvcredprescondsus"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ivaclass.credpres == 1)?_c('label-title',{attrs:{"title":"Crédito Presumido (CBS)"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.credpres == 1)?_c('div',{staticClass:"row"},[(_vm.ivaclass.credpres == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbspcredpres.validator),expression:"local_metadata.cbspcredpres.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.cbspcredpres,"disabled":_vm.isView,"name":"cbspcredpres","v-errors":_vm.errors},model:{value:(_vm.nfit.cbspcredpres),callback:function ($$v) {_vm.$set(_vm.nfit, "cbspcredpres", $$v)},expression:"nfit.cbspcredpres"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.credpres == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbsvcredpres.validator),expression:"local_metadata.cbsvcredpres.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.cbsvcredpres,"disabled":_vm.isView,"name":"cbsvcredpres","v-errors":_vm.errors},model:{value:(_vm.nfit.cbsvcredpres),callback:function ($$v) {_vm.$set(_vm.nfit, "cbsvcredpres", $$v)},expression:"nfit.cbsvcredpres"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.credpres == 1)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.cbsvcredprescondsus.validator),expression:"local_metadata.cbsvcredprescondsus.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.cbsvcredprescondsus,"disabled":_vm.isView,"name":"cbsvcredprescondsus","v-errors":_vm.errors},model:{value:(_vm.nfit.cbsvcredprescondsus),callback:function ($$v) {_vm.$set(_vm.nfit, "cbsvcredprescondsus", $$v)},expression:"nfit.cbsvcredprescondsus"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gcredpresibszfm == 1)?_c('label-title',{attrs:{"title":"Crédito presumido ZFM"}}):_vm._e(),_vm._v(" "),(_vm.ivaclass.ind_gcredpresibszfm == 1)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibszfmcredpresapur.validator),expression:"local_metadata.ibszfmcredpresapur.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.local_metadata.ibszfmcredpresapur,"disabled":_vm.isView,"name":"ibszfmcredpresapur","v-errors":_vm.errors},model:{value:(_vm.nfit.ibszfmcredpresapur),callback:function ($$v) {_vm.$set(_vm.nfit, "ibszfmcredpresapur", $$v)},expression:"nfit.ibszfmcredpresapur"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibszfmtpcredpres.validator),expression:"local_metadata.ibszfmtpcredpres.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.local_metadata.ibszfmtpcredpres,"disabled":_vm.isView,"name":"ibszfmtpcredpres","v-errors":_vm.errors},model:{value:(_vm.nfit.ibszfmtpcredpres),callback:function ($$v) {_vm.$set(_vm.nfit, "ibszfmtpcredpres", $$v)},expression:"nfit.ibszfmtpcredpres"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.ibszfmvcredpres.validator),expression:"local_metadata.ibszfmvcredpres.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.ibszfmvcredpres,"disabled":_vm.isView,"name":"ibszfmvcredpres","v-errors":_vm.errors},model:{value:(_vm.nfit.ibszfmvcredpres),callback:function ($$v) {_vm.$set(_vm.nfit, "ibszfmvcredpres", $$v)},expression:"nfit.ibszfmvcredpres"}})],1):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('label-title',{attrs:{"title":"Outros Dados"}}),_vm._v(" "),(_vm.nfImportacao)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.nadicao.validator),expression:"local_metadata.nadicao.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.nadicao,"disabled":_vm.isView,"name":"nadicao","v-errors":_vm.errors},model:{value:(_vm.nfit.nadicao),callback:function ($$v) {_vm.$set(_vm.nfit, "nadicao", $$v)},expression:"nfit.nadicao"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.itadicao.validator),expression:"local_metadata.itadicao.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.itadicao,"disabled":_vm.isView,"name":"itadicao","v-errors":_vm.errors},model:{value:(_vm.nfit.itadicao),callback:function ($$v) {_vm.$set(_vm.nfit, "itadicao", $$v)},expression:"nfit.itadicao"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.pedcliit.validator),expression:"local_metadata.pedcliit.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.local_metadata.pedcliit,"disabled":_vm.isView,"name":"pedcliit","v-errors":_vm.errors},model:{value:(_vm.nfit.pedcliit),callback:function ($$v) {_vm.$set(_vm.nfit, "pedcliit", $$v)},expression:"nfit.pedcliit"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.local_metadata.obs}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.nfit.obs),expression:"nfit.obs"},{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],staticClass:"form-control form-control-sm",attrs:{"rows":"4","cols":"100","disabled":_vm.isView,"name":"desccomp"},domProps:{"value":(_vm.nfit.obs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.nfit, "obs", $event.target.value)}}})],1)])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 1),expression:"activeTab === 1"}],staticClass:"mb-3"},[(!_vm.params.habilitaItem)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-1"},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(_vm.nfit.item[0].descricao))]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm.nfit.item[0].codigo))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2",attrs:{"align":"center"}},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(this.local_metadata.uni.label))]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(this.nfit.uni))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3",attrs:{"align":"right"}},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(this.local_metadata.qtuni.label))]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm._f("formatValue")(this.nfit.qtuni,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4",attrs:{"align":"right"}},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(this.local_metadata.vlr.label))]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm._f("formatValue")(this.nfit.vlr,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-5",attrs:{"align":"right"}},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(this.local_metadata.totliq.label))]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm._f("formatValue")(this.nfit.totliq,2)))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-12 d-flex justify-content-between align-items-center"},[_c('label-title',{attrs:{"title":"Vínculo de Origem do item da Nota (DFe Referenciado)"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button","disabled":_vm.isView},on:{"click":_vm.limparVinculoOrigem}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" Limpar Vínculo\n              ")])],1)]),_vm._v(" "),_c('tabs',{staticClass:"mb-4",attrs:{"tabs":_vm.subTabs,"setActiveTab":_vm.activeSubTab},on:{"onClickTab":_vm.changeSubTab}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeSubTab === 0),expression:"activeSubTab === 0"}]},[(_vm.nfOrigemDados || _vm.nfitemOrigemDados)?_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card bg-light p-3",staticStyle:{"border-radius":"5px","border":"1px solid #e3e6f0"}},[_c('div',{staticClass:"row"},[(_vm.nfOrigemDados)?_c('div',{staticClass:"col-md-6 col-12"},[_c('h6',{staticClass:"text-primary font-weight-bold mb-2"},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v(" Nota de Origem")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled mb-0",staticStyle:{"padding-left":"0"}},[_c('li',[_c('strong',[_vm._v("Nº da Nota:")]),_vm._v(" "+_vm._s(_vm.nfOrigemDados.numnf))]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Série:")]),_vm._v(" "+_vm._s(_vm.nfOrigemDados.serie))]),_vm._v(" "),_c('li',{staticClass:"text-truncate",attrs:{"title":_vm.nfOrigemDados.chave}},[_c('strong',[_vm._v("Chave:")]),_vm._v(" "+_vm._s(_vm.nfOrigemDados.chave))])])]):_vm._e(),_vm._v(" "),(_vm.nfitemOrigemDados)?_c('div',{staticClass:"col-md-6 col-12"},[_c('h6',{staticClass:"text-primary font-weight-bold mb-2"},[_c('i',{staticClass:"fa fa-cube"}),_vm._v(" Item de Origem")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled mb-0",staticStyle:{"padding-left":"0"}},[_c('li',[_c('strong',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(_vm.nfitemOrigemDados.descricao))]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Quantidade:")]),_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.nfitemOrigemDados.quantidade,2)))]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Valor Unitário:")]),_vm._v(" R$ "+_vm._s(_vm._f("formatValue")(_vm.nfitemOrigemDados.valor,2)))])])]):_vm._e()])])])]):_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-info mb-0"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" Nenhum vínculo com documento do sistema identificado para este item.\n                ")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeSubTab === 1),expression:"activeSubTab === 1"}]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Carregar Arquivo XML")]),_vm._v(" "),_c('input',{staticClass:"form-control form-control-sm",attrs:{"type":"file","accept":".xml","disabled":_vm.isView},on:{"change":_vm.onXMLFileSelected}})])]),_vm._v(" "),(_vm.xmlParsedData)?_c('form-field',{attrs:{"type":"select","col":"6","metadata":_vm.local_metadata.xmlSelectedItem,"disabled":_vm.isView,"select-options":_vm.xmlSelectOptions},on:{"input":_vm.selecionarItemXmlByValue},model:{value:(_vm.nfit.nitemorigem),callback:function ($$v) {_vm.$set(_vm.nfit, "nitemorigem", $$v)},expression:"nfit.nitemorigem"}}):_vm._e()],1),_vm._v(" "),(_vm.nfit.chaveorigem)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"text-success mt-2",staticStyle:{"font-weight":"bold"}},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" Chave Vinculada: "+_vm._s(_vm.nfit.chaveorigem)+" (Item: "+_vm._s(_vm.nfit.nitemorigem)+")\n                ")])])]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeSubTab === 2),expression:"activeSubTab === 2"}]},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.chaveorigem.validator),expression:"local_metadata.chaveorigem.validator"}],attrs:{"type":"text","col":"9","metadata":_vm.local_metadata.chaveorigem,"disabled":_vm.isView,"name":"chaveorigem","v-errors":_vm.errors,"maxlength":"44","placeholder":"00000000000000000000000000000000000000000000"},model:{value:(_vm.nfit.chaveorigem),callback:function ($$v) {_vm.$set(_vm.nfit, "chaveorigem", $$v)},expression:"nfit.chaveorigem"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.nitemorigem.validator),expression:"local_metadata.nitemorigem.validator"}],attrs:{"type":"number","col":"3","metadata":_vm.local_metadata.nitemorigem,"disabled":_vm.isView,"name":"nitemorigem","v-errors":_vm.errors,"min":"1","placeholder":"1"},model:{value:(_vm.nfit.nitemorigem),callback:function ($$v) {_vm.$set(_vm.nfit, "nitemorigem", $$v)},expression:"nfit.nitemorigem"}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[(!_vm.isView)?_c('v-button',{ref:"btnConfirmBottom",attrs:{"label":"Salvar (F9)","nb-btdef":true},on:{"click":_vm.handleValidarItem}}):_vm._e(),_vm._v(" "),_c('v-button',{ref:"btnCloseBottom",attrs:{"label":"Cancelar"},on:{"click":_vm.closeForm}})],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.showItemForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('Trap',[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('item-form',{attrs:{"crud":_vm.crud,"descricao":_vm.descricaoNovoItem},on:{"closeform":_vm.closeItemForm}})],1)])])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1608);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1da59a22", content, true, {});

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nf_form_origem_vue__ = __webpack_require__(578);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1ac9cc_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nf_form_origem_vue__ = __webpack_require__(1612);
function injectStyle (ssrContext) {
  __webpack_require__(1610)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nf_form_origem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1ac9cc_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nf_form_origem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1611);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("46760360", content, true, {});

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable",attrs:{"id":"mymodal"}},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v("Pesquisar Notas de Origem")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchString),expression:"searchString"}],ref:"pesquisa",staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":'Pesquisar'},domProps:{"value":(_vm.searchString)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSearch()},"input":function($event){if($event.target.composing){ return; }_vm.searchString=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary",staticStyle:{"margin-right":"5px"},attrs:{"tabindex":"1","type":"submit"},on:{"click":function($event){return _vm.handleSearch()}}},[_c('i',{staticClass:"fa fa-search",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('span',{staticClass:"badge badge-yellow",staticStyle:{"margin-top":"10px"}},[_vm._v("Efetue a pesquisa pelo número da nota")])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.nfList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.nfList),function(nf){return _c('div',{key:nf.codnf,staticClass:"mainbox"},[_c('div',{staticClass:"mark-gray"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-6"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(nf.nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Número")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(nf.serie)+" / "+_vm._s(nf.nf))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.data(nf.data)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Natureza")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(nf.descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-6"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(nf.chave))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.operacaoNf(nf.operacaonf)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Total")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(nf.totger)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('input-switch',{attrs:{"type":"success","label":"","value-checked":"S","value-unchecked":"N"},on:{"input":function($event){return _vm.handleSelectNf(nf.codnf, nf.chave, nf.serie, nf.nf)}},model:{value:(nf.selected),callback:function ($$v) {_vm.$set(nf, "selected", $$v)},expression:"nf.selected"}})],1)])])])})],2),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{attrs:{"tabindex":1,"label":"Adicionar Selecionadas","nb-btdef":true,"title":"","icon":"fa-plus"},on:{"click":function($event){return _vm.handleAddNotas()}}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":function($event){return _vm.closeForm()}}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8 col-12"},[_c('div',{staticClass:"float-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('label-title',{attrs:{"title":"Documentos Fiscais Referenciados"}}):_vm._e(),_c('br'),_vm._v(" "),(_vm.nfref.length == 0)?_c('alert',{attrs:{"type":"warning","text":"É necessário informar um documento fiscal referenciado para a natureza selecionada"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.nfref),function(nfref,index){return _c('div',{key:index,staticClass:"col"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-2 col-6"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfref.nfreftp}}),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(nfref.nfreftp),expression:"nfref.nfreftp"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(nfref, "nfreftp", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.metadata.nfref.nfreftp.options),function(opt){return _c('option',{key:opt.id,domProps:{"value":opt.id}},[_vm._v(_vm._s(opt.text))])}),0)])])],1)]),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfref.chave.validator),expression:"metadata.nfref.chave.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.nfref.chave,"name":"chave","v-errors":_vm.errors},model:{value:(nfref.chave),callback:function ($$v) {_vm.$set(nfref, "chave", $$v)},expression:"nfref.chave"}}),_vm._v(" "),(nfref.nfreftp == '4')?_c('div',{staticClass:"col-md-2 col-6"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfref.modnfpref}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(nfref.modnfpref),expression:"nfref.modnfpref"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(nfref, "modnfpref", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.metadata.nfref.modnfpref.options),function(opt){return _c('option',{key:opt.id,domProps:{"value":opt.id}},[_vm._v(_vm._s(opt.text))])}),0)],1)]):_vm._e(),_vm._v(" "),(nfref.nfreftp == '3' || nfref.nfreftp == '4')?_c('div',{staticClass:"col-md-1 col-6"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfref.serie}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(nfref.serie),expression:"nfref.serie"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","maxlength":"3"},domProps:{"value":(nfref.serie)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(nfref, "serie", $event.target.value)}}}),_vm._v(" "),(nfref.validation.serie)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(nfref.validation.serie))]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(nfref.nfreftp == '3' || nfref.nfreftp == '4')?_c('div',{staticClass:"col-md-2 col-6"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfref.nf}}),_vm._v(" "),_c('input-value',{staticClass:"form-control form-control-sm",attrs:{"precision":0,"maxlength":"9"},model:{value:(nfref.nf),callback:function ($$v) {_vm.$set(nfref, "nf", $$v)},expression:"nfref.nf"}}),_vm._v(" "),(nfref.validation.nf)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(nfref.validation.nf))]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(nfref.nfreftp == '3' || nfref.nfreftp == '4')?_c('div',{staticClass:"col-md-2 col-6"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfref.cnpj}}),_vm._v(" "),_c('input-value',{staticClass:"form-control form-control-sm",attrs:{"precision":0,"maxlength":"14"},model:{value:(nfref.cnpj),callback:function ($$v) {_vm.$set(nfref, "cnpj", $$v)},expression:"nfref.cnpj"}}),_vm._v(" "),(nfref.validation.cnpj)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(nfref.validation.cnpj))]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(nfref.nfreftp == '4')?_c('div',{staticClass:"col-md-2 col-6"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfref.cpf}}),_vm._v(" "),_c('input-value',{staticClass:"form-control form-control-sm",attrs:{"precision":0,"maxlength":"11"},model:{value:(nfref.cpf),callback:function ($$v) {_vm.$set(nfref, "cpf", $$v)},expression:"nfref.cpf"}})],1)]):_vm._e(),_vm._v(" "),(nfref.nfreftp == '4')?_c('div',{staticClass:"col-md-2 col-6"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfref.iest}}),_vm._v(" "),_c('input-value',{staticClass:"form-control form-control-sm",attrs:{"precision":0,"maxlength":"15"},model:{value:(nfref.iest),callback:function ($$v) {_vm.$set(nfref, "iest", $$v)},expression:"nfref.iest"}})],1)]):_vm._e(),_vm._v(" "),(nfref.nfreftp == '5')?_c('div',{staticClass:"col-md-2 col-6"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfref.modecfref}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(nfref.modecfref),expression:"nfref.modecfref"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(nfref, "modecfref", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.metadata.nfref.modecfref.options),function(opt){return _c('option',{key:opt.id,domProps:{"value":opt.id}},[_vm._v(_vm._s(opt.text))])}),0)],1)]):_vm._e(),_vm._v(" "),(nfref.nfreftp == '5')?_c('div',{staticClass:"col-md-2 col-6"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfref.necf}}),_vm._v(" "),_c('input-value',{staticClass:"form-control form-control-sm",attrs:{"precision":0,"maxlength":"3"},model:{value:(nfref.necf),callback:function ($$v) {_vm.$set(nfref, "necf", $$v)},expression:"nfref.necf"}})],1)]):_vm._e(),_vm._v(" "),(nfref.nfreftp == '5')?_c('div',{staticClass:"col-md-2 col-6"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfref.ncoo}}),_vm._v(" "),_c('input-value',{staticClass:"form-control form-control-sm",attrs:{"precision":0,"maxlength":"6"},model:{value:(nfref.ncoo),callback:function ($$v) {_vm.$set(nfref, "ncoo", $$v)},expression:"nfref.ncoo"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-1"},[_c('v-button',{attrs:{"label":"","title":"","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteRef(index)}}})],1)],1)])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row col"},[_c('v-button',{attrs:{"label":"Adicionar Documento Referenciado","title":"Adicione documentos fiscais referenciados","nb-btdef":true},on:{"click":_vm.handleAddRef}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Pesquisar Notas de Origem","title":"Selecione as notas de origem","nb-btdef":true},on:{"click":_vm.handleNfOrigem}})],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.showNfOrigem)?_c('nf-form-origem',{attrs:{"codpart":_vm.nf.codpart,"operacaonf":_vm.operacaonfOrigem,"nforigem":_vm.selectedNf},on:{"closeform":_vm.closeOrigemForm}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1615);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("9625b89e", content, true, {});

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"nb-modal-scrollable",attrs:{"id":"mymodal"}},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"500px"}},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v(" Alterar Número da Nota Fiscal ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.handleCancelar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),(_vm.errmessages)?_c('div',[_c('div',{staticClass:"col"},[_c('div',{staticClass:"alert alert-warning fade show",attrs:{"role":"alert"}},[_c('h5',{staticClass:"alert-heading"},[_vm._v("Erro:")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('p',[_c('small',[_vm._v(_vm._s(_vm.errmessages))])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl"},[_vm._v("Informe a nova numeração para a nota fiscal.")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.serie.validator),expression:"metadata.nf.serie.validator"}],ref:"serie",attrs:{"type":"select","selectOptions":_vm.serienfList,"col":"6","metadata":_vm.metadata.nf.serie,"name":"serie","v-errors":_vm.errors},model:{value:(_vm.serie),callback:function ($$v) {_vm.serie=$$v},expression:"serie"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.nf.validator),expression:"metadata.nf.nf.validator"}],attrs:{"type":"number","col":"6","metadata":_vm.metadata.nf.nf,"name":"nf","v-errors":_vm.errors},model:{value:(_vm.numero),callback:function ($$v) {_vm.numero=$$v},expression:"numero"}})],1),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{ref:"btnConfirm",attrs:{"label":"Salvar","title":"","nb-btdef":true},on:{"click":_vm.handleSalvar}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.handleCancelar}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1618);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7718ce6e", content, true, {});

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".erp-divider[data-v-b42a2292]{border-top:1px solid #e0e0e0}.erp-border-light[data-v-b42a2292]{border-color:#f0f0f0!important}.erp-shadow-sm[data-v-b42a2292]{box-shadow:0 1px 3px rgba(0,0,0,.05)}.erp-list-row[data-v-b42a2292]{transition:background-color .15s ease-in-out}.erp-list-row[data-v-b42a2292]:hover{background-color:#f8f9fa}.erp-list-row[data-v-b42a2292]:last-child{border-bottom:none!important}.erp-sq-badge[data-v-b42a2292]{display:flex;align-items:center;justify-content:center;width:24px;height:24px;border-radius:4px;font-size:.8rem;background-color:#e3f2fd;color:#0d47a1;font-weight:600;flex-shrink:0}.erp-status-badge[data-v-b42a2292]{border:1px solid transparent}.status-rounded[data-v-b42a2292]{border-radius:50%;width:10px;height:10px;content:\" \";display:inline-block}.erp-btn-action[data-v-b42a2292]{transition:all .2s ease-in-out}.erp-btn-action[data-v-b42a2292]:hover{transform:translateY(-1px);box-shadow:0 2px 5px rgba(0,0,0,.1)}.erp-modal-mask[data-v-b42a2292]{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:rgba(33,37,41,.4);backdrop-filter:blur(2px);display:table;transition:opacity .3s ease}.erp-modal-wrapper[data-v-b42a2292]{display:table-cell;vertical-align:middle}.erp-modal-container[data-v-b42a2292]{width:90%;max-width:950px;margin:0 auto;transition:all .3s ease;display:flex;flex-direction:column}.erp-estoque-card[data-v-b42a2292]{transition:box-shadow .2s ease}.erp-estoque-card[data-v-b42a2292]:hover{box-shadow:0 4px 8px rgba(0,0,0,.08)!important}.erp-dense-form[data-v-b42a2292] .form-group{margin-bottom:.2rem!important}.erp-dense-form[data-v-b42a2292] label{margin-bottom:.1rem!important;font-size:.75rem!important;color:#6c757d}.erp-dense-form[data-v-b42a2292] .form-control{height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.85rem}.gap-1[data-v-b42a2292]{gap:.25rem}.gap-2[data-v-b42a2292]{gap:.5rem}.text-truncate[data-v-b42a2292]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.modal-enter[data-v-b42a2292],.modal-leave-active[data-v-b42a2292]{opacity:0}.modal-enter .erp-modal-container[data-v-b42a2292],.modal-leave-active .erp-modal-container[data-v-b42a2292]{-webkit-transform:scale(1.02);transform:scale(1.02)}", ""]);

// exports


/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"erp-armazenamento-container"},[_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"row align-items-center mb-2"},[(_vm.excluir && _vm.nfEntrada)?_c('div',{staticClass:"col-md-auto"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(!_vm.excluir)?_c('div',{staticClass:"col text-right"},[_c('a',{staticClass:"text-primary font-weight-bold",staticStyle:{"cursor":"pointer","font-size":"12px"},on:{"click":_vm.handleSugerirLotes}},[_vm._v("\n          Sugerir preenchimento automático\n        ")])]):_vm._e()])]),_vm._v(" "),_c('hr',{staticClass:"mt-1 mb-3 erp-divider"}),_vm._v(" "),_c('div',{staticClass:"item-list-container bg-white border rounded erp-shadow-sm overflow-hidden mb-3"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.itemList),function(item,index){return _c('div',{key:index,staticClass:"d-flex flex-wrap align-items-center px-3 py-1 border-bottom erp-list-row"},[_c('div',{staticClass:"col-12 col-md-4 px-1 mb-1 mb-md-0"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"erp-sq-badge mr-2"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 overflow-hidden"},[_c('span',{staticClass:"d-md-none text-muted small text-uppercase font-weight-bold mb-0 d-block"},[_vm._v("Produto")]),_vm._v(" "),_c('span',{staticClass:"font-weight-bold d-block text-truncate text-dark",staticStyle:{"font-size":"0.9rem"},attrs:{"title":item.descricao}},[_vm._v(_vm._s(item.descricao))]),_vm._v(" "),_c('small',{staticClass:"text-secondary",staticStyle:{"font-size":"0.75rem"}},[_vm._v(_vm._s(item.codigo))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 px-1 mb-1 mb-md-0 d-flex justify-content-between justify-content-md-center align-items-center"},[_c('span',{staticClass:"d-md-none text-muted small text-uppercase font-weight-bold"},[_vm._v("Quantidade")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"text-secondary"},[_vm._v(_vm._s(_vm._f("formatValue")(item.qt,4))+" "+_vm._s(item.uni))]),_vm._v(" "),_c('i',{staticClass:"fa fa-arrow-right mx-2 text-muted small"}),_vm._v(" "),_c('span',{staticClass:"font-weight-bold",class:_vm.isAlocated(item) ? 'text-success' : 'text-danger'},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.qtAlcoated(item),4)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-2 px-1 mb-1 mb-md-0 d-flex justify-content-between justify-content-md-center align-items-center"},[_c('span',{staticClass:"d-md-none text-muted small text-uppercase font-weight-bold"},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"d-inline-flex align-items-center px-2 py-1 rounded erp-status-badge",class:_vm.isAlocated(item) ? 'bg-light-success border-success' : 'bg-light-danger border-danger'},[_c('div',{staticClass:"status-rounded mr-2",class:_vm.isAlocated(item) ? 'bg-success' : 'bg-danger'}),_vm._v(" "),_c('small',{staticClass:"font-weight-bold",class:_vm.isAlocated(item) ? 'text-success' : 'text-danger'},[_vm._v("\n            "+_vm._s(_vm.isAlocated(item) ? 'Alocado' : 'Pendente')+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 px-1 text-right d-flex gap-1 justify-content-end align-items-center flex-wrap"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary erp-btn-action",attrs:{"title":"Informar Dados"},on:{"click":function($event){return _vm.openModal(index)}}},[_c('i',{staticClass:"fa fa-edit mr-1"}),_vm._v(" "),_c('span',{staticClass:"d-md-none d-lg-inline"},[_vm._v("Informar Lote/Local")])])])])}),_vm._v(" "),(_vm.itemList.length === 0)?_c('div',{staticClass:"p-4 text-center text-muted"},[_c('small',[_vm._v("Nenhum item carregado.")])]):_vm._e()],2),_vm._v(" "),(_vm.msgErro)?_c('div',{staticClass:"w-100"},[_c('alert',{attrs:{"type":"error","text":_vm.msgErro}})],1):_vm._e(),_vm._v(" "),(_vm.msgConcluir)?_c('div',{staticClass:"w-100 mt-2"},[_c('alert',{attrs:{"type":"warning","text":_vm.msgConcluir}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-4 pt-3 border-top erp-border-light"},[(_vm.excluir)?_c('div',{staticClass:"col-md-12 col-12 mb-3"},[_c('input-checkbox',{ref:"confirmar",attrs:{"label":"Confirmo a exclusão definitiva do armazenamento","value-checked":"S","value-unchecked":"N"},model:{value:(_vm.exclusaoConfirmada),callback:function ($$v) {_vm.exclusaoConfirmada=$$v},expression:"exclusaoConfirmada"}})],1):_vm._e(),_vm._v(" "),(!_vm.excluir)?_c('div',{staticClass:"col d-flex gap-2"},[(_vm.concluir)?_c('v-button',{attrs:{"label":"Concluir Armazenamento","icon":"fa-check","nb-btdef":true},on:{"click":_vm.handleSalvar}}):_c('v-button',{attrs:{"label":"Validar Estoque","icon":"fa-check-circle-o","nb-btdef":true},on:{"click":_vm.handleSalvar}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Fechar","icon":"fa-times","nb-btdef":false},on:{"click":_vm.closeForm}})],1):_c('div',{staticClass:"col d-flex gap-2"},[_c('v-button',{staticClass:"btn-danger",attrs:{"label":"Confirmar Exclusão","icon":"fa-trash","nb-btdef":true},on:{"click":_vm.handleExcluir}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar","icon":"fa-times","nb-btdef":false},on:{"click":_vm.closeForm}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"modal"}},[(_vm.showModal && _vm.activeItem)?_c('div',{staticClass:"erp-modal-mask",on:{"mousedown":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.closeModal.apply(null, arguments)}}},[_c('div',{staticClass:"erp-modal-wrapper"},[_c('div',{staticClass:"erp-modal-container bg-white rounded shadow-lg"},[_c('div',{staticClass:"erp-modal-header border-bottom p-2 px-3 d-flex justify-content-between align-items-center bg-light rounded-top"},[_c('div',[_c('h5',{staticClass:"mb-0 text-dark font-weight-bold",staticStyle:{"font-size":"1.1rem"}},[_vm._v("\n                Armazenamento do produto "+_vm._s(_vm.activeItem.codigo)+" - "+_vm._s(_vm.activeItem.descricao)+"\n              ")])]),_vm._v(" "),_c('button',{staticClass:"close text-secondary",staticStyle:{"padding-top":"0.5rem"},attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('span',{staticStyle:{"font-size":"1.5rem"},attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"erp-modal-body p-2 overflow-auto bg-light erp-dense-form",staticStyle:{"max-height":"75vh"}},[(_vm.activeItem.validacao)?_c('div',{staticClass:"col-md-12 col-12 mb-1 px-0 text-center"},[_c('span',{staticClass:"badge badge-danger p-1"},[_vm._v(_vm._s(_vm.activeItem.validacao[0]))])]):_vm._e(),_vm._v(" "),_vm._l((_vm.activeItem.estoque),function(estoque,idx){return _c('div',{key:idx,staticClass:"mb-2 p-2 bg-white border rounded shadow-sm position-relative erp-estoque-card"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center border-bottom pb-1 mb-1"},[_c('span',{staticClass:"badge badge-primary text-uppercase px-2 py-1",staticStyle:{"font-size":"0.7rem"}},[_vm._v("Local #"+_vm._s(idx + 1))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-danger border-0 py-0",attrs:{"type":"button","title":"Remover local"},on:{"click":function($event){return _vm.handleDeleteEstoque(_vm.activeItem, estoque, idx)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('small',[_vm._v("Remover")])])]),_vm._v(" "),(!estoque.selecionarLote)?_c('div',[(estoque.validacao)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-1"},[_c('span',{staticClass:"text-danger small font-weight-bold"},[_c('i',{staticClass:"fa fa-exclamation-circle mr-1"}),_vm._v(_vm._s(estoque.validacao[0]))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row form-group mb-1 align-items-end"},[(_vm.depositoUnico == 'N')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfqt.coddeposito.validator),expression:"metadata.nfqt.coddeposito.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nfqt.coddeposito,"name":'coddeposito_' + idx,"v-errors":_vm.errors,"label":"Depósito"},model:{value:(estoque.coddeposito),callback:function ($$v) {_vm.$set(estoque, "coddeposito", $$v)},expression:"estoque.coddeposito"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfqt.qt.validator),expression:"metadata.nfqt.qt.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nfqt.qt,"name":"qt","v-errors":_vm.errors,"label":"Qtd. Armazenar"},model:{value:(estoque.qt),callback:function ($$v) {_vm.$set(estoque, "qt", _vm._n($$v))},expression:"estoque.qt"}}),_vm._v(" "),(_vm.activeItem.controlalocal == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfqt.local.validator),expression:"metadata.nfqt.local.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nfqt.local,"name":'local_' + idx,"v-errors":_vm.errors,"label":"Local/Endereço"},model:{value:(estoque.local),callback:function ($$v) {_vm.$set(estoque, "local", $$v)},expression:"estoque.local"}}):_vm._e(),_vm._v(" "),(_vm.activeItem.isgrade && _vm.activeItem.isgrade === 'S')?_c('form-field',{attrs:{"type":"select2","col":"4","metadata":_vm.metadata.mest.coditemgrade,"select2":{ entity: '/grades/item/' + _vm.activeItem.coditem, minlength: 0 },"label":"Grade"},model:{value:(estoque.coditemgrade),callback:function ($$v) {_vm.$set(estoque, "coditemgrade", $$v)},expression:"estoque.coditemgrade"}}):_vm._e()],1),_vm._v(" "),(_vm.isControleLote(_vm.activeItem))?_c('div',{staticClass:"row form-group mb-1 align-items-end"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfqt.lote.validator),expression:"metadata.nfqt.lote.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nfqt.lote,"name":'lote_' + idx,"v-errors":_vm.errors,"disabled":estoque.codqest},model:{value:(estoque.lote),callback:function ($$v) {_vm.$set(estoque, "lote", $$v)},expression:"estoque.lote"}}),_vm._v(" "),(_vm.isControleValidade(_vm.activeItem))?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfqt.dtfab.validator),expression:"metadata.nfqt.dtfab.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.nfqt.dtfab,"name":'dtfab_' + idx,"v-errors":_vm.errors,"disabled":estoque.codqest},model:{value:(estoque.dtfab),callback:function ($$v) {_vm.$set(estoque, "dtfab", $$v)},expression:"estoque.dtfab"}}):_vm._e(),_vm._v(" "),(_vm.isControleValidade(_vm.activeItem))?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfqt.dtval.validator),expression:"metadata.nfqt.dtval.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.nfqt.dtval,"name":'dtval_' + idx,"v-errors":_vm.errors,"disabled":estoque.codqest},model:{value:(estoque.dtval),callback:function ($$v) {_vm.$set(estoque, "dtval", $$v)},expression:"estoque.dtval"}}):_vm._e()],1):_vm._e()]):_vm._e(),_vm._v(" "),(estoque.selecionarLote)?_c('div',[(estoque.validacao)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-1"},[_c('span',{staticClass:"text-danger small font-weight-bold"},[_c('i',{staticClass:"fa fa-exclamation-circle mr-1"}),_vm._v(_vm._s(estoque.validacao[0]))])])]):_vm._e(),_vm._v(" "),_c('estoque-selecionar-lote',{attrs:{"obj":estoque,"filial":_vm.activeItem.codfil,"coditem":_vm.activeItem.coditem,"entrada":true,"somenteComQuantidade":true}}),_vm._v(" "),_c('div',{staticClass:"row mt-1"},[_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary py-0",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleDeleteEstoque(_vm.activeItem, estoque, idx)}}},[_c('small',[_vm._v("Cancelar Seleção")])])])])],1):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"text-left mt-2 pl-1"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm font-weight-bold erp-btn-action",staticStyle:{"padding":"0.25rem 0.5rem","font-size":"0.8rem"},attrs:{"type":"button"},on:{"click":function($event){return _vm.handleAdicionarEstoque(_vm.activeItem, false)}}},[_c('i',{staticClass:"fa fa-plus mr-1"}),_vm._v(" Novo Local\n              ")])])],2),_vm._v(" "),_c('div',{staticClass:"erp-modal-footer p-2 px-3 border-top bg-white text-right rounded-bottom"},[_c('v-button',{attrs:{"label":"Confirmar e Fechar","icon":"fa-check","nb-btdef":true},on:{"click":_vm.closeModal}})],1)])])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"def-title text-danger mb-0"},[_c('i',{staticClass:"fa fa-exclamation-triangle mr-2"}),_vm._v("Excluir Armazenamento da Nota")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none d-md-flex align-items-center bg-light border-bottom px-3 py-1 text-muted small text-uppercase font-weight-bold"},[_c('div',{staticClass:"col-md-4 px-1"},[_vm._v("Produto")]),_vm._v(" "),_c('div',{staticClass:"col-md-3 px-1 text-center"},[_vm._v("Qtd (Nota "),_c('i',{staticClass:"fa fa-angle-right mx-1"}),_vm._v(" Armaz.)")]),_vm._v(" "),_c('div',{staticClass:"col-md-2 px-1 text-center"},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"col-md-3 px-1 text-right"},[_vm._v("Ações")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_msg_banner_modal_vue__ = __webpack_require__(583);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c71fbb_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_msg_banner_modal_vue__ = __webpack_require__(1623);
function injectStyle (ssrContext) {
  __webpack_require__(1621)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_msg_banner_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c71fbb_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_msg_banner_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1622);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2ee59055", content, true, {});

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".modal-mask{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);display:table;transition:opacity .3s ease}", ""]);

// exports


/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{staticClass:"modal nb-modal-scrollable modal-mask",staticStyle:{"display":"block"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content nb-modal-scrollable-container"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"def-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.handleCloseButton()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"height":"555px","overflow-y":"auto"}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.url}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-sm",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.handleConfirmButton()}}},[_vm._v("Fechar e\n            não exibir novamente")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfsaida_form_modal_nfxml_vue__ = __webpack_require__(584);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f36e696_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfsaida_form_modal_nfxml_vue__ = __webpack_require__(1627);
function injectStyle (ssrContext) {
  __webpack_require__(1625)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfsaida_form_modal_nfxml_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f36e696_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfsaida_form_modal_nfxml_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1626);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1eb11bde", content, true, {});

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeModal()}}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"def-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("\n          Informar xml da nota\n        ")]),_vm._v(" "),_c('button',{staticClass:"close",on:{"click":function($event){return _vm.closeModal()}}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body pt-3 d-flex justify-content-center",staticStyle:{"max-height":"100%","overflow-y":"auto"}},[_c('div',{staticClass:"row border d-flex justify-content-center align-items-center",staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"col-12"},[_c('small',{staticClass:"lbl-edit"},[_vm._v("Chave Nfe")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chave),expression:"chave"}],ref:"chave",staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.chave)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chave=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('small',{staticClass:"lbl-edit"},[_vm._v("Protocolo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nprot),expression:"nprot"}],ref:"chave",staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.nprot)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nprot=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('small',{staticClass:"lbl-edit"},[_vm._v("Conteúdo XML da nota")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.xml),expression:"xml"}],ref:"nfxml",staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.xml)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.changeToNextEl()},"input":function($event){if($event.target.composing){ return; }_vm.xml=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"danger":"","label":"Cancelar"},on:{"click":function($event){return _vm.closeModal()}}}),_vm._v(" "),_c('v-button',{ref:"nfxmlConfirmButton",attrs:{"nbBtdef":"","label":"Confirmar"},on:{"click":function($event){return _vm.handleConfirmNfxml()}}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1629);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b1c486b6", content, true, {});

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-modal-mask[data-v-753c8d48]{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center}.modal-dialog[data-v-753c8d48]{width:90%;max-width:90%!important;min-width:320px}.modal-content[data-v-753c8d48]{min-height:300px}@media (min-width:768px){.modal-dialog[data-v-753c8d48]{min-width:600px}.modal-content[data-v-753c8d48]{min-height:400px}}@media (min-width:1200px){.modal-dialog[data-v-753c8d48]{min-width:900px}.modal-content[data-v-753c8d48]{min-height:450px}}", ""]);

// exports


/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-mask"},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-xl",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v("Eventos NF-e - "+_vm._s(_vm.nf.nf)+" / "+_vm._s(_vm.nf.serie))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.handleClose}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"max-height":"70vh","overflow-y":"auto"}},[(_vm.erros.length > 0)?_c('div',{staticClass:"alert alert-danger"},[_c('ul',_vm._l((_vm.erros),function(err,idx){return _c('li',{key:idx},[_vm._v(_vm._s(err))])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"12","label":"Tipo de Evento","select-options":_vm.listaEventos,"disabled":!!_vm.defaultTpEvento},model:{value:(_vm.tpEventoSelecionado),callback:function ($$v) {_vm.tpEventoSelecionado=$$v},expression:"tpEventoSelecionado"}})],1),_vm._v(" "),(_vm.tpEventoSelecionado === '110001')?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"text","col":"4","label":"Evento Original","disabled":!!_vm.defaultTpEventoAut},model:{value:(_vm.camposCabecalho.tpeventoaut),callback:function ($$v) {_vm.$set(_vm.camposCabecalho, "tpeventoaut", $$v)},expression:"camposCabecalho.tpeventoaut"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","col":"8","label":"Protocolo Original","disabled":!!_vm.defaultNProtEvento},model:{value:(_vm.camposCabecalho.nprotevento),callback:function ($$v) {_vm.$set(_vm.camposCabecalho, "nprotevento", $$v)},expression:"camposCabecalho.nprotevento"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","col":"12","label":"Justificativa do Cancelamento","placeholder":"Digite a justificativa (mínimo de 15 caracteres)"},model:{value:(_vm.camposCabecalho.xJust),callback:function ($$v) {_vm.$set(_vm.camposCabecalho, "xJust", $$v)},expression:"camposCabecalho.xJust"}})],1):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '112150')?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"date","col":"12","label":"Nova Previsão de Entrega"},model:{value:(_vm.camposCabecalho.dhPrevisaoEntrega),callback:function ($$v) {_vm.$set(_vm.camposCabecalho, "dhPrevisaoEntrega", $$v)},expression:"camposCabecalho.dhPrevisaoEntrega"}})],1):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '211128')?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"12","label":"Aceite","select-options":[{id: 1, text: 'Sim (Aceitar)'}, {id: 0, text: 'Não (Recusar)'}]},model:{value:(_vm.camposCabecalho.indAceitacao),callback:function ($$v) {_vm.$set(_vm.camposCabecalho, "indAceitacao", $$v)},expression:"camposCabecalho.indAceitacao"}})],1):_vm._e(),_vm._v(" "),(_vm.exigeItens)?_c('div',{staticClass:"mt-4"},[_c('label-title',{attrs:{"title":"Itens da Nota Fiscal","icon":"fa-list"}}),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Item")]),_vm._v(" "),_c('th',[_vm._v("Produto")]),_vm._v(" "),(_vm.tpEventoSelecionado === '211110')?_c('th',[_vm._v("Base Calc.")]):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '211110')?_c('th',[_vm._v("% Cred.")]):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '211110')?_c('th',[_vm._v("Cód. Créd. Pres.")]):_vm._e(),_vm._v(" "),(['211110', '211130', '211140', '211150', '112120', '112130', '112140', '211124'].includes(_vm.tpEventoSelecionado))?_c('th',[_vm._v("Vlr IBS")]):_vm._e(),_vm._v(" "),(['211110', '211130', '211140', '211150', '112120', '112130', '112140', '211124'].includes(_vm.tpEventoSelecionado))?_c('th',[_vm._v("Vlr CBS")]):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '211130')?_c('th',[_vm._v("Qtd Imob.")]):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '211140')?_c('th',[_vm._v("Qtd Comb.")]):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '112120')?_c('th',[_vm._v("Qtd Consumo")]):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '112120')?_c('th',[_vm._v("Unid. Consumo")]):_vm._e(),_vm._v(" "),(['112130', '211124'].includes(_vm.tpEventoSelecionado))?_c('th',[_vm._v("Qtd Perecida")]):_vm._e(),_vm._v(" "),(['112130', '211124'].includes(_vm.tpEventoSelecionado))?_c('th',[_vm._v("Unid. Perecida")]):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '112130')?_c('th',[_vm._v("IBS Estorno")]):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '112130')?_c('th',[_vm._v("CBS Estorno")]):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '112140')?_c('th',[_vm._v("Qtd Não Forn.")]):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '112140')?_c('th',[_vm._v("Unid. Não Forn.")]):_vm._e()])]),_vm._v(" "),_c('tbody',_vm._l((_vm.itensEvento),function(it,idx){return _c('tr',{key:idx},[_c('td',[_vm._v(_vm._s(it.nitem))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(it.descricao))]),_vm._v(" "),(_vm.tpEventoSelecionado === '211110')?_c('td',[_c('form-field',{attrs:{"type":"value","col":"","nolabel":true,"precision":2},model:{value:(it.vbc),callback:function ($$v) {_vm.$set(it, "vbc", $$v)},expression:"it.vbc"}})],1):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '211110')?_c('td',[_c('form-field',{attrs:{"type":"value","col":"","nolabel":true,"precision":4},model:{value:(it.pcredpres),callback:function ($$v) {_vm.$set(it, "pcredpres", $$v)},expression:"it.pcredpres"}})],1):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '211110')?_c('td',[_c('form-field',{attrs:{"type":"select","col":"","nolabel":true,"metadata":_vm.metadata.nfit.ccredpres},model:{value:(it.ccredpres),callback:function ($$v) {_vm.$set(it, "ccredpres", $$v)},expression:"it.ccredpres"}})],1):_vm._e(),_vm._v(" "),(['211110', '211130', '211140', '211150', '112120', '112130', '112140', '211124'].includes(_vm.tpEventoSelecionado))?_c('td',[_c('form-field',{attrs:{"type":"value","col":"","nolabel":true,"precision":2},model:{value:(it.vibs),callback:function ($$v) {_vm.$set(it, "vibs", $$v)},expression:"it.vibs"}})],1):_vm._e(),_vm._v(" "),(['211110', '211130', '211140', '211150', '112120', '112130', '112140', '211124'].includes(_vm.tpEventoSelecionado))?_c('td',[_c('form-field',{attrs:{"type":"value","col":"","nolabel":true,"precision":2},model:{value:(it.vcbs),callback:function ($$v) {_vm.$set(it, "vcbs", $$v)},expression:"it.vcbs"}})],1):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '211130')?_c('td',[_c('form-field',{attrs:{"type":"value","col":"","nolabel":true,"precision":4},model:{value:(it.qimob),callback:function ($$v) {_vm.$set(it, "qimob", $$v)},expression:"it.qimob"}})],1):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '211140')?_c('td',[_c('form-field',{attrs:{"type":"value","col":"","nolabel":true,"precision":4},model:{value:(it.qcomb),callback:function ($$v) {_vm.$set(it, "qcomb", $$v)},expression:"it.qcomb"}})],1):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '112120')?_c('td',[_c('form-field',{attrs:{"type":"value","col":"","nolabel":true,"precision":4},model:{value:(it.qcomb),callback:function ($$v) {_vm.$set(it, "qcomb", $$v)},expression:"it.qcomb"}})],1):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '112120')?_c('td',[_c('form-field',{attrs:{"type":"text","col":"","nolabel":true,"placeholder":"Ex: UN"},model:{value:(it.ucomb),callback:function ($$v) {_vm.$set(it, "ucomb", $$v)},expression:"it.ucomb"}})],1):_vm._e(),_vm._v(" "),(['112130', '211124'].includes(_vm.tpEventoSelecionado))?_c('td',[_c('form-field',{attrs:{"type":"value","col":"","nolabel":true,"precision":4},model:{value:(it.qperecimento),callback:function ($$v) {_vm.$set(it, "qperecimento", $$v)},expression:"it.qperecimento"}})],1):_vm._e(),_vm._v(" "),(['112130', '211124'].includes(_vm.tpEventoSelecionado))?_c('td',[_c('form-field',{attrs:{"type":"text","col":"","nolabel":true,"placeholder":"Ex: UN"},model:{value:(it.uperecimento),callback:function ($$v) {_vm.$set(it, "uperecimento", $$v)},expression:"it.uperecimento"}})],1):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '112130')?_c('td',[_c('form-field',{attrs:{"type":"value","col":"","nolabel":true,"precision":2},model:{value:(it.vestornoibs),callback:function ($$v) {_vm.$set(it, "vestornoibs", $$v)},expression:"it.vestornoibs"}})],1):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '112130')?_c('td',[_c('form-field',{attrs:{"type":"value","col":"","nolabel":true,"precision":2},model:{value:(it.vestornocbs),callback:function ($$v) {_vm.$set(it, "vestornocbs", $$v)},expression:"it.vestornocbs"}})],1):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '112140')?_c('td',[_c('form-field',{attrs:{"type":"value","col":"","nolabel":true,"precision":4},model:{value:(it.qnaofornecida),callback:function ($$v) {_vm.$set(it, "qnaofornecida", $$v)},expression:"it.qnaofornecida"}})],1):_vm._e(),_vm._v(" "),(_vm.tpEventoSelecionado === '112140')?_c('td',[_c('form-field',{attrs:{"type":"text","col":"","nolabel":true,"placeholder":"Ex: UN"},model:{value:(it.unaofornecida),callback:function ($$v) {_vm.$set(it, "unaofornecida", $$v)},expression:"it.unaofornecida"}})],1):_vm._e()])}),0)])])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"label":"Enviar Evento NF-e","icon":"fa-paper-plane","nb-btdef":true},on:{"click":_vm.handleEnviar}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar","icon":"fa-times"},on:{"click":_vm.handleClose}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.formIncluir && _vm.nfit.length)?_c('div',{staticClass:"w-100 text-center",staticStyle:{"position":"fixed","left":"0","bottom":"0","z-index":"10","border-top":"1px solid #eee","background-color":"#fdfbfb","padding":"15px","-webkit-box-shadow":"0 -2px 5px rgba(0,0,0,0.2)","-moz-box-shadow":"0 -2px 5px rgba(0,0,0,0.2)","box-shadow":"0 -2px 5px rgba(0,0,0,0.2)"}},[(!_vm.isView)?_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.nf.stnf == '00'),expression:"nf.stnf == '00'"}],attrs:{"label":"Totalizar","title":"","icon":"fa-dollar","nb-btdef":true},on:{"click":_vm.handleTotalizar}}):_vm._e(),_vm._v(" "),(_vm.nf.stnf === '01' || _vm.nf.stnf === '50')?_c('v-button',{attrs:{"label":"Salvar e Fechar","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleTotalizar(true)}}}):_vm._e(),_vm._v(" "),((_vm.nfAguardando))?_c('v-button',{attrs:{"label":"Visualizar Pré Nota"},on:{"click":function($event){return _vm.handleActions(11)}}}):_vm._e(),_vm._v(" "),(_vm.entradaArmazenamentoPendente)?_c('v-button',{attrs:{"label":"Armazenar Nota","title":"","icon":""},on:{"click":_vm.handleArmazenarEntrada}}):_vm._e(),_vm._v(" "),(_vm.saidaEstoquePendente)?_c('v-button',{attrs:{"label":"Baixar Estoque","title":"","icon":""},on:{"click":_vm.handleEstoqueSaida}}):_vm._e(),_vm._v(" "),(_vm.nfAguardando)?_c('v-button',{attrs:{"label":"Autorizar","icon":"fa-rss-square"},on:{"click":function($event){return _vm.handleActions(7)}}}):_vm._e(),_vm._v(" "),(_vm.nfAutorizada)?_c('v-button',{attrs:{"label":"Danfe"},on:{"click":function($event){return _vm.handleActions(2)}}}):_vm._e(),_vm._v(" "),(_vm.nfAutorizada)?_c('v-button',{attrs:{"label":"Enviar E-mail","icon":"fa-envelope-open"},on:{"click":function($event){return _vm.handleActions(1)}}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.formIncluir)?_c('div',[_c('div',{staticClass:"default-container mt-2"},[_c('div',{staticClass:"row align-items-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{staticClass:"float-right",attrs:{"label":"Continuar","title":"","nb-btdef":true},on:{"click":_vm.handleIncluir}}),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar","title":"","icon":"fa-arrow-left"},on:{"click":_vm.handleRetorna}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col"},[(_vm.errmessages.errmessages)?_c('validation',{attrs:{"title":"Erros de Validação","messages":_vm.errmessages.errmessages}}):_vm._e()],1)]),_vm._v(" "),_c('label-title',{attrs:{"title":_vm.titleParticipante,"icon":"fa-university"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('input-part',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codpart.validator),expression:"metadata.nf.codpart.validator"}],ref:"organizacao",attrs:{"participante":true,"add-button":true,"id":"part","name":"Cliente/Fornecedor","v-errors":_vm.errors},model:{value:(_vm.nf.codpart),callback:function ($$v) {_vm.$set(_vm.nf, "codpart", $$v)},expression:"nf.codpart"}})],1)]),_vm._v(" "),(_vm.nf.operacaonf == 'E')?_c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.emissaopropria.validator),expression:"metadata.nf.emissaopropria.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.emissaopropria,"name":"emissaopropria","v-errors":_vm.errors},model:{value:(_vm.nf.emissaopropria),callback:function ($$v) {_vm.$set(_vm.nf, "emissaopropria", $$v)},expression:"nf.emissaopropria"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.data.validator),expression:"metadata.nf.data.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.nf.data,"name":"data","v-errors":_vm.errors},model:{value:(_vm.nf.data),callback:function ($$v) {_vm.$set(_vm.nf, "data", $$v)},expression:"nf.data"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.dtent.validator),expression:"metadata.nf.dtent.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.nf.dtent,"name":"dtent","v-errors":_vm.errors},model:{value:(_vm.nf.dtent),callback:function ($$v) {_vm.$set(_vm.nf, "dtent", $$v)},expression:"nf.dtent"}}),_vm._v(" "),(_vm.nf.emissaopropria == 'N' && _vm.nf.entradaarmazenamento != 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.serie.validator),expression:"metadata.nf.serie.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.nf.serie,"name":"serie","v-errors":_vm.errors},model:{value:(_vm.nf.serie),callback:function ($$v) {_vm.$set(_vm.nf, "serie", $$v)},expression:"nf.serie"}}):_vm._e(),_vm._v(" "),(_vm.nf.emissaopropria == 'N' && _vm.nf.entradaarmazenamento != 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.nf.validator),expression:"metadata.nf.nf.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.nf.nf,"name":"nf","v-errors":_vm.errors},model:{value:(_vm.nf.nf),callback:function ($$v) {_vm.$set(_vm.nf, "nf", $$v)},expression:"nf.nf"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.nf.emissaopropria == 'N' && _vm.nf.entradaarmazenamento != 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.chave.validator),expression:"metadata.nf.chave.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.nf.chave,"name":"chave","v-errors":_vm.errors},model:{value:(_vm.nf.chave),callback:function ($$v) {_vm.$set(_vm.nf, "chave", $$v)},expression:"nf.chave"}}):_vm._e()],1),_vm._v(" "),(_vm.nf.entradaarmazenamento != 'S')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codnates.validator),expression:"metadata.nf.codnates.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.nf.codnates,"add-button":true,"name":"codnates","id":"codnates","v-errors":_vm.errors,"select2":{ entity: 'nates/entrada', minlength: 0 }},on:{"clickAdd":function($event){return _vm.handleIncluirNates()}},model:{value:(_vm.nf.codnates),callback:function ($$v) {_vm.$set(_vm.nf, "codnates", $$v)},expression:"nf.codnates"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.cfop.validator),expression:"metadata.nf.cfop.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.nf.cfop,"name":"cfop","id":"cfop","v-errors":_vm.errors,"select2":{ entity: 'cfop/entradas', minlength: 0 }},model:{value:(_vm.nf.cfop),callback:function ($$v) {_vm.$set(_vm.nf, "cfop", $$v)},expression:"nf.cfop"}})],1):_vm._e(),_vm._v(" "),(_vm.nf.operacaonf == 'E' && _vm.nf.entradaarmazenamento != 'S' && (_vm.nf.tpnf === 'CR' || _vm.nf.tpnf === 'DB'))?_c('div',{staticClass:"row"},[(_vm.nf.tpnf === 'CR')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.tpnfcredito,"name":"tpnfcredito","v-errors":_vm.errors},model:{value:(_vm.nf.tpnfcredito),callback:function ($$v) {_vm.$set(_vm.nf, "tpnfcredito", $$v)},expression:"nf.tpnfcredito"}}):_vm._e(),_vm._v(" "),(_vm.nf.tpnf === 'DB')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.tpnfdebito,"name":"tpnfdebito","v-errors":_vm.errors},model:{value:(_vm.nf.tpnfdebito),callback:function ($$v) {_vm.$set(_vm.nf, "tpnfdebito", $$v)},expression:"nf.tpnfdebito"}}):_vm._e()],1):_vm._e()]):_c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.dtsai.validator),expression:"metadata.nf.dtsai.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.nf.dtsai,"name":"dtsai","v-errors":_vm.errors},model:{value:(_vm.nf.dtsai),callback:function ($$v) {_vm.$set(_vm.nf, "dtsai", $$v)},expression:"nf.dtsai"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.nfVendaLivre),expression:"nfVendaLivre"},{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codnates.validator),expression:"metadata.nf.codnates.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.nf.codnates,"add-button":true,"name":"codnates","id":"codnates","v-errors":_vm.errors,"select2":{ entity: 'nates/venda', minlength: 0 }},on:{"clickAdd":function($event){return _vm.handleIncluirNates()}},model:{value:(_vm.nf.codnates),callback:function ($$v) {_vm.$set(_vm.nf, "codnates", $$v)},expression:"nf.codnates"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"show",rawName:"v-show",value:(!_vm.nfVendaLivre),expression:"!nfVendaLivre"},{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codnates.validator),expression:"metadata.nf.codnates.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.nf.codnates,"add-button":true,"name":"codnotes","id":"codnates","v-errors":_vm.errors,"select2":{ entity: 'nates/saida/outras', minlength: 0 }},on:{"clickAdd":function($event){return _vm.handleIncluirNates()}},model:{value:(_vm.nf.codnates),callback:function ($$v) {_vm.$set(_vm.nf, "codnates", $$v)},expression:"nf.codnates"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.cfop.validator),expression:"metadata.nf.cfop.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.nf.cfop,"name":"cfop","id":"cfop","v-errors":_vm.errors,"select2":{ entity: 'cfop/saidas', minlength: 0 }},model:{value:(_vm.nf.cfop),callback:function ($$v) {_vm.$set(_vm.nf, "cfop", $$v)},expression:"nf.cfop"}})],1),_vm._v(" "),(_vm.nfVendaLivre)?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.finalidade},model:{value:(_vm.nf.finalidade),callback:function ($$v) {_vm.$set(_vm.nf, "finalidade", $$v)},expression:"nf.finalidade"}}),_vm._v(" "),(_vm.nf.tpnf === 'CR')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.tpnfcredito,"name":"tpnfcredito","v-errors":_vm.errors},model:{value:(_vm.nf.tpnfcredito),callback:function ($$v) {_vm.$set(_vm.nf, "tpnfcredito", $$v)},expression:"nf.tpnfcredito"}}):_vm._e(),_vm._v(" "),(_vm.nf.tpnf === 'DB')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.tpnfdebito,"name":"tpnfdebito","v-errors":_vm.errors},model:{value:(_vm.nf.tpnfdebito),callback:function ($$v) {_vm.$set(_vm.nf, "tpnfdebito", $$v)},expression:"nf.tpnfdebito"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.nfVendaLivre && (_vm.nf.tpnf === 'CR' || _vm.nf.tpnf === 'DB'))?_c('div',{staticClass:"row"},[(_vm.nf.tpnf === 'CR')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.tpnfcredito,"name":"tpnfcredito","v-errors":_vm.errors},model:{value:(_vm.nf.tpnfcredito),callback:function ($$v) {_vm.$set(_vm.nf, "tpnfcredito", $$v)},expression:"nf.tpnfcredito"}}):_vm._e(),_vm._v(" "),(_vm.nf.tpnf === 'DB')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.tpnfdebito,"name":"tpnfdebito","v-errors":_vm.errors},model:{value:(_vm.nf.tpnfdebito),callback:function ($$v) {_vm.$set(_vm.nf, "tpnfdebito", $$v)},expression:"nf.tpnfdebito"}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.possuiNForigem()),expression:"possuiNForigem()"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.codnatesret,"select2":{ entity: 'nates/saida/retorno', minlength: 0 }},model:{value:(_vm.nf.codnatesret),callback:function ($$v) {_vm.$set(_vm.nf, "codnatesret", $$v)},expression:"nf.codnatesret"}})],1),_vm._v(" "),_c('div',{staticClass:"row mb-2"}),_vm._v(" "),(_vm.showNfRef())?_c('nf-form-ref',{attrs:{"nfref":_vm.nfref,"nf":_vm.nf}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formNF),expression:"formNF"}],attrs:{"id":"formNF"}},[_c('div',{staticClass:"default-container mt-2"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.nf.esp == '65')?_c('span',{staticClass:"badge badge-blue mr-2"},[_vm._v("NFC-e")]):_vm._e(),(_vm.nf.esp == '59')?_c('span',{staticClass:"badge badge-blue mr-2"},[_vm._v("SAT")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"float-right"},[_c('v-button',{attrs:{"label":"Retornar","title":"","icon":"fa-arrow-left"},on:{"click":_vm.handleRetorna}}),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.nf.stnf == '11' && _vm.nf.flagarmazenada != 'S'),expression:"nf.stnf == '11' && nf.flagarmazenada != 'S'"}],attrs:{"label":"Editar","title":"Editar nota fiscal","icon":"fa-pencil","nb-btdef":true},on:{"click":_vm.handleEditar}}),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.moreActions.length > 0),expression:"moreActions.length > 0"}],attrs:{"label":"Mais Ações","actions":_vm.moreActions},on:{"click":_vm.handleActions}})],1)])]),_vm._v(" "),(_vm.nf.entradaarmazenamento != 'S')?_c('div',{staticClass:"row mb-2 align-items-center",staticStyle:{"background-color":"#f9f9f9"}},[_c('div',{staticClass:"col"},[_c('v-label',{attrs:{"label":"Série"}}),_vm._v(" "),_c('span',{staticClass:"lbl-total-documento",staticStyle:{"font-size":"24px","padding":"5px","background-color":"#f9f9f9"}},[_vm._v(_vm._s(_vm.nf.serie))]),_vm._v(" "),_c('v-label',{attrs:{"label":"Número"}}),_vm._v(" "),_c('span',{staticClass:"lbl-total-documento",staticStyle:{"font-size":"24px","padding":"5px","background-color":"#f9f9f9"}},[_vm._v(_vm._s(_vm.nf.nf))]),_vm._v(" "),(_vm._alteraNumero)?_c('a',{staticClass:"w-100",staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleUpdateNumero}},[_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}}),_vm._v(" Alterar numeração desta\n            nota")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col text-right"},[(_vm.nf.stnf == '00')?_c('span',{staticClass:"badge badge-orange mr-2"},[_vm._v(_vm._s(_vm._f("getTextOption")(_vm.nf.stnf,_vm.metadata.nf.stnf)))]):_vm._e(),_vm._v(" "),(_vm.nf.stnf == '01' || _vm.nf.stnf == '02')?_c('span',{staticClass:"badge badge-blue mr-2"},[_vm._v(_vm._s(_vm._f("getTextOption")(_vm.nf.stnf,_vm.metadata.nf.stnf)))]):_vm._e(),_vm._v(" "),(_vm.nf.stnf == '10' || _vm.nf.stnf == '11')?_c('span',{staticClass:"badge badge-green mr-2"},[_vm._v(_vm._s(_vm._f("getTextOption")(_vm.nf.stnf,_vm.metadata.nf.stnf)))]):_vm._e(),_vm._v(" "),(_vm.nf.stnf >= '50')?_c('span',{staticClass:"badge badge-red mr-2"},[_vm._v(_vm._s(_vm._f("getTextOption")(_vm.nf.stnf,_vm.metadata.nf.stnf)))]):_vm._e(),_vm._v(" "),(_vm.nf.emissaopropria == 'S')?_c('span',{staticClass:"badge badge-yellow mr-2"},[_vm._v("Nota Fiscal Própria")]):_vm._e(),_vm._v(" "),(_vm.nf.carta_correcao > 0)?_c('span',{staticClass:"badge badge-yellow mr-2"},[_vm._v("Carta de Correção")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-4 col-6 d-flex align-items-center"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.data}}),_vm._v(" "),_c('strong',{},[_vm._v(_vm._s(_vm._f("formatData")(_vm.nf.data)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6 d-flex align-items-center"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.datalancamento}}),_vm._v(" "),_c('strong',{},[_vm._v(_vm._s(_vm._f("formatData")(_vm.nf.datalancamento)))])],1),_vm._v(" "),(_vm.nf.operacaonf != 'E')?_c('div',{staticClass:"col-md-4 col-6 d-flex align-items-center"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.dtsai}}),_vm._v(" "),_c('strong',{},[_vm._v(_vm._s(_vm._f("formatData")(this.nf.dtsai)))])],1):_c('div',{staticClass:"col-md-4 col-6 d-flex align-items-center"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.dtent}}),_vm._v(" "),_c('strong',{},[_vm._v(_vm._s(_vm._f("formatData")(this.nf.dtent)))])],1),_vm._v(" "),(_vm.nf.nates)?_c('div',{staticClass:"col-md-4 col-6 d-flex align-items-center"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.codnates}}),_vm._v(" "),_c('strong',{},[_vm._v(" "+_vm._s(_vm.selectedNates.descricao)+" ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6 d-flex align-items-center"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.finalidade}}),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm._f("getTextOption")(_vm.nf.finalidade,_vm.metadata.nf.finalidade)))])],1),_vm._v(" "),(_vm.nf.tpnf === 'CR')?_c('div',{staticClass:"col-md-4 col-6 d-flex align-items-center"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.tpnfcredito}}),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm._f("getTextOption")(_vm.nf.tpnfcredito,_vm.metadata.nf.tpnfcredito)))])],1):_vm._e(),_vm._v(" "),(_vm.nf.tpnf === 'DB')?_c('div',{staticClass:"col-md-4 col-6 d-flex align-items-center"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.tpnfdebito}}),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm._f("getTextOption")(_vm.nf.tpnfdebito,_vm.metadata.nf.tpnfdebito)))])],1):_vm._e(),_vm._v(" "),(_vm.nf.xmotivo && _vm.nf.stnf != '10')?_c('div',{staticClass:"col-6 error"},[_vm._v(" "+_vm._s(_vm.nf.xmotivo)+" ")]):_vm._e(),_vm._v(" "),(_vm.nf.npedido)?_c('div',{staticClass:"col-md-4 col-3 d-flex align-items-center my-2"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedv.npedido}}),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm.nf.npedido))])],1):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label-title',{attrs:{"title":_vm.titleParticipante,"icon":"fa-university"}}),_vm._v(" "),_c('div',{staticClass:"row col mb-2"},[_c('input-part',{ref:"part",attrs:{"participante":true,"disabled":(_vm.isView || _vm.nf.codpedv || (this.nf.flagarmazenada == 'S') || (this.nf.flagestoquebaixado == 'S')),"showMsgEmail":(_vm.nf.operacaonf != 'E')},model:{value:(_vm.nf.codpart),callback:function ($$v) {_vm.$set(_vm.nf, "codpart", $$v)},expression:"nf.codpart"}})],1),_vm._v(" "),(_vm.errmessages.errmessages)?_c('validation',{attrs:{"title":"Erros de Validação","messages":_vm.errmessages.errmessages}}):_vm._e(),_vm._v(" "),(_vm.nf.fin_baixado)?_c('div',[_c('alert',{attrs:{"type":"info","title":"Aviso","text":"Esta nota fiscal possui títulos baixados."}})],1):_vm._e(),_vm._v(" "),(_vm.nfPossuiEvento)?_c('div',[_c('alert',{attrs:{"type":"info","title":"Aviso","text":"Esta nota fiscal possui eventos vinculados."}})],1):_vm._e(),_vm._v(" "),(_vm.entradaArmazenamentoPendente)?_c('div',[_c('alert',{attrs:{"type":"info","text":_vm.entradaArmazenamentoPendente}})],1):_vm._e(),_vm._v(" "),(_vm.entradaArmazenamentoConcluido)?_c('div',[_c('alert',{attrs:{"type":"info","title":"Aviso","text":_vm.entradaArmazenamentoConcluido}})],1):_vm._e(),_vm._v(" "),(_vm.saidaEstoquePendente)?_c('div',[_c('alert',{attrs:{"type":"info","text":_vm.saidaEstoquePendente}})],1):_vm._e(),_vm._v(" "),(_vm.saidaEstoqueBaixado)?_c('div',[_c('alert',{attrs:{"type":"info","title":"Aviso","text":_vm.saidaEstoqueBaixado}})],1):_vm._e(),_vm._v(" "),_c('tabs',{attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}})],1),_vm._v(" "),(this.nfref.length > 0)?_c('div',{staticClass:"default-container nb-margin-top",staticStyle:{"border-top":"3px solid black"}},[_c('div',{staticClass:"row col"},[_c('label-title',{attrs:{"title":"Notas Fiscais Referenciadas","icon":"fa-info-circle"}}),_vm._v(" "),(!_vm.isView)?_c('a',{staticClass:"ml-3 mt-3",staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){_vm.editNfRef = !_vm.editNfRef}}},[_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true","data-toggle":"tooltip","data-placement":"top","title":"Alterar dados"}})]):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.editNfRef),expression:"!editNfRef"}]},_vm._l((_vm.nfref),function(nf){return _c('div',{key:nf.itref,staticClass:"mainbox"},[_c('div',{staticClass:"mark-gray"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-5 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.chave}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(nf.chave))])],1),_vm._v(" "),(nf.serie)?_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.serie}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(nf.serie))])],1):_vm._e(),_vm._v(" "),(nf.nf)?_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.nf}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(nf.nf))])],1):_vm._e(),_vm._v(" "),(_vm.isNfRefLinked(nf))?_c('div',{staticClass:"col-md-3 col-3 d-flex align-items-center justify-content-end pr-4"},[_vm._m(1,true)]):_vm._e()])])])}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.editNfRef),expression:"editNfRef"}]},[(_vm.showNfRef())?_c('nf-form-ref',{attrs:{"nfref":_vm.nfref,"nf":_vm.nf,"title":false}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"default-container nb-margin-top",staticStyle:{"border-top":"3px solid black"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab == 0),expression:"activeTab == 0"}]},[_c('label-title',{attrs:{"title":'Produtos (' + _vm.nfit.length + ')',"icon":"fa-archive"}}),_vm._v(" "),(_vm.habilitaBotaoProduto)?_c('div',{staticClass:"row col"},[_c('v-button',{ref:"incluirProduto",attrs:{"label":"Incluir Produto","title":"","nb-btdef":true,"icon":"fa-plus"},on:{"click":_vm.handleIncluirItem,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleIncluirItem.apply(null, arguments)}}})],1):_vm._e(),_vm._v(" "),_c('div',_vm._l((_vm.nfit),function(it,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"mark-gray"}),_vm._v(" "),_c('div',{staticClass:"box pl-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-6 row"},[_c('div',{staticClass:"col-md-6 col-auto"},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(it.item[0].descricao))]),_vm._v(" "),_c('v-label',{staticClass:"d-none d-md-inline",attrs:{"label":"Seq"}}),_vm._v(" "),_c('span',{staticClass:"lbl d-none d-md-inline"},[_vm._v(_vm._s(it.itnf))]),_vm._v(" "),_c('v-label',{attrs:{"label":"Codigo"}}),_vm._v(" "),_c('span',{staticClass:"lbl break-words text-break",staticStyle:{"word-break":"break-all !important","white-space":"wrap !important"}},[_vm._v(_vm._s(it.item[0].codigo))]),_vm._v(" "),_c('v-label',{staticClass:"d-none d-md-inline",attrs:{"label":"ST"}}),_vm._v(" "),(it.sticm && (_vm.nf.filial[0].crt != 1) && (_vm.nf.filial[0].crt != 4))?_c('span',{staticClass:"data-list d-none d-md-inline"},[_vm._v(_vm._s(it.sticm))]):_c('span',{staticClass:"data-list d-none d-md-inline"},[_vm._v(_vm._s(it.csosn))]),_vm._v(" "),_c('v-label',{staticClass:"d-none d-md-inline",attrs:{"label":"CFOP"}}),_vm._v(" "),_c('span',{staticClass:"data-list d-none d-md-inline"},[_vm._v(_vm._s(it.cfop))]),_vm._v(" "),_c('v-label',{staticClass:"d-none d-md-inline",attrs:{"label":"% ICMS"}}),_vm._v(" "),_c('span',{staticClass:"data-list d-none d-md-inline"},[_vm._v(_vm._s(_vm._f("formatValue")(it.aicm,2)))]),_vm._v(" "),_c('v-label',{staticClass:"d-none d-md-inline",attrs:{"label":"% ST"}}),_vm._v(" "),_c('span',{staticClass:"data-list d-none d-md-inline"},[_vm._v(_vm._s(_vm._f("formatValue")(it.aicmst,2)))]),_vm._v(" "),_c('v-label',{staticClass:"d-none d-md-inline",attrs:{"label":"%IPI"}}),_vm._v(" "),_c('span',{staticClass:"data-list d-none d-md-inline"},[_vm._v(_vm._s(_vm._f("formatValue")(it.aipi,2)))]),_vm._v(" "),(it.codregraimp)?_c('v-label',{staticClass:"d-none d-md-inline",attrs:{"label":"Regra"}}):_vm._e(),_vm._v(" "),(it.codregraimp)?_c('span',{staticClass:"data-list d-none d-md-inline"},[_vm._v(_vm._s(it.codregraimp))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-auto"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfit.qtuni}}),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(it.qtuni)+" "+_vm._s(it.uni))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-auto"},[_c('v-label',{attrs:{"label":"Preço"}}),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm._f("formatValue")(it.vlr,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-auto d-none d-md-flex align-item-start order-last ml-md-auto"},[_c('bar-grid',{attrs:{"options":{ barDefault: true, btnView: true, btnEdit: _vm.editItem, btnDelete: _vm.deleteItem },"moreActions":{}},on:{"edit":function($event){return _vm.handleEditItem(it.itnf, false)},"view":function($event){return _vm.handleEditItem(it.itnf, true)},"delete":function($event){return _vm.handleDeleteItemMsg(index)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-6 d-flex d-md-none flex-wrap align-items-center justify-content-end order-last ml-md-auto"},[_c('bar-grid',{attrs:{"options":{ barDefault: true, btnView: false, btnEdit: _vm.editItem, btnDelete: _vm.deleteItem },"moreActions":{}},on:{"edit":function($event){return _vm.handleEditItem(it.itnf, false)},"delete":function($event){return _vm.handleDeleteItemMsg(index)}}})],1)])])])}),0),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.nfit.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-12"},[_c('div',[_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){_vm.showTotal = true}}},[_vm._v("Detalhar Totais")])]),_vm._v(" "),(_vm.showTotal)?_c('div',{staticClass:"dropdown-total col-md-8 col-12",staticStyle:{"padding":"15px"}},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){_vm.showTotal = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"row col mb-2"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.bcicm}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.bcicm,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.toticm}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.toticm,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.totfcp}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.totfcp,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.bcicmst}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.bcicmst,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.toticmst}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.toticmst,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.toticmdeson}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.toticmdeson,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.totfcpst}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.totfcpst,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.totipi}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.totipi,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.totipidevol}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.totipidevol,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.toticmemit}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.toticmemit,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.toticmdest}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.toticmdest,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.totfcpdest}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.totfcpdest,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.bcpis}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.bcpis,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.totpis}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.totpis,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.totpisst}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.totpisst,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.bccofins}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.bccofins,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.totcofins}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.totcofins,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.totcofinsst}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.totcofinsst,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.vretirrf}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.vretirrf,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.vretcsll}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.vretcsll,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.vretinss}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.vretinss,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.vretpis}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.vretpis,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.vretcofins}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.vretcofins,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.totii}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.totii,2)))])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('table',{staticClass:"table table-sm",staticStyle:{"margin-left":"0","width":"100%"}},[_c('tbody',[(_vm.nf.totret)?_c('tr',[_c('th',[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totret}})],1),_vm._v(" "),_c('th',[_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.totret,2)))])])]):_vm._e(),_vm._v(" "),_c('tr',[_c('th',[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totmer}})],1),_vm._v(" "),_c('th',[_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.totmer,2)))])])]),_vm._v(" "),(_vm.nf.toticm)?_c('tr',[_c('th',[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.toticm}})],1),_vm._v(" "),_c('th',[_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.toticm,2)))])])]):_vm._e(),_vm._v(" "),(_vm._toticmsst)?_c('tr',[_c('th',[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.toticmst}})],1),_vm._v(" "),_c('th',[_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm._toticmsst,2)))])])]):_vm._e(),_vm._v(" "),(_vm.nf.totipi)?_c('tr',[_c('th',[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totipi}})],1),_vm._v(" "),_c('th',[_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.totipi,2)))])])]):_vm._e(),_vm._v(" "),(_vm.nf.totipidevol)?_c('tr',[_c('th',[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totipidevol}})],1),_vm._v(" "),_c('th',[_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.totipidevol,2)))])])]):_vm._e(),_vm._v(" "),(_vm.nf.vlrfre)?_c('tr',[_c('th',[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.vlrfre}})],1),_vm._v(" "),_c('th',[_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.vlrfre,2)))])])]):_vm._e(),_vm._v(" "),(_vm.nf.vlrdesp)?_c('tr',[_c('th',[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.vlrdesp}})],1),_vm._v(" "),_c('th',[_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.vlrdesp,2)))])])]):_vm._e(),_vm._v(" "),(_vm.nf.vlrseg)?_c('tr',[_c('th',[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.vlrseg}})],1),_vm._v(" "),_c('th',[_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.vlrseg,2)))])])]):_vm._e(),_vm._v(" "),(_vm.nf.totdes)?_c('tr',[_c('th',[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totdes}})],1),_vm._v(" "),_c('th',[_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.totdes,2)))])])]):_vm._e(),_vm._v(" "),(_vm.nf.totdup)?_c('tr',[_c('th',[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totdup}})],1),_vm._v(" "),_c('th',[_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.totdup,2)))])])]):_vm._e(),_vm._v(" "),_c('tr',[_c('th',[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totger}})],1),_vm._v(" "),_c('th',[_c('span',{staticClass:"lbl-total-documento float-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.totger,2)))])])])])])])]):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab == 1),expression:"activeTab == 1"}]},[(_vm.nf.nfxml && _vm.nf.nfxml.length > 0 && _vm.nf.nfxml[0].nprotcan)?_c('div',{staticClass:"mainbox"},[_c('div',{staticClass:"mark-green"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.dtcan}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.nf.dtcan)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfxml.nprot}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.nf.nfxml[0].nprotcan))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.obscan}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.nf.obscan)+" ")])],1)])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.nfPossuiEvento)?_c('div',[_c('alert',{attrs:{"type":"info","title":"Aviso","text":"Esta nota fiscal ainda não possui eventos vinculados."}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.nf.nfev),function(ev,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"mark-green"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-2 col-12"},[_c('label',[_vm._v("Data")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(ev.data)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('label',[_vm._v("Código do Evento")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_c('strong',[_vm._v(_vm._s(ev.tpeventonfe))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12"},[_c('label',[_vm._v("Tipo do Evento")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.getDescricaoEvento(ev.tpeventonfe)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('label',[_vm._v("Protocolo")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ev.nprot)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-12"},[(!_vm.isEventoCancelado(ev))?_c('span',{staticClass:"badge badge-success",staticStyle:{"background-color":"#2e7d32","color":"white","font-size":"0.75rem"}},[_vm._v("Autorizado")]):_c('span',{staticClass:"badge badge-danger",staticStyle:{"background-color":"#c62828","color":"white","font-size":"0.75rem"}},[_vm._v("Cancelado")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12 d-flex justify-content-end align-items-center"},[(ev.tpeventonfe !== '110001' && ev.tpeventonfe !== '110111' && !_vm.isEventoCancelado(ev))?_c('v-button',{staticClass:"btn-sm ml-2",attrs:{"label":"","icon":"fa-trash","title":"Cancelar este Evento na SEFAZ"},on:{"click":function($event){return _vm.handleCancelarEvento(ev)}}}):_vm._e(),_vm._v(" "),_c('v-button',{staticClass:"btn-sm",attrs:{"label":"","icon":"fa-download","title":"Baixar XML Protocolado"},on:{"click":function($event){return _vm.downloadXmlEvento(ev, 'PROT')}}})],1)]),_vm._v(" "),(ev.texto)?_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('label',[_vm._v("Histórico / Justificativa")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ev.texto)+" ")])])]):_vm._e(),_vm._v(" "),(ev.tpeventonfe === '110001' && ev.tpeventoaut)?_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"data-list",staticStyle:{"color":"#c62828"}},[_c('i',{staticClass:"fa fa-info-circle mr-1"}),_vm._v(" "),_c('strong',[_vm._v("Evento Original Cancelado:")]),_vm._v(" "+_vm._s(ev.tpeventoaut)+" - "+_vm._s(_vm.getDescricaoEvento(ev.tpeventoaut))+"\n                  "),_c('span',{staticClass:"mx-2"},[_vm._v("|")]),_vm._v(" "),_c('strong',[_vm._v("Protocolo Original:")]),_vm._v(" "+_vm._s(ev.nprotevento)+"\n                ")])])]):_vm._e()])])})],2)]),_vm._v(" "),_c('div',{staticClass:"default-container nb-margin-top",staticStyle:{"border-top":"3px solid black"}},[_c('label-title',{attrs:{"title":"Desconto"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.vlrdesc.validator),expression:"metadata.nf.vlrdesc.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vlrdesc,"disabled":_vm.isView,"name":"vlrdesc","v-errors":_vm.errors},on:{"input":function($event){return _vm.handleChangeValores()}},model:{value:(_vm.nf.vlrdesc),callback:function ($$v) {_vm.$set(_vm.nf, "vlrdesc", $$v)},expression:"nf.vlrdesc"}})],1),_vm._v(" "),(_vm.habilitaDuplicata)?_c('div',{staticClass:"mb-b mt-2"},[_c('label-title',{attrs:{"title":"Condição de Pagamento"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codnatfin.validator),expression:"metadata.nf.codnatfin.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.codnatfin,"disabled":_vm.isView,"name":"codnatfin","v-errors":_vm.errors,"select2":{ entity: (_vm.nf.operacaonf == 'E' ? 'natfin/despesas' : 'natfin/receitas'), minlength: 0 }},model:{value:(_vm.nf.codnatfin),callback:function ($$v) {_vm.$set(_vm.nf, "codnatfin", $$v)},expression:"nf.codnatfin"}}),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('div',{staticClass:"form-group form-group-sm"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.parcelas}}),_vm._v(" "),_c('div',{staticClass:"input-group input-group-sm"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.parcelas),expression:"parcelas"}],ref:"parcelas",staticClass:"form-control",attrs:{"disabled":_vm.isView},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.parcelas=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.metadata.nf.parcelas.options),function(opt){return _c('option',{key:opt.id,domProps:{"value":opt.id}},[_vm._v(_vm._s(opt.text)+"\n                  ")])}),0)])],1)]),_vm._v(" "),(_vm.nfpar.length > 0)?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfpar.dias}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfpar.dtv}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfpar.vlr}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfpar.formapag}})],1)]),_vm._v(" "),_vm._l((_vm.nfpar),function(par,index){return _c('div',{key:index,staticClass:"row justify-content-md-center"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfpar.dias.validator),expression:"metadata.nfpar.dias.validator"}],staticClass:"mb-1",attrs:{"type":"number","col":"2","disabled":_vm.isView || _vm.nf.parcelas === '0',"name":"dias","v-errors":_vm.errors},on:{"input":function($event){return _vm.nfparDiasChange(index)}},model:{value:(par.dias),callback:function ($$v) {_vm.$set(par, "dias", $$v)},expression:"par.dias"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfpar.dtv.validator),expression:"metadata.nfpar.dtv.validator"}],staticClass:"mb-1",attrs:{"type":"date","col":"2","disabled":_vm.isView,"name":"dtv","v-errors":_vm.errors},on:{"input":function($event){return _vm.nfparDtvChange(index)}},model:{value:(par.dtv),callback:function ($$v) {_vm.$set(par, "dtv", $$v)},expression:"par.dtv"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfpar.vlr.validator),expression:"metadata.nfpar.vlr.validator"}],staticClass:"mb-1",attrs:{"type":"value","col":"2","precision":2,"disabled":_vm.isView,"name":"vlr","v-errors":_vm.errors},on:{"input":function($event){return _vm.nfparVlrChange(index)}},model:{value:(par.vlr),callback:function ($$v) {_vm.$set(par, "vlr", $$v)},expression:"par.vlr"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.nfpar.formapag,"disabled":_vm.isView,"nolabel":true,"optionnull":true},model:{value:(par.formapag),callback:function ($$v) {_vm.$set(par, "formapag", $$v)},expression:"par.formapag"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(par.error)?_c('div',{staticClass:"col-md-6 mt-n3 mb-2"},[_c('small',{staticClass:"error"},[_vm._v(_vm._s(par.error))])]):_vm._e()],1)})],2):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('label-title',{attrs:{"title":"Transporte"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.tpfrete.validator),expression:"metadata.nf.tpfrete.validator"}],ref:"tpfrete",attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.tpfrete,"disabled":_vm.isView,"name":"tpfrete","v-errors":_vm.errors},model:{value:(_vm.nf.tpfrete),callback:function ($$v) {_vm.$set(_vm.nf, "tpfrete", $$v)},expression:"nf.tpfrete"}})],1),_vm._v(" "),(_vm.nf.tpfrete != '9')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codparttr.validator),expression:"metadata.nf.codparttr.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.codparttr,"name":"codparttr","v-errors":_vm.errors,"disabled":_vm.isView,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluirPart(true)}},model:{value:(_vm.nf.codparttr),callback:function ($$v) {_vm.$set(_vm.nf, "codparttr", $$v)},expression:"nf.codparttr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.placa.validator),expression:"metadata.nf.placa.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.placa,"disabled":_vm.isView,"name":"placa","v-errors":_vm.errors},model:{value:(_vm.nf.placa),callback:function ($$v) {_vm.$set(_vm.nf, "placa", $$v)},expression:"nf.placa"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.placauf.validator),expression:"metadata.nf.placauf.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.placauf,"disabled":_vm.isView,"name":"placauf","v-errors":_vm.errors},model:{value:(_vm.nf.placauf),callback:function ($$v) {_vm.$set(_vm.nf, "placauf", $$v)},expression:"nf.placauf"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.rntc.validator),expression:"metadata.nf.rntc.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.rntc,"disabled":_vm.isView,"name":"rntc","v-errors":_vm.errors},model:{value:(_vm.nf.rntc),callback:function ($$v) {_vm.$set(_vm.nf, "rntc", $$v)},expression:"nf.rntc"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.vlrfre.validator),expression:"metadata.nf.vlrfre.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vlrfre,"disabled":_vm.isView,"name":"vlrfre","v-errors":_vm.errors},on:{"input":function($event){return _vm.handleChangeValores()}},model:{value:(_vm.nf.vlrfre),callback:function ($$v) {_vm.$set(_vm.nf, "vlrfre", _vm._n($$v))},expression:"nf.vlrfre"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.vlrseg.validator),expression:"metadata.nf.vlrseg.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vlrseg,"disabled":_vm.isView,"name":"vlrseg","v-errors":_vm.errors},on:{"input":function($event){return _vm.handleChangeValores()}},model:{value:(_vm.nf.vlrseg),callback:function ($$v) {_vm.$set(_vm.nf, "vlrseg", _vm._n($$v))},expression:"nf.vlrseg"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.vlrdesp.validator),expression:"metadata.nf.vlrdesp.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vlrdesp,"disabled":_vm.isView,"name":"vlrdesp","v-errors":_vm.errors},on:{"input":function($event){return _vm.handleChangeValores()}},model:{value:(_vm.nf.vlrdesp),callback:function ($$v) {_vm.$set(_vm.nf, "vlrdesp", _vm._n($$v))},expression:"nf.vlrdesp"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pliq.validator),expression:"metadata.nf.pliq.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pliq,"disabled":_vm.isView,"name":"pliq","v-errors":_vm.errors},model:{value:(_vm.nf.pliq),callback:function ($$v) {_vm.$set(_vm.nf, "pliq", _vm._n($$v))},expression:"nf.pliq"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pbru.validator),expression:"metadata.nf.pbru.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pbru,"disabled":_vm.isView,"name":"pbru","v-errors":_vm.errors},model:{value:(_vm.nf.pbru),callback:function ($$v) {_vm.$set(_vm.nf, "pbru", _vm._n($$v))},expression:"nf.pbru"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.qtvolumes.validator),expression:"metadata.nf.qtvolumes.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.qtvolumes,"disabled":_vm.isView,"name":"qtvolumes","v-errors":_vm.errors},model:{value:(_vm.nf.qtvolumes),callback:function ($$v) {_vm.$set(_vm.nf, "qtvolumes", _vm._n($$v))},expression:"nf.qtvolumes"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.volespecie.validator),expression:"metadata.nf.volespecie.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.volespecie,"disabled":_vm.isView,"name":"volespecie","v-errors":_vm.errors},model:{value:(_vm.nf.volespecie),callback:function ($$v) {_vm.$set(_vm.nf, "volespecie", $$v)},expression:"nf.volespecie"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.volmarca.validator),expression:"metadata.nf.volmarca.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.volmarca,"disabled":_vm.isView,"name":"volmarca","v-errors":_vm.errors},model:{value:(_vm.nf.volmarca),callback:function ($$v) {_vm.$set(_vm.nf, "volmarca", $$v)},expression:"nf.volmarca"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.volnr.validator),expression:"metadata.nf.volnr.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.volnr,"disabled":_vm.isView,"name":"volnr","v-errors":_vm.errors},model:{value:(_vm.nf.volnr),callback:function ($$v) {_vm.$set(_vm.nf, "volnr", $$v)},expression:"nf.volnr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pedcli.validator),expression:"metadata.nf.pedcli.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.pedcli,"disabled":_vm.isView,"name":"pedcli","v-errors":_vm.errors},model:{value:(_vm.nf.pedcli),callback:function ($$v) {_vm.$set(_vm.nf, "pedcli", $$v)},expression:"nf.pedcli"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Informações Adicionais","icon":"fa-info-circle"}}),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[_c('form-field',{attrs:{"type":"select2","col":"6","metadata":_vm.metadata.nf.obs,"disabled":_vm.isView,"select2":{ entity: 'mennf', minlength: 0 }},model:{value:(_vm.codmenCpl),callback:function ($$v) {_vm.codmenCpl=$$v},expression:"codmenCpl"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select2","col":"6","metadata":_vm.metadata.nf.obsfisco,"disabled":_vm.isView,"select2":{ entity: 'mennf', minlength: 0 }},model:{value:(_vm.codmenFisco),callback:function ($$v) {_vm.codmenFisco=$$v},expression:"codmenFisco"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.nf.obs),expression:"nf.obs"}],staticClass:"form-control",attrs:{"rows":"6","cols":"100","name":"obs","disabled":_vm.isView},domProps:{"value":(_vm.nf.obs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.nf, "obs", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.nf.obsfisco),expression:"nf.obsfisco"}],staticClass:"form-control",attrs:{"rows":"6","cols":"100","name":"obsfisco","disabled":_vm.isView},domProps:{"value":(_vm.nf.obsfisco)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.nf, "obsfisco", $event.target.value)}}})])])]),_vm._v(" "),(_vm.nf.obsauto)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"form-group"},[_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(_vm.nf.obsauto)+" ")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"}),_vm._v(" "),_c('div',{staticClass:"row"},[(!_vm.showNewTaxes && !_vm.isView)?_c('div',{staticClass:"ml-3 mt-2 mb-2"},[_c('a',{attrs:{"href":"javascript:void(0);","tabindex":1},on:{"click":function($event){_vm.showNewTaxes = true}}},[_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" Exibir Nova Tributação (IS, IBS, CBS)\n          ")])]):_vm._e(),_vm._v(" "),(_vm.showNewTaxes || _vm.isView)?_c('div',{staticClass:"col-12"},[_c('label-title',{attrs:{"title":"Impostos Unificados (IBS e CBS)"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.ibscbstotbc}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.ibscbstotbc,2)))])],1)]),_vm._v(" "),_c('label-title',{attrs:{"title":"IBS"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.ibstot}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.ibstot,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.ibsuftot}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.ibsuftot,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.ibsuftotdif}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.ibsuftotdif,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.ibsuftotdevtrib}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.ibsuftotdevtrib,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.ibsmuntot}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.ibsmuntot,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.ibsmuntotdif}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.ibsmuntotdif,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.ibsmuntotdevtrib}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.ibsmuntotdevtrib,2)))])],1)]),_vm._v(" "),_c('label-title',{attrs:{"title":"CBS"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.cbstot}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.cbstot,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.cbstotdif}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.cbstotdif,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.cbstotdevtrib}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.cbstotdevtrib,2)))])],1)]),_vm._v(" "),_c('label-title',{attrs:{"title":"Créditos Presumidos"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.ibstotpres}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.ibstotpres,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.ibstotprescondsus}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.ibstotprescondsus,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.cbstotpres}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.cbstotpres,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.cbstotprescondsus}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.cbstotprescondsus,2)))])],1)]),_vm._v(" "),_c('label-title',{attrs:{"title":"Imposto Seletivo"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.istot}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.istot,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.istotbc}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.istotbc,2)))])],1)]),_vm._v(" "),_c('label-title',{attrs:{"title":"Tributação Monofásica"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.ibstotmono}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.ibstotmono,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.cbstotmono}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.cbstotmono,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.ibstotmonoret}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.ibstotmonoret,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.cbstotmonoret}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.cbstotmonoret,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.ibstotmonoreten}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.ibstotmonoreten,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.cbstotmonoreten}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.cbstotmonoreten,2)))])],1)]),_vm._v(" "),_c('label-title',{attrs:{"title":"Estorno de Crédito"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.ibstotestcred}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.ibstotestcred,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.cbstotestcred}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.cbstotestcred,2)))])],1)])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row col mt-2"},[_c('v-button',{attrs:{"label":"Alterar Outras Informações","title":"","icon":"fa-pencil","nb-btdef":true},on:{"click":_vm.handleAlterarOutras}})],1),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[(_vm.nf.enderet)?_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.nf.enderet}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.nf.enderet)+" "+_vm._s(_vm.nf.endenrret)+" "+_vm._s(_vm.nf.bairroret)+" "+_vm._s(_vm.nf.ufret))])],1):_vm._e(),_vm._v(" "),(_vm.nf.endeent)?_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.nf.endeent}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.nf.endeent)+" "+_vm._s(_vm.nf.endenrent)+" "+_vm._s(_vm.nf.bairroent)+" "+_vm._s(_vm.nf.ufent))])],1):_vm._e()])],1)]),_vm._v(" "),(_vm.showFormItem)?_c('div',[_c('Trap',[_c('nfsaida-item',{attrs:{"params":_vm.paramItem},on:{"closeform":_vm.closeFormItem,"save":_vm.saveItem}})],1)],1):_vm._e(),_vm._v(" "),(_vm.formCab)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('Trap',[_c('div',{staticClass:"container nb-modal-scrollable-container",attrs:{"id":"mymodal"}},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v(" Outras Informações ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeFormCab()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[(_vm.nfOutrasNotas)?_c('div',{staticClass:"row"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.nf.stnf == '10')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.chave.validator),expression:"metadata.nf.chave.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.nf.chave,"disabled":_vm.isView || _vm.nf.emissaopropria == 'S',"name":"chave","v-errors":_vm.errors},model:{value:(_vm.nf.chave),callback:function ($$v) {_vm.$set(_vm.nf, "chave", $$v)},expression:"nf.chave"}}):_vm._e(),_vm._v(" "),(_vm.nf.operacaonf == 'E')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.dtent.validator),expression:"metadata.nf.dtent.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.nf.dtent,"disabled":_vm.isView,"name":"dtent","v-errors":_vm.errors},model:{value:(_vm.nf.dtent),callback:function ($$v) {_vm.$set(_vm.nf, "dtent", $$v)},expression:"nf.dtent"}}):_vm._e(),_vm._v(" "),(_vm.nf.operacaonf == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.dtsai.validator),expression:"metadata.nf.dtsai.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.nf.dtsai,"disabled":_vm.isView,"name":"dtsai","v-errors":_vm.errors},model:{value:(_vm.nf.dtsai),callback:function ($$v) {_vm.$set(_vm.nf, "dtsai", $$v)},expression:"nf.dtsai"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pedcli.validator),expression:"metadata.nf.pedcli.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.pedcli,"disabled":_vm.isView,"name":"pedcli","v-errors":_vm.errors},model:{value:(_vm.nf.pedcli),callback:function ($$v) {_vm.$set(_vm.nf, "pedcli", $$v)},expression:"nf.pedcli"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.finalidade.validator),expression:"metadata.nf.finalidade.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.finalidade,"disabled":_vm.isView,"name":"finalidade","v-errors":_vm.errors},model:{value:(_vm.nf.finalidade),callback:function ($$v) {_vm.$set(_vm.nf, "finalidade", $$v)},expression:"nf.finalidade"}}),_vm._v(" "),(_vm.nf.tpnf === 'CR')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.tpnfcredito,"disabled":_vm.isView,"name":"tpnfcredito","v-errors":_vm.errors},model:{value:(_vm.nf.tpnfcredito),callback:function ($$v) {_vm.$set(_vm.nf, "tpnfcredito", $$v)},expression:"nf.tpnfcredito"}}):_vm._e(),_vm._v(" "),(_vm.nf.tpnf === 'DB')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.tpnfdebito,"disabled":_vm.isView,"name":"tpnfdebito","v-errors":_vm.errors},model:{value:(_vm.nf.tpnfdebito),callback:function ($$v) {_vm.$set(_vm.nf, "tpnfdebito", $$v)},expression:"nf.tpnfdebito"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.indpresencial.validator),expression:"metadata.nf.indpresencial.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.indpresencial,"disabled":_vm.isView,"name":"indpresencial","v-errors":_vm.errors},model:{value:(_vm.nf.indpresencial),callback:function ($$v) {_vm.$set(_vm.nf, "indpresencial", $$v)},expression:"nf.indpresencial"}}),_vm._v(" "),(_vm.nf.indpresencial == '2' || _vm.nf.indpresencial == '3' || _vm.nf.indpresencial == '4' || _vm.nf.indpresencial == '9')?_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nf.indintermed,"disabled":_vm.isView},model:{value:(_vm.nf.indintermed),callback:function ($$v) {_vm.$set(_vm.nf, "indintermed", $$v)},expression:"nf.indintermed"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.movfisica.validator),expression:"metadata.nf.movfisica.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.movfisica,"disabled":_vm.isView,"name":"movfisica","v-errors":_vm.errors},model:{value:(_vm.nf.movfisica),callback:function ($$v) {_vm.$set(_vm.nf, "movfisica", $$v)},expression:"nf.movfisica"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.movterc.validator),expression:"metadata.nf.movterc.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.movterc,"disabled":true,"name":"movterc","v-errors":_vm.errors},model:{value:(_vm.nf.movterc),callback:function ($$v) {_vm.$set(_vm.nf, "movterc", $$v)},expression:"nf.movterc"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.movest.validator),expression:"metadata.nf.movest.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.movest,"optionnull":false,"disabled":_vm.isView || (_vm.nf.stnf != '00' && _vm.nf.stnf != '01') || _vm.nf.flagestoquebaixado == 'S' || !_vm.controleEstoqueHabilitado,"name":"movest","v-errors":_vm.errors},model:{value:(_vm.nf.movest),callback:function ($$v) {_vm.$set(_vm.nf, "movest", $$v)},expression:"nf.movest"}})],1),_vm._v(" "),_c('label-title',{staticClass:"mt-3",attrs:{"title":"Transporte"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.tpfrete.validator),expression:"metadata.nf.tpfrete.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.tpfrete,"disabled":_vm.isView,"name":"tpfrete","v-errors":_vm.errors},model:{value:(_vm.nf.tpfrete),callback:function ($$v) {_vm.$set(_vm.nf, "tpfrete", $$v)},expression:"nf.tpfrete"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codparttr.validator),expression:"metadata.nf.codparttr.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.codparttr,"name":"codparttr","v-errors":_vm.errors,"disabled":_vm.isView,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluirPart(true)}},model:{value:(_vm.nf.codparttr),callback:function ($$v) {_vm.$set(_vm.nf, "codparttr", $$v)},expression:"nf.codparttr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.placa.validator),expression:"metadata.nf.placa.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.placa,"disabled":_vm.isView,"name":"placa","v-errors":_vm.errors},model:{value:(_vm.nf.placa),callback:function ($$v) {_vm.$set(_vm.nf, "placa", $$v)},expression:"nf.placa"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.placauf.validator),expression:"metadata.nf.placauf.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.placauf,"disabled":_vm.isView,"name":"placauf","v-errors":_vm.errors},model:{value:(_vm.nf.placauf),callback:function ($$v) {_vm.$set(_vm.nf, "placauf", $$v)},expression:"nf.placauf"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.rntc.validator),expression:"metadata.nf.rntc.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.rntc,"disabled":_vm.isView,"name":"rntc","v-errors":_vm.errors},model:{value:(_vm.nf.rntc),callback:function ($$v) {_vm.$set(_vm.nf, "rntc", $$v)},expression:"nf.rntc"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.vlrdesc.validator),expression:"metadata.nf.vlrdesc.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vlrdesc,"disabled":_vm.isView,"name":"vlrdesc","v-errors":_vm.errors},model:{value:(_vm.nf.vlrdesc),callback:function ($$v) {_vm.$set(_vm.nf, "vlrdesc", _vm._n($$v))},expression:"nf.vlrdesc"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.vlrfre.validator),expression:"metadata.nf.vlrfre.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vlrfre,"disabled":_vm.isView,"name":"vlrfre","v-errors":_vm.errors},model:{value:(_vm.nf.vlrfre),callback:function ($$v) {_vm.$set(_vm.nf, "vlrfre", _vm._n($$v))},expression:"nf.vlrfre"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.vlrseg.validator),expression:"metadata.nf.vlrseg.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vlrseg,"disabled":_vm.isView,"name":"vlrseg","v-errors":_vm.errors},model:{value:(_vm.nf.vlrseg),callback:function ($$v) {_vm.$set(_vm.nf, "vlrseg", _vm._n($$v))},expression:"nf.vlrseg"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.vlrdesp.validator),expression:"metadata.nf.vlrdesp.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vlrdesp,"disabled":_vm.isView,"name":"vlrdesp","v-errors":_vm.errors},model:{value:(_vm.nf.vlrdesp),callback:function ($$v) {_vm.$set(_vm.nf, "vlrdesp", _vm._n($$v))},expression:"nf.vlrdesp"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pliq.validator),expression:"metadata.nf.pliq.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pliq,"disabled":_vm.isView,"name":"pliq","v-errors":_vm.errors},model:{value:(_vm.nf.pliq),callback:function ($$v) {_vm.$set(_vm.nf, "pliq", _vm._n($$v))},expression:"nf.pliq"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pbru.validator),expression:"metadata.nf.pbru.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pbru,"disabled":_vm.isView,"name":"pbru","v-errors":_vm.errors},model:{value:(_vm.nf.pbru),callback:function ($$v) {_vm.$set(_vm.nf, "pbru", _vm._n($$v))},expression:"nf.pbru"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.qtvolumes.validator),expression:"metadata.nf.qtvolumes.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.qtvolumes,"disabled":_vm.isView,"name":"qtvolumes","v-errors":_vm.errors},model:{value:(_vm.nf.qtvolumes),callback:function ($$v) {_vm.$set(_vm.nf, "qtvolumes", _vm._n($$v))},expression:"nf.qtvolumes"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.volespecie.validator),expression:"metadata.nf.volespecie.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.volespecie,"disabled":_vm.isView,"name":"volespecie","v-errors":_vm.errors},model:{value:(_vm.nf.volespecie),callback:function ($$v) {_vm.$set(_vm.nf, "volespecie", $$v)},expression:"nf.volespecie"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.volmarca.validator),expression:"metadata.nf.volmarca.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.volmarca,"disabled":_vm.isView,"name":"volmarca","v-errors":_vm.errors},model:{value:(_vm.nf.volmarca),callback:function ($$v) {_vm.$set(_vm.nf, "volmarca", $$v)},expression:"nf.volmarca"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.volnr.validator),expression:"metadata.nf.volnr.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.volnr,"disabled":_vm.isView,"name":"volnr","v-errors":_vm.errors},model:{value:(_vm.nf.volnr),callback:function ($$v) {_vm.$set(_vm.nf, "volnr", $$v)},expression:"nf.volnr"}})],1),_vm._v(" "),(_vm.nfExportacao)?_c('label-title',{staticClass:"mt-5",attrs:{"title":"Exportação"}}):_vm._e(),_vm._v(" "),(_vm.nfExportacao)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.ufsaidapais.validator),expression:"metadata.nf.ufsaidapais.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.ufsaidapais,"name":"ufsaidapais","v-errors":_vm.errors},model:{value:(_vm.nf.ufsaidapais),callback:function ($$v) {_vm.$set(_vm.nf, "ufsaidapais", $$v)},expression:"nf.ufsaidapais"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.localemb.validator),expression:"metadata.nf.localemb.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.localemb,"name":"localemb","v-errors":_vm.errors},model:{value:(_vm.nf.localemb),callback:function ($$v) {_vm.$set(_vm.nf, "localemb", $$v)},expression:"nf.localemb"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.localdesp.validator),expression:"metadata.nf.localdesp.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.localdesp,"name":"localdesp","v-errors":_vm.errors},model:{value:(_vm.nf.localdesp),callback:function ($$v) {_vm.$set(_vm.nf, "localdesp", $$v)},expression:"nf.localdesp"}})],1):_vm._e(),_vm._v(" "),(_vm.nfImportacao)?_c('label-title',{staticClass:"mt-5",attrs:{"title":"Importação"}}):_vm._e(),_vm._v(" "),(_vm.nfImportacao)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.numerodi.validator),expression:"metadata.nf.numerodi.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.numerodi,"name":"numerodi","v-errors":_vm.errors},model:{value:(_vm.nf.numerodi),callback:function ($$v) {_vm.$set(_vm.nf, "numerodi", $$v)},expression:"nf.numerodi"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.datadi.validator),expression:"metadata.nf.datadi.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.nf.datadi,"name":"datadi","v-errors":_vm.errors},model:{value:(_vm.nf.datadi),callback:function ($$v) {_vm.$set(_vm.nf, "datadi", $$v)},expression:"nf.datadi"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.datadesemb.validator),expression:"metadata.nf.datadesemb.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.nf.datadesemb,"name":"datadesemb","v-errors":_vm.errors},model:{value:(_vm.nf.datadesemb),callback:function ($$v) {_vm.$set(_vm.nf, "datadesemb", $$v)},expression:"nf.datadesemb"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.localdesemb.validator),expression:"metadata.nf.localdesemb.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.localdesemb,"name":"localdesemb","v-errors":_vm.errors},model:{value:(_vm.nf.localdesemb),callback:function ($$v) {_vm.$set(_vm.nf, "localdesemb", $$v)},expression:"nf.localdesemb"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.ufdesemb.validator),expression:"metadata.nf.ufdesemb.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.ufdesemb,"name":"ufdesemb","v-errors":_vm.errors},model:{value:(_vm.nf.ufdesemb),callback:function ($$v) {_vm.$set(_vm.nf, "ufdesemb", $$v)},expression:"nf.ufdesemb"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.viatranspdi.validator),expression:"metadata.nf.viatranspdi.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.viatranspdi,"name":"viatranspdi","v-errors":_vm.errors},model:{value:(_vm.nf.viatranspdi),callback:function ($$v) {_vm.$set(_vm.nf, "viatranspdi", $$v)},expression:"nf.viatranspdi"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.vafrmm.validator),expression:"metadata.nf.vafrmm.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vafrmm,"name":"vafrmm","v-errors":_vm.errors},model:{value:(_vm.nf.vafrmm),callback:function ($$v) {_vm.$set(_vm.nf, "vafrmm", $$v)},expression:"nf.vafrmm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.tpintermediodi.validator),expression:"metadata.nf.tpintermediodi.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.tpintermediodi,"name":"tpintermediodi","v-errors":_vm.errors},model:{value:(_vm.nf.tpintermediodi),callback:function ($$v) {_vm.$set(_vm.nf, "tpintermediodi", $$v)},expression:"nf.tpintermediodi"}})],1):_vm._e(),_vm._v(" "),(_vm.nfImportacao && (_vm.nf.tpintermediodi == '2' || _vm.nf.tpintermediodi == '3'))?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.cnpjadquirente.validator),expression:"metadata.nf.cnpjadquirente.validator"}],attrs:{"type":"cnpj","col":"2","metadata":_vm.metadata.nf.cnpjadquirente,"name":"cnpjadquirente","v-errors":_vm.errors},model:{value:(_vm.nf.cnpjadquirente),callback:function ($$v) {_vm.$set(_vm.nf, "cnpjadquirente", $$v)},expression:"nf.cnpjadquirente"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.ufadquirente.validator),expression:"metadata.nf.ufadquirente.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.ufadquirente,"name":"ufadquirente","v-errors":_vm.errors},model:{value:(_vm.nf.ufadquirente),callback:function ($$v) {_vm.$set(_vm.nf, "ufadquirente", $$v)},expression:"nf.ufadquirente"}})],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.isView)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[(!_vm.enderecoEntrega)?_c('v-button',{attrs:{"label":"Definir Local de Entrega","title":"","nb-btdef":true},on:{"click":_vm.handleEnderecoEntrega}}):_vm._e(),_vm._v(" "),(!_vm.enderecoRetirada)?_c('v-button',{attrs:{"label":"Definir Local de Retirada","title":"","nb-btdef":true},on:{"click":_vm.handleEnderecoRetirada}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.enderecoRetirada)?_c('div',{attrs:{"id":"entrega"}},[_c('label-title',{staticClass:"mt-2",attrs:{"title":"Endereço de Retirada"}}),_c('br'),_vm._v(" "),(!_vm.isView)?_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Excluir Endereço","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleExcluirEndereco('ret')}}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.tppessoaret.validator),expression:"metadata.nf.tppessoaret.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.tppessoaret,"name":"tppessoaret","v-errors":_vm.errors},model:{value:(_vm.nf.tppessoaret),callback:function ($$v) {_vm.$set(_vm.nf, "tppessoaret", $$v)},expression:"nf.tppessoaret"}}),_vm._v(" "),(_vm.nf.tppessoaret == 'J')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ cnpj: true, required: true,  min: 14, max: 14 }),expression:"{ cnpj: true, required: true,  min: 14, max: 14 }"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.nf.cnpjcpfret,"name":"cnpjcpfret","v-errors":_vm.errors},model:{value:(_vm.nf.cnpjcpfret),callback:function ($$v) {_vm.$set(_vm.nf, "cnpjcpfret", $$v)},expression:"nf.cnpjcpfret"}}):_vm._e(),_vm._v(" "),(_vm.nf.tppessoaret == 'F')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ cpf: true, required: true,  min: 11, max: 11 }),expression:"{ cpf: true, required: true,  min: 11, max: 11 }"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.nf.cnpjcpfret,"name":"cnpjcpfret","v-errors":_vm.errors},model:{value:(_vm.nf.cnpjcpfret),callback:function ($$v) {_vm.$set(_vm.nf, "cnpjcpfret", $$v)},expression:"nf.cnpjcpfret"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.nomeret.validator),expression:"metadata.nf.nomeret.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.nf.nomeret,"disabled":_vm.isView,"name":"nomeret","v-errors":_vm.errors},model:{value:(_vm.nf.nomeret),callback:function ($$v) {_vm.$set(_vm.nf, "nomeret", $$v)},expression:"nf.nomeret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.emailret.validator),expression:"metadata.nf.emailret.validator"}],attrs:{"type":"email","col":"4","metadata":_vm.metadata.nf.emailret,"disabled":_vm.isView,"name":"emailret","v-errors":_vm.errors},model:{value:(_vm.nf.emailret),callback:function ($$v) {_vm.$set(_vm.nf, "emailret", $$v)},expression:"nf.emailret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.foneret.validator),expression:"metadata.nf.foneret.validator"}],attrs:{"type":"fone","col":"2","metadata":_vm.metadata.nf.foneret,"disabled":_vm.isView,"name":"foneret","v-errors":_vm.errors},model:{value:(_vm.nf.foneret),callback:function ($$v) {_vm.$set(_vm.nf, "foneret", $$v)},expression:"nf.foneret"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.cepret.validator),expression:"metadata.nf.cepret.validator"}],attrs:{"type":"cep","col":"2","metadata":_vm.metadata.nf.cepret,"name":"cepret","v-errors":_vm.errors},on:{"update":_vm.updateCepRet},model:{value:(_vm.nf.cepret),callback:function ($$v) {_vm.$set(_vm.nf, "cepret", $$v)},expression:"nf.cepret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.enderet.validator),expression:"metadata.nf.enderet.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.enderet,"name":"enderet","v-errors":_vm.errors},model:{value:(_vm.nf.enderet),callback:function ($$v) {_vm.$set(_vm.nf, "enderet", $$v)},expression:"nf.enderet"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.endenrret.validator),expression:"metadata.nf.endenrret.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.endenrret,"name":"endenrret","v-errors":_vm.errors},model:{value:(_vm.nf.endenrret),callback:function ($$v) {_vm.$set(_vm.nf, "endenrret", $$v)},expression:"nf.endenrret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.endecompret.validator),expression:"metadata.nf.endecompret.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.endecompret,"name":"endecompret","v-errors":_vm.errors},model:{value:(_vm.nf.endecompret),callback:function ($$v) {_vm.$set(_vm.nf, "endecompret", $$v)},expression:"nf.endecompret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.bairroret.validator),expression:"metadata.nf.bairroret.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.bairroret,"name":"bairroret","v-errors":_vm.errors},model:{value:(_vm.nf.bairroret),callback:function ($$v) {_vm.$set(_vm.nf, "bairroret", $$v)},expression:"nf.bairroret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.ufret.validator),expression:"metadata.nf.ufret.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.ufret,"name":"ufret","v-errors":_vm.errors},model:{value:(_vm.nf.ufret),callback:function ($$v) {_vm.$set(_vm.nf, "ufret", $$v)},expression:"nf.ufret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codmunret.validator),expression:"metadata.nf.codmunret.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.codmunret,"name":"codmunret","v-errors":_vm.errors,"select2":{ entity: 'mun/uf/' + _vm.nf.ufret, minlength: 2 }},model:{value:(_vm.nf.codmunret),callback:function ($$v) {_vm.$set(_vm.nf, "codmunret", $$v)},expression:"nf.codmunret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codpaisret.validator),expression:"metadata.nf.codpaisret.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.nf.codpaisret,"name":"codpaisret","v-errors":_vm.errors},model:{value:(_vm.nf.codpaisret),callback:function ($$v) {_vm.$set(_vm.nf, "codpaisret", $$v)},expression:"nf.codpaisret"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.enderecoEntrega)?_c('div',{attrs:{"id":"entrega"}},[_c('label-title',{staticClass:"mt-2",attrs:{"title":"Endereço de Entrega"}}),_vm._v(" "),(!_vm.isView)?_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Excluir Endereço","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleExcluirEndereco('ent')}}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.tppessoaent.validator),expression:"metadata.nf.tppessoaent.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.tppessoaent,"name":"tppessoaent","v-errors":_vm.errors},model:{value:(_vm.nf.tppessoaent),callback:function ($$v) {_vm.$set(_vm.nf, "tppessoaent", $$v)},expression:"nf.tppessoaent"}}),_vm._v(" "),(_vm.nf.tppessoaent == 'F')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ cpf: true, required: true,  min: 11, max: 11 }),expression:"{ cpf: true, required: true,  min: 11, max: 11 }"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.cnpjcpfent,"name":"cpfent","v-errors":_vm.errors},model:{value:(_vm.nf.cnpjcpfent),callback:function ($$v) {_vm.$set(_vm.nf, "cnpjcpfent", $$v)},expression:"nf.cnpjcpfent"}}):_vm._e(),_vm._v(" "),(_vm.nf.tppessoaent == 'J')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ cnpj: true, required: true,  min: 14, max: 14 }),expression:"{ cnpj: true, required: true,  min: 14, max: 14 }"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.cnpjcpfent,"name":"cnpjent","v-errors":_vm.errors},model:{value:(_vm.nf.cnpjcpfent),callback:function ($$v) {_vm.$set(_vm.nf, "cnpjcpfent", $$v)},expression:"nf.cnpjcpfent"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.nomeent.validator),expression:"metadata.nf.nomeent.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.nf.nomeent,"disabled":_vm.isView,"name":"nomeent","v-errors":_vm.errors},model:{value:(_vm.nf.nomeent),callback:function ($$v) {_vm.$set(_vm.nf, "nomeent", $$v)},expression:"nf.nomeent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.emailent.validator),expression:"metadata.nf.emailent.validator"}],attrs:{"type":"email","col":"4","metadata":_vm.metadata.nf.emailent,"disabled":_vm.isView,"name":"emailent","v-errors":_vm.errors},model:{value:(_vm.nf.emailent),callback:function ($$v) {_vm.$set(_vm.nf, "emailent", $$v)},expression:"nf.emailent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.foneent.validator),expression:"metadata.nf.foneent.validator"}],attrs:{"type":"fone","col":"2","metadata":_vm.metadata.nf.foneent,"disabled":_vm.isView,"name":"foneent","v-errors":_vm.errors},model:{value:(_vm.nf.foneent),callback:function ($$v) {_vm.$set(_vm.nf, "foneent", $$v)},expression:"nf.foneent"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.cepent.validator),expression:"metadata.nf.cepent.validator"}],attrs:{"type":"cep","col":"2","metadata":_vm.metadata.nf.cepent,"name":"cepent","v-errors":_vm.errors},on:{"update":_vm.updateCepEnt},model:{value:(_vm.nf.cepent),callback:function ($$v) {_vm.$set(_vm.nf, "cepent", $$v)},expression:"nf.cepent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.endeent.validator),expression:"metadata.nf.endeent.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.endeent,"name":"endeent","v-errors":_vm.errors},model:{value:(_vm.nf.endeent),callback:function ($$v) {_vm.$set(_vm.nf, "endeent", $$v)},expression:"nf.endeent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.endenrent.validator),expression:"metadata.nf.endenrent.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.endenrent,"name":"endenrent","v-errors":_vm.errors},model:{value:(_vm.nf.endenrent),callback:function ($$v) {_vm.$set(_vm.nf, "endenrent", $$v)},expression:"nf.endenrent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.endecompent.validator),expression:"metadata.nf.endecompent.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.endecompent,"name":"endecompent","v-errors":_vm.errors},model:{value:(_vm.nf.endecompent),callback:function ($$v) {_vm.$set(_vm.nf, "endecompent", $$v)},expression:"nf.endecompent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.bairroent.validator),expression:"metadata.nf.bairroent.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.bairroent,"name":"bairroent","v-errors":_vm.errors},model:{value:(_vm.nf.bairroent),callback:function ($$v) {_vm.$set(_vm.nf, "bairroent", $$v)},expression:"nf.bairroent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.ufent.validator),expression:"metadata.nf.ufent.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.ufent,"name":"ufent","v-errors":_vm.errors},model:{value:(_vm.nf.ufent),callback:function ($$v) {_vm.$set(_vm.nf, "ufent", $$v)},expression:"nf.ufent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codmunent.validator),expression:"metadata.nf.codmunent.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.codmunent,"name":"codmunent","v-errors":_vm.errors,"select2":{ entity: 'mun/uf/' + _vm.nf.ufent, minlength: 2 }},model:{value:(_vm.nf.codmunent),callback:function ($$v) {_vm.$set(_vm.nf, "codmunent", $$v)},expression:"nf.codmunent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codpaisent.validator),expression:"metadata.nf.codpaisent.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.nf.codpaisent,"name":"codpaisent","v-errors":_vm.errors},model:{value:(_vm.nf.codpaisent),callback:function ($$v) {_vm.$set(_vm.nf, "codpaisent", $$v)},expression:"nf.codpaisent"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.selectedNates && _vm.selectedNates.calcdup == 'S')?_c('div',{staticClass:"mt-5"},[_c('label-title',{staticClass:"mt-2",attrs:{"title":"Retenção de Impostos"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.calcreten.validator),expression:"metadata.nf.calcreten.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.calcreten,"disabled":_vm.isView,"name":"calcreten","v-errors":_vm.errors},model:{value:(_vm.nf.calcreten),callback:function ($$v) {_vm.$set(_vm.nf, "calcreten", $$v)},expression:"nf.calcreten"}})],1),_vm._v(" "),(_vm.nf.calcreten == 'S')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pretcsll.validator),expression:"metadata.nf.pretcsll.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pretcsll,"disabled":_vm.isView,"name":"pretcsll","v-errors":_vm.errors,"addon":"%"},model:{value:(_vm.nf.pretcsll),callback:function ($$v) {_vm.$set(_vm.nf, "pretcsll", $$v)},expression:"nf.pretcsll"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pretpis.validator),expression:"metadata.nf.pretpis.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pretpis,"disabled":_vm.isView,"name":"pretpis","v-errors":_vm.errors,"addon":"%"},model:{value:(_vm.nf.pretpis),callback:function ($$v) {_vm.$set(_vm.nf, "pretpis", $$v)},expression:"nf.pretpis"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pretcofins.validator),expression:"metadata.nf.pretcofins.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pretcofins,"disabled":_vm.isView,"name":"pretcofins","v-errors":_vm.errors,"addon":"%"},model:{value:(_vm.nf.pretcofins),callback:function ($$v) {_vm.$set(_vm.nf, "pretcofins", $$v)},expression:"nf.pretcofins"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pretinss.validator),expression:"metadata.nf.pretinss.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pretinss,"disabled":_vm.isView,"name":"pretinss","v-errors":_vm.errors,"addon":"%"},model:{value:(_vm.nf.pretinss),callback:function ($$v) {_vm.$set(_vm.nf, "pretinss", $$v)},expression:"nf.pretinss"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pretirrf.validator),expression:"metadata.nf.pretirrf.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pretirrf,"disabled":_vm.isView,"name":"pretirrf","v-errors":_vm.errors,"addon":"%"},model:{value:(_vm.nf.pretirrf),callback:function ($$v) {_vm.$set(_vm.nf, "pretirrf", $$v)},expression:"nf.pretirrf"}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.selectedPart && _vm.selectedPart.tpentgov != '')?_c('div',{staticClass:"mt-5"},[_c('label-title',{staticClass:"mt-2",attrs:{"title":"Compra Governamental"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.tpopergov.validator),expression:"metadata.nf.tpopergov.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.tpopergov,"disabled":_vm.isView,"name":"tpopergov","v-errors":_vm.errors},model:{value:(_vm.nf.tpopergov),callback:function ($$v) {_vm.$set(_vm.nf, "tpopergov", $$v)},expression:"nf.tpopergov"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.predutorgov.validator),expression:"metadata.nf.predutorgov.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.predutorgov,"disabled":_vm.isView,"name":"predutorgov","v-errors":_vm.errors,"addon":"%"},model:{value:(_vm.nf.predutorgov),callback:function ($$v) {_vm.$set(_vm.nf, "predutorgov", $$v)},expression:"nf.predutorgov"}})],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer mt-2"},[(!_vm.isView)?_c('v-button',{ref:"btnConfirm",attrs:{"label":"Salvar","title":"","nb-btdef":true},on:{"click":_vm.handleSalvarDadosAdicionais}}):_vm._e(),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeFormCab}})],1)],1)])])],1):_vm._e(),_vm._v(" "),(_vm.DELETE_ITEM_MESSAGE)?_c('md-message',{attrs:{"code":"deleteit"},on:{"close":function($event){return _vm.handleCloseMessage()},"confirm":function($event){return _vm.handleDeleteItem()}}}):_vm._e(),_vm._v(" "),(_vm.showNumeroForm)?_c('nf-form-numero',{attrs:{"nf":_vm.nf},on:{"closeform":_vm.closeNumeroForm,"save":_vm.updateNumero}}):_vm._e(),_vm._v(" "),(_vm.showFormEstoqueEntrada)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"nb-modal-scrollable-container",staticStyle:{"padding":"15px","width":"90%"}},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('estoque-entrada',{attrs:{"index":_vm.nf.codnf,"excluir":_vm.excluirArmazenamento},on:{"closeform":_vm.closeEstoqueForm}})],1)])]):_vm._e(),_vm._v(" "),(_vm.showEstoqueSaida)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"nb-modal-scrollable-container",staticStyle:{"padding":"15px","width":"90%"}},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('estoque-saida',{attrs:{"index":_vm.nf.codnf,"excluir":_vm.excluirEstoqueSaida,"notafiscal":true},on:{"closeform":_vm.closeEstoqueForm}})],1)])]):_vm._e(),_vm._v(" "),(_vm.showPartForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"nb-modal-scrollable-container",staticStyle:{"padding":"15px","width":"80%"}},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('customer-form',{attrs:{"crud":_vm.crudPart,"index":_vm.codpart},on:{"closeform":_vm.closeCustomerForm}})],1)])]):_vm._e(),_vm._v(" "),(_vm.showNatesForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('Trap',[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('nates-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closeNatesForm}})],1)])])],1):_vm._e(),_vm._v(" "),(_vm.showModalNfxml)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('Trap',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[(_vm.showModalNfxml)?_c('nfsaida-modal-nfxml',{staticClass:"to-front",attrs:{"nf":_vm.nf},on:{"close":function($event){return _vm.closeModalNfxml()},"getNfxml":function($event){return _vm.handleInformaNfxml($event)}}}):_vm._e()],1)])])],1):_vm._e(),_vm._v(" "),(_vm.showCorrecao)?_c('div',{staticClass:"nb-modal-mask"},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"max-height":"255px","overflow-y":"auto"}},[(_vm.errCorrecao.length != 0)?_c('div',[_c('div',{staticClass:"col"},[_c('div',{staticClass:"alert alert-danger fade show",attrs:{"role":"alert"}},[_c('h5',{staticClass:"alert-heading"},[_vm._v("Erro ao enviar a carta de correção: ")]),_vm._v(" "),_vm._l((_vm.errCorrecao),function(err,index){return _c('p',{key:index},[_c('small',[_vm._v(_vm._s(err))])])})],2)])]):_vm._e(),_vm._v(" "),(_vm.textocorrecao_anterior != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.textocorrecao_anterior),expression:"textocorrecao_anterior"}],staticClass:"form-control",attrs:{"rows":"5","cols":"100","disabled":""},domProps:{"value":(_vm.textocorrecao_anterior)},on:{"input":function($event){if($event.target.composing){ return; }_vm.textocorrecao_anterior=$event.target.value}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('label',{staticClass:"lbl"},[_vm._v("Informe o texto da correção:")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.textocorrecao),expression:"textocorrecao"}],ref:"correcao",staticClass:"form-control",attrs:{"rows":"5","cols":"100"},domProps:{"value":(_vm.textocorrecao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.textocorrecao=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"lbl"},[_vm._v("O texto da correção deve possuir no mínimo 15 e no máximo 1000 caracteres")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"label":"Enviar Correção","title":"","nb-btdef":true,"icon":"fa-check"},on:{"click":_vm.handleCorrecao}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Descartar","title":"","icon":"fa-rotate-left"},on:{"click":_vm.handleCorrecaoClose}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.showEventos)?_c('nfe-eventos-form',{attrs:{"nf":_vm.nf,"default-tp-evento":_vm.defaultTpEvento,"default-tp-evento-aut":_vm.defaultTpEventoAut,"default-n-prot-evento":_vm.defaultNProtEvento},on:{"close":function($event){_vm.showEventos = false},"success":_vm.loadData}}):_vm._e(),_vm._v(" "),(_vm.showCancel)?_c('div',{staticClass:"nb-modal-mask"},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"max-height":"255px","overflow-y":"auto"}},[(_vm.errCorrecao.length != 0)?_c('div',[_c('div',{staticClass:"col"},[_c('div',{staticClass:"alert alert-danger fade show",attrs:{"role":"alert"}},[_c('h5',{staticClass:"alert-heading"},[_vm._v("Erro ao enviar pedido de cancelamento: ")]),_vm._v(" "),_vm._l((_vm.errCorrecao),function(err,index){return _c('p',{key:index},[_c('small',[_vm._v(_vm._s(err))])])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('label',{staticClass:"lbl"},[_vm._v("Informe a justificativa do cancelamento:")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.nf.obscan),expression:"nf.obscan"}],ref:"correcao",staticClass:"form-control",attrs:{"rows":"5","cols":"100"},domProps:{"value":(_vm.nf.obscan)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.nf, "obscan", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"lbl"},[_vm._v("O texto deve possuir no mínimo 15 e no máximo 255 caracteres")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"label":"Confirmar Cancelamento","title":"","nb-btdef":true,"icon":"fa-check"},on:{"click":_vm.handleCancel}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Descartar","title":"","icon":"fa-rotate-left"},on:{"click":_vm.handleCancelDiscard}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.showFormEmail)?_c('email-form',{attrs:{"index":_vm.nf.codnf,"tipo":"DANFE","title":"Envio de Danfe"},on:{"closeform":_vm.closeFormEmail,"send":_vm.handleSendEmail}}):_vm._e(),_vm._v(" "),(_vm.showFormEmailCC)?_c('email-form',{attrs:{"index":_vm.nf.codnf,"tipo":"CCE","title":"Envio de Carta de Correção"},on:{"closeform":_vm.closeFormEmail,"send":_vm.handleSendEmailCC}}):_vm._e(),_vm._v(" "),(_vm.modalExcluir)?_c('md-message',{attrs:{"code":"delete"},on:{"confirm":function($event){return _vm.handleExcluir()},"close":function($event){return _vm.closeModal()}}}):_vm._e(),_vm._v(" "),(_vm.modalBannerIBSCBS)?_c('msg-banner-modal',{attrs:{"message":"Nova Tributação IBS / CBS","url":"https://s3.us-east-1.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/banners/banner_nb_nt.png"},on:{"onConfirm":function($event){return _vm.handleConfirmBannerIBSCBS()},"close":function($event){return _vm.closeModal()}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v("Incluir Nota Fiscal")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge badge-green p-2",staticStyle:{"font-size":"0.85rem"}},[_c('i',{staticClass:"fa fa-link"}),_vm._v(" Vinculada ao Item\n                ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"def-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(" Carta de Correção ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"def-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Cancelamento de Nota Fiscal")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1633);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5a2a65f9", content, true, {});

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".lbl-edit[data-v-4cbecb96],label[data-v-4cbecb96]{margin-bottom:0}.dropdown-total[data-v-4cbecb96]{z-index:1051;margin-top:3px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;position:absolute;padding:10px;z-index:1000;float:left;min-width:160px;list-style:none;background-color:#fff;border:1px solid #00000033;box-shadow:0 5px 10px #00000033;background-clip:padding-box}", ""]);

// exports


/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfse_item_vue__ = __webpack_require__(589);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_84c7565e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfse_item_vue__ = __webpack_require__(1637);
function injectStyle (ssrContext) {
  __webpack_require__(1635)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfse_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_84c7565e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfse_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1636);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("46faaf82", content, true, {});

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',[(!_vm.showItemForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v(" Item da Nota Fiscal")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body",attrs:{"id":"mymodal"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"f9",undefined,$event.key,undefined)){ return null; }return _vm.handleValidarItem.apply(null, arguments)}}},[(!_vm.params.habilitaItem)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-1"},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(_vm.nfit.item[0].descricao))]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm.nfit.item[0].codigo))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-5",attrs:{"align":"right"}},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(this.local_metadata.totliq.label))]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm._f("formatValue")(this.nfit.totliq,2)))])])]):_vm._e(),_vm._v(" "),(_vm.params.habilitaItem)?_c('div',{attrs:{"id":"item"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.local_metadata.coditem}}),_vm._v(" "),_c('div',{},[_c('input-item',{ref:"item",attrs:{"add-button":true,"disabled":_vm.nfit.codpedv,"tipoitem":'S'},on:{"onselect":_vm.handleNewItem,"novo":_vm.handleCadastroItem},model:{value:(_vm.nfit.coditem),callback:function ($$v) {_vm.$set(_vm.nfit, "coditem", $$v)},expression:"nfit.coditem"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.local_metadata.obs}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.nfit.obs),expression:"nfit.obs"},{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],staticClass:"form-control form-control-sm",attrs:{"rows":"4","cols":"100","disabled":_vm.isView,"name":"desccomp"},domProps:{"value":(_vm.nfit.obs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.nfit, "obs", $event.target.value)}}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.vlr.validator),expression:"local_metadata.vlr.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.vlr,"disabled":_vm.isView || _vm.nfit.codpedv,"name":"vlr","v-errors":_vm.errors},model:{value:(_vm.nfit.vlr),callback:function ($$v) {_vm.$set(_vm.nfit, "vlr", $$v)},expression:"nfit.vlr"}}),_vm._v(" "),(_vm.params.nfComplementar)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.local_metadata.totliq.validator),expression:"local_metadata.totliq.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.local_metadata.totliq,"disabled":_vm.isView,"name":"totliq","v-errors":_vm.errors},model:{value:(_vm.nfit.totliq),callback:function ($$v) {_vm.$set(_vm.nfit, "totliq", $$v)},expression:"nfit.totliq"}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[(!_vm.isView)?_c('v-button',{ref:"btnConfirm",attrs:{"label":"Salvar (F9)","title":"","nb-btdef":true},on:{"click":_vm.handleValidarItem}}):_vm._e(),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeForm}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.showItemForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('Trap',[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('item-form',{attrs:{"crud":_vm.crud,"descricao":_vm.descricaoNovoItem},on:{"closeform":_vm.closeItemForm}})],1)])])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.formIncluir && _vm.nfit.length)?_c('div',{staticClass:"w-100 text-center",staticStyle:{"position":"fixed","left":"0","bottom":"0","z-index":"10","border-top":"1px solid #eee","background-color":"#fdfbfb","padding":"15px","-webkit-box-shadow":"0 -2px 5px rgba(0,0,0,0.2)","-moz-box-shadow":"0 -2px 5px rgba(0,0,0,0.2)","box-shadow":"0 -2px 5px rgba(0,0,0,0.2)"}},[(!_vm.isView)?_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.nf.stnf == '00'),expression:"nf.stnf == '00'"}],attrs:{"label":"Totalizar","title":"","icon":"fa-dollar","nb-btdef":true},on:{"click":_vm.handleTotalizar}}):_vm._e(),_vm._v(" "),(_vm.nf.stnf === '01' || _vm.nf.stnf === '50')?_c('v-button',{attrs:{"label":"Salvar e Fechar","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleTotalizar(true)}}}):_vm._e(),_vm._v(" "),(_vm.nfAguardando)?_c('v-button',{attrs:{"label":"Autorizar","icon":"fa-rss-square"},on:{"click":function($event){return _vm.handleActions(_vm.Actions.AUTORIZA_NF)}}}):_vm._e(),_vm._v(" "),(_vm.nfAutorizada)?_c('v-button',{attrs:{"label":"Impressão"},on:{"click":function($event){return _vm.handleActions(_vm.Actions.IMPRIMIR_DANFE)}}}):_vm._e(),_vm._v(" "),(_vm.nfAutorizada)?_c('v-button',{attrs:{"label":"Enviar E-mail","icon":"fa-envelope-open"},on:{"click":function($event){return _vm.handleActions(_vm.Actions.ENVIAR_EMAIL)}}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.formIncluir)?_c('div',[_c('div',{staticClass:"default-container mt-2"},[_c('div',{staticClass:"row align-items-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{staticClass:"float-right",attrs:{"label":"Continuar","title":"","nb-btdef":true},on:{"click":_vm.handleIncluir}}),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar","title":"","icon":"fa-arrow-left"},on:{"click":_vm.handleRetorna}})],1)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('label-title',{attrs:{"title":_vm.titleParticipante,"icon":"fa-university"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('input-part',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codpart.validator),expression:"metadata.nf.codpart.validator"}],ref:"organizacao",attrs:{"participante":true,"add-button":true,"name":"Cliente/Fornecedor","v-errors":_vm.errors},model:{value:(_vm.nf.codpart),callback:function ($$v) {_vm.$set(_vm.nf, "codpart", $$v)},expression:"nf.codpart"}})],1)]),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.dtsai.validator),expression:"metadata.nf.dtsai.validator"}],attrs:{"type":"date","col":"3","metadata":_vm.metadata.nf.dtsai,"name":"dtsai","v-errors":_vm.errors},model:{value:(_vm.nf.dtsai),callback:function ($$v) {_vm.$set(_vm.nf, "dtsai", $$v)},expression:"nf.dtsai"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codnates.validator),expression:"metadata.nf.codnates.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.nf.codnates,"add-button":true,"name":"codnates","v-errors":_vm.errors,"select2":{entity: 'nates/saida/outras', minlength: 0}},on:{"clickAdd":function($event){return _vm.handleIncluirNates()}},model:{value:(_vm.nf.codnates),callback:function ($$v) {_vm.$set(_vm.nf, "codnates", $$v)},expression:"nf.codnates"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.cfop.validator),expression:"metadata.nf.cfop.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.nf.cfop,"name":"cfop","v-errors":_vm.errors,"select2":{entity: 'cfop/saidas', minlength: 0}},model:{value:(_vm.nf.cfop),callback:function ($$v) {_vm.$set(_vm.nf, "cfop", $$v)},expression:"nf.cfop"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.possuiNForigem()),expression:"possuiNForigem()"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.codnatesret,"select2":{entity: 'nates/saida/retorno', minlength: 0}},model:{value:(_vm.nf.codnatesret),callback:function ($$v) {_vm.$set(_vm.nf, "codnatesret", $$v)},expression:"nf.codnatesret"}})],1),_vm._v(" "),_c('div',{staticClass:"row mb-2"})],1)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formNF),expression:"formNF"}],attrs:{"id":"formNF"}},[_c('div',{staticClass:"default-container mt-2"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"badge badge-blue mr-2"},[_vm._v("NFS-e")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"float-right"},[_c('v-button',{attrs:{"label":"Retornar","title":"","icon":"fa-arrow-left"},on:{"click":_vm.handleRetorna}}),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.nf.stnf == '11' && _vm.nf.flagarmazenada != 'S'),expression:"nf.stnf == '11' && nf.flagarmazenada != 'S'"}],attrs:{"label":"Editar","title":"Editar nota fiscal","icon":"fa-pencil","nb-btdef":true},on:{"click":_vm.handleEditar}}),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.moreActions.length > 0),expression:"moreActions.length > 0"}],attrs:{"label":"Mais Ações","actions":_vm.moreActions},on:{"click":_vm.handleActions}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-2 align-items-center",staticStyle:{"background-color":"#f9f9f9"}},[_c('div',{staticClass:"col"},[_c('v-label',{attrs:{"label":"Série"}}),_vm._v(" "),_c('span',{staticClass:"lbl-total-documento",staticStyle:{"font-size":"24px","padding":"5px","background-color":"#f9f9f9"}},[_vm._v(_vm._s(_vm.nf.serie))]),_vm._v(" "),_c('v-label',{attrs:{"label":"Número"}}),_vm._v(" "),_c('span',{staticClass:"lbl-total-documento",staticStyle:{"font-size":"24px","padding":"5px","background-color":"#f9f9f9"}},[_vm._v(_vm._s(_vm.nf.nf))]),_vm._v(" "),(_vm._alteraNumero)?_c('a',{staticClass:"w-100",staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleUpdateNumero}},[_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}}),_vm._v(" Alterar numeração desta nota")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col text-right"},[(_vm.nf.stnf == '00')?_c('span',{staticClass:"badge badge-orange mr-2"},[_vm._v(_vm._s(_vm._f("getTextOption")(_vm.nf.stnf,_vm.metadata.nf.stnf)))]):_vm._e(),_vm._v(" "),(_vm.nf.stnf == '01')?_c('span',{staticClass:"badge badge-blue mr-2"},[_vm._v(_vm._s(_vm._f("getTextOption")(_vm.nf.stnf,_vm.metadata.nf.stnf)))]):_vm._e(),_vm._v(" "),(_vm.nf.stnf == '10'||_vm.nf.stnf == '11')?_c('span',{staticClass:"badge badge-green mr-2"},[_vm._v(_vm._s(_vm._f("getTextOption")(_vm.nf.stnf,_vm.metadata.nf.stnf)))]):_vm._e(),_vm._v(" "),(_vm.nf.stnf >= '50')?_c('span',{staticClass:"badge badge-red mr-2"},[_vm._v(_vm._s(_vm._f("getTextOption")(_vm.nf.stnf,_vm.metadata.nf.stnf)))]):_vm._e(),_vm._v(" "),(_vm.nf.emissaopropria=='S')?_c('span',{staticClass:"badge badge-yellow mr-2"},[_vm._v("Nota Fiscal Própria")]):_vm._e(),_vm._v(" "),(_vm.nf.carta_correcao > 0)?_c('span',{staticClass:"badge badge-yellow mr-2"},[_vm._v("Carta de Correção")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-3 col-6 d-flex align-items-center"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.data}}),_vm._v(" "),_c('strong',{},[_vm._v(_vm._s(_vm._f("formatData")(_vm.nf.data)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6 d-flex align-items-center"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.dtsai}}),_vm._v(" "),_c('strong',{},[_vm._v(_vm._s(_vm._f("formatData")(this.nf.dtsai)))])],1),_vm._v(" "),(_vm.nf.nates)?_c('div',{staticClass:"col-md-3 col-6 d-flex align-items-center"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.codnates}}),_vm._v(" "),_c('strong',{},[_vm._v(" "+_vm._s(_vm.selectedNates.descricao)+" ")])],1):_vm._e(),_vm._v(" "),(_vm.nf.xmotivo && _vm.nf.stnf != '10')?_c('div',{staticClass:"col-6 error"},[_vm._v(" "+_vm._s(_vm.nf.xmotivo)+" ")]):_vm._e(),_vm._v(" "),(_vm.nf.npedido)?_c('div',{staticClass:"col-md-3 col-3 d-flex align-items-center my-2"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedv.npedido}}),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm.nf.npedido))])],1):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label-title',{attrs:{"title":_vm.titleParticipante,"icon":"fa-university"}}),_vm._v(" "),_c('div',{staticClass:"row col mb-2"},[_c('input-part',{ref:"part",attrs:{"participante":true,"disabled":(_vm.isView || _vm.nf.codpedv || (this.nf.flagarmazenada == 'S') || (this.nf.flagestoquebaixado == 'S')),"showMsgEmail":(_vm.nf.operacaonf!='E')},model:{value:(_vm.nf.codpart),callback:function ($$v) {_vm.$set(_vm.nf, "codpart", $$v)},expression:"nf.codpart"}})],1),_vm._v(" "),(_vm.errmessages.errmessages)?_c('validation',{attrs:{"title":"Erros de Validação","messages":_vm.errmessages.errmessages}}):_vm._e(),_vm._v(" "),(_vm.nf.fin_baixado)?_c('div',[_c('alert',{attrs:{"type":"info","title":"Aviso","text":"Esta nota fiscal possui títulos baixados."}})],1):_vm._e(),_vm._v(" "),(_vm.nfPossuiEvento)?_c('div',[_c('alert',{attrs:{"type":"info","title":"Aviso","text":"Esta nota fiscal possui eventos vinculados."}})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"default-container nb-margin-top",staticStyle:{"border-top":"3px solid black"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab == 0),expression:"activeTab == 0"}]},[_c('label-title',{attrs:{"title":'Serviços (' + _vm.nfit.length + ')',"icon":"fa-archive"}}),_vm._v(" "),(_vm.habilitaBotaoProduto)?_c('div',{staticClass:"row col"},[_c('v-button',{ref:"incluirProduto",attrs:{"label":"Incluir Serviço","title":"","nb-btdef":true,"icon":"fa-plus"},on:{"click":_vm.handleIncluirItem,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleIncluirItem.apply(null, arguments)}}})],1):_vm._e(),_vm._v(" "),_c('div',_vm._l((_vm.nfit),function(it,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"mark-gray"}),_vm._v(" "),_c('div',{staticClass:"box pl-3 pl-md-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-6 row"},[_c('div',{staticClass:"col-md-6 col-auto"},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(it.item[0].descricao))]),_vm._v(" "),_c('v-label',{staticClass:"d-none d-md-inline",attrs:{"label":"Seq"}}),_vm._v(" "),_c('span',{staticClass:"lbl d-none d-md-inline"},[_vm._v(_vm._s(it.itnf))]),_vm._v(" "),_c('v-label',{attrs:{"label":"Codigo"}}),_vm._v(" "),_c('span',{staticClass:"lbl break-words text-break",staticStyle:{"word-break":"break-all !important","white-space":"wrap !important"}},[_vm._v(_vm._s(it.item[0].codigo))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-auto"},[_c('v-label',{attrs:{"label":"Preço"}}),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm._f("formatValue")(it.vlr,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-auto d-none d-md-flex align-item-start order-last ml-md-auto"},[_c('bar-grid',{attrs:{"options":{ barDefault: true, btnView: true, btnEdit: _vm.editItem, btnDelete: _vm.deleteItem },"moreActions":{}},on:{"edit":function($event){return _vm.handleEditItem(it.itnf, false)},"view":function($event){return _vm.handleEditItem(it.itnf, true)},"delete":function($event){return _vm.handleDeleteItemMsg(index)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-6 d-flex d-md-none flex-wrap align-items-center justify-content-end order-last ml-md-auto"},[_c('bar-grid',{attrs:{"options":{ barDefault: true, btnView: false, btnEdit: _vm.editItem, btnDelete: _vm.deleteItem },"moreActions":{}},on:{"edit":function($event){return _vm.handleEditItem(it.itnf, false)},"delete":function($event){return _vm.handleDeleteItemMsg(index)}}})],1)])])])}),0),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.nfit.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-12"},[_c('div',[_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){_vm.showTotal = true}}},[_vm._v("Detalhar Totais")])]),_vm._v(" "),(_vm.showTotal)?_c('div',{staticClass:"dropdown-total col-md-8 col-12",staticStyle:{"padding":"15px"}},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){_vm.showTotal = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"row col mb-2"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.totiss}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.totiss,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.totissret}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right font-weight-bold",style:(("" + (_vm.styleFontRed(_vm.nf.descontar_iss))))},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.totissret,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.vretirrf}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right font-weight-bold",style:(("" + (_vm.styleFontRed(_vm.nf.descontar_ir))))},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.vretirrf,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.vretcsll}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right font-weight-bold"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.vretcsll,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.vretinss}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right font-weight-bold"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.vretinss,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.vretpis}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right font-weight-bold"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.vretpis,2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-label',{staticClass:"float-left",attrs:{"metadata-field":_vm.metadata.nf.vretcofins}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl float-right font-weight-bold"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.nf.vretcofins,2)))])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('table',{staticClass:"table table-sm",staticStyle:{"margin-left":"0","width":"100%"}},[_c('tbody',[_c('tr',[_c('th',[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totmer}})],1),_vm._v(" "),_c('th',[_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.totmer,2)))])])]),_vm._v(" "),(_vm.nf.totdes)?_c('tr',[_c('th',[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totdes}})],1),_vm._v(" "),_c('th',[_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.totdes,2)))])])]):_vm._e(),_vm._v(" "),_c('tr',[_c('th',[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totger}})],1),_vm._v(" "),_c('th',[_c('span',{staticClass:"lbl-total-documento float-right"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.nf.totger,2)))])])])])])])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"default-container nb-margin-top",staticStyle:{"border-top":"3px solid black"}},[_c('label-title',{attrs:{"title":"Desconto"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.vlrdesc.validator),expression:"metadata.nf.vlrdesc.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vlrdesc,"disabled":_vm.isView,"name":"vlrdesc","v-errors":_vm.errors},on:{"input":function($event){return _vm.handleChangeValores()}},model:{value:(_vm.nf.vlrdesc),callback:function ($$v) {_vm.$set(_vm.nf, "vlrdesc", $$v)},expression:"nf.vlrdesc"}})],1),_vm._v(" "),(_vm.habilitaDuplicata)?_c('div',{staticClass:"mb-b mt-2"},[_c('label-title',{attrs:{"title":"Condição de Pagamento"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codnatfin.validator),expression:"metadata.nf.codnatfin.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.codnatfin,"disabled":_vm.isView,"name":"codnatfin","v-errors":_vm.errors,"select2":{ entity: (_vm.nf.operacaonf == 'E' ? 'natfin/despesas' : 'natfin/receitas'), minlength: 0 }},model:{value:(_vm.nf.codnatfin),callback:function ($$v) {_vm.$set(_vm.nf, "codnatfin", $$v)},expression:"nf.codnatfin"}}),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('div',{staticClass:"form-group form-group-sm"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.parcelas}}),_vm._v(" "),_c('div',{staticClass:"input-group input-group-sm"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.parcelas),expression:"parcelas"}],ref:"parcelas",staticClass:"form-control",attrs:{"disabled":_vm.isView},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.parcelas=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.metadata.nf.parcelas.options),function(opt){return _c('option',{key:opt.id,domProps:{"value":opt.id}},[_vm._v(_vm._s(opt.text))])}),0)])],1)]),_vm._v(" "),(_vm.nfpar.length > 0)?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfpar.dias}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfpar.dtv}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfpar.vlr}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfpar.formapag}})],1)]),_vm._v(" "),_vm._l((_vm.nfpar),function(par,index){return _c('div',{key:index,staticClass:"row justify-content-md-center"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfpar.dias.validator),expression:"metadata.nfpar.dias.validator"}],staticClass:"mb-1",attrs:{"type":"number","col":"2","disabled":_vm.isView || _vm.nf.parcelas==='0',"name":"dias","v-errors":_vm.errors},on:{"input":function($event){return _vm.nfparDiasChange(index)}},model:{value:(par.dias),callback:function ($$v) {_vm.$set(par, "dias", $$v)},expression:"par.dias"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfpar.dtv.validator),expression:"metadata.nfpar.dtv.validator"}],staticClass:"mb-1",attrs:{"type":"date","col":"2","disabled":_vm.isView,"name":"dtv","v-errors":_vm.errors},on:{"input":function($event){return _vm.nfparDtvChange(index)}},model:{value:(par.dtv),callback:function ($$v) {_vm.$set(par, "dtv", $$v)},expression:"par.dtv"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfpar.vlr.validator),expression:"metadata.nfpar.vlr.validator"}],staticClass:"mb-1",attrs:{"type":"value","col":"2","precision":2,"disabled":_vm.isView,"name":"vlr","v-errors":_vm.errors},on:{"input":function($event){return _vm.nfparVlrChange(index)}},model:{value:(par.vlr),callback:function ($$v) {_vm.$set(par, "vlr", $$v)},expression:"par.vlr"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.nfpar.formapag,"disabled":_vm.isView,"nolabel":true,"optionnull":true},model:{value:(par.formapag),callback:function ($$v) {_vm.$set(par, "formapag", $$v)},expression:"par.formapag"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(par.error)?_c('div',{staticClass:"col-md-6 mt-n3 mb-2"},[_c('small',{staticClass:"error"},[_vm._v(_vm._s(par.error))])]):_vm._e()],1)})],2):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('label-title',{attrs:{"title":"Informações Adicionais","icon":"fa-info-circle"}}),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[_c('form-field',{attrs:{"type":"select2","col":"6","metadata":_vm.metadata.nf.obs,"disabled":_vm.isView,"select2":{entity: 'mennf', minlength: 0}},model:{value:(_vm.codmenCpl),callback:function ($$v) {_vm.codmenCpl=$$v},expression:"codmenCpl"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.nf.obs),expression:"nf.obs"}],staticClass:"form-control",attrs:{"rows":"6","cols":"100","name":"obs","disabled":_vm.isView},domProps:{"value":(_vm.nf.obs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.nf, "obs", $event.target.value)}}})])])]),_vm._v(" "),(_vm.nf.obsauto)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(_vm.nf.obsauto)+" ")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row col mt-2"},[_c('v-button',{attrs:{"label":"Alterar Outras Informações","title":"","icon":"fa-pencil","nb-btdef":true},on:{"click":_vm.handleAlterarOutras}})],1),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[(_vm.nf.enderet)?_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.nf.enderet}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.nf.enderet)+" "+_vm._s(_vm.nf.endenrret)+" "+_vm._s(_vm.nf.bairroret)+" "+_vm._s(_vm.nf.ufret))])],1):_vm._e(),_vm._v(" "),(_vm.nf.endeent)?_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.nf.endeent}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.nf.endeent)+" "+_vm._s(_vm.nf.endenrent)+" "+_vm._s(_vm.nf.bairroent)+" "+_vm._s(_vm.nf.ufent))])],1):_vm._e()])],1)]),_vm._v(" "),(_vm.showFormItem)?_c('div',[_c('Trap',[_c('nfse-item',{attrs:{"params":_vm.paramItem},on:{"closeform":_vm.closeFormItem,"save":_vm.saveItem}})],1)],1):_vm._e(),_vm._v(" "),(_vm.formCab)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('Trap',[_c('div',{staticClass:"container nb-modal-scrollable-container",attrs:{"id":"mymodal"}},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v(" Outras Informações ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeFormCab()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row"},[(_vm.nf.stnf=='10')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.chave.validator),expression:"metadata.nf.chave.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.nf.chave,"disabled":_vm.isView || _vm.nf.emissaopropria=='S',"name":"chave","v-errors":_vm.errors},model:{value:(_vm.nf.chave),callback:function ($$v) {_vm.$set(_vm.nf, "chave", $$v)},expression:"nf.chave"}}):_vm._e(),_vm._v(" "),(_vm.nf.operacaonf=='E')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.dtent.validator),expression:"metadata.nf.dtent.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.nf.dtent,"disabled":_vm.isView,"name":"dtent","v-errors":_vm.errors},model:{value:(_vm.nf.dtent),callback:function ($$v) {_vm.$set(_vm.nf, "dtent", $$v)},expression:"nf.dtent"}}):_vm._e(),_vm._v(" "),(_vm.nf.operacaonf=='S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.dtsai.validator),expression:"metadata.nf.dtsai.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.nf.dtsai,"disabled":_vm.isView,"name":"dtsai","v-errors":_vm.errors},model:{value:(_vm.nf.dtsai),callback:function ($$v) {_vm.$set(_vm.nf, "dtsai", $$v)},expression:"nf.dtsai"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.indpresencial.validator),expression:"metadata.nf.indpresencial.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.indpresencial,"disabled":_vm.isView,"name":"indpresencial","v-errors":_vm.errors},model:{value:(_vm.nf.indpresencial),callback:function ($$v) {_vm.$set(_vm.nf, "indpresencial", $$v)},expression:"nf.indpresencial"}}),_vm._v(" "),(_vm.nf.indpresencial == '2' || _vm.nf.indpresencial == '3' || _vm.nf.indpresencial == '4' || _vm.nf.indpresencial == '9')?_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nf.indintermed,"disabled":_vm.isView},model:{value:(_vm.nf.indintermed),callback:function ($$v) {_vm.$set(_vm.nf, "indintermed", $$v)},expression:"nf.indintermed"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.movfisica.validator),expression:"metadata.nf.movfisica.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.nf.movfisica,"disabled":_vm.isView,"name":"movfisica","v-errors":_vm.errors},model:{value:(_vm.nf.movfisica),callback:function ($$v) {_vm.$set(_vm.nf, "movfisica", $$v)},expression:"nf.movfisica"}})],1),_vm._v(" "),(!_vm.isView)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[(!_vm.enderecoEntrega)?_c('v-button',{attrs:{"label":"Definir Local de Entrega","title":"","nb-btdef":true},on:{"click":_vm.handleEnderecoEntrega}}):_vm._e(),_vm._v(" "),(!_vm.enderecoRetirada)?_c('v-button',{attrs:{"label":"Definir Local de Retirada","title":"","nb-btdef":true},on:{"click":_vm.handleEnderecoRetirada}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.enderecoRetirada)?_c('div',{attrs:{"id":"entrega"}},[_c('label-title',{staticClass:"mt-2",attrs:{"title":"Endereço de Retirada"}}),_c('br'),_vm._v(" "),(!_vm.isView)?_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Excluir Endereço","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleExcluirEndereco('ret')}}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.tppessoaret.validator),expression:"metadata.nf.tppessoaret.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.tppessoaret,"name":"tppessoaret","v-errors":_vm.errors},model:{value:(_vm.nf.tppessoaret),callback:function ($$v) {_vm.$set(_vm.nf, "tppessoaret", $$v)},expression:"nf.tppessoaret"}}),_vm._v(" "),(_vm.nf.tppessoaret=='J')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({cnpj: true, required: true,  min: 14, max: 14}),expression:"{cnpj: true, required: true,  min: 14, max: 14}"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.nf.cnpjcpfret,"name":"cnpjcpfret","v-errors":_vm.errors},model:{value:(_vm.nf.cnpjcpfret),callback:function ($$v) {_vm.$set(_vm.nf, "cnpjcpfret", $$v)},expression:"nf.cnpjcpfret"}}):_vm._e(),_vm._v(" "),(_vm.nf.tppessoaret=='F')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({cpf: true, required: true,  min: 11, max: 11}),expression:"{cpf: true, required: true,  min: 11, max: 11}"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.nf.cnpjcpfret,"name":"cnpjcpfret","v-errors":_vm.errors},model:{value:(_vm.nf.cnpjcpfret),callback:function ($$v) {_vm.$set(_vm.nf, "cnpjcpfret", $$v)},expression:"nf.cnpjcpfret"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.nomeret.validator),expression:"metadata.nf.nomeret.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.nf.nomeret,"disabled":_vm.isView,"name":"nomeret","v-errors":_vm.errors},model:{value:(_vm.nf.nomeret),callback:function ($$v) {_vm.$set(_vm.nf, "nomeret", $$v)},expression:"nf.nomeret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.emailret.validator),expression:"metadata.nf.emailret.validator"}],attrs:{"type":"email","col":"4","metadata":_vm.metadata.nf.emailret,"disabled":_vm.isView,"name":"emailret","v-errors":_vm.errors},model:{value:(_vm.nf.emailret),callback:function ($$v) {_vm.$set(_vm.nf, "emailret", $$v)},expression:"nf.emailret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.foneret.validator),expression:"metadata.nf.foneret.validator"}],attrs:{"type":"fone","col":"2","metadata":_vm.metadata.nf.foneret,"disabled":_vm.isView,"name":"foneret","v-errors":_vm.errors},model:{value:(_vm.nf.foneret),callback:function ($$v) {_vm.$set(_vm.nf, "foneret", $$v)},expression:"nf.foneret"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.cepret.validator),expression:"metadata.nf.cepret.validator"}],attrs:{"type":"cep","col":"2","metadata":_vm.metadata.nf.cepret,"name":"cepret","v-errors":_vm.errors},on:{"update":_vm.updateCepRet},model:{value:(_vm.nf.cepret),callback:function ($$v) {_vm.$set(_vm.nf, "cepret", $$v)},expression:"nf.cepret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.enderet.validator),expression:"metadata.nf.enderet.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.enderet,"name":"enderet","v-errors":_vm.errors},model:{value:(_vm.nf.enderet),callback:function ($$v) {_vm.$set(_vm.nf, "enderet", $$v)},expression:"nf.enderet"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.endenrret.validator),expression:"metadata.nf.endenrret.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.endenrret,"name":"endenrret","v-errors":_vm.errors},model:{value:(_vm.nf.endenrret),callback:function ($$v) {_vm.$set(_vm.nf, "endenrret", $$v)},expression:"nf.endenrret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.endecompret.validator),expression:"metadata.nf.endecompret.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.endecompret,"name":"endecompret","v-errors":_vm.errors},model:{value:(_vm.nf.endecompret),callback:function ($$v) {_vm.$set(_vm.nf, "endecompret", $$v)},expression:"nf.endecompret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.bairroret.validator),expression:"metadata.nf.bairroret.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.bairroret,"name":"bairroret","v-errors":_vm.errors},model:{value:(_vm.nf.bairroret),callback:function ($$v) {_vm.$set(_vm.nf, "bairroret", $$v)},expression:"nf.bairroret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.ufret.validator),expression:"metadata.nf.ufret.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.ufret,"name":"ufret","v-errors":_vm.errors},model:{value:(_vm.nf.ufret),callback:function ($$v) {_vm.$set(_vm.nf, "ufret", $$v)},expression:"nf.ufret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codmunret.validator),expression:"metadata.nf.codmunret.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.codmunret,"name":"codmunret","v-errors":_vm.errors,"select2":{entity: 'mun/uf/' + _vm.nf.ufret, minlength: 2}},model:{value:(_vm.nf.codmunret),callback:function ($$v) {_vm.$set(_vm.nf, "codmunret", $$v)},expression:"nf.codmunret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codpaisret.validator),expression:"metadata.nf.codpaisret.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.nf.codpaisret,"name":"codpaisret","v-errors":_vm.errors},model:{value:(_vm.nf.codpaisret),callback:function ($$v) {_vm.$set(_vm.nf, "codpaisret", $$v)},expression:"nf.codpaisret"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.enderecoEntrega)?_c('div',{attrs:{"id":"entrega"}},[_c('label-title',{staticClass:"mt-2",attrs:{"title":"Endereço de Entrega"}}),_vm._v(" "),(!_vm.isView)?_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Excluir Endereço","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleExcluirEndereco('ent')}}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.tppessoaent.validator),expression:"metadata.nf.tppessoaent.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.tppessoaent,"name":"tppessoaent","v-errors":_vm.errors},model:{value:(_vm.nf.tppessoaent),callback:function ($$v) {_vm.$set(_vm.nf, "tppessoaent", $$v)},expression:"nf.tppessoaent"}}),_vm._v(" "),(_vm.nf.tppessoaent=='F')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({cpf: true, required: true,  min: 11, max: 11}),expression:"{cpf: true, required: true,  min: 11, max: 11}"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.cnpjcpfent,"name":"cpfent","v-errors":_vm.errors},model:{value:(_vm.nf.cnpjcpfent),callback:function ($$v) {_vm.$set(_vm.nf, "cnpjcpfent", $$v)},expression:"nf.cnpjcpfent"}}):_vm._e(),_vm._v(" "),(_vm.nf.tppessoaent=='J')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({cnpj: true, required: true,  min: 14, max: 14}),expression:"{cnpj: true, required: true,  min: 14, max: 14}"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.cnpjcpfent,"name":"cnpjent","v-errors":_vm.errors},model:{value:(_vm.nf.cnpjcpfent),callback:function ($$v) {_vm.$set(_vm.nf, "cnpjcpfent", $$v)},expression:"nf.cnpjcpfent"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.nomeent.validator),expression:"metadata.nf.nomeent.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.nf.nomeent,"disabled":_vm.isView,"name":"nomeent","v-errors":_vm.errors},model:{value:(_vm.nf.nomeent),callback:function ($$v) {_vm.$set(_vm.nf, "nomeent", $$v)},expression:"nf.nomeent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.emailent.validator),expression:"metadata.nf.emailent.validator"}],attrs:{"type":"email","col":"4","metadata":_vm.metadata.nf.emailent,"disabled":_vm.isView,"name":"emailent","v-errors":_vm.errors},model:{value:(_vm.nf.emailent),callback:function ($$v) {_vm.$set(_vm.nf, "emailent", $$v)},expression:"nf.emailent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.foneent.validator),expression:"metadata.nf.foneent.validator"}],attrs:{"type":"fone","col":"2","metadata":_vm.metadata.nf.foneent,"disabled":_vm.isView,"name":"foneent","v-errors":_vm.errors},model:{value:(_vm.nf.foneent),callback:function ($$v) {_vm.$set(_vm.nf, "foneent", $$v)},expression:"nf.foneent"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.cepent.validator),expression:"metadata.nf.cepent.validator"}],attrs:{"type":"cep","col":"2","metadata":_vm.metadata.nf.cepent,"name":"cepent","v-errors":_vm.errors},on:{"update":_vm.updateCepEnt},model:{value:(_vm.nf.cepent),callback:function ($$v) {_vm.$set(_vm.nf, "cepent", $$v)},expression:"nf.cepent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.endeent.validator),expression:"metadata.nf.endeent.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.endeent,"name":"endeent","v-errors":_vm.errors},model:{value:(_vm.nf.endeent),callback:function ($$v) {_vm.$set(_vm.nf, "endeent", $$v)},expression:"nf.endeent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.endenrent.validator),expression:"metadata.nf.endenrent.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.endenrent,"name":"endenrent","v-errors":_vm.errors},model:{value:(_vm.nf.endenrent),callback:function ($$v) {_vm.$set(_vm.nf, "endenrent", $$v)},expression:"nf.endenrent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.endecompent.validator),expression:"metadata.nf.endecompent.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.endecompent,"name":"endecompent","v-errors":_vm.errors},model:{value:(_vm.nf.endecompent),callback:function ($$v) {_vm.$set(_vm.nf, "endecompent", $$v)},expression:"nf.endecompent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.bairroent.validator),expression:"metadata.nf.bairroent.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.nf.bairroent,"name":"bairroent","v-errors":_vm.errors},model:{value:(_vm.nf.bairroent),callback:function ($$v) {_vm.$set(_vm.nf, "bairroent", $$v)},expression:"nf.bairroent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.ufent.validator),expression:"metadata.nf.ufent.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.ufent,"name":"ufent","v-errors":_vm.errors},model:{value:(_vm.nf.ufent),callback:function ($$v) {_vm.$set(_vm.nf, "ufent", $$v)},expression:"nf.ufent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codmunent.validator),expression:"metadata.nf.codmunent.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.codmunent,"name":"codmunent","v-errors":_vm.errors,"select2":{entity: 'mun/uf/' + _vm.nf.ufent, minlength: 2}},model:{value:(_vm.nf.codmunent),callback:function ($$v) {_vm.$set(_vm.nf, "codmunent", $$v)},expression:"nf.codmunent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codpaisent.validator),expression:"metadata.nf.codpaisent.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.nf.codpaisent,"name":"codpaisent","v-errors":_vm.errors},model:{value:(_vm.nf.codpaisent),callback:function ($$v) {_vm.$set(_vm.nf, "codpaisent", $$v)},expression:"nf.codpaisent"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.selectedNates && _vm.selectedNates.calcdup == 'S')?_c('div',{staticClass:"mt-5"},[_c('label-title',{staticClass:"mt-2",attrs:{"title":"Retenção de Impostos"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.calcreten.validator),expression:"metadata.nf.calcreten.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.calcreten,"disabled":_vm.isView,"name":"calcreten","v-errors":_vm.errors},model:{value:(_vm.nf.calcreten),callback:function ($$v) {_vm.$set(_vm.nf, "calcreten", $$v)},expression:"nf.calcreten"}})],1),_vm._v(" "),(_vm.nf.calcreten=='S')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pretcsll.validator),expression:"metadata.nf.pretcsll.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pretcsll,"disabled":_vm.isView,"name":"pretcsll","v-errors":_vm.errors,"addon":"%"},model:{value:(_vm.nf.pretcsll),callback:function ($$v) {_vm.$set(_vm.nf, "pretcsll", $$v)},expression:"nf.pretcsll"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pretpis.validator),expression:"metadata.nf.pretpis.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pretpis,"disabled":_vm.isView,"name":"pretpis","v-errors":_vm.errors,"addon":"%"},model:{value:(_vm.nf.pretpis),callback:function ($$v) {_vm.$set(_vm.nf, "pretpis", $$v)},expression:"nf.pretpis"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pretcofins.validator),expression:"metadata.nf.pretcofins.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pretcofins,"disabled":_vm.isView,"name":"pretcofins","v-errors":_vm.errors,"addon":"%"},model:{value:(_vm.nf.pretcofins),callback:function ($$v) {_vm.$set(_vm.nf, "pretcofins", $$v)},expression:"nf.pretcofins"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pretinss.validator),expression:"metadata.nf.pretinss.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pretinss,"disabled":_vm.isView,"name":"pretinss","v-errors":_vm.errors,"addon":"%"},model:{value:(_vm.nf.pretinss),callback:function ($$v) {_vm.$set(_vm.nf, "pretinss", $$v)},expression:"nf.pretinss"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.pretirrf.validator),expression:"metadata.nf.pretirrf.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pretirrf,"disabled":_vm.isView,"name":"pretirrf","v-errors":_vm.errors,"addon":"%"},model:{value:(_vm.nf.pretirrf),callback:function ($$v) {_vm.$set(_vm.nf, "pretirrf", $$v)},expression:"nf.pretirrf"}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer mt-2"},[(!_vm.isView)?_c('v-button',{ref:"btnConfirm",attrs:{"label":"Salvar","title":"","nb-btdef":true},on:{"click":_vm.handleSalvarDadosAdicionais}}):_vm._e(),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeFormCab}})],1)])])])],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab == 1),expression:"activeTab == 1"}]},[(_vm.nf.nfxml && _vm.nf.nfxml.length > 0 && _vm.nf.nfxml[0].nprotcan)?_c('div',{staticClass:"mainbox"},[_c('div',{staticClass:"mark-green"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.dtcan}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.nf.dtcan)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfxml.nprot}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.nf.nfxml[0].nprotcan))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.obscan}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.nf.obscan)+" ")])],1)])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.nfPossuiEvento)?_c('div',[_c('alert',{attrs:{"type":"info","title":"Aviso","text":"Esta nota fiscal ainda não possui eventos vinculados."}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.nf.nfev),function(ev,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"mark-green"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfev.data}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(ev.data)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfev.nprot}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ev.nprot))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfev.texto}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(ev.texto)+" ")])],1)])])])})],2),_vm._v(" "),(_vm.DELETE_ITEM_MESSAGE)?_c('md-message',{attrs:{"code":"deleteit"},on:{"close":function($event){return _vm.handleCloseMessage()},"confirm":function($event){return _vm.handleDeleteItem()}}}):_vm._e(),_vm._v(" "),(_vm.showNumeroForm)?_c('nf-form-numero',{attrs:{"nf":_vm.nf},on:{"closeform":_vm.closeNumeroForm,"save":_vm.updateNumero}}):_vm._e(),_vm._v(" "),(_vm.showPartForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"nb-modal-scrollable-container",staticStyle:{"padding":"15px","width":"80%"}},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('customer-form',{attrs:{"crud":_vm.crudPart,"index":_vm.codpart},on:{"closeform":_vm.closeCustomerForm}})],1)])]):_vm._e(),_vm._v(" "),(_vm.showNatesForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('Trap',[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('nates-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closeNatesForm}})],1)])])],1):_vm._e(),_vm._v(" "),(_vm.showCancel)?_c('div',{staticClass:"nb-modal-mask"},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"max-height":"255px","overflow-y":"auto"}},[(_vm.errCorrecao.length != 0)?_c('div',[_c('div',{staticClass:"col"},[_c('div',{staticClass:"alert alert-danger fade show",attrs:{"role":"alert"}},[_c('h5',{staticClass:"alert-heading"},[_vm._v("Erro ao enviar pedido de cancelamento: ")]),_vm._v(" "),_vm._l((_vm.errCorrecao),function(err,index){return _c('p',{key:index},[_c('small',[_vm._v(_vm._s(err))])])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('label',{staticClass:"lbl"},[_vm._v("Informe a justificativa do cancelamento:")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.nf.obscan),expression:"nf.obscan"}],ref:"correcao",staticClass:"form-control",attrs:{"rows":"5","cols":"100"},domProps:{"value":(_vm.nf.obscan)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.nf, "obscan", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"lbl"},[_vm._v("O texto deve possuir no mínimo 15 e no máximo 255 caracteres")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"label":"Confirmar Cancelamento","title":"","nb-btdef":true,"icon":"fa-check"},on:{"click":_vm.handleCancel}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Descartar","title":"","icon":"fa-rotate-left"},on:{"click":_vm.handleCancelDiscard}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.showFormEmail)?_c('email-form',{attrs:{"index":_vm.nf.codnf,"tipo":"DANFE","title":"Envio de Danfe"},on:{"closeform":_vm.closeFormEmail,"send":_vm.handleSendEmail}}):_vm._e(),_vm._v(" "),(_vm.modalExcluir)?_c('md-message',{attrs:{"code":"delete"},on:{"confirm":function($event){return _vm.handleExcluir()},"close":function($event){return _vm.closeModal()}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v("Incluir Nota Fiscal")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"def-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Cancelamento de Nota Fiscal")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1640);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("541599b9", content, true, {});

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-icon-link{font-size:32px;color:red;text-align:center}.nb-icon-ok{font-size:32px;color:#adff2f}", ""]);

// exports


/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"default-container"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v(" "+_vm._s(_vm.title)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"float-right"},[_c('v-button',{attrs:{"label":"Retornar","title":"","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}}),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.moreActions.length > 0),expression:"moreActions.length > 0"}],attrs:{"label":"Mais Ações","actions":_vm.moreActions},on:{"click":_vm.handleActions}})],1)])]),_vm._v(" "),(_vm.errmessages.errmessages)?_c('validation',{staticClass:"mt-3",attrs:{"title":"Erros de validação","messages":_vm.errmessages.errmessages}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFormImportXML),expression:"showFormImportXML"}]},[_c('div',{staticClass:"row col mb-2 align-items-center"},[_c('span',{staticClass:"lbl-title-produto",staticStyle:{"font-size":"24px","padding":"5px","background-color":"#f0f0f0"}},[_vm._v(_vm._s(_vm.nf.serie))]),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto",staticStyle:{"font-size":"24px","padding":"5px","background-color":"#f0f0f0"}},[_vm._v(_vm._s(_vm.nf.nf))])]),_vm._v(" "),_c('div',{staticClass:"row col"},[(_vm.nf.stnf == '00')?_c('span',{staticClass:"badge badge-orange mr-2"},[_vm._v(_vm._s(_vm._f("getTextOption")(_vm.nf.stnf,_vm.metadata.nf.stnf)))]):_vm._e(),_vm._v(" "),(_vm.nf.stnf == '01')?_c('span',{staticClass:"badge badge-blue mr-2"},[_vm._v(_vm._s(_vm._f("getTextOption")(_vm.nf.stnf,_vm.metadata.nf.stnf)))]):_vm._e(),_vm._v(" "),(_vm.nf.stnf == '10' || _vm.nf.stnf == '11')?_c('span',{staticClass:"badge badge-green mr-2"},[_vm._v(_vm._s(_vm._f("getTextOption")(_vm.nf.stnf,_vm.metadata.nf.stnf)))]):_vm._e(),_vm._v(" "),(_vm.nf.stnf >= '50')?_c('span',{staticClass:"badge badge-red mr-2"},[_vm._v(_vm._s(_vm._f("getTextOption")(_vm.nf.stnf,_vm.metadata.nf.stnf)))]):_vm._e(),_vm._v(" "),(_vm.nf.entradaarmazenamento == 'S')?_c('span',{staticClass:"badge badge-gray mr-2"},[_vm._v("Entrada Armazenamento")]):_vm._e(),_vm._v(" "),(_vm.nf.emissaopropria == 'S')?_c('span',{staticClass:"badge badge-yellow mr-2"},[_vm._v("Nota Fiscal Própria")]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.data}}),_c('br'),_vm._v(" "),_c('strong',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.nf.data)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totger}}),_c('br'),_vm._v(" "),_c('strong',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(this.nf.totger,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.chave}}),_c('br'),_vm._v(" "),_c('strong',{staticClass:"lbl",staticStyle:{"white-space":"initial !important","word-break":"break-all !important"}},[_vm._v(" "+_vm._s(_vm.nf.chave)+"\n          ")])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label-title',{attrs:{"title":"Organização","icon":"fa-university"}}),_vm._v(" "),_c('div',{staticClass:"row col mb-2"},[_c('input-part',{ref:"part",attrs:{"disabled":true},model:{value:(_vm.nf.codpart),callback:function ($$v) {_vm.$set(_vm.nf, "codpart", $$v)},expression:"nf.codpart"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.dtent.validator),expression:"metadata.nf.dtent.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.nf.dtent,"name":"dtent","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.nf.dtent),callback:function ($$v) {_vm.$set(_vm.nf, "dtent", $$v)},expression:"nf.dtent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.finalidade.validator),expression:"metadata.nf.finalidade.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.nf.finalidade,"name":"finalidade","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.nf.finalidade),callback:function ($$v) {_vm.$set(_vm.nf, "finalidade", $$v)},expression:"nf.finalidade"}}),_vm._v(" "),(_vm.nf.tpnf === 'CR')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.nf.tpnfcredito,"name":"tpnfcredito","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.nf.tpnfcredito),callback:function ($$v) {_vm.$set(_vm.nf, "tpnfcredito", $$v)},expression:"nf.tpnfcredito"}}):_vm._e(),_vm._v(" "),(_vm.nf.tpnf === 'DB')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.nf.tpnfdebito,"name":"tpnfdebito","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.nf.tpnfdebito),callback:function ($$v) {_vm.$set(_vm.nf, "tpnfdebito", $$v)},expression:"nf.tpnfdebito"}}):_vm._e()],1),_vm._v(" "),_vm._l((_vm.nf.cfop_natureza),function(cfop,index){return _c('div',{staticClass:"row mb-2",attrs:{"index":index}},[_c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("Selecione uma natureza para a CFOP "+_vm._s(cfop.cfop)+" ")])]),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codnates.validator),expression:"metadata.nf.codnates.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.codnates,"select2":{ entity: 'nates/entrada', minlength: 0 },"name":'codnates' + index,"v-errors":_vm.errors,"disabled":_vm.isView},on:{"input":function($event){return _vm.handleChangeCFOP(index)}},model:{value:(cfop.codnates),callback:function ($$v) {_vm.$set(cfop, "codnates", $$v)},expression:"cfop.codnates"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.cfop.validator),expression:"metadata.nf.cfop.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.cfop,"select2":{ entity: 'cfop/entradas', minlength: 0, maxWidth: '200px' },"name":'cfop' + index,"v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(cfop.cfopentrada),callback:function ($$v) {_vm.$set(cfop, "cfopentrada", $$v)},expression:"cfop.cfopentrada"}})],1)}),_vm._v(" "),(_vm.showNfRef)?_c('nf-form-ref',{attrs:{"nfref":_vm.nfref,"nf":"nf"}}):_vm._e()],2)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('tabs',{attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab == 0),expression:"activeTab == 0"}],staticClass:"default-container"},[(this.nfit.length == 0)?_c('alert',{attrs:{"type":"info","text":"Esta nota fiscal não possui itens."}}):_vm._e(),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{},_vm._l((_vm.nfit),function(it,index){return _c('div',{key:it.itnf,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[(it.nfitx[0].msg)?_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"alert alert-danger fade show",attrs:{"role":"alert"}},[_c('span',[_vm._v(_vm._s(it.nfitx[0].msg))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-10 d-flex justify-content-between align-items-end p-0"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfit.coditem.validator),expression:"metadata.nfit.coditem.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.nfit.coditem,"name":"coditem","v-errors":_vm.errors,"add-button":true,"disabled":_vm.isView},on:{"clickAdd":function($event){return _vm.handleIncluirItem(index)},"input":function($event){return _vm.itemChange(index)}},model:{value:(it.coditem),callback:function ($$v) {_vm.$set(it, "coditem", $$v)},expression:"it.coditem"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfit.qtuni.validator),expression:"metadata.nfit.qtuni.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nfit.qtuni,"name":"qtuni","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(it.qtuni),callback:function ($$v) {_vm.$set(it, "qtuni", $$v)},expression:"it.qtuni"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfit.uni.validator),expression:"metadata.nfit.uni.validator"}],attrs:{"type":"select2","col":"2","metadata":_vm.metadata.nfit.uni,"name":"uni","v-errors":_vm.errors,"add-button":true,"disabled":_vm.isView},on:{"clickAdd":function($event){return _vm.handleIncluirUnimed(index)},"input":function($event){return _vm.unidadeItemChange(index)}},model:{value:(it.uni),callback:function ($$v) {_vm.$set(it, "uni", $$v)},expression:"it.uni"}}),_vm._v(" "),_c('form-field',{directives:[{name:"show",rawName:"v-show",value:(it.obrigaFator),expression:"it.obrigaFator"},{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfit.fator.validator),expression:"metadata.nfit.fator.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.nfit.fator,"name":"fator","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(it.fator),callback:function ($$v) {_vm.$set(it, "fator", $$v)},expression:"it.fator"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(it.coditem == null || it.coditem == ''),expression:"it.coditem == null || it.coditem == ''"}],staticClass:"error"},[_c('i',{staticClass:"fa fa-unlink nb-icon-link",attrs:{"aria-hidden":"true","data-toggle":"tooltip","data-placement":"top","title":"Produto ainda não foi vinculado, ao Confirmar Nota de Entrada o produto será automaticamente cadastrado no sistema."}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(it.coditem != '' && it.coditem != null),expression:"it.coditem != '' && it.coditem != null"}]},[_c('i',{staticClass:"fa fa-check nb-icon-ok pt-4",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('div',{staticClass:"row m-3",staticStyle:{"background":"#f7f7f7"}},[_c('div',{staticClass:"col-12 mb-3"},[_c('strong',{staticClass:"data-list-sm",staticStyle:{"white-space":"initial !important","word-break":"break-all !important"}},[_vm._v(_vm._s(it.nfitx[0].descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('v-label',{staticClass:"lbl-edit-sm",staticStyle:{"white-space":"initial !important","word-break":"break-all !important"},attrs:{"metadata-field":_vm.metadata.nfitx.codigoxml}}),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(it.nfitx[0].codigoxml))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12 d-md-block d-none"},[_c('v-label',{staticClass:"lbl-edit-sm",attrs:{"label":"CFOP"}}),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col-md col-12 d-md-block d-none"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(it.nfitx[0].cfop))])]),_vm._v(" "),(it.item[0])?_c('div',{staticClass:"col-md-2 col-12 d-md-block d-none"},[_c('v-label',{staticClass:"lbl-edit-sm",attrs:{"label":"Uni. Item Cadastro"}}),_c('br')],1):_vm._e(),_vm._v(" "),(it.item[0])?_c('div',{staticClass:"col-md col-12 d-md-block d-none"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(it.item[0].uni))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('v-label',{staticClass:"lbl-edit-sm",attrs:{"metadata-field":_vm.metadata.nfitx.qt}}),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("format")(it.nfitx[0].qt,4))+" "+_vm._s(it.nfitx[0].uni))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('v-label',{staticClass:"lbl-edit-sm",attrs:{"metadata-field":_vm.metadata.nfitx.vlr}}),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("format")(it.nfitx[0].vlr,4)))])]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-2 d-md-block d-none"},[_c('v-label',{staticClass:"lbl-edit-sm",attrs:{"metadata-field":_vm.metadata.nfit.sticm}}),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col d-md-block d-none"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(it.sticm))])]),_vm._v(" "),_c('div',{staticClass:"col-2 d-md-block d-none"},[_c('v-label',{staticClass:"lbl-edit-sm",attrs:{"metadata-field":_vm.metadata.nfit.vicm}}),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col d-md-block d-none"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("format")(it.aicm,2))+" %")]),_vm._v(" "),_c('span',{staticClass:"data-list-sm"},[_vm._v("R$ "+_vm._s(_vm._f("format")(it.vicm,2)))])]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-2 d-md-block d-none"},[_c('v-label',{staticClass:"lbl-edit-sm",attrs:{"metadata-field":_vm.metadata.nfit.vicmst}}),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col d-md-block d-none"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("format")(it.aicmst,2))+" %")]),_vm._v(" "),_c('span',{staticClass:"data-list-sm"},[_vm._v("R$ "+_vm._s(_vm._f("format")(it.vicmst,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-2 d-md-block d-none"},[_c('v-label',{staticClass:"lbl-edit-sm",attrs:{"metadata-field":_vm.metadata.nfit.vipi}}),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col d-md-block d-none"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("format")(it.aipi,2))+" %")]),_vm._v(" "),_c('span',{staticClass:"data-list-sm"},[_vm._v("R$ "+_vm._s(_vm._f("format")(it.vipi,2)))])]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-2 d-md-block d-none"},[_c('v-label',{staticClass:"lbl-edit-sm",attrs:{"metadata-field":_vm.metadata.nfit.vpis}}),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col d-md-block d-none"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("format")(it.apis,2))+" %")]),_vm._v(" "),_c('span',{staticClass:"data-list-sm"},[_vm._v("R$ "+_vm._s(_vm._f("format")(it.vpis,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-2 d-md-block d-none"},[_c('v-label',{staticClass:"lbl-edit-sm",attrs:{"metadata-field":_vm.metadata.nfit.vcofins}}),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col d-md-block d-none"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("format")(it.acofins,2))+" %")]),_vm._v(" "),_c('span',{staticClass:"data-list-sm"},[_vm._v("R$ "+_vm._s(_vm._f("format")(it.vcofins,2)))])])])])])}),0)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formCab || _vm.activeTab == 3),expression:"formCab || activeTab == 3"}],staticClass:"default-container",attrs:{"id":"formCab"}},[_c('div',{staticClass:"col"},[_c('label-title',{attrs:{"title":"Totalização da Nota"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totipi}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.totipi,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totii}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.totii,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.vcredsn}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.vcredsn,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.tottrib}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.tottrib,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totmer}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.totmer,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totger}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.totger,2)))])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label-title',{attrs:{"title":"Despesas"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.vlrfre}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.vlrfre,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.vlrseg}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.vlrseg,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.vlrdesp}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.vlrdesp,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totdes}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.totdes,2)))])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label-title',{attrs:{"title":"ICMS"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.bcicm}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.bcicm,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.toticm}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.toticm,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totfcp}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.totfcp,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.bcicmst}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.bcicmst,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.toticmst}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.toticmst,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totfcpst}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.totfcpst,2)))])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label-title',{attrs:{"title":"DIFAL"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.toticmemit}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.toticmemit,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.toticmdest}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.toticmdest,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totfcpdest}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.dest,2)))])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label-title',{attrs:{"title":"PIS e COFINS"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.bcpis}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.bcpis,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totpis}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.totpis,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totpisst}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.totpisst,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.bccofins}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.bccofins,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totcofins}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.totcofins,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.totcofinsst}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.totcofinsst,2)))])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label-title',{attrs:{"title":"Retenções"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.vretcsll}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.vretcsll,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.vretirrf}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.vretirrf,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.vretinss}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.vretinss,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.vretpis}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.vretpis,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.vretcofins}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(_vm.nf.vretcofins,2)))])],1)])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab == 1),expression:"activeTab == 1"}],staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.movest,"disabled":true},model:{value:(_vm.nf.movest),callback:function ($$v) {_vm.$set(_vm.nf, "movest", $$v)},expression:"nf.movest"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.movterc,"disabled":true},model:{value:(_vm.nf.movterc),callback:function ($$v) {_vm.$set(_vm.nf, "movterc", $$v)},expression:"nf.movterc"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.creicm,"disabled":true},model:{value:(_vm.nf.creicm),callback:function ($$v) {_vm.$set(_vm.nf, "creicm", $$v)},expression:"nf.creicm"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.creipi,"disabled":true},model:{value:(_vm.nf.creipi),callback:function ($$v) {_vm.$set(_vm.nf, "creipi", $$v)},expression:"nf.creipi"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.crepis,"disabled":true},model:{value:(_vm.nf.crepis),callback:function ($$v) {_vm.$set(_vm.nf, "crepis", $$v)},expression:"nf.crepis"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.nf.crecofins,"disabled":true},model:{value:(_vm.nf.crecofins),callback:function ($$v) {_vm.$set(_vm.nf, "crecofins", $$v)},expression:"nf.crecofins"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Transporte"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"4","metadata":_vm.metadata.nf.tpfrete,"disabled":true},model:{value:(_vm.nf.tpfrete),callback:function ($$v) {_vm.$set(_vm.nf, "tpfrete", $$v)},expression:"nf.tpfrete"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select2","col":"4","metadata":_vm.metadata.nf.codparttr,"disabled":true},model:{value:(_vm.nf.codparttr),callback:function ($$v) {_vm.$set(_vm.nf, "codparttr", $$v)},expression:"nf.codparttr"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.placa,"disabled":true},model:{value:(_vm.nf.placa),callback:function ($$v) {_vm.$set(_vm.nf, "placa", $$v)},expression:"nf.placa"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","col":"2","metadata":_vm.metadata.nf.placauf,"disabled":true},model:{value:(_vm.nf.placauf),callback:function ($$v) {_vm.$set(_vm.nf, "placauf", $$v)},expression:"nf.placauf"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vlrfre,"disabled":true},model:{value:(_vm.nf.vlrfre),callback:function ($$v) {_vm.$set(_vm.nf, "vlrfre", $$v)},expression:"nf.vlrfre"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vlrseg,"disabled":true},model:{value:(_vm.nf.vlrseg),callback:function ($$v) {_vm.$set(_vm.nf, "vlrseg", $$v)},expression:"nf.vlrseg"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vlrdesp,"disabled":true},model:{value:(_vm.nf.vlrdesp),callback:function ($$v) {_vm.$set(_vm.nf, "vlrdesp", $$v)},expression:"nf.vlrdesp"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pliq,"disabled":true},model:{value:(_vm.nf.pliq),callback:function ($$v) {_vm.$set(_vm.nf, "pliq", $$v)},expression:"nf.pliq"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pbru,"disabled":true},model:{value:(_vm.nf.pbru),callback:function ($$v) {_vm.$set(_vm.nf, "pbru", $$v)},expression:"nf.pbru"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.qtvolumes,"disabled":_vm.isView},model:{value:(_vm.nf.qtvolumes),callback:function ($$v) {_vm.$set(_vm.nf, "qtvolumes", $$v)},expression:"nf.qtvolumes"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Informações Complementares"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.obs}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.nf.obs))])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.obsfisco}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.nf.obsfisco))])],1)])]),_vm._v(" "),_c('label-title',{attrs:{"title":"Retenções de Tributos"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vretcsll,"disabled":true},model:{value:(_vm.nf.vretcsll),callback:function ($$v) {_vm.$set(_vm.nf, "vretcsll", $$v)},expression:"nf.vretcsll"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pretpis,"disabled":true},model:{value:(_vm.nf.pretpis),callback:function ($$v) {_vm.$set(_vm.nf, "pretpis", $$v)},expression:"nf.pretpis"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vretpis,"disabled":true},model:{value:(_vm.nf.vretpis),callback:function ($$v) {_vm.$set(_vm.nf, "vretpis", $$v)},expression:"nf.vretpis"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pretcofins,"disabled":true},model:{value:(_vm.nf.pretcofins),callback:function ($$v) {_vm.$set(_vm.nf, "pretcofins", $$v)},expression:"nf.pretcofins"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vretcofins,"disabled":true},model:{value:(_vm.nf.vretcofins),callback:function ($$v) {_vm.$set(_vm.nf, "vretcofins", $$v)},expression:"nf.vretcofins"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pretinss,"disabled":true},model:{value:(_vm.nf.pretinss),callback:function ($$v) {_vm.$set(_vm.nf, "pretinss", $$v)},expression:"nf.pretinss"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vretinss,"disabled":true},model:{value:(_vm.nf.vretinss),callback:function ($$v) {_vm.$set(_vm.nf, "vretinss", $$v)},expression:"nf.vretinss"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.pretirrf,"disabled":true},model:{value:(_vm.nf.pretirrf),callback:function ($$v) {_vm.$set(_vm.nf, "pretirrf", $$v)},expression:"nf.pretirrf"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.nf.vretirrf,"disabled":true},model:{value:(_vm.nf.vretirrf),callback:function ($$v) {_vm.$set(_vm.nf, "vretirrf", $$v)},expression:"nf.vretirrf"}})],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab == 2),expression:"activeTab == 2"}],staticClass:"default-container",attrs:{"id":"formPar"}},[_c('label-title',{attrs:{"title":"Pagamento"}}),_c('br'),_vm._v(" "),(_vm.selectedNates && _vm.selectedNates.calcdup != 'S')?_c('div',[_c('alert',{attrs:{"type":"info","text":"A natureza atribuída à esta nota fiscal não permite informar parcelas."}})],1):_vm._e(),_vm._v(" "),(_vm.selectedNates && _vm.selectedNates.calcdup == 'S')?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-6"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nf.codnatfin.validator),expression:"metadata.nf.codnatfin.validator"}],attrs:{"type":"select2","col":"12","metadata":_vm.metadata.nf.codnatfin,"name":"codnatfin","v-errors":_vm.errors,"select2":{ entity: 'natfin/despesas/', minlength: 0 }},model:{value:(_vm.nf.codnatfin),callback:function ($$v) {_vm.$set(_vm.nf, "codnatfin", $$v)},expression:"nf.codnatfin"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('div',{staticClass:"form-group"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nf.parcelas}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.nf.parcelas),expression:"nf.parcelas"}],staticClass:"form-control form-control-sm",attrs:{"name":"parcelas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.nf, "parcelas", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.metadata.nf.parcelas.options),function(opt){return _c('option',{key:opt.id,domProps:{"value":opt.id}},[_vm._v(_vm._s(opt.text)+"\n              ")])}),0)],1)])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfpar.dias}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfpar.dtv}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.nfpar.vlr}})],1)]),_vm._v(" "),_vm._l((_vm.nfpar),function(par,index){return _c('div',{key:index,staticClass:"row justify-content-md-center"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfpar.dias.validator),expression:"metadata.nfpar.dias.validator"}],attrs:{"type":"number","col":"2","disabled":_vm.isView || _vm.nf.parcelas === '0',"name":"dias","v-errors":_vm.errors},on:{"input":function($event){return _vm.nfparDiasChange(index)}},model:{value:(par.dias),callback:function ($$v) {_vm.$set(par, "dias", $$v)},expression:"par.dias"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfpar.dtv.validator),expression:"metadata.nfpar.dtv.validator"}],attrs:{"type":"date","col":"2","disabled":_vm.isView,"name":"dtv","v-errors":_vm.errors},model:{value:(par.dtv),callback:function ($$v) {_vm.$set(par, "dtv", $$v)},expression:"par.dtv"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.nfpar.vlr.validator),expression:"metadata.nfpar.vlr.validator"}],attrs:{"type":"value","col":"2","precision":2,"disabled":_vm.isView,"name":"vlr","v-errors":_vm.errors},on:{"input":function($event){return _vm.nfparVlrChange(index)}},model:{value:(par.vlr),callback:function ($$v) {_vm.$set(par, "vlr", $$v)},expression:"par.vlr"}})],1)})],2):_vm._e()],1),_vm._v(" "),(_vm.entradaArmazenamentoPendente)?_c('div',[_c('alert',{attrs:{"type":"info","title":"Nota Pendente de Armazenamento","text":_vm.entradaArmazenamentoPendente}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Confirmar Nota de Entrada","title":"Conclui a digitação da nota fiscal de entrada","nb-btdef":true,"icon":"fa-check"},on:{"click":_vm.handleConcluirImportXml}}),_vm._v(" "),(_vm.entradaArmazenamentoPendente)?_c('v-button',{attrs:{"label":"Armazenar Nota","title":"","icon":""},on:{"click":_vm.handleArmazenarEntrada}}):_vm._e()],1)]),_vm._v(" "),(_vm.showItemForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"max-width":"700px"}},[_c('div',{staticClass:"nb-modal-scrollable-body",attrs:{"id":"mymodal"}},[_c('item-form',{attrs:{"crud":_vm.crudItem,"import-xml":_vm.paramsCadastro},on:{"closeform":_vm.closeItemForm}})],1)])]):_vm._e(),_vm._v(" "),(_vm.showUnimedForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"max-width":"700px"}},[_c('div',{staticClass:"nb-modal-scrollable-body mb-3",attrs:{"id":"mymodal"}},[_c('unimed-form',{attrs:{"crud":_vm.crudItem,"import-xml":_vm.paramsCadastro},on:{"closeform":_vm.closeUnimedForm}})],1)])]):_vm._e(),_vm._v(" "),(_vm.showFormEstoqueEntrada)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"nb-modal-scrollable-container",staticStyle:{"padding":"15px","width":"90%"}},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('estoque-entrada',{attrs:{"index":_vm.nf.codnf,"excluir":_vm.excluirArmazenamento},on:{"closeform":_vm.closeArmazenarForm}})],1)])]):_vm._e(),_vm._v(" "),(_vm.showEventos)?_c('nfe-eventos-form',{attrs:{"nf":_vm.nf},on:{"close":function($event){_vm.showEventos = false},"success":_vm.loadData}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm && !_vm.showFormNfse && !_vm.showFormImportXML),expression:"!showForm && !showFormNfse && !showFormImportXML"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"filter-button":true,"pdf-button":false,"xls-button":false,"filter-month":true,"adv-filters-object":_vm.filtroAvancado,"field-month":'datalancamento',"single-entity":_vm.title,"plural-entity":_vm.titlePl,"moreActions":_vm.moreActionsBarList,"incluirActions":_vm.incluirActionsBarList,"month-filter":_vm.monthFilter,"title-search":"Pesquise pelo número da nota ou pelo nome do cliente/fornecedor"},on:{"action":_vm.handleActionBarList,"search":_vm.handleSearch,"new":_vm.handleNew,"refresh":_vm.loadData,"filter":_vm.handleChangeFilter,"advancedfilter":_vm.handleChangeAdvancedFilter}}),_vm._v(" "),(_vm.inutCount > 0)?_c('div',{staticClass:"row col mt-2"},[_c('span',{staticClass:"badge badge-red"},[_vm._v("Existem inutilizações pendentes a serem enviadas")])]):_vm._e(),_vm._v(" "),(_vm.nfCount > 0)?_c('div',{staticClass:"row col mt-2"},[_c('span',{staticClass:"badge badge-red"},[_vm._v("Existem notas fiscais pendentes a serem enviadas")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"default-container mt-2"},[(_vm.nfList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),(_vm.showVideo && _vm.operacao != 'entrada' && _vm.operacao != 'servico')?_c('div',{staticClass:"mt-5 mb-5 row col justify-content-center"},[_c('iframe',{staticStyle:{"max-width":"800px"},attrs:{"width":"560","height":"315","src":"//www.youtube.com/embed/kxjxOHP8rRs","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.nfList),function(nf){return _c('div',{key:nf.codnf,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('span',{staticClass:"lbl-title-produto w-100"},[_vm._v(_vm._s(nf.nome))]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(nf.cnpjcpf)))]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(nf.uf))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('label',{staticClass:"lbl-list w-md-100 w-auto"},[_vm._v("Série/Número/Data")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(nf.serie)+" - "+_vm._s(nf.nf))]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(nf.data)))])]),_vm._v(" "),(_vm.operacao != 'servico')?_c('div',{staticClass:"col-md-2 col-12"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Natureza")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(nf.descricao))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Total")]),_vm._v(" "),_c('span',{staticClass:"data-list d-flex"},[_vm._v("R$ "),_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(nf.totger,2)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 mb-2"},[(nf.tpnf == 'S')?_c('span',{staticClass:"float-right badge badge-blue"},[_vm._v("NFS-e")]):_vm._e(),_vm._v(" "),(nf.esp == '65')?_c('span',{staticClass:"float-right badge badge-blue"},[_vm._v("NFC-e")]):_vm._e(),_vm._v(" "),(nf.esp == '59')?_c('span',{staticClass:"float-right badge badge-blue"},[_vm._v("SAT")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"float-right badge",class:[{ 'badge-green': nf.stnf == '10' || nf.stnf == '11' }, { 'badge-orange': nf.stnf == '00' }, { 'badge-orange': nf.stnf == '03' }, { 'badge-blue': nf.stnf == '01' }, { 'badge-red': nf.stnf == '90' || nf.stnf == '92' || nf.stnf == '50' }]},[_vm._v(_vm._s(_vm.textST(nf.stnf)))]),_vm._v(" "),(nf.carta_correcao > 0)?_c('span',{staticClass:"float-right badge badge-yellow mr-1"},[_vm._v("CC-e")]):_vm._e(),_vm._v(" "),(nf.entradaarmazenamento == 'S')?_c('span',{staticClass:"float-right badge badge-gray mr-1"},[_vm._v("NF Armazenamento")]):_vm._e(),_vm._v(" "),((nf.operacaonf == 'E' && nf.movest == 'S' && nf.flagarmazenada != 'S'))?_c('span',{staticClass:"float-right badge badge-yellow mr-1"},[_vm._v("Não Armazenada")]):_vm._e()]),_vm._v(" "),(nf.chave)?_c('div',{staticClass:"col-md-4 col-8"},[_c('div',{attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Último XML enviado para a Receita"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Chave")]),_c('span',{staticClass:"data-list",style:({color: nf.stnf != '10' ? 'gray' : ''})},[_vm._v(_vm._s(nf.chave))])]),_vm._v(" "),(nf.stnf != '10' && nf.xmotivo)?_c('span',{staticClass:"error w-100"},[_vm._v(_vm._s(nf.xmotivo))]):_vm._e()]):_vm._e(),_vm._v(" "),(nf.npedido)?_c('div',{staticClass:"col-md-2 col-4"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Pedido")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(nf.npedido))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12 ml-auto"},[_c('bar-grid',{attrs:{"options":{ barNF: true, stnf: nf.stnf, chave: nf.chave, autoriza: (nf.emissaopropria === 'S' && nf.tpnf != 'S') },"moreActions":_vm.getActions(nf)},on:{"view":function($event){return _vm.handleView(nf)},"edit":function($event){return _vm.handleEdit(nf.codnf, nf.impxml == 'S', nf.tpnf)},"xml":function($event){return _vm.handleDownloadXML(nf.codnf, nf.chave)},"print":function($event){return _vm.handlePDF(nf)},"send":function($event){return _vm.handleAutorizaNF(nf)},"action":function($event){return _vm.handleAction($event, nf.codnf)}}})],1)])])])})],2)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"row"},[_c('input',{ref:"xmlFile",attrs:{"type":"file","accept":".xml"},on:{"change":function($event){return _vm.handleUploadXML()}}})]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showForm)?_c('nfsaida-form',{attrs:{"params":_vm.params,"crud":_vm.crud},on:{"closeform":_vm.closeForm,"edit":_vm.editEntrada}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showFormNfse)?_c('nfse-form',{attrs:{"params":_vm.params,"crud":_vm.crud},on:{"closeform":_vm.closeForm,"edit":_vm.editEntrada}}):_vm._e()],1),_vm._v(" "),(_vm.errmessagesDownloadXML)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"800px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v("Não foi possível efetuar a geração")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.errmessagesDownloadXML = null}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row col mb-2"},[_vm._v("\n          Algumas pendências foram encontradas impossibilitando a geração dos arquivos XML do período\n        ")]),_vm._v(" "),_c('validation',{attrs:{"title":"Erros de Validação","messages":_vm.errmessagesDownloadXML}})],1),_vm._v(" "),(!_vm.noFiles)?_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"label":"Efetuar Download","title":"","nb-btdef":true},on:{"click":function($event){return _vm.downloadArquivosXMLPeriodo(true)}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar","title":""},on:{"click":function($event){_vm.errmessagesDownloadXML = null}}})],1):_vm._e()])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showFormImportXML)?_c('nfentrada-form',{attrs:{"params":_vm.params,"crud":_vm.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_serienf_list_vue__ = __webpack_require__(592);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e03935f_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_serienf_list_vue__ = __webpack_require__(1649);
function injectStyle (ssrContext) {
  __webpack_require__(1644)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_serienf_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e03935f_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_serienf_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1645);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7782315e", content, true, {});

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1647);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("789c500d", content, true, {});

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Série NF","plural-entity":"Série NF","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.serienf.codfil.validator),expression:"metadata.serienf.codfil.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.serienf.codfil,"name":"codfil","v-errors":_vm.errors},model:{value:(_vm.serienf.codfil),callback:function ($$v) {_vm.$set(_vm.serienf, "codfil", $$v)},expression:"serienf.codfil"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.serienf.serie.validator),expression:"metadata.serienf.serie.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.serienf.serie,"name":"serie","v-errors":_vm.errors},model:{value:(_vm.serienf.serie),callback:function ($$v) {_vm.$set(_vm.serienf, "serie", $$v)},expression:"serienf.serie"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.serienf.esp.validator),expression:"metadata.serienf.esp.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.serienf.esp,"name":"esp","v-errors":_vm.errors},model:{value:(_vm.serienf.esp),callback:function ($$v) {_vm.$set(_vm.serienf, "esp", $$v)},expression:"serienf.esp"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.serienf.nf.validator),expression:"metadata.serienf.nf.validator"}],attrs:{"metadata":_vm.metadata.serienf.nf,"type":"text","col":"4","name":"nf","v-errors":_vm.errors},model:{value:(_vm.serienf.nf),callback:function ($$v) {_vm.$set(_vm.serienf, "nf", $$v)},expression:"serienf.nf"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Serie de NF","plural-entity":"Séries de NF","title-search":"Pesquise pela série da nota"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.serienfList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.serienfList),function(serienf){return _c('div',{key:serienf.codserienf,staticClass:"mainbox"},[_c('div',{staticClass:"mark-green"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.serienf.codfil.label)+" ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(serienf.codfil))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.serienf.serie.label)+" ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(serienf.serie))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.serienf.nf.label)+" ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(serienf.nf))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.serienf.esp.label)+" ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(serienf.esp))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: false, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(serienf.codserienf)},"view":function($event){return _vm.handleEdit(serienf.codserienf, true)}}})],1)])])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('serienf-form',{attrs:{"index":this.codserienf,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_contador_list_vue__ = __webpack_require__(595);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9eb80430_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_contador_list_vue__ = __webpack_require__(1657);
function injectStyle (ssrContext) {
  __webpack_require__(1651)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_contador_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9eb80430_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_contador_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1652);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3bcab8ca", content, true, {});

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_contador_form_vue__ = __webpack_require__(596);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3345d8f3_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_contador_form_vue__ = __webpack_require__(1656);
function injectStyle (ssrContext) {
  __webpack_require__(1654)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_contador_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3345d8f3_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_contador_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1655);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4b796d66", content, true, {});

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Contador","plural-entity":"Contadores","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"metadata":_vm.metadata.contador.codcontador,"type":"text","col":"2","disabled":true},model:{value:(_vm.contador.codcontador),callback:function ($$v) {_vm.$set(_vm.contador, "codcontador", $$v)},expression:"contador.codcontador"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.contador.nome.validator),expression:"metadata.contador.nome.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.contador.nome,"name":"nome","v-errors":_vm.errors},model:{value:(_vm.contador.nome),callback:function ($$v) {_vm.$set(_vm.contador, "nome", $$v)},expression:"contador.nome"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.contador.cnpj.validator),expression:"metadata.contador.cnpj.validator"}],attrs:{"type":"cnpj","col":"2","metadata":_vm.metadata.contador.cnpj,"name":"cnpj","v-errors":_vm.errors},model:{value:(_vm.contador.cnpj),callback:function ($$v) {_vm.$set(_vm.contador, "cnpj", $$v)},expression:"contador.cnpj"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.contador.cpf.validator),expression:"metadata.contador.cpf.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.contador.cpf,"name":"cpf","v-errors":_vm.errors},model:{value:(_vm.contador.cpf),callback:function ($$v) {_vm.$set(_vm.contador, "cpf", $$v)},expression:"contador.cpf"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.contador.crc.validator),expression:"metadata.contador.crc.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.contador.crc,"name":"crc","v-errors":_vm.errors},model:{value:(_vm.contador.crc),callback:function ($$v) {_vm.$set(_vm.contador, "crc", $$v)},expression:"contador.crc"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.contador.cep.validator),expression:"metadata.contador.cep.validator"}],attrs:{"type":"cep","col":"2","metadata":_vm.metadata.contador.cep,"name":"cep","v-errors":_vm.errors},on:{"update":_vm.updateCep},model:{value:(_vm.contador.cep),callback:function ($$v) {_vm.$set(_vm.contador, "cep", $$v)},expression:"contador.cep"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.contador.ende.validator),expression:"metadata.contador.ende.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.contador.ende,"name":"ende","v-errors":_vm.errors},model:{value:(_vm.contador.ende),callback:function ($$v) {_vm.$set(_vm.contador, "ende", $$v)},expression:"contador.ende"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.contador.endenr.validator),expression:"metadata.contador.endenr.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.contador.endenr,"name":"endenr","v-errors":_vm.errors},model:{value:(_vm.contador.endenr),callback:function ($$v) {_vm.$set(_vm.contador, "endenr", $$v)},expression:"contador.endenr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.contador.endecomp.validator),expression:"metadata.contador.endecomp.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.contador.endecomp,"name":"endecomp","v-errors":_vm.errors},model:{value:(_vm.contador.endecomp),callback:function ($$v) {_vm.$set(_vm.contador, "endecomp", $$v)},expression:"contador.endecomp"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.contador.uf.validator),expression:"metadata.contador.uf.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.contador.uf,"name":"uf","v-errors":_vm.errors},model:{value:(_vm.contador.uf),callback:function ($$v) {_vm.$set(_vm.contador, "uf", $$v)},expression:"contador.uf"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.contador.codmun.validator),expression:"metadata.contador.codmun.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.contador.codmun,"name":"codmun","v-errors":_vm.errors,"select2":{entity: 'mun/uf/' + _vm.contador.uf, minlength: 2}},model:{value:(_vm.contador.codmun),callback:function ($$v) {_vm.$set(_vm.contador, "codmun", $$v)},expression:"contador.codmun"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.contador.fone.validator),expression:"metadata.contador.fone.validator"}],attrs:{"type":"fone","col":"2","metadata":_vm.metadata.contador.fone,"name":"fone","v-errors":_vm.errors},model:{value:(_vm.contador.fone),callback:function ($$v) {_vm.$set(_vm.contador, "fone", $$v)},expression:"contador.fone"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.contador.email.validator),expression:"metadata.contador.email.validator"}],attrs:{"type":"email","col":"4","metadata":_vm.metadata.contador.email,"name":"email","v-errors":_vm.errors},model:{value:(_vm.contador.email),callback:function ($$v) {_vm.$set(_vm.contador, "email", $$v)},expression:"contador.email"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Contador","plural-entity":"Contadores"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.contadorList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.contadorList),function(contador){return _c('div',{key:contador.codcontador,staticClass:"mainbox"},[_c('div',{staticClass:"mark-green"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-12"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(contador.nome)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: false, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(contador.codcontador)},"view":function($event){return _vm.handleEdit(contador.codcontador, true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.contador.codcontador.label)+": ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(contador.codcontador))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6"},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.contador.crc.label)+": ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(contador.crc))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6"},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.contador.cnpj.label)+": ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(contador.cnpj))])])])])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('contador-form',{attrs:{"index":this.codcontador,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1659);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("9be1b866", content, true, {});

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-0a032459]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-0a032459]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-0a032459]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-0a032459]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-0a032459]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-0a032459]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-0a032459]{flex:1;min-width:0}.nb-card-title-line[data-v-0a032459]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-0a032459]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-0a032459]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-0a032459]{color:#334155;font-weight:600}.nb-card-actions[data-v-0a032459]{flex:0 0 auto}@media (max-width:767.98px){.nb-card-top[data-v-0a032459]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-0a032459]{align-self:flex-end}}", ""]);

// exports


/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Ramo de Atividade","plural-entity":"Ramos de Atividade"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.ramoatList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.ramoatList),function(ramoat){return _c('article',{key:ramoat.codramo,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(ramoat.descricao))])]),_vm._v(" "),(ramoat.codramo)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(ramoat.codramo))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: false, btnEdit: true, btnEditLabel: 'Editar'},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(ramoat.codramo)}}})],1)])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('ramoat-form',{attrs:{"index":this.codramo,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-briefcase",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_natfin_list_vue__ = __webpack_require__(599);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_17c2359d_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_natfin_list_vue__ = __webpack_require__(1664);
function injectStyle (ssrContext) {
  __webpack_require__(1662)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17c2359d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_natfin_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_17c2359d_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_natfin_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1663);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e6a08ece", content, true, {});

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "h2[data-v-17c2359d]{font-size:2rem;color:#4993d2;margin-left:1rem}.default-container[data-v-17c2359d]{padding:2rem;border:none!important}.lvl-1[data-v-17c2359d]{margin-left:.5rem}.lvl-2[data-v-17c2359d]{margin-left:1.5rem}.lvl-3[data-v-17c2359d]{margin-left:2.5rem}#badge[data-v-17c2359d]{content:\"\";font-size:5px;padding:1px 4px;border-radius:100%;margin-right:.5rem}", ""]);

// exports


/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('br'),_vm._v(" "),_c('tabs',{attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}),_vm._v(" "),(_vm.tabReceitas)?_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row d-flex justify-content-between"},[_c('h2',[_vm._v("Naturezas de Receita")]),_vm._v(" "),_c('v-button',{staticClass:"mr-2",attrs:{"label":"Natureza de Receita","icon":"fa-plus","success":true},on:{"click":_vm.handleNew}})],1),_vm._v(" "),(_vm.natfinReceitas.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.natfinReceitas),function(natfin){return _c('div',{key:natfin.codnatfin,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"col-md-8"},[_c('div',{class:'lvl-'+natfin.nivel},[_c('span',{class:_vm.levelFont(natfin.nivel)},[_vm._v("\n                                    "+_vm._s(natfin.descricao)+"\n                                ")]),_vm._v(" "),(!natfin.haschildren && natfin.dre)?_c('span',{staticClass:"data-list w-100 lvl-3"},[_vm._v("\n                                    DRE: "+_vm._s(natfin.dre)+"\n                                ")]):_vm._e(),_vm._v(" "),(!natfin.haschildren && !natfin.dre)?_c('span',{staticClass:"data-list w-100 lvl-3"},[_vm._v("\n                                    Não considera no DRE\n                                ")]):_vm._e()])]),_vm._v(" "),(natfin.nivel != 1)?_c('div',{staticClass:"col-md-auto ml-auto"},[_c('v-button',{attrs:{"icon":"fa-pencil"},on:{"click":function($event){return _vm.handleEdit(natfin)}}}),_vm._v(" "),(!natfin.haschildren)?_c('v-button',{attrs:{"icon":"fa-trash"},on:{"click":function($event){natfin.transferDelete ? _vm.handleModalDelete(natfin) : _vm.handleDelete(natfin)}}}):_vm._e(),_vm._v(" "),(natfin.nivel != 3)?_c('v-button',{attrs:{"icon":"fa-plus","title":"Adicionar sub-categoria"},on:{"click":function($event){return _vm.handleSubgroup(natfin)}}}):_vm._e()],1):_vm._e()])])])})],2):_vm._e(),_vm._v(" "),(_vm.tabDespesas)?_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row d-flex justify-content-between"},[_c('h2',[_vm._v("Naturezas de Despesas")]),_vm._v(" "),_c('v-button',{staticClass:"mr-2",attrs:{"label":"Natureza de Despesas","icon":"fa-plus","success":true},on:{"click":_vm.handleNew}})],1),_vm._v(" "),(_vm.natfinDespesas.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.natfinDespesas),function(natfin){return _c('div',{key:natfin.codnatfin,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"col-md-8"},[_c('div',{class:'lvl-'+natfin.nivel},[_c('span',{class:_vm.levelFont(natfin.nivel)},[_vm._v("\n                                    "+_vm._s(natfin.descricao)+"\n                                ")]),_vm._v(" "),(!natfin.haschildren && natfin.dre)?_c('span',{staticClass:"data-list w-100 lvl-3"},[_vm._v("\n                                    DRE: "+_vm._s(natfin.dre)+"\n                                ")]):_vm._e(),_vm._v(" "),(!natfin.haschildren && !natfin.dre)?_c('span',{staticClass:"data-list w-100 lvl-3"},[_vm._v("\n                                    Não considera no DRE\n                                ")]):_vm._e()])]),_vm._v(" "),(natfin.nivel != 1)?_c('div',{staticClass:"col-md-auto ml-auto"},[_c('v-button',{attrs:{"icon":"fa-pencil"},on:{"click":function($event){return _vm.handleEdit(natfin)}}}),_vm._v(" "),(!natfin.haschildren)?_c('v-button',{attrs:{"icon":"fa-trash"},on:{"click":function($event){natfin.transferDelete ? _vm.handleModalDelete(natfin) : _vm.handleDelete(natfin)}}}):_vm._e(),_vm._v(" "),(natfin.nivel != 3)?_c('v-button',{attrs:{"icon":"fa-plus","title":"Adicionar sub-categoria"},on:{"click":function($event){return _vm.handleSubgroup(natfin)}}}):_vm._e()],1):_vm._e()])])])})],2):_vm._e()],1),_vm._v(" "),(_vm.showForm)?_c('natfin-form',{attrs:{"index":this.codnatfin,"crud":this.crud,"cod-natfin-pai":this.codNatfinPai,"natfin-type":_vm.tabReceitas ? 'R' : 'D'},on:{"closeform":_vm.closeForm}}):_vm._e(),_vm._v(" "),(_vm.showModalDeleteNatFin)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h5',[_vm._v("Excluir Natureza Financeira")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row d-flex flex-column"},[(_vm.tabReceitas)?_c('form-field',{attrs:{"type":"select2","col":"4","label":"Natureza Financeira de Destino","select2":{entity:'natfin/receitas', minlength: 0}},on:{"input":_vm.handleInputPai},model:{value:(_vm.codnatfinDestino),callback:function ($$v) {_vm.codnatfinDestino=$$v},expression:"codnatfinDestino"}}):_vm._e(),_vm._v(" "),(_vm.tabDespesas)?_c('form-field',{attrs:{"type":"select2","col":"4","label":"Natureza Financeira de Destino","select2":{entity:'natfin/despesas', minlength: 0}},on:{"input":_vm.handleInputPai},model:{value:(_vm.codnatfinDestino),callback:function ($$v) {_vm.codnatfinDestino=$$v},expression:"codnatfinDestino"}}):_vm._e(),_vm._v(" "),(_vm.natfinDestError)?_c('span',{staticClass:"error ml-3 mb-3"},[_vm._v(_vm._s(_vm.natfinDestErrorMsg))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{ref:"btnConfirm",attrs:{"label":"Deletar","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleDelete(_vm.natfinItem)}}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeForm}})],1)])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl"},[_vm._v("A natureza que está tentando excluir possui lançamentos associados.")]),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("Selecione uma natureza para a qual serão transferidos os lançamentos da natureza atual.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_inut_list_vue__ = __webpack_require__(600);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_24d28437_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_inut_list_vue__ = __webpack_require__(1672);
function injectStyle (ssrContext) {
  __webpack_require__(1666)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_inut_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_24d28437_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_inut_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1667);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0b70e3b0", content, true, {});

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_inut_form_vue__ = __webpack_require__(601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_35dda867_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_inut_form_vue__ = __webpack_require__(1671);
function injectStyle (ssrContext) {
  __webpack_require__(1669)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_inut_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_35dda867_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_inut_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1670);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1581e866", content, true, {});

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Inutilização","plural-entity":"Inutilização","crud":this.crud},on:{"closeform":_vm.closeForm,"save":_vm.handleSave}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[(_vm.errmessages.length != 0)?_c('validation',{attrs:{"title":"Erro ao enviar pedido de inutilização","messages":_vm.errmessages}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.inut.codfil.validator),expression:"metadata.inut.codfil.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.inut.codfil,"name":"codfil","v-errors":_vm.errors},model:{value:(_vm.inut.codfil),callback:function ($$v) {_vm.$set(_vm.inut, "codfil", $$v)},expression:"inut.codfil"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.inut.serie.validator),expression:"metadata.inut.serie.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.inut.serie,"name":"serie","v-errors":_vm.errors},model:{value:(_vm.inut.serie),callback:function ($$v) {_vm.$set(_vm.inut, "serie", $$v)},expression:"inut.serie"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.inut.nfinicial.validator),expression:"metadata.inut.nfinicial.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.inut.nfinicial,"name":"nfinicial","v-errors":_vm.errors},model:{value:(_vm.inut.nfinicial),callback:function ($$v) {_vm.$set(_vm.inut, "nfinicial", $$v)},expression:"inut.nfinicial"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"number","col":"2","metadata":_vm.metadata.inut.nffinal,"name":"nffinal","v-errors":_vm.errors,"v-validate":{ required: false },"disabled":true},model:{value:(_vm.inut.nffinal),callback:function ($$v) {_vm.$set(_vm.inut, "nffinal", $$v)},expression:"inut.nffinal"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.inut.texto.validator),expression:"metadata.inut.texto.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.inut.texto,"name":"texto","v-errors":_vm.errors},model:{value:(_vm.inut.texto),callback:function ($$v) {_vm.$set(_vm.inut, "texto", $$v)},expression:"inut.texto"}})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Inutilização de Numeração","plural-entity":"Inutilizacao de Numeração","title-search":"Pesquise pelo número da nota"},on:{"search":_vm.handleSearch,"new":_vm.handleIncluir,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container mt-2"},[(_vm.inutList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.inutList),function(inut,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.inut.data}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.data(inut.data)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.inut.serie}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(inut.serie))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.inut.nfinicial}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(inut.nfinicial))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.inut.nffinal}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(inut.nffinal))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.inut.nprot}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(inut.nprot))]),_vm._v(" "),(inut.nprot)?_c('span',{staticClass:"badge badge-green"},[_vm._v("Autorizado")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6"},[(inut.nprot == null)?_c('bar-grid',{attrs:{"options":{barDefault: true, btnEdit: true, btnDelete: false, btnView: true},"moreActions":[]},on:{"view":function($event){return _vm.handleView(inut.codinut)},"edit":function($event){return _vm.handleEdit(inut.codinut)}}}):_vm._e()],1)])])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('inut-form',{attrs:{"params":_vm.params,"crud":_vm.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_importa_ibpt_vue__ = __webpack_require__(602);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f8c551b_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_importa_ibpt_vue__ = __webpack_require__(1676);
function injectStyle (ssrContext) {
  __webpack_require__(1674)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_importa_ibpt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f8c551b_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_importa_ibpt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1675);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("46004bb2", content, true, {});

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Importação de Tabelas IBPT","disableSave":true,"disableRetorno":true}}),_vm._v(" "),(_vm.showSelecionaArquivos)?_c('div',{staticClass:"default-container"},[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Selecionar Arquivos CSV"}}),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("Importação de tabelas IBPT")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Selecionar Arquivos","nb-btdef":false,"icon":"fa-upload"},on:{"click":function($event){return _vm.handleFileSelectBtn()}}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.showConfirmaImportacao)?_c('div',{key:_vm.reRenderList,staticClass:"default-container"},[(!_vm.uploading && !_vm.showImportacaoFinalizada)?_c('label-title',{staticClass:"mb-2",attrs:{"title":"Confirmar Importação"}}):_vm._e(),_vm._v(" "),(_vm.uploading)?_c('label-title',{staticClass:"mb-2",attrs:{"title":"Importação em Andamento"}}):_vm._e(),_vm._v(" "),(_vm.showImportacaoFinalizada)?_c('label-title',{staticClass:"mb-2",attrs:{"title":"Importação Finalizada"}}):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mt-5"}),_vm._v(" "),_vm._l((_vm.fileList),function(file,index){return _c('div',{key:index,staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-3 col-4"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(file.name))])]),_vm._v(" "),(file.finished)?_c('div',{staticClass:"col-md-9 col-10"},[(!file.errors)?_c('span',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" upload concluído ")]):_vm._e(),_vm._v(" "),(!file.errors)?_c('span',[_vm._v(" Quantidade de linhas importadas: "+_vm._s(file.gravados)+" ")]):_vm._e(),_vm._v(" "),(file.errors)?_c('span',[_c('i',{staticClass:"error fa fa-warning",attrs:{"aria-hidden":"true"}}),_vm._v(" upload concluído com erros ")]):_vm._e()]):_vm._e(),_vm._v(" "),(file.uploading)?_c('div',{staticClass:"col-md-4 col-6"},[_c('div',{staticClass:"spinner-border text-muted"})]):_vm._e()])}),_vm._v(" "),(!_vm.uploading)?_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl-edit"},[_vm._v("Confirme a importação de "+_vm._s(_vm.qtFiles)+" arquivos XML")])])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.uploading && !_vm.showImportacaoFinalizada)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Continuar","nb-btdef":true},on:{"click":function($event){return _vm.handleExecutaImportacao()}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":function($event){return _vm.handleRetornar()}}})],1)]):_vm._e(),_vm._v(" "),(_vm.uploading && !_vm.showImportacaoFinalizada)?_c('div',{staticClass:"row"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.showImportacaoFinalizada)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Efetuar Nova Importação"},on:{"click":function($event){return _vm.handleNovaImportacao()}}})],1)]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"row"},[_c('div',{staticClass:"col"},[_c('label',[_c('input',{ref:"file",attrs:{"type":"file","multiple":"","accept":".csv"},on:{"change":function($event){return _vm.handleFileUpload()}}})])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-5 mb-5"},[_c('div',{staticClass:"col-md-12 mt-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 mt-2"},[_c('span',{staticClass:"w-100 lbl-edit"},[_vm._v("Importação em andamento!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_importa_xml_vue__ = __webpack_require__(603);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_208c942c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_importa_xml_vue__ = __webpack_require__(1680);
function injectStyle (ssrContext) {
  __webpack_require__(1678)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_importa_xml_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_208c942c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_importa_xml_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1679);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3270759a", content, true, {});

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Importação de Cadastros Por XML","disableSave":true,"disableRetorno":true}}),_vm._v(" "),(_vm.showSelecionaArquivos)?_c('div',{staticClass:"default-container"},[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Selecionar Arquivos XML de NF-e"}}),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("Importe agora dados de produtos, destinatários e emitentes através dos arquivos XML de suas notas de saída e entrada")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Selecionar Arquivos XML","nb-btdef":false,"icon":"fa-upload"},on:{"click":function($event){return _vm.handleFileSelectBtn()}}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.showConfirmaImportacao)?_c('div',{staticClass:"default-container"},[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Confirmar Importação"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('alert',{attrs:{"type":"warning","text":"Serão ignorados os registros de produtos, clientes, fornecedores ou transportadoras já existentes no sistema"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl-edit"},[_vm._v("Confirme a importação de "+_vm._s(_vm.qtFiles)+" arquivos XML")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Continuar","nb-btdef":true},on:{"click":function($event){return _vm.handleExecutaImportacao()}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":function($event){return _vm.handleRetornar()}}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.resultList.length > 0)?_c('div',{staticClass:"default-container"},[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Resultado da importação"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mt-5 mb-5"},[_c('div',{staticClass:"col-md-3 col-3 col-3"},[_c('div',{staticClass:"card h-100 text-center"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('label',{staticClass:"lbl-edit"},[_vm._v(" "+_vm._s(_vm.clicountentes)+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-3 col-3"},[_c('div',{staticClass:"card text-center"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('label',{staticClass:"lbl-edit"},[_vm._v(" "+_vm._s(_vm.forncount)+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-3 col-3"},[_c('div',{staticClass:"card text-center"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('label',{staticClass:"lbl-edit"},[_vm._v(" "+_vm._s(_vm.prodcountutos)+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-3 col-3"},[_c('div',{staticClass:"card text-center"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('label',{staticClass:"lbl-edit"},[_vm._v(" "+_vm._s(_vm.transcount)+" ")])])])])]),_vm._v(" "),_c('label-title',{attrs:{"title":"Detalhes da importação"}}),_vm._v(" "),_vm._l((_vm.resultList),function(item,index){return _c('div',{key:index,staticClass:"mainbox"},[(item.status=='error')?_c('div',{staticClass:"mark-red"}):_vm._e(),_vm._v(" "),(item.status!='error')?_c('div',{staticClass:"mark-green"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"label":"Arquivo"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.filename))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"label":"Descrição"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.text))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{attrs:{"label":"Mensagem"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.errormessage))])],1)])])])}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row col"},[_c('v-button',{attrs:{"label":"Retornar","icon":"fa-arrow-left"},on:{"click":_vm.handleRetornar}})],1)],2):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"row"},[_c('div',{staticClass:"col"},[_c('label',[_vm._v("Foto\n                    "),_c('input',{ref:"file",attrs:{"type":"file","multiple":"","accept":".xml"},on:{"change":function($event){return _vm.handleFileUpload()}}})])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-5 mb-5"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl-edit"},[_vm._v("A importação de dados é feita através dos arquivos XML de notas fiscais da sua Empresa")]),_vm._v(" "),_c('span',{staticClass:"w-100 lbl-edit"},[_vm._v("Selecione até 50 arquivos de XML")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('label',{staticClass:"lbl-title"},[_vm._v("Clientes Importados")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('label',{staticClass:"lbl-title"},[_vm._v("Fornecedores Importados")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('label',{staticClass:"lbl-title"},[_vm._v("Produtos Importados")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('label',{staticClass:"lbl-title"},[_vm._v("Transportadoras Importadas")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_importa_xmlhist_vue__ = __webpack_require__(604);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_114048fe_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_importa_xmlhist_vue__ = __webpack_require__(1684);
function injectStyle (ssrContext) {
  __webpack_require__(1682)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_importa_xmlhist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_114048fe_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_importa_xmlhist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1683);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("361792a1", content, true, {});

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Importação de Notas por XML","disableSave":true,"disableRetorno":true}}),_vm._v(" "),(_vm.showSelecionaArquivos)?_c('div',{staticClass:"default-container"},[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Selecionar Arquivos XML de NF-e"}}),_vm._v(" "),_c('span',{staticClass:"w-100 lbl"},[_vm._v("Importe suas notas fiscais eletrônicas por XML para armazená-las no Nota Brasil e gerar a\n      DANFE.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Selecionar os Arquivos XML","nb-btdef":false,"icon":"fa-upload"},on:{"click":function($event){return _vm.handleFileSelectBtn()}}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.showConfirmaImportacao)?_c('div',{staticClass:"default-container"},[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Confirmar Importação"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('alert',{attrs:{"type":"warning","text":"Serão ignoradas as notas fiscais já importadas pelo sistema."}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl-edit"},[_vm._v("Deseja continuar a importação de "+_vm._s(_vm.qtFiles)+" arquivo(s) de XML?")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-button',{attrs:{"label":"Continuar","nb-btdef":true},on:{"click":function($event){return _vm.handleExecutaImportacao()}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":function($event){return _vm.handleRetornar()}}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.resultList.length > 0)?_c('div',{staticClass:"default-container"},[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Resultado da Importação"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mt-5 mb-5"},[_c('div',{staticClass:"col-md-3 col-3 col-3"},[_c('div',{staticClass:"card text-center"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('label',{staticClass:"lbl-edit"},[_vm._v(" "+_vm._s(_vm.xmlcount)+" ")])])])])]),_vm._v(" "),(_vm.resultList.length > 0)?_c('alert',{attrs:{"type":"warning","text":"Consulte as notas fiscais importadas abaixo."}}):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row col"},[_c('v-button',{attrs:{"label":"Retornar","icon":"fa-arrow-left"},on:{"click":_vm.handleRetornar}})],1)],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"row"},[_c('div',{staticClass:"col"},[_c('label',[_vm._v("Foto\n        "),_c('input',{ref:"file",attrs:{"type":"file","multiple":"","accept":".xml"},on:{"change":function($event){return _vm.handleFileUpload()}}})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":false,"pdf-button":false,"xls-button":false,"single-entity":"NF-e Importada","plural-entity":"NF-e Importadas"},on:{"search":_vm.search,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},_vm._l((_vm.xmlhistList),function(xmlhist,index){return _c('div',{key:xmlhist.chnfe},[_c('div',{},[(index == 0)?_c('div',{staticClass:"row align-items-center",staticStyle:{"font-weight":"500"}},[_vm._m(2,true),_vm._v(" "),_vm._m(3,true),_vm._v(" "),_vm._m(4,true),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-center",staticStyle:{"font-size":"12px"}},[_c('div',{staticClass:"col-md-1 col-1 text-center"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(xmlhist.serie))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-1 text-center"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(xmlhist.nnf))])]),_vm._v(" "),_c('div',{staticClass:"col-md-7 col-7"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(xmlhist.dest_xnome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('div',{staticClass:"float-right"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Baixar XML da NF-e"},on:{"click":function($event){return _vm.handleDownloadXML(xmlhist.xml, xmlhist.chnfe)}}},[_vm._v("xml\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary btn-sm",staticStyle:{"margin-right":"5px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Gerar Danfe PDF"},on:{"click":function($event){return _vm.handlePDF(xmlhist.chnfe)}}},[_c('i',{staticClass:"fa fa-file-pdf-o fa-fw"})])])])])])]),_vm._v(" "),_c('hr')])}),0)],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-5 mb-5"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"w-100 lbl-edit"},[_vm._v("Selecione até 100 arquivos XML.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('label',{staticClass:"lbl-title"},[_vm._v("Nota(s) Importada(s)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-1 col-1 text-center"},[_c('span',{staticClass:"lbl-list"},[_vm._v("Série")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-1 col-1 text-center"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Número")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-7 col-7"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Destinatário")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfimport_list_vue__ = __webpack_require__(605);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7abb1a87_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfimport_list_vue__ = __webpack_require__(1692);
function injectStyle (ssrContext) {
  __webpack_require__(1686)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7abb1a87"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfimport_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7abb1a87_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfimport_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1687);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b3d3ba08", content, true, {});

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".mainbox[data-v-7abb1a87]{min-height:100px}", ""]);

// exports


/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfimport_form_vue__ = __webpack_require__(606);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_604fcba6_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfimport_form_vue__ = __webpack_require__(1691);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_nfimport_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_604fcba6_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_nfimport_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mb-3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"float-right"},[_c('v-button',{attrs:{"label":"Retornar","title":"","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Salvar","title":"","icon":"fa-download","nb-btdef":true},on:{"click":_vm.handleSalvar}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Número"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.di.numerodi))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{attrs:{"label":"Data"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.data(_vm.di.datadesemb)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.di.nomefornecedor}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.di.nomefornecedor))])],1)]),_vm._v(" "),_c('div',[_c('label-title',{attrs:{"title":"Adições"}}),_vm._v(" "),_vm._l((_vm.diad),function(adicao,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"mark-green"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.nadicao}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(adicao.nadicao))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.ncm}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(adicao.ncm))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.pliq}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.pliq,2)))])],1),_vm._v(" "),(_vm.showAliq(adicao))?_c('div',{staticClass:"col-md-1 col-2"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.aii}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.aii,2)))])],1):_vm._e(),_vm._v(" "),(_vm.showAliq(adicao))?_c('div',{staticClass:"col-md-1 col-2"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.aipi}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.aipi,2)))])],1):_vm._e(),_vm._v(" "),(_vm.showAliq(adicao))?_c('div',{staticClass:"col-md-1 col-2"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.apis}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.apis,2)))])],1):_vm._e(),_vm._v(" "),(_vm.showAliq(adicao))?_c('div',{staticClass:"col-md-1 col-2"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.acofins}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.acofins,2)))])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select2","col":"2","metadata":_vm.metadata.diad.cfop,"select2":{entity: 'cfop/entradas', minlength: 0}},model:{value:(adicao.cfop),callback:function ($$v) {_vm.$set(adicao, "cfop", $$v)},expression:"adicao.cfop"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.diad.sticm.validator),expression:"metadata.diad.sticm.validator"}],attrs:{"type":"select2","col":"2","metadata":_vm.metadata.diad.sticm,"name":"sticm","v-errors":_vm.errors},model:{value:(adicao.sticm),callback:function ($$v) {_vm.$set(adicao, "sticm", $$v)},expression:"adicao.sticm"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.diad.aicm},model:{value:(adicao.aicm),callback:function ($$v) {_vm.$set(adicao, "aicm", $$v)},expression:"adicao.aicm"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.diad.ricm},model:{value:(adicao.ricm),callback:function ($$v) {_vm.$set(adicao, "ricm", $$v)},expression:"adicao.ricm"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.diad.mva},model:{value:(adicao.mva),callback:function ($$v) {_vm.$set(adicao, "mva", $$v)},expression:"adicao.mva"}})],1)])])}),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"float-right"},[_c('v-button',{attrs:{"label":"Retornar","title":"","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Salvar","title":"","icon":"fa-download","nb-btdef":true},on:{"click":_vm.handleSalvar}})],1)])])])],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v(" Alteração de Alíquotas nas Adições")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mb-3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"float-right"},[_c('v-button',{attrs:{"label":"Retornar","title":"","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Salvar","title":"","icon":"fa-download","nb-btdef":true},on:{"click":_vm.handleSalvar}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.di.part && _vm.di.part.length)?_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.di.codpart}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(" "+_vm._s(_vm.di.part[0].nome)+" ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"label":"Número"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.di.numerodi))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"label":"Data"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.data(_vm.di.datadesemb)))])],1)]),_vm._v(" "),_c('div',[_c('label-title',{attrs:{"title":"Itens Importados"}}),_c('br'),_vm._v(" "),_vm._l((_vm.diit),function(it,index){return _c('div',{key:index,staticClass:"mainbox"},[(it.stitemdi == '1')?_c('div',{staticClass:"mark-red"}):_vm._e(),_vm._v(" "),(it.stitemdi == '0')?_c('div',{staticClass:"mark-green"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.nadicao}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(it.nadicao))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-6"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.descricaox}}),_c('br'),_vm._v(" "),(it.item && it.item.length>0)?_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(it.item[0].descricao))]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"data-list"},[_vm._v(_vm._s(it.descricaox))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.qt}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(it.qt,4))+" ("+_vm._s(it.unidadex)+")")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.vlr}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(it.vlr,4)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.ricm}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(it.ricm,2)))])],1),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.diit.bcicm},model:{value:(it.bcicm),callback:function ($$v) {_vm.$set(it, "bcicm", $$v)},expression:"it.bcicm"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.diit.vicm},model:{value:(it.vicm),callback:function ($$v) {_vm.$set(it, "vicm", $$v)},expression:"it.vicm"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.diit.bcii},model:{value:(it.bcii),callback:function ($$v) {_vm.$set(it, "bcii", $$v)},expression:"it.bcii"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.diit.vii},model:{value:(it.vii),callback:function ($$v) {_vm.$set(it, "vii", $$v)},expression:"it.vii"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.diit.bcipi},model:{value:(it.bcipi),callback:function ($$v) {_vm.$set(it, "bcipi", $$v)},expression:"it.bcipi"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.diit.vipi},model:{value:(it.vipi),callback:function ($$v) {_vm.$set(it, "vipi", $$v)},expression:"it.vipi"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.diit.bcpiscofins},model:{value:(it.bcpiscofins),callback:function ($$v) {_vm.$set(it, "bcpiscofins", $$v)},expression:"it.bcpiscofins"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.diit.vpis},model:{value:(it.vpis),callback:function ($$v) {_vm.$set(it, "vpis", $$v)},expression:"it.vpis"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.diit.vcofins},model:{value:(it.vcofins),callback:function ($$v) {_vm.$set(it, "vcofins", $$v)},expression:"it.vcofins"}})],1)])])}),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"float-right"},[_c('v-button',{attrs:{"label":"Retornar","title":"","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Salvar","title":"","icon":"fa-download","nb-btdef":true},on:{"click":_vm.handleSalvar}})],1)])])])],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v(" Alterar Valor de ICMS nos Itens")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showFormAdicao)?_c('div',[_c('nfimport-adicao-form',{attrs:{"params":_vm.paramsAdicao},on:{"save":_vm.saveAdicao,"closeform":_vm.closeFormAdicao}})],1):_vm._e(),_vm._v(" "),(_vm.showFormIcms)?_c('div',[_c('nfimport-icms-form',{attrs:{"params":_vm.paramsIcms},on:{"save":_vm.saveIcms,"closeform":_vm.closeFormIcms}})],1):_vm._e(),_vm._v(" "),(_vm.showFormDI)?_c('div',[_c('div',{staticClass:"nb-margin-bottom"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v(" "+_vm._s(_vm.title))]),_vm._v(" "),(_vm.di.stdi == '0')?_c('span',{staticClass:"lbl badge badge-orange"},[_vm._v(_vm._s(_vm.stdi))]):_vm._e(),_vm._v(" "),(_vm.di.stdi == '1')?_c('span',{staticClass:"lbl badge badge-green"},[_vm._v(_vm._s(_vm.stdi))]):_vm._e(),_vm._v(" "),(_vm.di.stdi >= '2')?_c('span',{staticClass:"lbl badge badge-green"},[_vm._v(_vm._s(_vm.stdi))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"float-right"},[_c('v-button',{attrs:{"label":"Retornar","title":"","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}}),_vm._v(" "),(!_vm.isView)?_c('v-button',{attrs:{"label":"Salvar","title":"","icon":"fa-download","nb-btdef":true},on:{"click":_vm.handleSalvarDados}}):_vm._e(),_vm._v(" "),(_vm.isDelete)?_c('v-button',{attrs:{"label":"Excluir","title":"","icon":"fa-trash","nb-btdef":true},on:{"click":_vm.handleExcluir}}):_vm._e(),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.moreActions.length > 0),expression:"moreActions.length > 0"}],attrs:{"label":"Mais Ações","actions":_vm.moreActions},on:{"click":_vm.handleActions}})],1)])]),_vm._v(" "),(_vm.errmessages.errmessages)?_c('validation',{attrs:{"title":"Erros de validação","messages":_vm.errmessages.errmessages}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.di.numerodi}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.di.numerodi))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.di.data}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.data(_vm.di.data)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.di.datadesemb}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.data(_vm.di.datadesemb)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.di.nomefornecedor}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.di.nomefornecedor))])],1)]),_vm._v(" "),(_vm.di.stdi == '0')?_c('div',{staticClass:"col"},[_c('alert',{attrs:{"type":"warning","title":"Pendência encontrada","text":"Efetue o relacionamento para os itens destacados abaixo."}})],1):_vm._e(),_vm._v(" "),_c('label-title',{attrs:{"title":"Dados da DI"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.codpart.validator),expression:"metadata.di.codpart.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.di.codpart,"disabled":_vm.isView,"name":"codpart","v-errors":_vm.errors},model:{value:(_vm.di.codpart),callback:function ($$v) {_vm.$set(_vm.di, "codpart", $$v)},expression:"di.codpart"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select2","col":"4","metadata":_vm.metadata.di.codnates,"disabled":_vm.isView,"select2":{entity: 'nates/entrada', minlength: 0}},model:{value:(_vm.di.codnates),callback:function ($$v) {_vm.$set(_vm.di, "codnates", $$v)},expression:"di.codnates"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select2","col":"4","metadata":_vm.metadata.di.cfop,"disabled":_vm.isView,"select2":{entity: 'cfop/entradas', minlength: 0}},model:{value:(_vm.di.cfop),callback:function ($$v) {_vm.$set(_vm.di, "cfop", $$v)},expression:"di.cfop"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Transporte"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.datadesemb.validator),expression:"metadata.di.datadesemb.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.di.datadesemb,"disabled":_vm.isView,"name":"datadesemb","v-errors":_vm.errors},model:{value:(_vm.di.datadesemb),callback:function ($$v) {_vm.$set(_vm.di, "datadesemb", $$v)},expression:"di.datadesemb"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.dataentrada.validator),expression:"metadata.di.dataentrada.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.di.dataentrada,"disabled":_vm.isView,"name":"dataentrada","v-errors":_vm.errors},model:{value:(_vm.di.dataentrada),callback:function ($$v) {_vm.$set(_vm.di, "dataentrada", $$v)},expression:"di.dataentrada"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.ufdesemb.validator),expression:"metadata.di.ufdesemb.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.di.ufdesemb,"disabled":_vm.isView,"name":"ufdesemb","v-errors":_vm.errors},model:{value:(_vm.di.ufdesemb),callback:function ($$v) {_vm.$set(_vm.di, "ufdesemb", $$v)},expression:"di.ufdesemb"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.localdesemb.validator),expression:"metadata.di.localdesemb.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.di.localdesemb,"disabled":_vm.isView,"name":"localdesemb","v-errors":_vm.errors},model:{value:(_vm.di.localdesemb),callback:function ($$v) {_vm.$set(_vm.di, "localdesemb", $$v)},expression:"di.localdesemb"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.viatranspdi.validator),expression:"metadata.di.viatranspdi.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.di.viatranspdi,"disabled":_vm.isView,"name":"viatranspdi","v-errors":_vm.errors},model:{value:(_vm.di.viatranspdi),callback:function ($$v) {_vm.$set(_vm.di, "viatranspdi", $$v)},expression:"di.viatranspdi"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.tpintermediodi.validator),expression:"metadata.di.tpintermediodi.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.di.tpintermediodi,"disabled":_vm.isView,"name":"tpintermediodi","v-errors":_vm.errors},model:{value:(_vm.di.tpintermediodi),callback:function ($$v) {_vm.$set(_vm.di, "tpintermediodi", $$v)},expression:"di.tpintermediodi"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.ndraw.validator),expression:"metadata.di.ndraw.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.di.ndraw,"disabled":_vm.isView,"name":"ndraw","v-errors":_vm.errors},model:{value:(_vm.di.ndraw),callback:function ($$v) {_vm.$set(_vm.di, "ndraw", $$v)},expression:"di.ndraw"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.pliq.validator),expression:"metadata.di.pliq.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.pliq,"disabled":_vm.isView,"name":"pliq","v-errors":_vm.errors},model:{value:(_vm.di.pliq),callback:function ($$v) {_vm.$set(_vm.di, "pliq", $$v)},expression:"di.pliq"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.pbru.validator),expression:"metadata.di.pbru.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.pbru,"disabled":_vm.isView,"name":"pbru","v-errors":_vm.errors},model:{value:(_vm.di.pbru),callback:function ($$v) {_vm.$set(_vm.di, "pbru", $$v)},expression:"di.pbru"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.qtvolumes.validator),expression:"metadata.di.qtvolumes.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.qtvolumes,"disabled":_vm.isView,"name":"qtvolumes","v-errors":_vm.errors},model:{value:(_vm.di.qtvolumes),callback:function ($$v) {_vm.$set(_vm.di, "qtvolumes", $$v)},expression:"di.qtvolumes"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.volespecie.validator),expression:"metadata.di.volespecie.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.di.volespecie,"disabled":_vm.isView,"name":"volespecie","v-errors":_vm.errors},model:{value:(_vm.di.volespecie),callback:function ($$v) {_vm.$set(_vm.di, "volespecie", $$v)},expression:"di.volespecie"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Informações Complementares"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.di.infcpl),expression:"di.infcpl"}],staticClass:"form-control form-control-sm",attrs:{"rows":"5","cols":"100"},domProps:{"value":(_vm.di.infcpl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.di, "infcpl", $event.target.value)}}})])])]),_vm._v(" "),_c('label-title',{attrs:{"title":"Valores"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vfob,"disabled":true},model:{value:(_vm.di.vfob),callback:function ($$v) {_vm.$set(_vm.di, "vfob", $$v)},expression:"di.vfob"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vfreteint,"disabled":true},model:{value:(_vm.di.vfreteint),callback:function ($$v) {_vm.$set(_vm.di, "vfreteint", $$v)},expression:"di.vfreteint"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vseguroint,"disabled":true},model:{value:(_vm.di.vseguroint),callback:function ($$v) {_vm.$set(_vm.di, "vseguroint", $$v)},expression:"di.vseguroint"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vaduaneiro,"disabled":true},model:{value:(_vm.di.vaduaneiro),callback:function ($$v) {_vm.$set(_vm.di, "vaduaneiro", $$v)},expression:"di.vaduaneiro"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.freteinclusoad.validator),expression:"metadata.di.freteinclusoad.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.di.freteinclusoad,"disabled":_vm.isView,"name":"freteinclusoad","v-errors":_vm.errors},model:{value:(_vm.di.freteinclusoad),callback:function ($$v) {_vm.$set(_vm.di, "freteinclusoad", $$v)},expression:"di.freteinclusoad"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Tributos e Taxas"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.taxamoeda.validator),expression:"metadata.di.taxamoeda.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.taxamoeda,"disabled":_vm.isView,"name":"taxamoeda","v-errors":_vm.errors},model:{value:(_vm.di.taxamoeda),callback:function ($$v) {_vm.$set(_vm.di, "taxamoeda", $$v)},expression:"di.taxamoeda"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.ratsiscomexdi.validator),expression:"metadata.di.ratsiscomexdi.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.di.ratsiscomexdi,"disabled":_vm.isView,"name":"ratsiscomexdi","v-errors":_vm.errors},model:{value:(_vm.di.ratsiscomexdi),callback:function ($$v) {_vm.$set(_vm.di, "ratsiscomexdi", $$v)},expression:"di.ratsiscomexdi"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.rattaxasdi.validator),expression:"metadata.di.rattaxasdi.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.di.rattaxasdi,"disabled":_vm.isView,"name":"rattaxasdi","v-errors":_vm.errors},model:{value:(_vm.di.rattaxasdi),callback:function ($$v) {_vm.$set(_vm.di, "rattaxasdi", $$v)},expression:"di.rattaxasdi"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.vsiscomex.validator),expression:"metadata.di.vsiscomex.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vsiscomex,"disabled":_vm.isView,"preaddon":"R$","name":"vsiscomex","v-errors":_vm.errors},model:{value:(_vm.di.vsiscomex),callback:function ($$v) {_vm.$set(_vm.di, "vsiscomex", $$v)},expression:"di.vsiscomex"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.vafrmm.validator),expression:"metadata.di.vafrmm.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vafrmm,"disabled":_vm.isView,"preaddon":"R$","name":"vafrmm","v-errors":_vm.errors},model:{value:(_vm.di.vafrmm),callback:function ($$v) {_vm.$set(_vm.di, "vafrmm", $$v)},expression:"di.vafrmm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.vmulta.validator),expression:"metadata.di.vmulta.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vmulta,"disabled":_vm.isView,"preaddon":"R$","name":"vmulta","v-errors":_vm.errors},model:{value:(_vm.di.vmulta),callback:function ($$v) {_vm.$set(_vm.di, "vmulta", $$v)},expression:"di.vmulta"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.vacrescimo.validator),expression:"metadata.di.vacrescimo.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vacrescimo,"disabled":_vm.isView,"preaddon":"R$","name":"vacrescimo","v-errors":_vm.errors},model:{value:(_vm.di.vacrescimo),callback:function ($$v) {_vm.$set(_vm.di, "vacrescimo", $$v)},expression:"di.vacrescimo"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.vantidumping.validator),expression:"metadata.di.vantidumping.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vantidumping,"disabled":_vm.isView,"preaddon":"R$","name":"vantidumping","v-errors":_vm.errors},model:{value:(_vm.di.vantidumping),callback:function ($$v) {_vm.$set(_vm.di, "vantidumping", $$v)},expression:"di.vantidumping"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.vataero.validator),expression:"metadata.di.vataero.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vataero,"disabled":_vm.isView,"preaddon":"R$","name":"vataero","v-errors":_vm.errors},model:{value:(_vm.di.vataero),callback:function ($$v) {_vm.$set(_vm.di, "vataero", $$v)},expression:"di.vataero"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vii,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vii),callback:function ($$v) {_vm.$set(_vm.di, "vii", $$v)},expression:"di.vii"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vipi,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vipi),callback:function ($$v) {_vm.$set(_vm.di, "vipi", $$v)},expression:"di.vipi"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vpis,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vpis),callback:function ($$v) {_vm.$set(_vm.di, "vpis", $$v)},expression:"di.vpis"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vcofins,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vcofins),callback:function ($$v) {_vm.$set(_vm.di, "vcofins", $$v)},expression:"di.vcofins"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vicm,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vicm),callback:function ($$v) {_vm.$set(_vm.di, "vicm", $$v)},expression:"di.vicm"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Valores Calculados"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.viicalc,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.viicalc),callback:function ($$v) {_vm.$set(_vm.di, "viicalc", $$v)},expression:"di.viicalc"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vipicalc,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vipicalc),callback:function ($$v) {_vm.$set(_vm.di, "vipicalc", $$v)},expression:"di.vipicalc"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vpiscalc,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vpiscalc),callback:function ($$v) {_vm.$set(_vm.di, "vpiscalc", $$v)},expression:"di.vpiscalc"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vcofinscalc,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vcofinscalc),callback:function ($$v) {_vm.$set(_vm.di, "vcofinscalc", $$v)},expression:"di.vcofinscalc"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vicmcalc,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vicmcalc),callback:function ($$v) {_vm.$set(_vm.di, "vicmcalc", $$v)},expression:"di.vicmcalc"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.totalnf,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.totalnf),callback:function ($$v) {_vm.$set(_vm.di, "totalnf", $$v)},expression:"di.totalnf"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"ICMS"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.orimerc.validator),expression:"metadata.di.orimerc.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.di.orimerc,"disabled":_vm.isView,"name":"orimerc","v-errors":_vm.errors},model:{value:(_vm.di.orimerc),callback:function ($$v) {_vm.$set(_vm.di, "orimerc", $$v)},expression:"di.orimerc"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.sticm.validator),expression:"metadata.di.sticm.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.di.sticm,"disabled":_vm.isView,"name":"sticm","v-errors":_vm.errors},model:{value:(_vm.di.sticm),callback:function ($$v) {_vm.$set(_vm.di, "sticm", $$v)},expression:"di.sticm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.aicm.validator),expression:"metadata.di.aicm.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.aicm,"disabled":_vm.isView,"name":"aicm","v-errors":_vm.errors},model:{value:(_vm.di.aicm),callback:function ($$v) {_vm.$set(_vm.di, "aicm", $$v)},expression:"di.aicm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.picmdif.validator),expression:"metadata.di.picmdif.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.picmdif,"disabled":_vm.isView,"name":"picmdif","v-errors":_vm.errors},model:{value:(_vm.di.picmdif),callback:function ($$v) {_vm.$set(_vm.di, "picmdif", $$v)},expression:"di.picmdif"}}),_vm._v(" "),_c('div',{staticClass:"col-2 mt-3"},[(!_vm.isView)?_c('v-button',{attrs:{"label":"Calcular","title":"","nb-btdef":true},on:{"click":_vm.handleCalcular}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"default-container mt-3"},[_c('label-title',{attrs:{"title":"Adições"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(!_vm.isView)?_c('v-button',{attrs:{"label":"Informar Alíquotas nas Adições","title":"","nb-btdef":true},on:{"click":_vm.editAliquotasAdicoes}}):_vm._e()],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.diad),function(adicao,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.nadicao}}),_c('br'),_vm._v(" "),_c('strong',{staticClass:"data-list"},[_vm._v(_vm._s(adicao.nadicao))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.ncm}}),_c('br'),_vm._v(" "),_c('strong',{staticClass:"data-list"},[_vm._v(_vm._s(adicao.ncm))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.aicm}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.aicm,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.picmdif}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.picmdif,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.ricm}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.ricm,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.mva}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.mva,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.vicm}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.vicm,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.aii}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.aii,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.aipi}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.aipi,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.apis}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.apis,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.acofins}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.acofins,2)))])],1)])])])})],2),_vm._v(" "),_c('div',{staticClass:"default-container mt-3"},[_c('label-title',{attrs:{"title":"Produtos Importados"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(!_vm.isView)?_c('v-button',{attrs:{"label":"Informar Impostos nos Produtos","title":"","nb-btdef":true},on:{"click":_vm.editIcms}}):_vm._e()],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.diit),function(it,index){return _c('div',{key:index,staticClass:"mainbox-select"},[(it.stitemdi == '1')?_c('div',{staticClass:"mark-red"}):_vm._e(),_vm._v(" "),(it.stitemdi == '0')?_c('div',{staticClass:"mark-green"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.descricaox}}),_c('br'),_vm._v(" "),_c('label',{staticClass:"data-list"},[_vm._v(_vm._s(it.descricaox))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.qt}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(it.qt,4))+"/"+_vm._s(it.unidadex))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.vlr}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(it.vlr,4)))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.diit.coditem.validator),expression:"metadata.diit.coditem.validator"}],staticClass:"my-2 my-md-0",attrs:{"type":"select2","col":"6","metadata":_vm.metadata.diit.coditem,"name":"coditem","v-errors":_vm.errors},on:{"input":function($event){return _vm.itemChange(index)}},model:{value:(it.coditem),callback:function ($$v) {_vm.$set(it, "coditem", $$v)},expression:"it.coditem"}}),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.coditem}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(it.coditem))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.uni}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(it.uni))])],1),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.diit.qt},model:{value:(it.qt),callback:function ($$v) {_vm.$set(it, "qt", $$v)},expression:"it.qt"}})],1)])])})],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm && !_vm.showEntradaForm),expression:"!showForm && !showEntradaForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"filtro-mes":true,"filter-button":true,"single-entity":"Declaração Importacao","plural-entity":"Declaração Importacao","moreActions":_vm.moreActionsBarList,"month-filter":_vm.monthFilter,"title-search":"Pesquise pelo nome do fornecedor ou número do DI"},on:{"action":_vm.handleActionBarList,"search":_vm.handleSearch,"new":_vm.handleIncluir,"refresh":_vm.loadData,"changeMonth":_vm.handleSearch}}),_vm._v(" "),_c('div',{staticClass:"default-container mt-3"},[(_vm.diList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.diList),function(di){return _c('div',{key:di.coddi,staticClass:"mainbox"},[_c('div',{staticClass:"mark-gray"}),_vm._v(" "),_c('div',{staticClass:"box pl-3 pl-md-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-7 col-md-12 row"},[_c('div',{staticClass:"col-md-2 col-12",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Número ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(di.numerodi))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12 d-none d-md-block"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data:")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.data(di.data)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12 d-md-flex d-none"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Natureza:")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(di.descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Total FOB:")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(di.vfob)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-5 d-none d-md-block"},[_c('bar-grid',{attrs:{"obj":di,"options":_vm.optionsGrid(di),"moreActions":_vm.moreActionsGrid(di)},on:{"view":function($event){return _vm.handleView(di.coddi)},"edit":function($event){return _vm.handleEdit(di.coddi)},"delete":function($event){return _vm.handleDelete(di.coddi)},"action":_vm.handleAction}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-16"})]),_vm._v(" "),_c('div',{staticClass:"col-5 d-flex flex-column align-items-end justify-content-end d-md-none"},[_c('div',{staticClass:"col-md-2 col-6"},[_c('bar-grid',{attrs:{"obj":di,"options":_vm.optionsGrid(di),"moreActions":_vm.moreActionsGrid(di)},on:{"view":function($event){return _vm.handleView(di.coddi)},"edit":function($event){return _vm.handleEdit(di.coddi)},"delete":function($event){return _vm.handleDelete(di.coddi)},"action":_vm.handleAction}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('span',{staticClass:"badge",class:[{'badge-green': di.stdi=='1'},{'badge-orange': di.stdi=='0'}]},[_vm._v(_vm._s(_vm.textST(di.stdi)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 col-6 d-md-flex d-none"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Fornecedor:")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(di.nome))])]),_vm._v(" "),(di.nf)?_c('div',{staticClass:"col-md-2 col-3 d-md-flex d-none"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Série/NF:")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(di.nf))])]):_vm._e()]),_vm._v(" "),_vm._m(0,true)])])})],2)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"row"},[_c('input',{ref:"xmlFile",attrs:{"type":"file","accept":".xml"},on:{"change":function($event){return _vm.handleUploadXML()}}})]),_vm._v(" "),(_vm.showForm)?_c('nfimport-form',{attrs:{"params":_vm.params,"crud":_vm.crud},on:{"closeform":_vm.closeForm}}):_vm._e(),_vm._v(" "),(_vm.showEntradaForm)?_c('nfsaida-form',{attrs:{"params":_vm.params,"crud":_vm.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-6"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_duimp_list_vue__ = __webpack_require__(611);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4bac81_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_duimp_list_vue__ = __webpack_require__(1697);
function injectStyle (ssrContext) {
  __webpack_require__(1694)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f4bac81"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_duimp_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4bac81_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_duimp_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1695);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("88647a78", content, true, {});

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".mainbox[data-v-0f4bac81]{min-height:100px}", ""]);

// exports


/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showFormAdicao)?_c('div',[_c('nfimport-adicao-form',{attrs:{"params":_vm.paramsAdicao},on:{"save":_vm.saveAdicao,"closeform":_vm.closeFormAdicao}})],1):_vm._e(),_vm._v(" "),(_vm.showFormIcms)?_c('div',[_c('nfimport-icms-form',{attrs:{"params":_vm.paramsIcms},on:{"save":_vm.saveIcms,"closeform":_vm.closeFormIcms}})],1):_vm._e(),_vm._v(" "),(_vm.showFormDI)?_c('div',[_c('div',{staticClass:"nb-margin-bottom"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v(" "+_vm._s(_vm.title))]),_vm._v(" "),(_vm.di.stdi == '0')?_c('span',{staticClass:"lbl badge badge-orange"},[_vm._v(_vm._s(_vm.stdi))]):_vm._e(),_vm._v(" "),(_vm.di.stdi == '1')?_c('span',{staticClass:"lbl badge badge-green"},[_vm._v(_vm._s(_vm.stdi))]):_vm._e(),_vm._v(" "),(_vm.di.stdi >= '2')?_c('span',{staticClass:"lbl badge badge-green"},[_vm._v(_vm._s(_vm.stdi))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"float-right"},[_c('v-button',{attrs:{"label":"Retornar","title":"","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}}),_vm._v(" "),(!_vm.isView)?_c('v-button',{attrs:{"label":"Salvar","title":"","icon":"fa-download","nb-btdef":true},on:{"click":_vm.handleSalvarDados}}):_vm._e(),_vm._v(" "),(_vm.isDelete)?_c('v-button',{attrs:{"label":"Excluir","title":"","icon":"fa-trash","nb-btdef":true},on:{"click":_vm.handleExcluir}}):_vm._e(),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.moreActions.length > 0),expression:"moreActions.length > 0"}],attrs:{"label":"Mais Ações","actions":_vm.moreActions},on:{"click":_vm.handleActions}})],1)])]),_vm._v(" "),(_vm.errmessages.errmessages)?_c('validation',{attrs:{"title":"Erros de validação","messages":_vm.errmessages.errmessages}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"label":"Número da DUIMP"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.di.numerodi))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"label":"Data da DUIMP"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.data(_vm.di.data)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.di.datadesemb}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.data(_vm.di.datadesemb)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.di.nomefornecedor}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.di.nomefornecedor))])],1)]),_vm._v(" "),(_vm.di.stdi == '0')?_c('div',{staticClass:"col mt-2"},[_c('alert',{attrs:{"type":"warning","title":"Pendência encontrada","text":"Efetue o relacionamento para os itens destacados abaixo."}})],1):_vm._e(),_vm._v(" "),_c('label-title',{attrs:{"title":"Dados da DUIMP"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.codpart.validator),expression:"metadata.di.codpart.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.di.codpart,"disabled":_vm.isView,"name":"codpart","v-errors":_vm.errors},model:{value:(_vm.di.codpart),callback:function ($$v) {_vm.$set(_vm.di, "codpart", $$v)},expression:"di.codpart"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select2","col":"4","metadata":_vm.metadata.di.codnates,"disabled":_vm.isView,"select2":{entity: 'nates/entrada', minlength: 0}},model:{value:(_vm.di.codnates),callback:function ($$v) {_vm.$set(_vm.di, "codnates", $$v)},expression:"di.codnates"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select2","col":"4","metadata":_vm.metadata.di.cfop,"disabled":_vm.isView,"select2":{entity: 'cfop/entradas', minlength: 0}},model:{value:(_vm.di.cfop),callback:function ($$v) {_vm.$set(_vm.di, "cfop", $$v)},expression:"di.cfop"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Transporte e Carga"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.datadesemb.validator),expression:"metadata.di.datadesemb.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.di.datadesemb,"disabled":_vm.isView,"name":"datadesemb","v-errors":_vm.errors},model:{value:(_vm.di.datadesemb),callback:function ($$v) {_vm.$set(_vm.di, "datadesemb", $$v)},expression:"di.datadesemb"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.dataentrada.validator),expression:"metadata.di.dataentrada.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.di.dataentrada,"disabled":_vm.isView,"name":"dataentrada","v-errors":_vm.errors},model:{value:(_vm.di.dataentrada),callback:function ($$v) {_vm.$set(_vm.di, "dataentrada", $$v)},expression:"di.dataentrada"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.ufdesemb.validator),expression:"metadata.di.ufdesemb.validator"}],attrs:{"type":"select2","col":"2","metadata":_vm.metadata.di.ufdesemb,"disabled":_vm.isView,"name":"ufdesemb","v-errors":_vm.errors},model:{value:(_vm.di.ufdesemb),callback:function ($$v) {_vm.$set(_vm.di, "ufdesemb", $$v)},expression:"di.ufdesemb"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.localdesemb.validator),expression:"metadata.di.localdesemb.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.di.localdesemb,"disabled":_vm.isView,"name":"localdesemb","v-errors":_vm.errors},model:{value:(_vm.di.localdesemb),callback:function ($$v) {_vm.$set(_vm.di, "localdesemb", $$v)},expression:"di.localdesemb"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.viatranspdi.validator),expression:"metadata.di.viatranspdi.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.di.viatranspdi,"disabled":_vm.isView,"name":"viatranspdi","v-errors":_vm.errors},model:{value:(_vm.di.viatranspdi),callback:function ($$v) {_vm.$set(_vm.di, "viatranspdi", $$v)},expression:"di.viatranspdi"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.tpintermediodi.validator),expression:"metadata.di.tpintermediodi.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.di.tpintermediodi,"disabled":_vm.isView,"name":"tpintermediodi","v-errors":_vm.errors},model:{value:(_vm.di.tpintermediodi),callback:function ($$v) {_vm.$set(_vm.di, "tpintermediodi", $$v)},expression:"di.tpintermediodi"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.ndraw.validator),expression:"metadata.di.ndraw.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.di.ndraw,"disabled":_vm.isView,"name":"ndraw","v-errors":_vm.errors},model:{value:(_vm.di.ndraw),callback:function ($$v) {_vm.$set(_vm.di, "ndraw", $$v)},expression:"di.ndraw"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.pliq.validator),expression:"metadata.di.pliq.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.pliq,"disabled":_vm.isView,"name":"pliq","v-errors":_vm.errors},model:{value:(_vm.di.pliq),callback:function ($$v) {_vm.$set(_vm.di, "pliq", $$v)},expression:"di.pliq"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.pbru.validator),expression:"metadata.di.pbru.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.pbru,"disabled":_vm.isView,"name":"pbru","v-errors":_vm.errors},model:{value:(_vm.di.pbru),callback:function ($$v) {_vm.$set(_vm.di, "pbru", $$v)},expression:"di.pbru"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.qtvolumes.validator),expression:"metadata.di.qtvolumes.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.qtvolumes,"disabled":_vm.isView,"name":"qtvolumes","v-errors":_vm.errors},model:{value:(_vm.di.qtvolumes),callback:function ($$v) {_vm.$set(_vm.di, "qtvolumes", $$v)},expression:"di.qtvolumes"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.volespecie.validator),expression:"metadata.di.volespecie.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.di.volespecie,"disabled":_vm.isView,"name":"volespecie","v-errors":_vm.errors},model:{value:(_vm.di.volespecie),callback:function ($$v) {_vm.$set(_vm.di, "volespecie", $$v)},expression:"di.volespecie"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Informações Complementares"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.di.infcpl),expression:"di.infcpl"}],staticClass:"form-control form-control-sm",attrs:{"rows":"5","cols":"100"},domProps:{"value":(_vm.di.infcpl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.di, "infcpl", $event.target.value)}}})])])]),_vm._v(" "),_c('label-title',{attrs:{"title":"Valores"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vfob,"disabled":true},model:{value:(_vm.di.vfob),callback:function ($$v) {_vm.$set(_vm.di, "vfob", $$v)},expression:"di.vfob"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vfreteint,"disabled":true},model:{value:(_vm.di.vfreteint),callback:function ($$v) {_vm.$set(_vm.di, "vfreteint", $$v)},expression:"di.vfreteint"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vseguroint,"disabled":true},model:{value:(_vm.di.vseguroint),callback:function ($$v) {_vm.$set(_vm.di, "vseguroint", $$v)},expression:"di.vseguroint"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vaduaneiro,"disabled":true},model:{value:(_vm.di.vaduaneiro),callback:function ($$v) {_vm.$set(_vm.di, "vaduaneiro", $$v)},expression:"di.vaduaneiro"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Tributos e Taxas"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.taxamoeda.validator),expression:"metadata.di.taxamoeda.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.taxamoeda,"disabled":_vm.isView,"name":"taxamoeda","v-errors":_vm.errors},model:{value:(_vm.di.taxamoeda),callback:function ($$v) {_vm.$set(_vm.di, "taxamoeda", $$v)},expression:"di.taxamoeda"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.ratsiscomexdi.validator),expression:"metadata.di.ratsiscomexdi.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.di.ratsiscomexdi,"disabled":_vm.isView,"name":"ratsiscomexdi","v-errors":_vm.errors},model:{value:(_vm.di.ratsiscomexdi),callback:function ($$v) {_vm.$set(_vm.di, "ratsiscomexdi", $$v)},expression:"di.ratsiscomexdi"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.rattaxasdi.validator),expression:"metadata.di.rattaxasdi.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.di.rattaxasdi,"disabled":_vm.isView,"name":"rattaxasdi","v-errors":_vm.errors},model:{value:(_vm.di.rattaxasdi),callback:function ($$v) {_vm.$set(_vm.di, "rattaxasdi", $$v)},expression:"di.rattaxasdi"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.vsiscomex.validator),expression:"metadata.di.vsiscomex.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vsiscomex,"disabled":_vm.isView,"preaddon":"R$","name":"vsiscomex","v-errors":_vm.errors},model:{value:(_vm.di.vsiscomex),callback:function ($$v) {_vm.$set(_vm.di, "vsiscomex", $$v)},expression:"di.vsiscomex"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.vafrmm.validator),expression:"metadata.di.vafrmm.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vafrmm,"disabled":_vm.isView,"preaddon":"R$","name":"vafrmm","v-errors":_vm.errors},model:{value:(_vm.di.vafrmm),callback:function ($$v) {_vm.$set(_vm.di, "vafrmm", $$v)},expression:"di.vafrmm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.vmulta.validator),expression:"metadata.di.vmulta.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vmulta,"disabled":_vm.isView,"preaddon":"R$","name":"vmulta","v-errors":_vm.errors},model:{value:(_vm.di.vmulta),callback:function ($$v) {_vm.$set(_vm.di, "vmulta", $$v)},expression:"di.vmulta"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.vacrescimo.validator),expression:"metadata.di.vacrescimo.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vacrescimo,"disabled":_vm.isView,"preaddon":"R$","name":"vacrescimo","v-errors":_vm.errors},model:{value:(_vm.di.vacrescimo),callback:function ($$v) {_vm.$set(_vm.di, "vacrescimo", $$v)},expression:"di.vacrescimo"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.vantidumping.validator),expression:"metadata.di.vantidumping.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vantidumping,"disabled":_vm.isView,"preaddon":"R$","name":"vantidumping","v-errors":_vm.errors},model:{value:(_vm.di.vantidumping),callback:function ($$v) {_vm.$set(_vm.di, "vantidumping", $$v)},expression:"di.vantidumping"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.vataero.validator),expression:"metadata.di.vataero.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vataero,"disabled":_vm.isView,"preaddon":"R$","name":"vataero","v-errors":_vm.errors},model:{value:(_vm.di.vataero),callback:function ($$v) {_vm.$set(_vm.di, "vataero", $$v)},expression:"di.vataero"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vii,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vii),callback:function ($$v) {_vm.$set(_vm.di, "vii", $$v)},expression:"di.vii"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vipi,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vipi),callback:function ($$v) {_vm.$set(_vm.di, "vipi", $$v)},expression:"di.vipi"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vpis,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vpis),callback:function ($$v) {_vm.$set(_vm.di, "vpis", $$v)},expression:"di.vpis"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vcofins,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vcofins),callback:function ($$v) {_vm.$set(_vm.di, "vcofins", $$v)},expression:"di.vcofins"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vicm,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vicm),callback:function ($$v) {_vm.$set(_vm.di, "vicm", $$v)},expression:"di.vicm"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Valores Calculados"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.viicalc,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.viicalc),callback:function ($$v) {_vm.$set(_vm.di, "viicalc", $$v)},expression:"di.viicalc"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vipicalc,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vipicalc),callback:function ($$v) {_vm.$set(_vm.di, "vipicalc", $$v)},expression:"di.vipicalc"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vpiscalc,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vpiscalc),callback:function ($$v) {_vm.$set(_vm.di, "vpiscalc", $$v)},expression:"di.vpiscalc"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vcofinscalc,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vcofinscalc),callback:function ($$v) {_vm.$set(_vm.di, "vcofinscalc", $$v)},expression:"di.vcofinscalc"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.vicmcalc,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.vicmcalc),callback:function ($$v) {_vm.$set(_vm.di, "vicmcalc", $$v)},expression:"di.vicmcalc"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.totalnf,"disabled":true,"preaddon":"R$"},model:{value:(_vm.di.totalnf),callback:function ($$v) {_vm.$set(_vm.di, "totalnf", $$v)},expression:"di.totalnf"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"ICMS"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.orimerc.validator),expression:"metadata.di.orimerc.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.di.orimerc,"disabled":_vm.isView,"name":"orimerc","v-errors":_vm.errors},model:{value:(_vm.di.orimerc),callback:function ($$v) {_vm.$set(_vm.di, "orimerc", $$v)},expression:"di.orimerc"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.sticm.validator),expression:"metadata.di.sticm.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.di.sticm,"disabled":_vm.isView,"name":"sticm","v-errors":_vm.errors},model:{value:(_vm.di.sticm),callback:function ($$v) {_vm.$set(_vm.di, "sticm", $$v)},expression:"di.sticm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.aicm.validator),expression:"metadata.di.aicm.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.aicm,"disabled":_vm.isView,"name":"aicm","v-errors":_vm.errors},model:{value:(_vm.di.aicm),callback:function ($$v) {_vm.$set(_vm.di, "aicm", $$v)},expression:"di.aicm"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.di.picmdif.validator),expression:"metadata.di.picmdif.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.di.picmdif,"disabled":_vm.isView,"name":"picmdif","v-errors":_vm.errors},model:{value:(_vm.di.picmdif),callback:function ($$v) {_vm.$set(_vm.di, "picmdif", $$v)},expression:"di.picmdif"}}),_vm._v(" "),_c('div',{staticClass:"col-2 mt-3"},[(!_vm.isView)?_c('v-button',{attrs:{"label":"Calcular","title":"","nb-btdef":true},on:{"click":_vm.handleCalcular}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"default-container mt-3"},[_c('label-title',{attrs:{"title":"Adições"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(!_vm.isView)?_c('v-button',{attrs:{"label":"Informar Alíquotas nas Adições","title":"","nb-btdef":true},on:{"click":_vm.editAliquotasAdicoes}}):_vm._e()],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.diad),function(adicao,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.nadicao}}),_c('br'),_vm._v(" "),_c('strong',{staticClass:"data-list"},[_vm._v(_vm._s(adicao.nadicao))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.ncm}}),_c('br'),_vm._v(" "),_c('strong',{staticClass:"data-list"},[_vm._v(_vm._s(adicao.ncm))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.aicm}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.aicm,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.picmdif}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.picmdif,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.ricm}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.ricm,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.mva}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.mva,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diad.vicm}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(adicao.vicm,2)))])],1)])])])})],2),_vm._v(" "),_c('div',{staticClass:"default-container mt-3"},[_c('label-title',{attrs:{"title":"Produtos Importados"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(!_vm.isView)?_c('v-button',{attrs:{"label":"Informar Impostos nos Produtos","title":"","nb-btdef":true},on:{"click":_vm.editIcms}}):_vm._e()],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.diit),function(it,index){return _c('div',{key:index,staticClass:"mainbox-select"},[(it.stitemdi == '1')?_c('div',{staticClass:"mark-red"}):_vm._e(),_vm._v(" "),(it.stitemdi == '0')?_c('div',{staticClass:"mark-green"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-12 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"label":"Descricao do Produto na DUIMP"}}),_c('br'),_vm._v(" "),_c('label',{staticClass:"data-list"},[_vm._v(_vm._s(it.descricaox))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"label":"Cod.Item Duimp"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(it.codigoitemx))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.vii}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(it.vii,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.vipi}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(it.vipi,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.vpis}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(it.vpis,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.vcofins}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(it.vcofins,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.qt}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(it.qt,4))+"/"+_vm._s(it.unidadex))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.vlr}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(it.vlr,4)))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.diit.coditem.validator),expression:"metadata.diit.coditem.validator"}],staticClass:"my-2 my-md-0",attrs:{"type":"select2","col":"6","metadata":_vm.metadata.diit.coditem,"name":"coditem","v-errors":_vm.errors},on:{"input":function($event){return _vm.itemChange(index)}},model:{value:(it.coditem),callback:function ($$v) {_vm.$set(it, "coditem", $$v)},expression:"it.coditem"}}),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.coditem}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(it.coditem))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 my-2 my-md-0"},[_c('v-label',{staticClass:"lbl-edit",attrs:{"metadata-field":_vm.metadata.diit.uni}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(it.uni))])],1),_vm._v(" "),_c('form-field',{attrs:{"type":"value","col":"2","metadata":_vm.metadata.diit.qt},model:{value:(it.qt),callback:function ($$v) {_vm.$set(it, "qt", $$v)},expression:"it.qt"}})],1)])])})],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm && !_vm.showEntradaForm),expression:"!showForm && !showEntradaForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"filtro-mes":true,"filter-button":true,"single-entity":"DUIMP","plural-entity":"DUIMPs","moreActions":_vm.moreActionsBarList,"month-filter":_vm.monthFilter,"title-search":"Pesquise pelo nome do fornecedor ou número do DUIMP"},on:{"action":_vm.handleActionBarList,"search":_vm.handleSearch,"new":_vm.handleIncluir,"refresh":_vm.loadData,"changeMonth":_vm.handleSearch}}),_vm._v(" "),_c('div',{staticClass:"default-container mt-3"},[(_vm.diList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.diList),function(di){return _c('div',{key:di.coddi,staticClass:"mainbox"},[_c('div',{staticClass:"mark-gray"}),_vm._v(" "),_c('div',{staticClass:"box pl-3 pl-md-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-7 col-md-12 row"},[_c('div',{staticClass:"col-md-2 col-12",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Número ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(di.numerodi))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12 d-none d-md-block"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data:")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.data(di.data)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12 d-md-flex d-none"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Natureza:")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(di.descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Total FOB:")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(di.vfob)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-5 d-none d-md-block"},[_c('bar-grid',{attrs:{"obj":di,"options":_vm.optionsGrid(di),"moreActions":_vm.moreActionsGrid(di)},on:{"view":function($event){return _vm.handleView(di.coddi)},"edit":function($event){return _vm.handleEdit(di.coddi)},"delete":function($event){return _vm.handleDelete(di.coddi)},"action":_vm.handleAction}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-5 d-flex flex-column align-items-end justify-content-end d-md-none"},[_c('div',{staticClass:"col-md-2 col-6"},[_c('bar-grid',{attrs:{"obj":di,"options":_vm.optionsGrid(di),"moreActions":_vm.moreActionsGrid(di)},on:{"view":function($event){return _vm.handleView(di.coddi)},"edit":function($event){return _vm.handleEdit(di.coddi)},"delete":function($event){return _vm.handleDelete(di.coddi)},"action":_vm.handleAction}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('span',{staticClass:"badge",class:[{'badge-green': di.stdi=='1'},{'badge-orange': di.stdi=='0'}]},[_vm._v(_vm._s(_vm.textST(di.stdi)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 col-6 d-md-flex d-none"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Fornecedor:")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(di.nome))])]),_vm._v(" "),(di.nf)?_c('div',{staticClass:"col-md-2 col-3 d-md-flex d-none"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Série/NF:")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(di.nf))])]):_vm._e()])])])})],2)],1),_vm._v(" "),(_vm.showModalImport)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h5',[_vm._v("Importar DUIMP do Siscomex")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){_vm.showModalImport = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body p-4"},[(_vm.errorMsg)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-danger py-2 mb-3"},[_c('i',{staticClass:"fa fa-exclamation-triangle mr-2"}),_vm._v(" "+_vm._s(_vm.errorMsg)+"\n                        ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-label',{attrs:{"label":"Número da DUIMP (Ex: 24BR000000001)"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","case":"normal"},model:{value:(_vm.duimpNumber),callback:function ($$v) {_vm.duimpNumber=$$v},expression:"duimpNumber"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{attrs:{"label":"Importar","nb-btdef":true},on:{"click":_vm.executeImport}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":function($event){_vm.showModalImport = false}}})],1)])]):_vm._e(),_vm._v(" "),(_vm.showForm)?_c('duimp-form',{attrs:{"params":_vm.params,"crud":_vm.crud},on:{"closeform":_vm.closeForm}}):_vm._e(),_vm._v(" "),(_vm.showEntradaForm)?_c('nfsaida-form',{attrs:{"params":_vm.params,"crud":_vm.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_receber_list_vue__ = __webpack_require__(614);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8f9010_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_receber_list_vue__ = __webpack_require__(1717);
function injectStyle (ssrContext) {
  __webpack_require__(1699)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_receber_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8f9010_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_receber_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1700);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2fc9954c", content, true, {});

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".total strong{font-size:20px}", ""]);

// exports


/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_receber_list_cnab_vue__ = __webpack_require__(615);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d76445b0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_receber_list_cnab_vue__ = __webpack_require__(1704);
function injectStyle (ssrContext) {
  __webpack_require__(1702)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_receber_list_cnab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d76445b0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_receber_list_cnab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1703);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("10824962", content, true, {});

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mark-gray"}),_vm._v(" "),_c('div',{staticClass:"box p-2"},[_c('div',{staticClass:"row"},[(_vm.cta)?_c('div',{staticClass:"col-lg-2 col-md-3 col-3 d-flex"},[_c('input-checkbox',{staticClass:"ml-3",attrs:{"value-checked":true,"value-unchecked":false},model:{value:(_vm.cta.isChecked),callback:function ($$v) {_vm.$set(_vm.cta, "isChecked", $$v)},expression:"cta.isChecked"}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Nr Documento")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.cta.doc))])])],1):_vm._e(),_vm._v(" "),(_vm.cta)?_c('div',{staticClass:"col-lg-1 col-md-1 col-3 d-flex flex-column"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Parcela")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.cta.parcela))])]):_vm._e(),_vm._v(" "),(_vm.cta)?_c('div',{staticClass:"col-lg-2 col-md-2 col-3 d-flex flex-column"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data Emissão")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.cta.data)))])]):_vm._e(),_vm._v(" "),(_vm.cta)?_c('div',{staticClass:"col-lg-2 col-md-2 col-3 d-flex flex-column"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data Vencimento")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.cta.dtv)))])]):_vm._e(),_vm._v(" "),(_vm.cta)?_c('div',{staticClass:"col-lg-3 col-md-3 col-3 d-flex flex-column"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Nome")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.cta.nome))])]):_vm._e(),_vm._v(" "),(_vm.cta)?_c('div',{staticClass:"col-lg-2 col-md-2 col-3 d-flex flex-column"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Valor do Documento")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.cta.vlr,2)))])]):_vm._e()]),_vm._v(" "),(!_vm.cta)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('span',{staticClass:"data-list"},[_vm._v("Não Há Títulos a Serem Vinculados")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1706);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("83363aba", content, true, {});

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1708);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("48f046ee", content, true, {});

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".dropdown-total[data-v-7df88638]{z-index:1051;margin-top:3px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;position:absolute;padding:10px;z-index:1000;min-width:200px;list-style:none;background-color:#fff;border:1px solid #00000033;box-shadow:0 5px 10px #00000033;background-clip:padding-box}", ""]);

// exports


/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_rentabilidade_vue__ = __webpack_require__(618);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_03695245_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_rentabilidade_vue__ = __webpack_require__(1712);
function injectStyle (ssrContext) {
  __webpack_require__(1710)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_rentabilidade_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_03695245_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_rentabilidade_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1711);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("26cf66e0", content, true, {});

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.liberaRentab)?_c('div',[_c('label-title',{attrs:{"title":"Liberação de Orçamento","icon":"fa-lock"}}),_vm._v(" "),_c('alert',{attrs:{"type":"warning","text":"O pedido está aguardando liberação superior"}}),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"case":"normal","type":"memo","col":"6","label":"Observações","name":"obs","v-errors":_vm.errors},model:{value:(_vm.obs),callback:function ($$v) {_vm.obs=$$v},expression:"obs"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 d-flex"},[_c('v-button',{attrs:{"label":"Liberar Agora","success":true},on:{"click":function($event){return _vm.handleLiberar(true)}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Reprovar"},on:{"click":function($event){return _vm.handleLiberar(false)}}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.liberacaoEfetuada || _vm.liberacaoReprovada)?_c('div',[(_vm.liberacaoEfetuada)?_c('label-title',{attrs:{"title":"Rentabilidade","icon":"fa-unlock"}}):_vm._e(),_vm._v(" "),(_vm.liberacaoReprovada)?_c('label-title',{attrs:{"title":"Rentabilidade","icon":"fa-lock"}}):_vm._e(),_vm._v(" "),(_vm.hist)?_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-12 col-12 mb-2"},[_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Liberação efetuada em "+_vm._s(_vm._f("formatDataHoraExtenso")(this.hist.data))+" ")]),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-user pr-2"}),_vm._v("Liberado por "+_vm._s(_vm.hist.nome)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-2"},[(_vm.liberacaoEfetuada)?_c('span',{staticClass:"badge badge-yellow mr-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"dataLeitura"}},[_vm._v("Rentabilidade abaixo do mínimo liberada")]):_vm._e(),_vm._v(" "),(_vm.liberacaoReprovada)?_c('span',{staticClass:"badge badge-red mr-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"dataLeitura"}},[_vm._v("Rentabilidade reprovada")]):_vm._e()]),_vm._v(" "),(_vm.hist.obs)?_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.hist.obs))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.desfazerLiberacao)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 d-flex"},[_c('v-button',{attrs:{"label":"Desfazer Liberação"},on:{"click":function($event){return _vm.handleLiberar(false, true)}}})],1)]):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fv_pedido_form_infcpl_vue__ = __webpack_require__(619);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_115eccf2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fv_pedido_form_infcpl_vue__ = __webpack_require__(1714);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fv_pedido_form_infcpl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_115eccf2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fv_pedido_form_infcpl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('div',{staticClass:"col-md-12 col-12"},[(_vm.pedv.tppedv == 'P')?_c('h4',{staticClass:"def-title"},[_vm._v("Dados do Pedido ("+_vm._s(_vm.pedv.npedido)+") "+_vm._s(_vm.pedv.part[0].nome)+" ")]):_vm._e(),_vm._v(" "),(_vm.pedv.tppedv == 'O')?_c('h4',{staticClass:"def-title"},[_vm._v("Dados do Orçamento ("+_vm._s(_vm.pedv.ncotacao)+") "+_vm._s(_vm.pedv.part[0].nome)+" ")]):_vm._e()])]),_vm._v(" "),(_vm.errmessages)?_c('validation',{attrs:{"title":"Erros de Validação","messages":_vm.errmessages.errmessages}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body",attrs:{"id":"cabec"}},[_c('label-title',{attrs:{"title":"Condições Comerciais"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[(!_vm.pedv.codnegocio)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.seqcontato.validator),expression:"metadata.pedv.seqcontato.validator"}],ref:"contato",attrs:{"type":"select2","col":"6","metadata":_vm.metadata.pedv.seqcontato,"disabled":_vm.isView,"parent":"cabec","name":"seqcontato","v-errors":_vm.errors,"select2":_vm.select2Contato,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluirContato()}},model:{value:(_vm.pedv.seqcontato),callback:function ($$v) {_vm.$set(_vm.pedv, "seqcontato", $$v)},expression:"pedv.seqcontato"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.pedcli.validator),expression:"metadata.pedv.pedcli.validator"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.pedv.pedcli,"name":"pedcli","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.pedv.pedcli),callback:function ($$v) {_vm.$set(_vm.pedv, "pedcli", $$v)},expression:"pedv.pedcli"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codtipo.validator),expression:"metadata.pedv.codtipo.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.pedv.codtipo,"disabled":_vm.isView,"parent":"cabec","name":"codtipo","v-errors":_vm.errors},model:{value:(_vm.pedv.codtipo),callback:function ($$v) {_vm.$set(_vm.pedv, "codtipo", $$v)},expression:"pedv.codtipo"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.pedv.finalidade,"disabled":_vm.isView},model:{value:(_vm.pedv.finalidade),callback:function ($$v) {_vm.$set(_vm.pedv, "finalidade", $$v)},expression:"pedv.finalidade"}}),_vm._v(" "),(!_vm.bloqueia_tabela_cliente)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codtabpre.validator),expression:"metadata.pedv.codtabpre.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.pedv.codtabpre,"select-options":_vm.tabelas_preco_options,"disabled":_vm.isView,"parent":"cabec","name":"codtabpre","v-errors":_vm.errors},model:{value:(_vm.pedv.codtabpre),callback:function ($$v) {_vm.$set(_vm.pedv, "codtabpre", $$v)},expression:"pedv.codtabpre"}}):_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.codtabpre}}),_vm._v(" "),(_vm.pedv.tabpre && _vm.pedv.tabpre.length)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.tabpre[0].descricao))]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.prazodias.validator),expression:"metadata.pedv.prazodias.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.pedv.prazodias,"disabled":_vm.isView,"name":"prazodias","v-errors":_vm.errors},model:{value:(_vm.pedv.prazodias),callback:function ($$v) {_vm.$set(_vm.pedv, "prazodias", $$v)},expression:"pedv.prazodias"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.prazo.validator),expression:"metadata.pedv.prazo.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.pedv.prazo,"disabled":_vm.isView,"name":"prazo","v-errors":_vm.errors},model:{value:(_vm.pedv.prazo),callback:function ($$v) {_vm.$set(_vm.pedv, "prazo", $$v)},expression:"pedv.prazo"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.validadedias.validator),expression:"metadata.pedv.validadedias.validator"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.pedv.validadedias,"disabled":_vm.isView,"name":"validadedias","v-errors":_vm.errors},model:{value:(_vm.pedv.validadedias),callback:function ($$v) {_vm.$set(_vm.pedv, "validadedias", $$v)},expression:"pedv.validadedias"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.dtvalidade.validator),expression:"metadata.pedv.dtvalidade.validator"}],attrs:{"type":"date","col":"2","metadata":_vm.metadata.pedv.dtvalidade,"disabled":_vm.isView,"name":"dtvalidade","v-errors":_vm.errors},model:{value:(_vm.pedv.dtvalidade),callback:function ($$v) {_vm.$set(_vm.pedv, "dtvalidade", $$v)},expression:"pedv.dtvalidade"}})],1),_vm._v(" "),((_vm.pedv.tppedv == 'O' || _vm.pedv.tppedv == 'P') && _vm.pedv.venda == 'S')?_c('div',[_c('label-title',{attrs:{"title":"Comissão"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codvendr.validator),expression:"metadata.pedv.codvendr.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.pedv.codvendr,"disabled":_vm.isView,"name":"codvendr","v-errors":_vm.errors,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluir('vend')}},model:{value:(_vm.pedv.codvendr),callback:function ($$v) {_vm.$set(_vm.pedv, "codvendr", $$v)},expression:"pedv.codvendr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.pcomir.validator),expression:"metadata.pedv.pcomir.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.pedv.pcomir,"precision":2,"disabled":_vm.isView,"name":"pcomir","v-errors":_vm.errors},model:{value:(_vm.pedv.pcomir),callback:function ($$v) {_vm.$set(_vm.pedv, "pcomir", $$v)},expression:"pedv.pcomir"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codvend2.validator),expression:"metadata.pedv.codvend2.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.pedv.codvend2,"disabled":_vm.isView,"name":"codvend2","v-errors":_vm.errors,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluir('vend')}},model:{value:(_vm.pedv.codvend2),callback:function ($$v) {_vm.$set(_vm.pedv, "codvend2", $$v)},expression:"pedv.codvend2"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.pcomi2.validator),expression:"metadata.pedv.pcomi2.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.pedv.pcomi2,"precision":2,"disabled":_vm.isView,"name":"pcomi2","v-errors":_vm.errors},model:{value:(_vm.pedv.pcomi2),callback:function ($$v) {_vm.$set(_vm.pedv, "pcomi2", $$v)},expression:"pedv.pcomi2"}})],1)],1):_vm._e(),_vm._v(" "),_c('label-title',{attrs:{"title":"Transporte"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codparttr.validator),expression:"metadata.pedv.codparttr.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.pedv.codparttr,"disabled":_vm.isView,"parent":"cabec","name":"codparttr","v-errors":_vm.errors,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluir('transp')}},model:{value:(_vm.pedv.codparttr),callback:function ($$v) {_vm.$set(_vm.pedv, "codparttr", $$v)},expression:"pedv.codparttr"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.vlrfre.validator),expression:"metadata.pedv.vlrfre.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedv.vlrfre,"disabled":_vm.isView,"preaddon":"R$","name":"vlrfre","v-errors":_vm.errors},model:{value:(_vm.pedv.vlrfre),callback:function ($$v) {_vm.$set(_vm.pedv, "vlrfre", $$v)},expression:"pedv.vlrfre"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Endereço de Entrega"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.nomeent.validator),expression:"metadata.pedv.nomeent.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.pedv.nomeent,"disabled":_vm.isView,"name":"nomeent","v-errors":_vm.errors},model:{value:(_vm.pedv.nomeent),callback:function ($$v) {_vm.$set(_vm.pedv, "nomeent", $$v)},expression:"pedv.nomeent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.emailent.validator),expression:"metadata.pedv.emailent.validator"}],attrs:{"type":"email","col":"4","metadata":_vm.metadata.pedv.emailent,"disabled":_vm.isView,"name":"emailent","v-errors":_vm.errors},model:{value:(_vm.pedv.emailent),callback:function ($$v) {_vm.$set(_vm.pedv, "emailent", $$v)},expression:"pedv.emailent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.foneent.validator),expression:"metadata.pedv.foneent.validator"}],attrs:{"type":"fone","col":"2","metadata":_vm.metadata.pedv.foneent,"disabled":_vm.isView,"name":"foneent","v-errors":_vm.errors},model:{value:(_vm.pedv.foneent),callback:function ($$v) {_vm.$set(_vm.pedv, "foneent", $$v)},expression:"pedv.foneent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.cepent.validator),expression:"metadata.pedv.cepent.validator"}],attrs:{"type":"cep","col":"2","metadata":_vm.metadata.pedv.cepent,"disabled":_vm.isView,"name":"cepent","v-errors":_vm.errors},on:{"update":_vm.updateCep},model:{value:(_vm.pedv.cepent),callback:function ($$v) {_vm.$set(_vm.pedv, "cepent", $$v)},expression:"pedv.cepent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.endeent.validator),expression:"metadata.pedv.endeent.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.pedv.endeent,"disabled":_vm.isView,"name":"endeent","v-errors":_vm.errors},model:{value:(_vm.pedv.endeent),callback:function ($$v) {_vm.$set(_vm.pedv, "endeent", $$v)},expression:"pedv.endeent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.endenrent.validator),expression:"metadata.pedv.endenrent.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.pedv.endenrent,"disabled":_vm.isView,"name":"endenrent","v-errors":_vm.errors},model:{value:(_vm.pedv.endenrent),callback:function ($$v) {_vm.$set(_vm.pedv, "endenrent", $$v)},expression:"pedv.endenrent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.endecompent.validator),expression:"metadata.pedv.endecompent.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.pedv.endecompent,"disabled":_vm.isView,"name":"endecompent","v-errors":_vm.errors},model:{value:(_vm.pedv.endecompent),callback:function ($$v) {_vm.$set(_vm.pedv, "endecompent", $$v)},expression:"pedv.endecompent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.bairroent.validator),expression:"metadata.pedv.bairroent.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.pedv.bairroent,"disabled":_vm.isView,"name":"bairroent","v-errors":_vm.errors},model:{value:(_vm.pedv.bairroent),callback:function ($$v) {_vm.$set(_vm.pedv, "bairroent", $$v)},expression:"pedv.bairroent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.ufent.validator),expression:"metadata.pedv.ufent.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.pedv.ufent,"disabled":_vm.isView,"parent":"cabec","name":"ufent","v-errors":_vm.errors},model:{value:(_vm.pedv.ufent),callback:function ($$v) {_vm.$set(_vm.pedv, "ufent", $$v)},expression:"pedv.ufent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codmunent.validator),expression:"metadata.pedv.codmunent.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.pedv.codmunent,"disabled":_vm.isView,"parent":"cabec","name":"codmunent","v-errors":_vm.errors,"select2":{entity: 'mun/uf/' + _vm.pedv.ufent, minlength: 2}},model:{value:(_vm.pedv.codmunent),callback:function ($$v) {_vm.$set(_vm.pedv, "codmunent", $$v)},expression:"pedv.codmunent"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codpaisent.validator),expression:"metadata.pedv.codpaisent.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.pedv.codpaisent,"parent":"cabec","name":"codpaisent","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.pedv.codpaisent),callback:function ($$v) {_vm.$set(_vm.pedv, "codpaisent", $$v)},expression:"pedv.codpaisent"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.pedv.tppessoaent,"disabled":_vm.isView},model:{value:(_vm.pedv.tppessoaent),callback:function ($$v) {_vm.$set(_vm.pedv, "tppessoaent", $$v)},expression:"pedv.tppessoaent"}}),_vm._v(" "),(_vm.pedv.tppessoaent=='F')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({cpf: true, required: true, numeric: true, min: 11, max: 11}),expression:"{cpf: true, required: true, numeric: true, min: 11, max: 11}"}],attrs:{"type":"number","col":"3","metadata":_vm.metadata.pedv.cnpjcpfent,"disabled":_vm.isView,"name":"cpf","v-errors":_vm.errors},model:{value:(_vm.pedv.cnpjcpfent),callback:function ($$v) {_vm.$set(_vm.pedv, "cnpjcpfent", $$v)},expression:"pedv.cnpjcpfent"}}):_vm._e(),_vm._v(" "),(_vm.pedv.tppessoaent=='J')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({cnpj: true, required: true, numeric: true, min: 14, max: 14}),expression:"{cnpj: true, required: true, numeric: true, min: 14, max: 14}"}],attrs:{"type":"number","col":"3","metadata":_vm.metadata.pedv.cnpjcpfent,"disabled":_vm.isView,"name":"cnpj","v-errors":_vm.errors},model:{value:(_vm.pedv.cnpjcpfent),callback:function ($$v) {_vm.$set(_vm.pedv, "cnpjcpfent", $$v)},expression:"pedv.cnpjcpfent"}}):_vm._e(),_vm._v(" "),(_vm.pedv.tppessoaent=='J')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.iestent.validator),expression:"metadata.pedv.iestent.validator"}],attrs:{"metadata":_vm.metadata.pedv.iestent,"type":"text","col":"4","disabled":_vm.isView,"name":"iestent","v-errors":_vm.errors},model:{value:(_vm.pedv.iestent),callback:function ($$v) {_vm.$set(_vm.pedv, "iestent", $$v)},expression:"pedv.iestent"}}):_vm._e()],1),_vm._v(" "),(_vm.administrador && _vm.metadata.pedv.codusuario.select2 && _vm.metadata.pedv.codusuario.select2.entity)?_c('div',[_c('label-title',{attrs:{"title":"Usuario vinculado ao pedido"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codusuario.validator),expression:"metadata.pedv.codusuario.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.pedv.codusuario,"disabled":_vm.isView,"name":"codusuario","v-errors":_vm.errors},model:{value:(_vm.pedv.codusuario),callback:function ($$v) {_vm.$set(_vm.pedv, "codusuario", $$v)},expression:"pedv.codusuario"}})],1)],1):_vm._e(),_vm._v(" "),_c('label-title',{attrs:{"title":"Observações"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.obspedido.validator),expression:"metadata.pedv.obspedido.validator"}],attrs:{"type":"memo","col":"6","metadata":_vm.metadata.pedv.obspedido,"disabled":_vm.isView,"name":"obspedido","v-errors":_vm.errors},model:{value:(_vm.pedv.obspedido),callback:function ($$v) {_vm.$set(_vm.pedv, "obspedido", $$v)},expression:"pedv.obspedido"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.obslog.validator),expression:"metadata.pedv.obslog.validator"}],attrs:{"type":"memo","col":"6","label":"Observação Interna","disabled":_vm.isView,"name":"obslog","v-errors":_vm.errors},model:{value:(_vm.pedv.obslog),callback:function ($$v) {_vm.$set(_vm.pedv, "obslog", $$v)},expression:"pedv.obslog"}})],1),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isView),expression:"!isView"}],attrs:{"label":"Salvar","title":"","nb-btdef":true},on:{"click":_vm.handleSave}}),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isView),expression:"!isView"}],attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeForm}}),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isView),expression:"isView"}],attrs:{"label":"Fechar","title":""},on:{"click":_vm.closeForm}})],1)],1)],1),_vm._v(" "),(_vm.showContatoForm)?_c('div',[_c('customer-contato-form',{attrs:{"crud":"ins","codpart":_vm.pedv.codpart},on:{"closeform":_vm.closeContatoForm}})],1):_vm._e(),_vm._v(" "),(_vm.showPartForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('customer-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closeCustomerForm}})],1)])]):_vm._e(),_vm._v(" "),(_vm.showVendForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('vend-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closeVendForm}})],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"default-container mb-2",attrs:{"id":"formOrder"}},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"float-right"},[_c('v-button',{attrs:{"label":"Retornar","title":"","icon":"fa-arrow-left"},on:{"click":function($event){return _vm.handleRetorna()}}}),_vm._v(" "),(_vm.btTotalizar)?_c('v-button',{attrs:{"label":"Finalizar Digitação de Produtos","nb-btdef":true,"title":"Efetua a totalização do pedido e encerra a digitação"},on:{"click":function($event){return _vm.handleTotalizar()}}}):_vm._e(),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.btImprimir),expression:"btImprimir"}],attrs:{"label":"","icon":"fa-whatsapp","title":"Enviar o pedido por whatsapp"},on:{"click":_vm.handleShowContatosWhats}}),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.btImprimir),expression:"btImprimir"}],attrs:{"title":"Visualizar","icon":"fa-print"},on:{"click":function($event){return _vm.handleAction(1)}}}),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.btEnviar),expression:"btEnviar"}],attrs:{"title":"Enviar Email","icon":"fa-envelope-open"},on:{"click":function($event){return _vm.handleEmail()}}}),_vm._v(" "),(_vm.moreActions.length > 0)?_c('v-button',{attrs:{"actions":_vm.moreActions},on:{"click":_vm.handleAction}}):_vm._e()],1)]),_vm._v(" "),(_vm.pedv.codpedv !== null)?_c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-user mr-2"}),_vm._v("Proprietário "+_vm._s(_vm.pedv.usuario_nome)+" ")]),_vm._v(" "),_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Criado em "+_vm._s(_vm._f("formatDataExtenso")(_vm.pedv.data)))]),_vm._v(" "),(_vm.pedv.data_leitura)?_c('span',{staticClass:"badge badge-yellow mr-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":_vm.dataLeitura}},[_vm._v("Leitura Efetuada")]):_vm._e(),_vm._v(" "),(_vm.tagAlteracaoBloqueada)?_c('span',{staticClass:"badge badge-red mr-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Alteração não permitida em pedidos com leitura efetuada"}},[_vm._v(" "+_vm._s(_vm.tagAlteracaoBloqueada)+" ")]):_vm._e(),_vm._v(" "),(_vm.pedv.tppedv == 'P')?_c('span',{staticClass:"badge",class:_vm.statusColor(_vm.pedv.stpedv)},[_vm._v(_vm._s(_vm.textOption(_vm.pedv.stpedv,
            _vm.metadata.pedv.stpedv)))]):_vm._e(),_vm._v(" "),(_vm.pedv.tppedv == 'R')?_c('span',{staticClass:"badge badge-red"},[_vm._v("Orçamento Perdido")]):_vm._e(),_vm._v(" "),(_vm.pedv.nf_pendente)?_c('span',{staticClass:"badge badge-red"},[_c('strong',[_vm._v("Pedido com nota fiscal pendente")])]):_vm._e(),_vm._v(" "),(_vm.pedv.fin_baixado)?_c('span',{staticClass:"badge badge-yellow"},[_vm._v("Pedido com título recebido")]):_vm._e(),_vm._v(" "),(_vm.pedv.fin_remessa)?_c('span',{staticClass:"badge badge-yellow"},[_vm._v("Título enviado em remessa bancaria")]):_vm._e(),_vm._v(" "),(_vm.pedv.status)?_c('span',{staticClass:"badge badge-blue"},[_vm._v(" "+_vm._s(_vm.pedv.status)+" ")]):_vm._e(),_vm._v(" "),(_vm.pedv.ecommerce == 'S' && _vm.pedv.clienteretira == 'S')?_c('span',{staticClass:"badge badge-info"},[_c('i',{staticClass:"fa fa-truck mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Retirar no local")]):_vm._e(),_vm._v(" "),(_vm.pedv.ecommerce == 'S' && _vm.pedv.clienteretira == 'N' && _vm.pedv.descricaofrete)?_c('span',{staticClass:"badge badge-info"},[_c('i',{staticClass:"fa fa-truck mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.pedv.descricaofrete))]):_vm._e(),_vm._v(" "),(_vm.orcamentoVencido)?_c('span',{staticClass:"badge badge-red mr-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Orçamento com data de validade vencida"}},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v("\n          Vencido")]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.orcamentoCrm)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-3"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.negociocrm.titulo}}),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('span',{staticClass:"lbl-title-produto pr-2",on:{"click":function($event){return _vm.handleShowNegocio(_vm.negociocrm.codnegocio)}}},[_vm._v(" "+_vm._s(_vm.negociocrm.titulo)+" ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.negociocrm.codorg}}),_vm._v(" "),(_vm.organizacao)?_c('div',{staticClass:"w-100"},[_c('span',{staticClass:"lbl-title-produto pr-2",on:{"click":function($event){return _vm.handleShowOrg(_vm.negociocrm.codorg)}}},[_vm._v(" "+_vm._s(_vm.organizacao.nome)+"\n          ")])]):_c('div',{staticClass:"w-100"},[_c('span',{staticClass:"lbl-title-produto pr-2"},[_vm._v(" Nenhuma organização vinculada ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.negociocrm.codpessoa}}),_vm._v(" "),(_vm.pessoa)?_c('div',{staticClass:"w-100"},[_c('span',{staticClass:"lbl-title-produto pr-2",on:{"click":function($event){return _vm.handleShowPessoa(_vm.pessoa.codpessoa)}}},[_vm._v(" "+_vm._s(_vm.pessoa.nome)+" ")])]):_c('div',{staticClass:"w-100"},[_c('span',{staticClass:"lbl-title-produto pr-2"},[_vm._v(" Nenhum contato vinculado ")])]),_vm._v(" "),(_vm.pessoa)?_c('div',_vm._l((_vm.pessoa.telefones),function(fone,index){return _c('div',{key:index,staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-12"},[_c('i',{staticClass:"fa fa-phone pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(_vm._f("formatFone")(fone.numero))+" ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(_vm._f("getTextOption")(fone.tipofone,_vm.metadata.fonecrm.tipofone))+" ")])])])}),0):_vm._e(),_vm._v(" "),(_vm.pessoa)?_c('div',_vm._l((_vm.pessoa.emails),function(email,index){return _c('div',{key:index,staticClass:"row align-items-center mb-1"},[_c('div',{staticClass:"col-md-12"},[_c('i',{staticClass:"fa fa-envelope pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(email.email)+" ")])])])}),0):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formNew && !_vm.orcamentoCrm),expression:"formNew && !orcamentoCrm"}]},[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Cliente","icon":"fa-university"}}),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col"},[_c('input-part',{ref:"part",attrs:{"add-button":true},model:{value:(_vm.pedv.codpart),callback:function ($$v) {_vm.$set(_vm.pedv, "codpart", $$v)},expression:"pedv.codpart"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.seqcontato.validator),expression:"metadata.pedv.seqcontato.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.pedv.seqcontato,"disabled":_vm.isView,"name":"seqcontato","v-errors":_vm.errors,"select2":_vm.select2Contato,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluirContato()}},model:{value:(_vm.pedv.seqcontato),callback:function ($$v) {_vm.$set(_vm.pedv, "seqcontato", $$v)},expression:"pedv.seqcontato"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.pedv.finalidade},model:{value:(_vm.pedv.finalidade),callback:function ($$v) {_vm.$set(_vm.pedv, "finalidade", $$v)},expression:"pedv.finalidade"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.pedcli.validator),expression:"metadata.pedv.pedcli.validator"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.pedv.pedcli,"name":"pedcli","v-errors":_vm.errors},model:{value:(_vm.pedv.pedcli),callback:function ($$v) {_vm.$set(_vm.pedv, "pedcli", $$v)},expression:"pedv.pedcli"}})],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formNew),expression:"formNew"}]},[(_vm.bloqueia_tabela_cliente)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-6 mb-2"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.codtabpre}}),_vm._v(" "),(_vm.pedv.tabpre)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.tabpre.descricao))]):_vm._e()],1)]):_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codtabpre.validator),expression:"metadata.pedv.codtabpre.validator"}],attrs:{"type":"select","col":"3","metadata":_vm.metadata.pedv.codtabpre,"select-options":_vm.tabelas_preco_options,"name":"codtabpre","v-errors":_vm.errors},model:{value:(_vm.pedv.codtabpre),callback:function ($$v) {_vm.$set(_vm.pedv, "codtabpre", $$v)},expression:"pedv.codtabpre"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.pedv.tpfrete,"disabled":_vm.isView},model:{value:(_vm.pedv.tpfrete),callback:function ($$v) {_vm.$set(_vm.pedv, "tpfrete", $$v)},expression:"pedv.tpfrete"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codparttr.validator),expression:"metadata.pedv.codparttr.validator"}],attrs:{"type":"select2","col":"3","metadata":_vm.metadata.pedv.codparttr,"disabled":_vm.isView,"name":"codparttr","v-errors":_vm.errors,"add-button":true},on:{"clickAdd":_vm.handleIncluir},model:{value:(_vm.pedv.codparttr),callback:function ($$v) {_vm.$set(_vm.pedv, "codparttr", $$v)},expression:"pedv.codparttr"}})],1)]),_vm._v(" "),(_vm.pedv.codpedv !== null)?_c('div',[(!_vm.orcamentoCrm)?_c('label-title',{attrs:{"title":"Cliente","icon":"fa-university"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(!_vm.orcamentoCrm)?_c('div',{staticClass:"col-12 col-md-6 mb-2"},[_c('input-part',{ref:"part",attrs:{"seqcontato":_vm.pedv.seqcontato,"disabled":true},model:{value:(_vm.pedv.codpart),callback:function ($$v) {_vm.$set(_vm.pedv, "codpart", $$v)},expression:"pedv.codpart"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('input-switch',{attrs:{"type":"success","label":"Imprimir Informações Gerais e Garantia dos Produtos","value-checked":"S","value-unchecked":"N"},on:{"input":_vm.updateImpInfGeraisGarantia},model:{value:(_vm.pedv.impinfgeraisgarantia),callback:function ($$v) {_vm.$set(_vm.pedv, "impinfgeraisgarantia", $$v)},expression:"pedv.impinfgeraisgarantia"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[(_vm.anexos.length > 0)?_c('label-title',{attrs:{"title":"Anexos","icon":"fa-paperclip"}}):_vm._e(),_vm._v(" "),(_vm.anexos.length > 0 || _vm.showAnexo)?_c('anexos-form',{ref:"anexos",attrs:{"params":{ ref: 'pedv', chaveref: _vm.pedv.codpedv, showForm: false }},on:{"change":_vm.handleChangeAnexos}}):_vm._e()],1)])],1):_vm._e(),_vm._v(" "),(_vm.errmessages && _vm.errmessages.errmessages)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label-title',{attrs:{"title":"Erros de Validação","icon":"fa-check-circle"}})],1)]):_vm._e(),_vm._v(" "),(_vm.errmessages)?_c('validation',{attrs:{"title":"Erros de Validação","messages":_vm.errmessages.errmessages}}):_vm._e(),_vm._v(" "),(_vm.pedv)?_c('pedido-rentabilidade',{attrs:{"pedv":_vm.pedv},on:{"reload":function($event){return _vm.loadData(_vm.pedv.codpedv)}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"default-container mb-2",staticStyle:{"border-top":"3px solid black"}},[_c('div',{},[_c('label-title',{attrs:{"title":"Produtos","icon":"fa-archive"}}),_vm._v(" "),(!_vm.isView && _vm.showPesquisaItens)?_c('pedido-addlist',{ref:"addList",attrs:{"params":_vm._paramsPesquisa},on:{"closeform":_vm.closeFormItem,"additem":_vm.handleSalvarItens}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row col mb-2"},[(!_vm.isView && _vm.possuiListaDestaqueValida)?_c('v-button',{attrs:{"label":"Lista de Destaques","title":"Visualizar lista de produtos em destaque","icon":"fa-tags"},on:{"click":_vm.handleShowDestaque}}):_vm._e(),_vm._v(" "),(!_vm.bloqueia_descontos && !_vm.showDescontos)?_c('v-button',{staticClass:"float-right",attrs:{"disabled":_vm.isView,"label":"Aplicar Desconto Sobre Desconto","title":"Aplicar descontos escalonados em todos os itens"},on:{"click":function($event){return _vm.handleShowDescontos('itens')}}}):_vm._e(),_vm._v(" "),(!_vm.bloqueia_descontos && !_vm.showDescontos)?_c('v-button',{staticClass:"float-right",attrs:{"disabled":_vm.isView,"label":"Aplicar Desconto em Valor","title":"Aplicar desconto no total do pedido"},on:{"click":function($event){return _vm.handleShowDescontos('total')}}}):_vm._e()],1),_vm._v(" "),(!_vm.isView && _vm.showListaDestaques)?_c('pedido-addlist',{attrs:{"params":_vm._paramsDestaques},on:{"closeform":_vm.closeDestaque,"additem":_vm.handleSalvarItens}}):_vm._e(),_vm._v(" "),(_vm.showDescontos)?_c('div',{staticClass:"p-3 border"},[(_vm.aplicaDescontoItens)?_c('label-title',{attrs:{"title":"Descontos Sobre Desconto","icon":""}}):_vm._e(),_vm._v(" "),(_vm.aplicaDescontoItens)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-2"},[_vm._v("\n            Os descontos informados aqui serão substituídos nos itens\n          ")]),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.pdesc1.validator),expression:"metadata.pedv.pdesc1.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedv.pdesc1,"precision":2,"addon":"%","name":"pdesc1","v-errors":_vm.errors},model:{value:(_vm.pedv.pdesc1),callback:function ($$v) {_vm.$set(_vm.pedv, "pdesc1", $$v)},expression:"pedv.pdesc1"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.pdesc2.validator),expression:"metadata.pedv.pdesc2.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedv.pdesc2,"precision":2,"addon":"%","name":"pdesc2","v-errors":_vm.errors},model:{value:(_vm.pedv.pdesc2),callback:function ($$v) {_vm.$set(_vm.pedv, "pdesc2", $$v)},expression:"pedv.pdesc2"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.pdesc3.validator),expression:"metadata.pedv.pdesc3.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedv.pdesc3,"precision":2,"addon":"%","name":"pdesc3","v-errors":_vm.errors},model:{value:(_vm.pedv.pdesc3),callback:function ($$v) {_vm.$set(_vm.pedv, "pdesc3", $$v)},expression:"pedv.pdesc3"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.pdesc4.validator),expression:"metadata.pedv.pdesc4.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.pedv.pdesc4,"precision":2,"addon":"%","name":"pdesc4","v-errors":_vm.errors},model:{value:(_vm.pedv.pdesc4),callback:function ($$v) {_vm.$set(_vm.pedv, "pdesc4", $$v)},expression:"pedv.pdesc4"}})],1):_vm._e(),_vm._v(" "),(_vm.aplicaDescontoTotal)?_c('label-title',{attrs:{"title":"Desconto no total","icon":""}}):_vm._e(),_vm._v(" "),(_vm.aplicaDescontoTotal)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.vlrdesc.validator),expression:"metadata.pedv.vlrdesc.validator"}],attrs:{"type":"value","col":"2","precision":2,"preaddon":"R$","name":"vlrdesc","v-errors":_vm.errors},model:{value:(_vm.pedv.vlrdesc),callback:function ($$v) {_vm.$set(_vm.pedv, "vlrdesc", $$v)},expression:"pedv.vlrdesc"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('v-button',{attrs:{"label":"Confirmar","nb-btdef":true,"title":"Aplicar os descontos informados em todos os itens"},on:{"click":_vm.handleAplicaDescontos}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Descartar"},on:{"click":_vm.handleCloseDescontos}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.pedvit.length == 0)?_c('div',[_c('alert',{attrs:{"type":"warning","text":"O pedido ainda não possui produtos."}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.pedvit),function(it,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"mark-green"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col-2 text-center d-flex align-items-center"},[(it.item[0].url)?_c('img',{staticClass:"m-auto",staticStyle:{"max-width":"55px","max-height":"55px","cursor":"pointer"},attrs:{"src":it.item[0].url,"alt":"Logotipo"}}):_c('i',{staticClass:"fa fa-camera m-auto",staticStyle:{"font-size":"25px","color":"silver"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-10"},[_c('span',{staticClass:"lbl-list-produto w-100"},[_vm._v(_vm._s(it.item[0].descricao))]),_vm._v(" "),_c('v-label',{attrs:{"label":"Codigo"}}),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(it.item[0].codigo))]),_vm._v(" "),(it.pedvgrade && it.pedvgrade.length > 0)?_c('v-button',{attrs:{"title":"Exibir grade","icon":"fa-th"},on:{"click":function($event){return _vm.handleShowGradeItem(index)}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(it.faltaestoque == 'S')?_c('span',{staticClass:"error"},[_vm._v("Produto não possui estoque suficiente.")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[_c('v-label',{attrs:{"label":"Quantidade x Preço"}}),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(it.qtuni)+" "+_vm._s(it.uni)+" x "),_c('small',[_vm._v("R$")]),_vm._v(" "+_vm._s(_vm._f("format")(it.vlr,2)))]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(it.aipi)?_c('span',{staticClass:"lbl"},[_c('small',[_vm._v("IPI")]),_vm._v(" "+_vm._s(it.aipi)+"%")]):_vm._e(),_vm._v(" "),(it.vicmst)?_c('span',{staticClass:"lbl"},[_c('small',[_vm._v("ICM ST R$")]),_vm._v(" "+_vm._s(_vm._f("format")(it.vicmst,2)))]):_vm._e()],1),_vm._v(" "),(it.qt != it.qtuni)?_c('div',{staticClass:"col-md-2 col-4"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedvit.qt}}),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(it.qt))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[_c('v-label',{staticClass:"d-block",attrs:{"label":"Desconto"}}),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("format")(it.ptotdes,2))+"%")]),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v("("),_c('small',[_vm._v("R$")]),_vm._v(" "+_vm._s(_vm._f("format")(it.totdes,2))+")")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-4"},[_c('v-label',{attrs:{"label":"Total"}}),_vm._v(" "),_c('span',{staticClass:"lbl"},[_c('small',[_vm._v("R$")]),_vm._v(" "+_vm._s(_vm._f("format")(it.totger,2)))])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(it.stpedv == 'D' || it.stpedv == 'P'),expression:"it.stpedv == 'D' || it.stpedv == 'P'"}],staticClass:"col-md-2 col-12"},[_c('bar-grid',{attrs:{"options":{ barPedvIt: true, stpedv: it.stpedv, isView: _vm.isView },"moreActions":{}},on:{"edit":function($event){return _vm.handleEditItem(it.itped, false)},"view":function($event){return _vm.handleEditItem(it.itped, true)},"cancel":function($event){return _vm.handleItemCancelMsg(it.itped)},"delete":function($event){return _vm.handleItemDeleteMsg(it.itped)},"action":function($event){return _vm.closeForm()}}})],1),_vm._v(" "),(it.showGrade)?_c('div',{staticClass:"col"},[_c('grade',{ref:"grade",refInFor:true,attrs:{"params":{ view: true, coditem: it.coditem, qt: it.qtuni, listItemGrade: it.pedvgrade }}})],1):_vm._e()])])])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formOrder),expression:"formOrder"}],attrs:{"id":"formTotal"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pedvit.length > 0),expression:"pedvit.length > 0"}]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"ml-auto col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedv.totmer}}),_vm._v(" "),_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.totmer,2)))]),_vm._v(" "),(_vm.pedv.ptotdes > 0)?_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedv.ptotdes}}):_vm._e(),_vm._v(" "),(_vm.pedv.ptotdes > 0)?_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("format")(_vm.pedv.ptotdes,2))+"%")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.pedv.vlrdesc > 0)?_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedv.vlrdesc}}):_vm._e(),_vm._v(" "),(_vm.pedv.vlrdesc > 0)?_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("format")(_vm.pedv.vlrdesc,2)))]):_vm._e(),_vm._v(" "),_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedv.totdes}}),_vm._v(" "),_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.totdes,2)))]),_vm._v(" "),_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedv.rentab}}),_vm._v(" "),_c('span',{staticClass:"lbl float-right"},[_vm._v(_vm._s(_vm._f("format")(_vm.pedv.rentab,2))+"%")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedv.toticm}}),_vm._v(" "),_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.toticm,2)))]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedv.toticmst}}),_vm._v(" "),_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.toticmst,2)))]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedv.totipi}}),_vm._v(" "),_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.totipi,2)))]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedv.vlrfre}}),_vm._v(" "),_c('span',{staticClass:"lbl float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.vlrfre,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('v-label',{staticClass:"float-right",attrs:{"metadata-field":_vm.metadata.pedv.totger}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl-total-documento float-right"},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.totger,2)))])],1)])])])],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.formNew),expression:"!formNew"}],staticClass:"default-container mb-2",staticStyle:{"border-top":"3px solid black"}},[_c('div',{staticClass:"mt-2",attrs:{"id":"condicao"}},[_c('label-title',{attrs:{"title":"Condição de Pagamento","icon":"fa-credit-card"}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{staticClass:"row"},[(_vm.condicaoList.length > 0)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codcondicao.validator),expression:"metadata.pedv.codcondicao.validator"}],ref:"condicao",attrs:{"type":"select2","col":"4","metadata":_vm.metadata.pedv.codcondicao,"disabled":_vm.isView,"name":"codcondicao","v-errors":_vm.errors},model:{value:(_vm.pedv.codcondicao),callback:function ($$v) {_vm.$set(_vm.pedv, "codcondicao", $$v)},expression:"pedv.codcondicao"}}):_vm._e(),_vm._v(" "),(_vm.appERP)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedv.codnatfin.validator),expression:"metadata.pedv.codnatfin.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.pedv.codnatfin,"disabled":_vm.isView,"select2":{ entity: 'natfin/receitas/', minlength: 0 },"name":"codnatfin","v-errors":_vm.errors},model:{value:(_vm.pedv.codnatfin),callback:function ($$v) {_vm.$set(_vm.pedv, "codnatfin", $$v)},expression:"pedv.codnatfin"}}):_vm._e(),_vm._v(" "),(_vm.condicaoList.length == 0)?_c('form-field',{ref:"parcelas",attrs:{"type":"select","col":"2","metadata":_vm.metadata.pedv.parcelas,"disabled":_vm.isView},model:{value:(_vm.pedv.parcelas),callback:function ($$v) {_vm.$set(_vm.pedv, "parcelas", $$v)},expression:"pedv.parcelas"}}):_vm._e(),_vm._v(" "),(_vm.pedv.parcelas > '0')?_c('div',{staticClass:"col-md-10 col-12"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedvpar.dias}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedvpar.dtv}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedvpar.vlr}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.pedvpar.obspar}})],1)]),_vm._v(" "),_vm._l((_vm.pedvpar),function(par,index){return _c('div',{key:index,staticClass:"row justify-content-md-center"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvpar.dias.validator),expression:"metadata.pedvpar.dias.validator"}],attrs:{"type":"number","col":"2","disabled":_vm.isView,"name":"dias","v-errors":_vm.errors},on:{"input":function($event){return _vm.pedvparDiasChange(index)}},model:{value:(par.dias),callback:function ($$v) {_vm.$set(par, "dias", $$v)},expression:"par.dias"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvpar.dtv.validator),expression:"metadata.pedvpar.dtv.validator"}],attrs:{"type":"date","col":"2","disabled":_vm.isView,"name":"dtv","v-errors":_vm.errors},model:{value:(par.dtv),callback:function ($$v) {_vm.$set(par, "dtv", $$v)},expression:"par.dtv"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvpar.vlr.validator),expression:"metadata.pedvpar.vlr.validator"}],attrs:{"type":"value","col":"2","precision":2,"disabled":_vm.isView,"name":"vlr","v-errors":_vm.errors},on:{"input":function($event){return _vm.pedvparVlrChange(index)}},model:{value:(par.vlr),callback:function ($$v) {_vm.$set(par, "vlr", $$v)},expression:"par.vlr"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","col":"2","disabled":_vm.isView,"name":"obs"},model:{value:(par.obs),callback:function ($$v) {_vm.$set(par, "obs", $$v)},expression:"par.obs"}})],1)})],2):_vm._e()],1)])])],1),_vm._v(" "),((_vm.pedv.tppedv == 'P') && (_vm.cielo_condicao || _vm.rede_condicao || _vm.pagseguro_condicao))?_c('div',{staticClass:"mt-3 mb-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('label-title',{attrs:{"title":"Pagamento On-line","icon":"fa-credit-card"}})],1)]),_vm._v(" "),(_vm.pedv.vendarecebida == 'S')?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.cielo_condicao)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.pedv.cieloidsuperlink && _vm.pedv.vendarecebida != 'S')?_c('v-button',{attrs:{"label":"Excluir Link Pagamento","title":"Excluir Link Pagamento","icon":"fa-trash"},on:{"click":function($event){return _vm.handleExcluirLinkPagamento()}}}):_vm._e(),_vm._v(" "),_c('v-button',{attrs:{"label":"Requisitar Pagamento","title":"Requisitar pagamento em cartão","icon":"fa-envelope"},on:{"click":function($event){return _vm.handleLinkPagamento()}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Requisitar Pagamento","title":"Requisitar pagamento em cartão","icon":"fa-whatsapp"},on:{"click":function($event){return _vm.handleLinkPagamento('whats')}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Link de pagamento","title":"","icon":"fa-external-link"},on:{"click":function($event){return _vm.handleLinkPagamento('acessar')}}}),_vm._v(" "),(_vm.pedv.cieloidsuperlink && _vm.pedv.vendarecebida != 'S' && _vm.pedv.vendarecebida != 'N')?_c('span',{staticClass:"float-right badge badge-warning mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("\n            Solicitação de pagamento gerada ")]):_vm._e(),_vm._v(" "),(_vm.pedv.cieloidsuperlink && _vm.pedv.vendarecebida == 'N')?_c('span',{staticClass:"float-right badge badge-warning mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Pagamento Não realizado ")]):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12"},[_c('label-title',{attrs:{"title":"Retorno da Operadora de Pagamento On-line","icon":"fa-credit-card"}}),_vm._v(" "),(_vm.pedv.pedvcielosl && _vm.pedv.pedvcielosl.length == 0)?_c('div',[_c('alert',{attrs:{"type":"warning","text":"O pedido ainda não possui retornos da operadora de cartão."}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.pedv.pedvcielosl),function(it,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"label":"Data"}}),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatDataHoraExtenso")(it.data)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4"},[_c('v-label',{attrs:{"label":"Status"}}),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(it.status))])],1)])])])})],2)])]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.formNew),expression:"!formNew"}],staticClass:"default-container mb-2",staticStyle:{"border-top":"3px solid black"}},[(_vm.pedv.logistica == '1')?_c('label-title',{attrs:{"title":"Integração Logística/Frete","icon":"fa-truck"}}):_vm._e(),_vm._v(" "),(_vm.pedv.logistica == '1')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3 text-center"},[_c('img',{staticClass:"d-block",attrs:{"src":"melhorenvio.png","alt":"Melhorenvio"}}),_vm._v(" "),(_vm.pedv.remessalogistica == 'S')?_c('span',{staticClass:"badge badge-yellow mr-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Remessa Enviada"}},[_vm._v("Remessa Enviada")]):_vm._e()]),_vm._v(" "),(_vm.pedv.remessalogistica == 'N')?_c('div',{staticClass:"col-md-2 col-3"},[_c('v-button',{attrs:{"label":"Enviar Remessa","title":""},on:{"click":_vm.handleRemessaLogistica}})],1):_c('div',{staticClass:"col-md-2 col-3"},[_c('v-button',{attrs:{"label":"Imprimir Etiquetas","title":""},on:{"click":_vm.handleEtiquetaLogistica}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.codfrete}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.descricaofrete))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.logisticaValidation)?_c('validation',{staticClass:"mt-3",attrs:{"title":"Erros de Validação","messages":_vm.logisticaValidation}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('label-title',{attrs:{"title":"Informações Adicionais","icon":"fa-info-circle"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-button',{staticClass:"mb-3",attrs:{"label":"Alterar Informações Adicionais","title":"","nb-btdef":false},on:{"click":_vm.handleInfAdicionais}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.finalidade}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.textOption(_vm.pedv.finalidade, _vm.metadata.pedv.finalidade)))])],1),_vm._v(" "),(_vm.pedv.prazodias)?_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.prazodias}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.prazodias))])],1):_vm._e(),_vm._v(" "),(_vm.pedv.prazo)?_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.prazo}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.pedv.prazo)))])],1):_vm._e(),_vm._v(" "),(_vm.pedv.validadedias)?_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.validadedias}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.validadedias))])],1):_vm._e(),_vm._v(" "),(_vm.pedv.dtvalidade)?_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.dtvalidade}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.pedv.dtvalidade)))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.pedcli}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.pedcli))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.codtabpre}}),_vm._v(" "),(_vm.pedv.tabpre && _vm.pedv.tabpre.length)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.tabpre[0].descricao))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.tpfrete}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.textOption(_vm.pedv.tpfrete, _vm.metadata.pedv.tpfrete)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.codparttr}}),_vm._v(" "),(_vm.pedv.parttr && _vm.pedv.parttr.length)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.parttr[0].nome))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.pliq}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.pedv.pliq,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.pbru}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.pedv.pbru,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.qtvolumes}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.qtvolumes))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.seqcontato}}),_vm._v(" "),(_vm.pedv.contato && _vm.pedv.contato.length)?_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.contato[0].nomecontato))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.pedv.endeent}}),_vm._v(" "),_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.pedv.endeent)+" "+_vm._s(_vm.pedv.endenrent)+" "+_vm._s(_vm.pedv.bairroent)+" "+_vm._s(_vm.pedv.ufent))])],1)]),_vm._v(" "),(_vm.pedv.historico_status)?_c('label-title',{attrs:{"title":"Histório Status","icon":"fa-list"}}):_vm._e(),_vm._v(" "),(_vm.pedv.historico_status)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ul',{staticClass:"timeline"},[_c('li',[_c('span',{staticClass:"card-text"},[_vm._v("Pedido Realizado")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"card-text"},[_vm._v(_vm._s(_vm._f("formatDataHoraExtenso")(_vm.pedv.data)))])]),_vm._v(" "),_vm._l((_vm.pedv.historico_status),function(hist,index){return _c('li',{key:index},[_c('span',{staticClass:"card-text"},[_vm._v(_vm._s(hist.descricao))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"card-text"},[_vm._v(_vm._s(_vm._f("formatDataHoraExtenso")(hist.data)))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(hist.obs))])])})],2)])]):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.btTotalizar || _vm.pedv.stpedv === 'P'),expression:"btTotalizar || pedv.stpedv === 'P'"}],staticClass:"w-100 text-center",staticStyle:{"position":"fixed","left":"0","bottom":"0","z-index":"10","border-top":"1px solid #eee","background-color":"#fdfbfb","padding":"15px","-webkit-box-shadow":"0 -2px 5px rgba(0,0,0,0.2)","-moz-box-shadow":"0 -2px 5px rgba(0,0,0,0.2)","box-shadow":"0 -2px 5px rgba(0,0,0,0.2)"}},[_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.btTotalizar),expression:"btTotalizar"}],attrs:{"tabindex":"1","label":"Finalizar Digitação de Produtos","nb-btdef":true,"title":"Efetua a totalização do pedido e encerra a digitação","icon":""},on:{"click":function($event){return _vm.handleTotalizar()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pedv.stpedv === 'P'),expression:"pedv.stpedv === 'P'"}]},[(_vm.botaoGerarPedido)?_c('v-button',{attrs:{"label":"Gerar Pedido","icon":"","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleGerarPedido()}}}):_vm._e(),_vm._v(" "),(!_vm.isView)?_c('v-button',{attrs:{"label":"Salvar e Fechar","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleTotalizar(true)}}}):_vm._e(),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.btImprimir),expression:"btImprimir"}],attrs:{"label":"Imprimir","icon":"fa-print","nb-btdef":false},on:{"click":function($event){return _vm.handleAction(1)}}}),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.btEnviar),expression:"btEnviar"}],attrs:{"label":"Enviar","icon":"fa-envelope-open","nb-btdef":false},on:{"click":function($event){return _vm.handleEmail()}}}),_vm._v(" "),(_vm.botaoPerdido)?_c('v-button',{attrs:{"label":"Orçamento Perdido","icon":"","title":"","danger":true},on:{"click":function($event){return _vm.handleOrcamentoPedido()}}}):_vm._e(),_vm._v(" "),_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.btFaturar),expression:"btFaturar"}],attrs:{"label":"Faturar Pedido","icon":"fa-dollar","title":"","success":true},on:{"click":function($event){return _vm.handleFaturar()}}})],1)],1),_vm._v(" "),(_vm.CANCEL_ITEM_MESSAGE)?_c('md-message',{attrs:{"code":"cancelit"},on:{"close":function($event){return _vm.handleCloseMessage()},"confirm":function($event){return _vm.handleItemCancel()}}}):_vm._e(),_vm._v(" "),(_vm.DELETE_ITEM_MESSAGE)?_c('md-message',{attrs:{"code":"deleteit"},on:{"close":function($event){return _vm.handleCloseMessage()},"confirm":function($event){return _vm.handleItemDelete()}}}):_vm._e(),_vm._v(" "),(_vm.CANCEL_MESSAGE)?_c('md-message',{attrs:{"code":"cancelpedv"},on:{"close":function($event){return _vm.handleCloseMessage()},"confirm":function($event){return _vm.handleCancel()}}}):_vm._e(),_vm._v(" "),(_vm.CIELO_SL_MESSAGE)?_c('md-message',{attrs:{"title":"Link de pagamento Cielo","message":_vm.cielo_sl_link},on:{"close":function($event){return _vm.handleCloseMessage()},"confirm":function($event){return _vm.handleCloseMessage()}}}):_vm._e(),_vm._v(" "),(_vm.showFormItem)?_c('pedido-additem',{attrs:{"params":{ pedv: _vm.pedv, pedvit: _vm.pedvit_update },"view":_vm.formItemView},on:{"closeform":_vm.closeFormItem,"save":_vm.handleSalvarItens}}):_vm._e(),_vm._v(" "),(_vm.showFormInfAd)?_c('pedido-form-infcpl',{attrs:{"is-view":_vm.isView,"metadata":_vm.metadata,"pedv":_vm.pedv,"partCodTabpre":_vm.partCodTabpre},on:{"closeform":_vm.closeFormItem,"save":_vm.handleSaveCab}}):_vm._e(),_vm._v(" "),(_vm.showContatosWhats)?_c('fones-part-share',{attrs:{"codpart":_vm.pedv.codpart},on:{"closeform":_vm.handleWhatsapp}}):_vm._e(),_vm._v(" "),(_vm.showContatoForm)?_c('div',[_c('customer-contato-form',{attrs:{"crud":"ins","codpart":_vm.pedv.codpart},on:{"closeform":_vm.closeContatoForm}})],1):_vm._e(),_vm._v(" "),(_vm.showPartForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('customer-form',{attrs:{"crud":"ins","transportadora":true},on:{"closeform":_vm.closePartForm}})],1)])]):_vm._e(),_vm._v(" "),(_vm.showNatesForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('nates-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closeNatesForm}})],1)])]):_vm._e(),_vm._v(" "),(_vm.showFormEmail)?_c('email-form',{attrs:{"index":_vm.pedv.codpedv,"tipo":"PEDV","title":"Envio de Pedido"},on:{"closeform":_vm.closeFormEmail,"send":_vm.handleSendEmail}}):_vm._e(),_vm._v(" "),(_vm.showFormEmailCieloSL)?_c('email-form',{attrs:{"index":_vm.pedv.codpedv,"tipo":"CIELOSUPERLINK","title":"Envio de Link para pagamento"},on:{"closeform":_vm.closeFormEmail,"send":_vm.handleSendEmail}}):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[(_vm.showImpressao)?_c('PedidoImpressao',{ref:"impressao",attrs:{"index":_vm.codpedvImpressao},on:{"close":_vm.handleClosePrint}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('span',{staticClass:"badge badge-success mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Pagamento\n            Efetuado ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable",attrs:{"id":"nb-modal-scrollable"}},[_c('div',{staticClass:"container nb-modal-scrollable-container",attrs:{"id":"mymodal"}},[(!_vm.showFormPedido && !_vm.showFormNF)?_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',[(_vm.localCrud != null)?[_c('bar-manut',{attrs:{"single-entity":_vm.title,"crud":_vm.localCrud,"moreActions":_vm.moreActions},on:{"action":_vm.handleAction,"closeform":_vm.closeForm,"save":_vm.handleSave}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[(_vm.showCancela || _vm.showCancelaRec)?_c('div',{staticClass:"border p-2 mb-3"},[(_vm.showCancela || _vm.showCancelaRec)?_c('label-title',{attrs:{"title":"Confirmar Cancelamento"}}):_vm._e(),_vm._v(" "),(_vm.showCancela)?_c('div',{staticClass:"row align-items-center px-2 pb-1"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showCancelaRec)?_c('div',{staticClass:"row align-items-center px-2 pb-1"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.showCancelaRec)?_c('div',{staticClass:"row align-items-center px-2 pb-5"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoCancelamento),expression:"tipoCancelamento"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio1","value":"1"},domProps:{"checked":_vm._q(_vm.tipoCancelamento,"1")},on:{"change":function($event){_vm.tipoCancelamento="1"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio1"}},[_vm._v("Cancelar somente este lançamento")])])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoCancelamento),expression:"tipoCancelamento"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio2","value":"2"},domProps:{"checked":_vm._q(_vm.tipoCancelamento,"2")},on:{"change":function($event){_vm.tipoCancelamento="2"}}}),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoCancelamento),expression:"tipoCancelamento"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio3","value":"3"},domProps:{"checked":_vm._q(_vm.tipoCancelamento,"3")},on:{"change":function($event){_vm.tipoCancelamento="3"}}}),_vm._v(" "),_vm._m(3)])])])]):_vm._e(),_vm._v(" "),(_vm.tipoCancelamento=='3')?_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-12"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Cancelar lançamentos baixados"},model:{value:(_vm.cancelaBaixados),callback:function ($$v) {_vm.cancelaBaixados=$$v},expression:"cancelaBaixados"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Confirmar Cancelamento","title":"","danger":true},on:{"click":_vm.handleCancelar}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Desistir"},on:{"click":_vm.handleCancelarExclusao}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.fin.codpedv || _vm.fin.codnf || _vm.fin.tipofin == 'R')?_c('div',{staticClass:"row mb-3"},[(_vm.fin.codpedv)?_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Pedido")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.openFormPedido}},[_vm._v("\n                                      Nr.:"+_vm._s(_vm.fin.pedv[0].npedido)+"\n                                   ")])]):_vm._e(),_vm._v(" "),(_vm.fin.codnf)?_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Nota Fiscal")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.openFormNF}},[_vm._v("\n                                      Doc.:"+_vm._s(_vm.fin.nf[0].nf)+"\n                                   ")])]):_vm._e(),_vm._v(" "),(_vm.fin.tipofin == 'R')?_c('div',{staticClass:"col-md-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Nr. Remessa")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm",attrs:{"data-toggle":"tooltip","data-placement":"top"}},[_vm._v(_vm._s(_vm.fin.numbordero))])]):_vm._e(),_vm._v(" "),(_vm.fin.tipofin == 'R')?_c('div',{staticClass:"col-md-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data Remessa")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm",attrs:{"data-toggle":"tooltip","data-placement":"top"}},[_vm._v(_vm._s(_vm.dataStr(_vm.fin.dtremessa)))])]):_vm._e(),_vm._v(" "),(_vm.fin.tipofin == 'R')?_c('div',{staticClass:"col-md-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Status Remessa")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm",attrs:{"data-toggle":"tooltip","data-placement":"top"}},[_vm._v(_vm._s(_vm.textSTREMESSA(_vm.fin.stremessacnab)))])]):_vm._e(),_vm._v(" "),(_vm.fin.tipofin == 'R' && _vm.fin.stremessacnab == 1)?_c('div',{staticClass:"col-md-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Codfin(ID)")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm",attrs:{"data-toggle":"tooltip","data-placement":"top"}},[_vm._v(_vm._s(_vm.fin.codfin))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.doc.validator),expression:"metadata.fin.doc.validator"}],ref:"doc",attrs:{"type":"text","col":"3","metadata":_vm.metadata.fin.doc,"disabled":_vm.isView || _vm._tituloNF || _vm._bloqueiaAlteracao,"name":"doc","v-errors":_vm.errors},model:{value:(_vm.fin.doc),callback:function ($$v) {_vm.$set(_vm.fin, "doc", $$v)},expression:"fin.doc"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.parcela.validator),expression:"metadata.fin.parcela.validator"}],attrs:{"type":"number","col":"3","metadata":_vm.metadata.fin.parcela,"disabled":_vm.isView || _vm._bloqueiaAlteracao,"name":"parcela","v-errors":_vm.errors},model:{value:(_vm.fin.parcela),callback:function ($$v) {_vm.$set(_vm.fin, "parcela", $$v)},expression:"fin.parcela"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.data.validator),expression:"metadata.fin.data.validator"}],attrs:{"type":"date","col":"3","metadata":_vm.metadata.fin.data,"disabled":_vm.isView || _vm._tituloNF || _vm._bloqueiaAlteracao,"name":"data","v-errors":_vm.errors},model:{value:(_vm.fin.data),callback:function ($$v) {_vm.$set(_vm.fin, "data", $$v)},expression:"fin.data"}})],1),_vm._v(" "),(_vm.errmessages)?_c('validation',{attrs:{"title":"Erros de Validação","messages":_vm.errmessages}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.codpart.validator),expression:"metadata.fin.codpart.validator"}],attrs:{"type":"select2","col":"6","label":_vm.clienteFornecedor,"metadata":_vm.metadata.fin.codpart,"disabled":_vm.isView || _vm._bloqueiaAlteracao,"parent":"mymodal","name":"codpart","v-errors":_vm.errors,"add-button":true},on:{"clickAdd":function($event){return _vm.handleIncluir('part')}},model:{value:(_vm.fin.codpart),callback:function ($$v) {_vm.$set(_vm.fin, "codpart", $$v)},expression:"fin.codpart"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.descricao.validator),expression:"metadata.fin.descricao.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.fin.descricao,"disabled":_vm._bloqueiaAlteracao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.fin.descricao),callback:function ($$v) {_vm.$set(_vm.fin, "descricao", $$v)},expression:"fin.descricao"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.dtv.validator),expression:"metadata.fin.dtv.validator"}],attrs:{"type":"date","col":"3","metadata":_vm.metadata.fin.dtv,"disabled":_vm.isView || _vm._bloqueiaAlteracao,"name":"dtv","v-errors":_vm.errors},model:{value:(_vm.fin.dtv),callback:function ($$v) {_vm.$set(_vm.fin, "dtv", $$v)},expression:"fin.dtv"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.vlr.validator),expression:"metadata.fin.vlr.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.fin.vlr,"disabled":_vm.isView || _vm._tituloNF || _vm._bloqueiaAlteracao,"name":"vlr","v-errors":_vm.errors},model:{value:(_vm.fin.vlr),callback:function ($$v) {_vm.$set(_vm.fin, "vlr", $$v)},expression:"fin.vlr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.pmulta.validator),expression:"metadata.fin.pmulta.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.fin.pmulta,"disabled":_vm.isView || _vm._bloqueiaAlteracao,"name":"pmulta","v-errors":_vm.errors},model:{value:(_vm.fin.pmulta),callback:function ($$v) {_vm.$set(_vm.fin, "pmulta", $$v)},expression:"fin.pmulta"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.pmora.validator),expression:"metadata.fin.pmora.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.fin.pmora,"disabled":_vm.isView || _vm._bloqueiaAlteracao,"name":"pmora","v-errors":_vm.errors},model:{value:(_vm.fin.pmora),callback:function ($$v) {_vm.$set(_vm.fin, "pmora", $$v)},expression:"fin.pmora"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"3","metadata":_vm.metadata.fin.formapag,"disabled":_vm.isView || _vm._bloqueiaAlteracao},model:{value:(_vm.fin.formapag),callback:function ($$v) {_vm.$set(_vm.fin, "formapag", $$v)},expression:"fin.formapag"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.codcta.validator),expression:"metadata.fin.codcta.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.fin.codcta,"disabled":_vm._habilitaConta,"parent":"mymodal","name":"codcta","v-errors":_vm.errors},model:{value:(_vm.fin.codcta),callback:function ($$v) {_vm.$set(_vm.fin, "codcta", $$v)},expression:"fin.codcta"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.codnatfin.validator),expression:"metadata.fin.codnatfin.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadataCodnatfin,"disabled":_vm._bloqueiaAlteracao,"parent":"mymodal","name":"codnatfin","v-errors":_vm.errors},model:{value:(_vm.fin.codnatfin),callback:function ($$v) {_vm.$set(_vm.fin, "codnatfin", $$v)},expression:"fin.codnatfin"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.obs.validator),expression:"metadata.fin.obs.validator"}],attrs:{"type":"memo","col":"6","metadata":_vm.metadata.fin.obs,"disabled":_vm.isView,"parent":"mymodal","name":"obs","v-errors":_vm.errors},model:{value:(_vm.fin.obs),callback:function ($$v) {_vm.$set(_vm.fin, "obs", $$v)},expression:"fin.obs"}}),_vm._v(" "),_c('div',{staticClass:"col-6"},[(_vm.fin.log && _vm.fin.log.length > 0)?_c('form-field',{attrs:{"type":"memo","metadata":_vm.metadata.fin.log,"disabled":true},model:{value:(_vm.fin.log[0]),callback:function ($$v) {_vm.$set(_vm.fin.log, 0, $$v)},expression:"fin.log[0]"}}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"my-3 d-flex justify-content-end"},[_c('a',{attrs:{"href":"#historico"}},[_c('v-button',{attrs:{"label":"Visualzar histórico de alterações do título","success":""},on:{"click":_vm.handleShowallLogs}})],1)]),_vm._v(" "),_c('div',{staticClass:"my-3",style:(_vm.showAllLogs ? 'opacity: 100%; height: auto' : 'opacity: 0; height: 0px'),attrs:{"id":"historico"}},[_c('strong',[_vm._v("Historico de Alterações do Título")]),_vm._v(" "),_c('div',{staticClass:"border",staticStyle:{"background":"#eaeaea"}},[_c('ul',{staticClass:"py-4"},_vm._l((_vm.fin.log),function(log,index){return _c('li',{key:index,staticClass:"my-1"},[_vm._v(_vm._s(log))])}),0)])]),_vm._v(" "),(!_vm.fin.codfin)?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"3","label":"Parcelas/Recorrência","select-options":_vm.recorrenciaOptions},model:{value:(_vm.recorrencia),callback:function ($$v) {_vm.recorrencia=$$v},expression:"recorrencia"}}),_vm._v(" "),(_vm.recorrencia == 'P')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 2 }),expression:"{ required: true, max: 2 }"}],attrs:{"type":"number","col":"3","label":"Parcelas","v-errors":_vm.errors},model:{value:(_vm.qtParcelas),callback:function ($$v) {_vm.qtParcelas=$$v},expression:"qtParcelas"}}):_vm._e(),_vm._v(" "),(_vm.recorrencia != 'U' && _vm.recorrencia != 'P')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 2 }),expression:"{ required: true, max: 2 }"}],attrs:{"type":"date","col":"3","label":"Data Limite","v-errors":_vm.errors},model:{value:(_vm.dataLimite),callback:function ($$v) {_vm.dataLimite=$$v},expression:"dataLimite"}}):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-3",staticStyle:{"border-left":"1px solid silver"}},[(_vm.fin.perdido == 'S')?_c('div',{staticClass:"row"},[_vm._m(4)]):_vm._e(),_vm._v(" "),(_vm.fin.cancelado == 'S')?_c('div',{staticClass:"row"},[_vm._m(5)]):_vm._e(),_vm._v(" "),(_vm.fin.baixado == 'S')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[(_vm.fin.tipofin == 'R')?_c('span',{staticClass:"badge badge-green"},[_vm._v("Recebido "),(_vm.fin.parcial == 'S')?_c('span',[_vm._v(" parcial")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.fin.tipofin == 'P')?_c('span',{staticClass:"badge badge-green"},[_vm._v("Pago "),(_vm.fin.parcial == 'S')?_c('span',[_vm._v(" parcial")]):_vm._e()]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.fin.cancelado == 'S')?_c('div',{staticClass:"row p-3"},[_c('input-switch',{attrs:{"type":"danger","label":"Reabrir Título Cancelado","value-checked":"S","value-unchecked":"N"},model:{value:(_vm.reabrirCancelado),callback:function ($$v) {_vm.reabrirCancelado=$$v},expression:"reabrirCancelado"}})],1):_vm._e(),_vm._v(" "),(_vm.fin.baixado == 'S')?_c('div',{staticClass:"row p-3"},[_c('input-switch',{attrs:{"type":"danger","label":"Reabrir Título Baixado","value-checked":"S","value-unchecked":"N"},model:{value:(_vm.reabrirBaixado),callback:function ($$v) {_vm.reabrirBaixado=$$v},expression:"reabrirBaixado"}})],1):_vm._e(),_vm._v(" "),(_vm.fin.tipofin == 'R' && _vm.fin.aberto == 'S')?_c('div',{staticClass:"row p-3"},[_c('input-switch',{attrs:{"type":"success","label":"Título Recebido","value-checked":"S","value-unchecked":"N","disabled":_vm.isView},model:{value:(_vm.baixado),callback:function ($$v) {_vm.baixado=$$v},expression:"baixado"}})],1):_vm._e(),_vm._v(" "),(_vm.fin.tipofin == 'P' && _vm.fin.aberto == 'S')?_c('div',{staticClass:"row p-3"},[_c('input-switch',{attrs:{"type":"success","label":"Título Pago","value-checked":"S","value-unchecked":"N","disabled":_vm.isView},model:{value:(_vm.baixado),callback:function ($$v) {_vm.baixado=$$v},expression:"baixado"}})],1):_vm._e(),_vm._v(" "),(_vm.reabrirBaixado == 'S' || _vm.reabrirCancelado == 'S')?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col"},[_c('v-button',{attrs:{"label":"Confirmar","title":"","danger":true},on:{"click":_vm.handleConfirmaAlteracao}})],1)]):_vm._e(),_vm._v(" "),(_vm.baixado==='S')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.dtb.validator),expression:"metadata.fin.dtb.validator"}],attrs:{"type":"date","col":"12","metadata":_vm.metadata.fin.dtb,"name":"dtb","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.fin.dtb),callback:function ($$v) {_vm.$set(_vm.fin, "dtb", $$v)},expression:"fin.dtb"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.vjuros.validator),expression:"metadata.fin.vjuros.validator"}],attrs:{"type":"value","col":"12","metadata":_vm.metadata.fin.vjuros,"name":"vjuros","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.fin.vjuros),callback:function ($$v) {_vm.$set(_vm.fin, "vjuros", $$v)},expression:"fin.vjuros"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.vdescontos.validator),expression:"metadata.fin.vdescontos.validator"}],attrs:{"type":"value","col":"12","metadata":_vm.metadata.fin.vdescontos,"name":"vdescontos","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.fin.vdescontos),callback:function ($$v) {_vm.$set(_vm.fin, "vdescontos", $$v)},expression:"fin.vdescontos"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.vpago.validator),expression:"metadata.fin.vpago.validator"}],attrs:{"type":"value","col":"12","metadata":_vm.metadata.fin.vpago,"name":"vpago","v-errors":_vm.errors,"disabled":_vm.isView},model:{value:(_vm.fin.vpago),callback:function ($$v) {_vm.$set(_vm.fin, "vpago", $$v)},expression:"fin.vpago"}}),_vm._v(" "),(_vm.baixaParcial)?_c('alert',{attrs:{"type":"info","text":"Um novo título será criado com o saldo"}}):_vm._e()],1):_vm._e()])])],2)]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showFormPedido)?_c('fv-pedido-form',{ref:"pedido",attrs:{"name":"pedido","index":_vm.fin.codpedv,"crud":'view'},on:{"closeform":_vm.closeFormPedido}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showFormNF)?_c('nfsaida-form',{ref:"notafiscal",attrs:{"name":"notafiscal","params":_vm.params,"crud":'view'},on:{"closeform":_vm.closeFormNF,"edit":_vm.closeFormNF}}):_vm._e()],1)],1),_vm._v(" "),(_vm.showPerguntaRecorrente)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(true)?_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoAlteracao),expression:"tipoAlteracao"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio1","value":"1"},domProps:{"checked":_vm._q(_vm.tipoAlteracao,"1")},on:{"change":function($event){_vm.tipoAlteracao="1"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio1"}},[_vm._v("Alterar somente o lançamento atual")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoAlteracao),expression:"tipoAlteracao"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio2","value":"2"},domProps:{"checked":_vm._q(_vm.tipoAlteracao,"2")},on:{"change":function($event){_vm.tipoAlteracao="2"}}}),_vm._v(" "),_vm._m(8)])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoAlteracao),expression:"tipoAlteracao"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio3","value":"3"},domProps:{"checked":_vm._q(_vm.tipoAlteracao,"3")},on:{"change":function($event){_vm.tipoAlteracao="3"}}}),_vm._v(" "),_vm._m(9)])])])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-footer",staticStyle:{"height":"10%"}},[_c('v-button',{attrs:{"label":"Confirmar","title":"","danger":true},on:{"click":_vm.handleConfirmaAlteracao}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar","title":""},on:{"click":_vm.handleCancelarAlteracao}})],1)])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showPartForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('customer-form',{attrs:{"crud":"ins"},on:{"closeform":_vm.closePartForm}})],1)])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('p',[_vm._v("Deseja realmente cancelar este lançamento ?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('p',[_vm._v("O lançamento que está sendo cancelado possui vínculo com outras parcelas.")]),_vm._v(" "),_c('p',[_vm._v("Selecione abaixo quais lançamentos deseja cancelar agora.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio2"}},[_vm._v("Cancelar este e os demais lançamentos em "),_c('b',[_vm._v(" aberto ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio3"}},[_vm._v("Cancelar "),_c('b',[_vm._v("todos")]),_vm._v(" os lançamentos")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col text-center"},[_c('span',{staticClass:"badge badge-red"},[_vm._v("Perdido")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col text-center"},[_c('span',{staticClass:"badge badge-red"},[_vm._v("Cancelado")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v("Alteração de Conta Recorrente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('p',[_vm._v("O lançamento que está sendo alterado possui vínculo com outras parcelas.")]),_vm._v(" "),_c('p',[_vm._v("Selecione abaixo quais lançamentos deseja alterar agora.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio2"}},[_vm._v("Alterar o lançamento atual e os demais lançamentos em "),_c('b',[_vm._v(" aberto ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio3"}},[_vm._v("Alterar "),_c('b',[_vm._v("todos")]),_vm._v(" os lançamentos")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._m(0),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('div',{staticClass:"row col"},[_c('v-button',{attrs:{"label":"Importar Arquivo de Retorno","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleImportarRetorno()}}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('tabs',{attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}),_vm._v(" "),(_vm.activeTab == '0')?_c('div',[(_vm.contasconfiguradas == 0)?_c('div',{staticClass:"row nb-margin-topbottom"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('label-title',{attrs:{"title":"Nenhuma conta foi configurada para emissão de boletos"}}),_c('br')],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-center nb-margin-topbottom"},[_c('v-button',{attrs:{"label":"Configurar Agora as Contas Bancárias","nb-btdef":true},on:{"click":function($event){return _vm.handleConfigurarConta()}}})],1)]):_vm._e(),_vm._v(" "),(_vm.contasconfiguradas > 0 && !_vm.cnabPendente.length)?_c('alert',{attrs:{"type":"warning","text":"Não há títulos disponíveis para gerar arquivo de remessa"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.cnabPendente),function(cta){return _c('div',{key:cta.codcta,staticClass:"mainbox"},[_c('div',{staticClass:"mark-gray"}),_vm._v(" "),_c('div',{staticClass:"box p-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-9"},[_c('img',{staticStyle:{"padding":"10px","height":"55px"},attrs:{"src":cta.banco_url}}),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(cta.descricao))]),_c('br')]),_vm._v(" "),(cta.qt > 0)?_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Quantidade de Documentos")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(cta.qt))])]):_vm._e(),_vm._v(" "),(cta.qt > 0)?_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Valor Total")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(cta.vlr,2)))])]):_vm._e(),_vm._v(" "),(cta.qt > 0)?_c('div',{staticClass:"col-md-4 col-3 ml-auto d-flex"},[_c('v-button',{attrs:{"label":"Ver Titulos Desta Remessa","title":"","nb-btdef":false},on:{"click":function($event){return _vm.handleShowTitulos(cta)}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Gerar Remessa Deste Banco","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleGerarRemessa(cta)}}})],1):_vm._e(),_vm._v(" "),(cta.errmessages && cta.errmessages.length > 0)?_c('div',{staticClass:"col-md-12 col-12"},[_c('alert',{attrs:{"type":"error","title":"Ocorreu erro na geração do arquivo","messages":cta.errmessages}})],1):_vm._e(),_vm._v(" "),(cta.errtitulos && cta.errtitulos.length > 0)?_c('div',{staticClass:"col-md-12 col-12"},[_c('alert',{attrs:{"type":"error","title":"Alguns erros precisam ser corrigidos:","messages":cta.errtitulos},on:{"edit":_vm.editPart}})],1):_vm._e()]),_vm._v(" "),(cta.qt == 0)?_c('div',{staticClass:"row"},[_vm._m(2,true)]):_vm._e()])])})],2):_vm._e(),_vm._v(" "),(_vm.activeTab == '1')?_c('div',[(!_vm.cnabRemList.length)?_c('alert',{attrs:{"type":"warning","text":"Não há arquivos disponíveis para envio"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.cnabRemList),function(item,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"mark-gray"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row p-2"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('img',{staticStyle:{"padding":"10px","height":"55px"},attrs:{"src":item.banco_url}}),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(item.descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Gerado Em")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatDataHora")(item.data)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Nr da Remessa")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.numbordero))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Quantidade Documentos")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.qt))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Valor Total")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(item.vlr,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Download do Arquivo","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleDownloadRemessa(item.codcnab)}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Excluir Remessa","title":"","nb-btdef":false},on:{"click":function($event){return _vm.handleConfirmaExcluirRemessa(item.codcnab)}}})],1)])])])})],2):_vm._e(),_vm._v(" "),(_vm.activeTab == '2')?_c('div',[(!_vm.cnabRetList.length)?_c('alert',{attrs:{"type":"warning","text":"Nenhum arquivo de retorno foi encontrado"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.cnabRetList),function(item,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{class:[{ 'mark-red': item.qtrej > 0 || item.qterros > 0 }, { 'mark-green': item.qtrej == 0 || item.qterros == 0 }]}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row p-2"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('img',{staticStyle:{"padding":"10px","height":"55px"},attrs:{"src":item.banco_url}}),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(item.descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Importado Em")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatDataHora")(item.data)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Confirmados")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.qt))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Liquidações")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.qtliq))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Baixas")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.qtbai))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Erros")]),_c('br'),_vm._v(" "),(item.qterros > 0)?_c('i',{staticClass:"fa fa-search text-secondary",staticStyle:{"cursor":"pointer"},attrs:{"title":"Ver detalhes"},on:{"click":function($event){return _vm.viewErrors(item)}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.qterros))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Rejeições")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.qtrej))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Arquivo")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.filename))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('v-button',{attrs:{"title":"Ver detalhes do arquivo","icon":"fa-search"},on:{"click":function($event){return _vm.handleDetalhesRetorno(item)}}})],1)])])])})],2):_vm._e(),_vm._v(" "),(_vm.activeTab == '3')?_c('div',[(!_vm.cnabRejList.length)?_c('alert',{attrs:{"type":"warning","text":"Não existem títulos rejeitados"}}):_vm._e(),_vm._v(" "),(_vm.cnabRejList.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12 nb-margin-bottom"},[_c('v-button',{attrs:{"title":"Exportar Para Planilha","icon":"fa-download"},on:{"click":function($event){return _vm.handleExportRejeitados()}}})],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.cnabRejList),function(item,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"mark-red"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row p-2"},[_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data da Remessa")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(item.dtremessa)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Nome do Cliente")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.part_nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Tipo de Erro")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.textSTREMESSA(item.stremessacnab)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Motivo")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.motivo))]),_vm._v(" "),(item.ret_filename)?_c('div',[_c('span',{staticClass:"lbl-list-sm"},[_vm._v("Arq. Retorno: ")]),_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(item.ret_filename)+" ("+_vm._s(_vm._f("formatData")(item.ret_dtimportacao))+")")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Documento")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.doc)),(item.parcela)?_c('span',[_vm._v("/"+_vm._s(item.parcela))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Ações")]),_c('br'),_vm._v(" "),_c('v-button',{attrs:{"title":"Consultar/Editar Título","icon":"fa-search"},on:{"click":function($event){return _vm.handleEditFin(item.codfin)}}})],1)])])])})],2):_vm._e(),_vm._v(" "),(_vm.activeTab == '4')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('div',{staticClass:"d-flex justify-content-start align-items-center bg-white p-2"},[_c('div',{staticClass:"col-md-3 text-center"},[_c('div',{staticClass:"lbl-edit"},[_vm._v("\n                                Total Títulos Não Vinculados\n                            ")]),_vm._v(" "),_c('div',{staticClass:"total"},[_vm._v("\n                                R$ "),_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(_vm.totalCnabSemVinculo,2)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-center"},[_c('div',{staticClass:"lbl-edit"},[_vm._v("\n                                Total Títulos Marcados\n                            ")]),_vm._v(" "),_c('div',{staticClass:"total"},[_vm._v("\n                                R$ "),_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(_vm.totalCnabSemVinculoChecked,2)))])])])]),_vm._v(" "),_c('div',{staticClass:"collapse multi-collapse",attrs:{"data-toggle":"collapse","id":"multiCollapseExample1"}},[_c('div',{staticClass:"card card-body border-0"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.codcta.validator),expression:"metadata.fin.codcta.validator"}],attrs:{"label":"Selecione uma conta","type":"select2","col":"3","metadata":_vm.metadata.fin.codcta},model:{value:(_vm.contaSelecionada),callback:function ($$v) {_vm.contaSelecionada=$$v},expression:"contaSelecionada"}}),_vm._v(" "),_c('button',{staticClass:"btn nb-btdef",on:{"click":_vm.handleVincular}},[_vm._v("Confirmar")])],1)])])])]):_vm._e(),_vm._v(" "),(_vm.activeTab == '4')?_c('div',[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Marcar/Desmarcar todos"},model:{value:(_vm.titulosCheckAll),callback:function ($$v) {_vm.titulosCheckAll=$$v},expression:"titulosCheckAll"}}),_vm._v(" "),_vm._l((_vm.cnabSemVinculo),function(cta){return _c('div',{key:cta.codcta,staticClass:"mainbox"},[_c('Cnab',{attrs:{"cta":cta},on:{"change":_vm.showSelectVincularConta}})],1)})],2):_vm._e()],1)]),_vm._v(" "),(_vm.confirmaExcluirRemessa)?_c('md-message',{attrs:{"message":_vm.messageExcluir,"title":_vm.titleExcluir},on:{"confirm":function($event){return _vm.handleExcluirRemessa()},"close":function($event){return _vm.handleCloseMessage()}}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"row"},[_c('input',{ref:"retFile",attrs:{"type":"file","accept":".txt;*.ret"},on:{"change":function($event){return _vm.handleUploadRetorno()}}})]),_vm._v(" "),(_vm.showDetalhesRetorno)?_c('div',[_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v(" Detalhes do Retorno ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeDetalhesRetorno()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body",attrs:{"id":"mymodal"}},[_c('div',{staticClass:"row nb-margin-bottom"},[_c('div',{staticClass:"col-auto"},[_c('img',{staticStyle:{"padding":"10px","height":"55px"},attrs:{"src":_vm.dadosRetorno.banco_url}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data da Importação")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatDataHora")(_vm.dadosRetorno.data)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Quantidade")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.dadosRetorno.qt))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Liquidações")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.dadosRetorno.qtliq))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Baixas")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.dadosRetorno.qtbai))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Erros")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.dadosRetorno.qterros))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Rejeições")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.dadosRetorno.qtrej))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Nome do Arquivo")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.dadosRetorno.filename))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.errmessages.length != 0)?_c('validation',{attrs:{"messages":_vm.errmessages}}):_vm._e(),_vm._v(" "),(_vm.cnabRetDetList.length == 0 && _vm.cnabErrors.length == 0)?_c('alert',{attrs:{"type":"warning","title":"Nenhum título foi localizado no retorno"}}):_vm._e(),_vm._v(" "),(_vm.cnabRetDetList.length > 0)?_c('label-title',{attrs:{"title":"Lista dos Titulos Retornados"}}):_vm._e(),_vm._v(" "),(_vm.cnabRejList.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12 nb-margin-bottom"},[_c('v-button',{attrs:{"title":"Exportar Para Planilha","icon":"fa-download"},on:{"click":function($event){return _vm.handleExportRetorno()}}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mainbox"},_vm._l((_vm.cnabRetDetList),function(item,index){return _c('div',{key:index,staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(item.dtoco)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Ocorrência")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"badge",class:[{ 'badge-red': (item.tipoococnab == '1') }, { 'badge-green': (item.tipoococnab == '5') }, { 'badge-red': (item.tipoococnab == '7') }, {'badge-blue': (item.tipoococnab == '8')} ]},[_vm._v(_vm._s(item.ocorrencia))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Documento")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.doc)),(item.parcela)?_c('span',[_vm._v("/"+_vm._s(item.parcela))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Valor Tarifa")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(item.vtarifa,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Valor Pago")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(item.vpago,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Nome do Cliente")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.part_nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Ações")]),_c('br'),_vm._v(" "),_c('v-button',{attrs:{"title":"Consultar/Editar Título","icon":"fa-search"},on:{"click":function($event){return _vm.handleEditFin(item.codfin)}}})],1),_vm._v(" "),(item.motivos.length)?_c('div',{staticClass:"col-md-12 col-12"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Motivo")]),_vm._v(" "),_vm._l((item.motivos),function(motivo,index2){return _c('span',{key:index2,staticClass:"error"},[_vm._v(_vm._s(motivo.descricao))])})],2):_vm._e()])])}),0),_vm._v(" "),(_vm.cnabErrors.length > 0)?_c('div',[_c('hr'),_vm._v(" "),_c('label-title',{attrs:{"title":"Títulos com Erros de Identificação (Não localizados no sistema)"}}),_vm._v(" "),_c('div',{staticClass:"mainbox"},_vm._l((_vm.cnabErrors),function(item,index){return _c('div',{key:'err-'+index,staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(item.dtoco)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Ocorrência")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"badge badge-red"},[_vm._v("NÃO ENCONTRADO: "+_vm._s(item.des_oco))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Nosso Número")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.nosso_numero))])]),_vm._v(" "),(item.vlr)?_c('div',{staticClass:"col-md-1 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Vlr. Título")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(item.vlr,2)))])]):_vm._e(),_vm._v(" "),(item.vtarifa)?_c('div',{staticClass:"col-md-1 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Tarifa")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(item.vtarifa,2)))])]):_vm._e(),_vm._v(" "),(item.vpago)?_c('div',{staticClass:"col-md-1 col-2"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Vlr. Pago")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(item.vpago,2)))])]):_vm._e(),_vm._v(" "),(item.motivos && item.motivos.length)?_c('div',{staticClass:"col-md-12 col-12"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Motivos da Rejeição / Ocorrência")]),_vm._v(" "),_vm._l((item.motivos),function(motivo,index2){return _c('span',{key:index2,staticClass:"error"},[_vm._v(_vm._s(motivo))])})],2):_vm._e()])])}),0)],1):_vm._e(),_vm._v(" "),_vm._m(3)],1)])])]):_vm._e(),_vm._v(" "),(_vm.showModalErros)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h5',[_vm._v("Erros Arquivo "+_vm._s(_vm.retornoImportadosItem.filename))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.closeModalErros}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row d-flex flex-column mb-3"},_vm._l((_vm.retornoImportadosItem.errors),function(erro){return _c('div',{key:erro.id,staticClass:"container"},[_vm._v("\n                        "+_vm._s(erro)+"\n                    ")])}),0),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{ref:"btnClose",attrs:{"label":"Fechar","title":""},on:{"click":_vm.closeModalErros}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.showModalTitulosRemessa)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h5',[_vm._v("Titulos Remessa ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.closeModalTitulosRemessa}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row mb-3"},[(_vm.titulos && _vm.titulos.length > 0)?_c('div',{staticClass:"col-md-12 col-12"},_vm._l((_vm.titulos),function(item,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"mark-gray"}),_vm._v(" "),_c('div',{staticClass:"box p-2"},[_c('div',{staticClass:"row"},[(item)?_c('div',{staticClass:"col-auto d-flex flex-column"},[(index==0)?_c('label',{staticClass:"lbl-list"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false},model:{value:(item.isChecked),callback:function ($$v) {_vm.$set(item, "isChecked", $$v)},expression:"item.isChecked"}})],1)]):_vm._e(),_vm._v(" "),(item)?_c('div',{staticClass:"col-lg-2 col-md-2 col-3 d-flex flex-column"},[(index==0)?_c('label',{staticClass:"lbl-list"},[_vm._v("Documento")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.doc))]),_vm._v(" "),(item.parcela)?_c('span',{staticClass:"data-list"},[_vm._v(" / "+_vm._s(item.parcela))]):_vm._e()])]):_vm._e(),_vm._v(" "),(item)?_c('div',{staticClass:"col-lg-2 col-md-2 col-3 d-flex flex-column"},[(index==0)?_c('label',{staticClass:"lbl-list"},[_vm._v("Data Emissão")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(item.data)))])]):_vm._e(),_vm._v(" "),(item)?_c('div',{staticClass:"col-lg-2 col-md-2 col-3 d-flex flex-column"},[(index==0)?_c('label',{staticClass:"lbl-list"},[_vm._v("Data Vencimento")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(item.dtv)))])]):_vm._e(),_vm._v(" "),(item)?_c('div',{staticClass:"col-lg-2 col-md-2 col-3 d-flex flex-column"},[(index==0)?_c('label',{staticClass:"lbl-list"},[_vm._v("Nome")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.nome))])]):_vm._e(),_vm._v(" "),(item)?_c('div',{staticClass:"col-lg-2 col-md-2 col-3 d-flex flex-column"},[(index==0)?_c('label',{staticClass:"lbl-list"},[_vm._v("Valor do Documento")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(item.vlr,2)))])]):_vm._e()])])])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{attrs:{"label":"Remover","title":"Remover","danger":"true"},on:{"click":_vm.handleRemoverTituloRemessa}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Fechar","title":""},on:{"click":_vm.closeModalTitulosRemessa}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.showFormPart)?_c('customer-form',{attrs:{"crud":_vm.crud,"index":_vm.codpart},on:{"closeform":_vm.closeFormPart}}):_vm._e(),_vm._v(" "),(_vm.showFormFin)?_c('financeiro-form',{attrs:{"tipo":'R',"crud":_vm.crud,"index":_vm.codfin},on:{"closeform":_vm.closeFormFin}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-12 float-left"},[_c('h4',{staticClass:"def-title"},[_vm._v("Cobrança Bancaria")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 text-center"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("Configure agora uma conta bancária para emissão de boletos e envio de arquivos de cobranças para o banco")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('span',{staticClass:"data-list"},[_vm._v("Nenhum título pendente para esta conta")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('p')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_list_vue__ = __webpack_require__(620);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d364c0b0_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_list_vue__ = __webpack_require__(1745);
function injectStyle (ssrContext) {
  __webpack_require__(1719)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d364c0b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d364c0b0_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1720);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("717ff30f", content, true, {});

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".menu-sticky[data-v-d364c0b0]{position:-webkit-sticky;position:sticky;top:0;padding:5px;z-index:1}.gap-10[data-v-d364c0b0]{gap:10px}.span-title[data-v-d364c0b0]{font-size:1.1rem}.span-header[data-v-d364c0b0]{font-size:1rem!important;font-weight:700!important}.uppercase[data-v-d364c0b0]{text-transform:uppercase}td[data-v-d364c0b0],th[data-v-d364c0b0]{font-size:.75rem!important;font-weight:500!important}hr[data-v-d364c0b0]{color:transparent;border:none}.half-payment[data-v-d364c0b0]{width:20px;height:10px;background-color:gold;border-top-left-radius:10px;border-top-right-radius:10px;border:1px solid gold;border-bottom:0;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.c-baixado[data-v-d364c0b0]{background-color:#e9f5dc}.c-perdido[data-v-d364c0b0]{background-color:#fdf7f3}.tipo[data-v-d364c0b0]{display:inline-block;padding:5px;font-size:13px;font-weight:600;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:20%}.tipo-recebimento[data-v-d364c0b0]{color:#fff;background-color:#80b852}.tipo-pagamento[data-v-d364c0b0]{color:#fff;background-color:#ee2727}.valor-positivo[data-v-d364c0b0]{color:#80b852}.valor-negativo[data-v-d364c0b0]{color:#ee2727}.total strong[data-v-d364c0b0]{font-size:20px;font-weight:700}.box-filtros[data-v-d364c0b0]{padding-left:.25rem!important}.sorting-header-bar[data-v-d364c0b0]{background-color:#fcfcfc;border-radius:6px;padding:10px 15px;border:1px solid #eaeaea;box-shadow:0 1px 3px rgba(0,0,0,.02)}.clickable-header[data-v-d364c0b0]{cursor:pointer;user-select:none;transition:color .15s ease-in-out;font-size:.78rem}.clickable-header[data-v-d364c0b0]:hover{color:#0091ea!important}.text-muted-light[data-v-d364c0b0]{color:#d1d5db!important;font-size:.7rem;margin-left:3px}", ""]);

// exports


/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_movimento_form_vue__ = __webpack_require__(621);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_73862012_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_movimento_form_vue__ = __webpack_require__(1724);
function injectStyle (ssrContext) {
  __webpack_require__(1722)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_movimento_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_73862012_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_movimento_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1723);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("27a86c97", content, true, {});

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",attrs:{"id":"mymodal"}},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',[_c('bar-manut',{attrs:{"single-entity":"Lançamento Caixa e Bancos","crud":this.crud,"moreActions":_vm.moreActions},on:{"action":_vm.handleAction,"closeform":_vm.closeForm,"save":_vm.handleSave}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[(_vm.errmessages.errmessages)?_c('validation',{attrs:{"title":"Erros de Validação","messages":_vm.errmessages.errmessages}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.codcta.validator),expression:"metadata.fin.codcta.validator"}],ref:"conta",attrs:{"type":"select2","col":"6","metadata":_vm.metadata.fin.codcta,"disabled":_vm.isView,"parent":"mymodal","name":"codcta","v-errors":_vm.errors},model:{value:(_vm.fin.codcta),callback:function ($$v) {_vm.$set(_vm.fin, "codcta", $$v)},expression:"fin.codcta"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"date","col":"3","metadata":_vm.metadata.fin.data,"disabled":_vm.isView,"name":"data","v-errors":_vm.errors},model:{value:(_vm.fin.data),callback:function ($$v) {_vm.$set(_vm.fin, "data", $$v)},expression:"fin.data"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.doc.validator),expression:"metadata.fin.doc.validator"}],attrs:{"type":"text","col":"3","metadata":_vm.metadata.fin.doc,"disabled":_vm.isView,"name":"doc","v-errors":_vm.errors},model:{value:(_vm.fin.doc),callback:function ($$v) {_vm.$set(_vm.fin, "doc", $$v)},expression:"fin.doc"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"select","col":"3","label":"Tipo","select-options":_vm.tipoOptions,"name":"tipo","v-errors":_vm.errors},model:{value:(_vm.tipo),callback:function ($$v) {_vm.tipo=$$v},expression:"tipo"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.vlr.validator),expression:"metadata.fin.vlr.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.fin.vlr,"disabled":_vm.isView,"name":"vlr","v-errors":_vm.errors},model:{value:(_vm.fin.vlr),callback:function ($$v) {_vm.$set(_vm.fin, "vlr", $$v)},expression:"fin.vlr"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.descricao.validator),expression:"metadata.fin.descricao.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.fin.descricao,"disabled":_vm.isView,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.fin.descricao),callback:function ($$v) {_vm.$set(_vm.fin, "descricao", $$v)},expression:"fin.descricao"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.tipo == 'E')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.codnatfin.validator),expression:"metadata.fin.codnatfin.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadataCodnatfin,"disabled":_vm.isView,"parent":"mymodal","name":"codnatfin","v-errors":_vm.errors},model:{value:(_vm.fin.codnatfin),callback:function ($$v) {_vm.$set(_vm.fin, "codnatfin", $$v)},expression:"fin.codnatfin"}}):_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.codnatfin.validator),expression:"metadata.fin.codnatfin.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadataCodnatfin,"disabled":_vm.isView,"parent":"mymodal","name":"codnatfin","v-errors":_vm.errors},model:{value:(_vm.fin.codnatfin),callback:function ($$v) {_vm.$set(_vm.fin, "codnatfin", $$v)},expression:"fin.codnatfin"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: false }),expression:"{ required: false }"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.fin.codpart,"disabled":_vm.isView,"parent":"mymodal","name":"codpart","v-errors":_vm.errors},model:{value:(_vm.fin.codpart),callback:function ($$v) {_vm.$set(_vm.fin, "codpart", $$v)},expression:"fin.codpart"}})],1),_vm._v(" "),(_vm.cancelarMovimento == 'S')?_c('label-title',{attrs:{"title":"Confirmar Cancelamento"}}):_vm._e(),_vm._v(" "),(_vm.cancelarMovimento == 'S')?_c('div',{staticClass:"row mb-3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Confirmar Cancelamento","title":"","danger":true},on:{"click":_vm.handleCancelar}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Desistir"},on:{"click":_vm.handleDesistir}})],1)]):_vm._e()],1)])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('span',{staticClass:"data-list"},[_vm._v("Esta operação não poderá ser desfeita.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_transf_form_vue__ = __webpack_require__(622);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_a27aa01a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_transf_form_vue__ = __webpack_require__(1728);
function injectStyle (ssrContext) {
  __webpack_require__(1726)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_transf_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_a27aa01a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_transf_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1727);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("da8c6e14", content, true, {});

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",attrs:{"id":"mymodal"}},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',[_c('bar-manut',{attrs:{"single-entity":this.modalTitle,"crud":this.crud,"title":this.modalTitle},on:{"closeform":_vm.closeForm,"save":_vm.handleSave}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[(_vm.errmessages.errmessages)?_c('validation',{attrs:{"title":"Erros de Validação","messages":_vm.errmessages.errmessages}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.codcta.validator),expression:"metadata.fin.codcta.validator"}],ref:"origem",attrs:{"type":"select2","col":"6","label":"Conta Origem","metadata":_vm.metadata.fin.codcta,"parent":"mymodal","name":"codctaorigem","v-errors":_vm.errors},model:{value:(_vm.movimento.origem.codcta),callback:function ($$v) {_vm.$set(_vm.movimento.origem, "codcta", $$v)},expression:"movimento.origem.codcta"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.codcta.validator),expression:"metadata.fin.codcta.validator"}],attrs:{"type":"select2","col":"6","label":"Conta Destino","metadata":_vm.metadata.fin.codcta,"parent":"mymodal","name":"codctadestino","v-errors":_vm.errors},model:{value:(_vm.movimento.destino.codcta),callback:function ($$v) {_vm.$set(_vm.movimento.destino, "codcta", $$v)},expression:"movimento.destino.codcta"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.data.validator),expression:"metadata.fin.data.validator"}],attrs:{"type":"date","col":"3","metadata":_vm.metadata.fin.data,"name":"data","v-errors":_vm.errors},model:{value:(_vm.movimento.data),callback:function ($$v) {_vm.$set(_vm.movimento, "data", $$v)},expression:"movimento.data"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.vlr.validator),expression:"metadata.fin.vlr.validator"}],attrs:{"type":"value","col":"3","metadata":_vm.metadata.fin.vlr,"name":"vlr","v-errors":_vm.errors},model:{value:(_vm.movimento.valor),callback:function ($$v) {_vm.$set(_vm.movimento, "valor", $$v)},expression:"movimento.valor"}})],1),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.codnatfin.validator),expression:"metadata.fin.codnatfin.validator"}],attrs:{"type":"select2","col":"6","label":"Natureza Origem","metadata":_vm.metadata.fin.codnatfin,"parent":"mymodal","name":"codnatfinorigem","select2":{entity: 'natfin/despesas', minlength: 0},"v-errors":_vm.errors},model:{value:(_vm.movimento.origem.codnatfin),callback:function ($$v) {_vm.$set(_vm.movimento.origem, "codnatfin", $$v)},expression:"movimento.origem.codnatfin"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.codnatfin.validator),expression:"metadata.fin.codnatfin.validator"}],attrs:{"type":"select2","col":"6","label":"Natureza Destino","metadata":_vm.metadata.fin.codnatfin,"parent":"mymodal","name":"codnatfindestino","select2":{entity: 'natfin/receitas', minlength: 0},"v-errors":_vm.errors},model:{value:(_vm.movimento.destino.codnatfin),callback:function ($$v) {_vm.$set(_vm.movimento.destino, "codnatfin", $$v)},expression:"movimento.destino.codnatfin"}})],1)],1)])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_print_recibo_vue__ = __webpack_require__(623);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_64d6da0a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_print_recibo_vue__ = __webpack_require__(1732);
function injectStyle (ssrContext) {
  __webpack_require__(1730)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_print_recibo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_64d6da0a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_print_recibo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1731);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4ca8eb7e", content, true, {});

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"recibo"}},_vm._l((_vm.finList),function(fin,index){return _c('div',{key:index,staticClass:"border border-dark mb-3"},[_c('div',{staticClass:"w-100 border-bottom border-dark"},[_c('div',{staticClass:"p-3 d-flex justify-content-between"},[_c('h2',{staticClass:"font-weight-bold"},[_vm._v("RECIBO")]),_vm._v(" "),_c('h2',{staticClass:"font-weight-bold"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(fin.vlr,2, true)))])])]),_vm._v(" "),_c('div',{staticClass:"w-100 border-bottom border-dark"},[_c('div',{staticClass:"p-3 d-flex flex-column"},[(_vm.receberTab)?_c('h5',[_vm._v("Recebido de: "+_vm._s(fin.nome))]):_vm._e(),_vm._v(" "),(_vm.pagarTab)?_c('h5',[_vm._v("Recebido de: "+_vm._s(_vm.filial.nome))]):_vm._e(),_vm._v(" "),_c('h5',[_vm._v("Título: "+_vm._s(fin.doc))]),_vm._v(" "),_c('h5',[_vm._v("Data de emissão: "+_vm._s(_vm._f("formatData")(fin.dtemissao)))]),_vm._v(" "),_c('h5',[_vm._v("Data de vencimento: "+_vm._s(_vm._f("formatData")(fin.data)))]),_vm._v(" "),_c('h5',[_vm._v("A imporância de "),_c('span',{staticClass:"uppercase"},[_vm._v(_vm._s(_vm.extensoMoeda(fin.vlr)))])])])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"row p-3 d-flex justify-content-start"},[_c('div',{staticClass:"col-12"},[_c('h5',[_vm._v("CIDADE DA FILIAL, "+_vm._s(_vm.dataSemiExtenso(fin.data)))])])]),_vm._v(" "),_c('div',{staticClass:"row d-flex justify-content-end"},[(_vm.receberTab)?_c('h5',{staticClass:"p-3 text-center"},[_vm._v("\n                    _______________________________________________________________________"),_c('br'),_vm._v("\n                    "+_vm._s(_vm.filial.nome)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.pagarTab)?_c('h5',{staticClass:"p-3 text-center"},[_vm._v("\n                    _______________________________________________________________________"),_c('br'),_vm._v("\n                    "+_vm._s(fin.nome)+"\n                ")]):_vm._e()])])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_relatorio_agrupado_vue__ = __webpack_require__(625);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0578a0fc_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_relatorio_agrupado_vue__ = __webpack_require__(1736);
function injectStyle (ssrContext) {
  __webpack_require__(1734)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_relatorio_agrupado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0578a0fc_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_relatorio_agrupado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1735);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2cac8200", content, true, {});

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"relatorio-financeiro"}},[_c('div',{staticClass:"title d-flex justify-content-center mb-5"},[(_vm.receberTab)?_c('h2',[_vm._v("Relatório de Contas a Pagar Agrupado por Cliente")]):_vm._e(),_vm._v(" "),(_vm.pagarTab)?_c('h2',[_vm._v("Relatório de Contas a Pagar Agrupado por Fornecedor")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column align-items-start"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center w-100"},[_c('div',{staticClass:"d-flex flex-column align-items-start text-start gap-10"},[_c('div',{staticClass:"d-flex flex-column align-items-start gap-10"},[(_vm.finListGrupo[0].codpart && !_vm.finListGrupo[0].codfin)?_c('span',{},[_c('strong',[_vm._v("Cliente: ")]),_vm._v(" "+_vm._s(_vm.finListGrupo[0].nome)+"\n                    "),(_vm.periodo.startDate && _vm.periodo.endDate)?_c('strong',{staticClass:"ml-3"},[_vm._v("Periodo : ")]):_vm._e(),_vm._v(" "+_vm._s(_vm._f("formatData")(_vm.periodo.startDate))+" à "+_vm._s(_vm._f("formatData")(_vm.periodo.endDate))+" ")]):_vm._e(),_vm._v(" "),(_vm.valor.start || _vm.valor.end)?_c('span',[_c('strong',[_vm._v("Valor de:")]),_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.valor.start,2))+" "),_c('strong',{staticClass:"ml-1"},[_vm._v("Valor até:")]),_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.valor.end,2)))]):_vm._e(),_vm._v(" "),(_vm.documento.start || _vm.documento.end)?_c('span',[_c('strong',[_vm._v("Doc. de: ")]),_vm._v(" "+_vm._s(_vm.documento.start)+" "),_c('strong',{staticClass:"ml-2"},[_vm._v("Doc até: ")]),_vm._v(_vm._s(_vm.documento.end))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row align-items-start gap-10"},[(_vm.periodoEmissao.startDate || _vm.periodoEmissao.endDate)?_c('span',{},[_c('strong',[_vm._v("Periodo Emissão: ")]),_vm._v(_vm._s(_vm._f("formatDate")(_vm.periodoEmissao.startDate))+" a "+_vm._s(_vm.periodoEmissao.endDate))]):_vm._e(),_vm._v(" "),(_vm.periodoVencimento.startDate || _vm.periodoVencimento.endDate)?_c('span',{},[_c('strong',[_vm._v("Periodo Vencimento: ")]),_vm._v(_vm._s(_vm._f("formatDate")(_vm.periodoVencimento.startDate))+" a "+_vm._s(_vm.periodoVencimento.endDate))]):_vm._e(),_vm._v(" "),(_vm.periodoRecebimento.startDate || _vm.periodoRecebimento.endDate)?_c('span',{},[_c('strong',[_vm._v("Periodo Recebimento: ")]),_vm._v(_vm._s(_vm._f("formatDate")(_vm.periodoRecebimento.startDate))+" a "+_vm._s(_vm.periodoRecebimento.endDate))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('strong',{staticStyle:{"font-size":"1rem","font-weight":"600"}},[_vm._v(" "+_vm._s(_vm.companyName)+" ")])])]),_vm._v(" "),_c('table',{staticClass:"table table-borderless table-sm"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('hr',{staticClass:"mt-5"}),_vm._v(" "),_vm._l((_vm.finListGrupo),function(fin,index){return [(fin.codpart && !fin.codfin)?_c('tr',{key:index,staticClass:"border-bottom border-dark"},[_c('th',{attrs:{"scope":"row","colspan":"6"}},[_c('span',{staticClass:"span-title font-weight-bold"},[_vm._v(_vm._s(fin.nome))])])]):_vm._e(),_vm._v(" "),(fin.codfin)?_c('tr',{key:index,staticClass:"border-bottom border-dark"},[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(fin.natureza))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(fin.doc))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("formatData")(fin.vencimento)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("formatData")(fin.dataBaixa)))]),_vm._v(" "),(fin.baixado)?_c('td',{staticClass:"text-center"},[_vm._v("Pago")]):_vm._e(),_vm._v(" "),(fin.aberto)?_c('td',{staticClass:"text-center"},[_vm._v("Em Aberto")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("formatValue")(fin.vlr,2, true)))])]):_vm._e(),_vm._v(" "),(fin.total)?_c('tr',{key:index},[_c('th',{staticClass:"span-header text-right font-weight-bold",attrs:{"scope":"row","colspan":"5"}},[_vm._v("Total: ")]),_vm._v(" "),_c('th',{staticClass:"span-header text-right font-weight-bold",attrs:{"scope":"row","colspan":"6"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(fin.total,2)))])]):_vm._e(),_vm._v(" "),(fin.totalGeral)?_c('tr',{key:index},[_c('th',{staticClass:"span-header text-right font-weight-bold",attrs:{"scope":"row","colspan":"5"}},[_vm._v("Total Geral: ")]),_vm._v(" "),_c('th',{staticClass:"span-header text-right font-weight-bold",attrs:{"scope":"row","colspan":"6"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(fin.totalGeral,2)))])]):_vm._e()]})],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"border-bottom border-dark"},[_c('th',{staticClass:"span-header",attrs:{"scope":"col"}},[_vm._v("Histórico")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Nro. documento")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Vencimento")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Liquidação")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Situação")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Pago")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_relatorio_data_vue__ = __webpack_require__(626);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd3ff036_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_relatorio_data_vue__ = __webpack_require__(1740);
function injectStyle (ssrContext) {
  __webpack_require__(1738)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_relatorio_data_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd3ff036_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_relatorio_data_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1739);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("31fe7614", content, true, {});

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"relatorio-financeiro"}},[_c('div',{staticClass:"title d-flex justify-content-center mb-5"},[(_vm.receberTab)?_c('h2',[_vm._v("Relatório de Contas a Receber Agrupado por Data")]):_vm._e(),_vm._v(" "),(_vm.pagarTab)?_c('h2',[_vm._v("Relatório de Contas a Pagar Agrupado por Data")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column align-items-start"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center w-100"},[_c('div',{staticClass:"d-flex flex-column align-items-end text-start gap-10"},[_c('div',{staticClass:"d-flex flex-column align-items-start gap-10"},[(_vm.finListGrupo[0].codpart && !_vm.finListGrupo[0].codfin)?_c('span',{},[_c('strong',[_vm._v("Cliente: ")]),_vm._v(" "+_vm._s(_vm.finListGrupo[0].nome)+"\n                    "),(_vm.periodo.startDate && _vm.periodo.endDate)?_c('strong',{staticClass:"ml-3"},[_vm._v("Periodo : ")]):_vm._e(),_vm._v(" "+_vm._s(_vm._f("formatData")(_vm.periodo.startDate))+" à "+_vm._s(_vm._f("formatData")(_vm.periodo.endDate))+" ")]):_vm._e(),_vm._v(" "),(_vm.valor.start || _vm.valor.end)?_c('span',[_c('strong',[_vm._v("Valor de:")]),_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.valor.start,2))+" "),_c('strong',{staticClass:"ml-1"},[_vm._v("Valor até:")]),_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.valor.end,2)))]):_vm._e(),_vm._v(" "),(_vm.documento.start || _vm.documento.end)?_c('span',[_c('strong',[_vm._v("Doc. de: ")]),_vm._v(" "+_vm._s(_vm.documento.start)+" "),_c('strong',{staticClass:"ml-2"},[_vm._v("Doc até: ")]),_vm._v(_vm._s(_vm.documento.end))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row align-items-start gap-10"},[(_vm.periodoEmissao.startDate || _vm.periodoEmissao.endDate)?_c('span',{},[_c('strong',[_vm._v("Periodo Emissão: ")]),_vm._v(_vm._s(_vm._f("formatDate")(_vm.periodoEmissao.startDate))+" a "+_vm._s(_vm.periodoEmissao.endDate))]):_vm._e(),_vm._v(" "),(_vm.periodoVencimento.startDate || _vm.periodoVencimento.endDate)?_c('span',{},[_c('strong',[_vm._v("Periodo Vencimento: ")]),_vm._v(_vm._s(_vm._f("formatDate")(_vm.periodoVencimento.startDate))+" a "+_vm._s(_vm.periodoVencimento.endDate))]):_vm._e(),_vm._v(" "),(_vm.periodoRecebimento.startDate || _vm.periodoRecebimento.endDate)?_c('span',{},[_c('strong',[_vm._v("Periodo Recebimento: ")]),_vm._v(_vm._s(_vm._f("formatDate")(_vm.periodoRecebimento.startDate))+" a "+_vm._s(_vm.periodoRecebimento.endDate))]):_vm._e()])]),_vm._v(" "),_c('div',[_c('strong',{staticStyle:{"font-size":"1rem","font-weight":"600"}},[_vm._v(" "+_vm._s(_vm.companyName)+" ")])])]),_vm._v(" "),_c('table',{staticClass:"table table-borderless table-sm"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('hr',{staticClass:"mt-5"}),_vm._v(" "),_vm._l((_vm.finListGrupoData),function(fin,index){return [(fin.data && !fin.codpart)?_c('tr',{key:'A' + index,staticClass:"border-bottom border-dark"},[_c('th',{attrs:{"scope":"row","colspan":"7"}},[_c('span',{staticClass:"span-title font-weight-bold"},[_vm._v(_vm._s(_vm._f("formatData")(fin.data)))])])]):_vm._e(),_vm._v(" "),(fin.codfin)?_c('tr',{key:'B' + index,staticClass:"border-bottom border-dark"},[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(fin.nome))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(fin.natureza))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(fin.doc))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("formatData")(fin.vencimento)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("formatData")(fin.dataBaixa)))]),_vm._v(" "),(fin.baixado)?_c('td',{staticClass:"text-center"},[_vm._v("Pago")]):_vm._e(),_vm._v(" "),(fin.aberto)?_c('td',{staticClass:"text-center"},[_vm._v("Em Aberto")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("formatValue")(fin.vlr,2)))])]):_vm._e(),_vm._v(" "),(fin.total)?_c('tr',{key:'C' + index},[_c('th',{staticClass:"span-header text-right font-weight-bold",attrs:{"scope":"row","colspan":"6"}},[_vm._v("Total: ")]),_vm._v(" "),_c('th',{staticClass:"span-header text-right font-weight-bold",attrs:{"scope":"row","colspan":"7"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(fin.total,2)))])]):_vm._e(),_vm._v(" "),(fin.totalGeral)?_c('tr',{key:'D' + index},[_c('th',{staticClass:"span-header text-right font-weight-bold",attrs:{"scope":"row","colspan":"6"}},[_vm._v("Total Geral: ")]),_vm._v(" "),_c('th',{staticClass:"span-header text-right font-weight-bold",attrs:{"scope":"row","colspan":"7"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(fin.totalGeral,2)))])]):_vm._e()]})],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"border-bottom border-dark"},[_c('th',{staticClass:"span-header",attrs:{"scope":"col"}},[_vm._v("Histórico")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Natureza")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Nro. documento")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Vencimento")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Liquidação")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Situação")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Pago")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_relatorio_extrato_vue__ = __webpack_require__(627);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_775c9a34_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_relatorio_extrato_vue__ = __webpack_require__(1744);
function injectStyle (ssrContext) {
  __webpack_require__(1742)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeiro_relatorio_extrato_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_775c9a34_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeiro_relatorio_extrato_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1743);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0a685d93", content, true, {});

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"relatorio-extrato"}},[_vm._m(0),_vm._v(" "),_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"mb-3 d-flex justify-content-between mx-3 w-100 align-items-center"},[_c('span',{},[_c('strong',[_vm._v(" Período: ")]),_vm._v(" "+_vm._s(_vm._f("formatData")(_vm.periodo.startDate))+" à "+_vm._s(_vm._f("formatData")(_vm.periodo.endDate)))]),_vm._v(" "),_c('strong',{staticStyle:{"font-size":"1rem","font-weight":"600"}},[_vm._v(" "+_vm._s(_vm.companyName)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"row col-5 mt-3"},[_c('table',{staticClass:"table table-borderless table-sm tabela-totais"},[_vm._m(1),_vm._v(" "),_c('tbody',[(this.dados && this.dados.totais)?_c('tr',{staticClass:"border border-dark"},[_c('th',{staticClass:"text-center border border-dark",attrs:{"scope":"row"}},[_vm._v("\n                            R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(this.dados.totais.saldoInicial,2,true))+" ")])]),_vm._v(" "),_c('th',{staticClass:"text-center border border-dark",attrs:{"scope":"row"}},[_vm._v("\n                            R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(this.dados.totais.totalRecebimentos,2,true))+" ")])]),_vm._v(" "),_c('th',{staticClass:"text-center border border-dark",attrs:{"scope":"row"}},[_vm._v("\n                            R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(this.dados.totais.totalPagamentos,2,true))+" ")])]),_vm._v(" "),_c('th',{staticClass:"text-center border border-dark",attrs:{"scope":"row"}},[_vm._v("\n                            R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(this.dados.totais.saldoFinal,2,true))+" ")])])]):_vm._e()])])])]),_vm._v(" "),_c('hr',{staticClass:"mt-2"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[(this.dados && this.dados.contas)?_c('table',{staticClass:"table table-borderless table-sm tabela-totais"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.dados.contas),function(conta,index){return [_c('tbody',[_c('tr',{staticClass:"border border-dark"},[_c('th',{staticClass:"text-center border border-dark",attrs:{"scope":"row"}},[_c('span',{staticStyle:{"font-weight":"400"}},[_vm._v(" "+_vm._s(conta.conta)+" ")])]),_vm._v(" "),_c('td',{staticClass:"text-center border border-dark"},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(" R$ "+_vm._s(_vm._f("formatValue")(conta.saldo,2,true))+" ")])])])])]})],2):_vm._e()])]),_vm._v(" "),_c('hr',{staticClass:"mt-2"}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('table',{staticClass:"table table-borderless table-sm tabela-titulos"},[_vm._m(3),_vm._v(" "),_c('tbody',[_vm._l((_vm.finList),function(fin,index){return [(fin.codpart && !fin.codfin)?_c('tr',{key:index,staticClass:"border-bottom border-dark"},[_c('th',{attrs:{"scope":"row","colspan":"6"}},[_c('span',{staticClass:"span-title font-weight-bold"},[_vm._v(_vm._s(fin.nome))])])]):_vm._e(),_vm._v(" "),(fin.codfin)?_c('tr',{key:index,staticClass:"border-bottom border-dark"},[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(fin.doc)+" / "+_vm._s(fin.parcela))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("formatData")(fin.data)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(fin.natureza))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(fin.nome))]),_vm._v(" "),(fin.tipo == 'R' || fin.tipo == 'E')?_c('td',{staticClass:"text-center"},[_vm._v("Recebimento")]):_vm._e(),_vm._v(" "),(fin.tipo == 'P' || fin.tipo == 'S')?_c('td',{staticClass:"text-center"},[_vm._v("Pagamento")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("formatValue")(fin.vlr,2, true)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("formatValue")(fin.saldo,2, true)))])]):_vm._e(),_vm._v(" "),(fin.total)?_c('tr',{key:index},[_c('th',{staticClass:"span-header text-right font-weight-bold",attrs:{"scope":"row","colspan":"5"}},[_vm._v("Total: ")]),_vm._v(" "),_c('th',{staticClass:"span-header text-right font-weight-bold",attrs:{"scope":"row","colspan":"6"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(fin.total,2)))])]):_vm._e(),_vm._v(" "),(fin.totalGeral)?_c('tr',{key:index},[_c('th',{staticClass:"span-header text-right font-weight-bold",attrs:{"scope":"row","colspan":"5"}},[_vm._v("Total Geral: ")]),_vm._v(" "),_c('th',{staticClass:"span-header text-right font-weight-bold",attrs:{"scope":"row","colspan":"6"}},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(fin.totalGeral,2)))])]):_vm._e()]})],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title d-flex justify-content-center mb-5"},[_c('h2',[_vm._v("Relatório Extrato")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"border border-dark"},[_c('th',{staticClass:"span-header text-center border border-dark",attrs:{"scope":"col"}},[_vm._v("Saldo Inicial")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center border border-dark",attrs:{"scope":"col"}},[_vm._v("Entradas")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center border border-dark",attrs:{"scope":"col"}},[_vm._v("Saídas")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center border border-dark",attrs:{"scope":"col"}},[_vm._v("Saldo Final")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 text-center"},[_c('h1',{staticStyle:{"font-size":"1.2rem","font-weight":"600","color":"#000"}},[_vm._v("Saldo Por Conta")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"border-bottom border-dark"},[_c('th',{staticClass:"span-header",attrs:{"scope":"col"}},[_vm._v("Documento")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Data")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Natureza")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Cliente/Fornecedor")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Tipo")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Valor")]),_vm._v(" "),_c('th',{staticClass:"span-header text-center",attrs:{"scope":"col"}},[_vm._v("Saldo")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tabs',{attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}),_vm._v(" "),_c('div',{staticClass:"row d-flex justify-content-between align-items-center mt-2 mb-2"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('div',{staticClass:"d-flex align-items-center",staticStyle:{"margin-bottom":".3rem"}},[_c('v-label',{staticClass:"m-0",attrs:{"label":"Período de:"}}),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v("\n                "+_vm._s(_vm._f("formatData")(_vm.periodo.startDate))+" até "+_vm._s(_vm._f("formatData")(_vm.periodo.endDate))+"\n              ")])],1),_vm._v(" "),_c('input-month',{attrs:{"p-month":_vm.periodo,"show-options":true}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12"},[_c('form-field',{attrs:{"select-options":_vm.listContas,"selectMultiple":true,"label":"Selecione as contas a exibir","placeholder":"Exibindo todas as contas","type":"select2static"},model:{value:(_vm.contas),callback:function ($$v) {_vm.contas=$$v},expression:"contas"}})],1),_vm._v(" "),_c('div',{staticClass:"col-auto ml-auto d-flex"},[_c('v-button',{attrs:{"title":"Atualizar Grid","icon":"fa-refresh"},on:{"click":_vm.loadData}}),_vm._v(" "),(_vm.extratoTab)?_c('v-button',{attrs:{"icon":"fa-plus","nb-btdef":true,"label":"Novo Lançamento"},on:{"click":_vm.handleNew}}):_c('v-button',{attrs:{"icon":"fa-plus","nb-btdef":true,"label":"Nova Conta"},on:{"click":_vm.handleNew}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Mais Ações","actions":_vm.maisAcoes},on:{"click":_vm.handleNew}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12"},[(!_vm.extratoTab)?_c('div',{staticClass:"border bg-light p-2"},[_c('div',{staticClass:"row px-2"},[_c('form-field',{attrs:{"optionnull":true,"select-options":_vm.listFiltros,"col":"4","label":"Tipo","type":"select"},model:{value:(_vm.tipo),callback:function ($$v) {_vm.tipo=$$v},expression:"tipo"}}),_vm._v(" "),_c('form-field',{attrs:{"select2":{entity: 'part', minlength: 2},"col":"4","label":"Cliente","type":"select2"},model:{value:(_vm.codpart),callback:function ($$v) {_vm.codpart=$$v},expression:"codpart"}})],1),_vm._v(" "),_c('div',{staticClass:"row px-2"},[_c('form-field',{attrs:{"col":"3","label":"Nr Documento","type":"text"},model:{value:(_vm.documento.value),callback:function ($$v) {_vm.$set(_vm.documento, "value", $$v)},expression:"documento.value"}}),_vm._v(" "),_c('form-field',{attrs:{"precision":2,"col":"3","label":"Valor De","type":"value"},model:{value:(_vm.valor.start),callback:function ($$v) {_vm.$set(_vm.valor, "start", $$v)},expression:"valor.start"}}),_vm._v(" "),_c('form-field',{attrs:{"precision":2,"col":"3","label":"Valor Até","type":"value"},model:{value:(_vm.valor.end),callback:function ($$v) {_vm.$set(_vm.valor, "end", $$v)},expression:"valor.end"}})],1),_vm._v(" "),_c('div',{staticClass:"row px-4 py-2 mb-2"},[_c('v-button',{attrs:{"label":"Filtrar","success":true},on:{"click":_vm.loadData}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Limpar Filtros"},on:{"click":_vm.handleLimparFiltros}})],1)]):_vm._e()])]),_vm._v(" "),(this.dados && this.dados.totais)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.extratoTab)?_c('div',{staticClass:"border bg-white mb-2"},[_c('div',{staticClass:"row p-2 mr-2"},[_c('div',{staticClass:"col-md-3 text-center"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("\n                            Saldo Inicial\n                        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"total",class:{ 'valor-negativo': this.dados.totais.saldoInicial < 0, 'valor-positivo': this.dados.totais.saldoInicial > 0}},[_vm._v(" R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(this.dados.totais.saldoInicial,2,true))+" ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-center"},[_c('span',{staticClass:"lbl-edit"},[_vm._v(" Entradas ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"total valor-positivo"},[_vm._v(" R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(this.dados.totais.totalRecebimentos,2,true))+" ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-center"},[_c('span',{staticClass:"lbl-edit"},[_vm._v(" Saídas ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"total valor-negativo"},[_vm._v(" R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(this.dados.totais.totalPagamentos,2,true))+" ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-center"},[_c('span',{staticClass:"lbl-edit"},[_vm._v(" Saldo Final ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"total"},[_vm._v(" R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(this.dados.totais.saldoFinal,2,true))+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"w-100 text-center my-2"},[(_vm.extratoTab)?_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},attrs:{"data-toggle":"collapse","data-target":"#collapseSaldos","aria-expanded":"false","aria-controls":"collapseOrg"}},[_c('i',{staticClass:"fa fa-dollar",attrs:{"aria-hidden":"true"}}),_vm._v("\n                            Detalhar saldos iniciais\n                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row collapse p-2 mr-2",attrs:{"id":"collapseSaldos"}},_vm._l((this.dados.contas),function(conta,index){return _c('div',{key:index,staticClass:"col-md-3 text-center mb-2"},[_c('v-label',{attrs:{"label":conta.conta}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"total"},[_vm._v(" R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(conta.saldo,2,true))+" ")])])],1)}),0)]):_vm._e(),_vm._v(" "),(!_vm.extratoTab)?_c('div',{staticClass:"border bg-white mb-2"},[_c('div',{staticClass:"row p-2"},[_c('div',{staticClass:"col-md-3 text-center"},[_c('span',{staticClass:"lbl-edit"},[_vm._v(" A Vencer ")]),_c('br'),_vm._v(" "),(_vm.receberTab)?_c('span',{staticClass:"total"},[_vm._v(" R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(this.dados.totais.totalReceber,2,true))+" ")])]):_c('span',{staticClass:"total"},[_vm._v(" R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(this.dados.totais.totalPagar,2,true))+" ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-center"},[_c('span',{staticClass:"lbl-edit"},[_vm._v(" Vencidos ")]),_c('br'),_vm._v(" "),(_vm.receberTab)?_c('span',{staticClass:"total"},[_vm._v(" R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(this.dados.totais.vencidosReceber,2,true))+" ")])]):_c('span',{staticClass:"total"},[_vm._v(" R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(this.dados.totais.vencidosPagar,2,true))+" ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-center"},[_c('span',{staticClass:"lbl-edit"},[_vm._v(" Baixados ")]),_c('br'),_vm._v(" "),(_vm.receberTab)?_c('span',{staticClass:"total valor-positivo"},[_vm._v(" R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(this.dados.totais.totalRecebimentos,2,true))+" ")])]):_c('span',{staticClass:"total valor-positivo"},[_vm._v(" R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(this.dados.totais.totalPagamentos,2,true))+" ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-center"},[_c('span',{staticClass:"lbl-edit"},[_vm._v(" Perdidos ou Cancelados ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"total valor-negativo"},[_vm._v(" R$"),_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(this.dados.totais.totalPerdidos,2,true))+" ")])])])])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',[(_vm.showAlert && _vm.finList.length == 0)?_c('alert',{attrs:{"type":"warning","text":"Nenhum título encontrado"}}):_vm._e(),_vm._v(" "),(_vm.finList.length > 0)?_c('div',{staticClass:"row col fixed-top mx-auto menu-sticky py-2",staticStyle:{"background":"white","width":"100%","max-width":"1078px"}},[(!_vm.extratoTab)?_c('div',[_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){return _vm.handleVerifyToCheckAll()}}},[_c('i',{class:'fa' + ' ' + (!_vm.allFinListChecked ? 'fa-check-square' : 'fa-minus'),attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"ml-2"},[_vm._v(" "+_vm._s(!_vm.allFinListChecked ? 'Marcar' : 'Desmarcar')+" todos ")])]),_vm._v(" "),_c('a',{staticClass:"ml-5",staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){return _vm.handlePrint(1)}}},[_c('i',{staticClass:"fa fa-print",attrs:{"aria-hidden":"true"}}),_vm._v(" Imprimir Recibo ")]),_vm._v(" "),(_vm.receberTab)?_c('a',{staticClass:"ml-5",staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleEnviarEmail}},[_c('i',{staticClass:"fa fa-send",attrs:{"aria-hidden":"true"}}),_vm._v(" Enviar Boletos ")]):_vm._e(),_vm._v(" "),(_vm.receberTab)?_c('a',{staticClass:"ml-5",staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleCobranca}},[_c('i',{staticClass:"fa fa-envelope",attrs:{"aria-hidden":"true"}}),_vm._v(" Enviar Carta de Cobrança ")]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.finList.length > 0)?_c('div',{staticClass:"sorting-header-bar mt-2 mb-3 d-none d-md-block"},[(!_vm.extratoTab)?_c('div',{staticClass:"row align-items-center text-muted font-weight-bold"},[_c('div',{staticClass:"col-auto ml-2",staticStyle:{"width":"38px","flex":"0 0 38px"}}),_vm._v(" "),_c('div',{staticClass:"col-auto clickable-header",staticStyle:{"width":"110px","flex":"0 0 110px","max-width":"110px"},on:{"click":function($event){return _vm.sortBy('doc')}}},[_vm._v("\n                        Doc. "),_c('i',{staticClass:"fa",class:_vm.getSortIcon('doc')})]),_vm._v(" "),_c('div',{staticClass:"col-auto clickable-header",staticStyle:{"width":"100px","flex":"0 0 100px","max-width":"100px"},on:{"click":function($event){return _vm.sortBy('dtemissao')}}},[_vm._v("\n                        Dt.Emi "),_c('i',{staticClass:"fa",class:_vm.getSortIcon('dtemissao')})]),_vm._v(" "),_c('div',{staticClass:"col-auto clickable-header",staticStyle:{"width":"100px","flex":"0 0 100px","max-width":"100px"},on:{"click":function($event){return _vm.sortBy('vencimento')}}},[_vm._v("\n                        Dt.Venc "),_c('i',{staticClass:"fa",class:_vm.getSortIcon('vencimento')})]),_vm._v(" "),_c('div',{staticClass:"col-auto clickable-header",staticStyle:{"width":"90px","flex":"0 0 90px","max-width":"90px"},on:{"click":function($event){return _vm.sortBy('natureza')}}},[_vm._v("\n                        Nat. "),_c('i',{staticClass:"fa",class:_vm.getSortIcon('natureza')})]),_vm._v(" "),_c('div',{staticClass:"col-auto clickable-header",staticStyle:{"width":"230px","flex":"0 0 230px","max-width":"230px"},on:{"click":function($event){return _vm.sortBy('nome')}}},[(_vm.receberTab)?_c('span',[_vm._v("Cliente")]):_c('span',[_vm._v("Fornecedor")]),_vm._v(" "),_c('i',{staticClass:"fa",class:_vm.getSortIcon('nome')})]),_vm._v(" "),_c('div',{staticClass:"col-auto clickable-header text-right",staticStyle:{"width":"90px","flex":"0 0 90px","max-width":"90px"},on:{"click":function($event){return _vm.sortBy('vlr')}}},[_vm._v("\n                        Valor "),_c('i',{staticClass:"fa",class:_vm.getSortIcon('vlr')})]),_vm._v(" "),_c('div',{staticClass:"col-auto clickable-header text-center",staticStyle:{"width":"110px","flex":"0 0 110px","max-width":"110px"},on:{"click":function($event){return _vm.sortBy('dataBaixa')}}},[_vm._v("\n                        Pag/Canc. "),_c('i',{staticClass:"fa",class:_vm.getSortIcon('dataBaixa')})])]):_vm._e(),_vm._v(" "),(_vm.extratoTab)?_c('div',{staticClass:"row align-items-center text-muted font-weight-bold"},[_c('div',{staticClass:"col-auto clickable-header",staticStyle:{"width":"130px","flex":"0 0 130px","max-width":"130px"},on:{"click":function($event){return _vm.sortBy('doc')}}},[_vm._v("\n                        Documento "),_c('i',{staticClass:"fa",class:_vm.getSortIcon('doc')})]),_vm._v(" "),_c('div',{staticClass:"col-auto clickable-header",staticStyle:{"width":"110px","flex":"0 0 110px","max-width":"110px"},on:{"click":function($event){return _vm.sortBy('data')}}},[_vm._v("\n                        Data "),_c('i',{staticClass:"fa",class:_vm.getSortIcon('data')})]),_vm._v(" "),_c('div',{staticClass:"col-auto clickable-header",staticStyle:{"width":"180px","flex":"0 0 180px","max-width":"180px"},on:{"click":function($event){return _vm.sortBy('natureza')}}},[_vm._v("\n                        Natureza "),_c('i',{staticClass:"fa",class:_vm.getSortIcon('natureza')})]),_vm._v(" "),_c('div',{staticClass:"col-auto clickable-header",staticStyle:{"width":"250px","flex":"0 0 250px","max-width":"250px"},on:{"click":function($event){return _vm.sortBy('nome')}}},[_vm._v("\n                        Cliente/Fornecedor "),_c('i',{staticClass:"fa",class:_vm.getSortIcon('nome')})]),_vm._v(" "),_c('div',{staticClass:"col-auto text-center",staticStyle:{"width":"80px","flex":"0 0 80px","max-width":"80px"}}),_vm._v(" "),_c('div',{staticClass:"col-auto clickable-header text-right",staticStyle:{"width":"100px","flex":"0 0 100px","max-width":"100px"},on:{"click":function($event){return _vm.sortBy('vlr')}}},[_vm._v("\n                        Valor "),_c('i',{staticClass:"fa",class:_vm.getSortIcon('vlr')})]),_vm._v(" "),_c('div',{staticClass:"col-auto clickable-header text-right",staticStyle:{"width":"110px","flex":"0 0 110px","max-width":"110px"},on:{"click":function($event){return _vm.sortBy('saldo')}}},[_vm._v("\n                        Saldo "),_c('i',{staticClass:"fa",class:_vm.getSortIcon('saldo')})])]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.finList),function(fin,index){return (!_vm.extratoTab)?_c('div',{key:index,staticClass:"mainbox"},[_c('div',{class:{ 'mark-green': fin.baixado, 'mark-red': fin.cancelado || fin.perdido }}),_vm._v(" "),_c('div',{staticClass:"box",class:{ 'c-baixado': fin.baixado, 'c-perdido': fin.cancelado || fin.perdido }},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-auto ml-2 pb-2",staticStyle:{"width":"38px","flex":"0 0 38px"}},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false},model:{value:(fin.isChecked),callback:function ($$v) {_vm.$set(fin, "isChecked", $$v)},expression:"fin.isChecked"}})],1),_vm._v(" "),_c('div',{staticClass:"col-auto",staticStyle:{"width":"110px","flex":"0 0 110px","max-width":"110px"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Documento")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm text-truncate"},[_vm._v(_vm._s(fin.doc)+" / "+_vm._s(fin.parcela)+" ")]),_vm._v(" "),(fin.recorrente)?_c('i',{staticClass:"fa fa-recycle float-right",staticStyle:{"font-size":"20px","color":"gray"},attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Recorrente"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-auto",staticStyle:{"width":"100px","flex":"0 0 100px","max-width":"100px"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Emissão")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm text-truncate",attrs:{"data-toggle":"tooltip","data-placement":"top","data-original-title":_vm.datasTitulo(fin)}},[_vm._v(_vm._s(_vm._f("formatData")(fin.dtemissao)))])]),_vm._v(" "),_c('div',{staticClass:"col-auto",staticStyle:{"width":"100px","flex":"0 0 100px","max-width":"100px"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Vencimento")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm text-truncate"},[_vm._v(_vm._s(_vm._f("formatData")(fin.vencimento)))])]),_vm._v(" "),_c('div',{staticClass:"col-auto",staticStyle:{"width":"90px","flex":"0 0 90px","max-width":"90px"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Natureza")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm text-truncate",attrs:{"data-toggle":"tooltip","data-placement":"top","title":fin.natureza}},[_vm._v(_vm._s(fin.natureza))])]),_vm._v(" "),_c('div',{staticClass:"col-auto",staticStyle:{"width":"230px","flex":"0 0 230px","max-width":"230px"}},[(_vm.receberTab)?_c('label',{staticClass:"lbl-list"},[_vm._v("Cliente")]):_c('span',{staticClass:"lbl-list"},[_vm._v("Fornecedor")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm text-truncate",attrs:{"data-toggle":"tooltip","data-placement":"top","title":_vm.getClienteLabel(fin)}},[_vm._v(_vm._s(fin.nome)+" "+_vm._s(fin.descricao)+"\n                                "),(fin.npedido)?_c('span',[_vm._v("Pedido "+_vm._s(fin.npedido))]):_vm._e(),_vm._v(" "),(fin.descricao)?_c('span',[_vm._v(_vm._s(fin.descricao))]):_vm._e(),_vm._v(" "),(fin.texto)?_c('span',[_vm._v(_vm._s(fin.texto))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-auto text-right",staticStyle:{"width":"90px","flex":"0 0 90px","max-width":"90px"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Valor")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm text-truncate"},[_vm._v(_vm._s(_vm._f("formatValue")(fin.vlr,2, true)))])]),_vm._v(" "),_c('div',{staticClass:"col-auto text-center d-flex flex-column justify-content-center align-items-center",staticStyle:{"width":"110px","flex":"0 0 110px","max-width":"110px"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Situação")]),_c('br'),_vm._v(" "),(fin.aberto)?_c('div',[(fin.vencido)?_c('i',{staticClass:"fa fa-circle",staticStyle:{"color":"yellow","padding":".25rem"},attrs:{"data-toggle":"tooltip","data-placement":"top","title":'Dias de atraso: ' + fin.dias}}):_vm._e(),_vm._v(" "),(_vm.receberTab && fin.boleto)?_c('i',{staticClass:"fa fa-envelope",staticStyle:{"color":"silver","padding":".25rem"},attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Boleto Enviado"}}):_vm._e(),_vm._v(" "),(fin.stremessacnab == 1 || fin.stremessacnab == 2)?_c('i',{staticClass:"fa fa-university",staticStyle:{"color":"silver","padding":".25rem"},attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Este título está em remessa e não pode ser alterado"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list-sm text-muted"},[_vm._v("Aberto")])]):(fin.perdido || fin.cancelado || fin.baixado)?_c('div',[_c('span',{staticClass:"badge",class:[{'badge-red': fin.cancelado || fin.perdido}, {'badge-green': fin.baixado && !fin.parcial}, {'badge-yellow': fin.parcial}],attrs:{"data-toggle":"tooltip","data-placement":"top","title":fin.baixado ? 'Baixado em ' + _vm.dataStr(fin.dataBaixa) : (fin.dataBaixa ? 'Cancelado/Perdido em ' + _vm.dataStr(fin.dataBaixa) : '')}},[_vm._v(_vm._s(_vm.textST(fin)))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-auto ml-auto text-right"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[(fin.banco_url)?_c('img',{staticClass:"m-2",staticStyle:{"width":"38px","height":"38px","border-radius":"5px"},attrs:{"src":fin.banco_url,"alt":"Logo do Banco","data-toggle":"tooltip","data-placement":"top","title":fin.banco_nome}}):_vm._e(),_vm._v(" "),_c('v-button',{attrs:{"title":"Editar","icon":"fa-pencil"},on:{"click":function($event){return _vm.handleEdit(fin)}}}),_vm._v(" "),((fin.aberto && fin.emiteboleto) && _vm.receberTab)?_c('v-button',{attrs:{"title":"Emitir Boleto","icon":"fa-barcode"},on:{"click":function($event){return _vm.handleEmiteBoleto(fin)}}}):_vm._e(),_vm._v(" "),(fin.aberto && _vm.receberTab)?_c('v-button',{attrs:{"title":"Baixar como recebido","success":true,"icon":"fa-check"},on:{"click":function($event){return _vm.handleBaixar(fin.codfin)}}}):_vm._e(),_vm._v(" "),(fin.aberto && _vm.pagarTab)?_c('v-button',{attrs:{"title":"Baixar como pago","success":true,"icon":"fa-check"},on:{"click":function($event){return _vm.handleBaixar(fin.codfin)}}}):_vm._e()],1)])])])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.finList),function(fin,index){return (_vm.extratoTab)?_c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-auto",staticStyle:{"width":"130px","flex":"0 0 130px","max-width":"130px"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Documento")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm text-truncate"},[_vm._v(_vm._s(fin.doc)+" / "+_vm._s(fin.parcela))])]),_vm._v(" "),_c('div',{staticClass:"col-auto",staticStyle:{"width":"110px","flex":"0 0 110px","max-width":"110px"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm text-truncate",attrs:{"data-toggle":"tooltip","data-placement":"top"}},[_vm._v(_vm._s(_vm._f("formatData")(fin.data)))])]),_vm._v(" "),_c('div',{staticClass:"col-auto",staticStyle:{"width":"180px","flex":"0 0 180px","max-width":"180px"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Natureza")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm text-truncate",attrs:{"data-toggle":"tooltip","data-placement":"top","title":fin.natureza}},[_vm._v(_vm._s(fin.natureza))])]),_vm._v(" "),_c('div',{staticClass:"col-auto",staticStyle:{"width":"250px","flex":"0 0 250px","max-width":"250px"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Cliente/Fornecedor")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm text-truncate",attrs:{"data-toggle":"tooltip","data-placement":"top","title":_vm.getClienteLabel(fin)}},[_vm._v(_vm._s(fin.nome)+"\n                                "),(fin.npedido)?_c('span',{staticClass:"data-list-sm"},[_vm._v("Pedido "+_vm._s(fin.npedido))]):_vm._e(),_vm._v(" "),(fin.descricao)?_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(fin.descricao))]):_vm._e(),_vm._v(" "),(fin.texto)?_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(fin.texto))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-auto text-center d-flex justify-content-center align-items-center",staticStyle:{"width":"80px","flex":"0 0 80px","max-width":"80px"}},[(fin.parcial)?_c('div',{staticClass:"fa fa-adjust mr-1",staticStyle:{"color":"lime"},attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Baixa parcial"}}):_vm._e(),_vm._v(" "),(fin.tipo == 'R' || fin.tipo == 'E')?_c('span',{staticClass:"tipo tipo-recebimento",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Recebimento"}},[_vm._v(" "+_vm._s(fin.tipo)+" ")]):_vm._e(),_vm._v(" "),(fin.tipo == 'P' || fin.tipo == 'S')?_c('span',{staticClass:"tipo tipo-pagamento",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Pagamento"}},[_vm._v(" "+_vm._s(fin.tipo)+" ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-auto text-right",staticStyle:{"width":"100px","flex":"0 0 100px","max-width":"100px"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Valor")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm text-truncate",class:{ 'valor-negativo': fin.tipo == 'P', 'valor-positivo': fin.tipo == 'R'}},[_vm._v(_vm._s(_vm._f("formatValue")(fin.vlr,2, true)))])]),_vm._v(" "),_c('div',{staticClass:"col-auto text-right",staticStyle:{"width":"110px","flex":"0 0 110px","max-width":"110px"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Saldo")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list-sm text-truncate",class:{ 'valor-negativo': fin.saldo < 0, 'valor-positivo': fin.tipo >= 0}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(fin.saldo,2, true)))])])]),_vm._v(" "),_c('div',{staticClass:"col-auto ml-auto text-right"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('v-button',{attrs:{"title":"Editar","icon":"fa-pencil"},on:{"click":function($event){return _vm.handleEdit(fin)}}})],1)])])])]):_vm._e()})],2)]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showForm)?_c('financeiro-form',{attrs:{"index":this.codfin,"tipo":_vm.tipofin,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showTransfForm)?_c('financeiro-transf-form',{attrs:{"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showMovForm)?_c('financeiro-movimento-form',{attrs:{"index":this.codfin,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"recibo"}},[(_vm.showRecibo)?_c('financeiro-print-recibo',{attrs:{"fin-list":_vm.printFinList,"receber-tab":_vm.receberTab,"pagar-tab":_vm.pagarTab,"filial":_vm.filial},on:{"close":_vm.handleClosePrint}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"mt-5",attrs:{"id":"relatorio"}},[(_vm.showRelatorio)?_c('financeiro-relatorio-agrupado',{attrs:{"fin-list-grupo":_vm.finListGrupo,"receber-tab":_vm.receberTab,"pagar-tab":_vm.pagarTab,"periodo-recebimento":_vm.periodoRecebimento,"periodo-vencimento":_vm.periodoVencimento,"periodo-emissao":_vm.periodoEmissao,"periodo":_vm.periodo,"documento":_vm.documento,"codpart":_vm.codpart,"valor":_vm.valor,"companyName":_vm.companyName},on:{"close":_vm.handleClosePrint}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"mt-5",attrs:{"id":"relatorio-data"}},[(_vm.showRelatorioData)?_c('financeiro-relatorio-data',{attrs:{"finListGrupo":_vm.finListGrupo,"fin-list-grupo-data":_vm.finListGrupoData,"receber-tab":_vm.receberTab,"pagar-tab":_vm.pagarTab,"periodo-recebimento":_vm.periodoRecebimento,"periodo-vencimento":_vm.periodoVencimento,"periodo-emissao":_vm.periodoEmissao,"periodo":_vm.periodo,"documento":_vm.documento,"codpart":_vm.codpart,"valor":_vm.valor,"companyName":_vm.companyName},on:{"close":_vm.handleClosePrint}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"mt-5",attrs:{"id":"relatorio-extrato"}},[(_vm.showRelatorioExtrato)?_c('financeiro-relatorio-extrato',{attrs:{"periodo":_vm.periodo,"dados":_vm.dados,"fin-list":_vm.finList,"companyName":_vm.companyName},on:{"close":_vm.handleClosePrint}}):_vm._e()],1),_vm._v(" "),(_vm.showModalCobranca)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h5',[_vm._v("Envio de e-mail de Carta de Cobrança")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.closeModalCobranca}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"ml-3 mb-3"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Marcar todos"},model:{value:(_vm.cartaCobrancaCheckAll),callback:function ($$v) {_vm.cartaCobrancaCheckAll=$$v},expression:"cartaCobrancaCheckAll"}})],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._l((_vm.titulosVencidosPorCliente),function(cliente,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"row align-items-center px-3"},[_c('div',{staticClass:"col-md-5 col-6 d-flex justify-content-start align-items-center"},[_c('div',{staticClass:"mt-n4"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false},model:{value:(cliente.isChecked),callback:function ($$v) {_vm.$set(cliente, "isChecked", $$v)},expression:"cliente.isChecked"}})],1),_vm._v(" "),_c('div',[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(cliente.nome))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 text-left"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("formatValue")(cliente.total,2, true)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 text-left"},[_c('form-field',{attrs:{"type":"text"},model:{value:(cliente.email),callback:function ($$v) {_vm.$set(cliente, "email", $$v)},expression:"cliente.email"}})],1)])])}),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer mt-3"},[_c('v-button',{ref:"btnConfirm",attrs:{"label":"Enviar","title":""},on:{"click":_vm.handleEnviarCobranca}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeModalCobranca}})],1)],2)])]):_vm._e(),_vm._v(" "),(_vm.showModalErrosBoleto)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h5',[_vm._v("Erro ao enviar emails de boletos")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.closeModalErros}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.listErrosBoleto),function(erro,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"row align-items-center px-3"},[_c('div',{staticClass:"col-md-1 col-6 text-left"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(erro.doc))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 d-flex justify-content-start align-items-center"},[_c('div',[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(erro.nome))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-left"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(erro.email))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-6 text-left"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("formatValue")(erro.vlr,2, true)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 text-left"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("formatData")(erro.dtv)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6 text-left"},[_c('span',{staticClass:"data-list-sm",staticStyle:{"white-space":"pre-line"}},[_vm._v(_vm._s(erro.erros[0]))])])])])}),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer mt-3"},[_c('v-button',{ref:"btnClose",attrs:{"label":"Fechar","title":""},on:{"click":_vm.closeModalErros}})],1)],2)])]):_vm._e(),_vm._v(" "),(_vm.showModalEnviarEmailBoleto)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h5',[_vm._v("Envio de Boleto por E-mail")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.closeModalEnviarEmailBoleto}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.selectedTitulosBoleto),function(titulo,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"row align-items-center px-3"},[_c('div',{staticClass:"col-md-2 text-left"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(titulo.doc)+" / "+_vm._s(titulo.parcela))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 d-flex justify-content-start align-items-center"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(titulo.nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-left"},[_c('span',{staticClass:"data-list-sm"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(titulo.vlr,2, true)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 text-left"},[_c('form-field',{attrs:{"type":"text"},model:{value:(titulo.email),callback:function ($$v) {_vm.$set(titulo, "email", $$v)},expression:"titulo.email"}})],1)])])}),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer mt-3"},[_c('v-button',{ref:"btnConfirm",attrs:{"label":"Enviar Boletos","title":""},on:{"click":_vm.handleConfirmarEnviarEmailBoleto}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeModalEnviarEmailBoleto}})],1)],2)])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainbox"},[_c('div',{staticClass:"row align-items-center px-3"},[_c('div',{staticClass:"col-md-5 d-flex align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Nome do Cliente")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-left"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Valor")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 text-left"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Email")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainbox"},[_c('div',{staticClass:"row align-items-center px-3"},[_c('div',{staticClass:"col-md-1 text-left"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Nr Doc")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 d-flex align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Nome do Cliente")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-left"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Email")])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 text-left"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Valor")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-left"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Vencimento")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-left"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Erro")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainbox"},[_c('div',{staticClass:"row align-items-center px-3"},[_c('div',{staticClass:"col-md-2 text-left"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Documento")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 d-flex align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Nome do Cliente")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-left"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Valor")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 text-left"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Email Destinatário")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_conciliacao_form_vue__ = __webpack_require__(628);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce35aaf0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_conciliacao_form_vue__ = __webpack_require__(1749);
function injectStyle (ssrContext) {
  __webpack_require__(1747)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_conciliacao_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce35aaf0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_conciliacao_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1748);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("13dbc9ac", content, true, {});

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".btn-excluir{display:flex;justify-content:center;align-items:center;font-size:.75rem;width:20px;height:20px;border-radius:100%;margin-top:-5px;margin-right:-5px;z-index:1;background-color:green;opacity:1%;cursor:pointer}", ""]);

// exports


/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dafault-container"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.extrato),function(item){return _c('div',{key:item.id,staticClass:"row bg-light border p-2 m-2"},[_c('div',{staticClass:"col-md-3 d-flex flex-column justify-content-center align-items-start"},[_c('span',[_vm._v("Data: "+_vm._s(item.data))]),_vm._v(" "),_c('span',[_vm._v("Valor: "+_vm._s(item.valor))]),_vm._v(" "),_c('span',[_vm._v("Saldo: "+_vm._s(item.saldo.toFixed(2)))]),_vm._v(" "),_c('span',[_vm._v("Descrição: "+_vm._s(item.descricao ? item.descricao : 'Sem Descrição'))])]),_vm._v(" "),(!item.conciliado)?_c('div',{staticClass:"col-md-3 d-flex align-items-center"},[_c('div',{staticClass:"lancamentos-select"},[_c('form-field',{attrs:{"type":"select","label":"Selecione um lançamento","select-options":_vm.lanOpts},model:{value:(item.lancamento),callback:function ($$v) {_vm.$set(item, "lancamento", $$v)},expression:"item.lancamento"}})],1),_vm._v(" "),_c('div',{staticClass:"acoes"},[_c('button',{staticClass:"btn btn-success ml-2",attrs:{"title":"Vincular Lançamento"},on:{"click":_vm.vincularLancamento}},[_c('i',{staticClass:"fa fa-link"})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6 d-flex"},_vm._l((item.lancamentos),function(lancamento){return _c('div',{key:lancamento.id,staticClass:"row border border-success rounded bg-success text-white p-2 ml-1 mr-1"},[_c('div',{staticClass:"d-flex flex-column align-items-start ml-2 mr-2"},[_c('small',[_vm._v("Data: "+_vm._s(lancamento.data))]),_vm._v(" "),_c('small',[_vm._v("Valor: "+_vm._s(lancamento.valor))]),_vm._v(" "),_c('small',[_vm._v("Nome: "+_vm._s(lancamento.nome))]),_vm._v(" "),_c('small',[_vm._v("Saldo: "+_vm._s(lancamento.saldo.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"btn-excluir",attrs:{"title":"Desvincular Lançamento"},on:{"click":function($event){return _vm.desvincularLancamento(item.codextrato, lancamento.codfin)}}},[_c('i',{staticClass:"fa fa-close"})])])}),0)])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-3"},[_c('h4',[_c('strong',[_vm._v("Conciliação Bancária")])]),_vm._v(" "),_c('span',[_vm._v("Vincule lançamentos aos extratos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeirolog_list_vue__ = __webpack_require__(629);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_33693597_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeirolog_list_vue__ = __webpack_require__(1753);
function injectStyle (ssrContext) {
  __webpack_require__(1751)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_financeirolog_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_33693597_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_financeirolog_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1752);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("579ecb02", content, true, {});

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('bar-list',{attrs:{"refresh-button":true,"new-button":false,"single-entity":"Histórico","plural-entity":"Histórico","filtro-mes":true},on:{"refresh":_vm.loadData,"search":_vm.handleTextSearch,"filter":_vm.handleAdvancedFilter}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.logList.length == 0)?_c('alert',{attrs:{"type":"warning","text":"Nenhum registro encontrado"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.logList),function(log){return _c('div',{key:log.codfin,staticClass:"mainbox"},[_c('div',{staticClass:"mark-gray"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.data(log.data)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Documento")]),_vm._v(" "),(log.parcela)?_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(log.doc)+" / "+_vm._s(log.parcela))]):_vm._e(),_vm._v(" "),(!log.parcela)?_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(log.doc))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Valor")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("format")(log.vlr)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(log.usuario))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.textACAO(log)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(log.part_nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-1"},[_c('v-button',{attrs:{"title":"Visualizar o documento","icon":"fa-search"},on:{"click":function($event){return _vm.handleVisualiza(log.id)}}})],1)])])])})],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_cta_list_vue__ = __webpack_require__(630);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_088dcdc3_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_cta_list_vue__ = __webpack_require__(1761);
function injectStyle (ssrContext) {
  __webpack_require__(1755)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_cta_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_088dcdc3_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_cta_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1756);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("566f893e", content, true, {});

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_cta_form_vue__ = __webpack_require__(631);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d027de_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_cta_form_vue__ = __webpack_require__(1760);
function injectStyle (ssrContext) {
  __webpack_require__(1758)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_cta_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d027de_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_cta_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1759);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5605079c", content, true, {});

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Conta","crud":this.crud},on:{"closeform":_vm.closeForm,"save":_vm.handleSave}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"metadata":_vm.metadata.cta.codcta,"type":"text","col":"2","disabled":true},model:{value:(_vm.cta.codcta),callback:function ($$v) {_vm.$set(_vm.cta, "codcta", $$v)},expression:"cta.codcta"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.descricao.validator),expression:"metadata.cta.descricao.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.cta.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.cta.descricao),callback:function ($$v) {_vm.$set(_vm.cta, "descricao", $$v)},expression:"cta.descricao"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"2","metadata":_vm.metadata.cta.tipocta},model:{value:(_vm.cta.tipocta),callback:function ($$v) {_vm.$set(_vm.cta, "tipocta", $$v)},expression:"cta.tipocta"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.ctapadrao.validator),expression:"metadata.cta.ctapadrao.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.cta.ctapadrao,"name":"ctapadrao","v-errors":_vm.errors},model:{value:(_vm.cta.ctapadrao),callback:function ($$v) {_vm.$set(_vm.cta, "ctapadrao", $$v)},expression:"cta.ctapadrao"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.codfil.validator),expression:"metadata.cta.codfil.validator"}],attrs:{"tabindex":-1,"type":"select2","col":"3","metadata":_vm.metadata.cta.codfil,"name":"codfil","v-errors":_vm.errors},model:{value:(_vm.cta.codfil),callback:function ($$v) {_vm.$set(_vm.cta, "codfil", $$v)},expression:"cta.codfil"}})],1),_vm._v(" "),(_vm.cta.tipocta==='B')?_c('label-title',{attrs:{"title":"Dados Bancários"}}):_vm._e(),_vm._v(" "),(_vm.cta.tipocta==='B')?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","col":"3","select-options":_vm.bancoOptions,"label":"Banco"},on:{"input":function($event){return _vm.setCtaValidate(_vm.cta.banco)}},model:{value:(_vm.cta.banco),callback:function ($$v) {_vm.$set(_vm.cta, "banco", $$v)},expression:"cta.banco"}})],1):_vm._e(),_vm._v(" "),(_vm.bancoHomologado)?_c('div',{staticClass:"row"},[_c('input-switch',{attrs:{"type":"success","label":"Emite Boleto?","value-checked":"S","value-unchecked":"N","metadata":_vm.metadata.cta.emiteboleto},model:{value:(_vm.cta.emiteboleto),callback:function ($$v) {_vm.$set(_vm.cta, "emiteboleto", $$v)},expression:"cta.emiteboleto"}})],1):_vm._e(),_vm._v(" "),(_vm.cta.emiteboleto==='S')?_c('div',[_c('label-title',{attrs:{"title":"Configuração para emissão de boletos"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('alert',{attrs:{"type":"info","text":"Assista ao vídeo com instruções para configuração da emissão de boleto e envio de cobrança escritural."}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.agencia.validator),expression:"metadata.cta.agencia.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.cta.agencia,"name":"agencia","v-errors":_vm.errors},model:{value:(_vm.cta.agencia),callback:function ($$v) {_vm.$set(_vm.cta, "agencia", $$v)},expression:"cta.agencia"}}),_vm._v(" "),(_vm.ctaValidate && _vm.ctaValidate.digitoagencia && _vm.ctaValidate.digitoagencia.exibe)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.digitoagencia.validate),expression:"ctaValidate.digitoagencia.validate"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.cta.digitoagencia,"name":"digitoagencia","v-errors":_vm.errors},model:{value:(_vm.cta.digitoagencia),callback:function ($$v) {_vm.$set(_vm.cta, "digitoagencia", $$v)},expression:"cta.digitoagencia"}}):_vm._e(),_vm._v(" "),(_vm.ctaValidate && _vm.ctaValidate.digitoagencia && _vm.ctaValidate.conta.exibe)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.conta.validate),expression:"ctaValidate.conta.validate"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.cta.conta,"name":"conta","v-errors":_vm.errors},model:{value:(_vm.cta.conta),callback:function ($$v) {_vm.$set(_vm.cta, "conta", $$v)},expression:"cta.conta"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.digito.validator),expression:"metadata.cta.digito.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.cta.digito,"name":"digito","v-errors":_vm.errors},model:{value:(_vm.cta.digito),callback:function ($$v) {_vm.$set(_vm.cta, "digito", $$v)},expression:"cta.digito"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.tparquivocnab.validator),expression:"metadata.cta.tparquivocnab.validator"}],attrs:{"type":"select","col":"2","metadata":_vm.metadata.cta.tparquivocnab,"name":"tparquivocnab","v-errors":_vm.errors},model:{value:(_vm.cta.tparquivocnab),callback:function ($$v) {_vm.$set(_vm.cta, "tparquivocnab", $$v)},expression:"cta.tparquivocnab"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.numbordero.validator),expression:"metadata.cta.numbordero.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.cta.numbordero,"name":"numbordero","v-errors":_vm.errors},model:{value:(_vm.cta.numbordero),callback:function ($$v) {_vm.$set(_vm.cta, "numbordero", $$v)},expression:"cta.numbordero"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.ctaValidate && _vm.ctaValidate.digitoagencia && _vm.ctaValidate.carteira.exibe)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.carteira.validate),expression:"ctaValidate.carteira.validate"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.cta.carteira,"name":"carteira","v-errors":_vm.errors},model:{value:(_vm.cta.carteira),callback:function ($$v) {_vm.$set(_vm.cta, "carteira", $$v)},expression:"cta.carteira"}}):_vm._e(),_vm._v(" "),(_vm.ctaValidate && _vm.ctaValidate.digitoagencia && _vm.ctaValidate.carteiravariacao.exibe)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.carteiravariacao.validate),expression:"ctaValidate.carteiravariacao.validate"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.cta.carteiravariacao,"name":"carteiravariacao","v-errors":_vm.errors},model:{value:(_vm.cta.carteiravariacao),callback:function ($$v) {_vm.$set(_vm.cta, "carteiravariacao", $$v)},expression:"cta.carteiravariacao"}}):_vm._e(),_vm._v(" "),(_vm.ctaValidate && _vm.ctaValidate.digitoagencia && _vm.ctaValidate.nrinscricao.exibe)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.nrinscricao.validate),expression:"ctaValidate.nrinscricao.validate"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.cta.nrinscricao,"name":"nrinscricao","v-errors":_vm.errors},model:{value:(_vm.cta.nrinscricao),callback:function ($$v) {_vm.$set(_vm.cta, "nrinscricao", $$v)},expression:"cta.nrinscricao"}}):_vm._e(),_vm._v(" "),(_vm.ctaValidate && _vm.ctaValidate.digitoagencia && _vm.ctaValidate.convenio.exibe)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.convenio.validate),expression:"ctaValidate.convenio.validate"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.cta.convenio,"name":"convenio","v-errors":_vm.errors},model:{value:(_vm.cta.convenio),callback:function ($$v) {_vm.$set(_vm.cta, "convenio", $$v)},expression:"cta.convenio"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.nossonumero.validator),expression:"metadata.cta.nossonumero.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.cta.nossonumero,"name":"nossonumero","v-errors":_vm.errors},model:{value:(_vm.cta.nossonumero),callback:function ($$v) {_vm.$set(_vm.cta, "nossonumero", $$v)},expression:"cta.nossonumero"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.ctaValidate && _vm.ctaValidate.digitoagencia && _vm.ctaValidate.especietitulo.exibe)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.especietitulo.validate),expression:"ctaValidate.especietitulo.validate"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.cta.especietitulo,"name":"especietitulo","v-errors":_vm.errors},model:{value:(_vm.cta.especietitulo),callback:function ($$v) {_vm.$set(_vm.cta, "especietitulo", $$v)},expression:"cta.especietitulo"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[(_vm.ctaValidate.emissaoempresa.exibe)?_c('input-checkbox',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.emissaoempresa.validate),expression:"ctaValidate.emissaoempresa.validate"}],attrs:{"label":_vm.metadata.cta.emissaoempresa.label,"value-checked":"S","value-unchecked":_vm.ctaValidate.emissaoempresa.validate.required 
                                ? null 
                                : 'N'},model:{value:(_vm.cta.emissaoempresa),callback:function ($$v) {_vm.$set(_vm.cta, "emissaoempresa", $$v)},expression:"cta.emissaoempresa"}}):_vm._e(),_vm._v(" "),(_vm.emissaoEmpresaError)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.emissaoEmpresaError.msg))]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.pmulta.validator),expression:"metadata.cta.pmulta.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.cta.pmulta,"name":"pmulta","v-errors":_vm.errors},model:{value:(_vm.cta.pmulta),callback:function ($$v) {_vm.$set(_vm.cta, "pmulta", $$v)},expression:"cta.pmulta"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.pmora.validator),expression:"metadata.cta.pmora.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.cta.pmora,"name":"pmora","v-errors":_vm.errors},model:{value:(_vm.cta.pmora),callback:function ($$v) {_vm.$set(_vm.cta, "pmora", $$v)},expression:"cta.pmora"}}),_vm._v(" "),(_vm.ctaValidate && _vm.ctaValidate.digitoagencia && _vm.ctaValidate.codinstr1.exibe)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.codinstr1.validate),expression:"ctaValidate.codinstr1.validate"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.cta.codinstr1,"name":"codinstr1","v-errors":_vm.errors},model:{value:(_vm.cta.codinstr1),callback:function ($$v) {_vm.$set(_vm.cta, "codinstr1", $$v)},expression:"cta.codinstr1"}}):_vm._e(),_vm._v(" "),(_vm.ctaValidate && _vm.ctaValidate.digitoagencia && _vm.ctaValidate.codinstr2.exibe)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.codinstr2.validate),expression:"ctaValidate.codinstr2.validate"}],attrs:{"type":"number","col":"2","metadata":_vm.metadata.cta.codinstr2,"name":"codinstr2","v-errors":_vm.errors},model:{value:(_vm.cta.codinstr2),callback:function ($$v) {_vm.$set(_vm.cta, "codinstr2", $$v)},expression:"cta.codinstr2"}}):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.instrucao1.validator),expression:"metadata.cta.instrucao1.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.cta.instrucao1,"name":"instrucao1","v-errors":_vm.errors},model:{value:(_vm.cta.instrucao1),callback:function ($$v) {_vm.$set(_vm.cta, "instrucao1", $$v)},expression:"cta.instrucao1"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.instrucao2.validator),expression:"metadata.cta.instrucao2.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.cta.instrucao2,"name":"instrucao2","v-errors":_vm.errors},model:{value:(_vm.cta.instrucao2),callback:function ($$v) {_vm.$set(_vm.cta, "instrucao2", $$v)},expression:"cta.instrucao2"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.localpag1.validator),expression:"metadata.cta.localpag1.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.cta.localpag1,"name":"localpag1","v-errors":_vm.errors},model:{value:(_vm.cta.localpag1),callback:function ($$v) {_vm.$set(_vm.cta, "localpag1", $$v)},expression:"cta.localpag1"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.localpag2.validator),expression:"metadata.cta.localpag2.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.cta.localpag2,"name":"localpag2","v-errors":_vm.errors},model:{value:(_vm.cta.localpag2),callback:function ($$v) {_vm.$set(_vm.cta, "localpag2", $$v)},expression:"cta.localpag2"}})],1)],1):_vm._e()],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row col"},[_c('span',{staticClass:"data-list"},[_vm._v("Para emissão de boleto será obrigatório o envio do arquivo de remessa no qual contém informações sobre os boletos emitidos aos clientes.")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v("O arquivo de remessa deve ser gerado após a emissão do boleto.")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v("O gerente da sua conta deve ser acionado para que seja feita a homologação do arquivo de remessa gerado pelo Nota Brasil.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row col"},[_c('span',{staticClass:"data-list"},[_vm._v("Configure abaixo as mensagens que serão impressas no boleto")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Conta","plural-entity":"Contas"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.ctaList.length == 0)?_c('alert',{attrs:{"type":"warning","text":"Nenhuma conta foi encontrada"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.ctaList),function(cta,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"mark-green"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-6"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(cta.descricao))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.cta.codcta.label)+" ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(cta.codcta))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.cta.tipocta.label)+" ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.getTipocta(cta.tipocta)))])]),_vm._v(" "),(cta.banco)?_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.cta.banco.label)+" ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(cta.banco_nome))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.cta.emiteboleto.label)+" ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.getBoleto(cta.emiteboleto)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6 ml-auto"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(cta.codcta)},"view":function($event){return _vm.handleEdit(cta.codcta, true)}}})],1)])])])})],2)],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showForm)?_c('cta-form',{attrs:{"index":this.codcta,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1763);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("c7b4df6a", content, true, {});

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-7b9db253]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-7b9db253]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-7b9db253]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-7b9db253]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-7b9db253]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-7b9db253]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-7b9db253]{flex:1;min-width:0}.nb-card-title-line[data-v-7b9db253]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-7b9db253]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-7b9db253]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-7b9db253]{color:#334155;font-weight:600}.nb-card-actions[data-v-7b9db253]{flex:0 0 auto}.nb-card-details[data-v-7b9db253]{display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:12px;margin:12px 0 0 60px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-card-detail[data-v-7b9db253]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-card-detail-label[data-v-7b9db253]{color:#64748b;font-size:11px}.nb-card-detail>strong[data-v-7b9db253]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}@media (max-width:767.98px){.nb-card-top[data-v-7b9db253]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-7b9db253]{align-self:flex-end}.nb-card-details[data-v-7b9db253]{margin-left:0}}", ""]);

// exports


/***/ }),
/* 1764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fpag_form_vue__ = __webpack_require__(634);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_39282a7b_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fpag_form_vue__ = __webpack_require__(1767);
function injectStyle (ssrContext) {
  __webpack_require__(1765)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fpag_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_39282a7b_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fpag_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1766);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5288f9cc", content, true, {});

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Forma de Pagamento","plural-entity":"Forma de Pagamento","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true, max:40}),expression:"{required:true, max:40}"}],ref:"descricao",attrs:{"v-errors":_vm.errors,"required":true,"metadata":_vm.metadata.fpag.descricao,"type":"text","col":"6","name":"descricao","disabled":_vm.isView},model:{value:(_vm.fpag.descricao),callback:function ($$v) {_vm.$set(_vm.fpag, "descricao", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"fpag.descricao"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"placeholder":"Selecione","value":_vm.fpag.formapag,"type":"select","metadata":_vm.metadata.fpag.formapag,"col":"3","disabled":_vm.isView},model:{value:(_vm.fpag.formapag),callback:function ($$v) {_vm.$set(_vm.fpag, "formapag", $$v)},expression:"fpag.formapag"}})],1),_vm._v(" "),(_vm.habilitaBandeira)?_c('label-title',{attrs:{"title":"Taxa"}}):_vm._e(),_vm._v(" "),(_vm.habilitaBandeira)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fpag.taxa.validator),expression:"metadata.fpag.taxa.validator"}],attrs:{"type":"value","metadata":_vm.metadata.fpag.taxa,"col":"2","v-errors":_vm.errors,"precision":2,"disabled":_vm.isView},model:{value:(_vm.fpag.taxa),callback:function ($$v) {_vm.$set(_vm.fpag, "taxa", _vm._n($$v))},expression:"fpag.taxa"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"value","metadata":_vm.metadata.fpag.taxafixa,"col":"2","disabled":_vm.isView},model:{value:(_vm.fpag.taxafixa),callback:function ($$v) {_vm.$set(_vm.fpag, "taxafixa", _vm._n($$v))},expression:"fpag.taxafixa"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fpag.validator),expression:"metadata.fpag.validator"}],attrs:{"type":"number","metadata":_vm.metadata.fpag.diascredito,"col":"2","v-errors":_vm.errors,"precision":2,"disabled":_vm.isView},model:{value:(_vm.fpag.diascredito),callback:function ($$v) {_vm.$set(_vm.fpag, "diascredito", _vm._n($$v))},expression:"fpag.diascredito"}})],1):_vm._e(),_vm._v(" "),_c('label-title',{attrs:{"title":"Módulo Financeiro"}}),_vm._v(" "),(!_vm.isCreditoLoja)?_c('validation',{attrs:{"messages":['Selecione se esta forma de pagamento deve gerar um contas a receber ou lançamento no extrato']}}):_vm._e(),_vm._v(" "),(!_vm.isCreditoLoja)?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"placeholder":"Selecione","value":_vm.fpag.lancamentofin,"type":"select","metadata":_vm.metadata.fpag.lancamentofin,"col":"3","disabled":_vm.isView},model:{value:(_vm.fpag.lancamentofin),callback:function ($$v) {_vm.$set(_vm.fpag, "lancamentofin", $$v)},expression:"fpag.lancamentofin"}})],1):_vm._e(),_vm._v(" "),(!_vm.isCreditoLoja)?_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select2","metadata":_vm.metadata.fpag.codcta,"name":"codcta","col":"3","disabled":_vm.isView},model:{value:(_vm.fpag.codcta),callback:function ($$v) {_vm.$set(_vm.fpag, "codcta", _vm._n($$v))},expression:"fpag.codcta"}})],1):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Forma de Pagamento","plural-entity":"Formas de Pagamento","title-search":"Pesquise pela descrição"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.fpagList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.fpagList),function(fpag){return _c('article',{key:fpag.codfpag,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(fpag.descricao.toUpperCase()))])]),_vm._v(" "),(fpag.codfpag)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(fpag.codfpag))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: true, btnEditLabel: 'Editar'},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(fpag.codfpag)},"view":function($event){return _vm.handleEdit(fpag.codfpag, true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"nb-card-details"},[(fpag.formapag)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Tipo")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.formapag(fpag.formapag)))])]):_vm._e(),_vm._v(" "),(fpag.bandeirapag)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Bandeira")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.bandeirapag(fpag.bandeirapag)))])]):_vm._e()])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('FpagForm',{attrs:{"index":this.codfpag,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-credit-card",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_vcaixa_list_vue__ = __webpack_require__(635);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8df5556_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_vcaixa_list_vue__ = __webpack_require__(1776);
function injectStyle (ssrContext) {
  __webpack_require__(1770)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_vcaixa_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8df5556_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_vcaixa_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1771);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("245904b6", content, true, {});

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_vcaixa_form_vue__ = __webpack_require__(636);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca38923_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_vcaixa_form_vue__ = __webpack_require__(1775);
function injectStyle (ssrContext) {
  __webpack_require__(1773)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_vcaixa_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca38923_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_vcaixa_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1774);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("65b41e0a", content, true, {});

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Caixa PDV","plural-entity":"Caixas PDV","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required:true, max:40}),expression:"{required:true, max:40}"}],ref:"descricao",attrs:{"v-errors":_vm.errors,"required":true,"metadata":_vm.metadata.vcaixa.descricao,"type":"text","col":"6","name":"descricao","disabled":_vm.isView},model:{value:(_vm.vcaixa.descricao),callback:function ($$v) {_vm.$set(_vm.vcaixa, "descricao", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vcaixa.descricao"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"placeholder":"Selecione","value":_vm.vcaixa.stcaixa,"type":"select","metadata":_vm.metadata.vcaixa.stcaixa,"col":"3","disabled":_vm.isView},model:{value:(_vm.vcaixa.stcaixa),callback:function ($$v) {_vm.$set(_vm.vcaixa, "stcaixa", $$v)},expression:"vcaixa.stcaixa"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Caixa PDV","plural-entity":"Caixas PDV","title-search":"Pesquise pela descrição"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.vcaixaList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.vcaixaList),function(vcaixa){return _c('div',{key:vcaixa.codvcaixa,staticClass:"mainbox"},[_c('div',{staticClass:"mark-green"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-6 col-8 d-flex flex-column"},[_c('span',{staticClass:"lbl-list"},[_vm._v("Descrição")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(vcaixa.descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"lbl-list"},[_vm._v("Caixa Ativo?")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.stcaixa(vcaixa.stcaixa)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(vcaixa.codvcaixa)},"view":function($event){return _vm.handleEdit(vcaixa.codvcaixa, true)}}})],1)])])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('vcaixaForm',{attrs:{"index":this.codvcaixa,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_print_form_vue__ = __webpack_require__(637);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d528d062_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_print_form_vue__ = __webpack_require__(1784);
function injectStyle (ssrContext) {
  __webpack_require__(1778)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_print_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d528d062_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_print_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1779);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5628ff9b", content, true, {});

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tableGrid_vue__ = __webpack_require__(638);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_541694d4_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tableGrid_vue__ = __webpack_require__(1783);
function injectStyle (ssrContext) {
  __webpack_require__(1781)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-541694d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tableGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_541694d4_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tableGrid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1782);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6b947f66", content, true, {});

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "body[data-v-541694d4]{font-size:14px}th[data-v-541694d4]{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}td[data-v-541694d4],th[data-v-541694d4]{font-size:12px;padding:10px 20px}th.active[data-v-541694d4]{color:#28a745}th.active .arrow[data-v-541694d4]{opacity:1}.arrow[data-v-541694d4]{display:inline-block;vertical-align:middle;width:0;height:0;margin-left:5px;opacity:.66}.arrow.asc[data-v-541694d4]{border-bottom:4px solid #495057}.arrow.asc[data-v-541694d4],.arrow.dsc[data-v-541694d4]{border-left:4px solid transparent;border-right:4px solid transparent}.arrow.dsc[data-v-541694d4]{border-top:4px solid #495057}", ""]);

// exports


/***/ }),
/* 1783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table table-bordered"},[_c('thead',{staticClass:"thead-light"},[_c('tr',_vm._l((_vm.columns),function(column,idx){return _c('th',{directives:[{name:"show",rawName:"v-show",value:(column[4]),expression:"column[4]"}],key:idx,class:{ active: _vm.sortKey == column[0] },style:({ width: column[2] }),on:{"click":function($event){return _vm.sortBy(column[0])}}},[_vm._v("            \n          "+_vm._s(_vm._f("capitalize")(column[1]))+"\n          "),_c('span',{staticClass:"arrow",class:_vm.sortOrders[column[0]] > 0 ? 'asc' : 'dsc'})])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredCampos),function(entry,idx){return _c('tr',{key:idx},_vm._l((_vm.columns),function(column,idx){return _c('td',{directives:[{name:"show",rawName:"v-show",value:(column[4]),expression:"column[4]"}],key:idx},[_vm._v("\n      "+_vm._s(_vm.formatar(entry[column[0]], column[3]))+"\n      ")])}),0)}),0)]),_vm._v(" "),_c('p',[_c('nav',{attrs:{"aria-label":"Page navigation example"}},[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",on:{"click":_vm.prevPage}},[_vm._v("Anterior")])]),_vm._v(" "),_c('li',{staticClass:"page-item disabled"},[_c('a',{staticClass:"page-link"},[_vm._v(_vm._s(_vm.page)+" de "+_vm._s((Math.ceil(_vm.campos.length / _vm.pageSize)) || _vm.page))])]),_vm._v(" "),_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",on:{"click":_vm.nextPage}},[_vm._v("Próximo")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-container"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"grid"},[_c('div',{staticClass:"grid-item col-md-12 mb-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                Filtros de Relatório\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('form-field',{attrs:{"type":"select","col":"5","metadata":_vm.tprel,"optionnull":true},model:{value:(_vm.rel),callback:function ($$v) {_vm.rel=$$v},expression:"rel"}}),_vm._v(" "),_c('form-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.rel === 'P'),expression:"rel === 'P'"}],attrs:{"type":"select","col":"5","metadata":_vm.tppedvfil,"optionnull":true},model:{value:(_vm.tppedv),callback:function ($$v) {_vm.tppedv=$$v},expression:"tppedv"}}),_vm._v(" "),_c('form-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.rel === 'P'),expression:"rel === 'P'"}],attrs:{"type":"select","col":"5","metadata":_vm.stpedvfil,"optionnull":true},model:{value:(_vm.stpedv),callback:function ($$v) {_vm.stpedv=$$v},expression:"stpedv"}}),_vm._v(" "),_c('form-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.rel === 'N'),expression:"rel === 'N'"}],attrs:{"type":"select","col":"5","metadata":_vm.operacaonffil,"optionnull":true},model:{value:(_vm.operacaonf),callback:function ($$v) {_vm.operacaonf=$$v},expression:"operacaonf"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select2","col":"12","name":"cliente","select2":{ entity: 'cliente/', minlength: 0 },"label":"Cliente"},model:{value:(_vm.cliente),callback:function ($$v) {_vm.cliente=$$v},expression:"cliente"}}),_vm._v(" "),_c('form-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.rel === 'T'),expression:"rel === 'T'"}],attrs:{"type":"select2","col":"12","name":"Grupo de Estoque","select2":{ entity: 'gruest/', minlength: 0 },"label":"Grupo de Estoque"},model:{value:(_vm.gruestid),callback:function ($$v) {_vm.gruestid=$$v},expression:"gruestid"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.rel === 'N'),expression:"rel === 'N'"}]},[_c('div',{staticClass:"col-sm-2"},[_vm._v("Situação das Notas:\n                  ")]),_vm._v(" "),_c('div',{staticClass:"col-md-auto"},_vm._l((_vm.stnf),function(column,idx){return _c('div',{key:idx,staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(column.filtrar),expression:"column.filtrar"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"idx","value":"option1"},domProps:{"checked":Array.isArray(column.filtrar)?_vm._i(column.filtrar,"option1")>-1:(column.filtrar)},on:{"change":function($event){var $$a=column.filtrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="option1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(column, "filtrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(column, "filtrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(column, "filtrar", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"inlineCheckbox1"}},[_vm._v(_vm._s(column.label))])])}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input-month2',{attrs:{"p-month":_vm.filter}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":this.textSearch}},[_vm._v("Consultar")])],1),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"col-sm-2"},[_vm._v("Colunas:\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-11"},_vm._l((_vm.columns),function(column,idx){return _c('div',{key:idx,staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(column[4]),expression:"column[4]"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"idx","value":"option1"},domProps:{"checked":Array.isArray(column[4])?_vm._i(column[4],"option1")>-1:(column[4])},on:{"change":function($event){var $$a=column[4],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="option1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(column, 4, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(column, 4, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(column, 4, $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"inlineCheckbox1"}},[_vm._v(_vm._s(column[1]))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"col-sm-2"},[_vm._v("Totalizar:\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-11"},_vm._l((_vm.columns),function(column,idx){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(column[3] === 'N'),expression:"column[3] === 'N'"}],key:idx,staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(column[7]),expression:"column[7]"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"idx","value":"option1"},domProps:{"checked":Array.isArray(column[7])?_vm._i(column[7],"option1")>-1:(column[7])},on:{"change":function($event){var $$a=column[7],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="option1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(column, 7, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(column, 7, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(column, 7, $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"inlineCheckbox1"}},[_vm._v(_vm._s(column[1]))])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"grid-item col-md-12 mb-4"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":this.downloadTest}},[_vm._v("Imprimir")])]),_vm._v(" "),_c('div',{staticClass:"grid-item col-md-12 mb-4"},[_c('tableGrid',{attrs:{"campos":_vm.list,"columns":_vm.columns,"currentPage":_vm.currentPage}})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1786);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("70b84943", content, true, {});

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-f84c21b2]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-f84c21b2]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-f84c21b2]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-f84c21b2]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-f84c21b2]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-f84c21b2]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-f84c21b2]{flex:1;min-width:0}.nb-card-title-line[data-v-f84c21b2]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-f84c21b2]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-f84c21b2]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-f84c21b2]{color:#334155;font-weight:600}.nb-card-badge[data-v-f84c21b2]{display:inline-flex;align-items:center;gap:4px;padding:4px 7px;border:1px solid transparent;border-radius:5px;font-size:10px;font-weight:700;line-height:1.2}.nb-card-badge--inactive[data-v-f84c21b2]{color:#92400e;background:#fffbeb;border-color:#fde68a}.nb-card-actions[data-v-f84c21b2]{display:flex;align-items:center;gap:6px;flex:0 0 auto}.nb-card-actions .btn[data-v-f84c21b2]{border-radius:6px}.nb-card-actions .btn-outline-primary[data-v-f84c21b2]{color:#004e94;border-color:#004e94}.nb-card-actions .btn-outline-primary[data-v-f84c21b2]:hover{color:#fff;background-color:#004e94}.nb-card-actions .btn-outline-secondary[data-v-f84c21b2]{color:#475569;border-color:#cbd5e1}.nb-card-actions .btn-outline-secondary[data-v-f84c21b2]:hover{color:#0f172a;background:#f1f5f9;border-color:#94a3b8}.nb-card-details[data-v-f84c21b2]{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px;margin:12px 0 0 60px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-card-detail[data-v-f84c21b2]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-card-detail--full[data-v-f84c21b2]{grid-column:1/-1}.nb-card-detail-label[data-v-f84c21b2]{color:#64748b;font-size:11px}.nb-card-detail>strong[data-v-f84c21b2]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}@media (max-width:767.98px){.nb-card-top[data-v-f84c21b2]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-f84c21b2]{align-self:flex-end}.nb-card-details[data-v-f84c21b2]{grid-template-columns:minmax(0,1fr);margin-left:0}}", ""]);

// exports


/***/ }),
/* 1787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tabpre_form_vue__ = __webpack_require__(641);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ab816a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tabpre_form_vue__ = __webpack_require__(1790);
function injectStyle (ssrContext) {
  __webpack_require__(1788)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tabpre_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ab816a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tabpre_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1789);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e851f2c2", content, true, {});

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Tabela de Preço","plural-entity":"Tabela de Preços","crud":this.crud},on:{"closeform":_vm.closeForm,"save":_vm.handleSave}}),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.tabpre.descricao.validator),expression:"metadata.tabpre.descricao.validator"}],ref:"descricao",attrs:{"type":"text","col":"8","metadata":_vm.metadata.tabpre.descricao,"case":"normal","name":"descricao","v-errors":_vm.errors},model:{value:(_vm.tabpre.descricao),callback:function ($$v) {_vm.$set(_vm.tabpre, "descricao", $$v)},expression:"tabpre.descricao"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.tabpre.sttabpre.validator),expression:"metadata.tabpre.sttabpre.validator"}],ref:"sttabpre",attrs:{"type":"select","col":"4","metadata":_vm.metadata.tabpre.sttabpre,"name":"sttabpre","v-errors":_vm.errors},model:{value:(_vm.tabpre.sttabpre),callback:function ($$v) {_vm.$set(_vm.tabpre, "sttabpre", $$v)},expression:"tabpre.sttabpre"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12 nb-margin-bottom"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tabpre.tptabela),expression:"tabpre.tptabela"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio1","value":"P"},domProps:{"checked":_vm._q(_vm.tabpre.tptabela,"P")},on:{"change":function($event){return _vm.$set(_vm.tabpre, "tptabela", "P")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio1"}},[_vm._v("Tabela de preços normal com preços informados")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 nb-margin-bottom"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tabpre.tptabela),expression:"tabpre.tptabela"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio2","value":"A"},domProps:{"checked":_vm._q(_vm.tabpre.tptabela,"A")},on:{"change":function($event){return _vm.$set(_vm.tabpre, "tptabela", "A")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio2"}},[_vm._v("Tabela automática de acréscimo aplicado na tabela de preços padrão ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 nb-margin-bottom"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tabpre.tptabela),expression:"tabpre.tptabela"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio3","value":"D"},domProps:{"checked":_vm._q(_vm.tabpre.tptabela,"D")},on:{"change":function($event){return _vm.$set(_vm.tabpre, "tptabela", "D")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio3"}},[_vm._v("Tabela automática de desconto aplicado na tabela de preços padrão ")])])])]),_vm._v(" "),(_vm.tabpre.tptabela != 'P')?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.tabpre.percentual.validator),expression:"metadata.tabpre.percentual.validator"}],attrs:{"type":"value","col":"2","metadata":_vm.metadata.tabpre.percentual,"addon":"%","name":"percentual","v-errors":_vm.errors},model:{value:(_vm.tabpre.percentual),callback:function ($$v) {_vm.$set(_vm.tabpre, "percentual", $$v)},expression:"tabpre.percentual"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"case":"normal","type":"memo","col":"8","label":"Observações","name":"text","v-errors":_vm.errors},model:{value:(_vm.tabpre.texto),callback:function ($$v) {_vm.$set(_vm.tabpre, "texto", $$v)},expression:"tabpre.texto"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tabpre_itens_form_vue__ = __webpack_require__(642);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b74a0c68_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tabpre_itens_form_vue__ = __webpack_require__(1798);
function injectStyle (ssrContext) {
  __webpack_require__(1792)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tabpre_itens_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_b74a0c68_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tabpre_itens_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1793);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0b4ac26a", content, true, {});

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tabpre_add_form_vue__ = __webpack_require__(643);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f53cb35_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tabpre_add_form_vue__ = __webpack_require__(1797);
function injectStyle (ssrContext) {
  __webpack_require__(1795)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tabpre_add_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f53cb35_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tabpre_add_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1796);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6a547836", content, true, {});

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".dropdown-select-item{width:100%;z-index:1051;margin-top:3px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;position:absolute;padding:10px;z-index:1000;float:left;min-width:160px;list-style:none;background-color:#fff;border:1px solid rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2);background-clip:padding-box}", ""]);

// exports


/***/ }),
/* 1797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-margin-bottom w-100"},[_c('div',{staticClass:"headerpesquisa",staticStyle:{"position":"relative","width":"100%","z-index":"10","background-color":"white"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchString),expression:"searchString"}],ref:"pesquisa",staticClass:"form-control form-control-sm",attrs:{"id":"search","type":"text","placeholder":"Pesquisa pela descrição ou pelo código do item"},domProps:{"value":(_vm.searchString)},on:{"change":function($event){return _vm.handleChange()},"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleEsc()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search()}],"input":function($event){if($event.target.composing){ return; }_vm.searchString=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary",staticStyle:{"margin-right":"5px"},attrs:{"tabindex":"1","type":"submit"},on:{"click":function($event){return _vm.search()}}},[_c('i',{staticClass:"fa fa-search",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[(false)?_c('a',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"href":"javascript:void(0);","title":"Mais Filtros"},on:{"click":function($event){return _vm.search()}}},[_vm._v("...")]):_vm._e()])])])])]),_vm._v(" "),(_vm.showItems)?_c('div',{staticClass:"dropdown-select-item",style:(_vm.myDropDown),on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleEsc()}}},[_c('div',{staticStyle:{"position":"absolute","margin-left":"70%","z-index":"10","background-color":"transparent"},style:(_vm.myStyle)},[_c('v-button',{attrs:{"tabindex":1,"nb-btdef":true,"label":"Adicionar","icon":"fa-plus"},on:{"click":function($event){return _vm.addItens()}}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"50px"}},_vm._l((_vm.localItemList),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-6 col-10"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(item.descricao))]),_vm._v(" "),(_vm.existe(item.coditem))?_c('span',{staticClass:"badge badge-yellow-outline"},[_vm._v("Adicionado")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(item.codigo))])]),_vm._v(" "),_c('form-field',{ref:"preco",refInFor:true,attrs:{"precision":2,"type":"value","col":"2","label":"Preço"},model:{value:(item.vlr),callback:function ($$v) {_vm.$set(item, "vlr", $$v)},expression:"item.vlr"}}),_vm._v(" "),_c('form-field',{attrs:{"precision":2,"type":"value","col":"2","label":"Preço Mínimo"},on:{"keyenter":function($event){return _vm.handleEnter(index)}},model:{value:(item.vlrmin),callback:function ($$v) {_vm.$set(item, "vlrmin", $$v)},expression:"item.vlrmin"}})],1),_vm._v(" "),_c('hr')])}),0)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"list"}},[_c('bar-manut',{attrs:{"single-entity":"Produtos da Tabela de Preço","btn-delete":false},on:{"closeform":_vm.closeForm}}),_vm._v(" "),_c('div',{staticClass:"default-container nb-margin-top",staticStyle:{"border-top":"3px solid black"}},[_c('label-title',{attrs:{"title":_vm.tabpre.descricao}}),_vm._v(" "),_c('div',{staticClass:"w-100"},[(_vm.tabpre.texto)?_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.tabpre.texto))]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.tpTabela != 'P')?_c('alert',{attrs:{"type":"info","title":"Tabela tipo acréscimo ou desconto","text":"Esta tabela não possibilita inclusão de novos itens."}}):_vm._e(),_vm._v(" "),(_vm.tabpreItens.length == 0)?_c('alert',{attrs:{"type":"info","title":"Tabela sem produtos","text":"Inclua produtos na tabela de preços."}}):_vm._e()],1),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.tpTabela == 'P')?_c('div',{staticClass:"row col",staticStyle:{"padding":"35px"}},[(!_vm.showInserirProduto)?_c('div',[_c('v-button',{attrs:{"label":"Adicionar Produtos","nb-btdef":true,"title":"","icon":"fa-plus"},on:{"click":_vm.handleAddItem}})],1):_vm._e(),_vm._v(" "),(!_vm.isView && _vm.showInserirProduto)?_c('tabpre-add-form',{ref:"addList",attrs:{"params":{ items: this.tabpreItens }},on:{"additem":_vm.handleSalvarItens}}):_vm._e()],1):_vm._e(),_vm._v(" "),_vm._l((_vm.tabpreItens),function(tabpre,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('span',{staticClass:"lbl-list w-100"},[_vm._v("Código")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(tabpre.codigo))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('span',{staticClass:"lbl-list w-100"},[_vm._v("Descrição")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(tabpre.descricao))])]),_vm._v(" "),(index != _vm.indexEditing)?_c('div',{staticClass:"col-md-2 col-3"},[_c('span',{staticClass:"lbl-list w-100"},[_vm._v("Preço")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(tabpre.vlr,2)))])]):_vm._e(),_vm._v(" "),(index != _vm.indexEditing)?_c('div',{staticClass:"col-md-2 col-3"},[_c('span',{staticClass:"lbl-list w-100"},[_vm._v("Preço Mínimo")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(tabpre.vlrmin,2)))])]):_vm._e(),_vm._v(" "),(index == _vm.indexEditing)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.tabpreit.vlr.validator),expression:"metadata.tabpreit.vlr.validator"}],ref:"vlr",refInFor:true,attrs:{"type":"value","col":"2","metadata":_vm.metadata.tabpreit.vlr,"name":"vlr","v-errors":_vm.errors},on:{"keyenter":function($event){return _vm.handleGravaAlteracaoItem(index)}},model:{value:(tabpre.vlr),callback:function ($$v) {_vm.$set(tabpre, "vlr", $$v)},expression:"tabpre.vlr"}}):_vm._e(),_vm._v(" "),(index == _vm.indexEditing)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.tabpreit.vlrmin.validator),expression:"metadata.tabpreit.vlrmin.validator"}],ref:"vlrmin",refInFor:true,attrs:{"type":"value","col":"2","metadata":_vm.metadata.tabpreit.vlrmin,"name":"vlrmin","v-errors":_vm.errors},on:{"keyenter":function($event){return _vm.handleGravaAlteracaoItem(index)}},model:{value:(tabpre.vlrmin),callback:function ($$v) {_vm.$set(tabpre, "vlrmin", $$v)},expression:"tabpre.vlrmin"}}):_vm._e(),_vm._v(" "),(_vm.permiteAlteracao)?_c('div',{staticClass:"col-md-2 col-2"},[(_vm.indexEditing == null)?_c('v-button',{attrs:{"tabindex":-1,"icon":"fa-pencil"},on:{"click":function($event){return _vm.handleEditItem(index)}}}):_vm._e(),_vm._v(" "),(_vm.indexEditing == null)?_c('v-button',{attrs:{"tabindex":-1,"icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteVariavel(tabpre.codtabpreit)}}}):_vm._e(),_vm._v(" "),(_vm.indexEditing != null)?_c('v-button',{attrs:{"tabindex":-1,"icon":"fa-check"},on:{"click":function($event){return _vm.handleGravaAlteracaoItem(index)}}}):_vm._e()],1):_vm._e()],1)])])})],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showForm == 'list')?_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":_vm.possuiPermissao,"pdf-button":false,"xls-button":false,"single-entity":"Tabela de Preço","plural-entity":"Tabelas de Preço","title-search":"Pesquise pela descrição"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.tabpreList.length == 0)?_c('alert',{attrs:{"type":"info","title":"","text":"Nenhuma tabela cadastrada."}}):_vm._e(),_vm._v(" "),_vm._l((_vm.tabpreList),function(tabpre,index){return _c('article',{key:tabpre.codtabpre || index,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(tabpre.descricao))]),_vm._v(" "),(tabpre.sttabpre == 'I')?_c('span',{staticClass:"nb-card-badge nb-card-badge--inactive"},[_vm._v("\n                                    "+_vm._s(_vm.textST(tabpre.sttabpre))+"\n                                ")]):_vm._e()]),_vm._v(" "),(tabpre.codtabpre)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(tabpre.codtabpre))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('button',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleEditItens(tabpre.codtabpre)}}},[_c('i',{staticClass:"fa fa-archive fa-fw"}),_vm._v(" "),_c('span',{staticClass:"d-none d-sm-inline ml-1"},[_vm._v("Produtos")])]),_vm._v(" "),(_vm.possuiPermissao)?_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"type":"button","title":"Alterar"},on:{"click":function($event){return _vm.handleEdit(tabpre.codtabpre)}}},[_c('i',{staticClass:"fa fa-pencil fa-fw"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-details"},[_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Tipo de Tabela")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("getTipoTabela")(tabpre.tptabela,_vm.metadata.tabpre.tptabela)))])]),_vm._v(" "),(tabpre.texto)?_c('div',{staticClass:"nb-card-detail nb-card-detail--full"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Observações")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(tabpre.texto))])]):_vm._e()])])})],2)],1):_vm._e(),_vm._v(" "),(_vm.showForm == 'form')?_c('tabpre-form',{attrs:{"index":_vm.codtabpre,"crud":_vm.crud},on:{"closeform":_vm.closeForm}}):_vm._e(),_vm._v(" "),(_vm.showForm == 'itens')?_c('tabpre-itens-form',{attrs:{"tabpre":_vm.selectedTabpre},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-dollar",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1801);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("58219227", content, true, {});

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-164fc055]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-164fc055]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-164fc055]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-164fc055]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-164fc055]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-image[data-v-164fc055]{position:relative;display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;padding:4px;color:#64748b;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;cursor:pointer}.nb-card-image[data-v-164fc055]:focus-visible{outline:2px solid #004e94;outline-offset:2px}.nb-card-image>img[data-v-164fc055]{max-width:100%;max-height:100%;object-fit:contain}.nb-card-image>.fa[data-v-164fc055]{font-size:19px}.nb-card-image-edit[data-v-164fc055]{position:absolute;right:-5px;bottom:-5px;display:flex;width:18px;height:18px;align-items:center;justify-content:center;color:#fff;background:#004e94;border:2px solid #fff;border-radius:50%;font-size:8px}.nb-card-title[data-v-164fc055]{flex:1;min-width:0}.nb-card-title-line[data-v-164fc055]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-164fc055]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-164fc055]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-164fc055]{color:#334155;font-weight:600}.nb-card-badge[data-v-164fc055]{display:inline-flex;align-items:center;gap:4px;padding:4px 7px;border:1px solid transparent;border-radius:5px;font-size:10px;font-weight:700;line-height:1.2}.nb-card-badge--success[data-v-164fc055]{color:#166534;background:#f0fdf4;border-color:#bbf7d0}.nb-card-badge--inactive[data-v-164fc055]{color:#92400e;background:#fffbeb;border-color:#fde68a}.nb-card-actions[data-v-164fc055]{flex:0 0 auto}.nb-card-details[data-v-164fc055]{display:grid;grid-template-columns:minmax(0,1fr);gap:12px;margin:12px 0 0 60px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-card-detail[data-v-164fc055]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-card-detail-label[data-v-164fc055]{color:#64748b;font-size:11px}.nb-card-detail>strong[data-v-164fc055]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}@media (max-width:767.98px){.nb-card-top[data-v-164fc055]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-164fc055]{align-self:flex-end}.nb-card-details[data-v-164fc055]{margin-left:0}}", ""]);

// exports


/***/ }),
/* 1802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_destaq_form_vue__ = __webpack_require__(646);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4224d4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_destaq_form_vue__ = __webpack_require__(1805);
function injectStyle (ssrContext) {
  __webpack_require__(1803)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_destaq_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4224d4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_destaq_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1804);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1957b4a2", content, true, {});

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Item em Destaque","plural-entity":"Itens em Destaque","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{ref:"descricao",attrs:{"type":"text","col":"12","case":"normal","name":"descricao","v-errors":_vm.errors,"label":"Descrição"},model:{value:(_vm.destaq.descricao),callback:function ($$v) {_vm.$set(_vm.destaq, "descricao", $$v)},expression:"destaq.descricao"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"date","col":"3","name":"dtinicio","v-errors":_vm.errors,"label":"Data de Início"},model:{value:(_vm.destaq.dtinicio),callback:function ($$v) {_vm.$set(_vm.destaq, "dtinicio", $$v)},expression:"destaq.dtinicio"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"date","col":"3","name":"dttermino","v-errors":_vm.errors,"label":"Data de Término"},model:{value:(_vm.destaq.dttermino),callback:function ($$v) {_vm.$set(_vm.destaq, "dttermino", $$v)},expression:"destaq.dttermino"}})],1),_vm._v(" "),_c('label-title',{staticClass:"nb-margin-bottom nb-margin-top",attrs:{"title":"Inclusão de Itens"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{},[_c('varejo-add-item',{ref:"item",attrs:{"add-button":true,"exibePreco":false},on:{"onselect":_vm.handleNewItem},model:{value:(_vm.coditem),callback:function ($$v) {_vm.coditem=$$v},expression:"coditem"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},_vm._l((_vm.destaqit),function(valor,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-1 col-1 text-center"},[(valor.url)?_c('img',{staticClass:"mx-auto d-block img-thumbnail",staticStyle:{"max-width":"45px","max-height":"45px","cursor":"pointer"},attrs:{"src":valor.url,"alt":"Logotipo"}}):_vm._e(),_vm._v(" "),(!valor.url)?_c('i',{staticClass:"fa fa-camera mx-auto d-block",staticStyle:{"font-size":"25px","color":"silver"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-1"},[_c('v-label',{attrs:{"label":"Código do Item"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(valor.codigo))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-7 col-2"},[_c('v-label',{attrs:{"label":"Item"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(valor.descricao))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('v-button',{attrs:{"label":"","title":"Excluir Item","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteVariavel(index)}}})],1)])])])}),0)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Item em Destaque","plural-entity":"Itens em Destaque","title-search":"Pesquise pela descrição"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.destaqList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.destaqList),function(destaq){return _c('article',{key:destaq.coddestaq,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_c('button',{staticClass:"nb-card-image",attrs:{"type":"button","aria-label":'Gerenciar imagem de ' + destaq.descricao,"title":"Gerenciar imagem"},on:{"click":function($event){return _vm.handleAnexosForm(destaq.coddestaq, destaq.descricao)}}},[(destaq.url)?_c('img',{attrs:{"src":destaq.url,"alt":""}}):_c('i',{staticClass:"fa fa-camera",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(destaq.descricao))]),_vm._v(" "),_c('span',{staticClass:"nb-card-badge",class:destaq.status == 'A' ? 'nb-card-badge--success' : 'nb-card-badge--inactive'},[_vm._v("\n                                    "+_vm._s(_vm.getStatus(destaq.status))+"\n                                ")])]),_vm._v(" "),(destaq.coddestaq)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(destaq.coddestaq))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{ barDefault: true, btnView: false, btnEdit: true, btnEditLabel: 'Editar' },"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(destaq.coddestaq)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"nb-card-details"},[_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Vigência (Início à Término)")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("formatData")(destaq.dtinicio))+" à "+_vm._s(_vm._f("formatData")(destaq.dttermino)))])])])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('destaq-form',{attrs:{"index":this.coddestaq,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e(),_vm._v(" "),(_vm.showAnexosForm)?_c('anexos-form',{attrs:{"params":{ ref: 'destaq', chaveref: _vm.coddestaq, title: _vm.descricao, showform: true }},on:{"closeform":_vm.closeAnexosForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"nb-card-image-edit"},[_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1808);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4e879d4a", content, true, {});

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-649e87df]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-649e87df]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-649e87df]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-649e87df]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-649e87df]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-649e87df]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-649e87df]{flex:1;min-width:0}.nb-card-title-line[data-v-649e87df]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-649e87df]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-649e87df]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-649e87df]{color:#334155;font-weight:600}.nb-card-badge[data-v-649e87df]{display:inline-flex;align-items:center;gap:4px;padding:4px 7px;border:1px solid transparent;border-radius:5px;font-size:10px;font-weight:700;line-height:1.2}.nb-card-badge--success[data-v-649e87df]{color:#166534;background:#f0fdf4;border-color:#bbf7d0}.nb-card-badge--inactive[data-v-649e87df]{color:#92400e;background:#fffbeb;border-color:#fde68a}.nb-card-actions[data-v-649e87df]{flex:0 0 auto}.nb-card-details[data-v-649e87df]{display:grid;grid-template-columns:minmax(0,1fr);gap:12px;margin:12px 0 0 60px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-card-detail[data-v-649e87df]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-card-detail-label[data-v-649e87df]{color:#64748b;font-size:11px}.nb-card-detail>strong[data-v-649e87df]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}@media (max-width:767.98px){.nb-card-top[data-v-649e87df]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-649e87df]{align-self:flex-end}.nb-card-details[data-v-649e87df]{margin-left:0}}", ""]);

// exports


/***/ }),
/* 1809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tabdes_form_vue__ = __webpack_require__(649);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1efc094c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tabdes_form_vue__ = __webpack_require__(1812);
function injectStyle (ssrContext) {
  __webpack_require__(1810)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_tabdes_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1efc094c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_tabdes_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1811);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5103f323", content, true, {});

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Tabela de Desconto","plural-entity":"Tabelas de Desconto","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.tabdes.descricao.validator),expression:"metadata.tabdes.descricao.validator"}],ref:"descricao",attrs:{"type":"text","col":"12","case":"upper","name":"descricao","v-errors":_vm.errors,"metadata":_vm.metadata.tabdes.descricao,"label":"Descrição"},model:{value:(_vm.tabdes.descricao),callback:function ($$v) {_vm.$set(_vm.tabdes, "descricao", $$v)},expression:"tabdes.descricao"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.tabdes.dtinicio.validator),expression:"metadata.tabdes.dtinicio.validator"}],attrs:{"type":"date","col":"3","name":"dtinicio","v-errors":_vm.errors,"label":"Data de Início","metadata":_vm.metadata.tabdes.dtinicio},model:{value:(_vm.tabdes.dtinicio),callback:function ($$v) {_vm.$set(_vm.tabdes, "dtinicio", $$v)},expression:"tabdes.dtinicio"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.tabdes.dttermino.validator),expression:"metadata.tabdes.dttermino.validator"}],attrs:{"type":"date","col":"3","name":"dttermino","v-errors":_vm.errors,"label":"Data de Término","metadata":_vm.metadata.tabdes.dttermino},model:{value:(_vm.tabdes.dttermino),callback:function ($$v) {_vm.$set(_vm.tabdes, "dttermino", $$v)},expression:"tabdes.dttermino"}})],1),_vm._v(" "),_c('label-title',{staticClass:"nb-margin-bottom nb-margin-top",attrs:{"title":"Itens da Tabela de Desconto"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('div',{},[_c('varejo-add-item',{ref:"item",attrs:{"add-button":true,"exibePreco":false,"tabelaPreco":"1"},on:{"onselect":_vm.handleNewItem},model:{value:(_vm.coditem),callback:function ($$v) {_vm.coditem=$$v},expression:"coditem"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},_vm._l((_vm.tabdesit),function(valor,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-1 col-1 text-center"},[(valor.url)?_c('img',{staticClass:"mx-auto d-block img-thumbnail",staticStyle:{"max-width":"45px","max-height":"45px","cursor":"pointer"},attrs:{"src":valor.url,"alt":"Logotipo"}}):_vm._e(),_vm._v(" "),(!valor.url)?_c('i',{staticClass:"fa fa-camera mx-auto d-block",staticStyle:{"font-size":"25px","color":"silver"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-1"},[_c('v-label',{attrs:{"label":"Código do Item"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(valor.codigo))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-1"},[_c('v-label',{attrs:{"label":"Item"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(valor.descricao))])],1),_vm._v(" "),_c('form-field',{ref:"pdesc",refInFor:true,attrs:{"type":"value","col":"2","metadata":_vm.metadata.tabdesit.pdesc,"addon":"%"},model:{value:(valor.pdesc),callback:function ($$v) {_vm.$set(valor, "pdesc", $$v)},expression:"valor.pdesc"}}),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('v-button',{attrs:{"label":"","title":"Excluir Item","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteVariavel(index)}}})],1)],1)])])}),0)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Tabela de Desconto","plural-entity":"Tabelas de Desconto","title-search":"Pesquise pela descrição da tabela"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.tabdesList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.tabdesList),function(tabdes){return _c('article',{key:tabdes.codtabdes,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(tabdes.descricao))]),_vm._v(" "),_c('span',{staticClass:"nb-card-badge",class:tabdes.status == 'A' ? 'nb-card-badge--success' : 'nb-card-badge--inactive'},[_vm._v("\n                                    "+_vm._s(_vm.getStatus(tabdes.status))+"\n                                ")])]),_vm._v(" "),(tabdes.codtabdes)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(tabdes.codtabdes))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{ barDefault: true, btnView: false, btnEdit: true, btnEditLabel: 'Editar' },"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(tabdes.codtabdes)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"nb-card-details"},[_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Vigência (Início à Término)")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("formatData")(tabdes.dtinicio))+" à "+_vm._s(_vm._f("formatData")(tabdes.dttermino)))])])])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('tabdes-form',{attrs:{"index":this.codtabdes,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-percent",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_menu_vue__ = __webpack_require__(650);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_933c08ce_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_menu_vue__ = __webpack_require__(1851);
function injectStyle (ssrContext) {
  __webpack_require__(1815)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_933c08ce_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1816);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2c28dc5a", content, true, {});

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1818);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5bd9e340", content, true, {});

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-09ab28d3]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-09ab28d3]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-09ab28d3]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-09ab28d3]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-09ab28d3]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-09ab28d3]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-09ab28d3]{flex:1;min-width:0}.nb-card-title-line[data-v-09ab28d3]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-09ab28d3]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-09ab28d3]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-09ab28d3]{color:#334155;font-weight:600}.nb-card-actions[data-v-09ab28d3]{flex:0 0 auto}.nb-card-inline-form[data-v-09ab28d3]{padding:12px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px}@media (max-width:767.98px){.nb-card-top[data-v-09ab28d3]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-09ab28d3]{align-self:flex-end}}", ""]);

// exports


/***/ }),
/* 1819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pdtipo_form_vue__ = __webpack_require__(653);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e632ddae_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pdtipo_form_vue__ = __webpack_require__(1822);
function injectStyle (ssrContext) {
  __webpack_require__(1820)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pdtipo_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e632ddae_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pdtipo_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1821);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("169c6878", content, true, {});

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row align-items-center"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pdtipo.descricao.validator),expression:"metadata.pdtipo.descricao.validator"}],ref:"descricao",attrs:{"type":"text","col":"6","metadata":_vm.metadata.pdtipo.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.pdtipo.descricao),callback:function ($$v) {_vm.$set(_vm.pdtipo, "descricao", $$v)},expression:"pdtipo.descricao"}}),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-button',{attrs:{"label":"Salvar","nb-btdef":true},on:{"click":_vm.handleSave}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.closeForm}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Tipo de Pedido","plural-entity":"Tipos de Pedido"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.pdtipoList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),(_vm.showForm)?_c('div',{staticClass:"nb-card-inline-form mb-3"},[_c('pdtipo-form',{attrs:{"index":_vm.codtipo,"crud":_vm.crud},on:{"closeform":_vm.closeForm}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.pdtipoList),function(pdtipo){return _c('article',{key:pdtipo.codtipo,staticClass:"nb-card"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!pdtipo.show),expression:"!pdtipo.show"}],staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(pdtipo.descricao))])]),_vm._v(" "),(pdtipo.codtipo)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(pdtipo.codtipo))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnDelete: true, btnEdit: true, btnEditLabel: 'Editar'},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(pdtipo)},"view":function($event){return _vm.handleEdit(pdtipo, true)},"delete":function($event){return _vm.handleDelete(pdtipo)}}})],1)]),_vm._v(" "),(pdtipo.show)?_c('div',{staticClass:"nb-card-inline-form"},[_c('pdtipo-form',{attrs:{"index":pdtipo.codtipo,"crud":_vm.crud},on:{"closeform":_vm.closeForm}})],1):_vm._e()])})],2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-file-text-o",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1825);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("229838b0", content, true, {});

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-6790a97b]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-6790a97b]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-6790a97b]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-6790a97b]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-6790a97b]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-6790a97b]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-6790a97b]{flex:1;min-width:0}.nb-card-title-line[data-v-6790a97b]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-6790a97b]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-6790a97b]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-6790a97b]{color:#334155;font-weight:600}.nb-card-badge[data-v-6790a97b]{display:inline-flex;align-items:center;gap:4px;padding:4px 7px;border:1px solid transparent;border-radius:5px;font-size:10px;font-weight:700;line-height:1.2}.nb-card-badge--success[data-v-6790a97b]{color:#166534;background:#f0fdf4;border-color:#bbf7d0}.nb-card-badge--neutral[data-v-6790a97b]{color:#475569;background:#f1f5f9;border-color:#e2e8f0}.nb-card-actions[data-v-6790a97b]{flex:0 0 auto}.nb-card-inline-form[data-v-6790a97b]{padding:12px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px}@media (max-width:767.98px){.nb-card-top[data-v-6790a97b]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-6790a97b]{align-self:flex-end}}", ""]);

// exports


/***/ }),
/* 1826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pdstatus_form_vue__ = __webpack_require__(656);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_fab34a1a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pdstatus_form_vue__ = __webpack_require__(1829);
function injectStyle (ssrContext) {
  __webpack_require__(1827)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pdstatus_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_fab34a1a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pdstatus_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1828);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6090c2de", content, true, {});

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row align-items-center"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pdstatus.descricao.validator),expression:"metadata.pdstatus.descricao.validator"}],ref:"descricao",attrs:{"type":"text","col":"6","metadata":_vm.metadata.pdstatus.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.pdstatus.descricao),callback:function ($$v) {_vm.$set(_vm.pdstatus, "descricao", $$v)},expression:"pdstatus.descricao"}}),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-button',{attrs:{"label":"Salvar","nb-btdef":true},on:{"click":_vm.handleSave}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.closeForm}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Status de Pedido","plural-entity":"Status de Pedido"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.pdstatusList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),(_vm.showForm)?_c('div',{staticClass:"nb-card-inline-form mb-3"},[_c('pdstatus-form',{attrs:{"index":_vm.codstatus,"crud":_vm.crud},on:{"closeform":_vm.closeForm}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.pdstatusList),function(pdstatus){return _c('article',{key:pdstatus.codstatus,staticClass:"nb-card"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!pdstatus.show),expression:"!pdstatus.show"}],staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(pdstatus.descricao))]),_vm._v(" "),(pdstatus.codstatus <= 13)?_c('span',{staticClass:"nb-card-badge nb-card-badge--neutral"},[_vm._v("\n                                    Padrão\n                                ")]):_c('span',{staticClass:"nb-card-badge nb-card-badge--success"},[_vm._v("\n                                    Personalizado\n                                ")])]),_vm._v(" "),(pdstatus.codstatus)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(pdstatus.codstatus))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnDelete: (pdstatus.codstatus>13), btnEdit: (pdstatus.codstatus>13), btnEditLabel: 'Editar'},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(pdstatus)},"view":function($event){return _vm.handleEdit(pdstatus, true)},"delete":function($event){return _vm.handleDelete(pdstatus)}}})],1)]),_vm._v(" "),(pdstatus.show)?_c('div',{staticClass:"nb-card-inline-form"},[_c('pdstatus-form',{attrs:{"index":pdstatus.codstatus,"crud":_vm.crud},on:{"closeform":_vm.closeForm}})],1):_vm._e()])})],2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-tasks",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1832);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("32f64e30", content, true, {});

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-2bcfa7f0]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-2bcfa7f0]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-2bcfa7f0]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-2bcfa7f0]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-2bcfa7f0]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-2bcfa7f0]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-2bcfa7f0]{flex:1;min-width:0}.nb-card-title-line[data-v-2bcfa7f0]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-2bcfa7f0]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-2bcfa7f0]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-2bcfa7f0]{color:#334155;font-weight:600}.nb-card-actions[data-v-2bcfa7f0]{flex:0 0 auto}.nb-card-inline-form[data-v-2bcfa7f0]{padding:12px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px}@media (max-width:767.98px){.nb-card-top[data-v-2bcfa7f0]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-2bcfa7f0]{align-self:flex-end}}", ""]);

// exports


/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_condicao_form_vue__ = __webpack_require__(659);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e9803ab_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_condicao_form_vue__ = __webpack_require__(1836);
function injectStyle (ssrContext) {
  __webpack_require__(1834)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_condicao_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e9803ab_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_condicao_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1835);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("eacfc998", content, true, {});

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row align-items-center"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.condicao.descricao.validator),expression:"metadata.condicao.descricao.validator"}],ref:"descricao",attrs:{"type":"text","col":"6","metadata":_vm.metadata.condicao.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.condicao.descricao),callback:function ($$v) {_vm.$set(_vm.condicao, "descricao", $$v)},expression:"condicao.descricao"}}),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-button',{attrs:{"label":"Salvar","nb-btdef":true},on:{"click":_vm.handleSave}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.closeForm}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Condição de Pagamento","plural-entity":"Condições de Pagamento"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.condicaoList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),(_vm.showForm)?_c('div',{staticClass:"nb-card-inline-form mb-3"},[_c('condicao-form',{attrs:{"index":_vm.codcondicao,"crud":_vm.crud},on:{"closeform":_vm.closeForm}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.condicaoList),function(condicao){return _c('article',{key:condicao.codcondicao,staticClass:"nb-card"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!condicao.show),expression:"!condicao.show"}],staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(condicao.descricao))])]),_vm._v(" "),(condicao.codcondicao)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(condicao.codcondicao))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnDelete: true, btnEdit: true, btnEditLabel: 'Editar'},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(condicao)},"view":function($event){return _vm.handleEdit(condicao, true)},"delete":function($event){return _vm.handleDelete(condicao)}}})],1)]),_vm._v(" "),(condicao.show)?_c('div',{staticClass:"nb-card-inline-form"},[_c('condicao-form',{attrs:{"index":condicao.codcondicao,"crud":_vm.crud},on:{"closeform":_vm.closeForm}})],1):_vm._e()])})],2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-calendar-check-o",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1839);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1700397c", content, true, {});

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-6561127e]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-6561127e]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-6561127e]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-6561127e]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-6561127e]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-6561127e]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-6561127e]{flex:1;min-width:0}.nb-card-title-line[data-v-6561127e]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-6561127e]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-6561127e]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-6561127e]{color:#334155;font-weight:600}.nb-card-actions[data-v-6561127e]{flex:0 0 auto}.nb-card-details[data-v-6561127e]{display:grid;grid-template-columns:minmax(0,1fr);gap:12px;margin:12px 0 0 60px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-card-detail[data-v-6561127e]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-card-detail-label[data-v-6561127e]{color:#64748b;font-size:11px}.nb-card-detail>strong[data-v-6561127e]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}@media (max-width:767.98px){.nb-card-top[data-v-6561127e]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-6561127e]{align-self:flex-end}.nb-card-details[data-v-6561127e]{margin-left:0}}", ""]);

// exports


/***/ }),
/* 1840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_equipe_form_vue__ = __webpack_require__(662);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4403115e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_equipe_form_vue__ = __webpack_require__(1843);
function injectStyle (ssrContext) {
  __webpack_require__(1841)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_equipe_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4403115e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_equipe_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1842);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("13b70b5d", content, true, {});

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Equipe","plural-entity":"Equipe","crud":this.crud,"btn-delete":true},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.equipe.nome.validator),expression:"metadata.equipe.nome.validator"}],ref:"nome",attrs:{"type":"text","col":"6","metadata":_vm.metadata.equipe.nome,"case":"normal","name":"nome","v-errors":_vm.errors},model:{value:(_vm.equipe.nome),callback:function ($$v) {_vm.$set(_vm.equipe, "nome", $$v)},expression:"equipe.nome"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label-title',{staticClass:"nb-margin-bottom nb-margin-top",attrs:{"title":"Usuários da Equipe","icon":"fa-group"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select2","col":"6","id":"usuario","label":"Selecione os Usuários","select2":{entity: 'usuario', minlength: 0}},model:{value:(_vm.codusuario),callback:function ($$v) {_vm.codusuario=$$v},expression:"codusuario"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},_vm._l((_vm.equipeit),function(valor,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-8 col-6"},[(valor.responsavel=='S')?_c('i',{staticClass:"lbl fa fa-user-secret mr-2",staticStyle:{"font-size":"28px"}}):_c('i',{staticClass:"lbl fa fa-user mr-2",staticStyle:{"font-size":"28px"}}),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(valor.nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-button',{attrs:{"label":"","title":"Excluir Item","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteUsuario(index)}}}),_vm._v(" "),(valor.responsavel!='S')?_c('v-button',{attrs:{"label":"Marcar como responsável","title":"","icon":"fa-user-secret"},on:{"click":function($event){return _vm.handleDefineResponsavel(index)}}}):_c('v-button',{attrs:{"label":"Remover responsável","title":"","icon":""},on:{"click":function($event){return _vm.handleRemoveResponsavel(index)}}})],1)])])])}),0)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Equipe","plural-entity":"Equipes"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.equipeList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.equipeList),function(equipe){return _c('article',{key:equipe.codequipe,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(equipe.nome))])]),_vm._v(" "),(equipe.codequipe)?_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(equipe.codequipe))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: false, btnEdit: true, btnEditLabel: 'Editar'},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(equipe.codequipe)}}})],1)]),_vm._v(" "),(equipe.usuarios && equipe.usuarios.length)?_c('div',{staticClass:"nb-card-details"},[_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Membros da Equipe")]),_vm._v(" "),_c('strong',[_c('i',{staticClass:"fa fa-user-circle-o mr-1",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.usuariosEquipe(equipe.usuarios)))])])]):_vm._e()])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('equipe-form',{attrs:{"index":this.codequipe,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-users",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1846);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("43977b7c", content, true, {});

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1848);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("22b75360", content, true, {});

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Categoria Marketplace","plural-entity":"Categorias Marketplace","crud":this.crud,"btn-delete":false},on:{"closeform":_vm.closeForm,"delete":_vm.handleDelete,"save":_vm.handleSave}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"metadata":_vm.metadata.catmkt.codcatmkt,"type":"text","col":"2","disabled":true},model:{value:(_vm.catmkt.codcatmkt),callback:function ($$v) {_vm.$set(_vm.catmkt, "codcatmkt", $$v)},expression:"catmkt.codcatmkt"}}),_vm._v(" "),_c('div',{staticClass:"col mt-2 mb-5"},[_c('input-checkbox',{attrs:{"value-checked":"A","value-unchecked":"I","label":"Categoria Ativa"},model:{value:(_vm.catmkt.stcatmkt),callback:function ($$v) {_vm.$set(_vm.catmkt, "stcatmkt", $$v)},expression:"catmkt.stcatmkt"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.catmkt.altern.validator),expression:"metadata.catmkt.altern.validator"}],ref:"altern",attrs:{"type":"text","col":"4","metadata":_vm.metadata.catmkt.altern,"name":"altern","v-errors":_vm.errors},model:{value:(_vm.catmkt.altern),callback:function ($$v) {_vm.$set(_vm.catmkt, "altern", $$v)},expression:"catmkt.altern"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.catmkt.nome.validator),expression:"metadata.catmkt.nome.validator"}],ref:"nome",attrs:{"type":"text","col":"8","metadata":_vm.metadata.catmkt.nome,"name":"nome","v-errors":_vm.errors},model:{value:(_vm.catmkt.nome),callback:function ($$v) {_vm.$set(_vm.catmkt, "nome", $$v)},expression:"catmkt.nome"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.catmkt.marketplacecatmkt.validator),expression:"metadata.catmkt.marketplacecatmkt.validator"}],ref:"marketplacecatmkt",attrs:{"type":"select","col":"4","metadata":_vm.metadata.catmkt.marketplacecatmkt,"name":"marketplacecatmkt","v-errors":_vm.errors},model:{value:(_vm.catmkt.marketplacecatmkt),callback:function ($$v) {_vm.$set(_vm.catmkt, "marketplacecatmkt", $$v)},expression:"catmkt.marketplacecatmkt"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Categoria Marketplace","plural-entity":"Categorias Marketplace","title-search":"Pesquise pela descrição"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.catmktList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.catmktList),function(catmkt){return _c('div',{key:catmkt.codcatmkt,staticClass:"mainbox"},[(catmkt.stcatmkt=='A')?_c('div',{staticClass:"mark-green"}):_vm._e(),_vm._v(" "),(catmkt.stcatmkt=='I')?_c('div',{staticClass:"mark-red"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-2",staticStyle:{"float":"left"}},[_c('span',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.catmkt.codcatmkt.label)+" ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(catmkt.codcatmkt))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2",staticStyle:{"float":"left"}},[_c('span',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.catmkt.altern.label)+" ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(catmkt.altern))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-4",staticStyle:{"float":"left"}},[_c('span',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.catmkt.nome.label)+" ")]),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(catmkt.nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2",staticStyle:{"float":"left"}},[_c('span',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.catmkt.marketplacecatmkt.label)+" ")]),_vm._v(" "),(catmkt.marketplacecatmkt=='1')?_c('span',{staticClass:"badge badge-green mb-2 float-right"},[_vm._v("B2W")]):_vm._e(),_vm._v(" "),(catmkt.marketplacecatmkt=='2')?_c('span',{staticClass:"badge badge-orange mb-2 float-right"},[_vm._v("Mercado Livre")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(catmkt.codcatmkt)},"view":function($event){return _vm.handleEdit(catmkt.codcatmkt, true)}}})],1)])])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('catmkt-form',{attrs:{"index":this.codcatmkt,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isList ? 'd-flex col-12' : 'd-flex flex-column'},[_c('div',{class:_vm.isList ? 'col-2' : ''},[_c('tabs',{attrs:{"tabs":_vm.tabs,"tabindex":1,"isList":_vm.isList,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}})],1),_vm._v(" "),_c('div',{staticClass:"nb-margin-top"},[(_vm.tabEmpresa)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('filial-list')],1):_vm._e(),_vm._v(" "),(_vm.tabUsuarios)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('usuario-list')],1):_vm._e(),_vm._v(" "),(_vm.tabStatus)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('pdstatus-list')],1):_vm._e(),_vm._v(" "),(_vm.tabRegras)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('regraimp-list')],1):_vm._e(),_vm._v(" "),(_vm.tabFcp)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('regrafcp-list')],1):_vm._e(),_vm._v(" "),(_vm.tabEstado)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('estado-list')],1):_vm._e(),_vm._v(" "),(_vm.tabUnimed)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('unimed-list')],1):_vm._e(),_vm._v(" "),(_vm.tabNates)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('nates-list')],1):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_cobranca_vue__ = __webpack_require__(666);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e20537c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_cobranca_vue__ = __webpack_require__(1855);
function injectStyle (ssrContext) {
  __webpack_require__(1853)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_cobranca_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e20537c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_cobranca_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1854);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6d725c96", content, true, {});

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".total strong{font-size:20px}.table>tbody>tr>td{vertical-align:middle!important}", ""]);

// exports


/***/ }),
/* 1855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1 !important"}},[_c('Trap',[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-xl",staticStyle:{"width":"80%!important","overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body",staticStyle:{"height":"80vh!important","max-height":"100%","overflow-y":"auto"},attrs:{"id":"modalCobranca"}},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-10 col-10"},[_c('div',{staticClass:"lbl",staticStyle:{"font-size":"20px"}},[_c('strong',[_vm._v("Emissão de Boletos")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2 text-right"},[_c('v-button',{attrs:{"icon":"fa-close"},on:{"click":_vm.handleClose}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-12 col-12"},[(_vm.isFiltrado)?_c('v-button',{attrs:{"title":"Atualizar","icon":"fa-refresh"},on:{"click":_vm.loadData}}):_vm._e()],1)]),_vm._v(" "),(!_vm.isFiltrado)?_c('div',{staticClass:"mainbox mb-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('v-label',{attrs:{"label":"Período Vencimento"}}),_vm._v(" "),_c('input-month2',{attrs:{"p-month":_vm.filtro.periodoVencimento},on:{"change":_vm.loadData}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-label',{attrs:{"label":"Período Emissão"}}),_vm._v(" "),_c('input-month2',{attrs:{"p-month":_vm.filtro.periodoEmissao},on:{"change":_vm.loadData}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[_c('form-field',{attrs:{"label":"Cliente","col":"5","type":"select2","parent":"modalCobranca","select2":{ entity: 'cliente/', minlength: 0 }},model:{value:(_vm.filtro.codpart),callback:function ($$v) {_vm.$set(_vm.filtro, "codpart", $$v)},expression:"filtro.codpart"}}),_vm._v(" "),_c('form-field',{attrs:{"label":"Nr. Documento","col":"3","type":"text"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.loadData.apply(null, arguments)}},model:{value:(_vm.filtro.doc),callback:function ($$v) {_vm.$set(_vm.filtro, "doc", $$v)},expression:"filtro.doc"}}),_vm._v(" "),_c('div',{staticClass:"col-md-4 text-right pt-4"},[_c('v-button',{attrs:{"title":"Pesquisar","icon":"fa-search","label":"Pesquisar","nb-btdef":true},on:{"click":_vm.loadData}})],1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.titulosList && _vm.titulosList.length > 0)?_c('div',{staticClass:"col-md-12 col-12"},[_c('table',{staticClass:"table table-hover table-sm"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"5%"}},[(_vm.titulosList.length > 0)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isSelectAll),expression:"isSelectAll"}],attrs:{"type":"checkbox","title":"Selecionar todos"},domProps:{"checked":Array.isArray(_vm.isSelectAll)?_vm._i(_vm.isSelectAll,null)>-1:(_vm.isSelectAll)},on:{"change":function($event){var $$a=_vm.isSelectAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isSelectAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isSelectAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isSelectAll=$$c}}}})]):_vm._e()]),_vm._v(" "),_c('th',{staticStyle:{"width":"10%"}},[_vm._v("Nr Doc")]),_vm._v(" "),_c('th',{staticStyle:{"width":"10%"}},[_vm._v("Vencimento")]),_vm._v(" "),_c('th',{staticStyle:{"width":"10%"}},[_vm._v("Valor")]),_vm._v(" "),_c('th',{staticStyle:{"width":"30%"}},[_vm._v("Nome")]),_vm._v(" "),_c('th',{staticStyle:{"width":"10%"}},[_vm._v("Forma Pag")]),_vm._v(" "),_c('th',{staticStyle:{"width":"10%"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("Boleto")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.titulosList),function(item,index){return _c('tr',{key:index,staticClass:"align-middle"},[_c('td',[(item.enviarcobranca || (!item.enviarcobranca && !item.cancelarcobranca))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.enviarcobranca),expression:"item.enviarcobranca"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.enviarcobranca)?_vm._i(item.enviarcobranca,null)>-1:(item.enviarcobranca)},on:{"change":function($event){var $$a=item.enviarcobranca,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "enviarcobranca", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "enviarcobranca", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "enviarcobranca", $$c)}}}}):(item.cancelarcobranca)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.cancelarcobranca),expression:"item.cancelarcobranca"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.cancelarcobranca)?_vm._i(item.cancelarcobranca,null)>-1:(item.cancelarcobranca)},on:{"change":function($event){var $$a=item.cancelarcobranca,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "cancelarcobranca", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "cancelarcobranca", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "cancelarcobranca", $$c)}}}}):_vm._e()]),_vm._v(" "),_c('td',[_vm._v("\n                          "+_vm._s(item.doc)+"\n                          "),(item.parcela)?_c('span',[_vm._v(" / "+_vm._s(item.parcela))]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatData")(item.vencimento)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatValue")(item.vlr,2)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.nome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.formapag))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.stcobranca))]),_vm._v(" "),_c('td',[(item.boletopdf)?_c('v-button',{attrs:{"icon":"fa fa-barcode"},on:{"click":function($event){return _vm.handleDownloadBoleto(item)}}}):_vm._e(),_vm._v(" "),_c('v-button',{attrs:{"icon":"fa fa-edit"},on:{"click":function($event){return _vm.handleEdit(item)}}})],1)])}),0)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.errmessages && _vm.errmessages.length > 0)?_c('div',{staticClass:"col-md-12 col-12"},[_c('alert',{attrs:{"type":"error","title":"Erro na cobrança bancaria","messages":_vm.errmessages}})],1):_vm._e()]),_vm._v(" "),(_vm.showSuccess)?_c('warnings',{attrs:{"messages":['Cobrança enviada com sucesso! Em alguns instantes o boleto será liberado.']}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.showAccountSelection)?_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.codcta.validator),expression:"metadata.fin.codcta.validator"}],attrs:{"type":"select2","col":"12","metadata":_vm.metadata.fin.codcta,"name":"codcta","v-errors":_vm.errors},model:{value:(_vm.codcta),callback:function ($$v) {_vm.codcta=$$v},expression:"codcta"}})],1)]):_vm._e(),_vm._v(" "),(_vm.habiltaEnviarCobranca)?_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fin.codnatfin.validator),expression:"metadata.fin.codnatfin.validator"}],attrs:{"type":"select2","col":"12","metadata":_vm.metadataCodnatfin,"name":"codnatfin","v-errors":_vm.errors},model:{value:(_vm.codnatfin),callback:function ($$v) {_vm.codnatfin=$$v},expression:"codnatfin"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row pt-4 pb-4"},[_c('div',{staticClass:"col-md-6"},[(_vm.habiltaEnviarCobranca)?_c('v-button',{attrs:{"label":_vm.labelBotaoEnviar,"nb-btdef":true},on:{"click":_vm.handleEnviarCobranca}}):_vm._e(),_vm._v(" "),(_vm.habiltaCancelarCobranca)?_c('v-button',{staticClass:"mr-2",attrs:{"label":"Cancelar Cobrança","title":"Cancelar os títulos selecionados da cobrança","danger":true},on:{"click":_vm.handleConfirmaExcluirCobranca}}):_vm._e()],1)])],1)])])])],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showForm)?_c('financeiro-form',{attrs:{"index":this.codfin,"tipo":_vm.tipofin,"crud":this.crud},on:{"closeform":_vm.closeEdit}}):_vm._e()],1),_vm._v(" "),(_vm.confirmaExcluirCobranca)?_c('md-message',{attrs:{"message":_vm.messageExcluir,"title":_vm.titleExcluir},on:{"confirm":function($event){return _vm.handleExcluirCobranca()},"close":function($event){return _vm.handleCloseMessage()}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_cobranca_config_vue__ = __webpack_require__(667);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b37b5da_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_cobranca_config_vue__ = __webpack_require__(1859);
function injectStyle (ssrContext) {
  __webpack_require__(1857)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_cobranca_config_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b37b5da_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_cobranca_config_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1858);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6cc4e5c1", content, true, {});

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-modal-mask{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);display:block;overflow-y:auto;transition:opacity .3s ease}", ""]);

// exports


/***/ }),
/* 1859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._m(0),_vm._v(" "),_c('div',[(_vm.contasConfiguradas.length)?_c('div',[_vm._m(1),_vm._v(" "),_vm._l((_vm.contasConfiguradas),function(conta){return _c('div',{key:conta.codcta,staticClass:"mainbox"},[_c('div',{staticClass:"mark-gray"}),_vm._v(" "),_c('div',{staticClass:"box p-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('img',{staticStyle:{"padding":"10px","height":"55px"},attrs:{"src":conta.banco_url}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Banco")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(conta.nome))]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Descrição da Conta")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(conta.descricao))]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3 ml-auto d-flex"},[_c('v-button',{attrs:{"label":"Editar"},on:{"click":function($event){return _vm.handleEdit(conta)}}})],1)])])])})],2):_vm._e(),_vm._v(" "),(_vm.contasExistentes.length)?_c('div',[_vm._m(2),_vm._v(" "),_vm._l((_vm.contasExistentes),function(conta){return _c('div',{key:conta.codcta,staticClass:"mainbox"},[_c('div',{staticClass:"mark-gray"}),_vm._v(" "),_c('div',{staticClass:"box p-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('img',{staticStyle:{"padding":"10px","height":"55px"},attrs:{"src":conta.banco_url}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Banco")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(conta.banco))]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Descrição")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(conta.descricao))]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Agência / Conta")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(conta.agencia)+" / "+_vm._s(conta.conta))]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3 ml-auto d-flex"},[_c('v-button',{attrs:{"label":"Configurar"},on:{"click":function($event){return _vm.handleNovoBanco(conta, true)}}})],1)])])])})],2):_vm._e(),_vm._v(" "),(_vm.listBancos.length)?_c('div',[_vm._m(3),_vm._v(" "),_vm._l((_vm.listBancos),function(banco){return _c('div',{key:banco.banco,staticClass:"mainbox"},[_c('div',{staticClass:"mark-gray"}),_vm._v(" "),_c('div',{staticClass:"box p-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('img',{staticStyle:{"padding":"10px","height":"55px"},attrs:{"src":banco.banco_url}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Banco")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(banco.banco))]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Nome do Banco")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(banco.nome))]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3 ml-auto d-flex"},[_c('v-button',{attrs:{"label":"Configurar"},on:{"click":function($event){return _vm.handleNovoBanco(banco, false)}}})],1)])])])})],2):_vm._e(),_vm._v(" "),(_vm.contasConfiguradas.length == 0 && _vm.contasExistentes.length == 0 && _vm.listBancos.length == 0)?_c('div',{staticClass:"row m-3"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('label-title',{attrs:{"title":"Nenhuma informação disponível"}})],1)]):_vm._e()])]),_vm._v(" "),(_vm.showForm)?_c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block"}},[_c('Trap',[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Configurar Cobrança Bancária")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.handleCloseEditing}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"max-height":"70vh","overflow-y":"auto"}},[_c('div',{staticClass:"row p-3"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.codfil.validator),expression:"metadata.cta.codfil.validator"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.cta.codfil,"name":"codfil","v-errors":_vm.errors},model:{value:(_vm.cta.codfil),callback:function ($$v) {_vm.$set(_vm.cta, "codfil", $$v)},expression:"cta.codfil"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.descricao.validator),expression:"metadata.cta.descricao.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.cta.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.cta.descricao),callback:function ($$v) {_vm.$set(_vm.cta, "descricao", $$v)},expression:"cta.descricao"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.ctaValidate && _vm.ctaValidate.agencia)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.agencia.validate),expression:"ctaValidate.agencia.validate"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.cta.agencia,"name":"agencia","v-errors":_vm.errors},model:{value:(_vm.cta.agencia),callback:function ($$v) {_vm.$set(_vm.cta, "agencia", $$v)},expression:"cta.agencia"}}):_vm._e(),_vm._v(" "),(_vm.ctaValidate && _vm.ctaValidate.conta)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.conta.validate),expression:"ctaValidate.conta.validate"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.cta.conta,"name":"conta","v-errors":_vm.errors},model:{value:(_vm.cta.conta),callback:function ($$v) {_vm.$set(_vm.cta, "conta", $$v)},expression:"cta.conta"}}):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.digito.validator),expression:"metadata.cta.digito.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.cta.digito,"name":"digito","v-errors":_vm.errors},model:{value:(_vm.cta.digito),callback:function ($$v) {_vm.$set(_vm.cta, "digito", $$v)},expression:"cta.digito"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.ctaValidate && _vm.ctaValidate.nrinscricao && _vm.ctaValidate.nrinscricao.exibe)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.nrinscricao.validate),expression:"ctaValidate.nrinscricao.validate"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.cta.nrinscricao,"name":"nrinscricao","v-errors":_vm.errors},model:{value:(_vm.cta.nrinscricao),callback:function ($$v) {_vm.$set(_vm.cta, "nrinscricao", $$v)},expression:"cta.nrinscricao"}}):_vm._e(),_vm._v(" "),(_vm.ctaValidate && _vm.ctaValidate.convenio && _vm.ctaValidate.convenio.exibe)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.convenio.validate),expression:"ctaValidate.convenio.validate"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.cta.convenio,"name":"convenio","v-errors":_vm.errors},model:{value:(_vm.cta.convenio),callback:function ($$v) {_vm.$set(_vm.cta, "convenio", $$v)},expression:"cta.convenio"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.ctaValidate && _vm.ctaValidate.clientid && _vm.ctaValidate.clientid.exibe)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.clientid.validate),expression:"ctaValidate.clientid.validate"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.cta.clientid,"name":"clientid","v-errors":_vm.errors},model:{value:(_vm.cta.clientid),callback:function ($$v) {_vm.$set(_vm.cta, "clientid", $$v)},expression:"cta.clientid"}}):_vm._e(),_vm._v(" "),(_vm.ctaValidate && _vm.ctaValidate.clientsecret && _vm.ctaValidate.clientsecret.exibe)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.ctaValidate.clientsecret.validate),expression:"ctaValidate.clientsecret.validate"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.cta.clientsecret,"name":"clientsecret","v-errors":_vm.errors},model:{value:(_vm.cta.clientsecret),callback:function ($$v) {_vm.$set(_vm.cta, "clientsecret", $$v)},expression:"cta.clientsecret"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.pmulta.validator),expression:"metadata.cta.pmulta.validator"}],attrs:{"type":"value","col":"6","metadata":_vm.metadata.cta.pmulta,"name":"pmulta","v-errors":_vm.errors},model:{value:(_vm.cta.pmulta),callback:function ($$v) {_vm.$set(_vm.cta, "pmulta", $$v)},expression:"cta.pmulta"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.pmora.validator),expression:"metadata.cta.pmora.validator"}],attrs:{"type":"value","col":"6","metadata":_vm.metadata.cta.pmora,"name":"pmora","v-errors":_vm.errors},model:{value:(_vm.cta.pmora),callback:function ($$v) {_vm.$set(_vm.cta, "pmora", $$v)},expression:"cta.pmora"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.negativacliente.validator),expression:"metadata.cta.negativacliente.validator"}],attrs:{"type":"select","col":"6","metadata":_vm.metadata.cta.negativacliente,"name":"negativacliente","v-errors":_vm.errors},model:{value:(_vm.cta.negativacliente),callback:function ($$v) {_vm.$set(_vm.cta, "negativacliente", $$v)},expression:"cta.negativacliente"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.cta.tipocobranca.validator),expression:"metadata.cta.tipocobranca.validator"}],attrs:{"type":"select","col":"6","metadata":_vm.metadata.cta.tipocobranca,"name":"tipocobranca","v-errors":_vm.errors},model:{value:(_vm.cta.tipocobranca),callback:function ($$v) {_vm.$set(_vm.cta, "tipocobranca", $$v)},expression:"cta.tipocobranca"}})],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.handleCloseEditing}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Confirmar","success":true},on:{"click":_vm.handleSave}})],1)])])])],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-12 col-12 float-left"},[_c('h4',{staticClass:"def-title"},[_vm._v("Configurar Cobrança Bancaria")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("Contas com Cobrança Ativa")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row my-4"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("Suas Contas Bancárias (Para Ativar Cobrança)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row my-4"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("Outros Bancos (Novo Cadastro)")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_agenda_list_vue__ = __webpack_require__(668);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e4ba2c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_agenda_list_vue__ = __webpack_require__(1866);
function injectStyle (ssrContext) {
  __webpack_require__(1861)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_agenda_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e4ba2c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_agenda_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1862);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("663cdacd", content, true, {});

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1864);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3a4b5fae", content, true, {});

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"500px","max-width":"100%"},attrs:{"id":"mymodal"}},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.agenda.titulo.validator),expression:"metadata.agenda.titulo.validator"}],attrs:{"type":"text","col":"12","metadata":_vm.metadata.agenda.titulo,"disabled":_vm.isView,"name":"titulo","v-errors":_vm.errors},model:{value:(_vm.agenda.titulo),callback:function ($$v) {_vm.$set(_vm.agenda, "titulo", $$v)},expression:"agenda.titulo"}})],1),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-3 col-12 mb-2"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agenda.tpagenda),expression:"agenda.tpagenda"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio0","value":"L","disabled":_vm.isView},domProps:{"checked":_vm._q(_vm.agenda.tpagenda,"L")},on:{"change":function($event){return _vm.$set(_vm.agenda, "tpagenda", "L")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label lbl-edit",attrs:{"for":"customRadio0"}},[_vm._v("Ligação")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12 mb-2"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agenda.tpagenda),expression:"agenda.tpagenda"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio1","value":"V","disabled":_vm.isView},domProps:{"checked":_vm._q(_vm.agenda.tpagenda,"V")},on:{"change":function($event){return _vm.$set(_vm.agenda, "tpagenda", "V")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label lbl-edit",attrs:{"for":"customRadio1"}},[_vm._v("Visita")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12 mb-2"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agenda.tpagenda),expression:"agenda.tpagenda"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio2","value":"A","disabled":_vm.isView},domProps:{"checked":_vm._q(_vm.agenda.tpagenda,"A")},on:{"change":function($event){return _vm.$set(_vm.agenda, "tpagenda", "A")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label lbl-edit",attrs:{"for":"customRadio2"}},[_vm._v("Atividade")])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.agenda.dataagendada.validator),expression:"metadata.agenda.dataagendada.validator"}],attrs:{"type":"date","col":"4","metadata":_vm.metadata.agenda.dataagendada,"disabled":_vm.isView,"name":"dataagendada","v-errors":_vm.errors},model:{value:(_vm.agenda.dataagendada),callback:function ($$v) {_vm.$set(_vm.agenda, "dataagendada", $$v)},expression:"agenda.dataagendada"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.agenda.horaagendada.validator),expression:"metadata.agenda.horaagendada.validator"}],attrs:{"type":"hora","col":"4","metadata":_vm.metadata.agenda.horaagendada,"disabled":_vm.isView,"name":"horaagendada","v-errors":_vm.errors},model:{value:(_vm.agenda.horaagendada),callback:function ($$v) {_vm.$set(_vm.agenda, "horaagendada", $$v)},expression:"agenda.horaagendada"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.agenda.texto.validator),expression:"metadata.agenda.texto.validator"}],attrs:{"type":"memo","col":"12","metadata":_vm.metadata.agenda.texto,"disabled":_vm.isView,"name":"texto","v-errors":_vm.errors},model:{value:(_vm.agenda.texto),callback:function ($$v) {_vm.$set(_vm.agenda, "texto", $$v)},expression:"agenda.texto"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.agenda.codusuario.validator),expression:"metadata.agenda.codusuario.validator"}],ref:"usuario",attrs:{"type":"select2static","col":"12","metadata":_vm.metadata.agenda.codusuario,"disabled":_vm.isView,"name":"codusuario","v-errors":_vm.errors,"select-options":_vm.usuarioList},model:{value:(_vm.agenda.codusuario),callback:function ($$v) {_vm.$set(_vm.agenda, "codusuario", $$v)},expression:"agenda.codusuario"}}),_vm._v(" "),(_vm.habilitaPartricipante)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.agenda.codpart.validator),expression:"metadata.agenda.codpart.validator"}],attrs:{"type":"select2","col":"12","metadata":_vm.metadata.agenda.codpart,"disabled":_vm.isView,"name":"codpart","v-errors":_vm.errors},model:{value:(_vm.agenda.codpart),callback:function ($$v) {_vm.$set(_vm.agenda, "codpart", $$v)},expression:"agenda.codpart"}}):_vm._e()],1),_vm._v(" "),(!_vm.agenda.codlead)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.agenda.codpessoa.validator),expression:"metadata.agenda.codpessoa.validator"}],attrs:{"type":"select2","col":"12","metadata":_vm.metadata.agenda.codpessoa,"disabled":_vm.isView,"name":"codpessoa","v-errors":_vm.errors},model:{value:(_vm.agenda.codpessoa),callback:function ($$v) {_vm.$set(_vm.agenda, "codpessoa", $$v)},expression:"agenda.codpessoa"}})],1):_vm._e(),_vm._v(" "),(!_vm.agenda.codlead)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.agenda.codorg.validator),expression:"metadata.agenda.codorg.validator"}],attrs:{"type":"select2","col":"12","metadata":_vm.metadata.agenda.codorg,"disabled":_vm.isView,"name":"codorg","v-errors":_vm.errors},model:{value:(_vm.agenda.codorg),callback:function ($$v) {_vm.$set(_vm.agenda, "codorg", $$v)},expression:"agenda.codorg"}})],1):_vm._e(),_vm._v(" "),(_vm.agenda.codlead)?_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-12"},[_c('v-label',{attrs:{"label":"Vinculado ao Lead"}}),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(" "+_vm._s(_vm.lead.titulo)+" ")]),_vm._v(" "),(_vm.lead.pessoanome)?_c('span',{staticClass:"data-list w-100"},[_c('i',{staticClass:"fa fa-user mr-2",staticStyle:{"width":"20px"}}),_vm._v(" "+_vm._s(_vm.lead.pessoanome)+" ")]):_vm._e(),_vm._v(" "),(_vm.lead.orgnome)?_c('span',{staticClass:"data-list w-100"},[_c('i',{staticClass:"fa fa-university mr-2",staticStyle:{"width":"20px"}}),_vm._v(" "+_vm._s(_vm.lead.orgnome)+" ")]):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('v-label',{attrs:{"label":"Convidados","metadataField":_vm.metadata.agenda.convidados}}),_vm._v(" "),_c('input-email-list',{ref:"convidados",attrs:{"emails":_vm.agenda.convidados,"url":"crm/find/pessoa/email?text=","disabled":_vm.isView}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-5 mb-5"},[_c('input-checkbox',{attrs:{"value-checked":"S","value-unchecked":"N","label":"Marcar como atividade executada","disabled":_vm.isView},model:{value:(_vm.agenda.concluida),callback:function ($$v) {_vm.$set(_vm.agenda, "concluida", $$v)},expression:"agenda.concluida"}})],1),_vm._v(" "),(_vm.agenda.concluida=='S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.agenda.textoconclusao.validator),expression:"metadata.agenda.textoconclusao.validator"}],attrs:{"type":"memo","col":"12","metadata":_vm.metadata.agenda.textoconclusao,"disabled":_vm.isView,"name":"textoconclusao","v-errors":_vm.errors},model:{value:(_vm.agenda.textoconclusao),callback:function ($$v) {_vm.$set(_vm.agenda, "textoconclusao", $$v)},expression:"agenda.textoconclusao"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[(!_vm.isView)?_c('v-button',{ref:"btnConfirm",attrs:{"label":"Salvar","title":"","nb-btdef":true},on:{"click":_vm.handleSalvar}}):_vm._e(),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeForm}}),_vm._v(" "),(_vm.buttonDelete)?_c('v-button',{attrs:{"label":"","title":"Excluir","icon":"fa-trash"},on:{"click":function($event){return _vm.confirmMessage('del')}}}):_vm._e()],1)])]),_vm._v(" "),(_vm.modalDelete)?_c('md-message',{attrs:{"code":"delete"},on:{"confirm":function($event){return _vm.handleDelete()},"close":function($event){return _vm.closeModal()}}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-list',{attrs:{"refresh-button":true,"new-button":false,"single-entity":"Agenda","plural-entity":"Agenda"},on:{"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"mb-2"}),_vm._v(" "),_c('div',{attrs:{"id":"list"}},[_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row align-items-center"},[_c('form-field',{attrs:{"type":"select","col":"6","select-options":_vm.usuarioList,"placeholder":"Todos os usuários"},model:{value:(_vm.codusuario),callback:function ($$v) {_vm.codusuario=$$v},expression:"codusuario"}}),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('input-month',{attrs:{"p-month":_vm.monthFilter},on:{"monthChange":_vm.handleMonthChange}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6 text-right"},[_c('v-button',{attrs:{"label":"Agenda","nb-btdef":true,"icon":"fa-plus"},on:{"click":_vm.handleNew}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 mt-2"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Mostrar tarefas concluídas"},model:{value:(_vm.showConcluidas),callback:function ($$v) {_vm.showConcluidas=$$v},expression:"showConcluidas"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"default-container mt-2"},[(_vm.agendaList.length == 0)?_c('div',{staticClass:"no-content mb-4"},[_vm._v("Nenhuma atividade foi encontrada")]):_vm._e(),_vm._v(" "),_vm._l((_vm.agendaList),function(item,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-auto text-center"},[_c('div',{staticClass:"list-icon"},[(item.tpagenda == 'L')?_c('i',{staticClass:"fa fa-phone"}):_vm._e(),_vm._v(" "),(item.tpagenda == 'V')?_c('i',{staticClass:"fa fa-car"}):_vm._e(),_vm._v(" "),(item.tpagenda == 'A')?_c('i',{staticClass:"fa fa-tasks"}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-8"},[_c('div',{staticClass:"row"},[(item.titulo)?_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"data-list"},[_c('strong',[_vm._v(_vm._s(item.titulo))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"lbl-list pr-3",class:{'atrasado': item.dias_atraso > 0 && item.concluida!='S' }},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataExtenso")(item.dataagendada))+"  "+_vm._s(item.horaagendada)+" ")]),_vm._v(" "),_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(item.usuario_nome))]),_vm._v(" "),(item.concluida=='S')?_c('span',{staticClass:"badge badge-green mb-2 float-right"},[_vm._v("Atividade Concluída")]):_vm._e()])]),_vm._v(" "),(item.ende)?_c('div',{staticClass:"row col"},[_c('span',{staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-location-arrow pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(item.ende)+" "+_vm._s(item.endenr))]),_vm._v(" "),(item.bairro)?_c('span',{staticClass:"lbl-list"},[_vm._v("- "+_vm._s(item.bairro))]):_vm._e(),_vm._v(" "),(item.nomemun)?_c('span',{staticClass:"lbl-list"},[_vm._v("- "+_vm._s(item.nomemun))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_vm._v("- "+_vm._s(item.uf))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl-list w-100"},[_vm._v(_vm._s(item.texto))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(item.pessoa_nome)?_c('a',{staticClass:"data-list mr-2",attrs:{"href":'#/crm/pessoa/'+item.codpessoa,"data-toggle":"tooltip","data-placement":"top","title":'Atividade vinculada à pessoa ' + item.pessoa_nome}},[_c('i',{staticClass:"fa fa-user mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(item.pessoa_nome))]):_vm._e(),_vm._v(" "),(item.org_nome)?_c('a',{staticClass:"data-list mr-2",attrs:{"href":'#/crm/organizacao/'+item.codorg,"data-toggle":"tooltip","data-placement":"top","title":'Atividade vinculada à organização ' + item.org_nome}},[_c('i',{staticClass:"fa fa-university mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(item.org_nome))]):_vm._e(),_vm._v(" "),(item.negocio_titulo)?_c('a',{staticClass:"data-list mr-2",attrs:{"href":'#/crm/negocio/'+item.codnegocio,"data-toggle":"tooltip","data-placement":"top","title":'Atividade vinculada ao negócio ' + item.negocio_titulo}},[_c('i',{staticClass:"fa fa-dollar mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(item.negocio_titulo))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('v-button',{staticClass:"float-right",attrs:{"label":"","icon":"fa-pencil"},on:{"click":function($event){return _vm.handleEdit(item.codagenda)}}})],1)])])])})],2)]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showForm)?_c('agenda-form',{attrs:{"index":_vm.codagenda,"crud":_vm.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fv_cliente_list_vue__ = __webpack_require__(670);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebe3acf4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fv_cliente_list_vue__ = __webpack_require__(1870);
function injectStyle (ssrContext) {
  __webpack_require__(1868)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fv_cliente_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebe3acf4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fv_cliente_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1869);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("411cd162", content, true, {});

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"grid"}},[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":true,"single-entity":"Cliente","plural-entity":"Clientes","moreActions":_vm.moreActionsBarList,"title-search":"Pesquise pelo nome, nome fantasia, código, cnpj ou cpf"},on:{"action":_vm.handleAction,"search":_vm.search,"new":_vm.incluirPart,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container nb-margin-top"},[(_vm.partList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.partList),function(part){return _c('div',{key:part.codpart,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9 col-10"},[_c('span',{staticClass:"lbl-title-produto",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.handlePainel(part.codpart)}}},[_vm._v(_vm._s(part.nome))]),_vm._v(" "),_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(part.cnpjcpf)))]),_vm._v(" "),(part.stpart=='I')?_c('span',{staticClass:"badge badge-yellow"},[_vm._v(_vm._s(_vm._f("getTextOption")(part.stpart,_vm.metadata.part.stpart)))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(part.fone1)?_c('span',{staticClass:"data-list-sm pr-3"},[_c('i',{staticClass:"fa fa-phone pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm._f("formatFone")(part.fone1)))]):_vm._e(),_vm._v(" "),(part.fone2)?_c('span',{staticClass:"data-list-sm pr-3"},[_c('i',{staticClass:"fa fa-phone pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm._f("formatFone")(part.fone2)))]):_vm._e(),_vm._v(" "),(part.fone3)?_c('span',{staticClass:"data-list-sm pr-3"},[_c('i',{staticClass:"fa fa-phone pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm._f("formatFone")(part.fone3)))]):_vm._e(),_vm._v(" "),(part.email)?_c('span',{staticClass:"data-list-sm pr-3"},[_c('i',{staticClass:"fa fa-envelope pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(part.email))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-2"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: false, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.editPart(part.codpart)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-6"},[_c('span',{staticClass:"data-list-sm w-100"},[_vm._v(_vm._s(part.fantasia))]),_vm._v(" "),(part.nomemun)?_c('span',{staticClass:"data-list-sm pr-3"},[_c('i',{staticClass:"fa fa-location-arrow pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(part.nomemun)+" "+_vm._s(part.uf))]):_vm._e()]),_vm._v(" "),(_vm.controleLimiteCredito)?_c('div',{staticClass:"col-md-3 col-3"},[_c('div',{staticClass:"w-100"},[_c('label',{staticClass:"lbl-list"},[_vm._v(_vm._s(_vm.metadata.part.stcred.label))]),_vm._v(" "),_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("getTextOption")(part.stcred,_vm.metadata.part.stcred)))])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('label',{staticClass:"lbl-list"},[_vm._v(_vm._s(_vm.metadata.part.limcred.label))]),_vm._v(" "),_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("formatValue")(part.limcred,2)))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-3"},[(part.data_ultima_compra)?_c('label',{staticClass:"lbl-list"},[_vm._v("Última Compra Em")]):_vm._e(),_vm._v(" "),(part.data_ultima_compra)?_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("formatData")(part.data_ultima_compra)))]):_vm._e(),_vm._v(" "),(part.total_pedidos_aberto)?_c('label',{staticClass:"lbl-list"},[_vm._v("Pedidos Abertos")]):_vm._e(),_vm._v(" "),(part.total_pedidos_aberto)?_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("formatValue")(part.total_pedidos_aberto,2)))]):_vm._e()])])])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"800px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('customer-form',{attrs:{"crud":_vm.crud,"index":_vm.codpart,"forcaVendas":true},on:{"closeform":_vm.closeForm}})],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fv_pedido_list_vue__ = __webpack_require__(671);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3328c985_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fv_pedido_list_vue__ = __webpack_require__(1882);
function injectStyle (ssrContext) {
  __webpack_require__(1872)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3328c985"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fv_pedido_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3328c985_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fv_pedido_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1873);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2ab931b9", content, true, {});

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".mobile-device[data-v-3328c985]{display:block}.other-device[data-v-3328c985]{display:none}@media (min-width:768px){.mobile-device[data-v-3328c985]{display:none}.other-device[data-v-3328c985]{display:block}}", ""]);

// exports


/***/ }),
/* 1874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_status_vue__ = __webpack_require__(672);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_73444b60_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_status_vue__ = __webpack_require__(1877);
function injectStyle (ssrContext) {
  __webpack_require__(1875)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_status_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_73444b60_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_status_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1876);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("34fbd22a", content, true, {});

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".status-popover{z-index:1051;margin-top:3px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;position:absolute;padding:10px;min-width:200px;list-style:none;background-color:#fff;border:1px solid #00000033;box-shadow:0 5px 10px #00000033;background-clip:padding-box}", ""]);

// exports


/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-popover",staticStyle:{"position":"absolute","width":"350px","top":"15px","left":"65px","padding":"15px"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{ref:"status",attrs:{"type":"select2","col":"12","select2":{entity: 'pdstatus', minlength: 0}},model:{value:(_vm.pedv.codstatus),callback:function ($$v) {_vm.$set(_vm.pedv, "codstatus", $$v)},expression:"pedv.codstatus"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mt-3 d-flex"},[_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.closeForm}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSave}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12"},[_vm._v("\n            Selecione o status\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_status_share_vue__ = __webpack_require__(673);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_256d5158_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_status_share_vue__ = __webpack_require__(1881);
function injectStyle (ssrContext) {
  __webpack_require__(1879)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_pedido_status_share_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_256d5158_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_pedido_status_share_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1880);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("53d19a7a", content, true, {});

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".status-popover{z-index:1051;margin-top:3px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;position:absolute;padding:10px;min-width:200px;list-style:none;background-color:#fff;border:1px solid #00000033;box-shadow:0 5px 10px #00000033;background-clip:padding-box}", ""]);

// exports


/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-popover",staticStyle:{"position":"absolute","width":"350px","top":"15px","left":"65px","padding":"15px"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mt-3 d-flex flex-wrap",staticStyle:{"gap":"8px"}},[(_vm.pedv.ecommerce == 'S')?_c('v-button',{attrs:{"label":"Exibir Link","success":true,"icon":"fa-external-link"},on:{"click":function($event){return _vm.handleLink('link')}}}):_vm._e(),_vm._v(" "),_c('v-button',{attrs:{"label":"WhatsApp","success":true,"icon":"fa-whatsapp"},on:{"click":function($event){return _vm.handleLink('whats')}}}),_vm._v(" "),(_vm.pedv.ecommerce == 'S')?_c('v-button',{attrs:{"label":"E-mail","success":true,"icon":"fa-envelope"},on:{"click":function($event){return _vm.handleLink('email')}}}):_vm._e(),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.closeForm}})],1)]),_vm._v(" "),(_vm.MESSAGE)?_c('md-message',{attrs:{"title":"Link de status do Pedido","message":_vm.link},on:{"close":function($event){return _vm.handleCloseMessage()},"confirm":function($event){return _vm.handleConfirmMessage()}}}):_vm._e(),_vm._v(" "),(_vm.showFormEmail)?_c('email-form',{attrs:{"index":_vm.pedv.codpedv,"tipo":"PEDV","title":"Envio de Pedido"},on:{"closeform":_vm.closeFormEmail,"send":_vm.handleSendEmail}}):_vm._e(),_vm._v(" "),(_vm.showModalNumber)?_c('fones-part-share',{attrs:{"codpart":_vm.pedv.codpart},on:{"closeform":_vm.handleEnviaLinkWhats}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12"},[_vm._v("\n            Selecione a opção de compartilhamento\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"filter-month":true,"single-entity":"Orçamento/Venda","plural-entity":"Orçamentos/Vendas","month-filter":_vm.monthFilter,"title-search":"Pesquise pelo número ou nome do cliente ou cnpj/cpf"},on:{"search":_vm.changeFiltroTexto,"new":_vm.handleNovoPedido,"refresh":_vm.loadData,"filter":_vm.changeFiltroMes}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('pedido-filtro',{attrs:{"filter-tipos":true,"filter-equipes":true,"filter-usuarios":true,"filter-status":true,"filter-frete":true,"params":_vm.paramsFiltro,"in-use":_vm.usingFiltros,"query":_vm.query},on:{"change":_vm.changeFiltros,"cancel":_vm.changeFiltros}}),_vm._v(" "),_c('filter-list',{attrs:{"params":_vm.paramFilterList},on:{"select":_vm.handleFilterList}}),_vm._v(" "),_c('div',{staticClass:"default-container p-0"},[(_vm.pedvList.length == 0)?_c('alert',{attrs:{"type":"warning","text":_vm.notFoundMsg()}}):_vm._e(),_vm._v(" "),_vm._l((_vm.pedvList),function(item){return _c('div',{key:item.codpedv,staticClass:"w-100",staticStyle:{"margin":"5px 0 5px","border-bottom":"1px solid #eee"}},[_c('div',{staticClass:"row p-3"},[_c('div',{staticClass:"col-md-7 d-none d-md-block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[(item.tppedv=='P')?_c('span',{staticClass:"lbl-list"},[_vm._v(" Pedido ")]):_vm._e(),_vm._v(" "),(item.tppedv=='P')?_c('span',{staticClass:"lbl-title-produto",attrs:{"title":"Número do Pedido"}},[_vm._v(" #"+_vm._s(item.npedido))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_vm._v(" Orçamento ")]),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto",attrs:{"title":"Número do Orçamento"}},[_vm._v(" #"+_vm._s(item.ncotacao))]),_vm._v(" "),_c('span',{staticClass:"lbl-list px-3"},[_c('i',{staticClass:"fa fa-user mr-2"}),_vm._v(" "+_vm._s(item.nome_usuario)+" ")]),_vm._v(" "),_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataExtenso")(item.data)))]),_vm._v(" "),(item.dtvalidade && item.tppedv=='O' )?_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v("Validade "+_vm._s(_vm._f("formatDataExtenso")(item.dtvalidade)))]):_vm._e(),_vm._v(" "),(_vm.orcamentoVencido(item))?_c('span',{staticClass:"badge badge-red mr-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Orçamento com data de validade vencida"}},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v("Vencido")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(item.nome))]),_vm._v(" "),_c('span',{staticClass:"data-list-sm w-100"},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(item.cnpjcpf))+" - "+_vm._s(item.bairro)+" - "+_vm._s(item.uf))]),_vm._v(" "),(item.fone1)?_c('span',{staticClass:"data-list-sm"},[_c('i',{staticClass:"fa fa-phone",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatFone")(item.fone1))+" ")]):_vm._e(),_vm._v(" "),(item.email)?_c('span',{staticClass:"data-list-sm"},[_c('i',{staticClass:"fa fa-envelope",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.email)+" ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('span',{staticClass:"data-list-sm"},[_vm._v("R$ "),_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(item.totger,2)))])])]),_vm._v(" "),(item.negocio_titulo)?_c('div',{staticClass:"col-12 other-device"},[_c('a',{staticClass:"data-list mr-2",attrs:{"href":'#/crm/negocio/'+item.codnegocio,"data-toggle":"tooltip","data-placement":"top","title":'Vinculado ao negócio ' + item.negocio_titulo}},[_c('i',{staticClass:"fa fa-dollar mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(item.negocio_titulo))])]):_vm._e(),_vm._v(" "),(item.datanfsync)?_c('div',{staticClass:"col-12 other-device"},[_c('label',{staticClass:"lbl-edit"},[_vm._v("Faturado em")]),_vm._v(" "),_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("formatData")(item.datanfsync)))]),_vm._v(" "),_c('label',{staticClass:"lbl-edit"},[_vm._v("Nota Fiscal")]),_vm._v(" "),_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(item.nfsync))]),_vm._v(" "),(item.chavenfsync)?_c('label',{staticClass:"lbl-edit"},[_vm._v("Chave")]):_vm._e(),_vm._v(" "),(item.chavenfsync)?_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(item.chavenfsync))]):_vm._e()]):_vm._e(),_vm._v(" "),(item.comissao && item.comissao.length > 0)?_c('div',{staticClass:"col-12 other-device"},[_c('label',{staticClass:"lbl-edit"},[_vm._v("Base Comissão")]),_vm._v(" "),_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("formatValue")(item.comissao[0].bcomi,2)))]),_vm._v(" "),_c('label',{staticClass:"lbl-edit"},[_vm._v("% Comissão")]),_vm._v(" "),_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("formatValue")(item.comissao[0].pcomi,2)))]),_vm._v(" "),_c('label',{staticClass:"lbl-edit"},[_vm._v("Valor Comissão")]),_vm._v(" "),_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("formatValue")(item.comissao[0].vcomi,2)))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 d-md-block d-none"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mb-2 text-right"},[(item.data_leitura)?_c('span',{staticClass:"badge badge-yellow ml-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":'Leitura efetuada em ' + item.data_leitura}},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.appLoja && item.tppedv == 'P' && item.stfraud == '3')?_c('span',{staticClass:"badge badge-error mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Reprovado Clearsale ")]):_vm._e(),_vm._v(" "),(_vm.appLoja && item.tppedv == 'P' && item.stpedv != 'C' && item.stfraud == '2')?_c('span',{staticClass:"badge badge-success mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Clearsale ")]):_vm._e(),_vm._v(" "),(_vm.appLoja && item.tppedv == 'P' && item.stpedv != 'C' && item.cieloidsuperlink && item.vendarecebida != 'S' && item.vendarecebida != 'N')?_c('span',{staticClass:"badge badge-warning mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Aguardando Pagamento Online ")]):_vm._e(),_vm._v(" "),(_vm.appLoja && item.tppedv == 'P' && item.cieloidsuperlink && item.vendarecebida == 'N')?_c('span',{staticClass:"badge badge-warning mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Pagamento Não realizado ")]):_vm._e(),_vm._v(" "),(_vm.appLoja && item.tppedv == 'P' && item.vendarecebida == 'S')?_c('span',{staticClass:"badge badge-success mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Pagamento Efetuado ")]):_vm._e(),_vm._v(" "),(item.ecommerce == 'S')?_c('span',{staticClass:"badge badge-warning"},[_c('i',{staticClass:"fa fa-shopping-basket"})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"badge",class:_vm.statusColor(item.stpedv, item.tppedv)},[_vm._v(_vm._s(_vm.textST(item)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 align-items-right"},[_c('v-button',{staticClass:"float-right",attrs:{"icon":"fa-share-alt","title":"Compartilhar o status do pedido"},on:{"click":function($event){return _vm.handleShareStatus(item)}}}),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"icon":"fa-exclamation-circle","title":"Definir o status do pedido"},on:{"click":function($event){return _vm.handleUpdateStatus(item)}}}),_vm._v(" "),(item.stpedv == 'F' && item.codnf && item.chave)?_c('v-button',{staticClass:"float-right",attrs:{"label":"xml","not_min_width":true,"title":"Baixar XML da NF-e"},on:{"click":function($event){return _vm.handleDownloadXML(item.codnf, item.chave)}}},[_vm._v("xml ")]):_vm._e(),_vm._v(" "),_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: _vm.enableEdit(item.stpedv, item.cieloidsuperlink, item.vendarecebida, item.tppedv), btnPrint: _vm.enablePrint(item.stpedv), btnFaturar: false},"moreActions":[]},on:{"edit":function($event){return _vm.handleEditPedido(item)},"view":function($event){return _vm.handleEditPedido(item, true)},"print":function($event){return _vm.handleAction(1, item.codpedv)},"faturar":function($event){return _vm.handleAction(2, item.codpedv)},"action":function($event){return _vm.handleAction(_vm.id, item.codpedv)}}}),_vm._v(" "),(_vm.pedv_update_status.codpedv == item.codpedv)?_c('pedido-status',{attrs:{"pedv":item},on:{"closeform":function($event){_vm.pedv_update_status = {}},"save":_vm.handlePostStatus}}):_vm._e(),_vm._v(" "),(_vm.pedv_share_status.codpedv == item.codpedv)?_c('pedido-status-share',{attrs:{"pedv":item},on:{"closeform":function($event){_vm.pedv_share_status = {}},"save":_vm.handlePostShareStatus}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-2 text-right"},[(item.stpedv != 'C' && item.status)?_c('span',{staticClass:"badge badge-warning",attrs:{"title":_vm.horaStatus(item.datastatus)}},[_c('i',{staticClass:"fa fa-exclamation-circle mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.status)+" ")]):_vm._e(),_vm._v(" "),(item.stpedv != 'C' && item.ecommerce == 'S' && item.clienteretira == 'S')?_c('span',{staticClass:"badge badge-info mr-2"},[_c('i',{staticClass:"fa fa-truck mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Retirar no local")]):_vm._e(),_vm._v(" "),(item.stpedv != 'C' && item.ecommerce == 'S' && item.clienteretira == 'N' && item.descricaofrete)?_c('span',{staticClass:"badge badge-info mr-2"},[_c('i',{staticClass:"fa fa-truck mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.descricaofrete))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-md-none d-xs-block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-2"},[(item.tppedv=='P')?_c('span',{staticClass:"lbl-list"},[_vm._v(" Pedido ")]):_vm._e(),_vm._v(" "),(item.tppedv=='P')?_c('span',{staticClass:"lbl-title-produto",attrs:{"title":"Número do Pedido"}},[_vm._v(" #"+_vm._s(item.npedido))]):_vm._e(),_vm._v(" "),(item.tppedv=='O')?_c('span',{staticClass:"lbl-list"},[_vm._v(" Orçamento ")]):_vm._e(),_vm._v(" "),(item.tppedv=='O')?_c('span',{staticClass:"lbl-title-produto",attrs:{"title":"Número do Orçamento"}},[_vm._v(" #"+_vm._s(item.ncotacao))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatData")(item.data)))]),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-user mr-2"}),_vm._v(" "+_vm._s(item.nome_usuario)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-2"},[_c('span',{staticClass:"badge",class:_vm.statusColor(item.stpedv, item.tppedv)},[_vm._v(_vm._s(_vm.textST(item)))]),_vm._v(" "),(item.ecommerce == 'S')?_c('span',{staticClass:"badge badge-warning"},[_c('i',{staticClass:"fa fa-shopping-basket"})]):_vm._e(),_vm._v(" "),(item.dtvalidade && item.tppedv=='O')?_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v("Validade "+_vm._s(_vm._f("formatDataExtenso")(item.dtvalidade)))]):_vm._e(),_vm._v(" "),(_vm.orcamentoVencido(item))?_c('span',{staticClass:"badge badge-red mr-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Orçamento com data de validade vencida"}},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v("Vencido")]):_vm._e(),_vm._v(" "),(item.data_leitura)?_c('span',{staticClass:"badge badge-yellow ml-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":'Leitura efetuada em ' + item.data_leitura}},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"lbl-deal-title d-block"},[_vm._v(_vm._s(item.nome))]),_vm._v(" "),(item.fone1)?_c('span',{staticClass:"data-list-sm"},[_c('i',{staticClass:"fa fa-phone",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatFone")(item.fone1))+" ")]):_vm._e(),_vm._v(" "),(item.email)?_c('span',{staticClass:"data-list-sm"},[_c('i',{staticClass:"fa fa-envelope",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.email)+" ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-2"},[_c('span',{staticClass:"data-list-sm"},[_vm._v("R$ "),_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(item.totger,2)))])]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"icon":"fa-share-alt","title":"Compartilhar o status do pedido"},on:{"click":function($event){return _vm.handleShareStatus(item)}}}),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"icon":"fa-exclamation-circle","title":"Definir o status do pedido"},on:{"click":function($event){return _vm.handleUpdateStatus(item)}}}),_vm._v(" "),(item.stpedv == 'F' && item.codnf && item.chave)?_c('v-button',{staticClass:"float-right",attrs:{"label":"xml","not_min_width":true,"title":"Baixar XML da NF-e"},on:{"click":function($event){return _vm.handleDownloadXML(item.codnf, item.chave)}}},[_vm._v("xml ")]):_vm._e(),_vm._v(" "),_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: true, btnEdit: _vm.enableEdit(item.stpedv, item.cieloidsuperlink, item.vendarecebida, item.tppedv), btnPrint: _vm.enablePrint(item.stpedv), btnFaturar: false},"moreActions":[]},on:{"edit":function($event){return _vm.handleEditPedido(item)},"view":function($event){return _vm.handleEditPedido(item, true)},"print":function($event){return _vm.handleAction(1, item.codpedv)},"faturar":function($event){return _vm.handleAction(2, item.codpedv)},"action":function($event){return _vm.handleAction(_vm.id, item.codpedv)}}}),_vm._v(" "),(_vm.pedv_update_status.codpedv == item.codpedv)?_c('pedido-status',{attrs:{"pedv":item},on:{"closeform":function($event){_vm.pedv_update_status = {}},"save":_vm.handlePostStatus}}):_vm._e(),_vm._v(" "),(_vm.pedv_share_status.codpedv == item.codpedv)?_c('pedido-status-share',{attrs:{"pedv":item},on:{"closeform":function($event){_vm.pedv_share_status = {}},"save":_vm.handlePostShareStatus}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-2"},[(_vm.appLoja && item.tppedv == 'P' && item.stfraud == '3')?_c('span',{staticClass:"badge badge-error mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Reprovado Clearsale ")]):_vm._e(),_vm._v(" "),(_vm.appLoja && item.tppedv == 'P' && item.stpedv != 'C' && item.stfraud == '2')?_c('span',{staticClass:"badge badge-success mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Clearsale ")]):_vm._e(),_vm._v(" "),(_vm.appLoja && item.tppedv == 'P' && item.stpedv != 'C' && item.cieloidsuperlink && item.vendarecebida != 'S' && item.vendarecebida != 'N')?_c('span',{staticClass:"badge badge-warning mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Aguardando Pagamento Online ")]):_vm._e(),_vm._v(" "),(_vm.appLoja && item.tppedv == 'P' && item.cieloidsuperlink && item.vendarecebida == 'N')?_c('span',{staticClass:"badge badge-warning mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Pagamento Não realizado ")]):_vm._e(),_vm._v(" "),(_vm.appLoja && item.tppedv == 'P' && item.vendarecebida == 'S')?_c('span',{staticClass:"badge badge-success mr-2"},[_c('i',{staticClass:"fa fa-credit-card mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Pagamento Efetuado ")]):_vm._e(),_vm._v(" "),(item.stpedv != 'C' && item.status)?_c('span',{staticClass:"badge badge-warning",attrs:{"title":_vm.horaStatus(item.datastatus)}},[_c('i',{staticClass:"fa fa-exclamation-circle mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.status)+" ")]):_vm._e()])])])])])})],2)],1),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[(_vm.showImpressao)?_c('PedidoImpressao',{ref:"impressao",attrs:{"index":_vm.codpedvImpressao},on:{"close":_vm.handleClosePrint}}):_vm._e()],1),_vm._v(" "),(_vm.showForm)?_c('fv-pedido-form',{attrs:{"index":this.codpedv,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fv_produtos_menu_vue__ = __webpack_require__(674);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a9c8f96_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fv_produtos_menu_vue__ = __webpack_require__(1892);
function injectStyle (ssrContext) {
  __webpack_require__(1884)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fv_produtos_menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a9c8f96_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fv_produtos_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1885);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("235644b9", content, true, {});

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1887);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("170a8102", content, true, {});

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-207e2513]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-207e2513]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-207e2513]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-207e2513]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-207e2513]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-image[data-v-207e2513]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;padding:4px;color:#64748b;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px}.nb-card-image>img[data-v-207e2513]{max-width:100%;max-height:100%;object-fit:contain}.nb-card-image>.fa[data-v-207e2513]{font-size:19px}.nb-card-title[data-v-207e2513]{flex:1;min-width:0}.nb-card-title-line[data-v-207e2513]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-207e2513]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-207e2513]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-207e2513]{color:#334155;font-weight:600}.nb-card-badge[data-v-207e2513]{display:inline-flex;align-items:center;gap:4px;padding:4px 7px;border:1px solid transparent;border-radius:5px;font-size:10px;font-weight:700;line-height:1.2}.nb-card-badge--info[data-v-207e2513]{color:#0369a1;background:#f0f9ff;border-color:#bae6fd}.nb-card-actions[data-v-207e2513]{flex:0 0 auto}.nb-stock-label[data-v-207e2513]{font-size:12px;color:#64748b;font-weight:600}.nb-stock-input[data-v-207e2513]{width:110px;text-align:right;font-weight:600}.nb-card-subitems[data-v-207e2513]{margin-top:12px;margin-left:24px;padding-left:16px;border-left:2px solid #e2e8f0;display:flex;flex-direction:column;gap:8px}.nb-card-subitem[data-v-207e2513]{background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:8px 12px}.nb-card-subitem-top[data-v-207e2513]{display:flex;align-items:center;justify-content:space-between;gap:12px}.nb-card-subitem-identity[data-v-207e2513]{display:flex;align-items:center;min-width:0;gap:8px}.nb-subitem-arrow[data-v-207e2513]{color:#94a3b8;font-size:14px}.nb-subitem-title[data-v-207e2513]{color:#1e293b;font-size:13px;font-weight:600}@media (max-width:767.98px){.nb-card-top[data-v-207e2513]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-207e2513]{align-self:flex-start}.nb-card-subitems[data-v-207e2513]{margin-left:10px;padding-left:10px}}", ""]);

// exports


/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"xls-button":true,"single-entity":"","plural-entity":"Saldos de Estoque","title-search":"Pesquise pelo código ou pela descrição do produto"},on:{"search":_vm.search,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.produtos.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.produtos),function(produto,index){return _c('article',{key:produto.coditem || index,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_c('div',{staticClass:"nb-card-image"},[(produto.url)?_c('img',{attrs:{"src":produto.url,"alt":""}}):_c('i',{staticClass:"fa fa-camera",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(produto.descricao))]),_vm._v(" "),(produto.isgrade == 'S')?_c('span',{staticClass:"nb-card-badge nb-card-badge--info"},[_vm._v("\n                                Grade\n                            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                            Código "),_c('strong',[_vm._v(_vm._s(produto.codigo || '—'))])])])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[(produto.isgrade == 'S')?_c('div',[_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.loadGrade(produto)}}},[_c('i',{staticClass:"fa fa-th fa-fw"}),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(produto.showGrade ? 'Ocultar Grades' : 'Ver Grades'))])])]):_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"nb-stock-label mr-2"},[_vm._v("Saldo:")]),_vm._v(" "),_c('input-number',{staticClass:"form-control form-control-sm nb-stock-input",on:{"blur":function($event){return _vm.updateQuantidade(produto)},"focus":function($event){return _vm.handleFocusProduto(produto)}},model:{value:(produto.saldo_estoque),callback:function ($$v) {_vm.$set(produto, "saldo_estoque", $$v)},expression:"produto.saldo_estoque"}})],1)])]),_vm._v(" "),(produto.showGrade && produto.grade && produto.grade.length)?_c('div',{staticClass:"nb-card-subitems"},_vm._l((produto.grade),function(grade,gIdx){return _c('div',{key:gIdx,staticClass:"nb-card-subitem"},[_c('div',{staticClass:"nb-card-subitem-top"},[_c('div',{staticClass:"nb-card-subitem-identity"},[_c('i',{staticClass:"fa fa-level-up fa-rotate-90 nb-subitem-arrow",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"nb-subitem-title"},[_vm._v(_vm._s(grade.linha)+" "),(grade.coluna)?_c('small',[_vm._v("/ "+_vm._s(grade.coluna))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"nb-stock-label mr-2"},[_vm._v("Saldo:")]),_vm._v(" "),_c('input-number',{staticClass:"form-control form-control-sm nb-stock-input",on:{"blur":function($event){return _vm.updateQuantidade(produto, grade)},"focus":function($event){return _vm.handleFocusProduto(produto, grade)}},model:{value:(grade.saldo_estoque),callback:function ($$v) {_vm.$set(grade, "saldo_estoque", $$v)},expression:"grade.saldo_estoque"}})],1)])])}),0):_vm._e()])}),_vm._v(" "),(_vm.nextPage > 0)?_c('div',{staticClass:"text-center my-3"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",on:{"click":function($event){return _vm.handleMore()}}},[_c('i',{staticClass:"fa fa-chevron-down mr-1"}),_vm._v(" Exibir mais produtos\n            ")])]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1890);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6ec81bfa", content, true, {});

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-d6313172]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-d6313172]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-d6313172]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-d6313172]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-d6313172]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-image[data-v-d6313172]{position:relative;display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;padding:4px;color:#64748b;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;cursor:pointer}.nb-card-image[data-v-d6313172]:focus-visible{outline:2px solid #004e94;outline-offset:2px}.nb-card-image>img[data-v-d6313172]{max-width:100%;max-height:100%;object-fit:contain}.nb-card-image>.fa[data-v-d6313172]{font-size:19px}.nb-card-image-edit[data-v-d6313172]{position:absolute;right:-5px;bottom:-5px;display:flex;width:18px;height:18px;align-items:center;justify-content:center;color:#fff;background:#004e94;border:2px solid #fff;border-radius:50%;font-size:8px}.nb-card-title[data-v-d6313172]{flex:1;min-width:0}.nb-card-title-line[data-v-d6313172]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-d6313172]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-d6313172]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-d6313172]{color:#334155;font-weight:600}.nb-card-actions[data-v-d6313172]{flex:0 0 auto}.nb-price-display[data-v-d6313172]{display:flex;flex-direction:column;align-items:flex-end;text-align:right}.nb-price-label[data-v-d6313172]{font-size:11px;color:#64748b}.nb-price-value[data-v-d6313172]{font-size:16px;font-weight:700}.nb-price-value small[data-v-d6313172]{font-size:11px;font-weight:500}.nb-card-details[data-v-d6313172]{display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:12px;margin:12px 0 0 60px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-card-detail[data-v-d6313172]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-card-detail-label[data-v-d6313172]{color:#64748b;font-size:11px}.nb-card-detail>strong[data-v-d6313172]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}@media (max-width:767.98px){.nb-card-top[data-v-d6313172]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-d6313172]{align-self:flex-start}.nb-price-display[data-v-d6313172]{align-items:flex-start;text-align:left}.nb-card-details[data-v-d6313172]{grid-template-columns:repeat(2,minmax(0,1fr));margin-left:0}}", ""]);

// exports


/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"xls-button":true,"single-entity":"","plural-entity":"Pesquisa de Produtos e Preços","title-search":"Pesquise pelo código ou pela descrição do produto"},on:{"search":_vm.search,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list"},[(_vm.produtos.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.produtos),function(produto,index){return _c('article',{key:produto.coditem || index,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_c('button',{staticClass:"nb-card-image",attrs:{"type":"button","aria-label":'Gerenciar imagem de ' + produto.descricao,"title":"Gerenciar imagem"},on:{"click":function($event){return _vm.handleAnexosForm(produto.coditem, produto.descricao)}}},[(produto.url)?_c('img',{attrs:{"src":produto.url,"alt":""}}):_c('i',{staticClass:"fa fa-camera",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(produto.descricao))])]),_vm._v(" "),_c('div',{staticClass:"nb-card-code"},[_vm._v("\n                                Código "),_c('strong',[_vm._v(_vm._s(produto.codigo || '—'))])])])]),_vm._v(" "),(_vm.renderTabelasUsuario(produto.tabelas_preco.tabelas).length)?_c('div',{staticClass:"nb-card-actions"},[_c('div',{staticClass:"nb-price-display"},[_c('span',{staticClass:"nb-price-label"},[_vm._v(_vm._s(_vm.getTabDescricao(_vm.renderTabelasUsuario(produto.tabelas_preco.tabelas)[0].codtabpre)))]),_vm._v(" "),_c('span',{staticClass:"nb-price-value text-primary"},[_c('small',[_vm._v("R$")]),_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.renderTabelasUsuario(produto.tabelas_preco.tabelas)[0].vlr,2))+"\n                            ")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nb-card-details"},[_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("NCM")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(produto.ncm || '—'))])]),_vm._v(" "),_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Estoque")]),_vm._v(" "),_c('strong',[_vm._v("\n                            "+_vm._s(produto.saldo_estoque !== null && produto.saldo_estoque !== undefined ? produto.saldo_estoque : '—')+"\n                            "),(produto.uni)?_c('small',[_vm._v(_vm._s(produto.uni))]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.renderTabelasUsuario(produto.tabelas_preco.tabelas)),function(tab,idx){return _c('div',{key:idx,staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v(_vm._s(_vm.getTabDescricao(tab.codtabpre)))]),_vm._v(" "),_c('strong',{staticClass:"text-primary"},[_c('small',[_vm._v("R$")]),_vm._v(" "+_vm._s(_vm._f("formatValue")(tab.vlr,2)))])])})],2)])}),_vm._v(" "),(_vm.nextPage > 0)?_c('div',{staticClass:"text-center my-3"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",on:{"click":function($event){return _vm.handleMore()}}},[_c('i',{staticClass:"fa fa-chevron-down mr-1"}),_vm._v(" Exibir mais produtos\n                ")])]):_vm._e()],2)],1),_vm._v(" "),(_vm.showAnexosForm)?_c('anexos-form',{attrs:{"params":{ ref: 'item', chaveref: _vm.coditem, title: _vm.descricao, showform: true }},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"nb-card-image-edit"},[_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tabs',{attrs:{"tabindex":1,"tabsTextStyle":'font-size: 13px',"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}),_vm._v(" "),_c('div',{staticClass:"nb-margin-top"},[(_vm.tabProdutos)?_c('transition',[_c('item-list')],1):_vm._e(),_vm._v(" "),(_vm.tabPesquisa)?_c('transition',[_c('item-precos-list')],1):_vm._e(),_vm._v(" "),(_vm.tabEstoque)?_c('transition',[_c('items-estoque-list')],1):_vm._e(),_vm._v(" "),(_vm.tabGrupos)?_c('transition',[_c('gruest-list')],1):_vm._e(),_vm._v(" "),(_vm.tabPreco)?_c('transition',[_c('tabpre-list')],1):_vm._e(),_vm._v(" "),(_vm.tabDes)?_c('transition',[_c('tabdes-list')],1):_vm._e(),_vm._v(" "),(_vm.tabDestaq)?_c('transition',[_c('destaq-list')],1):_vm._e(),_vm._v(" "),(_vm.tabGrade)?_c('transition',[_c('grade-list')],1):_vm._e(),_vm._v(" "),(_vm.tabUndMedidas)?_c('transition',[_c('unimed-list')],1):_vm._e(),_vm._v(" "),(_vm.tabAjusteEstoque)?_c('transition',[_c('item-ajuste-estoque')],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fv_config_menu_vue__ = __webpack_require__(679);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6603643e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fv_config_menu_vue__ = __webpack_require__(1955);
function injectStyle (ssrContext) {
  __webpack_require__(1894)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fv_config_menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6603643e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fv_config_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1895);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("77a46c88", content, true, {});

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1897);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("25e69676", content, true, {});

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_form_loja_vue__ = __webpack_require__(682);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fa8ccae_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_form_loja_vue__ = __webpack_require__(1949);
function injectStyle (ssrContext) {
  __webpack_require__(1899)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_form_loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fa8ccae_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_form_loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1900);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("efd4ff66", content, true, {});

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-modal-scrollable-container{top:0;border:none}.spacing-my{margin:1.5rem 0}.spacing-py{padding:1rem 0}.spacing-px{padding:0 1rem}", ""]);

// exports


/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_formasenvio_list_loja_vue__ = __webpack_require__(683);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed1acea_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_formasenvio_list_loja_vue__ = __webpack_require__(1908);
function injectStyle (ssrContext) {
  __webpack_require__(1902)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ed1acea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_formasenvio_list_loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed1acea_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_formasenvio_list_loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1903);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("ae4eb388", content, true, {});

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".container-accordion[data-v-4ed1acea]{transition:all .4s ease-in-out;overflow-x:hidden}.container-open[data-v-4ed1acea]{overflow-y:hidden;max-height:900px}.container-close[data-v-4ed1acea]{overflow-y:hidden;max-height:135px}", ""]);

// exports


/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_formasenvio_form_loja_vue__ = __webpack_require__(684);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_33cbcaad_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_formasenvio_form_loja_vue__ = __webpack_require__(1907);
function injectStyle (ssrContext) {
  __webpack_require__(1905)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_formasenvio_form_loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_33cbcaad_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_formasenvio_form_loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1906);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0a20248a", content, true, {});

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{staticClass:"nb-modal-scrollable",attrs:{"id":"mymodal"}},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container",staticStyle:{"width":"600px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],ref:"descricao",attrs:{"case":"normal","type":"text","col":"12","label":"Descrição desta opção de envio","name":"descricao","v-errors":_vm.errors},model:{value:(_vm.envioobj.descricao),callback:function ($$v) {_vm.$set(_vm.envioobj, "descricao", $$v)},expression:"envioobj.descricao"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],ref:"prazoenvio",attrs:{"case":"normal","type":"text","col":"12","label":"Prazo de envio (exemplo 1 à 2 dias úteis)","name":"prazoenvio","v-errors":_vm.errors},model:{value:(_vm.envioobj.prazoenvio),callback:function ($$v) {_vm.$set(_vm.envioobj, "prazoenvio", $$v)},expression:"envioobj.prazoenvio"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.envioobj.adicionacusto),expression:"envioobj.adicionacusto"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.envioobj.adicionacusto)?_vm._i(_vm.envioobj.adicionacusto,null)>-1:(_vm.envioobj.adicionacusto)},on:{"change":function($event){var $$a=_vm.envioobj.adicionacusto,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.envioobj, "adicionacusto", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.envioobj, "adicionacusto", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.envioobj, "adicionacusto", $$c)}}}}),_vm._v(" Adicionar taxa de envio desta forma de entrega\n                ")])]),_vm._v(" "),(_vm.envioobj.adicionacusto)?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"value","precision":2,"col":"3","label":"Taxa de envio","name":"taxaentrega","v-errors":_vm.errors},model:{value:(_vm.envioobj.taxaentrega),callback:function ($$v) {_vm.$set(_vm.envioobj, "taxaentrega", $$v)},expression:"envioobj.taxaentrega"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.envioobj.restricaopeso),expression:"envioobj.restricaopeso"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.envioobj.restricaopeso)?_vm._i(_vm.envioobj.restricaopeso,null)>-1:(_vm.envioobj.restricaopeso)},on:{"change":function($event){var $$a=_vm.envioobj.restricaopeso,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.envioobj, "restricaopeso", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.envioobj, "restricaopeso", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.envioobj, "restricaopeso", $$c)}}}}),_vm._v(" Restringir opção de envio pelo peso da compra \n                ")])])]),_vm._v(" "),(_vm.envioobj.restricaopeso)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: false }),expression:"{ required: false }"}],attrs:{"type":"value","precision":2,"col":"3","label":"Peso mínimo","name":"pesominimo","v-errors":_vm.errors},model:{value:(_vm.envioobj.pesominimo),callback:function ($$v) {_vm.$set(_vm.envioobj, "pesominimo", $$v)},expression:"envioobj.pesominimo"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"value","precision":2,"col":"3","label":"Peso máximo","name":"pesomaximo","v-errors":_vm.errors},model:{value:(_vm.envioobj.pesomaximo),callback:function ($$v) {_vm.$set(_vm.envioobj, "pesomaximo", $$v)},expression:"envioobj.pesomaximo"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.envioobj.restricaovalor),expression:"envioobj.restricaovalor"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.envioobj.restricaovalor)?_vm._i(_vm.envioobj.restricaovalor,null)>-1:(_vm.envioobj.restricaovalor)},on:{"change":function($event){var $$a=_vm.envioobj.restricaovalor,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.envioobj, "restricaovalor", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.envioobj, "restricaovalor", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.envioobj, "restricaovalor", $$c)}}}}),_vm._v(" Restringir opção de envio pelo total da compra\n                ")])])]),_vm._v(" "),(_vm.envioobj.restricaovalor)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: false }),expression:"{ required: false }"}],attrs:{"type":"value","precision":2,"col":"3","label":"Valor mínimo","name":"valorminimo","v-errors":_vm.errors},model:{value:(_vm.envioobj.valorminimo),callback:function ($$v) {_vm.$set(_vm.envioobj, "valorminimo", $$v)},expression:"envioobj.valorminimo"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"value","precision":2,"col":"3","label":"Valor máximo","name":"valormaximo","v-errors":_vm.errors},model:{value:(_vm.envioobj.valormaximo),callback:function ($$v) {_vm.$set(_vm.envioobj, "valormaximo", $$v)},expression:"envioobj.valormaximo"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{ref:"btnConfirm",attrs:{"label":"Ok","title":"","nb-btdef":true},on:{"click":_vm.validarDados}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeForm}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2 container-accordion row",class:_vm.showConfigShippingMethods ? 'container-open' : 'container-close'},[_c('div',{staticClass:"col cursor-pointer py-2",on:{"click":function () {_vm.showConfigShippingMethods = !_vm.showConfigShippingMethods}}},[_c('span',{staticClass:"lbl-deal-title mb-3"},[_vm._v("Formas de envio")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-auto"},[_c('v-button',{attrs:{"label":"Adicionar"},on:{"click":_vm.handleNew}})],1)])])]),_vm._v(" "),_c('button',{staticClass:"col-1 border-0 bg-transparent",staticStyle:{"outline":"none"},on:{"click":function () {_vm.showConfigShippingMethods = !_vm.showConfigShippingMethods}}},[_c('i',{class:'text-secondary fa fa-chevron-' + (_vm.showConfigShippingMethods ? 'up' : 'down')})]),_vm._v(" "),_vm._l((_vm.obj.formasenvio),function(formaenvio,index){return _c('div',{key:index,staticClass:"border p-3 mb-2 col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('v-label',{attrs:{"label":"Descrição"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(formaenvio.descricao))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('v-label',{attrs:{"label":"Taxa de Entrega"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(formaenvio.taxaentrega,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('v-label',{attrs:{"label":"Prazo"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(formaenvio.prazoenvio))])],1),_vm._v(" "),(!formaenvio.excluido)?_c('div',{staticClass:"col-md-12"},[_c('v-button',{attrs:{"label":"Desativar","danger":true},on:{"click":function($event){return _vm.handleDesativar(formaenvio, index)}}}),_vm._v(" "),_c('v-button',{attrs:{"icon":"fa-pencil","label":"Editar"},on:{"click":function($event){return _vm.handleEdit(index)}}})],1):_c('div',{staticClass:"col-md-12"},[_c('v-button',{attrs:{"label":"Ativar","success":true},on:{"click":function($event){return _vm.handleAtivar(formaenvio, index)}}})],1)])])}),_vm._v(" "),(_vm.showForm)?_c('formasenvio-form',{attrs:{"obj":_vm.formaenvioobj},on:{"confirma":_vm.handleConfirma,"closeform":_vm.handleCancel}}):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v("Configure as formas de envio que serão exibidas para o comprador no fechamento da venda!")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_formaspagamento_list_loja_vue__ = __webpack_require__(685);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5c60d8_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_formaspagamento_list_loja_vue__ = __webpack_require__(1916);
function injectStyle (ssrContext) {
  __webpack_require__(1910)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c5c60d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_formaspagamento_list_loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5c60d8_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_formaspagamento_list_loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1911);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7dd446f3", content, true, {});

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".container-accordion[data-v-2c5c60d8]{transition:all .4s;overflow-x:hidden}.container-open[data-v-2c5c60d8]{max-height:900px}.container-close[data-v-2c5c60d8]{overflow-y:hidden;max-height:120px}.accordion[data-v-2c5c60d8]{transition:opacity .4s linear;transition-delay:0s}.open[data-v-2c5c60d8]{opacity:1%}.close[data-v-2c5c60d8]{opacity:0}", ""]);

// exports


/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_formaspagamento_form_loja_vue__ = __webpack_require__(686);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_73dd13fd_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_formaspagamento_form_loja_vue__ = __webpack_require__(1915);
function injectStyle (ssrContext) {
  __webpack_require__(1913)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_formaspagamento_form_loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_73dd13fd_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_formaspagamento_form_loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1914);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3787c125", content, true, {});

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{staticClass:"nb-modal-scrollable",attrs:{"id":"mymodal"}},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"600px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, max: 50 }),expression:"{ required: true, max: 50 }"}],ref:"descricao",attrs:{"case":"normal","type":"text","col":"12","label":"Descrição","name":"text","v-errors":_vm.errors},model:{value:(_vm.formapagamentoobj.descricao),callback:function ($$v) {_vm.$set(_vm.formapagamentoobj, "descricao", $$v)},expression:"formapagamentoobj.descricao"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 1000 }),expression:"{ max: 1000 }"}],attrs:{"type":"memo","col":"12","label":"Instruções","name":"obs","v-errors":_vm.errors},model:{value:(_vm.formapagamentoobj.obs),callback:function ($$v) {_vm.$set(_vm.formapagamentoobj, "obs", $$v)},expression:"formapagamentoobj.obs"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formapagamentoobj.habilitarRetirada),expression:"formapagamentoobj.habilitarRetirada"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.formapagamentoobj.habilitarRetirada)?_vm._i(_vm.formapagamentoobj.habilitarRetirada,null)>-1:(_vm.formapagamentoobj.habilitarRetirada)},on:{"change":function($event){var $$a=_vm.formapagamentoobj.habilitarRetirada,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.formapagamentoobj, "habilitarRetirada", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.formapagamentoobj, "habilitarRetirada", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.formapagamentoobj, "habilitarRetirada", $$c)}}}}),_vm._v(" Habilitar esta forma de pagamento na retirada\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: false }),expression:"{ required: false }"}],attrs:{"type":"value","precision":2,"col":"3","label":"Desconto","addon":"%","name":"desconto","v-errors":_vm.errors},model:{value:(_vm.formapagamentoobj.desconto),callback:function ($$v) {_vm.$set(_vm.formapagamentoobj, "desconto", $$v)},expression:"formapagamentoobj.desconto"}})],1),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{ref:"btnConfirm",attrs:{"label":"Ok","title":"","nb-btdef":true},on:{"click":_vm.validarDados}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeForm}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2 container-accordion cursor-pointer",class:_vm.showConfigPayMethods ? 'container-open' : 'container-close'},[_c('div',{staticClass:"row mb-2",on:{"click":_vm.handleShowConfigPayMethods}},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"col-auto border-0 bg-transparent",staticStyle:{"outline":"none"}},[_c('i',{class:'text-secondary fa fa-chevron-' + ( _vm.showConfigPayMethods ? 'up' : 'down')})])]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-auto"},[_c('v-button',{attrs:{"label":"Adicionar"},on:{"click":_vm.handleNew}})],1)])]),_vm._v(" "),_c('transaction',{attrs:{"name":"slide"}},[_c('div',[_vm._l((_vm.obj.formaspagamento),function(pagamento,index){return _c('div',{key:index,staticClass:"border p-3 mb-2 my-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('v-label',{attrs:{"label":"Descrição"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(pagamento.descricao))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('v-label',{attrs:{"label":"Desconto"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(pagamento.desconto,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-label',{attrs:{"label":"Observações"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(pagamento.obs))])],1),_vm._v(" "),(!pagamento.excluido)?_c('div',{staticClass:"col-md-12"},[_c('v-button',{attrs:{"label":"Desativar","danger":true},on:{"click":function($event){return _vm.handleDesativar(pagamento, index)}}}),_vm._v(" "),_c('v-button',{attrs:{"icon":"fa-pencil","label":"Editar"},on:{"click":function($event){return _vm.handleEdit(index)}}})],1):_c('div',{staticClass:"col-md-12"},[_c('v-button',{attrs:{"label":"Ativar","success":true},on:{"click":function($event){return _vm.handleAtivar(pagamento, index)}}})],1)])])}),_vm._v(" "),(_vm.showForm)?_c('formaspagamento-form',{attrs:{"obj":_vm.formapagamentoobj},on:{"confirma":_vm.handleConfirma,"closeform":_vm.handleCancel}}):_vm._e()],2)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-11"},[_c('span',{staticClass:"lbl-deal-title mb-3"},[_vm._v("Outras formas de pagamento")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Adicione outras formas de pagamento como \"Pagar na retirada\", \"Combinar com o comprador\", \"Transferência bancária\" ou outra forma que deseja!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_retirada_form_loja_vue__ = __webpack_require__(687);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_09bea164_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_retirada_form_loja_vue__ = __webpack_require__(1920);
function injectStyle (ssrContext) {
  __webpack_require__(1918)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_retirada_form_loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_09bea164_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_retirada_form_loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1919);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("53b20d0d", content, true, {});

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"lbl-deal-title mb-3"},[_vm._v("Local de retirada")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"border p-3 mb-4"},[(!_vm.obj.habilitaRetirada && !_vm.editing)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('v-button',{attrs:{"label":"Ativar Local de Retirada","success":true},on:{"click":_vm.handleAtivar}})],1)]):_vm._e(),_vm._v(" "),(_vm.obj.habilitaRetirada || _vm.editing)?_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Nome da Loja"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],ref:"nome",attrs:{"type":"text","case":"normal","disabled":!_vm.editing,"name":"nome","v-errors":_vm.errors},model:{value:(_vm.obj.retirada.nome),callback:function ($$v) {_vm.$set(_vm.obj.retirada, "nome", $$v)},expression:"obj.retirada.nome"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Endereço completo para retirada"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"memo","case":"normal","disabled":!_vm.editing,"name":"endereco","v-errors":_vm.errors},model:{value:(_vm.obj.retirada.endereco),callback:function ($$v) {_vm.$set(_vm.obj.retirada, "endereco", $$v)},expression:"obj.retirada.endereco"}})],1),_vm._v(" "),(_vm.editing)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSalvar}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.handleCancelar}})],1):_vm._e(),_vm._v(" "),(_vm.obj.habilitaRetirada && !_vm.editing)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Excluir","danger":true},on:{"click":_vm.handleDesativar}}),_vm._v(" "),_c('v-button',{attrs:{"icon":"fa-pencil","label":"Editar"},on:{"click":_vm.handleEdit}})],1):_vm._e()]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v("Configure os dados onde seus clientes possam fazer a retirada da compra!")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_correios_form_loja_vue__ = __webpack_require__(688);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_61750bf5_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_correios_form_loja_vue__ = __webpack_require__(1924);
function injectStyle (ssrContext) {
  __webpack_require__(1922)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_correios_form_loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_61750bf5_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_correios_form_loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1923);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("39fa2d2d", content, true, {});

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[_c('span',{staticClass:"lbl-deal-title mb-3"},[_vm._v("Correios")]),_vm._v(" "),_vm._m(0),_vm._v(" "),(!_vm.editing)?_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('span',{staticClass:"badge badge-green"},[_vm._v("Esta forma está Ativada")]),_vm._v(" "),_c('v-button',{attrs:{"icon":"fa-pencil","label":""},on:{"click":_vm.handleEdit}}),_vm._v(" "),_c('v-button',{attrs:{"icon":"fa-pencil","title":"Desativar Correios","label":""},on:{"click":_vm.handleEdit}})],1)]):_vm._e(),_vm._v(" "),(_vm.editing)?_c('div',{staticClass:"border p-3 mb-4"},[(!_vm.obj.correios.contrato)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Habilita SEDEX"},model:{value:(_vm.obj.correios.habilitasedex),callback:function ($$v) {_vm.$set(_vm.obj.correios, "habilitasedex", $$v)},expression:"obj.correios.habilitasedex"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Habilita PAC"},model:{value:(_vm.obj.correios.habilitapac),callback:function ($$v) {_vm.$set(_vm.obj.correios, "habilitapac", $$v)},expression:"obj.correios.habilitapac"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Informar dados do meu contrato com os Correios"},model:{value:(_vm.obj.correios.contrato),callback:function ($$v) {_vm.$set(_vm.obj.correios, "contrato", $$v)},expression:"obj.correios.contrato"}})],1)]),_vm._v(" "),(_vm.obj.correios.contrato)?_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-3 col-12"},[_c('v-label',{attrs:{"label":"Código ECT"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"text","case":"normal","disabled":!_vm.editing,"v-errors":_vm.errors},model:{value:(_vm.obj.correios.codempresa),callback:function ($$v) {_vm.$set(_vm.obj.correios, "codempresa", $$v)},expression:"obj.correios.codempresa"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12"},[_c('v-label',{attrs:{"label":"Senha de acesso"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"text","case":"normal","disabled":!_vm.editing,"v-errors":_vm.errors},model:{value:(_vm.obj.correios.senha),callback:function ($$v) {_vm.$set(_vm.obj.correios, "senha", $$v)},expression:"obj.correios.senha"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Habilita SEDEX"},model:{value:(_vm.obj.correios.habilitasedex),callback:function ($$v) {_vm.$set(_vm.obj.correios, "habilitasedex", $$v)},expression:"obj.correios.habilitasedex"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.obj.correios.habilitasedex)?_c('div',{staticClass:"col-md-3 col-12 ml-5"},[_c('v-label',{attrs:{"label":"Informe o código SEDEX contratado"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"text","case":"normal","disabled":!_vm.editing,"v-errors":_vm.errors},model:{value:(_vm.obj.correios.codigosedex),callback:function ($$v) {_vm.$set(_vm.obj.correios, "codigosedex", $$v)},expression:"obj.correios.codigosedex"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Habilita PAC"},model:{value:(_vm.obj.correios.habilitapac),callback:function ($$v) {_vm.$set(_vm.obj.correios, "habilitapac", $$v)},expression:"obj.correios.habilitapac"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.obj.correios.habilitapac)?_c('div',{staticClass:"col-md-3 col-12 ml-5"},[_c('v-label',{attrs:{"label":"Informe o código PAC contratado"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"text","case":"normal","disabled":!_vm.editing,"v-errors":_vm.errors},model:{value:(_vm.obj.correios.codigopac),callback:function ($$v) {_vm.$set(_vm.obj.correios, "codigopac", $$v)},expression:"obj.correios.codigopac"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Serviço Mão Própria"},model:{value:(_vm.obj.correios.maopropria),callback:function ($$v) {_vm.$set(_vm.obj.correios, "maopropria", $$v)},expression:"obj.correios.maopropria"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Serviço Valor Declarado"},model:{value:(_vm.obj.correios.valordeclarado),callback:function ($$v) {_vm.$set(_vm.obj.correios, "valordeclarado", $$v)},expression:"obj.correios.valordeclarado"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Serviço Aviso de Recebimento"},model:{value:(_vm.obj.correios.avisorecebimento),callback:function ($$v) {_vm.$set(_vm.obj.correios, "avisorecebimento", $$v)},expression:"obj.correios.avisorecebimento"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.editing)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSalvar}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.handleCancelar}})],1):_vm._e(),_vm._v(" "),(_vm.obj.habilitaCorreios && !_vm.editing)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Excluir","danger":true},on:{"click":_vm.handleDesativar}}),_vm._v(" "),_c('v-button',{attrs:{"icon":"fa-pencil","label":"Editar"},on:{"click":_vm.handleEdit}})],1):_vm._e()])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v("Configure as formas de envio que serão exibidas para o comprador no fechamento da venda!")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-4"},[_c('img',{attrs:{"src":"correios.png","height":"40"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_melhorenvio_form_loja_vue__ = __webpack_require__(689);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_42bd55b0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_melhorenvio_form_loja_vue__ = __webpack_require__(1928);
function injectStyle (ssrContext) {
  __webpack_require__(1926)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_melhorenvio_form_loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_42bd55b0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_melhorenvio_form_loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1927);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("da844c6a", content, true, {});

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3"},[_c('span',{staticClass:"lbl-deal-title mb-3"},[_vm._v("Logística")]),_vm._v(" "),(!_vm.editing && !_vm.obj.habilitaMelhorenvio)?_c('div',{staticClass:"row mt-3 align-items-center"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('v-button',{attrs:{"icon":"","label":"Configurar"},on:{"click":_vm.handleEdit}})],1)]):_vm._e(),_vm._v(" "),(!_vm.editing && _vm.obj.habilitaMelhorenvio)?_c('div',{staticClass:"row d-flex pl-2 mt-3"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-auto pr-0"},[_c('v-button',{attrs:{"icon":"fa-pencil","label":""},on:{"click":_vm.handleEdit}}),_vm._v(" "),_c('v-button',{attrs:{"icon":"","label":"Desativar"},on:{"click":_vm.handleDesativar}})],1)]):_vm._e(),_vm._v(" "),(_vm.editing)?_c('div',{staticClass:"border p-3 mt-3 mb-3"},[_c('div',{staticClass:"row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12"},[_c('v-label',{attrs:{"label":"Client ID"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],ref:"clientid",attrs:{"type":"text","case":"normal","v-errors":_vm.errors},model:{value:(_vm.obj.melhorenvio.clientid),callback:function ($$v) {_vm.$set(_vm.obj.melhorenvio, "clientid", $$v)},expression:"obj.melhorenvio.clientid"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12"},[_c('v-label',{attrs:{"label":"Client Secret"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"text","case":"normal","v-errors":_vm.errors},model:{value:(_vm.obj.melhorenvio.clientsecret),callback:function ($$v) {_vm.$set(_vm.obj.melhorenvio, "clientsecret", $$v)},expression:"obj.melhorenvio.clientsecret"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6"},[_c('v-label',{attrs:{"label":"Agência (JadLog)"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"text","case":"normal","v-errors":_vm.errors},model:{value:(_vm.obj.melhorenvio.agencia),callback:function ($$v) {_vm.$set(_vm.obj.melhorenvio, "agencia", $$v)},expression:"obj.melhorenvio.agencia"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Serviço Mão Própria"},model:{value:(_vm.obj.melhorenvio.maopropria),callback:function ($$v) {_vm.$set(_vm.obj.melhorenvio, "maopropria", $$v)},expression:"obj.melhorenvio.maopropria"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Serviço Valor Declarado"},model:{value:(_vm.obj.melhorenvio.valordeclarado),callback:function ($$v) {_vm.$set(_vm.obj.melhorenvio, "valordeclarado", $$v)},expression:"obj.melhorenvio.valordeclarado"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('input-checkbox',{attrs:{"value-checked":true,"value-unchecked":false,"label":"Serviço Aviso de Recebimento"},model:{value:(_vm.obj.melhorenvio.avisorecebimento),callback:function ($$v) {_vm.$set(_vm.obj.melhorenvio, "avisorecebimento", $$v)},expression:"obj.melhorenvio.avisorecebimento"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('alert',{attrs:{"type":"info","title":"Aviso","text":"Produtos que não possuam dimensão e peso não serão exibidos na loja."}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.editing)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSalvar}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.handleCancelar}})],1):_vm._e()])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1"},[_c('img',{attrs:{"src":"melhorenvio.png","height":"40"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-9"},[_c('span',[_vm._v("Entregue seus produtos com o Melhor Envio. Entrega em todo o país com multiplas transportadoras.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2"},[_c('img',{attrs:{"src":"melhorenvio.png","height":"40"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5"},[_c('span',[_vm._v("Sua loja está configurada com Melhor Envio!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2"},[_c('span',{staticClass:"badge badge-green"},[_vm._v("Integração Ativada")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 mb-3"},[_c('img',{attrs:{"src":"melhorenvio.png","height":"40"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_pagonline_form_loja_vue__ = __webpack_require__(690);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3fbb060_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_pagonline_form_loja_vue__ = __webpack_require__(1932);
function injectStyle (ssrContext) {
  __webpack_require__(1930)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f3fbb060"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_pagonline_form_loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3fbb060_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_pagonline_form_loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1931);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("34b777c6", content, true, {});

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".container-accordion[data-v-f3fbb060]{transition:all .4s ease-in-out;position:relative;overflow-y:hidden}.container-open[data-v-f3fbb060]{max-height:900px}div[data-v-f3fbb060]::-webkit-scrollbar{display:none;width:0}div[data-v-f3fbb060]::-webkit-scrollbar-track{background:transparent}.container-close[data-v-f3fbb060]{overflow-y:hidden;max-height:80px}.accordion[data-v-f3fbb060]{transition:opacity .4s linear;transition-delay:.3s}.open[data-v-f3fbb060]{opacity:1%}.close[data-v-f3fbb060]{opacity:0}", ""]);

// exports


/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"lbl-deal-title mb-3"},[_vm._v("Operadoras de Pagamento On-Line")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"border p-3 mb-2 cursor-pointer container-accordion",class:_vm.showAccordionCielo ? 'container-open' : 'container-close'},[_c('div',{staticClass:"row mb-2 d-flex justify-content-between",on:{"click":function($event){return _vm.handleAccordion('cielo')}}},[_c('div',{staticClass:"col-11"},[_c('img',{staticStyle:{"height":"30px"},attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formaspagamento/cielo.png"}}),_vm._v(" "),(_vm.parametros.pagonline.habilitaCielo)?_c('span',{staticClass:"badge badge-success"},[_vm._v("Ativado")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"col-1 border-0 bg-transparent",staticStyle:{"outline":"none"}},[_c('i',{class:'text-secondary fa fa-chevron-' + (_vm.showAccordionCielo ? 'up' : 'down')})])]),_vm._v(" "),(!_vm.parametros.pagonline.habilitaCielo && !_vm.editingCielo)?_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-button',{attrs:{"label":"Ativar","success":true},on:{"click":function($event){return _vm.handleAtivar('cielo')}}})],1)]):_vm._e(),_vm._v(" "),(_vm.parametros.pagonline.habilitaCielo || _vm.editingCielo)?_c('div',{staticClass:"row mt-3 accordion",class:_vm.showAccordionCielo ? '' : 'close',attrs:{"id":"accordion"}},[_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.pagonline.habilitaCieloCheckout),expression:"parametros.pagonline.habilitaCieloCheckout"}],attrs:{"type":"checkbox","disabled":!_vm.editingCielo},domProps:{"checked":Array.isArray(_vm.parametros.pagonline.habilitaCieloCheckout)?_vm._i(_vm.parametros.pagonline.habilitaCieloCheckout,null)>-1:(_vm.parametros.pagonline.habilitaCieloCheckout)},on:{"change":function($event){var $$a=_vm.parametros.pagonline.habilitaCieloCheckout,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.pagonline, "habilitaCieloCheckout", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.pagonline, "habilitaCieloCheckout", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.pagonline, "habilitaCieloCheckout", $$c)}}}}),_vm._v(" Permitir que o comprador efetue o pagamento no fechamento da venda\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Client Id"}}),_vm._v(" "),_c('form-field',{key:"cieloclientid",attrs:{"type":"text","case":"normal","disabled":!_vm.editingCielo,"data-toggle":"tooltip","data-placement":"top","title":"client Id para acesso ao Cielo API."},model:{value:(_vm.parametros.pagonline.cielo.clientid),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.cielo, "clientid", $$v)},expression:"parametros.pagonline.cielo.clientid"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Client Secret"}}),_vm._v(" "),_c('form-field',{ref:"cieloclientsecret",attrs:{"type":"text","case":"normal","disabled":!_vm.editingCielo,"data-toggle":"tooltip","data-placement":"top","title":"Client Secret para acesso ao Cielo API."},model:{value:(_vm.parametros.pagonline.cielo.clientsecret),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.cielo, "clientsecret", $$v)},expression:"parametros.pagonline.cielo.clientsecret"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('v-label',{attrs:{"label":"Desconto"}}),_vm._v(" "),_c('form-field',{ref:"cielodesconto",attrs:{"type":"number","precion":2,"addon":"%","case":"normal","disabled":!_vm.editingCielo,"data-toggle":"tooltip","data-placement":"top","title":"Você pode informar um % de desconto para esta forma de pagamento."},model:{value:(_vm.parametros.pagonline.cielo.desconto),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.cielo, "desconto", $$v)},expression:"parametros.pagonline.cielo.desconto"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Observações"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","case":"normal","disabled":!_vm.editingCielo,"data-toggle":"tooltip","data-placement":"top","title":"Você pode informar uma Observação para esta forma de pagamento."},model:{value:(_vm.parametros.pagonline.cielo.observacao),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.cielo, "observacao", $$v)},expression:"parametros.pagonline.cielo.observacao"}})],1),_vm._v(" "),(!_vm.editingCielo)?_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-label',{attrs:{"label":"Seu link de Notificação Cielo (Super Link)"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('span',{staticClass:"badge badge-secondary"},[_vm._v("https://novo.notabrasil.com.br/ords/apiloja/notificacaopagamento/"+_vm._s(_vm.parametros.codempresa))])],1):_vm._e(),_vm._v(" "),(_vm.editingCielo)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSalvarCielo}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.handleCancelarCielo}})],1):_vm._e(),_vm._v(" "),(_vm.parametros.pagonline.habilitaCielo && !_vm.editingCielo)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Desativar","danger":true},on:{"click":function($event){return _vm.handleDesativar('cielo')}}}),_vm._v(" "),_c('v-button',{attrs:{"icon":"fa-pencil","label":"Editar"},on:{"click":_vm.handleEditCielo}})],1):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"border p-3 mb-2 cursor-pointer container-accordion",class:_vm.showAccordionRede ? 'container-open' : 'container-close'},[_c('div',{staticClass:"row mb-2",on:{"click":function($event){return _vm.handleAccordion('rede')}}},[_c('div',{staticClass:"col-11"},[_c('img',{staticStyle:{"height":"30px"},attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formaspagamento/rede.png"}}),_vm._v(" "),(_vm.parametros.pagonline.habilitaRede)?_c('span',{staticClass:"badge badge-success"},[_vm._v("Ativado")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"col-1 border-0 bg-transparent",staticStyle:{"outline":"none"}},[_c('i',{class:'text-secondary fa fa-chevron-' + (_vm.showAccordionRede ? 'up' : 'down')})])]),_vm._v(" "),(!_vm.parametros.pagonline.habilitaRede && !_vm.editingRede)?_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-button',{attrs:{"label":"Ativar","success":true},on:{"click":function($event){return _vm.handleAtivar('rede')}}})],1)]):_vm._e(),_vm._v(" "),(_vm.parametros.pagonline.habilitaRede || _vm.editingRede)?_c('div',{staticClass:"row mt-3 accordion",class:_vm.showAccordionRede ? '' : 'close'},[_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.pagonline.habilitaRedeCheckout),expression:"parametros.pagonline.habilitaRedeCheckout"}],attrs:{"type":"checkbox","disabled":!_vm.editingRede},domProps:{"checked":Array.isArray(_vm.parametros.pagonline.habilitaRedeCheckout)?_vm._i(_vm.parametros.pagonline.habilitaRedeCheckout,null)>-1:(_vm.parametros.pagonline.habilitaRedeCheckout)},on:{"change":function($event){var $$a=_vm.parametros.pagonline.habilitaRedeCheckout,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.pagonline, "habilitaRedeCheckout", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.pagonline, "habilitaRedeCheckout", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.pagonline, "habilitaRedeCheckout", $$c)}}}}),_vm._v(" Permitir que o comprador efetue o pagamento no fechamento da venda\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Token"}}),_vm._v(" "),_c('form-field',{key:"redetoken",attrs:{"type":"text","case":"normal","disabled":!_vm.editingRede,"data-toggle":"tooltip","data-placement":"top","title":"token para acesso a REDE API."},model:{value:(_vm.parametros.pagonline.rede.token),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.rede, "token", $$v)},expression:"parametros.pagonline.rede.token"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"PV"}}),_vm._v(" "),_c('form-field',{ref:"redepv",attrs:{"type":"text","case":"normal","disabled":!_vm.editingRede,"data-toggle":"tooltip","data-placement":"top","title":"PV para acesso a REDE API."},model:{value:(_vm.parametros.pagonline.rede.pv),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.rede, "pv", $$v)},expression:"parametros.pagonline.rede.pv"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('v-label',{attrs:{"label":"Desconto"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"number","precion":2,"addon":"%","disabled":!_vm.editingRede,"data-toggle":"tooltip","data-placement":"top","title":"Você pode informar um % de desconto para esta forma de pagamento."},model:{value:(_vm.parametros.pagonline.rede.desconto),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.rede, "desconto", $$v)},expression:"parametros.pagonline.rede.desconto"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('v-label',{attrs:{"label":"Parcelas"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"number","precion":0,"disabled":!_vm.editingRede,"data-toggle":"tooltip","data-placement":"top","title":"Informe o número de parcelas permitida (máximo 12)."},model:{value:(_vm.parametros.pagonline.rede.parcelas),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.rede, "parcelas", $$v)},expression:"parametros.pagonline.rede.parcelas"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('v-label',{attrs:{"label":"Valor Mínimo da Parcela"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"number","precion":0,"disabled":!_vm.editingRede,"data-toggle":"tooltip","data-placement":"top","title":"Informe o valor mínimo da parcela."},model:{value:(_vm.parametros.pagonline.rede.valorMinimoParcela),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.rede, "valorMinimoParcela", $$v)},expression:"parametros.pagonline.rede.valorMinimoParcela"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Observações"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","case":"normal","disabled":!_vm.editingRede,"data-toggle":"tooltip","data-placement":"top","title":"Você pode informar uma Observação para esta forma de pagamento."},model:{value:(_vm.parametros.pagonline.rede.observacao),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.rede, "observacao", $$v)},expression:"parametros.pagonline.rede.observacao"}})],1),_vm._v(" "),(_vm.editingRede)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSalvarRede}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.handleCancelarRede}})],1):_vm._e(),_vm._v(" "),(_vm.parametros.pagonline.habilitaRede && !_vm.editingRede)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Desativar","danger":true},on:{"click":function($event){return _vm.handleDesativar('rede')}}}),_vm._v(" "),_c('v-button',{attrs:{"icon":"fa-pencil","label":"Editar"},on:{"click":_vm.handleEditRede}})],1):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"border p-3 mb-2 cursor-pointer container-accordion",class:_vm.showAccordionShopline ? 'container-open' : 'container-close'},[_c('div',{staticClass:"row mb-2",on:{"click":function($event){return _vm.handleAccordion('shopline')}}},[_c('div',{staticClass:"col-11"},[_c('img',{staticStyle:{"height":"60px"},attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formaspagamento/itau_shopline.png"}}),_vm._v(" "),(_vm.parametros.pagonline.habilitaShopline)?_c('span',{staticClass:"badge badge-success"},[_vm._v("Ativado")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"col-1 border-0 bg-transparent",staticStyle:{"outline":"none"}},[_c('i',{class:'text-secondary fa fa-chevron-' + (_vm.showAccordionShopline ? 'up' : 'down')})])]),_vm._v(" "),(!_vm.parametros.pagonline.habilitaShopline && !_vm.editingShopline)?_c('div',{staticClass:"row accordion",class:_vm.showAccordionShopline ? '' : 'close'},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-button',{attrs:{"label":"Ativar","success":true},on:{"click":function($event){return _vm.handleAtivar('shopline')}}})],1)]):_vm._e(),_vm._v(" "),(_vm.parametros.pagonline.habilitaShopline || _vm.editingShopline)?_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Site"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({min: 26, max: 26}),expression:"{min: 26, max: 26}"}],key:"shoplinesite",attrs:{"type":"text","case":"normal","disabled":!_vm.editingShopline,"data-toggle":"tooltip","data-placement":"top","title":"Código da empresa no itaú shopline"},model:{value:(_vm.parametros.pagonline.shopline.codigosite),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.shopline, "codigosite", $$v)},expression:"parametros.pagonline.shopline.codigosite"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Chave de criptografia"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({min: 16, max: 16}),expression:"{min: 16, max: 16}"}],ref:"shoplinechave",attrs:{"type":"text","case":"normal","disabled":!_vm.editingShopline,"data-toggle":"tooltip","data-placement":"top","title":"Chave da criptografia"},model:{value:(_vm.parametros.pagonline.shopline.chave),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.shopline, "chave", $$v)},expression:"parametros.pagonline.shopline.chave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('v-label',{attrs:{"label":"Desconto"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"number","precion":2,"addon":"%","case":"normal","disabled":!_vm.editingShopline,"data-toggle":"tooltip","data-placement":"top","title":"Você pode informar um % de desconto para esta forma de pagamento."},model:{value:(_vm.parametros.pagonline.shopline.desconto),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.shopline, "desconto", $$v)},expression:"parametros.pagonline.shopline.desconto"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Observações"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","case":"normal","disabled":!_vm.editingShopline,"data-toggle":"tooltip","data-placement":"top","title":"Você pode informar uma Observação para esta forma de pagamento."},model:{value:(_vm.parametros.pagonline.shopline.observacao),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.shopline, "observacao", $$v)},expression:"parametros.pagonline.shopline.observacao"}})],1),_vm._v(" "),(!_vm.editingShopline)?_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-label',{attrs:{"label":"Campo URL de retorno"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_vm._m(4)],1):_vm._e(),_vm._v(" "),(_vm.editingShopline)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSalvarShopline}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.handleCancelarShopline}})],1):_vm._e(),_vm._v(" "),(_vm.parametros.pagonline.habilitaShopline && !_vm.editingShopline)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Desativar","danger":true},on:{"click":function($event){return _vm.handleDesativar('shopline')}}}),_vm._v(" "),_c('v-button',{attrs:{"icon":"fa-pencil","label":"Editar"},on:{"click":_vm.handleEditShopline}})],1):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"border p-3 mb-2 cursor-pointer container-accordion",class:_vm.showAccordionPixItau ? 'container-open' : 'container-close'},[_c('div',{staticClass:"row mb-2",on:{"click":function($event){return _vm.handleAccordion('pix-itau')}}},[_c('div',{staticClass:"col-11"},[_c('img',{staticStyle:{"height":"50px"},attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formaspagamento/pixitau.png"}}),_vm._v(" "),(_vm.parametros.pagonline.habilitaPixitau)?_c('span',{staticClass:"badge badge-success"},[_vm._v("Ativado")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"col-1 border-0 bg-transparent",staticStyle:{"outline":"none"}},[_c('i',{class:'text-secondary fa fa-chevron-' + (_vm.showAccordionPixItau ? 'up' : 'down')})])]),_vm._v(" "),(!_vm.parametros.pagonline.habilitaPixitau && !_vm.editingPixitau)?_c('div',{staticClass:"row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-button',{attrs:{"label":"Ativar","success":true},on:{"click":function($event){return _vm.handleAtivar('pixitau')}}})],1)]):_vm._e(),_vm._v(" "),(_vm.parametros.pagonline.habilitaPixitau || _vm.editingPixitau)?_c('div',{staticClass:"row mt-3 accordion",class:_vm.showAccordionPixItau ? '' : 'close'},[_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.pagonline.habilitaPixitauCheckout),expression:"parametros.pagonline.habilitaPixitauCheckout"}],attrs:{"type":"checkbox","disabled":!_vm.editingPixitau},domProps:{"checked":Array.isArray(_vm.parametros.pagonline.habilitaPixitauCheckout)?_vm._i(_vm.parametros.pagonline.habilitaPixitauCheckout,null)>-1:(_vm.parametros.pagonline.habilitaPixitauCheckout)},on:{"change":function($event){var $$a=_vm.parametros.pagonline.habilitaPixitauCheckout,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.pagonline, "habilitaPixitauCheckout", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.pagonline, "habilitaPixitauCheckout", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.pagonline, "habilitaPixitauCheckout", $$c)}}}}),_vm._v(" Permitir que o comprador efetue o pagamento no fechamento da venda\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Client Id"}}),_vm._v(" "),_c('form-field',{key:"pixitauclientid",attrs:{"type":"text","case":"normal","disabled":!_vm.editingPixitau,"data-toggle":"tooltip","data-placement":"top","title":"client Id para acesso à sua conta do itau."},model:{value:(_vm.parametros.pagonline.pixitau.clientid),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.pixitau, "clientid", $$v)},expression:"parametros.pagonline.pixitau.clientid"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Client Secret"}}),_vm._v(" "),_c('form-field',{ref:"pixitauclientsecret",attrs:{"type":"text","case":"normal","disabled":!_vm.editingPixitau,"data-toggle":"tooltip","data-placement":"top","title":"Client Secret para acesso à sua conta do itau."},model:{value:(_vm.parametros.pagonline.pixitau.clientsecret),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.pixitau, "clientsecret", $$v)},expression:"parametros.pagonline.pixitau.clientsecret"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('v-label',{attrs:{"label":"Desconto"}}),_vm._v(" "),_c('form-field',{ref:"pixitaudesconto",attrs:{"type":"number","precion":2,"addon":"%","case":"normal","disabled":!_vm.editingPixitau,"data-toggle":"tooltip","data-placement":"top","title":"Você pode informar um % de desconto para esta forma de pagamento."},model:{value:(_vm.parametros.pagonline.pixitau.desconto),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.pixitau, "desconto", $$v)},expression:"parametros.pagonline.pixitau.desconto"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Observações"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","case":"normal","disabled":!_vm.editingPixitau,"data-toggle":"tooltip","data-placement":"top","title":"Você pode informar uma Observação para esta forma de pagamento."},model:{value:(_vm.parametros.pagonline.pixitau.observacao),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.pixitau, "observacao", $$v)},expression:"parametros.pagonline.pixitau.observacao"}})],1),_vm._v(" "),(_vm.editingPixitau)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSalvarPixitau}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.handleCancelarPixitau}})],1):_vm._e(),_vm._v(" "),(_vm.parametros.pagonline.habilitaPixitau && !_vm.editingPixitau)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Desativar","danger":true},on:{"click":function($event){return _vm.handleDesativar('pixitau')}}}),_vm._v(" "),_c('v-button',{attrs:{"icon":"fa-pencil","label":"Editar"},on:{"click":_vm.handleEditPixitau}})],1):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"border p-3 mb-2 cursor-pointer container-accordion",class:_vm.showAccordionPagSeguro ? 'container-open' : 'container-close'},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-11",on:{"click":function($event){return _vm.handleAccordion('pagseguro')}}},[_c('img',{staticStyle:{"height":"60px"},attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formaspagamento/pagseguro.png"}}),_vm._v(" "),(_vm.parametros.pagonline.habilitaPagseguro)?_c('span',{staticClass:"badge badge-success"},[_vm._v("Ativado")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"col-1 border-0 bg-transparent",staticStyle:{"outline":"none"}},[_c('i',{class:'text-secondary fa fa-chevron-' + (_vm.showAccordionPagSeguro ? 'up' : 'down')})])]),_vm._v(" "),(!_vm.parametros.pagonline.habilitaPagseguro && !_vm.editingPagseguro)?_c('div',{staticClass:"row"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-button',{attrs:{"label":"Ativar","success":true},on:{"click":function($event){return _vm.handleAtivar('pagseguro')}}})],1)]):_vm._e(),_vm._v(" "),(_vm.parametros.pagonline.habilitaPagseguro || _vm.editingPagseguro)?_c('div',{staticClass:"row mt-3 accordion",class:_vm.showAccordionPagSeguro ? '' : 'close'},[_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.pagonline.habilitaPagseguroCheckout),expression:"parametros.pagonline.habilitaPagseguroCheckout"}],attrs:{"type":"checkbox","disabled":!_vm.editingPagseguro},domProps:{"checked":Array.isArray(_vm.parametros.pagonline.habilitaPagseguroCheckout)?_vm._i(_vm.parametros.pagonline.habilitaPagseguroCheckout,null)>-1:(_vm.parametros.pagonline.habilitaPagseguroCheckout)},on:{"change":function($event){var $$a=_vm.parametros.pagonline.habilitaPagseguroCheckout,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.pagonline, "habilitaPagseguroCheckout", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.pagonline, "habilitaPagseguroCheckout", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.pagonline, "habilitaPagseguroCheckout", $$c)}}}}),_vm._v(" Permitir que o comprador efetue o pagamento no fechamento da venda\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"E-mail"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate"}],key:"pagseguroemail",attrs:{"type":"email","case":"normal","disabled":!_vm.editingPagseguro,"data-toggle":"tooltip","data-placement":"top","title":"E-mail no PagSeguro"},model:{value:(_vm.parametros.pagonline.pagseguro.email),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.pagseguro, "email", $$v)},expression:"parametros.pagonline.pagseguro.email"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Token"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate"}],ref:"pagsegurotoken",attrs:{"type":"text","case":"normal","disabled":!_vm.editingPagseguro,"data-toggle":"tooltip","data-placement":"top","title":"Token no PagSeguro"},model:{value:(_vm.parametros.pagonline.pagseguro.token),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.pagseguro, "token", $$v)},expression:"parametros.pagonline.pagseguro.token"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('v-label',{attrs:{"label":"Desconto"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"number","precion":2,"addon":"%","case":"normal","disabled":!_vm.editingPagseguro,"data-toggle":"tooltip","data-placement":"top","title":"Você pode informar um % de desconto para esta forma de pagamento."},model:{value:(_vm.parametros.pagonline.pagseguro.desconto),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.pagseguro, "desconto", $$v)},expression:"parametros.pagonline.pagseguro.desconto"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Observações"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","case":"normal","disabled":!_vm.editingPagseguro,"data-toggle":"tooltip","data-placement":"top","title":"Você pode informar uma Observação para esta forma de pagamento."},model:{value:(_vm.parametros.pagonline.pagseguro.observacao),callback:function ($$v) {_vm.$set(_vm.parametros.pagonline.pagseguro, "observacao", $$v)},expression:"parametros.pagonline.pagseguro.observacao"}})],1),_vm._v(" "),(_vm.editingPagseguro)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSalvarPagseguro}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.handleCancelarPagseguro}})],1):_vm._e(),_vm._v(" "),(_vm.parametros.pagonline.habilitaPagseguro && !_vm.editingPagseguro)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Desativar","danger":true},on:{"click":function($event){return _vm.handleDesativar('pagseguro')}}}),_vm._v(" "),_c('v-button',{attrs:{"icon":"fa-pencil","label":"Editar"},on:{"click":_vm.handleEditPagseguro}})],1):_vm._e()]):_vm._e()]),_vm._v(" "),_c('hr')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v("Configure as operadoras de pagamento on-line da sua loja!")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"lbl-edit"},[_vm._v("\n                  Habilitar pagamentos através da operadora Cielo\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"lbl-edit"},[_vm._v("\n                  Habilitar pagamentos através da operadora Rede\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"lbl-edit"},[_vm._v("\n                  Habilitar pagamentos através da operadora Itau Shopline através de boleto ou transferência eletrônica\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{},[_c('strong',[_vm._v("dominio.notabrasil.com.br/notificacaopagamento")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"lbl-edit"},[_vm._v("\n                  Habilitar pagamentos online por PIX através do banco Itau\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"lbl-edit"},[_vm._v("\n                  Habilitar pagamentos através da operadora Pagseguro através de boleto ou cartões débitos/crédito\n              ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_bandeiras_form_loja_vue__ = __webpack_require__(691);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_aef1a328_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_bandeiras_form_loja_vue__ = __webpack_require__(1936);
function injectStyle (ssrContext) {
  __webpack_require__(1934)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aef1a328"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_bandeiras_form_loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_aef1a328_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_bandeiras_form_loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1935);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("769c6692", content, true, {});

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".bandeira[data-v-aef1a328]{height:20px;width:30px}.container-accordion[data-v-aef1a328]{transition:overflow 0s;transition:all .4s;overflow-x:hidden}.container-open[data-v-aef1a328]{overflow-y:hidden;max-height:900px}.container-close[data-v-aef1a328]{transition:overflow 0s;overflow-y:hidden;max-height:50px}.accordion[data-v-aef1a328]{transition:opacity .4s linear}.open[data-v-aef1a328]{opacity:1%}.close[data-v-aef1a328]{opacity:0}", ""]);

// exports


/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2 container-accordion",class:_vm.showConfigBrand ? 'container-open' : 'container-close'},[_c('div',{staticClass:"row mb-2 cursor-pointer",on:{"click":_vm.hanleShowConfigBrand}},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"col-auto border-0 bg-transparent",staticStyle:{"outline":"none"}},[_c('i',{class:'text-secondary fa fa-chevron-' + (_vm.showConfigBrand ? 'up' : 'down')})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"border p-3 mb-2"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12"},[(_vm.parametros.rodape.habilitaBandeiras)?_c('span',{staticClass:"badge badge-success"},[_vm._v("Ativado")]):_vm._e()])]),_vm._v(" "),(!_vm.parametros.rodape.habilitaBandeiras && !_vm.editingBandeiras)?_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-button',{attrs:{"label":"Ativar","success":true},on:{"click":function($event){return _vm.handleAtivar('bandeiras')}}})],1)]):_vm._e(),_vm._v(" "),(_vm.parametros.rodape.habilitaBandeiras || _vm.editingBandeiras)?_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit d-flex",staticStyle:{"gap":"10px"}},[_c('div',[(!_vm.parametros.rodape.bandeiras.boleto)?_c('i',{staticClass:"fa fa-times",class:!_vm.editingBandeiras ? 'text-secondary' :'text-danger',attrs:{"for":"Boleto"}}):_c('i',{staticClass:"fa fa-check",class:!_vm.editingBandeiras ? 'text-secondary' :'text-success',attrs:{"for":"Boleto"}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.rodape.bandeiras.boleto),expression:"parametros.rodape.bandeiras.boleto"},{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"checkbox","id":"Boleto","name":"Boleto","disabled":!_vm.editingBandeiras},domProps:{"checked":Array.isArray(_vm.parametros.rodape.bandeiras.boleto)?_vm._i(_vm.parametros.rodape.bandeiras.boleto,null)>-1:(_vm.parametros.rodape.bandeiras.boleto)},on:{"change":function($event){var $$a=_vm.parametros.rodape.bandeiras.boleto,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.rodape.bandeiras, "boleto", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.rodape.bandeiras, "boleto", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.rodape.bandeiras, "boleto", $$c)}}}}),_vm._v(" "),_c('img',{staticClass:"bandeira",attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/boleto.svg"}}),_vm._v(" Boleto\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit d-flex",staticStyle:{"gap":"10px"}},[_c('div',[(!_vm.parametros.rodape.bandeiras.visa)?_c('i',{staticClass:"fa fa-times",class:!_vm.editingBandeiras ? 'text-secondary' :'text-danger',attrs:{"for":"Visa"}}):_c('i',{staticClass:"fa fa-check",class:!_vm.editingBandeiras ? 'text-secondary' :'text-success',attrs:{"for":"Visa"}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.rodape.bandeiras.visa),expression:"parametros.rodape.bandeiras.visa"},{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"checkbox","id":"Visa","name":"Visa","disabled":!_vm.editingBandeiras},domProps:{"checked":Array.isArray(_vm.parametros.rodape.bandeiras.visa)?_vm._i(_vm.parametros.rodape.bandeiras.visa,null)>-1:(_vm.parametros.rodape.bandeiras.visa)},on:{"change":function($event){var $$a=_vm.parametros.rodape.bandeiras.visa,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.rodape.bandeiras, "visa", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.rodape.bandeiras, "visa", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.rodape.bandeiras, "visa", $$c)}}}}),_vm._v(" "),_c('img',{staticClass:"bandeira",attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/visa.svg"}}),_vm._v(" Visa\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit d-flex",staticStyle:{"gap":"10px"}},[_c('div',[(!_vm.parametros.rodape.bandeiras.mcard)?_c('i',{staticClass:"fa fa-times",class:!_vm.editingBandeiras ? 'text-secondary' :'text-danger',attrs:{"for":"Mastercard"}}):_c('i',{staticClass:"fa fa-check",class:!_vm.editingBandeiras ? 'text-secondary' :'text-success',attrs:{"for":"Mastercard"}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.rodape.bandeiras.mcard),expression:"parametros.rodape.bandeiras.mcard"},{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"checkbox","id":"Mastercard","name":"Mastercard","disabled":!_vm.editingBandeiras},domProps:{"checked":Array.isArray(_vm.parametros.rodape.bandeiras.mcard)?_vm._i(_vm.parametros.rodape.bandeiras.mcard,null)>-1:(_vm.parametros.rodape.bandeiras.mcard)},on:{"change":function($event){var $$a=_vm.parametros.rodape.bandeiras.mcard,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.rodape.bandeiras, "mcard", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.rodape.bandeiras, "mcard", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.rodape.bandeiras, "mcard", $$c)}}}}),_vm._v(" "),_c('img',{staticClass:"bandeira",attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/mcard.svg"}}),_vm._v(" Mastercard\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit d-flex",staticStyle:{"gap":"10px"}},[_c('div',[(!_vm.parametros.rodape.bandeiras.elo)?_c('i',{staticClass:"fa fa-times",class:!_vm.editingBandeiras ? 'text-secondary' :'text-danger',attrs:{"for":"Elo"}}):_c('i',{staticClass:"fa fa-check",class:!_vm.editingBandeiras ? 'text-secondary' :'text-success',attrs:{"for":"Elo"}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.rodape.bandeiras.elo),expression:"parametros.rodape.bandeiras.elo"},{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"checkbox","id":"Elo","name":"Elo","disabled":!_vm.editingBandeiras},domProps:{"checked":Array.isArray(_vm.parametros.rodape.bandeiras.elo)?_vm._i(_vm.parametros.rodape.bandeiras.elo,null)>-1:(_vm.parametros.rodape.bandeiras.elo)},on:{"change":function($event){var $$a=_vm.parametros.rodape.bandeiras.elo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.rodape.bandeiras, "elo", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.rodape.bandeiras, "elo", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.rodape.bandeiras, "elo", $$c)}}}}),_vm._v(" "),_c('img',{staticClass:"bandeira",attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/elo.svg"}}),_vm._v(" Elo\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit d-flex",staticStyle:{"gap":"10px"}},[_c('div',[(!_vm.parametros.rodape.bandeiras.american_express)?_c('i',{staticClass:"fa fa-times",class:!_vm.editingBandeiras ? 'text-secondary' :'text-danger',attrs:{"for":"Express"}}):_c('i',{staticClass:"fa fa-check",class:!_vm.editingBandeiras ? 'text-secondary' :'text-success',attrs:{"for":"Express"}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.rodape.bandeiras.american_express),expression:"parametros.rodape.bandeiras.american_express"},{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"checkbox","id":"Express","name":"Express","disabled":!_vm.editingBandeiras},domProps:{"checked":Array.isArray(_vm.parametros.rodape.bandeiras.american_express)?_vm._i(_vm.parametros.rodape.bandeiras.american_express,null)>-1:(_vm.parametros.rodape.bandeiras.american_express)},on:{"change":function($event){var $$a=_vm.parametros.rodape.bandeiras.american_express,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.rodape.bandeiras, "american_express", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.rodape.bandeiras, "american_express", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.rodape.bandeiras, "american_express", $$c)}}}}),_vm._v(" "),_c('img',{staticClass:"bandeira",attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/american-express.svg"}}),_vm._v(" American Express\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit d-flex",staticStyle:{"gap":"10px"}},[_c('div',[(!_vm.parametros.rodape.bandeiras.dinners_club)?_c('i',{staticClass:"fa fa-times",class:!_vm.editingBandeiras ? 'text-secondary' :'text-danger',attrs:{"for":"club"}}):_c('i',{staticClass:"fa fa-check",class:!_vm.editingBandeiras ? 'text-secondary' :'text-success',attrs:{"for":"club"}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.rodape.bandeiras.dinners_club),expression:"parametros.rodape.bandeiras.dinners_club"},{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"checkbox","id":"club","name":"club","disabled":!_vm.editingBandeiras},domProps:{"checked":Array.isArray(_vm.parametros.rodape.bandeiras.dinners_club)?_vm._i(_vm.parametros.rodape.bandeiras.dinners_club,null)>-1:(_vm.parametros.rodape.bandeiras.dinners_club)},on:{"change":function($event){var $$a=_vm.parametros.rodape.bandeiras.dinners_club,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.rodape.bandeiras, "dinners_club", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.rodape.bandeiras, "dinners_club", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.rodape.bandeiras, "dinners_club", $$c)}}}}),_vm._v(" "),_c('img',{staticClass:"bandeira",attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/dinners-club.svg"}}),_vm._v(" Dinners club\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit d-flex",staticStyle:{"gap":"10px"}},[_c('div',[(!_vm.parametros.rodape.bandeiras.hipercard)?_c('i',{staticClass:"fa fa-times",class:!_vm.editingBandeiras ? 'text-secondary' :'text-danger',attrs:{"for":"Hipercard"}}):_c('i',{staticClass:"fa fa-check",class:!_vm.editingBandeiras ? 'text-secondary' :'text-success',attrs:{"for":"Hipercard"}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.rodape.bandeiras.hipercard),expression:"parametros.rodape.bandeiras.hipercard"},{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"checkbox","id":"Hipercard","name":"Hipercard","disabled":!_vm.editingBandeiras},domProps:{"checked":Array.isArray(_vm.parametros.rodape.bandeiras.hipercard)?_vm._i(_vm.parametros.rodape.bandeiras.hipercard,null)>-1:(_vm.parametros.rodape.bandeiras.hipercard)},on:{"change":function($event){var $$a=_vm.parametros.rodape.bandeiras.hipercard,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.rodape.bandeiras, "hipercard", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.rodape.bandeiras, "hipercard", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.rodape.bandeiras, "hipercard", $$c)}}}}),_vm._v(" "),_c('img',{staticClass:"bandeira",attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/hipercard.svg"}}),_vm._v(" Hipercard\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit d-flex",staticStyle:{"gap":"10px"}},[_c('div',[(!_vm.parametros.rodape.bandeiras.aura)?_c('i',{staticClass:"fa fa-times",class:!_vm.editingBandeiras ? 'text-secondary' :'text-danger',attrs:{"for":"Aura"}}):_c('i',{staticClass:"fa fa-check",class:!_vm.editingBandeiras ? 'text-secondary' :'text-success',attrs:{"for":"Aura"}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.rodape.bandeiras.aura),expression:"parametros.rodape.bandeiras.aura"},{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"checkbox","id":"Aura","name":"Aura","disabled":!_vm.editingBandeiras},domProps:{"checked":Array.isArray(_vm.parametros.rodape.bandeiras.aura)?_vm._i(_vm.parametros.rodape.bandeiras.aura,null)>-1:(_vm.parametros.rodape.bandeiras.aura)},on:{"change":function($event){var $$a=_vm.parametros.rodape.bandeiras.aura,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.rodape.bandeiras, "aura", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.rodape.bandeiras, "aura", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.rodape.bandeiras, "aura", $$c)}}}}),_vm._v(" "),_c('img',{staticClass:"bandeira",attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/aura.svg"}}),_vm._v(" Aura\n                  ")])]),_vm._v(" "),(_vm.editingBandeiras)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSalvarBandeiras}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.handleCancelarBandeiras}})],1):_vm._e(),_vm._v(" "),(_vm.parametros.rodape.habilitaBandeiras && !_vm.editingBandeiras)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Desativar","danger":true},on:{"click":function($event){return _vm.handleDesativar('bandeiras')}}}),_vm._v(" "),_c('v-button',{attrs:{"icon":"fa-pencil","label":"Editar"},on:{"click":_vm.handleEditBandeiras}})],1):_vm._e()]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-11"},[_c('span',{staticClass:"lbl-deal-title mb-3"},[_vm._v("Imagens Bandeiras de cartões")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Configure as bandeiras de cartões exibidas no rodapé da sua loja!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"lbl-edit"},[_vm._v("                    \n                  Habilitar imagens das bandeiras no final da página\n                  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_analisefraude_form_loja_vue__ = __webpack_require__(692);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_72f1730b_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_analisefraude_form_loja_vue__ = __webpack_require__(1940);
function injectStyle (ssrContext) {
  __webpack_require__(1938)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_analisefraude_form_loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_72f1730b_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_analisefraude_form_loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1939);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3c5dca56", content, true, {});

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"lbl-deal-title mb-3"},[_vm._v("Análise de Fraude de Pagamento")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"border p-3 mb-2"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12"},[_c('img',{staticStyle:{"height":"30px"},attrs:{"src":"clearsale.png"}}),_vm._v(" "),(_vm.parametros.analisefraude.habilitaClearsale)?_c('span',{staticClass:"badge badge-success"},[_vm._v("Ativado")]):_vm._e()])]),_vm._v(" "),(!_vm.parametros.analisefraude.habilitaClearsale && !_vm.editingClearsale)?_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-button',{attrs:{"label":"Ativar","success":true},on:{"click":function($event){return _vm.handleAtivar('clearsale')}}})],1)]):_vm._e(),_vm._v(" "),(_vm.parametros.analisefraude.habilitaClearsale || _vm.editingClearsale)?_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Login"}}),_vm._v(" "),_c('form-field',{key:"clearsalelogin",attrs:{"type":"text","case":"normal","disabled":!_vm.editingClearsale,"data-toggle":"tooltip","data-placement":"top","title":"Login para acesso ao Clearsale API."},model:{value:(_vm.parametros.analisefraude.clearsale.login),callback:function ($$v) {_vm.$set(_vm.parametros.analisefraude.clearsale, "login", $$v)},expression:"parametros.analisefraude.clearsale.login"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Senha"}}),_vm._v(" "),_c('form-field',{ref:"clearsalesenha",attrs:{"type":"text","case":"normal","disabled":!_vm.editingClearsale,"data-toggle":"tooltip","data-placement":"top","title":"Senha para acesso ao Clearsale API."},model:{value:(_vm.parametros.analisefraude.clearsale.senha),callback:function ($$v) {_vm.$set(_vm.parametros.analisefraude.clearsale, "senha", $$v)},expression:"parametros.analisefraude.clearsale.senha"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-label',{attrs:{"label":"Fingerprint (Seu_app)"}}),_vm._v(" "),_c('form-field',{ref:"clearsalefingerprint",attrs:{"type":"text","case":"normal","disabled":!_vm.editingClearsale,"data-toggle":"tooltip","data-placement":"top","title":"Fingerprint (Seu_app) para acesso ao Clearsale API."},model:{value:(_vm.parametros.analisefraude.clearsale.fingerprint),callback:function ($$v) {_vm.$set(_vm.parametros.analisefraude.clearsale, "fingerprint", $$v)},expression:"parametros.analisefraude.clearsale.fingerprint"}})],1),_vm._v(" "),(!_vm.editingClearsale)?_c('div',{staticClass:"col-md-12 mt-2"},[_c('v-label',{attrs:{"label":"Seu link de Notificação Clearsale"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('span',{staticClass:"badge badge-secondary"},[_vm._v("https://novo.notabrasil.com.br/ords/nbapp/clearsale/webhook/"+_vm._s(_vm.parametros.codempresa))])],1):_vm._e(),_vm._v(" "),(_vm.editingClearsale)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSalvarClearsale}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.handleCancelarClearsale}})],1):_vm._e(),_vm._v(" "),(_vm.parametros.analisefraude.habilitaClearsale && !_vm.editingClearsale)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Desativar","danger":true},on:{"click":function($event){return _vm.handleDesativar('clearsale')}}}),_vm._v(" "),_c('v-button',{attrs:{"icon":"fa-pencil","label":"Editar"},on:{"click":_vm.handleEditClearsale}})],1):_vm._e()]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v("Configure as operadoras de Análise de Fraude de Pagamento da sua loja!")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"lbl-edit"},[_vm._v("                    \n                  Habilitar Análise de Fraude de Pagamentos através da operadora Clearsale \n              ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_selformasenvio_form_loja_vue__ = __webpack_require__(693);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_32b06589_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_selformasenvio_form_loja_vue__ = __webpack_require__(1944);
function injectStyle (ssrContext) {
  __webpack_require__(1942)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32b06589"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_selformasenvio_form_loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_32b06589_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_selformasenvio_form_loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1943);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("8a84e9e6", content, true, {});

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".container-accordion[data-v-32b06589]{transition:all .4s ease-in-out;overflow-x:hidden}.container-open[data-v-32b06589]{overflow-y:hidden;max-height:900px}.container-close[data-v-32b06589]{overflow-y:hidden;max-height:120px}.formasenvio[data-v-32b06589]{height:30px;width:50px}", ""]);

// exports


/***/ }),
/* 1944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2 mt-5 container-accordion cursor-pointer",class:_vm.showConfigShippingMethods ? 'container-open' : 'container-close'},[_c('div',{staticClass:"row",on:{"click":function () { return _vm.showConfigShippingMethods = !_vm.showConfigShippingMethods; }}},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"col-1 border-0 bg-transparent",staticStyle:{"outline":"none"}},[_c('i',{class:'text-secondary fa fa-chevron-' + (_vm.showConfigShippingMethods ? 'up' : 'down')})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showConfigShippingMethods),expression:"showConfigShippingMethods"}],staticClass:"border p-3 mb-2"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12"},[(_vm.parametros.rodape.habilitaFormasEnvio)?_c('span',{staticClass:"badge badge-success"},[_vm._v("Ativado")]):_vm._e()])]),_vm._v(" "),(!_vm.parametros.rodape.habilitaFormasEnvio && !_vm.editingFormasEnvio)?_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-button',{attrs:{"label":"Ativar","success":true},on:{"click":function($event){return _vm.handleAtivar('formasenvio')}}})],1)]):_vm._e(),_vm._v(" "),(_vm.parametros.rodape.habilitaFormasEnvio || _vm.editingFormasEnvio)?_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit d-flex align-items-center",staticStyle:{"gap":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.rodape.formasenvio.correios),expression:"parametros.rodape.formasenvio.correios"},{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"checkbox","disabled":!_vm.editingFormasEnvio,"id":"correios","name":"correios"},domProps:{"checked":Array.isArray(_vm.parametros.rodape.formasenvio.correios)?_vm._i(_vm.parametros.rodape.formasenvio.correios,null)>-1:(_vm.parametros.rodape.formasenvio.correios)},on:{"change":function($event){var $$a=_vm.parametros.rodape.formasenvio.correios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.rodape.formasenvio, "correios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.rodape.formasenvio, "correios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.rodape.formasenvio, "correios", $$c)}}}}),_vm._v(" "),_c('div',[(!_vm.parametros.rodape.formasenvio.correios)?_c('i',{staticClass:"fa fa-times",class:!_vm.editingFormasEnvio ? 'text-secondary' :'text-danger',attrs:{"for":"correios"}}):_c('i',{staticClass:"fa fa-check",class:!_vm.editingFormasEnvio ? 'text-secondary' :'text-success',attrs:{"for":"correios"}})]),_vm._v(" "),_c('img',{staticClass:"formasenvio",attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formasenvio/correios.png"}}),_vm._v(" Correios\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit d-flex align-items-center",staticStyle:{"gap":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.rodape.formasenvio.pac),expression:"parametros.rodape.formasenvio.pac"},{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"checkbox","disabled":!_vm.editingFormasEnvio,"id":"pac","name":"pac"},domProps:{"checked":Array.isArray(_vm.parametros.rodape.formasenvio.pac)?_vm._i(_vm.parametros.rodape.formasenvio.pac,null)>-1:(_vm.parametros.rodape.formasenvio.pac)},on:{"change":function($event){var $$a=_vm.parametros.rodape.formasenvio.pac,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.rodape.formasenvio, "pac", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.rodape.formasenvio, "pac", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.rodape.formasenvio, "pac", $$c)}}}}),_vm._v(" "),_c('div',[(!_vm.parametros.rodape.formasenvio.pac)?_c('i',{staticClass:"fa fa-times",class:!_vm.editingFormasEnvio ? 'text-secondary' :'text-danger',attrs:{"for":"pac"}}):_c('i',{staticClass:"fa fa-check",class:!_vm.editingFormasEnvio ? 'text-secondary' :'text-success',attrs:{"for":"pac"}})]),_vm._v(" "),_c('img',{staticClass:"formasenvio",attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formasenvio/pac.png"}}),_vm._v(" PAC\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit d-flex align-items-center",staticStyle:{"gap":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.rodape.formasenvio.sedex),expression:"parametros.rodape.formasenvio.sedex"},{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"checkbox","disabled":!_vm.editingFormasEnvio,"id":"sedex","name":"sedex"},domProps:{"checked":Array.isArray(_vm.parametros.rodape.formasenvio.sedex)?_vm._i(_vm.parametros.rodape.formasenvio.sedex,null)>-1:(_vm.parametros.rodape.formasenvio.sedex)},on:{"change":function($event){var $$a=_vm.parametros.rodape.formasenvio.sedex,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.rodape.formasenvio, "sedex", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.rodape.formasenvio, "sedex", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.rodape.formasenvio, "sedex", $$c)}}}}),_vm._v(" "),_c('div',[(!_vm.parametros.rodape.formasenvio.sedex)?_c('i',{staticClass:"fa fa-times",class:!_vm.editingFormasEnvio ? 'text-secondary' :'text-danger',attrs:{"for":"sedex"}}):_c('i',{staticClass:"fa fa-check",class:!_vm.editingFormasEnvio ? 'text-secondary' :'text-success',attrs:{"for":"sedex"}})]),_vm._v(" "),_c('img',{staticClass:"formasenvio",attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formasenvio/sedex.png"}}),_vm._v(" Sedex\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit d-flex align-items-center",staticStyle:{"gap":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.rodape.formasenvio.jadlog),expression:"parametros.rodape.formasenvio.jadlog"},{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"checkbox","disabled":!_vm.editingFormasEnvio,"id":"jadlog","name":"jadlog"},domProps:{"checked":Array.isArray(_vm.parametros.rodape.formasenvio.jadlog)?_vm._i(_vm.parametros.rodape.formasenvio.jadlog,null)>-1:(_vm.parametros.rodape.formasenvio.jadlog)},on:{"change":function($event){var $$a=_vm.parametros.rodape.formasenvio.jadlog,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.rodape.formasenvio, "jadlog", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.rodape.formasenvio, "jadlog", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.rodape.formasenvio, "jadlog", $$c)}}}}),_vm._v(" "),_c('div',[(!_vm.parametros.rodape.formasenvio.jadlog)?_c('i',{staticClass:"fa fa-times",class:!_vm.editingFormasEnvio ? 'text-secondary' :'text-danger',attrs:{"for":"jadlog"}}):_c('i',{staticClass:"fa fa-check",class:!_vm.editingFormasEnvio ? 'text-secondary' :'text-success',attrs:{"for":"jadlog"}})]),_vm._v(" "),_c('img',{staticClass:"formasenvio",attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formasenvio/jadlog.png"}}),_vm._v(" JadLog\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit d-flex align-items-center",staticStyle:{"gap":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.rodape.formasenvio.latam),expression:"parametros.rodape.formasenvio.latam"},{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"checkbox","disabled":!_vm.editingFormasEnvio,"id":"latam","name":"latam"},domProps:{"checked":Array.isArray(_vm.parametros.rodape.formasenvio.latam)?_vm._i(_vm.parametros.rodape.formasenvio.latam,null)>-1:(_vm.parametros.rodape.formasenvio.latam)},on:{"change":function($event){var $$a=_vm.parametros.rodape.formasenvio.latam,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.rodape.formasenvio, "latam", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.rodape.formasenvio, "latam", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.rodape.formasenvio, "latam", $$c)}}}}),_vm._v(" "),_c('div',[(!_vm.parametros.rodape.formasenvio.latam)?_c('i',{staticClass:"fa fa-times",class:!_vm.editingFormasEnvio ? 'text-secondary' :'text-danger',attrs:{"for":"latam"}}):_c('i',{staticClass:"fa fa-check",class:!_vm.editingFormasEnvio ? 'text-secondary' :'text-success',attrs:{"for":"latam"}})]),_vm._v(" "),_c('img',{staticClass:"formasenvio",attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formasenvio/latam.png"}}),_vm._v(" Latam Cargo\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-2"},[_c('label',{staticClass:"lbl-edit d-flex align-items-center",staticStyle:{"gap":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parametros.rodape.formasenvio.azul_express),expression:"parametros.rodape.formasenvio.azul_express"},{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"checkbox","disabled":!_vm.editingFormasEnvio,"id":"azul_express","name":"azul_express"},domProps:{"checked":Array.isArray(_vm.parametros.rodape.formasenvio.azul_express)?_vm._i(_vm.parametros.rodape.formasenvio.azul_express,null)>-1:(_vm.parametros.rodape.formasenvio.azul_express)},on:{"change":function($event){var $$a=_vm.parametros.rodape.formasenvio.azul_express,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.parametros.rodape.formasenvio, "azul_express", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.parametros.rodape.formasenvio, "azul_express", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.parametros.rodape.formasenvio, "azul_express", $$c)}}}}),_vm._v(" "),_c('div',[(!_vm.parametros.rodape.formasenvio.azul_express)?_c('i',{staticClass:"fa fa-times",class:!_vm.editingFormasEnvio ? 'text-secondary' :'text-danger',attrs:{"for":"azul_express"}}):_c('i',{staticClass:"fa fa-check",class:!_vm.editingFormasEnvio ? 'text-secondary' :'text-success',attrs:{"for":"azul_express"}})]),_vm._v(" "),_c('img',{staticClass:"formasenvio",attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formasenvio/azul_express.png"}}),_vm._v(" Azul Cargo Express\n              ")])]),_vm._v(" "),(_vm.editingFormasEnvio)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSalvarFormasEnvio}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.handleCancelarFormasEnvio}})],1):_vm._e(),_vm._v(" "),(_vm.parametros.rodape.habilitaFormasEnvio && !_vm.editingFormasEnvio)?_c('div',{staticClass:"col-md-12 mt-3"},[_c('v-button',{attrs:{"label":"Desativar","danger":true},on:{"click":function($event){return _vm.handleDesativar('formasenvio')}}}),_vm._v(" "),_c('v-button',{attrs:{"icon":"fa-pencil","label":"Editar"},on:{"click":_vm.handleEditFormasEnvio}})],1):_vm._e()]):_vm._e()]),_vm._v(" "),_c('hr')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col py-2"},[_c('span',{staticClass:"lbl-deal-title mb-3"},[_vm._v("Imagens Formas de Envio")]),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v("Configure as Formas de Envio exibidas no rodapé da sua loja!")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"lbl-edit"},[_vm._v("                    \n              Habilitar imagens das Formas de Envio no final da página\n              ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_mail_loja_vue__ = __webpack_require__(694);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5b6649e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_mail_loja_vue__ = __webpack_require__(1948);
function injectStyle (ssrContext) {
  __webpack_require__(1946)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_config_mail_loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5b6649e_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_config_mail_loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1947);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6e7c6eb6", content, true, {});

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3"},[_c('span',{staticClass:"lbl-deal-title mt-4"},[_vm._v("E-mail")]),_vm._v(" "),_c('div',{staticClass:"row py-2"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-3"},[_c('v-button',{attrs:{"label":"Configuração de E-mail","nb-btdef":true},on:{"click":_vm.handleNewMail}})],1),_vm._v(" "),_vm._l((_vm.parametros.emails),function(mail,i){return _c('div',{key:i,staticClass:"col-md-12 d-flex align-items-center ml-n2"},[_c('form-field',{attrs:{"type":"text","label":"Título da Página","col":"5","disabled":true},model:{value:(mail.assunto),callback:function ($$v) {_vm.$set(mail, "assunto", $$v)},expression:"mail.assunto"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","label":"Título para Rodapé","col":"3","disabled":true},model:{value:(mail.corpo),callback:function ($$v) {_vm.$set(mail, "corpo", $$v)},expression:"mail.corpo"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary mr-3",attrs:{"title":"Configurar Página"},on:{"click":function($event){return _vm.handleEditMail(i)}}},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Configurar Página"},on:{"click":function($event){return _vm.handleCancelMail(i)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)})],2),_vm._v(" "),(_vm.showModalMail)?_c('div',{staticClass:"nb-modal-scrollable",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeForm()}}},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h5',[_vm._v("Configuração de E-mail Automático")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select","label":"Tipo","col":"12","selectOptions":_vm.mailOptions},model:{value:(_vm.mail.tipo),callback:function ($$v) {_vm.$set(_vm.mail, "tipo", $$v)},expression:"mail.tipo"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"text","label":"Corpo do e-mail","col":"12"},model:{value:(_vm.mail.assunto),callback:function ($$v) {_vm.$set(_vm.mail, "assunto", $$v)},expression:"mail.assunto"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('wysiwyg',{model:{value:(_vm.mail.corpo),callback:function ($$v) {_vm.$set(_vm.mail, "corpo", $$v)},expression:"mail.corpo"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer mt-4"},[_c('v-button',{ref:"btnConfirm",attrs:{"label":"Salvar","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleSaveMail(_vm.mail)}}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":function($event){return _vm.closeForm()}}})],1)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 mb-3"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("Configure aqui o assunto e corpo das mensagens para o e-mail na rotina especificada.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tabs',{attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}),_vm._v(" "),(_vm.tabDados)?_c('div',{staticClass:"border p-3"},[_c('div',{staticClass:"row flex-column align-items-center justify-content-center"},[_c('span',{staticClass:"lbl-deal-title spacing-px w-100"},[_vm._v("Logotipo")]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('div',{},[_c('div',{staticStyle:{"padding":"10px"},attrs:{"data-toggle":"tooltip","data-placement":"bottom"}},[(_vm.image)?_c('img',{staticClass:"mx-auto img-thumbnail",staticStyle:{"max-width":"130px","max-height":"130px","cursor":"pointer"},attrs:{"src":_vm.image,"alt":"Logotipo"},on:{"click":function($event){return _vm.handleClickLogotipo()}}}):_vm._e(),_vm._v(" "),(!_vm.image)?_c('i',{staticClass:"img-thumbnail fa fa-camera",staticStyle:{"font-size":"72px","color":"silver","cursor":"pointer"},on:{"click":function($event){return _vm.handleClickLogotipo()}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"logotipo",attrs:{"id":"anexo","type":"file","accept":"image/*"},on:{"change":function($event){return _vm.handleUploadLogotipo($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"d-flex w-100",staticStyle:{"max-width":"60%"}},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.site.validator),expression:"metadata.filial.site.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.filial.site,"name":"site","v-errors":_vm.errors},model:{value:(_vm.filial.site),callback:function ($$v) {_vm.$set(_vm.filial, "site", $$v)},expression:"filial.site"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.email.validator),expression:"metadata.filial.email.validator"}],attrs:{"type":"email","col":"6","metadata":_vm.metadata.filial.email,"name":"email","v-errors":_vm.errors},model:{value:(_vm.filial.email),callback:function ($$v) {_vm.$set(_vm.filial, "email", $$v)},expression:"filial.email"}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row flex-column w-100 spacing-px"},[_c('span',{staticClass:"lbl-deal-title"},[_vm._v("Endereço")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"cep","col":"2","metadata":_vm.metadata.filial.cep},on:{"update":_vm.updateCep},model:{value:(_vm.filial.cep),callback:function ($$v) {_vm.$set(_vm.filial, "cep", $$v)},expression:"filial.cep"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.ende.validator),expression:"metadata.filial.ende.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.filial.ende,"name":"ende","v-errors":_vm.errors},model:{value:(_vm.filial.ende),callback:function ($$v) {_vm.$set(_vm.filial, "ende", $$v)},expression:"filial.ende"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.bairro.validator),expression:"metadata.filial.bairro.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.filial.bairro,"name":"bairro","v-errors":_vm.errors},model:{value:(_vm.filial.bairro),callback:function ($$v) {_vm.$set(_vm.filial, "bairro", $$v)},expression:"filial.bairro"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.endenr.validator),expression:"metadata.filial.endenr.validator"}],attrs:{"type":"text","col":"2","metadata":_vm.metadata.filial.endenr,"name":"endenr","v-errors":_vm.errors},model:{value:(_vm.filial.endenr),callback:function ($$v) {_vm.$set(_vm.filial, "endenr", $$v)},expression:"filial.endenr"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.endecomp.validator),expression:"metadata.filial.endecomp.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.filial.endecomp,"name":"endecomp","v-errors":_vm.errors},model:{value:(_vm.filial.endecomp),callback:function ($$v) {_vm.$set(_vm.filial, "endecomp", $$v)},expression:"filial.endecomp"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.uf.validator),expression:"metadata.filial.uf.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.filial.uf,"name":"uf","v-errors":_vm.errors},model:{value:(_vm.filial.uf),callback:function ($$v) {_vm.$set(_vm.filial, "uf", $$v)},expression:"filial.uf"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.filial.codmun.validator),expression:"metadata.filial.codmun.validator"}],attrs:{"type":"select2","col":"4","metadata":_vm.metadata.filial.codmun,"name":"codmun","v-errors":_vm.errors,"select2":{ entity: 'mun/uf/' + _vm.filial.uf, minlength: 2 }},model:{value:(_vm.filial.codmun),callback:function ($$v) {_vm.$set(_vm.filial, "codmun", $$v)},expression:"filial.codmun"}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSaveFilial}})],1)])]):_vm._e(),_vm._v(" "),(_vm.tabConfig)?_c('div',{staticClass:"border p-3"},[_c('span',{staticClass:"lbl-deal-title mb-3"},[_vm._v("Tabela de Preços Padrão")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.configloja.codtabpre.validator),expression:"metadata.configloja.codtabpre.validator"}],attrs:{"type":"select2","col":"4","select2":{ entity: 'tabpre', minlength: 0 },"name":"codtabpre","v-errors":_vm.errors},model:{value:(_vm.configloja.codtabpre),callback:function ($$v) {_vm.$set(_vm.configloja, "codtabpre", $$v)},expression:"configloja.codtabpre"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('span',{staticClass:"lbl-deal-title mt-4"},[_vm._v("Usuário Padrão")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('form-field',{attrs:{"type":"select2","col":"4","select2":{ entity: 'usuario', minlength: 0 }},model:{value:(_vm.configloja.codusuario),callback:function ($$v) {_vm.$set(_vm.configloja, "codusuario", $$v)},expression:"configloja.codusuario"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('span',{staticClass:"lbl-deal-title mt-4"},[_vm._v("TIPO DE LOJA B2B")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('input-checkbox',{attrs:{"label":"Vendas realizadas de empresa para empresa","value-checked":true,"value-unchecked":false},model:{value:(_vm.configloja.b2b),callback:function ($$v) {_vm.$set(_vm.configloja, "b2b", $$v)},expression:"configloja.b2b"}})],1),_vm._v(" "),(_vm.configloja.b2b)?_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("\n          É necessário realizar liberação de login no cadastro de cliente\n        ")])]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('span',{staticClass:"lbl-deal-title mt-4"},[_vm._v("Controle de estoque")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('input-checkbox',{attrs:{"label":"Controlar estoque na loja e bloquear venda de produtos sem estoque","value-checked":true,"value-unchecked":false},model:{value:(_vm.configloja.controlaestoque),callback:function ($$v) {_vm.$set(_vm.configloja, "controlaestoque", $$v)},expression:"configloja.controlaestoque"}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('span',{staticClass:"lbl-deal-title mt-4"},[_vm._v("Tipo de Pedido")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.configloja.tppedv),expression:"configloja.tppedv"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio1","value":"P"},domProps:{"checked":_vm._q(_vm.configloja.tppedv,"P")},on:{"change":function($event){return _vm.$set(_vm.configloja, "tppedv", "P")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio1"}},[_vm._v("Pedido de Venda")])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.configloja.tppedv),expression:"configloja.tppedv"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio2","value":"O"},domProps:{"checked":_vm._q(_vm.configloja.tppedv,"O")},on:{"change":function($event){return _vm.$set(_vm.configloja, "tppedv", "O")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label data-list",attrs:{"for":"customRadio2"}},[_vm._v("Orçamento")])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('span',{staticClass:"lbl-deal-title mt-4"},[_vm._v("Valor mínimo Pedido")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"type":"value","precision":2,"col":"3","label":"Valor mínimo","name":"valor_minimo_pedido","v-errors":_vm.errors},model:{value:(_vm.configloja.valor_minimo_pedido),callback:function ($$v) {_vm.$set(_vm.configloja, "valor_minimo_pedido", $$v)},expression:"configloja.valor_minimo_pedido"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('span',{staticClass:"lbl-deal-title mt-4"},[_vm._v("Telefones para contato")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 30 }),expression:"{ max: 30 }"}],attrs:{"type":"fone","col":"3","label":"Telefone","name":"fone","v-errors":_vm.errors},model:{value:(_vm.configloja.fone),callback:function ($$v) {_vm.$set(_vm.configloja, "fone", $$v)},expression:"configloja.fone"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 30 }),expression:"{ max: 30 }"}],attrs:{"type":"fone","col":"3","label":"Whatsapp para contato","name":"whatsapp","v-errors":_vm.errors},model:{value:(_vm.configloja.whatsapp),callback:function ($$v) {_vm.$set(_vm.configloja, "whatsapp", $$v)},expression:"configloja.whatsapp"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 30 }),expression:"{ max: 30 }"}],attrs:{"type":"text","col":"4","label":"Instagram da sua Loja","name":"whatsapp","v-errors":_vm.errors,"preaddon":"www.instagram.com/"},model:{value:(_vm.configloja.instagram),callback:function ($$v) {_vm.$set(_vm.configloja, "instagram", $$v)},expression:"configloja.instagram"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ max: 30 }),expression:"{ max: 30 }"}],attrs:{"type":"text","col":"4","label":"Facebook da sua Loja","name":"whatsapp","v-errors":_vm.errors,"preaddon":"www.facebook.com/"},model:{value:(_vm.configloja.facebook),callback:function ($$v) {_vm.$set(_vm.configloja, "facebook", $$v)},expression:"configloja.facebook"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('span',{staticClass:"lbl-deal-title mt-4"},[_vm._v("Cores e Aparência")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"type":"color","col":"3","label":"Fundo dos Botões","name":"bg_buttons","v-errors":_vm.errors},model:{value:(_vm.configloja.cores.bg_buttons),callback:function ($$v) {_vm.$set(_vm.configloja.cores, "bg_buttons", $$v)},expression:"configloja.cores.bg_buttons"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"type":"color","col":"3","label":"Fonte dos Botões","name":"fc_buttons","v-errors":_vm.errors},model:{value:(_vm.configloja.cores.fc_buttons),callback:function ($$v) {_vm.$set(_vm.configloja.cores, "fc_buttons", $$v)},expression:"configloja.cores.fc_buttons"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"type":"color","col":"3","label":"Fundo dos Descontos","name":"bg_descontos","v-errors":_vm.errors},model:{value:(_vm.configloja.cores.bg_descontos),callback:function ($$v) {_vm.$set(_vm.configloja.cores, "bg_descontos", $$v)},expression:"configloja.cores.bg_descontos"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"type":"color","col":"3","label":"Fonte dos Descontos","name":"fc_descontos","v-errors":_vm.errors},model:{value:(_vm.configloja.cores.fc_descontos),callback:function ($$v) {_vm.$set(_vm.configloja.cores, "fc_descontos", $$v)},expression:"configloja.cores.fc_descontos"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"type":"color","col":"3","label":"Fundo Promoções","name":"bg_promocao","v-errors":_vm.errors},model:{value:(_vm.configloja.cores.bg_promocao),callback:function ($$v) {_vm.$set(_vm.configloja.cores, "bg_promocao", $$v)},expression:"configloja.cores.bg_promocao"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"type":"color","col":"3","label":"Fonte Promoções","name":"fc_promocao","v-errors":_vm.errors},model:{value:(_vm.configloja.cores.fc_promocao),callback:function ($$v) {_vm.$set(_vm.configloja.cores, "fc_promocao", $$v)},expression:"configloja.cores.fc_promocao"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"type":"color","col":"3","label":"Fundo Destaques","name":"bg_destaques","v-errors":_vm.errors},model:{value:(_vm.configloja.cores.bg_destaques),callback:function ($$v) {_vm.$set(_vm.configloja.cores, "bg_destaques", $$v)},expression:"configloja.cores.bg_destaques"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({}),expression:"{}"}],attrs:{"type":"color","col":"3","label":"Fonte Destaques","name":"fc_destaques","v-errors":_vm.errors},model:{value:(_vm.configloja.cores.fc_destaques),callback:function ($$v) {_vm.$set(_vm.configloja.cores, "fc_destaques", $$v)},expression:"configloja.cores.fc_destaques"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('input-checkbox',{attrs:{"label":"Adicionar bordar laterais na loja?","value-checked":true,"value-unchecked":false},model:{value:(_vm.configloja.bordas_laterais_add),callback:function ($$v) {_vm.$set(_vm.configloja, "bordas_laterais_add", $$v)},expression:"configloja.bordas_laterais_add"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('input-checkbox',{attrs:{"label":"Exibir categoria ao iniciar loja","value-checked":true,"value-unchecked":false},model:{value:(_vm.configloja.categoria_iniciar_aberta),callback:function ($$v) {_vm.$set(_vm.configloja, "categoria_iniciar_aberta", $$v)},expression:"configloja.categoria_iniciar_aberta"}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('span',{staticClass:"lbl-deal-title mt-4"},[_vm._v("Rodapé")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"memo","col":"6","label":"Observação Atendimento","name":"atendimento_obs","v-errors":_vm.errors},model:{value:(_vm.configloja.rodape.atendimento_obs),callback:function ($$v) {_vm.$set(_vm.configloja.rodape, "atendimento_obs", $$v)},expression:"configloja.rodape.atendimento_obs"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('span',{staticClass:"lbl-deal-title mt-4"},[_vm._v("Páginas")]),_vm._v(" "),_c('div',{staticClass:"row py-2"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-3"},[_c('v-button',{attrs:{"label":"Nova Página","nb-btdef":true},on:{"click":_vm.handleNewPagina}})],1),_vm._v(" "),_vm._l((_vm.configloja.paginas),function(pagina,i){return _c('div',{key:i,staticClass:"col-md-12 d-flex align-items-center ml-n2"},[_c('form-field',{attrs:{"type":"text","label":"Título da Página","col":"5","disabled":true},model:{value:(pagina.titulo),callback:function ($$v) {_vm.$set(pagina, "titulo", $$v)},expression:"pagina.titulo"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","label":"Título para Rodapé","col":"3","disabled":true},model:{value:(pagina.titulorodape),callback:function ($$v) {_vm.$set(pagina, "titulorodape", $$v)},expression:"pagina.titulorodape"}}),_vm._v(" "),_c('i',{staticClass:"fa",class:pagina.ativa ? 'fa-check text-success mr-2' : 'fa-ban text-danger mr-2'}),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"title":"Configurar Página"},on:{"click":function($event){return _vm.handleEditPagina(i)}}},[_c('i',{staticClass:"fa fa-cog"})])],1)})],2),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSaveFilial}})],1)])]):_vm._e(),_vm._v(" "),(_vm.showModalPaginas)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h5',[_vm._v("Nova Pagina")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.closeModalPaginas}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"text","label":"Título","col":"12"},model:{value:(_vm.pagina.titulo),callback:function ($$v) {_vm.$set(_vm.pagina, "titulo", $$v)},expression:"pagina.titulo"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"text","label":"Título para Rodapé","col":"12"},model:{value:(_vm.pagina.titulorodape),callback:function ($$v) {_vm.$set(_vm.pagina, "titulorodape", $$v)},expression:"pagina.titulorodape"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('wysiwyg',{model:{value:(_vm.pagina.html),callback:function ($$v) {_vm.$set(_vm.pagina, "html", $$v)},expression:"pagina.html"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-12"},[_c('input-checkbox',{attrs:{"label":"Ativa","value-checked":true,"value-unchecked":false},model:{value:(_vm.pagina.ativa),callback:function ($$v) {_vm.$set(_vm.pagina, "ativa", $$v)},expression:"pagina.ativa"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer mt-4"},[_c('v-button',{ref:"btnConfirm",attrs:{"label":"Salvar","title":"","nb-btdef":true},on:{"click":function($event){return _vm.handleSavePagina(_vm.pagina)}}}),_vm._v(" "),_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":_vm.closeForm}})],1)])]):_vm._e(),_vm._v(" "),(_vm.tabBanner)?_c('div',{staticClass:"border p-3"},[_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),(_vm.configloja)?_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12 text-center d-flex justify-content-center",staticStyle:{"gap":"15px"}},[_vm._m(5),_vm._v(" "),_c('v-button',{attrs:{"label":"Imagem Para Desktop","icon":"fa-upload"},on:{"click":function($event){return _vm.handleClickAdicionaImagem('desktop')}}})],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.configloja.banners_desktop),function(banner,index){return _c('div',{key:index,staticClass:"row mt-2"},[_c('div',{staticClass:"col-auto m-auto"},[_c('v-button',{attrs:{"icon":"fa-trash"},on:{"click":function($event){return _vm.apiDeleteBanner(_vm.configloja.banners_desktop, index)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-10 p-2 m-auto"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-img-top p-3"},[_c('div',{staticClass:"position-relative text-center"},[(banner.url)?_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":banner.url}}):_c('span',{staticStyle:{"font-size":"250px"}},[_c('i',{staticClass:"fa d-inline fa-camera"})])])])])])])}),_vm._v(" "),(_vm.configloja)?_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-12 text-center px-2 d-flex justify-content-center",staticStyle:{"gap":"15px"}},[_vm._m(6),_vm._v(" "),_c('v-button',{attrs:{"label":"Imagem Para Celular","icon":"fa-upload"},on:{"click":function($event){return _vm.handleClickAdicionaImagem('mobile')}}})],1)]):_vm._e(),_vm._v(" "),_c('div'),_vm._v(" "),_vm._l((_vm.configloja.banners_mobile),function(banner,index){return _c('div',{key:index,staticClass:"row mt-2"},[_c('div',{staticClass:"col-auto m-auto"},[_c('v-button',{attrs:{"icon":"fa-trash"},on:{"click":function($event){return _vm.apiDeleteBanner(_vm.configloja.banners_mobile, index)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-10 p-2 m-auto"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-img-top p-3"},[_c('div',{staticClass:"position-relative text-center"},[(banner.url)?_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":banner.url}}):_c('span',{staticStyle:{"font-size":"250px"}},[_c('i',{staticClass:"fa d-inline fa-camera"})])])])])])])}),_vm._v(" "),(_vm.uploading)?_c('div',{staticClass:"row"},[_vm._m(7)]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"border p-3"},[(_vm.tabFormasEnvio)?_c('retirada-form',{attrs:{"obj":_vm.configloja},on:{"saveconfig":_vm.handleSaveFilial}}):_vm._e(),_vm._v(" "),(_vm.tabFormasEnvio)?_c('melhorenvio-form',{attrs:{"obj":_vm.configloja},on:{"saveconfig":_vm.handleSaveFilial}}):_vm._e(),_vm._v(" "),(_vm.tabFormasEnvio)?_c('selformasenvio-form',{attrs:{"parametros":_vm.configloja},on:{"saveconfig":_vm.handleSaveFilial}}):_vm._e(),_vm._v(" "),(_vm.tabFormasEnvio)?_c('formasenvio-list',{attrs:{"obj":_vm.configloja},on:{"saveconfig":_vm.handleSaveFilial}}):_vm._e(),_vm._v(" "),(_vm.tabPagamentos)?_c('pagonline-form',{attrs:{"parametros":_vm.parametros},on:{"saveconfig":_vm.handleSaveFilial}}):_vm._e(),_vm._v(" "),(_vm.tabPagamentos)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.tabPagamentos)?_c('bandeiras-form',{attrs:{"parametros":_vm.configloja},on:{"saveconfig":_vm.handleSaveFilial}}):_vm._e(),_vm._v(" "),(_vm.tabPagamentos)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.tabPagamentos)?_c('formaspagamento-list',{attrs:{"obj":_vm.configloja},on:{"saveconfig":_vm.handleSaveFilial}}):_vm._e(),_vm._v(" "),(_vm.tabPagamentos)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.tabAnaliseFraude)?_c('analisefraude-form',{attrs:{"parametros":_vm.configloja},on:{"saveconfig":_vm.handleSaveFilial}}):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"file",attrs:{"type":"file","accept":"image/*"},on:{"change":function($event){return _vm.handleUploadBanner($event)}}}),_vm._v(" "),(_vm.tabConfigMail)?_c('config-mail-loja',{attrs:{"parametros":_vm.configloja},on:{"editMode":function($event){return _vm.handleEditMail($event)},"insertMode":function($event){return _vm.handleInsertMail($event)},"deleteMode":function($event){return _vm.handleDelete($event)}}}):_vm._e(),_vm._v(" "),(_vm.tabConfigMail)?_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-12"},[_c('v-button',{attrs:{"label":"Salvar","success":true},on:{"click":_vm.handleSaveFilial}})],1)]):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("\n          Selecione uma tabela padrão para os produtos da loja\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("\n          Selecione um usuário para recebimento de e-mails dos pedidos\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 mb-3"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("Configure aqui suas páginas adicionais sobre a sua empresa, políticas de troca, formas de\n          pagamento, entre outros assuntos importantes.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('span',{staticClass:"lbl-deal-title"},[_vm._v("Banners")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"lbl"},[_c('strong',[_vm._v("\n            Adicione banners para apresentação na sua loja virtual ")])]),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_vm._v("\n          Efetue o upload de imagens e chame atenção do seu cliente para ofertas e condições comerciais.\n        ")]),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_vm._v("\n          É recomendado que a largura tenha entre 1200px a 1600px para tablets e desktops e 720px para celulares. Não é\n          permitido imagens com mais de 2mb.\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge badge-yellow ml-1 px-2 my-auto"},[_c('i',{staticClass:"fa fa-desktop"}),_vm._v("\n          Imagens para Desktop\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge badge-yellow ml-2 my-auto"},[_c('i',{staticClass:"fa fa-mobile",staticStyle:{"font-size":"18px"}}),_vm._v("\n          Imagens para Celular\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"text-center p-3"},[_c('div',{staticClass:"imagem-galeria-loading"},[_c('div',{staticClass:"spinner-border text-muted"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"list"}},[(!_vm.dominio)?_c('div',{staticClass:"default-container mb-2 p-5"},[_c('label-title',{attrs:{"title":"Configuração Inicial","icon":"fa-shopping-basket"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({max: 100}),expression:"{max: 100}"}],attrs:{"type":"text","col":"6","case":"lower","name":"url","v-errors":_vm.errors,"placeholder":'nome-da-sua-loja' + _vm.sufixoDominio},model:{value:(_vm.url),callback:function ($$v) {_vm.url=$$v},expression:"url"}},[_c('span',{staticClass:"lbl-list"},[_vm._v("Informe o nome que seus clientes irão utilizar para acessar sua loja virtual, exemplo: nome-da-sua-loja"+_vm._s(_vm.sufixoDominio))]),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_vm._v("Informe apenas letras, numeros e hífen \"-\"")]),_c('br'),_vm._v(" "),(_vm.invalidSub)?_c('span',{staticClass:"error"},[_vm._v("Nome de domínio inválido. Use apenas letras, números e \"-\"")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.errmessages.length > 0)?_c('div',{staticClass:"col-12"},[_c('alert',{attrs:{"type":"error","close":false,"title":"Erro","messages":_vm.errmessages}})],1):_c('div',{staticClass:"col-md-6 col-10"},[(_vm.url)?_c('span',{staticClass:"mt-3 badge badge-secondary",staticStyle:{"font-size":"24px"}},[_vm._v("https://"+_vm._s(_vm.url)+_vm._s(_vm.sufixoDominio)+"/loja")]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-md-6 col-10"},[_c('v-button',{attrs:{"label":"Confirmar","icon":"fa-check"},on:{"click":_vm.handleSalvar}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.dominio)?_c('div',{staticClass:"default-container d-flex justify-content-between align-items-center py-4 mb-2"},[_c('div',[_c('label-title',{attrs:{"title":"Link de Acesso","icon":"fa-shopping-basket"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('span',{staticClass:"badge badge-secondary",staticStyle:{"font-size":"18px"}},[_c('a',{staticStyle:{"color":"white"},attrs:{"href":_vm.urlLojaCompleta,"target":"_blank"}},[_vm._v(_vm._s(_vm.urlLojaCompleta))])])]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.errmessages.length > 0)?_c('div',{staticClass:"col-12"},[_c('alert',{attrs:{"type":"error","close":false,"title":"Erro","messages":_vm.errmessages}})],1):_vm._e()])],1),_vm._v(" "),_c('v-button',{attrs:{"label":"Alterar Link de Acesso","icon":"fa-trash"},on:{"click":_vm.handleDeletar}})],1):_vm._e(),_vm._v(" "),(_vm.dominio)?_c('div',{staticClass:"default-container py-4"},_vm._l((_vm.filialList),function(filial,index){return _c('div',{key:index,staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"lbl-deal-title"},[_vm._v("CONFIGURAÇÕES DA EMPRESA")]),_vm._v(" "),_c('label-title',{attrs:{"title":filial.nome,"icon":"fa-building"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 p-3"},[_c('config-form-loja',{attrs:{"codfil":filial.codfil}})],1)])}),0):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-10 mb-2"},[_c('span',{},[_vm._v("Informe nome de domínio para sua loja")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_transportadora_list_vue__ = __webpack_require__(695);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d503a5a_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_transportadora_list_vue__ = __webpack_require__(1954);
function injectStyle (ssrContext) {
  __webpack_require__(1952)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d503a5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_transportadora_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d503a5a_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_transportadora_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1953);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7edbdfc9", content, true, {});

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".default-container.nb-card-list[data-v-7d503a5a]{display:flex;flex-direction:column;gap:10px;padding:0;background:transparent;border:0;box-shadow:none}.nb-card[data-v-7d503a5a]{padding:14px 16px;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.04);transition:border-color .15s ease,box-shadow .15s ease}.nb-card[data-v-7d503a5a]:hover{border-color:#cbd5e1;box-shadow:0 4px 12px rgba(15,23,42,.06)}.nb-card-top[data-v-7d503a5a]{display:flex;align-items:center;justify-content:space-between;gap:16px}.nb-card-identity[data-v-7d503a5a]{display:flex;align-items:center;flex:1;min-width:0;gap:12px}.nb-card-icon[data-v-7d503a5a]{display:flex;flex:0 0 48px;width:48px;height:48px;align-items:center;justify-content:center;color:#004e94;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:19px}.nb-card-title[data-v-7d503a5a]{flex:1;min-width:0}.nb-card-title-line[data-v-7d503a5a]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 9px}.nb-card-title-line h2[data-v-7d503a5a]{min-width:0;margin:0;color:#0b1c30;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}.nb-card-code[data-v-7d503a5a]{margin-top:3px;color:#64748b;font-size:12px}.nb-card-code strong[data-v-7d503a5a]{color:#334155;font-weight:600}.nb-card-badge[data-v-7d503a5a]{display:inline-flex;align-items:center;gap:4px;padding:4px 7px;border:1px solid transparent;border-radius:5px;font-size:10px;font-weight:700;line-height:1.2}.nb-card-badge--neutral[data-v-7d503a5a]{color:#475569;background:#f1f5f9;border-color:#e2e8f0}.nb-card-actions[data-v-7d503a5a]{flex:0 0 auto}.nb-card-details[data-v-7d503a5a]{display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:12px;margin:12px 0 0 60px;padding-top:11px;border-top:1px solid #f1f5f9}.nb-card-detail[data-v-7d503a5a]{display:flex;min-width:0;flex-direction:column;gap:3px}.nb-card-detail-label[data-v-7d503a5a]{color:#64748b;font-size:11px}.nb-card-detail>strong[data-v-7d503a5a]{color:#334155;font-size:12px;font-weight:600;overflow-wrap:anywhere}@media (max-width:767.98px){.nb-card-top[data-v-7d503a5a]{align-items:flex-start;flex-direction:column}.nb-card-actions[data-v-7d503a5a]{align-self:flex-end}.nb-card-details[data-v-7d503a5a]{margin-left:0}}", ""]);

// exports


/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"grid"}},[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":true,"xls-button":true,"single-entity":"Transportadora","plural-entity":"Transportadoras"},on:{"search":_vm.search,"new":_vm.incluirPart,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"default-container nb-card-list nb-margin-top"},[(_vm.partList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.partList),function(part,index){return _c('article',{key:part.codpart || index,staticClass:"nb-card"},[_c('div',{staticClass:"nb-card-top"},[_c('div',{staticClass:"nb-card-identity"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"nb-card-title"},[_c('div',{staticClass:"nb-card-title-line"},[_c('h2',[_vm._v(_vm._s(part.nome))]),_vm._v(" "),(part.fantasia && part.fantasia !== part.nome)?_c('span',{staticClass:"nb-card-badge nb-card-badge--neutral"},[_vm._v("\n                                    "+_vm._s(part.fantasia)+"\n                                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nb-card-code"},[(part.cnpjcpf)?_c('span',[_vm._v("CNPJ/CPF "),_c('strong',[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(part.cnpjcpf)))])]):_vm._e(),_vm._v(" "),(part.codpart)?_c('span',{staticClass:"ml-2"},[_vm._v("Código "),_c('strong',[_vm._v(_vm._s(part.codpart))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"nb-card-actions"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnView: false, btnEdit: true, btnEditLabel: 'Editar'},"moreActions":[]},on:{"edit":function($event){return _vm.editPart(part.codpart)}}})],1)]),_vm._v(" "),(part.nomemun || part.fone1 || part.email)?_c('div',{staticClass:"nb-card-details"},[(part.nomemun || part.uf)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Localização")]),_vm._v(" "),_c('strong',[_c('i',{staticClass:"fa fa-map-marker mr-1",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(part.nomemun)+" - "+_vm._s(part.uf))])]):_vm._e(),_vm._v(" "),(part.fone1 || part.fone2 || part.fone3)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("Telefone")]),_vm._v(" "),_c('strong',[_c('i',{staticClass:"fa fa-phone mr-1",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatFone")(part.fone1))+" "),(part.fone2)?_c('span',[_vm._v("/ "+_vm._s(_vm._f("formatFone")(part.fone2)))]):_vm._e()])]):_vm._e(),_vm._v(" "),(part.email)?_c('div',{staticClass:"nb-card-detail"},[_c('span',{staticClass:"nb-card-detail-label"},[_vm._v("E-mail")]),_vm._v(" "),_c('strong',[_c('i',{staticClass:"fa fa-envelope-o mr-1",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(part.email))])]):_vm._e()]):_vm._e()])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"800px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('customer-form',{attrs:{"crud":_vm.crud,"index":_vm.codpart,"transportadora":true},on:{"closeform":_vm.closeForm}})],1)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-card-icon"},[_c('i',{staticClass:"fa fa-truck",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex py-3"},[_c('v-button',{attrs:{"label":"Configurações da Empresa","nb-btdef":_vm.configSistema,"icon":""},on:{"click":_vm.handleConfigSistema}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Configurações Comerciais","nb-btdef":_vm.configVendas,"icon":""},on:{"click":_vm.handleConfigVendas}})],1),_vm._v(" "),(_vm.configSistema)?_c('tabs',{attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}):_vm._e(),_vm._v(" "),(_vm.configVendas)?_c('tabs',{attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}):_vm._e(),_vm._v(" "),(_vm.configVendas && _vm.tabLinks.length)?_c('tabs',{attrs:{"tabs":_vm.tabLinks,"setActiveTab":_vm.activeTabLink},on:{"onClickTab":_vm.changeTabLink}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nb-margin-top pt-5"},[(_vm.tabEmpresa)?_c('transition',[_c('filial-list')],1):_vm._e(),_vm._v(" "),(_vm.tabUsuarios)?_c('transition',[_c('usuario-list')],1):_vm._e(),_vm._v(" "),(_vm.tabEquipes)?_c('transition',[_c('equipe-list')],1):_vm._e(),_vm._v(" "),(_vm.tabConta)?_c('transition',[_c('app-minha-conta-form')],1):_vm._e(),_vm._v(" "),(_vm.tabCondicoes)?_c('transition',[_c('condicao-list')],1):_vm._e(),_vm._v(" "),(_vm.tabFormasPag)?_c('transition',[_c('fpag-list')],1):_vm._e(),_vm._v(" "),(_vm.tabTransp)?_c('transition',[_c('transportadora-list')],1):_vm._e(),_vm._v(" "),(_vm.tabStatus)?_c('transition',[_c('pdstatus-list')],1):_vm._e(),_vm._v(" "),(_vm.tabTipos)?_c('transition',[_c('pdtipo-list')],1):_vm._e(),_vm._v(" "),(_vm.tabRegras)?_c('transition',[_c('regraimp-list')],1):_vm._e(),_vm._v(" "),(_vm.tabRegrasFcp)?_c('transition',[_c('regrafcp-list')],1):_vm._e(),_vm._v(" "),(_vm.tabEstados)?_c('transition',[_c('estado-list')],1):_vm._e(),_vm._v(" "),(_vm.tabSegmento)?_c('transition',[_c('ramoat-list')],1):_vm._e(),_vm._v(" "),(_vm.tabGrupoCliente)?_c('transition',[_c('grucli-list')],1):_vm._e(),_vm._v(" "),(_vm.tabRepresentante)?_c('transition',[_c('vend-list')],1):_vm._e(),_vm._v(" "),(_vm.tabDepositos)?_c('transition',[_c('depo-list')],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fv_pedido_form_pag_vue__ = __webpack_require__(696);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e5ddca0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fv_pedido_form_pag_vue__ = __webpack_require__(1959);
function injectStyle (ssrContext) {
  __webpack_require__(1957)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_fv_pedido_form_pag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e5ddca0_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_fv_pedido_form_pag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1958);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("66585215", content, true, {});

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pedv"}},[_c('bar-manut',{attrs:{"single-entity":"Pagamento","plural-entity":"Pagamentos","crud":this.crud,"btn-delete":false},on:{"closeform":_vm.closeForm,"save":_vm.handleSave}}),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"text","col":"2","disabled":true},model:{value:(_vm.pedv.codpedv),callback:function ($$v) {_vm.$set(_vm.pedv, "codpedv", $$v)},expression:"pedv.codpedv"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{ref:"nome",attrs:{"type":"text","col":"6","label":"Nome","name":"nome","v-errors":_vm.errors},model:{value:(_vm.cartao.nome),callback:function ($$v) {_vm.$set(_vm.cartao, "nome", $$v)},expression:"cartao.nome"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"number","col":"6","label":"Numero","name":"numero","v-errors":_vm.errors},model:{value:(_vm.cartao.numero),callback:function ($$v) {_vm.$set(_vm.cartao, "numero", $$v)},expression:"cartao.numero"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"number","col":"2","label":"Validade: Mes","name":"valmes","v-errors":_vm.errors},model:{value:(_vm.cartao.valmes),callback:function ($$v) {_vm.$set(_vm.cartao, "valmes", $$v)},expression:"cartao.valmes"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"number","col":"2","label":"Ano","name":"valano","v-errors":_vm.errors},model:{value:(_vm.cartao.valano),callback:function ($$v) {_vm.$set(_vm.cartao, "valano", $$v)},expression:"cartao.valano"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"number","col":"3","label":"CVV","name":"codsec","v-errors":_vm.errors},model:{value:(_vm.cartao.codsec),callback:function ($$v) {_vm.$set(_vm.cartao, "codsec", $$v)},expression:"cartao.codsec"}})],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.pedvit),function(item,index){return _c('div',{key:index,staticClass:"row border bg-white py-3 mb-2"},[_c('div',{staticClass:"col-md-6 col-6"},[(item.item[0].url != '' )?_c('img',{staticClass:"d-inline-block",staticStyle:{"max-width":"45px"},attrs:{"src":item.item[0].url}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"card-text d-inline-block",staticStyle:{"max-width":"70%"}},[_vm._v(" "+_vm._s(item.item[0].descricao)+" ")]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[(item.ptotdes > 0)?_c('em',{staticClass:"desconto detail"},[_vm._v(_vm._s(_vm._f("formatValue")(item.ptotdes,0))+"% OFF")]):_vm._e(),_vm._v(" "),(item.totdes > 0)?_c('em',{},[_vm._v("Economia de R$"+_vm._s(_vm._f("formatValue")(item.totdes,2)))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('span',{staticClass:"card-label"},[_vm._v("Quantidade")]),_c('br'),_vm._v(" "),_c('em',{},[_vm._v(" "+_vm._s(item.qt))])]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('span',{staticClass:"card-label"},[_vm._v("Preço Unitário")]),_c('br'),_vm._v(" "),(item.totbru > 0)?_c('em',{staticClass:"valor-de",staticStyle:{"display":"inline-block"}},[_vm._v("De: "),_c('strong',[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(item.totbru,2)))])]):_vm._e(),_vm._v(" "),(item.totbru > 0)?_c('em',{},[_vm._v("por "),_c('strong',[_vm._v("R$"+_vm._s(_vm._f("formatValue")(item.vlr,2)))]),_vm._v("/"+_vm._s(item.uni))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('span',{staticClass:"card-label"},[_vm._v("Preço Total")]),_c('br'),_vm._v(" "),_c('em',{},[_c('strong',[_vm._v("R$"+_vm._s(_vm._f("formatValue")(item.totliq,2)))])])])])}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row border bg-white p-3"},[_c('div',{staticClass:"col-3 mb-3"},[_c('span',{staticClass:"card-label d-block"},[_vm._v(" Quantidade de Produtos ")]),_vm._v(" "),_c('span',{staticClass:"card-text"},[_vm._v(" "+_vm._s(_vm.pedvit.length)+" ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"col-3 text-right mb-3"},[_c('span',{staticClass:"card-label d-block"},[_vm._v(" SubTotal ")]),_vm._v(" "),_c('span',{staticClass:"card-text"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.pedv.totmer,2))+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-3 text-right mb-3"},[_c('span',{staticClass:"card-label d-block"},[_vm._v(" Descontos ")]),_vm._v(" "),_c('span',{staticClass:"card-text"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.pedv.totdes,2))+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-3 text-right"},[_c('span',{staticClass:"card-label d-block"},[_vm._v(" Total Geral ")]),_vm._v(" "),_c('span',{staticClass:"card-text"},[_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.pedv.totger,2))+" ")])])])])],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row my-3"},[_c('h6',[_vm._v("Produtos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row my-3"},[_c('h6',[_vm._v("Totais")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_guia_loja_vue__ = __webpack_require__(697);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f40252a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_guia_loja_vue__ = __webpack_require__(1963);
function injectStyle (ssrContext) {
  __webpack_require__(1961)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_guia_loja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f40252a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_guia_loja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1962);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("157f056a", content, true, {});

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col"},[(_vm.showGuia)?_c('v-button',{attrs:{"link":true,"label":"Não exibir este guia na entrada do sistema"},on:{"click":_vm.apiPost}}):_vm._e(),_vm._v(" "),(_vm.showMensagem)?_c('p',[_vm._v("Este guia não será mais exibido na abertura do sistema. Para acessá-lo, vá ao menu de ajuda!")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"default-container px-5"},[_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ul',{staticClass:"timeline"},[_c('li',[_c('h6',{staticStyle:{"text-transform":"uppercase","color":"#afaeae"}},[_vm._v("Visão Geral")]),_vm._v(" "),_c('p',[_vm._v("Apresentação do funcionamento da loja virtual")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('iframe',{staticStyle:{"max-width":"800px"},attrs:{"width":"560","height":"315","src":_vm.videos.visao.video,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])]),_vm._v(" "),_c('li',[_c('h6',{staticStyle:{"text-transform":"uppercase","color":"#afaeae"}},[_vm._v("Configurações Iniciais")]),_vm._v(" "),_c('p',[_vm._v("Veja como configurar os dados da loja e sua a aparência")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('iframe',{staticStyle:{"max-width":"800px"},attrs:{"width":"560","height":"315","src":_vm.videos.config.video,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])]),_vm._v(" "),_c('li',[_c('h6',{staticStyle:{"text-transform":"uppercase","color":"#afaeae"}},[_vm._v("Importar Produtos e Preços")]),_vm._v(" "),_c('p',[_vm._v("Veja como importar o cadastro de produtos e preços")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('iframe',{staticStyle:{"max-width":"800px"},attrs:{"width":"560","height":"315","src":_vm.videos.importar.video,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])]),_vm._v(" "),_c('li',[_c('h6',{staticStyle:{"text-transform":"uppercase","color":"#afaeae"}},[_vm._v("Categorias de Produtos")]),_vm._v(" "),_c('p',[_vm._v("Veja como determinar as categorias de produtos")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('iframe',{staticStyle:{"max-width":"800px"},attrs:{"width":"560","height":"315","src":_vm.videos.categorias.video,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])]),_vm._v(" "),_c('li',[_c('h6',{staticStyle:{"text-transform":"uppercase","color":"#afaeae"}},[_vm._v("Cadastro dos Produtos e Fotos")]),_vm._v(" "),_c('p',[_vm._v("Veja como funciona o cadastro de produtos e importação de fotos dos produtos")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('iframe',{staticStyle:{"max-width":"800px"},attrs:{"width":"560","height":"315","src":_vm.videos.produtos.video,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])]),_vm._v(" "),_c('li',[_c('h6',{staticStyle:{"text-transform":"uppercase","color":"#afaeae"}},[_vm._v("Preço dos Produtos")]),_vm._v(" "),_c('p',[_vm._v("Veja como configurar uma tabela de preços para seus produtos")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('iframe',{staticStyle:{"max-width":"800px"},attrs:{"width":"560","height":"315","src":_vm.videos.precos.video,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])]),_vm._v(" "),_c('li',[_c('h6',{staticStyle:{"text-transform":"uppercase","color":"#afaeae"}},[_vm._v("Produtos em Promoção")]),_vm._v(" "),_c('p',[_vm._v("Veja como configurar produtos em promoção na loja")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('iframe',{staticStyle:{"max-width":"800px"},attrs:{"width":"560","height":"315","src":_vm.videos.promocao.video,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])]),_vm._v(" "),_c('li',[_c('h6',{staticStyle:{"text-transform":"uppercase","color":"#afaeae"}},[_vm._v("Produtos em Destaque")]),_vm._v(" "),_c('p',[_vm._v("Veja como configurar produtos em destaque na loja")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('iframe',{staticStyle:{"max-width":"800px"},attrs:{"width":"560","height":"315","src":_vm.videos.destaque.video,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])]),_vm._v(" "),_c('li',[_c('h6',{staticStyle:{"text-transform":"uppercase","color":"#afaeae"}},[_vm._v("Gerenciar os Pedidos Recebidos")]),_vm._v(" "),_c('p',[_vm._v("Veja como funciona o gerenciamento dos pedidos recebidos na loja")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('iframe',{staticStyle:{"max-width":"800px"},attrs:{"width":"560","height":"315","src":_vm.videos.pedidos.video,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v("Guia de Ajuda")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_painel_form_vue__ = __webpack_require__(698);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_05617834_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_painel_form_vue__ = __webpack_require__(2051);
function injectStyle (ssrContext) {
  __webpack_require__(1965)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_painel_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_05617834_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_painel_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1966);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5ba3b48f", content, true, {});

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_filtros_vue__ = __webpack_require__(699);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_10c4fce9_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_filtros_vue__ = __webpack_require__(1970);
function injectStyle (ssrContext) {
  __webpack_require__(1968)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_filtros_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_10c4fce9_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_filtros_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1969);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("bb6e4888", content, true, {});

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row align-items-center"},[(_vm.params.funil)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group align-items-center"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.codfunil),expression:"codfunil"}],ref:"input",staticClass:"form-control form-control-sm",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.codfunil=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.handleChangeFunil]}},_vm._l((_vm.funilList),function(opt){return _c('option',{key:opt.codfunil,domProps:{"value":opt.codfunil}},[_vm._v(_vm._s(opt.descricao))])}),0),_vm._v(" "),(_vm.administrador)?_c('v-button',{staticClass:"ml-1",attrs:{"title":"Incluir novo funil de vendas","icon":"fa-plus","data-toggle":"tooltip","data-placement":"top"},on:{"click":_vm.handleNovoFunil}}):_vm._e(),_vm._v(" "),(_vm.administrador)?_c('v-button',{attrs:{"title":"Editar funil atual","icon":"fa-pencil","data-toggle":"tooltip","data-placement":"top"},on:{"click":_vm.handleEditarFunil}}):_vm._e()],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1972);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("451420de", content, true, {});

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-12"},[(_vm.showFunil)?_c('span',{staticClass:"lbl"},[_vm._v("Funil\n            "),_c('a',{staticClass:"dropdown-toggle pr-2",staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"1","data-toggle":"dropdown"}},[_vm._v(" "+_vm._s(_vm.funilLabel)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.arrFunil),function(item,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleChangeFunil(index)}}},[_vm._v(_vm._s(item.label))])}),0)]):_vm._e(),_vm._v(" "),(_vm.showNegocios)?_c('span',{staticClass:"lbl"},[_vm._v("Negócios\n            "),_c('a',{staticClass:"dropdown-toggle pr-2",staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"1","data-toggle":"dropdown"}},[_vm._v(" "+_vm._s(_vm.labelNegocios)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.arrNegocios),function(filtro,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleChangeFiltro(index)}}},[_vm._v(_vm._s(filtro.label))])}),0)]):_vm._e(),_vm._v(" "),(_vm.showPessoas)?_c('span',{staticClass:"lbl"},[_vm._v("Contatos\n            "),_c('a',{staticClass:"dropdown-toggle pr-2",staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"1","data-toggle":"dropdown"}},[_vm._v(" "+_vm._s(_vm.labelContato)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.arrContatos),function(filtro,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleChangeContatos(index)}}},[_vm._v(_vm._s(filtro.label))])}),0)]):_vm._e(),_vm._v(" "),(_vm.showLeads)?_c('span',{staticClass:"lbl"},[_vm._v("Leads\n            "),_c('a',{staticClass:"dropdown-toggle pr-2",staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"1","data-toggle":"dropdown"}},[_vm._v(" "+_vm._s(_vm.labelContato)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.arrLeads),function(filtro,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleChangeLeads(index)}}},[_vm._v(_vm._s(filtro.label))])}),0)]):_vm._e(),_vm._v(" "),(_vm.showOrganizacao)?_c('span',{staticClass:"lbl"},[_vm._v("Organizações\n            "),_c('a',{staticClass:"dropdown-toggle pr-2",staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"1","data-toggle":"dropdown"}},[_vm._v(" "+_vm._s(_vm.labelOrg)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.arrOrgs),function(filtro,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleChangeOrgs(index)}}},[_vm._v(_vm._s(filtro.label))])}),0)]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v("Usuário\n            "),_c('a',{staticClass:"dropdown-toggle pr-2",staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"1","data-toggle":"dropdown"}},[_vm._v(" "+_vm._s(_vm.usuarioLabel)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.arrUsuarios),function(item,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleChangeUsuario(index)}}},[_vm._v(_vm._s(item.label))])}),0)]),_vm._v(" "),_c('span',{staticClass:"lbl pl-3"},[_vm._v("Equipe\n            "),_c('a',{staticClass:"dropdown-toggle pr-2",staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"1","data-toggle":"dropdown"}},[_vm._v(" "+_vm._s(_vm.equipeLabel)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.arrEquipes),function(item,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleChangeEquipe(index)}}},[_vm._v(_vm._s(item.label))])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_painel_etapa_vue__ = __webpack_require__(701);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_704fd597_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_painel_etapa_vue__ = __webpack_require__(1984);
function injectStyle (ssrContext) {
  __webpack_require__(1975)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_painel_etapa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_704fd597_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_painel_etapa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1976);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7c080f85", content, true, {});

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1978);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1bf8b5a2", content, true, {});

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_card_detalhe_vue__ = __webpack_require__(704);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b2303b8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_card_detalhe_vue__ = __webpack_require__(1982);
function injectStyle (ssrContext) {
  __webpack_require__(1980)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_card_detalhe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b2303b8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_card_detalhe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1981);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("28c76875", content, true, {});

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".card-pop{display:inline-flex;align-items:center;visibility:visible;top:0;left:0;position:relative;z-index:1;flex-direction:row}.card-pop-inner{max-width:640px;font:400 15px/20px Source Sans Pro,sans-serif;color:#26292c;background-color:#fff;border-radius:4px;box-shadow:0 0 2px 0 rgba(0,0,0,.24),0 8px 10px 1px rgba(0,0,0,.05),0 3px 14px 2px rgba(0,0,0,.06),0 5px 5px -3px rgba(0,0,0,.1);order:2}.card-pop-inner,.card-pop-inner>.cui4-spacing{overflow:hidden;overflow-wrap:break-word}.cui4-spacing{display:block}.card-dropdown{max-height:100%;display:flex;flex-direction:column}.card-dropdown__content{overflow-y:auto;flex:1 1 auto;padding:8px 0}", ""]);

// exports


/***/ }),
/* 1982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-pop",staticStyle:{"width":"300px","position":"absolute","will-change":"transform","transform":"translate3d(205px, -50px, 0px)"}},[_c('div',{staticClass:"card-pop-inner"},[_c('div',{staticClass:"card-dropdown"},[(!_vm.loading)?_c('div',{staticClass:"card-dropdown__content"},[(_vm.agendaList.length == 0)?_c('div',{staticClass:"row text-center mx-auto"},[_c('div',{staticClass:"no-content mt-5 mb-5"},[_vm._v("\n                        Nenhuma atividade foi agendada para este negócio\n                    ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.agendaList),function(item,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-2 col-2 text-center"},[(item.tpagenda == 'L')?_c('i',{staticClass:"fa fa-phone",staticStyle:{"font-size":"28px"}}):_vm._e(),_vm._v(" "),(item.tpagenda == 'V')?_c('i',{staticClass:"fa fa-car",staticStyle:{"font-size":"28px"}}):_vm._e(),_vm._v(" "),(item.tpagenda == 'A')?_c('i',{staticClass:"fa fa-tasks",staticStyle:{"font-size":"28px"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-8",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.handleEditAgenda(item.codagenda)}}},[_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataExtenso")(item.dataagendada)))]),_vm._v(" "),(item.dias_atraso > 0)?_c('span',{staticClass:"data-list mb-2 error"},[_vm._v("Astrasada "+_vm._s(_vm._f("formatValue")(item.dias_atraso,0))+" dias")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(item.titulo))])])])])])}),_vm._v(" "),_c('div',{staticClass:"col-12 mt-3 text-center"},[_c('v-button',{attrs:{"label":"Criar uma atividade","icon":"fa-plus"},on:{"click":function($event){return _vm.handleAdicionarAgenda()}}})],1)],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-negocio",class:{ 'card-perdido': _vm.isPerdido(_vm.negocio.stnegocio) }},[_c('div',{ref:'testeclose' + _vm.negocio.codnegocio,staticClass:"row"},[(_vm.negocio.tag_descricao)?_c('span',{staticClass:"tag mr-2",style:('background-color: ' + _vm.negocio.tag_cor),attrs:{"title":_vm.negocio.tag_descricao,"data-toggle":"tooltip","data-placement":"top"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"card-title w-100",on:{"click":function($event){return _vm.handleEditNegocio(_vm.negocio.codnegocio)}}},[_vm._v(" "+_vm._s(_vm.negocio.titulo)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"row col"},[(!_vm.negocio.org_nome)?_c('span',{staticClass:"card-text"},[_c('i',{staticClass:"fa fa-user pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.negocio.pessoa_nome)+" ")]):_c('span',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.negocio.org_nome)+" ")])]),_vm._v(" "),_c('div',{staticClass:"row col"},[(_vm.negocio.valor > 0)?_c('span',{staticClass:"card-value"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.negocio.valor,2))+" ")]):_vm._e()])]),_vm._v(" "),(_vm.isAberto(_vm.negocio.stnegocio))?_c('div',{staticClass:"col-3 text-center"},[(_vm.negocio.dias_atraso)?_c('span',{staticClass:"icon icon-atrasado",attrs:{"title":'Atividade atrasada há ' + _vm.negocio.dias_atraso + ' dias',"data-toggle":"tooltip","data-placement":"top"},on:{"click":function($event){return _vm.showDetalhePopover(_vm.negocio)}}},[_c('i',{staticClass:"fa fa-bookmark",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.negocio.count_agenda == 0)?_c('span',{staticClass:"icon icon-sem-agenda",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Nenhuma atividade. Crie uma atividade para este negócio."}},[_c('i',{staticClass:"fa fa-warning",attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.showDetalhePopover(_vm.negocio)}}})]):_vm._e(),_vm._v(" "),(_vm.negocio.count_agenda > 0 && !_vm.negocio.dias_atraso)?_c('span',{staticClass:"icon icon-agenda"},[_c('i',{staticClass:"fa fa-bookmark",attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.showDetalhePopover(_vm.negocio)}}})]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('span',{staticClass:"card-text"},[_vm._v(" "+_vm._s(_vm._f("formatDataExtenso")(_vm.negocio.data,true))+" ")]),_vm._v(" "),(_vm.negocio.stnegocio == 'A' && _vm.negocio.dias_estagnado)?_c('span',{staticClass:"estagnado",attrs:{"title":'Negócio estagnado há ' + _vm.negocio.dias_estagnado + ' dias',"data-toggle":"tooltip","data-placement":"top"}},[_vm._v(" "+_vm._s(_vm.negocio.dias_estagnado)+" D ")]):_vm._e(),_vm._v(" "),(_vm.negocio.count_anexo>0)?_c('span',{staticClass:"icon icon-outros"},[_c('i',{staticClass:"fa fa-paperclip",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.negocio.count_note>0)?_c('span',{staticClass:"icon icon-outros"},[_c('i',{staticClass:"fa fa-comment",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.negocio.count_email>0)?_c('span',{staticClass:"icon icon-email"},[_c('i',{staticClass:"fa fa-envelope",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.isGanho(_vm.negocio.stnegocio))?_c('span',{staticClass:"ganho",attrs:{"title":"Negócio ganho","data-toggle":"tooltip","data-placement":"top"}},[_vm._v("GANHO")]):_vm._e(),_vm._v(" "),(_vm.isPerdido(_vm.negocio.stnegocio))?_c('span',{staticClass:"perdido",attrs:{"title":"Negócio perdido","data-toggle":"tooltip","data-placement":"top"}},[_vm._v("PERDIDO")]):_vm._e()]),_vm._v(" "),(_vm.codnegocio_detalhePopover == _vm.negocio.codnegocio)?_c('div',{directives:[{name:"closable",rawName:"v-closable",value:({ exclude: ['testeclose' + _vm.negocio.codnegocio], handler: 'closeDetalhePopover' }),expression:"{ exclude: ['testeclose' + negocio.codnegocio], handler: 'closeDetalhePopover' }"}]},[_c('crm-card-detalhe',{attrs:{"index":_vm.codnegocio_detalhePopover},on:{"adicionarAgenda":_vm.handleAdicionarAgenda,"editAgenda":_vm.handleAdicionarAgenda}})],1):_vm._e(),_vm._v(" "),(_vm.showFormAgenda)?_c('agenda-form',{attrs:{"index":_vm.codagenda,"crud":_vm.crud,"params":_vm.paramsAgenda},on:{"closeform":_vm.closeAgenda}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"pipeline",class:_vm.cols,staticStyle:{"display":"flex","height":"auto"}},[(_vm.noDeals)?_c('div',{staticClass:"no-deals"},[_c('span',{staticClass:"lbl-no-deal",staticStyle:{"z-index":"1000"}},[_vm._v(" Nenhum negócio encontrado ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.painel),function(etapa){return _c('div',{key:etapa.codetapa,staticClass:"pipeline etapa"},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"title-etapa w-100"},[_vm._v(" "+_vm._s(etapa.descricao)+" ")]),_vm._v(" "),(etapa.totais.length > 0 && etapa.totais[0].count_negocios > 1)?_c('span',{staticClass:"card-text text-right"},[_vm._v(_vm._s(etapa.totais[0].count_negocios)+" Negócios")]):_vm._e(),_vm._v(" "),(etapa.totais.length > 0)?_c('span',{staticClass:"card-value text-right"},[_vm._v(_vm._s(etapa.totais[0].moeda)+" "+_vm._s(_vm._f("formatValue")(etapa.totais[0].valor,2))+" ")]):_vm._e()]),_vm._v(" "),_c('draggable',_vm._b({staticClass:"list-group",attrs:{"move":_vm.onMove},on:{"change":_vm.onChange,"start":function($event){_vm.isDragging=true},"end":_vm.onEnd},model:{value:(etapa.negocios),callback:function ($$v) {_vm.$set(etapa, "negocios", $$v)},expression:"etapa.negocios"}},'draggable',_vm.dragOptions,false),[_c('transition-group',{staticStyle:{"height":"100%"},attrs:{"type":"transition","name":'flip-list',"codetapa":etapa.codetapa}},_vm._l((etapa.negocios),function(negocio){return _c('crm-card',{key:negocio.codnegocio,attrs:{"negocio":negocio},on:{"edit":function($event){return _vm.handleEditNegocio(negocio.codnegocio)}}})}),1)],1)],1)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_painel_timeline_vue__ = __webpack_require__(705);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed823d7a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_painel_timeline_vue__ = __webpack_require__(1992);
function injectStyle (ssrContext) {
  __webpack_require__(1986)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_painel_timeline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed823d7a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_painel_timeline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1987);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("17d78c8a", content, true, {});

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_painel_timeline_teste_vue__ = __webpack_require__(706);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_68f11cfc_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_painel_timeline_teste_vue__ = __webpack_require__(1991);
function injectStyle (ssrContext) {
  __webpack_require__(1989)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68f11cfc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_painel_timeline_teste_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_68f11cfc_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_painel_timeline_teste_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1990);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("74a2845e", content, true, {});

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".guia-popover[data-v-68f11cfc]{position:fixed;top:auto;left:auto;bottom:20px;left:20px;display:inline-flex;align-items:center;z-index:1;flex-direction:row}.guia-popover-content[data-v-68f11cfc]{width:100%;color:#26292c;background-color:#fff;box-shadow:0 0 2px 0 #0000003d,0 8px 10px 1px #0000000d,0 3px 14px 2px #0000000f,0 5px 5px -3px rgba(0,0,0,.1);order:2}.guia-list[data-v-68f11cfc]{max-height:400px;display:flex;flex-direction:column}.guia-list__content[data-v-68f11cfc]{overflow-y:auto;flex:1 1 auto;padding:8px 0;background-color:#e9e9e9}.guia-title[data-v-68f11cfc]{font-size:18px;color:#2b6292}.guia-video[data-v-68f11cfc]{position:fixed;z-index:9998;top:0;bottom:0;left:0;right:0;width:100%;height:100%;overflow:auto;background-color:rgba(15,43,73,.25);display:flex;transition:opacity .3s ease;align-items:center;justify-content:center}.guia-icon[data-v-68f11cfc]{cursor:pointer}", ""]);

// exports


/***/ }),
/* 1991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guia-popover",staticStyle:{"width":"300px"}},[_c('div',[_c('div',{staticClass:"guia-popover-content"},[_c('div',{staticClass:"row mx-auto align-items-center",staticStyle:{"border-bottom":"1px solid gray"}},[_c('div',{staticClass:"col-12 p-2",staticStyle:{"cursor":"pointer"},on:{"click":_vm.handleMinimizar}},[_c('span',{staticClass:"guia-title w-100"},[_vm._v(" Negócios sem data prevista informada")]),_vm._v(" "),_c('i',{staticClass:"guia-title text-right pl-3 fa",class:{ 'fa-chevron-circle-up': _vm.minimizado, 'fa-chevron-circle-down': !_vm.minimizado },attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('span',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.total.count_negocios)+" Negócios")]),_vm._v(" "),_c('span',{staticClass:"card-value"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.total.total,2))+" ")])])]),_vm._v(" "),(!_vm.minimizado)?_c('div',{staticClass:"guia-list"},[_c('div',{staticClass:"guia-list__content"},_vm._l((_vm.negocioList),function(negocio,index){return _c('crm-card',{key:index,attrs:{"negocio":negocio},on:{"edit":function($event){return _vm.handleEditNegocio(negocio.codnegocio)}}})}),1)]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"pipeline col-md-12 col-12",class:_vm.cols},_vm._l((_vm.painel),function(mes,index){return _c('div',{key:index,staticClass:"pipeline etapa"},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"title-etapa w-100 mb-2"},[_vm._v(" "+_vm._s(_vm._f("formatMesExtenso")(mes.startdate))+" ")]),_vm._v(" "),_c('div',{staticClass:"w-100"},[(mes.totais.length > 0 && mes.totais[0].count_negocios > 1)?_c('span',{staticClass:"card-text text-right"},[_vm._v(_vm._s(mes.totais[0].count_negocios)+" Negócios")]):_vm._e(),_vm._v(" "),(mes.totais.length > 0)?_c('span',{staticClass:"card-value"},[_vm._v(_vm._s(mes.totais[0].moeda)+" "+_vm._s(_vm._f("formatValue")(mes.totais[0].valor,2))+" ")]):_vm._e()])]),_vm._v(" "),_c('draggable',_vm._b({staticClass:"list-group",attrs:{"move":_vm.onMove},on:{"change":_vm.onChange,"start":function($event){_vm.isDragging=true},"end":_vm.onEnd},model:{value:(mes.negocios),callback:function ($$v) {_vm.$set(mes, "negocios", $$v)},expression:"mes.negocios"}},'draggable',_vm.dragOptions,false),[_c('transition-group',{attrs:{"type":"transition","name":'flip-list',"mes":index}},_vm._l((mes.negocios),function(negocio){return _c('crm-card',{key:negocio.codnegocio,attrs:{"negocio":negocio},on:{"editNegocio":function($event){return _vm.handleEditNegocio(negocio.codnegocio)},"adicionarAgenda":_vm.handleAdicionarAgenda,"editAgenda":_vm.handleAdicionarAgenda}})}),1)],1)],1)}),0),_vm._v(" "),(_vm.showFormAgenda)?_c('agenda-form',{attrs:{"index":_vm.codagenda,"crud":_vm.crud,"params":_vm.paramsAgenda},on:{"closeform":_vm.closeAgenda}}):_vm._e(),_vm._v(" "),(_vm.noDateList.length > 0)?_c('crm-painel-timeline-teste'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_painel_list_vue__ = __webpack_require__(707);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7add0dc8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_painel_list_vue__ = __webpack_require__(1996);
function injectStyle (ssrContext) {
  __webpack_require__(1994)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_painel_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7add0dc8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_painel_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1995);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("449fc698", content, true, {});

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".list-title{display:inline-block;max-width:100%;font-weight:700;color:#4993d2}.list-icon{font-size:24px;align-items:center;justify-content:center;background-color:#f5f5f5;border:1px solid #e0e0e0;box-sizing:border-box;height:38px;width:42px;flex-shrink:0}", ""]);

// exports


/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-container"},[(_vm.datasNegociosList.length == 0)?_c('div',{staticClass:"no-content mb-4"},[_vm._v("\n        Nenhum negócio encontrado\n    ")]):_vm._e(),_vm._v(" "),_vm._l(((_vm.datasNegociosList)),function(datas,indexData){return _c('div',{key:indexData},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"section mt-3"},[_c('span',[_vm._v(_vm._s(datas.data))])])])]),_vm._v(" "),_vm._l((datas.negocios),function(negocio,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"row p-2"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"col-md-5 col-12"},[_c('span',{staticClass:"list-title"},[_vm._v(_vm._s(negocio.titulo))]),_vm._v(" "),_c('span',{staticClass:"tag-input-color float-right",style:('background-color: ' + negocio.tag_cor)},[_vm._v(_vm._s(negocio.tag_descricao)+" ")]),_vm._v(" "),(negocio.stnegocio == 'G')?_c('span',{staticClass:"badge badge-green float-right pr-2"},[_vm._v("GANHO")]):_vm._e(),_vm._v(" "),(negocio.stnegocio == 'P')?_c('span',{staticClass:"badge badge-red float-right pr-2"},[_vm._v("PERDIDO")]):_vm._e(),_vm._v(" "),(negocio.excluido=='S')?_c('span',{staticClass:"badge badge-red ml-2"},[_vm._v("Excluído")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('span',{staticClass:"lbl-list-detalhe"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataHoraExtenso")(negocio.data)))]),_vm._v(" "),_c('span',{staticClass:"lbl-list-detalhe"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(negocio.nome_usuario))]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_c('i',{staticClass:"fa fa-user",staticStyle:{"width":"20px"},attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(negocio.pessoa_nome))]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_c('i',{staticClass:"fa fa-university",staticStyle:{"width":"20px"},attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(negocio.org_nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('span',{staticClass:"lbl-list w-100"},[_vm._v(" "+_vm._s(_vm.metadata.negociocrm.valor.label)+" ")]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(_vm._f("formatValue")(negocio.valor,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[(negocio.dias_atividade>0)?_c('span',{staticClass:"icon icon-atrasado",attrs:{"title":'Atividade atrasada há ' + negocio.dias_atividade + ' dias',"data-toggle":"tooltip","data-placement":"top"}},[_c('i',{staticClass:"fa fa-calendar",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(negocio.count_agenda == 0)?_c('span',{staticClass:"icon icon-sem-agenda",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Nenhuma atividade"}},[_c('i',{staticClass:"fa fa-warning",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(negocio.count_agenda > 0 && negocio.dias_atividade <= 0)?_c('span',{staticClass:"icon icon-agenda",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Atividade planejada"}},[_c('i',{staticClass:"fa fa-calendar",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(!negocio.proxima_atividade)?_c('label',{staticClass:"lbl-list icon-sem-agenda"},[_vm._v("Sem Atividade")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list",style:(_vm.handleStyleAgenda(negocio))},[_vm._v(" "+_vm._s(_vm.formatDate(negocio.proxima_atividade))+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-auto ml-auto"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnDelete: false, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.handleEditNegocio(negocio.codnegocio)},"view":function($event){return _vm.handleEditNegocio(negocio.codnegocio, true)},"delete":function($event){return _vm.handleDelete(negocio)}}})],1)])])})],2)}),_vm._v(" "),_c('div',[(_vm.nextPage>0)?_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){return _vm.handleMore()}}},[_vm._v("Exibir mais")]):_vm._e()])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto text-center"},[_c('div',{staticClass:"list-icon"},[_c('i',{staticClass:"fa fa-dollar",attrs:{"aria-hidden":"true"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1998);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3f9abc2e", content, true, {});

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2000);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("22df1789", content, true, {});

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".pipelineSummary{position:relative;height:auto}.pipelineSummary .pipelineStages{position:relative;display:table;height:24px;overflow:visible}.pipelineSummary .pipelineStages ul{width:100%;display:table;border-collapse:collapse;table-layout:fixed;height:24px;-ms-box-sizing:border-box;-o-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.pipelineSummary .pipelineStages ul li .stageContent{position:relative}.pipelineSummary .pipelineStages ul li{position:relative;background:#e5e5e5;display:table-cell;text-align:left;line-height:24px;vertical-align:middle;color:#fff;text-align:center;cursor:pointer;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.pipelineSummary .pipelineStages ul li:first-child{-moz-border-top-left-radius:4px;border-top-left-radius:4px;-moz-border-bottom-left-radius:4px;border-bottom-left-radius:4px}.pipelineSummary .pipelineStages ul li .stageContent .stagename{font:400 13px/16px Source Sans Pro,sans-serif;display:inline-block;position:relative;left:4px}.pipelineSummary .pipelineStages ul li .stageContent .stageArrow{width:6px;height:30px;position:absolute;top:-16px;left:0;overflow:hidden}.pipelineSummary .pipelineStages ul li .stageContent .stageArrow:after{width:22px;height:22px;position:absolute;right:-7px;top:5px;border-top:3px solid #fff;border-right:3px solid #fff;transform:scaleX(.3) rotate(45deg);content:\" \";cursor:pointer;background:#e5e5e5}.pipelineSummary .pipelineStages.open ul li.active,.pipelineSummary .pipelineStages.open ul li.active .stageContent .stageArrow:after,.pipelineSummary .pipelineStages.won ul li.active,.pipelineSummary .pipelineStages.won ul li.active .stageContent .stageArrow:after{background:#174b79}.pipelineSummary .pipelineStages.open ul li.active+li .stageContent .stageArrow:after,.pipelineSummary .pipelineStages.won ul li.active+li .stageContent .stageArrow:after{border-top:3px solid #fff;border-right:3px solid #fff;background:#174b79}.pipelineSummary .pipelineStages ul li:first-child .stageContent .stageArrow{display:none}", ""]);

// exports


/***/ }),
/* 2001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pipelineSummary"},[_c('div',{staticClass:"row col align-itens-center"},[_c('v-label',{attrs:{"label":"Selecione a Etapa do Negócio"}})],1),_vm._v(" "),_c('div',{staticClass:"pipelineStages open"},[_c('ul',_vm._l((_vm.etapaList),function(etapa,index){return _c('li',{key:index,class:_vm.isActive(index),staticStyle:{"height":"35px","clip-path":"polygon(calc(100% - 6px) 0,100% 50%,calc(100% - 6px) 100%,2px 100%,8px 50%,2px 0)"},attrs:{"title":etapa.descricao,"data-toggle":"tooltip","data-placement":"top"},on:{"click":function($event){return _vm.handleSelectEtapa(index)}}},[_c('div',{staticClass:"stageContent"},[(etapa.texto_dias)?_c('span',{staticClass:"stagename"},[_vm._v(_vm._s(etapa.texto_dias))]):_vm._e()])])}),0)]),_vm._v(" "),_c('div',{staticClass:"row col align-itens-center"},[_c('span',{staticClass:"pipelineInfo mr-2"},[_vm._v(" "+_vm._s(_vm.funil.descricao)+" ")]),_vm._v(" "),(_vm.selectedEtapa)?_c('span',{staticClass:"pipelineInfo"},[_c('i',{staticClass:"fa fa-chevron-right mr-2"}),_vm._v(" "+_vm._s(_vm.selectedEtapa.descricao)+" ")]):_c('span',{staticClass:"pipelineInfo"},[_c('i',{staticClass:"fa fa-chevron-right mr-2"}),_vm._v(" Selecione uma etapa ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2003);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e296bf1a", content, true, {});

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2005);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e3ba2dda", content, true, {});

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".input-color{z-index:1051;position:absolute;top:80%;max-width:100%;display:block;list-style:none;background-color:#fff;border:1px solid #ccc;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);-moz-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2)}.input-color .active{color:#fff;background-color:#317ae2}.input-color *,.input-color-data{white-space:normal!important}.input-color-title{display:inline-block;max-width:100%;margin-bottom:5px;margin-right:5px;font-size:18px}.input-color .faixa{height:35px}.input-color .faixa:hover{background-color:#317ae2;cursor:pointer}.input-tag{margin-right:15px;min-width:50px}.input-color-footer{-ms-flex-align:center;align-items:center;-ms-flex-pack:end;width:100%;border-top:1px solid #c9d3dd}.teste-cursor{color:#fff;background:#fff;text-shadow:0 0 0 #2196f3}.teste-cursor:focus{outline:none}", ""]);

// exports


/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('div',{staticClass:"form-group form-group-sm"},[((_vm.params.label || _vm.metadata))?_c('div',[_c('v-label',{attrs:{"label":_vm.params.label}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn-group dropright"},[_c('button',{ref:"pesquisa",staticClass:"btn btn-outline-secondary btn-sm dropdown-toggle",staticStyle:{"min-width":"100px","border-radius":"0%"},attrs:{"data-toggle":"dropdown"}},[(!_vm.selected)?_c('span',[_vm._v("Nenhum")]):_vm._e(),_vm._v(" "),(_vm.selected)?_c('span',{staticClass:"input-tag tag-input-color",style:(_vm.handleStyle(_vm.selected.cor))},[_vm._v(_vm._s(_vm.selected.title))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},[_c('div',{staticClass:"w-100"},_vm._l((_vm.list),function(item,index){return _c('a',{key:index,staticClass:"dropdown-item mb-2",attrs:{"href":"#"},on:{"click":function($event){return _vm.handleSelectItem(index)}}},[(_vm.params.edit && _vm.administrador)?_c('i',{staticClass:"fa fa-pencil mt-1 pr-3",attrs:{"title":"Editar"},on:{"click":function($event){return _vm.handleEditar(index)}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"tag-input-color",style:(_vm.handleStyle(item.cor))},[_vm._v(" "+_vm._s(item.title)+" ")])])}),0),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){return _vm.handleSelectItem(null)}}},[_vm._v("Sem Etiqueta")]),_vm._v(" "),(_vm.params.edit && _vm.administrador)?_c('div',[_c('div',{staticClass:"divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":_vm.handleAdicionar}},[_vm._v("Incluir Etiqueta")])]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2008);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("bf52d032", content, true, {});

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"600px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h4',{staticClass:"def-title"},[_vm._v(_vm._s(_vm.title)+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.tagcrm.descricao.validator),expression:"metadata.tagcrm.descricao.validator"}],ref:"descricao",attrs:{"case":"normal","type":"text","col":"12","metadata":_vm.metadata.tagcrm.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.tagcrm.descricao),callback:function ($$v) {_vm.$set(_vm.tagcrm, "descricao", $$v)},expression:"tagcrm.descricao"}})],1),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('input-color',{attrs:{"params":_vm.params},model:{value:(_vm.tagcrm.cor),callback:function ($$v) {_vm.$set(_vm.tagcrm, "cor", $$v)},expression:"tagcrm.cor"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row col mb-3"},[_c('v-button',{attrs:{"label":"Salvar","nb-btdef":true},on:{"click":_vm.handleSalvar}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.closeForm}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2011);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("44c82f37", content, true, {});

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"600px","min-width":"500px","max-width":"100%"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select2","col":"12","metadata":_vm.metadata.negociocrm.codmotivo},model:{value:(_vm.negociocrm.codmotivo),callback:function ($$v) {_vm.$set(_vm.negociocrm, "codmotivo", $$v)},expression:"negociocrm.codmotivo"}},[(_vm.administrador)?_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleCadastroMotivo}},[_vm._v("Acesso ao cadastro de motivos")]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"row mt-2 mb-5"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.negociocrm.textomotivo.validator),expression:"metadata.negociocrm.textomotivo.validator"}],attrs:{"type":"memo","col":"12","metadata":_vm.metadata.negociocrm.textomotivo,"name":"textomotivo","v-errors":_vm.errors},model:{value:(_vm.negociocrm.textomotivo),callback:function ($$v) {_vm.$set(_vm.negociocrm, "textomotivo", $$v)},expression:"negociocrm.textomotivo"}})],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"label":"Cancelar","title":"","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Confirmar Como Perdido","title":"","danger":true},on:{"click":_vm.handleSalvar}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v(" Motivo da Perda ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"600px","min-width":"500px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[(_vm.isNovoNegocio || _vm.alterarPessoa)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input-search',{ref:"pessoa",attrs:{"isSelect":true,"params":_vm.inputPessoa,"metadata":_vm.metadata.negociocrm.codpessoa},on:{"novo":_vm.handleNovoPessoa,"select":_vm.handleSelectPessoa},model:{value:(_vm.negociocrm.codpessoa),callback:function ($$v) {_vm.$set(_vm.negociocrm, "codpessoa", $$v)},expression:"negociocrm.codpessoa"}})],1)]):_vm._e(),_vm._v(" "),(_vm.pessoa && _vm.pessoa.novo)?_c('div',[_c('div',{staticClass:"row pl-5"},[_c('div',{staticClass:"col-12"},[_c('v-label',{attrs:{"label":"Telefone"}})],1)]),_vm._v(" "),_c('div',_vm._l((_vm.telefones),function(fone,index){return _c('div',{key:index,staticClass:"row pl-5"},[_c('div',{staticClass:"col-md-5"},[_c('input-search',{attrs:{"params":_vm.inputFone},model:{value:(fone.numero),callback:function ($$v) {_vm.$set(fone, "numero", $$v)},expression:"fone.numero"}},[(index == _vm.telefones.length-1)?_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleAdicionarTelefone}},[_vm._v("Adicionar Telefone")]):_vm._e()])],1),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fonecrm.tipofone.validator),expression:"metadata.fonecrm.tipofone.validator"}],attrs:{"type":"select","col":"4","name":'tipofone' + index,"v-errors":_vm.errors},model:{value:(fone.tipofone),callback:function ($$v) {_vm.$set(fone, "tipofone", $$v)},expression:"fone.tipofone"}}),_vm._v(" "),_c('div',{staticClass:"col-auto"},[(_vm.telefones.length>1)?_c('v-button',{attrs:{"icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteTelefone(index)}}}):_vm._e()],1)],1)}),0),_vm._v(" "),_c('div',{staticClass:"row pl-5"},[_c('div',{staticClass:"col-12"},[_c('v-label',{attrs:{"label":"Email"}})],1)]),_vm._v(" "),_c('div',_vm._l((_vm.emails),function(email,index){return _c('div',{key:index,staticClass:"row pl-5"},[_c('div',{staticClass:"col-md-5"},[_c('input-search',{attrs:{"params":_vm.inputEmail},model:{value:(email.email),callback:function ($$v) {_vm.$set(email, "email", $$v)},expression:"email.email"}},[(index == _vm.telefones.length-1)?_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleAdicionarEmail}},[_vm._v("Adicionar Email")]):_vm._e()])],1),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.emailcrm.tipoemail.validator),expression:"metadata.emailcrm.tipoemail.validator"}],attrs:{"type":"select","col":"4","name":'tipoemail' + index,"v-errors":_vm.errors},model:{value:(email.tipoemail),callback:function ($$v) {_vm.$set(email, "tipoemail", $$v)},expression:"email.tipoemail"}}),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-1"},[(_vm.emails.length>1)?_c('v-button',{attrs:{"icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteEmail(index)}}}):_vm._e()],1)],1)}),0)]):_c('div',[_vm._l((_vm.telefones),function(fone,index){return _c('div',{key:index,staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-5 pl-5"},[_c('i',{staticClass:"fa fa-phone pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(_vm._f("formatFone")(fone.numero))+" ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(_vm._f("getTextOption")(fone.tipofone,_vm.metadata.fonecrm.tipofone))+" ")])])])}),_vm._v(" "),_vm._l((_vm.emails),function(email,index){return _c('div',{key:index,staticClass:"row align-items-center mb-1"},[_c('div',{staticClass:"col-md-5 pl-5"},[_c('i',{staticClass:"fa fa-envelope pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(email.email)+" ")])])])})],2),_vm._v(" "),(_vm.isNovoNegocio || _vm.alterarOrg)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input-search',{ref:"organizacao",attrs:{"isSelect":true,"params":_vm.inputOrg,"metadata":_vm.metadata.negociocrm.codorg},on:{"novo":_vm.handleNovoOrg,"select":_vm.handleSelectOrg},model:{value:(_vm.negociocrm.codorg),callback:function ($$v) {_vm.$set(_vm.negociocrm, "codorg", $$v)},expression:"negociocrm.codorg"}})],1)]):_vm._e(),_vm._v(" "),(_vm.alterarOutrosCampos)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.negociocrm.titulo.validator),expression:"metadata.negociocrm.titulo.validator"}],attrs:{"type":"text","col":"12","metadata":_vm.metadata.negociocrm.titulo,"name":"titulo","v-errors":_vm.errors},model:{value:(_vm.negociocrm.titulo),callback:function ($$v) {_vm.$set(_vm.negociocrm, "titulo", $$v)},expression:"negociocrm.titulo"}})],1):_vm._e(),_vm._v(" "),(_vm.localFunil && _vm.isNovoNegocio)?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('crm-pipeline',{attrs:{"negocio":_vm.negociocrm,"funil":_vm.localFunil,"negocio-novo-form":true},on:{"change":_vm.handleChangeEtapa}})],1)]):_vm._e(),_vm._v(" "),(_vm.alterarOutrosCampos)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('input-color',{ref:"etiqueta",attrs:{"params":{ edit: true, label: 'Etiqueta', url: 'crm/tag/list/negocio' }},on:{"editar":_vm.handleEditarTag,"adicionar":_vm.handleAdicionarTag},model:{value:(_vm.negociocrm.codtag),callback:function ($$v) {_vm.$set(_vm.negociocrm, "codtag", $$v)},expression:"negociocrm.codtag"}})],1)]):_vm._e(),_vm._v(" "),(_vm.alterarOutrosCampos)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.negociocrm.dataprevista.validator),expression:"metadata.negociocrm.dataprevista.validator"}],attrs:{"type":"date","col":"6","metadata":_vm.metadata.negociocrm.dataprevista,"name":"dataprevista","v-errors":_vm.errors},model:{value:(_vm.negociocrm.dataprevista),callback:function ($$v) {_vm.$set(_vm.negociocrm, "dataprevista", $$v)},expression:"negociocrm.dataprevista"}})],1):_vm._e(),_vm._v(" "),(_vm.alterarOutrosCampos)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.negociocrm.valor.validator),expression:"metadata.negociocrm.valor.validator"}],attrs:{"type":"value","col":"6","metadata":_vm.metadata.negociocrm.valor,"preaddon":"R$","name":"valor","v-errors":_vm.errors},model:{value:(_vm.negociocrm.valor),callback:function ($$v) {_vm.$set(_vm.negociocrm, "valor", $$v)},expression:"negociocrm.valor"}})],1):_vm._e(),_vm._v(" "),(_vm.alterarOutrosCampos)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.negociocrm.probabilidade.validator),expression:"metadata.negociocrm.probabilidade.validator"}],attrs:{"type":"value","col":"6","metadata":_vm.metadata.negociocrm.probabilidade,"addon":"%","name":"probabilidade","v-errors":_vm.errors},model:{value:(_vm.negociocrm.probabilidade),callback:function ($$v) {_vm.$set(_vm.negociocrm, "probabilidade", $$v)},expression:"negociocrm.probabilidade"}})],1):_vm._e(),_vm._v(" "),(_vm.alterarOutrosCampos)?_c('div',{staticClass:"row mb-5"},[_c('form-field',{attrs:{"type":"select2","col":"12","metadata":_vm.metadata.negociocrm.codorigem},model:{value:(_vm.negociocrm.codorigem),callback:function ($$v) {_vm.$set(_vm.negociocrm, "codorigem", $$v)},expression:"negociocrm.codorigem"}},[(_vm.administrador)?_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleCadastroOrigem}},[_vm._v("Acesso ao cadastro de origem")]):_vm._e()])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"label":"Cancelar","title":"","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Salvar","title":"","nb-btdef":true},on:{"click":_vm.handleSalvar}})],1)]),_vm._v(" "),(_vm.showTagForm)?_c('crm-tag-form',{attrs:{"tptag":"N","index":_vm.codtag,"crud":_vm.crudTag},on:{"closeform":_vm.handleCloseTag}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2015);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("44bb3113", content, true, {});

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"600px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-header"},[(_vm.orgcrm.codorg)?_c('h4',{staticClass:"def-title"},[_vm._v("Alterar Organização")]):_c('h4',{staticClass:"def-title"},[_vm._v("Nova Organização")])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[(_vm.transformarPart)?_c('alert',{attrs:{"type":"info","title":"Aviso","text":"Informe alguns dados obrigatórios para criação de um orçamento."}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input-search',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.orgcrm.nome.validator),expression:"metadata.orgcrm.nome.validator"}],ref:"nome",attrs:{"params":_vm.inputNome,"metadata":_vm.metadata.orgcrm.nome,"name":"nome","v-errors":_vm.errors},model:{value:(_vm.orgcrm.nome),callback:function ($$v) {_vm.$set(_vm.orgcrm, "nome", $$v)},expression:"orgcrm.nome"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('input-color',{ref:"etiqueta",attrs:{"params":{ edit: true, label: 'Etiqueta', url: 'crm/tag/list/pessoa' }},on:{"editar":_vm.handleEditarTag,"adicionar":_vm.handleAdicionarTag},model:{value:(_vm.orgcrm.codtag),callback:function ($$v) {_vm.$set(_vm.orgcrm, "codtag", $$v)},expression:"orgcrm.codtag"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.orgcrm.codusuario.validator),expression:"metadata.orgcrm.codusuario.validator"}],ref:"usuario",attrs:{"type":"select2","col":"6","metadata":_vm.metadata.orgcrm.codusuario,"name":"codusuario","v-errors":_vm.errors},model:{value:(_vm.orgcrm.codusuario),callback:function ($$v) {_vm.$set(_vm.orgcrm, "codusuario", $$v)},expression:"orgcrm.codusuario"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.orgcrm.cnpj.validator),expression:"metadata.orgcrm.cnpj.validator"}],attrs:{"type":"number","col":"6","metadata":_vm.metadata.orgcrm.cnpj,"name":"cnpj","v-errors":_vm.errors},model:{value:(_vm.orgcrm.cnpj),callback:function ($$v) {_vm.$set(_vm.orgcrm, "cnpj", $$v)},expression:"orgcrm.cnpj"}})],1),_vm._v(" "),_c('label-title',{staticClass:"mb-2",attrs:{"title":"Endereço"}}),_vm._v(" "),_c('div',{staticClass:"row pb-3"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"type":"select2","col":"6","metadata":_vm.metadata.orgcrm.codmun,"name":"codmun","v-errors":_vm.errors,"select2":{entity: 'mun/', minlength: 2}},model:{value:(_vm.orgcrm.codmun),callback:function ($$v) {_vm.$set(_vm.orgcrm, "codmun", $$v)},expression:"orgcrm.codmun"}})],1),_vm._v(" "),(_vm.transformarPart)?_c('div',[_c('label-title',{staticClass:"mb-2",attrs:{"title":"Informações Necessárias Para Orçamento"}}),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.contricms.validator),expression:"metadata.part.contricms.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.contricms,"name":"contricms","v-errors":_vm.errors},model:{value:(_vm.part.contricms),callback:function ($$v) {_vm.$set(_vm.part, "contricms", $$v)},expression:"part.contricms"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.iest.validator),expression:"metadata.part.iest.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.part.iest,"name":"iest","v-errors":_vm.errors},model:{value:(_vm.part.iest),callback:function ($$v) {_vm.$set(_vm.part, "iest", $$v)},expression:"part.iest"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.optsimples.validator),expression:"metadata.part.optsimples.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.optsimples,"name":"optsimples","v-errors":_vm.errors},model:{value:(_vm.part.optsimples),callback:function ($$v) {_vm.$set(_vm.part, "optsimples", $$v)},expression:"part.optsimples"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.tpcliente.validator),expression:"metadata.part.tpcliente.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.tpcliente,"name":"tpcliente","v-errors":_vm.errors},model:{value:(_vm.part.tpcliente),callback:function ($$v) {_vm.$set(_vm.part, "tpcliente", $$v)},expression:"part.tpcliente"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.zfranca.validator),expression:"metadata.part.zfranca.validator"}],attrs:{"type":"select","col":"4","metadata":_vm.metadata.part.zfranca,"name":"zfranca","v-errors":_vm.errors},model:{value:(_vm.part.zfranca),callback:function ($$v) {_vm.$set(_vm.part, "zfranca", $$v)},expression:"part.zfranca"}}),_vm._v(" "),(_vm.part.zfranca == 'S')?_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.part.inscsuframa.validator),expression:"metadata.part.inscsuframa.validator"}],attrs:{"type":"text","col":"4","metadata":_vm.metadata.part.inscsuframa,"name":"inscsuframa","v-errors":_vm.errors},model:{value:(_vm.part.inscsuframa),callback:function ($$v) {_vm.$set(_vm.part, "inscsuframa", $$v)},expression:"part.inscsuframa"}}):_vm._e()],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{staticClass:"float-right",attrs:{"label":"Cancelar","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}}),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Salvar","nb-btdef":true},on:{"click":_vm.handleSalvar}})],1)]),_vm._v(" "),(_vm.showTagForm)?_c('crm-tag-form',{attrs:{"tptag":"P","index":_vm.codtag,"crud":_vm.crudTag},on:{"closeform":_vm.handleCloseTag}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2018);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("91dab0a6", content, true, {});

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"600px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-header"},[(_vm.pessoacrm.codpessoa)?_c('h4',{staticClass:"def-title"},[_vm._v("Alterar Contato")]):_c('h4',{staticClass:"def-title"},[_vm._v("Novo Contato")])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[(!_vm.params)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input-search',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pessoacrm.nome.validator),expression:"metadata.pessoacrm.nome.validator"}],ref:"nome",attrs:{"params":_vm.inputNome,"metadata":_vm.metadata.pessoacrm.nome,"name":"nome","v-errors":_vm.errors},model:{value:(_vm.pessoacrm.nome),callback:function ($$v) {_vm.$set(_vm.pessoacrm, "nome", $$v)},expression:"pessoacrm.nome"}})],1)]):_vm._e(),_vm._v(" "),(!_vm.params || _vm.params.org)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input-search',{ref:"organizacao",attrs:{"isSelect":true,"params":_vm.inputOrg,"metadata":_vm.metadata.pessoacrm.codorg},on:{"novo":_vm.handleNovoOrg,"select":_vm.handleSelectOrg},model:{value:(_vm.pessoacrm.codorg),callback:function ($$v) {_vm.$set(_vm.pessoacrm, "codorg", $$v)},expression:"pessoacrm.codorg"}})],1)]):_vm._e(),_vm._v(" "),(!_vm.params)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('input-color',{ref:"etiqueta",attrs:{"params":{ edit: true, label: 'Etiqueta', url: 'crm/tag/list/pessoa' }},on:{"editar":_vm.handleEditarTag,"adicionar":_vm.handleAdicionarTag},model:{value:(_vm.pessoacrm.codtag),callback:function ($$v) {_vm.$set(_vm.pessoacrm, "codtag", $$v)},expression:"pessoacrm.codtag"}})],1)]):_vm._e(),_vm._v(" "),(!_vm.params || _vm.params.fone)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-label',{attrs:{"label":"Telefones"}})],1)]),_vm._v(" "),_vm._l((_vm.telefones),function(fone,index){return _c('div',{key:index,staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('input-search',{attrs:{"type":"fone","params":_vm.inputFone},model:{value:(fone.numero),callback:function ($$v) {_vm.$set(fone, "numero", $$v)},expression:"fone.numero"}},[(index == _vm.telefones.length-1)?_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleAdicionarTelefone}},[_vm._v("Adicionar Telefone")]):_vm._e()])],1),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fonecrm.tipofone.validator),expression:"metadata.fonecrm.tipofone.validator"}],attrs:{"type":"select","col":"5","name":'tipofone' + index,"v-errors":_vm.errors},model:{value:(fone.tipofone),callback:function ($$v) {_vm.$set(fone, "tipofone", $$v)},expression:"fone.tipofone"}}),_vm._v(" "),_c('div',{staticClass:"col-auto"},[(_vm.telefones.length>1)?_c('v-button',{attrs:{"icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteTelefone(index)}}}):_vm._e()],1)],1)})],2):_vm._e(),_vm._v(" "),(!_vm.params || _vm.params.email)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-label',{attrs:{"label":"Emails"}})],1)]),_vm._v(" "),_vm._l((_vm.emails),function(email,index){return _c('div',{key:index},[_c('div',{staticClass:"row mb-1"},[_c('div',{staticClass:"col-md-5"},[_c('input-search',{attrs:{"params":_vm.inputEmail},model:{value:(email.email),callback:function ($$v) {_vm.$set(email, "email", $$v)},expression:"email.email"}},[(index == _vm.emails.length-1)?_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleAdicionarEmail}},[_vm._v("Adicionar Email")]):_vm._e()])],1),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.emailcrm.tipoemail.validator),expression:"metadata.emailcrm.tipoemail.validator"}],attrs:{"type":"select","col":"5","name":'tipoemail' + index,"v-errors":_vm.errors},model:{value:(email.tipoemail),callback:function ($$v) {_vm.$set(email, "tipoemail", $$v)},expression:"email.tipoemail"}}),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-1"},[(_vm.emails.length>1)?_c('v-button',{attrs:{"icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteEmail(index)}}}):_vm._e()],1)],1)])})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{staticClass:"float-right",attrs:{"label":"Cancelar","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}}),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Salvar","nb-btdef":true},on:{"click":_vm.handleSalvar}})],1)]),_vm._v(" "),(_vm.showTagForm)?_c('crm-tag-form',{attrs:{"tptag":"P","index":_vm.codtag,"crud":_vm.crudTag},on:{"closeform":_vm.handleCloseTag}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2021);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("093de582", content, true, {});

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"600px","min-width":"500px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_vm._l((_vm.listParticipantes),function(item,index){return _c('div',{key:index,staticClass:"mainbox mt-3"},[_c('div',{staticClass:"row mb-2 align-items-center"},[_c('div',{staticClass:"col-md-10"},[_c('i',{staticClass:"fa fa-user pr-2",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.pessoa[0].nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('v-button',{staticClass:"float-right",attrs:{"label":"","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDelete(index)}}})],1)])])}),_vm._v(" "),(!_vm.addingParticipante)?_c('div',{staticClass:"row col mb-2"},[_c('v-button',{attrs:{"label":"Adicionar Contato","link":true,"icon":"fa-plus"},on:{"click":_vm.handleIncluirPessoa}})],1):_vm._e(),_vm._v(" "),(_vm.addingParticipante)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input-search',{ref:"pessoa",attrs:{"params":_vm.inputPessoa,"metadata":_vm.metadata.negociocrm.codpessoa},on:{"novo":_vm.handleIncluirPessoa,"select":_vm.handleSelectPessoa},model:{value:(_vm.codpessoa),callback:function ($$v) {_vm.codpessoa=$$v},expression:"codpessoa"}})],1)]),_vm._v(" "),(_vm.pessoa && _vm.pessoa.novo)?_c('div',[_c('div',{staticClass:"row pl-5"},[_c('div',{staticClass:"col-12"},[_c('v-label',{attrs:{"label":"Telefone"}})],1)]),_vm._v(" "),_vm._l((_vm.telefones),function(fone,index){return _c('div',{key:index,staticClass:"row pl-5"},[_c('div',{staticClass:"col-md-5"},[_c('input-search',{attrs:{"params":_vm.inputFone},model:{value:(fone.numero),callback:function ($$v) {_vm.$set(fone, "numero", $$v)},expression:"fone.numero"}},[(index == _vm.telefones.length-1)?_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleAdicionarTelefone}},[_vm._v("Adicionar Telefone")]):_vm._e()])],1),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.fonecrm.tipofone.validator),expression:"metadata.fonecrm.tipofone.validator"}],attrs:{"type":"select","col":"4","name":'tipofone' + index,"v-errors":_vm.errors},model:{value:(fone.tipofone),callback:function ($$v) {_vm.$set(fone, "tipofone", $$v)},expression:"fone.tipofone"}}),_vm._v(" "),_c('div',{staticClass:"col-auto"},[(_vm.telefones.length>1)?_c('v-button',{attrs:{"icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteTelefone(index)}}}):_vm._e()],1)],1)}),_vm._v(" "),_c('div',{staticClass:"row pl-5"},[_c('div',{staticClass:"col-12"},[_c('v-label',{attrs:{"label":"Email"}})],1)]),_vm._v(" "),_vm._l((_vm.emails),function(email,index){return _c('div',{key:index},[_c('div',{staticClass:"row pl-5"},[_c('div',{staticClass:"col-md-5"},[_c('input-search',{attrs:{"params":_vm.inputEmail},model:{value:(email.email),callback:function ($$v) {_vm.$set(email, "email", $$v)},expression:"email.email"}},[(index == _vm.telefones.length-1)?_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleAdicionarEmail}},[_vm._v("Adicionar Email")]):_vm._e()])],1),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.emailcrm.tipoemail.validator),expression:"metadata.emailcrm.tipoemail.validator"}],attrs:{"type":"select","col":"4","name":'tipoemail' + index,"v-errors":_vm.errors},model:{value:(email.tipoemail),callback:function ($$v) {_vm.$set(email, "tipoemail", $$v)},expression:"email.tipoemail"}}),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-1"},[(_vm.emails.length>1)?_c('v-button',{attrs:{"icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteEmail(index)}}}):_vm._e()],1)],1)])})],2):_c('div',[_vm._l((_vm.telefones),function(fone,index){return _c('div',{key:index,staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-5 pl-5"},[_c('i',{staticClass:"fa fa-phone pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(_vm._f("formatFone")(fone.numero))+" ")])])])}),_vm._v(" "),_vm._l((_vm.emails),function(email,index){return _c('div',{key:index,staticClass:"row align-items-center mb-1"},[_c('div',{staticClass:"col-md-5 pl-5"},[_c('i',{staticClass:"fa fa-envelope pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(email.email)+" ")])])])})],2),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-3 text-right"},[_c('v-button',{attrs:{"label":"Cancelar","tabindex":"1"},on:{"click":function($event){_vm.addingParticipante = false}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Salvar","icon":"fa-download","success":true},on:{"click":_vm.handleSalvar}})],1)]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"label":"Fechar","title":""},on:{"click":_vm.closeForm}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2024);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7a7b6583", content, true, {});

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"600px","min-width":"500px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-header",attrs:{"id":"mymodal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_vm._l((_vm.listSeguidores),function(item,index){return _c('div',{key:index,staticClass:"mainbox mt-3"},[_c('div',{staticClass:"row mb-2 align-items-center"},[_c('div',{staticClass:"col-md-10"},[_c('i',{staticClass:"fa fa-user-circle pr-2",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.usuario_nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('v-button',{staticClass:"float-right",attrs:{"label":"","icon":"fa-trash"},on:{"click":function($event){return _vm.handleDelete(index)}}})],1)])])}),_vm._v(" "),(!_vm.addingSeguidor)?_c('div',{staticClass:"row col mb-4"},[_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleIncluirSeguidor}},[_vm._v("Adicionar usuário")])]):_vm._e(),_vm._v(" "),(_vm.addingSeguidor)?_c('div',[_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select2","col":"12","metadata":_vm.metadata.seguidorcrm.codusuario,"select2":{entity: 'usuario', minlength: 0}},model:{value:(_vm.codseguidor),callback:function ($$v) {_vm.codseguidor=$$v},expression:"codseguidor"}}),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-3 text-right"},[_c('v-button',{attrs:{"label":"Cancelar","tabindex":"1"},on:{"click":function($event){_vm.addingSeguidor = false}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Salvar","icon":"fa-download","success":true},on:{"click":_vm.handleSalvar}})],1)],1)]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"label":"Fechar","title":""},on:{"click":_vm.closeForm}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2027);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("fbf2ec0a", content, true, {});

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 mt-2"},[_vm._l((_vm.listAgenda),function(item,index){return _c('div',{key:index,staticClass:"mb-2"},[_c('div',{staticClass:"align-items-center",staticStyle:{"display":"flex"}},[_c('div',{staticClass:"col-1 text-center"},[(item.tpagenda == 'L')?_c('i',{staticClass:"fa fa-phone lbl-deal-subtitle"}):_vm._e(),_vm._v(" "),(item.tpagenda == 'V')?_c('i',{staticClass:"fa fa-car lbl-deal-subtitle"}):_vm._e(),_vm._v(" "),(item.tpagenda == 'A')?_c('i',{staticClass:"fa fa-tasks lbl-deal-subtitle"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card p-2 col-11"},[_c('div',{staticClass:"w-100"},[(_vm.params.delete)?_c('v-button',{staticClass:"float-right",attrs:{"link":true,"icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteAgenda(item.codagenda)}}}):_vm._e(),_vm._v(" "),(_vm.params.edit)?_c('v-button',{staticClass:"float-right",attrs:{"link":true,"icon":"fa-pencil"},on:{"click":function($event){return _vm.handleEditAgenda(item.codagenda)}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_c('strong',[_vm._v(_vm._s(item.titulo))])])],1),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('span',{staticClass:"lbl-list pr-3",class:{'atrasado': item.dias_atraso > 0 && item.concluida!='S' }},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataHoraExtenso")(item.dataagendada))+" ")]),_vm._v(" "),_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(item.usuario_nome))]),_vm._v(" "),(item.concluida=='S')?_c('span',{staticClass:"badge badge-green mb-2 float-right"},[_vm._v("Atividade Concluída")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"w-100"},[(item.pessoa_nome)?_c('a',{staticClass:"lbl-list mr-2",attrs:{"href":'#/crm/pessoa/'+item.codpessoa}},[_c('i',{staticClass:"fa fa-user mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(item.pessoa_nome))]):_vm._e(),_vm._v(" "),(item.org_nome)?_c('a',{staticClass:"lbl-list mr-2",attrs:{"href":'#/crm/organizacao/'+item.codorg}},[_c('i',{staticClass:"fa fa-university mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(item.org_nome))]):_vm._e(),_vm._v(" "),(item.negocio_titulo)?_c('a',{staticClass:"lbl-list mr-2",attrs:{"href":'#/crm/negocio/'+item.codnegocio}},[_c('i',{staticClass:"fa fa-dollar mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(item.negocio_titulo))]):_vm._e()])])])])}),_vm._v(" "),(_vm.showFormAgenda)?_c('agenda-form',{attrs:{"index":_vm.codagenda,"crud":_vm.crud,"params":_vm.paramsAgenda},on:{"closeform":_vm.closeFormAgenda}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2030);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("64e7a45e", content, true, {});

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".attach-icon[data-v-761d25a2]{font-size:18px}.attach-file[data-v-761d25a2]{cursor:pointer}.badge-email[data-v-761d25a2]{display:inline-block;padding:0 5px;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;background:#fff;border:1px solid;border-radius:10px;border-color:#ebebeb}.badge-email[data-v-761d25a2]:hover{background-color:#f7f7f7}.close[data-v-761d25a2]:focus,.close[data-v-761d25a2]:hover{text-decoration:none;opacity:.75}.close[data-v-761d25a2]{float:right;font-size:1rem;color:#c5c4c4;opacity:1;margin:3px 5px 0}", ""]);

// exports


/***/ }),
/* 2031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_email_destinatarios_vue__ = __webpack_require__(720);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0bac754_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_email_destinatarios_vue__ = __webpack_require__(2034);
function injectStyle (ssrContext) {
  __webpack_require__(2032)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f0bac754"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_email_destinatarios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0bac754_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_email_destinatarios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2033);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("cda64bdc", content, true, {});

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-12"},[_c('v-label',{attrs:{"label":"Para"}}),_vm._v(" "),_c('input-email-list',{ref:"to",attrs:{"url":_vm.url,"emails":_vm.toList}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCC),expression:"showCC"}],staticClass:"col-12 mt-2"},[_c('v-label',{attrs:{"label":"CC"}}),_vm._v(" "),_c('input-email-list',{ref:"cc",attrs:{"url":_vm.url,"emails":_vm.ccList},on:{"blur":_vm.handleBlurCC}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBCC),expression:"showBCC"}],staticClass:"col-12 mt-2"},[_c('v-label',{attrs:{"label":"CCo"}}),_vm._v(" "),_c('input-email-list',{ref:"bcc",attrs:{"url":_vm.url,"emails":_vm.bccList},on:{"blur":_vm.handleBlurBCC}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-2"},[(!_vm.showCC)?_c('span',{staticClass:"lbl-edit",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.showCC = true}}},[_vm._v("CC")]):_vm._e(),_vm._v(" "),(!_vm.showBCC)?_c('span',{staticClass:"lbl-edit",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.showBCC = true}}},[_vm._v("CCo")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.email && !_vm.editing)?_c('div',{staticClass:"row mb-2 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('v-button',{staticClass:"float-right",attrs:{"link":true,"icon":"fa-compress"},on:{"click":_vm.handleClose}}),_vm._v(" "),_c('v-button',{staticClass:"float-left",attrs:{"link":true,"title":"Encaminhar","icon":"fa-mail-forward"},on:{"click":_vm.handleEncaminhar}}),_vm._v(" "),_c('v-button',{staticClass:"float-left",attrs:{"link":true,"title":"Responder","icon":"fa-mail-reply"},on:{"click":_vm.handleResponder}}),_vm._v(" "),_c('span',{staticClass:"lbl-list float-right"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataHoraExtenso")(_vm.email.data)))]),_vm._v(" "),(_vm.email.usuario_nome)?_c('span',{staticClass:"lbl-list pr-3 mb-3"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.email.usuario_nome))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"lbl-list pr-3 mb-3"},[_vm._v("De ")]),_vm._v(" "),(_vm.email.from_list.length > 0)?_c('span',{staticClass:"data-list"},[_c('strong',[_vm._v(_vm._s(_vm.email.pessoa_nome))]),_vm._v(" "+_vm._s(_vm.email.from_list[0].email))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"lbl-list pr-2"},[_vm._v("Para ")]),_vm._v(" "),_vm._l((_vm.email.to_list),function(to,index){return _c('span',{key:index,staticClass:"data-list pr-2"},[_c('strong',[_vm._v(_vm._s(to.nome))]),_vm._v(" "+_vm._s(to.email))])})],2),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"lbl-list pr-3"},[_vm._v("Assunto ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_c('strong',[_vm._v(" "+_vm._s(_vm.email.subject)+" ")])])]),_vm._v(" "),(_vm.bodyContent)?_c('div',{staticClass:"col-md-12"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.bodyContent)}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.email.attachments),function(file,index){return _c('div',{key:index,staticClass:"col-md-auto mt-2"},[_c('div',{staticClass:"card p-2 attach-file",staticStyle:{"cursor":"pointer"},attrs:{"data-toggle":"tooltip","data-placement":"top","title":file.filename}},[_c('div',{staticClass:"w-100"},[_c('a',{staticClass:"lbl-edit",attrs:{"href":file.url}},[_c('i',{staticClass:"fa fa-paperclip pr-2 attach-icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(file.filename)+" ")])])])])})],2):_vm._e(),_vm._v(" "),(_vm.email && _vm.editing)?_c('div',{staticClass:"row mb-2 align-items-center"},[_c('div',{staticClass:"col-6"},[(_vm.sendMode=='new')?_c('span',{staticClass:"lbl-deal-title"},[_vm._v("Novo E-mail")]):_vm._e(),_vm._v(" "),(_vm.sendMode=='reply')?_c('span',{staticClass:"lbl-deal-title"},[_vm._v("Responder")]):_vm._e(),_vm._v(" "),(_vm.sendMode=='forward')?_c('span',{staticClass:"lbl-deal-title"},[_vm._v("Encaminhar")]):_vm._e(),_vm._v(" "),(_vm.sendMode!='new')?_c('v-button',{staticClass:"float-left",attrs:{"link":true,"title":"Encaminhar","icon":"fa-mail-forward"},on:{"click":_vm.handleEncaminhar}}):_vm._e(),_vm._v(" "),(_vm.sendMode!='new')?_c('v-button',{staticClass:"float-left",attrs:{"link":true,"title":"Responder","icon":"fa-mail-reply"},on:{"click":_vm.handleResponder}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('v-button',{staticClass:"float-right",attrs:{"link":true,"icon":"fa-compress"},on:{"click":_vm.handleClose}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('crm-email-destinatarios',{ref:"destinatarios",attrs:{"destinatarios":_vm.destinatarios,"url":"crm/find/pessoa/email?text="}})],1),_vm._v(" "),_c('form-field',{attrs:{"type":"text","col":"12","label":"Assunto"},model:{value:(_vm.editingSubject),callback:function ($$v) {_vm.editingSubject=$$v},expression:"editingSubject"}}),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('wysiwyg',{model:{value:(_vm.bodyContent),callback:function ($$v) {_vm.bodyContent=$$v},expression:"bodyContent"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-2"},_vm._l((_vm.editingAttachments),function(file,index){return _c('div',{key:index},[(!file.excluido)?_c('div',{staticClass:"data-list badge-email mr-2",attrs:{"role":"alert"}},[_c('button',{staticClass:"close",attrs:{"type":"button","tabindex":"1","data-dismiss":"alert"},on:{"click":function($event){return _vm.handleRemoverAnexo(index)}}},[_vm._v("\n                        x")]),_vm._v(" "),_c('label',{staticClass:"mt-1"},[_c('i',{staticClass:"fa fa-paperclip pr-2 attach-icon",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(file.filename))])]):_vm._e()])}),0),_vm._v(" "),(_vm.templateOptions && _vm.templateOptions.length > 0)?_c('form-field',{attrs:{"type":"select2static","col":"6","label":"Selecione um Template","select-options":_vm.templateOptions},model:{value:(_vm.codtempl),callback:function ($$v) {_vm.codtempl=$$v},expression:"codtempl"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 mt-2"},[_c('v-button',{attrs:{"label":"Anexar","icon":"fa-paperclip"},on:{"click":_vm.handleAnexo}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Enviar","icon":"fa-arrow-right","success":true},on:{"click":_vm.handleEnviar}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar","icon":""},on:{"click":_vm.handleCancelar}})],1),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"file",attrs:{"type":"file","accept":"image/*"},on:{"change":function($event){return _vm.handleAdicionarAnexo($event)}}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2037);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d472a5e6", content, true, {});

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-100"},[_vm._m(0),_vm._v(" "),_c('v-button',{attrs:{"label":"Adicionar","link":true,"icon":"fa-plus","nb-btdef":false},on:{"click":_vm.handleIncluirObs}}),_vm._v(" "),(_vm.addingNote)?_c('div',{staticClass:"col-12 mt-4 mb-5"},[_c('form-field',{ref:"texto",attrs:{"type":"memo","col":"12"},model:{value:(_vm.texto),callback:function ($$v) {_vm.texto=$$v},expression:"texto"}}),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.handleCancelObs}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Salvar","success":true,"icon":"fa-download"},on:{"click":_vm.handlePostObs}})],1)],1):_vm._e()],1),_vm._v(" "),_vm._l((_vm.notes),function(item,index){return _c('div',{key:index,staticClass:"w-100"},[_c('div',{staticClass:"card p-2 mt-2"},[(!item.editing)?_c('div',{staticClass:"w-100 mb-2"},[_c('span',{staticClass:"lbl-list pr-2 mb-3"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataHoraExtenso")(item.data)))]),_vm._v(" "),_c('span',{staticClass:"lbl-list pr-2 mb-3"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.usuario_nome))]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"link":true,"icon":"fa-trash"},on:{"click":function($event){return _vm.handleDeleteObs(index)}}}),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"link":true,"icon":"fa-pencil"},on:{"click":function($event){return _vm.handleEditObs(index)}}}),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(item.texto))])],1):_vm._e(),_vm._v(" "),(item.editing)?_c('div',{staticClass:"w-100"},[_c('form-field',{ref:"texto",refInFor:true,attrs:{"type":"memo","col":"12"},model:{value:(_vm.texto),callback:function ($$v) {_vm.texto=$$v},expression:"texto"}}),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":function($event){return _vm.handleCancelObs(index)}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Salvar","success":true,"icon":"fa-download"},on:{"click":function($event){return _vm.handlePutObs(index)}}})],1)],1):_vm._e()])])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lbl-deal-subtitle"},[_c('i',{staticClass:"fa fa-edit pr-2"}),_vm._v("ANOTAÇÕES")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pessoa)?_c('div',{staticClass:"deal-form",attrs:{"id":"formorg"}},[_c('div',{staticClass:"deal-form-1"},[_c('div',{staticClass:"deal-form-2"},[_c('div',{staticClass:"deal-form-3"},[_c('div',{staticClass:"deal-form-left"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mt-2"},[_c('span',{staticClass:"lbl-deal-title",staticStyle:{"cursor":"pointer"},on:{"click":_vm.handleEditarPessoa}},[_vm._v(_vm._s(_vm.pessoa.nome))]),_vm._v(" "),(_vm.pessoa.excluido=='S')?_c('span',{staticClass:"badge badge-red"},[_vm._v("Excluída")]):_vm._e(),_vm._v(" "),(_vm.pessoa.excluido!='S')?_c('v-button',{staticClass:"float-right",attrs:{"label":"","title":"Excluir este contato","danger":true,"icon":"fa-trash"},on:{"click":_vm.handleExcluir}}):_vm._e(),_vm._v(" "),(_vm.pessoa.excluido!='S')?_c('v-button',{staticClass:"float-right",attrs:{"label":"","title":"","icon":"fa-pencil"},on:{"click":_vm.handleEditarPessoa}}):_vm._e(),_vm._v(" "),(_vm.pessoa.excluido=='S')?_c('v-button',{staticClass:"float-right",attrs:{"label":"Reabrir","title":"Reabrir este contato","icon":""},on:{"click":_vm.handleReabrir}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"w-100"},[_c('span',{staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Criado em "+_vm._s(_vm._f("formatDataHoraExtenso")(_vm.pessoa.data)))])]),_vm._v(" "),_c('div',{staticClass:"w-100"},_vm._l((_vm.pessoa.telefones),function(fone,index){return _c('span',{key:index,staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-phone pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatFone")(fone.numero))+" ")])}),0),_vm._v(" "),_c('div',{staticClass:"w-100"},_vm._l((_vm.pessoa.emails),function(email,index){return _c('span',{key:index,staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-envelope pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(email.email)+" ")])}),0)]),_vm._v(" "),(_vm.permiteAlteracao)?_c('div',{staticClass:"col-12 mt-3"},[(_vm.pessoa.tag.length>0)?_c('div',[_c('i',{staticClass:"lbl-deal-subtitle fa fa-tag pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"tag-input-color",style:(_vm.handleStyle(_vm.pessoa.tag[0].cor)),on:{"click":_vm.handleEditarPessoa}},[_vm._v(_vm._s(_vm.pessoa.tag[0].descricao)+" ")])]):_c('v-button',{attrs:{"link":true,"label":"Definir uma etiqueta","icon":"fa-tag"},on:{"click":_vm.handleEditarPessoa}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_vm._m(0),_vm._v(" "),(_vm.pessoa.codorg)?_c('div',{staticClass:"w-100"},[_c('i',{staticClass:"fa fa-university pr-2",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"lbl-subtitle pr-2"},[_vm._v(" "+_vm._s(_vm.organizacao.nome)+" ")]),_vm._v(" "),(_vm.organizacao.tag.length>0)?_c('span',{staticClass:"tag-input-color",style:(_vm.handleStyle(_vm.organizacao.tag[0].cor))},[_c('i',{staticClass:"fa fa-tag pr-2",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.organizacao.tag[0].descricao)+" ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"fa fa-pencil pl-3",attrs:{"data-toggle":"dropdown"}}),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},[_c('a',{staticClass:"dropdown-item pr-3",on:{"click":_vm.handleDesvincularOrg}},[_c('i',{staticClass:"fa fa-chain-broken pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Desvincular esta organização")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item pr-3",on:{"click":function($event){return _vm.handleEditarPessoa('org')}}},[_c('i',{staticClass:"fa fa-exchange pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Trocar organização")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item pr-3",on:{"click":_vm.handleEditarOrg}},[_c('i',{staticClass:"fa fa-pencil pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Alterar dados desta organização")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item pr-3",on:{"click":_vm.handleShowOrg}},[_c('i',{staticClass:"fa fa-search pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Exibir organização")])]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm._f("formatCNPJCPF")(_vm.organizacao.cnpj))+" ")])]):_vm._e(),_vm._v(" "),(!_vm.pessoa.codorg && _vm.permiteAlteracao)?_c('div',{staticClass:"w-100"},[_c('i',{staticClass:"fa fa-university pr-2",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('a',{staticClass:"pr-3",staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleEditNegocioOrg}},[_vm._v(" Vincular uma organização ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_vm._m(1),_vm._v(" "),_c('div',[_c('a',{staticClass:"lbl pr-2"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.nomeUsuario))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_vm._v("USUÁRIOS VINCULADOS")]),_vm._v(" "),(_vm.permiteAlteracao)?_c('v-button',{attrs:{"link":true,"label":"Adicione usuários vinculados","icon":"fa-plus","nb-btdef":false},on:{"click":_vm.handleIncluirSeguidor}}):_vm._e(),_vm._v(" "),_vm._l((_vm.seguidores),function(item,index){return _c('span',{key:index},[_c('a',{staticClass:"data-list pr-2"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.usuario_nome))])])})],2),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_vm._m(2),_vm._v(" "),(_vm.permiteAlteracao)?_c('v-button',{attrs:{"link":true,"label":"Anexar um Arquivo","icon":"fa-plus","nb-btdef":false},on:{"click":_vm.handleAnexarDocumento}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('anexos-form',{ref:"anexos",attrs:{"params":{ ref: 'pessoacrm', chaveref: _vm.pessoa.codpessoa, showForm: false }},on:{"change":_vm.handleChangeAnexos}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"deal-form-right"},[_c('div',{staticClass:"sticky"},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-x":"auto","height":"100%"}},[_c('div',{staticClass:"mt-1"},[_c('crm-notes',{attrs:{"params":{ codpessoa: _vm.pessoa.codpessoa, notes: _vm.notes }}})],1),_vm._v(" "),_c('div',{staticClass:"mt-5"},[_vm._m(3),_vm._v(" "),_c('v-button',{attrs:{"link":true,"label":"Criar uma atividade","icon":"fa-plus"},on:{"click":_vm.handleIncluirAgenda}})],1),_vm._v(" "),_c('crm-negocio-agenda',{ref:"agenda",attrs:{"params":{ organizacao: _vm.organizacao, pessoa: _vm.pessoa, listAgenda: _vm.pessoa.agenda, listAgendaShow: _vm.agendaListPlanejada, delete: true, edit: true }},on:{"update":_vm.updateAgenda,"delete":_vm.updateAgenda}}),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._l((_vm.listNegocios),function(negocio,index){return _c('div',{key:index},[_c('crm-card',{attrs:{"negocio":negocio},on:{"edit":function($event){return _vm.handleShowNegocio(negocio.codnegocio)}}})],1)}),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._l((_vm.listVinculados),function(negocio,index){return _c('div',{key:index},[_c('crm-card',{attrs:{"negocio":negocio},on:{"edit":function($event){return _vm.handleShowNegocio(negocio.codnegocio)}}})],1)})],2)])])])]),_vm._v(" "),(_vm.showFormNegocio)?_c('crm-negocio-novo-form',{attrs:{"params":_vm.paramsNegocio},on:{"closeform":_vm.closeNovoNegocio}}):_vm._e(),_vm._v(" "),(_vm.showFormPessoa)?_c('crm-pessoa-novo-form',{attrs:{"index":_vm.pessoa.codpessoa,"params":_vm.paramsPessoa},on:{"closeform":_vm.closeFormPessoa}}):_vm._e(),_vm._v(" "),(_vm.showFormOrg)?_c('crm-org-novo-form',{attrs:{"index":_vm.organizacao.codorg},on:{"closeform":_vm.closeFormOrg}}):_vm._e(),_vm._v(" "),(_vm.showFormSeguidores)?_c('crm-negocio-seguidores',{attrs:{"params":{ pessoa: _vm.pessoa }},on:{"closeform":_vm.handleCloseSeguidor}}):_vm._e()],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_vm._v("ORGANIZAÇÃO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"lbl-deal-subtitle mb-2"},[_vm._v("PROPRIETÁRIO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lbl-deal-subtitle"},[_c('i',{staticClass:"fa fa-paperclip pr-2"}),_vm._v("ANEXOS")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lbl-deal-subtitle mb-2"},[_c('i',{staticClass:"fa fa-calendar pr-2"}),_vm._v("ATIVIDADES PLANEJADAS")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_c('i',{staticClass:"fa fa-dollar pr-2"}),_vm._v("NEGÓCIOS")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_c('i',{staticClass:"fa fa-dollar pr-2"}),_vm._v("NEGÓCIOS VINCULADOS")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2041);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0afa3662", content, true, {});

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".typeahead[data-v-b92aac94]{position:absolute;top:100%;left:0;z-index:1051;list-style:none;background-color:#fff;border:1px solid #ccc;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);-moz-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2)}", ""]);

// exports


/***/ }),
/* 2042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.negociocrm)?_c('div',{staticClass:"deal-form mb-2"},[_c('div',{staticClass:"deal-form-1"},[_c('div',{staticClass:"deal-form-2"},[_c('div',{staticClass:"col-12 p-3"},[(_vm.negociocrm.stnegocio=='A')?_c('span',{staticClass:"badge badge-gray",staticStyle:{"font-size":"18px"}},[_vm._v("Negócio Aberto")]):_vm._e(),_vm._v(" "),(_vm.negociocrm.stnegocio=='G')?_c('span',{staticClass:"badge badge-green",staticStyle:{"font-size":"18px"}},[_vm._v("Negócio Ganho")]):_vm._e(),_vm._v(" "),(_vm.negociocrm.stnegocio=='P')?_c('span',{staticClass:"badge badge-red",staticStyle:{"font-size":"18px"}},[_vm._v("Negócio Perdido")]):_vm._e(),_vm._v(" "),(_vm.negociocrm.excluido=='S')?_c('span',{staticClass:"badge badge-red"},[_vm._v("Excluída")]):_vm._e(),_vm._v(" "),(_vm.botaoPerdidoGanho)?_c('v-button',{staticClass:"float-right",attrs:{"label":"","title":"Marcar negócio como ganho","success":true,"icon":"fa-trophy"},on:{"click":_vm.handleGanho}}):_vm._e(),_vm._v(" "),(_vm.botaoPerdidoGanho)?_c('v-button',{staticClass:"float-right",attrs:{"label":"","title":"Marcar negócio como perdido","icon":"fa-thumbs-down"},on:{"click":_vm.handlePerdido}}):_vm._e(),_vm._v(" "),(_vm.botaoExcluir)?_c('v-button',{staticClass:"float-right",attrs:{"label":"","title":"Excluir este negócio","danger":true,"icon":"fa-trash"},on:{"click":_vm.handleExcluir}}):_vm._e(),_vm._v(" "),(_vm.botaoAlterar)?_c('v-button',{staticClass:"float-right",attrs:{"label":"","title":"","icon":"fa-pencil"},on:{"click":_vm.handleEditNegocio}}):_vm._e(),_vm._v(" "),(_vm.botaoReabrir)?_c('v-button',{staticClass:"float-right",attrs:{"label":"Reabrir","title":"Reabrir este contato","icon":""},on:{"click":_vm.handleReabrir}}):_vm._e(),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar","icon":"fa-arrow-left"},on:{"click":function($event){return _vm.closeForm()}}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 p-3"},[_c('span',{staticClass:"lbl-deal-title",staticStyle:{"cursor":"pointer"},on:{"click":_vm.handleEditNegocio}},[_vm._v(_vm._s(_vm.negociocrm.titulo))])]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-2"},[_c('crm-pipeline',{attrs:{"negocio":_vm.negociocrm,"funil":_vm.funil},on:{"change":_vm.handleChangeEtapa}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.negociocrm)?_c('div',{staticClass:"deal-form",attrs:{"id":"formorg"}},[_c('div',{staticClass:"deal-form-1"},[_c('div',{staticClass:"deal-form-2"},[_c('div',{staticClass:"deal-form-3"},[_c('div',{staticClass:"deal-form-left"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"w-100"},[_c('span',{staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Criado em "+_vm._s(_vm._f("formatDataHoraExtenso")(_vm.negociocrm.data)))]),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-hourglass pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Negócio criado há "+_vm._s(_vm.negociocrm.idade_negocio)+" dias")]),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_vm._v("Negócio inativo há "+_vm._s(_vm.negociocrm.dias_inativo)+" dias")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-3"},[(!_vm.negociocrm.valor && _vm.permiteAlteracao)?_c('v-button',{attrs:{"link":true,"label":"Defina um valor para este negócio"},on:{"click":_vm.handleEditar}}):_c('span',{staticClass:"lbl-negocio",staticStyle:{"cursor":"pointer"},on:{"click":_vm.handleEditNegocio}},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.negociocrm.valor,2))+" ")]),_vm._v(" "),(_vm.tag)?_c('div',[_c('i',{staticClass:"lbl-deal-subtitle fa fa-tag pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"tag-input-color",style:(_vm.handleStyle(_vm.tag.cor)),on:{"click":_vm.handleEditNegocio}},[_vm._v(" "+_vm._s(_vm.tag.descricao)+" ")])]):_c('v-button',{attrs:{"link":true,"label":"Definir uma etiqueta","icon":"fa-tag"},on:{"click":_vm.handleEditNegocio}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_vm._v("ORGANIZAÇÃO")]),_vm._v(" "),_c('span',{staticClass:"fa fa-pencil pl-3 float-right",attrs:{"data-toggle":"dropdown"}}),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},[_c('a',{staticClass:"dropdown-item pr-3",on:{"click":_vm.handleDesvincularOrg}},[_c('i',{staticClass:"fa fa-chain-broken pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Desvincular esta organização")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item pr-3",on:{"click":_vm.handleEditNegocioOrg}},[_c('i',{staticClass:"fa fa-exchange pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Trocar organização")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item pr-3",on:{"click":_vm.handleEditarOrg}},[_c('i',{staticClass:"fa fa-pencil pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Alterar dados desta organização")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item pr-3",on:{"click":_vm.handleShowOrg}},[_c('i',{staticClass:"fa fa-search pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Exibir organização")])])]),_vm._v(" "),(_vm.negociocrm.codorg)?_c('div',{staticClass:"w-100"},[_c('i',{staticClass:"fa fa-university pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"lbl-deal-subtitle pr-2"},[_vm._v(" "+_vm._s(_vm.organizacao.nome)+" ")]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.organizacao.cnpj)?_c('span',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm._f("formatCNPJCPF")(_vm.organizacao.cnpj))+" ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-2"}),_vm._v(" "),_c('i',{staticClass:"lbl-deal-subtitle fa fa-tag pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.organizacao.tag.length>0)?_c('span',{staticClass:"tag-input-color",style:(_vm.handleStyle(_vm.organizacao.tag[0].cor))},[_vm._v(" "+_vm._s(_vm.organizacao.tag[0].descricao)+" ")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.negociocrm.codorg && _vm.permiteAlteracao)?_c('div',{staticClass:"w-100"},[_c('i',{staticClass:"fa fa-university pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('a',{staticClass:"pr-3",staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleEditNegocioOrg}},[_vm._v(" Vincular uma organização ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_vm._v("CONTATO")]),_vm._v(" "),_c('span',{staticClass:"fa fa-pencil float-right",staticStyle:{"cursor":"pointer"},attrs:{"data-toggle":"dropdown"}}),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},[_c('a',{staticClass:"dropdown-item pr-3",on:{"click":_vm.handleDesvincularPessoa}},[_c('i',{staticClass:"fa fa-chain-broken pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Desvincular esta pessoa")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item pr-3",on:{"click":_vm.handleEditNegocioPessoa}},[_c('i',{staticClass:"fa fa-exchange pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Trocar pessoa")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item pr-3",on:{"click":_vm.handleEditarPessoa}},[_c('i',{staticClass:"fa fa-pencil pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Alterar dados desta pessoa")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item pr-3",on:{"click":_vm.handleShowPessoa}},[_c('i',{staticClass:"fa fa-search pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Exibir pessoa")])])]),_vm._v(" "),(_vm.negociocrm.codpessoa)?_c('div',{staticClass:"w-100"},[_c('i',{staticClass:"fa fa-user pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"lbl-deal-subtitle"},[_vm._v(" "+_vm._s(_vm.pessoa.nome)+" ")]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_vm._l((_vm.pessoa.telefones),function(fone,index){return _c('span',{key:index,staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-phone pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatFone")(fone.numero))+" ")])}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_vm._l((_vm.pessoa.emails),function(email,index){return _c('span',{key:index,staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-envelope pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(email.email)+" ")])}),_vm._v(" "),_c('div',{staticClass:"mb-2"}),_vm._v(" "),_c('i',{staticClass:"lbl-deal-subtitle fa fa-tag pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.pessoa.tag.length>0)?_c('span',{staticClass:"tag-input-color",style:(_vm.handleStyle(_vm.pessoa.tag[0].cor))},[_vm._v(" "+_vm._s(_vm.pessoa.tag[0].descricao)+" ")]):_vm._e()],2):_vm._e(),_vm._v(" "),(!_vm.negociocrm.codpessoa && _vm.permiteAlteracao)?_c('div',{staticClass:"w-100"},[_c('i',{staticClass:"fa fa-user pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('a',{staticClass:"pr-3",staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleEditNegocioPessoa}},[_vm._v(" Vincular uma pessoa de contato ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_vm._m(0),_vm._v(" "),_c('div',[_c('a',{staticClass:"lbl pr-2"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.nomeUsuario))])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.negociocrm.dataprevista}}),_vm._v(" "),(!_vm.negociocrm.dataprevista && _vm.permiteAlteracao)?_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleEditNegocio}},[_vm._v(" Definir uma data ")]):_c('span',{staticClass:"lbl"},[_c('i',{staticClass:"fa fa-flag-checkered pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataExtenso")(_vm.negociocrm.dataprevista))+" ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-2"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.negociocrm.probabilidade}}),_vm._v(" "),(!_vm.negociocrm.probabilidade && _vm.permiteAlteracao)?_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleEditNegocio}},[_vm._v(" Não Definido ")]):_c('span',{staticClass:"lbl"},[_c('i',{staticClass:"fa fa-percent pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.negociocrm.probabilidade,2))+" ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-2"},[_c('label',{staticClass:"lbl-edit w-100"},[_vm._v("Origem do negócio")]),_vm._v(" "),(!_vm.negociocrm.codorigem && _vm.permiteAlteracao)?_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleEditNegocio}},[_vm._v(" Definir a origem do negócio ")]):_c('span',{staticClass:"lbl"},[_c('i',{staticClass:"fa fa-flag-checkered pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.negociocrm.origem[0].descricao)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_vm._v("USUÁRIOS VINCULADOS")]),_vm._v(" "),(_vm.permiteAlteracao)?_c('v-button',{staticClass:"mb-2",attrs:{"link":true,"label":"Adicione usuários vinculados","icon":"fa-plus","nb-btdef":false},on:{"click":_vm.handleIncluirSeguidor}}):_vm._e(),_vm._v(" "),_vm._l((_vm.seguidores),function(item,index){return _c('span',{key:index},[_c('a',{staticClass:"data-list pr-2"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.usuario_nome))])])})],2),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[(_vm.permiteAlteracao)?_c('span',{staticClass:"lbl-deal-subtitle"},[_c('i',{staticClass:"fa fa-paperclip pr-2"}),_vm._v("ANEXOS")]):_vm._e(),_vm._v(" "),_c('v-button',{attrs:{"link":true,"label":"Anexar um Arquivo","icon":"fa-plus","nb-btdef":false},on:{"click":_vm.handleAnexarDocumento}}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('anexos-form',{ref:"anexos",attrs:{"params":{ ref: 'negociocrm', chaveref: _vm.negociocrm.codnegocio, showForm: false }},on:{"change":_vm.handleChangeAnexos}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5 mb-5"},[_vm._m(2),_vm._v(" "),(_vm.permiteAlteracao)?_c('v-button',{staticClass:"mb-2",attrs:{"link":true,"label":"Adicione participantes ao negócio","icon":"fa-plus"},on:{"click":_vm.handleIncluirParticipante}}):_vm._e(),_vm._v(" "),_vm._l((_vm.participantes),function(item,index){return _c('span',{key:index},[_c('a',{staticClass:"data-list pr-2",attrs:{"href":'#/crm/pessoa/' + item.codpessoa}},[_c('i',{staticClass:"fa fa-user pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.pessoa[0].nome))])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"deal-form-right"},[_c('tabs',{attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}),_vm._v(" "),_c('div',{staticClass:"mb-2"}),_vm._v(" "),(_vm.tabPrincipal)?_c('div',{staticStyle:{"overflow-x":"auto","height":"100%"}},[_c('div',{staticClass:"mt-1"},[_c('crm-notes',{attrs:{"params":{ codnegocio: _vm.negociocrm.codnegocio, notes: _vm.notes }}})],1),_vm._v(" "),_c('div',{staticClass:"mt-5"},[_vm._m(3),_vm._v(" "),_c('v-button',{attrs:{"link":true,"label":"Criar uma atividade","icon":"fa-plus"},on:{"click":_vm.handleIncluirAgenda}})],1),_vm._v(" "),_c('crm-negocio-agenda',{ref:"agenda",attrs:{"params":{ negocio: _vm.negociocrm, organizacao: _vm.organizacao, pessoa: _vm.pessoa, listAgenda: _vm.negociocrm.agenda, listAgendaShow: _vm.agendaListPlanejada, delete: true, edit: true }},on:{"update":_vm.updateAgenda,"delete":_vm.updateAgenda}}),_vm._v(" "),_c('div',{staticClass:"mt-5"},[_vm._m(4),_vm._v(" "),(_vm.orcamentoList.length == 0)?_c('v-button',{attrs:{"link":true,"label":"Criar um Orçamento","icon":"fa-plus"},on:{"click":_vm.handleIncluirOrcamento}}):_vm._e()],1),_vm._v(" "),_vm._l((_vm.orcamentoList),function(item,index){return _c('div',{key:index,staticClass:"w-100 mt-3"},[_c('div',{staticClass:"align-items-center",staticStyle:{"display":"flex"}},[_vm._m(5,true),_vm._v(" "),_c('div',{staticClass:"card p-2 col-11"},[_c('div',{staticClass:"w-100"},[_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataExtenso")(item.data)))]),_vm._v(" "),_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Criado por "+_vm._s(item.usuario_nome))])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('span',{staticClass:"lbl-list pr-2"},[_vm._v("Número do Orçamento")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.ncotacao))]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('span',{staticClass:"lbl-list pr-2"},[_vm._v("Valor Total")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(item.totger,2)))])]),_vm._v(" "),_c('div',{staticClass:"w-100",staticStyle:{"display":"flex"}},[_c('v-button',{attrs:{"link":true,"label":"Editar","icon":"fa-pencil"},on:{"click":function($event){return _vm.handleEditOrcamento(item.codpedv)}}}),_vm._v(" "),_c('v-button',{attrs:{"link":true,"label":"Visualizar","icon":"fa-print"},on:{"click":function($event){return _vm.handleImprimir(item.codpedv)}}})],1)])])])})],2):_vm._e(),_vm._v(" "),(_vm.tabEmails)?_c('div',{staticStyle:{"overflow-x":"auto","height":"100%"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"w-100 mt-3 mb-2"},[_c('v-button',{attrs:{"label":"Enviar um E-mail","icon":"fa-envelope","nb-btdef":false},on:{"click":_vm.handleNovoEmail}})],1),_vm._v(" "),(_vm.novoEmail)?_c('div',{staticClass:"mt-3 card p-2"},[_c('crm-email',{attrs:{"negocio":_vm.negociocrm,"pessoa":_vm.pessoa},on:{"closeform":_vm.closeEmail}})],1):_vm._e()]),_vm._v(" "),_vm._l((_vm.emailList),function(item,index){return _c('div',{key:index,staticClass:"col-12 mt-2 mb-2"},[(item.codemail != _vm.showCodemail)?_c('div',{staticClass:"align-items-center",staticStyle:{"display":"flex"}},[_c('div',{staticClass:"col-1 text-center"},[(item.enviado=='S')?_c('i',{staticClass:"fa fa-arrow-right lbl-deal-subtitle"}):_c('i',{staticClass:"fa fa-envelope lbl-deal-subtitle"})]),_vm._v(" "),_c('div',{staticClass:"col-11 card p-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('v-button',{staticClass:"float-right",attrs:{"link":true,"icon":"fa-expand"},on:{"click":function($event){_vm.showCodemail = item.codemail}}}),_vm._v(" "),_c('span',{staticClass:"lbl-list float-right"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataHoraExtenso")(item.data,true)))]),_vm._v(" "),(item.usuario_nome)?_c('span',{staticClass:"card lbl-list px-2"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.usuario_nome))]):_vm._e(),_vm._v(" "),(item.attachments.length > 1)?_c('span',{staticClass:"lbl float-right pr-2"},[_c('i',{staticClass:"fa fa-paperclip",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(item.enviado != 'S' && item.from_list.length > 0)?_c('div',[_c('span',{staticClass:"lbl-list"},[_vm._v("De")]),_vm._v(" "),_c('span',{staticClass:"email-address"},[_c('strong',[_vm._v(_vm._s(item.pessoa_nome))]),_vm._v(" "+_vm._s(item.from_list[0].email))])]):_vm._e(),_vm._v(" "),(item.enviado == 'S' && item.to_list.length > 0)?_c('div',[_c('span',{staticClass:"lbl-list"},[_vm._v("Para")]),_vm._v(" "),_vm._l((item.to_list),function(to,index){return _c('span',{key:index,staticClass:"email-address pr-2"},[_c('strong',[_vm._v(_vm._s(to.nome))]),_vm._v(" "+_vm._s(to.email))])})],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(item.visualizado=='S')?_c('span',{staticClass:"data-list w-100",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.showCodemail = item.codemail}}},[_vm._v(_vm._s(item.subject))]):_c('span',{staticClass:"data-list w-100",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.showCodemail = item.codemail}}},[_c('strong',[_vm._v(" "+_vm._s(item.subject)+" ")])])])])])]):_vm._e(),_vm._v(" "),(item.codemail == _vm.showCodemail)?_c('div',{staticClass:"border border-info p-2"},[_c('crm-email',{attrs:{"codemail":item.codemail},on:{"closeform":_vm.closeEmail}})],1):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.tabAgenda)?_c('div',{staticStyle:{"overflow-x":"auto","height":"100%"}},[_c('crm-negocio-agenda',{attrs:{"params":{ listAgenda: _vm.agendaList }}})],1):_vm._e(),_vm._v(" "),(_vm.tabHistorico)?_c('div',{staticStyle:{"overflow-x":"auto","height":"100%"}},_vm._l((_vm.hist),function(item,index){return _c('div',{key:index,staticClass:"col-12 mb-3"},[_c('div',{staticClass:"row align-items-center"},[_vm._m(6,true),_vm._v(" "),_c('div',{staticClass:"col-11"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(item.tipo=='I')?_c('span',{staticClass:"data-list"},[_vm._v("Negócio criado")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(item.tipo=='U')?_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.label)+" de "),_c('strong',[_vm._v("\""+_vm._s(item.oldvalue)+"\"")]),_vm._v(" para "),_c('strong',[_vm._v("\""+_vm._s(item.newvalue)+"\"")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"lbl-list pr-3 mb-3"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataHoraExtenso")(item.data)))]),_vm._v(" "),_c('span',{staticClass:"lbl-list pr-3 mb-3"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.usuario_nome))])])])])])])}),0):_vm._e()],1)])])]),_vm._v(" "),(_vm.showFormParticipantes)?_c('crm-negocio-participantes',{attrs:{"params":{ negocio: _vm.negociocrm }},on:{"closeform":_vm.handleCloseParticipante}}):_vm._e(),_vm._v(" "),(_vm.showFormSeguidores)?_c('crm-negocio-seguidores',{attrs:{"params":{ negocio: _vm.negociocrm }},on:{"closeform":_vm.handleCloseSeguidor}}):_vm._e(),_vm._v(" "),(_vm.showFormEmail)?_c('email-form',{attrs:{"index":_vm.codpedv,"tipo":"PEDV","title":"Envio de Orçamento"},on:{"closeform":_vm.closeFormEmail,"send":_vm.handleSendEmail}}):_vm._e(),_vm._v(" "),(_vm.showFormMotivo)?_c('crm-negocio-motivo-form',{attrs:{"params":{ negocio: _vm.negociocrm }},on:{"closeform":_vm.closeFormMotivo}}):_vm._e(),_vm._v(" "),(_vm.showFormNegocio)?_c('crm-negocio-novo-form',{attrs:{"index":_vm.negociocrm.codnegocio,"params":_vm.paramsNegocio,"funil":_vm.funil},on:{"closeform":_vm.closeNovoNegocio}}):_vm._e(),_vm._v(" "),(_vm.showFormPessoa)?_c('crm-pessoa-novo-form',{attrs:{"index":_vm.pessoa.codpessoa},on:{"closeform":_vm.closeFormPessoa}}):_vm._e(),_vm._v(" "),(_vm.showFormOrg)?_c('crm-org-novo-form',{attrs:{"transformarPart":_vm.incluirOrcamento,"index":_vm.organizacao.codorg},on:{"closeform":_vm.closeFormOrg}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"lbl-deal-subtitle mb-2"},[_vm._v("PROPRIETÁRIO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt-5"},[_c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"lbl-deal-subtitle mb-2"},[_vm._v("DADOS DO NEGÓCIO")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lbl-deal-subtitle"},[_c('i',{staticClass:"fa fa-users pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" PARTICIPANTES")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lbl-deal-subtitle mb-2"},[_c('i',{staticClass:"fa fa-calendar pr-2"}),_vm._v("ATIVIDADES PLANEJADAS")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lbl-deal-subtitle"},[_c('i',{staticClass:"fa fa-document pr-2"}),_vm._v("ORÇAMENTOS")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 text-center"},[_c('i',{staticClass:"fa fa-dollar lbl-deal-subtitle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 text-center"},[_c('i',{staticClass:"fa fa-exchange"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_funil_form_vue__ = __webpack_require__(724);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a2b9a99_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_funil_form_vue__ = __webpack_require__(2046);
function injectStyle (ssrContext) {
  __webpack_require__(2044)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_funil_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a2b9a99_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_funil_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2045);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a5616a5c", content, true, {});

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"700px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-12"},[_c('div',{staticClass:"float-right"},[_c('v-button',{attrs:{"label":"Cancelar","title":"","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Salvar","title":"","nb-btdef":true},on:{"click":_vm.handleSalvar}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.funilcrm.descricao.validator),expression:"metadata.funilcrm.descricao.validator"}],ref:"descricao",attrs:{"type":"text","col":"12","metadata":_vm.metadata.funilcrm.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.funil.descricao),callback:function ($$v) {_vm.$set(_vm.funil, "descricao", $$v)},expression:"funil.descricao"}})],1),_vm._v(" "),_c('label-title',{attrs:{"title":"Etapas do Funil"}}),_vm._v(" "),_vm._l((_vm.etapas),function(etapa,index){return _c('div',{key:index},[(!etapa.excluida)?_c('div',{staticClass:"card mb-3 p-3"},[(!_vm.excluindoEtapa(index))?_c('div',{staticClass:"row align-items-center"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.etapacrm.descricao.validator),expression:"metadata.etapacrm.descricao.validator"}],attrs:{"type":"text","col":"6","metadata":_vm.metadata.etapacrm.descricao,"case":"normal","name":"descricao","v-errors":_vm.errors},model:{value:(etapa.descricao),callback:function ($$v) {_vm.$set(etapa, "descricao", $$v)},expression:"etapa.descricao"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.etapacrm.probabilidade.validator),expression:"metadata.etapacrm.probabilidade.validator"}],attrs:{"type":"number","col":"3","metadata":_vm.metadata.etapacrm.probabilidade,"name":"probabilidade","v-errors":_vm.errors,"addon":"%"},model:{value:(etapa.probabilidade),callback:function ($$v) {_vm.$set(etapa, "probabilidade", $$v)},expression:"etapa.probabilidade"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.etapacrm.diasestagnado.validator),expression:"metadata.etapacrm.diasestagnado.validator"}],attrs:{"type":"number","col":"3","metadata":_vm.metadata.etapacrm.diasestagnado,"name":"diasestagnado","v-errors":_vm.errors,"addon":"Dias"},model:{value:(etapa.diasestagnado),callback:function ($$v) {_vm.$set(etapa, "diasestagnado", $$v)},expression:"etapa.diasestagnado"}}),_vm._v(" "),(etapa.count_negocios)?_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"lbl-edit"},[_vm._v("Negócios Vinculados Nesta Etapa")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(etapa.count_negocios))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[(!_vm.excluindoEtapa(index) && _vm.countEtapas != 1)?_c('v-button',{attrs:{"icon":"fa-trash"},on:{"click":function($event){return _vm.handleShowDeleteEtapa(index)}}}):_vm._e(),_vm._v(" "),(index != 0)?_c('v-button',{attrs:{"icon":"fa-arrow-up"},on:{"click":function($event){return _vm.handleMoverEtapa(index, -1)}}}):_vm._e(),_vm._v(" "),(index != _vm.etapas.length-1)?_c('v-button',{attrs:{"icon":"fa-arrow-down"},on:{"click":function($event){return _vm.handleMoverEtapa(index, 1)}}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.excluindoEtapa(index))?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"data-list"},[_vm._v(" Excluir Etapa: "),_c('strong',[_vm._v(" "+_vm._s(etapa.descricao)+" ")])])]),_vm._v(" "),(etapa.count_negocios)?_c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"data-list"},[_vm._v("Existem negócios vinculados nesta etapa. Selecione para qual etapa serão movimentados estes negócios:")])]):_vm._e(),_vm._v(" "),(etapa.count_negocios)?_c('form-field',{attrs:{"type":"select","col":"6","select-options":_vm.optionsTransferEtapas},model:{value:(etapa.transfer_to_codetapa),callback:function ($$v) {_vm.$set(etapa, "transfer_to_codetapa", $$v)},expression:"etapa.transfer_to_codetapa"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Confirmar"},on:{"click":function($event){return _vm.handleDeleteEtapa(index)}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":function($event){_vm.idxExcluindoEtapa = null}}})],1)],1):_vm._e()]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"row col mt-3"},[_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleAdicionarEtapa}},[_vm._v("Adicionar Nova Etapa")])]),_vm._v(" "),_c('div',{staticClass:"mb-5"})],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-4 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v(" Funil ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_public_form_vue__ = __webpack_require__(725);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5889baea_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_public_form_vue__ = __webpack_require__(2050);
function injectStyle (ssrContext) {
  __webpack_require__(2048)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_public_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5889baea_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_public_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2049);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a71ad898", content, true, {});

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"400px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-header"},[_c('h4',{staticClass:"def-title"},[_vm._v("Formulário Público")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.closeForm}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"text","col":"12","label":"Nome","name":"nome","v-errors":_vm.errors},model:{value:(_vm.leadcrm.pessoanome),callback:function ($$v) {_vm.$set(_vm.leadcrm, "pessoanome", $$v)},expression:"leadcrm.pessoanome"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, email: true }),expression:"{ required: true, email: true }"}],attrs:{"type":"text","col":"12","label":"E-mail","name":"email","v-errors":_vm.errors},model:{value:(_vm.leadcrm.email),callback:function ($$v) {_vm.$set(_vm.leadcrm, "email", $$v)},expression:"leadcrm.email"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: false }),expression:"{ required: false }"}],attrs:{"type":"text","col":"12","label":"Empresa","name":"empresa","v-errors":_vm.errors},model:{value:(_vm.leadcrm.orgnome),callback:function ($$v) {_vm.$set(_vm.leadcrm, "orgnome", $$v)},expression:"leadcrm.orgnome"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"type":"fone","col":"12","label":"Telefone","name":"fone","v-errors":_vm.errors},model:{value:(_vm.leadcrm.fonenumero),callback:function ($$v) {_vm.$set(_vm.leadcrm, "fonenumero", $$v)},expression:"leadcrm.fonenumero"}})],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer text-center"},[_c('v-button',{attrs:{"label":"Enviar","success":true},on:{"click":_vm.handleSalvar}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full-width"},[(_vm.mounted && _vm.showPainel)?_c('div',[_c('div',{staticClass:"default-container mb-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-auto"},[_c('div',{staticClass:"btn-group"},[_c('v-button',{attrs:{"title":"Visão por etapas","nb-btdef":_vm.showEtapa,"icon":"fa-th"},on:{"click":_vm.handleVisaoEtapa}}),_vm._v(" "),_c('v-button',{attrs:{"title":"Visão por timeline","nb-btdef":_vm.showTimeline,"icon":"fa-calendar"},on:{"click":_vm.handleVisaoTimeline}}),_vm._v(" "),_c('v-button',{attrs:{"title":"Visão por lista","nb-btdef":_vm.showLista,"icon":"fa-list"},on:{"click":_vm.handleVisaoLista}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[(_vm.showTimeline)?_c('input-month',{attrs:{"p-month":_vm.filtroMes,"show-options":false},on:{"monthChange":_vm.handleMonthChange}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-auto ml-auto text-righy"},[(_vm.administrador && _vm.moreActions.length > 0)?_c('v-button',{attrs:{"actions":_vm.moreActions},on:{"click":_vm.handleAction}}):_vm._e(),_vm._v(" "),_c('v-button',{attrs:{"title":"Incluir novo contato","icon":"fa-user"},on:{"click":_vm.handleNovoPessoa}}),_vm._v(" "),_c('v-button',{attrs:{"title":"Incluir nova organização","icon":"fa-university"},on:{"click":_vm.handleNovoOrg}}),_vm._v(" "),_c('v-button',{attrs:{"title":"Formulário Público","icon":"fa-magic"},on:{"click":_vm.handlePublicForm}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Novo Negócio","title":"Incluir novo negócio","nb-btdef":true,"icon":"fa-plus"},on:{"click":_vm.handleNovoNegocio}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-2"},[_c('crm-filtros-negocio',{attrs:{"negocios":true},on:{"changeFiltro":_vm.handleChangeFiltroNegocios,"changeUsuario":_vm.handleChangeUsuario,"changeFunil":_vm.handleChangeFunil,"editfunil":_vm.handleEditarFunil,"novofunil":_vm.handleNovoFunil}})],1)])]),_vm._v(" "),(_vm.showEtapa)?_c('crm-painel-etapa',{ref:"painelEtapa",attrs:{"funil":_vm.selectedFunil,"usuario":_vm.selectedUsuario,"start-date":_vm.filtroMes.startDate,"filtro":_vm.selectedFiltroNegocios},on:{"edit":_vm.handleEditNegocio}}):_vm._e(),_vm._v(" "),(_vm.showTimeline)?_c('crm-painel-timeline',{ref:"painelTimeline",attrs:{"funil":_vm.selectedFunil,"usuario":_vm.selectedUsuario,"start-date":_vm.filtroMes.startDate,"filtro":_vm.selectedFiltroNegocios},on:{"edit":_vm.handleEditNegocio}}):_vm._e(),_vm._v(" "),(_vm.showLista)?_c('crm-painel-list',{ref:"painelLista",attrs:{"funil":_vm.selectedFunil,"usuario":_vm.selectedUsuario,"start-date":_vm.filtroMes.startDate,"filtro":_vm.selectedFiltroNegocios},on:{"edit":_vm.handleEditNegocio}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.formFunil)?_c('crm-funil-form',{attrs:{"index":_vm.codfunil},on:{"closeform":_vm.handleCloseFormFunil}}):_vm._e(),_vm._v(" "),(_vm.showPublicForm)?_c('crm-public-form',{on:{"closeform":_vm.closePublicForm}}):_vm._e(),_vm._v(" "),(_vm.showFormOrg)?_c('crm-org-novo-form',{on:{"closeform":_vm.closeFormOrg}}):_vm._e(),_vm._v(" "),(_vm.showFormPessoa)?_c('crm-pessoa-novo-form',{on:{"closeform":_vm.closeFormPessoa}}):_vm._e(),_vm._v(" "),(_vm.formNegocio)?_c('crm-negocio-form',{attrs:{"index":this.codnegocio},on:{"closeform":_vm.closeFormNegocio}}):_vm._e(),_vm._v(" "),(_vm.formNovoNegocio)?_c('crm-negocio-novo-form',{attrs:{"index":this.codnegocio,"funil":_vm.selectedFunil},on:{"closeform":_vm.closeFormNegocio}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_lead_list_vue__ = __webpack_require__(726);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a6ceec_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_lead_list_vue__ = __webpack_require__(2062);
function injectStyle (ssrContext) {
  __webpack_require__(2053)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_lead_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a6ceec_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_lead_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2054);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("70730c9f", content, true, {});

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".list-title{display:inline-block;max-width:100%;font-weight:700;color:#4993d2}.list-icon{font-size:24px;align-items:center;justify-content:center;background-color:#f5f5f5;border:1px solid #e0e0e0;box-sizing:border-box;height:38px;width:42px;flex-shrink:0}", ""]);

// exports


/***/ }),
/* 2055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_lead_form_vue__ = __webpack_require__(727);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e17d3d4a_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_lead_form_vue__ = __webpack_require__(2061);
function injectStyle (ssrContext) {
  __webpack_require__(2056)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e17d3d4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_lead_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e17d3d4a_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_lead_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2057);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("38dc97df", content, true, {});

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2059);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("16c61d85", content, true, {});

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"600px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-header"},[(_vm.leadcrm.codlead)?_c('h4',{staticClass:"def-title"},[_vm._v("Alterar Lead")]):_c('h4',{staticClass:"def-title"},[_vm._v("Novo Lead")])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row"},[_c('form-field',{ref:"titulo",attrs:{"type":"text","col":"12","metadata":_vm.metadata.leadcrm.titulo},model:{value:(_vm.leadcrm.titulo),callback:function ($$v) {_vm.$set(_vm.leadcrm, "titulo", $$v)},expression:"leadcrm.titulo"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"text","col":"12","metadata":_vm.metadata.leadcrm.pessoanome},model:{value:(_vm.leadcrm.pessoanome),callback:function ($$v) {_vm.$set(_vm.leadcrm, "pessoanome", $$v)},expression:"leadcrm.pessoanome"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"text","col":"12","metadata":_vm.metadata.leadcrm.orgnome},model:{value:(_vm.leadcrm.orgnome),callback:function ($$v) {_vm.$set(_vm.leadcrm, "orgnome", $$v)},expression:"leadcrm.orgnome"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('input-color',{ref:"etiqueta",attrs:{"params":{ edit: true, label: 'Etiqueta', url: 'crm/tag/list/negocio' }},on:{"editar":_vm.handleEditarTag,"adicionar":_vm.handleAdicionarTag},model:{value:(_vm.leadcrm.codtag),callback:function ($$v) {_vm.$set(_vm.leadcrm, "codtag", $$v)},expression:"leadcrm.codtag"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"fone","col":"4","metadata":_vm.metadata.leadcrm.fonenumero},model:{value:(_vm.leadcrm.fonenumero),callback:function ($$v) {_vm.$set(_vm.leadcrm, "fonenumero", $$v)},expression:"leadcrm.fonenumero"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"email","col":"12","metadata":_vm.metadata.leadcrm.email},model:{value:(_vm.leadcrm.email),callback:function ($$v) {_vm.$set(_vm.leadcrm, "email", $$v)},expression:"leadcrm.email"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.leadcrm.valor.validator),expression:"metadata.leadcrm.valor.validator"}],attrs:{"type":"value","col":"4","metadata":_vm.metadata.leadcrm.valor,"preaddon":"R$","name":"valor","v-errors":_vm.errors},model:{value:(_vm.leadcrm.valor),callback:function ($$v) {_vm.$set(_vm.leadcrm, "valor", $$v)},expression:"leadcrm.valor"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"type":"select2","col":"12","metadata":_vm.metadata.leadcrm.codorigem},model:{value:(_vm.leadcrm.codorigem),callback:function ($$v) {_vm.$set(_vm.leadcrm, "codorigem", $$v)},expression:"leadcrm.codorigem"}},[(_vm.administrador)?_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":_vm.handleCadastroOrigem}},[_vm._v("Acesso ao cadastro de origem")]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{staticClass:"float-right",attrs:{"label":"Cancelar","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}}),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Salvar","nb-btdef":true},on:{"click":_vm.handleSalvar}})],1)]),_vm._v(" "),(_vm.showTagForm)?_c('crm-tag-form',{attrs:{"tptag":"N","index":_vm.codtag,"crud":_vm.crudTag},on:{"closeform":_vm.handleCloseTag}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.leadcrm)?_c('div',{staticClass:"deal-form",attrs:{"id":"formorg"}},[_c('div',{staticClass:"deal-form-1"},[_c('div',{staticClass:"deal-form-2"},[_c('div',{staticClass:"deal-form-3"},[_c('div',{staticClass:"deal-form-left"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mt-2"},[_c('span',{staticClass:"lbl-deal-title",staticStyle:{"cursor":"pointer"},on:{"click":_vm.handleEditar}},[_vm._v(_vm._s(_vm.leadcrm.titulo))]),_vm._v(" "),(_vm.leadcrm.excluido=='S')?_c('span',{staticClass:"badge badge-red"},[_vm._v("Excluído")]):_vm._e(),_vm._v(" "),(_vm.leadcrm.stlead=='F')?_c('span',{staticClass:"badge badge-yellow"},[_vm._v("Arquivado")]):_vm._e(),_vm._v(" "),(_vm.permiteAlteracao)?_c('v-button',{staticClass:"float-right",attrs:{"label":"","title":"Gerar um negócio","icon":"fa-dollar","success":true},on:{"click":_vm.handleTransformToDeal}}):_vm._e(),_vm._v(" "),(_vm.permiteAlteracao)?_c('v-button',{staticClass:"float-right",attrs:{"label":"","title":"Arquivar este lead","icon":"fa-dropbox"},on:{"click":_vm.handleArquivar}}):_vm._e(),_vm._v(" "),(_vm.permiteAlteracao)?_c('v-button',{staticClass:"float-right",attrs:{"label":"","title":"","icon":"fa-pencil"},on:{"click":_vm.handleEditar}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-2"},[_c('div',{staticClass:"w-100"},[_c('span',{staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Criado em "+_vm._s(_vm._f("formatDataHoraExtenso")(_vm.leadcrm.data)))])])]),_vm._v(" "),(_vm.permiteAlteracao)?_c('div',{staticClass:"col-12 mt-3"},[(!_vm.leadcrm.valor)?_c('v-button',{attrs:{"link":true,"label":"Valor Não Definido"},on:{"click":_vm.handleEditar}}):_c('span',{staticClass:"lbl-negocio",staticStyle:{"cursor":"pointer"},on:{"click":_vm.handleEditar}},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.leadcrm.valor,2))+" ")])],1):_vm._e(),_vm._v(" "),(_vm.permiteAlteracao)?_c('div',{staticClass:"col-12 mt-3"},[(_vm.leadcrm.tag.length>0)?_c('div',[_c('i',{staticClass:"lbl-deal-subtitle fa fa-tag pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"tag-input-color",style:(_vm.handleStyle(_vm.leadcrm.tag[0].cor)),on:{"click":_vm.handleEditar}},[_vm._v(_vm._s(_vm.leadcrm.tag[0].descricao)+" ")])]):_c('v-button',{attrs:{"link":true,"label":"Definir uma etiqueta","icon":"fa-tag"},on:{"click":_vm.handleEditar}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('i',{staticClass:"fa fa-user pr-2",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"lbl-subtitle pr-2"},[_vm._v(" "+_vm._s(_vm.leadcrm.pessoanome)+" ")])]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-phone pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatFone")(_vm.leadcrm.fonenumero))+" ")]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('span',{staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-envelope pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.leadcrm.email)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('i',{staticClass:"fa fa-university pr-2",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"lbl-subtitle pr-2"},[_vm._v(" "+_vm._s(_vm.leadcrm.orgnome)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_vm._m(2),_vm._v(" "),_c('div',[_c('a',{staticClass:"lbl pr-2"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.nomeUsuario))])])])])]),_vm._v(" "),_c('div',{staticClass:"deal-form-right"},[_c('div',{staticClass:"sticky"},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-x":"auto","height":"100%"}},[_c('div',{staticClass:"mt-1"},[_c('crm-notes',{attrs:{"params":{ codlead: _vm.leadcrm.codlead, notes: _vm.notes }}})],1),_vm._v(" "),_c('div',{staticClass:"mt-5"},[_vm._m(3),_vm._v(" "),_c('v-button',{attrs:{"link":true,"label":"Criar uma atividade","icon":"fa-plus"},on:{"click":_vm.handleIncluirAgenda}})],1),_vm._v(" "),_c('crm-negocio-agenda',{ref:"agenda",attrs:{"params":{ lead: _vm.leadcrm, listAgenda: _vm.leadcrm.agenda, listAgendaShow: _vm.agendaListPlanejada, delete: true, edit: true }},on:{"update":_vm.updateAgenda,"delete":_vm.updateAgenda}}),_vm._v(" "),(_vm.agendaList.length > 0)?_c('div',{staticClass:"mt-5"},[_vm._m(4)]):_vm._e(),_vm._v(" "),(_vm.agendaList.length > 0)?_c('crm-negocio-agenda',{ref:"agenda",attrs:{"params":{ lead: _vm.leadcrm, listAgenda: _vm.leadcrm.agenda, listAgendaShow: _vm.agendaList, delete: true, edit: true }},on:{"update":_vm.updateAgenda,"delete":_vm.updateAgenda}}):_vm._e()],1)])])])]),_vm._v(" "),(_vm.showFormNegocio)?_c('crm-negocio-novo-form',{attrs:{"params":_vm.paramsNegocio},on:{"closeform":_vm.closeFormNegocio}}):_vm._e(),_vm._v(" "),(_vm.showFormLead)?_c('crm-lead-novo-form',{attrs:{"index":_vm.leadcrm.codlead},on:{"closeform":_vm.closeFormLead}}):_vm._e()],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_vm._v("PESSOA DE CONTATO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_vm._v("ORGANIZAÇÃO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"lbl-deal-subtitle mb-2"},[_vm._v("PROPRIETÁRIO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lbl-deal-subtitle mb-2"},[_c('i',{staticClass:"fa fa-calendar pr-2"}),_vm._v("ATIVIDADES PLANEJADAS")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lbl-deal-subtitle mb-2"},[_c('i',{staticClass:"fa fa-calendar pr-2"}),_vm._v("ATIVIDADES CONCLUÍDAS")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":true,"single-entity":"Lead","plural-entity":"Leads"},on:{"search":_vm.textSearch,"new":_vm.handleNovo,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('crm-filtros-negocio',{attrs:{"leads":true},on:{"changeUsuario":_vm.handleChangeUsuario,"changeEquipe":_vm.handleChangeEquipe,"changeFiltroLeads":_vm.handleChangeFiltroLeads}})],1),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.leadList.length == 0)?_c('div',{staticClass:"no-content mb-4"},[_vm._v("Nenhum lead foi encontrado")]):_vm._e(),_vm._v(" "),_vm._l((_vm.leadList),function(lead,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"row p-2"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('span',{staticClass:"list-title"},[_vm._v(_vm._s(lead.titulo))]),_vm._v(" "),(lead.excluido=='S')?_c('span',{staticClass:"badge badge-red ml-2"},[_vm._v("Excluído")]):_vm._e(),_vm._v(" "),(lead.stlead=='F')?_c('span',{staticClass:"badge badge-yellow ml-2"},[_vm._v("Arquivado")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('span',{staticClass:"lbl-list-detalhe"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataHoraExtenso")(lead.data)))]),_vm._v(" "),_c('span',{staticClass:"lbl-list-detalhe"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(lead.nome_usuario))]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(lead.fonenumero)?_c('div',[_c('span',{staticClass:"lbl-list pr-2"},[_c('i',{staticClass:"fa fa-phone pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatFone")(lead.fonenumero)))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[(lead.tag.length>0)?_c('span',{staticClass:"tag-input-color mr-3",style:(_vm.handleStyle(lead.tag[0].cor)),on:{"click":function($event){return _vm.handleEditarlead('nome')}}},[_vm._v(" "+_vm._s(lead.tag[0].descricao)+" ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[(lead.dias_atividade>0)?_c('span',{staticClass:"icon icon-atrasado",attrs:{"title":'Atividade atrasada há ' + lead.dias_atividade + ' dias',"data-toggle":"tooltip","data-placement":"top"}},[_c('i',{staticClass:"fa fa-calendar",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(lead.count_agenda == 0)?_c('span',{staticClass:"icon icon-sem-agenda",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Nenhuma atividade"}},[_c('i',{staticClass:"fa fa-warning",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(lead.count_agenda > 0 && lead.dias_atividade <= 0)?_c('span',{staticClass:"icon icon-agenda",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Atividade planejada"}},[_c('i',{staticClass:"fa fa-calendar",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(!lead.proxima_atividade)?_c('label',{staticClass:"lbl-list icon-sem-agenda"},[_vm._v("Sem Atividade")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list",style:(_vm.handleStyleAgenda(lead))},[_vm._v(" "+_vm._s(_vm.formatDate(lead.proxima_atividade))+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-auto ml-auto"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(lead.codlead)},"action":function($event){return _vm.handleAction(_vm.id, lead.codlead)}}})],1)])])})],2)],1),_vm._v(" "),(_vm.showFormNovo)?_c('crm-lead-novo-form',{attrs:{"index":_vm.codlead},on:{"closeform":_vm.closeForm}}):_vm._e(),_vm._v(" "),(_vm.codlead)?_c('div',{staticClass:"deal-form-side"},[_c('crm-lead-form',{attrs:{"index":_vm.codlead},on:{"closeform":_vm.closeForm}})],1):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto text-center"},[_c('div',{staticClass:"list-icon"},[_c('i',{staticClass:"fa fa-exclamation",attrs:{"aria-hidden":"true"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_pessoa_list_vue__ = __webpack_require__(730);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_130722a5_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_pessoa_list_vue__ = __webpack_require__(2066);
function injectStyle (ssrContext) {
  __webpack_require__(2064)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_pessoa_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_130722a5_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_pessoa_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2065);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5dd8bcca", content, true, {});

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".list-title{display:inline-block;max-width:100%;font-weight:700;color:#4993d2}.list-icon{font-size:24px;align-items:center;justify-content:center;background-color:#f5f5f5;border:1px solid #e0e0e0;box-sizing:border-box;height:38px;width:42px;flex-shrink:0}", ""]);

// exports


/***/ }),
/* 2066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":true,"single-entity":"Contato","plural-entity":"Contatos"},on:{"search":_vm.textSearch,"new":_vm.handleNovo,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('crm-filtros-negocio',{attrs:{"pessoas":true},on:{"changeUsuario":_vm.handleChangeUsuario,"changeEquipe":_vm.handleChangeEquipe,"changeFiltroContatos":_vm.handleChangeContatos}})],1),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.pessoaList.length == 0)?_c('div',{staticClass:"no-content mb-4"},[_vm._v("Nenhum contato foi encontrado")]):_vm._e(),_vm._v(" "),_vm._l((_vm.pessoaList),function(pessoa,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"row p-2"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('span',{staticClass:"list-title"},[_vm._v(_vm._s(pessoa.nome))]),_vm._v(" "),(pessoa.excluido=='S')?_c('span',{staticClass:"badge badge-red ml-2"},[_vm._v("Excluído")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('span',{staticClass:"lbl-list-detalhe"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataHoraExtenso")(pessoa.data)))]),_vm._v(" "),_c('span',{staticClass:"lbl-list-detalhe"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(pessoa.nome_usuario))]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(pessoa.telefones.length > 0)?_c('div',_vm._l((pessoa.telefones),function(fone,index2){return _c('span',{key:index2,staticClass:"lbl-list pr-2"},[_c('i',{staticClass:"fa fa-phone pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatFone")(fone.numero)))])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(pessoa.organizacao.length>0)?_c('a',{staticClass:"lbl-list w-100",attrs:{"href":'#/crm/organizacao/'+pessoa.codorg}},[_c('i',{staticClass:"fa fa-university pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(pessoa.organizacao[0].nome))]):_vm._e(),_vm._v(" "),(pessoa.count_abertos || pessoa.count_negocios)?_c('div',[_c('label',{staticClass:"lbl-list"},[_vm._v("Negócios Abertos "),_c('span',{staticClass:"lbl-list"},[_vm._v(_vm._s(pessoa.count_abertos))])]),_vm._v(" "),_c('label',{staticClass:"lbl-list"},[_vm._v("Negócios Fechados "),_c('span',{staticClass:"lbl-list"},[_vm._v(_vm._s(pessoa.count_negocios))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[(pessoa.tag.length>0)?_c('span',{staticClass:"tag-input-color mr-3",style:(_vm.handleStyle(pessoa.tag[0].cor)),on:{"click":function($event){return _vm.handleEditarPessoa('nome')}}},[_vm._v(" "+_vm._s(pessoa.tag[0].descricao)+" ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[(pessoa.dias_atividade>0)?_c('span',{staticClass:"icon icon-atrasado",attrs:{"title":'Atividade atrasada há ' + pessoa.dias_atividade + ' dias',"data-toggle":"tooltip","data-placement":"top"}},[_c('i',{staticClass:"fa fa-calendar",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(pessoa.count_agenda == 0)?_c('span',{staticClass:"icon icon-sem-agenda",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Nenhuma atividade"}},[_c('i',{staticClass:"fa fa-warning",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(pessoa.count_agenda > 0 && pessoa.dias_atividade <= 0)?_c('span',{staticClass:"icon icon-agenda",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Atividade planejada"}},[_c('i',{staticClass:"fa fa-calendar",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(!pessoa.proxima_atividade)?_c('label',{staticClass:"lbl-list icon-sem-agenda"},[_vm._v("Sem Atividade")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list",style:(_vm.handleStyleAgenda(pessoa))},[_vm._v(" "+_vm._s(_vm.formatDate(pessoa.proxima_atividade))+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-auto ml-auto"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(pessoa.codpessoa)},"action":function($event){return _vm.handleAction(_vm.id, pessoa.codpessoa)}}})],1)])])})],2)],1),_vm._v(" "),(_vm.showFormNovo)?_c('crm-pessoa-novo-form',{attrs:{"index":this.codpessoa},on:{"closeform":_vm.closeForm}}):_vm._e(),_vm._v(" "),(_vm.codpessoa)?_c('div',{staticClass:"deal-form-side"},[_c('crm-pessoa-form',{attrs:{"index":this.codpessoa},on:{"closeform":_vm.closeForm}})],1):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto text-center"},[_c('div',{staticClass:"list-icon"},[_c('i',{staticClass:"fa fa-user",attrs:{"aria-hidden":"true"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2068);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e5ee1090", content, true, {});

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.organizacao)?_c('div',{staticClass:"deal-form",attrs:{"id":"formorg"}},[_c('div',{staticClass:"deal-form-1"},[_c('div',{staticClass:"deal-form-2"},[_c('div',{staticClass:"deal-form-3"},[_c('div',{staticClass:"deal-form-left"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mt-2"},[_c('span',{staticClass:"lbl-deal-title",staticStyle:{"cursor":"pointer"},on:{"click":_vm.handleEditarOrg}},[_vm._v(_vm._s(_vm.organizacao.nome))]),_vm._v(" "),(_vm.organizacao.excluido=='S')?_c('span',{staticClass:"badge badge-red"},[_vm._v("Excluída")]):_vm._e(),_vm._v(" "),(_vm.organizacao.excluido!='S')?_c('v-button',{staticClass:"float-right",attrs:{"label":"","title":"Excluir esta organização","danger":true,"icon":"fa-trash"},on:{"click":_vm.handleExcluir}}):_vm._e(),_vm._v(" "),(_vm.organizacao.excluido!='S')?_c('v-button',{staticClass:"float-right",attrs:{"label":"","title":"","icon":"fa-pencil"},on:{"click":_vm.handleEditarOrg}}):_vm._e(),_vm._v(" "),(_vm.organizacao.excluido=='S')?_c('v-button',{staticClass:"float-right",attrs:{"label":"Reabrir","title":"Reabrir esta organização","icon":""},on:{"click":_vm.handleReabrir}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"w-100"},[_c('span',{staticClass:"lbl-list"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Criado em "+_vm._s(_vm._f("formatDataHoraExtenso")(_vm.organizacao.data)))])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[(_vm.organizacao.cnpj)?_c('span',{staticClass:"lbl-list pr-3"},[_vm._v(" "+_vm._s(_vm._f("formatCNPJCPF")(_vm.organizacao.cnpj))+" ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"w-100"},[(_vm.organizacao.mun_nome)?_c('span',{staticClass:"lbl-list pr-3"},[_c('i',{staticClass:"fa fa-location-arrow mr-2"}),_vm._v(" "+_vm._s(_vm.organizacao.mun_nome)+" "+_vm._s(_vm.organizacao.uf)+" ")]):_vm._e()])]),_vm._v(" "),(_vm.permiteAlteracao)?_c('div',{staticClass:"col-12 mt-3"},[(_vm.organizacao.tag.length>0)?_c('div',[_c('i',{staticClass:"lbl-deal-subtitle fa fa-tag pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"tag-input-color",style:(_vm.handleStyle(_vm.organizacao.tag[0].cor)),on:{"click":_vm.handleEditarOrg}},[_vm._v(_vm._s(_vm.organizacao.tag[0].descricao)+" ")])]):_c('v-button',{attrs:{"link":true,"label":"Definir uma etiqueta","icon":"fa-tag"},on:{"click":_vm.handleEditarOrg}})],1):_vm._e(),_vm._v(" "),(_vm.organizacao.pessoas.length > 0)?_c('div',{staticClass:"col-12 mt-5"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.organizacao.pessoas),function(pessoa,index){return _c('span',{key:index},[_c('a',{staticClass:"data-list pr-2",attrs:{"href":'#/crm/pessoa/' + pessoa.codpessoa}},[_c('i',{staticClass:"fa fa-user pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(pessoa.nome)+" ")])])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_vm._m(1),_vm._v(" "),_c('div',[_c('a',{staticClass:"lbl pr-2"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.nomeUsuario))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_vm._v("USUÁRIOS VINCULADOS")]),_vm._v(" "),(_vm.permiteAlteracao)?_c('v-button',{attrs:{"link":true,"label":"Adicione usuários vinculados","icon":"fa-plus","nb-btdef":false},on:{"click":_vm.handleIncluirSeguidor}}):_vm._e(),_vm._v(" "),_vm._l((_vm.seguidores),function(item,index){return _c('span',{key:index},[_c('a',{staticClass:"data-list pr-2"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.usuario_nome))])])})],2),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_vm._m(2),_vm._v(" "),(_vm.permiteAlteracao)?_c('v-button',{attrs:{"link":true,"label":"Anexar um Arquivo","icon":"fa-plus","nb-btdef":false},on:{"click":_vm.handleAnexarDocumento}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('anexos-form',{ref:"anexos",attrs:{"params":{ ref: 'orgcrm', chaveref: _vm.organizacao.codorganizacao, showForm: false }},on:{"change":_vm.handleChangeAnexos}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"deal-form-right"},[_c('div',{staticClass:"sticky"},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-x":"auto","height":"100%"}},[_c('div',{staticClass:"mt-1"},[_c('crm-notes',{attrs:{"params":{ codorg: _vm.organizacao.codorganizacao, notes: _vm.notes }}})],1),_vm._v(" "),_c('div',{staticClass:"mt-5"},[_vm._m(3),_vm._v(" "),_c('v-button',{attrs:{"link":true,"label":"Criar uma atividade","icon":"fa-plus"},on:{"click":_vm.handleIncluirAgenda}})],1),_vm._v(" "),_c('crm-negocio-agenda',{ref:"agenda",attrs:{"params":{ organizacao: _vm.organizacao, pessoa: null, listAgenda: _vm.organizacao.agenda, listAgendaShow: _vm.agendaListPlanejada, delete: true, edit: true }},on:{"update":_vm.updateAgenda,"delete":_vm.updateAgenda}}),_vm._v(" "),(_vm.listNegocios.length > 0)?_c('div',{staticClass:"mt-5"},[_vm._m(4)]):_vm._e(),_vm._v(" "),_vm._l((_vm.listNegocios),function(negocio,index){return _c('div',{key:index},[_c('crm-card',{attrs:{"negocio":negocio},on:{"edit":function($event){return _vm.handleShowNegocio(negocio.codnegocio)},"adicionarAgenda":_vm.handleAdicionarAgendaNegocio,"editAgenda":_vm.handleEditAgendaNegocio}})],1)})],2)])])])]),_vm._v(" "),(_vm.showFormNegocio)?_c('crm-negocio-novo-form',{attrs:{"params":_vm.paramsNegocio},on:{"closeform":_vm.closeNovoNegocio}}):_vm._e(),_vm._v(" "),(_vm.showFormOrg)?_c('crm-org-novo-form',{attrs:{"index":_vm.organizacao.codorg},on:{"closeform":_vm.closeFormOrg}}):_vm._e(),_vm._v(" "),(_vm.showFormPessoa)?_c('crm-pessoa-novo-form',{attrs:{"index":this.codpessoa},on:{"closeform":_vm.closeFormPessoa}}):_vm._e(),_vm._v(" "),(_vm.showFormSeguidores)?_c('crm-negocio-seguidores',{attrs:{"params":{ organizacao: _vm.organizacao }},on:{"closeform":_vm.handleCloseSeguidor}}):_vm._e()],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_vm._v("CONTATOS VINCULADOS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"lbl-deal-subtitle mb-2"},[_vm._v("PROPRIETÁRIO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lbl-deal-subtitle"},[_c('i',{staticClass:"fa fa-paperclip pr-2"}),_vm._v("ANEXOS")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lbl-deal-subtitle mb-2"},[_c('i',{staticClass:"fa fa-calendar pr-2"}),_vm._v("ATIVIDADES PLANEJADAS")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"lbl-deal-subtitle"},[_c('i',{staticClass:"fa fa-dollar pr-2"}),_vm._v("NEGÓCIOS")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_org_list_vue__ = __webpack_require__(732);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_305b5a96_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_org_list_vue__ = __webpack_require__(2073);
function injectStyle (ssrContext) {
  __webpack_require__(2071)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_org_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_305b5a96_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_org_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2072);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4186c71e", content, true, {});

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".list-title{display:inline-block;max-width:100%;font-weight:700;color:#4993d2}", ""]);

// exports


/***/ }),
/* 2073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":true,"single-entity":"Organização","plural-entity":"Organizações"},on:{"search":_vm.textSearch,"new":_vm.handleNovo,"refresh":_vm.loadData}}),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('crm-filtros-negocio',{attrs:{"organizacao":true},on:{"changeUsuario":_vm.handleChangeUsuario,"changeEquipe":_vm.handleChangeEquipe,"changeFiltroOrg":_vm.handleChangeFiltroOrg}})],1),_vm._v(" "),_c('div',{staticClass:"default-container py-0"},[(_vm.organizacaoList.length == 0)?_c('div',{staticClass:"no-content mb-4"},[_vm._v("Nenhuma organização foi encontrada")]):_vm._e(),_vm._v(" "),_vm._l((_vm.organizacaoList),function(organizacao,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"row p-2",on:{"click":function($event){return _vm.handleEdit(organizacao.codorg)}}},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('span',{staticClass:"list-title"},[_vm._v(_vm._s(organizacao.nome))]),_vm._v(" "),(organizacao.excluido=='S')?_c('span',{staticClass:"badge badge-red ml-2"},[_vm._v("Excluído")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('span',{staticClass:"lbl-list-detalhe"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataHoraExtenso")(organizacao.data)))]),_vm._v(" "),_c('span',{staticClass:"lbl-list-detalhe"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(organizacao.nome_usuario))]),_vm._v(" "),_c('div',{staticClass:"w-100 mt-3"}),_vm._v(" "),(organizacao.pessoas.length > 0)?_c('div',_vm._l((organizacao.pessoas),function(pessoa,index2){return _c('a',{key:index2,staticClass:"data-list pr-2",attrs:{"href":'#/crm/pessoa/'+pessoa.codpessoa}},[_c('i',{staticClass:"fa fa-user pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(pessoa.nome))])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100 mt-3"}),_vm._v(" "),(organizacao.count_abertos || organizacao.count_negocios)?_c('div',[_c('label',{staticClass:"lbl-list"},[_vm._v("Negócios Abertos "),_c('span',{staticClass:"lbl-list"},[_vm._v(_vm._s(organizacao.count_abertos))])]),_vm._v(" "),_c('label',{staticClass:"lbl-list"},[_vm._v("Negócios Fechados "),_c('span',{staticClass:"lbl-list"},[_vm._v(_vm._s(organizacao.count_negocios))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[(organizacao.tag.length>0)?_c('span',{staticClass:"tag-input-color mr-3",style:(_vm.handleStyle(organizacao.tag[0].cor))},[_vm._v(_vm._s(organizacao.tag[0].descricao)+" ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[(organizacao.dias_atividade>0)?_c('span',{staticClass:"icon icon-atrasado",attrs:{"title":'Atividade atrasada há ' + organizacao.dias_atividade + ' dias',"data-toggle":"tooltip","data-placement":"top"}},[_c('i',{staticClass:"fa fa-calendar",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(organizacao.count_agenda == 0)?_c('span',{staticClass:"icon icon-sem-agenda",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Nenhuma atividade"}},[_c('i',{staticClass:"fa fa-warning",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(organizacao.count_agenda > 0 && organizacao.dias_atividade <= 0)?_c('span',{staticClass:"icon icon-agenda",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Atividade planejada"}},[_c('i',{staticClass:"fa fa-calendar",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(!organizacao.proxima_atividade)?_c('label',{staticClass:"lbl-list icon-sem-agenda"},[_vm._v("Sem Atividade")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list",style:(_vm.handleStyleAgenda(organizacao))},[_vm._v(" "+_vm._s(_vm.formatDate(organizacao.proxima_atividade))+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-auto ml-auto"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(organizacao.codorg)},"action":function($event){return _vm.handleAction(_vm.id, organizacao.codorg)}}})],1)])])})],2)],1),_vm._v(" "),(_vm.showFormNovo)?_c('crm-org-novo-form',{attrs:{"index":this.codorg},on:{"closeform":_vm.closeForm}}):_vm._e(),_vm._v(" "),(_vm.codorg)?_c('div',{staticClass:"deal-form-side"},[_c('crm-org-form',{attrs:{"index":_vm.codorg},on:{"closeform":_vm.closeForm}})],1):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto text-center"},[_c('div',{staticClass:"list-icon"},[_c('i',{staticClass:"fa fa-university",attrs:{"aria-hidden":"true"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_email_list_vue__ = __webpack_require__(733);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4902932d_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_email_list_vue__ = __webpack_require__(2077);
function injectStyle (ssrContext) {
  __webpack_require__(2075)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_email_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4902932d_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_email_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2076);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("02f1dc9e", content, true, {});

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-100 mt-2 mb-2"},[_c('v-button',{attrs:{"title":"Sincronizar","icon":"fa-refresh","nb-btdef":false},on:{"click":_vm.loadData}})],1),_vm._v(" "),(_vm.novoEmail)?_c('div',{staticClass:"mt-3 card p-2"},[_c('crm-email',{attrs:{"negocio":_vm.negociocrm,"pessoa":_vm.pessoa},on:{"close":function($event){_vm.novoEmail = null}}})],1):_vm._e(),_vm._v(" "),(!_vm.novoEmail)?_c('div',{staticClass:"default-container"},[_c('tabs',{attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}),_vm._v(" "),(_vm.emailList.length == 0)?_c('div',{staticClass:"no-content mb-4"},[_vm._v("Nenhuma email foi encontrado")]):_vm._e(),_vm._v(" "),_vm._l((_vm.emailList),function(item,index){return _c('div',{key:index,staticClass:"mainbox mt-2"},[_c('div',{staticClass:"row p-2 align-items-center",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.showCodemail = item.codemail}}},[_c('div',{staticClass:"col-auto text-center"},[_c('div',{staticClass:"list-icon"},[(item.inbox == 'S')?_c('i',{staticClass:"fa fa-arrow-down"}):_c('i',{staticClass:"fa fa-arrow-right"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-6"},[_c('span',{staticClass:"lbl-list"},[_vm._v(_vm._s(_vm._f("formatDataHoraExtenso")(item.data)))]),_vm._v(" "),(item.inbox == 'S' && item.from_list.length > 0)?_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(item.pessoa_nome)+" "+_vm._s(item.from_list[0].email))]):_vm._e(),_vm._v(" "),(item.inbox != 'S' && item.to_list.length > 0)?_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(item.to_list[0].nome)+" "+_vm._s(item.to_list[0].email))]):_vm._e(),_vm._v(" "),(item.visualizado=='S')?_c('span',{staticClass:"data-list w-100"},[_vm._v(_vm._s(item.subject))]):_c('span',{staticClass:"data-list w-100"},[_c('strong',[_vm._v(" "+_vm._s(item.subject)+" ")])]),_vm._v(" "),(item.negocio_titulo)?_c('a',{staticClass:"lbl-list pr-2",attrs:{"href":'#/crm/negocio/'+item.link_codnegocio}},[_c('i',{staticClass:"fa fa-dollar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.negocio_titulo))]):_vm._e(),_vm._v(" "),(item.pessoa_nome)?_c('a',{staticClass:"lbl-list pr-2",attrs:{"href":'#/crm/pessoa/'+item.link_codnegocio}},[_c('i',{staticClass:"fa fa-user pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(item.pessoa_nome))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-auto col-3 text-right"},[(item.attachments.length > 1)?_c('span',{staticClass:"lbl"},[_c('i',{staticClass:"fa fa-paperclip",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}})]):_vm._e()])])])})],2):_vm._e(),_vm._v(" "),(_vm.showCodemail)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"max-width":"90%"}},[_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('crm-email',{attrs:{"codemail":_vm.showCodemail},on:{"closeform":_vm.closeEmail}})],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_config_vue__ = __webpack_require__(734);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4adb1c56_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_config_vue__ = __webpack_require__(2105);
function injectStyle (ssrContext) {
  __webpack_require__(2079)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_config_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4adb1c56_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_config_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2080);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b06db5ee", content, true, {});

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_motivo_list_vue__ = __webpack_require__(735);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_63bf9c26_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_motivo_list_vue__ = __webpack_require__(2088);
function injectStyle (ssrContext) {
  __webpack_require__(2082)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_motivo_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_63bf9c26_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_motivo_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2083);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("501d942a", content, true, {});

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_motivo_form_vue__ = __webpack_require__(736);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7011e168_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_motivo_form_vue__ = __webpack_require__(2087);
function injectStyle (ssrContext) {
  __webpack_require__(2085)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_motivo_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7011e168_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_motivo_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2086);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3d3e2ee4", content, true, {});

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row align-items-center"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.motivocrm.descricao.validator),expression:"metadata.motivocrm.descricao.validator"}],ref:"descricao",attrs:{"type":"text","col":"6","metadata":_vm.metadata.motivocrm.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.motivocrm.descricao),callback:function ($$v) {_vm.$set(_vm.motivocrm, "descricao", $$v)},expression:"motivocrm.descricao"}}),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-button',{attrs:{"label":"Salvar","nb-btdef":true},on:{"click":_vm.handleSave}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.closeForm}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Motivo de Perda","plural-entity":""},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.showForm)?_c('crm-motivo-form',{attrs:{"index":_vm.codmotivo,"crud":_vm.crud},on:{"closeform":_vm.closeForm}}):_vm._e(),_vm._v(" "),(_vm.motivoList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.motivoList),function(motivo){return _c('div',{key:motivo.codmotivo,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!motivo.show),expression:"!motivo.show"}],staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-6"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(motivo.descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnDelete: true, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(motivo)},"delete":function($event){return _vm.handleDelete(motivo)}}})],1)]),_vm._v(" "),(motivo.show)?_c('crm-motivo-form',{attrs:{"index":motivo.codmotivo,"crud":_vm.crud},on:{"closeform":function($event){return _vm.closeForm(motivo)}}}):_vm._e()],1)])})],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_origem_list_vue__ = __webpack_require__(737);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_26c18e16_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_origem_list_vue__ = __webpack_require__(2096);
function injectStyle (ssrContext) {
  __webpack_require__(2090)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_origem_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_26c18e16_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_origem_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2091);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("11cb9a26", content, true, {});

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_origem_form_vue__ = __webpack_require__(738);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2953b8a2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_origem_form_vue__ = __webpack_require__(2095);
function injectStyle (ssrContext) {
  __webpack_require__(2093)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_crm_origem_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2953b8a2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_crm_origem_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2094);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d625083e", content, true, {});

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row align-items-center"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.origemcrm.descricao.validator),expression:"metadata.origemcrm.descricao.validator"}],ref:"descricao",attrs:{"type":"text","col":"6","metadata":_vm.metadata.origemcrm.descricao,"name":"descricao","v-errors":_vm.errors},model:{value:(_vm.origemcrm.descricao),callback:function ($$v) {_vm.$set(_vm.origemcrm, "descricao", $$v)},expression:"origemcrm.descricao"}}),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('v-button',{attrs:{"label":"Salvar","nb-btdef":true},on:{"click":_vm.handleSave}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.closeForm}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Origem do Contato","plural-entity":""},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.showForm)?_c('crm-origem-form',{attrs:{"index":_vm.codorigem,"crud":_vm.crud},on:{"closeform":_vm.closeForm}}):_vm._e(),_vm._v(" "),(_vm.origemList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.origemList),function(origem){return _c('div',{key:origem.codorigem,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!origem.show),expression:"!origem.show"}],staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-6"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(origem.descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnDelete: true, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(origem)},"delete":function($event){return _vm.handleDelete(origem)}}})],1)]),_vm._v(" "),(origem.show)?_c('crm-origem-form',{attrs:{"index":origem.codorigem,"crud":_vm.crud},on:{"closeform":function($event){return _vm.closeForm(origem)}}}):_vm._e()],1)])})],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_template_email_list_vue__ = __webpack_require__(739);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_74cff185_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_template_email_list_vue__ = __webpack_require__(2104);
function injectStyle (ssrContext) {
  __webpack_require__(2098)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_template_email_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_74cff185_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_template_email_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2099);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("761c764f", content, true, {});

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_template_email_form_vue__ = __webpack_require__(740);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f759d2ce_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_template_email_form_vue__ = __webpack_require__(2103);
function injectStyle (ssrContext) {
  __webpack_require__(2101)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_template_email_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f759d2ce_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_template_email_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2102);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0157d0f8", content, true, {});

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container",staticStyle:{"width":"600px","max-width":"100%"}},[_c('div',{staticClass:"nb-modal-header"},[(_vm.templemail.codtempl)?_c('h4',{staticClass:"def-title"},[_vm._v("Alterar Template")]):_c('h4',{staticClass:"def-title"},[_vm._v("Novo Template")])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"row align-items-center"},[_c('form-field',{ref:"descricao",attrs:{"type":"text","col":"12","metadata":_vm.metadata.templemail.descricao},model:{value:(_vm.templemail.descricao),callback:function ($$v) {_vm.$set(_vm.templemail, "descricao", $$v)},expression:"templemail.descricao"}}),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('input-switch',{attrs:{"type":"success","label":"Template Publico","value-checked":"S","value-unchecked":"N","metadata":_vm.metadata.part.cliente},model:{value:(_vm.templemail.publico),callback:function ($$v) {_vm.$set(_vm.templemail, "publico", $$v)},expression:"templemail.publico"}})],1),_vm._v(" "),_c('form-field',{attrs:{"type":"text","col":"12","metadata":_vm.metadata.templemail.subject},model:{value:(_vm.templemail.subject),callback:function ($$v) {_vm.$set(_vm.templemail, "subject", $$v)},expression:"templemail.subject"}}),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('wysiwyg',{model:{value:(_vm.templemail.body_content),callback:function ($$v) {_vm.$set(_vm.templemail, "body_content", $$v)},expression:"templemail.body_content"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{staticClass:"float-right",attrs:{"label":"Cancelar","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}}),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Salvar","nb-btdef":true},on:{"click":_vm.handleSalvar}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":true,"pdf-button":false,"xls-button":false,"single-entity":"Template de Email","plural-entity":"Templates de Email"},on:{"search":_vm.search,"new":_vm.handleNew,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.templEmailList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.templEmailList),function(template){return _c('div',{key:template.codtempl,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-6"},[_c('span',{staticClass:"lbl-title-produto"},[_vm._v(_vm._s(template.descricao))]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('span',{staticClass:"lbl-list-detalhe pr-2"},[_c('i',{staticClass:"fa fa-calendar pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("formatDataHoraExtenso")(template.data)))]),_vm._v(" "),_c('span',{staticClass:"lbl-list-detalhe"},[_c('i',{staticClass:"fa fa-user-circle pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(template.usuario_nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6"},[_c('bar-grid',{attrs:{"options":{barDefault: true, btnDelete: true, btnEdit: true},"moreActions":[]},on:{"edit":function($event){return _vm.handleEdit(template)},"delete":function($event){return _vm.handleDelete(template)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 mt-3"},[(template.publico == 'S')?_c('span',{staticClass:"data-list pr-2"},[_c('i',{staticClass:"fa fa-unlock pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Template Público ")]):_c('span',{staticClass:"data-list pr-2"},[_c('i',{staticClass:"fa fa-lock pr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Template Privado ")])])])])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('template-email-form',{attrs:{"index":_vm.codtempl,"crud":_vm.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tabs',{attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}),_vm._v(" "),_c('div',{staticClass:"nb-margin-top"},[(_vm.tabMotivo)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('crm-motivo-list')],1):_vm._e(),_vm._v(" "),(_vm.tabOrigem)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('crm-origem-list')],1):_vm._e(),_vm._v(" "),(_vm.tabTemplate)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('template-email-list')],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_mercadolivre_code_vue__ = __webpack_require__(741);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_27ee6fbc_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_mercadolivre_code_vue__ = __webpack_require__(2109);
function injectStyle (ssrContext) {
  __webpack_require__(2107)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_app_mercadolivre_code_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_27ee6fbc_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_app_mercadolivre_code_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2108);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5f300952", content, true, {});

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row nb-margin-top mb-3"},[_c('form-field',{ref:"code",attrs:{"type":"text","col":"12","label":"Code","case":"normal"},model:{value:(_vm.code2),callback:function ($$v) {_vm.code2=$$v},expression:"code2"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_manifesto_list_vue__ = __webpack_require__(742);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_62896a74_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_manifesto_list_vue__ = __webpack_require__(2121);
function injectStyle (ssrContext) {
  __webpack_require__(2111)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_manifesto_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_62896a74_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_manifesto_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2112);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6a71b4be", content, true, {});

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_manifesto_form_vue__ = __webpack_require__(743);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f5ea97_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_manifesto_form_vue__ = __webpack_require__(2116);
function injectStyle (ssrContext) {
  __webpack_require__(2114)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_manifesto_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f5ea97_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_manifesto_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2115);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0ea11e45", content, true, {});

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Manifestação de Nota Recebida","plural-entity":"Manifestação de Nota Recebida","crud":this.crud,"btn-delete":false,"moreActions":_vm.getActionsManifesto()},on:{"action":_vm.handleAction,"closeform":_vm.closeForm}}),_vm._v(" "),(_vm.errmessages.length != 0)?_c('validation',{attrs:{"messages":_vm.errmessages}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3",staticStyle:{"float":"left"}},[_c('v-label',{attrs:{"label":"Manifestação"}}),_c('br'),_vm._v(" "),_c('strong',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.statusManifesto(_vm.manifesto.confdest)))])],1),_vm._v(" "),_c('div',{staticClass:"col-3",staticStyle:{"float":"left"}},[_c('v-label',{attrs:{"label":_vm.metadata.manifesto.nrdoc.label}}),_c('br'),_vm._v(" "),_c('strong',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.manifesto.nrdoc))])],1),_vm._v(" "),_c('div',{staticClass:"col-3",staticStyle:{"float":"left"}},[_c('v-label',{attrs:{"label":_vm.metadata.manifesto.vnf.label}}),_c('br'),_vm._v(" "),_c('strong',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.manifesto.vnf,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-3",staticStyle:{"float":"left"}},[_c('v-label',{attrs:{"label":_vm.metadata.manifesto.dtdoc.label}}),_c('br'),_vm._v(" "),_c('strong',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.manifesto.dtdoc)))])],1),_vm._v(" "),_c('div',{staticClass:"col-6",staticStyle:{"float":"left"}},[_c('v-label',{attrs:{"label":_vm.metadata.manifesto.emi_nome.label}}),_c('br'),_vm._v(" "),_c('strong',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.manifesto.emi_nome))])],1),_vm._v(" "),_c('div',{staticClass:"col-6",staticStyle:{"float":"left"}},[_c('v-label',{attrs:{"label":_vm.metadata.manifesto.chnfe.label}}),_c('br'),_vm._v(" "),_c('strong',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.manifesto.chnfe))])],1),_vm._v(" "),_c('div',{staticClass:"col-6",staticStyle:{"float":"left"}},[_c('v-label',{attrs:{"label":_vm.metadata.manifesto.emi_cnpjcpf.label}}),_c('br'),_vm._v(" "),_c('strong',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(_vm.manifesto.emi_cnpjcpf)))])],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},_vm._l((_vm.manifesto.list_manifesto),function(item){return _c('div',{key:_vm.manifesto.codmanifesto,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v(" Tipo ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.statusManifesto(item.confdest))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v(" "+_vm._s(_vm.metadata.manifesto.tpevento.label)+" ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm.descricaoEvento(item.tpevento)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v(" "+_vm._s(_vm.metadata.manifesto.dataleitura.label)+" ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(item.dataleitura)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v(" "+_vm._s(_vm.metadata.manifesto.dtemi.label)+" ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(item.dtemi)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v(" "+_vm._s(_vm.metadata.manifesto.stnfedesc.label)+" ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.stnfedesc))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v(" "+_vm._s(_vm.metadata.manifesto.tpamb.label)+" ")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.tpamb))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v(" "+_vm._s(_vm.metadata.manifesto.tpnf.label)+" ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.tpnf))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v(" NSU ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.nsu_novows))])]),_vm._v(" "),(item.msg)?_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v(" "+_vm._s(_vm.metadata.manifesto.msg.label)+" ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.msg)+" ")])]):_vm._e()])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"w-100 text-center",staticStyle:{"position":"fixed","left":"0","bottom":"0","z-index":"10","border-top":"1px solid #eee","background-color":"#fdfbfb","padding":"15px","-webkit-box-shadow":"0 -2px 5px rgba(0,0,0,0.2)","-moz-box-shadow":"0 -2px 5px rgba(0,0,0,0.2)","box-shadow":"0 -2px 5px rgba(0,0,0,0.2)"}},[(_vm.manifesto.confdest == '0')?_c('v-button',{attrs:{"label":"Ciência da Operação","icon":"","title":"","nb-btdef":false},on:{"click":function($event){return _vm.handleAction(_vm.Actions.CIENCIA_OPERACAO)}}}):_vm._e(),_vm._v(" "),(_vm.manifesto.confdest == '0')?_c('v-button',{attrs:{"label":"Confirmação da Operação","icon":"","nb-btdef":false},on:{"click":function($event){return _vm.handleAction(_vm.Actions.CONFIRMACAO_OPERACAO)}}}):_vm._e(),_vm._v(" "),(_vm.manifesto.confdest == '0')?_c('v-button',{attrs:{"label":"Desconhecimento da Operação","icon":"","nb-btdef":false},on:{"click":function($event){return _vm.handleAction(_vm.Actions.DESCONHECIMENTO_OPERACAO)}}}):_vm._e(),_vm._v(" "),(_vm.manifesto.confdest == '0')?_c('v-button',{attrs:{"label":"Operação não realizada","icon":"","nb-btdef":false},on:{"click":function($event){return _vm.handleAction(_vm.Actions.OPERACAO_NAO_REALIZADA)}}}):_vm._e(),_vm._v(" "),(_vm.manifesto.confdest != '0' && (!_vm.manifesto.list_manifesto[0].xml || _vm.manifesto.list_manifesto[0].xml == ''))?_c('v-button',{attrs:{"label":"Download do XML","icon":"","nb-btdef":true},on:{"click":function($event){return _vm.handleAction(_vm.Actions.CARREGAR_XML)}}}):_vm._e(),_vm._v(" "),(_vm.manifesto.list_manifesto[0].xml && _vm.manifesto.list_manifesto[0].xml != '')?_c('v-button',{attrs:{"label":"Gerar NF de Entrada por XML","icon":"","nb-btdef":true},on:{"click":function($event){return _vm.handleAction(_vm.Actions.GERAR_NF_ENTRADA)}}}):_vm._e(),_vm._v(" "),(_vm.manifesto.list_manifesto[0].xml && _vm.manifesto.list_manifesto[0].xml != '')?_c('v-button',{attrs:{"label":"Download XML","icon":"","nb-btdef":false},on:{"click":function($event){return _vm.handleAction(_vm.Actions.DOWNLOAD_XML)}}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_manifesto_filtro_vue__ = __webpack_require__(745);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_11ed001c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_manifesto_filtro_vue__ = __webpack_require__(2120);
function injectStyle (ssrContext) {
  __webpack_require__(2118)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_manifesto_filtro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_11ed001c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_manifesto_filtro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2119);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6c67e534", content, true, {});

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row align-items-center mb-3"},[_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"lbl"},[_vm._v("Tipo Manifesto\n            "),_c('a',{staticClass:"dropdown-toggle pr-2",staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"1","data-toggle":"dropdown"}},[_vm._v(" "+_vm._s(_vm.labelManifesto)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.filtroTipos.list),function(filtro,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleChangeFiltroManifesto(index)}}},[_vm._v(_vm._s(filtro.label))])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":false,"pdf-button":false,"xls-button":false,"single-entity":"Manifestação das Notas Recebidas","plural-entity":"Manifestação das Notas Recebidas","moreActions":_vm.moreActionsBarList,"pesqultimos":"","title-search":"Pesquise pelo CNPJ, Nome ou pelo Nr. documento "},on:{"action":_vm.handleAction,"search":_vm.search,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('manifesto-filtro',{attrs:{"query":_vm.query},on:{"change":_vm.changeFiltros}}),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.manifestoList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.manifestoList),function(manifesto,index){return (_vm.showList)?_c('div',{key:index,staticClass:"mainbox-select"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-6"},[(index == 0)?_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Número")]):_vm._e(),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(manifesto.nrdoc))]),_vm._v(" "),(manifesto.confdest == '1')?_c('span',{staticClass:"badge badge-green w-100 mb-2"},[_vm._v(" "+_vm._s(_vm.statusManifesto(manifesto.confdest))+" ")]):_vm._e(),_vm._v(" "),(manifesto.confdest == '0')?_c('span',{staticClass:"badge badge-yellow w-100 mb-2"},[_vm._v(" "+_vm._s(_vm.statusManifesto(manifesto.confdest))+" ")]):_vm._e(),_vm._v(" "),(manifesto.confdest == '4')?_c('span',{staticClass:"badge badge-blue w-100 mb-2"},[_vm._v(" "+_vm._s(_vm.statusManifesto(manifesto.confdest))+" ")]):_vm._e(),_vm._v(" "),(manifesto.confdest == '2')?_c('span',{staticClass:"badge badge-silver w-100 mb-2"},[_vm._v(" "+_vm._s(_vm.statusManifesto(manifesto.confdest))+" ")]):_vm._e(),_vm._v(" "),(manifesto.confdest == '3')?_c('span',{staticClass:"badge badge-silver w-100 mb-2"},[_vm._v(" "+_vm._s(_vm.statusManifesto(manifesto.confdest))+" ")]):_vm._e(),_vm._v(" "),(manifesto.stnfe == '2' || manifesto.stnfe == '3')?_c('span',{staticClass:"badge badge-red w-100 mb-2"},[_vm._v(" "+_vm._s(_vm.statusNFe(manifesto.stnfe))+" ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6"},[(index == 0)?_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Data Documento")]):_vm._e(),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(manifesto.dtdoc)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6",staticStyle:{"float":"left"}},[(index == 0)?_c('label',{staticClass:"lbl-list w-100"},[_vm._v(" "+_vm._s(_vm.metadata.manifesto.emi_nome.label)+" ")]):_vm._e(),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(manifesto.emi_nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6",staticStyle:{"float":"left"}},[(index == 0)?_c('label',{staticClass:"lbl-list w-100"},[_vm._v(" "+_vm._s(_vm.metadata.manifesto.vnf.label)+" ")]):_vm._e(),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(manifesto.vnf,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('bar-grid',{attrs:{"obj":manifesto,"options":{barDefault: true, btnView: true, btnEdit: false, barMANIFESTO: true},"moreActions":_vm.getActionsManifesto(manifesto)},on:{"action":_vm.handleActionManifesto,"view":function($event){return _vm.handleEdit(manifesto.chnfe, true)}}})],1)])])]):_vm._e()})],2)],1),_vm._v(" "),(_vm.showForm)?_c('manifesto-form',{attrs:{"index":this.chNfe,"crud":this.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_movimento_estoque_vue__ = __webpack_require__(746);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4625fbe4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_movimento_estoque_vue__ = __webpack_require__(2125);
function injectStyle (ssrContext) {
  __webpack_require__(2123)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_movimento_estoque_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4625fbe4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_movimento_estoque_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2124);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("31b90186", content, true, {});

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}", ""]);

// exports


/***/ }),
/* 2125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full-width default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showFiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":_vm.handleCloseFiltro}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("Consulta Movimentação de Estoque ")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":function($event){return _vm.clickRetornar()}}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 align-items-end"},[_c('div',{staticClass:"col-md-5 col-12"},[_c('label-title',{attrs:{"label":"Período"}}),_vm._v(" "),_c('input-month2',{attrs:{"p-month":_vm.monthObj},on:{"change":_vm.periodoChange}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12"},[_c('input-search',{attrs:{"label":"Pesquisar item","entity":"item"},on:{"change":_vm.handleItemSelect},model:{value:(_vm.itemPesquisa),callback:function ($$v) {_vm.itemPesquisa=$$v},expression:"itemPesquisa"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12"},[_c('v-button',{staticClass:"mt-4 mr-2",attrs:{"icon":"fa-search","success":true},on:{"click":_vm.handleSearch}}),_vm._v(" "),_c('v-button',{staticClass:"mt-4",attrs:{"icon":"fa-filter","success":true,"title":"Mais filtros"},on:{"click":_vm.handleShowFiltro}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_vm._v("\n           MOVIMENTAÇÕES\n            "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}})],1),_vm._v(" "),_vm._l((_vm.dados.items),function(produto,i){return _c('div',{key:i,staticClass:"col-12"},[_c('div',{staticClass:"lbl-deal-title mb-2 mt-4",staticStyle:{"font-size":"14px","background":"#f8f9fa","padding":"10px","border-radius":"4px"}},[_c('strong',[_vm._v(_vm._s(produto.codigo)+" - "+_vm._s(produto.descricao)+" "),(produto.linha || produto.coluna)?_c('span',[_vm._v(" ("+_vm._s(produto.linha)+" / "+_vm._s(produto.coluna)+")")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"float-right"},[_vm._v("Entradas: "+_vm._s(_vm._f("formatValue")(produto.total_entradas,2))+" | Saídas: "+_vm._s(_vm._f("formatValue")(produto.total_saidas,2)))])]),_vm._v(" "),_c('div',{staticClass:"px-4"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100"},[_vm._m(0,true),_vm._v(" "),_c('tbody',_vm._l((produto.movimentos),function(row,j){return _c('tr',{key:j,staticStyle:{"height":"37px"}},[_c('td',{staticClass:"textual d-none d-md-table-cell"},[_vm._v(_vm._s(_vm._f("formatData")(row.data)))]),_vm._v(" "),_c('td',{staticClass:"textual d-none d-md-table-cell"},[_vm._v(" "+_vm._s(row.tipo))]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_vm._v(_vm._s(_vm._f("formatValue")(row.quantidade,2)))]),_vm._v(" "),_c('td',{staticClass:"textual d-none d-md-table-cell"},[_vm._v(_vm._s(row.unidade))]),_vm._v(" "),_c('td',{staticClass:"textual d-none d-md-table-cell"},[_vm._v(_vm._s(row.usuario))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.part))])])}),0)])])])])])})],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"height":"37px"}},[_c('th',{staticClass:"textual header col-1 d-none d-md-table-cell",attrs:{"title":""}},[_vm._v("Data")]),_vm._v(" "),_c('th',{staticClass:"textual header col-auto d-none d-md-table-cell",attrs:{"title":""}},[_vm._v("Tipo")]),_vm._v(" "),_c('th',{staticClass:"numerico header col-auto",attrs:{"title":""}},[_vm._v("Quantidade")]),_vm._v(" "),_c('th',{staticClass:"textual header col-auto d-none d-md-table-cell",attrs:{"title":""}},[_vm._v("Uni")]),_vm._v(" "),_c('th',{staticClass:"textual header col-auto d-none d-md-table-cell",attrs:{"title":""}},[_vm._v("Usuário")]),_vm._v(" "),_c('th',{staticClass:"textual header col-auto",attrs:{"title":""}},[_vm._v("Cliente/Fornecedor")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_resumo_movimento_estoque_vue__ = __webpack_require__(747);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfdaa3b8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_resumo_movimento_estoque_vue__ = __webpack_require__(2129);
function injectStyle (ssrContext) {
  __webpack_require__(2127)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_resumo_movimento_estoque_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfdaa3b8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_resumo_movimento_estoque_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2128);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6a1f6fca", content, true, {});

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}", ""]);

// exports


/***/ }),
/* 2129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showFiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":_vm.handleCloseFiltro}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("Consulta Resumo Movimentação de Estoque ")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":function($event){return _vm.clickRetornar()}}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 align-items-end"},[_c('div',{staticClass:"col-md-5"},[_c('v-label',{attrs:{"label":"Período"}}),_vm._v(" "),_c('input-month2',{attrs:{"p-month":_vm.periodo}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input-search',{attrs:{"label":"Pesquisar item","entity":"item"},on:{"change":_vm.handleItemSelect},model:{value:(_vm.itemPesquisa),callback:function ($$v) {_vm.itemPesquisa=$$v},expression:"itemPesquisa"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 mb-1"},[_c('v-button',{attrs:{"icon":"fa-search","success":true},on:{"click":function($event){return _vm.loadData(false, false)}}}),_vm._v(" "),_c('v-button',{staticClass:"ml-1",attrs:{"icon":"fa-filter"},on:{"click":_vm.handleShowFiltro}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_c('span',[_vm._v("RESUMO MOVIMENTAÇÕES")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Exel"},on:{"click":function($event){return _vm.loadData(true)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100",attrs:{"id":"relatorio"}},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.dados.items),function(row,index){return _c('tr',{key:index,staticStyle:{"height":"37px"}},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.codigo))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_c('span',[_vm._v(_vm._s(row.descricao))]),_vm._v(" "),(row.linha || row.coluna)?_c('span',[_c('strong',[_vm._v(" ("+_vm._s(row.linha)+" / "+_vm._s(row.coluna)+")")])]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.uni))]),_vm._v(" "),_c('td',{staticClass:"numerico",attrs:{"title":""}},[_vm._v(" "+_vm._s(_vm._f("formatValue")(row.saldo,2,true))+" "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('td',{staticClass:"numerico",attrs:{"title":""}},[_vm._v(" "+_vm._s(_vm._f("formatValue")(row.qtentradas,2,true))+" "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('td',{staticClass:"numerico",attrs:{"title":""}},[_vm._v(" "+_vm._s(_vm._f("formatValue")(row.qtsaidas,2,true))+" "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatData")(row.dtultentrada)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatData")(row.dtultsaida)))]),_vm._v(" "),_c('td',{staticClass:"numerico",attrs:{"title":""}},[_vm._v(" "+_vm._s(row.dias_sem_vender)+" "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})])])}),0)])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"height":"37px"}},[_c('th',{staticClass:"textual header",attrs:{"title":""}},[_vm._v("Código"),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"30%"},attrs:{"title":""}},[_vm._v("Descrição"),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('th',{staticClass:"textual header",attrs:{"title":""}},[_vm._v("Uni"),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('th',{staticClass:"numerico header",attrs:{"title":""}},[_vm._v(" Estoque Atual "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('th',{staticClass:"numerico header",attrs:{"title":""}},[_vm._v(" Entradas no Período "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('th',{staticClass:"numerico header",attrs:{"title":""}},[_vm._v(" Saidas no Período "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"8%"},attrs:{"title":""}},[_vm._v(" Dt ultima Entada "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('th',{staticClass:"textual header",staticStyle:{"width":"8%"},attrs:{"title":""}},[_vm._v(" Dt ultima saida "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})]),_vm._v(" "),_c('th',{staticClass:"numerico header",staticStyle:{"width":"8%"},attrs:{"title":""}},[_vm._v(" Dias sem vender "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_saldo_estoque_vue__ = __webpack_require__(748);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_05c33c61_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_saldo_estoque_vue__ = __webpack_require__(2133);
function injectStyle (ssrContext) {
  __webpack_require__(2131)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_saldo_estoque_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_05c33c61_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_saldo_estoque_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2132);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("10f805ed", content, true, {});

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-dash-title{padding:10px 16px;border-bottom:1px solid #f7f7f7;color:#adadad;font-size:14px;font-weight:600;text-transform:uppercase}.nb-dash-lbl{font-style:normal;font-stretch:normal;line-height:18px;color:#757575!important;font-size:13px;letter-spacing:normal;float:left}.nb-dash-lbl,.nb-dash-total{font-weight:400;max-width:100%}.nb-dash-total{display:inline-block;margin:25px 0;color:#656565;font-size:26px}.legend{padding:5px}table .textual{font-size:12px;text-align:left}table .numerico{font-size:12px;min-width:65px;text-align:center}table .size130{min-width:130px}table .total{background:#c1c4c7;border:none}table .var{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}.var-negative,table .var-negative{color:#fff;background:#cd5c5c!important}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.resumo__performance{display:flex;align-items:center;justify-content:space-between}.resumo__performance__value{padding:5px 15px;font-size:18px;font-weight:600;text-align:left;border-radius:10%}", ""]);

// exports


/***/ }),
/* 2133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-container p-3"},[_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":_vm.handleCloseFiltro}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-deal-title mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("SALDO EM ESTOQUE")]),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar para visões","icon":"fa-bar-chart"},on:{"click":_vm.clickRetornar}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-3 align-items-end"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('input-search',{attrs:{"label":"Pesquisar item","entity":"item"},on:{"change":_vm.handleItemSelect},model:{value:(_vm.itemPesquisa),callback:function ($$v) {_vm.itemPesquisa=$$v},expression:"itemPesquisa"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12"},[_c('label-title',{attrs:{"label":"Status do Estoque"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status_estoque),expression:"status_estoque"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status_estoque=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Todos")]),_vm._v(" "),_c('option',{attrs:{"value":"abaixo_estoque_minimo"}},[_vm._v("Abaixo do estoque mínimo")]),_vm._v(" "),_c('option',{attrs:{"value":"somente_sem_estoque"}},[_vm._v("Somente sem estoque")]),_vm._v(" "),_c('option',{attrs:{"value":"somente_com_estoque"}},[_vm._v("Somente com estoque")]),_vm._v(" "),_c('option',{attrs:{"value":"lotes_vencidos"}},[_vm._v("Somente com lotes vencidos")])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-12 pt-2"},[_c('input-checkbox',{attrs:{"label":"Exibir valores (Preço de venda, compra e custo)","value-checked":true,"value-unchecked":false},model:{value:(_vm.filtro.resumoEstoque),callback:function ($$v) {_vm.$set(_vm.filtro, "resumoEstoque", $$v)},expression:"filtro.resumoEstoque"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-12"},[_c('v-button',{staticClass:"mt-4 mr-2",attrs:{"icon":"fa-search","success":true},on:{"click":_vm.handleSearch}}),_vm._v(" "),_c('v-button',{staticClass:"mt-4",attrs:{"icon":"fa-filter","success":true},on:{"click":_vm.handleShowFiltro}})],1)]),_vm._v(" "),(_vm.dados.total)?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"nb-dash-card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row p-3"},[_c('div',{staticClass:"col-md-4 col-12 mb-2"},[_c('div',{staticClass:"border p-2"},[_c('span',{staticClass:"nb-dash-lbl w-100"},[_vm._v("Valor do estoque (preço de venda)")]),_vm._v(" "),_c('span',{staticClass:"nb-dash-total w-100 text-center"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.dados.total.total_vlrvenda,2, true)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12 mb-2"},[_c('div',{staticClass:"border p-2"},[_c('span',{staticClass:"nb-dash-lbl w-100"},[_vm._v("Valor do estoque (preço de custo)")]),_vm._v(" "),_c('span',{staticClass:"nb-dash-total w-100 text-center"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.dados.total.total_custo,2, true)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12 mb-2"},[_c('div',{staticClass:"border p-2"},[_c('span',{staticClass:"nb-dash-lbl w-100"},[_vm._v("Valor do estoque (preço de compra)")]),_vm._v(" "),_c('span',{staticClass:"nb-dash-total w-100 text-center"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.dados.total.total_vlrcompra,2, true)))])])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title mb-2"},[_vm._v("\n      SALDO\n      "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}}),_vm._v(" "),_vm._m(1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped table-hover responsive tablesorter w-100",attrs:{"id":"relatorio"}},[_c('thead',[_c('tr',{staticStyle:{"height":"37px"}},_vm._l((_vm.tableColumns),function(col,index){return _c('th',{key:index,class:col.tp + ' header ',attrs:{"title":""}},[_vm._v(" "+_vm._s(col.label)+" "),_c('i',{staticClass:"icon-sort"}),_c('i',{staticClass:"icon-sort-down"}),_c('i',{staticClass:"icon-sort-up"})])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dados.items),function(row,index){return _c('tr',{key:index,class:row.qtuni < row.qtmin ? 'var-negative' : '',staticStyle:{"height":"37px"}},[_c('td',{staticClass:"textual"},[_c('span',[_vm._v(_vm._s(row.codigo))])]),_vm._v(" "),_c('td',{staticClass:"textual"},[_c('span',[_vm._v(_vm._s(row.descricao))]),_vm._v(" "),(row.linha || row.coluna)?_c('span',[_c('strong',[_vm._v(" ("+_vm._s(row.linha)+" / "+_vm._s(row.coluna)+")")])]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"textual"},[_c('span',[_vm._v(_vm._s(row.uni))])]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_c('span',[_vm._v(_vm._s(row.qt))])]),_vm._v(" "),_c('td',{staticClass:"numerico"},[_c('span',[_vm._v(_vm._s(row.qtmin))])]),_vm._v(" "),(_vm.filtro.resumoEstoque)?_c('td',{staticClass:"numerico"},[_c('span',[_vm._v(_vm._s(_vm._f("formatValue")(row.vlrvenda,2, true)))])]):_vm._e(),_vm._v(" "),(_vm.filtro.resumoEstoque)?_c('td',{staticClass:"numerico"},[_c('span',[_vm._v(_vm._s(_vm._f("formatValue")(row.vlrcompra,2, true)))])]):_vm._e(),_vm._v(" "),(_vm.filtro.resumoEstoque)?_c('td',{staticClass:"numerico"},[_c('span',[_vm._v(_vm._s(_vm._f("formatValue")(row.custo,2, true)))])]):_vm._e()])}),0)])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-dash-title"},[_c('span',{staticClass:"w-100"},[_vm._v("Resumo do Estoque")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"float-right mr-5 d-flex align-items-center mt-3"},[_c('span',{staticClass:"var-negative legend border mr-2"}),_vm._v(" "),_c('small',{staticStyle:{"font-size":"10px"}},[_vm._v("Abaixo do mínimo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_item_entradas_saidas_vue__ = __webpack_require__(749);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6405f3d5_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_item_entradas_saidas_vue__ = __webpack_require__(2137);
function injectStyle (ssrContext) {
  __webpack_require__(2135)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_item_entradas_saidas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6405f3d5_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_item_entradas_saidas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2136);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("370d031d", content, true, {});

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"xls-button":true,"single-entity":"","plural-entity":"Pesquisa de Produtos","title-search":"Pesquise pelo código ou pela descrição do produto"},on:{"search":_vm.search,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container"},[(_vm.produtos.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.produtos),function(produto,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[(index==0)?_c('div',{staticClass:"row align-items-center",staticStyle:{"font-weight":"500"}},[_c('div',{staticClass:"col-md-1 col-1 d-none d-md-block"}),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_vm._m(1,true),_vm._v(" "),_vm._m(2,true),_vm._v(" "),_vm._m(3,true),_vm._v(" "),_vm._m(4,true)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-center",staticStyle:{"font-size":"12px"}},[_c('div',{staticClass:"col-md-1 col-1 text-center d-none d-md-block"},[(produto.url)?_c('img',{staticClass:"mx-auto d-block img-thumbnail",staticStyle:{"max-width":"45px","max-height":"45px","cursor":"pointer"},attrs:{"src":produto.url,"alt":"Logotipo"}}):_vm._e(),_vm._v(" "),(!produto.url)?_c('i',{staticClass:"fa fa-camera mx-auto d-block",staticStyle:{"font-size":"25px","color":"silver"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(produto.descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-3"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(produto.codigo))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2 text-center d-none d-md-block"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("formatValue")(produto.qtent,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2 text-center d-none d-md-block"},[_c('span',{staticClass:"data-list-sm"},[_vm._v(_vm._s(_vm._f("formatValue")(produto.qtsai,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3 text-center"},[(((produto.qtent - produto.qtsai) > 0))?_c('span',{staticClass:"data-list-sm lbl-green"},[_vm._v(_vm._s(_vm._f("formatValue")((produto.qtent - produto.qtsai),2)))]):_c('span',{staticClass:"data-list-sm lbl-red"},[_vm._v(_vm._s(_vm._f("formatValue")((produto.qtent - produto.qtsai),2)))])])])])])}),_vm._v(" "),_c('div',[(_vm.nextPage>0)?_c('a',{staticStyle:{"cursor":"pointer","color":"#0091ea"},on:{"click":function($event){return _vm.handleMore()}}},[_vm._v("Exibir mais")]):_vm._e()])],2)],1),_vm._v(" "),(_vm.showAnexosForm)?_c('anexos-form',{attrs:{"params":{ ref: 'item', chaveref: _vm.coditem, title: _vm.descricao, showform: true }},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-4 col-6"},[_c('span',{staticClass:"lbl-list"},[_vm._v("Descrição")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-1 col-3",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Código")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 col-2 text-center d-none d-md-block",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Entradas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 col-2 text-center d-none d-md-block",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Saídas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 col-3 text-center",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list"},[_vm._v("Saldo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_list_vue__ = __webpack_require__(750);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_35fe29be_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_list_vue__ = __webpack_require__(2147);
function injectStyle (ssrContext) {
  __webpack_require__(2139)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35fe29be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_35fe29be_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2140);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4f631d98", content, true, {});

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".mainbox[data-v-35fe29be]{overflow:visible}.default-container[data-v-35fe29be]{overflow-y:hidden}.box[data-v-35fe29be]{float:none}", ""]);

// exports


/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2142);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("20632717", content, true, {});

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#cupom[data-v-333ac4c8]{visibility:hidden}p[data-v-333ac4c8],span[data-v-333ac4c8],table[data-v-333ac4c8]{font-size:13px!important}h5[data-v-333ac4c8],h6[data-v-333ac4c8]{font-size:15px}", ""]);

// exports


/***/ }),
/* 2143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.cupom && _vm.tipo == 'cupomnaofiscal')?_c('div',{staticStyle:{"width":"420px"},attrs:{"id":"cupom"}},[(_vm.cupom.empresa)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"img d-flex justify-content-center align-items-center",staticStyle:{"width":"140px","height":"70px"}},[_c('img',{staticClass:"img-fluid",staticStyle:{"max-width":"100px"},attrs:{"src":_vm.urlLogotipo,"alt":"Cupom_Nao_Fiscal"}})]),_vm._v(" "),(_vm.cupom && _vm.cupom.empresa)?_c('div',{staticClass:"d-flex flex-column justify-content-start",staticStyle:{"margin":"16px 0 !important"}},[_c('span',[_vm._v(_vm._s(_vm.cupom.empresa.nome))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(_vm.cupom.empresa.cnpj)))]),_vm._v(" "),_c('span',{staticClass:"mt-2"},[_vm._v("Tel: "+_vm._s(_vm._f("formatFone")(_vm.cupom.empresa.fone)))]),_vm._v(" "),_c('span',[(_vm.cupom && _vm.cupom.empresa && _vm.cupom.empresa.cep)?_c('span',[_vm._v("Cep:\n            "+_vm._s(_vm.cupom.empresa.cep)+" -")]):_vm._e(),_vm._v(" "),(_vm.cupom.empresa.uf)?_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.cupom.empresa.uf))]):_vm._e()]),_vm._v(" "),(_vm.cupom.empresa.endereco)?_c('span',{},[_vm._v(_vm._s(_vm.cupom.empresa.endereco)+"\n          "+_vm._s(_vm.cupom.empresa.numero)+" "+_vm._s(_vm.cupom.empresa.complemento))]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"d-flex flex-column"},[_c('span',[_c('strong',[_vm._v("Caixa:")]),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.cupom.caixa))])]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("Cliente:")]),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.cupom.nomeCliente))])]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("CNPJ/CPF:")]),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.cupom.docCliente))])]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("Pedido:")]),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.cupom.pedido))])]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("Data:")]),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.cupom.data)))])]),_vm._v(" "),(_vm.cupom &&
        _vm.cupom.empresa &&
        _vm.cupom.empresa.cnpj &&
        _vm.cupom.empresa.cnpj.length <= 11)?_c('span',[_c('strong',[_vm._v("Cliente: ")]),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v("Consumidor Final")])]):_vm._e()]),_vm._v(" "),_c('div',[_c('div',{staticClass:"d-flex flex-row mt-1"},[(_vm.cupom && _vm.cupom.itens)?_c('table',{staticStyle:{"width":"420px","border-top":"none!important"},attrs:{"border":"0"}},[_vm._m(0),_vm._v(" "),_vm._l((_vm.cupom.itens),function(item){return _c('tr',{key:item,staticStyle:{"word-break":"break-all","border-bottom":"1px solid","border-top":"1px solid"}},[_c('td',{staticStyle:{"text-align":"center","vertical-align":"middle","border-right":"1px solid"}},[_vm._v(_vm._s(item.codigo))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center","vertical-align":"middle","border-right":"1px solid","line-height":".85rem"}},[_vm._v("\n                "+_vm._s(item.descricao)+" "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(item.obs))])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center","vertical-align":"middle","border-right":"1px solid"}},[_vm._v(_vm._s(_vm._f("formatValue")(item.qt,2)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center","vertical-align":"middle","border-right":"1px solid"}},[_vm._v(_vm._s(_vm._f("formatValue")(item.valor,2)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center","vertical-align":"middle"}},[_vm._v(_vm._s(_vm._f("formatValue")(item.total,2)))])])})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column mt-3 pr-1",staticStyle:{"width":"424px"}},[(_vm.cupom && _vm.cupom.formas)?_c('div',{staticClass:"d-flex flex-row",staticStyle:{"width":"420px"}},[_c('span',{staticClass:"d-flex flex-column mr-5"},[_c('strong',[_vm._v("Data")]),_vm._v(" "),_vm._l((_vm.cupom.formas),function(forma){return _c('span',{key:forma},[_vm._v("\n                "+_vm._s(_vm._f("formatData")(forma.data))+"\n              ")])})],2),_vm._v(" "),_c('span',{staticClass:"d-flex flex-column ml-5 mr-5"},[_c('strong',[_vm._v("Forma Pag")]),_vm._v(" "),_vm._l((_vm.cupom.formas),function(forma){return _c('span',{key:forma},[_vm._v("\n                "+_vm._s(forma.forma)+"\n              ")])})],2),_vm._v(" "),_c('span',{staticClass:"d-flex flex-column align-self-end ml-auto",staticStyle:{}},[_c('strong',{staticClass:"text-right"},[_vm._v("Valor")]),_vm._v(" "),_vm._l((_vm.cupom.formas),function(forma){return _c('span',{key:forma,staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm._f("formatValue")(forma.valor,2))+"\n              ")])})],2)]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"align-self-end mr-0 mt-2"},[_c('strong',[_vm._v("Sub Total: ")]),_vm._v("\n            "+_vm._s(_vm._f("formatValue")(_vm.itemsSum,2))+"\n          ")]),_vm._v(" "),(_vm.cupom && _vm.cupom.frete)?_c('span',{staticClass:"align-self-end mr-0"},[_c('strong',[_vm._v("Frete: ")]),_vm._v("\n            "+_vm._s(_vm._f("formatValue")(_vm.cupom.frete,2))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.cupom && _vm.cupom.totalDescontos)?_c('span',{staticClass:"align-self-end mr-0"},[_c('strong',[_vm._v("Desconto: ")]),_vm._v("\n            "+_vm._s(_vm._f("formatValue")(_vm.cupom.totalDescontos,2))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.cupom && _vm.cupom.totalAcrescimos)?_c('span',{staticClass:"align-self-end mr-0"},[_c('strong',[_vm._v("Acréscimo: ")]),_vm._v("\n            "+_vm._s(_vm._f("formatValue")(_vm.cupom.totalAcrescimos,2))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.cupom && _vm.cupom.total)?_c('span',{staticClass:"align-self-end mr-0"},[_c('strong',[_vm._v("Total: "+_vm._s(_vm._f("formatValue")(_vm.cupom.total,2)))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column",staticStyle:{"width":"420px"}},[(_vm.cupom && _vm.cupom.mensagemCupom)?_c('span',{staticClass:"align-self-center mt-2"},[_vm._v("\n          "+_vm._s(_vm.cupom.mensagemCupom)+"\n          "),_c('span')]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"align-self-center mt-0"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.curentDate)))])])])]):_vm._e(),_vm._v(" "),(_vm.cupom && _vm.tipo == 'movimentocaixa')?_c('div',{attrs:{"id":"cupom"}},[_c('div',{staticStyle:{"width":"420px"}},[_c('div',[_c('div',{staticClass:"d-flex flex-row justify-content-center"},[_c('strong',[_c('h5',[_vm._v(" "+_vm._s(_vm.cupom.tipo)+" de Caixa ")])])]),_vm._v(" "),(_vm.cupom.empresa)?_c('div',{staticClass:"d-flex flex-column mt-3"},[_c('span',[_c('strong',{staticClass:"mr-1"},[_vm._v("Loja:")]),_vm._v(_vm._s(_vm.cupom.empresa.nome))]),_vm._v(" "),_c('span',[_c('strong',{staticClass:"mr-1"},[_vm._v("Operador:")]),_vm._v(_vm._s(_vm.cupom.operador))]),_vm._v(" "),_c('span',[_c('strong',{staticClass:"mr-1"},[_vm._v("Data abertura:")]),_vm._v(_vm._s(_vm._f("formatDataHora")(_vm.cupom.dataAbertura)))]),_vm._v(" "),_c('span',[_c('strong',{staticClass:"mr-1"},[_vm._v("Data operação:")]),_vm._v(_vm._s(_vm._f("formatDataHora")(_vm.cupom.dataMovimento)))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column justify-content-center;"},[_c('strong',{staticClass:"align-self-center mb-2 mt-3"},[_c('h5',[_vm._v(" "+_vm._s(_vm.cupom.caixa)+" ")])]),_vm._v(" "),_c('table',{staticStyle:{"border":"1px solid #ededed"},attrs:{"border":"1"}},[_vm._m(1),_vm._v(" "),_vm._l((_vm.cupom.items),function(item){return _c('tr',{staticStyle:{"border-color":"#ededed"}},[_c('td',{staticStyle:{"width":"70px"}},[_vm._v(_vm._s(_vm._f("formatValue")(item.valor,2)))]),_vm._v(" "),_c('td',{staticStyle:{"word-break":"break-all"}},[_vm._v(_vm._s(item.obs))])])})],2)]),_vm._v(" "),_c('hr',{staticClass:"mt-5",staticStyle:{"background":"black","border-color":"black"}}),_vm._v(" "),_c('h6',{staticClass:"align-self-center text-center"},[_vm._v("Assinatura")])])])]):_vm._e(),_vm._v(" "),(_vm.cupom && _vm.tipo == 'fechamentocaixa')?_c('div',{attrs:{"id":"cupom"}},[_c('div',{staticStyle:{"width":"420px"}},[_c('div',[_vm._m(2),_vm._v(" "),(_vm.cupom.empresa)?_c('div',{staticClass:"d-flex flex-column mt-3"},[_c('span',[_c('strong',{staticClass:"mr-1"},[_vm._v("Loja:")]),_vm._v(_vm._s(_vm.cupom.empresa.nome))]),_vm._v(" "),_c('span',[_c('strong',{staticClass:"mr-1"},[_vm._v("Caixa:")]),_vm._v(_vm._s(_vm.cupom.caixa))]),_vm._v(" "),_c('span',[_c('strong',{staticClass:"mr-1"},[_vm._v("Operador:")]),_vm._v(_vm._s(_vm.cupom.operador))]),_vm._v(" "),_c('span',[_c('strong',{staticClass:"mr-1"},[_vm._v("Data abertura:")]),_vm._v(_vm._s(_vm._f("formatDataHora")(_vm.cupom.data_abertura)))]),_vm._v(" "),_c('span',[_c('strong',{staticClass:"mr-1"},[_vm._v("Valor abertura:")]),_vm._v(_vm._s(_vm._f("formatValue")(_vm.cupom.valor,2)))]),_vm._v(" "),_c('span',[_c('strong',{staticClass:"mr-1"},[_vm._v("Data fechamento:")]),_vm._v(_vm._s(_vm._f("formatDataHora")(_vm.cupom.data_fechamento)))]),_vm._v(" "),_c('span',[_c('strong',{staticClass:"mr-1"},[_vm._v("Valor fechamento:")]),_vm._v(_vm._s(_vm._f("formatValue")(_vm.cupom.valor_fechamento,2)))])]):_vm._e(),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('hr',{staticClass:"mt-5",staticStyle:{"background":"black","border-color":"black"}}),_vm._v(" "),_c('h6',{staticClass:"align-self-center text-center"},[_vm._v("Assinatura")])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"border-top:0;",attrs:{"border":"0","cellpadding":"5px"}},[_c('td',{staticStyle:{"text-align":"center","vertical-align":"middle","border-right":"1px solid"}},[_c('strong',[_vm._v("Código")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center","vertical-align":"middle","border-right":"1px solid"}},[_c('strong',[_vm._v("Descrição")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center","vertical-align":"middle","border-right":"1px solid"}},[_c('strong',[_vm._v("Qtde")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center","vertical-align":"middle","border-right":"1px solid"}},[_c('strong',[_vm._v("Valor")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center","vertical-align":"middle"}},[_c('strong',[_vm._v("Total")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"border-right":"1px solid #ededed"}},[_c('strong',[_vm._v("Valor")])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v("Observação")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row justify-content-center"},[_c('strong',[_c('h5',[_vm._v(" Fechamento de Caixa ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-content-center;"},[_c('strong',{staticClass:"align-self-center mb-2 mt-3"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2145);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("73bc33ea", content, true, {});

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".d-f-hover-link:hover{color:#5788fd!important;cursor:pointer}", ""]);

// exports


/***/ }),
/* 2146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"default-container d-flex flex-column"},[_c('div',{staticClass:"row align-items-center mb-3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isView),expression:"!isView"}],staticClass:"float-right",attrs:{"label":"Salvar","title":"","icon":"fa-save","nb-btdef":true},on:{"click":_vm.handleSave}}),_vm._v(" "),(_vm.isView && _vm.vdevol.nfDevolucao && !_vm.vdevol.nfDevolucao.autorizada)?_c('v-button',{staticClass:"float-right",attrs:{"label":"Excluir","title":"","icon":"fa-trash"},on:{"click":_vm.apiDelete}}):_vm._e(),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"label":"Retornar","icon":"fa-arrow-left"},on:{"click":_vm.closeForm}})],1)]),_vm._v(" "),(_vm.errmessages.length)?_c('validation',{attrs:{"messages":_vm.errmessages}}):_vm._e(),_vm._v(" "),(_vm.isView)?_c('label-title',{attrs:{"title":"Dados da Devolução"}}):_vm._e(),_vm._v(" "),(_vm.isView)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.vdevol.codvdevol}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.vdevol.codvdevol))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.vdevol.data}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatDataHora")(_vm.vdevol.data)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"label":"Operador"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.vdevol.operador))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-6"},[_c('v-label',{attrs:{"label":"Nota de Devolução"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.vdevol.nfDevolucao.nf))]),_vm._v(" "),(_vm.vdevol.nfDevolucao.enviar)?_c('span',{staticClass:"badge badge-danger"},[_vm._v("NF Devolução Não Enviada")]):_vm._e(),_vm._v(" "),(_vm.vdevol.nfDevolucao.autorizada)?_c('span',{staticClass:"badge badge-success"},[_vm._v("Nota Autorizada")]):_vm._e()],1),_vm._v(" "),(_vm.vdevol.nfDevolucao.enviar)?_c('div',{staticClass:"col-md-3 col-6 ml-auto mt-2"},[_c('v-button',{attrs:{"label":"Autorizar NF","nb-btdef":true,"title":"","icon":"fa-rss-square"},on:{"click":function($event){return _vm.handleAutorizaNF(_vm.vdevol.nfDevolucao.codnf)}}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isView)?_c('div',{staticClass:"row"},[_vm._m(1)]):_vm._e(),_vm._v(" "),_c('label-title',{attrs:{"title":"Dados da Venda"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.vdevol.codpedv}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.vdevol.npedido))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"label":"Data da Venda"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm._f("formatDataHora")(_vm.vdevol.data)))])],1),_vm._v(" "),(_vm.vdevol.nfVenda)?_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"label":"Nota de Venda"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.vdevol.nfVenda.nf))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"label":"Operador"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.vdevol.operador))])],1)]),_vm._v(" "),(_vm.vdevol.part)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6 pl-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.vdevol.codpart}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.vdevol.part.nome))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6 pl-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.part.cnpjcpf}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(this.$formatCPF(_vm.vdevol.part.cnpjcpf)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[(_vm.vdevol.part.pessoaFisica)?_c('v-label',{attrs:{"metadata-field":_vm.metadata.part.tppessoa}}):_vm._e(),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.vdevol.part.pessoaFisica ? 'PESSOA FÍSICA':''))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.mun.nomemun}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.vdevol.part.codmun))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":{label:'UF'}}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.vdevol.part.uf))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.part.cep}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.vdevol.part.cep))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.part.ende}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.vdevol.part.endereco))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.part.endenr}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.vdevol.part.nr))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.part.endecomp}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.vdevol.part.complemento))])],1)]):_vm._e(),_vm._v(" "),(_vm.avisoSerie55)?_c('label-title',{attrs:{"title":"Série de nota fiscal 55"}}):_vm._e(),_vm._v(" "),(_vm.avisoSerie55)?_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-6"},[_c('warnings',{attrs:{"messages":['Cadastre uma série de NF modelo 55 para efetivar a devolução de venda!']}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('v-button',{ref:"buttonSerie",attrs:{"label":"Cadastrar Serie","title":"","nb-btdef":true},on:{"click":_vm.handleShowSerie}})],1)]):_vm._e(),_vm._v(" "),(_vm.isView)?_c('label-title',{attrs:{"title":"cliente"}}):_c('label-title',{attrs:{"title":"Informe o cliente"}}),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[(!_vm.isView)?_c('div',{staticClass:"col-6"},[_c('warnings',{attrs:{"messages":['Selecione um cliente cadastrado ou cadastre um novo cliente!']}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.vdevol.part)?_c('div',{staticClass:"col-6"},[_c('input-part',{ref:"part",attrs:{"name":"Cliente","add-button":true,"disabled":_vm.isView,"varejo":true},model:{value:(_vm.vdevol.part.codpart),callback:function ($$v) {_vm.$set(_vm.vdevol.part, "codpart", $$v)},expression:"vdevol.part.codpart"}})],1):_vm._e()]),_vm._v(" "),(!_vm.isView)?_c('label-title',{attrs:{"title":"Produtos a Devolver"}}):_c('label-title',{attrs:{"title":"Produtos Devolvidos"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isView),expression:"!isView"}],staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('warnings',{attrs:{"messages":['Informe o tipo da devolução e em seguida selecione os produtos devolvidos!']}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{staticStyle:{"font-size":"15px!important"},attrs:{"disabled":_vm.isView,"type":"select","metadata":{label:'Tipo da Devolução', options:[{id:1, text:'Devolução Parcial'}, {id:2, text:'Devolução Total'}]},"col":"4"},model:{value:(_vm.devTipo),callback:function ($$v) {_vm.devTipo=$$v},expression:"devTipo"}})],1),_vm._v(" "),_vm._l((_vm.vdevol.itens),function(item,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-auto justify-content-center"},[_c('div',{staticClass:"ml-3 mt-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.check),expression:"item.check"}],staticStyle:{"transform":"scale(1.5)","cursor":"pointer"},attrs:{"type":"checkbox","disabled":_vm.devTipo== ''},domProps:{"checked":Array.isArray(item.check)?_vm._i(item.check,null)>-1:(item.check)},on:{"change":[function($event){var $$a=item.check,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "check", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "check", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "check", $$c)}},function($event){return _vm.handleChangeCheck(item, index)}]}})])]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("Descrição")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(item.descricao)+" "+_vm._s(item.linha)+" "+_vm._s(item.coluna)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-center"},[_c('span',{staticClass:"lbl-edit"},[_vm._v(_vm._s(_vm.isView? 'Qtd Devolvida' : 'Qtd'))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(item.qt,2, true))+" "+_vm._s(item.uni)+" x R$ "+_vm._s(_vm._f("formatValue")(item.valor,2, true)))])]),_vm._v(" "),(!_vm.isView)?_c('div',{staticClass:"col-2 text-center pb-0 mb-0"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column align-items-start"},[_c('span',{staticClass:"d-flex"},[_c('form-field',{staticClass:"d-f-validation",attrs:{"required":true,"precision":2,"type":"value","disabled":!item.check},on:{"input":_vm.handleEditQtDev},model:{value:(item.qtdev),callback:function ($$v) {_vm.$set(item, "qtdev", _vm._n($$v))},expression:"item.qtdev"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.errors),expression:"item.errors"}],staticClass:"mt-0 p-0 justify-content-start text-left",staticStyle:{"word-break":"break-all","font-size":"12px","color":"#f50000"}},[_vm._v(_vm._s(item.errors))])])],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-2 text-center"},[_vm._m(3,true),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v("\n                            "+_vm._s(_vm._f("formatValue")(_vm.isView ? item.total : item.totdev,2, true))+"\n                        ")])])])])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 text-center ml-auto"},[_c('span',{staticClass:"data-list"},[_vm._v("Total da Devolução\n                    "),(!_vm.isView)?_c('strong',{staticClass:"col-2"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.totalDev,2, true)))]):_c('strong',{staticClass:"col-2"},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.vdevol.total,2, true)))])])])]),_vm._v(" "),_c('label-title',{staticClass:"mt-3",attrs:{"title":"Forma De Pagamento"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"placeholder":"Selecione","type":"select","metadata":{label:'Forma de Pagamento', options:[{id:'D', text:'Dinheiro'},{id:'C', text:'Crédito Loja'}]},"col":"2","disabled":_vm.isView},model:{value:(_vm.vdevol.lancamentodevol),callback:function ($$v) {_vm.$set(_vm.vdevol, "lancamentodevol", $$v)},expression:"vdevol.lancamentodevol"}})],1)],2),_vm._v(" "),(_vm.showModalSerie)?_c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1 !important"}},[_c('Trap',[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-md",staticStyle:{"max-width":"90%","width":"60% !important","overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body pt-3",staticStyle:{"height":"90vh!important","max-height":"100%","overflow-y":"auto"}},[_c('serienf-form',{attrs:{"crud":_vm.crudSerie},on:{"closeform":_vm.closeSerie}})],1)])])])],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-12"},[_c('h4',{staticClass:"def-title"},[_vm._v("Incluir Devolução")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 col-12"},[_c('hr')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"lbl-edit"},[_vm._v("Qtd Devolver")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"lbl-edit"},[_vm._v("Valor Total")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.showForm && !_vm.showDevolucao)?_c('div',{staticClass:"relative",attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":false,"new-button":true,"pdf-button":false,"xls-button":false,"filter-month":true,"hide-search":false,"single-entity":"PDV","plural-entity":"Vendas Frente de Caixa","moreActions":_vm.actions,"videoButton":"true","urlVideo":"//www.youtube.com/embed/mRtDNkM32PU"},on:{"action":_vm.handleButtonMoreActions,"new":_vm.handleNew,"filter":_vm.handleChangeMonth,"search":_vm.handleSearch,"refresh":_vm.handleRefresh}}),_vm._v(" "),(!_vm.codvabertura)?_c('div',{staticClass:"row mb-2"},[(!_vm.codvabertura)?_c('div',{staticClass:"col-md-3 col-8"},[_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nfSearch),expression:"nfSearch"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":'Pesquisar Nota Fiscal ou Chave'},domProps:{"value":(_vm.nfSearch)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleNfSearch.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.nfSearch=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary",on:{"click":_vm.handleNfSearch}},[_c('i',{staticClass:"fa fa-search",attrs:{"aria-hidden":"true"}})])])])]):_vm._e(),_vm._v(" "),(!_vm.codvabertura)?_c('div',{staticClass:"col-md-6 col-8"},[_c('pedido-filtro',{attrs:{"filter-espera":true,"query":_vm.query},on:{"change":_vm.changeFiltros}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.tipo_devolucao)?_c('alert',{attrs:{"type":"info","title":"Devolução de Venda","text":"Para laçar uma devolução de venda, localize a venda de origem e clique em 'devolução'"}}):_vm._e(),_vm._v(" "),(!_vm.tipo_devolucao && _vm.caixasList && _vm.caixasList.length)?_c('div',{staticClass:"row mb-2"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(!_vm.tipo_devolucao)?_c('div',{staticClass:"row mb-2"},_vm._l((_vm.caixasList),function(caixa,index){return _c('div',{key:index,staticClass:"col-md-3"},[_c('div',{staticClass:"nb-dash-card p-2"},[_c('span',{staticClass:"lbl-deal-title"},[_vm._v(" "+_vm._s(caixa.caixa)+" ")]),_vm._v(" "),_c('span',{staticClass:"data-list w-100"},[_vm._v(" "+_vm._s(caixa.operadorabertura)+" ")]),_vm._v(" "),_c('span',{staticClass:"nb-dash-total w-100 text-center"},[_c('span',{staticClass:"data-list text-center w-100"},[_vm._v(" Total em Vendas ")]),_vm._v(" R$ "+_vm._s(_vm._f("formatValue")(caixa.resumoVendas.total,2,true))+" ")]),_vm._v(" "),(caixa.aberto)?_c('span',{staticClass:"badge badge-green ml-2"},[_vm._v(_vm._s(caixa.status)+" ")]):_vm._e(),_vm._v(" "),(!caixa.aberto)?_c('span',{staticClass:"badge badge-gray ml-2"},[_vm._v(_vm._s(caixa.status)+" ")]):_vm._e()])])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"default-container position-relative"},[(_vm.varejoList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.varejoList),function(item,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box d-flex flex-wrap"},[_c('div',{staticClass:"col-md-1 col-2"},[(index==0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Pedido"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.npedido)+" ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[(index==0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Data"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatDataHora")(item.data)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[(index==0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Operador"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.nome_usuario)+" ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[(index==0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Cliente"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.fantasia)+" ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2 text-right"},[(index==0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Total do Pedido"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(item.totger,2)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-3"},[(index==0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"NF"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(item.nf)+" ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 ml-auto"},[_c('span',{staticClass:"badge",class:_vm.statusColor(item.stpedv, item.tppedv)},[_vm._v(_vm._s(_vm.textST(item)))]),_vm._v(" "),(item.espera == 'S')?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em espera")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2 align-items-right ml-auto"},[_c('bar-grid',{attrs:{"obj":item,"options":_vm.handleBarGrid(item.stpedv),"moreActions":_vm.getActions(item)},on:{"action":_vm.handleAction,"view":function($event){return _vm.handleCompletEdit(item.codpedv)},"edit":function($event){return _vm.handleCompletEdit(item.codpedv)},"devolucao":function($event){return _vm.handleDevolucao(item.codpedv)}}})],1),_vm._v(" "),(item.cpjcpf && item.cpjcpf=='CONSUMIDOR')?_c('div',{staticClass:"col-md-auto col-auto"},[_c('v-label',{staticClass:"w-100",attrs:{"label":"Cnpj/Cpf"}}),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(item.cnpjcpf)+" ")])],1):_vm._e(),_vm._v(" "),(item.obspedido)?_c('div',{staticClass:"col-md-auto col-auto"},[_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(item.obspedido)+" ")])]):_vm._e()])])})],2)],1):_vm._e(),_vm._v(" "),(_vm.showEmissaoCupom)?_c('VarejoEmissaoCupom',{attrs:{"index":_vm.cupomCodpedv,"tipo":"cupomnaofiscal"},on:{"resultadoemissaocupom":function($event){_vm.showEmissaoCupom = false}}}):_vm._e(),_vm._v(" "),(_vm.showDevolucao)?_c('DevolucaoForm',{attrs:{"index":this.codpedv,"crud":_vm.crud},on:{"closeform":_vm.closeFormDevolucao}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"lbl-deal-title"},[_vm._v(" Resumo dos Caixas ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_form_vue__ = __webpack_require__(754);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6227508a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_form_vue__ = __webpack_require__(2223);
function injectStyle (ssrContext) {
  __webpack_require__(2149)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6227508a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2150);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5e1cf4ab", content, true, {});

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".to-front{z-index:10001}.blank-button{display:flex;justify-content:center;align-items:center;background-color:#fff;transition:background-color .2s ease 0s;border:none;padding-top:1rem;padding-bottom:1rem;width:11rem}.blank-button:hover{background-color:#eee}.clock{width:4rem;text-align:end!important}.item-img{border:1px solid #c9d3dd;opacity:1%;border-radius:5px}.img-size{width:30vw;min-height:285px}.img-size-big{width:100%;min-height:290px}.items-box{height:60vh;border-radius:5px;border:1px solid #c9d3dd;overflow-y:scroll}@media (min-width:1367px){.blank-button{display:flex;justify-content:center;align-items:center;background-color:#fff;border:none;padding-top:1rem;padding-bottom:1rem;width:17.5rem}.navbar-collapse{margin-right:10px}.img-size{width:30vw;min-height:350px}.img-size-big{width:47vw;min-height:360px}.items-box{height:75vh}}.text-button{font-weight:700;text-transform:uppercase;font-size:12.5px;letter-spacing:-.025rem;color:#004a89}input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none}.badge-mesa-st{width:15px!important;height:15px!important;font-size:15px;display:flex;color:#fff}.lista__mesas{background:none;border:0;padding:0}.lista__mesas:focus-within{border:1px solid #000}.fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}.footer-varejo{position:fixed;bottom:0;padding:0!important}.item-group{line-height:1rem}.register{position:fixed;top:0;left:0;right:0;bottom:0;padding-top:55px;width:150px;height:calc(100% - 55px);background-color:rgba(15,43,73,.25);display:inherit}.register-info{display:block;word-break:break-word;border-bottom:1px solid #becbcf;padding:10px;background:#fff}.varejo-button{font-synthesis:none;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;position:relative;font-family:lato,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;cursor:pointer;font-size:15px;border-radius:3px;padding:12px 20px;text-align:center;box-sizing:border-box;display:inline-block;min-width:100px;margin:0 4px;border:1px solid transparent;font-weight:700;transition:all .2s;transition-property:background,color,border;outline:none}.varejo-button.varejo-button--primary{background-color:#41af4b;color:#fff}.varejo-button.varejo-button--big{font-synthesis:none;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.22222;font-size:18px;padding:16px 32px}.varejo-button:last-child{margin-right:0}.varejo-button:first-child{margin-left:0}.varejo-button.varejo-button--primary.disabled,.varejo-button.varejo-button--primary:disabled,.varejo-button.varejo-button--primary:disabled:hover,.varejo-button.varejobutton--primary[disabled]{cursor:default;pointer-events:none;opacity:.35;-webkit-filter:grayscale(100%);filter:grayscale(100%)}.vd-quick-key-label{box-sizing:border-box;max-width:100%;font-size:12px;line-height:1.3;overflow:hidden;padding:4px;white-space:nowrap;word-wrap:break-word;word-break:break-word;text-overflow:ellipsis}.btn--pay{width:100%}.pay-action-value{margin-left:auto;text-align:right;flex-grow:1}.pay-action-label,.pay-action-value{font-size:20px;font-weight:700}.footer-shortcuts{flex-wrap:wrap}.footer-shortcuts b{font-size:1.1rem}.footer-shortcuts .lbl{margin-right:1rem}.text-wine-color{color:#ad2222}.navbar-collapse{scrollbar-width:thin;scrollbar-color:#c9d3dd transparent}.navbar-collapse::-webkit-scrollbar{width:8px}.navbar-collapse::-webkit-scrollbar-track{background:transparent}.vend-inputs{text-decoration:none;outline:none!important;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.logo-image{z-index:-10}.capitalize-text{text-transform:capitalize!important}@media (min-width:1200px){.container-media{max-height:75vh!important}}", ""]);

// exports


/***/ }),
/* 2151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_bar_top_vue__ = __webpack_require__(755);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7110e19f_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_bar_top_vue__ = __webpack_require__(2154);
function injectStyle (ssrContext) {
  __webpack_require__(2152)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7110e19f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_bar_top_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7110e19f_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_bar_top_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2153);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("23094f8c", content, true, {});

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".zindextop[data-v-7110e19f]{z-index:99999}.exit-button[data-v-7110e19f]{display:flex;justify-content:space-between;align-items:center;border:none;border-radius:5px;gap:5px;background-color:#ffffff23;color:#ffff;margin:5px;padding-inline:24px}.nb-menu-config[data-v-7110e19f]{color:#9c9a9a;font-size:18px}.nb-menu-title[data-v-7110e19f]{color:#c2c4c5;font-size:15px;padding:.5rem 1.5rem;background-color:#2b6292}.nb-dropdown-header[data-v-7110e19f]{display:block;padding:.5rem 1.5rem;margin-bottom:0;color:#c2c4c5;font-size:85%;background:#2b6292;white-space:nowrap;text-align:center}.columns-1[data-v-7110e19f]{min-width:250px}.columns-2[data-v-7110e19f]{min-width:500px}.columns-3[data-v-7110e19f]{min-width:700px}.left-divider[data-v-7110e19f]{width:1;overflow:hidden;border-left:1px solid #e9ecef}.nb-dropdownmenu[data-v-7110e19f]{width:100%}.nb-dropdownmenu li[data-v-7110e19f],.nb-dropdownmenu ul[data-v-7110e19f]{margin:0;padding:0}.nb-dropdownmenu ul[data-v-7110e19f]{background:#fff;list-style:none;width:100%}.nb-dropdownmenu li[data-v-7110e19f]{float:left;position:relative;width:auto}.nb-dropdownmenu span[data-v-7110e19f],a[data-v-7110e19f]{background:#fff;color:gray;display:block;font-size:12px;font-weight:600;line-height:40px;text-transform:uppercase;letter-spacing:.3px;padding:0 25px;text-decoration:none;white-space:nowrap;-webkit-transition:all .25s ease;-moz-transition:all .25s ease;-ms-transition:all .25s ease;-o-transition:all .25s ease;transition:all .25s ease}.nb-dropdownmenu li:hover a[data-v-7110e19f]{background:#2b6292;color:#fff}.nb-dropdown-divider[data-v-7110e19f]{background:#2b6292;width:1;overflow:hidden;border-bottom:1px solid #e9ecef}#submenu[data-v-7110e19f]{left:0;opacity:0;position:absolute;visibility:hidden;background:#2b6292;padding:25px 0;z-index:1000}li:hover ul#submenu[data-v-7110e19f]{opacity:1;top:40px;visibility:visible}#submenu li[data-v-7110e19f]{float:none;width:100%}#submenu a[data-v-7110e19f]:hover{background:#2b629285}#submenu a[data-v-7110e19f]{background-color:#2b6292}#submenu .row[data-v-7110e19f]{background:#2b6292;margin-right:0;margin-left:0}#submenu .submenu-col-2[data-v-7110e19f]{flex:0 0 50%;max-width:50%}#submenu .submenu-col-3[data-v-7110e19f]{flex:0 0 33.33%;max-width:33.33%}#submenu.submenu-right[data-v-7110e19f]{right:0;left:auto}.mobile-device[data-v-7110e19f]{display:block}.other-device[data-v-7110e19f]{display:none}@media (min-width:768px){.mobile-device[data-v-7110e19f]{display:none}.other-device[data-v-7110e19f]{display:block}}.submenu-header[data-v-7110e19f]{display:block;padding:.5rem 1.5rem;margin-bottom:0;color:gray;font-weight:700;white-space:nowrap;text-align:center}.menu-user[data-v-7110e19f]{font-size:120%}.menu-email[data-v-7110e19f],.menu-user[data-v-7110e19f]{display:block;padding:.5rem 1.5rem;margin-bottom:0;color:#c2c4c5;font-weight:600;background:#2b6292}.menu-email[data-v-7110e19f]{font-size:85%}.close[data-v-7110e19f]{font-size:5rem}", ""]);

// exports


/***/ }),
/* 2154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"d-flex align-itens-center m-0 p-0",staticStyle:{"background-color":"white","height":"45px"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"w-100 row m-0 p-0",style:(_vm.hasBgconfig)},[_c('span',{staticClass:"text-center col-9 d-flex flex-column justify-content-center",staticStyle:{"font-size":"28px"}},[_vm._v("\n        "+_vm._s(_vm.params_msg)+" "+_vm._s(_vm.caixa)+"\n      ")]),_vm._v(" "),_c('strong',{staticClass:"col-auto mx-auto d-flex align-items-center"},[(_vm.pedv.comanda)?_c('span',{staticClass:"mr-2 border p-1"},[_c('i',{staticClass:"fa fa-barcode mr-1"}),_vm._v(_vm._s(_vm.pedv.comanda))]):_vm._e(),_vm._v(" "),(_vm.pedv.mesa)?_c('span',{staticClass:"mr-2 border p-1"},[_c('i',{staticClass:"fa fa-table mr-1"}),_vm._v(_vm._s(_vm.pedv.mesa))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"float-right",staticStyle:{"display":"flex","flex-direction":"row","justify-content":"end"}},[(_vm.showBtnConfig)?_c('button',{staticClass:"navbar-toggler",style:(_vm.hasFontconfig),attrs:{"type":"button"},on:{"click":_vm.handleConfig}},[_c('span',{staticClass:"fa fa-cog"})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"navbar-toggler",style:(_vm.hasFontconfig),attrs:{"type":"button"},on:{"click":_vm.handleFullScreen}},[_c('span',{class:_vm.isFullScreen ? 'fa fa-compress' : 'fa fa-expand'})]),_vm._v(" "),(_vm.showBtnConfig)?_c('button',{staticClass:"navbar-toggler",style:(_vm.hasFontconfig),attrs:{"type":"button"},on:{"click":_vm.handleClose}},[_c('span',{staticClass:"fa fa-close"})]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3 row",staticStyle:{"max-width":"240px!important","border-top-right-radius":"5px"}},[_c('a',{staticClass:"navbar-brand m-0 p-0",attrs:{"href":"/"}},[_c('img',{staticClass:"img-fluid px-2",staticStyle:{"max-height":"40px!important"},attrs:{"src":"https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo1.png"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_opcoes_vue__ = __webpack_require__(756);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4a80f36_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_opcoes_vue__ = __webpack_require__(2158);
function injectStyle (ssrContext) {
  __webpack_require__(2156)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4a80f36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_opcoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4a80f36_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_opcoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2157);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b769cfac", content, true, {});

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1 !important"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeModal.apply(null, arguments)}}},[_c('Trap',[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-md",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body pt-3",staticStyle:{"max-height":"100%","overflow-y":"auto"}},[_c('div',{staticClass:"lbl mb-2",staticStyle:{"font-size":"20px"}},[_c('strong',[_vm._v("Mais Opções")])]),_vm._v(" "),_c('button',{staticClass:"close",on:{"click":_vm.closeModal}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"lbl mb-2"},[_vm._v("\n                  Caixa\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 mb-2"},[_c('button',{staticClass:"btn btn-green font-weight-bold w-100",style:(_vm.bgButton),on:{"click":function($event){return _vm.handleEmit('fecharcaixa')}}},[_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v("Fechar Caixa (Alt + F)")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-2"},[_c('button',{staticClass:"btn btn-green font-weight-bold w-100",style:(_vm.bgButton),on:{"click":function($event){return _vm.handleEmit('sangrar')}}},[_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v("Sangrar (Alt + S)")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-2"},[_c('button',{staticClass:"btn btn-green font-weight-bold w-100",style:(_vm.bgButton),on:{"click":function($event){return _vm.handleEmit('reforcar')}}},[_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v("Reforçar (Alt + R)")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-2"},[_c('button',{staticClass:"btn btn-green font-weight-bold w-100",style:(_vm.bgButton),on:{"click":function($event){return _vm.handleEmit('pendcli')}}},[_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v("Pendencias Cliente")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"lbl mb-2"},[_vm._v("\n                  Venda\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 mb-2"},[_c('button',{staticClass:"btn btn-green font-weight-bold w-100",style:(_vm.bgButton),on:{"click":function($event){return _vm.handleEmit('excluir')}}},[_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v("Excluir Produto (Alt + D)")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-2"},[_c('button',{staticClass:"btn btn-green font-weight-bold w-100",style:(_vm.bgButton),on:{"click":function($event){return _vm.handleEmit('destaques')}}},[_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v("Destaques")])])])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_pag_form_vue__ = __webpack_require__(757);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f38f4e76_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_pag_form_vue__ = __webpack_require__(2170);
function injectStyle (ssrContext) {
  __webpack_require__(2160)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_pag_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_f38f4e76_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_pag_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2161);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7410c545", content, true, {});

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".vd-input{cursor:text;color:#3a4953;font-family:lato,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-size:15px;word-break:normal;width:100%;margin:0;padding:12px;box-sizing:border-box;outline:none;box-shadow:none;background-color:#fff;border:2px solid #e5eaed;border-radius:3px;transition:all .2s;transition-property:border-color,box-shadow}.wr-input--amount-tendered{max-width:100%;width:200px;height:60px;text-align:right;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;word-break:break-word;margin:0;font-size:32px;line-height:1.5;font-weight:700}.vd-text-supplementary{-webkit-font-smoothing:antialiased;font-size:12px;line-height:1.25;font-weight:400}.btn--payment-type{position:relative;flex-basis:calc(33.333% - 8px)}.varejo-button{font-synthesis:none;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;position:relative;font-family:lato,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;cursor:pointer;font-size:15px;border-radius:3px;padding:12px 20px;text-align:center;box-sizing:border-box;display:inline-block;min-width:100px;margin:0 4px;border:1px solid transparent;font-weight:700;transition:all .2s;transition-property:background,color,border;outline:none}.varejo-button.varejo-button--primary{background-color:#41af4b;color:#fff}.varejo-button.varejo-button--big{font-synthesis:none;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.22222;font-size:18px;padding:16px 32px}.varejo-button:last-child{margin-right:0}.varejo-button:first-child{margin-left:0}.varejo-button.varejo-button--primary.disabled,.varejo-button.varejo-button--primary:disabled,.varejo-button.varejo-button--primary:disabled:hover,.varejo-button.varejobutton--primary[disabled]{cursor:default;pointer-events:none;opacity:.35;-webkit-filter:grayscale(100%);filter:grayscale(100%)}.alert-short{border-top:1px solid #6c757d!important}.wr-info-fields{margin-left:-5px;margin-right:-5px;display:flex}.wr-info-fields--center,.wr-info-fields--large{justify-content:center;text-align:center}.wr-info-fields .wr-info-field{padding:0 5px;flex:1}.wr-info-field{display:block;min-width:0;word-wrap:break-word;margin:5px 0}.wr-info-field-label{color:#3a4953;font-size:14px}.wr-info-field-value{font-size:24px}.f-pag-icon{margin:1.3rem 0}.f-pag-icon i{font-size:1.5rem}.f-pag-icon span{width:5rem!important;height:1rem!important;font-size:.65rem;font-weight:900!important;margin-top:-10px!important;margin-right:-7px!important;z-index:1;display:flex;justify-content:center;align-items:center}.f-pag-desc .text-secondary{font-size:13px;text-transform:uppercase;margin-top:.5rem}.f-pag-desc .lbl-list{font-size:11px;text-transform:uppercase}.f-pag-action button{min-width:5rem!important}.forma-pagamento-list:hover{text-decoration:none;background:#f5f4f4}.half-card{width:100%;padding:5px 15px;border-radius:.25rem}", ""]);

// exports


/***/ }),
/* 2162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_parcelas_form_vue__ = __webpack_require__(758);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_48c9b701_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_parcelas_form_vue__ = __webpack_require__(2165);
function injectStyle (ssrContext) {
  __webpack_require__(2163)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_parcelas_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_48c9b701_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_parcelas_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2164);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("39cf7dac", content, true, {});

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1 !important"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body d-flex flex-column vh-100",staticStyle:{"height":"500px!important","max-height":"100%","overflow-y":"auto"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"lbl mb-4",staticStyle:{"font-size":"20px"}},[_c('strong',[_vm._v("Parcelas "+_vm._s(_vm.params.descricao))])]),_vm._v(" "),_c('button',{ref:"ediitemclose",staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.cancelFormParcelas()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{ref:"valoraparcelar",attrs:{"col":"3","disabled":true,"type":"value","precision":2,"label":"Valor do Pagamento"},model:{value:(_vm.params.valorPagamento),callback:function ($$v) {_vm.$set(_vm.params, "valorPagamento", $$v)},expression:"params.valorPagamento"}}),_vm._v(" "),_c('form-field',{ref:"parcelas",attrs:{"type":"value","col":"2","label":"Qt de Parcelas"},model:{value:(_vm.parcelas),callback:function ($$v) {_vm.parcelas=$$v},expression:"parcelas"}})],1),_vm._v(" "),(_vm.nrExcedido)?_c('alert',{attrs:{"close":false,"type":"warning","text":"Quantidade de parcelas não permitida"}}):_vm._e(),_vm._v(" "),(_vm.parcelas > '0')?_c('div',{staticClass:"row justify-content-md-center pl-2"},[_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"label":"Dias"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"label":"Vencimento"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('v-label',{attrs:{"label":"Valor"}})],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.listParcelas),function(par,index){return _c('div',{key:index,staticClass:"row justify-content-md-center"},[_c('strong',{staticClass:"d-md-flex justify-content-center align-items-start pr-5 mr-2 text-center d-none",staticStyle:{"width":"2px!important","padding":"0px!important"}},[_vm._v("\n                            "+_vm._s(index+1)+"\n                        ")]),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvpar.dias.validator),expression:"metadata.pedvpar.dias.validator"}],attrs:{"type":"number","col":"2","name":'dias'+index,"v-errors":_vm.errors},on:{"input":function($event){return _vm.parcelasDiasChange(index)}},model:{value:(par.dias),callback:function ($$v) {_vm.$set(par, "dias", $$v)},expression:"par.dias"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvpar.dtv.validator),expression:"metadata.pedvpar.dtv.validator"}],attrs:{"type":"date","col":"2","name":'dtv'+index,"v-errors":_vm.errors},model:{value:(par.dtv),callback:function ($$v) {_vm.$set(par, "dtv", $$v)},expression:"par.dtv"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.pedvpar.vlr.validator),expression:"metadata.pedvpar.vlr.validator"}],attrs:{"type":"value","col":"2","precision":2,"name":'vlr'+index,"v-errors":_vm.errors},on:{"input":function($event){return _vm.parcelasVlrChange(index)}},model:{value:(par.vlr),callback:function ($$v) {_vm.$set(par, "vlr", $$v)},expression:"par.vlr"}})],1)}),_vm._v(" "),_c('div',{staticClass:"row mt-auto"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Confirmar","title":"","disabled":_vm.parcelas <= 0},on:{"click":_vm.handleConfirmaParcelas}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar","title":""},on:{"click":_vm.cancelFormParcelas}})],1)])],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_opcoes_final_vue__ = __webpack_require__(759);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c7bbefc_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_opcoes_final_vue__ = __webpack_require__(2169);
function injectStyle (ssrContext) {
  __webpack_require__(2167)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c7bbefc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_opcoes_final_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c7bbefc_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_opcoes_final_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2168);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("ab769372", content, true, {});

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1 !important"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeModal.apply(null, arguments)}}},[_c('Trap',[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-md",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body pt-3",staticStyle:{"max-height":"100%","overflow-y":"auto"}},[_c('div',{staticClass:"lbl mb-2",staticStyle:{"font-size":"20px"}},[_c('strong',[_vm._v("Selecione um Documento")])]),_vm._v(" "),_c('button',{staticClass:"close",on:{"click":_vm.closeModal}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-3"},[_c('select',{ref:"list",staticClass:"form-control",staticStyle:{"font-size":"24px"},attrs:{"multiple":"","size":"6"},domProps:{"value":_vm.selectedOption},on:{"change":_vm.handleSelect,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleEmit.apply(null, arguments)}}},[_c('option',{attrs:{"value":"NC"}},[_vm._v("Emitir NFc-e")]),_vm._v(" "),_c('option',{attrs:{"value":"NF"}},[_vm._v("Emitir NF-e")]),_vm._v(" "),_c('option',{attrs:{"value":"CP"}},[_vm._v("Emitir Cupom Não Fiscal")]),_vm._v(" "),_c('option',{attrs:{"value":"FV"}},[_vm._v("Finalizar Venda")])])])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"varejopagform"},[_c('div',{staticClass:"d-flex flex-column",staticStyle:{"gap":"15px"}},[_c('div',{staticClass:"w-100 d-flex",staticStyle:{"gap":"30px"}},[_c('a',{staticClass:"text-secondary cursor-pointer",staticStyle:{"font-size":"12px"},on:{"click":_vm.handleRetorna}},[_vm._v("\n          ESC Retornar para Produtos")]),_vm._v(" "),(_vm.totalPago)?_c('a',{staticClass:"text-secondary cursor-pointer",staticStyle:{"font-size":"12px"},on:{"click":_vm.handleLimparPag}},[_vm._v("\n          Zerar Pagamentos\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"border shadow half-card"},[_c('div',{staticClass:"d-flex justify-content-start align-items-center",staticStyle:{"gap":"10px","padding":"10px","padding-inline":"2px!important"}},[_c('div',{staticClass:"d-flex align-items-start",staticStyle:{"gap":"30px","padding-top":"2px","align-items":"center"}},[_c('div',{staticClass:"d-flex flex-column"},[_c('span',[_vm._v(" Forma de Pagamento")]),_vm._v(" "),_c('input-value',{ref:"paymentType",staticClass:"vd-input d-flex justify-content-start text-left",staticStyle:{"max-width":"200px","max-height":"45px","font-size":"18px!important"},attrs:{"type":"value","id":"paymentType","placeholder":"Digite o código"},on:{"keyenter":function($event){return _vm.handleEnterTypePay()}},model:{value:(_vm.formaPagamento),callback:function ($$v) {_vm.formaPagamento=_vm._n($$v)},expression:"formaPagamento"}})],1),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('span',{staticClass:"mr-2"},[_vm._v("Valor do Pagamento")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"d-flex justify-content-start align-items-start",staticStyle:{"gap":"30px"}},[_c('input-value',{ref:"valorpagamento",staticClass:"vd-input wr-input--amount-tendered",staticStyle:{"max-width":"200px","max-height":"45px","font-size":"18px!important"},attrs:{"precision":2},on:{"keyenter":function($event){return _vm.handleEnterPaymentValue()}},model:{value:(_vm.valorPagamento),callback:function ($$v) {_vm.valorPagamento=$$v},expression:"valorPagamento"}}),_vm._v(" "),(_vm.formaPagamento && _vm.formaPagamento > _vm.fpagList.length)?_c('div',{staticClass:"error"},[_c('span',[_vm._v("Forma inválida")])]):_vm._e(),_vm._v(" "),(_vm.formaPagamento && _vm.formaPagamento <= _vm.fpagList.length || _vm.listPagamentos.length > 0)?_c('div',{staticClass:"text-dark"},[_c('strong',{staticClass:"font-weight-bold"},[_c('i',{class:_vm.formaPagamento ? _vm.fpagList[_vm.formaPagamento - 1].icon : _vm.listPagamentos[_vm.listPagamentos.length - 1].fpag.icon}),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v("\n                        "+_vm._s(_vm.formaPagamento ? _vm.fpagList[_vm.formaPagamento - 1].descricao : _vm.listPagamentos[_vm.listPagamentos.length - 1].fpag.descricao)+"\n                      ")])])]):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"vd-text-supplementary d-block"},[_vm._v(_vm._s(_vm.titulo))])])])])]),_vm._v(" "),(_vm.listPagamentos.length > 0)?_c('div',{staticClass:"p-2"},[_c('div',{staticClass:"my-2"},_vm._l((_vm.listPagamentos),function(pag,index){return _c('div',{key:index},[_c('div',{staticClass:"col-12 my-1"},[_vm._v("Recebido em "+_vm._s(pag.fpag.descricao)+"\n                  "+_vm._s(pag.parcelas)+"x\n                "),_c('strong',{staticClass:"vd-text-medium float-right"},[_vm._v("\n                  R$ "+_vm._s(_vm._f("formatValue")(pag.valor,2)))])])])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"p-2",attrs:{"aria-labelledby":"btnGroupDrop1"}},[_c('div',{staticClass:"row"},[_vm._l((_vm.fpagList),function(opcao,index){return [_c('div',{key:index,staticClass:"col-3 mb-2"},[_c('div',{staticClass:"nb-dash-card p-2 mx-n2 text-center align-items-center"},[_c('span',{staticClass:"w-100"},[_c('strong',{staticClass:"bg-light border rounded-circle text-dark",staticStyle:{"top":"3px","left":"3px","font-size":"11px","padding":"2px 6px","padding-right":"5.5px"}},[_vm._v("\n                      "+_vm._s(index + 1)+"\n                    ")])]),_vm._v(" "),_c('span',{staticClass:"w-100 mt-1"},[_vm._v(_vm._s(opcao.descricao))])])])]})],2)])]),_vm._v(" "),(_vm.totalPago >= _vm.params.totalVenda)?_c('div',{staticClass:"row mx-0 px-0 mt-2 mb-2"},[(!_vm.confirmPag)?_c('div',{staticClass:"col-12 mb-2"},[_c('button',{ref:"btnconfirmpag",staticClass:"btn font-weight-bold w-100",style:(_vm.hasBgButtomconfig()),on:{"click":function($event){return _vm.handleConfirmPag()}}},[_c('span',{staticStyle:{"font-size":"15px","text-transform":"uppercase"}},[_vm._v("Finalizar Recebimento (ENTER)")]),_vm._v(" "),(_vm.loadbutton)?_c('span',{staticClass:"spinner-border ml-2",staticStyle:{"height":"15px","width":"15px"},attrs:{"role":"status"}}):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.confirmPag)?_c('div',{staticClass:"col-8 mb-2"},[_c('button',{ref:"btnPaymentDone",staticClass:"btn font-weight-bold w-100",style:(_vm.hasBgButtomconfig()),attrs:{"id":"btnPaymentDone","disabled":_vm.totalPago < _vm.params.totalVenda},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==120){ return null; }_vm.showModalDocumentos=true},"click":_vm.handleDonePayment}},[_c('span',{staticStyle:{"font-size":"15px","text-transform":"uppercase"}},[_vm._v("\n            "+_vm._s(_vm.params_pdv.default_focus_btn_pag == "CP"
                ? "Imprimir Cupom (ENTER)"
                : _vm.params_pdv.default_focus_btn_pag == "ES"
                ? "Emitir Sat (ENTER)"
                : _vm.params_pdv.default_focus_btn_pag == "NC"
                ? "Emitir NFC-e (ENTER)"
                : _vm.params_pdv.default_focus_btn_pag == "NF"
                ? "Emitir NF (ENTER)"
                : "Finalizar Venda (ENTER)")+"\n            ")])])]):_vm._e(),_vm._v(" "),(_vm.confirmPag)?_c('div',{staticClass:"col-4 mb-2"},[_c('button',{staticClass:"btn btn-outline-secondary font-weight-bold w-100",on:{"click":function($event){_vm.showModalDocumentos=true},"keydown":function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==120){ return null; }_vm.showModalDocumentos=true}}},[_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v("(F9) Mais Opções")])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.saldo > 0)?_c('div',{staticClass:"shadow half-card",style:(_vm.saldo <= 0
            ? 'background-color: white'
            : "background-color: white; color: #343a40 !important; padding: 11px;border-radius:5px; font-weight: 500; font-size: 1.25rem;")},[_c('div',{},[(_vm.enableCreditoLoja)?_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"vd-text-medium"},[_vm._v("Saldo em Crédito na Loja")]),_vm._v(" "),_c('strong',{staticClass:"vd-text-medium float-right"},[_vm._v("\n              (R$ "+_vm._s(_vm._f("formatValue")(_vm.creditoLoja.saldo,2,true))+")")])]):_vm._e()]),_vm._v(" "),_c('div',{},[(_vm.saldo > 0)?_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"vd-text-medium"},[_vm._v("SALDO A RECEBER")]),_vm._v(" "),_c('strong',{staticClass:"vd-text-medium float-right"},[_vm._v("\n              R$ "+_vm._s(_vm._f("formatValue")(_vm.saldo,2,true)))])]):_vm._e()]),_vm._v(" "),(_vm.saldo > 0)?_c('div',{staticClass:"col-md-12"},[_c('strong',{staticClass:"vd-text-medium"},[_vm._v("VALOR RECEBIDO")]),_vm._v(" "),(_vm.totalPago > 0)?_c('strong',{staticClass:"vd-text-medium float-right"},[_vm._v("\n            R$ "+_vm._s(_vm._f("formatValue")(_vm.totalPago,2,true))+" ")]):_c('strong',{staticClass:"vd-text-medium float-right"},[_vm._v("\n            R$ "+_vm._s(_vm._f("formatValue")(0,2,true))+" ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.saldo <= 0)?_c('div',{staticClass:"shadow",style:(((_vm.hasBgconfig(true)) + "; padding: 11px;border-radius:5px; font-weight: 500; font-size: 1.25rem"))},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('span',[_vm._v("Total Recebido")]),_vm._v(" "),_c('span',[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.totalPago,2,true)))])]),_vm._v(" "),_c('div',{staticClass:"w100"}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('span',[_vm._v("Troco")]),_vm._v(" "),_c('span',[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(this.saldo ? this.saldo * -1 : 0,2,true)))])])]):_vm._e(),_vm._v(" "),(_vm.pedv)?_c('div',{staticClass:"shadow half-card",staticStyle:{"padding":"11px","border-radius":"5px"}},[_c('div',{staticClass:"d-flex flex-column justify-content-start align-items-start",staticStyle:{"gap":"10px"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.pedv.obspedido),expression:"pedv.obspedido"}],ref:"obspedido_side",staticClass:"form-control",staticStyle:{"font-size":"0.950rem","resize":"none"},attrs:{"type":"text","rows":"3"},domProps:{"value":(_vm.pedv.obspedido)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.pedv, "obspedido", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),_c('div',[_c('Trap',[(_vm.showModalDocumentos)?_c('VarejoModalOpcoesFinal',{on:{"selected":_vm.handleDocument,"closeModal":_vm.handleRetorna}}):_vm._e()],1)],1)]),_vm._v(" "),(_vm.showParcelas)?_c('div',[_c('varejo-parcelas-form',{attrs:{"params_pdv":_vm.params_pdv,"eventAlt":_vm.eventAlt,"params":_vm.paramParcelas},on:{"cancel":_vm.cancelFormParcelas,"confirma":_vm.handleConfirmaParcelas}})],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('strong',{staticStyle:{"font-size":"12px"}},[_vm._v("Obervaçoes")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_vabertura_form_vue__ = __webpack_require__(760);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1fc0cf_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_vabertura_form_vue__ = __webpack_require__(2174);
function injectStyle (ssrContext) {
  __webpack_require__(2172)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c1fc0cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_vabertura_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1fc0cf_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_vabertura_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2173);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4903d10a", content, true, {});

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1 !important"}},[_c('Trap',[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"width":"90vh!important","overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body pt-3",staticStyle:{"height":"80vh!important","max-height":"100%","overflow-y":"auto"}},[_c('warnings',{attrs:{"messages":['Selecione um caixa para iniciar as vendas!']}}),_vm._v(" "),_c('div',{staticClass:"lbl mb-2",staticStyle:{"font-size":"20px"}},[_c('strong',[_vm._v("Abertura do Caixa")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12 mb-3"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("Operador")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_c('strong',[_vm._v(_vm._s(_vm.usuarionome))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12 mb-3"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("Data da Operação")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl"},[_c('strong',[_vm._v(" "+_vm._s(_vm._f("formatData")(_vm.vabertura.data))+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12 mb-2"},[_c('span',{staticClass:"lbl-deal-title"},[_vm._v("Selecione o caixa para abertura")])]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('select',{ref:"listCaixas",staticClass:"form-control",staticStyle:{"font-size":"17px"},attrs:{"multiple":"","size":"4"},domProps:{"value":_vm.codvcaixa},on:{"change":_vm.selectCaixa,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleFocus()}}},_vm._l((_vm.listCaixas),function(opt){return _c('option',{key:opt.id,domProps:{"value":opt.id}},[_vm._v(_vm._s(opt.value))])}),0)])]),_vm._v(" "),(_vm.aberturadecaixa)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12 mb-3"},[_c('span',{staticClass:"lbl-deal-title"},[_vm._v("Informe o valor inicial de abertura do caixa")])]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vabertura.valor.validator),expression:"metadata.vabertura.valor.validator"}],ref:"valor",attrs:{"id":"valor","type":"value","precision":2,"col":"6","metadata":_vm.metadata.vabertura.valor,"name":"valor","v-errors":_vm.errors},model:{value:(_vm.vabertura.valor),callback:function ($$v) {_vm.$set(_vm.vabertura, "valor", $$v)},expression:"vabertura.valor"}}),_vm._v(" "),(_vm.valor_ultimo_fechamento)?_c('div',{staticClass:"col-md-6 col-6 mb-3"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("Valor Fechamento Anterior")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl-edit"},[_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(_vm.valor_ultimo_fechamento,2,true)))])])]):_vm._e(),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vabertura.obs.validator),expression:"metadata.vabertura.obs.validator"}],attrs:{"type":"text","col":"12","metadata":_vm.metadata.vabertura.obs,"name":"obs","v-errors":_vm.errors},model:{value:(_vm.vabertura.obs),callback:function ($$v) {_vm.$set(_vm.vabertura, "obs", $$v)},expression:"vabertura.obs"}})],1):_vm._e(),_vm._v(" "),(_vm.caixaaberto)?_c('alert',{attrs:{"type":"info","title":"Aviso","text":'O caixa já está aberto. O operador atual é ' + _vm.nomeoperador + '. Clique em confirmar para prosseguir.'}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{ref:"btnConfirma",attrs:{"label":"Confirmar","success":true},on:{"click":_vm.handleFinaliza}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Fechar"},on:{"click":_vm.handleRetorna}})],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1 !important"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleRetorna.apply(null, arguments)}}},[_c('Trap',[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"max-width":"650px","overflow-y":"initial !important","margin":"5px auto"}},[_c('div',{staticClass:"modal-content modal-full-h"},[_c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"lbl mb-2",staticStyle:{"font-size":"20px"}},[(_vm.params.tpmovcaixa == 'S')?_c('strong',[_vm._v("Sangria de Caixa")]):_c('strong',[_vm._v("Reforço de Caixa")])]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.handleRetorna}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body pt-3",staticStyle:{"max-height":"100%","overflow-y":"auto"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('form-field',{attrs:{"type":"select","col":"6","select-options":_vm.tpmovcaixaList,"placeholder":"Tipo movimento","label":"Tipo do movimento","disabled":""},model:{value:(_vm.vmovcaixa.tpmovcaixa),callback:function ($$v) {_vm.$set(_vm.vmovcaixa, "tpmovcaixa", $$v)},expression:"vmovcaixa.tpmovcaixa"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vmovcaixa.valor.validator),expression:"metadata.vmovcaixa.valor.validator"}],ref:"valor",attrs:{"type":"value","precision":2,"col":"12","label":"Valor do movimento","name":"valor","v-errors":_vm.errors},model:{value:(_vm.vmovcaixa.valor),callback:function ($$v) {_vm.$set(_vm.vmovcaixa, "valor", $$v)},expression:"vmovcaixa.valor"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.metadata.vmovcaixa.obs.validator),expression:"metadata.vmovcaixa.obs.validator"}],attrs:{"type":"text","col":"12","metadata":_vm.metadata.vabertura.obs,"name":"obs","v-errors":_vm.errors},model:{value:(_vm.vmovcaixa.obs),callback:function ($$v) {_vm.$set(_vm.vmovcaixa, "obs", $$v)},expression:"vmovcaixa.obs"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col"},[_c('v-button',{attrs:{"label":"Confirmar","nb-btdef":true},on:{"click":_vm.handleFinaliza}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":_vm.handleRetorna}})],1)]),_vm._v(" "),_vm._l((_vm.vmovcaixaList),function(item,index){return _c('div',{key:index,staticClass:"w-100"},[_c('div',{staticClass:"row border m-2 p-1"},[_c('div',{staticClass:"col-md-3 col-4"},[_c('span',{staticClass:"lbl-list"},[_vm._v(" Data ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(_vm._f("formatDataHora")(item.data)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-4"},[_c('span',{staticClass:"lbl-list"},[_vm._v(" Operador ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(item.operador))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-4"},[_c('span',{staticClass:"lbl-list"},[_vm._v(" Valor ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(item.valor,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-auto text-right"},[_c('v-button',{staticClass:"float-right",attrs:{"icon":"fa-trash","title":""},on:{"click":function($event){return _vm.handleConfirmaDelete(index)}}})],1),_vm._v(" "),(item.obs)?_c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"lbl-list"},[_vm._v(" Observação ")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(item.obs))])]):_vm._e(),_vm._v(" "),(item.confirmaexclusao)?_c('div',{staticClass:"col-auto p-2"},[_c('v-button',{attrs:{"label":"Confirmar Exclusão","danger":true},on:{"click":function($event){return _vm.handleDelete(item)}}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Cancelar"},on:{"click":function($event){item.confirmaexclusao = false}}})],1):_vm._e()])])})],2)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_item_sequencia_vue__ = __webpack_require__(763);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f7590b4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_item_sequencia_vue__ = __webpack_require__(2182);
function injectStyle (ssrContext) {
  __webpack_require__(2177)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_item_sequencia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f7590b4_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_item_sequencia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2178);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a660b298", content, true, {});

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".side-form{position:fixed;top:0;left:0;bottom:0;transform:translateZ(0);transition:all .35s;will-change:transform;z-index:10000}.side-form-shadow{box-shadow:0 0 32px 0 #a9aaac80}.side-form-inner{display:flex;flex-direction:column;background-color:rgba(75,71,71,.658);width:680px;overflow:hidden;height:100%}.side-form-footer{display:flex;align-items:center;background-color:#f5f5f5;padding:10px 20px;flex:0 0 78px}.side-form-body{padding:1rem!important;overflow-y:auto;height:100%}.nb-modal-mas-tranparent{background:transparent}", ""]);

// exports


/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2180);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("02b32b54", content, true, {});

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "table .numerico{min-width:65px;text-align:right}table .size100{width:100px}table .total{background:#e7e8e9;border:none}table .var-negative{color:#fff;background:#cd5c5c}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.consulta__total{display:flex;align-items:center;justify-content:center}.consulta__total_valor{font-size:40px;display:block;line-height:normal}.consulta__cifrao{font-size:16px;display:block;line-height:normal}.lbl-vcaixa{color:blue}.lbl-vcaixa,.lbl-vsaidas{font-size:120%;font-weight:600}.lbl-vsaidas{color:red}.lbl-ventradas{font-size:120%;font-weight:600;color:green}", ""]);

// exports


/***/ }),
/* 2181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.modal ? 'd-flex flex-wrap' : 'row'},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"border p-2"},[_c('div',{class:_vm.modal ? 'd-flex flex-wrap' : 'row'},[(_vm.vabertura)?_c('div',{staticClass:"col-12 mb-2"},[_c('span',{staticClass:"lbl-deal-title"},[_vm._v(_vm._s(_vm.vabertura.caixa)+" ")]),_vm._v(" "),(_vm.vabertura.aberto)?_c('span',{staticClass:"badge badge-green"},[_vm._v(_vm._s(_vm.vabertura.status)+" ")]):_vm._e(),_vm._v(" "),(_vm.vabertura.conferido)?_c('span',{staticClass:"badge badge-gray"},[_vm._v(_vm._s(_vm.vabertura.status)+" ")]):_vm._e(),_vm._v(" "),(!_vm.vabertura.conferido && !_vm.vabertura.aberto)?_c('span',{staticClass:"badge badge-blue"},[_vm._v(_vm._s(_vm.vabertura.status)+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-4 mb-3"},[_c('v-label',{attrs:{"label":"Data da Abertura"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"textual",staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm._f("formatDataHora")(_vm.vabertura.dataabertura)))])],1),_vm._v(" "),_c('div',{staticClass:"col-4 mb-3"},[_c('v-label',{attrs:{"label":"Operador"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"textual",staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.vabertura.operadorabertura))])],1),_vm._v(" "),_c('div',{staticClass:"col-4 mb-3"},[_c('v-label',{attrs:{"metadata-field":_vm.metadata.vabertura.codfil}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"textual",staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.vabertura.filial))])],1),_vm._v(" "),_c('div',{staticClass:"col-4 mb-3"},[_c('v-label',{attrs:{"label":"Valor Fechamento Anterior"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"textual",staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.vabertura.valor_ultimo_fechamento,2, true))+"\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"col-4 mb-3"},[_c('v-label',{attrs:{"label":"Valor na Abertura"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"textual",staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.vabertura.valorabertura,2, true)))])],1),_vm._v(" "),_c('div',{staticClass:"col-4 mb-3"},[_c('v-label',{attrs:{"label":"Total Vendido"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"textual",staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.vabertura.vendasValor,2, true)))])],1),_vm._v(" "),_c('div',{staticClass:"col-4 mb-3"},[_c('v-label',{attrs:{"label":"Quantidade de Vendas"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"textual",staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.vabertura.vendas))])],1),_vm._v(" "),_c('div',{staticClass:"col-4 mb-3"},[_c('v-label',{attrs:{"label":"Valor em Devoluções"}}),_vm._v(" "),_c('div',{staticClass:"textual",staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.vabertura.devolucoesValor,2, true))+"\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"col-4 mb-3"},[_c('v-label',{attrs:{"label":"Vendas Canceladas"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"textual",staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.vabertura.vendasCanceladas))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('div',{staticClass:"border p-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4 mb-3"},[_c('v-label',{attrs:{"label":"Valor Em Caixa"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl-vcaixa"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.vabertura.valoremcaixa,2, true)))])],1),_vm._v(" "),_c('div',{staticClass:"col-4 mb-3"},[_c('v-label',{attrs:{"label":"Total Saídas"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl-vsaidas"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.vabertura.valorsaidas,2, true)))])],1),_vm._v(" "),_c('div',{staticClass:"col-4 mb-3"},[_c('v-label',{attrs:{"label":"Total Entradas"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"lbl-ventradas"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(_vm.vabertura.valorentradas,2, true)))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('div',{staticClass:"border p-2"},[_c('div',{staticClass:"row"},[(!_vm.vabertura.aberto)?_c('div',{staticClass:"col-4 mb-3"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.vabertura.dtfechamento}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"textual",staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm._f("formatDataHora")(_vm.vabertura.datafechamento)))])],1):_vm._e(),_vm._v(" "),(!_vm.vabertura.aberto)?_c('div',{staticClass:"col-4 mb-3"},[_c('v-label',{staticClass:"w-100",attrs:{"metadata-field":_vm.metadata.vabertura.codusuariof}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"textual",staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.vabertura.operadorfechamento))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-4 mb-3"},[_c('v-label',{attrs:{"label":"Valor de Fechamento"}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.vabertura.aberto)?_c('form-field',{attrs:{"type":"value","precision":2},model:{value:(_vm.vabertura.valorfechamento),callback:function ($$v) {_vm.$set(_vm.vabertura, "valorfechamento", $$v)},expression:"vabertura.valorfechamento"}}):_c('div',{staticClass:"textual",staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm._f("formatValue")(_vm.vabertura.valorfechamento,2, true))+"\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('v-label',{attrs:{"label":"Observações"}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.vabertura.aberto)?_c('form-field',{attrs:{"type":"memo"},model:{value:(_vm.vabertura.obs),callback:function ($$v) {_vm.$set(_vm.vabertura, "obs", $$v)},expression:"vabertura.obs"}}):_c('div',{staticClass:"textual",staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.vabertura.obs))])],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[(_vm.vabertura.aberto)?_c('v-button',{attrs:{"success":true,"icon":"","label":"Fechar Caixa"},on:{"click":function($event){return _vm.showConfirmAdminPass(_vm.handleFechar)}}}):_vm._e(),_vm._v(" "),(!_vm.vabertura.aberto)?_c('v-button',{attrs:{"icon":"","label":"Rearbrir Caixa"},on:{"click":function($event){return _vm.showConfirmAdminPass(_vm.handleReabrir)}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[(_vm.errmessages)?_c('validation',{staticClass:"mt-3",attrs:{"title":"Erros de Validação","messages":_vm.errmessages}}):_vm._e()],1)])])])]),_vm._v(" "),(_vm.SHOW_CONFIRMADMINPASS)?_c('confirm-adminpass',{on:{"close":function($event){return _vm.hideConfirmAdminPass()},"confirm":function($event){return _vm.confirmAdminPass()}}}):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{class:_vm.modal ? 'd-flex flex-wrap mb-2' : 'row mb-2'},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-bordered responsive w-100"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.formasPagamento.lista),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatData")(row.data)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.descricao))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valor,2, true)))])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total",attrs:{"colspan":"2"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.formasPagamento.total,2, true))+" ")])])])])])])])]),_vm._v(" "),(_vm.movimentosCaixa.lista.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 m-2"},[_c('span',{staticClass:"lbl-deal-title"},[_vm._v("Movimentos do Caixa")]),_vm._v(" "),(_vm.vabertura.aberto)?_c('a',{staticClass:"ml-5 btn btn-outline-secondary",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.showConfirmAdminPass(_vm.handleSangrar)}}},[_c('i',{staticClass:"fa fa-minus",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-money",attrs:{"aria-hidden":"true"}}),_vm._v(" Sangrar ")]):_vm._e(),_vm._v(" "),(_vm.vabertura.aberto)?_c('a',{staticClass:"ml-3 btn btn-outline-secondary",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.showConfirmAdminPass(_vm.handlerReforcar)}}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-money",attrs:{"aria-hidden":"true"}}),_vm._v(" Reforçar ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.movimentosCaixa.lista.length)?_c('div',{class:_vm.modal ? 'd-flex flex-wrap mb-2' : 'row mb-2'},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-bordered responsive w-100"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.movimentosCaixa.lista),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatData")(row.data)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.tipo))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.observacao))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valoremcaixa,2, true)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_c('a',{staticClass:"alert-link",attrs:{"href":"#"},on:{"click":function($event){return _vm.handleEmissaoCupom(row.codvmovcaixa)}}},[_vm._v("Imprimir")])])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total",attrs:{"colspan":"3"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.movimentosCaixa.total,2, true))+" ")])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.vendasAbertas.lista.length)?_c('div',{staticClass:"row"},[_vm._m(3)]):_vm._e(),_vm._v(" "),(_vm.vendasAbertas.lista.length)?_c('div',{class:_vm.modal ? 'd-flex flex-wrap mb-2' : 'row mb-2'},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-bordered responsive w-100"},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.vendasAbertas.lista),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual"},[_c('a',{staticClass:"alert-link",attrs:{"href":"#"},on:{"click":function($event){return _vm.handleOpenVendaAberta(row)}}},[_vm._v(_vm._s(row.numero))])]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatData")(row.data)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.obs))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valor,2, true)))])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total",attrs:{"colspan":"2"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.vendasAbertas.total,2, true))+" ")])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.resumoVendas.lista.length)?_c('div',{staticClass:"row"},[_vm._m(5)]):_vm._e(),_vm._v(" "),(_vm.resumoVendas.lista.length)?_c('div',{class:_vm.modal ? 'd-flex flex-wrap mb-2' : 'row mb-2'},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-bordered responsive w-100"},[_vm._m(6),_vm._v(" "),_c('tbody',_vm._l((_vm.resumoVendas.lista),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.descricao))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.qt,2, true)))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valor,2, true)))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.perc,2, true))+" %")])])}),0)])])])])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showVmovCaixaForm)?_c('VarejoVmCaixaForm',{attrs:{"params":_vm.paramsvmovcaixa},on:{"resultadovmovcaixa":_vm.handleResultadoVmovCaixaForm}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showEmissaoCupomVmov)?_c('VarejoEmissaoCupom',{attrs:{"index":_vm.vmovcaixa.codvmovcaixa,"tipo":"movimentocaixa"},on:{"resultadoemissaocupom":_vm.handleResultadoEmissaoCupom}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showEmissaoCupomFechamento)?_c('VarejoEmissaoCupom',{attrs:{"index":_vm.index,"tipo":"fechamentocaixa"},on:{"resultadoemissaocupom":_vm.handleResultadoEmissaoCupomFechamento}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-12 m-2"},[_c('span',{staticClass:"lbl-deal-title"},[_vm._v("Formas de Pagamento")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  Data\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  Descrição\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Valor\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  Data\n                ")]),_vm._v(" "),_c('th',{staticClass:"textual",attrs:{"colspan":"1"}},[_vm._v("\n                  Descrição\n                ")]),_vm._v(" "),_c('th',{staticClass:"textual",attrs:{"colspan":"1"}},[_vm._v("\n                  Observações\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Valor\n                ")]),_vm._v(" "),_c('th',{staticClass:"textual",attrs:{"colspan":"1"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 m-2"},[_c('span',{staticClass:"lbl-deal-title"},[_vm._v("Vendas em Espera")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Pedido\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                  Data\n                ")]),_vm._v(" "),_c('th',{staticClass:"textual",attrs:{"colspan":"1"}},[_vm._v("\n                  Observações\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Valor\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 m-2"},[_c('span',{staticClass:"lbl-deal-title"},[_vm._v("Resumo das Vendas Por Grupo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"textual",attrs:{"colspan":"1"}},[_vm._v("\n                  Descrição\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Quantidade\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Valor\n                ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                  Porcentagem\n                ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1 !important"},style:(_vm.showClass)},[_c('div',{},[_c('div',{},[_c('div',{staticClass:"modal nb-modal-mask nb-modal-mas-tranparent",staticStyle:{"display":"block"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleRetorna()}}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-md",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleRetorna()}}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body",staticStyle:{"overflow-y":"auto"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"lbl mb-4",staticStyle:{"font-size":"20px"}},[_c('strong',[_vm._v("\n                "+_vm._s(_vm.modalCrud == "delete"
                    ? "Exclusão de Item"
                    : "Selecione o item")+"\n                        ")])]),_vm._v(" "),_c('button',{ref:"ediitemclose",staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.handleRetorna()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])]),_vm._v(" "),(!_vm.pedvit || _vm.pedvit.length == 0)?_c('div',{staticClass:"mb-4"},[_c('i',{staticClass:"lbl-title fa fa-exclamation-triangle mr-2"}),_c('span',{staticClass:"lbl-title"},[_vm._v("Não possui itens para\n                  "+_vm._s(_vm.modalCrud == "delete" ? "deletar" : "editar"))])]):_c('div',{staticClass:"d-flex flex-column"},[_c('form-field',{ref:"itemvalue",attrs:{"type":'number',"label":"Informe o Numero do Item","col":"6"},on:{"keyenter":function($event){return _vm.handleEnterModalEditIt()},"input":function($event){return _vm.handleInputModalEditIt()}},model:{value:(_vm.editItemValue),callback:function ($$v) {_vm.editItemValue=_vm._n($$v)},expression:"editItemValue"}},[_c('div',[_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errMessageModalEditItem))])])]),_vm._v(" "),(_vm.modalCrud == 'delete')?_c('div',{},[_c('form-field',{ref:"senhaModal",attrs:{"type":"password","col":"6","label":"Digite a senha de administrador"},on:{"keyenter":function($event){return _vm.handleConfirmButtonPass()}},model:{value:(_vm.adminPass),callback:function ($$v) {_vm.adminPass=$$v},expression:"adminPass"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12 mt-3"},[_c('button',{ref:"btnConfirm",staticClass:"btn-danger btn btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleConfirmButtonPass()}}},[_vm._v("\n                    Confirmar\n                  ")]),_vm._v(" "),_c('button',{ref:"btnClose",staticClass:"btn btn-outline-secondary btn-sm",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.handleRetorna()}}},[_vm._v("\n                    Cancelar\n                  ")])])],1)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_nfce_vue__ = __webpack_require__(765);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_25266ed2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_nfce_vue__ = __webpack_require__(2186);
function injectStyle (ssrContext) {
  __webpack_require__(2184)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_nfce_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_25266ed2_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_nfce_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2185);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1930b30c", content, true, {});

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleCloseModal()}}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-md",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleCloseModal()}}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body",staticStyle:{"overflow-y":"auto"}},[_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-md-12 col-12"},[_vm._m(0),_vm._v(" "),(_vm.erro)?_c('button',{ref:"ediitemclose",staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.handleCloseModal()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]):_vm._e()])]),_vm._v(" "),(_vm.message)?_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-md-12 col-12"},[_vm._v("\n            "+_vm._s(_vm.message)+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.erro)?_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-md-12 col-12"},[(_vm.errmessages.length)?_c('validation',{attrs:{"messages":_vm.errmessages}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.erro)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('v-button',{attrs:{"label":"Fechar"},on:{"click":_vm.handleCloseModal}})],1)]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"font-size":"20px"}},[_c('strong',[_vm._v("\n                Processando nota fiscal\n              ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_current_date_hour_vue__ = __webpack_require__(766);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1f4f698_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_current_date_hour_vue__ = __webpack_require__(2190);
function injectStyle (ssrContext) {
  __webpack_require__(2188)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_current_date_hour_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1f4f698_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_current_date_hour_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2189);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("75b0c67b", content, true, {});

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.datenow))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_cliente_vue__ = __webpack_require__(767);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af540fe_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_cliente_vue__ = __webpack_require__(2194);
function injectStyle (ssrContext) {
  __webpack_require__(2192)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_cliente_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af540fe_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_cliente_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2193);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0210e726", content, true, {});

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1 !important"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeModal()}}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body pt-3",staticStyle:{"height":"70vh!important","max-height":"100%","overflow-y":"auto"}},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"close",on:{"click":_vm.closeModal}},[_c('span',[_vm._v("×")])]),_vm._v(" "),(!_vm.localPart)?_c('div',{staticClass:"row nb-margin-bottom"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[(!_vm.localPart)?_c('input-part',{ref:"part",attrs:{"add-button":true,"varejo":true},on:{"change":function($event){return _vm.handleSetCodpart()}},model:{value:(_vm.codpart),callback:function ($$v) {_vm.codpart=$$v},expression:"codpart"}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.localPart)?_c('div',{staticClass:"border",staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',{staticClass:"lbl-title-produto decrase-lbl-title"},[_vm._v(_vm._s(_vm.localPart.nome))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list decrase-lbl-title"},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(_vm.localPart.cnpjcpf)))]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col d-flex justify-content-end align-items-center"},[_c('v-button',{ref:"btnPart",staticClass:"float-right",attrs:{"title":"Excluir","icon":"fa-trash"},on:{"click":_vm.handleDeleteCliente}}),_vm._v(" "),_c('v-button',{staticClass:"float-right",attrs:{"title":"Trocar Cliente","icon":"fa-refresh"},on:{"click":_vm.handleAlteraCliente}})],1)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.handleConfirm()}}},[_vm._v("\n          Confirmar\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.closeModal()}}},[_vm._v("\n          Voltar\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lbl mb-2",staticStyle:{"font-size":"20px"}},[_c('strong',[_vm._v("Informar Cliente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"vd-text-supplementary"},[_vm._v("Selecione um cliente (F4)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_vendas_vue__ = __webpack_require__(768);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_35926144_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_vendas_vue__ = __webpack_require__(2198);
function injectStyle (ssrContext) {
  __webpack_require__(2196)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35926144"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_vendas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_35926144_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_vendas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2197);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("42a966df", content, true, {});

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".mainbox[data-v-35926144]{overflow:visible}.main-content[data-v-35926144]{overflow-y:hidden}.box[data-v-35926144]{float:none}", ""]);

// exports


/***/ }),
/* 2198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1 !important"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"max-width":"90%","width":"90% !important","overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body pt-3",staticStyle:{"height":"80vh!important","max-height":"100%","overflow-y":"auto"},on:{"scroll":_vm.handleScroll}},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"close",on:{"click":_vm.closeModal}},[_c('span',[_vm._v("×")])]),_vm._v(" "),(_vm.show)?_c('div',[(_vm.varejoList.length === 0)?_c('alert',{attrs:{"text":"Nenhuma venda encontrada","type":"warning"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.filteredVarejoList),function(item,index){return _c('div',{key:index,staticClass:"mainbox"},[_c('div',{staticClass:"box mx-2 d-flex flex-wrap"},[_c('div',{staticClass:"col-md-1 col-2"},[(index==0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Pedido"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.npedido))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[(index==0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Data"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatDataHora")(item.data)))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[(index==0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Cliente"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.fantasia))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[(index==0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Operador"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.nome_usuario))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[(index==0)?_c('v-label',{staticClass:"w-100",attrs:{"label":"Total do Pedido"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v("R$\n                  "),_c('strong',[_vm._v(_vm._s(_vm._f("formatValue")(item.totger,2)))])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 text-right ml-auto"},[_c('span',{staticClass:"badge",class:_vm.statusColor(item.stpedv, item.tppedv)},[_vm._v(_vm._s(_vm.textST(item)))]),_vm._v(" "),(item.espera === 'S')?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em espera")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2 align-items-right ml-auto"},[_c('bar-grid',{attrs:{"options":_vm.handleBarGrid(item.stpedv)},on:{"action":_vm.handleAction,"view":function($event){return _vm.handleEdit(item.codpedv)}}})],1)])])})],2):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lbl mb-2",staticStyle:{"font-size":"20px"}},[_c('strong',[_vm._v("Consulta Vendas Abertas")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_comandas_vue__ = __webpack_require__(769);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_33be0061_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_comandas_vue__ = __webpack_require__(2202);
function injectStyle (ssrContext) {
  __webpack_require__(2200)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33be0061"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_comandas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_33be0061_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_comandas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2201);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("52def594", content, true, {});

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".comanda-mesa-square[data-v-33be0061]{border:1px solid;max-width:40%;text-align:center}.top-bar[data-v-33be0061]{display:flex;justify-content:space-between;align-items:center}.col-8-custom[data-v-33be0061]{width:70%}.btn-outline-custom[data-v-33be0061]:focus-within{background:#004489!important;color:#fff;border:1px solid #004489!important;box-shadow:0 0 0 0 transparent,0 0 0 0 transparent!important;border:none!important}.lista__comandas[data-v-33be0061],.lista__mesas[data-v-33be0061]{background:none;border:0;display:block;padding:0}.sidebar[data-v-33be0061]{position:fixed;top:0;left:0;bottom:0;transition:all .35s;will-change:transform;z-index:10000}.sidebar__inner[data-v-33be0061]{display:flex;flex-direction:column;background-color:#fff;overflow:hidden;height:100%;width:50vw}.sidebar__shadow[data-v-33be0061]{box-shadow:0 0 32px 0 #a9aaac80}@media (max-width:768px){.sidebar__inner[data-v-33be0061]{width:90vw}}.sidebar__footer[data-v-33be0061]{display:flex;align-items:center;background-color:#fff;padding:10px 20px;flex:0 0 78px}.sidebar__body[data-v-33be0061]{padding:0 1rem!important;overflow-y:auto;height:100%}#comanda[data-v-33be0061]{margin:.25rem 0;cursor:pointer}.btn__fechar[data-v-33be0061]{color:#5a5858;cursor:pointer}", ""]);

// exports


/***/ }),
/* 2202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleCloseSidebar()}}},[_c('div',{staticClass:"sidebar__inner sidebar__shadow px-3"},[_c('div',[_c('span',{staticClass:"btn__fechar float-right p-1 mt-1",on:{"click":_vm.handleCloseSidebar}},[_c('i',{staticClass:"fa fa-close"})])]),_vm._v(" "),_c('div',{staticClass:"sidebar__body"},[_c('div',{staticClass:"top-bar"},[_c('div',{class:_vm.params_pdv.tipo_controle_cm_ms == 'CM' ? 'col-8-custom' : 'col-12 px-0'},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"col-md-12 col-12 p-0"},[_c('div',{staticClass:"float-left"},[(_vm.modoComanda)?_c('strong',{staticStyle:{"font-size":"12px"}},[_vm._v("Buscar Comanda")]):_c('strong',{staticStyle:{"font-size":"12px"}},[_vm._v("Buscar Mesa")])]),_vm._v(" "),_c('div',{staticClass:"float-right"},[(_vm.params_pdv.tipo_controle_cm_ms == 'MC')?_c('input-checkbox',{attrs:{"label":'Buscar por comanda',"value-checked":true,"value-unchecked":false},model:{value:(_vm.modoComanda),callback:function ($$v) {_vm.modoComanda=$$v},expression:"modoComanda"}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","z-index":"10","background-color":"white"}},[_c('div',{staticClass:"col-md-12 col-12 p-0"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.codigo),expression:"codigo"}],ref:"pesquisacomanda",staticClass:"col-12 vd-input px-2 py-1",staticStyle:{"font-size":"17px"},attrs:{"id":"searchComanda","type":"text","autocomplete":"off","placeholder":_vm.pesquisacomandaPlaceholder},domProps:{"value":(_vm.codigo)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==120){ return null; }$event.stopPropagation();_vm.modoComanda = !_vm.modoComanda},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return (function () { return _vm.modoComanda ? _vm.handleChosePedido() : _vm.handleChose(); }).apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.codigo=$event.target.value}}})]),_vm._v(" "),(_vm.params_pdv.tipo_controle_cm_ms == 'MC')?_c('div',[(_vm.modoComanda)?_c('span',{staticClass:"text-secondary",staticStyle:{"font-size":"12px"}},[_vm._v("F9 - Alterar para mesa")]):_c('span',{staticClass:"text-secondary",staticStyle:{"font-size":"12px"}},[_vm._v("F9 - Alterar para comanda")])]):_vm._e(),_vm._v(" "),(_vm.params_pdv.tipo_controle_cm_ms == 'CM')?_c('span',{staticClass:"text-secondary",staticStyle:{"font-size":"12px"}},[_vm._v("ALT + N - Novo Pedido")]):_vm._e()])])]),_vm._v(" "),_c('div',{},[(_vm.params_pdv.tipo_controle_cm_ms == 'CM')?_c('button',{ref:"newPed",staticClass:"btn py-1",class:_vm.params_pdv.tipo_controle_cm_ms == 'MC' ? 'mt-0' : 'mt-3',style:(("background: " + (_vm.params_pdv.colors.bg_top_bottom ? _vm.params_pdv.colors.bg_top_bottom : '#174b79') + "; color: " + (_vm.params_pdv.colors.fc_top_bottom ? _vm.params_pdv.colors.fc_top_bottom : 'white;') + "; padding: 0 35px")),on:{"click":function($event){$event.stopPropagation();return _vm.handleSetNewSale()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Novo Pedido\n                        ")]):_vm._e()])]),_vm._v(" "),(_vm.modoComanda)?_c('div',{staticClass:"mt-2 col-md-12 row"},_vm._l((_vm.comandas),function(comanda,index){return (comanda.comanda)?_c('button',{key:index,staticClass:"p-0 my-1 col-md-10 mr-3",staticStyle:{"border":"2px solid black","max-width":"180px","background":"transparent"},on:{"click":function($event){return _vm.handleChosePedido(comanda.codpedv)}}},[_c('div',{staticClass:"px-2 py-2 text-left d-flex flex-column relative",staticStyle:{"border-bottom":"2px solid black"}},[(comanda.mesa)?_c('div',{staticClass:"comanda-mesa-square"},[_c('i',{staticClass:"fa fa-table mr-1"}),_c('span',{staticStyle:{"word-break":"break-all"}},[_vm._v(_vm._s(comanda.mesa))])]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"def-title text-center text-dark fa fa-solid fa-barcode",staticStyle:{"font-size":"50px"}}),_vm._v(" "),_c('strong',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("formatDataHora")(comanda.data)))])]),_vm._v(" "),_c('div',{staticClass:"border text-center text-danger",staticStyle:{"max-height":"68px","max-width":"200px"}},[_c('strong',{staticStyle:{"min-height":"68px","font-size":"30px"}},[_vm._v(_vm._s(comanda.comanda))])])]):_vm._e()}),0):_vm._e(),_vm._v(" "),(!_vm.modoComanda && !_vm.codigo)?_c('div',{staticClass:"row mt-2"},_vm._l((_vm.listMesas),function(mesa,index){return _c('div',{key:index,staticClass:"col-md-4 col-5 text-left my-1",staticStyle:{"padding":"0 15px !important"}},[_c('button',{staticClass:"d-flex flex-column text-left lista__mesas border border-secondary p-3 col-12",staticStyle:{"min-height":"110px"},style:(mesa.pedidos.length > 0 ? 'background: #ededed !important': ''),attrs:{"id":"mesa"},on:{"click":function($event){return _vm.handleChose(mesa.id)}}},[_c('div',{staticClass:"d-flex justify-content-between w-100"},[_c('strong',{staticClass:"col-12 row"},[_vm._v(_vm._s(mesa.id)+" | "+_vm._s(mesa.descricao))]),_vm._v(" "),(!_vm.modoComanda && !_vm.codigo)?_c('span',{staticClass:"translate-middle d-flex justify-content-center bg-success border rounded-circle badge-mesa-st",class:mesa.pedidos.length ? 'bg-danger' : '',staticStyle:{"z-index":"9999"}}):_vm._e()]),_vm._v(" "),_c('small',[_vm._v("Obs: "+_vm._s(mesa.obs))]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[(mesa.pedidos.length > 0)?_c('small',[_c('strong',[_vm._v("Pedidos")]),_vm._v(" "+_vm._s(mesa.pedidos.length))]):_vm._e(),_vm._v(" "),(mesa.pedidos.length > 0)?_c('small',{staticClass:"ml-2"},[_c('strong',[_vm._v(_vm._s(_vm._f("formatDataHora")(_vm.listMesas[index].pedidos[0].data)))])]):_vm._e()])])])}),0):_vm._e(),_vm._v(" "),_vm._l((_vm.mesas),function(mesa,indice){return (_vm.showDetails && !_vm.modoComanda)?_c('div',{key:indice,staticClass:"lista__mesas mt-2 cursor-pointer col-md-12 text-left border border-secondary"},[_c('div',{staticClass:"row px-3 py-2 px-0",attrs:{"id":"mesa"}},[_c('div',{staticClass:"col-md-10 col-5"},[_c('div',{staticStyle:{"word-break":"break-all"}},[_c('strong',[_vm._v("Código: "+_vm._s(mesa.id))]),_vm._v(" |\n                                "),_c('strong',[_vm._v(_vm._s(mesa.descricao))])]),_vm._v(" "),_c('div',[_c('small',[_vm._v("Pedidos Abertos: "+_vm._s(mesa.pedidos.length))]),_vm._v(" "),_c('small',[_vm._v("Observação: "+_vm._s(mesa.obs))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-auto col-3 p-0"},[(mesa.pedidos.length > 0)?_c('div',{staticClass:"d-flex align-items-center border border-dark p-2"},[_c('strong',[_vm._v("Ocupado")]),_vm._v(" "),_c('span',{staticClass:"bg-danger border border-light rounded-circle badge-mesa-st ml-1",staticStyle:{"width":"10px","height":"10px"}})]):_c('div',{staticClass:"d-flex align-items-center border border-dark p-2"},[_c('strong',[_vm._v("Liberado")]),_vm._v(" "),_c('span',{staticClass:"bg-success border border-light rounded-circle badge-mesa-st ml-1",staticStyle:{"width":"10px","height":"10px"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 d-flex flex-wrap align-items-center",staticStyle:{"word-break":"break-all"}},[_vm._l((mesa.pedidos),function(ped,index){return (ped.stpedv != 'C' || ped.stpedv != 'F')?_c('button',{key:index,ref:("ped" + index),refInFor:true,staticClass:"btn px-3 btn-outline-custom border col-md-auto mx-1 my-1 align-items-center",staticStyle:{"line-height":"18px !important","background":"#fff"},attrs:{"id":("ped" + index)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return _vm.handleLeft(index)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }return _vm.handleRight(index, mesa.id)}],"click":function($event){return _vm.handleChosePedido(ped.codpedv)}}},[_c('div',{staticClass:"d-flex align-items-center p-0 m-0"},[_c('span',{staticClass:"bg-success d-flex border border-light rounded-circle badge-mesa-st",staticStyle:{"width":"10px","height":"10px"}}),_vm._v(" "),(!ped.comanda)?_c('span',{staticClass:"mx-1"},[_vm._v(_vm._s(ped.npedido))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"font-size:13px"},[(ped.comanda)?_c('span',[_c('strong',{staticClass:"text-danger ml-1"},[_vm._v("COMANDA: ")]),_vm._v(_vm._s(ped.comanda))]):_c('span',[_vm._v(_vm._s(ped.obspedido))]),_vm._v(" "),_c('strong',{staticClass:"ml-1"},[_vm._v(" R$ "+_vm._s(_vm._f("formatValue")(ped.totmer,2)))])])]),_vm._v(" "),_c('div',{staticClass:"p-0 m-0 text-left mt-0 pt-0",staticStyle:{"margin-left":"20px!important"}},[_c('small',{staticStyle:{"font-size":"13px"}},[_c('strong',[_vm._v("Data: ")]),_vm._v(_vm._s(_vm._f("formatDataHora")(ped.data)))])])]):_vm._e()}),_vm._v(" "),((_vm.codigo && _vm.listMesas && _vm.codigo <= _vm.listMesas.length) || _vm.params_pdv.tipo_controle_cm_ms == 'CM' )?_c('button',{ref:"newPed",refInFor:true,staticClass:"btn py-1",class:_vm.params_pdv.tipo_controle_cm_ms == 'MC' ? 'mt-0' : 'mt-3',style:(("background: " + (_vm.params_pdv.colors.bg_top_bottom) + "; color: " + (_vm.params_pdv.colors.fc_buttom) + "; padding: 0 35px; max-height:40px")),on:{"click":function($event){$event.stopPropagation();return _vm.handleSetNewSale()},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return _vm.handleLeftNewPed()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Novo Pedido\n                            ")]):_vm._e(),_vm._v(" "),(mesa.totmesa)?_c('div',{staticClass:"text-right w-100"},[_c('strong',{staticClass:"mr-1",staticStyle:{"font-size":"20px"}},[_vm._v("TOTAL R$ "+_vm._s(_vm._f("formatValue")(mesa.totmesa,2)))])]):_vm._e()],2)])]):_vm._e()}),_vm._v(" "),(_vm.mesas)?_c('div',[(_vm.mesas.length <= 0 && !_vm.modoComanda && _vm.codigo)?_c('div',{},[_c('alert',{attrs:{"type":"warning text-dark","text":"Mesa não cadastrada"}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.comandas && _vm.modoComanda)?_c('div',[(_vm.comandas.length <=0 || _vm.comandas.length <=0)?_c('div',{},[_c('alert',{attrs:{"type":"warning text-dark","text":"Não possui registros"}}),_vm._v(" "),_c('span')],1):_vm._e()]):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_produtos_destaques_vue__ = __webpack_require__(770);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fecf23a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_produtos_destaques_vue__ = __webpack_require__(2206);
function injectStyle (ssrContext) {
  __webpack_require__(2204)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_produtos_destaques_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fecf23a_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_produtos_destaques_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2205);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3b91873d", content, true, {});

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".produtos-destaques{position:fixed;top:0;left:0;bottom:0;transition:all .35s;will-change:transform;z-index:10000}.destaques-inner{background-color:#fff;overflow:hidden;height:100%;width:50vw}.destaques-shadow{box-shadow:0 0 32px 0 #a9aaac80}#destaques-close,#returnDestaques{padding:.5rem;font-size:1.1rem;color:#7f808380;cursor:pointer}.returnDestaques{color:#55565880;font-size:.85rem;font-weight:700;text-transform:uppercase;cursor:pointer}.card{padding:.25rem;border:none!important}.card-content{border-radius:5px;border:1px solid #c3c3c3;cursor:pointer}.card-body{padding:.85rem .5rem!important}.card-body span{font-size:.75rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.card-img{border-radius:5px}.card-img i{color:#c3c3c3;font-size:3rem}.nb-modal-scrollable-container{width:80%;margin:auto;border:1px solid #c3c3c3;border-radius:7px}.nb-modal-header{border:none!important}.modal-container{width:50%;margin:auto}.card-img-top{height:8rem}.card-img{min-height:8rem}.badge{display:flex;justify-content:center;align-items:center;position:absolute;top:10px;right:10px;color:#fff;width:20px;height:20px;background-color:#265074}.product-img{width:100%;height:15rem}.product-img i{color:#c3c3c3;font-size:5rem}.product-details{color:#343a40}.product-details strong{color:#636262;font-size:1.5rem}.product-qty input{font-weight:600;width:3rem;margin:0;padding:0 .5rem}.product-qty button,.product-qty input{outline:none;font-size:1.1rem;border:1px solid #aca9a9}.product-qty button{color:#fff;width:2.5rem;height:2.5rem;font-weight:700;background-color:#aca9a9}.actions .btn{color:#fff;font-size:1.1rem;font-weight:500;padding:.25rem 1.5rem;margin:0 .25rem;background-color:#265074}.actions .btn-danger{color:#fff;background-color:#dc3545}@media only screen and (max-width:990px){.destaques-inner{width:100%;margin:auto}}", ""]);

// exports


/***/ }),
/* 2206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"produtos-destaques"},[_c('div',{staticClass:"destaques-inner destaques-shadow p-3"},[(_vm.showDestaques)?_c('div',{staticClass:"row px-4"},[_c('div',{staticClass:"col-12"},[_c('i',{staticClass:"fa fa-close float-right mr-n3",attrs:{"id":"destaques-close"},on:{"click":_vm.handleClose}})]),_vm._v(" "),_c('div',{staticClass:"input-group mb-2"},[_c('strong',{staticStyle:{"font-size":"12px"}},[_vm._v("Buscar Destaque")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroDestaque),expression:"numeroDestaque"}],ref:"pesquisaDestaque",staticClass:"col-12 vd-input px-2 py-1",staticStyle:{"font-size":"17px"},attrs:{"id":"search","type":"text","autocomplete":"off"},domProps:{"value":(_vm.numeroDestaque)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.numeroDestaque ? _vm.showItemsDestaque(_vm.destaques[0].coddestaq): ''},"input":function($event){if($event.target.composing){ return; }_vm.numeroDestaque=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.destaques),function(destaque,i){return _c('div',{key:i,staticClass:"card col-md-3",staticStyle:{"width":"8rem"}},[_c('div',{staticClass:"card-content",on:{"click":function($event){return _vm.showItemsDestaque(destaque.coddestaq)}}},[(destaque.url)?_c('img',{staticClass:"card-img-top",attrs:{"src":destaque.url,"alt":"Product Image"}}):_vm._e(),_vm._v(" "),(!destaque.url)?_c('div',{staticClass:"card-img d-flex justify-content-center align-items-center bg-light p-4"},[_c('i',{staticClass:"fa fa-camera"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body d-flex align-items-center",staticStyle:{"word-break":"break-all"}},[_c('span',{staticClass:"mr-1",staticStyle:{"font-size":"18px"}},[_c('strong',{staticClass:"text-dark"},[_vm._v("#"+_vm._s(destaque.coddestaq))])]),_c('span',{staticStyle:{"font-size":"13px"}},[_vm._v(_vm._s(destaque.descricao))])])])])})],2):_vm._e(),_vm._v(" "),(_vm.showItems)?_c('div',{staticClass:"row px-4"},[_c('div',{staticClass:"col-12"},[_c('span',{on:{"click":_vm.handleReturnDestaques}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"id":"returnDestaques"}}),_vm._v(" "),_c('span',{staticClass:"returnDestaques"},[_vm._v("Voltar")])]),_vm._v(" "),_c('i',{staticClass:"fa fa-close float-right mr-n3",attrs:{"id":"destaques-close"},on:{"click":_vm.handleClose}})]),_vm._v(" "),_vm._l((_vm.products),function(product,i){return _c('button',{key:i,staticClass:"border p-0 col-md-3 mr-2 my-1",staticStyle:{"width":"8rem","background":"white"},attrs:{"id":("id" + i)},on:{"click":function($event){return _vm.showModalDetalhes(product)},"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }return _vm.handleRight(i)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return _vm.handleLeft(i)}]}},[_c('div',{staticClass:"card-content",attrs:{"id":("id" + i)}},[(product.url)?_c('img',{staticClass:"card-img-top",attrs:{"src":product.url,"alt":"Product Image","id":("id" + i)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"badge",attrs:{"id":("id" + i)}},[_vm._v(_vm._s(product.qty))]),_vm._v(" "),(!product.url)?_c('div',{staticClass:"card-img d-flex justify-content-center align-items-center bg-light p-4",attrs:{"id":("id" + i)}},[_c('i',{staticClass:"fa fa-camera"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body d-flex flex-column",attrs:{"id":("id" + i)}},[_c('span',{attrs:{"id":("id" + i)}},[_vm._v(_vm._s(product.descricao))]),_vm._v(" "),_c('strong',{attrs:{"id":("id" + i)}},[_vm._v("R$"+_vm._s(_vm._f("formatValue")(product.vlrtab)))])])])])})],2):_vm._e()]),_vm._v(" "),(_vm.showModal)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-scrollable-body mt-3"},[_c('div',{staticClass:"modal-container"},[(_vm.product.url)?_c('div',{staticClass:"product-img d-flex justify-content-center"},[_c('img',{attrs:{"src":_vm.product.url,"alt":"Product Image"}})]):_vm._e(),_vm._v(" "),(!_vm.product.url)?_c('div',{staticClass:"product-img d-flex justify-content-center align-items-center bg-light p-4"},[_c('i',{staticClass:"fa fa-camera"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"product-details d-flex flex-column text-center mt-3"},[(_vm.product)?_c('strong',[_vm._v("R$"+_vm._s(_vm._f("formatValue")(_vm.product.vlrtab)))]):_vm._e(),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.product.descricao))])]),_vm._v(" "),_c('div',{staticClass:"product-qty d-flex justify-content-center mt-2"},[_c('button',{staticClass:"qty-control",on:{"click":_vm.subtract}},[_c('i',{staticClass:"fa fa-minus"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.productQty),expression:"productQty"}],attrs:{"type":"number","id":"quantidadedest"},domProps:{"value":(_vm.productQty)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleEnter()},"input":function($event){if($event.target.composing){ return; }_vm.productQty=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"qty-control",on:{"click":function($event){_vm.productQty++}}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center ml-2"},[_c('strong',[_vm._v(_vm._s(_vm.product.uni))])])]),_vm._v(" "),_c('div',{staticClass:"product-obs mt-3"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("Observações")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.obs),expression:"product.obs"}],ref:"destaqueobs",staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.product.obs)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleEnterObs()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "obs", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"actions d-flex justify-content-center mt-4 mb-5"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.showCloseDetalhes}},[_vm._v("Cancelar")]),_vm._v(" "),_c('button',{ref:"btnAdic",staticClass:"btn",on:{"click":function($event){return _vm.handleAdicionar(_vm.product, _vm.productQty)}}},[_vm._v("Adicionar")])])])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_quantidade_item_vue__ = __webpack_require__(771);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_34167236_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_quantidade_item_vue__ = __webpack_require__(2210);
function injectStyle (ssrContext) {
  __webpack_require__(2208)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_quantidade_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_34167236_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_quantidade_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2209);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4af12282", content, true, {});

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeModal()}}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header",style:(("background:" + (_vm.params_pdv.colors.bg_top_bottom ? _vm.params_pdv.colors.bg_top_bottom : '#174b79') + "!important;"))},[_c('h4',{staticClass:"def-title",style:(("color:" + (_vm.params_pdv.colors.fc_top_bottom ? _vm.params_pdv.colors.fc_top_bottom : 'white;') + "!important")),attrs:{"id":"exampleModalLabel"}},[_vm._v("\n                    Informar Quantidade\n                ")]),_vm._v(" "),_c('button',{staticClass:"close",style:(("color:" + (_vm.params_pdv.colors.fc_top_bottom ? _vm.params_pdv.colors.fc_top_bottom : 'white;') + "!important")),on:{"click":function($event){return _vm.closeModal()}}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body pt-3 d-flex justify-content-center",staticStyle:{"height":"180px!important","max-height":"100%","overflow-y":"auto"}},[_c('div',{staticClass:"border d-flex justify-content-center align-items-center col-12",staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"row col-5"},[_c('small',{staticClass:"lbl-edit"},[_vm._v("Quantidade")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.quantidade),expression:"quantidade",modifiers:{"number":true}}],ref:"qtd",staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.quantidade)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.changeToNextEl()},"input":function($event){if($event.target.composing){ return; }_vm.quantidade=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"danger":"","label":"Cancelar"},on:{"click":function($event){return _vm.closeModal()}}}),_vm._v(" "),_c('v-button',{ref:"qtdConfirmButton",attrs:{"nbBtdef":"","label":"Confirmar"},on:{"click":function($event){return _vm.handleConfirmQtd()}}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_obs_vue__ = __webpack_require__(772);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0be586ee_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_obs_vue__ = __webpack_require__(2214);
function injectStyle (ssrContext) {
  __webpack_require__(2212)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_obs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_0be586ee_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_obs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2213);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4777250e", content, true, {});

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeModal()}}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header",style:(("background:" + (_vm.params_pdv.colors.bg_top_bottom ? _vm.params_pdv.colors.bg_top_bottom : '#174b79') + "!important;"))},[_c('h4',{staticClass:"def-title",style:(("color:" + (_vm.params_pdv.colors.fc_top_bottom ? _vm.params_pdv.colors.fc_top_bottom : 'white;') + "!important")),attrs:{"id":"exampleModalLabel"}},[_vm._v("\n                    Informar Observação do Pedido\n                ")]),_vm._v(" "),(_vm.pedv)?_c('span',{staticClass:"mr-2 border p-1 ml-3",style:(("color:" + (_vm.params_pdv.colors.fc_top_bottom ? _vm.params_pdv.colors.fc_top_bottom : 'white;') + "!important"))},[_c('i',{staticClass:"fa fa-table mr-1"}),_vm._v(_vm._s(_vm.pedv.mesa)+"\n                ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"close",style:(("color:" + (_vm.params_pdv.colors.fc_top_bottom ? _vm.params_pdv.colors.fc_top_bottom : 'white;') + "!important")),on:{"click":function($event){return _vm.closeModal()}}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body pt-3 d-flex justify-content-center",staticStyle:{"height":"180px!important","max-height":"100%","overflow-y":"auto"}},[_c('div',{staticClass:"border d-flex justify-content-center align-items-center col-12",staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"row col-5"},[_c('small',{staticClass:"lbl-edit"},[_vm._v("Observação")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.obs),expression:"obs"}],ref:"obs",staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.obs)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.changeToNextEl()},"input":function($event){if($event.target.composing){ return; }_vm.obs=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"danger":"","label":"Cancelar"},on:{"click":function($event){return _vm.closeModal()}}}),_vm._v(" "),_c('v-button',{ref:"obsConfirmButton",attrs:{"nbBtdef":"","label":"Confirmar"},on:{"click":function($event){return _vm.handleConfirmObs()}}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_caixa_vue__ = __webpack_require__(773);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_eab9c134_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_caixa_vue__ = __webpack_require__(2218);
function injectStyle (ssrContext) {
  __webpack_require__(2216)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eab9c134"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_caixa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_eab9c134_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_caixa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2217);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7dc3ed1e", content, true, {});

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".mainbox[data-v-eab9c134]{overflow:visible}.main-content[data-v-eab9c134]{overflow-y:hidden}.box[data-v-eab9c134]{float:none}", ""]);

// exports


/***/ }),
/* 2218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1 !important"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeModal.apply(null, arguments)}}},[_c('Trap',[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-xl",staticStyle:{"width":"120vh!important","overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body pt-3",staticStyle:{"height":"90vh!important","max-height":"100%","overflow-y":"auto"}},[_c('div',{staticClass:"lbl mb-2",staticStyle:{"font-size":"20px"}},[_c('strong',[_vm._v("Fechamento do Caixa")])]),_vm._v(" "),_c('button',{staticClass:"close",on:{"click":_vm.closeModal}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"main-content"},[_c('fechar-caixa',{attrs:{"index":_vm.caixa,"modal":true},on:{"closeform":_vm.handleRetorna}})],1)])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_pendcli_vue__ = __webpack_require__(774);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1edaafbe_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_pendcli_vue__ = __webpack_require__(2222);
function injectStyle (ssrContext) {
  __webpack_require__(2220)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_modal_pendcli_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1edaafbe_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_modal_pendcli_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2221);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2af55d1f", content, true, {});

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1 !important"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"max-width":"90%","width":"90% !important","overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body pt-3",staticStyle:{"height":"80vh!important","max-height":"100%","overflow-y":"auto"}},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"close",on:{"click":_vm.closeModal}},[_c('span',[_vm._v("×")])]),_vm._v(" "),(_vm.show)?_c('div',[_c('ConsultaVarejoPendcli',{attrs:{"codvabertura":this.codvabertura}})],1):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lbl mb-2",staticStyle:{"font-size":"20px"}},[_c('strong',[_vm._v("Controle Pendencias Cliente")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"varejoform"},[_c('div',{staticClass:"nb-modal-varejo"},[_c('div',{staticClass:"header"},[_c('varejo-bar-top',{attrs:{"pedv":_vm.pedv,"params_msg":_vm.params_pdv.default_header_title,"params_colors":_vm.params_pdv.colors,"showBtnConfig":!_vm.showPagamentoVenda,"config":_vm.showModalMaisAcoes,"caixa":_vm.caixa},on:{"action":_vm.getAction,"logout":_vm.handleClosePDV,"config":_vm.handleConfig}})],1),_vm._v(" "),_c('div',{staticClass:"ml-md-auto mt-2"}),_vm._v(" "),_c('div',{staticClass:"mx-2"},[(_vm.pedv && _vm.pedv.nf && _vm.pedv.nf.xmotivo && _vm.pedv.nf.stnf != '10')?_c('div',{staticClass:"col-6 error"},[_vm._v("\n          "+_vm._s(_vm.pedv.nf.xmotivo)+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center",staticStyle:{"gap":"20px"}},[(!_vm.showPagamentoVenda)?_c('div',{staticClass:"d-flex flex-row col-md-6 col-12 pr-0",staticStyle:{"height":"83vh","max-height":"100%","overflow-y":"hidden","overflow-x":"hidden"}},[_c('div',{staticClass:"d-flex flex-column align-items-center justify-content-start mt-0 p-0 px-3"},[_c('div',{staticClass:"mt-0 align-self-center mb-2"},[_c('varejo-add-item',{ref:"item",attrs:{"add-button":true,"tabela-preco":this.params_pdv.tabela_preco,"balanca":_vm.params_pdv.balanca,"showQt":_vm.informed_qt,"newQt":_vm.qtdItemInformada},on:{"defineQt":_vm.handleQtd,"onselect":_vm.handleTypeofSell,"setView":function($event){return _vm.showModalViewItem($event)}},model:{value:(_vm.coditem),callback:function ($$v) {_vm.coditem=$$v},expression:"coditem"}})],1),_vm._v(" "),(this.vendaManual)?_c('div',{staticClass:"d-flex w-100 mb-3",staticStyle:{"gap":"20px","margin-top":"-15px"}},[_c('div',{staticClass:"input-group d-flex flex-column align-items-start",staticStyle:{"width":"40%"}},[_c('small',[_vm._v("Quantidade")]),_vm._v(" "),_c('input-value',{ref:"qtdItemInformada",staticClass:"vd-input px-3 py-2 vend-inputs",staticStyle:{"width":"100%","font-size":"17px!important","padding":"11px","border-radius":"5px","border":"1px solid #C9D3DD"},attrs:{"precision":3},model:{value:(_vm.qtdItemInformada),callback:function ($$v) {_vm.qtdItemInformada=$$v},expression:"qtdItemInformada"}})],1),_vm._v(" "),_c('div',{staticClass:"input-group d-flex flex-column align-items-start",staticStyle:{"width":"60%"}},[_c('small',{},[_vm._v("Valor Unitário (R$)")]),_vm._v(" "),_c('input-value',{ref:"vlrItemInformado",staticClass:"vd-input px-3 py-2 vend-inputs",staticStyle:{"width":"100%","font-size":"17px!important","padding":"11px","border-radius":"5px","border":"1px solid #C9D3DD"},attrs:{"precision":2},model:{value:(_vm.vlrItemInformado),callback:function ($$v) {_vm.vlrItemInformado=$$v},expression:"vlrItemInformado"}})],1)]):_vm._e(),_vm._v(" "),(this.item_waiting)?_c('button',{staticClass:"mb-2 btn btn-block font-weight-bold",style:(((_vm.hasBgConfirmconfig()) + "; font-size: 15px")),on:{"click":function($event){return _vm.handleNewItem(_vm.selectedItem)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleNewItem(_vm.selectedItem)}}},[_c('span',[_vm._v("INCLUIR (ENTER)")])]):_vm._e(),_vm._v(" "),(_vm.showViewItem)?_c('div',{staticClass:"w-100 mb-2",staticStyle:{"z-index":"-1"}},[_c('div',{staticClass:"shadow w-100 img-size img-size-big"},[_c('div',{staticClass:"row p-2 mt-2 mb-3"},[_c('div',{staticClass:"col-md-10"},[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.itemView.descricao))]),_vm._v(" Código "+_vm._s(_vm.itemView.coditem))])]),_vm._v(" "),_c('div',{staticClass:"col-md-auto ml-auto"},[_c('span',[_c('strong',[_vm._v("R$ "+_vm._s(_vm._f("formatValue")((_vm.itemView.vlrtab * _vm.itemView.quantidade),2)))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12 text-center align-self-center mt-auto",staticStyle:{"overflow":"hidden"}},[(!this.itemView.url)?_c('i',{staticClass:"fa fa-camera py-auto",staticStyle:{"font-size":"150px","opacity":"30%"}}):_c('img',{staticClass:"item-img",staticStyle:{"min-height":"200px","max-height":"300px"},attrs:{"src":_vm.itemView.url,"alt":""}})])])])]):_vm._e()]),_vm._v(" "),(_vm.showSidebar)?_c('sidebar-comandas',{attrs:{"params_pdv":_vm.params_pdv,"listComandas":_vm.listaComandas,"listMesas":_vm.listMesas},on:{"newSale":function($event){_vm.handleShowMesaComanda($event), (_vm.codmesa = $event)},"close":_vm.handleCloseComandas,"chosePedidoMesa":function($event){_vm.handleCloseComandas();
_vm.handleResult($event, 'OK');},"selectedmesa":function($event){return _vm.handleShowModalMesa($event)}}}):_vm._e(),_vm._v(" "),(_vm.showModalComanda)?_c('div',{staticClass:"to-front modal nb-modal-mask",staticStyle:{"display":"block"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header",style:(("" + (_vm.hasBgconfig(true))))},[_c('span',{staticClass:"text-light mr-2",staticStyle:{"font-size":"15px"}},[_c('h4',{staticClass:"def-title",style:(("color:" + (_vm.params_pdv.colors.fc_top_bottom) + " !important"))},[_vm._v("\n                        Informe a Comanda\n                      ")])]),_vm._v(" "),_c('button',{ref:"mesaclose",staticClass:"close",style:(("color:" + (_vm.params_pdv.colors.fc_top_bottom) + " !important")),attrs:{"type":"button","data-dimiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.handleCloseModalComanda()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex justify-content-center"},[_c('div',{staticClass:"my-2"},[_c('div',{staticStyle:{"border":"3px solid black"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"border",staticStyle:{"min-height":"70px","max-width":"240px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.codcomanda),expression:"codcomanda"}],ref:"comandaid",staticClass:"form-control border-0",staticStyle:{"min-height":"68px","font-size":"35px"},attrs:{"type":"number","required":true},domProps:{"value":(_vm.codcomanda)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.handleInformaComanda()},"input":function($event){if($event.target.composing){ return; }_vm.codcomanda=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"danger":"","label":"Cancelar"},on:{"click":function($event){$event.preventDefault();return _vm.handleCloseModalComanda()}}}),_vm._v(" "),_c('v-button',{attrs:{"nbBtdef":"","label":"Confirmar"},on:{"click":function($event){return _vm.handleInformaComanda()}}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.showModalMesa)?_c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header",style:(("" + (_vm.hasBgconfig(true))))},[_c('span',{staticClass:"text-light mr-2",staticStyle:{"font-size":"15px"}},[_c('h4',{staticClass:"def-title",style:(("color:" + (_vm.params_pdv.colors.fc_top_bottom) + " !important"))},[_vm._v("\n                        Informe a Mesa\n                      ")])]),_vm._v(" "),_c('button',{ref:"mesaclose",staticClass:"close",style:(("color:" + (_vm.params_pdv.colors.fc_top_bottom) + " !important")),attrs:{"type":"button","data-dimiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.handleCloseModalMesa()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-12 row mb-2"},[_c('div',{staticClass:"col-12 mr-5"},[_c('span',{staticClass:"lbl-edit"},[_vm._v("Código da Mesa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.codmesa),expression:"codmesa"}],ref:"inputmesa",staticClass:"col-md-4 col-12 form-control",staticStyle:{"font-size":"15px"},attrs:{"id":"search","type":"text","autocomplete":"off","placeholder":"Digite a mesa"},domProps:{"value":(_vm.codmesa)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleChangeMesa()},"input":function($event){if($event.target.composing){ return; }_vm.codmesa=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row col-12"},_vm._l((_vm.listMesas),function(mesa,index){return _c('div',{key:index,staticClass:"col-md-4 col-5 text-left my-1",staticStyle:{"padding":"0 15px !important"}},[_c('button',{staticClass:"d-flex flex-column text-left lista__mesas border border-secondary p-3 col-12",class:mesa.id == _vm.codmesa ? 'border-danger' : '',staticStyle:{"border-radius":"3px!important","min-height":"110px"},style:(mesa.pedidos.length > 0
                            ? 'background: #ededed !important'
                            : ''),attrs:{"id":"mesa"},on:{"click":function($event){return _vm.handleChangeMesa(index)}}},[_c('strong',[_vm._v(_vm._s(mesa.id)+" | "+_vm._s(mesa.descricao))]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"translate-middle d-flex justify-content-center bg-success border rounded-circle badge-mesa-st",class:mesa.pedidos.length > 0 ? 'bg-danger' : '',staticStyle:{"top":"-10px","z-index":"9999","right":"5px"}}),_vm._v(" "),_c('span',{class:mesa.pedidos.length > 0
                              ? 'text-danger ml-2'
                              : 'text-success ml-2'},[_vm._v(_vm._s(mesa.pedidos.length > 0 ? "Ocupada" : "Vaga"))])]),_vm._v(" "),_c('small',[_vm._v("Obs: "+_vm._s(mesa.obs))]),_vm._v(" "),(mesa.pedidos.length > 0)?_c('small',[_c('strong',[_vm._v("Pedidos")]),_vm._v("\n                            "+_vm._s(mesa.pedidos.length))]):_vm._e(),_vm._v(" "),(mesa.showObs)?_c('div',[(_vm.hasMesaControl)?_c('div',[_c('span',{staticClass:"lbl-edit mt-2 p-0"},[_vm._v("Observação")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mesaobs),expression:"mesaobs"}],ref:"mesaobs",refInFor:true,staticClass:"form-control",staticStyle:{"font-size":"12px"},attrs:{"type":"text","id":("mesaobs" + (mesa.id))},domProps:{"value":(_vm.mesaobs)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$refs.confirmMesaBtn.focus()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.stopPropagation();return _vm.handleCancelInput(index)}],"input":function($event){if($event.target.composing){ return; }_vm.mesaobs=$event.target.value}}})]):_vm._e()]):_vm._e()])])}),0)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('v-button',{attrs:{"danger":"","label":"Cancelar"},on:{"click":function($event){return _vm.handleCloseModalMesa()}}}),_vm._v(" "),_c('v-button',{ref:"confirmMesaBtn",attrs:{"nbBtdef":"","label":"Confirmar"},on:{"click":function($event){return _vm.handleInformaMesa()}}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.item_editing)?_c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleCancelEditItem(_vm.pedvit_index)}}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body",staticStyle:{"max-height":"100%","overflow-y":"auto"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_vm._m(1),_vm._v(" "),_c('button',{ref:"ediitemclose",staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.handleCancelEditItem(_vm.pedvit_index)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('span',{staticClass:"lbl-deal mb-3"},[_c('span',{staticClass:"ml-3 mr-1"},[_vm._v(_vm._s(_vm.pedvit[_vm.pedvit_index].item[0].codigo))]),_vm._v(_vm._s(_vm.pedvit[_vm.pedvit_index].item[0].descricao))]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap"},[_c('form-field',{ref:"quantidade",attrs:{"type":"value","col":"4","metadata":_vm.metadata.pedvit.qtuni},on:{"change":_vm.handleItem},model:{value:(_vm.pedvit[_vm.pedvit_index].qtuni),callback:function ($$v) {_vm.$set(_vm.pedvit[_vm.pedvit_index], "qtuni", $$v)},expression:"pedvit[pedvit_index].qtuni"}}),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.alterapreco != 'N')?_c('form-field',{attrs:{"type":"value","col":"4","metadata":_vm.metadata.pedvit.vlr},model:{value:(_vm.pedvit[_vm.pedvit_index].vlr),callback:function ($$v) {_vm.$set(_vm.pedvit[_vm.pedvit_index], "vlr", $$v)},expression:"pedvit[pedvit_index].vlr"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.params_pdv.permite_desconto == 'S')?_c('form-field',{attrs:{"label":"% Desconto","type":"value","col":"4","metadata":_vm.metadata.pedvit.pdesc1},model:{value:(_vm.pedvit[_vm.pedvit_index].pdesc1),callback:function ($$v) {_vm.$set(_vm.pedvit[_vm.pedvit_index], "pdesc1", $$v)},expression:"pedvit[pedvit_index].pdesc1"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_c('form-field',{staticClass:"mr-1",attrs:{"type":"text","col":"6","metadata":_vm.metadata.pedvit.obs},model:{value:(_vm.pedvit[_vm.pedvit_index].obs),callback:function ($$v) {_vm.$set(_vm.pedvit[_vm.pedvit_index], "obs", $$v)},expression:"pedvit[pedvit_index].obs"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12 mt-4"},[_c('button',{staticClass:"btn btn-success",attrs:{"title":"Confirmar"},on:{"click":function($event){return _vm.handleEditItem(_vm.pedvit_index)}}},[_c('span',[_vm._v("Confirmar")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary ml-2",attrs:{"title":"Cancelar"},on:{"click":function($event){_vm.handleCancelEditItem(_vm.pedvit_index)()}}},[_c('span',[_vm._v("Cancelar")])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.showVendas)?_c('VarejoModalVendas',{on:{"close":_vm.handleModalVendasEspera,"selectedItem":_vm.loadVendaEspera}}):_vm._e(),_vm._v(" "),(_vm.showCaixa)?_c('VarejoModalCaixa',{attrs:{"caixa":_vm.vabertura.codvabertura,"params_pdv":_vm.params_pdv},on:{"close":_vm.handleFecharCaixa}}):_vm._e(),_vm._v(" "),(_vm.showModalPendcli)?_c('VarejoModalPendcli',{attrs:{"codvabertura":_vm.vabertura.codvabertura},on:{"close":_vm.closeModalPendcli}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.showDestaques)?_c('produtos-destaques',{attrs:{"tabela-preco":this.params_pdv.tabela_preco,"itemsList":_vm.pedvit},on:{"newItem":_vm.handleNewItem,"closeDestaques":_vm.handleCloseDestaques}}):_vm._e(),_vm._v(" "),(_vm.SHOW_CONFIRMADMINPASS)?_c('confirm-adminpass',{on:{"close":function($event){return _vm.hideConfirmAdminPass()},"confirm":function($event){return _vm.confirmAdminPass()}}}):_vm._e(),_vm._v(" "),(_vm.showModalCliente)?_c('varejo-modal-cliente',{attrs:{"deletar":_vm.deletarCliente,"selectedPart":_vm.selectedPart,"codpartVarejo":_vm.codpart,"params_pdv":_vm.params_pdv},on:{"close":function($event){return _vm.closeModalCliente()},"changeCodpart":function($event){return _vm.handleChangeCodPart($event)}}}):_vm._e(),_vm._v(" "),(_vm.showModalQtd)?_c('varejo-quantidade-item',{attrs:{"params_pdv":_vm.params_pdv},on:{"close":function($event){return _vm.closeModalQtd()},"getQtdInformada":function($event){_vm.qtdItemInformada = $event}}}):_vm._e(),_vm._v(" "),(_vm.showModalObs)?_c('varejo-modal-obs',{staticClass:"to-front",attrs:{"pedv":_vm.pedv,"params_pdv":_vm.params_pdv},on:{"close":function($event){return _vm.closeModalObs()},"getObs":function($event){return _vm.handleInformaMesa($event)}}}):_vm._e(),_vm._v(" "),(_vm.showModalAcrescimo || _vm.showModalDesconto)?_c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg",staticStyle:{"overflow-y":"initial !important"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body",staticStyle:{"overflow-y":"auto"}},[_c('div',[_vm._m(2),_vm._v(" "),(this.params_pdv.permite_desconto == 'S')?_c('div',{staticClass:"row"},[_c('form-field',{ref:"desconto",attrs:{"label":"% Desconto","type":"value","precision":2,"col":"3","addon":"%"},on:{"input":function($event){return _vm.handlePdesc(_vm.pdesc)}},model:{value:(_vm.pdesc),callback:function ($$v) {_vm.pdesc=$$v},expression:"pdesc"}}),_vm._v(" "),_c('form-field',{attrs:{"enabled":false,"label":"Valor de Desconto","type":"value","precision":2,"col":"3","preaddon":"R$"},on:{"input":function($event){return _vm.handleVlrDesc(_vm.vlrdesc)}},model:{value:(_vm.vlrdesc),callback:function ($$v) {_vm.vlrdesc=$$v},expression:"vlrdesc"}})],1):_vm._e(),_vm._v(" "),(this.params_pdv.permite_acrescimo == 'S')?_c('div',{staticClass:"row"},[_c('form-field',{ref:"acrescimo",attrs:{"label":"% Acréscimo","type":"value","precision":2,"col":"3","addon":"%"},on:{"input":function($event){return _vm.handlePdesp(_vm.pdesp)}},model:{value:(_vm.pdesp),callback:function ($$v) {_vm.pdesp=$$v},expression:"pdesp"}}),_vm._v(" "),_c('form-field',{attrs:{"enabled":false,"label":"Valor do Acréscimo","type":"value","precision":2,"col":"3","preaddon":"R$"},on:{"input":function($event){return _vm.handleVlrdesp(_vm.vlrdesp)}},model:{value:(_vm.vlrdesp),callback:function ($$v) {_vm.vlrdesp=$$v},expression:"vlrdesp"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12 mt-4"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary",on:{"click":_vm.handleDesconto}},[_c('span',[_vm._v("Confirmar")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-secondary ml-2",on:{"click":function($event){return _vm.closeModalDescontoAcrescimo()}}},[_c('span',[_vm._v("Cancelar")])])])])])])])])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{staticStyle:{"width":"50%"}},[(_vm.showPagamentoVenda)?_c('varejo-pag-form',{ref:"pagamentoVenda",attrs:{"showModalCliente":_vm.showModalCliente,"selectedPart":_vm.selectedPart,"params":_vm.paramsPagamento,"params_pdv":this.params_pdv},on:{"handleModalClientee":function($event){return _vm.handleModalCliente($event)},"showModalDesconto":function($event){return _vm.handleInformarDesconto($event)},"resultadopagamento":_vm.handleResultadoPagamento}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12 p-0 pr-3"},[_c('div',{staticClass:"nb-margin-bottom d-flex flex-column",staticStyle:{"background-color":"transparent !important","z-index":"-10","width":"100%"}},[_vm._m(3),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","min-width":"30vw","width":"100%","z-index":"-1","background-color":"white"}},[_c('div',{},[_c('div',{staticClass:"shadow d-flex justify-content-start",staticStyle:{"padding":"11px","border-radius":"5px","border":"1px solid #C9D3DD"}},[(!_vm.pedv || !_vm.pedvit || _vm.pedvit.length == 0)?_c('span',[_vm._v("Aguardando abertura de pedido. Selecione um\n                      produto ou um\n                      pedido em aberto.")]):_c('div',{staticClass:"d-flex justify-content-between",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"d-flex",staticStyle:{"gap":"20px"}},[_c('span',{},[_vm._v("Pedido Nº "),_c('span',[_vm._v(_vm._s(_vm.pedv.npedido)+" ")])]),_vm._v(" "),_c('current-date-hour')],1),_vm._v(" "),(_vm.selectedPart)?_c('span',{},[_vm._v("CNPJCPF:"),_c('strong',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(_vm.selectedPart.cnpjcpf)))])]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"mr-0 ml-0 p-0 shadow nb-margin-bottom navbar-collapse",staticStyle:{"height":"58vh","border-radius":"5px","border":"1px solid #C9D3DD","overflow-y":"scroll"}},[_c('div',{ref:"divitems",staticStyle:{"height":"100%","border-radius":"10px 10px 0 0","border":"none!important","box-shadow":"none","padding-inline":"15px","padding":"10px"}},[(!_vm.pedv || !_vm.pedvit || _vm.pedvit.length == 0)?_c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"margin-bottom":"100px","margin-top":"100px"}},[_c('div',{staticClass:"vd-text-grand w-100 text-center"},[_vm._m(4),_vm._v(" "),(_vm.filial.urlimage)?_c('div',{staticClass:"d-flex justify-content-center w-100 logo-image",style:((_vm.logoStyle + ";"))},[_c('img',{staticStyle:{"max-width":"80%"},attrs:{"src":_vm.filial.urlimage,"alt":"Logo Filial"}})]):_vm._e()])]):_vm._e(),_vm._v(" "),_vm._l((_vm.pedvit),function(it,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(it.stpedv != 'C'),expression:"it.stpedv != 'C'"}],key:index,staticClass:"mainbox m-0 overflow-y py-1"},[(it.editing === true)?_c('div',{staticClass:"mark-gray p-0 m-0",staticStyle:{"background-color":"#005ea7"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex w-100 p-0 m-0 align-items-center"},[_c('div',{staticClass:"p-1 m-0 ml-2 justify-content-center"},[_c('span',{staticClass:"lbl-title-produto decrase-lbl-title p-0 text-center"},[_vm._v(_vm._s(_vm.listSequence + index + 1))])]),_vm._v(" "),_c('div',{staticClass:"w-100 m-0 p-0"},[_c('div',{staticClass:"item-group row m-0 align-items-center"},[_c('div',{staticClass:"col-md-12 p-0 m-0 d-flex flex-column"},[_c('span',{staticClass:"lbl-title-produto text-dark decrase-lbl-title",staticStyle:{"font-weight":"500","word-break":"break-all"}},[_vm._v(_vm._s(it.item[0].descricao)+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 p-0 m-0"},[_c('span',{staticClass:"lbl decrase-lbl"},[_vm._v("Cód: "+_vm._s(it.item[0].codigo))]),_vm._v(" "),(it.obs)?_c('span',{staticClass:"lbl decrase-lbl mt-n2"},[_vm._v("Obs: "+_vm._s(it.obs))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4 p-0 m-0"},[_c('div',{staticClass:"float-right"},[_c('span',{staticClass:"lbl-title-produto text-dark text-center text-secondary",staticStyle:{"font-weight":"400","font-size":"14px"}},[_c('span',[_vm._v(_vm._s(it.qtuni))]),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(it.uni))])]),_vm._v(" "),_c('span',{staticClass:"mx-2"},[_vm._v("X")]),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto text-dark",staticStyle:{"font-weight":"500","font-size":"14px"}},[_vm._v("R$"+_vm._s(_vm._f("format")(it.vlr,2)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 p-0 m-0"},[_c('div',{staticClass:"float-right"},[_c('span',{staticClass:"lbl-title-produto text-dark",staticStyle:{"font-size":"14px","font-weight":"500","word-break":"break-all"}},[_vm._v("\n                              Total R$\n                            ")]),_vm._v(" "),_c('span',{staticClass:"lbl-title-produto text-dark",staticStyle:{"font-size":"14px","font-weight":"500","word-break":"break-all"}},[_vm._v(_vm._s(_vm._f("format")(it.totliq,2)))])]),_vm._v(" "),(it.totdes)?_c('span',{staticClass:"lbl decrase-lbl float-right"},[_vm._v("Desconto ("+_vm._s(_vm._f("format")(it.totdes,2))+")")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"justify-content-center p-0 m-0"},[(!_vm.showPagamentoVenda)?_c('div',{staticClass:"d-flex float-right"},[_c('a',{staticClass:"text-secondary cursor-pointer text-center text-secondary p-0 m-0",on:{"click":function($event){return _vm.handleButtonEditItem(index + 1)}}},[_c('i',{staticClass:"fa fa-pencil fa-fw"})]),_vm._v(" "),_c('a',{staticClass:"text-secondary ml-2 cursor-pointer text-center text-secondary p-0 m-0",on:{"click":function($event){return _vm.handleButtonDeleteItem(index + 1)}}},[_c('i',{staticClass:"fa fa-trash fa-fw"})])]):_vm._e()])])])}),_vm._v(" "),_c('div',{staticClass:"row mb-5"})],2),_vm._v(" "),(_vm.pedvit && _vm.pedvit.length > 0 && _vm.filial.urlimage)?_c('div',{staticClass:"d-flex justify-content-center w-100",style:(_vm.logoStyle)},[_c('img',{staticStyle:{"max-width":"50%"},attrs:{"src":_vm.filial.urlimage,"alt":"Logo Filial"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex row"},[_c('div',{staticClass:"col-md-12 col-12"},[(!_vm.showModalAcrescimo && _vm.pedv && _vm.pedv.vlrdesp > 0)?_c('div',{staticClass:"d-flex justify-content-between col-12 mb-1"},[_vm._m(5),_vm._v(" "),(_vm.pedv)?_c('span',{staticClass:"lbl-title-produto text-success mt-0 pt-0",staticStyle:{"font-size":"18px"}},[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.vlrdesp,2)))]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[(!_vm.showModalDesconto && _vm.pedv && _vm.pedv.totdes + _vm.pedv.vlrdesc > 0
                )?_c('div',{staticClass:"d-flex justify-content-between col-12 mb-1"},[_vm._m(6),_vm._v(" "),(_vm.pedv)?_c('strong',{staticClass:"text-wine-color mt-0 pt-0",staticStyle:{"font-size":"18px"}},[_vm._v("R$ "+_vm._s(_vm._f("format")((_vm.pedv.totdes +
                      _vm.pedv.vlrdesc),2)))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"shadow d-flex justify-content-between",style:(((_vm.hasBgconfig(true)) + "; padding: 11px;border-radius:5px; font-weight: 500; font-size: 1.25rem"))},[(!_vm.showPagamentoVenda)?_c('span',[_vm._v("Subtotal")]):_vm._e(),_vm._v(" "),(_vm.showPagamentoVenda)?_c('span',[_vm._v("Total da Venda")]):_vm._e(),_vm._v(" "),(_vm.pedv)?_c('span',[_vm._v("R$ "+_vm._s(_vm._f("format")(_vm.pedv.totger,2, true)))]):_vm._e()])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"footer-varejo d-flex col-12 justify-content-between",staticStyle:{"background-color":"white"}},[_c('div',{staticClass:"d-flex align-items-center justify-content-between px-3 shadow",style:(((_vm.hasBgconfig(true)) + "; border-top-right-radius: 5px; text-align: center; gap: 30px"))},[_c('div',{staticClass:"d-flex flex-column"},[_c('span',{staticClass:"font-weight-bold",staticStyle:{"font-size":"14px"}},[_vm._v("OPERADOR:")]),_vm._v(" "),(_vm.usuarionome)?_c('span',{staticStyle:{"text-align":"start !important","font-size":"12px"}},[_vm._v("\n              "+_vm._s(_vm.usuarionome)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column clock pt-1",staticStyle:{"text-align":"end !important"}},[_c('current-date-hour')],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"mt-1"},[_c('div',{staticClass:"d-flex justify-content-end"},[(!_vm.showPagamentoVenda)?_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"blank-button text-button",attrs:{"disabled":_vm.closeCaixa},on:{"click":function($event){_vm.showModalMaisAcoes = true}}},[_c('span',[_vm._v("(Alt + O) Opções")])]),_vm._v(" "),_c('div',{staticStyle:{"height":"full","padding":"1px","background-color":"#eeeeee"}}),_vm._v(" "),_c('button',{staticClass:"blank-button text-button",attrs:{"disabled":_vm.closeCaixa},on:{"click":function($event){return _vm.handleNovaVenda(true)}}},[_c('span',[_vm._v("(F2) Nova Venda")])]),_vm._v(" "),_c('div',{staticStyle:{"height":"full","padding":"1px","background-color":"#eeeeee"}}),_vm._v(" "),_c('button',{staticClass:"blank-button text-button",attrs:{"disabled":_vm.closeCaixa},on:{"click":function($event){return _vm.handleModalVendasEspera()}}},[_c('span',[_vm._v("(F3) Vendas Abertas")])]),_vm._v(" "),_c('div',{staticStyle:{"height":"full","padding":"1px","background-color":"#eeeeee"}}),_vm._v(" "),_c('button',{staticClass:"blank-button text-button",on:{"click":function($event){return _vm.handleModalCliente()}}},[_c('span',[_vm._v("(F4) Informar CPF")])]),_vm._v(" "),_c('div',{staticStyle:{"height":"full","padding":"1px","background-color":"#eeeeee"}}),_vm._v(" "),_c('button',{staticClass:"blank-button text-button",on:{"click":function($event){return _vm.handleDescartarVenda()}}},[_c('span',[_vm._v("(F5) Descartar")])]),_vm._v(" "),_c('div',{staticStyle:{"height":"full","padding":"1px","background-color":"#eeeeee"}})]):_vm._e(),_vm._v(" "),(_vm.showPagamentoVenda)?_c('div',{staticClass:"d-flex"},[_c('div',{staticStyle:{"height":"full","padding":"1px","background-color":"#eeeeee"}}),_vm._v(" "),_c('button',{staticClass:"blank-button text-button",attrs:{"disabled":!_vm.pedv},on:{"click":function($event){return _vm.handleInformarDesconto()}}},[_c('span',[_vm._v("(F3) Desconto Total")])]),_vm._v(" "),_c('div',{staticStyle:{"height":"full","padding":"1px","background-color":"#eeeeee"}}),_vm._v(" "),_c('button',{staticClass:"blank-button text-button",attrs:{"disabled":!_vm.pedv},on:{"click":function($event){return _vm.handleModalCliente()}}},[_c('span',[_vm._v("(F4) Informar CPF")])])]):_vm._e(),_vm._v(" "),(!_vm.showPagamentoVenda)?_c('button',{staticClass:"blank-button rounded font-weight-bold",style:(!_vm.pedv
              ? 'background-color: #797979; color: white; border-bottom: 1px solid #e9e5e5; height: 55px;'
              : _vm.hasBgButtomconfig()),attrs:{"disabled":!_vm.pedv || !_vm.pedvit || _vm.pedvit.length == 0 || _vm.pedv.stpedv != 'D' || _vm.closeCaixa},on:{"click":_vm.handleClickPagamento}},[_c('span',{staticStyle:{"font-size":"15px","text-transform":"uppercase"}},[_vm._v("(F6) Pagamento")])]):_vm._e()])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showVAbertura)?_c('varejo-vabertura-form',{on:{"resultadovabertura":_vm.handleResultadoVabertura}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showVmovCaixaForm)?_c('VarejoVmCaixaForm',{attrs:{"params":_vm.paramsvmovcaixa},on:{"resultadovmovcaixa":_vm.handleResultadoVmovCaixaForm}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showEmissaoCupom && _vm.savedOrder)?_c('VarejoEmissaoCupom',{attrs:{"index":_vm.savedOrder,"tipo":"cupomnaofiscal"},on:{"resultadoemissaocupom":_vm.handleResultadoEmissaoCupom}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showEmissaoCupomVmov && _vm.vmovcaixa && _vm.vmovcaixa.codvmovcaixa)?_c('VarejoEmissaoCupom',{attrs:{"index":_vm.vmovcaixa.codvmovcaixa,"tipo":"movimentocaixa"},on:{"resultadoemissaocupom":_vm.handleResultadoEmissaoCupom}}):_vm._e()],1),_vm._v(" "),(_vm.showModalEditItem)?_c('div',[_c('VarejoModalItemSequencia',{attrs:{"value":_vm.editItemValue,"pedvit":_vm.pedvit,"pedv":_vm.pedv,"modalCrud":_vm.modalCrud,"pedvit_update":_vm.pedvit_update},on:{"closeModal":function($event){return _vm.closeModalEditItem()},"updateMode":function($event){_vm.editItemValue = $event;
_vm.handleEditItem(_vm.editItemValue);},"confirmedPass":function($event){_vm.pedvit_update = $event;
_vm.confirmaItemCancel();}}})],1):_vm._e(),_vm._v(" "),(_vm.showTotal)?_c('div',{staticClass:"dropdown-total col-md-4 col-10",staticStyle:{"padding":"15px"}},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){_vm.showTotal = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"row col nb-margin-bottom"})]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade","appear":""}},[(_vm.showModalMaisAcoes)?_c('varejo-modal-opcoes',{ref:"modalOpcoes",attrs:{"bgButton":_vm.hasBgButtomconfig()},on:{"selected":_vm.handleSelectedOption,"close":function($event){_vm.showModalMaisAcoes = false}}}):_vm._e()],1),_vm._v(" "),(_vm.CANCEL_MESSAGE)?_c('md-message',{attrs:{"adminPass":true,"kind":"delete","title":"Descartar Venda","message":"Deseja realmente descartar a venda?","help":""},on:{"close":function($event){return _vm.handleCloseMessage()},"confirm":function($event){return _vm.handleCancelarVenda()}}}):_vm._e(),_vm._v(" "),(_vm.showModalnfce)?_c('div',[_c('VarejoModalNfce',{ref:"modalnfce",on:{"closeModal":function($event){_vm.showModalnfce = false}}})],1):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-3 py-4 text-center",staticStyle:{"border-bottom":"2px solid black"}},[_c('span',{staticClass:"def-title text-danger"},[_vm._v("Número da Comanda")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lbl mb-4",staticStyle:{"font-size":"20px"}},[_c('strong',[_vm._v("Editar Produto")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-12"},[_c('span',{staticClass:"lbl mb-4",staticStyle:{"font-size":"20px"}},[_c('strong',[_vm._v("Aplicar desconto ou acréscimo na\n                            venda")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"float-left",staticStyle:{"padding-bottom":"4px"}},[_c('strong',{staticStyle:{"font-size":"12px"}},[_vm._v("Lista de Produtos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"font-weight":"600","margin-left":"30px"}},[_vm._v("\n                      Seu caixa está\n                      "),_c('span',{staticStyle:{"color":"#005ea7"}},[_vm._v("livre")]),_vm._v(" no momento!\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-success",staticStyle:{"font-size":"18px"}},[_c('strong',[_vm._v("Acrescimos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-wine-color",staticStyle:{"font-size":"18px"}},[_c('strong',[_vm._v("Descontos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_controlecaixa_list_vue__ = __webpack_require__(775);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_437b7584_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_controlecaixa_list_vue__ = __webpack_require__(2231);
function injectStyle (ssrContext) {
  __webpack_require__(2225)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_controlecaixa_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_437b7584_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_controlecaixa_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2226);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6a3bd068", content, true, {});

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_controlecaixa_form_vue__ = __webpack_require__(776);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e3e2f82_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_controlecaixa_form_vue__ = __webpack_require__(2230);
function injectStyle (ssrContext) {
  __webpack_require__(2228)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_controlecaixa_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e3e2f82_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_controlecaixa_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2229);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("42511b40", content, true, {});

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-container"},[_c('bar-manut',{attrs:{"single-entity":"Abertura e Fechamento do Caixa"},on:{"closeform":_vm.handleRetorna}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('fechar-caixa',{attrs:{"index":_vm.index},on:{"closeform":_vm.handleRetorna}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"new-button":false,"pdf-button":false,"xls-button":false,"filter-month":true,"plural-entity":"Controle de Caixas","title-search":"Pesquise pelo nome do operador"},on:{"search":_vm.changeFiltroTexto,"refresh":_vm.loadData,"filter":_vm.changeFiltroMes}}),_vm._v(" "),_c('div',{staticClass:"row align-items-center mb-3"},[_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"lbl"},[_vm._v("Status\n          "),_c('a',{staticClass:"dropdown-toggle pr-2",staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"1","data-toggle":"dropdown"}},[_vm._v("\n            "+_vm._s(_vm.labelStatus)+" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btnGroupDrop1"}},_vm._l((_vm.filtroStatus.list),function(filtro,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleChangeFiltroStatus(filtro)}}},[_vm._v(_vm._s(filtro.label))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"default-container p-0"},[(_vm.vaberturaList.length == 0)?_c('alert',{attrs:{"type":"warning","text":"Nenhum registro foi encontrado."}}):_vm._e(),_vm._v(" "),_vm._l((_vm.vaberturaList),function(item,index){return _c('div',{key:index,staticClass:"w-100",staticStyle:{"margin":"5px 0 5px","border-bottom":"1px solid #eee"}},[_c('div',{staticClass:"row p-3"},[_c('div',{staticClass:"col-md-2"},[_c('span',{staticClass:"lbl-list"},[_vm._v(" Data ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(_vm._f("formatDataHora")(item.data)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('span',{staticClass:"lbl-list"},[_vm._v("Caixa")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(item.caixa))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('span',{staticClass:"lbl-list"},[_vm._v(" Operador ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(" "+_vm._s(item.operador))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('span',{staticClass:"lbl-list"},[_vm._v(" Valor em Vendas ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v("\n              "+_vm._s(_vm._f("formatValue")(item.totalvendas,2, true)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[(item && item.aberto)?_c('span',{staticClass:"badge badge-green ml-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":""}},[_vm._v(_vm._s(item.status)+"\n            ")]):_vm._e(),_vm._v(" "),(item.conferido)?_c('span',{staticClass:"badge badge-green ml-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":""}},[_vm._v(_vm._s(item.status)+"\n            ")]):_vm._e(),_vm._v(" "),(!item.conferido && !item.aberto)?_c('span',{staticClass:"badge badge-gray ml-2",attrs:{"data-toggle":"tooltip","data-placement":"top","title":""}},[_vm._v(_vm._s(item.status)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-auto text-right"},[(item.aberto)?_c('v-button',{staticClass:"float-right",attrs:{"icon":"","label":"Fechar Caixa"},on:{"click":function($event){return _vm.handleShowForm(item)}}}):_vm._e(),_vm._v(" "),(item.aberto)?_c('v-button',{staticClass:"float-right",attrs:{"icon":"fa-user","title":"Trocar Usuario"},on:{"click":function($event){return _vm.handleChangeUser(item)}}}):_vm._e(),_vm._v(" "),(!item.aberto)?_c('v-button',{staticClass:"float-right",attrs:{"icon":"fa-search","title":""},on:{"click":function($event){return _vm.handleShowForm(item)}}}):_vm._e(),_vm._v(" "),(!item.aberto)?_c('v-button',{staticClass:"float-right",attrs:{"icon":"fa-print","title":""},on:{"click":function($event){return _vm.handleShowCupom(item)}}}):_vm._e()],1)])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('controlecaixa-form',{attrs:{"index":this.codvabertura},on:{"closeform":_vm.closeForm}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showCupom)?_c('VarejoEmissaoCupom',{attrs:{"index":this.codvabertura,"tipo":"fechamentocaixa"},on:{"resultadoemissaocupom":_vm.handleResultadoEmissaoCupomFechamento}}):_vm._e()],1),_vm._v(" "),(_vm.SHOW_CONFIRMADMINPASS)?_c('confirm-adminpass',{on:{"close":function($event){return _vm.hideConfirmAdminPass()},"confirm":function($event){return _vm.confirmAdminPass()}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_recebiveis_list_vue__ = __webpack_require__(777);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b86005c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_recebiveis_list_vue__ = __webpack_require__(2235);
function injectStyle (ssrContext) {
  __webpack_require__(2233)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_recebiveis_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b86005c_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_recebiveis_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2234);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3a1b2a82", content, true, {});

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('bar-list',{attrs:{"refresh-button":true,"filtro-mes":false,"new-button":false,"single-entity":"Valores a Receber Por Data de Crédito","plural-entity":"Valores a Receber Por Data de Crédito","hideSearch":true,"refreshButton":false}})],1)]),_vm._v(" "),_c('filtro',{attrs:{"showfiltro":_vm.showfiltro,"params":_vm.paramsFiltro},on:{"change":_vm.filtroChange,"cancel":function($event){_vm.showfiltro = false}}}),_vm._v(" "),_c('div',{staticClass:"row mb-3 align-items-center"},[_c('div',{staticClass:"col-md-6 col-12"},[_c('v-button',{attrs:{"label":"Filtro","success":true},on:{"click":_vm.handleShowFiltro}}),_vm._v(" "),_c('v-button',{attrs:{"title":"Atualizar Grid","icon":"fa-refresh"},on:{"click":_vm.loadData}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"default-container"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n        Resumo De Valores a Receber Por Forma de Pagamento\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_vm._v("\n        Dados exibidos somente de caixas fechados\n      ")]),_vm._v(" "),(_vm.filtro.periodos.length)?_c('div',{staticClass:"col-auto"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data de Início")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.filtro.periodos[0].data_inicio)))])]):_vm._e(),_vm._v(" "),(_vm.filtro.periodos.length)?_c('div',{staticClass:"col-auto"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data de Término")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.filtro.periodos[0].data_termino)))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[(!_vm.resumo || _vm.resumo.length == 0)?_c('div',{staticClass:"col-12 p-3"},[_vm._v("\n        Nenhum movimento encontrado\n      ")]):_c('div',{staticClass:"col-md-8"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-bordered table-sm responsive w-100"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.resumo),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.descricao))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valor,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valorliquido,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.taxas,2)))])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total"},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.totais.total,2))+" ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.totais.totalliquido,2))+" ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.totais.totaltaxas,2))+" ")])])])])])])])]),_vm._v(" "),(_vm.dados && _vm.dados.length)?_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n        Detalhes\n      ")])]):_vm._e(),_vm._v(" "),(_vm.dados && _vm.dados.length)?_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticStyle:{"width":"100%","max-height":"100%","overflow":"hidden","font-size":"12px"}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-bordered table-sm responsive w-100"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.dados),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.npedido))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(row.descricao))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatData")(row.data)))]),_vm._v(" "),_c('td',{staticClass:"textual"},[_vm._v(_vm._s(_vm._f("formatData")(row.dtcredito)))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valor,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.valorliquido,2)))]),_vm._v(" "),_c('td',{staticClass:"numerico size100"},[_vm._v(_vm._s(_vm._f("formatValue")(row.taxas,2)))])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right total",attrs:{"colspan":"4"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.totais.total,2))+" ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.totais.totalliquido,2))+" ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 total"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.totais.totaltaxas,2))+" ")])])])])])])])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                    Forma de Pagamento\n                  ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                    Valor Original R$\n                  ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                    Valor Líquido R$\n                  ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                    Taxas R$\n                  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                    Pedido\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                    Forma de Pagamento\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                    Data da Venda\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                    Data do Crédito\n                  ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                    Valor Original R$\n                  ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                    Valor Líquido R$\n                  ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100",attrs:{"colspan":"1"}},[_vm._v("\n                    Taxas R$\n                  ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_devolucao_list_vue__ = __webpack_require__(778);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d78f9b8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_devolucao_list_vue__ = __webpack_require__(2239);
function injectStyle (ssrContext) {
  __webpack_require__(2237)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_varejo_devolucao_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d78f9b8_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_varejo_devolucao_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2238);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("77960c14", content, true, {});

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showForm),expression:"!showForm"}],attrs:{"id":"list"}},[_c('bar-list',{attrs:{"refresh-button":true,"filter-month":true,"new-button":true,"single-entity":"Devolução/Venda","plural-entity":"Devolução/Vendas","title-search":"Pesquise pelo código ou nome do cliente"},on:{"new":_vm.handleNew,"search":_vm.changeFiltroTexto,"filter":_vm.changeFiltroMes,"refresh":_vm.loadData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"default-container mt-2"},[(_vm.pedvDevList.length == 0)?_c('alert',{attrs:{"type":"norecord"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.pedvDevList),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(item.excluido =='N'),expression:"item.excluido =='N'"}],key:index,staticClass:"mainbox"},[_c('div',{staticClass:"row pb-1"},[_c('div',{staticClass:"col-md-1 col-2"},[_c('span',{staticClass:"lbl-list"},[_vm._v("# Devolução")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"mb-1"},[_vm._v(_vm._s(item.codvdevol))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('span',{staticClass:"lbl-list"},[_vm._v("Data")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(item.data)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[_c('span',{staticClass:"lbl-list"},[_vm._v("Operador")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"mb-1"},[_vm._v(_vm._s(item.operador))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-2"},[_c('span',{staticClass:"lbl-list"},[_vm._v(" Pedido ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.npedido))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[_c('span',{staticClass:"lbl-list"},[_vm._v("Valor Total")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v("R$ "+_vm._s(_vm._f("formatValue")(item.total,2)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[_c('span',{staticClass:"lbl-list"},[_vm._v(" NF Devolução")]),_vm._v(" "),(item.nf.serie)?_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.nf.nf)+" "),_c('span',{staticClass:"lbl-list",staticStyle:{"font-size":"11px"}},[_vm._v(" Serie")]),_vm._v(" "+_vm._s(item.nf.serie))]):_c('span',{staticClass:"data-list"},[_vm._v("Não possui NF")]),_vm._v(" "),(item.nf.enviar)?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Não Enviada")]):_vm._e(),_vm._v(" "),(item.nf.autorizada)?_c('span',{staticClass:"badge badge-success"},[_vm._v("Autorizada")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-4"},[_c('div',{staticClass:"d-flex mt-2"},[_c('v-button',{staticClass:"float-right",attrs:{"title":"Visualizar","icon":"fa-search"},on:{"click":function($event){return _vm.handleView(item.codvdevol)}}}),_vm._v(" "),(item.nf.enviar)?_c('v-button',{staticClass:"float-right",attrs:{"title":"Autorizar a NF de Devolução","icon":"fa-rss-square"},on:{"click":function($event){return _vm.handleAutorizaNF(item.nf.codnf)}}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-12"},[(item.part)?_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(item.part.nome))]):_vm._e()])])])})],2)],1),_vm._v(" "),(_vm.showForm)?_c('DevolucaoForm',{attrs:{"index":this.codvdevol,"crud":_vm.crud},on:{"closeform":_vm.closeForm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_fluxo_caixa_vue__ = __webpack_require__(779);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bfced0c_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_fluxo_caixa_vue__ = __webpack_require__(2243);
function injectStyle (ssrContext) {
  __webpack_require__(2241)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bfced0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_fluxo_caixa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bfced0c_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_fluxo_caixa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2242);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e8ff5f90", content, true, {});

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".data-table[data-v-7bfced0c]{overflow:auto}span i[data-v-7bfced0c]{cursor:pointer}.lvl-1[data-v-7bfced0c]{margin-left:.5rem}.lvl-2[data-v-7bfced0c]{font-size:15px!important;margin-left:1.5rem}.lvl-3[data-v-7bfced0c]{margin-left:2.5rem}.lvl-4[data-v-7bfced0c]{font-weight:400;margin-left:3.5rem}table .textual[data-v-7bfced0c]{font-size:12px;padding:4.8px}table .numerico[data-v-7bfced0c]{font-size:12px;min-width:65px;text-align:right}table .size130[data-v-7bfced0c]{min-width:130px}table .size100[data-v-7bfced0c]{width:100px}table .total[data-v-7bfced0c]{background:#c1c4c7;border:none}table .var[data-v-7bfced0c]{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative[data-v-7bfced0c]{color:#fff;background:#cd5c5c}table .var-positive[data-v-7bfced0c]{color:#fff;background:green}table .border-left[data-v-7bfced0c]{border-left:1px solid #dee2e6}.value-bg-color[data-v-7bfced0c]{background-color:#fafffa!important}.consulta__total[data-v-7bfced0c]{display:flex;align-items:center;justify-content:center}.consulta__total_valor[data-v-7bfced0c]{font-size:40px;display:block;line-height:normal}.consulta__cifrao[data-v-7bfced0c]{font-size:16px;display:block;line-height:normal}.negative[data-v-7bfced0c]{color:red}.positive[data-v-7bfced0c]{color:green}.tipo[data-v-7bfced0c]{display:inline-block;padding:5px;font-size:13px;font-weight:600;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:20%}.tipo-recebimento[data-v-7bfced0c]{color:#fff;background-color:#80b852}.tipo-pagamento[data-v-7bfced0c]{color:#fff;background-color:#ee2727}", ""]);

// exports


/***/ }),
/* 2243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"default-container"},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('v-label',{attrs:{"label":"Período"}}),_vm._v(" "),_c('input-month2',{attrs:{"p-month":_vm.periodo}})],1),_vm._v(" "),_c('form-field',{attrs:{"type":"select2static","col":"4","label":"Selecione as Contas","select-options":_vm.listContas,"selectMultiple":true,"placeholder":"Todas as Contas"},model:{value:(_vm.contas),callback:function ($$v) {_vm.contas=$$v},expression:"contas"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"select","col":"2","label":"Tipo de Fluxo","select-options":_vm.tipoOptions},on:{"input":_vm.handleLoadDataFilter},model:{value:(_vm.tipo),callback:function ($$v) {_vm.tipo=$$v},expression:"tipo"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('input-checkbox',{attrs:{"estilo":'text-info',"label":"Considerar Contas Atrasadas","value-checked":true,"value-unchecked":false},model:{value:(_vm.atrasos),callback:function ($$v) {_vm.atrasos=$$v},expression:"atrasos"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),(_vm.atrasos)?_c('form-field',{attrs:{"type":"number","col":"3","label":"Tempo das Contas Atrasadas (Dias)"},model:{value:(_vm.atrasosTempo),callback:function ($$v) {_vm.atrasosTempo=$$v},expression:"atrasosTempo"}}):_vm._e()],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-button',{attrs:{"label":"Filtrar","success":true},on:{"click":_vm.loadData}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n                Gráfico Fluxo de Caixa\n            ")]),_vm._v(" "),(_vm.chart.type)?_c('GChart',{attrs:{"settings":{ packages:['corechart'], language: 'pt-br' },"type":_vm.chart.type,"data":_vm.chart.data,"options":_vm.chart.options}}):_vm._e()],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n                Saldos Iniciais\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12 lbl-title"},[(_vm.fluxoCaixaDados && _vm.fluxoCaixaDados.contas)?_c('table',{staticClass:"table table-bordered table-sm responsive w-100 bg-light"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.fluxoCaixaDados.contas),function(conta,index){return _c('tr',{key:index},[_c('th',{staticClass:"textual text-center value-bg-color"},[_c('span',[_vm._v("\n                                    "+_vm._s(conta.descricao)+"\n                                ")])]),_vm._v(" "),_c('td',{staticClass:"numerico size100 text-center value-bg-color"},[_c('span',[_vm._v("\n                                    "+_vm._s(_vm._f("formatValue")(conta.saldo,2))+"\n                                ")])])])}),0),_vm._v(" "),_c('tfoot')]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12 lbl-title"},[_vm._v("\n                Fluxo de Caixa\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data de Início")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.periodo.data_inicio)))])]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('label',{staticClass:"lbl-list"},[_vm._v("Data de Término")]),_vm._v(" "),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(_vm.periodo.data_termino)))])])]),_vm._v(" "),(!_vm.fluxoCaixaDados)?_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12 p-3"},[_vm._v("\n                Nenhum movimento encontrado\n            ")])]):_vm._e(),_vm._v(" "),(_vm.fluxoCaixaDados && _vm.tipo == 'M')?_c('div',{staticClass:"data-table bg-light"},[_c('table',{staticClass:"table table-bordered table-sm responsive w-100"},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"1"}}),_vm._v(" "),_vm._l((_vm.fluxoCaixaDados.periodos),function(periodo,i){return _c('th',{key:i,staticClass:"numerico size100 textual text-center",attrs:{"colspan":"1"}},[_vm._v("\n                            "+_vm._s(periodo.label)+"\n                        ")])})],2)]),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',{staticClass:"textual",attrs:{"scope":"row"}},[_vm._v("SALDO INICIAL")]),_vm._v(" "),_vm._l((_vm.fluxoCaixaDados.saldoInicial),function(saldoI,i){return _c('td',{key:i,staticClass:"numerico size100 value-bg-color"},[_c('span',{class:_vm.formatColorValue(saldoI)},[_vm._v(_vm._s(_vm._f("formatValue")(saldoI,2, true)))])])})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"textual",attrs:{"scope":"row"}},[_vm._v("RECEITAS")]),_vm._v(" "),_vm._l((_vm.fluxoCaixaDados.receitas),function(receita,i){return _c('td',{key:i,staticClass:"numerico size100 value-bg-color"},[_c('span',{class:_vm.formatColorValue(receita)},[_vm._v(_vm._s(_vm._f("formatValue")(receita,2, true)))])])})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"textual",attrs:{"scope":"row"}},[_vm._v("DESPESAS")]),_vm._v(" "),_vm._l((_vm.fluxoCaixaDados.despesas),function(despesa,i){return _c('td',{key:i,staticClass:"numerico size100 value-bg-color"},[_c('span',{class:_vm.formatColorValue(despesa)},[_vm._v(_vm._s(_vm._f("formatValue")(despesa,2, true)))])])})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"textual",attrs:{"scope":"row"}},[_vm._v("SALDO FINAL (SALDO INICIAL + RECEITAS - DESPESAS)")]),_vm._v(" "),_vm._l((_vm.fluxoCaixaDados.saldoAcumulado),function(saldoA,i){return _c('td',{key:i,staticClass:"numerico size100 value-bg-color"},[_c('span',{class:_vm.formatColorValue(saldoA)},[_vm._v(_vm._s(_vm._f("formatValue")(saldoA,2, true)))])])})],2),_vm._v(" "),(_vm.fluxoCaixaDados && _vm.fluxoCaixaDados.periodos)?_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":_vm.fluxoCaixaDados.periodos.length + 1,"scope":"row"}},[_vm._v("CATEGORIAS")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.fluxoCaixaDados.dados),function(dados,i){return _c('tr',{key:i},[_c('th',{staticClass:"textual"},[_c('div',{attrs:{"Class":'lvl-' + dados.nivel}},[_vm._v("\n                                "+_vm._s(dados.descricao)+"\n                            ")])]),_vm._v(" "),_vm._l((dados.valores),function(valor,i){return _c('td',{key:i,staticClass:"numerico size100 value-bg-color"},[_c('span',{class:_vm.formatColorValue(valor)},[(!dados.haschildren && valor)?_c('i',{staticClass:"fa fa-search fa-fw",on:{"click":function($event){return _vm.showModalDetalhes(dados, i)}}}):_vm._e(),_vm._v(" \n                                "+_vm._s(_vm._f("formatValue")(valor,2, true))+"\n                            ")])])})],2)})],2),_vm._v(" "),_c('tfoot')]),_vm._v(" "),(_vm.showModal)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-header"},[_c('h5',{staticClass:"p-2"},[_vm._v("Detalhes da natureza \""+_vm._s(_vm.dadosDetalhes.descricao)+"\"")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeModalDetalhes()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"mainbox"},_vm._l((_vm.dadosDetalhes.detalhes),function(valorDetalhes,index){return _c('div',{key:index,staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col-3",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Documento")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(valorDetalhes.doc))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Nome")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(valorDetalhes.nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Descrição")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(valorDetalhes.descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Valor")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(valorDetalhes.vlr,2, true)))])]),_vm._v(" "),_c('div',{staticClass:"col-auto text-center"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Tipo")]),_vm._v(" "),(valorDetalhes.tipo == 'R' || valorDetalhes.tipo == 'E')?_c('span',{staticClass:"tipo tipo-recebimento",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Recebimento"}},[_vm._v(" "+_vm._s(valorDetalhes.tipo)+" ")]):_vm._e(),_vm._v(" "),(valorDetalhes.tipo == 'P' || valorDetalhes.tipo == 'S')?_c('span',{staticClass:"tipo tipo-pagamento",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Pagamento"}},[_vm._v(" "+_vm._s(valorDetalhes.tipo)+" ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Vencimento")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(valorDetalhes.dtv)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Vencimento Real")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(valorDetalhes.dtvr)))])])])])}),0),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{ref:"btnClose",attrs:{"label":"Fechar","title":""},on:{"click":function($event){return _vm.closeModalDetalhes()}}})],1)])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-12 col-12"},[(_vm.fluxoCaixaDados && _vm.tipo == 'D')?_c('div',{staticClass:"data-table table-sm bg-light mt-2"},[_c('table',{staticClass:"table table-bordered responsive w-100"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.fluxoCaixaDados.dados),function(dados,i){return _c('tr',{key:i},[_c('th',{staticClass:"textual text-center"},[_c('span',[_vm._v(_vm._s(_vm._f("formatData")(dados.data)))]),_vm._v(" "),_c('span',{staticClass:"float-right"},[(dados.receitas || _vm.despesas)?_c('i',{staticClass:"fa fa-search fa-fw",on:{"click":function($event){return _vm.showModalDetalhesDiario(dados.detalhes, dados.data)}}}):_vm._e()])]),_vm._v(" "),_c('th',{staticClass:"numerico size100 value-bg-color"},[_c('div',[_vm._v(_vm._s(_vm._f("formatValue")(dados.receitas,2)))])]),_vm._v(" "),_c('th',{staticClass:"numerico size100 value-bg-color"},[_c('div',[_vm._v(_vm._s(_vm._f("formatValue")(dados.despesas,2)))])]),_vm._v(" "),_c('th',{staticClass:"numerico size100 value-bg-color"},[_c('div',[_vm._v(_vm._s(_vm._f("formatValue")(dados.saldo,2)))])])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 value-bg-color"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.fluxoCaixaDados.receitasTotal,2))+" ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 value-bg-color"},[_vm._v(" "+_vm._s(_vm._f("formatValue")(_vm.fluxoCaixaDados.despesasTotal,2))+" ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 value-bg-color"})])])])]):_vm._e()])]),_vm._v(" "),(_vm.showModalDiario)?_c('div',{staticClass:"nb-modal-scrollable"},[_c('div',{staticClass:"container nb-modal-scrollable-container nb-email-container"},[_c('div',{staticClass:"nb-modal-header"},[(_vm.diario.dataDia === 'Atrasos')?_c('h5',{staticClass:"p-2"},[_vm._v("Detalhes "+_vm._s(_vm.diario.dataDia))]):_c('h5',{staticClass:"p-2"},[_vm._v("Detalhes do dia "+_vm._s(_vm._f("formatData")(_vm.diario.dataDia)))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeModalDetalhes()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-body"},[_c('div',{staticClass:"mainbox"},_vm._l((_vm.diario.diarioDetalhes),function(detalhe,index){return _c('div',{key:index,staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col-3",staticStyle:{"float":"left"}},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Documento")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(detalhe.doc))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Nome")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(detalhe.nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Descrição")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(detalhe.descricao))])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Valor")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatValue")(detalhe.vlr,2, true)))])]),_vm._v(" "),_c('div',{staticClass:"col-auto text-center"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Tipo")]),_vm._v(" "),(detalhe.tipo == 'R' || detalhe.tipo == 'E')?_c('span',{staticClass:"tipo tipo-recebimento",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Recebimento"}},[_vm._v(" "+_vm._s(detalhe.tipo)+" ")]):_vm._e(),_vm._v(" "),(detalhe.tipo == 'P' || detalhe.tipo == 'S')?_c('span',{staticClass:"tipo tipo-pagamento",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Pagamento"}},[_vm._v(" "+_vm._s(detalhe.tipo)+" ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Vencimento")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(detalhe.dtv)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-3"},[_c('label',{staticClass:"lbl-list w-100"},[_vm._v("Vencimento Real")]),_c('span',{staticClass:"data-list"},[_vm._v(_vm._s(_vm._f("formatData")(detalhe.dtvr)))])])])])}),0),_vm._v(" "),_c('div',{staticClass:"nb-modal-scrollable-footer"},[_c('v-button',{ref:"btnClose",attrs:{"label":"Cancelar","title":""},on:{"click":function($event){return _vm.closeModalDetalhes()}}})],1)])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("CONSULTA FLUXO DE CAIXA")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"numerico size100 textual text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                CONTA\n                            ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 textual text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                SALDO\n                            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                    Data\n                                ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                    Receitas\n                                ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                    Despesas \n                                ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                    Saldo\n                                ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_dre_vue__ = __webpack_require__(780);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4e93020_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_dre_vue__ = __webpack_require__(2247);
function injectStyle (ssrContext) {
  __webpack_require__(2245)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e4e93020"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_dre_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4e93020_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_dre_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2246);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("42b17194", content, true, {});

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".data-table[data-v-e4e93020]{overflow:auto}span i[data-v-e4e93020]{cursor:pointer}.lvl-1[data-v-e4e93020]{font-size:15px!important;margin-left:.75rem}.lvl-2[data-v-e4e93020]{margin-left:1.75rem}.lvl-0[data-v-e4e93020]{font-size:15px!important;margin-left:.75rem}table .textual[data-v-e4e93020]{font-size:12px;padding:4.8px}table .numerico[data-v-e4e93020]{font-size:12px;min-width:65px;text-align:right}table .size130[data-v-e4e93020]{min-width:130px}table .size100[data-v-e4e93020]{width:100px}table .total[data-v-e4e93020]{background:#c1c4c7;border:none}table .var[data-v-e4e93020]{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative[data-v-e4e93020]{color:#fff;background:#cd5c5c}table .var-positive[data-v-e4e93020]{color:#fff;background:green}table .border-left[data-v-e4e93020]{border-left:1px solid #dee2e6}.value-bg-color[data-v-e4e93020]{background-color:#fafffa!important}.consulta__total[data-v-e4e93020]{display:flex;align-items:center;justify-content:center}.consulta__total_valor[data-v-e4e93020]{font-size:40px;display:block;line-height:normal}.consulta__cifrao[data-v-e4e93020]{font-size:16px;display:block;line-height:normal}.negative[data-v-e4e93020]{color:red}.positive[data-v-e4e93020]{color:green}.border-left-gray[data-v-e4e93020]{border-left:7px solid gray}.border-left-green[data-v-e4e93020]{border-left:7px solid #28a745}.border-left-red[data-v-e4e93020]{border-left:7px solid #ee2727}.totalizer[data-v-e4e93020]{position:absolute;left:.6rem;width:16px;height:16px;border:1px solid #ccc;background-color:#fff;border-radius:8px;color:#000;margin-top:3px;z-index:1;display:flex;justify-content:center;align-items:center}", ""]);

// exports


/***/ }),
/* 2247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"default-container position-relative"},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{attrs:{"select-options":_vm.listPeriodos,"col":"2","label":"Período","type":"select","optionnull":true},model:{value:(_vm.tipo),callback:function ($$v) {_vm.tipo=$$v},expression:"tipo"}}),_vm._v(" "),_c('form-field',{attrs:{"col":"2","label":"Ano","placeholder":"Ex.: 1999","type":"text"},model:{value:(_vm.ano),callback:function ($$v) {_vm.ano=$$v},expression:"ano"}}),_vm._v(" "),_c('v-button',{attrs:{"success":true,"label":"Consultar"},on:{"click":_vm.loadData}})],1),_vm._v(" "),(_vm.dadosDre)?_c('div',{staticClass:"data-table bg-light"},[_c('table',{staticClass:"table table-bordered table-sm responsive w-100"},[_c('tbody',[(_vm.dadosDre && _vm.dadosDre.periodos)?_c('tr',[_c('th',{staticClass:"text-center",attrs:{"scope":"row"}},[_vm._v("CATEGORIAS")]),_vm._v(" "),_vm._l((_vm.dadosDre.periodos),function(periodo,i){return _c('th',{key:i,staticClass:"numerico size100 textual text-center",attrs:{"colspan":"1"}},[_vm._v("\n                            "+_vm._s(periodo.label)+"\n                        ")])}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"row"}},[_vm._v("TOTAL")])],2):_vm._e(),_vm._v(" "),_vm._l((_vm.dadosDre.dre),function(dados,i){return _c('tr',{key:i},[_c('th',{staticClass:"textual",class:_vm.levelBorderClass(dados)},[(!dados.nivel)?_c('span',{staticClass:"totalizer"},[_vm._v("=")]):_vm._e(),_vm._v(" "),(dados.nivel === 1)?_c('span',{staticClass:"totalizer"}):_vm._e(),_vm._v(" "),_c('div',{attrs:{"Class":_vm.levelClass(dados)}},[_vm._v("\n                                "+_vm._s(dados.descricao)+"\n                            ")])]),_vm._v(" "),_vm._l((dados.colunas),function(valor,i){return _c('td',{key:i,staticClass:"numerico size100 value-bg-color"},[_c('span',{class:_vm.formatColorValue(valor)},[_vm._v("\n                                "+_vm._s(_vm._f("formatValue")(valor,2, true))+"\n                            ")])])})],2)})],2),_vm._v(" "),_c('tfoot')])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-2"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("CONSULTA DRE")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_posicao_financeiro_vue__ = __webpack_require__(781);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_402d8a3e_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_posicao_financeiro_vue__ = __webpack_require__(2251);
function injectStyle (ssrContext) {
  __webpack_require__(2249)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-402d8a3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_posicao_financeiro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_402d8a3e_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_posicao_financeiro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2250);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d28fd2ae", content, true, {});

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".text-navy-blue[data-v-402d8a3e]{color:#174b79!important}.text-blue[data-v-402d8a3e]{color:#2469a5!important}.total[data-v-402d8a3e]{padding:.5rem;min-width:1.5rem}.total p[data-v-402d8a3e]{color:#808080bb;text-align:end;font-size:.85rem;font-weight:700;margin-bottom:-7.5px}.total small[data-v-402d8a3e]{font-size:1rem;font-weight:500;padding-right:.25rem;color:#212529!important}.total span[data-v-402d8a3e]{text-align:end;font-size:1.85rem;font-weight:700;cursor:pointer}.data-table[data-v-402d8a3e]{overflow:auto}table .textual[data-v-402d8a3e]{font-size:12px;padding:4.8px}table .numerico[data-v-402d8a3e]{font-size:12px;min-width:65px;text-align:right}table .size130[data-v-402d8a3e]{min-width:130px}table .size100[data-v-402d8a3e]{width:100px}table .total[data-v-402d8a3e]{background:#c1c4c7;border:none}table .var[data-v-402d8a3e]{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative[data-v-402d8a3e]{color:#fff;background:#cd5c5c}table .var-positive[data-v-402d8a3e]{color:#fff;background:green}table .border-left[data-v-402d8a3e]{border-left:1px solid #dee2e6}.value-bg-color[data-v-402d8a3e]{background-color:#fafffa!important}.consulta__total[data-v-402d8a3e]{display:flex;align-items:center;justify-content:center}.consulta__total_valor[data-v-402d8a3e]{font-size:40px;display:block;line-height:normal}.consulta__cifrao[data-v-402d8a3e]{font-size:16px;display:block;line-height:normal}", ""]);

// exports


/***/ }),
/* 2251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"default-container"},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('v-label',{attrs:{"label":"Período"}}),_vm._v(" "),_c('input-month2',{attrs:{"p-month":_vm.periodo}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('form-field',{attrs:{"type":"select2","label":"Cliente/Fornecedor","select2":{entity: 'part', minlength: 0}},model:{value:(_vm.codpart),callback:function ($$v) {_vm.codpart=$$v},expression:"codpart"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('form-field',{attrs:{"type":"select2","label":"Conta","select2":{entity: 'cta', minlength: 0}},model:{value:(_vm.codcta),callback:function ($$v) {_vm.codcta=$$v},expression:"codcta"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('form-field',{attrs:{"type":"select","label":"Tipo de Fluxo","select-options":_vm.tipoOptions},model:{value:(_vm.tipo),callback:function ($$v) {_vm.tipo=$$v},expression:"tipo"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 d-flex flex-row-reverse mb-2"},[_c('v-button',{attrs:{"label":"Filtrar","success":true},on:{"click":_vm.loadData}}),_vm._v(" "),_c('v-button',{attrs:{"label":"Excel"},on:{"click":function($event){return _vm.loadData(true)}}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.total)?_c('div',{staticClass:"row totais d-flex justify-content-between align-items-center"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-10 d-flex flex-wrap justify-content-end align-items-center"},[_c('div',{staticClass:"total flex-fill"},[_c('p',[_vm._v("Cancelados")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end align-items-baseline"},[(_vm.total.cancelados > 0)?_c('small',[_vm._v("R$")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text-danger",on:{"click":function($event){return _vm.filtrarTitulos(3)}}},[_vm._v("\n                            "+_vm._s(_vm._f("formatValue")(_vm.total.cancelados,2))+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"total flex-fill"},[_c('p',[_vm._v("Em Atraso")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end align-items-baseline"},[(_vm.total.atrasados > 0)?_c('small',[_vm._v("R$")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text-warning",on:{"click":function($event){return _vm.filtrarTitulos(1)}}},[_vm._v("\n                            "+_vm._s(_vm._f("formatValue")(_vm.total.atrasados,2))+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"total flex-fill bg-light"},[_c('p',[_vm._v("A Receber")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end align-items-baseline"},[(_vm.total.abertos > 0)?_c('small',[_vm._v("R$")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text-navy-blue",on:{"click":function($event){return _vm.filtrarTitulos(2)}}},[_vm._v("\n                            "+_vm._s(_vm._f("formatValue")(_vm.total.abertos,2))+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"total flex-fill bg-light"},[_c('p',[_vm._v("Recebidos")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end align-items-baseline"},[(_vm.total.baixados > 0)?_c('small',[_vm._v("R$")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text-success",on:{"click":function($event){return _vm.filtrarTitulos(4)}}},[_vm._v("\n                            "+_vm._s(_vm._f("formatValue")(_vm.total.baixados,2))+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"total flex-fill bg-light"},[_c('p',[_vm._v("Total do Período")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end align-items-baseline"},[(_vm.total.total > 0)?_c('small',[_vm._v("R$")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text-blue",on:{"click":function($event){return _vm.filtrarTitulos(0)}}},[_vm._v("\n                            "+_vm._s(_vm._f("formatValue")(_vm.total.total,2))+"\n                        ")])])])])]):_vm._e(),_vm._v(" "),(_vm.data)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"data-table col-12 lbl-title"},[_c('table',{staticClass:"table table-bordered table-sm responsive w-100 bg-light"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.dataFilter),function(dado,index){return _c('tr',{key:index},[_c('th',{staticClass:"textual text-center value-bg-color"},[_c('span',[_vm._v("\n                                    "+_vm._s(_vm._f("formatData")(dado.data))+"\n                                ")])]),_vm._v(" "),_c('td',{staticClass:"numerico size100 text-center value-bg-color"},[_c('span',[_vm._v("\n                                    "+_vm._s(dado.doc)+" / "+_vm._s(dado.parcela)+"\n                                ")])]),_vm._v(" "),_c('td',{staticClass:"numerico size100 text-center value-bg-color"},[_c('span',[_vm._v("\n                                    "+_vm._s(dado.natureza)+"\n                                ")])]),_vm._v(" "),_c('td',{staticClass:"numerico size100 text-center value-bg-color"},[_c('span',[_vm._v("\n                                    "+_vm._s(dado.nome)+"\n                                ")])]),_vm._v(" "),_c('td',{staticClass:"numerico size100 text-center value-bg-color"},[(dado.cancelado)?_c('span',{staticClass:"text-danger"},[_vm._v("\n                                    "+_vm._s(_vm._f("formatData")(dado.pagamento))+"\n                                ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"numerico size100 text-center value-bg-color"},[_c('span',{class:dado.vencido ? 'text-warning' : ''},[_vm._v("\n                                    "+_vm._s(_vm._f("formatData")(dado.vencimento))+"\n                                ")])]),_vm._v(" "),_c('td',{staticClass:"numerico size100 text-center value-bg-color"},[(!dado.cancelado)?_c('span',[_vm._v("\n                                    "+_vm._s(_vm._f("formatData")(dado.pagamento))+"\n                                ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"numerico size100 text-center value-bg-color"},[_c('span',[_vm._v("\n                                    "+_vm._s(_vm._f("formatValue")(dado.vlr,2))+"\n                                ")])]),_vm._v(" "),_c('td',{staticClass:"numerico size100 text-center value-bg-color"},[(dado.baixado)?_c('i',{staticClass:"fa fa-check fa-fw text-success py-2",staticStyle:{"font-size":"1.1rem"}}):_vm._e(),_vm._v(" "),(dado.vencido)?_c('i',{staticClass:"fa fa-clock-o fa-fw text-warning py-2",staticStyle:{"font-size":"1.1rem"}}):_vm._e(),_vm._v(" "),(dado.cancelado)?_c('i',{staticClass:"fa fa-times fa-fw text-danger py-2",staticStyle:{"font-size":"1.1rem"}}):_vm._e(),_vm._v(" "),(dado.aberto && !dado.vencido)?_c('i',{staticClass:"fa fa-money fa-fw text-primary py-2",staticStyle:{"font-size":"1.1rem"}}):_vm._e(),_vm._v(" "),(dado.perdido)?_c('i',{staticClass:"fa fa-exclamation-circle fa-fw text-danger py-2",staticStyle:{"font-size":"1.1rem"}}):_vm._e()])])}),0),_vm._v(" "),_c('tfoot')])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("\n                    POSIÇÃO DE CONTAS\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-2"},[_c('h2',[_vm._v("Totais")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"numerico size100 textual text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                Emissão\n                            ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 textual text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                Nr Documento / Parcela\n                            ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 textual text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                Natureza Financeira\n                            ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 textual text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                Cliente / Fornecedor\n                            ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 textual text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                Cancelamento\n                            ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 textual text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                Vencimento\n                            ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 textual text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                Pagamento\n                            ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 textual text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                Valor (R$)\n                            ")]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_financeiro_baixas_vue__ = __webpack_require__(782);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_19eb5d88_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_financeiro_baixas_vue__ = __webpack_require__(2255);
function injectStyle (ssrContext) {
  __webpack_require__(2253)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19eb5d88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_consulta_financeiro_baixas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_19eb5d88_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_consulta_financeiro_baixas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2254);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("575fb4a0", content, true, {});

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".text-navy-blue[data-v-19eb5d88]{color:#174b79!important}.text-blue[data-v-19eb5d88]{color:#2469a5!important}.total[data-v-19eb5d88]{padding:0 .25rem}.total p[data-v-19eb5d88]{color:#808080bb;text-align:end;font-size:.85rem;font-weight:700;margin-bottom:-7.5px}.total small[data-v-19eb5d88]{font-size:1rem;font-weight:500;padding-right:.25rem;color:#212529!important}.total span[data-v-19eb5d88]{font-size:1.85rem;font-weight:700;cursor:pointer}.data-table[data-v-19eb5d88]{overflow:auto}table .textual[data-v-19eb5d88]{font-size:12px;padding:4.8px}table .numerico[data-v-19eb5d88]{font-size:12px;min-width:65px;text-align:right}table .size130[data-v-19eb5d88]{min-width:130px}table .size100[data-v-19eb5d88]{width:100px}table .total[data-v-19eb5d88]{background:#c1c4c7;border:none}table .var[data-v-19eb5d88]{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative[data-v-19eb5d88]{color:#fff;background:#cd5c5c}table .var-positive[data-v-19eb5d88]{color:#fff;background:green}table .border-left[data-v-19eb5d88]{border-left:1px solid #dee2e6}.value-bg-color[data-v-19eb5d88]{background-color:#fafffa!important}.consulta__total[data-v-19eb5d88]{display:flex;align-items:center;justify-content:center}.consulta__total_valor[data-v-19eb5d88]{font-size:40px;display:block;line-height:normal}.consulta__cifrao[data-v-19eb5d88]{font-size:16px;display:block;line-height:normal}.lvl-1[data-v-19eb5d88],.lvl-2[data-v-19eb5d88]{margin-left:.3rem}.lvl-3[data-v-19eb5d88]{margin-left:1.5rem}.lvl-4[data-v-19eb5d88]{margin-left:2.5rem}.title-upper[data-v-19eb5d88]{text-transform:uppercase}", ""]);

// exports


/***/ }),
/* 2255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"default-container"},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('v-label',{attrs:{"label":"Período"}}),_vm._v(" "),_c('input-month2',{attrs:{"p-month":_vm.periodo}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('form-field',{attrs:{"type":"select","label":"Tipo de Fluxo","select-options":_vm.tipoOptions},model:{value:(_vm.tipo),callback:function ($$v) {_vm.tipo=$$v},expression:"tipo"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 d-flex align-items-center"},[_c('v-button',{attrs:{"label":"Filtrar","success":true},on:{"click":_vm.loadData}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.dados.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('span',{staticClass:"lbl-deal-title title-upper mb-2"},[_vm._v("\n                   "+_vm._s(_vm.titulo)+"\n                ")])])]):_vm._e(),_vm._v(" "),(_vm.dados.length == 0)?_c('div',{staticClass:"row"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.dados.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"data-table col-6 lbl-title"},[_c('table',{staticClass:"table table-bordered table-sm responsive w-100 bg-light"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.dados),function(dado,index){return _c('tr',{key:index},[_c('th',{staticClass:"textual"},[_c('span',{class:'lvl-' + dado.nivel},[_vm._v("\n                                    "+_vm._s(dado.natureza)+"\n                                ")])]),_vm._v(" "),_c('td',{staticClass:"numerico size100 text-center value-bg-color"},[_c('span',[_vm._v("\n                                    "+_vm._s(_vm._f("formatValue")(dado.valor,2))+"\n                                ")])])])}),0),_vm._v(" "),_c('tfoot')])]),_vm._v(" "),(_vm.grafico)?_c('div',{staticClass:"grafico col-6 lbl-title"},[_c('div',{staticClass:"border"},[_c('chart',{attrs:{"params":_vm.paramsChart}})],1)]):_vm._e()]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"lbl-deal-title mb-2 w-100"},[_vm._v("\n                    ANÁLISE DE PAGAMENTOS\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('span',{staticClass:"lbl-deal-title title-upper mb-5 mt-5"},[_vm._v("\n                   NÃO HÁ DADOS A SEREM EXIBIDOS\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"numerico size100 textual text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                Natureza\n                            ")]),_vm._v(" "),_c('th',{staticClass:"numerico size100 textual text-center",attrs:{"colspan":"1"}},[_vm._v("\n                                Valor (R$)\n                            ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_contador_empresas_vue__ = __webpack_require__(783);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e582be5_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_contador_empresas_vue__ = __webpack_require__(2261);
function injectStyle (ssrContext) {
  __webpack_require__(2257)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e582be5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_contador_empresas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e582be5_hasScoped_true_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_contador_empresas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2258);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("fc95cab4", content, true, {});

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".nb-conecta-container[data-v-7e582be5]{font-family:Plus Jakarta Sans,Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;color:#0b1c30;max-width:1440px;margin:0 auto}.nb-header-card[data-v-7e582be5]{background:#fff;border:1px solid #e2e8f0;border-radius:12px;padding:16px 24px;box-shadow:0 1px 3px rgba(0,0,0,.03)}.nb-logo-wrapper[data-v-7e582be5]{display:flex;align-items:center;justify-content:center}.nb-logo-conecta[data-v-7e582be5]{height:70px;width:70px;object-fit:contain;transition:all .2s ease;filter:drop-shadow(0 1px 2px rgba(0,0,0,.05))}.nb-logo-escritorio[data-v-7e582be5]{width:44px;height:44px;object-fit:contain;border-radius:8px;border:1px solid #e2e8f0;padding:3px;background:#fff}.nb-logo-placeholder[data-v-7e582be5]{width:44px;height:44px;border-radius:8px;background:#eff4ff;color:#004e94;display:flex;align-items:center;justify-content:center;font-size:18px}.nb-escritorio-nome[data-v-7e582be5]{font-size:16px;color:#0b1c30;letter-spacing:-.2px}@media (min-width:992px){.border-lg-right[data-v-7e582be5]{border-right:1px solid #e2e8f0}}@media (max-width:768px){.nb-logo-conecta[data-v-7e582be5]{height:54px;width:54px}}.dash-kpi-card[data-v-7e582be5]{background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 2px rgba(0,0,0,.03);position:relative;overflow:hidden;min-height:100px;transition:all .2s ease}.dash-kpi-card[data-v-7e582be5]:hover{transform:translateY(-2px);box-shadow:0 4px 10px rgba(0,0,0,.06)}.kpi-top-bar[data-v-7e582be5]{height:3px;width:100%}.kpi-accent-0 .kpi-top-bar[data-v-7e582be5]{background:#004e94}.kpi-accent-1 .kpi-top-bar[data-v-7e582be5]{background:#ef4444}.kpi-accent-2 .kpi-top-bar[data-v-7e582be5]{background:#f59e0b}.kpi-accent-3 .kpi-top-bar[data-v-7e582be5]{background:#10b981}.kpi-title[data-v-7e582be5]{font-size:11.5px;font-weight:600;color:#64748b;text-transform:uppercase;letter-spacing:.4px}.kpi-value[data-v-7e582be5]{font-family:Plus Jakarta Sans,Inter,sans-serif;font-size:24px;font-weight:700;color:#0b1c30;letter-spacing:-.5px;line-height:1.2}.kpi-icon-wrapper[data-v-7e582be5]{width:32px;height:32px;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:14px}.kpi-icon-bg-0[data-v-7e582be5]{background:#eff4ff;color:#004e94}.kpi-icon-bg-1[data-v-7e582be5]{background:#fffbeb;color:#d97706}.kpi-icon-bg-2[data-v-7e582be5]{background:#ecfdf5;color:#059669}.kpi-icon-bg-red[data-v-7e582be5]{background:#fef2f2;color:#dc2626}.kpi-meta-footer[data-v-7e582be5]{border-top:1px dashed #e2e8f0}.font-11[data-v-7e582be5]{font-size:11px}.font-10[data-v-7e582be5]{font-size:10px}.font-12[data-v-7e582be5]{font-size:12px}.font-mono[data-v-7e582be5]{font-family:SFMono-Regular,Menlo,Monaco,Consolas,monospace}.text-warning-dark[data-v-7e582be5]{color:#d97706}.nb-toolbar-card[data-v-7e582be5]{background:#fff;border:1px solid #e2e8f0;border-radius:12px;padding:12px 18px;box-shadow:0 1px 3px rgba(0,0,0,.03)}.nb-search-wrapper[data-v-7e582be5]{position:relative;display:flex;align-items:center}.nb-search-icon[data-v-7e582be5]{position:absolute;left:12px;color:#94a3b8;font-size:13px}.nb-search-input[data-v-7e582be5]{padding-left:36px;padding-right:32px;height:38px;border-radius:8px;border:1px solid #cbd5e1;font-size:13px;transition:all .15s ease}.nb-search-input[data-v-7e582be5]:focus{border-color:#004e94;box-shadow:0 0 0 3px rgba(0,78,148,.1)}.nb-search-clear[data-v-7e582be5]{position:absolute;right:8px;color:#94a3b8;font-size:16px;padding:0 6px;background:transparent;border:none}.nb-pill-group[data-v-7e582be5]{display:flex;gap:6px}.nb-pill-btn[data-v-7e582be5]{background:#f8fafc;border:1px solid #cbd5e1;color:#475569;font-size:12.5px;font-weight:600;padding:6px 12px;border-radius:20px;cursor:pointer;transition:all .15s ease}.nb-pill-btn[data-v-7e582be5]:hover{background:#f1f5f9;color:#0b1c30}.nb-pill-btn.active[data-v-7e582be5]{background:#004e94;border-color:#004e94;color:#fff}.nb-dash-card[data-v-7e582be5]{background:#fff;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;box-shadow:0 1px 3px rgba(0,0,0,.03)}.nb-dash-header[data-v-7e582be5]{padding:14px 20px;border-bottom:1px solid #f1f5f9;display:flex;align-items:center;justify-content:space-between;background:#fff}.nb-dash-title-text[data-v-7e582be5]{font-size:14px;font-weight:700;color:#0b1c30;letter-spacing:-.2px}.nb-badge-count[data-v-7e582be5]{font-size:11px;font-weight:600;background:#eff4ff;color:#004e94;padding:2px 8px;border-radius:12px}.nb-table thead th[data-v-7e582be5]{background:#f8fafc;color:#64748b;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;border-bottom:1px solid #e2e8f0;padding:12px 16px}.nb-table tbody td[data-v-7e582be5]{padding:14px 16px;vertical-align:middle;border-bottom:1px solid #f1f5f9;font-size:13px}.nb-table tbody tr[data-v-7e582be5]:hover{background-color:#f8fafc}.badge-soft[data-v-7e582be5]{display:inline-flex;align-items:center;font-size:11.5px;font-weight:600;padding:3px 8px;border-radius:6px;text-decoration:none!important}.badge-success-soft[data-v-7e582be5]{background:#ecfdf5;color:#059669;border:1px solid #a7f3d0}.badge-warning-soft[data-v-7e582be5]{background:#fffbeb;color:#d97706;border:1px solid #fde68a}.badge-danger-soft[data-v-7e582be5]{background:#fef2f2;color:#dc2626;border:1px solid #fecaca}.badge-info-soft[data-v-7e582be5]{background:#eff4ff;color:#004e94;border:1px solid #dce9ff}.badge-secondary-soft[data-v-7e582be5]{background:#f1f5f9;color:#64748b;border:1px solid #e2e8f0}.nb-btn-primary[data-v-7e582be5]{background:#004e94;color:#fff;border:1px solid #004e94;font-weight:600;font-size:12.5px;padding:6px 12px;border-radius:8px;transition:all .15s ease}.nb-btn-primary[data-v-7e582be5]:hover{background:#00376c;color:#fff}.nb-btn-secondary[data-v-7e582be5]{background:#fff;color:#0b1c30;border:1px solid #cbd5e1;font-weight:600;font-size:12.5px;padding:6px 12px;border-radius:8px;transition:all .15s ease}.nb-btn-secondary[data-v-7e582be5]:hover{background:#f8fafc;border-color:#94a3b8}.nb-btn-logout[data-v-7e582be5]{background:#fff;color:#dc2626;border:1px solid #fecaca;font-weight:600;font-size:12.5px;padding:6px 12px;border-radius:8px;transition:all .15s ease}.nb-btn-logout[data-v-7e582be5]:hover{background:#fee2e2;color:#b91c1c}.nb-btn-action-icon[data-v-7e582be5]{background:#f1f5f9;color:#475569;border:1px solid #e2e8f0;width:32px;height:32px;border-radius:6px;padding:0;display:inline-flex;align-items:center;justify-content:center;transition:all .15s ease}.nb-btn-action-icon[data-v-7e582be5]:hover{background:#e2e8f0;color:#0b1c30}.nb-btn-access[data-v-7e582be5]{background:#004e94;color:#fff;border:1px solid #004e94;font-size:12px;font-weight:600;padding:6px 12px;border-radius:6px;transition:all .15s ease}.nb-btn-access[data-v-7e582be5]:hover{background:#00376c;color:#fff}.nb-empty-state[data-v-7e582be5]{padding:30px}.nb-empty-icon[data-v-7e582be5]{font-size:32px;color:#cbd5e1}.nb-modal-content[data-v-7e582be5]{border-radius:12px;border:none;overflow:hidden;box-shadow:0 10px 30px rgba(0,0,0,.2);background:#fff}.nb-modal-header-icon[data-v-7e582be5]{width:36px;height:36px;border-radius:8px;background:#eff4ff;color:#004e94;display:flex;align-items:center;justify-content:center;font-size:16px}.nb-inner-card[data-v-7e582be5]{border:1px solid #e2e8f0;border-radius:10px;box-shadow:none}", ""]);

// exports


/***/ }),
/* 2259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_perfil_contador_form_vue__ = __webpack_require__(784);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d4dab41_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_perfil_contador_form_vue__ = __webpack_require__(2260);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_script_index_0_perfil_contador_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d4dab41_hasScoped_false_buble_transforms_node_modules_pnpm_vue_loader_13_7_3_babel_core_6_26_3_css_loader_0_28_11_vue_template_compiler_2_7_16_webpack_3_12_0_node_modules_vue_loader_lib_selector_type_template_index_0_perfil_contador_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-manut',{attrs:{"single-entity":"Perfil do Contador","plural-entity":"Perfil do Contador","crud":this.crud,"btn-delete":false},on:{"closeform":_vm.closeForm,"save":_vm.handleSave}}),_vm._v(" "),_c('tabs',{staticClass:"mb-4",attrs:{"tabs":_vm.tabs,"setActiveTab":_vm.activeTab},on:{"onClickTab":_vm.changeTab}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"default-container"},[((_vm.errmessages && _vm.errmessages.length) || _vm.errors.any())?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._l((_vm.errmessages),function(msg,idx){return _c('div',{key:idx},[_vm._v(_vm._s(msg))])}),_vm._v(" "),_vm._l((_vm.errors.all()),function(error){return _c('div',{key:error},[_vm._v(_vm._s(error))])})],2):_vm._e(),_vm._v(" "),(_vm.tabUsuario)?_c('div',{attrs:{"data-vv-scope":"usuario"}},[_c('label-title',{attrs:{"title":"Dados de Acesso do Usuário","icon":""}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, max: 60}),expression:"{required: true, max: 60}"}],ref:"nome",attrs:{"type":"text","col":"6","label":"Nome do Usuário","name":"nome","v-errors":_vm.errors},model:{value:(_vm.usuario.nome),callback:function ($$v) {_vm.$set(_vm.usuario, "nome", $$v)},expression:"usuario.nome"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, max: 255, email: true}),expression:"{required: true, max: 255, email: true}"}],attrs:{"type":"email","col":"6","label":"Email de Login","disabled":true,"name":"email","v-errors":_vm.errors},model:{value:(_vm.usuario.email),callback:function ($$v) {_vm.$set(_vm.usuario, "email", $$v)},expression:"usuario.email"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({max: 30}),expression:"{max: 30}"}],attrs:{"type":"fone","col":"3","label":"Telefone de Contato","name":"fone","v-errors":_vm.errors},model:{value:(_vm.usuario.fone),callback:function ($$v) {_vm.$set(_vm.usuario, "fone", $$v)},expression:"usuario.fone"}})],1),_vm._v(" "),_c('label-title',{staticClass:"mt-4",attrs:{"title":"Alterar Senha","icon":""}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({max: 20}),expression:"{max: 20}"}],attrs:{"type":"password","col":"6","label":"Nova Senha","name":"senha1","v-errors":_vm.errors},model:{value:(_vm.senha1),callback:function ($$v) {_vm.senha1=$$v},expression:"senha1"}},[_c('span',{staticClass:"data-list w-100"},[_c('small',[_vm._v("Defina a senha com no máximo 20 caracteres (deixe em branco para não alterar)")])])])],1),_vm._v(" "),(_vm.senha1)?_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, max: 20}),expression:"{required: true, max: 20}"}],attrs:{"type":"password","col":"6","label":"Repetir Nova Senha","name":"senha2","v-errors":_vm.errors},model:{value:(_vm.senha2),callback:function ($$v) {_vm.senha2=$$v},expression:"senha2"}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.tabFilial)?_c('div',{attrs:{"data-vv-scope":"filial"}},[_c('label-title',{attrs:{"title":"Dados da Filial / Escritório de Contabilidade","icon":""}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"nomeFilial",attrs:{"type":"text","col":"6","label":"Nome / Razão Social da Filial","name":"nome_filial","v-errors":_vm.errors},model:{value:(_vm.filial.nome),callback:function ($$v) {_vm.$set(_vm.filial, "nome", $$v)},expression:"filial.nome"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"cep","col":"3","label":"CEP","name":"cep","id":"cep","v-errors":_vm.errors},on:{"update":_vm.updateCep},model:{value:(_vm.filial.cep),callback:function ($$v) {_vm.$set(_vm.filial, "cep", $$v)},expression:"filial.cep"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","col":"6","label":"Endereço","name":"ende","id":"ende","v-errors":_vm.errors},model:{value:(_vm.filial.ende),callback:function ($$v) {_vm.$set(_vm.filial, "ende", $$v)},expression:"filial.ende"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","col":"2","label":"Número","name":"endenr","id":"endenr","v-errors":_vm.errors},model:{value:(_vm.filial.endenr),callback:function ($$v) {_vm.$set(_vm.filial, "endenr", $$v)},expression:"filial.endenr"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","col":"4","label":"Complemento","name":"endecomp","id":"endecomp","v-errors":_vm.errors},model:{value:(_vm.filial.endecomp),callback:function ($$v) {_vm.$set(_vm.filial, "endecomp", $$v)},expression:"filial.endecomp"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","col":"4","label":"Bairro","name":"bairro","id":"bairro","v-errors":_vm.errors},model:{value:(_vm.filial.bairro),callback:function ($$v) {_vm.$set(_vm.filial, "bairro", $$v)},expression:"filial.bairro"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"select2","col":"4","label":"Estado (UF)","name":"uf","id":"uf","v-errors":_vm.errors},model:{value:(_vm.filial.uf),callback:function ($$v) {_vm.$set(_vm.filial, "uf", $$v)},expression:"filial.uf"}}),_vm._v(" "),_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"select2","col":"4","label":"Cidade","name":"codmun","id":"codmun","v-errors":_vm.errors,"select2":{ entity: 'mun/uf/' + _vm.filial.uf, minlength: 2 }},model:{value:(_vm.filial.codmun),callback:function ($$v) {_vm.$set(_vm.filial, "codmun", $$v)},expression:"filial.codmun"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"fone","col":"4","label":"Telefone Comercial 1","name":"fone1","v-errors":_vm.errors},model:{value:(_vm.filial.fone1),callback:function ($$v) {_vm.$set(_vm.filial, "fone1", $$v)},expression:"filial.fone1"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"fone","col":"4","label":"Telefone Comercial 2","name":"fone2","v-errors":_vm.errors},model:{value:(_vm.filial.fone2),callback:function ($$v) {_vm.$set(_vm.filial, "fone2", $$v)},expression:"filial.fone2"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"fone","col":"4","label":"Telefone Comercial 3","name":"fone3","v-errors":_vm.errors},model:{value:(_vm.filial.fone3),callback:function ($$v) {_vm.$set(_vm.filial, "fone3", $$v)},expression:"filial.fone3"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"type":"email","col":"6","label":"E-mail da Filial","name":"filial_email","v-errors":_vm.errors},model:{value:(_vm.filial.email),callback:function ($$v) {_vm.$set(_vm.filial, "email", $$v)},expression:"filial.email"}})],1),_vm._v(" "),_c('label-title',{staticClass:"mt-4",attrs:{"title":"Logotipo da Filial","icon":""}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-12"},[(_vm.filial.codfil)?_c('div',{staticStyle:{"padding":"10px"}},[(_vm.image)?_c('img',{staticClass:"img-thumbnail d-block mb-2",staticStyle:{"max-width":"150px","max-height":"150px","cursor":"pointer"},attrs:{"src":_vm.image,"alt":"Logotipo"},on:{"click":function($event){return _vm.handleClickLogotipo()}}}):_vm._e(),_vm._v(" "),(_vm.image)?_c('span',{staticClass:"data-list text-danger",staticStyle:{"cursor":"pointer"},on:{"click":_vm.apiDeleteImage}},[_vm._m(0)]):_vm._e(),_vm._v(" "),(!_vm.image)?_c('i',{staticClass:"fa fa-camera d-block mb-2",staticStyle:{"font-size":"72px","color":"silver","cursor":"pointer"},on:{"click":function($event){return _vm.handleClickLogotipo()}}}):_vm._e(),_vm._v(" "),(!_vm.image)?_c('span',{staticClass:"data-list",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.handleClickLogotipo()}}},[_vm._v("Selecionar Imagem")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"file",attrs:{"id":"anexo","type":"file","accept":"image/*"},on:{"change":function($event){return _vm.handleUpload($event)}}})])])])],1):_vm._e()])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}}),_vm._v(" Remover Imagem")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-conecta-container py-4 px-3 px-md-4"},[_c('div',{staticClass:"nb-header-card mb-4"},[_c('div',{staticClass:"d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3"},[_c('div',{staticClass:"d-flex flex-wrap align-items-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center py-1"},[(_vm.logoContador)?_c('img',{staticClass:"mr-3 nb-logo-escritorio",attrs:{"src":_vm.logoContador,"alt":"Logo do Escritório"}}):_c('div',{staticClass:"mr-3 nb-logo-placeholder"},[_c('i',{staticClass:"fa fa-briefcase"})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"d-flex align-items-center flex-wrap"},[_c('h5',{staticClass:"mb-0 font-weight-bold nb-escritorio-nome"},[_vm._v("\n                "+_vm._s(_vm.nomeFilial || _vm.nomeEscritorio || 'Escritório Contábil')+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"badge badge-info-soft ml-2"},[_vm._v("Painel do Contador")])]),_vm._v(" "),_c('span',{staticClass:"text-muted small"},[_c('i',{staticClass:"fa fa-user-circle-o mr-1"}),_vm._v("\n              Responsável: "),_c('strong',[_vm._v(_vm._s(_vm.nomeUsuario))])])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center flex-wrap gap-2 mt-2 mt-lg-0"},[_c('button',{staticClass:"btn nb-btn-secondary mr-2",on:{"click":_vm.handleEditProfile}},[_c('i',{staticClass:"fa fa-user mr-1"}),_vm._v(" Editar Perfil\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn nb-btn-logout",on:{"click":_vm.handleLogout}},[_c('i',{staticClass:"fa fa-sign-out mr-1"}),_vm._v(" Sair\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-xl-3 col-sm-6 col-12 mb-3 mb-xl-0"},[_c('div',{staticClass:"dash-kpi-card kpi-accent-0"},[_c('div',{staticClass:"kpi-top-bar"}),_vm._v(" "),_c('div',{staticClass:"p-3 d-flex flex-column justify-content-between h-100"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('span',{staticClass:"kpi-value"},[_vm._v(_vm._s(_vm.totalClientes))])]),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-sm-6 col-12 mb-3 mb-xl-0"},[_c('div',{staticClass:"dash-kpi-card kpi-accent-1",class:{ 'kpi-alert-glow': _vm.totalCertificadosCriticos > 0 }},[_c('div',{staticClass:"kpi-top-bar",style:({ background: _vm.totalCertificadosCriticos > 0 ? '#ef4444' : '#10b981' })}),_vm._v(" "),_c('div',{staticClass:"p-3 d-flex flex-column justify-content-between h-100"},[_c('div',{staticClass:"d-flex justify-content-between align-items-start"},[_c('span',{staticClass:"kpi-title"},[_vm._v("Certificados Críticos")]),_vm._v(" "),_c('div',{staticClass:"kpi-icon-wrapper",class:_vm.totalCertificadosCriticos > 0 ? 'kpi-icon-bg-red' : 'kpi-icon-bg-2'},[_c('i',{staticClass:"fa fa-shield"})])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('span',{staticClass:"kpi-value",class:_vm.totalCertificadosCriticos > 0 ? 'text-danger' : 'text-success'},[_vm._v("\n              "+_vm._s(_vm.totalCertificadosCriticos)+"\n            ")])]),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-sm-6 col-12 mb-3 mb-xl-0"},[_c('div',{staticClass:"dash-kpi-card kpi-accent-2"},[_c('div',{staticClass:"kpi-top-bar",style:({ background: _vm.totalPlanosRenovacao > 0 ? '#f59e0b' : '#10b981' })}),_vm._v(" "),_c('div',{staticClass:"p-3 d-flex flex-column justify-content-between h-100"},[_c('div',{staticClass:"d-flex justify-content-between align-items-start"},[_c('span',{staticClass:"kpi-title"},[_vm._v("Planos a Encerrar")]),_vm._v(" "),_c('div',{staticClass:"kpi-icon-wrapper",class:_vm.totalPlanosRenovacao > 0 ? 'kpi-icon-bg-1' : 'kpi-icon-bg-2'},[_c('i',{staticClass:"fa fa-calendar-check-o"})])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('span',{staticClass:"kpi-value",class:_vm.totalPlanosRenovacao > 0 ? 'text-warning-dark' : 'text-success'},[_vm._v("\n              "+_vm._s(_vm.totalPlanosRenovacao)+"\n            ")])]),_vm._v(" "),_vm._m(4)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-sm-6 col-12 mb-3 mb-xl-0"},[_c('div',{staticClass:"dash-kpi-card kpi-accent-3"},[_c('div',{staticClass:"kpi-top-bar",staticStyle:{"background":"#10b981"}}),_vm._v(" "),_c('div',{staticClass:"p-3 d-flex flex-column justify-content-between h-100"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('span',{staticClass:"kpi-value text-success"},[_vm._v(_vm._s(_vm.totalClientesRegulares))])]),_vm._v(" "),_vm._m(6)])])])]),_vm._v(" "),_c('div',{staticClass:"nb-toolbar-card mb-4"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-lg-5 col-md-6 col-12 mb-2 mb-md-0"},[_c('div',{staticClass:"nb-search-wrapper"},[_c('i',{staticClass:"fa fa-search nb-search-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtroTexto),expression:"filtroTexto"}],staticClass:"form-control nb-search-input",attrs:{"type":"text","placeholder":"Buscar por razão social, nome ou CNPJ..."},domProps:{"value":(_vm.filtroTexto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filtroTexto=$event.target.value}}}),_vm._v(" "),(_vm.filtroTexto)?_c('button',{staticClass:"btn btn-sm nb-search-clear",attrs:{"type":"button"},on:{"click":function($event){_vm.filtroTexto = ''}}},[_vm._v("\n            ×\n          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-md-6 col-12 d-flex justify-content-md-end align-items-center flex-wrap gap-2"},[_c('div',{staticClass:"nb-pill-group"},[_c('button',{staticClass:"nb-pill-btn",class:{ active: _vm.filtroStatus === 'todos' },on:{"click":function($event){_vm.filtroStatus = 'todos'}}},[_vm._v("\n            Todos ("+_vm._s(_vm.totalClientes)+")\n          ")]),_vm._v(" "),_c('button',{staticClass:"nb-pill-btn",class:{ active: _vm.filtroStatus === 'cert_critico' },on:{"click":function($event){_vm.filtroStatus = 'cert_critico'}}},[_c('i',{staticClass:"fa fa-shield text-danger mr-1"}),_vm._v(" Certificados ("+_vm._s(_vm.totalCertificadosCriticos)+")\n          ")]),_vm._v(" "),_c('button',{staticClass:"nb-pill-btn",class:{ active: _vm.filtroStatus === 'plano_critico' },on:{"click":function($event){_vm.filtroStatus = 'plano_critico'}}},[_c('i',{staticClass:"fa fa-shopping-cart text-warning mr-1"}),_vm._v(" Planos ("+_vm._s(_vm.totalPlanosRenovacao)+")\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"nb-dash-card"},[_c('div',{staticClass:"nb-dash-header"},[_c('div',{staticClass:"d-flex align-items-center"},[_vm._m(7),_vm._v(" "),_c('span',{staticClass:"nb-badge-count ml-2"},[_vm._v(_vm._s(_vm.empresasFiltradas.length)+" exibida(s)")])])]),_vm._v(" "),_c('div',{staticClass:"p-0 table-responsive"},[_c('table',{staticClass:"table table-hover nb-table mb-0"},[_vm._m(8),_vm._v(" "),_c('tbody',[_vm._l((_vm.empresasFiltradas),function(emp){return _c('tr',{key:emp.uuid},[_c('td',[_c('div',{staticClass:"font-weight-bold text-dark"},[_vm._v(_vm._s(emp.nome))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"font-mono text-muted font-12"},[_vm._v(_vm._s(_vm._f("formatCNPJCPF")(emp.cnpj)))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"text-muted small"},[_vm._v(_vm._s(emp.email || '-'))])]),_vm._v(" "),_c('td',[(_vm.precisaRenovarPlano(emp.data_termino_plano))?_c('a',{class:_vm.badgeDataTermino(emp.data_termino_plano),attrs:{"href":"#","title":"Renovar Plano do Cliente"},on:{"click":function($event){$event.preventDefault();return _vm.acessarEmpresaParaRenovacao(emp.uuid)}}},[_c('i',{staticClass:"fa fa-shopping-cart mr-1"}),_vm._v("\n                "+_vm._s(_vm.formatarDataTermino(emp.data_termino_plano))+"\n              ")]):_c('span',{class:_vm.badgeDataTermino(emp.data_termino_plano)},[_vm._v("\n                "+_vm._s(_vm.formatarDataTermino(emp.data_termino_plano))+"\n              ")])]),_vm._v(" "),_c('td',[(_vm.precisaCertificado(emp.validade_certificado))?_c('a',{class:_vm.badgeCertificado(emp.validade_certificado),attrs:{"href":"https://www.notabrasil.com.br/certificado-digital/#plans","target":"_blank","rel":"noopener noreferrer","title":"Comprar / Renovar Certificado Digital"}},[_c('i',{staticClass:"fa fa-shield mr-1"}),_vm._v("\n                "+_vm._s(_vm.formatarData(emp.validade_certificado))+"\n              ")]):_c('span',{class:_vm.badgeCertificado(emp.validade_certificado)},[_vm._v("\n                "+_vm._s(_vm.formatarData(emp.validade_certificado))+"\n              ")])]),_vm._v(" "),_c('td',{staticClass:"text-right text-nowrap"},[_c('button',{staticClass:"btn nb-btn-action-icon mr-1",attrs:{"title":"Consultar detalhes cadastrais e filiais"},on:{"click":function($event){return _vm.consultarEmpresa(emp.uuid)}}},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('button',{staticClass:"btn nb-btn-access",attrs:{"title":"Acessar painel do cliente"},on:{"click":function($event){return _vm.acessarEmpresa(emp.uuid)}}},[_c('span',[_vm._v("Acessar")]),_vm._v(" "),_c('i',{staticClass:"fa fa-external-link ml-1"})])])])}),_vm._v(" "),(_vm.empresasFiltradas.length === 0)?_c('tr',[_vm._m(9)]):_vm._e()],2)])])]),_vm._v(" "),(_vm.showEditProfile)?_c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1050 !important"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-full-w",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content modal-full-h nb-modal-content"},[_c('div',{staticClass:"modal-body p-0"},[_c('perfil-contador-form',{attrs:{"index":_vm.codusuario,"crud":"upd"},on:{"closeform":_vm.handleCloseProfile}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.showClientDetails)?_c('div',{staticClass:"modal nb-modal-mask",staticStyle:{"display":"block","z-index":"1050 !important","overflow-y":"auto"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-xl",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content shadow-lg border-0",staticStyle:{"border-radius":"12px","overflow":"hidden"}},[_c('div',{staticClass:"modal-header bg-white border-bottom py-3 px-4"},[_vm._m(10),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){_vm.showClientDetails = false}}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body p-4",staticStyle:{"max-height":"75vh","overflow-y":"auto"}},[(_vm.loadingClientDetails)?_c('div',{staticClass:"text-center py-5"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-3x text-primary"}),_vm._v(" "),_c('p',{staticClass:"mt-2 text-muted"},[_vm._v("Carregando dados da empresa...")])]):(_vm.selectedClient)?_c('div',[_c('div',{staticClass:"card nb-inner-card mb-4"},[_c('div',{staticClass:"card-header bg-white d-flex justify-content-between align-items-center py-3"},[_vm._m(11),_vm._v(" "),_c('button',{staticClass:"btn btn-link btn-sm font-weight-bold p-0 text-decoration-none",on:{"click":function($event){_vm.showFullData = !_vm.showFullData}}},[_vm._v("\n                  "+_vm._s(_vm.showFullData ? 'Recolher' : 'Ver todos os dados')+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 mb-3"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Razão Social")]),_vm._v(" "),_c('strong',{staticClass:"text-dark"},[_vm._v(_vm._s(_vm.selectedClient.nome))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-3"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("CNPJ")]),_vm._v(" "),_c('span',{staticClass:"font-mono"},[_vm._v(_vm._s(_vm.selectedClient.cnpj))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-3 mb-md-0"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Email")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedClient.email || '-'))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Telefone")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedClient.fone || '-'))])])]),_vm._v(" "),(_vm.showFullData)?_c('div',{staticClass:"border-top mt-3 pt-3"},[_c('h6',{staticClass:"font-weight-bold text-primary mb-3"},[_vm._v("Endereço e Cadastro")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 mb-3"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Endereço")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedClient.endereco || '-')+", "+_vm._s(_vm.selectedClient.numero || '')+" "+_vm._s(_vm.selectedClient.complemento || ''))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-3"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Bairro / CEP")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedClient.bairro || '-')+" / "+_vm._s(_vm.selectedClient.cep || '-'))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 mb-3"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Cidade / UF")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedClient.codmun || '-')+" / "+_vm._s(_vm.selectedClient.uf || '-'))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 mb-3"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Inscrição Estadual")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedClient.ie || '-'))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 mb-3"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Schema DB")]),_vm._v(" "),_c('span',{staticClass:"badge badge-info-soft font-mono"},[_vm._v(_vm._s(_vm.selectedClient.dbschema || '-'))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Data Cadastro")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatarDataGenerica(_vm.selectedClient.dtcadastro)))])])]),_vm._v(" "),_c('div',{staticClass:"border-top mt-4 pt-3"},[_c('h6',{staticClass:"font-weight-bold text-primary mb-3"},[_c('i',{staticClass:"fa fa-sitemap mr-2"}),_vm._v("Filiais Cadastradas ("+_vm._s(_vm.selectedClient.filiais ? _vm.selectedClient.filiais.length : 0)+")\n                    ")]),_vm._v(" "),(_vm.selectedClient.filiais && _vm.selectedClient.filiais.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.selectedClient.filiais),function(filial,idx){return _c('div',{key:idx,staticClass:"col-md-12 mb-3"},[_c('div',{staticClass:"card bg-light border-0 p-3 rounded-lg"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Razão Social / Fantasia")]),_vm._v(" "),_c('strong',{staticClass:"text-dark"},[_vm._v(_vm._s(filial.nome))]),_vm._v(" "),_c('span',{staticClass:"d-block text-muted small"},[_vm._v(_vm._s(filial.fantasia))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("CNPJ")]),_vm._v(" "),_c('span',{staticClass:"font-mono"},[_vm._v(_vm._s(filial.cnpj))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Inscrições")]),_vm._v(" "),_c('span',{staticClass:"d-block small"},[_c('b',[_vm._v("IE:")]),_vm._v(" "+_vm._s(filial.iest || '-'))]),_vm._v(" "),_c('span',{staticClass:"d-block small"},[_c('b',[_vm._v("IM:")]),_vm._v(" "+_vm._s(filial.imun || '-'))])]),_vm._v(" "),_c('div',{staticClass:"col-12 border-top mt-2 pt-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Endereço")]),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v(_vm._s(filial.endereco || '-')+", "+_vm._s(filial.numero || '')+" "+_vm._s(filial.complemento || ''))]),_vm._v(" "),_c('span',{staticClass:"d-block text-muted small"},[_vm._v(_vm._s(filial.bairro)+" - "+_vm._s(filial.cep)+" - "+_vm._s(filial.codmun)+"/"+_vm._s(filial.uf))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Contato")]),_vm._v(" "),_c('span',{staticClass:"d-block small"},[_vm._v(_vm._s(filial.email || '-'))]),_vm._v(" "),_c('span',{staticClass:"d-block small"},[_vm._v(_vm._s(filial.fone || '-'))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Configurações Tributárias")]),_vm._v(" "),_c('span',{staticClass:"d-block small"},[_c('b',[_vm._v("Regime:")]),_vm._v(" "+_vm._s(_vm.getDescricaoCRT(filial.crt)))]),_vm._v(" "),_c('span',{staticClass:"d-block small"},[_c('b',[_vm._v("Ambiente NF-e:")]),_vm._v(" "+_vm._s(_vm.getDescricaoAmbienteNfe(filial.tpambnfe)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 border-top mt-2 pt-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("% PIS")]),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v(_vm._s(filial.apis !== null && filial.apis !== undefined ? filial.apis + '%' : '-'))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("% COFINS")]),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v(_vm._s(filial.acofins !== null && filial.acofins !== undefined ? filial.acofins + '%' : '-'))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Classif. Trib. IBS/CBS")]),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v(_vm._s(filial.filialcclass || '-'))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase"},[_vm._v("Alíquotas IBS/CBS")]),_vm._v(" "),_c('span',{staticClass:"d-block small"},[_c('b',[_vm._v("IBS UF:")]),_vm._v(" "+_vm._s(filial.aliquotaibsuf !== null && filial.aliquotaibsuf !== undefined ? filial.aliquotaibsuf + '%' : '-'))]),_vm._v(" "),_c('span',{staticClass:"d-block small"},[_c('b',[_vm._v("CBS:")]),_vm._v(" "+_vm._s(filial.aliquotacbs !== null && filial.aliquotacbs !== undefined ? filial.aliquotacbs + '%' : '-'))])])])])])])])}),0):_c('div',{staticClass:"text-muted italic small pl-2"},[_vm._v("Nenhuma filial cadastrada.")])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 mb-4"},[_c('div',{staticClass:"card nb-inner-card h-100"},[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"d-flex justify-content-between mb-2"},[_c('span',{staticClass:"text-muted small"},[_vm._v("App Atual:")]),_vm._v(" "),_c('strong',{staticClass:"text-dark"},[_vm._v(_vm._s(_vm.selectedClient.app || '-'))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between mb-2"},[_c('span',{staticClass:"text-muted small"},[_vm._v("Plano Atual:")]),_vm._v(" "),_c('strong',{staticClass:"text-dark"},[_vm._v(_vm._s(_vm.selectedClient.codplan ? (_vm.selectedClient.codplan + ' - ' + (_vm.selectedClient.plan_nome || '')) : '-'))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between mb-2"},[_c('span',{staticClass:"text-muted small"},[_vm._v("Período:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedClient.plan_periodo || 'N/A'))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between border-top pt-2"},[_c('span',{staticClass:"text-muted small"},[_vm._v("Data de Encerramento:")]),_vm._v(" "),_c('strong',{class:_vm.verificarDataExpirada(_vm.selectedClient.dataterminoplano) ? 'text-danger' : 'text-success'},[_vm._v("\n                        "+_vm._s(_vm.formatarDataGenerica(_vm.selectedClient.dataterminoplano))+"\n                      ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-4"},[_c('div',{staticClass:"card nb-inner-card h-100"},[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"card-body p-0"},[(_vm.selectedClient.certificados && _vm.selectedClient.certificados.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-hover mb-0"},[_vm._m(14),_vm._v(" "),_c('tbody',_vm._l((_vm.selectedClient.certificados),function(cert,idx){return _c('tr',{key:idx,class:{'table-danger': _vm.verificarDataExpirada(cert.dtval)}},[_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(cert.nome))]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(_vm.formatarDataGenerica(cert.dtval))+"\n                              "),(_vm.verificarDataExpirada(cert.dtval))?_c('span',{staticClass:"badge badge-danger-soft ml-1"},[_vm._v("VENCIDO")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(cert.tpcertificado))]),_vm._v(" "),_c('td',{staticClass:"text-muted small"},[_vm._v(_vm._s(cert.filename))])])}),0)])]):_c('div',{staticClass:"text-center py-4 text-muted small"},[_vm._v("\n                      Nenhum certificado encontrado para esta empresa.\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"card nb-inner-card mb-4"},[_vm._m(15),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 mb-3 mb-md-0"},[_c('div',{staticClass:"border rounded-lg p-3 text-center bg-light"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase mb-2"},[_vm._v("Quantidade de Notas")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 border-right"},[_c('h4',{staticClass:"font-weight-bold text-primary mb-0"},[_vm._v(_vm._s(_vm.selectedClient.nf_month || 0))]),_vm._v(" "),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold font-10"},[_vm._v("Mês Atual")])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('h4',{staticClass:"font-weight-bold text-primary mb-0"},[_vm._v(_vm._s(_vm.selectedClient.nf_year || 0))]),_vm._v(" "),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold font-10"},[_vm._v("Ano Vigente")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"border rounded-lg p-3 text-center bg-light"},[_c('span',{staticClass:"d-block font-weight-bold text-muted small text-uppercase mb-2"},[_vm._v("Faturado em Notas")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 border-right"},[_c('h5',{staticClass:"font-weight-bold text-primary mb-0 text-truncate",attrs:{"title":_vm.formatarMoeda(_vm.selectedClient.nf_vlr_month)}},[_vm._v("\n                            "+_vm._s(_vm.formatarMoeda(_vm.selectedClient.nf_vlr_month))+"\n                          ")]),_vm._v(" "),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold font-10"},[_vm._v("Mês Atual")])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('h5',{staticClass:"font-weight-bold text-primary mb-0 text-truncate",attrs:{"title":_vm.formatarMoeda(_vm.selectedClient.nf_vlr_year)}},[_vm._v("\n                            "+_vm._s(_vm.formatarMoeda(_vm.selectedClient.nf_vlr_year))+"\n                          ")]),_vm._v(" "),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold font-10"},[_vm._v("Ano Vigente")])])])])])])])]),_vm._v(" "),_c('div',{staticStyle:{"height":"40px"}})]):_c('div',{staticClass:"text-center py-5"},[_c('i',{staticClass:"fa fa-info-circle text-muted fa-3x mb-3"}),_vm._v(" "),_c('p',{staticClass:"text-muted mb-0"},[_vm._v("Nenhum dado cadastral encontrado para esta empresa.")])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer bg-white border-top py-3 px-4"},[_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.showClientDetails = false}}},[_vm._v("Fechar")])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nb-logo-wrapper mr-3 mr-lg-4 mb-2 mb-lg-0 pr-lg-4 border-lg-right d-flex align-items-center"},[_c('img',{staticClass:"nb-logo-conecta",attrs:{"src":"https://s3.us-east-1.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/nbconecta.png","alt":"Nota Brasil Conecta"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between align-items-start"},[_c('span',{staticClass:"kpi-title"},[_vm._v("Empresas Clientes")]),_vm._v(" "),_c('div',{staticClass:"kpi-icon-wrapper kpi-icon-bg-0"},[_c('i',{staticClass:"fa fa-building-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kpi-meta-footer mt-2 pt-2 text-muted font-11"},[_c('span',[_c('i',{staticClass:"fa fa-database mr-1"}),_vm._v("Bases ativas no painel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kpi-meta-footer mt-2 pt-2 text-muted font-11"},[_c('span',[_c('i',{staticClass:"fa fa-clock-o mr-1"}),_vm._v("Expirados ou a vencer em < 30d")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kpi-meta-footer mt-2 pt-2 text-muted font-11"},[_c('span',[_c('i',{staticClass:"fa fa-refresh mr-1"}),_vm._v("Encerramento em < 15 dias")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between align-items-start"},[_c('span',{staticClass:"kpi-title"},[_vm._v("Situação Regular")]),_vm._v(" "),_c('div',{staticClass:"kpi-icon-wrapper kpi-icon-bg-2"},[_c('i',{staticClass:"fa fa-check-circle"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kpi-meta-footer mt-2 pt-2 text-muted font-11"},[_c('span',[_c('i',{staticClass:"fa fa-smile-o mr-1"}),_vm._v("Sem pendências imediatas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"nb-dash-title-text"},[_c('i',{staticClass:"fa fa-list-alt text-primary mr-2"}),_vm._v("Carteira de Empresas Clientes\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"width":"32%"}},[_vm._v("Nome / Razão Social")]),_vm._v(" "),_c('th',{attrs:{"width":"16%"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('th',{attrs:{"width":"16%"}},[_vm._v("Email / Contato")]),_vm._v(" "),_c('th',{attrs:{"width":"15%"}},[_vm._v("Plano")]),_vm._v(" "),_c('th',{attrs:{"width":"15%"}},[_vm._v("Certificado Digital")]),_vm._v(" "),_c('th',{staticClass:"text-right text-nowrap",attrs:{"width":"6%"}},[_vm._v("Ações")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center py-5",attrs:{"colspan":"6"}},[_c('div',{staticClass:"nb-empty-state"},[_c('i',{staticClass:"fa fa-folder-open-o nb-empty-icon mb-2"}),_vm._v(" "),_c('div',{staticClass:"font-weight-bold text-dark"},[_vm._v("Nenhuma empresa encontrada")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Ajuste os filtros de pesquisa para visualizar os registros.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"nb-modal-header-icon mr-3"},[_c('i',{staticClass:"fa fa-building"})]),_vm._v(" "),_c('div',[_c('h5',{staticClass:"modal-title font-weight-bold text-dark mb-0"},[_vm._v("Consulta Cadastral do Cliente")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Visão unificada de cadastro, filiais, plano e utilização")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',{staticClass:"mb-0 font-weight-bold text-dark"},[_c('i',{staticClass:"fa fa-info-circle mr-2 text-primary"}),_vm._v("Dados da Empresa Matriz\n                ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-white py-3"},[_c('h6',{staticClass:"mb-0 font-weight-bold text-dark"},[_c('i',{staticClass:"fa fa-cube mr-2 text-primary"}),_vm._v("Plano & Assinatura\n                      "),_c('span',{staticClass:"badge badge-info-soft ml-2"},[_vm._v("Apenas Consulta")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-white py-3"},[_c('h6',{staticClass:"mb-0 font-weight-bold text-dark"},[_c('i',{staticClass:"fa fa-shield mr-2 text-primary"}),_vm._v("Dados do Certificado\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Emitido Para")]),_vm._v(" "),_c('th',[_vm._v("Vencimento")]),_vm._v(" "),_c('th',[_vm._v("Tipo")]),_vm._v(" "),_c('th',[_vm._v("Arquivo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-white py-3"},[_c('h6',{staticClass:"mb-0 font-weight-bold text-dark"},[_c('i',{staticClass:"fa fa-bar-chart mr-2 text-primary"}),_vm._v("Consumo e Faturamento Fiscal\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, t) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = t() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.vueWysiwyg = t() : e.vueWysiwyg = t();
}("undefined" != typeof self ? self : undefined, function () {
  return function (e) {
    var t = {};function n(i) {
      if (t[i]) return t[i].exports;var o = t[i] = { i: i, l: !1, exports: {} };return e[i].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }return n.m = e, n.c = t, n.d = function (e, t, i) {
      n.o(e, t) || Object.defineProperty(e, t, { configurable: !1, enumerable: !0, get: i });
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/vue-wysiwyg/", n(n.s = 18);
  }([function (e, t, n) {
    "use strict";
    t.a = function (e, t, n, i, o, r, s, a) {
      var l = _typeof((e = e || {}).default);"object" !== l && "function" !== l || (e = e.default);var u,
          c = "function" == typeof e ? e.options : e;t && (c.render = t, c.staticRenderFns = n, c._compiled = !0);i && (c.functional = !0);r && (c._scopeId = r);s ? (u = function u(e) {
        (e = e || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (e = __VUE_SSR_CONTEXT__), o && o.call(this, e), e && e._registeredComponents && e._registeredComponents.add(s);
      }, c._ssrRegister = u) : o && (u = a ? function () {
        o.call(this, this.$root.$options.shadowRoot);
      } : o);if (u) if (c.functional) {
        c._injectStyles = u;var d = c.render;c.render = function (e, t) {
          return u.call(t), d(e, t);
        };
      } else {
        var p = c.beforeCreate;c.beforeCreate = p ? [].concat(p, u) : [u];
      }return { exports: e, options: c };
    };
  }, function (e, t, n) {
    "use strict";
    var i = new function () {
      var e = { listeners: {}, on: function on(t, n) {
          void 0 === e.listeners[t] && (e.listeners[t] = []), e.listeners[t].push(n);
        }, emit: function emit(t) {
          for (var n = arguments.length, i = Array(1 < n ? n - 1 : 0), o = 1; o < n; o++) {
            i[o - 1] = arguments[o];
          }void 0 !== e.listeners[t] && e.listeners[t].forEach(function (e) {
            return e.apply(i);
          });
        } };return e;
    }();i.options = { image: { uploadURL: "None", dropzoneOptions: {} }, hideModules: {}, paragraphSeparator: "div", maxHeight: void 0, customModules: [] }, i.utils = { getHTMLOfSelection: function getHTMLOfSelection() {
        if (void 0 !== window.getSelection) {
          var e = window.getSelection();if (0 < e.rangeCount) {
            var t = e.getRangeAt(0).cloneContents(),
                n = document.createElement("div");return n.appendChild(t), n.innerHTML;
          }
        }return "";
      } }, t.a = i;
  }, function (e, t, n) {
    "use strict";
    t.__esModule = !0;var i,
        o = n(20),
        r = (i = o) && i.__esModule ? i : { default: i };t.default = r.default || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];for (var i in n) {
          Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
        }
      }return e;
    };
  }, function (e, t) {
    var n = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();"number" == typeof __g && (__g = n);
  }, function (e, t) {
    e.exports = function (e) {
      return "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) ? null !== e : "function" == typeof e;
    };
  }, function (e, t, n) {
    e.exports = !n(6)(function () {
      return 7 != Object.defineProperty({}, "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    };
  }, function (e, t) {
    var n = e.exports = { version: "2.5.3" };"number" == typeof __e && (__e = n);
  }, function (e, t, n) {
    var i = n(9),
        o = n(10);e.exports = function (e) {
      return i(o(e));
    };
  }, function (e, t, n) {
    var i = n(37);e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
      return "String" == i(e) ? e.split("") : Object(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 == e) throw TypeError("Can't call method on  " + e);return e;
    };
  }, function (e, t) {
    var n = Math.ceil,
        i = Math.floor;e.exports = function (e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? i : n)(e);
    };
  }, function (e, t, n) {
    "use strict";
    var i = n(2),
        o = n.n(i),
        r = n(1),
        s = n(50),
        a = n.n(s),
        l = n(51),
        u = n(53),
        c = n.n(u),
        d = n(54),
        p = n.n(d),
        h = n(55),
        f = n.n(h),
        v = n(56),
        m = n.n(v),
        g = n(57),
        b = n.n(g),
        w = n(58),
        y = n.n(w),
        q = n(59),
        k = n(61),
        z = n(63),
        x = n.n(z),
        F = n(64),
        E = n.n(F),
        _ = n(65),
        C = n.n(_),
        S = n(66),
        L = n(72),
        M = n(75),
        T = n.n(M),
        A = n(76),
        O = n.n(A),
        D = [c.a, p.a, f.a, O.a, m.a, b.a, y.a, O.a, q.a, k.a, x.a, E.a, C.a, O.a, S.a, L.a, O.a, T.a];t.a = { model: { prop: "html", event: "html" }, props: { html: { type: String, default: "" }, placeholder: { type: String, default: "Enter text..." }, options: Object }, components: { Btn: l.a }, data: function data() {
        return { selection: "" };
      }, computed: { mergedOptions: function mergedOptions() {
          return o()({}, r.a.options, this.options);
        }, modules: function modules() {
          var e = this,
              t = this.mergedOptions.iconOverrides;return D.filter(function (t) {
            return void 0 === e.mergedOptions.hideModules || !e.mergedOptions.hideModules[t.title];
          }).map(function (e) {
            return void 0 !== t && void 0 !== t[e.title] && (e.icon = t[e.title]), e;
          }).concat(this.mergedOptions.customModules);
        }, btnsWithDashboards: function btnsWithDashboards() {
          return this.modules ? this.modules.filter(function (e) {
            return e.render;
          }) : [];
        }, innerHTML: { get: function get() {
            return this.$refs.content.innerHTML;
          }, set: function set(e) {
            this.$refs.content.innerHTML !== e && (this.$refs.content.innerHTML = e);
          } } }, methods: { saveSelection: function saveSelection() {
          if (void 0 !== window.getSelection) {
            if (this.selection = window.getSelection(), this.selection.getRangeAt && this.selection.rangeCount) return this.selection.getRangeAt(0);
          } else if (document.selection && document.selection.createRange) return document.selection.createRange();return null;
        }, restoreSelection: function restoreSelection(e) {
          e && (void 0 === window.getSelection ? document.selection && e.select && e.select() : (this.selection = window.getSelection(), this.selection.removeAllRanges(), this.selection.addRange(e)));
        }, clearSelection: function clearSelection() {
          this.selection = null;var e = window.getSelection();e && (void 0 !== e.empty && e.empty(), void 0 !== e.removeAllRanges && e.removeAllRanges());
        }, exec: function exec(e, t, n) {
          !1 !== n && this.selection && this.restoreSelection(this.selection), document.execCommand(e, !1, t || ""), this.clearSelection(), this.$nextTick(this.emit);
        }, onDocumentClick: function onDocumentClick(e) {
          for (var t, n = 0; n < this.btnsWithDashboards.length; n++) {
            (t = this.$refs["btn-" + this.btnsWithDashboards[n].title][0]) && t.showDashboard && !t.$el.contains(e.target) && t.closeDashboard();
          }
        }, emit: function emit() {
          this.$emit("html", this.$refs.content.innerHTML), this.$emit("change", this.$refs.content.innerHTML);
        }, onInput: a()(function () {
          this.emit();
        }, 300), onFocus: function onFocus() {
          document.execCommand("defaultParagraphSeparator", !1, this.mergedOptions.paragraphSeparator);
        }, onContentBlur: function onContentBlur() {
          this.selection = this.saveSelection();
        }, syncHTML: function syncHTML() {
          this.html !== this.$refs.content.innerHTML && (this.innerHTML = this.html);
        } }, mounted: function mounted() {
        this.unwatch = this.$watch("html", this.syncHTML, { immediate: !0 }), document.addEventListener("click", this.onDocumentClick), this.$refs.content.addEventListener("focus", this.onFocus), this.$refs.content.addEventListener("input", this.onInput), this.$refs.content.addEventListener("blur", this.onContentBlur, { capture: !0 }), this.$refs.content.style.maxHeight = this.mergedOptions.maxHeight;
      }, beforeDestroy: function beforeDestroy() {
        this.unwatch(), document.removeEventListener("click", this.onDocumentClick), this.$refs.content.removeEventListener("blur", this.onContentBlur), this.$refs.content.removeEventListener("input", this.onInput), this.$refs.content.removeEventListener("focus", this.onFocus);
      } };
  }, function (e, t, n) {
    "use strict";
    var i = n(1);t.a = { props: ["module", "options"], data: function data() {
        return { showDashboard: !1 };
      }, computed: { uid: function uid() {
          return this.$parent._uid;
        } }, methods: { closeDashboard: function closeDashboard() {
          this.showDashboard = !1;
        }, openDashboard: function openDashboard() {
          this.showDashboard = !0;
        }, exec: function exec() {
          this.$parent.exec.apply(null, arguments);
        }, onBtnClick: function onBtnClick(e) {
          var t = this;if (e.preventDefault(), void 0 !== this.module.action) this.exec.apply(null, this.module.action);else if (void 0 !== this.module.customAction) this.module.customAction(i.a.utils).forEach(function (e) {
            return t.exec.apply(null, e);
          });else if (!(void 0 === this.module.render || this.$refs.dashboard && this.$refs.dashboard.contains(e.target))) return this.showDashboard = !this.showDashboard, void i.a.emit(this.uid + "_" + (this.showDashboard ? "show" : "hide") + "_dashboard_" + this.module.title);
        } } };
  }, function (e, t, n) {
    "use strict";
    t.a = { title: "headings", description: "Headings (h1-h6)", icon: '<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1682 1664q-44 0-132.5-3.5t-133.5-3.5q-44 0-132 3.5t-132 3.5q-24 0-37-20.5t-13-45.5q0-31 17-46t39-17 51-7 45-15q33-21 33-140l-1-391q0-21-1-31-13-4-50-4h-675q-38 0-51 4-1 10-1 31l-1 371q0 142 37 164 16 10 48 13t57 3.5 45 15 20 45.5q0 26-12.5 48t-36.5 22q-47 0-139.5-3.5t-138.5-3.5q-43 0-128 3.5t-127 3.5q-23 0-35.5-21t-12.5-45q0-30 15.5-45t36-17.5 47.5-7.5 42-15q33-23 33-143l-1-57v-813q0-3 .5-26t0-36.5-1.5-38.5-3.5-42-6.5-36.5-11-31.5-16-18q-15-10-45-12t-53-2-41-14-18-45q0-26 12-48t36-22q46 0 138.5 3.5t138.5 3.5q42 0 126.5-3.5t126.5-3.5q25 0 37.5 22t12.5 48q0 30-17 43.5t-38.5 14.5-49.5 4-43 13q-35 21-35 160l1 320q0 21 1 32 13 3 39 3h699q25 0 38-3 1-11 1-32l1-320q0-139-35-160-18-11-58.5-12.5t-66-13-25.5-49.5q0-26 12.5-48t37.5-22q44 0 132 3.5t132 3.5q43 0 129-3.5t129-3.5q25 0 37.5 22t12.5 48q0 30-17.5 44t-40 14.5-51.5 3-44 12.5q-35 23-35 161l1 943q0 119 34 140 16 10 46 13.5t53.5 4.5 41.5 15.5 18 44.5q0 26-12 48t-36 22z"/></svg>', methods: { insertHeading: function insertHeading(e) {
          this.$parent.closeDashboard(), this.$emit("exec", "formatBlock", e.target.textContent);
        } } };
  }, function (e, t, n) {
    "use strict";
    var i = n(1);t.a = { title: "link", icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1520 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zm-703-705q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zm895 705q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z"/></svg>', description: "Hyperlink", props: { uid: null }, data: function data() {
        return { url: "", title: "" };
      }, methods: { insertLink: function insertLink() {
          this.$emit("exec", "insertHTML", "<a href='" + this.url + "'>" + this.title + "</a>"), this.$parent.closeDashboard(), this.url = "", this.title = "";
        } }, created: function created() {
        var e = this;i.a.on(this.uid + "_show_dashboard_link", function () {
          e.$nextTick(function () {
            e.$refs.url.focus();
          });
        });
      } };
  }, function (e, t, n) {
    "use strict";
    var i = n(2),
        o = n.n(i),
        r = n(67),
        s = n.n(r),
        a = (n(1), n(70));n.n(a);t.a = { title: "image", icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M576 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1024 384v448h-1408v-192l320-320 160 160 512-512zm96-704h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zm160 32v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z"/></svg>', description: "Insert Image", props: ["options"], components: { Dropzone: s.a }, computed: { uploadURL: function uploadURL() {
          return this.options.image.uploadURL;
        }, dropzoneOptions: function dropzoneOptions() {
          return o()({}, this.options.image.dropzoneOptions, { id: this._uid + "vwdropzone", url: this.uploadURL, autoProcessQueue: "None" !== this.uploadURL, dictDefaultMessage: '<i class="fa"><svg fill="#666" width="26" height="24" viewBox="0 0 2048 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1344 864q0-14-9-23l-352-352q-9-9-23-9t-23 9l-351 351q-10 12-10 24 0 14 9 23t23 9h224v352q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5v-352h224q13 0 22.5-9.5t9.5-22.5zm640 288q0 159-112.5 271.5t-271.5 112.5h-1088q-185 0-316.5-131.5t-131.5-316.5q0-130 70-240t188-165q-2-30-2-43 0-212 150-362t362-150q156 0 285.5 87t188.5 231q71-62 166-62 106 0 181 75t75 181q0 76-41 138 130 31 213.5 135.5t83.5 238.5z"/></svg></i><br>Click here to upload...' });
        } }, methods: { fileUploaded: function fileUploaded(e, t) {
          t && this.$emit("exec", "insertHTML", "<img src=" + t + ">");
        }, fileAdded: function fileAdded(e) {
          var t = this;if (!e || "None" === this.uploadURL) {
            var n = new FileReader();n.addEventListener("load", function () {
              t.$emit("exec", "insertHTML", "<img src=" + n.result + ">");
            }, !1), n.readAsDataURL(e);
          }
        } } };
  }, function (e, t, n) {
    "use strict";
    t.a = { title: "table", description: "Insert Table", icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M576 1376v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm128-320v1088q0 66-47 113t-113 47h-1344q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1344q66 0 113 47t47 113z"/></svg>', data: function data() {
        return { rows: 2, cols: 2 };
      }, methods: { insertTable: function insertTable() {
          var e = ("<tr>" + "<td></td>".repeat(this.cols) + "</tr>").repeat(this.rows);this.$emit("exec", "insertHTML", "<table><tbody>" + e + "</tbody></table>"), this.$parent.closeDashboard();
        } } };
  }, function (e, t, n) {
    e.exports = n(19);
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var i = n(2),
        o = n.n(i),
        r = n(48),
        s = n(1);t.default = { install: function install(e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};s.a.options = o()({}, s.a.options, t), e.component("wysiwyg", r.a);
      }, component: r.a };
  }, function (e, t, n) {
    e.exports = { default: n(21), __esModule: !0 };
  }, function (e, t, n) {
    n(22), e.exports = n(7).Object.assign;
  }, function (e, t, n) {
    var i = n(23);i(i.S + i.F, "Object", { assign: n(33) });
  }, function (e, t, n) {
    var i = n(3),
        o = n(7),
        r = n(24),
        s = n(26),
        a = function a(e, t, n) {
      var l,
          u,
          c,
          d = e & a.F,
          p = e & a.G,
          h = e & a.S,
          f = e & a.P,
          v = e & a.B,
          m = e & a.W,
          g = p ? o : o[t] || (o[t] = {}),
          b = g.prototype,
          w = p ? i : h ? i[t] : (i[t] || {}).prototype;for (l in p && (n = t), n) {
        (u = !d && w && void 0 !== w[l]) && l in g || (c = u ? w[l] : n[l], g[l] = p && "function" != typeof w[l] ? n[l] : v && u ? r(c, i) : m && w[l] == c ? function (e) {
          var t = function t(_t, n, i) {
            if (this instanceof e) {
              switch (arguments.length) {case 0:
                  return new e();case 1:
                  return new e(_t);case 2:
                  return new e(_t, n);}return new e(_t, n, i);
            }return e.apply(this, arguments);
          };return t.prototype = e.prototype, t;
        }(c) : f && "function" == typeof c ? r(Function.call, c) : c, f && ((g.virtual || (g.virtual = {}))[l] = c, e & a.R && b && !b[l] && s(b, l, c)));
      }
    };a.F = 1, a.G = 2, a.S = 4, a.P = 8, a.B = 16, a.W = 32, a.U = 64, a.R = 128, e.exports = a;
  }, function (e, t, n) {
    var i = n(25);e.exports = function (e, t, n) {
      if (i(e), void 0 === t) return e;switch (n) {case 1:
          return function (n) {
            return e.call(t, n);
          };case 2:
          return function (n, i) {
            return e.call(t, n, i);
          };case 3:
          return function (n, i, o) {
            return e.call(t, n, i, o);
          };}return function () {
        return e.apply(t, arguments);
      };
    };
  }, function (e, t) {
    e.exports = function (e) {
      if ("function" != typeof e) throw TypeError(e + " is not a function!");return e;
    };
  }, function (e, t, n) {
    var i = n(27),
        o = n(32);e.exports = n(5) ? function (e, t, n) {
      return i.f(e, t, o(1, n));
    } : function (e, t, n) {
      return e[t] = n, e;
    };
  }, function (e, t, n) {
    var i = n(28),
        o = n(29),
        r = n(31),
        s = Object.defineProperty;t.f = n(5) ? Object.defineProperty : function (e, t, n) {
      if (i(e), t = r(t, !0), i(n), o) try {
        return s(e, t, n);
      } catch (e) {}if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");return "value" in n && (e[t] = n.value), e;
    };
  }, function (e, t, n) {
    var i = n(4);e.exports = function (e) {
      if (!i(e)) throw TypeError(e + " is not an object!");return e;
    };
  }, function (e, t, n) {
    e.exports = !n(5) && !n(6)(function () {
      return 7 != Object.defineProperty(n(30)("div"), "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (e, t, n) {
    var i = n(4),
        o = n(3).document,
        r = i(o) && i(o.createElement);e.exports = function (e) {
      return r ? o.createElement(e) : {};
    };
  }, function (e, t, n) {
    var i = n(4);e.exports = function (e, t) {
      if (!i(e)) return e;var n, o;if (t && "function" == typeof (n = e.toString) && !i(o = n.call(e))) return o;if ("function" == typeof (n = e.valueOf) && !i(o = n.call(e))) return o;if (!t && "function" == typeof (n = e.toString) && !i(o = n.call(e))) return o;throw TypeError("Can't convert object to primitive value");
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return { enumerable: !(1 & e), configurable: !(2 & e), writable: !(4 & e), value: t };
    };
  }, function (e, t, n) {
    "use strict";
    var i = n(34),
        o = n(45),
        r = n(46),
        s = n(47),
        a = n(9),
        l = Object.assign;e.exports = !l || n(6)(function () {
      var e = {},
          t = {},
          n = Symbol(),
          i = "abcdefghijklmnopqrst";return e[n] = 7, i.split("").forEach(function (e) {
        t[e] = e;
      }), 7 != l({}, e)[n] || Object.keys(l({}, t)).join("") != i;
    }) ? function (e, t) {
      for (var n = s(e), l = arguments.length, u = 1, c = o.f, d = r.f; l > u;) {
        for (var p, h = a(arguments[u++]), f = c ? i(h).concat(c(h)) : i(h), v = f.length, m = 0; v > m;) {
          d.call(h, p = f[m++]) && (n[p] = h[p]);
        }
      }return n;
    } : l;
  }, function (e, t, n) {
    var i = n(35),
        o = n(44);e.exports = Object.keys || function (e) {
      return i(e, o);
    };
  }, function (e, t, n) {
    var i = n(36),
        o = n(8),
        r = n(38)(!1),
        s = n(41)("IE_PROTO");e.exports = function (e, t) {
      var n,
          a = o(e),
          l = 0,
          u = [];for (n in a) {
        n != s && i(a, n) && u.push(n);
      }for (; t.length > l;) {
        i(a, n = t[l++]) && (~r(u, n) || u.push(n));
      }return u;
    };
  }, function (e, t) {
    var n = {}.hasOwnProperty;e.exports = function (e, t) {
      return n.call(e, t);
    };
  }, function (e, t) {
    var n = {}.toString;e.exports = function (e) {
      return n.call(e).slice(8, -1);
    };
  }, function (e, t, n) {
    var i = n(8),
        o = n(39),
        r = n(40);e.exports = function (e) {
      return function (t, n, s) {
        var a,
            l = i(t),
            u = o(l.length),
            c = r(s, u);if (e && n != n) {
          for (; u > c;) {
            if ((a = l[c++]) != a) return !0;
          }
        } else for (; u > c; c++) {
          if ((e || c in l) && l[c] === n) return e || c || 0;
        }return !e && -1;
      };
    };
  }, function (e, t, n) {
    var i = n(11),
        o = Math.min;e.exports = function (e) {
      return e > 0 ? o(i(e), 9007199254740991) : 0;
    };
  }, function (e, t, n) {
    var i = n(11),
        o = Math.max,
        r = Math.min;e.exports = function (e, t) {
      return (e = i(e)) < 0 ? o(e + t, 0) : r(e, t);
    };
  }, function (e, t, n) {
    var i = n(42)("keys"),
        o = n(43);e.exports = function (e) {
      return i[e] || (i[e] = o(e));
    };
  }, function (e, t, n) {
    var i = n(3),
        o = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});e.exports = function (e) {
      return o[e] || (o[e] = {});
    };
  }, function (e, t) {
    var n = 0,
        i = Math.random();e.exports = function (e) {
      return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++n + i).toString(36));
    };
  }, function (e, t) {
    e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (e, t) {
    t.f = Object.getOwnPropertySymbols;
  }, function (e, t) {
    t.f = {}.propertyIsEnumerable;
  }, function (e, t, n) {
    var i = n(10);e.exports = function (e) {
      return Object(i(e));
    };
  }, function (e, t, n) {
    "use strict";
    var i = n(12),
        o = n(77),
        r = n(0);var s = function s(e) {
      n(49);
    },
        a = Object(r.a)(i.a, o.a, o.b, !1, s, null, null);t.a = a.exports;
  }, function (e, t) {}, function (e, t) {
    e.exports = function (e, t, n) {
      var i, o, r, s, a;function l() {
        var u = Date.now() - s;u < t && u >= 0 ? i = setTimeout(l, t - u) : (i = null, n || (a = e.apply(r, o), r = o = null));
      }null == t && (t = 100);var u = function u() {
        r = this, o = arguments, s = Date.now();var u = n && !i;return i || (i = setTimeout(l, t)), u && (a = e.apply(r, o), r = o = null), a;
      };return u.clear = function () {
        i && (clearTimeout(i), i = null);
      }, u.flush = function () {
        i && (a = e.apply(r, o), r = o = null, clearTimeout(i), i = null);
      }, u;
    };
  }, function (e, t, n) {
    "use strict";
    var i = n(13),
        o = n(52),
        r = n(0),
        s = Object(r.a)(i.a, o.a, o.b, !1, null, null, null);t.a = s.exports;
  }, function (e, t, n) {
    "use strict";
    n.d(t, "a", function () {
      return i;
    }), n.d(t, "b", function () {
      return o;
    });var i = function i() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { on: { mousedown: e.onBtnClick } }, [n("a", { class: "vw-btn-" + e.module.title, domProps: { innerHTML: e._s(e.module.icon) } }), n("div", { directives: [{ name: "show", rawName: "v-show", value: e.showDashboard, expression: "showDashboard" }], ref: "dashboard", staticClass: "dashboard" }, [e.module.render ? e._m(0) : e._e()], 1)]);
    },
        o = [function () {
      var e = this.$createElement;return (this._self._c || e)(this.module, { ref: "moduleDashboard", tag: "component", attrs: { uid: this.uid, options: this.options }, on: { exec: this.exec } });
    }];
  }, function (e, t) {
    e.exports = { title: "bold", action: ["bold"], description: "Bold", icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M747 1521q74 32 140 32 376 0 376-335 0-114-41-180-27-44-61.5-74t-67.5-46.5-80.5-25-84-10.5-94.5-2q-73 0-101 10 0 53-.5 159t-.5 158q0 8-1 67.5t-.5 96.5 4.5 83.5 12 66.5zm-14-746q42 7 109 7 82 0 143-13t110-44.5 74.5-89.5 25.5-142q0-70-29-122.5t-79-82-108-43.5-124-14q-50 0-130 13 0 50 4 151t4 152q0 27-.5 80t-.5 79q0 46 1 69zm-541 889l2-94q15-4 85-16t106-27q7-12 12.5-27t8.5-33.5 5.5-32.5 3-37.5.5-34v-65.5q0-982-22-1025-4-8-22-14.5t-44.5-11-49.5-7-48.5-4.5-30.5-3l-4-83q98-2 340-11.5t373-9.5q23 0 68.5.5t67.5.5q70 0 136.5 13t128.5 42 108 71 74 104.5 28 137.5q0 52-16.5 95.5t-39 72-64.5 57.5-73 45-84 40q154 35 256.5 134t102.5 248q0 100-35 179.5t-93.5 130.5-138 85.5-163.5 48.5-176 14q-44 0-132-3t-132-3q-106 0-307 11t-231 12z"/></svg>' };
  }, function (e, t) {
    e.exports = { title: "italic", description: "Italic", action: ["italic"], icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M384 1662l17-85q6-2 81.5-21.5t111.5-37.5q28-35 41-101 1-7 62-289t114-543.5 52-296.5v-25q-24-13-54.5-18.5t-69.5-8-58-5.5l19-103q33 2 120 6.5t149.5 7 120.5 2.5q48 0 98.5-2.5t121-7 98.5-6.5q-5 39-19 89-30 10-101.5 28.5t-108.5 33.5q-8 19-14 42.5t-9 40-7.5 45.5-6.5 42q-27 148-87.5 419.5t-77.5 355.5q-2 9-13 58t-20 90-16 83.5-6 57.5l1 18q17 4 185 31-3 44-16 99-11 0-32.5 1.5t-32.5 1.5q-29 0-87-10t-86-10q-138-2-206-2-51 0-143 9t-121 11z"/></svg>' };
  }, function (e, t) {
    e.exports = { title: "underline", action: ["underline"], description: "Underline", icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M176 223q-37-2-45-4l-3-88q13-1 40-1 60 0 112 4 132 7 166 7 86 0 168-3 116-4 146-5 56 0 86-2l-1 14 2 64v9q-60 9-124 9-60 0-79 25-13 14-13 132 0 13 .5 32.5t.5 25.5l1 229 14 280q6 124 51 202 35 59 96 92 88 47 177 47 104 0 191-28 56-18 99-51 48-36 65-64 36-56 53-114 21-73 21-229 0-79-3.5-128t-11-122.5-13.5-159.5l-4-59q-5-67-24-88-34-35-77-34l-100 2-14-3 2-86h84l205 10q76 3 196-10l18 2q6 38 6 51 0 7-4 31-45 12-84 13-73 11-79 17-15 15-15 41 0 7 1.5 27t1.5 31q8 19 22 396 6 195-15 304-15 76-41 122-38 65-112 123-75 57-182 89-109 33-255 33-167 0-284-46-119-47-179-122-61-76-83-195-16-80-16-237v-333q0-188-17-213-25-36-147-39zm1488 1409v-64q0-14-9-23t-23-9h-1472q-14 0-23 9t-9 23v64q0 14 9 23t23 9h1472q14 0 23-9t9-23z"/></svg>' };
  }, function (e, t) {
    e.exports = { title: "justifyLeft", action: ["justifyLeft"], description: "Justify Left", icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"/></svg>' };
  }, function (e, t) {
    e.exports = { title: "justifyCenter", action: ["justifyCenter"], description: "Center", icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h896q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-640q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h640q26 0 45 19t19 45z"/></svg>' };
  }, function (e, t) {
    e.exports = { title: "justifyRight", action: ["justifyRight"], description: "Justify Right", icon: '<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"/></svg>' };
  }, function (e, t, n) {
    "use strict";
    var i = n(14),
        o = n(60),
        r = n(0),
        s = Object(r.a)(i.a, o.a, o.b, !1, null, null, null);t.a = s.exports;
  }, function (e, t, n) {
    "use strict";
    n.d(t, "a", function () {
      return i;
    }), n.d(t, "b", function () {
      return o;
    });var i = function i() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", [n("button", { attrs: { type: "button" }, on: { click: e.insertHeading } }, [e._v("H1")]), e._v(" "), n("button", { attrs: { type: "button" }, on: { click: e.insertHeading } }, [e._v("H2")]), e._v(" "), n("button", { attrs: { type: "button" }, on: { click: e.insertHeading } }, [e._v("H3")]), e._v(" "), n("button", { attrs: { type: "button" }, on: { click: e.insertHeading } }, [e._v("H4")]), e._v(" "), n("button", { attrs: { type: "button" }, on: { click: e.insertHeading } }, [e._v("H5")]), e._v(" "), n("button", { attrs: { type: "button" }, on: { click: e.insertHeading } }, [e._v("H6")])]);
    },
        o = [];
  }, function (e, t, n) {
    "use strict";
    var i = n(15),
        o = n(62),
        r = n(0),
        s = Object(r.a)(i.a, o.a, o.b, !1, null, null, null);t.a = s.exports;
  }, function (e, t, n) {
    "use strict";
    n.d(t, "a", function () {
      return i;
    }), n.d(t, "b", function () {
      return o;
    });var i = function i() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("form", { on: { submit: function submit(t) {
            t.preventDefault(), e.insertLink(t);
          } } }, [n("label", [e._v("\n        URL\n        "), n("input", { directives: [{ name: "model", rawName: "v-model", value: e.url, expression: "url" }], ref: "url", staticStyle: { width: "40%" }, attrs: { type: "text" }, domProps: { value: e.url }, on: { input: function input(t) {
            t.target.composing || (e.url = t.target.value);
          } } })]), e._v(" "), n("label", [e._v("\n        Link Title\n        "), n("input", { directives: [{ name: "model", rawName: "v-model", value: e.title, expression: "title" }], staticStyle: { width: "40%" }, attrs: { type: "text" }, domProps: { value: e.title }, on: { input: function input(t) {
            t.target.composing || (e.title = t.target.value);
          } } })]), e._v(" "), n("button", { attrs: { type: "submit" } }, [e._v("Insert")])]);
    },
        o = [];
  }, function (e, t) {
    e.exports = { title: "code", icon: '<svg height="1792" viewBox="0 0 1792 1792" width="1792" xmlns="http://www.w3.org/2000/svg"><path d="M553 1399l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23t-10 23zm591-1067l-373 1291q-4 13-15.5 19.5t-23.5 2.5l-62-17q-13-4-19.5-15.5t-2.5-24.5l373-1291q4-13 15.5-19.5t23.5-2.5l62 17q13 4 19.5 15.5t2.5 24.5zm657 651l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23t-10 23z"/></svg>', description: "Code", action: ["formatBlock", "pre"] };
  }, function (e, t) {
    e.exports = { title: "orderedList", action: ["insertOrderedList"], description: "Ordered List (1, 2, 3)", icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M381 1620q0 80-54.5 126t-135.5 46q-106 0-172-66l57-88q49 45 106 45 29 0 50.5-14.5t21.5-42.5q0-64-105-56l-26-56q8-10 32.5-43.5t42.5-54 37-38.5v-1q-16 0-48.5 1t-48.5 1v53h-106v-152h333v88l-95 115q51 12 81 49t30 88zm2-627v159h-362q-6-36-6-54 0-51 23.5-93t56.5-68 66-47.5 56.5-43.5 23.5-45q0-25-14.5-38.5t-39.5-13.5q-46 0-81 58l-85-59q24-51 71.5-79.5t105.5-28.5q73 0 123 41.5t50 112.5q0 50-34 91.5t-75 64.5-75.5 50.5-35.5 52.5h127v-60h105zm1409 319v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm-1408-899v99h-335v-99h107q0-41 .5-122t.5-121v-12h-2q-8 17-50 54l-71-76 136-127h106v404h108zm1408 387v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"/></svg>' };
  }, function (e, t) {
    e.exports = { title: "unorderedList", action: ["insertUnorderedList"], description: "Bullet List", icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M384 1408q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm0-512q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm-1408-928q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"/></svg>' };
  }, function (e, t, n) {
    "use strict";
    var i = n(16),
        o = n(71),
        r = n(0),
        s = Object(r.a)(i.a, o.a, o.b, !1, null, null, null);t.a = s.exports;
  }, function (e, t, n) {
    var i;i = function i() {
      "use strict";
      var e = { getSignedURL: function getSignedURL(e, t) {
          var n = { filePath: e.name, contentType: e.type };return new Promise(function (i, o) {
            var r = new FormData(),
                s = new XMLHttpRequest(),
                a = "function" == typeof t.signingURL ? t.signingURL(e) : t.signingURL;s.open("POST", a), s.onload = function () {
              200 == s.status ? i(JSON.parse(s.response)) : o(s.statusText);
            }, s.onerror = function (e) {
              console.error("Network Error : Could not send request to AWS (Maybe CORS errors)"), o(e);
            }, Object.entries(t.headers || {}).forEach(function (e) {
              var t = e[0],
                  n = e[1];s.setRequestHeader(t, n);
            }), n = Object.assign(n, t.params || {}), Object.entries(n).forEach(function (e) {
              var t = e[0],
                  n = e[1];r.append(t, n);
            }), s.send(r);
          });
        }, sendFile: function sendFile(e, t) {
          var n = new FormData();return this.getSignedURL(e, t).then(function (t) {
            var i = t.signature;return Object.keys(i).forEach(function (e) {
              n.append(e, i[e]);
            }), n.append("file", e), new Promise(function (e, i) {
              var o = new XMLHttpRequest();o.open("POST", t.postEndpoint), o.onload = function () {
                if (201 == o.status) {
                  var t = new window.DOMParser().parseFromString(o.response, "text/xml").firstChild.children[0].innerHTML;e({ success: !0, message: t });
                } else {
                  var n = new window.DOMParser().parseFromString(o.response, "text/xml").firstChild.children[0].innerHTML;i({ success: !1, message: n + ". Request is marked as resolved when returns as status 201" });
                }
              }, o.onerror = function (e) {
                var t = new window.DOMParser().parseFromString(o.response, "text/xml").firstChild.children[1].innerHTML;i({ success: !1, message: t });
              }, o.send(n);
            });
          }).catch(function (e) {
            return e;
          });
        } };return { render: function render() {
          var e = this,
              t = e.$createElement;return (e._self._c || t)("div", { ref: "dropzoneElement", class: { "vue-dropzone dropzone": e.includeStyling }, attrs: { id: e.id } });
        }, staticRenderFns: [], props: { id: { type: String, required: !0 }, options: { type: Object, required: !0 }, includeStyling: { type: Boolean, default: !0, required: !1 }, awss3: { type: Object, required: !1, default: null }, destroyDropzone: { type: Boolean, default: !0, required: !1 } }, data: function data() {
          return { isS3: !1, wasQueueAutoProcess: !0 };
        }, computed: { dropzoneSettings: function dropzoneSettings() {
            var e = { thumbnailWidth: 200, thumbnailHeight: 200 };return Object.keys(this.options).forEach(function (t) {
              e[t] = this.options[t];
            }, this), null !== this.awss3 && (e.autoProcessQueue = !1, this.isS3 = !0, void 0 !== this.options.autoProcessQueue && (this.wasQueueAutoProcess = this.options.autoProcessQueue)), e;
          } }, methods: { manuallyAddFile: function manuallyAddFile(e, t) {
            e.manuallyAdded = !0, this.dropzone.emit("addedfile", e), t && this.dropzone.emit("thumbnail", e, t);for (var n = e.previewElement.querySelectorAll("[data-dz-thumbnail]"), i = 0; i < n.length; i++) {
              n[i].style.width = this.dropzoneSettings.thumbnailWidth + "px", n[i].style.height = this.dropzoneSettings.thumbnailHeight + "px", n[i].style["object-fit"] = "contain";
            }this.dropzone.emit("complete", e), this.dropzone.options.maxFiles && this.dropzone.options.maxFiles--, this.dropzone.files.push(e), this.$emit("vdropzone-file-added-manually", e);
          }, setOption: function setOption(e, t) {
            this.dropzone.options[e] = t;
          }, removeAllFiles: function removeAllFiles(e) {
            this.dropzone.removeAllFiles(e);
          }, processQueue: function processQueue() {
            var e = this,
                t = this.dropzone;this.isS3 && !this.wasQueueAutoProcess ? this.getQueuedFiles().forEach(function (t) {
              e.getSignedAndUploadToS3(t);
            }) : this.dropzone.processQueue(), this.dropzone.on("success", function () {
              t.options.autoProcessQueue = !0;
            }), this.dropzone.on("queuecomplete", function () {
              t.options.autoProcessQueue = !1;
            });
          }, init: function init() {
            return this.dropzone.init();
          }, destroy: function destroy() {
            return this.dropzone.destroy();
          }, updateTotalUploadProgress: function updateTotalUploadProgress() {
            return this.dropzone.updateTotalUploadProgress();
          }, getFallbackForm: function getFallbackForm() {
            return this.dropzone.getFallbackForm();
          }, getExistingFallback: function getExistingFallback() {
            return this.dropzone.getExistingFallback();
          }, setupEventListeners: function setupEventListeners() {
            return this.dropzone.setupEventListeners();
          }, removeEventListeners: function removeEventListeners() {
            return this.dropzone.removeEventListeners();
          }, disable: function disable() {
            return this.dropzone.disable();
          }, enable: function enable() {
            return this.dropzone.enable();
          }, filesize: function filesize(e) {
            return this.dropzone.filesize(e);
          }, accept: function accept(e, t) {
            return this.dropzone.accept(e, t);
          }, addFile: function addFile(e) {
            return this.dropzone.addFile(e);
          }, removeFile: function removeFile(e) {
            this.dropzone.removeFile(e);
          }, getAcceptedFiles: function getAcceptedFiles() {
            return this.dropzone.getAcceptedFiles();
          }, getRejectedFiles: function getRejectedFiles() {
            return this.dropzone.getRejectedFiles();
          }, getFilesWithStatus: function getFilesWithStatus() {
            return this.dropzone.getFilesWithStatus();
          }, getQueuedFiles: function getQueuedFiles() {
            return this.dropzone.getQueuedFiles();
          }, getUploadingFiles: function getUploadingFiles() {
            return this.dropzone.getUploadingFiles();
          }, getAddedFiles: function getAddedFiles() {
            return this.dropzone.getAddedFiles();
          }, getActiveFiles: function getActiveFiles() {
            return this.dropzone.getActiveFiles();
          }, getSignedAndUploadToS3: function getSignedAndUploadToS3(t) {
            var n = this;e.sendFile(t, this.awss3).then(function (e) {
              e.success ? (t.s3ObjectLocation = e.message, setTimeout(function () {
                return n.dropzone.processFile(t);
              }), n.$emit("vdropzone-s3-upload-success", e.message)) : "undefined" != typeof message ? n.$emit("vdropzone-s3-upload-error", e.message) : n.$emit("vdropzone-s3-upload-error", "Network Error : Could not send request to AWS. (Maybe CORS error)");
            }).catch(function (e) {
              alert(e);
            });
          }, setAWSSigningURL: function setAWSSigningURL(e) {
            this.isS3 && (this.awss3.signingURL = e);
          } }, mounted: function mounted() {
          if (!this.$isServer || !this.hasBeenMounted) {
            this.hasBeenMounted = !0;var e = n(68);e.autoDiscover = !1, this.dropzone = new e(this.$refs.dropzoneElement, this.dropzoneSettings);var t = this;this.dropzone.on("thumbnail", function (e, n) {
              t.$emit("vdropzone-thumbnail", e, n);
            }), this.dropzone.on("addedfile", function (e) {
              t.duplicateCheck && this.files.length && this.files.forEach(function (n) {
                n.name === e.name && (this.removeFile(e), t.$emit("duplicate-file", e));
              }, this), t.$emit("vdropzone-file-added", e), t.isS3 && t.wasQueueAutoProcess && t.getSignedAndUploadToS3(e);
            }), this.dropzone.on("addedfiles", function (e) {
              t.$emit("vdropzone-files-added", e);
            }), this.dropzone.on("removedfile", function (e) {
              t.$emit("vdropzone-removed-file", e), e.manuallyAdded && t.dropzone.options.maxFiles++;
            }), this.dropzone.on("success", function (e, n) {
              t.$emit("vdropzone-success", e, n), t.isS3 && t.wasQueueAutoProcess && t.setOption("autoProcessQueue", !1);
            }), this.dropzone.on("successmultiple", function (e, n) {
              t.$emit("vdropzone-success-multiple", e, n);
            }), this.dropzone.on("error", function (e, n, i) {
              t.$emit("vdropzone-error", e, n, i);
            }), this.dropzone.on("errormultiple", function (e, n, i) {
              t.$emit("vdropzone-error-multiple", e, n, i);
            }), this.dropzone.on("sending", function (e, n, i) {
              t.isS3 && i.append("s3ObjectLocation", e.s3ObjectLocation), t.$emit("vdropzone-sending", e, n, i);
            }), this.dropzone.on("sendingmultiple", function (e, n, i) {
              t.$emit("vdropzone-sending-multiple", e, n, i);
            }), this.dropzone.on("complete", function (e) {
              t.$emit("vdropzone-complete", e);
            }), this.dropzone.on("completemultiple", function (e) {
              t.$emit("vdropzone-complete-multiple", e);
            }), this.dropzone.on("canceled", function (e) {
              t.$emit("vdropzone-canceled", e);
            }), this.dropzone.on("canceledmultiple", function (e) {
              t.$emit("vdropzone-canceled-multiple", e);
            }), this.dropzone.on("maxfilesreached", function (e) {
              t.$emit("vdropzone-max-files-reached", e);
            }), this.dropzone.on("maxfilesexceeded", function (e) {
              t.$emit("vdropzone-max-files-exceeded", e);
            }), this.dropzone.on("processing", function (e) {
              t.$emit("vdropzone-processing", e);
            }), this.dropzone.on("processing", function (e) {
              t.$emit("vdropzone-processing", e);
            }), this.dropzone.on("processingmultiple", function (e) {
              t.$emit("vdropzone-processing-multiple", e);
            }), this.dropzone.on("uploadprogress", function (e, n, i) {
              t.$emit("vdropzone-upload-progress", e, n, i);
            }), this.dropzone.on("totaluploadprogress", function (e, n, i) {
              t.$emit("vdropzone-total-upload-progress", e, n, i);
            }), this.dropzone.on("reset", function () {
              t.$emit("vdropzone-reset");
            }), this.dropzone.on("queuecomplete", function () {
              t.$emit("vdropzone-queue-complete");
            }), this.dropzone.on("drop", function (e) {
              t.$emit("vdropzone-drop", e);
            }), this.dropzone.on("dragstart", function (e) {
              t.$emit("vdropzone-drag-start", e);
            }), this.dropzone.on("dragend", function (e) {
              t.$emit("vdropzone-drag-end", e);
            }), this.dropzone.on("dragenter", function (e) {
              t.$emit("vdropzone-drag-enter", e);
            }), this.dropzone.on("dragover", function (e) {
              t.$emit("vdropzone-drag-over", e);
            }), this.dropzone.on("dragleave", function (e) {
              t.$emit("vdropzone-drag-leave", e);
            }), t.$emit("vdropzone-mounted");
          }
        }, beforeDestroy: function beforeDestroy() {
          this.destroyDropzone && this.dropzone.destroy();
        } };
    }, e.exports = i();
  }, function (e, t, n) {
    "use strict";
    (function (e) {
      var t = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
          }
        }return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();function n(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t || "object" != (typeof t === "undefined" ? "undefined" : _typeof(t)) && "function" != typeof t ? e : t;
      }function i(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }var o = function () {
        function e() {
          i(this, e);
        }return t(e, [{ key: "on", value: function value(e, t) {
            return this._callbacks = this._callbacks || {}, this._callbacks[e] || (this._callbacks[e] = []), this._callbacks[e].push(t), this;
          } }, { key: "emit", value: function value(e) {
            this._callbacks = this._callbacks || {};var t = this._callbacks[e];if (t) {
              for (var n = arguments.length, i = Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) {
                i[o - 1] = arguments[o];
              }for (var r = 0, s = s = t;;) {
                if (r >= s.length) break;s[r++].apply(this, i);
              }
            }return this;
          } }, { key: "off", value: function value(e, t) {
            if (!this._callbacks || 0 === arguments.length) return this._callbacks = {}, this;var n = this._callbacks[e];if (!n) return this;if (1 === arguments.length) return delete this._callbacks[e], this;for (var i = 0; i < n.length; i++) {
              if (n[i] === t) {
                n.splice(i, 1);break;
              }
            }return this;
          } }]), e;
      }(),
          r = function (e) {
        function r(e, t) {
          i(this, r);var o,
              s = n(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this)),
              a = void 0;if (s.element = e, s.version = r.version, s.defaultOptions.previewTemplate = s.defaultOptions.previewTemplate.replace(/\n*/g, ""), s.clickableElements = [], s.listeners = [], s.files = [], "string" == typeof s.element && (s.element = document.querySelector(s.element)), !s.element || null == s.element.nodeType) throw new Error("Invalid dropzone element.");if (s.element.dropzone) throw new Error("Dropzone already attached.");r.instances.push(s), s.element.dropzone = s;var l,
              u = null != (o = r.optionsForElement(s.element)) ? o : {};if (s.options = r.extend({}, s.defaultOptions, u, null != t ? t : {}), s.options.forceFallback || !r.isBrowserSupported()) return l = s.options.fallback.call(s), n(s, l);if (null == s.options.url && (s.options.url = s.element.getAttribute("action")), !s.options.url) throw new Error("No URL provided.");if (s.options.acceptedFiles && s.options.acceptedMimeTypes) throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");if (s.options.uploadMultiple && s.options.chunking) throw new Error("You cannot set both: uploadMultiple and chunking.");return s.options.acceptedMimeTypes && (s.options.acceptedFiles = s.options.acceptedMimeTypes, delete s.options.acceptedMimeTypes), null != s.options.renameFilename && (s.options.renameFile = function (e) {
            return s.options.renameFilename.call(s, e.name, e);
          }), s.options.method = s.options.method.toUpperCase(), (a = s.getExistingFallback()) && a.parentNode && a.parentNode.removeChild(a), !1 !== s.options.previewsContainer && (s.options.previewsContainer ? s.previewsContainer = r.getElement(s.options.previewsContainer, "previewsContainer") : s.previewsContainer = s.element), s.options.clickable && (!0 === s.options.clickable ? s.clickableElements = [s.element] : s.clickableElements = r.getElements(s.options.clickable, "clickable")), s.init(), s;
        }return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (typeof t === "undefined" ? "undefined" : _typeof(t)));e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(r, o), t(r, null, [{ key: "initClass", value: function value() {
            this.prototype.Emitter = o, this.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"], this.prototype.defaultOptions = { url: null, method: "post", withCredentials: !1, timeout: 3e4, parallelUploads: 2, uploadMultiple: !1, chunking: !1, forceChunking: !1, chunkSize: 2e6, parallelChunkUploads: !1, retryChunks: !1, retryChunksLimit: 3, maxFilesize: 256, paramName: "file", createImageThumbnails: !0, maxThumbnailFilesize: 10, thumbnailWidth: 120, thumbnailHeight: 120, thumbnailMethod: "crop", resizeWidth: null, resizeHeight: null, resizeMimeType: null, resizeQuality: .8, resizeMethod: "contain", filesizeBase: 1e3, maxFiles: null, headers: null, clickable: !0, ignoreHiddenFiles: !0, acceptedFiles: null, acceptedMimeTypes: null, autoProcessQueue: !0, autoQueue: !0, addRemoveLinks: !1, previewsContainer: null, hiddenInputContainer: "body", capture: null, renameFilename: null, renameFile: null, forceFallback: !1, dictDefaultMessage: "Drop files here to upload", dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.", dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.", dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.", dictInvalidFileType: "You can't upload files of this type.", dictResponseError: "Server responded with {{statusCode}} code.", dictCancelUpload: "Cancel upload", dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?", dictRemoveFile: "Remove file", dictRemoveFileConfirmation: null, dictMaxFilesExceeded: "You can not upload any more files.", dictFileSizeUnits: { tb: "TB", gb: "GB", mb: "MB", kb: "KB", b: "b" }, init: function init() {}, params: function params(e, t, n) {
                if (n) return { dzuuid: n.file.upload.uuid, dzchunkindex: n.index, dztotalfilesize: n.file.size, dzchunksize: this.options.chunkSize, dztotalchunkcount: n.file.upload.totalChunkCount, dzchunkbyteoffset: n.index * this.options.chunkSize };
              }, accept: function accept(e, t) {
                return t();
              }, chunksUploaded: function chunksUploaded(e, t) {
                t();
              }, fallback: function fallback() {
                var e = void 0;this.element.className = this.element.className + " dz-browser-not-supported";for (var t = 0, n = n = this.element.getElementsByTagName("div");;) {
                  if (t >= n.length) break;var i = n[t++];if (/(^| )dz-message($| )/.test(i.className)) {
                    e = i, i.className = "dz-message";break;
                  }
                }e || (e = r.createElement('<div class="dz-message"><span></span></div>'), this.element.appendChild(e));var o = e.getElementsByTagName("span")[0];return o && (null != o.textContent ? o.textContent = this.options.dictFallbackMessage : null != o.innerText && (o.innerText = this.options.dictFallbackMessage)), this.element.appendChild(this.getFallbackForm());
              }, resize: function resize(e, t, n, i) {
                var o = { srcX: 0, srcY: 0, srcWidth: e.width, srcHeight: e.height },
                    r = e.width / e.height;null == t && null == n ? (t = o.srcWidth, n = o.srcHeight) : null == t ? t = n * r : null == n && (n = t / r);var s = (t = Math.min(t, o.srcWidth)) / (n = Math.min(n, o.srcHeight));if (o.srcWidth > t || o.srcHeight > n) if ("crop" === i) r > s ? (o.srcHeight = e.height, o.srcWidth = o.srcHeight * s) : (o.srcWidth = e.width, o.srcHeight = o.srcWidth / s);else {
                  if ("contain" !== i) throw new Error("Unknown resizeMethod '" + i + "'");r > s ? n = t / r : t = n * r;
                }return o.srcX = (e.width - o.srcWidth) / 2, o.srcY = (e.height - o.srcHeight) / 2, o.trgWidth = t, o.trgHeight = n, o;
              }, transformFile: function transformFile(e, t) {
                return (this.options.resizeWidth || this.options.resizeHeight) && e.type.match(/image.*/) ? this.resizeImage(e, this.options.resizeWidth, this.options.resizeHeight, this.options.resizeMethod, t) : t(e);
              }, previewTemplate: '<div class="dz-preview dz-file-preview">\n  <div class="dz-image"><img data-dz-thumbnail /></div>\n  <div class="dz-details">\n    <div class="dz-size"><span data-dz-size></span></div>\n    <div class="dz-filename"><span data-dz-name></span></div>\n  </div>\n  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n  <div class="dz-error-message"><span data-dz-errormessage></span></div>\n  <div class="dz-success-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">\n      <title>Check</title>\n      <defs></defs>\n      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">\n        <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path>\n      </g>\n    </svg>\n  </div>\n  <div class="dz-error-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">\n      <title>Error</title>\n      <defs></defs>\n      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">\n        <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">\n          <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>', drop: function drop(e) {
                return this.element.classList.remove("dz-drag-hover");
              }, dragstart: function dragstart(e) {}, dragend: function dragend(e) {
                return this.element.classList.remove("dz-drag-hover");
              }, dragenter: function dragenter(e) {
                return this.element.classList.add("dz-drag-hover");
              }, dragover: function dragover(e) {
                return this.element.classList.add("dz-drag-hover");
              }, dragleave: function dragleave(e) {
                return this.element.classList.remove("dz-drag-hover");
              }, paste: function paste(e) {}, reset: function reset() {
                return this.element.classList.remove("dz-started");
              }, addedfile: function addedfile(e) {
                var t = this;if (this.element === this.previewsContainer && this.element.classList.add("dz-started"), this.previewsContainer) {
                  e.previewElement = r.createElement(this.options.previewTemplate.trim()), e.previewTemplate = e.previewElement, this.previewsContainer.appendChild(e.previewElement);for (var n = 0, i = i = e.previewElement.querySelectorAll("[data-dz-name]");;) {
                    if (n >= i.length) break;var o = i[n++];o.textContent = e.name;
                  }for (var s = 0, a = a = e.previewElement.querySelectorAll("[data-dz-size]"); !(s >= a.length);) {
                    (o = a[s++]).innerHTML = this.filesize(e.size);
                  }this.options.addRemoveLinks && (e._removeLink = r.createElement('<a class="dz-remove" href="javascript:undefined;" data-dz-remove>' + this.options.dictRemoveFile + "</a>"), e.previewElement.appendChild(e._removeLink));for (var l = function l(n) {
                    return n.preventDefault(), n.stopPropagation(), e.status === r.UPLOADING ? r.confirm(t.options.dictCancelUploadConfirmation, function () {
                      return t.removeFile(e);
                    }) : t.options.dictRemoveFileConfirmation ? r.confirm(t.options.dictRemoveFileConfirmation, function () {
                      return t.removeFile(e);
                    }) : t.removeFile(e);
                  }, u = 0, c = c = e.previewElement.querySelectorAll("[data-dz-remove]");;) {
                    if (u >= c.length) break;c[u++].addEventListener("click", l);
                  }
                }
              }, removedfile: function removedfile(e) {
                return null != e.previewElement && null != e.previewElement.parentNode && e.previewElement.parentNode.removeChild(e.previewElement), this._updateMaxFilesReachedClass();
              }, thumbnail: function thumbnail(e, t) {
                if (e.previewElement) {
                  e.previewElement.classList.remove("dz-file-preview");for (var n = 0, i = i = e.previewElement.querySelectorAll("[data-dz-thumbnail]");;) {
                    if (n >= i.length) break;var o = i[n++];o.alt = e.name, o.src = t;
                  }return setTimeout(function () {
                    return e.previewElement.classList.add("dz-image-preview");
                  }, 1);
                }
              }, error: function error(e, t) {
                if (e.previewElement) {
                  e.previewElement.classList.add("dz-error"), "String" != typeof t && t.error && (t = t.error);for (var n = 0, i = i = e.previewElement.querySelectorAll("[data-dz-errormessage]");;) {
                    if (n >= i.length) break;i[n++].textContent = t;
                  }
                }
              }, errormultiple: function errormultiple() {}, processing: function processing(e) {
                if (e.previewElement && (e.previewElement.classList.add("dz-processing"), e._removeLink)) return e._removeLink.textContent = this.options.dictCancelUpload;
              }, processingmultiple: function processingmultiple() {}, uploadprogress: function uploadprogress(e, t, n) {
                if (e.previewElement) for (var i = 0, o = o = e.previewElement.querySelectorAll("[data-dz-uploadprogress]");;) {
                  if (i >= o.length) break;var r = o[i++];"PROGRESS" === r.nodeName ? r.value = t : r.style.width = t + "%";
                }
              }, totaluploadprogress: function totaluploadprogress() {}, sending: function sending() {}, sendingmultiple: function sendingmultiple() {}, success: function success(e) {
                if (e.previewElement) return e.previewElement.classList.add("dz-success");
              }, successmultiple: function successmultiple() {}, canceled: function canceled(e) {
                return this.emit("error", e, "Upload canceled.");
              }, canceledmultiple: function canceledmultiple() {}, complete: function complete(e) {
                if (e._removeLink && (e._removeLink.textContent = this.options.dictRemoveFile), e.previewElement) return e.previewElement.classList.add("dz-complete");
              }, completemultiple: function completemultiple() {}, maxfilesexceeded: function maxfilesexceeded() {}, maxfilesreached: function maxfilesreached() {}, queuecomplete: function queuecomplete() {}, addedfiles: function addedfiles() {} }, this.prototype._thumbnailQueue = [], this.prototype._processingThumbnail = !1;
          } }, { key: "extend", value: function value(e) {
            for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) {
              n[i - 1] = arguments[i];
            }for (var o = 0, r = r = n;;) {
              if (o >= r.length) break;var s = r[o++];for (var a in s) {
                var l = s[a];e[a] = l;
              }
            }return e;
          } }]), t(r, [{ key: "getAcceptedFiles", value: function value() {
            return this.files.filter(function (e) {
              return e.accepted;
            }).map(function (e) {
              return e;
            });
          } }, { key: "getRejectedFiles", value: function value() {
            return this.files.filter(function (e) {
              return !e.accepted;
            }).map(function (e) {
              return e;
            });
          } }, { key: "getFilesWithStatus", value: function value(e) {
            return this.files.filter(function (t) {
              return t.status === e;
            }).map(function (e) {
              return e;
            });
          } }, { key: "getQueuedFiles", value: function value() {
            return this.getFilesWithStatus(r.QUEUED);
          } }, { key: "getUploadingFiles", value: function value() {
            return this.getFilesWithStatus(r.UPLOADING);
          } }, { key: "getAddedFiles", value: function value() {
            return this.getFilesWithStatus(r.ADDED);
          } }, { key: "getActiveFiles", value: function value() {
            return this.files.filter(function (e) {
              return e.status === r.UPLOADING || e.status === r.QUEUED;
            }).map(function (e) {
              return e;
            });
          } }, { key: "init", value: function value() {
            var e = this;if ("form" === this.element.tagName && this.element.setAttribute("enctype", "multipart/form-data"), this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message") && this.element.appendChild(r.createElement('<div class="dz-default dz-message"><span>' + this.options.dictDefaultMessage + "</span></div>")), this.clickableElements.length) {
              !function t() {
                return e.hiddenFileInput && e.hiddenFileInput.parentNode.removeChild(e.hiddenFileInput), e.hiddenFileInput = document.createElement("input"), e.hiddenFileInput.setAttribute("type", "file"), (null === e.options.maxFiles || e.options.maxFiles > 1) && e.hiddenFileInput.setAttribute("multiple", "multiple"), e.hiddenFileInput.className = "dz-hidden-input", null !== e.options.acceptedFiles && e.hiddenFileInput.setAttribute("accept", e.options.acceptedFiles), null !== e.options.capture && e.hiddenFileInput.setAttribute("capture", e.options.capture), e.hiddenFileInput.style.visibility = "hidden", e.hiddenFileInput.style.position = "absolute", e.hiddenFileInput.style.top = "0", e.hiddenFileInput.style.left = "0", e.hiddenFileInput.style.height = "0", e.hiddenFileInput.style.width = "0", document.querySelector(e.options.hiddenInputContainer).appendChild(e.hiddenFileInput), e.hiddenFileInput.addEventListener("change", function () {
                  var n = e.hiddenFileInput.files;if (n.length) for (var i = 0, o = o = n; !(i >= o.length);) {
                    var r = o[i++];e.addFile(r);
                  }return e.emit("addedfiles", n), t();
                });
              }();
            }this.URL = null !== window.URL ? window.URL : window.webkitURL;for (var t = 0, n = n = this.events;;) {
              if (t >= n.length) break;var i = n[t++];this.on(i, this.options[i]);
            }this.on("uploadprogress", function () {
              return e.updateTotalUploadProgress();
            }), this.on("removedfile", function () {
              return e.updateTotalUploadProgress();
            }), this.on("canceled", function (t) {
              return e.emit("complete", t);
            }), this.on("complete", function (t) {
              if (0 === e.getAddedFiles().length && 0 === e.getUploadingFiles().length && 0 === e.getQueuedFiles().length) return setTimeout(function () {
                return e.emit("queuecomplete");
              }, 0);
            });var o = function o(e) {
              return e.stopPropagation(), e.preventDefault ? e.preventDefault() : e.returnValue = !1;
            };return this.listeners = [{ element: this.element, events: { dragstart: function dragstart(t) {
                  return e.emit("dragstart", t);
                }, dragenter: function dragenter(t) {
                  return o(t), e.emit("dragenter", t);
                }, dragover: function dragover(t) {
                  var n = void 0;try {
                    n = t.dataTransfer.effectAllowed;
                  } catch (e) {}return t.dataTransfer.dropEffect = "move" === n || "linkMove" === n ? "move" : "copy", o(t), e.emit("dragover", t);
                }, dragleave: function dragleave(t) {
                  return e.emit("dragleave", t);
                }, drop: function drop(t) {
                  return o(t), e.drop(t);
                }, dragend: function dragend(t) {
                  return e.emit("dragend", t);
                } } }], this.clickableElements.forEach(function (t) {
              return e.listeners.push({ element: t, events: { click: function click(n) {
                    return (t !== e.element || n.target === e.element || r.elementInside(n.target, e.element.querySelector(".dz-message"))) && e.hiddenFileInput.click(), !0;
                  } } });
            }), this.enable(), this.options.init.call(this);
          } }, { key: "destroy", value: function value() {
            return this.disable(), this.removeAllFiles(!0), (null != this.hiddenFileInput ? this.hiddenFileInput.parentNode : void 0) && (this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput), this.hiddenFileInput = null), delete this.element.dropzone, r.instances.splice(r.instances.indexOf(this), 1);
          } }, { key: "updateTotalUploadProgress", value: function value() {
            var e = void 0,
                t = 0,
                n = 0;if (this.getActiveFiles().length) {
              for (var i = 0, o = o = this.getActiveFiles();;) {
                if (i >= o.length) break;var r = o[i++];t += r.upload.bytesSent, n += r.upload.total;
              }e = 100 * t / n;
            } else e = 100;return this.emit("totaluploadprogress", e, n, t);
          } }, { key: "_getParamName", value: function value(e) {
            return "function" == typeof this.options.paramName ? this.options.paramName(e) : this.options.paramName + (this.options.uploadMultiple ? "[" + e + "]" : "");
          } }, { key: "_renameFile", value: function value(e) {
            return "function" != typeof this.options.renameFile ? e.name : this.options.renameFile(e);
          } }, { key: "getFallbackForm", value: function value() {
            var e,
                t = void 0;if (e = this.getExistingFallback()) return e;var n = '<div class="dz-fallback">';this.options.dictFallbackText && (n += "<p>" + this.options.dictFallbackText + "</p>"), n += '<input type="file" name="' + this._getParamName(0) + '" ' + (this.options.uploadMultiple ? 'multiple="multiple"' : void 0) + ' /><input type="submit" value="Upload!"></div>';var i = r.createElement(n);return "FORM" !== this.element.tagName ? (t = r.createElement('<form action="' + this.options.url + '" enctype="multipart/form-data" method="' + this.options.method + '"></form>')).appendChild(i) : (this.element.setAttribute("enctype", "multipart/form-data"), this.element.setAttribute("method", this.options.method)), null != t ? t : i;
          } }, { key: "getExistingFallback", value: function value() {
            for (var e = function e(_e) {
              for (var t = 0, n = n = _e;;) {
                if (t >= n.length) break;var i = n[t++];if (/(^| )fallback($| )/.test(i.className)) return i;
              }
            }, t = ["div", "form"], n = 0; n < t.length; n++) {
              var i,
                  o = t[n];if (i = e(this.element.getElementsByTagName(o))) return i;
            }
          } }, { key: "setupEventListeners", value: function value() {
            return this.listeners.map(function (e) {
              return function () {
                var t = [];for (var n in e.events) {
                  var i = e.events[n];t.push(e.element.addEventListener(n, i, !1));
                }return t;
              }();
            });
          } }, { key: "removeEventListeners", value: function value() {
            return this.listeners.map(function (e) {
              return function () {
                var t = [];for (var n in e.events) {
                  var i = e.events[n];t.push(e.element.removeEventListener(n, i, !1));
                }return t;
              }();
            });
          } }, { key: "disable", value: function value() {
            var e = this;return this.clickableElements.forEach(function (e) {
              return e.classList.remove("dz-clickable");
            }), this.removeEventListeners(), this.files.map(function (t) {
              return e.cancelUpload(t);
            });
          } }, { key: "enable", value: function value() {
            return this.clickableElements.forEach(function (e) {
              return e.classList.add("dz-clickable");
            }), this.setupEventListeners();
          } }, { key: "filesize", value: function value(e) {
            var t = 0,
                n = "b";if (e > 0) {
              for (var i = ["tb", "gb", "mb", "kb", "b"], o = 0; o < i.length; o++) {
                var r = i[o];if (e >= Math.pow(this.options.filesizeBase, 4 - o) / 10) {
                  t = e / Math.pow(this.options.filesizeBase, 4 - o), n = r;break;
                }
              }t = Math.round(10 * t) / 10;
            }return "<strong>" + t + "</strong> " + this.options.dictFileSizeUnits[n];
          } }, { key: "_updateMaxFilesReachedClass", value: function value() {
            return null != this.options.maxFiles && this.getAcceptedFiles().length >= this.options.maxFiles ? (this.getAcceptedFiles().length === this.options.maxFiles && this.emit("maxfilesreached", this.files), this.element.classList.add("dz-max-files-reached")) : this.element.classList.remove("dz-max-files-reached");
          } }, { key: "drop", value: function value(e) {
            if (e.dataTransfer) {
              this.emit("drop", e);var t = e.dataTransfer.files;if (this.emit("addedfiles", t), t.length) {
                var n = e.dataTransfer.items;n && n.length && null != n[0].webkitGetAsEntry ? this._addFilesFromItems(n) : this.handleFiles(t);
              }
            }
          } }, { key: "paste", value: function value(e) {
            if (null != (void 0 !== (t = null != e ? e.clipboardData : void 0) && null !== t ? function (e) {
              return e.items;
            }(t) : void 0)) {
              var t;this.emit("paste", e);var n = e.clipboardData.items;return n.length ? this._addFilesFromItems(n) : void 0;
            }
          } }, { key: "handleFiles", value: function value(e) {
            var t = this;return e.map(function (e) {
              return t.addFile(e);
            });
          } }, { key: "_addFilesFromItems", value: function value(e) {
            var t = this;return function () {
              for (var n = [], i = 0, o = o = e;;) {
                if (i >= o.length) break;var r,
                    s = o[i++];null != s.webkitGetAsEntry && (r = s.webkitGetAsEntry()) ? r.isFile ? n.push(t.addFile(s.getAsFile())) : r.isDirectory ? n.push(t._addFilesFromDirectory(r, r.name)) : n.push(void 0) : null != s.getAsFile && (null == s.kind || "file" === s.kind) ? n.push(t.addFile(s.getAsFile())) : n.push(void 0);
              }return n;
            }();
          } }, { key: "_addFilesFromDirectory", value: function value(e, t) {
            var n = this,
                i = e.createReader(),
                o = function o(e) {
              return t = console, n = "log", i = function i(t) {
                return t.log(e);
              }, void 0 !== t && null !== t && "function" == typeof t[n] ? i(t, n) : void 0;var t, n, i;
            };return function e() {
              return i.readEntries(function (i) {
                if (i.length > 0) {
                  for (var o = 0, r = r = i; !(o >= r.length);) {
                    var s = r[o++];s.isFile ? s.file(function (e) {
                      if (!n.options.ignoreHiddenFiles || "." !== e.name.substring(0, 1)) return e.fullPath = t + "/" + e.name, n.addFile(e);
                    }) : s.isDirectory && n._addFilesFromDirectory(s, t + "/" + s.name);
                  }e();
                }return null;
              }, o);
            }();
          } }, { key: "accept", value: function value(e, t) {
            return e.size > 1024 * this.options.maxFilesize * 1024 ? t(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(e.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize)) : r.isValidFile(e, this.options.acceptedFiles) ? null != this.options.maxFiles && this.getAcceptedFiles().length >= this.options.maxFiles ? (t(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles)), this.emit("maxfilesexceeded", e)) : this.options.accept.call(this, e, t) : t(this.options.dictInvalidFileType);
          } }, { key: "addFile", value: function value(e) {
            var t = this;return e.upload = { uuid: r.uuidv4(), progress: 0, total: e.size, bytesSent: 0, filename: this._renameFile(e), chunked: this.options.chunking && (this.options.forceChunking || e.size > this.options.chunkSize), totalChunkCount: Math.ceil(e.size / this.options.chunkSize) }, this.files.push(e), e.status = r.ADDED, this.emit("addedfile", e), this._enqueueThumbnail(e), this.accept(e, function (n) {
              return n ? (e.accepted = !1, t._errorProcessing([e], n)) : (e.accepted = !0, t.options.autoQueue && t.enqueueFile(e)), t._updateMaxFilesReachedClass();
            });
          } }, { key: "enqueueFiles", value: function value(e) {
            for (var t = 0, n = n = e;;) {
              if (t >= n.length) break;var i = n[t++];this.enqueueFile(i);
            }return null;
          } }, { key: "enqueueFile", value: function value(e) {
            var t = this;if (e.status !== r.ADDED || !0 !== e.accepted) throw new Error("This file can't be queued because it has already been processed or was rejected.");if (e.status = r.QUEUED, this.options.autoProcessQueue) return setTimeout(function () {
              return t.processQueue();
            }, 0);
          } }, { key: "_enqueueThumbnail", value: function value(e) {
            var t = this;if (this.options.createImageThumbnails && e.type.match(/image.*/) && e.size <= 1024 * this.options.maxThumbnailFilesize * 1024) return this._thumbnailQueue.push(e), setTimeout(function () {
              return t._processThumbnailQueue();
            }, 0);
          } }, { key: "_processThumbnailQueue", value: function value() {
            var e = this;if (!this._processingThumbnail && 0 !== this._thumbnailQueue.length) {
              this._processingThumbnail = !0;var t = this._thumbnailQueue.shift();return this.createThumbnail(t, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, !0, function (n) {
                return e.emit("thumbnail", t, n), e._processingThumbnail = !1, e._processThumbnailQueue();
              });
            }
          } }, { key: "removeFile", value: function value(e) {
            if (e.status === r.UPLOADING && this.cancelUpload(e), this.files = s(this.files, e), this.emit("removedfile", e), 0 === this.files.length) return this.emit("reset");
          } }, { key: "removeAllFiles", value: function value(e) {
            null == e && (e = !1);for (var t = 0, n = n = this.files.slice();;) {
              if (t >= n.length) break;var i = n[t++];(i.status !== r.UPLOADING || e) && this.removeFile(i);
            }return null;
          } }, { key: "resizeImage", value: function value(e, t, n, i, o) {
            var s = this;return this.createThumbnail(e, t, n, i, !1, function (t, n) {
              if (null === n) return o(e);var i = s.options.resizeMimeType;null == i && (i = e.type);var a = n.toDataURL(i, s.options.resizeQuality);return "image/jpeg" !== i && "image/jpg" !== i || (a = u.restore(e.dataURL, a)), o(r.dataURItoBlob(a));
            });
          } }, { key: "createThumbnail", value: function value(e, t, n, i, o, r) {
            var s = this,
                a = new FileReader();return a.onload = function () {
              if (e.dataURL = a.result, "image/svg+xml" !== e.type) return s.createThumbnailFromUrl(e, t, n, i, o, r);null != r && r(a.result);
            }, a.readAsDataURL(e);
          } }, { key: "createThumbnailFromUrl", value: function value(e, t, n, i, o, r, s) {
            var a = this,
                u = document.createElement("img");return s && (u.crossOrigin = s), u.onload = function () {
              var s = function s(e) {
                return e(1);
              };return "undefined" != typeof EXIF && null !== EXIF && o && (s = function s(e) {
                return EXIF.getData(u, function () {
                  return e(EXIF.getTag(this, "Orientation"));
                });
              }), s(function (o) {
                e.width = u.width, e.height = u.height;var s = a.options.resize.call(a, e, t, n, i),
                    c = document.createElement("canvas"),
                    d = c.getContext("2d");switch (c.width = s.trgWidth, c.height = s.trgHeight, o > 4 && (c.width = s.trgHeight, c.height = s.trgWidth), o) {case 2:
                    d.translate(c.width, 0), d.scale(-1, 1);break;case 3:
                    d.translate(c.width, c.height), d.rotate(Math.PI);break;case 4:
                    d.translate(0, c.height), d.scale(1, -1);break;case 5:
                    d.rotate(.5 * Math.PI), d.scale(1, -1);break;case 6:
                    d.rotate(.5 * Math.PI), d.translate(0, -c.height);break;case 7:
                    d.rotate(.5 * Math.PI), d.translate(c.width, -c.height), d.scale(-1, 1);break;case 8:
                    d.rotate(-.5 * Math.PI), d.translate(-c.width, 0);}l(d, u, null != s.srcX ? s.srcX : 0, null != s.srcY ? s.srcY : 0, s.srcWidth, s.srcHeight, null != s.trgX ? s.trgX : 0, null != s.trgY ? s.trgY : 0, s.trgWidth, s.trgHeight);var p = c.toDataURL("image/png");if (null != r) return r(p, c);
              });
            }, null != r && (u.onerror = r), u.src = e.dataURL;
          } }, { key: "processQueue", value: function value() {
            var e = this.options.parallelUploads,
                t = this.getUploadingFiles().length,
                n = t;if (!(t >= e)) {
              var i = this.getQueuedFiles();if (i.length > 0) {
                if (this.options.uploadMultiple) return this.processFiles(i.slice(0, e - t));for (; n < e;) {
                  if (!i.length) return;this.processFile(i.shift()), n++;
                }
              }
            }
          } }, { key: "processFile", value: function value(e) {
            return this.processFiles([e]);
          } }, { key: "processFiles", value: function value(e) {
            for (var t = 0, n = n = e;;) {
              if (t >= n.length) break;var i = n[t++];i.processing = !0, i.status = r.UPLOADING, this.emit("processing", i);
            }return this.options.uploadMultiple && this.emit("processingmultiple", e), this.uploadFiles(e);
          } }, { key: "_getFilesWithXhr", value: function value(e) {
            return this.files.filter(function (t) {
              return t.xhr === e;
            }).map(function (e) {
              return e;
            });
          } }, { key: "cancelUpload", value: function value(e) {
            if (e.status === r.UPLOADING) {
              for (var t = this._getFilesWithXhr(e.xhr), n = 0, i = i = t;;) {
                if (n >= i.length) break;i[n++].status = r.CANCELED;
              }void 0 !== e.xhr && e.xhr.abort();for (var o = 0, s = s = t;;) {
                if (o >= s.length) break;var a = s[o++];this.emit("canceled", a);
              }this.options.uploadMultiple && this.emit("canceledmultiple", t);
            } else e.status !== r.ADDED && e.status !== r.QUEUED || (e.status = r.CANCELED, this.emit("canceled", e), this.options.uploadMultiple && this.emit("canceledmultiple", [e]));if (this.options.autoProcessQueue) return this.processQueue();
          } }, { key: "resolveOption", value: function value(e) {
            if ("function" == typeof e) {
              for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) {
                n[i - 1] = arguments[i];
              }return e.apply(this, n);
            }return e;
          } }, { key: "uploadFile", value: function value(e) {
            return this.uploadFiles([e]);
          } }, { key: "uploadFiles", value: function value(e) {
            var t = this;this._transformFiles(e, function (n) {
              if (e[0].upload.chunked) {
                var i = e[0],
                    o = n[0];i.upload.chunks = [];var s = function s() {
                  for (var n = 0; void 0 !== i.upload.chunks[n];) {
                    n++;
                  }if (!(n >= i.upload.totalChunkCount)) {
                    0;var s = n * t.options.chunkSize,
                        a = Math.min(s + t.options.chunkSize, i.size),
                        l = { name: t._getParamName(0), data: o.webkitSlice ? o.webkitSlice(s, a) : o.slice(s, a), filename: i.upload.filename, chunkIndex: n };i.upload.chunks[n] = { file: i, index: n, dataBlock: l, status: r.UPLOADING, progress: 0, retries: 0 }, t._uploadData(e, [l]);
                  }
                };if (i.upload.finishedChunkUpload = function (n) {
                  var o = !0;n.status = r.SUCCESS, n.dataBlock = null;for (var a = 0; a < i.upload.totalChunkCount; a++) {
                    if (void 0 === i.upload.chunks[a]) return s();i.upload.chunks[a].status !== r.SUCCESS && (o = !1);
                  }o && t.options.chunksUploaded(i, function () {
                    t._finished(e, "", null);
                  });
                }, t.options.parallelChunkUploads) for (var a = 0; a < i.upload.totalChunkCount; a++) {
                  s();
                } else s();
              } else {
                for (var l = [], u = 0; u < e.length; u++) {
                  l[u] = { name: t._getParamName(u), data: n[u], filename: e[u].upload.filename };
                }t._uploadData(e, l);
              }
            });
          } }, { key: "_getChunk", value: function value(e, t) {
            for (var n = 0; n < e.upload.totalChunkCount; n++) {
              if (void 0 !== e.upload.chunks[n] && e.upload.chunks[n].xhr === t) return e.upload.chunks[n];
            }
          } }, { key: "_uploadData", value: function value(e, t) {
            for (var n = this, i = new XMLHttpRequest(), o = 0, s = s = e;;) {
              if (o >= s.length) break;s[o++].xhr = i;
            }e[0].upload.chunked && (e[0].upload.chunks[t[0].chunkIndex].xhr = i);var a = this.resolveOption(this.options.method, e),
                l = this.resolveOption(this.options.url, e);i.open(a, l, !0), i.timeout = this.resolveOption(this.options.timeout, e), i.withCredentials = !!this.options.withCredentials, i.onload = function (t) {
              n._finishedUploading(e, i, t);
            }, i.onerror = function () {
              n._handleUploadError(e, i);
            }, (null != i.upload ? i.upload : i).onprogress = function (t) {
              return n._updateFilesUploadProgress(e, i, t);
            };var u = { Accept: "application/json", "Cache-Control": "no-cache", "X-Requested-With": "XMLHttpRequest" };for (var c in this.options.headers && r.extend(u, this.options.headers), u) {
              var d = u[c];d && i.setRequestHeader(c, d);
            }var p = new FormData();if (this.options.params) {
              var h = this.options.params;for (var f in "function" == typeof h && (h = h.call(this, e, i, e[0].upload.chunked ? this._getChunk(e[0], i) : null)), h) {
                var v = h[f];p.append(f, v);
              }
            }for (var m = 0, g = g = e;;) {
              if (m >= g.length) break;var b = g[m++];this.emit("sending", b, i, p);
            }this.options.uploadMultiple && this.emit("sendingmultiple", e, i, p), this._addFormElementData(p);for (var w = 0; w < t.length; w++) {
              var y = t[w];p.append(y.name, y.data, y.filename);
            }this.submitRequest(i, p, e);
          } }, { key: "_transformFiles", value: function value(e, t) {
            for (var n = this, i = [], o = 0, r = function r(_r) {
              n.options.transformFile.call(n, e[_r], function (n) {
                i[_r] = n, ++o === e.length && t(i);
              });
            }, s = 0; s < e.length; s++) {
              r(s);
            }
          } }, { key: "_addFormElementData", value: function value(e) {
            if ("FORM" === this.element.tagName) for (var t = 0, n = n = this.element.querySelectorAll("input, textarea, select, button");;) {
              if (t >= n.length) break;var i = n[t++],
                  o = i.getAttribute("name"),
                  r = i.getAttribute("type");if (r && (r = r.toLowerCase()), void 0 !== o && null !== o) if ("SELECT" === i.tagName && i.hasAttribute("multiple")) for (var s = 0, a = a = i.options;;) {
                if (s >= a.length) break;var l = a[s++];l.selected && e.append(o, l.value);
              } else (!r || "checkbox" !== r && "radio" !== r || i.checked) && e.append(o, i.value);
            }
          } }, { key: "_updateFilesUploadProgress", value: function value(e, t, n) {
            var i = void 0;if (void 0 !== n) {
              if (i = 100 * n.loaded / n.total, e[0].upload.chunked) {
                var o = e[0],
                    r = this._getChunk(o, t);r.progress = i, r.total = n.total, r.bytesSent = n.loaded;o.upload.progress = 0, o.upload.total = 0, o.upload.bytesSent = 0;for (var s = 0; s < o.upload.totalChunkCount; s++) {
                  void 0 !== o.upload.chunks[s] && void 0 !== o.upload.chunks[s].progress && (o.upload.progress += o.upload.chunks[s].progress, o.upload.total += o.upload.chunks[s].total, o.upload.bytesSent += o.upload.chunks[s].bytesSent);
                }o.upload.progress = o.upload.progress / o.upload.totalChunkCount;
              } else for (var a = 0, l = l = e;;) {
                if (a >= l.length) break;var u = l[a++];u.upload.progress = i, u.upload.total = n.total, u.upload.bytesSent = n.loaded;
              }for (var c = 0, d = d = e;;) {
                if (c >= d.length) break;var p = d[c++];this.emit("uploadprogress", p, p.upload.progress, p.upload.bytesSent);
              }
            } else {
              var h = !0;i = 100;for (var f = 0, v = v = e;;) {
                if (f >= v.length) break;var m = v[f++];100 === m.upload.progress && m.upload.bytesSent === m.upload.total || (h = !1), m.upload.progress = i, m.upload.bytesSent = m.upload.total;
              }if (h) return;for (var g = 0, b = b = e;;) {
                if (g >= b.length) break;var w = b[g++];this.emit("uploadprogress", w, i, w.upload.bytesSent);
              }
            }
          } }, { key: "_finishedUploading", value: function value(e, t, n) {
            var i = void 0;if (e[0].status !== r.CANCELED && 4 === t.readyState) {
              if ("arraybuffer" !== t.responseType && "blob" !== t.responseType && (i = t.responseText, t.getResponseHeader("content-type") && ~t.getResponseHeader("content-type").indexOf("application/json"))) try {
                i = JSON.parse(i);
              } catch (e) {
                n = e, i = "Invalid JSON response from server.";
              }this._updateFilesUploadProgress(e), 200 <= t.status && t.status < 300 ? e[0].upload.chunked ? e[0].upload.finishedChunkUpload(this._getChunk(e[0], t)) : this._finished(e, i, n) : this._handleUploadError(e, t, i);
            }
          } }, { key: "_handleUploadError", value: function value(e, t, n) {
            if (e[0].status !== r.CANCELED) {
              if (e[0].upload.chunked && this.options.retryChunks) {
                var i = this._getChunk(e[0], t);if (i.retries++ < this.options.retryChunksLimit) return void this._uploadData(e, [i.dataBlock]);console.warn("Retried this chunk too often. Giving up.");
              }for (var o = 0, s = s = e;;) {
                if (o >= s.length) break;s[o++];this._errorProcessing(e, n || this.options.dictResponseError.replace("{{statusCode}}", t.status), t);
              }
            }
          } }, { key: "submitRequest", value: function value(e, t, n) {
            e.send(t);
          } }, { key: "_finished", value: function value(e, t, n) {
            for (var i = 0, o = o = e;;) {
              if (i >= o.length) break;var s = o[i++];s.status = r.SUCCESS, this.emit("success", s, t, n), this.emit("complete", s);
            }if (this.options.uploadMultiple && (this.emit("successmultiple", e, t, n), this.emit("completemultiple", e)), this.options.autoProcessQueue) return this.processQueue();
          } }, { key: "_errorProcessing", value: function value(e, t, n) {
            for (var i = 0, o = o = e;;) {
              if (i >= o.length) break;var s = o[i++];s.status = r.ERROR, this.emit("error", s, t, n), this.emit("complete", s);
            }if (this.options.uploadMultiple && (this.emit("errormultiple", e, t, n), this.emit("completemultiple", e)), this.options.autoProcessQueue) return this.processQueue();
          } }], [{ key: "uuidv4", value: function value() {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
              var t = 16 * Math.random() | 0;return ("x" === e ? t : 3 & t | 8).toString(16);
            });
          } }]), r;
      }();r.initClass(), r.version = "5.3.0", r.options = {}, r.optionsForElement = function (e) {
        return e.getAttribute("id") ? r.options[a(e.getAttribute("id"))] : void 0;
      }, r.instances = [], r.forElement = function (e) {
        if ("string" == typeof e && (e = document.querySelector(e)), null == (null != e ? e.dropzone : void 0)) throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");return e.dropzone;
      }, r.autoDiscover = !0, r.discover = function () {
        var e = void 0;if (document.querySelectorAll) e = document.querySelectorAll(".dropzone");else {
          e = [];var t = function t(_t2) {
            return function () {
              for (var n = [], i = 0, o = o = _t2;;) {
                if (i >= o.length) break;var r = o[i++];/(^| )dropzone($| )/.test(r.className) ? n.push(e.push(r)) : n.push(void 0);
              }return n;
            }();
          };t(document.getElementsByTagName("div")), t(document.getElementsByTagName("form"));
        }return function () {
          for (var t = [], n = 0, i = i = e;;) {
            if (n >= i.length) break;var o = i[n++];!1 !== r.optionsForElement(o) ? t.push(new r(o)) : t.push(void 0);
          }return t;
        }();
      }, r.blacklistedBrowsers = [/opera.*(Macintosh|Windows Phone).*version\/12/i], r.isBrowserSupported = function () {
        var e = !0;if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
          if ("classList" in document.createElement("a")) for (var t = 0, n = n = r.blacklistedBrowsers;;) {
            if (t >= n.length) break;n[t++].test(navigator.userAgent) && (e = !1);
          } else e = !1;
        } else e = !1;return e;
      }, r.dataURItoBlob = function (e) {
        for (var t = atob(e.split(",")[1]), n = e.split(",")[0].split(":")[1].split(";")[0], i = new ArrayBuffer(t.length), o = new Uint8Array(i), r = 0, s = t.length, a = 0 <= s; a ? r <= s : r >= s; a ? r++ : r--) {
          o[r] = t.charCodeAt(r);
        }return new Blob([i], { type: n });
      };var s = function s(e, t) {
        return e.filter(function (e) {
          return e !== t;
        }).map(function (e) {
          return e;
        });
      },
          a = function a(e) {
        return e.replace(/[\-_](\w)/g, function (e) {
          return e.charAt(1).toUpperCase();
        });
      };r.createElement = function (e) {
        var t = document.createElement("div");return t.innerHTML = e, t.childNodes[0];
      }, r.elementInside = function (e, t) {
        if (e === t) return !0;for (; e = e.parentNode;) {
          if (e === t) return !0;
        }return !1;
      }, r.getElement = function (e, t) {
        var n = void 0;if ("string" == typeof e ? n = document.querySelector(e) : null != e.nodeType && (n = e), null == n) throw new Error("Invalid `" + t + "` option provided. Please provide a CSS selector or a plain HTML element.");return n;
      }, r.getElements = function (e, t) {
        var n = void 0,
            i = void 0;if (e instanceof Array) {
          i = [];try {
            for (var o = 0, r = r = e; !(o >= r.length);) {
              n = r[o++], i.push(this.getElement(n, t));
            }
          } catch (e) {
            i = null;
          }
        } else if ("string" == typeof e) {
          i = [];for (var s = 0, a = a = document.querySelectorAll(e); !(s >= a.length);) {
            n = a[s++], i.push(n);
          }
        } else null != e.nodeType && (i = [e]);if (null == i || !i.length) throw new Error("Invalid `" + t + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");return i;
      }, r.confirm = function (e, t, n) {
        return window.confirm(e) ? t() : null != n ? n() : void 0;
      }, r.isValidFile = function (e, t) {
        if (!t) return !0;t = t.split(",");for (var n = e.type, i = n.replace(/\/.*$/, ""), o = 0, r = r = t;;) {
          if (o >= r.length) break;var s = r[o++];if ("." === (s = s.trim()).charAt(0)) {
            if (-1 !== e.name.toLowerCase().indexOf(s.toLowerCase(), e.name.length - s.length)) return !0;
          } else if (/\/\*$/.test(s)) {
            if (i === s.replace(/\/.*$/, "")) return !0;
          } else if (n === s) return !0;
        }return !1;
      }, "undefined" != typeof jQuery && null !== jQuery && (jQuery.fn.dropzone = function (e) {
        return this.each(function () {
          return new r(this, e);
        });
      }), void 0 !== e && null !== e ? e.exports = r : window.Dropzone = r, r.ADDED = "added", r.QUEUED = "queued", r.ACCEPTED = r.QUEUED, r.UPLOADING = "uploading", r.PROCESSING = r.UPLOADING, r.CANCELED = "canceled", r.ERROR = "error", r.SUCCESS = "success";var l = function l(e, t, n, i, o, r, s, a, _l, u) {
        var c = function (e) {
          e.naturalWidth;var t = e.naturalHeight,
              n = document.createElement("canvas");n.width = 1, n.height = t;var i = n.getContext("2d");i.drawImage(e, 0, 0);for (var o = i.getImageData(1, 0, 1, t).data, r = 0, s = t, a = t; a > r;) {
            0 === o[4 * (a - 1) + 3] ? s = a : r = a, a = s + r >> 1;
          }var l = a / t;return 0 === l ? 1 : l;
        }(t);return e.drawImage(t, n, i, o, r, s, a, _l, u / c);
      },
          u = function () {
        function e() {
          i(this, e);
        }return t(e, null, [{ key: "initClass", value: function value() {
            this.KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          } }, { key: "encode64", value: function value(e) {
            for (var t = "", n = void 0, i = void 0, o = "", r = void 0, s = void 0, a = void 0, l = "", u = 0; r = (n = e[u++]) >> 2, s = (3 & n) << 4 | (i = e[u++]) >> 4, a = (15 & i) << 2 | (o = e[u++]) >> 6, l = 63 & o, isNaN(i) ? a = l = 64 : isNaN(o) && (l = 64), t = t + this.KEY_STR.charAt(r) + this.KEY_STR.charAt(s) + this.KEY_STR.charAt(a) + this.KEY_STR.charAt(l), n = i = o = "", r = s = a = l = "", u < e.length;) {}return t;
          } }, { key: "restore", value: function value(e, t) {
            if (!e.match("data:image/jpeg;base64,")) return t;var n = this.decode64(e.replace("data:image/jpeg;base64,", "")),
                i = this.slice2Segments(n),
                o = this.exifManipulation(t, i);return "data:image/jpeg;base64," + this.encode64(o);
          } }, { key: "exifManipulation", value: function value(e, t) {
            var n = this.getExifArray(t),
                i = this.insertExif(e, n);return new Uint8Array(i);
          } }, { key: "getExifArray", value: function value(e) {
            for (var t = void 0, n = 0; n < e.length;) {
              if (255 === (t = e[n])[0] & 225 === t[1]) return t;n++;
            }return [];
          } }, { key: "insertExif", value: function value(e, t) {
            var n = e.replace("data:image/jpeg;base64,", ""),
                i = this.decode64(n),
                o = i.indexOf(255, 3),
                r = i.slice(0, o),
                s = i.slice(o),
                a = r;return a = (a = a.concat(t)).concat(s);
          } }, { key: "slice2Segments", value: function value(e) {
            for (var t = 0, n = [];;) {
              if (255 === e[t] & 218 === e[t + 1]) break;if (255 === e[t] & 216 === e[t + 1]) t += 2;else {
                var i = t + (256 * e[t + 2] + e[t + 3]) + 2,
                    o = e.slice(t, i);n.push(o), t = i;
              }if (t > e.length) break;
            }return n;
          } }, { key: "decode64", value: function value(e) {
            var t = void 0,
                n = void 0,
                i = "",
                o = void 0,
                r = void 0,
                s = "",
                a = 0,
                l = [];for (/[^A-Za-z0-9\+\/\=]/g.exec(e) && console.warn("There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding."), e = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""); t = this.KEY_STR.indexOf(e.charAt(a++)) << 2 | (o = this.KEY_STR.indexOf(e.charAt(a++))) >> 4, n = (15 & o) << 4 | (r = this.KEY_STR.indexOf(e.charAt(a++))) >> 2, i = (3 & r) << 6 | (s = this.KEY_STR.indexOf(e.charAt(a++))), l.push(t), 64 !== r && l.push(n), 64 !== s && l.push(i), t = n = i = "", o = r = s = "", a < e.length;) {}return l;
          } }]), e;
      }();u.initClass();r._autoDiscoverFunction = function () {
        if (r.autoDiscover) return r.discover();
      }, function (e, t) {
        var n = !1,
            i = !0,
            o = e.document,
            r = o.documentElement,
            s = o.addEventListener ? "addEventListener" : "attachEvent",
            a = o.addEventListener ? "removeEventListener" : "detachEvent",
            l = o.addEventListener ? "" : "on",
            u = function i(r) {
          if ("readystatechange" !== r.type || "complete" === o.readyState) return ("load" === r.type ? e : o)[a](l + r.type, i, !1), !n && (n = !0) ? t.call(e, r.type || r) : void 0;
        };if ("complete" !== o.readyState) {
          if (o.createEventObject && r.doScroll) {
            try {
              i = !e.frameElement;
            } catch (e) {}i && function e() {
              try {
                r.doScroll("left");
              } catch (t) {
                return void setTimeout(e, 50);
              }return u("poll");
            }();
          }o[s](l + "DOMContentLoaded", u, !1), o[s](l + "readystatechange", u, !1), e[s](l + "load", u, !1);
        }
      }(window, r._autoDiscoverFunction);
    }).call(t, n(69)(e));
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", { enumerable: !0, get: function get() {
          return e.l;
        } }), Object.defineProperty(e, "id", { enumerable: !0, get: function get() {
          return e.i;
        } }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t) {}, function (e, t, n) {
    "use strict";
    n.d(t, "a", function () {
      return i;
    }), n.d(t, "b", function () {
      return o;
    });var i = function i() {
      var e = this.$createElement;return (this._self._c || e)("Dropzone", { ref: "dropzone", attrs: { options: this.dropzoneOptions, id: this._uid + "vwdropzone" }, on: { "vdropzone-success": this.fileUploaded, "vdropzone-file-added": this.fileAdded } });
    },
        o = [];
  }, function (e, t, n) {
    "use strict";
    var i = n(17),
        o = n(74),
        r = n(0);var s = function s(e) {
      n(73);
    },
        a = Object(r.a)(i.a, o.a, o.b, !1, s, "data-v-ebce4d12", null);t.a = a.exports;
  }, function (e, t) {}, function (e, t, n) {
    "use strict";
    n.d(t, "a", function () {
      return i;
    }), n.d(t, "b", function () {
      return o;
    });var i = function i() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("form", { staticClass: "form", on: { submit: function submit(t) {
            t.preventDefault(), e.insertTable(t);
          } } }, [n("label", [n("div", [e._v("Rows")]), e._v(" "), n("input", { directives: [{ name: "model", rawName: "v-model", value: e.rows, expression: "rows" }], staticStyle: { width: "60px" }, attrs: { type: "number", min: "2" }, domProps: { value: e.rows }, on: { input: function input(t) {
            t.target.composing || (e.rows = t.target.value);
          } } })]), e._v(" "), n("label", [n("div", [e._v("Columns")]), e._v(" "), n("input", { directives: [{ name: "model", rawName: "v-model", value: e.cols, expression: "cols" }], staticStyle: { width: "60px" }, attrs: { type: "number", min: "2" }, domProps: { value: e.cols }, on: { input: function input(t) {
            t.target.composing || (e.cols = t.target.value);
          } } })]), e._v(" "), n("button", { attrs: { type: "submit" } }, [e._v("Insert")])]);
    },
        o = [];
  }, function (e, t) {
    e.exports = { title: "removeFormat", action: ["removeFormat"], description: "Remove formatting.\nClears headings, bold, italic, underlined text, etc.", icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M832 1408l336-384h-768l-336 384h768zm1013-1077q15 34 9.5 71.5t-30.5 65.5l-896 1024q-38 44-96 44h-768q-38 0-69.5-20.5t-47.5-54.5q-15-34-9.5-71.5t30.5-65.5l896-1024q38-44 96-44h768q38 0 69.5 20.5t47.5 54.5z"/></svg>' };
  }, function (e, t) {
    e.exports = { title: "separator", icon: "<i class='vw-separator'></i>" };
  }, function (e, t, n) {
    "use strict";
    n.d(t, "a", function () {
      return i;
    }), n.d(t, "b", function () {
      return o;
    });var i = function i() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { staticClass: "editr" }, [n("div", { staticClass: "editr--toolbar" }, e._l(e.modules, function (t, i) {
        return n("Btn", { key: t.title + i, ref: "btn-" + t.title, refInFor: !0, attrs: { module: t, options: e.mergedOptions, title: t.description || "" } });
      })), n("div", { ref: "content", staticClass: "editr--content", attrs: { contenteditable: "true", tabindex: "1", placeholder: e.placeholder } })]);
    },
        o = [];
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module)))

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2264);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2c488058", content, true, {});

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".snotifyToast {\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both; }\n\n.snotify-leftTop .fadeIn,\n.snotify-leftCenter .fadeIn,\n.snotify-leftBottom .fadeIn {\n  -webkit-animation-name: fadeInLeft;\n  animation-name: fadeInLeft; }\n\n.snotify-leftTop .fadeOut,\n.snotify-leftCenter .fadeOut,\n.snotify-leftBottom .fadeOut {\n  -webkit-animation-name: fadeOutLeft;\n  animation-name: fadeOutLeft; }\n\n.snotify-rightTop .fadeIn,\n.snotify-rightCenter .fadeIn,\n.snotify-rightBottom .fadeIn {\n  -webkit-animation-name: fadeInRight;\n  animation-name: fadeInRight; }\n\n.snotify-rightTop .fadeOut,\n.snotify-rightCenter .fadeOut,\n.snotify-rightBottom .fadeOut {\n  -webkit-animation-name: fadeOutRight;\n  animation-name: fadeOutRight; }\n\n.snotify-centerTop .fadeIn {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown; }\n\n.snotify-centerTop .fadeOut {\n  -webkit-animation-name: fadeOutUp;\n  animation-name: fadeOutUp; }\n\n.snotify-centerCenter .fadeIn {\n  -webkit-animation-name: fadeIn;\n  animation-name: fadeIn; }\n\n.snotify-centerCenter .fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut; }\n\n.snotify-centerBottom .fadeIn {\n  -webkit-animation-name: fadeInUp;\n  animation-name: fadeInUp; }\n\n.snotify-centerBottom .fadeOut {\n  -webkit-animation-name: fadeOutDown;\n  animation-name: fadeOutDown; }\n\n@-webkit-keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0) scaleX(1.2);\n    transform: translate3d(-100%, 0, 0) scaleX(1.2); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0) scaleX(1.2);\n    transform: translate3d(-100%, 0, 0) scaleX(1.2); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@-webkit-keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0) scaleX(1.2);\n    transform: translate3d(100%, 0, 0) scaleX(1.2); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0) scaleX(1.2);\n    transform: translate3d(100%, 0, 0) scaleX(1.2); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@-webkit-keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0) scaleY(1.2);\n    transform: translate3d(0, 100%, 0) scaleY(1.2); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0) scaleY(1.2);\n    transform: translate3d(0, 100%, 0) scaleY(1.2); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0) scaleY(1.2);\n    transform: translate3d(0, -100%, 0) scaleY(1.2); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0) scaleY(1.2);\n    transform: translate3d(0, -100%, 0) scaleY(1.2); }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none; } }\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes fadeOut {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@-webkit-keyframes fadeOutDown {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0); } }\n\n@keyframes fadeOutDown {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0); } }\n\n@-webkit-keyframes fadeOutLeft {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0); } }\n\n@keyframes fadeOutLeft {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0); } }\n\n@-webkit-keyframes fadeOutRight {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0); } }\n\n@keyframes fadeOutRight {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0); } }\n\n@-webkit-keyframes fadeOutUp {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0); } }\n\n@keyframes fadeOutUp {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0); } }\n\n@-webkit-keyframes appear {\n  0% {\n    max-height: 0; }\n  100% {\n    max-height: 50vh; } }\n\n@keyframes appear {\n  0% {\n    max-height: 0; }\n  100% {\n    max-height: 50vh; } }\n\n@-webkit-keyframes disappear {\n  0% {\n    opacity: 0;\n    max-height: 50vh; }\n  100% {\n    opacity: 0;\n    max-height: 0; } }\n\n@keyframes disappear {\n  0% {\n    opacity: 0;\n    max-height: 50vh; }\n  100% {\n    opacity: 0;\n    max-height: 0; } }\n\n@-webkit-keyframes async {\n  0% {\n    -webkit-transform: translate(0, -50%) rotate(0deg);\n    transform: translate(0, -50%) rotate(0deg); }\n  100% {\n    -webkit-transform: translate(0, -50%) rotate(360deg);\n    transform: translate(0, -50%) rotate(360deg); } }\n\n@keyframes async {\n  0% {\n    -webkit-transform: translate(0, -50%) rotate(0deg);\n    transform: translate(0, -50%) rotate(0deg); }\n  100% {\n    -webkit-transform: translate(0, -50%) rotate(360deg);\n    transform: translate(0, -50%) rotate(360deg); } }\n\n.snotify {\n  display: block;\n  position: fixed;\n  width: 300px;\n  z-index: 9999;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  pointer-events: none; }\n  .snotify * {\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box; }\n\n.snotify-leftTop,\n.snotify-leftCenter,\n.snotify-leftBottom {\n  left: 10px; }\n\n.snotify-rightTop,\n.snotify-rightCenter,\n.snotify-rightBottom {\n  right: 10px; }\n\n.snotify-centerTop,\n.snotify-centerCenter,\n.snotify-centerBottom {\n  left: calc(50% - 300px / 2); }\n\n.snotify-leftTop,\n.snotify-centerTop,\n.snotify-rightTop {\n  top: 10px; }\n\n.snotify-leftCenter,\n.snotify-rightCenter,\n.snotify-centerCenter {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%); }\n\n.snotify-leftBottom,\n.snotify-rightBottom,\n.snotify-centerBottom {\n  bottom: 10px; }\n\n.snotify-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: #000;\n  opacity: 0;\n  z-index: 9998;\n  -webkit-transition: opacity .3s;\n  transition: opacity .3s; }\n\n.snotifyToast {\n  display: block;\n  cursor: pointer;\n  background-color: #fff;\n  height: 100%;\n  margin: 5px;\n  opacity: 0;\n  border-radius: 5px;\n  overflow: hidden;\n  pointer-events: auto; }\n  .snotifyToast--in {\n    -webkit-animation-name: appear;\n    animation-name: appear; }\n  .snotifyToast--out {\n    -webkit-animation-name: disappear;\n    animation-name: disappear; }\n  .snotifyToast__inner {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-flow: column nowrap;\n    -ms-flex-flow: column nowrap;\n    flex-flow: column nowrap;\n    -webkit-box-align: start;\n    -webkit-align-items: flex-start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    position: relative;\n    padding: 5px 65px 5px 15px;\n    min-height: 78px;\n    font-size: 16px;\n    color: #000; }\n  .snotifyToast__noIcon {\n    padding: 5px 15px 5px 15px; }\n  .snotifyToast__progressBar {\n    position: relative;\n    width: 100%;\n    height: 10px;\n    background-color: #c7c7c7; }\n    .snotifyToast__progressBar__percentage {\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 10px;\n      background-color: #4c4c4c;\n      max-width: 100%; }\n  .snotifyToast__title {\n    font-size: 1.8em;\n    line-height: 1.2em;\n    margin-bottom: 5px;\n    color: #fff; }\n  .snotifyToast__body {\n    font-size: 1em; }\n\n.snotifyToast-show {\n  -webkit-transform: translate(0, 0);\n  transform: translate(0, 0);\n  opacity: 1; }\n\n.snotifyToast-remove {\n  max-height: 0;\n  overflow: hidden;\n  -webkit-transform: translate(0, 50%);\n  transform: translate(0, 50%);\n  opacity: 0; }\n\n.fadeOutRight {\n  -webkit-animation-name: fadeOutRight;\n  animation-name: fadeOutRight; }\n\n/***************\r\n ** Modifiers **\r\n **************/\n.snotify-simple .snotifyToast__title,\n.snotify-simple .snotifyToast__body {\n  color: #000; }\n\n.snotify-success {\n  background-color: #4caf50; }\n  .snotify-success .snotifyToast__progressBar {\n    background-color: #388e3c; }\n  .snotify-success .snotifyToast__progressBar__percentage {\n    background-color: #81c784; }\n  .snotify-success .snotifyToast__body {\n    color: #c8e6c9; }\n\n.snotify-info {\n  background-color: #1e88e5; }\n  .snotify-info .snotifyToast__progressBar {\n    background-color: #1565c0; }\n  .snotify-info .snotifyToast__progressBar__percentage {\n    background-color: #64b5f6; }\n  .snotify-info .snotifyToast__body {\n    color: #e3f2fd; }\n\n.snotify-warning {\n  background-color: #ff9800; }\n  .snotify-warning .snotifyToast__progressBar {\n    background-color: #ef6c00; }\n  .snotify-warning .snotifyToast__progressBar__percentage {\n    background-color: #ffcc80; }\n  .snotify-warning .snotifyToast__body {\n    color: #fff3e0; }\n\n.snotify-error {\n  background-color: #f44336; }\n  .snotify-error .snotifyToast__progressBar {\n    background-color: #c62828; }\n  .snotify-error .snotifyToast__progressBar__percentage {\n    background-color: #ef9a9a; }\n  .snotify-error .snotifyToast__body {\n    color: #ffebee; }\n\n.snotify-async {\n  background-color: #1e88e5; }\n  .snotify-async .snotifyToast__progressBar {\n    background-color: #1565c0; }\n  .snotify-async .snotifyToast__progressBar__percentage {\n    background-color: #64b5f6; }\n  .snotify-async .snotifyToast__body {\n    color: #e3f2fd; }\n\n.snotify-confirm {\n  background-color: #009688; }\n  .snotify-confirm .snotifyToast__progressBar {\n    background-color: #4db6ac; }\n  .snotify-confirm .snotifyToast__progressBar__percentage {\n    background-color: #80cbc4; }\n  .snotify-confirm .snotifyToast__body {\n    color: #e0f2f1; }\n\n.snotify-prompt {\n  background-color: #009688; }\n  .snotify-prompt .snotifyToast__title {\n    margin-bottom: 0; }\n  .snotify-prompt .snotifyToast__body {\n    color: #e0f2f1; }\n\n.snotify-confirm .snotifyToast__inner,\n.snotify-prompt .snotifyToast__inner {\n  padding: 10px 15px; }\n\n.snotifyToast__input {\n  position: relative;\n  z-index: 1;\n  display: inline-block;\n  margin: 0;\n  width: 100%;\n  vertical-align: top;\n  -webkit-transition: all .5s;\n  transition: all .5s;\n  -webkit-transition-delay: .3s;\n  transition-delay: .3s;\n  -webkit-transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1); }\n  .snotifyToast__input__field {\n    position: relative;\n    display: block;\n    float: right;\n    padding: .85em .5em;\n    width: 100%;\n    border: none;\n    border-radius: 0;\n    background: transparent;\n    color: #333;\n    font-weight: bold;\n    -webkit-appearance: none;\n    /* for box shadows to show on iOS */\n    opacity: 0;\n    -webkit-transition: opacity .3s;\n    transition: opacity .3s; }\n    .snotifyToast__input__field:focus {\n      outline: none; }\n  .snotifyToast__input__label {\n    display: inline-block;\n    float: right;\n    padding: 0 .85em;\n    width: 100%;\n    color: #e0f2f1;\n    font-weight: bold;\n    font-size: 70.25%;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    position: absolute;\n    left: 0;\n    height: 100%;\n    text-align: left;\n    pointer-events: none; }\n    .snotifyToast__input__label::before, .snotifyToast__input__label::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      -webkit-transition: -webkit-transform .3s;\n      transition: -webkit-transform .3s;\n      transition: transform .3s;\n      transition: transform .3s, -webkit-transform .3s; }\n    .snotifyToast__input__label::before {\n      border-top: 2px solid #fff;\n      -webkit-transform: translate3d(0, 100%, 0) translate3d(0, -2px, 0);\n      transform: translate3d(0, 100%, 0) translate3d(0, -2px, 0);\n      -webkit-transition-delay: .3s;\n      transition-delay: .3s; }\n    .snotifyToast__input__label::after {\n      z-index: -1;\n      background: #b2dfdb;\n      -webkit-transform: scale3d(1, 0, 1);\n      transform: scale3d(1, 0, 1);\n      -webkit-transform-origin: 50% 0;\n      transform-origin: 50% 0; }\n  .snotifyToast__input__labelContent {\n    position: relative;\n    display: block;\n    padding: 1em 0;\n    width: 100%;\n    -webkit-transition: -webkit-transform .3s .3s;\n    transition: -webkit-transform .3s .3s;\n    transition: transform .3s .3s;\n    transition: transform .3s .3s, -webkit-transform .3s .3s; }\n\n.snotifyToast__input--filled {\n  margin-top: 2.5em; }\n  .snotifyToast__input--filled:focus,\n  .snotifyToast__input--filled .snotifyToast__input__field {\n    opacity: 1;\n    -webkit-transition-delay: .3s;\n    transition-delay: .3s; }\n\n.snotifyToast__input__field:focus + .snotifyToast__input__label .snotifyToast__input__labelContent,\n.snotifyToast__input--filled .snotifyToast__input__labelContent {\n  -webkit-transform: translate(0, -80%);\n  transform: translate(0, -80%);\n  -webkit-transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1); }\n\n.snotifyToast__input__field:focus + .snotifyToast__input__label::before,\n.snotifyToast__input--filled .snotifyToast__input__label::before {\n  -webkit-transition-delay: 0s;\n  transition-delay: 0s; }\n\n.snotifyToast__input__field:focus + .snotifyToast__input__label::before,\n.snotifyToast__input--filled .snotifyToast__input__label::before {\n  -webkit-transform: translate(0, 0);\n  transform: translate(0, 0); }\n\n.snotifyToast__input__field:focus + .snotifyToast__input__label::after,\n.snotifyToast__input--filled .snotifyToast__input__label::after {\n  -webkit-transform: scale(1, 1);\n  transform: scale(1, 1);\n  -webkit-transition-delay: .3s;\n  transition-delay: .3s;\n  -webkit-transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1); }\n\n.snotifyToast--invalid .snotifyToast__input__label::before {\n  border-color: #f44336; }\n\n.snotifyToast--valid .snotifyToast__input__label::before {\n  border-color: #4caf50; }\n\n.snotifyToast__buttons {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-flow: row nowrap;\n  -ms-flex-flow: row nowrap;\n  flex-flow: row nowrap;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  border-top: 1px solid rgba(0, 0, 0, 0.1); }\n  .snotifyToast__buttons button {\n    position: relative;\n    width: 100%;\n    border-right: 1px solid rgba(0, 0, 0, 0.1);\n    border-left: 1px solid rgba(0, 0, 0, 0.1);\n    border-top: none;\n    border-bottom: none;\n    background: transparent;\n    padding: 8px;\n    text-transform: capitalize;\n    color: #fff;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    overflow: hidden; }\n    .snotifyToast__buttons button::after {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: 5px;\n      height: 5px;\n      background: rgba(255, 255, 255, 0.3);\n      opacity: 0;\n      border-radius: 100%;\n      -webkit-transform: scale(1, 1) translate(-50%);\n      transform: scale(1, 1) translate(-50%);\n      -webkit-transform-origin: 50% 50%;\n      transform-origin: 50% 50%; }\n    .snotifyToast__buttons button:focus:not(:active)::after {\n      -webkit-animation: ripple 1s ease-out;\n      animation: ripple 1s ease-out; }\n    .snotifyToast__buttons button:hover, .snotifyToast__buttons button:focus {\n      background: rgba(0, 0, 0, 0.1);\n      outline: none; }\n    .snotifyToast__buttons button:active {\n      background: rgba(0, 0, 0, 0.15); }\n    .snotifyToast__buttons button:last-child {\n      border-right: none; }\n    .snotifyToast__buttons button:first-child {\n      border-left: none; }\n  .snotifyToast__buttons--bold {\n    font-weight: 700; }\n\n@-webkit-keyframes ripple {\n  0% {\n    -webkit-transform: scale(0, 0);\n    transform: scale(0, 0);\n    opacity: 1; }\n  20% {\n    -webkit-transform: scale(25, 25);\n    transform: scale(25, 25);\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(40, 40);\n    transform: scale(40, 40); } }\n\n@keyframes ripple {\n  0% {\n    -webkit-transform: scale(0, 0);\n    transform: scale(0, 0);\n    opacity: 1; }\n  20% {\n    -webkit-transform: scale(25, 25);\n    transform: scale(25, 25);\n    opacity: 1; }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(40, 40);\n    transform: scale(40, 40); } }\n\n.snotify-icon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  line-height: 0;\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  max-height: 48px;\n  max-width: 48px;\n  width: 100%;\n  height: 100%; }\n\n.snotify-icon--error {\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20version=%221.1%22%20x=%220px%22%20y=%220px%22%20viewBox=%220%200%20512%20512%22%20fill=%22%23ffcdd2%22%3E%3Cg%3E%3Cpath%20d=%22M437,75A256,256,0,1,0,75,437,256,256,0,1,0,437,75ZM416.43,416.43a226.82,226.82,0,0,1-320.86,0C7.11,328,7.11,184,95.57,95.57a226.82,226.82,0,0,1,320.86,0C504.89,184,504.89,328,416.43,416.43Z%22/%3E%3Cpath%20d=%22M368.81,143.19a14.5,14.5,0,0,0-20.58,0L256,235.42l-92.23-92.23a14.55,14.55,0,0,0-20.58,20.58L235.42,256l-92.23,92.23a14.6,14.6,0,0,0,10.24,24.89,14.19,14.19,0,0,0,10.24-4.31l92.23-92.23,92.23,92.23a14.64,14.64,0,0,0,10.24,4.31,14,14,0,0,0,10.24-4.31,14.5,14.5,0,0,0,0-20.58l-92-92.23,92.23-92.23A14.5,14.5,0,0,0,368.81,143.19Z%22/%3E%3C/g%3E%3C/svg%3E\"); }\n\n.snotify-icon--warning {\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20version=%221.1%22%20x=%220px%22%20y=%220px%22%20viewBox=%220%200%20512%20512%22%20fill=%22%23ffccbc%22%3E%3Cg%3E%3Cpath%20d=%22M256,512c141.15,0,256-114.84,256-256S397.15,0,256,0,0,114.84,0,256,114.85,512,256,512Zm0-480.49c123.79,0,224.49,100.71,224.49,224.49S379.79,480.49,256,480.49,31.51,379.79,31.51,256,132.21,31.51,256,31.51Z%22/%3E%3Ccircle%20cx=%22260.08%22%20cy=%22343.87%22%20r=%2226.35%22/%3E%3Cpath%20d=%22M254.68,278.39a15.76,15.76,0,0,0,15.75-15.75V128.72a15.75,15.75,0,1,0-31.51,0V262.63A15.76,15.76,0,0,0,254.68,278.39Z%22/%3E%3C/g%3E%3C/svg%3E\"); }\n\n.snotify-icon--info {\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20version=%221.1%22%20x=%220px%22%20y=%220px%22%20viewBox=%220%200%20512%20512%22%20fill=%22%23bbdefb%22%3E%3Cg%3E%3Cpath%20d=%22M256,0C114.84,0,0,114.84,0,256S114.84,512,256,512,512,397.16,512,256,397.15,0,256,0Zm0,478.43C133.35,478.43,33.57,378.64,33.57,256S133.35,33.58,256,33.58,478.42,133.36,478.42,256,378.64,478.43,256,478.43Z%22/%3E%3Cpath%20d=%22M251.26,161.24a22.39,22.39,0,1,0-22.38-22.39A22.39,22.39,0,0,0,251.26,161.24Z%22/%3E%3Cpath%20d=%22M286.84,357.87h-14v-160A16.79,16.79,0,0,0,256,181.05H225.17a16.79,16.79,0,0,0,0,33.58h14.05V357.87H225.17a16.79,16.79,0,0,0,0,33.57h61.67a16.79,16.79,0,1,0,0-33.57Z%22/%3E%3C/g%3E%3C/svg%3E\"); }\n\n.snotify-icon--success {\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20version=%221.1%22%20x=%220px%22%20y=%220px%22%20viewBox=%220%200%20512%20512%22%20fill=%22%23c8e6c9%22%3E%3Cg%3E%3Cpath%20d=%22M256,0C114.85,0,0,114.84,0,256S114.85,512,256,512,512,397.16,512,256,397.15,0,256,0Zm0,492.31c-130.29,0-236.31-106-236.31-236.31S125.71,19.69,256,19.69,492.31,125.71,492.31,256,386.29,492.31,256,492.31Z%22/%3E%3Cpath%20class=%22cls-1%22%20d=%22M376.64,151,225.31,321.24l-91.17-72.93a9.85,9.85,0,0,0-12.3,15.38l98.46,78.77a9.86,9.86,0,0,0,13.52-1.15L391.36,164.08A9.85,9.85,0,0,0,376.64,151Z%22/%3E%3C/g%3E%3C/svg%3E\"); }\n\n.snotify-icon--async {\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20version=%221.1%22%20x=%220px%22%20y=%220px%22%20viewBox=%220%200%20512%20512%22%20fill=%22%23bbdefb%22%3E%3Cg%3E%3Cpath%20d=%22M256,0a32,32,0,0,0-32,32V96a32,32,0,0,0,64,0V32A32,32,0,0,0,256,0Zm0,384a32,32,0,0,0-32,32v64a32,32,0,0,0,64,0V416A32,32,0,0,0,256,384ZM391.74,165.5,437,120.22A32,32,0,0,0,391.74,75L346.5,120.22a32,32,0,0,0,45.25,45.28Zm-271.52,181L75,391.74A32,32,0,0,0,120.22,437l45.25-45.25a32,32,0,0,0-45.25-45.25Zm0-271.52A32,32,0,1,0,75,120.22l45.25,45.28a32,32,0,1,0,45.25-45.28ZM391.74,346.5a32,32,0,0,0-45.25,45.25L391.74,437A32,32,0,0,0,437,391.74ZM480,224H416a32,32,0,0,0,0,64h64a32,32,0,0,0,0-64ZM128,256a32,32,0,0,0-32-32H32a32,32,0,0,0,0,64H96A32,32,0,0,0,128,256Z%22/%3E%3C/g%3E%3C/svg%3E\");\n  -webkit-animation: async 3s infinite linear;\n  animation: async 3s infinite linear;\n  -webkit-transform-origin: 50% 50%;\n  transform-origin: 50% 50%; }\n", ""]);

// exports


/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2266);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("68d7cda5", content, true, {});

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "/*!\n * Bootstrap v4.6.2 (https://getbootstrap.com/)\n * Copyright 2011-2022 The Bootstrap Authors\n * Copyright 2011-2022 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root {\n  --blue: #007bff;\n  --indigo: #6610f2;\n  --purple: #6f42c1;\n  --pink: #e83e8c;\n  --red: #dc3545;\n  --orange: #fd7e14;\n  --yellow: #ffc107;\n  --green: #28a745;\n  --teal: #20c997;\n  --cyan: #17a2b8;\n  --white: #fff;\n  --gray: #6c757d;\n  --gray-dark: #343a40;\n  --primary: #007bff;\n  --secondary: #6c757d;\n  --success: #28a745;\n  --info: #17a2b8;\n  --warning: #ffc107;\n  --danger: #dc3545;\n  --light: #f8f9fa;\n  --dark: #343a40;\n  --breakpoint-xs: 0;\n  --breakpoint-sm: 576px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 992px;\n  --breakpoint-xl: 1200px;\n  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  text-align: left;\n  background-color: #fff;\n}\n\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n  text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0;\n  -webkit-text-decoration-skip-ink: none;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -.25em;\n}\n\nsup {\n  top: -.5em;\n}\n\na {\n  color: #007bff;\n  text-decoration: none;\n  background-color: transparent;\n}\n\na:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n}\n\na:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 1em;\n}\n\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  -ms-overflow-style: scrollbar;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\n\nsvg {\n  overflow: hidden;\n  vertical-align: middle;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #6c757d;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\n\nbutton:not(:disabled),\n[type=\"button\"]:not(:disabled),\n[type=\"reset\"]:not(:disabled),\n[type=\"submit\"]:not(:disabled) {\n  cursor: pointer;\n}\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: .5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\ntemplate {\n  display: none;\n}\n\n[hidden] {\n  display: none !important;\n}\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\nh1, .h1 {\n  font-size: 2.5rem;\n}\n\nh2, .h2 {\n  font-size: 2rem;\n}\n\nh3, .h3 {\n  font-size: 1.75rem;\n}\n\nh4, .h4 {\n  font-size: 1.5rem;\n}\n\nh5, .h5 {\n  font-size: 1.25rem;\n}\n\nh6, .h6 {\n  font-size: 1rem;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: 6rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-2 {\n  font-size: 5.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-3 {\n  font-size: 4.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-4 {\n  font-size: 3.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\nhr {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\nsmall,\n.small {\n  font-size: 0.875em;\n  font-weight: 400;\n}\n\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n\n.blockquote-footer {\n  display: block;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n\n.blockquote-footer::before {\n  content: \"\\2014\\A0\";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 90%;\n  color: #6c757d;\n}\n\ncode {\n  font-size: 87.5%;\n  color: #e83e8c;\n  word-wrap: break-word;\n}\n\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: #fff;\n  background-color: #212529;\n  border-radius: 0.2rem;\n}\n\nkbd kbd {\n  padding: 0;\n  font-size: 100%;\n  font-weight: 700;\n}\n\npre {\n  display: block;\n  font-size: 87.5%;\n  color: #212529;\n}\n\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n\n.container,\n.container-fluid,\n.container-sm,\n.container-md,\n.container-lg,\n.container-xl {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container, .container-sm {\n    max-width: 540px;\n  }\n}\n\n@media (min-width: 768px) {\n  .container, .container-sm, .container-md {\n    max-width: 720px;\n  }\n}\n\n@media (min-width: 992px) {\n  .container, .container-sm, .container-md, .container-lg {\n    max-width: 960px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .container, .container-sm, .container-md, .container-lg, .container-xl {\n    max-width: 1140px;\n  }\n}\n\n.row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n\n.no-gutters > .col,\n.no-gutters > [class*=\"col-\"] {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,\n.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,\n.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,\n.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,\n.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,\n.col-xl-auto {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.col {\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  max-width: 100%;\n}\n\n.row-cols-1 > * {\n  -ms-flex: 0 0 100%;\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.row-cols-2 > * {\n  -ms-flex: 0 0 50%;\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.row-cols-3 > * {\n  -ms-flex: 0 0 33.333333%;\n  flex: 0 0 33.333333%;\n  max-width: 33.333333%;\n}\n\n.row-cols-4 > * {\n  -ms-flex: 0 0 25%;\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.row-cols-5 > * {\n  -ms-flex: 0 0 20%;\n  flex: 0 0 20%;\n  max-width: 20%;\n}\n\n.row-cols-6 > * {\n  -ms-flex: 0 0 16.666667%;\n  flex: 0 0 16.666667%;\n  max-width: 16.666667%;\n}\n\n.col-auto {\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%;\n}\n\n.col-1 {\n  -ms-flex: 0 0 8.333333%;\n  flex: 0 0 8.333333%;\n  max-width: 8.333333%;\n}\n\n.col-2 {\n  -ms-flex: 0 0 16.666667%;\n  flex: 0 0 16.666667%;\n  max-width: 16.666667%;\n}\n\n.col-3 {\n  -ms-flex: 0 0 25%;\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.col-4 {\n  -ms-flex: 0 0 33.333333%;\n  flex: 0 0 33.333333%;\n  max-width: 33.333333%;\n}\n\n.col-5 {\n  -ms-flex: 0 0 41.666667%;\n  flex: 0 0 41.666667%;\n  max-width: 41.666667%;\n}\n\n.col-6 {\n  -ms-flex: 0 0 50%;\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.col-7 {\n  -ms-flex: 0 0 58.333333%;\n  flex: 0 0 58.333333%;\n  max-width: 58.333333%;\n}\n\n.col-8 {\n  -ms-flex: 0 0 66.666667%;\n  flex: 0 0 66.666667%;\n  max-width: 66.666667%;\n}\n\n.col-9 {\n  -ms-flex: 0 0 75%;\n  flex: 0 0 75%;\n  max-width: 75%;\n}\n\n.col-10 {\n  -ms-flex: 0 0 83.333333%;\n  flex: 0 0 83.333333%;\n  max-width: 83.333333%;\n}\n\n.col-11 {\n  -ms-flex: 0 0 91.666667%;\n  flex: 0 0 91.666667%;\n  max-width: 91.666667%;\n}\n\n.col-12 {\n  -ms-flex: 0 0 100%;\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.order-first {\n  -ms-flex-order: -1;\n  order: -1;\n}\n\n.order-last {\n  -ms-flex-order: 13;\n  order: 13;\n}\n\n.order-0 {\n  -ms-flex-order: 0;\n  order: 0;\n}\n\n.order-1 {\n  -ms-flex-order: 1;\n  order: 1;\n}\n\n.order-2 {\n  -ms-flex-order: 2;\n  order: 2;\n}\n\n.order-3 {\n  -ms-flex-order: 3;\n  order: 3;\n}\n\n.order-4 {\n  -ms-flex-order: 4;\n  order: 4;\n}\n\n.order-5 {\n  -ms-flex-order: 5;\n  order: 5;\n}\n\n.order-6 {\n  -ms-flex-order: 6;\n  order: 6;\n}\n\n.order-7 {\n  -ms-flex-order: 7;\n  order: 7;\n}\n\n.order-8 {\n  -ms-flex-order: 8;\n  order: 8;\n}\n\n.order-9 {\n  -ms-flex-order: 9;\n  order: 9;\n}\n\n.order-10 {\n  -ms-flex-order: 10;\n  order: 10;\n}\n\n.order-11 {\n  -ms-flex-order: 11;\n  order: 11;\n}\n\n.order-12 {\n  -ms-flex-order: 12;\n  order: 12;\n}\n\n.offset-1 {\n  margin-left: 8.333333%;\n}\n\n.offset-2 {\n  margin-left: 16.666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.333333%;\n}\n\n.offset-5 {\n  margin-left: 41.666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.333333%;\n}\n\n.offset-8 {\n  margin-left: 66.666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.333333%;\n}\n\n.offset-11 {\n  margin-left: 91.666667%;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-sm-1 > * {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n  .row-cols-sm-4 > * {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n  .col-sm-auto {\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-sm-1 {\n    -ms-flex: 0 0 8.333333%;\n    flex: 0 0 8.333333%;\n    max-width: 8.333333%;\n  }\n  .col-sm-2 {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n  .col-sm-3 {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-sm-4 {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n  .col-sm-5 {\n    -ms-flex: 0 0 41.666667%;\n    flex: 0 0 41.666667%;\n    max-width: 41.666667%;\n  }\n  .col-sm-6 {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-sm-7 {\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%;\n  }\n  .col-sm-8 {\n    -ms-flex: 0 0 66.666667%;\n    flex: 0 0 66.666667%;\n    max-width: 66.666667%;\n  }\n  .col-sm-9 {\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-sm-10 {\n    -ms-flex: 0 0 83.333333%;\n    flex: 0 0 83.333333%;\n    max-width: 83.333333%;\n  }\n  .col-sm-11 {\n    -ms-flex: 0 0 91.666667%;\n    flex: 0 0 91.666667%;\n    max-width: 91.666667%;\n  }\n  .col-sm-12 {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-sm-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n  .order-sm-last {\n    -ms-flex-order: 13;\n    order: 13;\n  }\n  .order-sm-0 {\n    -ms-flex-order: 0;\n    order: 0;\n  }\n  .order-sm-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n  .order-sm-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n  .order-sm-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n  .order-sm-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n  .order-sm-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n  .order-sm-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n  .order-sm-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n  .order-sm-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n  .order-sm-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n  .order-sm-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n  .order-sm-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n  .order-sm-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.666667%;\n  }\n}\n\n@media (min-width: 768px) {\n  .col-md {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-md-1 > * {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-md-2 > * {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-md-3 > * {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n  .row-cols-md-4 > * {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-md-5 > * {\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-md-6 > * {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n  .col-md-auto {\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-md-1 {\n    -ms-flex: 0 0 8.333333%;\n    flex: 0 0 8.333333%;\n    max-width: 8.333333%;\n  }\n  .col-md-2 {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n  .col-md-3 {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-md-4 {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n  .col-md-5 {\n    -ms-flex: 0 0 41.666667%;\n    flex: 0 0 41.666667%;\n    max-width: 41.666667%;\n  }\n  .col-md-6 {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-md-7 {\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%;\n  }\n  .col-md-8 {\n    -ms-flex: 0 0 66.666667%;\n    flex: 0 0 66.666667%;\n    max-width: 66.666667%;\n  }\n  .col-md-9 {\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-md-10 {\n    -ms-flex: 0 0 83.333333%;\n    flex: 0 0 83.333333%;\n    max-width: 83.333333%;\n  }\n  .col-md-11 {\n    -ms-flex: 0 0 91.666667%;\n    flex: 0 0 91.666667%;\n    max-width: 91.666667%;\n  }\n  .col-md-12 {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-md-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n  .order-md-last {\n    -ms-flex-order: 13;\n    order: 13;\n  }\n  .order-md-0 {\n    -ms-flex-order: 0;\n    order: 0;\n  }\n  .order-md-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n  .order-md-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n  .order-md-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n  .order-md-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n  .order-md-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n  .order-md-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n  .order-md-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n  .order-md-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n  .order-md-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n  .order-md-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n  .order-md-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n  .order-md-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.666667%;\n  }\n}\n\n@media (min-width: 992px) {\n  .col-lg {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-lg-1 > * {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n  .row-cols-lg-4 > * {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n  .col-lg-auto {\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-lg-1 {\n    -ms-flex: 0 0 8.333333%;\n    flex: 0 0 8.333333%;\n    max-width: 8.333333%;\n  }\n  .col-lg-2 {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n  .col-lg-3 {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-lg-4 {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n  .col-lg-5 {\n    -ms-flex: 0 0 41.666667%;\n    flex: 0 0 41.666667%;\n    max-width: 41.666667%;\n  }\n  .col-lg-6 {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-lg-7 {\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%;\n  }\n  .col-lg-8 {\n    -ms-flex: 0 0 66.666667%;\n    flex: 0 0 66.666667%;\n    max-width: 66.666667%;\n  }\n  .col-lg-9 {\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-lg-10 {\n    -ms-flex: 0 0 83.333333%;\n    flex: 0 0 83.333333%;\n    max-width: 83.333333%;\n  }\n  .col-lg-11 {\n    -ms-flex: 0 0 91.666667%;\n    flex: 0 0 91.666667%;\n    max-width: 91.666667%;\n  }\n  .col-lg-12 {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-lg-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n  .order-lg-last {\n    -ms-flex-order: 13;\n    order: 13;\n  }\n  .order-lg-0 {\n    -ms-flex-order: 0;\n    order: 0;\n  }\n  .order-lg-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n  .order-lg-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n  .order-lg-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n  .order-lg-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n  .order-lg-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n  .order-lg-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n  .order-lg-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n  .order-lg-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n  .order-lg-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n  .order-lg-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n  .order-lg-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n  .order-lg-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.666667%;\n  }\n}\n\n@media (min-width: 1200px) {\n  .col-xl {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-xl-1 > * {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n  .row-cols-xl-4 > * {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n  .col-xl-auto {\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-xl-1 {\n    -ms-flex: 0 0 8.333333%;\n    flex: 0 0 8.333333%;\n    max-width: 8.333333%;\n  }\n  .col-xl-2 {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n  .col-xl-3 {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-xl-4 {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n  .col-xl-5 {\n    -ms-flex: 0 0 41.666667%;\n    flex: 0 0 41.666667%;\n    max-width: 41.666667%;\n  }\n  .col-xl-6 {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-xl-7 {\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%;\n  }\n  .col-xl-8 {\n    -ms-flex: 0 0 66.666667%;\n    flex: 0 0 66.666667%;\n    max-width: 66.666667%;\n  }\n  .col-xl-9 {\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-xl-10 {\n    -ms-flex: 0 0 83.333333%;\n    flex: 0 0 83.333333%;\n    max-width: 83.333333%;\n  }\n  .col-xl-11 {\n    -ms-flex: 0 0 91.666667%;\n    flex: 0 0 91.666667%;\n    max-width: 91.666667%;\n  }\n  .col-xl-12 {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-xl-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n  .order-xl-last {\n    -ms-flex-order: 13;\n    order: 13;\n  }\n  .order-xl-0 {\n    -ms-flex-order: 0;\n    order: 0;\n  }\n  .order-xl-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n  .order-xl-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n  .order-xl-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n  .order-xl-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n  .order-xl-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n  .order-xl-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n  .order-xl-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n  .order-xl-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n  .order-xl-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n  .order-xl-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n  .order-xl-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n  .order-xl-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.666667%;\n  }\n}\n\n.table {\n  width: 100%;\n  margin-bottom: 1rem;\n  color: #212529;\n}\n\n.table th,\n.table td {\n  padding: 0.75rem;\n  vertical-align: top;\n  border-top: 1px solid #dee2e6;\n}\n\n.table thead th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.table tbody + tbody {\n  border-top: 2px solid #dee2e6;\n}\n\n.table-sm th,\n.table-sm td {\n  padding: 0.3rem;\n}\n\n.table-bordered {\n  border: 1px solid #dee2e6;\n}\n\n.table-bordered th,\n.table-bordered td {\n  border: 1px solid #dee2e6;\n}\n\n.table-bordered thead th,\n.table-bordered thead td {\n  border-bottom-width: 2px;\n}\n\n.table-borderless th,\n.table-borderless td,\n.table-borderless thead th,\n.table-borderless tbody + tbody {\n  border: 0;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.table-hover tbody tr:hover {\n  color: #212529;\n  background-color: rgba(0, 0, 0, 0.075);\n}\n\n.table-primary,\n.table-primary > th,\n.table-primary > td {\n  background-color: #b8daff;\n}\n\n.table-primary th,\n.table-primary td,\n.table-primary thead th,\n.table-primary tbody + tbody {\n  border-color: #7abaff;\n}\n\n.table-hover .table-primary:hover {\n  background-color: #9fcdff;\n}\n\n.table-hover .table-primary:hover > td,\n.table-hover .table-primary:hover > th {\n  background-color: #9fcdff;\n}\n\n.table-secondary,\n.table-secondary > th,\n.table-secondary > td {\n  background-color: #d6d8db;\n}\n\n.table-secondary th,\n.table-secondary td,\n.table-secondary thead th,\n.table-secondary tbody + tbody {\n  border-color: #b3b7bb;\n}\n\n.table-hover .table-secondary:hover {\n  background-color: #c8cbcf;\n}\n\n.table-hover .table-secondary:hover > td,\n.table-hover .table-secondary:hover > th {\n  background-color: #c8cbcf;\n}\n\n.table-success,\n.table-success > th,\n.table-success > td {\n  background-color: #c3e6cb;\n}\n\n.table-success th,\n.table-success td,\n.table-success thead th,\n.table-success tbody + tbody {\n  border-color: #8fd19e;\n}\n\n.table-hover .table-success:hover {\n  background-color: #b1dfbb;\n}\n\n.table-hover .table-success:hover > td,\n.table-hover .table-success:hover > th {\n  background-color: #b1dfbb;\n}\n\n.table-info,\n.table-info > th,\n.table-info > td {\n  background-color: #bee5eb;\n}\n\n.table-info th,\n.table-info td,\n.table-info thead th,\n.table-info tbody + tbody {\n  border-color: #86cfda;\n}\n\n.table-hover .table-info:hover {\n  background-color: #abdde5;\n}\n\n.table-hover .table-info:hover > td,\n.table-hover .table-info:hover > th {\n  background-color: #abdde5;\n}\n\n.table-warning,\n.table-warning > th,\n.table-warning > td {\n  background-color: #ffeeba;\n}\n\n.table-warning th,\n.table-warning td,\n.table-warning thead th,\n.table-warning tbody + tbody {\n  border-color: #ffdf7e;\n}\n\n.table-hover .table-warning:hover {\n  background-color: #ffe8a1;\n}\n\n.table-hover .table-warning:hover > td,\n.table-hover .table-warning:hover > th {\n  background-color: #ffe8a1;\n}\n\n.table-danger,\n.table-danger > th,\n.table-danger > td {\n  background-color: #f5c6cb;\n}\n\n.table-danger th,\n.table-danger td,\n.table-danger thead th,\n.table-danger tbody + tbody {\n  border-color: #ed969e;\n}\n\n.table-hover .table-danger:hover {\n  background-color: #f1b0b7;\n}\n\n.table-hover .table-danger:hover > td,\n.table-hover .table-danger:hover > th {\n  background-color: #f1b0b7;\n}\n\n.table-light,\n.table-light > th,\n.table-light > td {\n  background-color: #fdfdfe;\n}\n\n.table-light th,\n.table-light td,\n.table-light thead th,\n.table-light tbody + tbody {\n  border-color: #fbfcfc;\n}\n\n.table-hover .table-light:hover {\n  background-color: #ececf6;\n}\n\n.table-hover .table-light:hover > td,\n.table-hover .table-light:hover > th {\n  background-color: #ececf6;\n}\n\n.table-dark,\n.table-dark > th,\n.table-dark > td {\n  background-color: #c6c8ca;\n}\n\n.table-dark th,\n.table-dark td,\n.table-dark thead th,\n.table-dark tbody + tbody {\n  border-color: #95999c;\n}\n\n.table-hover .table-dark:hover {\n  background-color: #b9bbbe;\n}\n\n.table-hover .table-dark:hover > td,\n.table-hover .table-dark:hover > th {\n  background-color: #b9bbbe;\n}\n\n.table-active,\n.table-active > th,\n.table-active > td {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n\n.table-hover .table-active:hover {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n\n.table-hover .table-active:hover > td,\n.table-hover .table-active:hover > th {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n\n.table .thead-dark th {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #454d55;\n}\n\n.table .thead-light th {\n  color: #495057;\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n\n.table-dark {\n  color: #fff;\n  background-color: #343a40;\n}\n\n.table-dark th,\n.table-dark td,\n.table-dark thead th {\n  border-color: #454d55;\n}\n\n.table-dark.table-bordered {\n  border: 0;\n}\n\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.table-dark.table-hover tbody tr:hover {\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0.075);\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-sm > .table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-md > .table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-lg > .table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-xl > .table-bordered {\n    border: 0;\n  }\n}\n\n.table-responsive {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.table-responsive > .table-bordered {\n  border: 0;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n\n.form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n\n.form-control:focus {\n  color: #495057;\n  background-color: #fff;\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.form-control::-webkit-input-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n\n.form-control::-moz-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n\n.form-control:-ms-input-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n\n.form-control::-ms-input-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n\n.form-control::placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n\n.form-control:disabled, .form-control[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n\ninput[type=\"date\"].form-control,\ninput[type=\"time\"].form-control,\ninput[type=\"datetime-local\"].form-control,\ninput[type=\"month\"].form-control {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\nselect.form-control:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #495057;\n}\n\nselect.form-control:focus::-ms-value {\n  color: #495057;\n  background-color: #fff;\n}\n\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n.col-form-label {\n  padding-top: calc(0.375rem + 1px);\n  padding-bottom: calc(0.375rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 1.25rem;\n  line-height: 1.5;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0;\n  margin-bottom: 0;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #212529;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\n.form-control-lg {\n  height: calc(1.5em + 1rem + 2px);\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n\nselect.form-control[size], select.form-control[multiple] {\n  height: auto;\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-text {\n  display: block;\n  margin-top: 0.25rem;\n}\n\n.form-row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n\n.form-row > .col,\n.form-row > [class*=\"col-\"] {\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem;\n}\n\n.form-check-input[disabled] ~ .form-check-label,\n.form-check-input:disabled ~ .form-check-label {\n  color: #6c757d;\n}\n\n.form-check-label {\n  margin-bottom: 0;\n}\n\n.form-check-inline {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n  align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem;\n}\n\n.form-check-inline .form-check-input {\n  position: static;\n  margin-top: 0;\n  margin-right: 0.3125rem;\n  margin-left: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #28a745;\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: .1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(40, 167, 69, 0.9);\n  border-radius: 0.25rem;\n}\n\n.form-row > .col > .valid-tooltip,\n.form-row > [class*=\"col-\"] > .valid-tooltip {\n  left: 5px;\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: #28a745;\n  padding-right: calc(1.5em + 0.75rem) !important;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: #28a745;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n\n.was-validated select.form-control:valid, select.form-control.is-valid {\n  padding-right: 3rem !important;\n  background-position: right 1.5rem center;\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .custom-select:valid, .custom-select.is-valid {\n  border-color: #28a745;\n  padding-right: calc(0.75em + 2.3125rem) !important;\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right 0.75rem center/8px 10px no-repeat, #fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat;\n}\n\n.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {\n  border-color: #28a745;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #28a745;\n}\n\n.was-validated .form-check-input:valid ~ .valid-feedback,\n.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,\n.form-check-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {\n  color: #28a745;\n}\n\n.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {\n  border-color: #28a745;\n}\n\n.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {\n  border-color: #34ce57;\n  background-color: #34ce57;\n}\n\n.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n\n.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #28a745;\n}\n\n.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {\n  border-color: #28a745;\n}\n\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {\n  border-color: #28a745;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #dc3545;\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: .1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(220, 53, 69, 0.9);\n  border-radius: 0.25rem;\n}\n\n.form-row > .col > .invalid-tooltip,\n.form-row > [class*=\"col-\"] > .invalid-tooltip {\n  left: 5px;\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: #dc3545;\n  padding-right: calc(1.5em + 0.75rem) !important;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.was-validated select.form-control:invalid, select.form-control.is-invalid {\n  padding-right: 3rem !important;\n  background-position: right 1.5rem center;\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .custom-select:invalid, .custom-select.is-invalid {\n  border-color: #dc3545;\n  padding-right: calc(0.75em + 2.3125rem) !important;\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right 0.75rem center/8px 10px no-repeat, #fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\") center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat;\n}\n\n.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #dc3545;\n}\n\n.was-validated .form-check-input:invalid ~ .invalid-feedback,\n.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,\n.form-check-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {\n  color: #dc3545;\n}\n\n.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {\n  border-color: #dc3545;\n}\n\n.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {\n  border-color: #e4606d;\n  background-color: #e4606d;\n}\n\n.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #dc3545;\n}\n\n.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {\n  border-color: #dc3545;\n}\n\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.form-inline {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row wrap;\n  flex-flow: row wrap;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.form-inline .form-check {\n  width: 100%;\n}\n\n@media (min-width: 576px) {\n  .form-inline label {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-group {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    -ms-flex-flow: row wrap;\n    flex-flow: row wrap;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .form-inline .form-control-plaintext {\n    display: inline-block;\n  }\n  .form-inline .input-group,\n  .form-inline .custom-select {\n    width: auto;\n  }\n  .form-inline .form-check {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    width: auto;\n    padding-left: 0;\n  }\n  .form-inline .form-check-input {\n    position: relative;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    margin-top: 0;\n    margin-right: 0.25rem;\n    margin-left: 0;\n  }\n  .form-inline .custom-control {\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n  }\n  .form-inline .custom-control-label {\n    margin-bottom: 0;\n  }\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  color: #212529;\n  text-align: center;\n  vertical-align: middle;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n\n.btn:hover {\n  color: #212529;\n  text-decoration: none;\n}\n\n.btn:focus, .btn.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.btn.disabled, .btn:disabled {\n  opacity: 0.65;\n}\n\n.btn:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n\n.btn-primary:hover {\n  color: #fff;\n  background-color: #0069d9;\n  border-color: #0062cc;\n}\n\n.btn-primary:focus, .btn-primary.focus {\n  color: #fff;\n  background-color: #0069d9;\n  border-color: #0062cc;\n  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n}\n\n.btn-primary.disabled, .btn-primary:disabled {\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,\n.show > .btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #0062cc;\n  border-color: #005cbf;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-secondary:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n\n.btn-secondary:focus, .btn-secondary.focus {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n  box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);\n}\n\n.btn-secondary.disabled, .btn-secondary:disabled {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active,\n.show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #545b62;\n  border-color: #4e555b;\n}\n\n.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);\n}\n\n.btn-success {\n  color: #fff;\n  background-color: #28a745;\n  border-color: #28a745;\n}\n\n.btn-success:hover {\n  color: #fff;\n  background-color: #218838;\n  border-color: #1e7e34;\n}\n\n.btn-success:focus, .btn-success.focus {\n  color: #fff;\n  background-color: #218838;\n  border-color: #1e7e34;\n  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);\n}\n\n.btn-success.disabled, .btn-success:disabled {\n  color: #fff;\n  background-color: #28a745;\n  border-color: #28a745;\n}\n\n.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active,\n.show > .btn-success.dropdown-toggle {\n  color: #fff;\n  background-color: #1e7e34;\n  border-color: #1c7430;\n}\n\n.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus,\n.show > .btn-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);\n}\n\n.btn-info {\n  color: #fff;\n  background-color: #17a2b8;\n  border-color: #17a2b8;\n}\n\n.btn-info:hover {\n  color: #fff;\n  background-color: #138496;\n  border-color: #117a8b;\n}\n\n.btn-info:focus, .btn-info.focus {\n  color: #fff;\n  background-color: #138496;\n  border-color: #117a8b;\n  box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);\n}\n\n.btn-info.disabled, .btn-info:disabled {\n  color: #fff;\n  background-color: #17a2b8;\n  border-color: #17a2b8;\n}\n\n.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active,\n.show > .btn-info.dropdown-toggle {\n  color: #fff;\n  background-color: #117a8b;\n  border-color: #10707f;\n}\n\n.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus,\n.show > .btn-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);\n}\n\n.btn-warning {\n  color: #212529;\n  background-color: #ffc107;\n  border-color: #ffc107;\n}\n\n.btn-warning:hover {\n  color: #212529;\n  background-color: #e0a800;\n  border-color: #d39e00;\n}\n\n.btn-warning:focus, .btn-warning.focus {\n  color: #212529;\n  background-color: #e0a800;\n  border-color: #d39e00;\n  box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);\n}\n\n.btn-warning.disabled, .btn-warning:disabled {\n  color: #212529;\n  background-color: #ffc107;\n  border-color: #ffc107;\n}\n\n.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active,\n.show > .btn-warning.dropdown-toggle {\n  color: #212529;\n  background-color: #d39e00;\n  border-color: #c69500;\n}\n\n.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus,\n.show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #dc3545;\n  border-color: #dc3545;\n}\n\n.btn-danger:hover {\n  color: #fff;\n  background-color: #c82333;\n  border-color: #bd2130;\n}\n\n.btn-danger:focus, .btn-danger.focus {\n  color: #fff;\n  background-color: #c82333;\n  border-color: #bd2130;\n  box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);\n}\n\n.btn-danger.disabled, .btn-danger:disabled {\n  color: #fff;\n  background-color: #dc3545;\n  border-color: #dc3545;\n}\n\n.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active,\n.show > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #bd2130;\n  border-color: #b21f2d;\n}\n\n.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus,\n.show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);\n}\n\n.btn-light {\n  color: #212529;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n\n.btn-light:hover {\n  color: #212529;\n  background-color: #e2e6ea;\n  border-color: #dae0e5;\n}\n\n.btn-light:focus, .btn-light.focus {\n  color: #212529;\n  background-color: #e2e6ea;\n  border-color: #dae0e5;\n  box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);\n}\n\n.btn-light.disabled, .btn-light:disabled {\n  color: #212529;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n\n.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active,\n.show > .btn-light.dropdown-toggle {\n  color: #212529;\n  background-color: #dae0e5;\n  border-color: #d3d9df;\n}\n\n.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus,\n.show > .btn-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);\n}\n\n.btn-dark {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n\n.btn-dark:hover {\n  color: #fff;\n  background-color: #23272b;\n  border-color: #1d2124;\n}\n\n.btn-dark:focus, .btn-dark.focus {\n  color: #fff;\n  background-color: #23272b;\n  border-color: #1d2124;\n  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);\n}\n\n.btn-dark.disabled, .btn-dark:disabled {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n\n.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active,\n.show > .btn-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #1d2124;\n  border-color: #171a1d;\n}\n\n.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus,\n.show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);\n}\n\n.btn-outline-primary {\n  color: #007bff;\n  border-color: #007bff;\n}\n\n.btn-outline-primary:hover {\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n\n.btn-outline-primary:focus, .btn-outline-primary.focus {\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);\n}\n\n.btn-outline-primary.disabled, .btn-outline-primary:disabled {\n  color: #007bff;\n  background-color: transparent;\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active,\n.show > .btn-outline-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);\n}\n\n.btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-outline-secondary:focus, .btn-outline-secondary.focus {\n  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);\n}\n\n.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {\n  color: #6c757d;\n  background-color: transparent;\n}\n\n.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active,\n.show > .btn-outline-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);\n}\n\n.btn-outline-success {\n  color: #28a745;\n  border-color: #28a745;\n}\n\n.btn-outline-success:hover {\n  color: #fff;\n  background-color: #28a745;\n  border-color: #28a745;\n}\n\n.btn-outline-success:focus, .btn-outline-success.focus {\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n}\n\n.btn-outline-success.disabled, .btn-outline-success:disabled {\n  color: #28a745;\n  background-color: transparent;\n}\n\n.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active,\n.show > .btn-outline-success.dropdown-toggle {\n  color: #fff;\n  background-color: #28a745;\n  border-color: #28a745;\n}\n\n.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n}\n\n.btn-outline-info {\n  color: #17a2b8;\n  border-color: #17a2b8;\n}\n\n.btn-outline-info:hover {\n  color: #fff;\n  background-color: #17a2b8;\n  border-color: #17a2b8;\n}\n\n.btn-outline-info:focus, .btn-outline-info.focus {\n  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n}\n\n.btn-outline-info.disabled, .btn-outline-info:disabled {\n  color: #17a2b8;\n  background-color: transparent;\n}\n\n.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active,\n.show > .btn-outline-info.dropdown-toggle {\n  color: #fff;\n  background-color: #17a2b8;\n  border-color: #17a2b8;\n}\n\n.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n}\n\n.btn-outline-warning {\n  color: #ffc107;\n  border-color: #ffc107;\n}\n\n.btn-outline-warning:hover {\n  color: #212529;\n  background-color: #ffc107;\n  border-color: #ffc107;\n}\n\n.btn-outline-warning:focus, .btn-outline-warning.focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n\n.btn-outline-warning.disabled, .btn-outline-warning:disabled {\n  color: #ffc107;\n  background-color: transparent;\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active,\n.show > .btn-outline-warning.dropdown-toggle {\n  color: #212529;\n  background-color: #ffc107;\n  border-color: #ffc107;\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n\n.btn-outline-danger {\n  color: #dc3545;\n  border-color: #dc3545;\n}\n\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #dc3545;\n  border-color: #dc3545;\n}\n\n.btn-outline-danger:focus, .btn-outline-danger.focus {\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);\n}\n\n.btn-outline-danger.disabled, .btn-outline-danger:disabled {\n  color: #dc3545;\n  background-color: transparent;\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active,\n.show > .btn-outline-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #dc3545;\n  border-color: #dc3545;\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);\n}\n\n.btn-outline-light {\n  color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n\n.btn-outline-light:hover {\n  color: #212529;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n\n.btn-outline-light:focus, .btn-outline-light.focus {\n  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);\n}\n\n.btn-outline-light.disabled, .btn-outline-light:disabled {\n  color: #f8f9fa;\n  background-color: transparent;\n}\n\n.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active,\n.show > .btn-outline-light.dropdown-toggle {\n  color: #212529;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n\n.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);\n}\n\n.btn-outline-dark {\n  color: #343a40;\n  border-color: #343a40;\n}\n\n.btn-outline-dark:hover {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n\n.btn-outline-dark:focus, .btn-outline-dark.focus {\n  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\n}\n\n.btn-outline-dark.disabled, .btn-outline-dark:disabled {\n  color: #343a40;\n  background-color: transparent;\n}\n\n.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active,\n.show > .btn-outline-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\n}\n\n.btn-link {\n  font-weight: 400;\n  color: #007bff;\n  text-decoration: none;\n}\n\n.btn-link:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\n\n.btn-link:focus, .btn-link.focus {\n  text-decoration: underline;\n}\n\n.btn-link:disabled, .btn-link.disabled {\n  color: #6c757d;\n  pointer-events: none;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n\n.btn-block + .btn-block {\n  margin-top: 0.5rem;\n}\n\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n\n.collapsing.width {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.width {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 1rem;\n  color: #212529;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n}\n\n.dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 768px) {\n  .dropdown-menu-md-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 992px) {\n  .dropdown-menu-lg-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n.dropup .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0.125rem;\n}\n\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropright .dropdown-menu {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0.125rem;\n}\n\n.dropright .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n\n.dropright .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropright .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropleft .dropdown-menu {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0.125rem;\n}\n\n.dropleft .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n\n.dropleft .dropdown-toggle::after {\n  display: none;\n}\n\n.dropleft .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n\n.dropleft .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropleft .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-menu[x-placement^=\"top\"], .dropdown-menu[x-placement^=\"right\"], .dropdown-menu[x-placement^=\"bottom\"], .dropdown-menu[x-placement^=\"left\"] {\n  right: auto;\n  bottom: auto;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  border-top: 1px solid #e9ecef;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.25rem 1.5rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n\n.dropdown-item:hover, .dropdown-item:focus {\n  color: #16181b;\n  text-decoration: none;\n  background-color: #e9ecef;\n}\n\n.dropdown-item.active, .dropdown-item:active {\n  color: #fff;\n  text-decoration: none;\n  background-color: #007bff;\n}\n\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: #adb5bd;\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: 0.5rem 1.5rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: #6c757d;\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.25rem 1.5rem;\n  color: #212529;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n\n.btn-group > .btn:hover,\n.btn-group-vertical > .btn:hover {\n  z-index: 1;\n}\n\n.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: -1px;\n}\n\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem;\n}\n\n.dropdown-toggle-split::after,\n.dropup .dropdown-toggle-split::after,\n.dropright .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n\n.dropleft .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: -1px;\n}\n\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.btn-group-toggle > .btn,\n.btn-group-toggle > .btn-group > .btn {\n  margin-bottom: 0;\n}\n\n.btn-group-toggle > .btn input[type=\"radio\"],\n.btn-group-toggle > .btn input[type=\"checkbox\"],\n.btn-group-toggle > .btn-group > .btn input[type=\"radio\"],\n.btn-group-toggle > .btn-group > .btn input[type=\"checkbox\"] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n\n.input-group {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  width: 100%;\n}\n\n.input-group > .form-control,\n.input-group > .form-control-plaintext,\n.input-group > .custom-select,\n.input-group > .custom-file {\n  position: relative;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n  margin-bottom: 0;\n}\n\n.input-group > .form-control + .form-control,\n.input-group > .form-control + .custom-select,\n.input-group > .form-control + .custom-file,\n.input-group > .form-control-plaintext + .form-control,\n.input-group > .form-control-plaintext + .custom-select,\n.input-group > .form-control-plaintext + .custom-file,\n.input-group > .custom-select + .form-control,\n.input-group > .custom-select + .custom-select,\n.input-group > .custom-select + .custom-file,\n.input-group > .custom-file + .form-control,\n.input-group > .custom-file + .custom-select,\n.input-group > .custom-file + .custom-file {\n  margin-left: -1px;\n}\n\n.input-group > .form-control:focus,\n.input-group > .custom-select:focus,\n.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {\n  z-index: 3;\n}\n\n.input-group > .custom-file .custom-file-input:focus {\n  z-index: 4;\n}\n\n.input-group > .form-control:not(:first-child),\n.input-group > .custom-select:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group > .custom-file {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.input-group > .custom-file:not(:last-child) .custom-file-label,\n.input-group > .custom-file:not(:last-child) .custom-file-label::after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group > .custom-file:not(:first-child) .custom-file-label {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group:not(.has-validation) > .form-control:not(:last-child),\n.input-group:not(.has-validation) > .custom-select:not(:last-child),\n.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,\n.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group.has-validation > .form-control:nth-last-child(n + 3),\n.input-group.has-validation > .custom-select:nth-last-child(n + 3),\n.input-group.has-validation > .custom-file:nth-last-child(n + 3) .custom-file-label,\n.input-group.has-validation > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group-prepend,\n.input-group-append {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.input-group-prepend .btn,\n.input-group-append .btn {\n  position: relative;\n  z-index: 2;\n}\n\n.input-group-prepend .btn:focus,\n.input-group-append .btn:focus {\n  z-index: 3;\n}\n\n.input-group-prepend .btn + .btn,\n.input-group-prepend .btn + .input-group-text,\n.input-group-prepend .input-group-text + .input-group-text,\n.input-group-prepend .input-group-text + .btn,\n.input-group-append .btn + .btn,\n.input-group-append .btn + .input-group-text,\n.input-group-append .input-group-text + .input-group-text,\n.input-group-append .input-group-text + .btn {\n  margin-left: -1px;\n}\n\n.input-group-prepend {\n  margin-right: -1px;\n}\n\n.input-group-append {\n  margin-left: -1px;\n}\n\n.input-group-text {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n.input-group-text input[type=\"radio\"],\n.input-group-text input[type=\"checkbox\"] {\n  margin-top: 0;\n}\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: calc(1.5em + 1rem + 2px);\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: calc(1.5em + 0.5rem + 2px);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: 1.75rem;\n}\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5rem;\n  -webkit-print-color-adjust: exact;\n  color-adjust: exact;\n  print-color-adjust: exact;\n}\n\n.custom-control-inline {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin-right: 1rem;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1;\n  width: 1rem;\n  height: 1.25rem;\n  opacity: 0;\n}\n\n.custom-control-input:checked ~ .custom-control-label::before {\n  color: #fff;\n  border-color: #007bff;\n  background-color: #007bff;\n}\n\n.custom-control-input:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #80bdff;\n}\n\n.custom-control-input:not(:disabled):active ~ .custom-control-label::before {\n  color: #fff;\n  background-color: #b3d7ff;\n  border-color: #b3d7ff;\n}\n\n.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {\n  color: #6c757d;\n}\n\n.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {\n  background-color: #e9ecef;\n}\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  vertical-align: top;\n}\n\n.custom-control-label::before {\n  position: absolute;\n  top: 0.25rem;\n  left: -1.5rem;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  pointer-events: none;\n  content: \"\";\n  background-color: #fff;\n  border: 1px solid #adb5bd;\n}\n\n.custom-control-label::after {\n  position: absolute;\n  top: 0.25rem;\n  left: -1.5rem;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  content: \"\";\n  background: 50% / 50% 50% no-repeat;\n}\n\n.custom-checkbox .custom-control-label::before {\n  border-radius: 0.25rem;\n}\n\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\n}\n\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {\n  border-color: #007bff;\n  background-color: #007bff;\n}\n\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\");\n}\n\n.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(0, 123, 255, 0.5);\n}\n\n.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {\n  background-color: rgba(0, 123, 255, 0.5);\n}\n\n.custom-radio .custom-control-label::before {\n  border-radius: 50%;\n}\n\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n\n.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(0, 123, 255, 0.5);\n}\n\n.custom-switch {\n  padding-left: 2.25rem;\n}\n\n.custom-switch .custom-control-label::before {\n  left: -2.25rem;\n  width: 1.75rem;\n  pointer-events: all;\n  border-radius: 0.5rem;\n}\n\n.custom-switch .custom-control-label::after {\n  top: calc(0.25rem + 2px);\n  left: calc(-2.25rem + 2px);\n  width: calc(1rem - 4px);\n  height: calc(1rem - 4px);\n  background-color: #adb5bd;\n  border-radius: 0.5rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-transform 0.15s ease-in-out;\n  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-transform 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-switch .custom-control-label::after {\n    transition: none;\n  }\n}\n\n.custom-switch .custom-control-input:checked ~ .custom-control-label::after {\n  background-color: #fff;\n  -webkit-transform: translateX(0.75rem);\n  transform: translateX(0.75rem);\n}\n\n.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(0, 123, 255, 0.5);\n}\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  vertical-align: middle;\n  background: #fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right 0.75rem center/8px 10px no-repeat;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.custom-select:focus {\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.custom-select:focus::-ms-value {\n  color: #495057;\n  background-color: #fff;\n}\n\n.custom-select[multiple], .custom-select[size]:not([size=\"1\"]) {\n  height: auto;\n  padding-right: 0.75rem;\n  background-image: none;\n}\n\n.custom-select:disabled {\n  color: #6c757d;\n  background-color: #e9ecef;\n}\n\n.custom-select::-ms-expand {\n  display: none;\n}\n\n.custom-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #495057;\n}\n\n.custom-select-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.875rem;\n}\n\n.custom-select-lg {\n  height: calc(1.5em + 1rem + 2px);\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.25rem;\n}\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n}\n\n.custom-file-input:focus ~ .custom-file-label {\n  border-color: #80bdff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.custom-file-input[disabled] ~ .custom-file-label,\n.custom-file-input:disabled ~ .custom-file-label {\n  background-color: #e9ecef;\n}\n\n.custom-file-input:lang(en) ~ .custom-file-label::after {\n  content: \"Browse\";\n}\n\n.custom-file-input ~ .custom-file-label[data-browse]::after {\n  content: attr(data-browse);\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 0.75rem;\n  overflow: hidden;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n.custom-file-label::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n  display: block;\n  height: calc(1.5em + 0.75rem);\n  padding: 0.375rem 0.75rem;\n  line-height: 1.5;\n  color: #495057;\n  content: \"Browse\";\n  background-color: #e9ecef;\n  border-left: inherit;\n  border-radius: 0 0.25rem 0.25rem 0;\n}\n\n.custom-range {\n  width: 100%;\n  height: 1.4rem;\n  padding: 0;\n  background-color: transparent;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.custom-range:focus {\n  outline: 0;\n}\n\n.custom-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.custom-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.custom-range:focus::-ms-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.custom-range::-moz-focus-outer {\n  border: 0;\n}\n\n.custom-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: #007bff;\n  border: 0;\n  border-radius: 1rem;\n  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-webkit-slider-thumb {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.custom-range::-webkit-slider-thumb:active {\n  background-color: #b3d7ff;\n}\n\n.custom-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n\n.custom-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: #007bff;\n  border: 0;\n  border-radius: 1rem;\n  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-moz-range-thumb {\n    -moz-transition: none;\n    transition: none;\n  }\n}\n\n.custom-range::-moz-range-thumb:active {\n  background-color: #b3d7ff;\n}\n\n.custom-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n\n.custom-range::-ms-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: 0;\n  margin-right: 0.2rem;\n  margin-left: 0.2rem;\n  background-color: #007bff;\n  border: 0;\n  border-radius: 1rem;\n  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-ms-thumb {\n    -ms-transition: none;\n    transition: none;\n  }\n}\n\n.custom-range::-ms-thumb:active {\n  background-color: #b3d7ff;\n}\n\n.custom-range::-ms-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: transparent;\n  border-color: transparent;\n  border-width: 0.5rem;\n}\n\n.custom-range::-ms-fill-lower {\n  background-color: #dee2e6;\n  border-radius: 1rem;\n}\n\n.custom-range::-ms-fill-upper {\n  margin-right: 15px;\n  background-color: #dee2e6;\n  border-radius: 1rem;\n}\n\n.custom-range:disabled::-webkit-slider-thumb {\n  background-color: #adb5bd;\n}\n\n.custom-range:disabled::-webkit-slider-runnable-track {\n  cursor: default;\n}\n\n.custom-range:disabled::-moz-range-thumb {\n  background-color: #adb5bd;\n}\n\n.custom-range:disabled::-moz-range-track {\n  cursor: default;\n}\n\n.custom-range:disabled::-ms-thumb {\n  background-color: #adb5bd;\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-control-label::before,\n  .custom-file-label,\n  .custom-select {\n    transition: none;\n  }\n}\n\n.nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem;\n}\n\n.nav-link:hover, .nav-link:focus {\n  text-decoration: none;\n}\n\n.nav-link.disabled {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  border-bottom: 1px solid #dee2e6;\n}\n\n.nav-tabs .nav-link {\n  margin-bottom: -1px;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: #e9ecef #e9ecef #dee2e6;\n}\n\n.nav-tabs .nav-link.disabled {\n  color: #6c757d;\n  background-color: transparent;\n  border-color: transparent;\n}\n\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: #495057;\n  background-color: #fff;\n  border-color: #dee2e6 #dee2e6 #fff;\n}\n\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills .nav-link {\n  background: none;\n  border: 0;\n  border-radius: 0.25rem;\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #007bff;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding: 0.5rem 1rem;\n}\n\n.navbar .container,\n.navbar .container-fluid, .navbar .container-sm, .navbar .container-md, .navbar .container-lg, .navbar .container-xl {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: 0.3125rem;\n  padding-bottom: 0.3125rem;\n  margin-right: 1rem;\n  font-size: 1.25rem;\n  line-height: inherit;\n  white-space: nowrap;\n}\n\n.navbar-brand:hover, .navbar-brand:focus {\n  text-decoration: none;\n}\n\n.navbar-nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.navbar-nav .dropdown-menu {\n  position: static;\n  float: none;\n}\n\n.navbar-text {\n  display: inline-block;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.navbar-collapse {\n  -ms-flex-preferred-size: 100%;\n  flex-basis: 100%;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.25rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n\n.navbar-toggler:hover, .navbar-toggler:focus {\n  text-decoration: none;\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: 75vh;\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    -ms-flex-flow: row nowrap;\n    flex-flow: row nowrap;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    -ms-flex-flow: row nowrap;\n    flex-flow: row nowrap;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl {\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    -ms-flex-flow: row nowrap;\n    flex-flow: row nowrap;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl {\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    -ms-flex-flow: row nowrap;\n    flex-flow: row nowrap;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl {\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n}\n\n.navbar-expand {\n  -ms-flex-flow: row nowrap;\n  flex-flow: row nowrap;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n\n.navbar-expand > .container,\n.navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.navbar-expand .navbar-nav {\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n\n.navbar-expand > .container,\n.navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl {\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n\n.navbar-expand .navbar-collapse {\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -ms-flex-preferred-size: auto;\n  flex-basis: auto;\n}\n\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {\n  color: rgba(0, 0, 0, 0.7);\n}\n\n.navbar-light .navbar-nav .nav-link.disabled {\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.5);\n  border-color: rgba(0, 0, 0, 0.1);\n}\n\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.navbar-light .navbar-text a {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-dark .navbar-brand {\n  color: #fff;\n}\n\n.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {\n  color: #fff;\n}\n\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.navbar-dark .navbar-nav .nav-link.disabled {\n  color: rgba(255, 255, 255, 0.25);\n}\n\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .active > .nav-link,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: #fff;\n}\n\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.5);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.navbar-dark .navbar-text a {\n  color: #fff;\n}\n\n.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {\n  color: #fff;\n}\n\n.card {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  border-radius: 0.25rem;\n}\n\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  min-height: 1px;\n  padding: 1.25rem;\n}\n\n.card-title {\n  margin-bottom: 0.75rem;\n}\n\n.card-subtitle {\n  margin-top: -0.375rem;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link:hover {\n  text-decoration: none;\n}\n\n.card-link + .card-link {\n  margin-left: 1.25rem;\n}\n\n.card-header {\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 0;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.card-header:first-child {\n  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;\n}\n\n.card-footer {\n  padding: 0.75rem 1.25rem;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-top: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.card-footer:last-child {\n  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);\n}\n\n.card-header-tabs {\n  margin-right: -0.625rem;\n  margin-bottom: -0.75rem;\n  margin-left: -0.625rem;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -0.625rem;\n  margin-left: -0.625rem;\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem;\n  border-radius: calc(0.25rem - 1px);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n\n.card-deck .card {\n  margin-bottom: 15px;\n}\n\n@media (min-width: 576px) {\n  .card-deck {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: row wrap;\n    flex-flow: row wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n  }\n  .card-deck .card {\n    -ms-flex: 1 0 0%;\n    flex: 1 0 0%;\n    margin-right: 15px;\n    margin-bottom: 0;\n    margin-left: 15px;\n  }\n}\n\n.card-group > .card {\n  margin-bottom: 15px;\n}\n\n@media (min-width: 576px) {\n  .card-group {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: row wrap;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    -ms-flex: 1 0 0%;\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.card-columns .card {\n  margin-bottom: 0.75rem;\n}\n\n@media (min-width: 576px) {\n  .card-columns {\n    -webkit-column-count: 3;\n    -moz-column-count: 3;\n    column-count: 3;\n    -webkit-column-gap: 1.25rem;\n    -moz-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n    orphans: 1;\n    widows: 1;\n  }\n  .card-columns .card {\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n.accordion {\n  overflow-anchor: none;\n}\n\n.accordion > .card {\n  overflow: hidden;\n}\n\n.accordion > .card:not(:last-of-type) {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.accordion > .card:not(:first-of-type) {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.accordion > .card > .card-header {\n  border-radius: 0;\n  margin-bottom: -1px;\n}\n\n.breadcrumb {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: #e9ecef;\n  border-radius: 0.25rem;\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: 0.5rem;\n}\n\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: 0.5rem;\n  color: #6c757d;\n  content: \"/\";\n}\n\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: underline;\n}\n\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: none;\n}\n\n.breadcrumb-item.active {\n  color: #6c757d;\n}\n\n.pagination {\n  display: -ms-flexbox;\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n  border-radius: 0.25rem;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #007bff;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n}\n\n.page-link:hover {\n  z-index: 2;\n  color: #0056b3;\n  text-decoration: none;\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n\n.page-link:focus {\n  z-index: 3;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.page-item:first-child .page-link {\n  margin-left: 0;\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.page-item:last-child .page-link {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.page-item.active .page-link {\n  z-index: 3;\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n\n.page-item.disabled .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n}\n\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 0.3rem;\n  border-bottom-left-radius: 0.3rem;\n}\n\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 0.2rem;\n  border-bottom-left-radius: 0.2rem;\n}\n\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 0.2rem;\n  border-bottom-right-radius: 0.2rem;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .badge {\n    transition: none;\n  }\n}\n\na.badge:hover, a.badge:focus {\n  text-decoration: none;\n}\n\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.badge-pill {\n  padding-right: 0.6em;\n  padding-left: 0.6em;\n  border-radius: 10rem;\n}\n\n.badge-primary {\n  color: #fff;\n  background-color: #007bff;\n}\n\na.badge-primary:hover, a.badge-primary:focus {\n  color: #fff;\n  background-color: #0062cc;\n}\n\na.badge-primary:focus, a.badge-primary.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);\n}\n\n.badge-secondary {\n  color: #fff;\n  background-color: #6c757d;\n}\n\na.badge-secondary:hover, a.badge-secondary:focus {\n  color: #fff;\n  background-color: #545b62;\n}\n\na.badge-secondary:focus, a.badge-secondary.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);\n}\n\n.badge-success {\n  color: #fff;\n  background-color: #28a745;\n}\n\na.badge-success:hover, a.badge-success:focus {\n  color: #fff;\n  background-color: #1e7e34;\n}\n\na.badge-success:focus, a.badge-success.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n}\n\n.badge-info {\n  color: #fff;\n  background-color: #17a2b8;\n}\n\na.badge-info:hover, a.badge-info:focus {\n  color: #fff;\n  background-color: #117a8b;\n}\n\na.badge-info:focus, a.badge-info.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n}\n\n.badge-warning {\n  color: #212529;\n  background-color: #ffc107;\n}\n\na.badge-warning:hover, a.badge-warning:focus {\n  color: #212529;\n  background-color: #d39e00;\n}\n\na.badge-warning:focus, a.badge-warning.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n\n.badge-danger {\n  color: #fff;\n  background-color: #dc3545;\n}\n\na.badge-danger:hover, a.badge-danger:focus {\n  color: #fff;\n  background-color: #bd2130;\n}\n\na.badge-danger:focus, a.badge-danger.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);\n}\n\n.badge-light {\n  color: #212529;\n  background-color: #f8f9fa;\n}\n\na.badge-light:hover, a.badge-light:focus {\n  color: #212529;\n  background-color: #dae0e5;\n}\n\na.badge-light:focus, a.badge-light.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);\n}\n\n.badge-dark {\n  color: #fff;\n  background-color: #343a40;\n}\n\na.badge-dark:hover, a.badge-dark:focus {\n  color: #fff;\n  background-color: #1d2124;\n}\n\na.badge-dark:focus, a.badge-dark.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\n}\n\n.jumbotron {\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  background-color: #e9ecef;\n  border-radius: 0.3rem;\n}\n\n@media (min-width: 576px) {\n  .jumbotron {\n    padding: 4rem 2rem;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  border-radius: 0;\n}\n\n.alert {\n  position: relative;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n}\n\n.alert-dismissible {\n  padding-right: 4rem;\n}\n\n.alert-dismissible .close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 0.75rem 1.25rem;\n  color: inherit;\n}\n\n.alert-primary {\n  color: #004085;\n  background-color: #cce5ff;\n  border-color: #b8daff;\n}\n\n.alert-primary hr {\n  border-top-color: #9fcdff;\n}\n\n.alert-primary .alert-link {\n  color: #002752;\n}\n\n.alert-secondary {\n  color: #383d41;\n  background-color: #e2e3e5;\n  border-color: #d6d8db;\n}\n\n.alert-secondary hr {\n  border-top-color: #c8cbcf;\n}\n\n.alert-secondary .alert-link {\n  color: #202326;\n}\n\n.alert-success {\n  color: #155724;\n  background-color: #d4edda;\n  border-color: #c3e6cb;\n}\n\n.alert-success hr {\n  border-top-color: #b1dfbb;\n}\n\n.alert-success .alert-link {\n  color: #0b2e13;\n}\n\n.alert-info {\n  color: #0c5460;\n  background-color: #d1ecf1;\n  border-color: #bee5eb;\n}\n\n.alert-info hr {\n  border-top-color: #abdde5;\n}\n\n.alert-info .alert-link {\n  color: #062c33;\n}\n\n.alert-warning {\n  color: #856404;\n  background-color: #fff3cd;\n  border-color: #ffeeba;\n}\n\n.alert-warning hr {\n  border-top-color: #ffe8a1;\n}\n\n.alert-warning .alert-link {\n  color: #533f03;\n}\n\n.alert-danger {\n  color: #721c24;\n  background-color: #f8d7da;\n  border-color: #f5c6cb;\n}\n\n.alert-danger hr {\n  border-top-color: #f1b0b7;\n}\n\n.alert-danger .alert-link {\n  color: #491217;\n}\n\n.alert-light {\n  color: #818182;\n  background-color: #fefefe;\n  border-color: #fdfdfe;\n}\n\n.alert-light hr {\n  border-top-color: #ececf6;\n}\n\n.alert-light .alert-link {\n  color: #686868;\n}\n\n.alert-dark {\n  color: #1b1e21;\n  background-color: #d6d8d9;\n  border-color: #c6c8ca;\n}\n\n.alert-dark hr {\n  border-top-color: #b9bbbe;\n}\n\n.alert-dark .alert-link {\n  color: #040505;\n}\n\n@-webkit-keyframes progress-bar-stripes {\n  from {\n    background-position: 1rem 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 1rem 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n\n.progress {\n  display: -ms-flexbox;\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n  line-height: 0;\n  font-size: 0.75rem;\n  background-color: #e9ecef;\n  border-radius: 0.25rem;\n}\n\n.progress-bar {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -ms-flex-pack: center;\n  justify-content: center;\n  overflow: hidden;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #007bff;\n  transition: width 0.6s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 1rem 1rem;\n}\n\n.progress-bar-animated {\n  -webkit-animation: 1s linear infinite progress-bar-stripes;\n  animation: 1s linear infinite progress-bar-stripes;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    -webkit-animation: none;\n    animation: none;\n  }\n}\n\n.media {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n\n.media-body {\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.list-group {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: 0.25rem;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: #495057;\n  text-align: inherit;\n}\n\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: #495057;\n  text-decoration: none;\n  background-color: #f8f9fa;\n}\n\n.list-group-item-action:active {\n  color: #212529;\n  background-color: #e9ecef;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 0.75rem 1.25rem;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n\n.list-group-item.disabled, .list-group-item:disabled {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #fff;\n}\n\n.list-group-item.active {\n  z-index: 2;\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n\n.list-group-item + .list-group-item.active {\n  margin-top: -1px;\n  border-top-width: 1px;\n}\n\n.list-group-horizontal {\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.list-group-horizontal > .list-group-item:first-child {\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n}\n\n.list-group-horizontal > .list-group-item:last-child {\n  border-top-right-radius: 0.25rem;\n  border-bottom-left-radius: 0;\n}\n\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: 1px;\n  border-left-width: 0;\n}\n\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: -1px;\n  border-left-width: 1px;\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n\n.list-group-flush {\n  border-radius: 0;\n}\n\n.list-group-flush > .list-group-item {\n  border-width: 0 0 1px;\n}\n\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  color: #004085;\n  background-color: #b8daff;\n}\n\n.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n  color: #004085;\n  background-color: #9fcdff;\n}\n\n.list-group-item-primary.list-group-item-action.active {\n  color: #fff;\n  background-color: #004085;\n  border-color: #004085;\n}\n\n.list-group-item-secondary {\n  color: #383d41;\n  background-color: #d6d8db;\n}\n\n.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n  color: #383d41;\n  background-color: #c8cbcf;\n}\n\n.list-group-item-secondary.list-group-item-action.active {\n  color: #fff;\n  background-color: #383d41;\n  border-color: #383d41;\n}\n\n.list-group-item-success {\n  color: #155724;\n  background-color: #c3e6cb;\n}\n\n.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n  color: #155724;\n  background-color: #b1dfbb;\n}\n\n.list-group-item-success.list-group-item-action.active {\n  color: #fff;\n  background-color: #155724;\n  border-color: #155724;\n}\n\n.list-group-item-info {\n  color: #0c5460;\n  background-color: #bee5eb;\n}\n\n.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n  color: #0c5460;\n  background-color: #abdde5;\n}\n\n.list-group-item-info.list-group-item-action.active {\n  color: #fff;\n  background-color: #0c5460;\n  border-color: #0c5460;\n}\n\n.list-group-item-warning {\n  color: #856404;\n  background-color: #ffeeba;\n}\n\n.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n  color: #856404;\n  background-color: #ffe8a1;\n}\n\n.list-group-item-warning.list-group-item-action.active {\n  color: #fff;\n  background-color: #856404;\n  border-color: #856404;\n}\n\n.list-group-item-danger {\n  color: #721c24;\n  background-color: #f5c6cb;\n}\n\n.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n  color: #721c24;\n  background-color: #f1b0b7;\n}\n\n.list-group-item-danger.list-group-item-action.active {\n  color: #fff;\n  background-color: #721c24;\n  border-color: #721c24;\n}\n\n.list-group-item-light {\n  color: #818182;\n  background-color: #fdfdfe;\n}\n\n.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n  color: #818182;\n  background-color: #ececf6;\n}\n\n.list-group-item-light.list-group-item-action.active {\n  color: #fff;\n  background-color: #818182;\n  border-color: #818182;\n}\n\n.list-group-item-dark {\n  color: #1b1e21;\n  background-color: #c6c8ca;\n}\n\n.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n  color: #1b1e21;\n  background-color: #b9bbbe;\n}\n\n.list-group-item-dark.list-group-item-action.active {\n  color: #fff;\n  background-color: #1b1e21;\n  border-color: #1b1e21;\n}\n\n.close {\n  float: right;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: .5;\n}\n\n.close:hover {\n  color: #000;\n  text-decoration: none;\n}\n\n.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {\n  opacity: .75;\n}\n\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\na.close.disabled {\n  pointer-events: none;\n}\n\n.toast {\n  -ms-flex-preferred-size: 350px;\n  flex-basis: 350px;\n  max-width: 350px;\n  font-size: 0.875rem;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);\n  opacity: 0;\n  border-radius: 0.25rem;\n}\n\n.toast:not(:last-child) {\n  margin-bottom: 0.75rem;\n}\n\n.toast.showing {\n  opacity: 1;\n}\n\n.toast.show {\n  display: block;\n  opacity: 1;\n}\n\n.toast.hide {\n  display: none;\n}\n\n.toast-header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: 0.25rem 0.75rem;\n  color: #6c757d;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.toast-body {\n  padding: 0.75rem;\n}\n\n.modal-open {\n  overflow: hidden;\n}\n\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none;\n}\n\n.modal.fade .modal-dialog {\n  transition: -webkit-transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n  transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;\n  -webkit-transform: translate(0, -50px);\n  transform: translate(0, -50px);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n\n.modal.show .modal-dialog {\n  -webkit-transform: none;\n  transform: none;\n}\n\n.modal.modal-static .modal-dialog {\n  -webkit-transform: scale(1.02);\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  display: -ms-flexbox;\n  display: flex;\n  max-height: calc(100% - 1rem);\n}\n\n.modal-dialog-scrollable .modal-content {\n  max-height: calc(100vh - 1rem);\n  overflow: hidden;\n}\n\n.modal-dialog-scrollable .modal-header,\n.modal-dialog-scrollable .modal-footer {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  min-height: calc(100% - 1rem);\n}\n\n.modal-dialog-centered::before {\n  display: block;\n  height: calc(100vh - 1rem);\n  height: -webkit-min-content;\n  height: -moz-min-content;\n  height: min-content;\n  content: \"\";\n}\n\n.modal-dialog-centered.modal-dialog-scrollable {\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -ms-flex-pack: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.modal-dialog-centered.modal-dialog-scrollable .modal-content {\n  max-height: none;\n}\n\n.modal-dialog-centered.modal-dialog-scrollable::before {\n  content: none;\n}\n\n.modal-content {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n\n.modal-backdrop.fade {\n  opacity: 0;\n}\n\n.modal-backdrop.show {\n  opacity: 0.5;\n}\n\n.modal-header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n  border-bottom: 1px solid #dee2e6;\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px);\n}\n\n.modal-header .close {\n  padding: 1rem 1rem;\n  margin: -1rem -1rem -1rem auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.modal-body {\n  position: relative;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  padding: 1rem;\n}\n\n.modal-footer {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  padding: 0.75rem;\n  border-top: 1px solid #dee2e6;\n  border-bottom-right-radius: calc(0.3rem - 1px);\n  border-bottom-left-radius: calc(0.3rem - 1px);\n}\n\n.modal-footer > * {\n  margin: 0.25rem;\n}\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto;\n  }\n  .modal-dialog-scrollable {\n    max-height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-scrollable .modal-content {\n    max-height: calc(100vh - 3.5rem);\n  }\n  .modal-dialog-centered {\n    min-height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-centered::before {\n    height: calc(100vh - 3.5rem);\n    height: -webkit-min-content;\n    height: -moz-min-content;\n    height: min-content;\n  }\n  .modal-sm {\n    max-width: 300px;\n  }\n}\n\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    max-width: 800px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .modal-xl {\n    max-width: 1140px;\n  }\n}\n\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n\n.tooltip.show {\n  opacity: 0.9;\n}\n\n.tooltip .arrow {\n  position: absolute;\n  display: block;\n  width: 0.8rem;\n  height: 0.4rem;\n}\n\n.tooltip .arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top, .bs-tooltip-auto[x-placement^=\"top\"] {\n  padding: 0.4rem 0;\n}\n\n.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=\"top\"] .arrow {\n  bottom: 0;\n}\n\n.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=\"top\"] .arrow::before {\n  top: 0;\n  border-width: 0.4rem 0.4rem 0;\n  border-top-color: #000;\n}\n\n.bs-tooltip-right, .bs-tooltip-auto[x-placement^=\"right\"] {\n  padding: 0 0.4rem;\n}\n\n.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=\"right\"] .arrow {\n  left: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n\n.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=\"right\"] .arrow::before {\n  right: 0;\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #000;\n}\n\n.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=\"bottom\"] {\n  padding: 0.4rem 0;\n}\n\n.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow {\n  top: 0;\n}\n\n.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before {\n  bottom: 0;\n  border-width: 0 0.4rem 0.4rem;\n  border-bottom-color: #000;\n}\n\n.bs-tooltip-left, .bs-tooltip-auto[x-placement^=\"left\"] {\n  padding: 0 0.4rem;\n}\n\n.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=\"left\"] .arrow {\n  right: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n\n.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=\"left\"] .arrow::before {\n  left: 0;\n  border-width: 0.4rem 0 0.4rem 0.4rem;\n  border-left-color: #000;\n}\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 0.25rem;\n}\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 276px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n}\n\n.popover .arrow {\n  position: absolute;\n  display: block;\n  width: 1rem;\n  height: 0.5rem;\n  margin: 0 0.3rem;\n}\n\n.popover .arrow::before, .popover .arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-popover-top, .bs-popover-auto[x-placement^=\"top\"] {\n  margin-bottom: 0.5rem;\n}\n\n.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=\"top\"] > .arrow {\n  bottom: calc(-0.5rem - 1px);\n}\n\n.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=\"top\"] > .arrow::before {\n  bottom: 0;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=\"top\"] > .arrow::after {\n  bottom: 1px;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: #fff;\n}\n\n.bs-popover-right, .bs-popover-auto[x-placement^=\"right\"] {\n  margin-left: 0.5rem;\n}\n\n.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=\"right\"] > .arrow {\n  left: calc(-0.5rem - 1px);\n  width: 0.5rem;\n  height: 1rem;\n  margin: 0.3rem 0;\n}\n\n.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=\"right\"] > .arrow::before {\n  left: 0;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=\"right\"] > .arrow::after {\n  left: 1px;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: #fff;\n}\n\n.bs-popover-bottom, .bs-popover-auto[x-placement^=\"bottom\"] {\n  margin-top: 0.5rem;\n}\n\n.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=\"bottom\"] > .arrow {\n  top: calc(-0.5rem - 1px);\n}\n\n.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=\"bottom\"] > .arrow::before {\n  top: 0;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=\"bottom\"] > .arrow::after {\n  top: 1px;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: #fff;\n}\n\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: 1rem;\n  margin-left: -0.5rem;\n  content: \"\";\n  border-bottom: 1px solid #f7f7f7;\n}\n\n.bs-popover-left, .bs-popover-auto[x-placement^=\"left\"] {\n  margin-right: 0.5rem;\n}\n\n.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=\"left\"] > .arrow {\n  right: calc(-0.5rem - 1px);\n  width: 0.5rem;\n  height: 1rem;\n  margin: 0.3rem 0;\n}\n\n.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=\"left\"] > .arrow::before {\n  right: 0;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=\"left\"] > .arrow::after {\n  right: 1px;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: #fff;\n}\n\n.popover-header {\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px);\n}\n\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: 0.5rem 0.75rem;\n  color: #212529;\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  transition: -webkit-transform 0.6s ease-in-out;\n  transition: transform 0.6s ease-in-out;\n  transition: transform 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  -webkit-transform: translateX(-100%);\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  -webkit-transform: none;\n  transform: none;\n}\n\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-left,\n.carousel-fade .carousel-item-prev.carousel-item-right {\n  z-index: 1;\n  opacity: 1;\n}\n\n.carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-right {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-left,\n  .carousel-fade .active.carousel-item-right {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #fff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: 50% / 100% 100% no-repeat;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n  justify-content: center;\n  padding-left: 0;\n  margin-right: 15%;\n  margin-left: 15%;\n  list-style: none;\n}\n\n.carousel-indicators li {\n  box-sizing: content-box;\n  -ms-flex: 0 1 auto;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: .5;\n  transition: opacity 0.6s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators li {\n    transition: none;\n  }\n}\n\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n}\n\n@-webkit-keyframes spinner-border {\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes spinner-border {\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: -0.125em;\n  border: 0.25em solid currentcolor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  -webkit-animation: .75s linear infinite spinner-border;\n  animation: .75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  border-width: 0.2em;\n}\n\n@-webkit-keyframes spinner-grow {\n  0% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes spinner-grow {\n  0% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: -0.125em;\n  background-color: currentcolor;\n  border-radius: 50%;\n  opacity: 0;\n  -webkit-animation: .75s linear infinite spinner-grow;\n  animation: .75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: 1rem;\n  height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    -webkit-animation-duration: 1.5s;\n    animation-duration: 1.5s;\n  }\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.bg-primary {\n  background-color: #007bff !important;\n}\n\na.bg-primary:hover, a.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n  background-color: #0062cc !important;\n}\n\n.bg-secondary {\n  background-color: #6c757d !important;\n}\n\na.bg-secondary:hover, a.bg-secondary:focus,\nbutton.bg-secondary:hover,\nbutton.bg-secondary:focus {\n  background-color: #545b62 !important;\n}\n\n.bg-success {\n  background-color: #28a745 !important;\n}\n\na.bg-success:hover, a.bg-success:focus,\nbutton.bg-success:hover,\nbutton.bg-success:focus {\n  background-color: #1e7e34 !important;\n}\n\n.bg-info {\n  background-color: #17a2b8 !important;\n}\n\na.bg-info:hover, a.bg-info:focus,\nbutton.bg-info:hover,\nbutton.bg-info:focus {\n  background-color: #117a8b !important;\n}\n\n.bg-warning {\n  background-color: #ffc107 !important;\n}\n\na.bg-warning:hover, a.bg-warning:focus,\nbutton.bg-warning:hover,\nbutton.bg-warning:focus {\n  background-color: #d39e00 !important;\n}\n\n.bg-danger {\n  background-color: #dc3545 !important;\n}\n\na.bg-danger:hover, a.bg-danger:focus,\nbutton.bg-danger:hover,\nbutton.bg-danger:focus {\n  background-color: #bd2130 !important;\n}\n\n.bg-light {\n  background-color: #f8f9fa !important;\n}\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  background-color: #dae0e5 !important;\n}\n\n.bg-dark {\n  background-color: #343a40 !important;\n}\n\na.bg-dark:hover, a.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-dark:focus {\n  background-color: #1d2124 !important;\n}\n\n.bg-white {\n  background-color: #fff !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.border {\n  border: 1px solid #dee2e6 !important;\n}\n\n.border-top {\n  border-top: 1px solid #dee2e6 !important;\n}\n\n.border-right {\n  border-right: 1px solid #dee2e6 !important;\n}\n\n.border-bottom {\n  border-bottom: 1px solid #dee2e6 !important;\n}\n\n.border-left {\n  border-left: 1px solid #dee2e6 !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-right-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-left-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  border-color: #007bff !important;\n}\n\n.border-secondary {\n  border-color: #6c757d !important;\n}\n\n.border-success {\n  border-color: #28a745 !important;\n}\n\n.border-info {\n  border-color: #17a2b8 !important;\n}\n\n.border-warning {\n  border-color: #ffc107 !important;\n}\n\n.border-danger {\n  border-color: #dc3545 !important;\n}\n\n.border-light {\n  border-color: #f8f9fa !important;\n}\n\n.border-dark {\n  border-color: #343a40 !important;\n}\n\n.border-white {\n  border-color: #fff !important;\n}\n\n.rounded-sm {\n  border-radius: 0.2rem !important;\n}\n\n.rounded {\n  border-radius: 0.25rem !important;\n}\n\n.rounded-top {\n  border-top-left-radius: 0.25rem !important;\n  border-top-right-radius: 0.25rem !important;\n}\n\n.rounded-right {\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important;\n}\n\n.rounded-left {\n  border-top-left-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important;\n}\n\n.rounded-lg {\n  border-radius: 0.3rem !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: 50rem !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.d-none {\n  display: none !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: -ms-inline-flexbox !important;\n  display: inline-flex !important;\n}\n\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n}\n\n@media print {\n  .d-print-none {\n    display: none !important;\n  }\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n}\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n\n.embed-responsive::before {\n  display: block;\n  content: \"\";\n}\n\n.embed-responsive .embed-responsive-item,\n.embed-responsive iframe,\n.embed-responsive embed,\n.embed-responsive object,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.embed-responsive-21by9::before {\n  padding-top: 42.857143%;\n}\n\n.embed-responsive-16by9::before {\n  padding-top: 56.25%;\n}\n\n.embed-responsive-4by3::before {\n  padding-top: 75%;\n}\n\n.embed-responsive-1by1::before {\n  padding-top: 100%;\n}\n\n.flex-row {\n  -ms-flex-direction: row !important;\n  flex-direction: row !important;\n}\n\n.flex-column {\n  -ms-flex-direction: column !important;\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  -ms-flex-direction: row-reverse !important;\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  -ms-flex-direction: column-reverse !important;\n  flex-direction: column-reverse !important;\n}\n\n.flex-wrap {\n  -ms-flex-wrap: wrap !important;\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  -ms-flex-wrap: nowrap !important;\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  -ms-flex-wrap: wrap-reverse !important;\n  flex-wrap: wrap-reverse !important;\n}\n\n.flex-fill {\n  -ms-flex: 1 1 auto !important;\n  flex: 1 1 auto !important;\n}\n\n.flex-grow-0 {\n  -ms-flex-positive: 0 !important;\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  -ms-flex-positive: 1 !important;\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  -ms-flex-negative: 0 !important;\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  -ms-flex-negative: 1 !important;\n  flex-shrink: 1 !important;\n}\n\n.justify-content-start {\n  -ms-flex-pack: start !important;\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  -ms-flex-pack: end !important;\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  -ms-flex-pack: center !important;\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  -ms-flex-pack: justify !important;\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  -ms-flex-pack: distribute !important;\n  justify-content: space-around !important;\n}\n\n.align-items-start {\n  -ms-flex-align: start !important;\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  -ms-flex-align: end !important;\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  -ms-flex-align: center !important;\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  -ms-flex-align: baseline !important;\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  -ms-flex-align: stretch !important;\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  -ms-flex-line-pack: start !important;\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  -ms-flex-line-pack: end !important;\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  -ms-flex-line-pack: center !important;\n  align-content: center !important;\n}\n\n.align-content-between {\n  -ms-flex-line-pack: justify !important;\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  -ms-flex-line-pack: distribute !important;\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  -ms-flex-line-pack: stretch !important;\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  -ms-flex-item-align: auto !important;\n  align-self: auto !important;\n}\n\n.align-self-start {\n  -ms-flex-item-align: start !important;\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  -ms-flex-item-align: end !important;\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  -ms-flex-item-align: center !important;\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  -ms-flex-item-align: baseline !important;\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  -ms-flex-item-align: stretch !important;\n  align-self: stretch !important;\n}\n\n@media (min-width: 576px) {\n  .flex-sm-row {\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    -ms-flex-direction: column !important;\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    -ms-flex-direction: row-reverse !important;\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    -ms-flex-direction: column-reverse !important;\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-wrap {\n    -ms-flex-wrap: wrap !important;\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    -ms-flex-wrap: nowrap !important;\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-sm-fill {\n    -ms-flex: 1 1 auto !important;\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-grow-0 {\n    -ms-flex-positive: 0 !important;\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    -ms-flex-positive: 1 !important;\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    -ms-flex-negative: 0 !important;\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    -ms-flex-negative: 1 !important;\n    flex-shrink: 1 !important;\n  }\n  .justify-content-sm-start {\n    -ms-flex-pack: start !important;\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    -ms-flex-pack: end !important;\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    -ms-flex-pack: center !important;\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    -ms-flex-pack: justify !important;\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    -ms-flex-pack: distribute !important;\n    justify-content: space-around !important;\n  }\n  .align-items-sm-start {\n    -ms-flex-align: start !important;\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    -ms-flex-align: end !important;\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    -ms-flex-align: center !important;\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    -ms-flex-align: baseline !important;\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    -ms-flex-align: stretch !important;\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    -ms-flex-line-pack: start !important;\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    -ms-flex-line-pack: end !important;\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    -ms-flex-line-pack: center !important;\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    -ms-flex-line-pack: justify !important;\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    -ms-flex-line-pack: distribute !important;\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    -ms-flex-line-pack: stretch !important;\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    -ms-flex-item-align: auto !important;\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    -ms-flex-item-align: start !important;\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    -ms-flex-item-align: end !important;\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    -ms-flex-item-align: center !important;\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    -ms-flex-item-align: baseline !important;\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    -ms-flex-item-align: stretch !important;\n    align-self: stretch !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .flex-md-row {\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    -ms-flex-direction: column !important;\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    -ms-flex-direction: row-reverse !important;\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    -ms-flex-direction: column-reverse !important;\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-wrap {\n    -ms-flex-wrap: wrap !important;\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    -ms-flex-wrap: nowrap !important;\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-md-fill {\n    -ms-flex: 1 1 auto !important;\n    flex: 1 1 auto !important;\n  }\n  .flex-md-grow-0 {\n    -ms-flex-positive: 0 !important;\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    -ms-flex-positive: 1 !important;\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    -ms-flex-negative: 0 !important;\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    -ms-flex-negative: 1 !important;\n    flex-shrink: 1 !important;\n  }\n  .justify-content-md-start {\n    -ms-flex-pack: start !important;\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    -ms-flex-pack: end !important;\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    -ms-flex-pack: center !important;\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    -ms-flex-pack: justify !important;\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    -ms-flex-pack: distribute !important;\n    justify-content: space-around !important;\n  }\n  .align-items-md-start {\n    -ms-flex-align: start !important;\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    -ms-flex-align: end !important;\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    -ms-flex-align: center !important;\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    -ms-flex-align: baseline !important;\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    -ms-flex-align: stretch !important;\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    -ms-flex-line-pack: start !important;\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    -ms-flex-line-pack: end !important;\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    -ms-flex-line-pack: center !important;\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    -ms-flex-line-pack: justify !important;\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    -ms-flex-line-pack: distribute !important;\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    -ms-flex-line-pack: stretch !important;\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    -ms-flex-item-align: auto !important;\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    -ms-flex-item-align: start !important;\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    -ms-flex-item-align: end !important;\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    -ms-flex-item-align: center !important;\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    -ms-flex-item-align: baseline !important;\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    -ms-flex-item-align: stretch !important;\n    align-self: stretch !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .flex-lg-row {\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    -ms-flex-direction: column !important;\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    -ms-flex-direction: row-reverse !important;\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    -ms-flex-direction: column-reverse !important;\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-wrap {\n    -ms-flex-wrap: wrap !important;\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    -ms-flex-wrap: nowrap !important;\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-lg-fill {\n    -ms-flex: 1 1 auto !important;\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-grow-0 {\n    -ms-flex-positive: 0 !important;\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    -ms-flex-positive: 1 !important;\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    -ms-flex-negative: 0 !important;\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    -ms-flex-negative: 1 !important;\n    flex-shrink: 1 !important;\n  }\n  .justify-content-lg-start {\n    -ms-flex-pack: start !important;\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    -ms-flex-pack: end !important;\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    -ms-flex-pack: center !important;\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    -ms-flex-pack: justify !important;\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    -ms-flex-pack: distribute !important;\n    justify-content: space-around !important;\n  }\n  .align-items-lg-start {\n    -ms-flex-align: start !important;\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    -ms-flex-align: end !important;\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    -ms-flex-align: center !important;\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    -ms-flex-align: baseline !important;\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    -ms-flex-align: stretch !important;\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    -ms-flex-line-pack: start !important;\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    -ms-flex-line-pack: end !important;\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    -ms-flex-line-pack: center !important;\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    -ms-flex-line-pack: justify !important;\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    -ms-flex-line-pack: distribute !important;\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    -ms-flex-line-pack: stretch !important;\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    -ms-flex-item-align: auto !important;\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    -ms-flex-item-align: start !important;\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    -ms-flex-item-align: end !important;\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    -ms-flex-item-align: center !important;\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    -ms-flex-item-align: baseline !important;\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    -ms-flex-item-align: stretch !important;\n    align-self: stretch !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    -ms-flex-direction: column !important;\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    -ms-flex-direction: row-reverse !important;\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    -ms-flex-direction: column-reverse !important;\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-wrap {\n    -ms-flex-wrap: wrap !important;\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    -ms-flex-wrap: nowrap !important;\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-xl-fill {\n    -ms-flex: 1 1 auto !important;\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-grow-0 {\n    -ms-flex-positive: 0 !important;\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    -ms-flex-positive: 1 !important;\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    -ms-flex-negative: 0 !important;\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    -ms-flex-negative: 1 !important;\n    flex-shrink: 1 !important;\n  }\n  .justify-content-xl-start {\n    -ms-flex-pack: start !important;\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    -ms-flex-pack: end !important;\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    -ms-flex-pack: center !important;\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    -ms-flex-pack: justify !important;\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    -ms-flex-pack: distribute !important;\n    justify-content: space-around !important;\n  }\n  .align-items-xl-start {\n    -ms-flex-align: start !important;\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    -ms-flex-align: end !important;\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    -ms-flex-align: center !important;\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    -ms-flex-align: baseline !important;\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    -ms-flex-align: stretch !important;\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    -ms-flex-line-pack: start !important;\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    -ms-flex-line-pack: end !important;\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    -ms-flex-line-pack: center !important;\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    -ms-flex-line-pack: justify !important;\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    -ms-flex-line-pack: distribute !important;\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    -ms-flex-line-pack: stretch !important;\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    -ms-flex-item-align: auto !important;\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    -ms-flex-item-align: start !important;\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    -ms-flex-item-align: end !important;\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    -ms-flex-item-align: center !important;\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    -ms-flex-item-align: baseline !important;\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    -ms-flex-item-align: stretch !important;\n    align-self: stretch !important;\n  }\n}\n\n.float-left {\n  float: left !important;\n}\n\n.float-right {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-left {\n    float: left !important;\n  }\n  .float-sm-right {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .float-md-left {\n    float: left !important;\n  }\n  .float-md-right {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .float-lg-left {\n    float: left !important;\n  }\n  .float-lg-right {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .float-xl-left {\n    float: left !important;\n  }\n  .float-xl-right {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n}\n\n.user-select-all {\n  -webkit-user-select: all !important;\n  -moz-user-select: all !important;\n  user-select: all !important;\n}\n\n.user-select-auto {\n  -webkit-user-select: auto !important;\n  -moz-user-select: auto !important;\n  -ms-user-select: auto !important;\n  user-select: auto !important;\n}\n\n.user-select-none {\n  -webkit-user-select: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n  user-select: none !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: -webkit-sticky !important;\n  position: sticky !important;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n@supports ((position: -webkit-sticky) or (position: sticky)) {\n  .sticky-top {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n\n.shadow-sm {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n\n.shadow {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important;\n}\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important;\n}\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important;\n}\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important;\n}\n\n.mb-1,\n.my-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.ml-1,\n.mx-1 {\n  margin-left: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.mt-2,\n.my-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mr-2,\n.mx-2 {\n  margin-right: 0.5rem !important;\n}\n\n.mb-2,\n.my-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.ml-2,\n.mx-2 {\n  margin-left: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.mt-3,\n.my-3 {\n  margin-top: 1rem !important;\n}\n\n.mr-3,\n.mx-3 {\n  margin-right: 1rem !important;\n}\n\n.mb-3,\n.my-3 {\n  margin-bottom: 1rem !important;\n}\n\n.ml-3,\n.mx-3 {\n  margin-left: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.mt-4,\n.my-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mr-4,\n.mx-4 {\n  margin-right: 1.5rem !important;\n}\n\n.mb-4,\n.my-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.ml-4,\n.mx-4 {\n  margin-left: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.mt-5,\n.my-5 {\n  margin-top: 3rem !important;\n}\n\n.mr-5,\n.mx-5 {\n  margin-right: 3rem !important;\n}\n\n.mb-5,\n.my-5 {\n  margin-bottom: 3rem !important;\n}\n\n.ml-5,\n.mx-5 {\n  margin-left: 3rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important;\n}\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important;\n}\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important;\n}\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.pt-1,\n.py-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pr-1,\n.px-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pb-1,\n.py-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pl-1,\n.px-1 {\n  padding-left: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.pt-2,\n.py-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pr-2,\n.px-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pb-2,\n.py-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pl-2,\n.px-2 {\n  padding-left: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.pt-3,\n.py-3 {\n  padding-top: 1rem !important;\n}\n\n.pr-3,\n.px-3 {\n  padding-right: 1rem !important;\n}\n\n.pb-3,\n.py-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pl-3,\n.px-3 {\n  padding-left: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.pt-4,\n.py-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pr-4,\n.px-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pb-4,\n.py-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pl-4,\n.px-4 {\n  padding-left: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.pt-5,\n.py-5 {\n  padding-top: 3rem !important;\n}\n\n.pr-5,\n.px-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-5,\n.py-5 {\n  padding-bottom: 3rem !important;\n}\n\n.pl-5,\n.px-5 {\n  padding-left: 3rem !important;\n}\n\n.m-n1 {\n  margin: -0.25rem !important;\n}\n\n.mt-n1,\n.my-n1 {\n  margin-top: -0.25rem !important;\n}\n\n.mr-n1,\n.mx-n1 {\n  margin-right: -0.25rem !important;\n}\n\n.mb-n1,\n.my-n1 {\n  margin-bottom: -0.25rem !important;\n}\n\n.ml-n1,\n.mx-n1 {\n  margin-left: -0.25rem !important;\n}\n\n.m-n2 {\n  margin: -0.5rem !important;\n}\n\n.mt-n2,\n.my-n2 {\n  margin-top: -0.5rem !important;\n}\n\n.mr-n2,\n.mx-n2 {\n  margin-right: -0.5rem !important;\n}\n\n.mb-n2,\n.my-n2 {\n  margin-bottom: -0.5rem !important;\n}\n\n.ml-n2,\n.mx-n2 {\n  margin-left: -0.5rem !important;\n}\n\n.m-n3 {\n  margin: -1rem !important;\n}\n\n.mt-n3,\n.my-n3 {\n  margin-top: -1rem !important;\n}\n\n.mr-n3,\n.mx-n3 {\n  margin-right: -1rem !important;\n}\n\n.mb-n3,\n.my-n3 {\n  margin-bottom: -1rem !important;\n}\n\n.ml-n3,\n.mx-n3 {\n  margin-left: -1rem !important;\n}\n\n.m-n4 {\n  margin: -1.5rem !important;\n}\n\n.mt-n4,\n.my-n4 {\n  margin-top: -1.5rem !important;\n}\n\n.mr-n4,\n.mx-n4 {\n  margin-right: -1.5rem !important;\n}\n\n.mb-n4,\n.my-n4 {\n  margin-bottom: -1.5rem !important;\n}\n\n.ml-n4,\n.mx-n4 {\n  margin-left: -1.5rem !important;\n}\n\n.m-n5 {\n  margin: -3rem !important;\n}\n\n.mt-n5,\n.my-n5 {\n  margin-top: -3rem !important;\n}\n\n.mr-n5,\n.mx-n5 {\n  margin-right: -3rem !important;\n}\n\n.mb-n5,\n.my-n5 {\n  margin-bottom: -3rem !important;\n}\n\n.ml-n5,\n.mx-n5 {\n  margin-left: -3rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important;\n}\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important;\n}\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important;\n}\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important;\n}\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important;\n  }\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .m-sm-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-sm-n1,\n  .my-sm-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-sm-n1,\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-sm-n1,\n  .my-sm-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-sm-n1,\n  .mx-sm-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-sm-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-sm-n2,\n  .my-sm-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-sm-n2,\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-sm-n2,\n  .my-sm-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-sm-n2,\n  .mx-sm-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-sm-n3 {\n    margin: -1rem !important;\n  }\n  .mt-sm-n3,\n  .my-sm-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-sm-n3,\n  .mx-sm-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-sm-n3,\n  .my-sm-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-sm-n3,\n  .mx-sm-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-sm-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-sm-n4,\n  .my-sm-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-sm-n4,\n  .mx-sm-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-sm-n4,\n  .my-sm-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-sm-n4,\n  .mx-sm-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-sm-n5 {\n    margin: -3rem !important;\n  }\n  .mt-sm-n5,\n  .my-sm-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-sm-n5,\n  .mx-sm-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-sm-n5,\n  .my-sm-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-sm-n5,\n  .mx-sm-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important;\n  }\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important;\n  }\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important;\n  }\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 3rem !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important;\n  }\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important;\n  }\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 3rem !important;\n  }\n  .m-md-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-md-n1,\n  .my-md-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-md-n1,\n  .mx-md-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-md-n1,\n  .my-md-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-md-n1,\n  .mx-md-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-md-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-md-n2,\n  .my-md-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-md-n2,\n  .mx-md-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-md-n2,\n  .my-md-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-md-n2,\n  .mx-md-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-md-n3 {\n    margin: -1rem !important;\n  }\n  .mt-md-n3,\n  .my-md-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-md-n3,\n  .mx-md-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-md-n3,\n  .my-md-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-md-n3,\n  .mx-md-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-md-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-md-n4,\n  .my-md-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-md-n4,\n  .mx-md-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-md-n4,\n  .my-md-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-md-n4,\n  .mx-md-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-md-n5 {\n    margin: -3rem !important;\n  }\n  .mt-md-n5,\n  .my-md-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-md-n5,\n  .mx-md-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-md-n5,\n  .my-md-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-md-n5,\n  .mx-md-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important;\n  }\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important;\n  }\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .m-lg-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-lg-n1,\n  .my-lg-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-lg-n1,\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-lg-n1,\n  .my-lg-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-lg-n1,\n  .mx-lg-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-lg-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-lg-n2,\n  .my-lg-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-lg-n2,\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-lg-n2,\n  .my-lg-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-lg-n2,\n  .mx-lg-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-lg-n3 {\n    margin: -1rem !important;\n  }\n  .mt-lg-n3,\n  .my-lg-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-lg-n3,\n  .mx-lg-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-lg-n3,\n  .my-lg-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-lg-n3,\n  .mx-lg-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-lg-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-lg-n4,\n  .my-lg-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-lg-n4,\n  .mx-lg-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-lg-n4,\n  .my-lg-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-lg-n4,\n  .mx-lg-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-lg-n5 {\n    margin: -3rem !important;\n  }\n  .mt-lg-n5,\n  .my-lg-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-lg-n5,\n  .mx-lg-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-lg-n5,\n  .my-lg-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-lg-n5,\n  .mx-lg-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important;\n  }\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important;\n  }\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .m-xl-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-xl-n1,\n  .my-xl-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-xl-n1,\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-xl-n1,\n  .my-xl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-xl-n1,\n  .mx-xl-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-xl-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-xl-n2,\n  .my-xl-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-xl-n2,\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-xl-n2,\n  .my-xl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-xl-n2,\n  .mx-xl-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-xl-n3 {\n    margin: -1rem !important;\n  }\n  .mt-xl-n3,\n  .my-xl-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-xl-n3,\n  .mx-xl-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-xl-n3,\n  .my-xl-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-xl-n3,\n  .mx-xl-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-xl-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-xl-n4,\n  .my-xl-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-xl-n4,\n  .mx-xl-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-xl-n4,\n  .my-xl-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-xl-n4,\n  .mx-xl-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-xl-n5 {\n    margin: -3rem !important;\n  }\n  .mt-xl-n5,\n  .my-xl-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-xl-n5,\n  .mx-xl-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-xl-n5,\n  .my-xl-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-xl-n5,\n  .mx-xl-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important;\n  }\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important;\n  }\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  pointer-events: auto;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.text-monospace {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important;\n}\n\n.text-justify {\n  text-align: justify !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-left {\n  text-align: left !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n@media (min-width: 576px) {\n  .text-sm-left {\n    text-align: left !important;\n  }\n  .text-sm-right {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .text-md-left {\n    text-align: left !important;\n  }\n  .text-md-right {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .text-lg-left {\n    text-align: left !important;\n  }\n  .text-lg-right {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .text-xl-left {\n    text-align: left !important;\n  }\n  .text-xl-right {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.font-weight-light {\n  font-weight: 300 !important;\n}\n\n.font-weight-lighter {\n  font-weight: lighter !important;\n}\n\n.font-weight-normal {\n  font-weight: 400 !important;\n}\n\n.font-weight-bold {\n  font-weight: 700 !important;\n}\n\n.font-weight-bolder {\n  font-weight: bolder !important;\n}\n\n.font-italic {\n  font-style: italic !important;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\n.text-primary {\n  color: #007bff !important;\n}\n\na.text-primary:hover, a.text-primary:focus {\n  color: #0056b3 !important;\n}\n\n.text-secondary {\n  color: #6c757d !important;\n}\n\na.text-secondary:hover, a.text-secondary:focus {\n  color: #494f54 !important;\n}\n\n.text-success {\n  color: #28a745 !important;\n}\n\na.text-success:hover, a.text-success:focus {\n  color: #19692c !important;\n}\n\n.text-info {\n  color: #17a2b8 !important;\n}\n\na.text-info:hover, a.text-info:focus {\n  color: #0f6674 !important;\n}\n\n.text-warning {\n  color: #ffc107 !important;\n}\n\na.text-warning:hover, a.text-warning:focus {\n  color: #ba8b00 !important;\n}\n\n.text-danger {\n  color: #dc3545 !important;\n}\n\na.text-danger:hover, a.text-danger:focus {\n  color: #a71d2a !important;\n}\n\n.text-light {\n  color: #f8f9fa !important;\n}\n\na.text-light:hover, a.text-light:focus {\n  color: #cbd3da !important;\n}\n\n.text-dark {\n  color: #343a40 !important;\n}\n\na.text-dark:hover, a.text-dark:focus {\n  color: #121416 !important;\n}\n\n.text-body {\n  color: #212529 !important;\n}\n\n.text-muted {\n  color: #6c757d !important;\n}\n\n.text-black-50 {\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-break {\n  word-break: break-word !important;\n  word-wrap: break-word !important;\n}\n\n.text-reset {\n  color: inherit !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n@media print {\n  *,\n  *::before,\n  *::after {\n    text-shadow: none !important;\n    box-shadow: none !important;\n  }\n  a:not(.btn) {\n    text-decoration: underline;\n  }\n  abbr[title]::after {\n    content: \" (\" attr(title) \")\";\n  }\n  pre {\n    white-space: pre-wrap !important;\n  }\n  pre,\n  blockquote {\n    border: 1px solid #adb5bd;\n    page-break-inside: avoid;\n  }\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n  @page {\n    size: a3;\n  }\n  body {\n    min-width: 992px !important;\n  }\n  .container {\n    min-width: 992px !important;\n  }\n  .navbar {\n    display: none;\n  }\n  .badge {\n    border: 1px solid #000;\n  }\n  .table {\n    border-collapse: collapse !important;\n  }\n  .table td,\n  .table th {\n    background-color: #fff !important;\n  }\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #dee2e6 !important;\n  }\n  .table-dark {\n    color: inherit;\n  }\n  .table-dark th,\n  .table-dark td,\n  .table-dark thead th,\n  .table-dark tbody + tbody {\n    border-color: #dee2e6;\n  }\n  .table .thead-dark th {\n    color: inherit;\n    border-color: #dee2e6;\n  }\n}", ""]);

// exports


/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2268);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("59ebc1b8", content, true, {});

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".select2-container{box-sizing:border-box;display:inline-block;margin:0;position:relative;vertical-align:middle}.select2-container .select2-selection--single{box-sizing:border-box;cursor:pointer;display:block;height:28px;user-select:none;-webkit-user-select:none}.select2-container .select2-selection--single .select2-selection__rendered{display:block;padding-left:8px;padding-right:20px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.select2-container .select2-selection--single .select2-selection__clear{position:relative}.select2-container[dir=\"rtl\"] .select2-selection--single .select2-selection__rendered{padding-right:8px;padding-left:20px}.select2-container .select2-selection--multiple{box-sizing:border-box;cursor:pointer;display:block;min-height:32px;user-select:none;-webkit-user-select:none}.select2-container .select2-selection--multiple .select2-selection__rendered{display:inline-block;overflow:hidden;padding-left:8px;text-overflow:ellipsis;white-space:nowrap}.select2-container .select2-search--inline{float:left}.select2-container .select2-search--inline .select2-search__field{box-sizing:border-box;border:none;font-size:100%;margin-top:5px;padding:0}.select2-container .select2-search--inline .select2-search__field::-webkit-search-cancel-button{-webkit-appearance:none}.select2-dropdown{background-color:white;border:1px solid #aaa;border-radius:4px;box-sizing:border-box;display:block;position:absolute;left:-100000px;width:100%;z-index:1051}.select2-results{display:block}.select2-results__options{list-style:none;margin:0;padding:0}.select2-results__option{padding:6px;user-select:none;-webkit-user-select:none}.select2-results__option[aria-selected]{cursor:pointer}.select2-container--open .select2-dropdown{left:0}.select2-container--open .select2-dropdown--above{border-bottom:none;border-bottom-left-radius:0;border-bottom-right-radius:0}.select2-container--open .select2-dropdown--below{border-top:none;border-top-left-radius:0;border-top-right-radius:0}.select2-search--dropdown{display:block;padding:4px}.select2-search--dropdown .select2-search__field{padding:4px;width:100%;box-sizing:border-box}.select2-search--dropdown .select2-search__field::-webkit-search-cancel-button{-webkit-appearance:none}.select2-search--dropdown.select2-search--hide{display:none}.select2-close-mask{border:0;margin:0;padding:0;display:block;position:fixed;left:0;top:0;min-height:100%;min-width:100%;height:auto;width:auto;opacity:0;z-index:99;background-color:#fff;filter:alpha(opacity=0)}.select2-hidden-accessible{border:0 !important;clip:rect(0 0 0 0) !important;-webkit-clip-path:inset(50%) !important;clip-path:inset(50%) !important;height:1px !important;overflow:hidden !important;padding:0 !important;position:absolute !important;width:1px !important;white-space:nowrap !important}.select2-container--default .select2-selection--single{background-color:#fff;border:1px solid #aaa;border-radius:4px}.select2-container--default .select2-selection--single .select2-selection__rendered{color:#444;line-height:28px}.select2-container--default .select2-selection--single .select2-selection__clear{cursor:pointer;float:right;font-weight:bold}.select2-container--default .select2-selection--single .select2-selection__placeholder{color:#999}.select2-container--default .select2-selection--single .select2-selection__arrow{height:26px;position:absolute;top:1px;right:1px;width:20px}.select2-container--default .select2-selection--single .select2-selection__arrow b{border-color:#888 transparent transparent transparent;border-style:solid;border-width:5px 4px 0 4px;height:0;left:50%;margin-left:-4px;margin-top:-2px;position:absolute;top:50%;width:0}.select2-container--default[dir=\"rtl\"] .select2-selection--single .select2-selection__clear{float:left}.select2-container--default[dir=\"rtl\"] .select2-selection--single .select2-selection__arrow{left:1px;right:auto}.select2-container--default.select2-container--disabled .select2-selection--single{background-color:#eee;cursor:default}.select2-container--default.select2-container--disabled .select2-selection--single .select2-selection__clear{display:none}.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b{border-color:transparent transparent #888 transparent;border-width:0 4px 5px 4px}.select2-container--default .select2-selection--multiple{background-color:white;border:1px solid #aaa;border-radius:4px;cursor:text}.select2-container--default .select2-selection--multiple .select2-selection__rendered{box-sizing:border-box;list-style:none;margin:0;padding:0 5px;width:100%}.select2-container--default .select2-selection--multiple .select2-selection__rendered li{list-style:none}.select2-container--default .select2-selection--multiple .select2-selection__clear{cursor:pointer;float:right;font-weight:bold;margin-top:5px;margin-right:10px;padding:1px}.select2-container--default .select2-selection--multiple .select2-selection__choice{background-color:#e4e4e4;border:1px solid #aaa;border-radius:4px;cursor:default;float:left;margin-right:5px;margin-top:5px;padding:0 5px}.select2-container--default .select2-selection--multiple .select2-selection__choice__remove{color:#999;cursor:pointer;display:inline-block;font-weight:bold;margin-right:2px}.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover{color:#333}.select2-container--default[dir=\"rtl\"] .select2-selection--multiple .select2-selection__choice,.select2-container--default[dir=\"rtl\"] .select2-selection--multiple .select2-search--inline{float:right}.select2-container--default[dir=\"rtl\"] .select2-selection--multiple .select2-selection__choice{margin-left:5px;margin-right:auto}.select2-container--default[dir=\"rtl\"] .select2-selection--multiple .select2-selection__choice__remove{margin-left:2px;margin-right:auto}.select2-container--default.select2-container--focus .select2-selection--multiple{border:solid black 1px;outline:0}.select2-container--default.select2-container--disabled .select2-selection--multiple{background-color:#eee;cursor:default}.select2-container--default.select2-container--disabled .select2-selection__choice__remove{display:none}.select2-container--default.select2-container--open.select2-container--above .select2-selection--single,.select2-container--default.select2-container--open.select2-container--above .select2-selection--multiple{border-top-left-radius:0;border-top-right-radius:0}.select2-container--default.select2-container--open.select2-container--below .select2-selection--single,.select2-container--default.select2-container--open.select2-container--below .select2-selection--multiple{border-bottom-left-radius:0;border-bottom-right-radius:0}.select2-container--default .select2-search--dropdown .select2-search__field{border:1px solid #aaa}.select2-container--default .select2-search--inline .select2-search__field{background:transparent;border:none;outline:0;box-shadow:none;-webkit-appearance:textfield}.select2-container--default .select2-results>.select2-results__options{max-height:200px;overflow-y:auto}.select2-container--default .select2-results__option[role=group]{padding:0}.select2-container--default .select2-results__option[aria-disabled=true]{color:#999}.select2-container--default .select2-results__option[aria-selected=true]{background-color:#ddd}.select2-container--default .select2-results__option .select2-results__option{padding-left:1em}.select2-container--default .select2-results__option .select2-results__option .select2-results__group{padding-left:0}.select2-container--default .select2-results__option .select2-results__option .select2-results__option{margin-left:-1em;padding-left:2em}.select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-2em;padding-left:3em}.select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-3em;padding-left:4em}.select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-4em;padding-left:5em}.select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-5em;padding-left:6em}.select2-container--default .select2-results__option--highlighted[aria-selected]{background-color:#5897fb;color:white}.select2-container--default .select2-results__group{cursor:default;display:block;padding:6px}.select2-container--classic .select2-selection--single{background-color:#f7f7f7;border:1px solid #aaa;border-radius:4px;outline:0;background-image:-webkit-linear-gradient(top, #fff 50%, #eee 100%);background-image:-o-linear-gradient(top, #fff 50%, #eee 100%);background-image:linear-gradient(to bottom, #fff 50%, #eee 100%);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#FFFFFFFF', endColorstr='#FFEEEEEE', GradientType=0)}.select2-container--classic .select2-selection--single:focus{border:1px solid #5897fb}.select2-container--classic .select2-selection--single .select2-selection__rendered{color:#444;line-height:28px}.select2-container--classic .select2-selection--single .select2-selection__clear{cursor:pointer;float:right;font-weight:bold;margin-right:10px}.select2-container--classic .select2-selection--single .select2-selection__placeholder{color:#999}.select2-container--classic .select2-selection--single .select2-selection__arrow{background-color:#ddd;border:none;border-left:1px solid #aaa;border-top-right-radius:4px;border-bottom-right-radius:4px;height:26px;position:absolute;top:1px;right:1px;width:20px;background-image:-webkit-linear-gradient(top, #eee 50%, #ccc 100%);background-image:-o-linear-gradient(top, #eee 50%, #ccc 100%);background-image:linear-gradient(to bottom, #eee 50%, #ccc 100%);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#FFEEEEEE', endColorstr='#FFCCCCCC', GradientType=0)}.select2-container--classic .select2-selection--single .select2-selection__arrow b{border-color:#888 transparent transparent transparent;border-style:solid;border-width:5px 4px 0 4px;height:0;left:50%;margin-left:-4px;margin-top:-2px;position:absolute;top:50%;width:0}.select2-container--classic[dir=\"rtl\"] .select2-selection--single .select2-selection__clear{float:left}.select2-container--classic[dir=\"rtl\"] .select2-selection--single .select2-selection__arrow{border:none;border-right:1px solid #aaa;border-radius:0;border-top-left-radius:4px;border-bottom-left-radius:4px;left:1px;right:auto}.select2-container--classic.select2-container--open .select2-selection--single{border:1px solid #5897fb}.select2-container--classic.select2-container--open .select2-selection--single .select2-selection__arrow{background:transparent;border:none}.select2-container--classic.select2-container--open .select2-selection--single .select2-selection__arrow b{border-color:transparent transparent #888 transparent;border-width:0 4px 5px 4px}.select2-container--classic.select2-container--open.select2-container--above .select2-selection--single{border-top:none;border-top-left-radius:0;border-top-right-radius:0;background-image:-webkit-linear-gradient(top, #fff 0%, #eee 50%);background-image:-o-linear-gradient(top, #fff 0%, #eee 50%);background-image:linear-gradient(to bottom, #fff 0%, #eee 50%);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#FFFFFFFF', endColorstr='#FFEEEEEE', GradientType=0)}.select2-container--classic.select2-container--open.select2-container--below .select2-selection--single{border-bottom:none;border-bottom-left-radius:0;border-bottom-right-radius:0;background-image:-webkit-linear-gradient(top, #eee 50%, #fff 100%);background-image:-o-linear-gradient(top, #eee 50%, #fff 100%);background-image:linear-gradient(to bottom, #eee 50%, #fff 100%);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#FFEEEEEE', endColorstr='#FFFFFFFF', GradientType=0)}.select2-container--classic .select2-selection--multiple{background-color:white;border:1px solid #aaa;border-radius:4px;cursor:text;outline:0}.select2-container--classic .select2-selection--multiple:focus{border:1px solid #5897fb}.select2-container--classic .select2-selection--multiple .select2-selection__rendered{list-style:none;margin:0;padding:0 5px}.select2-container--classic .select2-selection--multiple .select2-selection__clear{display:none}.select2-container--classic .select2-selection--multiple .select2-selection__choice{background-color:#e4e4e4;border:1px solid #aaa;border-radius:4px;cursor:default;float:left;margin-right:5px;margin-top:5px;padding:0 5px}.select2-container--classic .select2-selection--multiple .select2-selection__choice__remove{color:#888;cursor:pointer;display:inline-block;font-weight:bold;margin-right:2px}.select2-container--classic .select2-selection--multiple .select2-selection__choice__remove:hover{color:#555}.select2-container--classic[dir=\"rtl\"] .select2-selection--multiple .select2-selection__choice{float:right;margin-left:5px;margin-right:auto}.select2-container--classic[dir=\"rtl\"] .select2-selection--multiple .select2-selection__choice__remove{margin-left:2px;margin-right:auto}.select2-container--classic.select2-container--open .select2-selection--multiple{border:1px solid #5897fb}.select2-container--classic.select2-container--open.select2-container--above .select2-selection--multiple{border-top:none;border-top-left-radius:0;border-top-right-radius:0}.select2-container--classic.select2-container--open.select2-container--below .select2-selection--multiple{border-bottom:none;border-bottom-left-radius:0;border-bottom-right-radius:0}.select2-container--classic .select2-search--dropdown .select2-search__field{border:1px solid #aaa;outline:0}.select2-container--classic .select2-search--inline .select2-search__field{outline:0;box-shadow:none}.select2-container--classic .select2-dropdown{background-color:#fff;border:1px solid transparent}.select2-container--classic .select2-dropdown--above{border-bottom:none}.select2-container--classic .select2-dropdown--below{border-top:none}.select2-container--classic .select2-results>.select2-results__options{max-height:200px;overflow-y:auto}.select2-container--classic .select2-results__option[role=group]{padding:0}.select2-container--classic .select2-results__option[aria-disabled=true]{color:grey}.select2-container--classic .select2-results__option--highlighted[aria-selected]{background-color:#3875d7;color:#fff}.select2-container--classic .select2-results__group{cursor:default;display:block;padding:6px}.select2-container--classic.select2-container--open .select2-dropdown{border-color:#5897fb}\n", ""]);

// exports


/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2270);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("051eac00", content, true, {});

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "/*!\n * Select2 Bootstrap Theme v0.1.0-beta.10 (https://select2.github.io/select2-bootstrap-theme)\n * Copyright 2015-2017 Florian Kissling and contributors (https://github.com/select2/select2-bootstrap-theme/graphs/contributors)\n * Licensed under MIT (https://github.com/select2/select2-bootstrap-theme/blob/master/LICENSE)\n */\n\n.select2-container--bootstrap{display:block}.select2-container--bootstrap .select2-selection{-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);background-color:#fff;border:1px solid #ccc;border-radius:4px;color:#555;font-size:14px;outline:0}.select2-container--bootstrap .select2-selection.form-control{border-radius:4px}.select2-container--bootstrap .select2-search--dropdown .select2-search__field{-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);background-color:#fff;border:1px solid #ccc;border-radius:4px;color:#555;font-size:14px}.select2-container--bootstrap .select2-search__field{outline:0}.select2-container--bootstrap .select2-search__field::-webkit-input-placeholder{color:#999}.select2-container--bootstrap .select2-search__field:-moz-placeholder{color:#999}.select2-container--bootstrap .select2-search__field::-moz-placeholder{color:#999;opacity:1}.select2-container--bootstrap .select2-search__field:-ms-input-placeholder{color:#999}.select2-container--bootstrap .select2-results__option{padding:6px 12px}.select2-container--bootstrap .select2-results__option[role=group]{padding:0}.select2-container--bootstrap .select2-results__option[aria-disabled=true]{color:#777;cursor:not-allowed}.select2-container--bootstrap .select2-results__option[aria-selected=true]{background-color:#f5f5f5;color:#262626}.select2-container--bootstrap .select2-results__option--highlighted[aria-selected]{background-color:#337ab7;color:#fff}.select2-container--bootstrap .select2-results__option .select2-results__option{padding:6px 12px}.select2-container--bootstrap .select2-results__option .select2-results__option .select2-results__group{padding-left:0}.select2-container--bootstrap .select2-results__option .select2-results__option .select2-results__option{margin-left:-12px;padding-left:24px}.select2-container--bootstrap .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-24px;padding-left:36px}.select2-container--bootstrap .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-36px;padding-left:48px}.select2-container--bootstrap .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-48px;padding-left:60px}.select2-container--bootstrap .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-60px;padding-left:72px}.select2-container--bootstrap .select2-results__group{color:#777;display:block;padding:6px 12px;font-size:12px;line-height:1.42857143;white-space:nowrap}.select2-container--bootstrap.select2-container--focus .select2-selection,.select2-container--bootstrap.select2-container--open .select2-selection{-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;-webkit-transition:border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;transition:border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;border-color:#66afe9}.select2-container--bootstrap.select2-container--open .select2-selection .select2-selection__arrow b{border-color:transparent transparent #999;border-width:0 4px 4px}.select2-container--bootstrap.select2-container--open.select2-container--below .select2-selection{border-bottom-right-radius:0;border-bottom-left-radius:0;border-bottom-color:transparent}.select2-container--bootstrap.select2-container--open.select2-container--above .select2-selection{border-top-right-radius:0;border-top-left-radius:0;border-top-color:transparent}.select2-container--bootstrap .select2-selection__clear{color:#999;cursor:pointer;float:right;font-weight:700;margin-right:10px}.select2-container--bootstrap .select2-selection__clear:hover{color:#333}.select2-container--bootstrap.select2-container--disabled .select2-selection{border-color:#ccc;-webkit-box-shadow:none;box-shadow:none}.select2-container--bootstrap.select2-container--disabled .select2-search__field,.select2-container--bootstrap.select2-container--disabled .select2-selection{cursor:not-allowed}.select2-container--bootstrap.select2-container--disabled .select2-selection,.select2-container--bootstrap.select2-container--disabled .select2-selection--multiple .select2-selection__choice{background-color:#eee}.select2-container--bootstrap.select2-container--disabled .select2-selection--multiple .select2-selection__choice__remove,.select2-container--bootstrap.select2-container--disabled .select2-selection__clear{display:none}.select2-container--bootstrap .select2-dropdown{-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175);border-color:#66afe9;overflow-x:hidden;margin-top:-1px}.select2-container--bootstrap .select2-dropdown--above{-webkit-box-shadow:0 -6px 12px rgba(0,0,0,.175);box-shadow:0 -6px 12px rgba(0,0,0,.175);margin-top:1px}.select2-container--bootstrap .select2-results>.select2-results__options{max-height:200px;overflow-y:auto}.select2-container--bootstrap .select2-selection--single{height:34px;line-height:1.42857143;padding:6px 24px 6px 12px}.select2-container--bootstrap .select2-selection--single .select2-selection__arrow{position:absolute;bottom:0;right:12px;top:0;width:4px}.select2-container--bootstrap .select2-selection--single .select2-selection__arrow b{border-color:#999 transparent transparent;border-style:solid;border-width:4px 4px 0;height:0;left:0;margin-left:-4px;margin-top:-2px;position:absolute;top:50%;width:0}.select2-container--bootstrap .select2-selection--single .select2-selection__rendered{color:#555;padding:0}.select2-container--bootstrap .select2-selection--single .select2-selection__placeholder{color:#999}.select2-container--bootstrap .select2-selection--multiple{min-height:34px;padding:0;height:auto}.select2-container--bootstrap .select2-selection--multiple .select2-selection__rendered{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;line-height:1.42857143;list-style:none;margin:0;overflow:hidden;padding:0;width:100%;text-overflow:ellipsis;white-space:nowrap}.select2-container--bootstrap .select2-selection--multiple .select2-selection__placeholder{color:#999;float:left;margin-top:5px}.select2-container--bootstrap .select2-selection--multiple .select2-selection__choice{color:#555;background:#fff;border:1px solid #ccc;border-radius:4px;cursor:default;float:left;margin:5px 0 0 6px;padding:0 6px}.select2-container--bootstrap .select2-selection--multiple .select2-search--inline .select2-search__field{background:0 0;padding:0 12px;height:32px;line-height:1.42857143;margin-top:0;min-width:5em}.select2-container--bootstrap .select2-selection--multiple .select2-selection__choice__remove{color:#999;cursor:pointer;display:inline-block;font-weight:700;margin-right:3px}.select2-container--bootstrap .select2-selection--multiple .select2-selection__choice__remove:hover{color:#333}.select2-container--bootstrap .select2-selection--multiple .select2-selection__clear{margin-top:6px}.form-group-sm .select2-container--bootstrap .select2-selection--single,.input-group-sm .select2-container--bootstrap .select2-selection--single,.select2-container--bootstrap .select2-selection--single.input-sm{border-radius:3px;font-size:12px;height:30px;line-height:1.5;padding:5px 22px 5px 10px}.form-group-sm .select2-container--bootstrap .select2-selection--single .select2-selection__arrow b,.input-group-sm .select2-container--bootstrap .select2-selection--single .select2-selection__arrow b,.select2-container--bootstrap .select2-selection--single.input-sm .select2-selection__arrow b{margin-left:-5px}.form-group-sm .select2-container--bootstrap .select2-selection--multiple,.input-group-sm .select2-container--bootstrap .select2-selection--multiple,.select2-container--bootstrap .select2-selection--multiple.input-sm{min-height:30px;border-radius:3px}.form-group-sm .select2-container--bootstrap .select2-selection--multiple .select2-selection__choice,.input-group-sm .select2-container--bootstrap .select2-selection--multiple .select2-selection__choice,.select2-container--bootstrap .select2-selection--multiple.input-sm .select2-selection__choice{font-size:12px;line-height:1.5;margin:4px 0 0 5px;padding:0 5px}.form-group-sm .select2-container--bootstrap .select2-selection--multiple .select2-search--inline .select2-search__field,.input-group-sm .select2-container--bootstrap .select2-selection--multiple .select2-search--inline .select2-search__field,.select2-container--bootstrap .select2-selection--multiple.input-sm .select2-search--inline .select2-search__field{padding:0 10px;font-size:12px;height:28px;line-height:1.5}.form-group-sm .select2-container--bootstrap .select2-selection--multiple .select2-selection__clear,.input-group-sm .select2-container--bootstrap .select2-selection--multiple .select2-selection__clear,.select2-container--bootstrap .select2-selection--multiple.input-sm .select2-selection__clear{margin-top:5px}.form-group-lg .select2-container--bootstrap .select2-selection--single,.input-group-lg .select2-container--bootstrap .select2-selection--single,.select2-container--bootstrap .select2-selection--single.input-lg{border-radius:6px;font-size:18px;height:46px;line-height:1.3333333;padding:10px 31px 10px 16px}.form-group-lg .select2-container--bootstrap .select2-selection--single .select2-selection__arrow,.input-group-lg .select2-container--bootstrap .select2-selection--single .select2-selection__arrow,.select2-container--bootstrap .select2-selection--single.input-lg .select2-selection__arrow{width:5px}.form-group-lg .select2-container--bootstrap .select2-selection--single .select2-selection__arrow b,.input-group-lg .select2-container--bootstrap .select2-selection--single .select2-selection__arrow b,.select2-container--bootstrap .select2-selection--single.input-lg .select2-selection__arrow b{border-width:5px 5px 0;margin-left:-10px;margin-top:-2.5px}.form-group-lg .select2-container--bootstrap .select2-selection--multiple,.input-group-lg .select2-container--bootstrap .select2-selection--multiple,.select2-container--bootstrap .select2-selection--multiple.input-lg{min-height:46px;border-radius:6px}.form-group-lg .select2-container--bootstrap .select2-selection--multiple .select2-selection__choice,.input-group-lg .select2-container--bootstrap .select2-selection--multiple .select2-selection__choice,.select2-container--bootstrap .select2-selection--multiple.input-lg .select2-selection__choice{font-size:18px;line-height:1.3333333;border-radius:4px;margin:9px 0 0 8px;padding:0 10px}.form-group-lg .select2-container--bootstrap .select2-selection--multiple .select2-search--inline .select2-search__field,.input-group-lg .select2-container--bootstrap .select2-selection--multiple .select2-search--inline .select2-search__field,.select2-container--bootstrap .select2-selection--multiple.input-lg .select2-search--inline .select2-search__field{padding:0 16px;font-size:18px;height:44px;line-height:1.3333333}.form-group-lg .select2-container--bootstrap .select2-selection--multiple .select2-selection__clear,.input-group-lg .select2-container--bootstrap .select2-selection--multiple .select2-selection__clear,.select2-container--bootstrap .select2-selection--multiple.input-lg .select2-selection__clear{margin-top:10px}.input-group-lg .select2-container--bootstrap .select2-selection.select2-container--open .select2-selection--single .select2-selection__arrow b,.select2-container--bootstrap .select2-selection.input-lg.select2-container--open .select2-selection--single .select2-selection__arrow b{border-color:transparent transparent #999;border-width:0 5px 5px}.select2-container--bootstrap[dir=rtl] .select2-selection--single{padding-left:24px;padding-right:12px}.select2-container--bootstrap[dir=rtl] .select2-selection--single .select2-selection__rendered{padding-right:0;padding-left:0;text-align:right}.select2-container--bootstrap[dir=rtl] .select2-selection--single .select2-selection__clear{float:left}.select2-container--bootstrap[dir=rtl] .select2-selection--single .select2-selection__arrow{left:12px;right:auto}.select2-container--bootstrap[dir=rtl] .select2-selection--single .select2-selection__arrow b{margin-left:0}.select2-container--bootstrap[dir=rtl] .select2-selection--multiple .select2-search--inline,.select2-container--bootstrap[dir=rtl] .select2-selection--multiple .select2-selection__choice,.select2-container--bootstrap[dir=rtl] .select2-selection--multiple .select2-selection__placeholder{float:right}.select2-container--bootstrap[dir=rtl] .select2-selection--multiple .select2-selection__choice{margin-left:0;margin-right:6px}.select2-container--bootstrap[dir=rtl] .select2-selection--multiple .select2-selection__choice__remove{margin-left:2px;margin-right:auto}.has-warning .select2-dropdown,.has-warning .select2-selection{border-color:#8a6d3b}.has-warning .select2-container--focus .select2-selection,.has-warning .select2-container--open .select2-selection{-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;border-color:#66512c}.has-warning.select2-drop-active{border-color:#66512c}.has-warning.select2-drop-active.select2-drop.select2-drop-above{border-top-color:#66512c}.has-error .select2-dropdown,.has-error .select2-selection{border-color:#a94442}.has-error .select2-container--focus .select2-selection,.has-error .select2-container--open .select2-selection{-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;border-color:#843534}.has-error.select2-drop-active{border-color:#843534}.has-error.select2-drop-active.select2-drop.select2-drop-above{border-top-color:#843534}.has-success .select2-dropdown,.has-success .select2-selection{border-color:#3c763d}.has-success .select2-container--focus .select2-selection,.has-success .select2-container--open .select2-selection{-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;border-color:#2b542c}.has-success.select2-drop-active{border-color:#2b542c}.has-success.select2-drop-active.select2-drop.select2-drop-above{border-top-color:#2b542c}.input-group>.select2-hidden-accessible:first-child+.select2-container--bootstrap>.selection>.select2-selection,.input-group>.select2-hidden-accessible:first-child+.select2-container--bootstrap>.selection>.select2-selection.form-control{border-bottom-right-radius:0;border-top-right-radius:0}.input-group>.select2-hidden-accessible:not(:first-child)+.select2-container--bootstrap:not(:last-child)>.selection>.select2-selection,.input-group>.select2-hidden-accessible:not(:first-child)+.select2-container--bootstrap:not(:last-child)>.selection>.select2-selection.form-control{border-radius:0}.input-group>.select2-hidden-accessible:not(:first-child):not(:last-child)+.select2-container--bootstrap:last-child>.selection>.select2-selection,.input-group>.select2-hidden-accessible:not(:first-child):not(:last-child)+.select2-container--bootstrap:last-child>.selection>.select2-selection.form-control{border-bottom-left-radius:0;border-top-left-radius:0}.input-group>.select2-container--bootstrap{display:table;table-layout:fixed;position:relative;z-index:2;width:100%;margin-bottom:0}.input-group>.select2-container--bootstrap>.selection>.select2-selection.form-control{float:none}.input-group>.select2-container--bootstrap.select2-container--focus,.input-group>.select2-container--bootstrap.select2-container--open{z-index:3}.input-group>.select2-container--bootstrap,.input-group>.select2-container--bootstrap .input-group-btn,.input-group>.select2-container--bootstrap .input-group-btn .btn{vertical-align:top}.form-control.select2-hidden-accessible{position:absolute!important;width:1px!important}@media (min-width:768px){.form-inline .select2-container--bootstrap{display:inline-block}}\n", ""]);

// exports


/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
  * vee-validate v2.2.15
  * (c) 2019 Abdelrahman Awad
  * @license MIT
  */
// 

var isTextInput = function isTextInput(el) {
  return includes(['text', 'password', 'search', 'email', 'tel', 'url', 'textarea', 'number'], el.type);
};

var isCheckboxOrRadioInput = function isCheckboxOrRadioInput(el) {
  return includes(['radio', 'checkbox'], el.type);
};

var isDateInput = function isDateInput(el) {
  return includes(['date', 'week', 'month', 'datetime-local', 'time'], el.type);
};

/**
 * Gets the data attribute. the name must be kebab-case.
 */
var getDataAttribute = function getDataAttribute(el, name) {
  return el.getAttribute("data-vv-" + name);
};

var isNaN$1 = function isNaN$1(value) {
  if ('isNaN' in Number) {
    return Number.isNaN(value);
  }

  // eslint-disable-next-line
  return typeof value === 'number' && value !== value;
};

/**
 * Checks if the values are either null or undefined.
 */
var isNullOrUndefined = function isNullOrUndefined() {
  var values = [],
      len = arguments.length;
  while (len--) {
    values[len] = arguments[len];
  }return values.every(function (value) {
    return value === null || value === undefined;
  });
};

/**
 * Creates the default flags object.
 */
var createFlags = function createFlags() {
  return {
    untouched: true,
    touched: false,
    dirty: false,
    pristine: true,
    valid: null,
    invalid: null,
    validated: false,
    pending: false,
    required: false,
    changed: false
  };
};

/**
 * Shallow object comparison.
 */
var isEqual = function isEqual(lhs, rhs) {
  if (lhs instanceof RegExp && rhs instanceof RegExp) {
    return isEqual(lhs.source, rhs.source) && isEqual(lhs.flags, rhs.flags);
  }

  if (Array.isArray(lhs) && Array.isArray(rhs)) {
    if (lhs.length !== rhs.length) {
      return false;
    }

    for (var i = 0; i < lhs.length; i++) {
      if (!isEqual(lhs[i], rhs[i])) {
        return false;
      }
    }

    return true;
  }

  // if both are objects, compare each key recursively.
  if (isObject(lhs) && isObject(rhs)) {
    return Object.keys(lhs).every(function (key) {
      return isEqual(lhs[key], rhs[key]);
    }) && Object.keys(rhs).every(function (key) {
      return isEqual(lhs[key], rhs[key]);
    });
  }

  if (isNaN$1(lhs) && isNaN$1(rhs)) {
    return true;
  }

  return lhs === rhs;
};

/**
 * Determines the input field scope.
 */
var getScope = function getScope(el) {
  var scope = getDataAttribute(el, 'scope');
  if (isNullOrUndefined(scope)) {
    var form = getForm(el);

    if (form) {
      scope = getDataAttribute(form, 'scope');
    }
  }

  return !isNullOrUndefined(scope) ? scope : null;
};

/**
 * Get the closest form element.
 */
var getForm = function getForm(el) {
  if (isNullOrUndefined(el)) {
    return null;
  }

  if (el.tagName === 'FORM') {
    return el;
  }

  if (!isNullOrUndefined(el.form)) {
    return el.form;
  }

  return !isNullOrUndefined(el.parentNode) ? getForm(el.parentNode) : null;
};

/**
 * Gets the value in an object safely.
 */
var getPath = function getPath(path, target, def) {
  if (def === void 0) def = undefined;

  if (!path || !target) {
    return def;
  }

  var value = target;
  path.split('.').every(function (prop) {
    if (prop in value) {
      value = value[prop];

      return true;
    }

    value = def;

    return false;
  });

  return value;
};

/**
 * Checks if path exists within an object.
 */
var hasPath = function hasPath(path, target) {
  var obj = target;
  var previousPath = null;
  var isNullOrNonObject = false;
  var isValidPath = path.split('.').reduce(function (reducer, prop) {
    if (obj == null || (typeof obj === 'undefined' ? 'undefined' : _typeof2(obj)) !== 'object') {
      isNullOrNonObject = true;
      return reducer && false;
    }

    if (prop in obj) {
      obj = obj[prop];
      previousPath = previousPath === null ? prop : previousPath + '.' + prop;

      return reducer && true;
    }

    return reducer && false;
  }, true);

  if (false) {
    if (isNullOrNonObject) {
      throw new Error(previousPath + ' is not an object');
    }
  }

  return isValidPath;
};

/**
 * Parses a rule string expression.
 */
var parseRule = function parseRule(rule) {
  var params = [];
  var name = rule.split(':')[0];

  if (includes(rule, ':')) {
    params = rule.split(':').slice(1).join(':').split(',');
  }

  return { name: name, params: params };
};

/**
 * Debounces a function.
 */
var debounce = function debounce(fn, wait, token) {
  if (wait === void 0) wait = 0;
  if (token === void 0) token = { cancelled: false };

  if (wait === 0) {
    return fn;
  }

  var timeout;

  return function () {
    var args = [],
        len = arguments.length;
    while (len--) {
      args[len] = arguments[len];
    }var later = function later() {
      timeout = null;

      // check if the fn call was cancelled.
      if (!token.cancelled) {
        fn.apply(void 0, args);
      }
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (!timeout) {
      fn.apply(void 0, args);
    }
  };
};

/**
 * Appends a rule definition to a list of rules.
 */
var appendRule = function appendRule(rule, rules) {
  if (!rules) {
    return normalizeRules(rule);
  }

  if (!rule) {
    return normalizeRules(rules);
  }

  if (typeof rules === 'string') {
    rules = normalizeRules(rules);
  }

  return assign({}, rules, normalizeRules(rule));
};

/**
 * Normalizes the given rules expression.
 */
var normalizeRules = function normalizeRules(rules) {
  // if falsy value return an empty object.
  if (!rules) {
    return {};
  }

  if (isObject(rules)) {
    // $FlowFixMe
    return Object.keys(rules).reduce(function (prev, curr) {
      var params = [];
      // $FlowFixMe
      if (rules[curr] === true) {
        params = [];
      } else if (Array.isArray(rules[curr])) {
        params = rules[curr];
      } else if (isObject(rules[curr])) {
        params = rules[curr];
      } else {
        params = [rules[curr]];
      }

      // $FlowFixMe
      if (rules[curr] !== false) {
        prev[curr] = params;
      }

      return prev;
    }, {});
  }

  if (typeof rules !== 'string') {
    warn('rules must be either a string or an object.');
    return {};
  }

  return rules.split('|').reduce(function (prev, rule) {
    var parsedRule = parseRule(rule);
    if (!parsedRule.name) {
      return prev;
    }

    prev[parsedRule.name] = parsedRule.params;
    return prev;
  }, {});
};

/**
 * Emits a warning to the console.
 */
var warn = function warn(message) {
  console.warn("[vee-validate] " + message); // eslint-disable-line
};

/**
 * Creates a branded error object.
 */
var createError = function createError(message) {
  return new Error("[vee-validate] " + message);
};

/**
 * Checks if the value is an object.
 */
var isObject = function isObject(obj) {
  return obj !== null && obj && (typeof obj === 'undefined' ? 'undefined' : _typeof2(obj)) === 'object' && !Array.isArray(obj);
};

/**
 * Checks if a function is callable.
 */
var isCallable = function isCallable(func) {
  return typeof func === 'function';
};

/**
 * Check if element has the css class on it.
 */
var hasClass = function hasClass(el, className) {
  if (el.classList) {
    return el.classList.contains(className);
  }

  return !!el.className.match(new RegExp("(\\s|^)" + className + "(\\s|$)"));
};

/**
 * Adds the provided css className to the element.
 */
var addClass = function addClass(el, className) {
  if (el.classList) {
    el.classList.add(className);
    return;
  }

  if (!hasClass(el, className)) {
    el.className += " " + className;
  }
};

/**
 * Remove the provided css className from the element.
 */
var removeClass = function removeClass(el, className) {
  if (el.classList) {
    el.classList.remove(className);
    return;
  }

  if (hasClass(el, className)) {
    var reg = new RegExp("(\\s|^)" + className + "(\\s|$)");
    el.className = el.className.replace(reg, ' ');
  }
};

/**
 * Adds or removes a class name on the input depending on the status flag.
 */
var toggleClass = function toggleClass(el, className, status) {
  if (!el || !className) {
    return;
  }

  if (Array.isArray(className)) {
    className.forEach(function (item) {
      return toggleClass(el, item, status);
    });
    return;
  }

  if (status) {
    return addClass(el, className);
  }

  removeClass(el, className);
};

/**
 * Converts an array-like object to array, provides a simple polyfill for Array.from
 */
var toArray = function toArray(arrayLike) {
  if (isCallable(Array.from)) {
    return Array.from(arrayLike);
  }

  var array = [];
  var length = arrayLike.length;
  /* istanbul ignore next */
  for (var i = 0; i < length; i++) {
    array.push(arrayLike[i]);
  }

  /* istanbul ignore next */
  return array;
};

/**
 * Converts an array-like object to array and place other elements in an array
 */
var ensureArray = function ensureArray(arrayLike) {
  if (Array.isArray(arrayLike)) {
    return [].concat(arrayLike);
  }
  var array = toArray(arrayLike);
  return isEmptyArray(array) ? [arrayLike] : array;
};

/**
 * Assign polyfill from the mdn.
 */
var assign = function assign(target) {
  var others = [],
      len = arguments.length - 1;
  while (len-- > 0) {
    others[len] = arguments[len + 1];
  } /* istanbul ignore else */
  if (isCallable(Object.assign)) {
    return Object.assign.apply(Object, [target].concat(others));
  }

  /* istanbul ignore next */
  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  /* istanbul ignore next */
  var to = Object(target);
  /* istanbul ignore next */
  others.forEach(function (arg) {
    // Skip over if undefined or null
    if (arg != null) {
      Object.keys(arg).forEach(function (key) {
        to[key] = arg[key];
      });
    }
  });
  /* istanbul ignore next */
  return to;
};

var id = 0;
var idTemplate = '{id}';

/**
 * Generates a unique id.
 */
var uniqId = function uniqId() {
  // handle too many uses of uniqId, although unlikely.
  if (id >= 9999) {
    id = 0;
    // shift the template.
    idTemplate = idTemplate.replace('{id}', '_{id}');
  }

  id++;
  var newId = idTemplate.replace('{id}', String(id));

  return newId;
};

var findIndex = function findIndex(arrayLike, predicate) {
  var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
  for (var i = 0; i < array.length; i++) {
    if (predicate(array[i])) {
      return i;
    }
  }

  return -1;
};

/**
 * finds the first element that satisfies the predicate callback, polyfills array.find
 */
var find = function find(arrayLike, predicate) {
  var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
  var idx = findIndex(array, predicate);

  return idx === -1 ? undefined : array[idx];
};

var isBuiltInComponent = function isBuiltInComponent(vnode) {
  if (!vnode) {
    return false;
  }

  var tag = vnode.componentOptions.tag;

  return (/^(keep-alive|transition|transition-group)$/.test(tag)
  );
};

var makeDelayObject = function makeDelayObject(events, delay, delayConfig) {
  if (typeof delay === 'number') {
    return events.reduce(function (prev, e) {
      prev[e] = delay;
      return prev;
    }, {});
  }

  return events.reduce(function (prev, e) {
    if ((typeof delay === 'undefined' ? 'undefined' : _typeof2(delay)) === 'object' && e in delay) {
      prev[e] = delay[e];
      return prev;
    }

    if (typeof delayConfig === 'number') {
      prev[e] = delayConfig;
      return prev;
    }

    prev[e] = delayConfig && delayConfig[e] || 0;

    return prev;
  }, {});
};

var deepParseInt = function deepParseInt(input) {
  if (typeof input === 'number') {
    return input;
  }

  if (typeof input === 'string') {
    return parseInt(input);
  }

  var map = {};
  for (var element in input) {
    map[element] = parseInt(input[element]);
  }

  return map;
};

var merge = function merge(target, source) {
  if (!(isObject(target) && isObject(source))) {
    return target;
  }

  Object.keys(source).forEach(function (key) {
    var obj, obj$1;

    if (isObject(source[key])) {
      if (!target[key]) {
        assign(target, (obj = {}, obj[key] = {}, obj));
      }

      merge(target[key], source[key]);
      return;
    }

    assign(target, (obj$1 = {}, obj$1[key] = source[key], obj$1));
  });

  return target;
};

var fillRulesFromElement = function fillRulesFromElement(el, rules) {
  if (el.required) {
    rules = appendRule('required', rules);
  }

  if (isTextInput(el)) {
    if (el.type === 'email') {
      rules = appendRule("email" + (el.multiple ? ':multiple' : ''), rules);
    }

    if (el.pattern) {
      rules = appendRule({ regex: el.pattern }, rules);
    }

    // 524288 is the max on some browsers and test environments.
    if (el.maxLength >= 0 && el.maxLength < 524288) {
      rules = appendRule("max:" + el.maxLength, rules);
    }

    if (el.minLength > 0) {
      rules = appendRule("min:" + el.minLength, rules);
    }

    if (el.type === 'number') {
      rules = appendRule('decimal', rules);
      if (el.min !== '') {
        rules = appendRule("min_value:" + el.min, rules);
      }

      if (el.max !== '') {
        rules = appendRule("max_value:" + el.max, rules);
      }
    }

    return rules;
  }

  if (isDateInput(el)) {
    var timeFormat = el.step && Number(el.step) < 60 ? 'HH:mm:ss' : 'HH:mm';

    if (el.type === 'date') {
      return appendRule('date_format:yyyy-MM-dd', rules);
    }

    if (el.type === 'datetime-local') {
      return appendRule("date_format:yyyy-MM-ddT" + timeFormat, rules);
    }

    if (el.type === 'month') {
      return appendRule('date_format:yyyy-MM', rules);
    }

    if (el.type === 'week') {
      return appendRule('date_format:yyyy-[W]WW', rules);
    }

    if (el.type === 'time') {
      return appendRule("date_format:" + timeFormat, rules);
    }
  }

  return rules;
};

var values = function values(obj) {
  if (isCallable(Object.values)) {
    return Object.values(obj);
  }

  // fallback to keys()
  /* istanbul ignore next */
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var parseSelector = function parseSelector(selector) {
  var rule = null;
  if (includes(selector, ':')) {
    rule = selector.split(':').pop();
    selector = selector.replace(":" + rule, '');
  }

  if (selector[0] === '#') {
    return {
      id: selector.slice(1),
      rule: rule,
      name: null,
      scope: null
    };
  }

  var scope = null;
  var name = selector;
  if (includes(selector, '.')) {
    var parts = selector.split('.');
    scope = parts[0];
    name = parts.slice(1).join('.');
  }

  return {
    id: null,
    scope: scope,
    name: name,
    rule: rule
  };
};

var includes = function includes(collection, item) {
  return collection.indexOf(item) !== -1;
};

var isEmptyArray = function isEmptyArray(arr) {
  return Array.isArray(arr) && arr.length === 0;
};

var defineNonReactive = function defineNonReactive(obj, prop, value) {
  Object.defineProperty(obj, prop, {
    configurable: false,
    writable: true,
    value: value
  });
};

// 

var LOCALE = 'en';

var Dictionary = function Dictionary(dictionary) {
  if (dictionary === void 0) dictionary = {};

  this.container = {};
  this.merge(dictionary);
};

var prototypeAccessors = { locale: { configurable: true } };

prototypeAccessors.locale.get = function () {
  return LOCALE;
};

prototypeAccessors.locale.set = function (value) {
  LOCALE = value || 'en';
};

Dictionary.prototype.hasLocale = function hasLocale(locale) {
  return !!this.container[locale];
};

Dictionary.prototype.setDateFormat = function setDateFormat(locale, format) {
  if (!this.container[locale]) {
    this.container[locale] = {};
  }

  this.container[locale].dateFormat = format;
};

Dictionary.prototype.getDateFormat = function getDateFormat(locale) {
  if (!this.container[locale] || !this.container[locale].dateFormat) {
    return null;
  }

  return this.container[locale].dateFormat;
};

Dictionary.prototype.getMessage = function getMessage(locale, key, data) {
  var message = null;
  if (!this.hasMessage(locale, key)) {
    message = this._getDefaultMessage(locale);
  } else {
    message = this.container[locale].messages[key];
  }

  return isCallable(message) ? message.apply(void 0, data) : message;
};

/**
 * Gets a specific message for field. falls back to the rule message.
 */
Dictionary.prototype.getFieldMessage = function getFieldMessage(locale, field, key, data) {
  if (!this.hasLocale(locale)) {
    return this.getMessage(locale, key, data);
  }

  var dict = this.container[locale].custom && this.container[locale].custom[field];
  if (!dict || !dict[key]) {
    return this.getMessage(locale, key, data);
  }

  var message = dict[key];
  return isCallable(message) ? message.apply(void 0, data) : message;
};

Dictionary.prototype._getDefaultMessage = function _getDefaultMessage(locale) {
  if (this.hasMessage(locale, '_default')) {
    return this.container[locale].messages._default;
  }

  return this.container.en.messages._default;
};

Dictionary.prototype.getAttribute = function getAttribute(locale, key, fallback) {
  if (fallback === void 0) fallback = '';

  if (!this.hasAttribute(locale, key)) {
    return fallback;
  }

  return this.container[locale].attributes[key];
};

Dictionary.prototype.hasMessage = function hasMessage(locale, key) {
  return !!(this.hasLocale(locale) && this.container[locale].messages && this.container[locale].messages[key]);
};

Dictionary.prototype.hasAttribute = function hasAttribute(locale, key) {
  return !!(this.hasLocale(locale) && this.container[locale].attributes && this.container[locale].attributes[key]);
};

Dictionary.prototype.merge = function merge$1(dictionary) {
  merge(this.container, dictionary);
};

Dictionary.prototype.setMessage = function setMessage(locale, key, message) {
  if (!this.hasLocale(locale)) {
    this.container[locale] = {
      messages: {},
      attributes: {}
    };
  }

  if (!this.container[locale].messages) {
    this.container[locale].messages = {};
  }

  this.container[locale].messages[key] = message;
};

Dictionary.prototype.setAttribute = function setAttribute(locale, key, attribute) {
  if (!this.hasLocale(locale)) {
    this.container[locale] = {
      messages: {},
      attributes: {}
    };
  }

  this.container[locale].attributes[key] = attribute;
};

Object.defineProperties(Dictionary.prototype, prototypeAccessors);

var drivers = {
  default: new Dictionary({
    en: {
      messages: {},
      attributes: {},
      custom: {}
    }
  })
};

var currentDriver = 'default';

var DictionaryResolver = function DictionaryResolver() {};

DictionaryResolver._checkDriverName = function _checkDriverName(driver) {
  if (!driver) {
    throw createError('you must provide a name to the dictionary driver');
  }
};

DictionaryResolver.setDriver = function setDriver(driver, implementation) {
  if (implementation === void 0) implementation = null;

  this._checkDriverName(driver);
  if (implementation) {
    drivers[driver] = implementation;
  }

  currentDriver = driver;
};

DictionaryResolver.getDriver = function getDriver() {
  return drivers[currentDriver];
};

// 

var ErrorBag = function ErrorBag(errorBag, id) {
  if (errorBag === void 0) errorBag = null;
  if (id === void 0) id = null;

  this.vmId = id || null;
  // make this bag a mirror of the provided one, sharing the same items reference.
  if (errorBag && errorBag instanceof ErrorBag) {
    this.items = errorBag.items;
  } else {
    this.items = [];
  }
};

ErrorBag.prototype[typeof Symbol === 'function' ? Symbol.iterator : '@@iterator'] = function () {
  var this$1 = this;

  var index = 0;
  return {
    next: function next() {
      return { value: this$1.items[index++], done: index > this$1.items.length };
    }
  };
};

/**
 * Adds an error to the internal array.
 */
ErrorBag.prototype.add = function add(error) {
  var ref;

  (ref = this.items).push.apply(ref, this._normalizeError(error));
};

/**
 * Normalizes passed errors to an error array.
 */
ErrorBag.prototype._normalizeError = function _normalizeError(error) {
  var this$1 = this;

  if (Array.isArray(error)) {
    return error.map(function (e) {
      e.scope = !isNullOrUndefined(e.scope) ? e.scope : null;
      e.vmId = !isNullOrUndefined(e.vmId) ? e.vmId : this$1.vmId || null;

      return e;
    });
  }

  error.scope = !isNullOrUndefined(error.scope) ? error.scope : null;
  error.vmId = !isNullOrUndefined(error.vmId) ? error.vmId : this.vmId || null;

  return [error];
};

/**
 * Regenrates error messages if they have a generator function.
 */
ErrorBag.prototype.regenerate = function regenerate() {
  this.items.forEach(function (i) {
    i.msg = isCallable(i.regenerate) ? i.regenerate() : i.msg;
  });
};

/**
 * Updates a field error with the new field scope.
 */
ErrorBag.prototype.update = function update(id, error) {
  var item = find(this.items, function (i) {
    return i.id === id;
  });
  if (!item) {
    return;
  }

  var idx = this.items.indexOf(item);
  this.items.splice(idx, 1);
  item.scope = error.scope;
  this.items.push(item);
};

/**
 * Gets all error messages from the internal array.
 */
ErrorBag.prototype.all = function all(scope) {
  var this$1 = this;

  var filterFn = function filterFn(item) {
    var matchesScope = true;
    var matchesVM = true;
    if (!isNullOrUndefined(scope)) {
      matchesScope = item.scope === scope;
    }

    if (!isNullOrUndefined(this$1.vmId)) {
      matchesVM = item.vmId === this$1.vmId;
    }

    return matchesVM && matchesScope;
  };

  return this.items.filter(filterFn).map(function (e) {
    return e.msg;
  });
};

/**
 * Checks if there are any errors in the internal array.
 */
ErrorBag.prototype.any = function any(scope) {
  var this$1 = this;

  var filterFn = function filterFn(item) {
    var matchesScope = true;
    var matchesVM = true;
    if (!isNullOrUndefined(scope)) {
      matchesScope = item.scope === scope;
    }

    if (!isNullOrUndefined(this$1.vmId)) {
      matchesVM = item.vmId === this$1.vmId;
    }

    return matchesVM && matchesScope;
  };

  return !!this.items.filter(filterFn).length;
};

/**
 * Removes all items from the internal array.
 */
ErrorBag.prototype.clear = function clear(scope) {
  var this$1 = this;

  var matchesVM = isNullOrUndefined(this.vmId) ? function () {
    return true;
  } : function (i) {
    return i.vmId === this$1.vmId;
  };
  var matchesScope = function matchesScope(i) {
    return i.scope === scope;
  };
  if (arguments.length === 0) {
    matchesScope = function matchesScope() {
      return true;
    };
  } else if (isNullOrUndefined(scope)) {
    scope = null;
  }

  for (var i = 0; i < this.items.length; ++i) {
    if (matchesVM(this.items[i]) && matchesScope(this.items[i])) {
      this.items.splice(i, 1);
      --i;
    }
  }
};

/**
 * Collects errors into groups or for a specific field.
 */
ErrorBag.prototype.collect = function collect(field, scope, map) {
  var this$1 = this;
  if (map === void 0) map = true;

  var isSingleField = !isNullOrUndefined(field) && !field.includes('*');
  var groupErrors = function groupErrors(items) {
    var errors = items.reduce(function (collection, error) {
      if (!isNullOrUndefined(this$1.vmId) && error.vmId !== this$1.vmId) {
        return collection;
      }

      if (!collection[error.field]) {
        collection[error.field] = [];
      }

      collection[error.field].push(map ? error.msg : error);

      return collection;
    }, {});

    // reduce the collection to be a single array.
    if (isSingleField) {
      return values(errors)[0] || [];
    }

    return errors;
  };

  if (isNullOrUndefined(field)) {
    return groupErrors(this.items);
  }

  var selector = isNullOrUndefined(scope) ? String(field) : scope + "." + field;
  var ref = this._makeCandidateFilters(selector);
  var isPrimary = ref.isPrimary;
  var isAlt = ref.isAlt;

  var collected = this.items.reduce(function (prev, curr) {
    if (isPrimary(curr)) {
      prev.primary.push(curr);
    }

    if (isAlt(curr)) {
      prev.alt.push(curr);
    }

    return prev;
  }, { primary: [], alt: [] });

  collected = collected.primary.length ? collected.primary : collected.alt;

  return groupErrors(collected);
};

/**
 * Gets the internal array length.
 */
ErrorBag.prototype.count = function count() {
  var this$1 = this;

  if (this.vmId) {
    return this.items.filter(function (e) {
      return e.vmId === this$1.vmId;
    }).length;
  }

  return this.items.length;
};

/**
 * Finds and fetches the first error message for the specified field id.
 */
ErrorBag.prototype.firstById = function firstById(id) {
  var error = find(this.items, function (i) {
    return i.id === id;
  });

  return error ? error.msg : undefined;
};

/**
 * Gets the first error message for a specific field.
 */
ErrorBag.prototype.first = function first(field, scope) {
  if (scope === void 0) scope = null;

  var selector = isNullOrUndefined(scope) ? field : scope + "." + field;
  var match = this._match(selector);

  return match && match.msg;
};

/**
 * Returns the first error rule for the specified field
 */
ErrorBag.prototype.firstRule = function firstRule(field, scope) {
  var errors = this.collect(field, scope, false);

  return errors.length && errors[0].rule || undefined;
};

/**
 * Checks if the internal array has at least one error for the specified field.
 */
ErrorBag.prototype.has = function has(field, scope) {
  if (scope === void 0) scope = null;

  return !!this.first(field, scope);
};

/**
 * Gets the first error message for a specific field and a rule.
 */
ErrorBag.prototype.firstByRule = function firstByRule(name, rule, scope) {
  if (scope === void 0) scope = null;

  var error = this.collect(name, scope, false).filter(function (e) {
    return e.rule === rule;
  })[0];

  return error && error.msg || undefined;
};

/**
 * Gets the first error message for a specific field that not match the rule.
 */
ErrorBag.prototype.firstNot = function firstNot(name, rule, scope) {
  if (rule === void 0) rule = 'required';
  if (scope === void 0) scope = null;

  var error = this.collect(name, scope, false).filter(function (e) {
    return e.rule !== rule;
  })[0];

  return error && error.msg || undefined;
};

/**
 * Removes errors by matching against the id or ids.
 */
ErrorBag.prototype.removeById = function removeById(id) {
  var condition = function condition(item) {
    return item.id === id;
  };
  if (Array.isArray(id)) {
    condition = function condition(item) {
      return id.indexOf(item.id) !== -1;
    };
  }

  for (var i = 0; i < this.items.length; ++i) {
    if (condition(this.items[i])) {
      this.items.splice(i, 1);
      --i;
    }
  }
};

/**
 * Removes all error messages associated with a specific field.
 */
ErrorBag.prototype.remove = function remove(field, scope, vmId) {
  if (isNullOrUndefined(field)) {
    return;
  }

  var selector = isNullOrUndefined(scope) ? String(field) : scope + "." + field;
  var ref = this._makeCandidateFilters(selector);
  var isPrimary = ref.isPrimary;
  var isAlt = ref.isAlt;
  var matches = function matches(item) {
    return isPrimary(item) || isAlt(item);
  };
  var shouldRemove = function shouldRemove(item) {
    if (isNullOrUndefined(vmId)) {
      return matches(item);
    }

    return matches(item) && item.vmId === vmId;
  };

  for (var i = 0; i < this.items.length; ++i) {
    if (shouldRemove(this.items[i])) {
      this.items.splice(i, 1);
      --i;
    }
  }
};

ErrorBag.prototype._makeCandidateFilters = function _makeCandidateFilters(selector) {
  var this$1 = this;

  var matchesRule = function matchesRule() {
    return true;
  };
  var matchesScope = function matchesScope() {
    return true;
  };
  var matchesName = function matchesName() {
    return true;
  };
  var matchesVM = function matchesVM() {
    return true;
  };

  var ref = parseSelector(selector);
  var id = ref.id;
  var rule = ref.rule;
  var scope = ref.scope;
  var name = ref.name;

  if (rule) {
    matchesRule = function matchesRule(item) {
      return item.rule === rule;
    };
  }

  // match by id, can be combined with rule selection.
  if (id) {
    return {
      isPrimary: function isPrimary(item) {
        return matchesRule(item) && function (item) {
          return id === item.id;
        };
      },
      isAlt: function isAlt() {
        return false;
      }
    };
  }

  if (isNullOrUndefined(scope)) {
    // if no scope specified, make sure the found error has no scope.
    matchesScope = function matchesScope(item) {
      return isNullOrUndefined(item.scope);
    };
  } else {
    matchesScope = function matchesScope(item) {
      return item.scope === scope;
    };
  }

  if (!isNullOrUndefined(name) && name !== '*') {
    matchesName = function matchesName(item) {
      return item.field === name;
    };
  }

  if (!isNullOrUndefined(this.vmId)) {
    matchesVM = function matchesVM(item) {
      return item.vmId === this$1.vmId;
    };
  }

  // matches the first candidate.
  var isPrimary = function isPrimary(item) {
    return matchesVM(item) && matchesName(item) && matchesRule(item) && matchesScope(item);
  };

  // matches a second candidate, which is a field with a name containing the '.' character.
  var isAlt = function isAlt(item) {
    return matchesVM(item) && matchesRule(item) && item.field === scope + "." + name;
  };

  return {
    isPrimary: isPrimary,
    isAlt: isAlt
  };
};

ErrorBag.prototype._match = function _match(selector) {
  if (isNullOrUndefined(selector)) {
    return undefined;
  }

  var ref = this._makeCandidateFilters(selector);
  var isPrimary = ref.isPrimary;
  var isAlt = ref.isAlt;

  return this.items.reduce(function (prev, item, idx, arr) {
    var isLast = idx === arr.length - 1;
    if (prev.primary) {
      return isLast ? prev.primary : prev;
    }

    if (isPrimary(item)) {
      prev.primary = item;
    }

    if (isAlt(item)) {
      prev.alt = item;
    }

    // keep going.
    if (!isLast) {
      return prev;
    }

    return prev.primary || prev.alt;
  }, {});
};

var DEFAULT_CONFIG = {
  locale: 'en',
  delay: 0,
  errorBagName: 'errors',
  dictionary: null,
  fieldsBagName: 'fields',
  classes: false,
  classNames: null,
  events: 'input',
  inject: true,
  fastExit: true,
  aria: true,
  validity: false,
  mode: 'aggressive',
  useConstraintAttrs: true,
  i18n: null,
  i18nRootKey: 'validation'
};

var currentConfig = assign({}, DEFAULT_CONFIG);

var resolveConfig = function resolveConfig(ctx) {
  var selfConfig = getPath('$options.$_veeValidate', ctx, {});

  return assign({}, currentConfig, selfConfig);
};

var getConfig = function getConfig() {
  return currentConfig;
};

var setConfig = function setConfig(newConf) {
  currentConfig = assign({}, currentConfig, newConf);
};

// VNode Utils

// Gets the model object on the vnode.
function findModel(vnode) {
  if (!vnode.data) {
    return null;
  }

  // Component Model
  if (vnode.data.model) {
    return vnode.data.model;
  }

  return !!vnode.data.directives && find(vnode.data.directives, function (d) {
    return d.name === 'model';
  });
}

function extractChildren(vnode) {
  if (Array.isArray(vnode)) {
    return vnode;
  }

  if (Array.isArray(vnode.children)) {
    return vnode.children;
  }

  if (vnode.componentOptions && Array.isArray(vnode.componentOptions.children)) {
    return vnode.componentOptions.children;
  }

  return [];
}

function extractVNodes(vnode) {
  if (findModel(vnode)) {
    return [vnode];
  }

  var children = extractChildren(vnode);

  return children.reduce(function (nodes, node) {
    var candidates = extractVNodes(node);
    if (candidates.length) {
      nodes.push.apply(nodes, candidates);
    }

    return nodes;
  }, []);
}

// Resolves v-model config if exists.
function findModelConfig(vnode) {
  if (!vnode.componentOptions) {
    return null;
  }

  return vnode.componentOptions.Ctor.options.model;
}
// Adds a listener to vnode listener object.
function mergeVNodeListeners(obj, eventName, handler) {
  // Has a single listener, convert to array.
  if (isCallable(obj[eventName])) {
    var prevHandler = obj[eventName];
    obj[eventName] = [prevHandler];
  }

  // no listeners, create the array.
  if (isNullOrUndefined(obj[eventName])) {
    obj[eventName] = [];
  }

  obj[eventName].push(handler);
}

// Adds a listener to a native HTML vnode.
function addNativeNodeListener(node, eventName, handler) {
  if (isNullOrUndefined(node.data.on)) {
    node.data.on = {};
  }

  mergeVNodeListeners(node.data.on, eventName, handler);
}

// Adds a listener to a Vue component vnode.
function addComponentNodeListener(node, eventName, handler) {
  /* istanbul ignore next */
  if (!node.componentOptions.listeners) {
    node.componentOptions.listeners = {};
  }

  mergeVNodeListeners(node.componentOptions.listeners, eventName, handler);
}
function addVNodeListener(vnode, eventName, handler) {
  if (vnode.componentOptions) {
    addComponentNodeListener(vnode, eventName, handler);
    return;
  }

  addNativeNodeListener(vnode, eventName, handler);
}
// Determines if `change` should be used over `input` for listeners.
function getInputEventName(vnode, model) {
  // Is a component.
  if (vnode.componentOptions) {
    var ref = findModelConfig(vnode) || { event: 'input' };
    var event = ref.event;

    return event;
  }

  // Lazy Models and select tag typically use change event
  if (model && model.modifiers && model.modifiers.lazy || vnode.tag === 'select') {
    return 'change';
  }

  // is a textual-type input.
  if (vnode.data.attrs && isTextInput({ type: vnode.data.attrs.type || 'text' })) {
    return 'input';
  }

  return 'change';
}

function normalizeSlots(slots, ctx) {
  return Object.keys(slots).reduce(function (arr, key) {
    slots[key].forEach(function (vnode) {
      if (!vnode.context) {
        slots[key].context = ctx;
        if (!vnode.data) {
          vnode.data = {};
        }
        vnode.data.slot = key;
      }
    });

    return arr.concat(slots[key]);
  }, []);
}
function createRenderless(h, children) {
  // Only render the first item of the node.
  if (Array.isArray(children) && children[0]) {
    return children[0];
  }

  // a single node.
  if (children) {
    return children;
  }

  // No slots, render nothing.
  return h();
}

/**
 * Generates the options required to construct a field.
 */
var Resolver = function Resolver() {};

Resolver.generate = function generate(el, binding, vnode) {
  var model = Resolver.resolveModel(binding, vnode);
  var options = resolveConfig(vnode.context);

  return {
    name: Resolver.resolveName(el, vnode),
    el: el,
    listen: !binding.modifiers.disable,
    bails: binding.modifiers.bails ? true : binding.modifiers.continues === true ? false : undefined,
    scope: Resolver.resolveScope(el, binding, vnode),
    vm: vnode.context,
    expression: binding.value,
    component: vnode.componentInstance,
    classes: options.classes,
    classNames: options.classNames,
    getter: Resolver.resolveGetter(el, vnode, model),
    events: Resolver.resolveEvents(el, vnode) || options.events,
    model: model,
    delay: Resolver.resolveDelay(el, vnode, options),
    rules: Resolver.resolveRules(el, binding, vnode),
    immediate: !!binding.modifiers.initial || !!binding.modifiers.immediate,
    persist: !!binding.modifiers.persist,
    validity: options.validity && !vnode.componentInstance,
    aria: options.aria && !vnode.componentInstance,
    initialValue: Resolver.resolveInitialValue(vnode)
  };
};

Resolver.getCtorConfig = function getCtorConfig(vnode) {
  if (!vnode.componentInstance) {
    return null;
  }

  var config = getPath('componentInstance.$options.$_veeValidate', vnode);

  return config;
};

/**
 * Resolves the rules defined on an element.
 */
Resolver.resolveRules = function resolveRules(el, binding, vnode) {
  var rules = '';
  if (!binding.value && (!binding || !binding.expression)) {
    rules = getDataAttribute(el, 'rules');
  }

  if (binding.value && includes(['string', 'object'], _typeof2(binding.value.rules))) {
    rules = binding.value.rules;
  } else if (binding.value) {
    rules = binding.value;
  }

  if (vnode.componentInstance) {
    return rules;
  }

  // If validity is disabled, ignore field rules.
  var normalized = normalizeRules(rules);
  if (!getConfig().useConstraintAttrs) {
    return normalized;
  }

  return assign({}, fillRulesFromElement(el, {}), normalized);
};

/**
 * @param {*} vnode
 */
Resolver.resolveInitialValue = function resolveInitialValue(vnode) {
  var model = vnode.data.model || find(vnode.data.directives, function (d) {
    return d.name === 'model';
  });

  return model && model.value;
};

/**
 * Resolves the delay value.
 * @param {*} el
 * @param {*} vnode
 * @param {Object} options
 */
Resolver.resolveDelay = function resolveDelay(el, vnode, options) {
  var delay = getDataAttribute(el, 'delay');
  var globalDelay = options && 'delay' in options ? options.delay : 0;

  if (!delay && vnode.componentInstance && vnode.componentInstance.$attrs) {
    delay = vnode.componentInstance.$attrs['data-vv-delay'];
  }

  if (!isObject(globalDelay)) {
    return deepParseInt(delay || globalDelay);
  }

  if (!isNullOrUndefined(delay)) {
    globalDelay.input = delay;
  }

  return deepParseInt(globalDelay);
};

/**
 * Resolves the events to validate in response to.
 * @param {*} el
 * @param {*} vnode
 */
Resolver.resolveEvents = function resolveEvents(el, vnode) {
  // resolve it from the root element.
  var events = getDataAttribute(el, 'validate-on');

  // resolve from data-vv-validate-on if its a vue component.
  if (!events && vnode.componentInstance && vnode.componentInstance.$attrs) {
    events = vnode.componentInstance.$attrs['data-vv-validate-on'];
  }

  // resolve it from $_veeValidate options.
  if (!events && vnode.componentInstance) {
    var config = Resolver.getCtorConfig(vnode);
    events = config && config.events;
  }

  if (!events && getConfig().events) {
    events = getConfig().events;
  }

  // resolve the model event if its configured for custom components.
  if (events && vnode.componentInstance && includes(events, 'input')) {
    var ref = vnode.componentInstance.$options.model || { event: 'input' };
    var event = ref.event;
    // if the prop was configured but not the model.
    if (!event) {
      return events;
    }

    events = events.replace('input', event);
  }

  return events;
};

/**
 * Resolves the scope for the field.
 * @param {*} el
 * @param {*} binding
 */
Resolver.resolveScope = function resolveScope(el, binding, vnode) {
  if (vnode === void 0) vnode = {};

  var scope = null;
  if (vnode.componentInstance && isNullOrUndefined(scope)) {
    scope = vnode.componentInstance.$attrs && vnode.componentInstance.$attrs['data-vv-scope'];
  }

  return !isNullOrUndefined(scope) ? scope : getScope(el);
};

/**
 * Checks if the node directives contains a v-model or a specified arg.
 * Args take priority over models.
 *
 * @return {Object}
 */
Resolver.resolveModel = function resolveModel(binding, vnode) {
  if (binding.arg) {
    return { expression: binding.arg };
  }

  var model = findModel(vnode);
  if (!model) {
    return null;
  }

  // https://github.com/vuejs/vue/blob/dev/src/core/util/lang.js#L26
  var watchable = !/[^\w.$]/.test(model.expression) && hasPath(model.expression, vnode.context);
  var lazy = !!(model.modifiers && model.modifiers.lazy);

  if (!watchable) {
    return { expression: null, lazy: lazy };
  }

  return { expression: model.expression, lazy: lazy };
};

/**
 * Resolves the field name to trigger validations.
 * @return {String} The field name.
 */
Resolver.resolveName = function resolveName(el, vnode) {
  var name = getDataAttribute(el, 'name');

  if (!name && !vnode.componentInstance) {
    return el.name;
  }

  if (!name && vnode.componentInstance && vnode.componentInstance.$attrs) {
    name = vnode.componentInstance.$attrs['data-vv-name'] || vnode.componentInstance.$attrs['name'];
  }

  if (!name && vnode.componentInstance) {
    var config = Resolver.getCtorConfig(vnode);
    if (config && isCallable(config.name)) {
      var boundGetter = config.name.bind(vnode.componentInstance);

      return boundGetter();
    }

    return vnode.componentInstance.name;
  }

  return name;
};

/**
 * Returns a value getter input type.
 */
Resolver.resolveGetter = function resolveGetter(el, vnode, model) {
  if (model && model.expression) {
    return function () {
      return getPath(model.expression, vnode.context);
    };
  }

  if (vnode.componentInstance) {
    var path = getDataAttribute(el, 'value-path') || vnode.componentInstance.$attrs && vnode.componentInstance.$attrs['data-vv-value-path'];
    if (path) {
      return function () {
        return getPath(path, vnode.componentInstance);
      };
    }

    var config = Resolver.getCtorConfig(vnode);
    if (config && isCallable(config.value)) {
      var boundGetter = config.value.bind(vnode.componentInstance);

      return function () {
        return boundGetter();
      };
    }

    var ref = vnode.componentInstance.$options.model || { prop: 'value' };
    var prop = ref.prop;

    return function () {
      return vnode.componentInstance[prop];
    };
  }

  switch (el.type) {
    case 'checkbox':
      return function () {
        var els = document.querySelectorAll("input[name=\"" + el.name + "\"]");

        els = toArray(els).filter(function (el) {
          return el.checked;
        });
        if (!els.length) {
          return undefined;
        }

        return els.map(function (checkbox) {
          return checkbox.value;
        });
      };
    case 'radio':
      return function () {
        var els = document.querySelectorAll("input[name=\"" + el.name + "\"]");
        var elm = find(els, function (el) {
          return el.checked;
        });

        return elm && elm.value;
      };
    case 'file':
      return function (context) {
        return toArray(el.files);
      };
    case 'select-multiple':
      return function () {
        return toArray(el.options).filter(function (opt) {
          return opt.selected;
        }).map(function (opt) {
          return opt.value;
        });
      };
    default:
      return function () {
        return el && el.value;
      };
  }
};

var RULES = {};

var RuleContainer = function RuleContainer() {};

var staticAccessors = { rules: { configurable: true } };

RuleContainer.add = function add(name, ref) {
  var validate = ref.validate;
  var options = ref.options;
  var paramNames = ref.paramNames;

  RULES[name] = {
    validate: validate,
    options: options,
    paramNames: paramNames
  };
};

staticAccessors.rules.get = function () {
  return RULES;
};

RuleContainer.has = function has(name) {
  return !!RULES[name];
};

RuleContainer.isImmediate = function isImmediate(name) {
  return !!(RULES[name] && RULES[name].options.immediate);
};

RuleContainer.isRequireRule = function isRequireRule(name) {
  return !!(RULES[name] && RULES[name].options.computesRequired);
};

RuleContainer.isTargetRule = function isTargetRule(name) {
  return !!(RULES[name] && RULES[name].options.hasTarget);
};

RuleContainer.remove = function remove(ruleName) {
  delete RULES[ruleName];
};

RuleContainer.getParamNames = function getParamNames(ruleName) {
  return RULES[ruleName] && RULES[ruleName].paramNames;
};

RuleContainer.getOptions = function getOptions(ruleName) {
  return RULES[ruleName] && RULES[ruleName].options;
};

RuleContainer.getValidatorMethod = function getValidatorMethod(ruleName) {
  return RULES[ruleName] ? RULES[ruleName].validate : null;
};

Object.defineProperties(RuleContainer, staticAccessors);

// 

var isEvent = function isEvent(evt) {
  return typeof Event !== 'undefined' && isCallable(Event) && evt instanceof Event || evt && evt.srcElement;
};

var normalizeEvents = function normalizeEvents(evts) {
  if (!evts) {
    return [];
  }

  return typeof evts === 'string' ? evts.split('|') : evts;
};

var supportsPassive = true;

var detectPassiveSupport = function detectPassiveSupport() {
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {
    supportsPassive = false;
  }
  return supportsPassive;
};

var addEventListener = function addEventListener(el, eventName, cb) {
  el.addEventListener(eventName, cb, supportsPassive ? { passive: true } : false);
};

// 

var DEFAULT_OPTIONS = {
  targetOf: null,
  immediate: false,
  persist: false,
  scope: null,
  listen: true,
  name: null,
  rules: {},
  vm: null,
  classes: false,
  validity: true,
  aria: true,
  events: 'input|blur',
  delay: 0,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  }
};

var Field = function Field(options) {
  if (options === void 0) options = {};

  this.id = uniqId();
  this.el = options.el;
  this.updated = false;
  this.vmId = options.vmId;
  defineNonReactive(this, 'dependencies', []);
  defineNonReactive(this, 'watchers', []);
  defineNonReactive(this, 'events', []);
  this.delay = 0;
  this.rules = {};
  this.forceRequired = false;
  this._cacheId(options);
  this.classNames = assign({}, DEFAULT_OPTIONS.classNames);
  options = assign({}, DEFAULT_OPTIONS, options);
  this._delay = !isNullOrUndefined(options.delay) ? options.delay : 0; // cache initial delay
  this.validity = options.validity;
  this.aria = options.aria;
  this.flags = options.flags || createFlags();
  defineNonReactive(this, 'vm', options.vm);
  defineNonReactive(this, 'componentInstance', options.component);
  this.ctorConfig = this.componentInstance ? getPath('$options.$_veeValidate', this.componentInstance) : undefined;
  this.update(options);
  // set initial value.
  this.initialValue = this.value;
  this.updated = false;
};

var prototypeAccessors$1 = { validator: { configurable: true }, isRequired: { configurable: true }, isDisabled: { configurable: true }, alias: { configurable: true }, value: { configurable: true }, bails: { configurable: true }, rejectsFalse: { configurable: true } };

prototypeAccessors$1.validator.get = function () {
  if (!this.vm || !this.vm.$validator) {
    return { validate: function validate() {
        return Promise.resolve(true);
      } };
  }

  return this.vm.$validator;
};

prototypeAccessors$1.isRequired.get = function () {
  return !!this.rules.required || this.forceRequired;
};

prototypeAccessors$1.isDisabled.get = function () {
  return !!(this.el && this.el.disabled);
};

/**
 * Gets the display name (user-friendly name).
 */
prototypeAccessors$1.alias.get = function () {
  if (this._alias) {
    return this._alias;
  }

  var alias = null;
  if (this.ctorConfig && this.ctorConfig.alias) {
    alias = isCallable(this.ctorConfig.alias) ? this.ctorConfig.alias.call(this.componentInstance) : this.ctorConfig.alias;
  }

  if (!alias && this.el) {
    alias = getDataAttribute(this.el, 'as');
  }

  if (!alias && this.componentInstance) {
    return this.componentInstance.$attrs && this.componentInstance.$attrs['data-vv-as'];
  }

  return alias;
};

/**
 * Gets the input value.
 */

prototypeAccessors$1.value.get = function () {
  if (!isCallable(this.getter)) {
    return undefined;
  }

  return this.getter();
};

prototypeAccessors$1.bails.get = function () {
  return this._bails;
};

/**
 * If the field rejects false as a valid value for the required rule.
 */

prototypeAccessors$1.rejectsFalse.get = function () {
  if (this.componentInstance && this.ctorConfig) {
    return !!this.ctorConfig.rejectsFalse;
  }

  if (!this.el) {
    return false;
  }

  return this.el.type === 'checkbox';
};

/**
 * Determines if the instance matches the options provided.
 */
Field.prototype.matches = function matches(options) {
  var this$1 = this;

  if (!options) {
    return true;
  }

  if (options.id) {
    return this.id === options.id;
  }

  var matchesComponentId = isNullOrUndefined(options.vmId) ? function () {
    return true;
  } : function (id) {
    return id === this$1.vmId;
  };
  if (!matchesComponentId(options.vmId)) {
    return false;
  }

  if (options.name === undefined && options.scope === undefined) {
    return true;
  }

  if (options.scope === undefined) {
    return this.name === options.name;
  }

  if (options.name === undefined) {
    return this.scope === options.scope;
  }

  return options.name === this.name && options.scope === this.scope;
};

/**
 * Caches the field id.
 */
Field.prototype._cacheId = function _cacheId(options) {
  if (this.el && !options.targetOf) {
    this.el._veeValidateId = this.id;
  }
};

/**
 * Keeps a reference of the most current validation run.
 */
Field.prototype.waitFor = function waitFor(pendingPromise) {
  this._waitingFor = pendingPromise;
};

Field.prototype.isWaitingFor = function isWaitingFor(promise) {
  return this._waitingFor === promise;
};

/**
 * Updates the field with changed data.
 */
Field.prototype.update = function update(options) {
  var this$1 = this;

  this.targetOf = options.targetOf || null;
  this.immediate = options.immediate || this.immediate || false;
  this.persist = options.persist || this.persist || false;

  // update errors scope if the field scope was changed.
  if (!isNullOrUndefined(options.scope) && options.scope !== this.scope && isCallable(this.validator.update)) {
    this.validator.update(this.id, { scope: options.scope });
  }
  this.scope = !isNullOrUndefined(options.scope) ? options.scope : !isNullOrUndefined(this.scope) ? this.scope : null;
  this.name = (!isNullOrUndefined(options.name) ? String(options.name) : options.name) || this.name || null;
  this.rules = options.rules !== undefined ? normalizeRules(options.rules) : this.rules;
  this._bails = options.bails !== undefined ? options.bails : this._bails;
  this.model = options.model || this.model;
  this.listen = options.listen !== undefined ? options.listen : this.listen;
  this.classes = (options.classes || this.classes || false) && !this.componentInstance;
  this.classNames = isObject(options.classNames) ? merge(this.classNames, options.classNames) : this.classNames;
  this.getter = isCallable(options.getter) ? options.getter : this.getter;
  this._alias = options.alias || this._alias;
  this.events = options.events ? normalizeEvents(options.events) : this.events;
  this.delay = makeDelayObject(this.events, options.delay || this.delay, this._delay);
  this.updateDependencies();
  this.addActionListeners();

  if (false) {
    warn('A field is missing a "name" or "data-vv-name" attribute');
  }

  // update required flag flags
  if (options.rules !== undefined) {
    this.flags.required = this.isRequired;
  }

  if (Object.keys(options.rules || {}).length === 0 && this.updated) {
    var resetFlag = this.flags.validated;
    this.validator.validate("#" + this.id).then(function () {
      this$1.flags.validated = resetFlag;
    });
  }

  // validate if it was validated before and field was updated and there was a rules mutation.
  if (this.flags.validated && options.rules !== undefined && this.updated) {
    this.validator.validate("#" + this.id);
  }

  this.updated = true;
  this.addValueListeners();

  // no need to continue.
  if (!this.el) {
    return;
  }
  this.updateClasses();
  this.updateAriaAttrs();
};

/**
 * Resets field flags and errors.
 */
Field.prototype.reset = function reset() {
  var this$1 = this;

  if (this._cancellationToken) {
    this._cancellationToken.cancelled = true;
    delete this._cancellationToken;
  }

  var defaults = createFlags();
  Object.keys(this.flags).filter(function (flag) {
    return flag !== 'required';
  }).forEach(function (flag) {
    this$1.flags[flag] = defaults[flag];
  });

  // update initial value
  this.initialValue = this.value;
  this.flags.changed = false;

  this.addValueListeners();
  this.addActionListeners();
  this.updateClasses(true);
  this.updateAriaAttrs();
  this.updateCustomValidity();
};

/**
 * Sets the flags and their negated counterparts, and updates the classes and re-adds action listeners.
 */
Field.prototype.setFlags = function setFlags(flags) {
  var this$1 = this;

  var negated = {
    pristine: 'dirty',
    dirty: 'pristine',
    valid: 'invalid',
    invalid: 'valid',
    touched: 'untouched',
    untouched: 'touched'
  };

  Object.keys(flags).forEach(function (flag) {
    this$1.flags[flag] = flags[flag];
    // if it has a negation and was not specified, set it as well.
    if (negated[flag] && flags[negated[flag]] === undefined) {
      this$1.flags[negated[flag]] = !flags[flag];
    }
  });

  if (flags.untouched !== undefined || flags.touched !== undefined || flags.dirty !== undefined || flags.pristine !== undefined) {
    this.addActionListeners();
  }
  this.updateClasses();
  this.updateAriaAttrs();
  this.updateCustomValidity();
};

/**
 * Determines if the field requires references to target fields.
*/
Field.prototype.updateDependencies = function updateDependencies() {
  var this$1 = this;

  // reset dependencies.
  this.dependencies.forEach(function (d) {
    return d.field.destroy();
  });
  this.dependencies = [];

  // we get the selectors for each field.
  var fields = Object.keys(this.rules).reduce(function (prev, r) {
    if (RuleContainer.isTargetRule(r)) {
      prev.push({ selector: this$1.rules[r][0], name: r });
    }

    return prev;
  }, []);

  if (!fields.length || !this.vm || !this.vm.$el) {
    return;
  }

  // must be contained within the same component, so we use the vm root element constrain our dom search.
  fields.forEach(function (ref$1) {
    var selector = ref$1.selector;
    var name = ref$1.name;

    var ref = this$1.vm.$refs[selector];
    var el = Array.isArray(ref) ? ref[0] : ref;
    if (!el) {
      return;
    }

    var options = {
      vm: this$1.vm,
      classes: this$1.classes,
      classNames: this$1.classNames,
      delay: this$1.delay,
      scope: this$1.scope,
      events: this$1.events.join('|'),
      immediate: this$1.immediate,
      targetOf: this$1.id
    };

    // probably a component.
    if (isCallable(el.$watch)) {
      options.component = el;
      options.el = el.$el;
      options.getter = Resolver.resolveGetter(el.$el, el.$vnode);
    } else {
      options.el = el;
      options.getter = Resolver.resolveGetter(el, {});
    }

    this$1.dependencies.push({ name: name, field: new Field(options) });
  });
};

/**
 * Removes listeners.
 */
Field.prototype.unwatch = function unwatch(tag) {
  if (tag === void 0) tag = null;

  if (!tag) {
    this.watchers.forEach(function (w) {
      return w.unwatch();
    });
    this.watchers = [];
    return;
  }

  this.watchers.filter(function (w) {
    return tag.test(w.tag);
  }).forEach(function (w) {
    return w.unwatch();
  });
  this.watchers = this.watchers.filter(function (w) {
    return !tag.test(w.tag);
  });
};

/**
 * Updates the element classes depending on each field flag status.
 */
Field.prototype.updateClasses = function updateClasses(isReset) {
  var this$1 = this;
  if (isReset === void 0) isReset = false;

  if (!this.classes || this.isDisabled) {
    return;
  }
  var applyClasses = function applyClasses(el) {
    toggleClass(el, this$1.classNames.dirty, this$1.flags.dirty);
    toggleClass(el, this$1.classNames.pristine, this$1.flags.pristine);
    toggleClass(el, this$1.classNames.touched, this$1.flags.touched);
    toggleClass(el, this$1.classNames.untouched, this$1.flags.untouched);

    // remove valid/invalid classes on reset.
    if (isReset) {
      toggleClass(el, this$1.classNames.valid, false);
      toggleClass(el, this$1.classNames.invalid, false);
    }

    // make sure we don't set any classes if the state is undetermined.
    if (!isNullOrUndefined(this$1.flags.valid) && this$1.flags.validated) {
      toggleClass(el, this$1.classNames.valid, this$1.flags.valid);
    }

    if (!isNullOrUndefined(this$1.flags.invalid) && this$1.flags.validated) {
      toggleClass(el, this$1.classNames.invalid, this$1.flags.invalid);
    }
  };

  if (!isCheckboxOrRadioInput(this.el)) {
    applyClasses(this.el);
    return;
  }

  var els = document.querySelectorAll("input[name=\"" + this.el.name + "\"]");
  toArray(els).forEach(applyClasses);
};

/**
 * Adds the listeners required for automatic classes and some flags.
 */
Field.prototype.addActionListeners = function addActionListeners() {
  var this$1 = this;

  // remove previous listeners.
  this.unwatch(/class/);

  if (!this.el) {
    return;
  }

  var onBlur = function onBlur() {
    this$1.flags.touched = true;
    this$1.flags.untouched = false;
    if (this$1.classes) {
      toggleClass(this$1.el, this$1.classNames.touched, true);
      toggleClass(this$1.el, this$1.classNames.untouched, false);
    }

    // only needed once.
    this$1.unwatch(/^class_blur$/);
  };

  var inputEvent = isTextInput(this.el) ? 'input' : 'change';
  var onInput = function onInput() {
    this$1.flags.dirty = true;
    this$1.flags.pristine = false;
    if (this$1.classes) {
      toggleClass(this$1.el, this$1.classNames.pristine, false);
      toggleClass(this$1.el, this$1.classNames.dirty, true);
    }

    // only needed once.
    this$1.unwatch(/^class_input$/);
  };

  if (this.componentInstance && isCallable(this.componentInstance.$once)) {
    this.componentInstance.$once('input', onInput);
    this.componentInstance.$once('blur', onBlur);
    this.watchers.push({
      tag: 'class_input',
      unwatch: function unwatch() {
        this$1.componentInstance.$off('input', onInput);
      }
    });
    this.watchers.push({
      tag: 'class_blur',
      unwatch: function unwatch() {
        this$1.componentInstance.$off('blur', onBlur);
      }
    });
    return;
  }

  if (!this.el) {
    return;
  }

  addEventListener(this.el, inputEvent, onInput);
  // Checkboxes and radio buttons on Mac don't emit blur naturally, so we listen on click instead.
  var blurEvent = isCheckboxOrRadioInput(this.el) ? 'change' : 'blur';
  addEventListener(this.el, blurEvent, onBlur);
  this.watchers.push({
    tag: 'class_input',
    unwatch: function unwatch() {
      this$1.el.removeEventListener(inputEvent, onInput);
    }
  });

  this.watchers.push({
    tag: 'class_blur',
    unwatch: function unwatch() {
      this$1.el.removeEventListener(blurEvent, onBlur);
    }
  });
};

Field.prototype.checkValueChanged = function checkValueChanged() {
  // handle some people initialize the value to null, since text inputs have empty string value.
  if (this.initialValue === null && this.value === '' && isTextInput(this.el)) {
    return false;
  }

  return this.value !== this.initialValue;
};

/**
 * Determines the suitable primary event to listen for.
 */
Field.prototype._determineInputEvent = function _determineInputEvent() {
  // if its a custom component, use the customized model event or the input event.
  if (this.componentInstance) {
    return this.componentInstance.$options.model && this.componentInstance.$options.model.event || 'input';
  }

  if (this.model && this.model.lazy) {
    return 'change';
  }

  if (isTextInput(this.el)) {
    return 'input';
  }

  return 'change';
};

/**
 * Determines the list of events to listen to.
 */
Field.prototype._determineEventList = function _determineEventList(defaultInputEvent) {
  var this$1 = this;

  // if no event is configured, or it is a component or a text input then respect the user choice.
  if (!this.events.length || this.componentInstance || isTextInput(this.el)) {
    return [].concat(this.events).map(function (evt) {
      if (evt === 'input' && this$1.model && this$1.model.lazy) {
        return 'change';
      }

      return evt;
    });
  }

  // force suitable event for non-text type fields.
  return this.events.map(function (e) {
    if (e === 'input') {
      return defaultInputEvent;
    }

    return e;
  });
};

/**
 * Adds the listeners required for validation.
 */
Field.prototype.addValueListeners = function addValueListeners() {
  var this$1 = this;

  this.unwatch(/^input_.+/);
  if (!this.listen || !this.el) {
    return;
  }

  var token = { cancelled: false };
  var fn = this.targetOf ? function () {
    var target = this$1.validator._resolveField("#" + this$1.targetOf);
    if (target && target.flags.validated) {
      this$1.validator.validate("#" + this$1.targetOf);
    }
  } : function () {
    var args = [],
        len = arguments.length;
    while (len--) {
      args[len] = arguments[len];
    } // if its a DOM event, resolve the value, otherwise use the first parameter as the value.
    if (args.length === 0 || isEvent(args[0])) {
      args[0] = this$1.value;
    }

    this$1.flags.pending = true;
    this$1._cancellationToken = token;
    this$1.validator.validate("#" + this$1.id, args[0]);
  };

  var inputEvent = this._determineInputEvent();
  var events = this._determineEventList(inputEvent);

  // if on input validation is requested.
  if (includes(events, inputEvent)) {
    var ctx = null;
    var expression = null;
    var watchCtxVm = false;
    // if its watchable from the context vm.
    if (this.model && this.model.expression) {
      ctx = this.vm;
      expression = this.model.expression;
      watchCtxVm = true;
    }

    // watch it from the custom component vm instead.
    if (!expression && this.componentInstance && this.componentInstance.$options.model) {
      ctx = this.componentInstance;
      expression = this.componentInstance.$options.model.prop || 'value';
    }

    if (ctx && expression) {
      var debouncedFn = debounce(fn, this.delay[inputEvent], token);
      var _unwatch = ctx.$watch(expression, debouncedFn);
      this.watchers.push({
        tag: 'input_model',
        unwatch: function unwatch() {
          this$1.vm.$nextTick(function () {
            _unwatch();
          });
        }
      });

      // filter out input event when we are watching from the context vm.
      if (watchCtxVm) {
        events = events.filter(function (e) {
          return e !== inputEvent;
        });
      }
    }
  }

  // Add events.
  events.forEach(function (e) {
    var debouncedFn = debounce(fn, this$1.delay[e], token);

    this$1._addComponentEventListener(e, debouncedFn);
    this$1._addHTMLEventListener(e, debouncedFn);
  });
};

Field.prototype._addComponentEventListener = function _addComponentEventListener(evt, validate) {
  var this$1 = this;

  if (!this.componentInstance) {
    return;
  }

  this.componentInstance.$on(evt, validate);
  this.watchers.push({
    tag: 'input_vue',
    unwatch: function unwatch() {
      this$1.componentInstance.$off(evt, validate);
    }
  });
};

Field.prototype._addHTMLEventListener = function _addHTMLEventListener(evt, validate) {
  var this$1 = this;

  if (!this.el || this.componentInstance) {
    return;
  }

  // listen for the current element.
  var addListener = function addListener(el) {
    addEventListener(el, evt, validate);
    this$1.watchers.push({
      tag: 'input_native',
      unwatch: function unwatch() {
        el.removeEventListener(evt, validate);
      }
    });
  };

  addListener(this.el);
  if (!isCheckboxOrRadioInput(this.el)) {
    return;
  }

  var els = document.querySelectorAll("input[name=\"" + this.el.name + "\"]");
  toArray(els).forEach(function (el) {
    // skip if it is added by v-validate and is not the current element.
    if (el._veeValidateId && el !== this$1.el) {
      return;
    }

    addListener(el);
  });
};

/**
 * Updates aria attributes on the element.
 */
Field.prototype.updateAriaAttrs = function updateAriaAttrs() {
  var this$1 = this;

  if (!this.aria || !this.el || !isCallable(this.el.setAttribute)) {
    return;
  }

  var applyAriaAttrs = function applyAriaAttrs(el) {
    el.setAttribute('aria-required', this$1.isRequired ? 'true' : 'false');
    el.setAttribute('aria-invalid', this$1.flags.invalid ? 'true' : 'false');
  };

  if (!isCheckboxOrRadioInput(this.el)) {
    applyAriaAttrs(this.el);
    return;
  }

  var els = document.querySelectorAll("input[name=\"" + this.el.name + "\"]");
  toArray(els).forEach(applyAriaAttrs);
};

/**
 * Updates the custom validity for the field.
 */
Field.prototype.updateCustomValidity = function updateCustomValidity() {
  if (!this.validity || !this.el || !isCallable(this.el.setCustomValidity) || !this.validator.errors) {
    return;
  }

  this.el.setCustomValidity(this.flags.valid ? '' : this.validator.errors.firstById(this.id) || '');
};

/**
 * Removes all listeners.
 */
Field.prototype.destroy = function destroy() {
  // ignore the result of any ongoing validation.
  if (this._cancellationToken) {
    this._cancellationToken.cancelled = true;
  }

  this.unwatch();
  this.dependencies.forEach(function (d) {
    return d.field.destroy();
  });
  this.dependencies = [];
};

Object.defineProperties(Field.prototype, prototypeAccessors$1);

// 

var FieldBag = function FieldBag(items) {
  if (items === void 0) items = [];

  this.items = items || [];
  this.itemsById = this.items.reduce(function (itemsById, item) {
    itemsById[item.id] = item;
    return itemsById;
  }, {});
};

var prototypeAccessors$2 = { length: { configurable: true } };

FieldBag.prototype[typeof Symbol === 'function' ? Symbol.iterator : '@@iterator'] = function () {
  var this$1 = this;

  var index = 0;
  return {
    next: function next() {
      return { value: this$1.items[index++], done: index > this$1.items.length };
    }
  };
};

/**
 * Gets the current items length.
 */

prototypeAccessors$2.length.get = function () {
  return this.items.length;
};

/**
 * Finds the first field that matches the provided matcher object.
 */
FieldBag.prototype.find = function find$1(matcher) {
  return find(this.items, function (item) {
    return item.matches(matcher);
  });
};

/**
 * Finds the field with the given id, using a plain object as a map to link
 * ids to items faster than by looping over the array and matching.
 */
FieldBag.prototype.findById = function findById(id) {
  return this.itemsById[id] || null;
};

/**
 * Filters the items down to the matched fields.
 */
FieldBag.prototype.filter = function filter(matcher) {
  // multiple matchers to be tried.
  if (Array.isArray(matcher)) {
    return this.items.filter(function (item) {
      return matcher.some(function (m) {
        return item.matches(m);
      });
    });
  }

  return this.items.filter(function (item) {
    return item.matches(matcher);
  });
};

/**
 * Maps the field items using the mapping function.
 */
FieldBag.prototype.map = function map(mapper) {
  return this.items.map(mapper);
};

/**
 * Finds and removes the first field that matches the provided matcher object, returns the removed item.
 */
FieldBag.prototype.remove = function remove(matcher) {
  var item = null;
  if (matcher instanceof Field) {
    item = matcher;
  } else {
    item = this.find(matcher);
  }

  if (!item) {
    return null;
  }

  var index = this.items.indexOf(item);
  this.items.splice(index, 1);
  delete this.itemsById[item.id];

  return item;
};

/**
 * Adds a field item to the list.
 */
FieldBag.prototype.push = function push(item) {
  if (!(item instanceof Field)) {
    throw createError('FieldBag only accepts instances of Field that has an id defined.');
  }

  if (!item.id) {
    throw createError('Field id must be defined.');
  }

  if (this.findById(item.id)) {
    throw createError("Field with id " + item.id + " is already added.");
  }

  this.items.push(item);
  this.itemsById[item.id] = item;
};

Object.defineProperties(FieldBag.prototype, prototypeAccessors$2);

var ScopedValidator = function ScopedValidator(base, vm) {
  this.id = vm._uid;
  this._base = base;
  this._paused = false;

  // create a mirror bag with limited component scope.
  this.errors = new ErrorBag(base.errors, this.id);
};

var prototypeAccessors$3 = { flags: { configurable: true }, rules: { configurable: true }, fields: { configurable: true }, dictionary: { configurable: true }, locale: { configurable: true } };

prototypeAccessors$3.flags.get = function () {
  var this$1 = this;

  return this._base.fields.items.filter(function (f) {
    return f.vmId === this$1.id;
  }).reduce(function (acc, field) {
    if (field.scope) {
      if (!acc["$" + field.scope]) {
        acc["$" + field.scope] = {};
      }

      acc["$" + field.scope][field.name] = field.flags;
    }

    acc[field.name] = field.flags;

    return acc;
  }, {});
};

prototypeAccessors$3.rules.get = function () {
  return this._base.rules;
};

prototypeAccessors$3.fields.get = function () {
  return new FieldBag(this._base.fields.filter({ vmId: this.id }));
};

prototypeAccessors$3.dictionary.get = function () {
  return this._base.dictionary;
};

prototypeAccessors$3.locale.get = function () {
  return this._base.locale;
};

prototypeAccessors$3.locale.set = function (val) {
  this._base.locale = val;
};

ScopedValidator.prototype.localize = function localize() {
  var ref;

  var args = [],
      len = arguments.length;
  while (len--) {
    args[len] = arguments[len];
  }return (ref = this._base).localize.apply(ref, args);
};

ScopedValidator.prototype.update = function update() {
  var ref;

  var args = [],
      len = arguments.length;
  while (len--) {
    args[len] = arguments[len];
  }return (ref = this._base).update.apply(ref, args);
};

ScopedValidator.prototype.attach = function attach(opts) {
  var attachOpts = assign({}, opts, { vmId: this.id });

  return this._base.attach(attachOpts);
};

ScopedValidator.prototype.pause = function pause() {
  this._paused = true;
};

ScopedValidator.prototype.resume = function resume() {
  this._paused = false;
};

ScopedValidator.prototype.remove = function remove(ruleName) {
  return this._base.remove(ruleName);
};

ScopedValidator.prototype.detach = function detach(name, scope) {
  return this._base.detach(name, scope, this.id);
};

ScopedValidator.prototype.extend = function extend() {
  var ref;

  var args = [],
      len = arguments.length;
  while (len--) {
    args[len] = arguments[len];
  }return (ref = this._base).extend.apply(ref, args);
};

ScopedValidator.prototype.validate = function validate(descriptor, value, opts) {
  if (opts === void 0) opts = {};

  if (this._paused) {
    return Promise.resolve(true);
  }

  return this._base.validate(descriptor, value, assign({}, { vmId: this.id }, opts || {}));
};

ScopedValidator.prototype.verify = function verify() {
  var ref;

  var args = [],
      len = arguments.length;
  while (len--) {
    args[len] = arguments[len];
  }return (ref = this._base).verify.apply(ref, args);
};

ScopedValidator.prototype.validateAll = function validateAll(values, opts) {
  if (opts === void 0) opts = {};

  if (this._paused) {
    return Promise.resolve(true);
  }

  return this._base.validateAll(values, assign({}, { vmId: this.id }, opts || {}));
};

ScopedValidator.prototype.validateScopes = function validateScopes(opts) {
  if (opts === void 0) opts = {};

  if (this._paused) {
    return Promise.resolve(true);
  }

  return this._base.validateScopes(assign({}, { vmId: this.id }, opts || {}));
};

ScopedValidator.prototype.destroy = function destroy() {
  delete this.id;
  delete this._base;
};

ScopedValidator.prototype.reset = function reset(matcher) {
  return this._base.reset(Object.assign({}, matcher || {}, { vmId: this.id }));
};

ScopedValidator.prototype.flag = function flag() {
  var ref;

  var args = [],
      len = arguments.length;
  while (len--) {
    args[len] = arguments[len];
  }return (ref = this._base).flag.apply(ref, args.concat([this.id]));
};

ScopedValidator.prototype._resolveField = function _resolveField() {
  var ref;

  var args = [],
      len = arguments.length;
  while (len--) {
    args[len] = arguments[len];
  }return (ref = this._base)._resolveField.apply(ref, args);
};

Object.defineProperties(ScopedValidator.prototype, prototypeAccessors$3);

var VALIDATOR = null;

var getValidator = function getValidator() {
  return VALIDATOR;
};

var setValidator = function setValidator(value) {
  VALIDATOR = value;

  return value;
};

// 

/**
 * Checks if a parent validator instance was requested.
 */
var requestsValidator = function requestsValidator(injections) {
  if (isObject(injections) && injections.$validator) {
    return true;
  }

  return false;
};

var mixin = {
  provide: function provide() {
    if (this.$validator && !isBuiltInComponent(this.$vnode)) {
      return {
        $validator: this.$validator
      };
    }

    return {};
  },
  beforeCreate: function beforeCreate() {
    // if built in do nothing.
    if (isBuiltInComponent(this.$vnode) || this.$options.$__veeInject === false) {
      return;
    }

    // if its a root instance set the config if it exists.
    if (!this.$parent) {
      setConfig(this.$options.$_veeValidate || {});
    }

    var options = resolveConfig(this);

    // if its a root instance, inject anyways, or if it requested a new instance.
    if (!this.$parent || this.$options.$_veeValidate && /new/.test(this.$options.$_veeValidate.validator)) {
      this.$validator = new ScopedValidator(getValidator(), this);
    }

    var requested = requestsValidator(this.$options.inject);

    // if automatic injection is enabled and no instance was requested.
    if (!this.$validator && options.inject && !requested) {
      this.$validator = new ScopedValidator(getValidator(), this);
    }

    // don't inject errors or fieldBag as no validator was resolved.
    if (!requested && !this.$validator) {
      return;
    }

    // There is a validator but it isn't injected, mark as reactive.
    if (!requested && this.$validator) {
      var Vue = this.$options._base; // the vue constructor.
      Vue.util.defineReactive(this.$validator, 'errors', this.$validator.errors);
    }

    if (!this.$options.computed) {
      this.$options.computed = {};
    }

    this.$options.computed[options.errorBagName || 'errors'] = function errorBagGetter() {
      return this.$validator.errors;
    };
    this.$options.computed[options.fieldsBagName || 'fields'] = function fieldBagGetter() {
      return this.$validator.fields.items.reduce(function (acc, field) {
        if (field.scope) {
          if (!acc["$" + field.scope]) {
            acc["$" + field.scope] = {};
          }

          acc["$" + field.scope][field.name] = field.flags;

          return acc;
        }

        acc[field.name] = field.flags;

        return acc;
      }, {});
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$validator && this._uid === this.$validator.id) {
      this.$validator.errors.clear(); // remove errors generated by this component.
    }
  }
};

// 

/**
 * Finds the requested field by id from the context object.
 */
function findField(el, context) {
  if (!context || !context.$validator) {
    return null;
  }

  return context.$validator.fields.findById(el._veeValidateId);
}
var directive = {
  bind: function bind(el, binding, vnode) {
    var validator = vnode.context.$validator;
    if (!validator) {
      if (false) {
        warn("No validator instance is present on vm, did you forget to inject '$validator'?");
      }

      return;
    }

    var fieldOptions = Resolver.generate(el, binding, vnode);
    validator.attach(fieldOptions);
  },
  inserted: function inserted(el, binding, vnode) {
    var field = findField(el, vnode.context);
    var scope = Resolver.resolveScope(el, binding, vnode);

    // skip if scope hasn't changed.
    if (!field || scope === field.scope) {
      return;
    }

    // only update scope.
    field.update({ scope: scope });

    // allows the field to re-evaluated once more in the update hook.
    field.updated = false;
  },
  update: function update(el, binding, vnode) {
    var field = findField(el, vnode.context);

    // make sure we don't do unneccasary work if no important change was done.
    if (!field || field.updated && isEqual(binding.value, binding.oldValue)) {
      return;
    }
    var scope = Resolver.resolveScope(el, binding, vnode);
    var rules = Resolver.resolveRules(el, binding, vnode);

    field.update({
      scope: scope,
      rules: rules
    });
  },
  unbind: function unbind(el, binding, ref) {
    var context = ref.context;

    var field = findField(el, context);
    if (!field) {
      return;
    }

    context.$validator.detach(field);
  }
};

// 

var Validator = function Validator(validations, options, pluginContainer) {
  if (options === void 0) options = { fastExit: true };
  if (pluginContainer === void 0) pluginContainer = null;

  this.errors = new ErrorBag();
  this.fields = new FieldBag();
  this._createFields(validations);
  this.paused = false;
  this.fastExit = !isNullOrUndefined(options && options.fastExit) ? options.fastExit : true;
  this.$vee = pluginContainer || {
    _vm: {
      $nextTick: function $nextTick(cb) {
        return isCallable(cb) ? cb() : Promise.resolve();
      },
      $emit: function $emit() {},
      $off: function $off() {}
    }
  };
};

var prototypeAccessors$4 = { rules: { configurable: true }, dictionary: { configurable: true }, flags: { configurable: true }, locale: { configurable: true } };
var staticAccessors$1 = { rules: { configurable: true }, dictionary: { configurable: true }, locale: { configurable: true } };

/**
 * @deprecated
 */
staticAccessors$1.rules.get = function () {
  if (false) {
    warn('this accessor will be deprecated, use `import { rules } from "vee-validate"` instead.');
  }

  return RuleContainer.rules;
};

/**
 * @deprecated
 */
prototypeAccessors$4.rules.get = function () {
  if (false) {
    warn('this accessor will be deprecated, use `import { rules } from "vee-validate"` instead.');
  }

  return RuleContainer.rules;
};

prototypeAccessors$4.dictionary.get = function () {
  return DictionaryResolver.getDriver();
};

staticAccessors$1.dictionary.get = function () {
  return DictionaryResolver.getDriver();
};

prototypeAccessors$4.flags.get = function () {
  return this.fields.items.reduce(function (acc, field) {
    var obj;

    if (field.scope) {
      acc["$" + field.scope] = (obj = {}, obj[field.name] = field.flags, obj);

      return acc;
    }

    acc[field.name] = field.flags;

    return acc;
  }, {});
};

/**
 * Getter for the current locale.
 */
prototypeAccessors$4.locale.get = function () {
  return Validator.locale;
};

/**
 * Setter for the validator locale.
 */
prototypeAccessors$4.locale.set = function (value) {
  Validator.locale = value;
};

staticAccessors$1.locale.get = function () {
  return DictionaryResolver.getDriver().locale;
};

/**
 * Setter for the validator locale.
 */
staticAccessors$1.locale.set = function (value) {
  var hasChanged = value !== DictionaryResolver.getDriver().locale;
  DictionaryResolver.getDriver().locale = value;
  if (hasChanged && Validator.$vee && Validator.$vee._vm) {
    Validator.$vee._vm.$emit('localeChanged');
  }
};

/**
 * Static constructor.
 * @deprecated
 */
Validator.create = function create(validations, options) {
  if (false) {
    warn('Please use `new` to create new validator instances.');
  }

  return new Validator(validations, options);
};

/**
 * Adds a custom validator to the list of validation rules.
 */
Validator.extend = function extend(name, validator, options) {
  if (options === void 0) options = {};

  Validator._guardExtend(name, validator);
  // rules imported from the minimal bundle
  // will have the options embedded in them
  var mergedOpts = validator.options || {};
  Validator._merge(name, {
    validator: validator,
    paramNames: options && options.paramNames || validator.paramNames,
    options: assign({ hasTarget: false, immediate: true }, mergedOpts, options || {})
  });
};

/**
 * Removes a rule from the list of validators.
 * @deprecated
 */
Validator.remove = function remove(name) {
  if (false) {
    warn('this method will be deprecated, you can still override your rules with `extend`');
  }

  RuleContainer.remove(name);
};

/**
 * Adds and sets the current locale for the validator.
*/
Validator.prototype.localize = function localize(lang, dictionary) {
  Validator.localize(lang, dictionary);
};

/**
 * Adds and sets the current locale for the validator.
 */
Validator.localize = function localize(lang, dictionary) {
  var obj;

  if (isObject(lang)) {
    DictionaryResolver.getDriver().merge(lang);
    return;
  }

  // merge the dictionary.
  if (dictionary) {
    var locale = lang || dictionary.name;
    dictionary = assign({}, dictionary);
    DictionaryResolver.getDriver().merge((obj = {}, obj[locale] = dictionary, obj));
  }

  if (lang) {
    // set the locale.
    Validator.locale = lang;
  }
};

/**
 * Registers a field to be validated.
 */
Validator.prototype.attach = function attach(fieldOpts) {
  var this$1 = this;

  // We search for a field with the same name & scope, having persist enabled
  var oldFieldMatcher = { name: fieldOpts.name, scope: fieldOpts.scope, persist: true };
  var oldField = fieldOpts.persist ? this.fields.find(oldFieldMatcher) : null;

  if (oldField) {
    // We keep the flags of the old field, then we remove its instance
    fieldOpts.flags = oldField.flags;
    oldField.destroy();
    this.fields.remove(oldField);
  }

  // fixes initial value detection with v-model and select elements.
  var value = fieldOpts.initialValue;
  var field = new Field(fieldOpts);
  this.fields.push(field);

  // validate the field initially
  if (field.immediate) {
    this.$vee._vm.$nextTick(function () {
      return this$1.validate("#" + field.id, value || field.value, { vmId: fieldOpts.vmId });
    });
  } else {
    this._validate(field, value || field.value, { initial: true }).then(function (result) {
      field.flags.valid = result.valid;
      field.flags.invalid = !result.valid;
    });
  }

  return field;
};

/**
 * Sets the flags on a field.
 */
Validator.prototype.flag = function flag(name, flags, uid) {
  if (uid === void 0) uid = null;

  var field = this._resolveField(name, undefined, uid);
  if (!field || !flags) {
    return;
  }

  field.setFlags(flags);
};

/**
 * Removes a field from the validator.
 */
Validator.prototype.detach = function detach(name, scope, uid) {
  var field = isCallable(name.destroy) ? name : this._resolveField(name, scope, uid);
  if (!field) {
    return;
  }

  // We destroy/remove the field & error instances if it's not a `persist` one
  if (!field.persist) {
    field.destroy();
    this.errors.remove(field.name, field.scope, field.vmId);
    this.fields.remove(field);
  }
};

/**
 * Adds a custom validator to the list of validation rules.
 */
Validator.prototype.extend = function extend(name, validator, options) {
  if (options === void 0) options = {};

  Validator.extend(name, validator, options);
};

Validator.prototype.reset = function reset(matcher) {
  var this$1 = this;

  // two ticks
  return this.$vee._vm.$nextTick().then(function () {
    return this$1.$vee._vm.$nextTick();
  }).then(function () {
    this$1.fields.filter(matcher).forEach(function (field) {
      field.waitFor(null);
      field.reset(); // reset field flags.
      this$1.errors.remove(field.name, field.scope, matcher && matcher.vmId);
    });
  });
};

/**
 * Updates a field, updating both errors and flags.
 */
Validator.prototype.update = function update(id, ref) {
  var scope = ref.scope;

  var field = this._resolveField("#" + id);
  if (!field) {
    return;
  }

  // remove old scope.
  this.errors.update(id, { scope: scope });
};

/**
 * Removes a rule from the list of validators.
 * @deprecated
 */
Validator.prototype.remove = function remove(name) {
  Validator.remove(name);
};

/**
 * Validates a value against a registered field validations.
 */
Validator.prototype.validate = function validate(fieldDescriptor, value, ref) {
  var this$1 = this;
  if (ref === void 0) ref = {};
  var silent = ref.silent;
  var vmId = ref.vmId;

  if (this.paused) {
    return Promise.resolve(true);
  }

  // overload to validate all.
  if (isNullOrUndefined(fieldDescriptor)) {
    return this.validateScopes({ silent: silent, vmId: vmId });
  }

  // overload to validate scope-less fields.
  if (fieldDescriptor === '*') {
    return this.validateAll(undefined, { silent: silent, vmId: vmId });
  }

  // if scope validation was requested.
  if (/^(.+)\.\*$/.test(fieldDescriptor)) {
    var matched = fieldDescriptor.match(/^(.+)\.\*$/)[1];
    return this.validateAll(matched);
  }

  var field = this._resolveField(fieldDescriptor);
  if (!field) {
    return this._handleFieldNotFound(fieldDescriptor);
  }

  if (!silent) {
    field.flags.pending = true;
  }
  if (value === undefined) {
    value = field.value;
  }

  var validationPromise = this._validate(field, value);
  field.waitFor(validationPromise);

  return validationPromise.then(function (result) {
    if (!silent && field.isWaitingFor(validationPromise)) {
      // allow next validation to mutate the state.
      field.waitFor(null);
      this$1._handleValidationResults([result], vmId);
    }

    return result.valid;
  });
};

/**
 * Pauses the validator.
 */
Validator.prototype.pause = function pause() {
  this.paused = true;

  return this;
};

/**
 * Resumes the validator.
 */
Validator.prototype.resume = function resume() {
  this.paused = false;

  return this;
};

/**
 * Validates each value against the corresponding field validations.
 */
Validator.prototype.validateAll = function validateAll(values, ref) {
  var this$1 = this;
  if (ref === void 0) ref = {};
  var silent = ref.silent;
  var vmId = ref.vmId;

  if (this.paused) {
    return Promise.resolve(true);
  }

  var matcher = null;
  var providedValues = false;

  if (typeof values === 'string') {
    matcher = { scope: values, vmId: vmId };
  } else if (isObject(values)) {
    matcher = Object.keys(values).map(function (key) {
      return { name: key, vmId: vmId, scope: null };
    });
    providedValues = true;
  } else if (Array.isArray(values)) {
    matcher = values.map(function (key) {
      return (typeof key === 'undefined' ? 'undefined' : _typeof2(key)) === 'object' ? Object.assign({ vmId: vmId }, key) : { name: key, vmId: vmId };
    });
  } else {
    matcher = { scope: null, vmId: vmId };
  }

  return Promise.all(this.fields.filter(matcher).map(function (field) {
    return this$1._validate(field, providedValues ? values[field.name] : field.value);
  })).then(function (results) {
    if (!silent) {
      this$1._handleValidationResults(results, vmId);
    }

    return results.every(function (t) {
      return t.valid;
    });
  });
};

/**
 * Validates all scopes.
 */
Validator.prototype.validateScopes = function validateScopes(ref) {
  var this$1 = this;
  if (ref === void 0) ref = {};
  var silent = ref.silent;
  var vmId = ref.vmId;

  if (this.paused) {
    return Promise.resolve(true);
  }

  return Promise.all(this.fields.filter({ vmId: vmId }).map(function (field) {
    return this$1._validate(field, field.value);
  })).then(function (results) {
    if (!silent) {
      this$1._handleValidationResults(results, vmId);
    }

    return results.every(function (t) {
      return t.valid;
    });
  });
};

/**
 * Validates a value against the rules.
 */
Validator.prototype.verify = function verify(value, rules, options) {
  if (options === void 0) options = {};

  var field = {
    name: options && options.name || '{field}',
    rules: normalizeRules(rules),
    bails: getPath('bails', options, true),
    forceRequired: false,
    get isRequired() {
      return !!this.rules.required || this.forceRequired;
    }
  };

  var targetRules = Object.keys(field.rules).filter(RuleContainer.isTargetRule);
  if (targetRules.length && options && isObject(options.values)) {
    field.dependencies = targetRules.map(function (rule) {
      var ref = field.rules[rule];
      var targetKey = ref[0];

      return {
        name: rule,
        field: { value: options.values[targetKey] }
      };
    });
  }

  return this._validate(field, value).then(function (result) {
    var errors = [];
    var ruleMap = {};
    result.errors.forEach(function (e) {
      errors.push(e.msg);
      ruleMap[e.rule] = e.msg;
    });

    return {
      valid: result.valid,
      errors: errors,
      failedRules: ruleMap
    };
  });
};

/**
 * Perform cleanup.
 */
Validator.prototype.destroy = function destroy() {
  this.$vee._vm.$off('localeChanged');
};

/**
 * Creates the fields to be validated.
 */
Validator.prototype._createFields = function _createFields(validations) {
  var this$1 = this;

  if (!validations) {
    return;
  }

  Object.keys(validations).forEach(function (field) {
    var options = assign({}, { name: field, rules: validations[field] });
    this$1.attach(options);
  });
};

/**
 * Date rules need the existence of a format, so date_format must be supplied.
 */
Validator.prototype._getDateFormat = function _getDateFormat(validations) {
  var format = null;
  if (validations.date_format && Array.isArray(validations.date_format)) {
    format = validations.date_format[0];
  }

  return format || DictionaryResolver.getDriver().getDateFormat(this.locale);
};

/**
 * Formats an error message for field and a rule.
 */
Validator.prototype._formatErrorMessage = function _formatErrorMessage(field, rule, data, targetName) {
  if (data === void 0) data = {};
  if (targetName === void 0) targetName = null;

  var name = this._getFieldDisplayName(field);
  var params = this._getLocalizedParams(rule, targetName);

  return DictionaryResolver.getDriver().getFieldMessage(this.locale, field.name, rule.name, [name, params, data]);
};

/**
 * We need to convert any object param to an array format since the locales do not handle params as objects yet.
 */
Validator.prototype._convertParamObjectToArray = function _convertParamObjectToArray(obj, ruleName) {
  if (Array.isArray(obj)) {
    return obj;
  }

  var paramNames = RuleContainer.getParamNames(ruleName);
  if (!paramNames || !isObject(obj)) {
    return obj;
  }

  return paramNames.reduce(function (prev, paramName) {
    if (paramName in obj) {
      prev.push(obj[paramName]);
    }

    return prev;
  }, []);
};

/**
 * Translates the parameters passed to the rule (mainly for target fields).
 */
Validator.prototype._getLocalizedParams = function _getLocalizedParams(rule, targetName) {
  if (targetName === void 0) targetName = null;

  var params = this._convertParamObjectToArray(rule.params, rule.name);
  if (rule.options.hasTarget && params && params[0]) {
    var localizedName = targetName || DictionaryResolver.getDriver().getAttribute(this.locale, params[0], params[0]);
    return [localizedName].concat(params.slice(1));
  }

  return params;
};

/**
 * Resolves an appropriate display name, first checking 'data-as' or the registered 'prettyName'
 */
Validator.prototype._getFieldDisplayName = function _getFieldDisplayName(field) {
  return field.alias || DictionaryResolver.getDriver().getAttribute(this.locale, field.name, field.name);
};

/**
 * Converts an array of params to an object with named properties.
 * Only works if the rule is configured with a paramNames array.
 * Returns the same params if it cannot convert it.
 */
Validator.prototype._convertParamArrayToObj = function _convertParamArrayToObj(params, ruleName) {
  var paramNames = RuleContainer.getParamNames(ruleName);
  if (!paramNames) {
    return params;
  }

  if (isObject(params)) {
    // check if the object is either a config object or a single parameter that is an object.
    var hasKeys = paramNames.some(function (name) {
      return Object.keys(params).indexOf(name) !== -1;
    });
    // if it has some of the keys, return it as is.
    if (hasKeys) {
      return params;
    }
    // otherwise wrap the object in an array.
    params = [params];
  }

  // Reduce the paramsNames to a param object.
  return params.reduce(function (prev, value, idx) {
    prev[paramNames[idx]] = value;

    return prev;
  }, {});
};

/**
 * Tests a single input value against a rule.
 */
Validator.prototype._test = function _test(field, value, rule) {
  var this$1 = this;

  var validator = RuleContainer.getValidatorMethod(rule.name);
  var params = Array.isArray(rule.params) ? toArray(rule.params) : rule.params;
  if (!params) {
    params = [];
  }

  var targetName = null;
  if (!validator || typeof validator !== 'function') {
    return Promise.reject(createError("No such validator '" + rule.name + "' exists."));
  }

  // has field dependencies.
  if (rule.options.hasTarget && field.dependencies) {
    var target = find(field.dependencies, function (d) {
      return d.name === rule.name;
    });
    if (target) {
      targetName = target.field.alias;
      params = [target.field.value].concat(params.slice(1));
    }
  } else if (rule.name === 'required' && field.rejectsFalse) {
    // invalidate false if no args were specified and the field rejects false by default.
    params = params.length ? params : [true];
  }

  if (rule.options.isDate) {
    var dateFormat = this._getDateFormat(field.rules);
    if (rule.name !== 'date_format') {
      params.push(dateFormat);
    }
  }

  var result = validator(value, this._convertParamArrayToObj(params, rule.name));

  // If it is a promise.
  if (isCallable(result.then)) {
    return result.then(function (values) {
      var allValid = true;
      var data = {};
      if (Array.isArray(values)) {
        allValid = values.every(function (t) {
          return isObject(t) ? t.valid : t;
        });
      } else {
        // Is a single object/boolean.
        allValid = isObject(values) ? values.valid : values;
        data = values.data;
      }

      return {
        valid: allValid,
        data: result.data,
        errors: allValid ? [] : [this$1._createFieldError(field, rule, data, targetName)]
      };
    });
  }

  if (!isObject(result)) {
    result = { valid: result, data: {} };
  }

  return {
    valid: result.valid,
    data: result.data,
    errors: result.valid ? [] : [this._createFieldError(field, rule, result.data, targetName)]
  };
};

/**
 * Merges a validator object into the RULES and Messages.
 */
Validator._merge = function _merge(name, ref) {
  var validator = ref.validator;
  var options = ref.options;
  var paramNames = ref.paramNames;

  var validate = isCallable(validator) ? validator : validator.validate;
  if (validator.getMessage) {
    DictionaryResolver.getDriver().setMessage(Validator.locale, name, validator.getMessage);
  }

  RuleContainer.add(name, {
    validate: validate,
    options: options,
    paramNames: paramNames
  });
};

/**
 * Guards from extension violations.
 */
Validator._guardExtend = function _guardExtend(name, validator) {
  if (isCallable(validator)) {
    return;
  }

  if (!isCallable(validator.validate)) {
    throw createError("Extension Error: The validator '" + name + "' must be a function or have a 'validate' method.");
  }
};

/**
 * Creates a Field Error Object.
 */
Validator.prototype._createFieldError = function _createFieldError(field, rule, data, targetName) {
  var this$1 = this;

  return {
    id: field.id,
    vmId: field.vmId,
    field: field.name,
    msg: this._formatErrorMessage(field, rule, data, targetName),
    rule: rule.name,
    scope: field.scope,
    regenerate: function regenerate() {
      return this$1._formatErrorMessage(field, rule, data, targetName);
    }
  };
};

/**
 * Tries different strategies to find a field.
 */
Validator.prototype._resolveField = function _resolveField(name, scope, uid) {
  if (name[0] === '#') {
    return this.fields.findById(name.slice(1));
  }

  if (!isNullOrUndefined(scope)) {
    return this.fields.find({ name: name, scope: scope, vmId: uid });
  }

  if (includes(name, '.')) {
    var ref = name.split('.');
    var fieldScope = ref[0];
    var fieldName = ref.slice(1);
    var field = this.fields.find({ name: fieldName.join('.'), scope: fieldScope, vmId: uid });
    if (field) {
      return field;
    }
  }

  return this.fields.find({ name: name, scope: null, vmId: uid });
};

/**
 * Handles when a field is not found.
 */
Validator.prototype._handleFieldNotFound = function _handleFieldNotFound(name, scope) {
  var fullName = isNullOrUndefined(scope) ? name : "" + (!isNullOrUndefined(scope) ? scope + '.' : '') + name;

  return Promise.reject(createError("Validating a non-existent field: \"" + fullName + "\". Use \"attach()\" first."));
};

/**
 * Handles validation results.
 */
Validator.prototype._handleValidationResults = function _handleValidationResults(results, vmId) {
  var this$1 = this;

  var matchers = results.map(function (result) {
    return { id: result.id };
  });
  this.errors.removeById(matchers.map(function (m) {
    return m.id;
  }));
  // remove by name and scope to remove any custom errors added.
  results.forEach(function (result) {
    this$1.errors.remove(result.field, result.scope, vmId);
  });
  var allErrors = results.reduce(function (prev, curr) {
    prev.push.apply(prev, curr.errors);

    return prev;
  }, []);

  this.errors.add(allErrors);

  // handle flags.
  this.fields.filter(matchers).forEach(function (field) {
    var result = find(results, function (r) {
      return r.id === field.id;
    });
    field.setFlags({
      pending: false,
      valid: result.valid,
      validated: true
    });
  });
};

Validator.prototype._shouldSkip = function _shouldSkip(field, value) {
  // field is configured to run through the pipeline regardless
  if (field.bails === false) {
    return false;
  }

  // disabled fields are skipped if useConstraintAttrs is enabled in config
  if (field.isDisabled && getConfig().useConstraintAttrs) {
    return true;
  }

  // skip if the field is not required and has an empty value.
  return !field.isRequired && (isNullOrUndefined(value) || value === '' || isEmptyArray(value));
};

Validator.prototype._shouldBail = function _shouldBail(field) {
  // if the field was configured explicitly.
  if (field.bails !== undefined) {
    return field.bails;
  }

  return this.fastExit;
};

/**
 * Starts the validation process.
 */
Validator.prototype._validate = function _validate(field, value, ref) {
  var this$1 = this;
  if (ref === void 0) ref = {};
  var initial = ref.initial;

  var requireRules = Object.keys(field.rules).filter(RuleContainer.isRequireRule);

  field.forceRequired = false;
  requireRules.forEach(function (rule) {
    var ruleOptions = RuleContainer.getOptions(rule);
    var result = this$1._test(field, value, { name: rule, params: field.rules[rule], options: ruleOptions });

    if (isCallable(result.then)) {
      throw createError('Require rules cannot be async');
    }
    if (!isObject(result)) {
      throw createError('Require rules has to return an object (see docs)');
    }

    if (result.data.required === true) {
      field.forceRequired = true;
    }
  });

  if (this._shouldSkip(field, value)) {
    return Promise.resolve({ valid: true, id: field.id, field: field.name, scope: field.scope, errors: [] });
  }

  var promises = [];
  var errors = [];
  var isExitEarly = false;
  if (isCallable(field.checkValueChanged)) {
    field.flags.changed = field.checkValueChanged();
  }

  // use of '.some()' is to break iteration in middle by returning true
  Object.keys(field.rules).filter(function (rule) {
    if (!initial || !RuleContainer.has(rule)) {
      return true;
    }

    return RuleContainer.isImmediate(rule);
  }).some(function (rule) {
    var ruleOptions = RuleContainer.getOptions(rule);
    var result = this$1._test(field, value, { name: rule, params: field.rules[rule], options: ruleOptions });
    if (isCallable(result.then)) {
      promises.push(result);
    } else if (!result.valid && this$1._shouldBail(field)) {
      errors.push.apply(errors, result.errors);
      isExitEarly = true;
    } else {
      // promisify the result.
      promises.push(new Promise(function (resolve) {
        return resolve(result);
      }));
    }

    return isExitEarly;
  });

  if (isExitEarly) {
    return Promise.resolve({ valid: false, errors: errors, id: field.id, field: field.name, scope: field.scope });
  }

  return Promise.all(promises).then(function (results) {
    return results.reduce(function (prev, v) {
      var ref;

      if (!v.valid) {
        (ref = prev.errors).push.apply(ref, v.errors);
      }

      prev.valid = prev.valid && v.valid;

      return prev;
    }, { valid: true, errors: errors, id: field.id, field: field.name, scope: field.scope });
  });
};

Object.defineProperties(Validator.prototype, prototypeAccessors$4);
Object.defineProperties(Validator, staticAccessors$1);

// 

var normalizeValue = function normalizeValue(value) {
  if (isObject(value)) {
    return Object.keys(value).reduce(function (prev, key) {
      prev[key] = normalizeValue(value[key]);

      return prev;
    }, {});
  }

  if (isCallable(value)) {
    return value('{0}', ['{1}', '{2}', '{3}']);
  }

  return value;
};

var normalizeFormat = function normalizeFormat(locale) {
  // normalize messages
  var dictionary = {};
  if (locale.messages) {
    dictionary.messages = normalizeValue(locale.messages);
  }

  if (locale.custom) {
    dictionary.custom = normalizeValue(locale.custom);
  }

  if (locale.attributes) {
    dictionary.attributes = locale.attributes;
  }

  if (!isNullOrUndefined(locale.dateFormat)) {
    dictionary.dateFormat = locale.dateFormat;
  }

  return dictionary;
};

var I18nDictionary = function I18nDictionary(i18n, rootKey) {
  this.i18n = i18n;
  this.rootKey = rootKey;
};

var prototypeAccessors$5 = { locale: { configurable: true } };

prototypeAccessors$5.locale.get = function () {
  return this.i18n.locale;
};

prototypeAccessors$5.locale.set = function (value) {
  warn('Cannot set locale from the validator when using vue-i18n, use i18n.locale setter instead');
};

I18nDictionary.prototype.getDateFormat = function getDateFormat(locale) {
  return this.i18n.getDateTimeFormat(locale || this.locale);
};

I18nDictionary.prototype.setDateFormat = function setDateFormat(locale, value) {
  this.i18n.setDateTimeFormat(locale || this.locale, value);
};

I18nDictionary.prototype.getMessage = function getMessage(_, key, data) {
  var path = this.rootKey + ".messages." + key;
  var dataOptions = data;

  if (Array.isArray(data)) {
    dataOptions = [].concat.apply([], data);
  }

  if (this.i18n.te(path)) {
    return this.i18n.t(path, dataOptions);
  }

  // fallback to the fallback message
  if (this.i18n.te(path, this.i18n.fallbackLocale)) {
    return this.i18n.t(path, this.i18n.fallbackLocale, dataOptions);
  }

  // fallback to the root message
  return this.i18n.t(this.rootKey + ".messages._default", dataOptions);
};

I18nDictionary.prototype.getAttribute = function getAttribute(_, key, fallback) {
  if (fallback === void 0) fallback = '';

  var path = this.rootKey + ".attributes." + key;
  if (this.i18n.te(path)) {
    return this.i18n.t(path);
  }

  return fallback;
};

I18nDictionary.prototype.getFieldMessage = function getFieldMessage(_, field, key, data) {
  var path = this.rootKey + ".custom." + field + "." + key;
  if (this.i18n.te(path)) {
    return this.i18n.t(path, data);
  }

  return this.getMessage(_, key, data);
};

I18nDictionary.prototype.merge = function merge$1(dictionary) {
  var this$1 = this;

  Object.keys(dictionary).forEach(function (localeKey) {
    var obj;

    // i18n doesn't deep merge
    // first clone the existing locale (avoid mutations to locale)
    var clone = merge({}, getPath(localeKey + "." + this$1.rootKey, this$1.i18n.messages, {}));
    // Merge cloned locale with new one
    var locale = merge(clone, normalizeFormat(dictionary[localeKey]));
    this$1.i18n.mergeLocaleMessage(localeKey, (obj = {}, obj[this$1.rootKey] = locale, obj));
    if (locale.dateFormat) {
      this$1.i18n.setDateTimeFormat(localeKey, locale.dateFormat);
    }
  });
};

I18nDictionary.prototype.setMessage = function setMessage(locale, key, value) {
  var obj, obj$1;

  this.merge((obj$1 = {}, obj$1[locale] = {
    messages: (obj = {}, obj[key] = value, obj)
  }, obj$1));
};

I18nDictionary.prototype.setAttribute = function setAttribute(locale, key, value) {
  var obj, obj$1;

  this.merge((obj$1 = {}, obj$1[locale] = {
    attributes: (obj = {}, obj[key] = value, obj)
  }, obj$1));
};

Object.defineProperties(I18nDictionary.prototype, prototypeAccessors$5);

var aggressive = function aggressive() {
  return {
    on: ['input']
  };
};

var lazy = function lazy() {
  return {
    on: ['change']
  };
};

var eager = function eager(ref) {
  var errors = ref.errors;

  if (errors.length) {
    return {
      on: ['input']
    };
  }

  return {
    on: ['change', 'blur']
  };
};

var passive = function passive() {
  return {
    on: []
  };
};

var modes = {
  aggressive: aggressive,
  eager: eager,
  passive: passive,
  lazy: lazy
};

// 

var Vue;
var pendingPlugins;
var pluginInstance;

var VeeValidate$1 = function VeeValidate(config, _Vue) {
  this.configure(config);
  pluginInstance = this;
  if (_Vue) {
    Vue = _Vue;
  }
  this._validator = setValidator(new Validator(null, { fastExit: config && config.fastExit }, this));
  this._initVM(this.config);
  this._initI18n(this.config);
};

var prototypeAccessors$6 = { i18nDriver: { configurable: true }, config: { configurable: true } };
var staticAccessors$2 = { i18nDriver: { configurable: true }, config: { configurable: true } };

VeeValidate$1.setI18nDriver = function setI18nDriver(driver, instance) {
  DictionaryResolver.setDriver(driver, instance);
};

VeeValidate$1.configure = function configure(cfg) {
  setConfig(cfg);
};

VeeValidate$1.setMode = function setMode(mode, implementation) {
  setConfig({ mode: mode });
  if (!implementation) {
    return;
  }

  if (!isCallable(implementation)) {
    throw new Error('A mode implementation must be a function');
  }

  modes[mode] = implementation;
};

VeeValidate$1.use = function use(plugin, options) {
  if (options === void 0) options = {};

  if (!isCallable(plugin)) {
    return warn('The plugin must be a callable function');
  }

  // Don't install plugins until vee-validate is installed.
  if (!pluginInstance) {
    if (!pendingPlugins) {
      pendingPlugins = [];
    }
    pendingPlugins.push({ plugin: plugin, options: options });
    return;
  }

  plugin({ Validator: Validator, ErrorBag: ErrorBag, Rules: Validator.rules }, options);
};
VeeValidate$1.install = function install(_Vue, opts) {
  if (Vue && _Vue === Vue) {
    if (false) {
      warn('already installed, Vue.use(VeeValidate) should only be called once.');
    }
    return;
  }

  Vue = _Vue;
  pluginInstance = new VeeValidate$1(opts);
  // inject the plugin container statically into the validator class
  Validator.$vee = pluginInstance;

  detectPassiveSupport();

  Vue.mixin(mixin);
  Vue.directive('validate', directive);
  if (pendingPlugins) {
    pendingPlugins.forEach(function (ref) {
      var plugin = ref.plugin;
      var options = ref.options;

      VeeValidate$1.use(plugin, options);
    });
    pendingPlugins = null;
  }
};

prototypeAccessors$6.i18nDriver.get = function () {
  return DictionaryResolver.getDriver();
};

staticAccessors$2.i18nDriver.get = function () {
  return DictionaryResolver.getDriver();
};

prototypeAccessors$6.config.get = function () {
  return getConfig();
};

staticAccessors$2.config.get = function () {
  return getConfig();
};

VeeValidate$1.prototype._initVM = function _initVM(config) {
  var this$1 = this;

  this._vm = new Vue({
    data: function data() {
      return {
        errors: this$1._validator.errors,
        fields: this$1._validator.fields
      };
    }
  });
};

VeeValidate$1.prototype._initI18n = function _initI18n(config) {
  var this$1 = this;

  var dictionary = config.dictionary;
  var i18n = config.i18n;
  var i18nRootKey = config.i18nRootKey;
  var locale = config.locale;
  var onLocaleChanged = function onLocaleChanged() {
    if (dictionary) {
      this$1.i18nDriver.merge(dictionary);
    }

    this$1._validator.errors.regenerate();
  };

  // i18 is being used for localization.
  if (i18n) {
    VeeValidate$1.setI18nDriver('i18n', new I18nDictionary(i18n, i18nRootKey));
    i18n._vm.$watch('locale', onLocaleChanged);
  } else if (typeof window !== 'undefined') {
    this._vm.$on('localeChanged', onLocaleChanged);
  }

  if (dictionary) {
    this.i18nDriver.merge(dictionary);
  }

  if (locale && !i18n) {
    this._validator.localize(locale);
  }
};

VeeValidate$1.prototype.configure = function configure(cfg) {
  setConfig(cfg);
};

Object.defineProperties(VeeValidate$1.prototype, prototypeAccessors$6);
Object.defineProperties(VeeValidate$1, staticAccessors$2);

VeeValidate$1.mixin = mixin;
VeeValidate$1.directive = directive;
VeeValidate$1.Validator = Validator;
VeeValidate$1.ErrorBag = ErrorBag;

/**
 * Formates file size.
 *
 * @param {Number|String} size
 */
var formatFileSize = function formatFileSize(size) {
  var units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var threshold = 1024;
  size = Number(size) * threshold;
  var i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold));
  return (size / Math.pow(threshold, i)).toFixed(2) * 1 + " " + units[i];
};

/**
 * Checks if vee-validate is defined globally.
 */
var isDefinedGlobally = function isDefinedGlobally() {
  return typeof VeeValidate !== 'undefined';
};

var obj;

var messages = {
  _default: function _default(field) {
    return "The " + field + " value is not valid";
  },
  after: function after(field, ref) {
    var target = ref[0];
    var inclusion = ref[1];

    return "The " + field + " must be after " + (inclusion ? 'or equal to ' : '') + target;
  },
  alpha: function alpha(field) {
    return "The " + field + " field may only contain alphabetic characters";
  },
  alpha_dash: function alpha_dash(field) {
    return "The " + field + " field may contain alpha-numeric characters as well as dashes and underscores";
  },
  alpha_num: function alpha_num(field) {
    return "The " + field + " field may only contain alpha-numeric characters";
  },
  alpha_spaces: function alpha_spaces(field) {
    return "The " + field + " field may only contain alphabetic characters as well as spaces";
  },
  before: function before(field, ref) {
    var target = ref[0];
    var inclusion = ref[1];

    return "The " + field + " must be before " + (inclusion ? 'or equal to ' : '') + target;
  },
  between: function between(field, ref) {
    var min = ref[0];
    var max = ref[1];

    return "The " + field + " field must be between " + min + " and " + max;
  },
  confirmed: function confirmed(field) {
    return "The " + field + " confirmation does not match";
  },
  credit_card: function credit_card(field) {
    return "The " + field + " field is invalid";
  },
  date_between: function date_between(field, ref) {
    var min = ref[0];
    var max = ref[1];

    return "The " + field + " must be between " + min + " and " + max;
  },
  date_format: function date_format(field, ref) {
    var format = ref[0];

    return "The " + field + " must be in the format " + format;
  },
  decimal: function decimal(field, ref) {
    if (ref === void 0) ref = [];
    var decimals = ref[0];if (decimals === void 0) decimals = '*';

    return "The " + field + " field must be numeric and may contain" + (!decimals || decimals === '*' ? '' : ' ' + decimals) + " decimal points";
  },
  digits: function digits(field, ref) {
    var length = ref[0];

    return "The " + field + " field must be numeric and contains exactly " + length + " digits";
  },
  dimensions: function dimensions(field, ref) {
    var width = ref[0];
    var height = ref[1];

    return "The " + field + " field must be " + width + " pixels by " + height + " pixels";
  },
  email: function email(field) {
    return "The " + field + " field must be a valid email";
  },
  excluded: function excluded(field) {
    return "The " + field + " field must be a valid value";
  },
  ext: function ext(field) {
    return "The " + field + " field must be a valid file";
  },
  image: function image(field) {
    return "The " + field + " field must be an image";
  },
  included: function included(field) {
    return "The " + field + " field must be a valid value";
  },
  integer: function integer(field) {
    return "The " + field + " field must be an integer";
  },
  ip: function ip(field) {
    return "The " + field + " field must be a valid ip address";
  },
  ip_or_fqdn: function ip_or_fqdn(field) {
    return "The " + field + " field must be a valid ip address or FQDN";
  },
  length: function length(field, ref) {
    var length = ref[0];
    var max = ref[1];

    if (max) {
      return "The " + field + " length must be between " + length + " and " + max;
    }

    return "The " + field + " length must be " + length;
  },
  max: function max(field, ref) {
    var length = ref[0];

    return "The " + field + " field may not be greater than " + length + " characters";
  },
  max_value: function max_value(field, ref) {
    var max = ref[0];

    return "The " + field + " field must be " + max + " or less";
  },
  mimes: function mimes(field) {
    return "The " + field + " field must have a valid file type";
  },
  min: function min(field, ref) {
    var length = ref[0];

    return "The " + field + " field must be at least " + length + " characters";
  },
  min_value: function min_value(field, ref) {
    var min = ref[0];

    return "The " + field + " field must be " + min + " or more";
  },
  numeric: function numeric(field) {
    return "The " + field + " field may only contain numeric characters";
  },
  regex: function regex(field) {
    return "The " + field + " field format is invalid";
  },
  required: function required(field) {
    return "The " + field + " field is required";
  },
  required_if: function required_if(field, ref) {
    var target = ref[0];

    return "The " + field + " field is required when the " + target + " field has this value";
  },
  size: function size(field, ref) {
    var size = ref[0];

    return "The " + field + " size must be less than " + formatFileSize(size);
  },
  url: function url(field) {
    return "The " + field + " field is not a valid URL";
  }
};

var locale = {
  name: 'en',
  messages: messages,
  attributes: {}
};

if (isDefinedGlobally()) {
  // eslint-disable-next-line
  VeeValidate.Validator.localize((obj = {}, obj[locale.name] = locale, obj));
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

var MILLISECONDS_IN_MINUTE = 60000;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = date.getTimezoneOffset();
  date.setSeconds(0, 0);
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE$1 = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;

var patterns = {
  dateTimeDelimeter: /[T ]/,
  plainTime: /:/,
  timeZoneDelimeter: /[Z ]/i,

  // year tokens
  YY: /^(\d{2})$/,
  YYY: [/^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [/^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
  ],

  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,

  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,

  // timezone tokens
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-])(\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 * If the function cannot parse the string or the values are invalid, it returns Invalid Date.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function toDate(argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  if (argument === null) {
    return new Date(NaN);
  }

  var options = dirtyOptions || {};

  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : toInteger(options.additionalDigits);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  // Clone the date
  if (argument instanceof Date || (typeof argument === 'undefined' ? 'undefined' : _typeof2(argument)) === 'object' && Object.prototype.toString.call(argument) === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') {
    return new Date(argument);
  } else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);

  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;

  var date = parseDate(restDateString, year);

  if (isNaN(date)) {
    return new Date(NaN);
  }

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);

      if (isNaN(time)) {
        return new Date(NaN);
      }
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone);
      if (isNaN(offset)) {
        return new Date(NaN);
      }
    } else {
      // get offset accurate to hour in timezones that change offset
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time));
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time + offset));
    }

    return new Date(timestamp + time + offset);
  } else {
    return new Date(NaN);
  }
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimeter);
  var timeString;

  if (patterns.plainTime.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimeter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimeter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var patternYYY = patterns.YYY[additionalDigits];
  var patternYYYYY = patterns.YYYYY[additionalDigits];

  var token;

  // YYYY or ±YYYYY
  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    };
  }

  // YY or ±YYY
  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    };
  }

  // Invalid ISO-formatted year
  return {
    year: null
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null;
  }

  var token;
  var date;
  var month;
  var week;

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date;
  }

  // YYYY-MM
  token = patterns.MM.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;

    if (!validateDate(year, month)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month);
    return date;
  }

  // YYYY-DDD or YYYYDDD
  token = patterns.DDD.exec(dateString);
  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);

    if (!validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, 0, dayOfYear);
    return date;
  }

  // YYYY-MM-DD or YYYYMMDD
  token = patterns.MMDD.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);

    if (!validateDate(year, month, day)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, day);
    return date;
  }

  // YYYY-Www or YYYYWww
  token = patterns.Www.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;

    if (!validateWeekDate(year, week)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week);
  }

  // YYYY-Www-D or YYYYWwwD
  token = patterns.WwwD.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;

    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  }

  // Invalid ISO-formatted date
  return null;
}

function parseTime(timeString) {
  var token;
  var hours;
  var minutes;

  // hh
  token = patterns.HH.exec(timeString);
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));

    if (!validateTime(hours)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR;
  }

  // hh:mm or hhmm
  token = patterns.HHMM.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));

    if (!validateTime(hours, minutes)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE$1;
  }

  // hh:mm:ss or hhmmss
  token = patterns.HHMMSS.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));

    if (!validateTime(hours, minutes, seconds)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE$1 + seconds * 1000;
  }

  // Invalid ISO-formatted time
  return null;
}

function parseTimezone(timezoneString) {
  var token;
  var absoluteOffset;

  // Z
  token = patterns.timezoneZ.exec(timezoneString);
  if (token) {
    return 0;
  }

  var hours;

  // ±hh
  token = patterns.timezoneHH.exec(timezoneString);
  if (token) {
    hours = parseInt(token[2], 10);

    if (!validateTimezone()) {
      return NaN;
    }

    absoluteOffset = hours * MILLISECONDS_IN_HOUR;
    return token[1] === '+' ? -absoluteOffset : absoluteOffset;
  }

  // ±hh:mm or ±hhmm
  token = patterns.timezoneHHMM.exec(timezoneString);
  if (token) {
    hours = parseInt(token[2], 10);
    var minutes = parseInt(token[3], 10);

    if (!validateTimezone(hours, minutes)) {
      return NaN;
    }

    absoluteOffset = hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE$1;
    return token[1] === '+' ? -absoluteOffset : absoluteOffset;
  }

  return 0;
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  if (month < 0 || month > 11) {
    return false;
  }

  if (date != null) {
    if (date < 1) {
      return false;
    }

    var isLeapYear = isLeapYearIndex(year);
    if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) {
      return false;
    }
    if (!isLeapYear && date > DAYS_IN_MONTH[month]) {
      return false;
    }
  }

  return true;
}

function validateDayOfYearDate(year, dayOfYear) {
  if (dayOfYear < 1) {
    return false;
  }

  var isLeapYear = isLeapYearIndex(year);
  if (isLeapYear && dayOfYear > 366) {
    return false;
  }
  if (!isLeapYear && dayOfYear > 365) {
    return false;
  }

  return true;
}

function validateWeekDate(year, week, day) {
  if (week < 0 || week > 52) {
    return false;
  }

  if (day != null && (day < 0 || day > 6)) {
    return false;
  }

  return true;
}

function validateTime(hours, minutes, seconds) {
  if (hours != null && (hours < 0 || hours >= 25)) {
    return false;
  }

  if (minutes != null && (minutes < 0 || minutes >= 60)) {
    return false;
  }

  if (seconds != null && (seconds < 0 || seconds >= 60)) {
    return false;
  }

  return true;
}

function validateTimezone(hours, minutes) {
  if (minutes != null && (minutes < 0 || minutes > 59)) {
    return false;
  }

  return true;
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var timestamp = toDate(dirtyDate, dirtyOptions).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid('2014-02-31')
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate, dirtyOptions);
  return !isNaN(date);
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },

  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },

  halfAMinute: 'half a minute',

  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },

  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },

  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },

  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },

  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },

  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },

  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },

  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },

  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },

  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },

  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

function formatDistance(token, count, options) {
  options = options || {};

  var result;
  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};

var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};

var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};

var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),

  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),

  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

function formatRelative(token, date, baseDate, options) {
  return formatRelativeLocale[token];
}

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var context = options.context ? String(options.context) : 'standalone';

    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      valuesArray = args.formattingValues[width] || args.formattingValues[args.defaultFormattingWidth];
    } else {
      valuesArray = args.values[width] || args.values[args.defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};

var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};

var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};

var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return Number(quarter) - 1;
    }
  }),

  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaulFormattingWidth: 'wide'
  })
};

function buildMatchPatternFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};

    var matchResult = string.match(args.matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];

    var parseResult = string.match(args.parsePattern);
    if (!parseResult) {
      return null;
    }
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;

    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;

    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];

    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];

    var value;
    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = parsePatterns.findIndex(function (pattern) {
        return pattern.test(string);
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(string);
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;

    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;

var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};

var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};

var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};

var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};

var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};

var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale$1 = {
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */
    , firstWeekContainsDate: 1
  }
};

var MILLISECONDS_IN_DAY = 86400000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCDayOfYear(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeek(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var weekStartsOn = 1;

  var date = toDate(dirtyDate, dirtyOptions);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeekYear(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();

  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear, dirtyOptions);

  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeekYear(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var year = getUTCISOWeekYear(dirtyDate, dirtyOptions);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeek(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var diff = startOfUTCISOWeek(date, dirtyOptions).getTime() - startOfUTCISOWeekYear(date, dirtyOptions).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeek(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate, options);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCWeekYear(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);

  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);

  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCWeek(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var diff = startOfUTCWeek(date, dirtyOptions).getTime() - startOfUTCWeekYear(date, dirtyOptions).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, { width: 'abbreviated' });
      // A, B
      case 'GGGGG':
        return localize.era(era, { width: 'narrow' });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, { width: 'wide' });
    }
  },

  // Year
  y: function y(date, token, localize, options) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();

    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;

    // Two digit year
    if (token === 'yy') {
      var twoDigitYear = year % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'yo') {
      return localize.ordinalNumber(year, { unit: 'year' });
    }

    // Padding
    return addLeadingZeros(year, token.length);
  },

  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, { unit: 'year' });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },

  // ISO week-numbering year
  R: function R(date, token, localize, options) {
    var isoWeekYear = getUTCISOWeekYear(date, options);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },

  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token, localize, options) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },

  // Quarter
  Q: function Q(date, token, localize, options) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, { unit: 'quarter' });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, { width: 'abbreviated', context: 'formatting' });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, { width: 'narrow', context: 'formatting' });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, { width: 'wide', context: 'formatting' });
    }
  },

  // Stand-alone quarter
  q: function q(date, token, localize, options) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, { unit: 'quarter' });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, { width: 'abbreviated', context: 'standalone' });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, { width: 'narrow', context: 'standalone' });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, { width: 'wide', context: 'standalone' });
    }
  },

  // Month
  M: function M(date, token, localize, options) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'M':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'MM':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, { unit: 'month' });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, { width: 'abbreviated', context: 'formatting' });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, { width: 'narrow', context: 'formatting' });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, { width: 'wide', context: 'formatting' });
    }
  },

  // Stand-alone month
  L: function L(date, token, localize, options) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, { unit: 'month' });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, { width: 'abbreviated', context: 'standalone' });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, { width: 'narrow', context: 'standalone' });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, { width: 'wide', context: 'standalone' });
    }
  },

  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, { unit: 'week' });
    }

    return addLeadingZeros(week, token.length);
  },

  // ISO week of year
  I: function I(date, token, localize, options) {
    var isoWeek = getUTCISOWeek(date, options);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, { unit: 'week' });
    }

    return addLeadingZeros(isoWeek, token.length);
  },

  // Day of the month
  d: function d(date, token, localize, options) {
    var dayOfMonth = date.getUTCDate();

    if (token === 'do') {
      return localize.ordinalNumber(dayOfMonth, { unit: 'date' });
    }

    return addLeadingZeros(dayOfMonth, token.length);
  },

  // Day of year
  D: function D(date, token, localize, options) {
    var dayOfYear = getUTCDayOfYear(date, options);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, { unit: 'dayOfYear' });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },

  // Day of week
  E: function E(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, { width: 'abbreviated', context: 'formatting' });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, { width: 'narrow', context: 'formatting' });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, { width: 'short', context: 'formatting' });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, { width: 'wide', context: 'formatting' });
    }
  },

  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, { unit: 'day' });
      case 'eee':
        return localize.day(dayOfWeek, { width: 'abbreviated', context: 'formatting' });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, { width: 'narrow', context: 'formatting' });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, { width: 'short', context: 'formatting' });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, { width: 'wide', context: 'formatting' });
    }
  },

  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numberical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, { unit: 'day' });
      case 'ccc':
        return localize.day(dayOfWeek, { width: 'abbreviated', context: 'standalone' });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, { width: 'narrow', context: 'standalone' });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, { width: 'short', context: 'standalone' });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, { width: 'wide', context: 'standalone' });
    }
  },

  // ISO day of week
  i: function i(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, { unit: 'day' });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, { width: 'abbreviated', context: 'formatting' });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, { width: 'narrow', context: 'formatting' });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, { width: 'short', context: 'formatting' });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, { width: 'wide', context: 'formatting' });
    }
  },

  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, { width: 'abbreviated', context: 'formatting' });
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, { width: 'narrow', context: 'formatting' });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, { width: 'wide', context: 'formatting' });
    }
  },

  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, { width: 'abbreviated', context: 'formatting' });
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, { width: 'narrow', context: 'formatting' });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, { width: 'wide', context: 'formatting' });
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, { width: 'abbreviated', context: 'formatting' });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, { width: 'narrow', context: 'formatting' });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, { width: 'wide', context: 'formatting' });
    }
  },

  // Hour [1-12]
  h: function h(date, token, localize, options) {
    var hours = date.getUTCHours() % 12;

    if (hours === 0) {
      hours = 12;
    }

    if (token === 'ho') {
      return localize.ordinalNumber(hours, { unit: 'hour' });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Hour [0-23]
  H: function H(date, token, localize, options) {
    var hours = date.getUTCHours();

    if (token === 'Ho') {
      return localize.ordinalNumber(hours, { unit: 'hour' });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Hour [0-11]
  K: function K(date, token, localize, options) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, { unit: 'hour' });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Hour [1-24]
  k: function k(date, token, localize, options) {
    var hours = date.getUTCHours();

    if (hours === 0) {
      hours = 24;
    }

    if (token === 'ko') {
      return localize.ordinalNumber(hours, { unit: 'hour' });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Minute
  m: function m(date, token, localize, options) {
    var minutes = date.getUTCMinutes();

    if (token === 'mo') {
      return localize.ordinalNumber(minutes, { unit: 'minute' });
    }

    return addLeadingZeros(minutes, token.length);
  },

  // Second
  s: function s(date, token, localize, options) {
    var seconds = date.getUTCSeconds();

    if (token === 'so') {
      return localize.ordinalNumber(seconds, { unit: 'second' });
    }

    return addLeadingZeros(seconds, token.length);
  },

  // Fraction of second
  S: function S(date, token, localize, options) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, numberOfDigits);
  },

  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },

  // Timezone (GMT)
  O: function O(date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },

  // Timezone (specific non-location)
  z: function z(date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },

  // Seconds timestamp
  t: function t(date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },

  // Milliseconds timestamp
  T: function T(date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

function formatTimezone(offset, dirtyDelimeter) {
  var delimeter = dirtyDelimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimeter + minutes;
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimeter);
}

function formatTimezoneShort(offset, dirtyDelimeter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimeter = dirtyDelimeter || '';
  return sign + String(hours) + delimeter + addLeadingZeros(minutes, 2);
}

function dateLongFormatter(pattern, formatLong, options) {
  switch (pattern) {
    case 'P':
      return formatLong.date({ width: 'short' });
    case 'PP':
      return formatLong.date({ width: 'medium' });
    case 'PPP':
      return formatLong.date({ width: 'long' });
    case 'PPPP':
    default:
      return formatLong.date({ width: 'full' });
  }
}

function timeLongFormatter(pattern, formatLong, options) {
  switch (pattern) {
    case 'p':
      return formatLong.time({ width: 'short' });
    case 'pp':
      return formatLong.time({ width: 'medium' });
    case 'ppp':
      return formatLong.time({ width: 'long' });
    case 'pppp':
    default:
      return formatLong.time({ width: 'full' });
  }
}

function dateTimeLongFormatter(pattern, formatLong, options) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({ width: 'short' });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({ width: 'medium' });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({ width: 'long' });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({ width: 'full' });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount, dirtyOptions);
}

var protectedTokens = ['D', 'DD', 'YY', 'YYYY'];

function isProtectedToken(token) {
  return protectedTokens.indexOf(token) !== -1;
}

function throwProtectedError(token) {
  throw new RangeError('`options.awareOfUnicodeTokens` must be set to `true` to use `' + token + '` token; see: https://git.io/fxCyr');
}

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

var escapedStringRegExp = /^'(.*?)'?$/;
var doubleQuoteRegExp = /''/g;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 8     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 8     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens (`yy`, `yyyy`).
 *   See: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see: https://git.io/fxCyr
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/dd/yyyy'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(
 *   new Date(2014, 6, 2),
 *   "do 'de' MMMM yyyy",
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(
 *   new Date(2014, 6, 2, 15),
 *   "h 'o''clock'"
 * )
 * //=> "3 o'clock"
 */
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};

  var locale = options.locale || locale$1;

  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate, options);

  if (!isValid(originalDate, options)) {
    return 'Invalid Date';
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset, options);

  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };

  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters[firstCharacter];
    if (formatter) {
      if (!options.awareOfUnicodeTokens && isProtectedToken(substring)) {
        throwProtectedError(substring);
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    return substring;
  }).join('');

  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(dirtyDate, dirtyDateToCompare, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
  return date.getTime() < dateToCompare.getTime();
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual$1(dirtyLeftDate, dirtyRightDate, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeft = toDate(dirtyLeftDate, dirtyOptions);
  var dateRight = toDate(dirtyRightDate, dirtyOptions);
  return dateLeft.getTime() === dateRight.getTime();
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var day = toInteger(dirtyDay);

  var currentDay = date.getUTCDay();

  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;

  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCWeek(dirtyDate, dirtyWeek, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, dirtyOptions) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISODay(dirtyDate, dirtyDay, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var day = toInteger(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate, dirtyOptions);
  var currentDay = date.getUTCDay();

  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;

  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISOWeek(dirtyDate, dirtyISOWeek, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date, dirtyOptions) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var MILLISECONDS_IN_HOUR$1 = 3600000;
var MILLISECONDS_IN_MINUTE$2 = 60000;
var MILLISECONDS_IN_SECOND = 1000;

var numericPatterns = {
  month: /^(1[0-2]|0?\d)/, // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/, // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/, // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/, // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/, // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/, // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/, // 0 to 12
  minute: /^[0-5]?\d/, // 0 to 59
  second: /^[0-5]?\d/, // 0 to 59

  singleDigit: /^\d/, // 0 to 9
  twoDigits: /^\d{1,2}/, // 0 to 99
  threeDigits: /^\d{1,3}/, // 0 to 999
  fourDigits: /^\d{1,4}/, // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/, // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/, // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/, // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};

var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);

  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  // Input is 'Z'
  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;

  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR$1 + minutes * MILLISECONDS_IN_MINUTE$2 + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);
    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);
    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;
    case 'evening':
      return 17;
    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;
    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;

  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH$1 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR$1 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// User for validation
function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function parse(string, token, match, options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, { width: 'abbreviated' }) || match.era(string, { width: 'narrow' });
        // A, B
        case 'GGGGG':
          return match.era(string, { width: 'narrow' });
        // Anno Domini, Before Christ
        case 'GGGG':
        default:
          return match.era(string, { width: 'wide' }) || match.era(string, { width: 'abbreviated' }) || match.era(string, { width: 'narrow' });
      }
    },
    set: function set(date, value, options) {
      // Sets year 10 BC if BC, or 10 AC if AC
      date.setUTCFullYear(value === 1 ? 10 : -9, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  },

  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    priority: 130,
    parse: function parse(string, token, match, options) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);
        case 'yo':
          return match.ordinalNumber(string, { unit: 'year', valueCallback: valueCallback });
        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function validate(date, value, options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function set(date, value, options) {
      var currentYear = getUTCWeekYear(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = currentYear > 0 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  },

  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function parse(string, token, match, options) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);
        case 'Yo':
          return match.ordinalNumber(string, { unit: 'year', valueCallback: valueCallback });
        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function validate(date, value, options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function set(date, value, options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }

      var year = currentYear > 0 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    }
  },

  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function parse(string, token, match, options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function set(date, value, options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    }
  },

  // Extended year
  u: {
    priority: 130,
    parse: function parse(string, token, match, options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function set(date, value, options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  },

  // Quarter
  Q: {
    priority: 120,
    parse: function parse(string, token, match, options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th
        case 'Qo':
          return match.ordinalNumber(string, { unit: 'quarter' });
        // Q1, Q2, Q3, Q4
        case 'QQQ':
          return match.quarter(string, { width: 'abbreviated', context: 'formatting' }) || match.quarter(string, { width: 'narrow', context: 'formatting' });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'QQQQQ':
          return match.quarter(string, { width: 'narrow', context: 'formatting' });
        // 1st quarter, 2nd quarter, ...
        case 'QQQQ':
        default:
          return match.quarter(string, { width: 'wide', context: 'formatting' }) || match.quarter(string, { width: 'abbreviated', context: 'formatting' }) || match.quarter(string, { width: 'narrow', context: 'formatting' });
      }
    },
    validate: function validate(date, value, options) {
      return value >= 1 && value <= 4;
    },
    set: function set(date, value, options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  },

  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function parse(string, token, match, options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th
        case 'qo':
          return match.ordinalNumber(string, { unit: 'quarter' });
        // Q1, Q2, Q3, Q4
        case 'qqq':
          return match.quarter(string, { width: 'abbreviated', context: 'standalone' }) || match.quarter(string, { width: 'narrow', context: 'standalone' });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'qqqqq':
          return match.quarter(string, { width: 'narrow', context: 'standalone' });
        // 1st quarter, 2nd quarter, ...
        case 'qqqq':
        default:
          return match.quarter(string, { width: 'wide', context: 'standalone' }) || match.quarter(string, { width: 'abbreviated', context: 'standalone' }) || match.quarter(string, { width: 'narrow', context: 'standalone' });
      }
    },
    validate: function validate(date, value, options) {
      return value >= 1 && value <= 4;
    },
    set: function set(date, value, options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  },

  // Month
  M: {
    priority: 110,
    parse: function parse(string, token, match, options) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12
        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Mo':
          return match.ordinalNumber(string, { unit: 'month', valueCallback: valueCallback });
        // Jan, Feb, ..., Dec
        case 'MMM':
          return match.month(string, { width: 'abbreviated', context: 'formatting' }) || match.month(string, { width: 'narrow', context: 'formatting' });
        // J, F, ..., D
        case 'MMMMM':
          return match.month(string, { width: 'narrow', context: 'formatting' });
        // January, February, ..., December
        case 'MMMM':
        default:
          return match.month(string, { width: 'wide', context: 'formatting' }) || match.month(string, { width: 'abbreviated', context: 'formatting' }) || match.month(string, { width: 'narrow', context: 'formatting' });
      }
    },
    validate: function validate(date, value, options) {
      return value >= 0 && value <= 11;
    },
    set: function set(date, value, options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  },

  // Stand-alone month
  L: {
    priority: 110,
    parse: function parse(string, token, match, options) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12
        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Lo':
          return match.ordinalNumber(string, { unit: 'month', valueCallback: valueCallback });
        // Jan, Feb, ..., Dec
        case 'LLL':
          return match.month(string, { width: 'abbreviated', context: 'standalone' }) || match.month(string, { width: 'narrow', context: 'standalone' });
        // J, F, ..., D
        case 'LLLLL':
          return match.month(string, { width: 'narrow', context: 'standalone' });
        // January, February, ..., December
        case 'LLLL':
        default:
          return match.month(string, { width: 'wide', context: 'standalone' }) || match.month(string, { width: 'abbreviated', context: 'standalone' }) || match.month(string, { width: 'narrow', context: 'standalone' });
      }
    },
    validate: function validate(date, value, options) {
      return value >= 0 && value <= 11;
    },
    set: function set(date, value, options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  },

  // Local week of year
  w: {
    priority: 100,
    parse: function parse(string, token, match, options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);
        case 'wo':
          return match.ordinalNumber(string, { unit: 'week' });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(date, value, options) {
      return value >= 1 && value <= 53;
    },
    set: function set(date, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    }
  },

  // ISO week of year
  I: {
    priority: 100,
    parse: function parse(string, token, match, options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);
        case 'Io':
          return match.ordinalNumber(string, { unit: 'week' });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(date, value, options) {
      return value >= 1 && value <= 53;
    },
    set: function set(date, value, options) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value, options), options);
    }
  },

  // Day of the month
  d: {
    priority: 90,
    parse: function parse(string, token, match, options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);
        case 'do':
          return match.ordinalNumber(string, { unit: 'date' });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(date, value, options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR$1[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH$1[month];
      }
    },
    set: function set(date, value, options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  },

  // Day of year
  D: {
    priority: 90,
    parse: function parse(string, token, match, options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);
        case 'Do':
          return match.ordinalNumber(string, { unit: 'date' });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(date, value, options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function set(date, value, options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  },

  // Day of week
  E: {
    priority: 90,
    parse: function parse(string, token, match, options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, { width: 'abbreviated', context: 'formatting' }) || match.day(string, { width: 'short', context: 'formatting' }) || match.day(string, { width: 'narrow', context: 'formatting' });
        // T
        case 'EEEEE':
          return match.day(string, { width: 'narrow', context: 'formatting' });
        // Tu
        case 'EEEEEE':
          return match.day(string, { width: 'short', context: 'formatting' }) || match.day(string, { width: 'narrow', context: 'formatting' });
        // Tuesday
        case 'EEEE':
        default:
          return match.day(string, { width: 'wide', context: 'formatting' }) || match.day(string, { width: 'abbreviated', context: 'formatting' }) || match.day(string, { width: 'short', context: 'formatting' }) || match.day(string, { width: 'narrow', context: 'formatting' });
      }
    },
    validate: function validate(date, value, options) {
      return value >= 0 && value <= 6;
    },
    set: function set(date, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  },

  // Local day of week
  e: {
    priority: 90,
    parse: function parse(string, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd
        case 'eo':
          return match.ordinalNumber(string, { unit: 'day', valueCallback: valueCallback });
        // Tue
        case 'eee':
          return match.day(string, { width: 'abbreviated', context: 'formatting' }) || match.day(string, { width: 'short', context: 'formatting' }) || match.day(string, { width: 'narrow', context: 'formatting' });
        // T
        case 'eeeee':
          return match.day(string, { width: 'narrow', context: 'formatting' });
        // Tu
        case 'eeeeee':
          return match.day(string, { width: 'short', context: 'formatting' }) || match.day(string, { width: 'narrow', context: 'formatting' });
        // Tuesday
        case 'eeee':
        default:
          return match.day(string, { width: 'wide', context: 'formatting' }) || match.day(string, { width: 'abbreviated', context: 'formatting' }) || match.day(string, { width: 'short', context: 'formatting' }) || match.day(string, { width: 'narrow', context: 'formatting' });
      }
    },
    validate: function validate(date, value, options) {
      return value >= 0 && value <= 6;
    },
    set: function set(date, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  },

  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function parse(string, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd
        case 'co':
          return match.ordinalNumber(string, { unit: 'day', valueCallback: valueCallback });
        // Tue
        case 'ccc':
          return match.day(string, { width: 'abbreviated', context: 'standalone' }) || match.day(string, { width: 'short', context: 'standalone' }) || match.day(string, { width: 'narrow', context: 'standalone' });
        // T
        case 'ccccc':
          return match.day(string, { width: 'narrow', context: 'standalone' });
        // Tu
        case 'cccccc':
          return match.day(string, { width: 'short', context: 'standalone' }) || match.day(string, { width: 'narrow', context: 'standalone' });
        // Tuesday
        case 'cccc':
        default:
          return match.day(string, { width: 'wide', context: 'standalone' }) || match.day(string, { width: 'abbreviated', context: 'standalone' }) || match.day(string, { width: 'short', context: 'standalone' }) || match.day(string, { width: 'narrow', context: 'standalone' });
      }
    },
    validate: function validate(date, value, options) {
      return value >= 0 && value <= 6;
    },
    set: function set(date, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  },

  // ISO day of week
  i: {
    priority: 90,
    parse: function parse(string, token, match, options) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }
        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd
        case 'io':
          return match.ordinalNumber(string, { unit: 'day' });
        // Tue
        case 'iii':
          return match.day(string, { width: 'abbreviated', context: 'formatting', valueCallback: valueCallback }) || match.day(string, { width: 'short', context: 'formatting', valueCallback: valueCallback }) || match.day(string, { width: 'narrow', context: 'formatting', valueCallback: valueCallback });
        // T
        case 'iiiii':
          return match.day(string, { width: 'narrow', context: 'formatting', valueCallback: valueCallback });
        // Tu
        case 'iiiiii':
          return match.day(string, { width: 'short', context: 'formatting', valueCallback: valueCallback }) || match.day(string, { width: 'narrow', context: 'formatting', valueCallback: valueCallback });
        // Tuesday
        case 'iiii':
        default:
          return match.day(string, { width: 'wide', context: 'formatting', valueCallback: valueCallback }) || match.day(string, { width: 'abbreviated', context: 'formatting', valueCallback: valueCallback }) || match.day(string, { width: 'short', context: 'formatting', valueCallback: valueCallback }) || match.day(string, { width: 'narrow', context: 'formatting', valueCallback: valueCallback });
      }
    },
    validate: function validate(date, value, options) {
      return value >= 1 && value <= 7;
    },
    set: function set(date, value, options) {
      date = setUTCISODay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  },

  // AM or PM
  a: {
    priority: 80,
    parse: function parse(string, token, match, options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, { width: 'abbreviated', context: 'formatting' }) || match.dayPeriod(string, { width: 'narrow', context: 'formatting' });
        case 'aaaaa':
          return match.dayPeriod(string, { width: 'narrow', context: 'formatting' });
        case 'aaaa':
        default:
          return match.dayPeriod(string, { width: 'wide', context: 'formatting' }) || match.dayPeriod(string, { width: 'abbreviated', context: 'formatting' }) || match.dayPeriod(string, { width: 'narrow', context: 'formatting' });
      }
    },
    set: function set(date, value, options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  },

  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function parse(string, token, match, options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, { width: 'abbreviated', context: 'formatting' }) || match.dayPeriod(string, { width: 'narrow', context: 'formatting' });
        case 'bbbbb':
          return match.dayPeriod(string, { width: 'narrow', context: 'formatting' });
        case 'bbbb':
        default:
          return match.dayPeriod(string, { width: 'wide', context: 'formatting' }) || match.dayPeriod(string, { width: 'abbreviated', context: 'formatting' }) || match.dayPeriod(string, { width: 'narrow', context: 'formatting' });
      }
    },
    set: function set(date, value, options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function parse(string, token, match, options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, { width: 'abbreviated', context: 'formatting' }) || match.dayPeriod(string, { width: 'narrow', context: 'formatting' });
        case 'BBBBB':
          return match.dayPeriod(string, { width: 'narrow', context: 'formatting' });
        case 'BBBB':
        default:
          return match.dayPeriod(string, { width: 'wide', context: 'formatting' }) || match.dayPeriod(string, { width: 'abbreviated', context: 'formatting' }) || match.dayPeriod(string, { width: 'narrow', context: 'formatting' });
      }
    },
    set: function set(date, value, options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  },

  // Hour [1-12]
  h: {
    priority: 70,
    parse: function parse(string, token, match, options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);
        case 'ho':
          return match.ordinalNumber(string, { unit: 'hour' });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(date, value, options) {
      return value >= 1 && value <= 12;
    },
    set: function set(date, value, options) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  },

  // Hour [0-23]
  H: {
    priority: 70,
    parse: function parse(string, token, match, options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);
        case 'Ho':
          return match.ordinalNumber(string, { unit: 'hour' });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(date, value, options) {
      return value >= 0 && value <= 23;
    },
    set: function set(date, value, options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  },

  // Hour [0-11]
  K: {
    priority: 70,
    parse: function parse(string, token, match, options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);
        case 'Ko':
          return match.ordinalNumber(string, { unit: 'hour' });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(date, value, options) {
      return value >= 0 && value <= 11;
    },
    set: function set(date, value, options) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  },

  // Hour [1-24]
  k: {
    priority: 70,
    parse: function parse(string, token, match, options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);
        case 'ko':
          return match.ordinalNumber(string, { unit: 'hour' });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(date, value, options) {
      return value >= 1 && value <= 24;
    },
    set: function set(date, value, options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  },

  // Minute
  m: {
    priority: 60,
    parse: function parse(string, token, match, options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);
        case 'mo':
          return match.ordinalNumber(string, { unit: 'minute' });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(date, value, options) {
      return value >= 0 && value <= 59;
    },
    set: function set(date, value, options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  },

  // Second
  s: {
    priority: 50,
    parse: function parse(string, token, match, options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);
        case 'so':
          return match.ordinalNumber(string, { unit: 'second' });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(date, value, options) {
      return value >= 0 && value <= 59;
    },
    set: function set(date, value, options) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  },

  // Fraction of second
  S: {
    priority: 40,
    parse: function parse(string, token, match, options) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };
      return parseNDigits(token.length, string, valueCallback);
    },
    set: function set(date, value, options) {
      date.setUTCMilliseconds(value);
      return date;
    }
  },

  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 20,
    parse: function parse(string, token, match, options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);
        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function set(date, value, options) {
      return new Date(date.getTime() - value);
    }
  },

  // Timezone (ISO-8601)
  x: {
    priority: 20,
    parse: function parse(string, token, match, options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);
        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function set(date, value, options) {
      return new Date(date.getTime() - value);
    }
  },

  // Seconds timestamp
  t: {
    priority: 10,
    parse: function parse(string, token, match, options) {
      return parseAnyDigitsSigned(string);
    },
    set: function set(date, value, options) {
      return new Date(value * 1000);
    }
  },

  // Milliseconds timestamp
  T: {
    priority: 10,
    parse: function parse(string, token, match, options) {
      return parseAnyDigitsSigned(string);
    },
    set: function set(date, value, options) {
      return new Date(value);
    }
  }
};

var TIMEZONE_UNIT_PRIORITY = 20;

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

var escapedStringRegExp$1 = /^'(.*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;

var notWhitespaceRegExp = /\S/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 6     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 6     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              |  40 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  20 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  20 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Seconds timestamp               |  10 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Milliseconds timestamp          |  10 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `baseDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *
 * 6. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `baseDate` which works as a context of parsing.
 *
 * `baseDate` must be passed for correct work of the function.
 * If you're not sure which `baseDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `baseDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `baseDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|String|Number} baseDate - defines values missing from the parsed dateString
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens (`yy`, `yyyy`).
 *   See: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see: https://git.io/fxCyr
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse(
 *   '02/11/2014',
 *   'MM/dd/yyyy',
 *   new Date()
 * )
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse(
 *   '28-a de februaro',
 *   "do 'de' MMMM",
 *   new Date(2010, 0, 1),
 *   {locale: eo}
 * )
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse(dirtyDateString, dirtyFormatString, dirtyBaseDate, dirtyOptions) {
  if (arguments.length < 3) {
    throw new TypeError('3 arguments required, but only ' + arguments.length + ' present');
  }

  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};

  var locale = options.locale || locale$1;

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyBaseDate, options);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  };

  // If timezone isn't specified, it will be set to the system timezone
  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    set: dateToSystemTimezone,
    index: 0
  }];

  var i;

  var tokens = formatString.match(formattingTokensRegExp$1);

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.awareOfUnicodeTokens && isProtectedToken(token)) {
      throwProtectedError(token);
    }

    var firstCharacter = token[0];
    var parser = parsers[firstCharacter];
    if (parser) {
      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });

      dateString = parseResult.rest;
    } else {
      // Replace two single quote characters with one single quote character
      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString$1(token);
      }

      // Cut token from string, or, if string doesn't match the token, return Invalid Date
      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  }

  // Check if the remaining input contains something other than whitespace
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).reverse();
  }).map(function (setterArray) {
    return setterArray[0];
  });

  var date = toDate(dirtyBaseDate, options);

  if (isNaN(date)) {
    return new Date(NaN);
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    utcDate = setter.set(utcDate, setter.value, subFnOptions);
  }

  return utcDate;
}

function dateToSystemTimezone(date) {
  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}

// 

/**
 * Custom parse behavior on top of date-fns parse function.
 */
function parseDate$1(date, format$1) {
  if (typeof date !== 'string') {
    return isValid(date) ? date : null;
  }

  var parsed = parse(date, format$1, new Date());

  // if date is not valid or the formatted output after parsing does not match
  // the string value passed in (avoids overflows)
  if (!isValid(parsed) || format(parsed, format$1) !== date) {
    return null;
  }

  return parsed;
}

var afterValidator = function afterValidator(value, ref) {
  if (ref === void 0) ref = {};
  var targetValue = ref.targetValue;
  var inclusion = ref.inclusion;if (inclusion === void 0) inclusion = false;
  var format = ref.format;

  if (typeof format === 'undefined') {
    format = inclusion;
    inclusion = false;
  }

  value = parseDate$1(value, format);
  targetValue = parseDate$1(targetValue, format);

  // if either is not valid.
  if (!value || !targetValue) {
    return false;
  }

  return isAfter(value, targetValue) || inclusion && isEqual$1(value, targetValue);
};

var options = {
  hasTarget: true,
  isDate: true
};

// required to convert from a list of array values to an object.
var paramNames = ['targetValue', 'inclusion', 'format'];

var after = {
  validate: afterValidator,
  options: options,
  paramNames: paramNames
};

/**
 * Some Alpha Regex helpers.
 * https://github.com/chriso/validator.js/blob/master/src/lib/alpha.js
 */

var alpha = {
  en: /^[A-Z]*$/i,
  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
  da: /^[A-ZÆØÅ]*$/i,
  de: /^[A-ZÄÖÜß]*$/i,
  es: /^[A-ZÁÉÍÑÓÚÜ]*$/i,
  fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
  it: /^[A-Z\xC0-\xFF]*$/i,
  lt: /^[A-ZĄČĘĖĮŠŲŪŽ]*$/i,
  nl: /^[A-ZÉËÏÓÖÜ]*$/i,
  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
  ru: /^[А-ЯЁ]*$/i,
  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
  sr: /^[A-ZČĆŽŠĐ]*$/i,
  sv: /^[A-ZÅÄÖ]*$/i,
  tr: /^[A-ZÇĞİıÖŞÜ]*$/i,
  uk: /^[А-ЩЬЮЯЄІЇҐ]*$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,
  az: /^[A-ZÇƏĞİıÖŞÜ]*$/i
};

var alphaSpaces = {
  en: /^[A-Z\s]*$/i,
  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s]*$/i,
  da: /^[A-ZÆØÅ\s]*$/i,
  de: /^[A-ZÄÖÜß\s]*$/i,
  es: /^[A-ZÁÉÍÑÓÚÜ\s]*$/i,
  fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی\s]*$/,
  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s]*$/i,
  it: /^[A-Z\xC0-\xFF\s]*$/i,
  lt: /^[A-ZĄČĘĖĮŠŲŪŽ\s]*$/i,
  nl: /^[A-ZÉËÏÓÖÜ\s]*$/i,
  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ\s]*$/i,
  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ\s]*$/i,
  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ\s]*$/i,
  ru: /^[А-ЯЁ\s]*$/i,
  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ\s]*$/i,
  sr: /^[A-ZČĆŽŠĐ\s]*$/i,
  sv: /^[A-ZÅÄÖ\s]*$/i,
  tr: /^[A-ZÇĞİıÖŞÜ\s]*$/i,
  uk: /^[А-ЩЬЮЯЄІЇҐ\s]*$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ\s]*$/,
  az: /^[A-ZÇƏĞİıÖŞÜ\s]*$/i
};

var alphanumeric = {
  en: /^[0-9A-Z]*$/i,
  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
  da: /^[0-9A-ZÆØÅ]$/i,
  de: /^[0-9A-ZÄÖÜß]*$/i,
  es: /^[0-9A-ZÁÉÍÑÓÚÜ]*$/i,
  fa: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
  it: /^[0-9A-Z\xC0-\xFF]*$/i,
  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ]*$/i,
  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
  nl: /^[0-9A-ZÉËÏÓÖÜ]*$/i,
  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
  ru: /^[0-9А-ЯЁ]*$/i,
  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
  sr: /^[0-9A-ZČĆŽŠĐ]*$/i,
  sv: /^[0-9A-ZÅÄÖ]*$/i,
  tr: /^[0-9A-ZÇĞİıÖŞÜ]*$/i,
  uk: /^[0-9А-ЩЬЮЯЄІЇҐ]*$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,
  az: /^[0-9A-ZÇƏĞİıÖŞÜ]*$/i
};

var alphaDash = {
  en: /^[0-9A-Z_-]*$/i,
  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ_-]*$/i,
  da: /^[0-9A-ZÆØÅ_-]*$/i,
  de: /^[0-9A-ZÄÖÜß_-]*$/i,
  es: /^[0-9A-ZÁÉÍÑÓÚÜ_-]*$/i,
  fa: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی_-]*$/,
  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ_-]*$/i,
  it: /^[0-9A-Z\xC0-\xFF_-]*$/i,
  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ_-]*$/i,
  nl: /^[0-9A-ZÉËÏÓÖÜ_-]*$/i,
  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ_-]*$/i,
  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ_-]*$/i,
  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ_-]*$/i,
  ru: /^[0-9А-ЯЁ_-]*$/i,
  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ_-]*$/i,
  sr: /^[0-9A-ZČĆŽŠĐ_-]*$/i,
  sv: /^[0-9A-ZÅÄÖ_-]*$/i,
  tr: /^[0-9A-ZÇĞİıÖŞÜ_-]*$/i,
  uk: /^[0-9А-ЩЬЮЯЄІЇҐ_-]*$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ_-]*$/,
  az: /^[0-9A-ZÇƏĞİıÖŞÜ_-]*$/i
};

var validate = function validate(value, ref) {
  if (ref === void 0) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) {
      return validate(val, [locale]);
    });
  }

  // Match at least one locale.
  if (!locale) {
    return Object.keys(alpha).some(function (loc) {
      return alpha[loc].test(value);
    });
  }

  return (alpha[locale] || alpha.en).test(value);
};

var paramNames$1 = ['locale'];

var alpha$1 = {
  validate: validate,
  paramNames: paramNames$1
};

var validate$1 = function validate$1(value, ref) {
  if (ref === void 0) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) {
      return validate$1(val, [locale]);
    });
  }

  // Match at least one locale.
  if (!locale) {
    return Object.keys(alphaDash).some(function (loc) {
      return alphaDash[loc].test(value);
    });
  }

  return (alphaDash[locale] || alphaDash.en).test(value);
};

var paramNames$2 = ['locale'];

var alpha_dash = {
  validate: validate$1,
  paramNames: paramNames$2
};

var validate$2 = function validate$2(value, ref) {
  if (ref === void 0) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) {
      return validate$2(val, [locale]);
    });
  }

  // Match at least one locale.
  if (!locale) {
    return Object.keys(alphanumeric).some(function (loc) {
      return alphanumeric[loc].test(value);
    });
  }

  return (alphanumeric[locale] || alphanumeric.en).test(value);
};

var paramNames$3 = ['locale'];

var alpha_num = {
  validate: validate$2,
  paramNames: paramNames$3
};

var validate$3 = function validate$3(value, ref) {
  if (ref === void 0) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) {
      return validate$3(val, [locale]);
    });
  }

  // Match at least one locale.
  if (!locale) {
    return Object.keys(alphaSpaces).some(function (loc) {
      return alphaSpaces[loc].test(value);
    });
  }

  return (alphaSpaces[locale] || alphaSpaces.en).test(value);
};

var paramNames$4 = ['locale'];

var alpha_spaces = {
  validate: validate$3,
  paramNames: paramNames$4
};

var validate$4 = function validate$4(value, ref) {
  if (ref === void 0) ref = {};
  var targetValue = ref.targetValue;
  var inclusion = ref.inclusion;if (inclusion === void 0) inclusion = false;
  var format = ref.format;

  if (typeof format === 'undefined') {
    format = inclusion;
    inclusion = false;
  }

  value = parseDate$1(value, format);
  targetValue = parseDate$1(targetValue, format);

  // if either is not valid.
  if (!value || !targetValue) {
    return false;
  }

  return isBefore(value, targetValue) || inclusion && isEqual$1(value, targetValue);
};

var options$1 = {
  hasTarget: true,
  isDate: true
};

var paramNames$5 = ['targetValue', 'inclusion', 'format'];

var before = {
  validate: validate$4,
  options: options$1,
  paramNames: paramNames$5
};

var validate$5 = function validate$5(value, ref) {
  if (ref === void 0) ref = {};
  var min = ref.min;
  var max = ref.max;

  if (Array.isArray(value)) {
    return value.every(function (val) {
      return validate$5(val, { min: min, max: max });
    });
  }

  return Number(min) <= value && Number(max) >= value;
};

var paramNames$6 = ['min', 'max'];

var between = {
  validate: validate$5,
  paramNames: paramNames$6
};

var validate$6 = function validate$6(value, ref) {
  var targetValue = ref.targetValue;

  return String(value) === String(targetValue);
};
var options$2 = {
  hasTarget: true
};

var paramNames$7 = ['targetValue'];

var confirmed = {
  validate: validate$6,
  options: options$2,
  paramNames: paramNames$7
};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var assertString_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = assertString;

  function _typeof(obj) {
    if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };
    }return _typeof(obj);
  }

  function assertString(input) {
    var isString = typeof input === 'string' || input instanceof String;

    if (!isString) {
      var invalidType;

      if (input === null) {
        invalidType = 'null';
      } else {
        invalidType = _typeof(input);

        if (invalidType === 'object' && input.constructor && input.constructor.hasOwnProperty('name')) {
          invalidType = input.constructor.name;
        } else {
          invalidType = "a ".concat(invalidType);
        }
      }

      throw new TypeError("Expected string but received ".concat(invalidType, "."));
    }
  }

  module.exports = exports.default;
  module.exports.default = exports.default;
});

unwrapExports(assertString_1);

var isCreditCard_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isCreditCard;

  var _assertString = _interopRequireDefault(assertString_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  /* eslint-disable max-len */
  var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14})$/;
  /* eslint-enable max-len */

  function isCreditCard(str) {
    (0, _assertString.default)(str);
    var sanitized = str.replace(/[- ]+/g, '');

    if (!creditCard.test(sanitized)) {
      return false;
    }

    var sum = 0;
    var digit;
    var tmpNum;
    var shouldDouble;

    for (var i = sanitized.length - 1; i >= 0; i--) {
      digit = sanitized.substring(i, i + 1);
      tmpNum = parseInt(digit, 10);

      if (shouldDouble) {
        tmpNum *= 2;

        if (tmpNum >= 10) {
          sum += tmpNum % 10 + 1;
        } else {
          sum += tmpNum;
        }
      } else {
        sum += tmpNum;
      }

      shouldDouble = !shouldDouble;
    }

    return !!(sum % 10 === 0 ? sanitized : false);
  }

  module.exports = exports.default;
  module.exports.default = exports.default;
});

var isCreditCard = unwrapExports(isCreditCard_1);

var validate$7 = function validate$7(value) {
  return isCreditCard(String(value));
};

var credit_card = {
  validate: validate$7
};

var validate$8 = function validate$8(value, ref) {
  if (ref === void 0) ref = {};
  var min = ref.min;
  var max = ref.max;
  var inclusivity = ref.inclusivity;if (inclusivity === void 0) inclusivity = '()';
  var format = ref.format;

  if (typeof format === 'undefined') {
    format = inclusivity;
    inclusivity = '()';
  }

  var minDate = parseDate$1(String(min), format);
  var maxDate = parseDate$1(String(max), format);
  var dateVal = parseDate$1(String(value), format);

  if (!minDate || !maxDate || !dateVal) {
    return false;
  }

  if (inclusivity === '()') {
    return isAfter(dateVal, minDate) && isBefore(dateVal, maxDate);
  }

  if (inclusivity === '(]') {
    return isAfter(dateVal, minDate) && (isEqual$1(dateVal, maxDate) || isBefore(dateVal, maxDate));
  }

  if (inclusivity === '[)') {
    return isBefore(dateVal, maxDate) && (isEqual$1(dateVal, minDate) || isAfter(dateVal, minDate));
  }

  return isEqual$1(dateVal, maxDate) || isEqual$1(dateVal, minDate) || isBefore(dateVal, maxDate) && isAfter(dateVal, minDate);
};

var options$3 = {
  isDate: true
};

var paramNames$8 = ['min', 'max', 'inclusivity', 'format'];

var date_between = {
  validate: validate$8,
  options: options$3,
  paramNames: paramNames$8
};

var validate$9 = function validate$9(value, ref) {
  var format = ref.format;

  return !!parseDate$1(value, format);
};

var options$4 = {
  isDate: true
};

var paramNames$9 = ['format'];

var date_format = {
  validate: validate$9,
  options: options$4,
  paramNames: paramNames$9
};

var validate$a = function validate$a(value, ref) {
  if (ref === void 0) ref = {};
  var decimals = ref.decimals;if (decimals === void 0) decimals = '*';
  var separator = ref.separator;if (separator === void 0) separator = '.';

  if (isNullOrUndefined(value) || value === '') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.every(function (val) {
      return validate$a(val, { decimals: decimals, separator: separator });
    });
  }

  // if is 0.
  if (Number(decimals) === 0) {
    return (/^-?\d*$/.test(value)
    );
  }

  var regexPart = decimals === '*' ? '+' : "{1," + decimals + "}";
  var regex = new RegExp("^[-+]?\\d*(\\" + separator + "\\d" + regexPart + ")?([eE]{1}[-]?\\d+)?$");

  if (!regex.test(value)) {
    return false;
  }

  var parsedValue = parseFloat(value);

  // eslint-disable-next-line
  return parsedValue === parsedValue;
};

var paramNames$a = ['decimals', 'separator'];

var decimal = {
  validate: validate$a,
  paramNames: paramNames$a
};

var validate$b = function validate$b(value, ref) {
  var length = ref[0];

  if (Array.isArray(value)) {
    return value.every(function (val) {
      return validate$b(val, [length]);
    });
  }
  var strVal = String(value);

  return (/^[0-9]*$/.test(strVal) && strVal.length === Number(length)
  );
};

var digits = {
  validate: validate$b
};

var imageRegex = /\.(jpg|svg|jpeg|png|bmp|gif)$/i;

var validateImage = function validateImage(file, width, height) {
  var URL = window.URL || window.webkitURL;
  return new Promise(function (resolve) {
    var image = new Image();
    image.onerror = function () {
      return resolve({ valid: false });
    };
    image.onload = function () {
      return resolve({
        valid: image.width === Number(width) && image.height === Number(height)
      });
    };

    image.src = URL.createObjectURL(file);
  });
};

var validate$c = function validate$c(files, ref) {
  var width = ref[0];
  var height = ref[1];

  var images = ensureArray(files).filter(function (file) {
    return imageRegex.test(file.name);
  });
  if (images.length === 0) {
    return false;
  }
  return Promise.all(images.map(function (image) {
    return validateImage(image, width, height);
  }));
};

var dimensions = {
  validate: validate$c
};

var merge_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = merge;

  function merge() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaults = arguments.length > 1 ? arguments[1] : undefined;

    for (var key in defaults) {
      if (typeof obj[key] === 'undefined') {
        obj[key] = defaults[key];
      }
    }

    return obj;
  }

  module.exports = exports.default;
  module.exports.default = exports.default;
});

unwrapExports(merge_1);

var isByteLength_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isByteLength;

  var _assertString = _interopRequireDefault(assertString_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };
    }return _typeof(obj);
  }

  /* eslint-disable prefer-rest-params */
  function isByteLength(str, options) {
    (0, _assertString.default)(str);
    var min;
    var max;

    if (_typeof(options) === 'object') {
      min = options.min || 0;
      max = options.max;
    } else {
      // backwards compatibility: isByteLength(str, min [, max])
      min = arguments[1];
      max = arguments[2];
    }

    var len = encodeURI(str).split(/%..|./).length - 1;
    return len >= min && (typeof max === 'undefined' || len <= max);
  }

  module.exports = exports.default;
  module.exports.default = exports.default;
});

unwrapExports(isByteLength_1);

var isFQDN_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isFQDN;

  var _assertString = _interopRequireDefault(assertString_1);

  var _merge = _interopRequireDefault(merge_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  var default_fqdn_options = {
    require_tld: true,
    allow_underscores: false,
    allow_trailing_dot: false
  };

  function isFQDN(str, options) {
    (0, _assertString.default)(str);
    options = (0, _merge.default)(options, default_fqdn_options);
    /* Remove the optional trailing dot before checking validity */

    if (options.allow_trailing_dot && str[str.length - 1] === '.') {
      str = str.substring(0, str.length - 1);
    }

    var parts = str.split('.');

    for (var i = 0; i < parts.length; i++) {
      if (parts[i].length > 63) {
        return false;
      }
    }

    if (options.require_tld) {
      var tld = parts.pop();

      if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
        return false;
      } // disallow spaces


      if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
        return false;
      }
    }

    for (var part, _i = 0; _i < parts.length; _i++) {
      part = parts[_i];

      if (options.allow_underscores) {
        part = part.replace(/_/g, '');
      }

      if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
        return false;
      } // disallow full-width chars


      if (/[\uff01-\uff5e]/.test(part)) {
        return false;
      }

      if (part[0] === '-' || part[part.length - 1] === '-') {
        return false;
      }
    }

    return true;
  }

  module.exports = exports.default;
  module.exports.default = exports.default;
});

var isFQDN = unwrapExports(isFQDN_1);

var isIP_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isIP;

  var _assertString = _interopRequireDefault(assertString_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
  var ipv6Block = /^[0-9A-F]{1,4}$/i;

  function isIP(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    (0, _assertString.default)(str);
    version = String(version);

    if (!version) {
      return isIP(str, 4) || isIP(str, 6);
    } else if (version === '4') {
      if (!ipv4Maybe.test(str)) {
        return false;
      }

      var parts = str.split('.').sort(function (a, b) {
        return a - b;
      });
      return parts[3] <= 255;
    } else if (version === '6') {
      var blocks = str.split(':');
      var foundOmissionBlock = false; // marker to indicate ::
      // At least some OS accept the last 32 bits of an IPv6 address
      // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
      // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
      // and '::a.b.c.d' is deprecated, but also valid.

      var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
      var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;

      if (blocks.length > expectedNumberOfBlocks) {
        return false;
      } // initial or final ::


      if (str === '::') {
        return true;
      } else if (str.substr(0, 2) === '::') {
        blocks.shift();
        blocks.shift();
        foundOmissionBlock = true;
      } else if (str.substr(str.length - 2) === '::') {
        blocks.pop();
        blocks.pop();
        foundOmissionBlock = true;
      }

      for (var i = 0; i < blocks.length; ++i) {
        // test for a :: which can not be at the string start/end
        // since those cases have been handled above
        if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
          if (foundOmissionBlock) {
            return false; // multiple :: in address
          }

          foundOmissionBlock = true;
        } else if (foundIPv4TransitionBlock && i === blocks.length - 1) ;else if (!ipv6Block.test(blocks[i])) {
          return false;
        }
      }

      if (foundOmissionBlock) {
        return blocks.length >= 1;
      }

      return blocks.length === expectedNumberOfBlocks;
    }

    return false;
  }

  module.exports = exports.default;
  module.exports.default = exports.default;
});

var isIP = unwrapExports(isIP_1);

var isEmail_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isEmail;

  var _assertString = _interopRequireDefault(assertString_1);

  var _merge = _interopRequireDefault(merge_1);

  var _isByteLength = _interopRequireDefault(isByteLength_1);

  var _isFQDN = _interopRequireDefault(isFQDN_1);

  var _isIP = _interopRequireDefault(isIP_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  var default_email_options = {
    allow_display_name: false,
    require_display_name: false,
    allow_utf8_local_part: true,
    require_tld: true
  };
  /* eslint-disable max-len */

  /* eslint-disable no-control-regex */

  var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
  var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
  var gmailUserPart = /^[a-z\d]+$/;
  var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
  var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
  var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
  /* eslint-enable max-len */

  /* eslint-enable no-control-regex */

  function isEmail(str, options) {
    (0, _assertString.default)(str);
    options = (0, _merge.default)(options, default_email_options);

    if (options.require_display_name || options.allow_display_name) {
      var display_email = str.match(displayName);

      if (display_email) {
        str = display_email[1];
      } else if (options.require_display_name) {
        return false;
      }
    }

    var parts = str.split('@');
    var domain = parts.pop();
    var user = parts.join('@');
    var lower_domain = domain.toLowerCase();

    if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
      /*
        Previously we removed dots for gmail addresses before validating.
        This was removed because it allows `multiple..dots@gmail.com`
        to be reported as valid, but it is not.
        Gmail only normalizes single dots, removing them from here is pointless,
        should be done in normalizeEmail
      */
      user = user.toLowerCase(); // Removing sub-address from username before gmail validation

      var username = user.split('+')[0]; // Dots are not included in gmail length restriction

      if (!(0, _isByteLength.default)(username.replace('.', ''), {
        min: 6,
        max: 30
      })) {
        return false;
      }

      var _user_parts = username.split('.');

      for (var i = 0; i < _user_parts.length; i++) {
        if (!gmailUserPart.test(_user_parts[i])) {
          return false;
        }
      }
    }

    if (!(0, _isByteLength.default)(user, {
      max: 64
    }) || !(0, _isByteLength.default)(domain, {
      max: 254
    })) {
      return false;
    }

    if (!(0, _isFQDN.default)(domain, {
      require_tld: options.require_tld
    })) {
      if (!options.allow_ip_domain) {
        return false;
      }

      if (!(0, _isIP.default)(domain)) {
        if (!domain.startsWith('[') || !domain.endsWith(']')) {
          return false;
        }

        var noBracketdomain = domain.substr(1, domain.length - 2);

        if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
          return false;
        }
      }
    }

    if (user[0] === '"') {
      user = user.slice(1, user.length - 1);
      return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
    }

    var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
    var user_parts = user.split('.');

    for (var _i = 0; _i < user_parts.length; _i++) {
      if (!pattern.test(user_parts[_i])) {
        return false;
      }
    }

    return true;
  }

  module.exports = exports.default;
  module.exports.default = exports.default;
});

var isEmail = unwrapExports(isEmail_1);

function objectWithoutProperties(obj, exclude) {
  var target = {};for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }return target;
}

var validate$d = function validate$d(value, ref) {
  if (ref === void 0) ref = {};
  var multiple = ref.multiple;if (multiple === void 0) multiple = false;
  var rest = objectWithoutProperties(ref, ["multiple"]);
  var options = rest;

  if (multiple && !Array.isArray(value)) {
    value = String(value).split(',').map(function (emailStr) {
      return emailStr.trim();
    });
  }

  var validatorOptions = assign({}, options);

  if (Array.isArray(value)) {
    return value.every(function (val) {
      return isEmail(String(val), validatorOptions);
    });
  }

  return isEmail(String(value), validatorOptions);
};

var email = {
  validate: validate$d
};

var validate$e = function validate$e(value, options) {
  if (Array.isArray(value)) {
    return value.every(function (val) {
      return validate$e(val, options);
    });
  }

  return toArray(options).some(function (item) {
    // eslint-disable-next-line
    return item == value;
  });
};

var included = {
  validate: validate$e
};

var validate$f = function validate$f() {
  var args = [],
      len = arguments.length;
  while (len--) {
    args[len] = arguments[len];
  }return !validate$e.apply(void 0, args);
};

var excluded = {
  validate: validate$f
};

var validate$g = function validate$g(files, extensions) {
  var regex = new RegExp(".(" + extensions.join('|') + ")$", 'i');
  return ensureArray(files).every(function (file) {
    return regex.test(file.name);
  });
};

var ext = {
  validate: validate$g
};

var validate$h = function validate$h(files) {
  return (Array.isArray(files) ? files : [files]).every(function (file) {
    return (/\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(file.name)
    );
  });
};

var image = {
  validate: validate$h
};

var validate$i = function validate$i(value) {
  if (Array.isArray(value)) {
    return value.every(function (val) {
      return (/^-?[0-9]+$/.test(String(val))
      );
    });
  }

  return (/^-?[0-9]+$/.test(String(value))
  );
};

var integer = {
  validate: validate$i
};

var validate$j = function validate$j(value, ref) {
  if (ref === void 0) ref = {};
  var version = ref.version;if (version === void 0) version = 4;

  if (isNullOrUndefined(value)) {
    value = '';
  }

  if (Array.isArray(value)) {
    return value.every(function (val) {
      return isIP(val, version);
    });
  }

  return isIP(value, version);
};

var paramNames$b = ['version'];

var ip = {
  validate: validate$j,
  paramNames: paramNames$b
};

var validate$k = function validate$k(value) {
  if (isNullOrUndefined(value)) {
    value = '';
  }

  if (Array.isArray(value)) {
    return value.every(function (val) {
      return isIP(val, '') || isFQDN(val);
    });
  }

  return isIP(value, '') || isFQDN(value);
};

var ip_or_fqdn = {
  validate: validate$k
};

var validate$l = function validate$l(value, ref) {
  if (ref === void 0) ref = [];
  var other = ref[0];

  return value === other;
};

var is = {
  validate: validate$l
};

var validate$m = function validate$m(value, ref) {
  if (ref === void 0) ref = [];
  var other = ref[0];

  return value !== other;
};

var is_not = {
  validate: validate$m
};

/**
 * @param {Array|String} value
 * @param {Number} length
 * @param {Number} max
 */
var compare = function compare(value, length, max) {
  if (max === undefined) {
    return value.length === length;
  }

  // cast to number.
  max = Number(max);

  return value.length >= length && value.length <= max;
};

var validate$n = function validate$n(value, ref) {
  var length = ref[0];
  var max = ref[1];if (max === void 0) max = undefined;

  if (isNullOrUndefined(value)) {
    return false;
  }

  length = Number(length);
  if (typeof value === 'number') {
    value = String(value);
  }

  if (!value.length) {
    value = toArray(value);
  }

  return compare(value, length, max);
};

var length = {
  validate: validate$n
};

var validate$o = function validate$o(value, ref) {
  var length = ref[0];

  if (isNullOrUndefined(value)) {
    return length >= 0;
  }

  if (Array.isArray(value)) {
    return value.every(function (val) {
      return validate$o(val, [length]);
    });
  }

  return String(value).length <= length;
};

var max = {
  validate: validate$o
};

var validate$p = function validate$p(value, ref) {
  var max = ref[0];

  if (isNullOrUndefined(value) || value === '') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0 && value.every(function (val) {
      return validate$p(val, [max]);
    });
  }

  return Number(value) <= max;
};

var max_value = {
  validate: validate$p
};

var validate$q = function validate$q(files, mimes) {
  var regex = new RegExp(mimes.join('|').replace('*', '.+') + "$", 'i');
  return ensureArray(files).every(function (file) {
    return regex.test(file.type);
  });
};

var mimes = {
  validate: validate$q
};

var validate$r = function validate$r(value, ref) {
  var length = ref[0];

  if (isNullOrUndefined(value)) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.every(function (val) {
      return validate$r(val, [length]);
    });
  }

  return String(value).length >= length;
};

var min = {
  validate: validate$r
};

var validate$s = function validate$s(value, ref) {
  var min = ref[0];

  if (isNullOrUndefined(value) || value === '') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0 && value.every(function (val) {
      return validate$s(val, [min]);
    });
  }

  return Number(value) >= min;
};

var min_value = {
  validate: validate$s
};

var ar = /^[٠١٢٣٤٥٦٧٨٩]+$/;
var en = /^[0-9]+$/;

var validate$t = function validate$t(value) {
  var testValue = function testValue(val) {
    var strValue = String(val);

    return en.test(strValue) || ar.test(strValue);
  };

  if (Array.isArray(value)) {
    return value.every(testValue);
  }

  return testValue(value);
};

var numeric = {
  validate: validate$t
};

var validate$u = function validate$u(value, ref) {
  var expression = ref.expression;

  if (typeof expression === 'string') {
    expression = new RegExp(expression);
  }

  if (Array.isArray(value)) {
    return value.every(function (val) {
      return validate$u(val, { expression: expression });
    });
  }

  return expression.test(String(value));
};

var paramNames$c = ['expression'];

var regex = {
  validate: validate$u,
  paramNames: paramNames$c
};

var validate$v = function validate$v(value, ref) {
  if (ref === void 0) ref = [];
  var invalidateFalse = ref[0];if (invalidateFalse === void 0) invalidateFalse = false;

  if (isNullOrUndefined(value) || isEmptyArray(value)) {
    return false;
  }

  // incase a field considers `false` as an empty value like checkboxes.
  if (value === false && invalidateFalse) {
    return false;
  }

  return !!String(value).trim().length;
};

var required = {
  validate: validate$v
};

var validate$w = function validate$w(value, ref) {
  if (ref === void 0) ref = [];
  var otherFieldVal = ref[0];
  var possibleVals = ref.slice(1);

  var required = possibleVals.includes(String(otherFieldVal).trim());

  if (!required) {
    return {
      valid: true,
      data: {
        required: required
      }
    };
  }

  var invalid = isEmptyArray(value) || [false, null, undefined].includes(value);

  invalid = invalid || !String(value).trim().length;

  return {
    valid: !invalid,
    data: {
      required: required
    }
  };
};

var options$5 = {
  hasTarget: true,
  computesRequired: true
};

var required_if = {
  validate: validate$w,
  options: options$5
};

var validate$x = function validate$x(files, ref) {
  var size = ref[0];

  if (isNaN(size)) {
    return false;
  }
  var nSize = Number(size) * 1024;
  return ensureArray(files).every(function (file) {
    return file.size <= nSize;
  });
};

var size = {
  validate: validate$x
};

var isURL_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isURL;

  var _assertString = _interopRequireDefault(assertString_1);

  var _isFQDN = _interopRequireDefault(isFQDN_1);

  var _isIP = _interopRequireDefault(isIP_1);

  var _merge = _interopRequireDefault(merge_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  var default_url_options = {
    protocols: ['http', 'https', 'ftp'],
    require_tld: true,
    require_protocol: false,
    require_host: true,
    require_valid_protocol: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_protocol_relative_urls: false
  };
  var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;

  function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
  }

  function checkHost(host, matches) {
    for (var i = 0; i < matches.length; i++) {
      var match = matches[i];

      if (host === match || isRegExp(match) && match.test(host)) {
        return true;
      }
    }

    return false;
  }

  function isURL(url, options) {
    (0, _assertString.default)(url);

    if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
      return false;
    }

    if (url.indexOf('mailto:') === 0) {
      return false;
    }

    options = (0, _merge.default)(options, default_url_options);
    var protocol, auth, host, hostname, port, port_str, split, ipv6;
    split = url.split('#');
    url = split.shift();
    split = url.split('?');
    url = split.shift();
    split = url.split('://');

    if (split.length > 1) {
      protocol = split.shift().toLowerCase();

      if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
        return false;
      }
    } else if (options.require_protocol) {
      return false;
    } else if (url.substr(0, 2) === '//') {
      if (!options.allow_protocol_relative_urls) {
        return false;
      }

      split[0] = url.substr(2);
    }

    url = split.join('://');

    if (url === '') {
      return false;
    }

    split = url.split('/');
    url = split.shift();

    if (url === '' && !options.require_host) {
      return true;
    }

    split = url.split('@');

    if (split.length > 1) {
      if (options.disallow_auth) {
        return false;
      }

      auth = split.shift();

      if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
        return false;
      }
    }

    hostname = split.join('@');
    port_str = null;
    ipv6 = null;
    var ipv6_match = hostname.match(wrapped_ipv6);

    if (ipv6_match) {
      host = '';
      ipv6 = ipv6_match[1];
      port_str = ipv6_match[2] || null;
    } else {
      split = hostname.split(':');
      host = split.shift();

      if (split.length) {
        port_str = split.join(':');
      }
    }

    if (port_str !== null) {
      port = parseInt(port_str, 10);

      if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
        return false;
      }
    }

    if (!(0, _isIP.default)(host) && !(0, _isFQDN.default)(host, options) && (!ipv6 || !(0, _isIP.default)(ipv6, 6))) {
      return false;
    }

    host = host || ipv6;

    if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
      return false;
    }

    if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
      return false;
    }

    return true;
  }

  module.exports = exports.default;
  module.exports.default = exports.default;
});

var isURL = unwrapExports(isURL_1);

var validate$y = function validate$y(value, options) {
  if (options === void 0) options = {};

  if (isNullOrUndefined(value)) {
    value = '';
  }

  var validatorOptions = assign({}, options);

  if (Array.isArray(value)) {
    return value.every(function (val) {
      return isURL(val, validatorOptions);
    });
  }

  return isURL(value, validatorOptions);
};

var url = {
  validate: validate$y
};

/* eslint-disable camelcase */

var Rules = /*#__PURE__*/Object.freeze({
  after: after,
  alpha_dash: alpha_dash,
  alpha_num: alpha_num,
  alpha_spaces: alpha_spaces,
  alpha: alpha$1,
  before: before,
  between: between,
  confirmed: confirmed,
  credit_card: credit_card,
  date_between: date_between,
  date_format: date_format,
  decimal: decimal,
  digits: digits,
  dimensions: dimensions,
  email: email,
  ext: ext,
  image: image,
  included: included,
  integer: integer,
  length: length,
  ip: ip,
  ip_or_fqdn: ip_or_fqdn,
  is_not: is_not,
  is: is,
  max: max,
  max_value: max_value,
  mimes: mimes,
  min: min,
  min_value: min_value,
  excluded: excluded,
  numeric: numeric,
  regex: regex,
  required: required,
  required_if: required_if,
  size: size,
  url: url
});

// 

var normalize = function normalize(fields) {
  if (Array.isArray(fields)) {
    return fields.reduce(function (prev, curr) {
      if (includes(curr, '.')) {
        prev[curr.split('.')[1]] = curr;
      } else {
        prev[curr] = curr;
      }

      return prev;
    }, {});
  }

  return fields;
};

// Combines two flags using either AND or OR depending on the flag type.
var combine = function combine(lhs, rhs) {
  var mapper = {
    pristine: function pristine(lhs, rhs) {
      return lhs && rhs;
    },
    dirty: function dirty(lhs, rhs) {
      return lhs || rhs;
    },
    touched: function touched(lhs, rhs) {
      return lhs || rhs;
    },
    untouched: function untouched(lhs, rhs) {
      return lhs && rhs;
    },
    valid: function valid(lhs, rhs) {
      return lhs && rhs;
    },
    invalid: function invalid(lhs, rhs) {
      return lhs || rhs;
    },
    pending: function pending(lhs, rhs) {
      return lhs || rhs;
    },
    required: function required(lhs, rhs) {
      return lhs || rhs;
    },
    validated: function validated(lhs, rhs) {
      return lhs && rhs;
    }
  };

  return Object.keys(mapper).reduce(function (flags, flag) {
    flags[flag] = mapper[flag](lhs[flag], rhs[flag]);

    return flags;
  }, {});
};

var mapScope = function mapScope(scope, deep) {
  if (deep === void 0) deep = true;

  return Object.keys(scope).reduce(function (flags, field) {
    if (!flags) {
      flags = assign({}, scope[field]);
      return flags;
    }

    // scope.
    var isScope = field.indexOf('$') === 0;
    if (deep && isScope) {
      return combine(mapScope(scope[field]), flags);
    } else if (!deep && isScope) {
      return flags;
    }

    flags = combine(flags, scope[field]);

    return flags;
  }, null);
};

/**
 * Maps fields to computed functions.
 */
var mapFields = function mapFields(fields) {
  if (!fields) {
    return function () {
      return mapScope(this.$validator.flags);
    };
  }

  var normalized = normalize(fields);
  return Object.keys(normalized).reduce(function (prev, curr) {
    var field = normalized[curr];
    prev[curr] = function mappedField() {
      // if field exists
      if (this.$validator.flags[field]) {
        return this.$validator.flags[field];
      }

      // scopeless fields were selected.
      if (normalized[curr] === '*') {
        return mapScope(this.$validator.flags, false);
      }

      // if it has a scope defined
      var index = field.indexOf('.');
      if (index <= 0) {
        return {};
      }

      var ref = field.split('.');
      var scope = ref[0];
      var name = ref.slice(1);

      scope = this.$validator.flags["$" + scope];
      name = name.join('.');

      // an entire scope was selected: scope.*
      if (name === '*' && scope) {
        return mapScope(scope);
      }

      if (scope && scope[name]) {
        return scope[name];
      }

      return {};
    };

    return prev;
  }, {});
};

var $validator = null;

var PROVIDER_COUNTER = 0;

var ValidationProvider = {
  $__veeInject: false,
  inject: {
    $_veeObserver: {
      from: '$_veeObserver',
      default: function default$1() {
        if (!this.$vnode.context.$_veeObserver) {
          this.$vnode.context.$_veeObserver = createObserver();
        }

        return this.$vnode.context.$_veeObserver;
      }
    }
  },
  props: {
    vid: {
      type: [String, Number],
      default: function _default() {
        PROVIDER_COUNTER++;

        return "_vee_" + PROVIDER_COUNTER;
      }
    },
    name: {
      type: String,
      default: null
    },
    mode: {
      type: [String, Function],
      default: function _default() {
        return getConfig().mode;
      }
    },
    events: {
      type: Array,
      validate: function validate() {
        /* istanbul ignore next */
        if (false) {
          warn('events prop and config will be deprecated in future version please use the interaction modes instead');
        }

        return true;
      },
      default: function _default() {
        var events = getConfig().events;
        if (typeof events === 'string') {
          return events.split('|');
        }

        return events;
      }
    },
    rules: {
      type: [Object, String],
      default: null
    },
    immediate: {
      type: Boolean,
      default: false
    },
    persist: {
      type: Boolean,
      default: false
    },
    bails: {
      type: Boolean,
      default: function _default() {
        return getConfig().fastExit;
      }
    },
    debounce: {
      type: Number,
      default: function _default() {
        return getConfig().delay || 0;
      }
    },
    tag: {
      type: String,
      default: 'span'
    },
    slim: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    rules: {
      deep: true,
      handler: function handler(val, oldVal) {
        this._needsValidation = !isEqual(val, oldVal);
      }
    }
  },
  data: function data() {
    return {
      messages: [],
      value: undefined,
      initialized: false,
      initialValue: undefined,
      flags: createFlags(),
      failedRules: {},
      forceRequired: false,
      isDeactivated: false,
      id: null
    };
  },
  computed: {
    isValid: function isValid() {
      return this.flags.valid;
    },
    fieldDeps: function fieldDeps() {
      var this$1 = this;

      var rules = normalizeRules(this.rules);

      return Object.keys(rules).filter(RuleContainer.isTargetRule).map(function (rule) {
        var depName = rules[rule][0];
        watchCrossFieldDep(this$1, depName);

        return depName;
      });
    },
    normalizedEvents: function normalizedEvents() {
      var this$1 = this;

      var ref = computeModeSetting(this);
      var on = ref.on;

      return normalizeEvents(on || this.events || []).map(function (e) {
        if (e === 'input') {
          return this$1._inputEventName;
        }

        return e;
      });
    },
    isRequired: function isRequired() {
      var rules = normalizeRules(this.rules);
      var forceRequired = this.forceRequired;

      var isRequired = rules.required || forceRequired;
      this.flags.required = isRequired;

      return isRequired;
    },
    classes: function classes() {
      var this$1 = this;

      var names = getConfig().classNames;
      return Object.keys(this.flags).reduce(function (classes, flag) {
        var className = names && names[flag] || flag;
        if (isNullOrUndefined(this$1.flags[flag])) {
          return classes;
        }

        if (className) {
          classes[className] = this$1.flags[flag];
        }

        return classes;
      }, {});
    }
  },
  render: function render(h) {
    var this$1 = this;

    this.registerField();
    var ctx = createValidationCtx(this);

    // Gracefully handle non-existent scoped slots.
    var slot = this.$scopedSlots.default;
    /* istanbul ignore next */
    if (!isCallable(slot)) {
      if (false) {
        warn('ValidationProvider expects a scoped slot. Did you forget to add "v-slot" to your slot?');
      }

      return h(this.tag, this.$slots.default);
    }

    var nodes = slot(ctx);
    // Handle single-root slot.
    extractVNodes(nodes).forEach(function (input) {
      addListeners.call(this$1, input);
    });

    return this.slim ? createRenderless(h, nodes) : h(this.tag, nodes);
  },
  beforeDestroy: function beforeDestroy() {
    // cleanup reference.
    this.$_veeObserver.unsubscribe(this);
  },
  activated: function activated() {
    this.$_veeObserver.subscribe(this);
    this.isDeactivated = false;
  },
  deactivated: function deactivated() {
    this.$_veeObserver.unsubscribe(this);
    this.isDeactivated = true;
  },
  methods: {
    setFlags: function setFlags(flags) {
      var this$1 = this;

      Object.keys(flags).forEach(function (flag) {
        this$1.flags[flag] = flags[flag];
      });
    },
    syncValue: function syncValue(e) {
      var value = normalizeValue$1(e);
      this.value = value;
      this.flags.changed = this.initialValue !== value;
    },
    reset: function reset() {
      this.messages = [];
      this._pendingValidation = null;
      this.initialValue = this.value;
      var flags = createFlags();
      this.setFlags(flags);
    },
    validate: function validate() {
      var this$1 = this;
      var args = [],
          len = arguments.length;
      while (len--) {
        args[len] = arguments[len];
      }if (args.length > 0) {
        this.syncValue(args[0]);
      }

      return this.validateSilent().then(function (result) {
        this$1.applyResult(result);

        return result;
      });
    },
    validateSilent: function validateSilent() {
      var this$1 = this;

      this.setFlags({ pending: true });

      return $validator.verify(this.value, this.rules, {
        name: this.name,
        values: createValuesLookup(this),
        bails: this.bails
      }).then(function (result) {
        this$1.setFlags({ pending: false });
        if (!this$1.isRequired) {
          this$1.setFlags({ valid: result.valid, invalid: !result.valid });
        }

        return result;
      });
    },
    applyResult: function applyResult(ref) {
      var errors = ref.errors;
      var failedRules = ref.failedRules;

      this.messages = errors;
      this.failedRules = assign({}, failedRules);
      this.setFlags({
        valid: !errors.length,
        changed: this.value !== this.initialValue,
        invalid: !!errors.length,
        validated: true
      });
    },
    registerField: function registerField() {
      if (!$validator) {
        $validator = getValidator() || new Validator(null, { fastExit: getConfig().fastExit });
      }

      updateRenderingContextRefs(this);
    }
  }
};

function createValidationCtx(ctx) {
  return {
    errors: ctx.messages,
    flags: ctx.flags,
    classes: ctx.classes,
    valid: ctx.isValid,
    failedRules: ctx.failedRules,
    reset: function reset() {
      return ctx.reset();
    },
    validate: function validate() {
      var args = [],
          len = arguments.length;
      while (len--) {
        args[len] = arguments[len];
      }return ctx.validate.apply(ctx, args);
    },
    aria: {
      'aria-invalid': ctx.flags.invalid ? 'true' : 'false',
      'aria-required': ctx.isRequired ? 'true' : 'false'
    }
  };
}

function normalizeValue$1(value) {
  if (isEvent(value)) {
    return value.target.type === 'file' ? toArray(value.target.files) : value.target.value;
  }

  return value;
}

/**
 * Determines if a provider needs to run validation.
 */
function shouldValidate(ctx, model) {
  // when an immediate/initial validation is needed and wasn't done before.
  if (!ctx._ignoreImmediate && ctx.immediate) {
    return true;
  }

  // when the value changes for whatever reason.
  if (ctx.value !== model.value) {
    return true;
  }

  // when it needs validation due to props/cross-fields changes.
  if (ctx._needsValidation) {
    return true;
  }

  // when the initial value is undefined and the field wasn't rendered yet.
  if (!ctx.initialized && model.value === undefined) {
    return true;
  }

  return false;
}

function computeModeSetting(ctx) {
  var compute = isCallable(ctx.mode) ? ctx.mode : modes[ctx.mode];

  return compute({
    errors: ctx.messages,
    value: ctx.value,
    flags: ctx.flags
  });
}

function onRenderUpdate(model) {
  if (!this.initialized) {
    this.initialValue = model.value;
  }

  var validateNow = shouldValidate(this, model);
  this._needsValidation = false;
  this.value = model.value;
  this._ignoreImmediate = true;

  if (!validateNow) {
    return;
  }

  this.validateSilent().then(this.immediate || this.flags.validated ? this.applyResult : function (x) {
    return x;
  });
}

// Creates the common handlers for a validatable context.
function createCommonHandlers(ctx) {
  var onInput = function onInput(e) {
    ctx.syncValue(e); // track and keep the value updated.
    ctx.setFlags({ dirty: true, pristine: false });
  };

  // Blur event listener.
  var onBlur = function onBlur() {
    ctx.setFlags({ touched: true, untouched: false });
  };

  var onValidate = ctx.$veeHandler;
  var mode = computeModeSetting(ctx);

  // Handle debounce changes.
  if (!onValidate || ctx.$veeDebounce !== ctx.debounce) {
    onValidate = debounce(function () {
      ctx.$nextTick(function () {
        var pendingPromise = ctx.validateSilent();
        // avoids race conditions between successive validations.
        ctx._pendingValidation = pendingPromise;
        pendingPromise.then(function (result) {
          if (pendingPromise === ctx._pendingValidation) {
            ctx.applyResult(result);
            ctx._pendingValidation = null;
          }
        });
      });
    }, mode.debounce || ctx.debounce);

    // Cache the handler so we don't create it each time.
    ctx.$veeHandler = onValidate;
    // cache the debounce value so we detect if it was changed.
    ctx.$veeDebounce = ctx.debounce;
  }

  return { onInput: onInput, onBlur: onBlur, onValidate: onValidate };
}

// Adds all plugin listeners to the vnode.
function addListeners(node) {
  var model = findModel(node);
  // cache the input eventName.
  this._inputEventName = this._inputEventName || getInputEventName(node, model);

  onRenderUpdate.call(this, model);

  var ref = createCommonHandlers(this);
  var onInput = ref.onInput;
  var onBlur = ref.onBlur;
  var onValidate = ref.onValidate;
  addVNodeListener(node, this._inputEventName, onInput);
  addVNodeListener(node, 'blur', onBlur);

  // add the validation listeners.
  this.normalizedEvents.forEach(function (evt) {
    addVNodeListener(node, evt, onValidate);
  });

  this.initialized = true;
}

function createValuesLookup(ctx) {
  var providers = ctx.$_veeObserver.refs;

  return ctx.fieldDeps.reduce(function (acc, depName) {
    if (!providers[depName]) {
      return acc;
    }

    acc[depName] = providers[depName].value;

    return acc;
  }, {});
}

function updateRenderingContextRefs(ctx) {
  // IDs should not be nullable.
  if (isNullOrUndefined(ctx.id) && ctx.id === ctx.vid) {
    ctx.id = PROVIDER_COUNTER;
    PROVIDER_COUNTER++;
  }

  var id = ctx.id;
  var vid = ctx.vid;
  // Nothing has changed.
  if (ctx.isDeactivated || id === vid && ctx.$_veeObserver.refs[id]) {
    return;
  }

  // vid was changed.
  if (id !== vid && ctx.$_veeObserver.refs[id] === ctx) {
    ctx.$_veeObserver.unsubscribe({ vid: id });
  }

  ctx.$_veeObserver.subscribe(ctx);
  ctx.id = vid;
}

function createObserver() {
  return {
    refs: {},
    subscribe: function subscribe(ctx) {
      this.refs[ctx.vid] = ctx;
    },
    unsubscribe: function unsubscribe(ctx) {
      delete this.refs[ctx.vid];
    }
  };
}

function watchCrossFieldDep(ctx, depName, withHooks) {
  if (withHooks === void 0) withHooks = true;

  var providers = ctx.$_veeObserver.refs;
  if (!ctx._veeWatchers) {
    ctx._veeWatchers = {};
  }

  if (!providers[depName] && withHooks) {
    return ctx.$once('hook:mounted', function () {
      watchCrossFieldDep(ctx, depName, false);
    });
  }

  if (!isCallable(ctx._veeWatchers[depName]) && providers[depName]) {
    ctx._veeWatchers[depName] = providers[depName].$watch('value', function () {
      if (ctx.flags.validated) {
        ctx._needsValidation = true;
        ctx.validate();
      }
    });
  }
}

var flagMergingStrategy = {
  pristine: 'every',
  dirty: 'some',
  touched: 'some',
  untouched: 'every',
  valid: 'every',
  invalid: 'some',
  pending: 'some',
  validated: 'every'
};

function mergeFlags(lhs, rhs, strategy) {
  var stratName = flagMergingStrategy[strategy];

  return [lhs, rhs][stratName](function (f) {
    return f;
  });
}

var OBSERVER_COUNTER = 0;

var ValidationObserver = {
  name: 'ValidationObserver',
  provide: function provide() {
    return {
      $_veeObserver: this
    };
  },
  inject: {
    $_veeObserver: {
      from: '$_veeObserver',
      default: function default$1() {
        if (!this.$vnode.context.$_veeObserver) {
          return null;
        }

        return this.$vnode.context.$_veeObserver;
      }
    }
  },
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    slim: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      vid: "obs_" + OBSERVER_COUNTER++,
      refs: {},
      observers: [],
      persistedStore: {}
    };
  },
  computed: {
    ctx: function ctx() {
      var this$1 = this;

      var ctx = {
        errors: {},
        validate: function validate(arg) {
          var promise = this$1.validate(arg);

          return {
            then: function then(thenable) {
              return promise.then(function (success) {
                if (success && isCallable(thenable)) {
                  return Promise.resolve(thenable());
                }

                return Promise.resolve(success);
              });
            }
          };
        },
        reset: function reset() {
          return this$1.reset();
        }
      };

      return values(this.refs).concat(Object.keys(this.persistedStore).map(function (key) {
        return {
          vid: key,
          flags: this$1.persistedStore[key].flags,
          messages: this$1.persistedStore[key].errors
        };
      }), this.observers).reduce(function (acc, provider) {
        Object.keys(flagMergingStrategy).forEach(function (flag) {
          var flags = provider.flags || provider.ctx;
          if (!(flag in acc)) {
            acc[flag] = flags[flag];
            return;
          }

          acc[flag] = mergeFlags(acc[flag], flags[flag], flag);
        });

        acc.errors[provider.vid] = provider.messages || values(provider.ctx.errors).reduce(function (errs, obsErrors) {
          return errs.concat(obsErrors);
        }, []);

        return acc;
      }, ctx);
    }
  },
  created: function created() {
    if (this.$_veeObserver) {
      this.$_veeObserver.subscribe(this, 'observer');
    }
  },
  activated: function activated() {
    if (this.$_veeObserver) {
      this.$_veeObserver.subscribe(this, 'observer');
    }
  },
  deactivated: function deactivated() {
    if (this.$_veeObserver) {
      this.$_veeObserver.unsubscribe(this, 'observer');
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$_veeObserver) {
      this.$_veeObserver.unsubscribe(this, 'observer');
    }
  },
  render: function render(h) {
    var slots = this.$slots.default || this.$scopedSlots.default || [];
    if (isCallable(slots)) {
      slots = slots(this.ctx);
    }

    return this.slim ? createRenderless(h, slots) : h(this.tag, { on: this.$listeners, attrs: this.$attrs }, slots);
  },
  methods: {
    subscribe: function subscribe(subscriber, kind) {
      var obj;

      if (kind === void 0) kind = 'provider';
      if (kind === 'observer') {
        this.observers.push(subscriber);
        return;
      }

      this.refs = Object.assign({}, this.refs, (obj = {}, obj[subscriber.vid] = subscriber, obj));
      if (subscriber.persist && this.persistedStore[subscriber.vid]) {
        this.restoreProviderState(subscriber);
      }
    },
    unsubscribe: function unsubscribe(ref, kind) {
      var vid = ref.vid;
      if (kind === void 0) kind = 'provider';

      if (kind === 'provider') {
        this.removeProvider(vid);
      }

      var idx = findIndex(this.observers, function (o) {
        return o.vid === vid;
      });
      if (idx !== -1) {
        this.observers.splice(idx, 1);
      }
    },
    validate: function validate(ref) {
      if (ref === void 0) ref = { silent: false };
      var silent = ref.silent;

      return Promise.all(values(this.refs).map(function (ref) {
        return ref[silent ? 'validateSilent' : 'validate']().then(function (r) {
          return r.valid;
        });
      }).concat(this.observers.map(function (obs) {
        return obs.validate({ silent: silent });
      }))).then(function (results) {
        return results.every(function (r) {
          return r;
        });
      });
    },
    reset: function reset() {
      var this$1 = this;

      Object.keys(this.persistedStore).forEach(function (key) {
        this$1.$delete(this$1.persistedStore, key);
      });
      return values(this.refs).concat(this.observers).forEach(function (ref) {
        return ref.reset();
      });
    },
    restoreProviderState: function restoreProviderState(provider) {
      var state = this.persistedStore[provider.vid];
      provider.setFlags(state.flags);
      provider.applyResult(state);
      this.$delete(this.persistedStore, provider.vid);
    },
    removeProvider: function removeProvider(vid) {
      var obj;

      var provider = this.refs[vid];
      // save it for the next time.
      if (provider && provider.persist) {
        /* istanbul ignore else */
        if (false) {
          if (vid.indexOf('_vee_') === 0) {
            warn('Please provide a `vid` prop when using `persist`, there might be unexpected issues otherwise.');
          }
        }

        this.persistedStore = assign({}, this.persistedStore, (obj = {}, obj[vid] = {
          flags: provider.flags,
          errors: provider.messages,
          failedRules: provider.failedRules
        }, obj));
      }

      this.$delete(this.refs, vid);
    }
  }
};

function withValidation(component, ctxToProps) {
  if (ctxToProps === void 0) ctxToProps = null;

  var options = isCallable(component) ? component.options : component;
  options.$__veeInject = false;
  var hoc = {
    name: (options.name || 'AnonymousHoc') + "WithValidation",
    props: assign({}, ValidationProvider.props),
    data: ValidationProvider.data,
    computed: assign({}, ValidationProvider.computed),
    methods: assign({}, ValidationProvider.methods),
    $__veeInject: false,
    beforeDestroy: ValidationProvider.beforeDestroy,
    inject: ValidationProvider.inject
  };

  // Default ctx converts ctx props to component props.
  if (!ctxToProps) {
    ctxToProps = function ctxToProps(ctx) {
      return ctx;
    };
  }

  var eventName = options.model && options.model.event || 'input';

  hoc.render = function (h) {
    var obj;

    this.registerField();
    var vctx = createValidationCtx(this);
    var listeners = assign({}, this.$listeners);

    var model = findModel(this.$vnode);
    this._inputEventName = this._inputEventName || getInputEventName(this.$vnode, model);
    onRenderUpdate.call(this, model);

    var ref = createCommonHandlers(this);
    var onInput = ref.onInput;
    var onBlur = ref.onBlur;
    var onValidate = ref.onValidate;

    mergeVNodeListeners(listeners, eventName, onInput);
    mergeVNodeListeners(listeners, 'blur', onBlur);
    this.normalizedEvents.forEach(function (evt, idx) {
      mergeVNodeListeners(listeners, evt, onValidate);
    });

    // Props are any attrs not associated with ValidationProvider Plus the model prop.
    // WARNING: Accidental prop overwrite will probably happen.
    var ref$1 = findModelConfig(this.$vnode) || { prop: 'value' };
    var prop = ref$1.prop;
    var props = assign({}, this.$attrs, (obj = {}, obj[prop] = model.value, obj), ctxToProps(vctx));

    return h(options, {
      attrs: this.$attrs,
      props: props,
      on: listeners
    }, normalizeSlots(this.$slots, this.$vnode.context));
  };

  return hoc;
}

var version = '2.2.15';

Object.keys(Rules).forEach(function (rule) {
  Validator.extend(rule, Rules[rule].validate, assign({}, Rules[rule].options, { paramNames: Rules[rule].paramNames }));
});

// Merge the english messages.
Validator.localize({ en: locale });

var install = VeeValidate$1.install;

VeeValidate$1.version = version;
VeeValidate$1.mapFields = mapFields;
VeeValidate$1.ValidationProvider = ValidationProvider;
VeeValidate$1.ValidationObserver = ValidationObserver;
VeeValidate$1.withValidation = withValidation;

exports.default = VeeValidate$1;
exports.ErrorBag = ErrorBag;
exports.Rules = Rules;
exports.ValidationObserver = ValidationObserver;
exports.ValidationProvider = ValidationProvider;
exports.Validator = Validator;
exports.directive = directive;
exports.install = install;
exports.mapFields = mapFields;
exports.mixin = mixin;
exports.version = version;
exports.withValidation = withValidation;

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cpf = __webpack_require__(118);

var _cpf2 = _interopRequireDefault(_cpf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validator = {
  getMessage: function getMessage(field, args) {
    // will be added to default English messages.
    return 'Invalid CPF';
  },
  validate: function validate(value, args) {
    return (0, _cpf2.default)(value);
  }
};

exports.default = validator;

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cnpj = __webpack_require__(2274);

var _cnpj2 = _interopRequireDefault(_cnpj);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validator = {
  getMessage: function getMessage(field, args) {
    // will be added to default English messages.
    return 'Invalid CNPJ';
  },
  validate: function validate(value, args) {
    return (0, _cnpj2.default)(value);
  }
};

exports.default = validator;

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// função que efetua validação do CNPJ (Suporte CNPJ 2.0 Alfanumérico)
function validate(cnpj) {
  if (!cnpj || String(cnpj).length === 0) return true;

  // Converte para maiúsculas e remove caracteres não alfanuméricos
  cnpj = String(cnpj).toUpperCase().replace(/[^A-Z0-9]/g, '');

  if (cnpj.length !== 14) return false;

  // Os dois últimos dígitos (DVs) DEVEM ser numéricos
  if (!/^[0-9]{2}$/.test(cnpj.substring(12))) return false;

  // Função interna para calcular o dígito verificador usando Módulo 11 e conversão ASCII
  var calculateDV = function calculateDV(base) {
    var weights = base.length === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    var sum = 0;
    for (var i = 0; i < base.length; i++) {
      var char = base[i];
      // Conversão alfanumérica: Valor ASCII - 48
      // '0' (48) -> 0
      // 'A' (65) -> 17
      var val = char.charCodeAt(0) - 48;
      sum += val * weights[i];
    }
    var rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
  };

  var dv1 = calculateDV(cnpj.substring(0, 12));
  var dv2 = calculateDV(cnpj.substring(0, 12) + dv1);

  return cnpj.endsWith("" + dv1 + dv2);
}

exports.default = validate;

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var validator = {
  getMessage: function getMessage(field, args) {
    return "Este campo é obrigatório";
  },
  validate: function validate(value, args) {
    return value != 0 && value != '0' && value != null;
  }
};

exports.default = validator;

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var dictionary = {
  pt: {
    messages: {
      cpf: function cpf() {
        return 'CPF inválido';
      },
      cnpj: function cnpj() {
        return 'CNPJ inválido';
      },
      required: function required(field) {
        return 'Este campo \xE9 obrigat\xF3rio.';
      },
      min: function min(e, n) {
        return "Campo deve conter ao menos " + n[0] + " caracteres.";
      },
      min_value: function min_value(e, n) {
        return "Valor mínimo permitido é " + n[0] + ".";
      },
      max: function max(e, n) {
        return "Campo deve conter no máximo " + n[0] + " caracteres.";
      },
      max_value: function max_value(e, n) {
        return "Valor máximo permitido é " + n[0] + ".";
      },
      digits: function digits(e, n) {
        return "Este campo deve conter " + n[0] + " caracteres.";
      },
      email: function email() {
        return "E-mail inválido.";
      },
      numeric: function numeric() {
        return "Campo deve conter somente números";
      },
      zero: function zero() {
        return "Este campo é obrigatório.";
      },
      'valida-zero': function validaZero(field, args) {
        return 'Este campo \xE9 obrigat\xF3rio.';
      }
    }
  }
};
exports.default = dictionary;

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2278);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("47da1205", content, true, {});

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "\n.editr {\n  border: 1px solid #e4e4e4;\n  width: 100%;\n}\n.editr--toolbar {\n  background: #f6f6f6;\n  border-bottom: 1px solid #e4e4e4;\n  position: relative;\n  display: flex;\n  height: 32px;\n}\n.editr--toolbar a {\n  display: inline-block;\n  width: 8vw;\n  max-width: 32px;\n  height: 32px;\n  color: #333;\n  fill: #333;\n  cursor: pointer;\n  text-align: center;\n  line-height: 1;\n}\n.editr--toolbar a:hover {\n  background: rgba(0,0,0,0.1);\n}\n.editr--toolbar a:active {\n  background: rgba(0,0,0,0.2);\n}\n.editr--toolbar a svg {\n  width: 16px;\n  height: 16px;\n  margin: 8px auto;\n}\n.editr--toolbar a svg path {\n  fill: inherit;\n}\n.editr--toolbar a.vw-btn-separator {\n  width: 1px;\n  margin: 0 8px;\n}\n.editr--toolbar a.vw-btn-separator:hover {\n  background: initial;\n  cursor: default;\n}\n.editr--toolbar a.vw-btn-separator i.vw-separator {\n  border-left: 1px solid rgba(0,0,0,0.1);\n  height: 100%;\n  position: absolute;\n  width: 1px;\n}\n.editr--toolbar .dashboard {\n  width: 100%;\n  position: absolute;\n  top: 32px;\n  left: 0;\n  text-align: left;\n  padding: 8px 16px;\n  background: rgba(255,255,255,0.95);\n  border: 1px solid #f6f6f6;\n}\n.editr--content {\n  min-height: 150px;\n  padding: 12px 8px 16px 8px;\n  line-height: 1.33;\n  font-family: inherit;\n  color: inherit;\n  overflow-y: auto;\n}\n.editr--content[contenteditable=true]:empty:before {\n  content: attr(placeholder);\n  color: rgba(0,0,0,0.3);\n  display: block; /* For Firefox */\n}\n.editr--content img {\n  max-width: 100%;\n}\n.editr--content table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.editr--content table th {\n  text-align: left;\n}\n.editr--content table th,\n.editr--content table td {\n  border: 1px solid #ddd;\n  padding: 2px;\n}\n.editr--content:focus {\n  outline: 0;\n}\n.editr--content ul li,\n.editr--content ol li {\n  list-style-position: inside;\n}\n@media screen and (max-width: 320px) {\n.editr--toolbar a {\n    margin: 0 2px;\n}\n.editr--toolbar a.vw-btn-separator {\n    display: none;\n}\n}/*\n * The MIT License\n * Copyright (c) 2012 Matias Meno <m@tias.me>\n */\n@-webkit-keyframes passing-through {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px); }\n  30%, 70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n    -moz-transform: translateY(-40px);\n    -ms-transform: translateY(-40px);\n    -o-transform: translateY(-40px);\n    transform: translateY(-40px); } }\n@-moz-keyframes passing-through {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px); }\n  30%, 70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n    -moz-transform: translateY(-40px);\n    -ms-transform: translateY(-40px);\n    -o-transform: translateY(-40px);\n    transform: translateY(-40px); } }\n@keyframes passing-through {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px); }\n  30%, 70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n    -moz-transform: translateY(-40px);\n    -ms-transform: translateY(-40px);\n    -o-transform: translateY(-40px);\n    transform: translateY(-40px); } }\n@-webkit-keyframes slide-in {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px); }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px); } }\n@-moz-keyframes slide-in {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px); }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px); } }\n@keyframes slide-in {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px); }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px); } }\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1); }\n  10% {\n    -webkit-transform: scale(1.1);\n    -moz-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    -o-transform: scale(1.1);\n    transform: scale(1.1); }\n  20% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1); } }\n@-moz-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1); }\n  10% {\n    -webkit-transform: scale(1.1);\n    -moz-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    -o-transform: scale(1.1);\n    transform: scale(1.1); }\n  20% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1); } }\n@keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1); }\n  10% {\n    -webkit-transform: scale(1.1);\n    -moz-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    -o-transform: scale(1.1);\n    transform: scale(1.1); }\n  20% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1); } }\n.dropzone, .dropzone * {\n  box-sizing: border-box; }\n\n.dropzone {\n  min-height: 150px;\n  border: 2px solid rgba(0, 0, 0, 0.3);\n  background: white;\n  padding: 20px 20px; }\n  .dropzone.dz-clickable {\n    cursor: pointer; }\n    .dropzone.dz-clickable * {\n      cursor: default; }\n    .dropzone.dz-clickable .dz-message, .dropzone.dz-clickable .dz-message * {\n      cursor: pointer; }\n  .dropzone.dz-started .dz-message {\n    display: none; }\n  .dropzone.dz-drag-hover {\n    border-style: solid; }\n    .dropzone.dz-drag-hover .dz-message {\n      opacity: 0.5; }\n  .dropzone .dz-message {\n    text-align: center;\n    margin: 2em 0; }\n  .dropzone .dz-preview {\n    position: relative;\n    display: inline-block;\n    vertical-align: top;\n    margin: 16px;\n    min-height: 100px; }\n    .dropzone .dz-preview:hover {\n      z-index: 1000; }\n      .dropzone .dz-preview:hover .dz-details {\n        opacity: 1; }\n    .dropzone .dz-preview.dz-file-preview .dz-image {\n      border-radius: 20px;\n      background: #999;\n      background: linear-gradient(to bottom, #eee, #ddd); }\n    .dropzone .dz-preview.dz-file-preview .dz-details {\n      opacity: 1; }\n    .dropzone .dz-preview.dz-image-preview {\n      background: white; }\n      .dropzone .dz-preview.dz-image-preview .dz-details {\n        -webkit-transition: opacity 0.2s linear;\n        -moz-transition: opacity 0.2s linear;\n        -ms-transition: opacity 0.2s linear;\n        -o-transition: opacity 0.2s linear;\n        transition: opacity 0.2s linear; }\n    .dropzone .dz-preview .dz-remove {\n      font-size: 14px;\n      text-align: center;\n      display: block;\n      cursor: pointer;\n      border: none; }\n      .dropzone .dz-preview .dz-remove:hover {\n        text-decoration: underline; }\n    .dropzone .dz-preview:hover .dz-details {\n      opacity: 1; }\n    .dropzone .dz-preview .dz-details {\n      z-index: 20;\n      position: absolute;\n      top: 0;\n      left: 0;\n      opacity: 0;\n      font-size: 13px;\n      min-width: 100%;\n      max-width: 100%;\n      padding: 2em 1em;\n      text-align: center;\n      color: rgba(0, 0, 0, 0.9);\n      line-height: 150%; }\n      .dropzone .dz-preview .dz-details .dz-size {\n        margin-bottom: 1em;\n        font-size: 16px; }\n      .dropzone .dz-preview .dz-details .dz-filename {\n        white-space: nowrap; }\n        .dropzone .dz-preview .dz-details .dz-filename:hover span {\n          border: 1px solid rgba(200, 200, 200, 0.8);\n          background-color: rgba(255, 255, 255, 0.8); }\n        .dropzone .dz-preview .dz-details .dz-filename:not(:hover) {\n          overflow: hidden;\n          text-overflow: ellipsis; }\n          .dropzone .dz-preview .dz-details .dz-filename:not(:hover) span {\n            border: 1px solid transparent; }\n      .dropzone .dz-preview .dz-details .dz-filename span, .dropzone .dz-preview .dz-details .dz-size span {\n        background-color: rgba(255, 255, 255, 0.4);\n        padding: 0 0.4em;\n        border-radius: 3px; }\n    .dropzone .dz-preview:hover .dz-image img {\n      -webkit-transform: scale(1.05, 1.05);\n      -moz-transform: scale(1.05, 1.05);\n      -ms-transform: scale(1.05, 1.05);\n      -o-transform: scale(1.05, 1.05);\n      transform: scale(1.05, 1.05);\n      -webkit-filter: blur(8px);\n      filter: blur(8px); }\n    .dropzone .dz-preview .dz-image {\n      border-radius: 20px;\n      overflow: hidden;\n      width: 120px;\n      height: 120px;\n      position: relative;\n      display: block;\n      z-index: 10; }\n      .dropzone .dz-preview .dz-image img {\n        display: block; }\n    .dropzone .dz-preview.dz-success .dz-success-mark {\n      -webkit-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n      -moz-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n      -ms-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n      -o-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n      animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1); }\n    .dropzone .dz-preview.dz-error .dz-error-mark {\n      opacity: 1;\n      -webkit-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n      -moz-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n      -ms-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n      -o-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n      animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1); }\n    .dropzone .dz-preview .dz-success-mark, .dropzone .dz-preview .dz-error-mark {\n      pointer-events: none;\n      opacity: 0;\n      z-index: 500;\n      position: absolute;\n      display: block;\n      top: 50%;\n      left: 50%;\n      margin-left: -27px;\n      margin-top: -27px; }\n      .dropzone .dz-preview .dz-success-mark svg, .dropzone .dz-preview .dz-error-mark svg {\n        display: block;\n        width: 54px;\n        height: 54px; }\n    .dropzone .dz-preview.dz-processing .dz-progress {\n      opacity: 1;\n      -webkit-transition: all 0.2s linear;\n      -moz-transition: all 0.2s linear;\n      -ms-transition: all 0.2s linear;\n      -o-transition: all 0.2s linear;\n      transition: all 0.2s linear; }\n    .dropzone .dz-preview.dz-complete .dz-progress {\n      opacity: 0;\n      -webkit-transition: opacity 0.4s ease-in;\n      -moz-transition: opacity 0.4s ease-in;\n      -ms-transition: opacity 0.4s ease-in;\n      -o-transition: opacity 0.4s ease-in;\n      transition: opacity 0.4s ease-in; }\n    .dropzone .dz-preview:not(.dz-processing) .dz-progress {\n      -webkit-animation: pulse 6s ease infinite;\n      -moz-animation: pulse 6s ease infinite;\n      -ms-animation: pulse 6s ease infinite;\n      -o-animation: pulse 6s ease infinite;\n      animation: pulse 6s ease infinite; }\n    .dropzone .dz-preview .dz-progress {\n      opacity: 1;\n      z-index: 1000;\n      pointer-events: none;\n      position: absolute;\n      height: 16px;\n      left: 50%;\n      top: 50%;\n      margin-top: -8px;\n      width: 80px;\n      margin-left: -40px;\n      background: rgba(255, 255, 255, 0.9);\n      -webkit-transform: scale(1);\n      border-radius: 8px;\n      overflow: hidden; }\n      .dropzone .dz-preview .dz-progress .dz-upload {\n        background: #333;\n        background: linear-gradient(to bottom, #666, #444);\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        width: 0;\n        -webkit-transition: width 300ms ease-in-out;\n        -moz-transition: width 300ms ease-in-out;\n        -ms-transition: width 300ms ease-in-out;\n        -o-transition: width 300ms ease-in-out;\n        transition: width 300ms ease-in-out; }\n    .dropzone .dz-preview.dz-error .dz-error-message {\n      display: block; }\n    .dropzone .dz-preview.dz-error:hover .dz-error-message {\n      opacity: 1;\n      pointer-events: auto; }\n    .dropzone .dz-preview .dz-error-message {\n      pointer-events: none;\n      z-index: 1000;\n      position: absolute;\n      display: block;\n      display: none;\n      opacity: 0;\n      -webkit-transition: opacity 0.3s ease;\n      -moz-transition: opacity 0.3s ease;\n      -ms-transition: opacity 0.3s ease;\n      -o-transition: opacity 0.3s ease;\n      transition: opacity 0.3s ease;\n      border-radius: 8px;\n      font-size: 13px;\n      top: 130px;\n      left: -10px;\n      width: 140px;\n      background: #be2626;\n      background: linear-gradient(to bottom, #be2626, #a92222);\n      padding: 0.5em 1.2em;\n      color: white; }\n      .dropzone .dz-preview .dz-error-message:after {\n        content: '';\n        position: absolute;\n        top: -6px;\n        left: 64px;\n        width: 0;\n        height: 0;\n        border-left: 6px solid transparent;\n        border-right: 6px solid transparent;\n        border-bottom: 6px solid #be2626; }\n\n.vue-dropzone {\n  border: 2px solid #E5E5E5;\n  font-family: 'Arial', sans-serif;\n  letter-spacing: 0.2px;\n  color: #777;\n  transition: background-color 0.2s linear;\n}\n.vue-dropzone:hover {\n  background-color: #F6F6F6;\n}\n.vue-dropzone i {\n  color: #CCC;\n}\n.vue-dropzone .dz-preview .dz-image {\n  border-radius: 0;\n  width: 100%;\n  height: 100%;\n}\n.vue-dropzone .dz-preview .dz-image img:not([src]) {\n  width: 200px;\n  height: 200px;\n}\n.vue-dropzone .dz-preview .dz-image:hover img {\n  transform: none;\n  -webkit-filter: none;\n}\n.vue-dropzone .dz-preview .dz-details {\n  bottom: 0;\n  top: 0;\n  color: white;\n  background-color: rgba(33, 150, 243, 0.8);\n  transition: opacity .2s linear;\n  text-align: left;\n}\n.vue-dropzone .dz-preview .dz-details .dz-filename {\n  overflow: hidden;\n}\n.vue-dropzone .dz-preview .dz-details .dz-filename span,\n.vue-dropzone .dz-preview .dz-details .dz-size span {\n  background-color: transparent;\n}\n.vue-dropzone .dz-preview .dz-details .dz-filename:not(:hover) span {\n  border: none;\n}\n.vue-dropzone .dz-preview .dz-details .dz-filename:hover span {\n  background-color: transparent;\n  border: none;\n}\n.vue-dropzone .dz-preview .dz-progress .dz-upload {\n  background: #cccccc;\n}\n.vue-dropzone .dz-preview .dz-remove {\n  position: absolute;\n  z-index: 30;\n  color: white;\n  margin-left: 15px;\n  padding: 10px;\n  top: inherit;\n  bottom: 15px;\n  border: 2px white solid;\n  text-decoration: none;\n  text-transform: uppercase;\n  font-size: 0.8rem;\n  font-weight: 800;\n  letter-spacing: 1.1px;\n  opacity: 0;\n}\n.vue-dropzone .dz-preview:hover .dz-remove {\n  opacity: 1;\n}\n.vue-dropzone .dz-preview .dz-success-mark,\n.vue-dropzone .dz-preview .dz-error-mark {\n  margin-left: auto;\n  margin-top: auto;\n  width: 100%;\n  top: 35%;\n  left: 0;\n}\n.vue-dropzone .dz-preview .dz-success-mark svg,\n.vue-dropzone .dz-preview .dz-error-mark svg {\n  margin-left: auto;\n  margin-right: auto;\n}\n.vue-dropzone .dz-preview .dz-error-message {\n  top: calc(15%);\n  margin-left: auto;\n  margin-right: auto;\n  left: 0;\n  width: 100%;\n}\n.vue-dropzone .dz-preview .dz-error-message:after {\n  bottom: -6px;\n  top: initial;\n  border-top: 6px solid #a92222;\n  border-bottom: none;\n}\n\n\n.form[data-v-ebce4d12] {\n  display: flex;\n  align-content: flex-end;\n}\n.form label[data-v-ebce4d12] {\n  margin-right: 1rem;\n}", ""]);

// exports


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js